/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: GenerateTranscriptSummary
// ====================================================

export interface GenerateTranscriptSummary_transcriptSummaryGenerate_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GenerateTranscriptSummary_transcriptSummaryGenerate_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface GenerateTranscriptSummary_transcriptSummaryGenerate_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: GenerateTranscriptSummary_transcriptSummaryGenerate_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: GenerateTranscriptSummary_transcriptSummaryGenerate_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface GenerateTranscriptSummary_transcriptSummaryGenerate {
  __typename: "TranscriptSummaryGeneratePayload";
  /**
   * Zoom meeting with the newly generated summary.
   */
  externalMeeting: GenerateTranscriptSummary_transcriptSummaryGenerate_externalMeeting | null;
}

export interface GenerateTranscriptSummary {
  /**
   * Generate a transcript summary
   */
  transcriptSummaryGenerate: GenerateTranscriptSummary_transcriptSummaryGenerate;
}

export interface GenerateTranscriptSummaryVariables {
  input: TranscriptSummaryGenerateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveTranscriptSummary
// ====================================================

export interface SaveTranscriptSummary_transcriptSummarySave_activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface SaveTranscriptSummary_transcriptSummarySave_activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface SaveTranscriptSummary_transcriptSummarySave_activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface SaveTranscriptSummary_transcriptSummarySave_activity_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface SaveTranscriptSummary_transcriptSummarySave_activity_relatedLeads_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SaveTranscriptSummary_transcriptSummarySave_activity_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface SaveTranscriptSummary_transcriptSummarySave_activity_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: SaveTranscriptSummary_transcriptSummarySave_activity_relatedLeads_contacts_primaryEdge_node;
}

export interface SaveTranscriptSummary_transcriptSummarySave_activity_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: SaveTranscriptSummary_transcriptSummarySave_activity_relatedLeads_contacts_primaryEdge | null;
}

export interface SaveTranscriptSummary_transcriptSummarySave_activity_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface SaveTranscriptSummary_transcriptSummarySave_activity_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: SaveTranscriptSummary_transcriptSummarySave_activity_relatedLeads_accounts_primaryEdge_node;
}

export interface SaveTranscriptSummary_transcriptSummarySave_activity_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: SaveTranscriptSummary_transcriptSummarySave_activity_relatedLeads_accounts_primaryEdge | null;
}

export interface SaveTranscriptSummary_transcriptSummarySave_activity_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: SaveTranscriptSummary_transcriptSummarySave_activity_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: SaveTranscriptSummary_transcriptSummarySave_activity_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: SaveTranscriptSummary_transcriptSummarySave_activity_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: SaveTranscriptSummary_transcriptSummarySave_activity_relatedLeads_accounts;
}

export interface SaveTranscriptSummary_transcriptSummarySave_activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface SaveTranscriptSummary_transcriptSummarySave_activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface SaveTranscriptSummary_transcriptSummarySave_activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: SaveTranscriptSummary_transcriptSummarySave_activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: SaveTranscriptSummary_transcriptSummarySave_activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface SaveTranscriptSummary_transcriptSummarySave_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: SaveTranscriptSummary_transcriptSummarySave_activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: SaveTranscriptSummary_transcriptSummarySave_activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: SaveTranscriptSummary_transcriptSummarySave_activity_participants[];
  /**
   * Related leads for the activity.
   */
  relatedLeads: SaveTranscriptSummary_transcriptSummarySave_activity_relatedLeads[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: SaveTranscriptSummary_transcriptSummarySave_activity_externalMeeting | null;
}

export interface SaveTranscriptSummary_transcriptSummarySave {
  __typename: "TranscriptSummarySavePayload";
  /**
   * The updated Nutshell Activity
   */
  activity: SaveTranscriptSummary_transcriptSummarySave_activity | null;
}

export interface SaveTranscriptSummary {
  /**
   * Updates a zoom meeting activity description with the transcript summary
   */
  transcriptSummarySave: SaveTranscriptSummary_transcriptSummarySave;
}

export interface SaveTranscriptSummaryVariables {
  input: TranscriptSummarySaveInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetActivity
// ====================================================

export interface GetActivity_activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetActivity_activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GetActivity_activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface GetActivity_activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: GetActivity_activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: GetActivity_activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface GetActivity_activity_summary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GetActivity_activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  htmlUrl: string | null;
}

export interface GetActivity_activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetActivity_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetActivity_activity_logNote | null;
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: GetActivity_activity_externalMeeting | null;
  /**
   * The summary of the activity.
   */
  summary: GetActivity_activity_summary | null;
  /**
   * The transcription of the activity.
   */
  transcription: string | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetActivity_activity_participants[];
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetActivity_activity_activityType;
  /**
   * The DateTime that represents the start time of the Activity record
   */
  startTime: any;
  /**
   * The DateTime that represents the end time of the Activity record
   */
  endTime: any;
  /**
   * Whether the activity should be summarized by the AI.
   */
  shouldSummarize: boolean;
  /**
   * The type of external service that the associated meeting belongs to
   */
  externalMeetingServiceType: ExternalServiceType | null;
}

export interface GetActivity {
  /**
   * Returns a Nutshell Activity
   */
  activity: GetActivity_activity | null;
}

export interface GetActivityVariables {
  activityId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPotentialMeetings
// ====================================================

export interface GetPotentialMeetings_potentialMeetings_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GetPotentialMeetings_potentialMeetings_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface GetPotentialMeetings_potentialMeetings {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: GetPotentialMeetings_potentialMeetings_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: GetPotentialMeetings_potentialMeetings_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface GetPotentialMeetings {
  /**
   * List of potential meetings
   */
  potentialMeetings: GetPotentialMeetings_potentialMeetings[];
}

export interface GetPotentialMeetingsVariables {
  activityId: string;
  serviceType: ExternalServiceType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ActivityRecordingDelete
// ====================================================

export interface ActivityRecordingDelete_activityRecordingDelete_activity_logNote_audioLog {
  __typename: "EntityAttributeValueFile";
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Unique id for this file
   */
  fileId: string;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The plain text (i.e., no HTML/rich text, no NutMark for @-mention tokenizing) representation of the Note text
   */
  body: string | null;
  /**
   * The audio log for this note
   */
  audioLog: ActivityRecordingDelete_activityRecordingDelete_activity_logNote_audioLog | null;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_externalMeeting_audioLog {
  __typename: "EntityAttributeValueFile";
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Unique id for this file
   */
  fileId: string;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The audio log of this meeting
   */
  audioLog: ActivityRecordingDelete_activityRecordingDelete_activity_externalMeeting_audioLog | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_summary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
  primaryEmailAddress: string | null;
  primaryPhoneNumber: string | null;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_participantsWithStatus_participant {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
  primaryEmailAddress: string | null;
  primaryPhoneNumber: string | null;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_participantsWithStatus {
  __typename: "ActivityParticipantEdge";
  /**
   * Null when the activity is not publicly synced, the feature is disabled, or the
   * assignment status is not an invitation response (e.g. completed, incomplete).
   */
  attendanceStatus: ActivityParticipantAttendanceStatus | null;
  participant: ActivityRecordingDelete_activityRecordingDelete_activity_participantsWithStatus_participant;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  originType: OriginType;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_comments_edges_node_changeLogEntry {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_comments_edges_node_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_comments_edges_node_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: ActivityRecordingDelete_activityRecordingDelete_activity_comments_edges_node_reactions_creatorUser;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_comments_edges_node_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  htmlUrl: string | null;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_comments_edges_node {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Change log associated with the comment
   */
  changeLogEntry: ActivityRecordingDelete_activityRecordingDelete_activity_comments_edges_node_changeLogEntry | null;
  /**
   * User reactions left for the comment change log entry
   */
  reactions: ActivityRecordingDelete_activityRecordingDelete_activity_comments_edges_node_reactions[];
  /**
   * The user who created the comment.
   */
  creatorUser: ActivityRecordingDelete_activityRecordingDelete_activity_comments_edges_node_creatorUser;
  /**
   * The created time for the comment.
   */
  createdTime: any;
  /**
   * True if this comment can be deleted
   */
  isDeleteable: boolean;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_comments_edges {
  __typename: "CommentsEdge";
  node: ActivityRecordingDelete_activityRecordingDelete_activity_comments_edges_node;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_comments {
  __typename: "CommentsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: ActivityRecordingDelete_activityRecordingDelete_activity_comments_edges[];
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_loggedBy {
  __typename: "User";
  name: string;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_conferenceData {
  __typename: "ConferenceData";
  externalId: string | null;
  externalUuid: string | null;
  meetingUrl: string;
  type: ActivityConferenceType;
  canBeRemoved: boolean;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * Leads don’t have initials, but for interface reasons we’ll return an empty
   * string here instead of removing the property entirely.
   */
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_summaryStates {
  __typename: "ActivitySummaryStates";
  /**
   * The copy to display for the current activity configuration on the recording tab.
   */
  recordingEmptyState: string;
  /**
   * The copy to display for the current activity configuration on the transcription tab.
   */
  transcriptionEmptyState: string;
  /**
   * The current state of the activity summary.
   */
  summaryEmptyState: string;
  /**
   * The next action to take for the activity summary.
   */
  summaryNextAction: ActivitySummaryAction;
  /**
   * Whether the relevant notetaker feature has been disabled by an admin.
   */
  isNotetakerDisabled: boolean;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_previousActivity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_nextActivity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_tasks_delayApplications_delay {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the delay
   */
  name: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_tasks_delayApplications_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_tasks_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * An optional note about the delay application
   */
  note: string | null;
  /**
   * The time when the delay was applied
   */
  appliedTime: any;
  /**
   * The delay that was applied
   */
  delay: ActivityRecordingDelete_activityRecordingDelete_activity_tasks_delayApplications_delay;
  /**
   * The user who applied the delay
   */
  user: ActivityRecordingDelete_activityRecordingDelete_activity_tasks_delayApplications_user | null;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_tasks_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_tasks_completedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_tasks_relatedEntity {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_tasks_creatorEntity_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_tasks_creatorEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export type ActivityRecordingDelete_activityRecordingDelete_activity_tasks_creatorEntity = ActivityRecordingDelete_activityRecordingDelete_activity_tasks_creatorEntity_Chat | ActivityRecordingDelete_activityRecordingDelete_activity_tasks_creatorEntity_Activity;

export interface ActivityRecordingDelete_activityRecordingDelete_activity_tasks_assigner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_tasks_recurrenceRule {
  __typename: "RecurrenceRule";
  mode: RecurrenceMode;
  /**
   * An RRULE-compatible string defining the recurrence pattern (e.g. "FREQ=WEEKLY;BYDAY=MO").
   */
  rule: string;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity_tasks {
  __typename: "Task";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the task
   */
  title: string;
  /**
   * The canonical API href for the task
   */
  href: string;
  /**
   * The task’s user-defined description
   */
  description: string | null;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: ActivityRecordingDelete_activityRecordingDelete_activity_tasks_delayApplications[];
  /**
   * The due timestamp of the task
   */
  dueTime: any | null;
  /**
   * The person or team assigned to this task
   */
  assignee: ActivityRecordingDelete_activityRecordingDelete_activity_tasks_assignee | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  completedTime: any | null;
  /**
   * Can the task be completed?
   */
  canBeCompleted: boolean;
  /**
   * Is this task completed?
   */
  isCompleted: boolean;
  /**
   * The user who completed the task
   */
  completedByUser: ActivityRecordingDelete_activityRecordingDelete_activity_tasks_completedByUser | null;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Whether the tasks due date is later than the current date
   */
  isOverdue: boolean;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  relatedEntity: ActivityRecordingDelete_activityRecordingDelete_activity_tasks_relatedEntity | null;
  /**
   * The DateTime that represents when the Activity record was created
   */
  createdTime: any;
  /**
   * The task's linkified description with URLs converted to clickable links
   */
  linkifiedDescription: string | null;
  isAiGenerated: boolean;
  creatorEntity: ActivityRecordingDelete_activityRecordingDelete_activity_tasks_creatorEntity | null;
  /**
   * The user who assigned the task
   */
  assigner: ActivityRecordingDelete_activityRecordingDelete_activity_tasks_assigner | null;
  /**
   * The time the task was assigned
   */
  assignedTime: any | null;
  /**
   * Number of days between follow-up reminders. Null if the task is not recurring.
   */
  recurringPeriod: number | null;
  /**
   * Whether this task is the current user recurring follow-up reminder.
   */
  isRecurringForUser: boolean;
  /**
   * Null if the task does not recur under the new recurrence system.
   */
  recurrenceRule: ActivityRecordingDelete_activityRecordingDelete_activity_tasks_recurrenceRule | null;
}

export interface ActivityRecordingDelete_activityRecordingDelete_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: ActivityRecordingDelete_activityRecordingDelete_activity_logNote | null;
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: ActivityRecordingDelete_activityRecordingDelete_activity_externalMeeting | null;
  /**
   * The summary of the activity.
   */
  summary: ActivityRecordingDelete_activityRecordingDelete_activity_summary | null;
  /**
   * The transcription of the activity.
   */
  transcription: string | null;
  /**
   * The status of the transcription.
   */
  transcriptionStatus: ActivityTranscriptionStatus;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: ActivityRecordingDelete_activityRecordingDelete_activity_participants[];
  /**
   * Activity participants paired with their calendar invitation response status.
   */
  participantsWithStatus: ActivityRecordingDelete_activityRecordingDelete_activity_participantsWithStatus[];
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: ActivityRecordingDelete_activityRecordingDelete_activity_activityType;
  /**
   * The boolean that represents whether or not the Activity is overdue.
   * Specifically, this means that the activity is not logged, and is in the past.
   */
  isOverdue: boolean;
  /**
   * The DateTime that represents the start time of the Activity record
   */
  startTime: any;
  /**
   * The DateTime that represents the end time of the Activity record
   */
  endTime: any;
  /**
   * Whether the activity should be summarized by the AI.
   */
  shouldSummarize: boolean;
  /**
   * Whether the activity is currently generating a summary.
   */
  generatingSummary: boolean;
  /**
   * Whether the activity is currently generating a recording.
   */
  generatingRecording: boolean;
  /**
   * The type of external service that the associated meeting belongs to
   */
  externalMeetingServiceType: ExternalServiceType | null;
  /**
   * The DateTime that represents when the Activity record was created
   */
  createdTime: any;
  /**
   * The user that created the activity.
   */
  creatorUser: ActivityRecordingDelete_activityRecordingDelete_activity_creatorUser | null;
  /**
   * The origin that created the activity.
   */
  creatorOrigin: ActivityRecordingDelete_activityRecordingDelete_activity_creatorOrigin | null;
  /**
   * The url of the origin that created the activity.
   */
  originUrl: string;
  /**
   * The comments for the activity.
   */
  comments: ActivityRecordingDelete_activityRecordingDelete_activity_comments;
  /**
   * The status of the activity.
   */
  status: ActivityStatus;
  /**
   * Freeform text for public notes & agendas around the Nutshell Activity
   */
  agenda: string;
  /**
   * The boolean that represents whether or not the Activity represents an all day calendar event
   */
  isAllDay: boolean;
  /**
   * The boolean that represents whether an activity should display the audio log.
   */
  shouldDisplayAudio: boolean;
  /**
   * The boolean that represents whether an activity should display the video log.
   */
  shouldDisplayVideo: boolean;
  /**
   * Whether the activity has an associated scheduler booking.
   */
  hasBooking: boolean;
  /**
   * The user that logged the activity.
   */
  loggedBy: ActivityRecordingDelete_activityRecordingDelete_activity_loggedBy | null;
  /**
   * The time that the activity was logged.
   */
  loggedTime: any | null;
  /**
   * Whether the activity was autologged
   */
  autologged: boolean;
  /**
   * An optional geographic location for the activity, helpful for knowing not only the time but the _place_ of the meeting
   */
  location: ActivityRecordingDelete_activityRecordingDelete_activity_location | null;
  /**
   * The URL of the meeting for the activity.
   */
  externalMeetingUrl: string | null;
  conferenceData: ActivityRecordingDelete_activityRecordingDelete_activity_conferenceData | null;
  /**
   * Related leads for the activity.
   */
  relatedLeads: ActivityRecordingDelete_activityRecordingDelete_activity_relatedLeads[];
  /**
   * The Quill delta for the activity note. Useful for reconstructing @mentions.
   */
  quillDelta: string | null;
  /**
   * Whether the activity is editable.
   */
  isEditable: boolean;
  /**
   * Whether the activity has been connected to an external calendar
   */
  isConnectedToExternalCalendar: boolean;
  /**
   * Whether the activity can be summarized by the AI.
   */
  canViewSummaryDetails: boolean;
  /**
   * The current states of the activity based on its type and current conditions.
   */
  summaryStates: ActivityRecordingDelete_activityRecordingDelete_activity_summaryStates;
  /**
   * Whether the user can log the activity.
   */
  canUserLogActivity: boolean;
  /**
   * The linkified agenda of the activity.
   */
  linkifiedAgenda: string;
  /**
   * Whether the user can sync the activity to the calendar.
   */
  canUserSeeSyncStatus: boolean;
  /**
   * Whether the activity should be force synced to the calendar. Not necessarily synced yet.
   */
  isForceSync: boolean;
  /**
   * Whether the activity is loggable due to its timing.
   */
  isLoggable: boolean;
  /**
   * Whether the activity should be synced to the calendar.
   */
  shouldSyncToCalendar: boolean;
  /**
   * The activity that preceded this activity in the follow up chain.
   */
  previousActivity: ActivityRecordingDelete_activityRecordingDelete_activity_previousActivity | null;
  /**
   * The activity that followed this activity in the follow up chain.
   */
  nextActivity: ActivityRecordingDelete_activityRecordingDelete_activity_nextActivity | null;
  /**
   * Whether the user can schedule a follow up for the activity.
   */
  canScheduleFollowUp: boolean;
  /**
   * The username of the organizer that the activity is synced to.
   */
  syncOrganizerUsername: string | null;
  /**
   * Whether the activity is private.
   */
  isPrivate: boolean;
  /**
   * The mode of how the activity should be synced to the calendar.
   */
  syncMode: ActivitySyncMode;
  /**
   * Tasks that were originated from this activity. Currently only as follow-ups from meeting summaries.
   */
  tasks: ActivityRecordingDelete_activityRecordingDelete_activity_tasks[];
}

export interface ActivityRecordingDelete_activityRecordingDelete {
  __typename: "ActivityRecordingDeletePayload";
  /**
   * The activity that had its recording deleted
   */
  activity: ActivityRecordingDelete_activityRecordingDelete_activity;
}

export interface ActivityRecordingDelete {
  /**
   * Delete an activity recording
   */
  activityRecordingDelete: ActivityRecordingDelete_activityRecordingDelete;
}

export interface ActivityRecordingDeleteVariables {
  input: ActivityRecordingDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ActivitySummarize
// ====================================================

export interface ActivitySummarize_activitySummarize_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ActivitySummarize_activitySummarize {
  __typename: "ActivitySummarizePayload";
  /**
   * The activity that had a summary job kicked off
   */
  activity: ActivitySummarize_activitySummarize_activity;
}

export interface ActivitySummarize {
  /**
   * Start a summary job for an activity based on either a transcript or a recording
   */
  activitySummarize: ActivitySummarize_activitySummarize;
}

export interface ActivitySummarizeVariables {
  input: ActivitySummarizeInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateActivityForModal
// ====================================================

export interface CreateActivityForModal_activityCreate_activity_logNote_audioLog {
  __typename: "EntityAttributeValueFile";
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Unique id for this file
   */
  fileId: string;
}

export interface CreateActivityForModal_activityCreate_activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The plain text (i.e., no HTML/rich text, no NutMark for @-mention tokenizing) representation of the Note text
   */
  body: string | null;
  /**
   * The audio log for this note
   */
  audioLog: CreateActivityForModal_activityCreate_activity_logNote_audioLog | null;
}

export interface CreateActivityForModal_activityCreate_activity_externalMeeting_audioLog {
  __typename: "EntityAttributeValueFile";
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Unique id for this file
   */
  fileId: string;
}

export interface CreateActivityForModal_activityCreate_activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The audio log of this meeting
   */
  audioLog: CreateActivityForModal_activityCreate_activity_externalMeeting_audioLog | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
}

export interface CreateActivityForModal_activityCreate_activity_summary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
}

export interface CreateActivityForModal_activityCreate_activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
  primaryEmailAddress: string | null;
  primaryPhoneNumber: string | null;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface CreateActivityForModal_activityCreate_activity_participantsWithStatus_participant {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
  primaryEmailAddress: string | null;
  primaryPhoneNumber: string | null;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface CreateActivityForModal_activityCreate_activity_participantsWithStatus {
  __typename: "ActivityParticipantEdge";
  /**
   * Null when the activity is not publicly synced, the feature is disabled, or the
   * assignment status is not an invitation response (e.g. completed, incomplete).
   */
  attendanceStatus: ActivityParticipantAttendanceStatus | null;
  participant: CreateActivityForModal_activityCreate_activity_participantsWithStatus_participant;
}

export interface CreateActivityForModal_activityCreate_activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface CreateActivityForModal_activityCreate_activity_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateActivityForModal_activityCreate_activity_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  originType: OriginType;
}

export interface CreateActivityForModal_activityCreate_activity_comments_edges_node_changeLogEntry {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateActivityForModal_activityCreate_activity_comments_edges_node_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateActivityForModal_activityCreate_activity_comments_edges_node_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: CreateActivityForModal_activityCreate_activity_comments_edges_node_reactions_creatorUser;
}

export interface CreateActivityForModal_activityCreate_activity_comments_edges_node_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  htmlUrl: string | null;
}

export interface CreateActivityForModal_activityCreate_activity_comments_edges_node {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Change log associated with the comment
   */
  changeLogEntry: CreateActivityForModal_activityCreate_activity_comments_edges_node_changeLogEntry | null;
  /**
   * User reactions left for the comment change log entry
   */
  reactions: CreateActivityForModal_activityCreate_activity_comments_edges_node_reactions[];
  /**
   * The user who created the comment.
   */
  creatorUser: CreateActivityForModal_activityCreate_activity_comments_edges_node_creatorUser;
  /**
   * The created time for the comment.
   */
  createdTime: any;
  /**
   * True if this comment can be deleted
   */
  isDeleteable: boolean;
}

export interface CreateActivityForModal_activityCreate_activity_comments_edges {
  __typename: "CommentsEdge";
  node: CreateActivityForModal_activityCreate_activity_comments_edges_node;
}

export interface CreateActivityForModal_activityCreate_activity_comments {
  __typename: "CommentsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: CreateActivityForModal_activityCreate_activity_comments_edges[];
}

export interface CreateActivityForModal_activityCreate_activity_loggedBy {
  __typename: "User";
  name: string;
}

export interface CreateActivityForModal_activityCreate_activity_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface CreateActivityForModal_activityCreate_activity_conferenceData {
  __typename: "ConferenceData";
  externalId: string | null;
  externalUuid: string | null;
  meetingUrl: string;
  type: ActivityConferenceType;
  canBeRemoved: boolean;
}

export interface CreateActivityForModal_activityCreate_activity_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * Leads don’t have initials, but for interface reasons we’ll return an empty
   * string here instead of removing the property entirely.
   */
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface CreateActivityForModal_activityCreate_activity_summaryStates {
  __typename: "ActivitySummaryStates";
  /**
   * The copy to display for the current activity configuration on the recording tab.
   */
  recordingEmptyState: string;
  /**
   * The copy to display for the current activity configuration on the transcription tab.
   */
  transcriptionEmptyState: string;
  /**
   * The current state of the activity summary.
   */
  summaryEmptyState: string;
  /**
   * The next action to take for the activity summary.
   */
  summaryNextAction: ActivitySummaryAction;
  /**
   * Whether the relevant notetaker feature has been disabled by an admin.
   */
  isNotetakerDisabled: boolean;
}

export interface CreateActivityForModal_activityCreate_activity_previousActivity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface CreateActivityForModal_activityCreate_activity_nextActivity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface CreateActivityForModal_activityCreate_activity_tasks_delayApplications_delay {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the delay
   */
  name: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface CreateActivityForModal_activityCreate_activity_tasks_delayApplications_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateActivityForModal_activityCreate_activity_tasks_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * An optional note about the delay application
   */
  note: string | null;
  /**
   * The time when the delay was applied
   */
  appliedTime: any;
  /**
   * The delay that was applied
   */
  delay: CreateActivityForModal_activityCreate_activity_tasks_delayApplications_delay;
  /**
   * The user who applied the delay
   */
  user: CreateActivityForModal_activityCreate_activity_tasks_delayApplications_user | null;
}

export interface CreateActivityForModal_activityCreate_activity_tasks_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateActivityForModal_activityCreate_activity_tasks_completedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateActivityForModal_activityCreate_activity_tasks_relatedEntity {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateActivityForModal_activityCreate_activity_tasks_creatorEntity_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface CreateActivityForModal_activityCreate_activity_tasks_creatorEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export type CreateActivityForModal_activityCreate_activity_tasks_creatorEntity = CreateActivityForModal_activityCreate_activity_tasks_creatorEntity_Chat | CreateActivityForModal_activityCreate_activity_tasks_creatorEntity_Activity;

export interface CreateActivityForModal_activityCreate_activity_tasks_assigner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateActivityForModal_activityCreate_activity_tasks_recurrenceRule {
  __typename: "RecurrenceRule";
  mode: RecurrenceMode;
  /**
   * An RRULE-compatible string defining the recurrence pattern (e.g. "FREQ=WEEKLY;BYDAY=MO").
   */
  rule: string;
}

export interface CreateActivityForModal_activityCreate_activity_tasks {
  __typename: "Task";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the task
   */
  title: string;
  /**
   * The canonical API href for the task
   */
  href: string;
  /**
   * The task’s user-defined description
   */
  description: string | null;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: CreateActivityForModal_activityCreate_activity_tasks_delayApplications[];
  /**
   * The due timestamp of the task
   */
  dueTime: any | null;
  /**
   * The person or team assigned to this task
   */
  assignee: CreateActivityForModal_activityCreate_activity_tasks_assignee | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  completedTime: any | null;
  /**
   * Can the task be completed?
   */
  canBeCompleted: boolean;
  /**
   * Is this task completed?
   */
  isCompleted: boolean;
  /**
   * The user who completed the task
   */
  completedByUser: CreateActivityForModal_activityCreate_activity_tasks_completedByUser | null;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Whether the tasks due date is later than the current date
   */
  isOverdue: boolean;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  relatedEntity: CreateActivityForModal_activityCreate_activity_tasks_relatedEntity | null;
  /**
   * The DateTime that represents when the Activity record was created
   */
  createdTime: any;
  /**
   * The task's linkified description with URLs converted to clickable links
   */
  linkifiedDescription: string | null;
  isAiGenerated: boolean;
  creatorEntity: CreateActivityForModal_activityCreate_activity_tasks_creatorEntity | null;
  /**
   * The user who assigned the task
   */
  assigner: CreateActivityForModal_activityCreate_activity_tasks_assigner | null;
  /**
   * The time the task was assigned
   */
  assignedTime: any | null;
  /**
   * Number of days between follow-up reminders. Null if the task is not recurring.
   */
  recurringPeriod: number | null;
  /**
   * Whether this task is the current user recurring follow-up reminder.
   */
  isRecurringForUser: boolean;
  /**
   * Null if the task does not recur under the new recurrence system.
   */
  recurrenceRule: CreateActivityForModal_activityCreate_activity_tasks_recurrenceRule | null;
}

export interface CreateActivityForModal_activityCreate_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: CreateActivityForModal_activityCreate_activity_logNote | null;
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: CreateActivityForModal_activityCreate_activity_externalMeeting | null;
  /**
   * The summary of the activity.
   */
  summary: CreateActivityForModal_activityCreate_activity_summary | null;
  /**
   * The transcription of the activity.
   */
  transcription: string | null;
  /**
   * The status of the transcription.
   */
  transcriptionStatus: ActivityTranscriptionStatus;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: CreateActivityForModal_activityCreate_activity_participants[];
  /**
   * Activity participants paired with their calendar invitation response status.
   */
  participantsWithStatus: CreateActivityForModal_activityCreate_activity_participantsWithStatus[];
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: CreateActivityForModal_activityCreate_activity_activityType;
  /**
   * The boolean that represents whether or not the Activity is overdue.
   * Specifically, this means that the activity is not logged, and is in the past.
   */
  isOverdue: boolean;
  /**
   * The DateTime that represents the start time of the Activity record
   */
  startTime: any;
  /**
   * The DateTime that represents the end time of the Activity record
   */
  endTime: any;
  /**
   * Whether the activity should be summarized by the AI.
   */
  shouldSummarize: boolean;
  /**
   * Whether the activity is currently generating a summary.
   */
  generatingSummary: boolean;
  /**
   * Whether the activity is currently generating a recording.
   */
  generatingRecording: boolean;
  /**
   * The type of external service that the associated meeting belongs to
   */
  externalMeetingServiceType: ExternalServiceType | null;
  /**
   * The DateTime that represents when the Activity record was created
   */
  createdTime: any;
  /**
   * The user that created the activity.
   */
  creatorUser: CreateActivityForModal_activityCreate_activity_creatorUser | null;
  /**
   * The origin that created the activity.
   */
  creatorOrigin: CreateActivityForModal_activityCreate_activity_creatorOrigin | null;
  /**
   * The url of the origin that created the activity.
   */
  originUrl: string;
  /**
   * The comments for the activity.
   */
  comments: CreateActivityForModal_activityCreate_activity_comments;
  /**
   * The status of the activity.
   */
  status: ActivityStatus;
  /**
   * Freeform text for public notes & agendas around the Nutshell Activity
   */
  agenda: string;
  /**
   * The boolean that represents whether or not the Activity represents an all day calendar event
   */
  isAllDay: boolean;
  /**
   * The boolean that represents whether an activity should display the audio log.
   */
  shouldDisplayAudio: boolean;
  /**
   * The boolean that represents whether an activity should display the video log.
   */
  shouldDisplayVideo: boolean;
  /**
   * Whether the activity has an associated scheduler booking.
   */
  hasBooking: boolean;
  /**
   * The user that logged the activity.
   */
  loggedBy: CreateActivityForModal_activityCreate_activity_loggedBy | null;
  /**
   * The time that the activity was logged.
   */
  loggedTime: any | null;
  /**
   * Whether the activity was autologged
   */
  autologged: boolean;
  /**
   * An optional geographic location for the activity, helpful for knowing not only the time but the _place_ of the meeting
   */
  location: CreateActivityForModal_activityCreate_activity_location | null;
  /**
   * The URL of the meeting for the activity.
   */
  externalMeetingUrl: string | null;
  conferenceData: CreateActivityForModal_activityCreate_activity_conferenceData | null;
  /**
   * Related leads for the activity.
   */
  relatedLeads: CreateActivityForModal_activityCreate_activity_relatedLeads[];
  /**
   * The Quill delta for the activity note. Useful for reconstructing @mentions.
   */
  quillDelta: string | null;
  /**
   * Whether the activity is editable.
   */
  isEditable: boolean;
  /**
   * Whether the activity has been connected to an external calendar
   */
  isConnectedToExternalCalendar: boolean;
  /**
   * Whether the activity can be summarized by the AI.
   */
  canViewSummaryDetails: boolean;
  /**
   * The current states of the activity based on its type and current conditions.
   */
  summaryStates: CreateActivityForModal_activityCreate_activity_summaryStates;
  /**
   * Whether the user can log the activity.
   */
  canUserLogActivity: boolean;
  /**
   * The linkified agenda of the activity.
   */
  linkifiedAgenda: string;
  /**
   * Whether the user can sync the activity to the calendar.
   */
  canUserSeeSyncStatus: boolean;
  /**
   * Whether the activity should be force synced to the calendar. Not necessarily synced yet.
   */
  isForceSync: boolean;
  /**
   * Whether the activity is loggable due to its timing.
   */
  isLoggable: boolean;
  /**
   * Whether the activity should be synced to the calendar.
   */
  shouldSyncToCalendar: boolean;
  /**
   * The activity that preceded this activity in the follow up chain.
   */
  previousActivity: CreateActivityForModal_activityCreate_activity_previousActivity | null;
  /**
   * The activity that followed this activity in the follow up chain.
   */
  nextActivity: CreateActivityForModal_activityCreate_activity_nextActivity | null;
  /**
   * Whether the user can schedule a follow up for the activity.
   */
  canScheduleFollowUp: boolean;
  /**
   * The username of the organizer that the activity is synced to.
   */
  syncOrganizerUsername: string | null;
  /**
   * Whether the activity is private.
   */
  isPrivate: boolean;
  /**
   * The mode of how the activity should be synced to the calendar.
   */
  syncMode: ActivitySyncMode;
  /**
   * Tasks that were originated from this activity. Currently only as follow-ups from meeting summaries.
   */
  tasks: CreateActivityForModal_activityCreate_activity_tasks[];
}

export interface CreateActivityForModal_activityCreate {
  __typename: "ActivityCreatePayload";
  /**
   * The created activity
   */
  activity: CreateActivityForModal_activityCreate_activity;
}

export interface CreateActivityForModal {
  /**
   * Create a new scheduled or logged activity
   */
  activityCreate: CreateActivityForModal_activityCreate;
}

export interface CreateActivityForModalVariables {
  input: ActivityCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ActivityCreateOrMergeContactFromExternalAttendee
// ====================================================

export interface ActivityCreateOrMergeContactFromExternalAttendee_activityCreateOrMergeContactFromExternalAttendee_activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
  primaryEmailAddress: string | null;
  primaryPhoneNumber: string | null;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface ActivityCreateOrMergeContactFromExternalAttendee_activityCreateOrMergeContactFromExternalAttendee_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: ActivityCreateOrMergeContactFromExternalAttendee_activityCreateOrMergeContactFromExternalAttendee_activity_participants[];
}

export interface ActivityCreateOrMergeContactFromExternalAttendee_activityCreateOrMergeContactFromExternalAttendee_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string | null;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface ActivityCreateOrMergeContactFromExternalAttendee_activityCreateOrMergeContactFromExternalAttendee {
  __typename: "ActivityCreateOrMergeContactFromExternalAttendeePayload";
  /**
   * The activity that a new contact was created for
   */
  activity: ActivityCreateOrMergeContactFromExternalAttendee_activityCreateOrMergeContactFromExternalAttendee_activity;
  /**
   * The contact that was created or merged into
   */
  contact: ActivityCreateOrMergeContactFromExternalAttendee_activityCreateOrMergeContactFromExternalAttendee_contact | null;
}

export interface ActivityCreateOrMergeContactFromExternalAttendee {
  /**
   * Creates or merges a contact from an external attendee
   */
  activityCreateOrMergeContactFromExternalAttendee: ActivityCreateOrMergeContactFromExternalAttendee_activityCreateOrMergeContactFromExternalAttendee;
}

export interface ActivityCreateOrMergeContactFromExternalAttendeeVariables {
  input: ActivityCreateOrMergeContactFromExternalAttendeeInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ActivityDelete
// ====================================================

export interface ActivityDelete_activityDelete_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ActivityDelete_activityDelete {
  __typename: "ActivityDeletePayload";
  /**
   * The deleted activity
   */
  activity: ActivityDelete_activityDelete_activity;
}

export interface ActivityDelete {
  /**
   * Delete an activity
   */
  activityDelete: ActivityDelete_activityDelete;
}

export interface ActivityDeleteVariables {
  input: ActivityDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TranscriptSummaryDelete
// ====================================================

export interface TranscriptSummaryDelete_transcriptSummaryDelete_activity_summary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
}

export interface TranscriptSummaryDelete_transcriptSummaryDelete_activity_summaryStates {
  __typename: "ActivitySummaryStates";
  /**
   * The copy to display for the current activity configuration on the recording tab.
   */
  recordingEmptyState: string;
  /**
   * The copy to display for the current activity configuration on the transcription tab.
   */
  transcriptionEmptyState: string;
  /**
   * The current state of the activity summary.
   */
  summaryEmptyState: string;
  /**
   * The next action to take for the activity summary.
   */
  summaryNextAction: ActivitySummaryAction;
}

export interface TranscriptSummaryDelete_transcriptSummaryDelete_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The summary of the activity.
   */
  summary: TranscriptSummaryDelete_transcriptSummaryDelete_activity_summary | null;
  /**
   * Whether the activity is currently generating a summary.
   */
  generatingSummary: boolean;
  /**
   * The current states of the activity based on its type and current conditions.
   */
  summaryStates: TranscriptSummaryDelete_transcriptSummaryDelete_activity_summaryStates;
}

export interface TranscriptSummaryDelete_transcriptSummaryDelete {
  __typename: "TranscriptSummaryDeletePayload";
  /**
   * The activity that had its transcription summary deleted.
   */
  activity: TranscriptSummaryDelete_transcriptSummaryDelete_activity;
}

export interface TranscriptSummaryDelete {
  /**
   * Soft deletes the transcription summary for an activity.
   */
  transcriptSummaryDelete: TranscriptSummaryDelete_transcriptSummaryDelete;
}

export interface TranscriptSummaryDeleteVariables {
  input: TranscriptSummaryDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TranscriptDelete
// ====================================================

export interface TranscriptDelete_transcriptDelete_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The transcription of the activity.
   */
  transcription: string | null;
  /**
   * The status of the transcription.
   */
  transcriptionStatus: ActivityTranscriptionStatus;
}

export interface TranscriptDelete_transcriptDelete {
  __typename: "TranscriptDeletePayload";
  /**
   * The updated activity with the transcript deleted
   */
  activity: TranscriptDelete_transcriptDelete_activity;
}

export interface TranscriptDelete {
  /**
   * Deletes a transcription for an activity
   */
  transcriptDelete: TranscriptDelete_transcriptDelete;
}

export interface TranscriptDeleteVariables {
  input: TranscriptDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ExternalMeetingRecordingDelete
// ====================================================

export interface ExternalMeetingRecordingDelete_externalMeetingRecordingDelete_externalMeeting_audioLog {
  __typename: "EntityAttributeValueFile";
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Unique id for this file
   */
  fileId: string;
}

export interface ExternalMeetingRecordingDelete_externalMeetingRecordingDelete_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The audio log of this meeting
   */
  audioLog: ExternalMeetingRecordingDelete_externalMeetingRecordingDelete_externalMeeting_audioLog | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
}

export interface ExternalMeetingRecordingDelete_externalMeetingRecordingDelete {
  __typename: "ExternalMeetingRecordingDeletePayload";
  /**
   * The external meeting that had its recording URL deleted
   */
  externalMeeting: ExternalMeetingRecordingDelete_externalMeetingRecordingDelete_externalMeeting;
}

export interface ExternalMeetingRecordingDelete {
  /**
   * Delete the recording URL on an external meeting
   */
  externalMeetingRecordingDelete: ExternalMeetingRecordingDelete_externalMeetingRecordingDelete;
}

export interface ExternalMeetingRecordingDeleteVariables {
  input: ExternalMeetingRecordingDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ProvisionMeetAsync
// ====================================================

export interface ProvisionMeetAsync_provisionMeetAsync {
  __typename: "ProvisionMeetAsyncPayload";
  meetingId: string;
  meetingUuid: string;
  meetingUrl: string;
  conferenceType: ActivityConferenceType;
}

export interface ProvisionMeetAsync {
  provisionMeetAsync: ProvisionMeetAsync_provisionMeetAsync;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ProvisionTeamsAsync
// ====================================================

export interface ProvisionTeamsAsync_provisionTeamsAsync {
  __typename: "ProvisionTeamsAsyncPayload";
  meetingId: string;
  meetingUuid: string;
  meetingUrl: string;
  conferenceType: ActivityConferenceType;
}

export interface ProvisionTeamsAsync {
  provisionTeamsAsync: ProvisionTeamsAsync_provisionTeamsAsync;
}

export interface ProvisionTeamsAsyncVariables {
  meetingName: string;
  startTime: any;
  durationMinutes: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ProvisionZoomAsync
// ====================================================

export interface ProvisionZoomAsync_provisionZoomAsync {
  __typename: "ProvisionZoomAsyncPayload";
  meetingId: string;
  meetingUuid: string;
  meetingUrl: string;
  conferenceType: ActivityConferenceType;
}

export interface ProvisionZoomAsync {
  provisionZoomAsync: ProvisionZoomAsync_provisionZoomAsync;
}

export interface ProvisionZoomAsyncVariables {
  meetingName: string;
  startTime: any;
  durationMinutes: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ActivityUpdate
// ====================================================

export interface ActivityUpdate_activityUpdate_activity_logNote_audioLog {
  __typename: "EntityAttributeValueFile";
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Unique id for this file
   */
  fileId: string;
}

export interface ActivityUpdate_activityUpdate_activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The plain text (i.e., no HTML/rich text, no NutMark for @-mention tokenizing) representation of the Note text
   */
  body: string | null;
  /**
   * The audio log for this note
   */
  audioLog: ActivityUpdate_activityUpdate_activity_logNote_audioLog | null;
}

export interface ActivityUpdate_activityUpdate_activity_externalMeeting_audioLog {
  __typename: "EntityAttributeValueFile";
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Unique id for this file
   */
  fileId: string;
}

export interface ActivityUpdate_activityUpdate_activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The audio log of this meeting
   */
  audioLog: ActivityUpdate_activityUpdate_activity_externalMeeting_audioLog | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
}

export interface ActivityUpdate_activityUpdate_activity_summary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
}

export interface ActivityUpdate_activityUpdate_activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
  primaryEmailAddress: string | null;
  primaryPhoneNumber: string | null;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface ActivityUpdate_activityUpdate_activity_participantsWithStatus_participant {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
  primaryEmailAddress: string | null;
  primaryPhoneNumber: string | null;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface ActivityUpdate_activityUpdate_activity_participantsWithStatus {
  __typename: "ActivityParticipantEdge";
  /**
   * Null when the activity is not publicly synced, the feature is disabled, or the
   * assignment status is not an invitation response (e.g. completed, incomplete).
   */
  attendanceStatus: ActivityParticipantAttendanceStatus | null;
  participant: ActivityUpdate_activityUpdate_activity_participantsWithStatus_participant;
}

export interface ActivityUpdate_activityUpdate_activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface ActivityUpdate_activityUpdate_activity_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ActivityUpdate_activityUpdate_activity_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  originType: OriginType;
}

export interface ActivityUpdate_activityUpdate_activity_comments_edges_node_changeLogEntry {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ActivityUpdate_activityUpdate_activity_comments_edges_node_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ActivityUpdate_activityUpdate_activity_comments_edges_node_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: ActivityUpdate_activityUpdate_activity_comments_edges_node_reactions_creatorUser;
}

export interface ActivityUpdate_activityUpdate_activity_comments_edges_node_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  htmlUrl: string | null;
}

export interface ActivityUpdate_activityUpdate_activity_comments_edges_node {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Change log associated with the comment
   */
  changeLogEntry: ActivityUpdate_activityUpdate_activity_comments_edges_node_changeLogEntry | null;
  /**
   * User reactions left for the comment change log entry
   */
  reactions: ActivityUpdate_activityUpdate_activity_comments_edges_node_reactions[];
  /**
   * The user who created the comment.
   */
  creatorUser: ActivityUpdate_activityUpdate_activity_comments_edges_node_creatorUser;
  /**
   * The created time for the comment.
   */
  createdTime: any;
  /**
   * True if this comment can be deleted
   */
  isDeleteable: boolean;
}

export interface ActivityUpdate_activityUpdate_activity_comments_edges {
  __typename: "CommentsEdge";
  node: ActivityUpdate_activityUpdate_activity_comments_edges_node;
}

export interface ActivityUpdate_activityUpdate_activity_comments {
  __typename: "CommentsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: ActivityUpdate_activityUpdate_activity_comments_edges[];
}

export interface ActivityUpdate_activityUpdate_activity_loggedBy {
  __typename: "User";
  name: string;
}

export interface ActivityUpdate_activityUpdate_activity_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface ActivityUpdate_activityUpdate_activity_conferenceData {
  __typename: "ConferenceData";
  externalId: string | null;
  externalUuid: string | null;
  meetingUrl: string;
  type: ActivityConferenceType;
  canBeRemoved: boolean;
}

export interface ActivityUpdate_activityUpdate_activity_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * Leads don’t have initials, but for interface reasons we’ll return an empty
   * string here instead of removing the property entirely.
   */
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface ActivityUpdate_activityUpdate_activity_summaryStates {
  __typename: "ActivitySummaryStates";
  /**
   * The copy to display for the current activity configuration on the recording tab.
   */
  recordingEmptyState: string;
  /**
   * The copy to display for the current activity configuration on the transcription tab.
   */
  transcriptionEmptyState: string;
  /**
   * The current state of the activity summary.
   */
  summaryEmptyState: string;
  /**
   * The next action to take for the activity summary.
   */
  summaryNextAction: ActivitySummaryAction;
  /**
   * Whether the relevant notetaker feature has been disabled by an admin.
   */
  isNotetakerDisabled: boolean;
}

export interface ActivityUpdate_activityUpdate_activity_previousActivity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface ActivityUpdate_activityUpdate_activity_nextActivity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface ActivityUpdate_activityUpdate_activity_tasks_delayApplications_delay {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the delay
   */
  name: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface ActivityUpdate_activityUpdate_activity_tasks_delayApplications_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ActivityUpdate_activityUpdate_activity_tasks_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * An optional note about the delay application
   */
  note: string | null;
  /**
   * The time when the delay was applied
   */
  appliedTime: any;
  /**
   * The delay that was applied
   */
  delay: ActivityUpdate_activityUpdate_activity_tasks_delayApplications_delay;
  /**
   * The user who applied the delay
   */
  user: ActivityUpdate_activityUpdate_activity_tasks_delayApplications_user | null;
}

export interface ActivityUpdate_activityUpdate_activity_tasks_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ActivityUpdate_activityUpdate_activity_tasks_completedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ActivityUpdate_activityUpdate_activity_tasks_relatedEntity {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ActivityUpdate_activityUpdate_activity_tasks_creatorEntity_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface ActivityUpdate_activityUpdate_activity_tasks_creatorEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export type ActivityUpdate_activityUpdate_activity_tasks_creatorEntity = ActivityUpdate_activityUpdate_activity_tasks_creatorEntity_Chat | ActivityUpdate_activityUpdate_activity_tasks_creatorEntity_Activity;

export interface ActivityUpdate_activityUpdate_activity_tasks_assigner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ActivityUpdate_activityUpdate_activity_tasks_recurrenceRule {
  __typename: "RecurrenceRule";
  mode: RecurrenceMode;
  /**
   * An RRULE-compatible string defining the recurrence pattern (e.g. "FREQ=WEEKLY;BYDAY=MO").
   */
  rule: string;
}

export interface ActivityUpdate_activityUpdate_activity_tasks {
  __typename: "Task";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the task
   */
  title: string;
  /**
   * The canonical API href for the task
   */
  href: string;
  /**
   * The task’s user-defined description
   */
  description: string | null;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: ActivityUpdate_activityUpdate_activity_tasks_delayApplications[];
  /**
   * The due timestamp of the task
   */
  dueTime: any | null;
  /**
   * The person or team assigned to this task
   */
  assignee: ActivityUpdate_activityUpdate_activity_tasks_assignee | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  completedTime: any | null;
  /**
   * Can the task be completed?
   */
  canBeCompleted: boolean;
  /**
   * Is this task completed?
   */
  isCompleted: boolean;
  /**
   * The user who completed the task
   */
  completedByUser: ActivityUpdate_activityUpdate_activity_tasks_completedByUser | null;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Whether the tasks due date is later than the current date
   */
  isOverdue: boolean;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  relatedEntity: ActivityUpdate_activityUpdate_activity_tasks_relatedEntity | null;
  /**
   * The DateTime that represents when the Activity record was created
   */
  createdTime: any;
  /**
   * The task's linkified description with URLs converted to clickable links
   */
  linkifiedDescription: string | null;
  isAiGenerated: boolean;
  creatorEntity: ActivityUpdate_activityUpdate_activity_tasks_creatorEntity | null;
  /**
   * The user who assigned the task
   */
  assigner: ActivityUpdate_activityUpdate_activity_tasks_assigner | null;
  /**
   * The time the task was assigned
   */
  assignedTime: any | null;
  /**
   * Number of days between follow-up reminders. Null if the task is not recurring.
   */
  recurringPeriod: number | null;
  /**
   * Whether this task is the current user recurring follow-up reminder.
   */
  isRecurringForUser: boolean;
  /**
   * Null if the task does not recur under the new recurrence system.
   */
  recurrenceRule: ActivityUpdate_activityUpdate_activity_tasks_recurrenceRule | null;
}

export interface ActivityUpdate_activityUpdate_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: ActivityUpdate_activityUpdate_activity_logNote | null;
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: ActivityUpdate_activityUpdate_activity_externalMeeting | null;
  /**
   * The summary of the activity.
   */
  summary: ActivityUpdate_activityUpdate_activity_summary | null;
  /**
   * The transcription of the activity.
   */
  transcription: string | null;
  /**
   * The status of the transcription.
   */
  transcriptionStatus: ActivityTranscriptionStatus;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: ActivityUpdate_activityUpdate_activity_participants[];
  /**
   * Activity participants paired with their calendar invitation response status.
   */
  participantsWithStatus: ActivityUpdate_activityUpdate_activity_participantsWithStatus[];
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: ActivityUpdate_activityUpdate_activity_activityType;
  /**
   * The boolean that represents whether or not the Activity is overdue.
   * Specifically, this means that the activity is not logged, and is in the past.
   */
  isOverdue: boolean;
  /**
   * The DateTime that represents the start time of the Activity record
   */
  startTime: any;
  /**
   * The DateTime that represents the end time of the Activity record
   */
  endTime: any;
  /**
   * Whether the activity should be summarized by the AI.
   */
  shouldSummarize: boolean;
  /**
   * Whether the activity is currently generating a summary.
   */
  generatingSummary: boolean;
  /**
   * Whether the activity is currently generating a recording.
   */
  generatingRecording: boolean;
  /**
   * The type of external service that the associated meeting belongs to
   */
  externalMeetingServiceType: ExternalServiceType | null;
  /**
   * The DateTime that represents when the Activity record was created
   */
  createdTime: any;
  /**
   * The user that created the activity.
   */
  creatorUser: ActivityUpdate_activityUpdate_activity_creatorUser | null;
  /**
   * The origin that created the activity.
   */
  creatorOrigin: ActivityUpdate_activityUpdate_activity_creatorOrigin | null;
  /**
   * The url of the origin that created the activity.
   */
  originUrl: string;
  /**
   * The comments for the activity.
   */
  comments: ActivityUpdate_activityUpdate_activity_comments;
  /**
   * The status of the activity.
   */
  status: ActivityStatus;
  /**
   * Freeform text for public notes & agendas around the Nutshell Activity
   */
  agenda: string;
  /**
   * The boolean that represents whether or not the Activity represents an all day calendar event
   */
  isAllDay: boolean;
  /**
   * The boolean that represents whether an activity should display the audio log.
   */
  shouldDisplayAudio: boolean;
  /**
   * The boolean that represents whether an activity should display the video log.
   */
  shouldDisplayVideo: boolean;
  /**
   * Whether the activity has an associated scheduler booking.
   */
  hasBooking: boolean;
  /**
   * The user that logged the activity.
   */
  loggedBy: ActivityUpdate_activityUpdate_activity_loggedBy | null;
  /**
   * The time that the activity was logged.
   */
  loggedTime: any | null;
  /**
   * Whether the activity was autologged
   */
  autologged: boolean;
  /**
   * An optional geographic location for the activity, helpful for knowing not only the time but the _place_ of the meeting
   */
  location: ActivityUpdate_activityUpdate_activity_location | null;
  /**
   * The URL of the meeting for the activity.
   */
  externalMeetingUrl: string | null;
  conferenceData: ActivityUpdate_activityUpdate_activity_conferenceData | null;
  /**
   * Related leads for the activity.
   */
  relatedLeads: ActivityUpdate_activityUpdate_activity_relatedLeads[];
  /**
   * The Quill delta for the activity note. Useful for reconstructing @mentions.
   */
  quillDelta: string | null;
  /**
   * Whether the activity is editable.
   */
  isEditable: boolean;
  /**
   * Whether the activity has been connected to an external calendar
   */
  isConnectedToExternalCalendar: boolean;
  /**
   * Whether the activity can be summarized by the AI.
   */
  canViewSummaryDetails: boolean;
  /**
   * The current states of the activity based on its type and current conditions.
   */
  summaryStates: ActivityUpdate_activityUpdate_activity_summaryStates;
  /**
   * Whether the user can log the activity.
   */
  canUserLogActivity: boolean;
  /**
   * The linkified agenda of the activity.
   */
  linkifiedAgenda: string;
  /**
   * Whether the user can sync the activity to the calendar.
   */
  canUserSeeSyncStatus: boolean;
  /**
   * Whether the activity should be force synced to the calendar. Not necessarily synced yet.
   */
  isForceSync: boolean;
  /**
   * Whether the activity is loggable due to its timing.
   */
  isLoggable: boolean;
  /**
   * Whether the activity should be synced to the calendar.
   */
  shouldSyncToCalendar: boolean;
  /**
   * The activity that preceded this activity in the follow up chain.
   */
  previousActivity: ActivityUpdate_activityUpdate_activity_previousActivity | null;
  /**
   * The activity that followed this activity in the follow up chain.
   */
  nextActivity: ActivityUpdate_activityUpdate_activity_nextActivity | null;
  /**
   * Whether the user can schedule a follow up for the activity.
   */
  canScheduleFollowUp: boolean;
  /**
   * The username of the organizer that the activity is synced to.
   */
  syncOrganizerUsername: string | null;
  /**
   * Whether the activity is private.
   */
  isPrivate: boolean;
  /**
   * The mode of how the activity should be synced to the calendar.
   */
  syncMode: ActivitySyncMode;
  /**
   * Tasks that were originated from this activity. Currently only as follow-ups from meeting summaries.
   */
  tasks: ActivityUpdate_activityUpdate_activity_tasks[];
}

export interface ActivityUpdate_activityUpdate {
  __typename: "ActivityUpdatePayload";
  /**
   * The updated activity
   */
  activity: ActivityUpdate_activityUpdate_activity;
}

export interface ActivityUpdate {
  /**
   * Update an activity
   */
  activityUpdate: ActivityUpdate_activityUpdate;
}

export interface ActivityUpdateVariables {
  input: ActivityUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetActivityDefaults
// ====================================================

export interface GetActivityDefaults_activityDefaults_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetActivityDefaults_activityDefaults_relatedEntities {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
  primaryEmailAddress: string | null;
  primaryPhoneNumber: string | null;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface GetActivityDefaults_activityDefaults_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
  primaryEmailAddress: string | null;
  primaryPhoneNumber: string | null;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface GetActivityDefaults_activityDefaults_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetActivityDefaults_activityDefaults_previousActivity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface GetActivityDefaults_activityDefaults {
  __typename: "ActivityDefaults";
  /**
   * The name of the activity
   */
  name: string;
  /**
   * The quill delta lognote of the activity
   */
  quillDelta: string | null;
  /**
   * The lognote of the activity
   */
  logNote: string | null;
  /**
   * The type of activity
   */
  activityType: GetActivityDefaults_activityDefaults_activityType;
  /**
   * The start time of the activity
   */
  startTime: any;
  /**
   * The end time of the activity
   */
  endTime: any;
  /**
   * The potential related entities (leads) for the given entity ids on an activity
   */
  relatedEntities: GetActivityDefaults_activityDefaults_relatedEntities[];
  /**
   * The potential related entities (contacts, accounts, users) for the given entity ids on an activity
   */
  participants: GetActivityDefaults_activityDefaults_participants[];
  /**
   * The user who is creating the activity
   */
  creatorUser: GetActivityDefaults_activityDefaults_creatorUser;
  /**
   * The previous activity in the follow-up chain
   */
  previousActivity: GetActivityDefaults_activityDefaults_previousActivity | null;
}

export interface GetActivityDefaults {
  /**
   * Default values to power the activity modal on creation/scheduling
   */
  activityDefaults: GetActivityDefaults_activityDefaults;
}

export interface GetActivityDefaultsVariables {
  input?: ActivityDefaultsInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetActivityForModal
// ====================================================

export interface GetActivityForModal_activity_logNote_audioLog {
  __typename: "EntityAttributeValueFile";
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Unique id for this file
   */
  fileId: string;
}

export interface GetActivityForModal_activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The plain text (i.e., no HTML/rich text, no NutMark for @-mention tokenizing) representation of the Note text
   */
  body: string | null;
  /**
   * The audio log for this note
   */
  audioLog: GetActivityForModal_activity_logNote_audioLog | null;
}

export interface GetActivityForModal_activity_externalMeeting_audioLog {
  __typename: "EntityAttributeValueFile";
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Unique id for this file
   */
  fileId: string;
}

export interface GetActivityForModal_activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The audio log of this meeting
   */
  audioLog: GetActivityForModal_activity_externalMeeting_audioLog | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
}

export interface GetActivityForModal_activity_summary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
}

export interface GetActivityForModal_activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
  primaryEmailAddress: string | null;
  primaryPhoneNumber: string | null;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface GetActivityForModal_activity_participantsWithStatus_participant {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
  primaryEmailAddress: string | null;
  primaryPhoneNumber: string | null;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface GetActivityForModal_activity_participantsWithStatus {
  __typename: "ActivityParticipantEdge";
  /**
   * Null when the activity is not publicly synced, the feature is disabled, or the
   * assignment status is not an invitation response (e.g. completed, incomplete).
   */
  attendanceStatus: ActivityParticipantAttendanceStatus | null;
  participant: GetActivityForModal_activity_participantsWithStatus_participant;
}

export interface GetActivityForModal_activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface GetActivityForModal_activity_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetActivityForModal_activity_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  originType: OriginType;
}

export interface GetActivityForModal_activity_comments_edges_node_changeLogEntry {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetActivityForModal_activity_comments_edges_node_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetActivityForModal_activity_comments_edges_node_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: GetActivityForModal_activity_comments_edges_node_reactions_creatorUser;
}

export interface GetActivityForModal_activity_comments_edges_node_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  htmlUrl: string | null;
}

export interface GetActivityForModal_activity_comments_edges_node {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Change log associated with the comment
   */
  changeLogEntry: GetActivityForModal_activity_comments_edges_node_changeLogEntry | null;
  /**
   * User reactions left for the comment change log entry
   */
  reactions: GetActivityForModal_activity_comments_edges_node_reactions[];
  /**
   * The user who created the comment.
   */
  creatorUser: GetActivityForModal_activity_comments_edges_node_creatorUser;
  /**
   * The created time for the comment.
   */
  createdTime: any;
  /**
   * True if this comment can be deleted
   */
  isDeleteable: boolean;
}

export interface GetActivityForModal_activity_comments_edges {
  __typename: "CommentsEdge";
  node: GetActivityForModal_activity_comments_edges_node;
}

export interface GetActivityForModal_activity_comments {
  __typename: "CommentsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetActivityForModal_activity_comments_edges[];
}

export interface GetActivityForModal_activity_loggedBy {
  __typename: "User";
  name: string;
}

export interface GetActivityForModal_activity_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface GetActivityForModal_activity_conferenceData {
  __typename: "ConferenceData";
  externalId: string | null;
  externalUuid: string | null;
  meetingUrl: string;
  type: ActivityConferenceType;
  canBeRemoved: boolean;
}

export interface GetActivityForModal_activity_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * Leads don’t have initials, but for interface reasons we’ll return an empty
   * string here instead of removing the property entirely.
   */
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetActivityForModal_activity_summaryStates {
  __typename: "ActivitySummaryStates";
  /**
   * The copy to display for the current activity configuration on the recording tab.
   */
  recordingEmptyState: string;
  /**
   * The copy to display for the current activity configuration on the transcription tab.
   */
  transcriptionEmptyState: string;
  /**
   * The current state of the activity summary.
   */
  summaryEmptyState: string;
  /**
   * The next action to take for the activity summary.
   */
  summaryNextAction: ActivitySummaryAction;
  /**
   * Whether the relevant notetaker feature has been disabled by an admin.
   */
  isNotetakerDisabled: boolean;
}

export interface GetActivityForModal_activity_previousActivity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface GetActivityForModal_activity_nextActivity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface GetActivityForModal_activity_tasks_delayApplications_delay {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the delay
   */
  name: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface GetActivityForModal_activity_tasks_delayApplications_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetActivityForModal_activity_tasks_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * An optional note about the delay application
   */
  note: string | null;
  /**
   * The time when the delay was applied
   */
  appliedTime: any;
  /**
   * The delay that was applied
   */
  delay: GetActivityForModal_activity_tasks_delayApplications_delay;
  /**
   * The user who applied the delay
   */
  user: GetActivityForModal_activity_tasks_delayApplications_user | null;
}

export interface GetActivityForModal_activity_tasks_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetActivityForModal_activity_tasks_completedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetActivityForModal_activity_tasks_relatedEntity {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetActivityForModal_activity_tasks_creatorEntity_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface GetActivityForModal_activity_tasks_creatorEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export type GetActivityForModal_activity_tasks_creatorEntity = GetActivityForModal_activity_tasks_creatorEntity_Chat | GetActivityForModal_activity_tasks_creatorEntity_Activity;

export interface GetActivityForModal_activity_tasks_assigner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetActivityForModal_activity_tasks_recurrenceRule {
  __typename: "RecurrenceRule";
  mode: RecurrenceMode;
  /**
   * An RRULE-compatible string defining the recurrence pattern (e.g. "FREQ=WEEKLY;BYDAY=MO").
   */
  rule: string;
}

export interface GetActivityForModal_activity_tasks {
  __typename: "Task";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the task
   */
  title: string;
  /**
   * The canonical API href for the task
   */
  href: string;
  /**
   * The task’s user-defined description
   */
  description: string | null;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: GetActivityForModal_activity_tasks_delayApplications[];
  /**
   * The due timestamp of the task
   */
  dueTime: any | null;
  /**
   * The person or team assigned to this task
   */
  assignee: GetActivityForModal_activity_tasks_assignee | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  completedTime: any | null;
  /**
   * Can the task be completed?
   */
  canBeCompleted: boolean;
  /**
   * Is this task completed?
   */
  isCompleted: boolean;
  /**
   * The user who completed the task
   */
  completedByUser: GetActivityForModal_activity_tasks_completedByUser | null;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Whether the tasks due date is later than the current date
   */
  isOverdue: boolean;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  relatedEntity: GetActivityForModal_activity_tasks_relatedEntity | null;
  /**
   * The DateTime that represents when the Activity record was created
   */
  createdTime: any;
  /**
   * The task's linkified description with URLs converted to clickable links
   */
  linkifiedDescription: string | null;
  isAiGenerated: boolean;
  creatorEntity: GetActivityForModal_activity_tasks_creatorEntity | null;
  /**
   * The user who assigned the task
   */
  assigner: GetActivityForModal_activity_tasks_assigner | null;
  /**
   * The time the task was assigned
   */
  assignedTime: any | null;
  /**
   * Number of days between follow-up reminders. Null if the task is not recurring.
   */
  recurringPeriod: number | null;
  /**
   * Whether this task is the current user recurring follow-up reminder.
   */
  isRecurringForUser: boolean;
  /**
   * Null if the task does not recur under the new recurrence system.
   */
  recurrenceRule: GetActivityForModal_activity_tasks_recurrenceRule | null;
}

export interface GetActivityForModal_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetActivityForModal_activity_logNote | null;
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: GetActivityForModal_activity_externalMeeting | null;
  /**
   * The summary of the activity.
   */
  summary: GetActivityForModal_activity_summary | null;
  /**
   * The transcription of the activity.
   */
  transcription: string | null;
  /**
   * The status of the transcription.
   */
  transcriptionStatus: ActivityTranscriptionStatus;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetActivityForModal_activity_participants[];
  /**
   * Activity participants paired with their calendar invitation response status.
   */
  participantsWithStatus: GetActivityForModal_activity_participantsWithStatus[];
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetActivityForModal_activity_activityType;
  /**
   * The boolean that represents whether or not the Activity is overdue.
   * Specifically, this means that the activity is not logged, and is in the past.
   */
  isOverdue: boolean;
  /**
   * The DateTime that represents the start time of the Activity record
   */
  startTime: any;
  /**
   * The DateTime that represents the end time of the Activity record
   */
  endTime: any;
  /**
   * Whether the activity should be summarized by the AI.
   */
  shouldSummarize: boolean;
  /**
   * Whether the activity is currently generating a summary.
   */
  generatingSummary: boolean;
  /**
   * Whether the activity is currently generating a recording.
   */
  generatingRecording: boolean;
  /**
   * The type of external service that the associated meeting belongs to
   */
  externalMeetingServiceType: ExternalServiceType | null;
  /**
   * The DateTime that represents when the Activity record was created
   */
  createdTime: any;
  /**
   * The user that created the activity.
   */
  creatorUser: GetActivityForModal_activity_creatorUser | null;
  /**
   * The origin that created the activity.
   */
  creatorOrigin: GetActivityForModal_activity_creatorOrigin | null;
  /**
   * The url of the origin that created the activity.
   */
  originUrl: string;
  /**
   * The comments for the activity.
   */
  comments: GetActivityForModal_activity_comments;
  /**
   * The status of the activity.
   */
  status: ActivityStatus;
  /**
   * Freeform text for public notes & agendas around the Nutshell Activity
   */
  agenda: string;
  /**
   * The boolean that represents whether or not the Activity represents an all day calendar event
   */
  isAllDay: boolean;
  /**
   * The boolean that represents whether an activity should display the audio log.
   */
  shouldDisplayAudio: boolean;
  /**
   * The boolean that represents whether an activity should display the video log.
   */
  shouldDisplayVideo: boolean;
  /**
   * Whether the activity has an associated scheduler booking.
   */
  hasBooking: boolean;
  /**
   * The user that logged the activity.
   */
  loggedBy: GetActivityForModal_activity_loggedBy | null;
  /**
   * The time that the activity was logged.
   */
  loggedTime: any | null;
  /**
   * Whether the activity was autologged
   */
  autologged: boolean;
  /**
   * An optional geographic location for the activity, helpful for knowing not only the time but the _place_ of the meeting
   */
  location: GetActivityForModal_activity_location | null;
  /**
   * The URL of the meeting for the activity.
   */
  externalMeetingUrl: string | null;
  conferenceData: GetActivityForModal_activity_conferenceData | null;
  /**
   * Related leads for the activity.
   */
  relatedLeads: GetActivityForModal_activity_relatedLeads[];
  /**
   * The Quill delta for the activity note. Useful for reconstructing @mentions.
   */
  quillDelta: string | null;
  /**
   * Whether the activity is editable.
   */
  isEditable: boolean;
  /**
   * Whether the activity has been connected to an external calendar
   */
  isConnectedToExternalCalendar: boolean;
  /**
   * Whether the activity can be summarized by the AI.
   */
  canViewSummaryDetails: boolean;
  /**
   * The current states of the activity based on its type and current conditions.
   */
  summaryStates: GetActivityForModal_activity_summaryStates;
  /**
   * Whether the user can log the activity.
   */
  canUserLogActivity: boolean;
  /**
   * The linkified agenda of the activity.
   */
  linkifiedAgenda: string;
  /**
   * Whether the user can sync the activity to the calendar.
   */
  canUserSeeSyncStatus: boolean;
  /**
   * Whether the activity should be force synced to the calendar. Not necessarily synced yet.
   */
  isForceSync: boolean;
  /**
   * Whether the activity is loggable due to its timing.
   */
  isLoggable: boolean;
  /**
   * Whether the activity should be synced to the calendar.
   */
  shouldSyncToCalendar: boolean;
  /**
   * The activity that preceded this activity in the follow up chain.
   */
  previousActivity: GetActivityForModal_activity_previousActivity | null;
  /**
   * The activity that followed this activity in the follow up chain.
   */
  nextActivity: GetActivityForModal_activity_nextActivity | null;
  /**
   * Whether the user can schedule a follow up for the activity.
   */
  canScheduleFollowUp: boolean;
  /**
   * The username of the organizer that the activity is synced to.
   */
  syncOrganizerUsername: string | null;
  /**
   * Whether the activity is private.
   */
  isPrivate: boolean;
  /**
   * The mode of how the activity should be synced to the calendar.
   */
  syncMode: ActivitySyncMode;
  /**
   * Tasks that were originated from this activity. Currently only as follow-ups from meeting summaries.
   */
  tasks: GetActivityForModal_activity_tasks[];
}

export interface GetActivityForModal {
  /**
   * Returns a Nutshell Activity
   */
  activity: GetActivityForModal_activity | null;
}

export interface GetActivityForModalVariables {
  activityId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetActivitySyncStatus
// ====================================================

export interface GetActivitySyncStatus_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether the activity has been connected to an external calendar
   */
  isConnectedToExternalCalendar: boolean;
}

export interface GetActivitySyncStatus {
  /**
   * Returns a Nutshell Activity
   */
  activity: GetActivitySyncStatus_activity | null;
}

export interface GetActivitySyncStatusVariables {
  activityId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetActivityTranscriptAndSummary
// ====================================================

export interface GetActivityTranscriptAndSummary_activity_summary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
}

export interface GetActivityTranscriptAndSummary_activity_logNote_audioLog {
  __typename: "EntityAttributeValueFile";
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Unique id for this file
   */
  fileId: string;
}

export interface GetActivityTranscriptAndSummary_activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audio log for this note
   */
  audioLog: GetActivityTranscriptAndSummary_activity_logNote_audioLog | null;
}

export interface GetActivityTranscriptAndSummary_activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
}

export interface GetActivityTranscriptAndSummary_activity_summaryStates {
  __typename: "ActivitySummaryStates";
  /**
   * The copy to display for the current activity configuration on the recording tab.
   */
  recordingEmptyState: string;
  /**
   * The copy to display for the current activity configuration on the transcription tab.
   */
  transcriptionEmptyState: string;
  /**
   * The current state of the activity summary.
   */
  summaryEmptyState: string;
  /**
   * The next action to take for the activity summary.
   */
  summaryNextAction: ActivitySummaryAction;
  /**
   * Whether the relevant notetaker feature has been disabled by an admin.
   */
  isNotetakerDisabled: boolean;
}

export interface GetActivityTranscriptAndSummary_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The transcription of the activity.
   */
  transcription: string | null;
  /**
   * The status of the transcription.
   */
  transcriptionStatus: ActivityTranscriptionStatus;
  /**
   * The summary of the activity.
   */
  summary: GetActivityTranscriptAndSummary_activity_summary | null;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetActivityTranscriptAndSummary_activity_logNote | null;
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: GetActivityTranscriptAndSummary_activity_externalMeeting | null;
  /**
   * Whether the activity is currently generating a summary.
   */
  generatingSummary: boolean;
  /**
   * Whether the activity is currently generating a recording.
   */
  generatingRecording: boolean;
  /**
   * The boolean that represents whether an activity should display the audio log.
   */
  shouldDisplayAudio: boolean;
  /**
   * The current states of the activity based on its type and current conditions.
   */
  summaryStates: GetActivityTranscriptAndSummary_activity_summaryStates;
}

export interface GetActivityTranscriptAndSummary {
  /**
   * Returns a Nutshell Activity
   */
  activity: GetActivityTranscriptAndSummary_activity | null;
}

export interface GetActivityTranscriptAndSummaryVariables {
  activityId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCalendarSyncForActivityModal
// ====================================================

export interface GetCalendarSyncForActivityModal_loggedInUser_calendarSync_primaryCalendar {
  __typename: "CalendarSyncCalendar";
  /**
   * The rules for what events, if any, should be added to the calendar from Nutshell
   */
  exportRule: CalendarExportRule;
}

export interface GetCalendarSyncForActivityModal_loggedInUser_calendarSync {
  __typename: "CalendarSync";
  /**
   * Whether or not calendar sync is enabled
   */
  isEnabled: boolean;
  /**
   * The external calendar service we're syncing with
   */
  externalService: ExternalService;
  /**
   * How to handle calendar invitations when creating activities that sync to the external calendar
   */
  inviteSetting: CalendarInviteSetting;
  /**
   * The primary calendar we are syncing with
   */
  primaryCalendar: GetCalendarSyncForActivityModal_loggedInUser_calendarSync_primaryCalendar | null;
}

export interface GetCalendarSyncForActivityModal_loggedInUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Calendar sync details for this user
   */
  calendarSync: GetCalendarSyncForActivityModal_loggedInUser_calendarSync | null;
}

export interface GetCalendarSyncForActivityModal {
  /**
   * Returns the requesting user. This is essentially the logged in user, but in an
   * API context, they might not be any "logged in"
   */
  loggedInUser: GetCalendarSyncForActivityModal_loggedInUser;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPotentialActivityEntities
// ====================================================

export interface GetPotentialActivityEntities_activityPotentialEntities_relatedEntities {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
  primaryEmailAddress: string | null;
  primaryPhoneNumber: string | null;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface GetPotentialActivityEntities_activityPotentialEntities_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
  primaryEmailAddress: string | null;
  primaryPhoneNumber: string | null;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface GetPotentialActivityEntities_activityPotentialEntities {
  __typename: "ActivityPotentialEntities";
  /**
   * The potential related entities (leads) for the given entity ids on an activity
   */
  relatedEntities: GetPotentialActivityEntities_activityPotentialEntities_relatedEntities[];
  /**
   * The potential related entities (contacts, accounts, users) for the given entity ids on an activity
   */
  participants: GetPotentialActivityEntities_activityPotentialEntities_participants[];
}

export interface GetPotentialActivityEntities {
  /**
   * The potential related entities for the given entity ids on an activity
   */
  activityPotentialEntities: GetPotentialActivityEntities_activityPotentialEntities;
}

export interface GetPotentialActivityEntitiesVariables {
  input: PotentialEntitiesInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAiFeature
// ====================================================

export interface GetAiFeature_aiFeature_AiFeatureBase {
  __typename: "AiFeatureBase";
  /**
   * The type of the feature
   */
  type: AiFeatureType;
  requiresUpgrade: boolean;
  /**
   * The display name of the lowest plan that includes this feature, or null if available on all plans
   */
  minimumPlanName: string | null;
}

export interface GetAiFeature_aiFeature_AiFeatureWithStats_stats_AiValueStat {
  __typename: "AiValueStat";
  /**
   * The display name of the feature stat
   */
  displayName: string;
  /**
   * The tooltip of the feature stat
   */
  tooltip: string | null;
  /**
   * The value to be displayed
   */
  value: string;
}

export interface GetAiFeature_aiFeature_AiFeatureWithStats_stats_AiPercentageStat {
  __typename: "AiPercentageStat";
  /**
   * The display name of the feature stat
   */
  displayName: string;
  /**
   * The tooltip of the feature stat
   */
  tooltip: string | null;
  /**
   * The percentage to be displayed
   */
  percentage: number;
}

export interface GetAiFeature_aiFeature_AiFeatureWithStats_stats_AiUserStat_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface GetAiFeature_aiFeature_AiFeatureWithStats_stats_AiUserStat {
  __typename: "AiUserStat";
  /**
   * The display name of the feature stat
   */
  displayName: string;
  /**
   * The tooltip of the feature stat
   */
  tooltip: string | null;
  /**
   * The user who has the stat
   */
  user: GetAiFeature_aiFeature_AiFeatureWithStats_stats_AiUserStat_user | null;
}

export interface GetAiFeature_aiFeature_AiFeatureWithStats_stats_AiLimitStat {
  __typename: "AiLimitStat";
  /**
   * The display name of the feature stat
   */
  displayName: string;
  /**
   * The tooltip of the feature stat
   */
  tooltip: string | null;
  limitValue: number;
  limit: number | null;
  isUnlimited: boolean;
}

export type GetAiFeature_aiFeature_AiFeatureWithStats_stats = GetAiFeature_aiFeature_AiFeatureWithStats_stats_AiValueStat | GetAiFeature_aiFeature_AiFeatureWithStats_stats_AiPercentageStat | GetAiFeature_aiFeature_AiFeatureWithStats_stats_AiUserStat | GetAiFeature_aiFeature_AiFeatureWithStats_stats_AiLimitStat;

export interface GetAiFeature_aiFeature_AiFeatureWithStats {
  __typename: "AiFeatureWithStats";
  /**
   * The type of the feature
   */
  type: AiFeatureType;
  requiresUpgrade: boolean;
  /**
   * The display name of the lowest plan that includes this feature, or null if available on all plans
   */
  minimumPlanName: string | null;
  /**
   * The stats of the feature
   */
  stats: GetAiFeature_aiFeature_AiFeatureWithStats_stats[];
  loggedInUserHasUsed: boolean;
}

export type GetAiFeature_aiFeature = GetAiFeature_aiFeature_AiFeatureBase | GetAiFeature_aiFeature_AiFeatureWithStats;

export interface GetAiFeature {
  /**
   * A specific feature of the Nutshell AI offerings
   */
  aiFeature: GetAiFeature_aiFeature;
}

export interface GetAiFeatureVariables {
  type: AiFeatureType;
  period: AiFeaturePeriod;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAiHomepage
// ====================================================

export interface GetAiHomepage_aiHomepage_stats_AiValueStat {
  __typename: "AiValueStat";
  /**
   * The display name of the feature stat
   */
  displayName: string;
  /**
   * The tooltip of the feature stat
   */
  tooltip: string | null;
  /**
   * The value to be displayed
   */
  value: string;
}

export interface GetAiHomepage_aiHomepage_stats_AiPercentageStat {
  __typename: "AiPercentageStat";
  /**
   * The display name of the feature stat
   */
  displayName: string;
  /**
   * The tooltip of the feature stat
   */
  tooltip: string | null;
  /**
   * The percentage to be displayed
   */
  percentage: number;
}

export interface GetAiHomepage_aiHomepage_stats_AiUserStat_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface GetAiHomepage_aiHomepage_stats_AiUserStat {
  __typename: "AiUserStat";
  /**
   * The display name of the feature stat
   */
  displayName: string;
  /**
   * The tooltip of the feature stat
   */
  tooltip: string | null;
  /**
   * The user who has the stat
   */
  user: GetAiHomepage_aiHomepage_stats_AiUserStat_user | null;
}

export interface GetAiHomepage_aiHomepage_stats_AiLimitStat {
  __typename: "AiLimitStat";
  /**
   * The display name of the feature stat
   */
  displayName: string;
  /**
   * The tooltip of the feature stat
   */
  tooltip: string | null;
  limitValue: number;
  limit: number | null;
  isUnlimited: boolean;
}

export type GetAiHomepage_aiHomepage_stats = GetAiHomepage_aiHomepage_stats_AiValueStat | GetAiHomepage_aiHomepage_stats_AiPercentageStat | GetAiHomepage_aiHomepage_stats_AiUserStat | GetAiHomepage_aiHomepage_stats_AiLimitStat;

export interface GetAiHomepage_aiHomepage_topUsers_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface GetAiHomepage_aiHomepage_topUsers {
  __typename: "AiUser";
  /**
   * The user
   */
  user: GetAiHomepage_aiHomepage_topUsers_user;
  /**
   * The formatted time saved by this user
   */
  timeSaved: string;
  outcomeCount: number;
}

export interface GetAiHomepage_aiHomepage_topFeatures_AiFeatureBase {
  __typename: "AiFeatureBase";
  /**
   * The type of the feature
   */
  type: AiFeatureType;
  /**
   * The display name of the feature
   */
  displayName: string;
  requiresUpgrade: boolean;
  /**
   * The display name of the lowest plan that includes this feature, or null if available on all plans
   */
  minimumPlanName: string | null;
}

export interface GetAiHomepage_aiHomepage_topFeatures_AiFeatureWithStats_stats_AiValueStat {
  __typename: "AiValueStat";
  /**
   * The display name of the feature stat
   */
  displayName: string;
  /**
   * The tooltip of the feature stat
   */
  tooltip: string | null;
  /**
   * The value to be displayed
   */
  value: string;
}

export interface GetAiHomepage_aiHomepage_topFeatures_AiFeatureWithStats_stats_AiPercentageStat {
  __typename: "AiPercentageStat";
  /**
   * The display name of the feature stat
   */
  displayName: string;
  /**
   * The tooltip of the feature stat
   */
  tooltip: string | null;
  /**
   * The percentage to be displayed
   */
  percentage: number;
}

export interface GetAiHomepage_aiHomepage_topFeatures_AiFeatureWithStats_stats_AiUserStat_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface GetAiHomepage_aiHomepage_topFeatures_AiFeatureWithStats_stats_AiUserStat {
  __typename: "AiUserStat";
  /**
   * The display name of the feature stat
   */
  displayName: string;
  /**
   * The tooltip of the feature stat
   */
  tooltip: string | null;
  /**
   * The user who has the stat
   */
  user: GetAiHomepage_aiHomepage_topFeatures_AiFeatureWithStats_stats_AiUserStat_user | null;
}

export interface GetAiHomepage_aiHomepage_topFeatures_AiFeatureWithStats_stats_AiLimitStat {
  __typename: "AiLimitStat";
  /**
   * The display name of the feature stat
   */
  displayName: string;
  /**
   * The tooltip of the feature stat
   */
  tooltip: string | null;
  limitValue: number;
  limit: number | null;
  isUnlimited: boolean;
}

export type GetAiHomepage_aiHomepage_topFeatures_AiFeatureWithStats_stats = GetAiHomepage_aiHomepage_topFeatures_AiFeatureWithStats_stats_AiValueStat | GetAiHomepage_aiHomepage_topFeatures_AiFeatureWithStats_stats_AiPercentageStat | GetAiHomepage_aiHomepage_topFeatures_AiFeatureWithStats_stats_AiUserStat | GetAiHomepage_aiHomepage_topFeatures_AiFeatureWithStats_stats_AiLimitStat;

export interface GetAiHomepage_aiHomepage_topFeatures_AiFeatureWithStats {
  __typename: "AiFeatureWithStats";
  /**
   * The type of the feature
   */
  type: AiFeatureType;
  /**
   * The display name of the feature
   */
  displayName: string;
  requiresUpgrade: boolean;
  /**
   * The display name of the lowest plan that includes this feature, or null if available on all plans
   */
  minimumPlanName: string | null;
  /**
   * The stats of the feature
   */
  stats: GetAiHomepage_aiHomepage_topFeatures_AiFeatureWithStats_stats[];
}

export type GetAiHomepage_aiHomepage_topFeatures = GetAiHomepage_aiHomepage_topFeatures_AiFeatureBase | GetAiHomepage_aiHomepage_topFeatures_AiFeatureWithStats;

export interface GetAiHomepage_aiHomepage {
  __typename: "AiHomepage";
  /**
   * Whether the instance has ever used any Nutshell AI features
   */
  hasAiUsage: boolean;
  /**
   * The stats of the AI homepage
   */
  stats: GetAiHomepage_aiHomepage_stats[];
  /**
   * The top users by usage of Nutshell AI features
   */
  topUsers: GetAiHomepage_aiHomepage_topUsers[];
  /**
   * The top features by usage of Nutshell AI features
   */
  topFeatures: GetAiHomepage_aiHomepage_topFeatures[];
}

export interface GetAiHomepage {
  /**
   * Get the AI homepage stats and features
   */
  aiHomepage: GetAiHomepage_aiHomepage;
}

export interface GetAiHomepageVariables {
  period: AiFeaturePeriod;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ProductCategoryCreate
// ====================================================

export interface ProductCategoryCreate_productCategoryCreate_productCategory {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
  /**
   * The time the product category was created
   */
  createdTime: any;
  /**
   * The number of products associated with this category
   */
  numAssociatedProducts: number;
  /**
   * The link to the report for this product category
   */
  reportLink: string;
}

export interface ProductCategoryCreate_productCategoryCreate {
  __typename: "ProductCategoryCreatePayload";
  /**
   * The product category object
   */
  productCategory: ProductCategoryCreate_productCategoryCreate_productCategory;
}

export interface ProductCategoryCreate {
  /**
   * Create a product category
   */
  productCategoryCreate: ProductCategoryCreate_productCategoryCreate;
}

export interface ProductCategoryCreateVariables {
  input: ProductCategoryCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ProductCategoryDelete
// ====================================================

export interface ProductCategoryDelete_productCategoryDelete_productCategory {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
  /**
   * The time the product category was created
   */
  createdTime: any;
  /**
   * The number of products associated with this category
   */
  numAssociatedProducts: number;
  /**
   * The link to the report for this product category
   */
  reportLink: string;
}

export interface ProductCategoryDelete_productCategoryDelete {
  __typename: "ProductCategoryDeletePayload";
  /**
   * The product category that has been successfully deleted
   */
  productCategory: ProductCategoryDelete_productCategoryDelete_productCategory;
}

export interface ProductCategoryDelete {
  /**
   * Deletes a product category
   */
  productCategoryDelete: ProductCategoryDelete_productCategoryDelete;
}

export interface ProductCategoryDeleteVariables {
  input: ProductCategoryDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ProductCategoryUpdate
// ====================================================

export interface ProductCategoryUpdate_productCategoryUpdate_productCategory {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
  /**
   * The time the product category was created
   */
  createdTime: any;
  /**
   * The number of products associated with this category
   */
  numAssociatedProducts: number;
  /**
   * The link to the report for this product category
   */
  reportLink: string;
}

export interface ProductCategoryUpdate_productCategoryUpdate {
  __typename: "ProductCategoryUpdatePayload";
  /**
   * The product category that was updated
   */
  productCategory: ProductCategoryUpdate_productCategoryUpdate_productCategory;
}

export interface ProductCategoryUpdate {
  /**
   * Returns the updated product category
   */
  productCategoryUpdate: ProductCategoryUpdate_productCategoryUpdate;
}

export interface ProductCategoryUpdateVariables {
  input: ProductCategoryUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetProductsCategories
// ====================================================

export interface GetProductsCategories_productCategories {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
  /**
   * The time the product category was created
   */
  createdTime: any;
  /**
   * The number of products associated with this category
   */
  numAssociatedProducts: number;
  /**
   * The link to the report for this product category
   */
  reportLink: string;
}

export interface GetProductsCategories {
  /**
   * Returns all product categories
   */
  productCategories: GetProductsCategories_productCategories[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetProductsSidebarCounts
// ====================================================

export interface GetProductsSidebarCounts_productsSidebarCounts {
  __typename: "ProductsSidebarCounts";
  /**
   * The total number of non-deleted products
   */
  numProducts: number;
  /**
   * The total number of non-deleted products that are uncategorized
   */
  numUncategorizedProducts: number;
  /**
   * The total number of deleted products
   */
  numDeletedProducts: number;
}

export interface GetProductsSidebarCounts {
  /**
   * Returns products sidebar counts
   */
  productsSidebarCounts: GetProductsSidebarCounts_productsSidebarCounts;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TranscribeActivityCall
// ====================================================

export interface TranscribeActivityCall_activityTranscribeCall_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The transcription of the activity.
   */
  transcription: string | null;
  /**
   * The status of the transcription.
   */
  transcriptionStatus: ActivityTranscriptionStatus;
}

export interface TranscribeActivityCall_activityTranscribeCall {
  __typename: "ActivityTranscribeCallPayload";
  /**
   * The activity that has had a transcription queued.
   */
  activity: TranscribeActivityCall_activityTranscribeCall_activity;
}

export interface TranscribeActivityCall {
  /**
   * Kicks off a transcribe call for a given Click To Call activity.
   */
  activityTranscribeCall: TranscribeActivityCall_activityTranscribeCall | null;
}

export interface TranscribeActivityCallVariables {
  input: ActivityTranscribeCallInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ConnectedFormActivate
// ====================================================

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_mcfxForm {
  __typename: "McfxForm";
  /**
   * A list of unique submission urls
   */
  urls: string[];
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_publishedVersion_fields_exampleValues_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile" | "EntityAttributeValueImage" | "EntityAttributeValueset" | "EntityAttributeValueLocation" | "EntityAttributeValueCurrency" | "EntityAttributeValueDate" | "EntityAttributeValueEmail" | "EntityAttributeValueEnum" | "EntityAttributeValuePhone" | "EntityAttributeValueNumber" | "EntityAttributeValueText" | "EntityAttributeValueUrl";
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_publishedVersion_fields_exampleValues_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export type ConnectedFormActivate_connectedFormActivate_connectedForm_publishedVersion_fields_exampleValues_all = ConnectedFormActivate_connectedFormActivate_connectedForm_publishedVersion_fields_exampleValues_all_EntityAttributeValueFile | ConnectedFormActivate_connectedFormActivate_connectedForm_publishedVersion_fields_exampleValues_all_EntityAttributeValueString;

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_publishedVersion_fields_exampleValues {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: ConnectedFormActivate_connectedFormActivate_connectedForm_publishedVersion_fields_exampleValues_all[];
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The input name that we received from an MCFX form submission
   */
  inputName: string;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: ConnectedFormActivate_connectedFormActivate_connectedForm_publishedVersion_fields_attribute | null;
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * If a field is ignored, data that it contains will not be transfered into Nutshell entities
   */
  isIgnored: boolean;
  /**
   * Whether or not the field has the required information to create data in Nutshell
   */
  needsMapping: boolean;
  /**
   * The last 3 submitted values for this field – only relevent for MCFX forms
   */
  exampleValues: ConnectedFormActivate_connectedFormActivate_connectedForm_publishedVersion_fields_exampleValues;
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
  /**
   * Array of fields associated with this web form version
   */
  fields: ConnectedFormActivate_connectedFormActivate_connectedForm_publishedVersion_fields[];
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_contact_audiences[];
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_lead_stagesetFieldRules_stageset;
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_lead_stagesetFieldRules[];
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a contact
   */
  contact: ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_account | null;
  /**
   * The create rules related to a lead
   */
  lead: ConnectedFormActivate_connectedFormActivate_connectedForm_createRules_lead | null;
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: ConnectedFormActivate_connectedFormActivate_connectedForm_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: ConnectedFormActivate_connectedFormActivate_connectedForm_nextSteps_slackMessage_form;
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type ConnectedFormActivate_connectedFormActivate_connectedForm_nextSteps_nutshellNotification_notifiables = ConnectedFormActivate_connectedFormActivate_connectedForm_nextSteps_nutshellNotification_notifiables_NotifiableAlias | ConnectedFormActivate_connectedFormActivate_connectedForm_nextSteps_nutshellNotification_notifiables_User;

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: ConnectedFormActivate_connectedFormActivate_connectedForm_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: ConnectedFormActivate_connectedFormActivate_connectedForm_nextSteps_nutshellNotification_form;
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: ConnectedFormActivate_connectedFormActivate_connectedForm_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: ConnectedFormActivate_connectedFormActivate_connectedForm_nextSteps_nutshellNotification | null;
}

export interface ConnectedFormActivate_connectedFormActivate_connectedForm {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The status of the form
   */
  status: FormStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of mapped fields on this form
   */
  numMappedFields: number;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The mcfx form that points to this wfForm
   */
  mcfxForm: ConnectedFormActivate_connectedFormActivate_connectedForm_mcfxForm | null;
  /**
   * The version of this form that is published
   */
  publishedVersion: ConnectedFormActivate_connectedFormActivate_connectedForm_publishedVersion | null;
  /**
   * Json representation of create rules for this form
   */
  createRules: ConnectedFormActivate_connectedFormActivate_connectedForm_createRules;
  /**
   * Next step automations for this form
   */
  nextSteps: ConnectedFormActivate_connectedFormActivate_connectedForm_nextSteps;
}

export interface ConnectedFormActivate_connectedFormActivate {
  __typename: "ConnectedFormActivatePayload";
  /**
   * The activated connected form
   */
  connectedForm: ConnectedFormActivate_connectedFormActivate_connectedForm | null;
}

export interface ConnectedFormActivate {
  /**
   * Activates a connected form
   */
  connectedFormActivate: ConnectedFormActivate_connectedFormActivate;
}

export interface ConnectedFormActivateVariables {
  input: ConnectedFormActivateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: connectedFormUnignore
// ====================================================

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_mcfxForm {
  __typename: "McfxForm";
  /**
   * A list of unique submission urls
   */
  urls: string[];
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_publishedVersion_fields_exampleValues_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile" | "EntityAttributeValueImage" | "EntityAttributeValueset" | "EntityAttributeValueLocation" | "EntityAttributeValueCurrency" | "EntityAttributeValueDate" | "EntityAttributeValueEmail" | "EntityAttributeValueEnum" | "EntityAttributeValuePhone" | "EntityAttributeValueNumber" | "EntityAttributeValueText" | "EntityAttributeValueUrl";
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_publishedVersion_fields_exampleValues_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export type connectedFormUnignore_connectedFormUnignore_connectedForm_publishedVersion_fields_exampleValues_all = connectedFormUnignore_connectedFormUnignore_connectedForm_publishedVersion_fields_exampleValues_all_EntityAttributeValueFile | connectedFormUnignore_connectedFormUnignore_connectedForm_publishedVersion_fields_exampleValues_all_EntityAttributeValueString;

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_publishedVersion_fields_exampleValues {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: connectedFormUnignore_connectedFormUnignore_connectedForm_publishedVersion_fields_exampleValues_all[];
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The input name that we received from an MCFX form submission
   */
  inputName: string;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: connectedFormUnignore_connectedFormUnignore_connectedForm_publishedVersion_fields_attribute | null;
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * If a field is ignored, data that it contains will not be transfered into Nutshell entities
   */
  isIgnored: boolean;
  /**
   * Whether or not the field has the required information to create data in Nutshell
   */
  needsMapping: boolean;
  /**
   * The last 3 submitted values for this field – only relevent for MCFX forms
   */
  exampleValues: connectedFormUnignore_connectedFormUnignore_connectedForm_publishedVersion_fields_exampleValues;
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
  /**
   * Array of fields associated with this web form version
   */
  fields: connectedFormUnignore_connectedFormUnignore_connectedForm_publishedVersion_fields[];
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_contact_audiences[];
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_lead_stagesetFieldRules_stageset;
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_lead_stagesetFieldRules[];
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a contact
   */
  contact: connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_account | null;
  /**
   * The create rules related to a lead
   */
  lead: connectedFormUnignore_connectedFormUnignore_connectedForm_createRules_lead | null;
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: connectedFormUnignore_connectedFormUnignore_connectedForm_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: connectedFormUnignore_connectedFormUnignore_connectedForm_nextSteps_slackMessage_form;
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type connectedFormUnignore_connectedFormUnignore_connectedForm_nextSteps_nutshellNotification_notifiables = connectedFormUnignore_connectedFormUnignore_connectedForm_nextSteps_nutshellNotification_notifiables_NotifiableAlias | connectedFormUnignore_connectedFormUnignore_connectedForm_nextSteps_nutshellNotification_notifiables_User;

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: connectedFormUnignore_connectedFormUnignore_connectedForm_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: connectedFormUnignore_connectedFormUnignore_connectedForm_nextSteps_nutshellNotification_form;
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: connectedFormUnignore_connectedFormUnignore_connectedForm_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: connectedFormUnignore_connectedFormUnignore_connectedForm_nextSteps_nutshellNotification | null;
}

export interface connectedFormUnignore_connectedFormUnignore_connectedForm {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The status of the form
   */
  status: FormStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of mapped fields on this form
   */
  numMappedFields: number;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The mcfx form that points to this wfForm
   */
  mcfxForm: connectedFormUnignore_connectedFormUnignore_connectedForm_mcfxForm | null;
  /**
   * The version of this form that is published
   */
  publishedVersion: connectedFormUnignore_connectedFormUnignore_connectedForm_publishedVersion | null;
  /**
   * Json representation of create rules for this form
   */
  createRules: connectedFormUnignore_connectedFormUnignore_connectedForm_createRules;
  /**
   * Next step automations for this form
   */
  nextSteps: connectedFormUnignore_connectedFormUnignore_connectedForm_nextSteps;
}

export interface connectedFormUnignore_connectedFormUnignore {
  __typename: "ConnectedFormUnignorePayload";
  /**
   * The not-activated connected form
   */
  connectedForm: connectedFormUnignore_connectedFormUnignore_connectedForm | null;
}

export interface connectedFormUnignore {
  /**
   * Sets connected form to not-activated
   */
  connectedFormUnignore: connectedFormUnignore_connectedFormUnignore;
}

export interface connectedFormUnignoreVariables {
  input: ConnectedFormUnignoreInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: IgnoreForm
// ====================================================

export interface IgnoreForm_connectedFormIgnore_connectedForm_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface IgnoreForm_connectedFormIgnore_connectedForm_publishedVersion_fields_exampleValues_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile" | "EntityAttributeValueImage" | "EntityAttributeValueset" | "EntityAttributeValueLocation" | "EntityAttributeValueCurrency" | "EntityAttributeValueDate" | "EntityAttributeValueEmail" | "EntityAttributeValueEnum" | "EntityAttributeValuePhone" | "EntityAttributeValueNumber" | "EntityAttributeValueText" | "EntityAttributeValueUrl";
}

export interface IgnoreForm_connectedFormIgnore_connectedForm_publishedVersion_fields_exampleValues_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export type IgnoreForm_connectedFormIgnore_connectedForm_publishedVersion_fields_exampleValues_all = IgnoreForm_connectedFormIgnore_connectedForm_publishedVersion_fields_exampleValues_all_EntityAttributeValueFile | IgnoreForm_connectedFormIgnore_connectedForm_publishedVersion_fields_exampleValues_all_EntityAttributeValueString;

export interface IgnoreForm_connectedFormIgnore_connectedForm_publishedVersion_fields_exampleValues {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: IgnoreForm_connectedFormIgnore_connectedForm_publishedVersion_fields_exampleValues_all[];
}

export interface IgnoreForm_connectedFormIgnore_connectedForm_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The input name that we received from an MCFX form submission
   */
  inputName: string;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: IgnoreForm_connectedFormIgnore_connectedForm_publishedVersion_fields_attribute | null;
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * If a field is ignored, data that it contains will not be transfered into Nutshell entities
   */
  isIgnored: boolean;
  /**
   * Whether or not the field has the required information to create data in Nutshell
   */
  needsMapping: boolean;
  /**
   * The last 3 submitted values for this field – only relevent for MCFX forms
   */
  exampleValues: IgnoreForm_connectedFormIgnore_connectedForm_publishedVersion_fields_exampleValues;
}

export interface IgnoreForm_connectedFormIgnore_connectedForm_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of fields associated with this web form version
   */
  fields: IgnoreForm_connectedFormIgnore_connectedForm_publishedVersion_fields[];
}

export interface IgnoreForm_connectedFormIgnore_connectedForm {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The status of the form
   */
  status: FormStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of mapped fields on this form
   */
  numMappedFields: number;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The version of this form that is published
   */
  publishedVersion: IgnoreForm_connectedFormIgnore_connectedForm_publishedVersion | null;
}

export interface IgnoreForm_connectedFormIgnore {
  __typename: "ConnectedFormIgnorePayload";
  /**
   * The ignored connected form
   */
  connectedForm: IgnoreForm_connectedFormIgnore_connectedForm | null;
}

export interface IgnoreForm {
  /**
   * Ignores a connected form
   */
  connectedFormIgnore: IgnoreForm_connectedFormIgnore;
}

export interface IgnoreFormVariables {
  input: ConnectedFormIgnoreInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateField
// ====================================================

export interface UpdateField_formFieldUpdate_field_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateField_formFieldUpdate_field_exampleValues_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile" | "EntityAttributeValueImage" | "EntityAttributeValueset" | "EntityAttributeValueLocation" | "EntityAttributeValueCurrency" | "EntityAttributeValueDate" | "EntityAttributeValueEmail" | "EntityAttributeValueEnum" | "EntityAttributeValuePhone" | "EntityAttributeValueNumber" | "EntityAttributeValueText" | "EntityAttributeValueUrl";
}

export interface UpdateField_formFieldUpdate_field_exampleValues_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export type UpdateField_formFieldUpdate_field_exampleValues_all = UpdateField_formFieldUpdate_field_exampleValues_all_EntityAttributeValueFile | UpdateField_formFieldUpdate_field_exampleValues_all_EntityAttributeValueString;

export interface UpdateField_formFieldUpdate_field_exampleValues {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: UpdateField_formFieldUpdate_field_exampleValues_all[];
}

export interface UpdateField_formFieldUpdate_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The input name that we received from an MCFX form submission
   */
  inputName: string;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: UpdateField_formFieldUpdate_field_attribute | null;
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * If a field is ignored, data that it contains will not be transfered into Nutshell entities
   */
  isIgnored: boolean;
  /**
   * Whether or not the field has the required information to create data in Nutshell
   */
  needsMapping: boolean;
  /**
   * The last 3 submitted values for this field – only relevent for MCFX forms
   */
  exampleValues: UpdateField_formFieldUpdate_field_exampleValues;
}

export interface UpdateField_formFieldUpdate {
  __typename: "FormFieldUpdatePayload";
  /**
   * The updated field.
   */
  field: UpdateField_formFieldUpdate_field | null;
}

export interface UpdateField {
  /**
   * Updates a form field.
   */
  formFieldUpdate: UpdateField_formFieldUpdate;
}

export interface UpdateFieldVariables {
  input: FormFieldUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: WfFormCreateRulesUpdate
// ====================================================

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_mcfxForm {
  __typename: "McfxForm";
  /**
   * A list of unique submission urls
   */
  urls: string[];
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_exampleValues_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile" | "EntityAttributeValueImage" | "EntityAttributeValueset" | "EntityAttributeValueLocation" | "EntityAttributeValueCurrency" | "EntityAttributeValueDate" | "EntityAttributeValueEmail" | "EntityAttributeValueEnum" | "EntityAttributeValuePhone" | "EntityAttributeValueNumber" | "EntityAttributeValueText" | "EntityAttributeValueUrl";
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_exampleValues_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export type WfFormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_exampleValues_all = WfFormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_exampleValues_all_EntityAttributeValueFile | WfFormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_exampleValues_all_EntityAttributeValueString;

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_exampleValues {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_exampleValues_all[];
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The input name that we received from an MCFX form submission
   */
  inputName: string;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_attribute | null;
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * If a field is ignored, data that it contains will not be transfered into Nutshell entities
   */
  isIgnored: boolean;
  /**
   * Whether or not the field has the required information to create data in Nutshell
   */
  needsMapping: boolean;
  /**
   * The last 3 submitted values for this field – only relevent for MCFX forms
   */
  exampleValues: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_exampleValues;
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
  /**
   * Array of fields associated with this web form version
   */
  fields: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields[];
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_contact_audiences[];
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_stagesetFieldRules_stageset;
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_stagesetFieldRules[];
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a contact
   */
  contact: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_account | null;
  /**
   * The create rules related to a lead
   */
  lead: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead | null;
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_slackMessage_form;
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type WfFormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_nutshellNotification_notifiables = WfFormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias | WfFormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_nutshellNotification_notifiables_User;

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_nutshellNotification_form;
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_nutshellNotification | null;
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The status of the form
   */
  status: FormStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of mapped fields on this form
   */
  numMappedFields: number;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The mcfx form that points to this wfForm
   */
  mcfxForm: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_mcfxForm | null;
  /**
   * The version of this form that is published
   */
  publishedVersion: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion | null;
  /**
   * Json representation of create rules for this form
   */
  createRules: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_createRules;
  /**
   * Next step automations for this form
   */
  nextSteps: WfFormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps;
}

export interface WfFormCreateRulesUpdate_formCreateRulesUpdate {
  __typename: "FormCreateRulesUpdatePayload";
  /**
   * The assigned Nutshell form.
   */
  form: WfFormCreateRulesUpdate_formCreateRulesUpdate_form | null;
}

export interface WfFormCreateRulesUpdate {
  /**
   * Updates the create rules for a Nutshell form.
   */
  formCreateRulesUpdate: WfFormCreateRulesUpdate_formCreateRulesUpdate;
}

export interface WfFormCreateRulesUpdateVariables {
  input: FormCreateRulesUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateWfForm
// ====================================================

export interface UpdateWfForm_formUpdate_form_mcfxForm {
  __typename: "McfxForm";
  /**
   * A list of unique submission urls
   */
  urls: string[];
}

export interface UpdateWfForm_formUpdate_form_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateWfForm_formUpdate_form_publishedVersion_fields_exampleValues_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile" | "EntityAttributeValueImage" | "EntityAttributeValueset" | "EntityAttributeValueLocation" | "EntityAttributeValueCurrency" | "EntityAttributeValueDate" | "EntityAttributeValueEmail" | "EntityAttributeValueEnum" | "EntityAttributeValuePhone" | "EntityAttributeValueNumber" | "EntityAttributeValueText" | "EntityAttributeValueUrl";
}

export interface UpdateWfForm_formUpdate_form_publishedVersion_fields_exampleValues_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export type UpdateWfForm_formUpdate_form_publishedVersion_fields_exampleValues_all = UpdateWfForm_formUpdate_form_publishedVersion_fields_exampleValues_all_EntityAttributeValueFile | UpdateWfForm_formUpdate_form_publishedVersion_fields_exampleValues_all_EntityAttributeValueString;

export interface UpdateWfForm_formUpdate_form_publishedVersion_fields_exampleValues {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: UpdateWfForm_formUpdate_form_publishedVersion_fields_exampleValues_all[];
}

export interface UpdateWfForm_formUpdate_form_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The input name that we received from an MCFX form submission
   */
  inputName: string;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: UpdateWfForm_formUpdate_form_publishedVersion_fields_attribute | null;
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * If a field is ignored, data that it contains will not be transfered into Nutshell entities
   */
  isIgnored: boolean;
  /**
   * Whether or not the field has the required information to create data in Nutshell
   */
  needsMapping: boolean;
  /**
   * The last 3 submitted values for this field – only relevent for MCFX forms
   */
  exampleValues: UpdateWfForm_formUpdate_form_publishedVersion_fields_exampleValues;
}

export interface UpdateWfForm_formUpdate_form_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
  /**
   * Array of fields associated with this web form version
   */
  fields: UpdateWfForm_formUpdate_form_publishedVersion_fields[];
}

export interface UpdateWfForm_formUpdate_form_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateWfForm_formUpdate_form_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface UpdateWfForm_formUpdate_form_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: UpdateWfForm_formUpdate_form_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: UpdateWfForm_formUpdate_form_createRules_contact_audiences[];
}

export interface UpdateWfForm_formUpdate_form_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateWfForm_formUpdate_form_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: UpdateWfForm_formUpdate_form_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface UpdateWfForm_formUpdate_form_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface UpdateWfForm_formUpdate_form_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateWfForm_formUpdate_form_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface UpdateWfForm_formUpdate_form_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface UpdateWfForm_formUpdate_form_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface UpdateWfForm_formUpdate_form_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: UpdateWfForm_formUpdate_form_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: UpdateWfForm_formUpdate_form_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: UpdateWfForm_formUpdate_form_createRules_lead_stagesetFieldRules_stageset;
}

export interface UpdateWfForm_formUpdate_form_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: UpdateWfForm_formUpdate_form_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: UpdateWfForm_formUpdate_form_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: UpdateWfForm_formUpdate_form_createRules_lead_stagesetFieldRules[];
}

export interface UpdateWfForm_formUpdate_form_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a contact
   */
  contact: UpdateWfForm_formUpdate_form_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: UpdateWfForm_formUpdate_form_createRules_account | null;
  /**
   * The create rules related to a lead
   */
  lead: UpdateWfForm_formUpdate_form_createRules_lead | null;
}

export interface UpdateWfForm_formUpdate_form_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface UpdateWfForm_formUpdate_form_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateWfForm_formUpdate_form_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: UpdateWfForm_formUpdate_form_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: UpdateWfForm_formUpdate_form_nextSteps_slackMessage_form;
}

export interface UpdateWfForm_formUpdate_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface UpdateWfForm_formUpdate_form_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type UpdateWfForm_formUpdate_form_nextSteps_nutshellNotification_notifiables = UpdateWfForm_formUpdate_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias | UpdateWfForm_formUpdate_form_nextSteps_nutshellNotification_notifiables_User;

export interface UpdateWfForm_formUpdate_form_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateWfForm_formUpdate_form_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: UpdateWfForm_formUpdate_form_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: UpdateWfForm_formUpdate_form_nextSteps_nutshellNotification_form;
}

export interface UpdateWfForm_formUpdate_form_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: UpdateWfForm_formUpdate_form_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: UpdateWfForm_formUpdate_form_nextSteps_nutshellNotification | null;
}

export interface UpdateWfForm_formUpdate_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The status of the form
   */
  status: FormStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of mapped fields on this form
   */
  numMappedFields: number;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The mcfx form that points to this wfForm
   */
  mcfxForm: UpdateWfForm_formUpdate_form_mcfxForm | null;
  /**
   * The version of this form that is published
   */
  publishedVersion: UpdateWfForm_formUpdate_form_publishedVersion | null;
  /**
   * Json representation of create rules for this form
   */
  createRules: UpdateWfForm_formUpdate_form_createRules;
  /**
   * Next step automations for this form
   */
  nextSteps: UpdateWfForm_formUpdate_form_nextSteps;
}

export interface UpdateWfForm_formUpdate {
  __typename: "FormUpdatePayload";
  /**
   * The assigned Nutshell form.
   */
  form: UpdateWfForm_formUpdate_form | null;
}

export interface UpdateWfForm {
  /**
   * Updates the editable version of a Nutshell form.
   */
  formUpdate: UpdateWfForm_formUpdate;
}

export interface UpdateWfFormVariables {
  input: FormUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMcfxForms
// ====================================================

export interface GetMcfxForms_mcfxForms_pageInfo {
  __typename: "PageInfo";
  endCursor: string | null;
  hasNextPage: boolean;
}

export interface GetMcfxForms_mcfxForms_edges_node_lastSubmission {
  __typename: "FormSubmission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  createdTime: any;
}

export interface GetMcfxForms_mcfxForms_edges_node_submissions_edges_node_form {
  __typename: "McfxForm";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMcfxForms_mcfxForms_edges_node_submissions_edges_node_contact_nutshellContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMcfxForms_mcfxForms_edges_node_submissions_edges_node_contact {
  __typename: "McfxContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The contact that made this form submission.
   */
  nutshellContact: GetMcfxForms_mcfxForms_edges_node_submissions_edges_node_contact_nutshellContact | null;
}

export interface GetMcfxForms_mcfxForms_edges_node_submissions_edges_node {
  __typename: "FormSubmission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  createdTime: any;
  /**
   * The mcfx form that this submission is from.
   */
  form: GetMcfxForms_mcfxForms_edges_node_submissions_edges_node_form;
  /**
   * The contact that made this form submission.
   */
  contact: GetMcfxForms_mcfxForms_edges_node_submissions_edges_node_contact | null;
}

export interface GetMcfxForms_mcfxForms_edges_node_submissions_edges {
  __typename: "McfxSubmissionEdge";
  node: GetMcfxForms_mcfxForms_edges_node_submissions_edges_node;
}

export interface GetMcfxForms_mcfxForms_edges_node_submissions {
  __typename: "McfxSubmissionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetMcfxForms_mcfxForms_edges_node_submissions_edges[];
}

export interface GetMcfxForms_mcfxForms_edges_node_wfForm_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMcfxForms_mcfxForms_edges_node_wfForm_publishedVersion_fields_exampleValues_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile" | "EntityAttributeValueImage" | "EntityAttributeValueset" | "EntityAttributeValueLocation" | "EntityAttributeValueCurrency" | "EntityAttributeValueDate" | "EntityAttributeValueEmail" | "EntityAttributeValueEnum" | "EntityAttributeValuePhone" | "EntityAttributeValueNumber" | "EntityAttributeValueText" | "EntityAttributeValueUrl";
}

export interface GetMcfxForms_mcfxForms_edges_node_wfForm_publishedVersion_fields_exampleValues_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export type GetMcfxForms_mcfxForms_edges_node_wfForm_publishedVersion_fields_exampleValues_all = GetMcfxForms_mcfxForms_edges_node_wfForm_publishedVersion_fields_exampleValues_all_EntityAttributeValueFile | GetMcfxForms_mcfxForms_edges_node_wfForm_publishedVersion_fields_exampleValues_all_EntityAttributeValueString;

export interface GetMcfxForms_mcfxForms_edges_node_wfForm_publishedVersion_fields_exampleValues {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: GetMcfxForms_mcfxForms_edges_node_wfForm_publishedVersion_fields_exampleValues_all[];
}

export interface GetMcfxForms_mcfxForms_edges_node_wfForm_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The input name that we received from an MCFX form submission
   */
  inputName: string;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: GetMcfxForms_mcfxForms_edges_node_wfForm_publishedVersion_fields_attribute | null;
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * If a field is ignored, data that it contains will not be transfered into Nutshell entities
   */
  isIgnored: boolean;
  /**
   * Whether or not the field has the required information to create data in Nutshell
   */
  needsMapping: boolean;
  /**
   * The last 3 submitted values for this field – only relevent for MCFX forms
   */
  exampleValues: GetMcfxForms_mcfxForms_edges_node_wfForm_publishedVersion_fields_exampleValues;
}

export interface GetMcfxForms_mcfxForms_edges_node_wfForm_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of fields associated with this web form version
   */
  fields: GetMcfxForms_mcfxForms_edges_node_wfForm_publishedVersion_fields[];
}

export interface GetMcfxForms_mcfxForms_edges_node_wfForm {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The status of the form
   */
  status: FormStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of mapped fields on this form
   */
  numMappedFields: number;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The version of this form that is published
   */
  publishedVersion: GetMcfxForms_mcfxForms_edges_node_wfForm_publishedVersion | null;
}

export interface GetMcfxForms_mcfxForms_edges_node {
  __typename: "McfxForm";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmission: GetMcfxForms_mcfxForms_edges_node_lastSubmission | null;
  submissions: GetMcfxForms_mcfxForms_edges_node_submissions;
  /**
   * The wf form that this mcfx form is related to.
   */
  wfForm: GetMcfxForms_mcfxForms_edges_node_wfForm | null;
}

export interface GetMcfxForms_mcfxForms_edges {
  __typename: "McfxFormsEdge";
  cursor: string;
  node: GetMcfxForms_mcfxForms_edges_node;
}

export interface GetMcfxForms_mcfxForms {
  __typename: "McfxFormsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetMcfxForms_mcfxForms_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetMcfxForms_mcfxForms_edges[];
}

export interface GetMcfxForms {
  /**
   * Returns a connection of Mcfx Forms
   */
  mcfxForms: GetMcfxForms_mcfxForms;
}

export interface GetMcfxFormsVariables {
  filters: McfxFormsInput;
  limit: number;
  after?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWfForm
// ====================================================

export interface GetWfForm_form_mcfxForm {
  __typename: "McfxForm";
  /**
   * A list of unique submission urls
   */
  urls: string[];
}

export interface GetWfForm_form_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetWfForm_form_publishedVersion_fields_exampleValues_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile" | "EntityAttributeValueImage" | "EntityAttributeValueset" | "EntityAttributeValueLocation" | "EntityAttributeValueCurrency" | "EntityAttributeValueDate" | "EntityAttributeValueEmail" | "EntityAttributeValueEnum" | "EntityAttributeValuePhone" | "EntityAttributeValueNumber" | "EntityAttributeValueText" | "EntityAttributeValueUrl";
}

export interface GetWfForm_form_publishedVersion_fields_exampleValues_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export type GetWfForm_form_publishedVersion_fields_exampleValues_all = GetWfForm_form_publishedVersion_fields_exampleValues_all_EntityAttributeValueFile | GetWfForm_form_publishedVersion_fields_exampleValues_all_EntityAttributeValueString;

export interface GetWfForm_form_publishedVersion_fields_exampleValues {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: GetWfForm_form_publishedVersion_fields_exampleValues_all[];
}

export interface GetWfForm_form_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The input name that we received from an MCFX form submission
   */
  inputName: string;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: GetWfForm_form_publishedVersion_fields_attribute | null;
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * If a field is ignored, data that it contains will not be transfered into Nutshell entities
   */
  isIgnored: boolean;
  /**
   * Whether or not the field has the required information to create data in Nutshell
   */
  needsMapping: boolean;
  /**
   * The last 3 submitted values for this field – only relevent for MCFX forms
   */
  exampleValues: GetWfForm_form_publishedVersion_fields_exampleValues;
}

export interface GetWfForm_form_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
  /**
   * Array of fields associated with this web form version
   */
  fields: GetWfForm_form_publishedVersion_fields[];
}

export interface GetWfForm_form_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetWfForm_form_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetWfForm_form_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: GetWfForm_form_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: GetWfForm_form_createRules_contact_audiences[];
}

export interface GetWfForm_form_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetWfForm_form_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: GetWfForm_form_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface GetWfForm_form_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetWfForm_form_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetWfForm_form_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface GetWfForm_form_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface GetWfForm_form_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetWfForm_form_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: GetWfForm_form_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: GetWfForm_form_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: GetWfForm_form_createRules_lead_stagesetFieldRules_stageset;
}

export interface GetWfForm_form_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: GetWfForm_form_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: GetWfForm_form_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: GetWfForm_form_createRules_lead_stagesetFieldRules[];
}

export interface GetWfForm_form_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a contact
   */
  contact: GetWfForm_form_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: GetWfForm_form_createRules_account | null;
  /**
   * The create rules related to a lead
   */
  lead: GetWfForm_form_createRules_lead | null;
}

export interface GetWfForm_form_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface GetWfForm_form_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetWfForm_form_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: GetWfForm_form_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: GetWfForm_form_nextSteps_slackMessage_form;
}

export interface GetWfForm_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface GetWfForm_form_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type GetWfForm_form_nextSteps_nutshellNotification_notifiables = GetWfForm_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias | GetWfForm_form_nextSteps_nutshellNotification_notifiables_User;

export interface GetWfForm_form_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetWfForm_form_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: GetWfForm_form_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: GetWfForm_form_nextSteps_nutshellNotification_form;
}

export interface GetWfForm_form_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: GetWfForm_form_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: GetWfForm_form_nextSteps_nutshellNotification | null;
}

export interface GetWfForm_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The status of the form
   */
  status: FormStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of mapped fields on this form
   */
  numMappedFields: number;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The mcfx form that points to this wfForm
   */
  mcfxForm: GetWfForm_form_mcfxForm | null;
  /**
   * The version of this form that is published
   */
  publishedVersion: GetWfForm_form_publishedVersion | null;
  /**
   * Json representation of create rules for this form
   */
  createRules: GetWfForm_form_createRules;
  /**
   * Next step automations for this form
   */
  nextSteps: GetWfForm_form_nextSteps;
}

export interface GetWfForm {
  /**
   * Returns a Nutshell web form by ID or slug.
   */
  form: GetWfForm_form;
}

export interface GetWfFormVariables {
  formId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ContractUpdateStatus
// ====================================================

export interface ContractUpdateStatus_contractUpdateStatus_contract {
  __typename: "Contract";
  id: string;
  displayStatus: ContractDisplayStatus;
  modifiedTime: any | null;
  readyTime: any | null;
  sentTime: any | null;
  acceptedTime: any | null;
  revokedTime: any | null;
}

export interface ContractUpdateStatus_contractUpdateStatus {
  __typename: "ContractUpdateStatusPayload";
  contract: ContractUpdateStatus_contractUpdateStatus_contract;
}

export interface ContractUpdateStatus {
  /**
   * Updates the status of a contract.
   */
  contractUpdateStatus: ContractUpdateStatus_contractUpdateStatus;
}

export interface ContractUpdateStatusVariables {
  input: ContractUpdateStatusInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ContractUpdate
// ====================================================

export interface ContractUpdate_contractUpdate_contract {
  __typename: "Contract";
  id: string;
  name: string;
  modifiedTime: any | null;
  validThroughTime: string | null;
}

export interface ContractUpdate_contractUpdate {
  __typename: "ContractUpdatePayload";
  contract: ContractUpdate_contractUpdate_contract;
}

export interface ContractUpdate {
  /**
   * Updates a contract.
   */
  contractUpdate: ContractUpdate_contractUpdate;
}

export interface ContractUpdateVariables {
  input: ContractUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLeadContract
// ====================================================

export interface GetLeadContract_contract_recipientEntity_Contact_primaryAccount_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContract_contract_recipientEntity_Contact_primaryAccount {
  __typename: "ContactAccountsEdge";
  node: GetLeadContract_contract_recipientEntity_Contact_primaryAccount_node;
}

export interface GetLeadContract_contract_recipientEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary account edge for this contact
   */
  primaryAccount: GetLeadContract_contract_recipientEntity_Contact_primaryAccount | null;
}

export interface GetLeadContract_contract_recipientEntity_Account_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContract_contract_recipientEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary contact for this account
   */
  primaryContact: GetLeadContract_contract_recipientEntity_Account_primaryContact | null;
}

export type GetLeadContract_contract_recipientEntity = GetLeadContract_contract_recipientEntity_Contact | GetLeadContract_contract_recipientEntity_Account;

export interface GetLeadContract_contract_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContract_contract_fields {
  __typename: "DocumentField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  contractId: string | null;
  direction: DocumentFieldDirection;
  type: DocumentFieldType;
  signatureValueType: DocumentSignatureValueType | null;
  label: string;
  placeholder: string | null;
  isRequired: boolean;
  entityName: string | null;
  fieldName: string | null;
  entityAttributeId: string | null;
  /**
   * Raw JSON configuration for this field.
   */
  fieldJson: string | null;
  pageNumber: number | null;
  value: string | null;
}

export interface GetLeadContract_contract_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  avatarUrl: string;
}

export interface GetLeadContract_contract {
  __typename: "Contract";
  id: string;
  /**
   * Same-origin URL for this contract PDF.
   */
  pdfDownloadUrl: string | null;
  shareableViewInBrowserLink: string;
  internalViewInBrowserLink: string;
  name: string;
  description: string | null;
  publicSlug: string;
  number: number;
  displayNumber: string;
  displayStatus: ContractDisplayStatus;
  recipientEntity: GetLeadContract_contract_recipientEntity | null;
  recipientEmailAddress: string | null;
  readyTime: any | null;
  sentTime: any | null;
  acceptedTime: any | null;
  revokedTime: any | null;
  validThroughTime: string | null;
  creatorUserTimezone: string;
  createdTime: any;
  modifiedTime: any | null;
  deletedTime: any | null;
  creatorUser: GetLeadContract_contract_creatorUser | null;
  fields: GetLeadContract_contract_fields[];
  lead: GetLeadContract_contract_lead;
}

export interface GetLeadContract {
  /**
   * Returns a contract by ID.
   */
  contract: GetLeadContract_contract | null;
}

export interface GetLeadContractVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContractsOverview
// ====================================================

export interface GetContractsOverview_contractsOverview_edges_node_recipientEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
}

export interface GetContractsOverview_contractsOverview_edges_node_recipientEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The primary email address for this account
   */
  primaryEmailAddress: string | null;
}

export type GetContractsOverview_contractsOverview_edges_node_recipientEntity = GetContractsOverview_contractsOverview_edges_node_recipientEntity_Contact | GetContractsOverview_contractsOverview_edges_node_recipientEntity_Account;

export interface GetContractsOverview_contractsOverview_edges_node_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetContractsOverview_contractsOverview_edges_node_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetContractsOverview_contractsOverview_edges_node_createdFromTemplate {
  __typename: "ContractTemplate";
  id: string;
  name: string;
  htmlUrlPath: string;
  deletedTime: any | null;
}

export interface GetContractsOverview_contractsOverview_edges_node {
  __typename: "Contract";
  id: string;
  name: string;
  shareableViewInBrowserLink: string;
  internalViewInBrowserLink: string;
  displayNumber: string;
  displayStatus: ContractDisplayStatus;
  createdTime: any;
  modifiedTime: any | null;
  readyTime: any | null;
  sentTime: any | null;
  acceptedTime: any | null;
  revokedTime: any | null;
  deletedTime: any | null;
  /**
   * Url path to this specific contract attached to a lead
   */
  leadContractUrl: string | null;
  recipientEntity: GetContractsOverview_contractsOverview_edges_node_recipientEntity | null;
  creatorUser: GetContractsOverview_contractsOverview_edges_node_creatorUser | null;
  lead: GetContractsOverview_contractsOverview_edges_node_lead;
  createdFromTemplate: GetContractsOverview_contractsOverview_edges_node_createdFromTemplate | null;
}

export interface GetContractsOverview_contractsOverview_edges {
  __typename: "ContractEdge";
  node: GetContractsOverview_contractsOverview_edges_node;
}

export interface GetContractsOverview_contractsOverview_pageInfo {
  __typename: "PageInfo";
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor: string | null;
  endCursor: string | null;
}

export interface GetContractsOverview_contractsOverview {
  __typename: "ContractsConnection";
  /**
   * A list of edges.
   */
  edges: GetContractsOverview_contractsOverview_edges[];
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetContractsOverview_contractsOverview_pageInfo;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetContractsOverview {
  /**
   * Returns generated contracts for the contracts overview page.
   */
  contractsOverview: GetContractsOverview_contractsOverview;
}

export interface GetContractsOverviewVariables {
  input: ContractListInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ContractTemplateArchive
// ====================================================

export interface ContractTemplateArchive_contractTemplateArchive_contractTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ContractTemplateArchive_contractTemplateArchive_contractTemplate_fields {
  __typename: "DocumentField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  direction: DocumentFieldDirection;
  type: DocumentFieldType;
  label: string;
  placeholder: string | null;
  isRequired: boolean;
  entityName: string | null;
  fieldName: string | null;
  entityAttributeId: string | null;
  /**
   * Raw JSON configuration for this field.
   */
  fieldJson: string | null;
  pageNumber: number | null;
}

export interface ContractTemplateArchive_contractTemplateArchive_contractTemplate {
  __typename: "ContractTemplate";
  id: string;
  name: string;
  description: string | null;
  isTemplatePublished: boolean;
  creatorUser: ContractTemplateArchive_contractTemplateArchive_contractTemplate_creatorUser | null;
  createdTime: any;
  modifiedTime: any | null;
  deletedTime: any | null;
  /**
   * Same-origin URL for the template PDF; requires session auth. Null if none.
   */
  pdfDownloadUrl: string | null;
  numGeneratedDocuments: number | null;
  htmlUrlPath: string;
  isAttachedToQuoteTemplate: boolean;
  lastUsedTime: any | null;
  fields: ContractTemplateArchive_contractTemplateArchive_contractTemplate_fields[];
}

export interface ContractTemplateArchive_contractTemplateArchive {
  __typename: "ContractTemplateArchivePayload";
  contractTemplate: ContractTemplateArchive_contractTemplateArchive_contractTemplate;
}

export interface ContractTemplateArchive {
  /**
   * Sets whether a contract template is archived.
   */
  contractTemplateArchive: ContractTemplateArchive_contractTemplateArchive;
}

export interface ContractTemplateArchiveVariables {
  id: string;
  isArchived: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ContractTemplateCreate
// ====================================================

export interface ContractTemplateCreate_contractTemplateCreate_contractTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ContractTemplateCreate_contractTemplateCreate_contractTemplate_fields {
  __typename: "DocumentField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  direction: DocumentFieldDirection;
  type: DocumentFieldType;
  label: string;
  placeholder: string | null;
  isRequired: boolean;
  entityName: string | null;
  fieldName: string | null;
  entityAttributeId: string | null;
  /**
   * Raw JSON configuration for this field.
   */
  fieldJson: string | null;
  pageNumber: number | null;
}

export interface ContractTemplateCreate_contractTemplateCreate_contractTemplate {
  __typename: "ContractTemplate";
  id: string;
  name: string;
  description: string | null;
  isTemplatePublished: boolean;
  creatorUser: ContractTemplateCreate_contractTemplateCreate_contractTemplate_creatorUser | null;
  createdTime: any;
  modifiedTime: any | null;
  deletedTime: any | null;
  /**
   * Same-origin URL for the template PDF; requires session auth. Null if none.
   */
  pdfDownloadUrl: string | null;
  numGeneratedDocuments: number | null;
  htmlUrlPath: string;
  isAttachedToQuoteTemplate: boolean;
  lastUsedTime: any | null;
  fields: ContractTemplateCreate_contractTemplateCreate_contractTemplate_fields[];
}

export interface ContractTemplateCreate_contractTemplateCreate {
  __typename: "ContractTemplateCreatePayload";
  contractTemplate: ContractTemplateCreate_contractTemplateCreate_contractTemplate;
}

export interface ContractTemplateCreate {
  /**
   * Creates a contract template with a PDF from Filestack.
   */
  contractTemplateCreate: ContractTemplateCreate_contractTemplateCreate;
}

export interface ContractTemplateCreateVariables {
  input: ContractTemplateCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ContractTemplateUpdate
// ====================================================

export interface ContractTemplateUpdate_contractTemplateUpdate_contractTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ContractTemplateUpdate_contractTemplateUpdate_contractTemplate_fields {
  __typename: "DocumentField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  direction: DocumentFieldDirection;
  type: DocumentFieldType;
  label: string;
  placeholder: string | null;
  isRequired: boolean;
  entityName: string | null;
  fieldName: string | null;
  entityAttributeId: string | null;
  /**
   * Raw JSON configuration for this field.
   */
  fieldJson: string | null;
  pageNumber: number | null;
}

export interface ContractTemplateUpdate_contractTemplateUpdate_contractTemplate {
  __typename: "ContractTemplate";
  id: string;
  name: string;
  description: string | null;
  isTemplatePublished: boolean;
  creatorUser: ContractTemplateUpdate_contractTemplateUpdate_contractTemplate_creatorUser | null;
  createdTime: any;
  modifiedTime: any | null;
  deletedTime: any | null;
  /**
   * Same-origin URL for the template PDF; requires session auth. Null if none.
   */
  pdfDownloadUrl: string | null;
  numGeneratedDocuments: number | null;
  htmlUrlPath: string;
  isAttachedToQuoteTemplate: boolean;
  lastUsedTime: any | null;
  fields: ContractTemplateUpdate_contractTemplateUpdate_contractTemplate_fields[];
}

export interface ContractTemplateUpdate_contractTemplateUpdate {
  __typename: "ContractTemplateUpdatePayload";
  contractTemplate: ContractTemplateUpdate_contractTemplateUpdate_contractTemplate;
}

export interface ContractTemplateUpdate {
  /**
   * Updates a contract template.
   */
  contractTemplateUpdate: ContractTemplateUpdate_contractTemplateUpdate;
}

export interface ContractTemplateUpdateVariables {
  input: ContractTemplateUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContractTemplateChildren
// ====================================================

export interface GetContractTemplateChildren_contractTemplateChildren_documents_edges_node_contract_recipientEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
}

export interface GetContractTemplateChildren_contractTemplateChildren_documents_edges_node_contract_recipientEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The primary email address for this account
   */
  primaryEmailAddress: string | null;
}

export type GetContractTemplateChildren_contractTemplateChildren_documents_edges_node_contract_recipientEntity = GetContractTemplateChildren_contractTemplateChildren_documents_edges_node_contract_recipientEntity_Contact | GetContractTemplateChildren_contractTemplateChildren_documents_edges_node_contract_recipientEntity_Account;

export interface GetContractTemplateChildren_contractTemplateChildren_documents_edges_node_contract_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetContractTemplateChildren_contractTemplateChildren_documents_edges_node_contract_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetContractTemplateChildren_contractTemplateChildren_documents_edges_node_contract_createdFromTemplate {
  __typename: "ContractTemplate";
  id: string;
  name: string;
  htmlUrlPath: string;
  deletedTime: any | null;
}

export interface GetContractTemplateChildren_contractTemplateChildren_documents_edges_node_contract {
  __typename: "Contract";
  id: string;
  name: string;
  shareableViewInBrowserLink: string;
  internalViewInBrowserLink: string;
  displayNumber: string;
  displayStatus: ContractDisplayStatus;
  createdTime: any;
  modifiedTime: any | null;
  readyTime: any | null;
  sentTime: any | null;
  acceptedTime: any | null;
  revokedTime: any | null;
  deletedTime: any | null;
  /**
   * Url path to this specific contract attached to a lead
   */
  leadContractUrl: string | null;
  recipientEntity: GetContractTemplateChildren_contractTemplateChildren_documents_edges_node_contract_recipientEntity | null;
  creatorUser: GetContractTemplateChildren_contractTemplateChildren_documents_edges_node_contract_creatorUser | null;
  lead: GetContractTemplateChildren_contractTemplateChildren_documents_edges_node_contract_lead;
  createdFromTemplate: GetContractTemplateChildren_contractTemplateChildren_documents_edges_node_contract_createdFromTemplate | null;
}

export interface GetContractTemplateChildren_contractTemplateChildren_documents_edges_node_quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetContractTemplateChildren_contractTemplateChildren_documents_edges_node {
  __typename: "EnvelopeDocument";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  documentType: EnvelopeDocumentType;
  contract: GetContractTemplateChildren_contractTemplateChildren_documents_edges_node_contract | null;
  quote: GetContractTemplateChildren_contractTemplateChildren_documents_edges_node_quote | null;
}

export interface GetContractTemplateChildren_contractTemplateChildren_documents_edges {
  __typename: "EnvelopeDocumentsEdge";
  node: GetContractTemplateChildren_contractTemplateChildren_documents_edges_node;
}

export interface GetContractTemplateChildren_contractTemplateChildren_documents {
  __typename: "EnvelopeDocumentsConnection";
  /**
   * A list of edges.
   */
  edges: GetContractTemplateChildren_contractTemplateChildren_documents_edges[];
}

export interface GetContractTemplateChildren_contractTemplateChildren {
  __typename: "Envelope";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  documents: GetContractTemplateChildren_contractTemplateChildren_documents;
}

export interface GetContractTemplateChildren {
  /**
   * Returns the envelopes for documents generated by a contract template.
   */
  contractTemplateChildren: GetContractTemplateChildren_contractTemplateChildren[];
}

export interface GetContractTemplateChildrenVariables {
  input: ContractTemplateChildrenInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContractTemplate
// ====================================================

export interface GetContractTemplate_contractTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetContractTemplate_contractTemplate_fields {
  __typename: "DocumentField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  direction: DocumentFieldDirection;
  type: DocumentFieldType;
  label: string;
  placeholder: string | null;
  isRequired: boolean;
  entityName: string | null;
  fieldName: string | null;
  entityAttributeId: string | null;
  /**
   * Raw JSON configuration for this field.
   */
  fieldJson: string | null;
  pageNumber: number | null;
}

export interface GetContractTemplate_contractTemplate {
  __typename: "ContractTemplate";
  id: string;
  name: string;
  description: string | null;
  isTemplatePublished: boolean;
  creatorUser: GetContractTemplate_contractTemplate_creatorUser | null;
  createdTime: any;
  modifiedTime: any | null;
  deletedTime: any | null;
  /**
   * Same-origin URL for the template PDF; requires session auth. Null if none.
   */
  pdfDownloadUrl: string | null;
  numGeneratedDocuments: number | null;
  htmlUrlPath: string;
  isAttachedToQuoteTemplate: boolean;
  lastUsedTime: any | null;
  fields: GetContractTemplate_contractTemplate_fields[];
}

export interface GetContractTemplate {
  /**
   * Returns a contract template by ID.
   */
  contractTemplate: GetContractTemplate_contractTemplate | null;
}

export interface GetContractTemplateVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContractTemplates
// ====================================================

export interface GetContractTemplates_contractTemplates_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetContractTemplates_contractTemplates_fields {
  __typename: "DocumentField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  direction: DocumentFieldDirection;
  type: DocumentFieldType;
  label: string;
  placeholder: string | null;
  isRequired: boolean;
  entityName: string | null;
  fieldName: string | null;
  entityAttributeId: string | null;
  /**
   * Raw JSON configuration for this field.
   */
  fieldJson: string | null;
  pageNumber: number | null;
}

export interface GetContractTemplates_contractTemplates {
  __typename: "ContractTemplate";
  id: string;
  name: string;
  description: string | null;
  isTemplatePublished: boolean;
  creatorUser: GetContractTemplates_contractTemplates_creatorUser | null;
  createdTime: any;
  modifiedTime: any | null;
  deletedTime: any | null;
  /**
   * Same-origin URL for the template PDF; requires session auth. Null if none.
   */
  pdfDownloadUrl: string | null;
  numGeneratedDocuments: number | null;
  htmlUrlPath: string;
  isAttachedToQuoteTemplate: boolean;
  lastUsedTime: any | null;
  fields: GetContractTemplates_contractTemplates_fields[];
}

export interface GetContractTemplates {
  /**
   * Returns contract templates (active by default, or archived when archived is true).
   */
  contractTemplates: GetContractTemplates_contractTemplates[];
}

export interface GetContractTemplatesVariables {
  input: ContractTemplateListInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCoreEntityDeletedEvent
// ====================================================

export interface GetCoreEntityDeletedEvent_coreEntity_deletedEvent_actor_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface GetCoreEntityDeletedEvent_coreEntity_deletedEvent_actor_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetCoreEntityDeletedEvent_coreEntity_deletedEvent_actor_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetCoreEntityDeletedEvent_coreEntity_deletedEvent_actor_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetCoreEntityDeletedEvent_coreEntity_deletedEvent_actor_Form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
}

export interface GetCoreEntityDeletedEvent_coreEntity_deletedEvent_actor_MaUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type GetCoreEntityDeletedEvent_coreEntity_deletedEvent_actor = GetCoreEntityDeletedEvent_coreEntity_deletedEvent_actor_User | GetCoreEntityDeletedEvent_coreEntity_deletedEvent_actor_Origin | GetCoreEntityDeletedEvent_coreEntity_deletedEvent_actor_Contact | GetCoreEntityDeletedEvent_coreEntity_deletedEvent_actor_Account | GetCoreEntityDeletedEvent_coreEntity_deletedEvent_actor_Form | GetCoreEntityDeletedEvent_coreEntity_deletedEvent_actor_MaUrl;

export interface GetCoreEntityDeletedEvent_coreEntity_deletedEvent {
  __typename: "TimelineEvent";
  changeTime: any;
  /**
   * The entity that triggered the change_log entry
   */
  actor: GetCoreEntityDeletedEvent_coreEntity_deletedEvent_actor;
}

export interface GetCoreEntityDeletedEvent_coreEntity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The change log entry for this entity’s soft delete, including actor and timestamp.
   */
  deletedEvent: GetCoreEntityDeletedEvent_coreEntity_deletedEvent | null;
}

export interface GetCoreEntityDeletedEvent {
  /**
   * Returns a Nutshell Core entity by id
   */
  coreEntity: GetCoreEntityDeletedEvent_coreEntity;
}

export interface GetCoreEntityDeletedEventVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateAccountForCoreEntity
// ====================================================

export interface CreateAccountForCoreEntity_accountCreate_account_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface CreateAccountForCoreEntity_accountCreate_account_postalAddresses_primary {
  __typename: "PostalAddress";
  location: CreateAccountForCoreEntity_accountCreate_account_postalAddresses_primary_location;
}

export interface CreateAccountForCoreEntity_accountCreate_account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: CreateAccountForCoreEntity_accountCreate_account_postalAddresses_primary | null;
}

export interface CreateAccountForCoreEntity_accountCreate_account_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface CreateAccountForCoreEntity_accountCreate_account_phones_primary {
  __typename: "Phone";
  value: CreateAccountForCoreEntity_accountCreate_account_phones_primary_value;
}

export interface CreateAccountForCoreEntity_accountCreate_account_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: CreateAccountForCoreEntity_accountCreate_account_phones_primary | null;
}

export interface CreateAccountForCoreEntity_accountCreate_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: CreateAccountForCoreEntity_accountCreate_account_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: CreateAccountForCoreEntity_accountCreate_account_phones;
}

export interface CreateAccountForCoreEntity_accountCreate {
  __typename: "AccountCreatePayload";
  /**
   * The created Nutshell account.
   */
  account: CreateAccountForCoreEntity_accountCreate_account;
}

export interface CreateAccountForCoreEntity {
  /**
   * Creates a Nutshell account
   */
  accountCreate: CreateAccountForCoreEntity_accountCreate;
}

export interface CreateAccountForCoreEntityVariables {
  input: AccountCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateContactForCoreEntity
// ====================================================

export interface CreateContactForCoreEntity_contactCreate_contact_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface CreateContactForCoreEntity_contactCreate_contact_phones_primary {
  __typename: "Phone";
  value: CreateContactForCoreEntity_contactCreate_contact_phones_primary_value;
}

export interface CreateContactForCoreEntity_contactCreate_contact_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: CreateContactForCoreEntity_contactCreate_contact_phones_primary | null;
}

export interface CreateContactForCoreEntity_contactCreate_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: CreateContactForCoreEntity_contactCreate_contact_phones;
}

export interface CreateContactForCoreEntity_contactCreate {
  __typename: "ContactCreatePayload";
  /**
   * The created Nutshell contact.
   */
  contact: CreateContactForCoreEntity_contactCreate_contact;
}

export interface CreateContactForCoreEntity {
  /**
   * Creates a Nutshell contact.
   */
  contactCreate: CreateContactForCoreEntity_contactCreate;
}

export interface CreateContactForCoreEntityVariables {
  input: ContactCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetActivitiesForWidget
// ====================================================

export interface GetActivitiesForWidget_activities_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface GetActivitiesForWidget_activities_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetActivitiesForWidget_activities_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
  primaryEmailAddress: string | null;
  primaryPhoneNumber: string | null;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface GetActivitiesForWidget_activities {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetActivitiesForWidget_activities_activityType;
  /**
   * The DateTime that represents the start time of the Activity record
   */
  startTime: any;
  /**
   * The DateTime that represents the end time of the Activity record
   */
  endTime: any;
  /**
   * The boolean that represents whether or not the Activity represents an all day calendar event
   */
  isAllDay: boolean;
  /**
   * The boolean that represents whether or not the Activity is overdue.
   * Specifically, this means that the activity is not logged, and is in the past.
   */
  isOverdue: boolean;
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: GetActivitiesForWidget_activities_externalMeeting | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetActivitiesForWidget_activities_participants[];
  /**
   * Whether the activity is private.
   */
  isPrivate: boolean;
}

export interface GetActivitiesForWidget {
  /**
   * A list of Nutshell Activities
   */
  activities: GetActivitiesForWidget_activities[];
}

export interface GetActivitiesForWidgetVariables {
  entityId: string;
  status?: number | null;
  activityTypes?: string[] | null;
  sortOrder?: SortOrder | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWidgetCustomFields
// ====================================================

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates | null;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all = GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueset | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueString | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueText | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueEnum | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueDate | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueEmail | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValuePhone | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueLocation | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueFile | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueCurrency | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueImage | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueUrl | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all_EntityAttributeValueNumber;

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset_all[];
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueLocation_coordinates | null;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueCurrency_currencyValue;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type GetWidgetCustomFields_widgetCustomFields_edges_value = GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueString | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueText | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueEnum | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueDate | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueset | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueEmail | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValuePhone | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueLocation | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueFile | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueCurrency | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueImage | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueUrl | GetWidgetCustomFields_widgetCustomFields_edges_value_EntityAttributeValueNumber;

export interface GetWidgetCustomFields_widgetCustomFields_edges_node_EntityAttributeBase_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_node_EntityAttributeBase {
  __typename: "EntityAttributeBase";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: GetWidgetCustomFields_widgetCustomFields_edges_node_EntityAttributeBase_attribute;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_node_EntityAttributeEnum_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_node_EntityAttributeEnum_options {
  __typename: "EnumOption";
  /**
   * The name (and primary identifier) of the enum option.
   */
  id: string;
  /**
   * The name (and display) of the enum option.
   */
  name: string;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_node_EntityAttributeEnum {
  __typename: "EntityAttributeEnum";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: GetWidgetCustomFields_widgetCustomFields_edges_node_EntityAttributeEnum_attribute;
  /**
   * Enum options for this field
   */
  options: GetWidgetCustomFields_widgetCustomFields_edges_node_EntityAttributeEnum_options[];
  /**
   * Does this enum field allow multiple selections. I.e. can the value of "Favorite Color" be "Red" AND "Blue"?
   */
  allowMultiple: boolean;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_node_EntityAttributeCurrency_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface GetWidgetCustomFields_widgetCustomFields_edges_node_EntityAttributeCurrency {
  __typename: "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: GetWidgetCustomFields_widgetCustomFields_edges_node_EntityAttributeCurrency_attribute;
  /**
   * Available currency options for this field
   */
  currencyOptions: string[];
  /**
   * Default currency for this field
   */
  defaultCurrency: string;
}

export type GetWidgetCustomFields_widgetCustomFields_edges_node = GetWidgetCustomFields_widgetCustomFields_edges_node_EntityAttributeBase | GetWidgetCustomFields_widgetCustomFields_edges_node_EntityAttributeEnum | GetWidgetCustomFields_widgetCustomFields_edges_node_EntityAttributeCurrency;

export interface GetWidgetCustomFields_widgetCustomFields_edges {
  __typename: "CustomFieldsEdge";
  /**
   * Value of this custom field for this entity.
   */
  value: GetWidgetCustomFields_widgetCustomFields_edges_value | null;
  node: GetWidgetCustomFields_widgetCustomFields_edges_node;
}

export interface GetWidgetCustomFields_widgetCustomFields {
  __typename: "CustomFieldsConnection";
  /**
   * A list of edges.
   */
  edges: GetWidgetCustomFields_widgetCustomFields_edges[];
}

export interface GetWidgetCustomFields {
  /**
   * Returns the custom fields for a widget on an entity.
   */
  widgetCustomFields: GetWidgetCustomFields_widgetCustomFields;
}

export interface GetWidgetCustomFieldsVariables {
  entityId: string;
  widgetId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CancelDripProgression
// ====================================================

export interface CancelDripProgression_dripProgressionDelete_dripProgression_currentNode {
  __typename: "SmartSequenceNode";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CancelDripProgression_dripProgressionDelete_dripProgression_campaign_startTrigger {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface CancelDripProgression_dripProgressionDelete_dripProgression_campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this goal. This is essentially just the stringified
   * version of the goal’s conditions, but because a goal can have multiple
   * conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface CancelDripProgression_dripProgressionDelete_dripProgression_campaign_from_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CancelDripProgression_dripProgressionDelete_dripProgression_campaign_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: CancelDripProgression_dripProgressionDelete_dripProgression_campaign_from_creatorUser | null;
}

export interface CancelDripProgression_dripProgressionDelete_dripProgression_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * When a lead is closed, should drip sequences stop?
   */
  isStopOnLeadClose: boolean;
  /**
   * The start trigger for the drip sequence
   */
  startTrigger: CancelDripProgression_dripProgressionDelete_dripProgression_campaign_startTrigger | null;
  /**
   * The newly created Nutshell goal
   */
  goal: CancelDripProgression_dripProgressionDelete_dripProgression_campaign_goal | null;
  /**
   * The address to send this edition from
   */
  from: CancelDripProgression_dripProgressionDelete_dripProgression_campaign_from | null;
}

export interface CancelDripProgression_dripProgressionDelete_dripProgression_editions_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CancelDripProgression_dripProgressionDelete_dripProgression_editions_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface CancelDripProgression_dripProgressionDelete_dripProgression_editions_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The URL that this edition links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  scheduledTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: CancelDripProgression_dripProgressionDelete_dripProgression_editions_edition_emailTemplate | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: CancelDripProgression_dripProgressionDelete_dripProgression_editions_edition_delay | null;
}

export interface CancelDripProgression_dripProgressionDelete_dripProgression_editions {
  __typename: "DripProgressionEdition";
  /**
   * Whether this edition has been sent
   */
  sent: boolean;
  /**
   * The edition
   */
  edition: CancelDripProgression_dripProgressionDelete_dripProgression_editions_edition;
}

export interface CancelDripProgression_dripProgressionDelete_dripProgression {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * When this drip progression was created (when the contact entered the sequence)
   */
  createdTime: any;
  /**
   * When this progression stopped, or null if it is still active
   */
  stoppedTime: any | null;
  /**
   * Why this progression stopped, or null if it is still active
   */
  stoppedReason: DripProgressionStoppedReason | null;
  /**
   * The graph node this progression is currently on, if any. Null for legacy drip
   * progressions and for smart progressions without a current node.
   */
  currentNode: CancelDripProgression_dripProgressionDelete_dripProgression_currentNode | null;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
  /**
   * Number of editions that have been sent so far for this progression. NOTE: This
   * can be inaccurate if editions are reordered or an edition is added to the
   * start of the drip after a progression has started. This is ok! We want this
   * number to represent the number of prior active editions, even if they aren’t always sent.
   */
  numEditionsSent: number;
  /**
   * The drip sequence for this drip progressions
   */
  campaign: CancelDripProgression_dripProgressionDelete_dripProgression_campaign;
  /**
   * All editions in the drip sequence for this drip progression, in send order
   */
  editions: CancelDripProgression_dripProgressionDelete_dripProgression_editions[];
}

export interface CancelDripProgression_dripProgressionDelete {
  __typename: "DripProgressionDeletePayload";
  /**
   * The stopped drip progression model
   */
  dripProgression: CancelDripProgression_dripProgressionDelete_dripProgression;
}

export interface CancelDripProgression {
  /**
   * Stops a drip sequence for a contact.
   */
  dripProgressionDelete: CancelDripProgression_dripProgressionDelete;
}

export interface CancelDripProgressionVariables {
  input: DripProgressionDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CancelPersonalEmailSequence
// ====================================================

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_sender_sendableEmailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_sender {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * List of successfully enabled user email addresses that a user is able to send emails from Nutshell with.
   */
  sendableEmailAddresses: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_sender_sendableEmailAddresses[];
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_companyName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_firstName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_lastName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_lead_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  name: string;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_lead_contacts_primaryEdge_node;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_lead_contacts_primaryEdge | null;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_lead_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_lead_contacts;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailAutomation_exitsStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailAutomation_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailAutomation_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailAutomation_entersStage;
  /**
   * The stage in which this stage subscription ends.
   */
  exitsStage: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailAutomation_exitsStage | null;
  /**
   * Indicates if a lead should receive emails from this subscription until it closes.
   */
  sendUntilClose: boolean;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailAutomation_delay | null;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailAutomation_emailList | null;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailSequence_emailsQueued_fromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailSequence_emailsQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailSequence_emailsQueued_to {
  __typename: "NutEmailAddress";
  avatarEntity: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailSequence_emailsQueued_to_avatarEntity | null;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The current status of this queued email.
   */
  status: EmailQueuedStatus;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  fromUser: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailSequence_emailsQueued_fromUser | null;
  to: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailSequence_emailsQueued_to[];
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The next message to be sent
   */
  nextUnsentEmail: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailSequence_nextUnsentEmail | null;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  /**
   * The number of emails that have been sent
   */
  sentEmailsCount: number;
  emailsQueued: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailSequence_emailsQueued[];
  emailSequenceTemplate: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailSequence_emailSequenceTemplate | null;
  /**
   * True if this sequence has only one email
   */
  isSingleEmailSequence: boolean;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus {
  __typename: "EmailAutomationStatus";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that either did send this automation, or current _would_ send this
   * automation given the current context. For example, if the user is assigned to
   * a team, the logged in user is considered a potential sender if they’re on that team
   */
  sender: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_sender | null;
  /**
   * The total number of messages in the sequence for this status
   */
  unsentMessageCount: number | null;
  /**
   * Is this automation status paused?
   */
  isPaused: boolean;
  /**
   * Can this status be started
   */
  canStart: boolean;
  /**
   * Can this status be cancelled
   */
  canCancel: boolean;
  /**
   * The message to show to the user
   */
  status: EmailAutomationStatusStatus;
  /**
   * Status of the company name field
   */
  companyName: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_companyName;
  /**
   * Status of the first name field
   */
  firstName: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_firstName;
  /**
   * Status of the last name field
   */
  lastName: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_lastName;
  /**
   * Lead associated with this status row
   */
  lead: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_lead;
  /**
   * Email list stage subscription associated with this status row
   */
  emailAutomation: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailAutomation;
  /**
   * The actual email sequence going out for this lead in this stage
   */
  emailSequence: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus_emailSequence | null;
}

export interface CancelPersonalEmailSequence_emailAutomationStatusCancel {
  __typename: "EmailAutomationStatusCancelPayload";
  /**
   * The deleted email automation status.
   */
  emailAutomationStatus: CancelPersonalEmailSequence_emailAutomationStatusCancel_emailAutomationStatus;
}

export interface CancelPersonalEmailSequence {
  /**
   * Cancel an email automation status
   */
  emailAutomationStatusCancel: CancelPersonalEmailSequence_emailAutomationStatusCancel;
}

export interface CancelPersonalEmailSequenceVariables {
  input: EmailAutomationStatusCancelInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendQueuedEmailNow
// ====================================================

export interface SendQueuedEmailNow_emailQueuedSendNow_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
}

export interface SendQueuedEmailNow_emailQueuedSendNow_emailSequence_emailsQueued_fromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SendQueuedEmailNow_emailQueuedSendNow_emailSequence_emailsQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SendQueuedEmailNow_emailQueuedSendNow_emailSequence_emailsQueued_to {
  __typename: "NutEmailAddress";
  avatarEntity: SendQueuedEmailNow_emailQueuedSendNow_emailSequence_emailsQueued_to_avatarEntity | null;
}

export interface SendQueuedEmailNow_emailQueuedSendNow_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The current status of this queued email.
   */
  status: EmailQueuedStatus;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  fromUser: SendQueuedEmailNow_emailQueuedSendNow_emailSequence_emailsQueued_fromUser | null;
  to: SendQueuedEmailNow_emailQueuedSendNow_emailSequence_emailsQueued_to[];
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
}

export interface SendQueuedEmailNow_emailQueuedSendNow_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SendQueuedEmailNow_emailQueuedSendNow_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The next message to be sent
   */
  nextUnsentEmail: SendQueuedEmailNow_emailQueuedSendNow_emailSequence_nextUnsentEmail | null;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  /**
   * The number of emails that have been sent
   */
  sentEmailsCount: number;
  emailsQueued: SendQueuedEmailNow_emailQueuedSendNow_emailSequence_emailsQueued[];
  emailSequenceTemplate: SendQueuedEmailNow_emailQueuedSendNow_emailSequence_emailSequenceTemplate | null;
  /**
   * True if this sequence has only one email
   */
  isSingleEmailSequence: boolean;
}

export interface SendQueuedEmailNow_emailQueuedSendNow {
  __typename: "EmailQueuedSendNowPayload";
  /**
   * The freshly updated email sequence.
   */
  emailSequence: SendQueuedEmailNow_emailQueuedSendNow_emailSequence;
}

export interface SendQueuedEmailNow {
  /**
   * This mutation will send a queued email immediately if the only thing holding it back is the delivery time.
   */
  emailQueuedSendNow: SendQueuedEmailNow_emailQueuedSendNow;
}

export interface SendQueuedEmailNowVariables {
  payload: EmailQueuedSendNowInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: StartPersonalEmailSequence
// ====================================================

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_sender_sendableEmailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_sender {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * List of successfully enabled user email addresses that a user is able to send emails from Nutshell with.
   */
  sendableEmailAddresses: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_sender_sendableEmailAddresses[];
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_companyName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_firstName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_lastName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_lead_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  name: string;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_lead_contacts_primaryEdge_node;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_lead_contacts_primaryEdge | null;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_lead_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_lead_contacts;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailAutomation_exitsStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailAutomation_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailAutomation_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailAutomation_entersStage;
  /**
   * The stage in which this stage subscription ends.
   */
  exitsStage: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailAutomation_exitsStage | null;
  /**
   * Indicates if a lead should receive emails from this subscription until it closes.
   */
  sendUntilClose: boolean;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailAutomation_delay | null;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailAutomation_emailList | null;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence_emailsQueued_fromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence_emailsQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence_emailsQueued_to {
  __typename: "NutEmailAddress";
  avatarEntity: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence_emailsQueued_to_avatarEntity | null;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The current status of this queued email.
   */
  status: EmailQueuedStatus;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  fromUser: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence_emailsQueued_fromUser | null;
  to: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence_emailsQueued_to[];
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The next message to be sent
   */
  nextUnsentEmail: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence_nextUnsentEmail | null;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  /**
   * The number of emails that have been sent
   */
  sentEmailsCount: number;
  emailsQueued: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence_emailsQueued[];
  emailSequenceTemplate: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence_emailSequenceTemplate | null;
  /**
   * True if this sequence has only one email
   */
  isSingleEmailSequence: boolean;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus {
  __typename: "EmailAutomationStatus";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that either did send this automation, or current _would_ send this
   * automation given the current context. For example, if the user is assigned to
   * a team, the logged in user is considered a potential sender if they’re on that team
   */
  sender: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_sender | null;
  /**
   * The total number of messages in the sequence for this status
   */
  unsentMessageCount: number | null;
  /**
   * Is this automation status paused?
   */
  isPaused: boolean;
  /**
   * Can this status be started
   */
  canStart: boolean;
  /**
   * Can this status be cancelled
   */
  canCancel: boolean;
  /**
   * The message to show to the user
   */
  status: EmailAutomationStatusStatus;
  /**
   * Status of the company name field
   */
  companyName: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_companyName;
  /**
   * Status of the first name field
   */
  firstName: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_firstName;
  /**
   * Status of the last name field
   */
  lastName: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_lastName;
  /**
   * Lead associated with this status row
   */
  lead: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_lead;
  /**
   * Email list stage subscription associated with this status row
   */
  emailAutomation: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailAutomation;
  /**
   * The actual email sequence going out for this lead in this stage
   */
  emailSequence: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence | null;
}

export interface StartPersonalEmailSequence_emailAutomationStatusManualStart {
  __typename: "EmailAutomationStatusManualStartPayload";
  /**
   * The started email automation status.
   */
  emailAutomationStatus: StartPersonalEmailSequence_emailAutomationStatusManualStart_emailAutomationStatus;
}

export interface StartPersonalEmailSequence {
  /**
   * Manually start an email sequence that is `ready to send` from an automation (EmailAutomationStatus).
   */
  emailAutomationStatusManualStart: StartPersonalEmailSequence_emailAutomationStatusManualStart;
}

export interface StartPersonalEmailSequenceVariables {
  input: EmailAutomationStatusManualStartInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDripProgressionSentEmails
// ====================================================

export interface GetDripProgressionSentEmails_dripProgression_sentEmails_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetDripProgressionSentEmails_dripProgression_sentEmails {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  sentTime: any | null;
  /**
   * If this a Nutshell Marketing email, this is the edition
   */
  edition: GetDripProgressionSentEmails_dripProgression_sentEmails_edition | null;
}

export interface GetDripProgressionSentEmails_dripProgression {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Emails from this sequence that have actually been sent to this recipient,
   * oldest first. Unlike `editions`, this follows the path a smart sequence
   * recipient took rather than assuming a linear drip.
   */
  sentEmails: GetDripProgressionSentEmails_dripProgression_sentEmails[];
}

export interface GetDripProgressionSentEmails {
  /**
   * Returns an email marketing drip sequence for a contact.
   */
  dripProgression: GetDripProgressionSentEmails_dripProgression | null;
}

export interface GetDripProgressionSentEmailsVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateTask
// ====================================================

export interface CreateTask_taskCreate_task_delayApplications_delay {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the delay
   */
  name: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface CreateTask_taskCreate_task_delayApplications_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateTask_taskCreate_task_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * An optional note about the delay application
   */
  note: string | null;
  /**
   * The time when the delay was applied
   */
  appliedTime: any;
  /**
   * The delay that was applied
   */
  delay: CreateTask_taskCreate_task_delayApplications_delay;
  /**
   * The user who applied the delay
   */
  user: CreateTask_taskCreate_task_delayApplications_user | null;
}

export interface CreateTask_taskCreate_task_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateTask_taskCreate_task_completedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateTask_taskCreate_task_relatedEntity {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateTask_taskCreate_task_creatorEntity_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface CreateTask_taskCreate_task_creatorEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export type CreateTask_taskCreate_task_creatorEntity = CreateTask_taskCreate_task_creatorEntity_Chat | CreateTask_taskCreate_task_creatorEntity_Activity;

export interface CreateTask_taskCreate_task_assigner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateTask_taskCreate_task_recurrenceRule {
  __typename: "RecurrenceRule";
  mode: RecurrenceMode;
  /**
   * An RRULE-compatible string defining the recurrence pattern (e.g. "FREQ=WEEKLY;BYDAY=MO").
   */
  rule: string;
}

export interface CreateTask_taskCreate_task {
  __typename: "Task";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the task
   */
  title: string;
  /**
   * The canonical API href for the task
   */
  href: string;
  /**
   * The task’s user-defined description
   */
  description: string | null;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: CreateTask_taskCreate_task_delayApplications[];
  /**
   * The due timestamp of the task
   */
  dueTime: any | null;
  /**
   * The person or team assigned to this task
   */
  assignee: CreateTask_taskCreate_task_assignee | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  completedTime: any | null;
  /**
   * Can the task be completed?
   */
  canBeCompleted: boolean;
  /**
   * Is this task completed?
   */
  isCompleted: boolean;
  /**
   * The user who completed the task
   */
  completedByUser: CreateTask_taskCreate_task_completedByUser | null;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Whether the tasks due date is later than the current date
   */
  isOverdue: boolean;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  relatedEntity: CreateTask_taskCreate_task_relatedEntity | null;
  /**
   * The DateTime that represents when the Activity record was created
   */
  createdTime: any;
  /**
   * The task's linkified description with URLs converted to clickable links
   */
  linkifiedDescription: string | null;
  isAiGenerated: boolean;
  creatorEntity: CreateTask_taskCreate_task_creatorEntity | null;
  /**
   * The user who assigned the task
   */
  assigner: CreateTask_taskCreate_task_assigner | null;
  /**
   * The time the task was assigned
   */
  assignedTime: any | null;
  /**
   * Number of days between follow-up reminders. Null if the task is not recurring.
   */
  recurringPeriod: number | null;
  /**
   * Whether this task is the current user recurring follow-up reminder.
   */
  isRecurringForUser: boolean;
  /**
   * Null if the task does not recur under the new recurrence system.
   */
  recurrenceRule: CreateTask_taskCreate_task_recurrenceRule | null;
}

export interface CreateTask_taskCreate {
  __typename: "TaskCreatePayload";
  /**
   * The newly created task
   */
  task: CreateTask_taskCreate_task | null;
}

export interface CreateTask {
  /**
   * Creates a new task for an entity
   */
  taskCreate: CreateTask_taskCreate;
}

export interface CreateTaskVariables {
  input: TaskCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteTask
// ====================================================

export interface DeleteTask_taskDelete_task_delayApplications_delay {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the delay
   */
  name: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface DeleteTask_taskDelete_task_delayApplications_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DeleteTask_taskDelete_task_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * An optional note about the delay application
   */
  note: string | null;
  /**
   * The time when the delay was applied
   */
  appliedTime: any;
  /**
   * The delay that was applied
   */
  delay: DeleteTask_taskDelete_task_delayApplications_delay;
  /**
   * The user who applied the delay
   */
  user: DeleteTask_taskDelete_task_delayApplications_user | null;
}

export interface DeleteTask_taskDelete_task_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DeleteTask_taskDelete_task_completedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DeleteTask_taskDelete_task_relatedEntity {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DeleteTask_taskDelete_task_creatorEntity_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface DeleteTask_taskDelete_task_creatorEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export type DeleteTask_taskDelete_task_creatorEntity = DeleteTask_taskDelete_task_creatorEntity_Chat | DeleteTask_taskDelete_task_creatorEntity_Activity;

export interface DeleteTask_taskDelete_task_assigner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DeleteTask_taskDelete_task_recurrenceRule {
  __typename: "RecurrenceRule";
  mode: RecurrenceMode;
  /**
   * An RRULE-compatible string defining the recurrence pattern (e.g. "FREQ=WEEKLY;BYDAY=MO").
   */
  rule: string;
}

export interface DeleteTask_taskDelete_task {
  __typename: "Task";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the task
   */
  title: string;
  /**
   * The canonical API href for the task
   */
  href: string;
  /**
   * The task’s user-defined description
   */
  description: string | null;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: DeleteTask_taskDelete_task_delayApplications[];
  /**
   * The due timestamp of the task
   */
  dueTime: any | null;
  /**
   * The person or team assigned to this task
   */
  assignee: DeleteTask_taskDelete_task_assignee | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  completedTime: any | null;
  /**
   * Can the task be completed?
   */
  canBeCompleted: boolean;
  /**
   * Is this task completed?
   */
  isCompleted: boolean;
  /**
   * The user who completed the task
   */
  completedByUser: DeleteTask_taskDelete_task_completedByUser | null;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Whether the tasks due date is later than the current date
   */
  isOverdue: boolean;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  relatedEntity: DeleteTask_taskDelete_task_relatedEntity | null;
  /**
   * The DateTime that represents when the Activity record was created
   */
  createdTime: any;
  /**
   * The task's linkified description with URLs converted to clickable links
   */
  linkifiedDescription: string | null;
  isAiGenerated: boolean;
  creatorEntity: DeleteTask_taskDelete_task_creatorEntity | null;
  /**
   * The user who assigned the task
   */
  assigner: DeleteTask_taskDelete_task_assigner | null;
  /**
   * The time the task was assigned
   */
  assignedTime: any | null;
  /**
   * Number of days between follow-up reminders. Null if the task is not recurring.
   */
  recurringPeriod: number | null;
  /**
   * Whether this task is the current user recurring follow-up reminder.
   */
  isRecurringForUser: boolean;
  /**
   * Null if the task does not recur under the new recurrence system.
   */
  recurrenceRule: DeleteTask_taskDelete_task_recurrenceRule | null;
}

export interface DeleteTask_taskDelete {
  __typename: "TaskDeletePayload";
  /**
   * The deleted task
   */
  task: DeleteTask_taskDelete_task | null;
}

export interface DeleteTask {
  /**
   * Deletes an existing task
   */
  taskDelete: DeleteTask_taskDelete;
}

export interface DeleteTaskVariables {
  input: TaskDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MarkUnhelpfulAndDeleteTask
// ====================================================

export interface MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task_delayApplications_delay {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the delay
   */
  name: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task_delayApplications_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * An optional note about the delay application
   */
  note: string | null;
  /**
   * The time when the delay was applied
   */
  appliedTime: any;
  /**
   * The delay that was applied
   */
  delay: MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task_delayApplications_delay;
  /**
   * The user who applied the delay
   */
  user: MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task_delayApplications_user | null;
}

export interface MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task_completedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task_relatedEntity {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task_creatorEntity_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task_creatorEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export type MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task_creatorEntity = MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task_creatorEntity_Chat | MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task_creatorEntity_Activity;

export interface MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task_assigner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task_recurrenceRule {
  __typename: "RecurrenceRule";
  mode: RecurrenceMode;
  /**
   * An RRULE-compatible string defining the recurrence pattern (e.g. "FREQ=WEEKLY;BYDAY=MO").
   */
  rule: string;
}

export interface MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task {
  __typename: "Task";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the task
   */
  title: string;
  /**
   * The canonical API href for the task
   */
  href: string;
  /**
   * The task’s user-defined description
   */
  description: string | null;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task_delayApplications[];
  /**
   * The due timestamp of the task
   */
  dueTime: any | null;
  /**
   * The person or team assigned to this task
   */
  assignee: MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task_assignee | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  completedTime: any | null;
  /**
   * Can the task be completed?
   */
  canBeCompleted: boolean;
  /**
   * Is this task completed?
   */
  isCompleted: boolean;
  /**
   * The user who completed the task
   */
  completedByUser: MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task_completedByUser | null;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Whether the tasks due date is later than the current date
   */
  isOverdue: boolean;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  relatedEntity: MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task_relatedEntity | null;
  /**
   * The DateTime that represents when the Activity record was created
   */
  createdTime: any;
  /**
   * The task's linkified description with URLs converted to clickable links
   */
  linkifiedDescription: string | null;
  isAiGenerated: boolean;
  creatorEntity: MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task_creatorEntity | null;
  /**
   * The user who assigned the task
   */
  assigner: MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task_assigner | null;
  /**
   * The time the task was assigned
   */
  assignedTime: any | null;
  /**
   * Number of days between follow-up reminders. Null if the task is not recurring.
   */
  recurringPeriod: number | null;
  /**
   * Whether this task is the current user recurring follow-up reminder.
   */
  isRecurringForUser: boolean;
  /**
   * Null if the task does not recur under the new recurrence system.
   */
  recurrenceRule: MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task_recurrenceRule | null;
}

export interface MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete {
  __typename: "TaskMarkUnhelpfulAndDeletePayload";
  /**
   * The deleted task
   */
  task: MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete_task;
}

export interface MarkUnhelpfulAndDeleteTask {
  /**
   * Record analytics to mark an AI generated task as unhelpful and delete it
   */
  taskMarkUnhelpfulAndDelete: MarkUnhelpfulAndDeleteTask_taskMarkUnhelpfulAndDelete;
}

export interface MarkUnhelpfulAndDeleteTaskVariables {
  input: TaskMarkUnhelpfulAndDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateTask
// ====================================================

export interface UpdateTask_taskUpdate_task_delayApplications_delay {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the delay
   */
  name: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface UpdateTask_taskUpdate_task_delayApplications_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateTask_taskUpdate_task_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * An optional note about the delay application
   */
  note: string | null;
  /**
   * The time when the delay was applied
   */
  appliedTime: any;
  /**
   * The delay that was applied
   */
  delay: UpdateTask_taskUpdate_task_delayApplications_delay;
  /**
   * The user who applied the delay
   */
  user: UpdateTask_taskUpdate_task_delayApplications_user | null;
}

export interface UpdateTask_taskUpdate_task_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateTask_taskUpdate_task_completedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateTask_taskUpdate_task_relatedEntity {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateTask_taskUpdate_task_creatorEntity_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface UpdateTask_taskUpdate_task_creatorEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export type UpdateTask_taskUpdate_task_creatorEntity = UpdateTask_taskUpdate_task_creatorEntity_Chat | UpdateTask_taskUpdate_task_creatorEntity_Activity;

export interface UpdateTask_taskUpdate_task_assigner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateTask_taskUpdate_task_recurrenceRule {
  __typename: "RecurrenceRule";
  mode: RecurrenceMode;
  /**
   * An RRULE-compatible string defining the recurrence pattern (e.g. "FREQ=WEEKLY;BYDAY=MO").
   */
  rule: string;
}

export interface UpdateTask_taskUpdate_task {
  __typename: "Task";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the task
   */
  title: string;
  /**
   * The canonical API href for the task
   */
  href: string;
  /**
   * The task’s user-defined description
   */
  description: string | null;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: UpdateTask_taskUpdate_task_delayApplications[];
  /**
   * The due timestamp of the task
   */
  dueTime: any | null;
  /**
   * The person or team assigned to this task
   */
  assignee: UpdateTask_taskUpdate_task_assignee | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  completedTime: any | null;
  /**
   * Can the task be completed?
   */
  canBeCompleted: boolean;
  /**
   * Is this task completed?
   */
  isCompleted: boolean;
  /**
   * The user who completed the task
   */
  completedByUser: UpdateTask_taskUpdate_task_completedByUser | null;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Whether the tasks due date is later than the current date
   */
  isOverdue: boolean;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  relatedEntity: UpdateTask_taskUpdate_task_relatedEntity | null;
  /**
   * The DateTime that represents when the Activity record was created
   */
  createdTime: any;
  /**
   * The task's linkified description with URLs converted to clickable links
   */
  linkifiedDescription: string | null;
  isAiGenerated: boolean;
  creatorEntity: UpdateTask_taskUpdate_task_creatorEntity | null;
  /**
   * The user who assigned the task
   */
  assigner: UpdateTask_taskUpdate_task_assigner | null;
  /**
   * The time the task was assigned
   */
  assignedTime: any | null;
  /**
   * Number of days between follow-up reminders. Null if the task is not recurring.
   */
  recurringPeriod: number | null;
  /**
   * Whether this task is the current user recurring follow-up reminder.
   */
  isRecurringForUser: boolean;
  /**
   * Null if the task does not recur under the new recurrence system.
   */
  recurrenceRule: UpdateTask_taskUpdate_task_recurrenceRule | null;
}

export interface UpdateTask_taskUpdate {
  __typename: "TaskUpdatePayload";
  /**
   * The updated task
   */
  task: UpdateTask_taskUpdate_task | null;
}

export interface UpdateTask {
  /**
   * Updates an existing task
   */
  taskUpdate: UpdateTask_taskUpdate;
}

export interface UpdateTaskVariables {
  input: TaskUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDefaultTask
// ====================================================

export interface GetDefaultTask_taskDefaults_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetDefaultTask_taskDefaults_completedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetDefaultTask_taskDefaults_recurrenceRule {
  __typename: "RecurrenceRule";
  mode: RecurrenceMode;
  /**
   * An RRULE-compatible string defining the recurrence pattern (e.g. "FREQ=WEEKLY;BYDAY=MO").
   */
  rule: string;
}

export interface GetDefaultTask_taskDefaults {
  __typename: "Task";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the task
   */
  title: string;
  /**
   * The task’s user-defined description
   */
  description: string | null;
  /**
   * The due timestamp of the task
   */
  dueTime: any | null;
  /**
   * The person or team assigned to this task
   */
  assignee: GetDefaultTask_taskDefaults_assignee | null;
  /**
   * Whether the tasks due date is later than the current date
   */
  isOverdue: boolean;
  /**
   * The DateTime that represents when the Task record was created
   */
  completedTime: any | null;
  /**
   * The user who completed the task
   */
  completedByUser: GetDefaultTask_taskDefaults_completedByUser | null;
  /**
   * Null if the task does not recur under the new recurrence system.
   */
  recurrenceRule: GetDefaultTask_taskDefaults_recurrenceRule | null;
}

export interface GetDefaultTask {
  /**
   * Returns a default task for creation
   */
  taskDefaults: GetDefaultTask_taskDefaults;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateWidgetCollapseState
// ====================================================

export interface UpdateWidgetCollapseState_widgetUpdateCollapseState_widget {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
}

export interface UpdateWidgetCollapseState_widgetUpdateCollapseState {
  __typename: "WidgetUpdateCollapseStatePayload";
  /**
   * The updated Nutshell widget
   */
  widget: UpdateWidgetCollapseState_widgetUpdateCollapseState_widget;
}

export interface UpdateWidgetCollapseState {
  /**
   * Collapses or expands a widget
   */
  widgetUpdateCollapseState: UpdateWidgetCollapseState_widgetUpdateCollapseState | null;
}

export interface UpdateWidgetCollapseStateVariables {
  input: WidgetUpdateCollapseStateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetConstantContactEmailCampaignActivityPreview
// ====================================================

export interface GetConstantContactEmailCampaignActivityPreview_constantContactEmailCampaignActivityPreview {
  __typename: "ConstantContactEmailCampaignActivityPreview";
  campaignActivityId: string;
  fromEmail: string;
  fromName: string;
  preheader: string;
  previewHtmlContent: string;
  previewTextContent: string;
  replyToEmail: string;
  subject: string;
}

export interface GetConstantContactEmailCampaignActivityPreview {
  /**
   * Wrapper for getting the preview content of a constant contact activity preview
   */
  constantContactEmailCampaignActivityPreview: GetConstantContactEmailCampaignActivityPreview_constantContactEmailCampaignActivityPreview | null;
}

export interface GetConstantContactEmailCampaignActivityPreviewVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateCustomField
// ====================================================

export interface CreateCustomField_createCustomField_customField_field_FieldPhone {
  __typename: "FieldPhone" | "FieldString" | "FieldLocation" | "FieldBoolean" | "FieldCurrency" | "FieldDateTime" | "FieldInteger" | "FieldRelationship" | "FieldStrings" | "FieldText";
  /**
   * The internal name of the field
   */
  name: string;
  /**
   * The type of the field (string, date-time, etc)
   */
  type: EntityFieldType;
  /**
   * The filter title of the field
   */
  filterTitle: string;
}

export interface CreateCustomField_createCustomField_customField_field_FieldEnum {
  __typename: "FieldEnum";
  /**
   * The internal name of the field
   */
  name: string;
  /**
   * The type of the field (string, date-time, etc)
   */
  type: EntityFieldType;
  /**
   * The filter title of the field
   */
  filterTitle: string;
  /**
   * The possible options allowed for this enum type
   */
  options: string[];
}

export type CreateCustomField_createCustomField_customField_field = CreateCustomField_createCustomField_customField_field_FieldPhone | CreateCustomField_createCustomField_customField_field_FieldEnum;

export interface CreateCustomField_createCustomField_customField {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  field: CreateCustomField_createCustomField_customField_field;
}

export interface CreateCustomField_createCustomField {
  __typename: "CreateCustomFieldPayload";
  /**
   * The newly created Nutshell custom field
   */
  customField: CreateCustomField_createCustomField_customField;
}

export interface CreateCustomField {
  /**
   * Creates a custom field.
   */
  createCustomField: CreateCustomField_createCustomField | null;
}

export interface CreateCustomFieldVariables {
  customField: CreateCustomFieldInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: FromAddressCreate
// ====================================================

export interface FromAddressCreate_fromAddressCreate_fromAddress_emailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface FromAddressCreate_fromAddressCreate_fromAddress_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface FromAddressCreate_fromAddressCreate_fromAddress {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: FromAddressCreate_fromAddressCreate_fromAddress_emailAddress;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: FromAddressCreate_fromAddressCreate_fromAddress_fromDomain | null;
}

export interface FromAddressCreate_fromAddressCreate {
  __typename: "FromAddressPayload";
  /**
   * The new from address
   */
  fromAddress: FromAddressCreate_fromAddressCreate_fromAddress;
}

export interface FromAddressCreate {
  /**
   * Create a new email marketing from address
   */
  fromAddressCreate: FromAddressCreate_fromAddressCreate | null;
}

export interface FromAddressCreateVariables {
  input: FromAddressInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EmailGlobalBlocklistAdd
// ====================================================

export interface EmailGlobalBlocklistAdd_emailGlobalBlocklistAdd_blocklistedEmail {
  __typename: "GloballyBlocklistedEmail";
  /**
   * The Globally blocklisted email address
   */
  emailAddress: string;
}

export interface EmailGlobalBlocklistAdd_emailGlobalBlocklistAdd {
  __typename: "EmailGlobalBlocklistAddPayload";
  /**
   * Resulting globally blocklisted email after being added
   */
  blocklistedEmail: EmailGlobalBlocklistAdd_emailGlobalBlocklistAdd_blocklistedEmail;
}

export interface EmailGlobalBlocklistAdd {
  /**
   * Adds a given email address to the instances global blocklist
   */
  emailGlobalBlocklistAdd: EmailGlobalBlocklistAdd_emailGlobalBlocklistAdd;
}

export interface EmailGlobalBlocklistAddVariables {
  input: EmailGlobalBlocklistAddInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateSetting
// ====================================================

export interface UpdateSetting_updateSetting_setting {
  __typename: "Setting";
  /**
   * The name of this Setting
   */
  id: string;
  /**
   * The value of this Setting
   */
  value: string | null;
}

export interface UpdateSetting_updateSetting {
  __typename: "UpdateSettingPayload";
  /**
   * The updated user setting
   */
  setting: UpdateSetting_updateSetting_setting;
}

export interface UpdateSetting {
  /**
   * Update a setting.
   */
  updateSetting: UpdateSetting_updateSetting | null;
}

export interface UpdateSettingVariables {
  setting: UpdateSettingFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAssignable
// ====================================================

export interface GetAssignable_assignable_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface GetAssignable_assignable_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  initials: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export type GetAssignable_assignable = GetAssignable_assignable_Team | GetAssignable_assignable_User;

export interface GetAssignable {
  /**
   * Returns a single Nutshell user or team
   */
  assignable: GetAssignable_assignable;
}

export interface GetAssignableVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactFormValidation
// ====================================================

export interface GetContactFormValidation_contactCreateValidation_errors {
  __typename: "ContactCreateError";
  /**
   * The name of the field
   */
  field: string;
  /**
   * The error message
   */
  error: string;
}

export interface GetContactFormValidation_contactCreateValidation {
  __typename: "ContactCreateValidation";
  /**
   * The array of errors that occured during validation
   */
  errors: GetContactFormValidation_contactCreateValidation_errors[];
}

export interface GetContactFormValidation {
  /**
   * The validation result of contact creation. Input only includes fields that need validation
   */
  contactCreateValidation: GetContactFormValidation_contactCreateValidation;
}

export interface GetContactFormValidationVariables {
  input: ContactCreateValidationInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCoreEntity
// ====================================================

export interface GetCoreEntity_coreEntity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string;
  createdTime: any;
}

export interface GetCoreEntity {
  /**
   * Returns a Nutshell Core entity by id
   */
  coreEntity: GetCoreEntity_coreEntity;
}

export interface GetCoreEntityVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetInstanceInfo
// ====================================================

export interface GetInstanceInfo_sessionInstance {
  __typename: "Instance";
  /**
   * The id for the specific Nutshell instance.
   */
  instanceId: string | null;
  /**
   * Is this a pro instance?
   */
  isPro: boolean;
  /**
   * Is this a Nutshell trial?
   */
  isTrial: boolean;
  companyName: string;
  /**
   * Has this instance configured any Nutshell email automations?
   */
  hasConfiguredNutshellEmailAutomations: boolean;
  /**
   * Does this instance have an active landing pages plan?
   */
  hasLandingPages: boolean;
  /**
   * The string version of the WebFX site ID.
   */
  webfxSiteId: string | null;
  /**
   * Is the billing cycle deprecated?
   */
  hasDeprecatedBillingCycle: boolean | null;
  /**
   * Days left in trial
   */
  daysLeftInTrial: number | null;
  /**
   * Is billing managed by WebFX?
   */
  isBillingManagedByWebfx: boolean | null;
  /**
   * The type of scheduler access this instance has.
   */
  schedulerAccessType: SchedulerAccessType;
  /**
   * Date the Nutshell instance was created (YYYY-M-D)
   */
  inceptionDate: string | null;
}

export interface GetInstanceInfo {
  /**
   * A hodge-podge of instance-level concerns
   */
  sessionInstance: GetInstanceInfo_sessionInstance | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRelatedEntities
// ====================================================

export interface GetRelatedEntities_potentialRelatedEntities_contacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetRelatedEntities_potentialRelatedEntities_accounts {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetRelatedEntities_potentialRelatedEntities_leads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Leads don’t have initials, but for interface reasons we’ll return an empty
   * string here instead of removing the property entirely.
   */
  initials: string;
}

export interface GetRelatedEntities_potentialRelatedEntities_users {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetRelatedEntities_potentialRelatedEntities {
  __typename: "PotentialRelatedEntities";
  contacts: GetRelatedEntities_potentialRelatedEntities_contacts[];
  accounts: GetRelatedEntities_potentialRelatedEntities_accounts[];
  leads: GetRelatedEntities_potentialRelatedEntities_leads[];
  users: GetRelatedEntities_potentialRelatedEntities_users[];
}

export interface GetRelatedEntities {
  /**
   * The potential related entities for the given entity ids
   */
  potentialRelatedEntities: GetRelatedEntities_potentialRelatedEntities;
}

export interface GetRelatedEntitiesVariables {
  input: PotentialEntitiesInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSessionUser
// ====================================================

export interface GetSessionUser_loggedInUser_sendableEmailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The address string of this email.
   */
  address: string;
  formatted: string;
  /**
   * Is email sync enabled for this address? When the user is sending follow-ups,
   * for example, it’s nice to warn them if sync is not enabled
   */
  isSyncEnabled: boolean;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
}

export interface GetSessionUser_loggedInUser_emailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The address string of this email.
   */
  address: string;
  formatted: string;
  /**
   * Is email sync enabled for this address? When the user is sending follow-ups,
   * for example, it’s nice to warn them if sync is not enabled
   */
  isSyncEnabled: boolean;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
}

export interface GetSessionUser_loggedInUser_permissions {
  __typename: "UserPermissionBooleans";
  canAccessSetup: boolean;
  canAccessMarketing: boolean;
  canBulkEdit: boolean;
  canExport: boolean;
  canViewSharedEmails: boolean;
  canImport: boolean;
  canMergeEntities: boolean;
  canDeleteEntities: boolean;
  canAssignEntities: boolean;
  canAccessBilling: boolean;
  canViewAllMeetings: boolean;
  canManageEmailTemplates: boolean;
  canAccessCrm: boolean;
  canAccessFullCampaigns: boolean;
  canUseInbox: boolean;
  canUseSms: boolean;
  canUseOrTryInbox: boolean;
  canUseSalesDocuments: boolean;
  canDeleteNotesAndActivities: boolean;
}

export interface GetSessionUser_loggedInUser_zoomIntegration {
  __typename: "ZoomIntegration";
  /**
   * Whether or not the zoom integration is enabled
   */
  isEnabled: boolean;
}

export interface GetSessionUser_loggedInUser_googleMeetIntegration {
  __typename: "GoogleMeetIntegration";
  /**
   * Whether or not the  Google Meet integration is enabled with calendar sync
   */
  isEnabledCalendarSync: boolean;
  /**
   * Whether or not the Google Meet integration is enabled with meet sync
   */
  isEnabledMeetSync: boolean;
}

export interface GetSessionUser_loggedInUser_microsoftTeamsIntegration {
  __typename: "MicrosoftTeamsIntegration";
  /**
   * Whether or not the  Microsoft Teams integration is enabled
   */
  isEnabled: boolean;
}

export interface GetSessionUser_loggedInUser_widgetsCollapsedState {
  __typename: "WidgetsCollapsedState";
  /**
   * Lead sales documents section widget state
   */
  leadSalesDocuments: boolean;
  /**
   * Lead companies and people section widget state
   */
  leadCompaniesAndPeople: boolean;
  /**
   * Lead products section widget state
   */
  leadProducts: boolean;
  /**
   * Lead channels and sources section widget state
   */
  leadChannelsAndSources: boolean;
  /**
   * Lead pipeline section widget state
   */
  leadPipeline: boolean;
  /**
   * Top custom fields section widget state
   */
  leadTopCustomFields: boolean;
  /**
   * Custom fields section widget state
   */
  leadCustomFields: boolean;
  /**
   * Competitors section widget state
   */
  leadCompetitors: boolean;
  /**
   * Attachments section widget state
   */
  leadAttachments: boolean;
  /**
   * Scheduled activities section widget state
   */
  leadScheduledActivities: boolean;
  /**
   * Logged activities section widget state
   */
  leadLoggedActivities: boolean;
  /**
   * Upcoming tasks section widget state
   */
  leadUpcomingTasks: boolean;
  /**
   * Future tasks section widget state
   */
  leadFutureTasks: boolean;
  /**
   * Completed tasks section widget state
   */
  leadCompletedTasks: boolean;
  /**
   * Drip sequences section widget state
   */
  leadDripSequences: boolean;
  /**
   * Personal email sequences section widget state
   */
  leadPersonalEmailSequences: boolean;
}

export interface GetSessionUser_loggedInUser_phoneIntegrations_integration {
  __typename: "Integration";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Indicates whether the integration is currently enabled
   */
  isEnabled: boolean;
  /**
   * Indicates whether the integration has been validated
   */
  isValidated: boolean;
}

export interface GetSessionUser_loggedInUser_phoneIntegrations_defaultCallsActivityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface GetSessionUser_loggedInUser_phoneIntegrations_defaultVoicemailsActivityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface GetSessionUser_loggedInUser_phoneIntegrations_phoneNumberAssignments_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSessionUser_loggedInUser_phoneIntegrations_phoneNumberAssignments {
  __typename: "CallRailPhoneNumberAssignment";
  /**
   * The CallRail tracking phone number in E.164 format.
   */
  phoneNumber: string;
  /**
   * Display-formatted version of the tracking phone number.
   */
  formattedPhoneNumber: string;
  /**
   * The Nutshell user the phone number is assigned to. Null if the user has been deleted.
   */
  user: GetSessionUser_loggedInUser_phoneIntegrations_phoneNumberAssignments_user | null;
}

export interface GetSessionUser_loggedInUser_phoneIntegrations {
  __typename: "PhoneIntegration";
  /**
   * If the current user has enabled and set up credentials for this specific integration
   */
  isEnabledForUser: boolean;
  /**
   * The integration object for those types that have an instance-wide integration.
   * Null for user-specific phone integration types.
   */
  integration: GetSessionUser_loggedInUser_phoneIntegrations_integration | null;
  /**
   * The type of integration
   */
  integrationType: ExternalServiceType;
  /**
   * Unique Identifier for the user in the external system
   */
  externalUserIdentifier: string | null;
  /**
   * Additional information about the integration
   */
  tertiaryInformation: string | null;
  /**
   * The default activity type for calls from this integration
   */
  defaultCallsActivityType: GetSessionUser_loggedInUser_phoneIntegrations_defaultCallsActivityType;
  /**
   * The default activity type for voicemails from this integration
   */
  defaultVoicemailsActivityType: GetSessionUser_loggedInUser_phoneIntegrations_defaultVoicemailsActivityType;
  /**
   * True if the current user can sync previous calls for this integration
   */
  canSyncPreviousCalls: boolean;
  /**
   * True if the current user is performing an initial sync for this integration
   */
  isPerformingInitialSync: boolean;
  /**
   * CallRail-specific. Map of tracking phone numbers to the Nutshell users they
   * are assigned to. Empty for other integration types.
   */
  phoneNumberAssignments: GetSessionUser_loggedInUser_phoneIntegrations_phoneNumberAssignments[];
}

export interface GetSessionUser_loggedInUser_clickToCallIntegration_defaultCallsActivityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
  /**
   * Whether this activity type is immutable
   */
  isImmutable: boolean;
}

export interface GetSessionUser_loggedInUser_clickToCallIntegration_defaultVoicemailsActivityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
  /**
   * Whether this activity type is immutable
   */
  isImmutable: boolean;
}

export interface GetSessionUser_loggedInUser_clickToCallIntegration {
  __typename: "ClickToCallIntegration";
  /**
   * The type of integration
   */
  integrationType: ExternalServiceType;
  /**
   * If the current user has a validated phone number and caller ID for ClickToCall
   */
  isEnabled: boolean;
  /**
   * The phone number the user has configured for ClickToCall
   */
  phoneNumber: string | null;
  /**
   * The caller ID the user has configured for ClickToCall
   */
  callerId: string | null;
  /**
   * The activity type that will be used when activities are created for click-to-call phone calls
   */
  defaultCallsActivityType: GetSessionUser_loggedInUser_clickToCallIntegration_defaultCallsActivityType | null;
  /**
   * The activity type that will be used when activities are created for click-to-call voicemails
   */
  defaultVoicemailsActivityType: GetSessionUser_loggedInUser_clickToCallIntegration_defaultVoicemailsActivityType | null;
}

export interface GetSessionUser_loggedInUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  firstName: string | null;
  lastName: string | null;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
  /**
   * Is this user an administrator
   */
  isAdministrator: boolean;
  /**
   * Is this user a support user
   */
  isSupport: boolean;
  /**
   * The user’s configured timezone
   */
  timezone: string;
  /**
   * List of successfully enabled user email addresses that a user is able to send emails from Nutshell with.
   */
  sendableEmailAddresses: GetSessionUser_loggedInUser_sendableEmailAddresses[];
  /**
   * User emails configured for this user
   */
  emailAddresses: GetSessionUser_loggedInUser_emailAddresses[];
  /**
   * Full email signature for this user. Currently using base64 encoded images, so we can just send back a string
   */
  emailSignature: string | null;
  /**
   * Is this user tracking email clicks/views
   */
  isEmailTrackingEnabled: boolean;
  /**
   * Is this user hiding timeline email interactions
   */
  isExcludingTimelineInteractions: boolean;
  /**
   * Is this user hiding timeline outreach events
   */
  isExcludingTimelineOutreach: boolean;
  /**
   * Is this user hiding timeline customer journeys
   */
  isExcludingTimelineCustomerJourneys: boolean;
  /**
   * Should we show the confirmation popover before unlocking a company
   */
  hasDismissedCompanyUnlockConfirmation: boolean;
  /**
   * Should we show the scheduler promotion component on activities list
   */
  hasDismissedSchedulerPromotion: boolean;
  /**
   * Should we show the scheduler onboarding modal on scheduler page
   */
  hasViewedSchedulerOnboardingModal: boolean;
  dismissedSettings: string[];
  completedWizards: string[];
  /**
   * The user’s configured root meeting URL for scheduler
   */
  schedulerRootMeetingsUrl: string;
  /**
   * The user’s allowed permissions
   */
  permissions: GetSessionUser_loggedInUser_permissions;
  agentStatus: AgentStatusEnum;
  isMainSidebarCollapsed: boolean;
  isAiAgentSidebarOpen: boolean;
  /**
   * The number of active chats the agent is currently assigned
   */
  numActiveChats: number;
  /**
   * The number of chats that need a reply from the agent
   */
  numNeedsReplyChats: number;
  clickToCallRecordingEnabled: boolean;
  clickToCallTranscriptionEnabled: boolean;
  clickToCallSummaryEnabled: boolean;
  agentPresence: AgentPresenceEnum;
  hasUploadedAvatar: boolean;
  hasDisabledShortcuts: boolean;
  hasMfaToken: boolean;
  /**
   * Zoom integration details for this user
   */
  zoomIntegration: GetSessionUser_loggedInUser_zoomIntegration;
  /**
   * Google Meet integration details for this user
   */
  googleMeetIntegration: GetSessionUser_loggedInUser_googleMeetIntegration;
  /**
   * Microsoft Teams integration details for this user
   */
  microsoftTeamsIntegration: GetSessionUser_loggedInUser_microsoftTeamsIntegration;
  autoPresenceEnabled: boolean;
  hasEnabledZoomAutolog: boolean;
  hasEnabledGoogleMeetAutolog: boolean;
  hasEnabledMicrosoftTeamsAutolog: boolean;
  hasEnabledAircallAutolog: boolean;
  hasEnabledCallRailAutolog: boolean;
  hasEnabledRingCentralAutolog: boolean;
  hasEnabledDialpadAutolog: boolean;
  hasEnabledKixieAutolog: boolean;
  hasAllowedGoogleMeetWebhookProcessing: boolean;
  leadPageRedesignM1Enabled: boolean;
  leadPageRedesignM3Enabled: boolean;
  peepPagesRedesignEnabled: boolean;
  aiDashboardEnabled: boolean;
  widgetsCollapsedState: GetSessionUser_loggedInUser_widgetsCollapsedState;
  isAiFollowUpTasksEnabled: boolean;
  phoneCallerType: string | null;
  phoneIntegrations: GetSessionUser_loggedInUser_phoneIntegrations[];
  clickToCallIntegration: GetSessionUser_loggedInUser_clickToCallIntegration;
  sendFromNutshellEnabled: boolean;
  shouldShowPipelineOnboardingTour: boolean;
}

export interface GetSessionUser {
  /**
   * Returns the requesting user. This is essentially the logged in user, but in an
   * API context, they might not be any "logged in"
   */
  loggedInUser: GetSessionUser_loggedInUser;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSetting
// ====================================================

export interface GetSetting_setting {
  __typename: "Setting";
  /**
   * The name of this Setting
   */
  id: string;
  /**
   * The value of this Setting
   */
  value: string | null;
}

export interface GetSetting {
  /**
   * Returns a whitelisted setting
   */
  setting: GetSetting_setting;
}

export interface GetSettingVariables {
  settingName: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTeams
// ====================================================

export interface GetTeams_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The number of users affiliated with this team
   */
  numUsers: number;
}

export interface GetTeams {
  /**
   * Returns a list of Nutshell Teams
   */
  teams: GetTeams_teams[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUser
// ====================================================

export interface GetUser_user_sendableEmailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The address string of this email.
   */
  address: string;
  formatted: string;
  /**
   * Is email sync enabled for this address? When the user is sending follow-ups,
   * for example, it’s nice to warn them if sync is not enabled
   */
  isSyncEnabled: boolean;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
}

export interface GetUser_user_emailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The address string of this email.
   */
  address: string;
  formatted: string;
  /**
   * Is email sync enabled for this address? When the user is sending follow-ups,
   * for example, it’s nice to warn them if sync is not enabled
   */
  isSyncEnabled: boolean;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
}

export interface GetUser_user_permissions {
  __typename: "UserPermissionBooleans";
  canAccessSetup: boolean;
  canAccessMarketing: boolean;
  canBulkEdit: boolean;
  canExport: boolean;
  canViewSharedEmails: boolean;
  canImport: boolean;
  canMergeEntities: boolean;
  canDeleteEntities: boolean;
  canAssignEntities: boolean;
  canAccessBilling: boolean;
  canViewAllMeetings: boolean;
  canManageEmailTemplates: boolean;
  canAccessCrm: boolean;
  canAccessFullCampaigns: boolean;
  canUseInbox: boolean;
  canUseSms: boolean;
  canUseOrTryInbox: boolean;
  canUseSalesDocuments: boolean;
  canDeleteNotesAndActivities: boolean;
}

export interface GetUser_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is this user an administrator
   */
  isAdministrator: boolean;
  /**
   * List of successfully enabled user email addresses that a user is able to send emails from Nutshell with.
   */
  sendableEmailAddresses: GetUser_user_sendableEmailAddresses[];
  /**
   * User emails configured for this user
   */
  emailAddresses: GetUser_user_emailAddresses[];
  /**
   * Full email signature for this user. Currently using base64 encoded images, so we can just send back a string
   */
  emailSignature: string | null;
  /**
   * Is this user tracking email clicks/views
   */
  isEmailTrackingEnabled: boolean;
  /**
   * The user’s allowed permissions
   */
  permissions: GetUser_user_permissions;
}

export interface GetUser {
  /**
   * Returns a full Nutshell user object
   */
  user: GetUser_user;
}

export interface GetUserVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DismissNotifyMessage
// ====================================================

export interface DismissNotifyMessage_notifyMessageDismiss_loggedInUser_notifies {
  __typename: "NotifyMessage";
  id: string;
  type: string;
  message: string;
  errors: string[];
}

export interface DismissNotifyMessage_notifyMessageDismiss_loggedInUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Notify messages that relate to this user. Notify messages are user-specific
   * problems or alerts that we can’t display in real time, and need to persist
   * longer than a notification.
   */
  notifies: DismissNotifyMessage_notifyMessageDismiss_loggedInUser_notifies[];
}

export interface DismissNotifyMessage_notifyMessageDismiss {
  __typename: "NotifyMessageDismissPayload";
  /**
   * The user that the notify was dismissed for
   */
  loggedInUser: DismissNotifyMessage_notifyMessageDismiss_loggedInUser;
}

export interface DismissNotifyMessage {
  /**
   * Registers a Nutshell User for a Demio Webcast.
   */
  notifyMessageDismiss: DismissNotifyMessage_notifyMessageDismiss;
}

export interface DismissNotifyMessageVariables {
  input: NotifyMessageDismissInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetNotifyMessages
// ====================================================

export interface GetNotifyMessages_loggedInUser_notifies {
  __typename: "NotifyMessage";
  id: string;
  type: string;
  message: string;
  errors: string[];
}

export interface GetNotifyMessages_loggedInUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Notify messages that relate to this user. Notify messages are user-specific
   * problems or alerts that we can’t display in real time, and need to persist
   * longer than a notification.
   */
  notifies: GetNotifyMessages_loggedInUser_notifies[];
}

export interface GetNotifyMessages {
  /**
   * Returns the requesting user. This is essentially the logged in user, but in an
   * API context, they might not be any "logged in"
   */
  loggedInUser: GetNotifyMessages_loggedInUser;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: PrepareQuickbooksInvoice
// ====================================================

export interface PrepareQuickbooksInvoice_quickbooksCreateInvoiceForInvoice_invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * URL to view this invoice in QuickBooks, or null if it has not been sent to QuickBooks
   */
  quickbooksInvoiceUrl: string | null;
}

export interface PrepareQuickbooksInvoice_quickbooksCreateInvoiceForInvoice {
  __typename: "QuickbooksCreateInvoiceForInvoicePayload";
  /**
   * The Nutshell invoice that was sent to Quickbooks
   */
  invoice: PrepareQuickbooksInvoice_quickbooksCreateInvoiceForInvoice_invoice;
}

export interface PrepareQuickbooksInvoice {
  /**
   * Creates an invoice in Quickbooks from a Nutshell invoice
   */
  quickbooksCreateInvoiceForInvoice: PrepareQuickbooksInvoice_quickbooksCreateInvoiceForInvoice;
}

export interface PrepareQuickbooksInvoiceVariables {
  input: QuickbooksCreateInvoiceForInvoiceInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetQuickbooksInvoicePreparation
// ====================================================

export interface GetQuickbooksInvoicePreparation_quickbooksInvoicePreparation_customer {
  __typename: "QuickbooksCustomerPreparation";
  status: QuickbooksCustomerPreparationStatus;
  localEntityId: string | null;
  name: string | null;
  quickbooksCustomerId: string | null;
  reason: string | null;
}

export interface GetQuickbooksInvoicePreparation_quickbooksInvoicePreparation_products {
  __typename: "QuickbooksProductsPreparation";
  status: QuickbooksProductsPreparationStatus;
  totalCount: number;
  linkedCount: number;
  newCount: number;
  reason: string | null;
}

export interface GetQuickbooksInvoicePreparation_quickbooksInvoicePreparation {
  __typename: "QuickbooksInvoicePreparation";
  customer: GetQuickbooksInvoicePreparation_quickbooksInvoicePreparation_customer;
  products: GetQuickbooksInvoicePreparation_quickbooksInvoicePreparation_products;
}

export interface GetQuickbooksInvoicePreparation {
  quickbooksInvoicePreparation: GetQuickbooksInvoicePreparation_quickbooksInvoicePreparation;
}

export interface GetQuickbooksInvoicePreparationVariables {
  invoiceId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SearchQuickbooksCustomers
// ====================================================

export interface SearchQuickbooksCustomers_quickbooksCustomerSearch {
  __typename: "QuickbooksCustomer";
  id: string;
  displayName: string;
  isActive: boolean;
}

export interface SearchQuickbooksCustomers {
  quickbooksCustomerSearch: SearchQuickbooksCustomers_quickbooksCustomerSearch[];
}

export interface SearchQuickbooksCustomersVariables {
  search: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetProductsByIds
// ====================================================

export interface GetProductsByIds_productsByIds_marketPrice {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface GetProductsByIds_productsByIds_product_category {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
}

export interface GetProductsByIds_productsByIds_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The category of the product
   */
  category: GetProductsByIds_productsByIds_product_category | null;
}

export interface GetProductsByIds_productsByIds {
  __typename: "ProductSearchResult";
  /**
   * Whether the product is available in the requested market.
   */
  isAvailable: boolean | null;
  /**
   * The product price in the requested market, when one exists.
   */
  marketPrice: GetProductsByIds_productsByIds_marketPrice | null;
  product: GetProductsByIds_productsByIds_product;
}

export interface GetProductsByIds {
  /**
   * Returns existing products in the requested order, including archived products.
   */
  productsByIds: GetProductsByIds_productsByIds[];
}

export interface GetProductsByIdsVariables {
  ids: string[];
  marketId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SearchProducts
// ====================================================

export interface SearchProducts_productsSearch_marketPrice {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface SearchProducts_productsSearch_product_category {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
}

export interface SearchProducts_productsSearch_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The category of the product
   */
  category: SearchProducts_productsSearch_product_category | null;
}

export interface SearchProducts_productsSearch {
  __typename: "ProductSearchResult";
  /**
   * Whether the product is available in the requested market.
   */
  isAvailable: boolean | null;
  /**
   * The product price in the requested market, when one exists.
   */
  marketPrice: SearchProducts_productsSearch_marketPrice | null;
  product: SearchProducts_productsSearch_product;
}

export interface SearchProducts {
  /**
   * Searches the active product catalog for product picker results.
   */
  productsSearch: SearchProducts_productsSearch[];
}

export interface SearchProductsVariables {
  search: string;
  marketId?: string | null;
  omittedIds?: string[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SelectCreateAccount
// ====================================================

export interface SelectCreateAccount_accountCreate_account_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  region: string | null;
}

export interface SelectCreateAccount_accountCreate_account_postalAddresses_primary {
  __typename: "PostalAddress";
  value: SelectCreateAccount_accountCreate_account_postalAddresses_primary_value;
}

export interface SelectCreateAccount_accountCreate_account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: SelectCreateAccount_accountCreate_account_postalAddresses_primary | null;
}

export interface SelectCreateAccount_accountCreate_account_contacts_edges_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface SelectCreateAccount_accountCreate_account_contacts_edges {
  __typename: "AccountContactsEdge";
  node: SelectCreateAccount_accountCreate_account_contacts_edges_node;
}

export interface SelectCreateAccount_accountCreate_account_contacts {
  __typename: "AccountContactsConnection";
  /**
   * A list of edges.
   */
  edges: SelectCreateAccount_accountCreate_account_contacts_edges[];
}

export interface SelectCreateAccount_accountCreate_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: SelectCreateAccount_accountCreate_account_postalAddresses;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to
   * Nutshell Contacts. This allows you to see and query all of the contacts that
   * are related in someway (e.g., they work for) this account. For further
   * reading, see [this blog post explaining GraphQL connection types](https: // dev-blog.apollodata.com/explaining-graphql-connections-c48b7c3d6976).
   */
  contacts: SelectCreateAccount_accountCreate_account_contacts;
}

export interface SelectCreateAccount_accountCreate {
  __typename: "AccountCreatePayload";
  /**
   * The created Nutshell account.
   */
  account: SelectCreateAccount_accountCreate_account;
}

export interface SelectCreateAccount {
  /**
   * Creates a Nutshell account
   */
  accountCreate: SelectCreateAccount_accountCreate;
}

export interface SelectCreateAccountVariables {
  account: AccountCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SelectCreateAudience
// ====================================================

export interface SelectCreateAudience_audienceCreate_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface SelectCreateAudience_audienceCreate_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: SelectCreateAudience_audienceCreate_audience_membershipStats_totalCount;
}

export interface SelectCreateAudience_audienceCreate_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The audience name
   */
  name: string;
  /**
   * Is this audience on the preference center?
   */
  isPublic: boolean;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  membershipStats: SelectCreateAudience_audienceCreate_audience_membershipStats;
}

export interface SelectCreateAudience_audienceCreate {
  __typename: "AudienceCreatePayload";
  /**
   * The newly created email marketing audience
   */
  audience: SelectCreateAudience_audienceCreate_audience;
}

export interface SelectCreateAudience {
  /**
   * Creates a new email marketing audience.
   */
  audienceCreate: SelectCreateAudience_audienceCreate;
}

export interface SelectCreateAudienceVariables {
  audience: AudienceCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SelectCreateContact
// ====================================================

export interface SelectCreateContact_contactCreate_contact_accounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface SelectCreateContact_contactCreate_contact_accounts_edges {
  __typename: "ContactAccountsEdge";
  node: SelectCreateContact_contactCreate_contact_accounts_edges_node;
}

export interface SelectCreateContact_contactCreate_contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * A list of edges.
   */
  edges: SelectCreateContact_contactCreate_contact_accounts_edges[];
}

export interface SelectCreateContact_contactCreate_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: SelectCreateContact_contactCreate_contact_accounts;
}

export interface SelectCreateContact_contactCreate {
  __typename: "ContactCreatePayload";
  /**
   * The created Nutshell contact.
   */
  contact: SelectCreateContact_contactCreate_contact;
}

export interface SelectCreateContact {
  /**
   * Creates a Nutshell contact.
   */
  contactCreate: SelectCreateContact_contactCreate;
}

export interface SelectCreateContactVariables {
  input: ContactCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SelectCreateTag
// ====================================================

export interface SelectCreateTag_createTag_tag_creator_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface SelectCreateTag_createTag_tag_creator_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type SelectCreateTag_createTag_tag_creator = SelectCreateTag_createTag_tag_creator_User | SelectCreateTag_createTag_tag_creator_Origin;

export interface SelectCreateTag_createTag_tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The number of entities tagged with this tag
   */
  count: number;
  /**
   * The different type of entity that this tag belongs to (e.g., a Lead, or a Contact)
   */
  tagType: TagType;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
  /**
   * The creator of this tag
   */
  creator: SelectCreateTag_createTag_tag_creator;
  /**
   * The DateTime that represents when the Tag was last used
   */
  lastUsedTime: any | null;
}

export interface SelectCreateTag_createTag {
  __typename: "CreateTagPayload";
  /**
   * The newly created tag
   */
  tag: SelectCreateTag_createTag_tag;
}

export interface SelectCreateTag {
  /**
   * Creates a new tag in the list of available tags
   */
  createTag: SelectCreateTag_createTag;
}

export interface SelectCreateTagVariables {
  tag: CreateTagInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteTag
// ====================================================

export interface DeleteTag_deleteTag_tag_creator_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface DeleteTag_deleteTag_tag_creator_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type DeleteTag_deleteTag_tag_creator = DeleteTag_deleteTag_tag_creator_User | DeleteTag_deleteTag_tag_creator_Origin;

export interface DeleteTag_deleteTag_tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The number of entities tagged with this tag
   */
  count: number;
  /**
   * The different type of entity that this tag belongs to (e.g., a Lead, or a Contact)
   */
  tagType: TagType;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
  /**
   * The creator of this tag
   */
  creator: DeleteTag_deleteTag_tag_creator;
  /**
   * The DateTime that represents when the Tag was last used
   */
  lastUsedTime: any | null;
}

export interface DeleteTag_deleteTag {
  __typename: "DeleteTagPayload";
  /**
   * The deleted tag
   */
  tag: DeleteTag_deleteTag_tag;
}

export interface DeleteTag {
  /**
   * Deletes a tag
   */
  deleteTag: DeleteTag_deleteTag;
}

export interface DeleteTagVariables {
  input: DeleteTagInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RestoreTag
// ====================================================

export interface RestoreTag_restoreTag_tag_creator_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface RestoreTag_restoreTag_tag_creator_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type RestoreTag_restoreTag_tag_creator = RestoreTag_restoreTag_tag_creator_User | RestoreTag_restoreTag_tag_creator_Origin;

export interface RestoreTag_restoreTag_tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The number of entities tagged with this tag
   */
  count: number;
  /**
   * The different type of entity that this tag belongs to (e.g., a Lead, or a Contact)
   */
  tagType: TagType;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
  /**
   * The creator of this tag
   */
  creator: RestoreTag_restoreTag_tag_creator;
  /**
   * The DateTime that represents when the Tag was last used
   */
  lastUsedTime: any | null;
}

export interface RestoreTag_restoreTag {
  __typename: "RestoreTagPayload";
  /**
   * The restored tag
   */
  tag: RestoreTag_restoreTag_tag;
}

export interface RestoreTag {
  /**
   * Restores a deleted tag
   */
  restoreTag: RestoreTag_restoreTag;
}

export interface RestoreTagVariables {
  input: RestoreTagInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditTag
// ====================================================

export interface EditTag_editTag_tag_creator_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface EditTag_editTag_tag_creator_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type EditTag_editTag_tag_creator = EditTag_editTag_tag_creator_User | EditTag_editTag_tag_creator_Origin;

export interface EditTag_editTag_tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The number of entities tagged with this tag
   */
  count: number;
  /**
   * The different type of entity that this tag belongs to (e.g., a Lead, or a Contact)
   */
  tagType: TagType;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
  /**
   * The creator of this tag
   */
  creator: EditTag_editTag_tag_creator;
  /**
   * The DateTime that represents when the Tag was last used
   */
  lastUsedTime: any | null;
}

export interface EditTag_editTag {
  __typename: "TagEditPayload";
  /**
   * The Tag
   */
  tag: EditTag_editTag_tag;
}

export interface EditTag {
  /**
   * Edits a tag
   */
  editTag: EditTag_editTag;
}

export interface EditTagVariables {
  tag: EditTagInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ConstantContactLists
// ====================================================

export interface ConstantContactLists_constantContactLists {
  __typename: "ConstantContactList";
  id: string;
  name: string;
  favorite: boolean;
  membershipCount: number;
}

export interface ConstantContactLists {
  /**
   * Returns a flat list of Constant Contact mailing lists to which user has access
   */
  constantContactLists: ConstantContactLists_constantContactLists[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountTypes
// ====================================================

export interface GetAccountTypes_accountTypes {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface GetAccountTypes {
  /**
   * Get a list of the user‘s account types
   */
  accountTypes: GetAccountTypes_accountTypes[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountsSearchResults
// ====================================================

export interface GetAccountsSearchResults_search_quickResults_recentResults_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
}

export interface GetAccountsSearchResults_search_quickResults_recentResults_Account_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  region: string | null;
}

export interface GetAccountsSearchResults_search_quickResults_recentResults_Account_postalAddresses_primary {
  __typename: "PostalAddress";
  value: GetAccountsSearchResults_search_quickResults_recentResults_Account_postalAddresses_primary_value;
}

export interface GetAccountsSearchResults_search_quickResults_recentResults_Account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountsSearchResults_search_quickResults_recentResults_Account_postalAddresses_primary | null;
}

export interface GetAccountsSearchResults_search_quickResults_recentResults_Account_contacts_edges_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetAccountsSearchResults_search_quickResults_recentResults_Account_contacts_edges {
  __typename: "AccountContactsEdge";
  node: GetAccountsSearchResults_search_quickResults_recentResults_Account_contacts_edges_node;
}

export interface GetAccountsSearchResults_search_quickResults_recentResults_Account_contacts {
  __typename: "AccountContactsConnection";
  /**
   * A list of edges.
   */
  edges: GetAccountsSearchResults_search_quickResults_recentResults_Account_contacts_edges[];
}

export interface GetAccountsSearchResults_search_quickResults_recentResults_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetAccountsSearchResults_search_quickResults_recentResults_Account_postalAddresses;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to
   * Nutshell Contacts. This allows you to see and query all of the contacts that
   * are related in someway (e.g., they work for) this account. For further
   * reading, see [this blog post explaining GraphQL connection types](https: // dev-blog.apollodata.com/explaining-graphql-connections-c48b7c3d6976).
   */
  contacts: GetAccountsSearchResults_search_quickResults_recentResults_Account_contacts;
}

export interface GetAccountsSearchResults_search_quickResults_recentResults_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export type GetAccountsSearchResults_search_quickResults_recentResults = GetAccountsSearchResults_search_quickResults_recentResults_Lead | GetAccountsSearchResults_search_quickResults_recentResults_Account | GetAccountsSearchResults_search_quickResults_recentResults_Contact;

export interface GetAccountsSearchResults_search_quickResults_accountResults_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  region: string | null;
}

export interface GetAccountsSearchResults_search_quickResults_accountResults_postalAddresses_primary {
  __typename: "PostalAddress";
  value: GetAccountsSearchResults_search_quickResults_accountResults_postalAddresses_primary_value;
}

export interface GetAccountsSearchResults_search_quickResults_accountResults_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountsSearchResults_search_quickResults_accountResults_postalAddresses_primary | null;
}

export interface GetAccountsSearchResults_search_quickResults_accountResults_contacts_edges_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetAccountsSearchResults_search_quickResults_accountResults_contacts_edges {
  __typename: "AccountContactsEdge";
  node: GetAccountsSearchResults_search_quickResults_accountResults_contacts_edges_node;
}

export interface GetAccountsSearchResults_search_quickResults_accountResults_contacts {
  __typename: "AccountContactsConnection";
  /**
   * A list of edges.
   */
  edges: GetAccountsSearchResults_search_quickResults_accountResults_contacts_edges[];
}

export interface GetAccountsSearchResults_search_quickResults_accountResults {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetAccountsSearchResults_search_quickResults_accountResults_postalAddresses;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to
   * Nutshell Contacts. This allows you to see and query all of the contacts that
   * are related in someway (e.g., they work for) this account. For further
   * reading, see [this blog post explaining GraphQL connection types](https: // dev-blog.apollodata.com/explaining-graphql-connections-c48b7c3d6976).
   */
  contacts: GetAccountsSearchResults_search_quickResults_accountResults_contacts;
}

export interface GetAccountsSearchResults_search_quickResults {
  __typename: "SearchQuickResults";
  /**
   * A heterogeneous collection of recently viewed items across all apps.
   */
  recentResults: GetAccountsSearchResults_search_quickResults_recentResults[];
  /**
   * A collection of account results items for the query.
   */
  accountResults: GetAccountsSearchResults_search_quickResults_accountResults[];
}

export interface GetAccountsSearchResults_search {
  __typename: "SearchResultItemConnection";
  /**
   * An opinionated object that is useful for our "search everything" UIs
   */
  quickResults: GetAccountsSearchResults_search_quickResults | null;
}

export interface GetAccountsSearchResults {
  /**
   * Perform a search across resources.
   */
  search: GetAccountsSearchResults_search | null;
}

export interface GetAccountsSearchResultsVariables {
  query?: string | null;
  limit?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetActivityTypes
// ====================================================

export interface GetActivityTypes_activityTypes {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
  /**
   * The URL of the report for this activity type
   */
  reportUrl: string;
  /**
   * Whether this activity type is immutable
   */
  isImmutable: boolean;
}

export interface GetActivityTypes {
  /**
   * Get a list of activity types
   */
  activityTypes: GetActivityTypes_activityTypes[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAudiencesBasic
// ====================================================

export interface GetAudiencesBasic_audiences_edges_node_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetAudiencesBasic_audiences_edges_node_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetAudiencesBasic_audiences_edges_node_membershipStats_totalCount;
}

export interface GetAudiencesBasic_audiences_edges_node {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The audience name
   */
  name: string;
  /**
   * Is this audience on the preference center?
   */
  isPublic: boolean;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  membershipStats: GetAudiencesBasic_audiences_edges_node_membershipStats;
}

export interface GetAudiencesBasic_audiences_edges {
  __typename: "AudienceEdge";
  node: GetAudiencesBasic_audiences_edges_node;
}

export interface GetAudiencesBasic_audiences {
  __typename: "AudienceConnection";
  /**
   * A list of edges.
   */
  edges: GetAudiencesBasic_audiences_edges[];
}

export interface GetAudiencesBasic {
  /**
   * Returns all email marketing audiences
   */
  audiences: GetAudiencesBasic_audiences;
}

export interface GetAudiencesBasicVariables {
  excludeWebFXAudiences?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCompetitors
// ====================================================

export interface GetCompetitors_competitors_edges_node {
  __typename: "Competitor";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the competitor
   */
  name: string | null;
}

export interface GetCompetitors_competitors_edges {
  __typename: "LeadCompetitorsEdge";
  node: GetCompetitors_competitors_edges_node;
}

export interface GetCompetitors_competitors {
  __typename: "LeadCompetitorsConnection";
  /**
   * A list of edges.
   */
  edges: GetCompetitors_competitors_edges[];
}

export interface GetCompetitors {
  competitors: GetCompetitors_competitors | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactsSearchResults
// ====================================================

export interface GetContactsSearchResults_search_quickResults_recentResults_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
}

export interface GetContactsSearchResults_search_quickResults_recentResults_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetContactsSearchResults_search_quickResults_recentResults_Contact_accounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetContactsSearchResults_search_quickResults_recentResults_Contact_accounts_edges {
  __typename: "ContactAccountsEdge";
  node: GetContactsSearchResults_search_quickResults_recentResults_Contact_accounts_edges_node;
}

export interface GetContactsSearchResults_search_quickResults_recentResults_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * A list of edges.
   */
  edges: GetContactsSearchResults_search_quickResults_recentResults_Contact_accounts_edges[];
}

export interface GetContactsSearchResults_search_quickResults_recentResults_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetContactsSearchResults_search_quickResults_recentResults_Contact_accounts;
}

export type GetContactsSearchResults_search_quickResults_recentResults = GetContactsSearchResults_search_quickResults_recentResults_Lead | GetContactsSearchResults_search_quickResults_recentResults_Account | GetContactsSearchResults_search_quickResults_recentResults_Contact;

export interface GetContactsSearchResults_search_quickResults_contactResults_accounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetContactsSearchResults_search_quickResults_contactResults_accounts_edges {
  __typename: "ContactAccountsEdge";
  node: GetContactsSearchResults_search_quickResults_contactResults_accounts_edges_node;
}

export interface GetContactsSearchResults_search_quickResults_contactResults_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * A list of edges.
   */
  edges: GetContactsSearchResults_search_quickResults_contactResults_accounts_edges[];
}

export interface GetContactsSearchResults_search_quickResults_contactResults {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetContactsSearchResults_search_quickResults_contactResults_accounts;
}

export interface GetContactsSearchResults_search_quickResults {
  __typename: "SearchQuickResults";
  /**
   * A heterogeneous collection of recently viewed items across all apps.
   */
  recentResults: GetContactsSearchResults_search_quickResults_recentResults[];
  /**
   * A collection of contact results items for the query.
   */
  contactResults: GetContactsSearchResults_search_quickResults_contactResults[];
}

export interface GetContactsSearchResults_search {
  __typename: "SearchResultItemConnection";
  /**
   * An opinionated object that is useful for our "search everything" UIs
   */
  quickResults: GetContactsSearchResults_search_quickResults | null;
}

export interface GetContactsSearchResults {
  /**
   * Perform a search across resources.
   */
  search: GetContactsSearchResults_search | null;
}

export interface GetContactsSearchResultsVariables {
  query?: string | null;
  limit?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetIndustries
// ====================================================

export interface GetIndustries_industries {
  __typename: "Industry";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this industry
   */
  name: string;
}

export interface GetIndustries {
  /**
   * Returns a list of industries
   */
  industries: GetIndustries_industries[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLeadsSearchResults
// ====================================================

export interface GetLeadsSearchResults_search_quickResults_leadResults {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Leads don’t have initials, but for interface reasons we’ll return an empty
   * string here instead of removing the property entirely.
   */
  initials: string;
}

export interface GetLeadsSearchResults_search_quickResults {
  __typename: "SearchQuickResults";
  /**
   * A collection of lead results items for the query.
   */
  leadResults: GetLeadsSearchResults_search_quickResults_leadResults[];
}

export interface GetLeadsSearchResults_search {
  __typename: "SearchResultItemConnection";
  /**
   * An opinionated object that is useful for our "search everything" UIs
   */
  quickResults: GetLeadsSearchResults_search_quickResults | null;
}

export interface GetLeadsSearchResults {
  /**
   * Perform a search across resources.
   */
  search: GetLeadsSearchResults_search | null;
}

export interface GetLeadsSearchResultsVariables {
  query?: string | null;
  limit?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMarkets
// ====================================================

export interface GetMarkets_markets_edges_node {
  __typename: "Market";
  id: string;
  name: string;
  currency: string;
  currencySymbol: string;
  isDefault: boolean;
}

export interface GetMarkets_markets_edges {
  __typename: "MarketsEdge";
  node: GetMarkets_markets_edges_node;
}

export interface GetMarkets_markets {
  __typename: "MarketsConnection";
  /**
   * A list of edges.
   */
  edges: GetMarkets_markets_edges[];
}

export interface GetMarkets {
  /**
   * Returns a paging connection of markets from the root of our query.
   */
  markets: GetMarkets_markets | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRecentLeads
// ====================================================

export interface GetRecentLeads_search_quickResults_recentResultsByType_leads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetRecentLeads_search_quickResults_recentResultsByType_leads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetRecentLeads_search_quickResults_recentResultsByType_leads_contacts_primaryEdge_node;
}

export interface GetRecentLeads_search_quickResults_recentResultsByType_leads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetRecentLeads_search_quickResults_recentResultsByType_leads_contacts_primaryEdge | null;
}

export interface GetRecentLeads_search_quickResults_recentResultsByType_leads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetRecentLeads_search_quickResults_recentResultsByType_leads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetRecentLeads_search_quickResults_recentResultsByType_leads_accounts_primaryEdge_node;
}

export interface GetRecentLeads_search_quickResults_recentResultsByType_leads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetRecentLeads_search_quickResults_recentResultsByType_leads_accounts_primaryEdge | null;
}

export interface GetRecentLeads_search_quickResults_recentResultsByType_leads_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetRecentLeads_search_quickResults_recentResultsByType_leads_value {
  __typename: "Money";
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetRecentLeads_search_quickResults_recentResultsByType_leads_value_formattedValue;
}

export interface GetRecentLeads_search_quickResults_recentResultsByType_leads_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetRecentLeads_search_quickResults_recentResultsByType_leads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Leads don’t have initials, but for interface reasons we’ll return an empty
   * string here instead of removing the property entirely.
   */
  initials: string;
  number: number | null;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetRecentLeads_search_quickResults_recentResultsByType_leads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetRecentLeads_search_quickResults_recentResultsByType_leads_accounts;
  value: GetRecentLeads_search_quickResults_recentResultsByType_leads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetRecentLeads_search_quickResults_recentResultsByType_leads_assignee | null;
}

export interface GetRecentLeads_search_quickResults_recentResultsByType {
  __typename: "RecentResults";
  /**
   * Recently viewed leads
   */
  leads: GetRecentLeads_search_quickResults_recentResultsByType_leads[];
}

export interface GetRecentLeads_search_quickResults {
  __typename: "SearchQuickResults";
  /**
   * Recently viewed items grouped by entity type
   */
  recentResultsByType: GetRecentLeads_search_quickResults_recentResultsByType;
}

export interface GetRecentLeads_search {
  __typename: "SearchResultItemConnection";
  /**
   * An opinionated object that is useful for our "search everything" UIs
   */
  quickResults: GetRecentLeads_search_quickResults | null;
}

export interface GetRecentLeads {
  /**
   * Perform a search across resources.
   */
  search: GetRecentLeads_search | null;
}

export interface GetRecentLeadsVariables {
  limit?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRelatedEntitiesSearchResults
// ====================================================

export interface GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Leads don’t have initials, but for interface reasons we’ll return an empty
   * string here instead of removing the property entirely.
   */
  initials: string;
}

export interface GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Account_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  region: string | null;
}

export interface GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Account_postalAddresses_primary {
  __typename: "PostalAddress";
  value: GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Account_postalAddresses_primary_value;
}

export interface GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Account_postalAddresses_primary | null;
}

export interface GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Account_contacts_edges_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Account_contacts_edges {
  __typename: "AccountContactsEdge";
  node: GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Account_contacts_edges_node;
}

export interface GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Account_contacts {
  __typename: "AccountContactsConnection";
  /**
   * A list of edges.
   */
  edges: GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Account_contacts_edges[];
}

export interface GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Account_postalAddresses;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to
   * Nutshell Contacts. This allows you to see and query all of the contacts that
   * are related in someway (e.g., they work for) this account. For further
   * reading, see [this blog post explaining GraphQL connection types](https: // dev-blog.apollodata.com/explaining-graphql-connections-c48b7c3d6976).
   */
  contacts: GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Account_contacts;
}

export interface GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Contact_accounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Contact_accounts_edges {
  __typename: "ContactAccountsEdge";
  node: GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Contact_accounts_edges_node;
}

export interface GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * A list of edges.
   */
  edges: GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Contact_accounts_edges[];
}

export interface GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Contact_accounts;
}

export type GetRelatedEntitiesSearchResults_search_quickResults_recentResults = GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Lead | GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Account | GetRelatedEntitiesSearchResults_search_quickResults_recentResults_Contact;

export interface GetRelatedEntitiesSearchResults_search_quickResults_topResults_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Leads don’t have initials, but for interface reasons we’ll return an empty
   * string here instead of removing the property entirely.
   */
  initials: string;
}

export interface GetRelatedEntitiesSearchResults_search_quickResults_topResults_Account_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  region: string | null;
}

export interface GetRelatedEntitiesSearchResults_search_quickResults_topResults_Account_postalAddresses_primary {
  __typename: "PostalAddress";
  value: GetRelatedEntitiesSearchResults_search_quickResults_topResults_Account_postalAddresses_primary_value;
}

export interface GetRelatedEntitiesSearchResults_search_quickResults_topResults_Account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetRelatedEntitiesSearchResults_search_quickResults_topResults_Account_postalAddresses_primary | null;
}

export interface GetRelatedEntitiesSearchResults_search_quickResults_topResults_Account_contacts_edges_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetRelatedEntitiesSearchResults_search_quickResults_topResults_Account_contacts_edges {
  __typename: "AccountContactsEdge";
  node: GetRelatedEntitiesSearchResults_search_quickResults_topResults_Account_contacts_edges_node;
}

export interface GetRelatedEntitiesSearchResults_search_quickResults_topResults_Account_contacts {
  __typename: "AccountContactsConnection";
  /**
   * A list of edges.
   */
  edges: GetRelatedEntitiesSearchResults_search_quickResults_topResults_Account_contacts_edges[];
}

export interface GetRelatedEntitiesSearchResults_search_quickResults_topResults_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetRelatedEntitiesSearchResults_search_quickResults_topResults_Account_postalAddresses;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to
   * Nutshell Contacts. This allows you to see and query all of the contacts that
   * are related in someway (e.g., they work for) this account. For further
   * reading, see [this blog post explaining GraphQL connection types](https: // dev-blog.apollodata.com/explaining-graphql-connections-c48b7c3d6976).
   */
  contacts: GetRelatedEntitiesSearchResults_search_quickResults_topResults_Account_contacts;
}

export interface GetRelatedEntitiesSearchResults_search_quickResults_topResults_Contact_accounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetRelatedEntitiesSearchResults_search_quickResults_topResults_Contact_accounts_edges {
  __typename: "ContactAccountsEdge";
  node: GetRelatedEntitiesSearchResults_search_quickResults_topResults_Contact_accounts_edges_node;
}

export interface GetRelatedEntitiesSearchResults_search_quickResults_topResults_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * A list of edges.
   */
  edges: GetRelatedEntitiesSearchResults_search_quickResults_topResults_Contact_accounts_edges[];
}

export interface GetRelatedEntitiesSearchResults_search_quickResults_topResults_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetRelatedEntitiesSearchResults_search_quickResults_topResults_Contact_accounts;
}

export type GetRelatedEntitiesSearchResults_search_quickResults_topResults = GetRelatedEntitiesSearchResults_search_quickResults_topResults_Lead | GetRelatedEntitiesSearchResults_search_quickResults_topResults_Account | GetRelatedEntitiesSearchResults_search_quickResults_topResults_Contact;

export interface GetRelatedEntitiesSearchResults_search_quickResults {
  __typename: "SearchQuickResults";
  /**
   * A heterogeneous collection of recently viewed items across all apps.
   */
  recentResults: GetRelatedEntitiesSearchResults_search_quickResults_recentResults[];
  /**
   * A heterogeneous collection of the top search results items for the query.
   */
  topResults: GetRelatedEntitiesSearchResults_search_quickResults_topResults[];
}

export interface GetRelatedEntitiesSearchResults_search {
  __typename: "SearchResultItemConnection";
  /**
   * An opinionated object that is useful for our "search everything" UIs
   */
  quickResults: GetRelatedEntitiesSearchResults_search_quickResults | null;
}

export interface GetRelatedEntitiesSearchResults {
  /**
   * Perform a search across resources.
   */
  search: GetRelatedEntitiesSearchResults_search | null;
}

export interface GetRelatedEntitiesSearchResultsVariables {
  query?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSelectableCustomFields
// ====================================================

export interface GetSelectableCustomFields_customFields_active_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable type of the attribute
   */
  displayType: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
}

export interface GetSelectableCustomFields_customFields_active {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: GetSelectableCustomFields_customFields_active_attribute;
}

export interface GetSelectableCustomFields_customFields {
  __typename: "CustomFields";
  /**
   * The custom field that haven't been deleted
   */
  active: GetSelectableCustomFields_customFields_active[];
}

export interface GetSelectableCustomFields {
  /**
   * List of custom fields for a particular entity type
   */
  customFields: GetSelectableCustomFields_customFields;
}

export interface GetSelectableCustomFieldsVariables {
  input: CustomFieldsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetStagesets
// ====================================================

export interface GetStagesets_stagesets_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetStagesets_stagesets {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * Can this pipeline be accessed? If a customer downgrades, non-default pipelines may become inaccessible
   */
  canAccess: boolean;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The stages associated with this stageset
   */
  stages: GetStagesets_stagesets_stages[];
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
}

export interface GetStagesets {
  /**
   * Returns a list of Nutshell Stagesets
   */
  stagesets: GetStagesets_stagesets[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTerritories
// ====================================================

export interface GetTerritories_territories_edges_node {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface GetTerritories_territories_edges {
  __typename: "TerritoriesEdge";
  node: GetTerritories_territories_edges_node;
}

export interface GetTerritories_territories {
  __typename: "TerritoriesConnection";
  /**
   * A list of edges.
   */
  edges: GetTerritories_territories_edges[];
}

export interface GetTerritories {
  /**
   * Returns a paging connection of territories from the root of our query.
   */
  territories: GetTerritories_territories | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUsers
// ====================================================

export interface GetUsers_users_pageInfo {
  __typename: "PageInfo";
  endCursor: string | null;
  hasNextPage: boolean;
}

export interface GetUsers_users_edges_node_calendarSync {
  __typename: "CalendarSync";
  /**
   * Whether or not calendar sync is enabled
   */
  isEnabled: boolean;
}

export interface GetUsers_users_edges_node {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
  /**
   * Calendar sync details for this user
   */
  calendarSync: GetUsers_users_edges_node_calendarSync | null;
  isAgent: boolean;
}

export interface GetUsers_users_edges {
  __typename: "UsersEdge";
  node: GetUsers_users_edges_node;
}

export interface GetUsers_users {
  __typename: "UsersConnection";
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetUsers_users_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetUsers_users_edges[];
}

export interface GetUsers {
  /**
   * Returns a paging connection of users from the root of our query.
   */
  users: GetUsers_users;
}

export interface GetUsersVariables {
  first?: number | null;
  after?: string | null;
  search?: string | null;
  includeUnprovisioned?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetVerifiedEmailAddresses
// ====================================================

export interface GetVerifiedEmailAddresses_fromAddresses_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetVerifiedEmailAddresses_fromAddresses_edges_node_emailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface GetVerifiedEmailAddresses_fromAddresses_edges_node_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface GetVerifiedEmailAddresses_fromAddresses_edges_node {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: GetVerifiedEmailAddresses_fromAddresses_edges_node_emailAddress;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: GetVerifiedEmailAddresses_fromAddresses_edges_node_fromDomain | null;
}

export interface GetVerifiedEmailAddresses_fromAddresses_edges {
  __typename: "FromAddressesEdge";
  cursor: string;
  node: GetVerifiedEmailAddresses_fromAddresses_edges_node;
}

export interface GetVerifiedEmailAddresses_fromAddresses {
  __typename: "FromAddressesConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetVerifiedEmailAddresses_fromAddresses_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetVerifiedEmailAddresses_fromAddresses_edges[];
}

export interface GetVerifiedEmailAddresses {
  /**
   * Returns a paging connection of marketing from addresses. If a userId is
   * provided, it will return the from addresses for that user. Otherwise, it will
   * return the from addresses for the current user.
   */
  fromAddresses: GetVerifiedEmailAddresses_fromAddresses | null;
}

export interface GetVerifiedEmailAddressesVariables {
  userId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: MailChimpListsQuery
// ====================================================

export interface MailChimpListsQuery_mailChimpLists {
  __typename: "MailChimpList";
  id: string;
  name: string;
}

export interface MailChimpListsQuery {
  /**
   * Returns a flat list of MailChimp mailing lists to which user has access
   */
  mailChimpLists: MailChimpListsQuery_mailChimpLists[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SalesAutomationableEmailSequenceTemplates
// ====================================================

export interface SalesAutomationableEmailSequenceTemplates_salesAutomationableEmailSequenceTemplates_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SalesAutomationableEmailSequenceTemplates_salesAutomationableEmailSequenceTemplates_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SalesAutomationableEmailSequenceTemplates_salesAutomationableEmailSequenceTemplates {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  creatorUser: SalesAutomationableEmailSequenceTemplates_salesAutomationableEmailSequenceTemplates_creatorUser;
  createdTime: any | null;
  emailSequenceTemplateMessages: SalesAutomationableEmailSequenceTemplates_salesAutomationableEmailSequenceTemplates_emailSequenceTemplateMessages[];
  /**
   * The url pathname to the edit modal for the email template
   */
  htmlUrlPath: string;
  /**
   * Whether the template has custom placeholders
   */
  hasCustomPlaceholders: boolean;
}

export interface SalesAutomationableEmailSequenceTemplates {
  /**
   * List of email sequence templates available for creating an email automation in a given stageset
   */
  salesAutomationableEmailSequenceTemplates: SalesAutomationableEmailSequenceTemplates_salesAutomationableEmailSequenceTemplates[];
}

export interface SalesAutomationableEmailSequenceTemplatesVariables {
  stagesetId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SlackChannelsQuery
// ====================================================

export interface SlackChannelsQuery_slackChannels {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
}

export interface SlackChannelsQuery {
  /**
   * Returns a flat list of slack channels to which user has access
   */
  slackChannels: SlackChannelsQuery_slackChannels[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SourcesQuery
// ====================================================

export interface SourcesQuery_sources_pageInfo {
  __typename: "PageInfo";
  endCursor: string | null;
  hasNextPage: boolean;
}

export interface SourcesQuery_sources_edges_node {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface SourcesQuery_sources_edges {
  __typename: "SourcesEdge";
  node: SourcesQuery_sources_edges_node;
}

export interface SourcesQuery_sources {
  __typename: "SourcesConnection";
  /**
   * Information to aid in pagination.
   */
  pageInfo: SourcesQuery_sources_pageInfo;
  /**
   * A list of edges.
   */
  edges: SourcesQuery_sources_edges[];
}

export interface SourcesQuery {
  /**
   * Returns a paging connection of sources from the root of our query.
   */
  sources: SourcesQuery_sources | null;
}

export interface SourcesQueryVariables {
  after?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTagsBasic
// ====================================================

export interface GetTagsBasic_tags_pageInfo {
  __typename: "PageInfo";
  hasNextPage: boolean;
  endCursor: string | null;
}

export interface GetTagsBasic_tags_edges_node_creator_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface GetTagsBasic_tags_edges_node_creator_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type GetTagsBasic_tags_edges_node_creator = GetTagsBasic_tags_edges_node_creator_User | GetTagsBasic_tags_edges_node_creator_Origin;

export interface GetTagsBasic_tags_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The number of entities tagged with this tag
   */
  count: number;
  /**
   * The different type of entity that this tag belongs to (e.g., a Lead, or a Contact)
   */
  tagType: TagType;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
  /**
   * The creator of this tag
   */
  creator: GetTagsBasic_tags_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was last used
   */
  lastUsedTime: any | null;
}

export interface GetTagsBasic_tags_edges {
  __typename: "TagsEdge";
  node: GetTagsBasic_tags_edges_node;
}

export interface GetTagsBasic_tags {
  __typename: "TagsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetTagsBasic_tags_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetTagsBasic_tags_edges[];
}

export interface GetTagsBasic {
  /**
   * Returns a paginated connection of Nutshell Tag objects
   */
  tags: GetTagsBasic_tags | null;
}

export interface GetTagsBasicVariables {
  first?: number | null;
  after?: string | null;
  input: TagsQueryInputType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetClickTrackingDomain
// ====================================================

export interface GetClickTrackingDomain {
  /**
   * Returns the current set click tracking domain (if exists).
   */
  clickTrackingDomain: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSubdomains
// ====================================================

export interface GetSubdomains_subdomains {
  __typename: "Subdomain";
  /**
   * The ID of the em_from_domain row this record corresponds to, as each domain is split into multiple rows
   */
  fromDomainId: string;
  /**
   * The record of this DNS record
   */
  record: string;
  /**
   * The record of this DNS record
   */
  formattedRecord: string;
  /**
   * Where this subdomain is verified
   */
  isVerified: boolean;
}

export interface GetSubdomains {
  /**
   * Returns a list of domain records which can serve as a hosted page (ex: growth.customerdomain.com)
   */
  subdomains: GetSubdomains_subdomains[];
}

export interface GetSubdomainsVariables {
  includeNutshellManaged?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddModalFieldsUpdate
// ====================================================

export interface AddModalFieldsUpdate_addModalFieldsUpdate {
  __typename: "SelectableField";
  /**
   * The ID of the field to add
   */
  fieldId: string;
  /**
   * Whether the field is required
   */
  isRequired: boolean;
  /**
   * Whether the field can be removed
   */
  isRemoveable: boolean;
}

export interface AddModalFieldsUpdate {
  /**
   * Updates the order of selected fields for a given entity type
   */
  addModalFieldsUpdate: AddModalFieldsUpdate_addModalFieldsUpdate[];
}

export interface AddModalFieldsUpdateVariables {
  input: AddModalFieldsUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetFields
// ====================================================

export interface GetFields_createModalFields {
  __typename: "SelectableField";
  /**
   * The ID of the field to add
   */
  fieldId: string;
  /**
   * Whether the field is required
   */
  isRequired: boolean;
  /**
   * Whether the field can be removed
   */
  isRemoveable: boolean;
  /**
   * Whether the field can be shown on the lead board
   */
  isBoardable: boolean;
}

export interface GetFields {
  /**
   * Array of fields
   */
  createModalFields: GetFields_createModalFields[];
}

export interface GetFieldsVariables {
  entityType: EntityType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AcceptAiEmailTemplate
// ====================================================

export interface AcceptAiEmailTemplate_aiEmailTemplateAccept_edition {
  __typename: "Edition";
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface AcceptAiEmailTemplate_aiEmailTemplateAccept {
  __typename: "AiEmailTemplateAcceptPayload";
  edition: AcceptAiEmailTemplate_aiEmailTemplateAccept_edition;
}

export interface AcceptAiEmailTemplate {
  /**
   * Accept an AI-generated template and convert it or add it to an existing campaign.
   */
  aiEmailTemplateAccept: AcceptAiEmailTemplate_aiEmailTemplateAccept;
}

export interface AcceptAiEmailTemplateVariables {
  input: AiEmailTemplateAcceptInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: GenerateAiEmailFromTemplate
// ====================================================

export interface GenerateAiEmailFromTemplate_aiEmailTemplateGenerateFromTemplate_campaign_editions_edges_node_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface GenerateAiEmailFromTemplate_aiEmailTemplateGenerateFromTemplate_campaign_editions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: GenerateAiEmailFromTemplate_aiEmailTemplateGenerateFromTemplate_campaign_editions_edges_node_emailTemplate | null;
}

export interface GenerateAiEmailFromTemplate_aiEmailTemplateGenerateFromTemplate_campaign_editions_edges {
  __typename: "EditionsEdge";
  node: GenerateAiEmailFromTemplate_aiEmailTemplateGenerateFromTemplate_campaign_editions_edges_node;
}

export interface GenerateAiEmailFromTemplate_aiEmailTemplateGenerateFromTemplate_campaign_editions {
  __typename: "EditionsConnection";
  /**
   * A list of edges.
   */
  edges: GenerateAiEmailFromTemplate_aiEmailTemplateGenerateFromTemplate_campaign_editions_edges[];
}

export interface GenerateAiEmailFromTemplate_aiEmailTemplateGenerateFromTemplate_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  description: string;
  editions: GenerateAiEmailFromTemplate_aiEmailTemplateGenerateFromTemplate_campaign_editions;
}

export interface GenerateAiEmailFromTemplate_aiEmailTemplateGenerateFromTemplate {
  __typename: "AiEmailTemplateGenerateFromTemplatePayload";
  campaign: GenerateAiEmailFromTemplate_aiEmailTemplateGenerateFromTemplate_campaign;
}

export interface GenerateAiEmailFromTemplate {
  /**
   * Generates an AI email by replacing content in an existing template
   */
  aiEmailTemplateGenerateFromTemplate: GenerateAiEmailFromTemplate_aiEmailTemplateGenerateFromTemplate;
}

export interface GenerateAiEmailFromTemplateVariables {
  input: AiEmailTemplateGenerateFromTemplateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RegenerateAiEmailTemplateFromTemplate
// ====================================================

export interface RegenerateAiEmailTemplateFromTemplate_aiEmailTemplateRegenerateFromTemplate_campaign_editions_edges_node_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface RegenerateAiEmailTemplateFromTemplate_aiEmailTemplateRegenerateFromTemplate_campaign_editions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: RegenerateAiEmailTemplateFromTemplate_aiEmailTemplateRegenerateFromTemplate_campaign_editions_edges_node_emailTemplate | null;
}

export interface RegenerateAiEmailTemplateFromTemplate_aiEmailTemplateRegenerateFromTemplate_campaign_editions_edges {
  __typename: "EditionsEdge";
  node: RegenerateAiEmailTemplateFromTemplate_aiEmailTemplateRegenerateFromTemplate_campaign_editions_edges_node;
}

export interface RegenerateAiEmailTemplateFromTemplate_aiEmailTemplateRegenerateFromTemplate_campaign_editions {
  __typename: "EditionsConnection";
  /**
   * A list of edges.
   */
  edges: RegenerateAiEmailTemplateFromTemplate_aiEmailTemplateRegenerateFromTemplate_campaign_editions_edges[];
}

export interface RegenerateAiEmailTemplateFromTemplate_aiEmailTemplateRegenerateFromTemplate_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  description: string;
  editions: RegenerateAiEmailTemplateFromTemplate_aiEmailTemplateRegenerateFromTemplate_campaign_editions;
}

export interface RegenerateAiEmailTemplateFromTemplate_aiEmailTemplateRegenerateFromTemplate {
  __typename: "AiEmailTemplateRegenerateFromTemplatePayload";
  /**
   * The campaign that was regenerated
   */
  campaign: RegenerateAiEmailTemplateFromTemplate_aiEmailTemplateRegenerateFromTemplate_campaign;
}

export interface RegenerateAiEmailTemplateFromTemplate {
  /**
   * Regenerates an AI email template for a campaign
   */
  aiEmailTemplateRegenerateFromTemplate: RegenerateAiEmailTemplateFromTemplate_aiEmailTemplateRegenerateFromTemplate;
}

export interface RegenerateAiEmailTemplateFromTemplateVariables {
  input: AiEmailTemplateRegenerateFromTemplateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAiGeneratedTemplateByEdition
// ====================================================

export interface GetAiGeneratedTemplateByEdition_aiGeneratedTemplateGet_editions_edges_node_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface GetAiGeneratedTemplateByEdition_aiGeneratedTemplateGet_editions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: GetAiGeneratedTemplateByEdition_aiGeneratedTemplateGet_editions_edges_node_emailTemplate | null;
}

export interface GetAiGeneratedTemplateByEdition_aiGeneratedTemplateGet_editions_edges {
  __typename: "EditionsEdge";
  node: GetAiGeneratedTemplateByEdition_aiGeneratedTemplateGet_editions_edges_node;
}

export interface GetAiGeneratedTemplateByEdition_aiGeneratedTemplateGet_editions {
  __typename: "EditionsConnection";
  /**
   * A list of edges.
   */
  edges: GetAiGeneratedTemplateByEdition_aiGeneratedTemplateGet_editions_edges[];
}

export interface GetAiGeneratedTemplateByEdition_aiGeneratedTemplateGet {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  description: string;
  editions: GetAiGeneratedTemplateByEdition_aiGeneratedTemplateGet_editions;
}

export interface GetAiGeneratedTemplateByEdition {
  /**
   * Get the AI-generated campaign from an edition ID.
   */
  aiGeneratedTemplateGet: GetAiGeneratedTemplateByEdition_aiGeneratedTemplateGet | null;
}

export interface GetAiGeneratedTemplateByEditionVariables {
  editionId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAnalyticsStatus
// ====================================================

export interface GetAnalyticsStatus_analyticsStatus_latestImpressionData_Visit {
  __typename: "Visit";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  createdTime: any;
}

export interface GetAnalyticsStatus_analyticsStatus_latestImpressionData_FormSubmission {
  __typename: "FormSubmission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  createdTime: any;
}

export type GetAnalyticsStatus_analyticsStatus_latestImpressionData = GetAnalyticsStatus_analyticsStatus_latestImpressionData_Visit | GetAnalyticsStatus_analyticsStatus_latestImpressionData_FormSubmission;

export interface GetAnalyticsStatus_analyticsStatus {
  __typename: "AnalyticsStatus";
  /**
   * The tracking status for the instance
   */
  status: Status;
  /**
   * The status of the chat snippet embed for an instance
   */
  chatStatus: Status;
  /**
   * The last detected visit or submission to the instance
   */
  latestImpressionData: GetAnalyticsStatus_analyticsStatus_latestImpressionData | null;
  /**
   * The number of forms that have been connected
   */
  numActiveForms: number;
  /**
   * The number of forms that have not been connected
   */
  numInactiveForms: number;
  /**
   * The embeddable script to add tracking to an instance
   */
  trackingScript: string;
  /**
   * The version of the analytics snippet that is being used
   */
  snippetVersion: AnalyticsSnippetVersion;
  /**
   * The auth token used in the embeddable snippet
   */
  authTokenForSnippet: string;
  /**
   * The domain that is embedded in the snippet.
   */
  embeddedDomain: string | null;
}

export interface GetAnalyticsStatus {
  /**
   * Status of the user’s session tracking
   */
  analyticsStatus: GetAnalyticsStatus_analyticsStatus;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAudienceEngagementStats
// ====================================================

export interface GetAudienceEngagementStats_audience_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
}

export interface GetAudienceEngagementStats_audience_smsEngagementStats {
  __typename: "SmsEngagementStats";
  /**
   * Total number of texts we tried to send
   */
  totalSentCount: number;
  /**
   * Total number of people who responded to the SMS campaign
   */
  responseCount: number;
  /**
   * The ratio of response to total texts sent
   */
  responseRate: number | null;
  /**
   * Total number of texts which couldn’t be delivered
   */
  undeliveredCount: number;
  /**
   * The ratio of undelivered texts to total texts sent
   */
  undeliveredRate: number | null;
  /**
   * The number of people who opted out of SMS messages after receiving this campaign
   */
  optoutCount: number;
  /**
   * The ratio of optouts to total texts sent
   */
  optoutRate: number | null;
}

export interface GetAudienceEngagementStats_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  engagementStats: GetAudienceEngagementStats_audience_engagementStats;
  smsEngagementStats: GetAudienceEngagementStats_audience_smsEngagementStats;
}

export interface GetAudienceEngagementStats {
  /**
   * Returns an email marketing audience.
   */
  audience: GetAudienceEngagementStats_audience;
}

export interface GetAudienceEngagementStatsVariables {
  audienceId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAudienceMembershipStats
// ====================================================

export interface GetAudienceMembershipStats_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetAudienceMembershipStats_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetAudienceMembershipStats_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface GetAudienceMembershipStats_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  membershipStats: GetAudienceMembershipStats_audience_membershipStats;
}

export interface GetAudienceMembershipStats {
  /**
   * Returns an email marketing audience.
   */
  audience: GetAudienceMembershipStats_audience;
}

export interface GetAudienceMembershipStatsVariables {
  audienceId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAudienceSmsMembershipStats
// ====================================================

export interface GetAudienceSmsMembershipStats_audience_smsMembershipStatsRealtime_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetAudienceSmsMembershipStats_audience_smsMembershipStatsRealtime {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetAudienceSmsMembershipStats_audience_smsMembershipStatsRealtime_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface GetAudienceSmsMembershipStats_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Runs the query to get SMS membership stats rather than using data from our cache table. 
   * 							Should only be used when quering an individual audience as it takes about ~0.5 seconds. 
   * 							If used in a list context it will take a while.
   */
  smsMembershipStatsRealtime: GetAudienceSmsMembershipStats_audience_smsMembershipStatsRealtime;
}

export interface GetAudienceSmsMembershipStats {
  /**
   * Returns an email marketing audience.
   */
  audience: GetAudienceSmsMembershipStats_audience;
}

export interface GetAudienceSmsMembershipStatsVariables {
  audienceId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSentBroadcastCount
// ====================================================

export interface GetSentBroadcastCount_broadcasts {
  __typename: "CampaignsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetSentBroadcastCount {
  /**
   * Returns a paging connection of email broadcasts from the root of our query.
   */
  broadcasts: GetSentBroadcastCount_broadcasts;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBeeToken
// ====================================================

export interface GetBeeToken {
  /**
   * Returns the BEE editor token.
   */
  beeToken: string;
}

export interface GetBeeTokenVariables {
  input: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AcceptAndConvertAiBroadcast
// ====================================================

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_campaign_nextSendingEdition | null;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_emailTemplate_links[];
  name: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_comparisonEdition_emailTemplate_links[];
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_comparisonEdition_emailTemplate | null;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_comparison_winnerEdition_emailTemplate | null;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_comparison_winningEdition | null;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_audience_fromSavedFilter_count;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_audience_fromSavedFilter | null;
  membershipStats: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_audience_membershipStats;
  smsMembershipStats: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_audience_smsMembershipStats;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_from_emailAddress;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_from_fromDomain | null;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_gateError {
  __typename: "GateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity = AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account | AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges_node;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions_edges[];
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_emailTemplate | null;
  engagementStats: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_delay | null;
  /**
   * The number of emails sent for this edition
   */
  numSentEmails: number;
  /**
   * The custom click domain that this edition will use to track links, if there is one
   */
  customClickDomain: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_customClickDomain | null;
  utmParameters: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_utmParameters;
  defaultUtmParameters: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_defaultUtmParameters;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  useUtmParameters: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_gateError | null;
  /**
   * Boolean indicating if the edition is using a web font.
   */
  hasWebFonts: boolean;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition_queuedDripProgressions | null;
  /**
   * The maximum number of recipients this edition can send to, if DMARC is not
   * fully configured. This is only relevant for non-drip sequence editions.
   */
  recipientLimitForDeliverability: number | null;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  edition: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign_edition;
  description: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
}

export interface AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert {
  __typename: "AiBroadcastAcceptAndConvertPayload";
  /**
   * The broadcast that was accepted and converted
   */
  campaign: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert_campaign;
}

export interface AcceptAndConvertAiBroadcast {
  /**
   * Run when a user accepts an AI broadcast. Converts the AI broadcast to a regular broadcast.
   */
  aiBroadcastAcceptAndConvert: AcceptAndConvertAiBroadcast_aiBroadcastAcceptAndConvert;
}

export interface AcceptAndConvertAiBroadcastVariables {
  input: AiBroadcastAcceptAndConvertInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RegenerateAiEmailTemplate
// ====================================================

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_campaign_nextSendingEdition | null;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_emailTemplate_links[];
  name: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_comparisonEdition_emailTemplate_links[];
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_comparisonEdition_emailTemplate | null;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_comparison_winnerEdition_emailTemplate | null;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_comparison_winningEdition | null;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_audience_fromSavedFilter_count;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_audience_fromSavedFilter | null;
  membershipStats: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_audience_membershipStats;
  smsMembershipStats: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_audience_smsMembershipStats;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_from_emailAddress;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_from_fromDomain | null;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_gateError {
  __typename: "GateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity = RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account | RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges_node;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions_edges[];
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_emailTemplate | null;
  engagementStats: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_delay | null;
  /**
   * The number of emails sent for this edition
   */
  numSentEmails: number;
  /**
   * The custom click domain that this edition will use to track links, if there is one
   */
  customClickDomain: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_customClickDomain | null;
  utmParameters: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_utmParameters;
  defaultUtmParameters: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_defaultUtmParameters;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  useUtmParameters: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_gateError | null;
  /**
   * Boolean indicating if the edition is using a web font.
   */
  hasWebFonts: boolean;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition_queuedDripProgressions | null;
  /**
   * The maximum number of recipients this edition can send to, if DMARC is not
   * fully configured. This is only relevant for non-drip sequence editions.
   */
  recipientLimitForDeliverability: number | null;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  edition: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign_edition;
  description: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
}

export interface RegenerateAiEmailTemplate_aiEmailTemplateRegenerate {
  __typename: "AiEmailTemplateRegeneratePayload";
  /**
   * The campaign that was regenerated
   */
  campaign: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate_campaign;
}

export interface RegenerateAiEmailTemplate {
  /**
   * Regenerates an AI email template for a campaign
   */
  aiEmailTemplateRegenerate: RegenerateAiEmailTemplate_aiEmailTemplateRegenerate;
}

export interface RegenerateAiEmailTemplateVariables {
  input: AiEmailTemplateRegenerateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateCompetitorIqWebsiteSettings
// ====================================================

export interface UpdateCompetitorIqWebsiteSettings_competitorIqWebsitesSettingsSet {
  __typename: "CompetitorIqWebsitesSettingsPayload";
  /**
   * The website to be tracked
   */
  website: string | null;
  /**
   * The competitors to be tracked
   */
  competitors: string[] | null;
}

export interface UpdateCompetitorIqWebsiteSettings {
  /**
   * Sets or updates CompetitorIQ website settings
   */
  competitorIqWebsitesSettingsSet: UpdateCompetitorIqWebsiteSettings_competitorIqWebsitesSettingsSet;
}

export interface UpdateCompetitorIqWebsiteSettingsVariables {
  input: CompetitorIqWebsitesSettingsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCompetitorIqWebsites
// ====================================================

export interface GetCompetitorIqWebsites_competitorIqSettings {
  __typename: "CompetitorIqSettings";
  /**
   * The website we predict belongs to the customer
   */
  predictedWebsite: string | null;
  /**
   * The website to be tracked
   */
  website: string | null;
  /**
   * The competitors to be tracked
   */
  competitors: string[];
}

export interface GetCompetitorIqWebsites {
  /**
   * Returns a list of competitor iq websites.
   */
  competitorIqSettings: GetCompetitorIqWebsites_competitorIqSettings | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAudienceDashboard
// ====================================================

export interface GetAudienceDashboard_audienceDashboard_audiences_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetAudienceDashboard_audienceDashboard_audiences {
  __typename: "AudienceMarketing";
  /**
   * The audience.
   */
  audience: GetAudienceDashboard_audienceDashboard_audiences_audience;
  /**
   * The total audience size in a user-friendly format
   */
  formattedTotal: string;
}

export interface GetAudienceDashboard_audienceDashboard {
  __typename: "AudienceDashboard";
  /**
   * A list of the largest audiences and their marketing stats.
   */
  audiences: GetAudienceDashboard_audienceDashboard_audiences[];
  /**
   * The total number of audiences.
   */
  totalCount: number;
}

export interface GetAudienceDashboard {
  /**
   * A collection of audiences and their marketing stats.
   */
  audienceDashboard: GetAudienceDashboard_audienceDashboard;
}

export interface GetAudienceDashboardVariables {
  input: DashboardInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetConnectedFormsDashboard
// ====================================================

export interface GetConnectedFormsDashboard_connectedFormsDashboard_stat_delta {
  __typename: "Delta";
  /**
   * Which direction the statistic moved over the timespan
   */
  direction: DeltaDirection;
  /**
   * How much a statistic changed percentage wise over the timespan, formatted with a % sign
   */
  percentChange: string;
  /**
   * The text trailing the percentage change describing the timespan the change represents
   */
  timespanSuffix: string | null;
}

export interface GetConnectedFormsDashboard_connectedFormsDashboard_stat {
  __typename: "Stat";
  /**
   * The name of the quantity the statistics represent
   */
  name: string;
  /**
   * The current value of the statistic formatted as a human-readable number
   */
  formattedValue: string;
  /**
   * Details about how a statistic has changed in a given timespan, and by how
   * much. If there is no data for the timespan preceeding this one, returns null.
   */
  delta: GetConnectedFormsDashboard_connectedFormsDashboard_stat_delta | null;
}

export interface GetConnectedFormsDashboard_connectedFormsDashboard_topForms_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetConnectedFormsDashboard_connectedFormsDashboard_topForms {
  __typename: "TopForm";
  /**
   * The form associated with the statistics
   */
  form: GetConnectedFormsDashboard_connectedFormsDashboard_topForms_form;
  /**
   * The number of views the form has received
   */
  views: string;
  /**
   * The number of submissions the form has received
   */
  submissions: string;
}

export interface GetConnectedFormsDashboard_connectedFormsDashboard {
  __typename: "ConnectedFormsDashboard";
  /**
   * The number of submissions and how it changed over the timespan.
   */
  stat: GetConnectedFormsDashboard_connectedFormsDashboard_stat;
  /**
   * The total number of connected forms.
   */
  numForms: number;
  /**
   * The top 3 connected forms by submissions over the timespan.
   */
  topForms: GetConnectedFormsDashboard_connectedFormsDashboard_topForms[];
}

export interface GetConnectedFormsDashboard {
  /**
   * Returns the stats and most submitted forms for the connected forms dashboard card
   */
  connectedFormsDashboard: GetConnectedFormsDashboard_connectedFormsDashboard;
}

export interface GetConnectedFormsDashboardVariables {
  input: DashboardInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDripSequencesDashboard
// ====================================================

export interface GetDripSequencesDashboard_dripsDashboard_stats_delta {
  __typename: "Delta";
  /**
   * Which direction the statistic moved over the timespan
   */
  direction: DeltaDirection;
  /**
   * How much a statistic changed percentage wise over the timespan, formatted with a % sign
   */
  percentChange: string;
  /**
   * The text trailing the percentage change describing the timespan the change represents
   */
  timespanSuffix: string | null;
}

export interface GetDripSequencesDashboard_dripsDashboard_stats {
  __typename: "Stat";
  /**
   * The name of the quantity the statistics represent
   */
  name: string;
  /**
   * The current value of the statistic formatted as a human-readable number
   */
  formattedValue: string;
  /**
   * Details about how a statistic has changed in a given timespan, and by how
   * much. If there is no data for the timespan preceeding this one, returns null.
   */
  delta: GetDripSequencesDashboard_dripsDashboard_stats_delta | null;
}

export interface GetDripSequencesDashboard_dripsDashboard_recentDrips_edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetDripSequencesDashboard_dripsDashboard_recentDrips_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetDripSequencesDashboard_dripsDashboard_recentDrips_edition_campaign;
}

export interface GetDripSequencesDashboard_dripsDashboard_recentDrips {
  __typename: "RecentDrip";
  /**
   * The edition associated with this drip.
   */
  edition: GetDripSequencesDashboard_dripsDashboard_recentDrips_edition;
  /**
   * User-friendly string representation of the number of deliveries
   */
  formattedDeliveries: string;
  /**
   * User-friendly string representation of the open rate
   */
  formattedOpenRate: string;
  /**
   * User-friendly string representation of the click rate
   */
  formattedClickRate: string;
}

export interface GetDripSequencesDashboard_dripsDashboard {
  __typename: "DripsDashboard";
  /**
   * The total number of drip sequences.
   */
  totalCount: number;
  /**
   * The list of key stats and how they’ve changed over the timespan.
   */
  stats: GetDripSequencesDashboard_dripsDashboard_stats[];
  /**
   * The top 9 recently sent drip sequences, sorted by number of deliveries.
   */
  recentDrips: GetDripSequencesDashboard_dripsDashboard_recentDrips[] | null;
}

export interface GetDripSequencesDashboard {
  /**
   * Returns the stats for the Drip sequences card
   */
  dripsDashboard: GetDripSequencesDashboard_dripsDashboard;
}

export interface GetDripSequencesDashboardVariables {
  input: DashboardInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEditionsDashboard
// ====================================================

export interface GetEditionsDashboard_editionsDashboard_stats_delta {
  __typename: "Delta";
  /**
   * Which direction the statistic moved over the timespan
   */
  direction: DeltaDirection;
  /**
   * How much a statistic changed percentage wise over the timespan, formatted with a % sign
   */
  percentChange: string;
  /**
   * The text trailing the percentage change describing the timespan the change represents
   */
  timespanSuffix: string | null;
}

export interface GetEditionsDashboard_editionsDashboard_stats {
  __typename: "Stat";
  /**
   * The name of the quantity the statistics represent
   */
  name: string;
  /**
   * The current value of the statistic formatted as a human-readable number
   */
  formattedValue: string;
  /**
   * Details about how a statistic has changed in a given timespan, and by how
   * much. If there is no data for the timespan preceeding this one, returns null.
   */
  delta: GetEditionsDashboard_editionsDashboard_stats_delta | null;
}

export interface GetEditionsDashboard_editionsDashboard_recentEditions_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEditionsDashboard_editionsDashboard_recentEditions_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetEditionsDashboard_editionsDashboard_recentEditions_audience_membershipStats_totalCount;
  /**
   * String-formatted number of members to display on the frontend.
   */
  totalCountFormatted: string;
}

export interface GetEditionsDashboard_editionsDashboard_recentEditions_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  membershipStats: GetEditionsDashboard_editionsDashboard_recentEditions_audience_membershipStats;
}

export interface GetEditionsDashboard_editionsDashboard_recentEditions_engagementStats {
  __typename: "EngagementStats";
  /**
   * The click rate formatted as a human-readable number
   */
  clickRateFormatted: string;
  /**
   * String-formatted number of deliveries to display on the frontend.
   */
  totalSentCountFormatted: string;
  /**
   * The open rate formatted as a human-readable number
   */
  openRateFormatted: string;
}

export interface GetEditionsDashboard_editionsDashboard_recentEditions {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The audience to send this edition to
   */
  audience: GetEditionsDashboard_editionsDashboard_recentEditions_audience | null;
  engagementStats: GetEditionsDashboard_editionsDashboard_recentEditions_engagementStats;
}

export interface GetEditionsDashboard_editionsDashboard_scheduledEditions {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  scheduledTime: any | null;
}

export interface GetEditionsDashboard_editionsDashboard_draftEditions {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
}

export interface GetEditionsDashboard_editionsDashboard {
  __typename: "EditionsDashboard";
  /**
   * The list of key stats and how they’ve changed over the timespan.
   */
  stats: GetEditionsDashboard_editionsDashboard_stats[];
  /**
   * The top 6 recently sent editions, sorted by number of deliveries.
   */
  recentEditions: GetEditionsDashboard_editionsDashboard_recentEditions[];
  /**
   * The two editions scheduled to be sent the soonest.
   */
  scheduledEditions: GetEditionsDashboard_editionsDashboard_scheduledEditions[];
  /**
   * The two draft editions most recently modified.
   */
  draftEditions: GetEditionsDashboard_editionsDashboard_draftEditions[];
  /**
   * The total number of editions.
   */
  totalCount: number;
}

export interface GetEditionsDashboard {
  /**
   * Returns the stats for the Broadcasts & newsletters card
   */
  editionsDashboard: GetEditionsDashboard_editionsDashboard;
}

export interface GetEditionsDashboardVariables {
  input: DashboardInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetFormsDashboard
// ====================================================

export interface GetFormsDashboard_formsDashboard_stats_delta {
  __typename: "Delta";
  /**
   * Which direction the statistic moved over the timespan
   */
  direction: DeltaDirection;
  /**
   * How much a statistic changed percentage wise over the timespan, formatted with a % sign
   */
  percentChange: string;
  /**
   * The text trailing the percentage change describing the timespan the change represents
   */
  timespanSuffix: string | null;
}

export interface GetFormsDashboard_formsDashboard_stats {
  __typename: "Stat";
  /**
   * The name of the quantity the statistics represent
   */
  name: string;
  /**
   * The current value of the statistic formatted as a human-readable number
   */
  formattedValue: string;
  /**
   * Details about how a statistic has changed in a given timespan, and by how
   * much. If there is no data for the timespan preceeding this one, returns null.
   */
  delta: GetFormsDashboard_formsDashboard_stats_delta | null;
}

export interface GetFormsDashboard_formsDashboard_topForms_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetFormsDashboard_formsDashboard_topForms {
  __typename: "TopForm";
  /**
   * The form associated with the statistics
   */
  form: GetFormsDashboard_formsDashboard_topForms_form;
  /**
   * The number of views the form has received
   */
  views: string;
  /**
   * The number of submissions the form has received
   */
  submissions: string;
}

export interface GetFormsDashboard_formsDashboard {
  __typename: "FormsDashboard";
  /**
   * The list of key stats and how they’ve changed over the timespan.
   */
  stats: GetFormsDashboard_formsDashboard_stats[];
  /**
   * The total number of forms.
   */
  numForms: number;
  /**
   * The top 5 forms by submissions over the timespan.
   */
  topForms: GetFormsDashboard_formsDashboard_topForms[];
}

export interface GetFormsDashboard {
  /**
   * Returns the stats and most submitted forms for the forms dashboard card
   */
  formsDashboard: GetFormsDashboard_formsDashboard;
}

export interface GetFormsDashboardVariables {
  input: DashboardInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLandingPagesDashboard
// ====================================================

export interface GetLandingPagesDashboard_landingPagesDashboard_stat_delta {
  __typename: "Delta";
  /**
   * Which direction the statistic moved over the timespan
   */
  direction: DeltaDirection;
  /**
   * How much a statistic changed percentage wise over the timespan, formatted with a % sign
   */
  percentChange: string;
  /**
   * The text trailing the percentage change describing the timespan the change represents
   */
  timespanSuffix: string | null;
}

export interface GetLandingPagesDashboard_landingPagesDashboard_stat {
  __typename: "Stat";
  /**
   * The name of the quantity the statistics represent
   */
  name: string;
  /**
   * The current value of the statistic formatted as a human-readable number
   */
  formattedValue: string;
  /**
   * Details about how a statistic has changed in a given timespan, and by how
   * much. If there is no data for the timespan preceeding this one, returns null.
   */
  delta: GetLandingPagesDashboard_landingPagesDashboard_stat_delta | null;
}

export interface GetLandingPagesDashboard_landingPagesDashboard_landingPages_page {
  __typename: "Page";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this landing page
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetLandingPagesDashboard_landingPagesDashboard_landingPages {
  __typename: "TopPage";
  /**
   * The page associated with the statistics
   */
  page: GetLandingPagesDashboard_landingPagesDashboard_landingPages_page;
  /**
   * The number of views the form has received
   */
  views: string;
}

export interface GetLandingPagesDashboard_landingPagesDashboard {
  __typename: "LandingPagesDashboard";
  /**
   * The list of key stats and how they’ve changed over the timespan.
   */
  stat: GetLandingPagesDashboard_landingPagesDashboard_stat;
  /**
   * The top landing pages by views over the timespan.
   */
  landingPages: GetLandingPagesDashboard_landingPagesDashboard_landingPages[];
  /**
   * The total number of landing pages.
   */
  numLandingPages: number;
}

export interface GetLandingPagesDashboard {
  /**
   * Returns the stats and most viewed landing pages for the landing pages dashboard card
   */
  landingPagesDashboard: GetLandingPagesDashboard_landingPagesDashboard;
}

export interface GetLandingPagesDashboardVariables {
  input: DashboardInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMarketingDashboardChecklist
// ====================================================

export interface GetMarketingDashboardChecklist_marketingDashboardChecklist_items {
  __typename: "OnboardingChecklistItem";
  /**
   * Completion percentage of all tasks on the onboarding checklist
   */
  key: OnboardingChecklistKey;
  /**
   * Title of the checklist item, i.e. "Create your first contact"
   */
  title: string;
  /**
   * Subtitle of the checklist item
   */
  subtitle: string | null;
  /**
   * The total decimal amount of the monetary value.
   */
  isComplete: boolean;
}

export interface GetMarketingDashboardChecklist_marketingDashboardChecklist {
  __typename: "OnboardingChecklist";
  /**
   * The total decimal amount of the monetary value.
   */
  items: GetMarketingDashboardChecklist_marketingDashboardChecklist_items[];
  /**
   * Completion percentage of all tasks on the onboarding checklist
   */
  percentComplete: number;
  /**
   * Is the checklist displayed to the user, or have they manually hidden it / completed it.
   */
  isAvailable: boolean;
  /**
   * Can the sidebar checklist be removed? We prevent this for new users for a couple days
   */
  canRemove: boolean;
}

export interface GetMarketingDashboardChecklist {
  /**
   * Information about the Marketing dashboard checklist
   */
  marketingDashboardChecklist: GetMarketingDashboardChecklist_marketingDashboardChecklist;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetVIQDashboard
// ====================================================

export interface GetVIQDashboard_viqDashboard_stats_delta {
  __typename: "Delta";
  /**
   * How much a statistic changed percentage wise over the timespan, formatted with a % sign
   */
  percentChange: string;
  /**
   * The text trailing the percentage change describing the timespan the change represents
   */
  timespanSuffix: string | null;
  /**
   * Which direction the statistic moved over the timespan
   */
  direction: DeltaDirection;
}

export interface GetVIQDashboard_viqDashboard_stats {
  __typename: "Stat";
  /**
   * The name of the quantity the statistics represent
   */
  name: string;
  /**
   * The current value of the statistic formatted as a human-readable number
   */
  formattedValue: string;
  /**
   * The previous value of the statistic formatted as a human-readable number
   */
  formattedPreviousValue: string | null;
  /**
   * Details about how a statistic has changed in a given timespan, and by how
   * much. If there is no data for the timespan preceeding this one, returns null.
   */
  delta: GetVIQDashboard_viqDashboard_stats_delta | null;
  /**
   * The human readable format of the timespan the statistic is from
   */
  timespanString: string;
}

export interface GetVIQDashboard_viqDashboard {
  __typename: "VIQDashboard";
  /**
   * The total number of visitors recorded by VisitorIQ
   */
  totalCount: number;
  /**
   * The list of key stats and how they’ve changed over the timespan.
   */
  stats: GetVIQDashboard_viqDashboard_stats[];
  /**
   * The ID of the VIQ origin for leads filtering
   */
  originId: string;
}

export interface GetVIQDashboard {
  /**
   * Returns the deltas for the VIQ card
   */
  viqDashboard: GetVIQDashboard_viqDashboard;
}

export interface GetVIQDashboardVariables {
  input: DashboardInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWebsiteTrafficDashboard
// ====================================================

export interface GetWebsiteTrafficDashboard_websiteTrafficDashboard_stats_delta {
  __typename: "Delta";
  /**
   * Which direction the statistic moved over the timespan
   */
  direction: DeltaDirection;
  /**
   * How much a statistic changed percentage wise over the timespan, formatted with a % sign
   */
  percentChange: string;
  /**
   * The text trailing the percentage change describing the timespan the change represents
   */
  timespanSuffix: string | null;
}

export interface GetWebsiteTrafficDashboard_websiteTrafficDashboard_stats {
  __typename: "Stat";
  /**
   * The name of the quantity the statistics represent
   */
  name: string;
  /**
   * The current value of the statistic formatted as a human-readable number
   */
  formattedValue: string;
  /**
   * Details about how a statistic has changed in a given timespan, and by how
   * much. If there is no data for the timespan preceeding this one, returns null.
   */
  delta: GetWebsiteTrafficDashboard_websiteTrafficDashboard_stats_delta | null;
}

export interface GetWebsiteTrafficDashboard_websiteTrafficDashboard {
  __typename: "WebsiteTrafficDashboard";
  /**
   * The list of key stats and how they’ve changed over the timespan.
   */
  stats: GetWebsiteTrafficDashboard_websiteTrafficDashboard_stats[];
}

export interface GetWebsiteTrafficDashboard {
  /**
   * Returns the stats for website traffic
   */
  websiteTrafficDashboard: GetWebsiteTrafficDashboard_websiteTrafficDashboard;
}

export interface GetWebsiteTrafficDashboardVariables {
  input: DashboardInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DripSequenceActivate
// ====================================================

export interface DripSequenceActivate_dripSequenceActivate_dripSequence {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DripSequenceActivate_dripSequenceActivate {
  __typename: "DripSequenceActivatePayload";
  /**
   * The newly created drip sequence
   */
  dripSequence: DripSequenceActivate_dripSequenceActivate_dripSequence;
}

export interface DripSequenceActivate {
  /**
   * Activate a new email marketing drip sequence
   */
  dripSequenceActivate: DripSequenceActivate_dripSequenceActivate | null;
}

export interface DripSequenceActivateVariables {
  input: DripSequenceActivateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CancelDripSequence
// ====================================================

export interface CancelDripSequence_dripSequenceCancel_dripSequence {
  __typename: "Campaign" | "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CancelDripSequence_dripSequenceCancel {
  __typename: "DripSequenceCancelPayload";
  /**
   * The canceled drip sequence
   */
  dripSequence: CancelDripSequence_dripSequenceCancel_dripSequence;
}

export interface CancelDripSequence {
  /**
   * Cancel an email marketing drip sequence
   */
  dripSequenceCancel: CancelDripSequence_dripSequenceCancel | null;
}

export interface CancelDripSequenceVariables {
  input: DripSequenceCancelInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: PauseDripSequence
// ====================================================

export interface PauseDripSequence_dripSequencePause_dripSequence {
  __typename: "Campaign" | "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface PauseDripSequence_dripSequencePause {
  __typename: "DripSequencePausePayload";
  /**
   * The paused drip sequence
   */
  dripSequence: PauseDripSequence_dripSequencePause_dripSequence;
}

export interface PauseDripSequence {
  /**
   * Pause an email marketing drip sequence
   */
  dripSequencePause: PauseDripSequence_dripSequencePause | null;
}

export interface PauseDripSequenceVariables {
  input: DripSequencePauseInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RetireDripSequence
// ====================================================

export interface RetireDripSequence_dripSequenceRetire_dripSequence {
  __typename: "Campaign" | "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface RetireDripSequence_dripSequenceRetire {
  __typename: "DripSequenceRetirePayload";
  /**
   * The retire drip sequence
   */
  dripSequence: RetireDripSequence_dripSequenceRetire_dripSequence;
}

export interface RetireDripSequence {
  /**
   * Retire an email marketing drip sequence
   */
  dripSequenceRetire: RetireDripSequence_dripSequenceRetire | null;
}

export interface RetireDripSequenceVariables {
  input: DripSequenceRetireInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UnpauseDripSequence
// ====================================================

export interface UnpauseDripSequence_dripSequenceUnpause_dripSequence {
  __typename: "Campaign" | "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UnpauseDripSequence_dripSequenceUnpause {
  __typename: "DripSequenceUnpausePayload";
  /**
   * The unpaused drip sequence
   */
  dripSequence: UnpauseDripSequence_dripSequenceUnpause_dripSequence;
}

export interface UnpauseDripSequence {
  /**
   * Unpause an email marketing drip sequence
   */
  dripSequenceUnpause: UnpauseDripSequence_dripSequenceUnpause | null;
}

export interface UnpauseDripSequenceVariables {
  input: DripSequenceUnpauseInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DripSequenceGoalSet
// ====================================================

export interface DripSequenceGoalSet_dripSequenceGoalSet_campaign {
  __typename: "Campaign" | "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DripSequenceGoalSet_dripSequenceGoalSet {
  __typename: "DripSequenceGoalSetPayload";
  /**
   * The newly updated Nutshell campaign
   */
  campaign: DripSequenceGoalSet_dripSequenceGoalSet_campaign;
}

export interface DripSequenceGoalSet {
  /**
   * Sets a dripSequenceGoal for a given drip sequence.
   */
  dripSequenceGoalSet: DripSequenceGoalSet_dripSequenceGoalSet;
}

export interface DripSequenceGoalSetVariables {
  input: DripSequenceGoalSetInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DripSequenceStartTriggerSet
// ====================================================

export interface DripSequenceStartTriggerSet_startTriggerSet_campaign {
  __typename: "Campaign" | "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DripSequenceStartTriggerSet_startTriggerSet {
  __typename: "StartTriggerSetPayload";
  /**
   * The newly updated Nutshell campaign
   */
  campaign: DripSequenceStartTriggerSet_startTriggerSet_campaign;
}

export interface DripSequenceStartTriggerSet {
  /**
   * Sets a startTrigger for a given drip sequence.
   */
  startTriggerSet: DripSequenceStartTriggerSet_startTriggerSet;
}

export interface DripSequenceStartTriggerSetVariables {
  input: StartTriggerSetInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MigrateSmartSequence
// ====================================================

export interface MigrateSmartSequence_smartSequenceMigrate_smartSequence {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface MigrateSmartSequence_smartSequenceMigrate_migratedCampaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
}

export interface MigrateSmartSequence_smartSequenceMigrate {
  __typename: "SmartSequenceMigratePayload";
  /**
   * The smart sequence that was migrated
   */
  smartSequence: MigrateSmartSequence_smartSequenceMigrate_smartSequence;
  /**
   * The underlying campaign after migration, for updating drip sequence Apollo cache entries
   */
  migratedCampaign: MigrateSmartSequence_smartSequenceMigrate_migratedCampaign;
}

export interface MigrateSmartSequence {
  /**
   * Turns a drip sequence into a smart sequence
   */
  smartSequenceMigrate: MigrateSmartSequence_smartSequenceMigrate;
}

export interface MigrateSmartSequenceVariables {
  input: SmartSequenceMigrateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEditionsThatWillSendImmediatelyWithDelayChange
// ====================================================

export interface GetEditionsThatWillSendImmediatelyWithDelayChange {
  /**
   * Returns the number of emails that would send immediately if the delay for a drip edition was changed.
   */
  dripEditionsThatWillSendImmediatelyWithDelayChange: number;
}

export interface GetEditionsThatWillSendImmediatelyWithDelayChangeVariables {
  editionId: string;
  delay?: TimespanInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMessageBody
// ====================================================

export interface GetMessageBody_materializedEmailTemplate_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetMessageBody_materializedEmailTemplate_entity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMessageBody_materializedEmailTemplate {
  __typename: "MaterializedEmailTemplate";
  /**
   * Materialized body of this email template, meaning {firstName} would be returned as Chris.
   */
  body: string;
  /**
   * Underlying non-materialized version of this email template, for accessing the raw field data.
   */
  emailTemplate: GetMessageBody_materializedEmailTemplate_emailTemplate;
  /**
   * Model associated with this materialized email template.
   */
  entity: GetMessageBody_materializedEmailTemplate_entity;
}

export interface GetMessageBody {
  /**
   * Materialized email template with entity-relevant information
   */
  materializedEmailTemplate: GetMessageBody_materializedEmailTemplate;
}

export interface GetMessageBodyVariables {
  emailTemplateId: string;
  entityId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CancelDripSequenceForAllEntities
// ====================================================

export interface CancelDripSequenceForAllEntities_deleteAllProgressionsForDripEdition_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CancelDripSequenceForAllEntities_deleteAllProgressionsForDripEdition {
  __typename: "DeleteAllProgressionsForDripEditionPayload";
  /**
   * The edition that no longer has recipients
   */
  edition: CancelDripSequenceForAllEntities_deleteAllProgressionsForDripEdition_edition;
}

export interface CancelDripSequenceForAllEntities {
  /**
   * Stops a drip sequence for all contacts.
   */
  deleteAllProgressionsForDripEdition: CancelDripSequenceForAllEntities_deleteAllProgressionsForDripEdition;
}

export interface CancelDripSequenceForAllEntitiesVariables {
  deleteAllProgressionsForDripEditionInput: DeleteAllProgressionsForDripEditionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CancelDripSequenceForEntity
// ====================================================

export interface CancelDripSequenceForEntity_dripProgressionDelete_dripProgression {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CancelDripSequenceForEntity_dripProgressionDelete {
  __typename: "DripProgressionDeletePayload";
  /**
   * The stopped drip progression model
   */
  dripProgression: CancelDripSequenceForEntity_dripProgressionDelete_dripProgression;
}

export interface CancelDripSequenceForEntity {
  /**
   * Stops a drip sequence for a contact.
   */
  dripProgressionDelete: CancelDripSequenceForEntity_dripProgressionDelete;
}

export interface CancelDripSequenceForEntityVariables {
  dripProgressionDeleteInput: DripProgressionDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDripProgressions
// ====================================================

export interface GetDripProgressions_edition_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetDripProgressions_edition_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetDripProgressions_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetDripProgressions_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface GetDripProgressions_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetDripProgressions_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface GetDripProgressions_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetDripProgressions_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface GetDripProgressions_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetDripProgressions_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetDripProgressions_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface GetDripProgressions_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetDripProgressions_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetDripProgressions_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type GetDripProgressions_edition_queuedDripProgressions_edges_node_audienceMember_entity = GetDripProgressions_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account | GetDripProgressions_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface GetDripProgressions_edition_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: GetDripProgressions_edition_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: GetDripProgressions_edition_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface GetDripProgressions_edition_queuedDripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: GetDripProgressions_edition_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface GetDripProgressions_edition_queuedDripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: GetDripProgressions_edition_queuedDripProgressions_edges_node;
}

export interface GetDripProgressions_edition_queuedDripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetDripProgressions_edition_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetDripProgressions_edition_queuedDripProgressions_edges[];
}

export interface GetDripProgressions_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: GetDripProgressions_edition_queuedDripProgressions | null;
}

export interface GetDripProgressions {
  /**
   * Returns an email marketing edition.
   */
  edition: GetDripProgressions_edition | null;
}

export interface GetDripProgressionsVariables {
  editionId: string;
  first: number;
  after?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CopyContentToEdition
// ====================================================

export interface CopyContentToEdition_editionCopyContentToEdition_toEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface CopyContentToEdition_editionCopyContentToEdition_toEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: CopyContentToEdition_editionCopyContentToEdition_toEdition_emailTemplate_links_url | null;
}

export interface CopyContentToEdition_editionCopyContentToEdition_toEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: CopyContentToEdition_editionCopyContentToEdition_toEdition_emailTemplate_links[];
}

export interface CopyContentToEdition_editionCopyContentToEdition_toEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: CopyContentToEdition_editionCopyContentToEdition_toEdition_emailTemplate | null;
}

export interface CopyContentToEdition_editionCopyContentToEdition {
  __typename: "EditionCopyContentToEditionPayload";
  /**
   * The edition that the body content was copied to
   */
  toEdition: CopyContentToEdition_editionCopyContentToEdition_toEdition;
}

export interface CopyContentToEdition {
  /**
   * Copies the body content from one edition to another
   */
  editionCopyContentToEdition: CopyContentToEdition_editionCopyContentToEdition;
}

export interface CopyContentToEditionVariables {
  input: EditionCopyContentToEditionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ToggleComparison
// ====================================================

export interface ToggleComparison_comparisonToggle_edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface ToggleComparison_comparisonToggle_edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface ToggleComparison_comparisonToggle_edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: ToggleComparison_comparisonToggle_edition_comparison_winnerEdition_emailTemplate | null;
}

export interface ToggleComparison_comparisonToggle_edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface ToggleComparison_comparisonToggle_edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ToggleComparison_comparisonToggle_edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: ToggleComparison_comparisonToggle_edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: ToggleComparison_comparisonToggle_edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: ToggleComparison_comparisonToggle_edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: ToggleComparison_comparisonToggle_edition_comparison_winningEdition | null;
}

export interface ToggleComparison_comparisonToggle_edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface ToggleComparison_comparisonToggle_edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: ToggleComparison_comparisonToggle_edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface ToggleComparison_comparisonToggle_edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: ToggleComparison_comparisonToggle_edition_comparisonEdition_emailTemplate_links[];
}

export interface ToggleComparison_comparisonToggle_edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: ToggleComparison_comparisonToggle_edition_comparisonEdition_emailTemplate | null;
}

export interface ToggleComparison_comparisonToggle_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparison: ToggleComparison_comparisonToggle_edition_comparison | null;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: ToggleComparison_comparisonToggle_edition_comparisonEdition | null;
}

export interface ToggleComparison_comparisonToggle {
  __typename: "ComparisonTogglePayload";
  /**
   * The edition that was updated
   */
  edition: ToggleComparison_comparisonToggle_edition;
}

export interface ToggleComparison {
  /**
   * Toggles an edition between comparison and non-comparison
   */
  comparisonToggle: ToggleComparison_comparisonToggle | null;
}

export interface ToggleComparisonVariables {
  input: ComparisonToggleInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SyncMcfxAudience
// ====================================================

export interface SyncMcfxAudience_mcfxAudienceSyncInApp_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface SyncMcfxAudience_mcfxAudienceSyncInApp_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: SyncMcfxAudience_mcfxAudienceSyncInApp_membershipStats_totalCount;
}

export interface SyncMcfxAudience_mcfxAudienceSyncInApp {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The audience name
   */
  name: string;
  /**
   * Is this audience on the preference center?
   */
  isPublic: boolean;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  membershipStats: SyncMcfxAudience_mcfxAudienceSyncInApp_membershipStats;
}

export interface SyncMcfxAudience {
  /**
   * Syncs an Mcfx audience into Nutshell (started from within Nutshell)
   */
  mcfxAudienceSyncInApp: SyncMcfxAudience_mcfxAudienceSyncInApp;
}

export interface SyncMcfxAudienceVariables {
  input: McfxAudienceSyncInAppInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllMembershipStatsForAudience
// ====================================================

export interface GetAllMembershipStatsForAudience_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetAllMembershipStatsForAudience_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetAllMembershipStatsForAudience_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface GetAllMembershipStatsForAudience_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetAllMembershipStatsForAudience_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetAllMembershipStatsForAudience_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface GetAllMembershipStatsForAudience_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  membershipStats: GetAllMembershipStatsForAudience_audience_membershipStats;
  smsMembershipStats: GetAllMembershipStatsForAudience_audience_smsMembershipStats;
}

export interface GetAllMembershipStatsForAudience {
  /**
   * Returns an email marketing audience.
   */
  audience: GetAllMembershipStatsForAudience_audience;
}

export interface GetAllMembershipStatsForAudienceVariables {
  audienceId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMcfxAudiencesFromApi
// ====================================================

export interface GetMcfxAudiencesFromApi_mcfxAudiencesViaApi {
  __typename: "McfxApiAudience";
  /**
   * How long the specific page visit lasted.
   */
  externalId: string;
  /**
   * How name of this MCFX audience.
   */
  name: string;
  /**
   * Category for audience (forms, campaigns, etc) – not shown in UI.
   */
  category: string | null;
  /**
   * How many members there are currently in this audience.
   */
  size: number;
}

export interface GetMcfxAudiencesFromApi {
  /**
   * Returns an array of mcfx audiences via their API
   */
  mcfxAudiencesViaApi: GetMcfxAudiencesFromApi_mcfxAudiencesViaApi[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetClickNotification
// ====================================================

export interface SetClickNotification_clickNotificationSet_link {
  __typename: "EmailTemplateLink";
  link: string;
}

export interface SetClickNotification_clickNotificationSet {
  __typename: "ClickNotificationSetPayload";
  /**
   * The updated TemplateLink
   */
  link: SetClickNotification_clickNotificationSet_link | null;
}

export interface SetClickNotification {
  /**
   * Set notifiables for click tracking.
   */
  clickNotificationSet: SetClickNotification_clickNotificationSet | null;
}

export interface SetClickNotificationVariables {
  input: ClickNotificationSetInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEditionStatus
// ====================================================

export interface GetEditionStatus_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
}

export interface GetEditionStatus {
  /**
   * Returns an email marketing edition.
   */
  edition: GetEditionStatus_edition | null;
}

export interface GetEditionStatusVariables {
  editionId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEmailTemplateLinkEngagementStats
// ====================================================

export interface GetEmailTemplateLinkEngagementStats_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetEmailTemplateLinkEngagementStats_emailTemplate_links_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEmailTemplateLinkEngagementStats_emailTemplate_links_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
  /**
   * Specific type of alias
   */
  type: NotifiableAliasType;
}

export type GetEmailTemplateLinkEngagementStats_emailTemplate_links_notifiables = GetEmailTemplateLinkEngagementStats_emailTemplate_links_notifiables_User | GetEmailTemplateLinkEngagementStats_emailTemplate_links_notifiables_NotifiableAlias;

export interface GetEmailTemplateLinkEngagementStats_emailTemplate_links {
  __typename: "EmailTemplateLink";
  link: string;
  url: GetEmailTemplateLinkEngagementStats_emailTemplate_links_url | null;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
  notifiables: GetEmailTemplateLinkEngagementStats_emailTemplate_links_notifiables[];
}

export interface GetEmailTemplateLinkEngagementStats_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * All links in this email template
   */
  links: GetEmailTemplateLinkEngagementStats_emailTemplate_links[];
}

export interface GetEmailTemplateLinkEngagementStats {
  /**
   * Single email template by id
   */
  emailTemplate: GetEmailTemplateLinkEngagementStats_emailTemplate;
}

export interface GetEmailTemplateLinkEngagementStatsVariables {
  emailTemplateId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CampaignSetOwner
// ====================================================

export interface CampaignSetOwner_campaignSetOwner_campaign_SmsCampaign {
  __typename: "SmsCampaign";
}

export interface CampaignSetOwner_campaignSetOwner_campaign_Campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CampaignSetOwner_campaignSetOwner_campaign_Campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CampaignSetOwner_campaignSetOwner_campaign_Campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface CampaignSetOwner_campaignSetOwner_campaign_Campaign_edition_from_emailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface CampaignSetOwner_campaignSetOwner_campaign_Campaign_edition_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface CampaignSetOwner_campaignSetOwner_campaign_Campaign_edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: CampaignSetOwner_campaignSetOwner_campaign_Campaign_edition_from_emailAddress;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: CampaignSetOwner_campaignSetOwner_campaign_Campaign_edition_from_fromDomain | null;
}

export interface CampaignSetOwner_campaignSetOwner_campaign_Campaign_edition_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface CampaignSetOwner_campaignSetOwner_campaign_Campaign_edition_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: CampaignSetOwner_campaignSetOwner_campaign_Campaign_edition_audience_fromSavedFilter_count;
}

export interface CampaignSetOwner_campaignSetOwner_campaign_Campaign_edition_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface CampaignSetOwner_campaignSetOwner_campaign_Campaign_edition_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: CampaignSetOwner_campaignSetOwner_campaign_Campaign_edition_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface CampaignSetOwner_campaignSetOwner_campaign_Campaign_edition_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface CampaignSetOwner_campaignSetOwner_campaign_Campaign_edition_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: CampaignSetOwner_campaignSetOwner_campaign_Campaign_edition_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface CampaignSetOwner_campaignSetOwner_campaign_Campaign_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: CampaignSetOwner_campaignSetOwner_campaign_Campaign_edition_audience_fromSavedFilter | null;
  membershipStats: CampaignSetOwner_campaignSetOwner_campaign_Campaign_edition_audience_membershipStats;
  smsMembershipStats: CampaignSetOwner_campaignSetOwner_campaign_Campaign_edition_audience_smsMembershipStats;
}

export interface CampaignSetOwner_campaignSetOwner_campaign_Campaign_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The address to send this edition from
   */
  from: CampaignSetOwner_campaignSetOwner_campaign_Campaign_edition_from | null;
  /**
   * The audience to send this edition to
   */
  audience: CampaignSetOwner_campaignSetOwner_campaign_Campaign_edition_audience | null;
}

export interface CampaignSetOwner_campaignSetOwner_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: CampaignSetOwner_campaignSetOwner_campaign_Campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: CampaignSetOwner_campaignSetOwner_campaign_Campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: CampaignSetOwner_campaignSetOwner_campaign_Campaign_nextSendingEdition | null;
  edition: CampaignSetOwner_campaignSetOwner_campaign_Campaign_edition;
}

export type CampaignSetOwner_campaignSetOwner_campaign = CampaignSetOwner_campaignSetOwner_campaign_SmsCampaign | CampaignSetOwner_campaignSetOwner_campaign_Campaign;

export interface CampaignSetOwner_campaignSetOwner {
  __typename: "CampaignSetOwnerPayload";
  /**
   * The campaign
   */
  campaign: CampaignSetOwner_campaignSetOwner_campaign;
}

export interface CampaignSetOwner {
  /**
   * Sets the owner of a campaign. If the user is null, it will unassign the current owner.
   */
  campaignSetOwner: CampaignSetOwner_campaignSetOwner | null;
}

export interface CampaignSetOwnerVariables {
  input: CampaignSetOwnerInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditionTestEmailSend
// ====================================================

export interface EditionTestEmailSend_editionTestEmailSend {
  __typename: "EditionTestEmailSendPayload";
  /**
   * The number of test emails sent
   */
  count: number;
}

export interface EditionTestEmailSend {
  /**
   * Send test emails for an edition
   */
  editionTestEmailSend: EditionTestEmailSend_editionTestEmailSend | null;
}

export interface EditionTestEmailSendVariables {
  input: EditionTestEmailSendInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEditionEngagementStats
// ====================================================

export interface GetEditionEngagementStats_edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
}

export interface GetEditionEngagementStats_edition_comparisonEdition_comparisonPeriodEngagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
}

export interface GetEditionEngagementStats_edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The engagement stats for the duration of a comparison test
   */
  comparisonPeriodEngagementStats: GetEditionEngagementStats_edition_comparisonEdition_comparisonPeriodEngagementStats | null;
}

export interface GetEditionEngagementStats_edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEditionEngagementStats_edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
}

export interface GetEditionEngagementStats_edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEditionEngagementStats_edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  winningMetric: ComparisonMetricType;
  /**
   * The winning edition
   */
  winnerEdition: GetEditionEngagementStats_edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: GetEditionEngagementStats_edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: GetEditionEngagementStats_edition_comparison_winningEdition | null;
  /**
   * The percent of the test that is complete
   */
  percentComplete: number;
  /**
   * The number of minutes remaining in the test
   */
  minutesRemaining: number | null;
  /**
   * Indicates whether the comparison is tied
   */
  isTied: boolean;
}

export interface GetEditionEngagementStats_edition_comparisonPeriodEngagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
}

export interface GetEditionEngagementStats_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  engagementStats: GetEditionEngagementStats_edition_engagementStats;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: GetEditionEngagementStats_edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: GetEditionEngagementStats_edition_comparison | null;
  /**
   * The engagement stats for the duration of a comparison test
   */
  comparisonPeriodEngagementStats: GetEditionEngagementStats_edition_comparisonPeriodEngagementStats | null;
}

export interface GetEditionEngagementStats {
  /**
   * Returns an email marketing edition.
   */
  edition: GetEditionEngagementStats_edition | null;
}

export interface GetEditionEngagementStatsVariables {
  editionId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEditionStarters
// ====================================================

export interface GetEditionStarters_editionStarters {
  __typename: "EditionStarter";
  /**
   * The id of the edition starter
   */
  id: string;
  /**
   * The name of the edition starter
   */
  name: string;
  /**
   * Edition starter thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The DateTime that represents when the edition starter was created
   */
  createdTime: any;
  /**
   * The status for this edition starter
   */
  status: EditionStatus;
  /**
   * The id of the associated starter campaign, only used for bucketing templates together
   */
  campaignId: string;
  /**
   * The name of the associated campaign
   */
  campaignName: string;
  /**
   * The description of the associated campaign
   */
  campaignDescription: string | null;
  /**
   * The background color of this edition starter
   */
  backgroundColor: string;
}

export interface GetEditionStarters {
  /**
   * Returns edition starter templates.
   */
  editionStarters: GetEditionStarters_editionStarters[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRecentEditions
// ====================================================

export interface GetRecentEditions_recentEditions_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
}

export interface GetRecentEditions_recentEditions_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetRecentEditions_recentEditions_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetRecentEditions_recentEditions_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The user who owns this campaign
   */
  owner: GetRecentEditions_recentEditions_campaign_owner | null;
}

export interface GetRecentEditions_recentEditions {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  sendTime: any | null;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetRecentEditions_recentEditions_emailTemplate | null;
  /**
   * The comparison test for this edition
   */
  comparison: GetRecentEditions_recentEditions_comparison | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetRecentEditions_recentEditions_campaign;
}

export interface GetRecentEditions {
  /**
   * Returns 20 recent editions.
   */
  recentEditions: GetRecentEditions_recentEditions[];
}

export interface GetRecentEditionsVariables {
  limit: number;
  dripSequenceId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRecentUserTemplates
// ====================================================

export interface GetRecentUserTemplates_recentUserTemplates_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
}

export interface GetRecentUserTemplates_recentUserTemplates_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetRecentUserTemplates_recentUserTemplates_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The user who owns this campaign
   */
  owner: GetRecentUserTemplates_recentUserTemplates_campaign_owner | null;
}

export interface GetRecentUserTemplates_recentUserTemplates {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetRecentUserTemplates_recentUserTemplates_emailTemplate | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetRecentUserTemplates_recentUserTemplates_campaign;
}

export interface GetRecentUserTemplates {
  /**
   * Returns 20 recent user-created templates.
   */
  recentUserTemplates: GetRecentUserTemplates_recentUserTemplates[];
}

export interface GetRecentUserTemplatesVariables {
  limit: number;
  status: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTemplates
// ====================================================

export interface GetTemplates_templates_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetTemplates_templates_edges_node_edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetTemplates_templates_edges_node_edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetTemplates_templates_edges_node_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetTemplates_templates_edges_node_edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetTemplates_templates_edges_node_edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: GetTemplates_templates_edges_node_edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: GetTemplates_templates_edges_node_edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: GetTemplates_templates_edges_node_edition_campaign_nextSendingEdition | null;
}

export interface GetTemplates_templates_edges_node_edition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetTemplates_templates_edges_node_edition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: GetTemplates_templates_edges_node_edition_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface GetTemplates_templates_edges_node_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: GetTemplates_templates_edges_node_edition_emailTemplate_links[];
}

export interface GetTemplates_templates_edges_node_edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface GetTemplates_templates_edges_node_edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetTemplates_templates_edges_node_edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: GetTemplates_templates_edges_node_edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface GetTemplates_templates_edges_node_edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: GetTemplates_templates_edges_node_edition_comparisonEdition_emailTemplate_links[];
}

export interface GetTemplates_templates_edges_node_edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: GetTemplates_templates_edges_node_edition_comparisonEdition_emailTemplate | null;
}

export interface GetTemplates_templates_edges_node_edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetTemplates_templates_edges_node_edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface GetTemplates_templates_edges_node_edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetTemplates_templates_edges_node_edition_comparison_winnerEdition_emailTemplate | null;
}

export interface GetTemplates_templates_edges_node_edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface GetTemplates_templates_edges_node_edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetTemplates_templates_edges_node_edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: GetTemplates_templates_edges_node_edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: GetTemplates_templates_edges_node_edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: GetTemplates_templates_edges_node_edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: GetTemplates_templates_edges_node_edition_comparison_winningEdition | null;
}

export interface GetTemplates_templates_edges_node_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetTemplates_templates_edges_node_edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
}

export interface GetTemplates_templates_edges_node_edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: GetTemplates_templates_edges_node_edition_from_emailAddress;
}

export interface GetTemplates_templates_edges_node_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetTemplates_templates_edges_node_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: GetTemplates_templates_edges_node_edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetTemplates_templates_edges_node_edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: GetTemplates_templates_edges_node_edition_emailTemplate | null;
  engagementStats: GetTemplates_templates_edges_node_edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: GetTemplates_templates_edges_node_edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: GetTemplates_templates_edges_node_edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: GetTemplates_templates_edges_node_edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: GetTemplates_templates_edges_node_edition_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: GetTemplates_templates_edges_node_edition_delay | null;
}

export interface GetTemplates_templates_edges_node {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  edition: GetTemplates_templates_edges_node_edition;
}

export interface GetTemplates_templates_edges {
  __typename: "CampaignsEdge";
  cursor: string;
  node: GetTemplates_templates_edges_node;
}

export interface GetTemplates_templates {
  __typename: "CampaignsConnection";
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetTemplates_templates_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetTemplates_templates_edges[];
}

export interface GetTemplates {
  /**
   * Returns a paging connection of email templates from the root of our query.
   */
  templates: GetTemplates_templates;
}

export interface GetTemplatesVariables {
  archived: boolean;
  sort: BroadcastSortType;
  search?: string | null;
  statuses?: CampaignStatus[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ScheduleEdition
// ====================================================

export interface ScheduleEdition_editionSchedule_edition_SmsEdition {
  __typename: "SmsEdition";
}

export interface ScheduleEdition_editionSchedule_edition_Edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: ScheduleEdition_editionSchedule_edition_Edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: ScheduleEdition_editionSchedule_edition_Edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: ScheduleEdition_editionSchedule_edition_Edition_campaign_nextSendingEdition | null;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: ScheduleEdition_editionSchedule_edition_Edition_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: ScheduleEdition_editionSchedule_edition_Edition_emailTemplate_links[];
  name: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: ScheduleEdition_editionSchedule_edition_Edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: ScheduleEdition_editionSchedule_edition_Edition_comparisonEdition_emailTemplate_links[];
}

export interface ScheduleEdition_editionSchedule_edition_Edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: ScheduleEdition_editionSchedule_edition_Edition_comparisonEdition_emailTemplate | null;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: ScheduleEdition_editionSchedule_edition_Edition_comparison_winnerEdition_emailTemplate | null;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: ScheduleEdition_editionSchedule_edition_Edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: ScheduleEdition_editionSchedule_edition_Edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: ScheduleEdition_editionSchedule_edition_Edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: ScheduleEdition_editionSchedule_edition_Edition_comparison_winningEdition | null;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: ScheduleEdition_editionSchedule_edition_Edition_audience_fromSavedFilter_count;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: ScheduleEdition_editionSchedule_edition_Edition_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: ScheduleEdition_editionSchedule_edition_Edition_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: ScheduleEdition_editionSchedule_edition_Edition_audience_fromSavedFilter | null;
  membershipStats: ScheduleEdition_editionSchedule_edition_Edition_audience_membershipStats;
  smsMembershipStats: ScheduleEdition_editionSchedule_edition_Edition_audience_smsMembershipStats;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: ScheduleEdition_editionSchedule_edition_Edition_from_emailAddress;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: ScheduleEdition_editionSchedule_edition_Edition_from_fromDomain | null;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_gateError {
  __typename: "GateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity = ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Account | ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges_node;
}

export interface ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions_edges[];
}

export interface ScheduleEdition_editionSchedule_edition_Edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: ScheduleEdition_editionSchedule_edition_Edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: ScheduleEdition_editionSchedule_edition_Edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: ScheduleEdition_editionSchedule_edition_Edition_emailTemplate | null;
  engagementStats: ScheduleEdition_editionSchedule_edition_Edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: ScheduleEdition_editionSchedule_edition_Edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: ScheduleEdition_editionSchedule_edition_Edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: ScheduleEdition_editionSchedule_edition_Edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: ScheduleEdition_editionSchedule_edition_Edition_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: ScheduleEdition_editionSchedule_edition_Edition_delay | null;
  /**
   * The number of emails sent for this edition
   */
  numSentEmails: number;
  /**
   * The custom click domain that this edition will use to track links, if there is one
   */
  customClickDomain: ScheduleEdition_editionSchedule_edition_Edition_customClickDomain | null;
  utmParameters: ScheduleEdition_editionSchedule_edition_Edition_utmParameters;
  defaultUtmParameters: ScheduleEdition_editionSchedule_edition_Edition_defaultUtmParameters;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  useUtmParameters: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: ScheduleEdition_editionSchedule_edition_Edition_gateError | null;
  /**
   * Boolean indicating if the edition is using a web font.
   */
  hasWebFonts: boolean;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: ScheduleEdition_editionSchedule_edition_Edition_queuedDripProgressions | null;
  /**
   * The maximum number of recipients this edition can send to, if DMARC is not
   * fully configured. This is only relevant for non-drip sequence editions.
   */
  recipientLimitForDeliverability: number | null;
}

export type ScheduleEdition_editionSchedule_edition = ScheduleEdition_editionSchedule_edition_SmsEdition | ScheduleEdition_editionSchedule_edition_Edition;

export interface ScheduleEdition_editionSchedule {
  __typename: "EditionSchedulePayload";
  /**
   * The edition
   */
  edition: ScheduleEdition_editionSchedule_edition;
}

export interface ScheduleEdition {
  /**
   * Schedule an edition for sending.
   */
  editionSchedule: ScheduleEdition_editionSchedule | null;
}

export interface ScheduleEditionVariables {
  edition: EditionScheduleInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendEditionToFilteredList
// ====================================================

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_SmsEdition {
  __typename: "SmsEdition";
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_campaign_nextSendingEdition | null;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_emailTemplate_links[];
  name: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_comparisonEdition_emailTemplate_links[];
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_comparisonEdition_emailTemplate | null;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_comparison_winnerEdition_emailTemplate | null;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_comparison_winningEdition | null;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_audience_fromSavedFilter_count;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_audience_fromSavedFilter | null;
  membershipStats: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_audience_membershipStats;
  smsMembershipStats: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_audience_smsMembershipStats;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_from_emailAddress;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_from_fromDomain | null;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_gateError {
  __typename: "GateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity = SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Account | SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node;
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges[];
}

export interface SendEditionToFilteredList_editionSendToFilteredList_edition_Edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_emailTemplate | null;
  engagementStats: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_delay | null;
  /**
   * The number of emails sent for this edition
   */
  numSentEmails: number;
  /**
   * The custom click domain that this edition will use to track links, if there is one
   */
  customClickDomain: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_customClickDomain | null;
  utmParameters: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_utmParameters;
  defaultUtmParameters: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_defaultUtmParameters;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  useUtmParameters: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_gateError | null;
  /**
   * Boolean indicating if the edition is using a web font.
   */
  hasWebFonts: boolean;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: SendEditionToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions | null;
  /**
   * The maximum number of recipients this edition can send to, if DMARC is not
   * fully configured. This is only relevant for non-drip sequence editions.
   */
  recipientLimitForDeliverability: number | null;
}

export type SendEditionToFilteredList_editionSendToFilteredList_edition = SendEditionToFilteredList_editionSendToFilteredList_edition_SmsEdition | SendEditionToFilteredList_editionSendToFilteredList_edition_Edition;

export interface SendEditionToFilteredList_editionSendToFilteredList {
  __typename: "EditionSendToFilteredListPayload";
  /**
   * The edition
   */
  edition: SendEditionToFilteredList_editionSendToFilteredList_edition;
}

export interface SendEditionToFilteredList {
  /**
   * Send an edition to a filtered list of people.
   */
  editionSendToFilteredList: SendEditionToFilteredList_editionSendToFilteredList | null;
}

export interface SendEditionToFilteredListVariables {
  input: EditionSendToFilteredListInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendEdition
// ====================================================

export interface SendEdition_editionSend_edition_SmsEdition {
  __typename: "SmsEdition";
}

export interface SendEdition_editionSend_edition_Edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SendEdition_editionSend_edition_Edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SendEdition_editionSend_edition_Edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SendEdition_editionSend_edition_Edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SendEdition_editionSend_edition_Edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: SendEdition_editionSend_edition_Edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: SendEdition_editionSend_edition_Edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: SendEdition_editionSend_edition_Edition_campaign_nextSendingEdition | null;
}

export interface SendEdition_editionSend_edition_Edition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface SendEdition_editionSend_edition_Edition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: SendEdition_editionSend_edition_Edition_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface SendEdition_editionSend_edition_Edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: SendEdition_editionSend_edition_Edition_emailTemplate_links[];
  name: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface SendEdition_editionSend_edition_Edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface SendEdition_editionSend_edition_Edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface SendEdition_editionSend_edition_Edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: SendEdition_editionSend_edition_Edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface SendEdition_editionSend_edition_Edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: SendEdition_editionSend_edition_Edition_comparisonEdition_emailTemplate_links[];
}

export interface SendEdition_editionSend_edition_Edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: SendEdition_editionSend_edition_Edition_comparisonEdition_emailTemplate | null;
}

export interface SendEdition_editionSend_edition_Edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface SendEdition_editionSend_edition_Edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface SendEdition_editionSend_edition_Edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: SendEdition_editionSend_edition_Edition_comparison_winnerEdition_emailTemplate | null;
}

export interface SendEdition_editionSend_edition_Edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface SendEdition_editionSend_edition_Edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SendEdition_editionSend_edition_Edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: SendEdition_editionSend_edition_Edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: SendEdition_editionSend_edition_Edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: SendEdition_editionSend_edition_Edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: SendEdition_editionSend_edition_Edition_comparison_winningEdition | null;
}

export interface SendEdition_editionSend_edition_Edition_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface SendEdition_editionSend_edition_Edition_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: SendEdition_editionSend_edition_Edition_audience_fromSavedFilter_count;
}

export interface SendEdition_editionSend_edition_Edition_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface SendEdition_editionSend_edition_Edition_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: SendEdition_editionSend_edition_Edition_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface SendEdition_editionSend_edition_Edition_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface SendEdition_editionSend_edition_Edition_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: SendEdition_editionSend_edition_Edition_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface SendEdition_editionSend_edition_Edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: SendEdition_editionSend_edition_Edition_audience_fromSavedFilter | null;
  membershipStats: SendEdition_editionSend_edition_Edition_audience_membershipStats;
  smsMembershipStats: SendEdition_editionSend_edition_Edition_audience_smsMembershipStats;
}

export interface SendEdition_editionSend_edition_Edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface SendEdition_editionSend_edition_Edition_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface SendEdition_editionSend_edition_Edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: SendEdition_editionSend_edition_Edition_from_emailAddress;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: SendEdition_editionSend_edition_Edition_from_fromDomain | null;
}

export interface SendEdition_editionSend_edition_Edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface SendEdition_editionSend_edition_Edition_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface SendEdition_editionSend_edition_Edition_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface SendEdition_editionSend_edition_Edition_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface SendEdition_editionSend_edition_Edition_gateError {
  __typename: "GateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface SendEdition_editionSend_edition_Edition_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity = SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Account | SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges_node;
}

export interface SendEdition_editionSend_edition_Edition_queuedDripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: SendEdition_editionSend_edition_Edition_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: SendEdition_editionSend_edition_Edition_queuedDripProgressions_edges[];
}

export interface SendEdition_editionSend_edition_Edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: SendEdition_editionSend_edition_Edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: SendEdition_editionSend_edition_Edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: SendEdition_editionSend_edition_Edition_emailTemplate | null;
  engagementStats: SendEdition_editionSend_edition_Edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: SendEdition_editionSend_edition_Edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: SendEdition_editionSend_edition_Edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: SendEdition_editionSend_edition_Edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: SendEdition_editionSend_edition_Edition_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: SendEdition_editionSend_edition_Edition_delay | null;
  /**
   * The number of emails sent for this edition
   */
  numSentEmails: number;
  /**
   * The custom click domain that this edition will use to track links, if there is one
   */
  customClickDomain: SendEdition_editionSend_edition_Edition_customClickDomain | null;
  utmParameters: SendEdition_editionSend_edition_Edition_utmParameters;
  defaultUtmParameters: SendEdition_editionSend_edition_Edition_defaultUtmParameters;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  useUtmParameters: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: SendEdition_editionSend_edition_Edition_gateError | null;
  /**
   * Boolean indicating if the edition is using a web font.
   */
  hasWebFonts: boolean;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: SendEdition_editionSend_edition_Edition_queuedDripProgressions | null;
  /**
   * The maximum number of recipients this edition can send to, if DMARC is not
   * fully configured. This is only relevant for non-drip sequence editions.
   */
  recipientLimitForDeliverability: number | null;
}

export type SendEdition_editionSend_edition = SendEdition_editionSend_edition_SmsEdition | SendEdition_editionSend_edition_Edition;

export interface SendEdition_editionSend {
  __typename: "EditionSendPayload";
  /**
   * The edition
   */
  edition: SendEdition_editionSend_edition;
}

export interface SendEdition {
  /**
   * Send an edition.
   */
  editionSend: SendEdition_editionSend | null;
}

export interface SendEditionVariables {
  edition: EditionSendInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UnscheduleEdition
// ====================================================

export interface UnscheduleEdition_editionUnschedule_edition_SmsEdition {
  __typename: "SmsEdition";
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: UnscheduleEdition_editionUnschedule_edition_Edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: UnscheduleEdition_editionUnschedule_edition_Edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: UnscheduleEdition_editionUnschedule_edition_Edition_campaign_nextSendingEdition | null;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: UnscheduleEdition_editionUnschedule_edition_Edition_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: UnscheduleEdition_editionUnschedule_edition_Edition_emailTemplate_links[];
  name: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: UnscheduleEdition_editionUnschedule_edition_Edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: UnscheduleEdition_editionUnschedule_edition_Edition_comparisonEdition_emailTemplate_links[];
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: UnscheduleEdition_editionUnschedule_edition_Edition_comparisonEdition_emailTemplate | null;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: UnscheduleEdition_editionUnschedule_edition_Edition_comparison_winnerEdition_emailTemplate | null;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: UnscheduleEdition_editionUnschedule_edition_Edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: UnscheduleEdition_editionUnschedule_edition_Edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: UnscheduleEdition_editionUnschedule_edition_Edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: UnscheduleEdition_editionUnschedule_edition_Edition_comparison_winningEdition | null;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: UnscheduleEdition_editionUnschedule_edition_Edition_audience_fromSavedFilter_count;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: UnscheduleEdition_editionUnschedule_edition_Edition_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: UnscheduleEdition_editionUnschedule_edition_Edition_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: UnscheduleEdition_editionUnschedule_edition_Edition_audience_fromSavedFilter | null;
  membershipStats: UnscheduleEdition_editionUnschedule_edition_Edition_audience_membershipStats;
  smsMembershipStats: UnscheduleEdition_editionUnschedule_edition_Edition_audience_smsMembershipStats;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: UnscheduleEdition_editionUnschedule_edition_Edition_from_emailAddress;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: UnscheduleEdition_editionUnschedule_edition_Edition_from_fromDomain | null;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_gateError {
  __typename: "GateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity = UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Account | UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges_node;
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions_edges[];
}

export interface UnscheduleEdition_editionUnschedule_edition_Edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: UnscheduleEdition_editionUnschedule_edition_Edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: UnscheduleEdition_editionUnschedule_edition_Edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: UnscheduleEdition_editionUnschedule_edition_Edition_emailTemplate | null;
  engagementStats: UnscheduleEdition_editionUnschedule_edition_Edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: UnscheduleEdition_editionUnschedule_edition_Edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: UnscheduleEdition_editionUnschedule_edition_Edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: UnscheduleEdition_editionUnschedule_edition_Edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: UnscheduleEdition_editionUnschedule_edition_Edition_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: UnscheduleEdition_editionUnschedule_edition_Edition_delay | null;
  /**
   * The number of emails sent for this edition
   */
  numSentEmails: number;
  /**
   * The custom click domain that this edition will use to track links, if there is one
   */
  customClickDomain: UnscheduleEdition_editionUnschedule_edition_Edition_customClickDomain | null;
  utmParameters: UnscheduleEdition_editionUnschedule_edition_Edition_utmParameters;
  defaultUtmParameters: UnscheduleEdition_editionUnschedule_edition_Edition_defaultUtmParameters;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  useUtmParameters: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: UnscheduleEdition_editionUnschedule_edition_Edition_gateError | null;
  /**
   * Boolean indicating if the edition is using a web font.
   */
  hasWebFonts: boolean;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: UnscheduleEdition_editionUnschedule_edition_Edition_queuedDripProgressions | null;
  /**
   * The maximum number of recipients this edition can send to, if DMARC is not
   * fully configured. This is only relevant for non-drip sequence editions.
   */
  recipientLimitForDeliverability: number | null;
}

export type UnscheduleEdition_editionUnschedule_edition = UnscheduleEdition_editionUnschedule_edition_SmsEdition | UnscheduleEdition_editionUnschedule_edition_Edition;

export interface UnscheduleEdition_editionUnschedule {
  __typename: "EditionSchedulePayload";
  /**
   * The edition
   */
  edition: UnscheduleEdition_editionUnschedule_edition;
}

export interface UnscheduleEdition {
  /**
   * Unschedule an edition that has been scheduled for sending.
   */
  editionUnschedule: UnscheduleEdition_editionUnschedule | null;
}

export interface UnscheduleEditionVariables {
  edition: EditionUnscheduleInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: GenerateAiEmailTemplate
// ====================================================

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_campaign_nextSendingEdition | null;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_emailTemplate_links[];
  name: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_comparisonEdition_emailTemplate_links[];
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_comparisonEdition_emailTemplate | null;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_comparison_winnerEdition_emailTemplate | null;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_comparison_winningEdition | null;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_audience_fromSavedFilter_count;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_audience_fromSavedFilter | null;
  membershipStats: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_audience_membershipStats;
  smsMembershipStats: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_audience_smsMembershipStats;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_from_emailAddress;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_from_fromDomain | null;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_gateError {
  __typename: "GateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity = GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account | GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges_node;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions_edges[];
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_emailTemplate | null;
  engagementStats: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_delay | null;
  /**
   * The number of emails sent for this edition
   */
  numSentEmails: number;
  /**
   * The custom click domain that this edition will use to track links, if there is one
   */
  customClickDomain: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_customClickDomain | null;
  utmParameters: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_utmParameters;
  defaultUtmParameters: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_defaultUtmParameters;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  useUtmParameters: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_gateError | null;
  /**
   * Boolean indicating if the edition is using a web font.
   */
  hasWebFonts: boolean;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition_queuedDripProgressions | null;
  /**
   * The maximum number of recipients this edition can send to, if DMARC is not
   * fully configured. This is only relevant for non-drip sequence editions.
   */
  recipientLimitForDeliverability: number | null;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  edition: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign_edition;
  description: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
}

export interface GenerateAiEmailTemplate_aiEmailTemplateGenerate {
  __typename: "AiEmailTemplateGeneratePayload";
  /**
   * The campaign that was generated
   */
  campaign: GenerateAiEmailTemplate_aiEmailTemplateGenerate_campaign;
}

export interface GenerateAiEmailTemplate {
  /**
   * Generates an AI email template for a campaign
   */
  aiEmailTemplateGenerate: GenerateAiEmailTemplate_aiEmailTemplateGenerate;
}

export interface GenerateAiEmailTemplateVariables {
  input: AiEmailTemplateGenerateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateAudience
// ====================================================

export interface CreateAudience_audienceCreate_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface CreateAudience_audienceCreate_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: CreateAudience_audienceCreate_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface CreateAudience_audienceCreate_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface CreateAudience_audienceCreate_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: CreateAudience_audienceCreate_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface CreateAudience_audienceCreate_audience_publishedEditions_edges_node_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface CreateAudience_audienceCreate_audience_publishedEditions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  sendTime: any | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: CreateAudience_audienceCreate_audience_publishedEditions_edges_node_campaign;
}

export interface CreateAudience_audienceCreate_audience_publishedEditions_edges {
  __typename: "AudienceEditionEdge";
  node: CreateAudience_audienceCreate_audience_publishedEditions_edges_node;
}

export interface CreateAudience_audienceCreate_audience_publishedEditions {
  __typename: "AudienceEditionConnection";
  /**
   * A list of edges.
   */
  edges: CreateAudience_audienceCreate_audience_publishedEditions_edges[];
}

export interface CreateAudience_audienceCreate_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The description of this audience
   */
  description: string | null;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  membershipStats: CreateAudience_audienceCreate_audience_membershipStats;
  smsMembershipStats: CreateAudience_audienceCreate_audience_smsMembershipStats;
  /**
   * All published email editions for this audience
   */
  publishedEditions: CreateAudience_audienceCreate_audience_publishedEditions;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * Is this audience on the preference center?
   */
  isPublic: boolean;
  modifiedTime: any | null;
  deletedTime: any | null;
  /**
   * The last time an email or SMS edition was sent to this audience
   */
  lastContactedTime: any | null;
  isArchived: boolean;
}

export interface CreateAudience_audienceCreate {
  __typename: "AudienceCreatePayload";
  /**
   * The newly created email marketing audience
   */
  audience: CreateAudience_audienceCreate_audience;
}

export interface CreateAudience {
  /**
   * Creates a new email marketing audience.
   */
  audienceCreate: CreateAudience_audienceCreate;
}

export interface CreateAudienceVariables {
  audience: AudienceCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteAudience
// ====================================================

export interface DeleteAudience_audienceDelete_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteAudience_audienceDelete {
  __typename: "AudienceDeletePayload";
  /**
   * The deleted Nutshell audience
   */
  audience: DeleteAudience_audienceDelete_audience;
}

export interface DeleteAudience {
  /**
   * Deletes an audience.
   */
  audienceDelete: DeleteAudience_audienceDelete;
}

export interface DeleteAudienceVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RestoreAudience
// ====================================================

export interface RestoreAudience_audienceRestore_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface RestoreAudience_audienceRestore {
  __typename: "AudienceRestorePayload";
  /**
   * The restored Nutshell audience
   */
  audience: RestoreAudience_audienceRestore_audience;
}

export interface RestoreAudience {
  /**
   * Restores a deleted audience.
   */
  audienceRestore: RestoreAudience_audienceRestore;
}

export interface RestoreAudienceVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateAudience
// ====================================================

export interface UpdateAudience_audienceUpdate_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface UpdateAudience_audienceUpdate_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: UpdateAudience_audienceUpdate_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface UpdateAudience_audienceUpdate_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface UpdateAudience_audienceUpdate_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: UpdateAudience_audienceUpdate_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface UpdateAudience_audienceUpdate_audience_publishedEditions_edges_node_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
}

export interface UpdateAudience_audienceUpdate_audience_publishedEditions_edges_node_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
}

export interface UpdateAudience_audienceUpdate_audience_publishedEditions_edges_node_from_emailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface UpdateAudience_audienceUpdate_audience_publishedEditions_edges_node_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface UpdateAudience_audienceUpdate_audience_publishedEditions_edges_node_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: UpdateAudience_audienceUpdate_audience_publishedEditions_edges_node_from_emailAddress;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: UpdateAudience_audienceUpdate_audience_publishedEditions_edges_node_from_fromDomain | null;
}

export interface UpdateAudience_audienceUpdate_audience_publishedEditions_edges_node_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface UpdateAudience_audienceUpdate_audience_publishedEditions_edges_node_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
}

export interface UpdateAudience_audienceUpdate_audience_publishedEditions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  sendTime: any | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: UpdateAudience_audienceUpdate_audience_publishedEditions_edges_node_campaign;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The email template for this edition
   */
  emailTemplate: UpdateAudience_audienceUpdate_audience_publishedEditions_edges_node_emailTemplate | null;
  /**
   * The address to send this edition from
   */
  from: UpdateAudience_audienceUpdate_audience_publishedEditions_edges_node_from | null;
  /**
   * The audience to send this edition to
   */
  audience: UpdateAudience_audienceUpdate_audience_publishedEditions_edges_node_audience | null;
  engagementStats: UpdateAudience_audienceUpdate_audience_publishedEditions_edges_node_engagementStats;
}

export interface UpdateAudience_audienceUpdate_audience_publishedEditions_edges {
  __typename: "AudienceEditionEdge";
  node: UpdateAudience_audienceUpdate_audience_publishedEditions_edges_node;
}

export interface UpdateAudience_audienceUpdate_audience_publishedEditions {
  __typename: "AudienceEditionConnection";
  /**
   * A list of edges.
   */
  edges: UpdateAudience_audienceUpdate_audience_publishedEditions_edges[];
}

export interface UpdateAudience_audienceUpdate_audience_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_SmsEdition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_SmsEdition_campaign {
  __typename: "Campaign" | "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
}

export interface UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_SmsEdition_engagementStats {
  __typename: "SmsEngagementStats";
  /**
   * Total number of texts we tried to send
   */
  totalSentCount: number;
  /**
   * Total number of people who responded to the SMS campaign
   */
  responseCount: number;
  /**
   * The ratio of undelivered texts to total texts sent
   */
  undeliveredRate: number | null;
  /**
   * The ratio of optouts to total texts sent
   */
  optoutRate: number | null;
}

export interface UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_SmsEdition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The audience to send this edition to
   */
  audience: UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_SmsEdition_audience | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_SmsEdition_campaign;
  /**
   * The content of the edition
   */
  content: string;
  engagementStats: UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_SmsEdition_engagementStats;
}

export interface UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_Edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_Edition_campaign {
  __typename: "Campaign" | "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
}

export interface UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_Edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
}

export interface UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_Edition_from_emailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_Edition_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_Edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_Edition_from_emailAddress;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_Edition_from_fromDomain | null;
}

export interface UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_Edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
}

export interface UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_Edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The audience to send this edition to
   */
  audience: UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_Edition_audience | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_Edition_campaign;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The email template for this edition
   */
  emailTemplate: UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_Edition_emailTemplate | null;
  /**
   * The address to send this edition from
   */
  from: UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_Edition_from | null;
  engagementStats: UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_Edition_engagementStats;
}

export type UpdateAudience_audienceUpdate_audience_mostRecentSentEdition = UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_SmsEdition | UpdateAudience_audienceUpdate_audience_mostRecentSentEdition_Edition;

export interface UpdateAudience_audienceUpdate_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The description of this audience
   */
  description: string | null;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  membershipStats: UpdateAudience_audienceUpdate_audience_membershipStats;
  smsMembershipStats: UpdateAudience_audienceUpdate_audience_smsMembershipStats;
  /**
   * All published email editions for this audience
   */
  publishedEditions: UpdateAudience_audienceUpdate_audience_publishedEditions;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * Is this audience on the preference center?
   */
  isPublic: boolean;
  modifiedTime: any | null;
  deletedTime: any | null;
  /**
   * The last time an email or SMS edition was sent to this audience
   */
  lastContactedTime: any | null;
  isArchived: boolean;
  creatorUser: UpdateAudience_audienceUpdate_audience_creatorUser | null;
  createdTime: any;
  /**
   * The most recent sent edition for this audience
   */
  mostRecentSentEdition: UpdateAudience_audienceUpdate_audience_mostRecentSentEdition | null;
}

export interface UpdateAudience_audienceUpdate {
  __typename: "AudienceUpdatePayload";
  /**
   * The audience
   */
  audience: UpdateAudience_audienceUpdate_audience;
}

export interface UpdateAudience {
  /**
   * Save the template data for an email marketing audience
   */
  audienceUpdate: UpdateAudience_audienceUpdate | null;
}

export interface UpdateAudienceVariables {
  audience: AudienceUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAudience
// ====================================================

export interface GetAudience_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetAudience_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetAudience_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface GetAudience_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetAudience_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetAudience_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface GetAudience_audience_publishedEditions_edges_node_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
}

export interface GetAudience_audience_publishedEditions_edges_node_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
}

export interface GetAudience_audience_publishedEditions_edges_node_from_emailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface GetAudience_audience_publishedEditions_edges_node_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface GetAudience_audience_publishedEditions_edges_node_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: GetAudience_audience_publishedEditions_edges_node_from_emailAddress;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: GetAudience_audience_publishedEditions_edges_node_from_fromDomain | null;
}

export interface GetAudience_audience_publishedEditions_edges_node_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetAudience_audience_publishedEditions_edges_node_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
}

export interface GetAudience_audience_publishedEditions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  sendTime: any | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetAudience_audience_publishedEditions_edges_node_campaign;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetAudience_audience_publishedEditions_edges_node_emailTemplate | null;
  /**
   * The address to send this edition from
   */
  from: GetAudience_audience_publishedEditions_edges_node_from | null;
  /**
   * The audience to send this edition to
   */
  audience: GetAudience_audience_publishedEditions_edges_node_audience | null;
  engagementStats: GetAudience_audience_publishedEditions_edges_node_engagementStats;
}

export interface GetAudience_audience_publishedEditions_edges {
  __typename: "AudienceEditionEdge";
  node: GetAudience_audience_publishedEditions_edges_node;
}

export interface GetAudience_audience_publishedEditions {
  __typename: "AudienceEditionConnection";
  /**
   * A list of edges.
   */
  edges: GetAudience_audience_publishedEditions_edges[];
}

export interface GetAudience_audience_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetAudience_audience_mostRecentSentEdition_SmsEdition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetAudience_audience_mostRecentSentEdition_SmsEdition_campaign {
  __typename: "Campaign" | "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
}

export interface GetAudience_audience_mostRecentSentEdition_SmsEdition_engagementStats {
  __typename: "SmsEngagementStats";
  /**
   * Total number of texts we tried to send
   */
  totalSentCount: number;
  /**
   * Total number of people who responded to the SMS campaign
   */
  responseCount: number;
  /**
   * The ratio of undelivered texts to total texts sent
   */
  undeliveredRate: number | null;
  /**
   * The ratio of optouts to total texts sent
   */
  optoutRate: number | null;
}

export interface GetAudience_audience_mostRecentSentEdition_SmsEdition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The audience to send this edition to
   */
  audience: GetAudience_audience_mostRecentSentEdition_SmsEdition_audience | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetAudience_audience_mostRecentSentEdition_SmsEdition_campaign;
  /**
   * The content of the edition
   */
  content: string;
  engagementStats: GetAudience_audience_mostRecentSentEdition_SmsEdition_engagementStats;
}

export interface GetAudience_audience_mostRecentSentEdition_Edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetAudience_audience_mostRecentSentEdition_Edition_campaign {
  __typename: "Campaign" | "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
}

export interface GetAudience_audience_mostRecentSentEdition_Edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
}

export interface GetAudience_audience_mostRecentSentEdition_Edition_from_emailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface GetAudience_audience_mostRecentSentEdition_Edition_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface GetAudience_audience_mostRecentSentEdition_Edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: GetAudience_audience_mostRecentSentEdition_Edition_from_emailAddress;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: GetAudience_audience_mostRecentSentEdition_Edition_from_fromDomain | null;
}

export interface GetAudience_audience_mostRecentSentEdition_Edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
}

export interface GetAudience_audience_mostRecentSentEdition_Edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The audience to send this edition to
   */
  audience: GetAudience_audience_mostRecentSentEdition_Edition_audience | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetAudience_audience_mostRecentSentEdition_Edition_campaign;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetAudience_audience_mostRecentSentEdition_Edition_emailTemplate | null;
  /**
   * The address to send this edition from
   */
  from: GetAudience_audience_mostRecentSentEdition_Edition_from | null;
  engagementStats: GetAudience_audience_mostRecentSentEdition_Edition_engagementStats;
}

export type GetAudience_audience_mostRecentSentEdition = GetAudience_audience_mostRecentSentEdition_SmsEdition | GetAudience_audience_mostRecentSentEdition_Edition;

export interface GetAudience_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The description of this audience
   */
  description: string | null;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  membershipStats: GetAudience_audience_membershipStats;
  smsMembershipStats: GetAudience_audience_smsMembershipStats;
  /**
   * All published email editions for this audience
   */
  publishedEditions: GetAudience_audience_publishedEditions;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * Is this audience on the preference center?
   */
  isPublic: boolean;
  modifiedTime: any | null;
  deletedTime: any | null;
  /**
   * The last time an email or SMS edition was sent to this audience
   */
  lastContactedTime: any | null;
  isArchived: boolean;
  creatorUser: GetAudience_audience_creatorUser | null;
  createdTime: any;
  /**
   * The most recent sent edition for this audience
   */
  mostRecentSentEdition: GetAudience_audience_mostRecentSentEdition | null;
}

export interface GetAudience {
  /**
   * Returns an email marketing audience.
   */
  audience: GetAudience_audience;
}

export interface GetAudienceVariables {
  audienceId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAudiences
// ====================================================

export interface GetAudiences_audiences_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetAudiences_audiences_edges_node_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetAudiences_audiences_edges_node_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetAudiences_audiences_edges_node_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface GetAudiences_audiences_edges_node_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetAudiences_audiences_edges_node_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetAudiences_audiences_edges_node_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface GetAudiences_audiences_edges_node_publishedEditions_edges_node_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface GetAudiences_audiences_edges_node_publishedEditions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  sendTime: any | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetAudiences_audiences_edges_node_publishedEditions_edges_node_campaign;
}

export interface GetAudiences_audiences_edges_node_publishedEditions_edges {
  __typename: "AudienceEditionEdge";
  node: GetAudiences_audiences_edges_node_publishedEditions_edges_node;
}

export interface GetAudiences_audiences_edges_node_publishedEditions {
  __typename: "AudienceEditionConnection";
  /**
   * A list of edges.
   */
  edges: GetAudiences_audiences_edges_node_publishedEditions_edges[];
}

export interface GetAudiences_audiences_edges_node {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The description of this audience
   */
  description: string | null;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  membershipStats: GetAudiences_audiences_edges_node_membershipStats;
  smsMembershipStats: GetAudiences_audiences_edges_node_smsMembershipStats;
  /**
   * All published email editions for this audience
   */
  publishedEditions: GetAudiences_audiences_edges_node_publishedEditions;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * Is this audience on the preference center?
   */
  isPublic: boolean;
  modifiedTime: any | null;
  deletedTime: any | null;
  /**
   * The last time an email or SMS edition was sent to this audience
   */
  lastContactedTime: any | null;
  isArchived: boolean;
}

export interface GetAudiences_audiences_edges {
  __typename: "AudienceEdge";
  cursor: string;
  node: GetAudiences_audiences_edges_node;
}

export interface GetAudiences_audiences {
  __typename: "AudienceConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetAudiences_audiences_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetAudiences_audiences_edges[];
}

export interface GetAudiences {
  /**
   * Returns all email marketing audiences
   */
  audiences: GetAudiences_audiences;
}

export interface GetAudiencesVariables {
  limit: number;
  archived?: boolean | null;
  cursor?: string | null;
  sort: AudienceSortType;
  search?: string | null;
  creatorUserId?: string | null;
  lastUpdatedTime?: string | null;
  audienceTypeFilter?: AudienceTypeFilter | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateBroadcast
// ====================================================

export interface CreateBroadcast_broadcastCreate_broadcast_edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateBroadcast_broadcastCreate_broadcast_edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateBroadcast_broadcastCreate_broadcast_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateBroadcast_broadcastCreate_broadcast_edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface CreateBroadcast_broadcastCreate_broadcast_edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: CreateBroadcast_broadcastCreate_broadcast_edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: CreateBroadcast_broadcastCreate_broadcast_edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: CreateBroadcast_broadcastCreate_broadcast_edition_campaign_nextSendingEdition | null;
}

export interface CreateBroadcast_broadcastCreate_broadcast_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface CreateBroadcast_broadcastCreate_broadcast_edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
}

export interface CreateBroadcast_broadcastCreate_broadcast_edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface CreateBroadcast_broadcastCreate_broadcast_edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: CreateBroadcast_broadcastCreate_broadcast_edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface CreateBroadcast_broadcastCreate_broadcast_edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: CreateBroadcast_broadcastCreate_broadcast_edition_comparisonEdition_emailTemplate_links[];
}

export interface CreateBroadcast_broadcastCreate_broadcast_edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: CreateBroadcast_broadcastCreate_broadcast_edition_comparisonEdition_emailTemplate | null;
}

export interface CreateBroadcast_broadcastCreate_broadcast_edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface CreateBroadcast_broadcastCreate_broadcast_edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface CreateBroadcast_broadcastCreate_broadcast_edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: CreateBroadcast_broadcastCreate_broadcast_edition_comparison_winnerEdition_emailTemplate | null;
}

export interface CreateBroadcast_broadcastCreate_broadcast_edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface CreateBroadcast_broadcastCreate_broadcast_edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateBroadcast_broadcastCreate_broadcast_edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: CreateBroadcast_broadcastCreate_broadcast_edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: CreateBroadcast_broadcastCreate_broadcast_edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: CreateBroadcast_broadcastCreate_broadcast_edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: CreateBroadcast_broadcastCreate_broadcast_edition_comparison_winningEdition | null;
}

export interface CreateBroadcast_broadcastCreate_broadcast_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface CreateBroadcast_broadcastCreate_broadcast_edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
}

export interface CreateBroadcast_broadcastCreate_broadcast_edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: CreateBroadcast_broadcastCreate_broadcast_edition_from_emailAddress;
}

export interface CreateBroadcast_broadcastCreate_broadcast_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: CreateBroadcast_broadcastCreate_broadcast_edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: CreateBroadcast_broadcastCreate_broadcast_edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: CreateBroadcast_broadcastCreate_broadcast_edition_emailTemplate | null;
  engagementStats: CreateBroadcast_broadcastCreate_broadcast_edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: CreateBroadcast_broadcastCreate_broadcast_edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: CreateBroadcast_broadcastCreate_broadcast_edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: CreateBroadcast_broadcastCreate_broadcast_edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: CreateBroadcast_broadcastCreate_broadcast_edition_from | null;
}

export interface CreateBroadcast_broadcastCreate_broadcast {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  edition: CreateBroadcast_broadcastCreate_broadcast_edition;
}

export interface CreateBroadcast_broadcastCreate {
  __typename: "BroadcastCreatePayload";
  /**
   * The newly created broadcast
   */
  broadcast: CreateBroadcast_broadcastCreate_broadcast;
}

export interface CreateBroadcast {
  /**
   * Create a new email marketing broadcast
   */
  broadcastCreate: CreateBroadcast_broadcastCreate | null;
}

export interface CreateBroadcastVariables {
  broadcast: BroadcastCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteBroadcast
// ====================================================

export interface DeleteBroadcast_campaignDelete_campaign {
  __typename: "Campaign" | "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteBroadcast_campaignDelete {
  __typename: "CampaignDeletePayload";
  /**
   * The campaign
   */
  campaign: DeleteBroadcast_campaignDelete_campaign;
}

export interface DeleteBroadcast {
  /**
   * Delete a campaign and associated content.
   */
  campaignDelete: DeleteBroadcast_campaignDelete | null;
}

export interface DeleteBroadcastVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DuplicateBroadcast
// ====================================================

export interface DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_campaign_nextSendingEdition | null;
}

export interface DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
}

export interface DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_comparisonEdition_emailTemplate_links[];
}

export interface DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_comparisonEdition_emailTemplate | null;
}

export interface DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_comparison_winnerEdition_emailTemplate | null;
}

export interface DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_comparison_winningEdition | null;
}

export interface DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
}

export interface DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_from_emailAddress;
}

export interface DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_emailTemplate | null;
  engagementStats: DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition_from | null;
}

export interface DuplicateBroadcast_editionDuplicateToBroadcast_broadcast {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  edition: DuplicateBroadcast_editionDuplicateToBroadcast_broadcast_edition;
}

export interface DuplicateBroadcast_editionDuplicateToBroadcast {
  __typename: "EditionDuplicateToBroadcastPayload";
  /**
   * The newly created broadcast
   */
  broadcast: DuplicateBroadcast_editionDuplicateToBroadcast_broadcast;
}

export interface DuplicateBroadcast {
  /**
   * Duplicate an email marketing edition to a new broadcast
   */
  editionDuplicateToBroadcast: DuplicateBroadcast_editionDuplicateToBroadcast | null;
}

export interface DuplicateBroadcastVariables {
  broadcast: EditionDuplicateToBroadcastInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RestoreBroadcast
// ====================================================

export interface RestoreBroadcast_campaignRestore_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface RestoreBroadcast_campaignRestore {
  __typename: "CampaignRestorePayload";
  /**
   * The campaign
   */
  campaign: RestoreBroadcast_campaignRestore_campaign;
}

export interface RestoreBroadcast {
  /**
   * Restore an email campaign
   */
  campaignRestore: RestoreBroadcast_campaignRestore | null;
}

export interface RestoreBroadcastVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateBroadcast
// ====================================================

export interface UpdateBroadcast_editionUpdate_edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateBroadcast_editionUpdate_edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateBroadcast_editionUpdate_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateBroadcast_editionUpdate_edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface UpdateBroadcast_editionUpdate_edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: UpdateBroadcast_editionUpdate_edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: UpdateBroadcast_editionUpdate_edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: UpdateBroadcast_editionUpdate_edition_campaign_nextSendingEdition | null;
}

export interface UpdateBroadcast_editionUpdate_edition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface UpdateBroadcast_editionUpdate_edition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: UpdateBroadcast_editionUpdate_edition_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface UpdateBroadcast_editionUpdate_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: UpdateBroadcast_editionUpdate_edition_emailTemplate_links[];
  name: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface UpdateBroadcast_editionUpdate_edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface UpdateBroadcast_editionUpdate_edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface UpdateBroadcast_editionUpdate_edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: UpdateBroadcast_editionUpdate_edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface UpdateBroadcast_editionUpdate_edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: UpdateBroadcast_editionUpdate_edition_comparisonEdition_emailTemplate_links[];
}

export interface UpdateBroadcast_editionUpdate_edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: UpdateBroadcast_editionUpdate_edition_comparisonEdition_emailTemplate | null;
}

export interface UpdateBroadcast_editionUpdate_edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface UpdateBroadcast_editionUpdate_edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface UpdateBroadcast_editionUpdate_edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: UpdateBroadcast_editionUpdate_edition_comparison_winnerEdition_emailTemplate | null;
}

export interface UpdateBroadcast_editionUpdate_edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface UpdateBroadcast_editionUpdate_edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateBroadcast_editionUpdate_edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: UpdateBroadcast_editionUpdate_edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: UpdateBroadcast_editionUpdate_edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: UpdateBroadcast_editionUpdate_edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: UpdateBroadcast_editionUpdate_edition_comparison_winningEdition | null;
}

export interface UpdateBroadcast_editionUpdate_edition_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface UpdateBroadcast_editionUpdate_edition_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: UpdateBroadcast_editionUpdate_edition_audience_fromSavedFilter_count;
}

export interface UpdateBroadcast_editionUpdate_edition_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface UpdateBroadcast_editionUpdate_edition_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: UpdateBroadcast_editionUpdate_edition_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface UpdateBroadcast_editionUpdate_edition_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface UpdateBroadcast_editionUpdate_edition_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: UpdateBroadcast_editionUpdate_edition_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface UpdateBroadcast_editionUpdate_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: UpdateBroadcast_editionUpdate_edition_audience_fromSavedFilter | null;
  membershipStats: UpdateBroadcast_editionUpdate_edition_audience_membershipStats;
  smsMembershipStats: UpdateBroadcast_editionUpdate_edition_audience_smsMembershipStats;
}

export interface UpdateBroadcast_editionUpdate_edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface UpdateBroadcast_editionUpdate_edition_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface UpdateBroadcast_editionUpdate_edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: UpdateBroadcast_editionUpdate_edition_from_emailAddress;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: UpdateBroadcast_editionUpdate_edition_from_fromDomain | null;
}

export interface UpdateBroadcast_editionUpdate_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface UpdateBroadcast_editionUpdate_edition_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface UpdateBroadcast_editionUpdate_edition_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface UpdateBroadcast_editionUpdate_edition_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface UpdateBroadcast_editionUpdate_edition_gateError {
  __typename: "GateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity = UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account | UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges_node;
}

export interface UpdateBroadcast_editionUpdate_edition_queuedDripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: UpdateBroadcast_editionUpdate_edition_queuedDripProgressions_edges[];
}

export interface UpdateBroadcast_editionUpdate_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: UpdateBroadcast_editionUpdate_edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: UpdateBroadcast_editionUpdate_edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: UpdateBroadcast_editionUpdate_edition_emailTemplate | null;
  engagementStats: UpdateBroadcast_editionUpdate_edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: UpdateBroadcast_editionUpdate_edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: UpdateBroadcast_editionUpdate_edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: UpdateBroadcast_editionUpdate_edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: UpdateBroadcast_editionUpdate_edition_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: UpdateBroadcast_editionUpdate_edition_delay | null;
  /**
   * The number of emails sent for this edition
   */
  numSentEmails: number;
  /**
   * The custom click domain that this edition will use to track links, if there is one
   */
  customClickDomain: UpdateBroadcast_editionUpdate_edition_customClickDomain | null;
  utmParameters: UpdateBroadcast_editionUpdate_edition_utmParameters;
  defaultUtmParameters: UpdateBroadcast_editionUpdate_edition_defaultUtmParameters;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  useUtmParameters: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: UpdateBroadcast_editionUpdate_edition_gateError | null;
  /**
   * Boolean indicating if the edition is using a web font.
   */
  hasWebFonts: boolean;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: UpdateBroadcast_editionUpdate_edition_queuedDripProgressions | null;
  /**
   * The maximum number of recipients this edition can send to, if DMARC is not
   * fully configured. This is only relevant for non-drip sequence editions.
   */
  recipientLimitForDeliverability: number | null;
}

export interface UpdateBroadcast_editionUpdate {
  __typename: "EditionUpdatePayload";
  /**
   * The edition
   */
  edition: UpdateBroadcast_editionUpdate_edition;
}

export interface UpdateBroadcast {
  /**
   * Save the template data for an email marketing edition
   */
  editionUpdate: UpdateBroadcast_editionUpdate | null;
}

export interface UpdateBroadcastVariables {
  edition: EditionUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBroadcast
// ====================================================

export interface GetBroadcast_broadcast_edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetBroadcast_broadcast_edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetBroadcast_broadcast_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetBroadcast_broadcast_edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetBroadcast_broadcast_edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: GetBroadcast_broadcast_edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: GetBroadcast_broadcast_edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: GetBroadcast_broadcast_edition_campaign_nextSendingEdition | null;
}

export interface GetBroadcast_broadcast_edition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetBroadcast_broadcast_edition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: GetBroadcast_broadcast_edition_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface GetBroadcast_broadcast_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: GetBroadcast_broadcast_edition_emailTemplate_links[];
  name: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface GetBroadcast_broadcast_edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface GetBroadcast_broadcast_edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetBroadcast_broadcast_edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: GetBroadcast_broadcast_edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface GetBroadcast_broadcast_edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: GetBroadcast_broadcast_edition_comparisonEdition_emailTemplate_links[];
}

export interface GetBroadcast_broadcast_edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: GetBroadcast_broadcast_edition_comparisonEdition_emailTemplate | null;
}

export interface GetBroadcast_broadcast_edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetBroadcast_broadcast_edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface GetBroadcast_broadcast_edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetBroadcast_broadcast_edition_comparison_winnerEdition_emailTemplate | null;
}

export interface GetBroadcast_broadcast_edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface GetBroadcast_broadcast_edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetBroadcast_broadcast_edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: GetBroadcast_broadcast_edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: GetBroadcast_broadcast_edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: GetBroadcast_broadcast_edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: GetBroadcast_broadcast_edition_comparison_winningEdition | null;
}

export interface GetBroadcast_broadcast_edition_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetBroadcast_broadcast_edition_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: GetBroadcast_broadcast_edition_audience_fromSavedFilter_count;
}

export interface GetBroadcast_broadcast_edition_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetBroadcast_broadcast_edition_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetBroadcast_broadcast_edition_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface GetBroadcast_broadcast_edition_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetBroadcast_broadcast_edition_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetBroadcast_broadcast_edition_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface GetBroadcast_broadcast_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: GetBroadcast_broadcast_edition_audience_fromSavedFilter | null;
  membershipStats: GetBroadcast_broadcast_edition_audience_membershipStats;
  smsMembershipStats: GetBroadcast_broadcast_edition_audience_smsMembershipStats;
}

export interface GetBroadcast_broadcast_edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface GetBroadcast_broadcast_edition_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface GetBroadcast_broadcast_edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: GetBroadcast_broadcast_edition_from_emailAddress;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: GetBroadcast_broadcast_edition_from_fromDomain | null;
}

export interface GetBroadcast_broadcast_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetBroadcast_broadcast_edition_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface GetBroadcast_broadcast_edition_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface GetBroadcast_broadcast_edition_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface GetBroadcast_broadcast_edition_gateError {
  __typename: "GateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface GetBroadcast_broadcast_edition_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetBroadcast_broadcast_edition_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetBroadcast_broadcast_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetBroadcast_broadcast_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface GetBroadcast_broadcast_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetBroadcast_broadcast_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface GetBroadcast_broadcast_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetBroadcast_broadcast_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface GetBroadcast_broadcast_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetBroadcast_broadcast_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetBroadcast_broadcast_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface GetBroadcast_broadcast_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetBroadcast_broadcast_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetBroadcast_broadcast_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type GetBroadcast_broadcast_edition_queuedDripProgressions_edges_node_audienceMember_entity = GetBroadcast_broadcast_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account | GetBroadcast_broadcast_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface GetBroadcast_broadcast_edition_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: GetBroadcast_broadcast_edition_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: GetBroadcast_broadcast_edition_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface GetBroadcast_broadcast_edition_queuedDripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: GetBroadcast_broadcast_edition_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface GetBroadcast_broadcast_edition_queuedDripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: GetBroadcast_broadcast_edition_queuedDripProgressions_edges_node;
}

export interface GetBroadcast_broadcast_edition_queuedDripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetBroadcast_broadcast_edition_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetBroadcast_broadcast_edition_queuedDripProgressions_edges[];
}

export interface GetBroadcast_broadcast_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: GetBroadcast_broadcast_edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetBroadcast_broadcast_edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: GetBroadcast_broadcast_edition_emailTemplate | null;
  engagementStats: GetBroadcast_broadcast_edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: GetBroadcast_broadcast_edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: GetBroadcast_broadcast_edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: GetBroadcast_broadcast_edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: GetBroadcast_broadcast_edition_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: GetBroadcast_broadcast_edition_delay | null;
  /**
   * The number of emails sent for this edition
   */
  numSentEmails: number;
  /**
   * The custom click domain that this edition will use to track links, if there is one
   */
  customClickDomain: GetBroadcast_broadcast_edition_customClickDomain | null;
  utmParameters: GetBroadcast_broadcast_edition_utmParameters;
  defaultUtmParameters: GetBroadcast_broadcast_edition_defaultUtmParameters;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  useUtmParameters: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: GetBroadcast_broadcast_edition_gateError | null;
  /**
   * Boolean indicating if the edition is using a web font.
   */
  hasWebFonts: boolean;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: GetBroadcast_broadcast_edition_queuedDripProgressions | null;
  /**
   * The maximum number of recipients this edition can send to, if DMARC is not
   * fully configured. This is only relevant for non-drip sequence editions.
   */
  recipientLimitForDeliverability: number | null;
}

export interface GetBroadcast_broadcast {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  edition: GetBroadcast_broadcast_edition;
  description: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
}

export interface GetBroadcast {
  /**
   * Returns an email marketing broadcast.
   */
  broadcast: GetBroadcast_broadcast | null;
}

export interface GetBroadcastVariables {
  broadcastId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBroadcasts
// ====================================================

export interface GetBroadcasts_broadcasts_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetBroadcasts_broadcasts_edges_node_edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetBroadcasts_broadcasts_edges_node_edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetBroadcasts_broadcasts_edges_node_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetBroadcasts_broadcasts_edges_node_edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetBroadcasts_broadcasts_edges_node_edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: GetBroadcasts_broadcasts_edges_node_edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: GetBroadcasts_broadcasts_edges_node_edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: GetBroadcasts_broadcasts_edges_node_edition_campaign_nextSendingEdition | null;
}

export interface GetBroadcasts_broadcasts_edges_node_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface GetBroadcasts_broadcasts_edges_node_edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
}

export interface GetBroadcasts_broadcasts_edges_node_edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetBroadcasts_broadcasts_edges_node_edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: GetBroadcasts_broadcasts_edges_node_edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface GetBroadcasts_broadcasts_edges_node_edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: GetBroadcasts_broadcasts_edges_node_edition_comparisonEdition_emailTemplate_links[];
}

export interface GetBroadcasts_broadcasts_edges_node_edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: GetBroadcasts_broadcasts_edges_node_edition_comparisonEdition_emailTemplate | null;
}

export interface GetBroadcasts_broadcasts_edges_node_edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetBroadcasts_broadcasts_edges_node_edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface GetBroadcasts_broadcasts_edges_node_edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetBroadcasts_broadcasts_edges_node_edition_comparison_winnerEdition_emailTemplate | null;
}

export interface GetBroadcasts_broadcasts_edges_node_edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface GetBroadcasts_broadcasts_edges_node_edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetBroadcasts_broadcasts_edges_node_edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: GetBroadcasts_broadcasts_edges_node_edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: GetBroadcasts_broadcasts_edges_node_edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: GetBroadcasts_broadcasts_edges_node_edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: GetBroadcasts_broadcasts_edges_node_edition_comparison_winningEdition | null;
}

export interface GetBroadcasts_broadcasts_edges_node_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetBroadcasts_broadcasts_edges_node_edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
}

export interface GetBroadcasts_broadcasts_edges_node_edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: GetBroadcasts_broadcasts_edges_node_edition_from_emailAddress;
}

export interface GetBroadcasts_broadcasts_edges_node_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: GetBroadcasts_broadcasts_edges_node_edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetBroadcasts_broadcasts_edges_node_edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: GetBroadcasts_broadcasts_edges_node_edition_emailTemplate | null;
  engagementStats: GetBroadcasts_broadcasts_edges_node_edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: GetBroadcasts_broadcasts_edges_node_edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: GetBroadcasts_broadcasts_edges_node_edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: GetBroadcasts_broadcasts_edges_node_edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: GetBroadcasts_broadcasts_edges_node_edition_from | null;
}

export interface GetBroadcasts_broadcasts_edges_node {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  edition: GetBroadcasts_broadcasts_edges_node_edition;
}

export interface GetBroadcasts_broadcasts_edges {
  __typename: "CampaignsEdge";
  cursor: string;
  node: GetBroadcasts_broadcasts_edges_node;
}

export interface GetBroadcasts_broadcasts {
  __typename: "CampaignsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetBroadcasts_broadcasts_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetBroadcasts_broadcasts_edges[];
}

export interface GetBroadcasts {
  /**
   * Returns a paging connection of email broadcasts from the root of our query.
   */
  broadcasts: GetBroadcasts_broadcasts;
}

export interface GetBroadcastsVariables {
  limit: number;
  after?: string | null;
  archived: boolean;
  sort: BroadcastSortType;
  search?: string | null;
  creatorUserId?: string | null;
  lastUpdatedTime?: string | null;
  statuses?: EditionStatus[] | null;
  assigneeIds?: string[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDripSequenceEditionStubs
// ====================================================

export interface GetDripSequenceEditionStubs_dripSequence_editions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_campaign_nextSendingEdition | null;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_emailTemplate_links[];
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_comparisonEdition_emailTemplate_links_url | null;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_comparisonEdition_emailTemplate_links[];
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_comparisonEdition_emailTemplate | null;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_comparison_winnerEdition_emailTemplate | null;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_comparison_winningEdition | null;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_from_emailAddress;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_emailTemplate | null;
  engagementStats: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_audience | null;
  /**
   * The address to send this edition from
   */
  from: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: GetDripSequenceEditionStubs_dripSequence_editions_edges_node_delay | null;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions_edges {
  __typename: "EditionsEdge";
  cursor: string;
  node: GetDripSequenceEditionStubs_dripSequence_editions_edges_node;
}

export interface GetDripSequenceEditionStubs_dripSequence_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetDripSequenceEditionStubs_dripSequence_editions_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetDripSequenceEditionStubs_dripSequence_editions_edges[];
}

export interface GetDripSequenceEditionStubs_dripSequence {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  editions: GetDripSequenceEditionStubs_dripSequence_editions;
}

export interface GetDripSequenceEditionStubs {
  /**
   * Returns an email marketing drip sequence.
   */
  dripSequence: GetDripSequenceEditionStubs_dripSequence | null;
}

export interface GetDripSequenceEditionStubsVariables {
  limit: number;
  cursor?: string | null;
  dripSequenceId: string;
  isArchived?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDripSequenceEditions
// ====================================================

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: GetDripSequenceEditions_dripSequence_editions_edges_node_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: GetDripSequenceEditions_dripSequence_editions_edges_node_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: GetDripSequenceEditions_dripSequence_editions_edges_node_campaign_nextSendingEdition | null;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: GetDripSequenceEditions_dripSequence_editions_edges_node_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: GetDripSequenceEditions_dripSequence_editions_edges_node_emailTemplate_links[];
  name: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: GetDripSequenceEditions_dripSequence_editions_edges_node_comparisonEdition_emailTemplate_links_url | null;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: GetDripSequenceEditions_dripSequence_editions_edges_node_comparisonEdition_emailTemplate_links[];
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: GetDripSequenceEditions_dripSequence_editions_edges_node_comparisonEdition_emailTemplate | null;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetDripSequenceEditions_dripSequence_editions_edges_node_comparison_winnerEdition_emailTemplate | null;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: GetDripSequenceEditions_dripSequence_editions_edges_node_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: GetDripSequenceEditions_dripSequence_editions_edges_node_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: GetDripSequenceEditions_dripSequence_editions_edges_node_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: GetDripSequenceEditions_dripSequence_editions_edges_node_comparison_winningEdition | null;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: GetDripSequenceEditions_dripSequence_editions_edges_node_audience_fromSavedFilter_count;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetDripSequenceEditions_dripSequence_editions_edges_node_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetDripSequenceEditions_dripSequence_editions_edges_node_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: GetDripSequenceEditions_dripSequence_editions_edges_node_audience_fromSavedFilter | null;
  membershipStats: GetDripSequenceEditions_dripSequence_editions_edges_node_audience_membershipStats;
  smsMembershipStats: GetDripSequenceEditions_dripSequence_editions_edges_node_audience_smsMembershipStats;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: GetDripSequenceEditions_dripSequence_editions_edges_node_from_emailAddress;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: GetDripSequenceEditions_dripSequence_editions_edges_node_from_fromDomain | null;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_gateError {
  __typename: "GateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity = GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Account | GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges_node;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions_edges[];
}

export interface GetDripSequenceEditions_dripSequence_editions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: GetDripSequenceEditions_dripSequence_editions_edges_node_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetDripSequenceEditions_dripSequence_editions_edges_node_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: GetDripSequenceEditions_dripSequence_editions_edges_node_emailTemplate | null;
  engagementStats: GetDripSequenceEditions_dripSequence_editions_edges_node_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: GetDripSequenceEditions_dripSequence_editions_edges_node_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: GetDripSequenceEditions_dripSequence_editions_edges_node_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: GetDripSequenceEditions_dripSequence_editions_edges_node_audience | null;
  /**
   * The address to send this edition from
   */
  from: GetDripSequenceEditions_dripSequence_editions_edges_node_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: GetDripSequenceEditions_dripSequence_editions_edges_node_delay | null;
  /**
   * The number of emails sent for this edition
   */
  numSentEmails: number;
  /**
   * The custom click domain that this edition will use to track links, if there is one
   */
  customClickDomain: GetDripSequenceEditions_dripSequence_editions_edges_node_customClickDomain | null;
  utmParameters: GetDripSequenceEditions_dripSequence_editions_edges_node_utmParameters;
  defaultUtmParameters: GetDripSequenceEditions_dripSequence_editions_edges_node_defaultUtmParameters;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  useUtmParameters: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: GetDripSequenceEditions_dripSequence_editions_edges_node_gateError | null;
  /**
   * Boolean indicating if the edition is using a web font.
   */
  hasWebFonts: boolean;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: GetDripSequenceEditions_dripSequence_editions_edges_node_queuedDripProgressions | null;
  /**
   * The maximum number of recipients this edition can send to, if DMARC is not
   * fully configured. This is only relevant for non-drip sequence editions.
   */
  recipientLimitForDeliverability: number | null;
}

export interface GetDripSequenceEditions_dripSequence_editions_edges {
  __typename: "EditionsEdge";
  cursor: string;
  node: GetDripSequenceEditions_dripSequence_editions_edges_node;
}

export interface GetDripSequenceEditions_dripSequence_editions {
  __typename: "EditionsConnection";
  /**
   * A list of edges.
   */
  edges: GetDripSequenceEditions_dripSequence_editions_edges[];
}

export interface GetDripSequenceEditions_dripSequence {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  editions: GetDripSequenceEditions_dripSequence_editions;
}

export interface GetDripSequenceEditions {
  /**
   * Returns an email marketing drip sequence.
   */
  dripSequence: GetDripSequenceEditions_dripSequence | null;
}

export interface GetDripSequenceEditionsVariables {
  limit: number;
  cursor?: string | null;
  dripSequenceId: string;
  isArchived?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateDripSequence
// ====================================================

export interface CreateDripSequence_dripSequenceCreate_dripSequence_startTrigger_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface CreateDripSequence_dripSequenceCreate_dripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface CreateDripSequence_dripSequenceCreate_dripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface CreateDripSequence_dripSequenceCreate_dripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type CreateDripSequence_dripSequenceCreate_dripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter = CreateDripSequence_dripSequenceCreate_dripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | CreateDripSequence_dripSequenceCreate_dripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | CreateDripSequence_dripSequenceCreate_dripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface CreateDripSequence_dripSequenceCreate_dripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: CreateDripSequence_dripSequenceCreate_dripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface CreateDripSequence_dripSequenceCreate_dripSequence_startTrigger_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface CreateDripSequence_dripSequenceCreate_dripSequence_startTrigger_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type CreateDripSequence_dripSequenceCreate_dripSequence_startTrigger_conditions_config = CreateDripSequence_dripSequenceCreate_dripSequence_startTrigger_conditions_config_ConditionConfigLink | CreateDripSequence_dripSequenceCreate_dripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter | CreateDripSequence_dripSequenceCreate_dripSequence_startTrigger_conditions_config_ConditionConfigTag | CreateDripSequence_dripSequenceCreate_dripSequence_startTrigger_conditions_config_ConditionConfigAudience;

export interface CreateDripSequence_dripSequenceCreate_dripSequence_startTrigger_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: CreateDripSequence_dripSequenceCreate_dripSequence_startTrigger_conditions_config;
}

export interface CreateDripSequence_dripSequenceCreate_dripSequence_startTrigger {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of startTrigger
   */
  type: StartTriggerType;
  /**
   * A list of conditions which must be true to activate this startTrigger.
   */
  conditions: CreateDripSequence_dripSequenceCreate_dripSequence_startTrigger_conditions[];
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface CreateDripSequence_dripSequenceCreate_dripSequence_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateDripSequence_dripSequenceCreate_dripSequence_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface CreateDripSequence_dripSequenceCreate_dripSequence_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * The last time this particular piece of content was sent. This is slow to
   * calculate on a one-off basis so we chuck it in here.
   */
  latestDeliveryTime: any | null;
  /**
   * For edition base stats, the total number of drip progressions in any state for the related campaigns
   */
  dripProgressionTotalRecipients: number;
  /**
   * For edition base stats, the number of drip progressions that have stopped for the related campaigns
   */
  dripProgressionsStopped: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
  /**
   * For edition base stats, the percentage of drip progressions that received every message for the related campaigns
   */
  dripProgressionsReceivedEveryMessageRate: number | null;
}

export interface CreateDripSequence_dripSequenceCreate_dripSequence_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
}

export interface CreateDripSequence_dripSequenceCreate_dripSequence_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: CreateDripSequence_dripSequenceCreate_dripSequence_from_emailAddress;
}

export interface CreateDripSequence_dripSequenceCreate_dripSequence {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The start trigger for the drip sequence
   */
  startTrigger: CreateDripSequence_dripSequenceCreate_dripSequence_startTrigger | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  creatorUser: CreateDripSequence_dripSequenceCreate_dripSequence_creatorUser | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The DateTime that represents when the campaign was last modified
   */
  modifiedTime: any | null;
  /**
   * Time of the last campaign status change. For example, if a customer activated
   * this sequence and its still active, this would be the time the sequence was
   * activated. Once the campaign status is changed (paused, retired, etc) this
   * would reflect that new time
   */
  lastStatusChangeTime: any | null;
  editions: CreateDripSequence_dripSequenceCreate_dripSequence_editions;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * Whether the drip sequence should have a remove option
   */
  isRemovable: boolean;
  engagementStats: CreateDripSequence_dripSequenceCreate_dripSequence_engagementStats;
  /**
   * The address to send this edition from
   */
  from: CreateDripSequence_dripSequenceCreate_dripSequence_from | null;
}

export interface CreateDripSequence_dripSequenceCreate {
  __typename: "DripSequenceCreatePayload";
  /**
   * The newly created drip sequence
   */
  dripSequence: CreateDripSequence_dripSequenceCreate_dripSequence;
}

export interface CreateDripSequence {
  /**
   * Create a new email marketing dripSequence
   */
  dripSequenceCreate: CreateDripSequence_dripSequenceCreate | null;
}

export interface CreateDripSequenceVariables {
  dripSequence: DripSequenceCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteDripSequence
// ====================================================

export interface DeleteDripSequence_campaignDelete_campaign {
  __typename: "Campaign" | "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteDripSequence_campaignDelete {
  __typename: "CampaignDeletePayload";
  /**
   * The campaign
   */
  campaign: DeleteDripSequence_campaignDelete_campaign;
}

export interface DeleteDripSequence {
  /**
   * Delete a campaign and associated content.
   */
  campaignDelete: DeleteDripSequence_campaignDelete | null;
}

export interface DeleteDripSequenceVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DuplicateDripSequence
// ====================================================

export interface DuplicateDripSequence_dripSequenceDuplicate_dripSequence {
  __typename: "Campaign" | "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface DuplicateDripSequence_dripSequenceDuplicate {
  __typename: "DripSequenceDuplicatePayload";
  /**
   * The newly duplicated drip sequence
   */
  dripSequence: DuplicateDripSequence_dripSequenceDuplicate_dripSequence;
}

export interface DuplicateDripSequence {
  /**
   * Duplicate an existing email marketing drip sequence
   */
  dripSequenceDuplicate: DuplicateDripSequence_dripSequenceDuplicate | null;
}

export interface DuplicateDripSequenceVariables {
  input: DripSequenceDuplicateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RestoreDripSequence
// ====================================================

export interface RestoreDripSequence_campaignRestore_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface RestoreDripSequence_campaignRestore {
  __typename: "CampaignRestorePayload";
  /**
   * The campaign
   */
  campaign: RestoreDripSequence_campaignRestore_campaign;
}

export interface RestoreDripSequence {
  /**
   * Restore an email campaign
   */
  campaignRestore: RestoreDripSequence_campaignRestore | null;
}

export interface RestoreDripSequenceVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateDripSequence
// ====================================================

export interface UpdateDripSequence_campaignUpdate_campaign_startTrigger_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface UpdateDripSequence_campaignUpdate_campaign_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface UpdateDripSequence_campaignUpdate_campaign_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface UpdateDripSequence_campaignUpdate_campaign_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type UpdateDripSequence_campaignUpdate_campaign_startTrigger_conditions_config_ConditionConfigEntityFilter_filter = UpdateDripSequence_campaignUpdate_campaign_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | UpdateDripSequence_campaignUpdate_campaign_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | UpdateDripSequence_campaignUpdate_campaign_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface UpdateDripSequence_campaignUpdate_campaign_startTrigger_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: UpdateDripSequence_campaignUpdate_campaign_startTrigger_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface UpdateDripSequence_campaignUpdate_campaign_startTrigger_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface UpdateDripSequence_campaignUpdate_campaign_startTrigger_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type UpdateDripSequence_campaignUpdate_campaign_startTrigger_conditions_config = UpdateDripSequence_campaignUpdate_campaign_startTrigger_conditions_config_ConditionConfigLink | UpdateDripSequence_campaignUpdate_campaign_startTrigger_conditions_config_ConditionConfigEntityFilter | UpdateDripSequence_campaignUpdate_campaign_startTrigger_conditions_config_ConditionConfigTag | UpdateDripSequence_campaignUpdate_campaign_startTrigger_conditions_config_ConditionConfigAudience;

export interface UpdateDripSequence_campaignUpdate_campaign_startTrigger_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: UpdateDripSequence_campaignUpdate_campaign_startTrigger_conditions_config;
}

export interface UpdateDripSequence_campaignUpdate_campaign_startTrigger {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of startTrigger
   */
  type: StartTriggerType;
  /**
   * A list of conditions which must be true to activate this startTrigger.
   */
  conditions: UpdateDripSequence_campaignUpdate_campaign_startTrigger_conditions[];
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface UpdateDripSequence_campaignUpdate_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateDripSequence_campaignUpdate_campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface UpdateDripSequence_campaignUpdate_campaign_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * The last time this particular piece of content was sent. This is slow to
   * calculate on a one-off basis so we chuck it in here.
   */
  latestDeliveryTime: any | null;
  /**
   * For edition base stats, the total number of drip progressions in any state for the related campaigns
   */
  dripProgressionTotalRecipients: number;
  /**
   * For edition base stats, the number of drip progressions that have stopped for the related campaigns
   */
  dripProgressionsStopped: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
  /**
   * For edition base stats, the percentage of drip progressions that received every message for the related campaigns
   */
  dripProgressionsReceivedEveryMessageRate: number | null;
}

export interface UpdateDripSequence_campaignUpdate_campaign_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
}

export interface UpdateDripSequence_campaignUpdate_campaign_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: UpdateDripSequence_campaignUpdate_campaign_from_emailAddress;
}

export interface UpdateDripSequence_campaignUpdate_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The start trigger for the drip sequence
   */
  startTrigger: UpdateDripSequence_campaignUpdate_campaign_startTrigger | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  creatorUser: UpdateDripSequence_campaignUpdate_campaign_creatorUser | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The DateTime that represents when the campaign was last modified
   */
  modifiedTime: any | null;
  /**
   * Time of the last campaign status change. For example, if a customer activated
   * this sequence and its still active, this would be the time the sequence was
   * activated. Once the campaign status is changed (paused, retired, etc) this
   * would reflect that new time
   */
  lastStatusChangeTime: any | null;
  editions: UpdateDripSequence_campaignUpdate_campaign_editions;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * Whether the drip sequence should have a remove option
   */
  isRemovable: boolean;
  engagementStats: UpdateDripSequence_campaignUpdate_campaign_engagementStats;
  /**
   * The address to send this edition from
   */
  from: UpdateDripSequence_campaignUpdate_campaign_from | null;
}

export interface UpdateDripSequence_campaignUpdate {
  __typename: "CampaignUpdatePayload";
  /**
   * The campaign
   */
  campaign: UpdateDripSequence_campaignUpdate_campaign;
}

export interface UpdateDripSequence {
  /**
   * Save the template data for an email marketing campaign
   */
  campaignUpdate: UpdateDripSequence_campaignUpdate | null;
}

export interface UpdateDripSequenceVariables {
  dripSequence: CampaignUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDripSequence
// ====================================================

export interface GetDripSequence_campaign_startTrigger_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface GetDripSequence_campaign_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface GetDripSequence_campaign_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface GetDripSequence_campaign_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type GetDripSequence_campaign_startTrigger_conditions_config_ConditionConfigEntityFilter_filter = GetDripSequence_campaign_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | GetDripSequence_campaign_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | GetDripSequence_campaign_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface GetDripSequence_campaign_startTrigger_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: GetDripSequence_campaign_startTrigger_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface GetDripSequence_campaign_startTrigger_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface GetDripSequence_campaign_startTrigger_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type GetDripSequence_campaign_startTrigger_conditions_config = GetDripSequence_campaign_startTrigger_conditions_config_ConditionConfigLink | GetDripSequence_campaign_startTrigger_conditions_config_ConditionConfigEntityFilter | GetDripSequence_campaign_startTrigger_conditions_config_ConditionConfigTag | GetDripSequence_campaign_startTrigger_conditions_config_ConditionConfigAudience;

export interface GetDripSequence_campaign_startTrigger_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: GetDripSequence_campaign_startTrigger_conditions_config;
}

export interface GetDripSequence_campaign_startTrigger {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of startTrigger
   */
  type: StartTriggerType;
  /**
   * A list of conditions which must be true to activate this startTrigger.
   */
  conditions: GetDripSequence_campaign_startTrigger_conditions[];
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface GetDripSequence_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetDripSequence_campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetDripSequence_campaign_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * The last time this particular piece of content was sent. This is slow to
   * calculate on a one-off basis so we chuck it in here.
   */
  latestDeliveryTime: any | null;
  /**
   * For edition base stats, the total number of drip progressions in any state for the related campaigns
   */
  dripProgressionTotalRecipients: number;
  /**
   * For edition base stats, the number of drip progressions that have stopped for the related campaigns
   */
  dripProgressionsStopped: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
  /**
   * For edition base stats, the percentage of drip progressions that received every message for the related campaigns
   */
  dripProgressionsReceivedEveryMessageRate: number | null;
}

export interface GetDripSequence_campaign_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface GetDripSequence_campaign_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface GetDripSequence_campaign_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: GetDripSequence_campaign_from_emailAddress;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: GetDripSequence_campaign_from_fromDomain | null;
}

export interface GetDripSequence_campaign_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
}

export interface GetDripSequence_campaign_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
}

export interface GetDripSequence_campaign_goal_conditions_config_ConditionConfigSourceEntity {
  __typename: "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface GetDripSequence_campaign_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface GetDripSequence_campaign_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface GetDripSequence_campaign_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type GetDripSequence_campaign_goal_conditions_config_ConditionConfigEntityFilter_filter = GetDripSequence_campaign_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | GetDripSequence_campaign_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | GetDripSequence_campaign_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface GetDripSequence_campaign_goal_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: GetDripSequence_campaign_goal_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface GetDripSequence_campaign_goal_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export interface GetDripSequence_campaign_goal_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface GetDripSequence_campaign_goal_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type GetDripSequence_campaign_goal_conditions_config = GetDripSequence_campaign_goal_conditions_config_ConditionConfigSourceEntity | GetDripSequence_campaign_goal_conditions_config_ConditionConfigEntityFilter | GetDripSequence_campaign_goal_conditions_config_ConditionConfigLink | GetDripSequence_campaign_goal_conditions_config_ConditionConfigTag | GetDripSequence_campaign_goal_conditions_config_ConditionConfigAudience;

export interface GetDripSequence_campaign_goal_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: GetDripSequence_campaign_goal_conditions_config;
}

export interface GetDripSequence_campaign_goal_action_config_ActionConfigRemoveTags {
  __typename: "ActionConfigRemoveTags" | "ActionConfigSendPageViewedNotification" | "ActionConfigAddToDripSequence" | "ActionConfigCreateLead" | "ActionConfigSendEmail";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
}

export interface GetDripSequence_campaign_goal_action_config_ActionConfigAddTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetDripSequence_campaign_goal_action_config_ActionConfigAddTags {
  __typename: "ActionConfigAddTags";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  tags: GetDripSequence_campaign_goal_action_config_ActionConfigAddTags_tags[];
}

export interface GetDripSequence_campaign_goal_action_config_ActionConfigAddAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetDripSequence_campaign_goal_action_config_ActionConfigAddAudiences {
  __typename: "ActionConfigAddAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: GetDripSequence_campaign_goal_action_config_ActionConfigAddAudiences_audiences[];
}

export interface GetDripSequence_campaign_goal_action_config_ActionConfigRemoveAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetDripSequence_campaign_goal_action_config_ActionConfigRemoveAudiences {
  __typename: "ActionConfigRemoveAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: GetDripSequence_campaign_goal_action_config_ActionConfigRemoveAudiences_audiences[];
}

export type GetDripSequence_campaign_goal_action_config = GetDripSequence_campaign_goal_action_config_ActionConfigRemoveTags | GetDripSequence_campaign_goal_action_config_ActionConfigAddTags | GetDripSequence_campaign_goal_action_config_ActionConfigAddAudiences | GetDripSequence_campaign_goal_action_config_ActionConfigRemoveAudiences;

export interface GetDripSequence_campaign_goal_action {
  __typename: "Action";
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * Human readable title of this action
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this action. This is essentially just the
   * stringified version of the action’s conditions, but because a action can have
   * multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The configuration for this action.
   */
  config: GetDripSequence_campaign_goal_action_config;
}

export interface GetDripSequence_campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Calculated goal type based on conditions. This is not saved in the database
   */
  type: DripSequenceGoalType;
  /**
   * A list of conditions which must be true to activate this goal.
   */
  conditions: GetDripSequence_campaign_goal_conditions[];
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this goal. This is essentially just the stringified
   * version of the goal’s conditions, but because a goal can have multiple
   * conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The optional action (next step in this context) that will run when this goal is met
   */
  action: GetDripSequence_campaign_goal_action | null;
}

export interface GetDripSequence_campaign_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface GetDripSequence_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The start trigger for the drip sequence
   */
  startTrigger: GetDripSequence_campaign_startTrigger | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  creatorUser: GetDripSequence_campaign_creatorUser | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The DateTime that represents when the campaign was last modified
   */
  modifiedTime: any | null;
  /**
   * Time of the last campaign status change. For example, if a customer activated
   * this sequence and its still active, this would be the time the sequence was
   * activated. Once the campaign status is changed (paused, retired, etc) this
   * would reflect that new time
   */
  lastStatusChangeTime: any | null;
  editions: GetDripSequence_campaign_editions;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * Whether the drip sequence should have a remove option
   */
  isRemovable: boolean;
  engagementStats: GetDripSequence_campaign_engagementStats;
  /**
   * The address to send this edition from
   */
  from: GetDripSequence_campaign_from | null;
  useUtmParameters: boolean;
  utmParameters: GetDripSequence_campaign_utmParameters;
  defaultUtmParameters: GetDripSequence_campaign_defaultUtmParameters;
  /**
   * Should messages only be sent during business hours.
   */
  isBusinessHoursOnly: boolean;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * When a lead is closed, should drip sequences stop?
   */
  isStopOnLeadClose: boolean;
  /**
   * When a person is removed from an audience, should drip sequences stop?
   */
  isStopOnRemovedFromAudience: boolean;
  /**
   * The newly created Nutshell goal
   */
  goal: GetDripSequence_campaign_goal | null;
  /**
   * Number of in progress drip progressions for the drip sequence
   */
  numInProgressDripProgressions: number;
  /**
   * The custom click domain that this campaign will use to track links, if there is one
   */
  customClickDomain: GetDripSequence_campaign_customClickDomain | null;
}

export interface GetDripSequence {
  /**
   * Returns an email marketing campaign.
   */
  campaign: GetDripSequence_campaign | null;
}

export interface GetDripSequenceVariables {
  dripSequenceId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDripSequences
// ====================================================

export interface GetDripSequences_dripSequences_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetDripSequences_dripSequences_edges_node_startTrigger_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface GetDripSequences_dripSequences_edges_node_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface GetDripSequences_dripSequences_edges_node_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface GetDripSequences_dripSequences_edges_node_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type GetDripSequences_dripSequences_edges_node_startTrigger_conditions_config_ConditionConfigEntityFilter_filter = GetDripSequences_dripSequences_edges_node_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | GetDripSequences_dripSequences_edges_node_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | GetDripSequences_dripSequences_edges_node_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface GetDripSequences_dripSequences_edges_node_startTrigger_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: GetDripSequences_dripSequences_edges_node_startTrigger_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface GetDripSequences_dripSequences_edges_node_startTrigger_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface GetDripSequences_dripSequences_edges_node_startTrigger_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type GetDripSequences_dripSequences_edges_node_startTrigger_conditions_config = GetDripSequences_dripSequences_edges_node_startTrigger_conditions_config_ConditionConfigLink | GetDripSequences_dripSequences_edges_node_startTrigger_conditions_config_ConditionConfigEntityFilter | GetDripSequences_dripSequences_edges_node_startTrigger_conditions_config_ConditionConfigTag | GetDripSequences_dripSequences_edges_node_startTrigger_conditions_config_ConditionConfigAudience;

export interface GetDripSequences_dripSequences_edges_node_startTrigger_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: GetDripSequences_dripSequences_edges_node_startTrigger_conditions_config;
}

export interface GetDripSequences_dripSequences_edges_node_startTrigger {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of startTrigger
   */
  type: StartTriggerType;
  /**
   * A list of conditions which must be true to activate this startTrigger.
   */
  conditions: GetDripSequences_dripSequences_edges_node_startTrigger_conditions[];
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface GetDripSequences_dripSequences_edges_node_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetDripSequences_dripSequences_edges_node_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetDripSequences_dripSequences_edges_node_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * The last time this particular piece of content was sent. This is slow to
   * calculate on a one-off basis so we chuck it in here.
   */
  latestDeliveryTime: any | null;
  /**
   * For edition base stats, the total number of drip progressions in any state for the related campaigns
   */
  dripProgressionTotalRecipients: number;
  /**
   * For edition base stats, the number of drip progressions that have stopped for the related campaigns
   */
  dripProgressionsStopped: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
  /**
   * For edition base stats, the percentage of drip progressions that received every message for the related campaigns
   */
  dripProgressionsReceivedEveryMessageRate: number | null;
}

export interface GetDripSequences_dripSequences_edges_node_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
}

export interface GetDripSequences_dripSequences_edges_node_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: GetDripSequences_dripSequences_edges_node_from_emailAddress;
}

export interface GetDripSequences_dripSequences_edges_node {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The start trigger for the drip sequence
   */
  startTrigger: GetDripSequences_dripSequences_edges_node_startTrigger | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  creatorUser: GetDripSequences_dripSequences_edges_node_creatorUser | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The DateTime that represents when the campaign was last modified
   */
  modifiedTime: any | null;
  /**
   * Time of the last campaign status change. For example, if a customer activated
   * this sequence and its still active, this would be the time the sequence was
   * activated. Once the campaign status is changed (paused, retired, etc) this
   * would reflect that new time
   */
  lastStatusChangeTime: any | null;
  editions: GetDripSequences_dripSequences_edges_node_editions;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * Whether the drip sequence should have a remove option
   */
  isRemovable: boolean;
  engagementStats: GetDripSequences_dripSequences_edges_node_engagementStats;
  /**
   * The address to send this edition from
   */
  from: GetDripSequences_dripSequences_edges_node_from | null;
}

export interface GetDripSequences_dripSequences_edges {
  __typename: "CampaignsEdge";
  cursor: string;
  node: GetDripSequences_dripSequences_edges_node;
}

export interface GetDripSequences_dripSequences {
  __typename: "CampaignsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetDripSequences_dripSequences_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetDripSequences_dripSequences_edges[];
}

export interface GetDripSequences {
  /**
   * Returns a paging connection of email drip sequences from the root of our query.
   */
  dripSequences: GetDripSequences_dripSequences;
}

export interface GetDripSequencesVariables {
  limit: number;
  archived: boolean;
  cursor?: string | null;
  sort: DripSequenceSortType;
  search?: string | null;
  creatorUserId?: string | null;
  lastUpdatedTime?: string | null;
  statuses?: CampaignStatus[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetNewsletterEditions
// ====================================================

export interface GetNewsletterEditions_newsletter_editions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: GetNewsletterEditions_newsletter_editions_edges_node_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: GetNewsletterEditions_newsletter_editions_edges_node_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: GetNewsletterEditions_newsletter_editions_edges_node_campaign_nextSendingEdition | null;
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: GetNewsletterEditions_newsletter_editions_edges_node_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: GetNewsletterEditions_newsletter_editions_edges_node_emailTemplate_links[];
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: GetNewsletterEditions_newsletter_editions_edges_node_comparisonEdition_emailTemplate_links_url | null;
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: GetNewsletterEditions_newsletter_editions_edges_node_comparisonEdition_emailTemplate_links[];
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: GetNewsletterEditions_newsletter_editions_edges_node_comparisonEdition_emailTemplate | null;
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetNewsletterEditions_newsletter_editions_edges_node_comparison_winnerEdition_emailTemplate | null;
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: GetNewsletterEditions_newsletter_editions_edges_node_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: GetNewsletterEditions_newsletter_editions_edges_node_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: GetNewsletterEditions_newsletter_editions_edges_node_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: GetNewsletterEditions_newsletter_editions_edges_node_comparison_winningEdition | null;
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: GetNewsletterEditions_newsletter_editions_edges_node_from_emailAddress;
}

export interface GetNewsletterEditions_newsletter_editions_edges_node_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetNewsletterEditions_newsletter_editions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: GetNewsletterEditions_newsletter_editions_edges_node_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetNewsletterEditions_newsletter_editions_edges_node_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: GetNewsletterEditions_newsletter_editions_edges_node_emailTemplate | null;
  engagementStats: GetNewsletterEditions_newsletter_editions_edges_node_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: GetNewsletterEditions_newsletter_editions_edges_node_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: GetNewsletterEditions_newsletter_editions_edges_node_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: GetNewsletterEditions_newsletter_editions_edges_node_audience | null;
  /**
   * The address to send this edition from
   */
  from: GetNewsletterEditions_newsletter_editions_edges_node_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: GetNewsletterEditions_newsletter_editions_edges_node_delay | null;
}

export interface GetNewsletterEditions_newsletter_editions_edges {
  __typename: "EditionsEdge";
  cursor: string;
  node: GetNewsletterEditions_newsletter_editions_edges_node;
}

export interface GetNewsletterEditions_newsletter_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetNewsletterEditions_newsletter_editions_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetNewsletterEditions_newsletter_editions_edges[];
}

export interface GetNewsletterEditions_newsletter {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  editions: GetNewsletterEditions_newsletter_editions;
}

export interface GetNewsletterEditions {
  /**
   * Returns an email marketing newsletter.
   */
  newsletter: GetNewsletterEditions_newsletter | null;
}

export interface GetNewsletterEditionsVariables {
  limit: number;
  cursor?: string | null;
  newsletterId: string;
  isArchived?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateEdition
// ====================================================

export interface CreateEdition_editionCreate_edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateEdition_editionCreate_edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateEdition_editionCreate_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateEdition_editionCreate_edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface CreateEdition_editionCreate_edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: CreateEdition_editionCreate_edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: CreateEdition_editionCreate_edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: CreateEdition_editionCreate_edition_campaign_nextSendingEdition | null;
}

export interface CreateEdition_editionCreate_edition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface CreateEdition_editionCreate_edition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: CreateEdition_editionCreate_edition_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface CreateEdition_editionCreate_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: CreateEdition_editionCreate_edition_emailTemplate_links[];
}

export interface CreateEdition_editionCreate_edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface CreateEdition_editionCreate_edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface CreateEdition_editionCreate_edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: CreateEdition_editionCreate_edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface CreateEdition_editionCreate_edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: CreateEdition_editionCreate_edition_comparisonEdition_emailTemplate_links[];
}

export interface CreateEdition_editionCreate_edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: CreateEdition_editionCreate_edition_comparisonEdition_emailTemplate | null;
}

export interface CreateEdition_editionCreate_edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface CreateEdition_editionCreate_edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface CreateEdition_editionCreate_edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: CreateEdition_editionCreate_edition_comparison_winnerEdition_emailTemplate | null;
}

export interface CreateEdition_editionCreate_edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface CreateEdition_editionCreate_edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateEdition_editionCreate_edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: CreateEdition_editionCreate_edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: CreateEdition_editionCreate_edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: CreateEdition_editionCreate_edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: CreateEdition_editionCreate_edition_comparison_winningEdition | null;
}

export interface CreateEdition_editionCreate_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface CreateEdition_editionCreate_edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
}

export interface CreateEdition_editionCreate_edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: CreateEdition_editionCreate_edition_from_emailAddress;
}

export interface CreateEdition_editionCreate_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface CreateEdition_editionCreate_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: CreateEdition_editionCreate_edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: CreateEdition_editionCreate_edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: CreateEdition_editionCreate_edition_emailTemplate | null;
  engagementStats: CreateEdition_editionCreate_edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: CreateEdition_editionCreate_edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: CreateEdition_editionCreate_edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: CreateEdition_editionCreate_edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: CreateEdition_editionCreate_edition_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: CreateEdition_editionCreate_edition_delay | null;
}

export interface CreateEdition_editionCreate {
  __typename: "EditionCreatePayload";
  /**
   * The new edition
   */
  edition: CreateEdition_editionCreate_edition;
}

export interface CreateEdition {
  /**
   * Create a new email marketing edition
   */
  editionCreate: CreateEdition_editionCreate | null;
}

export interface CreateEditionVariables {
  edition: EditionCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteEdition
// ====================================================

export interface DeleteEdition_editionDelete_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteEdition_editionDelete {
  __typename: "EditionDeletePayload";
  /**
   * The edition
   */
  edition: DeleteEdition_editionDelete_edition;
}

export interface DeleteEdition {
  /**
   * Delete an email edition and its corresponding email template
   */
  editionDelete: DeleteEdition_editionDelete | null;
}

export interface DeleteEditionVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DuplicateEdition
// ====================================================

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_campaign_nextSendingEdition | null;
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_emailTemplate_links[];
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_comparisonEdition_emailTemplate_links[];
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_comparisonEdition_emailTemplate | null;
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_comparison_winnerEdition_emailTemplate | null;
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_comparison_winningEdition | null;
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_from_emailAddress;
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_emailTemplate | null;
  engagementStats: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: DuplicateEdition_editionDuplicateToNewsletterEdition_edition_delay | null;
}

export interface DuplicateEdition_editionDuplicateToNewsletterEdition {
  __typename: "EditionDuplicateToNewsletterEditionPayload";
  /**
   * The duplicated edition
   */
  edition: DuplicateEdition_editionDuplicateToNewsletterEdition_edition;
}

export interface DuplicateEdition {
  /**
   * Duplicate an existing email marketing edition
   */
  editionDuplicateToNewsletterEdition: DuplicateEdition_editionDuplicateToNewsletterEdition | null;
}

export interface DuplicateEditionVariables {
  edition: EditionDuplicateToNewsletterEditionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RestoreEdition
// ====================================================

export interface RestoreEdition_editionRestore_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface RestoreEdition_editionRestore {
  __typename: "EditionRestorePayload";
  /**
   * The edition
   */
  edition: RestoreEdition_editionRestore_edition;
}

export interface RestoreEdition {
  /**
   * Restore an email edition and its corresponding email template
   */
  editionRestore: RestoreEdition_editionRestore | null;
}

export interface RestoreEditionVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateEdition
// ====================================================

export interface UpdateEdition_editionUpdate_edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateEdition_editionUpdate_edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateEdition_editionUpdate_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateEdition_editionUpdate_edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface UpdateEdition_editionUpdate_edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: UpdateEdition_editionUpdate_edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: UpdateEdition_editionUpdate_edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: UpdateEdition_editionUpdate_edition_campaign_nextSendingEdition | null;
}

export interface UpdateEdition_editionUpdate_edition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface UpdateEdition_editionUpdate_edition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: UpdateEdition_editionUpdate_edition_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface UpdateEdition_editionUpdate_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: UpdateEdition_editionUpdate_edition_emailTemplate_links[];
  name: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface UpdateEdition_editionUpdate_edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface UpdateEdition_editionUpdate_edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface UpdateEdition_editionUpdate_edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: UpdateEdition_editionUpdate_edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface UpdateEdition_editionUpdate_edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: UpdateEdition_editionUpdate_edition_comparisonEdition_emailTemplate_links[];
}

export interface UpdateEdition_editionUpdate_edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: UpdateEdition_editionUpdate_edition_comparisonEdition_emailTemplate | null;
}

export interface UpdateEdition_editionUpdate_edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface UpdateEdition_editionUpdate_edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface UpdateEdition_editionUpdate_edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: UpdateEdition_editionUpdate_edition_comparison_winnerEdition_emailTemplate | null;
}

export interface UpdateEdition_editionUpdate_edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface UpdateEdition_editionUpdate_edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateEdition_editionUpdate_edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: UpdateEdition_editionUpdate_edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: UpdateEdition_editionUpdate_edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: UpdateEdition_editionUpdate_edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: UpdateEdition_editionUpdate_edition_comparison_winningEdition | null;
}

export interface UpdateEdition_editionUpdate_edition_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface UpdateEdition_editionUpdate_edition_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: UpdateEdition_editionUpdate_edition_audience_fromSavedFilter_count;
}

export interface UpdateEdition_editionUpdate_edition_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface UpdateEdition_editionUpdate_edition_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: UpdateEdition_editionUpdate_edition_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface UpdateEdition_editionUpdate_edition_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface UpdateEdition_editionUpdate_edition_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: UpdateEdition_editionUpdate_edition_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface UpdateEdition_editionUpdate_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: UpdateEdition_editionUpdate_edition_audience_fromSavedFilter | null;
  membershipStats: UpdateEdition_editionUpdate_edition_audience_membershipStats;
  smsMembershipStats: UpdateEdition_editionUpdate_edition_audience_smsMembershipStats;
}

export interface UpdateEdition_editionUpdate_edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface UpdateEdition_editionUpdate_edition_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface UpdateEdition_editionUpdate_edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: UpdateEdition_editionUpdate_edition_from_emailAddress;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: UpdateEdition_editionUpdate_edition_from_fromDomain | null;
}

export interface UpdateEdition_editionUpdate_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface UpdateEdition_editionUpdate_edition_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface UpdateEdition_editionUpdate_edition_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface UpdateEdition_editionUpdate_edition_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface UpdateEdition_editionUpdate_edition_gateError {
  __typename: "GateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface UpdateEdition_editionUpdate_edition_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity = UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account | UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges_node;
}

export interface UpdateEdition_editionUpdate_edition_queuedDripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: UpdateEdition_editionUpdate_edition_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: UpdateEdition_editionUpdate_edition_queuedDripProgressions_edges[];
}

export interface UpdateEdition_editionUpdate_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: UpdateEdition_editionUpdate_edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: UpdateEdition_editionUpdate_edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: UpdateEdition_editionUpdate_edition_emailTemplate | null;
  engagementStats: UpdateEdition_editionUpdate_edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: UpdateEdition_editionUpdate_edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: UpdateEdition_editionUpdate_edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: UpdateEdition_editionUpdate_edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: UpdateEdition_editionUpdate_edition_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: UpdateEdition_editionUpdate_edition_delay | null;
  /**
   * The number of emails sent for this edition
   */
  numSentEmails: number;
  /**
   * The custom click domain that this edition will use to track links, if there is one
   */
  customClickDomain: UpdateEdition_editionUpdate_edition_customClickDomain | null;
  utmParameters: UpdateEdition_editionUpdate_edition_utmParameters;
  defaultUtmParameters: UpdateEdition_editionUpdate_edition_defaultUtmParameters;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  useUtmParameters: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: UpdateEdition_editionUpdate_edition_gateError | null;
  /**
   * Boolean indicating if the edition is using a web font.
   */
  hasWebFonts: boolean;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: UpdateEdition_editionUpdate_edition_queuedDripProgressions | null;
  /**
   * The maximum number of recipients this edition can send to, if DMARC is not
   * fully configured. This is only relevant for non-drip sequence editions.
   */
  recipientLimitForDeliverability: number | null;
}

export interface UpdateEdition_editionUpdate {
  __typename: "EditionUpdatePayload";
  /**
   * The edition
   */
  edition: UpdateEdition_editionUpdate_edition;
}

export interface UpdateEdition {
  /**
   * Save the template data for an email marketing edition
   */
  editionUpdate: UpdateEdition_editionUpdate | null;
}

export interface UpdateEditionVariables {
  edition: EditionUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEdition
// ====================================================

export interface GetEdition_edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEdition_edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEdition_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEdition_edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetEdition_edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: GetEdition_edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: GetEdition_edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: GetEdition_edition_campaign_nextSendingEdition | null;
}

export interface GetEdition_edition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetEdition_edition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: GetEdition_edition_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface GetEdition_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: GetEdition_edition_emailTemplate_links[];
  name: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface GetEdition_edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface GetEdition_edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetEdition_edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: GetEdition_edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface GetEdition_edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: GetEdition_edition_comparisonEdition_emailTemplate_links[];
}

export interface GetEdition_edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: GetEdition_edition_comparisonEdition_emailTemplate | null;
}

export interface GetEdition_edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetEdition_edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface GetEdition_edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetEdition_edition_comparison_winnerEdition_emailTemplate | null;
}

export interface GetEdition_edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface GetEdition_edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEdition_edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: GetEdition_edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: GetEdition_edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: GetEdition_edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: GetEdition_edition_comparison_winningEdition | null;
}

export interface GetEdition_edition_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEdition_edition_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: GetEdition_edition_audience_fromSavedFilter_count;
}

export interface GetEdition_edition_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEdition_edition_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetEdition_edition_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface GetEdition_edition_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetEdition_edition_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetEdition_edition_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface GetEdition_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: GetEdition_edition_audience_fromSavedFilter | null;
  membershipStats: GetEdition_edition_audience_membershipStats;
  smsMembershipStats: GetEdition_edition_audience_smsMembershipStats;
}

export interface GetEdition_edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface GetEdition_edition_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface GetEdition_edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: GetEdition_edition_from_emailAddress;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: GetEdition_edition_from_fromDomain | null;
}

export interface GetEdition_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetEdition_edition_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface GetEdition_edition_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface GetEdition_edition_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface GetEdition_edition_gateError {
  __typename: "GateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface GetEdition_edition_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetEdition_edition_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEdition_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetEdition_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface GetEdition_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetEdition_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface GetEdition_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetEdition_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface GetEdition_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetEdition_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetEdition_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface GetEdition_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetEdition_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetEdition_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type GetEdition_edition_queuedDripProgressions_edges_node_audienceMember_entity = GetEdition_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account | GetEdition_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface GetEdition_edition_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: GetEdition_edition_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: GetEdition_edition_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface GetEdition_edition_queuedDripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: GetEdition_edition_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface GetEdition_edition_queuedDripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: GetEdition_edition_queuedDripProgressions_edges_node;
}

export interface GetEdition_edition_queuedDripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetEdition_edition_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetEdition_edition_queuedDripProgressions_edges[];
}

export interface GetEdition_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: GetEdition_edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetEdition_edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: GetEdition_edition_emailTemplate | null;
  engagementStats: GetEdition_edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: GetEdition_edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: GetEdition_edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: GetEdition_edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: GetEdition_edition_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: GetEdition_edition_delay | null;
  /**
   * The number of emails sent for this edition
   */
  numSentEmails: number;
  /**
   * The custom click domain that this edition will use to track links, if there is one
   */
  customClickDomain: GetEdition_edition_customClickDomain | null;
  utmParameters: GetEdition_edition_utmParameters;
  defaultUtmParameters: GetEdition_edition_defaultUtmParameters;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  useUtmParameters: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: GetEdition_edition_gateError | null;
  /**
   * Boolean indicating if the edition is using a web font.
   */
  hasWebFonts: boolean;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: GetEdition_edition_queuedDripProgressions | null;
  /**
   * The maximum number of recipients this edition can send to, if DMARC is not
   * fully configured. This is only relevant for non-drip sequence editions.
   */
  recipientLimitForDeliverability: number | null;
}

export interface GetEdition {
  /**
   * Returns an email marketing edition.
   */
  edition: GetEdition_edition | null;
}

export interface GetEditionVariables {
  editionId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEditions
// ====================================================

export interface GetEditions_editions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetEditions_editions_edges_node_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEditions_editions_edges_node_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEditions_editions_edges_node_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEditions_editions_edges_node_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetEditions_editions_edges_node_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: GetEditions_editions_edges_node_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: GetEditions_editions_edges_node_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: GetEditions_editions_edges_node_campaign_nextSendingEdition | null;
}

export interface GetEditions_editions_edges_node_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetEditions_editions_edges_node_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: GetEditions_editions_edges_node_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface GetEditions_editions_edges_node_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: GetEditions_editions_edges_node_emailTemplate_links[];
  name: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface GetEditions_editions_edges_node_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface GetEditions_editions_edges_node_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetEditions_editions_edges_node_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: GetEditions_editions_edges_node_comparisonEdition_emailTemplate_links_url | null;
}

export interface GetEditions_editions_edges_node_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: GetEditions_editions_edges_node_comparisonEdition_emailTemplate_links[];
}

export interface GetEditions_editions_edges_node_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: GetEditions_editions_edges_node_comparisonEdition_emailTemplate | null;
}

export interface GetEditions_editions_edges_node_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetEditions_editions_edges_node_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface GetEditions_editions_edges_node_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetEditions_editions_edges_node_comparison_winnerEdition_emailTemplate | null;
}

export interface GetEditions_editions_edges_node_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface GetEditions_editions_edges_node_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEditions_editions_edges_node_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: GetEditions_editions_edges_node_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: GetEditions_editions_edges_node_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: GetEditions_editions_edges_node_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: GetEditions_editions_edges_node_comparison_winningEdition | null;
}

export interface GetEditions_editions_edges_node_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEditions_editions_edges_node_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: GetEditions_editions_edges_node_audience_fromSavedFilter_count;
}

export interface GetEditions_editions_edges_node_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEditions_editions_edges_node_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetEditions_editions_edges_node_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface GetEditions_editions_edges_node_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetEditions_editions_edges_node_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetEditions_editions_edges_node_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface GetEditions_editions_edges_node_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: GetEditions_editions_edges_node_audience_fromSavedFilter | null;
  membershipStats: GetEditions_editions_edges_node_audience_membershipStats;
  smsMembershipStats: GetEditions_editions_edges_node_audience_smsMembershipStats;
}

export interface GetEditions_editions_edges_node_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface GetEditions_editions_edges_node_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface GetEditions_editions_edges_node_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: GetEditions_editions_edges_node_from_emailAddress;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: GetEditions_editions_edges_node_from_fromDomain | null;
}

export interface GetEditions_editions_edges_node_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetEditions_editions_edges_node_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface GetEditions_editions_edges_node_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface GetEditions_editions_edges_node_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface GetEditions_editions_edges_node_gateError {
  __typename: "GateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface GetEditions_editions_edges_node_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetEditions_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEditions_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetEditions_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface GetEditions_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetEditions_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface GetEditions_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetEditions_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface GetEditions_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetEditions_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetEditions_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface GetEditions_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetEditions_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetEditions_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type GetEditions_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity = GetEditions_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Account | GetEditions_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface GetEditions_editions_edges_node_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: GetEditions_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: GetEditions_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface GetEditions_editions_edges_node_queuedDripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: GetEditions_editions_edges_node_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface GetEditions_editions_edges_node_queuedDripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: GetEditions_editions_edges_node_queuedDripProgressions_edges_node;
}

export interface GetEditions_editions_edges_node_queuedDripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetEditions_editions_edges_node_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetEditions_editions_edges_node_queuedDripProgressions_edges[];
}

export interface GetEditions_editions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: GetEditions_editions_edges_node_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetEditions_editions_edges_node_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: GetEditions_editions_edges_node_emailTemplate | null;
  engagementStats: GetEditions_editions_edges_node_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: GetEditions_editions_edges_node_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: GetEditions_editions_edges_node_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: GetEditions_editions_edges_node_audience | null;
  /**
   * The address to send this edition from
   */
  from: GetEditions_editions_edges_node_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: GetEditions_editions_edges_node_delay | null;
  /**
   * The number of emails sent for this edition
   */
  numSentEmails: number;
  /**
   * The custom click domain that this edition will use to track links, if there is one
   */
  customClickDomain: GetEditions_editions_edges_node_customClickDomain | null;
  utmParameters: GetEditions_editions_edges_node_utmParameters;
  defaultUtmParameters: GetEditions_editions_edges_node_defaultUtmParameters;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  useUtmParameters: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: GetEditions_editions_edges_node_gateError | null;
  /**
   * Boolean indicating if the edition is using a web font.
   */
  hasWebFonts: boolean;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: GetEditions_editions_edges_node_queuedDripProgressions | null;
  /**
   * The maximum number of recipients this edition can send to, if DMARC is not
   * fully configured. This is only relevant for non-drip sequence editions.
   */
  recipientLimitForDeliverability: number | null;
}

export interface GetEditions_editions_edges {
  __typename: "EditionsEdge";
  cursor: string;
  node: GetEditions_editions_edges_node;
}

export interface GetEditions_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetEditions_editions_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetEditions_editions_edges[];
}

export interface GetEditions {
  /**
   * Returns the latest sent editions.
   */
  editions: GetEditions_editions;
}

export interface GetEditionsVariables {
  first: number;
  after?: string | null;
  sort?: EditionSortType | null;
  audienceId?: string | null;
  campaignTypes?: CampaignType[] | null;
  statuses?: EditionStatus[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSmsEditions
// ====================================================

export interface GetSmsEditions_smsEditions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetSmsEditions_smsEditions_edges_node_from_phone {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetSmsEditions_smsEditions_edges_node_from {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
  phone: GetSmsEditions_smsEditions_edges_node_from_phone | null;
}

export interface GetSmsEditions_smsEditions_edges_node_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetSmsEditions_smsEditions_edges_node_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The user who owns this campaign
   */
  owner: GetSmsEditions_smsEditions_edges_node_campaign_owner | null;
}

export interface GetSmsEditions_smsEditions_edges_node_engagementStats {
  __typename: "SmsEngagementStats";
  /**
   * Total number of texts we tried to send
   */
  totalSentCount: number;
  /**
   * Total number of people who responded to the SMS campaign
   */
  responseCount: number;
  /**
   * The ratio of response to total texts sent
   */
  responseRate: number | null;
  /**
   * Total number of texts which couldn’t be delivered
   */
  undeliveredCount: number;
  /**
   * The ratio of undelivered texts to total texts sent
   */
  undeliveredRate: number | null;
  /**
   * The number of people who opted out of SMS messages after receiving this campaign
   */
  optoutCount: number;
  /**
   * The ratio of optouts to total texts sent
   */
  optoutRate: number | null;
}

export interface GetSmsEditions_smsEditions_edges_node_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetSmsEditions_smsEditions_edges_node_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: GetSmsEditions_smsEditions_edges_node_audience_fromSavedFilter_count;
}

export interface GetSmsEditions_smsEditions_edges_node_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetSmsEditions_smsEditions_edges_node_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetSmsEditions_smsEditions_edges_node_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface GetSmsEditions_smsEditions_edges_node_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetSmsEditions_smsEditions_edges_node_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetSmsEditions_smsEditions_edges_node_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface GetSmsEditions_smsEditions_edges_node_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: GetSmsEditions_smsEditions_edges_node_audience_fromSavedFilter | null;
  membershipStats: GetSmsEditions_smsEditions_edges_node_audience_membershipStats;
  smsMembershipStats: GetSmsEditions_smsEditions_edges_node_audience_smsMembershipStats;
}

export interface GetSmsEditions_smsEditions_edges_node_gateError {
  __typename: "SmsGateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface GetSmsEditions_smsEditions_edges_node {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The content of the edition
   */
  content: string;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  scheduledTime: any | null;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The channel this edition was sent from
   */
  from: GetSmsEditions_smsEditions_edges_node_from | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetSmsEditions_smsEditions_edges_node_campaign;
  /**
   * The opt-out string in the message content
   */
  optOutText: string | null;
  engagementStats: GetSmsEditions_smsEditions_edges_node_engagementStats;
  /**
   * The audience to send this edition to
   */
  audience: GetSmsEditions_smsEditions_edges_node_audience | null;
  /**
   * If the content of the edition contains a link from a public URL shortener
   */
  hasShortLink: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: GetSmsEditions_smsEditions_edges_node_gateError | null;
  /**
   * The number of SMS Campaigns credits this account has per month
   */
  smsCampaignsCreditLimit: number | null;
  /**
   * The number of SMS Campaigns credits this account has used per month
   */
  smsCampaignsCreditsUsed: number;
}

export interface GetSmsEditions_smsEditions_edges {
  __typename: "SmsEditionsEdge";
  cursor: string;
  node: GetSmsEditions_smsEditions_edges_node;
}

export interface GetSmsEditions_smsEditions {
  __typename: "SmsEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetSmsEditions_smsEditions_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetSmsEditions_smsEditions_edges[];
}

export interface GetSmsEditions {
  /**
   * Returns a list of sms marketing editions.
   */
  smsEditions: GetSmsEditions_smsEditions;
}

export interface GetSmsEditionsVariables {
  first: number;
  after?: string | null;
  sort?: EditionSortType | null;
  audienceId?: string | null;
  campaignTypes?: CampaignType[] | null;
  statuses?: EditionStatus[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateNewsletter
// ====================================================

export interface CreateNewsletter_newsletterCreate_newsletter_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateNewsletter_newsletterCreate_newsletter_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface CreateNewsletter_newsletterCreate_newsletter_lastSentEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  sendTime: any | null;
}

export interface CreateNewsletter_newsletterCreate_newsletter_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
}

export interface CreateNewsletter_newsletterCreate_newsletter {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  creatorUser: CreateNewsletter_newsletterCreate_newsletter_creatorUser | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  editions: CreateNewsletter_newsletterCreate_newsletter_editions;
  lastSentEdition: CreateNewsletter_newsletterCreate_newsletter_lastSentEdition | null;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the campaign was last modified
   */
  modifiedTime: any | null;
  engagementStats: CreateNewsletter_newsletterCreate_newsletter_engagementStats;
}

export interface CreateNewsletter_newsletterCreate {
  __typename: "NewsletterCreatePayload";
  /**
   * The verified user email
   */
  newsletter: CreateNewsletter_newsletterCreate_newsletter;
}

export interface CreateNewsletter {
  /**
   * Create a new email marketing newsletter
   */
  newsletterCreate: CreateNewsletter_newsletterCreate | null;
}

export interface CreateNewsletterVariables {
  newsletter: NewsletterCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteNewsletter
// ====================================================

export interface DeleteNewsletter_campaignDelete_campaign {
  __typename: "Campaign" | "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteNewsletter_campaignDelete {
  __typename: "CampaignDeletePayload";
  /**
   * The campaign
   */
  campaign: DeleteNewsletter_campaignDelete_campaign;
}

export interface DeleteNewsletter {
  /**
   * Delete a campaign and associated content.
   */
  campaignDelete: DeleteNewsletter_campaignDelete | null;
}

export interface DeleteNewsletterVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RestoreNewsletter
// ====================================================

export interface RestoreNewsletter_campaignRestore_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface RestoreNewsletter_campaignRestore {
  __typename: "CampaignRestorePayload";
  /**
   * The campaign
   */
  campaign: RestoreNewsletter_campaignRestore_campaign;
}

export interface RestoreNewsletter {
  /**
   * Restore an email campaign
   */
  campaignRestore: RestoreNewsletter_campaignRestore | null;
}

export interface RestoreNewsletterVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateNewsletter
// ====================================================

export interface UpdateNewsletter_campaignUpdate_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateNewsletter_campaignUpdate_campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface UpdateNewsletter_campaignUpdate_campaign_lastSentEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  sendTime: any | null;
}

export interface UpdateNewsletter_campaignUpdate_campaign_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
}

export interface UpdateNewsletter_campaignUpdate_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  creatorUser: UpdateNewsletter_campaignUpdate_campaign_creatorUser | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  editions: UpdateNewsletter_campaignUpdate_campaign_editions;
  lastSentEdition: UpdateNewsletter_campaignUpdate_campaign_lastSentEdition | null;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the campaign was last modified
   */
  modifiedTime: any | null;
  engagementStats: UpdateNewsletter_campaignUpdate_campaign_engagementStats;
}

export interface UpdateNewsletter_campaignUpdate {
  __typename: "CampaignUpdatePayload";
  /**
   * The campaign
   */
  campaign: UpdateNewsletter_campaignUpdate_campaign;
}

export interface UpdateNewsletter {
  /**
   * Save the template data for an email marketing campaign
   */
  campaignUpdate: UpdateNewsletter_campaignUpdate | null;
}

export interface UpdateNewsletterVariables {
  newsletter: CampaignUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetNewsletter
// ====================================================

export interface GetNewsletter_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetNewsletter_campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetNewsletter_campaign_lastSentEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  sendTime: any | null;
}

export interface GetNewsletter_campaign_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
}

export interface GetNewsletter_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetNewsletter_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  creatorUser: GetNewsletter_campaign_creatorUser | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  editions: GetNewsletter_campaign_editions;
  lastSentEdition: GetNewsletter_campaign_lastSentEdition | null;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the campaign was last modified
   */
  modifiedTime: any | null;
  engagementStats: GetNewsletter_campaign_engagementStats;
  /**
   * The number of archived editions on this campaign.
   */
  archivedEditionCount: number;
  nextSendingEdition: GetNewsletter_campaign_nextSendingEdition | null;
}

export interface GetNewsletter {
  /**
   * Returns an email marketing campaign.
   */
  campaign: GetNewsletter_campaign | null;
}

export interface GetNewsletterVariables {
  newsletterId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetNewsletters
// ====================================================

export interface GetNewsletters_newsletters_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetNewsletters_newsletters_edges_node_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetNewsletters_newsletters_edges_node_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetNewsletters_newsletters_edges_node_lastSentEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  sendTime: any | null;
}

export interface GetNewsletters_newsletters_edges_node_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
}

export interface GetNewsletters_newsletters_edges_node {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  creatorUser: GetNewsletters_newsletters_edges_node_creatorUser | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  editions: GetNewsletters_newsletters_edges_node_editions;
  lastSentEdition: GetNewsletters_newsletters_edges_node_lastSentEdition | null;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the campaign was last modified
   */
  modifiedTime: any | null;
  engagementStats: GetNewsletters_newsletters_edges_node_engagementStats;
}

export interface GetNewsletters_newsletters_edges {
  __typename: "CampaignsEdge";
  cursor: string;
  node: GetNewsletters_newsletters_edges_node;
}

export interface GetNewsletters_newsletters {
  __typename: "CampaignsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetNewsletters_newsletters_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetNewsletters_newsletters_edges[];
}

export interface GetNewsletters {
  /**
   * Returns a paging connection of email newsletters from the root of our query.
   */
  newsletters: GetNewsletters_newsletters;
}

export interface GetNewslettersVariables {
  limit: number;
  archived: boolean;
  cursor?: string | null;
  sort: NewsletterSortType;
  search?: string | null;
  creatorUserId?: string | null;
  lastUpdatedTime?: string | null;
  statuses?: CampaignStatus[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEmailMarketingSavedFilters
// ====================================================

export interface GetEmailMarketingSavedFilters_emailMarketingSavedFilters_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEmailMarketingSavedFilters_emailMarketingSavedFilters {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The DateTime that represents when the saved filter was created. This is sometimes not set for built-in filters.
   */
  createdTime: any | null;
  /**
   * The count of entities in this list
   */
  count: GetEmailMarketingSavedFilters_emailMarketingSavedFilters_count;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
}

export interface GetEmailMarketingSavedFilters {
  /**
   * Returns all saved lists of entities
   */
  emailMarketingSavedFilters: GetEmailMarketingSavedFilters_emailMarketingSavedFilters[];
}

export interface GetEmailMarketingSavedFiltersVariables {
  sort?: SavedFilterSortType | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: PublishTemplate
// ====================================================

export interface PublishTemplate_templatePublish_template_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
}

export interface PublishTemplate_templatePublish_template {
  __typename: "Campaign";
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  edition: PublishTemplate_templatePublish_template_edition;
}

export interface PublishTemplate_templatePublish {
  __typename: "TemplatePublishPayload";
  /**
   * The published template.
   */
  template: PublishTemplate_templatePublish_template;
}

export interface PublishTemplate {
  /**
   * Publishes a user created template.
   */
  templatePublish: PublishTemplate_templatePublish;
}

export interface PublishTemplateVariables {
  input: TemplatePublishInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTemplate
// ====================================================

export interface GetTemplate_template_edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetTemplate_template_edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetTemplate_template_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetTemplate_template_edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetTemplate_template_edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: GetTemplate_template_edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: GetTemplate_template_edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: GetTemplate_template_edition_campaign_nextSendingEdition | null;
}

export interface GetTemplate_template_edition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetTemplate_template_edition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: GetTemplate_template_edition_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface GetTemplate_template_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: GetTemplate_template_edition_emailTemplate_links[];
  name: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface GetTemplate_template_edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface GetTemplate_template_edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetTemplate_template_edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: GetTemplate_template_edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface GetTemplate_template_edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: GetTemplate_template_edition_comparisonEdition_emailTemplate_links[];
}

export interface GetTemplate_template_edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: GetTemplate_template_edition_comparisonEdition_emailTemplate | null;
}

export interface GetTemplate_template_edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetTemplate_template_edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface GetTemplate_template_edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetTemplate_template_edition_comparison_winnerEdition_emailTemplate | null;
}

export interface GetTemplate_template_edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface GetTemplate_template_edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetTemplate_template_edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: GetTemplate_template_edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: GetTemplate_template_edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: GetTemplate_template_edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: GetTemplate_template_edition_comparison_winningEdition | null;
}

export interface GetTemplate_template_edition_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetTemplate_template_edition_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: GetTemplate_template_edition_audience_fromSavedFilter_count;
}

export interface GetTemplate_template_edition_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetTemplate_template_edition_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetTemplate_template_edition_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface GetTemplate_template_edition_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetTemplate_template_edition_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetTemplate_template_edition_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface GetTemplate_template_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: GetTemplate_template_edition_audience_fromSavedFilter | null;
  membershipStats: GetTemplate_template_edition_audience_membershipStats;
  smsMembershipStats: GetTemplate_template_edition_audience_smsMembershipStats;
}

export interface GetTemplate_template_edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface GetTemplate_template_edition_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface GetTemplate_template_edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: GetTemplate_template_edition_from_emailAddress;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: GetTemplate_template_edition_from_fromDomain | null;
}

export interface GetTemplate_template_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetTemplate_template_edition_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface GetTemplate_template_edition_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface GetTemplate_template_edition_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface GetTemplate_template_edition_gateError {
  __typename: "GateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface GetTemplate_template_edition_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetTemplate_template_edition_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetTemplate_template_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetTemplate_template_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface GetTemplate_template_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetTemplate_template_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface GetTemplate_template_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetTemplate_template_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface GetTemplate_template_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetTemplate_template_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetTemplate_template_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface GetTemplate_template_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetTemplate_template_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetTemplate_template_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type GetTemplate_template_edition_queuedDripProgressions_edges_node_audienceMember_entity = GetTemplate_template_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account | GetTemplate_template_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface GetTemplate_template_edition_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: GetTemplate_template_edition_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: GetTemplate_template_edition_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface GetTemplate_template_edition_queuedDripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: GetTemplate_template_edition_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface GetTemplate_template_edition_queuedDripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: GetTemplate_template_edition_queuedDripProgressions_edges_node;
}

export interface GetTemplate_template_edition_queuedDripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetTemplate_template_edition_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetTemplate_template_edition_queuedDripProgressions_edges[];
}

export interface GetTemplate_template_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: GetTemplate_template_edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetTemplate_template_edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: GetTemplate_template_edition_emailTemplate | null;
  engagementStats: GetTemplate_template_edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: GetTemplate_template_edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: GetTemplate_template_edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: GetTemplate_template_edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: GetTemplate_template_edition_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: GetTemplate_template_edition_delay | null;
  /**
   * The number of emails sent for this edition
   */
  numSentEmails: number;
  /**
   * The custom click domain that this edition will use to track links, if there is one
   */
  customClickDomain: GetTemplate_template_edition_customClickDomain | null;
  utmParameters: GetTemplate_template_edition_utmParameters;
  defaultUtmParameters: GetTemplate_template_edition_defaultUtmParameters;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  useUtmParameters: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: GetTemplate_template_edition_gateError | null;
  /**
   * Boolean indicating if the edition is using a web font.
   */
  hasWebFonts: boolean;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: GetTemplate_template_edition_queuedDripProgressions | null;
  /**
   * The maximum number of recipients this edition can send to, if DMARC is not
   * fully configured. This is only relevant for non-drip sequence editions.
   */
  recipientLimitForDeliverability: number | null;
}

export interface GetTemplate_template {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  edition: GetTemplate_template_edition;
}

export interface GetTemplate {
  /**
   * Returns a user-created email marketing template.
   */
  template: GetTemplate_template | null;
}

export interface GetTemplateVariables {
  templateId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteCampaign
// ====================================================

export interface DeleteCampaign_campaignDelete_campaign {
  __typename: "Campaign" | "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteCampaign_campaignDelete {
  __typename: "CampaignDeletePayload";
  /**
   * The campaign
   */
  campaign: DeleteCampaign_campaignDelete_campaign;
}

export interface DeleteCampaign {
  /**
   * Delete a campaign and associated content.
   */
  campaignDelete: DeleteCampaign_campaignDelete | null;
}

export interface DeleteCampaignVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MarketingEmailTemplateDelete
// ====================================================

export interface MarketingEmailTemplateDelete_marketingEmailTemplateDelete {
  __typename: "MarketingEmailTemplateDeletePayload";
  /**
   * The updated Nutshell email template json setting
   */
  templateJson: string | null;
}

export interface MarketingEmailTemplateDelete {
  /**
   * NOT FOR USE IN PRODUCTION Only for testing BEE editor
   */
  marketingEmailTemplateDelete: MarketingEmailTemplateDelete_marketingEmailTemplateDelete | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MarketingEmailTemplateSave
// ====================================================

export interface MarketingEmailTemplateSave_marketingEmailTemplateSave {
  __typename: "MarketingEmailTemplateSavePayload";
  /**
   * The updated Nutshell email template json setting
   */
  templateJson: string | null;
}

export interface MarketingEmailTemplateSave {
  /**
   * NOT FOR USE IN PRODUCTION Only for testing BEE editor
   */
  marketingEmailTemplateSave: MarketingEmailTemplateSave_marketingEmailTemplateSave | null;
}

export interface MarketingEmailTemplateSaveVariables {
  templateJson: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendRawHtmlEmail
// ====================================================

export interface SendRawHtmlEmail_sendRawHtmlEmail_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SendRawHtmlEmail_sendRawHtmlEmail {
  __typename: "SendRawHtmlEmailPayload";
  /**
   * The newly created email sequence
   */
  emailSequence: SendRawHtmlEmail_sendRawHtmlEmail_emailSequence;
}

export interface SendRawHtmlEmail {
  /**
   * NOT FOR USE IN PRODUCTION Only for testing BEE editor
   */
  sendRawHtmlEmail: SendRawHtmlEmail_sendRawHtmlEmail | null;
}

export interface SendRawHtmlEmailVariables {
  emailSequence: SendRawHtmlEmailInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMarketingEmailTemplate
// ====================================================

export interface GetMarketingEmailTemplate {
  /**
   * Saved marketing email for this user
   */
  marketingEmailTemplate: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMarketingVerifiedUserEmail
// ====================================================

export interface GetMarketingVerifiedUserEmail_marketingVerifiedUserEmail {
  __typename: "NutEmailAddress";
  address: string;
}

export interface GetMarketingVerifiedUserEmail {
  /**
   * Verified email address for marketing emails
   */
  marketingVerifiedUserEmail: GetMarketingVerifiedUserEmail_marketingVerifiedUserEmail | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetNutshellMarketingStats
// ====================================================

export interface GetNutshellMarketingStats_nutshellMarketingStats_usageStats {
  __typename: "UsageStats";
  /**
   * The number of emails this account has sent this month
   */
  numberOfEmailsSentThisMonth: number;
  /**
   * The number of marketable contacts this account has
   */
  numberOfMarketableContacts: number;
}

export interface GetNutshellMarketingStats_nutshellMarketingStats_gate {
  __typename: "Gate";
  /**
   * The max number of emails this account can send in a month
   */
  maxNumberOfEmailsPerMonth: number | null;
  /**
   * The max number of marketable contacts this account can have
   */
  maxNumberOfMarketableContacts: number | null;
  /**
   * The number of marketable contacts over the limit - if under this number we allow sending a test email
   */
  marketingContactsOverageAllowance: number | null;
  /**
   * Whether this account has unlimited marketing contacts - if true we allow
   * sending a test email as long as their email limit is not exceeded
   */
  hasUnlimitedMarketingContacts: boolean;
  /**
   * True if they have marketingContactsOverageAllowance set to null or 1
   * (indicating unlimited contacts) or a number besides 0 (a manual limit). Used
   * to determine whether to show overage text in the marketing sidebar.
   */
  hasOveragesEnabledFromWebfx: boolean;
}

export interface GetNutshellMarketingStats_nutshellMarketingStats {
  __typename: "NutshellMarketingStats";
  /**
   * The number of emails this account has sent this month
   */
  usageStats: GetNutshellMarketingStats_nutshellMarketingStats_usageStats;
  /**
   * The number of marketable contacts this account has
   */
  gate: GetNutshellMarketingStats_nutshellMarketingStats_gate;
}

export interface GetNutshellMarketingStats {
  /**
   * Returns info about the accounts email marketing usage.
   */
  nutshellMarketingStats: GetNutshellMarketingStats_nutshellMarketingStats;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateProspectorContacts
// ====================================================

export interface CreateProspectorContacts_prospectorContactsAdd_accounts {
  __typename: "Account";
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface CreateProspectorContacts_prospectorContactsAdd_contacts_origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateProspectorContacts_prospectorContactsAdd_contacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The origin of the peep
   */
  origin: CreateProspectorContacts_prospectorContactsAdd_contacts_origin;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface CreateProspectorContacts_prospectorContactsAdd_leads {
  __typename: "Lead";
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateProspectorContacts_prospectorContactsAdd {
  __typename: "ProspectorContactsAddPayload";
  /**
   * The new Nutshell accounts.
   */
  accounts: CreateProspectorContacts_prospectorContactsAdd_accounts[];
  /**
   * The new contacts.
   */
  contacts: CreateProspectorContacts_prospectorContactsAdd_contacts[];
  /**
   * The new Nutshell leads.
   */
  leads: CreateProspectorContacts_prospectorContactsAdd_leads[];
  /**
   * The number of contacts that were updated.
   */
  numUpdatedContacts: number;
}

export interface CreateProspectorContacts {
  /**
   * Creates contacts, and optionally accounts and leads in Nutshell
   */
  prospectorContactsAdd: CreateProspectorContacts_prospectorContactsAdd;
}

export interface CreateProspectorContactsVariables {
  input: ProspectorContactsAddInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateFilter
// ====================================================

export interface CreateFilter_filterCreate_filter_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateFilter_filterCreate_filter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The url path of the saved filter
   */
  htmlUrl: string;
  /**
   * The DateTime that represents when the saved filter was created. This is sometimes not set for built-in filters.
   */
  createdTime: any | null;
  /**
   * The user who created the saved filter
   */
  creatorUser: CreateFilter_filterCreate_filter_creatorUser | null;
}

export interface CreateFilter_filterCreate {
  __typename: "FilterCreatePayload";
  /**
   * The newly created filter.
   */
  filter: CreateFilter_filterCreate_filter | null;
}

export interface CreateFilter {
  /**
   * Creates a new saved filter
   */
  filterCreate: CreateFilter_filterCreate;
}

export interface CreateFilterVariables {
  input: FilterCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteFilter
// ====================================================

export interface DeleteFilter_filterDelete_filter_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DeleteFilter_filterDelete_filter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The url path of the saved filter
   */
  htmlUrl: string;
  /**
   * The DateTime that represents when the saved filter was created. This is sometimes not set for built-in filters.
   */
  createdTime: any | null;
  /**
   * The user who created the saved filter
   */
  creatorUser: DeleteFilter_filterDelete_filter_creatorUser | null;
}

export interface DeleteFilter_filterDelete {
  __typename: "FilterDeletePayload";
  /**
   * The filter that was deleted.
   */
  filter: DeleteFilter_filterDelete_filter | null;
}

export interface DeleteFilter {
  /**
   * Delete a saved filter
   */
  filterDelete: DeleteFilter_filterDelete;
}

export interface DeleteFilterVariables {
  input: FilterDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateFilter
// ====================================================

export interface UpdateFilter_filterUpdate_filter_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateFilter_filterUpdate_filter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The url path of the saved filter
   */
  htmlUrl: string;
  /**
   * The DateTime that represents when the saved filter was created. This is sometimes not set for built-in filters.
   */
  createdTime: any | null;
  /**
   * The user who created the saved filter
   */
  creatorUser: UpdateFilter_filterUpdate_filter_creatorUser | null;
}

export interface UpdateFilter_filterUpdate {
  __typename: "FilterUpdatePayload";
  /**
   * The updated filter.
   */
  filter: UpdateFilter_filterUpdate_filter | null;
}

export interface UpdateFilter {
  /**
   * Updates basic info about a saved filter
   */
  filterUpdate: UpdateFilter_filterUpdate;
}

export interface UpdateFilterVariables {
  input: FilterUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetProspectorContacts
// ====================================================

export interface GetProspectorContacts_prospectorContacts_mcfxContacts_companySize {
  __typename: "NumericalRange";
  /**
   * The lower bound of the range (inclusive)
   */
  gte: number | null;
  /**
   * The upper bound of the range (inclusive)
   */
  lte: number | null;
}

export interface GetProspectorContacts_prospectorContacts_mcfxContacts_companyRevenue {
  __typename: "NumericalRange";
  /**
   * The lower bound of the range (inclusive)
   */
  gte: number | null;
  /**
   * The upper bound of the range (inclusive)
   */
  lte: number | null;
}

export interface GetProspectorContacts_prospectorContacts_mcfxContacts {
  __typename: "McfxViqContact";
  /**
   * The (external) id for this Viq person
   */
  id: string;
  /**
   * The (external) id for this Viq person
   */
  fullName: string;
  /**
   * Whether this Viq person has a valid phone number
   */
  hasPhone: boolean;
  /**
   * Whether this Viq person has a valid email address
   */
  hasEmail: boolean;
  /**
   * Whether this Viq person has a LinkedIn Url we know about
   */
  hasLinkedinUrl: boolean;
  /**
   * The location of this Viq person
   */
  location: string | null;
  /**
   * The job title of this Viq person
   */
  jobTitle: string | null;
  /**
   * The position of this Viq person
   */
  position: string | null;
  /**
   * The job title role of this person
   */
  industry: string | null;
  /**
   * The size of the company this person works for
   */
  companySize: GetProspectorContacts_prospectorContacts_mcfxContacts_companySize | null;
  /**
   * The name of the company this person works for
   */
  companyName: string | null;
  /**
   * The location of the company this person works for
   */
  companyLocation: string | null;
  /**
   * The industry of the company this person works for
   */
  companyIndustry: string | null;
  /**
   * The website of the company this person works for
   */
  companyWebsite: string | null;
  /**
   * The revenue of the company this person works for
   */
  companyRevenue: GetProspectorContacts_prospectorContacts_mcfxContacts_companyRevenue | null;
  /**
   * The initials of the person
   */
  initials: string | null;
}

export interface GetProspectorContacts_prospectorContacts {
  __typename: "ProspectorContacts";
  /**
   * The total number of contacts
   */
  totalCount: number | null;
  /**
   * The contacts from the Prospector API
   */
  mcfxContacts: GetProspectorContacts_prospectorContacts_mcfxContacts[] | null;
  /**
   * The skip for the next page
   */
  nextSkip: number | null;
}

export interface GetProspectorContacts {
  /**
   * Returns the prospector contacts based on filters
   */
  prospectorContacts: GetProspectorContacts_prospectorContacts;
}

export interface GetProspectorContactsVariables {
  input: ProspectorFilters;
  skip: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetProspectorSavedFilters
// ====================================================

export interface GetProspectorSavedFilters_prospectorSavedFilters_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetProspectorSavedFilters_prospectorSavedFilters {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The url path of the saved filter
   */
  htmlUrl: string;
  /**
   * The DateTime that represents when the saved filter was created. This is sometimes not set for built-in filters.
   */
  createdTime: any | null;
  /**
   * The user who created the saved filter
   */
  creatorUser: GetProspectorSavedFilters_prospectorSavedFilters_creatorUser | null;
}

export interface GetProspectorSavedFilters {
  /**
   * Returns all saved filters for prospector
   */
  prospectorSavedFilters: GetProspectorSavedFilters_prospectorSavedFilters[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetGuessedInstanceWebsite
// ====================================================

export interface GetGuessedInstanceWebsite_sessionInstance {
  __typename: "Instance";
  /**
   * The guessed instance website.
   */
  guessedInstanceWebsite: string | null;
}

export interface GetGuessedInstanceWebsite {
  /**
   * A hodge-podge of instance-level concerns
   */
  sessionInstance: GetGuessedInstanceWebsite_sessionInstance | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetNutshellMarketingBannerInfo
// ====================================================

export interface GetNutshellMarketingBannerInfo_nutshellMarketingStats_gate_error {
  __typename: "GateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface GetNutshellMarketingBannerInfo_nutshellMarketingStats_gate {
  __typename: "Gate";
  /**
   * The error, if any, for gating email sending
   */
  error: GetNutshellMarketingBannerInfo_nutshellMarketingStats_gate_error | null;
}

export interface GetNutshellMarketingBannerInfo_nutshellMarketingStats {
  __typename: "NutshellMarketingStats";
  /**
   * The number of marketable contacts this account has
   */
  gate: GetNutshellMarketingBannerInfo_nutshellMarketingStats_gate;
  /**
   * Boolean describing whether to show the import unsubscribes banner
   */
  shouldShowImportUnsubscribesBanner: boolean;
}

export interface GetNutshellMarketingBannerInfo {
  /**
   * Returns info about the accounts email marketing usage.
   */
  nutshellMarketingStats: GetNutshellMarketingBannerInfo_nutshellMarketingStats;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateMoneyPageAutomation
// ====================================================

export interface CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigRemoveTags {
  __typename: "ActionConfigRemoveTags" | "ActionConfigSendEmail";
}

export interface CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigAddTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigAddTags {
  __typename: "ActionConfigAddTags";
  /**
   * The boolean value to filter on.
   */
  tags: CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigAddTags_tags[];
}

export interface CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigAddAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigAddAudiences {
  __typename: "ActionConfigAddAudiences";
  /**
   * The boolean value to filter on.
   */
  audiences: CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigAddAudiences_audiences[];
}

export interface CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigRemoveAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigRemoveAudiences {
  __typename: "ActionConfigRemoveAudiences";
  /**
   * The boolean value to filter on.
   */
  audiences: CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigRemoveAudiences_audiences[];
}

export interface CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
  /**
   * Specific type of alias
   */
  type: NotifiableAliasType;
}

export type CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables = CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables_User | CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables_NotifiableAlias;

export interface CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigSendPageViewedNotification {
  __typename: "ActionConfigSendPageViewedNotification";
  /**
   * The users or aliases to which the notification should be sent.
   */
  notifiables: CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables[];
}

export interface CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigAddToDripSequence_dripSequence {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigAddToDripSequence {
  __typename: "ActionConfigAddToDripSequence";
  /**
   * The drip sequence to which the contact should be added.
   */
  dripSequence: CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigAddToDripSequence_dripSequence;
}

export interface CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigCreateLead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigCreateLead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigCreateLead_assigneeOrRule = CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_User | CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_Team | CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule;

export interface CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigCreateLead {
  __typename: "ActionConfigCreateLead";
  /**
   * The stageset to which the lead should be added.
   */
  stageset: CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigCreateLead_stageset;
  /**
   * The tags which should be added to the lead.
   */
  tags: CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigCreateLead_tags[];
  /**
   * The assignee for the lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigCreateLead_assigneeOrRule | null;
}

export type CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config = CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigRemoveTags | CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigAddTags | CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigAddAudiences | CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigRemoveAudiences | CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigSendPageViewedNotification | CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigAddToDripSequence | CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config_ActionConfigCreateLead;

export interface CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions {
  __typename: "Action";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * The configuration for this action.
   */
  config: CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions_config;
  /**
   * Human readable title of this action
   */
  humanReadableTitle: string;
}

export interface CreateMoneyPageAutomation_maUrlAutomationCreate_automation {
  __typename: "Automation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of this automation.
   */
  type: number;
  /**
   * Actions that will be taken when this automation is activated.
   */
  actions: CreateMoneyPageAutomation_maUrlAutomationCreate_automation_actions[];
}

export interface CreateMoneyPageAutomation_maUrlAutomationCreate {
  __typename: "UrlAutomationCreatePayload";
  /**
   * The automation that was updated with the new action.
   */
  automation: CreateMoneyPageAutomation_maUrlAutomationCreate_automation;
}

export interface CreateMoneyPageAutomation {
  /**
   * Create a single automation action for a marketing automation URL.
   */
  maUrlAutomationCreate: CreateMoneyPageAutomation_maUrlAutomationCreate;
}

export interface CreateMoneyPageAutomationVariables {
  input: UrlAutomationCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateMoneyPage
// ====================================================

export interface CreateMoneyPage_maUrlCreate_url_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
}

export interface CreateMoneyPage_maUrlCreate_url {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  url: CreateMoneyPage_maUrlCreate_url_url;
  /**
   * Path to the edit page for this money page.
   */
  htmlUrlPath: string;
}

export interface CreateMoneyPage_maUrlCreate {
  __typename: "UrlCreatePayload";
  /**
   * The newly created marketing automation URL
   */
  url: CreateMoneyPage_maUrlCreate_url;
}

export interface CreateMoneyPage {
  /**
   * Creates a marketing automation URL
   */
  maUrlCreate: CreateMoneyPage_maUrlCreate;
}

export interface CreateMoneyPageVariables {
  input: UrlCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteMoneyPageAction
// ====================================================

export interface DeleteMoneyPageAction_maUrlAutomationDelete_automation_actions {
  __typename: "Action";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * The position of this action relative to its siblings.
   */
  position: number;
}

export interface DeleteMoneyPageAction_maUrlAutomationDelete_automation {
  __typename: "Automation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Actions that will be taken when this automation is activated.
   */
  actions: DeleteMoneyPageAction_maUrlAutomationDelete_automation_actions[];
}

export interface DeleteMoneyPageAction_maUrlAutomationDelete {
  __typename: "UrlAutomationDeletePayload";
  /**
   * The automation that the action was deleted from.
   */
  automation: DeleteMoneyPageAction_maUrlAutomationDelete_automation;
}

export interface DeleteMoneyPageAction {
  /**
   * Delete an automation action from a marketing automation URL.
   */
  maUrlAutomationDelete: DeleteMoneyPageAction_maUrlAutomationDelete;
}

export interface DeleteMoneyPageActionVariables {
  input: UrlAutomationDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteMoneyPage
// ====================================================

export interface DeleteMoneyPage_maUrlDelete_url_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface DeleteMoneyPage_maUrlDelete_url {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  url: DeleteMoneyPage_maUrlDelete_url_url;
}

export interface DeleteMoneyPage_maUrlDelete {
  __typename: "UrlDeletePayload";
  /**
   * The deleted marketing automation URL
   */
  url: DeleteMoneyPage_maUrlDelete_url;
}

export interface DeleteMoneyPage {
  /**
   * Soft deletes a marketing automation URL
   */
  maUrlDelete: DeleteMoneyPage_maUrlDelete;
}

export interface DeleteMoneyPageVariables {
  input: UrlDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetMoneyPageIsEnabled
// ====================================================

export interface SetMoneyPageIsEnabled_maUrlSetIsEnabled_url {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * When false, the URL is visible in UI but automations will not trigger.
   */
  isEnabled: boolean | null;
}

export interface SetMoneyPageIsEnabled_maUrlSetIsEnabled {
  __typename: "UrlSetIsEnabledPayload";
  /**
   * The marketing automation URL that was updated
   */
  url: SetMoneyPageIsEnabled_maUrlSetIsEnabled_url;
}

export interface SetMoneyPageIsEnabled {
  /**
   * Set an individual marketing automation URL to be enabled or disabled, which
   * will either allow the automations to fire or not
   */
  maUrlSetIsEnabled: SetMoneyPageIsEnabled_maUrlSetIsEnabled;
}

export interface SetMoneyPageIsEnabledVariables {
  input: UrlSetIsEnabledInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateMoneyPageAutomation
// ====================================================

export interface UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigRemoveTags {
  __typename: "ActionConfigRemoveTags" | "ActionConfigSendEmail";
}

export interface UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigAddTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigAddTags {
  __typename: "ActionConfigAddTags";
  /**
   * The boolean value to filter on.
   */
  tags: UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigAddTags_tags[];
}

export interface UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigAddAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigAddAudiences {
  __typename: "ActionConfigAddAudiences";
  /**
   * The boolean value to filter on.
   */
  audiences: UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigAddAudiences_audiences[];
}

export interface UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigRemoveAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigRemoveAudiences {
  __typename: "ActionConfigRemoveAudiences";
  /**
   * The boolean value to filter on.
   */
  audiences: UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigRemoveAudiences_audiences[];
}

export interface UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
  /**
   * Specific type of alias
   */
  type: NotifiableAliasType;
}

export type UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables = UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables_User | UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables_NotifiableAlias;

export interface UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigSendPageViewedNotification {
  __typename: "ActionConfigSendPageViewedNotification";
  /**
   * The users or aliases to which the notification should be sent.
   */
  notifiables: UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables[];
}

export interface UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigAddToDripSequence_dripSequence {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigAddToDripSequence {
  __typename: "ActionConfigAddToDripSequence";
  /**
   * The drip sequence to which the contact should be added.
   */
  dripSequence: UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigAddToDripSequence_dripSequence;
}

export interface UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigCreateLead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigCreateLead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigCreateLead_assigneeOrRule = UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_User | UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_Team | UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule;

export interface UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigCreateLead {
  __typename: "ActionConfigCreateLead";
  /**
   * The stageset to which the lead should be added.
   */
  stageset: UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigCreateLead_stageset;
  /**
   * The tags which should be added to the lead.
   */
  tags: UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigCreateLead_tags[];
  /**
   * The assignee for the lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigCreateLead_assigneeOrRule | null;
}

export type UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config = UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigRemoveTags | UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigAddTags | UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigAddAudiences | UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigRemoveAudiences | UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigSendPageViewedNotification | UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigAddToDripSequence | UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config_ActionConfigCreateLead;

export interface UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions {
  __typename: "Action";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * The configuration for this action.
   */
  config: UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions_config;
  /**
   * Human readable title of this action
   */
  humanReadableTitle: string;
}

export interface UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation {
  __typename: "Automation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of this automation.
   */
  type: number;
  /**
   * Actions that will be taken when this automation is activated.
   */
  actions: UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation_actions[];
}

export interface UpdateMoneyPageAutomation_maUrlAutomationUpdate {
  __typename: "UrlAutomationUpdatePayload";
  /**
   * The automation that was updated.
   */
  automation: UpdateMoneyPageAutomation_maUrlAutomationUpdate_automation;
}

export interface UpdateMoneyPageAutomation {
  /**
   * Update an automation action on a marketing automation URL.
   */
  maUrlAutomationUpdate: UpdateMoneyPageAutomation_maUrlAutomationUpdate;
}

export interface UpdateMoneyPageAutomationVariables {
  input: UrlAutomationUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateMoneyPage
// ====================================================

export interface UpdateMoneyPage_maUrlUpdate_url {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateMoneyPage_maUrlUpdate {
  __typename: "UrlUpdatePayload";
  /**
   * The updated marketing automation URL
   */
  url: UpdateMoneyPage_maUrlUpdate_url;
}

export interface UpdateMoneyPage {
  /**
   * Updates a Marketing Automation URL
   */
  maUrlUpdate: UpdateMoneyPage_maUrlUpdate;
}

export interface UpdateMoneyPageVariables {
  input: UrlUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMoneyPageTriggers
// ====================================================

export interface GetMoneyPageTriggers_maUrlTriggers_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface GetMoneyPageTriggers_maUrlTriggers_edges_node_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetMoneyPageTriggers_maUrlTriggers_edges_node_lead_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetMoneyPageTriggers_maUrlTriggers_edges_node_lead_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export type GetMoneyPageTriggers_maUrlTriggers_edges_node_lead_assignee = GetMoneyPageTriggers_maUrlTriggers_edges_node_lead_assignee_User | GetMoneyPageTriggers_maUrlTriggers_edges_node_lead_assignee_Team;

export interface GetMoneyPageTriggers_maUrlTriggers_edges_node_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetMoneyPageTriggers_maUrlTriggers_edges_node_lead_assignee | null;
}

export interface GetMoneyPageTriggers_maUrlTriggers_edges_node {
  __typename: "MaUrlTrigger";
  triggeredTime: any;
  contact: GetMoneyPageTriggers_maUrlTriggers_edges_node_contact | null;
  /**
   * First open lead related to the contact at trigger time.
   */
  lead: GetMoneyPageTriggers_maUrlTriggers_edges_node_lead | null;
}

export interface GetMoneyPageTriggers_maUrlTriggers_edges {
  __typename: "MaUrlTriggersEdge";
  cursor: string;
  node: GetMoneyPageTriggers_maUrlTriggers_edges_node;
}

export interface GetMoneyPageTriggers_maUrlTriggers {
  __typename: "MaUrlTriggersConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetMoneyPageTriggers_maUrlTriggers_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetMoneyPageTriggers_maUrlTriggers_edges[];
}

export interface GetMoneyPageTriggers {
  /**
   * Paginated list of trigger events for a Marketing Automation URL.
   */
  maUrlTriggers: GetMoneyPageTriggers_maUrlTriggers;
}

export interface GetMoneyPageTriggersVariables {
  maUrlId: string;
  first?: number | null;
  after?: string | null;
  last?: number | null;
  before?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMoneyPage
// ====================================================

export interface GetMoneyPage_maUrl_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetMoneyPage_maUrl_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMoneyPage_maUrl_automation_actions_config_ActionConfigRemoveTags {
  __typename: "ActionConfigRemoveTags" | "ActionConfigSendEmail";
}

export interface GetMoneyPage_maUrl_automation_actions_config_ActionConfigAddTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface GetMoneyPage_maUrl_automation_actions_config_ActionConfigAddTags {
  __typename: "ActionConfigAddTags";
  /**
   * The boolean value to filter on.
   */
  tags: GetMoneyPage_maUrl_automation_actions_config_ActionConfigAddTags_tags[];
}

export interface GetMoneyPage_maUrl_automation_actions_config_ActionConfigAddAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetMoneyPage_maUrl_automation_actions_config_ActionConfigAddAudiences {
  __typename: "ActionConfigAddAudiences";
  /**
   * The boolean value to filter on.
   */
  audiences: GetMoneyPage_maUrl_automation_actions_config_ActionConfigAddAudiences_audiences[];
}

export interface GetMoneyPage_maUrl_automation_actions_config_ActionConfigRemoveAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetMoneyPage_maUrl_automation_actions_config_ActionConfigRemoveAudiences {
  __typename: "ActionConfigRemoveAudiences";
  /**
   * The boolean value to filter on.
   */
  audiences: GetMoneyPage_maUrl_automation_actions_config_ActionConfigRemoveAudiences_audiences[];
}

export interface GetMoneyPage_maUrl_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetMoneyPage_maUrl_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
  /**
   * Specific type of alias
   */
  type: NotifiableAliasType;
}

export type GetMoneyPage_maUrl_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables = GetMoneyPage_maUrl_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables_User | GetMoneyPage_maUrl_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables_NotifiableAlias;

export interface GetMoneyPage_maUrl_automation_actions_config_ActionConfigSendPageViewedNotification {
  __typename: "ActionConfigSendPageViewedNotification";
  /**
   * The users or aliases to which the notification should be sent.
   */
  notifiables: GetMoneyPage_maUrl_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables[];
}

export interface GetMoneyPage_maUrl_automation_actions_config_ActionConfigAddToDripSequence_dripSequence {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface GetMoneyPage_maUrl_automation_actions_config_ActionConfigAddToDripSequence {
  __typename: "ActionConfigAddToDripSequence";
  /**
   * The drip sequence to which the contact should be added.
   */
  dripSequence: GetMoneyPage_maUrl_automation_actions_config_ActionConfigAddToDripSequence_dripSequence;
}

export interface GetMoneyPage_maUrl_automation_actions_config_ActionConfigCreateLead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetMoneyPage_maUrl_automation_actions_config_ActionConfigCreateLead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetMoneyPage_maUrl_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetMoneyPage_maUrl_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface GetMoneyPage_maUrl_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type GetMoneyPage_maUrl_automation_actions_config_ActionConfigCreateLead_assigneeOrRule = GetMoneyPage_maUrl_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_User | GetMoneyPage_maUrl_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_Team | GetMoneyPage_maUrl_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule;

export interface GetMoneyPage_maUrl_automation_actions_config_ActionConfigCreateLead {
  __typename: "ActionConfigCreateLead";
  /**
   * The stageset to which the lead should be added.
   */
  stageset: GetMoneyPage_maUrl_automation_actions_config_ActionConfigCreateLead_stageset;
  /**
   * The tags which should be added to the lead.
   */
  tags: GetMoneyPage_maUrl_automation_actions_config_ActionConfigCreateLead_tags[];
  /**
   * The assignee for the lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: GetMoneyPage_maUrl_automation_actions_config_ActionConfigCreateLead_assigneeOrRule | null;
}

export type GetMoneyPage_maUrl_automation_actions_config = GetMoneyPage_maUrl_automation_actions_config_ActionConfigRemoveTags | GetMoneyPage_maUrl_automation_actions_config_ActionConfigAddTags | GetMoneyPage_maUrl_automation_actions_config_ActionConfigAddAudiences | GetMoneyPage_maUrl_automation_actions_config_ActionConfigRemoveAudiences | GetMoneyPage_maUrl_automation_actions_config_ActionConfigSendPageViewedNotification | GetMoneyPage_maUrl_automation_actions_config_ActionConfigAddToDripSequence | GetMoneyPage_maUrl_automation_actions_config_ActionConfigCreateLead;

export interface GetMoneyPage_maUrl_automation_actions {
  __typename: "Action";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * The configuration for this action.
   */
  config: GetMoneyPage_maUrl_automation_actions_config;
  /**
   * Human readable title of this action
   */
  humanReadableTitle: string;
}

export interface GetMoneyPage_maUrl_automation {
  __typename: "Automation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of this automation.
   */
  type: number;
  /**
   * Actions that will be taken when this automation is activated.
   */
  actions: GetMoneyPage_maUrl_automation_actions[];
}

export interface GetMoneyPage_maUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  url: GetMoneyPage_maUrl_url;
  creatorUser: GetMoneyPage_maUrl_creatorUser | null;
  createdTime: any;
  automation: GetMoneyPage_maUrl_automation | null;
  /**
   * When false, the URL is visible in UI but automations will not trigger.
   */
  isEnabled: boolean | null;
  /**
   * Count of page views that triggered the automation.
   */
  views: number;
  /**
   * Null if the automation has never been triggered.
   */
  lastTriggeredTime: any | null;
}

export interface GetMoneyPage {
  /**
   * An individual marketing automation "money" page
   */
  maUrl: GetMoneyPage_maUrl;
}

export interface GetMoneyPageVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMoneyPages
// ====================================================

export interface GetMoneyPages_maUrls_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface GetMoneyPages_maUrls_edges_node_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
}

export interface GetMoneyPages_maUrls_edges_node_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigRemoveTags {
  __typename: "ActionConfigRemoveTags" | "ActionConfigSendEmail";
}

export interface GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigAddTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigAddTags {
  __typename: "ActionConfigAddTags";
  /**
   * The boolean value to filter on.
   */
  tags: GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigAddTags_tags[];
}

export interface GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigAddAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigAddAudiences {
  __typename: "ActionConfigAddAudiences";
  /**
   * The boolean value to filter on.
   */
  audiences: GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigAddAudiences_audiences[];
}

export interface GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigRemoveAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigRemoveAudiences {
  __typename: "ActionConfigRemoveAudiences";
  /**
   * The boolean value to filter on.
   */
  audiences: GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigRemoveAudiences_audiences[];
}

export interface GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
  /**
   * Specific type of alias
   */
  type: NotifiableAliasType;
}

export type GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables = GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables_User | GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables_NotifiableAlias;

export interface GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigSendPageViewedNotification {
  __typename: "ActionConfigSendPageViewedNotification";
  /**
   * The users or aliases to which the notification should be sent.
   */
  notifiables: GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigSendPageViewedNotification_notifiables[];
}

export interface GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigAddToDripSequence_dripSequence {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigAddToDripSequence {
  __typename: "ActionConfigAddToDripSequence";
  /**
   * The drip sequence to which the contact should be added.
   */
  dripSequence: GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigAddToDripSequence_dripSequence;
}

export interface GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigCreateLead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigCreateLead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigCreateLead_assigneeOrRule = GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_User | GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_Team | GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule;

export interface GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigCreateLead {
  __typename: "ActionConfigCreateLead";
  /**
   * The stageset to which the lead should be added.
   */
  stageset: GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigCreateLead_stageset;
  /**
   * The tags which should be added to the lead.
   */
  tags: GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigCreateLead_tags[];
  /**
   * The assignee for the lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigCreateLead_assigneeOrRule | null;
}

export type GetMoneyPages_maUrls_edges_node_automation_actions_config = GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigRemoveTags | GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigAddTags | GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigAddAudiences | GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigRemoveAudiences | GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigSendPageViewedNotification | GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigAddToDripSequence | GetMoneyPages_maUrls_edges_node_automation_actions_config_ActionConfigCreateLead;

export interface GetMoneyPages_maUrls_edges_node_automation_actions {
  __typename: "Action";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * The configuration for this action.
   */
  config: GetMoneyPages_maUrls_edges_node_automation_actions_config;
  /**
   * Human readable title of this action
   */
  humanReadableTitle: string;
}

export interface GetMoneyPages_maUrls_edges_node_automation {
  __typename: "Automation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of this automation.
   */
  type: number;
  /**
   * Actions that will be taken when this automation is activated.
   */
  actions: GetMoneyPages_maUrls_edges_node_automation_actions[];
}

export interface GetMoneyPages_maUrls_edges_node {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  url: GetMoneyPages_maUrls_edges_node_url;
  creatorUser: GetMoneyPages_maUrls_edges_node_creatorUser | null;
  createdTime: any;
  automation: GetMoneyPages_maUrls_edges_node_automation | null;
  /**
   * When false, the URL is visible in UI but automations will not trigger.
   */
  isEnabled: boolean | null;
  /**
   * Null if the automation has never been triggered.
   */
  lastTriggeredTime: any | null;
  /**
   * Count of page views that triggered the automation.
   */
  views: number;
  /**
   * Path to the edit page for this money page.
   */
  htmlUrlPath: string;
}

export interface GetMoneyPages_maUrls_edges {
  __typename: "MaUrlsEdge";
  cursor: string;
  node: GetMoneyPages_maUrls_edges_node;
}

export interface GetMoneyPages_maUrls {
  __typename: "MaUrlsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetMoneyPages_maUrls_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetMoneyPages_maUrls_edges[];
}

export interface GetMoneyPages {
  /**
   * Returns a paging connection of non-deleted marketing automation URLs.
   */
  maUrls: GetMoneyPages_maUrls;
}

export interface GetMoneyPagesVariables {
  first?: number | null;
  after?: string | null;
  last?: number | null;
  before?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetNewsletterEngagementStats
// ====================================================

export interface GetNewsletterEngagementStats_newsletter_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
}

export interface GetNewsletterEngagementStats_newsletter_editions_edges_node_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
}

export interface GetNewsletterEngagementStats_newsletter_editions_edges_node_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
}

export interface GetNewsletterEngagementStats_newsletter_editions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetNewsletterEngagementStats_newsletter_editions_edges_node_emailTemplate | null;
  sendTime: any | null;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  engagementStats: GetNewsletterEngagementStats_newsletter_editions_edges_node_engagementStats;
}

export interface GetNewsletterEngagementStats_newsletter_editions_edges {
  __typename: "EditionsEdge";
  node: GetNewsletterEngagementStats_newsletter_editions_edges_node;
}

export interface GetNewsletterEngagementStats_newsletter_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetNewsletterEngagementStats_newsletter_editions_edges[];
}

export interface GetNewsletterEngagementStats_newsletter {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  engagementStats: GetNewsletterEngagementStats_newsletter_engagementStats;
  editions: GetNewsletterEngagementStats_newsletter_editions;
}

export interface GetNewsletterEngagementStats {
  /**
   * Returns an email marketing newsletter.
   */
  newsletter: GetNewsletterEngagementStats_newsletter | null;
}

export interface GetNewsletterEngagementStatsVariables {
  newsletterId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MakeAudiencePrivate
// ====================================================

export interface MakeAudiencePrivate_audienceUpdate_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface MakeAudiencePrivate_audienceUpdate_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  totalCount: MakeAudiencePrivate_audienceUpdate_audience_membershipStats_totalCount;
}

export interface MakeAudiencePrivate_audienceUpdate_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The public name of this audience
   */
  publicName: string;
  /**
   * The description of this audience
   */
  description: string | null;
  /**
   * The public description of this audience
   */
  publicDescription: string | null;
  /**
   * Is this audience on the preference center?
   */
  isPublic: boolean;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  deletedTime: any | null;
  /**
   * The last time an email or SMS edition was sent to this audience
   */
  lastContactedTime: any | null;
  membershipStats: MakeAudiencePrivate_audienceUpdate_audience_membershipStats;
}

export interface MakeAudiencePrivate_audienceUpdate {
  __typename: "AudienceUpdatePayload";
  /**
   * The audience
   */
  audience: MakeAudiencePrivate_audienceUpdate_audience;
}

export interface MakeAudiencePrivate {
  /**
   * Save the template data for an email marketing audience
   */
  audienceUpdate: MakeAudiencePrivate_audienceUpdate | null;
}

export interface MakeAudiencePrivateVariables {
  audienceId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MakeAudiencePublic
// ====================================================

export interface MakeAudiencePublic_audienceUpdate_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface MakeAudiencePublic_audienceUpdate_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  totalCount: MakeAudiencePublic_audienceUpdate_audience_membershipStats_totalCount;
}

export interface MakeAudiencePublic_audienceUpdate_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The public name of this audience
   */
  publicName: string;
  /**
   * The description of this audience
   */
  description: string | null;
  /**
   * The public description of this audience
   */
  publicDescription: string | null;
  /**
   * Is this audience on the preference center?
   */
  isPublic: boolean;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  deletedTime: any | null;
  /**
   * The last time an email or SMS edition was sent to this audience
   */
  lastContactedTime: any | null;
  membershipStats: MakeAudiencePublic_audienceUpdate_audience_membershipStats;
}

export interface MakeAudiencePublic_audienceUpdate {
  __typename: "AudienceUpdatePayload";
  /**
   * The audience
   */
  audience: MakeAudiencePublic_audienceUpdate_audience;
}

export interface MakeAudiencePublic {
  /**
   * Save the template data for an email marketing audience
   */
  audienceUpdate: MakeAudiencePublic_audienceUpdate | null;
}

export interface MakeAudiencePublicVariables {
  input: AudienceUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAudiencesForPreferenceCenter
// ====================================================

export interface GetAudiencesForPreferenceCenter_audiences_edges_node_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetAudiencesForPreferenceCenter_audiences_edges_node_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  totalCount: GetAudiencesForPreferenceCenter_audiences_edges_node_membershipStats_totalCount;
}

export interface GetAudiencesForPreferenceCenter_audiences_edges_node {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The public name of this audience
   */
  publicName: string;
  /**
   * The description of this audience
   */
  description: string | null;
  /**
   * The public description of this audience
   */
  publicDescription: string | null;
  /**
   * Is this audience on the preference center?
   */
  isPublic: boolean;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  deletedTime: any | null;
  /**
   * The last time an email or SMS edition was sent to this audience
   */
  lastContactedTime: any | null;
  membershipStats: GetAudiencesForPreferenceCenter_audiences_edges_node_membershipStats;
}

export interface GetAudiencesForPreferenceCenter_audiences_edges {
  __typename: "AudienceEdge";
  cursor: string;
  node: GetAudiencesForPreferenceCenter_audiences_edges_node;
}

export interface GetAudiencesForPreferenceCenter_audiences {
  __typename: "AudienceConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetAudiencesForPreferenceCenter_audiences_edges[];
}

export interface GetAudiencesForPreferenceCenter {
  /**
   * Returns all email marketing audiences
   */
  audiences: GetAudiencesForPreferenceCenter_audiences;
}

export interface GetAudiencesForPreferenceCenterVariables {
  sort: AudienceSortType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPublicAudience
// ====================================================

export interface GetPublicAudience_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetPublicAudience_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  totalCount: GetPublicAudience_audience_membershipStats_totalCount;
}

export interface GetPublicAudience_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The public name of this audience
   */
  publicName: string;
  /**
   * The description of this audience
   */
  description: string | null;
  /**
   * The public description of this audience
   */
  publicDescription: string | null;
  /**
   * Is this audience on the preference center?
   */
  isPublic: boolean;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  deletedTime: any | null;
  /**
   * The last time an email or SMS edition was sent to this audience
   */
  lastContactedTime: any | null;
  membershipStats: GetPublicAudience_audience_membershipStats;
}

export interface GetPublicAudience {
  /**
   * Returns an email marketing audience.
   */
  audience: GetPublicAudience_audience;
}

export interface GetPublicAudienceVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateSmsBroadcast
// ====================================================

export interface CreateSmsBroadcast_smsBroadcastCreate_broadcast_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The URL that this edition links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface CreateSmsBroadcast_smsBroadcastCreate_broadcast {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The URL that this campaign links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The edition of the broadcast
   */
  edition: CreateSmsBroadcast_smsBroadcastCreate_broadcast_edition;
}

export interface CreateSmsBroadcast_smsBroadcastCreate {
  __typename: "SmsBroadcastCreatePayload";
  /**
   * The newly created broadcast
   */
  broadcast: CreateSmsBroadcast_smsBroadcastCreate_broadcast;
}

export interface CreateSmsBroadcast {
  /**
   * Create a new sms marketing broadcast
   */
  smsBroadcastCreate: CreateSmsBroadcast_smsBroadcastCreate | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteSmsCampaign
// ====================================================

export interface DeleteSmsCampaign_campaignDelete_campaign {
  __typename: "Campaign" | "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteSmsCampaign_campaignDelete {
  __typename: "CampaignDeletePayload";
  /**
   * The campaign
   */
  campaign: DeleteSmsCampaign_campaignDelete_campaign;
}

export interface DeleteSmsCampaign {
  /**
   * Delete a campaign and associated content.
   */
  campaignDelete: DeleteSmsCampaign_campaignDelete | null;
}

export interface DeleteSmsCampaignVariables {
  input: CampaignDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RestoreSmsCampaign
// ====================================================

export interface RestoreSmsCampaign_smsCampaignRestore_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface RestoreSmsCampaign_smsCampaignRestore {
  __typename: "SmsCampaignRestorePayload";
  /**
   * The campaign
   */
  campaign: RestoreSmsCampaign_smsCampaignRestore_campaign;
}

export interface RestoreSmsCampaign {
  /**
   * Restore an sms campaign
   */
  smsCampaignRestore: RestoreSmsCampaign_smsCampaignRestore | null;
}

export interface RestoreSmsCampaignVariables {
  input: SmsCampaignRestoreInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ScheduleSmsEdition
// ====================================================

export interface ScheduleSmsEdition_editionSchedule_edition_Edition {
  __typename: "Edition";
}

export interface ScheduleSmsEdition_editionSchedule_edition_SmsEdition_from_phone {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface ScheduleSmsEdition_editionSchedule_edition_SmsEdition_from {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
  phone: ScheduleSmsEdition_editionSchedule_edition_SmsEdition_from_phone | null;
}

export interface ScheduleSmsEdition_editionSchedule_edition_SmsEdition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ScheduleSmsEdition_editionSchedule_edition_SmsEdition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The user who owns this campaign
   */
  owner: ScheduleSmsEdition_editionSchedule_edition_SmsEdition_campaign_owner | null;
}

export interface ScheduleSmsEdition_editionSchedule_edition_SmsEdition_engagementStats {
  __typename: "SmsEngagementStats";
  /**
   * Total number of texts we tried to send
   */
  totalSentCount: number;
  /**
   * Total number of people who responded to the SMS campaign
   */
  responseCount: number;
  /**
   * The ratio of response to total texts sent
   */
  responseRate: number | null;
  /**
   * Total number of texts which couldn’t be delivered
   */
  undeliveredCount: number;
  /**
   * The ratio of undelivered texts to total texts sent
   */
  undeliveredRate: number | null;
  /**
   * The number of people who opted out of SMS messages after receiving this campaign
   */
  optoutCount: number;
  /**
   * The ratio of optouts to total texts sent
   */
  optoutRate: number | null;
}

export interface ScheduleSmsEdition_editionSchedule_edition_SmsEdition_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface ScheduleSmsEdition_editionSchedule_edition_SmsEdition_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: ScheduleSmsEdition_editionSchedule_edition_SmsEdition_audience_fromSavedFilter_count;
}

export interface ScheduleSmsEdition_editionSchedule_edition_SmsEdition_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface ScheduleSmsEdition_editionSchedule_edition_SmsEdition_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: ScheduleSmsEdition_editionSchedule_edition_SmsEdition_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface ScheduleSmsEdition_editionSchedule_edition_SmsEdition_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface ScheduleSmsEdition_editionSchedule_edition_SmsEdition_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: ScheduleSmsEdition_editionSchedule_edition_SmsEdition_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface ScheduleSmsEdition_editionSchedule_edition_SmsEdition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: ScheduleSmsEdition_editionSchedule_edition_SmsEdition_audience_fromSavedFilter | null;
  membershipStats: ScheduleSmsEdition_editionSchedule_edition_SmsEdition_audience_membershipStats;
  smsMembershipStats: ScheduleSmsEdition_editionSchedule_edition_SmsEdition_audience_smsMembershipStats;
}

export interface ScheduleSmsEdition_editionSchedule_edition_SmsEdition_gateError {
  __typename: "SmsGateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface ScheduleSmsEdition_editionSchedule_edition_SmsEdition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The content of the edition
   */
  content: string;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  scheduledTime: any | null;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The channel this edition was sent from
   */
  from: ScheduleSmsEdition_editionSchedule_edition_SmsEdition_from | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: ScheduleSmsEdition_editionSchedule_edition_SmsEdition_campaign;
  /**
   * The opt-out string in the message content
   */
  optOutText: string | null;
  engagementStats: ScheduleSmsEdition_editionSchedule_edition_SmsEdition_engagementStats;
  /**
   * The audience to send this edition to
   */
  audience: ScheduleSmsEdition_editionSchedule_edition_SmsEdition_audience | null;
  /**
   * If the content of the edition contains a link from a public URL shortener
   */
  hasShortLink: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: ScheduleSmsEdition_editionSchedule_edition_SmsEdition_gateError | null;
  /**
   * The number of SMS Campaigns credits this account has per month
   */
  smsCampaignsCreditLimit: number | null;
  /**
   * The number of SMS Campaigns credits this account has used per month
   */
  smsCampaignsCreditsUsed: number;
}

export type ScheduleSmsEdition_editionSchedule_edition = ScheduleSmsEdition_editionSchedule_edition_Edition | ScheduleSmsEdition_editionSchedule_edition_SmsEdition;

export interface ScheduleSmsEdition_editionSchedule {
  __typename: "EditionSchedulePayload";
  /**
   * The edition
   */
  edition: ScheduleSmsEdition_editionSchedule_edition;
}

export interface ScheduleSmsEdition {
  /**
   * Schedule an edition for sending.
   */
  editionSchedule: ScheduleSmsEdition_editionSchedule | null;
}

export interface ScheduleSmsEditionVariables {
  input: EditionScheduleInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendSmsEdition
// ====================================================

export interface SendSmsEdition_editionSendToFilteredList_edition_Edition {
  __typename: "Edition";
}

export interface SendSmsEdition_editionSendToFilteredList_edition_SmsEdition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type SendSmsEdition_editionSendToFilteredList_edition = SendSmsEdition_editionSendToFilteredList_edition_Edition | SendSmsEdition_editionSendToFilteredList_edition_SmsEdition;

export interface SendSmsEdition_editionSendToFilteredList {
  __typename: "EditionSendToFilteredListPayload";
  /**
   * The edition
   */
  edition: SendSmsEdition_editionSendToFilteredList_edition;
}

export interface SendSmsEdition {
  /**
   * Send an edition to a filtered list of people.
   */
  editionSendToFilteredList: SendSmsEdition_editionSendToFilteredList | null;
}

export interface SendSmsEditionVariables {
  input: EditionSendToFilteredListInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UnscheduleSmsEdition
// ====================================================

export interface UnscheduleSmsEdition_editionUnschedule_edition_Edition {
  __typename: "Edition";
}

export interface UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_from_phone {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_from {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
  phone: UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_from_phone | null;
}

export interface UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The user who owns this campaign
   */
  owner: UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_campaign_owner | null;
}

export interface UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_engagementStats {
  __typename: "SmsEngagementStats";
  /**
   * Total number of texts we tried to send
   */
  totalSentCount: number;
  /**
   * Total number of people who responded to the SMS campaign
   */
  responseCount: number;
  /**
   * The ratio of response to total texts sent
   */
  responseRate: number | null;
  /**
   * Total number of texts which couldn’t be delivered
   */
  undeliveredCount: number;
  /**
   * The ratio of undelivered texts to total texts sent
   */
  undeliveredRate: number | null;
  /**
   * The number of people who opted out of SMS messages after receiving this campaign
   */
  optoutCount: number;
  /**
   * The ratio of optouts to total texts sent
   */
  optoutRate: number | null;
}

export interface UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_audience_fromSavedFilter_count;
}

export interface UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_audience_fromSavedFilter | null;
  membershipStats: UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_audience_membershipStats;
  smsMembershipStats: UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_audience_smsMembershipStats;
}

export interface UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_gateError {
  __typename: "SmsGateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The content of the edition
   */
  content: string;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  scheduledTime: any | null;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The channel this edition was sent from
   */
  from: UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_from | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_campaign;
  /**
   * The opt-out string in the message content
   */
  optOutText: string | null;
  engagementStats: UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_engagementStats;
  /**
   * The audience to send this edition to
   */
  audience: UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_audience | null;
  /**
   * If the content of the edition contains a link from a public URL shortener
   */
  hasShortLink: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition_gateError | null;
  /**
   * The number of SMS Campaigns credits this account has per month
   */
  smsCampaignsCreditLimit: number | null;
  /**
   * The number of SMS Campaigns credits this account has used per month
   */
  smsCampaignsCreditsUsed: number;
}

export type UnscheduleSmsEdition_editionUnschedule_edition = UnscheduleSmsEdition_editionUnschedule_edition_Edition | UnscheduleSmsEdition_editionUnschedule_edition_SmsEdition;

export interface UnscheduleSmsEdition_editionUnschedule {
  __typename: "EditionSchedulePayload";
  /**
   * The edition
   */
  edition: UnscheduleSmsEdition_editionUnschedule_edition;
}

export interface UnscheduleSmsEdition {
  /**
   * Unschedule an edition that has been scheduled for sending.
   */
  editionUnschedule: UnscheduleSmsEdition_editionUnschedule | null;
}

export interface UnscheduleSmsEditionVariables {
  input: EditionUnscheduleInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateSMSBroadcast
// ====================================================

export interface UpdateSMSBroadcast_smsEditionUpdate_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateSMSBroadcast_smsEditionUpdate_edition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The user who owns this campaign
   */
  owner: UpdateSMSBroadcast_smsEditionUpdate_edition_campaign_owner | null;
}

export interface UpdateSMSBroadcast_smsEditionUpdate_edition_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface UpdateSMSBroadcast_smsEditionUpdate_edition_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: UpdateSMSBroadcast_smsEditionUpdate_edition_audience_fromSavedFilter_count;
}

export interface UpdateSMSBroadcast_smsEditionUpdate_edition_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface UpdateSMSBroadcast_smsEditionUpdate_edition_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: UpdateSMSBroadcast_smsEditionUpdate_edition_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface UpdateSMSBroadcast_smsEditionUpdate_edition_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface UpdateSMSBroadcast_smsEditionUpdate_edition_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: UpdateSMSBroadcast_smsEditionUpdate_edition_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface UpdateSMSBroadcast_smsEditionUpdate_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: UpdateSMSBroadcast_smsEditionUpdate_edition_audience_fromSavedFilter | null;
  membershipStats: UpdateSMSBroadcast_smsEditionUpdate_edition_audience_membershipStats;
  smsMembershipStats: UpdateSMSBroadcast_smsEditionUpdate_edition_audience_smsMembershipStats;
}

export interface UpdateSMSBroadcast_smsEditionUpdate_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The content of the edition
   */
  content: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: UpdateSMSBroadcast_smsEditionUpdate_edition_campaign;
  /**
   * The opt-out string in the message content
   */
  optOutText: string | null;
  /**
   * The audience to send this edition to
   */
  audience: UpdateSMSBroadcast_smsEditionUpdate_edition_audience | null;
}

export interface UpdateSMSBroadcast_smsEditionUpdate {
  __typename: "SmsEditionUpdatePayload";
  /**
   * The edition
   */
  edition: UpdateSMSBroadcast_smsEditionUpdate_edition;
}

export interface UpdateSMSBroadcast {
  /**
   * Save the data for an sms marketing edition
   */
  smsEditionUpdate: UpdateSMSBroadcast_smsEditionUpdate | null;
}

export interface UpdateSMSBroadcastVariables {
  input: SmsEditionUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSmsBroadcastEngagementStats
// ====================================================

export interface GetSmsBroadcastEngagementStats_smsBroadcasts_edition_engagementStats {
  __typename: "SmsEngagementStats";
  /**
   * Total number of texts we tried to send
   */
  totalSentCount: number;
  /**
   * Total number of people who responded to the SMS campaign
   */
  responseCount: number;
  /**
   * The ratio of response to total texts sent
   */
  responseRate: number | null;
  /**
   * Total number of texts which couldn’t be delivered
   */
  undeliveredCount: number;
  /**
   * The ratio of undelivered texts to total texts sent
   */
  undeliveredRate: number | null;
  /**
   * The number of people who opted out of SMS messages after receiving this campaign
   */
  optoutCount: number;
  /**
   * The ratio of optouts to total texts sent
   */
  optoutRate: number | null;
}

export interface GetSmsBroadcastEngagementStats_smsBroadcasts_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  engagementStats: GetSmsBroadcastEngagementStats_smsBroadcasts_edition_engagementStats;
}

export interface GetSmsBroadcastEngagementStats_smsBroadcasts {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The edition of the broadcast
   */
  edition: GetSmsBroadcastEngagementStats_smsBroadcasts_edition;
}

export interface GetSmsBroadcastEngagementStats {
  /**
   * Returns a list of sms broadcasts.
   */
  smsBroadcasts: GetSmsBroadcastEngagementStats_smsBroadcasts[];
}

export interface GetSmsBroadcastEngagementStatsVariables {
  archived?: boolean | null;
  statuses: EditionStatus[];
  assigneeIds?: string[] | null;
  lastUpdatedTime?: string | null;
  creatorUserId?: string | null;
  search?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSmsBroadcast
// ====================================================

export interface GetSmsBroadcast_smsBroadcast_edition_from_phone {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetSmsBroadcast_smsBroadcast_edition_from {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
  phone: GetSmsBroadcast_smsBroadcast_edition_from_phone | null;
}

export interface GetSmsBroadcast_smsBroadcast_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetSmsBroadcast_smsBroadcast_edition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The user who owns this campaign
   */
  owner: GetSmsBroadcast_smsBroadcast_edition_campaign_owner | null;
}

export interface GetSmsBroadcast_smsBroadcast_edition_engagementStats {
  __typename: "SmsEngagementStats";
  /**
   * Total number of texts we tried to send
   */
  totalSentCount: number;
  /**
   * Total number of people who responded to the SMS campaign
   */
  responseCount: number;
  /**
   * The ratio of response to total texts sent
   */
  responseRate: number | null;
  /**
   * Total number of texts which couldn’t be delivered
   */
  undeliveredCount: number;
  /**
   * The ratio of undelivered texts to total texts sent
   */
  undeliveredRate: number | null;
  /**
   * The number of people who opted out of SMS messages after receiving this campaign
   */
  optoutCount: number;
  /**
   * The ratio of optouts to total texts sent
   */
  optoutRate: number | null;
}

export interface GetSmsBroadcast_smsBroadcast_edition_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetSmsBroadcast_smsBroadcast_edition_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: GetSmsBroadcast_smsBroadcast_edition_audience_fromSavedFilter_count;
}

export interface GetSmsBroadcast_smsBroadcast_edition_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetSmsBroadcast_smsBroadcast_edition_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetSmsBroadcast_smsBroadcast_edition_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface GetSmsBroadcast_smsBroadcast_edition_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetSmsBroadcast_smsBroadcast_edition_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetSmsBroadcast_smsBroadcast_edition_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface GetSmsBroadcast_smsBroadcast_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: GetSmsBroadcast_smsBroadcast_edition_audience_fromSavedFilter | null;
  membershipStats: GetSmsBroadcast_smsBroadcast_edition_audience_membershipStats;
  smsMembershipStats: GetSmsBroadcast_smsBroadcast_edition_audience_smsMembershipStats;
}

export interface GetSmsBroadcast_smsBroadcast_edition_gateError {
  __typename: "SmsGateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface GetSmsBroadcast_smsBroadcast_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The content of the edition
   */
  content: string;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  scheduledTime: any | null;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The channel this edition was sent from
   */
  from: GetSmsBroadcast_smsBroadcast_edition_from | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetSmsBroadcast_smsBroadcast_edition_campaign;
  /**
   * The opt-out string in the message content
   */
  optOutText: string | null;
  engagementStats: GetSmsBroadcast_smsBroadcast_edition_engagementStats;
  /**
   * The audience to send this edition to
   */
  audience: GetSmsBroadcast_smsBroadcast_edition_audience | null;
  /**
   * If the content of the edition contains a link from a public URL shortener
   */
  hasShortLink: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: GetSmsBroadcast_smsBroadcast_edition_gateError | null;
  /**
   * The number of SMS Campaigns credits this account has per month
   */
  smsCampaignsCreditLimit: number | null;
  /**
   * The number of SMS Campaigns credits this account has used per month
   */
  smsCampaignsCreditsUsed: number;
}

export interface GetSmsBroadcast_smsBroadcast_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSmsBroadcast_smsBroadcast {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The edition of the broadcast
   */
  edition: GetSmsBroadcast_smsBroadcast_edition;
  /**
   * The user who owns this campaign
   */
  owner: GetSmsBroadcast_smsBroadcast_owner | null;
}

export interface GetSmsBroadcast {
  /**
   * Returns the sms broadcast.
   */
  smsBroadcast: GetSmsBroadcast_smsBroadcast;
}

export interface GetSmsBroadcastVariables {
  broadcastId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSmsBroadcasts
// ====================================================

export interface GetSmsBroadcasts_smsBroadcasts_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The content of the edition
   */
  content: string;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  scheduledTime: any | null;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The opt-out string in the message content
   */
  optOutText: string | null;
}

export interface GetSmsBroadcasts_smsBroadcasts_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSmsBroadcasts_smsBroadcasts {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The edition of the broadcast
   */
  edition: GetSmsBroadcasts_smsBroadcasts_edition;
  /**
   * The user who owns this campaign
   */
  owner: GetSmsBroadcasts_smsBroadcasts_owner | null;
}

export interface GetSmsBroadcasts {
  /**
   * Returns a list of sms broadcasts.
   */
  smsBroadcasts: GetSmsBroadcasts_smsBroadcasts[];
}

export interface GetSmsBroadcastsVariables {
  archived?: boolean | null;
  statuses: EditionStatus[];
  assigneeIds?: string[] | null;
  lastUpdatedTime?: string | null;
  creatorUserId?: string | null;
  search?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ActivateSmsDripSequence
// ====================================================

export interface ActivateSmsDripSequence_smsDripSequenceActivate_dripSequence_editions_edges_node {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
}

export interface ActivateSmsDripSequence_smsDripSequenceActivate_dripSequence_editions_edges {
  __typename: "SmsDripEditionsEdge";
  node: ActivateSmsDripSequence_smsDripSequenceActivate_dripSequence_editions_edges_node;
}

export interface ActivateSmsDripSequence_smsDripSequenceActivate_dripSequence_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * A list of edges.
   */
  edges: ActivateSmsDripSequence_smsDripSequenceActivate_dripSequence_editions_edges[];
}

export interface ActivateSmsDripSequence_smsDripSequenceActivate_dripSequence {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The editions of the drip sequence
   */
  editions: ActivateSmsDripSequence_smsDripSequenceActivate_dripSequence_editions;
}

export interface ActivateSmsDripSequence_smsDripSequenceActivate {
  __typename: "SmsDripSequenceActivatePayload";
  /**
   * The newly created drip sequence
   */
  dripSequence: ActivateSmsDripSequence_smsDripSequenceActivate_dripSequence;
}

export interface ActivateSmsDripSequence {
  /**
   * Activate a new sms marketing drip sequence
   */
  smsDripSequenceActivate: ActivateSmsDripSequence_smsDripSequenceActivate | null;
}

export interface ActivateSmsDripSequenceVariables {
  input: SmsDripSequenceActivateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateSmsDripSequenceEdition
// ====================================================

export interface CreateSmsDripSequenceEdition_smsDripEditionCreate_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface CreateSmsDripSequenceEdition_smsDripEditionCreate_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * The URL that this edition links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: CreateSmsDripSequenceEdition_smsDripEditionCreate_edition_delay | null;
}

export interface CreateSmsDripSequenceEdition_smsDripEditionCreate {
  __typename: "SmsDripEditionCreatePayload";
  /**
   * The new edition
   */
  edition: CreateSmsDripSequenceEdition_smsDripEditionCreate_edition;
}

export interface CreateSmsDripSequenceEdition {
  /**
   * Create a new sms marketing edition
   */
  smsDripEditionCreate: CreateSmsDripSequenceEdition_smsDripEditionCreate | null;
}

export interface CreateSmsDripSequenceEditionVariables {
  input: SmsDripEditionCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateSmsDripSequence
// ====================================================

export interface CreateSmsDripSequence_smsDripSequenceCreate_dripSequence {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The URL that this campaign links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface CreateSmsDripSequence_smsDripSequenceCreate {
  __typename: "SmsDripSequencePayload";
  /**
   * The newly created drip sequence
   */
  dripSequence: CreateSmsDripSequence_smsDripSequenceCreate_dripSequence;
}

export interface CreateSmsDripSequence {
  /**
   * Creates a new sms marketing drip sequence
   */
  smsDripSequenceCreate: CreateSmsDripSequence_smsDripSequenceCreate | null;
}

export interface CreateSmsDripSequenceVariables {
  input: SmsDripSequenceCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteSmsDripEdition
// ====================================================

export interface DeleteSmsDripEdition_smsDripEditionDelete_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteSmsDripEdition_smsDripEditionDelete {
  __typename: "SmsDripEditionDeletePayload";
  /**
   * The edition
   */
  edition: DeleteSmsDripEdition_smsDripEditionDelete_edition;
}

export interface DeleteSmsDripEdition {
  /**
   * Delete a sms drip sequence edition
   */
  smsDripEditionDelete: DeleteSmsDripEdition_smsDripEditionDelete | null;
}

export interface DeleteSmsDripEditionVariables {
  input: SmsDripEditionDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DuplicateSmsDripSequence
// ====================================================

export interface DuplicateSmsDripSequence_dripSequenceDuplicate_dripSequence {
  __typename: "Campaign" | "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface DuplicateSmsDripSequence_dripSequenceDuplicate {
  __typename: "DripSequenceDuplicatePayload";
  /**
   * The newly duplicated drip sequence
   */
  dripSequence: DuplicateSmsDripSequence_dripSequenceDuplicate_dripSequence;
}

export interface DuplicateSmsDripSequence {
  /**
   * Duplicate an existing email marketing drip sequence
   */
  dripSequenceDuplicate: DuplicateSmsDripSequence_dripSequenceDuplicate | null;
}

export interface DuplicateSmsDripSequenceVariables {
  input: DripSequenceDuplicateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetDripSequenceStartTrigger
// ====================================================

export interface SetDripSequenceStartTrigger_startTriggerSet_campaign {
  __typename: "Campaign" | "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SetDripSequenceStartTrigger_startTriggerSet {
  __typename: "StartTriggerSetPayload";
  /**
   * The newly updated Nutshell campaign
   */
  campaign: SetDripSequenceStartTrigger_startTriggerSet_campaign;
}

export interface SetDripSequenceStartTrigger {
  /**
   * Sets a startTrigger for a given drip sequence.
   */
  startTriggerSet: SetDripSequenceStartTrigger_startTriggerSet;
}

export interface SetDripSequenceStartTriggerVariables {
  input: StartTriggerSetInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateSmsDripEdition
// ====================================================

export interface UpdateSmsDripEdition_smsEditionUpdate_edition_from_phone {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface UpdateSmsDripEdition_smsEditionUpdate_edition_from {
  __typename: "InboxChannel";
  phone: UpdateSmsDripEdition_smsEditionUpdate_edition_from_phone | null;
}

export interface UpdateSmsDripEdition_smsEditionUpdate_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateSmsDripEdition_smsEditionUpdate_edition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The user who owns this campaign
   */
  owner: UpdateSmsDripEdition_smsEditionUpdate_edition_campaign_owner | null;
}

export interface UpdateSmsDripEdition_smsEditionUpdate_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface UpdateSmsDripEdition_smsEditionUpdate_edition_engagementStats {
  __typename: "SmsEngagementStats";
  /**
   * Total number of texts we tried to send
   */
  totalSentCount: number;
  /**
   * Total number of people who responded to the SMS campaign
   */
  responseCount: number;
  /**
   * The ratio of response to total texts sent
   */
  responseRate: number | null;
  /**
   * Total number of texts which couldn’t be delivered
   */
  undeliveredCount: number;
  /**
   * The ratio of undelivered texts to total texts sent
   */
  undeliveredRate: number | null;
  /**
   * The number of people who opted out of SMS messages after receiving this campaign
   */
  optoutCount: number;
  /**
   * The ratio of optouts to total texts sent
   */
  optoutRate: number | null;
  /**
   * The ratio of goals met to total drip editions sent
   */
  dripProgressionsGoalMetRate: number | null;
  /**
   * The number of times the goal was met for this (drip) edition
   */
  goalMetCount: number | null;
}

export interface UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity = UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account | UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges_node {
  __typename: "SmsDripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges {
  __typename: "SmsEditionDripProgressionEdge";
  node: UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges_node;
}

export interface UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions {
  __typename: "SmsEditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions_edges[];
}

export interface UpdateSmsDripEdition_smsEditionUpdate_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The content of the edition
   */
  content: string;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The channel this edition was sent from
   */
  from: UpdateSmsDripEdition_smsEditionUpdate_edition_from | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: UpdateSmsDripEdition_smsEditionUpdate_edition_campaign;
  /**
   * The opt-out string in the message content
   */
  optOutText: string | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: UpdateSmsDripEdition_smsEditionUpdate_edition_delay | null;
  engagementStats: UpdateSmsDripEdition_smsEditionUpdate_edition_engagementStats;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: UpdateSmsDripEdition_smsEditionUpdate_edition_queuedDripProgressions | null;
  /**
   * If the content of the edition contains a link from a public URL shortener
   */
  hasShortLink: boolean;
}

export interface UpdateSmsDripEdition_smsEditionUpdate {
  __typename: "SmsEditionUpdatePayload";
  /**
   * The edition
   */
  edition: UpdateSmsDripEdition_smsEditionUpdate_edition;
}

export interface UpdateSmsDripEdition {
  /**
   * Save the data for an sms marketing edition
   */
  smsEditionUpdate: UpdateSmsDripEdition_smsEditionUpdate | null;
}

export interface UpdateSmsDripEditionVariables {
  edition: SmsEditionUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateSmsDripSequence
// ====================================================

export interface UpdateSmsDripSequence_smsDripSequenceUpdate_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The URL that this campaign links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
}

export interface UpdateSmsDripSequence_smsDripSequenceUpdate {
  __typename: "SmsDripSequenceUpdatePayload";
  /**
   * The campaign
   */
  campaign: UpdateSmsDripSequence_smsDripSequenceUpdate_campaign;
}

export interface UpdateSmsDripSequence {
  /**
   * Updates a sms drip sequence
   */
  smsDripSequenceUpdate: UpdateSmsDripSequence_smsDripSequenceUpdate | null;
}

export interface UpdateSmsDripSequenceVariables {
  input: SmsDripSequenceUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSmsDripEdition
// ====================================================

export interface GetSmsDripEdition_smsDripEdition_from_phone {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetSmsDripEdition_smsDripEdition_from {
  __typename: "InboxChannel";
  phone: GetSmsDripEdition_smsDripEdition_from_phone | null;
}

export interface GetSmsDripEdition_smsDripEdition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetSmsDripEdition_smsDripEdition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The user who owns this campaign
   */
  owner: GetSmsDripEdition_smsDripEdition_campaign_owner | null;
}

export interface GetSmsDripEdition_smsDripEdition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetSmsDripEdition_smsDripEdition_engagementStats {
  __typename: "SmsEngagementStats";
  /**
   * Total number of texts we tried to send
   */
  totalSentCount: number;
  /**
   * Total number of people who responded to the SMS campaign
   */
  responseCount: number;
  /**
   * The ratio of response to total texts sent
   */
  responseRate: number | null;
  /**
   * Total number of texts which couldn’t be delivered
   */
  undeliveredCount: number;
  /**
   * The ratio of undelivered texts to total texts sent
   */
  undeliveredRate: number | null;
  /**
   * The number of people who opted out of SMS messages after receiving this campaign
   */
  optoutCount: number;
  /**
   * The ratio of optouts to total texts sent
   */
  optoutRate: number | null;
  /**
   * The ratio of goals met to total drip editions sent
   */
  dripProgressionsGoalMetRate: number | null;
  /**
   * The number of times the goal was met for this (drip) edition
   */
  goalMetCount: number | null;
}

export interface GetSmsDripEdition_smsDripEdition_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges_node_audienceMember_entity = GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges_node_audienceMember_entity_Account | GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges_node {
  __typename: "SmsDripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges {
  __typename: "SmsEditionDripProgressionEdge";
  node: GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges_node;
}

export interface GetSmsDripEdition_smsDripEdition_queuedDripProgressions {
  __typename: "SmsEditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetSmsDripEdition_smsDripEdition_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetSmsDripEdition_smsDripEdition_queuedDripProgressions_edges[];
}

export interface GetSmsDripEdition_smsDripEdition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The content of the edition
   */
  content: string;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The channel this edition was sent from
   */
  from: GetSmsDripEdition_smsDripEdition_from | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetSmsDripEdition_smsDripEdition_campaign;
  /**
   * The opt-out string in the message content
   */
  optOutText: string | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: GetSmsDripEdition_smsDripEdition_delay | null;
  engagementStats: GetSmsDripEdition_smsDripEdition_engagementStats;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: GetSmsDripEdition_smsDripEdition_queuedDripProgressions | null;
  /**
   * If the content of the edition contains a link from a public URL shortener
   */
  hasShortLink: boolean;
}

export interface GetSmsDripEdition {
  /**
   * Returns the sms marketing drip edition.
   */
  smsDripEdition: GetSmsDripEdition_smsDripEdition;
}

export interface GetSmsDripEditionVariables {
  editionId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSmsDripSequenceEditions
// ====================================================

export interface GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_from_phone {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_from {
  __typename: "InboxChannel";
  phone: GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_from_phone | null;
}

export interface GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The user who owns this campaign
   */
  owner: GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_campaign_owner | null;
}

export interface GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_engagementStats {
  __typename: "SmsEngagementStats";
  /**
   * Total number of texts we tried to send
   */
  totalSentCount: number;
  /**
   * Total number of people who responded to the SMS campaign
   */
  responseCount: number;
  /**
   * The ratio of response to total texts sent
   */
  responseRate: number | null;
  /**
   * Total number of texts which couldn’t be delivered
   */
  undeliveredCount: number;
  /**
   * The ratio of undelivered texts to total texts sent
   */
  undeliveredRate: number | null;
  /**
   * The number of people who opted out of SMS messages after receiving this campaign
   */
  optoutCount: number;
  /**
   * The ratio of optouts to total texts sent
   */
  optoutRate: number | null;
  /**
   * The ratio of goals met to total drip editions sent
   */
  dripProgressionsGoalMetRate: number | null;
  /**
   * The number of times the goal was met for this (drip) edition
   */
  goalMetCount: number | null;
}

export interface GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity = GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Account | GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges_node {
  __typename: "SmsDripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges {
  __typename: "SmsEditionDripProgressionEdge";
  node: GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges_node;
}

export interface GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions {
  __typename: "SmsEditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions_edges[];
}

export interface GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The content of the edition
   */
  content: string;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The channel this edition was sent from
   */
  from: GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_from | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_campaign;
  /**
   * The opt-out string in the message content
   */
  optOutText: string | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_delay | null;
  engagementStats: GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_engagementStats;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node_queuedDripProgressions | null;
  /**
   * If the content of the edition contains a link from a public URL shortener
   */
  hasShortLink: boolean;
}

export interface GetSmsDripSequenceEditions_smsDripSequence_editions_edges {
  __typename: "SmsDripEditionsEdge";
  cursor: string;
  node: GetSmsDripSequenceEditions_smsDripSequence_editions_edges_node;
}

export interface GetSmsDripSequenceEditions_smsDripSequence_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * A list of edges.
   */
  edges: GetSmsDripSequenceEditions_smsDripSequence_editions_edges[];
}

export interface GetSmsDripSequenceEditions_smsDripSequence {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The editions of the drip sequence
   */
  editions: GetSmsDripSequenceEditions_smsDripSequence_editions;
}

export interface GetSmsDripSequenceEditions {
  /**
   * Returns the sms marketing drip sequence.
   */
  smsDripSequence: GetSmsDripSequenceEditions_smsDripSequence;
}

export interface GetSmsDripSequenceEditionsVariables {
  limit: number;
  cursor?: string | null;
  dripSequenceId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSmsDripSequence
// ====================================================

export interface GetSmsDripSequence_smsDripSequence_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetSmsDripSequence_smsDripSequence_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSmsDripSequence_smsDripSequence_from_phone {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetSmsDripSequence_smsDripSequence_from {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
  phone: GetSmsDripSequence_smsDripSequence_from_phone | null;
}

export interface GetSmsDripSequence_smsDripSequence_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSmsDripSequence_smsDripSequence_startTrigger_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface GetSmsDripSequence_smsDripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface GetSmsDripSequence_smsDripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface GetSmsDripSequence_smsDripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type GetSmsDripSequence_smsDripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter = GetSmsDripSequence_smsDripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | GetSmsDripSequence_smsDripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | GetSmsDripSequence_smsDripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface GetSmsDripSequence_smsDripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: GetSmsDripSequence_smsDripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface GetSmsDripSequence_smsDripSequence_startTrigger_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface GetSmsDripSequence_smsDripSequence_startTrigger_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type GetSmsDripSequence_smsDripSequence_startTrigger_conditions_config = GetSmsDripSequence_smsDripSequence_startTrigger_conditions_config_ConditionConfigLink | GetSmsDripSequence_smsDripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter | GetSmsDripSequence_smsDripSequence_startTrigger_conditions_config_ConditionConfigTag | GetSmsDripSequence_smsDripSequence_startTrigger_conditions_config_ConditionConfigAudience;

export interface GetSmsDripSequence_smsDripSequence_startTrigger_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: GetSmsDripSequence_smsDripSequence_startTrigger_conditions_config;
}

export interface GetSmsDripSequence_smsDripSequence_startTrigger {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of startTrigger
   */
  type: StartTriggerType;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * A list of conditions which must be true to activate this startTrigger.
   */
  conditions: GetSmsDripSequence_smsDripSequence_startTrigger_conditions[];
}

export interface GetSmsDripSequence_smsDripSequence_goal_conditions_config_ConditionConfigSourceEntity {
  __typename: "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface GetSmsDripSequence_smsDripSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface GetSmsDripSequence_smsDripSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface GetSmsDripSequence_smsDripSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type GetSmsDripSequence_smsDripSequence_goal_conditions_config_ConditionConfigEntityFilter_filter = GetSmsDripSequence_smsDripSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | GetSmsDripSequence_smsDripSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | GetSmsDripSequence_smsDripSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface GetSmsDripSequence_smsDripSequence_goal_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: GetSmsDripSequence_smsDripSequence_goal_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface GetSmsDripSequence_smsDripSequence_goal_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export interface GetSmsDripSequence_smsDripSequence_goal_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface GetSmsDripSequence_smsDripSequence_goal_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type GetSmsDripSequence_smsDripSequence_goal_conditions_config = GetSmsDripSequence_smsDripSequence_goal_conditions_config_ConditionConfigSourceEntity | GetSmsDripSequence_smsDripSequence_goal_conditions_config_ConditionConfigEntityFilter | GetSmsDripSequence_smsDripSequence_goal_conditions_config_ConditionConfigLink | GetSmsDripSequence_smsDripSequence_goal_conditions_config_ConditionConfigTag | GetSmsDripSequence_smsDripSequence_goal_conditions_config_ConditionConfigAudience;

export interface GetSmsDripSequence_smsDripSequence_goal_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: GetSmsDripSequence_smsDripSequence_goal_conditions_config;
}

export interface GetSmsDripSequence_smsDripSequence_goal_action_config_ActionConfigRemoveTags {
  __typename: "ActionConfigRemoveTags" | "ActionConfigSendPageViewedNotification" | "ActionConfigAddToDripSequence" | "ActionConfigCreateLead" | "ActionConfigSendEmail";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
}

export interface GetSmsDripSequence_smsDripSequence_goal_action_config_ActionConfigAddTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetSmsDripSequence_smsDripSequence_goal_action_config_ActionConfigAddTags {
  __typename: "ActionConfigAddTags";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  tags: GetSmsDripSequence_smsDripSequence_goal_action_config_ActionConfigAddTags_tags[];
}

export interface GetSmsDripSequence_smsDripSequence_goal_action_config_ActionConfigAddAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetSmsDripSequence_smsDripSequence_goal_action_config_ActionConfigAddAudiences {
  __typename: "ActionConfigAddAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: GetSmsDripSequence_smsDripSequence_goal_action_config_ActionConfigAddAudiences_audiences[];
}

export interface GetSmsDripSequence_smsDripSequence_goal_action_config_ActionConfigRemoveAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetSmsDripSequence_smsDripSequence_goal_action_config_ActionConfigRemoveAudiences {
  __typename: "ActionConfigRemoveAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: GetSmsDripSequence_smsDripSequence_goal_action_config_ActionConfigRemoveAudiences_audiences[];
}

export type GetSmsDripSequence_smsDripSequence_goal_action_config = GetSmsDripSequence_smsDripSequence_goal_action_config_ActionConfigRemoveTags | GetSmsDripSequence_smsDripSequence_goal_action_config_ActionConfigAddTags | GetSmsDripSequence_smsDripSequence_goal_action_config_ActionConfigAddAudiences | GetSmsDripSequence_smsDripSequence_goal_action_config_ActionConfigRemoveAudiences;

export interface GetSmsDripSequence_smsDripSequence_goal_action {
  __typename: "Action";
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * Human readable title of this action
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this action. This is essentially just the
   * stringified version of the action’s conditions, but because a action can have
   * multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The configuration for this action.
   */
  config: GetSmsDripSequence_smsDripSequence_goal_action_config;
}

export interface GetSmsDripSequence_smsDripSequence_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Calculated goal type based on conditions. This is not saved in the database
   */
  type: DripSequenceGoalType;
  /**
   * A list of conditions which must be true to activate this goal.
   */
  conditions: GetSmsDripSequence_smsDripSequence_goal_conditions[];
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this goal. This is essentially just the stringified
   * version of the goal’s conditions, but because a goal can have multiple
   * conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The optional action (next step in this context) that will run when this goal is met
   */
  action: GetSmsDripSequence_smsDripSequence_goal_action | null;
}

export interface GetSmsDripSequence_smsDripSequence_engagementStats {
  __typename: "SmsEngagementStats";
  /**
   * Total number of texts we tried to send
   */
  totalSentCount: number;
  /**
   * The ratio of response to total texts sent
   */
  responseRate: number | null;
  /**
   * Total number of people who responded to the SMS campaign
   */
  responseCount: number;
  /**
   * The ratio of undelivered texts to total texts sent
   */
  undeliveredRate: number | null;
  /**
   * Total number of texts which couldn’t be delivered
   */
  undeliveredCount: number;
  /**
   * The number of people who opted out of SMS messages after receiving this campaign
   */
  optoutCount: number;
  /**
   * The ratio of optouts to total texts sent
   */
  optoutRate: number | null;
  /**
   * The ratio of people who received every message in the sequence to the total number of recipients
   */
  dripProgressionsReceivedEveryMessageRate: number | null;
  /**
   * The ratio of goals met to total drip editions sent
   */
  dripProgressionsGoalMetRate: number | null;
  /**
   * The number of people who have received or are scheduled to receive messages from this drip campaign
   */
  dripProgressionTotalRecipients: number | null;
}

export interface GetSmsDripSequence_smsDripSequence {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The editions of the drip sequence
   */
  editions: GetSmsDripSequence_smsDripSequence_editions;
  /**
   * The user who owns this campaign
   */
  owner: GetSmsDripSequence_smsDripSequence_owner | null;
  /**
   * The channel this edition was sent from
   */
  from: GetSmsDripSequence_smsDripSequence_from | null;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The DateTime that represents when the campaign was last modified
   */
  modifiedTime: any | null;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: GetSmsDripSequence_smsDripSequence_creatorUser | null;
  /**
   * Should messages only be sent during business hours.
   */
  isBusinessHoursOnly: boolean;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * When a lead is closed, should drip sequences stop?
   */
  isStopOnLeadClose: boolean;
  /**
   * When a person is removed from an audience, should drip sequences stop?
   */
  isStopOnRemovedFromAudience: boolean;
  /**
   * Time of the last campaign status change. For example, if a customer activated
   * this sequence and its still active, this would be the time the sequence was
   * activated. Once the campaign status is changed (paused, retired, etc) this
   * would reflect that new time
   */
  lastStatusChangeTime: any | null;
  /**
   * The start trigger for the drip sequence
   */
  startTrigger: GetSmsDripSequence_smsDripSequence_startTrigger | null;
  /**
   * The newly created Nutshell goal
   */
  goal: GetSmsDripSequence_smsDripSequence_goal | null;
  /**
   * Statistics about the engagement of this campaign
   */
  engagementStats: GetSmsDripSequence_smsDripSequence_engagementStats;
  /**
   * Number of in progress drip progressions for the drip sequence
   */
  numInProgressDripProgressions: number;
  /**
   * Whether the drip sequence should have a remove option
   */
  isRemovable: boolean;
}

export interface GetSmsDripSequence {
  /**
   * Returns the sms marketing drip sequence.
   */
  smsDripSequence: GetSmsDripSequence_smsDripSequence;
}

export interface GetSmsDripSequenceVariables {
  dripSequenceId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSmsDripSequences
// ====================================================

export interface GetSmsDripSequences_smsDripSequences_edges_node_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_from_phone {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_from {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
  phone: GetSmsDripSequences_smsDripSequences_edges_node_from_phone | null;
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_startTrigger_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type GetSmsDripSequences_smsDripSequences_edges_node_startTrigger_conditions_config_ConditionConfigEntityFilter_filter = GetSmsDripSequences_smsDripSequences_edges_node_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | GetSmsDripSequences_smsDripSequences_edges_node_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | GetSmsDripSequences_smsDripSequences_edges_node_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface GetSmsDripSequences_smsDripSequences_edges_node_startTrigger_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: GetSmsDripSequences_smsDripSequences_edges_node_startTrigger_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_startTrigger_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_startTrigger_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type GetSmsDripSequences_smsDripSequences_edges_node_startTrigger_conditions_config = GetSmsDripSequences_smsDripSequences_edges_node_startTrigger_conditions_config_ConditionConfigLink | GetSmsDripSequences_smsDripSequences_edges_node_startTrigger_conditions_config_ConditionConfigEntityFilter | GetSmsDripSequences_smsDripSequences_edges_node_startTrigger_conditions_config_ConditionConfigTag | GetSmsDripSequences_smsDripSequences_edges_node_startTrigger_conditions_config_ConditionConfigAudience;

export interface GetSmsDripSequences_smsDripSequences_edges_node_startTrigger_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: GetSmsDripSequences_smsDripSequences_edges_node_startTrigger_conditions_config;
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_startTrigger {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of startTrigger
   */
  type: StartTriggerType;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * A list of conditions which must be true to activate this startTrigger.
   */
  conditions: GetSmsDripSequences_smsDripSequences_edges_node_startTrigger_conditions[];
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_goal_conditions_config_ConditionConfigSourceEntity {
  __typename: "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type GetSmsDripSequences_smsDripSequences_edges_node_goal_conditions_config_ConditionConfigEntityFilter_filter = GetSmsDripSequences_smsDripSequences_edges_node_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | GetSmsDripSequences_smsDripSequences_edges_node_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | GetSmsDripSequences_smsDripSequences_edges_node_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface GetSmsDripSequences_smsDripSequences_edges_node_goal_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: GetSmsDripSequences_smsDripSequences_edges_node_goal_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_goal_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_goal_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_goal_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type GetSmsDripSequences_smsDripSequences_edges_node_goal_conditions_config = GetSmsDripSequences_smsDripSequences_edges_node_goal_conditions_config_ConditionConfigSourceEntity | GetSmsDripSequences_smsDripSequences_edges_node_goal_conditions_config_ConditionConfigEntityFilter | GetSmsDripSequences_smsDripSequences_edges_node_goal_conditions_config_ConditionConfigLink | GetSmsDripSequences_smsDripSequences_edges_node_goal_conditions_config_ConditionConfigTag | GetSmsDripSequences_smsDripSequences_edges_node_goal_conditions_config_ConditionConfigAudience;

export interface GetSmsDripSequences_smsDripSequences_edges_node_goal_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: GetSmsDripSequences_smsDripSequences_edges_node_goal_conditions_config;
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_goal_action_config_ActionConfigRemoveTags {
  __typename: "ActionConfigRemoveTags" | "ActionConfigSendPageViewedNotification" | "ActionConfigAddToDripSequence" | "ActionConfigCreateLead" | "ActionConfigSendEmail";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_goal_action_config_ActionConfigAddTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_goal_action_config_ActionConfigAddTags {
  __typename: "ActionConfigAddTags";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  tags: GetSmsDripSequences_smsDripSequences_edges_node_goal_action_config_ActionConfigAddTags_tags[];
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_goal_action_config_ActionConfigAddAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_goal_action_config_ActionConfigAddAudiences {
  __typename: "ActionConfigAddAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: GetSmsDripSequences_smsDripSequences_edges_node_goal_action_config_ActionConfigAddAudiences_audiences[];
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_goal_action_config_ActionConfigRemoveAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_goal_action_config_ActionConfigRemoveAudiences {
  __typename: "ActionConfigRemoveAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: GetSmsDripSequences_smsDripSequences_edges_node_goal_action_config_ActionConfigRemoveAudiences_audiences[];
}

export type GetSmsDripSequences_smsDripSequences_edges_node_goal_action_config = GetSmsDripSequences_smsDripSequences_edges_node_goal_action_config_ActionConfigRemoveTags | GetSmsDripSequences_smsDripSequences_edges_node_goal_action_config_ActionConfigAddTags | GetSmsDripSequences_smsDripSequences_edges_node_goal_action_config_ActionConfigAddAudiences | GetSmsDripSequences_smsDripSequences_edges_node_goal_action_config_ActionConfigRemoveAudiences;

export interface GetSmsDripSequences_smsDripSequences_edges_node_goal_action {
  __typename: "Action";
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * Human readable title of this action
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this action. This is essentially just the
   * stringified version of the action’s conditions, but because a action can have
   * multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The configuration for this action.
   */
  config: GetSmsDripSequences_smsDripSequences_edges_node_goal_action_config;
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Calculated goal type based on conditions. This is not saved in the database
   */
  type: DripSequenceGoalType;
  /**
   * A list of conditions which must be true to activate this goal.
   */
  conditions: GetSmsDripSequences_smsDripSequences_edges_node_goal_conditions[];
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this goal. This is essentially just the stringified
   * version of the goal’s conditions, but because a goal can have multiple
   * conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The optional action (next step in this context) that will run when this goal is met
   */
  action: GetSmsDripSequences_smsDripSequences_edges_node_goal_action | null;
}

export interface GetSmsDripSequences_smsDripSequences_edges_node_engagementStats {
  __typename: "SmsEngagementStats";
  /**
   * Total number of texts we tried to send
   */
  totalSentCount: number;
  /**
   * The ratio of response to total texts sent
   */
  responseRate: number | null;
  /**
   * Total number of people who responded to the SMS campaign
   */
  responseCount: number;
  /**
   * The ratio of undelivered texts to total texts sent
   */
  undeliveredRate: number | null;
  /**
   * Total number of texts which couldn’t be delivered
   */
  undeliveredCount: number;
  /**
   * The number of people who opted out of SMS messages after receiving this campaign
   */
  optoutCount: number;
  /**
   * The ratio of optouts to total texts sent
   */
  optoutRate: number | null;
  /**
   * The ratio of people who received every message in the sequence to the total number of recipients
   */
  dripProgressionsReceivedEveryMessageRate: number | null;
  /**
   * The ratio of goals met to total drip editions sent
   */
  dripProgressionsGoalMetRate: number | null;
  /**
   * The number of people who have received or are scheduled to receive messages from this drip campaign
   */
  dripProgressionTotalRecipients: number | null;
}

export interface GetSmsDripSequences_smsDripSequences_edges_node {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The editions of the drip sequence
   */
  editions: GetSmsDripSequences_smsDripSequences_edges_node_editions;
  /**
   * The user who owns this campaign
   */
  owner: GetSmsDripSequences_smsDripSequences_edges_node_owner | null;
  /**
   * The channel this edition was sent from
   */
  from: GetSmsDripSequences_smsDripSequences_edges_node_from | null;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The DateTime that represents when the campaign was last modified
   */
  modifiedTime: any | null;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: GetSmsDripSequences_smsDripSequences_edges_node_creatorUser | null;
  /**
   * Should messages only be sent during business hours.
   */
  isBusinessHoursOnly: boolean;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * When a lead is closed, should drip sequences stop?
   */
  isStopOnLeadClose: boolean;
  /**
   * When a person is removed from an audience, should drip sequences stop?
   */
  isStopOnRemovedFromAudience: boolean;
  /**
   * Time of the last campaign status change. For example, if a customer activated
   * this sequence and its still active, this would be the time the sequence was
   * activated. Once the campaign status is changed (paused, retired, etc) this
   * would reflect that new time
   */
  lastStatusChangeTime: any | null;
  /**
   * The start trigger for the drip sequence
   */
  startTrigger: GetSmsDripSequences_smsDripSequences_edges_node_startTrigger | null;
  /**
   * The newly created Nutshell goal
   */
  goal: GetSmsDripSequences_smsDripSequences_edges_node_goal | null;
  /**
   * Statistics about the engagement of this campaign
   */
  engagementStats: GetSmsDripSequences_smsDripSequences_edges_node_engagementStats;
  /**
   * Number of in progress drip progressions for the drip sequence
   */
  numInProgressDripProgressions: number;
  /**
   * Whether the drip sequence should have a remove option
   */
  isRemovable: boolean;
}

export interface GetSmsDripSequences_smsDripSequences_edges {
  __typename: "SmsDripSequencesEdge";
  node: GetSmsDripSequences_smsDripSequences_edges_node;
}

export interface GetSmsDripSequences_smsDripSequences {
  __typename: "SmsDripSequencesConnection";
  /**
   * A list of edges.
   */
  edges: GetSmsDripSequences_smsDripSequences_edges[];
}

export interface GetSmsDripSequences {
  /**
   * Returns a list of sms marketing drip sequences.
   */
  smsDripSequences: GetSmsDripSequences_smsDripSequences;
}

export interface GetSmsDripSequencesVariables {
  archived: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSmsEditionEngagementStats
// ====================================================

export interface GetSmsEditionEngagementStats_smsEdition_engagementStats {
  __typename: "SmsEngagementStats";
  /**
   * Total number of texts we tried to send
   */
  totalSentCount: number;
  /**
   * Total number of people who responded to the SMS campaign
   */
  responseCount: number;
  /**
   * The ratio of response to total texts sent
   */
  responseRate: number | null;
  /**
   * Total number of texts which couldn’t be delivered
   */
  undeliveredCount: number;
  /**
   * The ratio of undelivered texts to total texts sent
   */
  undeliveredRate: number | null;
  /**
   * The number of people who opted out of SMS messages after receiving this campaign
   */
  optoutCount: number;
  /**
   * The ratio of optouts to total texts sent
   */
  optoutRate: number | null;
}

export interface GetSmsEditionEngagementStats_smsEdition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  engagementStats: GetSmsEditionEngagementStats_smsEdition_engagementStats;
}

export interface GetSmsEditionEngagementStats {
  /**
   * Returns an SMS edition.
   */
  smsEdition: GetSmsEditionEngagementStats_smsEdition | null;
}

export interface GetSmsEditionEngagementStatsVariables {
  editionId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TemplateCreate
// ====================================================

export interface TemplateCreate_templateCreate_template_edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface TemplateCreate_templateCreate_template_edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface TemplateCreate_templateCreate_template_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface TemplateCreate_templateCreate_template_edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface TemplateCreate_templateCreate_template_edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: TemplateCreate_templateCreate_template_edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: TemplateCreate_templateCreate_template_edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: TemplateCreate_templateCreate_template_edition_campaign_nextSendingEdition | null;
}

export interface TemplateCreate_templateCreate_template_edition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface TemplateCreate_templateCreate_template_edition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: TemplateCreate_templateCreate_template_edition_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface TemplateCreate_templateCreate_template_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: TemplateCreate_templateCreate_template_edition_emailTemplate_links[];
}

export interface TemplateCreate_templateCreate_template_edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface TemplateCreate_templateCreate_template_edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface TemplateCreate_templateCreate_template_edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: TemplateCreate_templateCreate_template_edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface TemplateCreate_templateCreate_template_edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: TemplateCreate_templateCreate_template_edition_comparisonEdition_emailTemplate_links[];
}

export interface TemplateCreate_templateCreate_template_edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: TemplateCreate_templateCreate_template_edition_comparisonEdition_emailTemplate | null;
}

export interface TemplateCreate_templateCreate_template_edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface TemplateCreate_templateCreate_template_edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface TemplateCreate_templateCreate_template_edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: TemplateCreate_templateCreate_template_edition_comparison_winnerEdition_emailTemplate | null;
}

export interface TemplateCreate_templateCreate_template_edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface TemplateCreate_templateCreate_template_edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface TemplateCreate_templateCreate_template_edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: TemplateCreate_templateCreate_template_edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: TemplateCreate_templateCreate_template_edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: TemplateCreate_templateCreate_template_edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: TemplateCreate_templateCreate_template_edition_comparison_winningEdition | null;
}

export interface TemplateCreate_templateCreate_template_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface TemplateCreate_templateCreate_template_edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
}

export interface TemplateCreate_templateCreate_template_edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: TemplateCreate_templateCreate_template_edition_from_emailAddress;
}

export interface TemplateCreate_templateCreate_template_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface TemplateCreate_templateCreate_template_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: TemplateCreate_templateCreate_template_edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: TemplateCreate_templateCreate_template_edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: TemplateCreate_templateCreate_template_edition_emailTemplate | null;
  engagementStats: TemplateCreate_templateCreate_template_edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: TemplateCreate_templateCreate_template_edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: TemplateCreate_templateCreate_template_edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: TemplateCreate_templateCreate_template_edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: TemplateCreate_templateCreate_template_edition_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: TemplateCreate_templateCreate_template_edition_delay | null;
}

export interface TemplateCreate_templateCreate_template {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  edition: TemplateCreate_templateCreate_template_edition;
}

export interface TemplateCreate_templateCreate {
  __typename: "TemplateCreatePayload";
  /**
   * The newly created template
   */
  template: TemplateCreate_templateCreate_template;
}

export interface TemplateCreate {
  /**
   * Create a new email marketing template
   */
  templateCreate: TemplateCreate_templateCreate | null;
}

export interface TemplateCreateVariables {
  input: TemplateCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TemplateDuplicate
// ====================================================

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: TemplateDuplicate_editionDuplicateToTemplate_template_edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: TemplateDuplicate_editionDuplicateToTemplate_template_edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: TemplateDuplicate_editionDuplicateToTemplate_template_edition_campaign_nextSendingEdition | null;
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: TemplateDuplicate_editionDuplicateToTemplate_template_edition_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: TemplateDuplicate_editionDuplicateToTemplate_template_edition_emailTemplate_links[];
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: TemplateDuplicate_editionDuplicateToTemplate_template_edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: TemplateDuplicate_editionDuplicateToTemplate_template_edition_comparisonEdition_emailTemplate_links[];
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: TemplateDuplicate_editionDuplicateToTemplate_template_edition_comparisonEdition_emailTemplate | null;
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: TemplateDuplicate_editionDuplicateToTemplate_template_edition_comparison_winnerEdition_emailTemplate | null;
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: TemplateDuplicate_editionDuplicateToTemplate_template_edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: TemplateDuplicate_editionDuplicateToTemplate_template_edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: TemplateDuplicate_editionDuplicateToTemplate_template_edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: TemplateDuplicate_editionDuplicateToTemplate_template_edition_comparison_winningEdition | null;
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: TemplateDuplicate_editionDuplicateToTemplate_template_edition_from_emailAddress;
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: TemplateDuplicate_editionDuplicateToTemplate_template_edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: TemplateDuplicate_editionDuplicateToTemplate_template_edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: TemplateDuplicate_editionDuplicateToTemplate_template_edition_emailTemplate | null;
  engagementStats: TemplateDuplicate_editionDuplicateToTemplate_template_edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: TemplateDuplicate_editionDuplicateToTemplate_template_edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: TemplateDuplicate_editionDuplicateToTemplate_template_edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: TemplateDuplicate_editionDuplicateToTemplate_template_edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: TemplateDuplicate_editionDuplicateToTemplate_template_edition_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: TemplateDuplicate_editionDuplicateToTemplate_template_edition_delay | null;
}

export interface TemplateDuplicate_editionDuplicateToTemplate_template {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  edition: TemplateDuplicate_editionDuplicateToTemplate_template_edition;
}

export interface TemplateDuplicate_editionDuplicateToTemplate {
  __typename: "EditionDuplicateToTemplatePayload";
  /**
   * The newly created template
   */
  template: TemplateDuplicate_editionDuplicateToTemplate_template;
}

export interface TemplateDuplicate {
  /**
   * Duplicate an email marketing edition to a new template
   */
  editionDuplicateToTemplate: TemplateDuplicate_editionDuplicateToTemplate | null;
}

export interface TemplateDuplicateVariables {
  edition: EditionDuplicateToTemplateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateAccountFromMcfxCompany
// ====================================================

export interface CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_industry {
  __typename: "McfxIndustry";
  /**
   * The enum value of this industry
   */
  id: IndustryType;
  /**
   * The name of this industry
   */
  name: string;
}

export interface CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_annualRevenue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_contacts_primaryEdge_node;
}

export interface CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_contacts_primaryEdge | null;
}

export interface CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_accounts_primaryEdge_node;
}

export interface CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_accounts_primaryEdge | null;
}

export interface CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_value_formattedValue;
}

export interface CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_accounts;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  value: CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_value | null;
}

export interface CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount_leads_edges {
  __typename: "PeepLeadsEdge";
  node: CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node;
}

export interface CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount_leads {
  __typename: "PeepLeadsConnection";
  /**
   * A list of edges.
   */
  edges: CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount_leads_edges[];
}

export interface CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * Leads related to this peep
   */
  leads: CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount_leads;
}

export interface CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_primaryAddress_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_primaryAddress {
  __typename: "EntityAttributeValueLocation";
  fullAddress: string | null;
  region: string | null;
  postalCode: string | null;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_primaryAddress_coordinates | null;
}

export interface CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany {
  __typename: "McfxCompany";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the company
   */
  name: string;
  /**
   * The initials of the company
   */
  initials: string | null;
  /**
   * This company’s website
   */
  url: string | null;
  /**
   * Phone numbers for the company
   */
  phones: string[];
  /**
   * The industry of the company
   */
  industry: CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_industry | null;
  /**
   * The number of employees the company
   */
  numEmployees: number | null;
  /**
   * The annual revenue of the company
   */
  annualRevenue: CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_annualRevenue | null;
  /**
   * Is this company locked (not yet revealed)
   */
  isLocked: boolean;
  /**
   * The time this company was created
   */
  createdTime: any;
  /**
   * The time this company was converted to a real Nutshell account
   */
  convertedTime: any | null;
  /**
   * The time this company was unlocked
   */
  unlockTime: any | null;
  /**
   * The time this company was last seen
   */
  lastSeenTime: any | null;
  /**
   * Whether this company was converted automatically because it already existed in Nutshell when added
   */
  wasConvertedAutomatically: boolean;
  /**
   * The total number of page visits in all sessions
   */
  numVisits: number;
  /**
   * The total duration of all page visits in all sessions
   */
  totalVisitDuration: number;
  /**
   * Url of the account created from this company
   */
  relatedAccount: CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_relatedAccount | null;
  /**
   * The location of the company
   */
  primaryAddress: CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany_primaryAddress | null;
}

export interface CreateAccountFromMcfxCompany_createAccountFromMcfxCompany {
  __typename: "CreateAccountFromMcfxCompanyPayload";
  /**
   * The updated mcfxCompany
   */
  mcfxCompany: CreateAccountFromMcfxCompany_createAccountFromMcfxCompany_mcfxCompany | null;
}

export interface CreateAccountFromMcfxCompany {
  /**
   * Creates a new account from a mcfx company.
   */
  createAccountFromMcfxCompany: CreateAccountFromMcfxCompany_createAccountFromMcfxCompany;
}

export interface CreateAccountFromMcfxCompanyVariables {
  input: CreateAccountFromMcfxCompanyInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: McfxCompaniesUnlock
// ====================================================

export interface McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_industry {
  __typename: "McfxIndustry";
  /**
   * The enum value of this industry
   */
  id: IndustryType;
  /**
   * The name of this industry
   */
  name: string;
}

export interface McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_annualRevenue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount_leads_edges_node_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount_leads_edges_node_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount_leads_edges_node_contacts_primaryEdge_node;
}

export interface McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount_leads_edges_node_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount_leads_edges_node_contacts_primaryEdge | null;
}

export interface McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount_leads_edges_node_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount_leads_edges_node_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount_leads_edges_node_accounts_primaryEdge_node;
}

export interface McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount_leads_edges_node_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount_leads_edges_node_accounts_primaryEdge | null;
}

export interface McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount_leads_edges_node_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount_leads_edges_node_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount_leads_edges_node_value_formattedValue;
}

export interface McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount_leads_edges_node {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount_leads_edges_node_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount_leads_edges_node_accounts;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  value: McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount_leads_edges_node_value | null;
}

export interface McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount_leads_edges {
  __typename: "PeepLeadsEdge";
  node: McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount_leads_edges_node;
}

export interface McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount_leads {
  __typename: "PeepLeadsConnection";
  /**
   * A list of edges.
   */
  edges: McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount_leads_edges[];
}

export interface McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * Leads related to this peep
   */
  leads: McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount_leads;
}

export interface McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_primaryAddress_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_primaryAddress {
  __typename: "EntityAttributeValueLocation";
  fullAddress: string | null;
  region: string | null;
  postalCode: string | null;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_primaryAddress_coordinates | null;
}

export interface McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies {
  __typename: "McfxCompany";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the company
   */
  name: string;
  /**
   * The initials of the company
   */
  initials: string | null;
  /**
   * This company’s website
   */
  url: string | null;
  /**
   * Phone numbers for the company
   */
  phones: string[];
  /**
   * The industry of the company
   */
  industry: McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_industry | null;
  /**
   * The number of employees the company
   */
  numEmployees: number | null;
  /**
   * The annual revenue of the company
   */
  annualRevenue: McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_annualRevenue | null;
  /**
   * Is this company locked (not yet revealed)
   */
  isLocked: boolean;
  /**
   * The time this company was created
   */
  createdTime: any;
  /**
   * The time this company was converted to a real Nutshell account
   */
  convertedTime: any | null;
  /**
   * The time this company was unlocked
   */
  unlockTime: any | null;
  /**
   * The time this company was last seen
   */
  lastSeenTime: any | null;
  /**
   * Whether this company was converted automatically because it already existed in Nutshell when added
   */
  wasConvertedAutomatically: boolean;
  /**
   * The total number of page visits in all sessions
   */
  numVisits: number;
  /**
   * The total duration of all page visits in all sessions
   */
  totalVisitDuration: number;
  /**
   * Url of the account created from this company
   */
  relatedAccount: McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_relatedAccount | null;
  /**
   * The location of the company
   */
  primaryAddress: McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies_primaryAddress | null;
}

export interface McfxCompaniesUnlock_mcfxCompaniesUnlock {
  __typename: "McfxCompaniesUnlockPayload";
  /**
   * The new Nutshell account.
   */
  mcfxCompanies: McfxCompaniesUnlock_mcfxCompaniesUnlock_mcfxCompanies[];
}

export interface McfxCompaniesUnlock {
  /**
   * Creates a new account from a mcfx company.
   */
  mcfxCompaniesUnlock: McfxCompaniesUnlock_mcfxCompaniesUnlock;
}

export interface McfxCompaniesUnlockVariables {
  input: McfxCompaniesUnlockInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: McfxViqCompanyUpdate
// ====================================================

export interface McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_industry {
  __typename: "McfxIndustry";
  /**
   * The enum value of this industry
   */
  id: IndustryType;
  /**
   * The name of this industry
   */
  name: string;
}

export interface McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_annualRevenue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount_leads_edges_node_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount_leads_edges_node_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount_leads_edges_node_contacts_primaryEdge_node;
}

export interface McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount_leads_edges_node_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount_leads_edges_node_contacts_primaryEdge | null;
}

export interface McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount_leads_edges_node_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount_leads_edges_node_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount_leads_edges_node_accounts_primaryEdge_node;
}

export interface McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount_leads_edges_node_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount_leads_edges_node_accounts_primaryEdge | null;
}

export interface McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount_leads_edges_node_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount_leads_edges_node_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount_leads_edges_node_value_formattedValue;
}

export interface McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount_leads_edges_node {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount_leads_edges_node_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount_leads_edges_node_accounts;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  value: McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount_leads_edges_node_value | null;
}

export interface McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount_leads_edges {
  __typename: "PeepLeadsEdge";
  node: McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount_leads_edges_node;
}

export interface McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount_leads {
  __typename: "PeepLeadsConnection";
  /**
   * A list of edges.
   */
  edges: McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount_leads_edges[];
}

export interface McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * Leads related to this peep
   */
  leads: McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount_leads;
}

export interface McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_primaryAddress_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_primaryAddress {
  __typename: "EntityAttributeValueLocation";
  fullAddress: string | null;
  region: string | null;
  postalCode: string | null;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_primaryAddress_coordinates | null;
}

export interface McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany {
  __typename: "McfxCompany";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the company
   */
  name: string;
  /**
   * The initials of the company
   */
  initials: string | null;
  /**
   * This company’s website
   */
  url: string | null;
  /**
   * Phone numbers for the company
   */
  phones: string[];
  /**
   * The industry of the company
   */
  industry: McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_industry | null;
  /**
   * The number of employees the company
   */
  numEmployees: number | null;
  /**
   * The annual revenue of the company
   */
  annualRevenue: McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_annualRevenue | null;
  /**
   * Is this company locked (not yet revealed)
   */
  isLocked: boolean;
  /**
   * The time this company was created
   */
  createdTime: any;
  /**
   * The time this company was converted to a real Nutshell account
   */
  convertedTime: any | null;
  /**
   * The time this company was unlocked
   */
  unlockTime: any | null;
  /**
   * The time this company was last seen
   */
  lastSeenTime: any | null;
  /**
   * Whether this company was converted automatically because it already existed in Nutshell when added
   */
  wasConvertedAutomatically: boolean;
  /**
   * The total number of page visits in all sessions
   */
  numVisits: number;
  /**
   * The total duration of all page visits in all sessions
   */
  totalVisitDuration: number;
  /**
   * Url of the account created from this company
   */
  relatedAccount: McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_relatedAccount | null;
  /**
   * The location of the company
   */
  primaryAddress: McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany_primaryAddress | null;
}

export interface McfxViqCompanyUpdate_mcfxViqCompanyUpdate {
  __typename: "McfxViqCompanyUpdatePayload";
  /**
   * The updated mcfxCompany
   */
  mcfxCompany: McfxViqCompanyUpdate_mcfxViqCompanyUpdate_mcfxCompany | null;
}

export interface McfxViqCompanyUpdate {
  /**
   * Updates a Mcfx Viq company by adding a Nutshell company, person(s), or lead
   */
  mcfxViqCompanyUpdate: McfxViqCompanyUpdate_mcfxViqCompanyUpdate;
}

export interface McfxViqCompanyUpdateVariables {
  input: McfxViqCompanyUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMcfxCompanySessions
// ====================================================

export interface GetMcfxCompanySessions_sessions_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https:             // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The `www.nutshell.com` part of https: // www.nutshell.com/features?utm_source=Google
   */
  host: string | null;
}

export interface GetMcfxCompanySessions_sessions_browser {
  __typename: "Browser";
  /**
   * The platform for the visit
   */
  platform: string;
  /**
   * The device type for the visit
   */
  deviceType: DeviceType;
}

export interface GetMcfxCompanySessions_sessions_source {
  __typename: "McfxVisitSource";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The utm_medium value for this particular visit
   */
  medium: string;
  /**
   * The utm_source value for this particular visit
   */
  source: string;
  /**
   * Then mROI channel derived from this source information
   */
  channel: string;
}

export interface GetMcfxCompanySessions_sessions_contact_nutshellContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetMcfxCompanySessions_sessions_contact {
  __typename: "McfxContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The contact that made this form submission.
   */
  nutshellContact: GetMcfxCompanySessions_sessions_contact_nutshellContact | null;
}

export interface GetMcfxCompanySessions_sessions_visits_edges_node_maUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetMcfxCompanySessions_sessions_visits_edges_node_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The `/features` part of https: // www.nutshell.com/features?utm_source=Google
   */
  path: string | null;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
  /**
   * The full URL, i.e. https:      // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetMcfxCompanySessions_sessions_visits_edges_node {
  __typename: "Visit";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * How long the specific page visit lasted.
   */
  durationSeconds: number;
  /**
   * The marketing automation URL associated with this visit, if any.
   */
  maUrl: GetMcfxCompanySessions_sessions_visits_edges_node_maUrl | null;
  /**
   * The page url for this user visit.
   */
  url: GetMcfxCompanySessions_sessions_visits_edges_node_url;
}

export interface GetMcfxCompanySessions_sessions_visits_edges {
  __typename: "SessionVisitsEdge";
  node: GetMcfxCompanySessions_sessions_visits_edges_node;
}

export interface GetMcfxCompanySessions_sessions_visits {
  __typename: "SessionVisitsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The total amount of time the visits lasted.
   */
  totalDuration: number | null;
  /**
   * The number of visits that have an associated marketing automation URL.
   */
  maUrlCount: number;
  /**
   * A list of edges.
   */
  edges: GetMcfxCompanySessions_sessions_visits_edges[];
}

export interface GetMcfxCompanySessions_sessions {
  __typename: "Session";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The url for the session, used to open as a timeline entry modal.
   */
  htmlUrlPath: string;
  /**
   * Some basic info on the location of the user represented as a string.
   */
  locationSummary: string | null;
  /**
   * The session url.
   */
  url: GetMcfxCompanySessions_sessions_url;
  /**
   * The platform the user was on during the session.
   */
  browser: GetMcfxCompanySessions_sessions_browser | null;
  source: GetMcfxCompanySessions_sessions_source;
  /**
   * The contact associated with this session.
   */
  contact: GetMcfxCompanySessions_sessions_contact | null;
  visits: GetMcfxCompanySessions_sessions_visits;
  /**
   * When this session started. This is the value we’ll display to the user
   */
  startTime: any;
}

export interface GetMcfxCompanySessions {
  /**
   * All Sessions for a McfxCompany
   */
  sessions: GetMcfxCompanySessions_sessions[] | null;
}

export interface GetMcfxCompanySessionsVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMcfxCompany
// ====================================================

export interface GetMcfxCompany_mcfxCompany_industry {
  __typename: "McfxIndustry";
  /**
   * The enum value of this industry
   */
  id: IndustryType;
  /**
   * The name of this industry
   */
  name: string;
}

export interface GetMcfxCompany_mcfxCompany_annualRevenue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface GetMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_contacts_primaryEdge_node;
}

export interface GetMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_contacts_primaryEdge | null;
}

export interface GetMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_accounts_primaryEdge_node;
}

export interface GetMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_accounts_primaryEdge | null;
}

export interface GetMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_value_formattedValue;
}

export interface GetMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_accounts;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  value: GetMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node_value | null;
}

export interface GetMcfxCompany_mcfxCompany_relatedAccount_leads_edges {
  __typename: "PeepLeadsEdge";
  node: GetMcfxCompany_mcfxCompany_relatedAccount_leads_edges_node;
}

export interface GetMcfxCompany_mcfxCompany_relatedAccount_leads {
  __typename: "PeepLeadsConnection";
  /**
   * A list of edges.
   */
  edges: GetMcfxCompany_mcfxCompany_relatedAccount_leads_edges[];
}

export interface GetMcfxCompany_mcfxCompany_relatedAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * Leads related to this peep
   */
  leads: GetMcfxCompany_mcfxCompany_relatedAccount_leads;
}

export interface GetMcfxCompany_mcfxCompany_primaryAddress_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface GetMcfxCompany_mcfxCompany_primaryAddress {
  __typename: "EntityAttributeValueLocation";
  fullAddress: string | null;
  region: string | null;
  postalCode: string | null;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: GetMcfxCompany_mcfxCompany_primaryAddress_coordinates | null;
}

export interface GetMcfxCompany_mcfxCompany {
  __typename: "McfxCompany";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the company
   */
  name: string;
  /**
   * The initials of the company
   */
  initials: string | null;
  /**
   * This company’s website
   */
  url: string | null;
  /**
   * Phone numbers for the company
   */
  phones: string[];
  /**
   * The industry of the company
   */
  industry: GetMcfxCompany_mcfxCompany_industry | null;
  /**
   * The number of employees the company
   */
  numEmployees: number | null;
  /**
   * The annual revenue of the company
   */
  annualRevenue: GetMcfxCompany_mcfxCompany_annualRevenue | null;
  /**
   * Is this company locked (not yet revealed)
   */
  isLocked: boolean;
  /**
   * The time this company was created
   */
  createdTime: any;
  /**
   * The time this company was converted to a real Nutshell account
   */
  convertedTime: any | null;
  /**
   * The time this company was unlocked
   */
  unlockTime: any | null;
  /**
   * The time this company was last seen
   */
  lastSeenTime: any | null;
  /**
   * Whether this company was converted automatically because it already existed in Nutshell when added
   */
  wasConvertedAutomatically: boolean;
  /**
   * The total number of page visits in all sessions
   */
  numVisits: number;
  /**
   * The total duration of all page visits in all sessions
   */
  totalVisitDuration: number;
  /**
   * Url of the account created from this company
   */
  relatedAccount: GetMcfxCompany_mcfxCompany_relatedAccount | null;
  /**
   * The location of the company
   */
  primaryAddress: GetMcfxCompany_mcfxCompany_primaryAddress | null;
}

export interface GetMcfxCompany {
  /**
   * Returns an mcfxCompany with information about an individual mcfx_company record
   */
  mcfxCompany: GetMcfxCompany_mcfxCompany;
}

export interface GetMcfxCompanyVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateVisitorIqFilterSettings
// ====================================================

export interface UpdateVisitorIqFilterSettings_visitorIqFilterSettingsUpdate_mcfxIndustries_industry {
  __typename: "McfxIndustry";
  /**
   * The enum value of this industry
   */
  id: IndustryType;
  /**
   * The name of this industry
   */
  name: string;
}

export interface UpdateVisitorIqFilterSettings_visitorIqFilterSettingsUpdate_mcfxIndustries {
  __typename: "IndustrySetting";
  /**
   * The industry that this setting relates to
   */
  industry: UpdateVisitorIqFilterSettings_visitorIqFilterSettingsUpdate_mcfxIndustries_industry;
  /**
   * Whether this industry should be ignored in Nutshell
   */
  isBlocked: boolean;
}

export interface UpdateVisitorIqFilterSettings_visitorIqFilterSettingsUpdate_contactInformationList_contactInformation {
  __typename: "ContactInformationDetail";
  /**
   * The enum value of this filter
   */
  id: ContactInformationType;
  /**
   * The name of this filter
   */
  name: string;
}

export interface UpdateVisitorIqFilterSettings_visitorIqFilterSettingsUpdate_contactInformationList {
  __typename: "ContactInformationSetting";
  /**
   * The contact information that this setting relates to
   */
  contactInformation: UpdateVisitorIqFilterSettings_visitorIqFilterSettingsUpdate_contactInformationList_contactInformation;
  /**
   * Whether this contact information should be ignored in Nutshell
   */
  isBlocked: boolean;
}

export interface UpdateVisitorIqFilterSettings_visitorIqFilterSettingsUpdate_jobFieldList_jobField {
  __typename: "JobFieldDetail";
  /**
   * The enum value of this filter
   */
  id: JobFieldType;
  /**
   * The name of this filter
   */
  name: string;
}

export interface UpdateVisitorIqFilterSettings_visitorIqFilterSettingsUpdate_jobFieldList {
  __typename: "JobFieldSetting";
  /**
   * The job field that this setting relates to
   */
  jobField: UpdateVisitorIqFilterSettings_visitorIqFilterSettingsUpdate_jobFieldList_jobField;
  /**
   * Whether this job field should be ignored in Nutshell
   */
  isBlocked: boolean;
}

export interface UpdateVisitorIqFilterSettings_visitorIqFilterSettingsUpdate_managementLevelList_managementLevel {
  __typename: "ManagementLevelDetail";
  /**
   * The enum value of this filter
   */
  id: ManagementLevelType;
  /**
   * The name of this filter
   */
  name: string;
}

export interface UpdateVisitorIqFilterSettings_visitorIqFilterSettingsUpdate_managementLevelList {
  __typename: "ManagementLevelSetting";
  /**
   * The job field that this setting relates to
   */
  managementLevel: UpdateVisitorIqFilterSettings_visitorIqFilterSettingsUpdate_managementLevelList_managementLevel;
  /**
   * Whether this job field should be ignored in Nutshell
   */
  isBlocked: boolean;
}

export interface UpdateVisitorIqFilterSettings_visitorIqFilterSettingsUpdate {
  __typename: "FilterSettingsPayload";
  /**
   * The updated list of industries to include in Nutshell
   */
  mcfxIndustries: UpdateVisitorIqFilterSettings_visitorIqFilterSettingsUpdate_mcfxIndustries[];
  /**
   * The list of contact information to include in Nutshell
   */
  contactInformationList: UpdateVisitorIqFilterSettings_visitorIqFilterSettingsUpdate_contactInformationList[];
  /**
   * The list of job fields to include in Nutshell
   */
  jobFieldList: UpdateVisitorIqFilterSettings_visitorIqFilterSettingsUpdate_jobFieldList[];
  /**
   * The list of management levels to include in Nutshell
   */
  managementLevelList: UpdateVisitorIqFilterSettings_visitorIqFilterSettingsUpdate_managementLevelList[];
  /**
   * Visitor IQ only: page URLs to exclude from visitor results when visited
   */
  urlBlocklist: string[];
}

export interface UpdateVisitorIqFilterSettings {
  /**
   * Update the VisitorIQ filters in Nutshell
   */
  visitorIqFilterSettingsUpdate: UpdateVisitorIqFilterSettings_visitorIqFilterSettingsUpdate;
}

export interface UpdateVisitorIqFilterSettingsVariables {
  input: VisitorIqFilterSettingsUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetVisitorIqFilterSettings
// ====================================================

export interface GetVisitorIqFilterSettings_visitorIqFilterSettings_mcfxIndustries_industry {
  __typename: "McfxIndustry";
  /**
   * The enum value of this industry
   */
  id: IndustryType;
  /**
   * The name of this industry
   */
  name: string;
}

export interface GetVisitorIqFilterSettings_visitorIqFilterSettings_mcfxIndustries {
  __typename: "IndustrySetting";
  /**
   * The industry that this setting relates to
   */
  industry: GetVisitorIqFilterSettings_visitorIqFilterSettings_mcfxIndustries_industry;
  /**
   * Whether this industry should be ignored in Nutshell
   */
  isBlocked: boolean;
}

export interface GetVisitorIqFilterSettings_visitorIqFilterSettings_contactInformationList_contactInformation {
  __typename: "ContactInformationDetail";
  /**
   * The enum value of this filter
   */
  id: ContactInformationType;
  /**
   * The name of this filter
   */
  name: string;
}

export interface GetVisitorIqFilterSettings_visitorIqFilterSettings_contactInformationList {
  __typename: "ContactInformationSetting";
  /**
   * The contact information that this setting relates to
   */
  contactInformation: GetVisitorIqFilterSettings_visitorIqFilterSettings_contactInformationList_contactInformation;
  /**
   * Whether this contact information should be ignored in Nutshell
   */
  isBlocked: boolean;
}

export interface GetVisitorIqFilterSettings_visitorIqFilterSettings_jobFieldList_jobField {
  __typename: "JobFieldDetail";
  /**
   * The enum value of this filter
   */
  id: JobFieldType;
  /**
   * The name of this filter
   */
  name: string;
}

export interface GetVisitorIqFilterSettings_visitorIqFilterSettings_jobFieldList {
  __typename: "JobFieldSetting";
  /**
   * The job field that this setting relates to
   */
  jobField: GetVisitorIqFilterSettings_visitorIqFilterSettings_jobFieldList_jobField;
  /**
   * Whether this job field should be ignored in Nutshell
   */
  isBlocked: boolean;
}

export interface GetVisitorIqFilterSettings_visitorIqFilterSettings_managementLevelList_managementLevel {
  __typename: "ManagementLevelDetail";
  /**
   * The enum value of this filter
   */
  id: ManagementLevelType;
  /**
   * The name of this filter
   */
  name: string;
}

export interface GetVisitorIqFilterSettings_visitorIqFilterSettings_managementLevelList {
  __typename: "ManagementLevelSetting";
  /**
   * The job field that this setting relates to
   */
  managementLevel: GetVisitorIqFilterSettings_visitorIqFilterSettings_managementLevelList_managementLevel;
  /**
   * Whether this job field should be ignored in Nutshell
   */
  isBlocked: boolean;
}

export interface GetVisitorIqFilterSettings_visitorIqFilterSettings {
  __typename: "FilterSettingsPayload";
  /**
   * The updated list of industries to include in Nutshell
   */
  mcfxIndustries: GetVisitorIqFilterSettings_visitorIqFilterSettings_mcfxIndustries[];
  /**
   * The list of contact information to include in Nutshell
   */
  contactInformationList: GetVisitorIqFilterSettings_visitorIqFilterSettings_contactInformationList[];
  /**
   * The list of job fields to include in Nutshell
   */
  jobFieldList: GetVisitorIqFilterSettings_visitorIqFilterSettings_jobFieldList[];
  /**
   * The list of management levels to include in Nutshell
   */
  managementLevelList: GetVisitorIqFilterSettings_visitorIqFilterSettings_managementLevelList[];
  /**
   * Visitor IQ only: page URLs to exclude from visitor results when visited
   */
  urlBlocklist: string[];
}

export interface GetVisitorIqFilterSettings {
  /**
   * A list of all contact information filters in Nutshell
   */
  visitorIqFilterSettings: GetVisitorIqFilterSettings_visitorIqFilterSettings;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EmailAutomationStatusCancel
// ====================================================

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_sender {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses_primary_value;
}

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses;
}

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_lead_contacts_primaryEdge_node;
}

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_lead_contacts_primaryEdge | null;
}

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  avatarUrl: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_lead_contacts;
}

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_emailAutomation_emailList_ConstantContactList {
  __typename: "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_emailAutomation_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
  emailSequenceTemplateMessages: EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
}

export type EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_emailAutomation_emailList = EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_emailAutomation_emailList_ConstantContactList | EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_emailAutomation_emailList_EmailSequenceTemplate;

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_emailAutomation_emailList | null;
}

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_emailSequence_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_emailSequence_emailSequenceTemplate_creatorUser;
}

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
}

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailSequenceTemplate: EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_emailSequence_emailSequenceTemplate | null;
  emailsQueued: EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_emailSequence_emailsQueued[];
  /**
   * The next message to be sent
   */
  nextUnsentEmail: EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_emailSequence_nextUnsentEmail | null;
}

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_firstName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_lastName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_emailAddress {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_companyName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus {
  __typename: "EmailAutomationStatus";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The message to show to the user
   */
  status: EmailAutomationStatusStatus;
  /**
   * Is this automation status paused?
   */
  isPaused: boolean;
  /**
   * Can this status be cancelled
   */
  canCancel: boolean;
  /**
   * Can this status be started
   */
  canStart: boolean;
  /**
   * The user that either did send this automation, or current _would_ send this
   * automation given the current context. For example, if the user is assigned to
   * a team, the logged in user is considered a potential sender if they’re on that team
   */
  sender: EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_sender | null;
  /**
   * Lead associated with this status row
   */
  lead: EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_lead;
  /**
   * Email list stage subscription associated with this status row
   */
  emailAutomation: EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_emailAutomation;
  /**
   * The actual email sequence going out for this lead in this stage
   */
  emailSequence: EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_emailSequence | null;
  /**
   * Status of the first name field
   */
  firstName: EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_firstName;
  /**
   * Status of the last name field
   */
  lastName: EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_lastName;
  /**
   * Status of the email address field
   */
  emailAddress: EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_emailAddress;
  /**
   * Status of the company name field
   */
  companyName: EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus_companyName;
}

export interface EmailAutomationStatusCancel_emailAutomationStatusCancel {
  __typename: "EmailAutomationStatusCancelPayload";
  /**
   * The deleted email automation status.
   */
  emailAutomationStatus: EmailAutomationStatusCancel_emailAutomationStatusCancel_emailAutomationStatus;
}

export interface EmailAutomationStatusCancel {
  /**
   * Cancel an email automation status
   */
  emailAutomationStatusCancel: EmailAutomationStatusCancel_emailAutomationStatusCancel;
}

export interface EmailAutomationStatusCancelVariables {
  input: EmailAutomationStatusCancelInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EmailAutomationStatusManualStart
// ====================================================

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_sender {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses_primary_value;
}

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses;
}

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_lead_contacts_primaryEdge_node;
}

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_lead_contacts_primaryEdge | null;
}

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  avatarUrl: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_lead_contacts;
}

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_emailAutomation_emailList_ConstantContactList {
  __typename: "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_emailAutomation_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
  emailSequenceTemplateMessages: EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
}

export type EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_emailAutomation_emailList = EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_emailAutomation_emailList_ConstantContactList | EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_emailAutomation_emailList_EmailSequenceTemplate;

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_emailAutomation_emailList | null;
}

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence_emailSequenceTemplate_creatorUser;
}

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
}

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailSequenceTemplate: EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence_emailSequenceTemplate | null;
  emailsQueued: EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence_emailsQueued[];
  /**
   * The next message to be sent
   */
  nextUnsentEmail: EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence_nextUnsentEmail | null;
}

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_firstName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_lastName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_emailAddress {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_companyName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus {
  __typename: "EmailAutomationStatus";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The message to show to the user
   */
  status: EmailAutomationStatusStatus;
  /**
   * Is this automation status paused?
   */
  isPaused: boolean;
  /**
   * Can this status be cancelled
   */
  canCancel: boolean;
  /**
   * Can this status be started
   */
  canStart: boolean;
  /**
   * The user that either did send this automation, or current _would_ send this
   * automation given the current context. For example, if the user is assigned to
   * a team, the logged in user is considered a potential sender if they’re on that team
   */
  sender: EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_sender | null;
  /**
   * Lead associated with this status row
   */
  lead: EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_lead;
  /**
   * Email list stage subscription associated with this status row
   */
  emailAutomation: EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_emailAutomation;
  /**
   * The actual email sequence going out for this lead in this stage
   */
  emailSequence: EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_emailSequence | null;
  /**
   * Status of the first name field
   */
  firstName: EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_firstName;
  /**
   * Status of the last name field
   */
  lastName: EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_lastName;
  /**
   * Status of the email address field
   */
  emailAddress: EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_emailAddress;
  /**
   * Status of the company name field
   */
  companyName: EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus_companyName;
}

export interface EmailAutomationStatusManualStart_emailAutomationStatusManualStart {
  __typename: "EmailAutomationStatusManualStartPayload";
  /**
   * The started email automation status.
   */
  emailAutomationStatus: EmailAutomationStatusManualStart_emailAutomationStatusManualStart_emailAutomationStatus;
}

export interface EmailAutomationStatusManualStart {
  /**
   * Manually start an email sequence that is `ready to send` from an automation (EmailAutomationStatus).
   */
  emailAutomationStatusManualStart: EmailAutomationStatusManualStart_emailAutomationStatusManualStart;
}

export interface EmailAutomationStatusManualStartVariables {
  input: EmailAutomationStatusManualStartInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EmailAutomationStatusUpdateField
// ====================================================

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_sender {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses_primary_value;
}

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses;
}

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_lead_contacts_primaryEdge_node;
}

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_lead_contacts_primaryEdge | null;
}

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  avatarUrl: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_lead_contacts;
}

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_emailAutomation_emailList_ConstantContactList {
  __typename: "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_emailAutomation_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
  emailSequenceTemplateMessages: EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
}

export type EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_emailAutomation_emailList = EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_emailAutomation_emailList_ConstantContactList | EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_emailAutomation_emailList_EmailSequenceTemplate;

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_emailAutomation_emailList | null;
}

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_emailSequence_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_emailSequence_emailSequenceTemplate_creatorUser;
}

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
}

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailSequenceTemplate: EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_emailSequence_emailSequenceTemplate | null;
  emailsQueued: EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_emailSequence_emailsQueued[];
  /**
   * The next message to be sent
   */
  nextUnsentEmail: EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_emailSequence_nextUnsentEmail | null;
}

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_firstName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_lastName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_emailAddress {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_companyName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus {
  __typename: "EmailAutomationStatus";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The message to show to the user
   */
  status: EmailAutomationStatusStatus;
  /**
   * Is this automation status paused?
   */
  isPaused: boolean;
  /**
   * Can this status be cancelled
   */
  canCancel: boolean;
  /**
   * Can this status be started
   */
  canStart: boolean;
  /**
   * The user that either did send this automation, or current _would_ send this
   * automation given the current context. For example, if the user is assigned to
   * a team, the logged in user is considered a potential sender if they’re on that team
   */
  sender: EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_sender | null;
  /**
   * Lead associated with this status row
   */
  lead: EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_lead;
  /**
   * Email list stage subscription associated with this status row
   */
  emailAutomation: EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_emailAutomation;
  /**
   * The actual email sequence going out for this lead in this stage
   */
  emailSequence: EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_emailSequence | null;
  /**
   * Status of the first name field
   */
  firstName: EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_firstName;
  /**
   * Status of the last name field
   */
  lastName: EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_lastName;
  /**
   * Status of the email address field
   */
  emailAddress: EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_emailAddress;
  /**
   * Status of the company name field
   */
  companyName: EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus_companyName;
}

export interface EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField {
  __typename: "EmailAutomationStatusUpdateFieldPayload";
  /**
   * The updated email automation status model
   */
  emailAutomationStatus: EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField_emailAutomationStatus;
}

export interface EmailAutomationStatusUpdateField {
  /**
   * Update a value on an email automation status’s related lead
   */
  emailAutomationStatusUpdateField: EmailAutomationStatusUpdateField_emailAutomationStatusUpdateField;
}

export interface EmailAutomationStatusUpdateFieldVariables {
  input: EmailAutomationStatusUpdateFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEmailAutomationsNeedingAttention
// ====================================================

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_pageInfo {
  __typename: "PageInfo";
  endCursor: string | null;
  hasNextPage: boolean;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_sender {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_lead_contacts_primaryEdge_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_lead_contacts_primaryEdge_node_emailAddresses_primary_value;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_lead_contacts_primaryEdge_node_emailAddresses;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_lead_contacts_primaryEdge_node;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_lead_contacts_primaryEdge | null;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  avatarUrl: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_lead_contacts;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_emailAutomation_emailList_ConstantContactList {
  __typename: "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_emailAutomation_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
  emailSequenceTemplateMessages: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
}

export type GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_emailAutomation_emailList = GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_emailAutomation_emailList_ConstantContactList | GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_emailAutomation_emailList_EmailSequenceTemplate;

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_emailAutomation_emailList | null;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_emailSequence_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_emailSequence_emailSequenceTemplate_creatorUser;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailSequenceTemplate: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_emailSequence_emailSequenceTemplate | null;
  emailsQueued: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_emailSequence_emailsQueued[];
  /**
   * The next message to be sent
   */
  nextUnsentEmail: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_emailSequence_nextUnsentEmail | null;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_firstName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_lastName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_emailAddress {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_companyName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node {
  __typename: "EmailAutomationStatus";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The message to show to the user
   */
  status: EmailAutomationStatusStatus;
  /**
   * Is this automation status paused?
   */
  isPaused: boolean;
  /**
   * Can this status be cancelled
   */
  canCancel: boolean;
  /**
   * Can this status be started
   */
  canStart: boolean;
  /**
   * The user that either did send this automation, or current _would_ send this
   * automation given the current context. For example, if the user is assigned to
   * a team, the logged in user is considered a potential sender if they’re on that team
   */
  sender: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_sender | null;
  /**
   * Lead associated with this status row
   */
  lead: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_lead;
  /**
   * Email list stage subscription associated with this status row
   */
  emailAutomation: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_emailAutomation;
  /**
   * The actual email sequence going out for this lead in this stage
   */
  emailSequence: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_emailSequence | null;
  /**
   * Status of the first name field
   */
  firstName: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_firstName;
  /**
   * Status of the last name field
   */
  lastName: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_lastName;
  /**
   * Status of the email address field
   */
  emailAddress: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_emailAddress;
  /**
   * Status of the company name field
   */
  companyName: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node_companyName;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges {
  __typename: "EmailAutomationStatusEdge";
  node: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges_node;
}

export interface GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention {
  __typename: "EmailAutomationStatusConnection";
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention_edges[];
}

export interface GetEmailAutomationsNeedingAttention {
  /**
   * Pageable collection of lead email sequence stage subscription status models that are missing information
   */
  emailAutomationStatusesNeedsAttention: GetEmailAutomationsNeedingAttention_emailAutomationStatusesNeedsAttention;
}

export interface GetEmailAutomationsNeedingAttentionVariables {
  limit: number;
  cursor?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEmailAutomationsQueued
// ====================================================

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_pageInfo {
  __typename: "PageInfo";
  endCursor: string | null;
  hasNextPage: boolean;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_sender {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_lead_contacts_primaryEdge_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_lead_contacts_primaryEdge_node_emailAddresses_primary_value;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_lead_contacts_primaryEdge_node_emailAddresses;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_lead_contacts_primaryEdge_node;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_lead_contacts_primaryEdge | null;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  avatarUrl: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_lead_contacts;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_emailAutomation_emailList_ConstantContactList {
  __typename: "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_emailAutomation_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
  emailSequenceTemplateMessages: GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
}

export type GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_emailAutomation_emailList = GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_emailAutomation_emailList_ConstantContactList | GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_emailAutomation_emailList_EmailSequenceTemplate;

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_emailAutomation_emailList | null;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_emailSequence_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_emailSequence_emailSequenceTemplate_creatorUser;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailSequenceTemplate: GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_emailSequence_emailSequenceTemplate | null;
  emailsQueued: GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_emailSequence_emailsQueued[];
  /**
   * The next message to be sent
   */
  nextUnsentEmail: GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_emailSequence_nextUnsentEmail | null;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_firstName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_lastName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_emailAddress {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_companyName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node {
  __typename: "EmailAutomationStatus";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The message to show to the user
   */
  status: EmailAutomationStatusStatus;
  /**
   * Is this automation status paused?
   */
  isPaused: boolean;
  /**
   * Can this status be cancelled
   */
  canCancel: boolean;
  /**
   * Can this status be started
   */
  canStart: boolean;
  /**
   * The user that either did send this automation, or current _would_ send this
   * automation given the current context. For example, if the user is assigned to
   * a team, the logged in user is considered a potential sender if they’re on that team
   */
  sender: GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_sender | null;
  /**
   * Lead associated with this status row
   */
  lead: GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_lead;
  /**
   * Email list stage subscription associated with this status row
   */
  emailAutomation: GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_emailAutomation;
  /**
   * The actual email sequence going out for this lead in this stage
   */
  emailSequence: GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_emailSequence | null;
  /**
   * Status of the first name field
   */
  firstName: GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_firstName;
  /**
   * Status of the last name field
   */
  lastName: GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_lastName;
  /**
   * Status of the email address field
   */
  emailAddress: GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_emailAddress;
  /**
   * Status of the company name field
   */
  companyName: GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node_companyName;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges {
  __typename: "EmailAutomationStatusEdge";
  node: GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges_node;
}

export interface GetEmailAutomationsQueued_emailAutomationStatusesQueued {
  __typename: "EmailAutomationStatusConnection";
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetEmailAutomationsQueued_emailAutomationStatusesQueued_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetEmailAutomationsQueued_emailAutomationStatusesQueued_edges[];
}

export interface GetEmailAutomationsQueued {
  /**
   * Pageable collection of lead email sequence stage subscription status models that are queued and will send
   */
  emailAutomationStatusesQueued: GetEmailAutomationsQueued_emailAutomationStatusesQueued;
}

export interface GetEmailAutomationsQueuedVariables {
  limit: number;
  cursor?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEmailAutomationsReadyToSend
// ====================================================

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_pageInfo {
  __typename: "PageInfo";
  endCursor: string | null;
  hasNextPage: boolean;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_sender {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_lead_contacts_primaryEdge_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_lead_contacts_primaryEdge_node_emailAddresses_primary_value;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_lead_contacts_primaryEdge_node_emailAddresses;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_lead_contacts_primaryEdge_node;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_lead_contacts_primaryEdge | null;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  avatarUrl: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_lead_contacts;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_emailAutomation_emailList_ConstantContactList {
  __typename: "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_emailAutomation_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
  emailSequenceTemplateMessages: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
}

export type GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_emailAutomation_emailList = GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_emailAutomation_emailList_ConstantContactList | GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_emailAutomation_emailList_EmailSequenceTemplate;

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_emailAutomation_emailList | null;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_emailSequence_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_emailSequence_emailSequenceTemplate_creatorUser;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailSequenceTemplate: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_emailSequence_emailSequenceTemplate | null;
  emailsQueued: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_emailSequence_emailsQueued[];
  /**
   * The next message to be sent
   */
  nextUnsentEmail: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_emailSequence_nextUnsentEmail | null;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_firstName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_lastName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_emailAddress {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_companyName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node {
  __typename: "EmailAutomationStatus";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The message to show to the user
   */
  status: EmailAutomationStatusStatus;
  /**
   * Is this automation status paused?
   */
  isPaused: boolean;
  /**
   * Can this status be cancelled
   */
  canCancel: boolean;
  /**
   * Can this status be started
   */
  canStart: boolean;
  /**
   * The user that either did send this automation, or current _would_ send this
   * automation given the current context. For example, if the user is assigned to
   * a team, the logged in user is considered a potential sender if they’re on that team
   */
  sender: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_sender | null;
  /**
   * Lead associated with this status row
   */
  lead: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_lead;
  /**
   * Email list stage subscription associated with this status row
   */
  emailAutomation: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_emailAutomation;
  /**
   * The actual email sequence going out for this lead in this stage
   */
  emailSequence: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_emailSequence | null;
  /**
   * Status of the first name field
   */
  firstName: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_firstName;
  /**
   * Status of the last name field
   */
  lastName: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_lastName;
  /**
   * Status of the email address field
   */
  emailAddress: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_emailAddress;
  /**
   * Status of the company name field
   */
  companyName: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node_companyName;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges {
  __typename: "EmailAutomationStatusEdge";
  node: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges_node;
}

export interface GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend {
  __typename: "EmailAutomationStatusConnection";
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend_edges[];
}

export interface GetEmailAutomationsReadyToSend {
  /**
   * Pageable collection of lead email sequence stage subscription status models that are waiting for user confirmation to send
   */
  emailAutomationStatusesReadyToSend: GetEmailAutomationsReadyToSend_emailAutomationStatusesReadyToSend;
}

export interface GetEmailAutomationsReadyToSendVariables {
  limit: number;
  cursor?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetModifiedEmailAutomationsStatuses
// ====================================================

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_pageInfo {
  __typename: "PageInfo";
  endCursor: string | null;
  hasNextPage: boolean;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_sender {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_lead_contacts_primaryEdge_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_lead_contacts_primaryEdge_node_emailAddresses_primary_value;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_lead_contacts_primaryEdge_node_emailAddresses;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_lead_contacts_primaryEdge_node;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_lead_contacts_primaryEdge | null;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  avatarUrl: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_lead_contacts;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_emailAutomation_emailList_ConstantContactList {
  __typename: "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_emailAutomation_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
  emailSequenceTemplateMessages: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
}

export type GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_emailAutomation_emailList = GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_emailAutomation_emailList_ConstantContactList | GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_emailAutomation_emailList_EmailSequenceTemplate;

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_emailAutomation_emailList | null;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_emailSequence_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_emailSequence_emailSequenceTemplate_creatorUser;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailSequenceTemplate: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_emailSequence_emailSequenceTemplate | null;
  emailsQueued: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_emailSequence_emailsQueued[];
  /**
   * The next message to be sent
   */
  nextUnsentEmail: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_emailSequence_nextUnsentEmail | null;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_firstName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_lastName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_emailAddress {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_companyName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node {
  __typename: "EmailAutomationStatus";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The message to show to the user
   */
  status: EmailAutomationStatusStatus;
  /**
   * Is this automation status paused?
   */
  isPaused: boolean;
  /**
   * Can this status be cancelled
   */
  canCancel: boolean;
  /**
   * Can this status be started
   */
  canStart: boolean;
  /**
   * The user that either did send this automation, or current _would_ send this
   * automation given the current context. For example, if the user is assigned to
   * a team, the logged in user is considered a potential sender if they’re on that team
   */
  sender: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_sender | null;
  /**
   * Lead associated with this status row
   */
  lead: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_lead;
  /**
   * Email list stage subscription associated with this status row
   */
  emailAutomation: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_emailAutomation;
  /**
   * The actual email sequence going out for this lead in this stage
   */
  emailSequence: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_emailSequence | null;
  /**
   * Status of the first name field
   */
  firstName: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_firstName;
  /**
   * Status of the last name field
   */
  lastName: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_lastName;
  /**
   * Status of the email address field
   */
  emailAddress: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_emailAddress;
  /**
   * Status of the company name field
   */
  companyName: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node_companyName;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges {
  __typename: "EmailAutomationStatusEdge";
  node: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges_node;
}

export interface GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified {
  __typename: "EmailAutomationStatusConnection";
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified_edges[];
}

export interface GetModifiedEmailAutomationsStatuses {
  /**
   * Paging collection of emailAutomationStatuses which have been modified since the given cursor.
   */
  emailAutomationStatusesModified: GetModifiedEmailAutomationsStatuses_emailAutomationStatusesModified;
}

export interface GetModifiedEmailAutomationsStatusesVariables {
  after?: string | null;
  last?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: PauseAutomatedEmails
// ====================================================

export interface PauseAutomatedEmails_pauseAutomatedEmails_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface PauseAutomatedEmails_pauseAutomatedEmails {
  __typename: "PauseAutomatedEmailsPayload";
  /**
   * The user that has paused automated emails
   */
  user: PauseAutomatedEmails_pauseAutomatedEmails_user;
}

export interface PauseAutomatedEmails {
  /**
   * Pauses automated emails for the logged in user.
   */
  pauseAutomatedEmails: PauseAutomatedEmails_pauseAutomatedEmails | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ResumeAutomatedEmails
// ====================================================

export interface ResumeAutomatedEmails_resumeAutomatedEmails_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ResumeAutomatedEmails_resumeAutomatedEmails {
  __typename: "ResumeAutomatedEmailsPayload";
  /**
   * The user that has resumed automated emails
   */
  user: ResumeAutomatedEmails_resumeAutomatedEmails_user;
}

export interface ResumeAutomatedEmails {
  /**
   * Resumes sending automated emails for the logged in user.
   */
  resumeAutomatedEmails: ResumeAutomatedEmails_resumeAutomatedEmails | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEmailStats
// ====================================================

export interface GetEmailStats_emailStats {
  __typename: "EmailStats";
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  status: EmailHealthStatus | null;
  /**
   * A quick summary of the account email health. Used for health button.
   */
  summary: string;
  /**
   * The long description of the account email health.
   */
  description: string;
  /**
   * The link destination for the email health description.
   */
  descriptionLinkHtmlRef: string | null;
  /**
   * The recommended max number of emails to be sent each day.
   */
  maxDailyEmailsCount: number;
  /**
   * The number of emails the user has sent today.
   */
  emailsSentTodayCount: number;
  /**
   * The number of scheduled emails for the user today.
   */
  emailsScheduledTodayCount: number;
  /**
   * The number of failed emails for the user.
   */
  emailsFailedCount: number;
  /**
   * The number of automated emails currently queued to send for the user.
   */
  automatedEmailsWillSendCount: number;
  /**
   * The number of automated emails ready to send for the user.
   */
  automatedEmailsReadyToSendCount: number;
  /**
   * The number of automated emails for the user that need attention before they can be queued to send.
   */
  automatedEmailsNeedsAttentionCount: number;
  /**
   * Has anyone in this instance configured Nutshell Email Automations?
   */
  instanceHasConfiguredEmailAutomations: boolean;
  /**
   * Has this user paused their automated emails from sending?
   */
  isAutomatedSendingPaused: boolean;
}

export interface GetEmailStats {
  /**
   * Statistics about this user's email behavior.
   */
  emailStats: GetEmailStats_emailStats;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EmailSequenceCreateFromGmail
// ====================================================

export interface EmailSequenceCreateFromGmail_emailSequenceCreateFromGmail {
  __typename: "SequenceCreateFromGmailPayload";
  /**
   * The body of the first email in the sequence, with tracking links and pixels
   */
  trackedBody: string;
}

export interface EmailSequenceCreateFromGmail {
  emailSequenceCreateFromGmail: EmailSequenceCreateFromGmail_emailSequenceCreateFromGmail;
}

export interface EmailSequenceCreateFromGmailVariables {
  emailSequenceInput: SequenceCreateFromGmailInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateEmailSequenceTemplate
// ====================================================

export interface CreateEmailSequenceTemplate_emailSequenceTemplateCreate_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface CreateEmailSequenceTemplate_emailSequenceTemplateCreate_emailSequenceTemplate_parent_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface CreateEmailSequenceTemplate_emailSequenceTemplateCreate_emailSequenceTemplate_parent {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: CreateEmailSequenceTemplate_emailSequenceTemplateCreate_emailSequenceTemplate_parent_creatorUser;
}

export interface CreateEmailSequenceTemplate_emailSequenceTemplateCreate_emailSequenceTemplate_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface CreateEmailSequenceTemplate_emailSequenceTemplateCreate_emailSequenceTemplate_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: CreateEmailSequenceTemplate_emailSequenceTemplateCreate_emailSequenceTemplate_emailAutomation_entersStage_stageset;
}

export interface CreateEmailSequenceTemplate_emailSequenceTemplateCreate_emailSequenceTemplate_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: CreateEmailSequenceTemplate_emailSequenceTemplateCreate_emailSequenceTemplate_emailAutomation_entersStage;
}

export interface CreateEmailSequenceTemplate_emailSequenceTemplateCreate_emailSequenceTemplate_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateEmailSequenceTemplate_emailSequenceTemplateCreate_emailSequenceTemplate_emailSequenceTemplateMessages_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateEmailSequenceTemplate_emailSequenceTemplateCreate_emailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailTemplate: CreateEmailSequenceTemplate_emailSequenceTemplateCreate_emailSequenceTemplate_emailSequenceTemplateMessages_emailTemplate;
}

export interface CreateEmailSequenceTemplate_emailSequenceTemplateCreate_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  creatorUser: CreateEmailSequenceTemplate_emailSequenceTemplateCreate_emailSequenceTemplate_creatorUser;
  lastSentTime: any | null;
  isShared: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  /**
   * The parent sequence template of this child sequence template
   */
  parent: CreateEmailSequenceTemplate_emailSequenceTemplateCreate_emailSequenceTemplate_parent | null;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: CreateEmailSequenceTemplate_emailSequenceTemplateCreate_emailSequenceTemplate_emailAutomation | null;
  group: CreateEmailSequenceTemplate_emailSequenceTemplateCreate_emailSequenceTemplate_group | null;
  deletedTime: any | null;
  emailSequenceTemplateMessages: CreateEmailSequenceTemplate_emailSequenceTemplateCreate_emailSequenceTemplate_emailSequenceTemplateMessages[];
  replyRate: number | null;
  /**
   * The count of the sent sequences that got a reply
   */
  replyCount: number;
  clickRate: number | null;
  clickCount: number;
  /**
   * The count of the sequences that are still sending messages
   */
  inProgressCount: number;
  /**
   * The count of the sequences that finished sending
   */
  finishedCount: number;
  /**
   * The count of the sent sequences that were cancelled
   */
  cancelledCount: number;
  /**
   * The count of the sent sequences that have one or more emails with click tracking
   */
  startedWithClickTrackingCount: number;
}

export interface CreateEmailSequenceTemplate_emailSequenceTemplateCreate {
  __typename: "EmailSequenceTemplateCreatePayload";
  /**
   * The newly created email sequence template
   */
  emailSequenceTemplate: CreateEmailSequenceTemplate_emailSequenceTemplateCreate_emailSequenceTemplate;
}

export interface CreateEmailSequenceTemplate {
  /**
   * Creates a email sequence template, which is later instantiated to build sequences for specific entities
   */
  emailSequenceTemplateCreate: CreateEmailSequenceTemplate_emailSequenceTemplateCreate;
}

export interface CreateEmailSequenceTemplateVariables {
  emailSequenceTemplate: EmailSequenceTemplateCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateEmailSequence
// ====================================================

export interface CreateEmailSequence_emailSequenceCreate_emailSequence_emailsQueued_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface CreateEmailSequence_emailSequenceCreate_emailSequence_emailsQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateEmailSequence_emailSequenceCreate_emailSequence_emailsQueued_to {
  __typename: "NutEmailAddress";
  avatarEntity: CreateEmailSequence_emailSequenceCreate_emailSequence_emailsQueued_to_avatarEntity | null;
}

export interface CreateEmailSequence_emailSequenceCreate_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  attachments: CreateEmailSequence_emailSequenceCreate_emailSequence_emailsQueued_attachments[];
  /**
   * True if this queued email has a delivery time that is in the future.
   */
  isScheduled: boolean;
  to: CreateEmailSequence_emailSequenceCreate_emailSequence_emailsQueued_to[];
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
}

export interface CreateEmailSequence_emailSequenceCreate_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailsQueued: CreateEmailSequence_emailSequenceCreate_emailSequence_emailsQueued[];
}

export interface CreateEmailSequence_emailSequenceCreate {
  __typename: "EmailSequenceCreatePayload";
  /**
   * The newly created email sequence
   */
  emailSequence: CreateEmailSequence_emailSequenceCreate_emailSequence;
}

export interface CreateEmailSequence {
  /**
   * Creates a new email sequence, and schedules the emails for delivery
   */
  emailSequenceCreate: CreateEmailSequence_emailSequenceCreate | null;
}

export interface CreateEmailSequenceVariables {
  emailSequence: EmailSequenceCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteEmailSequenceTemplate
// ====================================================

export interface DeleteEmailSequenceTemplate_emailSequenceTemplateDelete_emailSequenceTemplate_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DeleteEmailSequenceTemplate_emailSequenceTemplateDelete_emailSequenceTemplate_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface DeleteEmailSequenceTemplate_emailSequenceTemplateDelete_emailSequenceTemplate_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: DeleteEmailSequenceTemplate_emailSequenceTemplateDelete_emailSequenceTemplate_emailAutomation_entersStage_stageset;
}

export interface DeleteEmailSequenceTemplate_emailSequenceTemplateDelete_emailSequenceTemplate_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: DeleteEmailSequenceTemplate_emailSequenceTemplateDelete_emailSequenceTemplate_emailAutomation_entersStage;
}

export interface DeleteEmailSequenceTemplate_emailSequenceTemplateDelete_emailSequenceTemplate_userChildSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteEmailSequenceTemplate_emailSequenceTemplateDelete_emailSequenceTemplate_emailSequenceTemplateMessages_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteEmailSequenceTemplate_emailSequenceTemplateDelete_emailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailTemplate: DeleteEmailSequenceTemplate_emailSequenceTemplateDelete_emailSequenceTemplate_emailSequenceTemplateMessages_emailTemplate;
}

export interface DeleteEmailSequenceTemplate_emailSequenceTemplateDelete_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DeleteEmailSequenceTemplate_emailSequenceTemplateDelete_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  lastSentTime: any | null;
  isShared: boolean;
  isImmutable: boolean;
  /**
   * Has this sequence template been deleted?
   */
  isArchived: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  deletedTime: any | null;
  group: DeleteEmailSequenceTemplate_emailSequenceTemplateDelete_emailSequenceTemplate_group | null;
  replyRate: number | null;
  /**
   * The count of the sent sequences that got a reply
   */
  replyCount: number;
  clickRate: number | null;
  clickCount: number;
  /**
   * The count of the sent sequences that were cancelled
   */
  cancelledCount: number;
  /**
   * The count of the sequences that finished sending
   */
  finishedCount: number;
  /**
   * The count of the sequences that are still sending messages
   */
  inProgressCount: number;
  /**
   * The count of the sent sequences that have one or more emails with click tracking
   */
  startedWithClickTrackingCount: number;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: DeleteEmailSequenceTemplate_emailSequenceTemplateDelete_emailSequenceTemplate_emailAutomation | null;
  /**
   * Child template created by the user, if they have made one. Includes the template if its archived
   */
  userChildSequenceTemplate: DeleteEmailSequenceTemplate_emailSequenceTemplateDelete_emailSequenceTemplate_userChildSequenceTemplate | null;
  emailSequenceTemplateMessages: DeleteEmailSequenceTemplate_emailSequenceTemplateDelete_emailSequenceTemplate_emailSequenceTemplateMessages[];
  creatorUser: DeleteEmailSequenceTemplate_emailSequenceTemplateDelete_emailSequenceTemplate_creatorUser;
}

export interface DeleteEmailSequenceTemplate_emailSequenceTemplateDelete {
  __typename: "EmailSequenceTemplateDeletePayload";
  /**
   * The freshly updated email sequence template.
   */
  emailSequenceTemplate: DeleteEmailSequenceTemplate_emailSequenceTemplateDelete_emailSequenceTemplate;
}

export interface DeleteEmailSequenceTemplate {
  /**
   * Deletes (archives) an email sequence template
   */
  emailSequenceTemplateDelete: DeleteEmailSequenceTemplate_emailSequenceTemplateDelete;
}

export interface DeleteEmailSequenceTemplateVariables {
  sequenceTemplate: EmailSequenceTemplateDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UndeleteEmailSequenceTemplate
// ====================================================

export interface UndeleteEmailSequenceTemplate_emailSequenceTemplateUndelete_emailSequenceTemplate_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UndeleteEmailSequenceTemplate_emailSequenceTemplateUndelete_emailSequenceTemplate_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface UndeleteEmailSequenceTemplate_emailSequenceTemplateUndelete_emailSequenceTemplate_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: UndeleteEmailSequenceTemplate_emailSequenceTemplateUndelete_emailSequenceTemplate_emailAutomation_entersStage_stageset;
}

export interface UndeleteEmailSequenceTemplate_emailSequenceTemplateUndelete_emailSequenceTemplate_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: UndeleteEmailSequenceTemplate_emailSequenceTemplateUndelete_emailSequenceTemplate_emailAutomation_entersStage;
}

export interface UndeleteEmailSequenceTemplate_emailSequenceTemplateUndelete_emailSequenceTemplate_userChildSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UndeleteEmailSequenceTemplate_emailSequenceTemplateUndelete_emailSequenceTemplate_emailSequenceTemplateMessages_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UndeleteEmailSequenceTemplate_emailSequenceTemplateUndelete_emailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailTemplate: UndeleteEmailSequenceTemplate_emailSequenceTemplateUndelete_emailSequenceTemplate_emailSequenceTemplateMessages_emailTemplate;
}

export interface UndeleteEmailSequenceTemplate_emailSequenceTemplateUndelete_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UndeleteEmailSequenceTemplate_emailSequenceTemplateUndelete_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  lastSentTime: any | null;
  isShared: boolean;
  isImmutable: boolean;
  /**
   * Has this sequence template been deleted?
   */
  isArchived: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  deletedTime: any | null;
  group: UndeleteEmailSequenceTemplate_emailSequenceTemplateUndelete_emailSequenceTemplate_group | null;
  replyRate: number | null;
  /**
   * The count of the sent sequences that got a reply
   */
  replyCount: number;
  clickRate: number | null;
  clickCount: number;
  /**
   * The count of the sent sequences that were cancelled
   */
  cancelledCount: number;
  /**
   * The count of the sequences that finished sending
   */
  finishedCount: number;
  /**
   * The count of the sequences that are still sending messages
   */
  inProgressCount: number;
  /**
   * The count of the sent sequences that have one or more emails with click tracking
   */
  startedWithClickTrackingCount: number;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: UndeleteEmailSequenceTemplate_emailSequenceTemplateUndelete_emailSequenceTemplate_emailAutomation | null;
  /**
   * Child template created by the user, if they have made one. Includes the template if its archived
   */
  userChildSequenceTemplate: UndeleteEmailSequenceTemplate_emailSequenceTemplateUndelete_emailSequenceTemplate_userChildSequenceTemplate | null;
  emailSequenceTemplateMessages: UndeleteEmailSequenceTemplate_emailSequenceTemplateUndelete_emailSequenceTemplate_emailSequenceTemplateMessages[];
  creatorUser: UndeleteEmailSequenceTemplate_emailSequenceTemplateUndelete_emailSequenceTemplate_creatorUser;
}

export interface UndeleteEmailSequenceTemplate_emailSequenceTemplateUndelete {
  __typename: "EmailSequenceTemplateUndeletePayload";
  /**
   * The freshly updated email sequence template.
   */
  emailSequenceTemplate: UndeleteEmailSequenceTemplate_emailSequenceTemplateUndelete_emailSequenceTemplate;
}

export interface UndeleteEmailSequenceTemplate {
  /**
   * Undeletes (restores) an email sequence template
   */
  emailSequenceTemplateUndelete: UndeleteEmailSequenceTemplate_emailSequenceTemplateUndelete;
}

export interface UndeleteEmailSequenceTemplateVariables {
  sequenceTemplate: EmailSequenceTemplateUndeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateEmailSequenceTemplate
// ====================================================

export interface UpdateEmailSequenceTemplate_emailSequenceTemplateUpdate_emailSequenceTemplate_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateEmailSequenceTemplate_emailSequenceTemplateUpdate_emailSequenceTemplate_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface UpdateEmailSequenceTemplate_emailSequenceTemplateUpdate_emailSequenceTemplate_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: UpdateEmailSequenceTemplate_emailSequenceTemplateUpdate_emailSequenceTemplate_emailAutomation_entersStage_stageset;
}

export interface UpdateEmailSequenceTemplate_emailSequenceTemplateUpdate_emailSequenceTemplate_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: UpdateEmailSequenceTemplate_emailSequenceTemplateUpdate_emailSequenceTemplate_emailAutomation_entersStage;
}

export interface UpdateEmailSequenceTemplate_emailSequenceTemplateUpdate_emailSequenceTemplate_userChildSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateEmailSequenceTemplate_emailSequenceTemplateUpdate_emailSequenceTemplate_emailSequenceTemplateMessages_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateEmailSequenceTemplate_emailSequenceTemplateUpdate_emailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailTemplate: UpdateEmailSequenceTemplate_emailSequenceTemplateUpdate_emailSequenceTemplate_emailSequenceTemplateMessages_emailTemplate;
}

export interface UpdateEmailSequenceTemplate_emailSequenceTemplateUpdate_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateEmailSequenceTemplate_emailSequenceTemplateUpdate_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  lastSentTime: any | null;
  isShared: boolean;
  isImmutable: boolean;
  /**
   * Has this sequence template been deleted?
   */
  isArchived: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  deletedTime: any | null;
  group: UpdateEmailSequenceTemplate_emailSequenceTemplateUpdate_emailSequenceTemplate_group | null;
  replyRate: number | null;
  /**
   * The count of the sent sequences that got a reply
   */
  replyCount: number;
  clickRate: number | null;
  clickCount: number;
  /**
   * The count of the sent sequences that were cancelled
   */
  cancelledCount: number;
  /**
   * The count of the sequences that finished sending
   */
  finishedCount: number;
  /**
   * The count of the sequences that are still sending messages
   */
  inProgressCount: number;
  /**
   * The count of the sent sequences that have one or more emails with click tracking
   */
  startedWithClickTrackingCount: number;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: UpdateEmailSequenceTemplate_emailSequenceTemplateUpdate_emailSequenceTemplate_emailAutomation | null;
  /**
   * Child template created by the user, if they have made one. Includes the template if its archived
   */
  userChildSequenceTemplate: UpdateEmailSequenceTemplate_emailSequenceTemplateUpdate_emailSequenceTemplate_userChildSequenceTemplate | null;
  emailSequenceTemplateMessages: UpdateEmailSequenceTemplate_emailSequenceTemplateUpdate_emailSequenceTemplate_emailSequenceTemplateMessages[];
  creatorUser: UpdateEmailSequenceTemplate_emailSequenceTemplateUpdate_emailSequenceTemplate_creatorUser;
}

export interface UpdateEmailSequenceTemplate_emailSequenceTemplateUpdate {
  __typename: "EmailSequenceTemplateUpdatePayload";
  /**
   * The updated email sequence template
   */
  emailSequenceTemplate: UpdateEmailSequenceTemplate_emailSequenceTemplateUpdate_emailSequenceTemplate;
}

export interface UpdateEmailSequenceTemplate {
  /**
   * Updates an email sequence template
   */
  emailSequenceTemplateUpdate: UpdateEmailSequenceTemplate_emailSequenceTemplateUpdate;
}

export interface UpdateEmailSequenceTemplateVariables {
  emailSequenceTemplate: EmailSequenceTemplateUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetArchivedEmailSequenceTemplates
// ====================================================

export interface GetArchivedEmailSequenceTemplates_emailSequenceTemplateCollection_archivedTemplates_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetArchivedEmailSequenceTemplates_emailSequenceTemplateCollection_archivedTemplates_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetArchivedEmailSequenceTemplates_emailSequenceTemplateCollection_archivedTemplates_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: GetArchivedEmailSequenceTemplates_emailSequenceTemplateCollection_archivedTemplates_emailAutomation_entersStage_stageset;
}

export interface GetArchivedEmailSequenceTemplates_emailSequenceTemplateCollection_archivedTemplates_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: GetArchivedEmailSequenceTemplates_emailSequenceTemplateCollection_archivedTemplates_emailAutomation_entersStage;
}

export interface GetArchivedEmailSequenceTemplates_emailSequenceTemplateCollection_archivedTemplates_userChildSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetArchivedEmailSequenceTemplates_emailSequenceTemplateCollection_archivedTemplates_emailSequenceTemplateMessages_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetArchivedEmailSequenceTemplates_emailSequenceTemplateCollection_archivedTemplates_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailTemplate: GetArchivedEmailSequenceTemplates_emailSequenceTemplateCollection_archivedTemplates_emailSequenceTemplateMessages_emailTemplate;
}

export interface GetArchivedEmailSequenceTemplates_emailSequenceTemplateCollection_archivedTemplates_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetArchivedEmailSequenceTemplates_emailSequenceTemplateCollection_archivedTemplates {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  lastSentTime: any | null;
  isShared: boolean;
  isImmutable: boolean;
  /**
   * Has this sequence template been deleted?
   */
  isArchived: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  deletedTime: any | null;
  group: GetArchivedEmailSequenceTemplates_emailSequenceTemplateCollection_archivedTemplates_group | null;
  replyRate: number | null;
  /**
   * The count of the sent sequences that got a reply
   */
  replyCount: number;
  clickRate: number | null;
  clickCount: number;
  /**
   * The count of the sent sequences that were cancelled
   */
  cancelledCount: number;
  /**
   * The count of the sequences that finished sending
   */
  finishedCount: number;
  /**
   * The count of the sequences that are still sending messages
   */
  inProgressCount: number;
  /**
   * The count of the sent sequences that have one or more emails with click tracking
   */
  startedWithClickTrackingCount: number;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: GetArchivedEmailSequenceTemplates_emailSequenceTemplateCollection_archivedTemplates_emailAutomation | null;
  /**
   * Child template created by the user, if they have made one. Includes the template if its archived
   */
  userChildSequenceTemplate: GetArchivedEmailSequenceTemplates_emailSequenceTemplateCollection_archivedTemplates_userChildSequenceTemplate | null;
  emailSequenceTemplateMessages: GetArchivedEmailSequenceTemplates_emailSequenceTemplateCollection_archivedTemplates_emailSequenceTemplateMessages[];
  creatorUser: GetArchivedEmailSequenceTemplates_emailSequenceTemplateCollection_archivedTemplates_creatorUser;
}

export interface GetArchivedEmailSequenceTemplates_emailSequenceTemplateCollection {
  __typename: "EmailSequenceTemplateCollection";
  /**
   * Sequence templates for the current user which have been deleted/archived
   */
  archivedTemplates: GetArchivedEmailSequenceTemplates_emailSequenceTemplateCollection_archivedTemplates[];
}

export interface GetArchivedEmailSequenceTemplates {
  /**
   * Email sequence templates, grouped by provenance
   */
  emailSequenceTemplateCollection: GetArchivedEmailSequenceTemplates_emailSequenceTemplateCollection;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetArchivedSequenceIds
// ====================================================

export interface GetArchivedSequenceIds_emailSequenceTemplateCollection_archivedTemplates {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetArchivedSequenceIds_emailSequenceTemplateCollection {
  __typename: "EmailSequenceTemplateCollection";
  /**
   * Sequence templates for the current user which have been deleted/archived
   */
  archivedTemplates: GetArchivedSequenceIds_emailSequenceTemplateCollection_archivedTemplates[];
}

export interface GetArchivedSequenceIds {
  /**
   * Email sequence templates, grouped by provenance
   */
  emailSequenceTemplateCollection: GetArchivedSequenceIds_emailSequenceTemplateCollection;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEmailSequenceTemplate
// ====================================================

export interface GetEmailSequenceTemplate_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_parent_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_parent {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: GetEmailSequenceTemplate_emailSequenceTemplate_parent_parent_creatorUser;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: GetEmailSequenceTemplate_emailSequenceTemplate_parent_emailAutomation_entersStage_stageset;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: GetEmailSequenceTemplate_emailSequenceTemplate_parent_emailAutomation_entersStage;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_emailSequenceTemplateMessages_sendDelay {
  __typename: "EmailSequenceEmailTemplateSendDelay";
  /**
   * The timespan after the start of the sequence in units of dueUnit for this email template’s send date.
   */
  delayTimespan: number;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_emailSequenceTemplateMessages_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The raw saved body of the email template, without any HTML tags. This string
   * includes the variables strings ( {firstName}, {lastName}, etc ) in variable form.
   */
  plaintextBody: string;
  /**
   * The raw saved body of the email template. This string includes the variables
   * strings ( {firstName}, {lastName}, etc ) in variable form.
   */
  body: string;
  /**
   * The number of times this email template has been sent.
   */
  sentCount: number;
  /**
   * The number of times this email template has been opened by the reciepents.
   */
  openedCount: number;
  /**
   * The number of times this email template has been clicked by the recipients.
   */
  clickCount: number;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  sendAsReply: boolean;
  useSignature: boolean;
  position: number;
  /**
   * The delay after which to send the follow up email. This is `null` for email
   * templates, and only exists for emails in sequence templates.
   */
  sendDelay: GetEmailSequenceTemplate_emailSequenceTemplate_parent_emailSequenceTemplateMessages_sendDelay | null;
  emailTemplate: GetEmailSequenceTemplate_emailSequenceTemplate_parent_emailSequenceTemplateMessages_emailTemplate;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges_node_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges_node_parent_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges_node_parent {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges_node_parent_creatorUser;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges_node_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges_node_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges_node_emailAutomation_entersStage_stageset;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges_node_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges_node_emailAutomation_entersStage;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges_node_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges_node_emailSequenceTemplateMessages_sendDelay {
  __typename: "EmailSequenceEmailTemplateSendDelay";
  /**
   * The timespan after the start of the sequence in units of dueUnit for this email template’s send date.
   */
  delayTimespan: number;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges_node_emailSequenceTemplateMessages_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The raw saved body of the email template, without any HTML tags. This string
   * includes the variables strings ( {firstName}, {lastName}, etc ) in variable form.
   */
  plaintextBody: string;
  /**
   * The raw saved body of the email template. This string includes the variables
   * strings ( {firstName}, {lastName}, etc ) in variable form.
   */
  body: string;
  /**
   * The number of times this email template has been sent.
   */
  sentCount: number;
  /**
   * The number of times this email template has been opened by the reciepents.
   */
  openedCount: number;
  /**
   * The number of times this email template has been clicked by the recipients.
   */
  clickCount: number;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges_node_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  sendAsReply: boolean;
  useSignature: boolean;
  position: number;
  /**
   * The delay after which to send the follow up email. This is `null` for email
   * templates, and only exists for emails in sequence templates.
   */
  sendDelay: GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges_node_emailSequenceTemplateMessages_sendDelay | null;
  emailTemplate: GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges_node_emailSequenceTemplateMessages_emailTemplate;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges_node {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  creatorUser: GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges_node_creatorUser;
  lastSentTime: any | null;
  isShared: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  /**
   * The parent sequence template of this child sequence template
   */
  parent: GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges_node_parent | null;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges_node_emailAutomation | null;
  group: GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges_node_group | null;
  deletedTime: any | null;
  isImmutable: boolean;
  /**
   * Has this sequence template been deleted?
   */
  isArchived: boolean;
  emailSequenceTemplateMessages: GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges_node_emailSequenceTemplateMessages[];
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges {
  __typename: "EmailSequenceTemplatesEdge";
  node: GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges_node;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent_children {
  __typename: "EmailSequenceTemplatesConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetEmailSequenceTemplate_emailSequenceTemplate_parent_children_edges[];
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_parent {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: GetEmailSequenceTemplate_emailSequenceTemplate_parent_creatorUser;
  name: string;
  lastSentTime: any | null;
  isShared: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  /**
   * The parent sequence template of this child sequence template
   */
  parent: GetEmailSequenceTemplate_emailSequenceTemplate_parent_parent | null;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: GetEmailSequenceTemplate_emailSequenceTemplate_parent_emailAutomation | null;
  group: GetEmailSequenceTemplate_emailSequenceTemplate_parent_group | null;
  deletedTime: any | null;
  isImmutable: boolean;
  /**
   * Has this sequence template been deleted?
   */
  isArchived: boolean;
  emailSequenceTemplateMessages: GetEmailSequenceTemplate_emailSequenceTemplate_parent_emailSequenceTemplateMessages[];
  /**
   * User-customized copies of this template
   */
  children: GetEmailSequenceTemplate_emailSequenceTemplate_parent_children;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: GetEmailSequenceTemplate_emailSequenceTemplate_emailAutomation_entersStage_stageset;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: GetEmailSequenceTemplate_emailSequenceTemplate_emailAutomation_entersStage;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_emailSequenceTemplateMessages_sendDelay {
  __typename: "EmailSequenceEmailTemplateSendDelay";
  /**
   * The timespan after the start of the sequence in units of dueUnit for this email template’s send date.
   */
  delayTimespan: number;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_emailSequenceTemplateMessages_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The raw saved body of the email template, without any HTML tags. This string
   * includes the variables strings ( {firstName}, {lastName}, etc ) in variable form.
   */
  plaintextBody: string;
  /**
   * The raw saved body of the email template. This string includes the variables
   * strings ( {firstName}, {lastName}, etc ) in variable form.
   */
  body: string;
  /**
   * The number of times this email template has been sent.
   */
  sentCount: number;
  /**
   * The number of times this email template has been opened by the reciepents.
   */
  openedCount: number;
  /**
   * The number of times this email template has been clicked by the recipients.
   */
  clickCount: number;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  sendAsReply: boolean;
  useSignature: boolean;
  position: number;
  /**
   * The delay after which to send the follow up email. This is `null` for email
   * templates, and only exists for emails in sequence templates.
   */
  sendDelay: GetEmailSequenceTemplate_emailSequenceTemplate_emailSequenceTemplateMessages_sendDelay | null;
  emailTemplate: GetEmailSequenceTemplate_emailSequenceTemplate_emailSequenceTemplateMessages_emailTemplate;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_userChildSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_userChildSequenceTemplate_parent_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_userChildSequenceTemplate_parent {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: GetEmailSequenceTemplate_emailSequenceTemplate_userChildSequenceTemplate_parent_creatorUser;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_userChildSequenceTemplate_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_userChildSequenceTemplate_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: GetEmailSequenceTemplate_emailSequenceTemplate_userChildSequenceTemplate_emailAutomation_entersStage_stageset;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_userChildSequenceTemplate_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: GetEmailSequenceTemplate_emailSequenceTemplate_userChildSequenceTemplate_emailAutomation_entersStage;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_userChildSequenceTemplate_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_userChildSequenceTemplate_emailSequenceTemplateMessages_sendDelay {
  __typename: "EmailSequenceEmailTemplateSendDelay";
  /**
   * The timespan after the start of the sequence in units of dueUnit for this email template’s send date.
   */
  delayTimespan: number;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_userChildSequenceTemplate_emailSequenceTemplateMessages_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The raw saved body of the email template, without any HTML tags. This string
   * includes the variables strings ( {firstName}, {lastName}, etc ) in variable form.
   */
  plaintextBody: string;
  /**
   * The raw saved body of the email template. This string includes the variables
   * strings ( {firstName}, {lastName}, etc ) in variable form.
   */
  body: string;
  /**
   * The number of times this email template has been sent.
   */
  sentCount: number;
  /**
   * The number of times this email template has been opened by the reciepents.
   */
  openedCount: number;
  /**
   * The number of times this email template has been clicked by the recipients.
   */
  clickCount: number;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_userChildSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  sendAsReply: boolean;
  useSignature: boolean;
  position: number;
  /**
   * The delay after which to send the follow up email. This is `null` for email
   * templates, and only exists for emails in sequence templates.
   */
  sendDelay: GetEmailSequenceTemplate_emailSequenceTemplate_userChildSequenceTemplate_emailSequenceTemplateMessages_sendDelay | null;
  emailTemplate: GetEmailSequenceTemplate_emailSequenceTemplate_userChildSequenceTemplate_emailSequenceTemplateMessages_emailTemplate;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_userChildSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  creatorUser: GetEmailSequenceTemplate_emailSequenceTemplate_userChildSequenceTemplate_creatorUser;
  lastSentTime: any | null;
  isShared: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  /**
   * The parent sequence template of this child sequence template
   */
  parent: GetEmailSequenceTemplate_emailSequenceTemplate_userChildSequenceTemplate_parent | null;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: GetEmailSequenceTemplate_emailSequenceTemplate_userChildSequenceTemplate_emailAutomation | null;
  group: GetEmailSequenceTemplate_emailSequenceTemplate_userChildSequenceTemplate_group | null;
  deletedTime: any | null;
  isImmutable: boolean;
  /**
   * Has this sequence template been deleted?
   */
  isArchived: boolean;
  emailSequenceTemplateMessages: GetEmailSequenceTemplate_emailSequenceTemplate_userChildSequenceTemplate_emailSequenceTemplateMessages[];
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_children_edges_node_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_children_edges_node_parent_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_children_edges_node_parent {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: GetEmailSequenceTemplate_emailSequenceTemplate_children_edges_node_parent_creatorUser;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_children_edges_node_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_children_edges_node_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: GetEmailSequenceTemplate_emailSequenceTemplate_children_edges_node_emailAutomation_entersStage_stageset;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_children_edges_node_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: GetEmailSequenceTemplate_emailSequenceTemplate_children_edges_node_emailAutomation_entersStage;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_children_edges_node_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_children_edges_node_emailSequenceTemplateMessages_sendDelay {
  __typename: "EmailSequenceEmailTemplateSendDelay";
  /**
   * The timespan after the start of the sequence in units of dueUnit for this email template’s send date.
   */
  delayTimespan: number;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_children_edges_node_emailSequenceTemplateMessages_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The raw saved body of the email template, without any HTML tags. This string
   * includes the variables strings ( {firstName}, {lastName}, etc ) in variable form.
   */
  plaintextBody: string;
  /**
   * The raw saved body of the email template. This string includes the variables
   * strings ( {firstName}, {lastName}, etc ) in variable form.
   */
  body: string;
  /**
   * The number of times this email template has been sent.
   */
  sentCount: number;
  /**
   * The number of times this email template has been opened by the reciepents.
   */
  openedCount: number;
  /**
   * The number of times this email template has been clicked by the recipients.
   */
  clickCount: number;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_children_edges_node_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  sendAsReply: boolean;
  useSignature: boolean;
  position: number;
  /**
   * The delay after which to send the follow up email. This is `null` for email
   * templates, and only exists for emails in sequence templates.
   */
  sendDelay: GetEmailSequenceTemplate_emailSequenceTemplate_children_edges_node_emailSequenceTemplateMessages_sendDelay | null;
  emailTemplate: GetEmailSequenceTemplate_emailSequenceTemplate_children_edges_node_emailSequenceTemplateMessages_emailTemplate;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_children_edges_node {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  creatorUser: GetEmailSequenceTemplate_emailSequenceTemplate_children_edges_node_creatorUser;
  lastSentTime: any | null;
  isShared: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  /**
   * The parent sequence template of this child sequence template
   */
  parent: GetEmailSequenceTemplate_emailSequenceTemplate_children_edges_node_parent | null;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: GetEmailSequenceTemplate_emailSequenceTemplate_children_edges_node_emailAutomation | null;
  group: GetEmailSequenceTemplate_emailSequenceTemplate_children_edges_node_group | null;
  deletedTime: any | null;
  isImmutable: boolean;
  /**
   * Has this sequence template been deleted?
   */
  isArchived: boolean;
  emailSequenceTemplateMessages: GetEmailSequenceTemplate_emailSequenceTemplate_children_edges_node_emailSequenceTemplateMessages[];
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_children_edges {
  __typename: "EmailSequenceTemplatesEdge";
  node: GetEmailSequenceTemplate_emailSequenceTemplate_children_edges_node;
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate_children {
  __typename: "EmailSequenceTemplatesConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetEmailSequenceTemplate_emailSequenceTemplate_children_edges[];
}

export interface GetEmailSequenceTemplate_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  creatorUser: GetEmailSequenceTemplate_emailSequenceTemplate_creatorUser;
  lastSentTime: any | null;
  isShared: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  /**
   * The parent sequence template of this child sequence template
   */
  parent: GetEmailSequenceTemplate_emailSequenceTemplate_parent | null;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: GetEmailSequenceTemplate_emailSequenceTemplate_emailAutomation | null;
  group: GetEmailSequenceTemplate_emailSequenceTemplate_group | null;
  deletedTime: any | null;
  isImmutable: boolean;
  /**
   * Has this sequence template been deleted?
   */
  isArchived: boolean;
  emailSequenceTemplateMessages: GetEmailSequenceTemplate_emailSequenceTemplate_emailSequenceTemplateMessages[];
  /**
   * Child template created by the user, if they have made one. Includes the template if its archived
   */
  userChildSequenceTemplate: GetEmailSequenceTemplate_emailSequenceTemplate_userChildSequenceTemplate | null;
  /**
   * User-customized copies of this template
   */
  children: GetEmailSequenceTemplate_emailSequenceTemplate_children;
}

export interface GetEmailSequenceTemplate {
  /**
   * Single email sequence template by id
   */
  emailSequenceTemplate: GetEmailSequenceTemplate_emailSequenceTemplate;
}

export interface GetEmailSequenceTemplateVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMaterializedEmailSequenceTemplates
// ====================================================

export interface GetMaterializedEmailSequenceTemplates_materializedEmailSequenceTemplates_entity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMaterializedEmailSequenceTemplates_materializedEmailSequenceTemplates_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMaterializedEmailSequenceTemplates_materializedEmailSequenceTemplates_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  isShared: boolean;
  creatorUser: GetMaterializedEmailSequenceTemplates_materializedEmailSequenceTemplates_emailSequenceTemplate_creatorUser;
}

export interface GetMaterializedEmailSequenceTemplates_materializedEmailSequenceTemplates_materializedEmailSequenceTemplateMessages_materializedEmailTemplate {
  __typename: "MaterializedEmailTemplate";
  /**
   * Materialized subject of this email template, meaning {firstName} would be returned as Chris.
   */
  subject: string;
  /**
   * Materialized body of this email template, meaning {firstName} would be returned as Chris.
   */
  body: string;
  /**
   * Essentially our "warning" or "error" message for this materialized template,
   * if either the entity has no email address, or the entity doesn’t have all of
   * the expected template information (such as a missing last name, or no company name)
   */
  missingFieldsMessage: string | null;
  /**
   * Materialized body of this email template, without any HTML tags, meaning
   * <div>{firstName}</div> would be returned as Chris.
   */
  plaintextBody: string;
}

export interface GetMaterializedEmailSequenceTemplates_materializedEmailSequenceTemplates_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMaterializedEmailSequenceTemplates_materializedEmailSequenceTemplates_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage_sendDelay {
  __typename: "EmailSequenceEmailTemplateSendDelay";
  /**
   * The unit to measure this email template’s send date.This could be days or hours or their business equalivents.
   */
  delayUnit: DueDateUnit;
  /**
   * The timespan after the start of the sequence in units of dueUnit for this email template’s send date.
   */
  delayTimespan: number;
}

export interface GetMaterializedEmailSequenceTemplates_materializedEmailSequenceTemplates_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage {
  __typename: "EmailSequenceTemplateMessage";
  emailTemplate: GetMaterializedEmailSequenceTemplates_materializedEmailSequenceTemplates_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage_emailTemplate;
  /**
   * The delay after which to send the follow up email. This is `null` for email
   * templates, and only exists for emails in sequence templates.
   */
  sendDelay: GetMaterializedEmailSequenceTemplates_materializedEmailSequenceTemplates_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage_sendDelay | null;
  /**
   * The time that this email is expected to be sent based on the given delay.
   * Follows the same null logic as the sendDelay field above.
   */
  expectedSendTime: any | null;
  sendAsReply: boolean;
}

export interface GetMaterializedEmailSequenceTemplates_materializedEmailSequenceTemplates_materializedEmailSequenceTemplateMessages {
  __typename: "MaterializedEmailSequenceTemplateMessage";
  /**
   * The materialized email template for this message in the email sequence template
   */
  materializedEmailTemplate: GetMaterializedEmailSequenceTemplates_materializedEmailSequenceTemplates_materializedEmailSequenceTemplateMessages_materializedEmailTemplate;
  /**
   * The unmunged email sequence template message
   */
  emailSequenceTemplateMessage: GetMaterializedEmailSequenceTemplates_materializedEmailSequenceTemplates_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage;
}

export interface GetMaterializedEmailSequenceTemplates_materializedEmailSequenceTemplates {
  __typename: "MaterializedEmailSequenceTemplate";
  /**
   * The entity used for munging
   */
  entity: GetMaterializedEmailSequenceTemplates_materializedEmailSequenceTemplates_entity;
  /**
   * The unmunged email sequence template
   */
  emailSequenceTemplate: GetMaterializedEmailSequenceTemplates_materializedEmailSequenceTemplates_emailSequenceTemplate;
  /**
   * The sequence of messages for this email sequence template, munged with entity info
   */
  materializedEmailSequenceTemplateMessages: GetMaterializedEmailSequenceTemplates_materializedEmailSequenceTemplates_materializedEmailSequenceTemplateMessages[];
}

export interface GetMaterializedEmailSequenceTemplates {
  /**
   * Materialized email sequence templates
   */
  materializedEmailSequenceTemplates: GetMaterializedEmailSequenceTemplates_materializedEmailSequenceTemplates[];
}

export interface GetMaterializedEmailSequenceTemplatesVariables {
  entityId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMaterializedEmailSequence
// ====================================================

export interface GetMaterializedEmailSequence_materializedEmailSequenceTemplate_entity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMaterializedEmailSequence_materializedEmailSequenceTemplate_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMaterializedEmailSequence_materializedEmailSequenceTemplate_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  isShared: boolean;
  creatorUser: GetMaterializedEmailSequence_materializedEmailSequenceTemplate_emailSequenceTemplate_creatorUser;
}

export interface GetMaterializedEmailSequence_materializedEmailSequenceTemplate_materializedEmailSequenceTemplateMessages_materializedEmailTemplate {
  __typename: "MaterializedEmailTemplate";
  /**
   * Materialized subject of this email template, meaning {firstName} would be returned as Chris.
   */
  subject: string;
  /**
   * Materialized body of this email template, meaning {firstName} would be returned as Chris.
   */
  body: string;
  /**
   * Essentially our "warning" or "error" message for this materialized template,
   * if either the entity has no email address, or the entity doesn’t have all of
   * the expected template information (such as a missing last name, or no company name)
   */
  missingFieldsMessage: string | null;
  /**
   * Materialized body of this email template, without any HTML tags, meaning
   * <div>{firstName}</div> would be returned as Chris.
   */
  plaintextBody: string;
}

export interface GetMaterializedEmailSequence_materializedEmailSequenceTemplate_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMaterializedEmailSequence_materializedEmailSequenceTemplate_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage_sendDelay {
  __typename: "EmailSequenceEmailTemplateSendDelay";
  /**
   * The unit to measure this email template’s send date.This could be days or hours or their business equalivents.
   */
  delayUnit: DueDateUnit;
  /**
   * The timespan after the start of the sequence in units of dueUnit for this email template’s send date.
   */
  delayTimespan: number;
}

export interface GetMaterializedEmailSequence_materializedEmailSequenceTemplate_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage {
  __typename: "EmailSequenceTemplateMessage";
  emailTemplate: GetMaterializedEmailSequence_materializedEmailSequenceTemplate_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage_emailTemplate;
  /**
   * The delay after which to send the follow up email. This is `null` for email
   * templates, and only exists for emails in sequence templates.
   */
  sendDelay: GetMaterializedEmailSequence_materializedEmailSequenceTemplate_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage_sendDelay | null;
  /**
   * The time that this email is expected to be sent based on the given delay.
   * Follows the same null logic as the sendDelay field above.
   */
  expectedSendTime: any | null;
  sendAsReply: boolean;
}

export interface GetMaterializedEmailSequence_materializedEmailSequenceTemplate_materializedEmailSequenceTemplateMessages {
  __typename: "MaterializedEmailSequenceTemplateMessage";
  /**
   * The materialized email template for this message in the email sequence template
   */
  materializedEmailTemplate: GetMaterializedEmailSequence_materializedEmailSequenceTemplate_materializedEmailSequenceTemplateMessages_materializedEmailTemplate;
  /**
   * The unmunged email sequence template message
   */
  emailSequenceTemplateMessage: GetMaterializedEmailSequence_materializedEmailSequenceTemplate_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage;
}

export interface GetMaterializedEmailSequence_materializedEmailSequenceTemplate {
  __typename: "MaterializedEmailSequenceTemplate";
  /**
   * The entity used for munging
   */
  entity: GetMaterializedEmailSequence_materializedEmailSequenceTemplate_entity;
  /**
   * The unmunged email sequence template
   */
  emailSequenceTemplate: GetMaterializedEmailSequence_materializedEmailSequenceTemplate_emailSequenceTemplate;
  /**
   * The sequence of messages for this email sequence template, munged with entity info
   */
  materializedEmailSequenceTemplateMessages: GetMaterializedEmailSequence_materializedEmailSequenceTemplate_materializedEmailSequenceTemplateMessages[];
}

export interface GetMaterializedEmailSequence {
  /**
   * Single email sequence template by id, materialized for a given entity
   */
  materializedEmailSequenceTemplate: GetMaterializedEmailSequence_materializedEmailSequenceTemplate;
}

export interface GetMaterializedEmailSequenceVariables {
  emailSequenceTemplateId: string;
  entityId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMaterializedEmailTemplate
// ====================================================

export interface GetMaterializedEmailTemplate_materializedEmailTemplate_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetMaterializedEmailTemplate_materializedEmailTemplate_entity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMaterializedEmailTemplate_materializedEmailTemplate {
  __typename: "MaterializedEmailTemplate";
  /**
   * Materialized subject of this email template, meaning {firstName} would be returned as Chris.
   */
  subject: string;
  /**
   * Materialized body of this email template, meaning {firstName} would be returned as Chris.
   */
  body: string;
  /**
   * Essentially our "warning" or "error" message for this materialized template,
   * if either the entity has no email address, or the entity doesn’t have all of
   * the expected template information (such as a missing last name, or no company name)
   */
  missingFieldsMessage: string | null;
  /**
   * Underlying non-materialized version of this email template, for accessing the raw field data.
   */
  emailTemplate: GetMaterializedEmailTemplate_materializedEmailTemplate_emailTemplate;
  /**
   * Model associated with this materialized email template.
   */
  entity: GetMaterializedEmailTemplate_materializedEmailTemplate_entity;
}

export interface GetMaterializedEmailTemplate {
  /**
   * Materialized email template with entity-relevant information
   */
  materializedEmailTemplate: GetMaterializedEmailTemplate_materializedEmailTemplate;
}

export interface GetMaterializedEmailTemplateVariables {
  emailTemplateId: string;
  entityId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRelatedEmailAddresses
// ====================================================

export interface GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
  formatted: string;
}

export interface GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_primary_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
}

export interface GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_primary_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary email address for this account
   */
  primaryEmailAddress: string | null;
}

export interface GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_primary_entity_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
}

export type GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_primary_entity = GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_primary_entity_Contact | GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_primary_entity_Account | GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_primary_entity_User;

export interface GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_primary {
  __typename: "EmailAddressEav";
  id: string;
  name: string;
  isPrimary: boolean;
  isFormer: boolean;
  value: GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_primary_value;
  /**
   * The entity that is associated with this email address value.
   */
  entity: GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_primary_entity;
}

export interface GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_all_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
  formatted: string;
}

export interface GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_all_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
}

export interface GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_all_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary email address for this account
   */
  primaryEmailAddress: string | null;
}

export interface GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_all_entity_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
}

export type GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_all_entity = GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_all_entity_Contact | GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_all_entity_Account | GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_all_entity_User;

export interface GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_all {
  __typename: "EmailAddressEav";
  id: string;
  name: string;
  isPrimary: boolean;
  isFormer: boolean;
  value: GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_all_value;
  /**
   * The entity that is associated with this email address value.
   */
  entity: GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_all_entity;
}

export interface GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_primary | null;
  /**
   * An ordered collection of values
   */
  all: GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses_all[];
}

export interface GetRelatedEmailAddresses_coreEntity_emailableLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
}

export interface GetRelatedEmailAddresses_coreEntity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  htmlUrl: string;
  relatedEmailAddresses: GetRelatedEmailAddresses_coreEntity_relatedEmailAddresses;
  emailableLeads: GetRelatedEmailAddresses_coreEntity_emailableLeads[];
}

export interface GetRelatedEmailAddresses {
  /**
   * Returns a Nutshell Core entity by id
   */
  coreEntity: GetRelatedEmailAddresses_coreEntity;
}

export interface GetRelatedEmailAddressesVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSharedEmailSequenceTemplates
// ====================================================

export interface GetSharedEmailSequenceTemplates_emailSequenceTemplateCollection_sharedTemplates_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSharedEmailSequenceTemplates_emailSequenceTemplateCollection_sharedTemplates_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetSharedEmailSequenceTemplates_emailSequenceTemplateCollection_sharedTemplates_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: GetSharedEmailSequenceTemplates_emailSequenceTemplateCollection_sharedTemplates_emailAutomation_entersStage_stageset;
}

export interface GetSharedEmailSequenceTemplates_emailSequenceTemplateCollection_sharedTemplates_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: GetSharedEmailSequenceTemplates_emailSequenceTemplateCollection_sharedTemplates_emailAutomation_entersStage;
}

export interface GetSharedEmailSequenceTemplates_emailSequenceTemplateCollection_sharedTemplates_userChildSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetSharedEmailSequenceTemplates_emailSequenceTemplateCollection_sharedTemplates_emailSequenceTemplateMessages_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetSharedEmailSequenceTemplates_emailSequenceTemplateCollection_sharedTemplates_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailTemplate: GetSharedEmailSequenceTemplates_emailSequenceTemplateCollection_sharedTemplates_emailSequenceTemplateMessages_emailTemplate;
}

export interface GetSharedEmailSequenceTemplates_emailSequenceTemplateCollection_sharedTemplates_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSharedEmailSequenceTemplates_emailSequenceTemplateCollection_sharedTemplates {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  lastSentTime: any | null;
  isShared: boolean;
  isImmutable: boolean;
  /**
   * Has this sequence template been deleted?
   */
  isArchived: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  deletedTime: any | null;
  group: GetSharedEmailSequenceTemplates_emailSequenceTemplateCollection_sharedTemplates_group | null;
  replyRate: number | null;
  /**
   * The count of the sent sequences that got a reply
   */
  replyCount: number;
  clickRate: number | null;
  clickCount: number;
  /**
   * The count of the sent sequences that were cancelled
   */
  cancelledCount: number;
  /**
   * The count of the sequences that finished sending
   */
  finishedCount: number;
  /**
   * The count of the sequences that are still sending messages
   */
  inProgressCount: number;
  /**
   * The count of the sent sequences that have one or more emails with click tracking
   */
  startedWithClickTrackingCount: number;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: GetSharedEmailSequenceTemplates_emailSequenceTemplateCollection_sharedTemplates_emailAutomation | null;
  /**
   * Child template created by the user, if they have made one. Includes the template if its archived
   */
  userChildSequenceTemplate: GetSharedEmailSequenceTemplates_emailSequenceTemplateCollection_sharedTemplates_userChildSequenceTemplate | null;
  emailSequenceTemplateMessages: GetSharedEmailSequenceTemplates_emailSequenceTemplateCollection_sharedTemplates_emailSequenceTemplateMessages[];
  creatorUser: GetSharedEmailSequenceTemplates_emailSequenceTemplateCollection_sharedTemplates_creatorUser;
}

export interface GetSharedEmailSequenceTemplates_emailSequenceTemplateCollection {
  __typename: "EmailSequenceTemplateCollection";
  sharedTemplates: GetSharedEmailSequenceTemplates_emailSequenceTemplateCollection_sharedTemplates[];
}

export interface GetSharedEmailSequenceTemplates {
  /**
   * Email sequence templates, grouped by provenance
   */
  emailSequenceTemplateCollection: GetSharedEmailSequenceTemplates_emailSequenceTemplateCollection;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSuggestedReplies
// ====================================================

export interface GetSuggestedReplies_suggestedReplies_replies {
  __typename: "SuggestedReply";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The title of the suggested reply
   */
  title: string;
  /**
   * The body of the suggested reply
   */
  body: string;
}

export interface GetSuggestedReplies_suggestedReplies {
  __typename: "SuggestedReplies";
  /**
   * The suggested replies
   */
  replies: GetSuggestedReplies_suggestedReplies_replies[];
  /**
   * The status of the AI email suggested replies for the currently logged in user
   */
  status: SuggestedReplyStatus;
}

export interface GetSuggestedReplies {
  /**
   * Returns an array of suggested replies and a status
   */
  suggestedReplies: GetSuggestedReplies_suggestedReplies;
}

export interface GetSuggestedRepliesVariables {
  input: SuggestedRepliesInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserEmailSequenceTemplates
// ====================================================

export interface GetUserEmailSequenceTemplates_emailSequenceTemplateCollection_userTemplates_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetUserEmailSequenceTemplates_emailSequenceTemplateCollection_userTemplates_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetUserEmailSequenceTemplates_emailSequenceTemplateCollection_userTemplates_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: GetUserEmailSequenceTemplates_emailSequenceTemplateCollection_userTemplates_emailAutomation_entersStage_stageset;
}

export interface GetUserEmailSequenceTemplates_emailSequenceTemplateCollection_userTemplates_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: GetUserEmailSequenceTemplates_emailSequenceTemplateCollection_userTemplates_emailAutomation_entersStage;
}

export interface GetUserEmailSequenceTemplates_emailSequenceTemplateCollection_userTemplates_userChildSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetUserEmailSequenceTemplates_emailSequenceTemplateCollection_userTemplates_emailSequenceTemplateMessages_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetUserEmailSequenceTemplates_emailSequenceTemplateCollection_userTemplates_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailTemplate: GetUserEmailSequenceTemplates_emailSequenceTemplateCollection_userTemplates_emailSequenceTemplateMessages_emailTemplate;
}

export interface GetUserEmailSequenceTemplates_emailSequenceTemplateCollection_userTemplates_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetUserEmailSequenceTemplates_emailSequenceTemplateCollection_userTemplates {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  lastSentTime: any | null;
  isShared: boolean;
  isImmutable: boolean;
  /**
   * Has this sequence template been deleted?
   */
  isArchived: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  deletedTime: any | null;
  group: GetUserEmailSequenceTemplates_emailSequenceTemplateCollection_userTemplates_group | null;
  replyRate: number | null;
  /**
   * The count of the sent sequences that got a reply
   */
  replyCount: number;
  clickRate: number | null;
  clickCount: number;
  /**
   * The count of the sent sequences that were cancelled
   */
  cancelledCount: number;
  /**
   * The count of the sequences that finished sending
   */
  finishedCount: number;
  /**
   * The count of the sequences that are still sending messages
   */
  inProgressCount: number;
  /**
   * The count of the sent sequences that have one or more emails with click tracking
   */
  startedWithClickTrackingCount: number;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: GetUserEmailSequenceTemplates_emailSequenceTemplateCollection_userTemplates_emailAutomation | null;
  /**
   * Child template created by the user, if they have made one. Includes the template if its archived
   */
  userChildSequenceTemplate: GetUserEmailSequenceTemplates_emailSequenceTemplateCollection_userTemplates_userChildSequenceTemplate | null;
  emailSequenceTemplateMessages: GetUserEmailSequenceTemplates_emailSequenceTemplateCollection_userTemplates_emailSequenceTemplateMessages[];
  creatorUser: GetUserEmailSequenceTemplates_emailSequenceTemplateCollection_userTemplates_creatorUser;
}

export interface GetUserEmailSequenceTemplates_emailSequenceTemplateCollection {
  __typename: "EmailSequenceTemplateCollection";
  userTemplates: GetUserEmailSequenceTemplates_emailSequenceTemplateCollection_userTemplates[];
}

export interface GetUserEmailSequenceTemplates {
  /**
   * Email sequence templates, grouped by provenance
   */
  emailSequenceTemplateCollection: GetUserEmailSequenceTemplates_emailSequenceTemplateCollection;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DelayQueuedEmail
// ====================================================

export interface DelayQueuedEmail_delayQueuedEmail_emailSequence_emailsQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface DelayQueuedEmail_delayQueuedEmail_emailSequence_emailsQueued_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: DelayQueuedEmail_delayQueuedEmail_emailSequence_emailsQueued_to_avatarEntity | null;
}

export interface DelayQueuedEmail_delayQueuedEmail_emailSequence_emailsQueued_cc_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface DelayQueuedEmail_delayQueuedEmail_emailSequence_emailsQueued_cc {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: DelayQueuedEmail_delayQueuedEmail_emailSequence_emailsQueued_cc_avatarEntity | null;
}

export interface DelayQueuedEmail_delayQueuedEmail_emailSequence_emailsQueued_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface DelayQueuedEmail_delayQueuedEmail_emailSequence_emailsQueued_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: DelayQueuedEmail_delayQueuedEmail_emailSequence_emailsQueued_from_avatarEntity | null;
}

export interface DelayQueuedEmail_delayQueuedEmail_emailSequence_emailsQueued_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface DelayQueuedEmail_delayQueuedEmail_emailSequence_emailsQueued_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DelayQueuedEmail_delayQueuedEmail_emailSequence_emailsQueued_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DelayQueuedEmail_delayQueuedEmail_emailSequence_emailsQueued_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  emailSequenceTemplate: DelayQueuedEmail_delayQueuedEmail_emailSequence_emailsQueued_emailSequence_emailSequenceTemplate | null;
  /**
   * True if this sequence has only one email
   */
  isSingleEmailSequence: boolean;
  /**
   * The next message to be sent
   */
  nextUnsentEmail: DelayQueuedEmail_delayQueuedEmail_emailSequence_emailsQueued_emailSequence_nextUnsentEmail | null;
}

export interface DelayQueuedEmail_delayQueuedEmail_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  to: DelayQueuedEmail_delayQueuedEmail_emailSequence_emailsQueued_to[];
  cc: DelayQueuedEmail_delayQueuedEmail_emailSequence_emailsQueued_cc[];
  /**
   * The sender email address for this queued email.
   */
  from: DelayQueuedEmail_delayQueuedEmail_emailSequence_emailsQueued_from;
  /**
   * The numerical position of the email in its sequence, if it belongs to one
   */
  messageNumber: number | null;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * A plain-text version of the body of this queued email,for use in the collapsed view in a list
   */
  bodyText: string;
  /**
   * A partially-formatted version of the body of this queued email,for use in the expanded view in a list
   */
  bodyHtml: string;
  attachments: DelayQueuedEmail_delayQueuedEmail_emailSequence_emailsQueued_attachments[];
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * The parent email sequence of this queued email.
   */
  emailSequence: DelayQueuedEmail_delayQueuedEmail_emailSequence_emailsQueued_emailSequence | null;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  /**
   * The current status of this queued email.
   */
  status: EmailQueuedStatus;
  /**
   * The current status of this queued email.
   */
  sendProblems: EmailQueuedSendProblem[];
  /**
   * True if this queued email is postponed and the user can retry it.
   */
  canRetry: boolean;
  /**
   * True if this queued email has a delivery time that is in the future.
   */
  isScheduled: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
  /**
   * True if this queued email should be able to be delayed by the user.
   */
  canDelay: boolean;
  /**
   * True if this queued email is in reply to a previous email.
   */
  sendAsReply: boolean;
}

export interface DelayQueuedEmail_delayQueuedEmail_emailSequence {
  __typename: "EmailSequence";
  emailsQueued: DelayQueuedEmail_delayQueuedEmail_emailSequence_emailsQueued[];
}

export interface DelayQueuedEmail_delayQueuedEmail {
  __typename: "DelayQueuedEmailPayload";
  /**
   * The freshly updated email sequence.
   */
  emailSequence: DelayQueuedEmail_delayQueuedEmail_emailSequence;
}

export interface DelayQueuedEmail {
  /**
   * This mutation will delay a queued email and all subsequent emails in that queued email's sequence.
   */
  delayQueuedEmail: DelayQueuedEmail_delayQueuedEmail;
}

export interface DelayQueuedEmailVariables {
  payload: DelayQueuedEmailInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteEmailSequence
// ====================================================

export interface DeleteEmailSequence_emailSequenceDelete_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteEmailSequence_emailSequenceDelete {
  __typename: "EmailSequenceDeletePayload";
  /**
   * The freshly updated email sequence.
   */
  emailSequence: DeleteEmailSequence_emailSequenceDelete_emailSequence;
}

export interface DeleteEmailSequence {
  /**
   * Deletes an email sequence
   */
  emailSequenceDelete: DeleteEmailSequence_emailSequenceDelete;
}

export interface DeleteEmailSequenceVariables {
  payload: EmailSequenceDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteEmail
// ====================================================

export interface DeleteEmail_emailDelete_email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteEmail_emailDelete {
  __typename: "DeleteEmailPayload";
  /**
   * The deleted Nutshell email
   */
  email: DeleteEmail_emailDelete_email;
}

export interface DeleteEmail {
  /**
   * Deletes an email.
   */
  emailDelete: DeleteEmail_emailDelete;
}

export interface DeleteEmailVariables {
  payload: DeleteEmailInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteFailedEmails
// ====================================================

export interface DeleteFailedEmails_failedEmailsDelete {
  __typename: "DeleteFailedEmailsPayload";
  /**
   * The number of failed emails deleted
   */
  numEmailsDeleted: number;
  /**
   * Returns true if the deletion is asynchronous in the background
   */
  deleteDeferred: boolean;
}

export interface DeleteFailedEmails {
  /**
   * Deletes all failed emails for a user.
   */
  failedEmailsDelete: DeleteFailedEmails_failedEmailsDelete;
}

export interface DeleteFailedEmailsVariables {
  input: DeleteFailedEmailsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditQueuedEmail
// ====================================================

export interface EditQueuedEmail_editQueuedEmail_emailsQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface EditQueuedEmail_editQueuedEmail_emailsQueued_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: EditQueuedEmail_editQueuedEmail_emailsQueued_to_avatarEntity | null;
}

export interface EditQueuedEmail_editQueuedEmail_emailsQueued_cc_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface EditQueuedEmail_editQueuedEmail_emailsQueued_cc {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: EditQueuedEmail_editQueuedEmail_emailsQueued_cc_avatarEntity | null;
}

export interface EditQueuedEmail_editQueuedEmail_emailsQueued_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface EditQueuedEmail_editQueuedEmail_emailsQueued_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: EditQueuedEmail_editQueuedEmail_emailsQueued_from_avatarEntity | null;
}

export interface EditQueuedEmail_editQueuedEmail_emailsQueued_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface EditQueuedEmail_editQueuedEmail_emailsQueued_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EditQueuedEmail_editQueuedEmail_emailsQueued_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EditQueuedEmail_editQueuedEmail_emailsQueued_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  emailSequenceTemplate: EditQueuedEmail_editQueuedEmail_emailsQueued_emailSequence_emailSequenceTemplate | null;
  /**
   * True if this sequence has only one email
   */
  isSingleEmailSequence: boolean;
  /**
   * The next message to be sent
   */
  nextUnsentEmail: EditQueuedEmail_editQueuedEmail_emailsQueued_emailSequence_nextUnsentEmail | null;
}

export interface EditQueuedEmail_editQueuedEmail_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  to: EditQueuedEmail_editQueuedEmail_emailsQueued_to[];
  cc: EditQueuedEmail_editQueuedEmail_emailsQueued_cc[];
  /**
   * The sender email address for this queued email.
   */
  from: EditQueuedEmail_editQueuedEmail_emailsQueued_from;
  /**
   * The numerical position of the email in its sequence, if it belongs to one
   */
  messageNumber: number | null;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * A plain-text version of the body of this queued email,for use in the collapsed view in a list
   */
  bodyText: string;
  /**
   * A partially-formatted version of the body of this queued email,for use in the expanded view in a list
   */
  bodyHtml: string;
  attachments: EditQueuedEmail_editQueuedEmail_emailsQueued_attachments[];
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * The parent email sequence of this queued email.
   */
  emailSequence: EditQueuedEmail_editQueuedEmail_emailsQueued_emailSequence | null;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  /**
   * The current status of this queued email.
   */
  status: EmailQueuedStatus;
  /**
   * The current status of this queued email.
   */
  sendProblems: EmailQueuedSendProblem[];
  /**
   * True if this queued email is postponed and the user can retry it.
   */
  canRetry: boolean;
  /**
   * True if this queued email has a delivery time that is in the future.
   */
  isScheduled: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
  /**
   * True if this queued email should be able to be delayed by the user.
   */
  canDelay: boolean;
  /**
   * True if this queued email is in reply to a previous email.
   */
  sendAsReply: boolean;
}

export interface EditQueuedEmail_editQueuedEmail {
  __typename: "EditQueuedEmailPayload";
  /**
   * The freshly updated queued emails.
   */
  emailsQueued: EditQueuedEmail_editQueuedEmail_emailsQueued[];
}

export interface EditQueuedEmail {
  /**
   * This mutation will edit a queued email.
   */
  editQueuedEmail: EditQueuedEmail_editQueuedEmail;
}

export interface EditQueuedEmailVariables {
  payload: EditQueuedEmailInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RetryFailedEmail
// ====================================================

export interface RetryFailedEmail_failedEmailRetry_email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface RetryFailedEmail_failedEmailRetry {
  __typename: "FailedEmailRetryPayload";
  /**
   * The email that was retried.
   */
  email: RetryFailedEmail_failedEmailRetry_email;
}

export interface RetryFailedEmail {
  /**
   * Tries to send a failed email again.
   */
  failedEmailRetry: RetryFailedEmail_failedEmailRetry;
}

export interface RetryFailedEmailVariables {
  payload: FailedEmailRetryInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RetryQueuedEmail
// ====================================================

export interface RetryQueuedEmail_emailQueuedRetry_emailSequence_emailsQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface RetryQueuedEmail_emailQueuedRetry_emailSequence_emailsQueued_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: RetryQueuedEmail_emailQueuedRetry_emailSequence_emailsQueued_to_avatarEntity | null;
}

export interface RetryQueuedEmail_emailQueuedRetry_emailSequence_emailsQueued_cc_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface RetryQueuedEmail_emailQueuedRetry_emailSequence_emailsQueued_cc {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: RetryQueuedEmail_emailQueuedRetry_emailSequence_emailsQueued_cc_avatarEntity | null;
}

export interface RetryQueuedEmail_emailQueuedRetry_emailSequence_emailsQueued_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface RetryQueuedEmail_emailQueuedRetry_emailSequence_emailsQueued_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: RetryQueuedEmail_emailQueuedRetry_emailSequence_emailsQueued_from_avatarEntity | null;
}

export interface RetryQueuedEmail_emailQueuedRetry_emailSequence_emailsQueued_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface RetryQueuedEmail_emailQueuedRetry_emailSequence_emailsQueued_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface RetryQueuedEmail_emailQueuedRetry_emailSequence_emailsQueued_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface RetryQueuedEmail_emailQueuedRetry_emailSequence_emailsQueued_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  emailSequenceTemplate: RetryQueuedEmail_emailQueuedRetry_emailSequence_emailsQueued_emailSequence_emailSequenceTemplate | null;
  /**
   * True if this sequence has only one email
   */
  isSingleEmailSequence: boolean;
  /**
   * The next message to be sent
   */
  nextUnsentEmail: RetryQueuedEmail_emailQueuedRetry_emailSequence_emailsQueued_emailSequence_nextUnsentEmail | null;
}

export interface RetryQueuedEmail_emailQueuedRetry_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  to: RetryQueuedEmail_emailQueuedRetry_emailSequence_emailsQueued_to[];
  cc: RetryQueuedEmail_emailQueuedRetry_emailSequence_emailsQueued_cc[];
  /**
   * The sender email address for this queued email.
   */
  from: RetryQueuedEmail_emailQueuedRetry_emailSequence_emailsQueued_from;
  /**
   * The numerical position of the email in its sequence, if it belongs to one
   */
  messageNumber: number | null;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * A plain-text version of the body of this queued email,for use in the collapsed view in a list
   */
  bodyText: string;
  /**
   * A partially-formatted version of the body of this queued email,for use in the expanded view in a list
   */
  bodyHtml: string;
  attachments: RetryQueuedEmail_emailQueuedRetry_emailSequence_emailsQueued_attachments[];
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * The parent email sequence of this queued email.
   */
  emailSequence: RetryQueuedEmail_emailQueuedRetry_emailSequence_emailsQueued_emailSequence | null;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  /**
   * The current status of this queued email.
   */
  status: EmailQueuedStatus;
  /**
   * The current status of this queued email.
   */
  sendProblems: EmailQueuedSendProblem[];
  /**
   * True if this queued email is postponed and the user can retry it.
   */
  canRetry: boolean;
  /**
   * True if this queued email has a delivery time that is in the future.
   */
  isScheduled: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
  /**
   * True if this queued email should be able to be delayed by the user.
   */
  canDelay: boolean;
  /**
   * True if this queued email is in reply to a previous email.
   */
  sendAsReply: boolean;
}

export interface RetryQueuedEmail_emailQueuedRetry_emailSequence {
  __typename: "EmailSequence";
  emailsQueued: RetryQueuedEmail_emailQueuedRetry_emailSequence_emailsQueued[];
}

export interface RetryQueuedEmail_emailQueuedRetry {
  __typename: "EmailQueuedRetryPayload";
  /**
   * The freshly updated email sequence.
   */
  emailSequence: RetryQueuedEmail_emailQueuedRetry_emailSequence;
}

export interface RetryQueuedEmail {
  /**
   * This mutation will retry a postponed queued email and reschedule any remaining followups	
   */
  emailQueuedRetry: RetryQueuedEmail_emailQueuedRetry;
}

export interface RetryQueuedEmailVariables {
  payload: EmailQueuedRetryInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendNowQueuedEmail
// ====================================================

export interface SendNowQueuedEmail_emailQueuedSendNow_emailSequence_emailsQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface SendNowQueuedEmail_emailQueuedSendNow_emailSequence_emailsQueued_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: SendNowQueuedEmail_emailQueuedSendNow_emailSequence_emailsQueued_to_avatarEntity | null;
}

export interface SendNowQueuedEmail_emailQueuedSendNow_emailSequence_emailsQueued_cc_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface SendNowQueuedEmail_emailQueuedSendNow_emailSequence_emailsQueued_cc {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: SendNowQueuedEmail_emailQueuedSendNow_emailSequence_emailsQueued_cc_avatarEntity | null;
}

export interface SendNowQueuedEmail_emailQueuedSendNow_emailSequence_emailsQueued_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface SendNowQueuedEmail_emailQueuedSendNow_emailSequence_emailsQueued_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: SendNowQueuedEmail_emailQueuedSendNow_emailSequence_emailsQueued_from_avatarEntity | null;
}

export interface SendNowQueuedEmail_emailQueuedSendNow_emailSequence_emailsQueued_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface SendNowQueuedEmail_emailQueuedSendNow_emailSequence_emailsQueued_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SendNowQueuedEmail_emailQueuedSendNow_emailSequence_emailsQueued_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SendNowQueuedEmail_emailQueuedSendNow_emailSequence_emailsQueued_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  emailSequenceTemplate: SendNowQueuedEmail_emailQueuedSendNow_emailSequence_emailsQueued_emailSequence_emailSequenceTemplate | null;
  /**
   * True if this sequence has only one email
   */
  isSingleEmailSequence: boolean;
  /**
   * The next message to be sent
   */
  nextUnsentEmail: SendNowQueuedEmail_emailQueuedSendNow_emailSequence_emailsQueued_emailSequence_nextUnsentEmail | null;
}

export interface SendNowQueuedEmail_emailQueuedSendNow_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  to: SendNowQueuedEmail_emailQueuedSendNow_emailSequence_emailsQueued_to[];
  cc: SendNowQueuedEmail_emailQueuedSendNow_emailSequence_emailsQueued_cc[];
  /**
   * The sender email address for this queued email.
   */
  from: SendNowQueuedEmail_emailQueuedSendNow_emailSequence_emailsQueued_from;
  /**
   * The numerical position of the email in its sequence, if it belongs to one
   */
  messageNumber: number | null;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * A plain-text version of the body of this queued email,for use in the collapsed view in a list
   */
  bodyText: string;
  /**
   * A partially-formatted version of the body of this queued email,for use in the expanded view in a list
   */
  bodyHtml: string;
  attachments: SendNowQueuedEmail_emailQueuedSendNow_emailSequence_emailsQueued_attachments[];
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * The parent email sequence of this queued email.
   */
  emailSequence: SendNowQueuedEmail_emailQueuedSendNow_emailSequence_emailsQueued_emailSequence | null;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  /**
   * The current status of this queued email.
   */
  status: EmailQueuedStatus;
  /**
   * The current status of this queued email.
   */
  sendProblems: EmailQueuedSendProblem[];
  /**
   * True if this queued email is postponed and the user can retry it.
   */
  canRetry: boolean;
  /**
   * True if this queued email has a delivery time that is in the future.
   */
  isScheduled: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
  /**
   * True if this queued email should be able to be delayed by the user.
   */
  canDelay: boolean;
  /**
   * True if this queued email is in reply to a previous email.
   */
  sendAsReply: boolean;
}

export interface SendNowQueuedEmail_emailQueuedSendNow_emailSequence {
  __typename: "EmailSequence";
  emailsQueued: SendNowQueuedEmail_emailQueuedSendNow_emailSequence_emailsQueued[];
}

export interface SendNowQueuedEmail_emailQueuedSendNow {
  __typename: "EmailQueuedSendNowPayload";
  /**
   * The freshly updated email sequence.
   */
  emailSequence: SendNowQueuedEmail_emailQueuedSendNow_emailSequence;
}

export interface SendNowQueuedEmail {
  /**
   * This mutation will send a queued email immediately if the only thing holding it back is the delivery time.
   */
  emailQueuedSendNow: SendNowQueuedEmail_emailQueuedSendNow;
}

export interface SendNowQueuedEmailVariables {
  payload: EmailQueuedSendNowInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ShareEmail
// ====================================================

export interface ShareEmail_shareEmail_email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ShareEmail_shareEmail {
  __typename: "ShareEmailPayload";
  /**
   * The email that was shared or unshared.
   */
  email: ShareEmail_shareEmail_email;
}

export interface ShareEmail {
  /**
   * Share or unshare an email.
   */
  shareEmail: ShareEmail_shareEmail;
}

export interface ShareEmailVariables {
  payload: ShareEmailInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateEmail
// ====================================================

export interface UpdateEmail_emailShareAndCreateContacts_email_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface UpdateEmail_emailShareAndCreateContacts_email_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: UpdateEmail_emailShareAndCreateContacts_email_to_avatarEntity | null;
}

export interface UpdateEmail_emailShareAndCreateContacts_email_cc_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface UpdateEmail_emailShareAndCreateContacts_email_cc {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: UpdateEmail_emailShareAndCreateContacts_email_cc_avatarEntity | null;
}

export interface UpdateEmail_emailShareAndCreateContacts_email_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface UpdateEmail_emailShareAndCreateContacts_email_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: UpdateEmail_emailShareAndCreateContacts_email_from_avatarEntity | null;
}

export interface UpdateEmail_emailShareAndCreateContacts_email_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface UpdateEmail_emailShareAndCreateContacts_email_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateEmail_emailShareAndCreateContacts_email_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  emailSequenceTemplate: UpdateEmail_emailShareAndCreateContacts_email_emailSequence_emailSequenceTemplate | null;
}

export interface UpdateEmail_emailShareAndCreateContacts_email_queuedEmail {
  __typename: "EmailQueued";
  /**
   * The numerical position of the email in its sequence, if it belongs to one
   */
  messageNumber: number | null;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

export interface UpdateEmail_emailShareAndCreateContacts_email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  to: UpdateEmail_emailShareAndCreateContacts_email_to[];
  cc: UpdateEmail_emailShareAndCreateContacts_email_cc[];
  from: UpdateEmail_emailShareAndCreateContacts_email_from;
  createdTime: any;
  sentTime: any | null;
  deletedTime: any | null;
  attachments: UpdateEmail_emailShareAndCreateContacts_email_attachments[];
  subject: string;
  /**
   * A plain-text version of the body of this email,for use in the collapsed view in a list
   */
  bodyText: string;
  /**
   * A partially-formatted version of the body of this email,for use in the expanded view in a list
   */
  bodyHtml: string;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
  /**
   * True if the email is shared with other Nutshell users
   */
  isShared: boolean;
  /**
   * True if the email can be shared with other Nutshell users
   */
  isShareable: boolean;
  /**
   * True if a Nutshell user can reply to this email
   */
  isReplyable: boolean;
  /**
   * The sequence this email is a part of, if any
   */
  emailSequence: UpdateEmail_emailShareAndCreateContacts_email_emailSequence | null;
  /**
   * The queued email that relates to this email
   */
  queuedEmail: UpdateEmail_emailShareAndCreateContacts_email_queuedEmail | null;
  /**
   * Number of times this email has been viewed via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedViewsCount: number | null;
  /**
   * Was this email a reply sent by Nutshell automatically.
   */
  isAutomatedReply: boolean;
  /**
   * Was this email sent by Nutshell automatically.
   */
  isEmailAutomation: boolean;
}

export interface UpdateEmail_emailShareAndCreateContacts {
  __typename: "EmailShareAndCreateContactsPayload";
  email: UpdateEmail_emailShareAndCreateContacts_email;
}

export interface UpdateEmail {
  /**
   * Shares (or unshares) a Nutshell email. If the email is being shared, and there
   * are addresses on this email that are not previously associated with Nutshell
   * contacts, this mutation will create those contacts at this time.
   */
  emailShareAndCreateContacts: UpdateEmail_emailShareAndCreateContacts;
}

export interface UpdateEmailVariables {
  payload: EmailShareAndCreateContactsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEmailDetails
// ====================================================

export interface GetEmailDetails_email_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetEmailDetails_email_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetEmailDetails_email_to_avatarEntity | null;
}

export interface GetEmailDetails_email_cc_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetEmailDetails_email_cc {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetEmailDetails_email_cc_avatarEntity | null;
}

export interface GetEmailDetails_email_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetEmailDetails_email_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetEmailDetails_email_from_avatarEntity | null;
}

export interface GetEmailDetails_email_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetEmailDetails_email_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEmailDetails_email_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  emailSequenceTemplate: GetEmailDetails_email_emailSequence_emailSequenceTemplate | null;
}

export interface GetEmailDetails_email_queuedEmail {
  __typename: "EmailQueued";
  /**
   * The numerical position of the email in its sequence, if it belongs to one
   */
  messageNumber: number | null;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

export interface GetEmailDetails_email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  to: GetEmailDetails_email_to[];
  cc: GetEmailDetails_email_cc[];
  from: GetEmailDetails_email_from;
  createdTime: any;
  sentTime: any | null;
  deletedTime: any | null;
  attachments: GetEmailDetails_email_attachments[];
  subject: string;
  /**
   * A plain-text version of the body of this email,for use in the collapsed view in a list
   */
  bodyText: string;
  /**
   * A partially-formatted version of the body of this email,for use in the expanded view in a list
   */
  bodyHtml: string;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
  /**
   * True if the email is shared with other Nutshell users
   */
  isShared: boolean;
  /**
   * True if the email can be shared with other Nutshell users
   */
  isShareable: boolean;
  /**
   * True if a Nutshell user can reply to this email
   */
  isReplyable: boolean;
  /**
   * The sequence this email is a part of, if any
   */
  emailSequence: GetEmailDetails_email_emailSequence | null;
  /**
   * The queued email that relates to this email
   */
  queuedEmail: GetEmailDetails_email_queuedEmail | null;
  /**
   * Number of times this email has been viewed via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedViewsCount: number | null;
  /**
   * Was this email a reply sent by Nutshell automatically.
   */
  isAutomatedReply: boolean;
  /**
   * Was this email sent by Nutshell automatically.
   */
  isEmailAutomation: boolean;
}

export interface GetEmailDetails {
  /**
   * Get the details for a given email
   */
  email: GetEmailDetails_email | null;
}

export interface GetEmailDetailsVariables {
  emailId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetFailedEmails
// ====================================================

export interface GetFailedEmails_failedEmails_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetFailedEmails_failedEmails_edges_node_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetFailedEmails_failedEmails_edges_node_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetFailedEmails_failedEmails_edges_node_to_avatarEntity | null;
}

export interface GetFailedEmails_failedEmails_edges_node_cc_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetFailedEmails_failedEmails_edges_node_cc {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetFailedEmails_failedEmails_edges_node_cc_avatarEntity | null;
}

export interface GetFailedEmails_failedEmails_edges_node_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetFailedEmails_failedEmails_edges_node_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetFailedEmails_failedEmails_edges_node_from_avatarEntity | null;
}

export interface GetFailedEmails_failedEmails_edges_node_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
}

export interface GetFailedEmails_failedEmails_edges_node_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetFailedEmails_failedEmails_edges_node_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  emailSequenceTemplate: GetFailedEmails_failedEmails_edges_node_emailSequence_emailSequenceTemplate | null;
}

export interface GetFailedEmails_failedEmails_edges_node_queuedEmail {
  __typename: "EmailQueued";
  /**
   * The numerical position of the email in its sequence, if it belongs to one
   */
  messageNumber: number | null;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

export interface GetFailedEmails_failedEmails_edges_node {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  to: GetFailedEmails_failedEmails_edges_node_to[];
  cc: GetFailedEmails_failedEmails_edges_node_cc[];
  from: GetFailedEmails_failedEmails_edges_node_from;
  createdTime: any;
  sentTime: any | null;
  attachments: GetFailedEmails_failedEmails_edges_node_attachments[];
  subject: string;
  /**
   * A plain-text version of the body of this email,for use in the collapsed view in a list
   */
  bodyText: string;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
  /**
   * True if the email is shared with other Nutshell users
   */
  isShared: boolean;
  /**
   * True if the email can be shared with other Nutshell users
   */
  isShareable: boolean;
  /**
   * True if a Nutshell user can reply to this email
   */
  isReplyable: boolean;
  /**
   * The sequence this email is a part of, if any
   */
  emailSequence: GetFailedEmails_failedEmails_edges_node_emailSequence | null;
  /**
   * The queued email that relates to this email
   */
  queuedEmail: GetFailedEmails_failedEmails_edges_node_queuedEmail | null;
  /**
   * Number of times this email has been viewed via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedViewsCount: number | null;
  /**
   * Was this email a reply sent by Nutshell automatically.
   */
  isAutomatedReply: boolean;
  /**
   * Was this email sent by Nutshell automatically.
   */
  isEmailAutomation: boolean;
}

export interface GetFailedEmails_failedEmails_edges {
  __typename: "EmailsEdge";
  cursor: string;
  node: GetFailedEmails_failedEmails_edges_node;
}

export interface GetFailedEmails_failedEmails {
  __typename: "EmailsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetFailedEmails_failedEmails_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetFailedEmails_failedEmails_edges[];
}

export interface GetFailedEmails {
  /**
   * Paginated collection of all failed emails for a given user
   */
  failedEmails: GetFailedEmails_failedEmails;
}

export interface GetFailedEmailsVariables {
  limit: number;
  cursor?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetQueuedEmail
// ====================================================

export interface GetQueuedEmail_queuedEmail_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetQueuedEmail_queuedEmail_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetQueuedEmail_queuedEmail_to_avatarEntity | null;
}

export interface GetQueuedEmail_queuedEmail_cc_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetQueuedEmail_queuedEmail_cc {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetQueuedEmail_queuedEmail_cc_avatarEntity | null;
}

export interface GetQueuedEmail_queuedEmail_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetQueuedEmail_queuedEmail_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetQueuedEmail_queuedEmail_from_avatarEntity | null;
}

export interface GetQueuedEmail_queuedEmail_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetQueuedEmail_queuedEmail_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetQueuedEmail_queuedEmail_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetQueuedEmail_queuedEmail_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  emailSequenceTemplate: GetQueuedEmail_queuedEmail_emailSequence_emailSequenceTemplate | null;
  /**
   * True if this sequence has only one email
   */
  isSingleEmailSequence: boolean;
  /**
   * The next message to be sent
   */
  nextUnsentEmail: GetQueuedEmail_queuedEmail_emailSequence_nextUnsentEmail | null;
}

export interface GetQueuedEmail_queuedEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  to: GetQueuedEmail_queuedEmail_to[];
  cc: GetQueuedEmail_queuedEmail_cc[];
  /**
   * The sender email address for this queued email.
   */
  from: GetQueuedEmail_queuedEmail_from;
  /**
   * The numerical position of the email in its sequence, if it belongs to one
   */
  messageNumber: number | null;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * A plain-text version of the body of this queued email,for use in the collapsed view in a list
   */
  bodyText: string;
  /**
   * A partially-formatted version of the body of this queued email,for use in the expanded view in a list
   */
  bodyHtml: string;
  attachments: GetQueuedEmail_queuedEmail_attachments[];
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * The parent email sequence of this queued email.
   */
  emailSequence: GetQueuedEmail_queuedEmail_emailSequence | null;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  /**
   * The current status of this queued email.
   */
  status: EmailQueuedStatus;
  /**
   * The current status of this queued email.
   */
  sendProblems: EmailQueuedSendProblem[];
  /**
   * True if this queued email is postponed and the user can retry it.
   */
  canRetry: boolean;
  /**
   * True if this queued email has a delivery time that is in the future.
   */
  isScheduled: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
  /**
   * True if this queued email should be able to be delayed by the user.
   */
  canDelay: boolean;
  /**
   * True if this queued email is in reply to a previous email.
   */
  sendAsReply: boolean;
}

export interface GetQueuedEmail {
  /**
   * Get the details for a given queued email
   */
  queuedEmail: GetQueuedEmail_queuedEmail | null;
}

export interface GetQueuedEmailVariables {
  queuedEmailId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetReceivedEmails
// ====================================================

export interface GetReceivedEmails_receivedEmails_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetReceivedEmails_receivedEmails_edges_node_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetReceivedEmails_receivedEmails_edges_node_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetReceivedEmails_receivedEmails_edges_node_to_avatarEntity | null;
}

export interface GetReceivedEmails_receivedEmails_edges_node_cc_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetReceivedEmails_receivedEmails_edges_node_cc {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetReceivedEmails_receivedEmails_edges_node_cc_avatarEntity | null;
}

export interface GetReceivedEmails_receivedEmails_edges_node_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetReceivedEmails_receivedEmails_edges_node_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetReceivedEmails_receivedEmails_edges_node_from_avatarEntity | null;
}

export interface GetReceivedEmails_receivedEmails_edges_node_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
}

export interface GetReceivedEmails_receivedEmails_edges_node_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetReceivedEmails_receivedEmails_edges_node_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  emailSequenceTemplate: GetReceivedEmails_receivedEmails_edges_node_emailSequence_emailSequenceTemplate | null;
}

export interface GetReceivedEmails_receivedEmails_edges_node_queuedEmail {
  __typename: "EmailQueued";
  /**
   * The numerical position of the email in its sequence, if it belongs to one
   */
  messageNumber: number | null;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

export interface GetReceivedEmails_receivedEmails_edges_node {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  to: GetReceivedEmails_receivedEmails_edges_node_to[];
  cc: GetReceivedEmails_receivedEmails_edges_node_cc[];
  from: GetReceivedEmails_receivedEmails_edges_node_from;
  createdTime: any;
  sentTime: any | null;
  attachments: GetReceivedEmails_receivedEmails_edges_node_attachments[];
  subject: string;
  /**
   * A plain-text version of the body of this email,for use in the collapsed view in a list
   */
  bodyText: string;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
  /**
   * True if the email is shared with other Nutshell users
   */
  isShared: boolean;
  /**
   * True if the email can be shared with other Nutshell users
   */
  isShareable: boolean;
  /**
   * True if a Nutshell user can reply to this email
   */
  isReplyable: boolean;
  /**
   * The sequence this email is a part of, if any
   */
  emailSequence: GetReceivedEmails_receivedEmails_edges_node_emailSequence | null;
  /**
   * The queued email that relates to this email
   */
  queuedEmail: GetReceivedEmails_receivedEmails_edges_node_queuedEmail | null;
  /**
   * Number of times this email has been viewed via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedViewsCount: number | null;
  /**
   * Was this email a reply sent by Nutshell automatically.
   */
  isAutomatedReply: boolean;
  /**
   * Was this email sent by Nutshell automatically.
   */
  isEmailAutomation: boolean;
}

export interface GetReceivedEmails_receivedEmails_edges {
  __typename: "EmailsEdge";
  cursor: string;
  node: GetReceivedEmails_receivedEmails_edges_node;
}

export interface GetReceivedEmails_receivedEmails {
  __typename: "EmailsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetReceivedEmails_receivedEmails_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetReceivedEmails_receivedEmails_edges[];
}

export interface GetReceivedEmails {
  /**
   * Paginated collection of all received emails for a given user. This includes cc’d emails
   */
  receivedEmails: GetReceivedEmails_receivedEmails;
}

export interface GetReceivedEmailsVariables {
  limit: number;
  cursor?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetScheduledEmails
// ====================================================

export interface GetScheduledEmails_queuedEmails_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetScheduledEmails_queuedEmails_edges_node_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetScheduledEmails_queuedEmails_edges_node_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetScheduledEmails_queuedEmails_edges_node_to_avatarEntity | null;
}

export interface GetScheduledEmails_queuedEmails_edges_node_cc_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetScheduledEmails_queuedEmails_edges_node_cc {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetScheduledEmails_queuedEmails_edges_node_cc_avatarEntity | null;
}

export interface GetScheduledEmails_queuedEmails_edges_node_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetScheduledEmails_queuedEmails_edges_node_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetScheduledEmails_queuedEmails_edges_node_from_avatarEntity | null;
}

export interface GetScheduledEmails_queuedEmails_edges_node_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetScheduledEmails_queuedEmails_edges_node_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetScheduledEmails_queuedEmails_edges_node_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetScheduledEmails_queuedEmails_edges_node_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  emailSequenceTemplate: GetScheduledEmails_queuedEmails_edges_node_emailSequence_emailSequenceTemplate | null;
  /**
   * True if this sequence has only one email
   */
  isSingleEmailSequence: boolean;
  /**
   * The next message to be sent
   */
  nextUnsentEmail: GetScheduledEmails_queuedEmails_edges_node_emailSequence_nextUnsentEmail | null;
}

export interface GetScheduledEmails_queuedEmails_edges_node {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  to: GetScheduledEmails_queuedEmails_edges_node_to[];
  cc: GetScheduledEmails_queuedEmails_edges_node_cc[];
  /**
   * The sender email address for this queued email.
   */
  from: GetScheduledEmails_queuedEmails_edges_node_from;
  /**
   * The numerical position of the email in its sequence, if it belongs to one
   */
  messageNumber: number | null;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * A plain-text version of the body of this queued email,for use in the collapsed view in a list
   */
  bodyText: string;
  /**
   * A partially-formatted version of the body of this queued email,for use in the expanded view in a list
   */
  bodyHtml: string;
  attachments: GetScheduledEmails_queuedEmails_edges_node_attachments[];
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * The parent email sequence of this queued email.
   */
  emailSequence: GetScheduledEmails_queuedEmails_edges_node_emailSequence | null;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  /**
   * The current status of this queued email.
   */
  status: EmailQueuedStatus;
  /**
   * The current status of this queued email.
   */
  sendProblems: EmailQueuedSendProblem[];
  /**
   * True if this queued email is postponed and the user can retry it.
   */
  canRetry: boolean;
  /**
   * True if this queued email has a delivery time that is in the future.
   */
  isScheduled: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
  /**
   * True if this queued email should be able to be delayed by the user.
   */
  canDelay: boolean;
  /**
   * True if this queued email is in reply to a previous email.
   */
  sendAsReply: boolean;
}

export interface GetScheduledEmails_queuedEmails_edges {
  __typename: "EmailsQueuedEdge";
  cursor: string;
  node: GetScheduledEmails_queuedEmails_edges_node;
}

export interface GetScheduledEmails_queuedEmails {
  __typename: "EmailsQueuedConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetScheduledEmails_queuedEmails_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetScheduledEmails_queuedEmails_edges[];
}

export interface GetScheduledEmails {
  /**
   * Returns queued emails for the current user
   */
  queuedEmails: GetScheduledEmails_queuedEmails;
}

export interface GetScheduledEmailsVariables {
  limit: number;
  cursor?: string | null;
  filters?: EmailsQueuedFilterInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSendingEmails
// ====================================================

export interface GetSendingEmails_sendingEmails_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetSendingEmails_sendingEmails_edges_node_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetSendingEmails_sendingEmails_edges_node_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetSendingEmails_sendingEmails_edges_node_to_avatarEntity | null;
}

export interface GetSendingEmails_sendingEmails_edges_node_cc_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetSendingEmails_sendingEmails_edges_node_cc {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetSendingEmails_sendingEmails_edges_node_cc_avatarEntity | null;
}

export interface GetSendingEmails_sendingEmails_edges_node_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetSendingEmails_sendingEmails_edges_node_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetSendingEmails_sendingEmails_edges_node_from_avatarEntity | null;
}

export interface GetSendingEmails_sendingEmails_edges_node_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetSendingEmails_sendingEmails_edges_node_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSendingEmails_sendingEmails_edges_node_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetSendingEmails_sendingEmails_edges_node_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  emailSequenceTemplate: GetSendingEmails_sendingEmails_edges_node_emailSequence_emailSequenceTemplate | null;
  /**
   * True if this sequence has only one email
   */
  isSingleEmailSequence: boolean;
  /**
   * The next message to be sent
   */
  nextUnsentEmail: GetSendingEmails_sendingEmails_edges_node_emailSequence_nextUnsentEmail | null;
}

export interface GetSendingEmails_sendingEmails_edges_node {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  to: GetSendingEmails_sendingEmails_edges_node_to[];
  cc: GetSendingEmails_sendingEmails_edges_node_cc[];
  /**
   * The sender email address for this queued email.
   */
  from: GetSendingEmails_sendingEmails_edges_node_from;
  /**
   * The numerical position of the email in its sequence, if it belongs to one
   */
  messageNumber: number | null;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * A plain-text version of the body of this queued email,for use in the collapsed view in a list
   */
  bodyText: string;
  /**
   * A partially-formatted version of the body of this queued email,for use in the expanded view in a list
   */
  bodyHtml: string;
  attachments: GetSendingEmails_sendingEmails_edges_node_attachments[];
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * The parent email sequence of this queued email.
   */
  emailSequence: GetSendingEmails_sendingEmails_edges_node_emailSequence | null;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  /**
   * The current status of this queued email.
   */
  status: EmailQueuedStatus;
  /**
   * The current status of this queued email.
   */
  sendProblems: EmailQueuedSendProblem[];
  /**
   * True if this queued email is postponed and the user can retry it.
   */
  canRetry: boolean;
  /**
   * True if this queued email has a delivery time that is in the future.
   */
  isScheduled: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
  /**
   * True if this queued email should be able to be delayed by the user.
   */
  canDelay: boolean;
  /**
   * True if this queued email is in reply to a previous email.
   */
  sendAsReply: boolean;
}

export interface GetSendingEmails_sendingEmails_edges {
  __typename: "EmailsQueuedEdge";
  cursor: string;
  node: GetSendingEmails_sendingEmails_edges_node;
}

export interface GetSendingEmails_sendingEmails {
  __typename: "EmailsQueuedConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetSendingEmails_sendingEmails_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetSendingEmails_sendingEmails_edges[];
}

export interface GetSendingEmails {
  /**
   * Paginated collection of all emails being sent for a given user
   */
  sendingEmails: GetSendingEmails_sendingEmails;
}

export interface GetSendingEmailsVariables {
  limit: number;
  cursor?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSentEmails
// ====================================================

export interface GetSentEmails_sentEmails_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetSentEmails_sentEmails_edges_node_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetSentEmails_sentEmails_edges_node_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetSentEmails_sentEmails_edges_node_to_avatarEntity | null;
}

export interface GetSentEmails_sentEmails_edges_node_cc_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetSentEmails_sentEmails_edges_node_cc {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetSentEmails_sentEmails_edges_node_cc_avatarEntity | null;
}

export interface GetSentEmails_sentEmails_edges_node_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetSentEmails_sentEmails_edges_node_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetSentEmails_sentEmails_edges_node_from_avatarEntity | null;
}

export interface GetSentEmails_sentEmails_edges_node_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
}

export interface GetSentEmails_sentEmails_edges_node_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSentEmails_sentEmails_edges_node_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  emailSequenceTemplate: GetSentEmails_sentEmails_edges_node_emailSequence_emailSequenceTemplate | null;
}

export interface GetSentEmails_sentEmails_edges_node_queuedEmail {
  __typename: "EmailQueued";
  /**
   * The numerical position of the email in its sequence, if it belongs to one
   */
  messageNumber: number | null;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

export interface GetSentEmails_sentEmails_edges_node {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  to: GetSentEmails_sentEmails_edges_node_to[];
  cc: GetSentEmails_sentEmails_edges_node_cc[];
  from: GetSentEmails_sentEmails_edges_node_from;
  createdTime: any;
  sentTime: any | null;
  attachments: GetSentEmails_sentEmails_edges_node_attachments[];
  subject: string;
  /**
   * A plain-text version of the body of this email,for use in the collapsed view in a list
   */
  bodyText: string;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
  /**
   * True if the email is shared with other Nutshell users
   */
  isShared: boolean;
  /**
   * True if the email can be shared with other Nutshell users
   */
  isShareable: boolean;
  /**
   * True if a Nutshell user can reply to this email
   */
  isReplyable: boolean;
  /**
   * The sequence this email is a part of, if any
   */
  emailSequence: GetSentEmails_sentEmails_edges_node_emailSequence | null;
  /**
   * The queued email that relates to this email
   */
  queuedEmail: GetSentEmails_sentEmails_edges_node_queuedEmail | null;
  /**
   * Number of times this email has been viewed via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedViewsCount: number | null;
  /**
   * Was this email a reply sent by Nutshell automatically.
   */
  isAutomatedReply: boolean;
  /**
   * Was this email sent by Nutshell automatically.
   */
  isEmailAutomation: boolean;
}

export interface GetSentEmails_sentEmails_edges {
  __typename: "EmailsEdge";
  cursor: string;
  node: GetSentEmails_sentEmails_edges_node;
}

export interface GetSentEmails_sentEmails {
  __typename: "EmailsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetSentEmails_sentEmails_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetSentEmails_sentEmails_edges[];
}

export interface GetSentEmails {
  /**
   * Paginated collection of all sent emails for a given user
   */
  sentEmails: GetSentEmails_sentEmails;
}

export interface GetSentEmailsVariables {
  limit: number;
  cursor?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEmailSyncStatusBanner
// ====================================================

export interface GetEmailSyncStatusBanner_emailBannerStats_lastEmail {
  __typename: "Email";
  subject: string;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
}

export interface GetEmailSyncStatusBanner_emailBannerStats {
  __typename: "EmailSyncStatusBanner";
  /**
   * An enum of the current email sync status. Success, warning, or error. Null if email is not configured.
   */
  status: EmailBannerStatus;
  /**
   * A quick summary of the account email health. Used for health button.
   */
  title: string;
  /**
   * The long description of the account email health.
   */
  description: string | null;
  /**
   * The error message text.
   */
  error: string | null;
  /**
   * Status of the initial sync to bring in historic emails
   */
  initialSyncDescription: string | null;
  /**
   * Whether or not initialSyncDescription is an error
   */
  initialSyncDescriptionIsError: boolean;
  /**
   * The time of the last sync performed.
   */
  lastSyncTime: any | null;
  /**
   * The last email synced in for this user.
   */
  lastEmail: GetEmailSyncStatusBanner_emailBannerStats_lastEmail | null;
}

export interface GetEmailSyncStatusBanner {
  /**
   * Statistics about this user's email sync.
   */
  emailBannerStats: GetEmailSyncStatusBanner_emailBannerStats | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RescheduleQueuedEmail
// ====================================================

export interface RescheduleQueuedEmail_queuedEmailReschedule_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
}

export interface RescheduleQueuedEmail_queuedEmailReschedule_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailsQueued: RescheduleQueuedEmail_queuedEmailReschedule_emailSequence_emailsQueued[];
}

export interface RescheduleQueuedEmail_queuedEmailReschedule {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * The parent email sequence of this queued email.
   */
  emailSequence: RescheduleQueuedEmail_queuedEmailReschedule_emailSequence | null;
}

export interface RescheduleQueuedEmail {
  /**
   * Reschedules a queued email by setting its delivery time to the provided scheduled time.
   */
  queuedEmailReschedule: RescheduleQueuedEmail_queuedEmailReschedule;
}

export interface RescheduleQueuedEmailVariables {
  queuedEmailId: string;
  scheduledTime: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AcceptEmailReplySuggestion
// ====================================================

export interface AcceptEmailReplySuggestion_emailAcceptSuggestedReply {
  __typename: "EmailAcceptSuggestedReplyPayload";
  /**
   * Whether the suggested reply was accepted successfully
   */
  success: boolean;
}

export interface AcceptEmailReplySuggestion {
  emailAcceptSuggestedReply: AcceptEmailReplySuggestion_emailAcceptSuggestedReply;
}

export interface AcceptEmailReplySuggestionVariables {
  input: EmailAcceptSuggestedReplyInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEmailableQuotesByLeadIds
// ====================================================

export interface GetEmailableQuotesByLeadIds_quotesForSend {
  __typename: "Quote" | "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The sharable view in browser link
   */
  shareableViewInBrowserLink: string;
}

export interface GetEmailableQuotesByLeadIds {
  /**
   * Returns an array of readied quotes for sending
   */
  quotesForSend: GetEmailableQuotesByLeadIds_quotesForSend[];
}

export interface GetEmailableQuotesByLeadIdsVariables {
  leadIds: string[];
  documentType?: SalesDocumentVariant | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetReplyableEmail
// ====================================================

export interface GetReplyableEmail_replyEmail_replyAllAddresses_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetReplyableEmail_replyEmail_replyAllAddresses {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetReplyableEmail_replyEmail_replyAllAddresses_avatarEntity | null;
}

export interface GetReplyableEmail_replyEmail_replyToAddress_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetReplyableEmail_replyEmail_replyToAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: GetReplyableEmail_replyEmail_replyToAddress_avatarEntity | null;
}

export interface GetReplyableEmail_replyEmail_relatedLeads_edges_node {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
}

export interface GetReplyableEmail_replyEmail_relatedLeads_edges {
  __typename: "EmailLeadsEdge";
  node: GetReplyableEmail_replyEmail_relatedLeads_edges_node;
  /**
   * Is this lead mapped to this email?
   */
  isMapped: boolean;
}

export interface GetReplyableEmail_replyEmail_relatedLeads {
  __typename: "EmailLeadsConnection";
  /**
   * A list of edges.
   */
  edges: GetReplyableEmail_replyEmail_relatedLeads_edges[];
}

export interface GetReplyableEmail_replyEmail {
  __typename: "ReplyableEmail";
  /**
   * The HTML of the previous email, in a blockquote
   */
  bodyHtml: string;
  /**
   * The subject of the previous email, in a with re:
   */
  subject: string;
  /**
   * The array of email addresses for a reply all.
   */
  replyAllAddresses: GetReplyableEmail_replyEmail_replyAllAddresses[];
  /**
   * The email address of the sender or the first non-self sent to address.
   */
  replyToAddress: GetReplyableEmail_replyEmail_replyToAddress;
  /**
   * Gets all leads related to this email reply. This includes all open leads at
   * the time of send, as well as any previously/explicitly associated leads
   */
  relatedLeads: GetReplyableEmail_replyEmail_relatedLeads;
}

export interface GetReplyableEmail {
  /**
   * Returns info about the accounts email marketing usage.
   */
  replyEmail: GetReplyableEmail_replyEmail;
}

export interface GetReplyableEmailVariables {
  emailId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMaterializedEmailSequenceExtension
// ====================================================

export interface GetMaterializedEmailSequenceExtension_materializedEmailSequenceTemplateExtension_entity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMaterializedEmailSequenceExtension_materializedEmailSequenceTemplateExtension_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMaterializedEmailSequenceExtension_materializedEmailSequenceTemplateExtension_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  isShared: boolean;
  creatorUser: GetMaterializedEmailSequenceExtension_materializedEmailSequenceTemplateExtension_emailSequenceTemplate_creatorUser;
  /**
   * The complete url to the edit modal for the email template
   */
  htmlUrl: string;
}

export interface GetMaterializedEmailSequenceExtension_materializedEmailSequenceTemplateExtension_materializedEmailSequenceTemplateMessages_materializedEmailTemplate {
  __typename: "MaterializedEmailTemplate";
  /**
   * Materialized subject of this email template, meaning {firstName} would be returned as Chris.
   */
  subject: string;
  /**
   * Materialized body of this email template, meaning {firstName} would be returned as Chris.
   */
  body: string;
  /**
   * Essentially our "warning" or "error" message for this materialized template,
   * if either the entity has no email address, or the entity doesn’t have all of
   * the expected template information (such as a missing last name, or no company name)
   */
  missingFieldsMessage: string | null;
  /**
   * Materialized body of this email template, without any HTML tags, meaning
   * <div>{firstName}</div> would be returned as Chris.
   */
  plaintextBody: string;
}

export interface GetMaterializedEmailSequenceExtension_materializedEmailSequenceTemplateExtension_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMaterializedEmailSequenceExtension_materializedEmailSequenceTemplateExtension_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage_sendDelay {
  __typename: "EmailSequenceEmailTemplateSendDelay";
  /**
   * The unit to measure this email template’s send date.This could be days or hours or their business equalivents.
   */
  delayUnit: DueDateUnit;
  /**
   * The timespan after the start of the sequence in units of dueUnit for this email template’s send date.
   */
  delayTimespan: number;
}

export interface GetMaterializedEmailSequenceExtension_materializedEmailSequenceTemplateExtension_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage {
  __typename: "EmailSequenceTemplateMessage";
  emailTemplate: GetMaterializedEmailSequenceExtension_materializedEmailSequenceTemplateExtension_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage_emailTemplate;
  /**
   * The delay after which to send the follow up email. This is `null` for email
   * templates, and only exists for emails in sequence templates.
   */
  sendDelay: GetMaterializedEmailSequenceExtension_materializedEmailSequenceTemplateExtension_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage_sendDelay | null;
  /**
   * The time that this email is expected to be sent based on the given delay.
   * Follows the same null logic as the sendDelay field above.
   */
  expectedSendTime: any | null;
  sendAsReply: boolean;
}

export interface GetMaterializedEmailSequenceExtension_materializedEmailSequenceTemplateExtension_materializedEmailSequenceTemplateMessages {
  __typename: "MaterializedEmailSequenceTemplateMessage";
  /**
   * The materialized email template for this message in the email sequence template
   */
  materializedEmailTemplate: GetMaterializedEmailSequenceExtension_materializedEmailSequenceTemplateExtension_materializedEmailSequenceTemplateMessages_materializedEmailTemplate;
  /**
   * The unmunged email sequence template message
   */
  emailSequenceTemplateMessage: GetMaterializedEmailSequenceExtension_materializedEmailSequenceTemplateExtension_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage;
}

export interface GetMaterializedEmailSequenceExtension_materializedEmailSequenceTemplateExtension {
  __typename: "MaterializedEmailSequenceTemplate";
  /**
   * The entity used for munging
   */
  entity: GetMaterializedEmailSequenceExtension_materializedEmailSequenceTemplateExtension_entity;
  /**
   * The unmunged email sequence template
   */
  emailSequenceTemplate: GetMaterializedEmailSequenceExtension_materializedEmailSequenceTemplateExtension_emailSequenceTemplate;
  /**
   * The sequence of messages for this email sequence template, munged with entity info
   */
  materializedEmailSequenceTemplateMessages: GetMaterializedEmailSequenceExtension_materializedEmailSequenceTemplateExtension_materializedEmailSequenceTemplateMessages[];
}

export interface GetMaterializedEmailSequenceExtension {
  /**
   * Single email sequence template by id, materialized for email extensions
   */
  materializedEmailSequenceTemplateExtension: GetMaterializedEmailSequenceExtension_materializedEmailSequenceTemplateExtension;
}

export interface GetMaterializedEmailSequenceExtensionVariables {
  emailSequenceTemplateId: string;
  emailAddress?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  companyName?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ArchiveGroup
// ====================================================

export interface ArchiveGroup_emailSequenceTemplateGroupArchive_emailSequenceTemplateGroup {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ArchiveGroup_emailSequenceTemplateGroupArchive {
  __typename: "EmailSequenceTemplateGroupArchivePayload";
  /**
   * The Archived email sequence template group
   */
  emailSequenceTemplateGroup: ArchiveGroup_emailSequenceTemplateGroupArchive_emailSequenceTemplateGroup;
}

export interface ArchiveGroup {
  /**
   * Archives an email sequence template group
   */
  emailSequenceTemplateGroupArchive: ArchiveGroup_emailSequenceTemplateGroupArchive;
}

export interface ArchiveGroupVariables {
  input: EmailSequenceTemplateGroupArchiveInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateEmailSequenceTemplateGroup
// ====================================================

export interface CreateEmailSequenceTemplateGroup_emailSequenceTemplateGroupCreate_emailSequenceTemplateGroup {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  position: number;
}

export interface CreateEmailSequenceTemplateGroup_emailSequenceTemplateGroupCreate {
  __typename: "EmailSequenceTemplateGroupCreatePayload";
  /**
   * The newly created email sequence template group.
   */
  emailSequenceTemplateGroup: CreateEmailSequenceTemplateGroup_emailSequenceTemplateGroupCreate_emailSequenceTemplateGroup;
}

export interface CreateEmailSequenceTemplateGroup {
  /**
   * Creates a email sequence template group
   */
  emailSequenceTemplateGroupCreate: CreateEmailSequenceTemplateGroup_emailSequenceTemplateGroupCreate;
}

export interface CreateEmailSequenceTemplateGroupVariables {
  input: EmailSequenceTemplateGroupCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DuplicateEmailSequenceTemplate
// ====================================================

export interface DuplicateEmailSequenceTemplate_emailSequenceTemplateDuplicate_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface DuplicateEmailSequenceTemplate_emailSequenceTemplateDuplicate_emailSequenceTemplate_parent_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface DuplicateEmailSequenceTemplate_emailSequenceTemplateDuplicate_emailSequenceTemplate_parent {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: DuplicateEmailSequenceTemplate_emailSequenceTemplateDuplicate_emailSequenceTemplate_parent_creatorUser;
}

export interface DuplicateEmailSequenceTemplate_emailSequenceTemplateDuplicate_emailSequenceTemplate_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface DuplicateEmailSequenceTemplate_emailSequenceTemplateDuplicate_emailSequenceTemplate_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: DuplicateEmailSequenceTemplate_emailSequenceTemplateDuplicate_emailSequenceTemplate_emailAutomation_entersStage_stageset;
}

export interface DuplicateEmailSequenceTemplate_emailSequenceTemplateDuplicate_emailSequenceTemplate_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: DuplicateEmailSequenceTemplate_emailSequenceTemplateDuplicate_emailSequenceTemplate_emailAutomation_entersStage;
}

export interface DuplicateEmailSequenceTemplate_emailSequenceTemplateDuplicate_emailSequenceTemplate_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DuplicateEmailSequenceTemplate_emailSequenceTemplateDuplicate_emailSequenceTemplate_emailSequenceTemplateMessages_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DuplicateEmailSequenceTemplate_emailSequenceTemplateDuplicate_emailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailTemplate: DuplicateEmailSequenceTemplate_emailSequenceTemplateDuplicate_emailSequenceTemplate_emailSequenceTemplateMessages_emailTemplate;
}

export interface DuplicateEmailSequenceTemplate_emailSequenceTemplateDuplicate_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  creatorUser: DuplicateEmailSequenceTemplate_emailSequenceTemplateDuplicate_emailSequenceTemplate_creatorUser;
  lastSentTime: any | null;
  isShared: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  /**
   * The parent sequence template of this child sequence template
   */
  parent: DuplicateEmailSequenceTemplate_emailSequenceTemplateDuplicate_emailSequenceTemplate_parent | null;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: DuplicateEmailSequenceTemplate_emailSequenceTemplateDuplicate_emailSequenceTemplate_emailAutomation | null;
  group: DuplicateEmailSequenceTemplate_emailSequenceTemplateDuplicate_emailSequenceTemplate_group | null;
  deletedTime: any | null;
  emailSequenceTemplateMessages: DuplicateEmailSequenceTemplate_emailSequenceTemplateDuplicate_emailSequenceTemplate_emailSequenceTemplateMessages[];
  replyRate: number | null;
  /**
   * The count of the sent sequences that got a reply
   */
  replyCount: number;
  clickRate: number | null;
  clickCount: number;
  /**
   * The count of the sequences that are still sending messages
   */
  inProgressCount: number;
  /**
   * The count of the sequences that finished sending
   */
  finishedCount: number;
  /**
   * The count of the sent sequences that were cancelled
   */
  cancelledCount: number;
  /**
   * The count of the sent sequences that have one or more emails with click tracking
   */
  startedWithClickTrackingCount: number;
}

export interface DuplicateEmailSequenceTemplate_emailSequenceTemplateDuplicate {
  __typename: "EmailSequenceTemplateDuplicatePayload";
  /**
   * The freshly duplicated email sequence template.
   */
  emailSequenceTemplate: DuplicateEmailSequenceTemplate_emailSequenceTemplateDuplicate_emailSequenceTemplate;
}

export interface DuplicateEmailSequenceTemplate {
  /**
   * Duplicates an email sequence template
   */
  emailSequenceTemplateDuplicate: DuplicateEmailSequenceTemplate_emailSequenceTemplateDuplicate;
}

export interface DuplicateEmailSequenceTemplateVariables {
  input: EmailSequenceTemplateDuplicateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateGroup
// ====================================================

export interface UpdateGroup_emailSequenceTemplateGroupUpdate_emailSequenceTemplateGroup {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateGroup_emailSequenceTemplateGroupUpdate {
  __typename: "EmailSequenceTemplateGroupUpdatePayload";
  /**
   * The updated email sequence template group
   */
  emailSequenceTemplateGroup: UpdateGroup_emailSequenceTemplateGroupUpdate_emailSequenceTemplateGroup;
}

export interface UpdateGroup {
  /**
   * Updates an email sequence template group
   */
  emailSequenceTemplateGroupUpdate: UpdateGroup_emailSequenceTemplateGroupUpdate;
}

export interface UpdateGroupVariables {
  input: EmailSequenceTemplateGroupUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEmailTemplateGroup
// ====================================================

export interface GetEmailTemplateGroup_emailSequenceTemplateGroup_emailSequenceTemplates_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface GetEmailTemplateGroup_emailSequenceTemplateGroup_emailSequenceTemplates_parent_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface GetEmailTemplateGroup_emailSequenceTemplateGroup_emailSequenceTemplates_parent {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: GetEmailTemplateGroup_emailSequenceTemplateGroup_emailSequenceTemplates_parent_creatorUser;
}

export interface GetEmailTemplateGroup_emailSequenceTemplateGroup_emailSequenceTemplates_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetEmailTemplateGroup_emailSequenceTemplateGroup_emailSequenceTemplates_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: GetEmailTemplateGroup_emailSequenceTemplateGroup_emailSequenceTemplates_emailAutomation_entersStage_stageset;
}

export interface GetEmailTemplateGroup_emailSequenceTemplateGroup_emailSequenceTemplates_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: GetEmailTemplateGroup_emailSequenceTemplateGroup_emailSequenceTemplates_emailAutomation_entersStage;
}

export interface GetEmailTemplateGroup_emailSequenceTemplateGroup_emailSequenceTemplates_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEmailTemplateGroup_emailSequenceTemplateGroup_emailSequenceTemplates_emailSequenceTemplateMessages_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEmailTemplateGroup_emailSequenceTemplateGroup_emailSequenceTemplates_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailTemplate: GetEmailTemplateGroup_emailSequenceTemplateGroup_emailSequenceTemplates_emailSequenceTemplateMessages_emailTemplate;
}

export interface GetEmailTemplateGroup_emailSequenceTemplateGroup_emailSequenceTemplates {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  creatorUser: GetEmailTemplateGroup_emailSequenceTemplateGroup_emailSequenceTemplates_creatorUser;
  lastSentTime: any | null;
  isShared: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  /**
   * The parent sequence template of this child sequence template
   */
  parent: GetEmailTemplateGroup_emailSequenceTemplateGroup_emailSequenceTemplates_parent | null;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: GetEmailTemplateGroup_emailSequenceTemplateGroup_emailSequenceTemplates_emailAutomation | null;
  group: GetEmailTemplateGroup_emailSequenceTemplateGroup_emailSequenceTemplates_group | null;
  deletedTime: any | null;
  emailSequenceTemplateMessages: GetEmailTemplateGroup_emailSequenceTemplateGroup_emailSequenceTemplates_emailSequenceTemplateMessages[];
  replyRate: number | null;
  /**
   * The count of the sent sequences that got a reply
   */
  replyCount: number;
  clickRate: number | null;
  clickCount: number;
  /**
   * The count of the sequences that are still sending messages
   */
  inProgressCount: number;
  /**
   * The count of the sequences that finished sending
   */
  finishedCount: number;
  /**
   * The count of the sent sequences that were cancelled
   */
  cancelledCount: number;
  /**
   * The count of the sent sequences that have one or more emails with click tracking
   */
  startedWithClickTrackingCount: number;
}

export interface GetEmailTemplateGroup_emailSequenceTemplateGroup {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailSequenceTemplates: GetEmailTemplateGroup_emailSequenceTemplateGroup_emailSequenceTemplates[];
}

export interface GetEmailTemplateGroup {
  /**
   * Returns the email sequence template group
   */
  emailSequenceTemplateGroup: GetEmailTemplateGroup_emailSequenceTemplateGroup;
}

export interface GetEmailTemplateGroupVariables {
  id: string;
  creatorIds?: string[] | null;
  search?: string | null;
  onlyArchived?: boolean | null;
  includeShared?: boolean | null;
  includeUnsharedFromOthers?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEmailTemplateGroups
// ====================================================

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_groups_emailSequenceTemplates_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_groups_emailSequenceTemplates_parent_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_groups_emailSequenceTemplates_parent {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: GetEmailTemplateGroups_emailSequenceTemplateGroups_groups_emailSequenceTemplates_parent_creatorUser;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_groups_emailSequenceTemplates_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_groups_emailSequenceTemplates_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: GetEmailTemplateGroups_emailSequenceTemplateGroups_groups_emailSequenceTemplates_emailAutomation_entersStage_stageset;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_groups_emailSequenceTemplates_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: GetEmailTemplateGroups_emailSequenceTemplateGroups_groups_emailSequenceTemplates_emailAutomation_entersStage;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_groups_emailSequenceTemplates_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_groups_emailSequenceTemplates_emailSequenceTemplateMessages_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_groups_emailSequenceTemplates_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailTemplate: GetEmailTemplateGroups_emailSequenceTemplateGroups_groups_emailSequenceTemplates_emailSequenceTemplateMessages_emailTemplate;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_groups_emailSequenceTemplates {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  creatorUser: GetEmailTemplateGroups_emailSequenceTemplateGroups_groups_emailSequenceTemplates_creatorUser;
  lastSentTime: any | null;
  isShared: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  /**
   * The parent sequence template of this child sequence template
   */
  parent: GetEmailTemplateGroups_emailSequenceTemplateGroups_groups_emailSequenceTemplates_parent | null;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: GetEmailTemplateGroups_emailSequenceTemplateGroups_groups_emailSequenceTemplates_emailAutomation | null;
  group: GetEmailTemplateGroups_emailSequenceTemplateGroups_groups_emailSequenceTemplates_group | null;
  deletedTime: any | null;
  emailSequenceTemplateMessages: GetEmailTemplateGroups_emailSequenceTemplateGroups_groups_emailSequenceTemplates_emailSequenceTemplateMessages[];
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_groups {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  position: number;
  canRename: boolean;
  canArchive: boolean;
  emailSequenceTemplates: GetEmailTemplateGroups_emailSequenceTemplateGroups_groups_emailSequenceTemplates[];
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_uncategorized_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_uncategorized_parent_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_uncategorized_parent {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: GetEmailTemplateGroups_emailSequenceTemplateGroups_uncategorized_parent_creatorUser;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_uncategorized_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_uncategorized_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: GetEmailTemplateGroups_emailSequenceTemplateGroups_uncategorized_emailAutomation_entersStage_stageset;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_uncategorized_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: GetEmailTemplateGroups_emailSequenceTemplateGroups_uncategorized_emailAutomation_entersStage;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_uncategorized_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_uncategorized_emailSequenceTemplateMessages_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_uncategorized_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailTemplate: GetEmailTemplateGroups_emailSequenceTemplateGroups_uncategorized_emailSequenceTemplateMessages_emailTemplate;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_uncategorized {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  creatorUser: GetEmailTemplateGroups_emailSequenceTemplateGroups_uncategorized_creatorUser;
  lastSentTime: any | null;
  isShared: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  /**
   * The parent sequence template of this child sequence template
   */
  parent: GetEmailTemplateGroups_emailSequenceTemplateGroups_uncategorized_parent | null;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: GetEmailTemplateGroups_emailSequenceTemplateGroups_uncategorized_emailAutomation | null;
  group: GetEmailTemplateGroups_emailSequenceTemplateGroups_uncategorized_group | null;
  deletedTime: any | null;
  emailSequenceTemplateMessages: GetEmailTemplateGroups_emailSequenceTemplateGroups_uncategorized_emailSequenceTemplateMessages[];
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_recentlySent_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_recentlySent_parent_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_recentlySent_parent {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: GetEmailTemplateGroups_emailSequenceTemplateGroups_recentlySent_parent_creatorUser;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_recentlySent_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_recentlySent_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: GetEmailTemplateGroups_emailSequenceTemplateGroups_recentlySent_emailAutomation_entersStage_stageset;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_recentlySent_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: GetEmailTemplateGroups_emailSequenceTemplateGroups_recentlySent_emailAutomation_entersStage;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_recentlySent_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_recentlySent_emailSequenceTemplateMessages_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_recentlySent_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailTemplate: GetEmailTemplateGroups_emailSequenceTemplateGroups_recentlySent_emailSequenceTemplateMessages_emailTemplate;
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups_recentlySent {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  creatorUser: GetEmailTemplateGroups_emailSequenceTemplateGroups_recentlySent_creatorUser;
  lastSentTime: any | null;
  isShared: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  /**
   * The parent sequence template of this child sequence template
   */
  parent: GetEmailTemplateGroups_emailSequenceTemplateGroups_recentlySent_parent | null;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: GetEmailTemplateGroups_emailSequenceTemplateGroups_recentlySent_emailAutomation | null;
  group: GetEmailTemplateGroups_emailSequenceTemplateGroups_recentlySent_group | null;
  deletedTime: any | null;
  emailSequenceTemplateMessages: GetEmailTemplateGroups_emailSequenceTemplateGroups_recentlySent_emailSequenceTemplateMessages[];
}

export interface GetEmailTemplateGroups_emailSequenceTemplateGroups {
  __typename: "EmailSequenceTemplateGroups";
  groups: GetEmailTemplateGroups_emailSequenceTemplateGroups_groups[];
  uncategorized: GetEmailTemplateGroups_emailSequenceTemplateGroups_uncategorized[];
  recentlySent: GetEmailTemplateGroups_emailSequenceTemplateGroups_recentlySent[];
}

export interface GetEmailTemplateGroups {
  /**
   * Returns the email sequence template groups, as well as an uncategorized group and a recently sent group
   */
  emailSequenceTemplateGroups: GetEmailTemplateGroups_emailSequenceTemplateGroups;
}

export interface GetEmailTemplateGroupsVariables {
  creatorIds?: string[] | null;
  onlyArchived?: boolean | null;
  includeShared?: boolean | null;
  search?: string | null;
  includeUnsharedFromOthers?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUncategorizedEmailSequenceTemplates
// ====================================================

export interface GetUncategorizedEmailSequenceTemplates_emailSequenceTemplateGroups_uncategorized_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface GetUncategorizedEmailSequenceTemplates_emailSequenceTemplateGroups_uncategorized_parent_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface GetUncategorizedEmailSequenceTemplates_emailSequenceTemplateGroups_uncategorized_parent {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: GetUncategorizedEmailSequenceTemplates_emailSequenceTemplateGroups_uncategorized_parent_creatorUser;
}

export interface GetUncategorizedEmailSequenceTemplates_emailSequenceTemplateGroups_uncategorized_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetUncategorizedEmailSequenceTemplates_emailSequenceTemplateGroups_uncategorized_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: GetUncategorizedEmailSequenceTemplates_emailSequenceTemplateGroups_uncategorized_emailAutomation_entersStage_stageset;
}

export interface GetUncategorizedEmailSequenceTemplates_emailSequenceTemplateGroups_uncategorized_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: GetUncategorizedEmailSequenceTemplates_emailSequenceTemplateGroups_uncategorized_emailAutomation_entersStage;
}

export interface GetUncategorizedEmailSequenceTemplates_emailSequenceTemplateGroups_uncategorized_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetUncategorizedEmailSequenceTemplates_emailSequenceTemplateGroups_uncategorized_emailSequenceTemplateMessages_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetUncategorizedEmailSequenceTemplates_emailSequenceTemplateGroups_uncategorized_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailTemplate: GetUncategorizedEmailSequenceTemplates_emailSequenceTemplateGroups_uncategorized_emailSequenceTemplateMessages_emailTemplate;
}

export interface GetUncategorizedEmailSequenceTemplates_emailSequenceTemplateGroups_uncategorized {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  creatorUser: GetUncategorizedEmailSequenceTemplates_emailSequenceTemplateGroups_uncategorized_creatorUser;
  lastSentTime: any | null;
  isShared: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  /**
   * The parent sequence template of this child sequence template
   */
  parent: GetUncategorizedEmailSequenceTemplates_emailSequenceTemplateGroups_uncategorized_parent | null;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: GetUncategorizedEmailSequenceTemplates_emailSequenceTemplateGroups_uncategorized_emailAutomation | null;
  group: GetUncategorizedEmailSequenceTemplates_emailSequenceTemplateGroups_uncategorized_group | null;
  deletedTime: any | null;
  emailSequenceTemplateMessages: GetUncategorizedEmailSequenceTemplates_emailSequenceTemplateGroups_uncategorized_emailSequenceTemplateMessages[];
  replyRate: number | null;
  /**
   * The count of the sent sequences that got a reply
   */
  replyCount: number;
  clickRate: number | null;
  clickCount: number;
  /**
   * The count of the sequences that are still sending messages
   */
  inProgressCount: number;
  /**
   * The count of the sequences that finished sending
   */
  finishedCount: number;
  /**
   * The count of the sent sequences that were cancelled
   */
  cancelledCount: number;
  /**
   * The count of the sent sequences that have one or more emails with click tracking
   */
  startedWithClickTrackingCount: number;
}

export interface GetUncategorizedEmailSequenceTemplates_emailSequenceTemplateGroups {
  __typename: "EmailSequenceTemplateGroups";
  uncategorized: GetUncategorizedEmailSequenceTemplates_emailSequenceTemplateGroups_uncategorized[];
}

export interface GetUncategorizedEmailSequenceTemplates {
  /**
   * Returns the email sequence template groups, as well as an uncategorized group and a recently sent group
   */
  emailSequenceTemplateGroups: GetUncategorizedEmailSequenceTemplates_emailSequenceTemplateGroups;
}

export interface GetUncategorizedEmailSequenceTemplatesVariables {
  creatorIds?: string[] | null;
  onlyArchived?: boolean | null;
  includeShared?: boolean | null;
  search?: string | null;
  includeUnsharedFromOthers?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactFormSubmissions
// ====================================================

export interface GetContactFormSubmissions_contact_submissions_edges_node_formVersion_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetContactFormSubmissions_contact_submissions_edges_node_formVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent form of this form version
   */
  form: GetContactFormSubmissions_contact_submissions_edges_node_formVersion_form;
}

export interface GetContactFormSubmissions_contact_submissions_edges_node_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface GetContactFormSubmissions_contact_submissions_edges_node_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
}

export interface GetContactFormSubmissions_contact_submissions_edges_node_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface GetContactFormSubmissions_contact_submissions_edges_node_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export type GetContactFormSubmissions_contact_submissions_edges_node_fields_edges_fieldValue = GetContactFormSubmissions_contact_submissions_edges_node_fields_edges_fieldValue_FormFieldSubmissionValueSubfields | GetContactFormSubmissions_contact_submissions_edges_node_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | GetContactFormSubmissions_contact_submissions_edges_node_fields_edges_fieldValue_FormFieldSubmissionValueSingle;

export interface GetContactFormSubmissions_contact_submissions_edges_node_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: GetContactFormSubmissions_contact_submissions_edges_node_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: GetContactFormSubmissions_contact_submissions_edges_node_fields_edges_fieldValue | null;
}

export interface GetContactFormSubmissions_contact_submissions_edges_node_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: GetContactFormSubmissions_contact_submissions_edges_node_fields_edges[];
}

export interface GetContactFormSubmissions_contact_submissions_edges_node {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the submitted web form
   */
  formVersion: GetContactFormSubmissions_contact_submissions_edges_node_formVersion;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The url where the submission originates
   */
  submissionUrl: string;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: GetContactFormSubmissions_contact_submissions_edges_node_fields;
}

export interface GetContactFormSubmissions_contact_submissions_edges {
  __typename: "SubmissionEdge";
  node: GetContactFormSubmissions_contact_submissions_edges_node;
}

export interface GetContactFormSubmissions_contact_submissions {
  __typename: "SubmissionsConnection";
  /**
   * A list of edges.
   */
  edges: GetContactFormSubmissions_contact_submissions_edges[];
}

export interface GetContactFormSubmissions_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
  avatarUrl: string;
  /**
   * Submissions related to this peep
   */
  submissions: GetContactFormSubmissions_contact_submissions;
}

export interface GetContactFormSubmissions {
  /**
   * Returns a Nutshell Contact
   */
  contact: GetContactFormSubmissions_contact | null;
}

export interface GetContactFormSubmissionsVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPeepEngagementStats
// ====================================================

export interface GetPeepEngagementStats_peep_Account_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
}

export interface GetPeepEngagementStats_peep_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * Returns a Nutshell engagement rating of 0-5 stars
   */
  engagementRating: number;
  engagementStats: GetPeepEngagementStats_peep_Account_engagementStats;
}

export interface GetPeepEngagementStats_peep_Contact_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
}

export interface GetPeepEngagementStats_peep_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * Returns a Nutshell engagement rating of 0-5 stars
   */
  engagementRating: number;
  engagementStats: GetPeepEngagementStats_peep_Contact_engagementStats;
  /**
   * Boolean if the contact has hard bounced
   */
  hasHardBounced: boolean;
}

export type GetPeepEngagementStats_peep = GetPeepEngagementStats_peep_Account | GetPeepEngagementStats_peep_Contact;

export interface GetPeepEngagementStats {
  /**
   * Returns a Nutshell peep
   */
  peep: GetPeepEngagementStats_peep;
}

export interface GetPeepEngagementStatsVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPeepRelatedLeadCards
// ====================================================

export interface GetPeepRelatedLeadCards_peep_leads_edges_node_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetPeepRelatedLeadCards_peep_leads_edges_node_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetPeepRelatedLeadCards_peep_leads_edges_node_value_formattedValue;
}

export interface GetPeepRelatedLeadCards_peep_leads_edges_node_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetPeepRelatedLeadCards_peep_leads_edges_node_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetPeepRelatedLeadCards_peep_leads_edges_node_contacts_primaryEdge_node;
}

export interface GetPeepRelatedLeadCards_peep_leads_edges_node_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPeepRelatedLeadCards_peep_leads_edges_node_contacts_primaryEdge | null;
}

export interface GetPeepRelatedLeadCards_peep_leads_edges_node_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetPeepRelatedLeadCards_peep_leads_edges_node_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetPeepRelatedLeadCards_peep_leads_edges_node_accounts_primaryEdge_node;
}

export interface GetPeepRelatedLeadCards_peep_leads_edges_node_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPeepRelatedLeadCards_peep_leads_edges_node_accounts_primaryEdge | null;
}

export interface GetPeepRelatedLeadCards_peep_leads_edges_node_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
}

export interface GetPeepRelatedLeadCards_peep_leads_edges_node {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: GetPeepRelatedLeadCards_peep_leads_edges_node_value | null;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  /**
   * The time this lead did or will become overdue
   */
  overdueTime: any | null;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  avatarUrl: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetPeepRelatedLeadCards_peep_leads_edges_node_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetPeepRelatedLeadCards_peep_leads_edges_node_accounts;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetPeepRelatedLeadCards_peep_leads_edges_node_assignee | null;
}

export interface GetPeepRelatedLeadCards_peep_leads_edges {
  __typename: "PeepLeadsEdge";
  node: GetPeepRelatedLeadCards_peep_leads_edges_node;
}

export interface GetPeepRelatedLeadCards_peep_leads {
  __typename: "PeepLeadsConnection";
  /**
   * A list of edges.
   */
  edges: GetPeepRelatedLeadCards_peep_leads_edges[];
}

export interface GetPeepRelatedLeadCards_peep_childLeads_edges_node_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetPeepRelatedLeadCards_peep_childLeads_edges_node_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetPeepRelatedLeadCards_peep_childLeads_edges_node_value_formattedValue;
}

export interface GetPeepRelatedLeadCards_peep_childLeads_edges_node_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetPeepRelatedLeadCards_peep_childLeads_edges_node_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetPeepRelatedLeadCards_peep_childLeads_edges_node_contacts_primaryEdge_node;
}

export interface GetPeepRelatedLeadCards_peep_childLeads_edges_node_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPeepRelatedLeadCards_peep_childLeads_edges_node_contacts_primaryEdge | null;
}

export interface GetPeepRelatedLeadCards_peep_childLeads_edges_node_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetPeepRelatedLeadCards_peep_childLeads_edges_node_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetPeepRelatedLeadCards_peep_childLeads_edges_node_accounts_primaryEdge_node;
}

export interface GetPeepRelatedLeadCards_peep_childLeads_edges_node_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPeepRelatedLeadCards_peep_childLeads_edges_node_accounts_primaryEdge | null;
}

export interface GetPeepRelatedLeadCards_peep_childLeads_edges_node_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
}

export interface GetPeepRelatedLeadCards_peep_childLeads_edges_node {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: GetPeepRelatedLeadCards_peep_childLeads_edges_node_value | null;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  /**
   * The time this lead did or will become overdue
   */
  overdueTime: any | null;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  avatarUrl: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetPeepRelatedLeadCards_peep_childLeads_edges_node_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetPeepRelatedLeadCards_peep_childLeads_edges_node_accounts;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetPeepRelatedLeadCards_peep_childLeads_edges_node_assignee | null;
}

export interface GetPeepRelatedLeadCards_peep_childLeads_edges {
  __typename: "PeepLeadsEdge";
  node: GetPeepRelatedLeadCards_peep_childLeads_edges_node;
}

export interface GetPeepRelatedLeadCards_peep_childLeads {
  __typename: "PeepLeadsConnection";
  /**
   * A list of edges.
   */
  edges: GetPeepRelatedLeadCards_peep_childLeads_edges[];
}

export interface GetPeepRelatedLeadCards_peep {
  __typename: "Account" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * Leads related to this peep
   */
  leads: GetPeepRelatedLeadCards_peep_leads;
  /**
   * Leads related to this peeps children (for accounts, else null)
   */
  childLeads: GetPeepRelatedLeadCards_peep_childLeads;
}

export interface GetPeepRelatedLeadCards {
  /**
   * Returns a Nutshell peep
   */
  peep: GetPeepRelatedLeadCards_peep;
}

export interface GetPeepRelatedLeadCardsVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPeepRelatedLeadStats
// ====================================================

export interface GetPeepRelatedLeadStats_peep_Account_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetPeepRelatedLeadStats_peep_Account_phones_primary {
  __typename: "Phone";
  value: GetPeepRelatedLeadStats_peep_Account_phones_primary_value;
}

export interface GetPeepRelatedLeadStats_peep_Account_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPeepRelatedLeadStats_peep_Account_phones_primary | null;
}

export interface GetPeepRelatedLeadStats_peep_Account_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface GetPeepRelatedLeadStats_peep_Account_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetPeepRelatedLeadStats_peep_Account_emailAddresses_primary_value;
}

export interface GetPeepRelatedLeadStats_peep_Account_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPeepRelatedLeadStats_peep_Account_emailAddresses_primary | null;
}

export interface GetPeepRelatedLeadStats_peep_Account_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  region: string | null;
}

export interface GetPeepRelatedLeadStats_peep_Account_postalAddresses_primary {
  __typename: "PostalAddress";
  value: GetPeepRelatedLeadStats_peep_Account_postalAddresses_primary_value;
}

export interface GetPeepRelatedLeadStats_peep_Account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPeepRelatedLeadStats_peep_Account_postalAddresses_primary | null;
}

export interface GetPeepRelatedLeadStats_peep_Account_leads_stats_all_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetPeepRelatedLeadStats_peep_Account_leads_stats_all_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetPeepRelatedLeadStats_peep_Account_leads_stats_all_value_formattedValue;
}

export interface GetPeepRelatedLeadStats_peep_Account_leads_stats_all {
  __typename: "LeadStat";
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  count: number;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  status: LeadStatus;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  value: GetPeepRelatedLeadStats_peep_Account_leads_stats_all_value;
}

export interface GetPeepRelatedLeadStats_peep_Account_leads_stats {
  __typename: "LeadStats";
  /**
   * All the stats, boi
   */
  all: GetPeepRelatedLeadStats_peep_Account_leads_stats_all[];
}

export interface GetPeepRelatedLeadStats_peep_Account_leads {
  __typename: "PeepLeadsConnection";
  /**
   * Statistics about this peep’s related leads
   */
  stats: GetPeepRelatedLeadStats_peep_Account_leads_stats;
}

export interface GetPeepRelatedLeadStats_peep_Account_childLeads_subsidiaryStats_all_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetPeepRelatedLeadStats_peep_Account_childLeads_subsidiaryStats_all_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetPeepRelatedLeadStats_peep_Account_childLeads_subsidiaryStats_all_value_formattedValue;
}

export interface GetPeepRelatedLeadStats_peep_Account_childLeads_subsidiaryStats_all {
  __typename: "LeadStat";
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  count: number;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  status: LeadStatus;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  value: GetPeepRelatedLeadStats_peep_Account_childLeads_subsidiaryStats_all_value;
}

export interface GetPeepRelatedLeadStats_peep_Account_childLeads_subsidiaryStats {
  __typename: "LeadStats";
  /**
   * All the stats, boi
   */
  all: GetPeepRelatedLeadStats_peep_Account_childLeads_subsidiaryStats_all[];
}

export interface GetPeepRelatedLeadStats_peep_Account_childLeads {
  __typename: "PeepLeadsConnection";
  /**
   * Statistics about this peep’s related leads
   */
  subsidiaryStats: GetPeepRelatedLeadStats_peep_Account_childLeads_subsidiaryStats | null;
}

export interface GetPeepRelatedLeadStats_peep_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  avatarUrl: string;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetPeepRelatedLeadStats_peep_Account_phones;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetPeepRelatedLeadStats_peep_Account_emailAddresses;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetPeepRelatedLeadStats_peep_Account_postalAddresses;
  /**
   * Leads related to this peep
   */
  leads: GetPeepRelatedLeadStats_peep_Account_leads;
  /**
   * Leads related to this peeps children (for accounts, else null)
   */
  childLeads: GetPeepRelatedLeadStats_peep_Account_childLeads;
}

export interface GetPeepRelatedLeadStats_peep_Contact_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetPeepRelatedLeadStats_peep_Contact_phones_primary {
  __typename: "Phone";
  value: GetPeepRelatedLeadStats_peep_Contact_phones_primary_value;
}

export interface GetPeepRelatedLeadStats_peep_Contact_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPeepRelatedLeadStats_peep_Contact_phones_primary | null;
}

export interface GetPeepRelatedLeadStats_peep_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface GetPeepRelatedLeadStats_peep_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetPeepRelatedLeadStats_peep_Contact_emailAddresses_primary_value;
}

export interface GetPeepRelatedLeadStats_peep_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPeepRelatedLeadStats_peep_Contact_emailAddresses_primary | null;
}

export interface GetPeepRelatedLeadStats_peep_Contact_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  region: string | null;
}

export interface GetPeepRelatedLeadStats_peep_Contact_postalAddresses_primary {
  __typename: "PostalAddress";
  value: GetPeepRelatedLeadStats_peep_Contact_postalAddresses_primary_value;
}

export interface GetPeepRelatedLeadStats_peep_Contact_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPeepRelatedLeadStats_peep_Contact_postalAddresses_primary | null;
}

export interface GetPeepRelatedLeadStats_peep_Contact_leads_stats_all_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetPeepRelatedLeadStats_peep_Contact_leads_stats_all_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetPeepRelatedLeadStats_peep_Contact_leads_stats_all_value_formattedValue;
}

export interface GetPeepRelatedLeadStats_peep_Contact_leads_stats_all {
  __typename: "LeadStat";
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  count: number;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  status: LeadStatus;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  value: GetPeepRelatedLeadStats_peep_Contact_leads_stats_all_value;
}

export interface GetPeepRelatedLeadStats_peep_Contact_leads_stats {
  __typename: "LeadStats";
  /**
   * All the stats, boi
   */
  all: GetPeepRelatedLeadStats_peep_Contact_leads_stats_all[];
}

export interface GetPeepRelatedLeadStats_peep_Contact_leads {
  __typename: "PeepLeadsConnection";
  /**
   * Statistics about this peep’s related leads
   */
  stats: GetPeepRelatedLeadStats_peep_Contact_leads_stats;
}

export interface GetPeepRelatedLeadStats_peep_Contact_childLeads_subsidiaryStats_all_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetPeepRelatedLeadStats_peep_Contact_childLeads_subsidiaryStats_all_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetPeepRelatedLeadStats_peep_Contact_childLeads_subsidiaryStats_all_value_formattedValue;
}

export interface GetPeepRelatedLeadStats_peep_Contact_childLeads_subsidiaryStats_all {
  __typename: "LeadStat";
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  count: number;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  status: LeadStatus;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  value: GetPeepRelatedLeadStats_peep_Contact_childLeads_subsidiaryStats_all_value;
}

export interface GetPeepRelatedLeadStats_peep_Contact_childLeads_subsidiaryStats {
  __typename: "LeadStats";
  /**
   * All the stats, boi
   */
  all: GetPeepRelatedLeadStats_peep_Contact_childLeads_subsidiaryStats_all[];
}

export interface GetPeepRelatedLeadStats_peep_Contact_childLeads {
  __typename: "PeepLeadsConnection";
  /**
   * Statistics about this peep’s related leads
   */
  subsidiaryStats: GetPeepRelatedLeadStats_peep_Contact_childLeads_subsidiaryStats | null;
}

export interface GetPeepRelatedLeadStats_peep_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  avatarUrl: string;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetPeepRelatedLeadStats_peep_Contact_phones;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetPeepRelatedLeadStats_peep_Contact_emailAddresses;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetPeepRelatedLeadStats_peep_Contact_postalAddresses;
  /**
   * Leads related to this peep
   */
  leads: GetPeepRelatedLeadStats_peep_Contact_leads;
  /**
   * Leads related to this peeps children (for accounts, else null)
   */
  childLeads: GetPeepRelatedLeadStats_peep_Contact_childLeads;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
}

export type GetPeepRelatedLeadStats_peep = GetPeepRelatedLeadStats_peep_Account | GetPeepRelatedLeadStats_peep_Contact;

export interface GetPeepRelatedLeadStats {
  /**
   * Returns a Nutshell peep
   */
  peep: GetPeepRelatedLeadStats_peep;
}

export interface GetPeepRelatedLeadStatsVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPeepSendToDestinations
// ====================================================

export interface GetPeepSendToDestinations_peep_Account_sendToDestinations {
  __typename: "EntityDestination";
  /**
   * The URL this destination should direct to.
   */
  localUrl: string;
  /**
   * The descriptive name for this destination.
   */
  name: string;
}

export interface GetPeepSendToDestinations_peep_Account_externalResources {
  __typename: "ExternalResource";
  /**
   * The name of the external service this resource belongs to.
   */
  externalService: ExternalService;
  /**
   * The type of external resource.
   */
  externalResourceType: ExternalResourceType;
  /**
   * The ID of the external resource.
   */
  externalId: string;
}

export interface GetPeepSendToDestinations_peep_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Is this entity deleted
   */
  isDeleted: boolean;
  /**
   * The list of destinations for this peep
   */
  sendToDestinations: GetPeepSendToDestinations_peep_Account_sendToDestinations[];
  /**
   * External resources mapped to this peep
   */
  externalResources: GetPeepSendToDestinations_peep_Account_externalResources[];
}

export interface GetPeepSendToDestinations_peep_Contact_sendToDestinations {
  __typename: "EntityDestination";
  /**
   * The URL this destination should direct to.
   */
  localUrl: string;
  /**
   * The descriptive name for this destination.
   */
  name: string;
}

export interface GetPeepSendToDestinations_peep_Contact_externalResources {
  __typename: "ExternalResource";
  /**
   * The name of the external service this resource belongs to.
   */
  externalService: ExternalService;
  /**
   * The type of external resource.
   */
  externalResourceType: ExternalResourceType;
  /**
   * The ID of the external resource.
   */
  externalId: string;
}

export interface GetPeepSendToDestinations_peep_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
  formatted: string;
}

export interface GetPeepSendToDestinations_peep_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  isPrimary: boolean;
  value: GetPeepSendToDestinations_peep_Contact_emailAddresses_primary_value;
}

export interface GetPeepSendToDestinations_peep_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPeepSendToDestinations_peep_Contact_emailAddresses_primary | null;
}

export interface GetPeepSendToDestinations_peep_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Is this entity deleted
   */
  isDeleted: boolean;
  /**
   * The list of destinations for this peep
   */
  sendToDestinations: GetPeepSendToDestinations_peep_Contact_sendToDestinations[];
  /**
   * External resources mapped to this peep
   */
  externalResources: GetPeepSendToDestinations_peep_Contact_externalResources[];
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetPeepSendToDestinations_peep_Contact_emailAddresses;
}

export type GetPeepSendToDestinations_peep = GetPeepSendToDestinations_peep_Account | GetPeepSendToDestinations_peep_Contact;

export interface GetPeepSendToDestinations {
  /**
   * Returns a Nutshell peep
   */
  peep: GetPeepSendToDestinations_peep;
}

export interface GetPeepSendToDestinationsVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateAccountInfo
// ====================================================

export interface UpdateAccountInfo_accountUpdate_account_territory {
  __typename: "Territory";
  id: string | null;
}

export interface UpdateAccountInfo_accountUpdate_account_revenue_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface UpdateAccountInfo_accountUpdate_account_revenue {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: UpdateAccountInfo_accountUpdate_account_revenue_currencyValue;
}

export interface UpdateAccountInfo_accountUpdate_account_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateAccountInfo_accountUpdate_account_industry {
  __typename: "NutshellIndustry";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateAccountInfo_accountUpdate_account_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateAccountInfo_accountUpdate_account_tags_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateAccountInfo_accountUpdate_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: UpdateAccountInfo_accountUpdate_account_tags_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface UpdateAccountInfo_accountUpdate_account_tagMaps_edges_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateAccountInfo_accountUpdate_account_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateAccountInfo_accountUpdate_account_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: UpdateAccountInfo_accountUpdate_account_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface UpdateAccountInfo_accountUpdate_account_tagMaps_edges {
  __typename: "TagMapsEdge";
  /**
   * The creator of this tag map
   */
  creator: UpdateAccountInfo_accountUpdate_account_tagMaps_edges_creator | null;
  /**
   * The DateTime that represents when the Tag was mapped
   */
  createdTime: any | null;
  node: UpdateAccountInfo_accountUpdate_account_tagMaps_edges_node | null;
}

export interface UpdateAccountInfo_accountUpdate_account_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: UpdateAccountInfo_accountUpdate_account_tagMaps_edges[];
}

export interface UpdateAccountInfo_accountUpdate_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The terrority to which this peep is assigned.
   */
  territory: UpdateAccountInfo_accountUpdate_account_territory | null;
  /**
   * The number of people employed by this company
   */
  employeeCount: string | null;
  revenue: UpdateAccountInfo_accountUpdate_account_revenue | null;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: UpdateAccountInfo_accountUpdate_account_owner | null;
  /**
   * The industry of this account
   */
  industry: UpdateAccountInfo_accountUpdate_account_industry | null;
  /**
   * The type assigned to this account
   */
  accountType: UpdateAccountInfo_accountUpdate_account_accountType;
  /**
   * Tags associated with the given peep
   */
  tags: UpdateAccountInfo_accountUpdate_account_tags[];
  /**
   * Tag maps for the peep
   */
  tagMaps: UpdateAccountInfo_accountUpdate_account_tagMaps | null;
}

export interface UpdateAccountInfo_accountUpdate {
  __typename: "AccountUpdatePayload";
  /**
   * The updated Nutshell Account
   */
  account: UpdateAccountInfo_accountUpdate_account;
}

export interface UpdateAccountInfo {
  /**
   * Updates an account
   */
  accountUpdate: UpdateAccountInfo_accountUpdate;
}

export interface UpdateAccountInfoVariables {
  input: AccountUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountInfo
// ====================================================

export interface GetAccountInfo_account_territory {
  __typename: "Territory";
  id: string | null;
}

export interface GetAccountInfo_account_revenue_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface GetAccountInfo_account_revenue {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: GetAccountInfo_account_revenue_currencyValue;
}

export interface GetAccountInfo_account_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetAccountInfo_account_industry {
  __typename: "NutshellIndustry";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetAccountInfo_account_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetAccountInfo_account_tags_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetAccountInfo_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: GetAccountInfo_account_tags_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface GetAccountInfo_account_tagMaps_edges_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetAccountInfo_account_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetAccountInfo_account_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: GetAccountInfo_account_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface GetAccountInfo_account_tagMaps_edges {
  __typename: "TagMapsEdge";
  /**
   * The creator of this tag map
   */
  creator: GetAccountInfo_account_tagMaps_edges_creator | null;
  /**
   * The DateTime that represents when the Tag was mapped
   */
  createdTime: any | null;
  node: GetAccountInfo_account_tagMaps_edges_node | null;
}

export interface GetAccountInfo_account_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetAccountInfo_account_tagMaps_edges[];
}

export interface GetAccountInfo_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The terrority to which this peep is assigned.
   */
  territory: GetAccountInfo_account_territory | null;
  /**
   * The number of people employed by this company
   */
  employeeCount: string | null;
  revenue: GetAccountInfo_account_revenue | null;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: GetAccountInfo_account_owner | null;
  /**
   * The industry of this account
   */
  industry: GetAccountInfo_account_industry | null;
  /**
   * The type assigned to this account
   */
  accountType: GetAccountInfo_account_accountType;
  /**
   * Tags associated with the given peep
   */
  tags: GetAccountInfo_account_tags[];
  /**
   * Tag maps for the peep
   */
  tagMaps: GetAccountInfo_account_tagMaps | null;
}

export interface GetAccountInfo {
  /**
   * Returns a Nutshell Account
   */
  account: GetAccountInfo_account | null;
}

export interface GetAccountInfoVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateContactInfo
// ====================================================

export interface UpdateContactInfo_contactUpdate_contact_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateContactInfo_contactUpdate_contact_territory {
  __typename: "Territory";
  id: string | null;
}

export interface UpdateContactInfo_contactUpdate_contact_tags_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateContactInfo_contactUpdate_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: UpdateContactInfo_contactUpdate_contact_tags_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface UpdateContactInfo_contactUpdate_contact_tagMaps_edges_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateContactInfo_contactUpdate_contact_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateContactInfo_contactUpdate_contact_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: UpdateContactInfo_contactUpdate_contact_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface UpdateContactInfo_contactUpdate_contact_tagMaps_edges {
  __typename: "TagMapsEdge";
  /**
   * The creator of this tag map
   */
  creator: UpdateContactInfo_contactUpdate_contact_tagMaps_edges_creator | null;
  /**
   * The DateTime that represents when the Tag was mapped
   */
  createdTime: any | null;
  node: UpdateContactInfo_contactUpdate_contact_tagMaps_edges_node | null;
}

export interface UpdateContactInfo_contactUpdate_contact_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: UpdateContactInfo_contactUpdate_contact_tagMaps_edges[];
}

export interface UpdateContactInfo_contactUpdate_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: UpdateContactInfo_contactUpdate_contact_owner | null;
  /**
   * The terrority to which this peep is assigned.
   */
  territory: UpdateContactInfo_contactUpdate_contact_territory | null;
  /**
   * Tags associated with the given peep
   */
  tags: UpdateContactInfo_contactUpdate_contact_tags[];
  /**
   * Tag maps for the peep
   */
  tagMaps: UpdateContactInfo_contactUpdate_contact_tagMaps | null;
}

export interface UpdateContactInfo_contactUpdate {
  __typename: "ContactUpdatePayload";
  /**
   * The updated Nutshell contact.
   */
  contact: UpdateContactInfo_contactUpdate_contact;
}

export interface UpdateContactInfo {
  /**
   * Updates a Nutshell contact.
   */
  contactUpdate: UpdateContactInfo_contactUpdate;
}

export interface UpdateContactInfoVariables {
  input: ContactUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactInfo
// ====================================================

export interface GetContactInfo_contact_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetContactInfo_contact_territory {
  __typename: "Territory";
  id: string | null;
}

export interface GetContactInfo_contact_tags_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetContactInfo_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: GetContactInfo_contact_tags_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface GetContactInfo_contact_tagMaps_edges_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetContactInfo_contact_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetContactInfo_contact_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: GetContactInfo_contact_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface GetContactInfo_contact_tagMaps_edges {
  __typename: "TagMapsEdge";
  /**
   * The creator of this tag map
   */
  creator: GetContactInfo_contact_tagMaps_edges_creator | null;
  /**
   * The DateTime that represents when the Tag was mapped
   */
  createdTime: any | null;
  node: GetContactInfo_contact_tagMaps_edges_node | null;
}

export interface GetContactInfo_contact_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetContactInfo_contact_tagMaps_edges[];
}

export interface GetContactInfo_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: GetContactInfo_contact_owner | null;
  /**
   * The terrority to which this peep is assigned.
   */
  territory: GetContactInfo_contact_territory | null;
  /**
   * Tags associated with the given peep
   */
  tags: GetContactInfo_contact_tags[];
  /**
   * Tag maps for the peep
   */
  tagMaps: GetContactInfo_contact_tagMaps | null;
}

export interface GetContactInfo {
  /**
   * Returns a Nutshell Contact
   */
  contact: GetContactInfo_contact | null;
}

export interface GetContactInfoVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLastContactedTimes
// ====================================================

export interface GetLastContactedTimes_peep {
  __typename: "Account" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The most recent date this entity was contacted by the active user
   */
  myLastContactedTime: any | null;
}

export interface GetLastContactedTimes {
  /**
   * Returns a Nutshell peep
   */
  peep: GetLastContactedTimes_peep;
}

export interface GetLastContactedTimesVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: LeadAddChannel
// ====================================================

export interface LeadAddChannel_leadAddChannel_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LeadAddChannel_leadAddChannel {
  __typename: "LeadAddChannelPayload";
  /**
   * The lead with the newly added channel.
   */
  lead: LeadAddChannel_leadAddChannel_lead;
}

export interface LeadAddChannel {
  /**
   * Adds a Channel to a Lead
   */
  leadAddChannel: LeadAddChannel_leadAddChannel;
}

export interface LeadAddChannelVariables {
  input: LeadAddChannelInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: LeadAddSource
// ====================================================

export interface LeadAddSource_leadAddSource_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LeadAddSource_leadAddSource {
  __typename: "LeadAddSourcePayload";
  /**
   * The lead with the newly added source.
   */
  lead: LeadAddSource_leadAddSource_lead;
}

export interface LeadAddSource {
  /**
   * Adds a Source to a Lead
   */
  leadAddSource: LeadAddSource_leadAddSource;
}

export interface LeadAddSourceVariables {
  input: LeadAddSourceInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: LeadRemoveChannel
// ====================================================

export interface LeadRemoveChannel_leadRemoveChannel_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LeadRemoveChannel_leadRemoveChannel {
  __typename: "LeadRemoveChannelPayload";
  /**
   * The lead with the removed channel.
   */
  lead: LeadRemoveChannel_leadRemoveChannel_lead;
}

export interface LeadRemoveChannel {
  /**
   * Removes a Channel from a Lead
   */
  leadRemoveChannel: LeadRemoveChannel_leadRemoveChannel;
}

export interface LeadRemoveChannelVariables {
  input: LeadRemoveChannelInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: LeadRemoveSource
// ====================================================

export interface LeadRemoveSource_leadRemoveSource_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LeadRemoveSource_leadRemoveSource {
  __typename: "LeadRemoveSourcePayload";
  /**
   * The lead with the newly removed source.
   */
  lead: LeadRemoveSource_leadRemoveSource_lead;
}

export interface LeadRemoveSource {
  /**
   * Removes a Source to a Lead
   */
  leadRemoveSource: LeadRemoveSource_leadRemoveSource;
}

export interface LeadRemoveSourceVariables {
  input: LeadRemoveSourceInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLeadChannels
// ====================================================

export interface GetLeadChannels_lead_channels_sources_channel {
  __typename: "Channel";
  /**
   * The enum value of the source
   */
  value: ChannelType;
  /**
   * The title of the channel
   */
  title: string;
  /**
   * The description of the channel
   */
  description: string;
}

export interface GetLeadChannels_lead_channels_sources {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The type of the source
   */
  type: SourceType;
  /**
   * The DateTime that represents when the Source was created
   */
  createdTime: any | null;
  /**
   * Can the user delete this source?
   */
  isDeleteable: boolean;
  /**
   * Can the user edit this source?
   */
  isEditable: boolean;
  /**
   * The DateTime the source was last used
   */
  lastUsedTime: any | null;
  /**
   * The channel associated with the source
   */
  channel: GetLeadChannels_lead_channels_sources_channel | null;
}

export interface GetLeadChannels_lead_channels_edges_node {
  __typename: "Channel";
  /**
   * The enum value of the source
   */
  value: ChannelType;
  /**
   * The title of the channel
   */
  title: string;
}

export interface GetLeadChannels_lead_channels_edges_sources_channel {
  __typename: "Channel";
  /**
   * The enum value of the source
   */
  value: ChannelType;
  /**
   * The title of the channel
   */
  title: string;
  /**
   * The description of the channel
   */
  description: string;
}

export interface GetLeadChannels_lead_channels_edges_sources {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The type of the source
   */
  type: SourceType;
  /**
   * The DateTime that represents when the Source was created
   */
  createdTime: any | null;
  /**
   * Can the user delete this source?
   */
  isDeleteable: boolean;
  /**
   * Can the user edit this source?
   */
  isEditable: boolean;
  /**
   * The DateTime the source was last used
   */
  lastUsedTime: any | null;
  /**
   * The channel associated with the source
   */
  channel: GetLeadChannels_lead_channels_edges_sources_channel | null;
}

export interface GetLeadChannels_lead_channels_edges {
  __typename: "LeadChannelsEdge";
  node: GetLeadChannels_lead_channels_edges_node;
  /**
   * Sources related to this LeadChannel
   */
  sources: GetLeadChannels_lead_channels_edges_sources[];
}

export interface GetLeadChannels_lead_channels {
  __typename: "LeadChannelsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Sources related to a lead that do not belong to a channel
   */
  sources: GetLeadChannels_lead_channels_sources[];
  /**
   * A list of edges.
   */
  edges: GetLeadChannels_lead_channels_edges[];
}

export interface GetLeadChannels_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * List of channels associated with this lead
   */
  channels: GetLeadChannels_lead_channels | null;
}

export interface GetLeadChannels {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetLeadChannels_lead | null;
}

export interface GetLeadChannelsVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditionSendToFilteredList
// ====================================================

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_SmsEdition {
  __typename: "SmsEdition";
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_campaign_nextSendingEdition | null;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_emailTemplate_links[];
  name: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_comparisonEdition_emailTemplate_links[];
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_comparisonEdition_emailTemplate | null;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_comparison_winnerEdition_emailTemplate | null;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_comparison_winningEdition | null;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_audience_fromSavedFilter_count;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_audience_fromSavedFilter | null;
  membershipStats: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_audience_membershipStats;
  smsMembershipStats: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_audience_smsMembershipStats;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_from_emailAddress;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_from_fromDomain | null;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_gateError {
  __typename: "GateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity = EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Account | EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges_node;
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions_edges[];
}

export interface EditionSendToFilteredList_editionSendToFilteredList_edition_Edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_emailTemplate | null;
  engagementStats: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_delay | null;
  /**
   * The number of emails sent for this edition
   */
  numSentEmails: number;
  /**
   * The custom click domain that this edition will use to track links, if there is one
   */
  customClickDomain: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_customClickDomain | null;
  utmParameters: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_utmParameters;
  defaultUtmParameters: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_defaultUtmParameters;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  useUtmParameters: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_gateError | null;
  /**
   * Boolean indicating if the edition is using a web font.
   */
  hasWebFonts: boolean;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: EditionSendToFilteredList_editionSendToFilteredList_edition_Edition_queuedDripProgressions | null;
  /**
   * The maximum number of recipients this edition can send to, if DMARC is not
   * fully configured. This is only relevant for non-drip sequence editions.
   */
  recipientLimitForDeliverability: number | null;
}

export type EditionSendToFilteredList_editionSendToFilteredList_edition = EditionSendToFilteredList_editionSendToFilteredList_edition_SmsEdition | EditionSendToFilteredList_editionSendToFilteredList_edition_Edition;

export interface EditionSendToFilteredList_editionSendToFilteredList {
  __typename: "EditionSendToFilteredListPayload";
  /**
   * The edition
   */
  edition: EditionSendToFilteredList_editionSendToFilteredList_edition;
}

export interface EditionSendToFilteredList {
  /**
   * Send an edition to a filtered list of people.
   */
  editionSendToFilteredList: EditionSendToFilteredList_editionSendToFilteredList | null;
}

export interface EditionSendToFilteredListVariables {
  input: EditionSendToFilteredListInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: FilteredListAddToDripSequence
// ====================================================

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_startTrigger_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter = FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_startTrigger_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_startTrigger_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_startTrigger_conditions_config = FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_startTrigger_conditions_config_ConditionConfigLink | FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_startTrigger_conditions_config_ConditionConfigEntityFilter | FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_startTrigger_conditions_config_ConditionConfigTag | FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_startTrigger_conditions_config_ConditionConfigAudience;

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_startTrigger_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_startTrigger_conditions_config;
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_startTrigger {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of startTrigger
   */
  type: StartTriggerType;
  /**
   * A list of conditions which must be true to activate this startTrigger.
   */
  conditions: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_startTrigger_conditions[];
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * The last time this particular piece of content was sent. This is slow to
   * calculate on a one-off basis so we chuck it in here.
   */
  latestDeliveryTime: any | null;
  /**
   * For edition base stats, the total number of drip progressions in any state for the related campaigns
   */
  dripProgressionTotalRecipients: number;
  /**
   * For edition base stats, the number of drip progressions that have stopped for the related campaigns
   */
  dripProgressionsStopped: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
  /**
   * For edition base stats, the percentage of drip progressions that received every message for the related campaigns
   */
  dripProgressionsReceivedEveryMessageRate: number | null;
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_from_emailAddress;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_from_fromDomain | null;
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_conditions_config_ConditionConfigSourceEntity {
  __typename: "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_conditions_config_ConditionConfigEntityFilter_filter = FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_conditions_config = FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_conditions_config_ConditionConfigSourceEntity | FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_conditions_config_ConditionConfigEntityFilter | FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_conditions_config_ConditionConfigLink | FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_conditions_config_ConditionConfigTag | FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_conditions_config_ConditionConfigAudience;

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_conditions_config;
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_action_config_ActionConfigRemoveTags {
  __typename: "ActionConfigRemoveTags" | "ActionConfigSendPageViewedNotification" | "ActionConfigAddToDripSequence" | "ActionConfigCreateLead" | "ActionConfigSendEmail";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_action_config_ActionConfigAddTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_action_config_ActionConfigAddTags {
  __typename: "ActionConfigAddTags";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  tags: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_action_config_ActionConfigAddTags_tags[];
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_action_config_ActionConfigAddAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_action_config_ActionConfigAddAudiences {
  __typename: "ActionConfigAddAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_action_config_ActionConfigAddAudiences_audiences[];
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_action_config_ActionConfigRemoveAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_action_config_ActionConfigRemoveAudiences {
  __typename: "ActionConfigRemoveAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_action_config_ActionConfigRemoveAudiences_audiences[];
}

export type FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_action_config = FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_action_config_ActionConfigRemoveTags | FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_action_config_ActionConfigAddTags | FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_action_config_ActionConfigAddAudiences | FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_action_config_ActionConfigRemoveAudiences;

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_action {
  __typename: "Action";
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * Human readable title of this action
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this action. This is essentially just the
   * stringified version of the action’s conditions, but because a action can have
   * multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The configuration for this action.
   */
  config: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_action_config;
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Calculated goal type based on conditions. This is not saved in the database
   */
  type: DripSequenceGoalType;
  /**
   * A list of conditions which must be true to activate this goal.
   */
  conditions: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_conditions[];
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this goal. This is essentially just the stringified
   * version of the goal’s conditions, but because a goal can have multiple
   * conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The optional action (next step in this context) that will run when this goal is met
   */
  action: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal_action | null;
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The start trigger for the drip sequence
   */
  startTrigger: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_startTrigger | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  creatorUser: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_creatorUser | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The DateTime that represents when the campaign was last modified
   */
  modifiedTime: any | null;
  /**
   * Time of the last campaign status change. For example, if a customer activated
   * this sequence and its still active, this would be the time the sequence was
   * activated. Once the campaign status is changed (paused, retired, etc) this
   * would reflect that new time
   */
  lastStatusChangeTime: any | null;
  editions: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_editions;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * Whether the drip sequence should have a remove option
   */
  isRemovable: boolean;
  engagementStats: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_engagementStats;
  /**
   * The address to send this edition from
   */
  from: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_from | null;
  useUtmParameters: boolean;
  utmParameters: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_utmParameters;
  defaultUtmParameters: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_defaultUtmParameters;
  /**
   * Should messages only be sent during business hours.
   */
  isBusinessHoursOnly: boolean;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * When a lead is closed, should drip sequences stop?
   */
  isStopOnLeadClose: boolean;
  /**
   * When a person is removed from an audience, should drip sequences stop?
   */
  isStopOnRemovedFromAudience: boolean;
  /**
   * The newly created Nutshell goal
   */
  goal: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_goal | null;
  /**
   * Number of in progress drip progressions for the drip sequence
   */
  numInProgressDripProgressions: number;
  /**
   * The custom click domain that this campaign will use to track links, if there is one
   */
  customClickDomain: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence_customClickDomain | null;
}

export interface FilteredListAddToDripSequence_filteredListAddToDripSequence {
  __typename: "FilteredListAddToDripSequencePayload";
  /**
   * The drip sequence the entites were added to
   */
  dripSequence: FilteredListAddToDripSequence_filteredListAddToDripSequence_dripSequence;
}

export interface FilteredListAddToDripSequence {
  /**
   * Add a filtered list of Nutshell entities to a drip sequence.
   */
  filteredListAddToDripSequence: FilteredListAddToDripSequence_filteredListAddToDripSequence | null;
}

export interface FilteredListAddToDripSequenceVariables {
  input: FilteredListAddToDripSequenceInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDripSequencesForPreviewList
// ====================================================

export interface GetDripSequencesForPreviewList_dripSequences_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetDripSequencesForPreviewList_dripSequences_edges_node_startTrigger {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface GetDripSequencesForPreviewList_dripSequences_edges_node_editions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetDripSequencesForPreviewList_dripSequences_edges_node_editions_edges_node_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
}

export interface GetDripSequencesForPreviewList_dripSequences_edges_node_editions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetDripSequencesForPreviewList_dripSequences_edges_node_editions_edges_node_emailTemplate | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
}

export interface GetDripSequencesForPreviewList_dripSequences_edges_node_editions_edges {
  __typename: "EditionsEdge";
  node: GetDripSequencesForPreviewList_dripSequences_edges_node_editions_edges_node;
}

export interface GetDripSequencesForPreviewList_dripSequences_edges_node_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetDripSequencesForPreviewList_dripSequences_edges_node_editions_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetDripSequencesForPreviewList_dripSequences_edges_node_editions_edges[];
}

export interface GetDripSequencesForPreviewList_dripSequences_edges_node_from_emailAddress {
  __typename: "NutEmailAddress";
  formatted: string;
}

export interface GetDripSequencesForPreviewList_dripSequences_edges_node_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: GetDripSequencesForPreviewList_dripSequences_edges_node_from_emailAddress;
}

export interface GetDripSequencesForPreviewList_dripSequences_edges_node {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * Time of the last campaign status change. For example, if a customer activated
   * this sequence and its still active, this would be the time the sequence was
   * activated. Once the campaign status is changed (paused, retired, etc) this
   * would reflect that new time
   */
  lastStatusChangeTime: any | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The start trigger for the drip sequence
   */
  startTrigger: GetDripSequencesForPreviewList_dripSequences_edges_node_startTrigger | null;
  editions: GetDripSequencesForPreviewList_dripSequences_edges_node_editions;
  /**
   * The address to send this edition from
   */
  from: GetDripSequencesForPreviewList_dripSequences_edges_node_from | null;
}

export interface GetDripSequencesForPreviewList_dripSequences_edges {
  __typename: "CampaignsEdge";
  cursor: string;
  node: GetDripSequencesForPreviewList_dripSequences_edges_node;
}

export interface GetDripSequencesForPreviewList_dripSequences {
  __typename: "CampaignsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetDripSequencesForPreviewList_dripSequences_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetDripSequencesForPreviewList_dripSequences_edges[];
}

export interface GetDripSequencesForPreviewList {
  /**
   * Returns a paging connection of email drip sequences from the root of our query.
   */
  dripSequences: GetDripSequencesForPreviewList_dripSequences;
}

export interface GetDripSequencesForPreviewListVariables {
  limit: number;
  archived: boolean;
  cursor?: string | null;
  sort: DripSequenceSortType;
  search?: string | null;
  creatorUserId?: string | null;
  lastUpdatedTime?: string | null;
  statuses?: CampaignStatus[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEditionsForPreviewList
// ====================================================

export interface GetEditionsForPreviewList_editions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetEditionsForPreviewList_editions_edges_node_from_emailAddress {
  __typename: "NutEmailAddress";
  formatted: string;
}

export interface GetEditionsForPreviewList_editions_edges_node_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: GetEditionsForPreviewList_editions_edges_node_from_emailAddress;
}

export interface GetEditionsForPreviewList_editions_edges_node_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetEditionsForPreviewList_editions_edges_node_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
}

export interface GetEditionsForPreviewList_editions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  scheduledTime: any | null;
  sendTime: any | null;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The address to send this edition from
   */
  from: GetEditionsForPreviewList_editions_edges_node_from | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetEditionsForPreviewList_editions_edges_node_campaign;
  /**
   * The email template for this edition
   */
  emailTemplate: GetEditionsForPreviewList_editions_edges_node_emailTemplate | null;
}

export interface GetEditionsForPreviewList_editions_edges {
  __typename: "EditionsEdge";
  cursor: string;
  node: GetEditionsForPreviewList_editions_edges_node;
}

export interface GetEditionsForPreviewList_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetEditionsForPreviewList_editions_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetEditionsForPreviewList_editions_edges[];
}

export interface GetEditionsForPreviewList {
  /**
   * Returns the latest sent editions.
   */
  editions: GetEditionsForPreviewList_editions;
}

export interface GetEditionsForPreviewListVariables {
  first: number;
  after?: string | null;
  sort?: EditionSortType | null;
  audienceId?: string | null;
  campaignTypes?: CampaignType[] | null;
  statuses?: EditionStatus[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSavedFilterCount
// ====================================================

export interface GetSavedFilterCount_savedFilterCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetSavedFilterCount {
  /**
   * Returns the count of entities in a saved list
   */
  savedFilterCount: GetSavedFilterCount_savedFilterCount;
}

export interface GetSavedFilterCountVariables {
  url: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateFixedAudience
// ====================================================

export interface CreateFixedAudience_audienceCreate_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface CreateFixedAudience_audienceCreate_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: CreateFixedAudience_audienceCreate_audience_membershipStats_totalCount;
}

export interface CreateFixedAudience_audienceCreate_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  membershipStats: CreateFixedAudience_audienceCreate_audience_membershipStats;
  createdTime: any;
  /**
   * If this audience was created recently, we need to know to inform users that not all members may be added yet
   */
  isRecentlyCreated: boolean;
  /**
   * The description of this audience
   */
  description: string | null;
}

export interface CreateFixedAudience_audienceCreate {
  __typename: "AudienceCreatePayload";
  /**
   * The newly created email marketing audience
   */
  audience: CreateFixedAudience_audienceCreate_audience;
}

export interface CreateFixedAudience {
  /**
   * Creates a new email marketing audience.
   */
  audienceCreate: CreateFixedAudience_audienceCreate;
}

export interface CreateFixedAudienceVariables {
  audience: AudienceCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateSavedFilter
// ====================================================

export interface CreateSavedFilter_filterCreate_filter_sharedWithEntities {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateSavedFilter_filterCreate_filter_creatorUser {
  __typename: "User";
  name: string;
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateSavedFilter_filterCreate_filter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url to the count of entities in this list
   */
  countUrl: string | null;
  /**
   * The DateTime that represents when the saved filter was created. This is sometimes not set for built-in filters.
   */
  createdTime: any | null;
  /**
   * The url path of the saved filter
   */
  htmlUrl: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The users description of the saved filter
   */
  description: string | null;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * Whether the saved filter is shared with other users or private
   */
  isShared: boolean | null;
  /**
   * The users and teams that the saved filter is shared with
   */
  sharedWithEntities: (CreateSavedFilter_filterCreate_filter_sharedWithEntities | null)[];
  /**
   * Whether the saved filter can be deleted
   */
  isDeleteable: boolean;
  /**
   * Whether the saved filter is updateable (can be edited)
   */
  isUpdateable: boolean | null;
  /**
   * Whether the saved filter is immutable (unable to be edited)
   */
  isImmutable: boolean | null;
  /**
   * The user who created the saved filter
   */
  creatorUser: CreateSavedFilter_filterCreate_filter_creatorUser | null;
}

export interface CreateSavedFilter_filterCreate {
  __typename: "FilterCreatePayload";
  /**
   * The newly created filter.
   */
  filter: CreateSavedFilter_filterCreate_filter | null;
}

export interface CreateSavedFilter {
  /**
   * Creates a new saved filter
   */
  filterCreate: CreateSavedFilter_filterCreate;
}

export interface CreateSavedFilterVariables {
  input: FilterCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteAudienceForEntityList
// ====================================================

export interface DeleteAudienceForEntityList_audienceDelete_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteAudienceForEntityList_audienceDelete {
  __typename: "AudienceDeletePayload";
  /**
   * The deleted Nutshell audience
   */
  audience: DeleteAudienceForEntityList_audienceDelete_audience;
}

export interface DeleteAudienceForEntityList {
  /**
   * Deletes an audience.
   */
  audienceDelete: DeleteAudienceForEntityList_audienceDelete;
}

export interface DeleteAudienceForEntityListVariables {
  input: AudienceDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteSavedFilter
// ====================================================

export interface DeleteSavedFilter_filterDelete_filter {
  __typename: "SavedFilter";
  id: string;
  /**
   * Whether the saved filter is shared with other users or private
   */
  isShared: boolean | null;
}

export interface DeleteSavedFilter_filterDelete {
  __typename: "FilterDeletePayload";
  /**
   * The filter that was deleted.
   */
  filter: DeleteSavedFilter_filterDelete_filter | null;
}

export interface DeleteSavedFilter {
  /**
   * Delete a saved filter
   */
  filterDelete: DeleteSavedFilter_filterDelete;
}

export interface DeleteSavedFilterVariables {
  input: FilterDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateAudienceForEntityList
// ====================================================

export interface UpdateAudienceForEntityList_audienceUpdate_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface UpdateAudienceForEntityList_audienceUpdate_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: UpdateAudienceForEntityList_audienceUpdate_audience_membershipStats_totalCount;
}

export interface UpdateAudienceForEntityList_audienceUpdate_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  membershipStats: UpdateAudienceForEntityList_audienceUpdate_audience_membershipStats;
  createdTime: any;
  /**
   * If this audience was created recently, we need to know to inform users that not all members may be added yet
   */
  isRecentlyCreated: boolean;
  /**
   * The description of this audience
   */
  description: string | null;
}

export interface UpdateAudienceForEntityList_audienceUpdate {
  __typename: "AudienceUpdatePayload";
  /**
   * The audience
   */
  audience: UpdateAudienceForEntityList_audienceUpdate_audience;
}

export interface UpdateAudienceForEntityList {
  /**
   * Save the template data for an email marketing audience
   */
  audienceUpdate: UpdateAudienceForEntityList_audienceUpdate | null;
}

export interface UpdateAudienceForEntityListVariables {
  audience: AudienceUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateFilterShare
// ====================================================

export interface UpdateFilterShare_filterShareUpdate_filter_sharedWithEntities {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateFilterShare_filterShareUpdate_filter {
  __typename: "SavedFilter";
  id: string;
  /**
   * Whether the saved filter is shared with other users or private
   */
  isShared: boolean | null;
  /**
   * The users and teams that the saved filter is shared with
   */
  sharedWithEntities: (UpdateFilterShare_filterShareUpdate_filter_sharedWithEntities | null)[];
}

export interface UpdateFilterShare_filterShareUpdate {
  __typename: "FilterShareUpdatePayload";
  /**
   * The updated filter.
   */
  filter: UpdateFilterShare_filterShareUpdate_filter | null;
}

export interface UpdateFilterShare {
  /**
   * Updates the sharing settings for a saved filter
   */
  filterShareUpdate: UpdateFilterShare_filterShareUpdate;
}

export interface UpdateFilterShareVariables {
  input: FilterShareUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateSavedFilter
// ====================================================

export interface UpdateSavedFilter_filterUpdate_filter_sharedWithEntities {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateSavedFilter_filterUpdate_filter_creatorUser {
  __typename: "User";
  name: string;
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateSavedFilter_filterUpdate_filter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url to the count of entities in this list
   */
  countUrl: string | null;
  /**
   * The DateTime that represents when the saved filter was created. This is sometimes not set for built-in filters.
   */
  createdTime: any | null;
  /**
   * The url path of the saved filter
   */
  htmlUrl: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The users description of the saved filter
   */
  description: string | null;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * Whether the saved filter is shared with other users or private
   */
  isShared: boolean | null;
  /**
   * The users and teams that the saved filter is shared with
   */
  sharedWithEntities: (UpdateSavedFilter_filterUpdate_filter_sharedWithEntities | null)[];
  /**
   * Whether the saved filter can be deleted
   */
  isDeleteable: boolean;
  /**
   * Whether the saved filter is updateable (can be edited)
   */
  isUpdateable: boolean | null;
  /**
   * Whether the saved filter is immutable (unable to be edited)
   */
  isImmutable: boolean | null;
  /**
   * The user who created the saved filter
   */
  creatorUser: UpdateSavedFilter_filterUpdate_filter_creatorUser | null;
}

export interface UpdateSavedFilter_filterUpdate {
  __typename: "FilterUpdatePayload";
  /**
   * The updated filter.
   */
  filter: UpdateSavedFilter_filterUpdate_filter | null;
}

export interface UpdateSavedFilter {
  /**
   * Updates basic info about a saved filter
   */
  filterUpdate: UpdateSavedFilter_filterUpdate;
}

export interface UpdateSavedFilterVariables {
  input: FilterUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAudienceForCount
// ====================================================

export interface GetAudienceForCount_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetAudienceForCount_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetAudienceForCount_audience_membershipStats_totalCount;
}

export interface GetAudienceForCount_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  membershipStats: GetAudienceForCount_audience_membershipStats;
  createdTime: any;
  /**
   * If this audience was created recently, we need to know to inform users that not all members may be added yet
   */
  isRecentlyCreated: boolean;
  /**
   * The description of this audience
   */
  description: string | null;
}

export interface GetAudienceForCount {
  /**
   * Returns an email marketing audience.
   */
  audience: GetAudienceForCount_audience;
}

export interface GetAudienceForCountVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAudienceForEntityList
// ====================================================

export interface GetAudienceForEntityList_audience_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetAudienceForEntityList_audience_members {
  __typename: "AudienceMemberConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetAudienceForEntityList_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The description of this audience
   */
  description: string | null;
  createdTime: any;
  creatorUser: GetAudienceForEntityList_audience_creatorUser | null;
  /**
   * If this audience was created recently, we need to know to inform users that not all members may be added yet
   */
  isRecentlyCreated: boolean;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * All members of this audience
   */
  members: GetAudienceForEntityList_audience_members;
}

export interface GetAudienceForEntityList {
  /**
   * Returns an email marketing audience.
   */
  audience: GetAudienceForEntityList_audience;
}

export interface GetAudienceForEntityListVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAudiencesForEntityList
// ====================================================

export interface GetAudiencesForEntityList_audiences_edges_node_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetAudiencesForEntityList_audiences_edges_node_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetAudiencesForEntityList_audiences_edges_node_membershipStats_totalCount;
}

export interface GetAudiencesForEntityList_audiences_edges_node {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  membershipStats: GetAudiencesForEntityList_audiences_edges_node_membershipStats;
  createdTime: any;
  /**
   * If this audience was created recently, we need to know to inform users that not all members may be added yet
   */
  isRecentlyCreated: boolean;
  /**
   * The description of this audience
   */
  description: string | null;
}

export interface GetAudiencesForEntityList_audiences_edges {
  __typename: "AudienceEdge";
  cursor: string;
  node: GetAudiencesForEntityList_audiences_edges_node;
}

export interface GetAudiencesForEntityList_audiences {
  __typename: "AudienceConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetAudiencesForEntityList_audiences_edges[];
}

export interface GetAudiencesForEntityList {
  /**
   * Returns all email marketing audiences
   */
  audiences: GetAudiencesForEntityList_audiences;
}

export interface GetAudiencesForEntityListVariables {
  limit: number;
  archived?: boolean | null;
  cursor?: string | null;
  sort: AudienceSortType;
  search?: string | null;
  creatorUserId?: string | null;
  lastUpdatedTime?: string | null;
  audienceTypeFilter?: AudienceTypeFilter | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDefaultFilters
// ====================================================

export interface GetDefaultFilters_defaultFilters_sharedWithEntities {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetDefaultFilters_defaultFilters {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url to the count of entities in this list
   */
  countUrl: string | null;
  /**
   * The DateTime that represents when the saved filter was created. This is sometimes not set for built-in filters.
   */
  createdTime: any | null;
  /**
   * The url path of the saved filter
   */
  htmlUrl: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The users description of the saved filter
   */
  description: string | null;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * Whether the saved filter is shared with other users or private
   */
  isShared: boolean | null;
  /**
   * The users and teams that the saved filter is shared with
   */
  sharedWithEntities: (GetDefaultFilters_defaultFilters_sharedWithEntities | null)[];
  /**
   * Whether the saved filter can be deleted
   */
  isDeleteable: boolean;
}

export interface GetDefaultFilters {
  /**
   * Returns the default saved lists for a given entity type.
   */
  defaultFilters: GetDefaultFilters_defaultFilters[];
}

export interface GetDefaultFiltersVariables {
  type: SavedFiltersReportType;
  searchNameQuery?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSavedFilters
// ====================================================

export interface GetSavedFilters_savedFilters_edges_node_sharedWithEntities {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSavedFilters_savedFilters_edges_node {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url to the count of entities in this list
   */
  countUrl: string | null;
  /**
   * The DateTime that represents when the saved filter was created. This is sometimes not set for built-in filters.
   */
  createdTime: any | null;
  /**
   * The url path of the saved filter
   */
  htmlUrl: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The users description of the saved filter
   */
  description: string | null;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * Whether the saved filter is shared with other users or private
   */
  isShared: boolean | null;
  /**
   * The users and teams that the saved filter is shared with
   */
  sharedWithEntities: (GetSavedFilters_savedFilters_edges_node_sharedWithEntities | null)[];
  /**
   * Whether the saved filter can be deleted
   */
  isDeleteable: boolean;
}

export interface GetSavedFilters_savedFilters_edges {
  __typename: "SavedFiltersEdge";
  node: GetSavedFilters_savedFilters_edges_node;
}

export interface GetSavedFilters_savedFilters {
  __typename: "SavedFiltersConnection";
  /**
   * A list of edges.
   */
  edges: GetSavedFilters_savedFilters_edges[];
}

export interface GetSavedFilters {
  /**
   * Returns all saved lists of entities
   */
  savedFilters: GetSavedFilters_savedFilters;
}

export interface GetSavedFiltersVariables {
  type?: SavedFiltersReportType | null;
  includeShared?: boolean | null;
  ignoreUserFilters?: boolean | null;
  sort?: SavedFilterSortType | null;
  searchNameQuery?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EnvelopeDuplicate
// ====================================================

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_recipientEntity_Contact_primaryAccount_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_recipientEntity_Contact_primaryAccount {
  __typename: "ContactAccountsEdge";
  node: EnvelopeDuplicate_envelopeDuplicate_envelope_recipientEntity_Contact_primaryAccount_node;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_recipientEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary account edge for this contact
   */
  primaryAccount: EnvelopeDuplicate_envelopeDuplicate_envelope_recipientEntity_Contact_primaryAccount | null;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_recipientEntity_Account_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_recipientEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary contact for this account
   */
  primaryContact: EnvelopeDuplicate_envelopeDuplicate_envelope_recipientEntity_Account_primaryContact | null;
}

export type EnvelopeDuplicate_envelopeDuplicate_envelope_recipientEntity = EnvelopeDuplicate_envelopeDuplicate_envelope_recipientEntity_Contact | EnvelopeDuplicate_envelopeDuplicate_envelope_recipientEntity_Account;

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_subtotal {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_productLineItems_edges_node_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_productLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_productLineItems_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_productLineItems_edges_node {
  __typename: "ProductLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The Nutshell product this line item is related to
   */
  product: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_productLineItems_edges_node_product | null;
  /**
   * The unmodified price of a single unit of the product
   */
  price: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_productLineItems_edges_node_price;
  /**
   * The description of the product
   */
  description: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The quantity of the product
   */
  quantity: number;
  /**
   * The formatted quantity of the product
   */
  formattedQuantity: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The unit of the discount
   */
  discountUnit: QuoteLineItemUnit | null;
  /**
   * The number of the discount
   */
  discountNumber: number | null;
  /**
   * The formatted discount
   */
  formattedDiscount: string | null;
  /**
   * The total price of the product including quantity and discount
   */
  total: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_productLineItems_edges_node_total;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_productLineItems_edges {
  __typename: "QuoteProductLineItemsEdge";
  node: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_productLineItems_edges_node;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_productLineItems {
  __typename: "QuoteProductLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_productLineItems_edges[];
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_subtotalLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_subtotalLineItems_edges_node {
  __typename: "SubtotalLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The price of the subtotal item
   */
  price: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_subtotalLineItems_edges_node_price;
  /**
   * The label of the subtotal item
   */
  label: string;
  /**
   * The unit of the subtotal item's modifier
   */
  modifierUnit: QuoteLineItemUnit;
  /**
   * The value of the subtotal item's modifier
   */
  modifierValue: number;
  /**
   * The formatted subtotal item's modifier
   */
  formattedValue: string;
  /**
   * The operation of the subtotal item
   */
  operation: QuoteLineItemOperation;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_subtotalLineItems_edges {
  __typename: "QuoteSubtotalLineItemsEdge";
  node: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_subtotalLineItems_edges_node;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_subtotalLineItems {
  __typename: "QuoteSubtotalLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_subtotalLineItems_edges[];
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The subtotal (pre-SubtotalLineItem modifiers) price of the quote
   */
  subtotal: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_subtotal;
  /**
   * The total price of the quote after all modifiers
   */
  total: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_total;
  /**
   * The line items of the quote
   */
  productLineItems: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_productLineItems;
  /**
   * The subtotal line items of the quote
   */
  subtotalLineItems: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote_subtotalLineItems;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The time the quote was prepared
   */
  preparedTime: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * The name of the person the quote was prepared for
   */
  preparedFor: string;
  /**
   * The name of the person that prepared the quote
   */
  preparedBy: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The option chosen for how end-users will accept the quote
   */
  acceptanceMode: QuoteAcceptanceOption;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_subtotal {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_productLineItems_edges_node_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_productLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_productLineItems_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_productLineItems_edges_node {
  __typename: "ProductLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The Nutshell product this line item is related to
   */
  product: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_productLineItems_edges_node_product | null;
  /**
   * The unmodified price of a single unit of the product
   */
  price: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_productLineItems_edges_node_price;
  /**
   * The description of the product
   */
  description: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The quantity of the product
   */
  quantity: number;
  /**
   * The formatted quantity of the product
   */
  formattedQuantity: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The unit of the discount
   */
  discountUnit: QuoteLineItemUnit | null;
  /**
   * The number of the discount
   */
  discountNumber: number | null;
  /**
   * The formatted discount
   */
  formattedDiscount: string | null;
  /**
   * The total price of the product including quantity and discount
   */
  total: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_productLineItems_edges_node_total;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_productLineItems_edges {
  __typename: "QuoteProductLineItemsEdge";
  node: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_productLineItems_edges_node;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_productLineItems {
  __typename: "QuoteProductLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_productLineItems_edges[];
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_subtotalLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_subtotalLineItems_edges_node {
  __typename: "SubtotalLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The price of the subtotal item
   */
  price: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_subtotalLineItems_edges_node_price;
  /**
   * The label of the subtotal item
   */
  label: string;
  /**
   * The unit of the subtotal item's modifier
   */
  modifierUnit: QuoteLineItemUnit;
  /**
   * The value of the subtotal item's modifier
   */
  modifierValue: number;
  /**
   * The formatted subtotal item's modifier
   */
  formattedValue: string;
  /**
   * The operation of the subtotal item
   */
  operation: QuoteLineItemOperation;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_subtotalLineItems_edges {
  __typename: "QuoteSubtotalLineItemsEdge";
  node: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_subtotalLineItems_edges_node;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_subtotalLineItems {
  __typename: "QuoteSubtotalLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_subtotalLineItems_edges[];
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_canSendToQuickbooks_TrueWithReason {
  __typename: "TrueWithReason";
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_canSendToQuickbooks_FalseWithReason {
  __typename: "FalseWithReason";
  /**
   * The reason why the value is false
   */
  reason: string;
}

export type EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_canSendToQuickbooks = EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_canSendToQuickbooks_TrueWithReason | EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_canSendToQuickbooks_FalseWithReason;

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The subtotal (pre-SubtotalLineItem modifiers) price of the quote
   */
  subtotal: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_subtotal;
  /**
   * The total price of the quote after all modifiers
   */
  total: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_total;
  /**
   * The line items of the quote
   */
  productLineItems: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_productLineItems;
  /**
   * The subtotal line items of the quote
   */
  subtotalLineItems: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_subtotalLineItems;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The time the quote was prepared
   */
  preparedTime: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * The name of the person the quote was prepared for
   */
  preparedFor: string;
  /**
   * The name of the person that prepared the quote
   */
  preparedBy: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The purchase order number
   */
  purchaseOrderNumber: string | null;
  /**
   * The customer number
   */
  customerNumber: string | null;
  /**
   * The job number
   */
  jobNumber: string | null;
  /**
   * The reference number
   */
  referenceNumber: string | null;
  /**
   * The payment and terms
   */
  paymentAndTerms: string;
  /**
   * The completion comment
   */
  completionComment: string | null;
  /**
   * A human readable string representing how long over due the invoice is
   */
  overdueDuration: string | null;
  /**
   * URL to view this invoice in QuickBooks, or null if it has not been sent to QuickBooks
   */
  quickbooksInvoiceUrl: string | null;
  /**
   * Whether the invoice can be sent to Quickbooks in its current state
   */
  canSendToQuickbooks: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice_canSendToQuickbooks;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_contract {
  __typename: "Contract";
  id: string;
  /**
   * Same-origin URL for this contract PDF.
   */
  pdfDownloadUrl: string | null;
  name: string;
  displayNumber: string;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_documentFields {
  __typename: "DocumentField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  quoteId: string | null;
  contractId: string | null;
  direction: DocumentFieldDirection;
  type: DocumentFieldType;
  signatureValueType: DocumentSignatureValueType | null;
  label: string;
  placeholder: string | null;
  isRequired: boolean;
  entityName: string | null;
  fieldName: string | null;
  entityAttributeId: string | null;
  /**
   * Raw JSON configuration for this field.
   */
  fieldJson: string | null;
  pageNumber: number | null;
  value: string | null;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node {
  __typename: "EnvelopeDocument";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  documentType: EnvelopeDocumentType;
  position: number;
  quote: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_quote | null;
  invoice: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_invoice | null;
  contract: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_contract | null;
  documentFields: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node_documentFields[];
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges {
  __typename: "EnvelopeDocumentsEdge";
  node: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges_node;
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope_documents {
  __typename: "EnvelopeDocumentsConnection";
  /**
   * A list of edges.
   */
  edges: EnvelopeDuplicate_envelopeDuplicate_envelope_documents_edges[];
}

export interface EnvelopeDuplicate_envelopeDuplicate_envelope {
  __typename: "Envelope";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * In-app route to the envelope primary document page.
   */
  htmlUrlPath: string;
  primaryDocumentType: EnvelopeDocumentType;
  displayStatus: EnvelopeDisplayStatus;
  publicSlug: string;
  shareableViewInBrowserLink: string;
  internalViewInBrowserLink: string;
  validThroughTime: string | null;
  readyTime: any | null;
  sentTime: any | null;
  acceptedTime: any | null;
  revokedTime: any | null;
  deletedTime: any | null;
  createdTime: any;
  modifiedTime: any | null;
  recipientEmailAddress: string | null;
  recipientEntity: EnvelopeDuplicate_envelopeDuplicate_envelope_recipientEntity | null;
  lead: EnvelopeDuplicate_envelopeDuplicate_envelope_lead;
  documents: EnvelopeDuplicate_envelopeDuplicate_envelope_documents;
}

export interface EnvelopeDuplicate_envelopeDuplicate {
  __typename: "EnvelopeDuplicatePayload";
  /**
   * The duplicated envelope
   */
  envelope: EnvelopeDuplicate_envelopeDuplicate_envelope;
}

export interface EnvelopeDuplicate {
  /**
   * Duplicates an envelope and all of its member documents as a new draft envelope.
   */
  envelopeDuplicate: EnvelopeDuplicate_envelopeDuplicate;
}

export interface EnvelopeDuplicateVariables {
  input: EnvelopeDuplicateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EnvelopeEmailSend
// ====================================================

export interface EnvelopeEmailSend_envelopeEmailSend_envelope {
  __typename: "Envelope";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  displayStatus: EnvelopeDisplayStatus;
  modifiedTime: any | null;
  sentTime: any | null;
}

export interface EnvelopeEmailSend_envelopeEmailSend {
  __typename: "EnvelopeEmailSendPayload";
  envelope: EnvelopeEmailSend_envelopeEmailSend_envelope;
}

export interface EnvelopeEmailSend {
  /**
   * Queues an email to the envelope recipient with a link to review the document.
   * Performs envelope validation before enqueing the email sending job to prevent
   * unnecessary jobs.
   */
  envelopeEmailSend: EnvelopeEmailSend_envelopeEmailSend;
}

export interface EnvelopeEmailSendVariables {
  input: EnvelopeEmailSendInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: QuickbooksCreateInvoice
// ====================================================

export interface QuickbooksCreateInvoice_quickbooksCreateInvoiceForInvoice_invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * URL to view this invoice in QuickBooks, or null if it has not been sent to QuickBooks
   */
  quickbooksInvoiceUrl: string | null;
}

export interface QuickbooksCreateInvoice_quickbooksCreateInvoiceForInvoice {
  __typename: "QuickbooksCreateInvoiceForInvoicePayload";
  /**
   * The Nutshell invoice that was sent to Quickbooks
   */
  invoice: QuickbooksCreateInvoice_quickbooksCreateInvoiceForInvoice_invoice;
}

export interface QuickbooksCreateInvoice {
  /**
   * Creates an invoice in Quickbooks from a Nutshell invoice
   */
  quickbooksCreateInvoiceForInvoice: QuickbooksCreateInvoice_quickbooksCreateInvoiceForInvoice;
}

export interface QuickbooksCreateInvoiceVariables {
  input: QuickbooksCreateInvoiceForInvoiceInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DocumentFieldUpdateValue
// ====================================================

export interface DocumentFieldUpdateValue_documentFieldUpdateValue_documentField {
  __typename: "DocumentField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  quoteId: string | null;
  contractId: string | null;
  direction: DocumentFieldDirection;
  type: DocumentFieldType;
  signatureValueType: DocumentSignatureValueType | null;
  label: string;
  placeholder: string | null;
  isRequired: boolean;
  entityName: string | null;
  fieldName: string | null;
  entityAttributeId: string | null;
  /**
   * Raw JSON configuration for this field.
   */
  fieldJson: string | null;
  pageNumber: number | null;
  value: string | null;
}

export interface DocumentFieldUpdateValue_documentFieldUpdateValue {
  __typename: "DocumentFieldUpdateValuePayload";
  documentField: DocumentFieldUpdateValue_documentFieldUpdateValue_documentField;
}

export interface DocumentFieldUpdateValue {
  /**
   * Update a single document field value.
   */
  documentFieldUpdateValue: DocumentFieldUpdateValue_documentFieldUpdateValue;
}

export interface DocumentFieldUpdateValueVariables {
  input: DocumentFieldUpdateValueInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EnvelopeUpdateStatus
// ====================================================

export interface EnvelopeUpdateStatus_envelopeUpdateStatus_envelope_documents_edges_node_invoice_canSendToQuickbooks_TrueWithReason {
  __typename: "TrueWithReason";
}

export interface EnvelopeUpdateStatus_envelopeUpdateStatus_envelope_documents_edges_node_invoice_canSendToQuickbooks_FalseWithReason {
  __typename: "FalseWithReason";
  /**
   * The reason why the value is false
   */
  reason: string;
}

export type EnvelopeUpdateStatus_envelopeUpdateStatus_envelope_documents_edges_node_invoice_canSendToQuickbooks = EnvelopeUpdateStatus_envelopeUpdateStatus_envelope_documents_edges_node_invoice_canSendToQuickbooks_TrueWithReason | EnvelopeUpdateStatus_envelopeUpdateStatus_envelope_documents_edges_node_invoice_canSendToQuickbooks_FalseWithReason;

export interface EnvelopeUpdateStatus_envelopeUpdateStatus_envelope_documents_edges_node_invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The completion comment
   */
  completionComment: string | null;
  /**
   * Whether the invoice can be sent to Quickbooks in its current state
   */
  canSendToQuickbooks: EnvelopeUpdateStatus_envelopeUpdateStatus_envelope_documents_edges_node_invoice_canSendToQuickbooks;
}

export interface EnvelopeUpdateStatus_envelopeUpdateStatus_envelope_documents_edges_node {
  __typename: "EnvelopeDocument";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  documentType: EnvelopeDocumentType;
  invoice: EnvelopeUpdateStatus_envelopeUpdateStatus_envelope_documents_edges_node_invoice | null;
}

export interface EnvelopeUpdateStatus_envelopeUpdateStatus_envelope_documents_edges {
  __typename: "EnvelopeDocumentsEdge";
  node: EnvelopeUpdateStatus_envelopeUpdateStatus_envelope_documents_edges_node;
}

export interface EnvelopeUpdateStatus_envelopeUpdateStatus_envelope_documents {
  __typename: "EnvelopeDocumentsConnection";
  /**
   * A list of edges.
   */
  edges: EnvelopeUpdateStatus_envelopeUpdateStatus_envelope_documents_edges[];
}

export interface EnvelopeUpdateStatus_envelopeUpdateStatus_envelope {
  __typename: "Envelope";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  displayStatus: EnvelopeDisplayStatus;
  modifiedTime: any | null;
  readyTime: any | null;
  sentTime: any | null;
  acceptedTime: any | null;
  revokedTime: any | null;
  deletedTime: any | null;
  documents: EnvelopeUpdateStatus_envelopeUpdateStatus_envelope_documents;
}

export interface EnvelopeUpdateStatus_envelopeUpdateStatus {
  __typename: "EnvelopeUpdateStatusPayload";
  /**
   * The envelope that was updated
   */
  envelope: EnvelopeUpdateStatus_envelopeUpdateStatus_envelope;
}

export interface EnvelopeUpdateStatus {
  /**
   * Updates the status of an envelope and its member documents.
   */
  envelopeUpdateStatus: EnvelopeUpdateStatus_envelopeUpdateStatus;
}

export interface EnvelopeUpdateStatusVariables {
  input: EnvelopeUpdateStatusInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EnvelopeUpdate
// ====================================================

export interface EnvelopeUpdate_envelopeUpdate_envelope_recipientEntity_Contact_primaryAccount_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface EnvelopeUpdate_envelopeUpdate_envelope_recipientEntity_Contact_primaryAccount {
  __typename: "ContactAccountsEdge";
  node: EnvelopeUpdate_envelopeUpdate_envelope_recipientEntity_Contact_primaryAccount_node;
}

export interface EnvelopeUpdate_envelopeUpdate_envelope_recipientEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary account edge for this contact
   */
  primaryAccount: EnvelopeUpdate_envelopeUpdate_envelope_recipientEntity_Contact_primaryAccount | null;
}

export interface EnvelopeUpdate_envelopeUpdate_envelope_recipientEntity_Account_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface EnvelopeUpdate_envelopeUpdate_envelope_recipientEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary contact for this account
   */
  primaryContact: EnvelopeUpdate_envelopeUpdate_envelope_recipientEntity_Account_primaryContact | null;
}

export type EnvelopeUpdate_envelopeUpdate_envelope_recipientEntity = EnvelopeUpdate_envelopeUpdate_envelope_recipientEntity_Contact | EnvelopeUpdate_envelopeUpdate_envelope_recipientEntity_Account;

export interface EnvelopeUpdate_envelopeUpdate_envelope_documents_edges_node_documentFields {
  __typename: "DocumentField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  quoteId: string | null;
  contractId: string | null;
  direction: DocumentFieldDirection;
  type: DocumentFieldType;
  signatureValueType: DocumentSignatureValueType | null;
  label: string;
  placeholder: string | null;
  isRequired: boolean;
  entityName: string | null;
  fieldName: string | null;
  entityAttributeId: string | null;
  /**
   * Raw JSON configuration for this field.
   */
  fieldJson: string | null;
  pageNumber: number | null;
  value: string | null;
}

export interface EnvelopeUpdate_envelopeUpdate_envelope_documents_edges_node {
  __typename: "EnvelopeDocument";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  documentType: EnvelopeDocumentType;
  documentFields: EnvelopeUpdate_envelopeUpdate_envelope_documents_edges_node_documentFields[];
}

export interface EnvelopeUpdate_envelopeUpdate_envelope_documents_edges {
  __typename: "EnvelopeDocumentsEdge";
  node: EnvelopeUpdate_envelopeUpdate_envelope_documents_edges_node;
}

export interface EnvelopeUpdate_envelopeUpdate_envelope_documents {
  __typename: "EnvelopeDocumentsConnection";
  /**
   * A list of edges.
   */
  edges: EnvelopeUpdate_envelopeUpdate_envelope_documents_edges[];
}

export interface EnvelopeUpdate_envelopeUpdate_envelope {
  __typename: "Envelope";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  modifiedTime: any | null;
  validThroughTime: string | null;
  recipientEmailAddress: string | null;
  recipientEntity: EnvelopeUpdate_envelopeUpdate_envelope_recipientEntity | null;
  documents: EnvelopeUpdate_envelopeUpdate_envelope_documents;
}

export interface EnvelopeUpdate_envelopeUpdate {
  __typename: "EnvelopeUpdatePayload";
  /**
   * The envelope that was updated
   */
  envelope: EnvelopeUpdate_envelopeUpdate_envelope;
}

export interface EnvelopeUpdate {
  /**
   * Updates non-status fields on an envelope (recipient and valid-through date).
   */
  envelopeUpdate: EnvelopeUpdate_envelopeUpdate;
}

export interface EnvelopeUpdateVariables {
  input: EnvelopeUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEnvelopeForDocument
// ====================================================

export interface GetEnvelopeForDocument_envelopeForDocument_recipientEntity_Contact_primaryAccount_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetEnvelopeForDocument_envelopeForDocument_recipientEntity_Contact_primaryAccount {
  __typename: "ContactAccountsEdge";
  node: GetEnvelopeForDocument_envelopeForDocument_recipientEntity_Contact_primaryAccount_node;
}

export interface GetEnvelopeForDocument_envelopeForDocument_recipientEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary account edge for this contact
   */
  primaryAccount: GetEnvelopeForDocument_envelopeForDocument_recipientEntity_Contact_primaryAccount | null;
}

export interface GetEnvelopeForDocument_envelopeForDocument_recipientEntity_Account_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetEnvelopeForDocument_envelopeForDocument_recipientEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary contact for this account
   */
  primaryContact: GetEnvelopeForDocument_envelopeForDocument_recipientEntity_Account_primaryContact | null;
}

export type GetEnvelopeForDocument_envelopeForDocument_recipientEntity = GetEnvelopeForDocument_envelopeForDocument_recipientEntity_Contact | GetEnvelopeForDocument_envelopeForDocument_recipientEntity_Account;

export interface GetEnvelopeForDocument_envelopeForDocument_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_subtotal {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_productLineItems_edges_node_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_productLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_productLineItems_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_productLineItems_edges_node {
  __typename: "ProductLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The Nutshell product this line item is related to
   */
  product: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_productLineItems_edges_node_product | null;
  /**
   * The unmodified price of a single unit of the product
   */
  price: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_productLineItems_edges_node_price;
  /**
   * The description of the product
   */
  description: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The quantity of the product
   */
  quantity: number;
  /**
   * The formatted quantity of the product
   */
  formattedQuantity: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The unit of the discount
   */
  discountUnit: QuoteLineItemUnit | null;
  /**
   * The number of the discount
   */
  discountNumber: number | null;
  /**
   * The formatted discount
   */
  formattedDiscount: string | null;
  /**
   * The total price of the product including quantity and discount
   */
  total: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_productLineItems_edges_node_total;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_productLineItems_edges {
  __typename: "QuoteProductLineItemsEdge";
  node: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_productLineItems_edges_node;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_productLineItems {
  __typename: "QuoteProductLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_productLineItems_edges[];
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_subtotalLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_subtotalLineItems_edges_node {
  __typename: "SubtotalLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The price of the subtotal item
   */
  price: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_subtotalLineItems_edges_node_price;
  /**
   * The label of the subtotal item
   */
  label: string;
  /**
   * The unit of the subtotal item's modifier
   */
  modifierUnit: QuoteLineItemUnit;
  /**
   * The value of the subtotal item's modifier
   */
  modifierValue: number;
  /**
   * The formatted subtotal item's modifier
   */
  formattedValue: string;
  /**
   * The operation of the subtotal item
   */
  operation: QuoteLineItemOperation;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_subtotalLineItems_edges {
  __typename: "QuoteSubtotalLineItemsEdge";
  node: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_subtotalLineItems_edges_node;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_subtotalLineItems {
  __typename: "QuoteSubtotalLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_subtotalLineItems_edges[];
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The subtotal (pre-SubtotalLineItem modifiers) price of the quote
   */
  subtotal: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_subtotal;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_total;
  /**
   * The line items of the quote
   */
  productLineItems: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_productLineItems;
  /**
   * The subtotal line items of the quote
   */
  subtotalLineItems: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote_subtotalLineItems;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The time the quote was prepared
   */
  preparedTime: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * The name of the person the quote was prepared for
   */
  preparedFor: string;
  /**
   * The name of the person that prepared the quote
   */
  preparedBy: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The option chosen for how end-users will accept the quote
   */
  acceptanceMode: QuoteAcceptanceOption;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_subtotal {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_productLineItems_edges_node_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_productLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_productLineItems_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_productLineItems_edges_node {
  __typename: "ProductLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The Nutshell product this line item is related to
   */
  product: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_productLineItems_edges_node_product | null;
  /**
   * The unmodified price of a single unit of the product
   */
  price: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_productLineItems_edges_node_price;
  /**
   * The description of the product
   */
  description: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The quantity of the product
   */
  quantity: number;
  /**
   * The formatted quantity of the product
   */
  formattedQuantity: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The unit of the discount
   */
  discountUnit: QuoteLineItemUnit | null;
  /**
   * The number of the discount
   */
  discountNumber: number | null;
  /**
   * The formatted discount
   */
  formattedDiscount: string | null;
  /**
   * The total price of the product including quantity and discount
   */
  total: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_productLineItems_edges_node_total;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_productLineItems_edges {
  __typename: "QuoteProductLineItemsEdge";
  node: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_productLineItems_edges_node;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_productLineItems {
  __typename: "QuoteProductLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_productLineItems_edges[];
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_subtotalLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_subtotalLineItems_edges_node {
  __typename: "SubtotalLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The price of the subtotal item
   */
  price: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_subtotalLineItems_edges_node_price;
  /**
   * The label of the subtotal item
   */
  label: string;
  /**
   * The unit of the subtotal item's modifier
   */
  modifierUnit: QuoteLineItemUnit;
  /**
   * The value of the subtotal item's modifier
   */
  modifierValue: number;
  /**
   * The formatted subtotal item's modifier
   */
  formattedValue: string;
  /**
   * The operation of the subtotal item
   */
  operation: QuoteLineItemOperation;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_subtotalLineItems_edges {
  __typename: "QuoteSubtotalLineItemsEdge";
  node: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_subtotalLineItems_edges_node;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_subtotalLineItems {
  __typename: "QuoteSubtotalLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_subtotalLineItems_edges[];
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_canSendToQuickbooks_TrueWithReason {
  __typename: "TrueWithReason";
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_canSendToQuickbooks_FalseWithReason {
  __typename: "FalseWithReason";
  /**
   * The reason why the value is false
   */
  reason: string;
}

export type GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_canSendToQuickbooks = GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_canSendToQuickbooks_TrueWithReason | GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_canSendToQuickbooks_FalseWithReason;

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The subtotal (pre-SubtotalLineItem modifiers) price of the quote
   */
  subtotal: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_subtotal;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_total;
  /**
   * The line items of the quote
   */
  productLineItems: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_productLineItems;
  /**
   * The subtotal line items of the quote
   */
  subtotalLineItems: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_subtotalLineItems;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The time the quote was prepared
   */
  preparedTime: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * The name of the person the quote was prepared for
   */
  preparedFor: string;
  /**
   * The name of the person that prepared the quote
   */
  preparedBy: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The purchase order number
   */
  purchaseOrderNumber: string | null;
  /**
   * The customer number
   */
  customerNumber: string | null;
  /**
   * The job number
   */
  jobNumber: string | null;
  /**
   * The reference number
   */
  referenceNumber: string | null;
  /**
   * The payment and terms
   */
  paymentAndTerms: string;
  /**
   * The completion comment
   */
  completionComment: string | null;
  /**
   * A human readable string representing how long over due the invoice is
   */
  overdueDuration: string | null;
  /**
   * URL to view this invoice in QuickBooks, or null if it has not been sent to QuickBooks
   */
  quickbooksInvoiceUrl: string | null;
  /**
   * Whether the invoice can be sent to Quickbooks in its current state
   */
  canSendToQuickbooks: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice_canSendToQuickbooks;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_contract {
  __typename: "Contract";
  id: string;
  /**
   * Same-origin URL for this contract PDF.
   */
  pdfDownloadUrl: string | null;
  name: string;
  displayNumber: string;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_documentFields {
  __typename: "DocumentField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  quoteId: string | null;
  contractId: string | null;
  direction: DocumentFieldDirection;
  type: DocumentFieldType;
  signatureValueType: DocumentSignatureValueType | null;
  label: string;
  placeholder: string | null;
  isRequired: boolean;
  entityName: string | null;
  fieldName: string | null;
  entityAttributeId: string | null;
  /**
   * Raw JSON configuration for this field.
   */
  fieldJson: string | null;
  pageNumber: number | null;
  value: string | null;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges_node {
  __typename: "EnvelopeDocument";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  documentType: EnvelopeDocumentType;
  position: number;
  quote: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_quote | null;
  invoice: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_invoice | null;
  contract: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_contract | null;
  documentFields: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node_documentFields[];
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents_edges {
  __typename: "EnvelopeDocumentsEdge";
  node: GetEnvelopeForDocument_envelopeForDocument_documents_edges_node;
}

export interface GetEnvelopeForDocument_envelopeForDocument_documents {
  __typename: "EnvelopeDocumentsConnection";
  /**
   * A list of edges.
   */
  edges: GetEnvelopeForDocument_envelopeForDocument_documents_edges[];
}

export interface GetEnvelopeForDocument_envelopeForDocument {
  __typename: "Envelope";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * In-app route to the envelope primary document page.
   */
  htmlUrlPath: string;
  primaryDocumentType: EnvelopeDocumentType;
  displayStatus: EnvelopeDisplayStatus;
  publicSlug: string;
  shareableViewInBrowserLink: string;
  internalViewInBrowserLink: string;
  validThroughTime: string | null;
  readyTime: any | null;
  sentTime: any | null;
  acceptedTime: any | null;
  revokedTime: any | null;
  deletedTime: any | null;
  createdTime: any;
  modifiedTime: any | null;
  recipientEmailAddress: string | null;
  recipientEntity: GetEnvelopeForDocument_envelopeForDocument_recipientEntity | null;
  lead: GetEnvelopeForDocument_envelopeForDocument_lead;
  documents: GetEnvelopeForDocument_envelopeForDocument_documents;
}

export interface GetEnvelopeForDocument {
  envelopeForDocument: GetEnvelopeForDocument_envelopeForDocument | null;
}

export interface GetEnvelopeForDocumentVariables {
  documentId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateInvoiceFromQuote
// ====================================================

export interface CreateInvoiceFromQuote_invoiceCreateFromQuote_invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface CreateInvoiceFromQuote_invoiceCreateFromQuote {
  __typename: "InvoiceCreateFromQuotePayload";
  /**
   * The created invoice
   */
  invoice: CreateInvoiceFromQuote_invoiceCreateFromQuote_invoice;
}

export interface CreateInvoiceFromQuote {
  /**
   * Create an invoice from a quote
   */
  invoiceCreateFromQuote: CreateInvoiceFromQuote_invoiceCreateFromQuote;
}

export interface CreateInvoiceFromQuoteVariables {
  input: InvoiceCreateFromQuoteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateQuoteTemplate
// ====================================================

export interface CreateQuoteTemplate_quoteTemplateCreate_quoteTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateQuoteTemplate_quoteTemplateCreate_quoteTemplate_templateAttachedContract {
  __typename: "ContractTemplate";
  id: string;
  name: string;
  htmlUrlPath: string;
}

export interface CreateQuoteTemplate_quoteTemplateCreate_quoteTemplate {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Display name for the quote template
   */
  name: string | null;
  /**
   * The user that created the quote
   */
  creatorUser: CreateQuoteTemplate_quoteTemplateCreate_quoteTemplate_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The option chosen for how end-users will accept the quote
   */
  acceptanceMode: QuoteAcceptanceOption;
  /**
   * The contract template attached to this quote template
   */
  templateAttachedContract: CreateQuoteTemplate_quoteTemplateCreate_quoteTemplate_templateAttachedContract | null;
}

export interface CreateQuoteTemplate_quoteTemplateCreate {
  __typename: "QuoteTemplateCreatePayload";
  /**
   * The created quote template
   */
  quoteTemplate: CreateQuoteTemplate_quoteTemplateCreate_quoteTemplate;
}

export interface CreateQuoteTemplate {
  /**
   * Creates a new quote template with default content. Name can be set later while editing.
   */
  quoteTemplateCreate: CreateQuoteTemplate_quoteTemplateCreate;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateSalesDocument
// ====================================================

export interface CreateSalesDocument_salesDocumentCreate_salesDocument {
  __typename: "Quote" | "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface CreateSalesDocument_salesDocumentCreate {
  __typename: "SalesDocumentCreatePayload";
  /**
   * The sales document that was created
   */
  salesDocument: CreateSalesDocument_salesDocumentCreate_salesDocument;
}

export interface CreateSalesDocument {
  /**
   * Creates a new sales document
   */
  salesDocumentCreate: CreateSalesDocument_salesDocumentCreate;
}

export interface CreateSalesDocumentVariables {
  input: SalesDocumentCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: QuoteTemplateUpdateName
// ====================================================

export interface QuoteTemplateUpdateName_quoteTemplateUpdateName_quoteTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface QuoteTemplateUpdateName_quoteTemplateUpdateName_quoteTemplate_templateAttachedContract {
  __typename: "ContractTemplate";
  id: string;
  name: string;
  htmlUrlPath: string;
}

export interface QuoteTemplateUpdateName_quoteTemplateUpdateName_quoteTemplate {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Display name for the quote template
   */
  name: string | null;
  /**
   * The user that created the quote
   */
  creatorUser: QuoteTemplateUpdateName_quoteTemplateUpdateName_quoteTemplate_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The option chosen for how end-users will accept the quote
   */
  acceptanceMode: QuoteAcceptanceOption;
  /**
   * The contract template attached to this quote template
   */
  templateAttachedContract: QuoteTemplateUpdateName_quoteTemplateUpdateName_quoteTemplate_templateAttachedContract | null;
}

export interface QuoteTemplateUpdateName_quoteTemplateUpdateName {
  __typename: "QuoteTemplateUpdateNamePayload";
  quoteTemplate: QuoteTemplateUpdateName_quoteTemplateUpdateName_quoteTemplate;
}

export interface QuoteTemplateUpdateName {
  /**
   * Updates the display name of a quote template.
   */
  quoteTemplateUpdateName: QuoteTemplateUpdateName_quoteTemplateUpdateName;
}

export interface QuoteTemplateUpdateNameVariables {
  input: QuoteTemplateUpdateNameInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RestoreSalesDocument
// ====================================================

export interface RestoreSalesDocument_salesDocumentRestore_salesDocument {
  __typename: "Quote" | "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface RestoreSalesDocument_salesDocumentRestore {
  __typename: "SalesDocumentRestorePayload";
  /**
   * The sales document that was restored
   */
  salesDocument: RestoreSalesDocument_salesDocumentRestore_salesDocument;
}

export interface RestoreSalesDocument {
  /**
   * Restores a removed sales document
   */
  salesDocumentRestore: RestoreSalesDocument_salesDocumentRestore;
}

export interface RestoreSalesDocumentVariables {
  input: SalesDocumentRestoreInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateSalesDocumentStatus
// ====================================================

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_subtotal {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_productLineItems_edges_node_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_productLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_productLineItems_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_productLineItems_edges_node {
  __typename: "ProductLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The Nutshell product this line item is related to
   */
  product: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_productLineItems_edges_node_product | null;
  /**
   * The unmodified price of a single unit of the product
   */
  price: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_productLineItems_edges_node_price;
  /**
   * The description of the product
   */
  description: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The quantity of the product
   */
  quantity: number;
  /**
   * The formatted quantity of the product
   */
  formattedQuantity: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The unit of the discount
   */
  discountUnit: QuoteLineItemUnit | null;
  /**
   * The number of the discount
   */
  discountNumber: number | null;
  /**
   * The formatted discount
   */
  formattedDiscount: string | null;
  /**
   * The total price of the product including quantity and discount
   */
  total: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_productLineItems_edges_node_total;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_productLineItems_edges {
  __typename: "QuoteProductLineItemsEdge";
  node: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_productLineItems_edges_node;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_productLineItems {
  __typename: "QuoteProductLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_productLineItems_edges[];
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_subtotalLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_subtotalLineItems_edges_node {
  __typename: "SubtotalLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The price of the subtotal item
   */
  price: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_subtotalLineItems_edges_node_price;
  /**
   * The label of the subtotal item
   */
  label: string;
  /**
   * The unit of the subtotal item's modifier
   */
  modifierUnit: QuoteLineItemUnit;
  /**
   * The value of the subtotal item's modifier
   */
  modifierValue: number;
  /**
   * The formatted subtotal item's modifier
   */
  formattedValue: string;
  /**
   * The operation of the subtotal item
   */
  operation: QuoteLineItemOperation;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_subtotalLineItems_edges {
  __typename: "QuoteSubtotalLineItemsEdge";
  node: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_subtotalLineItems_edges_node;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_subtotalLineItems {
  __typename: "QuoteSubtotalLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_subtotalLineItems_edges[];
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The subtotal (pre-SubtotalLineItem modifiers) price of the quote
   */
  subtotal: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_subtotal;
  /**
   * The total price of the quote after all modifiers
   */
  total: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_total;
  /**
   * The line items of the quote
   */
  productLineItems: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_productLineItems;
  /**
   * The subtotal line items of the quote
   */
  subtotalLineItems: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_subtotalLineItems;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The time the quote was prepared
   */
  preparedTime: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * The name of the person the quote was prepared for
   */
  preparedFor: string;
  /**
   * The name of the person that prepared the quote
   */
  preparedBy: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The status of a quote that should be displayed to the user
   */
  displayStatus: QuoteDisplayStatus;
  /**
   * The string log of the last status update
   */
  statusLog: string;
  /**
   * The slug of the quote
   */
  slug: string;
  /**
   * The date the quote is valid until
   */
  validUntilDate: string | null;
  /**
   * The date the quote is valid until
   */
  validUntilDateFormatted: string;
  /**
   * The user that created the quote
   */
  creatorUser: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The time the quote was sent
   */
  sentTime: any | null;
  /**
   * The time the quote was accepted
   */
  acceptedTime: any | null;
  /**
   * The time the quote was revoked
   */
  revokedTime: any | null;
  /**
   * The time the quote was archived
   */
  archivedTime: any | null;
  /**
   * The time the quote was published
   */
  publishedTime: any | null;
  /**
   * The sharable view in browser link
   */
  shareableViewInBrowserLink: string;
  /**
   * The lead the quote is associated with
   */
  lead: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote_lead;
  /**
   * The option chosen for how end-users will accept the quote
   */
  acceptanceMode: QuoteAcceptanceOption;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_subtotal {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_productLineItems_edges_node_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_productLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_productLineItems_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_productLineItems_edges_node {
  __typename: "ProductLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The Nutshell product this line item is related to
   */
  product: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_productLineItems_edges_node_product | null;
  /**
   * The unmodified price of a single unit of the product
   */
  price: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_productLineItems_edges_node_price;
  /**
   * The description of the product
   */
  description: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The quantity of the product
   */
  quantity: number;
  /**
   * The formatted quantity of the product
   */
  formattedQuantity: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The unit of the discount
   */
  discountUnit: QuoteLineItemUnit | null;
  /**
   * The number of the discount
   */
  discountNumber: number | null;
  /**
   * The formatted discount
   */
  formattedDiscount: string | null;
  /**
   * The total price of the product including quantity and discount
   */
  total: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_productLineItems_edges_node_total;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_productLineItems_edges {
  __typename: "QuoteProductLineItemsEdge";
  node: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_productLineItems_edges_node;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_productLineItems {
  __typename: "QuoteProductLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_productLineItems_edges[];
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_subtotalLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_subtotalLineItems_edges_node {
  __typename: "SubtotalLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The price of the subtotal item
   */
  price: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_subtotalLineItems_edges_node_price;
  /**
   * The label of the subtotal item
   */
  label: string;
  /**
   * The unit of the subtotal item's modifier
   */
  modifierUnit: QuoteLineItemUnit;
  /**
   * The value of the subtotal item's modifier
   */
  modifierValue: number;
  /**
   * The formatted subtotal item's modifier
   */
  formattedValue: string;
  /**
   * The operation of the subtotal item
   */
  operation: QuoteLineItemOperation;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_subtotalLineItems_edges {
  __typename: "QuoteSubtotalLineItemsEdge";
  node: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_subtotalLineItems_edges_node;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_subtotalLineItems {
  __typename: "QuoteSubtotalLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_subtotalLineItems_edges[];
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The subtotal (pre-SubtotalLineItem modifiers) price of the quote
   */
  subtotal: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_subtotal;
  /**
   * The total price of the quote after all modifiers
   */
  total: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_total;
  /**
   * The line items of the quote
   */
  productLineItems: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_productLineItems;
  /**
   * The subtotal line items of the quote
   */
  subtotalLineItems: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_subtotalLineItems;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The time the quote was prepared
   */
  preparedTime: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * The name of the person the quote was prepared for
   */
  preparedFor: string;
  /**
   * The name of the person that prepared the quote
   */
  preparedBy: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The status of a quote that should be displayed to the user
   */
  displayStatus: QuoteDisplayStatus;
  /**
   * The string log of the last status update
   */
  statusLog: string;
  /**
   * The slug of the quote
   */
  slug: string;
  /**
   * The date the quote is valid until
   */
  validUntilDate: string | null;
  /**
   * The date the quote is valid until
   */
  validUntilDateFormatted: string;
  /**
   * The user that created the quote
   */
  creatorUser: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The time the quote was sent
   */
  sentTime: any | null;
  /**
   * The time the quote was accepted
   */
  acceptedTime: any | null;
  /**
   * The time the quote was revoked
   */
  revokedTime: any | null;
  /**
   * The time the quote was archived
   */
  archivedTime: any | null;
  /**
   * The time the quote was published
   */
  publishedTime: any | null;
  /**
   * The sharable view in browser link
   */
  shareableViewInBrowserLink: string;
  /**
   * The lead the quote is associated with
   */
  lead: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice_lead;
  /**
   * The purchase order number
   */
  purchaseOrderNumber: string | null;
  /**
   * The customer number
   */
  customerNumber: string | null;
  /**
   * The job number
   */
  jobNumber: string | null;
  /**
   * The reference number
   */
  referenceNumber: string | null;
  /**
   * The payment and terms
   */
  paymentAndTerms: string;
  /**
   * The completion comment
   */
  completionComment: string | null;
  /**
   * A human readable string representing how long over due the invoice is
   */
  overdueDuration: string | null;
}

export type UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument = UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Quote | UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument_Invoice;

export interface UpdateSalesDocumentStatus_salesDocumentUpdateStatus {
  __typename: "SalesDocumentUpdateStatusPayload";
  /**
   * The sales document that was updated
   */
  salesDocument: UpdateSalesDocumentStatus_salesDocumentUpdateStatus_salesDocument;
}

export interface UpdateSalesDocumentStatus {
  /**
   * Updates the status of a sales document
   */
  salesDocumentUpdateStatus: UpdateSalesDocumentStatus_salesDocumentUpdateStatus;
}

export interface UpdateSalesDocumentStatusVariables {
  input: SalesDocumentUpdateStatusInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateQuoteProduct
// ====================================================

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_subtotal {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_productLineItems_edges_node_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_productLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_productLineItems_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_productLineItems_edges_node {
  __typename: "ProductLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The Nutshell product this line item is related to
   */
  product: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_productLineItems_edges_node_product | null;
  /**
   * The unmodified price of a single unit of the product
   */
  price: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_productLineItems_edges_node_price;
  /**
   * The description of the product
   */
  description: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The quantity of the product
   */
  quantity: number;
  /**
   * The formatted quantity of the product
   */
  formattedQuantity: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The unit of the discount
   */
  discountUnit: QuoteLineItemUnit | null;
  /**
   * The number of the discount
   */
  discountNumber: number | null;
  /**
   * The formatted discount
   */
  formattedDiscount: string | null;
  /**
   * The total price of the product including quantity and discount
   */
  total: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_productLineItems_edges_node_total;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_productLineItems_edges {
  __typename: "QuoteProductLineItemsEdge";
  node: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_productLineItems_edges_node;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_productLineItems {
  __typename: "QuoteProductLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_productLineItems_edges[];
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_subtotalLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_subtotalLineItems_edges_node {
  __typename: "SubtotalLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The price of the subtotal item
   */
  price: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_subtotalLineItems_edges_node_price;
  /**
   * The label of the subtotal item
   */
  label: string;
  /**
   * The unit of the subtotal item's modifier
   */
  modifierUnit: QuoteLineItemUnit;
  /**
   * The value of the subtotal item's modifier
   */
  modifierValue: number;
  /**
   * The formatted subtotal item's modifier
   */
  formattedValue: string;
  /**
   * The operation of the subtotal item
   */
  operation: QuoteLineItemOperation;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_subtotalLineItems_edges {
  __typename: "QuoteSubtotalLineItemsEdge";
  node: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_subtotalLineItems_edges_node;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_subtotalLineItems {
  __typename: "QuoteSubtotalLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_subtotalLineItems_edges[];
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The subtotal (pre-SubtotalLineItem modifiers) price of the quote
   */
  subtotal: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_subtotal;
  /**
   * The total price of the quote after all modifiers
   */
  total: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_total;
  /**
   * The line items of the quote
   */
  productLineItems: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_productLineItems;
  /**
   * The subtotal line items of the quote
   */
  subtotalLineItems: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_subtotalLineItems;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The time the quote was prepared
   */
  preparedTime: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * The name of the person the quote was prepared for
   */
  preparedFor: string;
  /**
   * The name of the person that prepared the quote
   */
  preparedBy: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The status of a quote that should be displayed to the user
   */
  displayStatus: QuoteDisplayStatus;
  /**
   * The string log of the last status update
   */
  statusLog: string;
  /**
   * The slug of the quote
   */
  slug: string;
  /**
   * The date the quote is valid until
   */
  validUntilDate: string | null;
  /**
   * The date the quote is valid until
   */
  validUntilDateFormatted: string;
  /**
   * The user that created the quote
   */
  creatorUser: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The time the quote was sent
   */
  sentTime: any | null;
  /**
   * The time the quote was accepted
   */
  acceptedTime: any | null;
  /**
   * The time the quote was revoked
   */
  revokedTime: any | null;
  /**
   * The time the quote was archived
   */
  archivedTime: any | null;
  /**
   * The time the quote was published
   */
  publishedTime: any | null;
  /**
   * The sharable view in browser link
   */
  shareableViewInBrowserLink: string;
  /**
   * The lead the quote is associated with
   */
  lead: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote_lead;
  /**
   * The option chosen for how end-users will accept the quote
   */
  acceptanceMode: QuoteAcceptanceOption;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_subtotal {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_productLineItems_edges_node_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_productLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_productLineItems_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_productLineItems_edges_node {
  __typename: "ProductLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The Nutshell product this line item is related to
   */
  product: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_productLineItems_edges_node_product | null;
  /**
   * The unmodified price of a single unit of the product
   */
  price: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_productLineItems_edges_node_price;
  /**
   * The description of the product
   */
  description: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The quantity of the product
   */
  quantity: number;
  /**
   * The formatted quantity of the product
   */
  formattedQuantity: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The unit of the discount
   */
  discountUnit: QuoteLineItemUnit | null;
  /**
   * The number of the discount
   */
  discountNumber: number | null;
  /**
   * The formatted discount
   */
  formattedDiscount: string | null;
  /**
   * The total price of the product including quantity and discount
   */
  total: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_productLineItems_edges_node_total;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_productLineItems_edges {
  __typename: "QuoteProductLineItemsEdge";
  node: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_productLineItems_edges_node;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_productLineItems {
  __typename: "QuoteProductLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_productLineItems_edges[];
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_subtotalLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_subtotalLineItems_edges_node {
  __typename: "SubtotalLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The price of the subtotal item
   */
  price: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_subtotalLineItems_edges_node_price;
  /**
   * The label of the subtotal item
   */
  label: string;
  /**
   * The unit of the subtotal item's modifier
   */
  modifierUnit: QuoteLineItemUnit;
  /**
   * The value of the subtotal item's modifier
   */
  modifierValue: number;
  /**
   * The formatted subtotal item's modifier
   */
  formattedValue: string;
  /**
   * The operation of the subtotal item
   */
  operation: QuoteLineItemOperation;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_subtotalLineItems_edges {
  __typename: "QuoteSubtotalLineItemsEdge";
  node: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_subtotalLineItems_edges_node;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_subtotalLineItems {
  __typename: "QuoteSubtotalLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_subtotalLineItems_edges[];
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The subtotal (pre-SubtotalLineItem modifiers) price of the quote
   */
  subtotal: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_subtotal;
  /**
   * The total price of the quote after all modifiers
   */
  total: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_total;
  /**
   * The line items of the quote
   */
  productLineItems: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_productLineItems;
  /**
   * The subtotal line items of the quote
   */
  subtotalLineItems: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_subtotalLineItems;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The time the quote was prepared
   */
  preparedTime: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * The name of the person the quote was prepared for
   */
  preparedFor: string;
  /**
   * The name of the person that prepared the quote
   */
  preparedBy: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The status of a quote that should be displayed to the user
   */
  displayStatus: QuoteDisplayStatus;
  /**
   * The string log of the last status update
   */
  statusLog: string;
  /**
   * The slug of the quote
   */
  slug: string;
  /**
   * The date the quote is valid until
   */
  validUntilDate: string | null;
  /**
   * The date the quote is valid until
   */
  validUntilDateFormatted: string;
  /**
   * The user that created the quote
   */
  creatorUser: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The time the quote was sent
   */
  sentTime: any | null;
  /**
   * The time the quote was accepted
   */
  acceptedTime: any | null;
  /**
   * The time the quote was revoked
   */
  revokedTime: any | null;
  /**
   * The time the quote was archived
   */
  archivedTime: any | null;
  /**
   * The time the quote was published
   */
  publishedTime: any | null;
  /**
   * The sharable view in browser link
   */
  shareableViewInBrowserLink: string;
  /**
   * The lead the quote is associated with
   */
  lead: UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice_lead;
  /**
   * The purchase order number
   */
  purchaseOrderNumber: string | null;
  /**
   * The customer number
   */
  customerNumber: string | null;
  /**
   * The job number
   */
  jobNumber: string | null;
  /**
   * The reference number
   */
  referenceNumber: string | null;
  /**
   * The payment and terms
   */
  paymentAndTerms: string;
  /**
   * The completion comment
   */
  completionComment: string | null;
  /**
   * A human readable string representing how long over due the invoice is
   */
  overdueDuration: string | null;
}

export type UpdateQuoteProduct_quoteProductsUpdate_salesDocument = UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Quote | UpdateQuoteProduct_quoteProductsUpdate_salesDocument_Invoice;

export interface UpdateQuoteProduct_quoteProductsUpdate {
  __typename: "QuoteProductsUpdatePayload";
  /**
   * The sales document that was edited
   */
  salesDocument: UpdateQuoteProduct_quoteProductsUpdate_salesDocument;
}

export interface UpdateQuoteProduct {
  /**
   * Edit the product table on a quote
   */
  quoteProductsUpdate: UpdateQuoteProduct_quoteProductsUpdate;
}

export interface UpdateQuoteProductVariables {
  input: QuoteProductsUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateQuoteSubtotal
// ====================================================

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_subtotal {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_productLineItems_edges_node_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_productLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_productLineItems_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_productLineItems_edges_node {
  __typename: "ProductLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The Nutshell product this line item is related to
   */
  product: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_productLineItems_edges_node_product | null;
  /**
   * The unmodified price of a single unit of the product
   */
  price: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_productLineItems_edges_node_price;
  /**
   * The description of the product
   */
  description: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The quantity of the product
   */
  quantity: number;
  /**
   * The formatted quantity of the product
   */
  formattedQuantity: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The unit of the discount
   */
  discountUnit: QuoteLineItemUnit | null;
  /**
   * The number of the discount
   */
  discountNumber: number | null;
  /**
   * The formatted discount
   */
  formattedDiscount: string | null;
  /**
   * The total price of the product including quantity and discount
   */
  total: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_productLineItems_edges_node_total;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_productLineItems_edges {
  __typename: "QuoteProductLineItemsEdge";
  node: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_productLineItems_edges_node;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_productLineItems {
  __typename: "QuoteProductLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_productLineItems_edges[];
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_subtotalLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_subtotalLineItems_edges_node {
  __typename: "SubtotalLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The price of the subtotal item
   */
  price: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_subtotalLineItems_edges_node_price;
  /**
   * The label of the subtotal item
   */
  label: string;
  /**
   * The unit of the subtotal item's modifier
   */
  modifierUnit: QuoteLineItemUnit;
  /**
   * The value of the subtotal item's modifier
   */
  modifierValue: number;
  /**
   * The formatted subtotal item's modifier
   */
  formattedValue: string;
  /**
   * The operation of the subtotal item
   */
  operation: QuoteLineItemOperation;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_subtotalLineItems_edges {
  __typename: "QuoteSubtotalLineItemsEdge";
  node: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_subtotalLineItems_edges_node;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_subtotalLineItems {
  __typename: "QuoteSubtotalLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_subtotalLineItems_edges[];
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The subtotal (pre-SubtotalLineItem modifiers) price of the quote
   */
  subtotal: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_subtotal;
  /**
   * The total price of the quote after all modifiers
   */
  total: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_total;
  /**
   * The line items of the quote
   */
  productLineItems: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_productLineItems;
  /**
   * The subtotal line items of the quote
   */
  subtotalLineItems: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_subtotalLineItems;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The time the quote was prepared
   */
  preparedTime: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * The name of the person the quote was prepared for
   */
  preparedFor: string;
  /**
   * The name of the person that prepared the quote
   */
  preparedBy: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The status of a quote that should be displayed to the user
   */
  displayStatus: QuoteDisplayStatus;
  /**
   * The string log of the last status update
   */
  statusLog: string;
  /**
   * The slug of the quote
   */
  slug: string;
  /**
   * The date the quote is valid until
   */
  validUntilDate: string | null;
  /**
   * The date the quote is valid until
   */
  validUntilDateFormatted: string;
  /**
   * The user that created the quote
   */
  creatorUser: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The time the quote was sent
   */
  sentTime: any | null;
  /**
   * The time the quote was accepted
   */
  acceptedTime: any | null;
  /**
   * The time the quote was revoked
   */
  revokedTime: any | null;
  /**
   * The time the quote was archived
   */
  archivedTime: any | null;
  /**
   * The time the quote was published
   */
  publishedTime: any | null;
  /**
   * The sharable view in browser link
   */
  shareableViewInBrowserLink: string;
  /**
   * The lead the quote is associated with
   */
  lead: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote_lead;
  /**
   * The option chosen for how end-users will accept the quote
   */
  acceptanceMode: QuoteAcceptanceOption;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_subtotal {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_productLineItems_edges_node_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_productLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_productLineItems_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_productLineItems_edges_node {
  __typename: "ProductLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The Nutshell product this line item is related to
   */
  product: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_productLineItems_edges_node_product | null;
  /**
   * The unmodified price of a single unit of the product
   */
  price: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_productLineItems_edges_node_price;
  /**
   * The description of the product
   */
  description: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The quantity of the product
   */
  quantity: number;
  /**
   * The formatted quantity of the product
   */
  formattedQuantity: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The unit of the discount
   */
  discountUnit: QuoteLineItemUnit | null;
  /**
   * The number of the discount
   */
  discountNumber: number | null;
  /**
   * The formatted discount
   */
  formattedDiscount: string | null;
  /**
   * The total price of the product including quantity and discount
   */
  total: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_productLineItems_edges_node_total;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_productLineItems_edges {
  __typename: "QuoteProductLineItemsEdge";
  node: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_productLineItems_edges_node;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_productLineItems {
  __typename: "QuoteProductLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_productLineItems_edges[];
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_subtotalLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_subtotalLineItems_edges_node {
  __typename: "SubtotalLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The price of the subtotal item
   */
  price: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_subtotalLineItems_edges_node_price;
  /**
   * The label of the subtotal item
   */
  label: string;
  /**
   * The unit of the subtotal item's modifier
   */
  modifierUnit: QuoteLineItemUnit;
  /**
   * The value of the subtotal item's modifier
   */
  modifierValue: number;
  /**
   * The formatted subtotal item's modifier
   */
  formattedValue: string;
  /**
   * The operation of the subtotal item
   */
  operation: QuoteLineItemOperation;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_subtotalLineItems_edges {
  __typename: "QuoteSubtotalLineItemsEdge";
  node: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_subtotalLineItems_edges_node;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_subtotalLineItems {
  __typename: "QuoteSubtotalLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_subtotalLineItems_edges[];
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The subtotal (pre-SubtotalLineItem modifiers) price of the quote
   */
  subtotal: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_subtotal;
  /**
   * The total price of the quote after all modifiers
   */
  total: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_total;
  /**
   * The line items of the quote
   */
  productLineItems: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_productLineItems;
  /**
   * The subtotal line items of the quote
   */
  subtotalLineItems: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_subtotalLineItems;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The time the quote was prepared
   */
  preparedTime: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * The name of the person the quote was prepared for
   */
  preparedFor: string;
  /**
   * The name of the person that prepared the quote
   */
  preparedBy: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The status of a quote that should be displayed to the user
   */
  displayStatus: QuoteDisplayStatus;
  /**
   * The string log of the last status update
   */
  statusLog: string;
  /**
   * The slug of the quote
   */
  slug: string;
  /**
   * The date the quote is valid until
   */
  validUntilDate: string | null;
  /**
   * The date the quote is valid until
   */
  validUntilDateFormatted: string;
  /**
   * The user that created the quote
   */
  creatorUser: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The time the quote was sent
   */
  sentTime: any | null;
  /**
   * The time the quote was accepted
   */
  acceptedTime: any | null;
  /**
   * The time the quote was revoked
   */
  revokedTime: any | null;
  /**
   * The time the quote was archived
   */
  archivedTime: any | null;
  /**
   * The time the quote was published
   */
  publishedTime: any | null;
  /**
   * The sharable view in browser link
   */
  shareableViewInBrowserLink: string;
  /**
   * The lead the quote is associated with
   */
  lead: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice_lead;
  /**
   * The purchase order number
   */
  purchaseOrderNumber: string | null;
  /**
   * The customer number
   */
  customerNumber: string | null;
  /**
   * The job number
   */
  jobNumber: string | null;
  /**
   * The reference number
   */
  referenceNumber: string | null;
  /**
   * The payment and terms
   */
  paymentAndTerms: string;
  /**
   * The completion comment
   */
  completionComment: string | null;
  /**
   * A human readable string representing how long over due the invoice is
   */
  overdueDuration: string | null;
}

export type UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument = UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Quote | UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument_Invoice;

export interface UpdateQuoteSubtotal_quoteSubtotalItemsUpdate {
  __typename: "QuoteSubtotalItemsUpdatePayload";
  /**
   * The sales document that was edited
   */
  salesDocument: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate_salesDocument;
}

export interface UpdateQuoteSubtotal {
  /**
   * Edit the subtotal table on a quote
   */
  quoteSubtotalItemsUpdate: UpdateQuoteSubtotal_quoteSubtotalItemsUpdate;
}

export interface UpdateQuoteSubtotalVariables {
  input: QuoteSubtotalItemsUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateQuoteTemplateProduct
// ====================================================

export interface UpdateQuoteTemplateProduct_quoteProductsUpdate_salesDocument_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateQuoteTemplateProduct_quoteProductsUpdate_salesDocument_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that created the quote
   */
  creatorUser: UpdateQuoteTemplateProduct_quoteProductsUpdate_salesDocument_Quote_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
}

export interface UpdateQuoteTemplateProduct_quoteProductsUpdate_salesDocument_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateQuoteTemplateProduct_quoteProductsUpdate_salesDocument_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that created the quote
   */
  creatorUser: UpdateQuoteTemplateProduct_quoteProductsUpdate_salesDocument_Invoice_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The purchase order number
   */
  purchaseOrderNumber: string | null;
  /**
   * The job number
   */
  jobNumber: string | null;
  /**
   * The customer number
   */
  customerNumber: string | null;
  /**
   * The reference number
   */
  referenceNumber: string | null;
  /**
   * The payment and terms
   */
  paymentAndTerms: string;
}

export type UpdateQuoteTemplateProduct_quoteProductsUpdate_salesDocument = UpdateQuoteTemplateProduct_quoteProductsUpdate_salesDocument_Quote | UpdateQuoteTemplateProduct_quoteProductsUpdate_salesDocument_Invoice;

export interface UpdateQuoteTemplateProduct_quoteProductsUpdate {
  __typename: "QuoteProductsUpdatePayload";
  /**
   * The sales document that was edited
   */
  salesDocument: UpdateQuoteTemplateProduct_quoteProductsUpdate_salesDocument;
}

export interface UpdateQuoteTemplateProduct {
  /**
   * Edit the product table on a quote
   */
  quoteProductsUpdate: UpdateQuoteTemplateProduct_quoteProductsUpdate;
}

export interface UpdateQuoteTemplateProductVariables {
  input: QuoteProductsUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateSalesDocumentTemplate
// ====================================================

export interface UpdateSalesDocumentTemplate_salesDocumentUpdate_salesDocument_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateSalesDocumentTemplate_salesDocumentUpdate_salesDocument_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that created the quote
   */
  creatorUser: UpdateSalesDocumentTemplate_salesDocumentUpdate_salesDocument_Quote_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
}

export interface UpdateSalesDocumentTemplate_salesDocumentUpdate_salesDocument_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateSalesDocumentTemplate_salesDocumentUpdate_salesDocument_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that created the quote
   */
  creatorUser: UpdateSalesDocumentTemplate_salesDocumentUpdate_salesDocument_Invoice_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The purchase order number
   */
  purchaseOrderNumber: string | null;
  /**
   * The job number
   */
  jobNumber: string | null;
  /**
   * The customer number
   */
  customerNumber: string | null;
  /**
   * The reference number
   */
  referenceNumber: string | null;
  /**
   * The payment and terms
   */
  paymentAndTerms: string;
}

export type UpdateSalesDocumentTemplate_salesDocumentUpdate_salesDocument = UpdateSalesDocumentTemplate_salesDocumentUpdate_salesDocument_Quote | UpdateSalesDocumentTemplate_salesDocumentUpdate_salesDocument_Invoice;

export interface UpdateSalesDocumentTemplate_salesDocumentUpdate {
  __typename: "SalesDocumentUpdatePayload";
  /**
   * The sales document that was edited
   */
  salesDocument: UpdateSalesDocumentTemplate_salesDocumentUpdate_salesDocument;
}

export interface UpdateSalesDocumentTemplate {
  /**
   * Update a sales document
   */
  salesDocumentUpdate: UpdateSalesDocumentTemplate_salesDocumentUpdate;
}

export interface UpdateSalesDocumentTemplateVariables {
  input: SalesDocumentUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateSalesDocument
// ====================================================

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_subtotal {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_productLineItems_edges_node_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_productLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_productLineItems_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_productLineItems_edges_node {
  __typename: "ProductLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The Nutshell product this line item is related to
   */
  product: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_productLineItems_edges_node_product | null;
  /**
   * The unmodified price of a single unit of the product
   */
  price: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_productLineItems_edges_node_price;
  /**
   * The description of the product
   */
  description: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The quantity of the product
   */
  quantity: number;
  /**
   * The formatted quantity of the product
   */
  formattedQuantity: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The unit of the discount
   */
  discountUnit: QuoteLineItemUnit | null;
  /**
   * The number of the discount
   */
  discountNumber: number | null;
  /**
   * The formatted discount
   */
  formattedDiscount: string | null;
  /**
   * The total price of the product including quantity and discount
   */
  total: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_productLineItems_edges_node_total;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_productLineItems_edges {
  __typename: "QuoteProductLineItemsEdge";
  node: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_productLineItems_edges_node;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_productLineItems {
  __typename: "QuoteProductLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_productLineItems_edges[];
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_subtotalLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_subtotalLineItems_edges_node {
  __typename: "SubtotalLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The price of the subtotal item
   */
  price: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_subtotalLineItems_edges_node_price;
  /**
   * The label of the subtotal item
   */
  label: string;
  /**
   * The unit of the subtotal item's modifier
   */
  modifierUnit: QuoteLineItemUnit;
  /**
   * The value of the subtotal item's modifier
   */
  modifierValue: number;
  /**
   * The formatted subtotal item's modifier
   */
  formattedValue: string;
  /**
   * The operation of the subtotal item
   */
  operation: QuoteLineItemOperation;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_subtotalLineItems_edges {
  __typename: "QuoteSubtotalLineItemsEdge";
  node: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_subtotalLineItems_edges_node;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_subtotalLineItems {
  __typename: "QuoteSubtotalLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_subtotalLineItems_edges[];
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The subtotal (pre-SubtotalLineItem modifiers) price of the quote
   */
  subtotal: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_subtotal;
  /**
   * The total price of the quote after all modifiers
   */
  total: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_total;
  /**
   * The line items of the quote
   */
  productLineItems: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_productLineItems;
  /**
   * The subtotal line items of the quote
   */
  subtotalLineItems: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_subtotalLineItems;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The time the quote was prepared
   */
  preparedTime: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * The name of the person the quote was prepared for
   */
  preparedFor: string;
  /**
   * The name of the person that prepared the quote
   */
  preparedBy: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The status of a quote that should be displayed to the user
   */
  displayStatus: QuoteDisplayStatus;
  /**
   * The string log of the last status update
   */
  statusLog: string;
  /**
   * The slug of the quote
   */
  slug: string;
  /**
   * The date the quote is valid until
   */
  validUntilDate: string | null;
  /**
   * The date the quote is valid until
   */
  validUntilDateFormatted: string;
  /**
   * The user that created the quote
   */
  creatorUser: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The time the quote was sent
   */
  sentTime: any | null;
  /**
   * The time the quote was accepted
   */
  acceptedTime: any | null;
  /**
   * The time the quote was revoked
   */
  revokedTime: any | null;
  /**
   * The time the quote was archived
   */
  archivedTime: any | null;
  /**
   * The time the quote was published
   */
  publishedTime: any | null;
  /**
   * The sharable view in browser link
   */
  shareableViewInBrowserLink: string;
  /**
   * The lead the quote is associated with
   */
  lead: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote_lead;
  /**
   * The option chosen for how end-users will accept the quote
   */
  acceptanceMode: QuoteAcceptanceOption;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_subtotal {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_productLineItems_edges_node_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_productLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_productLineItems_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_productLineItems_edges_node {
  __typename: "ProductLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The Nutshell product this line item is related to
   */
  product: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_productLineItems_edges_node_product | null;
  /**
   * The unmodified price of a single unit of the product
   */
  price: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_productLineItems_edges_node_price;
  /**
   * The description of the product
   */
  description: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The quantity of the product
   */
  quantity: number;
  /**
   * The formatted quantity of the product
   */
  formattedQuantity: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The unit of the discount
   */
  discountUnit: QuoteLineItemUnit | null;
  /**
   * The number of the discount
   */
  discountNumber: number | null;
  /**
   * The formatted discount
   */
  formattedDiscount: string | null;
  /**
   * The total price of the product including quantity and discount
   */
  total: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_productLineItems_edges_node_total;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_productLineItems_edges {
  __typename: "QuoteProductLineItemsEdge";
  node: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_productLineItems_edges_node;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_productLineItems {
  __typename: "QuoteProductLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_productLineItems_edges[];
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_subtotalLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_subtotalLineItems_edges_node {
  __typename: "SubtotalLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The price of the subtotal item
   */
  price: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_subtotalLineItems_edges_node_price;
  /**
   * The label of the subtotal item
   */
  label: string;
  /**
   * The unit of the subtotal item's modifier
   */
  modifierUnit: QuoteLineItemUnit;
  /**
   * The value of the subtotal item's modifier
   */
  modifierValue: number;
  /**
   * The formatted subtotal item's modifier
   */
  formattedValue: string;
  /**
   * The operation of the subtotal item
   */
  operation: QuoteLineItemOperation;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_subtotalLineItems_edges {
  __typename: "QuoteSubtotalLineItemsEdge";
  node: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_subtotalLineItems_edges_node;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_subtotalLineItems {
  __typename: "QuoteSubtotalLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_subtotalLineItems_edges[];
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The subtotal (pre-SubtotalLineItem modifiers) price of the quote
   */
  subtotal: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_subtotal;
  /**
   * The total price of the quote after all modifiers
   */
  total: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_total;
  /**
   * The line items of the quote
   */
  productLineItems: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_productLineItems;
  /**
   * The subtotal line items of the quote
   */
  subtotalLineItems: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_subtotalLineItems;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The time the quote was prepared
   */
  preparedTime: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * The name of the person the quote was prepared for
   */
  preparedFor: string;
  /**
   * The name of the person that prepared the quote
   */
  preparedBy: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The status of a quote that should be displayed to the user
   */
  displayStatus: QuoteDisplayStatus;
  /**
   * The string log of the last status update
   */
  statusLog: string;
  /**
   * The slug of the quote
   */
  slug: string;
  /**
   * The date the quote is valid until
   */
  validUntilDate: string | null;
  /**
   * The date the quote is valid until
   */
  validUntilDateFormatted: string;
  /**
   * The user that created the quote
   */
  creatorUser: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The time the quote was sent
   */
  sentTime: any | null;
  /**
   * The time the quote was accepted
   */
  acceptedTime: any | null;
  /**
   * The time the quote was revoked
   */
  revokedTime: any | null;
  /**
   * The time the quote was archived
   */
  archivedTime: any | null;
  /**
   * The time the quote was published
   */
  publishedTime: any | null;
  /**
   * The sharable view in browser link
   */
  shareableViewInBrowserLink: string;
  /**
   * The lead the quote is associated with
   */
  lead: UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice_lead;
  /**
   * The purchase order number
   */
  purchaseOrderNumber: string | null;
  /**
   * The customer number
   */
  customerNumber: string | null;
  /**
   * The job number
   */
  jobNumber: string | null;
  /**
   * The reference number
   */
  referenceNumber: string | null;
  /**
   * The payment and terms
   */
  paymentAndTerms: string;
  /**
   * The completion comment
   */
  completionComment: string | null;
  /**
   * A human readable string representing how long over due the invoice is
   */
  overdueDuration: string | null;
}

export type UpdateSalesDocument_salesDocumentUpdate_salesDocument = UpdateSalesDocument_salesDocumentUpdate_salesDocument_Quote | UpdateSalesDocument_salesDocumentUpdate_salesDocument_Invoice;

export interface UpdateSalesDocument_salesDocumentUpdate_envelope {
  __typename: "Envelope";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  validThroughTime: string | null;
}

export interface UpdateSalesDocument_salesDocumentUpdate {
  __typename: "SalesDocumentUpdatePayload";
  /**
   * The sales document that was edited
   */
  salesDocument: UpdateSalesDocument_salesDocumentUpdate_salesDocument;
  /**
   * The envelope attached to the sales document
   */
  envelope: UpdateSalesDocument_salesDocumentUpdate_envelope | null;
}

export interface UpdateSalesDocument {
  /**
   * Update a sales document
   */
  salesDocumentUpdate: UpdateSalesDocument_salesDocumentUpdate;
}

export interface UpdateSalesDocumentVariables {
  input: SalesDocumentUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetInvoiceTemplate
// ====================================================

export interface GetInvoiceTemplate_invoiceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetInvoiceTemplate_invoiceTemplate_canSendToQuickbooks_TrueWithReason {
  __typename: "TrueWithReason";
}

export interface GetInvoiceTemplate_invoiceTemplate_canSendToQuickbooks_FalseWithReason {
  __typename: "FalseWithReason";
  /**
   * The reason why the value is false
   */
  reason: string;
}

export type GetInvoiceTemplate_invoiceTemplate_canSendToQuickbooks = GetInvoiceTemplate_invoiceTemplate_canSendToQuickbooks_TrueWithReason | GetInvoiceTemplate_invoiceTemplate_canSendToQuickbooks_FalseWithReason;

export interface GetInvoiceTemplate_invoiceTemplate {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that created the quote
   */
  creatorUser: GetInvoiceTemplate_invoiceTemplate_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The purchase order number
   */
  purchaseOrderNumber: string | null;
  /**
   * The job number
   */
  jobNumber: string | null;
  /**
   * The customer number
   */
  customerNumber: string | null;
  /**
   * The reference number
   */
  referenceNumber: string | null;
  /**
   * The payment and terms
   */
  paymentAndTerms: string;
  /**
   * Whether the signature should be shown
   */
  isSignatureShown: boolean;
  /**
   * Whether the invoice can be sent to Quickbooks in its current state
   */
  canSendToQuickbooks: GetInvoiceTemplate_invoiceTemplate_canSendToQuickbooks;
  /**
   * URL to view this invoice in QuickBooks, or null if it has not been sent to QuickBooks
   */
  quickbooksInvoiceUrl: string | null;
}

export interface GetInvoiceTemplate {
  /**
   * Returns the template invoice for the instance
   */
  invoiceTemplate: GetInvoiceTemplate_invoiceTemplate;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPossibleProducts
// ====================================================

export interface GetPossibleProducts_quotePossibleProducts_edges_marketPrice {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetPossibleProducts_quotePossibleProducts_edges_node_category {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
}

export interface GetPossibleProducts_quotePossibleProducts_edges_node {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The description of the product
   */
  description: string | null;
  /**
   * The category of the product
   */
  category: GetPossibleProducts_quotePossibleProducts_edges_node_category | null;
}

export interface GetPossibleProducts_quotePossibleProducts_edges {
  __typename: "QuotePossibleProductsEdge";
  /**
   * The price of this product in the quotes market
   */
  marketPrice: GetPossibleProducts_quotePossibleProducts_edges_marketPrice | null;
  node: GetPossibleProducts_quotePossibleProducts_edges_node;
}

export interface GetPossibleProducts_quotePossibleProducts {
  __typename: "QuotePossibleProductsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetPossibleProducts_quotePossibleProducts_edges[];
}

export interface GetPossibleProducts {
  /**
   * Returns possible products that can be attached to this quote
   */
  quotePossibleProducts: GetPossibleProducts_quotePossibleProducts;
}

export interface GetPossibleProductsVariables {
  quoteId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetQuoteTemplateById
// ====================================================

export interface GetQuoteTemplateById_quoteTemplateById_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetQuoteTemplateById_quoteTemplateById_templateAttachedContract {
  __typename: "ContractTemplate";
  id: string;
  name: string;
  htmlUrlPath: string;
}

export interface GetQuoteTemplateById_quoteTemplateById {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Display name for the quote template
   */
  name: string | null;
  /**
   * The user that created the quote
   */
  creatorUser: GetQuoteTemplateById_quoteTemplateById_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The option chosen for how end-users will accept the quote
   */
  acceptanceMode: QuoteAcceptanceOption;
  /**
   * The contract template attached to this quote template
   */
  templateAttachedContract: GetQuoteTemplateById_quoteTemplateById_templateAttachedContract | null;
}

export interface GetQuoteTemplateById {
  /**
   * Returns a quote template by ID
   */
  quoteTemplateById: GetQuoteTemplateById_quoteTemplateById;
}

export interface GetQuoteTemplateByIdVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetQuoteTemplate
// ====================================================

export interface GetQuoteTemplate_quoteTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetQuoteTemplate_quoteTemplate_templateAttachedContract {
  __typename: "ContractTemplate";
  id: string;
  name: string;
  htmlUrlPath: string;
}

export interface GetQuoteTemplate_quoteTemplate {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Display name for the quote template
   */
  name: string | null;
  /**
   * The user that created the quote
   */
  creatorUser: GetQuoteTemplate_quoteTemplate_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The option chosen for how end-users will accept the quote
   */
  acceptanceMode: QuoteAcceptanceOption;
  /**
   * The contract template attached to this quote template
   */
  templateAttachedContract: GetQuoteTemplate_quoteTemplate_templateAttachedContract | null;
}

export interface GetQuoteTemplate {
  /**
   * Returns the template quote for the instance
   */
  quoteTemplate: GetQuoteTemplate_quoteTemplate;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetQuoteTemplates
// ====================================================

export interface GetQuoteTemplates_quoteTemplates_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetQuoteTemplates_quoteTemplates_templateAttachedContract {
  __typename: "ContractTemplate";
  id: string;
  name: string;
  htmlUrlPath: string;
}

export interface GetQuoteTemplates_quoteTemplates {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Display name for the quote template
   */
  name: string | null;
  /**
   * The user that created the quote
   */
  creatorUser: GetQuoteTemplates_quoteTemplates_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The option chosen for how end-users will accept the quote
   */
  acceptanceMode: QuoteAcceptanceOption;
  /**
   * The contract template attached to this quote template
   */
  templateAttachedContract: GetQuoteTemplates_quoteTemplates_templateAttachedContract | null;
}

export interface GetQuoteTemplates {
  /**
   * Returns all quote templates for the instance. Creates a default template if none exist.
   */
  quoteTemplates: GetQuoteTemplates_quoteTemplates[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserNames
// ====================================================

export interface GetUserNames_users_edges_node {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetUserNames_users_edges {
  __typename: "UsersEdge";
  node: GetUserNames_users_edges_node;
}

export interface GetUserNames_users {
  __typename: "UsersConnection";
  /**
   * A list of edges.
   */
  edges: GetUserNames_users_edges[];
}

export interface GetUserNames {
  /**
   * Returns a paging connection of users from the root of our query.
   */
  users: GetUserNames_users;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SubscribeGoogleMeetWebhooks
// ====================================================

export interface SubscribeGoogleMeetWebhooks_googleMeetWebhooksSubscribe_googleMeetIntegration {
  __typename: "GoogleMeetIntegration";
  /**
   * Whether or not the  Google Meet integration is enabled with calendar sync
   */
  isEnabledCalendarSync: boolean;
  /**
   * Whether or not the Google Meet integration is enabled with meet sync
   */
  isEnabledMeetSync: boolean;
  /**
   * The email address of the Google Meet user
   */
  email: string | null;
}

export interface SubscribeGoogleMeetWebhooks_googleMeetWebhooksSubscribe {
  __typename: "GoogleMeetWebhooksSubscribePayload";
  /**
   * Information about the Google Meet integration
   */
  googleMeetIntegration: SubscribeGoogleMeetWebhooks_googleMeetWebhooksSubscribe_googleMeetIntegration;
}

export interface SubscribeGoogleMeetWebhooks {
  /**
   * Subscribe or unsubscribe to Google Meet webhooks.
   */
  googleMeetWebhooksSubscribe: SubscribeGoogleMeetWebhooks_googleMeetWebhooksSubscribe | null;
}

export interface SubscribeGoogleMeetWebhooksVariables {
  input: GoogleMeetWebhooksSubscribeInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AssociateExternalMeetingWithActivity
// ====================================================

export interface AssociateExternalMeetingWithActivity_externalMeetingAssociateWithActivity_duration {
  __typename: "FormattedValueDuration";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formattedString: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface AssociateExternalMeetingWithActivity_externalMeetingAssociateWithActivity_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface AssociateExternalMeetingWithActivity_externalMeetingAssociateWithActivity_participants_emailAddress_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface AssociateExternalMeetingWithActivity_externalMeetingAssociateWithActivity_participants_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  address: string;
  avatarEntity: AssociateExternalMeetingWithActivity_externalMeetingAssociateWithActivity_participants_emailAddress_avatarEntity | null;
}

export interface AssociateExternalMeetingWithActivity_externalMeetingAssociateWithActivity_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
  emailAddress: AssociateExternalMeetingWithActivity_externalMeetingAssociateWithActivity_participants_emailAddress | null;
}

export interface AssociateExternalMeetingWithActivity_externalMeetingAssociateWithActivity_activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  htmlUrl: string | null;
  htmlUrlPath: string | null;
  primaryEmailAddress: string | null;
  primaryPhoneNumber: string | null;
}

export interface AssociateExternalMeetingWithActivity_externalMeetingAssociateWithActivity_activity_duration {
  __typename: "FormattedValueDuration";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formattedString: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface AssociateExternalMeetingWithActivity_externalMeetingAssociateWithActivity_activity_summary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface AssociateExternalMeetingWithActivity_externalMeetingAssociateWithActivity_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The DateTime that represents the start time of the Activity record
   */
  startTime: any;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: AssociateExternalMeetingWithActivity_externalMeetingAssociateWithActivity_activity_participants[];
  /**
   * The duration of the activity in minutes
   */
  durationMinutes: number | null;
  /**
   * The duration of this meeting
   */
  duration: AssociateExternalMeetingWithActivity_externalMeetingAssociateWithActivity_activity_duration | null;
  /**
   * The summary of the activity.
   */
  summary: AssociateExternalMeetingWithActivity_externalMeetingAssociateWithActivity_activity_summary | null;
}

export interface AssociateExternalMeetingWithActivity_externalMeetingAssociateWithActivity {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of meeting (ex., instant, scheduled, inbound call, etc.)
   */
  type: ExternalType;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
  /**
   * The duration of this meeting
   */
  duration: AssociateExternalMeetingWithActivity_externalMeetingAssociateWithActivity_duration | null;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: AssociateExternalMeetingWithActivity_externalMeetingAssociateWithActivity_transcriptionSummary | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: AssociateExternalMeetingWithActivity_externalMeetingAssociateWithActivity_participants[];
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The activity associated with this meeting, if it exists
   */
  activity: AssociateExternalMeetingWithActivity_externalMeetingAssociateWithActivity_activity | null;
  /**
   * Whether the meeting is still processing, which is the state we go into when we do not have an end time
   */
  isProcessing: boolean;
}

export interface AssociateExternalMeetingWithActivity {
  /**
   * Associates a external meeting with a new or existing Nutshell activity
   */
  externalMeetingAssociateWithActivity: AssociateExternalMeetingWithActivity_externalMeetingAssociateWithActivity | null;
}

export interface AssociateExternalMeetingWithActivityVariables {
  input: ExternalMeetingAssociateWithActivityInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveExternalMeeting
// ====================================================

export interface RemoveExternalMeeting_removeExternalMeeting_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface RemoveExternalMeeting_removeExternalMeeting {
  __typename: "RemoveExternalMeetingPayload";
  /**
   * The newly removed external meeting
   */
  externalMeeting: RemoveExternalMeeting_removeExternalMeeting_externalMeeting;
}

export interface RemoveExternalMeeting {
  /**
   * Removes an external meeting
   */
  removeExternalMeeting: RemoveExternalMeeting_removeExternalMeeting | null;
}

export interface RemoveExternalMeetingVariables {
  input: RemoveExternalMeetingInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetExternalMeetings
// ====================================================

export interface GetExternalMeetings_externalMeetings_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetExternalMeetings_externalMeetings_edges_node_duration {
  __typename: "FormattedValueDuration";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formattedString: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetExternalMeetings_externalMeetings_edges_node_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GetExternalMeetings_externalMeetings_edges_node_participants_emailAddress_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface GetExternalMeetings_externalMeetings_edges_node_participants_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  address: string;
  avatarEntity: GetExternalMeetings_externalMeetings_edges_node_participants_emailAddress_avatarEntity | null;
}

export interface GetExternalMeetings_externalMeetings_edges_node_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
  emailAddress: GetExternalMeetings_externalMeetings_edges_node_participants_emailAddress | null;
}

export interface GetExternalMeetings_externalMeetings_edges_node_activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  htmlUrl: string | null;
  htmlUrlPath: string | null;
  primaryEmailAddress: string | null;
  primaryPhoneNumber: string | null;
}

export interface GetExternalMeetings_externalMeetings_edges_node_activity_duration {
  __typename: "FormattedValueDuration";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formattedString: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetExternalMeetings_externalMeetings_edges_node_activity_summary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GetExternalMeetings_externalMeetings_edges_node_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The DateTime that represents the start time of the Activity record
   */
  startTime: any;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetExternalMeetings_externalMeetings_edges_node_activity_participants[];
  /**
   * The duration of the activity in minutes
   */
  durationMinutes: number | null;
  /**
   * The duration of this meeting
   */
  duration: GetExternalMeetings_externalMeetings_edges_node_activity_duration | null;
  /**
   * The summary of the activity.
   */
  summary: GetExternalMeetings_externalMeetings_edges_node_activity_summary | null;
}

export interface GetExternalMeetings_externalMeetings_edges_node {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of meeting (ex., instant, scheduled, inbound call, etc.)
   */
  type: ExternalType;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
  /**
   * The duration of this meeting
   */
  duration: GetExternalMeetings_externalMeetings_edges_node_duration | null;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: GetExternalMeetings_externalMeetings_edges_node_transcriptionSummary | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: GetExternalMeetings_externalMeetings_edges_node_participants[];
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The activity associated with this meeting, if it exists
   */
  activity: GetExternalMeetings_externalMeetings_edges_node_activity | null;
  /**
   * Whether the meeting is still processing, which is the state we go into when we do not have an end time
   */
  isProcessing: boolean;
}

export interface GetExternalMeetings_externalMeetings_edges {
  __typename: "ExternalMeetingsEdge";
  node: GetExternalMeetings_externalMeetings_edges_node;
}

export interface GetExternalMeetings_externalMeetings {
  __typename: "ExternalMeetingsConnection";
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetExternalMeetings_externalMeetings_pageInfo;
  /**
   * The total number of external meetings for this type
   */
  count: number;
  /**
   * A list of edges.
   */
  edges: GetExternalMeetings_externalMeetings_edges[];
}

export interface GetExternalMeetings {
  /**
   * Returns external meetings for a user
   */
  externalMeetings: GetExternalMeetings_externalMeetings;
}

export interface GetExternalMeetingsVariables {
  isLogged: boolean;
  after?: string | null;
  before?: string | null;
  first?: number | null;
  last?: number | null;
  serviceTypes: ExternalServiceType[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTeamsReauthStatus
// ====================================================

export interface GetTeamsReauthStatus_loggedInUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldShowTeamsReauthModal: boolean;
}

export interface GetTeamsReauthStatus {
  /**
   * Returns the requesting user. This is essentially the logged in user, but in an
   * API context, they might not be any "logged in"
   */
  loggedInUser: GetTeamsReauthStatus_loggedInUser;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetFeatureFlags
// ====================================================

export interface GetFeatureFlags_featureFlags {
  __typename: "FeatureFlags";
  /**
   * Can this instance insert materialized templates? (true if they have Revenue Booster)
   */
  canInsertMaterializedTemplate: boolean;
  /**
   * Is the logged in user an admin?
   */
  isAdministrator: boolean;
}

export interface GetFeatureFlags {
  featureFlags: GetFeatureFlags_featureFlags;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetActiveProductUpdate
// ====================================================

export interface GetActiveProductUpdate_activeProductUpdate_primaryCta {
  __typename: "ProductUpdatePrimaryCta";
  text: string;
  href: string;
  isExternal: boolean;
  /**
   * When true, the in-app modal only shows this CTA to administrators.
   */
  adminOnly: boolean;
}

export interface GetActiveProductUpdate_activeProductUpdate {
  __typename: "ProductUpdate";
  id: string;
  slug: string;
  /**
   * ISO date `YYYY-MM-DD` from frontmatter.
   */
  publishedAt: string;
  /**
   * When true, only administrators see this update in the in-app teaser.
   */
  adminOnly: boolean;
  /**
   * True when the promo is live for production customers. Set in frontmatter; independent of `publishedAt`.
   */
  isLive: boolean;
  labels: string[];
  title: string;
  /**
   * Sidebar teaser body. One short sentence.
   */
  teaserDescription: string;
  /**
   * Description sized for product update cards on the explore page.
   */
  exploreDescription: string;
  /**
   * 1-2 sentence summary sized for the in-modal "Recent updates" list and the
   * public changelog. Null falls back to `teaserDescription` on render.
   */
  listDescription: string | null;
  /**
   * Absolute web path to the illustration asset under
   * `public/include/images/product-updates/<id>/`. Pass this directly to the
   * `Illustration` component via the `fullPath` prop on the client.
   */
  illustrationSrc: string;
  /**
   * Compact illustration asset for explore-page cards.
   */
  illustrationMiniSrc: string;
  illustrationBackgroundColor: string | null;
  modalHeaderText: string;
  modalHeaderSubtext: string | null;
  modalHeaderBackgroundColor: string | null;
  modalCloseButtonColor: string | null;
  updateColor: string | null;
  primaryCta: GetActiveProductUpdate_activeProductUpdate_primaryCta | null;
  learnMoreUrl: string | null;
  /**
   * GitHub-flavored markdown source. Render client-side via `react-markdown`.
   */
  body: string;
}

export interface GetActiveProductUpdate {
  /**
   * The single product update to surface in the sidebar teaser for the current
   * user, or null. Server-side rule: newest entry that passes admin + feature-flag
   * gates and that the user has not dismissed (`cuehide_<id>`). No fall-through on
   * dismissal — dismissing the active entry hides the teaser until a fresher one ships.
   */
  activeProductUpdate: GetActiveProductUpdate_activeProductUpdate | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDebugProductUpdates
// ====================================================

export interface GetDebugProductUpdates_debugProductUpdates_primaryCta {
  __typename: "ProductUpdatePrimaryCta";
  text: string;
  href: string;
  isExternal: boolean;
  /**
   * When true, the in-app modal only shows this CTA to administrators.
   */
  adminOnly: boolean;
}

export interface GetDebugProductUpdates_debugProductUpdates {
  __typename: "ProductUpdate";
  id: string;
  slug: string;
  /**
   * ISO date `YYYY-MM-DD` from frontmatter.
   */
  publishedAt: string;
  /**
   * When true, only administrators see this update in the in-app teaser.
   */
  adminOnly: boolean;
  /**
   * True when the promo is live for production customers. Set in frontmatter; independent of `publishedAt`.
   */
  isLive: boolean;
  labels: string[];
  title: string;
  /**
   * Sidebar teaser body. One short sentence.
   */
  teaserDescription: string;
  /**
   * Description sized for product update cards on the explore page.
   */
  exploreDescription: string;
  /**
   * 1-2 sentence summary sized for the in-modal "Recent updates" list and the
   * public changelog. Null falls back to `teaserDescription` on render.
   */
  listDescription: string | null;
  /**
   * Absolute web path to the illustration asset under
   * `public/include/images/product-updates/<id>/`. Pass this directly to the
   * `Illustration` component via the `fullPath` prop on the client.
   */
  illustrationSrc: string;
  /**
   * Compact illustration asset for explore-page cards.
   */
  illustrationMiniSrc: string;
  illustrationBackgroundColor: string | null;
  modalHeaderText: string;
  modalHeaderSubtext: string | null;
  modalHeaderBackgroundColor: string | null;
  modalCloseButtonColor: string | null;
  updateColor: string | null;
  primaryCta: GetDebugProductUpdates_debugProductUpdates_primaryCta | null;
  learnMoreUrl: string | null;
  /**
   * GitHub-flavored markdown source. Render client-side via `react-markdown`.
   */
  body: string;
}

export interface GetDebugProductUpdates {
  /**
   * All product updates on disk, newest first, with no gating applied. Powers the
   * internal `/debug/product-updates` preview page — admin-only.
   */
  debugProductUpdates: GetDebugProductUpdates_debugProductUpdates[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetProductUpdate
// ====================================================

export interface GetProductUpdate_productUpdate_primaryCta {
  __typename: "ProductUpdatePrimaryCta";
  text: string;
  href: string;
  isExternal: boolean;
  /**
   * When true, the in-app modal only shows this CTA to administrators.
   */
  adminOnly: boolean;
}

export interface GetProductUpdate_productUpdate {
  __typename: "ProductUpdate";
  id: string;
  slug: string;
  /**
   * ISO date `YYYY-MM-DD` from frontmatter.
   */
  publishedAt: string;
  /**
   * When true, only administrators see this update in the in-app teaser.
   */
  adminOnly: boolean;
  /**
   * True when the promo is live for production customers. Set in frontmatter; independent of `publishedAt`.
   */
  isLive: boolean;
  labels: string[];
  title: string;
  /**
   * Sidebar teaser body. One short sentence.
   */
  teaserDescription: string;
  /**
   * Description sized for product update cards on the explore page.
   */
  exploreDescription: string;
  /**
   * 1-2 sentence summary sized for the in-modal "Recent updates" list and the
   * public changelog. Null falls back to `teaserDescription` on render.
   */
  listDescription: string | null;
  /**
   * Absolute web path to the illustration asset under
   * `public/include/images/product-updates/<id>/`. Pass this directly to the
   * `Illustration` component via the `fullPath` prop on the client.
   */
  illustrationSrc: string;
  /**
   * Compact illustration asset for explore-page cards.
   */
  illustrationMiniSrc: string;
  illustrationBackgroundColor: string | null;
  modalHeaderText: string;
  modalHeaderSubtext: string | null;
  modalHeaderBackgroundColor: string | null;
  modalCloseButtonColor: string | null;
  updateColor: string | null;
  primaryCta: GetProductUpdate_productUpdate_primaryCta | null;
  learnMoreUrl: string | null;
  /**
   * GitHub-flavored markdown source. Render client-side via `react-markdown`.
   */
  body: string;
}

export interface GetProductUpdate {
  /**
   * Fetch a single product update by id, bypassing the
   * dismissal/feature-flag/admin gates used by `activeProductUpdate`. Internal
   * preview surface — admin-only.
   */
  productUpdate: GetProductUpdate_productUpdate | null;
}

export interface GetProductUpdateVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRecentProductUpdates
// ====================================================

export interface GetRecentProductUpdates_recentProductUpdates_primaryCta {
  __typename: "ProductUpdatePrimaryCta";
  text: string;
  href: string;
  isExternal: boolean;
  /**
   * When true, the in-app modal only shows this CTA to administrators.
   */
  adminOnly: boolean;
}

export interface GetRecentProductUpdates_recentProductUpdates {
  __typename: "ProductUpdate";
  id: string;
  slug: string;
  /**
   * ISO date `YYYY-MM-DD` from frontmatter.
   */
  publishedAt: string;
  /**
   * When true, only administrators see this update in the in-app teaser.
   */
  adminOnly: boolean;
  /**
   * True when the promo is live for production customers. Set in frontmatter; independent of `publishedAt`.
   */
  isLive: boolean;
  labels: string[];
  title: string;
  /**
   * Sidebar teaser body. One short sentence.
   */
  teaserDescription: string;
  /**
   * Description sized for product update cards on the explore page.
   */
  exploreDescription: string;
  /**
   * 1-2 sentence summary sized for the in-modal "Recent updates" list and the
   * public changelog. Null falls back to `teaserDescription` on render.
   */
  listDescription: string | null;
  /**
   * Absolute web path to the illustration asset under
   * `public/include/images/product-updates/<id>/`. Pass this directly to the
   * `Illustration` component via the `fullPath` prop on the client.
   */
  illustrationSrc: string;
  /**
   * Compact illustration asset for explore-page cards.
   */
  illustrationMiniSrc: string;
  illustrationBackgroundColor: string | null;
  modalHeaderText: string;
  modalHeaderSubtext: string | null;
  modalHeaderBackgroundColor: string | null;
  modalCloseButtonColor: string | null;
  updateColor: string | null;
  primaryCta: GetRecentProductUpdates_recentProductUpdates_primaryCta | null;
  learnMoreUrl: string | null;
  /**
   * GitHub-flavored markdown source. Render client-side via `react-markdown`.
   */
  body: string;
}

export interface GetRecentProductUpdates {
  /**
   * Up to 29 most recent product updates visible to the current user, newest
   * first. Powers the explore product-updates archive (4 featured + up to 25
   * previous) and the feature-promo detail modal lookup. Honors the same
   * admin-only and feature-flag gating as `activeProductUpdate`, but does not
   * filter dismissed entries — the list is an archive, not a "what's new" feed.
   */
  recentProductUpdates: GetRecentProductUpdates_recentProductUpdates[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDecisionFields
// ====================================================

export interface GetDecisionFields_form_editableVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface GetDecisionFields_form_editableVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface GetDecisionFields_form_editableVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface GetDecisionFields_form_editableVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetDecisionFields_form_editableVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetDecisionFields_form_editableVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface GetDecisionFields_form_editableVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetDecisionFields_form_editableVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type GetDecisionFields_form_editableVersion_fields_rules_objectsToAssign = GetDecisionFields_form_editableVersion_fields_rules_objectsToAssign_Tag | GetDecisionFields_form_editableVersion_fields_rules_objectsToAssign_Audience | GetDecisionFields_form_editableVersion_fields_rules_objectsToAssign_Product | GetDecisionFields_form_editableVersion_fields_rules_objectsToAssign_Source | GetDecisionFields_form_editableVersion_fields_rules_objectsToAssign_Stageset;

export interface GetDecisionFields_form_editableVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: GetDecisionFields_form_editableVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: GetDecisionFields_form_editableVersion_fields_rules_objectsToAssign[];
}

export interface GetDecisionFields_form_editableVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: GetDecisionFields_form_editableVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: GetDecisionFields_form_editableVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: GetDecisionFields_form_editableVersion_fields_rules[];
}

export interface GetDecisionFields_form_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of fields associated with this web form version
   */
  fields: GetDecisionFields_form_editableVersion_fields[];
}

export interface GetDecisionFields_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: GetDecisionFields_form_editableVersion;
}

export interface GetDecisionFields {
  /**
   * Returns a Nutshell web form by ID or slug.
   */
  form: GetDecisionFields_form;
}

export interface GetDecisionFieldsVariables {
  formId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateSubmissionsCSV
// ====================================================

export interface CreateSubmissionsCSV_submissionsCsvGenerate {
  __typename: "SubmissionsCsvGeneratePayload";
  /**
   * The URL to download the csv
   */
  url: string;
}

export interface CreateSubmissionsCSV {
  /**
   * Generates a csv of form submissions
   */
  submissionsCsvGenerate: CreateSubmissionsCSV_submissionsCsvGenerate;
}

export interface CreateSubmissionsCSVVariables {
  input: SubmissionsCsvGenerateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: FormNextStepsNutshellNotificationDelete
// ====================================================

export interface FormNextStepsNutshellNotificationDelete_formNextStepsNutshellNotificationDelete_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface FormNextStepsNutshellNotificationDelete_formNextStepsNutshellNotificationDelete_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type FormNextStepsNutshellNotificationDelete_formNextStepsNutshellNotificationDelete_nutshellNotification_notifiables = FormNextStepsNutshellNotificationDelete_formNextStepsNutshellNotificationDelete_nutshellNotification_notifiables_NotifiableAlias | FormNextStepsNutshellNotificationDelete_formNextStepsNutshellNotificationDelete_nutshellNotification_notifiables_User;

export interface FormNextStepsNutshellNotificationDelete_formNextStepsNutshellNotificationDelete_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface FormNextStepsNutshellNotificationDelete_formNextStepsNutshellNotificationDelete_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: FormNextStepsNutshellNotificationDelete_formNextStepsNutshellNotificationDelete_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: FormNextStepsNutshellNotificationDelete_formNextStepsNutshellNotificationDelete_nutshellNotification_form;
}

export interface FormNextStepsNutshellNotificationDelete_formNextStepsNutshellNotificationDelete {
  __typename: "FormNextStepsNutshellNotificationDeletePayload";
  /**
   * The nutshell notification action deleted in this mutation.
   */
  nutshellNotification: FormNextStepsNutshellNotificationDelete_formNextStepsNutshellNotificationDelete_nutshellNotification;
}

export interface FormNextStepsNutshellNotificationDelete {
  /**
   * Sets the Slack notifications next step for a Nutshell form.
   */
  formNextStepsNutshellNotificationDelete: FormNextStepsNutshellNotificationDelete_formNextStepsNutshellNotificationDelete;
}

export interface FormNextStepsNutshellNotificationDeleteVariables {
  input: FormNextStepsNutshellNotificationDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: FormNextStepsSlackMessageDelete
// ====================================================

export interface FormNextStepsSlackMessageDelete_formNextStepsSlackMessageDelete_slackMessage_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface FormNextStepsSlackMessageDelete_formNextStepsSlackMessageDelete_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface FormNextStepsSlackMessageDelete_formNextStepsSlackMessageDelete_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: FormNextStepsSlackMessageDelete_formNextStepsSlackMessageDelete_slackMessage_slackChannel | null;
  /**
   * The associated form for this slack message.
   */
  form: FormNextStepsSlackMessageDelete_formNextStepsSlackMessageDelete_slackMessage_form;
}

export interface FormNextStepsSlackMessageDelete_formNextStepsSlackMessageDelete {
  __typename: "FormNextStepsSlackMessageDeletePayload";
  /**
   * The slack message action deleted in this mutation.
   */
  slackMessage: FormNextStepsSlackMessageDelete_formNextStepsSlackMessageDelete_slackMessage;
}

export interface FormNextStepsSlackMessageDelete {
  /**
   * Sets the Slack notifications next step for a Nutshell form.
   */
  formNextStepsSlackMessageDelete: FormNextStepsSlackMessageDelete_formNextStepsSlackMessageDelete;
}

export interface FormNextStepsSlackMessageDeleteVariables {
  input: FormNextStepsSlackMessageDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: PublishMultiPageForm
// ====================================================

export interface PublishMultiPageForm_formPublish_form_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface PublishMultiPageForm_formPublish_form_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface PublishMultiPageForm_formPublish_form_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface PublishMultiPageForm_formPublish_form_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface PublishMultiPageForm_formPublish_form_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface PublishMultiPageForm_formPublish_form_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: PublishMultiPageForm_formPublish_form_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: PublishMultiPageForm_formPublish_form_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: PublishMultiPageForm_formPublish_form_createRules_lead_stagesetFieldRules_stageset;
}

export interface PublishMultiPageForm_formPublish_form_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: PublishMultiPageForm_formPublish_form_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: PublishMultiPageForm_formPublish_form_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: PublishMultiPageForm_formPublish_form_createRules_lead_stagesetFieldRules[];
}

export interface PublishMultiPageForm_formPublish_form_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface PublishMultiPageForm_formPublish_form_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface PublishMultiPageForm_formPublish_form_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: PublishMultiPageForm_formPublish_form_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: PublishMultiPageForm_formPublish_form_createRules_contact_audiences[];
}

export interface PublishMultiPageForm_formPublish_form_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface PublishMultiPageForm_formPublish_form_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: PublishMultiPageForm_formPublish_form_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface PublishMultiPageForm_formPublish_form_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: PublishMultiPageForm_formPublish_form_createRules_lead | null;
  /**
   * The create rules related to a contact
   */
  contact: PublishMultiPageForm_formPublish_form_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: PublishMultiPageForm_formPublish_form_createRules_account | null;
}

export interface PublishMultiPageForm_formPublish_form_publishedVersion_pages_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface PublishMultiPageForm_formPublish_form_publishedVersion_pages_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface PublishMultiPageForm_formPublish_form_publishedVersion_pages_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface PublishMultiPageForm_formPublish_form_publishedVersion_pages_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface PublishMultiPageForm_formPublish_form_publishedVersion_pages_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface PublishMultiPageForm_formPublish_form_publishedVersion_pages_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface PublishMultiPageForm_formPublish_form_publishedVersion_pages_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface PublishMultiPageForm_formPublish_form_publishedVersion_pages_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type PublishMultiPageForm_formPublish_form_publishedVersion_pages_fields_rules_objectsToAssign = PublishMultiPageForm_formPublish_form_publishedVersion_pages_fields_rules_objectsToAssign_Tag | PublishMultiPageForm_formPublish_form_publishedVersion_pages_fields_rules_objectsToAssign_Audience | PublishMultiPageForm_formPublish_form_publishedVersion_pages_fields_rules_objectsToAssign_Product | PublishMultiPageForm_formPublish_form_publishedVersion_pages_fields_rules_objectsToAssign_Source | PublishMultiPageForm_formPublish_form_publishedVersion_pages_fields_rules_objectsToAssign_Stageset;

export interface PublishMultiPageForm_formPublish_form_publishedVersion_pages_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: PublishMultiPageForm_formPublish_form_publishedVersion_pages_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: PublishMultiPageForm_formPublish_form_publishedVersion_pages_fields_rules_objectsToAssign[];
}

export interface PublishMultiPageForm_formPublish_form_publishedVersion_pages_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: PublishMultiPageForm_formPublish_form_publishedVersion_pages_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: PublishMultiPageForm_formPublish_form_publishedVersion_pages_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: PublishMultiPageForm_formPublish_form_publishedVersion_pages_fields_rules[];
}

export interface PublishMultiPageForm_formPublish_form_publishedVersion_pages_defaultRule_targetPage {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
}

export interface PublishMultiPageForm_formPublish_form_publishedVersion_pages_defaultRule_enumElement {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface PublishMultiPageForm_formPublish_form_publishedVersion_pages_defaultRule_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface PublishMultiPageForm_formPublish_form_publishedVersion_pages_defaultRule {
  __typename: "PageRule";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The action type of the rule
   */
  actionType: PageRuleActionType;
  /**
   * Whether the rule is field based
   */
  isFieldBased: boolean;
  /**
   * The page that the rule is associated with
   */
  targetPage: PublishMultiPageForm_formPublish_form_publishedVersion_pages_defaultRule_targetPage | null;
  /**
   * The enum element that the rule is associated with
   */
  enumElement: PublishMultiPageForm_formPublish_form_publishedVersion_pages_defaultRule_enumElement | null;
  /**
   * The field that the rule is associated with
   */
  field: PublishMultiPageForm_formPublish_form_publishedVersion_pages_defaultRule_field | null;
}

export interface PublishMultiPageForm_formPublish_form_publishedVersion_pages_conditionalRules_targetPage {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
}

export interface PublishMultiPageForm_formPublish_form_publishedVersion_pages_conditionalRules_enumElement {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface PublishMultiPageForm_formPublish_form_publishedVersion_pages_conditionalRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface PublishMultiPageForm_formPublish_form_publishedVersion_pages_conditionalRules {
  __typename: "PageRule";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The action type of the rule
   */
  actionType: PageRuleActionType;
  /**
   * Whether the rule is field based
   */
  isFieldBased: boolean;
  /**
   * The page that the rule is associated with
   */
  targetPage: PublishMultiPageForm_formPublish_form_publishedVersion_pages_conditionalRules_targetPage | null;
  /**
   * The enum element that the rule is associated with
   */
  enumElement: PublishMultiPageForm_formPublish_form_publishedVersion_pages_conditionalRules_enumElement | null;
  /**
   * The field that the rule is associated with
   */
  field: PublishMultiPageForm_formPublish_form_publishedVersion_pages_conditionalRules_field | null;
}

export interface PublishMultiPageForm_formPublish_form_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
  /**
   * Array of fields associated with this web form page
   */
  fields: PublishMultiPageForm_formPublish_form_publishedVersion_pages_fields[];
  /**
   * The non-field based page rule associated with this web form page
   */
  defaultRule: PublishMultiPageForm_formPublish_form_publishedVersion_pages_defaultRule;
  /**
   * Array of field-based rules associated with this web form page
   */
  conditionalRules: PublishMultiPageForm_formPublish_form_publishedVersion_pages_conditionalRules[];
}

export interface PublishMultiPageForm_formPublish_form_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: PublishMultiPageForm_formPublish_form_publishedVersion_pages[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
}

export interface PublishMultiPageForm_formPublish_form_editableVersion_pages_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface PublishMultiPageForm_formPublish_form_editableVersion_pages_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface PublishMultiPageForm_formPublish_form_editableVersion_pages_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface PublishMultiPageForm_formPublish_form_editableVersion_pages_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface PublishMultiPageForm_formPublish_form_editableVersion_pages_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface PublishMultiPageForm_formPublish_form_editableVersion_pages_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface PublishMultiPageForm_formPublish_form_editableVersion_pages_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface PublishMultiPageForm_formPublish_form_editableVersion_pages_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type PublishMultiPageForm_formPublish_form_editableVersion_pages_fields_rules_objectsToAssign = PublishMultiPageForm_formPublish_form_editableVersion_pages_fields_rules_objectsToAssign_Tag | PublishMultiPageForm_formPublish_form_editableVersion_pages_fields_rules_objectsToAssign_Audience | PublishMultiPageForm_formPublish_form_editableVersion_pages_fields_rules_objectsToAssign_Product | PublishMultiPageForm_formPublish_form_editableVersion_pages_fields_rules_objectsToAssign_Source | PublishMultiPageForm_formPublish_form_editableVersion_pages_fields_rules_objectsToAssign_Stageset;

export interface PublishMultiPageForm_formPublish_form_editableVersion_pages_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: PublishMultiPageForm_formPublish_form_editableVersion_pages_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: PublishMultiPageForm_formPublish_form_editableVersion_pages_fields_rules_objectsToAssign[];
}

export interface PublishMultiPageForm_formPublish_form_editableVersion_pages_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: PublishMultiPageForm_formPublish_form_editableVersion_pages_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: PublishMultiPageForm_formPublish_form_editableVersion_pages_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: PublishMultiPageForm_formPublish_form_editableVersion_pages_fields_rules[];
}

export interface PublishMultiPageForm_formPublish_form_editableVersion_pages_defaultRule_targetPage {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
}

export interface PublishMultiPageForm_formPublish_form_editableVersion_pages_defaultRule_enumElement {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface PublishMultiPageForm_formPublish_form_editableVersion_pages_defaultRule_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface PublishMultiPageForm_formPublish_form_editableVersion_pages_defaultRule {
  __typename: "PageRule";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The action type of the rule
   */
  actionType: PageRuleActionType;
  /**
   * Whether the rule is field based
   */
  isFieldBased: boolean;
  /**
   * The page that the rule is associated with
   */
  targetPage: PublishMultiPageForm_formPublish_form_editableVersion_pages_defaultRule_targetPage | null;
  /**
   * The enum element that the rule is associated with
   */
  enumElement: PublishMultiPageForm_formPublish_form_editableVersion_pages_defaultRule_enumElement | null;
  /**
   * The field that the rule is associated with
   */
  field: PublishMultiPageForm_formPublish_form_editableVersion_pages_defaultRule_field | null;
}

export interface PublishMultiPageForm_formPublish_form_editableVersion_pages_conditionalRules_targetPage {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
}

export interface PublishMultiPageForm_formPublish_form_editableVersion_pages_conditionalRules_enumElement {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface PublishMultiPageForm_formPublish_form_editableVersion_pages_conditionalRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface PublishMultiPageForm_formPublish_form_editableVersion_pages_conditionalRules {
  __typename: "PageRule";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The action type of the rule
   */
  actionType: PageRuleActionType;
  /**
   * Whether the rule is field based
   */
  isFieldBased: boolean;
  /**
   * The page that the rule is associated with
   */
  targetPage: PublishMultiPageForm_formPublish_form_editableVersion_pages_conditionalRules_targetPage | null;
  /**
   * The enum element that the rule is associated with
   */
  enumElement: PublishMultiPageForm_formPublish_form_editableVersion_pages_conditionalRules_enumElement | null;
  /**
   * The field that the rule is associated with
   */
  field: PublishMultiPageForm_formPublish_form_editableVersion_pages_conditionalRules_field | null;
}

export interface PublishMultiPageForm_formPublish_form_editableVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
  /**
   * Array of fields associated with this web form page
   */
  fields: PublishMultiPageForm_formPublish_form_editableVersion_pages_fields[];
  /**
   * The non-field based page rule associated with this web form page
   */
  defaultRule: PublishMultiPageForm_formPublish_form_editableVersion_pages_defaultRule;
  /**
   * Array of field-based rules associated with this web form page
   */
  conditionalRules: PublishMultiPageForm_formPublish_form_editableVersion_pages_conditionalRules[];
}

export interface PublishMultiPageForm_formPublish_form_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of pages associated with this web form version
   */
  pages: PublishMultiPageForm_formPublish_form_editableVersion_pages[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * Whether the form should render its multi-page progress indicator.
   */
  shouldShowFormProgress: boolean;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
}

export interface PublishMultiPageForm_formPublish_form_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface PublishMultiPageForm_formPublish_form_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface PublishMultiPageForm_formPublish_form_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: PublishMultiPageForm_formPublish_form_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: PublishMultiPageForm_formPublish_form_nextSteps_slackMessage_form;
}

export interface PublishMultiPageForm_formPublish_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface PublishMultiPageForm_formPublish_form_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type PublishMultiPageForm_formPublish_form_nextSteps_nutshellNotification_notifiables = PublishMultiPageForm_formPublish_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias | PublishMultiPageForm_formPublish_form_nextSteps_nutshellNotification_notifiables_User;

export interface PublishMultiPageForm_formPublish_form_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface PublishMultiPageForm_formPublish_form_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: PublishMultiPageForm_formPublish_form_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: PublishMultiPageForm_formPublish_form_nextSteps_nutshellNotification_form;
}

export interface PublishMultiPageForm_formPublish_form_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: PublishMultiPageForm_formPublish_form_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: PublishMultiPageForm_formPublish_form_nextSteps_nutshellNotification | null;
}

export interface PublishMultiPageForm_formPublish_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: PublishMultiPageForm_formPublish_form_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: PublishMultiPageForm_formPublish_form_publishedVersion | null;
  /**
   * Editor validation for the editable version (page fields and submittable navigation)
   */
  validationErrors: string[];
  /**
   * Whether the form has been embedded
   */
  isLiveForm: boolean;
  /**
   * The published form preview url
   */
  publishedFormPreviewUrl: string;
  /**
   * Publicly viewable link to published form
   */
  sharableViewInBrowserLink: string;
  /**
   * Boolean, true if the editable version has any edits
   */
  hasUnpublishedChanges: boolean;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: PublishMultiPageForm_formPublish_form_editableVersion;
  /**
   * The embed snippet for this form
   */
  embedSnippet: string;
  /**
   * The type of form
   */
  type: FormType;
  /**
   * True when this form is referenced anywhere in the chat config (intake,
   * offline, goals, or an action form). Chat-backed forms cannot be converted to
   * multi-page, so the editor should block adding additional pages when this is true.
   */
  isUsedByChat: boolean;
  /**
   * Next step automations for this form
   */
  nextSteps: PublishMultiPageForm_formPublish_form_nextSteps;
}

export interface PublishMultiPageForm_formPublish {
  __typename: "FormPublishPayload";
  /**
   * The published form.
   */
  form: PublishMultiPageForm_formPublish_form | null;
}

export interface PublishMultiPageForm {
  /**
   * Publishes a Nutshell form, replacing the previous live version.
   */
  formPublish: PublishMultiPageForm_formPublish;
}

export interface PublishMultiPageFormVariables {
  input: FormPublishInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: FormNextStepsNutshellNotificationSet
// ====================================================

export interface FormNextStepsNutshellNotificationSet_formNextStepsNutshellNotificationSet_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface FormNextStepsNutshellNotificationSet_formNextStepsNutshellNotificationSet_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type FormNextStepsNutshellNotificationSet_formNextStepsNutshellNotificationSet_nutshellNotification_notifiables = FormNextStepsNutshellNotificationSet_formNextStepsNutshellNotificationSet_nutshellNotification_notifiables_NotifiableAlias | FormNextStepsNutshellNotificationSet_formNextStepsNutshellNotificationSet_nutshellNotification_notifiables_User;

export interface FormNextStepsNutshellNotificationSet_formNextStepsNutshellNotificationSet_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface FormNextStepsNutshellNotificationSet_formNextStepsNutshellNotificationSet_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: FormNextStepsNutshellNotificationSet_formNextStepsNutshellNotificationSet_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: FormNextStepsNutshellNotificationSet_formNextStepsNutshellNotificationSet_nutshellNotification_form;
}

export interface FormNextStepsNutshellNotificationSet_formNextStepsNutshellNotificationSet {
  __typename: "FormNextStepsNutshellNotificationSetPayload";
  /**
   * The nutshell notification action set for this automation.
   */
  nutshellNotification: FormNextStepsNutshellNotificationSet_formNextStepsNutshellNotificationSet_nutshellNotification;
}

export interface FormNextStepsNutshellNotificationSet {
  /**
   * Sets the Slack notifications next step for a Nutshell form.
   */
  formNextStepsNutshellNotificationSet: FormNextStepsNutshellNotificationSet_formNextStepsNutshellNotificationSet;
}

export interface FormNextStepsNutshellNotificationSetVariables {
  input: FormNextStepsNutshellNotificationSetInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: FormNextStepsSlackMessageSet
// ====================================================

export interface FormNextStepsSlackMessageSet_formNextStepsSlackMessageSet_slackMessage_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface FormNextStepsSlackMessageSet_formNextStepsSlackMessageSet_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface FormNextStepsSlackMessageSet_formNextStepsSlackMessageSet_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: FormNextStepsSlackMessageSet_formNextStepsSlackMessageSet_slackMessage_slackChannel | null;
  /**
   * The associated form for this slack message.
   */
  form: FormNextStepsSlackMessageSet_formNextStepsSlackMessageSet_slackMessage_form;
}

export interface FormNextStepsSlackMessageSet_formNextStepsSlackMessageSet {
  __typename: "FormNextStepsSlackMessageSetPayload";
  /**
   * The slack message action set for this automation.
   */
  slackMessage: FormNextStepsSlackMessageSet_formNextStepsSlackMessageSet_slackMessage;
}

export interface FormNextStepsSlackMessageSet {
  /**
   * Sets the Slack notifications next step for a Nutshell form.
   */
  formNextStepsSlackMessageSet: FormNextStepsSlackMessageSet_formNextStepsSlackMessageSet;
}

export interface FormNextStepsSlackMessageSetVariables {
  input: FormNextStepsSlackMessageSetInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateFormPageRules
// ====================================================

export interface UpdateFormPageRules_formPageRulesUpdate_page_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface UpdateFormPageRules_formPageRulesUpdate_page_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface UpdateFormPageRules_formPageRulesUpdate_page_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface UpdateFormPageRules_formPageRulesUpdate_page_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateFormPageRules_formPageRulesUpdate_page_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface UpdateFormPageRules_formPageRulesUpdate_page_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface UpdateFormPageRules_formPageRulesUpdate_page_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateFormPageRules_formPageRulesUpdate_page_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type UpdateFormPageRules_formPageRulesUpdate_page_fields_rules_objectsToAssign = UpdateFormPageRules_formPageRulesUpdate_page_fields_rules_objectsToAssign_Tag | UpdateFormPageRules_formPageRulesUpdate_page_fields_rules_objectsToAssign_Audience | UpdateFormPageRules_formPageRulesUpdate_page_fields_rules_objectsToAssign_Product | UpdateFormPageRules_formPageRulesUpdate_page_fields_rules_objectsToAssign_Source | UpdateFormPageRules_formPageRulesUpdate_page_fields_rules_objectsToAssign_Stageset;

export interface UpdateFormPageRules_formPageRulesUpdate_page_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: UpdateFormPageRules_formPageRulesUpdate_page_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: UpdateFormPageRules_formPageRulesUpdate_page_fields_rules_objectsToAssign[];
}

export interface UpdateFormPageRules_formPageRulesUpdate_page_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: UpdateFormPageRules_formPageRulesUpdate_page_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: UpdateFormPageRules_formPageRulesUpdate_page_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: UpdateFormPageRules_formPageRulesUpdate_page_fields_rules[];
}

export interface UpdateFormPageRules_formPageRulesUpdate_page_defaultRule_targetPage {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
}

export interface UpdateFormPageRules_formPageRulesUpdate_page_defaultRule_enumElement {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface UpdateFormPageRules_formPageRulesUpdate_page_defaultRule_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateFormPageRules_formPageRulesUpdate_page_defaultRule {
  __typename: "PageRule";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The action type of the rule
   */
  actionType: PageRuleActionType;
  /**
   * Whether the rule is field based
   */
  isFieldBased: boolean;
  /**
   * The page that the rule is associated with
   */
  targetPage: UpdateFormPageRules_formPageRulesUpdate_page_defaultRule_targetPage | null;
  /**
   * The enum element that the rule is associated with
   */
  enumElement: UpdateFormPageRules_formPageRulesUpdate_page_defaultRule_enumElement | null;
  /**
   * The field that the rule is associated with
   */
  field: UpdateFormPageRules_formPageRulesUpdate_page_defaultRule_field | null;
}

export interface UpdateFormPageRules_formPageRulesUpdate_page_conditionalRules_targetPage {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
}

export interface UpdateFormPageRules_formPageRulesUpdate_page_conditionalRules_enumElement {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface UpdateFormPageRules_formPageRulesUpdate_page_conditionalRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateFormPageRules_formPageRulesUpdate_page_conditionalRules {
  __typename: "PageRule";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The action type of the rule
   */
  actionType: PageRuleActionType;
  /**
   * Whether the rule is field based
   */
  isFieldBased: boolean;
  /**
   * The page that the rule is associated with
   */
  targetPage: UpdateFormPageRules_formPageRulesUpdate_page_conditionalRules_targetPage | null;
  /**
   * The enum element that the rule is associated with
   */
  enumElement: UpdateFormPageRules_formPageRulesUpdate_page_conditionalRules_enumElement | null;
  /**
   * The field that the rule is associated with
   */
  field: UpdateFormPageRules_formPageRulesUpdate_page_conditionalRules_field | null;
}

export interface UpdateFormPageRules_formPageRulesUpdate_page {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
  /**
   * Array of fields associated with this web form page
   */
  fields: UpdateFormPageRules_formPageRulesUpdate_page_fields[];
  /**
   * The non-field based page rule associated with this web form page
   */
  defaultRule: UpdateFormPageRules_formPageRulesUpdate_page_defaultRule;
  /**
   * Array of field-based rules associated with this web form page
   */
  conditionalRules: UpdateFormPageRules_formPageRulesUpdate_page_conditionalRules[];
}

export interface UpdateFormPageRules_formPageRulesUpdate_form_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
}

export interface UpdateFormPageRules_formPageRulesUpdate_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Editor validation for the editable version (page fields and submittable navigation)
   */
  validationErrors: string[];
  /**
   * Boolean, true if the editable version has any edits
   */
  hasUnpublishedChanges: boolean;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: UpdateFormPageRules_formPageRulesUpdate_form_editableVersion;
}

export interface UpdateFormPageRules_formPageRulesUpdate {
  __typename: "FormPageRulesUpdatePayload";
  /**
   * The updated page rules
   */
  page: UpdateFormPageRules_formPageRulesUpdate_page;
  form: UpdateFormPageRules_formPageRulesUpdate_form;
}

export interface UpdateFormPageRules {
  /**
   * Updates the page rules for a Nutshell form
   */
  formPageRulesUpdate: UpdateFormPageRules_formPageRulesUpdate;
}

export interface UpdateFormPageRulesVariables {
  input: FormPageRulesUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateMultiPageForm
// ====================================================

export interface UpdateMultiPageForm_formUpdate_form_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface UpdateMultiPageForm_formUpdate_form_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateMultiPageForm_formUpdate_form_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface UpdateMultiPageForm_formUpdate_form_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface UpdateMultiPageForm_formUpdate_form_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface UpdateMultiPageForm_formUpdate_form_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: UpdateMultiPageForm_formUpdate_form_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: UpdateMultiPageForm_formUpdate_form_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: UpdateMultiPageForm_formUpdate_form_createRules_lead_stagesetFieldRules_stageset;
}

export interface UpdateMultiPageForm_formUpdate_form_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: UpdateMultiPageForm_formUpdate_form_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: UpdateMultiPageForm_formUpdate_form_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: UpdateMultiPageForm_formUpdate_form_createRules_lead_stagesetFieldRules[];
}

export interface UpdateMultiPageForm_formUpdate_form_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateMultiPageForm_formUpdate_form_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface UpdateMultiPageForm_formUpdate_form_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: UpdateMultiPageForm_formUpdate_form_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: UpdateMultiPageForm_formUpdate_form_createRules_contact_audiences[];
}

export interface UpdateMultiPageForm_formUpdate_form_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateMultiPageForm_formUpdate_form_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: UpdateMultiPageForm_formUpdate_form_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface UpdateMultiPageForm_formUpdate_form_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: UpdateMultiPageForm_formUpdate_form_createRules_lead | null;
  /**
   * The create rules related to a contact
   */
  contact: UpdateMultiPageForm_formUpdate_form_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: UpdateMultiPageForm_formUpdate_form_createRules_account | null;
}

export interface UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_fields_rules_objectsToAssign = UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_fields_rules_objectsToAssign_Tag | UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_fields_rules_objectsToAssign_Audience | UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_fields_rules_objectsToAssign_Product | UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_fields_rules_objectsToAssign_Source | UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_fields_rules_objectsToAssign_Stageset;

export interface UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_fields_rules_objectsToAssign[];
}

export interface UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_fields_rules[];
}

export interface UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_defaultRule_targetPage {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
}

export interface UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_defaultRule_enumElement {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_defaultRule_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_defaultRule {
  __typename: "PageRule";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The action type of the rule
   */
  actionType: PageRuleActionType;
  /**
   * Whether the rule is field based
   */
  isFieldBased: boolean;
  /**
   * The page that the rule is associated with
   */
  targetPage: UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_defaultRule_targetPage | null;
  /**
   * The enum element that the rule is associated with
   */
  enumElement: UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_defaultRule_enumElement | null;
  /**
   * The field that the rule is associated with
   */
  field: UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_defaultRule_field | null;
}

export interface UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_conditionalRules_targetPage {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
}

export interface UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_conditionalRules_enumElement {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_conditionalRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_conditionalRules {
  __typename: "PageRule";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The action type of the rule
   */
  actionType: PageRuleActionType;
  /**
   * Whether the rule is field based
   */
  isFieldBased: boolean;
  /**
   * The page that the rule is associated with
   */
  targetPage: UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_conditionalRules_targetPage | null;
  /**
   * The enum element that the rule is associated with
   */
  enumElement: UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_conditionalRules_enumElement | null;
  /**
   * The field that the rule is associated with
   */
  field: UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_conditionalRules_field | null;
}

export interface UpdateMultiPageForm_formUpdate_form_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
  /**
   * Array of fields associated with this web form page
   */
  fields: UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_fields[];
  /**
   * The non-field based page rule associated with this web form page
   */
  defaultRule: UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_defaultRule;
  /**
   * Array of field-based rules associated with this web form page
   */
  conditionalRules: UpdateMultiPageForm_formUpdate_form_publishedVersion_pages_conditionalRules[];
}

export interface UpdateMultiPageForm_formUpdate_form_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: UpdateMultiPageForm_formUpdate_form_publishedVersion_pages[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
}

export interface UpdateMultiPageForm_formUpdate_form_editableVersion_pages_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface UpdateMultiPageForm_formUpdate_form_editableVersion_pages_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface UpdateMultiPageForm_formUpdate_form_editableVersion_pages_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface UpdateMultiPageForm_formUpdate_form_editableVersion_pages_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateMultiPageForm_formUpdate_form_editableVersion_pages_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface UpdateMultiPageForm_formUpdate_form_editableVersion_pages_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface UpdateMultiPageForm_formUpdate_form_editableVersion_pages_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateMultiPageForm_formUpdate_form_editableVersion_pages_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type UpdateMultiPageForm_formUpdate_form_editableVersion_pages_fields_rules_objectsToAssign = UpdateMultiPageForm_formUpdate_form_editableVersion_pages_fields_rules_objectsToAssign_Tag | UpdateMultiPageForm_formUpdate_form_editableVersion_pages_fields_rules_objectsToAssign_Audience | UpdateMultiPageForm_formUpdate_form_editableVersion_pages_fields_rules_objectsToAssign_Product | UpdateMultiPageForm_formUpdate_form_editableVersion_pages_fields_rules_objectsToAssign_Source | UpdateMultiPageForm_formUpdate_form_editableVersion_pages_fields_rules_objectsToAssign_Stageset;

export interface UpdateMultiPageForm_formUpdate_form_editableVersion_pages_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: UpdateMultiPageForm_formUpdate_form_editableVersion_pages_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: UpdateMultiPageForm_formUpdate_form_editableVersion_pages_fields_rules_objectsToAssign[];
}

export interface UpdateMultiPageForm_formUpdate_form_editableVersion_pages_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: UpdateMultiPageForm_formUpdate_form_editableVersion_pages_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: UpdateMultiPageForm_formUpdate_form_editableVersion_pages_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: UpdateMultiPageForm_formUpdate_form_editableVersion_pages_fields_rules[];
}

export interface UpdateMultiPageForm_formUpdate_form_editableVersion_pages_defaultRule_targetPage {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
}

export interface UpdateMultiPageForm_formUpdate_form_editableVersion_pages_defaultRule_enumElement {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface UpdateMultiPageForm_formUpdate_form_editableVersion_pages_defaultRule_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateMultiPageForm_formUpdate_form_editableVersion_pages_defaultRule {
  __typename: "PageRule";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The action type of the rule
   */
  actionType: PageRuleActionType;
  /**
   * Whether the rule is field based
   */
  isFieldBased: boolean;
  /**
   * The page that the rule is associated with
   */
  targetPage: UpdateMultiPageForm_formUpdate_form_editableVersion_pages_defaultRule_targetPage | null;
  /**
   * The enum element that the rule is associated with
   */
  enumElement: UpdateMultiPageForm_formUpdate_form_editableVersion_pages_defaultRule_enumElement | null;
  /**
   * The field that the rule is associated with
   */
  field: UpdateMultiPageForm_formUpdate_form_editableVersion_pages_defaultRule_field | null;
}

export interface UpdateMultiPageForm_formUpdate_form_editableVersion_pages_conditionalRules_targetPage {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
}

export interface UpdateMultiPageForm_formUpdate_form_editableVersion_pages_conditionalRules_enumElement {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface UpdateMultiPageForm_formUpdate_form_editableVersion_pages_conditionalRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateMultiPageForm_formUpdate_form_editableVersion_pages_conditionalRules {
  __typename: "PageRule";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The action type of the rule
   */
  actionType: PageRuleActionType;
  /**
   * Whether the rule is field based
   */
  isFieldBased: boolean;
  /**
   * The page that the rule is associated with
   */
  targetPage: UpdateMultiPageForm_formUpdate_form_editableVersion_pages_conditionalRules_targetPage | null;
  /**
   * The enum element that the rule is associated with
   */
  enumElement: UpdateMultiPageForm_formUpdate_form_editableVersion_pages_conditionalRules_enumElement | null;
  /**
   * The field that the rule is associated with
   */
  field: UpdateMultiPageForm_formUpdate_form_editableVersion_pages_conditionalRules_field | null;
}

export interface UpdateMultiPageForm_formUpdate_form_editableVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
  /**
   * Array of fields associated with this web form page
   */
  fields: UpdateMultiPageForm_formUpdate_form_editableVersion_pages_fields[];
  /**
   * The non-field based page rule associated with this web form page
   */
  defaultRule: UpdateMultiPageForm_formUpdate_form_editableVersion_pages_defaultRule;
  /**
   * Array of field-based rules associated with this web form page
   */
  conditionalRules: UpdateMultiPageForm_formUpdate_form_editableVersion_pages_conditionalRules[];
}

export interface UpdateMultiPageForm_formUpdate_form_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of pages associated with this web form version
   */
  pages: UpdateMultiPageForm_formUpdate_form_editableVersion_pages[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * Whether the form should render its multi-page progress indicator.
   */
  shouldShowFormProgress: boolean;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
}

export interface UpdateMultiPageForm_formUpdate_form_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface UpdateMultiPageForm_formUpdate_form_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateMultiPageForm_formUpdate_form_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: UpdateMultiPageForm_formUpdate_form_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: UpdateMultiPageForm_formUpdate_form_nextSteps_slackMessage_form;
}

export interface UpdateMultiPageForm_formUpdate_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface UpdateMultiPageForm_formUpdate_form_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type UpdateMultiPageForm_formUpdate_form_nextSteps_nutshellNotification_notifiables = UpdateMultiPageForm_formUpdate_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias | UpdateMultiPageForm_formUpdate_form_nextSteps_nutshellNotification_notifiables_User;

export interface UpdateMultiPageForm_formUpdate_form_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateMultiPageForm_formUpdate_form_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: UpdateMultiPageForm_formUpdate_form_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: UpdateMultiPageForm_formUpdate_form_nextSteps_nutshellNotification_form;
}

export interface UpdateMultiPageForm_formUpdate_form_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: UpdateMultiPageForm_formUpdate_form_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: UpdateMultiPageForm_formUpdate_form_nextSteps_nutshellNotification | null;
}

export interface UpdateMultiPageForm_formUpdate_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: UpdateMultiPageForm_formUpdate_form_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: UpdateMultiPageForm_formUpdate_form_publishedVersion | null;
  /**
   * Editor validation for the editable version (page fields and submittable navigation)
   */
  validationErrors: string[];
  /**
   * Whether the form has been embedded
   */
  isLiveForm: boolean;
  /**
   * The published form preview url
   */
  publishedFormPreviewUrl: string;
  /**
   * Publicly viewable link to published form
   */
  sharableViewInBrowserLink: string;
  /**
   * Boolean, true if the editable version has any edits
   */
  hasUnpublishedChanges: boolean;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: UpdateMultiPageForm_formUpdate_form_editableVersion;
  /**
   * The embed snippet for this form
   */
  embedSnippet: string;
  /**
   * The type of form
   */
  type: FormType;
  /**
   * True when this form is referenced anywhere in the chat config (intake,
   * offline, goals, or an action form). Chat-backed forms cannot be converted to
   * multi-page, so the editor should block adding additional pages when this is true.
   */
  isUsedByChat: boolean;
  /**
   * Next step automations for this form
   */
  nextSteps: UpdateMultiPageForm_formUpdate_form_nextSteps;
}

export interface UpdateMultiPageForm_formUpdate {
  __typename: "FormUpdatePayload";
  /**
   * The assigned Nutshell form.
   */
  form: UpdateMultiPageForm_formUpdate_form | null;
}

export interface UpdateMultiPageForm {
  /**
   * Updates the editable version of a Nutshell form.
   */
  formUpdate: UpdateMultiPageForm_formUpdate;
}

export interface UpdateMultiPageFormVariables {
  input: FormUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMultiPageForm
// ====================================================

export interface GetMultiPageForm_form_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetMultiPageForm_form_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetMultiPageForm_form_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface GetMultiPageForm_form_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface GetMultiPageForm_form_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetMultiPageForm_form_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: GetMultiPageForm_form_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: GetMultiPageForm_form_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: GetMultiPageForm_form_createRules_lead_stagesetFieldRules_stageset;
}

export interface GetMultiPageForm_form_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: GetMultiPageForm_form_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: GetMultiPageForm_form_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: GetMultiPageForm_form_createRules_lead_stagesetFieldRules[];
}

export interface GetMultiPageForm_form_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetMultiPageForm_form_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetMultiPageForm_form_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: GetMultiPageForm_form_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: GetMultiPageForm_form_createRules_contact_audiences[];
}

export interface GetMultiPageForm_form_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetMultiPageForm_form_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: GetMultiPageForm_form_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface GetMultiPageForm_form_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: GetMultiPageForm_form_createRules_lead | null;
  /**
   * The create rules related to a contact
   */
  contact: GetMultiPageForm_form_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: GetMultiPageForm_form_createRules_account | null;
}

export interface GetMultiPageForm_form_publishedVersion_pages_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface GetMultiPageForm_form_publishedVersion_pages_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface GetMultiPageForm_form_publishedVersion_pages_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface GetMultiPageForm_form_publishedVersion_pages_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetMultiPageForm_form_publishedVersion_pages_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetMultiPageForm_form_publishedVersion_pages_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface GetMultiPageForm_form_publishedVersion_pages_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetMultiPageForm_form_publishedVersion_pages_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type GetMultiPageForm_form_publishedVersion_pages_fields_rules_objectsToAssign = GetMultiPageForm_form_publishedVersion_pages_fields_rules_objectsToAssign_Tag | GetMultiPageForm_form_publishedVersion_pages_fields_rules_objectsToAssign_Audience | GetMultiPageForm_form_publishedVersion_pages_fields_rules_objectsToAssign_Product | GetMultiPageForm_form_publishedVersion_pages_fields_rules_objectsToAssign_Source | GetMultiPageForm_form_publishedVersion_pages_fields_rules_objectsToAssign_Stageset;

export interface GetMultiPageForm_form_publishedVersion_pages_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: GetMultiPageForm_form_publishedVersion_pages_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: GetMultiPageForm_form_publishedVersion_pages_fields_rules_objectsToAssign[];
}

export interface GetMultiPageForm_form_publishedVersion_pages_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: GetMultiPageForm_form_publishedVersion_pages_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: GetMultiPageForm_form_publishedVersion_pages_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: GetMultiPageForm_form_publishedVersion_pages_fields_rules[];
}

export interface GetMultiPageForm_form_publishedVersion_pages_defaultRule_targetPage {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
}

export interface GetMultiPageForm_form_publishedVersion_pages_defaultRule_enumElement {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface GetMultiPageForm_form_publishedVersion_pages_defaultRule_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMultiPageForm_form_publishedVersion_pages_defaultRule {
  __typename: "PageRule";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The action type of the rule
   */
  actionType: PageRuleActionType;
  /**
   * Whether the rule is field based
   */
  isFieldBased: boolean;
  /**
   * The page that the rule is associated with
   */
  targetPage: GetMultiPageForm_form_publishedVersion_pages_defaultRule_targetPage | null;
  /**
   * The enum element that the rule is associated with
   */
  enumElement: GetMultiPageForm_form_publishedVersion_pages_defaultRule_enumElement | null;
  /**
   * The field that the rule is associated with
   */
  field: GetMultiPageForm_form_publishedVersion_pages_defaultRule_field | null;
}

export interface GetMultiPageForm_form_publishedVersion_pages_conditionalRules_targetPage {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
}

export interface GetMultiPageForm_form_publishedVersion_pages_conditionalRules_enumElement {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface GetMultiPageForm_form_publishedVersion_pages_conditionalRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMultiPageForm_form_publishedVersion_pages_conditionalRules {
  __typename: "PageRule";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The action type of the rule
   */
  actionType: PageRuleActionType;
  /**
   * Whether the rule is field based
   */
  isFieldBased: boolean;
  /**
   * The page that the rule is associated with
   */
  targetPage: GetMultiPageForm_form_publishedVersion_pages_conditionalRules_targetPage | null;
  /**
   * The enum element that the rule is associated with
   */
  enumElement: GetMultiPageForm_form_publishedVersion_pages_conditionalRules_enumElement | null;
  /**
   * The field that the rule is associated with
   */
  field: GetMultiPageForm_form_publishedVersion_pages_conditionalRules_field | null;
}

export interface GetMultiPageForm_form_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
  /**
   * Array of fields associated with this web form page
   */
  fields: GetMultiPageForm_form_publishedVersion_pages_fields[];
  /**
   * The non-field based page rule associated with this web form page
   */
  defaultRule: GetMultiPageForm_form_publishedVersion_pages_defaultRule;
  /**
   * Array of field-based rules associated with this web form page
   */
  conditionalRules: GetMultiPageForm_form_publishedVersion_pages_conditionalRules[];
}

export interface GetMultiPageForm_form_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: GetMultiPageForm_form_publishedVersion_pages[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
}

export interface GetMultiPageForm_form_editableVersion_pages_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface GetMultiPageForm_form_editableVersion_pages_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface GetMultiPageForm_form_editableVersion_pages_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface GetMultiPageForm_form_editableVersion_pages_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetMultiPageForm_form_editableVersion_pages_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetMultiPageForm_form_editableVersion_pages_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface GetMultiPageForm_form_editableVersion_pages_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetMultiPageForm_form_editableVersion_pages_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type GetMultiPageForm_form_editableVersion_pages_fields_rules_objectsToAssign = GetMultiPageForm_form_editableVersion_pages_fields_rules_objectsToAssign_Tag | GetMultiPageForm_form_editableVersion_pages_fields_rules_objectsToAssign_Audience | GetMultiPageForm_form_editableVersion_pages_fields_rules_objectsToAssign_Product | GetMultiPageForm_form_editableVersion_pages_fields_rules_objectsToAssign_Source | GetMultiPageForm_form_editableVersion_pages_fields_rules_objectsToAssign_Stageset;

export interface GetMultiPageForm_form_editableVersion_pages_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: GetMultiPageForm_form_editableVersion_pages_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: GetMultiPageForm_form_editableVersion_pages_fields_rules_objectsToAssign[];
}

export interface GetMultiPageForm_form_editableVersion_pages_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: GetMultiPageForm_form_editableVersion_pages_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: GetMultiPageForm_form_editableVersion_pages_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: GetMultiPageForm_form_editableVersion_pages_fields_rules[];
}

export interface GetMultiPageForm_form_editableVersion_pages_defaultRule_targetPage {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
}

export interface GetMultiPageForm_form_editableVersion_pages_defaultRule_enumElement {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface GetMultiPageForm_form_editableVersion_pages_defaultRule_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMultiPageForm_form_editableVersion_pages_defaultRule {
  __typename: "PageRule";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The action type of the rule
   */
  actionType: PageRuleActionType;
  /**
   * Whether the rule is field based
   */
  isFieldBased: boolean;
  /**
   * The page that the rule is associated with
   */
  targetPage: GetMultiPageForm_form_editableVersion_pages_defaultRule_targetPage | null;
  /**
   * The enum element that the rule is associated with
   */
  enumElement: GetMultiPageForm_form_editableVersion_pages_defaultRule_enumElement | null;
  /**
   * The field that the rule is associated with
   */
  field: GetMultiPageForm_form_editableVersion_pages_defaultRule_field | null;
}

export interface GetMultiPageForm_form_editableVersion_pages_conditionalRules_targetPage {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
}

export interface GetMultiPageForm_form_editableVersion_pages_conditionalRules_enumElement {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface GetMultiPageForm_form_editableVersion_pages_conditionalRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMultiPageForm_form_editableVersion_pages_conditionalRules {
  __typename: "PageRule";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The action type of the rule
   */
  actionType: PageRuleActionType;
  /**
   * Whether the rule is field based
   */
  isFieldBased: boolean;
  /**
   * The page that the rule is associated with
   */
  targetPage: GetMultiPageForm_form_editableVersion_pages_conditionalRules_targetPage | null;
  /**
   * The enum element that the rule is associated with
   */
  enumElement: GetMultiPageForm_form_editableVersion_pages_conditionalRules_enumElement | null;
  /**
   * The field that the rule is associated with
   */
  field: GetMultiPageForm_form_editableVersion_pages_conditionalRules_field | null;
}

export interface GetMultiPageForm_form_editableVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
  /**
   * Array of fields associated with this web form page
   */
  fields: GetMultiPageForm_form_editableVersion_pages_fields[];
  /**
   * The non-field based page rule associated with this web form page
   */
  defaultRule: GetMultiPageForm_form_editableVersion_pages_defaultRule;
  /**
   * Array of field-based rules associated with this web form page
   */
  conditionalRules: GetMultiPageForm_form_editableVersion_pages_conditionalRules[];
}

export interface GetMultiPageForm_form_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of pages associated with this web form version
   */
  pages: GetMultiPageForm_form_editableVersion_pages[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * Whether the form should render its multi-page progress indicator.
   */
  shouldShowFormProgress: boolean;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
}

export interface GetMultiPageForm_form_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface GetMultiPageForm_form_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMultiPageForm_form_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: GetMultiPageForm_form_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: GetMultiPageForm_form_nextSteps_slackMessage_form;
}

export interface GetMultiPageForm_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface GetMultiPageForm_form_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type GetMultiPageForm_form_nextSteps_nutshellNotification_notifiables = GetMultiPageForm_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias | GetMultiPageForm_form_nextSteps_nutshellNotification_notifiables_User;

export interface GetMultiPageForm_form_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMultiPageForm_form_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: GetMultiPageForm_form_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: GetMultiPageForm_form_nextSteps_nutshellNotification_form;
}

export interface GetMultiPageForm_form_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: GetMultiPageForm_form_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: GetMultiPageForm_form_nextSteps_nutshellNotification | null;
}

export interface GetMultiPageForm_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: GetMultiPageForm_form_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: GetMultiPageForm_form_publishedVersion | null;
  /**
   * Editor validation for the editable version (page fields and submittable navigation)
   */
  validationErrors: string[];
  /**
   * Whether the form has been embedded
   */
  isLiveForm: boolean;
  /**
   * The published form preview url
   */
  publishedFormPreviewUrl: string;
  /**
   * Publicly viewable link to published form
   */
  sharableViewInBrowserLink: string;
  /**
   * Boolean, true if the editable version has any edits
   */
  hasUnpublishedChanges: boolean;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: GetMultiPageForm_form_editableVersion;
  /**
   * The embed snippet for this form
   */
  embedSnippet: string;
  /**
   * The type of form
   */
  type: FormType;
  /**
   * True when this form is referenced anywhere in the chat config (intake,
   * offline, goals, or an action form). Chat-backed forms cannot be converted to
   * multi-page, so the editor should block adding additional pages when this is true.
   */
  isUsedByChat: boolean;
  /**
   * Next step automations for this form
   */
  nextSteps: GetMultiPageForm_form_nextSteps;
}

export interface GetMultiPageForm {
  /**
   * Returns a Nutshell web form by ID or slug.
   */
  form: GetMultiPageForm_form;
}

export interface GetMultiPageFormVariables {
  formId?: string | null;
  formSlug?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSubmissions
// ====================================================

export interface GetSubmissions_submissions_submissions_pageInfo {
  __typename: "PageInfo";
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  endCursor: string | null;
  startCursor: string | null;
}

export interface GetSubmissions_submissions_submissions_edges_node_primaryEntity_relatedEmailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetSubmissions_submissions_submissions_edges_node_primaryEntity_relatedEmailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetSubmissions_submissions_submissions_edges_node_primaryEntity_relatedEmailAddresses_primary_value;
}

export interface GetSubmissions_submissions_submissions_edges_node_primaryEntity_relatedEmailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSubmissions_submissions_submissions_edges_node_primaryEntity_relatedEmailAddresses_primary | null;
}

export interface GetSubmissions_submissions_submissions_edges_node_primaryEntity {
  __typename: "Account" | "Lead" | "Contact";
  name: string;
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  relatedEmailAddresses: GetSubmissions_submissions_submissions_edges_node_primaryEntity_relatedEmailAddresses;
  htmlUrl: string;
  htmlUrlPath: string;
  avatarUrl: string;
}

export interface GetSubmissions_submissions_submissions_edges_node_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface GetSubmissions_submissions_submissions_edges_node_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: GetSubmissions_submissions_submissions_edges_node_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export interface GetSubmissions_submissions_submissions_edges_node_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface GetSubmissions_submissions_submissions_edges_node_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export type GetSubmissions_submissions_submissions_edges_node_fields_edges_fieldValue = GetSubmissions_submissions_submissions_edges_node_fields_edges_fieldValue_FormFieldSubmissionValueSubfields | GetSubmissions_submissions_submissions_edges_node_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | GetSubmissions_submissions_submissions_edges_node_fields_edges_fieldValue_FormFieldSubmissionValueSingle;

export interface GetSubmissions_submissions_submissions_edges_node_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
}

export interface GetSubmissions_submissions_submissions_edges_node_fields_edges {
  __typename: "SubmissionFieldsEdge";
  /**
   * Value for field on a given submission
   */
  fieldValue: GetSubmissions_submissions_submissions_edges_node_fields_edges_fieldValue | null;
  node: GetSubmissions_submissions_submissions_edges_node_fields_edges_node;
}

export interface GetSubmissions_submissions_submissions_edges_node_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetSubmissions_submissions_submissions_edges_node_fields_edges[];
}

export interface GetSubmissions_submissions_submissions_edges_node {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The primary entity on the submission
   */
  primaryEntity: GetSubmissions_submissions_submissions_edges_node_primaryEntity | null;
  /**
   * The internal submission id of this form submission.
   */
  submissionId: string | null;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: GetSubmissions_submissions_submissions_edges_node_fields;
}

export interface GetSubmissions_submissions_submissions_edges {
  __typename: "SubmissionEdge";
  node: GetSubmissions_submissions_submissions_edges_node;
}

export interface GetSubmissions_submissions_submissions {
  __typename: "SubmissionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetSubmissions_submissions_submissions_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetSubmissions_submissions_submissions_edges[];
}

export interface GetSubmissions_submissions {
  __typename: "FormSubmissions";
  /**
   * The submissions for the form.
   */
  submissions: GetSubmissions_submissions_submissions;
}

export interface GetSubmissions {
  /**
   * An interface for retrieving a form and viewing and sorting its submissions.
   */
  submissions: GetSubmissions_submissions;
}

export interface GetSubmissionsVariables {
  input: FormSubmissionsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateField
// ====================================================

export interface CreateField_fieldCreate_field_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface CreateField_fieldCreate_field_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface CreateField_fieldCreate_field_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface CreateField_fieldCreate_field_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateField_fieldCreate_field_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface CreateField_fieldCreate_field_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface CreateField_fieldCreate_field_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateField_fieldCreate_field_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type CreateField_fieldCreate_field_rules_objectsToAssign = CreateField_fieldCreate_field_rules_objectsToAssign_Tag | CreateField_fieldCreate_field_rules_objectsToAssign_Audience | CreateField_fieldCreate_field_rules_objectsToAssign_Product | CreateField_fieldCreate_field_rules_objectsToAssign_Source | CreateField_fieldCreate_field_rules_objectsToAssign_Stageset;

export interface CreateField_fieldCreate_field_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: CreateField_fieldCreate_field_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: CreateField_fieldCreate_field_rules_objectsToAssign[];
}

export interface CreateField_fieldCreate_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: CreateField_fieldCreate_field_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: CreateField_fieldCreate_field_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: CreateField_fieldCreate_field_rules[];
}

export interface CreateField_fieldCreate {
  __typename: "FieldCreatePayload";
  /**
   * The new field.
   */
  field: CreateField_fieldCreate_field;
}

export interface CreateField {
  /**
   * Updates the editable version of a Nutshell form.
   */
  fieldCreate: CreateField_fieldCreate;
}

export interface CreateFieldVariables {
  input: FieldCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateForm
// ====================================================

export interface CreateForm_formCreate_form_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface CreateForm_formCreate_form_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateForm_formCreate_form_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface CreateForm_formCreate_form_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface CreateForm_formCreate_form_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface CreateForm_formCreate_form_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: CreateForm_formCreate_form_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: CreateForm_formCreate_form_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: CreateForm_formCreate_form_createRules_lead_stagesetFieldRules_stageset;
}

export interface CreateForm_formCreate_form_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: CreateForm_formCreate_form_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: CreateForm_formCreate_form_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: CreateForm_formCreate_form_createRules_lead_stagesetFieldRules[];
}

export interface CreateForm_formCreate_form_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateForm_formCreate_form_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface CreateForm_formCreate_form_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: CreateForm_formCreate_form_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: CreateForm_formCreate_form_createRules_contact_audiences[];
}

export interface CreateForm_formCreate_form_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateForm_formCreate_form_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: CreateForm_formCreate_form_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface CreateForm_formCreate_form_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: CreateForm_formCreate_form_createRules_lead | null;
  /**
   * The create rules related to a contact
   */
  contact: CreateForm_formCreate_form_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: CreateForm_formCreate_form_createRules_account | null;
}

export interface CreateForm_formCreate_form_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateForm_formCreate_form_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface CreateForm_formCreate_form_publishedVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface CreateForm_formCreate_form_publishedVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface CreateForm_formCreate_form_publishedVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateForm_formCreate_form_publishedVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface CreateForm_formCreate_form_publishedVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface CreateForm_formCreate_form_publishedVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateForm_formCreate_form_publishedVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type CreateForm_formCreate_form_publishedVersion_fields_rules_objectsToAssign = CreateForm_formCreate_form_publishedVersion_fields_rules_objectsToAssign_Tag | CreateForm_formCreate_form_publishedVersion_fields_rules_objectsToAssign_Audience | CreateForm_formCreate_form_publishedVersion_fields_rules_objectsToAssign_Product | CreateForm_formCreate_form_publishedVersion_fields_rules_objectsToAssign_Source | CreateForm_formCreate_form_publishedVersion_fields_rules_objectsToAssign_Stageset;

export interface CreateForm_formCreate_form_publishedVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: CreateForm_formCreate_form_publishedVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: CreateForm_formCreate_form_publishedVersion_fields_rules_objectsToAssign[];
}

export interface CreateForm_formCreate_form_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: CreateForm_formCreate_form_publishedVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: CreateForm_formCreate_form_publishedVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: CreateForm_formCreate_form_publishedVersion_fields_rules[];
}

export interface CreateForm_formCreate_form_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: CreateForm_formCreate_form_publishedVersion_pages[];
  /**
   * Array of fields associated with this web form version
   */
  fields: CreateForm_formCreate_form_publishedVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
}

export interface CreateForm_formCreate_form_editableVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface CreateForm_formCreate_form_editableVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface CreateForm_formCreate_form_editableVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface CreateForm_formCreate_form_editableVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateForm_formCreate_form_editableVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface CreateForm_formCreate_form_editableVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface CreateForm_formCreate_form_editableVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateForm_formCreate_form_editableVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type CreateForm_formCreate_form_editableVersion_fields_rules_objectsToAssign = CreateForm_formCreate_form_editableVersion_fields_rules_objectsToAssign_Tag | CreateForm_formCreate_form_editableVersion_fields_rules_objectsToAssign_Audience | CreateForm_formCreate_form_editableVersion_fields_rules_objectsToAssign_Product | CreateForm_formCreate_form_editableVersion_fields_rules_objectsToAssign_Source | CreateForm_formCreate_form_editableVersion_fields_rules_objectsToAssign_Stageset;

export interface CreateForm_formCreate_form_editableVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: CreateForm_formCreate_form_editableVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: CreateForm_formCreate_form_editableVersion_fields_rules_objectsToAssign[];
}

export interface CreateForm_formCreate_form_editableVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: CreateForm_formCreate_form_editableVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: CreateForm_formCreate_form_editableVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: CreateForm_formCreate_form_editableVersion_fields_rules[];
}

export interface CreateForm_formCreate_form_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of fields associated with this web form version
   */
  fields: CreateForm_formCreate_form_editableVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
}

export interface CreateForm_formCreate_form_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface CreateForm_formCreate_form_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateForm_formCreate_form_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: CreateForm_formCreate_form_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: CreateForm_formCreate_form_nextSteps_slackMessage_form;
}

export interface CreateForm_formCreate_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface CreateForm_formCreate_form_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type CreateForm_formCreate_form_nextSteps_nutshellNotification_notifiables = CreateForm_formCreate_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias | CreateForm_formCreate_form_nextSteps_nutshellNotification_notifiables_User;

export interface CreateForm_formCreate_form_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateForm_formCreate_form_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: CreateForm_formCreate_form_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: CreateForm_formCreate_form_nextSteps_nutshellNotification_form;
}

export interface CreateForm_formCreate_form_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: CreateForm_formCreate_form_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: CreateForm_formCreate_form_nextSteps_nutshellNotification | null;
}

export interface CreateForm_formCreate_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: CreateForm_formCreate_form_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: CreateForm_formCreate_form_publishedVersion | null;
  /**
   * Whether the form has been embedded
   */
  isLiveForm: boolean;
  /**
   * The published form preview url
   */
  publishedFormPreviewUrl: string;
  /**
   * Publicly viewable link to published form
   */
  sharableViewInBrowserLink: string;
  /**
   * Boolean, true if the editable version has any edits
   */
  hasUnpublishedChanges: boolean;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: CreateForm_formCreate_form_editableVersion;
  /**
   * Next step automations for this form
   */
  nextSteps: CreateForm_formCreate_form_nextSteps;
  /**
   * The embed snippet for this form
   */
  embedSnippet: string;
  /**
   * The type of form
   */
  type: FormType;
}

export interface CreateForm_formCreate {
  __typename: "FormCreatePayload";
  /**
   * The newly created Nutshell form.
   */
  form: CreateForm_formCreate_form | null;
}

export interface CreateForm {
  /**
   * Creates a Nutshell web form
   */
  formCreate: CreateForm_formCreate;
}

export interface CreateFormVariables {
  input: FormCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteForm
// ====================================================

export interface DeleteForm_formDelete_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteForm_formDelete {
  __typename: "FormDeletePayload";
  /**
   * The form
   */
  form: DeleteForm_formDelete_form;
}

export interface DeleteForm {
  /**
   * Delete a web form
   */
  formDelete: DeleteForm_formDelete | null;
}

export interface DeleteFormVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DiscardForm
// ====================================================

export interface DiscardForm_formDiscardChanges_form_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface DiscardForm_formDiscardChanges_form_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DiscardForm_formDiscardChanges_form_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface DiscardForm_formDiscardChanges_form_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface DiscardForm_formDiscardChanges_form_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface DiscardForm_formDiscardChanges_form_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: DiscardForm_formDiscardChanges_form_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: DiscardForm_formDiscardChanges_form_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: DiscardForm_formDiscardChanges_form_createRules_lead_stagesetFieldRules_stageset;
}

export interface DiscardForm_formDiscardChanges_form_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: DiscardForm_formDiscardChanges_form_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: DiscardForm_formDiscardChanges_form_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: DiscardForm_formDiscardChanges_form_createRules_lead_stagesetFieldRules[];
}

export interface DiscardForm_formDiscardChanges_form_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DiscardForm_formDiscardChanges_form_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface DiscardForm_formDiscardChanges_form_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: DiscardForm_formDiscardChanges_form_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: DiscardForm_formDiscardChanges_form_createRules_contact_audiences[];
}

export interface DiscardForm_formDiscardChanges_form_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DiscardForm_formDiscardChanges_form_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: DiscardForm_formDiscardChanges_form_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface DiscardForm_formDiscardChanges_form_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: DiscardForm_formDiscardChanges_form_createRules_lead | null;
  /**
   * The create rules related to a contact
   */
  contact: DiscardForm_formDiscardChanges_form_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: DiscardForm_formDiscardChanges_form_createRules_account | null;
}

export interface DiscardForm_formDiscardChanges_form_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DiscardForm_formDiscardChanges_form_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface DiscardForm_formDiscardChanges_form_publishedVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface DiscardForm_formDiscardChanges_form_publishedVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface DiscardForm_formDiscardChanges_form_publishedVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DiscardForm_formDiscardChanges_form_publishedVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface DiscardForm_formDiscardChanges_form_publishedVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface DiscardForm_formDiscardChanges_form_publishedVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DiscardForm_formDiscardChanges_form_publishedVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type DiscardForm_formDiscardChanges_form_publishedVersion_fields_rules_objectsToAssign = DiscardForm_formDiscardChanges_form_publishedVersion_fields_rules_objectsToAssign_Tag | DiscardForm_formDiscardChanges_form_publishedVersion_fields_rules_objectsToAssign_Audience | DiscardForm_formDiscardChanges_form_publishedVersion_fields_rules_objectsToAssign_Product | DiscardForm_formDiscardChanges_form_publishedVersion_fields_rules_objectsToAssign_Source | DiscardForm_formDiscardChanges_form_publishedVersion_fields_rules_objectsToAssign_Stageset;

export interface DiscardForm_formDiscardChanges_form_publishedVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: DiscardForm_formDiscardChanges_form_publishedVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: DiscardForm_formDiscardChanges_form_publishedVersion_fields_rules_objectsToAssign[];
}

export interface DiscardForm_formDiscardChanges_form_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: DiscardForm_formDiscardChanges_form_publishedVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: DiscardForm_formDiscardChanges_form_publishedVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: DiscardForm_formDiscardChanges_form_publishedVersion_fields_rules[];
}

export interface DiscardForm_formDiscardChanges_form_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: DiscardForm_formDiscardChanges_form_publishedVersion_pages[];
  /**
   * Array of fields associated with this web form version
   */
  fields: DiscardForm_formDiscardChanges_form_publishedVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
}

export interface DiscardForm_formDiscardChanges_form_editableVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface DiscardForm_formDiscardChanges_form_editableVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface DiscardForm_formDiscardChanges_form_editableVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface DiscardForm_formDiscardChanges_form_editableVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DiscardForm_formDiscardChanges_form_editableVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface DiscardForm_formDiscardChanges_form_editableVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface DiscardForm_formDiscardChanges_form_editableVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DiscardForm_formDiscardChanges_form_editableVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type DiscardForm_formDiscardChanges_form_editableVersion_fields_rules_objectsToAssign = DiscardForm_formDiscardChanges_form_editableVersion_fields_rules_objectsToAssign_Tag | DiscardForm_formDiscardChanges_form_editableVersion_fields_rules_objectsToAssign_Audience | DiscardForm_formDiscardChanges_form_editableVersion_fields_rules_objectsToAssign_Product | DiscardForm_formDiscardChanges_form_editableVersion_fields_rules_objectsToAssign_Source | DiscardForm_formDiscardChanges_form_editableVersion_fields_rules_objectsToAssign_Stageset;

export interface DiscardForm_formDiscardChanges_form_editableVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: DiscardForm_formDiscardChanges_form_editableVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: DiscardForm_formDiscardChanges_form_editableVersion_fields_rules_objectsToAssign[];
}

export interface DiscardForm_formDiscardChanges_form_editableVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: DiscardForm_formDiscardChanges_form_editableVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: DiscardForm_formDiscardChanges_form_editableVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: DiscardForm_formDiscardChanges_form_editableVersion_fields_rules[];
}

export interface DiscardForm_formDiscardChanges_form_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of fields associated with this web form version
   */
  fields: DiscardForm_formDiscardChanges_form_editableVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
}

export interface DiscardForm_formDiscardChanges_form_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface DiscardForm_formDiscardChanges_form_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DiscardForm_formDiscardChanges_form_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: DiscardForm_formDiscardChanges_form_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: DiscardForm_formDiscardChanges_form_nextSteps_slackMessage_form;
}

export interface DiscardForm_formDiscardChanges_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface DiscardForm_formDiscardChanges_form_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type DiscardForm_formDiscardChanges_form_nextSteps_nutshellNotification_notifiables = DiscardForm_formDiscardChanges_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias | DiscardForm_formDiscardChanges_form_nextSteps_nutshellNotification_notifiables_User;

export interface DiscardForm_formDiscardChanges_form_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DiscardForm_formDiscardChanges_form_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: DiscardForm_formDiscardChanges_form_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: DiscardForm_formDiscardChanges_form_nextSteps_nutshellNotification_form;
}

export interface DiscardForm_formDiscardChanges_form_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: DiscardForm_formDiscardChanges_form_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: DiscardForm_formDiscardChanges_form_nextSteps_nutshellNotification | null;
}

export interface DiscardForm_formDiscardChanges_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: DiscardForm_formDiscardChanges_form_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: DiscardForm_formDiscardChanges_form_publishedVersion | null;
  /**
   * Whether the form has been embedded
   */
  isLiveForm: boolean;
  /**
   * The published form preview url
   */
  publishedFormPreviewUrl: string;
  /**
   * Publicly viewable link to published form
   */
  sharableViewInBrowserLink: string;
  /**
   * Boolean, true if the editable version has any edits
   */
  hasUnpublishedChanges: boolean;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: DiscardForm_formDiscardChanges_form_editableVersion;
  /**
   * Next step automations for this form
   */
  nextSteps: DiscardForm_formDiscardChanges_form_nextSteps;
  /**
   * The embed snippet for this form
   */
  embedSnippet: string;
  /**
   * The type of form
   */
  type: FormType;
}

export interface DiscardForm_formDiscardChanges {
  __typename: "FormDiscardChangesPayload";
  /**
   * The assigned Nutshell form.
   */
  form: DiscardForm_formDiscardChanges_form | null;
}

export interface DiscardForm {
  /**
   * Updates the editable version of a Nutshell form.
   */
  formDiscardChanges: DiscardForm_formDiscardChanges;
}

export interface DiscardFormVariables {
  input: FormDiscardChangesInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DuplicateForm
// ====================================================

export interface DuplicateForm_formDuplicate_form_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface DuplicateForm_formDuplicate_form_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DuplicateForm_formDuplicate_form_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface DuplicateForm_formDuplicate_form_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface DuplicateForm_formDuplicate_form_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface DuplicateForm_formDuplicate_form_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: DuplicateForm_formDuplicate_form_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: DuplicateForm_formDuplicate_form_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: DuplicateForm_formDuplicate_form_createRules_lead_stagesetFieldRules_stageset;
}

export interface DuplicateForm_formDuplicate_form_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: DuplicateForm_formDuplicate_form_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: DuplicateForm_formDuplicate_form_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: DuplicateForm_formDuplicate_form_createRules_lead_stagesetFieldRules[];
}

export interface DuplicateForm_formDuplicate_form_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DuplicateForm_formDuplicate_form_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface DuplicateForm_formDuplicate_form_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: DuplicateForm_formDuplicate_form_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: DuplicateForm_formDuplicate_form_createRules_contact_audiences[];
}

export interface DuplicateForm_formDuplicate_form_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DuplicateForm_formDuplicate_form_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: DuplicateForm_formDuplicate_form_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface DuplicateForm_formDuplicate_form_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: DuplicateForm_formDuplicate_form_createRules_lead | null;
  /**
   * The create rules related to a contact
   */
  contact: DuplicateForm_formDuplicate_form_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: DuplicateForm_formDuplicate_form_createRules_account | null;
}

export interface DuplicateForm_formDuplicate_form_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DuplicateForm_formDuplicate_form_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface DuplicateForm_formDuplicate_form_publishedVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface DuplicateForm_formDuplicate_form_publishedVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface DuplicateForm_formDuplicate_form_publishedVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DuplicateForm_formDuplicate_form_publishedVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface DuplicateForm_formDuplicate_form_publishedVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface DuplicateForm_formDuplicate_form_publishedVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DuplicateForm_formDuplicate_form_publishedVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type DuplicateForm_formDuplicate_form_publishedVersion_fields_rules_objectsToAssign = DuplicateForm_formDuplicate_form_publishedVersion_fields_rules_objectsToAssign_Tag | DuplicateForm_formDuplicate_form_publishedVersion_fields_rules_objectsToAssign_Audience | DuplicateForm_formDuplicate_form_publishedVersion_fields_rules_objectsToAssign_Product | DuplicateForm_formDuplicate_form_publishedVersion_fields_rules_objectsToAssign_Source | DuplicateForm_formDuplicate_form_publishedVersion_fields_rules_objectsToAssign_Stageset;

export interface DuplicateForm_formDuplicate_form_publishedVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: DuplicateForm_formDuplicate_form_publishedVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: DuplicateForm_formDuplicate_form_publishedVersion_fields_rules_objectsToAssign[];
}

export interface DuplicateForm_formDuplicate_form_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: DuplicateForm_formDuplicate_form_publishedVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: DuplicateForm_formDuplicate_form_publishedVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: DuplicateForm_formDuplicate_form_publishedVersion_fields_rules[];
}

export interface DuplicateForm_formDuplicate_form_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: DuplicateForm_formDuplicate_form_publishedVersion_pages[];
  /**
   * Array of fields associated with this web form version
   */
  fields: DuplicateForm_formDuplicate_form_publishedVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
}

export interface DuplicateForm_formDuplicate_form_editableVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface DuplicateForm_formDuplicate_form_editableVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface DuplicateForm_formDuplicate_form_editableVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface DuplicateForm_formDuplicate_form_editableVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DuplicateForm_formDuplicate_form_editableVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface DuplicateForm_formDuplicate_form_editableVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface DuplicateForm_formDuplicate_form_editableVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DuplicateForm_formDuplicate_form_editableVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type DuplicateForm_formDuplicate_form_editableVersion_fields_rules_objectsToAssign = DuplicateForm_formDuplicate_form_editableVersion_fields_rules_objectsToAssign_Tag | DuplicateForm_formDuplicate_form_editableVersion_fields_rules_objectsToAssign_Audience | DuplicateForm_formDuplicate_form_editableVersion_fields_rules_objectsToAssign_Product | DuplicateForm_formDuplicate_form_editableVersion_fields_rules_objectsToAssign_Source | DuplicateForm_formDuplicate_form_editableVersion_fields_rules_objectsToAssign_Stageset;

export interface DuplicateForm_formDuplicate_form_editableVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: DuplicateForm_formDuplicate_form_editableVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: DuplicateForm_formDuplicate_form_editableVersion_fields_rules_objectsToAssign[];
}

export interface DuplicateForm_formDuplicate_form_editableVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: DuplicateForm_formDuplicate_form_editableVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: DuplicateForm_formDuplicate_form_editableVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: DuplicateForm_formDuplicate_form_editableVersion_fields_rules[];
}

export interface DuplicateForm_formDuplicate_form_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of fields associated with this web form version
   */
  fields: DuplicateForm_formDuplicate_form_editableVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
}

export interface DuplicateForm_formDuplicate_form_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface DuplicateForm_formDuplicate_form_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DuplicateForm_formDuplicate_form_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: DuplicateForm_formDuplicate_form_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: DuplicateForm_formDuplicate_form_nextSteps_slackMessage_form;
}

export interface DuplicateForm_formDuplicate_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface DuplicateForm_formDuplicate_form_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type DuplicateForm_formDuplicate_form_nextSteps_nutshellNotification_notifiables = DuplicateForm_formDuplicate_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias | DuplicateForm_formDuplicate_form_nextSteps_nutshellNotification_notifiables_User;

export interface DuplicateForm_formDuplicate_form_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DuplicateForm_formDuplicate_form_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: DuplicateForm_formDuplicate_form_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: DuplicateForm_formDuplicate_form_nextSteps_nutshellNotification_form;
}

export interface DuplicateForm_formDuplicate_form_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: DuplicateForm_formDuplicate_form_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: DuplicateForm_formDuplicate_form_nextSteps_nutshellNotification | null;
}

export interface DuplicateForm_formDuplicate_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: DuplicateForm_formDuplicate_form_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: DuplicateForm_formDuplicate_form_publishedVersion | null;
  /**
   * Whether the form has been embedded
   */
  isLiveForm: boolean;
  /**
   * The published form preview url
   */
  publishedFormPreviewUrl: string;
  /**
   * Publicly viewable link to published form
   */
  sharableViewInBrowserLink: string;
  /**
   * Boolean, true if the editable version has any edits
   */
  hasUnpublishedChanges: boolean;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: DuplicateForm_formDuplicate_form_editableVersion;
  /**
   * Next step automations for this form
   */
  nextSteps: DuplicateForm_formDuplicate_form_nextSteps;
  /**
   * The embed snippet for this form
   */
  embedSnippet: string;
  /**
   * The type of form
   */
  type: FormType;
}

export interface DuplicateForm_formDuplicate {
  __typename: "FormDuplicatePayload";
  /**
   * The newly copied Nutshell form.
   */
  form: DuplicateForm_formDuplicate_form;
}

export interface DuplicateForm {
  /**
   * Creates a deep copy of a Nutshell Form
   */
  formDuplicate: DuplicateForm_formDuplicate;
}

export interface DuplicateFormVariables {
  input: FormDuplicateInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: PublishForm
// ====================================================

export interface PublishForm_formPublish_form_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface PublishForm_formPublish_form_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface PublishForm_formPublish_form_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface PublishForm_formPublish_form_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface PublishForm_formPublish_form_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface PublishForm_formPublish_form_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: PublishForm_formPublish_form_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: PublishForm_formPublish_form_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: PublishForm_formPublish_form_createRules_lead_stagesetFieldRules_stageset;
}

export interface PublishForm_formPublish_form_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: PublishForm_formPublish_form_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: PublishForm_formPublish_form_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: PublishForm_formPublish_form_createRules_lead_stagesetFieldRules[];
}

export interface PublishForm_formPublish_form_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface PublishForm_formPublish_form_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface PublishForm_formPublish_form_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: PublishForm_formPublish_form_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: PublishForm_formPublish_form_createRules_contact_audiences[];
}

export interface PublishForm_formPublish_form_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface PublishForm_formPublish_form_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: PublishForm_formPublish_form_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface PublishForm_formPublish_form_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: PublishForm_formPublish_form_createRules_lead | null;
  /**
   * The create rules related to a contact
   */
  contact: PublishForm_formPublish_form_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: PublishForm_formPublish_form_createRules_account | null;
}

export interface PublishForm_formPublish_form_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface PublishForm_formPublish_form_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface PublishForm_formPublish_form_publishedVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface PublishForm_formPublish_form_publishedVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface PublishForm_formPublish_form_publishedVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface PublishForm_formPublish_form_publishedVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface PublishForm_formPublish_form_publishedVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface PublishForm_formPublish_form_publishedVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface PublishForm_formPublish_form_publishedVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type PublishForm_formPublish_form_publishedVersion_fields_rules_objectsToAssign = PublishForm_formPublish_form_publishedVersion_fields_rules_objectsToAssign_Tag | PublishForm_formPublish_form_publishedVersion_fields_rules_objectsToAssign_Audience | PublishForm_formPublish_form_publishedVersion_fields_rules_objectsToAssign_Product | PublishForm_formPublish_form_publishedVersion_fields_rules_objectsToAssign_Source | PublishForm_formPublish_form_publishedVersion_fields_rules_objectsToAssign_Stageset;

export interface PublishForm_formPublish_form_publishedVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: PublishForm_formPublish_form_publishedVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: PublishForm_formPublish_form_publishedVersion_fields_rules_objectsToAssign[];
}

export interface PublishForm_formPublish_form_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: PublishForm_formPublish_form_publishedVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: PublishForm_formPublish_form_publishedVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: PublishForm_formPublish_form_publishedVersion_fields_rules[];
}

export interface PublishForm_formPublish_form_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: PublishForm_formPublish_form_publishedVersion_pages[];
  /**
   * Array of fields associated with this web form version
   */
  fields: PublishForm_formPublish_form_publishedVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
}

export interface PublishForm_formPublish_form_editableVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface PublishForm_formPublish_form_editableVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface PublishForm_formPublish_form_editableVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface PublishForm_formPublish_form_editableVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface PublishForm_formPublish_form_editableVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface PublishForm_formPublish_form_editableVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface PublishForm_formPublish_form_editableVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface PublishForm_formPublish_form_editableVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type PublishForm_formPublish_form_editableVersion_fields_rules_objectsToAssign = PublishForm_formPublish_form_editableVersion_fields_rules_objectsToAssign_Tag | PublishForm_formPublish_form_editableVersion_fields_rules_objectsToAssign_Audience | PublishForm_formPublish_form_editableVersion_fields_rules_objectsToAssign_Product | PublishForm_formPublish_form_editableVersion_fields_rules_objectsToAssign_Source | PublishForm_formPublish_form_editableVersion_fields_rules_objectsToAssign_Stageset;

export interface PublishForm_formPublish_form_editableVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: PublishForm_formPublish_form_editableVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: PublishForm_formPublish_form_editableVersion_fields_rules_objectsToAssign[];
}

export interface PublishForm_formPublish_form_editableVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: PublishForm_formPublish_form_editableVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: PublishForm_formPublish_form_editableVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: PublishForm_formPublish_form_editableVersion_fields_rules[];
}

export interface PublishForm_formPublish_form_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of fields associated with this web form version
   */
  fields: PublishForm_formPublish_form_editableVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
}

export interface PublishForm_formPublish_form_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface PublishForm_formPublish_form_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface PublishForm_formPublish_form_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: PublishForm_formPublish_form_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: PublishForm_formPublish_form_nextSteps_slackMessage_form;
}

export interface PublishForm_formPublish_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface PublishForm_formPublish_form_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type PublishForm_formPublish_form_nextSteps_nutshellNotification_notifiables = PublishForm_formPublish_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias | PublishForm_formPublish_form_nextSteps_nutshellNotification_notifiables_User;

export interface PublishForm_formPublish_form_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface PublishForm_formPublish_form_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: PublishForm_formPublish_form_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: PublishForm_formPublish_form_nextSteps_nutshellNotification_form;
}

export interface PublishForm_formPublish_form_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: PublishForm_formPublish_form_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: PublishForm_formPublish_form_nextSteps_nutshellNotification | null;
}

export interface PublishForm_formPublish_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: PublishForm_formPublish_form_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: PublishForm_formPublish_form_publishedVersion | null;
  /**
   * Whether the form has been embedded
   */
  isLiveForm: boolean;
  /**
   * The published form preview url
   */
  publishedFormPreviewUrl: string;
  /**
   * Publicly viewable link to published form
   */
  sharableViewInBrowserLink: string;
  /**
   * Boolean, true if the editable version has any edits
   */
  hasUnpublishedChanges: boolean;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: PublishForm_formPublish_form_editableVersion;
  /**
   * Next step automations for this form
   */
  nextSteps: PublishForm_formPublish_form_nextSteps;
  /**
   * The embed snippet for this form
   */
  embedSnippet: string;
  /**
   * The type of form
   */
  type: FormType;
}

export interface PublishForm_formPublish {
  __typename: "FormPublishPayload";
  /**
   * The published form.
   */
  form: PublishForm_formPublish_form | null;
}

export interface PublishForm {
  /**
   * Publishes a Nutshell form, replacing the previous live version.
   */
  formPublish: PublishForm_formPublish;
}

export interface PublishFormVariables {
  input: FormPublishInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RestoreForm
// ====================================================

export interface RestoreForm_formRestore_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface RestoreForm_formRestore {
  __typename: "FormRestorePayload";
  /**
   * The restored Nutshell form
   */
  form: RestoreForm_formRestore_form;
}

export interface RestoreForm {
  /**
   * Restores a deleted form.
   */
  formRestore: RestoreForm_formRestore;
}

export interface RestoreFormVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: FormCreateRulesUpdate
// ====================================================

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_stagesetFieldRules_stageset;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead_stagesetFieldRules[];
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_contact_audiences[];
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_lead | null;
  /**
   * The create rules related to a contact
   */
  contact: FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules_account | null;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_rules_objectsToAssign = FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_rules_objectsToAssign_Tag | FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_rules_objectsToAssign_Audience | FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_rules_objectsToAssign_Product | FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_rules_objectsToAssign_Source | FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_rules_objectsToAssign_Stageset;

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_rules_objectsToAssign[];
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields_rules[];
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_pages[];
  /**
   * Array of fields associated with this web form version
   */
  fields: FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion_fields_rules_objectsToAssign = FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion_fields_rules_objectsToAssign_Tag | FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion_fields_rules_objectsToAssign_Audience | FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion_fields_rules_objectsToAssign_Product | FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion_fields_rules_objectsToAssign_Source | FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion_fields_rules_objectsToAssign_Stageset;

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion_fields_rules_objectsToAssign[];
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion_fields_rules[];
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of fields associated with this web form version
   */
  fields: FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: FormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: FormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_slackMessage_form;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type FormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_nutshellNotification_notifiables = FormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias | FormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_nutshellNotification_notifiables_User;

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: FormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: FormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_nutshellNotification_form;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: FormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: FormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps_nutshellNotification | null;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: FormCreateRulesUpdate_formCreateRulesUpdate_form_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: FormCreateRulesUpdate_formCreateRulesUpdate_form_publishedVersion | null;
  /**
   * Whether the form has been embedded
   */
  isLiveForm: boolean;
  /**
   * The published form preview url
   */
  publishedFormPreviewUrl: string;
  /**
   * Publicly viewable link to published form
   */
  sharableViewInBrowserLink: string;
  /**
   * Boolean, true if the editable version has any edits
   */
  hasUnpublishedChanges: boolean;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: FormCreateRulesUpdate_formCreateRulesUpdate_form_editableVersion;
  /**
   * Next step automations for this form
   */
  nextSteps: FormCreateRulesUpdate_formCreateRulesUpdate_form_nextSteps;
  /**
   * The embed snippet for this form
   */
  embedSnippet: string;
  /**
   * The type of form
   */
  type: FormType;
}

export interface FormCreateRulesUpdate_formCreateRulesUpdate {
  __typename: "FormCreateRulesUpdatePayload";
  /**
   * The assigned Nutshell form.
   */
  form: FormCreateRulesUpdate_formCreateRulesUpdate_form | null;
}

export interface FormCreateRulesUpdate {
  /**
   * Updates the create rules for a Nutshell form.
   */
  formCreateRulesUpdate: FormCreateRulesUpdate_formCreateRulesUpdate;
}

export interface FormCreateRulesUpdateVariables {
  input: FormCreateRulesUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateForm
// ====================================================

export interface UpdateForm_formUpdate_form_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface UpdateForm_formUpdate_form_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateForm_formUpdate_form_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface UpdateForm_formUpdate_form_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface UpdateForm_formUpdate_form_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface UpdateForm_formUpdate_form_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: UpdateForm_formUpdate_form_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: UpdateForm_formUpdate_form_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: UpdateForm_formUpdate_form_createRules_lead_stagesetFieldRules_stageset;
}

export interface UpdateForm_formUpdate_form_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: UpdateForm_formUpdate_form_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: UpdateForm_formUpdate_form_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: UpdateForm_formUpdate_form_createRules_lead_stagesetFieldRules[];
}

export interface UpdateForm_formUpdate_form_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateForm_formUpdate_form_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface UpdateForm_formUpdate_form_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: UpdateForm_formUpdate_form_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: UpdateForm_formUpdate_form_createRules_contact_audiences[];
}

export interface UpdateForm_formUpdate_form_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateForm_formUpdate_form_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: UpdateForm_formUpdate_form_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface UpdateForm_formUpdate_form_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: UpdateForm_formUpdate_form_createRules_lead | null;
  /**
   * The create rules related to a contact
   */
  contact: UpdateForm_formUpdate_form_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: UpdateForm_formUpdate_form_createRules_account | null;
}

export interface UpdateForm_formUpdate_form_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateForm_formUpdate_form_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface UpdateForm_formUpdate_form_publishedVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface UpdateForm_formUpdate_form_publishedVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface UpdateForm_formUpdate_form_publishedVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateForm_formUpdate_form_publishedVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface UpdateForm_formUpdate_form_publishedVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface UpdateForm_formUpdate_form_publishedVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateForm_formUpdate_form_publishedVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type UpdateForm_formUpdate_form_publishedVersion_fields_rules_objectsToAssign = UpdateForm_formUpdate_form_publishedVersion_fields_rules_objectsToAssign_Tag | UpdateForm_formUpdate_form_publishedVersion_fields_rules_objectsToAssign_Audience | UpdateForm_formUpdate_form_publishedVersion_fields_rules_objectsToAssign_Product | UpdateForm_formUpdate_form_publishedVersion_fields_rules_objectsToAssign_Source | UpdateForm_formUpdate_form_publishedVersion_fields_rules_objectsToAssign_Stageset;

export interface UpdateForm_formUpdate_form_publishedVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: UpdateForm_formUpdate_form_publishedVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: UpdateForm_formUpdate_form_publishedVersion_fields_rules_objectsToAssign[];
}

export interface UpdateForm_formUpdate_form_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: UpdateForm_formUpdate_form_publishedVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: UpdateForm_formUpdate_form_publishedVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: UpdateForm_formUpdate_form_publishedVersion_fields_rules[];
}

export interface UpdateForm_formUpdate_form_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: UpdateForm_formUpdate_form_publishedVersion_pages[];
  /**
   * Array of fields associated with this web form version
   */
  fields: UpdateForm_formUpdate_form_publishedVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
}

export interface UpdateForm_formUpdate_form_editableVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface UpdateForm_formUpdate_form_editableVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface UpdateForm_formUpdate_form_editableVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface UpdateForm_formUpdate_form_editableVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateForm_formUpdate_form_editableVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface UpdateForm_formUpdate_form_editableVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface UpdateForm_formUpdate_form_editableVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateForm_formUpdate_form_editableVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type UpdateForm_formUpdate_form_editableVersion_fields_rules_objectsToAssign = UpdateForm_formUpdate_form_editableVersion_fields_rules_objectsToAssign_Tag | UpdateForm_formUpdate_form_editableVersion_fields_rules_objectsToAssign_Audience | UpdateForm_formUpdate_form_editableVersion_fields_rules_objectsToAssign_Product | UpdateForm_formUpdate_form_editableVersion_fields_rules_objectsToAssign_Source | UpdateForm_formUpdate_form_editableVersion_fields_rules_objectsToAssign_Stageset;

export interface UpdateForm_formUpdate_form_editableVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: UpdateForm_formUpdate_form_editableVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: UpdateForm_formUpdate_form_editableVersion_fields_rules_objectsToAssign[];
}

export interface UpdateForm_formUpdate_form_editableVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: UpdateForm_formUpdate_form_editableVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: UpdateForm_formUpdate_form_editableVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: UpdateForm_formUpdate_form_editableVersion_fields_rules[];
}

export interface UpdateForm_formUpdate_form_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of fields associated with this web form version
   */
  fields: UpdateForm_formUpdate_form_editableVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
}

export interface UpdateForm_formUpdate_form_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface UpdateForm_formUpdate_form_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateForm_formUpdate_form_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: UpdateForm_formUpdate_form_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: UpdateForm_formUpdate_form_nextSteps_slackMessage_form;
}

export interface UpdateForm_formUpdate_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface UpdateForm_formUpdate_form_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type UpdateForm_formUpdate_form_nextSteps_nutshellNotification_notifiables = UpdateForm_formUpdate_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias | UpdateForm_formUpdate_form_nextSteps_nutshellNotification_notifiables_User;

export interface UpdateForm_formUpdate_form_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateForm_formUpdate_form_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: UpdateForm_formUpdate_form_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: UpdateForm_formUpdate_form_nextSteps_nutshellNotification_form;
}

export interface UpdateForm_formUpdate_form_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: UpdateForm_formUpdate_form_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: UpdateForm_formUpdate_form_nextSteps_nutshellNotification | null;
}

export interface UpdateForm_formUpdate_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: UpdateForm_formUpdate_form_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: UpdateForm_formUpdate_form_publishedVersion | null;
  /**
   * Whether the form has been embedded
   */
  isLiveForm: boolean;
  /**
   * The published form preview url
   */
  publishedFormPreviewUrl: string;
  /**
   * Publicly viewable link to published form
   */
  sharableViewInBrowserLink: string;
  /**
   * Boolean, true if the editable version has any edits
   */
  hasUnpublishedChanges: boolean;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: UpdateForm_formUpdate_form_editableVersion;
  /**
   * Next step automations for this form
   */
  nextSteps: UpdateForm_formUpdate_form_nextSteps;
  /**
   * The embed snippet for this form
   */
  embedSnippet: string;
  /**
   * The type of form
   */
  type: FormType;
}

export interface UpdateForm_formUpdate {
  __typename: "FormUpdatePayload";
  /**
   * The assigned Nutshell form.
   */
  form: UpdateForm_formUpdate_form | null;
}

export interface UpdateForm {
  /**
   * Updates the editable version of a Nutshell form.
   */
  formUpdate: UpdateForm_formUpdate;
}

export interface UpdateFormVariables {
  input: FormUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetFormLocations
// ====================================================

export interface GetFormLocations_form_locations {
  __typename: "FormLocation";
  /**
   * The url corresponding to this location
   */
  url: string;
  /**
   * The number of submissions from this location
   */
  submissionsCount: number;
  /**
   * The timestamp of the most recent submission from this location
   */
  lastSubmissionDate: any | null;
  /**
   * The ratio of submissions to views for this location
   */
  conversionRate: number;
}

export interface GetFormLocations_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of links where the form is posted
   */
  locations: GetFormLocations_form_locations[];
}

export interface GetFormLocations {
  /**
   * Returns a Nutshell web form by ID or slug.
   */
  form: GetFormLocations_form;
}

export interface GetFormLocationsVariables {
  formId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWebFormStarters
// ====================================================

export interface GetWebFormStarters_webFormStarters {
  __typename: "WebFormStarter";
  /**
   * The id of the form starter
   */
  id: string;
  /**
   * The name of this form starter
   */
  name: string;
  /**
   * The description of this form starter
   */
  description: string | null;
}

export interface GetWebFormStarters {
  /**
   * A list of Nutshell pre-made Forms.
   */
  webFormStarters: GetWebFormStarters_webFormStarters[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetForm
// ====================================================

export interface GetForm_form_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetForm_form_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetForm_form_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface GetForm_form_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface GetForm_form_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetForm_form_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: GetForm_form_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: GetForm_form_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: GetForm_form_createRules_lead_stagesetFieldRules_stageset;
}

export interface GetForm_form_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: GetForm_form_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: GetForm_form_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: GetForm_form_createRules_lead_stagesetFieldRules[];
}

export interface GetForm_form_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetForm_form_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetForm_form_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: GetForm_form_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: GetForm_form_createRules_contact_audiences[];
}

export interface GetForm_form_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetForm_form_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: GetForm_form_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface GetForm_form_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: GetForm_form_createRules_lead | null;
  /**
   * The create rules related to a contact
   */
  contact: GetForm_form_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: GetForm_form_createRules_account | null;
}

export interface GetForm_form_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetForm_form_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface GetForm_form_publishedVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface GetForm_form_publishedVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface GetForm_form_publishedVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetForm_form_publishedVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetForm_form_publishedVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface GetForm_form_publishedVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetForm_form_publishedVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type GetForm_form_publishedVersion_fields_rules_objectsToAssign = GetForm_form_publishedVersion_fields_rules_objectsToAssign_Tag | GetForm_form_publishedVersion_fields_rules_objectsToAssign_Audience | GetForm_form_publishedVersion_fields_rules_objectsToAssign_Product | GetForm_form_publishedVersion_fields_rules_objectsToAssign_Source | GetForm_form_publishedVersion_fields_rules_objectsToAssign_Stageset;

export interface GetForm_form_publishedVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: GetForm_form_publishedVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: GetForm_form_publishedVersion_fields_rules_objectsToAssign[];
}

export interface GetForm_form_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: GetForm_form_publishedVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: GetForm_form_publishedVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: GetForm_form_publishedVersion_fields_rules[];
}

export interface GetForm_form_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: GetForm_form_publishedVersion_pages[];
  /**
   * Array of fields associated with this web form version
   */
  fields: GetForm_form_publishedVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
}

export interface GetForm_form_editableVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface GetForm_form_editableVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface GetForm_form_editableVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface GetForm_form_editableVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetForm_form_editableVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetForm_form_editableVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface GetForm_form_editableVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetForm_form_editableVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type GetForm_form_editableVersion_fields_rules_objectsToAssign = GetForm_form_editableVersion_fields_rules_objectsToAssign_Tag | GetForm_form_editableVersion_fields_rules_objectsToAssign_Audience | GetForm_form_editableVersion_fields_rules_objectsToAssign_Product | GetForm_form_editableVersion_fields_rules_objectsToAssign_Source | GetForm_form_editableVersion_fields_rules_objectsToAssign_Stageset;

export interface GetForm_form_editableVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: GetForm_form_editableVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: GetForm_form_editableVersion_fields_rules_objectsToAssign[];
}

export interface GetForm_form_editableVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: GetForm_form_editableVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: GetForm_form_editableVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: GetForm_form_editableVersion_fields_rules[];
}

export interface GetForm_form_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of fields associated with this web form version
   */
  fields: GetForm_form_editableVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
}

export interface GetForm_form_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface GetForm_form_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetForm_form_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: GetForm_form_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: GetForm_form_nextSteps_slackMessage_form;
}

export interface GetForm_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface GetForm_form_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type GetForm_form_nextSteps_nutshellNotification_notifiables = GetForm_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias | GetForm_form_nextSteps_nutshellNotification_notifiables_User;

export interface GetForm_form_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetForm_form_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: GetForm_form_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: GetForm_form_nextSteps_nutshellNotification_form;
}

export interface GetForm_form_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: GetForm_form_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: GetForm_form_nextSteps_nutshellNotification | null;
}

export interface GetForm_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: GetForm_form_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: GetForm_form_publishedVersion | null;
  /**
   * Whether the form has been embedded
   */
  isLiveForm: boolean;
  /**
   * The published form preview url
   */
  publishedFormPreviewUrl: string;
  /**
   * Publicly viewable link to published form
   */
  sharableViewInBrowserLink: string;
  /**
   * Boolean, true if the editable version has any edits
   */
  hasUnpublishedChanges: boolean;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: GetForm_form_editableVersion;
  /**
   * Next step automations for this form
   */
  nextSteps: GetForm_form_nextSteps;
  /**
   * The embed snippet for this form
   */
  embedSnippet: string;
  /**
   * The type of form
   */
  type: FormType;
}

export interface GetForm {
  /**
   * Returns a Nutshell web form by ID or slug.
   */
  form: GetForm_form;
}

export interface GetFormVariables {
  formId?: string | null;
  formSlug?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetForms
// ====================================================

export interface GetForms_forms_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetForms_forms_edges_node_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetForms_forms_edges_node_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: GetForms_forms_edges_node_createRules_lead_stageset | null;
}

export interface GetForms_forms_edges_node_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: GetForms_forms_edges_node_createRules_lead | null;
}

export interface GetForms_forms_edges_node_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetForms_forms_edges_node_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: GetForms_forms_edges_node_publishedVersion_pages[];
}

export interface GetForms_forms_edges_node {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: GetForms_forms_edges_node_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: GetForms_forms_edges_node_publishedVersion | null;
}

export interface GetForms_forms_edges {
  __typename: "FormsEdge";
  cursor: string;
  node: GetForms_forms_edges_node;
}

export interface GetForms_forms {
  __typename: "FormsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetForms_forms_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetForms_forms_edges[];
}

export interface GetForms {
  /**
   * Returns a connection of Nutshell Web Forms
   */
  forms: GetForms_forms;
}

export interface GetFormsVariables {
  limit: number;
  after?: string | null;
  archived: boolean;
  sort: FormSortType;
  search?: string | null;
  creatorUserId?: string | null;
  lastUpdatedTime?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: GenerateRecommendations
// ====================================================

export interface GenerateRecommendations_recommendationsGenerate_chatSettings_intakeForm {
  __typename: "ChatSettingsIntakeForm";
  fields: ChatSettingsIntakeFormFieldsEnum[];
  message: string;
  type: ChatSettingsIntakeFormTypeEnum;
  /**
   * Whether to create a lead if no other rules trigger a lead creation
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID to create the lead in
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * Allow chat threads to proceed without requiring a contact to be created
   */
  allowThreadsWithoutContact: boolean;
}

export interface GenerateRecommendations_recommendationsGenerate_chatSettings_lookAndFeel_nudgeSettings {
  __typename: "ChatSettingsNudge";
  /**
   * Is the nudge behavior enabled
   */
  isEnabled: boolean;
  /**
   * The nudge overlay text
   */
  message: string;
  /**
   * The call to action text
   */
  callToAction: string;
  /**
   * When to show nudges (desktop only or always)
   */
  deviceVisibility: NudgeDeviceVisibilityEnum;
}

export interface GenerateRecommendations_recommendationsGenerate_chatSettings_lookAndFeel_icon {
  __typename: "ChatIcon";
  /**
   * Icon type
   */
  type: ChatIconEnum;
  /**
   * Icon URL
   */
  url: string | null;
}

export interface GenerateRecommendations_recommendationsGenerate_chatSettings_lookAndFeel_disclaimerSettings {
  __typename: "ChatSettingsDisclaimer";
  /**
   * Is the disclaimer enabled
   */
  isEnabled: boolean;
  /**
   * The disclaimer message
   */
  message: string;
}

export interface GenerateRecommendations_recommendationsGenerate_chatSettings_lookAndFeel {
  __typename: "LookAndFeel";
  /**
   * The primary color of the chat window
   */
  color: string;
  /**
   * The secondary color for chat
   */
  secondaryColor: string;
  /**
   * The position of the chat window
   */
  nameDisplay: string;
  /**
   * The nudge settings
   */
  nudgeSettings: GenerateRecommendations_recommendationsGenerate_chatSettings_lookAndFeel_nudgeSettings;
  /**
   * The chat icon settings
   */
  icon: GenerateRecommendations_recommendationsGenerate_chatSettings_lookAndFeel_icon;
  /**
   * The intro message a visitor sees when they open the chat
   */
  conversationStarter: string;
  /**
   * Whether to show the powered by Nutshell logo
   */
  showPoweredBy: boolean;
  /**
   * The disclaimer settings
   */
  disclaimerSettings: GenerateRecommendations_recommendationsGenerate_chatSettings_lookAndFeel_disclaimerSettings;
  /**
   * The actions that are shown in the engagement bar
   */
  actionBarShownActions: ActionBarActionEnum[];
  /**
   * The actions that are hidden in the engagement bar
   */
  actionBarHiddenActions: ActionBarActionEnum[];
  /**
   * The chat variant (chat button only or actions bar)
   */
  chatVariant: ChatVariantEnum;
  /**
   * The name of the chatbot
   */
  chatbotName: string;
  /**
   * The icon type for the chatbot
   */
  chatbotIconEnum: ChatbotIconEnum;
  /**
   * The paths that are disabled for the chat widget
   */
  disabledPaths: string[];
}

export interface GenerateRecommendations_recommendationsGenerate_chatSettings_offline_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
}

export interface GenerateRecommendations_recommendationsGenerate_chatSettings_offline {
  __typename: "ChatSettingsOffline";
  /**
   * Offline form capture enabled
   */
  isEnabled: boolean;
  /**
   * The offline custom form
   */
  form: GenerateRecommendations_recommendationsGenerate_chatSettings_offline_form;
  formType: ChatSettingsOfflineFormTypeEnum;
  /**
   * The message to show if there are no agents online
   */
  message: string;
  /**
   * The message to show if there are no agents online for conversational forms
   */
  conversationalMessage: string;
}

export interface GenerateRecommendations_recommendationsGenerate_chatSettings_assignment_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GenerateRecommendations_recommendationsGenerate_chatSettings_assignment {
  __typename: "ChatSettingsAssignment";
  /**
   * The assignment strategy for new chats
   */
  strategy: ChatAssignmentStrategyEnum;
  /**
   * The user to assign new chats to (only applicable if assignmentStrategy is SPECIFIC_USER)
   */
  user: GenerateRecommendations_recommendationsGenerate_chatSettings_assignment_user | null;
}

export interface GenerateRecommendations_recommendationsGenerate_chatSettings_chatbot {
  __typename: "Chatbot";
  /**
   * When the chatbot should respond to messages
   */
  responseTiming: ChatbotResponseTimingEnum;
  /**
   * The name of the chatbot
   */
  name: string;
  /**
   * The icon type for the chatbot
   */
  iconEnum: ChatbotIconEnum;
  /**
   * The tone of the chatbot responses
   */
  tone: ChatbotToneEnum;
  /**
   * The preferred length of chatbot responses
   */
  answerLength: ChatbotAnswerLengthEnum;
  /**
   * Style and behavior suggestions for the chatbot
   */
  suggestions: (string | null)[];
  /**
   * Topics the chatbot should avoid discussing
   */
  topicsToAvoid: (string | null)[];
}

export interface GenerateRecommendations_recommendationsGenerate_chatSettings_goals {
  __typename: "Goals";
  /**
   * Whether the scheduler goal is enabled
   */
  schedulerIsEnabled: boolean;
  /**
   * The scheduler meeting ID to show in the chat
   */
  schedulerMeetingId: string | null;
  /**
   * Whether the form goal is enabled
   */
  formIsEnabled: boolean;
  /**
   * The form slug to show in the chat
   */
  formSlug: string | null;
}

export interface GenerateRecommendations_recommendationsGenerate_chatSettings {
  __typename: "ChatSettings";
  /**
   * Is the chat widget enabled
   */
  isChatEnabled: boolean;
  /**
   * The chat intake form settings
   */
  intakeForm: GenerateRecommendations_recommendationsGenerate_chatSettings_intakeForm;
  /**
   * The chat look and feel settings
   */
  lookAndFeel: GenerateRecommendations_recommendationsGenerate_chatSettings_lookAndFeel;
  /**
   * The chat offline settings
   */
  offline: GenerateRecommendations_recommendationsGenerate_chatSettings_offline;
  /**
   * The chat assignment settings
   */
  assignment: GenerateRecommendations_recommendationsGenerate_chatSettings_assignment;
  /**
   * The embeddable script to add chat on a website
   */
  embedScript: string;
  /**
   * The chatbot settings
   */
  chatbot: GenerateRecommendations_recommendationsGenerate_chatSettings_chatbot;
  /**
   * The goals settings
   */
  goals: GenerateRecommendations_recommendationsGenerate_chatSettings_goals;
}

export interface GenerateRecommendations_recommendationsGenerate {
  __typename: "RecommendationsGeneratePayload";
  chatSettings: GenerateRecommendations_recommendationsGenerate_chatSettings | null;
}

export interface GenerateRecommendations {
  /**
   * Generates and adds recommendations to the chatbot suggestions or topics to avoid
   */
  recommendationsGenerate: GenerateRecommendations_recommendationsGenerate;
}

export interface GenerateRecommendationsVariables {
  input: RecommendationsGenerateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: PreviewChatbotResponse
// ====================================================

export interface PreviewChatbotResponse_previewChatbotResponse_citations {
  __typename: "PreviewChatbotCitation";
  documentId: string;
  url: string;
  title: string;
  sourceType: DocumentSourceTypeEnum;
}

export interface PreviewChatbotResponse_previewChatbotResponse {
  __typename: "PreviewChatbotResponsePayload";
  answer: string;
  citations: PreviewChatbotResponse_previewChatbotResponse_citations[];
  promptTokens: number;
  completionTokens: number;
  /**
   * True when the returned answer text matches an enabled custom answer verbatim.
   */
  usedCustomAnswer: boolean;
  /**
   * The custom answer question that matched, when usedCustomAnswer is true.
   */
  matchedCustomAnswerQuestion: string | null;
}

export interface PreviewChatbotResponse {
  /**
   * Generates a one-off chatbot answer for an admin-supplied question without persisting anything to thread or chat history.
   */
  previewChatbotResponse: PreviewChatbotResponse_previewChatbotResponse;
}

export interface PreviewChatbotResponseVariables {
  input: PreviewChatbotResponseInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RecrawlContextDocuments
// ====================================================

export interface RecrawlContextDocuments_contextDocumentRecrawl_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
}

export interface RecrawlContextDocuments_contextDocumentRecrawl_aiSuggestions {
  __typename: "AiSuggestion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The content of the AI suggestion
   */
  content: string;
}

export interface RecrawlContextDocuments_contextDocumentRecrawl {
  __typename: "ContextDocument";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the context document, for example, the name of the uploaded file
   */
  name: string | null;
  /**
   * The URL of the context document
   */
  url: RecrawlContextDocuments_contextDocumentRecrawl_url | null;
  /**
   * The content of the context document
   */
  content: string | null;
  /**
   * The summary of the context document
   */
  summary: string | null;
  /**
   * Whether the context document is included
   */
  isIncluded: boolean;
  isHidden: boolean;
  /**
   * The effective status of the context document
   */
  effectiveStatus: DocumentEffectiveStatusEnum;
  /**
   * The number of words in the context document
   */
  wordCount: number;
  /**
   * Whether the context document is a subpage
   */
  isSubpage: boolean;
  /**
   * The source type of the context document
   */
  sourceType: DocumentSourceTypeEnum;
  /**
   * The time the context document was last crawled
   */
  lastCrawledTime: any;
  /**
   * The AI suggestions for the context document
   */
  aiSuggestions: RecrawlContextDocuments_contextDocumentRecrawl_aiSuggestions[];
}

export interface RecrawlContextDocuments {
  /**
   * Recrawls context documents (either all or a specific one). As of now, we can only recrawl webpages and not pdfs.
   */
  contextDocumentRecrawl: (RecrawlContextDocuments_contextDocumentRecrawl | null)[] | null;
}

export interface RecrawlContextDocumentsVariables {
  input: ContextDocumentRecrawlInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveContextDocument
// ====================================================

export interface RemoveContextDocument_contextDocumentRemove {
  __typename: "ContextDocument";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface RemoveContextDocument {
  /**
   * Removes a context document
   */
  contextDocumentRemove: RemoveContextDocument_contextDocumentRemove | null;
}

export interface RemoveContextDocumentVariables {
  input: ContextDocumentRemoveInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ToggleContextDocumentUsage
// ====================================================

export interface ToggleContextDocumentUsage_contextDocumentUsageToggle {
  __typename: "ContextDocument";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether the context document is included
   */
  isIncluded: boolean;
  isHidden: boolean;
  /**
   * The effective status of the context document
   */
  effectiveStatus: DocumentEffectiveStatusEnum;
}

export interface ToggleContextDocumentUsage {
  /**
   * Toggles whether the document is being used for the chatbot context
   */
  contextDocumentUsageToggle: ToggleContextDocumentUsage_contextDocumentUsageToggle | null;
}

export interface ToggleContextDocumentUsageVariables {
  input: ContextDocumentUsageToggleInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: PagesCrawlTrigger
// ====================================================

export interface PagesCrawlTrigger_pagesCrawlTrigger_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
}

export interface PagesCrawlTrigger_pagesCrawlTrigger_aiSuggestions {
  __typename: "AiSuggestion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The content of the AI suggestion
   */
  content: string;
}

export interface PagesCrawlTrigger_pagesCrawlTrigger {
  __typename: "ContextDocument";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the context document, for example, the name of the uploaded file
   */
  name: string | null;
  /**
   * The URL of the context document
   */
  url: PagesCrawlTrigger_pagesCrawlTrigger_url | null;
  /**
   * The content of the context document
   */
  content: string | null;
  /**
   * The summary of the context document
   */
  summary: string | null;
  /**
   * Whether the context document is included
   */
  isIncluded: boolean;
  isHidden: boolean;
  /**
   * The effective status of the context document
   */
  effectiveStatus: DocumentEffectiveStatusEnum;
  /**
   * The number of words in the context document
   */
  wordCount: number;
  /**
   * Whether the context document is a subpage
   */
  isSubpage: boolean;
  /**
   * The source type of the context document
   */
  sourceType: DocumentSourceTypeEnum;
  /**
   * The time the context document was last crawled
   */
  lastCrawledTime: any;
  /**
   * The AI suggestions for the context document
   */
  aiSuggestions: PagesCrawlTrigger_pagesCrawlTrigger_aiSuggestions[];
}

export interface PagesCrawlTrigger {
  /**
   * Trigger crawling pages
   */
  pagesCrawlTrigger: (PagesCrawlTrigger_pagesCrawlTrigger | null)[] | null;
}

export interface PagesCrawlTriggerVariables {
  input: PagesCrawlTriggerInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateAgentStatus
// ====================================================

export interface UpdateAgentStatus_chatAgentStatusUpdate {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  agentStatus: AgentStatusEnum;
}

export interface UpdateAgentStatus {
  /**
   * Update chat agent status
   */
  chatAgentStatusUpdate: UpdateAgentStatus_chatAgentStatusUpdate;
}

export interface UpdateAgentStatusVariables {
  input: AgentStatusUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateChatBusinessCardLogo
// ====================================================

export interface UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_lookAndFeel_nudgeSettings {
  __typename: "ChatSettingsNudge";
  /**
   * Is the nudge behavior enabled
   */
  isEnabled: boolean;
  /**
   * The nudge overlay text
   */
  message: string;
  /**
   * When to show nudges (desktop only or always)
   */
  deviceVisibility: NudgeDeviceVisibilityEnum;
  /**
   * The call to action text
   */
  callToAction: string;
}

export interface UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_lookAndFeel_icon {
  __typename: "ChatIcon";
  /**
   * Icon type
   */
  type: ChatIconEnum;
  /**
   * Icon URL
   */
  url: string | null;
}

export interface UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_lookAndFeel_disclaimerSettings {
  __typename: "ChatSettingsDisclaimer";
  /**
   * Is the disclaimer enabled
   */
  isEnabled: boolean;
  /**
   * The disclaimer message
   */
  message: string;
}

export interface UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_lookAndFeel {
  __typename: "LookAndFeel";
  /**
   * The primary color of the chat window
   */
  color: string;
  /**
   * The secondary color for chat
   */
  secondaryColor: string;
  /**
   * The position of the chat window
   */
  nameDisplay: string;
  /**
   * The chat variant (chat button only or actions bar)
   */
  chatVariant: ChatVariantEnum;
  /**
   * The actions that are shown in the engagement bar
   */
  actionBarShownActions: ActionBarActionEnum[];
  /**
   * The nudge settings
   */
  nudgeSettings: UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_lookAndFeel_nudgeSettings;
  /**
   * The chat icon settings
   */
  icon: UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_lookAndFeel_icon;
  /**
   * The intro message a visitor sees when they open the chat
   */
  conversationStarter: string;
  /**
   * Whether to show the powered by Nutshell logo
   */
  showPoweredBy: boolean;
  /**
   * The disclaimer settings
   */
  disclaimerSettings: UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_lookAndFeel_disclaimerSettings;
}

export interface UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_intakeForm {
  __typename: "ChatSettingsIntakeForm";
  fields: ChatSettingsIntakeFormFieldsEnum[];
  type: ChatSettingsIntakeFormTypeEnum;
  /**
   * Allow chat threads to proceed without requiring a contact to be created
   */
  allowThreadsWithoutContact: boolean;
}

export interface UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_actions_chat {
  __typename: "ChatAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * Whether to automatically create leads from chat conversations
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
}

export interface UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_actions_booking {
  __typename: "BookingAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The meeting ID to use for booking
   */
  meetingId: string | null;
  /**
   * The confirmation message after booking a meeting
   */
  formConfirmationMessage: string;
  /**
   * Whether to automatically create leads from booking requests
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
}

export interface UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_actions_email {
  __typename: "EmailAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The slug for the form to display for email action
   */
  formSlug: string | null;
  /**
   * The slug for the default form that was auto-created for this action
   */
  defaultFormSlug: string | null;
  /**
   * The confirmation message after submitting a form
   */
  formConfirmationMessage: string;
  /**
   * Whether to automatically create leads from email requests
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * Whether to link an email address
   */
  shouldLinkEmailAddress: boolean;
  /**
   * The email address to link
   */
  linkEmailAddress: string | null;
}

export interface UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_actions_call_linkNumberConfig {
  __typename: "LinkNumberConfig";
  /**
   * The type of phone number that is linked (custom or call tracker fx)
   */
  type: LinkNumberTypeEnum;
  /**
   * The custom phone number to link
   */
  customNumber: string | null;
  /**
   * The phone number to link
   */
  callTrackerNumber: string | null;
  /**
   * The call tracker id
   */
  callTrackerId: string | null;
}

export interface UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_actions_call {
  __typename: "CallAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The slug for the form to display for call action
   */
  formSlug: string | null;
  /**
   * The slug for the default form that was auto-created for this action
   */
  defaultFormSlug: string | null;
  /**
   * The confirmation message after submitting a form
   */
  formConfirmationMessage: string;
  /**
   * Whether to automatically create leads from call requests
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * Whether to link a phone number
   */
  shouldLinkNumber: boolean;
  /**
   * The configuration for the linked phone number
   */
  linkNumberConfig: UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_actions_call_linkNumberConfig;
}

export interface UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_actions_text {
  __typename: "TextAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The slug for the form to display for text action
   */
  formSlug: string | null;
  /**
   * The slug for the default form that was auto-created for this action
   */
  defaultFormSlug: string | null;
  /**
   * The confirmation message after submitting a form
   */
  formConfirmationMessage: string;
  /**
   * Whether to automatically create leads from text requests
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * Whether to link a phone number
   */
  shouldLinkNumber: boolean;
  /**
   * The phone number to link
   */
  linkNumber: string | null;
}

export interface UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_actions_quote {
  __typename: "QuoteAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * Whether to automatically create leads after submitting a quote form
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The slug for the form to display for quote action
   */
  formSlug: string | null;
  /**
   * The slug for the default form that was auto-created for this action
   */
  defaultFormSlug: string | null;
  /**
   * The confirmation message after submitting a form
   */
  formConfirmationMessage: string;
}

export interface UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_actions {
  __typename: "Actions";
  /**
   * Chat action configuration
   */
  chat: UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_actions_chat;
  /**
   * Booking action configuration
   */
  booking: UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_actions_booking;
  /**
   * Email action configuration
   */
  email: UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_actions_email;
  /**
   * Call action configuration
   */
  call: UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_actions_call;
  /**
   * Text action configuration
   */
  text: UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_actions_text;
  /**
   * Quote action configuration
   */
  quote: UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_actions_quote;
}

export interface UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_appMode_homepageSettings_actionLabels {
  __typename: "ChatSettingsHomepageActionLabels";
  /**
   * The label for the book action
   */
  book: string;
  /**
   * The label for the email action
   */
  email: string;
  /**
   * The label for the call action
   */
  call: string;
  /**
   * The label for the text action
   */
  text: string;
  /**
   * The label for the quote action
   */
  quote: string;
}

export interface UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_appMode_homepageSettings {
  __typename: "ChatSettingsHomepage";
  /**
   * Whether the homepage is enabled
   */
  isEnabled: boolean;
  /**
   * The layout of the homepage
   */
  layout: ChatHomepageLayoutEnum;
  /**
   * Per-action labels displayed on the homepage
   */
  actionLabels: UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_appMode_homepageSettings_actionLabels;
}

export interface UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_appMode_businessCardSettings {
  __typename: "ChatSettingsBusinessCard";
  /**
   * Whether the business card is enabled
   */
  isEnabled: boolean;
  /**
   * The logo URL
   */
  logoUrl: string | null;
  /**
   * The company name
   */
  companyName: string | null;
  /**
   * The email
   */
  email: string | null;
  /**
   * The phone number
   */
  phoneNumber: string | null;
  /**
   * The address
   */
  address: string | null;
  /**
   * The business hours description
   */
  businessHours: string | null;
}

export interface UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_appMode {
  __typename: "AppMode";
  /**
   * The homepage settings
   */
  homepageSettings: UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_appMode_homepageSettings;
  /**
   * The business card settings
   */
  businessCardSettings: UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_appMode_businessCardSettings;
}

export interface UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate {
  __typename: "ChatSettings";
  /**
   * The chat look and feel settings
   */
  lookAndFeel: UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_lookAndFeel;
  /**
   * The chat intake form settings
   */
  intakeForm: UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_intakeForm;
  /**
   * The actions settings
   */
  actions: UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_actions;
  /**
   * The app mode settings
   */
  appMode: UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate_appMode;
}

export interface UpdateChatBusinessCardLogo {
  /**
   * Updates the business card logo for the chat widget
   */
  chatBusinessCardLogoUpdate: UpdateChatBusinessCardLogo_chatBusinessCardLogoUpdate;
}

export interface UpdateChatBusinessCardLogoVariables {
  input: ChatBusinessCardLogoUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateChatSettingsEnableChat
// ====================================================

export interface UpdateChatSettingsEnableChat_chatSettingsEnableChat {
  __typename: "ChatSettingsEnableChatPayload";
  /**
   * Whether the chat box is enabled
   */
  isChatEnabled: boolean;
}

export interface UpdateChatSettingsEnableChat {
  /**
   * Updates whether the chat box is enabled on customer's site
   */
  chatSettingsEnableChat: UpdateChatSettingsEnableChat_chatSettingsEnableChat | null;
}

export interface UpdateChatSettingsEnableChatVariables {
  input: ChatSettingsEnableChatInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateChatSettings
// ====================================================

export interface UpdateChatSettings_chatSettingsUpdate_intakeForm {
  __typename: "ChatSettingsIntakeForm";
  fields: ChatSettingsIntakeFormFieldsEnum[];
  message: string;
  type: ChatSettingsIntakeFormTypeEnum;
  /**
   * Whether to create a lead if no other rules trigger a lead creation
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID to create the lead in
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * Allow chat threads to proceed without requiring a contact to be created
   */
  allowThreadsWithoutContact: boolean;
}

export interface UpdateChatSettings_chatSettingsUpdate_lookAndFeel_nudgeSettings {
  __typename: "ChatSettingsNudge";
  /**
   * Is the nudge behavior enabled
   */
  isEnabled: boolean;
  /**
   * The nudge overlay text
   */
  message: string;
  /**
   * The call to action text
   */
  callToAction: string;
  /**
   * When to show nudges (desktop only or always)
   */
  deviceVisibility: NudgeDeviceVisibilityEnum;
}

export interface UpdateChatSettings_chatSettingsUpdate_lookAndFeel_icon {
  __typename: "ChatIcon";
  /**
   * Icon type
   */
  type: ChatIconEnum;
  /**
   * Icon URL
   */
  url: string | null;
}

export interface UpdateChatSettings_chatSettingsUpdate_lookAndFeel_disclaimerSettings {
  __typename: "ChatSettingsDisclaimer";
  /**
   * Is the disclaimer enabled
   */
  isEnabled: boolean;
  /**
   * The disclaimer message
   */
  message: string;
}

export interface UpdateChatSettings_chatSettingsUpdate_lookAndFeel {
  __typename: "LookAndFeel";
  /**
   * The primary color of the chat window
   */
  color: string;
  /**
   * The secondary color for chat
   */
  secondaryColor: string;
  /**
   * The position of the chat window
   */
  nameDisplay: string;
  /**
   * The nudge settings
   */
  nudgeSettings: UpdateChatSettings_chatSettingsUpdate_lookAndFeel_nudgeSettings;
  /**
   * The chat icon settings
   */
  icon: UpdateChatSettings_chatSettingsUpdate_lookAndFeel_icon;
  /**
   * The intro message a visitor sees when they open the chat
   */
  conversationStarter: string;
  /**
   * Whether to show the powered by Nutshell logo
   */
  showPoweredBy: boolean;
  /**
   * The disclaimer settings
   */
  disclaimerSettings: UpdateChatSettings_chatSettingsUpdate_lookAndFeel_disclaimerSettings;
  /**
   * The actions that are shown in the engagement bar
   */
  actionBarShownActions: ActionBarActionEnum[];
  /**
   * The actions that are hidden in the engagement bar
   */
  actionBarHiddenActions: ActionBarActionEnum[];
  /**
   * The chat variant (chat button only or actions bar)
   */
  chatVariant: ChatVariantEnum;
  /**
   * The name of the chatbot
   */
  chatbotName: string;
  /**
   * The icon type for the chatbot
   */
  chatbotIconEnum: ChatbotIconEnum;
  /**
   * The paths that are disabled for the chat widget
   */
  disabledPaths: string[];
}

export interface UpdateChatSettings_chatSettingsUpdate_offline_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
}

export interface UpdateChatSettings_chatSettingsUpdate_offline {
  __typename: "ChatSettingsOffline";
  /**
   * Offline form capture enabled
   */
  isEnabled: boolean;
  /**
   * The offline custom form
   */
  form: UpdateChatSettings_chatSettingsUpdate_offline_form;
  formType: ChatSettingsOfflineFormTypeEnum;
  /**
   * The message to show if there are no agents online
   */
  message: string;
  /**
   * The message to show if there are no agents online for conversational forms
   */
  conversationalMessage: string;
}

export interface UpdateChatSettings_chatSettingsUpdate_assignment_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateChatSettings_chatSettingsUpdate_assignment {
  __typename: "ChatSettingsAssignment";
  /**
   * The assignment strategy for new chats
   */
  strategy: ChatAssignmentStrategyEnum;
  /**
   * The user to assign new chats to (only applicable if assignmentStrategy is SPECIFIC_USER)
   */
  user: UpdateChatSettings_chatSettingsUpdate_assignment_user | null;
}

export interface UpdateChatSettings_chatSettingsUpdate_chatbot {
  __typename: "Chatbot";
  /**
   * When the chatbot should respond to messages
   */
  responseTiming: ChatbotResponseTimingEnum;
  /**
   * The name of the chatbot
   */
  name: string;
  /**
   * The icon type for the chatbot
   */
  iconEnum: ChatbotIconEnum;
  /**
   * The tone of the chatbot responses
   */
  tone: ChatbotToneEnum;
  /**
   * The preferred length of chatbot responses
   */
  answerLength: ChatbotAnswerLengthEnum;
  /**
   * Style and behavior suggestions for the chatbot
   */
  suggestions: (string | null)[];
  /**
   * Topics the chatbot should avoid discussing
   */
  topicsToAvoid: (string | null)[];
}

export interface UpdateChatSettings_chatSettingsUpdate_goals {
  __typename: "Goals";
  /**
   * Whether the scheduler goal is enabled
   */
  schedulerIsEnabled: boolean;
  /**
   * The scheduler meeting ID to show in the chat
   */
  schedulerMeetingId: string | null;
  /**
   * Whether the form goal is enabled
   */
  formIsEnabled: boolean;
  /**
   * The form slug to show in the chat
   */
  formSlug: string | null;
}

export interface UpdateChatSettings_chatSettingsUpdate {
  __typename: "ChatSettings";
  /**
   * Is the chat widget enabled
   */
  isChatEnabled: boolean;
  /**
   * The chat intake form settings
   */
  intakeForm: UpdateChatSettings_chatSettingsUpdate_intakeForm;
  /**
   * The chat look and feel settings
   */
  lookAndFeel: UpdateChatSettings_chatSettingsUpdate_lookAndFeel;
  /**
   * The chat offline settings
   */
  offline: UpdateChatSettings_chatSettingsUpdate_offline;
  /**
   * The chat assignment settings
   */
  assignment: UpdateChatSettings_chatSettingsUpdate_assignment;
  /**
   * The embeddable script to add chat on a website
   */
  embedScript: string;
  /**
   * The chatbot settings
   */
  chatbot: UpdateChatSettings_chatSettingsUpdate_chatbot;
  /**
   * The goals settings
   */
  goals: UpdateChatSettings_chatSettingsUpdate_goals;
}

export interface UpdateChatSettings {
  /**
   * Saves Chat Settings
   */
  chatSettingsUpdate: UpdateChatSettings_chatSettingsUpdate;
}

export interface UpdateChatSettingsVariables {
  input: ChatSettingsUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateChatWidgetIcon
// ====================================================

export interface UpdateChatWidgetIcon_chatWidgetIconUpdate_intakeForm {
  __typename: "ChatSettingsIntakeForm";
  fields: ChatSettingsIntakeFormFieldsEnum[];
  message: string;
  type: ChatSettingsIntakeFormTypeEnum;
  /**
   * Whether to create a lead if no other rules trigger a lead creation
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID to create the lead in
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * Allow chat threads to proceed without requiring a contact to be created
   */
  allowThreadsWithoutContact: boolean;
}

export interface UpdateChatWidgetIcon_chatWidgetIconUpdate_lookAndFeel_nudgeSettings {
  __typename: "ChatSettingsNudge";
  /**
   * Is the nudge behavior enabled
   */
  isEnabled: boolean;
  /**
   * The nudge overlay text
   */
  message: string;
  /**
   * The call to action text
   */
  callToAction: string;
  /**
   * When to show nudges (desktop only or always)
   */
  deviceVisibility: NudgeDeviceVisibilityEnum;
}

export interface UpdateChatWidgetIcon_chatWidgetIconUpdate_lookAndFeel_icon {
  __typename: "ChatIcon";
  /**
   * Icon type
   */
  type: ChatIconEnum;
  /**
   * Icon URL
   */
  url: string | null;
}

export interface UpdateChatWidgetIcon_chatWidgetIconUpdate_lookAndFeel_disclaimerSettings {
  __typename: "ChatSettingsDisclaimer";
  /**
   * Is the disclaimer enabled
   */
  isEnabled: boolean;
  /**
   * The disclaimer message
   */
  message: string;
}

export interface UpdateChatWidgetIcon_chatWidgetIconUpdate_lookAndFeel {
  __typename: "LookAndFeel";
  /**
   * The primary color of the chat window
   */
  color: string;
  /**
   * The secondary color for chat
   */
  secondaryColor: string;
  /**
   * The position of the chat window
   */
  nameDisplay: string;
  /**
   * The nudge settings
   */
  nudgeSettings: UpdateChatWidgetIcon_chatWidgetIconUpdate_lookAndFeel_nudgeSettings;
  /**
   * The chat icon settings
   */
  icon: UpdateChatWidgetIcon_chatWidgetIconUpdate_lookAndFeel_icon;
  /**
   * The intro message a visitor sees when they open the chat
   */
  conversationStarter: string;
  /**
   * Whether to show the powered by Nutshell logo
   */
  showPoweredBy: boolean;
  /**
   * The disclaimer settings
   */
  disclaimerSettings: UpdateChatWidgetIcon_chatWidgetIconUpdate_lookAndFeel_disclaimerSettings;
  /**
   * The actions that are shown in the engagement bar
   */
  actionBarShownActions: ActionBarActionEnum[];
  /**
   * The actions that are hidden in the engagement bar
   */
  actionBarHiddenActions: ActionBarActionEnum[];
  /**
   * The chat variant (chat button only or actions bar)
   */
  chatVariant: ChatVariantEnum;
  /**
   * The name of the chatbot
   */
  chatbotName: string;
  /**
   * The icon type for the chatbot
   */
  chatbotIconEnum: ChatbotIconEnum;
  /**
   * The paths that are disabled for the chat widget
   */
  disabledPaths: string[];
}

export interface UpdateChatWidgetIcon_chatWidgetIconUpdate_offline_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
}

export interface UpdateChatWidgetIcon_chatWidgetIconUpdate_offline {
  __typename: "ChatSettingsOffline";
  /**
   * Offline form capture enabled
   */
  isEnabled: boolean;
  /**
   * The offline custom form
   */
  form: UpdateChatWidgetIcon_chatWidgetIconUpdate_offline_form;
  formType: ChatSettingsOfflineFormTypeEnum;
  /**
   * The message to show if there are no agents online
   */
  message: string;
  /**
   * The message to show if there are no agents online for conversational forms
   */
  conversationalMessage: string;
}

export interface UpdateChatWidgetIcon_chatWidgetIconUpdate_assignment_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateChatWidgetIcon_chatWidgetIconUpdate_assignment {
  __typename: "ChatSettingsAssignment";
  /**
   * The assignment strategy for new chats
   */
  strategy: ChatAssignmentStrategyEnum;
  /**
   * The user to assign new chats to (only applicable if assignmentStrategy is SPECIFIC_USER)
   */
  user: UpdateChatWidgetIcon_chatWidgetIconUpdate_assignment_user | null;
}

export interface UpdateChatWidgetIcon_chatWidgetIconUpdate_chatbot {
  __typename: "Chatbot";
  /**
   * When the chatbot should respond to messages
   */
  responseTiming: ChatbotResponseTimingEnum;
  /**
   * The name of the chatbot
   */
  name: string;
  /**
   * The icon type for the chatbot
   */
  iconEnum: ChatbotIconEnum;
  /**
   * The tone of the chatbot responses
   */
  tone: ChatbotToneEnum;
  /**
   * The preferred length of chatbot responses
   */
  answerLength: ChatbotAnswerLengthEnum;
  /**
   * Style and behavior suggestions for the chatbot
   */
  suggestions: (string | null)[];
  /**
   * Topics the chatbot should avoid discussing
   */
  topicsToAvoid: (string | null)[];
}

export interface UpdateChatWidgetIcon_chatWidgetIconUpdate_goals {
  __typename: "Goals";
  /**
   * Whether the scheduler goal is enabled
   */
  schedulerIsEnabled: boolean;
  /**
   * The scheduler meeting ID to show in the chat
   */
  schedulerMeetingId: string | null;
  /**
   * Whether the form goal is enabled
   */
  formIsEnabled: boolean;
  /**
   * The form slug to show in the chat
   */
  formSlug: string | null;
}

export interface UpdateChatWidgetIcon_chatWidgetIconUpdate {
  __typename: "ChatSettings";
  /**
   * Is the chat widget enabled
   */
  isChatEnabled: boolean;
  /**
   * The chat intake form settings
   */
  intakeForm: UpdateChatWidgetIcon_chatWidgetIconUpdate_intakeForm;
  /**
   * The chat look and feel settings
   */
  lookAndFeel: UpdateChatWidgetIcon_chatWidgetIconUpdate_lookAndFeel;
  /**
   * The chat offline settings
   */
  offline: UpdateChatWidgetIcon_chatWidgetIconUpdate_offline;
  /**
   * The chat assignment settings
   */
  assignment: UpdateChatWidgetIcon_chatWidgetIconUpdate_assignment;
  /**
   * The embeddable script to add chat on a website
   */
  embedScript: string;
  /**
   * The chatbot settings
   */
  chatbot: UpdateChatWidgetIcon_chatWidgetIconUpdate_chatbot;
  /**
   * The goals settings
   */
  goals: UpdateChatWidgetIcon_chatWidgetIconUpdate_goals;
}

export interface UpdateChatWidgetIcon {
  /**
   * Update chat widget icon
   */
  chatWidgetIconUpdate: UpdateChatWidgetIcon_chatWidgetIconUpdate;
}

export interface UpdateChatWidgetIconVariables {
  input: ChatWidgetIconUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAgents
// ====================================================

export interface GetAgents_chatAgents {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  agentStatus: AgentStatusEnum;
  /**
   * The number of active chats the agent is currently assigned
   */
  numActiveChats: number;
  /**
   * The number of chats that need a reply from the agent
   */
  numNeedsReplyChats: number;
  name: string;
  agentPresence: AgentPresenceEnum;
}

export interface GetAgents {
  /**
   * List of all chat agents
   */
  chatAgents: (GetAgents_chatAgents | null)[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAppearanceSettings
// ====================================================

export interface GetAppearanceSettings_chatSettings_lookAndFeel_nudgeSettings {
  __typename: "ChatSettingsNudge";
  /**
   * Is the nudge behavior enabled
   */
  isEnabled: boolean;
  /**
   * The nudge overlay text
   */
  message: string;
  /**
   * The call to action text
   */
  callToAction: string;
  /**
   * When to show nudges (desktop only or always)
   */
  deviceVisibility: NudgeDeviceVisibilityEnum;
}

export interface GetAppearanceSettings_chatSettings_lookAndFeel_icon {
  __typename: "ChatIcon";
  /**
   * Icon type
   */
  type: ChatIconEnum;
  /**
   * Icon URL
   */
  url: string | null;
}

export interface GetAppearanceSettings_chatSettings_lookAndFeel_disclaimerSettings {
  __typename: "ChatSettingsDisclaimer";
  /**
   * Is the disclaimer enabled
   */
  isEnabled: boolean;
  /**
   * The disclaimer message
   */
  message: string;
}

export interface GetAppearanceSettings_chatSettings_lookAndFeel {
  __typename: "LookAndFeel";
  /**
   * The primary color of the chat window
   */
  color: string;
  /**
   * The secondary color for chat
   */
  secondaryColor: string;
  /**
   * The chat variant (chat button only or actions bar)
   */
  chatVariant: ChatVariantEnum;
  /**
   * The position of the chat window
   */
  nameDisplay: string;
  /**
   * The name of the chatbot
   */
  chatbotName: string;
  /**
   * The icon type for the chatbot
   */
  chatbotIconEnum: ChatbotIconEnum;
  /**
   * The nudge settings
   */
  nudgeSettings: GetAppearanceSettings_chatSettings_lookAndFeel_nudgeSettings;
  /**
   * The chat icon settings
   */
  icon: GetAppearanceSettings_chatSettings_lookAndFeel_icon;
  /**
   * The intro message a visitor sees when they open the chat
   */
  conversationStarter: string;
  /**
   * Whether to show the powered by Nutshell logo
   */
  showPoweredBy: boolean;
  /**
   * The disclaimer settings
   */
  disclaimerSettings: GetAppearanceSettings_chatSettings_lookAndFeel_disclaimerSettings;
  /**
   * The actions that are shown in the engagement bar
   */
  actionBarShownActions: ActionBarActionEnum[];
  /**
   * The actions that are hidden in the engagement bar
   */
  actionBarHiddenActions: ActionBarActionEnum[];
  /**
   * The paths that are disabled for the chat widget
   */
  disabledPaths: string[];
}

export interface GetAppearanceSettings_chatSettings_appMode_homepageSettings_actionLabels {
  __typename: "ChatSettingsHomepageActionLabels";
  /**
   * The label for the book action
   */
  book: string;
  /**
   * The label for the email action
   */
  email: string;
  /**
   * The label for the call action
   */
  call: string;
  /**
   * The label for the text action
   */
  text: string;
  /**
   * The label for the quote action
   */
  quote: string;
}

export interface GetAppearanceSettings_chatSettings_appMode_homepageSettings {
  __typename: "ChatSettingsHomepage";
  /**
   * Whether the homepage is enabled
   */
  isEnabled: boolean;
  /**
   * The layout of the homepage
   */
  layout: ChatHomepageLayoutEnum;
  /**
   * Per-action labels displayed on the homepage
   */
  actionLabels: GetAppearanceSettings_chatSettings_appMode_homepageSettings_actionLabels;
}

export interface GetAppearanceSettings_chatSettings_appMode_businessCardSettings {
  __typename: "ChatSettingsBusinessCard";
  /**
   * Whether the business card is enabled
   */
  isEnabled: boolean;
  /**
   * The logo URL
   */
  logoUrl: string | null;
  /**
   * The company name
   */
  companyName: string | null;
  /**
   * The email
   */
  email: string | null;
  /**
   * The phone number
   */
  phoneNumber: string | null;
  /**
   * The address
   */
  address: string | null;
  /**
   * The business hours description
   */
  businessHours: string | null;
}

export interface GetAppearanceSettings_chatSettings_appMode {
  __typename: "AppMode";
  /**
   * The homepage settings
   */
  homepageSettings: GetAppearanceSettings_chatSettings_appMode_homepageSettings;
  /**
   * The business card settings
   */
  businessCardSettings: GetAppearanceSettings_chatSettings_appMode_businessCardSettings;
  /**
   * The auto open view
   */
  autoOpenView: ChatAutoOpenEnum | null;
}

export interface GetAppearanceSettings_chatSettings_intakeForm {
  __typename: "ChatSettingsIntakeForm";
  fields: ChatSettingsIntakeFormFieldsEnum[];
  type: ChatSettingsIntakeFormTypeEnum;
  /**
   * Allow chat threads to proceed without requiring a contact to be created
   */
  allowThreadsWithoutContact: boolean;
}

export interface GetAppearanceSettings_chatSettings_actions_chat {
  __typename: "ChatAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * Whether to automatically create leads from chat conversations
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
}

export interface GetAppearanceSettings_chatSettings_actions_booking {
  __typename: "BookingAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The meeting ID to use for booking
   */
  meetingId: string | null;
  /**
   * The confirmation message after booking a meeting
   */
  formConfirmationMessage: string;
  /**
   * Whether to automatically create leads from booking requests
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
}

export interface GetAppearanceSettings_chatSettings_actions_email {
  __typename: "EmailAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The slug for the form to display for email action
   */
  formSlug: string | null;
  /**
   * The slug for the default form that was auto-created for this action
   */
  defaultFormSlug: string | null;
  /**
   * The confirmation message after submitting a form
   */
  formConfirmationMessage: string;
  /**
   * Whether to automatically create leads from email requests
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * Whether to link an email address
   */
  shouldLinkEmailAddress: boolean;
  /**
   * The email address to link
   */
  linkEmailAddress: string | null;
}

export interface GetAppearanceSettings_chatSettings_actions_call_linkNumberConfig {
  __typename: "LinkNumberConfig";
  /**
   * The type of phone number that is linked (custom or call tracker fx)
   */
  type: LinkNumberTypeEnum;
  /**
   * The custom phone number to link
   */
  customNumber: string | null;
  /**
   * The phone number to link
   */
  callTrackerNumber: string | null;
  /**
   * The call tracker id
   */
  callTrackerId: string | null;
}

export interface GetAppearanceSettings_chatSettings_actions_call {
  __typename: "CallAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The slug for the form to display for call action
   */
  formSlug: string | null;
  /**
   * The slug for the default form that was auto-created for this action
   */
  defaultFormSlug: string | null;
  /**
   * The confirmation message after submitting a form
   */
  formConfirmationMessage: string;
  /**
   * Whether to automatically create leads from call requests
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * Whether to link a phone number
   */
  shouldLinkNumber: boolean;
  /**
   * The configuration for the linked phone number
   */
  linkNumberConfig: GetAppearanceSettings_chatSettings_actions_call_linkNumberConfig;
}

export interface GetAppearanceSettings_chatSettings_actions_text {
  __typename: "TextAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The slug for the form to display for text action
   */
  formSlug: string | null;
  /**
   * The slug for the default form that was auto-created for this action
   */
  defaultFormSlug: string | null;
  /**
   * The confirmation message after submitting a form
   */
  formConfirmationMessage: string;
  /**
   * Whether to automatically create leads from text requests
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * Whether to link a phone number
   */
  shouldLinkNumber: boolean;
  /**
   * The phone number to link
   */
  linkNumber: string | null;
}

export interface GetAppearanceSettings_chatSettings_actions_quote {
  __typename: "QuoteAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * Whether to automatically create leads after submitting a quote form
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The slug for the form to display for quote action
   */
  formSlug: string | null;
  /**
   * The slug for the default form that was auto-created for this action
   */
  defaultFormSlug: string | null;
  /**
   * The confirmation message after submitting a form
   */
  formConfirmationMessage: string;
}

export interface GetAppearanceSettings_chatSettings_actions {
  __typename: "Actions";
  /**
   * Chat action configuration
   */
  chat: GetAppearanceSettings_chatSettings_actions_chat;
  /**
   * Booking action configuration
   */
  booking: GetAppearanceSettings_chatSettings_actions_booking;
  /**
   * Email action configuration
   */
  email: GetAppearanceSettings_chatSettings_actions_email;
  /**
   * Call action configuration
   */
  call: GetAppearanceSettings_chatSettings_actions_call;
  /**
   * Text action configuration
   */
  text: GetAppearanceSettings_chatSettings_actions_text;
  /**
   * Quote action configuration
   */
  quote: GetAppearanceSettings_chatSettings_actions_quote;
}

export interface GetAppearanceSettings_chatSettings {
  __typename: "ChatSettings";
  /**
   * The chat look and feel settings
   */
  lookAndFeel: GetAppearanceSettings_chatSettings_lookAndFeel;
  /**
   * The app mode settings
   */
  appMode: GetAppearanceSettings_chatSettings_appMode;
  /**
   * The chat intake form settings
   */
  intakeForm: GetAppearanceSettings_chatSettings_intakeForm;
  /**
   * The actions settings
   */
  actions: GetAppearanceSettings_chatSettings_actions;
}

export interface GetAppearanceSettings {
  /**
   * Configuration for nutshell chat widget
   */
  chatSettings: GetAppearanceSettings_chatSettings;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCallTrackerNumbers
// ====================================================

export interface GetCallTrackerNumbers_callTrackerNumbers {
  __typename: "CallTrackerNumber";
  id: string;
  label: string;
  match: string;
  forwardTo: string;
}

export interface GetCallTrackerNumbers {
  /**
   * Returns a list of CallTrackerFX number configurations
   */
  callTrackerNumbers: GetCallTrackerNumbers_callTrackerNumbers[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBehaviorSettings
// ====================================================

export interface GetBehaviorSettings_chatSettings_chatbot_customAnswers {
  __typename: "CustomAnswer";
  question: string;
  answer: string;
  isEnabled: boolean;
}

export interface GetBehaviorSettings_chatSettings_chatbot {
  __typename: "Chatbot";
  /**
   * When the chatbot should respond to messages
   */
  responseTiming: ChatbotResponseTimingEnum;
  /**
   * The name of the chatbot
   */
  name: string;
  /**
   * The icon type for the chatbot
   */
  iconEnum: ChatbotIconEnum;
  /**
   * The tone of the chatbot responses
   */
  tone: ChatbotToneEnum;
  /**
   * The preferred length of chatbot responses
   */
  answerLength: ChatbotAnswerLengthEnum;
  /**
   * Style and behavior suggestions for the chatbot
   */
  suggestions: (string | null)[];
  /**
   * Topics the chatbot should avoid discussing
   */
  topicsToAvoid: (string | null)[];
  customAnswers: GetBehaviorSettings_chatSettings_chatbot_customAnswers[];
}

export interface GetBehaviorSettings_chatSettings_offline_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
}

export interface GetBehaviorSettings_chatSettings_offline {
  __typename: "ChatSettingsOffline";
  /**
   * Offline form capture enabled
   */
  isEnabled: boolean;
  /**
   * The offline custom form
   */
  form: GetBehaviorSettings_chatSettings_offline_form;
  formType: ChatSettingsOfflineFormTypeEnum;
  /**
   * The message to show if there are no agents online
   */
  message: string;
  /**
   * The message to show if there are no agents online for conversational forms
   */
  conversationalMessage: string;
}

export interface GetBehaviorSettings_chatSettings_assignment_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetBehaviorSettings_chatSettings_assignment {
  __typename: "ChatSettingsAssignment";
  /**
   * The assignment strategy for new chats
   */
  strategy: ChatAssignmentStrategyEnum;
  /**
   * The user to assign new chats to (only applicable if assignmentStrategy is SPECIFIC_USER)
   */
  user: GetBehaviorSettings_chatSettings_assignment_user | null;
}

export interface GetBehaviorSettings_chatSettings_lookAndFeel_nudgeSettings {
  __typename: "ChatSettingsNudge";
  /**
   * Is the nudge behavior enabled
   */
  isEnabled: boolean;
  /**
   * The nudge overlay text
   */
  message: string;
  /**
   * The call to action text
   */
  callToAction: string;
  /**
   * When to show nudges (desktop only or always)
   */
  deviceVisibility: NudgeDeviceVisibilityEnum;
}

export interface GetBehaviorSettings_chatSettings_lookAndFeel_icon {
  __typename: "ChatIcon";
  /**
   * Icon type
   */
  type: ChatIconEnum;
  /**
   * Icon URL
   */
  url: string | null;
}

export interface GetBehaviorSettings_chatSettings_lookAndFeel_disclaimerSettings {
  __typename: "ChatSettingsDisclaimer";
  /**
   * Is the disclaimer enabled
   */
  isEnabled: boolean;
  /**
   * The disclaimer message
   */
  message: string;
}

export interface GetBehaviorSettings_chatSettings_lookAndFeel {
  __typename: "LookAndFeel";
  /**
   * The primary color of the chat window
   */
  color: string;
  /**
   * The position of the chat window
   */
  nameDisplay: string;
  /**
   * The nudge settings
   */
  nudgeSettings: GetBehaviorSettings_chatSettings_lookAndFeel_nudgeSettings;
  /**
   * The chat icon settings
   */
  icon: GetBehaviorSettings_chatSettings_lookAndFeel_icon;
  /**
   * The intro message a visitor sees when they open the chat
   */
  conversationStarter: string;
  /**
   * Whether to show the powered by Nutshell logo
   */
  showPoweredBy: boolean;
  /**
   * The disclaimer settings
   */
  disclaimerSettings: GetBehaviorSettings_chatSettings_lookAndFeel_disclaimerSettings;
  /**
   * The secondary color for chat
   */
  secondaryColor: string;
  /**
   * The chat variant (chat button only or actions bar)
   */
  chatVariant: ChatVariantEnum;
  /**
   * The name of the chatbot
   */
  chatbotName: string;
  /**
   * The icon type for the chatbot
   */
  chatbotIconEnum: ChatbotIconEnum;
  /**
   * The actions that are shown in the engagement bar
   */
  actionBarShownActions: ActionBarActionEnum[];
  /**
   * The actions that are hidden in the engagement bar
   */
  actionBarHiddenActions: ActionBarActionEnum[];
  /**
   * The paths that are disabled for the chat widget
   */
  disabledPaths: string[];
}

export interface GetBehaviorSettings_chatSettings_appMode_homepageSettings_actionLabels {
  __typename: "ChatSettingsHomepageActionLabels";
  /**
   * The label for the book action
   */
  book: string;
  /**
   * The label for the email action
   */
  email: string;
  /**
   * The label for the call action
   */
  call: string;
  /**
   * The label for the text action
   */
  text: string;
  /**
   * The label for the quote action
   */
  quote: string;
}

export interface GetBehaviorSettings_chatSettings_appMode_homepageSettings {
  __typename: "ChatSettingsHomepage";
  /**
   * Whether the homepage is enabled
   */
  isEnabled: boolean;
  /**
   * The layout of the homepage
   */
  layout: ChatHomepageLayoutEnum;
  /**
   * Per-action labels displayed on the homepage
   */
  actionLabels: GetBehaviorSettings_chatSettings_appMode_homepageSettings_actionLabels;
}

export interface GetBehaviorSettings_chatSettings_appMode_businessCardSettings {
  __typename: "ChatSettingsBusinessCard";
  /**
   * Whether the business card is enabled
   */
  isEnabled: boolean;
  /**
   * The logo URL
   */
  logoUrl: string | null;
  /**
   * The company name
   */
  companyName: string | null;
  /**
   * The email
   */
  email: string | null;
  /**
   * The phone number
   */
  phoneNumber: string | null;
  /**
   * The address
   */
  address: string | null;
  /**
   * The business hours description
   */
  businessHours: string | null;
}

export interface GetBehaviorSettings_chatSettings_appMode {
  __typename: "AppMode";
  /**
   * The homepage settings
   */
  homepageSettings: GetBehaviorSettings_chatSettings_appMode_homepageSettings;
  /**
   * The business card settings
   */
  businessCardSettings: GetBehaviorSettings_chatSettings_appMode_businessCardSettings;
  /**
   * The auto open view
   */
  autoOpenView: ChatAutoOpenEnum | null;
}

export interface GetBehaviorSettings_chatSettings_intakeForm {
  __typename: "ChatSettingsIntakeForm";
  fields: ChatSettingsIntakeFormFieldsEnum[];
  type: ChatSettingsIntakeFormTypeEnum;
  /**
   * Allow chat threads to proceed without requiring a contact to be created
   */
  allowThreadsWithoutContact: boolean;
}

export interface GetBehaviorSettings_chatSettings {
  __typename: "ChatSettings";
  /**
   * The chatbot settings
   */
  chatbot: GetBehaviorSettings_chatSettings_chatbot;
  /**
   * The chat offline settings
   */
  offline: GetBehaviorSettings_chatSettings_offline;
  /**
   * The chat assignment settings
   */
  assignment: GetBehaviorSettings_chatSettings_assignment;
  /**
   * The chat look and feel settings
   */
  lookAndFeel: GetBehaviorSettings_chatSettings_lookAndFeel;
  /**
   * The app mode settings
   */
  appMode: GetBehaviorSettings_chatSettings_appMode;
  /**
   * The chat intake form settings
   */
  intakeForm: GetBehaviorSettings_chatSettings_intakeForm;
}

export interface GetBehaviorSettings {
  /**
   * Configuration for nutshell chat widget
   */
  chatSettings: GetBehaviorSettings_chatSettings;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetChatSettingsEngagementBar
// ====================================================

export interface GetChatSettingsEngagementBar_chatSettings_lookAndFeel_nudgeSettings {
  __typename: "ChatSettingsNudge";
  /**
   * Is the nudge behavior enabled
   */
  isEnabled: boolean;
  /**
   * The nudge overlay text
   */
  message: string;
  /**
   * When to show nudges (desktop only or always)
   */
  deviceVisibility: NudgeDeviceVisibilityEnum;
  /**
   * The call to action text
   */
  callToAction: string;
}

export interface GetChatSettingsEngagementBar_chatSettings_lookAndFeel_icon {
  __typename: "ChatIcon";
  /**
   * Icon type
   */
  type: ChatIconEnum;
  /**
   * Icon URL
   */
  url: string | null;
}

export interface GetChatSettingsEngagementBar_chatSettings_lookAndFeel_disclaimerSettings {
  __typename: "ChatSettingsDisclaimer";
  /**
   * Is the disclaimer enabled
   */
  isEnabled: boolean;
  /**
   * The disclaimer message
   */
  message: string;
}

export interface GetChatSettingsEngagementBar_chatSettings_lookAndFeel {
  __typename: "LookAndFeel";
  /**
   * The primary color of the chat window
   */
  color: string;
  /**
   * The secondary color for chat
   */
  secondaryColor: string;
  /**
   * The position of the chat window
   */
  nameDisplay: string;
  /**
   * The chat variant (chat button only or actions bar)
   */
  chatVariant: ChatVariantEnum;
  /**
   * The actions that are shown in the engagement bar
   */
  actionBarShownActions: ActionBarActionEnum[];
  /**
   * The nudge settings
   */
  nudgeSettings: GetChatSettingsEngagementBar_chatSettings_lookAndFeel_nudgeSettings;
  /**
   * The chat icon settings
   */
  icon: GetChatSettingsEngagementBar_chatSettings_lookAndFeel_icon;
  /**
   * The intro message a visitor sees when they open the chat
   */
  conversationStarter: string;
  /**
   * Whether to show the powered by Nutshell logo
   */
  showPoweredBy: boolean;
  /**
   * The disclaimer settings
   */
  disclaimerSettings: GetChatSettingsEngagementBar_chatSettings_lookAndFeel_disclaimerSettings;
}

export interface GetChatSettingsEngagementBar_chatSettings_intakeForm {
  __typename: "ChatSettingsIntakeForm";
  fields: ChatSettingsIntakeFormFieldsEnum[];
  type: ChatSettingsIntakeFormTypeEnum;
  /**
   * Allow chat threads to proceed without requiring a contact to be created
   */
  allowThreadsWithoutContact: boolean;
}

export interface GetChatSettingsEngagementBar_chatSettings_actions_chat {
  __typename: "ChatAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * Whether to automatically create leads from chat conversations
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
}

export interface GetChatSettingsEngagementBar_chatSettings_actions_booking {
  __typename: "BookingAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The meeting ID to use for booking
   */
  meetingId: string | null;
  /**
   * The confirmation message after booking a meeting
   */
  formConfirmationMessage: string;
  /**
   * Whether to automatically create leads from booking requests
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
}

export interface GetChatSettingsEngagementBar_chatSettings_actions_email {
  __typename: "EmailAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The slug for the form to display for email action
   */
  formSlug: string | null;
  /**
   * The slug for the default form that was auto-created for this action
   */
  defaultFormSlug: string | null;
  /**
   * The confirmation message after submitting a form
   */
  formConfirmationMessage: string;
  /**
   * Whether to automatically create leads from email requests
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * Whether to link an email address
   */
  shouldLinkEmailAddress: boolean;
  /**
   * The email address to link
   */
  linkEmailAddress: string | null;
}

export interface GetChatSettingsEngagementBar_chatSettings_actions_call_linkNumberConfig {
  __typename: "LinkNumberConfig";
  /**
   * The type of phone number that is linked (custom or call tracker fx)
   */
  type: LinkNumberTypeEnum;
  /**
   * The custom phone number to link
   */
  customNumber: string | null;
  /**
   * The phone number to link
   */
  callTrackerNumber: string | null;
  /**
   * The call tracker id
   */
  callTrackerId: string | null;
}

export interface GetChatSettingsEngagementBar_chatSettings_actions_call {
  __typename: "CallAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The slug for the form to display for call action
   */
  formSlug: string | null;
  /**
   * The slug for the default form that was auto-created for this action
   */
  defaultFormSlug: string | null;
  /**
   * The confirmation message after submitting a form
   */
  formConfirmationMessage: string;
  /**
   * Whether to automatically create leads from call requests
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * Whether to link a phone number
   */
  shouldLinkNumber: boolean;
  /**
   * The configuration for the linked phone number
   */
  linkNumberConfig: GetChatSettingsEngagementBar_chatSettings_actions_call_linkNumberConfig;
}

export interface GetChatSettingsEngagementBar_chatSettings_actions_text {
  __typename: "TextAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The slug for the form to display for text action
   */
  formSlug: string | null;
  /**
   * The slug for the default form that was auto-created for this action
   */
  defaultFormSlug: string | null;
  /**
   * The confirmation message after submitting a form
   */
  formConfirmationMessage: string;
  /**
   * Whether to automatically create leads from text requests
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * Whether to link a phone number
   */
  shouldLinkNumber: boolean;
  /**
   * The phone number to link
   */
  linkNumber: string | null;
}

export interface GetChatSettingsEngagementBar_chatSettings_actions_quote {
  __typename: "QuoteAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * Whether to automatically create leads after submitting a quote form
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The slug for the form to display for quote action
   */
  formSlug: string | null;
  /**
   * The slug for the default form that was auto-created for this action
   */
  defaultFormSlug: string | null;
  /**
   * The confirmation message after submitting a form
   */
  formConfirmationMessage: string;
}

export interface GetChatSettingsEngagementBar_chatSettings_actions {
  __typename: "Actions";
  /**
   * Chat action configuration
   */
  chat: GetChatSettingsEngagementBar_chatSettings_actions_chat;
  /**
   * Booking action configuration
   */
  booking: GetChatSettingsEngagementBar_chatSettings_actions_booking;
  /**
   * Email action configuration
   */
  email: GetChatSettingsEngagementBar_chatSettings_actions_email;
  /**
   * Call action configuration
   */
  call: GetChatSettingsEngagementBar_chatSettings_actions_call;
  /**
   * Text action configuration
   */
  text: GetChatSettingsEngagementBar_chatSettings_actions_text;
  /**
   * Quote action configuration
   */
  quote: GetChatSettingsEngagementBar_chatSettings_actions_quote;
}

export interface GetChatSettingsEngagementBar_chatSettings_appMode_homepageSettings_actionLabels {
  __typename: "ChatSettingsHomepageActionLabels";
  /**
   * The label for the book action
   */
  book: string;
  /**
   * The label for the email action
   */
  email: string;
  /**
   * The label for the call action
   */
  call: string;
  /**
   * The label for the text action
   */
  text: string;
  /**
   * The label for the quote action
   */
  quote: string;
}

export interface GetChatSettingsEngagementBar_chatSettings_appMode_homepageSettings {
  __typename: "ChatSettingsHomepage";
  /**
   * Whether the homepage is enabled
   */
  isEnabled: boolean;
  /**
   * The layout of the homepage
   */
  layout: ChatHomepageLayoutEnum;
  /**
   * Per-action labels displayed on the homepage
   */
  actionLabels: GetChatSettingsEngagementBar_chatSettings_appMode_homepageSettings_actionLabels;
}

export interface GetChatSettingsEngagementBar_chatSettings_appMode_businessCardSettings {
  __typename: "ChatSettingsBusinessCard";
  /**
   * Whether the business card is enabled
   */
  isEnabled: boolean;
  /**
   * The logo URL
   */
  logoUrl: string | null;
  /**
   * The company name
   */
  companyName: string | null;
  /**
   * The email
   */
  email: string | null;
  /**
   * The phone number
   */
  phoneNumber: string | null;
  /**
   * The address
   */
  address: string | null;
  /**
   * The business hours description
   */
  businessHours: string | null;
}

export interface GetChatSettingsEngagementBar_chatSettings_appMode {
  __typename: "AppMode";
  /**
   * The homepage settings
   */
  homepageSettings: GetChatSettingsEngagementBar_chatSettings_appMode_homepageSettings;
  /**
   * The business card settings
   */
  businessCardSettings: GetChatSettingsEngagementBar_chatSettings_appMode_businessCardSettings;
}

export interface GetChatSettingsEngagementBar_chatSettings {
  __typename: "ChatSettings";
  /**
   * The chat look and feel settings
   */
  lookAndFeel: GetChatSettingsEngagementBar_chatSettings_lookAndFeel;
  /**
   * The chat intake form settings
   */
  intakeForm: GetChatSettingsEngagementBar_chatSettings_intakeForm;
  /**
   * The actions settings
   */
  actions: GetChatSettingsEngagementBar_chatSettings_actions;
  /**
   * The app mode settings
   */
  appMode: GetChatSettingsEngagementBar_chatSettings_appMode;
}

export interface GetChatSettingsEngagementBar {
  /**
   * Configuration for nutshell chat widget
   */
  chatSettings: GetChatSettingsEngagementBar_chatSettings;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetChatSettingsKnowledge
// ====================================================

export interface GetChatSettingsKnowledge_chatSettings_lookAndFeel_nudgeSettings {
  __typename: "ChatSettingsNudge";
  /**
   * Is the nudge behavior enabled
   */
  isEnabled: boolean;
  /**
   * The nudge overlay text
   */
  message: string;
}

export interface GetChatSettingsKnowledge_chatSettings_lookAndFeel {
  __typename: "LookAndFeel";
  /**
   * The nudge settings
   */
  nudgeSettings: GetChatSettingsKnowledge_chatSettings_lookAndFeel_nudgeSettings;
  /**
   * The secondary color for chat
   */
  secondaryColor: string;
}

export interface GetChatSettingsKnowledge_chatSettings_chatbot_customAnswers {
  __typename: "CustomAnswer";
  question: string;
  answer: string;
  isEnabled: boolean;
}

export interface GetChatSettingsKnowledge_chatSettings_chatbot {
  __typename: "Chatbot";
  customAnswers: GetChatSettingsKnowledge_chatSettings_chatbot_customAnswers[];
}

export interface GetChatSettingsKnowledge_chatSettings {
  __typename: "ChatSettings";
  /**
   * The chat look and feel settings
   */
  lookAndFeel: GetChatSettingsKnowledge_chatSettings_lookAndFeel;
  /**
   * The chatbot settings
   */
  chatbot: GetChatSettingsKnowledge_chatSettings_chatbot;
}

export interface GetChatSettingsKnowledge {
  /**
   * Configuration for nutshell chat widget
   */
  chatSettings: GetChatSettingsKnowledge_chatSettings;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetChatSettings
// ====================================================

export interface GetChatSettings_chatSettings_intakeForm {
  __typename: "ChatSettingsIntakeForm";
  fields: ChatSettingsIntakeFormFieldsEnum[];
  message: string;
  type: ChatSettingsIntakeFormTypeEnum;
  /**
   * Whether to create a lead if no other rules trigger a lead creation
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID to create the lead in
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * Allow chat threads to proceed without requiring a contact to be created
   */
  allowThreadsWithoutContact: boolean;
}

export interface GetChatSettings_chatSettings_lookAndFeel_nudgeSettings {
  __typename: "ChatSettingsNudge";
  /**
   * Is the nudge behavior enabled
   */
  isEnabled: boolean;
  /**
   * The nudge overlay text
   */
  message: string;
  /**
   * The call to action text
   */
  callToAction: string;
  /**
   * When to show nudges (desktop only or always)
   */
  deviceVisibility: NudgeDeviceVisibilityEnum;
}

export interface GetChatSettings_chatSettings_lookAndFeel_icon {
  __typename: "ChatIcon";
  /**
   * Icon type
   */
  type: ChatIconEnum;
  /**
   * Icon URL
   */
  url: string | null;
}

export interface GetChatSettings_chatSettings_lookAndFeel_disclaimerSettings {
  __typename: "ChatSettingsDisclaimer";
  /**
   * Is the disclaimer enabled
   */
  isEnabled: boolean;
  /**
   * The disclaimer message
   */
  message: string;
}

export interface GetChatSettings_chatSettings_lookAndFeel {
  __typename: "LookAndFeel";
  /**
   * The primary color of the chat window
   */
  color: string;
  /**
   * The secondary color for chat
   */
  secondaryColor: string;
  /**
   * The position of the chat window
   */
  nameDisplay: string;
  /**
   * The nudge settings
   */
  nudgeSettings: GetChatSettings_chatSettings_lookAndFeel_nudgeSettings;
  /**
   * The chat icon settings
   */
  icon: GetChatSettings_chatSettings_lookAndFeel_icon;
  /**
   * The intro message a visitor sees when they open the chat
   */
  conversationStarter: string;
  /**
   * Whether to show the powered by Nutshell logo
   */
  showPoweredBy: boolean;
  /**
   * The disclaimer settings
   */
  disclaimerSettings: GetChatSettings_chatSettings_lookAndFeel_disclaimerSettings;
  /**
   * The actions that are shown in the engagement bar
   */
  actionBarShownActions: ActionBarActionEnum[];
  /**
   * The actions that are hidden in the engagement bar
   */
  actionBarHiddenActions: ActionBarActionEnum[];
  /**
   * The chat variant (chat button only or actions bar)
   */
  chatVariant: ChatVariantEnum;
  /**
   * The name of the chatbot
   */
  chatbotName: string;
  /**
   * The icon type for the chatbot
   */
  chatbotIconEnum: ChatbotIconEnum;
  /**
   * The paths that are disabled for the chat widget
   */
  disabledPaths: string[];
}

export interface GetChatSettings_chatSettings_offline_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
}

export interface GetChatSettings_chatSettings_offline {
  __typename: "ChatSettingsOffline";
  /**
   * Offline form capture enabled
   */
  isEnabled: boolean;
  /**
   * The offline custom form
   */
  form: GetChatSettings_chatSettings_offline_form;
  formType: ChatSettingsOfflineFormTypeEnum;
  /**
   * The message to show if there are no agents online
   */
  message: string;
  /**
   * The message to show if there are no agents online for conversational forms
   */
  conversationalMessage: string;
}

export interface GetChatSettings_chatSettings_assignment_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetChatSettings_chatSettings_assignment {
  __typename: "ChatSettingsAssignment";
  /**
   * The assignment strategy for new chats
   */
  strategy: ChatAssignmentStrategyEnum;
  /**
   * The user to assign new chats to (only applicable if assignmentStrategy is SPECIFIC_USER)
   */
  user: GetChatSettings_chatSettings_assignment_user | null;
}

export interface GetChatSettings_chatSettings_chatbot {
  __typename: "Chatbot";
  /**
   * When the chatbot should respond to messages
   */
  responseTiming: ChatbotResponseTimingEnum;
  /**
   * The name of the chatbot
   */
  name: string;
  /**
   * The icon type for the chatbot
   */
  iconEnum: ChatbotIconEnum;
  /**
   * The tone of the chatbot responses
   */
  tone: ChatbotToneEnum;
  /**
   * The preferred length of chatbot responses
   */
  answerLength: ChatbotAnswerLengthEnum;
  /**
   * Style and behavior suggestions for the chatbot
   */
  suggestions: (string | null)[];
  /**
   * Topics the chatbot should avoid discussing
   */
  topicsToAvoid: (string | null)[];
}

export interface GetChatSettings_chatSettings_goals {
  __typename: "Goals";
  /**
   * Whether the scheduler goal is enabled
   */
  schedulerIsEnabled: boolean;
  /**
   * The scheduler meeting ID to show in the chat
   */
  schedulerMeetingId: string | null;
  /**
   * Whether the form goal is enabled
   */
  formIsEnabled: boolean;
  /**
   * The form slug to show in the chat
   */
  formSlug: string | null;
}

export interface GetChatSettings_chatSettings {
  __typename: "ChatSettings";
  /**
   * Is the chat widget enabled
   */
  isChatEnabled: boolean;
  /**
   * The chat intake form settings
   */
  intakeForm: GetChatSettings_chatSettings_intakeForm;
  /**
   * The chat look and feel settings
   */
  lookAndFeel: GetChatSettings_chatSettings_lookAndFeel;
  /**
   * The chat offline settings
   */
  offline: GetChatSettings_chatSettings_offline;
  /**
   * The chat assignment settings
   */
  assignment: GetChatSettings_chatSettings_assignment;
  /**
   * The embeddable script to add chat on a website
   */
  embedScript: string;
  /**
   * The chatbot settings
   */
  chatbot: GetChatSettings_chatSettings_chatbot;
  /**
   * The goals settings
   */
  goals: GetChatSettings_chatSettings_goals;
}

export interface GetChatSettings {
  /**
   * Configuration for nutshell chat widget
   */
  chatSettings: GetChatSettings_chatSettings;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetChatbotTopRecentNudges
// ====================================================

export interface GetChatbotTopRecentNudges_chatbotTopRecentNudges {
  __typename: "AiSuggestion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The content of the AI suggestion
   */
  content: string;
}

export interface GetChatbotTopRecentNudges {
  /**
   * Returns the most-clicked visitor nudges over the last 30 days, deduped,
   * ordered by frequency. Used to populate sample questions in admin tooling.
   */
  chatbotTopRecentNudges: GetChatbotTopRecentNudges_chatbotTopRecentNudges[];
}

export interface GetChatbotTopRecentNudgesVariables {
  limit?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContextDocumentUsage
// ====================================================

export interface GetContextDocumentUsage_contextDocumentUsage {
  __typename: "ContextDocumentUsage";
  /**
   * The total number of words used, calculated roughly from the number of tokens
   */
  wordsUsage: number;
  /**
   * The limit of words, calculated roughly from the number of tokens
   */
  wordsLimit: number;
  /**
   * The total number of web pages used
   */
  webPagesUsage: number;
  /**
   * The total number of context documents used
   */
  pdfsUsage: number;
  /**
   * The limit of context documents
   */
  pagesLimit: number;
  /**
   * The reason for the limit being exceeded
   */
  limitExceededReason: DocumentLimitExceededReasonEnum | null;
}

export interface GetContextDocumentUsage {
  /**
   * Statistics for nutshell context document usage
   */
  contextDocumentUsage: GetContextDocumentUsage_contextDocumentUsage;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContextDocuments
// ====================================================

export interface GetContextDocuments_contextDocuments_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
}

export interface GetContextDocuments_contextDocuments_aiSuggestions {
  __typename: "AiSuggestion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The content of the AI suggestion
   */
  content: string;
}

export interface GetContextDocuments_contextDocuments {
  __typename: "ContextDocument";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the context document, for example, the name of the uploaded file
   */
  name: string | null;
  /**
   * The URL of the context document
   */
  url: GetContextDocuments_contextDocuments_url | null;
  /**
   * The content of the context document
   */
  content: string | null;
  /**
   * The summary of the context document
   */
  summary: string | null;
  /**
   * Whether the context document is included
   */
  isIncluded: boolean;
  isHidden: boolean;
  /**
   * The effective status of the context document
   */
  effectiveStatus: DocumentEffectiveStatusEnum;
  /**
   * The number of words in the context document
   */
  wordCount: number;
  /**
   * Whether the context document is a subpage
   */
  isSubpage: boolean;
  /**
   * The source type of the context document
   */
  sourceType: DocumentSourceTypeEnum;
  /**
   * The time the context document was last crawled
   */
  lastCrawledTime: any;
  /**
   * The AI suggestions for the context document
   */
  aiSuggestions: GetContextDocuments_contextDocuments_aiSuggestions[];
}

export interface GetContextDocuments_primaryContextDocument_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
}

export interface GetContextDocuments_primaryContextDocument_aiSuggestions {
  __typename: "AiSuggestion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The content of the AI suggestion
   */
  content: string;
}

export interface GetContextDocuments_primaryContextDocument {
  __typename: "ContextDocument";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the context document, for example, the name of the uploaded file
   */
  name: string | null;
  /**
   * The URL of the context document
   */
  url: GetContextDocuments_primaryContextDocument_url | null;
  /**
   * The content of the context document
   */
  content: string | null;
  /**
   * The summary of the context document
   */
  summary: string | null;
  /**
   * Whether the context document is included
   */
  isIncluded: boolean;
  isHidden: boolean;
  /**
   * The effective status of the context document
   */
  effectiveStatus: DocumentEffectiveStatusEnum;
  /**
   * The number of words in the context document
   */
  wordCount: number;
  /**
   * Whether the context document is a subpage
   */
  isSubpage: boolean;
  /**
   * The source type of the context document
   */
  sourceType: DocumentSourceTypeEnum;
  /**
   * The time the context document was last crawled
   */
  lastCrawledTime: any;
  /**
   * The AI suggestions for the context document
   */
  aiSuggestions: GetContextDocuments_primaryContextDocument_aiSuggestions[];
  /**
   * The preview URL of the context document
   */
  previewUrl: string;
  /**
   * The shareable preview URL of the context document
   */
  shareablePreviewUrl: string;
  /**
   * Whether the url for the context document can be embedded in an iframe
   */
  canEmbedIframe: boolean;
}

export interface GetContextDocuments {
  /**
   * The Nutshell Context Documents
   */
  contextDocuments: (GetContextDocuments_contextDocuments | null)[];
  /**
   * The primary context document
   */
  primaryContextDocument: GetContextDocuments_primaryContextDocument | null;
}

export interface GetContextDocumentsVariables {
  includeExcluded: boolean;
  includeHidden?: boolean | null;
  sourceType?: DocumentSourceTypeEnum | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPrimaryContextDocument
// ====================================================

export interface GetPrimaryContextDocument_primaryContextDocument_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
}

export interface GetPrimaryContextDocument_primaryContextDocument_aiSuggestions {
  __typename: "AiSuggestion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The content of the AI suggestion
   */
  content: string;
}

export interface GetPrimaryContextDocument_primaryContextDocument {
  __typename: "ContextDocument";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the context document, for example, the name of the uploaded file
   */
  name: string | null;
  /**
   * The URL of the context document
   */
  url: GetPrimaryContextDocument_primaryContextDocument_url | null;
  /**
   * The content of the context document
   */
  content: string | null;
  /**
   * The summary of the context document
   */
  summary: string | null;
  /**
   * Whether the context document is included
   */
  isIncluded: boolean;
  isHidden: boolean;
  /**
   * The effective status of the context document
   */
  effectiveStatus: DocumentEffectiveStatusEnum;
  /**
   * The number of words in the context document
   */
  wordCount: number;
  /**
   * Whether the context document is a subpage
   */
  isSubpage: boolean;
  /**
   * The source type of the context document
   */
  sourceType: DocumentSourceTypeEnum;
  /**
   * The time the context document was last crawled
   */
  lastCrawledTime: any;
  /**
   * The AI suggestions for the context document
   */
  aiSuggestions: GetPrimaryContextDocument_primaryContextDocument_aiSuggestions[];
}

export interface GetPrimaryContextDocument {
  /**
   * The primary context document
   */
  primaryContextDocument: GetPrimaryContextDocument_primaryContextDocument | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSchedulerMeetingsChat
// ====================================================

export interface GetSchedulerMeetingsChat_meetings_primaryHost {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSchedulerMeetingsChat_meetings_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface GetSchedulerMeetingsChat_meetings_validity {
  __typename: "MeetingValidity";
  /**
   * Whether this meeting can be booked
   */
  isBookable: boolean;
}

export interface GetSchedulerMeetingsChat_meetings {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number;
  /**
   * The primary host for this meeting
   */
  primaryHost: GetSchedulerMeetingsChat_meetings_primaryHost | null;
  /**
   * The activity type for this meeting
   */
  activityType: GetSchedulerMeetingsChat_meetings_activityType;
  /**
   * The timestamp this web form was last submitted
   */
  lastBookedTime: any | null;
  /**
   * The validity of this meeting
   */
  validity: GetSchedulerMeetingsChat_meetings_validity;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetSchedulerMeetingsChat {
  /**
   * Returns scheduler meetings
   */
  meetings: GetSchedulerMeetingsChat_meetings[];
}

export interface GetSchedulerMeetingsChatVariables {
  sort?: MeetingSortOrder | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWfFormsChat
// ====================================================

export interface GetWfFormsChat_forms_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetWfFormsChat_forms_edges_node {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetWfFormsChat_forms_edges {
  __typename: "FormsEdge";
  cursor: string;
  node: GetWfFormsChat_forms_edges_node;
}

export interface GetWfFormsChat_forms {
  __typename: "FormsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetWfFormsChat_forms_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetWfFormsChat_forms_edges[];
}

export interface GetWfFormsChat {
  /**
   * Returns a connection of Nutshell Web Forms
   */
  forms: GetWfFormsChat_forms;
}

export interface GetWfFormsChatVariables {
  limit: number;
  after?: string | null;
  archived: boolean;
  sort: FormSortType;
  search?: string | null;
  creatorUserId?: string | null;
  lastUpdatedTime?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetChannelDashboard
// ====================================================

export interface GetChannelDashboard_channelDashboard_stats_delta {
  __typename: "Delta";
  /**
   * The text trailing the percentage change describing the timespan the change represents
   */
  timespanSuffix: string | null;
  /**
   * Which direction the statistic moved over the timespan
   */
  direction: DeltaDirection;
  /**
   * How much a statistic changed percentage wise over the timespan, formatted with a % sign
   */
  percentChange: string;
}

export interface GetChannelDashboard_channelDashboard_stats {
  __typename: "Stat";
  /**
   * Details about how a statistic has changed in a given timespan, and by how
   * much. If there is no data for the timespan preceeding this one, returns null.
   */
  delta: GetChannelDashboard_channelDashboard_stats_delta | null;
  /**
   * The name of the quantity the statistics represent
   */
  name: string;
  /**
   * The current value of the statistic formatted as a human-readable number
   */
  formattedValue: string;
}

export interface GetChannelDashboard_channelDashboard {
  __typename: "ChannelDashboard";
  /**
   * The list of key stats and how they’ve changed over the timespan.
   */
  stats: GetChannelDashboard_channelDashboard_stats[];
}

export interface GetChannelDashboard {
  /**
   * Returns the stats for a channels card
   */
  channelDashboard: GetChannelDashboard_channelDashboard;
}

export interface GetChannelDashboardVariables {
  input: DashboardInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetInboxDashboardChecklist
// ====================================================

export interface GetInboxDashboardChecklist_inboxDashboardChecklist_items {
  __typename: "OnboardingChecklistItem";
  /**
   * Completion percentage of all tasks on the onboarding checklist
   */
  key: OnboardingChecklistKey;
  /**
   * Title of the checklist item, i.e. "Create your first contact"
   */
  title: string;
  /**
   * Subtitle of the checklist item
   */
  subtitle: string | null;
  /**
   * The total decimal amount of the monetary value.
   */
  isComplete: boolean;
}

export interface GetInboxDashboardChecklist_inboxDashboardChecklist {
  __typename: "OnboardingChecklist";
  /**
   * The total decimal amount of the monetary value.
   */
  items: GetInboxDashboardChecklist_inboxDashboardChecklist_items[];
  /**
   * Completion percentage of all tasks on the onboarding checklist
   */
  percentComplete: number;
}

export interface GetInboxDashboardChecklist {
  /**
   * A list of open threads related to a Nutshell entity
   */
  inboxDashboardChecklist: GetInboxDashboardChecklist_inboxDashboardChecklist;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSMSDashboard
// ====================================================

export interface GetSMSDashboard_inboxDashboard_stats_delta {
  __typename: "Delta";
  /**
   * The text trailing the percentage change describing the timespan the change represents
   */
  timespanSuffix: string | null;
  /**
   * Which direction the statistic moved over the timespan
   */
  direction: DeltaDirection;
  /**
   * How much a statistic changed percentage wise over the timespan, formatted with a % sign
   */
  percentChange: string;
}

export interface GetSMSDashboard_inboxDashboard_stats {
  __typename: "Stat";
  /**
   * Details about how a statistic has changed in a given timespan, and by how
   * much. If there is no data for the timespan preceeding this one, returns null.
   */
  delta: GetSMSDashboard_inboxDashboard_stats_delta | null;
  /**
   * The name of the quantity the statistics represent
   */
  name: string;
  /**
   * The current value of the statistic formatted as a human-readable number
   */
  formattedValue: string;
}

export interface GetSMSDashboard_inboxDashboard {
  __typename: "InboxDashboard";
  /**
   * The list of key stats and how they’ve changed over the timespan.
   */
  stats: GetSMSDashboard_inboxDashboard_stats[];
}

export interface GetSMSDashboard {
  /**
   * Returns the stats for the Text messaging card
   */
  inboxDashboard: GetSMSDashboard_inboxDashboard;
}

export interface GetSMSDashboardVariables {
  input: DashboardInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SharedEmailAddressAdd
// ====================================================

export interface SharedEmailAddressAdd_sharedEmailAddressAdd_fromAddress_emailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface SharedEmailAddressAdd_sharedEmailAddressAdd_fromAddress_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface SharedEmailAddressAdd_sharedEmailAddressAdd_fromAddress {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: SharedEmailAddressAdd_sharedEmailAddressAdd_fromAddress_emailAddress;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: SharedEmailAddressAdd_sharedEmailAddressAdd_fromAddress_fromDomain | null;
}

export interface SharedEmailAddressAdd_sharedEmailAddressAdd {
  __typename: "SharedEmailAddressAddPayload";
  fromAddress: SharedEmailAddressAdd_sharedEmailAddressAdd_fromAddress;
}

export interface SharedEmailAddressAdd {
  sharedEmailAddressAdd: SharedEmailAddressAdd_sharedEmailAddressAdd;
}

export interface SharedEmailAddressAddVariables {
  input: SharedEmailAddressAddInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MarkThreadAsNotSpam
// ====================================================

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The images in the message
   */
  images: string[];
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_owner_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_owner_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export type MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_owner = MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_owner_User | MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_owner_Team;

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_externalChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_externalChannel_email {
  __typename: "NutEmailAddress";
  address: string;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  sessionId: string | null;
  status: ChannelStatus;
  phone: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_externalChannel_phone | null;
  email: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_externalChannel_email | null;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_nutshellChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_nutshellChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  phone: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_nutshellChannel_phone | null;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_bestEntity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_bestEntity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_bestEntity_Contact_accounts_primary | null;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_bestEntity_Contact_accounts;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
}

export type MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_bestEntity = MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_bestEntity_Lead | MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_bestEntity_Contact | MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_bestEntity_Account;

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_stubEntity {
  __typename: "StubEntity";
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrlPath: string;
  initials: string;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export type MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_assignee = MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_assignee_Team | MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_assignee_User;

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_contacts_primaryEdge_node_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_contacts_primaryEdge_node_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_contacts_primaryEdge_node_accounts_primary | null;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_contacts_primaryEdge_node_accounts;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_contacts_primaryEdge_node;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_contacts_primaryEdge | null;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_accounts_primaryEdge_node;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_accounts_primaryEdge | null;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_stages_edges {
  __typename: "LeadStagesEdge";
  node: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_stages_edges_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_stages_current | null;
  /**
   * A list of edges.
   */
  edges: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_stages_edges[];
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_accounts;
  /**
   * Stageset associated with the given lead
   */
  stageset: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_stageset | null;
  /**
   * Stages for the lead
   */
  stages: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_stages;
  /**
   * The list of tags on this lead
   */
  tags: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads_tags[];
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this thread is open
   */
  isOpen: boolean;
  /**
   * Whether this thread is active
   */
  isActive: boolean;
  /**
   * The effective status of this thread
   */
  effectiveStatus: ThreadStatus;
  threadSummary: string | null;
  /**
   * Whether this thread can be archived
   */
  canArchive: boolean;
  /**
   * Whether this thread can be reopened
   */
  canReopen: boolean;
  /**
   * Whether this thread is assigned to the current user
   */
  isAssignedToCurrentUser: boolean;
  /**
   * The bot status of this thread
   */
  botStatus: ThreadBotStatus;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_displayMessage | null;
  /**
   * The user who created this thread
   */
  creatorUser: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_creatorUser | null;
  /**
   * The time this thread was created
   */
  createdTime: any;
  /**
   * The time this thread is snoozed until
   */
  snoozedUntilTime: any | null;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The user or team assigned to this thread
   */
  owner: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_owner | null;
  /**
   * The external channel this thread is related to
   */
  externalChannel: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_externalChannel;
  /**
   * The internal nutshell channel this thread is related to
   */
  nutshellChannel: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_nutshellChannel;
  /**
   * The best entity associated with this thread
   */
  bestEntity: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_bestEntity | null;
  /**
   * The Shelly entity only if this thread is on the stub Shelly channel
   */
  stubEntity: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_stubEntity | null;
  /**
   * The leads associated with this thread
   */
  relatedLeads: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread_relatedLeads[] | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
  /**
   * Whether this thread has unread messages
   */
  isUnread: boolean;
}

export interface MarkThreadAsNotSpam_threadMarkAsNotSpam {
  __typename: "ThreadMarkAsNotSpamPayload";
  /**
   * The updated thread.
   */
  thread: MarkThreadAsNotSpam_threadMarkAsNotSpam_thread;
}

export interface MarkThreadAsNotSpam {
  /**
   * Mark a thread as not spam. Clears is_spam; closedTime is left alone (user can
   * reopen separately). Does not retroactively create a lead.
   */
  threadMarkAsNotSpam: MarkThreadAsNotSpam_threadMarkAsNotSpam;
}

export interface MarkThreadAsNotSpamVariables {
  input: ThreadMarkAsNotSpamInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MarkThreadAsSpam
// ====================================================

export interface MarkThreadAsSpam_threadMarkAsSpam_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MarkThreadAsSpam_threadMarkAsSpam {
  __typename: "ThreadMarkAsSpamPayload";
  /**
   * The updated thread.
   */
  thread: MarkThreadAsSpam_threadMarkAsSpam_thread;
}

export interface MarkThreadAsSpam {
  /**
   * Mark a thread as spam. Sets is_spam=1 and closes the thread if not already closed. Does not touch leads.
   */
  threadMarkAsSpam: MarkThreadAsSpam_threadMarkAsSpam;
}

export interface MarkThreadAsSpamVariables {
  input: ThreadMarkAsSpamInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SharedEmailAddressRemove
// ====================================================

export interface SharedEmailAddressRemove_sharedEmailAddressRemove_fromAddress_emailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface SharedEmailAddressRemove_sharedEmailAddressRemove_fromAddress_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface SharedEmailAddressRemove_sharedEmailAddressRemove_fromAddress {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: SharedEmailAddressRemove_sharedEmailAddressRemove_fromAddress_emailAddress;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: SharedEmailAddressRemove_sharedEmailAddressRemove_fromAddress_fromDomain | null;
}

export interface SharedEmailAddressRemove_sharedEmailAddressRemove {
  __typename: "SharedEmailAddressRemovePayload";
  fromAddress: SharedEmailAddressRemove_sharedEmailAddressRemove_fromAddress;
}

export interface SharedEmailAddressRemove {
  sharedEmailAddressRemove: SharedEmailAddressRemove_sharedEmailAddressRemove;
}

export interface SharedEmailAddressRemoveVariables {
  input: SharedEmailAddressRemoveInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendSharedInboxVerificationEmail
// ====================================================

export interface SendSharedInboxVerificationEmail_sharedInboxVerificationEmailSend {
  __typename: "SharedInboxVerificationEmailSendPayload";
  success: boolean;
  errorMessage: string | null;
}

export interface SendSharedInboxVerificationEmail {
  /**
   * Sends a verification email to confirm forwarding is set up to the shared inbox.
   */
  sharedInboxVerificationEmailSend: SendSharedInboxVerificationEmail_sharedInboxVerificationEmailSend;
}

export interface SendSharedInboxVerificationEmailVariables {
  input: SharedInboxVerificationEmailSendInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateInboundEmailRules
// ====================================================

export interface UpdateInboundEmailRules_inboundEmailRulesUpdate_assignment_assignedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateInboundEmailRules_inboundEmailRulesUpdate_assignment {
  __typename: "InboundRulesAssignment";
  strategy: ChatAssignmentStrategyEnum;
  /**
   * The user to assign inbound SMS thread to.
   */
  assignedUser: UpdateInboundEmailRules_inboundEmailRulesUpdate_assignment_assignedUser | null;
}

export interface UpdateInboundEmailRules_inboundEmailRulesUpdate_leadCreation_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface UpdateInboundEmailRules_inboundEmailRulesUpdate_leadCreation_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateInboundEmailRules_inboundEmailRulesUpdate_leadCreation {
  __typename: "InboundRulesLeadCreation";
  /**
   * Whether lead creation is enabled.
   */
  enabled: boolean;
  /**
   * The stageset to use for lead creation.
   */
  stageset: UpdateInboundEmailRules_inboundEmailRulesUpdate_leadCreation_stageset | null;
  /**
   * The tags to apply to the lead.
   */
  tags: UpdateInboundEmailRules_inboundEmailRulesUpdate_leadCreation_tags[] | null;
}

export interface UpdateInboundEmailRules_inboundEmailRulesUpdate_contactCreation_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateInboundEmailRules_inboundEmailRulesUpdate_contactCreation_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface UpdateInboundEmailRules_inboundEmailRulesUpdate_contactCreation {
  __typename: "InboundEmailRulesContactCreation";
  enabled: boolean;
  tags: UpdateInboundEmailRules_inboundEmailRulesUpdate_contactCreation_tags[];
  audiences: UpdateInboundEmailRules_inboundEmailRulesUpdate_contactCreation_audiences[];
}

export interface UpdateInboundEmailRules_inboundEmailRulesUpdate_spamFilter {
  __typename: "InboundEmailRulesSpamFilter";
  /**
   * Whether spam filtering is enabled.
   */
  isEnabled: boolean;
  /**
   * Sender addresses or wildcard patterns (e.g. *@trusted.com) that bypass the spam check.
   */
  senderAllowlist: string[];
  /**
   * Sender addresses or wildcard patterns that are always classified as spam.
   */
  senderDenylist: string[];
  /**
   * Number of inbound email threads classified as spam in the last 30 days.
   */
  spamFilteredCount: number;
}

export interface UpdateInboundEmailRules_inboundEmailRulesUpdate {
  __typename: "InboundEmailRules";
  /**
   * The assignment rule for inbound Email.
   */
  assignment: UpdateInboundEmailRules_inboundEmailRulesUpdate_assignment;
  /**
   * The lead creation rule for inbound Email.
   */
  leadCreation: UpdateInboundEmailRules_inboundEmailRulesUpdate_leadCreation;
  contactCreation: UpdateInboundEmailRules_inboundEmailRulesUpdate_contactCreation;
  /**
   * The spam filter rule for inbound Email.
   */
  spamFilter: UpdateInboundEmailRules_inboundEmailRulesUpdate_spamFilter;
}

export interface UpdateInboundEmailRules {
  /**
   * Updates the inbound Email rules for an email.
   */
  inboundEmailRulesUpdate: UpdateInboundEmailRules_inboundEmailRulesUpdate | null;
}

export interface UpdateInboundEmailRulesVariables {
  input: InboundEmailRulesUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SharedEmailAddressUpdate
// ====================================================

export interface SharedEmailAddressUpdate_sharedEmailAddressUpdate_fromAddress_emailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface SharedEmailAddressUpdate_sharedEmailAddressUpdate_fromAddress_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface SharedEmailAddressUpdate_sharedEmailAddressUpdate_fromAddress {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: SharedEmailAddressUpdate_sharedEmailAddressUpdate_fromAddress_emailAddress;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: SharedEmailAddressUpdate_sharedEmailAddressUpdate_fromAddress_fromDomain | null;
}

export interface SharedEmailAddressUpdate_sharedEmailAddressUpdate {
  __typename: "SharedEmailAddressUpdatePayload";
  fromAddress: SharedEmailAddressUpdate_sharedEmailAddressUpdate_fromAddress;
}

export interface SharedEmailAddressUpdate {
  /**
   * Update the display name of a shared email address
   */
  sharedEmailAddressUpdate: SharedEmailAddressUpdate_sharedEmailAddressUpdate;
}

export interface SharedEmailAddressUpdateVariables {
  input: SharedEmailAddressUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetInboundEmailRules
// ====================================================

export interface GetInboundEmailRules_inboundEmailRules_assignment_assignedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetInboundEmailRules_inboundEmailRules_assignment {
  __typename: "InboundRulesAssignment";
  strategy: ChatAssignmentStrategyEnum;
  /**
   * The user to assign inbound SMS thread to.
   */
  assignedUser: GetInboundEmailRules_inboundEmailRules_assignment_assignedUser | null;
}

export interface GetInboundEmailRules_inboundEmailRules_leadCreation_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetInboundEmailRules_inboundEmailRules_leadCreation_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetInboundEmailRules_inboundEmailRules_leadCreation {
  __typename: "InboundRulesLeadCreation";
  /**
   * Whether lead creation is enabled.
   */
  enabled: boolean;
  /**
   * The stageset to use for lead creation.
   */
  stageset: GetInboundEmailRules_inboundEmailRules_leadCreation_stageset | null;
  /**
   * The tags to apply to the lead.
   */
  tags: GetInboundEmailRules_inboundEmailRules_leadCreation_tags[] | null;
}

export interface GetInboundEmailRules_inboundEmailRules_contactCreation_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetInboundEmailRules_inboundEmailRules_contactCreation_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetInboundEmailRules_inboundEmailRules_contactCreation {
  __typename: "InboundEmailRulesContactCreation";
  enabled: boolean;
  tags: GetInboundEmailRules_inboundEmailRules_contactCreation_tags[];
  audiences: GetInboundEmailRules_inboundEmailRules_contactCreation_audiences[];
}

export interface GetInboundEmailRules_inboundEmailRules_spamFilter {
  __typename: "InboundEmailRulesSpamFilter";
  /**
   * Whether spam filtering is enabled.
   */
  isEnabled: boolean;
  /**
   * Sender addresses or wildcard patterns (e.g. *@trusted.com) that bypass the spam check.
   */
  senderAllowlist: string[];
  /**
   * Sender addresses or wildcard patterns that are always classified as spam.
   */
  senderDenylist: string[];
  /**
   * Number of inbound email threads classified as spam in the last 30 days.
   */
  spamFilteredCount: number;
}

export interface GetInboundEmailRules_inboundEmailRules {
  __typename: "InboundEmailRules";
  /**
   * The assignment rule for inbound Email.
   */
  assignment: GetInboundEmailRules_inboundEmailRules_assignment;
  /**
   * The lead creation rule for inbound Email.
   */
  leadCreation: GetInboundEmailRules_inboundEmailRules_leadCreation;
  contactCreation: GetInboundEmailRules_inboundEmailRules_contactCreation;
  /**
   * The spam filter rule for inbound Email.
   */
  spamFilter: GetInboundEmailRules_inboundEmailRules_spamFilter;
}

export interface GetInboundEmailRules {
  /**
   * The rules for inbound Email.
   */
  inboundEmailRules: GetInboundEmailRules_inboundEmailRules;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSharedInboxConfig
// ====================================================

export interface GetSharedInboxConfig_sharedInboxConfig_nutshellAddress_email {
  __typename: "NutEmailAddress";
  address: string;
}

export interface GetSharedInboxConfig_sharedInboxConfig_nutshellAddress {
  __typename: "SharedInboxInboundAddress";
  email: GetSharedInboxConfig_sharedInboxConfig_nutshellAddress_email;
}

export interface GetSharedInboxConfig_sharedInboxConfig_sharedAddresses_emailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface GetSharedInboxConfig_sharedInboxConfig_sharedAddresses_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface GetSharedInboxConfig_sharedInboxConfig_sharedAddresses {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: GetSharedInboxConfig_sharedInboxConfig_sharedAddresses_emailAddress;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: GetSharedInboxConfig_sharedInboxConfig_sharedAddresses_fromDomain | null;
  /**
   * The DateTime when email forwarding was last verified for this shared inbox address.
   */
  forwardingVerifiedTime: any | null;
}

export interface GetSharedInboxConfig_sharedInboxConfig {
  __typename: "SharedEmailInboxConfig";
  nutshellAddress: GetSharedInboxConfig_sharedInboxConfig_nutshellAddress;
  sharedAddresses: GetSharedInboxConfig_sharedInboxConfig_sharedAddresses[];
}

export interface GetSharedInboxConfig {
  /**
   * The config for the shared email inbox.
   */
  sharedInboxConfig: GetSharedInboxConfig_sharedInboxConfig;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteAllFacebookInstagramData
// ====================================================

export interface DeleteAllFacebookInstagramData {
  /**
   * Deletes all Facebook and Instagram data from Nutshell.
   */
  deleteAllFacebookInstagramData: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendMessage
// ====================================================

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The images in the message
   */
  images: string[];
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_owner_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_owner_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export type SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_owner = SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_owner_User | SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_owner_Team;

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_externalChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_externalChannel_email {
  __typename: "NutEmailAddress";
  address: string;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  sessionId: string | null;
  status: ChannelStatus;
  phone: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_externalChannel_phone | null;
  email: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_externalChannel_email | null;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_nutshellChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_nutshellChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  phone: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_nutshellChannel_phone | null;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts_primary | null;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
}

export type SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_bestEntity = SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_bestEntity_Lead | SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_bestEntity_Contact | SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_bestEntity_Account;

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_stubEntity {
  __typename: "StubEntity";
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrlPath: string;
  initials: string;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export type SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee = SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_Team | SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_User;

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary | null;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge | null;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge_node;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge | null;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges {
  __typename: "LeadStagesEdge";
  node: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_current | null;
  /**
   * A list of edges.
   */
  edges: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges[];
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts;
  /**
   * Stageset associated with the given lead
   */
  stageset: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_stageset | null;
  /**
   * Stages for the lead
   */
  stages: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages;
  /**
   * The list of tags on this lead
   */
  tags: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_tags[];
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads_latestThread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this thread is open
   */
  isOpen: boolean;
  /**
   * Whether this thread is active
   */
  isActive: boolean;
  /**
   * The effective status of this thread
   */
  effectiveStatus: ThreadStatus;
  threadSummary: string | null;
  /**
   * Whether this thread can be archived
   */
  canArchive: boolean;
  /**
   * Whether this thread can be reopened
   */
  canReopen: boolean;
  /**
   * Whether this thread is assigned to the current user
   */
  isAssignedToCurrentUser: boolean;
  /**
   * The bot status of this thread
   */
  botStatus: ThreadBotStatus;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_displayMessage | null;
  /**
   * The user who created this thread
   */
  creatorUser: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_creatorUser | null;
  /**
   * The time this thread was created
   */
  createdTime: any;
  /**
   * The time this thread is snoozed until
   */
  snoozedUntilTime: any | null;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The user or team assigned to this thread
   */
  owner: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_owner | null;
  /**
   * The external channel this thread is related to
   */
  externalChannel: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_externalChannel;
  /**
   * The internal nutshell channel this thread is related to
   */
  nutshellChannel: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_nutshellChannel;
  /**
   * The best entity associated with this thread
   */
  bestEntity: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_bestEntity | null;
  /**
   * The Shelly entity only if this thread is on the stub Shelly channel
   */
  stubEntity: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_stubEntity | null;
  /**
   * The leads associated with this thread
   */
  relatedLeads: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread_relatedLeads[] | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
  /**
   * Whether this thread has unread messages
   */
  isUnread: boolean;
}

export interface SendMessage_messageSend_message_thread_externalChannel_threads {
  __typename: "InboxChannelThreadsConnection";
  /**
   * The latest thread (open or closed) on this channel
   */
  latestThread: SendMessage_messageSend_message_thread_externalChannel_threads_latestThread | null;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The number of closed threads on this channel.
   */
  closedCount: number;
}

export interface SendMessage_messageSend_message_thread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
  threads: SendMessage_messageSend_message_thread_externalChannel_threads;
}

export interface SendMessage_messageSend_message_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external channel this thread is related to
   */
  externalChannel: SendMessage_messageSend_message_thread_externalChannel;
}

export interface SendMessage_messageSend_message_senderEmailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface SendMessage_messageSend_message_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface SendMessage_messageSend_message_edition_campaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface SendMessage_messageSend_message_edition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The editions of the drip sequence
   */
  editions: SendMessage_messageSend_message_edition_campaign_editions;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SendMessage_messageSend_message_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: SendMessage_messageSend_message_edition_campaign;
  /**
   * The position of the edition in the drip sequence
   */
  position: number;
}

export interface SendMessage_messageSend_message_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  originType: OriginType;
}

export interface SendMessage_messageSend_message_submission_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface SendMessage_messageSend_message_submission_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: SendMessage_messageSend_message_submission_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface SendMessage_messageSend_message_submission_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: SendMessage_messageSend_message_submission_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface SendMessage_messageSend_message_submission_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: SendMessage_messageSend_message_submission_booking_additionalAttendees_emailAddresses;
}

export interface SendMessage_messageSend_message_submission_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The start time of this booking
   */
  startTime: any;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (SendMessage_messageSend_message_submission_booking_additionalAttendees | null)[];
}

export interface SendMessage_messageSend_message_submission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface SendMessage_messageSend_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface SendMessage_messageSend_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export interface SendMessage_messageSend_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface SendMessage_messageSend_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: SendMessage_messageSend_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export type SendMessage_messageSend_message_submission_fields_edges_fieldValue = SendMessage_messageSend_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | SendMessage_messageSend_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle | SendMessage_messageSend_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields;

export interface SendMessage_messageSend_message_submission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: SendMessage_messageSend_message_submission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: SendMessage_messageSend_message_submission_fields_edges_fieldValue | null;
}

export interface SendMessage_messageSend_message_submission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: SendMessage_messageSend_message_submission_fields_edges[];
}

export interface SendMessage_messageSend_message_submission {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The booking associated with this submission (if Scheduler)
   */
  booking: SendMessage_messageSend_message_submission_booking | null;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: SendMessage_messageSend_message_submission_fields;
}

export interface SendMessage_messageSend_message {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: MessageStatus;
  /**
   * The thread this message is part of
   */
  thread: SendMessage_messageSend_message_thread;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  senderEmailAddress: SendMessage_messageSend_message_senderEmailAddress | null;
  /**
   * Whether this message is a Nutshell system response
   */
  isNutshellSystemResponse: boolean;
  /**
   * The user who created this thread
   */
  creatorUser: SendMessage_messageSend_message_creatorUser | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The time the message was read
   */
  readTime: any | null;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The edition of the message
   */
  edition: SendMessage_messageSend_message_edition | null;
  /**
   * Whether this message can be canceled
   */
  isCancelable: boolean;
  /**
   * The reaction to the message
   */
  reaction: string | null;
  /**
   * The reason the message failed to send
   */
  errorReason: ErrorReason | null;
  /**
   * The URL of the media in the message
   */
  mediaUrl: string | null;
  /**
   * The origin of the user who created this thread
   */
  creatorOrigin: SendMessage_messageSend_message_creatorOrigin | null;
  /**
   * The images in the message
   */
  images: string[];
  /**
   * The submission for a form or scheduler booking related to the chatbot goal
   */
  submission: SendMessage_messageSend_message_submission | null;
}

export interface SendMessage_messageSend {
  __typename: "MessageSendPayload";
  message: SendMessage_messageSend_message | null;
}

export interface SendMessage {
  /**
   * Sends a message for one of the Facebook services (Messenger, Instagram, or WhatsApp)
   */
  messageSend: SendMessage_messageSend;
}

export interface SendMessageVariables {
  input: MessageSendInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ToggleFacebookInstagramIsEnabled
// ====================================================

export interface ToggleFacebookInstagramIsEnabled {
  /**
   * Toggle the Facebook and Instagram integrations.
   */
  toggleFacebookInstagramIsEnabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateInboundFacebookRules
// ====================================================

export interface UpdateInboundFacebookRules_inboundFacebookRulesUpdate_assignment_assignedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateInboundFacebookRules_inboundFacebookRulesUpdate_assignment {
  __typename: "InboundRulesAssignment";
  /**
   * The user to assign inbound SMS thread to.
   */
  assignedUser: UpdateInboundFacebookRules_inboundFacebookRulesUpdate_assignment_assignedUser | null;
}

export interface UpdateInboundFacebookRules_inboundFacebookRulesUpdate {
  __typename: "InboundFacebookRules";
  /**
   * The assignment rule for inbound Facebook.
   */
  assignment: UpdateInboundFacebookRules_inboundFacebookRulesUpdate_assignment;
}

export interface UpdateInboundFacebookRules {
  /**
   * Updates the inbound Facebook rules for an sms.
   */
  inboundFacebookRulesUpdate: UpdateInboundFacebookRules_inboundFacebookRulesUpdate | null;
}

export interface UpdateInboundFacebookRulesVariables {
  input: InboundFacebookRulesUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetFacebookIntegration
// ====================================================

export interface GetFacebookIntegration_facebookIntegration_pages {
  __typename: "FacebookPage";
  /**
   * The id of the facebook page
   */
  pageId: string | null;
  /**
   * The name of the facebook page
   */
  name: string | null;
  /**
   * The link to the facebook page
   */
  link: string | null;
}

export interface GetFacebookIntegration_facebookIntegration {
  __typename: "FacebookIntegration";
  /**
   * Whether the user has a facebook auth token in the DB
   */
  hasAuthToken: boolean;
  /**
   * Whether the facebook integration is enabled
   */
  isEnabled: boolean;
  /**
   * The email of the facebook user
   */
  userEmail: string;
  /**
   * The pages the facebook user has authorized with Nutshell
   */
  pages: GetFacebookIntegration_facebookIntegration_pages[];
}

export interface GetFacebookIntegration {
  /**
   * The rules for inbound Facebook.
   */
  facebookIntegration: GetFacebookIntegration_facebookIntegration;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetInboundFacebookRules
// ====================================================

export interface GetInboundFacebookRules_inboundFacebookRules_assignment_assignedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetInboundFacebookRules_inboundFacebookRules_assignment {
  __typename: "InboundRulesAssignment";
  strategy: ChatAssignmentStrategyEnum;
  /**
   * The user to assign inbound SMS thread to.
   */
  assignedUser: GetInboundFacebookRules_inboundFacebookRules_assignment_assignedUser | null;
}

export interface GetInboundFacebookRules_inboundFacebookRules_leadCreation_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetInboundFacebookRules_inboundFacebookRules_leadCreation_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetInboundFacebookRules_inboundFacebookRules_leadCreation {
  __typename: "InboundRulesLeadCreation";
  /**
   * Whether lead creation is enabled.
   */
  enabled: boolean;
  /**
   * The stageset to use for lead creation.
   */
  stageset: GetInboundFacebookRules_inboundFacebookRules_leadCreation_stageset | null;
  /**
   * The tags to apply to the lead.
   */
  tags: GetInboundFacebookRules_inboundFacebookRules_leadCreation_tags[] | null;
}

export interface GetInboundFacebookRules_inboundFacebookRules {
  __typename: "InboundFacebookRules";
  /**
   * The assignment rule for inbound Facebook.
   */
  assignment: GetInboundFacebookRules_inboundFacebookRules_assignment;
  /**
   * The lead creation rule for inbound Facebook.
   */
  leadCreation: GetInboundFacebookRules_inboundFacebookRules_leadCreation;
}

export interface GetInboundFacebookRules {
  /**
   * The rules for inbound Facebook.
   */
  inboundFacebookRules: GetInboundFacebookRules_inboundFacebookRules;
}

export interface GetInboundFacebookRulesVariables {
  threadType: ThreadType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddUserInbox
// ====================================================

export interface AddUserInbox_userInboxAdd_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface AddUserInbox_userInboxAdd {
  __typename: "UserInboxAddPayload";
  /**
   * The user added to the inbox.
   */
  user: AddUserInbox_userInboxAdd_user;
}

export interface AddUserInbox {
  /**
   * Add a user to an inbox
   */
  userInboxAdd: AddUserInbox_userInboxAdd;
}

export interface AddUserInboxVariables {
  input: UserInboxAddInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ArchiveThread
// ====================================================

export interface ArchiveThread_threadArchive_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ArchiveThread_threadArchive {
  __typename: "ThreadArchivePayload";
  /**
   * The archived thread.
   */
  thread: ArchiveThread_threadArchive_thread;
}

export interface ArchiveThread {
  /**
   * Archive a thread.
   */
  threadArchive: ArchiveThread_threadArchive;
}

export interface ArchiveThreadVariables {
  input: ThreadArchiveInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CloseThread
// ====================================================

export interface CloseThread_threadClose_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CloseThread_threadClose {
  __typename: "ThreadClosePayload";
  /**
   * The closed thread.
   */
  thread: CloseThread_threadClose_thread;
}

export interface CloseThread {
  /**
   * Close a thread.
   */
  threadClose: CloseThread_threadClose;
}

export interface CloseThreadVariables {
  input: ThreadCloseInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateContactByThread
// ====================================================

export interface CreateContactByThread_contactCreateByThread_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface CreateContactByThread_contactCreateByThread {
  __typename: "ContactCreateByThreadPayload";
  contact: CreateContactByThread_contactCreateByThread_contact;
}

export interface CreateContactByThread {
  /**
   * Creates or links a contact for a shared email inbox thread.
   */
  contactCreateByThread: CreateContactByThread_contactCreateByThread;
}

export interface CreateContactByThreadVariables {
  input: ContactCreateByThreadInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateLeadByThread
// ====================================================

export interface CreateLeadByThread_leadCreateByThread_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface CreateLeadByThread_leadCreateByThread {
  __typename: "LeadCreateByThreadPayload";
  lead: CreateLeadByThread_leadCreateByThread_lead;
}

export interface CreateLeadByThread {
  leadCreateByThread: CreateLeadByThread_leadCreateByThread;
}

export interface CreateLeadByThreadVariables {
  input: LeadCreateByThreadInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateLead
// ====================================================

export interface CreateLead_leadCreate {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface CreateLead {
  /**
   * Creates a Nutshell lead
   */
  leadCreate: CreateLead_leadCreate;
}

export interface CreateLeadVariables {
  input: LeadCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MarkThreadAsRead
// ====================================================

export interface MarkThreadAsRead_markThreadAsRead {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this thread has unread messages
   */
  isUnread: boolean;
}

export interface MarkThreadAsRead {
  /**
   * Marks all messages in a thread as read when the thread is opened
   */
  markThreadAsRead: MarkThreadAsRead_markThreadAsRead;
}

export interface MarkThreadAsReadVariables {
  threadId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ReassignThread
// ====================================================

export interface ReassignThread_threadReassign_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ReassignThread_threadReassign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface ReassignThread_threadReassign {
  __typename: "ThreadReassignPayload";
  /**
   * The thread that was assigned.
   */
  thread: ReassignThread_threadReassign_thread;
  /**
   * The user that the thread was assigned to.
   */
  owner: ReassignThread_threadReassign_owner | null;
}

export interface ReassignThread {
  /**
   * Assign or reassign a thread to another user.
   */
  threadReassign: ReassignThread_threadReassign;
}

export interface ReassignThreadVariables {
  input: ThreadReassignInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveUserInbox
// ====================================================

export interface RemoveUserInbox_userInboxRemove_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface RemoveUserInbox_userInboxRemove {
  __typename: "UserInboxRemovePayload";
  /**
   * The user removed from the inbox.
   */
  user: RemoveUserInbox_userInboxRemove_user;
}

export interface RemoveUserInbox {
  /**
   * Remove a user's inbox
   */
  userInboxRemove: RemoveUserInbox_userInboxRemove;
}

export interface RemoveUserInboxVariables {
  input: UserInboxRemoveInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ReopenThread
// ====================================================

export interface ReopenThread_threadReopen_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ReopenThread_threadReopen {
  __typename: "ThreadReopenPayload";
  /**
   * The reopened thread.
   */
  thread: ReopenThread_threadReopen_thread;
}

export interface ReopenThread {
  /**
   * Reopen a thread.
   */
  threadReopen: ReopenThread_threadReopen;
}

export interface ReopenThreadVariables {
  input: ThreadReopenInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendChatMessage
// ====================================================

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The images in the message
   */
  images: string[];
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_owner_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_owner_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export type SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_owner = SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_owner_User | SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_owner_Team;

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_externalChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_externalChannel_email {
  __typename: "NutEmailAddress";
  address: string;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  sessionId: string | null;
  status: ChannelStatus;
  phone: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_externalChannel_phone | null;
  email: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_externalChannel_email | null;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_nutshellChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_nutshellChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  phone: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_nutshellChannel_phone | null;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts_primary | null;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
}

export type SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_bestEntity = SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_bestEntity_Lead | SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_bestEntity_Contact | SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_bestEntity_Account;

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_stubEntity {
  __typename: "StubEntity";
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrlPath: string;
  initials: string;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export type SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee = SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_Team | SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_User;

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary | null;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge | null;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge_node;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge | null;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges {
  __typename: "LeadStagesEdge";
  node: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_current | null;
  /**
   * A list of edges.
   */
  edges: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges[];
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts;
  /**
   * Stageset associated with the given lead
   */
  stageset: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_stageset | null;
  /**
   * Stages for the lead
   */
  stages: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_stages;
  /**
   * The list of tags on this lead
   */
  tags: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads_tags[];
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this thread is open
   */
  isOpen: boolean;
  /**
   * Whether this thread is active
   */
  isActive: boolean;
  /**
   * The effective status of this thread
   */
  effectiveStatus: ThreadStatus;
  threadSummary: string | null;
  /**
   * Whether this thread can be archived
   */
  canArchive: boolean;
  /**
   * Whether this thread can be reopened
   */
  canReopen: boolean;
  /**
   * Whether this thread is assigned to the current user
   */
  isAssignedToCurrentUser: boolean;
  /**
   * The bot status of this thread
   */
  botStatus: ThreadBotStatus;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_displayMessage | null;
  /**
   * The user who created this thread
   */
  creatorUser: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_creatorUser | null;
  /**
   * The time this thread was created
   */
  createdTime: any;
  /**
   * The time this thread is snoozed until
   */
  snoozedUntilTime: any | null;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The user or team assigned to this thread
   */
  owner: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_owner | null;
  /**
   * The external channel this thread is related to
   */
  externalChannel: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_externalChannel;
  /**
   * The internal nutshell channel this thread is related to
   */
  nutshellChannel: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_nutshellChannel;
  /**
   * The best entity associated with this thread
   */
  bestEntity: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_bestEntity | null;
  /**
   * The Shelly entity only if this thread is on the stub Shelly channel
   */
  stubEntity: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_stubEntity | null;
  /**
   * The leads associated with this thread
   */
  relatedLeads: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread_relatedLeads[] | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
  /**
   * Whether this thread has unread messages
   */
  isUnread: boolean;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel_threads {
  __typename: "InboxChannelThreadsConnection";
  /**
   * The latest thread (open or closed) on this channel
   */
  latestThread: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads_latestThread | null;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The number of closed threads on this channel.
   */
  closedCount: number;
}

export interface SendChatMessage_messageSendForChat_message_thread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
  threads: SendChatMessage_messageSendForChat_message_thread_externalChannel_threads;
}

export interface SendChatMessage_messageSendForChat_message_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external channel this thread is related to
   */
  externalChannel: SendChatMessage_messageSendForChat_message_thread_externalChannel;
}

export interface SendChatMessage_messageSendForChat_message_senderEmailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface SendChatMessage_messageSendForChat_message_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface SendChatMessage_messageSendForChat_message_edition_campaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface SendChatMessage_messageSendForChat_message_edition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The editions of the drip sequence
   */
  editions: SendChatMessage_messageSendForChat_message_edition_campaign_editions;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SendChatMessage_messageSendForChat_message_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: SendChatMessage_messageSendForChat_message_edition_campaign;
  /**
   * The position of the edition in the drip sequence
   */
  position: number;
}

export interface SendChatMessage_messageSendForChat_message_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  originType: OriginType;
}

export interface SendChatMessage_messageSendForChat_message_submission_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface SendChatMessage_messageSendForChat_message_submission_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: SendChatMessage_messageSendForChat_message_submission_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface SendChatMessage_messageSendForChat_message_submission_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: SendChatMessage_messageSendForChat_message_submission_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface SendChatMessage_messageSendForChat_message_submission_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: SendChatMessage_messageSendForChat_message_submission_booking_additionalAttendees_emailAddresses;
}

export interface SendChatMessage_messageSendForChat_message_submission_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The start time of this booking
   */
  startTime: any;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (SendChatMessage_messageSendForChat_message_submission_booking_additionalAttendees | null)[];
}

export interface SendChatMessage_messageSendForChat_message_submission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface SendChatMessage_messageSendForChat_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface SendChatMessage_messageSendForChat_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export interface SendChatMessage_messageSendForChat_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface SendChatMessage_messageSendForChat_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: SendChatMessage_messageSendForChat_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export type SendChatMessage_messageSendForChat_message_submission_fields_edges_fieldValue = SendChatMessage_messageSendForChat_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | SendChatMessage_messageSendForChat_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle | SendChatMessage_messageSendForChat_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields;

export interface SendChatMessage_messageSendForChat_message_submission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: SendChatMessage_messageSendForChat_message_submission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: SendChatMessage_messageSendForChat_message_submission_fields_edges_fieldValue | null;
}

export interface SendChatMessage_messageSendForChat_message_submission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: SendChatMessage_messageSendForChat_message_submission_fields_edges[];
}

export interface SendChatMessage_messageSendForChat_message_submission {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The booking associated with this submission (if Scheduler)
   */
  booking: SendChatMessage_messageSendForChat_message_submission_booking | null;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: SendChatMessage_messageSendForChat_message_submission_fields;
}

export interface SendChatMessage_messageSendForChat_message {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: MessageStatus;
  /**
   * The thread this message is part of
   */
  thread: SendChatMessage_messageSendForChat_message_thread;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  senderEmailAddress: SendChatMessage_messageSendForChat_message_senderEmailAddress | null;
  /**
   * Whether this message is a Nutshell system response
   */
  isNutshellSystemResponse: boolean;
  /**
   * The user who created this thread
   */
  creatorUser: SendChatMessage_messageSendForChat_message_creatorUser | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The time the message was read
   */
  readTime: any | null;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The edition of the message
   */
  edition: SendChatMessage_messageSendForChat_message_edition | null;
  /**
   * Whether this message can be canceled
   */
  isCancelable: boolean;
  /**
   * The reaction to the message
   */
  reaction: string | null;
  /**
   * The reason the message failed to send
   */
  errorReason: ErrorReason | null;
  /**
   * The URL of the media in the message
   */
  mediaUrl: string | null;
  /**
   * The origin of the user who created this thread
   */
  creatorOrigin: SendChatMessage_messageSendForChat_message_creatorOrigin | null;
  /**
   * The images in the message
   */
  images: string[];
  /**
   * The submission for a form or scheduler booking related to the chatbot goal
   */
  submission: SendChatMessage_messageSendForChat_message_submission | null;
}

export interface SendChatMessage_messageSendForChat {
  __typename: "MessageSendForChatPayload";
  message: SendChatMessage_messageSendForChat_message | null;
}

export interface SendChatMessage {
  /**
   * Sends a chat message using Nutshell Inbox
   */
  messageSendForChat: SendChatMessage_messageSendForChat;
}

export interface SendChatMessageVariables {
  input: MessageSendForChatInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendSharedInboxEmailMessage
// ====================================================

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The images in the message
   */
  images: string[];
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_owner_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_owner_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export type SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_owner = SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_owner_User | SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_owner_Team;

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_externalChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_externalChannel_email {
  __typename: "NutEmailAddress";
  address: string;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  sessionId: string | null;
  status: ChannelStatus;
  phone: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_externalChannel_phone | null;
  email: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_externalChannel_email | null;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_nutshellChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_nutshellChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  phone: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_nutshellChannel_phone | null;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts_primary | null;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
}

export type SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_bestEntity = SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_bestEntity_Lead | SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_bestEntity_Contact | SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_bestEntity_Account;

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_stubEntity {
  __typename: "StubEntity";
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrlPath: string;
  initials: string;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export type SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee = SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_Team | SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_User;

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary | null;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge | null;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge_node;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge | null;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges {
  __typename: "LeadStagesEdge";
  node: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_current | null;
  /**
   * A list of edges.
   */
  edges: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges[];
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts;
  /**
   * Stageset associated with the given lead
   */
  stageset: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_stageset | null;
  /**
   * Stages for the lead
   */
  stages: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_stages;
  /**
   * The list of tags on this lead
   */
  tags: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads_tags[];
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this thread is open
   */
  isOpen: boolean;
  /**
   * Whether this thread is active
   */
  isActive: boolean;
  /**
   * The effective status of this thread
   */
  effectiveStatus: ThreadStatus;
  threadSummary: string | null;
  /**
   * Whether this thread can be archived
   */
  canArchive: boolean;
  /**
   * Whether this thread can be reopened
   */
  canReopen: boolean;
  /**
   * Whether this thread is assigned to the current user
   */
  isAssignedToCurrentUser: boolean;
  /**
   * The bot status of this thread
   */
  botStatus: ThreadBotStatus;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_displayMessage | null;
  /**
   * The user who created this thread
   */
  creatorUser: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_creatorUser | null;
  /**
   * The time this thread was created
   */
  createdTime: any;
  /**
   * The time this thread is snoozed until
   */
  snoozedUntilTime: any | null;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The user or team assigned to this thread
   */
  owner: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_owner | null;
  /**
   * The external channel this thread is related to
   */
  externalChannel: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_externalChannel;
  /**
   * The internal nutshell channel this thread is related to
   */
  nutshellChannel: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_nutshellChannel;
  /**
   * The best entity associated with this thread
   */
  bestEntity: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_bestEntity | null;
  /**
   * The Shelly entity only if this thread is on the stub Shelly channel
   */
  stubEntity: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_stubEntity | null;
  /**
   * The leads associated with this thread
   */
  relatedLeads: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread_relatedLeads[] | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
  /**
   * Whether this thread has unread messages
   */
  isUnread: boolean;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads {
  __typename: "InboxChannelThreadsConnection";
  /**
   * The latest thread (open or closed) on this channel
   */
  latestThread: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads_latestThread | null;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The number of closed threads on this channel.
   */
  closedCount: number;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
  threads: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel_threads;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external channel this thread is related to
   */
  externalChannel: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread_externalChannel;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_senderEmailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_edition_campaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_edition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The editions of the drip sequence
   */
  editions: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_edition_campaign_editions;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_edition_campaign;
  /**
   * The position of the edition in the drip sequence
   */
  position: number;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  originType: OriginType;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_booking_additionalAttendees_emailAddresses;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The start time of this booking
   */
  startTime: any;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_booking_additionalAttendees | null)[];
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export type SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_fields_edges_fieldValue = SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle | SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields;

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_fields_edges_fieldValue | null;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_fields_edges[];
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The booking associated with this submission (if Scheduler)
   */
  booking: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_booking | null;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission_fields;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox_message {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: MessageStatus;
  /**
   * The thread this message is part of
   */
  thread: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_thread;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  senderEmailAddress: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_senderEmailAddress | null;
  /**
   * Whether this message is a Nutshell system response
   */
  isNutshellSystemResponse: boolean;
  /**
   * The user who created this thread
   */
  creatorUser: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_creatorUser | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The time the message was read
   */
  readTime: any | null;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The edition of the message
   */
  edition: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_edition | null;
  /**
   * Whether this message can be canceled
   */
  isCancelable: boolean;
  /**
   * The reaction to the message
   */
  reaction: string | null;
  /**
   * The reason the message failed to send
   */
  errorReason: ErrorReason | null;
  /**
   * The URL of the media in the message
   */
  mediaUrl: string | null;
  /**
   * The origin of the user who created this thread
   */
  creatorOrigin: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_creatorOrigin | null;
  /**
   * The images in the message
   */
  images: string[];
  /**
   * The submission for a form or scheduler booking related to the chatbot goal
   */
  submission: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message_submission | null;
}

export interface SendSharedInboxEmailMessage_messageSendFromSharedInbox {
  __typename: "MessageSendFromSharedInboxPayload";
  /**
   * The newly created inbox message.
   */
  message: SendSharedInboxEmailMessage_messageSendFromSharedInbox_message;
}

export interface SendSharedInboxEmailMessage {
  /**
   * Sends an email reply from a shared inbox thread.
   */
  messageSendFromSharedInbox: SendSharedInboxEmailMessage_messageSendFromSharedInbox;
}

export interface SendSharedInboxEmailMessageVariables {
  input: MessageSendFromSharedInboxInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SnoozeThread
// ====================================================

export interface SnoozeThread_threadSnooze_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SnoozeThread_threadSnooze {
  __typename: "ThreadSnoozePayload";
  /**
   * The snoozed thread.
   */
  thread: SnoozeThread_threadSnooze_thread;
}

export interface SnoozeThread {
  /**
   * Snooze a thread.
   */
  threadSnooze: SnoozeThread_threadSnooze;
}

export interface SnoozeThreadVariables {
  input: ThreadSnoozeInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateContactName
// ====================================================

export interface UpdateContactName_contactUpdate_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateContactName_contactUpdate {
  __typename: "ContactUpdatePayload";
  /**
   * The updated Nutshell contact.
   */
  contact: UpdateContactName_contactUpdate_contact;
}

export interface UpdateContactName {
  /**
   * Updates a Nutshell contact.
   */
  contactUpdate: UpdateContactName_contactUpdate;
}

export interface UpdateContactNameVariables {
  input: ContactUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getChannelActiveStatuses
// ====================================================

export interface getChannelActiveStatuses {
  /**
   * Takes in a list of channel ids and returns a list of booleans indicating whether each channel is active
   */
  channelActiveStatuses: boolean[];
}

export interface getChannelActiveStatusesVariables {
  channelIds: string[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetChannelEvents
// ====================================================

export interface GetChannelEvents_channelEvents_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
}

export interface GetChannelEvents_channelEvents_edges_node_changes {
  __typename: "ChangeLogChange";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attrbute changed by the entry
   */
  attribute: string;
  /**
   * The old value before the change
   */
  oldValue: string | null;
  /**
   * The new value after the change
   */
  newValue: string | null;
}

export interface GetChannelEvents_channelEvents_edges_node_actor_Account {
  __typename: "Account" | "Form" | "MaUrl";
}

export interface GetChannelEvents_channelEvents_edges_node_actor_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetChannelEvents_channelEvents_edges_node_actor_Contact {
  __typename: "Contact";
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetChannelEvents_channelEvents_edges_node_actor_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type GetChannelEvents_channelEvents_edges_node_actor = GetChannelEvents_channelEvents_edges_node_actor_Account | GetChannelEvents_channelEvents_edges_node_actor_User | GetChannelEvents_channelEvents_edges_node_actor_Contact | GetChannelEvents_channelEvents_edges_node_actor_Origin;

export interface GetChannelEvents_channelEvents_edges_node_payload_Activity {
  __typename: "Activity" | "Email" | "EmailQueued" | "EmailInteraction" | "Origin" | "Submission" | "Account" | "Contact" | "Lead" | "ConstantContactContactTrackingActivity" | "Comment" | "TimelineEventPayloadUnknownType" | "Chat" | "EntityAttributeValueFile" | "Session" | "AccountRelationshipChange" | "Quote" | "DocumentView" | "Invoice" | "Contract" | "LeadClonePayload" | "AccountContactFormerStatusChange";
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Assignment_assignmentEntity_Account {
  __typename: "Account" | "Activity" | "Contact" | "Lead" | "UnknownEntityType";
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Assignment_assignmentEntity_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type GetChannelEvents_channelEvents_edges_node_payload_Assignment_assignmentEntity = GetChannelEvents_channelEvents_edges_node_payload_Assignment_assignmentEntity_Account | GetChannelEvents_channelEvents_edges_node_payload_Assignment_assignmentEntity_Thread;

export interface GetChannelEvents_channelEvents_edges_node_payload_Assignment_assigneeEntity {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Assignment {
  __typename: "Assignment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity that was assigned
   */
  assignmentEntity: GetChannelEvents_channelEvents_edges_node_payload_Assignment_assignmentEntity;
  /**
   * The entity to which the assignment was made
   */
  assigneeEntity: GetChannelEvents_channelEvents_edges_node_payload_Assignment_assigneeEntity;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Thread_recipientEmailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Thread_startedFromUrl {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https:      // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
  /**
   * The `/features` part of https: // www.nutshell.com/features?utm_source=Google
   */
  path: string | null;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The time this thread was created
   */
  createdTime: any;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
  /**
   * The shared inbox address this email thread was delivered to
   */
  recipientEmailAddress: GetChannelEvents_channelEvents_edges_node_payload_Thread_recipientEmailAddress | null;
  /**
   * The URL that this thread was started from
   */
  startedFromUrl: GetChannelEvents_channelEvents_edges_node_payload_Thread_startedFromUrl | null;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The images in the message
   */
  images: string[];
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_owner_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_owner_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export type GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_owner = GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_owner_User | GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_owner_Team;

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_externalChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_externalChannel_email {
  __typename: "NutEmailAddress";
  address: string;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  sessionId: string | null;
  status: ChannelStatus;
  phone: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_externalChannel_phone | null;
  email: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_externalChannel_email | null;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_nutshellChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_nutshellChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  phone: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_nutshellChannel_phone | null;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts_primary | null;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
}

export type GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity = GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Lead | GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Contact | GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Account;

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_stubEntity {
  __typename: "StubEntity";
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrlPath: string;
  initials: string;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export type GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_assignee = GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_Team | GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_User;

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary | null;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge | null;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge_node;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge | null;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges {
  __typename: "LeadStagesEdge";
  node: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages_current | null;
  /**
   * A list of edges.
   */
  edges: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges[];
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_accounts;
  /**
   * Stageset associated with the given lead
   */
  stageset: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stageset | null;
  /**
   * Stages for the lead
   */
  stages: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages;
  /**
   * The list of tags on this lead
   */
  tags: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_tags[];
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this thread is open
   */
  isOpen: boolean;
  /**
   * Whether this thread is active
   */
  isActive: boolean;
  /**
   * The effective status of this thread
   */
  effectiveStatus: ThreadStatus;
  threadSummary: string | null;
  /**
   * Whether this thread can be archived
   */
  canArchive: boolean;
  /**
   * Whether this thread can be reopened
   */
  canReopen: boolean;
  /**
   * Whether this thread is assigned to the current user
   */
  isAssignedToCurrentUser: boolean;
  /**
   * The bot status of this thread
   */
  botStatus: ThreadBotStatus;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_displayMessage | null;
  /**
   * The user who created this thread
   */
  creatorUser: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_creatorUser | null;
  /**
   * The time this thread was created
   */
  createdTime: any;
  /**
   * The time this thread is snoozed until
   */
  snoozedUntilTime: any | null;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The user or team assigned to this thread
   */
  owner: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_owner | null;
  /**
   * The external channel this thread is related to
   */
  externalChannel: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_externalChannel;
  /**
   * The internal nutshell channel this thread is related to
   */
  nutshellChannel: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_nutshellChannel;
  /**
   * The best entity associated with this thread
   */
  bestEntity: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity | null;
  /**
   * The Shelly entity only if this thread is on the stub Shelly channel
   */
  stubEntity: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_stubEntity | null;
  /**
   * The leads associated with this thread
   */
  relatedLeads: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads[] | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
  /**
   * Whether this thread has unread messages
   */
  isUnread: boolean;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads {
  __typename: "InboxChannelThreadsConnection";
  /**
   * The latest thread (open or closed) on this channel
   */
  latestThread: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads_latestThread | null;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The number of closed threads on this channel.
   */
  closedCount: number;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
  threads: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel_threads;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external channel this thread is related to
   */
  externalChannel: GetChannelEvents_channelEvents_edges_node_payload_Message_thread_externalChannel;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_senderEmailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_edition_campaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_edition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The editions of the drip sequence
   */
  editions: GetChannelEvents_channelEvents_edges_node_payload_Message_edition_campaign_editions;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetChannelEvents_channelEvents_edges_node_payload_Message_edition_campaign;
  /**
   * The position of the edition in the drip sequence
   */
  position: number;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  originType: OriginType;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_submission_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_submission_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetChannelEvents_channelEvents_edges_node_payload_Message_submission_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_submission_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetChannelEvents_channelEvents_edges_node_payload_Message_submission_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_submission_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetChannelEvents_channelEvents_edges_node_payload_Message_submission_booking_additionalAttendees_emailAddresses;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_submission_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The start time of this booking
   */
  startTime: any;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (GetChannelEvents_channelEvents_edges_node_payload_Message_submission_booking_additionalAttendees | null)[];
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_submission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: GetChannelEvents_channelEvents_edges_node_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export type GetChannelEvents_channelEvents_edges_node_payload_Message_submission_fields_edges_fieldValue = GetChannelEvents_channelEvents_edges_node_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | GetChannelEvents_channelEvents_edges_node_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle | GetChannelEvents_channelEvents_edges_node_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields;

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_submission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: GetChannelEvents_channelEvents_edges_node_payload_Message_submission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: GetChannelEvents_channelEvents_edges_node_payload_Message_submission_fields_edges_fieldValue | null;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_submission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: GetChannelEvents_channelEvents_edges_node_payload_Message_submission_fields_edges[];
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message_submission {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The booking associated with this submission (if Scheduler)
   */
  booking: GetChannelEvents_channelEvents_edges_node_payload_Message_submission_booking | null;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: GetChannelEvents_channelEvents_edges_node_payload_Message_submission_fields;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Message {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: MessageStatus;
  /**
   * The thread this message is part of
   */
  thread: GetChannelEvents_channelEvents_edges_node_payload_Message_thread;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  senderEmailAddress: GetChannelEvents_channelEvents_edges_node_payload_Message_senderEmailAddress | null;
  /**
   * Whether this message is a Nutshell system response
   */
  isNutshellSystemResponse: boolean;
  /**
   * The user who created this thread
   */
  creatorUser: GetChannelEvents_channelEvents_edges_node_payload_Message_creatorUser | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The time the message was read
   */
  readTime: any | null;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The edition of the message
   */
  edition: GetChannelEvents_channelEvents_edges_node_payload_Message_edition | null;
  /**
   * Whether this message can be canceled
   */
  isCancelable: boolean;
  /**
   * The reaction to the message
   */
  reaction: string | null;
  /**
   * The reason the message failed to send
   */
  errorReason: ErrorReason | null;
  /**
   * The URL of the media in the message
   */
  mediaUrl: string | null;
  /**
   * The origin of the user who created this thread
   */
  creatorOrigin: GetChannelEvents_channelEvents_edges_node_payload_Message_creatorOrigin | null;
  /**
   * The images in the message
   */
  images: string[];
  /**
   * The submission for a form or scheduler booking related to the chatbot goal
   */
  submission: GetChannelEvents_channelEvents_edges_node_payload_Message_submission | null;
}

export interface GetChannelEvents_channelEvents_edges_node_payload_Note {
  __typename: "Note";
  /**
   * The plain text (i.e., no HTML/rich text, no NutMark for @-mention tokenizing) representation of the Note text
   */
  body: string | null;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export type GetChannelEvents_channelEvents_edges_node_payload = GetChannelEvents_channelEvents_edges_node_payload_Activity | GetChannelEvents_channelEvents_edges_node_payload_Assignment | GetChannelEvents_channelEvents_edges_node_payload_Thread | GetChannelEvents_channelEvents_edges_node_payload_Message | GetChannelEvents_channelEvents_edges_node_payload_Note;

export interface GetChannelEvents_channelEvents_edges_node {
  __typename: "TimelineEvent";
  changeTime: any;
  /**
   * The type of change i.e. created, modified, deleted, etc
   */
  changeType: ChangeType;
  changes: GetChannelEvents_channelEvents_edges_node_changes[];
  /**
   * The entity that triggered the change_log entry
   */
  actor: GetChannelEvents_channelEvents_edges_node_actor;
  payload: GetChannelEvents_channelEvents_edges_node_payload;
}

export interface GetChannelEvents_channelEvents_edges {
  __typename: "ChannelEventsEdge";
  node: GetChannelEvents_channelEvents_edges_node;
}

export interface GetChannelEvents_channelEvents {
  __typename: "ChannelEventsConnection";
  /**
   * Indicates if the user can send messages to the channel/thread
   */
  sendabilityStatus: SendabilityStatus | null;
  /**
   * The last time this channel was seen
   */
  lastSeenTime: any | null;
  /**
   * The channel is activie if the lastSeenTime is within 10 seconds of the current time.
   */
  isActive: boolean;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetChannelEvents_channelEvents_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetChannelEvents_channelEvents_edges[];
}

export interface GetChannelEvents {
  /**
   * Returns events related to a channel
   */
  channelEvents: GetChannelEvents_channelEvents;
}

export interface GetChannelEventsVariables {
  channelId: string;
  threadId?: string | null;
  after?: string | null;
  before?: string | null;
  first?: number | null;
  last?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetInboxMessage
// ====================================================

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The images in the message
   */
  images: string[];
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_owner_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_owner_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export type GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_owner = GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_owner_User | GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_owner_Team;

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_externalChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_externalChannel_email {
  __typename: "NutEmailAddress";
  address: string;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  sessionId: string | null;
  status: ChannelStatus;
  phone: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_externalChannel_phone | null;
  email: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_externalChannel_email | null;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_nutshellChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_nutshellChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  phone: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_nutshellChannel_phone | null;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts_primary | null;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
}

export type GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_bestEntity = GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_bestEntity_Lead | GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_bestEntity_Contact | GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_bestEntity_Account;

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_stubEntity {
  __typename: "StubEntity";
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrlPath: string;
  initials: string;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export type GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_assignee = GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_assignee_Team | GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_assignee_User;

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary | null;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge | null;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge_node;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge | null;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges {
  __typename: "LeadStagesEdge";
  node: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_stages_current | null;
  /**
   * A list of edges.
   */
  edges: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges[];
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_accounts;
  /**
   * Stageset associated with the given lead
   */
  stageset: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_stageset | null;
  /**
   * Stages for the lead
   */
  stages: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_stages;
  /**
   * The list of tags on this lead
   */
  tags: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads_tags[];
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this thread is open
   */
  isOpen: boolean;
  /**
   * Whether this thread is active
   */
  isActive: boolean;
  /**
   * The effective status of this thread
   */
  effectiveStatus: ThreadStatus;
  threadSummary: string | null;
  /**
   * Whether this thread can be archived
   */
  canArchive: boolean;
  /**
   * Whether this thread can be reopened
   */
  canReopen: boolean;
  /**
   * Whether this thread is assigned to the current user
   */
  isAssignedToCurrentUser: boolean;
  /**
   * The bot status of this thread
   */
  botStatus: ThreadBotStatus;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_displayMessage | null;
  /**
   * The user who created this thread
   */
  creatorUser: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_creatorUser | null;
  /**
   * The time this thread was created
   */
  createdTime: any;
  /**
   * The time this thread is snoozed until
   */
  snoozedUntilTime: any | null;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The user or team assigned to this thread
   */
  owner: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_owner | null;
  /**
   * The external channel this thread is related to
   */
  externalChannel: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_externalChannel;
  /**
   * The internal nutshell channel this thread is related to
   */
  nutshellChannel: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_nutshellChannel;
  /**
   * The best entity associated with this thread
   */
  bestEntity: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_bestEntity | null;
  /**
   * The Shelly entity only if this thread is on the stub Shelly channel
   */
  stubEntity: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_stubEntity | null;
  /**
   * The leads associated with this thread
   */
  relatedLeads: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread_relatedLeads[] | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
  /**
   * Whether this thread has unread messages
   */
  isUnread: boolean;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel_threads {
  __typename: "InboxChannelThreadsConnection";
  /**
   * The latest thread (open or closed) on this channel
   */
  latestThread: GetInboxMessage_inboxMessage_thread_externalChannel_threads_latestThread | null;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The number of closed threads on this channel.
   */
  closedCount: number;
}

export interface GetInboxMessage_inboxMessage_thread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
  threads: GetInboxMessage_inboxMessage_thread_externalChannel_threads;
}

export interface GetInboxMessage_inboxMessage_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external channel this thread is related to
   */
  externalChannel: GetInboxMessage_inboxMessage_thread_externalChannel;
}

export interface GetInboxMessage_inboxMessage_senderEmailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface GetInboxMessage_inboxMessage_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface GetInboxMessage_inboxMessage_edition_campaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetInboxMessage_inboxMessage_edition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The editions of the drip sequence
   */
  editions: GetInboxMessage_inboxMessage_edition_campaign_editions;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetInboxMessage_inboxMessage_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetInboxMessage_inboxMessage_edition_campaign;
  /**
   * The position of the edition in the drip sequence
   */
  position: number;
}

export interface GetInboxMessage_inboxMessage_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  originType: OriginType;
}

export interface GetInboxMessage_inboxMessage_submission_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetInboxMessage_inboxMessage_submission_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetInboxMessage_inboxMessage_submission_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface GetInboxMessage_inboxMessage_submission_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetInboxMessage_inboxMessage_submission_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface GetInboxMessage_inboxMessage_submission_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetInboxMessage_inboxMessage_submission_booking_additionalAttendees_emailAddresses;
}

export interface GetInboxMessage_inboxMessage_submission_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The start time of this booking
   */
  startTime: any;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (GetInboxMessage_inboxMessage_submission_booking_additionalAttendees | null)[];
}

export interface GetInboxMessage_inboxMessage_submission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface GetInboxMessage_inboxMessage_submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface GetInboxMessage_inboxMessage_submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export interface GetInboxMessage_inboxMessage_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface GetInboxMessage_inboxMessage_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: GetInboxMessage_inboxMessage_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export type GetInboxMessage_inboxMessage_submission_fields_edges_fieldValue = GetInboxMessage_inboxMessage_submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | GetInboxMessage_inboxMessage_submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle | GetInboxMessage_inboxMessage_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields;

export interface GetInboxMessage_inboxMessage_submission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: GetInboxMessage_inboxMessage_submission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: GetInboxMessage_inboxMessage_submission_fields_edges_fieldValue | null;
}

export interface GetInboxMessage_inboxMessage_submission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: GetInboxMessage_inboxMessage_submission_fields_edges[];
}

export interface GetInboxMessage_inboxMessage_submission {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The booking associated with this submission (if Scheduler)
   */
  booking: GetInboxMessage_inboxMessage_submission_booking | null;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: GetInboxMessage_inboxMessage_submission_fields;
}

export interface GetInboxMessage_inboxMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: MessageStatus;
  /**
   * The thread this message is part of
   */
  thread: GetInboxMessage_inboxMessage_thread;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  senderEmailAddress: GetInboxMessage_inboxMessage_senderEmailAddress | null;
  /**
   * Whether this message is a Nutshell system response
   */
  isNutshellSystemResponse: boolean;
  /**
   * The user who created this thread
   */
  creatorUser: GetInboxMessage_inboxMessage_creatorUser | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The time the message was read
   */
  readTime: any | null;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The edition of the message
   */
  edition: GetInboxMessage_inboxMessage_edition | null;
  /**
   * Whether this message can be canceled
   */
  isCancelable: boolean;
  /**
   * The reaction to the message
   */
  reaction: string | null;
  /**
   * The reason the message failed to send
   */
  errorReason: ErrorReason | null;
  /**
   * The URL of the media in the message
   */
  mediaUrl: string | null;
  /**
   * The origin of the user who created this thread
   */
  creatorOrigin: GetInboxMessage_inboxMessage_creatorOrigin | null;
  /**
   * The images in the message
   */
  images: string[];
  /**
   * The submission for a form or scheduler booking related to the chatbot goal
   */
  submission: GetInboxMessage_inboxMessage_submission | null;
}

export interface GetInboxMessage {
  /**
   * Returns the inbox message
   */
  inboxMessage: GetInboxMessage_inboxMessage;
}

export interface GetInboxMessageVariables {
  messageId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetInboxSidebarCounts
// ====================================================

export interface GetInboxSidebarCounts_inboxThreadCounts_sms_userInboxCounts_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetInboxSidebarCounts_inboxThreadCounts_sms_userInboxCounts {
  __typename: "UserInbox";
  user: GetInboxSidebarCounts_inboxThreadCounts_sms_userInboxCounts_user | null;
  count: number | null;
}

export interface GetInboxSidebarCounts_inboxThreadCounts_sms {
  __typename: "SmsThreadCounts";
  /**
   * The number of unassigned threads
   */
  unassignedCount: number;
  /**
   * The total number of open threads
   */
  totalCount: number;
  /**
   * Whether the sms channel has a thread that has unread messages
   */
  hasUnread: boolean;
  /**
   * The number of threads in each requested user's inbox
   */
  userInboxCounts: GetInboxSidebarCounts_inboxThreadCounts_sms_userInboxCounts[];
}

export interface GetInboxSidebarCounts_inboxThreadCounts_chat_userInboxCounts_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetInboxSidebarCounts_inboxThreadCounts_chat_userInboxCounts {
  __typename: "UserInbox";
  user: GetInboxSidebarCounts_inboxThreadCounts_chat_userInboxCounts_user | null;
  count: number | null;
}

export interface GetInboxSidebarCounts_inboxThreadCounts_chat {
  __typename: "ChatThreadCounts";
  /**
   * The number of unassigned threads
   */
  unassignedCount: number;
  /**
   * The total number of open threads
   */
  totalCount: number;
  /**
   * Whether the chat channel has a thread that has unread messages
   */
  hasUnread: boolean;
  /**
   * The number of threads in each requested user's inbox
   */
  userInboxCounts: GetInboxSidebarCounts_inboxThreadCounts_chat_userInboxCounts[];
  /**
   * The number of chatbot threads
   */
  chatbotCount: number;
}

export interface GetInboxSidebarCounts_inboxThreadCounts_messenger_userInboxCounts_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetInboxSidebarCounts_inboxThreadCounts_messenger_userInboxCounts {
  __typename: "UserInbox";
  user: GetInboxSidebarCounts_inboxThreadCounts_messenger_userInboxCounts_user | null;
  count: number | null;
}

export interface GetInboxSidebarCounts_inboxThreadCounts_messenger {
  __typename: "MessengerThreadCounts";
  /**
   * The number of unassigned threads
   */
  unassignedCount: number;
  /**
   * The total number of open threads
   */
  totalCount: number;
  /**
   * Whether the messenger channel has a thread that has unread messages
   */
  hasUnread: boolean;
  /**
   * The number of threads in each requested user's inbox
   */
  userInboxCounts: GetInboxSidebarCounts_inboxThreadCounts_messenger_userInboxCounts[];
}

export interface GetInboxSidebarCounts_inboxThreadCounts_instagram_userInboxCounts_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetInboxSidebarCounts_inboxThreadCounts_instagram_userInboxCounts {
  __typename: "UserInbox";
  user: GetInboxSidebarCounts_inboxThreadCounts_instagram_userInboxCounts_user | null;
  count: number | null;
}

export interface GetInboxSidebarCounts_inboxThreadCounts_instagram {
  __typename: "InstagramThreadCounts";
  /**
   * The number of unassigned threads
   */
  unassignedCount: number;
  /**
   * The total number of open threads
   */
  totalCount: number;
  /**
   * Whether the instagram channel has a thread that has unread messages
   */
  hasUnread: boolean;
  /**
   * The number of threads in each requested user's inbox
   */
  userInboxCounts: GetInboxSidebarCounts_inboxThreadCounts_instagram_userInboxCounts[];
}

export interface GetInboxSidebarCounts_inboxThreadCounts_allChannels_userInboxCounts_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetInboxSidebarCounts_inboxThreadCounts_allChannels_userInboxCounts {
  __typename: "UserInbox";
  user: GetInboxSidebarCounts_inboxThreadCounts_allChannels_userInboxCounts_user | null;
  count: number | null;
}

export interface GetInboxSidebarCounts_inboxThreadCounts_allChannels {
  __typename: "AllChannelsThreadCounts";
  /**
   * The number of unassigned threads
   */
  unassignedCount: number;
  /**
   * The total number of open threads
   */
  totalCount: number;
  /**
   * Whether any of the channels have a thread that has unread messages
   */
  hasUnread: boolean;
  /**
   * The number of threads in each requested user's inbox
   */
  userInboxCounts: GetInboxSidebarCounts_inboxThreadCounts_allChannels_userInboxCounts[];
}

export interface GetInboxSidebarCounts_inboxThreadCounts_whatsapp_userInboxCounts_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetInboxSidebarCounts_inboxThreadCounts_whatsapp_userInboxCounts {
  __typename: "UserInbox";
  user: GetInboxSidebarCounts_inboxThreadCounts_whatsapp_userInboxCounts_user | null;
  count: number | null;
}

export interface GetInboxSidebarCounts_inboxThreadCounts_whatsapp {
  __typename: "WhatsAppThreadCounts";
  /**
   * The number of unassigned threads
   */
  unassignedCount: number;
  /**
   * The total number of open threads
   */
  totalCount: number;
  /**
   * Whether the chat channel has a thread that has unread messages
   */
  hasUnread: boolean;
  /**
   * The number of threads in each requested user's inbox
   */
  userInboxCounts: GetInboxSidebarCounts_inboxThreadCounts_whatsapp_userInboxCounts[];
}

export interface GetInboxSidebarCounts_inboxThreadCounts_email_userInboxCounts_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetInboxSidebarCounts_inboxThreadCounts_email_userInboxCounts {
  __typename: "UserInbox";
  user: GetInboxSidebarCounts_inboxThreadCounts_email_userInboxCounts_user | null;
  count: number | null;
}

export interface GetInboxSidebarCounts_inboxThreadCounts_email {
  __typename: "EmailThreadCounts";
  /**
   * The number of unassigned threads
   */
  unassignedCount: number;
  /**
   * The total number of open threads
   */
  totalCount: number;
  /**
   * Whether the email channel has a thread that has unread messages
   */
  hasUnread: boolean;
  /**
   * The number of threads in each requested user's inbox
   */
  userInboxCounts: GetInboxSidebarCounts_inboxThreadCounts_email_userInboxCounts[];
}

export interface GetInboxSidebarCounts_inboxThreadCounts {
  __typename: "InboxThreadCounts";
  /**
   * The thread counts for sms
   */
  sms: GetInboxSidebarCounts_inboxThreadCounts_sms;
  /**
   * The thread counts for chat
   */
  chat: GetInboxSidebarCounts_inboxThreadCounts_chat;
  /**
   * The thread counts for messenger
   */
  messenger: GetInboxSidebarCounts_inboxThreadCounts_messenger;
  /**
   * The thread counts for instagram
   */
  instagram: GetInboxSidebarCounts_inboxThreadCounts_instagram;
  /**
   * The thread counts for all channels
   */
  allChannels: GetInboxSidebarCounts_inboxThreadCounts_allChannels;
  /**
   * The thread counts for whatsapp
   */
  whatsapp: GetInboxSidebarCounts_inboxThreadCounts_whatsapp;
  /**
   * The thread counts for shared email
   */
  email: GetInboxSidebarCounts_inboxThreadCounts_email;
}

export interface GetInboxSidebarCounts {
  /**
   * Returns the thread counts for the inbox page
   */
  inboxThreadCounts: GetInboxSidebarCounts_inboxThreadCounts;
}

export interface GetInboxSidebarCountsVariables {
  assignees?: string[] | null;
  inboxUserIds?: string[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetInboxThreadCounts
// ====================================================

export interface GetInboxThreadCounts_inboxThreadCounts_sms {
  __typename: "SmsThreadCounts";
  /**
   * The number of open threads
   */
  openCount: number;
  /**
   * The number of threads that need a reply
   */
  needsReplyCount: number;
  /**
   * The number of threads that have a scheduled message
   */
  scheduledCount: number;
  /**
   * The number of snoozed threads
   */
  snoozedCount: number;
  /**
   * The number of closed threads
   */
  closedCount: number;
  /**
   * The number of threads whose most recent outgoing message has failed
   */
  failedCount: number;
  /**
   * The number of unassigned threads
   */
  unassignedCount: number;
  /**
   * The number of archived threads
   */
  archivedCount: number;
}

export interface GetInboxThreadCounts_inboxThreadCounts_chat {
  __typename: "ChatThreadCounts";
  /**
   * The number of open threads
   */
  openCount: number;
  /**
   * The number of threads that need a reply
   */
  needsReplyCount: number;
  /**
   * The number of closed threads
   */
  closedCount: number;
  /**
   * The number of unassigned threads
   */
  unassignedCount: number;
  /**
   * The timestamp of the last chat thread started
   */
  lastStartedTime: any | null;
}

export interface GetInboxThreadCounts_inboxThreadCounts_messenger {
  __typename: "MessengerThreadCounts";
  /**
   * The number of open threads
   */
  openCount: number;
  /**
   * The number of closed threads
   */
  closedCount: number;
  /**
   * The number of snoozed threads
   */
  snoozedCount: number;
  /**
   * The number of unassigned threads
   */
  unassignedCount: number;
  /**
   * The number of threads that need a reply
   */
  needsReplyCount: number;
  /**
   * The number of threads whose most recent outgoing message has failed
   */
  failedCount: number;
}

export interface GetInboxThreadCounts_inboxThreadCounts_instagram {
  __typename: "InstagramThreadCounts";
  /**
   * The number of open threads
   */
  openCount: number;
  /**
   * The number of closed threads
   */
  closedCount: number;
  /**
   * The number of snoozed threads
   */
  snoozedCount: number;
  /**
   * The number of unassigned threads
   */
  unassignedCount: number;
  /**
   * The number of threads that need a reply
   */
  needsReplyCount: number;
}

export interface GetInboxThreadCounts_inboxThreadCounts_allChannels {
  __typename: "AllChannelsThreadCounts";
  /**
   * The number of open threads
   */
  openCount: number;
  /**
   * The number of closed threads
   */
  closedCount: number;
  /**
   * The number of snoozed threads
   */
  snoozedCount: number;
  /**
   * The number of unassigned threads
   */
  unassignedCount: number;
  /**
   * The number of threads that need a reply
   */
  needsReplyCount: number;
}

export interface GetInboxThreadCounts_inboxThreadCounts_whatsapp {
  __typename: "WhatsAppThreadCounts";
  /**
   * The number of open threads
   */
  openCount: number;
  /**
   * The number of closed threads
   */
  closedCount: number;
  /**
   * The number of unassigned threads
   */
  unassignedCount: number;
  /**
   * The number of threads that need a reply
   */
  needsReplyCount: number;
}

export interface GetInboxThreadCounts_inboxThreadCounts_email {
  __typename: "EmailThreadCounts";
  /**
   * The number of open threads
   */
  openCount: number;
  /**
   * The number of closed threads
   */
  closedCount: number;
  /**
   * The number of unassigned threads
   */
  unassignedCount: number;
  /**
   * The number of threads that need a reply
   */
  needsReplyCount: number;
  /**
   * The number of threads classified as spam
   */
  spamCount: number;
}

export interface GetInboxThreadCounts_inboxThreadCounts_chatbot {
  __typename: "ChatbotThreadCounts";
  openCount: number;
  closedCount: number;
  unidentifiedCount: number;
}

export interface GetInboxThreadCounts_inboxThreadCounts {
  __typename: "InboxThreadCounts";
  /**
   * The thread counts for sms
   */
  sms: GetInboxThreadCounts_inboxThreadCounts_sms;
  /**
   * The thread counts for chat
   */
  chat: GetInboxThreadCounts_inboxThreadCounts_chat;
  /**
   * The thread counts for messenger
   */
  messenger: GetInboxThreadCounts_inboxThreadCounts_messenger;
  /**
   * The thread counts for instagram
   */
  instagram: GetInboxThreadCounts_inboxThreadCounts_instagram;
  /**
   * The thread counts for all channels
   */
  allChannels: GetInboxThreadCounts_inboxThreadCounts_allChannels;
  /**
   * The thread counts for whatsapp
   */
  whatsapp: GetInboxThreadCounts_inboxThreadCounts_whatsapp;
  /**
   * The thread counts for shared email
   */
  email: GetInboxThreadCounts_inboxThreadCounts_email;
  /**
   * The thread counts for chatbot
   */
  chatbot: GetInboxThreadCounts_inboxThreadCounts_chatbot;
}

export interface GetInboxThreadCounts {
  /**
   * Returns the thread counts for the inbox page
   */
  inboxThreadCounts: GetInboxThreadCounts_inboxThreadCounts;
}

export interface GetInboxThreadCountsVariables {
  assignees?: string[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetInboxThread
// ====================================================

export interface GetInboxThread_inboxThread_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The images in the message
   */
  images: string[];
}

export interface GetInboxThread_inboxThread_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface GetInboxThread_inboxThread_owner_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface GetInboxThread_inboxThread_owner_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export type GetInboxThread_inboxThread_owner = GetInboxThread_inboxThread_owner_User | GetInboxThread_inboxThread_owner_Team;

export interface GetInboxThread_inboxThread_externalChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetInboxThread_inboxThread_externalChannel_email {
  __typename: "NutEmailAddress";
  address: string;
}

export interface GetInboxThread_inboxThread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  sessionId: string | null;
  status: ChannelStatus;
  phone: GetInboxThread_inboxThread_externalChannel_phone | null;
  email: GetInboxThread_inboxThread_externalChannel_email | null;
}

export interface GetInboxThread_inboxThread_nutshellChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetInboxThread_inboxThread_nutshellChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  phone: GetInboxThread_inboxThread_nutshellChannel_phone | null;
}

export interface GetInboxThread_inboxThread_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetInboxThread_inboxThread_bestEntity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetInboxThread_inboxThread_bestEntity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetInboxThread_inboxThread_bestEntity_Contact_accounts_primary | null;
}

export interface GetInboxThread_inboxThread_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetInboxThread_inboxThread_bestEntity_Contact_accounts;
}

export interface GetInboxThread_inboxThread_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
}

export type GetInboxThread_inboxThread_bestEntity = GetInboxThread_inboxThread_bestEntity_Lead | GetInboxThread_inboxThread_bestEntity_Contact | GetInboxThread_inboxThread_bestEntity_Account;

export interface GetInboxThread_inboxThread_stubEntity {
  __typename: "StubEntity";
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrlPath: string;
  initials: string;
}

export interface GetInboxThread_inboxThread_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetInboxThread_inboxThread_relatedLeads_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface GetInboxThread_inboxThread_relatedLeads_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export type GetInboxThread_inboxThread_relatedLeads_assignee = GetInboxThread_inboxThread_relatedLeads_assignee_Team | GetInboxThread_inboxThread_relatedLeads_assignee_User;

export interface GetInboxThread_inboxThread_relatedLeads_contacts_primaryEdge_node_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetInboxThread_inboxThread_relatedLeads_contacts_primaryEdge_node_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetInboxThread_inboxThread_relatedLeads_contacts_primaryEdge_node_accounts_primary | null;
}

export interface GetInboxThread_inboxThread_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetInboxThread_inboxThread_relatedLeads_contacts_primaryEdge_node_accounts;
}

export interface GetInboxThread_inboxThread_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetInboxThread_inboxThread_relatedLeads_contacts_primaryEdge_node;
}

export interface GetInboxThread_inboxThread_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetInboxThread_inboxThread_relatedLeads_contacts_primaryEdge | null;
}

export interface GetInboxThread_inboxThread_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetInboxThread_inboxThread_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetInboxThread_inboxThread_relatedLeads_accounts_primaryEdge_node;
}

export interface GetInboxThread_inboxThread_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetInboxThread_inboxThread_relatedLeads_accounts_primaryEdge | null;
}

export interface GetInboxThread_inboxThread_relatedLeads_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetInboxThread_inboxThread_relatedLeads_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetInboxThread_inboxThread_relatedLeads_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetInboxThread_inboxThread_relatedLeads_stages_edges {
  __typename: "LeadStagesEdge";
  node: GetInboxThread_inboxThread_relatedLeads_stages_edges_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
}

export interface GetInboxThread_inboxThread_relatedLeads_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: GetInboxThread_inboxThread_relatedLeads_stages_current | null;
  /**
   * A list of edges.
   */
  edges: GetInboxThread_inboxThread_relatedLeads_stages_edges[];
}

export interface GetInboxThread_inboxThread_relatedLeads_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface GetInboxThread_inboxThread_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: GetInboxThread_inboxThread_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetInboxThread_inboxThread_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetInboxThread_inboxThread_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetInboxThread_inboxThread_relatedLeads_accounts;
  /**
   * Stageset associated with the given lead
   */
  stageset: GetInboxThread_inboxThread_relatedLeads_stageset | null;
  /**
   * Stages for the lead
   */
  stages: GetInboxThread_inboxThread_relatedLeads_stages;
  /**
   * The list of tags on this lead
   */
  tags: GetInboxThread_inboxThread_relatedLeads_tags[];
}

export interface GetInboxThread_inboxThread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this thread is open
   */
  isOpen: boolean;
  /**
   * Whether this thread is active
   */
  isActive: boolean;
  /**
   * The effective status of this thread
   */
  effectiveStatus: ThreadStatus;
  threadSummary: string | null;
  /**
   * Whether this thread can be archived
   */
  canArchive: boolean;
  /**
   * Whether this thread can be reopened
   */
  canReopen: boolean;
  /**
   * Whether this thread is assigned to the current user
   */
  isAssignedToCurrentUser: boolean;
  /**
   * The bot status of this thread
   */
  botStatus: ThreadBotStatus;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: GetInboxThread_inboxThread_displayMessage | null;
  /**
   * The user who created this thread
   */
  creatorUser: GetInboxThread_inboxThread_creatorUser | null;
  /**
   * The time this thread was created
   */
  createdTime: any;
  /**
   * The time this thread is snoozed until
   */
  snoozedUntilTime: any | null;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The user or team assigned to this thread
   */
  owner: GetInboxThread_inboxThread_owner | null;
  /**
   * The external channel this thread is related to
   */
  externalChannel: GetInboxThread_inboxThread_externalChannel;
  /**
   * The internal nutshell channel this thread is related to
   */
  nutshellChannel: GetInboxThread_inboxThread_nutshellChannel;
  /**
   * The best entity associated with this thread
   */
  bestEntity: GetInboxThread_inboxThread_bestEntity | null;
  /**
   * The Shelly entity only if this thread is on the stub Shelly channel
   */
  stubEntity: GetInboxThread_inboxThread_stubEntity | null;
  /**
   * The leads associated with this thread
   */
  relatedLeads: GetInboxThread_inboxThread_relatedLeads[] | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
  /**
   * Whether this thread has unread messages
   */
  isUnread: boolean;
}

export interface GetInboxThread {
  /**
   * Returns the inbox thread
   */
  inboxThread: GetInboxThread_inboxThread;
}

export interface GetInboxThreadVariables {
  threadId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetInboxThreadsByIds
// ====================================================

export interface GetInboxThreadsByIds_inboxThreads_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The content of the message
   */
  content: string;
}

export interface GetInboxThreadsByIds_inboxThreads_externalChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetInboxThreadsByIds_inboxThreads_externalChannel_email {
  __typename: "NutEmailAddress";
  address: string;
}

export interface GetInboxThreadsByIds_inboxThreads_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  phone: GetInboxThreadsByIds_inboxThreads_externalChannel_phone | null;
  email: GetInboxThreadsByIds_inboxThreads_externalChannel_email | null;
}

export interface GetInboxThreadsByIds_inboxThreads_nutshellChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetInboxThreadsByIds_inboxThreads_nutshellChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  phone: GetInboxThreadsByIds_inboxThreads_nutshellChannel_phone | null;
}

export interface GetInboxThreadsByIds_inboxThreads_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetInboxThreadsByIds_inboxThreads_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
}

export interface GetInboxThreadsByIds_inboxThreads_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
}

export type GetInboxThreadsByIds_inboxThreads_bestEntity = GetInboxThreadsByIds_inboxThreads_bestEntity_Lead | GetInboxThreadsByIds_inboxThreads_bestEntity_Contact | GetInboxThreadsByIds_inboxThreads_bestEntity_Account;

export interface GetInboxThreadsByIds_inboxThreads_stubEntity {
  __typename: "StubEntity";
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrlPath: string;
  initials: string;
}

export interface GetInboxThreadsByIds_inboxThreads_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetInboxThreadsByIds_inboxThreads_relatedLeads_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface GetInboxThreadsByIds_inboxThreads_relatedLeads_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export type GetInboxThreadsByIds_inboxThreads_relatedLeads_assignee = GetInboxThreadsByIds_inboxThreads_relatedLeads_assignee_Team | GetInboxThreadsByIds_inboxThreads_relatedLeads_assignee_User;

export interface GetInboxThreadsByIds_inboxThreads_relatedLeads_contacts_primaryEdge_node_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetInboxThreadsByIds_inboxThreads_relatedLeads_contacts_primaryEdge_node_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetInboxThreadsByIds_inboxThreads_relatedLeads_contacts_primaryEdge_node_accounts_primary | null;
}

export interface GetInboxThreadsByIds_inboxThreads_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetInboxThreadsByIds_inboxThreads_relatedLeads_contacts_primaryEdge_node_accounts;
}

export interface GetInboxThreadsByIds_inboxThreads_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetInboxThreadsByIds_inboxThreads_relatedLeads_contacts_primaryEdge_node;
}

export interface GetInboxThreadsByIds_inboxThreads_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetInboxThreadsByIds_inboxThreads_relatedLeads_contacts_primaryEdge | null;
}

export interface GetInboxThreadsByIds_inboxThreads_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetInboxThreadsByIds_inboxThreads_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetInboxThreadsByIds_inboxThreads_relatedLeads_accounts_primaryEdge_node;
}

export interface GetInboxThreadsByIds_inboxThreads_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetInboxThreadsByIds_inboxThreads_relatedLeads_accounts_primaryEdge | null;
}

export interface GetInboxThreadsByIds_inboxThreads_relatedLeads_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetInboxThreadsByIds_inboxThreads_relatedLeads_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetInboxThreadsByIds_inboxThreads_relatedLeads_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetInboxThreadsByIds_inboxThreads_relatedLeads_stages_edges {
  __typename: "LeadStagesEdge";
  node: GetInboxThreadsByIds_inboxThreads_relatedLeads_stages_edges_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
}

export interface GetInboxThreadsByIds_inboxThreads_relatedLeads_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: GetInboxThreadsByIds_inboxThreads_relatedLeads_stages_current | null;
  /**
   * A list of edges.
   */
  edges: GetInboxThreadsByIds_inboxThreads_relatedLeads_stages_edges[];
}

export interface GetInboxThreadsByIds_inboxThreads_relatedLeads_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface GetInboxThreadsByIds_inboxThreads_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: GetInboxThreadsByIds_inboxThreads_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetInboxThreadsByIds_inboxThreads_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetInboxThreadsByIds_inboxThreads_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetInboxThreadsByIds_inboxThreads_relatedLeads_accounts;
  /**
   * Stageset associated with the given lead
   */
  stageset: GetInboxThreadsByIds_inboxThreads_relatedLeads_stageset | null;
  /**
   * Stages for the lead
   */
  stages: GetInboxThreadsByIds_inboxThreads_relatedLeads_stages;
  /**
   * The list of tags on this lead
   */
  tags: GetInboxThreadsByIds_inboxThreads_relatedLeads_tags[];
}

export interface GetInboxThreadsByIds_inboxThreads {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The effective status of this thread
   */
  effectiveStatus: ThreadStatus;
  /**
   * The number of messages on this thread
   */
  messageCount: number;
  threadSummary: string | null;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: GetInboxThreadsByIds_inboxThreads_displayMessage | null;
  /**
   * The external channel this thread is related to
   */
  externalChannel: GetInboxThreadsByIds_inboxThreads_externalChannel;
  /**
   * The internal nutshell channel this thread is related to
   */
  nutshellChannel: GetInboxThreadsByIds_inboxThreads_nutshellChannel;
  /**
   * The best entity associated with this thread
   */
  bestEntity: GetInboxThreadsByIds_inboxThreads_bestEntity | null;
  /**
   * The Shelly entity only if this thread is on the stub Shelly channel
   */
  stubEntity: GetInboxThreadsByIds_inboxThreads_stubEntity | null;
  /**
   * The leads associated with this thread
   */
  relatedLeads: GetInboxThreadsByIds_inboxThreads_relatedLeads[] | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
}

export interface GetInboxThreadsByIds {
  inboxThreads: GetInboxThreadsByIds_inboxThreads[];
}

export interface GetInboxThreadsByIdsVariables {
  ids: string[];
  botStatus: ThreadBotStatus;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLatestThreads
// ====================================================

export interface GetLatestThreads_latestThreads_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
}

export interface GetLatestThreads_latestThreads_edges_node_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The images in the message
   */
  images: string[];
}

export interface GetLatestThreads_latestThreads_edges_node_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface GetLatestThreads_latestThreads_edges_node_owner_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface GetLatestThreads_latestThreads_edges_node_owner_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export type GetLatestThreads_latestThreads_edges_node_owner = GetLatestThreads_latestThreads_edges_node_owner_User | GetLatestThreads_latestThreads_edges_node_owner_Team;

export interface GetLatestThreads_latestThreads_edges_node_externalChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetLatestThreads_latestThreads_edges_node_externalChannel_email {
  __typename: "NutEmailAddress";
  address: string;
}

export interface GetLatestThreads_latestThreads_edges_node_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  sessionId: string | null;
  status: ChannelStatus;
  phone: GetLatestThreads_latestThreads_edges_node_externalChannel_phone | null;
  email: GetLatestThreads_latestThreads_edges_node_externalChannel_email | null;
}

export interface GetLatestThreads_latestThreads_edges_node_nutshellChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetLatestThreads_latestThreads_edges_node_nutshellChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  phone: GetLatestThreads_latestThreads_edges_node_nutshellChannel_phone | null;
}

export interface GetLatestThreads_latestThreads_edges_node_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetLatestThreads_latestThreads_edges_node_bestEntity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLatestThreads_latestThreads_edges_node_bestEntity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetLatestThreads_latestThreads_edges_node_bestEntity_Contact_accounts_primary | null;
}

export interface GetLatestThreads_latestThreads_edges_node_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetLatestThreads_latestThreads_edges_node_bestEntity_Contact_accounts;
}

export interface GetLatestThreads_latestThreads_edges_node_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
}

export type GetLatestThreads_latestThreads_edges_node_bestEntity = GetLatestThreads_latestThreads_edges_node_bestEntity_Lead | GetLatestThreads_latestThreads_edges_node_bestEntity_Contact | GetLatestThreads_latestThreads_edges_node_bestEntity_Account;

export interface GetLatestThreads_latestThreads_edges_node_stubEntity {
  __typename: "StubEntity";
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrlPath: string;
  initials: string;
}

export interface GetLatestThreads_latestThreads_edges_node_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetLatestThreads_latestThreads_edges_node_relatedLeads_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface GetLatestThreads_latestThreads_edges_node_relatedLeads_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export type GetLatestThreads_latestThreads_edges_node_relatedLeads_assignee = GetLatestThreads_latestThreads_edges_node_relatedLeads_assignee_Team | GetLatestThreads_latestThreads_edges_node_relatedLeads_assignee_User;

export interface GetLatestThreads_latestThreads_edges_node_relatedLeads_contacts_primaryEdge_node_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLatestThreads_latestThreads_edges_node_relatedLeads_contacts_primaryEdge_node_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetLatestThreads_latestThreads_edges_node_relatedLeads_contacts_primaryEdge_node_accounts_primary | null;
}

export interface GetLatestThreads_latestThreads_edges_node_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetLatestThreads_latestThreads_edges_node_relatedLeads_contacts_primaryEdge_node_accounts;
}

export interface GetLatestThreads_latestThreads_edges_node_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetLatestThreads_latestThreads_edges_node_relatedLeads_contacts_primaryEdge_node;
}

export interface GetLatestThreads_latestThreads_edges_node_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetLatestThreads_latestThreads_edges_node_relatedLeads_contacts_primaryEdge | null;
}

export interface GetLatestThreads_latestThreads_edges_node_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLatestThreads_latestThreads_edges_node_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetLatestThreads_latestThreads_edges_node_relatedLeads_accounts_primaryEdge_node;
}

export interface GetLatestThreads_latestThreads_edges_node_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetLatestThreads_latestThreads_edges_node_relatedLeads_accounts_primaryEdge | null;
}

export interface GetLatestThreads_latestThreads_edges_node_relatedLeads_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetLatestThreads_latestThreads_edges_node_relatedLeads_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetLatestThreads_latestThreads_edges_node_relatedLeads_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetLatestThreads_latestThreads_edges_node_relatedLeads_stages_edges {
  __typename: "LeadStagesEdge";
  node: GetLatestThreads_latestThreads_edges_node_relatedLeads_stages_edges_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
}

export interface GetLatestThreads_latestThreads_edges_node_relatedLeads_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: GetLatestThreads_latestThreads_edges_node_relatedLeads_stages_current | null;
  /**
   * A list of edges.
   */
  edges: GetLatestThreads_latestThreads_edges_node_relatedLeads_stages_edges[];
}

export interface GetLatestThreads_latestThreads_edges_node_relatedLeads_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface GetLatestThreads_latestThreads_edges_node_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: GetLatestThreads_latestThreads_edges_node_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetLatestThreads_latestThreads_edges_node_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetLatestThreads_latestThreads_edges_node_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetLatestThreads_latestThreads_edges_node_relatedLeads_accounts;
  /**
   * Stageset associated with the given lead
   */
  stageset: GetLatestThreads_latestThreads_edges_node_relatedLeads_stageset | null;
  /**
   * Stages for the lead
   */
  stages: GetLatestThreads_latestThreads_edges_node_relatedLeads_stages;
  /**
   * The list of tags on this lead
   */
  tags: GetLatestThreads_latestThreads_edges_node_relatedLeads_tags[];
}

export interface GetLatestThreads_latestThreads_edges_node {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this thread is open
   */
  isOpen: boolean;
  /**
   * Whether this thread is active
   */
  isActive: boolean;
  /**
   * The effective status of this thread
   */
  effectiveStatus: ThreadStatus;
  threadSummary: string | null;
  /**
   * Whether this thread can be archived
   */
  canArchive: boolean;
  /**
   * Whether this thread can be reopened
   */
  canReopen: boolean;
  /**
   * Whether this thread is assigned to the current user
   */
  isAssignedToCurrentUser: boolean;
  /**
   * The bot status of this thread
   */
  botStatus: ThreadBotStatus;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: GetLatestThreads_latestThreads_edges_node_displayMessage | null;
  /**
   * The user who created this thread
   */
  creatorUser: GetLatestThreads_latestThreads_edges_node_creatorUser | null;
  /**
   * The time this thread was created
   */
  createdTime: any;
  /**
   * The time this thread is snoozed until
   */
  snoozedUntilTime: any | null;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The user or team assigned to this thread
   */
  owner: GetLatestThreads_latestThreads_edges_node_owner | null;
  /**
   * The external channel this thread is related to
   */
  externalChannel: GetLatestThreads_latestThreads_edges_node_externalChannel;
  /**
   * The internal nutshell channel this thread is related to
   */
  nutshellChannel: GetLatestThreads_latestThreads_edges_node_nutshellChannel;
  /**
   * The best entity associated with this thread
   */
  bestEntity: GetLatestThreads_latestThreads_edges_node_bestEntity | null;
  /**
   * The Shelly entity only if this thread is on the stub Shelly channel
   */
  stubEntity: GetLatestThreads_latestThreads_edges_node_stubEntity | null;
  /**
   * The leads associated with this thread
   */
  relatedLeads: GetLatestThreads_latestThreads_edges_node_relatedLeads[] | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
  /**
   * Whether this thread has unread messages
   */
  isUnread: boolean;
}

export interface GetLatestThreads_latestThreads_edges {
  __typename: "LatestThreadsEdge";
  node: GetLatestThreads_latestThreads_edges_node;
}

export interface GetLatestThreads_latestThreads {
  __typename: "LatestThreadsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetLatestThreads_latestThreads_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetLatestThreads_latestThreads_edges[];
}

export interface GetLatestThreads {
  /**
   * A connection to a list of items.
   */
  latestThreads: GetLatestThreads_latestThreads;
}

export interface GetLatestThreadsVariables {
  status?: ThreadStatus | null;
  assignees?: string[] | null;
  after?: string | null;
  before?: string | null;
  first?: number | null;
  threadType?: ThreadType | null;
  findThreadId?: string | null;
  botStatus?: ThreadBotStatus | null;
  contactFilter?: ContactFilter | null;
  search?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserInboxes
// ====================================================

export interface GetUserInboxes_userInboxes {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetUserInboxes {
  /**
   * List of user inboxes added to engagement page
   */
  userInboxes: GetUserInboxes_userInboxes[];
}

export interface GetUserInboxesVariables {
  threadType?: ThreadType | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateShelly
// ====================================================

export interface CreateShelly_shellyCreate {
  __typename: "ShellyCreatePayload";
  didCreate: boolean;
}

export interface CreateShelly {
  /**
   * Creates Shelly for the instance
   */
  shellyCreate: CreateShelly_shellyCreate;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteTextMessage
// ====================================================

export interface DeleteTextMessage_textMessageDelete_message {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteTextMessage_textMessageDelete {
  __typename: "TextMessageDeletePayload";
  message: DeleteTextMessage_textMessageDelete_message | null;
}

export interface DeleteTextMessage {
  /**
   * Deletes a text message using Nutshell Inbox
   */
  textMessageDelete: DeleteTextMessage_textMessageDelete;
}

export interface DeleteTextMessageVariables {
  input: TextMessageDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ResendTextMessage
// ====================================================

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The images in the message
   */
  images: string[];
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_owner_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_owner_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export type ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_owner = ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_owner_User | ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_owner_Team;

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_externalChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_externalChannel_email {
  __typename: "NutEmailAddress";
  address: string;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  sessionId: string | null;
  status: ChannelStatus;
  phone: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_externalChannel_phone | null;
  email: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_externalChannel_email | null;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_nutshellChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_nutshellChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  phone: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_nutshellChannel_phone | null;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts_primary | null;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
}

export type ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_bestEntity = ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_bestEntity_Lead | ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_bestEntity_Contact | ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_bestEntity_Account;

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_stubEntity {
  __typename: "StubEntity";
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrlPath: string;
  initials: string;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export type ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee = ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_Team | ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_User;

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary | null;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge | null;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge_node;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge | null;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges {
  __typename: "LeadStagesEdge";
  node: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_current | null;
  /**
   * A list of edges.
   */
  edges: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges[];
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts;
  /**
   * Stageset associated with the given lead
   */
  stageset: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_stageset | null;
  /**
   * Stages for the lead
   */
  stages: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages;
  /**
   * The list of tags on this lead
   */
  tags: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads_tags[];
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this thread is open
   */
  isOpen: boolean;
  /**
   * Whether this thread is active
   */
  isActive: boolean;
  /**
   * The effective status of this thread
   */
  effectiveStatus: ThreadStatus;
  threadSummary: string | null;
  /**
   * Whether this thread can be archived
   */
  canArchive: boolean;
  /**
   * Whether this thread can be reopened
   */
  canReopen: boolean;
  /**
   * Whether this thread is assigned to the current user
   */
  isAssignedToCurrentUser: boolean;
  /**
   * The bot status of this thread
   */
  botStatus: ThreadBotStatus;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_displayMessage | null;
  /**
   * The user who created this thread
   */
  creatorUser: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_creatorUser | null;
  /**
   * The time this thread was created
   */
  createdTime: any;
  /**
   * The time this thread is snoozed until
   */
  snoozedUntilTime: any | null;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The user or team assigned to this thread
   */
  owner: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_owner | null;
  /**
   * The external channel this thread is related to
   */
  externalChannel: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_externalChannel;
  /**
   * The internal nutshell channel this thread is related to
   */
  nutshellChannel: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_nutshellChannel;
  /**
   * The best entity associated with this thread
   */
  bestEntity: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_bestEntity | null;
  /**
   * The Shelly entity only if this thread is on the stub Shelly channel
   */
  stubEntity: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_stubEntity | null;
  /**
   * The leads associated with this thread
   */
  relatedLeads: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread_relatedLeads[] | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
  /**
   * Whether this thread has unread messages
   */
  isUnread: boolean;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel_threads {
  __typename: "InboxChannelThreadsConnection";
  /**
   * The latest thread (open or closed) on this channel
   */
  latestThread: ResendTextMessage_textResend_message_thread_externalChannel_threads_latestThread | null;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The number of closed threads on this channel.
   */
  closedCount: number;
}

export interface ResendTextMessage_textResend_message_thread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
  threads: ResendTextMessage_textResend_message_thread_externalChannel_threads;
}

export interface ResendTextMessage_textResend_message_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external channel this thread is related to
   */
  externalChannel: ResendTextMessage_textResend_message_thread_externalChannel;
}

export interface ResendTextMessage_textResend_message_senderEmailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface ResendTextMessage_textResend_message_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface ResendTextMessage_textResend_message_edition_campaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface ResendTextMessage_textResend_message_edition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The editions of the drip sequence
   */
  editions: ResendTextMessage_textResend_message_edition_campaign_editions;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface ResendTextMessage_textResend_message_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: ResendTextMessage_textResend_message_edition_campaign;
  /**
   * The position of the edition in the drip sequence
   */
  position: number;
}

export interface ResendTextMessage_textResend_message_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  originType: OriginType;
}

export interface ResendTextMessage_textResend_message_submission_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface ResendTextMessage_textResend_message_submission_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: ResendTextMessage_textResend_message_submission_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface ResendTextMessage_textResend_message_submission_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: ResendTextMessage_textResend_message_submission_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface ResendTextMessage_textResend_message_submission_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: ResendTextMessage_textResend_message_submission_booking_additionalAttendees_emailAddresses;
}

export interface ResendTextMessage_textResend_message_submission_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The start time of this booking
   */
  startTime: any;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (ResendTextMessage_textResend_message_submission_booking_additionalAttendees | null)[];
}

export interface ResendTextMessage_textResend_message_submission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface ResendTextMessage_textResend_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface ResendTextMessage_textResend_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export interface ResendTextMessage_textResend_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface ResendTextMessage_textResend_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: ResendTextMessage_textResend_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export type ResendTextMessage_textResend_message_submission_fields_edges_fieldValue = ResendTextMessage_textResend_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | ResendTextMessage_textResend_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle | ResendTextMessage_textResend_message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields;

export interface ResendTextMessage_textResend_message_submission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: ResendTextMessage_textResend_message_submission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: ResendTextMessage_textResend_message_submission_fields_edges_fieldValue | null;
}

export interface ResendTextMessage_textResend_message_submission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: ResendTextMessage_textResend_message_submission_fields_edges[];
}

export interface ResendTextMessage_textResend_message_submission {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The booking associated with this submission (if Scheduler)
   */
  booking: ResendTextMessage_textResend_message_submission_booking | null;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: ResendTextMessage_textResend_message_submission_fields;
}

export interface ResendTextMessage_textResend_message {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: MessageStatus;
  /**
   * The thread this message is part of
   */
  thread: ResendTextMessage_textResend_message_thread;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  senderEmailAddress: ResendTextMessage_textResend_message_senderEmailAddress | null;
  /**
   * Whether this message is a Nutshell system response
   */
  isNutshellSystemResponse: boolean;
  /**
   * The user who created this thread
   */
  creatorUser: ResendTextMessage_textResend_message_creatorUser | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The time the message was read
   */
  readTime: any | null;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The edition of the message
   */
  edition: ResendTextMessage_textResend_message_edition | null;
  /**
   * Whether this message can be canceled
   */
  isCancelable: boolean;
  /**
   * The reaction to the message
   */
  reaction: string | null;
  /**
   * The reason the message failed to send
   */
  errorReason: ErrorReason | null;
  /**
   * The URL of the media in the message
   */
  mediaUrl: string | null;
  /**
   * The origin of the user who created this thread
   */
  creatorOrigin: ResendTextMessage_textResend_message_creatorOrigin | null;
  /**
   * The images in the message
   */
  images: string[];
  /**
   * The submission for a form or scheduler booking related to the chatbot goal
   */
  submission: ResendTextMessage_textResend_message_submission | null;
}

export interface ResendTextMessage_textResend {
  __typename: "TextMessageResendPayload";
  /**
   * The resent message.
   */
  message: ResendTextMessage_textResend_message;
}

export interface ResendTextMessage {
  /**
   * Resend a text message.
   */
  textResend: ResendTextMessage_textResend;
}

export interface ResendTextMessageVariables {
  input: TextMessageResendInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendTextMessage
// ====================================================

export interface SendTextMessage_inboxTextMessageSend_message_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The images in the message
   */
  images: string[];
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_owner_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_owner_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export type SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_owner = SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_owner_User | SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_owner_Team;

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_externalChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_externalChannel_email {
  __typename: "NutEmailAddress";
  address: string;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  sessionId: string | null;
  status: ChannelStatus;
  phone: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_externalChannel_phone | null;
  email: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_externalChannel_email | null;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_nutshellChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_nutshellChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  phone: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_nutshellChannel_phone | null;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts_primary | null;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
}

export type SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_bestEntity = SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_bestEntity_Lead | SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_bestEntity_Contact | SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_bestEntity_Account;

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_stubEntity {
  __typename: "StubEntity";
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrlPath: string;
  initials: string;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export type SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee = SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_Team | SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_User;

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary | null;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge | null;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge_node;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge | null;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges {
  __typename: "LeadStagesEdge";
  node: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_current | null;
  /**
   * A list of edges.
   */
  edges: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges[];
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_accounts;
  /**
   * Stageset associated with the given lead
   */
  stageset: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_stageset | null;
  /**
   * Stages for the lead
   */
  stages: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_stages;
  /**
   * The list of tags on this lead
   */
  tags: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads_tags[];
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this thread is open
   */
  isOpen: boolean;
  /**
   * Whether this thread is active
   */
  isActive: boolean;
  /**
   * The effective status of this thread
   */
  effectiveStatus: ThreadStatus;
  threadSummary: string | null;
  /**
   * Whether this thread can be archived
   */
  canArchive: boolean;
  /**
   * Whether this thread can be reopened
   */
  canReopen: boolean;
  /**
   * Whether this thread is assigned to the current user
   */
  isAssignedToCurrentUser: boolean;
  /**
   * The bot status of this thread
   */
  botStatus: ThreadBotStatus;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_displayMessage | null;
  /**
   * The user who created this thread
   */
  creatorUser: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_creatorUser | null;
  /**
   * The time this thread was created
   */
  createdTime: any;
  /**
   * The time this thread is snoozed until
   */
  snoozedUntilTime: any | null;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The user or team assigned to this thread
   */
  owner: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_owner | null;
  /**
   * The external channel this thread is related to
   */
  externalChannel: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_externalChannel;
  /**
   * The internal nutshell channel this thread is related to
   */
  nutshellChannel: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_nutshellChannel;
  /**
   * The best entity associated with this thread
   */
  bestEntity: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_bestEntity | null;
  /**
   * The Shelly entity only if this thread is on the stub Shelly channel
   */
  stubEntity: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_stubEntity | null;
  /**
   * The leads associated with this thread
   */
  relatedLeads: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread_relatedLeads[] | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
  /**
   * Whether this thread has unread messages
   */
  isUnread: boolean;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads {
  __typename: "InboxChannelThreadsConnection";
  /**
   * The latest thread (open or closed) on this channel
   */
  latestThread: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads_latestThread | null;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The number of closed threads on this channel.
   */
  closedCount: number;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
  threads: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel_threads;
}

export interface SendTextMessage_inboxTextMessageSend_message_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external channel this thread is related to
   */
  externalChannel: SendTextMessage_inboxTextMessageSend_message_thread_externalChannel;
}

export interface SendTextMessage_inboxTextMessageSend_message {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: MessageStatus;
  /**
   * The content of the message
   */
  content: string;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The user who created this thread
   */
  creatorUser: SendTextMessage_inboxTextMessageSend_message_creatorUser | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The thread this message is part of
   */
  thread: SendTextMessage_inboxTextMessageSend_message_thread;
}

export interface SendTextMessage_inboxTextMessageSend {
  __typename: "TextMessageSendPayload";
  message: SendTextMessage_inboxTextMessageSend_message | null;
}

export interface SendTextMessage {
  /**
   * Sends a text message using Nutshell Inbox
   */
  inboxTextMessageSend: SendTextMessage_inboxTextMessageSend;
}

export interface SendTextMessageVariables {
  input: TextMessageSendInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateInboundSmsRules
// ====================================================

export interface UpdateInboundSmsRules_inboundSmsRulesUpdate_assignment_assignedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateInboundSmsRules_inboundSmsRulesUpdate_assignment {
  __typename: "InboundRulesAssignment";
  /**
   * The user to assign inbound SMS thread to.
   */
  assignedUser: UpdateInboundSmsRules_inboundSmsRulesUpdate_assignment_assignedUser | null;
}

export interface UpdateInboundSmsRules_inboundSmsRulesUpdate {
  __typename: "InboundSmsRules";
  /**
   * The assignment rule for inbound SMS.
   */
  assignment: UpdateInboundSmsRules_inboundSmsRulesUpdate_assignment;
}

export interface UpdateInboundSmsRules {
  /**
   * Updates the inbound SMS rules for an sms.
   */
  inboundSmsRulesUpdate: UpdateInboundSmsRules_inboundSmsRulesUpdate | null;
}

export interface UpdateInboundSmsRulesVariables {
  input: InboundSmsRulesUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: VerifyPhoneNumber
// ====================================================

export interface VerifyPhoneNumber_phoneNumberVerify {
  __typename: "PhoneNumberVerify";
  /**
   * The verification code sent to the phone number
   */
  verificationCode: string;
}

export interface VerifyPhoneNumber {
  /**
   * The rules for inbound SMS.
   */
  phoneNumberVerify: VerifyPhoneNumber_phoneNumberVerify;
}

export interface VerifyPhoneNumberVariables {
  phoneNumber: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetInboundSmsRules
// ====================================================

export interface GetInboundSmsRules_inboundSmsRules_assignment_assignedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetInboundSmsRules_inboundSmsRules_assignment {
  __typename: "InboundRulesAssignment";
  strategy: ChatAssignmentStrategyEnum;
  /**
   * The user to assign inbound SMS thread to.
   */
  assignedUser: GetInboundSmsRules_inboundSmsRules_assignment_assignedUser | null;
}

export interface GetInboundSmsRules_inboundSmsRules_leadCreation_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetInboundSmsRules_inboundSmsRules_leadCreation_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetInboundSmsRules_inboundSmsRules_leadCreation {
  __typename: "InboundRulesLeadCreation";
  /**
   * Whether lead creation is enabled.
   */
  enabled: boolean;
  /**
   * The stageset to use for lead creation.
   */
  stageset: GetInboundSmsRules_inboundSmsRules_leadCreation_stageset | null;
  /**
   * The tags to apply to the lead.
   */
  tags: GetInboundSmsRules_inboundSmsRules_leadCreation_tags[] | null;
}

export interface GetInboundSmsRules_inboundSmsRules_redirectPhoneNumber {
  __typename: "NutPhoneNumber";
  /**
   * The base number component of the phone number
   */
  numberFormatted: string;
}

export interface GetInboundSmsRules_inboundSmsRules {
  __typename: "InboundSmsRules";
  /**
   * The assignment rule for inbound SMS.
   */
  assignment: GetInboundSmsRules_inboundSmsRules_assignment;
  /**
   * The lead creation rule for inbound SMS.
   */
  leadCreation: GetInboundSmsRules_inboundSmsRules_leadCreation;
  /**
   * The phone number to redirect inbound SMS to.
   */
  redirectPhoneNumber: GetInboundSmsRules_inboundSmsRules_redirectPhoneNumber | null;
}

export interface GetInboundSmsRules {
  /**
   * The rules for inbound SMS.
   */
  inboundSmsRules: GetInboundSmsRules_inboundSmsRules;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRelatedTextables
// ====================================================

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The images in the message
   */
  images: string[];
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_owner_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_owner_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export type GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_owner = GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_owner_User | GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_owner_Team;

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_externalChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_externalChannel_email {
  __typename: "NutEmailAddress";
  address: string;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  sessionId: string | null;
  status: ChannelStatus;
  phone: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_externalChannel_phone | null;
  email: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_externalChannel_email | null;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_nutshellChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_nutshellChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  phone: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_nutshellChannel_phone | null;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_bestEntity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_bestEntity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_bestEntity_Contact_accounts_primary | null;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_bestEntity_Contact_accounts;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
}

export type GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_bestEntity = GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_bestEntity_Lead | GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_bestEntity_Contact | GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_bestEntity_Account;

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_stubEntity {
  __typename: "StubEntity";
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrlPath: string;
  initials: string;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export type GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_assignee = GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_assignee_Team | GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_assignee_User;

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary | null;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_contacts_primaryEdge_node;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_contacts_primaryEdge | null;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_accounts_primaryEdge_node;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_accounts_primaryEdge | null;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_stages_edges {
  __typename: "LeadStagesEdge";
  node: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_stages_edges_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_stages_current | null;
  /**
   * A list of edges.
   */
  edges: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_stages_edges[];
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_accounts;
  /**
   * Stageset associated with the given lead
   */
  stageset: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_stageset | null;
  /**
   * Stages for the lead
   */
  stages: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_stages;
  /**
   * The list of tags on this lead
   */
  tags: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads_tags[];
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this thread is open
   */
  isOpen: boolean;
  /**
   * Whether this thread is active
   */
  isActive: boolean;
  /**
   * The effective status of this thread
   */
  effectiveStatus: ThreadStatus;
  threadSummary: string | null;
  /**
   * Whether this thread can be archived
   */
  canArchive: boolean;
  /**
   * Whether this thread can be reopened
   */
  canReopen: boolean;
  /**
   * Whether this thread is assigned to the current user
   */
  isAssignedToCurrentUser: boolean;
  /**
   * The bot status of this thread
   */
  botStatus: ThreadBotStatus;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_displayMessage | null;
  /**
   * The user who created this thread
   */
  creatorUser: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_creatorUser | null;
  /**
   * The time this thread was created
   */
  createdTime: any;
  /**
   * The time this thread is snoozed until
   */
  snoozedUntilTime: any | null;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The user or team assigned to this thread
   */
  owner: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_owner | null;
  /**
   * The external channel this thread is related to
   */
  externalChannel: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_externalChannel;
  /**
   * The internal nutshell channel this thread is related to
   */
  nutshellChannel: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_nutshellChannel;
  /**
   * The best entity associated with this thread
   */
  bestEntity: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_bestEntity | null;
  /**
   * The Shelly entity only if this thread is on the stub Shelly channel
   */
  stubEntity: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_stubEntity | null;
  /**
   * The leads associated with this thread
   */
  relatedLeads: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread_relatedLeads[] | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
  /**
   * Whether this thread has unread messages
   */
  isUnread: boolean;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel_threads {
  __typename: "InboxChannelThreadsConnection";
  /**
   * The latest thread (open or closed) on this channel
   */
  latestThread: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads_latestThread | null;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The number of closed threads on this channel.
   */
  closedCount: number;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value_channel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
  threads: GetRelatedTextables_relatedTextables_phones_all_value_channel_threads;
}

export interface GetRelatedTextables_relatedTextables_phones_all_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The inbox channel of this phone number
   */
  channel: GetRelatedTextables_relatedTextables_phones_all_value_channel | null;
}

export interface GetRelatedTextables_relatedTextables_phones_all {
  __typename: "Phone";
  id: string;
  name: string;
  isFormer: boolean;
  value: GetRelatedTextables_relatedTextables_phones_all_value;
}

export interface GetRelatedTextables_relatedTextables_phones {
  __typename: "PhonesConnection";
  /**
   * An ordered collection of values
   */
  all: GetRelatedTextables_relatedTextables_phones_all[];
}

export interface GetRelatedTextables_relatedTextables {
  __typename: "Account" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  initials: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetRelatedTextables_relatedTextables_phones;
}

export interface GetRelatedTextables {
  /**
   * Returns related textable peeps for a given entity
   */
  relatedTextables: GetRelatedTextables_relatedTextables[];
}

export interface GetRelatedTextablesVariables {
  entityId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetScheduledMessages
// ====================================================

export interface GetScheduledMessages_scheduledMessages_edges_node_changes {
  __typename: "ChangeLogChange";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attrbute changed by the entry
   */
  attribute: string;
  /**
   * The old value before the change
   */
  oldValue: string | null;
  /**
   * The new value after the change
   */
  newValue: string | null;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_actor_Account {
  __typename: "Account" | "Form" | "MaUrl";
}

export interface GetScheduledMessages_scheduledMessages_edges_node_actor_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_actor_Contact {
  __typename: "Contact";
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_actor_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type GetScheduledMessages_scheduledMessages_edges_node_actor = GetScheduledMessages_scheduledMessages_edges_node_actor_Account | GetScheduledMessages_scheduledMessages_edges_node_actor_User | GetScheduledMessages_scheduledMessages_edges_node_actor_Contact | GetScheduledMessages_scheduledMessages_edges_node_actor_Origin;

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Activity {
  __typename: "Activity" | "Email" | "EmailQueued" | "EmailInteraction" | "Origin" | "Submission" | "Account" | "Contact" | "Lead" | "ConstantContactContactTrackingActivity" | "Comment" | "TimelineEventPayloadUnknownType" | "Chat" | "EntityAttributeValueFile" | "Session" | "AccountRelationshipChange" | "Quote" | "DocumentView" | "Invoice" | "Contract" | "LeadClonePayload" | "AccountContactFormerStatusChange";
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Assignment_assignmentEntity_Account {
  __typename: "Account" | "Activity" | "Contact" | "Lead" | "UnknownEntityType";
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Assignment_assignmentEntity_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type GetScheduledMessages_scheduledMessages_edges_node_payload_Assignment_assignmentEntity = GetScheduledMessages_scheduledMessages_edges_node_payload_Assignment_assignmentEntity_Account | GetScheduledMessages_scheduledMessages_edges_node_payload_Assignment_assignmentEntity_Thread;

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Assignment_assigneeEntity {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Assignment {
  __typename: "Assignment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity that was assigned
   */
  assignmentEntity: GetScheduledMessages_scheduledMessages_edges_node_payload_Assignment_assignmentEntity;
  /**
   * The entity to which the assignment was made
   */
  assigneeEntity: GetScheduledMessages_scheduledMessages_edges_node_payload_Assignment_assigneeEntity;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Thread_recipientEmailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Thread_startedFromUrl {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https:      // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
  /**
   * The `/features` part of https: // www.nutshell.com/features?utm_source=Google
   */
  path: string | null;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The time this thread was created
   */
  createdTime: any;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
  /**
   * The shared inbox address this email thread was delivered to
   */
  recipientEmailAddress: GetScheduledMessages_scheduledMessages_edges_node_payload_Thread_recipientEmailAddress | null;
  /**
   * The URL that this thread was started from
   */
  startedFromUrl: GetScheduledMessages_scheduledMessages_edges_node_payload_Thread_startedFromUrl | null;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The images in the message
   */
  images: string[];
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_owner_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_owner_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export type GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_owner = GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_owner_User | GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_owner_Team;

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_externalChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_externalChannel_email {
  __typename: "NutEmailAddress";
  address: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  sessionId: string | null;
  status: ChannelStatus;
  phone: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_externalChannel_phone | null;
  email: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_externalChannel_email | null;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_nutshellChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_nutshellChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  phone: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_nutshellChannel_phone | null;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts_primary | null;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
}

export type GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity = GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Lead | GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Contact | GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Account;

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_stubEntity {
  __typename: "StubEntity";
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrlPath: string;
  initials: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export type GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_assignee = GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_Team | GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_User;

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary | null;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge | null;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge_node;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge | null;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges {
  __typename: "LeadStagesEdge";
  node: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages_current | null;
  /**
   * A list of edges.
   */
  edges: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges[];
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_accounts;
  /**
   * Stageset associated with the given lead
   */
  stageset: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stageset | null;
  /**
   * Stages for the lead
   */
  stages: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages;
  /**
   * The list of tags on this lead
   */
  tags: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_tags[];
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this thread is open
   */
  isOpen: boolean;
  /**
   * Whether this thread is active
   */
  isActive: boolean;
  /**
   * The effective status of this thread
   */
  effectiveStatus: ThreadStatus;
  threadSummary: string | null;
  /**
   * Whether this thread can be archived
   */
  canArchive: boolean;
  /**
   * Whether this thread can be reopened
   */
  canReopen: boolean;
  /**
   * Whether this thread is assigned to the current user
   */
  isAssignedToCurrentUser: boolean;
  /**
   * The bot status of this thread
   */
  botStatus: ThreadBotStatus;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_displayMessage | null;
  /**
   * The user who created this thread
   */
  creatorUser: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_creatorUser | null;
  /**
   * The time this thread was created
   */
  createdTime: any;
  /**
   * The time this thread is snoozed until
   */
  snoozedUntilTime: any | null;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The user or team assigned to this thread
   */
  owner: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_owner | null;
  /**
   * The external channel this thread is related to
   */
  externalChannel: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_externalChannel;
  /**
   * The internal nutshell channel this thread is related to
   */
  nutshellChannel: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_nutshellChannel;
  /**
   * The best entity associated with this thread
   */
  bestEntity: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_bestEntity | null;
  /**
   * The Shelly entity only if this thread is on the stub Shelly channel
   */
  stubEntity: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_stubEntity | null;
  /**
   * The leads associated with this thread
   */
  relatedLeads: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads[] | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
  /**
   * Whether this thread has unread messages
   */
  isUnread: boolean;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads {
  __typename: "InboxChannelThreadsConnection";
  /**
   * The latest thread (open or closed) on this channel
   */
  latestThread: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads_latestThread | null;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The number of closed threads on this channel.
   */
  closedCount: number;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
  threads: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel_threads;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external channel this thread is related to
   */
  externalChannel: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread_externalChannel;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_senderEmailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_edition_campaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_edition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The editions of the drip sequence
   */
  editions: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_edition_campaign_editions;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_edition_campaign;
  /**
   * The position of the edition in the drip sequence
   */
  position: number;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  originType: OriginType;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_booking_additionalAttendees_emailAddresses;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The start time of this booking
   */
  startTime: any;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_booking_additionalAttendees | null)[];
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export type GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_fields_edges_fieldValue = GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle | GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields;

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_fields_edges_fieldValue | null;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_fields_edges[];
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The booking associated with this submission (if Scheduler)
   */
  booking: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_booking | null;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission_fields;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Message {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: MessageStatus;
  /**
   * The thread this message is part of
   */
  thread: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_thread;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  senderEmailAddress: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_senderEmailAddress | null;
  /**
   * Whether this message is a Nutshell system response
   */
  isNutshellSystemResponse: boolean;
  /**
   * The user who created this thread
   */
  creatorUser: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_creatorUser | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The time the message was read
   */
  readTime: any | null;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The edition of the message
   */
  edition: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_edition | null;
  /**
   * Whether this message can be canceled
   */
  isCancelable: boolean;
  /**
   * The reaction to the message
   */
  reaction: string | null;
  /**
   * The reason the message failed to send
   */
  errorReason: ErrorReason | null;
  /**
   * The URL of the media in the message
   */
  mediaUrl: string | null;
  /**
   * The origin of the user who created this thread
   */
  creatorOrigin: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_creatorOrigin | null;
  /**
   * The images in the message
   */
  images: string[];
  /**
   * The submission for a form or scheduler booking related to the chatbot goal
   */
  submission: GetScheduledMessages_scheduledMessages_edges_node_payload_Message_submission | null;
}

export interface GetScheduledMessages_scheduledMessages_edges_node_payload_Note {
  __typename: "Note";
  /**
   * The plain text (i.e., no HTML/rich text, no NutMark for @-mention tokenizing) representation of the Note text
   */
  body: string | null;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export type GetScheduledMessages_scheduledMessages_edges_node_payload = GetScheduledMessages_scheduledMessages_edges_node_payload_Activity | GetScheduledMessages_scheduledMessages_edges_node_payload_Assignment | GetScheduledMessages_scheduledMessages_edges_node_payload_Thread | GetScheduledMessages_scheduledMessages_edges_node_payload_Message | GetScheduledMessages_scheduledMessages_edges_node_payload_Note;

export interface GetScheduledMessages_scheduledMessages_edges_node {
  __typename: "TimelineEvent";
  changeTime: any;
  /**
   * The type of change i.e. created, modified, deleted, etc
   */
  changeType: ChangeType;
  changes: GetScheduledMessages_scheduledMessages_edges_node_changes[];
  /**
   * The entity that triggered the change_log entry
   */
  actor: GetScheduledMessages_scheduledMessages_edges_node_actor;
  payload: GetScheduledMessages_scheduledMessages_edges_node_payload;
}

export interface GetScheduledMessages_scheduledMessages_edges {
  __typename: "TimelineEventsEdge";
  node: GetScheduledMessages_scheduledMessages_edges_node;
}

export interface GetScheduledMessages_scheduledMessages {
  __typename: "TimelineEventsConnection";
  /**
   * A list of edges.
   */
  edges: GetScheduledMessages_scheduledMessages_edges[];
}

export interface GetScheduledMessages {
  /**
   * A list of scheduled messages associated with a given channel.
   */
  scheduledMessages: GetScheduledMessages_scheduledMessages;
}

export interface GetScheduledMessagesVariables {
  channelId: string;
  threadId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: IsNumberVerified
// ====================================================

export interface IsNumberVerified {
  isNumberVerified: boolean;
}

export interface IsNumberVerifiedVariables {
  phoneNumber: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DisconnectWhatsApp
// ====================================================

export interface DisconnectWhatsApp {
  /**
   * Disconnects the WhatsApp integration.
   */
  whatsAppDisconnect: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: WhatsAppSyncInitiate
// ====================================================

export interface WhatsAppSyncInitiate {
  /**
   * Initiate a sync of WhatsApp contacts and messages.
   */
  whatsAppSyncInitiate: boolean | null;
}

export interface WhatsAppSyncInitiateVariables {
  input: WhatsAppSyncInitiateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ToggleWhatsAppIsEnabled
// ====================================================

export interface ToggleWhatsAppIsEnabled_toggleWhatsAppIsEnabled {
  __typename: "WhatsAppIntegration";
  /**
   * Whether the user has a whatsapp access token in the DB
   */
  hasAuthToken: boolean;
  /**
   * Whether the whatsapp integration is enabled
   */
  isEnabled: boolean;
  /**
   * The phone number of the whatsapp user
   */
  userPhoneNumber: string | null;
}

export interface ToggleWhatsAppIsEnabled {
  /**
   * Toggle the WhatsApp integration.
   */
  toggleWhatsAppIsEnabled: ToggleWhatsAppIsEnabled_toggleWhatsAppIsEnabled;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateInboundWhatsAppRules
// ====================================================

export interface UpdateInboundWhatsAppRules_inboundWhatsAppRulesUpdate_assignment_assignedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateInboundWhatsAppRules_inboundWhatsAppRulesUpdate_assignment {
  __typename: "InboundRulesAssignment";
  /**
   * The user to assign inbound SMS thread to.
   */
  assignedUser: UpdateInboundWhatsAppRules_inboundWhatsAppRulesUpdate_assignment_assignedUser | null;
}

export interface UpdateInboundWhatsAppRules_inboundWhatsAppRulesUpdate {
  __typename: "InboundWhatsAppRules";
  /**
   * The assignment rule for inbound WhatsApp.
   */
  assignment: UpdateInboundWhatsAppRules_inboundWhatsAppRulesUpdate_assignment;
}

export interface UpdateInboundWhatsAppRules {
  /**
   * Updates the inbound WhatsApp rules for an sms.
   */
  inboundWhatsAppRulesUpdate: UpdateInboundWhatsAppRules_inboundWhatsAppRulesUpdate | null;
}

export interface UpdateInboundWhatsAppRulesVariables {
  input: InboundWhatsAppRulesUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetInboundWhatsAppRules
// ====================================================

export interface GetInboundWhatsAppRules_inboundWhatsAppRules_assignment_assignedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetInboundWhatsAppRules_inboundWhatsAppRules_assignment {
  __typename: "InboundRulesAssignment";
  strategy: ChatAssignmentStrategyEnum;
  /**
   * The user to assign inbound SMS thread to.
   */
  assignedUser: GetInboundWhatsAppRules_inboundWhatsAppRules_assignment_assignedUser | null;
}

export interface GetInboundWhatsAppRules_inboundWhatsAppRules_leadCreation_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetInboundWhatsAppRules_inboundWhatsAppRules_leadCreation_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetInboundWhatsAppRules_inboundWhatsAppRules_leadCreation {
  __typename: "InboundRulesLeadCreation";
  /**
   * Whether lead creation is enabled.
   */
  enabled: boolean;
  /**
   * The stageset to use for lead creation.
   */
  stageset: GetInboundWhatsAppRules_inboundWhatsAppRules_leadCreation_stageset | null;
  /**
   * The tags to apply to the lead.
   */
  tags: GetInboundWhatsAppRules_inboundWhatsAppRules_leadCreation_tags[] | null;
}

export interface GetInboundWhatsAppRules_inboundWhatsAppRules {
  __typename: "InboundWhatsAppRules";
  /**
   * The assignment rule for inbound WhatsApp.
   */
  assignment: GetInboundWhatsAppRules_inboundWhatsAppRules_assignment;
  /**
   * The lead creation rule for inbound WhatsApp.
   */
  leadCreation: GetInboundWhatsAppRules_inboundWhatsAppRules_leadCreation;
}

export interface GetInboundWhatsAppRules {
  /**
   * The rules for inbound WhatsApp.
   */
  inboundWhatsAppRules: GetInboundWhatsAppRules_inboundWhatsAppRules;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWhatsAppIntegration
// ====================================================

export interface GetWhatsAppIntegration_whatsAppIntegration_contactSync {
  __typename: "WhatsAppSyncStatus";
  /**
   * The sync status (not_started, in_progress, completed, failed)
   */
  status: WhatsAppSyncStatusEnum;
  /**
   * Error message if sync failed
   */
  error: string | null;
}

export interface GetWhatsAppIntegration_whatsAppIntegration_messageSync {
  __typename: "WhatsAppSyncStatus";
  /**
   * The sync status (not_started, in_progress, completed, failed)
   */
  status: WhatsAppSyncStatusEnum;
  /**
   * Error message if sync failed
   */
  error: string | null;
}

export interface GetWhatsAppIntegration_whatsAppIntegration_origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetWhatsAppIntegration_whatsAppIntegration {
  __typename: "WhatsAppIntegration";
  /**
   * Whether the user has a whatsapp access token in the DB
   */
  hasAuthToken: boolean;
  /**
   * Whether the whatsapp integration is enabled
   */
  isEnabled: boolean;
  /**
   * The phone number of the whatsapp user
   */
  userPhoneNumber: string | null;
  /**
   * Whether the whatsapp number is also connected via the whatsapp business app
   */
  isOnBusinessApp: boolean;
  /**
   * Contact sync status information
   */
  contactSync: GetWhatsAppIntegration_whatsAppIntegration_contactSync;
  /**
   * Message history sync status information
   */
  messageSync: GetWhatsAppIntegration_whatsAppIntegration_messageSync;
  shouldSyncContacts: boolean;
  shouldSyncMessages: boolean;
  /**
   * The ID of the WhatsApp origin for contact filtering
   */
  origin: GetWhatsAppIntegration_whatsAppIntegration_origin;
}

export interface GetWhatsAppIntegration {
  /**
   * Returns details about the whatsapp integration
   */
  whatsAppIntegration: GetWhatsAppIntegration_whatsAppIntegration;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: FeedbackSubmit
// ====================================================

export interface FeedbackSubmit_feedbackSubmit {
  __typename: "FeedbackSubmitPayload";
  /**
   * Whether the feedback was submitted successfully
   */
  success: boolean;
}

export interface FeedbackSubmit {
  /**
   * Submits internal feedback for Nutshell tracking
   */
  feedbackSubmit: FeedbackSubmit_feedbackSubmit;
}

export interface FeedbackSubmitVariables {
  input: FeedbackSubmitInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetFormsForLandingPages
// ====================================================

export interface GetFormsForLandingPages_forms_edges_node_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetFormsForLandingPages_forms_edges_node {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  creatorUser: GetFormsForLandingPages_forms_edges_node_creatorUser | null;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
}

export interface GetFormsForLandingPages_forms_edges {
  __typename: "FormsEdge";
  node: GetFormsForLandingPages_forms_edges_node;
}

export interface GetFormsForLandingPages_forms {
  __typename: "FormsConnection";
  /**
   * A list of edges.
   */
  edges: GetFormsForLandingPages_forms_edges[];
}

export interface GetFormsForLandingPages {
  /**
   * Returns a connection of Nutshell Web Forms
   */
  forms: GetFormsForLandingPages_forms;
}

export interface GetFormsForLandingPagesVariables {
  search?: string | null;
  sort: FormSortType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMeetingsForLandingPages
// ====================================================

export interface GetMeetingsForLandingPages_meetings_validity_issues_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetMeetingsForLandingPages_meetings_validity_issues {
  __typename: "MeetingValidityIssue";
  /**
   * The user tied to this issue
   */
  user: GetMeetingsForLandingPages_meetings_validity_issues_user;
  /**
   * The issue type of this issue
   */
  issueType: ValidityIssueType;
}

export interface GetMeetingsForLandingPages_meetings_validity {
  __typename: "MeetingValidity";
  /**
   * A list of issues with host users tied to this meeting
   */
  issues: GetMeetingsForLandingPages_meetings_validity_issues[];
  /**
   * Whether this meeting can be booked
   */
  isBookable: boolean;
}

export interface GetMeetingsForLandingPages_meetings_creator {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
}

export interface GetMeetingsForLandingPages_meetings_cohosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetMeetingsForLandingPages_meetings_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetMeetingsForLandingPages_meetings_bookings {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMeetingsForLandingPages_meetings {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * The type of this meeting
   */
  meetingType: MeetingType;
  /**
   * Whether this meeting is active
   */
  isActive: boolean;
  /**
   * The DateTime that represents when the meeting was deleted
   */
  deletedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The validity of this meeting
   */
  validity: GetMeetingsForLandingPages_meetings_validity;
  /**
   * The primary host for this meeting
   */
  creator: GetMeetingsForLandingPages_meetings_creator;
  /**
   * The cohosts of this meeting, not including primary host
   */
  cohosts: GetMeetingsForLandingPages_meetings_cohosts[];
  /**
   * The activity type for this meeting
   */
  activityType: GetMeetingsForLandingPages_meetings_activityType;
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number;
  /**
   * The bookings of this meeting
   */
  bookings: GetMeetingsForLandingPages_meetings_bookings[];
}

export interface GetMeetingsForLandingPages {
  /**
   * Returns scheduler meetings
   */
  meetings: GetMeetingsForLandingPages_meetings[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateLandingPage
// ====================================================

export interface CreateLandingPage_pageCreate_page_publishedVersion_publisherUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateLandingPage_pageCreate_page_publishedVersion {
  __typename: "PageVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that published this landing page version
   */
  publisherUser: CreateLandingPage_pageCreate_page_publishedVersion_publisherUser | null;
}

export interface CreateLandingPage_pageCreate_page {
  __typename: "Page";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this landing page
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this landing page was created
   */
  createdTime: any;
  /**
   * The timestamp this landing page was last modified
   */
  lastModifiedTime: any;
  /**
   * The custom domain published version URL
   */
  customPublishedUrl: string | null;
  /**
   * The Nutshell hosted published version URL
   */
  nutshellPublishedUrl: string;
  /**
   * Whether or not this landing page has unpublished changes
   */
  hasUnpublishedChanges: boolean;
  /**
   * Page thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The status of this page
   */
  status: PageStatus;
  /**
   * The number of times this page has been viewed
   */
  numViews: number;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The current published version
   */
  publishedVersion: CreateLandingPage_pageCreate_page_publishedVersion | null;
}

export interface CreateLandingPage_pageCreate {
  __typename: "PageCreatePayload";
  /**
   * The newly created page
   */
  page: CreateLandingPage_pageCreate_page | null;
}

export interface CreateLandingPage {
  /**
   * Creates a new landing page
   */
  pageCreate: CreateLandingPage_pageCreate;
}

export interface CreateLandingPageVariables {
  input: PageCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteLandingPage
// ====================================================

export interface DeleteLandingPage_pageDelete_page_publishedVersion_publisherUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DeleteLandingPage_pageDelete_page_publishedVersion {
  __typename: "PageVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that published this landing page version
   */
  publisherUser: DeleteLandingPage_pageDelete_page_publishedVersion_publisherUser | null;
}

export interface DeleteLandingPage_pageDelete_page {
  __typename: "Page";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this landing page
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this landing page was created
   */
  createdTime: any;
  /**
   * The timestamp this landing page was last modified
   */
  lastModifiedTime: any;
  /**
   * The custom domain published version URL
   */
  customPublishedUrl: string | null;
  /**
   * The Nutshell hosted published version URL
   */
  nutshellPublishedUrl: string;
  /**
   * Whether or not this landing page has unpublished changes
   */
  hasUnpublishedChanges: boolean;
  /**
   * Page thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The status of this page
   */
  status: PageStatus;
  /**
   * The number of times this page has been viewed
   */
  numViews: number;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The current published version
   */
  publishedVersion: DeleteLandingPage_pageDelete_page_publishedVersion | null;
}

export interface DeleteLandingPage_pageDelete {
  __typename: "PageDeletePayload";
  /**
   * The deleted page
   */
  page: DeleteLandingPage_pageDelete_page | null;
}

export interface DeleteLandingPage {
  /**
   * Deletes a landing page
   */
  pageDelete: DeleteLandingPage_pageDelete;
}

export interface DeleteLandingPageVariables {
  input: PageDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DiscardChanges
// ====================================================

export interface DiscardChanges_pageDiscardChanges_page {
  __typename: "Page";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DiscardChanges_pageDiscardChanges {
  __typename: "PageDiscardChangesPayload";
  /**
   * The page
   */
  page: DiscardChanges_pageDiscardChanges_page | null;
}

export interface DiscardChanges {
  /**
   * Updates the editable version of a landing page.
   */
  pageDiscardChanges: DiscardChanges_pageDiscardChanges;
}

export interface DiscardChangesVariables {
  input: PageDiscardChangesInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DuplicateLandingPage
// ====================================================

export interface DuplicateLandingPage_pageDuplicate_page_publishedVersion_publisherUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DuplicateLandingPage_pageDuplicate_page_publishedVersion {
  __typename: "PageVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that published this landing page version
   */
  publisherUser: DuplicateLandingPage_pageDuplicate_page_publishedVersion_publisherUser | null;
}

export interface DuplicateLandingPage_pageDuplicate_page {
  __typename: "Page";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this landing page
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this landing page was created
   */
  createdTime: any;
  /**
   * The timestamp this landing page was last modified
   */
  lastModifiedTime: any;
  /**
   * The custom domain published version URL
   */
  customPublishedUrl: string | null;
  /**
   * The Nutshell hosted published version URL
   */
  nutshellPublishedUrl: string;
  /**
   * Whether or not this landing page has unpublished changes
   */
  hasUnpublishedChanges: boolean;
  /**
   * Page thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The status of this page
   */
  status: PageStatus;
  /**
   * The number of times this page has been viewed
   */
  numViews: number;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The current published version
   */
  publishedVersion: DuplicateLandingPage_pageDuplicate_page_publishedVersion | null;
}

export interface DuplicateLandingPage_pageDuplicate {
  __typename: "PageDuplicatePayload";
  /**
   * The newly created page
   */
  page: DuplicateLandingPage_pageDuplicate_page | null;
}

export interface DuplicateLandingPage {
  /**
   * Duplicates a pre-existing landing page
   */
  pageDuplicate: DuplicateLandingPage_pageDuplicate;
}

export interface DuplicateLandingPageVariables {
  input: PageDuplicateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: PreviewPage
// ====================================================

export interface PreviewPage_pagePreview_page_editableVersion {
  __typename: "PageVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The HTML string representing the materialized page
   */
  htmlMaterialized: string;
}

export interface PreviewPage_pagePreview_page {
  __typename: "Page";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this landing page
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * An editable version of this landing page
   */
  editableVersion: PreviewPage_pagePreview_page_editableVersion;
}

export interface PreviewPage_pagePreview {
  __typename: "PagePreviewPayload";
  /**
   * The updated page to preview.
   */
  page: PreviewPage_pagePreview_page | null;
}

export interface PreviewPage {
  /**
   * Requests an updated preview of the editable version, which materialized real HTML for prevewing
   */
  pagePreview: PreviewPage_pagePreview;
}

export interface PreviewPageVariables {
  input: PagePreviewInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: PublishPage
// ====================================================

export interface PublishPage_pagePublish_page_publishedVersion_publisherUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface PublishPage_pagePublish_page_publishedVersion {
  __typename: "PageVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that published this landing page version
   */
  publisherUser: PublishPage_pagePublish_page_publishedVersion_publisherUser | null;
  /**
   * The JSON string representing the BEE page body
   */
  beeBodyJson: string;
  /**
   * The HTML string representing the materialized page
   */
  htmlMaterialized: string;
}

export interface PublishPage_pagePublish_page_subdomainRecord {
  __typename: "Subdomain";
  /**
   * The ID of the em_from_domain row this record corresponds to, as each domain is split into multiple rows
   */
  fromDomainId: string;
  /**
   * The record of this DNS record
   */
  record: string;
  /**
   * The record of this DNS record
   */
  formattedRecord: string;
  /**
   * Where this subdomain is verified
   */
  isVerified: boolean;
}

export interface PublishPage_pagePublish_page_editableVersion {
  __typename: "PageVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The JSON string representing the BEE page body
   */
  beeBodyJson: string;
}

export interface PublishPage_pagePublish_page {
  __typename: "Page";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this landing page
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this landing page was created
   */
  createdTime: any;
  /**
   * The timestamp this landing page was last modified
   */
  lastModifiedTime: any;
  /**
   * The custom domain published version URL
   */
  customPublishedUrl: string | null;
  /**
   * The Nutshell hosted published version URL
   */
  nutshellPublishedUrl: string;
  /**
   * Whether or not this landing page has unpublished changes
   */
  hasUnpublishedChanges: boolean;
  /**
   * Page thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The status of this page
   */
  status: PageStatus;
  /**
   * The number of times this page has been viewed
   */
  numViews: number;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The current published version
   */
  publishedVersion: PublishPage_pagePublish_page_publishedVersion | null;
  /**
   * The url slug of this landing page
   */
  urlSlug: string;
  /**
   * The embed code for embedding this landing page into an iframe
   */
  iframeEmbedCode: string;
  /**
   * The subdomain record tied to this page
   */
  subdomainRecord: PublishPage_pagePublish_page_subdomainRecord | null;
  /**
   * An editable version of this landing page
   */
  editableVersion: PublishPage_pagePublish_page_editableVersion;
}

export interface PublishPage_pagePublish {
  __typename: "PagePublishPayload";
  /**
   * The published page.
   */
  page: PublishPage_pagePublish_page | null;
}

export interface PublishPage {
  /**
   * Publishes a new version of a Nutshell page.
   */
  pagePublish: PublishPage_pagePublish;
}

export interface PublishPageVariables {
  input: PagePublishInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TogglePageStatus
// ====================================================

export interface TogglePageStatus_togglePageStatus_page_publishedVersion_publisherUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface TogglePageStatus_togglePageStatus_page_publishedVersion {
  __typename: "PageVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that published this landing page version
   */
  publisherUser: TogglePageStatus_togglePageStatus_page_publishedVersion_publisherUser | null;
  /**
   * The JSON string representing the BEE page body
   */
  beeBodyJson: string;
  /**
   * The HTML string representing the materialized page
   */
  htmlMaterialized: string;
}

export interface TogglePageStatus_togglePageStatus_page_subdomainRecord {
  __typename: "Subdomain";
  /**
   * The ID of the em_from_domain row this record corresponds to, as each domain is split into multiple rows
   */
  fromDomainId: string;
  /**
   * The record of this DNS record
   */
  record: string;
  /**
   * The record of this DNS record
   */
  formattedRecord: string;
  /**
   * Where this subdomain is verified
   */
  isVerified: boolean;
}

export interface TogglePageStatus_togglePageStatus_page_editableVersion {
  __typename: "PageVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The JSON string representing the BEE page body
   */
  beeBodyJson: string;
}

export interface TogglePageStatus_togglePageStatus_page {
  __typename: "Page";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this landing page
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this landing page was created
   */
  createdTime: any;
  /**
   * The timestamp this landing page was last modified
   */
  lastModifiedTime: any;
  /**
   * The custom domain published version URL
   */
  customPublishedUrl: string | null;
  /**
   * The Nutshell hosted published version URL
   */
  nutshellPublishedUrl: string;
  /**
   * Whether or not this landing page has unpublished changes
   */
  hasUnpublishedChanges: boolean;
  /**
   * Page thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The status of this page
   */
  status: PageStatus;
  /**
   * The number of times this page has been viewed
   */
  numViews: number;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The current published version
   */
  publishedVersion: TogglePageStatus_togglePageStatus_page_publishedVersion | null;
  /**
   * The url slug of this landing page
   */
  urlSlug: string;
  /**
   * The embed code for embedding this landing page into an iframe
   */
  iframeEmbedCode: string;
  /**
   * The subdomain record tied to this page
   */
  subdomainRecord: TogglePageStatus_togglePageStatus_page_subdomainRecord | null;
  /**
   * An editable version of this landing page
   */
  editableVersion: TogglePageStatus_togglePageStatus_page_editableVersion;
}

export interface TogglePageStatus_togglePageStatus {
  __typename: "SupportPageStatusTogglePayload";
  /**
   * The updated page.
   */
  page: TogglePageStatus_togglePageStatus_page | null;
}

export interface TogglePageStatus {
  /**
   * Support use only: updates the status of a Nutshell page.
   */
  togglePageStatus: TogglePageStatus_togglePageStatus;
}

export interface TogglePageStatusVariables {
  input: SupportPageStatusToggleInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UndeleteLandingPage
// ====================================================

export interface UndeleteLandingPage_pageUndelete_page_publishedVersion_publisherUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UndeleteLandingPage_pageUndelete_page_publishedVersion {
  __typename: "PageVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that published this landing page version
   */
  publisherUser: UndeleteLandingPage_pageUndelete_page_publishedVersion_publisherUser | null;
}

export interface UndeleteLandingPage_pageUndelete_page {
  __typename: "Page";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this landing page
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this landing page was created
   */
  createdTime: any;
  /**
   * The timestamp this landing page was last modified
   */
  lastModifiedTime: any;
  /**
   * The custom domain published version URL
   */
  customPublishedUrl: string | null;
  /**
   * The Nutshell hosted published version URL
   */
  nutshellPublishedUrl: string;
  /**
   * Whether or not this landing page has unpublished changes
   */
  hasUnpublishedChanges: boolean;
  /**
   * Page thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The status of this page
   */
  status: PageStatus;
  /**
   * The number of times this page has been viewed
   */
  numViews: number;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The current published version
   */
  publishedVersion: UndeleteLandingPage_pageUndelete_page_publishedVersion | null;
}

export interface UndeleteLandingPage_pageUndelete {
  __typename: "PageUndeletePayload";
  /**
   * The undeleted page
   */
  page: UndeleteLandingPage_pageUndelete_page;
}

export interface UndeleteLandingPage {
  /**
   * Undeletes a landing page
   */
  pageUndelete: UndeleteLandingPage_pageUndelete;
}

export interface UndeleteLandingPageVariables {
  input: PageUndeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdatePage
// ====================================================

export interface UpdatePage_pageUpdate_page_publishedVersion_publisherUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdatePage_pageUpdate_page_publishedVersion {
  __typename: "PageVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that published this landing page version
   */
  publisherUser: UpdatePage_pageUpdate_page_publishedVersion_publisherUser | null;
  /**
   * The JSON string representing the BEE page body
   */
  beeBodyJson: string;
  /**
   * The HTML string representing the materialized page
   */
  htmlMaterialized: string;
}

export interface UpdatePage_pageUpdate_page_subdomainRecord {
  __typename: "Subdomain";
  /**
   * The ID of the em_from_domain row this record corresponds to, as each domain is split into multiple rows
   */
  fromDomainId: string;
  /**
   * The record of this DNS record
   */
  record: string;
  /**
   * The record of this DNS record
   */
  formattedRecord: string;
  /**
   * Where this subdomain is verified
   */
  isVerified: boolean;
}

export interface UpdatePage_pageUpdate_page_editableVersion {
  __typename: "PageVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The JSON string representing the BEE page body
   */
  beeBodyJson: string;
}

export interface UpdatePage_pageUpdate_page {
  __typename: "Page";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this landing page
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this landing page was created
   */
  createdTime: any;
  /**
   * The timestamp this landing page was last modified
   */
  lastModifiedTime: any;
  /**
   * The custom domain published version URL
   */
  customPublishedUrl: string | null;
  /**
   * The Nutshell hosted published version URL
   */
  nutshellPublishedUrl: string;
  /**
   * Whether or not this landing page has unpublished changes
   */
  hasUnpublishedChanges: boolean;
  /**
   * Page thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The status of this page
   */
  status: PageStatus;
  /**
   * The number of times this page has been viewed
   */
  numViews: number;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The current published version
   */
  publishedVersion: UpdatePage_pageUpdate_page_publishedVersion | null;
  /**
   * The url slug of this landing page
   */
  urlSlug: string;
  /**
   * The embed code for embedding this landing page into an iframe
   */
  iframeEmbedCode: string;
  /**
   * The subdomain record tied to this page
   */
  subdomainRecord: UpdatePage_pageUpdate_page_subdomainRecord | null;
  /**
   * An editable version of this landing page
   */
  editableVersion: UpdatePage_pageUpdate_page_editableVersion;
}

export interface UpdatePage_pageUpdate {
  __typename: "PageUpdatePayload";
  /**
   * The updated page.
   */
  page: UpdatePage_pageUpdate_page | null;
}

export interface UpdatePage {
  /**
   * Updates the editable version of a Nutshell page.
   */
  pageUpdate: UpdatePage_pageUpdate;
}

export interface UpdatePageVariables {
  input: PageUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLandingPageDomain
// ====================================================

export interface GetLandingPageDomain {
  /**
   * Returns the current set landing page domain (if exists).
   */
  landingPageDomain: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLandingPageStarters
// ====================================================

export interface GetLandingPageStarters_pageStarters {
  __typename: "PageStarter";
  /**
   * The id of the page starter
   */
  id: string;
  /**
   * The name of this page starter
   */
  name: string;
  /**
   * The thumbnail url of this page starter
   */
  thumbnailUrl: string | null;
  /**
   * The id of the associated starter page, only used for bucketing templates together
   */
  categoryId: string;
  /**
   * The name of the associated page category for bucketing
   */
  categoryName: string;
  /**
   * The background color of this page starter
   */
  backgroundColor: string;
}

export interface GetLandingPageStarters {
  /**
   * Returns a list of landing page starters
   */
  pageStarters: GetLandingPageStarters_pageStarters[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLandingPage
// ====================================================

export interface GetLandingPage_page_publishedVersion_publisherUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLandingPage_page_publishedVersion {
  __typename: "PageVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that published this landing page version
   */
  publisherUser: GetLandingPage_page_publishedVersion_publisherUser | null;
  /**
   * The JSON string representing the BEE page body
   */
  beeBodyJson: string;
  /**
   * The HTML string representing the materialized page
   */
  htmlMaterialized: string;
}

export interface GetLandingPage_page_subdomainRecord {
  __typename: "Subdomain";
  /**
   * The ID of the em_from_domain row this record corresponds to, as each domain is split into multiple rows
   */
  fromDomainId: string;
  /**
   * The record of this DNS record
   */
  record: string;
  /**
   * The record of this DNS record
   */
  formattedRecord: string;
  /**
   * Where this subdomain is verified
   */
  isVerified: boolean;
}

export interface GetLandingPage_page_editableVersion {
  __typename: "PageVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The JSON string representing the BEE page body
   */
  beeBodyJson: string;
}

export interface GetLandingPage_page {
  __typename: "Page";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this landing page
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this landing page was created
   */
  createdTime: any;
  /**
   * The timestamp this landing page was last modified
   */
  lastModifiedTime: any;
  /**
   * The custom domain published version URL
   */
  customPublishedUrl: string | null;
  /**
   * The Nutshell hosted published version URL
   */
  nutshellPublishedUrl: string;
  /**
   * Whether or not this landing page has unpublished changes
   */
  hasUnpublishedChanges: boolean;
  /**
   * Page thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The status of this page
   */
  status: PageStatus;
  /**
   * The number of times this page has been viewed
   */
  numViews: number;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The current published version
   */
  publishedVersion: GetLandingPage_page_publishedVersion | null;
  /**
   * The url slug of this landing page
   */
  urlSlug: string;
  /**
   * The embed code for embedding this landing page into an iframe
   */
  iframeEmbedCode: string;
  /**
   * The subdomain record tied to this page
   */
  subdomainRecord: GetLandingPage_page_subdomainRecord | null;
  /**
   * An editable version of this landing page
   */
  editableVersion: GetLandingPage_page_editableVersion;
}

export interface GetLandingPage {
  /**
   * Returns a landing page by id
   */
  page: GetLandingPage_page;
}

export interface GetLandingPageVariables {
  pageId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLandingPages
// ====================================================

export interface GetLandingPages_pages_publishedVersion_publisherUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLandingPages_pages_publishedVersion {
  __typename: "PageVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that published this landing page version
   */
  publisherUser: GetLandingPages_pages_publishedVersion_publisherUser | null;
}

export interface GetLandingPages_pages {
  __typename: "Page";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this landing page
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this landing page was created
   */
  createdTime: any;
  /**
   * The timestamp this landing page was last modified
   */
  lastModifiedTime: any;
  /**
   * The custom domain published version URL
   */
  customPublishedUrl: string | null;
  /**
   * The Nutshell hosted published version URL
   */
  nutshellPublishedUrl: string;
  /**
   * Whether or not this landing page has unpublished changes
   */
  hasUnpublishedChanges: boolean;
  /**
   * Page thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The status of this page
   */
  status: PageStatus;
  /**
   * The number of times this page has been viewed
   */
  numViews: number;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The current published version
   */
  publishedVersion: GetLandingPages_pages_publishedVersion | null;
}

export interface GetLandingPages {
  /**
   * Returns a list of landing pages
   */
  pages: GetLandingPages_pages[];
}

export interface GetLandingPagesVariables {
  archived?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLeadDripSequences
// ====================================================

export interface GetLeadDripSequences_lead_contacts_edges_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  id: string;
  name: string;
}

export interface GetLeadDripSequences_lead_contacts_edges_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetLeadDripSequences_lead_contacts_edges_node_emailAddresses_primary | null;
}

export interface GetLeadDripSequences_lead_contacts_edges_node_dripProgressions_currentNode {
  __typename: "SmartSequenceNode";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetLeadDripSequences_lead_contacts_edges_node_dripProgressions_campaign_startTrigger {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface GetLeadDripSequences_lead_contacts_edges_node_dripProgressions_campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this goal. This is essentially just the stringified
   * version of the goal’s conditions, but because a goal can have multiple
   * conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface GetLeadDripSequences_lead_contacts_edges_node_dripProgressions_campaign_from_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadDripSequences_lead_contacts_edges_node_dripProgressions_campaign_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: GetLeadDripSequences_lead_contacts_edges_node_dripProgressions_campaign_from_creatorUser | null;
}

export interface GetLeadDripSequences_lead_contacts_edges_node_dripProgressions_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * When a lead is closed, should drip sequences stop?
   */
  isStopOnLeadClose: boolean;
  /**
   * The start trigger for the drip sequence
   */
  startTrigger: GetLeadDripSequences_lead_contacts_edges_node_dripProgressions_campaign_startTrigger | null;
  /**
   * The newly created Nutshell goal
   */
  goal: GetLeadDripSequences_lead_contacts_edges_node_dripProgressions_campaign_goal | null;
  /**
   * The address to send this edition from
   */
  from: GetLeadDripSequences_lead_contacts_edges_node_dripProgressions_campaign_from | null;
}

export interface GetLeadDripSequences_lead_contacts_edges_node_dripProgressions_editions_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetLeadDripSequences_lead_contacts_edges_node_dripProgressions_editions_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetLeadDripSequences_lead_contacts_edges_node_dripProgressions_editions_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The URL that this edition links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  scheduledTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: GetLeadDripSequences_lead_contacts_edges_node_dripProgressions_editions_edition_emailTemplate | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: GetLeadDripSequences_lead_contacts_edges_node_dripProgressions_editions_edition_delay | null;
}

export interface GetLeadDripSequences_lead_contacts_edges_node_dripProgressions_editions {
  __typename: "DripProgressionEdition";
  /**
   * Whether this edition has been sent
   */
  sent: boolean;
  /**
   * The edition
   */
  edition: GetLeadDripSequences_lead_contacts_edges_node_dripProgressions_editions_edition;
}

export interface GetLeadDripSequences_lead_contacts_edges_node_dripProgressions {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * When this drip progression was created (when the contact entered the sequence)
   */
  createdTime: any;
  /**
   * When this progression stopped, or null if it is still active
   */
  stoppedTime: any | null;
  /**
   * Why this progression stopped, or null if it is still active
   */
  stoppedReason: DripProgressionStoppedReason | null;
  /**
   * The graph node this progression is currently on, if any. Null for legacy drip
   * progressions and for smart progressions without a current node.
   */
  currentNode: GetLeadDripSequences_lead_contacts_edges_node_dripProgressions_currentNode | null;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
  /**
   * Number of editions that have been sent so far for this progression. NOTE: This
   * can be inaccurate if editions are reordered or an edition is added to the
   * start of the drip after a progression has started. This is ok! We want this
   * number to represent the number of prior active editions, even if they aren’t always sent.
   */
  numEditionsSent: number;
  /**
   * The drip sequence for this drip progressions
   */
  campaign: GetLeadDripSequences_lead_contacts_edges_node_dripProgressions_campaign;
  /**
   * All editions in the drip sequence for this drip progression, in send order
   */
  editions: GetLeadDripSequences_lead_contacts_edges_node_dripProgressions_editions[];
}

export interface GetLeadDripSequences_lead_contacts_edges_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetLeadDripSequences_lead_contacts_edges_node_emailAddresses;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * List of drip progressions for this contact. By default only active
   * progressions on non-cancelled campaigns are returned. Soft-deleted
   * progressions are always excluded.
   */
  dripProgressions: GetLeadDripSequences_lead_contacts_edges_node_dripProgressions[];
}

export interface GetLeadDripSequences_lead_contacts_edges {
  __typename: "LeadContactsEdge";
  node: GetLeadDripSequences_lead_contacts_edges_node;
}

export interface GetLeadDripSequences_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * A list of edges.
   */
  edges: GetLeadDripSequences_lead_contacts_edges[];
}

export interface GetLeadDripSequences_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetLeadDripSequences_lead_contacts;
}

export interface GetLeadDripSequences {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetLeadDripSequences_lead | null;
}

export interface GetLeadDripSequencesVariables {
  leadId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLeadManuallyStartedEmailSequences
// ====================================================

export interface GetLeadManuallyStartedEmailSequences_lead_queuedEmails_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
}

export interface GetLeadManuallyStartedEmailSequences_lead_queuedEmails_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadManuallyStartedEmailSequences_lead_queuedEmails_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The next message to be sent
   */
  nextUnsentEmail: GetLeadManuallyStartedEmailSequences_lead_queuedEmails_emailSequence_nextUnsentEmail | null;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  /**
   * The number of emails that have been sent
   */
  sentEmailsCount: number;
  emailSequenceTemplate: GetLeadManuallyStartedEmailSequences_lead_queuedEmails_emailSequence_emailSequenceTemplate | null;
  /**
   * True if this sequence has only one email
   */
  isSingleEmailSequence: boolean;
}

export interface GetLeadManuallyStartedEmailSequences_lead_queuedEmails_fromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadManuallyStartedEmailSequences_lead_queuedEmails_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadManuallyStartedEmailSequences_lead_queuedEmails_to {
  __typename: "NutEmailAddress";
  avatarEntity: GetLeadManuallyStartedEmailSequences_lead_queuedEmails_to_avatarEntity | null;
}

export interface GetLeadManuallyStartedEmailSequences_lead_queuedEmails {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent email sequence of this queued email.
   */
  emailSequence: GetLeadManuallyStartedEmailSequences_lead_queuedEmails_emailSequence | null;
  /**
   * The current status of this queued email.
   */
  status: EmailQueuedStatus;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  fromUser: GetLeadManuallyStartedEmailSequences_lead_queuedEmails_fromUser | null;
  to: GetLeadManuallyStartedEmailSequences_lead_queuedEmails_to[];
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
}

export interface GetLeadManuallyStartedEmailSequences_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Emails queued to be sent to this accounts primary contact
   */
  queuedEmails: GetLeadManuallyStartedEmailSequences_lead_queuedEmails[];
}

export interface GetLeadManuallyStartedEmailSequences {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetLeadManuallyStartedEmailSequences_lead | null;
}

export interface GetLeadManuallyStartedEmailSequencesVariables {
  leadId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLeadPersonalEmailSequences
// ====================================================

export interface GetLeadPersonalEmailSequences_lead_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_sender_sendableEmailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_sender {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * List of successfully enabled user email addresses that a user is able to send emails from Nutshell with.
   */
  sendableEmailAddresses: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_sender_sendableEmailAddresses[];
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_companyName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_firstName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_lastName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_lead_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  name: string;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge | null;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_lead_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_lead_contacts;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailAutomation_exitsStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailAutomation_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailAutomation_entersStage;
  /**
   * The stage in which this stage subscription ends.
   */
  exitsStage: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailAutomation_exitsStage | null;
  /**
   * Indicates if a lead should receive emails from this subscription until it closes.
   */
  sendUntilClose: boolean;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailAutomation_delay | null;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList | null;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued_fromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued_to {
  __typename: "NutEmailAddress";
  avatarEntity: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued_to_avatarEntity | null;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The current status of this queued email.
   */
  status: EmailQueuedStatus;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  fromUser: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued_fromUser | null;
  to: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued_to[];
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The next message to be sent
   */
  nextUnsentEmail: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailSequence_nextUnsentEmail | null;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  /**
   * The number of emails that have been sent
   */
  sentEmailsCount: number;
  emailsQueued: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued[];
  emailSequenceTemplate: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate | null;
  /**
   * True if this sequence has only one email
   */
  isSingleEmailSequence: boolean;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses {
  __typename: "EmailAutomationStatus";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that either did send this automation, or current _would_ send this
   * automation given the current context. For example, if the user is assigned to
   * a team, the logged in user is considered a potential sender if they’re on that team
   */
  sender: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_sender | null;
  /**
   * The total number of messages in the sequence for this status
   */
  unsentMessageCount: number | null;
  /**
   * Is this automation status paused?
   */
  isPaused: boolean;
  /**
   * Can this status be started
   */
  canStart: boolean;
  /**
   * Can this status be cancelled
   */
  canCancel: boolean;
  /**
   * The message to show to the user
   */
  status: EmailAutomationStatusStatus;
  /**
   * Status of the company name field
   */
  companyName: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_companyName;
  /**
   * Status of the first name field
   */
  firstName: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_firstName;
  /**
   * Status of the last name field
   */
  lastName: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_lastName;
  /**
   * Lead associated with this status row
   */
  lead: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_lead;
  /**
   * Email list stage subscription associated with this status row
   */
  emailAutomation: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailAutomation;
  /**
   * The actual email sequence going out for this lead in this stage
   */
  emailSequence: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses_emailSequence | null;
}

export interface GetLeadPersonalEmailSequences_lead_stages_edges {
  __typename: "LeadStagesEdge";
  node: GetLeadPersonalEmailSequences_lead_stages_edges_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
  /**
   * List of active stage subscription statuses for this lead
   */
  emailAutomationStatuses: GetLeadPersonalEmailSequences_lead_stages_edges_emailAutomationStatuses[];
}

export interface GetLeadPersonalEmailSequences_lead_stages {
  __typename: "LeadStagesConnection";
  /**
   * A list of edges.
   */
  edges: GetLeadPersonalEmailSequences_lead_stages_edges[];
}

export interface GetLeadPersonalEmailSequences_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Stages for the lead
   */
  stages: GetLeadPersonalEmailSequences_lead_stages;
}

export interface GetLeadPersonalEmailSequences {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetLeadPersonalEmailSequences_lead | null;
}

export interface GetLeadPersonalEmailSequencesVariables {
  leadId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DelayStepForLead
// ====================================================

export interface DelayStepForLead_stepDelay_step_delayApplications_delay {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the delay
   */
  name: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface DelayStepForLead_stepDelay_step_delayApplications_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DelayStepForLead_stepDelay_step_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * An optional note about the delay application
   */
  note: string | null;
  /**
   * The time when the delay was applied
   */
  appliedTime: any;
  /**
   * The delay that was applied
   */
  delay: DelayStepForLead_stepDelay_step_delayApplications_delay;
  /**
   * The user who applied the delay
   */
  user: DelayStepForLead_stepDelay_step_delayApplications_user | null;
}

export interface DelayStepForLead_stepDelay_step_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DelayStepForLead_stepDelay_step_completedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DelayStepForLead_stepDelay_step_relatedEntity {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DelayStepForLead_stepDelay_step_relatedLead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
}

export interface DelayStepForLead_stepDelay_step_delays {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface DelayStepForLead_stepDelay_step_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface DelayStepForLead_stepDelay_step {
  __typename: "Step";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the step
   */
  title: string;
  /**
   * The canonical API href for the step
   */
  href: string;
  /**
   * The step’s user-defined description
   */
  description: string | null;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: DelayStepForLead_stepDelay_step_delayApplications[];
  /**
   * The due timestamp of the step
   */
  dueTime: any | null;
  /**
   * The person or team assigned to this step
   */
  assignee: DelayStepForLead_stepDelay_step_assignee | null;
  /**
   * The DateTime that represents when the Step record was deleted
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the Step record was created
   */
  completedTime: any | null;
  /**
   * Can the step be completed?
   */
  canBeCompleted: boolean;
  /**
   * Is this step completed?
   */
  isCompleted: boolean;
  /**
   * The user who completed the step
   */
  completedByUser: DelayStepForLead_stepDelay_step_completedByUser | null;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Is the step overdue?
   */
  isOverdue: boolean;
  /**
   * The entity that this task exists on
   */
  relatedEntity: DelayStepForLead_stepDelay_step_relatedEntity | null;
  /**
   * Related lead that this step is associated with
   */
  relatedLead: DelayStepForLead_stepDelay_step_relatedLead;
  /**
   * The delays that can be applied to this step
   */
  delays: (DelayStepForLead_stepDelay_step_delays | null)[];
  /**
   * The stage that this step is due in
   */
  stage: DelayStepForLead_stepDelay_step_stage | null;
  /**
   * The step's linkified description with URLs converted to clickable links
   */
  linkifiedDescription: string | null;
}

export interface DelayStepForLead_stepDelay {
  __typename: "StepDelayPayload";
  /**
   * The delayed step
   */
  step: DelayStepForLead_stepDelay_step | null;
}

export interface DelayStepForLead {
  /**
   * Deletes an existing task
   */
  stepDelay: DelayStepForLead_stepDelay;
}

export interface DelayStepForLeadVariables {
  input: StepDelayInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SkipStepForLead
// ====================================================

export interface SkipStepForLead_skipStep_step_delayApplications_delay {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the delay
   */
  name: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface SkipStepForLead_skipStep_step_delayApplications_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SkipStepForLead_skipStep_step_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * An optional note about the delay application
   */
  note: string | null;
  /**
   * The time when the delay was applied
   */
  appliedTime: any;
  /**
   * The delay that was applied
   */
  delay: SkipStepForLead_skipStep_step_delayApplications_delay;
  /**
   * The user who applied the delay
   */
  user: SkipStepForLead_skipStep_step_delayApplications_user | null;
}

export interface SkipStepForLead_skipStep_step_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SkipStepForLead_skipStep_step_completedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SkipStepForLead_skipStep_step_relatedEntity {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SkipStepForLead_skipStep_step_relatedLead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
}

export interface SkipStepForLead_skipStep_step_delays {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface SkipStepForLead_skipStep_step_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface SkipStepForLead_skipStep_step {
  __typename: "Step";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the step
   */
  title: string;
  /**
   * The canonical API href for the step
   */
  href: string;
  /**
   * The step’s user-defined description
   */
  description: string | null;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: SkipStepForLead_skipStep_step_delayApplications[];
  /**
   * The due timestamp of the step
   */
  dueTime: any | null;
  /**
   * The person or team assigned to this step
   */
  assignee: SkipStepForLead_skipStep_step_assignee | null;
  /**
   * The DateTime that represents when the Step record was deleted
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the Step record was created
   */
  completedTime: any | null;
  /**
   * Can the step be completed?
   */
  canBeCompleted: boolean;
  /**
   * Is this step completed?
   */
  isCompleted: boolean;
  /**
   * The user who completed the step
   */
  completedByUser: SkipStepForLead_skipStep_step_completedByUser | null;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Is the step overdue?
   */
  isOverdue: boolean;
  /**
   * The entity that this task exists on
   */
  relatedEntity: SkipStepForLead_skipStep_step_relatedEntity | null;
  /**
   * Related lead that this step is associated with
   */
  relatedLead: SkipStepForLead_skipStep_step_relatedLead;
  /**
   * The delays that can be applied to this step
   */
  delays: (SkipStepForLead_skipStep_step_delays | null)[];
  /**
   * The stage that this step is due in
   */
  stage: SkipStepForLead_skipStep_step_stage | null;
  /**
   * The step's linkified description with URLs converted to clickable links
   */
  linkifiedDescription: string | null;
}

export interface SkipStepForLead_skipStep {
  __typename: "SkipStepPayload";
  /**
   * The skipped Nutshell step
   */
  step: SkipStepForLead_skipStep_step;
}

export interface SkipStepForLead {
  /**
   * Attempts to perform a skip step operation on a step
   */
  skipStep: SkipStepForLead_skipStep | null;
}

export interface SkipStepForLeadVariables {
  input: SkipStepInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UnskipStepForLead
// ====================================================

export interface UnskipStepForLead_stepUnskip_step_delayApplications_delay {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the delay
   */
  name: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface UnskipStepForLead_stepUnskip_step_delayApplications_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UnskipStepForLead_stepUnskip_step_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * An optional note about the delay application
   */
  note: string | null;
  /**
   * The time when the delay was applied
   */
  appliedTime: any;
  /**
   * The delay that was applied
   */
  delay: UnskipStepForLead_stepUnskip_step_delayApplications_delay;
  /**
   * The user who applied the delay
   */
  user: UnskipStepForLead_stepUnskip_step_delayApplications_user | null;
}

export interface UnskipStepForLead_stepUnskip_step_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UnskipStepForLead_stepUnskip_step_completedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UnskipStepForLead_stepUnskip_step_relatedEntity {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UnskipStepForLead_stepUnskip_step_relatedLead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
}

export interface UnskipStepForLead_stepUnskip_step_delays {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface UnskipStepForLead_stepUnskip_step_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface UnskipStepForLead_stepUnskip_step {
  __typename: "Step";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the step
   */
  title: string;
  /**
   * The canonical API href for the step
   */
  href: string;
  /**
   * The step’s user-defined description
   */
  description: string | null;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: UnskipStepForLead_stepUnskip_step_delayApplications[];
  /**
   * The due timestamp of the step
   */
  dueTime: any | null;
  /**
   * The person or team assigned to this step
   */
  assignee: UnskipStepForLead_stepUnskip_step_assignee | null;
  /**
   * The DateTime that represents when the Step record was deleted
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the Step record was created
   */
  completedTime: any | null;
  /**
   * Can the step be completed?
   */
  canBeCompleted: boolean;
  /**
   * Is this step completed?
   */
  isCompleted: boolean;
  /**
   * The user who completed the step
   */
  completedByUser: UnskipStepForLead_stepUnskip_step_completedByUser | null;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Is the step overdue?
   */
  isOverdue: boolean;
  /**
   * The entity that this task exists on
   */
  relatedEntity: UnskipStepForLead_stepUnskip_step_relatedEntity | null;
  /**
   * Related lead that this step is associated with
   */
  relatedLead: UnskipStepForLead_stepUnskip_step_relatedLead;
  /**
   * The delays that can be applied to this step
   */
  delays: (UnskipStepForLead_stepUnskip_step_delays | null)[];
  /**
   * The stage that this step is due in
   */
  stage: UnskipStepForLead_stepUnskip_step_stage | null;
  /**
   * The step's linkified description with URLs converted to clickable links
   */
  linkifiedDescription: string | null;
}

export interface UnskipStepForLead_stepUnskip {
  __typename: "StepUnskipPayload";
  /**
   * The unskipped Nutshell step
   */
  step: UnskipStepForLead_stepUnskip_step;
}

export interface UnskipStepForLead {
  /**
   * Attempts to perform a unskip step operation on a step
   */
  stepUnskip: UnskipStepForLead_stepUnskip | null;
}

export interface UnskipStepForLeadVariables {
  input: StepUnskipInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateStepForLead
// ====================================================

export interface UpdateStepForLead_stepUpdate_step_delayApplications_delay {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the delay
   */
  name: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface UpdateStepForLead_stepUpdate_step_delayApplications_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateStepForLead_stepUpdate_step_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * An optional note about the delay application
   */
  note: string | null;
  /**
   * The time when the delay was applied
   */
  appliedTime: any;
  /**
   * The delay that was applied
   */
  delay: UpdateStepForLead_stepUpdate_step_delayApplications_delay;
  /**
   * The user who applied the delay
   */
  user: UpdateStepForLead_stepUpdate_step_delayApplications_user | null;
}

export interface UpdateStepForLead_stepUpdate_step_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateStepForLead_stepUpdate_step_completedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateStepForLead_stepUpdate_step_relatedEntity {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateStepForLead_stepUpdate_step_relatedLead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
}

export interface UpdateStepForLead_stepUpdate_step_delays {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface UpdateStepForLead_stepUpdate_step_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface UpdateStepForLead_stepUpdate_step {
  __typename: "Step";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the step
   */
  title: string;
  /**
   * The canonical API href for the step
   */
  href: string;
  /**
   * The step’s user-defined description
   */
  description: string | null;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: UpdateStepForLead_stepUpdate_step_delayApplications[];
  /**
   * The due timestamp of the step
   */
  dueTime: any | null;
  /**
   * The person or team assigned to this step
   */
  assignee: UpdateStepForLead_stepUpdate_step_assignee | null;
  /**
   * The DateTime that represents when the Step record was deleted
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the Step record was created
   */
  completedTime: any | null;
  /**
   * Can the step be completed?
   */
  canBeCompleted: boolean;
  /**
   * Is this step completed?
   */
  isCompleted: boolean;
  /**
   * The user who completed the step
   */
  completedByUser: UpdateStepForLead_stepUpdate_step_completedByUser | null;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Is the step overdue?
   */
  isOverdue: boolean;
  /**
   * The entity that this task exists on
   */
  relatedEntity: UpdateStepForLead_stepUpdate_step_relatedEntity | null;
  /**
   * Related lead that this step is associated with
   */
  relatedLead: UpdateStepForLead_stepUpdate_step_relatedLead;
  /**
   * The delays that can be applied to this step
   */
  delays: (UpdateStepForLead_stepUpdate_step_delays | null)[];
  /**
   * The stage that this step is due in
   */
  stage: UpdateStepForLead_stepUpdate_step_stage | null;
  /**
   * The step's linkified description with URLs converted to clickable links
   */
  linkifiedDescription: string | null;
}

export interface UpdateStepForLead_stepUpdate {
  __typename: "StepUpdatePayload";
  /**
   * The updated step
   */
  step: UpdateStepForLead_stepUpdate_step | null;
}

export interface UpdateStepForLead {
  /**
   * Updates an existing step
   */
  stepUpdate: UpdateStepForLead_stepUpdate;
}

export interface UpdateStepForLeadVariables {
  input: StepUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetGoalsByStage
// ====================================================

export interface GetGoalsByStage_lead_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetGoalsByStage_lead_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_condition {
  __typename: "Condition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase {
  __typename: "EntityAttributeBase";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase_attribute;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_options {
  __typename: "EnumOption";
  /**
   * The name (and primary identifier) of the enum option.
   */
  id: string;
  /**
   * The name (and display) of the enum option.
   */
  name: string;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum {
  __typename: "EntityAttributeEnum";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_attribute;
  /**
   * Enum options for this field
   */
  options: GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_options[];
  /**
   * Does this enum field allow multiple selections. I.e. can the value of "Favorite Color" be "Red" AND "Blue"?
   */
  allowMultiple: boolean;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency {
  __typename: "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency_attribute;
  /**
   * Available currency options for this field
   */
  currencyOptions: string[];
  /**
   * Default currency for this field
   */
  defaultCurrency: string;
}

export type GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_node = GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency;

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates | null;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all = GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueset | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueString | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueText | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEnum | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueDate | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEmail | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValuePhone | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueImage | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueUrl | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueNumber;

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all[];
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation_coordinates | null;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value = GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueString | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueText | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEnum | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueDate | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEmail | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValuePhone | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueImage | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueUrl | GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueNumber;

export interface GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField {
  __typename: "LeadConditionCustomField";
  /**
   * The lead agnostic entity attribute object (the field).
   */
  node: GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_node;
  /**
   * Value of this custom field for this particular lead
   */
  value: GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField_value | null;
}

export interface GetGoalsByStage_lead_stages_edges_goalConditions {
  __typename: "LeadGoalCondition";
  /**
   * The lead agnostic condition object.
   */
  condition: GetGoalsByStage_lead_stages_edges_goalConditions_condition;
  /**
   * Is this the current stage of the lead?
   */
  status: ConditionStatus;
  /**
   * Custom field associated with this goal’s condition. Ideally, this would be
   * _any_ field, but for now we’re only supporting custom fields. Therefore, if
   * the field associated with this condition is _not_ a custom field, this will return `null`
   */
  conditionCustomField: GetGoalsByStage_lead_stages_edges_goalConditions_conditionCustomField | null;
}

export interface GetGoalsByStage_lead_stages_edges {
  __typename: "LeadStagesEdge";
  node: GetGoalsByStage_lead_stages_edges_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
  /**
   * List of this lead goal’s conditions associated with the given stage
   */
  goalConditions: GetGoalsByStage_lead_stages_edges_goalConditions[];
}

export interface GetGoalsByStage_lead_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: GetGoalsByStage_lead_stages_current | null;
  /**
   * A list of edges.
   */
  edges: GetGoalsByStage_lead_stages_edges[];
}

export interface GetGoalsByStage_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Stages for the lead
   */
  stages: GetGoalsByStage_lead_stages;
}

export interface GetGoalsByStage {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetGoalsByStage_lead | null;
}

export interface GetGoalsByStageVariables {
  leadId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetStepsByStage
// ====================================================

export interface GetStepsByStage_lead_leadTasksBySource_steps_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetStepsByStage_lead_leadTasksBySource_steps_steps_delayApplications_delay {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the delay
   */
  name: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface GetStepsByStage_lead_leadTasksBySource_steps_steps_delayApplications_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetStepsByStage_lead_leadTasksBySource_steps_steps_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * An optional note about the delay application
   */
  note: string | null;
  /**
   * The time when the delay was applied
   */
  appliedTime: any;
  /**
   * The delay that was applied
   */
  delay: GetStepsByStage_lead_leadTasksBySource_steps_steps_delayApplications_delay;
  /**
   * The user who applied the delay
   */
  user: GetStepsByStage_lead_leadTasksBySource_steps_steps_delayApplications_user | null;
}

export interface GetStepsByStage_lead_leadTasksBySource_steps_steps_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetStepsByStage_lead_leadTasksBySource_steps_steps_completedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetStepsByStage_lead_leadTasksBySource_steps_steps_relatedEntity {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetStepsByStage_lead_leadTasksBySource_steps_steps_relatedLead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
}

export interface GetStepsByStage_lead_leadTasksBySource_steps_steps_delays {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface GetStepsByStage_lead_leadTasksBySource_steps_steps_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetStepsByStage_lead_leadTasksBySource_steps_steps {
  __typename: "Step";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the step
   */
  title: string;
  /**
   * The canonical API href for the step
   */
  href: string;
  /**
   * The step’s user-defined description
   */
  description: string | null;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: GetStepsByStage_lead_leadTasksBySource_steps_steps_delayApplications[];
  /**
   * The due timestamp of the step
   */
  dueTime: any | null;
  /**
   * The person or team assigned to this step
   */
  assignee: GetStepsByStage_lead_leadTasksBySource_steps_steps_assignee | null;
  /**
   * The DateTime that represents when the Step record was deleted
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the Step record was created
   */
  completedTime: any | null;
  /**
   * Can the step be completed?
   */
  canBeCompleted: boolean;
  /**
   * Is this step completed?
   */
  isCompleted: boolean;
  /**
   * The user who completed the step
   */
  completedByUser: GetStepsByStage_lead_leadTasksBySource_steps_steps_completedByUser | null;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Is the step overdue?
   */
  isOverdue: boolean;
  /**
   * The entity that this task exists on
   */
  relatedEntity: GetStepsByStage_lead_leadTasksBySource_steps_steps_relatedEntity | null;
  /**
   * Related lead that this step is associated with
   */
  relatedLead: GetStepsByStage_lead_leadTasksBySource_steps_steps_relatedLead;
  /**
   * The delays that can be applied to this step
   */
  delays: (GetStepsByStage_lead_leadTasksBySource_steps_steps_delays | null)[];
  /**
   * The stage that this step is due in
   */
  stage: GetStepsByStage_lead_leadTasksBySource_steps_steps_stage | null;
  /**
   * The step's linkified description with URLs converted to clickable links
   */
  linkifiedDescription: string | null;
}

export interface GetStepsByStage_lead_leadTasksBySource_steps {
  __typename: "StepsByStage";
  /**
   * The stage the steps belong to
   */
  stage: GetStepsByStage_lead_leadTasksBySource_steps_stage;
  /**
   * The steps for this stage
   */
  steps: GetStepsByStage_lead_leadTasksBySource_steps_steps[];
}

export interface GetStepsByStage_lead_leadTasksBySource {
  __typename: "LeadTasksBySource";
  /**
   * Steps (also known as "automated tasks") organized by stage
   */
  steps: GetStepsByStage_lead_leadTasksBySource_steps[];
}

export interface GetStepsByStage_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * LeadTasks organized by source for display on the lead page workspace
   */
  leadTasksBySource: GetStepsByStage_lead_leadTasksBySource;
}

export interface GetStepsByStage {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetStepsByStage_lead | null;
}

export interface GetStepsByStageVariables {
  leadId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTasksForLead
// ====================================================

export interface GetTasksForLead_lead_tasks_delayApplications_delay {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the delay
   */
  name: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface GetTasksForLead_lead_tasks_delayApplications_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetTasksForLead_lead_tasks_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * An optional note about the delay application
   */
  note: string | null;
  /**
   * The time when the delay was applied
   */
  appliedTime: any;
  /**
   * The delay that was applied
   */
  delay: GetTasksForLead_lead_tasks_delayApplications_delay;
  /**
   * The user who applied the delay
   */
  user: GetTasksForLead_lead_tasks_delayApplications_user | null;
}

export interface GetTasksForLead_lead_tasks_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetTasksForLead_lead_tasks_completedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetTasksForLead_lead_tasks_relatedEntity {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetTasksForLead_lead_tasks_creatorEntity_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface GetTasksForLead_lead_tasks_creatorEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export type GetTasksForLead_lead_tasks_creatorEntity = GetTasksForLead_lead_tasks_creatorEntity_Chat | GetTasksForLead_lead_tasks_creatorEntity_Activity;

export interface GetTasksForLead_lead_tasks_assigner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetTasksForLead_lead_tasks_recurrenceRule {
  __typename: "RecurrenceRule";
  mode: RecurrenceMode;
  /**
   * An RRULE-compatible string defining the recurrence pattern (e.g. "FREQ=WEEKLY;BYDAY=MO").
   */
  rule: string;
}

export interface GetTasksForLead_lead_tasks {
  __typename: "Task";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the task
   */
  title: string;
  /**
   * The canonical API href for the task
   */
  href: string;
  /**
   * The task’s user-defined description
   */
  description: string | null;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: GetTasksForLead_lead_tasks_delayApplications[];
  /**
   * The due timestamp of the task
   */
  dueTime: any | null;
  /**
   * The person or team assigned to this task
   */
  assignee: GetTasksForLead_lead_tasks_assignee | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  completedTime: any | null;
  /**
   * Can the task be completed?
   */
  canBeCompleted: boolean;
  /**
   * Is this task completed?
   */
  isCompleted: boolean;
  /**
   * The user who completed the task
   */
  completedByUser: GetTasksForLead_lead_tasks_completedByUser | null;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Whether the tasks due date is later than the current date
   */
  isOverdue: boolean;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  relatedEntity: GetTasksForLead_lead_tasks_relatedEntity | null;
  /**
   * The DateTime that represents when the Activity record was created
   */
  createdTime: any;
  /**
   * The task's linkified description with URLs converted to clickable links
   */
  linkifiedDescription: string | null;
  isAiGenerated: boolean;
  creatorEntity: GetTasksForLead_lead_tasks_creatorEntity | null;
  /**
   * The user who assigned the task
   */
  assigner: GetTasksForLead_lead_tasks_assigner | null;
  /**
   * The time the task was assigned
   */
  assignedTime: any | null;
  /**
   * Number of days between follow-up reminders. Null if the task is not recurring.
   */
  recurringPeriod: number | null;
  /**
   * Whether this task is the current user recurring follow-up reminder.
   */
  isRecurringForUser: boolean;
  /**
   * Null if the task does not recur under the new recurrence system.
   */
  recurrenceRule: GetTasksForLead_lead_tasks_recurrenceRule | null;
}

export interface GetTasksForLead_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * List of tasks on this lead
   */
  tasks: GetTasksForLead_lead_tasks[];
}

export interface GetTasksForLead {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetTasksForLead_lead | null;
}

export interface GetTasksForLeadVariables {
  leadId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTaskDisplayCount
// ====================================================

export interface GetTaskDisplayCount_lead_tasks {
  __typename: "Task";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this task completed?
   */
  isCompleted: boolean;
}

export interface GetTaskDisplayCount_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * List of tasks on this lead
   */
  tasks: GetTaskDisplayCount_lead_tasks[];
}

export interface GetTaskDisplayCount {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetTaskDisplayCount_lead | null;
}

export interface GetTaskDisplayCountVariables {
  leadId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: LeadBackboneUpdate
// ====================================================

export interface LeadBackboneUpdate_lead_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
}

export interface LeadBackboneUpdate_lead_products_totalValue {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface LeadBackboneUpdate_lead_products_edges_price {
  __typename: "Money";
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface LeadBackboneUpdate_lead_products_edges_originalPrice {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface LeadBackboneUpdate_lead_products_edges_node_category {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
}

export interface LeadBackboneUpdate_lead_products_edges_node_markets_edges_price {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface LeadBackboneUpdate_lead_products_edges_node_markets_edges {
  __typename: "ProductMarketsEdge";
  /**
   * The price and currency of the product in the market.
   */
  price: LeadBackboneUpdate_lead_products_edges_node_markets_edges_price | null;
  /**
   * Whether the product is available in the market.
   */
  isAvailable: boolean | null;
}

export interface LeadBackboneUpdate_lead_products_edges_node_markets {
  __typename: "ProductMarketsConnection";
  /**
   * A list of edges.
   */
  edges: LeadBackboneUpdate_lead_products_edges_node_markets_edges[];
}

export interface LeadBackboneUpdate_lead_products_edges_node {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The description of the product
   */
  description: string | null;
  /**
   * The type of the product (Good or Service)
   */
  type: ProductType;
  /**
   * The URL of the report for this product
   */
  reportUrl: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The category of the product
   */
  category: LeadBackboneUpdate_lead_products_edges_node_category | null;
  /**
   * The markets of the product
   */
  markets: LeadBackboneUpdate_lead_products_edges_node_markets;
  /**
   * The DateTime the product was created
   */
  createdTime: any;
}

export interface LeadBackboneUpdate_lead_products_edges {
  __typename: "LeadProductsEdge";
  /**
   * The API ID of the Lead_ProductMap
   */
  id: string;
  /**
   * The one-off short note that users can write on this lead->product relationship.
   */
  relationshipNote: string | null;
  /**
   * The quantity number of the given product that is attached to the lead
   */
  quantity: number;
  /**
   * The monetary value for each unit of the product attached to the lead
   */
  price: LeadBackboneUpdate_lead_products_edges_price;
  /**
   * The original price of the product
   */
  originalPrice: LeadBackboneUpdate_lead_products_edges_originalPrice | null;
  /**
   * The total value of this attached product on the lead, taking its unit price and multiplying it by the given quantity.
   */
  total: number;
  /**
   * The product
   */
  node: LeadBackboneUpdate_lead_products_edges_node;
}

export interface LeadBackboneUpdate_lead_products {
  __typename: "LeadProductsConnection";
  /**
   * The total value of the products mapped to the lead
   */
  totalValue: LeadBackboneUpdate_lead_products_totalValue | null;
  /**
   * A list of edges.
   */
  edges: LeadBackboneUpdate_lead_products_edges[];
}

export interface LeadBackboneUpdate_lead_accounts_primaryEdge_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface LeadBackboneUpdate_lead_accounts_primaryEdge_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: LeadBackboneUpdate_lead_accounts_primaryEdge_node_postalAddresses_primary_location;
}

export interface LeadBackboneUpdate_lead_accounts_primaryEdge_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: LeadBackboneUpdate_lead_accounts_primaryEdge_node_postalAddresses_primary | null;
}

export interface LeadBackboneUpdate_lead_accounts_primaryEdge_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface LeadBackboneUpdate_lead_accounts_primaryEdge_node_phones_primary {
  __typename: "Phone";
  value: LeadBackboneUpdate_lead_accounts_primaryEdge_node_phones_primary_value;
}

export interface LeadBackboneUpdate_lead_accounts_primaryEdge_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: LeadBackboneUpdate_lead_accounts_primaryEdge_node_phones_primary | null;
}

export interface LeadBackboneUpdate_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: LeadBackboneUpdate_lead_accounts_primaryEdge_node_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: LeadBackboneUpdate_lead_accounts_primaryEdge_node_phones;
}

export interface LeadBackboneUpdate_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: LeadBackboneUpdate_lead_accounts_primaryEdge_node;
}

export interface LeadBackboneUpdate_lead_accounts_edges_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface LeadBackboneUpdate_lead_accounts_edges_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: LeadBackboneUpdate_lead_accounts_edges_node_postalAddresses_primary_location;
}

export interface LeadBackboneUpdate_lead_accounts_edges_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: LeadBackboneUpdate_lead_accounts_edges_node_postalAddresses_primary | null;
}

export interface LeadBackboneUpdate_lead_accounts_edges_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface LeadBackboneUpdate_lead_accounts_edges_node_phones_primary {
  __typename: "Phone";
  value: LeadBackboneUpdate_lead_accounts_edges_node_phones_primary_value;
}

export interface LeadBackboneUpdate_lead_accounts_edges_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: LeadBackboneUpdate_lead_accounts_edges_node_phones_primary | null;
}

export interface LeadBackboneUpdate_lead_accounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: LeadBackboneUpdate_lead_accounts_edges_node_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: LeadBackboneUpdate_lead_accounts_edges_node_phones;
}

export interface LeadBackboneUpdate_lead_accounts_edges_leadAccountContacts_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface LeadBackboneUpdate_lead_accounts_edges_leadAccountContacts_phones_primary {
  __typename: "Phone";
  value: LeadBackboneUpdate_lead_accounts_edges_leadAccountContacts_phones_primary_value;
}

export interface LeadBackboneUpdate_lead_accounts_edges_leadAccountContacts_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: LeadBackboneUpdate_lead_accounts_edges_leadAccountContacts_phones_primary | null;
}

export interface LeadBackboneUpdate_lead_accounts_edges_leadAccountContacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: LeadBackboneUpdate_lead_accounts_edges_leadAccountContacts_phones;
}

export interface LeadBackboneUpdate_lead_accounts_edges {
  __typename: "LeadAccountsEdge";
  node: LeadBackboneUpdate_lead_accounts_edges_node;
  /**
   * List of contacts associated with this account that are also on the root lead
   */
  leadAccountContacts: LeadBackboneUpdate_lead_accounts_edges_leadAccountContacts[] | null;
}

export interface LeadBackboneUpdate_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LeadBackboneUpdate_lead_accounts_primaryEdge | null;
  /**
   * A list of edges.
   */
  edges: LeadBackboneUpdate_lead_accounts_edges[];
}

export interface LeadBackboneUpdate_lead_contacts_primaryEdge_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface LeadBackboneUpdate_lead_contacts_primaryEdge_node_phones_primary {
  __typename: "Phone";
  value: LeadBackboneUpdate_lead_contacts_primaryEdge_node_phones_primary_value;
}

export interface LeadBackboneUpdate_lead_contacts_primaryEdge_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: LeadBackboneUpdate_lead_contacts_primaryEdge_node_phones_primary | null;
}

export interface LeadBackboneUpdate_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: LeadBackboneUpdate_lead_contacts_primaryEdge_node_phones;
}

export interface LeadBackboneUpdate_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: LeadBackboneUpdate_lead_contacts_primaryEdge_node;
}

export interface LeadBackboneUpdate_lead_contacts_nonCompanyMappedContacts_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface LeadBackboneUpdate_lead_contacts_nonCompanyMappedContacts_node_phones_primary {
  __typename: "Phone";
  value: LeadBackboneUpdate_lead_contacts_nonCompanyMappedContacts_node_phones_primary_value;
}

export interface LeadBackboneUpdate_lead_contacts_nonCompanyMappedContacts_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: LeadBackboneUpdate_lead_contacts_nonCompanyMappedContacts_node_phones_primary | null;
}

export interface LeadBackboneUpdate_lead_contacts_nonCompanyMappedContacts_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: LeadBackboneUpdate_lead_contacts_nonCompanyMappedContacts_node_phones;
}

export interface LeadBackboneUpdate_lead_contacts_nonCompanyMappedContacts {
  __typename: "LeadContactsEdge";
  node: LeadBackboneUpdate_lead_contacts_nonCompanyMappedContacts_node;
}

export interface LeadBackboneUpdate_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LeadBackboneUpdate_lead_contacts_primaryEdge | null;
  /**
   * List of contacts that are not associated with a company on this lead
   */
  nonCompanyMappedContacts: LeadBackboneUpdate_lead_contacts_nonCompanyMappedContacts[] | null;
}

export interface LeadBackboneUpdate_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The mode of the leads value
   */
  valueMode: LeadValueMode;
  value: LeadBackboneUpdate_lead_value | null;
  /**
   * Products for the lead
   */
  products: LeadBackboneUpdate_lead_products | null;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: LeadBackboneUpdate_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: LeadBackboneUpdate_lead_contacts;
}

export interface LeadBackboneUpdate {
  /**
   * Returns a Nutshell Lead
   */
  lead: LeadBackboneUpdate_lead | null;
}

export interface LeadBackboneUpdateVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLeadPrimaryContactDripSequenceProgressions
// ====================================================

export interface GetLeadPrimaryContactDripSequenceProgressions_lead_contacts_edges_node_dripProgressions_campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetLeadPrimaryContactDripSequenceProgressions_lead_contacts_edges_node_dripProgressions_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  editions: GetLeadPrimaryContactDripSequenceProgressions_lead_contacts_edges_node_dripProgressions_campaign_editions;
}

export interface GetLeadPrimaryContactDripSequenceProgressions_lead_contacts_edges_node_dripProgressions_nextEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetLeadPrimaryContactDripSequenceProgressions_lead_contacts_edges_node_dripProgressions_nextEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetLeadPrimaryContactDripSequenceProgressions_lead_contacts_edges_node_dripProgressions_nextEdition_emailTemplate | null;
}

export interface GetLeadPrimaryContactDripSequenceProgressions_lead_contacts_edges_node_dripProgressions {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
  /**
   * Number of editions that have been sent so far for this progression. NOTE: This
   * can be inaccurate if editions are reordered or an edition is added to the
   * start of the drip after a progression has started. This is ok! We want this
   * number to represent the number of prior active editions, even if they aren’t always sent.
   */
  numEditionsSent: number;
  /**
   * The drip sequence for this drip progressions
   */
  campaign: GetLeadPrimaryContactDripSequenceProgressions_lead_contacts_edges_node_dripProgressions_campaign;
  /**
   * The next edition in the drip to be sent, null if ended
   */
  nextEdition: GetLeadPrimaryContactDripSequenceProgressions_lead_contacts_edges_node_dripProgressions_nextEdition | null;
}

export interface GetLeadPrimaryContactDripSequenceProgressions_lead_contacts_edges_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * List of drip progressions for this contact. By default only active
   * progressions on non-cancelled campaigns are returned. Soft-deleted
   * progressions are always excluded.
   */
  dripProgressions: GetLeadPrimaryContactDripSequenceProgressions_lead_contacts_edges_node_dripProgressions[];
}

export interface GetLeadPrimaryContactDripSequenceProgressions_lead_contacts_edges {
  __typename: "LeadContactsEdge";
  node: GetLeadPrimaryContactDripSequenceProgressions_lead_contacts_edges_node;
}

export interface GetLeadPrimaryContactDripSequenceProgressions_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * A list of edges.
   */
  edges: GetLeadPrimaryContactDripSequenceProgressions_lead_contacts_edges[];
}

export interface GetLeadPrimaryContactDripSequenceProgressions_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetLeadPrimaryContactDripSequenceProgressions_lead_contacts;
}

export interface GetLeadPrimaryContactDripSequenceProgressions {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetLeadPrimaryContactDripSequenceProgressions_lead | null;
}

export interface GetLeadPrimaryContactDripSequenceProgressionsVariables {
  leadId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: InstallmentsUpdate
// ====================================================

export interface InstallmentsUpdate_installmentsUpdate_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface InstallmentsUpdate_installmentsUpdate {
  __typename: "InstallmentsUpdatePayload";
  /**
   * The lead with the updated installments.
   */
  lead: InstallmentsUpdate_installmentsUpdate_lead;
}

export interface InstallmentsUpdate {
  /**
   * Creates installments for a Lead
   */
  installmentsUpdate: InstallmentsUpdate_installmentsUpdate;
}

export interface InstallmentsUpdateVariables {
  input: InstallmentsUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetInstallmentsForLead
// ====================================================

export interface GetInstallmentsForLead_lead_installments_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface GetInstallmentsForLead_lead_installments {
  __typename: "Installment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  dueTime: any;
  description: string | null;
  failedTime: any | null;
  value: GetInstallmentsForLead_lead_installments_value;
}

export interface GetInstallmentsForLead_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * List of installments on this lead
   */
  installments: GetInstallmentsForLead_lead_installments[];
}

export interface GetInstallmentsForLead {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetInstallmentsForLead_lead | null;
}

export interface GetInstallmentsForLeadVariables {
  leadId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLeadWithInstallments
// ====================================================

export interface GetLeadWithInstallments_lead_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
}

export interface GetLeadWithInstallments_lead_installments_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface GetLeadWithInstallments_lead_installments {
  __typename: "Installment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  dueTime: any;
  description: string | null;
  failedTime: any | null;
  value: GetLeadWithInstallments_lead_installments_value;
}

export interface GetLeadWithInstallments_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The anticipated close time for the lead.
   */
  anticipatedClosedTime: any | null;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Timezone for installment paid and past-due. Lead owner, then first admin, then UTC.
   */
  installmentsTimezone: string;
  value: GetLeadWithInstallments_lead_value | null;
  /**
   * List of installments on this lead
   */
  installments: GetLeadWithInstallments_lead_installments[];
}

export interface GetLeadWithInstallments {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetLeadWithInstallments_lead | null;
}

export interface GetLeadWithInstallmentsVariables {
  leadId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: LeadCardFieldsUpdate
// ====================================================

export interface LeadCardFieldsUpdate_leadCardFieldsUpdate {
  __typename: "SelectableField";
  /**
   * The ID of the field to add
   */
  fieldId: string;
  /**
   * Whether the field is required
   */
  isRequired: boolean;
  /**
   * Whether the field can be removed
   */
  isRemoveable: boolean;
}

export interface LeadCardFieldsUpdate {
  /**
   * Updates the selected fields for a lead card in the given stageset
   */
  leadCardFieldsUpdate: LeadCardFieldsUpdate_leadCardFieldsUpdate[];
}

export interface LeadCardFieldsUpdateVariables {
  input: LeadCardFieldsUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLeadCardFields
// ====================================================

export interface GetLeadCardFields_leadCardFields {
  __typename: "SelectableField";
  /**
   * The ID of the field to add
   */
  fieldId: string;
  /**
   * Whether the field is required
   */
  isRequired: boolean;
  /**
   * Whether the field can be removed
   */
  isRemoveable: boolean;
  /**
   * Whether the field can be shown on the lead board
   */
  isBoardable: boolean;
}

export interface GetLeadCardFields {
  /**
   * Get list of fields for a lead card
   */
  leadCardFields: GetLeadCardFields_leadCardFields[];
}

export interface GetLeadCardFieldsVariables {
  stagesetId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetFollowUpTasksEligibility
// ====================================================

export interface GetFollowUpTasksEligibility_loggedInUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  isAiFollowUpTasksEnabled: boolean;
  /**
   * Whether the user has at least 1+ completed transcription summary in the last 30 days.
   */
  hasRecentTranscriptionSummary: boolean;
}

export interface GetFollowUpTasksEligibility {
  /**
   * Returns the requesting user. This is essentially the logged in user, but in an
   * API context, they might not be any "logged in"
   */
  loggedInUser: GetFollowUpTasksEligibility_loggedInUser;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddEntityToConstantContactList
// ====================================================

export interface AddEntityToConstantContactList_constantContactAddEntityToList_entity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface AddEntityToConstantContactList_constantContactAddEntityToList {
  __typename: "ConstantContactAddEntityToListPayload";
  /**
   * The updated Nutshell entity
   */
  entity: AddEntityToConstantContactList_constantContactAddEntityToList_entity;
}

export interface AddEntityToConstantContactList {
  /**
   * Adds a Nutshell entity to the given Constant Contact list.
   */
  constantContactAddEntityToList: AddEntityToConstantContactList_constantContactAddEntityToList;
}

export interface AddEntityToConstantContactListVariables {
  input: ConstantContactAddEntityToListInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: QuickbooksCreateInvoiceForLead
// ====================================================

export interface QuickbooksCreateInvoiceForLead_quickbooksCreateInvoiceForLead_lead_externalResources {
  __typename: "ExternalResource";
  /**
   * The name of the external service this resource belongs to.
   */
  externalService: ExternalService;
  /**
   * The type of external resource.
   */
  externalResourceType: ExternalResourceType;
  /**
   * The ID of the external resource.
   */
  externalId: string;
}

export interface QuickbooksCreateInvoiceForLead_quickbooksCreateInvoiceForLead_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * External resources mapped to this lead
   */
  externalResources: QuickbooksCreateInvoiceForLead_quickbooksCreateInvoiceForLead_lead_externalResources[];
}

export interface QuickbooksCreateInvoiceForLead_quickbooksCreateInvoiceForLead {
  __typename: "QuickbooksCreateInvoicePayload";
  /**
   * The Nutshell Lead that the invoice was created for
   */
  lead: QuickbooksCreateInvoiceForLead_quickbooksCreateInvoiceForLead_lead;
}

export interface QuickbooksCreateInvoiceForLead {
  /**
   * Creates an invoice in Quickbooks for a Nutshell lead
   */
  quickbooksCreateInvoiceForLead: QuickbooksCreateInvoiceForLead_quickbooksCreateInvoiceForLead;
}

export interface QuickbooksCreateInvoiceForLeadVariables {
  input: QuickbooksCreateInvoiceForLeadInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: GenerateLeadPromptResponse
// ====================================================

export interface GenerateLeadPromptResponse_leadPromptResponseGenerate {
  __typename: "LeadPromptResponseGeneratePayload";
  /**
   * The question the user asked
   */
  userPrompt: string;
  /**
   * Null when generation fails
   */
  response: string | null;
  status: EntitySummaryStatus;
}

export interface GenerateLeadPromptResponse {
  /**
   * Ask a free-form question about a lead, answered by AI from the lead's context.
   * Runs synchronously and does not persist the response.
   */
  leadPromptResponseGenerate: GenerateLeadPromptResponse_leadPromptResponseGenerate;
}

export interface GenerateLeadPromptResponseVariables {
  input: LeadPromptResponseGenerateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: LeadSetWatched
// ====================================================

export interface LeadSetWatched_leadSetWatched_lead_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface LeadSetWatched_leadSetWatched_lead_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface LeadSetWatched_leadSetWatched_lead_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type LeadSetWatched_leadSetWatched_lead_assignee = LeadSetWatched_leadSetWatched_lead_assignee_Team | LeadSetWatched_leadSetWatched_lead_assignee_User;

export interface LeadSetWatched_leadSetWatched_lead_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadSetWatched_leadSetWatched_lead_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
}

export interface LeadSetWatched_leadSetWatched_lead_products_totalValue {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface LeadSetWatched_leadSetWatched_lead_products {
  __typename: "LeadProductsConnection";
  /**
   * The total value of the products mapped to the lead
   */
  totalValue: LeadSetWatched_leadSetWatched_lead_products_totalValue | null;
}

export interface LeadSetWatched_leadSetWatched_lead_clonedFrom {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The time this stage was deleted, or null if this stage has not been deleted.
   */
  deletedTime: any | null;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_timeInStage {
  __typename: "FormattedValueDuration";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formattedString: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_condition {
  __typename: "Condition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase {
  __typename: "EntityAttributeBase";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase_attribute;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_options {
  __typename: "EnumOption";
  /**
   * The name (and primary identifier) of the enum option.
   */
  id: string;
  /**
   * The name (and display) of the enum option.
   */
  name: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum {
  __typename: "EntityAttributeEnum";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_attribute;
  /**
   * Enum options for this field
   */
  options: LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_options[];
  /**
   * Does this enum field allow multiple selections. I.e. can the value of "Favorite Color" be "Red" AND "Blue"?
   */
  allowMultiple: boolean;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency {
  __typename: "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency_attribute;
  /**
   * Available currency options for this field
   */
  currencyOptions: string[];
  /**
   * Default currency for this field
   */
  defaultCurrency: string;
}

export type LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_node = LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency;

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates | null;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all = LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueset | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueString | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueText | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEnum | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueDate | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEmail | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValuePhone | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueImage | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueUrl | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueNumber;

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all[];
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation_coordinates | null;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value = LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueString | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueText | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEnum | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueDate | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEmail | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValuePhone | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueImage | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueUrl | LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueNumber;

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField {
  __typename: "LeadConditionCustomField";
  /**
   * The lead agnostic entity attribute object (the field).
   */
  node: LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_node;
  /**
   * Value of this custom field for this particular lead
   */
  value: LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_value | null;
  /**
   * Lead associated with this particular custom field context
   */
  lead: LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField_lead;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions {
  __typename: "LeadGoalCondition";
  /**
   * The lead agnostic condition object.
   */
  condition: LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_condition;
  /**
   * Is this the current stage of the lead?
   */
  status: ConditionStatus;
  /**
   * Custom field associated with this goal’s condition. Ideally, this would be
   * _any_ field, but for now we’re only supporting custom fields. Therefore, if
   * the field associated with this condition is _not_ a custom field, this will return `null`
   */
  conditionCustomField: LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions_conditionCustomField | null;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_unfiredEmailAutomations_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_unfiredEmailAutomations_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_unfiredEmailAutomations_emailList_MailChimpList {
  __typename: "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_unfiredEmailAutomations_emailList_ConstantContactList {
  __typename: "ConstantContactList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_unfiredEmailAutomations_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_unfiredEmailAutomations_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  emailSequenceTemplateMessages: LeadSetWatched_leadSetWatched_lead_stages_edges_unfiredEmailAutomations_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
}

export type LeadSetWatched_leadSetWatched_lead_stages_edges_unfiredEmailAutomations_emailList = LeadSetWatched_leadSetWatched_lead_stages_edges_unfiredEmailAutomations_emailList_MailChimpList | LeadSetWatched_leadSetWatched_lead_stages_edges_unfiredEmailAutomations_emailList_ConstantContactList | LeadSetWatched_leadSetWatched_lead_stages_edges_unfiredEmailAutomations_emailList_EmailSequenceTemplate;

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_unfiredEmailAutomations {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: LeadSetWatched_leadSetWatched_lead_stages_edges_unfiredEmailAutomations_delay | null;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: LeadSetWatched_leadSetWatched_lead_stages_edges_unfiredEmailAutomations_entersStage;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: LeadSetWatched_leadSetWatched_lead_stages_edges_unfiredEmailAutomations_emailList | null;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_sender_sendableEmailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_sender {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * List of successfully enabled user email addresses that a user is able to send emails from Nutshell with.
   */
  sendableEmailAddresses: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_sender_sendableEmailAddresses[];
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailAutomation_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_MailChimpList {
  __typename: "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_ConstantContactList {
  __typename: "ConstantContactList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  emailSequenceTemplateMessages: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
}

export type LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList = LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_MailChimpList | LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_ConstantContactList | LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate;

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailAutomation_delay | null;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailAutomation_entersStage;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList | null;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate_creatorUser;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  emailsQueued: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued[];
  /**
   * The next message to be sent
   */
  nextUnsentEmail: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailSequence_nextUnsentEmail | null;
  emailSequenceTemplate: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate | null;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_firstName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_lastName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_companyName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary_value;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge | null;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_lead_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_lead_contacts;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_lead_assignee | null;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses {
  __typename: "EmailAutomationStatus";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The message to show to the user
   */
  status: EmailAutomationStatusStatus;
  /**
   * Is this automation status paused?
   */
  isPaused: boolean;
  /**
   * Can this status be cancelled
   */
  canCancel: boolean;
  /**
   * The total number of messages in the sequence for this status
   */
  unsentMessageCount: number | null;
  /**
   * Can this status be started
   */
  canStart: boolean;
  /**
   * The user that either did send this automation, or current _would_ send this
   * automation given the current context. For example, if the user is assigned to
   * a team, the logged in user is considered a potential sender if they’re on that team
   */
  sender: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_sender | null;
  /**
   * Email list stage subscription associated with this status row
   */
  emailAutomation: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailAutomation;
  /**
   * The actual email sequence going out for this lead in this stage
   */
  emailSequence: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_emailSequence | null;
  /**
   * Status of the first name field
   */
  firstName: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_firstName;
  /**
   * Status of the last name field
   */
  lastName: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_lastName;
  /**
   * Status of the company name field
   */
  companyName: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_companyName;
  /**
   * Lead associated with this status row
   */
  lead: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses_lead;
}

export interface LeadSetWatched_leadSetWatched_lead_stages_edges {
  __typename: "LeadStagesEdge";
  node: LeadSetWatched_leadSetWatched_lead_stages_edges_node;
  /**
   * Contextual avatarUrl for this stage. This might be something like an
   * incomplete avatarUrl, an active one, or a complete one.
   */
  avatarUrl: string;
  /**
   * Chevron style avatarUrl for this stage. This is impacted by the status of the lead.
   */
  chevronAvatarUrl: string;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
  /**
   * How long did the lead spend in this stage?
   */
  timeInStage: LeadSetWatched_leadSetWatched_lead_stages_edges_timeInStage | null;
  /**
   * List of this lead goal’s conditions associated with the given stage
   */
  goalConditions: LeadSetWatched_leadSetWatched_lead_stages_edges_goalConditions[];
  /**
   * List of this stage’s unfired email automations (automations without a status yet, because they’re in a future stage)
   */
  unfiredEmailAutomations: LeadSetWatched_leadSetWatched_lead_stages_edges_unfiredEmailAutomations[];
  /**
   * List of active stage subscription statuses for this lead
   */
  emailAutomationStatuses: LeadSetWatched_leadSetWatched_lead_stages_edges_emailAutomationStatuses[];
}

export interface LeadSetWatched_leadSetWatched_lead_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: LeadSetWatched_leadSetWatched_lead_stages_current | null;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: LeadSetWatched_leadSetWatched_lead_stages_edges[];
}

export interface LeadSetWatched_leadSetWatched_lead_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface LeadSetWatched_leadSetWatched_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The stages associated with this stageset
   */
  stages: LeadSetWatched_leadSetWatched_lead_stageset_stages[];
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
}

export interface LeadSetWatched_leadSetWatched_lead_stagesetForWidgets_sidebarWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface LeadSetWatched_leadSetWatched_lead_stagesetForWidgets_workspaceWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface LeadSetWatched_leadSetWatched_lead_stagesetForWidgets {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The widgets of the stageset lead sidebar
   */
  sidebarWidgets: LeadSetWatched_leadSetWatched_lead_stagesetForWidgets_sidebarWidgets[];
  /**
   * The widgets of the stageset lead workspace
   */
  workspaceWidgets: LeadSetWatched_leadSetWatched_lead_stagesetForWidgets_workspaceWidgets[];
}

export interface LeadSetWatched_leadSetWatched_lead_tags_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadSetWatched_leadSetWatched_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: LeadSetWatched_leadSetWatched_lead_tags_creator;
}

export interface LeadSetWatched_leadSetWatched_lead_tagMaps_edges_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadSetWatched_leadSetWatched_lead_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadSetWatched_leadSetWatched_lead_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: LeadSetWatched_leadSetWatched_lead_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface LeadSetWatched_leadSetWatched_lead_tagMaps_edges {
  __typename: "TagMapsEdge";
  /**
   * The creator of this tag map
   */
  creator: LeadSetWatched_leadSetWatched_lead_tagMaps_edges_creator | null;
  /**
   * The DateTime that represents when the Tag was mapped
   */
  createdTime: any | null;
  node: LeadSetWatched_leadSetWatched_lead_tagMaps_edges_node | null;
}

export interface LeadSetWatched_leadSetWatched_lead_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * A list of edges.
   */
  edges: LeadSetWatched_leadSetWatched_lead_tagMaps_edges[];
}

export interface LeadSetWatched_leadSetWatched_lead_outcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadSetWatched_leadSetWatched_lead_sendToDestinations {
  __typename: "EntityDestination";
  /**
   * The descriptive name for this destination.
   */
  name: string;
  /**
   * The URL this destination should direct to.
   */
  localUrl: string;
}

export interface LeadSetWatched_leadSetWatched_lead_externalResources {
  __typename: "ExternalResource";
  /**
   * The name of the external service this resource belongs to.
   */
  externalService: ExternalService;
  /**
   * The type of external resource.
   */
  externalResourceType: ExternalResourceType;
  /**
   * The ID of the external resource.
   */
  externalId: string;
}

export interface LeadSetWatched_leadSetWatched_lead_research_summary_leadFitReasons {
  __typename: "LeadFitReason";
  /**
   * Concise headline explaining this factor (always visible)
   */
  text: string;
  sentiment: LeadResearchSentiment;
  /**
   * Supporting detail shown when expanded
   */
  body: string;
}

export interface LeadSetWatched_leadSetWatched_lead_research_summary_fields {
  __typename: "LeadResearchField";
  key: string;
  label: string;
  value: string;
}

export interface LeadSetWatched_leadSetWatched_lead_research_summary_companyOverview {
  __typename: "CompanyOverview";
  /**
   * One punchy sentence about the company (max 48 chars)
   */
  headline: string;
  /**
   * 1-2 sentences of key factual details
   */
  body: string;
}

export interface LeadSetWatched_leadSetWatched_lead_research_summary {
  __typename: "EntitySummaryLeadResearch";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
  leadFit: LeadFitScore;
  leadFitLabel: string;
  leadFitReasons: LeadSetWatched_leadSetWatched_lead_research_summary_leadFitReasons[];
  fields: LeadSetWatched_leadSetWatched_lead_research_summary_fields[];
  companyOverview: LeadSetWatched_leadSetWatched_lead_research_summary_companyOverview | null;
  isDemoOverride: boolean;
  canRefresh: boolean;
}

export interface LeadSetWatched_leadSetWatched_lead_research {
  __typename: "LeadResearchResult";
  /**
   * Whether the lead has sufficient data (domains) to be researched
   */
  canResearch: boolean;
  isDemoResearchEnabled: boolean;
  /**
   * The AI-generated research summary, if available
   */
  summary: LeadSetWatched_leadSetWatched_lead_research_summary | null;
}

export interface LeadSetWatched_leadSetWatched_lead_installments_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface LeadSetWatched_leadSetWatched_lead_installments {
  __typename: "Installment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  dueTime: any;
  description: string | null;
  failedTime: any | null;
  value: LeadSetWatched_leadSetWatched_lead_installments_value;
}

export interface LeadSetWatched_leadSetWatched_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The bcc address of the Nutshell Lead.
   */
  bccAddress: string;
  number: number | null;
  /**
   * The terrority to which this lead is assigned.
   */
  territory: LeadSetWatched_leadSetWatched_lead_territory | null;
  avatarUrl: string;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  /**
   * Is this lead "Hot"?
   */
  isHot: boolean;
  /**
   * Is this lead "Overdue"? Overdue generally means that the lead is behind a
   * designated schedule dictated by its associated sales process
   */
  isOverdue: boolean;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The deleted time for the lead if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The percentage confidence of lead success.
   */
  confidence: number;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * The anticipated close time for the lead.
   */
  anticipatedClosedTime: any | null;
  /**
   * Returns true if the current user is watching this lead.
   */
  isCurrentUserWatching: boolean;
  /**
   * What time does this lead become overdue in the active stage? Null if no overdue time is set.
   */
  stageOverdueTime: any | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: LeadSetWatched_leadSetWatched_lead_assignee | null;
  /**
   * The deemed "creator" of this lead. If a user has created the lead manually,
   * our UI will show the user, otherwise we’ll fallback to the origin, i.e. "API"
   * or "CSV import"
   */
  creator: LeadSetWatched_leadSetWatched_lead_creator;
  /**
   * The mode of the leads value
   */
  valueMode: LeadValueMode;
  value: LeadSetWatched_leadSetWatched_lead_value | null;
  /**
   * Products for the lead
   */
  products: LeadSetWatched_leadSetWatched_lead_products | null;
  /**
   * The lead this lead was cloned from (usually null)
   */
  clonedFrom: LeadSetWatched_leadSetWatched_lead_clonedFrom | null;
  /**
   * Stages for the lead
   */
  stages: LeadSetWatched_leadSetWatched_lead_stages;
  /**
   * Stageset associated with the given lead
   */
  stageset: LeadSetWatched_leadSetWatched_lead_stageset | null;
  /**
   * Stageset to be used for gathering widget information, even for leads that may be missing an explicit stageset
   */
  stagesetForWidgets: LeadSetWatched_leadSetWatched_lead_stagesetForWidgets;
  /**
   * The list of tags on this lead
   */
  tags: LeadSetWatched_leadSetWatched_lead_tags[];
  /**
   * Tag maps for the lead
   */
  tagMaps: LeadSetWatched_leadSetWatched_lead_tagMaps | null;
  /**
   * The outcome for this lead, if there is one.
   */
  outcome: LeadSetWatched_leadSetWatched_lead_outcome | null;
  /**
   * The list of destinations for this lead
   */
  sendToDestinations: LeadSetWatched_leadSetWatched_lead_sendToDestinations[];
  /**
   * External resources mapped to this lead
   */
  externalResources: LeadSetWatched_leadSetWatched_lead_externalResources[];
  /**
   * AI-generated research and insights about this lead
   */
  research: LeadSetWatched_leadSetWatched_lead_research;
  /**
   * Timezone for installment paid and past-due. Lead owner, then first admin, then UTC.
   */
  installmentsTimezone: string;
  /**
   * List of installments on this lead
   */
  installments: LeadSetWatched_leadSetWatched_lead_installments[];
}

export interface LeadSetWatched_leadSetWatched {
  __typename: "LeadSetWatchedPayload";
  /**
   * The watched Nutshell lead.
   */
  lead: LeadSetWatched_leadSetWatched_lead;
}

export interface LeadSetWatched {
  /**
   * Adds users to the watch list for a Nutshell lead.
   */
  leadSetWatched: LeadSetWatched_leadSetWatched;
}

export interface LeadSetWatchedVariables {
  lead: LeadSetWatchedInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateLeadAssignee
// ====================================================

export interface UpdateLeadAssignee_assignLead_lead_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface UpdateLeadAssignee_assignLead_lead_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface UpdateLeadAssignee_assignLead_lead_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type UpdateLeadAssignee_assignLead_lead_assignee = UpdateLeadAssignee_assignLead_lead_assignee_Team | UpdateLeadAssignee_assignLead_lead_assignee_User;

export interface UpdateLeadAssignee_assignLead_lead_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateLeadAssignee_assignLead_lead_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
}

export interface UpdateLeadAssignee_assignLead_lead_products_totalValue {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface UpdateLeadAssignee_assignLead_lead_products {
  __typename: "LeadProductsConnection";
  /**
   * The total value of the products mapped to the lead
   */
  totalValue: UpdateLeadAssignee_assignLead_lead_products_totalValue | null;
}

export interface UpdateLeadAssignee_assignLead_lead_clonedFrom {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The time this stage was deleted, or null if this stage has not been deleted.
   */
  deletedTime: any | null;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_timeInStage {
  __typename: "FormattedValueDuration";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formattedString: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_condition {
  __typename: "Condition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase {
  __typename: "EntityAttributeBase";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase_attribute;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_options {
  __typename: "EnumOption";
  /**
   * The name (and primary identifier) of the enum option.
   */
  id: string;
  /**
   * The name (and display) of the enum option.
   */
  name: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum {
  __typename: "EntityAttributeEnum";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_attribute;
  /**
   * Enum options for this field
   */
  options: UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_options[];
  /**
   * Does this enum field allow multiple selections. I.e. can the value of "Favorite Color" be "Red" AND "Blue"?
   */
  allowMultiple: boolean;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency {
  __typename: "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency_attribute;
  /**
   * Available currency options for this field
   */
  currencyOptions: string[];
  /**
   * Default currency for this field
   */
  defaultCurrency: string;
}

export type UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_node = UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency;

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates | null;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all = UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueset | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueString | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueText | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEnum | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueDate | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEmail | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValuePhone | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueImage | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueUrl | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueNumber;

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all[];
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation_coordinates | null;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value = UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueString | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueText | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEnum | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueDate | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEmail | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValuePhone | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueImage | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueUrl | UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueNumber;

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField {
  __typename: "LeadConditionCustomField";
  /**
   * The lead agnostic entity attribute object (the field).
   */
  node: UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_node;
  /**
   * Value of this custom field for this particular lead
   */
  value: UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_value | null;
  /**
   * Lead associated with this particular custom field context
   */
  lead: UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField_lead;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions {
  __typename: "LeadGoalCondition";
  /**
   * The lead agnostic condition object.
   */
  condition: UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_condition;
  /**
   * Is this the current stage of the lead?
   */
  status: ConditionStatus;
  /**
   * Custom field associated with this goal’s condition. Ideally, this would be
   * _any_ field, but for now we’re only supporting custom fields. Therefore, if
   * the field associated with this condition is _not_ a custom field, this will return `null`
   */
  conditionCustomField: UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions_conditionCustomField | null;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_unfiredEmailAutomations_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_unfiredEmailAutomations_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_unfiredEmailAutomations_emailList_MailChimpList {
  __typename: "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_unfiredEmailAutomations_emailList_ConstantContactList {
  __typename: "ConstantContactList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_unfiredEmailAutomations_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_unfiredEmailAutomations_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  emailSequenceTemplateMessages: UpdateLeadAssignee_assignLead_lead_stages_edges_unfiredEmailAutomations_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
}

export type UpdateLeadAssignee_assignLead_lead_stages_edges_unfiredEmailAutomations_emailList = UpdateLeadAssignee_assignLead_lead_stages_edges_unfiredEmailAutomations_emailList_MailChimpList | UpdateLeadAssignee_assignLead_lead_stages_edges_unfiredEmailAutomations_emailList_ConstantContactList | UpdateLeadAssignee_assignLead_lead_stages_edges_unfiredEmailAutomations_emailList_EmailSequenceTemplate;

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_unfiredEmailAutomations {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: UpdateLeadAssignee_assignLead_lead_stages_edges_unfiredEmailAutomations_delay | null;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: UpdateLeadAssignee_assignLead_lead_stages_edges_unfiredEmailAutomations_entersStage;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: UpdateLeadAssignee_assignLead_lead_stages_edges_unfiredEmailAutomations_emailList | null;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_sender_sendableEmailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_sender {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * List of successfully enabled user email addresses that a user is able to send emails from Nutshell with.
   */
  sendableEmailAddresses: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_sender_sendableEmailAddresses[];
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_MailChimpList {
  __typename: "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_ConstantContactList {
  __typename: "ConstantContactList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  emailSequenceTemplateMessages: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
}

export type UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList = UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_MailChimpList | UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_ConstantContactList | UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate;

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_delay | null;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_entersStage;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList | null;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate_creatorUser;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  emailsQueued: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued[];
  /**
   * The next message to be sent
   */
  nextUnsentEmail: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailSequence_nextUnsentEmail | null;
  emailSequenceTemplate: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate | null;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_firstName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_lastName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_companyName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary_value;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge | null;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_lead_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_lead_contacts;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_lead_assignee | null;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses {
  __typename: "EmailAutomationStatus";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The message to show to the user
   */
  status: EmailAutomationStatusStatus;
  /**
   * Is this automation status paused?
   */
  isPaused: boolean;
  /**
   * Can this status be cancelled
   */
  canCancel: boolean;
  /**
   * The total number of messages in the sequence for this status
   */
  unsentMessageCount: number | null;
  /**
   * Can this status be started
   */
  canStart: boolean;
  /**
   * The user that either did send this automation, or current _would_ send this
   * automation given the current context. For example, if the user is assigned to
   * a team, the logged in user is considered a potential sender if they’re on that team
   */
  sender: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_sender | null;
  /**
   * Email list stage subscription associated with this status row
   */
  emailAutomation: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailAutomation;
  /**
   * The actual email sequence going out for this lead in this stage
   */
  emailSequence: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_emailSequence | null;
  /**
   * Status of the first name field
   */
  firstName: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_firstName;
  /**
   * Status of the last name field
   */
  lastName: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_lastName;
  /**
   * Status of the company name field
   */
  companyName: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_companyName;
  /**
   * Lead associated with this status row
   */
  lead: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses_lead;
}

export interface UpdateLeadAssignee_assignLead_lead_stages_edges {
  __typename: "LeadStagesEdge";
  node: UpdateLeadAssignee_assignLead_lead_stages_edges_node;
  /**
   * Contextual avatarUrl for this stage. This might be something like an
   * incomplete avatarUrl, an active one, or a complete one.
   */
  avatarUrl: string;
  /**
   * Chevron style avatarUrl for this stage. This is impacted by the status of the lead.
   */
  chevronAvatarUrl: string;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
  /**
   * How long did the lead spend in this stage?
   */
  timeInStage: UpdateLeadAssignee_assignLead_lead_stages_edges_timeInStage | null;
  /**
   * List of this lead goal’s conditions associated with the given stage
   */
  goalConditions: UpdateLeadAssignee_assignLead_lead_stages_edges_goalConditions[];
  /**
   * List of this stage’s unfired email automations (automations without a status yet, because they’re in a future stage)
   */
  unfiredEmailAutomations: UpdateLeadAssignee_assignLead_lead_stages_edges_unfiredEmailAutomations[];
  /**
   * List of active stage subscription statuses for this lead
   */
  emailAutomationStatuses: UpdateLeadAssignee_assignLead_lead_stages_edges_emailAutomationStatuses[];
}

export interface UpdateLeadAssignee_assignLead_lead_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: UpdateLeadAssignee_assignLead_lead_stages_current | null;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: UpdateLeadAssignee_assignLead_lead_stages_edges[];
}

export interface UpdateLeadAssignee_assignLead_lead_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface UpdateLeadAssignee_assignLead_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The stages associated with this stageset
   */
  stages: UpdateLeadAssignee_assignLead_lead_stageset_stages[];
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
}

export interface UpdateLeadAssignee_assignLead_lead_stagesetForWidgets_sidebarWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface UpdateLeadAssignee_assignLead_lead_stagesetForWidgets_workspaceWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface UpdateLeadAssignee_assignLead_lead_stagesetForWidgets {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The widgets of the stageset lead sidebar
   */
  sidebarWidgets: UpdateLeadAssignee_assignLead_lead_stagesetForWidgets_sidebarWidgets[];
  /**
   * The widgets of the stageset lead workspace
   */
  workspaceWidgets: UpdateLeadAssignee_assignLead_lead_stagesetForWidgets_workspaceWidgets[];
}

export interface UpdateLeadAssignee_assignLead_lead_tags_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateLeadAssignee_assignLead_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: UpdateLeadAssignee_assignLead_lead_tags_creator;
}

export interface UpdateLeadAssignee_assignLead_lead_tagMaps_edges_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateLeadAssignee_assignLead_lead_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateLeadAssignee_assignLead_lead_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: UpdateLeadAssignee_assignLead_lead_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface UpdateLeadAssignee_assignLead_lead_tagMaps_edges {
  __typename: "TagMapsEdge";
  /**
   * The creator of this tag map
   */
  creator: UpdateLeadAssignee_assignLead_lead_tagMaps_edges_creator | null;
  /**
   * The DateTime that represents when the Tag was mapped
   */
  createdTime: any | null;
  node: UpdateLeadAssignee_assignLead_lead_tagMaps_edges_node | null;
}

export interface UpdateLeadAssignee_assignLead_lead_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * A list of edges.
   */
  edges: UpdateLeadAssignee_assignLead_lead_tagMaps_edges[];
}

export interface UpdateLeadAssignee_assignLead_lead_outcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateLeadAssignee_assignLead_lead_sendToDestinations {
  __typename: "EntityDestination";
  /**
   * The descriptive name for this destination.
   */
  name: string;
  /**
   * The URL this destination should direct to.
   */
  localUrl: string;
}

export interface UpdateLeadAssignee_assignLead_lead_externalResources {
  __typename: "ExternalResource";
  /**
   * The name of the external service this resource belongs to.
   */
  externalService: ExternalService;
  /**
   * The type of external resource.
   */
  externalResourceType: ExternalResourceType;
  /**
   * The ID of the external resource.
   */
  externalId: string;
}

export interface UpdateLeadAssignee_assignLead_lead_research_summary_leadFitReasons {
  __typename: "LeadFitReason";
  /**
   * Concise headline explaining this factor (always visible)
   */
  text: string;
  sentiment: LeadResearchSentiment;
  /**
   * Supporting detail shown when expanded
   */
  body: string;
}

export interface UpdateLeadAssignee_assignLead_lead_research_summary_fields {
  __typename: "LeadResearchField";
  key: string;
  label: string;
  value: string;
}

export interface UpdateLeadAssignee_assignLead_lead_research_summary_companyOverview {
  __typename: "CompanyOverview";
  /**
   * One punchy sentence about the company (max 48 chars)
   */
  headline: string;
  /**
   * 1-2 sentences of key factual details
   */
  body: string;
}

export interface UpdateLeadAssignee_assignLead_lead_research_summary {
  __typename: "EntitySummaryLeadResearch";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
  leadFit: LeadFitScore;
  leadFitLabel: string;
  leadFitReasons: UpdateLeadAssignee_assignLead_lead_research_summary_leadFitReasons[];
  fields: UpdateLeadAssignee_assignLead_lead_research_summary_fields[];
  companyOverview: UpdateLeadAssignee_assignLead_lead_research_summary_companyOverview | null;
  isDemoOverride: boolean;
  canRefresh: boolean;
}

export interface UpdateLeadAssignee_assignLead_lead_research {
  __typename: "LeadResearchResult";
  /**
   * Whether the lead has sufficient data (domains) to be researched
   */
  canResearch: boolean;
  isDemoResearchEnabled: boolean;
  /**
   * The AI-generated research summary, if available
   */
  summary: UpdateLeadAssignee_assignLead_lead_research_summary | null;
}

export interface UpdateLeadAssignee_assignLead_lead_installments_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface UpdateLeadAssignee_assignLead_lead_installments {
  __typename: "Installment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  dueTime: any;
  description: string | null;
  failedTime: any | null;
  value: UpdateLeadAssignee_assignLead_lead_installments_value;
}

export interface UpdateLeadAssignee_assignLead_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The bcc address of the Nutshell Lead.
   */
  bccAddress: string;
  number: number | null;
  /**
   * The terrority to which this lead is assigned.
   */
  territory: UpdateLeadAssignee_assignLead_lead_territory | null;
  avatarUrl: string;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  /**
   * Is this lead "Hot"?
   */
  isHot: boolean;
  /**
   * Is this lead "Overdue"? Overdue generally means that the lead is behind a
   * designated schedule dictated by its associated sales process
   */
  isOverdue: boolean;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The deleted time for the lead if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The percentage confidence of lead success.
   */
  confidence: number;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * The anticipated close time for the lead.
   */
  anticipatedClosedTime: any | null;
  /**
   * Returns true if the current user is watching this lead.
   */
  isCurrentUserWatching: boolean;
  /**
   * What time does this lead become overdue in the active stage? Null if no overdue time is set.
   */
  stageOverdueTime: any | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: UpdateLeadAssignee_assignLead_lead_assignee | null;
  /**
   * The deemed "creator" of this lead. If a user has created the lead manually,
   * our UI will show the user, otherwise we’ll fallback to the origin, i.e. "API"
   * or "CSV import"
   */
  creator: UpdateLeadAssignee_assignLead_lead_creator;
  /**
   * The mode of the leads value
   */
  valueMode: LeadValueMode;
  value: UpdateLeadAssignee_assignLead_lead_value | null;
  /**
   * Products for the lead
   */
  products: UpdateLeadAssignee_assignLead_lead_products | null;
  /**
   * The lead this lead was cloned from (usually null)
   */
  clonedFrom: UpdateLeadAssignee_assignLead_lead_clonedFrom | null;
  /**
   * Stages for the lead
   */
  stages: UpdateLeadAssignee_assignLead_lead_stages;
  /**
   * Stageset associated with the given lead
   */
  stageset: UpdateLeadAssignee_assignLead_lead_stageset | null;
  /**
   * Stageset to be used for gathering widget information, even for leads that may be missing an explicit stageset
   */
  stagesetForWidgets: UpdateLeadAssignee_assignLead_lead_stagesetForWidgets;
  /**
   * The list of tags on this lead
   */
  tags: UpdateLeadAssignee_assignLead_lead_tags[];
  /**
   * Tag maps for the lead
   */
  tagMaps: UpdateLeadAssignee_assignLead_lead_tagMaps | null;
  /**
   * The outcome for this lead, if there is one.
   */
  outcome: UpdateLeadAssignee_assignLead_lead_outcome | null;
  /**
   * The list of destinations for this lead
   */
  sendToDestinations: UpdateLeadAssignee_assignLead_lead_sendToDestinations[];
  /**
   * External resources mapped to this lead
   */
  externalResources: UpdateLeadAssignee_assignLead_lead_externalResources[];
  /**
   * AI-generated research and insights about this lead
   */
  research: UpdateLeadAssignee_assignLead_lead_research;
  /**
   * Timezone for installment paid and past-due. Lead owner, then first admin, then UTC.
   */
  installmentsTimezone: string;
  /**
   * List of installments on this lead
   */
  installments: UpdateLeadAssignee_assignLead_lead_installments[];
}

export interface UpdateLeadAssignee_assignLead {
  __typename: "AssignLeadPayload";
  /**
   * The assigned Nutshell lead.
   */
  lead: UpdateLeadAssignee_assignLead_lead | null;
  /**
   * Any errors returned for this operation
   */
  errors: string | null;
}

export interface UpdateLeadAssignee {
  /**
   * Assigns a Nutshell lead.
   */
  assignLead: UpdateLeadAssignee_assignLead;
}

export interface UpdateLeadAssigneeVariables {
  lead: AssignLeadInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateLeadCustomFieldValue
// ====================================================

export interface UpdateLeadCustomFieldValue_updateLead_lead_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type UpdateLeadCustomFieldValue_updateLead_lead_assignee = UpdateLeadCustomFieldValue_updateLead_lead_assignee_Team | UpdateLeadCustomFieldValue_updateLead_lead_assignee_User;

export interface UpdateLeadCustomFieldValue_updateLead_lead_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_products_totalValue {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_products {
  __typename: "LeadProductsConnection";
  /**
   * The total value of the products mapped to the lead
   */
  totalValue: UpdateLeadCustomFieldValue_updateLead_lead_products_totalValue | null;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_clonedFrom {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The time this stage was deleted, or null if this stage has not been deleted.
   */
  deletedTime: any | null;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_timeInStage {
  __typename: "FormattedValueDuration";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formattedString: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_condition {
  __typename: "Condition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase {
  __typename: "EntityAttributeBase";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase_attribute;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_options {
  __typename: "EnumOption";
  /**
   * The name (and primary identifier) of the enum option.
   */
  id: string;
  /**
   * The name (and display) of the enum option.
   */
  name: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum {
  __typename: "EntityAttributeEnum";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_attribute;
  /**
   * Enum options for this field
   */
  options: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_options[];
  /**
   * Does this enum field allow multiple selections. I.e. can the value of "Favorite Color" be "Red" AND "Blue"?
   */
  allowMultiple: boolean;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency {
  __typename: "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency_attribute;
  /**
   * Available currency options for this field
   */
  currencyOptions: string[];
  /**
   * Default currency for this field
   */
  defaultCurrency: string;
}

export type UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_node = UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency;

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates | null;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all = UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueset | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueString | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueText | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEnum | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueDate | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEmail | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValuePhone | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueImage | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueUrl | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueNumber;

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all[];
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation_coordinates | null;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value = UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueString | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueText | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEnum | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueDate | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEmail | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValuePhone | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueImage | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueUrl | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueNumber;

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField {
  __typename: "LeadConditionCustomField";
  /**
   * The lead agnostic entity attribute object (the field).
   */
  node: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_node;
  /**
   * Value of this custom field for this particular lead
   */
  value: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_value | null;
  /**
   * Lead associated with this particular custom field context
   */
  lead: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField_lead;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions {
  __typename: "LeadGoalCondition";
  /**
   * The lead agnostic condition object.
   */
  condition: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_condition;
  /**
   * Is this the current stage of the lead?
   */
  status: ConditionStatus;
  /**
   * Custom field associated with this goal’s condition. Ideally, this would be
   * _any_ field, but for now we’re only supporting custom fields. Therefore, if
   * the field associated with this condition is _not_ a custom field, this will return `null`
   */
  conditionCustomField: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions_conditionCustomField | null;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_unfiredEmailAutomations_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_unfiredEmailAutomations_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_unfiredEmailAutomations_emailList_MailChimpList {
  __typename: "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_unfiredEmailAutomations_emailList_ConstantContactList {
  __typename: "ConstantContactList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_unfiredEmailAutomations_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_unfiredEmailAutomations_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  emailSequenceTemplateMessages: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_unfiredEmailAutomations_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
}

export type UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_unfiredEmailAutomations_emailList = UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_unfiredEmailAutomations_emailList_MailChimpList | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_unfiredEmailAutomations_emailList_ConstantContactList | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_unfiredEmailAutomations_emailList_EmailSequenceTemplate;

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_unfiredEmailAutomations {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_unfiredEmailAutomations_delay | null;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_unfiredEmailAutomations_entersStage;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_unfiredEmailAutomations_emailList | null;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_sender_sendableEmailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_sender {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * List of successfully enabled user email addresses that a user is able to send emails from Nutshell with.
   */
  sendableEmailAddresses: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_sender_sendableEmailAddresses[];
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_MailChimpList {
  __typename: "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_ConstantContactList {
  __typename: "ConstantContactList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  emailSequenceTemplateMessages: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
}

export type UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList = UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_MailChimpList | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_ConstantContactList | UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate;

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_delay | null;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_entersStage;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList | null;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate_creatorUser;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  emailsQueued: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued[];
  /**
   * The next message to be sent
   */
  nextUnsentEmail: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailSequence_nextUnsentEmail | null;
  emailSequenceTemplate: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate | null;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_firstName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_lastName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_companyName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary_value;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge | null;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_lead_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_lead_contacts;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_lead_assignee | null;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses {
  __typename: "EmailAutomationStatus";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The message to show to the user
   */
  status: EmailAutomationStatusStatus;
  /**
   * Is this automation status paused?
   */
  isPaused: boolean;
  /**
   * Can this status be cancelled
   */
  canCancel: boolean;
  /**
   * The total number of messages in the sequence for this status
   */
  unsentMessageCount: number | null;
  /**
   * Can this status be started
   */
  canStart: boolean;
  /**
   * The user that either did send this automation, or current _would_ send this
   * automation given the current context. For example, if the user is assigned to
   * a team, the logged in user is considered a potential sender if they’re on that team
   */
  sender: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_sender | null;
  /**
   * Email list stage subscription associated with this status row
   */
  emailAutomation: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailAutomation;
  /**
   * The actual email sequence going out for this lead in this stage
   */
  emailSequence: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_emailSequence | null;
  /**
   * Status of the first name field
   */
  firstName: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_firstName;
  /**
   * Status of the last name field
   */
  lastName: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_lastName;
  /**
   * Status of the company name field
   */
  companyName: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_companyName;
  /**
   * Lead associated with this status row
   */
  lead: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses_lead;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages_edges {
  __typename: "LeadStagesEdge";
  node: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_node;
  /**
   * Contextual avatarUrl for this stage. This might be something like an
   * incomplete avatarUrl, an active one, or a complete one.
   */
  avatarUrl: string;
  /**
   * Chevron style avatarUrl for this stage. This is impacted by the status of the lead.
   */
  chevronAvatarUrl: string;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
  /**
   * How long did the lead spend in this stage?
   */
  timeInStage: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_timeInStage | null;
  /**
   * List of this lead goal’s conditions associated with the given stage
   */
  goalConditions: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_goalConditions[];
  /**
   * List of this stage’s unfired email automations (automations without a status yet, because they’re in a future stage)
   */
  unfiredEmailAutomations: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_unfiredEmailAutomations[];
  /**
   * List of active stage subscription statuses for this lead
   */
  emailAutomationStatuses: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges_emailAutomationStatuses[];
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: UpdateLeadCustomFieldValue_updateLead_lead_stages_current | null;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: UpdateLeadCustomFieldValue_updateLead_lead_stages_edges[];
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The stages associated with this stageset
   */
  stages: UpdateLeadCustomFieldValue_updateLead_lead_stageset_stages[];
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stagesetForWidgets_sidebarWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stagesetForWidgets_workspaceWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_stagesetForWidgets {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The widgets of the stageset lead sidebar
   */
  sidebarWidgets: UpdateLeadCustomFieldValue_updateLead_lead_stagesetForWidgets_sidebarWidgets[];
  /**
   * The widgets of the stageset lead workspace
   */
  workspaceWidgets: UpdateLeadCustomFieldValue_updateLead_lead_stagesetForWidgets_workspaceWidgets[];
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_tags_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: UpdateLeadCustomFieldValue_updateLead_lead_tags_creator;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_tagMaps_edges_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: UpdateLeadCustomFieldValue_updateLead_lead_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_tagMaps_edges {
  __typename: "TagMapsEdge";
  /**
   * The creator of this tag map
   */
  creator: UpdateLeadCustomFieldValue_updateLead_lead_tagMaps_edges_creator | null;
  /**
   * The DateTime that represents when the Tag was mapped
   */
  createdTime: any | null;
  node: UpdateLeadCustomFieldValue_updateLead_lead_tagMaps_edges_node | null;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * A list of edges.
   */
  edges: UpdateLeadCustomFieldValue_updateLead_lead_tagMaps_edges[];
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_outcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_sendToDestinations {
  __typename: "EntityDestination";
  /**
   * The descriptive name for this destination.
   */
  name: string;
  /**
   * The URL this destination should direct to.
   */
  localUrl: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_externalResources {
  __typename: "ExternalResource";
  /**
   * The name of the external service this resource belongs to.
   */
  externalService: ExternalService;
  /**
   * The type of external resource.
   */
  externalResourceType: ExternalResourceType;
  /**
   * The ID of the external resource.
   */
  externalId: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_research_summary_leadFitReasons {
  __typename: "LeadFitReason";
  /**
   * Concise headline explaining this factor (always visible)
   */
  text: string;
  sentiment: LeadResearchSentiment;
  /**
   * Supporting detail shown when expanded
   */
  body: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_research_summary_fields {
  __typename: "LeadResearchField";
  key: string;
  label: string;
  value: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_research_summary_companyOverview {
  __typename: "CompanyOverview";
  /**
   * One punchy sentence about the company (max 48 chars)
   */
  headline: string;
  /**
   * 1-2 sentences of key factual details
   */
  body: string;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_research_summary {
  __typename: "EntitySummaryLeadResearch";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
  leadFit: LeadFitScore;
  leadFitLabel: string;
  leadFitReasons: UpdateLeadCustomFieldValue_updateLead_lead_research_summary_leadFitReasons[];
  fields: UpdateLeadCustomFieldValue_updateLead_lead_research_summary_fields[];
  companyOverview: UpdateLeadCustomFieldValue_updateLead_lead_research_summary_companyOverview | null;
  isDemoOverride: boolean;
  canRefresh: boolean;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_research {
  __typename: "LeadResearchResult";
  /**
   * Whether the lead has sufficient data (domains) to be researched
   */
  canResearch: boolean;
  isDemoResearchEnabled: boolean;
  /**
   * The AI-generated research summary, if available
   */
  summary: UpdateLeadCustomFieldValue_updateLead_lead_research_summary | null;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_installments_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead_installments {
  __typename: "Installment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  dueTime: any;
  description: string | null;
  failedTime: any | null;
  value: UpdateLeadCustomFieldValue_updateLead_lead_installments_value;
}

export interface UpdateLeadCustomFieldValue_updateLead_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The bcc address of the Nutshell Lead.
   */
  bccAddress: string;
  number: number | null;
  /**
   * The terrority to which this lead is assigned.
   */
  territory: UpdateLeadCustomFieldValue_updateLead_lead_territory | null;
  avatarUrl: string;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  /**
   * Is this lead "Hot"?
   */
  isHot: boolean;
  /**
   * Is this lead "Overdue"? Overdue generally means that the lead is behind a
   * designated schedule dictated by its associated sales process
   */
  isOverdue: boolean;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The deleted time for the lead if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The percentage confidence of lead success.
   */
  confidence: number;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * The anticipated close time for the lead.
   */
  anticipatedClosedTime: any | null;
  /**
   * Returns true if the current user is watching this lead.
   */
  isCurrentUserWatching: boolean;
  /**
   * What time does this lead become overdue in the active stage? Null if no overdue time is set.
   */
  stageOverdueTime: any | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: UpdateLeadCustomFieldValue_updateLead_lead_assignee | null;
  /**
   * The deemed "creator" of this lead. If a user has created the lead manually,
   * our UI will show the user, otherwise we’ll fallback to the origin, i.e. "API"
   * or "CSV import"
   */
  creator: UpdateLeadCustomFieldValue_updateLead_lead_creator;
  /**
   * The mode of the leads value
   */
  valueMode: LeadValueMode;
  value: UpdateLeadCustomFieldValue_updateLead_lead_value | null;
  /**
   * Products for the lead
   */
  products: UpdateLeadCustomFieldValue_updateLead_lead_products | null;
  /**
   * The lead this lead was cloned from (usually null)
   */
  clonedFrom: UpdateLeadCustomFieldValue_updateLead_lead_clonedFrom | null;
  /**
   * Stages for the lead
   */
  stages: UpdateLeadCustomFieldValue_updateLead_lead_stages;
  /**
   * Stageset associated with the given lead
   */
  stageset: UpdateLeadCustomFieldValue_updateLead_lead_stageset | null;
  /**
   * Stageset to be used for gathering widget information, even for leads that may be missing an explicit stageset
   */
  stagesetForWidgets: UpdateLeadCustomFieldValue_updateLead_lead_stagesetForWidgets;
  /**
   * The list of tags on this lead
   */
  tags: UpdateLeadCustomFieldValue_updateLead_lead_tags[];
  /**
   * Tag maps for the lead
   */
  tagMaps: UpdateLeadCustomFieldValue_updateLead_lead_tagMaps | null;
  /**
   * The outcome for this lead, if there is one.
   */
  outcome: UpdateLeadCustomFieldValue_updateLead_lead_outcome | null;
  /**
   * The list of destinations for this lead
   */
  sendToDestinations: UpdateLeadCustomFieldValue_updateLead_lead_sendToDestinations[];
  /**
   * External resources mapped to this lead
   */
  externalResources: UpdateLeadCustomFieldValue_updateLead_lead_externalResources[];
  /**
   * AI-generated research and insights about this lead
   */
  research: UpdateLeadCustomFieldValue_updateLead_lead_research;
  /**
   * Timezone for installment paid and past-due. Lead owner, then first admin, then UTC.
   */
  installmentsTimezone: string;
  /**
   * List of installments on this lead
   */
  installments: UpdateLeadCustomFieldValue_updateLead_lead_installments[];
}

export interface UpdateLeadCustomFieldValue_updateLead {
  __typename: "UpdateLeadPayload";
  /**
   * The updated Nutshell lead.
   */
  lead: UpdateLeadCustomFieldValue_updateLead_lead;
}

export interface UpdateLeadCustomFieldValue {
  /**
   * Updates a Nutshell lead.
   */
  updateLead: UpdateLeadCustomFieldValue_updateLead;
}

export interface UpdateLeadCustomFieldValueVariables {
  lead: UpdateLeadInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateLeadTags
// ====================================================

export interface UpdateLeadTags_updateLead_lead_tagMaps_edges_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateLeadTags_updateLead_lead_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateLeadTags_updateLead_lead_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: UpdateLeadTags_updateLead_lead_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
  /**
   * The number of entities tagged with this tag
   */
  count: number;
}

export interface UpdateLeadTags_updateLead_lead_tagMaps_edges {
  __typename: "TagMapsEdge";
  /**
   * The creator of this tag map
   */
  creator: UpdateLeadTags_updateLead_lead_tagMaps_edges_creator | null;
  /**
   * The DateTime that represents when the Tag was mapped
   */
  createdTime: any | null;
  node: UpdateLeadTags_updateLead_lead_tagMaps_edges_node | null;
}

export interface UpdateLeadTags_updateLead_lead_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * A list of edges.
   */
  edges: UpdateLeadTags_updateLead_lead_tagMaps_edges[];
}

export interface UpdateLeadTags_updateLead_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Tag maps for the lead
   */
  tagMaps: UpdateLeadTags_updateLead_lead_tagMaps | null;
}

export interface UpdateLeadTags_updateLead {
  __typename: "UpdateLeadPayload";
  /**
   * The updated Nutshell lead.
   */
  lead: UpdateLeadTags_updateLead_lead;
}

export interface UpdateLeadTags {
  /**
   * Updates a Nutshell lead.
   */
  updateLead: UpdateLeadTags_updateLead;
}

export interface UpdateLeadTagsVariables {
  lead: UpdateLeadInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLeadContextSummary
// ====================================================

export interface GetLeadContextSummary_leadContextSummary {
  __typename: "LeadEntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
  /**
   * Whether the lead context summary is valid
   */
  isValid: boolean;
  /**
   * The recap of the lead context summary
   */
  recap: string | null;
  /**
   * The next steps of the lead context summary
   */
  nextSteps: string[] | null;
  /**
   * Recap of the lead's most recent logged and scheduled activities. Null if the lead has none.
   */
  lastActivities: string | null;
  /**
   * Unanswered questions surfaced from emails, calls, and notes. Empty if none were found.
   */
  openQuestions: string[] | null;
  /**
   * Profile of the lead: conversation points, business context, and rapport notes. Null if there is not enough data.
   */
  dossier: string | null;
}

export interface GetLeadContextSummary {
  /**
   * Get the latest summary for a lead, generating a new one if necessary
   */
  leadContextSummary: GetLeadContextSummary_leadContextSummary;
}

export interface GetLeadContextSummaryVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLeadTagMaps
// ====================================================

export interface GetLeadTagMaps_lead_tagMaps_edges_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadTagMaps_lead_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadTagMaps_lead_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: GetLeadTagMaps_lead_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
  /**
   * The number of entities tagged with this tag
   */
  count: number;
}

export interface GetLeadTagMaps_lead_tagMaps_edges {
  __typename: "TagMapsEdge";
  /**
   * The creator of this tag map
   */
  creator: GetLeadTagMaps_lead_tagMaps_edges_creator | null;
  /**
   * The DateTime that represents when the Tag was mapped
   */
  createdTime: any | null;
  node: GetLeadTagMaps_lead_tagMaps_edges_node | null;
}

export interface GetLeadTagMaps_lead_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * A list of edges.
   */
  edges: GetLeadTagMaps_lead_tagMaps_edges[];
}

export interface GetLeadTagMaps_lead_tags_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadTagMaps_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: GetLeadTagMaps_lead_tags_creator;
}

export interface GetLeadTagMaps_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Tag maps for the lead
   */
  tagMaps: GetLeadTagMaps_lead_tagMaps | null;
  /**
   * The list of tags on this lead
   */
  tags: GetLeadTagMaps_lead_tags[];
}

export interface GetLeadTagMaps {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetLeadTagMaps_lead | null;
}

export interface GetLeadTagMapsVariables {
  leadId?: string | null;
  number?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLead
// ====================================================

export interface GetLead_lead_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface GetLead_lead_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface GetLead_lead_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type GetLead_lead_assignee = GetLead_lead_assignee_Team | GetLead_lead_assignee_User;

export interface GetLead_lead_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLead_lead_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
}

export interface GetLead_lead_products_totalValue {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetLead_lead_products {
  __typename: "LeadProductsConnection";
  /**
   * The total value of the products mapped to the lead
   */
  totalValue: GetLead_lead_products_totalValue | null;
}

export interface GetLead_lead_clonedFrom {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetLead_lead_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The time this stage was deleted, or null if this stage has not been deleted.
   */
  deletedTime: any | null;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
}

export interface GetLead_lead_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetLead_lead_stages_edges_timeInStage {
  __typename: "FormattedValueDuration";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formattedString: string;
}

export interface GetLead_lead_stages_edges_goalConditions_condition {
  __typename: "Condition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase {
  __typename: "EntityAttributeBase";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: GetLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase_attribute;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_options {
  __typename: "EnumOption";
  /**
   * The name (and primary identifier) of the enum option.
   */
  id: string;
  /**
   * The name (and display) of the enum option.
   */
  name: string;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum {
  __typename: "EntityAttributeEnum";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: GetLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_attribute;
  /**
   * Enum options for this field
   */
  options: GetLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_options[];
  /**
   * Does this enum field allow multiple selections. I.e. can the value of "Favorite Color" be "Red" AND "Blue"?
   */
  allowMultiple: boolean;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency {
  __typename: "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: GetLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency_attribute;
  /**
   * Available currency options for this field
   */
  currencyOptions: string[];
  /**
   * Default currency for this field
   */
  defaultCurrency: string;
}

export type GetLead_lead_stages_edges_goalConditions_conditionCustomField_node = GetLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase | GetLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum | GetLead_lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency;

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates | null;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all = GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueset | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueString | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueText | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEnum | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueDate | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEmail | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValuePhone | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueImage | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueUrl | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueNumber;

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all[];
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation_coordinates | null;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type GetLead_lead_stages_edges_goalConditions_conditionCustomField_value = GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueString | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueText | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEnum | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueDate | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEmail | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValuePhone | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueImage | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueUrl | GetLead_lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueNumber;

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetLead_lead_stages_edges_goalConditions_conditionCustomField {
  __typename: "LeadConditionCustomField";
  /**
   * The lead agnostic entity attribute object (the field).
   */
  node: GetLead_lead_stages_edges_goalConditions_conditionCustomField_node;
  /**
   * Value of this custom field for this particular lead
   */
  value: GetLead_lead_stages_edges_goalConditions_conditionCustomField_value | null;
  /**
   * Lead associated with this particular custom field context
   */
  lead: GetLead_lead_stages_edges_goalConditions_conditionCustomField_lead;
}

export interface GetLead_lead_stages_edges_goalConditions {
  __typename: "LeadGoalCondition";
  /**
   * The lead agnostic condition object.
   */
  condition: GetLead_lead_stages_edges_goalConditions_condition;
  /**
   * Is this the current stage of the lead?
   */
  status: ConditionStatus;
  /**
   * Custom field associated with this goal’s condition. Ideally, this would be
   * _any_ field, but for now we’re only supporting custom fields. Therefore, if
   * the field associated with this condition is _not_ a custom field, this will return `null`
   */
  conditionCustomField: GetLead_lead_stages_edges_goalConditions_conditionCustomField | null;
}

export interface GetLead_lead_stages_edges_unfiredEmailAutomations_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetLead_lead_stages_edges_unfiredEmailAutomations_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetLead_lead_stages_edges_unfiredEmailAutomations_emailList_MailChimpList {
  __typename: "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface GetLead_lead_stages_edges_unfiredEmailAutomations_emailList_ConstantContactList {
  __typename: "ConstantContactList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface GetLead_lead_stages_edges_unfiredEmailAutomations_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetLead_lead_stages_edges_unfiredEmailAutomations_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  emailSequenceTemplateMessages: GetLead_lead_stages_edges_unfiredEmailAutomations_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
}

export type GetLead_lead_stages_edges_unfiredEmailAutomations_emailList = GetLead_lead_stages_edges_unfiredEmailAutomations_emailList_MailChimpList | GetLead_lead_stages_edges_unfiredEmailAutomations_emailList_ConstantContactList | GetLead_lead_stages_edges_unfiredEmailAutomations_emailList_EmailSequenceTemplate;

export interface GetLead_lead_stages_edges_unfiredEmailAutomations {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: GetLead_lead_stages_edges_unfiredEmailAutomations_delay | null;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: GetLead_lead_stages_edges_unfiredEmailAutomations_entersStage;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: GetLead_lead_stages_edges_unfiredEmailAutomations_emailList | null;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_sender_sendableEmailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_sender {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * List of successfully enabled user email addresses that a user is able to send emails from Nutshell with.
   */
  sendableEmailAddresses: GetLead_lead_stages_edges_emailAutomationStatuses_sender_sendableEmailAddresses[];
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_MailChimpList {
  __typename: "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_ConstantContactList {
  __typename: "ConstantContactList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  emailSequenceTemplateMessages: GetLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
}

export type GetLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList = GetLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_MailChimpList | GetLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_ConstantContactList | GetLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate;

export interface GetLead_lead_stages_edges_emailAutomationStatuses_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: GetLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_delay | null;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: GetLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_entersStage;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: GetLead_lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList | null;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: GetLead_lead_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate_creatorUser;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  emailsQueued: GetLead_lead_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued[];
  /**
   * The next message to be sent
   */
  nextUnsentEmail: GetLead_lead_stages_edges_emailAutomationStatuses_emailSequence_nextUnsentEmail | null;
  emailSequenceTemplate: GetLead_lead_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate | null;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_firstName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_lastName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_companyName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary_value;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetLead_lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge | null;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_lead_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetLead_lead_stages_edges_emailAutomationStatuses_lead_contacts;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetLead_lead_stages_edges_emailAutomationStatuses_lead_assignee | null;
}

export interface GetLead_lead_stages_edges_emailAutomationStatuses {
  __typename: "EmailAutomationStatus";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The message to show to the user
   */
  status: EmailAutomationStatusStatus;
  /**
   * Is this automation status paused?
   */
  isPaused: boolean;
  /**
   * Can this status be cancelled
   */
  canCancel: boolean;
  /**
   * The total number of messages in the sequence for this status
   */
  unsentMessageCount: number | null;
  /**
   * Can this status be started
   */
  canStart: boolean;
  /**
   * The user that either did send this automation, or current _would_ send this
   * automation given the current context. For example, if the user is assigned to
   * a team, the logged in user is considered a potential sender if they’re on that team
   */
  sender: GetLead_lead_stages_edges_emailAutomationStatuses_sender | null;
  /**
   * Email list stage subscription associated with this status row
   */
  emailAutomation: GetLead_lead_stages_edges_emailAutomationStatuses_emailAutomation;
  /**
   * The actual email sequence going out for this lead in this stage
   */
  emailSequence: GetLead_lead_stages_edges_emailAutomationStatuses_emailSequence | null;
  /**
   * Status of the first name field
   */
  firstName: GetLead_lead_stages_edges_emailAutomationStatuses_firstName;
  /**
   * Status of the last name field
   */
  lastName: GetLead_lead_stages_edges_emailAutomationStatuses_lastName;
  /**
   * Status of the company name field
   */
  companyName: GetLead_lead_stages_edges_emailAutomationStatuses_companyName;
  /**
   * Lead associated with this status row
   */
  lead: GetLead_lead_stages_edges_emailAutomationStatuses_lead;
}

export interface GetLead_lead_stages_edges {
  __typename: "LeadStagesEdge";
  node: GetLead_lead_stages_edges_node;
  /**
   * Contextual avatarUrl for this stage. This might be something like an
   * incomplete avatarUrl, an active one, or a complete one.
   */
  avatarUrl: string;
  /**
   * Chevron style avatarUrl for this stage. This is impacted by the status of the lead.
   */
  chevronAvatarUrl: string;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
  /**
   * How long did the lead spend in this stage?
   */
  timeInStage: GetLead_lead_stages_edges_timeInStage | null;
  /**
   * List of this lead goal’s conditions associated with the given stage
   */
  goalConditions: GetLead_lead_stages_edges_goalConditions[];
  /**
   * List of this stage’s unfired email automations (automations without a status yet, because they’re in a future stage)
   */
  unfiredEmailAutomations: GetLead_lead_stages_edges_unfiredEmailAutomations[];
  /**
   * List of active stage subscription statuses for this lead
   */
  emailAutomationStatuses: GetLead_lead_stages_edges_emailAutomationStatuses[];
}

export interface GetLead_lead_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: GetLead_lead_stages_current | null;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetLead_lead_stages_edges[];
}

export interface GetLead_lead_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetLead_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The stages associated with this stageset
   */
  stages: GetLead_lead_stageset_stages[];
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
}

export interface GetLead_lead_stagesetForWidgets_sidebarWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface GetLead_lead_stagesetForWidgets_workspaceWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface GetLead_lead_stagesetForWidgets {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The widgets of the stageset lead sidebar
   */
  sidebarWidgets: GetLead_lead_stagesetForWidgets_sidebarWidgets[];
  /**
   * The widgets of the stageset lead workspace
   */
  workspaceWidgets: GetLead_lead_stagesetForWidgets_workspaceWidgets[];
}

export interface GetLead_lead_tags_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLead_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: GetLead_lead_tags_creator;
}

export interface GetLead_lead_tagMaps_edges_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLead_lead_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLead_lead_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: GetLead_lead_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface GetLead_lead_tagMaps_edges {
  __typename: "TagMapsEdge";
  /**
   * The creator of this tag map
   */
  creator: GetLead_lead_tagMaps_edges_creator | null;
  /**
   * The DateTime that represents when the Tag was mapped
   */
  createdTime: any | null;
  node: GetLead_lead_tagMaps_edges_node | null;
}

export interface GetLead_lead_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * A list of edges.
   */
  edges: GetLead_lead_tagMaps_edges[];
}

export interface GetLead_lead_outcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLead_lead_sendToDestinations {
  __typename: "EntityDestination";
  /**
   * The descriptive name for this destination.
   */
  name: string;
  /**
   * The URL this destination should direct to.
   */
  localUrl: string;
}

export interface GetLead_lead_externalResources {
  __typename: "ExternalResource";
  /**
   * The name of the external service this resource belongs to.
   */
  externalService: ExternalService;
  /**
   * The type of external resource.
   */
  externalResourceType: ExternalResourceType;
  /**
   * The ID of the external resource.
   */
  externalId: string;
}

export interface GetLead_lead_research_summary_leadFitReasons {
  __typename: "LeadFitReason";
  /**
   * Concise headline explaining this factor (always visible)
   */
  text: string;
  sentiment: LeadResearchSentiment;
  /**
   * Supporting detail shown when expanded
   */
  body: string;
}

export interface GetLead_lead_research_summary_fields {
  __typename: "LeadResearchField";
  key: string;
  label: string;
  value: string;
}

export interface GetLead_lead_research_summary_companyOverview {
  __typename: "CompanyOverview";
  /**
   * One punchy sentence about the company (max 48 chars)
   */
  headline: string;
  /**
   * 1-2 sentences of key factual details
   */
  body: string;
}

export interface GetLead_lead_research_summary {
  __typename: "EntitySummaryLeadResearch";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
  leadFit: LeadFitScore;
  leadFitLabel: string;
  leadFitReasons: GetLead_lead_research_summary_leadFitReasons[];
  fields: GetLead_lead_research_summary_fields[];
  companyOverview: GetLead_lead_research_summary_companyOverview | null;
  isDemoOverride: boolean;
  canRefresh: boolean;
}

export interface GetLead_lead_research {
  __typename: "LeadResearchResult";
  /**
   * Whether the lead has sufficient data (domains) to be researched
   */
  canResearch: boolean;
  isDemoResearchEnabled: boolean;
  /**
   * The AI-generated research summary, if available
   */
  summary: GetLead_lead_research_summary | null;
}

export interface GetLead_lead_installments_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface GetLead_lead_installments {
  __typename: "Installment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  dueTime: any;
  description: string | null;
  failedTime: any | null;
  value: GetLead_lead_installments_value;
}

export interface GetLead_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The bcc address of the Nutshell Lead.
   */
  bccAddress: string;
  number: number | null;
  /**
   * The terrority to which this lead is assigned.
   */
  territory: GetLead_lead_territory | null;
  avatarUrl: string;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  /**
   * Is this lead "Hot"?
   */
  isHot: boolean;
  /**
   * Is this lead "Overdue"? Overdue generally means that the lead is behind a
   * designated schedule dictated by its associated sales process
   */
  isOverdue: boolean;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The deleted time for the lead if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The percentage confidence of lead success.
   */
  confidence: number;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * The anticipated close time for the lead.
   */
  anticipatedClosedTime: any | null;
  /**
   * Returns true if the current user is watching this lead.
   */
  isCurrentUserWatching: boolean;
  /**
   * What time does this lead become overdue in the active stage? Null if no overdue time is set.
   */
  stageOverdueTime: any | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetLead_lead_assignee | null;
  /**
   * The deemed "creator" of this lead. If a user has created the lead manually,
   * our UI will show the user, otherwise we’ll fallback to the origin, i.e. "API"
   * or "CSV import"
   */
  creator: GetLead_lead_creator;
  /**
   * The mode of the leads value
   */
  valueMode: LeadValueMode;
  value: GetLead_lead_value | null;
  /**
   * Products for the lead
   */
  products: GetLead_lead_products | null;
  /**
   * The lead this lead was cloned from (usually null)
   */
  clonedFrom: GetLead_lead_clonedFrom | null;
  /**
   * Stages for the lead
   */
  stages: GetLead_lead_stages;
  /**
   * Stageset associated with the given lead
   */
  stageset: GetLead_lead_stageset | null;
  /**
   * Stageset to be used for gathering widget information, even for leads that may be missing an explicit stageset
   */
  stagesetForWidgets: GetLead_lead_stagesetForWidgets;
  /**
   * The list of tags on this lead
   */
  tags: GetLead_lead_tags[];
  /**
   * Tag maps for the lead
   */
  tagMaps: GetLead_lead_tagMaps | null;
  /**
   * The outcome for this lead, if there is one.
   */
  outcome: GetLead_lead_outcome | null;
  /**
   * The list of destinations for this lead
   */
  sendToDestinations: GetLead_lead_sendToDestinations[];
  /**
   * External resources mapped to this lead
   */
  externalResources: GetLead_lead_externalResources[];
  /**
   * AI-generated research and insights about this lead
   */
  research: GetLead_lead_research;
  /**
   * Timezone for installment paid and past-due. Lead owner, then first admin, then UTC.
   */
  installmentsTimezone: string;
  /**
   * List of installments on this lead
   */
  installments: GetLead_lead_installments[];
}

export interface GetLead {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetLead_lead | null;
}

export interface GetLeadVariables {
  id?: string | null;
  number?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetStages
// ====================================================

export interface GetStages_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
}

export interface GetStages {
  /**
   * Returns a list of Nutshell Stages that match the given stageset
   */
  stages: GetStages_stages[];
}

export interface GetStagesVariables {
  stagesetId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTags
// ====================================================

export interface GetTags_tags_pageInfo {
  __typename: "PageInfo";
  endCursor: string | null;
  hasNextPage: boolean;
  startCursor: string | null;
  hasPreviousPage: boolean;
}

export interface GetTags_tags_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetTags_tags_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: GetTags_tags_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
  /**
   * The number of entities tagged with this tag
   */
  count: number;
}

export interface GetTags_tags_edges {
  __typename: "TagsEdge";
  node: GetTags_tags_edges_node;
}

export interface GetTags_tags {
  __typename: "TagsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetTags_tags_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetTags_tags_edges[];
}

export interface GetTags {
  /**
   * Returns a paginated connection of Nutshell Tag objects
   */
  tags: GetTags_tags | null;
}

export interface GetTagsVariables {
  input: TagsQueryInputType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveAccountForLead
// ====================================================

export interface RemoveAccountForLead_leadRemoveAccount_lead_accounts_primaryEdge_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_accounts_primaryEdge_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: RemoveAccountForLead_leadRemoveAccount_lead_accounts_primaryEdge_node_postalAddresses_primary_location;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_accounts_primaryEdge_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveAccountForLead_leadRemoveAccount_lead_accounts_primaryEdge_node_postalAddresses_primary | null;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_accounts_primaryEdge_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_accounts_primaryEdge_node_phones_primary {
  __typename: "Phone";
  value: RemoveAccountForLead_leadRemoveAccount_lead_accounts_primaryEdge_node_phones_primary_value;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_accounts_primaryEdge_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveAccountForLead_leadRemoveAccount_lead_accounts_primaryEdge_node_phones_primary | null;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: RemoveAccountForLead_leadRemoveAccount_lead_accounts_primaryEdge_node_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: RemoveAccountForLead_leadRemoveAccount_lead_accounts_primaryEdge_node_phones;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: RemoveAccountForLead_leadRemoveAccount_lead_accounts_primaryEdge_node;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges_node_postalAddresses_primary_location;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges_node_postalAddresses_primary | null;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges_node_phones_primary {
  __typename: "Phone";
  value: RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges_node_phones_primary_value;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges_node_phones_primary | null;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges_node_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges_node_phones;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges_leadAccountContacts_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges_leadAccountContacts_phones_primary {
  __typename: "Phone";
  value: RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges_leadAccountContacts_phones_primary_value;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges_leadAccountContacts_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges_leadAccountContacts_phones_primary | null;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges_leadAccountContacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges_leadAccountContacts_phones;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges {
  __typename: "LeadAccountsEdge";
  node: RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges_node;
  /**
   * List of contacts associated with this account that are also on the root lead
   */
  leadAccountContacts: RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges_leadAccountContacts[] | null;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: RemoveAccountForLead_leadRemoveAccount_lead_accounts_primaryEdge | null;
  /**
   * A list of edges.
   */
  edges: RemoveAccountForLead_leadRemoveAccount_lead_accounts_edges[];
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_contacts_primaryEdge_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_contacts_primaryEdge_node_phones_primary {
  __typename: "Phone";
  value: RemoveAccountForLead_leadRemoveAccount_lead_contacts_primaryEdge_node_phones_primary_value;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_contacts_primaryEdge_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveAccountForLead_leadRemoveAccount_lead_contacts_primaryEdge_node_phones_primary | null;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: RemoveAccountForLead_leadRemoveAccount_lead_contacts_primaryEdge_node_phones;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: RemoveAccountForLead_leadRemoveAccount_lead_contacts_primaryEdge_node;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_contacts_nonCompanyMappedContacts_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_contacts_nonCompanyMappedContacts_node_phones_primary {
  __typename: "Phone";
  value: RemoveAccountForLead_leadRemoveAccount_lead_contacts_nonCompanyMappedContacts_node_phones_primary_value;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_contacts_nonCompanyMappedContacts_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveAccountForLead_leadRemoveAccount_lead_contacts_nonCompanyMappedContacts_node_phones_primary | null;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_contacts_nonCompanyMappedContacts_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: RemoveAccountForLead_leadRemoveAccount_lead_contacts_nonCompanyMappedContacts_node_phones;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_contacts_nonCompanyMappedContacts {
  __typename: "LeadContactsEdge";
  node: RemoveAccountForLead_leadRemoveAccount_lead_contacts_nonCompanyMappedContacts_node;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: RemoveAccountForLead_leadRemoveAccount_lead_contacts_primaryEdge | null;
  /**
   * List of contacts that are not associated with a company on this lead
   */
  nonCompanyMappedContacts: RemoveAccountForLead_leadRemoveAccount_lead_contacts_nonCompanyMappedContacts[] | null;
}

export interface RemoveAccountForLead_leadRemoveAccount_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: RemoveAccountForLead_leadRemoveAccount_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: RemoveAccountForLead_leadRemoveAccount_lead_contacts;
}

export interface RemoveAccountForLead_leadRemoveAccount {
  __typename: "LeadRemoveAccountPayload";
  /**
   * The lead with the removed account.
   */
  lead: RemoveAccountForLead_leadRemoveAccount_lead;
}

export interface RemoveAccountForLead {
  /**
   * Removes an account from a Lead
   */
  leadRemoveAccount: RemoveAccountForLead_leadRemoveAccount;
}

export interface RemoveAccountForLeadVariables {
  input: LeadRemoveAccountInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveContactForLead
// ====================================================

export interface RemoveContactForLead_leadRemoveContact_lead_accounts_primaryEdge_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface RemoveContactForLead_leadRemoveContact_lead_accounts_primaryEdge_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: RemoveContactForLead_leadRemoveContact_lead_accounts_primaryEdge_node_postalAddresses_primary_location;
}

export interface RemoveContactForLead_leadRemoveContact_lead_accounts_primaryEdge_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveContactForLead_leadRemoveContact_lead_accounts_primaryEdge_node_postalAddresses_primary | null;
}

export interface RemoveContactForLead_leadRemoveContact_lead_accounts_primaryEdge_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface RemoveContactForLead_leadRemoveContact_lead_accounts_primaryEdge_node_phones_primary {
  __typename: "Phone";
  value: RemoveContactForLead_leadRemoveContact_lead_accounts_primaryEdge_node_phones_primary_value;
}

export interface RemoveContactForLead_leadRemoveContact_lead_accounts_primaryEdge_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveContactForLead_leadRemoveContact_lead_accounts_primaryEdge_node_phones_primary | null;
}

export interface RemoveContactForLead_leadRemoveContact_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: RemoveContactForLead_leadRemoveContact_lead_accounts_primaryEdge_node_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: RemoveContactForLead_leadRemoveContact_lead_accounts_primaryEdge_node_phones;
}

export interface RemoveContactForLead_leadRemoveContact_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: RemoveContactForLead_leadRemoveContact_lead_accounts_primaryEdge_node;
}

export interface RemoveContactForLead_leadRemoveContact_lead_accounts_edges_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface RemoveContactForLead_leadRemoveContact_lead_accounts_edges_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: RemoveContactForLead_leadRemoveContact_lead_accounts_edges_node_postalAddresses_primary_location;
}

export interface RemoveContactForLead_leadRemoveContact_lead_accounts_edges_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveContactForLead_leadRemoveContact_lead_accounts_edges_node_postalAddresses_primary | null;
}

export interface RemoveContactForLead_leadRemoveContact_lead_accounts_edges_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface RemoveContactForLead_leadRemoveContact_lead_accounts_edges_node_phones_primary {
  __typename: "Phone";
  value: RemoveContactForLead_leadRemoveContact_lead_accounts_edges_node_phones_primary_value;
}

export interface RemoveContactForLead_leadRemoveContact_lead_accounts_edges_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveContactForLead_leadRemoveContact_lead_accounts_edges_node_phones_primary | null;
}

export interface RemoveContactForLead_leadRemoveContact_lead_accounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: RemoveContactForLead_leadRemoveContact_lead_accounts_edges_node_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: RemoveContactForLead_leadRemoveContact_lead_accounts_edges_node_phones;
}

export interface RemoveContactForLead_leadRemoveContact_lead_accounts_edges_leadAccountContacts_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface RemoveContactForLead_leadRemoveContact_lead_accounts_edges_leadAccountContacts_phones_primary {
  __typename: "Phone";
  value: RemoveContactForLead_leadRemoveContact_lead_accounts_edges_leadAccountContacts_phones_primary_value;
}

export interface RemoveContactForLead_leadRemoveContact_lead_accounts_edges_leadAccountContacts_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveContactForLead_leadRemoveContact_lead_accounts_edges_leadAccountContacts_phones_primary | null;
}

export interface RemoveContactForLead_leadRemoveContact_lead_accounts_edges_leadAccountContacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: RemoveContactForLead_leadRemoveContact_lead_accounts_edges_leadAccountContacts_phones;
}

export interface RemoveContactForLead_leadRemoveContact_lead_accounts_edges {
  __typename: "LeadAccountsEdge";
  node: RemoveContactForLead_leadRemoveContact_lead_accounts_edges_node;
  /**
   * List of contacts associated with this account that are also on the root lead
   */
  leadAccountContacts: RemoveContactForLead_leadRemoveContact_lead_accounts_edges_leadAccountContacts[] | null;
}

export interface RemoveContactForLead_leadRemoveContact_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: RemoveContactForLead_leadRemoveContact_lead_accounts_primaryEdge | null;
  /**
   * A list of edges.
   */
  edges: RemoveContactForLead_leadRemoveContact_lead_accounts_edges[];
}

export interface RemoveContactForLead_leadRemoveContact_lead_contacts_primaryEdge_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface RemoveContactForLead_leadRemoveContact_lead_contacts_primaryEdge_node_phones_primary {
  __typename: "Phone";
  value: RemoveContactForLead_leadRemoveContact_lead_contacts_primaryEdge_node_phones_primary_value;
}

export interface RemoveContactForLead_leadRemoveContact_lead_contacts_primaryEdge_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveContactForLead_leadRemoveContact_lead_contacts_primaryEdge_node_phones_primary | null;
}

export interface RemoveContactForLead_leadRemoveContact_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: RemoveContactForLead_leadRemoveContact_lead_contacts_primaryEdge_node_phones;
}

export interface RemoveContactForLead_leadRemoveContact_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: RemoveContactForLead_leadRemoveContact_lead_contacts_primaryEdge_node;
}

export interface RemoveContactForLead_leadRemoveContact_lead_contacts_nonCompanyMappedContacts_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface RemoveContactForLead_leadRemoveContact_lead_contacts_nonCompanyMappedContacts_node_phones_primary {
  __typename: "Phone";
  value: RemoveContactForLead_leadRemoveContact_lead_contacts_nonCompanyMappedContacts_node_phones_primary_value;
}

export interface RemoveContactForLead_leadRemoveContact_lead_contacts_nonCompanyMappedContacts_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveContactForLead_leadRemoveContact_lead_contacts_nonCompanyMappedContacts_node_phones_primary | null;
}

export interface RemoveContactForLead_leadRemoveContact_lead_contacts_nonCompanyMappedContacts_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: RemoveContactForLead_leadRemoveContact_lead_contacts_nonCompanyMappedContacts_node_phones;
}

export interface RemoveContactForLead_leadRemoveContact_lead_contacts_nonCompanyMappedContacts {
  __typename: "LeadContactsEdge";
  node: RemoveContactForLead_leadRemoveContact_lead_contacts_nonCompanyMappedContacts_node;
}

export interface RemoveContactForLead_leadRemoveContact_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: RemoveContactForLead_leadRemoveContact_lead_contacts_primaryEdge | null;
  /**
   * List of contacts that are not associated with a company on this lead
   */
  nonCompanyMappedContacts: RemoveContactForLead_leadRemoveContact_lead_contacts_nonCompanyMappedContacts[] | null;
}

export interface RemoveContactForLead_leadRemoveContact_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: RemoveContactForLead_leadRemoveContact_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: RemoveContactForLead_leadRemoveContact_lead_contacts;
}

export interface RemoveContactForLead_leadRemoveContact {
  __typename: "LeadRemoveContactPayload";
  /**
   * The lead with the removed contact.
   */
  lead: RemoveContactForLead_leadRemoveContact_lead;
}

export interface RemoveContactForLead {
  /**
   * Removes a contact from a Lead
   */
  leadRemoveContact: RemoveContactForLead_leadRemoveContact;
}

export interface RemoveContactForLeadVariables {
  input: LeadRemoveContactInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateAccountForLead
// ====================================================

export interface UpdateAccountForLead_accountUpdate_account_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface UpdateAccountForLead_accountUpdate_account_postalAddresses_primary {
  __typename: "PostalAddress";
  location: UpdateAccountForLead_accountUpdate_account_postalAddresses_primary_location;
}

export interface UpdateAccountForLead_accountUpdate_account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: UpdateAccountForLead_accountUpdate_account_postalAddresses_primary | null;
}

export interface UpdateAccountForLead_accountUpdate_account_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface UpdateAccountForLead_accountUpdate_account_phones_primary {
  __typename: "Phone";
  value: UpdateAccountForLead_accountUpdate_account_phones_primary_value;
}

export interface UpdateAccountForLead_accountUpdate_account_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: UpdateAccountForLead_accountUpdate_account_phones_primary | null;
}

export interface UpdateAccountForLead_accountUpdate_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: UpdateAccountForLead_accountUpdate_account_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: UpdateAccountForLead_accountUpdate_account_phones;
}

export interface UpdateAccountForLead_accountUpdate {
  __typename: "AccountUpdatePayload";
  /**
   * The updated Nutshell Account
   */
  account: UpdateAccountForLead_accountUpdate_account;
}

export interface UpdateAccountForLead {
  /**
   * Updates an account
   */
  accountUpdate: UpdateAccountForLead_accountUpdate;
}

export interface UpdateAccountForLeadVariables {
  input: AccountUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateContactForLead
// ====================================================

export interface UpdateContactForLead_contactUpdate_contact_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface UpdateContactForLead_contactUpdate_contact_phones_primary {
  __typename: "Phone";
  value: UpdateContactForLead_contactUpdate_contact_phones_primary_value;
}

export interface UpdateContactForLead_contactUpdate_contact_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: UpdateContactForLead_contactUpdate_contact_phones_primary | null;
}

export interface UpdateContactForLead_contactUpdate_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: UpdateContactForLead_contactUpdate_contact_phones;
}

export interface UpdateContactForLead_contactUpdate {
  __typename: "ContactUpdatePayload";
  /**
   * The updated Nutshell contact.
   */
  contact: UpdateContactForLead_contactUpdate_contact;
}

export interface UpdateContactForLead {
  /**
   * Updates a Nutshell contact.
   */
  contactUpdate: UpdateContactForLead_contactUpdate;
}

export interface UpdateContactForLeadVariables {
  input: ContactUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountsForLead
// ====================================================

export interface GetAccountsForLead_lead_accounts_primaryEdge_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface GetAccountsForLead_lead_accounts_primaryEdge_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: GetAccountsForLead_lead_accounts_primaryEdge_node_postalAddresses_primary_location;
}

export interface GetAccountsForLead_lead_accounts_primaryEdge_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountsForLead_lead_accounts_primaryEdge_node_postalAddresses_primary | null;
}

export interface GetAccountsForLead_lead_accounts_primaryEdge_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetAccountsForLead_lead_accounts_primaryEdge_node_phones_primary {
  __typename: "Phone";
  value: GetAccountsForLead_lead_accounts_primaryEdge_node_phones_primary_value;
}

export interface GetAccountsForLead_lead_accounts_primaryEdge_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountsForLead_lead_accounts_primaryEdge_node_phones_primary | null;
}

export interface GetAccountsForLead_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetAccountsForLead_lead_accounts_primaryEdge_node_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetAccountsForLead_lead_accounts_primaryEdge_node_phones;
}

export interface GetAccountsForLead_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetAccountsForLead_lead_accounts_primaryEdge_node;
}

export interface GetAccountsForLead_lead_accounts_edges_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface GetAccountsForLead_lead_accounts_edges_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: GetAccountsForLead_lead_accounts_edges_node_postalAddresses_primary_location;
}

export interface GetAccountsForLead_lead_accounts_edges_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountsForLead_lead_accounts_edges_node_postalAddresses_primary | null;
}

export interface GetAccountsForLead_lead_accounts_edges_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetAccountsForLead_lead_accounts_edges_node_phones_primary {
  __typename: "Phone";
  value: GetAccountsForLead_lead_accounts_edges_node_phones_primary_value;
}

export interface GetAccountsForLead_lead_accounts_edges_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountsForLead_lead_accounts_edges_node_phones_primary | null;
}

export interface GetAccountsForLead_lead_accounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetAccountsForLead_lead_accounts_edges_node_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetAccountsForLead_lead_accounts_edges_node_phones;
}

export interface GetAccountsForLead_lead_accounts_edges_leadAccountContacts_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetAccountsForLead_lead_accounts_edges_leadAccountContacts_phones_primary {
  __typename: "Phone";
  value: GetAccountsForLead_lead_accounts_edges_leadAccountContacts_phones_primary_value;
}

export interface GetAccountsForLead_lead_accounts_edges_leadAccountContacts_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountsForLead_lead_accounts_edges_leadAccountContacts_phones_primary | null;
}

export interface GetAccountsForLead_lead_accounts_edges_leadAccountContacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetAccountsForLead_lead_accounts_edges_leadAccountContacts_phones;
}

export interface GetAccountsForLead_lead_accounts_edges {
  __typename: "LeadAccountsEdge";
  node: GetAccountsForLead_lead_accounts_edges_node;
  /**
   * List of contacts associated with this account that are also on the root lead
   */
  leadAccountContacts: GetAccountsForLead_lead_accounts_edges_leadAccountContacts[] | null;
}

export interface GetAccountsForLead_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetAccountsForLead_lead_accounts_primaryEdge | null;
  /**
   * A list of edges.
   */
  edges: GetAccountsForLead_lead_accounts_edges[];
}

export interface GetAccountsForLead_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetAccountsForLead_lead_accounts;
}

export interface GetAccountsForLead {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetAccountsForLead_lead | null;
}

export interface GetAccountsForLeadVariables {
  leadId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactsForLead
// ====================================================

export interface GetContactsForLead_lead_contacts_primaryEdge_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetContactsForLead_lead_contacts_primaryEdge_node_phones_primary {
  __typename: "Phone";
  value: GetContactsForLead_lead_contacts_primaryEdge_node_phones_primary_value;
}

export interface GetContactsForLead_lead_contacts_primaryEdge_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetContactsForLead_lead_contacts_primaryEdge_node_phones_primary | null;
}

export interface GetContactsForLead_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetContactsForLead_lead_contacts_primaryEdge_node_phones;
}

export interface GetContactsForLead_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetContactsForLead_lead_contacts_primaryEdge_node;
}

export interface GetContactsForLead_lead_contacts_nonCompanyMappedContacts_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetContactsForLead_lead_contacts_nonCompanyMappedContacts_node_phones_primary {
  __typename: "Phone";
  value: GetContactsForLead_lead_contacts_nonCompanyMappedContacts_node_phones_primary_value;
}

export interface GetContactsForLead_lead_contacts_nonCompanyMappedContacts_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetContactsForLead_lead_contacts_nonCompanyMappedContacts_node_phones_primary | null;
}

export interface GetContactsForLead_lead_contacts_nonCompanyMappedContacts_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetContactsForLead_lead_contacts_nonCompanyMappedContacts_node_phones;
}

export interface GetContactsForLead_lead_contacts_nonCompanyMappedContacts {
  __typename: "LeadContactsEdge";
  node: GetContactsForLead_lead_contacts_nonCompanyMappedContacts_node;
}

export interface GetContactsForLead_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetContactsForLead_lead_contacts_primaryEdge | null;
  /**
   * List of contacts that are not associated with a company on this lead
   */
  nonCompanyMappedContacts: GetContactsForLead_lead_contacts_nonCompanyMappedContacts[] | null;
}

export interface GetContactsForLead_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetContactsForLead_lead_contacts;
}

export interface GetContactsForLead {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetContactsForLead_lead | null;
}

export interface GetContactsForLeadVariables {
  leadId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetIqContactsForAccount
// ====================================================

export interface GetIqContactsForAccount_account_peopleIqContacts_edges_node_contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetIqContactsForAccount_account_peopleIqContacts_edges_node_contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetIqContactsForAccount_account_peopleIqContacts_edges_node_contact_emailAddresses_primary_value;
}

export interface GetIqContactsForAccount_account_peopleIqContacts_edges_node_contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetIqContactsForAccount_account_peopleIqContacts_edges_node_contact_emailAddresses_primary | null;
}

export interface GetIqContactsForAccount_account_peopleIqContacts_edges_node_contact_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetIqContactsForAccount_account_peopleIqContacts_edges_node_contact_phones_primary {
  __typename: "Phone";
  value: GetIqContactsForAccount_account_peopleIqContacts_edges_node_contact_phones_primary_value;
}

export interface GetIqContactsForAccount_account_peopleIqContacts_edges_node_contact_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetIqContactsForAccount_account_peopleIqContacts_edges_node_contact_phones_primary | null;
}

export interface GetIqContactsForAccount_account_peopleIqContacts_edges_node_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetIqContactsForAccount_account_peopleIqContacts_edges_node_contact_emailAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetIqContactsForAccount_account_peopleIqContacts_edges_node_contact_phones;
}

export interface GetIqContactsForAccount_account_peopleIqContacts_edges_node {
  __typename: "McfxViqContact";
  /**
   * The (external) id for this Viq person
   */
  id: string;
  /**
   * The (external) id for this Viq person
   */
  fullName: string;
  /**
   * The job title of this Viq person
   */
  jobTitle: string | null;
  /**
   * The location of this Viq person
   */
  location: string | null;
  /**
   * The position of this Viq person
   */
  position: string | null;
  /**
   * Whether this Viq person has a valid email address
   */
  hasEmail: boolean;
  /**
   * Whether this Viq person has a valid phone number
   */
  hasPhone: boolean;
  /**
   * Whether this Viq person has a LinkedIn Url we know about
   */
  hasLinkedinUrl: boolean;
  /**
   * The Nutshell contact associated with this viq contact
   */
  contact: GetIqContactsForAccount_account_peopleIqContacts_edges_node_contact | null;
}

export interface GetIqContactsForAccount_account_peopleIqContacts_edges {
  __typename: "AccountIqContactsEdge";
  node: GetIqContactsForAccount_account_peopleIqContacts_edges_node;
}

export interface GetIqContactsForAccount_account_peopleIqContacts {
  __typename: "AccountIqContactsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetIqContactsForAccount_account_peopleIqContacts_edges[];
}

export interface GetIqContactsForAccount_account {
  __typename: "Account";
  /**
   * The contacts from PeopleIQ
   */
  peopleIqContacts: GetIqContactsForAccount_account_peopleIqContacts;
}

export interface GetIqContactsForAccount {
  /**
   * Returns a Nutshell Account
   */
  account: GetIqContactsForAccount_account | null;
}

export interface GetIqContactsForAccountVariables {
  accountId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddAttachmentToLead
// ====================================================

export interface AddAttachmentToLead_leadFilesAdd_lead_files_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface AddAttachmentToLead_leadFilesAdd_lead_files {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * The user who uploaded the file
   */
  creatorUser: AddAttachmentToLead_leadFilesAdd_lead_files_creatorUser | null;
}

export interface AddAttachmentToLead_leadFilesAdd_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * List of attachments on this lead
   */
  files: AddAttachmentToLead_leadFilesAdd_lead_files[];
}

export interface AddAttachmentToLead_leadFilesAdd {
  __typename: "LeadFileAddPayload";
  /**
   * The lead that the file was added to
   */
  lead: AddAttachmentToLead_leadFilesAdd_lead;
}

export interface AddAttachmentToLead {
  /**
   * Add a file to a lead
   */
  leadFilesAdd: AddAttachmentToLead_leadFilesAdd;
}

export interface AddAttachmentToLeadVariables {
  input: LeadFileAddInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateContractForLead
// ====================================================

export interface CreateContractForLead_contractCreate_contract_recipientEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
}

export interface CreateContractForLead_contractCreate_contract_recipientEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The primary email address for this account
   */
  primaryEmailAddress: string | null;
}

export type CreateContractForLead_contractCreate_contract_recipientEntity = CreateContractForLead_contractCreate_contract_recipientEntity_Contact | CreateContractForLead_contractCreate_contract_recipientEntity_Account;

export interface CreateContractForLead_contractCreate_contract_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateContractForLead_contractCreate_contract_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface CreateContractForLead_contractCreate_contract_createdFromTemplate {
  __typename: "ContractTemplate";
  id: string;
  name: string;
  htmlUrlPath: string;
  deletedTime: any | null;
}

export interface CreateContractForLead_contractCreate_contract {
  __typename: "Contract";
  id: string;
  name: string;
  shareableViewInBrowserLink: string;
  internalViewInBrowserLink: string;
  displayNumber: string;
  displayStatus: ContractDisplayStatus;
  createdTime: any;
  modifiedTime: any | null;
  readyTime: any | null;
  sentTime: any | null;
  acceptedTime: any | null;
  revokedTime: any | null;
  deletedTime: any | null;
  /**
   * Url path to this specific contract attached to a lead
   */
  leadContractUrl: string | null;
  recipientEntity: CreateContractForLead_contractCreate_contract_recipientEntity | null;
  creatorUser: CreateContractForLead_contractCreate_contract_creatorUser | null;
  lead: CreateContractForLead_contractCreate_contract_lead;
  createdFromTemplate: CreateContractForLead_contractCreate_contract_createdFromTemplate | null;
}

export interface CreateContractForLead_contractCreate {
  __typename: "ContractCreatePayload";
  contract: CreateContractForLead_contractCreate_contract;
}

export interface CreateContractForLead {
  /**
   * Creates a contract from a contract template.
   */
  contractCreate: CreateContractForLead_contractCreate;
}

export interface CreateContractForLeadVariables {
  input: ContractCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveAttachmentFromLead
// ====================================================

export interface RemoveAttachmentFromLead_leadFileRemove_lead_files_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface RemoveAttachmentFromLead_leadFileRemove_lead_files {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * The user who uploaded the file
   */
  creatorUser: RemoveAttachmentFromLead_leadFileRemove_lead_files_creatorUser | null;
}

export interface RemoveAttachmentFromLead_leadFileRemove_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * List of attachments on this lead
   */
  files: RemoveAttachmentFromLead_leadFileRemove_lead_files[];
}

export interface RemoveAttachmentFromLead_leadFileRemove {
  __typename: "LeadFileRemovePayload";
  /**
   * The lead that the file was removed from
   */
  lead: RemoveAttachmentFromLead_leadFileRemove_lead;
}

export interface RemoveAttachmentFromLead {
  /**
   * Remove a file from a lead
   */
  leadFileRemove: RemoveAttachmentFromLead_leadFileRemove;
}

export interface RemoveAttachmentFromLeadVariables {
  input: LeadFileRemoveInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAttachmentsForLead
// ====================================================

export interface GetAttachmentsForLead_lead_files_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface GetAttachmentsForLead_lead_files {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * The user who uploaded the file
   */
  creatorUser: GetAttachmentsForLead_lead_files_creatorUser | null;
}

export interface GetAttachmentsForLead_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * List of attachments on this lead
   */
  files: GetAttachmentsForLead_lead_files[];
}

export interface GetAttachmentsForLead {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetAttachmentsForLead_lead | null;
}

export interface GetAttachmentsForLeadVariables {
  leadId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPotentialContractRecipients
// ====================================================

export interface GetPotentialContractRecipients_lead_accounts_primaryEdge_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetPotentialContractRecipients_lead_accounts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  id: string;
  value: GetPotentialContractRecipients_lead_accounts_primaryEdge_node_emailAddresses_primary_value;
}

export interface GetPotentialContractRecipients_lead_accounts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPotentialContractRecipients_lead_accounts_primaryEdge_node_emailAddresses_primary | null;
}

export interface GetPotentialContractRecipients_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetPotentialContractRecipients_lead_accounts_primaryEdge_node_emailAddresses;
}

export interface GetPotentialContractRecipients_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetPotentialContractRecipients_lead_accounts_primaryEdge_node;
}

export interface GetPotentialContractRecipients_lead_accounts_edges_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetPotentialContractRecipients_lead_accounts_edges_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  id: string;
  value: GetPotentialContractRecipients_lead_accounts_edges_node_emailAddresses_primary_value;
}

export interface GetPotentialContractRecipients_lead_accounts_edges_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPotentialContractRecipients_lead_accounts_edges_node_emailAddresses_primary | null;
}

export interface GetPotentialContractRecipients_lead_accounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetPotentialContractRecipients_lead_accounts_edges_node_emailAddresses;
}

export interface GetPotentialContractRecipients_lead_accounts_edges {
  __typename: "LeadAccountsEdge";
  node: GetPotentialContractRecipients_lead_accounts_edges_node;
}

export interface GetPotentialContractRecipients_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPotentialContractRecipients_lead_accounts_primaryEdge | null;
  /**
   * A list of edges.
   */
  edges: GetPotentialContractRecipients_lead_accounts_edges[];
}

export interface GetPotentialContractRecipients_lead_contacts_primaryEdge_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetPotentialContractRecipients_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  id: string;
  value: GetPotentialContractRecipients_lead_contacts_primaryEdge_node_emailAddresses_primary_value;
}

export interface GetPotentialContractRecipients_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPotentialContractRecipients_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface GetPotentialContractRecipients_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetPotentialContractRecipients_lead_contacts_primaryEdge_node_emailAddresses;
}

export interface GetPotentialContractRecipients_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetPotentialContractRecipients_lead_contacts_primaryEdge_node;
}

export interface GetPotentialContractRecipients_lead_contacts_edges_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetPotentialContractRecipients_lead_contacts_edges_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  id: string;
  value: GetPotentialContractRecipients_lead_contacts_edges_node_emailAddresses_primary_value;
}

export interface GetPotentialContractRecipients_lead_contacts_edges_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPotentialContractRecipients_lead_contacts_edges_node_emailAddresses_primary | null;
}

export interface GetPotentialContractRecipients_lead_contacts_edges_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetPotentialContractRecipients_lead_contacts_edges_node_emailAddresses;
}

export interface GetPotentialContractRecipients_lead_contacts_edges {
  __typename: "LeadContactsEdge";
  node: GetPotentialContractRecipients_lead_contacts_edges_node;
}

export interface GetPotentialContractRecipients_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPotentialContractRecipients_lead_contacts_primaryEdge | null;
  /**
   * A list of edges.
   */
  edges: GetPotentialContractRecipients_lead_contacts_edges[];
}

export interface GetPotentialContractRecipients_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetPotentialContractRecipients_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetPotentialContractRecipients_lead_contacts;
}

export interface GetPotentialContractRecipients {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetPotentialContractRecipients_lead | null;
}

export interface GetPotentialContractRecipientsVariables {
  leadId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddCompetitorToLead
// ====================================================

export interface AddCompetitorToLead_leadCompetitorAdd_lead_competitors_edges_node {
  __typename: "Competitor";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the competitor
   */
  name: string | null;
  /**
   * The percentage of leads that have been won against this competitor
   */
  leadSuccessPercent: number | null;
  /**
   * The URL of the report for this competitor
   */
  reportUrl: string;
}

export interface AddCompetitorToLead_leadCompetitorAdd_lead_competitors_edges {
  __typename: "LeadCompetitorsEdge";
  node: AddCompetitorToLead_leadCompetitorAdd_lead_competitors_edges_node;
  /**
   * The one-off short note that users can write on this lead->competitor relationship.
   */
  relationshipNote: string | null;
}

export interface AddCompetitorToLead_leadCompetitorAdd_lead_competitors {
  __typename: "LeadCompetitorsConnection";
  /**
   * A list of edges.
   */
  edges: AddCompetitorToLead_leadCompetitorAdd_lead_competitors_edges[];
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface AddCompetitorToLead_leadCompetitorAdd_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Competitors for the lead
   */
  competitors: AddCompetitorToLead_leadCompetitorAdd_lead_competitors | null;
}

export interface AddCompetitorToLead_leadCompetitorAdd {
  __typename: "LeadCompetitorAddPayload";
  /**
   * The lead with the newly added competitor.
   */
  lead: AddCompetitorToLead_leadCompetitorAdd_lead;
}

export interface AddCompetitorToLead {
  /**
   * Adds a competitor to a Lead
   */
  leadCompetitorAdd: AddCompetitorToLead_leadCompetitorAdd;
}

export interface AddCompetitorToLeadVariables {
  input: LeadCompetitorAddInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: LeadUpdateCompetitor
// ====================================================

export interface LeadUpdateCompetitor_leadCompetitorUpdate_lead_competitors_edges_node {
  __typename: "Competitor";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the competitor
   */
  name: string | null;
  /**
   * The percentage of leads that have been won against this competitor
   */
  leadSuccessPercent: number | null;
  /**
   * The URL of the report for this competitor
   */
  reportUrl: string;
}

export interface LeadUpdateCompetitor_leadCompetitorUpdate_lead_competitors_edges {
  __typename: "LeadCompetitorsEdge";
  node: LeadUpdateCompetitor_leadCompetitorUpdate_lead_competitors_edges_node;
  /**
   * The one-off short note that users can write on this lead->competitor relationship.
   */
  relationshipNote: string | null;
}

export interface LeadUpdateCompetitor_leadCompetitorUpdate_lead_competitors {
  __typename: "LeadCompetitorsConnection";
  /**
   * A list of edges.
   */
  edges: LeadUpdateCompetitor_leadCompetitorUpdate_lead_competitors_edges[];
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface LeadUpdateCompetitor_leadCompetitorUpdate_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Competitors for the lead
   */
  competitors: LeadUpdateCompetitor_leadCompetitorUpdate_lead_competitors | null;
}

export interface LeadUpdateCompetitor_leadCompetitorUpdate {
  __typename: "LeadCompetitorUpdatePayload";
  /**
   * The lead with the updated competitor.
   */
  lead: LeadUpdateCompetitor_leadCompetitorUpdate_lead;
}

export interface LeadUpdateCompetitor {
  /**
   * Updates a competitor on a Lead
   */
  leadCompetitorUpdate: LeadUpdateCompetitor_leadCompetitorUpdate;
}

export interface LeadUpdateCompetitorVariables {
  input: LeadCompetitorUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveCompetitorFromLead
// ====================================================

export interface RemoveCompetitorFromLead_leadCompetitorRemove_lead_competitors_edges_node {
  __typename: "Competitor";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the competitor
   */
  name: string | null;
  /**
   * The percentage of leads that have been won against this competitor
   */
  leadSuccessPercent: number | null;
  /**
   * The URL of the report for this competitor
   */
  reportUrl: string;
}

export interface RemoveCompetitorFromLead_leadCompetitorRemove_lead_competitors_edges {
  __typename: "LeadCompetitorsEdge";
  node: RemoveCompetitorFromLead_leadCompetitorRemove_lead_competitors_edges_node;
  /**
   * The one-off short note that users can write on this lead->competitor relationship.
   */
  relationshipNote: string | null;
}

export interface RemoveCompetitorFromLead_leadCompetitorRemove_lead_competitors {
  __typename: "LeadCompetitorsConnection";
  /**
   * A list of edges.
   */
  edges: RemoveCompetitorFromLead_leadCompetitorRemove_lead_competitors_edges[];
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface RemoveCompetitorFromLead_leadCompetitorRemove_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Competitors for the lead
   */
  competitors: RemoveCompetitorFromLead_leadCompetitorRemove_lead_competitors | null;
}

export interface RemoveCompetitorFromLead_leadCompetitorRemove {
  __typename: "LeadCompetitorRemovePayload";
  /**
   * The lead with the removed competitor.
   */
  lead: RemoveCompetitorFromLead_leadCompetitorRemove_lead;
}

export interface RemoveCompetitorFromLead {
  /**
   * Removes a competitor from a Lead
   */
  leadCompetitorRemove: RemoveCompetitorFromLead_leadCompetitorRemove;
}

export interface RemoveCompetitorFromLeadVariables {
  input: LeadCompetitorRemoveInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCompetitorsForLead
// ====================================================

export interface GetCompetitorsForLead_lead_competitors_edges_node {
  __typename: "Competitor";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the competitor
   */
  name: string | null;
  /**
   * The percentage of leads that have been won against this competitor
   */
  leadSuccessPercent: number | null;
  /**
   * The URL of the report for this competitor
   */
  reportUrl: string;
}

export interface GetCompetitorsForLead_lead_competitors_edges {
  __typename: "LeadCompetitorsEdge";
  node: GetCompetitorsForLead_lead_competitors_edges_node;
  /**
   * The one-off short note that users can write on this lead->competitor relationship.
   */
  relationshipNote: string | null;
}

export interface GetCompetitorsForLead_lead_competitors {
  __typename: "LeadCompetitorsConnection";
  /**
   * A list of edges.
   */
  edges: GetCompetitorsForLead_lead_competitors_edges[];
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetCompetitorsForLead_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Competitors for the lead
   */
  competitors: GetCompetitorsForLead_lead_competitors | null;
}

export interface GetCompetitorsForLead {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetCompetitorsForLead_lead | null;
}

export interface GetCompetitorsForLeadVariables {
  leadId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getEnvelopesForLead
// ====================================================

export interface getEnvelopesForLead_envelopesForLead_documents_edges_node_quote_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface getEnvelopesForLead_envelopesForLead_documents_edges_node_quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of a quote that should be displayed to the user
   */
  displayStatus: QuoteDisplayStatus;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: getEnvelopesForLead_envelopesForLead_documents_edges_node_quote_total;
  /**
   * The slug of the quote
   */
  slug: string;
  /**
   * The sharable view in browser link
   */
  shareableViewInBrowserLink: string;
  /**
   * The internal view in browser link, for viewing as the customer without recording a view
   */
  internalViewInBrowserLink: string;
  /**
   * The time the quote was sent
   */
  sentTime: any | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was published
   */
  publishedTime: any | null;
  /**
   * The time the quote was accepted
   */
  acceptedTime: any | null;
}

export interface getEnvelopesForLead_envelopesForLead_documents_edges_node_invoice_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface getEnvelopesForLead_envelopesForLead_documents_edges_node_invoice_canSendToQuickbooks_TrueWithReason {
  __typename: "TrueWithReason";
}

export interface getEnvelopesForLead_envelopesForLead_documents_edges_node_invoice_canSendToQuickbooks_FalseWithReason {
  __typename: "FalseWithReason";
  /**
   * The reason why the value is false
   */
  reason: string;
}

export type getEnvelopesForLead_envelopesForLead_documents_edges_node_invoice_canSendToQuickbooks = getEnvelopesForLead_envelopesForLead_documents_edges_node_invoice_canSendToQuickbooks_TrueWithReason | getEnvelopesForLead_envelopesForLead_documents_edges_node_invoice_canSendToQuickbooks_FalseWithReason;

export interface getEnvelopesForLead_envelopesForLead_documents_edges_node_invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of a quote that should be displayed to the user
   */
  displayStatus: QuoteDisplayStatus;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: getEnvelopesForLead_envelopesForLead_documents_edges_node_invoice_total;
  /**
   * The slug of the quote
   */
  slug: string;
  /**
   * The sharable view in browser link
   */
  shareableViewInBrowserLink: string;
  /**
   * The internal view in browser link, for viewing as the customer without recording a view
   */
  internalViewInBrowserLink: string;
  /**
   * The time the quote was sent
   */
  sentTime: any | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was published
   */
  publishedTime: any | null;
  /**
   * The time the quote was accepted
   */
  acceptedTime: any | null;
  /**
   * A human readable string representing how long over due the invoice is
   */
  overdueDuration: string | null;
  /**
   * URL to view this invoice in QuickBooks, or null if it has not been sent to QuickBooks
   */
  quickbooksInvoiceUrl: string | null;
  /**
   * Whether the invoice can be sent to Quickbooks in its current state
   */
  canSendToQuickbooks: getEnvelopesForLead_envelopesForLead_documents_edges_node_invoice_canSendToQuickbooks;
}

export interface getEnvelopesForLead_envelopesForLead_documents_edges_node_contract_recipientEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
}

export interface getEnvelopesForLead_envelopesForLead_documents_edges_node_contract_recipientEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The primary email address for this account
   */
  primaryEmailAddress: string | null;
}

export type getEnvelopesForLead_envelopesForLead_documents_edges_node_contract_recipientEntity = getEnvelopesForLead_envelopesForLead_documents_edges_node_contract_recipientEntity_Contact | getEnvelopesForLead_envelopesForLead_documents_edges_node_contract_recipientEntity_Account;

export interface getEnvelopesForLead_envelopesForLead_documents_edges_node_contract_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface getEnvelopesForLead_envelopesForLead_documents_edges_node_contract_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface getEnvelopesForLead_envelopesForLead_documents_edges_node_contract_createdFromTemplate {
  __typename: "ContractTemplate";
  id: string;
  name: string;
  htmlUrlPath: string;
  deletedTime: any | null;
}

export interface getEnvelopesForLead_envelopesForLead_documents_edges_node_contract {
  __typename: "Contract";
  id: string;
  name: string;
  shareableViewInBrowserLink: string;
  internalViewInBrowserLink: string;
  displayNumber: string;
  displayStatus: ContractDisplayStatus;
  createdTime: any;
  modifiedTime: any | null;
  readyTime: any | null;
  sentTime: any | null;
  acceptedTime: any | null;
  revokedTime: any | null;
  deletedTime: any | null;
  /**
   * Url path to this specific contract attached to a lead
   */
  leadContractUrl: string | null;
  recipientEntity: getEnvelopesForLead_envelopesForLead_documents_edges_node_contract_recipientEntity | null;
  creatorUser: getEnvelopesForLead_envelopesForLead_documents_edges_node_contract_creatorUser | null;
  lead: getEnvelopesForLead_envelopesForLead_documents_edges_node_contract_lead;
  createdFromTemplate: getEnvelopesForLead_envelopesForLead_documents_edges_node_contract_createdFromTemplate | null;
}

export interface getEnvelopesForLead_envelopesForLead_documents_edges_node {
  __typename: "EnvelopeDocument";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  documentType: EnvelopeDocumentType;
  quote: getEnvelopesForLead_envelopesForLead_documents_edges_node_quote | null;
  invoice: getEnvelopesForLead_envelopesForLead_documents_edges_node_invoice | null;
  contract: getEnvelopesForLead_envelopesForLead_documents_edges_node_contract | null;
}

export interface getEnvelopesForLead_envelopesForLead_documents_edges {
  __typename: "EnvelopeDocumentsEdge";
  node: getEnvelopesForLead_envelopesForLead_documents_edges_node;
}

export interface getEnvelopesForLead_envelopesForLead_documents {
  __typename: "EnvelopeDocumentsConnection";
  /**
   * A list of edges.
   */
  edges: getEnvelopesForLead_envelopesForLead_documents_edges[];
}

export interface getEnvelopesForLead_envelopesForLead {
  __typename: "Envelope";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  primaryDocumentType: EnvelopeDocumentType;
  documents: getEnvelopesForLead_envelopesForLead_documents;
}

export interface getEnvelopesForLead {
  envelopesForLead: getEnvelopesForLead_envelopesForLead[];
}

export interface getEnvelopesForLeadVariables {
  leadId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: LeadResearchPromptUpdateMutation
// ====================================================

export interface LeadResearchPromptUpdateMutation_leadResearchPromptUpdate {
  __typename: "LeadResearchPromptUpdatePayload";
  selectedFields: string[];
  businessContext: string | null;
  idealCustomer: string | null;
}

export interface LeadResearchPromptUpdateMutation {
  /**
   * Update the global lead research settings.
   */
  leadResearchPromptUpdate: LeadResearchPromptUpdateMutation_leadResearchPromptUpdate;
}

export interface LeadResearchPromptUpdateMutationVariables {
  input: LeadResearchPromptUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: LeadResearchMutation
// ====================================================

export interface LeadResearchMutation_leadResearch_lead_research_summary_leadFitReasons {
  __typename: "LeadFitReason";
  /**
   * Concise headline explaining this factor (always visible)
   */
  text: string;
  sentiment: LeadResearchSentiment;
  /**
   * Supporting detail shown when expanded
   */
  body: string;
}

export interface LeadResearchMutation_leadResearch_lead_research_summary_fields {
  __typename: "LeadResearchField";
  key: string;
  label: string;
  value: string;
}

export interface LeadResearchMutation_leadResearch_lead_research_summary_companyOverview {
  __typename: "CompanyOverview";
  /**
   * One punchy sentence about the company (max 48 chars)
   */
  headline: string;
  /**
   * 1-2 sentences of key factual details
   */
  body: string;
}

export interface LeadResearchMutation_leadResearch_lead_research_summary {
  __typename: "EntitySummaryLeadResearch";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
  leadFit: LeadFitScore;
  leadFitLabel: string;
  leadFitReasons: LeadResearchMutation_leadResearch_lead_research_summary_leadFitReasons[];
  fields: LeadResearchMutation_leadResearch_lead_research_summary_fields[];
  companyOverview: LeadResearchMutation_leadResearch_lead_research_summary_companyOverview | null;
  isDemoOverride: boolean;
  canRefresh: boolean;
}

export interface LeadResearchMutation_leadResearch_lead_research {
  __typename: "LeadResearchResult";
  isDemoResearchEnabled: boolean;
  /**
   * The AI-generated research summary, if available
   */
  summary: LeadResearchMutation_leadResearch_lead_research_summary | null;
}

export interface LeadResearchMutation_leadResearch_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * AI-generated research and insights about this lead
   */
  research: LeadResearchMutation_leadResearch_lead_research;
}

export interface LeadResearchMutation_leadResearch {
  __typename: "LeadResearchPayload";
  /**
   * The lead that was researched, with the research field populated.
   */
  lead: LeadResearchMutation_leadResearch_lead;
}

export interface LeadResearchMutation {
  /**
   * Research a lead using AI to gather sales intelligence.
   */
  leadResearch: LeadResearchMutation_leadResearch;
}

export interface LeadResearchMutationVariables {
  input: LeadResearchInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: LeadResearchPromptQuery
// ====================================================

export interface LeadResearchPromptQuery_leadResearchPrompt_availableFields {
  __typename: "LeadResearchAvailableField";
  key: string;
  label: string;
}

export interface LeadResearchPromptQuery_leadResearchPrompt {
  __typename: "LeadResearchPrompt";
  /**
   * The selected research fields (e.g., revenue, team_size, industry).
   */
  selectedFields: string[];
  /**
   * Description of the business.
   */
  businessContext: string | null;
  /**
   * Description of the ideal customer.
   */
  idealCustomer: string | null;
  /**
   * All available fields that can be selected.
   */
  availableFields: LeadResearchPromptQuery_leadResearchPrompt_availableFields[];
}

export interface LeadResearchPromptQuery {
  /**
   * Returns the global lead research prompt settings.
   */
  leadResearchPrompt: LeadResearchPromptQuery_leadResearchPrompt | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddProductForLead
// ====================================================

export interface AddProductForLead_leadProductAdd_lead_products_edges_price {
  __typename: "Money";
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface AddProductForLead_leadProductAdd_lead_products_edges_originalPrice {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface AddProductForLead_leadProductAdd_lead_products_edges_node_category {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
}

export interface AddProductForLead_leadProductAdd_lead_products_edges_node_markets_edges_price {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface AddProductForLead_leadProductAdd_lead_products_edges_node_markets_edges {
  __typename: "ProductMarketsEdge";
  /**
   * The price and currency of the product in the market.
   */
  price: AddProductForLead_leadProductAdd_lead_products_edges_node_markets_edges_price | null;
  /**
   * Whether the product is available in the market.
   */
  isAvailable: boolean | null;
}

export interface AddProductForLead_leadProductAdd_lead_products_edges_node_markets {
  __typename: "ProductMarketsConnection";
  /**
   * A list of edges.
   */
  edges: AddProductForLead_leadProductAdd_lead_products_edges_node_markets_edges[];
}

export interface AddProductForLead_leadProductAdd_lead_products_edges_node {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The description of the product
   */
  description: string | null;
  /**
   * The type of the product (Good or Service)
   */
  type: ProductType;
  /**
   * The URL of the report for this product
   */
  reportUrl: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The category of the product
   */
  category: AddProductForLead_leadProductAdd_lead_products_edges_node_category | null;
  /**
   * The markets of the product
   */
  markets: AddProductForLead_leadProductAdd_lead_products_edges_node_markets;
  /**
   * The DateTime the product was created
   */
  createdTime: any;
}

export interface AddProductForLead_leadProductAdd_lead_products_edges {
  __typename: "LeadProductsEdge";
  /**
   * The API ID of the Lead_ProductMap
   */
  id: string;
  /**
   * The one-off short note that users can write on this lead->product relationship.
   */
  relationshipNote: string | null;
  /**
   * The quantity number of the given product that is attached to the lead
   */
  quantity: number;
  /**
   * The monetary value for each unit of the product attached to the lead
   */
  price: AddProductForLead_leadProductAdd_lead_products_edges_price;
  /**
   * The original price of the product
   */
  originalPrice: AddProductForLead_leadProductAdd_lead_products_edges_originalPrice | null;
  /**
   * The total value of this attached product on the lead, taking its unit price and multiplying it by the given quantity.
   */
  total: number;
  /**
   * The product
   */
  node: AddProductForLead_leadProductAdd_lead_products_edges_node;
}

export interface AddProductForLead_leadProductAdd_lead_products_totalValue {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface AddProductForLead_leadProductAdd_lead_products {
  __typename: "LeadProductsConnection";
  /**
   * A list of edges.
   */
  edges: AddProductForLead_leadProductAdd_lead_products_edges[];
  /**
   * The total value of the products mapped to the lead
   */
  totalValue: AddProductForLead_leadProductAdd_lead_products_totalValue | null;
}

export interface AddProductForLead_leadProductAdd_lead_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
}

export interface AddProductForLead_leadProductAdd_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Products for the lead
   */
  products: AddProductForLead_leadProductAdd_lead_products | null;
  /**
   * The mode of the leads value
   */
  valueMode: LeadValueMode;
  value: AddProductForLead_leadProductAdd_lead_value | null;
}

export interface AddProductForLead_leadProductAdd_product_price {
  __typename: "Money";
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface AddProductForLead_leadProductAdd_product_originalPrice {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface AddProductForLead_leadProductAdd_product_node_category {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
}

export interface AddProductForLead_leadProductAdd_product_node_markets_edges_price {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface AddProductForLead_leadProductAdd_product_node_markets_edges {
  __typename: "ProductMarketsEdge";
  /**
   * The price and currency of the product in the market.
   */
  price: AddProductForLead_leadProductAdd_product_node_markets_edges_price | null;
  /**
   * Whether the product is available in the market.
   */
  isAvailable: boolean | null;
}

export interface AddProductForLead_leadProductAdd_product_node_markets {
  __typename: "ProductMarketsConnection";
  /**
   * A list of edges.
   */
  edges: AddProductForLead_leadProductAdd_product_node_markets_edges[];
}

export interface AddProductForLead_leadProductAdd_product_node {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The description of the product
   */
  description: string | null;
  /**
   * The type of the product (Good or Service)
   */
  type: ProductType;
  /**
   * The URL of the report for this product
   */
  reportUrl: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The category of the product
   */
  category: AddProductForLead_leadProductAdd_product_node_category | null;
  /**
   * The markets of the product
   */
  markets: AddProductForLead_leadProductAdd_product_node_markets;
  /**
   * The DateTime the product was created
   */
  createdTime: any;
}

export interface AddProductForLead_leadProductAdd_product {
  __typename: "LeadProductsEdge";
  /**
   * The API ID of the Lead_ProductMap
   */
  id: string;
  /**
   * The one-off short note that users can write on this lead->product relationship.
   */
  relationshipNote: string | null;
  /**
   * The quantity number of the given product that is attached to the lead
   */
  quantity: number;
  /**
   * The monetary value for each unit of the product attached to the lead
   */
  price: AddProductForLead_leadProductAdd_product_price;
  /**
   * The original price of the product
   */
  originalPrice: AddProductForLead_leadProductAdd_product_originalPrice | null;
  /**
   * The total value of this attached product on the lead, taking its unit price and multiplying it by the given quantity.
   */
  total: number;
  /**
   * The product
   */
  node: AddProductForLead_leadProductAdd_product_node;
}

export interface AddProductForLead_leadProductAdd {
  __typename: "LeadProductAddPayload";
  /**
   * The lead that the product was added to
   */
  lead: AddProductForLead_leadProductAdd_lead;
  /**
   * The product that was added to the lead
   */
  product: AddProductForLead_leadProductAdd_product;
}

export interface AddProductForLead {
  /**
   * Add a product to a lead
   */
  leadProductAdd: AddProductForLead_leadProductAdd;
}

export interface AddProductForLeadVariables {
  input: LeadProductAddInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveProductForLead
// ====================================================

export interface RemoveProductForLead_leadProductRemove_lead_products_edges_price {
  __typename: "Money";
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface RemoveProductForLead_leadProductRemove_lead_products_edges_originalPrice {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface RemoveProductForLead_leadProductRemove_lead_products_edges_node_category {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
}

export interface RemoveProductForLead_leadProductRemove_lead_products_edges_node_markets_edges_price {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface RemoveProductForLead_leadProductRemove_lead_products_edges_node_markets_edges {
  __typename: "ProductMarketsEdge";
  /**
   * The price and currency of the product in the market.
   */
  price: RemoveProductForLead_leadProductRemove_lead_products_edges_node_markets_edges_price | null;
  /**
   * Whether the product is available in the market.
   */
  isAvailable: boolean | null;
}

export interface RemoveProductForLead_leadProductRemove_lead_products_edges_node_markets {
  __typename: "ProductMarketsConnection";
  /**
   * A list of edges.
   */
  edges: RemoveProductForLead_leadProductRemove_lead_products_edges_node_markets_edges[];
}

export interface RemoveProductForLead_leadProductRemove_lead_products_edges_node {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The description of the product
   */
  description: string | null;
  /**
   * The type of the product (Good or Service)
   */
  type: ProductType;
  /**
   * The URL of the report for this product
   */
  reportUrl: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The category of the product
   */
  category: RemoveProductForLead_leadProductRemove_lead_products_edges_node_category | null;
  /**
   * The markets of the product
   */
  markets: RemoveProductForLead_leadProductRemove_lead_products_edges_node_markets;
  /**
   * The DateTime the product was created
   */
  createdTime: any;
}

export interface RemoveProductForLead_leadProductRemove_lead_products_edges {
  __typename: "LeadProductsEdge";
  /**
   * The API ID of the Lead_ProductMap
   */
  id: string;
  /**
   * The one-off short note that users can write on this lead->product relationship.
   */
  relationshipNote: string | null;
  /**
   * The quantity number of the given product that is attached to the lead
   */
  quantity: number;
  /**
   * The monetary value for each unit of the product attached to the lead
   */
  price: RemoveProductForLead_leadProductRemove_lead_products_edges_price;
  /**
   * The original price of the product
   */
  originalPrice: RemoveProductForLead_leadProductRemove_lead_products_edges_originalPrice | null;
  /**
   * The total value of this attached product on the lead, taking its unit price and multiplying it by the given quantity.
   */
  total: number;
  /**
   * The product
   */
  node: RemoveProductForLead_leadProductRemove_lead_products_edges_node;
}

export interface RemoveProductForLead_leadProductRemove_lead_products_totalValue {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface RemoveProductForLead_leadProductRemove_lead_products {
  __typename: "LeadProductsConnection";
  /**
   * A list of edges.
   */
  edges: RemoveProductForLead_leadProductRemove_lead_products_edges[];
  /**
   * The total value of the products mapped to the lead
   */
  totalValue: RemoveProductForLead_leadProductRemove_lead_products_totalValue | null;
}

export interface RemoveProductForLead_leadProductRemove_lead_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
}

export interface RemoveProductForLead_leadProductRemove_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Products for the lead
   */
  products: RemoveProductForLead_leadProductRemove_lead_products | null;
  /**
   * The mode of the leads value
   */
  valueMode: LeadValueMode;
  value: RemoveProductForLead_leadProductRemove_lead_value | null;
}

export interface RemoveProductForLead_leadProductRemove {
  __typename: "LeadProductRemovePayload";
  /**
   * The lead that the product was removed from
   */
  lead: RemoveProductForLead_leadProductRemove_lead;
}

export interface RemoveProductForLead {
  /**
   * Remove a product from a lead
   */
  leadProductRemove: RemoveProductForLead_leadProductRemove;
}

export interface RemoveProductForLeadVariables {
  input: LeadProductRemoveInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateLeadValue
// ====================================================

export interface UpdateLeadValue_leadValueUpdate_lead_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
}

export interface UpdateLeadValue_leadValueUpdate_lead_products_totalValue {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface UpdateLeadValue_leadValueUpdate_lead_products {
  __typename: "LeadProductsConnection";
  /**
   * The total value of the products mapped to the lead
   */
  totalValue: UpdateLeadValue_leadValueUpdate_lead_products_totalValue | null;
}

export interface UpdateLeadValue_leadValueUpdate_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The mode of the leads value
   */
  valueMode: LeadValueMode;
  value: UpdateLeadValue_leadValueUpdate_lead_value | null;
  /**
   * Products for the lead
   */
  products: UpdateLeadValue_leadValueUpdate_lead_products | null;
}

export interface UpdateLeadValue_leadValueUpdate {
  __typename: "LeadValueUpdatePayload";
  /**
   * The lead with the updated value.
   */
  lead: UpdateLeadValue_leadValueUpdate_lead;
}

export interface UpdateLeadValue {
  /**
   * Update the value of a lead between modes and values
   */
  leadValueUpdate: UpdateLeadValue_leadValueUpdate;
}

export interface UpdateLeadValueVariables {
  input: LeadValueUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateMarketForLead
// ====================================================

export interface UpdateMarketForLead_leadMarketUpdate_lead_market {
  __typename: "Market";
  id: string;
  name: string;
  currency: string;
  currencySymbol: string;
  isDefault: boolean;
}

export interface UpdateMarketForLead_leadMarketUpdate_lead_products_edges_price {
  __typename: "Money";
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateMarketForLead_leadMarketUpdate_lead_products_edges_originalPrice {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface UpdateMarketForLead_leadMarketUpdate_lead_products_edges_node_category {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
}

export interface UpdateMarketForLead_leadMarketUpdate_lead_products_edges_node_markets_edges_price {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateMarketForLead_leadMarketUpdate_lead_products_edges_node_markets_edges {
  __typename: "ProductMarketsEdge";
  /**
   * The price and currency of the product in the market.
   */
  price: UpdateMarketForLead_leadMarketUpdate_lead_products_edges_node_markets_edges_price | null;
  /**
   * Whether the product is available in the market.
   */
  isAvailable: boolean | null;
}

export interface UpdateMarketForLead_leadMarketUpdate_lead_products_edges_node_markets {
  __typename: "ProductMarketsConnection";
  /**
   * A list of edges.
   */
  edges: UpdateMarketForLead_leadMarketUpdate_lead_products_edges_node_markets_edges[];
}

export interface UpdateMarketForLead_leadMarketUpdate_lead_products_edges_node {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The description of the product
   */
  description: string | null;
  /**
   * The type of the product (Good or Service)
   */
  type: ProductType;
  /**
   * The URL of the report for this product
   */
  reportUrl: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The category of the product
   */
  category: UpdateMarketForLead_leadMarketUpdate_lead_products_edges_node_category | null;
  /**
   * The markets of the product
   */
  markets: UpdateMarketForLead_leadMarketUpdate_lead_products_edges_node_markets;
  /**
   * The DateTime the product was created
   */
  createdTime: any;
}

export interface UpdateMarketForLead_leadMarketUpdate_lead_products_edges {
  __typename: "LeadProductsEdge";
  /**
   * The API ID of the Lead_ProductMap
   */
  id: string;
  /**
   * The one-off short note that users can write on this lead->product relationship.
   */
  relationshipNote: string | null;
  /**
   * The quantity number of the given product that is attached to the lead
   */
  quantity: number;
  /**
   * The monetary value for each unit of the product attached to the lead
   */
  price: UpdateMarketForLead_leadMarketUpdate_lead_products_edges_price;
  /**
   * The original price of the product
   */
  originalPrice: UpdateMarketForLead_leadMarketUpdate_lead_products_edges_originalPrice | null;
  /**
   * The total value of this attached product on the lead, taking its unit price and multiplying it by the given quantity.
   */
  total: number;
  /**
   * The product
   */
  node: UpdateMarketForLead_leadMarketUpdate_lead_products_edges_node;
}

export interface UpdateMarketForLead_leadMarketUpdate_lead_products_totalValue {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface UpdateMarketForLead_leadMarketUpdate_lead_products {
  __typename: "LeadProductsConnection";
  /**
   * A list of edges.
   */
  edges: UpdateMarketForLead_leadMarketUpdate_lead_products_edges[];
  /**
   * The total value of the products mapped to the lead
   */
  totalValue: UpdateMarketForLead_leadMarketUpdate_lead_products_totalValue | null;
}

export interface UpdateMarketForLead_leadMarketUpdate_lead_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
}

export interface UpdateMarketForLead_leadMarketUpdate_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The market for the products attached to the lead
   */
  market: UpdateMarketForLead_leadMarketUpdate_lead_market | null;
  /**
   * Products for the lead
   */
  products: UpdateMarketForLead_leadMarketUpdate_lead_products | null;
  /**
   * The mode of the leads value
   */
  valueMode: LeadValueMode;
  value: UpdateMarketForLead_leadMarketUpdate_lead_value | null;
}

export interface UpdateMarketForLead_leadMarketUpdate {
  __typename: "LeadMarketUpdatePayload";
  /**
   * The updated lead.
   */
  lead: UpdateMarketForLead_leadMarketUpdate_lead;
}

export interface UpdateMarketForLead {
  /**
   * Updates the market for a lead.
   */
  leadMarketUpdate: UpdateMarketForLead_leadMarketUpdate;
}

export interface UpdateMarketForLeadVariables {
  input: LeadMarketUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateProductForLead
// ====================================================

export interface UpdateProductForLead_leadProductUpdate_lead_products_edges_price {
  __typename: "Money";
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateProductForLead_leadProductUpdate_lead_products_edges_originalPrice {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface UpdateProductForLead_leadProductUpdate_lead_products_edges_node_category {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
}

export interface UpdateProductForLead_leadProductUpdate_lead_products_edges_node_markets_edges_price {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateProductForLead_leadProductUpdate_lead_products_edges_node_markets_edges {
  __typename: "ProductMarketsEdge";
  /**
   * The price and currency of the product in the market.
   */
  price: UpdateProductForLead_leadProductUpdate_lead_products_edges_node_markets_edges_price | null;
  /**
   * Whether the product is available in the market.
   */
  isAvailable: boolean | null;
}

export interface UpdateProductForLead_leadProductUpdate_lead_products_edges_node_markets {
  __typename: "ProductMarketsConnection";
  /**
   * A list of edges.
   */
  edges: UpdateProductForLead_leadProductUpdate_lead_products_edges_node_markets_edges[];
}

export interface UpdateProductForLead_leadProductUpdate_lead_products_edges_node {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The description of the product
   */
  description: string | null;
  /**
   * The type of the product (Good or Service)
   */
  type: ProductType;
  /**
   * The URL of the report for this product
   */
  reportUrl: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The category of the product
   */
  category: UpdateProductForLead_leadProductUpdate_lead_products_edges_node_category | null;
  /**
   * The markets of the product
   */
  markets: UpdateProductForLead_leadProductUpdate_lead_products_edges_node_markets;
  /**
   * The DateTime the product was created
   */
  createdTime: any;
}

export interface UpdateProductForLead_leadProductUpdate_lead_products_edges {
  __typename: "LeadProductsEdge";
  /**
   * The API ID of the Lead_ProductMap
   */
  id: string;
  /**
   * The one-off short note that users can write on this lead->product relationship.
   */
  relationshipNote: string | null;
  /**
   * The quantity number of the given product that is attached to the lead
   */
  quantity: number;
  /**
   * The monetary value for each unit of the product attached to the lead
   */
  price: UpdateProductForLead_leadProductUpdate_lead_products_edges_price;
  /**
   * The original price of the product
   */
  originalPrice: UpdateProductForLead_leadProductUpdate_lead_products_edges_originalPrice | null;
  /**
   * The total value of this attached product on the lead, taking its unit price and multiplying it by the given quantity.
   */
  total: number;
  /**
   * The product
   */
  node: UpdateProductForLead_leadProductUpdate_lead_products_edges_node;
}

export interface UpdateProductForLead_leadProductUpdate_lead_products_totalValue {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface UpdateProductForLead_leadProductUpdate_lead_products {
  __typename: "LeadProductsConnection";
  /**
   * A list of edges.
   */
  edges: UpdateProductForLead_leadProductUpdate_lead_products_edges[];
  /**
   * The total value of the products mapped to the lead
   */
  totalValue: UpdateProductForLead_leadProductUpdate_lead_products_totalValue | null;
}

export interface UpdateProductForLead_leadProductUpdate_lead_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
}

export interface UpdateProductForLead_leadProductUpdate_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Products for the lead
   */
  products: UpdateProductForLead_leadProductUpdate_lead_products | null;
  /**
   * The mode of the leads value
   */
  valueMode: LeadValueMode;
  value: UpdateProductForLead_leadProductUpdate_lead_value | null;
}

export interface UpdateProductForLead_leadProductUpdate {
  __typename: "LeadProductUpdatePayload";
  /**
   * The lead that the product was updated on
   */
  lead: UpdateProductForLead_leadProductUpdate_lead;
}

export interface UpdateProductForLead {
  /**
   * Update a product on a lead
   */
  leadProductUpdate: UpdateProductForLead_leadProductUpdate;
}

export interface UpdateProductForLeadVariables {
  input: LeadProductUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMarketForLead
// ====================================================

export interface GetMarketForLead_lead_market {
  __typename: "Market";
  id: string;
  name: string;
  currency: string;
  currencySymbol: string;
  isDefault: boolean;
}

export interface GetMarketForLead_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The market for the products attached to the lead
   */
  market: GetMarketForLead_lead_market | null;
}

export interface GetMarketForLead {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetMarketForLead_lead | null;
}

export interface GetMarketForLeadVariables {
  leadId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetProductsForLead
// ====================================================

export interface GetProductsForLead_lead_products_edges_price {
  __typename: "Money";
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetProductsForLead_lead_products_edges_originalPrice {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface GetProductsForLead_lead_products_edges_node_category {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
}

export interface GetProductsForLead_lead_products_edges_node_markets_edges_price {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetProductsForLead_lead_products_edges_node_markets_edges {
  __typename: "ProductMarketsEdge";
  /**
   * The price and currency of the product in the market.
   */
  price: GetProductsForLead_lead_products_edges_node_markets_edges_price | null;
  /**
   * Whether the product is available in the market.
   */
  isAvailable: boolean | null;
}

export interface GetProductsForLead_lead_products_edges_node_markets {
  __typename: "ProductMarketsConnection";
  /**
   * A list of edges.
   */
  edges: GetProductsForLead_lead_products_edges_node_markets_edges[];
}

export interface GetProductsForLead_lead_products_edges_node {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The description of the product
   */
  description: string | null;
  /**
   * The type of the product (Good or Service)
   */
  type: ProductType;
  /**
   * The URL of the report for this product
   */
  reportUrl: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The category of the product
   */
  category: GetProductsForLead_lead_products_edges_node_category | null;
  /**
   * The markets of the product
   */
  markets: GetProductsForLead_lead_products_edges_node_markets;
  /**
   * The DateTime the product was created
   */
  createdTime: any;
}

export interface GetProductsForLead_lead_products_edges {
  __typename: "LeadProductsEdge";
  /**
   * The API ID of the Lead_ProductMap
   */
  id: string;
  /**
   * The one-off short note that users can write on this lead->product relationship.
   */
  relationshipNote: string | null;
  /**
   * The quantity number of the given product that is attached to the lead
   */
  quantity: number;
  /**
   * The monetary value for each unit of the product attached to the lead
   */
  price: GetProductsForLead_lead_products_edges_price;
  /**
   * The original price of the product
   */
  originalPrice: GetProductsForLead_lead_products_edges_originalPrice | null;
  /**
   * The total value of this attached product on the lead, taking its unit price and multiplying it by the given quantity.
   */
  total: number;
  /**
   * The product
   */
  node: GetProductsForLead_lead_products_edges_node;
}

export interface GetProductsForLead_lead_products {
  __typename: "LeadProductsConnection";
  /**
   * A list of edges.
   */
  edges: GetProductsForLead_lead_products_edges[];
}

export interface GetProductsForLead_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Products for the lead
   */
  products: GetProductsForLead_lead_products | null;
}

export interface GetProductsForLead {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetProductsForLead_lead | null;
}

export interface GetProductsForLeadVariables {
  leadId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateLeadSummary
// ====================================================

export interface UpdateLeadSummary_updateLead_lead_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface UpdateLeadSummary_updateLead_lead_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateLeadSummary_updateLead_lead_clonedFrom {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface UpdateLeadSummary_updateLead_lead_outcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateLeadSummary_updateLead_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  number: number | null;
  /**
   * The terrority to which this lead is assigned.
   */
  territory: UpdateLeadSummary_updateLead_lead_territory | null;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The percentage confidence of lead success.
   */
  confidence: number;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * The anticipated close time for the lead.
   */
  anticipatedClosedTime: any | null;
  /**
   * The deemed "creator" of this lead. If a user has created the lead manually,
   * our UI will show the user, otherwise we’ll fallback to the origin, i.e. "API"
   * or "CSV import"
   */
  creator: UpdateLeadSummary_updateLead_lead_creator;
  /**
   * The lead this lead was cloned from (usually null)
   */
  clonedFrom: UpdateLeadSummary_updateLead_lead_clonedFrom | null;
  /**
   * The outcome for this lead, if there is one.
   */
  outcome: UpdateLeadSummary_updateLead_lead_outcome | null;
}

export interface UpdateLeadSummary_updateLead {
  __typename: "UpdateLeadPayload";
  /**
   * The updated Nutshell lead.
   */
  lead: UpdateLeadSummary_updateLead_lead;
}

export interface UpdateLeadSummary {
  /**
   * Updates a Nutshell lead.
   */
  updateLead: UpdateLeadSummary_updateLead;
}

export interface UpdateLeadSummaryVariables {
  lead: UpdateLeadInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLeadSummary
// ====================================================

export interface GetLeadSummary_lead_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface GetLeadSummary_lead_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadSummary_lead_clonedFrom {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetLeadSummary_lead_outcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadSummary_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  number: number | null;
  /**
   * The terrority to which this lead is assigned.
   */
  territory: GetLeadSummary_lead_territory | null;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The percentage confidence of lead success.
   */
  confidence: number;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * The anticipated close time for the lead.
   */
  anticipatedClosedTime: any | null;
  /**
   * The deemed "creator" of this lead. If a user has created the lead manually,
   * our UI will show the user, otherwise we’ll fallback to the origin, i.e. "API"
   * or "CSV import"
   */
  creator: GetLeadSummary_lead_creator;
  /**
   * The lead this lead was cloned from (usually null)
   */
  clonedFrom: GetLeadSummary_lead_clonedFrom | null;
  /**
   * The outcome for this lead, if there is one.
   */
  outcome: GetLeadSummary_lead_outcome | null;
}

export interface GetLeadSummary {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetLeadSummary_lead | null;
}

export interface GetLeadSummaryVariables {
  id?: string | null;
  number?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: getReview
// ====================================================

export interface getReview_g2Review {
  __typename: "G2Review";
  /**
   * Returns the link to leave a G2 review
   */
  reviewLink: string;
}

export interface getReview {
  /**
   * Returns information about a G2 review
   */
  g2Review: getReview_g2Review;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAllLimits
// ====================================================

export interface GetAllLimits_allLimits_limits {
  __typename: "LimitInfo";
  /**
   * In trial, we don’t show limits but instead a warning when usage is above the lowest tier
   */
  shouldShowWarningInTrial: boolean;
  /**
   * The current usage of the given type
   */
  currentUsage: number;
  /**
   * The limit according to the user’s plan
   */
  currentPlanLimit: number | null;
  /**
   * The limit according to the user’s plan excluding custom settings
   */
  tierPlanLimit: number | null;
  /**
   * Whether the user can add another of given type
   */
  canAdd: boolean;
  /**
   * The name of the user’s current plan
   */
  currentPlanName: string;
  /**
   * The limit according to the user’s plan
   */
  upgradePlanLimit: number | null;
  /**
   * The name of the user’s direct upgrade plan
   */
  upgradePlanName: string;
  /**
   * User facing string of the thing being limited
   */
  humanReadableType: string;
  /**
   * The limit for this feature in foundation
   */
  foundationLimit: number | null;
  /**
   * The limit for this feature in pro
   */
  proLimit: number | null;
  /**
   * The limit for this feature in business
   */
  businessLimit: number | null;
  /**
   * The limit for this feature in enterprise
   */
  enterpriseLimit: number | null;
}

export interface GetAllLimits_allLimits {
  __typename: "AllLimits";
  /**
   * The minimum plan name necessary to stay within limits
   */
  minimumPlanName: string;
  /**
   * The minimum plan SKU necessary to stay within limits
   */
  minimumPlanSku: string;
  /**
   * All limits on features by plan
   */
  limits: GetAllLimits_allLimits_limits[];
}

export interface GetAllLimits {
  /**
   * Info about all limits for different plans
   */
  allLimits: GetAllLimits_allLimits | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLimits
// ====================================================

export interface GetLimits_limits {
  __typename: "LimitInfo";
  /**
   * In trial, we don’t show limits but instead a warning when usage is above the lowest tier
   */
  shouldShowWarningInTrial: boolean;
  /**
   * The current usage of the given type
   */
  currentUsage: number;
  /**
   * All time usage of the given type
   */
  allTimeUsage: number | null;
  /**
   * The limit according to the user’s plan
   */
  currentPlanLimit: number | null;
  /**
   * Whether this limit is enforced or not, since some limits are grandfathered into older plans and are not being enforced
   */
  isEnforced: boolean;
  /**
   * Whether the user can add another of given type
   */
  canAdd: boolean;
  /**
   * The name of the user’s current plan
   */
  currentPlanName: string;
  /**
   * The limit according to the user’s plan
   */
  upgradePlanLimit: number | null;
  /**
   * The name of the user’s direct upgrade plan
   */
  upgradePlanName: string;
  /**
   * User facing string of the thing being limited
   */
  humanReadableType: string;
  /**
   * The limit according to the user’s plan excluding custom settings
   */
  tierPlanLimit: number | null;
}

export interface GetLimits {
  /**
   * Info about the feature limits for this instance
   */
  limits: GetLimits_limits | null;
}

export interface GetLimitsVariables {
  type: LimitedType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RegisterForWebcast
// ====================================================

export interface RegisterForWebcast_demioRegister_webcast {
  __typename: "Webcast";
  /**
   * The id field denoting a single instance of a webcast event.
   */
  id: number;
  /**
   * The name of the Webcast.
   */
  name: string;
  /**
   * The registration url for a specific Webcast event.
   */
  registrationUrl: string;
  /**
   * The DateTime that represents when the Webcast will take place.
   */
  timestamp: any;
  isCurrentUserRegistered: boolean;
}

export interface RegisterForWebcast_demioRegister {
  __typename: "DemioRegisterPayload";
  /**
   * The webcast the User just registered for.
   */
  webcast: RegisterForWebcast_demioRegister_webcast;
}

export interface RegisterForWebcast {
  /**
   * Registers a Nutshell User for a Demio Webcast.
   */
  demioRegister: RegisterForWebcast_demioRegister;
}

export interface RegisterForWebcastVariables {
  registrationInput: DemioRegisterInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCTABanners
// ====================================================

export interface GetCTABanners_ctaBanners_demioEvent {
  __typename: "Webcast";
  /**
   * The id field denoting a single instance of a webcast event.
   */
  id: number;
  /**
   * The name of the Webcast.
   */
  name: string;
  /**
   * The registration url for a specific Webcast event.
   */
  registrationUrl: string;
  /**
   * The DateTime that represents when the Webcast will take place.
   */
  timestamp: any;
  isCurrentUserRegistered: boolean;
}

export interface GetCTABanners_ctaBanners_upcomingEvents {
  __typename: "Webcast";
  /**
   * The id field denoting a single instance of a webcast event.
   */
  id: number;
  /**
   * The name of the Webcast.
   */
  name: string;
  /**
   * The registration url for a specific Webcast event.
   */
  registrationUrl: string;
  /**
   * The DateTime that represents when the Webcast will take place.
   */
  timestamp: any;
  isCurrentUserRegistered: boolean;
}

export interface GetCTABanners_ctaBanners {
  __typename: "CTABanner";
  /**
   * The title of the banner
   */
  key: CTABannerKey;
  /**
   * The title of the banner
   */
  ctaType: CTABannerType;
  /**
   * The title of the banner
   */
  title: string;
  /**
   * The subtitle of the banner
   */
  subtitle: string;
  /**
   * The url to register a meeting with a team member
   */
  registrationUrl: string | null;
  /**
   * The dismiss setting associated with this banner
   */
  dismissSettingName: string;
  /**
   * The event for the banner
   */
  demioEvent: GetCTABanners_ctaBanners_demioEvent | null;
  /**
   * A list of upcoming events
   */
  upcomingEvents: GetCTABanners_ctaBanners_upcomingEvents[];
}

export interface GetCTABanners {
  /**
   * Returns an array of CTA banners.
   */
  ctaBanners: GetCTABanners_ctaBanners[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUpcomingWebcasts
// ====================================================

export interface GetUpcomingWebcasts_upcomingWebcasts {
  __typename: "Webcast";
  /**
   * The id field denoting a single instance of a webcast event.
   */
  id: number;
  /**
   * The name of the Webcast.
   */
  name: string;
  /**
   * The registration url for a specific Webcast event.
   */
  registrationUrl: string;
  /**
   * The DateTime that represents when the Webcast will take place.
   */
  timestamp: any;
  isCurrentUserRegistered: boolean;
}

export interface GetUpcomingWebcasts {
  /**
   * Internal endpoint that returns a list of upcoming webcasts.
   */
  upcomingWebcasts: GetUpcomingWebcasts_upcomingWebcasts[] | null;
}

export interface GetUpcomingWebcastsVariables {
  limit?: number | null;
  type: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CompleteStepMutation
// ====================================================

export interface CompleteStepMutation_completeStep_step_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CompleteStepMutation_completeStep_step_relatedLead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CompleteStepMutation_completeStep_step {
  __typename: "Step";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The name/title of the step
   */
  title: string;
  /**
   * The canonical API href for the step
   */
  href: string;
  /**
   * The step’s user-defined description
   */
  description: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: CompleteStepMutation_completeStep_step_delayApplications[];
  /**
   * The due timestamp of the step
   */
  dueTime: any | null;
  /**
   * Can the step be completed?
   */
  isCompleteable: boolean;
  /**
   * Is this step completed?
   */
  isCompleted: boolean;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Is the step overdue?
   */
  isOverdue: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string;
  /**
   * Related lead that this step is associated with
   */
  relatedLead: CompleteStepMutation_completeStep_step_relatedLead;
}

export interface CompleteStepMutation_completeStep_nextStep_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CompleteStepMutation_completeStep_nextStep_relatedLead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CompleteStepMutation_completeStep_nextStep {
  __typename: "Step";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The name/title of the step
   */
  title: string;
  /**
   * The canonical API href for the step
   */
  href: string;
  /**
   * The step’s user-defined description
   */
  description: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: CompleteStepMutation_completeStep_nextStep_delayApplications[];
  /**
   * The due timestamp of the step
   */
  dueTime: any | null;
  /**
   * Can the step be completed?
   */
  isCompleteable: boolean;
  /**
   * Is this step completed?
   */
  isCompleted: boolean;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Is the step overdue?
   */
  isOverdue: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string;
  /**
   * Related lead that this step is associated with
   */
  relatedLead: CompleteStepMutation_completeStep_nextStep_relatedLead;
}

export interface CompleteStepMutation_completeStep {
  __typename: "CompleteStepPayload";
  /**
   * The newly completed Nutshell step
   */
  step: CompleteStepMutation_completeStep_step;
  /**
   * The next Nutshell step to be completed
   */
  nextStep: CompleteStepMutation_completeStep_nextStep | null;
}

export interface CompleteStepMutation {
  /**
   * Attempts to perform a complete step operation on an uncompleted step
   */
  completeStep: CompleteStepMutation_completeStep | null;
}

export interface CompleteStepMutationVariables {
  step: CompleteStepInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SkipStepMutation
// ====================================================

export interface SkipStepMutation_skipStep_step_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SkipStepMutation_skipStep_step_relatedLead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SkipStepMutation_skipStep_step {
  __typename: "Step";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The name/title of the step
   */
  title: string;
  /**
   * The canonical API href for the step
   */
  href: string;
  /**
   * The step’s user-defined description
   */
  description: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: SkipStepMutation_skipStep_step_delayApplications[];
  /**
   * The due timestamp of the step
   */
  dueTime: any | null;
  /**
   * Can the step be completed?
   */
  isCompleteable: boolean;
  /**
   * Is this step completed?
   */
  isCompleted: boolean;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Is the step overdue?
   */
  isOverdue: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string;
  /**
   * Related lead that this step is associated with
   */
  relatedLead: SkipStepMutation_skipStep_step_relatedLead;
}

export interface SkipStepMutation_skipStep_nextStep_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SkipStepMutation_skipStep_nextStep_relatedLead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SkipStepMutation_skipStep_nextStep {
  __typename: "Step";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The name/title of the step
   */
  title: string;
  /**
   * The canonical API href for the step
   */
  href: string;
  /**
   * The step’s user-defined description
   */
  description: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: SkipStepMutation_skipStep_nextStep_delayApplications[];
  /**
   * The due timestamp of the step
   */
  dueTime: any | null;
  /**
   * Can the step be completed?
   */
  isCompleteable: boolean;
  /**
   * Is this step completed?
   */
  isCompleted: boolean;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Is the step overdue?
   */
  isOverdue: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string;
  /**
   * Related lead that this step is associated with
   */
  relatedLead: SkipStepMutation_skipStep_nextStep_relatedLead;
}

export interface SkipStepMutation_skipStep {
  __typename: "SkipStepPayload";
  /**
   * The skipped Nutshell step
   */
  step: SkipStepMutation_skipStep_step;
  /**
   * The next Nutshell step to be worked
   */
  nextStep: SkipStepMutation_skipStep_nextStep | null;
}

export interface SkipStepMutation {
  /**
   * Attempts to perform a skip step operation on a step
   */
  skipStep: SkipStepMutation_skipStep | null;
}

export interface SkipStepMutationVariables {
  step: SkipStepInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAppMessages
// ====================================================

export interface GetAppMessages_appMessages {
  __typename: "AppMessage";
  /**
   * The unique id of the message.
   */
  id: string;
  /**
   * The message to show to the user.
   */
  message: string;
}

export interface GetAppMessages {
  /**
   * Returns a list of app messages
   */
  appMessages: GetAppMessages_appMessages[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: NavigationSwitch
// ====================================================

export interface NavigationSwitch_navigationSwitch {
  __typename: "NavigationSwitchPayload";
  /**
   * Is the new navigation enabled.
   */
  isNewNavigation: boolean;
}

export interface NavigationSwitch {
  /**
   * Switch between old and new navigation.
   */
  navigationSwitch: NavigationSwitch_navigationSwitch | null;
}

export interface NavigationSwitchVariables {
  input: NavigationSwitchInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAiSearchResults
// ====================================================

export interface GetAiSearchResults_aiSearch_suggestions {
  __typename: "AiSearchSuggestion";
  /**
   * Suggestion type: navigation or action
   */
  type: AiSearchSuggestionTypeEnum;
  /**
   * Human-readable label
   */
  label: string;
  /**
   * Brief explanation of why this is suggested
   */
  description: string | null;
  /**
   * Navigation path, if type is navigation
   */
  path: string | null;
  /**
   * Action identifier, if type is action
   */
  actionId: string | null;
}

export interface GetAiSearchResults_aiSearch {
  __typename: "AiSearchResult";
  /**
   * The intent of AI search
   */
  intent: AiSearchIntentEnum;
  /**
   * Ordered list of suggestions
   */
  suggestions: GetAiSearchResults_aiSearch_suggestions[];
  /**
   * Refined search query for entity search, if applicable
   */
  searchRefinement: string | null;
}

export interface GetAiSearchResults {
  /**
   * AI-powered command palette search that interprets natural language queries.
   */
  aiSearch: GetAiSearchResults_aiSearch;
}

export interface GetAiSearchResultsVariables {
  query: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSearchResultsByType
// ====================================================

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_leads_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_leads_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_leads_value {
  __typename: "Money";
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetSearchResultsByType_search_quickResults_recentResultsByType_leads_value_formattedValue;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_leads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_leads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetSearchResultsByType_search_quickResults_recentResultsByType_leads_contacts_primaryEdge_node;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_leads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetSearchResultsByType_search_quickResults_recentResultsByType_leads_contacts_primaryEdge | null;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_leads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_leads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetSearchResultsByType_search_quickResults_recentResultsByType_leads_accounts_primaryEdge_node;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_leads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetSearchResultsByType_search_quickResults_recentResultsByType_leads_accounts_primaryEdge | null;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_leads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * Leads don’t have initials, but for interface reasons we’ll return an empty
   * string here instead of removing the property entirely.
   */
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetSearchResultsByType_search_quickResults_recentResultsByType_leads_assignee | null;
  value: GetSearchResultsByType_search_quickResults_recentResultsByType_leads_value | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetSearchResultsByType_search_quickResults_recentResultsByType_leads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetSearchResultsByType_search_quickResults_recentResultsByType_leads_accounts;
  /**
   * The created time for the lead.
   */
  createdTime: any;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_accounts_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_accounts_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  city: string | null;
  postalCode: string | null;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_accounts_postalAddresses_primary {
  __typename: "PostalAddress";
  value: GetSearchResultsByType_search_quickResults_recentResultsByType_accounts_postalAddresses_primary_value;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_accounts_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSearchResultsByType_search_quickResults_recentResultsByType_accounts_postalAddresses_primary | null;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_accounts_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_accounts_phones_primary {
  __typename: "Phone";
  value: GetSearchResultsByType_search_quickResults_recentResultsByType_accounts_phones_primary_value;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_accounts_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSearchResultsByType_search_quickResults_recentResultsByType_accounts_phones_primary | null;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_accounts {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * The primary contact for this account
   */
  primaryContact: GetSearchResultsByType_search_quickResults_recentResultsByType_accounts_primaryContact | null;
  /**
   * Convenience way to get the region display for an account
   */
  primaryAddressRegion: string | null;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetSearchResultsByType_search_quickResults_recentResultsByType_accounts_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetSearchResultsByType_search_quickResults_recentResultsByType_accounts_phones;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_contacts_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_contacts_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetSearchResultsByType_search_quickResults_recentResultsByType_contacts_accounts_primary | null;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_contacts_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_contacts_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetSearchResultsByType_search_quickResults_recentResultsByType_contacts_emailAddresses_primary_value;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_contacts_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSearchResultsByType_search_quickResults_recentResultsByType_contacts_emailAddresses_primary | null;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_contacts_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_contacts_phones_primary {
  __typename: "Phone";
  value: GetSearchResultsByType_search_quickResults_recentResultsByType_contacts_phones_primary_value;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_contacts_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSearchResultsByType_search_quickResults_recentResultsByType_contacts_phones_primary | null;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType_contacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetSearchResultsByType_search_quickResults_recentResultsByType_contacts_accounts;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetSearchResultsByType_search_quickResults_recentResultsByType_contacts_emailAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetSearchResultsByType_search_quickResults_recentResultsByType_contacts_phones;
}

export interface GetSearchResultsByType_search_quickResults_recentResultsByType {
  __typename: "RecentResults";
  /**
   * Recently viewed leads
   */
  leads: GetSearchResultsByType_search_quickResults_recentResultsByType_leads[];
  /**
   * Recently viewed accounts
   */
  accounts: GetSearchResultsByType_search_quickResults_recentResultsByType_accounts[];
  /**
   * Recently viewed contacts
   */
  contacts: GetSearchResultsByType_search_quickResults_recentResultsByType_contacts[];
}

export interface GetSearchResultsByType_search_quickResults_leadResults_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSearchResultsByType_search_quickResults_leadResults_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
}

export interface GetSearchResultsByType_search_quickResults_leadResults_value {
  __typename: "Money";
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetSearchResultsByType_search_quickResults_leadResults_value_formattedValue;
}

export interface GetSearchResultsByType_search_quickResults_leadResults_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetSearchResultsByType_search_quickResults_leadResults_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetSearchResultsByType_search_quickResults_leadResults_contacts_primaryEdge_node;
}

export interface GetSearchResultsByType_search_quickResults_leadResults_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetSearchResultsByType_search_quickResults_leadResults_contacts_primaryEdge | null;
}

export interface GetSearchResultsByType_search_quickResults_leadResults_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetSearchResultsByType_search_quickResults_leadResults_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetSearchResultsByType_search_quickResults_leadResults_accounts_primaryEdge_node;
}

export interface GetSearchResultsByType_search_quickResults_leadResults_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetSearchResultsByType_search_quickResults_leadResults_accounts_primaryEdge | null;
}

export interface GetSearchResultsByType_search_quickResults_leadResults {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * Leads don’t have initials, but for interface reasons we’ll return an empty
   * string here instead of removing the property entirely.
   */
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetSearchResultsByType_search_quickResults_leadResults_assignee | null;
  value: GetSearchResultsByType_search_quickResults_leadResults_value | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetSearchResultsByType_search_quickResults_leadResults_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetSearchResultsByType_search_quickResults_leadResults_accounts;
  /**
   * The created time for the lead.
   */
  createdTime: any;
}

export interface GetSearchResultsByType_search_quickResults_accountResults_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetSearchResultsByType_search_quickResults_accountResults_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  city: string | null;
  postalCode: string | null;
}

export interface GetSearchResultsByType_search_quickResults_accountResults_postalAddresses_primary {
  __typename: "PostalAddress";
  value: GetSearchResultsByType_search_quickResults_accountResults_postalAddresses_primary_value;
}

export interface GetSearchResultsByType_search_quickResults_accountResults_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSearchResultsByType_search_quickResults_accountResults_postalAddresses_primary | null;
}

export interface GetSearchResultsByType_search_quickResults_accountResults_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetSearchResultsByType_search_quickResults_accountResults_phones_primary {
  __typename: "Phone";
  value: GetSearchResultsByType_search_quickResults_accountResults_phones_primary_value;
}

export interface GetSearchResultsByType_search_quickResults_accountResults_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSearchResultsByType_search_quickResults_accountResults_phones_primary | null;
}

export interface GetSearchResultsByType_search_quickResults_accountResults {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * The primary contact for this account
   */
  primaryContact: GetSearchResultsByType_search_quickResults_accountResults_primaryContact | null;
  /**
   * Convenience way to get the region display for an account
   */
  primaryAddressRegion: string | null;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetSearchResultsByType_search_quickResults_accountResults_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetSearchResultsByType_search_quickResults_accountResults_phones;
}

export interface GetSearchResultsByType_search_quickResults_contactResults_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetSearchResultsByType_search_quickResults_contactResults_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetSearchResultsByType_search_quickResults_contactResults_accounts_primary | null;
}

export interface GetSearchResultsByType_search_quickResults_contactResults_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetSearchResultsByType_search_quickResults_contactResults_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetSearchResultsByType_search_quickResults_contactResults_emailAddresses_primary_value;
}

export interface GetSearchResultsByType_search_quickResults_contactResults_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSearchResultsByType_search_quickResults_contactResults_emailAddresses_primary | null;
}

export interface GetSearchResultsByType_search_quickResults_contactResults_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetSearchResultsByType_search_quickResults_contactResults_phones_primary {
  __typename: "Phone";
  value: GetSearchResultsByType_search_quickResults_contactResults_phones_primary_value;
}

export interface GetSearchResultsByType_search_quickResults_contactResults_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSearchResultsByType_search_quickResults_contactResults_phones_primary | null;
}

export interface GetSearchResultsByType_search_quickResults_contactResults {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetSearchResultsByType_search_quickResults_contactResults_accounts;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetSearchResultsByType_search_quickResults_contactResults_emailAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetSearchResultsByType_search_quickResults_contactResults_phones;
}

export interface GetSearchResultsByType_search_quickResults {
  __typename: "SearchQuickResults";
  /**
   * Recently viewed items grouped by entity type
   */
  recentResultsByType: GetSearchResultsByType_search_quickResults_recentResultsByType;
  /**
   * A collection of lead results items for the query.
   */
  leadResults: GetSearchResultsByType_search_quickResults_leadResults[];
  /**
   * A collection of account results items for the query.
   */
  accountResults: GetSearchResultsByType_search_quickResults_accountResults[];
  /**
   * A collection of contact results items for the query.
   */
  contactResults: GetSearchResultsByType_search_quickResults_contactResults[];
}

export interface GetSearchResultsByType_search {
  __typename: "SearchResultItemConnection";
  /**
   * An opinionated object that is useful for our "search everything" UIs
   */
  quickResults: GetSearchResultsByType_search_quickResults | null;
}

export interface GetSearchResultsByType {
  /**
   * Perform a search across resources.
   */
  search: GetSearchResultsByType_search | null;
}

export interface GetSearchResultsByTypeVariables {
  query: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPersonalizedDemo
// ====================================================

export interface GetPersonalizedDemo_personalizedDemo {
  __typename: "PersonalizedDemo";
  salesContactImageUrl: string;
  salesContactType: SalesContactType;
  salesContactName: string;
  salesContactShortName: string;
  salesContactMeetingId: number;
  instanceId: string;
  salesContactEmail: string;
}

export interface GetPersonalizedDemo {
  /**
   * A representation of a personalized demo config
   */
  personalizedDemo: GetPersonalizedDemo_personalizedDemo | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AccountEnrichmentRespond
// ====================================================

export interface AccountEnrichmentRespond_accountEnrichmentRespond_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface AccountEnrichmentRespond_accountEnrichmentRespond {
  __typename: "AccountEnrichmentRespondPayload";
  /**
   * The account to enrich or decline enrichment data for
   */
  account: AccountEnrichmentRespond_accountEnrichmentRespond_account;
}

export interface AccountEnrichmentRespond {
  /**
   * Accepts or decline company enrichment data for a given company
   */
  accountEnrichmentRespond: AccountEnrichmentRespond_accountEnrichmentRespond;
}

export interface AccountEnrichmentRespondVariables {
  input: AccountEnrichmentRespondInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountEnrichment
// ====================================================

export interface GetAccountEnrichment_accountEnrichment {
  __typename: "EnrichmentField";
  /**
   * The label for the field
   */
  label: string;
  /**
   * The display label for the field
   */
  displayLabel: string;
  /**
   * The value for the field
   */
  value: string;
  /**
   * Is this field net-new for this entity?
   */
  isNew: boolean;
}

export interface GetAccountEnrichment {
  /**
   * Returns a list of enrichment fields for an account
   */
  accountEnrichment: GetAccountEnrichment_accountEnrichment[] | null;
}

export interface GetAccountEnrichmentVariables {
  accountId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EnrichContact
// ====================================================

export interface EnrichContact_enrichContact_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EnrichContact_enrichContact {
  __typename: "EnrichContactPayload";
  /**
   * The contact to enrich or decline enrichment data for
   */
  contact: EnrichContact_enrichContact_contact;
}

export interface EnrichContact {
  /**
   * Accepts or decline contact enrichment data for a given contact
   */
  enrichContact: EnrichContact_enrichContact;
}

export interface EnrichContactVariables {
  input: EnrichContactInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactEnrichment
// ====================================================

export interface GetContactEnrichment_contactEnrichment_baseFields {
  __typename: "EnrichmentField";
  /**
   * The label for the field
   */
  label: string;
  /**
   * The display label for the field
   */
  displayLabel: string;
  /**
   * The value for the field
   */
  value: string;
  /**
   * Is this field net-new for this entity?
   */
  isNew: boolean;
}

export interface GetContactEnrichment_contactEnrichment_companyFields {
  __typename: "EnrichmentField";
  /**
   * The label for the field
   */
  label: string;
  /**
   * The display label for the field
   */
  displayLabel: string;
  /**
   * The value for the field
   */
  value: string;
  /**
   * Is this field net-new for this entity?
   */
  isNew: boolean;
}

export interface GetContactEnrichment_contactEnrichment_socialFields {
  __typename: "EnrichmentField";
  /**
   * The label for the field
   */
  label: string;
  /**
   * The display label for the field
   */
  displayLabel: string;
  /**
   * The value for the field
   */
  value: string;
  /**
   * Is this field net-new for this entity?
   */
  isNew: boolean;
}

export interface GetContactEnrichment_contactEnrichment {
  __typename: "ContactEnrichment";
  /**
   * The fields of the enrichment request.
   */
  baseFields: GetContactEnrichment_contactEnrichment_baseFields[];
  /**
   * The fields of the enrichment request.
   */
  companyFields: GetContactEnrichment_contactEnrichment_companyFields[];
  /**
   * The fields of the enrichment request.
   */
  socialFields: GetContactEnrichment_contactEnrichment_socialFields[];
}

export interface GetContactEnrichment {
  /**
   * Fetch enrichment data for a contact.
   */
  contactEnrichment: GetContactEnrichment_contactEnrichment | null;
}

export interface GetContactEnrichmentVariables {
  input: ContactEnrichmentInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactSalesLink
// ====================================================

export interface GetContactSalesLink {
  /**
   * Returns a registration url that a trial user can use to contact their representative.
   */
  contactSalesLink: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetOnboardingChecklist
// ====================================================

export interface GetOnboardingChecklist_onboardingChecklist_items {
  __typename: "OnboardingChecklistItem";
  /**
   * Completion percentage of all tasks on the onboarding checklist
   */
  key: OnboardingChecklistKey;
  /**
   * Title of the checklist item, i.e. "Create your first contact"
   */
  title: string;
  /**
   * Subtitle of the checklist item
   */
  subtitle: string | null;
  /**
   * The total decimal amount of the monetary value.
   */
  isComplete: boolean;
}

export interface GetOnboardingChecklist_onboardingChecklist {
  __typename: "OnboardingChecklist";
  /**
   * The total decimal amount of the monetary value.
   */
  items: GetOnboardingChecklist_onboardingChecklist_items[];
  /**
   * Completion percentage of all tasks on the onboarding checklist
   */
  percentComplete: number;
  /**
   * Is the checklist displayed to the user, or have they manually hidden it / completed it.
   */
  isAvailable: boolean;
  /**
   * Can the sidebar checklist be removed? We prevent this for new users for a couple days
   */
  canRemove: boolean;
}

export interface GetOnboardingChecklist {
  /**
   * Information about the user onboarding checklist
   */
  onboardingChecklist: GetOnboardingChecklist_onboardingChecklist;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTrialInfo
// ====================================================

export interface GetTrialInfo_sessionInstance {
  __typename: "Instance";
  /**
   * Should we show a chat CTA to the current user? Note, we still might hide this if we’re outside business hours.
   */
  shouldShowChatCta: boolean;
  /**
   * Is it currently during Nutshell business hours?
   */
  isDuringNutshellBusinessHours: boolean;
  /**
   * Should we hide chat even during business hours?
   */
  isChatHidden: boolean;
}

export interface GetTrialInfo {
  /**
   * A hodge-podge of instance-level concerns
   */
  sessionInstance: GetTrialInfo_sessionInstance | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveAccountParent
// ====================================================

export interface RemoveAccountParent_accountParentRemove_account_parentAccount_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface RemoveAccountParent_accountParentRemove_account_parentAccount_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface RemoveAccountParent_accountParentRemove_account_parentAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The type assigned to this account
   */
  accountType: RemoveAccountParent_accountParentRemove_account_parentAccount_accountType;
  /**
   * Convenience way to get the region display for an account
   */
  primaryAddressRegion: string | null;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The primary contact for this account
   */
  primaryContact: RemoveAccountParent_accountParentRemove_account_parentAccount_primaryContact | null;
}

export interface RemoveAccountParent_accountParentRemove_account_childAccounts_edges_node_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface RemoveAccountParent_accountParentRemove_account_childAccounts_edges_node_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface RemoveAccountParent_accountParentRemove_account_childAccounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The type assigned to this account
   */
  accountType: RemoveAccountParent_accountParentRemove_account_childAccounts_edges_node_accountType;
  /**
   * Convenience way to get the region display for an account
   */
  primaryAddressRegion: string | null;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The primary contact for this account
   */
  primaryContact: RemoveAccountParent_accountParentRemove_account_childAccounts_edges_node_primaryContact | null;
}

export interface RemoveAccountParent_accountParentRemove_account_childAccounts_edges {
  __typename: "AccountChildrenEdge";
  node: RemoveAccountParent_accountParentRemove_account_childAccounts_edges_node;
}

export interface RemoveAccountParent_accountParentRemove_account_childAccounts {
  __typename: "AccountChildrenConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: RemoveAccountParent_accountParentRemove_account_childAccounts_edges[];
}

export interface RemoveAccountParent_accountParentRemove_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The parent account of this account
   */
  parentAccount: RemoveAccountParent_accountParentRemove_account_parentAccount | null;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to child Accounts.
   */
  childAccounts: RemoveAccountParent_accountParentRemove_account_childAccounts;
}

export interface RemoveAccountParent_accountParentRemove_parentAccount_parentAccount_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface RemoveAccountParent_accountParentRemove_parentAccount_parentAccount_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface RemoveAccountParent_accountParentRemove_parentAccount_parentAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The type assigned to this account
   */
  accountType: RemoveAccountParent_accountParentRemove_parentAccount_parentAccount_accountType;
  /**
   * Convenience way to get the region display for an account
   */
  primaryAddressRegion: string | null;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The primary contact for this account
   */
  primaryContact: RemoveAccountParent_accountParentRemove_parentAccount_parentAccount_primaryContact | null;
}

export interface RemoveAccountParent_accountParentRemove_parentAccount_childAccounts_edges_node_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface RemoveAccountParent_accountParentRemove_parentAccount_childAccounts_edges_node_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface RemoveAccountParent_accountParentRemove_parentAccount_childAccounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The type assigned to this account
   */
  accountType: RemoveAccountParent_accountParentRemove_parentAccount_childAccounts_edges_node_accountType;
  /**
   * Convenience way to get the region display for an account
   */
  primaryAddressRegion: string | null;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The primary contact for this account
   */
  primaryContact: RemoveAccountParent_accountParentRemove_parentAccount_childAccounts_edges_node_primaryContact | null;
}

export interface RemoveAccountParent_accountParentRemove_parentAccount_childAccounts_edges {
  __typename: "AccountChildrenEdge";
  node: RemoveAccountParent_accountParentRemove_parentAccount_childAccounts_edges_node;
}

export interface RemoveAccountParent_accountParentRemove_parentAccount_childAccounts {
  __typename: "AccountChildrenConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: RemoveAccountParent_accountParentRemove_parentAccount_childAccounts_edges[];
}

export interface RemoveAccountParent_accountParentRemove_parentAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The parent account of this account
   */
  parentAccount: RemoveAccountParent_accountParentRemove_parentAccount_parentAccount | null;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to child Accounts.
   */
  childAccounts: RemoveAccountParent_accountParentRemove_parentAccount_childAccounts;
}

export interface RemoveAccountParent_accountParentRemove {
  __typename: "AccountParentRemovePayload";
  /**
   * The child account that had its parent relationship removed.
   */
  account: RemoveAccountParent_accountParentRemove_account;
  /**
   * The parent account that was removed from the child account.
   */
  parentAccount: RemoveAccountParent_accountParentRemove_parentAccount;
}

export interface RemoveAccountParent {
  /**
   * Delete a parent/child relationship between existing accounts.
   */
  accountParentRemove: RemoveAccountParent_accountParentRemove;
}

export interface RemoveAccountParentVariables {
  input: AccountParentRemoveInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetAccountParent
// ====================================================

export interface SetAccountParent_accountParentSet_account_parentAccount_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface SetAccountParent_accountParentSet_account_parentAccount_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface SetAccountParent_accountParentSet_account_parentAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The type assigned to this account
   */
  accountType: SetAccountParent_accountParentSet_account_parentAccount_accountType;
  /**
   * Convenience way to get the region display for an account
   */
  primaryAddressRegion: string | null;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The primary contact for this account
   */
  primaryContact: SetAccountParent_accountParentSet_account_parentAccount_primaryContact | null;
}

export interface SetAccountParent_accountParentSet_account_childAccounts_edges_node_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface SetAccountParent_accountParentSet_account_childAccounts_edges_node_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface SetAccountParent_accountParentSet_account_childAccounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The type assigned to this account
   */
  accountType: SetAccountParent_accountParentSet_account_childAccounts_edges_node_accountType;
  /**
   * Convenience way to get the region display for an account
   */
  primaryAddressRegion: string | null;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The primary contact for this account
   */
  primaryContact: SetAccountParent_accountParentSet_account_childAccounts_edges_node_primaryContact | null;
}

export interface SetAccountParent_accountParentSet_account_childAccounts_edges {
  __typename: "AccountChildrenEdge";
  node: SetAccountParent_accountParentSet_account_childAccounts_edges_node;
}

export interface SetAccountParent_accountParentSet_account_childAccounts {
  __typename: "AccountChildrenConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: SetAccountParent_accountParentSet_account_childAccounts_edges[];
}

export interface SetAccountParent_accountParentSet_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The parent account of this account
   */
  parentAccount: SetAccountParent_accountParentSet_account_parentAccount | null;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to child Accounts.
   */
  childAccounts: SetAccountParent_accountParentSet_account_childAccounts;
}

export interface SetAccountParent_accountParentSet_parentAccount_parentAccount_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface SetAccountParent_accountParentSet_parentAccount_parentAccount_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface SetAccountParent_accountParentSet_parentAccount_parentAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The type assigned to this account
   */
  accountType: SetAccountParent_accountParentSet_parentAccount_parentAccount_accountType;
  /**
   * Convenience way to get the region display for an account
   */
  primaryAddressRegion: string | null;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The primary contact for this account
   */
  primaryContact: SetAccountParent_accountParentSet_parentAccount_parentAccount_primaryContact | null;
}

export interface SetAccountParent_accountParentSet_parentAccount_childAccounts_edges_node_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface SetAccountParent_accountParentSet_parentAccount_childAccounts_edges_node_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface SetAccountParent_accountParentSet_parentAccount_childAccounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The type assigned to this account
   */
  accountType: SetAccountParent_accountParentSet_parentAccount_childAccounts_edges_node_accountType;
  /**
   * Convenience way to get the region display for an account
   */
  primaryAddressRegion: string | null;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The primary contact for this account
   */
  primaryContact: SetAccountParent_accountParentSet_parentAccount_childAccounts_edges_node_primaryContact | null;
}

export interface SetAccountParent_accountParentSet_parentAccount_childAccounts_edges {
  __typename: "AccountChildrenEdge";
  node: SetAccountParent_accountParentSet_parentAccount_childAccounts_edges_node;
}

export interface SetAccountParent_accountParentSet_parentAccount_childAccounts {
  __typename: "AccountChildrenConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: SetAccountParent_accountParentSet_parentAccount_childAccounts_edges[];
}

export interface SetAccountParent_accountParentSet_parentAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The parent account of this account
   */
  parentAccount: SetAccountParent_accountParentSet_parentAccount_parentAccount | null;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to child Accounts.
   */
  childAccounts: SetAccountParent_accountParentSet_parentAccount_childAccounts;
}

export interface SetAccountParent_accountParentSet {
  __typename: "AccountParentSetPayload";
  /**
   * Nutshell Account identifier
   */
  account: SetAccountParent_accountParentSet_account;
  /**
   * Nutshell Account identifier
   */
  parentAccount: SetAccountParent_accountParentSet_parentAccount;
}

export interface SetAccountParent {
  /**
   * Creates a parent/child relationship between existing accounts.
   */
  accountParentSet: SetAccountParent_accountParentSet;
}

export interface SetAccountParentVariables {
  input: AccountParentSetInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountHierarchy
// ====================================================

export interface GetAccountHierarchy_account_parentAccount_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface GetAccountHierarchy_account_parentAccount_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetAccountHierarchy_account_parentAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The type assigned to this account
   */
  accountType: GetAccountHierarchy_account_parentAccount_accountType;
  /**
   * Convenience way to get the region display for an account
   */
  primaryAddressRegion: string | null;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The primary contact for this account
   */
  primaryContact: GetAccountHierarchy_account_parentAccount_primaryContact | null;
}

export interface GetAccountHierarchy_account_childAccounts_edges_node_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface GetAccountHierarchy_account_childAccounts_edges_node_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetAccountHierarchy_account_childAccounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The type assigned to this account
   */
  accountType: GetAccountHierarchy_account_childAccounts_edges_node_accountType;
  /**
   * Convenience way to get the region display for an account
   */
  primaryAddressRegion: string | null;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The primary contact for this account
   */
  primaryContact: GetAccountHierarchy_account_childAccounts_edges_node_primaryContact | null;
}

export interface GetAccountHierarchy_account_childAccounts_edges {
  __typename: "AccountChildrenEdge";
  node: GetAccountHierarchy_account_childAccounts_edges_node;
}

export interface GetAccountHierarchy_account_childAccounts {
  __typename: "AccountChildrenConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetAccountHierarchy_account_childAccounts_edges[];
}

export interface GetAccountHierarchy_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The parent account of this account
   */
  parentAccount: GetAccountHierarchy_account_parentAccount | null;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to child Accounts.
   */
  childAccounts: GetAccountHierarchy_account_childAccounts;
}

export interface GetAccountHierarchy {
  /**
   * Returns a Nutshell Account
   */
  account: GetAccountHierarchy_account | null;
}

export interface GetAccountHierarchyVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountEmailSequenceData
// ====================================================

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  id: string;
  name: string;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountEmailSequenceData_account_contacts_edges_node_emailAddresses_primary | null;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_dripProgressions_currentNode {
  __typename: "SmartSequenceNode";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_dripProgressions_campaign_startTrigger {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_dripProgressions_campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this goal. This is essentially just the stringified
   * version of the goal’s conditions, but because a goal can have multiple
   * conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_dripProgressions_campaign_from_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_dripProgressions_campaign_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: GetAccountEmailSequenceData_account_contacts_edges_node_dripProgressions_campaign_from_creatorUser | null;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_dripProgressions_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * When a lead is closed, should drip sequences stop?
   */
  isStopOnLeadClose: boolean;
  /**
   * The start trigger for the drip sequence
   */
  startTrigger: GetAccountEmailSequenceData_account_contacts_edges_node_dripProgressions_campaign_startTrigger | null;
  /**
   * The newly created Nutshell goal
   */
  goal: GetAccountEmailSequenceData_account_contacts_edges_node_dripProgressions_campaign_goal | null;
  /**
   * The address to send this edition from
   */
  from: GetAccountEmailSequenceData_account_contacts_edges_node_dripProgressions_campaign_from | null;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_dripProgressions_editions_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_dripProgressions_editions_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_dripProgressions_editions_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The URL that this edition links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  scheduledTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: GetAccountEmailSequenceData_account_contacts_edges_node_dripProgressions_editions_edition_emailTemplate | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: GetAccountEmailSequenceData_account_contacts_edges_node_dripProgressions_editions_edition_delay | null;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_dripProgressions_editions {
  __typename: "DripProgressionEdition";
  /**
   * Whether this edition has been sent
   */
  sent: boolean;
  /**
   * The edition
   */
  edition: GetAccountEmailSequenceData_account_contacts_edges_node_dripProgressions_editions_edition;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_dripProgressions {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * When this drip progression was created (when the contact entered the sequence)
   */
  createdTime: any;
  /**
   * When this progression stopped, or null if it is still active
   */
  stoppedTime: any | null;
  /**
   * Why this progression stopped, or null if it is still active
   */
  stoppedReason: DripProgressionStoppedReason | null;
  /**
   * The graph node this progression is currently on, if any. Null for legacy drip
   * progressions and for smart progressions without a current node.
   */
  currentNode: GetAccountEmailSequenceData_account_contacts_edges_node_dripProgressions_currentNode | null;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
  /**
   * Number of editions that have been sent so far for this progression. NOTE: This
   * can be inaccurate if editions are reordered or an edition is added to the
   * start of the drip after a progression has started. This is ok! We want this
   * number to represent the number of prior active editions, even if they aren’t always sent.
   */
  numEditionsSent: number;
  /**
   * The drip sequence for this drip progressions
   */
  campaign: GetAccountEmailSequenceData_account_contacts_edges_node_dripProgressions_campaign;
  /**
   * All editions in the drip sequence for this drip progression, in send order
   */
  editions: GetAccountEmailSequenceData_account_contacts_edges_node_dripProgressions_editions[];
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_sender_sendableEmailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_sender {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * List of successfully enabled user email addresses that a user is able to send emails from Nutshell with.
   */
  sendableEmailAddresses: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_sender_sendableEmailAddresses[];
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_companyName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_firstName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_lastName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_lead_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  name: string;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_lead_contacts_primaryEdge_node;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_lead_contacts_primaryEdge | null;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_lead_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_lead_contacts;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailAutomation_exitsStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailAutomation_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailAutomation_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailAutomation_entersStage;
  /**
   * The stage in which this stage subscription ends.
   */
  exitsStage: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailAutomation_exitsStage | null;
  /**
   * Indicates if a lead should receive emails from this subscription until it closes.
   */
  sendUntilClose: boolean;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailAutomation_delay | null;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailAutomation_emailList | null;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailSequence_emailsQueued_fromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailSequence_emailsQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailSequence_emailsQueued_to {
  __typename: "NutEmailAddress";
  avatarEntity: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailSequence_emailsQueued_to_avatarEntity | null;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The current status of this queued email.
   */
  status: EmailQueuedStatus;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  fromUser: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailSequence_emailsQueued_fromUser | null;
  to: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailSequence_emailsQueued_to[];
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The next message to be sent
   */
  nextUnsentEmail: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailSequence_nextUnsentEmail | null;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  /**
   * The number of emails that have been sent
   */
  sentEmailsCount: number;
  emailsQueued: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailSequence_emailsQueued[];
  emailSequenceTemplate: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailSequence_emailSequenceTemplate | null;
  /**
   * True if this sequence has only one email
   */
  isSingleEmailSequence: boolean;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses {
  __typename: "EmailAutomationStatus";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that either did send this automation, or current _would_ send this
   * automation given the current context. For example, if the user is assigned to
   * a team, the logged in user is considered a potential sender if they’re on that team
   */
  sender: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_sender | null;
  /**
   * The total number of messages in the sequence for this status
   */
  unsentMessageCount: number | null;
  /**
   * Is this automation status paused?
   */
  isPaused: boolean;
  /**
   * Can this status be started
   */
  canStart: boolean;
  /**
   * Can this status be cancelled
   */
  canCancel: boolean;
  /**
   * The message to show to the user
   */
  status: EmailAutomationStatusStatus;
  /**
   * Status of the company name field
   */
  companyName: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_companyName;
  /**
   * Status of the first name field
   */
  firstName: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_firstName;
  /**
   * Status of the last name field
   */
  lastName: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_lastName;
  /**
   * Lead associated with this status row
   */
  lead: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_lead;
  /**
   * Email list stage subscription associated with this status row
   */
  emailAutomation: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailAutomation;
  /**
   * The actual email sequence going out for this lead in this stage
   */
  emailSequence: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses_emailSequence | null;
}

export interface GetAccountEmailSequenceData_account_contacts_edges_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetAccountEmailSequenceData_account_contacts_edges_node_emailAddresses;
  /**
   * List of drip progressions for this contact. By default only active
   * progressions on non-cancelled campaigns are returned. Soft-deleted
   * progressions are always excluded.
   */
  dripProgressions: GetAccountEmailSequenceData_account_contacts_edges_node_dripProgressions[];
  /**
   * Automation statuses from leads where this contact is the primary contact
   */
  emailAutomationStatuses: GetAccountEmailSequenceData_account_contacts_edges_node_emailAutomationStatuses[];
}

export interface GetAccountEmailSequenceData_account_contacts_edges {
  __typename: "AccountContactsEdge";
  node: GetAccountEmailSequenceData_account_contacts_edges_node;
}

export interface GetAccountEmailSequenceData_account_contacts {
  __typename: "AccountContactsConnection";
  /**
   * A list of edges.
   */
  edges: GetAccountEmailSequenceData_account_contacts_edges[];
}

export interface GetAccountEmailSequenceData_account_queuedEmails_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
}

export interface GetAccountEmailSequenceData_account_queuedEmails_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetAccountEmailSequenceData_account_queuedEmails_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The next message to be sent
   */
  nextUnsentEmail: GetAccountEmailSequenceData_account_queuedEmails_emailSequence_nextUnsentEmail | null;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  /**
   * The number of emails that have been sent
   */
  sentEmailsCount: number;
  emailSequenceTemplate: GetAccountEmailSequenceData_account_queuedEmails_emailSequence_emailSequenceTemplate | null;
  /**
   * True if this sequence has only one email
   */
  isSingleEmailSequence: boolean;
}

export interface GetAccountEmailSequenceData_account_queuedEmails_fromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetAccountEmailSequenceData_account_queuedEmails_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetAccountEmailSequenceData_account_queuedEmails_to {
  __typename: "NutEmailAddress";
  avatarEntity: GetAccountEmailSequenceData_account_queuedEmails_to_avatarEntity | null;
}

export interface GetAccountEmailSequenceData_account_queuedEmails {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent email sequence of this queued email.
   */
  emailSequence: GetAccountEmailSequenceData_account_queuedEmails_emailSequence | null;
  /**
   * The current status of this queued email.
   */
  status: EmailQueuedStatus;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  fromUser: GetAccountEmailSequenceData_account_queuedEmails_fromUser | null;
  to: GetAccountEmailSequenceData_account_queuedEmails_to[];
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
}

export interface GetAccountEmailSequenceData_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to
   * Nutshell Contacts. This allows you to see and query all of the contacts that
   * are related in someway (e.g., they work for) this account. For further
   * reading, see [this blog post explaining GraphQL connection types](https: // dev-blog.apollodata.com/explaining-graphql-connections-c48b7c3d6976).
   */
  contacts: GetAccountEmailSequenceData_account_contacts;
  /**
   * Emails queued to be sent to this accounts primary contact
   */
  queuedEmails: GetAccountEmailSequenceData_account_queuedEmails[];
}

export interface GetAccountEmailSequenceData {
  /**
   * Returns a Nutshell Account
   */
  account: GetAccountEmailSequenceData_account | null;
}

export interface GetAccountEmailSequenceDataVariables {
  accountId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateRelatedContact
// ====================================================

export interface UpdateRelatedContact_contactUpdate_contact_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface UpdateRelatedContact_contactUpdate_contact_phones_primary {
  __typename: "Phone";
  value: UpdateRelatedContact_contactUpdate_contact_phones_primary_value;
}

export interface UpdateRelatedContact_contactUpdate_contact_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: UpdateRelatedContact_contactUpdate_contact_phones_primary | null;
}

export interface UpdateRelatedContact_contactUpdate_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: UpdateRelatedContact_contactUpdate_contact_phones;
}

export interface UpdateRelatedContact_contactUpdate {
  __typename: "ContactUpdatePayload";
  /**
   * The updated Nutshell contact.
   */
  contact: UpdateRelatedContact_contactUpdate_contact;
}

export interface UpdateRelatedContact {
  /**
   * Updates a Nutshell contact.
   */
  contactUpdate: UpdateRelatedContact_contactUpdate;
}

export interface UpdateRelatedContactVariables {
  input: ContactUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRelatedContacts
// ====================================================

export interface GetRelatedContacts_account_contacts_pageInfo {
  __typename: "PageInfo";
  hasNextPage: boolean;
  endCursor: string | null;
}

export interface GetRelatedContacts_account_contacts_primary {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetRelatedContacts_account_contacts_edges_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetRelatedContacts_account_contacts_edges_node_phones_primary {
  __typename: "Phone";
  value: GetRelatedContacts_account_contacts_edges_node_phones_primary_value;
}

export interface GetRelatedContacts_account_contacts_edges_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetRelatedContacts_account_contacts_edges_node_phones_primary | null;
}

export interface GetRelatedContacts_account_contacts_edges_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetRelatedContacts_account_contacts_edges_node_phones;
}

export interface GetRelatedContacts_account_contacts_edges {
  __typename: "AccountContactsEdge";
  node: GetRelatedContacts_account_contacts_edges_node;
  /**
   * Whether this contact is no longer associated with this account.
   */
  isFormer: boolean;
  /**
   * The one-off short note that users can write on this contact->account relationship.
   */
  relationshipNote: string | null;
}

export interface GetRelatedContacts_account_contacts {
  __typename: "AccountContactsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetRelatedContacts_account_contacts_pageInfo;
  /**
   * Primary account for this contact
   */
  primary: GetRelatedContacts_account_contacts_primary | null;
  /**
   * A list of edges.
   */
  edges: GetRelatedContacts_account_contacts_edges[];
}

export interface GetRelatedContacts_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to
   * Nutshell Contacts. This allows you to see and query all of the contacts that
   * are related in someway (e.g., they work for) this account. For further
   * reading, see [this blog post explaining GraphQL connection types](https: // dev-blog.apollodata.com/explaining-graphql-connections-c48b7c3d6976).
   */
  contacts: GetRelatedContacts_account_contacts;
}

export interface GetRelatedContacts {
  /**
   * Returns a Nutshell Account
   */
  account: GetRelatedContacts_account | null;
}

export interface GetRelatedContactsVariables {
  id: string;
  first?: number | null;
  after?: string | null;
  formerOnly?: boolean | null;
  search?: string | null;
  sortBy?: PeepRelatedPeepSortType | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AccountsMarkNotDupe
// ====================================================

export interface AccountsMarkNotDupe_accountsMarkNotDupe {
  __typename: "AccountsMarkNotDupePayload";
  success: boolean;
}

export interface AccountsMarkNotDupe {
  accountsMarkNotDupe: AccountsMarkNotDupe_accountsMarkNotDupe;
}

export interface AccountsMarkNotDupeVariables {
  input: AccountsMarkNotDupeInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AccountsMerge
// ====================================================

export interface AccountsMerge_accountsMerge_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface AccountsMerge_accountsMerge {
  __typename: "AccountsMergePayload";
  account: AccountsMerge_accountsMerge_account;
}

export interface AccountsMerge {
  /**
   * Merges the specified accounts into the primary account
   */
  accountsMerge: AccountsMerge_accountsMerge;
}

export interface AccountsMergeVariables {
  input: AccountsMergeInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountDuplicateDetails
// ====================================================

export interface GetAccountDuplicateDetails_account_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetAccountDuplicateDetails_account_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The full printable address of this location
   */
  fullPrintableAddress: string | null;
}

export interface GetAccountDuplicateDetails_account_postalAddresses_primary {
  __typename: "PostalAddress";
  id: string;
  location: GetAccountDuplicateDetails_account_postalAddresses_primary_location;
}

export interface GetAccountDuplicateDetails_account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountDuplicateDetails_account_postalAddresses_primary | null;
}

export interface GetAccountDuplicateDetails_account_industry {
  __typename: "NutshellIndustry";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human description of the industry
   */
  name: string | null;
}

export interface GetAccountDuplicateDetails_account_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface GetAccountDuplicateDetails_account_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetAccountDuplicateDetails_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The primary email address for this account
   */
  primaryEmailAddress: string | null;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: GetAccountDuplicateDetails_account_owner | null;
  /**
   * The time this peep was last modified.
   */
  modifiedTime: any | null;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetAccountDuplicateDetails_account_postalAddresses;
  /**
   * The industry of this account
   */
  industry: GetAccountDuplicateDetails_account_industry | null;
  /**
   * The type assigned to this account
   */
  accountType: GetAccountDuplicateDetails_account_accountType;
  /**
   * The primary contact for this account
   */
  primaryContact: GetAccountDuplicateDetails_account_primaryContact | null;
}

export interface GetAccountDuplicateDetails {
  /**
   * Returns a Nutshell Account
   */
  account: GetAccountDuplicateDetails_account | null;
}

export interface GetAccountDuplicateDetailsVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountDuplicateGroups
// ====================================================

export interface GetAccountDuplicateGroups_accountDuplicateGroups_edges_node_accounts_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetAccountDuplicateGroups_accountDuplicateGroups_edges_node_accounts_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The full printable address of this location
   */
  fullPrintableAddress: string | null;
}

export interface GetAccountDuplicateGroups_accountDuplicateGroups_edges_node_accounts_postalAddresses_primary {
  __typename: "PostalAddress";
  id: string;
  location: GetAccountDuplicateGroups_accountDuplicateGroups_edges_node_accounts_postalAddresses_primary_location;
}

export interface GetAccountDuplicateGroups_accountDuplicateGroups_edges_node_accounts_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountDuplicateGroups_accountDuplicateGroups_edges_node_accounts_postalAddresses_primary | null;
}

export interface GetAccountDuplicateGroups_accountDuplicateGroups_edges_node_accounts_industry {
  __typename: "NutshellIndustry";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human description of the industry
   */
  name: string | null;
}

export interface GetAccountDuplicateGroups_accountDuplicateGroups_edges_node_accounts_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface GetAccountDuplicateGroups_accountDuplicateGroups_edges_node_accounts_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetAccountDuplicateGroups_accountDuplicateGroups_edges_node_accounts {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The primary email address for this account
   */
  primaryEmailAddress: string | null;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: GetAccountDuplicateGroups_accountDuplicateGroups_edges_node_accounts_owner | null;
  /**
   * The time this peep was last modified.
   */
  modifiedTime: any | null;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetAccountDuplicateGroups_accountDuplicateGroups_edges_node_accounts_postalAddresses;
  /**
   * The industry of this account
   */
  industry: GetAccountDuplicateGroups_accountDuplicateGroups_edges_node_accounts_industry | null;
  /**
   * The type assigned to this account
   */
  accountType: GetAccountDuplicateGroups_accountDuplicateGroups_edges_node_accounts_accountType;
  /**
   * The primary contact for this account
   */
  primaryContact: GetAccountDuplicateGroups_accountDuplicateGroups_edges_node_accounts_primaryContact | null;
}

export interface GetAccountDuplicateGroups_accountDuplicateGroups_edges_node {
  __typename: "AccountDuplicateGroup";
  id: string;
  groupingKeys: PeepDuplicateGroupingKey[];
  companyName: string | null;
  emailAddress: string | null;
  phoneNumber: string | null;
  count: number;
  accounts: GetAccountDuplicateGroups_accountDuplicateGroups_edges_node_accounts[];
}

export interface GetAccountDuplicateGroups_accountDuplicateGroups_edges {
  __typename: "AccountDuplicateGroupEdge";
  cursor: string;
  node: GetAccountDuplicateGroups_accountDuplicateGroups_edges_node;
}

export interface GetAccountDuplicateGroups_accountDuplicateGroups {
  __typename: "AccountDuplicateGroupsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Sum of accounts across all post-prune duplicate groups for the requested
   * grouping (each account once per group, account_non_dupes pairs removed). Same
   * pruning as edges; matches the sum of edge `count` values once paginated
   * through every page.
   */
  duplicateAccountCount: number;
  /**
   * A list of edges.
   */
  edges: GetAccountDuplicateGroups_accountDuplicateGroups_edges[];
}

export interface GetAccountDuplicateGroups {
  /**
   * Groups of accounts that match on all selected duplicate keys. Computed in real
   * time from MySQL with a per-request MEMORY temp table over every non-deleted
   * account (no Solr/index involvement, no list-filter scoping).
   */
  accountDuplicateGroups: GetAccountDuplicateGroups_accountDuplicateGroups;
}

export interface GetAccountDuplicateGroupsVariables {
  groupBy: PeepDuplicateGroupingKey[];
  first?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountDuplicateStatus
// ====================================================

export interface GetAccountDuplicateStatus_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this peep has duplicates
   */
  hasDuplicates: boolean;
}

export interface GetAccountDuplicateStatus {
  /**
   * Returns a Nutshell Account
   */
  account: GetAccountDuplicateStatus_account | null;
}

export interface GetAccountDuplicateStatusVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountDuplicateStatuses
// ====================================================

export interface GetAccountDuplicateStatuses_accounts {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this peep has duplicates
   */
  hasDuplicates: boolean;
}

export interface GetAccountDuplicateStatuses {
  /**
   * Returns a list of Nutshell Accounts
   */
  accounts: (GetAccountDuplicateStatuses_accounts | null)[] | null;
}

export interface GetAccountDuplicateStatusesVariables {
  ids: string[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountDuplicates
// ====================================================

export interface GetAccountDuplicates_accountDuplicates_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetAccountDuplicates_accountDuplicates_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The full printable address of this location
   */
  fullPrintableAddress: string | null;
}

export interface GetAccountDuplicates_accountDuplicates_postalAddresses_primary {
  __typename: "PostalAddress";
  id: string;
  location: GetAccountDuplicates_accountDuplicates_postalAddresses_primary_location;
}

export interface GetAccountDuplicates_accountDuplicates_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountDuplicates_accountDuplicates_postalAddresses_primary | null;
}

export interface GetAccountDuplicates_accountDuplicates_industry {
  __typename: "NutshellIndustry";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human description of the industry
   */
  name: string | null;
}

export interface GetAccountDuplicates_accountDuplicates_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface GetAccountDuplicates_accountDuplicates_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetAccountDuplicates_accountDuplicates {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The primary email address for this account
   */
  primaryEmailAddress: string | null;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: GetAccountDuplicates_accountDuplicates_owner | null;
  /**
   * The time this peep was last modified.
   */
  modifiedTime: any | null;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetAccountDuplicates_accountDuplicates_postalAddresses;
  /**
   * The industry of this account
   */
  industry: GetAccountDuplicates_accountDuplicates_industry | null;
  /**
   * The type assigned to this account
   */
  accountType: GetAccountDuplicates_accountDuplicates_accountType;
  /**
   * The primary contact for this account
   */
  primaryContact: GetAccountDuplicates_accountDuplicates_primaryContact | null;
}

export interface GetAccountDuplicates {
  accountDuplicates: GetAccountDuplicates_accountDuplicates[];
}

export interface GetAccountDuplicatesVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountsBulkMergeStatus
// ====================================================

export interface GetAccountsBulkMergeStatus_bulkEdits_edges_node_config {
  __typename: "BulkEditConfig";
  numDuplicates: number;
}

export interface GetAccountsBulkMergeStatus_bulkEdits_edges_node {
  __typename: "BulkEdit";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  progress: number;
  /**
   * The status of the bulk edit
   */
  status: BulkEditStatus;
  config: GetAccountsBulkMergeStatus_bulkEdits_edges_node_config | null;
}

export interface GetAccountsBulkMergeStatus_bulkEdits_edges {
  __typename: "BulkEditsEdge";
  node: GetAccountsBulkMergeStatus_bulkEdits_edges_node;
}

export interface GetAccountsBulkMergeStatus_bulkEdits {
  __typename: "BulkEditsConnection";
  /**
   * A list of edges.
   */
  edges: GetAccountsBulkMergeStatus_bulkEdits_edges[];
}

export interface GetAccountsBulkMergeStatus {
  bulkEdits: GetAccountsBulkMergeStatus_bulkEdits | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: HardDeleteAccount
// ====================================================

export interface HardDeleteAccount_accountHardDelete {
  __typename: "AccountHardDeletePayload";
  success: boolean;
}

export interface HardDeleteAccount {
  /**
   * Permanently deletes a soft-deleted account.
   */
  accountHardDelete: HardDeleteAccount_accountHardDelete;
}

export interface HardDeleteAccountVariables {
  accountId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateAccountCustomFieldValue
// ====================================================

export interface UpdateAccountCustomFieldValue_accountUpdate_account_revenue_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface UpdateAccountCustomFieldValue_accountUpdate_account_revenue {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: UpdateAccountCustomFieldValue_accountUpdate_account_revenue_currencyValue;
}

export interface UpdateAccountCustomFieldValue_accountUpdate_account_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface UpdateAccountCustomFieldValue_accountUpdate_account_industry {
  __typename: "NutshellIndustry";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human description of the industry
   */
  name: string | null;
}

export interface UpdateAccountCustomFieldValue_accountUpdate_account_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface UpdateAccountCustomFieldValue_accountUpdate_account_parentAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface UpdateAccountCustomFieldValue_accountUpdate_account_childAccounts {
  __typename: "AccountChildrenConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface UpdateAccountCustomFieldValue_accountUpdate_account_creatorUser_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface UpdateAccountCustomFieldValue_accountUpdate_account_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  firstName: string | null;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
  teams: UpdateAccountCustomFieldValue_accountUpdate_account_creatorUser_teams[];
}

export interface UpdateAccountCustomFieldValue_accountUpdate_account_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateAccountCustomFieldValue_accountUpdate_account_workspaceWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface UpdateAccountCustomFieldValue_accountUpdate_account_sidebarWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface UpdateAccountCustomFieldValue_accountUpdate_account_headerFields {
  __typename: "HeaderField";
  /**
   * The type of the header field
   */
  type: HeaderFieldType;
  /**
   * Whether the header field is enabled
   */
  isEnabled: boolean;
  /**
   * The name of the header field
   */
  name: string;
}

export interface UpdateAccountCustomFieldValue_accountUpdate_account_postalAddresses_primary_location_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface UpdateAccountCustomFieldValue_accountUpdate_account_postalAddresses_primary_location_weather {
  __typename: "Weather";
  temperature: string | null;
  condition: string | null;
  location: string | null;
  localTime: string | null;
}

export interface UpdateAccountCustomFieldValue_accountUpdate_account_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
  coordinates: UpdateAccountCustomFieldValue_accountUpdate_account_postalAddresses_primary_location_coordinates | null;
  weather: UpdateAccountCustomFieldValue_accountUpdate_account_postalAddresses_primary_location_weather | null;
}

export interface UpdateAccountCustomFieldValue_accountUpdate_account_postalAddresses_primary {
  __typename: "PostalAddress";
  location: UpdateAccountCustomFieldValue_accountUpdate_account_postalAddresses_primary_location;
}

export interface UpdateAccountCustomFieldValue_accountUpdate_account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: UpdateAccountCustomFieldValue_accountUpdate_account_postalAddresses_primary | null;
}

export interface UpdateAccountCustomFieldValue_accountUpdate_account_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateAccountCustomFieldValue_accountUpdate_account_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: UpdateAccountCustomFieldValue_accountUpdate_account_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface UpdateAccountCustomFieldValue_accountUpdate_account_tagMaps_edges {
  __typename: "TagMapsEdge";
  node: UpdateAccountCustomFieldValue_accountUpdate_account_tagMaps_edges_node | null;
}

export interface UpdateAccountCustomFieldValue_accountUpdate_account_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * A list of edges.
   */
  edges: UpdateAccountCustomFieldValue_accountUpdate_account_tagMaps_edges[];
}

export interface UpdateAccountCustomFieldValue_accountUpdate_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this entity deleted
   */
  isDeleted: boolean;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  avatarUrl: string;
  hasUploadedAvatar: boolean;
  canDeleteAvatar: boolean;
  /**
   * The number of people employed by this company
   */
  employeeCount: string | null;
  revenue: UpdateAccountCustomFieldValue_accountUpdate_account_revenue | null;
  /**
   * The terrority to which this peep is assigned.
   */
  territory: UpdateAccountCustomFieldValue_accountUpdate_account_territory | null;
  /**
   * The industry of this account
   */
  industry: UpdateAccountCustomFieldValue_accountUpdate_account_industry | null;
  /**
   * The type assigned to this account
   */
  accountType: UpdateAccountCustomFieldValue_accountUpdate_account_accountType;
  /**
   * The parent account of this account
   */
  parentAccount: UpdateAccountCustomFieldValue_accountUpdate_account_parentAccount | null;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to child Accounts.
   */
  childAccounts: UpdateAccountCustomFieldValue_accountUpdate_account_childAccounts;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The user who created this peep.
   */
  creatorUser: UpdateAccountCustomFieldValue_accountUpdate_account_creatorUser | null;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: UpdateAccountCustomFieldValue_accountUpdate_account_owner | null;
  /**
   * The widgets of the stageset lead workspace
   */
  workspaceWidgets: UpdateAccountCustomFieldValue_accountUpdate_account_workspaceWidgets[];
  /**
   * The widgets of the stageset lead sidebar
   */
  sidebarWidgets: UpdateAccountCustomFieldValue_accountUpdate_account_sidebarWidgets[];
  /**
   * The header fields for the entity type
   */
  headerFields: UpdateAccountCustomFieldValue_accountUpdate_account_headerFields[];
  /**
   * The postal addresses of the peep
   */
  postalAddresses: UpdateAccountCustomFieldValue_accountUpdate_account_postalAddresses;
  /**
   * Tag maps for the peep
   */
  tagMaps: UpdateAccountCustomFieldValue_accountUpdate_account_tagMaps | null;
}

export interface UpdateAccountCustomFieldValue_accountUpdate {
  __typename: "AccountUpdatePayload";
  /**
   * The updated Nutshell Account
   */
  account: UpdateAccountCustomFieldValue_accountUpdate_account;
}

export interface UpdateAccountCustomFieldValue {
  /**
   * Updates an account
   */
  accountUpdate: UpdateAccountCustomFieldValue_accountUpdate;
}

export interface UpdateAccountCustomFieldValueVariables {
  input: AccountUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateAccount
// ====================================================

export interface UpdateAccount_accountUpdate_account_revenue_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface UpdateAccount_accountUpdate_account_revenue {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: UpdateAccount_accountUpdate_account_revenue_currencyValue;
}

export interface UpdateAccount_accountUpdate_account_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface UpdateAccount_accountUpdate_account_industry {
  __typename: "NutshellIndustry";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human description of the industry
   */
  name: string | null;
}

export interface UpdateAccount_accountUpdate_account_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface UpdateAccount_accountUpdate_account_parentAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface UpdateAccount_accountUpdate_account_childAccounts {
  __typename: "AccountChildrenConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface UpdateAccount_accountUpdate_account_creatorUser_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface UpdateAccount_accountUpdate_account_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  firstName: string | null;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
  teams: UpdateAccount_accountUpdate_account_creatorUser_teams[];
}

export interface UpdateAccount_accountUpdate_account_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateAccount_accountUpdate_account_workspaceWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface UpdateAccount_accountUpdate_account_sidebarWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface UpdateAccount_accountUpdate_account_headerFields {
  __typename: "HeaderField";
  /**
   * The type of the header field
   */
  type: HeaderFieldType;
  /**
   * Whether the header field is enabled
   */
  isEnabled: boolean;
  /**
   * The name of the header field
   */
  name: string;
}

export interface UpdateAccount_accountUpdate_account_postalAddresses_primary_location_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface UpdateAccount_accountUpdate_account_postalAddresses_primary_location_weather {
  __typename: "Weather";
  temperature: string | null;
  condition: string | null;
  location: string | null;
  localTime: string | null;
}

export interface UpdateAccount_accountUpdate_account_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
  coordinates: UpdateAccount_accountUpdate_account_postalAddresses_primary_location_coordinates | null;
  weather: UpdateAccount_accountUpdate_account_postalAddresses_primary_location_weather | null;
}

export interface UpdateAccount_accountUpdate_account_postalAddresses_primary {
  __typename: "PostalAddress";
  location: UpdateAccount_accountUpdate_account_postalAddresses_primary_location;
}

export interface UpdateAccount_accountUpdate_account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: UpdateAccount_accountUpdate_account_postalAddresses_primary | null;
}

export interface UpdateAccount_accountUpdate_account_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateAccount_accountUpdate_account_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: UpdateAccount_accountUpdate_account_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface UpdateAccount_accountUpdate_account_tagMaps_edges {
  __typename: "TagMapsEdge";
  node: UpdateAccount_accountUpdate_account_tagMaps_edges_node | null;
}

export interface UpdateAccount_accountUpdate_account_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * A list of edges.
   */
  edges: UpdateAccount_accountUpdate_account_tagMaps_edges[];
}

export interface UpdateAccount_accountUpdate_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this entity deleted
   */
  isDeleted: boolean;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  avatarUrl: string;
  hasUploadedAvatar: boolean;
  canDeleteAvatar: boolean;
  /**
   * The number of people employed by this company
   */
  employeeCount: string | null;
  revenue: UpdateAccount_accountUpdate_account_revenue | null;
  /**
   * The terrority to which this peep is assigned.
   */
  territory: UpdateAccount_accountUpdate_account_territory | null;
  /**
   * The industry of this account
   */
  industry: UpdateAccount_accountUpdate_account_industry | null;
  /**
   * The type assigned to this account
   */
  accountType: UpdateAccount_accountUpdate_account_accountType;
  /**
   * The parent account of this account
   */
  parentAccount: UpdateAccount_accountUpdate_account_parentAccount | null;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to child Accounts.
   */
  childAccounts: UpdateAccount_accountUpdate_account_childAccounts;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The user who created this peep.
   */
  creatorUser: UpdateAccount_accountUpdate_account_creatorUser | null;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: UpdateAccount_accountUpdate_account_owner | null;
  /**
   * The widgets of the stageset lead workspace
   */
  workspaceWidgets: UpdateAccount_accountUpdate_account_workspaceWidgets[];
  /**
   * The widgets of the stageset lead sidebar
   */
  sidebarWidgets: UpdateAccount_accountUpdate_account_sidebarWidgets[];
  /**
   * The header fields for the entity type
   */
  headerFields: UpdateAccount_accountUpdate_account_headerFields[];
  /**
   * The postal addresses of the peep
   */
  postalAddresses: UpdateAccount_accountUpdate_account_postalAddresses;
  /**
   * Tag maps for the peep
   */
  tagMaps: UpdateAccount_accountUpdate_account_tagMaps | null;
}

export interface UpdateAccount_accountUpdate {
  __typename: "AccountUpdatePayload";
  /**
   * The updated Nutshell Account
   */
  account: UpdateAccount_accountUpdate_account;
}

export interface UpdateAccount {
  /**
   * Updates an account
   */
  accountUpdate: UpdateAccount_accountUpdate;
}

export interface UpdateAccountVariables {
  input: AccountUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountLastContactedTime
// ====================================================

export interface GetAccountLastContactedTime_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The most recent date this entity was contacted by the active user
   */
  myLastContactedTime: any | null;
}

export interface GetAccountLastContactedTime {
  /**
   * Returns a Nutshell Account
   */
  account: GetAccountLastContactedTime_account | null;
}

export interface GetAccountLastContactedTimeVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountLocationData
// ====================================================

export interface GetAccountLocationData_account_postalAddresses_primary_location_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface GetAccountLocationData_account_postalAddresses_primary_location_weather {
  __typename: "Weather";
  temperature: string | null;
  condition: string | null;
  location: string | null;
  localTime: string | null;
}

export interface GetAccountLocationData_account_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
  coordinates: GetAccountLocationData_account_postalAddresses_primary_location_coordinates | null;
  weather: GetAccountLocationData_account_postalAddresses_primary_location_weather | null;
}

export interface GetAccountLocationData_account_postalAddresses_primary {
  __typename: "PostalAddress";
  location: GetAccountLocationData_account_postalAddresses_primary_location;
}

export interface GetAccountLocationData_account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountLocationData_account_postalAddresses_primary | null;
}

export interface GetAccountLocationData_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetAccountLocationData_account_postalAddresses;
}

export interface GetAccountLocationData {
  /**
   * Returns a Nutshell Account
   */
  account: GetAccountLocationData_account | null;
}

export interface GetAccountLocationDataVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccount
// ====================================================

export interface GetAccount_account_revenue_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface GetAccount_account_revenue {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: GetAccount_account_revenue_currencyValue;
}

export interface GetAccount_account_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface GetAccount_account_industry {
  __typename: "NutshellIndustry";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human description of the industry
   */
  name: string | null;
}

export interface GetAccount_account_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface GetAccount_account_parentAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetAccount_account_childAccounts {
  __typename: "AccountChildrenConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetAccount_account_creatorUser_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface GetAccount_account_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  firstName: string | null;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
  teams: GetAccount_account_creatorUser_teams[];
}

export interface GetAccount_account_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetAccount_account_workspaceWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface GetAccount_account_sidebarWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface GetAccount_account_headerFields {
  __typename: "HeaderField";
  /**
   * The type of the header field
   */
  type: HeaderFieldType;
  /**
   * Whether the header field is enabled
   */
  isEnabled: boolean;
  /**
   * The name of the header field
   */
  name: string;
}

export interface GetAccount_account_postalAddresses_primary_location_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface GetAccount_account_postalAddresses_primary_location_weather {
  __typename: "Weather";
  temperature: string | null;
  condition: string | null;
  location: string | null;
  localTime: string | null;
}

export interface GetAccount_account_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
  coordinates: GetAccount_account_postalAddresses_primary_location_coordinates | null;
  weather: GetAccount_account_postalAddresses_primary_location_weather | null;
}

export interface GetAccount_account_postalAddresses_primary {
  __typename: "PostalAddress";
  location: GetAccount_account_postalAddresses_primary_location;
}

export interface GetAccount_account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccount_account_postalAddresses_primary | null;
}

export interface GetAccount_account_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetAccount_account_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: GetAccount_account_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface GetAccount_account_tagMaps_edges {
  __typename: "TagMapsEdge";
  node: GetAccount_account_tagMaps_edges_node | null;
}

export interface GetAccount_account_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * A list of edges.
   */
  edges: GetAccount_account_tagMaps_edges[];
}

export interface GetAccount_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this entity deleted
   */
  isDeleted: boolean;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  avatarUrl: string;
  hasUploadedAvatar: boolean;
  canDeleteAvatar: boolean;
  /**
   * The number of people employed by this company
   */
  employeeCount: string | null;
  revenue: GetAccount_account_revenue | null;
  /**
   * The terrority to which this peep is assigned.
   */
  territory: GetAccount_account_territory | null;
  /**
   * The industry of this account
   */
  industry: GetAccount_account_industry | null;
  /**
   * The type assigned to this account
   */
  accountType: GetAccount_account_accountType;
  /**
   * The parent account of this account
   */
  parentAccount: GetAccount_account_parentAccount | null;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to child Accounts.
   */
  childAccounts: GetAccount_account_childAccounts;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The user who created this peep.
   */
  creatorUser: GetAccount_account_creatorUser | null;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: GetAccount_account_owner | null;
  /**
   * The widgets of the stageset lead workspace
   */
  workspaceWidgets: GetAccount_account_workspaceWidgets[];
  /**
   * The widgets of the stageset lead sidebar
   */
  sidebarWidgets: GetAccount_account_sidebarWidgets[];
  /**
   * The header fields for the entity type
   */
  headerFields: GetAccount_account_headerFields[];
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetAccount_account_postalAddresses;
  /**
   * Tag maps for the peep
   */
  tagMaps: GetAccount_account_tagMaps | null;
}

export interface GetAccount {
  /**
   * Returns a Nutshell Account
   */
  account: GetAccount_account | null;
}

export interface GetAccountVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddAccountParentRelationship
// ====================================================

export interface AddAccountParentRelationship_accountParentSet_account_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface AddAccountParentRelationship_accountParentSet_account_postalAddresses_primary {
  __typename: "PostalAddress";
  location: AddAccountParentRelationship_accountParentSet_account_postalAddresses_primary_location;
}

export interface AddAccountParentRelationship_accountParentSet_account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AddAccountParentRelationship_accountParentSet_account_postalAddresses_primary | null;
}

export interface AddAccountParentRelationship_accountParentSet_account_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface AddAccountParentRelationship_accountParentSet_account_phones_primary {
  __typename: "Phone";
  value: AddAccountParentRelationship_accountParentSet_account_phones_primary_value;
}

export interface AddAccountParentRelationship_accountParentSet_account_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AddAccountParentRelationship_accountParentSet_account_phones_primary | null;
}

export interface AddAccountParentRelationship_accountParentSet_account_parentAccount_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface AddAccountParentRelationship_accountParentSet_account_parentAccount_postalAddresses_primary {
  __typename: "PostalAddress";
  location: AddAccountParentRelationship_accountParentSet_account_parentAccount_postalAddresses_primary_location;
}

export interface AddAccountParentRelationship_accountParentSet_account_parentAccount_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AddAccountParentRelationship_accountParentSet_account_parentAccount_postalAddresses_primary | null;
}

export interface AddAccountParentRelationship_accountParentSet_account_parentAccount_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface AddAccountParentRelationship_accountParentSet_account_parentAccount_phones_primary {
  __typename: "Phone";
  value: AddAccountParentRelationship_accountParentSet_account_parentAccount_phones_primary_value;
}

export interface AddAccountParentRelationship_accountParentSet_account_parentAccount_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AddAccountParentRelationship_accountParentSet_account_parentAccount_phones_primary | null;
}

export interface AddAccountParentRelationship_accountParentSet_account_parentAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: AddAccountParentRelationship_accountParentSet_account_parentAccount_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: AddAccountParentRelationship_accountParentSet_account_parentAccount_phones;
}

export interface AddAccountParentRelationship_accountParentSet_account_childAccounts_edges_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface AddAccountParentRelationship_accountParentSet_account_childAccounts_edges_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: AddAccountParentRelationship_accountParentSet_account_childAccounts_edges_node_postalAddresses_primary_location;
}

export interface AddAccountParentRelationship_accountParentSet_account_childAccounts_edges_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AddAccountParentRelationship_accountParentSet_account_childAccounts_edges_node_postalAddresses_primary | null;
}

export interface AddAccountParentRelationship_accountParentSet_account_childAccounts_edges_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface AddAccountParentRelationship_accountParentSet_account_childAccounts_edges_node_phones_primary {
  __typename: "Phone";
  value: AddAccountParentRelationship_accountParentSet_account_childAccounts_edges_node_phones_primary_value;
}

export interface AddAccountParentRelationship_accountParentSet_account_childAccounts_edges_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AddAccountParentRelationship_accountParentSet_account_childAccounts_edges_node_phones_primary | null;
}

export interface AddAccountParentRelationship_accountParentSet_account_childAccounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: AddAccountParentRelationship_accountParentSet_account_childAccounts_edges_node_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: AddAccountParentRelationship_accountParentSet_account_childAccounts_edges_node_phones;
}

export interface AddAccountParentRelationship_accountParentSet_account_childAccounts_edges {
  __typename: "AccountChildrenEdge";
  node: AddAccountParentRelationship_accountParentSet_account_childAccounts_edges_node;
}

export interface AddAccountParentRelationship_accountParentSet_account_childAccounts {
  __typename: "AccountChildrenConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: AddAccountParentRelationship_accountParentSet_account_childAccounts_edges[];
}

export interface AddAccountParentRelationship_accountParentSet_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: AddAccountParentRelationship_accountParentSet_account_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: AddAccountParentRelationship_accountParentSet_account_phones;
  /**
   * The parent account of this account
   */
  parentAccount: AddAccountParentRelationship_accountParentSet_account_parentAccount | null;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to child Accounts.
   */
  childAccounts: AddAccountParentRelationship_accountParentSet_account_childAccounts;
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount_postalAddresses_primary {
  __typename: "PostalAddress";
  location: AddAccountParentRelationship_accountParentSet_parentAccount_postalAddresses_primary_location;
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AddAccountParentRelationship_accountParentSet_parentAccount_postalAddresses_primary | null;
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount_phones_primary {
  __typename: "Phone";
  value: AddAccountParentRelationship_accountParentSet_parentAccount_phones_primary_value;
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AddAccountParentRelationship_accountParentSet_parentAccount_phones_primary | null;
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount_parentAccount_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount_parentAccount_postalAddresses_primary {
  __typename: "PostalAddress";
  location: AddAccountParentRelationship_accountParentSet_parentAccount_parentAccount_postalAddresses_primary_location;
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount_parentAccount_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AddAccountParentRelationship_accountParentSet_parentAccount_parentAccount_postalAddresses_primary | null;
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount_parentAccount_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount_parentAccount_phones_primary {
  __typename: "Phone";
  value: AddAccountParentRelationship_accountParentSet_parentAccount_parentAccount_phones_primary_value;
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount_parentAccount_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AddAccountParentRelationship_accountParentSet_parentAccount_parentAccount_phones_primary | null;
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount_parentAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: AddAccountParentRelationship_accountParentSet_parentAccount_parentAccount_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: AddAccountParentRelationship_accountParentSet_parentAccount_parentAccount_phones;
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount_childAccounts_edges_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount_childAccounts_edges_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: AddAccountParentRelationship_accountParentSet_parentAccount_childAccounts_edges_node_postalAddresses_primary_location;
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount_childAccounts_edges_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AddAccountParentRelationship_accountParentSet_parentAccount_childAccounts_edges_node_postalAddresses_primary | null;
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount_childAccounts_edges_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount_childAccounts_edges_node_phones_primary {
  __typename: "Phone";
  value: AddAccountParentRelationship_accountParentSet_parentAccount_childAccounts_edges_node_phones_primary_value;
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount_childAccounts_edges_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AddAccountParentRelationship_accountParentSet_parentAccount_childAccounts_edges_node_phones_primary | null;
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount_childAccounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: AddAccountParentRelationship_accountParentSet_parentAccount_childAccounts_edges_node_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: AddAccountParentRelationship_accountParentSet_parentAccount_childAccounts_edges_node_phones;
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount_childAccounts_edges {
  __typename: "AccountChildrenEdge";
  node: AddAccountParentRelationship_accountParentSet_parentAccount_childAccounts_edges_node;
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount_childAccounts {
  __typename: "AccountChildrenConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: AddAccountParentRelationship_accountParentSet_parentAccount_childAccounts_edges[];
}

export interface AddAccountParentRelationship_accountParentSet_parentAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: AddAccountParentRelationship_accountParentSet_parentAccount_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: AddAccountParentRelationship_accountParentSet_parentAccount_phones;
  /**
   * The parent account of this account
   */
  parentAccount: AddAccountParentRelationship_accountParentSet_parentAccount_parentAccount | null;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to child Accounts.
   */
  childAccounts: AddAccountParentRelationship_accountParentSet_parentAccount_childAccounts;
}

export interface AddAccountParentRelationship_accountParentSet {
  __typename: "AccountParentSetPayload";
  /**
   * Nutshell Account identifier
   */
  account: AddAccountParentRelationship_accountParentSet_account;
  /**
   * Nutshell Account identifier
   */
  parentAccount: AddAccountParentRelationship_accountParentSet_parentAccount;
}

export interface AddAccountParentRelationship {
  /**
   * Creates a parent/child relationship between existing accounts.
   */
  accountParentSet: AddAccountParentRelationship_accountParentSet;
}

export interface AddAccountParentRelationshipVariables {
  input: AccountParentSetInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveAccountParentRelationship
// ====================================================

export interface RemoveAccountParentRelationship_accountParentRemove_account_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_account_postalAddresses_primary {
  __typename: "PostalAddress";
  location: RemoveAccountParentRelationship_accountParentRemove_account_postalAddresses_primary_location;
}

export interface RemoveAccountParentRelationship_accountParentRemove_account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveAccountParentRelationship_accountParentRemove_account_postalAddresses_primary | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_account_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_account_phones_primary {
  __typename: "Phone";
  value: RemoveAccountParentRelationship_accountParentRemove_account_phones_primary_value;
}

export interface RemoveAccountParentRelationship_accountParentRemove_account_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveAccountParentRelationship_accountParentRemove_account_phones_primary | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_account_parentAccount_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_account_parentAccount_postalAddresses_primary {
  __typename: "PostalAddress";
  location: RemoveAccountParentRelationship_accountParentRemove_account_parentAccount_postalAddresses_primary_location;
}

export interface RemoveAccountParentRelationship_accountParentRemove_account_parentAccount_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveAccountParentRelationship_accountParentRemove_account_parentAccount_postalAddresses_primary | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_account_parentAccount_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_account_parentAccount_phones_primary {
  __typename: "Phone";
  value: RemoveAccountParentRelationship_accountParentRemove_account_parentAccount_phones_primary_value;
}

export interface RemoveAccountParentRelationship_accountParentRemove_account_parentAccount_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveAccountParentRelationship_accountParentRemove_account_parentAccount_phones_primary | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_account_parentAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: RemoveAccountParentRelationship_accountParentRemove_account_parentAccount_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: RemoveAccountParentRelationship_accountParentRemove_account_parentAccount_phones;
}

export interface RemoveAccountParentRelationship_accountParentRemove_account_childAccounts_edges_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_account_childAccounts_edges_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: RemoveAccountParentRelationship_accountParentRemove_account_childAccounts_edges_node_postalAddresses_primary_location;
}

export interface RemoveAccountParentRelationship_accountParentRemove_account_childAccounts_edges_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveAccountParentRelationship_accountParentRemove_account_childAccounts_edges_node_postalAddresses_primary | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_account_childAccounts_edges_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_account_childAccounts_edges_node_phones_primary {
  __typename: "Phone";
  value: RemoveAccountParentRelationship_accountParentRemove_account_childAccounts_edges_node_phones_primary_value;
}

export interface RemoveAccountParentRelationship_accountParentRemove_account_childAccounts_edges_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveAccountParentRelationship_accountParentRemove_account_childAccounts_edges_node_phones_primary | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_account_childAccounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: RemoveAccountParentRelationship_accountParentRemove_account_childAccounts_edges_node_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: RemoveAccountParentRelationship_accountParentRemove_account_childAccounts_edges_node_phones;
}

export interface RemoveAccountParentRelationship_accountParentRemove_account_childAccounts_edges {
  __typename: "AccountChildrenEdge";
  node: RemoveAccountParentRelationship_accountParentRemove_account_childAccounts_edges_node;
}

export interface RemoveAccountParentRelationship_accountParentRemove_account_childAccounts {
  __typename: "AccountChildrenConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: RemoveAccountParentRelationship_accountParentRemove_account_childAccounts_edges[];
}

export interface RemoveAccountParentRelationship_accountParentRemove_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: RemoveAccountParentRelationship_accountParentRemove_account_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: RemoveAccountParentRelationship_accountParentRemove_account_phones;
  /**
   * The parent account of this account
   */
  parentAccount: RemoveAccountParentRelationship_accountParentRemove_account_parentAccount | null;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to child Accounts.
   */
  childAccounts: RemoveAccountParentRelationship_accountParentRemove_account_childAccounts;
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount_postalAddresses_primary {
  __typename: "PostalAddress";
  location: RemoveAccountParentRelationship_accountParentRemove_parentAccount_postalAddresses_primary_location;
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveAccountParentRelationship_accountParentRemove_parentAccount_postalAddresses_primary | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount_phones_primary {
  __typename: "Phone";
  value: RemoveAccountParentRelationship_accountParentRemove_parentAccount_phones_primary_value;
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveAccountParentRelationship_accountParentRemove_parentAccount_phones_primary | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount_parentAccount_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount_parentAccount_postalAddresses_primary {
  __typename: "PostalAddress";
  location: RemoveAccountParentRelationship_accountParentRemove_parentAccount_parentAccount_postalAddresses_primary_location;
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount_parentAccount_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveAccountParentRelationship_accountParentRemove_parentAccount_parentAccount_postalAddresses_primary | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount_parentAccount_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount_parentAccount_phones_primary {
  __typename: "Phone";
  value: RemoveAccountParentRelationship_accountParentRemove_parentAccount_parentAccount_phones_primary_value;
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount_parentAccount_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveAccountParentRelationship_accountParentRemove_parentAccount_parentAccount_phones_primary | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount_parentAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: RemoveAccountParentRelationship_accountParentRemove_parentAccount_parentAccount_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: RemoveAccountParentRelationship_accountParentRemove_parentAccount_parentAccount_phones;
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount_childAccounts_edges_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount_childAccounts_edges_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: RemoveAccountParentRelationship_accountParentRemove_parentAccount_childAccounts_edges_node_postalAddresses_primary_location;
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount_childAccounts_edges_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveAccountParentRelationship_accountParentRemove_parentAccount_childAccounts_edges_node_postalAddresses_primary | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount_childAccounts_edges_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount_childAccounts_edges_node_phones_primary {
  __typename: "Phone";
  value: RemoveAccountParentRelationship_accountParentRemove_parentAccount_childAccounts_edges_node_phones_primary_value;
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount_childAccounts_edges_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RemoveAccountParentRelationship_accountParentRemove_parentAccount_childAccounts_edges_node_phones_primary | null;
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount_childAccounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: RemoveAccountParentRelationship_accountParentRemove_parentAccount_childAccounts_edges_node_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: RemoveAccountParentRelationship_accountParentRemove_parentAccount_childAccounts_edges_node_phones;
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount_childAccounts_edges {
  __typename: "AccountChildrenEdge";
  node: RemoveAccountParentRelationship_accountParentRemove_parentAccount_childAccounts_edges_node;
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount_childAccounts {
  __typename: "AccountChildrenConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: RemoveAccountParentRelationship_accountParentRemove_parentAccount_childAccounts_edges[];
}

export interface RemoveAccountParentRelationship_accountParentRemove_parentAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: RemoveAccountParentRelationship_accountParentRemove_parentAccount_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: RemoveAccountParentRelationship_accountParentRemove_parentAccount_phones;
  /**
   * The parent account of this account
   */
  parentAccount: RemoveAccountParentRelationship_accountParentRemove_parentAccount_parentAccount | null;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to child Accounts.
   */
  childAccounts: RemoveAccountParentRelationship_accountParentRemove_parentAccount_childAccounts;
}

export interface RemoveAccountParentRelationship_accountParentRemove {
  __typename: "AccountParentRemovePayload";
  /**
   * The child account that had its parent relationship removed.
   */
  account: RemoveAccountParentRelationship_accountParentRemove_account;
  /**
   * The parent account that was removed from the child account.
   */
  parentAccount: RemoveAccountParentRelationship_accountParentRemove_parentAccount;
}

export interface RemoveAccountParentRelationship {
  /**
   * Delete a parent/child relationship between existing accounts.
   */
  accountParentRemove: RemoveAccountParentRelationship_accountParentRemove;
}

export interface RemoveAccountParentRelationshipVariables {
  input: AccountParentRemoveInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountHierarchyWidget
// ====================================================

export interface GetAccountHierarchyWidget_account_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface GetAccountHierarchyWidget_account_postalAddresses_primary {
  __typename: "PostalAddress";
  location: GetAccountHierarchyWidget_account_postalAddresses_primary_location;
}

export interface GetAccountHierarchyWidget_account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountHierarchyWidget_account_postalAddresses_primary | null;
}

export interface GetAccountHierarchyWidget_account_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetAccountHierarchyWidget_account_phones_primary {
  __typename: "Phone";
  value: GetAccountHierarchyWidget_account_phones_primary_value;
}

export interface GetAccountHierarchyWidget_account_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountHierarchyWidget_account_phones_primary | null;
}

export interface GetAccountHierarchyWidget_account_parentAccount_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface GetAccountHierarchyWidget_account_parentAccount_postalAddresses_primary {
  __typename: "PostalAddress";
  location: GetAccountHierarchyWidget_account_parentAccount_postalAddresses_primary_location;
}

export interface GetAccountHierarchyWidget_account_parentAccount_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountHierarchyWidget_account_parentAccount_postalAddresses_primary | null;
}

export interface GetAccountHierarchyWidget_account_parentAccount_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetAccountHierarchyWidget_account_parentAccount_phones_primary {
  __typename: "Phone";
  value: GetAccountHierarchyWidget_account_parentAccount_phones_primary_value;
}

export interface GetAccountHierarchyWidget_account_parentAccount_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountHierarchyWidget_account_parentAccount_phones_primary | null;
}

export interface GetAccountHierarchyWidget_account_parentAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetAccountHierarchyWidget_account_parentAccount_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetAccountHierarchyWidget_account_parentAccount_phones;
}

export interface GetAccountHierarchyWidget_account_childAccounts_edges_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface GetAccountHierarchyWidget_account_childAccounts_edges_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: GetAccountHierarchyWidget_account_childAccounts_edges_node_postalAddresses_primary_location;
}

export interface GetAccountHierarchyWidget_account_childAccounts_edges_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountHierarchyWidget_account_childAccounts_edges_node_postalAddresses_primary | null;
}

export interface GetAccountHierarchyWidget_account_childAccounts_edges_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetAccountHierarchyWidget_account_childAccounts_edges_node_phones_primary {
  __typename: "Phone";
  value: GetAccountHierarchyWidget_account_childAccounts_edges_node_phones_primary_value;
}

export interface GetAccountHierarchyWidget_account_childAccounts_edges_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountHierarchyWidget_account_childAccounts_edges_node_phones_primary | null;
}

export interface GetAccountHierarchyWidget_account_childAccounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetAccountHierarchyWidget_account_childAccounts_edges_node_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetAccountHierarchyWidget_account_childAccounts_edges_node_phones;
}

export interface GetAccountHierarchyWidget_account_childAccounts_edges {
  __typename: "AccountChildrenEdge";
  node: GetAccountHierarchyWidget_account_childAccounts_edges_node;
}

export interface GetAccountHierarchyWidget_account_childAccounts {
  __typename: "AccountChildrenConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetAccountHierarchyWidget_account_childAccounts_edges[];
}

export interface GetAccountHierarchyWidget_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetAccountHierarchyWidget_account_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetAccountHierarchyWidget_account_phones;
  /**
   * The parent account of this account
   */
  parentAccount: GetAccountHierarchyWidget_account_parentAccount | null;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to child Accounts.
   */
  childAccounts: GetAccountHierarchyWidget_account_childAccounts;
}

export interface GetAccountHierarchyWidget {
  /**
   * Returns a Nutshell Account
   */
  account: GetAccountHierarchyWidget_account | null;
}

export interface GetAccountHierarchyWidgetVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddAttachmentToAccount
// ====================================================

export interface AddAttachmentToAccount_accountFilesAdd_account_files_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface AddAttachmentToAccount_accountFilesAdd_account_files {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * The user who uploaded the file
   */
  creatorUser: AddAttachmentToAccount_accountFilesAdd_account_files_creatorUser | null;
}

export interface AddAttachmentToAccount_accountFilesAdd_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The files for this peep
   */
  files: AddAttachmentToAccount_accountFilesAdd_account_files[];
}

export interface AddAttachmentToAccount_accountFilesAdd {
  __typename: "AccountFileAddPayload";
  /**
   * The account that the file was added to
   */
  account: AddAttachmentToAccount_accountFilesAdd_account;
}

export interface AddAttachmentToAccount {
  /**
   * Add a file to an account
   */
  accountFilesAdd: AddAttachmentToAccount_accountFilesAdd;
}

export interface AddAttachmentToAccountVariables {
  input: AccountFileAddInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveAttachmentFromAccount
// ====================================================

export interface RemoveAttachmentFromAccount_accountFileRemove_account_files_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface RemoveAttachmentFromAccount_accountFileRemove_account_files {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * The user who uploaded the file
   */
  creatorUser: RemoveAttachmentFromAccount_accountFileRemove_account_files_creatorUser | null;
}

export interface RemoveAttachmentFromAccount_accountFileRemove_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The files for this peep
   */
  files: RemoveAttachmentFromAccount_accountFileRemove_account_files[];
}

export interface RemoveAttachmentFromAccount_accountFileRemove {
  __typename: "AccountFileRemovePayload";
  /**
   * The account that the file was removed from
   */
  account: RemoveAttachmentFromAccount_accountFileRemove_account;
}

export interface RemoveAttachmentFromAccount {
  /**
   * Remove a file from an account
   */
  accountFileRemove: RemoveAttachmentFromAccount_accountFileRemove;
}

export interface RemoveAttachmentFromAccountVariables {
  input: AccountFileRemoveInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAttachmentsForAccount
// ====================================================

export interface GetAttachmentsForAccount_account_files_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface GetAttachmentsForAccount_account_files {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * The user who uploaded the file
   */
  creatorUser: GetAttachmentsForAccount_account_files_creatorUser | null;
}

export interface GetAttachmentsForAccount_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The files for this peep
   */
  files: GetAttachmentsForAccount_account_files[];
}

export interface GetAttachmentsForAccount {
  /**
   * Returns a Nutshell Account
   */
  account: GetAttachmentsForAccount_account | null;
}

export interface GetAttachmentsForAccountVariables {
  accountId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateAccountLegacyId
// ====================================================

export interface UpdateAccountLegacyId_accountUpdate_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The legacy ID for this peep
   */
  legacyId: string | null;
  /**
   * Whether the legacy ID field should be shown for this peep
   */
  shouldShowLegacyId: boolean;
}

export interface UpdateAccountLegacyId_accountUpdate {
  __typename: "AccountUpdatePayload";
  /**
   * The updated Nutshell Account
   */
  account: UpdateAccountLegacyId_accountUpdate_account;
}

export interface UpdateAccountLegacyId {
  /**
   * Updates an account
   */
  accountUpdate: UpdateAccountLegacyId_accountUpdate;
}

export interface UpdateAccountLegacyIdVariables {
  input: AccountUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountLegacyId
// ====================================================

export interface GetAccountLegacyId_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The legacy ID for this peep
   */
  legacyId: string | null;
  /**
   * Whether the legacy ID field should be shown for this peep
   */
  shouldShowLegacyId: boolean;
}

export interface GetAccountLegacyId {
  /**
   * Returns a Nutshell Account
   */
  account: GetAccountLegacyId_account | null;
}

export interface GetAccountLegacyIdVariables {
  accountId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateAccountSummary
// ====================================================

export interface UpdateAccountSummary_accountUpdate_account_revenue_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface UpdateAccountSummary_accountUpdate_account_revenue {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: UpdateAccountSummary_accountUpdate_account_revenue_currencyValue;
}

export interface UpdateAccountSummary_accountUpdate_account_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface UpdateAccountSummary_accountUpdate_account_industry {
  __typename: "NutshellIndustry";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human description of the industry
   */
  name: string | null;
}

export interface UpdateAccountSummary_accountUpdate_account_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface UpdateAccountSummary_accountUpdate_account_creatorUser_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface UpdateAccountSummary_accountUpdate_account_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  firstName: string | null;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
  teams: UpdateAccountSummary_accountUpdate_account_creatorUser_teams[];
}

export interface UpdateAccountSummary_accountUpdate_account_mergedWith {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface UpdateAccountSummary_accountUpdate_account_origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  originType: OriginType;
  isInteresting: boolean;
  htmlUrl: string | null;
}

export interface UpdateAccountSummary_accountUpdate_account_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateAccountSummary_accountUpdate_account_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateAccountSummary_accountUpdate_account_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: UpdateAccountSummary_accountUpdate_account_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface UpdateAccountSummary_accountUpdate_account_tagMaps_edges {
  __typename: "TagMapsEdge";
  node: UpdateAccountSummary_accountUpdate_account_tagMaps_edges_node | null;
}

export interface UpdateAccountSummary_accountUpdate_account_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * A list of edges.
   */
  edges: UpdateAccountSummary_accountUpdate_account_tagMaps_edges[];
}

export interface UpdateAccountSummary_accountUpdate_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The number of people employed by this company
   */
  employeeCount: string | null;
  revenue: UpdateAccountSummary_accountUpdate_account_revenue | null;
  /**
   * The terrority to which this peep is assigned.
   */
  territory: UpdateAccountSummary_accountUpdate_account_territory | null;
  /**
   * The industry of this account
   */
  industry: UpdateAccountSummary_accountUpdate_account_industry | null;
  /**
   * The type assigned to this account
   */
  accountType: UpdateAccountSummary_accountUpdate_account_accountType;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The time this entity was deleted
   */
  deletedTime: any | null;
  /**
   * The user who created this peep.
   */
  creatorUser: UpdateAccountSummary_accountUpdate_account_creatorUser | null;
  /**
   * Entity this account was merged with
   */
  mergedWith: UpdateAccountSummary_accountUpdate_account_mergedWith | null;
  /**
   * The origin of the peep
   */
  origin: UpdateAccountSummary_accountUpdate_account_origin;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: UpdateAccountSummary_accountUpdate_account_owner | null;
  /**
   * Tag maps for the peep
   */
  tagMaps: UpdateAccountSummary_accountUpdate_account_tagMaps | null;
}

export interface UpdateAccountSummary_accountUpdate {
  __typename: "AccountUpdatePayload";
  /**
   * The updated Nutshell Account
   */
  account: UpdateAccountSummary_accountUpdate_account;
}

export interface UpdateAccountSummary {
  /**
   * Updates an account
   */
  accountUpdate: UpdateAccountSummary_accountUpdate;
}

export interface UpdateAccountSummaryVariables {
  input: AccountUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountSummary
// ====================================================

export interface GetAccountSummary_account_revenue_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface GetAccountSummary_account_revenue {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: GetAccountSummary_account_revenue_currencyValue;
}

export interface GetAccountSummary_account_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface GetAccountSummary_account_industry {
  __typename: "NutshellIndustry";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human description of the industry
   */
  name: string | null;
}

export interface GetAccountSummary_account_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface GetAccountSummary_account_creatorUser_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface GetAccountSummary_account_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  firstName: string | null;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
  teams: GetAccountSummary_account_creatorUser_teams[];
}

export interface GetAccountSummary_account_mergedWith {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetAccountSummary_account_origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  originType: OriginType;
  isInteresting: boolean;
  htmlUrl: string | null;
}

export interface GetAccountSummary_account_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetAccountSummary_account_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetAccountSummary_account_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: GetAccountSummary_account_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface GetAccountSummary_account_tagMaps_edges {
  __typename: "TagMapsEdge";
  node: GetAccountSummary_account_tagMaps_edges_node | null;
}

export interface GetAccountSummary_account_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * A list of edges.
   */
  edges: GetAccountSummary_account_tagMaps_edges[];
}

export interface GetAccountSummary_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The number of people employed by this company
   */
  employeeCount: string | null;
  revenue: GetAccountSummary_account_revenue | null;
  /**
   * The terrority to which this peep is assigned.
   */
  territory: GetAccountSummary_account_territory | null;
  /**
   * The industry of this account
   */
  industry: GetAccountSummary_account_industry | null;
  /**
   * The type assigned to this account
   */
  accountType: GetAccountSummary_account_accountType;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The time this entity was deleted
   */
  deletedTime: any | null;
  /**
   * The user who created this peep.
   */
  creatorUser: GetAccountSummary_account_creatorUser | null;
  /**
   * Entity this account was merged with
   */
  mergedWith: GetAccountSummary_account_mergedWith | null;
  /**
   * The origin of the peep
   */
  origin: GetAccountSummary_account_origin;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: GetAccountSummary_account_owner | null;
  /**
   * Tag maps for the peep
   */
  tagMaps: GetAccountSummary_account_tagMaps | null;
}

export interface GetAccountSummary {
  /**
   * Returns a Nutshell Account
   */
  account: GetAccountSummary_account | null;
}

export interface GetAccountSummaryVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetActivities
// ====================================================

export interface GetActivities_activities_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetActivities_activities_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetActivities_activities {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The DateTime that represents the start time of the Activity record
   */
  startTime: any;
  /**
   * The DateTime that represents the end time of the Activity record
   */
  endTime: any;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetActivities_activities_activityType;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetActivities_activities_participants[];
  /**
   * Canonical URL for an individual activity - launches a modal in this case
   */
  htmlUrl: string;
  /**
   * Whether the activity should show the new logging flow with video transcription and summary.
   */
  showTranscribeLoggingFlow: boolean;
  /**
   * The type of external service that the associated meeting belongs to
   */
  externalMeetingServiceType: ExternalServiceType | null;
  /**
   * Whether the activity is private.
   */
  isPrivate: boolean;
}

export interface GetActivities {
  /**
   * A list of Nutshell Activities
   */
  activities: GetActivities_activities[];
}

export interface GetActivitiesVariables {
  entityId: string;
  status?: number | null;
  limit?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddEntityToConstantContact
// ====================================================

export interface AddEntityToConstantContact_constantContactAddEntityToList_entity_primaryCtctContact_listMemberships {
  __typename: "ConstantContactList";
  id: string;
  name: string;
}

export interface AddEntityToConstantContact_constantContactAddEntityToList_entity_primaryCtctContact_latestActivity {
  __typename: "ConstantContactContactTrackingActivity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  createdTime: any;
  trackingActivityType: ConstantContactContactTrackingActivityType;
  campaignName: string | null;
  subject: string | null;
}

export interface AddEntityToConstantContact_constantContactAddEntityToList_entity_primaryCtctContact {
  __typename: "ConstantContactContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailAddress: string;
  status: ConstantContactContactStatus;
  openRate: number | null;
  clickRate: number | null;
  /**
   * The 0-5 Nutshell generated engagement rating for this contact
   */
  engagementRating: number | null;
  sendsCount: number;
  /**
   * The last time that constant contact tracking activities were fetched for this contact
   */
  lastActivitySyncTime: any | null;
  listMemberships: AddEntityToConstantContact_constantContactAddEntityToList_entity_primaryCtctContact_listMemberships[];
  latestActivity: AddEntityToConstantContact_constantContactAddEntityToList_entity_primaryCtctContact_latestActivity | null;
}

export interface AddEntityToConstantContact_constantContactAddEntityToList_entity_ctctContacts_listMemberships {
  __typename: "ConstantContactList";
  id: string;
  name: string;
}

export interface AddEntityToConstantContact_constantContactAddEntityToList_entity_ctctContacts_latestActivity {
  __typename: "ConstantContactContactTrackingActivity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  createdTime: any;
  trackingActivityType: ConstantContactContactTrackingActivityType;
  campaignName: string | null;
  subject: string | null;
}

export interface AddEntityToConstantContact_constantContactAddEntityToList_entity_ctctContacts {
  __typename: "ConstantContactContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailAddress: string;
  status: ConstantContactContactStatus;
  openRate: number | null;
  clickRate: number | null;
  /**
   * The 0-5 Nutshell generated engagement rating for this contact
   */
  engagementRating: number | null;
  sendsCount: number;
  /**
   * The last time that constant contact tracking activities were fetched for this contact
   */
  lastActivitySyncTime: any | null;
  listMemberships: AddEntityToConstantContact_constantContactAddEntityToList_entity_ctctContacts_listMemberships[];
  latestActivity: AddEntityToConstantContact_constantContactAddEntityToList_entity_ctctContacts_latestActivity | null;
}

export interface AddEntityToConstantContact_constantContactAddEntityToList_entity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The Constant Contact contacts linked to this contact’s primary email address
   */
  primaryCtctContact: AddEntityToConstantContact_constantContactAddEntityToList_entity_primaryCtctContact | null;
  /**
   * The Constant Contact contacts linked to this Nutshell contact
   */
  ctctContacts: AddEntityToConstantContact_constantContactAddEntityToList_entity_ctctContacts[];
}

export interface AddEntityToConstantContact_constantContactAddEntityToList {
  __typename: "ConstantContactAddEntityToListPayload";
  /**
   * The updated Nutshell entity
   */
  entity: AddEntityToConstantContact_constantContactAddEntityToList_entity;
}

export interface AddEntityToConstantContact {
  /**
   * Adds a Nutshell entity to the given Constant Contact list.
   */
  constantContactAddEntityToList: AddEntityToConstantContact_constantContactAddEntityToList;
}

export interface AddEntityToConstantContactVariables {
  input: ConstantContactAddEntityToListInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SyncCtctEntity
// ====================================================

export interface SyncCtctEntity_constantContactSyncEntity_entity_ctctContacts_listMemberships {
  __typename: "ConstantContactList";
  id: string;
  name: string;
}

export interface SyncCtctEntity_constantContactSyncEntity_entity_ctctContacts_latestActivity {
  __typename: "ConstantContactContactTrackingActivity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  createdTime: any;
  trackingActivityType: ConstantContactContactTrackingActivityType;
  campaignName: string | null;
  subject: string | null;
}

export interface SyncCtctEntity_constantContactSyncEntity_entity_ctctContacts {
  __typename: "ConstantContactContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailAddress: string;
  status: ConstantContactContactStatus;
  openRate: number | null;
  clickRate: number | null;
  /**
   * The 0-5 Nutshell generated engagement rating for this contact
   */
  engagementRating: number | null;
  sendsCount: number;
  /**
   * The last time that constant contact tracking activities were fetched for this contact
   */
  lastActivitySyncTime: any | null;
  listMemberships: SyncCtctEntity_constantContactSyncEntity_entity_ctctContacts_listMemberships[];
  latestActivity: SyncCtctEntity_constantContactSyncEntity_entity_ctctContacts_latestActivity | null;
}

export interface SyncCtctEntity_constantContactSyncEntity_entity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The Constant Contact contacts linked to this Nutshell contact
   */
  ctctContacts: SyncCtctEntity_constantContactSyncEntity_entity_ctctContacts[];
}

export interface SyncCtctEntity_constantContactSyncEntity {
  __typename: "ConstantContactSyncEntityPayload";
  /**
   * The updated Nutshell entity
   */
  entity: SyncCtctEntity_constantContactSyncEntity_entity;
}

export interface SyncCtctEntity {
  /**
   * Manually trigger a sync of a constant contact contact tracking activity data,
   * which normally only happens once per day otherwise.
   */
  constantContactSyncEntity: SyncCtctEntity_constantContactSyncEntity;
}

export interface SyncCtctEntityVariables {
  entityId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCtctContacts
// ====================================================

export interface GetCtctContacts_coreEntity_primaryCtctContact_listMemberships {
  __typename: "ConstantContactList";
  id: string;
  name: string;
}

export interface GetCtctContacts_coreEntity_primaryCtctContact_latestActivity {
  __typename: "ConstantContactContactTrackingActivity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  createdTime: any;
  trackingActivityType: ConstantContactContactTrackingActivityType;
  campaignName: string | null;
  subject: string | null;
}

export interface GetCtctContacts_coreEntity_primaryCtctContact {
  __typename: "ConstantContactContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailAddress: string;
  status: ConstantContactContactStatus;
  openRate: number | null;
  clickRate: number | null;
  /**
   * The 0-5 Nutshell generated engagement rating for this contact
   */
  engagementRating: number | null;
  sendsCount: number;
  /**
   * The last time that constant contact tracking activities were fetched for this contact
   */
  lastActivitySyncTime: any | null;
  listMemberships: GetCtctContacts_coreEntity_primaryCtctContact_listMemberships[];
  latestActivity: GetCtctContacts_coreEntity_primaryCtctContact_latestActivity | null;
}

export interface GetCtctContacts_coreEntity_ctctContacts_listMemberships {
  __typename: "ConstantContactList";
  id: string;
  name: string;
}

export interface GetCtctContacts_coreEntity_ctctContacts_latestActivity {
  __typename: "ConstantContactContactTrackingActivity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  createdTime: any;
  trackingActivityType: ConstantContactContactTrackingActivityType;
  campaignName: string | null;
  subject: string | null;
}

export interface GetCtctContacts_coreEntity_ctctContacts {
  __typename: "ConstantContactContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailAddress: string;
  status: ConstantContactContactStatus;
  openRate: number | null;
  clickRate: number | null;
  /**
   * The 0-5 Nutshell generated engagement rating for this contact
   */
  engagementRating: number | null;
  sendsCount: number;
  /**
   * The last time that constant contact tracking activities were fetched for this contact
   */
  lastActivitySyncTime: any | null;
  listMemberships: GetCtctContacts_coreEntity_ctctContacts_listMemberships[];
  latestActivity: GetCtctContacts_coreEntity_ctctContacts_latestActivity | null;
}

export interface GetCtctContacts_coreEntity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The Constant Contact contacts linked to this contact’s primary email address
   */
  primaryCtctContact: GetCtctContacts_coreEntity_primaryCtctContact | null;
  /**
   * The Constant Contact contacts linked to this Nutshell contact
   */
  ctctContacts: GetCtctContacts_coreEntity_ctctContacts[];
}

export interface GetCtctContacts {
  /**
   * Returns a Nutshell Core entity by id
   */
  coreEntity: GetCtctContacts_coreEntity;
}

export interface GetCtctContactsVariables {
  entityId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactEmailSequenceData
// ====================================================

export interface GetContactEmailSequenceData_contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  name: string;
}

export interface GetContactEmailSequenceData_contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetContactEmailSequenceData_contact_emailAddresses_primary | null;
}

export interface GetContactEmailSequenceData_contact_dripProgressions_currentNode {
  __typename: "SmartSequenceNode";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetContactEmailSequenceData_contact_dripProgressions_campaign_startTrigger {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface GetContactEmailSequenceData_contact_dripProgressions_campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this goal. This is essentially just the stringified
   * version of the goal’s conditions, but because a goal can have multiple
   * conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface GetContactEmailSequenceData_contact_dripProgressions_campaign_from_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetContactEmailSequenceData_contact_dripProgressions_campaign_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: GetContactEmailSequenceData_contact_dripProgressions_campaign_from_creatorUser | null;
}

export interface GetContactEmailSequenceData_contact_dripProgressions_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * When a lead is closed, should drip sequences stop?
   */
  isStopOnLeadClose: boolean;
  /**
   * The start trigger for the drip sequence
   */
  startTrigger: GetContactEmailSequenceData_contact_dripProgressions_campaign_startTrigger | null;
  /**
   * The newly created Nutshell goal
   */
  goal: GetContactEmailSequenceData_contact_dripProgressions_campaign_goal | null;
  /**
   * The address to send this edition from
   */
  from: GetContactEmailSequenceData_contact_dripProgressions_campaign_from | null;
}

export interface GetContactEmailSequenceData_contact_dripProgressions_editions_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetContactEmailSequenceData_contact_dripProgressions_editions_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetContactEmailSequenceData_contact_dripProgressions_editions_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The URL that this edition links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  scheduledTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: GetContactEmailSequenceData_contact_dripProgressions_editions_edition_emailTemplate | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: GetContactEmailSequenceData_contact_dripProgressions_editions_edition_delay | null;
}

export interface GetContactEmailSequenceData_contact_dripProgressions_editions {
  __typename: "DripProgressionEdition";
  /**
   * Whether this edition has been sent
   */
  sent: boolean;
  /**
   * The edition
   */
  edition: GetContactEmailSequenceData_contact_dripProgressions_editions_edition;
}

export interface GetContactEmailSequenceData_contact_dripProgressions {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * When this drip progression was created (when the contact entered the sequence)
   */
  createdTime: any;
  /**
   * When this progression stopped, or null if it is still active
   */
  stoppedTime: any | null;
  /**
   * Why this progression stopped, or null if it is still active
   */
  stoppedReason: DripProgressionStoppedReason | null;
  /**
   * The graph node this progression is currently on, if any. Null for legacy drip
   * progressions and for smart progressions without a current node.
   */
  currentNode: GetContactEmailSequenceData_contact_dripProgressions_currentNode | null;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
  /**
   * Number of editions that have been sent so far for this progression. NOTE: This
   * can be inaccurate if editions are reordered or an edition is added to the
   * start of the drip after a progression has started. This is ok! We want this
   * number to represent the number of prior active editions, even if they aren’t always sent.
   */
  numEditionsSent: number;
  /**
   * The drip sequence for this drip progressions
   */
  campaign: GetContactEmailSequenceData_contact_dripProgressions_campaign;
  /**
   * All editions in the drip sequence for this drip progression, in send order
   */
  editions: GetContactEmailSequenceData_contact_dripProgressions_editions[];
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_sender_sendableEmailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_sender {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * List of successfully enabled user email addresses that a user is able to send emails from Nutshell with.
   */
  sendableEmailAddresses: GetContactEmailSequenceData_contact_emailAutomationStatuses_sender_sendableEmailAddresses[];
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_companyName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_firstName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_lastName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_lead_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  name: string;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetContactEmailSequenceData_contact_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetContactEmailSequenceData_contact_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetContactEmailSequenceData_contact_emailAutomationStatuses_lead_contacts_primaryEdge_node;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetContactEmailSequenceData_contact_emailAutomationStatuses_lead_contacts_primaryEdge | null;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetContactEmailSequenceData_contact_emailAutomationStatuses_lead_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetContactEmailSequenceData_contact_emailAutomationStatuses_lead_contacts;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_emailAutomation_exitsStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_emailAutomation_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_emailAutomation_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: GetContactEmailSequenceData_contact_emailAutomationStatuses_emailAutomation_entersStage;
  /**
   * The stage in which this stage subscription ends.
   */
  exitsStage: GetContactEmailSequenceData_contact_emailAutomationStatuses_emailAutomation_exitsStage | null;
  /**
   * Indicates if a lead should receive emails from this subscription until it closes.
   */
  sendUntilClose: boolean;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: GetContactEmailSequenceData_contact_emailAutomationStatuses_emailAutomation_delay | null;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: GetContactEmailSequenceData_contact_emailAutomationStatuses_emailAutomation_emailList | null;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_emailSequence_emailsQueued_fromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_emailSequence_emailsQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_emailSequence_emailsQueued_to {
  __typename: "NutEmailAddress";
  avatarEntity: GetContactEmailSequenceData_contact_emailAutomationStatuses_emailSequence_emailsQueued_to_avatarEntity | null;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The current status of this queued email.
   */
  status: EmailQueuedStatus;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  fromUser: GetContactEmailSequenceData_contact_emailAutomationStatuses_emailSequence_emailsQueued_fromUser | null;
  to: GetContactEmailSequenceData_contact_emailAutomationStatuses_emailSequence_emailsQueued_to[];
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The next message to be sent
   */
  nextUnsentEmail: GetContactEmailSequenceData_contact_emailAutomationStatuses_emailSequence_nextUnsentEmail | null;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  /**
   * The number of emails that have been sent
   */
  sentEmailsCount: number;
  emailsQueued: GetContactEmailSequenceData_contact_emailAutomationStatuses_emailSequence_emailsQueued[];
  emailSequenceTemplate: GetContactEmailSequenceData_contact_emailAutomationStatuses_emailSequence_emailSequenceTemplate | null;
  /**
   * True if this sequence has only one email
   */
  isSingleEmailSequence: boolean;
}

export interface GetContactEmailSequenceData_contact_emailAutomationStatuses {
  __typename: "EmailAutomationStatus";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that either did send this automation, or current _would_ send this
   * automation given the current context. For example, if the user is assigned to
   * a team, the logged in user is considered a potential sender if they’re on that team
   */
  sender: GetContactEmailSequenceData_contact_emailAutomationStatuses_sender | null;
  /**
   * The total number of messages in the sequence for this status
   */
  unsentMessageCount: number | null;
  /**
   * Is this automation status paused?
   */
  isPaused: boolean;
  /**
   * Can this status be started
   */
  canStart: boolean;
  /**
   * Can this status be cancelled
   */
  canCancel: boolean;
  /**
   * The message to show to the user
   */
  status: EmailAutomationStatusStatus;
  /**
   * Status of the company name field
   */
  companyName: GetContactEmailSequenceData_contact_emailAutomationStatuses_companyName;
  /**
   * Status of the first name field
   */
  firstName: GetContactEmailSequenceData_contact_emailAutomationStatuses_firstName;
  /**
   * Status of the last name field
   */
  lastName: GetContactEmailSequenceData_contact_emailAutomationStatuses_lastName;
  /**
   * Lead associated with this status row
   */
  lead: GetContactEmailSequenceData_contact_emailAutomationStatuses_lead;
  /**
   * Email list stage subscription associated with this status row
   */
  emailAutomation: GetContactEmailSequenceData_contact_emailAutomationStatuses_emailAutomation;
  /**
   * The actual email sequence going out for this lead in this stage
   */
  emailSequence: GetContactEmailSequenceData_contact_emailAutomationStatuses_emailSequence | null;
}

export interface GetContactEmailSequenceData_contact_queuedEmails_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
}

export interface GetContactEmailSequenceData_contact_queuedEmails_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetContactEmailSequenceData_contact_queuedEmails_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The next message to be sent
   */
  nextUnsentEmail: GetContactEmailSequenceData_contact_queuedEmails_emailSequence_nextUnsentEmail | null;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  /**
   * The number of emails that have been sent
   */
  sentEmailsCount: number;
  emailSequenceTemplate: GetContactEmailSequenceData_contact_queuedEmails_emailSequence_emailSequenceTemplate | null;
  /**
   * True if this sequence has only one email
   */
  isSingleEmailSequence: boolean;
}

export interface GetContactEmailSequenceData_contact_queuedEmails_fromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetContactEmailSequenceData_contact_queuedEmails_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetContactEmailSequenceData_contact_queuedEmails_to {
  __typename: "NutEmailAddress";
  avatarEntity: GetContactEmailSequenceData_contact_queuedEmails_to_avatarEntity | null;
}

export interface GetContactEmailSequenceData_contact_queuedEmails {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent email sequence of this queued email.
   */
  emailSequence: GetContactEmailSequenceData_contact_queuedEmails_emailSequence | null;
  /**
   * The current status of this queued email.
   */
  status: EmailQueuedStatus;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  fromUser: GetContactEmailSequenceData_contact_queuedEmails_fromUser | null;
  to: GetContactEmailSequenceData_contact_queuedEmails_to[];
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
}

export interface GetContactEmailSequenceData_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetContactEmailSequenceData_contact_emailAddresses;
  /**
   * List of drip progressions for this contact. By default only active
   * progressions on non-cancelled campaigns are returned. Soft-deleted
   * progressions are always excluded.
   */
  dripProgressions: GetContactEmailSequenceData_contact_dripProgressions[];
  /**
   * Automation statuses from leads where this contact is the primary contact
   */
  emailAutomationStatuses: GetContactEmailSequenceData_contact_emailAutomationStatuses[];
  /**
   * Emails queued to be sent to this accounts primary contact
   */
  queuedEmails: GetContactEmailSequenceData_contact_queuedEmails[];
}

export interface GetContactEmailSequenceData {
  /**
   * Returns a Nutshell Contact
   */
  contact: GetContactEmailSequenceData_contact | null;
}

export interface GetContactEmailSequenceDataVariables {
  contactId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateRelatedAccount
// ====================================================

export interface UpdateRelatedAccount_accountUpdate_account_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface UpdateRelatedAccount_accountUpdate_account_postalAddresses_primary {
  __typename: "PostalAddress";
  location: UpdateRelatedAccount_accountUpdate_account_postalAddresses_primary_location;
}

export interface UpdateRelatedAccount_accountUpdate_account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: UpdateRelatedAccount_accountUpdate_account_postalAddresses_primary | null;
}

export interface UpdateRelatedAccount_accountUpdate_account_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface UpdateRelatedAccount_accountUpdate_account_phones_primary {
  __typename: "Phone";
  value: UpdateRelatedAccount_accountUpdate_account_phones_primary_value;
}

export interface UpdateRelatedAccount_accountUpdate_account_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: UpdateRelatedAccount_accountUpdate_account_phones_primary | null;
}

export interface UpdateRelatedAccount_accountUpdate_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: UpdateRelatedAccount_accountUpdate_account_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: UpdateRelatedAccount_accountUpdate_account_phones;
}

export interface UpdateRelatedAccount_accountUpdate {
  __typename: "AccountUpdatePayload";
  /**
   * The updated Nutshell Account
   */
  account: UpdateRelatedAccount_accountUpdate_account;
}

export interface UpdateRelatedAccount {
  /**
   * Updates an account
   */
  accountUpdate: UpdateRelatedAccount_accountUpdate;
}

export interface UpdateRelatedAccountVariables {
  input: AccountUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRelatedAccounts
// ====================================================

export interface GetRelatedAccounts_contact_accounts_pageInfo {
  __typename: "PageInfo";
  hasNextPage: boolean;
  endCursor: string | null;
}

export interface GetRelatedAccounts_contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetRelatedAccounts_contact_accounts_edges_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface GetRelatedAccounts_contact_accounts_edges_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: GetRelatedAccounts_contact_accounts_edges_node_postalAddresses_primary_location;
}

export interface GetRelatedAccounts_contact_accounts_edges_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetRelatedAccounts_contact_accounts_edges_node_postalAddresses_primary | null;
}

export interface GetRelatedAccounts_contact_accounts_edges_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetRelatedAccounts_contact_accounts_edges_node_phones_primary {
  __typename: "Phone";
  value: GetRelatedAccounts_contact_accounts_edges_node_phones_primary_value;
}

export interface GetRelatedAccounts_contact_accounts_edges_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetRelatedAccounts_contact_accounts_edges_node_phones_primary | null;
}

export interface GetRelatedAccounts_contact_accounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetRelatedAccounts_contact_accounts_edges_node_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetRelatedAccounts_contact_accounts_edges_node_phones;
}

export interface GetRelatedAccounts_contact_accounts_edges {
  __typename: "ContactAccountsEdge";
  node: GetRelatedAccounts_contact_accounts_edges_node;
  /**
   * Whether this account is no longer associated with this contact.
   */
  isFormer: boolean;
  /**
   * The one-off short note that users can write on this contact->account relationship.
   */
  relationshipNote: string | null;
}

export interface GetRelatedAccounts_contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetRelatedAccounts_contact_accounts_pageInfo;
  /**
   * Primary account for this contact
   */
  primary: GetRelatedAccounts_contact_accounts_primary | null;
  /**
   * A list of edges.
   */
  edges: GetRelatedAccounts_contact_accounts_edges[];
}

export interface GetRelatedAccounts_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetRelatedAccounts_contact_accounts;
}

export interface GetRelatedAccounts {
  /**
   * Returns a Nutshell Contact
   */
  contact: GetRelatedAccounts_contact | null;
}

export interface GetRelatedAccountsVariables {
  id: string;
  first?: number | null;
  after?: string | null;
  formerOnly?: boolean | null;
  search?: string | null;
  sortBy?: PeepRelatedPeepSortType | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ContactsMarkNotDupe
// ====================================================

export interface ContactsMarkNotDupe_contactsMarkNotDupe {
  __typename: "ContactsMarkNotDupePayload";
  success: boolean;
}

export interface ContactsMarkNotDupe {
  contactsMarkNotDupe: ContactsMarkNotDupe_contactsMarkNotDupe;
}

export interface ContactsMarkNotDupeVariables {
  input: ContactsMarkNotDupeInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ContactsMerge
// ====================================================

export interface ContactsMerge_contactsMerge_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ContactsMerge_contactsMerge {
  __typename: "ContactsMergePayload";
  contact: ContactsMerge_contactsMerge_contact;
}

export interface ContactsMerge {
  /**
   * Merges the specified contacts into the primary contact
   */
  contactsMerge: ContactsMerge_contactsMerge;
}

export interface ContactsMergeVariables {
  input: ContactsMergeInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactDuplicateDetails
// ====================================================

export interface GetContactDuplicateDetails_contact_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetContactDuplicateDetails_contact_primaryAccount_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetContactDuplicateDetails_contact_primaryAccount {
  __typename: "ContactAccountsEdge";
  node: GetContactDuplicateDetails_contact_primaryAccount_node;
}

export interface GetContactDuplicateDetails_contact_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The full printable address of this location
   */
  fullPrintableAddress: string | null;
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface GetContactDuplicateDetails_contact_postalAddresses_primary {
  __typename: "PostalAddress";
  id: string;
  location: GetContactDuplicateDetails_contact_postalAddresses_primary_location;
}

export interface GetContactDuplicateDetails_contact_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetContactDuplicateDetails_contact_postalAddresses_primary | null;
}

export interface GetContactDuplicateDetails_contact_leads {
  __typename: "PeepLeadsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetContactDuplicateDetails_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: GetContactDuplicateDetails_contact_owner | null;
  /**
   * The time this peep was last modified.
   */
  modifiedTime: any | null;
  /**
   * The primary account edge for this contact
   */
  primaryAccount: GetContactDuplicateDetails_contact_primaryAccount | null;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetContactDuplicateDetails_contact_postalAddresses;
  /**
   * Leads related to this peep
   */
  leads: GetContactDuplicateDetails_contact_leads;
}

export interface GetContactDuplicateDetails {
  /**
   * Returns a Nutshell Contact
   */
  contact: GetContactDuplicateDetails_contact | null;
}

export interface GetContactDuplicateDetailsVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactDuplicateGroups
// ====================================================

export interface GetContactDuplicateGroups_contactDuplicateGroups_edges_node_contacts_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetContactDuplicateGroups_contactDuplicateGroups_edges_node_contacts_primaryAccount_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetContactDuplicateGroups_contactDuplicateGroups_edges_node_contacts_primaryAccount {
  __typename: "ContactAccountsEdge";
  node: GetContactDuplicateGroups_contactDuplicateGroups_edges_node_contacts_primaryAccount_node;
}

export interface GetContactDuplicateGroups_contactDuplicateGroups_edges_node_contacts_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The full printable address of this location
   */
  fullPrintableAddress: string | null;
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface GetContactDuplicateGroups_contactDuplicateGroups_edges_node_contacts_postalAddresses_primary {
  __typename: "PostalAddress";
  id: string;
  location: GetContactDuplicateGroups_contactDuplicateGroups_edges_node_contacts_postalAddresses_primary_location;
}

export interface GetContactDuplicateGroups_contactDuplicateGroups_edges_node_contacts_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetContactDuplicateGroups_contactDuplicateGroups_edges_node_contacts_postalAddresses_primary | null;
}

export interface GetContactDuplicateGroups_contactDuplicateGroups_edges_node_contacts_leads {
  __typename: "PeepLeadsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetContactDuplicateGroups_contactDuplicateGroups_edges_node_contacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: GetContactDuplicateGroups_contactDuplicateGroups_edges_node_contacts_owner | null;
  /**
   * The time this peep was last modified.
   */
  modifiedTime: any | null;
  /**
   * The primary account edge for this contact
   */
  primaryAccount: GetContactDuplicateGroups_contactDuplicateGroups_edges_node_contacts_primaryAccount | null;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetContactDuplicateGroups_contactDuplicateGroups_edges_node_contacts_postalAddresses;
  /**
   * Leads related to this peep
   */
  leads: GetContactDuplicateGroups_contactDuplicateGroups_edges_node_contacts_leads;
}

export interface GetContactDuplicateGroups_contactDuplicateGroups_edges_node {
  __typename: "ContactDuplicateGroup";
  id: string;
  groupingKeys: PeepDuplicateGroupingKey[];
  fullName: string | null;
  emailAddress: string | null;
  phoneNumber: string | null;
  companyName: string | null;
  count: number;
  contacts: GetContactDuplicateGroups_contactDuplicateGroups_edges_node_contacts[];
}

export interface GetContactDuplicateGroups_contactDuplicateGroups_edges {
  __typename: "ContactDuplicateGroupEdge";
  cursor: string;
  node: GetContactDuplicateGroups_contactDuplicateGroups_edges_node;
}

export interface GetContactDuplicateGroups_contactDuplicateGroups {
  __typename: "ContactDuplicateGroupsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Sum of contacts across all post-prune duplicate groups for the requested
   * grouping (each contact once per group, contact_non_dupes pairs removed). Same
   * pruning as edges; matches the sum of edge `count` values once paginated
   * through every page.
   */
  duplicateContactCount: number;
  /**
   * A list of edges.
   */
  edges: GetContactDuplicateGroups_contactDuplicateGroups_edges[];
}

export interface GetContactDuplicateGroups {
  /**
   * Groups of contacts that match on all selected duplicate keys. Computed in real
   * time from MySQL with a per-request MEMORY temp table over every non-deleted
   * contact (no Solr/index involvement, no list-filter scoping).
   */
  contactDuplicateGroups: GetContactDuplicateGroups_contactDuplicateGroups;
}

export interface GetContactDuplicateGroupsVariables {
  groupBy: PeepDuplicateGroupingKey[];
  first?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactDuplicateStatus
// ====================================================

export interface GetContactDuplicateStatus_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this peep has duplicates
   */
  hasDuplicates: boolean;
}

export interface GetContactDuplicateStatus {
  /**
   * Returns a Nutshell Contact
   */
  contact: GetContactDuplicateStatus_contact | null;
}

export interface GetContactDuplicateStatusVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactDuplicateStatuses
// ====================================================

export interface GetContactDuplicateStatuses_contacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this peep has duplicates
   */
  hasDuplicates: boolean;
}

export interface GetContactDuplicateStatuses {
  /**
   * Returns a list of Nutshell Contacts
   */
  contacts: (GetContactDuplicateStatuses_contacts | null)[] | null;
}

export interface GetContactDuplicateStatusesVariables {
  ids: string[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactDuplicates
// ====================================================

export interface GetContactDuplicates_contactDuplicates_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetContactDuplicates_contactDuplicates_primaryAccount_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetContactDuplicates_contactDuplicates_primaryAccount {
  __typename: "ContactAccountsEdge";
  node: GetContactDuplicates_contactDuplicates_primaryAccount_node;
}

export interface GetContactDuplicates_contactDuplicates_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The full printable address of this location
   */
  fullPrintableAddress: string | null;
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface GetContactDuplicates_contactDuplicates_postalAddresses_primary {
  __typename: "PostalAddress";
  id: string;
  location: GetContactDuplicates_contactDuplicates_postalAddresses_primary_location;
}

export interface GetContactDuplicates_contactDuplicates_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetContactDuplicates_contactDuplicates_postalAddresses_primary | null;
}

export interface GetContactDuplicates_contactDuplicates_leads {
  __typename: "PeepLeadsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetContactDuplicates_contactDuplicates {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: GetContactDuplicates_contactDuplicates_owner | null;
  /**
   * The time this peep was last modified.
   */
  modifiedTime: any | null;
  /**
   * The primary account edge for this contact
   */
  primaryAccount: GetContactDuplicates_contactDuplicates_primaryAccount | null;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetContactDuplicates_contactDuplicates_postalAddresses;
  /**
   * Leads related to this peep
   */
  leads: GetContactDuplicates_contactDuplicates_leads;
}

export interface GetContactDuplicates {
  contactDuplicates: GetContactDuplicates_contactDuplicates[];
}

export interface GetContactDuplicatesVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactsBulkMergeStatus
// ====================================================

export interface GetContactsBulkMergeStatus_bulkEdits_edges_node_config {
  __typename: "BulkEditConfig";
  numDuplicates: number;
}

export interface GetContactsBulkMergeStatus_bulkEdits_edges_node {
  __typename: "BulkEdit";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  progress: number;
  /**
   * The status of the bulk edit
   */
  status: BulkEditStatus;
  config: GetContactsBulkMergeStatus_bulkEdits_edges_node_config | null;
}

export interface GetContactsBulkMergeStatus_bulkEdits_edges {
  __typename: "BulkEditsEdge";
  node: GetContactsBulkMergeStatus_bulkEdits_edges_node;
}

export interface GetContactsBulkMergeStatus_bulkEdits {
  __typename: "BulkEditsConnection";
  /**
   * A list of edges.
   */
  edges: GetContactsBulkMergeStatus_bulkEdits_edges[];
}

export interface GetContactsBulkMergeStatus {
  bulkEdits: GetContactsBulkMergeStatus_bulkEdits | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: HardDeleteContact
// ====================================================

export interface HardDeleteContact_contactHardDelete {
  __typename: "ContactHardDeletePayload";
  success: boolean;
}

export interface HardDeleteContact {
  /**
   * Permanently deletes a soft-deleted contact.
   */
  contactHardDelete: HardDeleteContact_contactHardDelete;
}

export interface HardDeleteContactVariables {
  contactId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateContactCustomFieldValue
// ====================================================

export interface UpdateContactCustomFieldValue_contactUpdate_contact_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_creatorUser_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  firstName: string | null;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
  teams: UpdateContactCustomFieldValue_contactUpdate_contact_creatorUser_teams[];
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_primaryAccount_node_postalAddresses_primary_location_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_primaryAccount_node_postalAddresses_primary_location_weather {
  __typename: "Weather";
  temperature: string | null;
  condition: string | null;
  location: string | null;
  localTime: string | null;
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_primaryAccount_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
  coordinates: UpdateContactCustomFieldValue_contactUpdate_contact_primaryAccount_node_postalAddresses_primary_location_coordinates | null;
  weather: UpdateContactCustomFieldValue_contactUpdate_contact_primaryAccount_node_postalAddresses_primary_location_weather | null;
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_primaryAccount_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: UpdateContactCustomFieldValue_contactUpdate_contact_primaryAccount_node_postalAddresses_primary_location;
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_primaryAccount_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: UpdateContactCustomFieldValue_contactUpdate_contact_primaryAccount_node_postalAddresses_primary | null;
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_primaryAccount_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: UpdateContactCustomFieldValue_contactUpdate_contact_primaryAccount_node_postalAddresses;
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_primaryAccount {
  __typename: "ContactAccountsEdge";
  /**
   * The one-off short note that users can write on this contact->account relationship.
   */
  relationshipNote: string | null;
  node: UpdateContactCustomFieldValue_contactUpdate_contact_primaryAccount_node;
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_leads {
  __typename: "PeepLeadsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_workspaceWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_sidebarWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_headerFields {
  __typename: "HeaderField";
  /**
   * The type of the header field
   */
  type: HeaderFieldType;
  /**
   * Whether the header field is enabled
   */
  isEnabled: boolean;
  /**
   * The name of the header field
   */
  name: string;
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_postalAddresses_primary_location_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_postalAddresses_primary_location_weather {
  __typename: "Weather";
  temperature: string | null;
  condition: string | null;
  location: string | null;
  localTime: string | null;
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The full printable address of this location
   */
  fullPrintableAddress: string | null;
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
  coordinates: UpdateContactCustomFieldValue_contactUpdate_contact_postalAddresses_primary_location_coordinates | null;
  weather: UpdateContactCustomFieldValue_contactUpdate_contact_postalAddresses_primary_location_weather | null;
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_postalAddresses_primary {
  __typename: "PostalAddress";
  location: UpdateContactCustomFieldValue_contactUpdate_contact_postalAddresses_primary_location;
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: UpdateContactCustomFieldValue_contactUpdate_contact_postalAddresses_primary | null;
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: UpdateContactCustomFieldValue_contactUpdate_contact_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_tagMaps_edges {
  __typename: "TagMapsEdge";
  node: UpdateContactCustomFieldValue_contactUpdate_contact_tagMaps_edges_node | null;
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * A list of edges.
   */
  edges: UpdateContactCustomFieldValue_contactUpdate_contact_tagMaps_edges[];
}

export interface UpdateContactCustomFieldValue_contactUpdate_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this entity deleted
   */
  isDeleted: boolean;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  avatarUrl: string;
  hasUploadedAvatar: boolean;
  canDeleteAvatar: boolean;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The terrority to which this peep is assigned.
   */
  territory: UpdateContactCustomFieldValue_contactUpdate_contact_territory | null;
  /**
   * The user who created this peep.
   */
  creatorUser: UpdateContactCustomFieldValue_contactUpdate_contact_creatorUser | null;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: UpdateContactCustomFieldValue_contactUpdate_contact_owner | null;
  /**
   * The primary account edge for this contact
   */
  primaryAccount: UpdateContactCustomFieldValue_contactUpdate_contact_primaryAccount | null;
  /**
   * Leads related to this peep
   */
  leads: UpdateContactCustomFieldValue_contactUpdate_contact_leads;
  /**
   * The widgets of the stageset lead workspace
   */
  workspaceWidgets: UpdateContactCustomFieldValue_contactUpdate_contact_workspaceWidgets[];
  /**
   * The widgets of the stageset lead sidebar
   */
  sidebarWidgets: UpdateContactCustomFieldValue_contactUpdate_contact_sidebarWidgets[];
  /**
   * The header fields for the entity type
   */
  headerFields: UpdateContactCustomFieldValue_contactUpdate_contact_headerFields[];
  /**
   * The postal addresses of the peep
   */
  postalAddresses: UpdateContactCustomFieldValue_contactUpdate_contact_postalAddresses;
  /**
   * Tag maps for the peep
   */
  tagMaps: UpdateContactCustomFieldValue_contactUpdate_contact_tagMaps | null;
}

export interface UpdateContactCustomFieldValue_contactUpdate {
  __typename: "ContactUpdatePayload";
  /**
   * The updated Nutshell contact.
   */
  contact: UpdateContactCustomFieldValue_contactUpdate_contact;
}

export interface UpdateContactCustomFieldValue {
  /**
   * Updates a Nutshell contact.
   */
  contactUpdate: UpdateContactCustomFieldValue_contactUpdate;
}

export interface UpdateContactCustomFieldValueVariables {
  contact: ContactUpdateInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateContact
// ====================================================

export interface UpdateContact_contactUpdate_contact_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface UpdateContact_contactUpdate_contact_creatorUser_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface UpdateContact_contactUpdate_contact_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  firstName: string | null;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
  teams: UpdateContact_contactUpdate_contact_creatorUser_teams[];
}

export interface UpdateContact_contactUpdate_contact_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateContact_contactUpdate_contact_primaryAccount_node_postalAddresses_primary_location_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface UpdateContact_contactUpdate_contact_primaryAccount_node_postalAddresses_primary_location_weather {
  __typename: "Weather";
  temperature: string | null;
  condition: string | null;
  location: string | null;
  localTime: string | null;
}

export interface UpdateContact_contactUpdate_contact_primaryAccount_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
  coordinates: UpdateContact_contactUpdate_contact_primaryAccount_node_postalAddresses_primary_location_coordinates | null;
  weather: UpdateContact_contactUpdate_contact_primaryAccount_node_postalAddresses_primary_location_weather | null;
}

export interface UpdateContact_contactUpdate_contact_primaryAccount_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: UpdateContact_contactUpdate_contact_primaryAccount_node_postalAddresses_primary_location;
}

export interface UpdateContact_contactUpdate_contact_primaryAccount_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: UpdateContact_contactUpdate_contact_primaryAccount_node_postalAddresses_primary | null;
}

export interface UpdateContact_contactUpdate_contact_primaryAccount_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: UpdateContact_contactUpdate_contact_primaryAccount_node_postalAddresses;
}

export interface UpdateContact_contactUpdate_contact_primaryAccount {
  __typename: "ContactAccountsEdge";
  /**
   * The one-off short note that users can write on this contact->account relationship.
   */
  relationshipNote: string | null;
  node: UpdateContact_contactUpdate_contact_primaryAccount_node;
}

export interface UpdateContact_contactUpdate_contact_leads {
  __typename: "PeepLeadsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface UpdateContact_contactUpdate_contact_workspaceWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface UpdateContact_contactUpdate_contact_sidebarWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface UpdateContact_contactUpdate_contact_headerFields {
  __typename: "HeaderField";
  /**
   * The type of the header field
   */
  type: HeaderFieldType;
  /**
   * Whether the header field is enabled
   */
  isEnabled: boolean;
  /**
   * The name of the header field
   */
  name: string;
}

export interface UpdateContact_contactUpdate_contact_postalAddresses_primary_location_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface UpdateContact_contactUpdate_contact_postalAddresses_primary_location_weather {
  __typename: "Weather";
  temperature: string | null;
  condition: string | null;
  location: string | null;
  localTime: string | null;
}

export interface UpdateContact_contactUpdate_contact_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The full printable address of this location
   */
  fullPrintableAddress: string | null;
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
  coordinates: UpdateContact_contactUpdate_contact_postalAddresses_primary_location_coordinates | null;
  weather: UpdateContact_contactUpdate_contact_postalAddresses_primary_location_weather | null;
}

export interface UpdateContact_contactUpdate_contact_postalAddresses_primary {
  __typename: "PostalAddress";
  location: UpdateContact_contactUpdate_contact_postalAddresses_primary_location;
}

export interface UpdateContact_contactUpdate_contact_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: UpdateContact_contactUpdate_contact_postalAddresses_primary | null;
}

export interface UpdateContact_contactUpdate_contact_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateContact_contactUpdate_contact_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: UpdateContact_contactUpdate_contact_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface UpdateContact_contactUpdate_contact_tagMaps_edges {
  __typename: "TagMapsEdge";
  node: UpdateContact_contactUpdate_contact_tagMaps_edges_node | null;
}

export interface UpdateContact_contactUpdate_contact_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * A list of edges.
   */
  edges: UpdateContact_contactUpdate_contact_tagMaps_edges[];
}

export interface UpdateContact_contactUpdate_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this entity deleted
   */
  isDeleted: boolean;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  avatarUrl: string;
  hasUploadedAvatar: boolean;
  canDeleteAvatar: boolean;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The terrority to which this peep is assigned.
   */
  territory: UpdateContact_contactUpdate_contact_territory | null;
  /**
   * The user who created this peep.
   */
  creatorUser: UpdateContact_contactUpdate_contact_creatorUser | null;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: UpdateContact_contactUpdate_contact_owner | null;
  /**
   * The primary account edge for this contact
   */
  primaryAccount: UpdateContact_contactUpdate_contact_primaryAccount | null;
  /**
   * Leads related to this peep
   */
  leads: UpdateContact_contactUpdate_contact_leads;
  /**
   * The widgets of the stageset lead workspace
   */
  workspaceWidgets: UpdateContact_contactUpdate_contact_workspaceWidgets[];
  /**
   * The widgets of the stageset lead sidebar
   */
  sidebarWidgets: UpdateContact_contactUpdate_contact_sidebarWidgets[];
  /**
   * The header fields for the entity type
   */
  headerFields: UpdateContact_contactUpdate_contact_headerFields[];
  /**
   * The postal addresses of the peep
   */
  postalAddresses: UpdateContact_contactUpdate_contact_postalAddresses;
  /**
   * Tag maps for the peep
   */
  tagMaps: UpdateContact_contactUpdate_contact_tagMaps | null;
}

export interface UpdateContact_contactUpdate {
  __typename: "ContactUpdatePayload";
  /**
   * The updated Nutshell contact.
   */
  contact: UpdateContact_contactUpdate_contact;
}

export interface UpdateContact {
  /**
   * Updates a Nutshell contact.
   */
  contactUpdate: UpdateContact_contactUpdate;
}

export interface UpdateContactVariables {
  input: ContactUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactDeliverabilityStatuses
// ====================================================

export interface GetContactDeliverabilityStatuses_contact_phones_primary_deliverabilityStatus {
  __typename: "SmsDeliverabilityStatus";
  /**
   * The deliverability status of the phone number
   */
  status: SmsDeliverabilityStatusType;
  /**
   * The time the phone number was opted out of SMS solicitations
   */
  optOutTime: any | null;
}

export interface GetContactDeliverabilityStatuses_contact_phones_primary {
  __typename: "Phone";
  deliverabilityStatus: GetContactDeliverabilityStatuses_contact_phones_primary_deliverabilityStatus;
}

export interface GetContactDeliverabilityStatuses_contact_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetContactDeliverabilityStatuses_contact_phones_primary | null;
}

export interface GetContactDeliverabilityStatuses_contact_emailAddresses_primary_deliverabilityStatus_unsubscribeStats_userUnsubscribedBy {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetContactDeliverabilityStatuses_contact_emailAddresses_primary_deliverabilityStatus_unsubscribeStats {
  __typename: "UnsubscribeStats";
  /**
   * The time the email address was globally unsubscribed
   */
  unsubscribeTime: any;
  /**
   * The source of the unsubscribe
   */
  unsubscribeSource: UnsubscribeSource;
  /**
   * The Nutshell user who unsubscribed the email address, if applicable
   */
  userUnsubscribedBy: GetContactDeliverabilityStatuses_contact_emailAddresses_primary_deliverabilityStatus_unsubscribeStats_userUnsubscribedBy | null;
}

export interface GetContactDeliverabilityStatuses_contact_emailAddresses_primary_deliverabilityStatus {
  __typename: "DeliverabilityStatus";
  /**
   * The status of deliverability
   */
  status: EmailDeliverabilityStatusType;
  /**
   * The stats for an unsubscribe
   */
  unsubscribeStats: GetContactDeliverabilityStatuses_contact_emailAddresses_primary_deliverabilityStatus_unsubscribeStats | null;
}

export interface GetContactDeliverabilityStatuses_contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  deliverabilityStatus: GetContactDeliverabilityStatuses_contact_emailAddresses_primary_deliverabilityStatus;
}

export interface GetContactDeliverabilityStatuses_contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetContactDeliverabilityStatuses_contact_emailAddresses_primary | null;
}

export interface GetContactDeliverabilityStatuses_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetContactDeliverabilityStatuses_contact_phones;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetContactDeliverabilityStatuses_contact_emailAddresses;
}

export interface GetContactDeliverabilityStatuses {
  /**
   * Returns a Nutshell Contact
   */
  contact: GetContactDeliverabilityStatuses_contact | null;
}

export interface GetContactDeliverabilityStatusesVariables {
  contactId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactLastContactedTime
// ====================================================

export interface GetContactLastContactedTime_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The most recent date this entity was contacted by the active user
   */
  myLastContactedTime: any | null;
}

export interface GetContactLastContactedTime {
  /**
   * Returns a Nutshell Contact
   */
  contact: GetContactLastContactedTime_contact | null;
}

export interface GetContactLastContactedTimeVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactLocationData
// ====================================================

export interface GetContactLocationData_contact_postalAddresses_primary_location_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface GetContactLocationData_contact_postalAddresses_primary_location_weather {
  __typename: "Weather";
  temperature: string | null;
  condition: string | null;
  location: string | null;
  localTime: string | null;
}

export interface GetContactLocationData_contact_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
  coordinates: GetContactLocationData_contact_postalAddresses_primary_location_coordinates | null;
  weather: GetContactLocationData_contact_postalAddresses_primary_location_weather | null;
}

export interface GetContactLocationData_contact_postalAddresses_primary {
  __typename: "PostalAddress";
  location: GetContactLocationData_contact_postalAddresses_primary_location;
}

export interface GetContactLocationData_contact_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetContactLocationData_contact_postalAddresses_primary | null;
}

export interface GetContactLocationData_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetContactLocationData_contact_postalAddresses;
}

export interface GetContactLocationData {
  /**
   * Returns a Nutshell Contact
   */
  contact: GetContactLocationData_contact | null;
}

export interface GetContactLocationDataVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactPrimaryAccount
// ====================================================

export interface GetContactPrimaryAccount_contact_primaryAccount_node_postalAddresses_primary_location_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface GetContactPrimaryAccount_contact_primaryAccount_node_postalAddresses_primary_location_weather {
  __typename: "Weather";
  temperature: string | null;
  condition: string | null;
  location: string | null;
  localTime: string | null;
}

export interface GetContactPrimaryAccount_contact_primaryAccount_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
  coordinates: GetContactPrimaryAccount_contact_primaryAccount_node_postalAddresses_primary_location_coordinates | null;
  weather: GetContactPrimaryAccount_contact_primaryAccount_node_postalAddresses_primary_location_weather | null;
}

export interface GetContactPrimaryAccount_contact_primaryAccount_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: GetContactPrimaryAccount_contact_primaryAccount_node_postalAddresses_primary_location;
}

export interface GetContactPrimaryAccount_contact_primaryAccount_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetContactPrimaryAccount_contact_primaryAccount_node_postalAddresses_primary | null;
}

export interface GetContactPrimaryAccount_contact_primaryAccount_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetContactPrimaryAccount_contact_primaryAccount_node_postalAddresses;
}

export interface GetContactPrimaryAccount_contact_primaryAccount {
  __typename: "ContactAccountsEdge";
  /**
   * The one-off short note that users can write on this contact->account relationship.
   */
  relationshipNote: string | null;
  node: GetContactPrimaryAccount_contact_primaryAccount_node;
}

export interface GetContactPrimaryAccount_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The primary account edge for this contact
   */
  primaryAccount: GetContactPrimaryAccount_contact_primaryAccount | null;
}

export interface GetContactPrimaryAccount {
  /**
   * Returns a Nutshell Contact
   */
  contact: GetContactPrimaryAccount_contact | null;
}

export interface GetContactPrimaryAccountVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContact
// ====================================================

export interface GetContact_contact_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface GetContact_contact_creatorUser_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface GetContact_contact_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  firstName: string | null;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
  teams: GetContact_contact_creatorUser_teams[];
}

export interface GetContact_contact_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetContact_contact_primaryAccount_node_postalAddresses_primary_location_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface GetContact_contact_primaryAccount_node_postalAddresses_primary_location_weather {
  __typename: "Weather";
  temperature: string | null;
  condition: string | null;
  location: string | null;
  localTime: string | null;
}

export interface GetContact_contact_primaryAccount_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
  coordinates: GetContact_contact_primaryAccount_node_postalAddresses_primary_location_coordinates | null;
  weather: GetContact_contact_primaryAccount_node_postalAddresses_primary_location_weather | null;
}

export interface GetContact_contact_primaryAccount_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: GetContact_contact_primaryAccount_node_postalAddresses_primary_location;
}

export interface GetContact_contact_primaryAccount_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetContact_contact_primaryAccount_node_postalAddresses_primary | null;
}

export interface GetContact_contact_primaryAccount_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetContact_contact_primaryAccount_node_postalAddresses;
}

export interface GetContact_contact_primaryAccount {
  __typename: "ContactAccountsEdge";
  /**
   * The one-off short note that users can write on this contact->account relationship.
   */
  relationshipNote: string | null;
  node: GetContact_contact_primaryAccount_node;
}

export interface GetContact_contact_leads {
  __typename: "PeepLeadsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetContact_contact_workspaceWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface GetContact_contact_sidebarWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface GetContact_contact_headerFields {
  __typename: "HeaderField";
  /**
   * The type of the header field
   */
  type: HeaderFieldType;
  /**
   * Whether the header field is enabled
   */
  isEnabled: boolean;
  /**
   * The name of the header field
   */
  name: string;
}

export interface GetContact_contact_postalAddresses_primary_location_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface GetContact_contact_postalAddresses_primary_location_weather {
  __typename: "Weather";
  temperature: string | null;
  condition: string | null;
  location: string | null;
  localTime: string | null;
}

export interface GetContact_contact_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The full printable address of this location
   */
  fullPrintableAddress: string | null;
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
  coordinates: GetContact_contact_postalAddresses_primary_location_coordinates | null;
  weather: GetContact_contact_postalAddresses_primary_location_weather | null;
}

export interface GetContact_contact_postalAddresses_primary {
  __typename: "PostalAddress";
  location: GetContact_contact_postalAddresses_primary_location;
}

export interface GetContact_contact_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetContact_contact_postalAddresses_primary | null;
}

export interface GetContact_contact_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetContact_contact_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: GetContact_contact_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface GetContact_contact_tagMaps_edges {
  __typename: "TagMapsEdge";
  node: GetContact_contact_tagMaps_edges_node | null;
}

export interface GetContact_contact_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * A list of edges.
   */
  edges: GetContact_contact_tagMaps_edges[];
}

export interface GetContact_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this entity deleted
   */
  isDeleted: boolean;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  avatarUrl: string;
  hasUploadedAvatar: boolean;
  canDeleteAvatar: boolean;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The terrority to which this peep is assigned.
   */
  territory: GetContact_contact_territory | null;
  /**
   * The user who created this peep.
   */
  creatorUser: GetContact_contact_creatorUser | null;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: GetContact_contact_owner | null;
  /**
   * The primary account edge for this contact
   */
  primaryAccount: GetContact_contact_primaryAccount | null;
  /**
   * Leads related to this peep
   */
  leads: GetContact_contact_leads;
  /**
   * The widgets of the stageset lead workspace
   */
  workspaceWidgets: GetContact_contact_workspaceWidgets[];
  /**
   * The widgets of the stageset lead sidebar
   */
  sidebarWidgets: GetContact_contact_sidebarWidgets[];
  /**
   * The header fields for the entity type
   */
  headerFields: GetContact_contact_headerFields[];
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetContact_contact_postalAddresses;
  /**
   * Tag maps for the peep
   */
  tagMaps: GetContact_contact_tagMaps | null;
}

export interface GetContact {
  /**
   * Returns a Nutshell Contact
   */
  contact: GetContact_contact | null;
}

export interface GetContactVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddAttachmentToContact
// ====================================================

export interface AddAttachmentToContact_contactFilesAdd_contact_files_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface AddAttachmentToContact_contactFilesAdd_contact_files {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * The user who uploaded the file
   */
  creatorUser: AddAttachmentToContact_contactFilesAdd_contact_files_creatorUser | null;
}

export interface AddAttachmentToContact_contactFilesAdd_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The files for this peep
   */
  files: AddAttachmentToContact_contactFilesAdd_contact_files[];
}

export interface AddAttachmentToContact_contactFilesAdd {
  __typename: "ContactFileAddPayload";
  /**
   * The contact that the file was added to
   */
  contact: AddAttachmentToContact_contactFilesAdd_contact;
}

export interface AddAttachmentToContact {
  /**
   * Add a file to a contact
   */
  contactFilesAdd: AddAttachmentToContact_contactFilesAdd;
}

export interface AddAttachmentToContactVariables {
  input: ContactFileAddInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveAttachmentFromContact
// ====================================================

export interface RemoveAttachmentFromContact_contactFileRemove_contact_files_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface RemoveAttachmentFromContact_contactFileRemove_contact_files {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * The user who uploaded the file
   */
  creatorUser: RemoveAttachmentFromContact_contactFileRemove_contact_files_creatorUser | null;
}

export interface RemoveAttachmentFromContact_contactFileRemove_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The files for this peep
   */
  files: RemoveAttachmentFromContact_contactFileRemove_contact_files[];
}

export interface RemoveAttachmentFromContact_contactFileRemove {
  __typename: "ContactFileRemovePayload";
  /**
   * The contact that the file was removed from
   */
  contact: RemoveAttachmentFromContact_contactFileRemove_contact;
}

export interface RemoveAttachmentFromContact {
  /**
   * Remove a file from a contact
   */
  contactFileRemove: RemoveAttachmentFromContact_contactFileRemove;
}

export interface RemoveAttachmentFromContactVariables {
  input: ContactFileRemoveInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAttachmentsForContact
// ====================================================

export interface GetAttachmentsForContact_contact_files_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface GetAttachmentsForContact_contact_files {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * The user who uploaded the file
   */
  creatorUser: GetAttachmentsForContact_contact_files_creatorUser | null;
}

export interface GetAttachmentsForContact_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The files for this peep
   */
  files: GetAttachmentsForContact_contact_files[];
}

export interface GetAttachmentsForContact {
  /**
   * Returns a Nutshell Contact
   */
  contact: GetAttachmentsForContact_contact | null;
}

export interface GetAttachmentsForContactVariables {
  contactId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddAudienceMembership
// ====================================================

export interface AddAudienceMembership_addEntityToAudience_audienceMembers_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
}

export interface AddAudienceMembership_addEntityToAudience_audienceMembers {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: AddAudienceMembership_addEntityToAudience_audienceMembers_audience;
}

export interface AddAudienceMembership_addEntityToAudience {
  __typename: "AddEntityToAudiencePayload";
  /**
   * The new audience memberships
   */
  audienceMembers: AddAudienceMembership_addEntityToAudience_audienceMembers[];
}

export interface AddAudienceMembership {
  /**
   * Adds an entity to a marketing audience. If not a contact, the related contact(s) will be added to the audience.
   */
  addEntityToAudience: AddAudienceMembership_addEntityToAudience;
}

export interface AddAudienceMembershipVariables {
  input: AddEntityToAudienceInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveAudienceMembership
// ====================================================

export interface RemoveAudienceMembership_audienceMemberDelete_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface RemoveAudienceMembership_audienceMemberDelete {
  __typename: "AudienceMemberDeletePayload";
  /**
   * The deleted audience membership
   */
  audienceMember: RemoveAudienceMembership_audienceMemberDelete_audienceMember;
}

export interface RemoveAudienceMembership {
  /**
   * Delete an entity audience membership
   */
  audienceMemberDelete: RemoveAudienceMembership_audienceMemberDelete;
}

export interface RemoveAudienceMembershipVariables {
  input: AudienceMemberDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactAudiences
// ====================================================

export interface GetContactAudiences_contact_audienceMembershipsSubscribed_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
}

export interface GetContactAudiences_contact_audienceMembershipsSubscribed {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: GetContactAudiences_contact_audienceMembershipsSubscribed_audience;
}

export interface GetContactAudiences_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The current membership status of each audience this contact belongs to
   */
  audienceMembershipsSubscribed: GetContactAudiences_contact_audienceMembershipsSubscribed[];
}

export interface GetContactAudiences {
  /**
   * Returns a Nutshell Contact
   */
  contact: GetContactAudiences_contact | null;
}

export interface GetContactAudiencesVariables {
  personId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactEmailUnsubscribe
// ====================================================

export interface GetContactEmailUnsubscribe_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Boolean if the contact has unsubscribed from all marketing emails
   */
  hasUnsubscribedFromAllAudiences: boolean;
  /**
   * Source where the contact unsubscribed from all marketing emails
   */
  unsubscribedFromAllAudiencesSource: UnsubscribeSource | null;
  /**
   * The link for this contact to manage their email preferences
   */
  preferenceCenterLink: string | null;
}

export interface GetContactEmailUnsubscribe {
  /**
   * Returns a Nutshell Contact
   */
  contact: GetContactEmailUnsubscribe_contact | null;
}

export interface GetContactEmailUnsubscribeVariables {
  contactId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateContactLegacyId
// ====================================================

export interface UpdateContactLegacyId_contactUpdate_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The legacy ID for this peep
   */
  legacyId: string | null;
  /**
   * Whether the legacy ID field should be shown for this peep
   */
  shouldShowLegacyId: boolean;
}

export interface UpdateContactLegacyId_contactUpdate {
  __typename: "ContactUpdatePayload";
  /**
   * The updated Nutshell contact.
   */
  contact: UpdateContactLegacyId_contactUpdate_contact;
}

export interface UpdateContactLegacyId {
  /**
   * Updates a Nutshell contact.
   */
  contactUpdate: UpdateContactLegacyId_contactUpdate;
}

export interface UpdateContactLegacyIdVariables {
  input: ContactUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactLegacyId
// ====================================================

export interface GetContactLegacyId_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The legacy ID for this peep
   */
  legacyId: string | null;
  /**
   * Whether the legacy ID field should be shown for this peep
   */
  shouldShowLegacyId: boolean;
}

export interface GetContactLegacyId {
  /**
   * Returns a Nutshell Contact
   */
  contact: GetContactLegacyId_contact | null;
}

export interface GetContactLegacyIdVariables {
  contactId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactPageFormSubmissions
// ====================================================

export interface GetContactPageFormSubmissions_contact_submissions_pageInfo {
  __typename: "PageInfo";
  hasNextPage: boolean;
  endCursor: string | null;
}

export interface GetContactPageFormSubmissions_contact_submissions_edges_node_formVersion_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetContactPageFormSubmissions_contact_submissions_edges_node_formVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent form of this form version
   */
  form: GetContactPageFormSubmissions_contact_submissions_edges_node_formVersion_form;
}

export interface GetContactPageFormSubmissions_contact_submissions_edges_node {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The url where the submission originates
   */
  submissionUrl: string;
  /**
   * The name of the submitted web form
   */
  formVersion: GetContactPageFormSubmissions_contact_submissions_edges_node_formVersion;
}

export interface GetContactPageFormSubmissions_contact_submissions_edges {
  __typename: "SubmissionEdge";
  node: GetContactPageFormSubmissions_contact_submissions_edges_node;
}

export interface GetContactPageFormSubmissions_contact_submissions {
  __typename: "SubmissionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetContactPageFormSubmissions_contact_submissions_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetContactPageFormSubmissions_contact_submissions_edges[];
}

export interface GetContactPageFormSubmissions_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Submissions related to this peep
   */
  submissions: GetContactPageFormSubmissions_contact_submissions;
}

export interface GetContactPageFormSubmissions {
  /**
   * Returns a Nutshell Contact
   */
  contact: GetContactPageFormSubmissions_contact | null;
}

export interface GetContactPageFormSubmissionsVariables {
  id: string;
  first?: number | null;
  after?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateContactSummary
// ====================================================

export interface UpdateContactSummary_contactUpdate_contact_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface UpdateContactSummary_contactUpdate_contact_creatorUser_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface UpdateContactSummary_contactUpdate_contact_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  firstName: string | null;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
  teams: UpdateContactSummary_contactUpdate_contact_creatorUser_teams[];
}

export interface UpdateContactSummary_contactUpdate_contact_mergedWith {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface UpdateContactSummary_contactUpdate_contact_origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  originType: OriginType;
  isInteresting: boolean;
  htmlUrl: string | null;
}

export interface UpdateContactSummary_contactUpdate_contact_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateContactSummary_contactUpdate_contact_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: UpdateContactSummary_contactUpdate_contact_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface UpdateContactSummary_contactUpdate_contact_tagMaps_edges {
  __typename: "TagMapsEdge";
  node: UpdateContactSummary_contactUpdate_contact_tagMaps_edges_node | null;
}

export interface UpdateContactSummary_contactUpdate_contact_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * A list of edges.
   */
  edges: UpdateContactSummary_contactUpdate_contact_tagMaps_edges[];
}

export interface UpdateContactSummary_contactUpdate_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The time this entity was deleted
   */
  deletedTime: any | null;
  /**
   * The terrority to which this peep is assigned.
   */
  territory: UpdateContactSummary_contactUpdate_contact_territory | null;
  /**
   * The user who created this peep.
   */
  creatorUser: UpdateContactSummary_contactUpdate_contact_creatorUser | null;
  /**
   * Entity this contact was merged with
   */
  mergedWith: UpdateContactSummary_contactUpdate_contact_mergedWith | null;
  /**
   * The origin of the peep
   */
  origin: UpdateContactSummary_contactUpdate_contact_origin;
  /**
   * Tag maps for the peep
   */
  tagMaps: UpdateContactSummary_contactUpdate_contact_tagMaps | null;
}

export interface UpdateContactSummary_contactUpdate {
  __typename: "ContactUpdatePayload";
  /**
   * The updated Nutshell contact.
   */
  contact: UpdateContactSummary_contactUpdate_contact;
}

export interface UpdateContactSummary {
  /**
   * Updates a Nutshell contact.
   */
  contactUpdate: UpdateContactSummary_contactUpdate;
}

export interface UpdateContactSummaryVariables {
  input: ContactUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactSummary
// ====================================================

export interface GetContactSummary_contact_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface GetContactSummary_contact_creatorUser_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface GetContactSummary_contact_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  firstName: string | null;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
  teams: GetContactSummary_contact_creatorUser_teams[];
}

export interface GetContactSummary_contact_mergedWith {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetContactSummary_contact_origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  originType: OriginType;
  isInteresting: boolean;
  htmlUrl: string | null;
}

export interface GetContactSummary_contact_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetContactSummary_contact_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: GetContactSummary_contact_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface GetContactSummary_contact_tagMaps_edges {
  __typename: "TagMapsEdge";
  node: GetContactSummary_contact_tagMaps_edges_node | null;
}

export interface GetContactSummary_contact_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * A list of edges.
   */
  edges: GetContactSummary_contact_tagMaps_edges[];
}

export interface GetContactSummary_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The time this entity was deleted
   */
  deletedTime: any | null;
  /**
   * The terrority to which this peep is assigned.
   */
  territory: GetContactSummary_contact_territory | null;
  /**
   * The user who created this peep.
   */
  creatorUser: GetContactSummary_contact_creatorUser | null;
  /**
   * Entity this contact was merged with
   */
  mergedWith: GetContactSummary_contact_mergedWith | null;
  /**
   * The origin of the peep
   */
  origin: GetContactSummary_contact_origin;
  /**
   * Tag maps for the peep
   */
  tagMaps: GetContactSummary_contact_tagMaps | null;
}

export interface GetContactSummary {
  /**
   * Returns a Nutshell Contact
   */
  contact: GetContactSummary_contact | null;
}

export interface GetContactSummaryVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: PeepMergeAll
// ====================================================

export interface PeepMergeAll_peepMergeAll {
  __typename: "PeepMergeAllPayload";
  /**
   * Whether the merge operation was successfully queued
   */
  success: boolean;
}

export interface PeepMergeAll {
  /**
   * Merges all duplicates of the given entity type (contacts or accounts) grouped
   * by the given grouping keys using the specified merge rule
   */
  peepMergeAll: PeepMergeAll_peepMergeAll;
}

export interface PeepMergeAllVariables {
  input: PeepMergeAllInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPeepsBulkMergeHistory
// ====================================================

export interface GetPeepsBulkMergeHistory_bulkEdits_edges_node_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetPeepsBulkMergeHistory_bulkEdits_edges_node_config {
  __typename: "BulkEditConfig";
  /**
   * Whether this bulk-merge job operates on contacts or accounts.
   */
  entityType: EntityType;
  groupBy: PeepDuplicateGroupingKey[];
  mergeRule: PeepDuplicateMergeRule;
  numDuplicates: number;
}

export interface GetPeepsBulkMergeHistory_bulkEdits_edges_node {
  __typename: "BulkEdit";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of the bulk edit
   */
  status: BulkEditStatus;
  /**
   * The time the bulk edit was started
   */
  startedTime: any | null;
  /**
   * The user that initiated the bulk edit
   */
  user: GetPeepsBulkMergeHistory_bulkEdits_edges_node_user | null;
  /**
   * The time the bulk edit was submitted
   */
  createdTime: any;
  config: GetPeepsBulkMergeHistory_bulkEdits_edges_node_config | null;
}

export interface GetPeepsBulkMergeHistory_bulkEdits_edges {
  __typename: "BulkEditsEdge";
  node: GetPeepsBulkMergeHistory_bulkEdits_edges_node;
}

export interface GetPeepsBulkMergeHistory_bulkEdits {
  __typename: "BulkEditsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetPeepsBulkMergeHistory_bulkEdits_edges[];
}

export interface GetPeepsBulkMergeHistory {
  bulkEdits: GetPeepsBulkMergeHistory_bulkEdits | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddEntityToAudience
// ====================================================

export interface AddEntityToAudience_addEntityToAudience_audienceMembers {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface AddEntityToAudience_addEntityToAudience {
  __typename: "AddEntityToAudiencePayload";
  /**
   * The new audience memberships
   */
  audienceMembers: AddEntityToAudience_addEntityToAudience_audienceMembers[];
}

export interface AddEntityToAudience {
  /**
   * Adds an entity to a marketing audience. If not a contact, the related contact(s) will be added to the audience.
   */
  addEntityToAudience: AddEntityToAudience_addEntityToAudience;
}

export interface AddEntityToAudienceVariables {
  audienceId: string;
  entityId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteAudienceMember
// ====================================================

export interface DeleteAudienceMember_audienceMemberDelete_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  deletedTime: any | null;
}

export interface DeleteAudienceMember_audienceMemberDelete {
  __typename: "AudienceMemberDeletePayload";
  /**
   * The deleted audience membership
   */
  audienceMember: DeleteAudienceMember_audienceMemberDelete_audienceMember;
}

export interface DeleteAudienceMember {
  /**
   * Delete an entity audience membership
   */
  audienceMemberDelete: DeleteAudienceMember_audienceMemberDelete;
}

export interface DeleteAudienceMemberVariables {
  audienceMemberId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UnsubscribeContactFromAllAudiences
// ====================================================

export interface UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_emailAddresses_all_deliverabilityStatus_unsubscribeStats_userUnsubscribedBy {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_emailAddresses_all_deliverabilityStatus_unsubscribeStats {
  __typename: "UnsubscribeStats";
  /**
   * The time the email address was globally unsubscribed
   */
  unsubscribeTime: any;
  /**
   * The source of the unsubscribe
   */
  unsubscribeSource: UnsubscribeSource;
  /**
   * The Nutshell user who unsubscribed the email address, if applicable
   */
  userUnsubscribedBy: UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_emailAddresses_all_deliverabilityStatus_unsubscribeStats_userUnsubscribedBy | null;
}

export interface UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_emailAddresses_all_deliverabilityStatus {
  __typename: "DeliverabilityStatus";
  /**
   * The status of deliverability
   */
  status: EmailDeliverabilityStatusType;
  /**
   * The stats for an unsubscribe
   */
  unsubscribeStats: UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_emailAddresses_all_deliverabilityStatus_unsubscribeStats | null;
}

export interface UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_emailAddresses_all {
  __typename: "EmailAddressEav";
  id: string;
  name: string;
  deliverabilityStatus: UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_emailAddresses_all_deliverabilityStatus;
}

export interface UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_emailAddresses_primary_deliverabilityStatus_unsubscribeStats_userUnsubscribedBy {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_emailAddresses_primary_deliverabilityStatus_unsubscribeStats {
  __typename: "UnsubscribeStats";
  /**
   * The time the email address was globally unsubscribed
   */
  unsubscribeTime: any;
  /**
   * The source of the unsubscribe
   */
  unsubscribeSource: UnsubscribeSource;
  /**
   * The Nutshell user who unsubscribed the email address, if applicable
   */
  userUnsubscribedBy: UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_emailAddresses_primary_deliverabilityStatus_unsubscribeStats_userUnsubscribedBy | null;
}

export interface UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_emailAddresses_primary_deliverabilityStatus {
  __typename: "DeliverabilityStatus";
  /**
   * The status of deliverability
   */
  status: EmailDeliverabilityStatusType;
  /**
   * The stats for an unsubscribe
   */
  unsubscribeStats: UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_emailAddresses_primary_deliverabilityStatus_unsubscribeStats | null;
}

export interface UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  id: string;
  deliverabilityStatus: UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_emailAddresses_primary_deliverabilityStatus;
}

export interface UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * An ordered collection of values
   */
  all: UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_emailAddresses_all[];
  /**
   * The property value marked as the primary one.
   */
  primary: UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_emailAddresses_primary | null;
}

export interface UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_audienceMemberships_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
}

export interface UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_audienceMemberships {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_audienceMemberships_audience;
}

export interface UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_audienceMembershipsSubscribed_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
}

export interface UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_audienceMembershipsSubscribed {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_audienceMembershipsSubscribed_audience;
}

export interface UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_audienceMembershipsUnsubscribed_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
}

export interface UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_audienceMembershipsUnsubscribed {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_audienceMembershipsUnsubscribed_audience;
}

export interface UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_phones_primary_deliverabilityStatus {
  __typename: "SmsDeliverabilityStatus";
  /**
   * The deliverability status of the phone number
   */
  status: SmsDeliverabilityStatusType;
  /**
   * The time the phone number was opted out of SMS solicitations
   */
  optOutTime: any | null;
}

export interface UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_phones_primary {
  __typename: "Phone";
  id: string;
  deliverabilityStatus: UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_phones_primary_deliverabilityStatus;
}

export interface UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_phones_all_deliverabilityStatus {
  __typename: "SmsDeliverabilityStatus";
  /**
   * The deliverability status of the phone number
   */
  status: SmsDeliverabilityStatusType;
  /**
   * The time the phone number was opted out of SMS solicitations
   */
  optOutTime: any | null;
}

export interface UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_phones_all {
  __typename: "Phone";
  id: string;
  deliverabilityStatus: UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_phones_all_deliverabilityStatus;
}

export interface UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_phones_primary | null;
  /**
   * An ordered collection of values
   */
  all: UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_phones_all[];
}

export interface UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * Boolean if the contact has unsubscribed from all marketing emails
   */
  hasUnsubscribedFromAllAudiences: boolean;
  /**
   * Source where the contact unsubscribed from all marketing emails
   */
  unsubscribedFromAllAudiencesSource: UnsubscribeSource | null;
  /**
   * Boolean if the contact has hard bounced
   */
  hasHardBounced: boolean;
  /**
   * The link for this contact to manage their email preferences
   */
  preferenceCenterLink: string | null;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_emailAddresses;
  /**
   * The current membership status of each audience this contact belongs to
   */
  audienceMemberships: UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_audienceMemberships[];
  /**
   * The current membership status of each audience this contact belongs to
   */
  audienceMembershipsSubscribed: UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_audienceMembershipsSubscribed[];
  /**
   * The current membership status of each audience this contact belongs to
   */
  audienceMembershipsUnsubscribed: UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_audienceMembershipsUnsubscribed[];
  /**
   * True if the contact has a global unsubscribe for email and their primary SMS number is opted out
   */
  hasUnsubscribedFromEmailAndSmsMarketing: boolean;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact_phones;
}

export interface UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences {
  __typename: "SetIsContactSubscribedToAllAudiencesPayload";
  /**
   * The contact that has been subscribed to / unsubscribed from all audiences
   */
  contact: UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences_contact;
}

export interface UnsubscribeContactFromAllAudiences {
  /**
   * Subscribes or unsubscribes a contact to or from all audiences.
   */
  setIsContactSubscribedToAllAudiences: UnsubscribeContactFromAllAudiences_setIsContactSubscribedToAllAudiences | null;
}

export interface UnsubscribeContactFromAllAudiencesVariables {
  contactId: string;
  shouldPrimaryEmailBeSubscribedToAllAudiences?: boolean | null;
  shouldPrimaryPhoneBeSubscribedToAllAudiences?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactAudienceMemberships
// ====================================================

export interface GetContactAudienceMemberships_contact_emailAddresses_all {
  __typename: "EmailAddressEav";
  id: string;
  name: string;
}

export interface GetContactAudienceMemberships_contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * An ordered collection of values
   */
  all: GetContactAudienceMemberships_contact_emailAddresses_all[];
}

export interface GetContactAudienceMemberships_contact_audienceMemberships_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
}

export interface GetContactAudienceMemberships_contact_audienceMemberships {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: GetContactAudienceMemberships_contact_audienceMemberships_audience;
}

export interface GetContactAudienceMemberships_contact_audienceMembershipsSubscribed_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
}

export interface GetContactAudienceMemberships_contact_audienceMembershipsSubscribed {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: GetContactAudienceMemberships_contact_audienceMembershipsSubscribed_audience;
}

export interface GetContactAudienceMemberships_contact_audienceMembershipsUnsubscribed_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
}

export interface GetContactAudienceMemberships_contact_audienceMembershipsUnsubscribed {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: GetContactAudienceMemberships_contact_audienceMembershipsUnsubscribed_audience;
}

export interface GetContactAudienceMemberships_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * Boolean if the contact has unsubscribed from all marketing emails
   */
  hasUnsubscribedFromAllAudiences: boolean;
  /**
   * Source where the contact unsubscribed from all marketing emails
   */
  unsubscribedFromAllAudiencesSource: UnsubscribeSource | null;
  /**
   * Boolean if the contact has hard bounced
   */
  hasHardBounced: boolean;
  /**
   * The link for this contact to manage their email preferences
   */
  preferenceCenterLink: string | null;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetContactAudienceMemberships_contact_emailAddresses;
  /**
   * The current membership status of each audience this contact belongs to
   */
  audienceMemberships: GetContactAudienceMemberships_contact_audienceMemberships[];
  /**
   * The current membership status of each audience this contact belongs to
   */
  audienceMembershipsSubscribed: GetContactAudienceMemberships_contact_audienceMembershipsSubscribed[];
  /**
   * The current membership status of each audience this contact belongs to
   */
  audienceMembershipsUnsubscribed: GetContactAudienceMemberships_contact_audienceMembershipsUnsubscribed[];
}

export interface GetContactAudienceMemberships {
  /**
   * Returns a Nutshell Contact
   */
  contact: GetContactAudienceMemberships_contact | null;
}

export interface GetContactAudienceMembershipsVariables {
  personId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountDripSequenceProgressions
// ====================================================

export interface GetAccountDripSequenceProgressions_account_contacts_edges_node_dripProgressions_campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetAccountDripSequenceProgressions_account_contacts_edges_node_dripProgressions_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  editions: GetAccountDripSequenceProgressions_account_contacts_edges_node_dripProgressions_campaign_editions;
}

export interface GetAccountDripSequenceProgressions_account_contacts_edges_node_dripProgressions_nextEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetAccountDripSequenceProgressions_account_contacts_edges_node_dripProgressions_nextEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetAccountDripSequenceProgressions_account_contacts_edges_node_dripProgressions_nextEdition_emailTemplate | null;
}

export interface GetAccountDripSequenceProgressions_account_contacts_edges_node_dripProgressions {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
  /**
   * Number of editions that have been sent so far for this progression. NOTE: This
   * can be inaccurate if editions are reordered or an edition is added to the
   * start of the drip after a progression has started. This is ok! We want this
   * number to represent the number of prior active editions, even if they aren’t always sent.
   */
  numEditionsSent: number;
  /**
   * The drip sequence for this drip progressions
   */
  campaign: GetAccountDripSequenceProgressions_account_contacts_edges_node_dripProgressions_campaign;
  /**
   * The next edition in the drip to be sent, null if ended
   */
  nextEdition: GetAccountDripSequenceProgressions_account_contacts_edges_node_dripProgressions_nextEdition | null;
}

export interface GetAccountDripSequenceProgressions_account_contacts_edges_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * List of drip progressions for this contact. By default only active
   * progressions on non-cancelled campaigns are returned. Soft-deleted
   * progressions are always excluded.
   */
  dripProgressions: GetAccountDripSequenceProgressions_account_contacts_edges_node_dripProgressions[];
}

export interface GetAccountDripSequenceProgressions_account_contacts_edges {
  __typename: "AccountContactsEdge";
  node: GetAccountDripSequenceProgressions_account_contacts_edges_node;
}

export interface GetAccountDripSequenceProgressions_account_contacts {
  __typename: "AccountContactsConnection";
  /**
   * A list of edges.
   */
  edges: GetAccountDripSequenceProgressions_account_contacts_edges[];
}

export interface GetAccountDripSequenceProgressions_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to
   * Nutshell Contacts. This allows you to see and query all of the contacts that
   * are related in someway (e.g., they work for) this account. For further
   * reading, see [this blog post explaining GraphQL connection types](https: // dev-blog.apollodata.com/explaining-graphql-connections-c48b7c3d6976).
   */
  contacts: GetAccountDripSequenceProgressions_account_contacts;
}

export interface GetAccountDripSequenceProgressions {
  /**
   * Returns a Nutshell Account
   */
  account: GetAccountDripSequenceProgressions_account | null;
}

export interface GetAccountDripSequenceProgressionsVariables {
  accountId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactDripSequenceProgressions
// ====================================================

export interface GetContactDripSequenceProgressions_contact_dripProgressions_campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetContactDripSequenceProgressions_contact_dripProgressions_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  editions: GetContactDripSequenceProgressions_contact_dripProgressions_campaign_editions;
}

export interface GetContactDripSequenceProgressions_contact_dripProgressions_nextEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetContactDripSequenceProgressions_contact_dripProgressions_nextEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetContactDripSequenceProgressions_contact_dripProgressions_nextEdition_emailTemplate | null;
}

export interface GetContactDripSequenceProgressions_contact_dripProgressions {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
  /**
   * Number of editions that have been sent so far for this progression. NOTE: This
   * can be inaccurate if editions are reordered or an edition is added to the
   * start of the drip after a progression has started. This is ok! We want this
   * number to represent the number of prior active editions, even if they aren’t always sent.
   */
  numEditionsSent: number;
  /**
   * The drip sequence for this drip progressions
   */
  campaign: GetContactDripSequenceProgressions_contact_dripProgressions_campaign;
  /**
   * The next edition in the drip to be sent, null if ended
   */
  nextEdition: GetContactDripSequenceProgressions_contact_dripProgressions_nextEdition | null;
}

export interface GetContactDripSequenceProgressions_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * List of drip progressions for this contact. By default only active
   * progressions on non-cancelled campaigns are returned. Soft-deleted
   * progressions are always excluded.
   */
  dripProgressions: GetContactDripSequenceProgressions_contact_dripProgressions[];
}

export interface GetContactDripSequenceProgressions {
  /**
   * Returns a Nutshell Contact
   */
  contact: GetContactDripSequenceProgressions_contact | null;
}

export interface GetContactDripSequenceProgressionsVariables {
  contactId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetQueuedEmailsForEntity
// ====================================================

export interface GetQueuedEmailsForEntity_coreEntity_queuedEmails_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  htmlUrl: string | null;
}

export interface GetQueuedEmailsForEntity_coreEntity_queuedEmails_to {
  __typename: "NutEmailAddress";
  avatarEntity: GetQueuedEmailsForEntity_coreEntity_queuedEmails_to_avatarEntity | null;
}

export interface GetQueuedEmailsForEntity_coreEntity_queuedEmails_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetQueuedEmailsForEntity_coreEntity_queuedEmails_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  emailSequenceTemplate: GetQueuedEmailsForEntity_coreEntity_queuedEmails_emailSequence_emailSequenceTemplate | null;
}

export interface GetQueuedEmailsForEntity_coreEntity_queuedEmails {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The numerical position of the email in its sequence, if it belongs to one
   */
  messageNumber: number | null;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
  to: GetQueuedEmailsForEntity_coreEntity_queuedEmails_to[];
  /**
   * The parent email sequence of this queued email.
   */
  emailSequence: GetQueuedEmailsForEntity_coreEntity_queuedEmails_emailSequence | null;
}

export interface GetQueuedEmailsForEntity_coreEntity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  queuedEmails: GetQueuedEmailsForEntity_coreEntity_queuedEmails[];
}

export interface GetQueuedEmailsForEntity {
  /**
   * Returns a Nutshell Core entity by id
   */
  coreEntity: GetQueuedEmailsForEntity_coreEntity;
}

export interface GetQueuedEmailsForEntityVariables {
  entityId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSubmission
// ====================================================

export interface GetSubmission_submission_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
  formatted: string;
}

export interface GetSubmission_submission_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  isPrimary: boolean;
  value: GetSubmission_submission_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface GetSubmission_submission_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSubmission_submission_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface GetSubmission_submission_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetSubmission_submission_booking_additionalAttendees_emailAddresses;
}

export interface GetSubmission_submission_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (GetSubmission_submission_booking_additionalAttendees | null)[];
}

export interface GetSubmission_submission_primaryEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetSubmission_submission_primaryEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetSubmission_submission_primaryEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetSubmission_submission_primaryEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetSubmission_submission_primaryEntity_Lead_value | null;
}

export type GetSubmission_submission_primaryEntity = GetSubmission_submission_primaryEntity_Account | GetSubmission_submission_primaryEntity_Contact | GetSubmission_submission_primaryEntity_Lead;

export interface GetSubmission_submission_formVersion_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetSubmission_submission_formVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent form of this form version
   */
  form: GetSubmission_submission_formVersion_form;
}

export interface GetSubmission_submission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface GetSubmission_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface GetSubmission_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: GetSubmission_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export interface GetSubmission_submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface GetSubmission_submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export type GetSubmission_submission_fields_edges_fieldValue = GetSubmission_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields | GetSubmission_submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | GetSubmission_submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle;

export interface GetSubmission_submission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: GetSubmission_submission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: GetSubmission_submission_fields_edges_fieldValue | null;
}

export interface GetSubmission_submission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: GetSubmission_submission_fields_edges[];
}

export interface GetSubmission_submission_notificationLogs_recipient {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSubmission_submission_notificationLogs {
  __typename: "SubmissionNotificationLog";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Team member who received the notification. Null for channels without a user (e.g. webhook).
   */
  recipient: GetSubmission_submission_notificationLogs_recipient | null;
  sendType: NotificationSendType;
  /**
   * True when the notification could not be sent.
   */
  didNotSend: boolean;
  createdTime: any;
}

export interface GetSubmission_submission {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The url where the submission originates
   */
  submissionUrl: string;
  /**
   * The booking associated with this submission (if Scheduler)
   */
  booking: GetSubmission_submission_booking | null;
  /**
   * The primary entity on the submission
   */
  primaryEntity: GetSubmission_submission_primaryEntity | null;
  /**
   * The name of the submitted web form
   */
  formVersion: GetSubmission_submission_formVersion;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: GetSubmission_submission_fields;
  notificationLogs: GetSubmission_submission_notificationLogs[];
}

export interface GetSubmission {
  /**
   * Returns a Nutshell web form submission.
   */
  submission: GetSubmission_submission;
}

export interface GetSubmissionVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreatePeepMap
// ====================================================

export interface CreatePeepMap_peepMapCreate_contact_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface CreatePeepMap_peepMapCreate_contact_phones_primary {
  __typename: "Phone";
  value: CreatePeepMap_peepMapCreate_contact_phones_primary_value;
}

export interface CreatePeepMap_peepMapCreate_contact_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: CreatePeepMap_peepMapCreate_contact_phones_primary | null;
}

export interface CreatePeepMap_peepMapCreate_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: CreatePeepMap_peepMapCreate_contact_phones;
}

export interface CreatePeepMap_peepMapCreate_account_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface CreatePeepMap_peepMapCreate_account_postalAddresses_primary {
  __typename: "PostalAddress";
  location: CreatePeepMap_peepMapCreate_account_postalAddresses_primary_location;
}

export interface CreatePeepMap_peepMapCreate_account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: CreatePeepMap_peepMapCreate_account_postalAddresses_primary | null;
}

export interface CreatePeepMap_peepMapCreate_account_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface CreatePeepMap_peepMapCreate_account_phones_primary {
  __typename: "Phone";
  value: CreatePeepMap_peepMapCreate_account_phones_primary_value;
}

export interface CreatePeepMap_peepMapCreate_account_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: CreatePeepMap_peepMapCreate_account_phones_primary | null;
}

export interface CreatePeepMap_peepMapCreate_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: CreatePeepMap_peepMapCreate_account_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: CreatePeepMap_peepMapCreate_account_phones;
}

export interface CreatePeepMap_peepMapCreate {
  __typename: "PeepMapCreatePayload";
  /**
   * The mapped contact
   */
  contact: CreatePeepMap_peepMapCreate_contact;
  /**
   * The mapped account
   */
  account: CreatePeepMap_peepMapCreate_account;
}

export interface CreatePeepMap {
  /**
   * Creates a new peep map between a contact and an account
   */
  peepMapCreate: CreatePeepMap_peepMapCreate;
}

export interface CreatePeepMapVariables {
  input: PeepMapCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeletePeepMap
// ====================================================

export interface DeletePeepMap_peepMapDelete {
  __typename: "PeepMapDeletePayload";
  /**
   * Whether the map was deleted successfully
   */
  success: boolean | null;
}

export interface DeletePeepMap {
  /**
   * Deletes a peep map between a contact and an account
   */
  peepMapDelete: DeletePeepMap_peepMapDelete;
}

export interface DeletePeepMapVariables {
  input: PeepMapDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdatePeepMap
// ====================================================

export interface UpdatePeepMap_peepMapUpdate_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdatePeepMap_peepMapUpdate_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdatePeepMap_peepMapUpdate {
  __typename: "PeepMapUpdatePayload";
  /**
   * The mapped contact
   */
  contact: UpdatePeepMap_peepMapUpdate_contact;
  /**
   * The mapped account
   */
  account: UpdatePeepMap_peepMapUpdate_account;
}

export interface UpdatePeepMap {
  /**
   * Updates a peep map between a contact and an account
   */
  peepMapUpdate: UpdatePeepMap_peepMapUpdate;
}

export interface UpdatePeepMapVariables {
  input: PeepMapUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdatePeepWidgets
// ====================================================

export interface UpdatePeepWidgets_widgetEntityTypeUpdate_sidebar_OtherWidget {
  __typename: "OtherWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  /**
   * Whether the widget is required
   */
  isRequired: boolean;
  /**
   * Whether the widget is editable
   */
  isEditable: boolean;
  isDisabledByAdmin: boolean;
}

export interface UpdatePeepWidgets_widgetEntityTypeUpdate_sidebar_CustomCustomFieldsWidget_customCustomFields_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable type of the attribute
   */
  displayType: string;
}

export interface UpdatePeepWidgets_widgetEntityTypeUpdate_sidebar_CustomCustomFieldsWidget_customCustomFields {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: UpdatePeepWidgets_widgetEntityTypeUpdate_sidebar_CustomCustomFieldsWidget_customCustomFields_attribute;
}

export interface UpdatePeepWidgets_widgetEntityTypeUpdate_sidebar_CustomCustomFieldsWidget {
  __typename: "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  /**
   * Whether the widget is required
   */
  isRequired: boolean;
  /**
   * Whether the widget is editable
   */
  isEditable: boolean;
  isDisabledByAdmin: boolean;
  /**
   * The custom fields of the widget that can be customized
   */
  customCustomFields: UpdatePeepWidgets_widgetEntityTypeUpdate_sidebar_CustomCustomFieldsWidget_customCustomFields[];
}

export type UpdatePeepWidgets_widgetEntityTypeUpdate_sidebar = UpdatePeepWidgets_widgetEntityTypeUpdate_sidebar_OtherWidget | UpdatePeepWidgets_widgetEntityTypeUpdate_sidebar_CustomCustomFieldsWidget;

export interface UpdatePeepWidgets_widgetEntityTypeUpdate_workspace_OtherWidget {
  __typename: "OtherWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  /**
   * Whether the widget is required
   */
  isRequired: boolean;
  /**
   * Whether the widget is editable
   */
  isEditable: boolean;
  isDisabledByAdmin: boolean;
}

export interface UpdatePeepWidgets_widgetEntityTypeUpdate_workspace_CustomCustomFieldsWidget_customCustomFields_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable type of the attribute
   */
  displayType: string;
}

export interface UpdatePeepWidgets_widgetEntityTypeUpdate_workspace_CustomCustomFieldsWidget_customCustomFields {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: UpdatePeepWidgets_widgetEntityTypeUpdate_workspace_CustomCustomFieldsWidget_customCustomFields_attribute;
}

export interface UpdatePeepWidgets_widgetEntityTypeUpdate_workspace_CustomCustomFieldsWidget {
  __typename: "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  /**
   * Whether the widget is required
   */
  isRequired: boolean;
  /**
   * Whether the widget is editable
   */
  isEditable: boolean;
  isDisabledByAdmin: boolean;
  /**
   * The custom fields of the widget that can be customized
   */
  customCustomFields: UpdatePeepWidgets_widgetEntityTypeUpdate_workspace_CustomCustomFieldsWidget_customCustomFields[];
}

export type UpdatePeepWidgets_widgetEntityTypeUpdate_workspace = UpdatePeepWidgets_widgetEntityTypeUpdate_workspace_OtherWidget | UpdatePeepWidgets_widgetEntityTypeUpdate_workspace_CustomCustomFieldsWidget;

export interface UpdatePeepWidgets_widgetEntityTypeUpdate_headerFields {
  __typename: "HeaderField";
  /**
   * The type of the header field
   */
  type: HeaderFieldType;
  /**
   * Whether the header field is enabled
   */
  isEnabled: boolean;
  /**
   * The name of the header field
   */
  name: string;
}

export interface UpdatePeepWidgets_widgetEntityTypeUpdate {
  __typename: "WidgetEntityTypeUpdatePayload";
  /**
   * The updated sidebar widgets
   */
  sidebar: UpdatePeepWidgets_widgetEntityTypeUpdate_sidebar[];
  /**
   * The updated workspace widgets
   */
  workspace: UpdatePeepWidgets_widgetEntityTypeUpdate_workspace[];
  /**
   * The updated header fields
   */
  headerFields: UpdatePeepWidgets_widgetEntityTypeUpdate_headerFields[];
}

export interface UpdatePeepWidgets {
  /**
   * Updates the state of widgets for a given entity type
   */
  widgetEntityTypeUpdate: UpdatePeepWidgets_widgetEntityTypeUpdate | null;
}

export interface UpdatePeepWidgetsVariables {
  input: WidgetEntityTypeUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPeepWidgets
// ====================================================

export interface GetPeepWidgets_entityTypeWidgets_workspaceWidgets_OtherWidget {
  __typename: "OtherWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  /**
   * Whether the widget is required
   */
  isRequired: boolean;
  /**
   * Whether the widget is editable
   */
  isEditable: boolean;
  isDisabledByAdmin: boolean;
}

export interface GetPeepWidgets_entityTypeWidgets_workspaceWidgets_CustomCustomFieldsWidget_customCustomFields_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable type of the attribute
   */
  displayType: string;
}

export interface GetPeepWidgets_entityTypeWidgets_workspaceWidgets_CustomCustomFieldsWidget_customCustomFields {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: GetPeepWidgets_entityTypeWidgets_workspaceWidgets_CustomCustomFieldsWidget_customCustomFields_attribute;
}

export interface GetPeepWidgets_entityTypeWidgets_workspaceWidgets_CustomCustomFieldsWidget {
  __typename: "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  /**
   * Whether the widget is required
   */
  isRequired: boolean;
  /**
   * Whether the widget is editable
   */
  isEditable: boolean;
  isDisabledByAdmin: boolean;
  /**
   * The custom fields of the widget that can be customized
   */
  customCustomFields: GetPeepWidgets_entityTypeWidgets_workspaceWidgets_CustomCustomFieldsWidget_customCustomFields[];
}

export type GetPeepWidgets_entityTypeWidgets_workspaceWidgets = GetPeepWidgets_entityTypeWidgets_workspaceWidgets_OtherWidget | GetPeepWidgets_entityTypeWidgets_workspaceWidgets_CustomCustomFieldsWidget;

export interface GetPeepWidgets_entityTypeWidgets_sidebarWidgets_OtherWidget {
  __typename: "OtherWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  /**
   * Whether the widget is required
   */
  isRequired: boolean;
  /**
   * Whether the widget is editable
   */
  isEditable: boolean;
  isDisabledByAdmin: boolean;
}

export interface GetPeepWidgets_entityTypeWidgets_sidebarWidgets_CustomCustomFieldsWidget_customCustomFields_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable type of the attribute
   */
  displayType: string;
}

export interface GetPeepWidgets_entityTypeWidgets_sidebarWidgets_CustomCustomFieldsWidget_customCustomFields {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: GetPeepWidgets_entityTypeWidgets_sidebarWidgets_CustomCustomFieldsWidget_customCustomFields_attribute;
}

export interface GetPeepWidgets_entityTypeWidgets_sidebarWidgets_CustomCustomFieldsWidget {
  __typename: "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  /**
   * Whether the widget is required
   */
  isRequired: boolean;
  /**
   * Whether the widget is editable
   */
  isEditable: boolean;
  isDisabledByAdmin: boolean;
  /**
   * The custom fields of the widget that can be customized
   */
  customCustomFields: GetPeepWidgets_entityTypeWidgets_sidebarWidgets_CustomCustomFieldsWidget_customCustomFields[];
}

export type GetPeepWidgets_entityTypeWidgets_sidebarWidgets = GetPeepWidgets_entityTypeWidgets_sidebarWidgets_OtherWidget | GetPeepWidgets_entityTypeWidgets_sidebarWidgets_CustomCustomFieldsWidget;

export interface GetPeepWidgets_entityTypeWidgets_headerFields {
  __typename: "HeaderField";
  /**
   * The type of the header field
   */
  type: HeaderFieldType;
  /**
   * Whether the header field is enabled
   */
  isEnabled: boolean;
  /**
   * The name of the header field
   */
  name: string;
}

export interface GetPeepWidgets_entityTypeWidgets {
  __typename: "EntityTypeWidgets";
  /**
   * Widgets for the entity types workspace
   */
  workspaceWidgets: GetPeepWidgets_entityTypeWidgets_workspaceWidgets[];
  /**
   * Widgets for the entity types sidebar
   */
  sidebarWidgets: GetPeepWidgets_entityTypeWidgets_sidebarWidgets[];
  /**
   * The header fields for the entity type
   */
  headerFields: GetPeepWidgets_entityTypeWidgets_headerFields[];
}

export interface GetPeepWidgets {
  /**
   * Returns the widgets for a given entity type
   */
  entityTypeWidgets: GetPeepWidgets_entityTypeWidgets;
}

export interface GetPeepWidgetsVariables {
  entityType: WidgetEntityType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: QuickbooksCreateOrUpdateCustomer
// ====================================================

export interface QuickbooksCreateOrUpdateCustomer_quickbooksCreateOrUpdateCustomer_peep {
  __typename: "Account" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface QuickbooksCreateOrUpdateCustomer_quickbooksCreateOrUpdateCustomer {
  __typename: "QuickbooksCreateOrUpdateCustomerPayload";
  /**
   * The updated Nutshell Contact
   */
  peep: QuickbooksCreateOrUpdateCustomer_quickbooksCreateOrUpdateCustomer_peep;
}

export interface QuickbooksCreateOrUpdateCustomer {
  /**
   * Creates or updates a Quickbooks customer from a Nutshell contact
   */
  quickbooksCreateOrUpdateCustomer: QuickbooksCreateOrUpdateCustomer_quickbooksCreateOrUpdateCustomer;
}

export interface QuickbooksCreateOrUpdateCustomerVariables {
  input: QuickbooksCreateOrUpdateCustomerInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddPeepOmnifield
// ====================================================

export interface AddPeepOmnifield_entityOmnifieldAdd_entity_emailAddresses_all_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface AddPeepOmnifield_entityOmnifieldAdd_entity_emailAddresses_all_deliverabilityStatus_unsubscribeStats_userUnsubscribedBy {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface AddPeepOmnifield_entityOmnifieldAdd_entity_emailAddresses_all_deliverabilityStatus_unsubscribeStats {
  __typename: "UnsubscribeStats";
  /**
   * The time the email address was globally unsubscribed
   */
  unsubscribeTime: any;
  /**
   * The source of the unsubscribe
   */
  unsubscribeSource: UnsubscribeSource;
  /**
   * The Nutshell user who unsubscribed the email address, if applicable
   */
  userUnsubscribedBy: AddPeepOmnifield_entityOmnifieldAdd_entity_emailAddresses_all_deliverabilityStatus_unsubscribeStats_userUnsubscribedBy | null;
}

export interface AddPeepOmnifield_entityOmnifieldAdd_entity_emailAddresses_all_deliverabilityStatus {
  __typename: "DeliverabilityStatus";
  /**
   * The status of deliverability
   */
  status: EmailDeliverabilityStatusType;
  /**
   * The stats for an unsubscribe
   */
  unsubscribeStats: AddPeepOmnifield_entityOmnifieldAdd_entity_emailAddresses_all_deliverabilityStatus_unsubscribeStats | null;
}

export interface AddPeepOmnifield_entityOmnifieldAdd_entity_emailAddresses_all {
  __typename: "EmailAddressEav";
  id: string;
  name: string;
  isPrimary: boolean;
  isFormer: boolean;
  value: AddPeepOmnifield_entityOmnifieldAdd_entity_emailAddresses_all_value;
  deliverabilityStatus: AddPeepOmnifield_entityOmnifieldAdd_entity_emailAddresses_all_deliverabilityStatus;
}

export interface AddPeepOmnifield_entityOmnifieldAdd_entity_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * An ordered collection of values
   */
  all: AddPeepOmnifield_entityOmnifieldAdd_entity_emailAddresses_all[];
}

export interface AddPeepOmnifield_entityOmnifieldAdd_entity_phones_all_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface AddPeepOmnifield_entityOmnifieldAdd_entity_phones_all_deliverabilityStatus {
  __typename: "SmsDeliverabilityStatus";
  /**
   * The deliverability status of the phone number
   */
  status: SmsDeliverabilityStatusType;
  /**
   * The time the phone number was opted out of SMS solicitations
   */
  optOutTime: any | null;
}

export interface AddPeepOmnifield_entityOmnifieldAdd_entity_phones_all {
  __typename: "Phone";
  id: string;
  name: string;
  isPrimary: boolean;
  isFormer: boolean;
  value: AddPeepOmnifield_entityOmnifieldAdd_entity_phones_all_value;
  deliverabilityStatus: AddPeepOmnifield_entityOmnifieldAdd_entity_phones_all_deliverabilityStatus;
}

export interface AddPeepOmnifield_entityOmnifieldAdd_entity_phones {
  __typename: "PhonesConnection";
  /**
   * An ordered collection of values
   */
  all: AddPeepOmnifield_entityOmnifieldAdd_entity_phones_all[];
}

export interface AddPeepOmnifield_entityOmnifieldAdd_entity_postalAddresses_all_location {
  __typename: "Location";
  /**
   * The full printable address of this location
   */
  fullPrintableAddress: string | null;
  /**
   * Street address
   */
  address_1: string | null;
  /**
   * Street address, continued
   */
  address_2: string | null;
  /**
   * Street address, continued
   */
  address_3: string | null;
  /**
   * City of this address
   */
  city: string | null;
  /**
   * [ISO 3166-2](https:         // en.wikipedia.org/wiki/ISO_3166-2) state code of this address
   */
  state: string | null;
  /**
   * Postal/zip code of this address
   */
  postal_code: string | null;
  /**
   * [ISO 3166-1 alpha-2](https: // en.wikipedia.org/wiki/ISO_3166-1_alpha-2) country code of this address
   */
  country: string | null;
}

export interface AddPeepOmnifield_entityOmnifieldAdd_entity_postalAddresses_all {
  __typename: "PostalAddress";
  id: string;
  name: string;
  isPrimary: boolean;
  isFormer: boolean;
  location: AddPeepOmnifield_entityOmnifieldAdd_entity_postalAddresses_all_location;
}

export interface AddPeepOmnifield_entityOmnifieldAdd_entity_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * An ordered collection of values
   */
  all: AddPeepOmnifield_entityOmnifieldAdd_entity_postalAddresses_all[];
}

export interface AddPeepOmnifield_entityOmnifieldAdd_entity_urls_all {
  __typename: "URL";
  id: string;
  name: string;
  value: string | null;
  isPrimary: boolean;
  /**
   * User-friendly display text for this URL, such as `@handle` for Twitter profiles.
   */
  displayValue: string;
  /**
   * Recognized social platform based on the URL host. Null for non-social URLs.
   */
  socialPlatform: SocialPlatform | null;
}

export interface AddPeepOmnifield_entityOmnifieldAdd_entity_urls {
  __typename: "UrlsConnection";
  /**
   * An ordered collection of values
   */
  all: AddPeepOmnifield_entityOmnifieldAdd_entity_urls_all[];
}

export interface AddPeepOmnifield_entityOmnifieldAdd_entity {
  __typename: "Account" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The paging collection of email addresses for this peep.
   */
  emailAddresses: AddPeepOmnifield_entityOmnifieldAdd_entity_emailAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: AddPeepOmnifield_entityOmnifieldAdd_entity_phones;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: AddPeepOmnifield_entityOmnifieldAdd_entity_postalAddresses;
  /**
   * The paging collection of URLs.
   */
  urls: AddPeepOmnifield_entityOmnifieldAdd_entity_urls;
}

export interface AddPeepOmnifield_entityOmnifieldAdd {
  __typename: "OmnifieldAddPayload";
  entity: AddPeepOmnifield_entityOmnifieldAdd_entity;
}

export interface AddPeepOmnifield {
  /**
   * Parses and appends one omnifield value to a supported entity.
   */
  entityOmnifieldAdd: AddPeepOmnifield_entityOmnifieldAdd;
}

export interface AddPeepOmnifieldVariables {
  input: OmnifieldAddInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditAccountBusinessCardField
// ====================================================

export interface EditAccountBusinessCardField_accountEavPatch_account_emailAddresses_all_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface EditAccountBusinessCardField_accountEavPatch_account_emailAddresses_all_deliverabilityStatus_unsubscribeStats_userUnsubscribedBy {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EditAccountBusinessCardField_accountEavPatch_account_emailAddresses_all_deliverabilityStatus_unsubscribeStats {
  __typename: "UnsubscribeStats";
  /**
   * The time the email address was globally unsubscribed
   */
  unsubscribeTime: any;
  /**
   * The source of the unsubscribe
   */
  unsubscribeSource: UnsubscribeSource;
  /**
   * The Nutshell user who unsubscribed the email address, if applicable
   */
  userUnsubscribedBy: EditAccountBusinessCardField_accountEavPatch_account_emailAddresses_all_deliverabilityStatus_unsubscribeStats_userUnsubscribedBy | null;
}

export interface EditAccountBusinessCardField_accountEavPatch_account_emailAddresses_all_deliverabilityStatus {
  __typename: "DeliverabilityStatus";
  /**
   * The status of deliverability
   */
  status: EmailDeliverabilityStatusType;
  /**
   * The stats for an unsubscribe
   */
  unsubscribeStats: EditAccountBusinessCardField_accountEavPatch_account_emailAddresses_all_deliverabilityStatus_unsubscribeStats | null;
}

export interface EditAccountBusinessCardField_accountEavPatch_account_emailAddresses_all {
  __typename: "EmailAddressEav";
  id: string;
  name: string;
  isPrimary: boolean;
  isFormer: boolean;
  value: EditAccountBusinessCardField_accountEavPatch_account_emailAddresses_all_value;
  deliverabilityStatus: EditAccountBusinessCardField_accountEavPatch_account_emailAddresses_all_deliverabilityStatus;
}

export interface EditAccountBusinessCardField_accountEavPatch_account_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * An ordered collection of values
   */
  all: EditAccountBusinessCardField_accountEavPatch_account_emailAddresses_all[];
}

export interface EditAccountBusinessCardField_accountEavPatch_account_phones_all_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface EditAccountBusinessCardField_accountEavPatch_account_phones_all_deliverabilityStatus {
  __typename: "SmsDeliverabilityStatus";
  /**
   * The deliverability status of the phone number
   */
  status: SmsDeliverabilityStatusType;
  /**
   * The time the phone number was opted out of SMS solicitations
   */
  optOutTime: any | null;
}

export interface EditAccountBusinessCardField_accountEavPatch_account_phones_all {
  __typename: "Phone";
  id: string;
  name: string;
  isPrimary: boolean;
  isFormer: boolean;
  value: EditAccountBusinessCardField_accountEavPatch_account_phones_all_value;
  deliverabilityStatus: EditAccountBusinessCardField_accountEavPatch_account_phones_all_deliverabilityStatus;
}

export interface EditAccountBusinessCardField_accountEavPatch_account_phones {
  __typename: "PhonesConnection";
  /**
   * An ordered collection of values
   */
  all: EditAccountBusinessCardField_accountEavPatch_account_phones_all[];
}

export interface EditAccountBusinessCardField_accountEavPatch_account_postalAddresses_all_location {
  __typename: "Location";
  /**
   * The full printable address of this location
   */
  fullPrintableAddress: string | null;
  /**
   * Street address
   */
  address_1: string | null;
  /**
   * Street address, continued
   */
  address_2: string | null;
  /**
   * Street address, continued
   */
  address_3: string | null;
  /**
   * City of this address
   */
  city: string | null;
  /**
   * [ISO 3166-2](https:         // en.wikipedia.org/wiki/ISO_3166-2) state code of this address
   */
  state: string | null;
  /**
   * Postal/zip code of this address
   */
  postal_code: string | null;
  /**
   * [ISO 3166-1 alpha-2](https: // en.wikipedia.org/wiki/ISO_3166-1_alpha-2) country code of this address
   */
  country: string | null;
}

export interface EditAccountBusinessCardField_accountEavPatch_account_postalAddresses_all {
  __typename: "PostalAddress";
  id: string;
  name: string;
  isPrimary: boolean;
  isFormer: boolean;
  location: EditAccountBusinessCardField_accountEavPatch_account_postalAddresses_all_location;
}

export interface EditAccountBusinessCardField_accountEavPatch_account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * An ordered collection of values
   */
  all: EditAccountBusinessCardField_accountEavPatch_account_postalAddresses_all[];
}

export interface EditAccountBusinessCardField_accountEavPatch_account_urls_all {
  __typename: "URL";
  id: string;
  name: string;
  value: string | null;
  isPrimary: boolean;
  /**
   * User-friendly display text for this URL, such as `@handle` for Twitter profiles.
   */
  displayValue: string;
  /**
   * Recognized social platform based on the URL host. Null for non-social URLs.
   */
  socialPlatform: SocialPlatform | null;
}

export interface EditAccountBusinessCardField_accountEavPatch_account_urls {
  __typename: "UrlsConnection";
  /**
   * An ordered collection of values
   */
  all: EditAccountBusinessCardField_accountEavPatch_account_urls_all[];
}

export interface EditAccountBusinessCardField_accountEavPatch_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: EditAccountBusinessCardField_accountEavPatch_account_emailAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: EditAccountBusinessCardField_accountEavPatch_account_phones;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: EditAccountBusinessCardField_accountEavPatch_account_postalAddresses;
  /**
   * The paging collection of URLs.
   */
  urls: EditAccountBusinessCardField_accountEavPatch_account_urls;
}

export interface EditAccountBusinessCardField_accountEavPatch {
  __typename: "AccountEavPatchPayload";
  account: EditAccountBusinessCardField_accountEavPatch_account;
}

export interface EditAccountBusinessCardField {
  /**
   * Updates one EAV value on an account.
   */
  accountEavPatch: EditAccountBusinessCardField_accountEavPatch;
}

export interface EditAccountBusinessCardFieldVariables {
  input: EavPatchInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: EditContactBusinessCardField
// ====================================================

export interface EditContactBusinessCardField_contactEavPatch_contact_emailAddresses_all_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface EditContactBusinessCardField_contactEavPatch_contact_emailAddresses_all_deliverabilityStatus_unsubscribeStats_userUnsubscribedBy {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EditContactBusinessCardField_contactEavPatch_contact_emailAddresses_all_deliverabilityStatus_unsubscribeStats {
  __typename: "UnsubscribeStats";
  /**
   * The time the email address was globally unsubscribed
   */
  unsubscribeTime: any;
  /**
   * The source of the unsubscribe
   */
  unsubscribeSource: UnsubscribeSource;
  /**
   * The Nutshell user who unsubscribed the email address, if applicable
   */
  userUnsubscribedBy: EditContactBusinessCardField_contactEavPatch_contact_emailAddresses_all_deliverabilityStatus_unsubscribeStats_userUnsubscribedBy | null;
}

export interface EditContactBusinessCardField_contactEavPatch_contact_emailAddresses_all_deliverabilityStatus {
  __typename: "DeliverabilityStatus";
  /**
   * The status of deliverability
   */
  status: EmailDeliverabilityStatusType;
  /**
   * The stats for an unsubscribe
   */
  unsubscribeStats: EditContactBusinessCardField_contactEavPatch_contact_emailAddresses_all_deliverabilityStatus_unsubscribeStats | null;
}

export interface EditContactBusinessCardField_contactEavPatch_contact_emailAddresses_all {
  __typename: "EmailAddressEav";
  id: string;
  name: string;
  isPrimary: boolean;
  isFormer: boolean;
  value: EditContactBusinessCardField_contactEavPatch_contact_emailAddresses_all_value;
  deliverabilityStatus: EditContactBusinessCardField_contactEavPatch_contact_emailAddresses_all_deliverabilityStatus;
}

export interface EditContactBusinessCardField_contactEavPatch_contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * An ordered collection of values
   */
  all: EditContactBusinessCardField_contactEavPatch_contact_emailAddresses_all[];
}

export interface EditContactBusinessCardField_contactEavPatch_contact_phones_all_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface EditContactBusinessCardField_contactEavPatch_contact_phones_all_deliverabilityStatus {
  __typename: "SmsDeliverabilityStatus";
  /**
   * The deliverability status of the phone number
   */
  status: SmsDeliverabilityStatusType;
  /**
   * The time the phone number was opted out of SMS solicitations
   */
  optOutTime: any | null;
}

export interface EditContactBusinessCardField_contactEavPatch_contact_phones_all {
  __typename: "Phone";
  id: string;
  name: string;
  isPrimary: boolean;
  isFormer: boolean;
  value: EditContactBusinessCardField_contactEavPatch_contact_phones_all_value;
  deliverabilityStatus: EditContactBusinessCardField_contactEavPatch_contact_phones_all_deliverabilityStatus;
}

export interface EditContactBusinessCardField_contactEavPatch_contact_phones {
  __typename: "PhonesConnection";
  /**
   * An ordered collection of values
   */
  all: EditContactBusinessCardField_contactEavPatch_contact_phones_all[];
}

export interface EditContactBusinessCardField_contactEavPatch_contact_postalAddresses_all_location {
  __typename: "Location";
  /**
   * The full printable address of this location
   */
  fullPrintableAddress: string | null;
  /**
   * Street address
   */
  address_1: string | null;
  /**
   * Street address, continued
   */
  address_2: string | null;
  /**
   * Street address, continued
   */
  address_3: string | null;
  /**
   * City of this address
   */
  city: string | null;
  /**
   * [ISO 3166-2](https:         // en.wikipedia.org/wiki/ISO_3166-2) state code of this address
   */
  state: string | null;
  /**
   * Postal/zip code of this address
   */
  postal_code: string | null;
  /**
   * [ISO 3166-1 alpha-2](https: // en.wikipedia.org/wiki/ISO_3166-1_alpha-2) country code of this address
   */
  country: string | null;
}

export interface EditContactBusinessCardField_contactEavPatch_contact_postalAddresses_all {
  __typename: "PostalAddress";
  id: string;
  name: string;
  isPrimary: boolean;
  isFormer: boolean;
  location: EditContactBusinessCardField_contactEavPatch_contact_postalAddresses_all_location;
}

export interface EditContactBusinessCardField_contactEavPatch_contact_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * An ordered collection of values
   */
  all: EditContactBusinessCardField_contactEavPatch_contact_postalAddresses_all[];
}

export interface EditContactBusinessCardField_contactEavPatch_contact_urls_all {
  __typename: "URL";
  id: string;
  name: string;
  value: string | null;
  isPrimary: boolean;
  /**
   * User-friendly display text for this URL, such as `@handle` for Twitter profiles.
   */
  displayValue: string;
  /**
   * Recognized social platform based on the URL host. Null for non-social URLs.
   */
  socialPlatform: SocialPlatform | null;
}

export interface EditContactBusinessCardField_contactEavPatch_contact_urls {
  __typename: "UrlsConnection";
  /**
   * An ordered collection of values
   */
  all: EditContactBusinessCardField_contactEavPatch_contact_urls_all[];
}

export interface EditContactBusinessCardField_contactEavPatch_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: EditContactBusinessCardField_contactEavPatch_contact_emailAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: EditContactBusinessCardField_contactEavPatch_contact_phones;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: EditContactBusinessCardField_contactEavPatch_contact_postalAddresses;
  /**
   * The paging collection of URLs.
   */
  urls: EditContactBusinessCardField_contactEavPatch_contact_urls;
}

export interface EditContactBusinessCardField_contactEavPatch {
  __typename: "ContactEavPatchPayload";
  contact: EditContactBusinessCardField_contactEavPatch_contact;
}

export interface EditContactBusinessCardField {
  /**
   * Updates one EAV value on a contact.
   */
  contactEavPatch: EditContactBusinessCardField_contactEavPatch;
}

export interface EditContactBusinessCardFieldVariables {
  input: EavPatchInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPeepBusinessCardInfo
// ====================================================

export interface GetPeepBusinessCardInfo_peep_emailAddresses_all_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetPeepBusinessCardInfo_peep_emailAddresses_all_deliverabilityStatus_unsubscribeStats_userUnsubscribedBy {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetPeepBusinessCardInfo_peep_emailAddresses_all_deliverabilityStatus_unsubscribeStats {
  __typename: "UnsubscribeStats";
  /**
   * The time the email address was globally unsubscribed
   */
  unsubscribeTime: any;
  /**
   * The source of the unsubscribe
   */
  unsubscribeSource: UnsubscribeSource;
  /**
   * The Nutshell user who unsubscribed the email address, if applicable
   */
  userUnsubscribedBy: GetPeepBusinessCardInfo_peep_emailAddresses_all_deliverabilityStatus_unsubscribeStats_userUnsubscribedBy | null;
}

export interface GetPeepBusinessCardInfo_peep_emailAddresses_all_deliverabilityStatus {
  __typename: "DeliverabilityStatus";
  /**
   * The status of deliverability
   */
  status: EmailDeliverabilityStatusType;
  /**
   * The stats for an unsubscribe
   */
  unsubscribeStats: GetPeepBusinessCardInfo_peep_emailAddresses_all_deliverabilityStatus_unsubscribeStats | null;
}

export interface GetPeepBusinessCardInfo_peep_emailAddresses_all {
  __typename: "EmailAddressEav";
  id: string;
  name: string;
  isPrimary: boolean;
  isFormer: boolean;
  value: GetPeepBusinessCardInfo_peep_emailAddresses_all_value;
  deliverabilityStatus: GetPeepBusinessCardInfo_peep_emailAddresses_all_deliverabilityStatus;
}

export interface GetPeepBusinessCardInfo_peep_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * An ordered collection of values
   */
  all: GetPeepBusinessCardInfo_peep_emailAddresses_all[];
}

export interface GetPeepBusinessCardInfo_peep_phones_all_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface GetPeepBusinessCardInfo_peep_phones_all_deliverabilityStatus {
  __typename: "SmsDeliverabilityStatus";
  /**
   * The deliverability status of the phone number
   */
  status: SmsDeliverabilityStatusType;
  /**
   * The time the phone number was opted out of SMS solicitations
   */
  optOutTime: any | null;
}

export interface GetPeepBusinessCardInfo_peep_phones_all {
  __typename: "Phone";
  id: string;
  name: string;
  isPrimary: boolean;
  isFormer: boolean;
  value: GetPeepBusinessCardInfo_peep_phones_all_value;
  deliverabilityStatus: GetPeepBusinessCardInfo_peep_phones_all_deliverabilityStatus;
}

export interface GetPeepBusinessCardInfo_peep_phones {
  __typename: "PhonesConnection";
  /**
   * An ordered collection of values
   */
  all: GetPeepBusinessCardInfo_peep_phones_all[];
}

export interface GetPeepBusinessCardInfo_peep_postalAddresses_all_location {
  __typename: "Location";
  /**
   * The full printable address of this location
   */
  fullPrintableAddress: string | null;
  /**
   * Street address
   */
  address_1: string | null;
  /**
   * Street address, continued
   */
  address_2: string | null;
  /**
   * Street address, continued
   */
  address_3: string | null;
  /**
   * City of this address
   */
  city: string | null;
  /**
   * [ISO 3166-2](https:         // en.wikipedia.org/wiki/ISO_3166-2) state code of this address
   */
  state: string | null;
  /**
   * Postal/zip code of this address
   */
  postal_code: string | null;
  /**
   * [ISO 3166-1 alpha-2](https: // en.wikipedia.org/wiki/ISO_3166-1_alpha-2) country code of this address
   */
  country: string | null;
}

export interface GetPeepBusinessCardInfo_peep_postalAddresses_all {
  __typename: "PostalAddress";
  id: string;
  name: string;
  isPrimary: boolean;
  isFormer: boolean;
  location: GetPeepBusinessCardInfo_peep_postalAddresses_all_location;
}

export interface GetPeepBusinessCardInfo_peep_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * An ordered collection of values
   */
  all: GetPeepBusinessCardInfo_peep_postalAddresses_all[];
}

export interface GetPeepBusinessCardInfo_peep_urls_all {
  __typename: "URL";
  id: string;
  name: string;
  value: string | null;
  isPrimary: boolean;
  /**
   * User-friendly display text for this URL, such as `@handle` for Twitter profiles.
   */
  displayValue: string;
  /**
   * Recognized social platform based on the URL host. Null for non-social URLs.
   */
  socialPlatform: SocialPlatform | null;
}

export interface GetPeepBusinessCardInfo_peep_urls {
  __typename: "UrlsConnection";
  /**
   * An ordered collection of values
   */
  all: GetPeepBusinessCardInfo_peep_urls_all[];
}

export interface GetPeepBusinessCardInfo_peep {
  __typename: "Account" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The paging collection of email addresses for this peep.
   */
  emailAddresses: GetPeepBusinessCardInfo_peep_emailAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetPeepBusinessCardInfo_peep_phones;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetPeepBusinessCardInfo_peep_postalAddresses;
  /**
   * The paging collection of URLs.
   */
  urls: GetPeepBusinessCardInfo_peep_urls;
}

export interface GetPeepBusinessCardInfo {
  /**
   * Returns a Nutshell peep
   */
  peep: GetPeepBusinessCardInfo_peep;
}

export interface GetPeepBusinessCardInfoVariables {
  entityId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPeepLabelOptions
// ====================================================

export interface GetPeepLabelOptions_peepLabelOptions {
  __typename: "PeepLabelOptions";
  phones: string[];
  emailAddresses: string[];
  postalAddresses: string[];
  urls: string[];
}

export interface GetPeepLabelOptions {
  /**
   * Predefined label options for peep contact details such as phone, email, postal address, and url.
   */
  peepLabelOptions: GetPeepLabelOptions_peepLabelOptions;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountChildLeads
// ====================================================

export interface GetAccountChildLeads_account_childLeads_edges_node_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetAccountChildLeads_account_childLeads_edges_node_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetAccountChildLeads_account_childLeads_edges_node_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetAccountChildLeads_account_childLeads_edges_node_contacts_primaryEdge_node;
}

export interface GetAccountChildLeads_account_childLeads_edges_node_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetAccountChildLeads_account_childLeads_edges_node_contacts_primaryEdge | null;
}

export interface GetAccountChildLeads_account_childLeads_edges_node_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetAccountChildLeads_account_childLeads_edges_node_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetAccountChildLeads_account_childLeads_edges_node_accounts_primaryEdge_node;
}

export interface GetAccountChildLeads_account_childLeads_edges_node_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetAccountChildLeads_account_childLeads_edges_node_accounts_primaryEdge | null;
}

export interface GetAccountChildLeads_account_childLeads_edges_node_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetAccountChildLeads_account_childLeads_edges_node {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  value: GetAccountChildLeads_account_childLeads_edges_node_value | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  avatarUrl: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetAccountChildLeads_account_childLeads_edges_node_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetAccountChildLeads_account_childLeads_edges_node_accounts;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetAccountChildLeads_account_childLeads_edges_node_assignee | null;
}

export interface GetAccountChildLeads_account_childLeads_edges {
  __typename: "PeepLeadsEdge";
  node: GetAccountChildLeads_account_childLeads_edges_node;
}

export interface GetAccountChildLeads_account_childLeads_subsidiaryStats_all_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetAccountChildLeads_account_childLeads_subsidiaryStats_all_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetAccountChildLeads_account_childLeads_subsidiaryStats_all_value_formattedValue;
}

export interface GetAccountChildLeads_account_childLeads_subsidiaryStats_all {
  __typename: "LeadStat";
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  count: number;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  status: LeadStatus;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  value: GetAccountChildLeads_account_childLeads_subsidiaryStats_all_value;
}

export interface GetAccountChildLeads_account_childLeads_subsidiaryStats_openAndPending_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetAccountChildLeads_account_childLeads_subsidiaryStats_openAndPending_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetAccountChildLeads_account_childLeads_subsidiaryStats_openAndPending_value_formattedValue;
}

export interface GetAccountChildLeads_account_childLeads_subsidiaryStats_openAndPending {
  __typename: "LeadStat";
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  count: number;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  status: LeadStatus;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  value: GetAccountChildLeads_account_childLeads_subsidiaryStats_openAndPending_value;
}

export interface GetAccountChildLeads_account_childLeads_subsidiaryStats {
  __typename: "LeadStats";
  /**
   * All the stats, boi
   */
  all: GetAccountChildLeads_account_childLeads_subsidiaryStats_all[];
  /**
   * The count and value of open and pending leads with a status of open
   */
  openAndPending: GetAccountChildLeads_account_childLeads_subsidiaryStats_openAndPending | null;
}

export interface GetAccountChildLeads_account_childLeads {
  __typename: "PeepLeadsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetAccountChildLeads_account_childLeads_edges[];
  /**
   * Statistics about this peep’s related leads
   */
  subsidiaryStats: GetAccountChildLeads_account_childLeads_subsidiaryStats | null;
}

export interface GetAccountChildLeads_account_childAccounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetAccountChildLeads_account_childAccounts_edges {
  __typename: "AccountChildrenEdge";
  node: GetAccountChildLeads_account_childAccounts_edges_node;
}

export interface GetAccountChildLeads_account_childAccounts {
  __typename: "AccountChildrenConnection";
  /**
   * A list of edges.
   */
  edges: GetAccountChildLeads_account_childAccounts_edges[];
}

export interface GetAccountChildLeads_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Leads related to this peeps children (for accounts, else null)
   */
  childLeads: GetAccountChildLeads_account_childLeads;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to child Accounts.
   */
  childAccounts: GetAccountChildLeads_account_childAccounts;
}

export interface GetAccountChildLeads {
  /**
   * Returns a Nutshell Account
   */
  account: GetAccountChildLeads_account | null;
}

export interface GetAccountChildLeadsVariables {
  accountId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPeepRelatedLeads
// ====================================================

export interface GetPeepRelatedLeads_peep_Account_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetPeepRelatedLeads_peep_Account_phones_primary {
  __typename: "Phone";
  value: GetPeepRelatedLeads_peep_Account_phones_primary_value;
}

export interface GetPeepRelatedLeads_peep_Account_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPeepRelatedLeads_peep_Account_phones_primary | null;
}

export interface GetPeepRelatedLeads_peep_Account_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface GetPeepRelatedLeads_peep_Account_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetPeepRelatedLeads_peep_Account_emailAddresses_primary_value;
}

export interface GetPeepRelatedLeads_peep_Account_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPeepRelatedLeads_peep_Account_emailAddresses_primary | null;
}

export interface GetPeepRelatedLeads_peep_Account_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  region: string | null;
}

export interface GetPeepRelatedLeads_peep_Account_postalAddresses_primary {
  __typename: "PostalAddress";
  value: GetPeepRelatedLeads_peep_Account_postalAddresses_primary_value;
}

export interface GetPeepRelatedLeads_peep_Account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPeepRelatedLeads_peep_Account_postalAddresses_primary | null;
}

export interface GetPeepRelatedLeads_peep_Account_leads_edges_node_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetPeepRelatedLeads_peep_Account_leads_edges_node_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetPeepRelatedLeads_peep_Account_leads_edges_node_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetPeepRelatedLeads_peep_Account_leads_edges_node_contacts_primaryEdge_node;
}

export interface GetPeepRelatedLeads_peep_Account_leads_edges_node_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPeepRelatedLeads_peep_Account_leads_edges_node_contacts_primaryEdge | null;
}

export interface GetPeepRelatedLeads_peep_Account_leads_edges_node_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetPeepRelatedLeads_peep_Account_leads_edges_node_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetPeepRelatedLeads_peep_Account_leads_edges_node_accounts_primaryEdge_node;
}

export interface GetPeepRelatedLeads_peep_Account_leads_edges_node_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPeepRelatedLeads_peep_Account_leads_edges_node_accounts_primaryEdge | null;
}

export interface GetPeepRelatedLeads_peep_Account_leads_edges_node_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetPeepRelatedLeads_peep_Account_leads_edges_node {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  value: GetPeepRelatedLeads_peep_Account_leads_edges_node_value | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  avatarUrl: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetPeepRelatedLeads_peep_Account_leads_edges_node_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetPeepRelatedLeads_peep_Account_leads_edges_node_accounts;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetPeepRelatedLeads_peep_Account_leads_edges_node_assignee | null;
}

export interface GetPeepRelatedLeads_peep_Account_leads_edges {
  __typename: "PeepLeadsEdge";
  node: GetPeepRelatedLeads_peep_Account_leads_edges_node;
}

export interface GetPeepRelatedLeads_peep_Account_leads_stats_all_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetPeepRelatedLeads_peep_Account_leads_stats_all_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetPeepRelatedLeads_peep_Account_leads_stats_all_value_formattedValue;
}

export interface GetPeepRelatedLeads_peep_Account_leads_stats_all {
  __typename: "LeadStat";
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  count: number;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  status: LeadStatus;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  value: GetPeepRelatedLeads_peep_Account_leads_stats_all_value;
}

export interface GetPeepRelatedLeads_peep_Account_leads_stats_openAndPending_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetPeepRelatedLeads_peep_Account_leads_stats_openAndPending_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetPeepRelatedLeads_peep_Account_leads_stats_openAndPending_value_formattedValue;
}

export interface GetPeepRelatedLeads_peep_Account_leads_stats_openAndPending {
  __typename: "LeadStat";
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  count: number;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  status: LeadStatus;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  value: GetPeepRelatedLeads_peep_Account_leads_stats_openAndPending_value;
}

export interface GetPeepRelatedLeads_peep_Account_leads_stats {
  __typename: "LeadStats";
  /**
   * All the stats, boi
   */
  all: GetPeepRelatedLeads_peep_Account_leads_stats_all[];
  /**
   * The count and value of open and pending leads with a status of open
   */
  openAndPending: GetPeepRelatedLeads_peep_Account_leads_stats_openAndPending | null;
}

export interface GetPeepRelatedLeads_peep_Account_leads {
  __typename: "PeepLeadsConnection";
  /**
   * A list of edges.
   */
  edges: GetPeepRelatedLeads_peep_Account_leads_edges[];
  /**
   * Statistics about this peep’s related leads
   */
  stats: GetPeepRelatedLeads_peep_Account_leads_stats;
}

export interface GetPeepRelatedLeads_peep_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  avatarUrl: string;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetPeepRelatedLeads_peep_Account_phones;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetPeepRelatedLeads_peep_Account_emailAddresses;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetPeepRelatedLeads_peep_Account_postalAddresses;
  /**
   * Leads related to this peep
   */
  leads: GetPeepRelatedLeads_peep_Account_leads;
}

export interface GetPeepRelatedLeads_peep_Contact_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetPeepRelatedLeads_peep_Contact_phones_primary {
  __typename: "Phone";
  value: GetPeepRelatedLeads_peep_Contact_phones_primary_value;
}

export interface GetPeepRelatedLeads_peep_Contact_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPeepRelatedLeads_peep_Contact_phones_primary | null;
}

export interface GetPeepRelatedLeads_peep_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface GetPeepRelatedLeads_peep_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetPeepRelatedLeads_peep_Contact_emailAddresses_primary_value;
}

export interface GetPeepRelatedLeads_peep_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPeepRelatedLeads_peep_Contact_emailAddresses_primary | null;
}

export interface GetPeepRelatedLeads_peep_Contact_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  region: string | null;
}

export interface GetPeepRelatedLeads_peep_Contact_postalAddresses_primary {
  __typename: "PostalAddress";
  value: GetPeepRelatedLeads_peep_Contact_postalAddresses_primary_value;
}

export interface GetPeepRelatedLeads_peep_Contact_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPeepRelatedLeads_peep_Contact_postalAddresses_primary | null;
}

export interface GetPeepRelatedLeads_peep_Contact_leads_edges_node_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetPeepRelatedLeads_peep_Contact_leads_edges_node_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetPeepRelatedLeads_peep_Contact_leads_edges_node_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetPeepRelatedLeads_peep_Contact_leads_edges_node_contacts_primaryEdge_node;
}

export interface GetPeepRelatedLeads_peep_Contact_leads_edges_node_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPeepRelatedLeads_peep_Contact_leads_edges_node_contacts_primaryEdge | null;
}

export interface GetPeepRelatedLeads_peep_Contact_leads_edges_node_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetPeepRelatedLeads_peep_Contact_leads_edges_node_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetPeepRelatedLeads_peep_Contact_leads_edges_node_accounts_primaryEdge_node;
}

export interface GetPeepRelatedLeads_peep_Contact_leads_edges_node_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPeepRelatedLeads_peep_Contact_leads_edges_node_accounts_primaryEdge | null;
}

export interface GetPeepRelatedLeads_peep_Contact_leads_edges_node_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetPeepRelatedLeads_peep_Contact_leads_edges_node {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  value: GetPeepRelatedLeads_peep_Contact_leads_edges_node_value | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  avatarUrl: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetPeepRelatedLeads_peep_Contact_leads_edges_node_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetPeepRelatedLeads_peep_Contact_leads_edges_node_accounts;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetPeepRelatedLeads_peep_Contact_leads_edges_node_assignee | null;
}

export interface GetPeepRelatedLeads_peep_Contact_leads_edges {
  __typename: "PeepLeadsEdge";
  node: GetPeepRelatedLeads_peep_Contact_leads_edges_node;
}

export interface GetPeepRelatedLeads_peep_Contact_leads_stats_all_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetPeepRelatedLeads_peep_Contact_leads_stats_all_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetPeepRelatedLeads_peep_Contact_leads_stats_all_value_formattedValue;
}

export interface GetPeepRelatedLeads_peep_Contact_leads_stats_all {
  __typename: "LeadStat";
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  count: number;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  status: LeadStatus;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  value: GetPeepRelatedLeads_peep_Contact_leads_stats_all_value;
}

export interface GetPeepRelatedLeads_peep_Contact_leads_stats_openAndPending_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetPeepRelatedLeads_peep_Contact_leads_stats_openAndPending_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetPeepRelatedLeads_peep_Contact_leads_stats_openAndPending_value_formattedValue;
}

export interface GetPeepRelatedLeads_peep_Contact_leads_stats_openAndPending {
  __typename: "LeadStat";
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  count: number;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  status: LeadStatus;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  value: GetPeepRelatedLeads_peep_Contact_leads_stats_openAndPending_value;
}

export interface GetPeepRelatedLeads_peep_Contact_leads_stats {
  __typename: "LeadStats";
  /**
   * All the stats, boi
   */
  all: GetPeepRelatedLeads_peep_Contact_leads_stats_all[];
  /**
   * The count and value of open and pending leads with a status of open
   */
  openAndPending: GetPeepRelatedLeads_peep_Contact_leads_stats_openAndPending | null;
}

export interface GetPeepRelatedLeads_peep_Contact_leads {
  __typename: "PeepLeadsConnection";
  /**
   * A list of edges.
   */
  edges: GetPeepRelatedLeads_peep_Contact_leads_edges[];
  /**
   * Statistics about this peep’s related leads
   */
  stats: GetPeepRelatedLeads_peep_Contact_leads_stats;
}

export interface GetPeepRelatedLeads_peep_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  avatarUrl: string;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetPeepRelatedLeads_peep_Contact_phones;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetPeepRelatedLeads_peep_Contact_emailAddresses;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetPeepRelatedLeads_peep_Contact_postalAddresses;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  /**
   * Leads related to this peep
   */
  leads: GetPeepRelatedLeads_peep_Contact_leads;
}

export type GetPeepRelatedLeads_peep = GetPeepRelatedLeads_peep_Account | GetPeepRelatedLeads_peep_Contact;

export interface GetPeepRelatedLeads {
  /**
   * Returns a Nutshell peep
   */
  peep: GetPeepRelatedLeads_peep;
}

export interface GetPeepRelatedLeadsVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTasksForPeep
// ====================================================

export interface GetTasksForPeep_peep_tasks_delayApplications_delay {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the delay
   */
  name: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface GetTasksForPeep_peep_tasks_delayApplications_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetTasksForPeep_peep_tasks_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * An optional note about the delay application
   */
  note: string | null;
  /**
   * The time when the delay was applied
   */
  appliedTime: any;
  /**
   * The delay that was applied
   */
  delay: GetTasksForPeep_peep_tasks_delayApplications_delay;
  /**
   * The user who applied the delay
   */
  user: GetTasksForPeep_peep_tasks_delayApplications_user | null;
}

export interface GetTasksForPeep_peep_tasks_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetTasksForPeep_peep_tasks_completedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetTasksForPeep_peep_tasks_relatedEntity {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetTasksForPeep_peep_tasks_creatorEntity_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface GetTasksForPeep_peep_tasks_creatorEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export type GetTasksForPeep_peep_tasks_creatorEntity = GetTasksForPeep_peep_tasks_creatorEntity_Chat | GetTasksForPeep_peep_tasks_creatorEntity_Activity;

export interface GetTasksForPeep_peep_tasks_assigner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetTasksForPeep_peep_tasks_recurrenceRule {
  __typename: "RecurrenceRule";
  mode: RecurrenceMode;
  /**
   * An RRULE-compatible string defining the recurrence pattern (e.g. "FREQ=WEEKLY;BYDAY=MO").
   */
  rule: string;
}

export interface GetTasksForPeep_peep_tasks {
  __typename: "Task";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the task
   */
  title: string;
  /**
   * The canonical API href for the task
   */
  href: string;
  /**
   * The task’s user-defined description
   */
  description: string | null;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: GetTasksForPeep_peep_tasks_delayApplications[];
  /**
   * The due timestamp of the task
   */
  dueTime: any | null;
  /**
   * The person or team assigned to this task
   */
  assignee: GetTasksForPeep_peep_tasks_assignee | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  completedTime: any | null;
  /**
   * Can the task be completed?
   */
  canBeCompleted: boolean;
  /**
   * Is this task completed?
   */
  isCompleted: boolean;
  /**
   * The user who completed the task
   */
  completedByUser: GetTasksForPeep_peep_tasks_completedByUser | null;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Whether the tasks due date is later than the current date
   */
  isOverdue: boolean;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  relatedEntity: GetTasksForPeep_peep_tasks_relatedEntity | null;
  /**
   * The DateTime that represents when the Activity record was created
   */
  createdTime: any;
  /**
   * The task's linkified description with URLs converted to clickable links
   */
  linkifiedDescription: string | null;
  isAiGenerated: boolean;
  creatorEntity: GetTasksForPeep_peep_tasks_creatorEntity | null;
  /**
   * The user who assigned the task
   */
  assigner: GetTasksForPeep_peep_tasks_assigner | null;
  /**
   * The time the task was assigned
   */
  assignedTime: any | null;
  /**
   * Number of days between follow-up reminders. Null if the task is not recurring.
   */
  recurringPeriod: number | null;
  /**
   * Whether this task is the current user recurring follow-up reminder.
   */
  isRecurringForUser: boolean;
  /**
   * Null if the task does not recur under the new recurrence system.
   */
  recurrenceRule: GetTasksForPeep_peep_tasks_recurrenceRule | null;
}

export interface GetTasksForPeep_peep {
  __typename: "Account" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The tasks for this peep
   */
  tasks: GetTasksForPeep_peep_tasks[];
}

export interface GetTasksForPeep {
  /**
   * Returns a Nutshell peep
   */
  peep: GetTasksForPeep_peep;
}

export interface GetTasksForPeepVariables {
  peepId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddPdlContactsToAccount
// ====================================================

export interface AddPdlContactsToAccount_accountPdlContactsAdd_account_contacts {
  __typename: "AccountContactsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface AddPdlContactsToAccount_accountPdlContactsAdd_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to
   * Nutshell Contacts. This allows you to see and query all of the contacts that
   * are related in someway (e.g., they work for) this account. For further
   * reading, see [this blog post explaining GraphQL connection types](https: // dev-blog.apollodata.com/explaining-graphql-connections-c48b7c3d6976).
   */
  contacts: AddPdlContactsToAccount_accountPdlContactsAdd_account_contacts;
}

export interface AddPdlContactsToAccount_accountPdlContactsAdd_contacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface AddPdlContactsToAccount_accountPdlContactsAdd {
  __typename: "AccountPdlContactsAddPayload";
  /**
   * The updated Nutshell account.
   */
  account: AddPdlContactsToAccount_accountPdlContactsAdd_account;
  /**
   * The new contacts created
   */
  contacts: (AddPdlContactsToAccount_accountPdlContactsAdd_contacts | null)[] | null;
}

export interface AddPdlContactsToAccount {
  /**
   * Updates a Nutshell account by adding contacts via PeopleIQ
   */
  accountPdlContactsAdd: AddPdlContactsToAccount_accountPdlContactsAdd;
}

export interface AddPdlContactsToAccountVariables {
  input: AccountPdlContactsAddInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdatePeopleIqFilterSettings
// ====================================================

export interface UpdatePeopleIqFilterSettings_peopleIqFilterSettingsUpdate_contactInformationList_contactInformation {
  __typename: "ContactInformationDetail";
  /**
   * The enum value of this filter
   */
  id: ContactInformationType;
  /**
   * The name of this filter
   */
  name: string;
}

export interface UpdatePeopleIqFilterSettings_peopleIqFilterSettingsUpdate_contactInformationList {
  __typename: "ContactInformationSetting";
  /**
   * The contact information that this setting relates to
   */
  contactInformation: UpdatePeopleIqFilterSettings_peopleIqFilterSettingsUpdate_contactInformationList_contactInformation;
  /**
   * Whether this contact information should be ignored in Nutshell
   */
  isBlocked: boolean;
}

export interface UpdatePeopleIqFilterSettings_peopleIqFilterSettingsUpdate_jobFieldList_jobField {
  __typename: "JobFieldDetail";
  /**
   * The enum value of this filter
   */
  id: JobFieldType;
  /**
   * The name of this filter
   */
  name: string;
}

export interface UpdatePeopleIqFilterSettings_peopleIqFilterSettingsUpdate_jobFieldList {
  __typename: "JobFieldSetting";
  /**
   * The job field that this setting relates to
   */
  jobField: UpdatePeopleIqFilterSettings_peopleIqFilterSettingsUpdate_jobFieldList_jobField;
  /**
   * Whether this job field should be ignored in Nutshell
   */
  isBlocked: boolean;
}

export interface UpdatePeopleIqFilterSettings_peopleIqFilterSettingsUpdate_managementLevelList_managementLevel {
  __typename: "ManagementLevelDetail";
  /**
   * The enum value of this filter
   */
  id: ManagementLevelType;
  /**
   * The name of this filter
   */
  name: string;
}

export interface UpdatePeopleIqFilterSettings_peopleIqFilterSettingsUpdate_managementLevelList {
  __typename: "ManagementLevelSetting";
  /**
   * The job field that this setting relates to
   */
  managementLevel: UpdatePeopleIqFilterSettings_peopleIqFilterSettingsUpdate_managementLevelList_managementLevel;
  /**
   * Whether this job field should be ignored in Nutshell
   */
  isBlocked: boolean;
}

export interface UpdatePeopleIqFilterSettings_peopleIqFilterSettingsUpdate {
  __typename: "FilterSettingsPayload";
  /**
   * The list of contact information to include in Nutshell
   */
  contactInformationList: UpdatePeopleIqFilterSettings_peopleIqFilterSettingsUpdate_contactInformationList[];
  /**
   * The list of job fields to include in Nutshell
   */
  jobFieldList: UpdatePeopleIqFilterSettings_peopleIqFilterSettingsUpdate_jobFieldList[];
  /**
   * The list of management levels to include in Nutshell
   */
  managementLevelList: UpdatePeopleIqFilterSettings_peopleIqFilterSettingsUpdate_managementLevelList[];
}

export interface UpdatePeopleIqFilterSettings {
  /**
   * Update the PeopleIQ filters in Nutshell
   */
  peopleIqFilterSettingsUpdate: UpdatePeopleIqFilterSettings_peopleIqFilterSettingsUpdate;
}

export interface UpdatePeopleIqFilterSettingsVariables {
  input: PeopleIqFilterSettingsUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdatePeopleIqPreference
// ====================================================

export interface UpdatePeopleIqPreference_peopleIqPreference_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface UpdatePeopleIqPreference_peopleIqPreference {
  __typename: "PeopleIqPreferencePayload";
  /**
   * The account PeopleIQ suggestions were set
   */
  account: UpdatePeopleIqPreference_peopleIqPreference_account;
}

export interface UpdatePeopleIqPreference {
  /**
   * Set PeopleIQ suggestion preference for a given company
   */
  peopleIqPreference: UpdatePeopleIqPreference_peopleIqPreference;
}

export interface UpdatePeopleIqPreferenceVariables {
  input: PeopleIqPreferenceInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMcfxViqContacts
// ====================================================

export interface GetMcfxViqContacts_mcfxViqContacts_contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetMcfxViqContacts_mcfxViqContacts_contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetMcfxViqContacts_mcfxViqContacts_contact_emailAddresses_primary_value;
}

export interface GetMcfxViqContacts_mcfxViqContacts_contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetMcfxViqContacts_mcfxViqContacts_contact_emailAddresses_primary | null;
}

export interface GetMcfxViqContacts_mcfxViqContacts_contact_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetMcfxViqContacts_mcfxViqContacts_contact_phones_primary {
  __typename: "Phone";
  value: GetMcfxViqContacts_mcfxViqContacts_contact_phones_primary_value;
}

export interface GetMcfxViqContacts_mcfxViqContacts_contact_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetMcfxViqContacts_mcfxViqContacts_contact_phones_primary | null;
}

export interface GetMcfxViqContacts_mcfxViqContacts_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetMcfxViqContacts_mcfxViqContacts_contact_emailAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetMcfxViqContacts_mcfxViqContacts_contact_phones;
}

export interface GetMcfxViqContacts_mcfxViqContacts {
  __typename: "McfxViqContact";
  /**
   * The (external) id for this Viq person
   */
  id: string;
  /**
   * The (external) id for this Viq person
   */
  fullName: string;
  /**
   * The job title of this Viq person
   */
  jobTitle: string | null;
  /**
   * The location of this Viq person
   */
  location: string | null;
  /**
   * The position of this Viq person
   */
  position: string | null;
  /**
   * Whether this Viq person has a valid email address
   */
  hasEmail: boolean;
  /**
   * Whether this Viq person has a valid phone number
   */
  hasPhone: boolean;
  /**
   * Whether this Viq person has a LinkedIn Url we know about
   */
  hasLinkedinUrl: boolean;
  /**
   * The Nutshell contact associated with this viq contact
   */
  contact: GetMcfxViqContacts_mcfxViqContacts_contact | null;
}

export interface GetMcfxViqContacts {
  /**
   * Returns an array of Viq contacts with possible Nutshell contacts
   */
  mcfxViqContacts: GetMcfxViqContacts_mcfxViqContacts[];
}

export interface GetMcfxViqContactsVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPeopleIqFilterSettings
// ====================================================

export interface GetPeopleIqFilterSettings_peopleIqFilterSettings_contactInformationList_contactInformation {
  __typename: "ContactInformationDetail";
  /**
   * The enum value of this filter
   */
  id: ContactInformationType;
  /**
   * The name of this filter
   */
  name: string;
}

export interface GetPeopleIqFilterSettings_peopleIqFilterSettings_contactInformationList {
  __typename: "ContactInformationSetting";
  /**
   * The contact information that this setting relates to
   */
  contactInformation: GetPeopleIqFilterSettings_peopleIqFilterSettings_contactInformationList_contactInformation;
  /**
   * Whether this contact information should be ignored in Nutshell
   */
  isBlocked: boolean;
}

export interface GetPeopleIqFilterSettings_peopleIqFilterSettings_jobFieldList_jobField {
  __typename: "JobFieldDetail";
  /**
   * The enum value of this filter
   */
  id: JobFieldType;
  /**
   * The name of this filter
   */
  name: string;
}

export interface GetPeopleIqFilterSettings_peopleIqFilterSettings_jobFieldList {
  __typename: "JobFieldSetting";
  /**
   * The job field that this setting relates to
   */
  jobField: GetPeopleIqFilterSettings_peopleIqFilterSettings_jobFieldList_jobField;
  /**
   * Whether this job field should be ignored in Nutshell
   */
  isBlocked: boolean;
}

export interface GetPeopleIqFilterSettings_peopleIqFilterSettings_managementLevelList_managementLevel {
  __typename: "ManagementLevelDetail";
  /**
   * The enum value of this filter
   */
  id: ManagementLevelType;
  /**
   * The name of this filter
   */
  name: string;
}

export interface GetPeopleIqFilterSettings_peopleIqFilterSettings_managementLevelList {
  __typename: "ManagementLevelSetting";
  /**
   * The job field that this setting relates to
   */
  managementLevel: GetPeopleIqFilterSettings_peopleIqFilterSettings_managementLevelList_managementLevel;
  /**
   * Whether this job field should be ignored in Nutshell
   */
  isBlocked: boolean;
}

export interface GetPeopleIqFilterSettings_peopleIqFilterSettings {
  __typename: "FilterSettingsPayload";
  /**
   * The list of contact information to include in Nutshell
   */
  contactInformationList: GetPeopleIqFilterSettings_peopleIqFilterSettings_contactInformationList[];
  /**
   * The list of job fields to include in Nutshell
   */
  jobFieldList: GetPeopleIqFilterSettings_peopleIqFilterSettings_jobFieldList[];
  /**
   * The list of management levels to include in Nutshell
   */
  managementLevelList: GetPeopleIqFilterSettings_peopleIqFilterSettings_managementLevelList[];
}

export interface GetPeopleIqFilterSettings {
  /**
   * A list of all contact information filters in Nutshell
   */
  peopleIqFilterSettings: GetPeopleIqFilterSettings_peopleIqFilterSettings;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUnlockInfo
// ====================================================

export interface GetUnlockInfo_unlockInfo {
  __typename: "UnlockInfo";
  /**
   * The number of credits alloted per month
   */
  unlockLimit: number;
  /**
   * The number of credits used this month
   */
  unlockedThisMonth: number;
}

export interface GetUnlockInfo {
  /**
   * Get information about company tracker credits
   */
  unlockInfo: GetUnlockInfo_unlockInfo;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPersistedListParams
// ====================================================

export interface GetPersistedListParams_accounts {
  __typename: "Setting";
  /**
   * The name of this Setting
   */
  id: string;
  /**
   * The value of this Setting
   */
  value: string | null;
}

export interface GetPersistedListParams_contacts {
  __typename: "Setting";
  /**
   * The name of this Setting
   */
  id: string;
  /**
   * The value of this Setting
   */
  value: string | null;
}

export interface GetPersistedListParams_leads {
  __typename: "Setting";
  /**
   * The name of this Setting
   */
  id: string;
  /**
   * The value of this Setting
   */
  value: string | null;
}

export interface GetPersistedListParams {
  /**
   * Returns a whitelisted setting
   */
  accounts: GetPersistedListParams_accounts;
  /**
   * Returns a whitelisted setting
   */
  contacts: GetPersistedListParams_contacts;
  /**
   * Returns a whitelisted setting
   */
  leads: GetPersistedListParams_leads;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: updatePhonecallShouldSummarize
// ====================================================

export interface updatePhonecallShouldSummarize_phonecallSetShouldSummarize {
  __typename: "PhoneCallSetShouldSummarizePayload";
  /**
   * Whether the phonecall was successfully updated
   */
  wasUpdated: boolean | null;
}

export interface updatePhonecallShouldSummarize {
  /**
   * Toggles whether a phonecall should be summarized from the transcription
   */
  phonecallSetShouldSummarize: updatePhonecallShouldSummarize_phonecallSetShouldSummarize;
}

export interface updatePhonecallShouldSummarizeVariables {
  input: PhoneCallSetShouldSummarizeInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCallActivity
// ====================================================

export interface GetCallActivity_activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetCallActivity_activity_summary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GetCallActivity_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetCallActivity_activity_logNote | null;
  /**
   * The transcription of the activity.
   */
  transcription: string | null;
  /**
   * The status of the transcription.
   */
  transcriptionStatus: ActivityTranscriptionStatus;
  /**
   * The summary of the activity.
   */
  summary: GetCallActivity_activity_summary | null;
}

export interface GetCallActivity {
  /**
   * Returns a Nutshell Activity
   */
  activity: GetCallActivity_activity | null;
}

export interface GetCallActivityVariables {
  activityId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteEntitySummary
// ====================================================

export interface DeleteEntitySummary_entitySummaryDelete_entitySummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface DeleteEntitySummary_entitySummaryDelete {
  __typename: "EntitySummaryDeletePayload";
  /**
   * The deleted summary.
   */
  entitySummary: DeleteEntitySummary_entitySummaryDelete_entitySummary | null;
}

export interface DeleteEntitySummary {
  /**
   * Delete an entity summary
   */
  entitySummaryDelete: DeleteEntitySummary_entitySummaryDelete;
}

export interface DeleteEntitySummaryVariables {
  input: EntitySummaryDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: GenerateEntitySummary
// ====================================================

export interface GenerateEntitySummary_entitySummaryGenerate_entitySummary_EntitySummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GenerateEntitySummary_entitySummaryGenerate_entitySummary_LeadEntitySummary {
  __typename: "LeadEntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
  /**
   * Whether the lead context summary is valid
   */
  isValid: boolean;
  /**
   * The recap of the lead context summary
   */
  recap: string | null;
  /**
   * The next steps of the lead context summary
   */
  nextSteps: string[] | null;
  /**
   * Recap of the lead's most recent logged and scheduled activities. Null if the lead has none.
   */
  lastActivities: string | null;
  /**
   * Unanswered questions surfaced from emails, calls, and notes. Empty if none were found.
   */
  openQuestions: string[] | null;
  /**
   * Profile of the lead: conversation points, business context, and rapport notes. Null if there is not enough data.
   */
  dossier: string | null;
}

export interface GenerateEntitySummary_entitySummaryGenerate_entitySummary_EntitySummaryLeadResearch_leadFitReasons {
  __typename: "LeadFitReason";
  /**
   * Concise headline explaining this factor (always visible)
   */
  text: string;
  sentiment: LeadResearchSentiment;
  /**
   * Supporting detail shown when expanded
   */
  body: string;
}

export interface GenerateEntitySummary_entitySummaryGenerate_entitySummary_EntitySummaryLeadResearch_fields {
  __typename: "LeadResearchField";
  key: string;
  label: string;
  value: string;
}

export interface GenerateEntitySummary_entitySummaryGenerate_entitySummary_EntitySummaryLeadResearch_companyOverview {
  __typename: "CompanyOverview";
  /**
   * One punchy sentence about the company (max 48 chars)
   */
  headline: string;
  /**
   * 1-2 sentences of key factual details
   */
  body: string;
}

export interface GenerateEntitySummary_entitySummaryGenerate_entitySummary_EntitySummaryLeadResearch {
  __typename: "EntitySummaryLeadResearch";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
  leadFit: LeadFitScore;
  leadFitLabel: string;
  leadFitReasons: GenerateEntitySummary_entitySummaryGenerate_entitySummary_EntitySummaryLeadResearch_leadFitReasons[];
  fields: GenerateEntitySummary_entitySummaryGenerate_entitySummary_EntitySummaryLeadResearch_fields[];
  companyOverview: GenerateEntitySummary_entitySummaryGenerate_entitySummary_EntitySummaryLeadResearch_companyOverview | null;
}

export type GenerateEntitySummary_entitySummaryGenerate_entitySummary = GenerateEntitySummary_entitySummaryGenerate_entitySummary_EntitySummary | GenerateEntitySummary_entitySummaryGenerate_entitySummary_LeadEntitySummary | GenerateEntitySummary_entitySummaryGenerate_entitySummary_EntitySummaryLeadResearch;

export interface GenerateEntitySummary_entitySummaryGenerate {
  __typename: "EntitySummaryGeneratePayload";
  /**
   * The newly generated summary.
   */
  entitySummary: GenerateEntitySummary_entitySummaryGenerate_entitySummary | null;
}

export interface GenerateEntitySummary {
  /**
   * Generate an entity summary
   */
  entitySummaryGenerate: GenerateEntitySummary_entitySummaryGenerate;
}

export interface GenerateEntitySummaryVariables {
  input: EntitySummaryGenerateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RateEntitySummary
// ====================================================

export interface RateEntitySummary_entitySummaryRate_entitySummary_EntitySummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface RateEntitySummary_entitySummaryRate_entitySummary_LeadEntitySummary {
  __typename: "LeadEntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
  /**
   * Whether the lead context summary is valid
   */
  isValid: boolean;
  /**
   * The recap of the lead context summary
   */
  recap: string | null;
  /**
   * The next steps of the lead context summary
   */
  nextSteps: string[] | null;
  /**
   * Recap of the lead's most recent logged and scheduled activities. Null if the lead has none.
   */
  lastActivities: string | null;
  /**
   * Unanswered questions surfaced from emails, calls, and notes. Empty if none were found.
   */
  openQuestions: string[] | null;
  /**
   * Profile of the lead: conversation points, business context, and rapport notes. Null if there is not enough data.
   */
  dossier: string | null;
}

export interface RateEntitySummary_entitySummaryRate_entitySummary_EntitySummaryLeadResearch_leadFitReasons {
  __typename: "LeadFitReason";
  /**
   * Concise headline explaining this factor (always visible)
   */
  text: string;
  sentiment: LeadResearchSentiment;
  /**
   * Supporting detail shown when expanded
   */
  body: string;
}

export interface RateEntitySummary_entitySummaryRate_entitySummary_EntitySummaryLeadResearch_fields {
  __typename: "LeadResearchField";
  key: string;
  label: string;
  value: string;
}

export interface RateEntitySummary_entitySummaryRate_entitySummary_EntitySummaryLeadResearch_companyOverview {
  __typename: "CompanyOverview";
  /**
   * One punchy sentence about the company (max 48 chars)
   */
  headline: string;
  /**
   * 1-2 sentences of key factual details
   */
  body: string;
}

export interface RateEntitySummary_entitySummaryRate_entitySummary_EntitySummaryLeadResearch {
  __typename: "EntitySummaryLeadResearch";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
  leadFit: LeadFitScore;
  leadFitLabel: string;
  leadFitReasons: RateEntitySummary_entitySummaryRate_entitySummary_EntitySummaryLeadResearch_leadFitReasons[];
  fields: RateEntitySummary_entitySummaryRate_entitySummary_EntitySummaryLeadResearch_fields[];
  companyOverview: RateEntitySummary_entitySummaryRate_entitySummary_EntitySummaryLeadResearch_companyOverview | null;
}

export type RateEntitySummary_entitySummaryRate_entitySummary = RateEntitySummary_entitySummaryRate_entitySummary_EntitySummary | RateEntitySummary_entitySummaryRate_entitySummary_LeadEntitySummary | RateEntitySummary_entitySummaryRate_entitySummary_EntitySummaryLeadResearch;

export interface RateEntitySummary_entitySummaryRate {
  __typename: "EntitySummaryRatePayload";
  /**
   * The summary with an updated rating.
   */
  entitySummary: RateEntitySummary_entitySummaryRate_entitySummary | null;
}

export interface RateEntitySummary {
  /**
   * Rate an entity summary
   */
  entitySummaryRate: RateEntitySummary_entitySummaryRate;
}

export interface RateEntitySummaryVariables {
  input: EntitySummaryRateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEntitySummary
// ====================================================

export interface GetEntitySummary_entitySummary_EntitySummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GetEntitySummary_entitySummary_LeadEntitySummary {
  __typename: "LeadEntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
  /**
   * Whether the lead context summary is valid
   */
  isValid: boolean;
  /**
   * The recap of the lead context summary
   */
  recap: string | null;
  /**
   * The next steps of the lead context summary
   */
  nextSteps: string[] | null;
  /**
   * Recap of the lead's most recent logged and scheduled activities. Null if the lead has none.
   */
  lastActivities: string | null;
  /**
   * Unanswered questions surfaced from emails, calls, and notes. Empty if none were found.
   */
  openQuestions: string[] | null;
  /**
   * Profile of the lead: conversation points, business context, and rapport notes. Null if there is not enough data.
   */
  dossier: string | null;
}

export interface GetEntitySummary_entitySummary_EntitySummaryLeadResearch_leadFitReasons {
  __typename: "LeadFitReason";
  /**
   * Concise headline explaining this factor (always visible)
   */
  text: string;
  sentiment: LeadResearchSentiment;
  /**
   * Supporting detail shown when expanded
   */
  body: string;
}

export interface GetEntitySummary_entitySummary_EntitySummaryLeadResearch_fields {
  __typename: "LeadResearchField";
  key: string;
  label: string;
  value: string;
}

export interface GetEntitySummary_entitySummary_EntitySummaryLeadResearch_companyOverview {
  __typename: "CompanyOverview";
  /**
   * One punchy sentence about the company (max 48 chars)
   */
  headline: string;
  /**
   * 1-2 sentences of key factual details
   */
  body: string;
}

export interface GetEntitySummary_entitySummary_EntitySummaryLeadResearch {
  __typename: "EntitySummaryLeadResearch";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
  leadFit: LeadFitScore;
  leadFitLabel: string;
  leadFitReasons: GetEntitySummary_entitySummary_EntitySummaryLeadResearch_leadFitReasons[];
  fields: GetEntitySummary_entitySummary_EntitySummaryLeadResearch_fields[];
  companyOverview: GetEntitySummary_entitySummary_EntitySummaryLeadResearch_companyOverview | null;
}

export type GetEntitySummary_entitySummary = GetEntitySummary_entitySummary_EntitySummary | GetEntitySummary_entitySummary_LeadEntitySummary | GetEntitySummary_entitySummary_EntitySummaryLeadResearch;

export interface GetEntitySummary {
  /**
   * Returns a summary of an entity
   */
  entitySummary: GetEntitySummary_entitySummary | null;
}

export interface GetEntitySummaryVariables {
  id: string;
  summaryType: SummaryType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetChatbotReport
// ====================================================

export interface GetChatbotReport_chatbotReport_aiMetrics_summary {
  __typename: "ChatbotReportSummary";
  performance: string | null;
  activity: string | null;
  impact: string | null;
}

export interface GetChatbotReport_chatbotReport_aiMetrics_sentimentBreakdown {
  __typename: "ChatbotReportSentimentBreakdown";
  goodPercent: number;
  badPercent: number;
  neutralPercent: number;
  goodSampleThreadIds: string[];
  badSampleThreadIds: string[];
  neutralSampleThreadIds: string[];
}

export interface GetChatbotReport_chatbotReport_aiMetrics_commonTopics {
  __typename: "ChatbotReportTopic";
  topic: string;
  threadIds: string[];
  threadCount: number;
}

export interface GetChatbotReport_chatbotReport_aiMetrics_frustrationTopics {
  __typename: "ChatbotReportTopic";
  topic: string;
  threadIds: string[];
  threadCount: number;
}

export interface GetChatbotReport_chatbotReport_aiMetrics_knowledgeGaps {
  __typename: "ChatbotReportKnowledgeGap";
  question: string;
  threadIds: string[];
  threadCount: number;
}

export interface GetChatbotReport_chatbotReport_aiMetrics_oddballThreads {
  __typename: "ChatbotReportOddballThread";
  topic: string;
  description: string;
  threadIds: string[];
  threadCount: number;
}

export interface GetChatbotReport_chatbotReport_aiMetrics {
  __typename: "ChatbotReportAIMetrics";
  summary: GetChatbotReport_chatbotReport_aiMetrics_summary | null;
  sentimentBreakdown: GetChatbotReport_chatbotReport_aiMetrics_sentimentBreakdown | null;
  askedForHumanPercent: number;
  commonTopics: GetChatbotReport_chatbotReport_aiMetrics_commonTopics[];
  frustrationTopics: GetChatbotReport_chatbotReport_aiMetrics_frustrationTopics[];
  knowledgeGaps: GetChatbotReport_chatbotReport_aiMetrics_knowledgeGaps[];
  oddballThreads: GetChatbotReport_chatbotReport_aiMetrics_oddballThreads[];
}

export interface GetChatbotReport_chatbotReport_dbMetrics_topNudges {
  __typename: "ChatbotReportNudge";
  nudgeId: string;
  content: string;
  pageSlugs: string[];
  threadCount: number;
  threadIds: string[];
}

export interface GetChatbotReport_chatbotReport_dbMetrics {
  __typename: "ChatbotReportDbMetrics";
  visitorCount: number;
  conversationCount: number;
  visitorsFilledFormPercent: number;
  topNudges: GetChatbotReport_chatbotReport_dbMetrics_topNudges[];
}

export interface GetChatbotReport_chatbotReport {
  __typename: "ChatbotReport";
  aiMetrics: GetChatbotReport_chatbotReport_aiMetrics | null;
  dbMetrics: GetChatbotReport_chatbotReport_dbMetrics | null;
}

export interface GetChatbotReport {
  /**
   * Returns chatbot report data with AI metrics and database metrics
   */
  chatbotReport: GetChatbotReport_chatbotReport;
}

export interface GetChatbotReportVariables {
  period: string;
  contactFilter?: ContactFilter | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TrackReportView
// ====================================================

export interface TrackReportView_trackReportView_recentlyViewedReports_savedFilter {
  __typename: "SavedFilter";
  id: string;
}

export interface TrackReportView_trackReportView_recentlyViewedReports {
  __typename: "ReportView";
  /**
   * The title of the report (saved filter name or description of filters)
   */
  title: string;
  /**
   * The subtitle of the report
   */
  subtitle: string;
  /**
   * The type of report (e.g., Sales, Activity, Forecast)
   */
  reportType: SavedFiltersReportType;
  /**
   * The time to display for the report on the frontend (last viewed time for
   * recently viewed reports, created time for saved reports)
   */
  displayTime: any;
  /**
   * The URL path to navigate to this report
   */
  htmlUrlPath: string;
  /**
   * The underlying saved filter if this is a saved report
   */
  savedFilter: TrackReportView_trackReportView_recentlyViewedReports_savedFilter | null;
}

export interface TrackReportView_trackReportView {
  __typename: "TrackReportViewPayload";
  /**
   * The recently viewed reports for the user
   */
  recentlyViewedReports: (TrackReportView_trackReportView_recentlyViewedReports | null)[];
}

export interface TrackReportView {
  /**
   * Tracks a report view for the current user. Call on mount to create entry, on leave to update.
   */
  trackReportView: TrackReportView_trackReportView;
}

export interface TrackReportViewVariables {
  input: TrackReportViewInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: GenerateReport
// ====================================================

export interface GenerateReport_generateReport_savedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The users description of the saved filter
   */
  description: string | null;
  /**
   * The type of this saved filter
   */
  type: SavedFiltersReportType;
}

export interface GenerateReport_generateReport {
  __typename: "GenerateReportPayload";
  /**
   * The generated saved filter
   */
  savedFilter: GenerateReport_generateReport_savedFilter;
  /**
   * Status of the report that was generated
   */
  status: GenerateReportStatus;
}

export interface GenerateReport {
  /**
   * Generate an AI report based on a user prompt
   */
  generateReport: GenerateReport_generateReport;
}

export interface GenerateReportVariables {
  input: GenerateReportInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRecentlySavedReports
// ====================================================

export interface GetRecentlySavedReports_recentlySavedReports_savedFilter {
  __typename: "SavedFilter";
  id: string;
}

export interface GetRecentlySavedReports_recentlySavedReports {
  __typename: "ReportView";
  /**
   * The title of the report (saved filter name or description of filters)
   */
  title: string;
  /**
   * The subtitle of the report
   */
  subtitle: string;
  /**
   * The type of report (e.g., Sales, Activity, Forecast)
   */
  reportType: SavedFiltersReportType;
  /**
   * The time to display for the report on the frontend (last viewed time for
   * recently viewed reports, created time for saved reports)
   */
  displayTime: any;
  /**
   * The URL path to navigate to this report
   */
  htmlUrlPath: string;
  /**
   * The underlying saved filter if this is a saved report
   */
  savedFilter: GetRecentlySavedReports_recentlySavedReports_savedFilter | null;
}

export interface GetRecentlySavedReports {
  /**
   * Returns the recently saved reports for the current user.
   */
  recentlySavedReports: GetRecentlySavedReports_recentlySavedReports[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRecentlyViewedReports
// ====================================================

export interface GetRecentlyViewedReports_recentlyViewedReports_savedFilter {
  __typename: "SavedFilter";
  id: string;
}

export interface GetRecentlyViewedReports_recentlyViewedReports {
  __typename: "ReportView";
  /**
   * The title of the report (saved filter name or description of filters)
   */
  title: string;
  /**
   * The subtitle of the report
   */
  subtitle: string;
  /**
   * The type of report (e.g., Sales, Activity, Forecast)
   */
  reportType: SavedFiltersReportType;
  /**
   * The time to display for the report on the frontend (last viewed time for
   * recently viewed reports, created time for saved reports)
   */
  displayTime: any;
  /**
   * The URL path to navigate to this report
   */
  htmlUrlPath: string;
  /**
   * The underlying saved filter if this is a saved report
   */
  savedFilter: GetRecentlyViewedReports_recentlyViewedReports_savedFilter | null;
}

export interface GetRecentlyViewedReports {
  /**
   * Returns the recently viewed reports for the current user.
   */
  recentlyViewedReports: GetRecentlyViewedReports_recentlyViewedReports[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMeetingForReportValue
// ====================================================

export interface GetMeetingForReportValue_meeting_primaryHost {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetMeetingForReportValue_meeting_cohosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetMeetingForReportValue_meeting {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * The primary host for this meeting
   */
  primaryHost: GetMeetingForReportValue_meeting_primaryHost | null;
  /**
   * The cohosts of this meeting, not including primary host
   */
  cohosts: GetMeetingForReportValue_meeting_cohosts[];
  /**
   * The number of bookings in the last 90 days
   */
  bookingsCountLast90Days: number;
}

export interface GetMeetingForReportValue {
  /**
   * Returns a scheduler meeting
   */
  meeting: GetMeetingForReportValue_meeting;
}

export interface GetMeetingForReportValueVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMeetingsForReport
// ====================================================

export interface GetMeetingsForReport_meetings_primaryHost {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetMeetingsForReport_meetings_cohosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetMeetingsForReport_meetings {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * The primary host for this meeting
   */
  primaryHost: GetMeetingsForReport_meetings_primaryHost | null;
  /**
   * The cohosts of this meeting, not including primary host
   */
  cohosts: GetMeetingsForReport_meetings_cohosts[];
  /**
   * The number of bookings in the last 90 days
   */
  bookingsCountLast90Days: number;
}

export interface GetMeetingsForReport {
  /**
   * Returns scheduler meetings
   */
  meetings: GetMeetingsForReport_meetings[];
}

export interface GetMeetingsForReportVariables {
  limit?: number | null;
  sort?: MeetingSortOrder | null;
  search?: string | null;
  hasBookingsInLast90Days?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateClosedLeadFollowupAutomation
// ====================================================

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_stages_addTagAutomationTags[];
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_leadDistributionAutomation_conditions_config = CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_leadDistributionAutomation_conditions_config;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_leadDistributionAutomation_conditions[];
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate {
  __typename: "FollowupLeadAutomationCreatePayload";
  /**
   * The created automation.
   */
  stageset: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate_stageset;
}

export interface CreateClosedLeadFollowupAutomation {
  /**
   * Creates a Lead followup automation
   */
  followupLeadAutomationCreate: CreateClosedLeadFollowupAutomation_followupLeadAutomationCreate;
}

export interface CreateClosedLeadFollowupAutomationVariables {
  input: FollowupLeadAutomationCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateClosedLeadTagAutomation
// ====================================================

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_stages_addTagAutomationTags[];
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_leadDistributionAutomation_conditions_config = CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_leadDistributionAutomation_conditions_config;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_leadDistributionAutomation_conditions[];
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate {
  __typename: "ClosedLeadTagAutomationCreatePayload";
  /**
   * The updated stageset.
   */
  stageset: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate_stageset;
}

export interface CreateClosedLeadTagAutomation {
  /**
   * Creates an automation to tag contacts or companies when a lead is closed
   */
  closedLeadTagAutomationCreate: CreateClosedLeadTagAutomation_closedLeadTagAutomationCreate;
}

export interface CreateClosedLeadTagAutomationVariables {
  input: ClosedLeadTagAutomationCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteClosedLeadFollowupAutomation
// ====================================================

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_stages_addTagAutomationTags[];
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_leadDistributionAutomation_conditions_config = DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_leadDistributionAutomation_conditions_config;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_leadDistributionAutomation_conditions[];
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete {
  __typename: "FollowupLeadAutomationDeletePayload";
  /**
   * The updated stageset.
   */
  stageset: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete_stageset;
}

export interface DeleteClosedLeadFollowupAutomation {
  /**
   * Deletes a Lead followup automation
   */
  followupLeadAutomationDelete: DeleteClosedLeadFollowupAutomation_followupLeadAutomationDelete;
}

export interface DeleteClosedLeadFollowupAutomationVariables {
  input: FollowupLeadAutomationDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteClosedLeadTagAutomation
// ====================================================

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_stages_addTagAutomationTags[];
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_leadDistributionAutomation_conditions_config = DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_leadDistributionAutomation_conditions_config;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_leadDistributionAutomation_conditions[];
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete {
  __typename: "ClosedLeadTagAutomationDeletePayload";
  /**
   * The updated stageset.
   */
  stageset: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete_stageset;
}

export interface DeleteClosedLeadTagAutomation {
  /**
   * Deletes an automation to tag contacts or companies when a lead is closed
   */
  closedLeadTagAutomationDelete: DeleteClosedLeadTagAutomation_closedLeadTagAutomationDelete;
}

export interface DeleteClosedLeadTagAutomationVariables {
  input: ClosedLeadTagAutomationDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateClosedLeadFollowupAutomation
// ====================================================

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_stages_addTagAutomationTags[];
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_leadDistributionAutomation_conditions_config = UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_leadDistributionAutomation_conditions_config;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_leadDistributionAutomation_conditions[];
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate {
  __typename: "FollowupLeadAutomationUpdatePayload";
  /**
   * The updated stageset.
   */
  stageset: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate_stageset;
}

export interface UpdateClosedLeadFollowupAutomation {
  /**
   * Updates a Lead followup automation
   */
  followupLeadAutomationUpdate: UpdateClosedLeadFollowupAutomation_followupLeadAutomationUpdate;
}

export interface UpdateClosedLeadFollowupAutomationVariables {
  input: FollowupLeadAutomationUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateClosedLeadTagAutomation
// ====================================================

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_stages_addTagAutomationTags[];
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_leadDistributionAutomation_conditions_config = UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_leadDistributionAutomation_conditions_config;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_leadDistributionAutomation_conditions[];
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate {
  __typename: "ClosedLeadTagAutomationUpdatePayload";
  /**
   * The updated stageset.
   */
  stageset: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate_stageset;
}

export interface UpdateClosedLeadTagAutomation {
  /**
   * Updates an automation to tag contacts or companies when a lead is closed
   */
  closedLeadTagAutomationUpdate: UpdateClosedLeadTagAutomation_closedLeadTagAutomationUpdate;
}

export interface UpdateClosedLeadTagAutomationVariables {
  input: ClosedLeadTagAutomationUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetClosedLeadFollowupAutomation
// ====================================================

export interface GetClosedLeadFollowupAutomation_closedLeadFollowupAutomation_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetClosedLeadFollowupAutomation_closedLeadFollowupAutomation_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetClosedLeadFollowupAutomation_closedLeadFollowupAutomation_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface GetClosedLeadFollowupAutomation_closedLeadFollowupAutomation_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type GetClosedLeadFollowupAutomation_closedLeadFollowupAutomation_assigneeOrRule = GetClosedLeadFollowupAutomation_closedLeadFollowupAutomation_assigneeOrRule_User | GetClosedLeadFollowupAutomation_closedLeadFollowupAutomation_assigneeOrRule_Team | GetClosedLeadFollowupAutomation_closedLeadFollowupAutomation_assigneeOrRule_LeadAssigneeRule;

export interface GetClosedLeadFollowupAutomation_closedLeadFollowupAutomation_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetClosedLeadFollowupAutomation_closedLeadFollowupAutomation {
  __typename: "FollowupLeadAutomation";
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: GetClosedLeadFollowupAutomation_closedLeadFollowupAutomation_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: GetClosedLeadFollowupAutomation_closedLeadFollowupAutomation_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: GetClosedLeadFollowupAutomation_closedLeadFollowupAutomation_tags[];
}

export interface GetClosedLeadFollowupAutomation {
  /**
   * An automation to clone a lead based on the closes status.
   */
  closedLeadFollowupAutomation: GetClosedLeadFollowupAutomation_closedLeadFollowupAutomation;
}

export interface GetClosedLeadFollowupAutomationVariables {
  input: FollowupLeadAutomationInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetClosedLeadTagAutomation
// ====================================================

export interface GetClosedLeadTagAutomation_closedLeadTagAutomation_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface GetClosedLeadTagAutomation_closedLeadTagAutomation {
  __typename: "ClosedLeadTagAutomation";
  entityType: ClosedLeadTagAutomationEntityType;
  tags: GetClosedLeadTagAutomation_closedLeadTagAutomation_tags[];
}

export interface GetClosedLeadTagAutomation {
  /**
   * An automation to tag contacts or companies when a lead is closed.
   */
  closedLeadTagAutomation: GetClosedLeadTagAutomation_closedLeadTagAutomation;
}

export interface GetClosedLeadTagAutomationVariables {
  input: ClosedLeadTagAutomationInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: StageItemSidebar
// ====================================================

export interface StageItemSidebar_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface StageItemSidebar {
  /**
   * Returns a Nutshell Stage
   */
  stage: StageItemSidebar_stage | null;
}

export interface StageItemSidebarVariables {
  stageId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: WidgetStagesetUpdate
// ====================================================

export interface WidgetStagesetUpdate_widgetStagesetUpdate_sidebar_OtherWidget {
  __typename: "OtherWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  /**
   * Whether the widget is required
   */
  isRequired: boolean;
  /**
   * Whether the widget is editable
   */
  isEditable: boolean;
  isDisabledByAdmin: boolean;
}

export interface WidgetStagesetUpdate_widgetStagesetUpdate_sidebar_CustomCustomFieldsWidget_customCustomFields_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable type of the attribute
   */
  displayType: string;
}

export interface WidgetStagesetUpdate_widgetStagesetUpdate_sidebar_CustomCustomFieldsWidget_customCustomFields {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: WidgetStagesetUpdate_widgetStagesetUpdate_sidebar_CustomCustomFieldsWidget_customCustomFields_attribute;
}

export interface WidgetStagesetUpdate_widgetStagesetUpdate_sidebar_CustomCustomFieldsWidget {
  __typename: "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  /**
   * Whether the widget is required
   */
  isRequired: boolean;
  /**
   * Whether the widget is editable
   */
  isEditable: boolean;
  isDisabledByAdmin: boolean;
  /**
   * The custom fields of the widget that can be customized
   */
  customCustomFields: WidgetStagesetUpdate_widgetStagesetUpdate_sidebar_CustomCustomFieldsWidget_customCustomFields[];
}

export type WidgetStagesetUpdate_widgetStagesetUpdate_sidebar = WidgetStagesetUpdate_widgetStagesetUpdate_sidebar_OtherWidget | WidgetStagesetUpdate_widgetStagesetUpdate_sidebar_CustomCustomFieldsWidget;

export interface WidgetStagesetUpdate_widgetStagesetUpdate_workspace_OtherWidget {
  __typename: "OtherWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  /**
   * Whether the widget is required
   */
  isRequired: boolean;
  /**
   * Whether the widget is editable
   */
  isEditable: boolean;
  isDisabledByAdmin: boolean;
}

export interface WidgetStagesetUpdate_widgetStagesetUpdate_workspace_CustomCustomFieldsWidget_customCustomFields_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable type of the attribute
   */
  displayType: string;
}

export interface WidgetStagesetUpdate_widgetStagesetUpdate_workspace_CustomCustomFieldsWidget_customCustomFields {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: WidgetStagesetUpdate_widgetStagesetUpdate_workspace_CustomCustomFieldsWidget_customCustomFields_attribute;
}

export interface WidgetStagesetUpdate_widgetStagesetUpdate_workspace_CustomCustomFieldsWidget {
  __typename: "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  /**
   * Whether the widget is required
   */
  isRequired: boolean;
  /**
   * Whether the widget is editable
   */
  isEditable: boolean;
  isDisabledByAdmin: boolean;
  /**
   * The custom fields of the widget that can be customized
   */
  customCustomFields: WidgetStagesetUpdate_widgetStagesetUpdate_workspace_CustomCustomFieldsWidget_customCustomFields[];
}

export type WidgetStagesetUpdate_widgetStagesetUpdate_workspace = WidgetStagesetUpdate_widgetStagesetUpdate_workspace_OtherWidget | WidgetStagesetUpdate_widgetStagesetUpdate_workspace_CustomCustomFieldsWidget;

export interface WidgetStagesetUpdate_widgetStagesetUpdate {
  __typename: "WidgetStagesetUpdatePayload";
  /**
   * The updated sidebar widgets
   */
  sidebar: WidgetStagesetUpdate_widgetStagesetUpdate_sidebar[];
  /**
   * The updated workspace widgets
   */
  workspace: WidgetStagesetUpdate_widgetStagesetUpdate_workspace[];
}

export interface WidgetStagesetUpdate {
  /**
   * Updates the state of widgets for a given stageset
   */
  widgetStagesetUpdate: WidgetStagesetUpdate_widgetStagesetUpdate | null;
}

export interface WidgetStagesetUpdateVariables {
  input: WidgetStagesetUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetStagesetWidgets
// ====================================================

export interface GetStagesetWidgets_stageset_workspaceWidgets_OtherWidget {
  __typename: "OtherWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  /**
   * Whether the widget is required
   */
  isRequired: boolean;
  /**
   * Whether the widget is editable
   */
  isEditable: boolean;
  isDisabledByAdmin: boolean;
}

export interface GetStagesetWidgets_stageset_workspaceWidgets_CustomCustomFieldsWidget_customCustomFields_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable type of the attribute
   */
  displayType: string;
}

export interface GetStagesetWidgets_stageset_workspaceWidgets_CustomCustomFieldsWidget_customCustomFields {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: GetStagesetWidgets_stageset_workspaceWidgets_CustomCustomFieldsWidget_customCustomFields_attribute;
}

export interface GetStagesetWidgets_stageset_workspaceWidgets_CustomCustomFieldsWidget {
  __typename: "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  /**
   * Whether the widget is required
   */
  isRequired: boolean;
  /**
   * Whether the widget is editable
   */
  isEditable: boolean;
  isDisabledByAdmin: boolean;
  /**
   * The custom fields of the widget that can be customized
   */
  customCustomFields: GetStagesetWidgets_stageset_workspaceWidgets_CustomCustomFieldsWidget_customCustomFields[];
}

export type GetStagesetWidgets_stageset_workspaceWidgets = GetStagesetWidgets_stageset_workspaceWidgets_OtherWidget | GetStagesetWidgets_stageset_workspaceWidgets_CustomCustomFieldsWidget;

export interface GetStagesetWidgets_stageset_sidebarWidgets_OtherWidget {
  __typename: "OtherWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  /**
   * Whether the widget is required
   */
  isRequired: boolean;
  /**
   * Whether the widget is editable
   */
  isEditable: boolean;
  isDisabledByAdmin: boolean;
}

export interface GetStagesetWidgets_stageset_sidebarWidgets_CustomCustomFieldsWidget_customCustomFields_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable type of the attribute
   */
  displayType: string;
}

export interface GetStagesetWidgets_stageset_sidebarWidgets_CustomCustomFieldsWidget_customCustomFields {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: GetStagesetWidgets_stageset_sidebarWidgets_CustomCustomFieldsWidget_customCustomFields_attribute;
}

export interface GetStagesetWidgets_stageset_sidebarWidgets_CustomCustomFieldsWidget {
  __typename: "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  /**
   * Whether the widget is required
   */
  isRequired: boolean;
  /**
   * Whether the widget is editable
   */
  isEditable: boolean;
  isDisabledByAdmin: boolean;
  /**
   * The custom fields of the widget that can be customized
   */
  customCustomFields: GetStagesetWidgets_stageset_sidebarWidgets_CustomCustomFieldsWidget_customCustomFields[];
}

export type GetStagesetWidgets_stageset_sidebarWidgets = GetStagesetWidgets_stageset_sidebarWidgets_OtherWidget | GetStagesetWidgets_stageset_sidebarWidgets_CustomCustomFieldsWidget;

export interface GetStagesetWidgets_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The widgets of the stageset lead workspace
   */
  workspaceWidgets: GetStagesetWidgets_stageset_workspaceWidgets[];
  /**
   * The widgets of the stageset lead sidebar
   */
  sidebarWidgets: GetStagesetWidgets_stageset_sidebarWidgets[];
}

export interface GetStagesetWidgets {
  /**
   * Returns a Nutshell Stageset
   */
  stageset: GetStagesetWidgets_stageset | null;
}

export interface GetStagesetWidgetsVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateAccountAssignmentAutomation
// ====================================================

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_stages_addTagAutomationTags[];
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config = CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions[];
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation {
  __typename: "CreateClosedLeadAccountTypeAutomationPayload";
  /**
   * The updated stageset this new slack automation will be a part of.
   */
  stageset: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation_stageset;
}

export interface CreateAccountAssignmentAutomation {
  /**
   * Creates an account type automation
   */
  createClosedLeadAccountTypeAutomation: CreateAccountAssignmentAutomation_createClosedLeadAccountTypeAutomation;
}

export interface CreateAccountAssignmentAutomationVariables {
  automation: CreateClosedLeadAccountTypeAutomationInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteAccountAssignmentAutomation
// ====================================================

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_stages_addTagAutomationTags[];
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config = DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions[];
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation {
  __typename: "DeleteClosedLeadAccountTypeAutomationPayload";
  /**
   * The update stageset the deleted account type automation will no longer be a part of.
   */
  stageset: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation_stageset;
}

export interface DeleteAccountAssignmentAutomation {
  /**
   * Deletes an account type automation
   */
  deleteClosedLeadAccountTypeAutomation: DeleteAccountAssignmentAutomation_deleteClosedLeadAccountTypeAutomation;
}

export interface DeleteAccountAssignmentAutomationVariables {
  automation: DeleteClosedLeadAccountTypeAutomationInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateAccountAssignmentAutomation
// ====================================================

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_stages_addTagAutomationTags[];
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config = UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions_config;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation_conditions[];
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation {
  __typename: "UpdateClosedLeadAccountTypeAutomationPayload";
  /**
   * The updated stageset this new closed lead account type automation will be a part of.
   */
  stageset: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation_stageset;
}

export interface UpdateAccountAssignmentAutomation {
  /**
   * Updates a Closed Lead account type automation
   */
  updateClosedLeadAccountTypeAutomation: UpdateAccountAssignmentAutomation_updateClosedLeadAccountTypeAutomation;
}

export interface UpdateAccountAssignmentAutomationVariables {
  automation: UpdateClosedLeadAccountTypeAutomationInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: Stages
// ====================================================

export interface Stages_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
}

export interface Stages {
  /**
   * Returns a list of Nutshell Stages that match the given stageset
   */
  stages: Stages_stages[];
}

export interface StagesVariables {
  stagesetId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ActiveStage
// ====================================================

export interface ActiveStage_stage_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface ActiveStage_stage_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface ActiveStage_stage_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ActiveStage_stage_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface ActiveStage_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: ActiveStage_stage_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: ActiveStage_stage_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: ActiveStage_stage_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: ActiveStage_stage_addTagAutomationTags[];
}

export interface ActiveStage {
  /**
   * Returns a Nutshell Stage
   */
  stage: ActiveStage_stage | null;
}

export interface ActiveStageVariables {
  stageId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: OutcomesSelect
// ====================================================

export interface OutcomesSelect_outcomes {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: number;
}

export interface OutcomesSelect {
  /**
   * Returns a list of outcomes by type.
   */
  outcomes: OutcomesSelect_outcomes[];
}

export interface OutcomesSelectVariables {
  type?: OutcomeType[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SlackMessagePreviewStage
// ====================================================

export interface SlackMessagePreviewStage_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * Whether the stage is the first in its stageset
   */
  isFirstStage: boolean;
}

export interface SlackMessagePreviewStage {
  /**
   * Returns a Nutshell Stage
   */
  stage: SlackMessagePreviewStage_stage | null;
}

export interface SlackMessagePreviewStageVariables {
  stageId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateClosedLeadEmailAutomation
// ====================================================

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_stages_addTagAutomationTags[];
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config = CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions[];
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation {
  __typename: "CreateClosedLeadEmailAutomationPayload";
  /**
   * The stageset of the newly created EmailList subscription
   */
  stageset: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation_stageset;
}

export interface CreateClosedLeadEmailAutomation {
  /**
   * Creates a mailchimp subscription for a given outcome type on a stageset.
   */
  createClosedLeadEmailAutomation: CreateClosedLeadEmailAutomation_createClosedLeadEmailAutomation;
}

export interface CreateClosedLeadEmailAutomationVariables {
  emailAutomation: CreateClosedLeadEmailAutomationInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateClosedLeadSlackMessage
// ====================================================

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_stages_addTagAutomationTags[];
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config = CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions[];
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface CreateClosedLeadSlackMessage_createClosedLeadSlackMessage {
  __typename: "CreateClosedLeadSlackMessagePayload";
  /**
   * The updated stageset this new slack automation will be a part of.
   */
  stageset: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage_stageset;
}

export interface CreateClosedLeadSlackMessage {
  /**
   * Creates a Slack automation
   */
  createClosedLeadSlackMessage: CreateClosedLeadSlackMessage_createClosedLeadSlackMessage;
}

export interface CreateClosedLeadSlackMessageVariables {
  closedLeadSlackMessage: CreateClosedLeadSlackMessageInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateClosedLeadTaskTemplate
// ====================================================

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_stages_addTagAutomationTags[];
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config = CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions[];
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate {
  __typename: "CreateClosedLeadTaskTemplatePayload";
  /**
   * The stageset of the newly created task template
   */
  stageset: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate_stageset;
}

export interface CreateClosedLeadTaskTemplate {
  /**
   * Creates a task template for a given outcome type on a stageset.
   */
  createClosedLeadTaskTemplate: CreateClosedLeadTaskTemplate_createClosedLeadTaskTemplate | null;
}

export interface CreateClosedLeadTaskTemplateVariables {
  taskTemplate: CreateClosedLeadTaskTemplateInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateEmailAutomation
// ====================================================

export interface CreateEmailAutomation_createEmailAutomation_emailAutomation_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
}

export interface CreateEmailAutomation_createEmailAutomation_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateEmailAutomation_createEmailAutomation_emailAutomation_exitsStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateEmailAutomation_createEmailAutomation_emailAutomation_sendFromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateEmailAutomation_createEmailAutomation_emailAutomation_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface CreateEmailAutomation_createEmailAutomation_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: CreateEmailAutomation_createEmailAutomation_emailAutomation_emailList | null;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: CreateEmailAutomation_createEmailAutomation_emailAutomation_entersStage;
  /**
   * The stage in which this stage subscription ends.
   */
  exitsStage: CreateEmailAutomation_createEmailAutomation_emailAutomation_exitsStage | null;
  /**
   * The user that automated email sequences should be sent from, or null if sent from the lead assignee
   */
  sendFromUser: CreateEmailAutomation_createEmailAutomation_emailAutomation_sendFromUser | null;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: CreateEmailAutomation_createEmailAutomation_emailAutomation_delay | null;
}

export interface CreateEmailAutomation_createEmailAutomation {
  __typename: "CreateEmailAutomationPayload";
  /**
   * The newly created MailChimp stage subscription
   */
  emailAutomation: CreateEmailAutomation_createEmailAutomation_emailAutomation;
}

export interface CreateEmailAutomation {
  /**
   * Creates an email automation.
   */
  createEmailAutomation: CreateEmailAutomation_createEmailAutomation | null;
}

export interface CreateEmailAutomationVariables {
  emailAutomation: CreateEmailAutomationInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateGoal
// ====================================================

export interface CreateGoal_createGoal_goal_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface CreateGoal_createGoal_goal_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface CreateGoal_createGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface CreateGoal_createGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface CreateGoal_createGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface CreateGoal_createGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface CreateGoal_createGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface CreateGoal_createGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type CreateGoal_createGoal_goal_conditions_config_ConditionConfigEntityFilter_filter = CreateGoal_createGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | CreateGoal_createGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | CreateGoal_createGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | CreateGoal_createGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | CreateGoal_createGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | CreateGoal_createGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface CreateGoal_createGoal_goal_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: CreateGoal_createGoal_goal_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface CreateGoal_createGoal_goal_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type CreateGoal_createGoal_goal_conditions_config = CreateGoal_createGoal_goal_conditions_config_ConditionConfigAudience | CreateGoal_createGoal_goal_conditions_config_ConditionConfigEntityFilter | CreateGoal_createGoal_goal_conditions_config_ConditionConfigLink;

export interface CreateGoal_createGoal_goal_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: CreateGoal_createGoal_goal_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface CreateGoal_createGoal_goal {
  __typename: "Goal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of goal. This is strictly used for UI purposes, and is inferred from the goal’s conditions
   */
  goalType: GoalType;
  /**
   * The associated stage for this goal.
   */
  stage: CreateGoal_createGoal_goal_stage;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this goal. This is essentially just the stringified
   * version of the goal’s conditions, but because a goal can have multiple
   * conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * A list of conditions which must be true to activate this goal.
   */
  conditions: CreateGoal_createGoal_goal_conditions[];
}

export interface CreateGoal_createGoal {
  __typename: "CreateGoalPayload";
  /**
   * The newly created Nutshell goal
   */
  goal: CreateGoal_createGoal_goal;
}

export interface CreateGoal {
  /**
   * Creates a sales process goal for a given stage.
   */
  createGoal: CreateGoal_createGoal;
}

export interface CreateGoalVariables {
  goal: CreateGoalInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateLeadDistributionAutomation
// ====================================================

export interface CreateLeadDistributionAutomation_createLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface CreateLeadDistributionAutomation_createLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface CreateLeadDistributionAutomation_createLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface CreateLeadDistributionAutomation_createLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface CreateLeadDistributionAutomation_createLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type CreateLeadDistributionAutomation_createLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = CreateLeadDistributionAutomation_createLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | CreateLeadDistributionAutomation_createLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | CreateLeadDistributionAutomation_createLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | CreateLeadDistributionAutomation_createLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface CreateLeadDistributionAutomation_createLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: CreateLeadDistributionAutomation_createLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface CreateLeadDistributionAutomation_createLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type CreateLeadDistributionAutomation_createLeadDistributionAutomation_leadDistributionAutomation_conditions_config = CreateLeadDistributionAutomation_createLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigAudience | CreateLeadDistributionAutomation_createLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | CreateLeadDistributionAutomation_createLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface CreateLeadDistributionAutomation_createLeadDistributionAutomation_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: CreateLeadDistributionAutomation_createLeadDistributionAutomation_leadDistributionAutomation_conditions_config;
}

export interface CreateLeadDistributionAutomation_createLeadDistributionAutomation_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: CreateLeadDistributionAutomation_createLeadDistributionAutomation_leadDistributionAutomation_conditions[];
}

export interface CreateLeadDistributionAutomation_createLeadDistributionAutomation {
  __typename: "CreateLeadDistributionAutomationPayload";
  /**
   * The newly created Nutshell lead distribution automation
   */
  leadDistributionAutomation: CreateLeadDistributionAutomation_createLeadDistributionAutomation_leadDistributionAutomation;
}

export interface CreateLeadDistributionAutomation {
  /**
   * Creates a lead distribution automation
   */
  createLeadDistributionAutomation: CreateLeadDistributionAutomation_createLeadDistributionAutomation;
}

export interface CreateLeadDistributionAutomationVariables {
  leadDistributionAutomation: CreateLeadDistributionAutomationInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateOpenLeadSlackMessage
// ====================================================

export interface CreateOpenLeadSlackMessage_createOpenLeadSlackMessage_stage_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface CreateOpenLeadSlackMessage_createOpenLeadSlackMessage_stage_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface CreateOpenLeadSlackMessage_createOpenLeadSlackMessage_stage_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateOpenLeadSlackMessage_createOpenLeadSlackMessage_stage_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface CreateOpenLeadSlackMessage_createOpenLeadSlackMessage_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: CreateOpenLeadSlackMessage_createOpenLeadSlackMessage_stage_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: CreateOpenLeadSlackMessage_createOpenLeadSlackMessage_stage_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: CreateOpenLeadSlackMessage_createOpenLeadSlackMessage_stage_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: CreateOpenLeadSlackMessage_createOpenLeadSlackMessage_stage_addTagAutomationTags[];
}

export interface CreateOpenLeadSlackMessage_createOpenLeadSlackMessage {
  __typename: "CreateOpenLeadSlackMessagePayload";
  /**
   * The updated stage this new slack automation will be a part of.
   */
  stage: CreateOpenLeadSlackMessage_createOpenLeadSlackMessage_stage;
}

export interface CreateOpenLeadSlackMessage {
  /**
   * Creates a Slack automation
   */
  createOpenLeadSlackMessage: CreateOpenLeadSlackMessage_createOpenLeadSlackMessage;
}

export interface CreateOpenLeadSlackMessageVariables {
  openLeadSlackMessage: CreateOpenLeadSlackMessageInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateStagesetStarter
// ====================================================

export interface CreateStagesetStarter_stagesetStarterCreate_stageset {
  __typename: "Stageset";
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface CreateStagesetStarter_stagesetStarterCreate {
  __typename: "StagesetStarterCreatePayload";
  /**
   * The newly created Nutshell stageset.
   */
  stageset: CreateStagesetStarter_stagesetStarterCreate_stageset;
}

export interface CreateStagesetStarter {
  /**
   * Creates a new stageset.
   */
  stagesetStarterCreate: CreateStagesetStarter_stagesetStarterCreate;
}

export interface CreateStagesetStarterVariables {
  input: StagesetStarterCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateBlankStageset
// ====================================================

export interface CreateBlankStageset_createStageset_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
}

export interface CreateBlankStageset_createStageset_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateBlankStageset_createStageset_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * Can this pipeline be accessed? If a customer downgrades, non-default pipelines may become inaccessible
   */
  canAccess: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The stages associated with this stageset
   */
  stages: CreateBlankStageset_createStageset_stageset_stages[];
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: CreateBlankStageset_createStageset_stageset_leadDistributionAutomation | null;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
  /**
   * Who is allowed to view this stageset, its leads, and their contacts/accounts.
   */
  visibilityMode: StagesetVisibilityMode;
  /**
   * The number of enabled users who can view this stageset when visibilityMode is
   * RESTRICTED. Includes administrators. Returns null otherwise. Admin-only; null
   * for non-admins.
   */
  restrictedCanViewCount: number | null;
}

export interface CreateBlankStageset_createStageset {
  __typename: "CreateStagesetPayload";
  /**
   * The newly created Nutshell stageset.
   */
  stageset: CreateBlankStageset_createStageset_stageset;
}

export interface CreateBlankStageset {
  /**
   * Creates a new stageset.
   */
  createStageset: CreateBlankStageset_createStageset;
}

export interface CreateBlankStagesetVariables {
  stageset: CreateStagesetInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateStepTemplate
// ====================================================

export interface CreateStepTemplate_createStepTemplate_stepTemplate_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateStepTemplate_createStepTemplate_stepTemplate_dueDate {
  __typename: "StepDueDate";
  /**
   * The reference point for this due date. This can include when the lead was created, when the stage was entered, etc.
   */
  dueFrom: number;
  /**
   * The unit to measure this step template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this step template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface CreateStepTemplate_createStepTemplate_stepTemplate_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface CreateStepTemplate_createStepTemplate_stepTemplate_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type CreateStepTemplate_createStepTemplate_stepTemplate_assignee = CreateStepTemplate_createStepTemplate_stepTemplate_assignee_Team | CreateStepTemplate_createStepTemplate_stepTemplate_assignee_User;

export interface CreateStepTemplate_createStepTemplate_stepTemplate {
  __typename: "StepTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The name of the Nutshell StepTemplate.
   */
  name: string;
  /**
   * The description of the Nutshell StepTemplate.
   */
  description: string | null;
  /**
   * The stage/milestone within the pipeline that this step template lives within for our sales automation tool
   */
  stage: CreateStepTemplate_createStepTemplate_stepTemplate_stage;
  /**
   * The rules to determine the due date for this step.
   */
  dueDate: CreateStepTemplate_createStepTemplate_stepTemplate_dueDate | null;
  /**
   * The description of the Nutshell StepTemplate.
   */
  assignee: CreateStepTemplate_createStepTemplate_stepTemplate_assignee | null;
}

export interface CreateStepTemplate_createStepTemplate {
  __typename: "CreateStepTemplatePayload";
  /**
   * The newly created Nutshell step template
   */
  stepTemplate: CreateStepTemplate_createStepTemplate_stepTemplate;
}

export interface CreateStepTemplate {
  /**
   * Creates a sales process step template for a given stage.
   */
  createStepTemplate: CreateStepTemplate_createStepTemplate | null;
}

export interface CreateStepTemplateVariables {
  stepTemplate: CreateStepTemplateInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateTextAutomation
// ====================================================

export interface CreateTextAutomation_textAutomationCreate_textAutomation_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface CreateTextAutomation_textAutomationCreate_textAutomation_sendFromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  initials: string;
  avatarUrl: string;
  name: string;
}

export interface CreateTextAutomation_textAutomationCreate_textAutomation_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface CreateTextAutomation_textAutomationCreate_textAutomation {
  __typename: "TextMessageAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Content of the text body.
   */
  content: string;
  position: number;
  /**
   * The associated stage for this text.
   */
  stage: CreateTextAutomation_textAutomationCreate_textAutomation_stage;
  /**
   * The user to assign the thread to and send messages from.
   */
  sendFromUser: CreateTextAutomation_textAutomationCreate_textAutomation_sendFromUser | null;
  /**
   * How long to wait before sending the text.
   */
  delay: CreateTextAutomation_textAutomationCreate_textAutomation_delay;
}

export interface CreateTextAutomation_textAutomationCreate {
  __typename: "TextAutomationCreatePayload";
  /**
   * The created automation.
   */
  textAutomation: CreateTextAutomation_textAutomationCreate_textAutomation;
}

export interface CreateTextAutomation {
  /**
   * Creates a Text automation
   */
  textAutomationCreate: CreateTextAutomation_textAutomationCreate;
}

export interface CreateTextAutomationVariables {
  textAutomation: TextAutomationCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteClosedLeadEmailAutomation
// ====================================================

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_stages_addTagAutomationTags[];
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config = DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions[];
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation {
  __typename: "DeleteClosedLeadEmailAutomationPayload";
  /**
   * The stageset of the deleted EmailList subscription
   */
  stageset: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation_stageset;
}

export interface DeleteClosedLeadEmailAutomation {
  /**
   * Deletes a closed lead mailchimp subscription
   */
  deleteClosedLeadEmailAutomation: DeleteClosedLeadEmailAutomation_deleteClosedLeadEmailAutomation;
}

export interface DeleteClosedLeadEmailAutomationVariables {
  emailAutomation: DeleteClosedLeadEmailAutomationInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteClosedLeadSlackMessage
// ====================================================

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_stages_addTagAutomationTags[];
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config = DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions[];
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage {
  __typename: "DeleteClosedLeadSlackMessagePayload";
  /**
   * The update stageset the deleted slack automation will no longer be a part of.
   */
  stageset: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage_stageset;
}

export interface DeleteClosedLeadSlackMessage {
  /**
   * Deletes a Slack automation
   */
  deleteClosedLeadSlackMessage: DeleteClosedLeadSlackMessage_deleteClosedLeadSlackMessage;
}

export interface DeleteClosedLeadSlackMessageVariables {
  closedLeadSlackMessage: DeleteClosedLeadSlackMessageInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteClosedLeadTaskTemplate
// ====================================================

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_stages_addTagAutomationTags[];
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config = DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions[];
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate {
  __typename: "DeleteClosedLeadTaskTemplatePayload";
  /**
   * The stageset of the deleted task template
   */
  stageset: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate_stageset;
}

export interface DeleteClosedLeadTaskTemplate {
  /**
   * Deletes a task template
   */
  deleteClosedLeadTaskTemplate: DeleteClosedLeadTaskTemplate_deleteClosedLeadTaskTemplate | null;
}

export interface DeleteClosedLeadTaskTemplateVariables {
  taskTemplate: DeleteClosedLeadTaskTemplateInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteEmailAutomation
// ====================================================

export interface DeleteEmailAutomation_deleteEmailAutomation_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteEmailAutomation_deleteEmailAutomation {
  __typename: "DeleteEmailAutomationPayload";
  /**
   * The deleted MailChimp stage subscription
   */
  emailAutomation: DeleteEmailAutomation_deleteEmailAutomation_emailAutomation;
}

export interface DeleteEmailAutomation {
  /**
   * Deletes an EmailList stage subscription.
   */
  deleteEmailAutomation: DeleteEmailAutomation_deleteEmailAutomation | null;
}

export interface DeleteEmailAutomationVariables {
  emailAutomation: DeleteEmailAutomationInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteGoal
// ====================================================

export interface DeleteGoal_deleteGoal_goal {
  __typename: "Goal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteGoal_deleteGoal {
  __typename: "DeleteGoalPayload";
  /**
   * The deleted Nutshell goal
   */
  goal: DeleteGoal_deleteGoal_goal;
}

export interface DeleteGoal {
  /**
   * Deletes a sales process goal.
   */
  deleteGoal: DeleteGoal_deleteGoal;
}

export interface DeleteGoalVariables {
  goal: DeleteGoalInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteLeadDistributionAutomation
// ====================================================

export interface DeleteLeadDistributionAutomation_deleteLeadDistributionAutomation_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteLeadDistributionAutomation_deleteLeadDistributionAutomation {
  __typename: "DeleteLeadDistributionAutomationPayload";
  /**
   * The newly deleted Nutshell lead distribution automation
   */
  leadDistributionAutomation: DeleteLeadDistributionAutomation_deleteLeadDistributionAutomation_leadDistributionAutomation;
}

export interface DeleteLeadDistributionAutomation {
  /**
   * Deletes a lead distribution automation
   */
  deleteLeadDistributionAutomation: DeleteLeadDistributionAutomation_deleteLeadDistributionAutomation;
}

export interface DeleteLeadDistributionAutomationVariables {
  leadDistributionAutomation: DeleteLeadDistributionAutomationInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteOpenLeadSlackMessage
// ====================================================

export interface DeleteOpenLeadSlackMessage_deleteOpenLeadSlackMessage_openLeadSlackMessage {
  __typename: "SlackMessageAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteOpenLeadSlackMessage_deleteOpenLeadSlackMessage {
  __typename: "DeleteOpenLeadSlackMessagePayload";
  /**
   * The newly deleted slack message automation.
   */
  openLeadSlackMessage: DeleteOpenLeadSlackMessage_deleteOpenLeadSlackMessage_openLeadSlackMessage;
}

export interface DeleteOpenLeadSlackMessage {
  /**
   * Deletes a Slack automation
   */
  deleteOpenLeadSlackMessage: DeleteOpenLeadSlackMessage_deleteOpenLeadSlackMessage;
}

export interface DeleteOpenLeadSlackMessageVariables {
  openLeadSlackMessage: DeleteOpenLeadSlackMessageInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteStepTemplate
// ====================================================

export interface DeleteStepTemplate_deleteStepTemplate_stepTemplate {
  __typename: "StepTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteStepTemplate_deleteStepTemplate {
  __typename: "DeleteStepTemplatePayload";
  /**
   * The deleted Nutshell step template
   */
  stepTemplate: DeleteStepTemplate_deleteStepTemplate_stepTemplate;
}

export interface DeleteStepTemplate {
  /**
   * Deletes a sales process step template.
   */
  deleteStepTemplate: DeleteStepTemplate_deleteStepTemplate | null;
}

export interface DeleteStepTemplateVariables {
  stepTemplate: DeleteStepTemplateInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteTextAutomation
// ====================================================

export interface DeleteTextAutomation_textAutomationDelete_textAutomation {
  __typename: "TextMessageAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteTextAutomation_textAutomationDelete {
  __typename: "TextAutomationDeletePayload";
  /**
   * The newly deleted text message automation.
   */
  textAutomation: DeleteTextAutomation_textAutomationDelete_textAutomation;
}

export interface DeleteTextAutomation {
  /**
   * Deletes a text automation
   */
  textAutomationDelete: DeleteTextAutomation_textAutomationDelete;
}

export interface DeleteTextAutomationVariables {
  textAutomation: TextAutomationDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DuplicateStagesetForModal
// ====================================================

export interface DuplicateStagesetForModal_duplicateStageset_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface DuplicateStagesetForModal_duplicateStageset {
  __typename: "DuplicateStagesetPayload";
  stageset: DuplicateStagesetForModal_duplicateStageset_stageset;
}

export interface DuplicateStagesetForModal {
  /**
   * Duplicates (referred to as archived in the UI) a Stageset.
   */
  duplicateStageset: DuplicateStagesetForModal_duplicateStageset | null;
}

export interface DuplicateStagesetForModalVariables {
  input: DuplicateStagesetInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MoveStage
// ====================================================

export interface MoveStage_stageUpdate_stageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface MoveStage_stageUpdate_stageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface MoveStage_stageUpdate_stageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface MoveStage_stageUpdate_stageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MoveStage_stageUpdate_stageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface MoveStage_stageUpdate_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: MoveStage_stageUpdate_stageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: MoveStage_stageUpdate_stageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: MoveStage_stageUpdate_stageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: MoveStage_stageUpdate_stageset_stages_addTagAutomationTags[];
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface MoveStage_stageUpdate_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: MoveStage_stageUpdate_stageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface MoveStage_stageUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface MoveStage_stageUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface MoveStage_stageUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface MoveStage_stageUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface MoveStage_stageUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type MoveStage_stageUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = MoveStage_stageUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | MoveStage_stageUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | MoveStage_stageUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | MoveStage_stageUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface MoveStage_stageUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: MoveStage_stageUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface MoveStage_stageUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type MoveStage_stageUpdate_stageset_leadDistributionAutomation_conditions_config = MoveStage_stageUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | MoveStage_stageUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | MoveStage_stageUpdate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface MoveStage_stageUpdate_stageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: MoveStage_stageUpdate_stageset_leadDistributionAutomation_conditions_config;
}

export interface MoveStage_stageUpdate_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: MoveStage_stageUpdate_stageset_leadDistributionAutomation_conditions[];
}

export interface MoveStage_stageUpdate_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: MoveStage_stageUpdate_stageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: MoveStage_stageUpdate_stageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: MoveStage_stageUpdate_stageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: MoveStage_stageUpdate_stageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface MoveStage_stageUpdate {
  __typename: "StageUpdatePayload";
  stageset: MoveStage_stageUpdate_stageset;
}

export interface MoveStage {
  /**
   * Updates a Nutshell stage.
   */
  stageUpdate: MoveStage_stageUpdate;
}

export interface MoveStageVariables {
  stage: StageUpdateInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RepositionStageset
// ====================================================

export interface RepositionStageset_repositionStageset_stagesets_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
}

export interface RepositionStageset_repositionStageset_stagesets_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface RepositionStageset_repositionStageset_stagesets {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * Can this pipeline be accessed? If a customer downgrades, non-default pipelines may become inaccessible
   */
  canAccess: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The stages associated with this stageset
   */
  stages: RepositionStageset_repositionStageset_stagesets_stages[];
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: RepositionStageset_repositionStageset_stagesets_leadDistributionAutomation | null;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
  /**
   * Who is allowed to view this stageset, its leads, and their contacts/accounts.
   */
  visibilityMode: StagesetVisibilityMode;
  /**
   * The number of enabled users who can view this stageset when visibilityMode is
   * RESTRICTED. Includes administrators. Returns null otherwise. Admin-only; null
   * for non-admins.
   */
  restrictedCanViewCount: number | null;
}

export interface RepositionStageset_repositionStageset {
  __typename: "RepositionStagesetPayload";
  /**
   * All stagesets.
   */
  stagesets: RepositionStageset_repositionStageset_stagesets[];
}

export interface RepositionStageset {
  /**
   * Repositions a sales process stageset.
   */
  repositionStageset: RepositionStageset_repositionStageset | null;
}

export interface RepositionStagesetVariables {
  stagesetPositionPayload: RepositionStagesetInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RepositionStepTemplate
// ====================================================

export interface RepositionStepTemplate_repositionStepTemplate_stepTemplate_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface RepositionStepTemplate_repositionStepTemplate_stepTemplate_dueDate {
  __typename: "StepDueDate";
  /**
   * The reference point for this due date. This can include when the lead was created, when the stage was entered, etc.
   */
  dueFrom: number;
  /**
   * The unit to measure this step template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this step template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface RepositionStepTemplate_repositionStepTemplate_stepTemplate_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface RepositionStepTemplate_repositionStepTemplate_stepTemplate_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type RepositionStepTemplate_repositionStepTemplate_stepTemplate_assignee = RepositionStepTemplate_repositionStepTemplate_stepTemplate_assignee_Team | RepositionStepTemplate_repositionStepTemplate_stepTemplate_assignee_User;

export interface RepositionStepTemplate_repositionStepTemplate_stepTemplate {
  __typename: "StepTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The name of the Nutshell StepTemplate.
   */
  name: string;
  /**
   * The description of the Nutshell StepTemplate.
   */
  description: string | null;
  /**
   * The stage/milestone within the pipeline that this step template lives within for our sales automation tool
   */
  stage: RepositionStepTemplate_repositionStepTemplate_stepTemplate_stage;
  /**
   * The rules to determine the due date for this step.
   */
  dueDate: RepositionStepTemplate_repositionStepTemplate_stepTemplate_dueDate | null;
  /**
   * The description of the Nutshell StepTemplate.
   */
  assignee: RepositionStepTemplate_repositionStepTemplate_stepTemplate_assignee | null;
}

export interface RepositionStepTemplate_repositionStepTemplate_oldStage_editableStepTemplates_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface RepositionStepTemplate_repositionStepTemplate_oldStage_editableStepTemplates_dueDate {
  __typename: "StepDueDate";
  /**
   * The reference point for this due date. This can include when the lead was created, when the stage was entered, etc.
   */
  dueFrom: number;
  /**
   * The unit to measure this step template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this step template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface RepositionStepTemplate_repositionStepTemplate_oldStage_editableStepTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface RepositionStepTemplate_repositionStepTemplate_oldStage_editableStepTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type RepositionStepTemplate_repositionStepTemplate_oldStage_editableStepTemplates_assignee = RepositionStepTemplate_repositionStepTemplate_oldStage_editableStepTemplates_assignee_Team | RepositionStepTemplate_repositionStepTemplate_oldStage_editableStepTemplates_assignee_User;

export interface RepositionStepTemplate_repositionStepTemplate_oldStage_editableStepTemplates {
  __typename: "StepTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The name of the Nutshell StepTemplate.
   */
  name: string;
  /**
   * The description of the Nutshell StepTemplate.
   */
  description: string | null;
  /**
   * The stage/milestone within the pipeline that this step template lives within for our sales automation tool
   */
  stage: RepositionStepTemplate_repositionStepTemplate_oldStage_editableStepTemplates_stage;
  /**
   * The rules to determine the due date for this step.
   */
  dueDate: RepositionStepTemplate_repositionStepTemplate_oldStage_editableStepTemplates_dueDate | null;
  /**
   * The description of the Nutshell StepTemplate.
   */
  assignee: RepositionStepTemplate_repositionStepTemplate_oldStage_editableStepTemplates_assignee | null;
}

export interface RepositionStepTemplate_repositionStepTemplate_oldStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The editable copies of the step templates available for this stage
   */
  editableStepTemplates: RepositionStepTemplate_repositionStepTemplate_oldStage_editableStepTemplates[];
}

export interface RepositionStepTemplate_repositionStepTemplate_newStage_editableStepTemplates_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface RepositionStepTemplate_repositionStepTemplate_newStage_editableStepTemplates_dueDate {
  __typename: "StepDueDate";
  /**
   * The reference point for this due date. This can include when the lead was created, when the stage was entered, etc.
   */
  dueFrom: number;
  /**
   * The unit to measure this step template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this step template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface RepositionStepTemplate_repositionStepTemplate_newStage_editableStepTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface RepositionStepTemplate_repositionStepTemplate_newStage_editableStepTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type RepositionStepTemplate_repositionStepTemplate_newStage_editableStepTemplates_assignee = RepositionStepTemplate_repositionStepTemplate_newStage_editableStepTemplates_assignee_Team | RepositionStepTemplate_repositionStepTemplate_newStage_editableStepTemplates_assignee_User;

export interface RepositionStepTemplate_repositionStepTemplate_newStage_editableStepTemplates {
  __typename: "StepTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The name of the Nutshell StepTemplate.
   */
  name: string;
  /**
   * The description of the Nutshell StepTemplate.
   */
  description: string | null;
  /**
   * The stage/milestone within the pipeline that this step template lives within for our sales automation tool
   */
  stage: RepositionStepTemplate_repositionStepTemplate_newStage_editableStepTemplates_stage;
  /**
   * The rules to determine the due date for this step.
   */
  dueDate: RepositionStepTemplate_repositionStepTemplate_newStage_editableStepTemplates_dueDate | null;
  /**
   * The description of the Nutshell StepTemplate.
   */
  assignee: RepositionStepTemplate_repositionStepTemplate_newStage_editableStepTemplates_assignee | null;
}

export interface RepositionStepTemplate_repositionStepTemplate_newStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The editable copies of the step templates available for this stage
   */
  editableStepTemplates: RepositionStepTemplate_repositionStepTemplate_newStage_editableStepTemplates[];
}

export interface RepositionStepTemplate_repositionStepTemplate {
  __typename: "RepositionStepTemplatePayload";
  /**
   * The newly created Nutshell step template
   */
  stepTemplate: RepositionStepTemplate_repositionStepTemplate_stepTemplate;
  /**
   * The stage of the step template _before_ the repositioning, handy for querying
   * the field so you can reposition any remaining tasks within that stage
   */
  oldStage: RepositionStepTemplate_repositionStepTemplate_oldStage;
  /**
   * The stage of the step template _after_ the repositioning, handy for querying
   * the field so you can reposition any remaining tasks within that stage
   */
  newStage: RepositionStepTemplate_repositionStepTemplate_newStage;
}

export interface RepositionStepTemplate {
  /**
   * Repositions a sales process step template within a stage of a sales pipeline.
   * This allows for reordering steps within a sales process.
   */
  repositionStepTemplate: RepositionStepTemplate_repositionStepTemplate | null;
}

export interface RepositionStepTemplateVariables {
  stepTemplatePositionPayload: RepositionStepTemplateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetDefaultStageset
// ====================================================

export interface SetDefaultStageset_setDefaultStageset_stagesets_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
}

export interface SetDefaultStageset_setDefaultStageset_stagesets_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SetDefaultStageset_setDefaultStageset_stagesets {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * Can this pipeline be accessed? If a customer downgrades, non-default pipelines may become inaccessible
   */
  canAccess: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The stages associated with this stageset
   */
  stages: SetDefaultStageset_setDefaultStageset_stagesets_stages[];
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: SetDefaultStageset_setDefaultStageset_stagesets_leadDistributionAutomation | null;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
  /**
   * Who is allowed to view this stageset, its leads, and their contacts/accounts.
   */
  visibilityMode: StagesetVisibilityMode;
  /**
   * The number of enabled users who can view this stageset when visibilityMode is
   * RESTRICTED. Includes administrators. Returns null otherwise. Admin-only; null
   * for non-admins.
   */
  restrictedCanViewCount: number | null;
}

export interface SetDefaultStageset_setDefaultStageset {
  __typename: "SetDefaultStagesetPayload";
  /**
   * All stagesets.
   */
  stagesets: SetDefaultStageset_setDefaultStageset_stagesets[];
}

export interface SetDefaultStageset {
  /**
   * Sets a new default Nutshell Stageset.
   */
  setDefaultStageset: SetDefaultStageset_setDefaultStageset | null;
}

export interface SetDefaultStagesetVariables {
  stageset: SetDefaultStagesetInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetStageAddTagAutomation
// ====================================================

export interface SetStageAddTagAutomation_setStageAddTagAutomation_stage_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface SetStageAddTagAutomation_setStageAddTagAutomation_stage_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface SetStageAddTagAutomation_setStageAddTagAutomation_stage_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SetStageAddTagAutomation_setStageAddTagAutomation_stage_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SetStageAddTagAutomation_setStageAddTagAutomation_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: SetStageAddTagAutomation_setStageAddTagAutomation_stage_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: SetStageAddTagAutomation_setStageAddTagAutomation_stage_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: SetStageAddTagAutomation_setStageAddTagAutomation_stage_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: SetStageAddTagAutomation_setStageAddTagAutomation_stage_addTagAutomationTags[];
}

export interface SetStageAddTagAutomation_setStageAddTagAutomation {
  __typename: "SetStageAddTagAutomationPayload";
  /**
   * The stage that houses the new add-tag automation.
   */
  stage: SetStageAddTagAutomation_setStageAddTagAutomation_stage;
}

export interface SetStageAddTagAutomation {
  /**
   * Creates, updates, or clears the add-tag automation for a given stage.
   */
  setStageAddTagAutomation: SetStageAddTagAutomation_setStageAddTagAutomation;
}

export interface SetStageAddTagAutomationVariables {
  stageId: string;
  tagIds: string[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetStageLeadAssignmentAutomation
// ====================================================

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The DateTime that represents when the team record was deleted
   */
  deletedTime: any | null;
}

export type SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_assignee = SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_assignee_User | SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_assignee_Team;

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter = SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config = SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigAudience | SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter | SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigLink;

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate {
  __typename: "Predicate";
  /**
   * The conditions that must be true for this predicate to activate an automation.
   */
  conditions: SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions[];
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation {
  __typename: "StageLeadAssignmentAutomation";
  /**
   * Flag to determine if this automation should unassign the lead.
   */
  shouldUnassign: boolean;
  /**
   * If the assignee is a team, round robin will equally distribute leads to each member of the team.
   */
  shouldRoundRobin: boolean | null;
  /**
   * The assignee object for this lead assignment automation.
   */
  assignee: SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_assignee | null;
  /**
   * This automation's predicate.
   */
  predicate: SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate;
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The DateTime that represents when the team record was deleted
   */
  deletedTime: any | null;
}

export type SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_assignee = SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_assignee_User | SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_assignee_Team;

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter = SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config = SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigAudience | SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter | SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigLink;

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate {
  __typename: "Predicate";
  /**
   * The conditions that must be true for this predicate to activate an automation.
   */
  conditions: SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions[];
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations {
  __typename: "StageLeadAssignmentAutomation";
  /**
   * Flag to determine if this automation should unassign the lead.
   */
  shouldUnassign: boolean;
  /**
   * If the assignee is a team, round robin will equally distribute leads to each member of the team.
   */
  shouldRoundRobin: boolean | null;
  /**
   * The assignee object for this lead assignment automation.
   */
  assignee: SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_assignee | null;
  /**
   * This automation's predicate.
   */
  predicate: SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate;
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData {
  __typename: "StageLeadAssignmentAutomationData";
  /**
   * The global setting for this set of stage lead assignment automations saying whether reassignment is allowed.
   */
  stageLeadAssignmentAllowReassign: boolean;
  /**
   * The default automation that will be fired if all special cases fail to fire.
   */
  stageLeadAssignmentDefaultAutomation: SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation | null;
  /**
   * The nicely unpacked list of automations for this set of stage lead assignment automations.
   */
  stageLeadAssignmentAutomations: SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations[];
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage {
  __typename: "Stage";
  /**
   * The object housing the list of editable stageLeadAssignmentAutomations and associated meta data for this stage.
   */
  editableStageLeadAssignmentAutomationData: SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage_editableStageLeadAssignmentAutomationData;
}

export interface SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation {
  __typename: "SetStageLeadAssignmentAutomationPayload";
  /**
   * The complete stage that houses this new stage lead assignment automation.
   */
  stage: SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation_stage;
}

export interface SetStageLeadAssignmentAutomation {
  /**
   * Creates or updates a sales process conditional lead assignment automation for a given stage.
   */
  setStageLeadAssignmentAutomation: SetStageLeadAssignmentAutomation_setStageLeadAssignmentAutomation | null;
}

export interface SetStageLeadAssignmentAutomationVariables {
  stageLeadAssignmentAutomation: SetStageLeadAssignmentAutomationInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: StageCreate
// ====================================================

export interface StageCreate_stageCreate_stage_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface StageCreate_stageCreate_stage_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface StageCreate_stageCreate_stage_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface StageCreate_stageCreate_stage_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface StageCreate_stageCreate_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: StageCreate_stageCreate_stage_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: StageCreate_stageCreate_stage_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: StageCreate_stageCreate_stage_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: StageCreate_stageCreate_stage_addTagAutomationTags[];
}

export interface StageCreate_stageCreate {
  __typename: "StageCreatePayload";
  stage: StageCreate_stageCreate_stage | null;
}

export interface StageCreate {
  /**
   * Creates a new stage in the given pipeline.
   */
  stageCreate: StageCreate_stageCreate;
}

export interface StageCreateVariables {
  stage: StageCreateInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: StageDelete
// ====================================================

export interface StageDelete_stageDelete_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface StageDelete_stageDelete {
  __typename: "StageDeletePayload";
  stage: StageDelete_stageDelete_stage;
}

export interface StageDelete {
  /**
   * Deletes a Stage.
   */
  stageDelete: StageDelete_stageDelete;
}

export interface StageDeleteVariables {
  stage: StageDeleteInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: StageUpdate
// ====================================================

export interface StageUpdate_stageUpdate_stage_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface StageUpdate_stageUpdate_stage_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface StageUpdate_stageUpdate_stage_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface StageUpdate_stageUpdate_stage_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface StageUpdate_stageUpdate_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: StageUpdate_stageUpdate_stage_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: StageUpdate_stageUpdate_stage_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: StageUpdate_stageUpdate_stage_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: StageUpdate_stageUpdate_stage_addTagAutomationTags[];
}

export interface StageUpdate_stageUpdate {
  __typename: "StageUpdatePayload";
  stage: StageUpdate_stageUpdate_stage;
}

export interface StageUpdate {
  /**
   * Updates a Nutshell stage.
   */
  stageUpdate: StageUpdate_stageUpdate;
}

export interface StageUpdateVariables {
  stage: StageUpdateInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: StagesetActivateDraft
// ====================================================

export interface StagesetActivateDraft_stagesetActivateDraft_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
}

export interface StagesetActivateDraft_stagesetActivateDraft_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface StagesetActivateDraft_stagesetActivateDraft_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * Can this pipeline be accessed? If a customer downgrades, non-default pipelines may become inaccessible
   */
  canAccess: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The stages associated with this stageset
   */
  stages: StagesetActivateDraft_stagesetActivateDraft_stageset_stages[];
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: StagesetActivateDraft_stagesetActivateDraft_stageset_leadDistributionAutomation | null;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
  /**
   * Who is allowed to view this stageset, its leads, and their contacts/accounts.
   */
  visibilityMode: StagesetVisibilityMode;
  /**
   * The number of enabled users who can view this stageset when visibilityMode is
   * RESTRICTED. Includes administrators. Returns null otherwise. Admin-only; null
   * for non-admins.
   */
  restrictedCanViewCount: number | null;
}

export interface StagesetActivateDraft_stagesetActivateDraft {
  __typename: "StagesetActivateDraftPayload";
  /**
   * The activated stageset
   */
  stageset: StagesetActivateDraft_stagesetActivateDraft_stageset;
}

export interface StagesetActivateDraft {
  /**
   * Activates a draft stageset, and optionally sets it as the default stageset
   */
  stagesetActivateDraft: StagesetActivateDraft_stagesetActivateDraft;
}

export interface StagesetActivateDraftVariables {
  input: StagesetActivateDraftInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: StagesetDeactivate
// ====================================================

export interface StagesetDeactivate_stagesetDeactivate_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
}

export interface StagesetDeactivate_stagesetDeactivate_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface StagesetDeactivate_stagesetDeactivate_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * Can this pipeline be accessed? If a customer downgrades, non-default pipelines may become inaccessible
   */
  canAccess: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The stages associated with this stageset
   */
  stages: StagesetDeactivate_stagesetDeactivate_stageset_stages[];
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: StagesetDeactivate_stagesetDeactivate_stageset_leadDistributionAutomation | null;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
  /**
   * Who is allowed to view this stageset, its leads, and their contacts/accounts.
   */
  visibilityMode: StagesetVisibilityMode;
  /**
   * The number of enabled users who can view this stageset when visibilityMode is
   * RESTRICTED. Includes administrators. Returns null otherwise. Admin-only; null
   * for non-admins.
   */
  restrictedCanViewCount: number | null;
}

export interface StagesetDeactivate_stagesetDeactivate {
  __typename: "StagesetDeactivatePayload";
  /**
   * The deactivated stageset
   */
  stageset: StagesetDeactivate_stagesetDeactivate_stageset;
}

export interface StagesetDeactivate {
  /**
   * Deactivates a stageset. If the stageset has any historical lead data then we
   * will set the status to retired, otherwise it will be set to draft.
   */
  stagesetDeactivate: StagesetDeactivate_stagesetDeactivate;
}

export interface StagesetDeactivateVariables {
  input: StagesetDeactivateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateClosedLeadEmailAutomation
// ====================================================

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_stages_addTagAutomationTags[];
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config = UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions_config;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_leadDistributionAutomation_conditions[];
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation {
  __typename: "UpdateClosedLeadEmailAutomationPayload";
  /**
   * The stageset of the newly created EmailList subscription
   */
  stageset: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation_stageset;
}

export interface UpdateClosedLeadEmailAutomation {
  /**
   * Update a EmailList subcription for closed leads.
   */
  updateClosedLeadEmailAutomation: UpdateClosedLeadEmailAutomation_updateClosedLeadEmailAutomation | null;
}

export interface UpdateClosedLeadEmailAutomationVariables {
  emailAutomation: UpdateClosedLeadEmailAutomationInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateClosedLeadSlackMessage
// ====================================================

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_stages_addTagAutomationTags[];
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config = UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions_config;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_leadDistributionAutomation_conditions[];
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage {
  __typename: "UpdateClosedLeadSlackMessagePayload";
  /**
   * The updated stageset this new closed lead slack message will be a part of.
   */
  stageset: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage_stageset;
}

export interface UpdateClosedLeadSlackMessage {
  /**
   * Updates a Closed Lead Slack message
   */
  updateClosedLeadSlackMessage: UpdateClosedLeadSlackMessage_updateClosedLeadSlackMessage;
}

export interface UpdateClosedLeadSlackMessageVariables {
  closedLeadSlackMessage: UpdateClosedLeadSlackMessageInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateClosedLeadTaskTemplate
// ====================================================

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_stages_addTagAutomationTags[];
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config = UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions_config;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_leadDistributionAutomation_conditions[];
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate {
  __typename: "UpdateClosedLeadTaskTemplatePayload";
  /**
   * The stageset of the newly created task template
   */
  stageset: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate_stageset;
}

export interface UpdateClosedLeadTaskTemplate {
  /**
   * Update a task template for closed lead.
   */
  updateClosedLeadTaskTemplate: UpdateClosedLeadTaskTemplate_updateClosedLeadTaskTemplate | null;
}

export interface UpdateClosedLeadTaskTemplateVariables {
  taskTemplate: UpdateClosedLeadTaskTemplateInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateDefaultStagesetForOnboardingWizard
// ====================================================

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_stages_addTagAutomationTags[];
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_leadDistributionAutomation_conditions_config = UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_leadDistributionAutomation_conditions_config;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_leadDistributionAutomation_conditions[];
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard {
  __typename: "UpdateDefaultStagesetForOnboardingWizardPayload";
  /**
   * The newly updated Nutshell stageset.
   */
  stageset: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard_stageset;
}

export interface UpdateDefaultStagesetForOnboardingWizard {
  /**
   * Updates the default stageset in response to the onboarding wizard responses.
   */
  updateDefaultStagesetForOnboardingWizard: UpdateDefaultStagesetForOnboardingWizard_updateDefaultStagesetForOnboardingWizard | null;
}

export interface UpdateDefaultStagesetForOnboardingWizardVariables {
  optionSelections: UpdateDefaultStagesetForOnboardingWizardInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateEmailAutomation
// ====================================================

export interface UpdateEmailAutomation_updateEmailAutomation_emailAutomation_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
}

export interface UpdateEmailAutomation_updateEmailAutomation_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateEmailAutomation_updateEmailAutomation_emailAutomation_exitsStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateEmailAutomation_updateEmailAutomation_emailAutomation_sendFromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateEmailAutomation_updateEmailAutomation_emailAutomation_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface UpdateEmailAutomation_updateEmailAutomation_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: UpdateEmailAutomation_updateEmailAutomation_emailAutomation_emailList | null;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: UpdateEmailAutomation_updateEmailAutomation_emailAutomation_entersStage;
  /**
   * The stage in which this stage subscription ends.
   */
  exitsStage: UpdateEmailAutomation_updateEmailAutomation_emailAutomation_exitsStage | null;
  /**
   * The user that automated email sequences should be sent from, or null if sent from the lead assignee
   */
  sendFromUser: UpdateEmailAutomation_updateEmailAutomation_emailAutomation_sendFromUser | null;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: UpdateEmailAutomation_updateEmailAutomation_emailAutomation_delay | null;
}

export interface UpdateEmailAutomation_updateEmailAutomation {
  __typename: "UpdateEmailAutomationPayload";
  /**
   * The newly updated MailChimp stage subscription
   */
  emailAutomation: UpdateEmailAutomation_updateEmailAutomation_emailAutomation;
}

export interface UpdateEmailAutomation {
  /**
   * Updates a MailChimp stage subscription.
   */
  updateEmailAutomation: UpdateEmailAutomation_updateEmailAutomation | null;
}

export interface UpdateEmailAutomationVariables {
  emailAutomation: UpdateEmailAutomationInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateGoal
// ====================================================

export interface UpdateGoal_updateGoal_goal_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface UpdateGoal_updateGoal_goal_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface UpdateGoal_updateGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface UpdateGoal_updateGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface UpdateGoal_updateGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface UpdateGoal_updateGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface UpdateGoal_updateGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface UpdateGoal_updateGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type UpdateGoal_updateGoal_goal_conditions_config_ConditionConfigEntityFilter_filter = UpdateGoal_updateGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | UpdateGoal_updateGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | UpdateGoal_updateGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | UpdateGoal_updateGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | UpdateGoal_updateGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | UpdateGoal_updateGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface UpdateGoal_updateGoal_goal_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: UpdateGoal_updateGoal_goal_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface UpdateGoal_updateGoal_goal_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type UpdateGoal_updateGoal_goal_conditions_config = UpdateGoal_updateGoal_goal_conditions_config_ConditionConfigAudience | UpdateGoal_updateGoal_goal_conditions_config_ConditionConfigEntityFilter | UpdateGoal_updateGoal_goal_conditions_config_ConditionConfigLink;

export interface UpdateGoal_updateGoal_goal_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: UpdateGoal_updateGoal_goal_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface UpdateGoal_updateGoal_goal {
  __typename: "Goal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of goal. This is strictly used for UI purposes, and is inferred from the goal’s conditions
   */
  goalType: GoalType;
  /**
   * The associated stage for this goal.
   */
  stage: UpdateGoal_updateGoal_goal_stage;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this goal. This is essentially just the stringified
   * version of the goal’s conditions, but because a goal can have multiple
   * conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * A list of conditions which must be true to activate this goal.
   */
  conditions: UpdateGoal_updateGoal_goal_conditions[];
}

export interface UpdateGoal_updateGoal {
  __typename: "UpdateGoalPayload";
  /**
   * The newly updated Nutshell goal
   */
  goal: UpdateGoal_updateGoal_goal;
}

export interface UpdateGoal {
  /**
   * Updates a sales process goal with the given goal id.
   */
  updateGoal: UpdateGoal_updateGoal;
}

export interface UpdateGoalVariables {
  goal: UpdateGoalInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateLeadDistributionAutomation
// ====================================================

export interface UpdateLeadDistributionAutomation_updateLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface UpdateLeadDistributionAutomation_updateLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface UpdateLeadDistributionAutomation_updateLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface UpdateLeadDistributionAutomation_updateLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface UpdateLeadDistributionAutomation_updateLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type UpdateLeadDistributionAutomation_updateLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = UpdateLeadDistributionAutomation_updateLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | UpdateLeadDistributionAutomation_updateLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | UpdateLeadDistributionAutomation_updateLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | UpdateLeadDistributionAutomation_updateLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface UpdateLeadDistributionAutomation_updateLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: UpdateLeadDistributionAutomation_updateLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface UpdateLeadDistributionAutomation_updateLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type UpdateLeadDistributionAutomation_updateLeadDistributionAutomation_leadDistributionAutomation_conditions_config = UpdateLeadDistributionAutomation_updateLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigAudience | UpdateLeadDistributionAutomation_updateLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | UpdateLeadDistributionAutomation_updateLeadDistributionAutomation_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface UpdateLeadDistributionAutomation_updateLeadDistributionAutomation_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: UpdateLeadDistributionAutomation_updateLeadDistributionAutomation_leadDistributionAutomation_conditions_config;
}

export interface UpdateLeadDistributionAutomation_updateLeadDistributionAutomation_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: UpdateLeadDistributionAutomation_updateLeadDistributionAutomation_leadDistributionAutomation_conditions[];
}

export interface UpdateLeadDistributionAutomation_updateLeadDistributionAutomation {
  __typename: "UpdateLeadDistributionAutomationPayload";
  /**
   * The newly updated Nutshell lead distribution automation
   */
  leadDistributionAutomation: UpdateLeadDistributionAutomation_updateLeadDistributionAutomation_leadDistributionAutomation;
}

export interface UpdateLeadDistributionAutomation {
  /**
   * Updates a lead distribution automation
   */
  updateLeadDistributionAutomation: UpdateLeadDistributionAutomation_updateLeadDistributionAutomation;
}

export interface UpdateLeadDistributionAutomationVariables {
  leadDistributionAutomation: UpdateLeadDistributionAutomationInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateOpenLeadSlackMessage
// ====================================================

export interface UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter = UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions_config = UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigAudience | UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter | UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigLink;

export interface UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage {
  __typename: "SlackMessageAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to activate this slack message automation.
   */
  conditions: UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage_slackChannel | null;
}

export interface UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage {
  __typename: "UpdateOpenLeadSlackMessagePayload";
  /**
   * The updated slack automation.
   */
  openLeadSlackMessage: UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage_openLeadSlackMessage;
}

export interface UpdateOpenLeadSlackMessage {
  /**
   * Updates a Slack automation
   */
  updateOpenLeadSlackMessage: UpdateOpenLeadSlackMessage_updateOpenLeadSlackMessage;
}

export interface UpdateOpenLeadSlackMessageVariables {
  openLeadSlackMessage: UpdateOpenLeadSlackMessageInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateStagesetVisibility
// ====================================================

export interface UpdateStagesetVisibility_updateStagesetVisibility_stageset_allowedViewers_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
}

export interface UpdateStagesetVisibility_updateStagesetVisibility_stageset_allowedViewers_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The number of users affiliated with this team
   */
  numUsers: number;
}

export type UpdateStagesetVisibility_updateStagesetVisibility_stageset_allowedViewers = UpdateStagesetVisibility_updateStagesetVisibility_stageset_allowedViewers_User | UpdateStagesetVisibility_updateStagesetVisibility_stageset_allowedViewers_Team;

export interface UpdateStagesetVisibility_updateStagesetVisibility_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Who is allowed to view this stageset, its leads, and their contacts/accounts.
   */
  visibilityMode: StagesetVisibilityMode;
  /**
   * The number of enabled users who can view this stageset when visibilityMode is
   * RESTRICTED. Includes administrators. Returns null otherwise. Admin-only; null
   * for non-admins.
   */
  restrictedCanViewCount: number | null;
  /**
   * The users and teams allowed to view this stageset when visibilityMode is
   * RESTRICTED. Administrators always have access and are never included here.
   * Admin-only; empty for non-admins.
   */
  allowedViewers: UpdateStagesetVisibility_updateStagesetVisibility_stageset_allowedViewers[];
}

export interface UpdateStagesetVisibility_updateStagesetVisibility {
  __typename: "UpdateStagesetVisibilityPayload";
  /**
   * The updated Nutshell stageset.
   */
  stageset: UpdateStagesetVisibility_updateStagesetVisibility_stageset;
}

export interface UpdateStagesetVisibility {
  /**
   * Updates a Nutshell Stageset's visibility mode and allowed viewers.
   */
  updateStagesetVisibility: UpdateStagesetVisibility_updateStagesetVisibility;
}

export interface UpdateStagesetVisibilityVariables {
  input: UpdateStagesetVisibilityInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateStageset
// ====================================================

export interface UpdateStageset_updateStageset_stageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateStageset_updateStageset_stageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface UpdateStageset_updateStageset_stageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface UpdateStageset_updateStageset_stageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateStageset_updateStageset_stageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface UpdateStageset_updateStageset_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: UpdateStageset_updateStageset_stageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: UpdateStageset_updateStageset_stageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: UpdateStageset_updateStageset_stageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: UpdateStageset_updateStageset_stageset_stages_addTagAutomationTags[];
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface UpdateStageset_updateStageset_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: UpdateStageset_updateStageset_stageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface UpdateStageset_updateStageset_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface UpdateStageset_updateStageset_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface UpdateStageset_updateStageset_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface UpdateStageset_updateStageset_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface UpdateStageset_updateStageset_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type UpdateStageset_updateStageset_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = UpdateStageset_updateStageset_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | UpdateStageset_updateStageset_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | UpdateStageset_updateStageset_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | UpdateStageset_updateStageset_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface UpdateStageset_updateStageset_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: UpdateStageset_updateStageset_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface UpdateStageset_updateStageset_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type UpdateStageset_updateStageset_stageset_leadDistributionAutomation_conditions_config = UpdateStageset_updateStageset_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | UpdateStageset_updateStageset_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | UpdateStageset_updateStageset_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface UpdateStageset_updateStageset_stageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: UpdateStageset_updateStageset_stageset_leadDistributionAutomation_conditions_config;
}

export interface UpdateStageset_updateStageset_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: UpdateStageset_updateStageset_stageset_leadDistributionAutomation_conditions[];
}

export interface UpdateStageset_updateStageset_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: UpdateStageset_updateStageset_stageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: UpdateStageset_updateStageset_stageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: UpdateStageset_updateStageset_stageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: UpdateStageset_updateStageset_stageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface UpdateStageset_updateStageset {
  __typename: "UpdateStagesetPayload";
  /**
   * The updated Nutshell stageset.
   */
  stageset: UpdateStageset_updateStageset_stageset;
}

export interface UpdateStageset {
  /**
   * Updates a Nutshell Stageset.
   */
  updateStageset: UpdateStageset_updateStageset | null;
}

export interface UpdateStagesetVariables {
  stageset: UpdateStagesetInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateStepTemplate
// ====================================================

export interface UpdateStepTemplate_updateStepTemplate_stepTemplate_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateStepTemplate_updateStepTemplate_stepTemplate_dueDate {
  __typename: "StepDueDate";
  /**
   * The reference point for this due date. This can include when the lead was created, when the stage was entered, etc.
   */
  dueFrom: number;
  /**
   * The unit to measure this step template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this step template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface UpdateStepTemplate_updateStepTemplate_stepTemplate_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface UpdateStepTemplate_updateStepTemplate_stepTemplate_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type UpdateStepTemplate_updateStepTemplate_stepTemplate_assignee = UpdateStepTemplate_updateStepTemplate_stepTemplate_assignee_Team | UpdateStepTemplate_updateStepTemplate_stepTemplate_assignee_User;

export interface UpdateStepTemplate_updateStepTemplate_stepTemplate {
  __typename: "StepTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The name of the Nutshell StepTemplate.
   */
  name: string;
  /**
   * The description of the Nutshell StepTemplate.
   */
  description: string | null;
  /**
   * The stage/milestone within the pipeline that this step template lives within for our sales automation tool
   */
  stage: UpdateStepTemplate_updateStepTemplate_stepTemplate_stage;
  /**
   * The rules to determine the due date for this step.
   */
  dueDate: UpdateStepTemplate_updateStepTemplate_stepTemplate_dueDate | null;
  /**
   * The description of the Nutshell StepTemplate.
   */
  assignee: UpdateStepTemplate_updateStepTemplate_stepTemplate_assignee | null;
}

export interface UpdateStepTemplate_updateStepTemplate {
  __typename: "UpdateStepTemplatePayload";
  /**
   * The newly updated Nutshell step template
   */
  stepTemplate: UpdateStepTemplate_updateStepTemplate_stepTemplate;
}

export interface UpdateStepTemplate {
  /**
   * Updates a sales process step template.
   */
  updateStepTemplate: UpdateStepTemplate_updateStepTemplate | null;
}

export interface UpdateStepTemplateVariables {
  stepTemplate: UpdateStepTemplateInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateTextAutomation
// ====================================================

export interface UpdateTextAutomation_textAutomationUpdate_textAutomation_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface UpdateTextAutomation_textAutomationUpdate_textAutomation_sendFromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  initials: string;
  avatarUrl: string;
  name: string;
}

export interface UpdateTextAutomation_textAutomationUpdate_textAutomation_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface UpdateTextAutomation_textAutomationUpdate_textAutomation {
  __typename: "TextMessageAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Content of the text body.
   */
  content: string;
  position: number;
  /**
   * The associated stage for this text.
   */
  stage: UpdateTextAutomation_textAutomationUpdate_textAutomation_stage;
  /**
   * The user to assign the thread to and send messages from.
   */
  sendFromUser: UpdateTextAutomation_textAutomationUpdate_textAutomation_sendFromUser | null;
  /**
   * How long to wait before sending the text.
   */
  delay: UpdateTextAutomation_textAutomationUpdate_textAutomation_delay;
}

export interface UpdateTextAutomation_textAutomationUpdate {
  __typename: "TextAutomationUpdatePayload";
  /**
   * The updated automation.
   */
  textAutomation: UpdateTextAutomation_textAutomationUpdate_textAutomation;
}

export interface UpdateTextAutomation {
  /**
   * Updates a Text automation
   */
  textAutomationUpdate: UpdateTextAutomation_textAutomationUpdate;
}

export interface UpdateTextAutomationVariables {
  textAutomation: TextAutomationUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountAssignmentAutomation
// ====================================================

export interface GetAccountAssignmentAutomation_accountTypeAutomation_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface GetAccountAssignmentAutomation_accountTypeAutomation {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: GetAccountAssignmentAutomation_accountTypeAutomation_accountType;
}

export interface GetAccountAssignmentAutomation {
  /**
   * Returns a Nutshell account type automation
   */
  accountTypeAutomation: GetAccountAssignmentAutomation_accountTypeAutomation | null;
}

export interface GetAccountAssignmentAutomationVariables {
  automationId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetClosedLeadEmailAutomation
// ====================================================

export interface GetClosedLeadEmailAutomation_closedLeadEmailAutomation_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface GetClosedLeadEmailAutomation_closedLeadEmailAutomation {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: GetClosedLeadEmailAutomation_closedLeadEmailAutomation_emailList | null;
}

export interface GetClosedLeadEmailAutomation {
  /**
   * Returns an email automation for closed lead
   */
  closedLeadEmailAutomation: GetClosedLeadEmailAutomation_closedLeadEmailAutomation | null;
}

export interface GetClosedLeadEmailAutomationVariables {
  emailAutomationId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetClosedLeadSlackMessage
// ====================================================

export interface GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter = GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions_config = GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions_config_ConditionConfigAudience | GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter | GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions_config_ConditionConfigLink;

export interface GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface GetClosedLeadSlackMessage_closedLeadSlackMessage_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface GetClosedLeadSlackMessage_closedLeadSlackMessage {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: GetClosedLeadSlackMessage_closedLeadSlackMessage_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: GetClosedLeadSlackMessage_closedLeadSlackMessage_slackChannel | null;
}

export interface GetClosedLeadSlackMessage {
  /**
   * Returns a slack automation for closed leads
   */
  closedLeadSlackMessage: GetClosedLeadSlackMessage_closedLeadSlackMessage;
}

export interface GetClosedLeadSlackMessageVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetClosedLeadTaskTemplate
// ====================================================

export interface GetClosedLeadTaskTemplate_closedLeadTaskTemplate_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface GetClosedLeadTaskTemplate_closedLeadTaskTemplate_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface GetClosedLeadTaskTemplate_closedLeadTaskTemplate_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type GetClosedLeadTaskTemplate_closedLeadTaskTemplate_assignee = GetClosedLeadTaskTemplate_closedLeadTaskTemplate_assignee_Team | GetClosedLeadTaskTemplate_closedLeadTaskTemplate_assignee_User;

export interface GetClosedLeadTaskTemplate_closedLeadTaskTemplate {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: GetClosedLeadTaskTemplate_closedLeadTaskTemplate_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: GetClosedLeadTaskTemplate_closedLeadTaskTemplate_assignee | null;
}

export interface GetClosedLeadTaskTemplate {
  /**
   * Returns a Nutshell task template
   */
  closedLeadTaskTemplate: GetClosedLeadTaskTemplate_closedLeadTaskTemplate | null;
}

export interface GetClosedLeadTaskTemplateVariables {
  taskTemplateId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: DripSequenceStartTriggersForStageset
// ====================================================

export interface DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_campaign = DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_campaign_Campaign | DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink" | "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_conditions_config_ConditionConfigEntityFilter_filter = DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_conditions_config_ConditionConfigEntityFilter_filter;
}

export type DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_conditions_config = DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_conditions_config_ConditionConfigLink | DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_conditions_config_ConditionConfigEntityFilter;

export interface DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_conditions {
  __typename: "Condition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The configuration for this condition.
   */
  config: DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_conditions_config;
}

export interface DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_campaign;
  /**
   * The type of startTrigger
   */
  type: StartTriggerType;
  /**
   * A list of conditions which must be true to activate this startTrigger.
   */
  conditions: DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers_conditions[];
}

export interface DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers[];
}

export interface DripSequenceStartTriggersForStageset_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate;
}

export interface DripSequenceStartTriggersForStageset {
  /**
   * Returns a Nutshell Stageset
   */
  stageset: DripSequenceStartTriggersForStageset_stageset | null;
}

export interface DripSequenceStartTriggersForStagesetVariables {
  stagesetId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEmailAutomation
// ====================================================

export interface GetEmailAutomation_emailAutomation_emailList_MailChimpList {
  __typename: "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface GetEmailAutomation_emailAutomation_emailList_ConstantContactList {
  __typename: "ConstantContactList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface GetEmailAutomation_emailAutomation_emailList_EmailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEmailAutomation_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEmailAutomation_emailAutomation_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  creatorUser: GetEmailAutomation_emailAutomation_emailList_EmailSequenceTemplate_creatorUser;
  createdTime: any | null;
  emailSequenceTemplateMessages: GetEmailAutomation_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
  /**
   * The url pathname to the edit modal for the email template
   */
  htmlUrlPath: string;
  /**
   * Whether the template has custom placeholders
   */
  hasCustomPlaceholders: boolean;
}

export type GetEmailAutomation_emailAutomation_emailList = GetEmailAutomation_emailAutomation_emailList_MailChimpList | GetEmailAutomation_emailAutomation_emailList_ConstantContactList | GetEmailAutomation_emailAutomation_emailList_EmailSequenceTemplate;

export interface GetEmailAutomation_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
}

export interface GetEmailAutomation_emailAutomation_exitsStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetEmailAutomation_emailAutomation_sendFromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEmailAutomation_emailAutomation_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetEmailAutomation_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: GetEmailAutomation_emailAutomation_emailList | null;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: GetEmailAutomation_emailAutomation_entersStage;
  /**
   * The stage in which this stage subscription ends.
   */
  exitsStage: GetEmailAutomation_emailAutomation_exitsStage | null;
  /**
   * The user that automated email sequences should be sent from, or null if sent from the lead assignee
   */
  sendFromUser: GetEmailAutomation_emailAutomation_sendFromUser | null;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: GetEmailAutomation_emailAutomation_delay | null;
  /**
   * The unix timestamp of when this stage subscription was created
   */
  createdTime: any;
  /**
   * Number of stages a EmailAutomation spans. If a subscription has no exit stage,
   * we count the last stage in the stageset as the "exit stage" for this count.
   */
  numberOfStagesSpanned: number;
  /**
   * Indicates if a lead should receive emails from this subscription until it closes.
   */
  sendUntilClose: boolean;
}

export interface GetEmailAutomation {
  /**
   * Returns a single Nutshell email automation
   */
  emailAutomation: GetEmailAutomation_emailAutomation;
}

export interface GetEmailAutomationVariables {
  emailAutomationId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: EmailsForStagesetQuery
// ====================================================

export interface EmailsForStagesetQuery_stageset_editableProcessTemplate_emailAutomations_emailList_MailChimpList {
  __typename: "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface EmailsForStagesetQuery_stageset_editableProcessTemplate_emailAutomations_emailList_ConstantContactList {
  __typename: "ConstantContactList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface EmailsForStagesetQuery_stageset_editableProcessTemplate_emailAutomations_emailList_EmailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EmailsForStagesetQuery_stageset_editableProcessTemplate_emailAutomations_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailsForStagesetQuery_stageset_editableProcessTemplate_emailAutomations_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  creatorUser: EmailsForStagesetQuery_stageset_editableProcessTemplate_emailAutomations_emailList_EmailSequenceTemplate_creatorUser;
  createdTime: any | null;
  emailSequenceTemplateMessages: EmailsForStagesetQuery_stageset_editableProcessTemplate_emailAutomations_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
  /**
   * The url pathname to the edit modal for the email template
   */
  htmlUrlPath: string;
  /**
   * Whether the template has custom placeholders
   */
  hasCustomPlaceholders: boolean;
}

export type EmailsForStagesetQuery_stageset_editableProcessTemplate_emailAutomations_emailList = EmailsForStagesetQuery_stageset_editableProcessTemplate_emailAutomations_emailList_MailChimpList | EmailsForStagesetQuery_stageset_editableProcessTemplate_emailAutomations_emailList_ConstantContactList | EmailsForStagesetQuery_stageset_editableProcessTemplate_emailAutomations_emailList_EmailSequenceTemplate;

export interface EmailsForStagesetQuery_stageset_editableProcessTemplate_emailAutomations_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
}

export interface EmailsForStagesetQuery_stageset_editableProcessTemplate_emailAutomations_exitsStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface EmailsForStagesetQuery_stageset_editableProcessTemplate_emailAutomations_sendFromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EmailsForStagesetQuery_stageset_editableProcessTemplate_emailAutomations_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface EmailsForStagesetQuery_stageset_editableProcessTemplate_emailAutomations {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: EmailsForStagesetQuery_stageset_editableProcessTemplate_emailAutomations_emailList | null;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: EmailsForStagesetQuery_stageset_editableProcessTemplate_emailAutomations_entersStage;
  /**
   * The stage in which this stage subscription ends.
   */
  exitsStage: EmailsForStagesetQuery_stageset_editableProcessTemplate_emailAutomations_exitsStage | null;
  /**
   * The user that automated email sequences should be sent from, or null if sent from the lead assignee
   */
  sendFromUser: EmailsForStagesetQuery_stageset_editableProcessTemplate_emailAutomations_sendFromUser | null;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: EmailsForStagesetQuery_stageset_editableProcessTemplate_emailAutomations_delay | null;
  /**
   * The unix timestamp of when this stage subscription was created
   */
  createdTime: any;
  /**
   * Number of stages a EmailAutomation spans. If a subscription has no exit stage,
   * we count the last stage in the stageset as the "exit stage" for this count.
   */
  numberOfStagesSpanned: number;
  /**
   * Indicates if a lead should receive emails from this subscription until it closes.
   */
  sendUntilClose: boolean;
}

export interface EmailsForStagesetQuery_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * Returns a list of Nutshell emails automations for a given process template
   */
  emailAutomations: EmailsForStagesetQuery_stageset_editableProcessTemplate_emailAutomations[];
}

export interface EmailsForStagesetQuery_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: EmailsForStagesetQuery_stageset_editableProcessTemplate;
}

export interface EmailsForStagesetQuery {
  /**
   * Returns a Nutshell Stageset
   */
  stageset: EmailsForStagesetQuery_stageset | null;
  /**
   * Whether there is a MailChimp Integration for an instance
   */
  hasMailChimpIntegration: boolean | null;
}

export interface EmailsForStagesetQueryVariables {
  stagesetId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetGoalFields
// ====================================================

export interface GetGoalFields_entityFields_FieldPhone {
  __typename: "FieldPhone" | "FieldString" | "FieldLocation" | "FieldBoolean" | "FieldCurrency" | "FieldDateTime" | "FieldInteger" | "FieldRelationship" | "FieldStrings" | "FieldText";
  /**
   * The internal name of the field
   */
  name: string;
  /**
   * The type of the field (string, date-time, etc)
   */
  type: EntityFieldType;
  /**
   * The filter title of the field
   */
  filterTitle: string;
}

export interface GetGoalFields_entityFields_FieldEnum {
  __typename: "FieldEnum";
  /**
   * The internal name of the field
   */
  name: string;
  /**
   * The type of the field (string, date-time, etc)
   */
  type: EntityFieldType;
  /**
   * The filter title of the field
   */
  filterTitle: string;
  /**
   * The possible options allowed for this enum type
   */
  options: string[];
}

export type GetGoalFields_entityFields = GetGoalFields_entityFields_FieldPhone | GetGoalFields_entityFields_FieldEnum;

export interface GetGoalFields {
  /**
   * List of custom fields for a particualr entity type
   */
  entityFields: GetGoalFields_entityFields[];
}

export interface GetGoalFieldsVariables {
  entityType: string;
  isGoalable?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetGoal
// ====================================================

export interface GetGoal_goal_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetGoal_goal_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface GetGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface GetGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface GetGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface GetGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface GetGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface GetGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type GetGoal_goal_conditions_config_ConditionConfigEntityFilter_filter = GetGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | GetGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | GetGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | GetGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | GetGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | GetGoal_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface GetGoal_goal_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: GetGoal_goal_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface GetGoal_goal_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type GetGoal_goal_conditions_config = GetGoal_goal_conditions_config_ConditionConfigAudience | GetGoal_goal_conditions_config_ConditionConfigEntityFilter | GetGoal_goal_conditions_config_ConditionConfigLink;

export interface GetGoal_goal_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: GetGoal_goal_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface GetGoal_goal {
  __typename: "Goal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of goal. This is strictly used for UI purposes, and is inferred from the goal’s conditions
   */
  goalType: GoalType;
  /**
   * The associated stage for this goal.
   */
  stage: GetGoal_goal_stage;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this goal. This is essentially just the stringified
   * version of the goal’s conditions, but because a goal can have multiple
   * conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * A list of conditions which must be true to activate this goal.
   */
  conditions: GetGoal_goal_conditions[];
}

export interface GetGoal {
  /**
   * Returns a the latest version of a single Nutshell Goal
   */
  goal: GetGoal_goal;
}

export interface GetGoalVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLeadDistribution
// ====================================================

export interface GetLeadDistribution_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface GetLeadDistribution_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface GetLeadDistribution_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface GetLeadDistribution_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface GetLeadDistribution_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type GetLeadDistribution_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = GetLeadDistribution_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | GetLeadDistribution_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | GetLeadDistribution_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | GetLeadDistribution_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface GetLeadDistribution_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: GetLeadDistribution_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface GetLeadDistribution_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type GetLeadDistribution_leadDistributionAutomation_conditions_config = GetLeadDistribution_leadDistributionAutomation_conditions_config_ConditionConfigAudience | GetLeadDistribution_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | GetLeadDistribution_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface GetLeadDistribution_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: GetLeadDistribution_leadDistributionAutomation_conditions_config;
}

export interface GetLeadDistribution_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: GetLeadDistribution_leadDistributionAutomation_conditions[];
}

export interface GetLeadDistribution {
  /**
   * Returns a lead distribution ruleset
   */
  leadDistributionAutomation: GetLeadDistribution_leadDistributionAutomation;
}

export interface GetLeadDistributionVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetOpenLeadSlackMessage
// ====================================================

export interface GetOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface GetOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface GetOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface GetOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface GetOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface GetOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface GetOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type GetOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter = GetOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | GetOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | GetOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | GetOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | GetOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | GetOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface GetOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: GetOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface GetOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type GetOpenLeadSlackMessage_openLeadSlackMessage_conditions_config = GetOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigAudience | GetOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigEntityFilter | GetOpenLeadSlackMessage_openLeadSlackMessage_conditions_config_ConditionConfigLink;

export interface GetOpenLeadSlackMessage_openLeadSlackMessage_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: GetOpenLeadSlackMessage_openLeadSlackMessage_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface GetOpenLeadSlackMessage_openLeadSlackMessage_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface GetOpenLeadSlackMessage_openLeadSlackMessage {
  __typename: "SlackMessageAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to activate this slack message automation.
   */
  conditions: GetOpenLeadSlackMessage_openLeadSlackMessage_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: GetOpenLeadSlackMessage_openLeadSlackMessage_slackChannel | null;
}

export interface GetOpenLeadSlackMessage {
  /**
   * Returns a slack automation for open leads
   */
  openLeadSlackMessage: GetOpenLeadSlackMessage_openLeadSlackMessage;
}

export interface GetOpenLeadSlackMessageVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSlackMessagesForStage
// ====================================================

export interface GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter = GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions_config = GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions_config_ConditionConfigAudience | GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter | GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions_config_ConditionConfigLink;

export interface GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface GetSlackMessagesForStage_stage_editableSlackMessageAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface GetSlackMessagesForStage_stage_editableSlackMessageAutomations {
  __typename: "SlackMessageAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to activate this slack message automation.
   */
  conditions: GetSlackMessagesForStage_stage_editableSlackMessageAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: GetSlackMessagesForStage_stage_editableSlackMessageAutomations_slackChannel | null;
}

export interface GetSlackMessagesForStage_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The list of slack message automations attached to this stage.
   */
  editableSlackMessageAutomations: GetSlackMessagesForStage_stage_editableSlackMessageAutomations[];
}

export interface GetSlackMessagesForStage {
  /**
   * Returns a Nutshell Stage
   */
  stage: GetSlackMessagesForStage_stage | null;
}

export interface GetSlackMessagesForStageVariables {
  stageId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: StageGoalsForStage
// ====================================================

export interface StageGoalsForStage_editableGoals_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface StageGoalsForStage_editableGoals_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface StageGoalsForStage_editableGoals_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface StageGoalsForStage_editableGoals_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface StageGoalsForStage_editableGoals_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface StageGoalsForStage_editableGoals_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface StageGoalsForStage_editableGoals_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface StageGoalsForStage_editableGoals_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type StageGoalsForStage_editableGoals_conditions_config_ConditionConfigEntityFilter_filter = StageGoalsForStage_editableGoals_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | StageGoalsForStage_editableGoals_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | StageGoalsForStage_editableGoals_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | StageGoalsForStage_editableGoals_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | StageGoalsForStage_editableGoals_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | StageGoalsForStage_editableGoals_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface StageGoalsForStage_editableGoals_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: StageGoalsForStage_editableGoals_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface StageGoalsForStage_editableGoals_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type StageGoalsForStage_editableGoals_conditions_config = StageGoalsForStage_editableGoals_conditions_config_ConditionConfigAudience | StageGoalsForStage_editableGoals_conditions_config_ConditionConfigEntityFilter | StageGoalsForStage_editableGoals_conditions_config_ConditionConfigLink;

export interface StageGoalsForStage_editableGoals_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: StageGoalsForStage_editableGoals_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface StageGoalsForStage_editableGoals {
  __typename: "Goal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of goal. This is strictly used for UI purposes, and is inferred from the goal’s conditions
   */
  goalType: GoalType;
  /**
   * The associated stage for this goal.
   */
  stage: StageGoalsForStage_editableGoals_stage;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this goal. This is essentially just the stringified
   * version of the goal’s conditions, but because a goal can have multiple
   * conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * A list of conditions which must be true to activate this goal.
   */
  conditions: StageGoalsForStage_editableGoals_conditions[];
}

export interface StageGoalsForStage {
  /**
   * Returns a list of Nutshell goals for a given stage
   */
  editableGoals: StageGoalsForStage_editableGoals[];
}

export interface StageGoalsForStageVariables {
  stageId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: StagesetAndStages
// ====================================================

export interface StagesetAndStages_stageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface StagesetAndStages_stageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface StagesetAndStages_stageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface StagesetAndStages_stageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface StagesetAndStages_stageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface StagesetAndStages_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: StagesetAndStages_stageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: StagesetAndStages_stageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: StagesetAndStages_stageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: StagesetAndStages_stageset_stages_addTagAutomationTags[];
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface StagesetAndStages_stageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: StagesetAndStages_stageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface StagesetAndStages_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface StagesetAndStages_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface StagesetAndStages_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface StagesetAndStages_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface StagesetAndStages_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type StagesetAndStages_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = StagesetAndStages_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | StagesetAndStages_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | StagesetAndStages_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | StagesetAndStages_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface StagesetAndStages_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: StagesetAndStages_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface StagesetAndStages_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type StagesetAndStages_stageset_leadDistributionAutomation_conditions_config = StagesetAndStages_stageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | StagesetAndStages_stageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | StagesetAndStages_stageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface StagesetAndStages_stageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: StagesetAndStages_stageset_leadDistributionAutomation_conditions_config;
}

export interface StagesetAndStages_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: StagesetAndStages_stageset_leadDistributionAutomation_conditions[];
}

export interface StagesetAndStages_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: StagesetAndStages_stageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: StagesetAndStages_stageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: StagesetAndStages_stageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: StagesetAndStages_stageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface StagesetAndStages {
  /**
   * Returns a Nutshell Stageset
   */
  stageset: StagesetAndStages_stageset | null;
  /**
   * Whether there is a MailChimp Integration for an instance
   */
  hasMailChimpIntegration: boolean | null;
  /**
   * Whether there is a Constant Contact Integration for an instance
   */
  hasConstantContactIntegration: boolean | null;
  /**
   * Whether there is a Slack Integration for an instance
   */
  hasSlackIntegration: boolean | null;
}

export interface StagesetAndStagesVariables {
  stagesetId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: StagesetBasicInfo
// ====================================================

export interface StagesetBasicInfo_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
}

export interface StagesetBasicInfo_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface StagesetBasicInfo_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * Can this pipeline be accessed? If a customer downgrades, non-default pipelines may become inaccessible
   */
  canAccess: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The stages associated with this stageset
   */
  stages: StagesetBasicInfo_stageset_stages[];
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: StagesetBasicInfo_stageset_leadDistributionAutomation | null;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
  /**
   * Who is allowed to view this stageset, its leads, and their contacts/accounts.
   */
  visibilityMode: StagesetVisibilityMode;
  /**
   * The number of enabled users who can view this stageset when visibilityMode is
   * RESTRICTED. Includes administrators. Returns null otherwise. Admin-only; null
   * for non-admins.
   */
  restrictedCanViewCount: number | null;
}

export interface StagesetBasicInfo {
  /**
   * Returns a Nutshell Stageset
   */
  stageset: StagesetBasicInfo_stageset | null;
}

export interface StagesetBasicInfoVariables {
  stagesetId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetStagesetStarters
// ====================================================

export interface GetStagesetStarters_stagesetStarters_previewData_stages_goal {
  __typename: "StagesetStarterPreviewStageGoal";
  type: GoalType;
  label: string;
}

export interface GetStagesetStarters_stagesetStarters_previewData_stages_tasks {
  __typename: "StagesetStarterPreviewTaskTemplate";
  name: string;
}

export interface GetStagesetStarters_stagesetStarters_previewData_stages {
  __typename: "StagesetStarterPreviewStage";
  name: string;
  goal: GetStagesetStarters_stagesetStarters_previewData_stages_goal | null;
  tasks: GetStagesetStarters_stagesetStarters_previewData_stages_tasks[];
}

export interface GetStagesetStarters_stagesetStarters_previewData_dripSequence_emails {
  __typename: "StagesetStarterPreviewDripEmail";
  name: string;
  /**
   * Human-readable summary of when this drip edition sends relative to the sequence.
   */
  sendDescription: string;
}

export interface GetStagesetStarters_stagesetStarters_previewData_dripSequence {
  __typename: "StagesetStarterPreviewDripSequence";
  name: string;
  status: StagesetStarterPreviewDripSequenceStatus;
  emails: GetStagesetStarters_stagesetStarters_previewData_dripSequence_emails[];
}

export interface GetStagesetStarters_stagesetStarters_previewData {
  __typename: "StagesetStarterPreviewData";
  stages: GetStagesetStarters_stagesetStarters_previewData_stages[];
  dripSequence: GetStagesetStarters_stagesetStarters_previewData_dripSequence;
}

export interface GetStagesetStarters_stagesetStarters {
  __typename: "StagesetStarter";
  /**
   * The type of the Nutshell Stageset template.
   */
  type: StagesetStarterType;
  /**
   * The human name of the Nutshell Stageset template.
   */
  name: string;
  /**
   * The description of the Nutshell Stageset template.
   */
  description: string;
  /**
   * The category of the Nutshell Stageset template.
   */
  category: StagesetStarterCategory;
  previewData: GetStagesetStarters_stagesetStarters_previewData;
}

export interface GetStagesetStarters {
  /**
   * A list of Nutshell Stageset templates
   */
  stagesetStarters: GetStagesetStarters_stagesetStarters[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: StagesetVisibilityInfo
// ====================================================

export interface StagesetVisibilityInfo_stageset_allowedViewers_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
}

export interface StagesetVisibilityInfo_stageset_allowedViewers_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The number of users affiliated with this team
   */
  numUsers: number;
}

export type StagesetVisibilityInfo_stageset_allowedViewers = StagesetVisibilityInfo_stageset_allowedViewers_User | StagesetVisibilityInfo_stageset_allowedViewers_Team;

export interface StagesetVisibilityInfo_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Who is allowed to view this stageset, its leads, and their contacts/accounts.
   */
  visibilityMode: StagesetVisibilityMode;
  /**
   * The number of enabled users who can view this stageset when visibilityMode is
   * RESTRICTED. Includes administrators. Returns null otherwise. Admin-only; null
   * for non-admins.
   */
  restrictedCanViewCount: number | null;
  /**
   * The users and teams allowed to view this stageset when visibilityMode is
   * RESTRICTED. Administrators always have access and are never included here.
   * Admin-only; empty for non-admins.
   */
  allowedViewers: StagesetVisibilityInfo_stageset_allowedViewers[];
}

export interface StagesetVisibilityInfo {
  /**
   * Returns a Nutshell Stageset
   */
  stageset: StagesetVisibilityInfo_stageset | null;
}

export interface StagesetVisibilityInfoVariables {
  stagesetId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: StagesetsForPipelineList
// ====================================================

export interface StagesetsForPipelineList_stagesets_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
}

export interface StagesetsForPipelineList_stagesets_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface StagesetsForPipelineList_stagesets {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * Can this pipeline be accessed? If a customer downgrades, non-default pipelines may become inaccessible
   */
  canAccess: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The stages associated with this stageset
   */
  stages: StagesetsForPipelineList_stagesets_stages[];
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: StagesetsForPipelineList_stagesets_leadDistributionAutomation | null;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
  /**
   * Who is allowed to view this stageset, its leads, and their contacts/accounts.
   */
  visibilityMode: StagesetVisibilityMode;
  /**
   * The number of enabled users who can view this stageset when visibilityMode is
   * RESTRICTED. Includes administrators. Returns null otherwise. Admin-only; null
   * for non-admins.
   */
  restrictedCanViewCount: number | null;
}

export interface StagesetsForPipelineList {
  /**
   * Returns a list of Nutshell Stagesets
   */
  stagesets: StagesetsForPipelineList_stagesets[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetStagesetsUnarchived
// ====================================================

export interface GetStagesetsUnarchived_stagesets_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
}

export interface GetStagesetsUnarchived_stagesets_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetStagesetsUnarchived_stagesets {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * Can this pipeline be accessed? If a customer downgrades, non-default pipelines may become inaccessible
   */
  canAccess: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The stages associated with this stageset
   */
  stages: GetStagesetsUnarchived_stagesets_stages[];
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: GetStagesetsUnarchived_stagesets_leadDistributionAutomation | null;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
  /**
   * Who is allowed to view this stageset, its leads, and their contacts/accounts.
   */
  visibilityMode: StagesetVisibilityMode;
  /**
   * The number of enabled users who can view this stageset when visibilityMode is
   * RESTRICTED. Includes administrators. Returns null otherwise. Admin-only; null
   * for non-admins.
   */
  restrictedCanViewCount: number | null;
}

export interface GetStagesetsUnarchived {
  /**
   * Returns a list of Nutshell Stagesets
   */
  stagesets: GetStagesetsUnarchived_stagesets[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: Stagesets
// ====================================================

export interface Stagesets_stagesets_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface Stagesets_stagesets_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface Stagesets_stagesets_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface Stagesets_stagesets_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface Stagesets_stagesets_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface Stagesets_stagesets_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: Stagesets_stagesets_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: Stagesets_stagesets_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: Stagesets_stagesets_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: Stagesets_stagesets_stages_addTagAutomationTags[];
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface Stagesets_stagesets_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: Stagesets_stagesets_editableProcessTemplate_closedLeadAutomations[];
}

export interface Stagesets_stagesets_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface Stagesets_stagesets_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface Stagesets_stagesets_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface Stagesets_stagesets_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface Stagesets_stagesets_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type Stagesets_stagesets_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = Stagesets_stagesets_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | Stagesets_stagesets_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | Stagesets_stagesets_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | Stagesets_stagesets_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface Stagesets_stagesets_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: Stagesets_stagesets_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface Stagesets_stagesets_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type Stagesets_stagesets_leadDistributionAutomation_conditions_config = Stagesets_stagesets_leadDistributionAutomation_conditions_config_ConditionConfigAudience | Stagesets_stagesets_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | Stagesets_stagesets_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface Stagesets_stagesets_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: Stagesets_stagesets_leadDistributionAutomation_conditions_config;
}

export interface Stagesets_stagesets_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: Stagesets_stagesets_leadDistributionAutomation_conditions[];
}

export interface Stagesets_stagesets {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: Stagesets_stagesets_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: Stagesets_stagesets_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: Stagesets_stagesets_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: Stagesets_stagesets_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

export interface Stagesets {
  /**
   * Returns a list of Nutshell Stagesets
   */
  stagesets: Stagesets_stagesets[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetStepTemplate
// ====================================================

export interface GetStepTemplate_stepTemplate_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetStepTemplate_stepTemplate_dueDate {
  __typename: "StepDueDate";
  /**
   * The reference point for this due date. This can include when the lead was created, when the stage was entered, etc.
   */
  dueFrom: number;
  /**
   * The unit to measure this step template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this step template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface GetStepTemplate_stepTemplate_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface GetStepTemplate_stepTemplate_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type GetStepTemplate_stepTemplate_assignee = GetStepTemplate_stepTemplate_assignee_Team | GetStepTemplate_stepTemplate_assignee_User;

export interface GetStepTemplate_stepTemplate {
  __typename: "StepTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The name of the Nutshell StepTemplate.
   */
  name: string;
  /**
   * The description of the Nutshell StepTemplate.
   */
  description: string | null;
  /**
   * The stage/milestone within the pipeline that this step template lives within for our sales automation tool
   */
  stage: GetStepTemplate_stepTemplate_stage;
  /**
   * The rules to determine the due date for this step.
   */
  dueDate: GetStepTemplate_stepTemplate_dueDate | null;
  /**
   * The description of the Nutshell StepTemplate.
   */
  assignee: GetStepTemplate_stepTemplate_assignee | null;
}

export interface GetStepTemplate {
  /**
   * Returns the latest version of a Nutshell step template looked up by id
   */
  stepTemplate: GetStepTemplate_stepTemplate | null;
}

export interface GetStepTemplateVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: StepTemplatesForStageQuery
// ====================================================

export interface StepTemplatesForStageQuery_editableStepTemplates_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface StepTemplatesForStageQuery_editableStepTemplates_dueDate {
  __typename: "StepDueDate";
  /**
   * The reference point for this due date. This can include when the lead was created, when the stage was entered, etc.
   */
  dueFrom: number;
  /**
   * The unit to measure this step template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this step template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface StepTemplatesForStageQuery_editableStepTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface StepTemplatesForStageQuery_editableStepTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type StepTemplatesForStageQuery_editableStepTemplates_assignee = StepTemplatesForStageQuery_editableStepTemplates_assignee_Team | StepTemplatesForStageQuery_editableStepTemplates_assignee_User;

export interface StepTemplatesForStageQuery_editableStepTemplates {
  __typename: "StepTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The name of the Nutshell StepTemplate.
   */
  name: string;
  /**
   * The description of the Nutshell StepTemplate.
   */
  description: string | null;
  /**
   * The stage/milestone within the pipeline that this step template lives within for our sales automation tool
   */
  stage: StepTemplatesForStageQuery_editableStepTemplates_stage;
  /**
   * The rules to determine the due date for this step.
   */
  dueDate: StepTemplatesForStageQuery_editableStepTemplates_dueDate | null;
  /**
   * The description of the Nutshell StepTemplate.
   */
  assignee: StepTemplatesForStageQuery_editableStepTemplates_assignee | null;
}

export interface StepTemplatesForStageQuery {
  /**
   * Returns a list of Nuthsell step templates
   */
  editableStepTemplates: StepTemplatesForStageQuery_editableStepTemplates[];
}

export interface StepTemplatesForStageQueryVariables {
  stageId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTextAutomation
// ====================================================

export interface GetTextAutomation_textAutomation_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetTextAutomation_textAutomation_sendFromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  initials: string;
  avatarUrl: string;
  name: string;
}

export interface GetTextAutomation_textAutomation_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetTextAutomation_textAutomation {
  __typename: "TextMessageAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Content of the text body.
   */
  content: string;
  position: number;
  /**
   * The associated stage for this text.
   */
  stage: GetTextAutomation_textAutomation_stage;
  /**
   * The user to assign the thread to and send messages from.
   */
  sendFromUser: GetTextAutomation_textAutomation_sendFromUser | null;
  /**
   * How long to wait before sending the text.
   */
  delay: GetTextAutomation_textAutomation_delay;
}

export interface GetTextAutomation {
  /**
   * Returns the text message automation.
   */
  textAutomation: GetTextAutomation_textAutomation;
}

export interface GetTextAutomationVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTextAutomationsByStage
// ====================================================

export interface GetTextAutomationsByStage_textAutomations_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetTextAutomationsByStage_textAutomations_sendFromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  initials: string;
  avatarUrl: string;
  name: string;
}

export interface GetTextAutomationsByStage_textAutomations_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetTextAutomationsByStage_textAutomations {
  __typename: "TextMessageAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Content of the text body.
   */
  content: string;
  position: number;
  /**
   * The associated stage for this text.
   */
  stage: GetTextAutomationsByStage_textAutomations_stage;
  /**
   * The user to assign the thread to and send messages from.
   */
  sendFromUser: GetTextAutomationsByStage_textAutomations_sendFromUser | null;
  /**
   * How long to wait before sending the text.
   */
  delay: GetTextAutomationsByStage_textAutomations_delay;
}

export interface GetTextAutomationsByStage {
  /**
   * Returns a list of text message automations.
   */
  textAutomations: GetTextAutomationsByStage_textAutomations[];
}

export interface GetTextAutomationsByStageVariables {
  stageId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserAssignmentsForStage
// ====================================================

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The DateTime that represents when the team record was deleted
   */
  deletedTime: any | null;
}

export type GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_assignee = GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_assignee_User | GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_assignee_Team;

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter = GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config = GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigAudience | GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter | GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigLink;

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate {
  __typename: "Predicate";
  /**
   * The conditions that must be true for this predicate to activate an automation.
   */
  conditions: GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions[];
}

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation {
  __typename: "StageLeadAssignmentAutomation";
  /**
   * Flag to determine if this automation should unassign the lead.
   */
  shouldUnassign: boolean;
  /**
   * If the assignee is a team, round robin will equally distribute leads to each member of the team.
   */
  shouldRoundRobin: boolean | null;
  /**
   * The assignee object for this lead assignment automation.
   */
  assignee: GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_assignee | null;
  /**
   * This automation's predicate.
   */
  predicate: GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate;
}

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The DateTime that represents when the team record was deleted
   */
  deletedTime: any | null;
}

export type GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_assignee = GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_assignee_User | GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_assignee_Team;

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter = GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config = GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigAudience | GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter | GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigLink;

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate {
  __typename: "Predicate";
  /**
   * The conditions that must be true for this predicate to activate an automation.
   */
  conditions: GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions[];
}

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations {
  __typename: "StageLeadAssignmentAutomation";
  /**
   * Flag to determine if this automation should unassign the lead.
   */
  shouldUnassign: boolean;
  /**
   * If the assignee is a team, round robin will equally distribute leads to each member of the team.
   */
  shouldRoundRobin: boolean | null;
  /**
   * The assignee object for this lead assignment automation.
   */
  assignee: GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_assignee | null;
  /**
   * This automation's predicate.
   */
  predicate: GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate;
}

export interface GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData {
  __typename: "StageLeadAssignmentAutomationData";
  /**
   * The global setting for this set of stage lead assignment automations saying whether reassignment is allowed.
   */
  stageLeadAssignmentAllowReassign: boolean;
  /**
   * The default automation that will be fired if all special cases fail to fire.
   */
  stageLeadAssignmentDefaultAutomation: GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation | null;
  /**
   * The nicely unpacked list of automations for this set of stage lead assignment automations.
   */
  stageLeadAssignmentAutomations: GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations[];
}

export interface GetUserAssignmentsForStage_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The object housing the list of editable stageLeadAssignmentAutomations and associated meta data for this stage.
   */
  editableStageLeadAssignmentAutomationData: GetUserAssignmentsForStage_stage_editableStageLeadAssignmentAutomationData;
}

export interface GetUserAssignmentsForStage {
  /**
   * Returns a Nutshell Stage
   */
  stage: GetUserAssignmentsForStage_stage | null;
}

export interface GetUserAssignmentsForStageVariables {
  stageId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DuplicateStageset
// ====================================================

export interface DuplicateStageset_duplicateStageset_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
}

export interface DuplicateStageset_duplicateStageset_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DuplicateStageset_duplicateStageset_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * Can this pipeline be accessed? If a customer downgrades, non-default pipelines may become inaccessible
   */
  canAccess: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The stages associated with this stageset
   */
  stages: DuplicateStageset_duplicateStageset_stageset_stages[];
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: DuplicateStageset_duplicateStageset_stageset_leadDistributionAutomation | null;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
  /**
   * Who is allowed to view this stageset, its leads, and their contacts/accounts.
   */
  visibilityMode: StagesetVisibilityMode;
  /**
   * The number of enabled users who can view this stageset when visibilityMode is
   * RESTRICTED. Includes administrators. Returns null otherwise. Admin-only; null
   * for non-admins.
   */
  restrictedCanViewCount: number | null;
}

export interface DuplicateStageset_duplicateStageset {
  __typename: "DuplicateStagesetPayload";
  stageset: DuplicateStageset_duplicateStageset_stageset;
}

export interface DuplicateStageset {
  /**
   * Duplicates (referred to as archived in the UI) a Stageset.
   */
  duplicateStageset: DuplicateStageset_duplicateStageset | null;
}

export interface DuplicateStagesetVariables {
  stageset: DuplicateStagesetInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteStageset
// ====================================================

export interface DeleteStageset_deleteStageset_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
}

export interface DeleteStageset_deleteStageset_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteStageset_deleteStageset_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * Can this pipeline be accessed? If a customer downgrades, non-default pipelines may become inaccessible
   */
  canAccess: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The stages associated with this stageset
   */
  stages: DeleteStageset_deleteStageset_stageset_stages[];
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: DeleteStageset_deleteStageset_stageset_leadDistributionAutomation | null;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
  /**
   * Who is allowed to view this stageset, its leads, and their contacts/accounts.
   */
  visibilityMode: StagesetVisibilityMode;
  /**
   * The number of enabled users who can view this stageset when visibilityMode is
   * RESTRICTED. Includes administrators. Returns null otherwise. Admin-only; null
   * for non-admins.
   */
  restrictedCanViewCount: number | null;
}

export interface DeleteStageset_deleteStageset {
  __typename: "DeleteStagesetPayload";
  stageset: DeleteStageset_deleteStageset_stageset | null;
}

export interface DeleteStageset {
  /**
   * Deletes (referred to as archived in the UI) a Stageset.
   */
  deleteStageset: DeleteStageset_deleteStageset | null;
}

export interface DeleteStagesetVariables {
  stageset: DeleteStagesetInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RestoreStageset
// ====================================================

export interface RestoreStageset_restoreStageset_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
}

export interface RestoreStageset_restoreStageset_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface RestoreStageset_restoreStageset_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * Can this pipeline be accessed? If a customer downgrades, non-default pipelines may become inaccessible
   */
  canAccess: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The stages associated with this stageset
   */
  stages: RestoreStageset_restoreStageset_stageset_stages[];
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: RestoreStageset_restoreStageset_stageset_leadDistributionAutomation | null;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
  /**
   * Who is allowed to view this stageset, its leads, and their contacts/accounts.
   */
  visibilityMode: StagesetVisibilityMode;
  /**
   * The number of enabled users who can view this stageset when visibilityMode is
   * RESTRICTED. Includes administrators. Returns null otherwise. Admin-only; null
   * for non-admins.
   */
  restrictedCanViewCount: number | null;
}

export interface RestoreStageset_restoreStageset {
  __typename: "RestoreStagesetPayload";
  stageset: RestoreStageset_restoreStageset_stageset;
}

export interface RestoreStageset {
  /**
   * Restores a Stageset.
   */
  restoreStageset: RestoreStageset_restoreStageset | null;
}

export interface RestoreStagesetVariables {
  stageset: RestoreStagesetInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateStageset
// ====================================================

export interface CreateStageset_createStageset_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
}

export interface CreateStageset_createStageset_stageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateStageset_createStageset_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * Can this pipeline be accessed? If a customer downgrades, non-default pipelines may become inaccessible
   */
  canAccess: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The stages associated with this stageset
   */
  stages: CreateStageset_createStageset_stageset_stages[];
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: CreateStageset_createStageset_stageset_leadDistributionAutomation | null;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
  /**
   * Who is allowed to view this stageset, its leads, and their contacts/accounts.
   */
  visibilityMode: StagesetVisibilityMode;
  /**
   * The number of enabled users who can view this stageset when visibilityMode is
   * RESTRICTED. Includes administrators. Returns null otherwise. Admin-only; null
   * for non-admins.
   */
  restrictedCanViewCount: number | null;
}

export interface CreateStageset_createStageset {
  __typename: "CreateStagesetPayload";
  /**
   * The newly created Nutshell stageset.
   */
  stageset: CreateStageset_createStageset_stageset;
}

export interface CreateStageset {
  /**
   * Creates a new stageset.
   */
  createStageset: CreateStageset_createStageset;
}

export interface CreateStagesetVariables {
  stageset: CreateStagesetInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMeetingsSidebarCounts
// ====================================================

export interface GetMeetingsSidebarCounts_meetingsSidebarCounts_zoom {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetMeetingsSidebarCounts_meetingsSidebarCounts_googleMeet {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetMeetingsSidebarCounts_meetingsSidebarCounts_teams {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetMeetingsSidebarCounts_meetingsSidebarCounts {
  __typename: "MeetingsSidebarCounts";
  /**
   * Count of unlogged Zoom meetings
   */
  zoom: GetMeetingsSidebarCounts_meetingsSidebarCounts_zoom;
  /**
   * Count of unlogged Google Meet meetings
   */
  googleMeet: GetMeetingsSidebarCounts_meetingsSidebarCounts_googleMeet;
  /**
   * Count of unlogged Teams meetings
   */
  teams: GetMeetingsSidebarCounts_meetingsSidebarCounts_teams;
}

export interface GetMeetingsSidebarCounts {
  /**
   * Returns the sidebar counts for the meetings section
   */
  meetingsSidebarCounts: GetMeetingsSidebarCounts_meetingsSidebarCounts;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: QuotaCreate
// ====================================================

export interface QuotaCreate_quotaCreate_users_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface QuotaCreate_quotaCreate_users_quotas_months_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface QuotaCreate_quotaCreate_users_quotas_months {
  __typename: "Month";
  /**
   * The number of the month (1-12)
   */
  identifier: number;
  /**
   * The monetary total of the month
   */
  value: QuotaCreate_quotaCreate_users_quotas_months_value;
}

export interface QuotaCreate_quotaCreate_users_quotas {
  __typename: "Quota";
  /**
   * The fiscal year for the quota
   */
  fiscalYear: number;
  months: QuotaCreate_quotaCreate_users_quotas_months[];
}

export interface QuotaCreate_quotaCreate_users {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  teams: QuotaCreate_quotaCreate_users_teams[];
  quotas: QuotaCreate_quotaCreate_users_quotas[];
}

export interface QuotaCreate_quotaCreate {
  __typename: "QuotaCreatePayload";
  /**
   * The users whose quotas were created
   */
  users: QuotaCreate_quotaCreate_users[];
}

export interface QuotaCreate {
  /**
   * Creates a new quota for a user
   */
  quotaCreate: QuotaCreate_quotaCreate;
}

export interface QuotaCreateVariables {
  input: QuotaCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: QuotaDelete
// ====================================================

export interface QuotaDelete_quotaDelete_user_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface QuotaDelete_quotaDelete_user_quotas_months_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface QuotaDelete_quotaDelete_user_quotas_months {
  __typename: "Month";
  /**
   * The number of the month (1-12)
   */
  identifier: number;
  /**
   * The monetary total of the month
   */
  value: QuotaDelete_quotaDelete_user_quotas_months_value;
}

export interface QuotaDelete_quotaDelete_user_quotas {
  __typename: "Quota";
  /**
   * The fiscal year for the quota
   */
  fiscalYear: number;
  months: QuotaDelete_quotaDelete_user_quotas_months[];
}

export interface QuotaDelete_quotaDelete_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  teams: QuotaDelete_quotaDelete_user_teams[];
  quotas: QuotaDelete_quotaDelete_user_quotas[];
}

export interface QuotaDelete_quotaDelete {
  __typename: "QuotaDeletePayload";
  /**
   * The user whose quota was deleted
   */
  user: QuotaDelete_quotaDelete_user;
}

export interface QuotaDelete {
  /**
   * Deletes a quota for a user
   */
  quotaDelete: QuotaDelete_quotaDelete;
}

export interface QuotaDeleteVariables {
  input: QuotaDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ExportQuotas
// ====================================================

export interface ExportQuotas_quotasExport {
  __typename: "QuotaExportPayload";
  /**
   * The URL to download the CSV file
   */
  url: string;
}

export interface ExportQuotas {
  /**
   * Exports all quotas to a CSV file and returns a URL to download it
   */
  quotasExport: ExportQuotas_quotasExport;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: QuotaUpdate
// ====================================================

export interface QuotaUpdate_quotaUpdate_user_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface QuotaUpdate_quotaUpdate_user_quotas_months_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface QuotaUpdate_quotaUpdate_user_quotas_months {
  __typename: "Month";
  /**
   * The number of the month (1-12)
   */
  identifier: number;
  /**
   * The monetary total of the month
   */
  value: QuotaUpdate_quotaUpdate_user_quotas_months_value;
}

export interface QuotaUpdate_quotaUpdate_user_quotas {
  __typename: "Quota";
  /**
   * The fiscal year for the quota
   */
  fiscalYear: number;
  months: QuotaUpdate_quotaUpdate_user_quotas_months[];
}

export interface QuotaUpdate_quotaUpdate_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  teams: QuotaUpdate_quotaUpdate_user_teams[];
  quotas: QuotaUpdate_quotaUpdate_user_quotas[];
}

export interface QuotaUpdate_quotaUpdate {
  __typename: "QuotaUpdatePayload";
  /**
   * The user whose quota was updated
   */
  user: QuotaUpdate_quotaUpdate_user;
}

export interface QuotaUpdate {
  /**
   * Updates a quota for a user for the given months and fiscal year
   */
  quotaUpdate: QuotaUpdate_quotaUpdate;
}

export interface QuotaUpdateVariables {
  input: QuotaUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetQuotaMigrationProblems
// ====================================================

export interface GetQuotaMigrationProblems_quotaMigrationProblems {
  __typename: "QuotaMigrationProblemsPayload";
}

export interface GetQuotaMigrationProblems {
  quotaMigrationProblems: GetQuotaMigrationProblems_quotaMigrationProblems;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUsersWithQuotas
// ====================================================

export interface GetUsersWithQuotas_usersWithQuotas_pageInfo {
  __typename: "PageInfo";
  endCursor: string | null;
  hasNextPage: boolean;
}

export interface GetUsersWithQuotas_usersWithQuotas_edges_node_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface GetUsersWithQuotas_usersWithQuotas_edges_node_quotas_months_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface GetUsersWithQuotas_usersWithQuotas_edges_node_quotas_months {
  __typename: "Month";
  /**
   * The number of the month (1-12)
   */
  identifier: number;
  /**
   * The monetary total of the month
   */
  value: GetUsersWithQuotas_usersWithQuotas_edges_node_quotas_months_value;
}

export interface GetUsersWithQuotas_usersWithQuotas_edges_node_quotas {
  __typename: "Quota";
  /**
   * The fiscal year for the quota
   */
  fiscalYear: number;
  months: GetUsersWithQuotas_usersWithQuotas_edges_node_quotas_months[];
}

export interface GetUsersWithQuotas_usersWithQuotas_edges_node {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  teams: GetUsersWithQuotas_usersWithQuotas_edges_node_teams[];
  quotas: GetUsersWithQuotas_usersWithQuotas_edges_node_quotas[];
}

export interface GetUsersWithQuotas_usersWithQuotas_edges {
  __typename: "UsersEdge";
  node: GetUsersWithQuotas_usersWithQuotas_edges_node;
}

export interface GetUsersWithQuotas_usersWithQuotas {
  __typename: "UsersConnection";
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetUsersWithQuotas_usersWithQuotas_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetUsersWithQuotas_usersWithQuotas_edges[];
}

export interface GetUsersWithQuotas {
  /**
   * Returns a paging connection of users by status from the root of our query.
   */
  usersWithQuotas: GetUsersWithQuotas_usersWithQuotas;
}

export interface GetUsersWithQuotasVariables {
  first?: number | null;
  after?: string | null;
  minFiscalYear: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetYearOverviewStats
// ====================================================

export interface GetYearOverviewStats_quotaYearOverview_yearValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface GetYearOverviewStats_quotaYearOverview_months_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface GetYearOverviewStats_quotaYearOverview_months {
  __typename: "Month";
  /**
   * The monetary total of the month
   */
  value: GetYearOverviewStats_quotaYearOverview_months_value;
  /**
   * The number of the month (1-12)
   */
  identifier: number;
}

export interface GetYearOverviewStats_quotaYearOverview {
  __typename: "YearOverviewPayload";
  /**
   * The fiscal year for the overview
   */
  fiscalYear: number;
  /**
   * The sum of every month’s quota value
   */
  yearValue: GetYearOverviewStats_quotaYearOverview_yearValue;
  /**
   * Each month with the sum of all user quotas
   */
  months: GetYearOverviewStats_quotaYearOverview_months[];
}

export interface GetYearOverviewStats {
  /**
   * Returns the quota year overview stats for a given fiscal year
   */
  quotaYearOverview: GetYearOverviewStats_quotaYearOverview[];
}

export interface GetYearOverviewStatsVariables {
  fiscalYears: number[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateManagedMeetingTemplateAssignments
// ====================================================

export interface UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting_assignments_edges_meetings_hosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting_assignments_edges_meetings_bookings {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting_assignments_edges_meetings_validity {
  __typename: "MeetingValidity";
  /**
   * Whether this meeting can be booked
   */
  isBookable: boolean;
}

export interface UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting_assignments_edges_meetings {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The possible hosts of this meeting, team members for ROUND_ROBIN, set hosts for other types
   */
  hosts: UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting_assignments_edges_meetings_hosts[];
  /**
   * The bookings of this meeting
   */
  bookings: UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting_assignments_edges_meetings_bookings[];
  /**
   * Whether this meeting is severed from its template. Always false for non-managed meetings.
   */
  isSevered: boolean;
  /**
   * The DateTime that represents when the meeting was deleted
   */
  deletedTime: any | null;
  /**
   * The validity of this meeting
   */
  validity: UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting_assignments_edges_meetings_validity;
}

export interface UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting_assignments_edges_node_assigneeEntity_User_emailAddresses {
  __typename: "UserEmail";
  /**
   * The address string of this email.
   */
  address: string;
}

export interface UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting_assignments_edges_node_assigneeEntity_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * User emails configured for this user
   */
  emailAddresses: UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting_assignments_edges_node_assigneeEntity_User_emailAddresses[];
  avatarUrl: string;
  initials: string;
}

export interface UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting_assignments_edges_node_assigneeEntity_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The number of users affiliated with this team
   */
  numUsers: number;
}

export type UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting_assignments_edges_node_assigneeEntity = UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting_assignments_edges_node_assigneeEntity_User | UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting_assignments_edges_node_assigneeEntity_Team;

export interface UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting_assignments_edges_node {
  __typename: "Assignment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity to which the assignment was made
   */
  assigneeEntity: UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting_assignments_edges_node_assigneeEntity;
}

export interface UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting_assignments_edges {
  __typename: "MaterializedMeetingsEdge";
  /**
   * The materialized meetings.
   */
  meetings: UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting_assignments_edges_meetings[];
  node: UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting_assignments_edges_node;
}

export interface UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting_assignments {
  __typename: "MaterializedMeetingsConnection";
  /**
   * A list of edges.
   */
  edges: UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting_assignments_edges[];
}

export interface UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The users or teams assigned to this meeting template.
   */
  assignments: UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting_assignments | null;
}

export interface UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate {
  __typename: "ManagedMeetingTemplateAssignmentsUpdatePayload";
  /**
   * The meeting that was updated.
   */
  meeting: UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate_meeting | null;
}

export interface UpdateManagedMeetingTemplateAssignments {
  /**
   * Update the assignments for a managed meeting template
   */
  managedMeetingTemplateAssignmentsUpdate: UpdateManagedMeetingTemplateAssignments_managedMeetingTemplateAssignmentsUpdate;
}

export interface UpdateManagedMeetingTemplateAssignmentsVariables {
  input: ManagedMeetingTemplateAssignmentsUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAssignments
// ====================================================

export interface GetAssignments_meeting_assignments_edges_meetings_hosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetAssignments_meeting_assignments_edges_meetings_bookings {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetAssignments_meeting_assignments_edges_meetings_validity {
  __typename: "MeetingValidity";
  /**
   * Whether this meeting can be booked
   */
  isBookable: boolean;
}

export interface GetAssignments_meeting_assignments_edges_meetings {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The possible hosts of this meeting, team members for ROUND_ROBIN, set hosts for other types
   */
  hosts: GetAssignments_meeting_assignments_edges_meetings_hosts[];
  /**
   * The bookings of this meeting
   */
  bookings: GetAssignments_meeting_assignments_edges_meetings_bookings[];
  /**
   * Whether this meeting is severed from its template. Always false for non-managed meetings.
   */
  isSevered: boolean;
  /**
   * The DateTime that represents when the meeting was deleted
   */
  deletedTime: any | null;
  /**
   * The validity of this meeting
   */
  validity: GetAssignments_meeting_assignments_edges_meetings_validity;
}

export interface GetAssignments_meeting_assignments_edges_node_assigneeEntity_User_emailAddresses {
  __typename: "UserEmail";
  /**
   * The address string of this email.
   */
  address: string;
}

export interface GetAssignments_meeting_assignments_edges_node_assigneeEntity_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * User emails configured for this user
   */
  emailAddresses: GetAssignments_meeting_assignments_edges_node_assigneeEntity_User_emailAddresses[];
  avatarUrl: string;
  initials: string;
}

export interface GetAssignments_meeting_assignments_edges_node_assigneeEntity_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The number of users affiliated with this team
   */
  numUsers: number;
}

export type GetAssignments_meeting_assignments_edges_node_assigneeEntity = GetAssignments_meeting_assignments_edges_node_assigneeEntity_User | GetAssignments_meeting_assignments_edges_node_assigneeEntity_Team;

export interface GetAssignments_meeting_assignments_edges_node {
  __typename: "Assignment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity to which the assignment was made
   */
  assigneeEntity: GetAssignments_meeting_assignments_edges_node_assigneeEntity;
}

export interface GetAssignments_meeting_assignments_edges {
  __typename: "MaterializedMeetingsEdge";
  /**
   * The materialized meetings.
   */
  meetings: GetAssignments_meeting_assignments_edges_meetings[];
  node: GetAssignments_meeting_assignments_edges_node;
}

export interface GetAssignments_meeting_assignments {
  __typename: "MaterializedMeetingsConnection";
  /**
   * A list of edges.
   */
  edges: GetAssignments_meeting_assignments_edges[];
}

export interface GetAssignments_meeting {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The users or teams assigned to this meeting template.
   */
  assignments: GetAssignments_meeting_assignments | null;
}

export interface GetAssignments {
  /**
   * Returns a scheduler meeting
   */
  meeting: GetAssignments_meeting;
}

export interface GetAssignmentsVariables {
  meetingId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUsersForManagedMeetings
// ====================================================

export interface GetUsersForManagedMeetings_users_pageInfo {
  __typename: "PageInfo";
  endCursor: string | null;
  hasNextPage: boolean;
}

export interface GetUsersForManagedMeetings_users_edges_node_emailAddresses {
  __typename: "UserEmail";
  /**
   * The address string of this email.
   */
  address: string;
}

export interface GetUsersForManagedMeetings_users_edges_node {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * User emails configured for this user
   */
  emailAddresses: GetUsersForManagedMeetings_users_edges_node_emailAddresses[];
  avatarUrl: string;
  initials: string;
}

export interface GetUsersForManagedMeetings_users_edges {
  __typename: "UsersEdge";
  node: GetUsersForManagedMeetings_users_edges_node;
}

export interface GetUsersForManagedMeetings_users {
  __typename: "UsersConnection";
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetUsersForManagedMeetings_users_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetUsersForManagedMeetings_users_edges[];
}

export interface GetUsersForManagedMeetings {
  /**
   * Returns a paging connection of users from the root of our query.
   */
  users: GetUsersForManagedMeetings_users;
}

export interface GetUsersForManagedMeetingsVariables {
  first?: number | null;
  after?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CancelBooking
// ====================================================

export interface CancelBooking_bookingCancel_booking_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface CancelBooking_bookingCancel_booking_meeting {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of this meeting
   */
  meetingType: MeetingType;
}

export interface CancelBooking_bookingCancel_booking_formSubmission_primaryEntity_Lead {
  __typename: "Lead";
}

export interface CancelBooking_bookingCancel_booking_formSubmission_primaryEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface CancelBooking_bookingCancel_booking_formSubmission_primaryEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export type CancelBooking_bookingCancel_booking_formSubmission_primaryEntity = CancelBooking_bookingCancel_booking_formSubmission_primaryEntity_Lead | CancelBooking_bookingCancel_booking_formSubmission_primaryEntity_Account | CancelBooking_bookingCancel_booking_formSubmission_primaryEntity_Contact;

export interface CancelBooking_bookingCancel_booking_formSubmission_formVersion_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface CancelBooking_bookingCancel_booking_formSubmission_formVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent form of this form version
   */
  form: CancelBooking_bookingCancel_booking_formSubmission_formVersion_form;
}

export interface CancelBooking_bookingCancel_booking_formSubmission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface CancelBooking_bookingCancel_booking_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
}

export interface CancelBooking_bookingCancel_booking_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface CancelBooking_bookingCancel_booking_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export type CancelBooking_bookingCancel_booking_formSubmission_fields_edges_fieldValue = CancelBooking_bookingCancel_booking_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields | CancelBooking_bookingCancel_booking_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | CancelBooking_bookingCancel_booking_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueSingle;

export interface CancelBooking_bookingCancel_booking_formSubmission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: CancelBooking_bookingCancel_booking_formSubmission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: CancelBooking_bookingCancel_booking_formSubmission_fields_edges_fieldValue | null;
}

export interface CancelBooking_bookingCancel_booking_formSubmission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: CancelBooking_bookingCancel_booking_formSubmission_fields_edges[];
}

export interface CancelBooking_bookingCancel_booking_formSubmission {
  __typename: "Submission";
  /**
   * The primary entity on the submission
   */
  primaryEntity: CancelBooking_bookingCancel_booking_formSubmission_primaryEntity | null;
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The url where the submission originates
   */
  submissionUrl: string;
  /**
   * The name of the submitted web form
   */
  formVersion: CancelBooking_bookingCancel_booking_formSubmission_formVersion;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: CancelBooking_bookingCancel_booking_formSubmission_fields;
}

export interface CancelBooking_bookingCancel_booking_hostUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The user’s configured timezone
   */
  timezone: string;
}

export interface CancelBooking_bookingCancel_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of the booking
   */
  status: BookingStatus;
  /**
   * The URL for rescheduling a booking
   */
  rescheduleUrl: string;
  /**
   * The activity associated with this booking
   */
  activity: CancelBooking_bookingCancel_booking_activity | null;
  /**
   * The meeting connected to this booking
   */
  meeting: CancelBooking_bookingCancel_booking_meeting;
  /**
   * The form submission associated with this booking
   */
  formSubmission: CancelBooking_bookingCancel_booking_formSubmission | null;
  /**
   * The start time of this booking
   */
  startTime: any;
  /**
   * The created time of this booking
   */
  createdTime: any;
  /**
   * The host user of this booking
   */
  hostUser: CancelBooking_bookingCancel_booking_hostUser | null;
}

export interface CancelBooking_bookingCancel {
  __typename: "BookingCancelPayload";
  /**
   * The booking that was cancelled.
   */
  booking: CancelBooking_bookingCancel_booking | null;
}

export interface CancelBooking {
  /**
   * Cancel a booking
   */
  bookingCancel: CancelBooking_bookingCancel;
}

export interface CancelBookingVariables {
  input: BookingCancelInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateMeeting
// ====================================================

export interface CreateMeeting_meetingCreate_meeting_minNotice {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface CreateMeeting_meetingCreate_meeting_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface CreateMeeting_meetingCreate_meeting_creator {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
  /**
   * The user’s configured root meeting URL for scheduler
   */
  schedulerRootMeetingsUrl: string;
  /**
   * Whether or not the user has customized their meeting URL
   */
  hasCustomizedMeetingUrl: boolean;
}

export interface CreateMeeting_meetingCreate_meeting_cohosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
}

export interface CreateMeeting_meetingCreate_meeting_hosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
}

export interface CreateMeeting_meetingCreate_meeting_team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface CreateMeeting_meetingCreate_meeting_availability_times {
  __typename: "AvailabilityTime";
  /**
   * The day of this availability time
   */
  day: AvailabilityDay;
  /**
   * The time this duration starts
   */
  startTime: string;
  /**
   * The time this duration ends
   */
  endTime: string;
}

export interface CreateMeeting_meetingCreate_meeting_availability {
  __typename: "Availability";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Availability times on monday
   */
  times: CreateMeeting_meetingCreate_meeting_availability_times[];
}

export interface CreateMeeting_meetingCreate_meeting_form_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface CreateMeeting_meetingCreate_meeting_form_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateMeeting_meetingCreate_meeting_form_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface CreateMeeting_meetingCreate_meeting_form_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface CreateMeeting_meetingCreate_meeting_form_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface CreateMeeting_meetingCreate_meeting_form_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: CreateMeeting_meetingCreate_meeting_form_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: CreateMeeting_meetingCreate_meeting_form_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: CreateMeeting_meetingCreate_meeting_form_createRules_lead_stagesetFieldRules_stageset;
}

export interface CreateMeeting_meetingCreate_meeting_form_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: CreateMeeting_meetingCreate_meeting_form_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: CreateMeeting_meetingCreate_meeting_form_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: CreateMeeting_meetingCreate_meeting_form_createRules_lead_stagesetFieldRules[];
}

export interface CreateMeeting_meetingCreate_meeting_form_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateMeeting_meetingCreate_meeting_form_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface CreateMeeting_meetingCreate_meeting_form_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: CreateMeeting_meetingCreate_meeting_form_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: CreateMeeting_meetingCreate_meeting_form_createRules_contact_audiences[];
}

export interface CreateMeeting_meetingCreate_meeting_form_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateMeeting_meetingCreate_meeting_form_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: CreateMeeting_meetingCreate_meeting_form_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface CreateMeeting_meetingCreate_meeting_form_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: CreateMeeting_meetingCreate_meeting_form_createRules_lead | null;
  /**
   * The create rules related to a contact
   */
  contact: CreateMeeting_meetingCreate_meeting_form_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: CreateMeeting_meetingCreate_meeting_form_createRules_account | null;
}

export interface CreateMeeting_meetingCreate_meeting_form_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateMeeting_meetingCreate_meeting_form_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface CreateMeeting_meetingCreate_meeting_form_publishedVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface CreateMeeting_meetingCreate_meeting_form_publishedVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface CreateMeeting_meetingCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateMeeting_meetingCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface CreateMeeting_meetingCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface CreateMeeting_meetingCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateMeeting_meetingCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type CreateMeeting_meetingCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign = CreateMeeting_meetingCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Tag | CreateMeeting_meetingCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Audience | CreateMeeting_meetingCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Product | CreateMeeting_meetingCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Source | CreateMeeting_meetingCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Stageset;

export interface CreateMeeting_meetingCreate_meeting_form_publishedVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: CreateMeeting_meetingCreate_meeting_form_publishedVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: CreateMeeting_meetingCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign[];
}

export interface CreateMeeting_meetingCreate_meeting_form_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: CreateMeeting_meetingCreate_meeting_form_publishedVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: CreateMeeting_meetingCreate_meeting_form_publishedVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: CreateMeeting_meetingCreate_meeting_form_publishedVersion_fields_rules[];
}

export interface CreateMeeting_meetingCreate_meeting_form_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: CreateMeeting_meetingCreate_meeting_form_publishedVersion_pages[];
  /**
   * Array of fields associated with this web form version
   */
  fields: CreateMeeting_meetingCreate_meeting_form_publishedVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
}

export interface CreateMeeting_meetingCreate_meeting_form_editableVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface CreateMeeting_meetingCreate_meeting_form_editableVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface CreateMeeting_meetingCreate_meeting_form_editableVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface CreateMeeting_meetingCreate_meeting_form_editableVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateMeeting_meetingCreate_meeting_form_editableVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface CreateMeeting_meetingCreate_meeting_form_editableVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface CreateMeeting_meetingCreate_meeting_form_editableVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateMeeting_meetingCreate_meeting_form_editableVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type CreateMeeting_meetingCreate_meeting_form_editableVersion_fields_rules_objectsToAssign = CreateMeeting_meetingCreate_meeting_form_editableVersion_fields_rules_objectsToAssign_Tag | CreateMeeting_meetingCreate_meeting_form_editableVersion_fields_rules_objectsToAssign_Audience | CreateMeeting_meetingCreate_meeting_form_editableVersion_fields_rules_objectsToAssign_Product | CreateMeeting_meetingCreate_meeting_form_editableVersion_fields_rules_objectsToAssign_Source | CreateMeeting_meetingCreate_meeting_form_editableVersion_fields_rules_objectsToAssign_Stageset;

export interface CreateMeeting_meetingCreate_meeting_form_editableVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: CreateMeeting_meetingCreate_meeting_form_editableVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: CreateMeeting_meetingCreate_meeting_form_editableVersion_fields_rules_objectsToAssign[];
}

export interface CreateMeeting_meetingCreate_meeting_form_editableVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: CreateMeeting_meetingCreate_meeting_form_editableVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: CreateMeeting_meetingCreate_meeting_form_editableVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: CreateMeeting_meetingCreate_meeting_form_editableVersion_fields_rules[];
}

export interface CreateMeeting_meetingCreate_meeting_form_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of fields associated with this web form version
   */
  fields: CreateMeeting_meetingCreate_meeting_form_editableVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
}

export interface CreateMeeting_meetingCreate_meeting_form_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface CreateMeeting_meetingCreate_meeting_form_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateMeeting_meetingCreate_meeting_form_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: CreateMeeting_meetingCreate_meeting_form_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: CreateMeeting_meetingCreate_meeting_form_nextSteps_slackMessage_form;
}

export interface CreateMeeting_meetingCreate_meeting_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface CreateMeeting_meetingCreate_meeting_form_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type CreateMeeting_meetingCreate_meeting_form_nextSteps_nutshellNotification_notifiables = CreateMeeting_meetingCreate_meeting_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias | CreateMeeting_meetingCreate_meeting_form_nextSteps_nutshellNotification_notifiables_User;

export interface CreateMeeting_meetingCreate_meeting_form_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateMeeting_meetingCreate_meeting_form_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: CreateMeeting_meetingCreate_meeting_form_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: CreateMeeting_meetingCreate_meeting_form_nextSteps_nutshellNotification_form;
}

export interface CreateMeeting_meetingCreate_meeting_form_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: CreateMeeting_meetingCreate_meeting_form_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: CreateMeeting_meetingCreate_meeting_form_nextSteps_nutshellNotification | null;
}

export interface CreateMeeting_meetingCreate_meeting_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: CreateMeeting_meetingCreate_meeting_form_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: CreateMeeting_meetingCreate_meeting_form_publishedVersion | null;
  /**
   * Whether the form has been embedded
   */
  isLiveForm: boolean;
  /**
   * The published form preview url
   */
  publishedFormPreviewUrl: string;
  /**
   * Publicly viewable link to published form
   */
  sharableViewInBrowserLink: string;
  /**
   * Boolean, true if the editable version has any edits
   */
  hasUnpublishedChanges: boolean;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: CreateMeeting_meetingCreate_meeting_form_editableVersion;
  /**
   * Next step automations for this form
   */
  nextSteps: CreateMeeting_meetingCreate_meeting_form_nextSteps;
  /**
   * The embed snippet for this form
   */
  embedSnippet: string;
  /**
   * The type of form
   */
  type: FormType;
}

export interface CreateMeeting_meetingCreate_meeting_bookings {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateMeeting_meetingCreate_meeting_validity_issues_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateMeeting_meetingCreate_meeting_validity_issues {
  __typename: "MeetingValidityIssue";
  /**
   * The user tied to this issue
   */
  user: CreateMeeting_meetingCreate_meeting_validity_issues_user;
  /**
   * The issue type of this issue
   */
  issueType: ValidityIssueType;
}

export interface CreateMeeting_meetingCreate_meeting_validity {
  __typename: "MeetingValidity";
  /**
   * A list of issues with host users tied to this meeting
   */
  issues: CreateMeeting_meetingCreate_meeting_validity_issues[];
  /**
   * Whether this meeting can be booked
   */
  isBookable: boolean;
}

export interface CreateMeeting_meetingCreate_meeting_assignments_stats {
  __typename: "MaterializedMeetingsStats";
  /**
   * The number of users assigned to this meeting template.
   */
  assignedUsersCount: number;
  /**
   * The number of teams assigned to this meeting template.
   */
  assignedTeamsCount: number;
  /**
   * The number of materialized meetings from this meeting template that have been modified and severed.
   */
  severedCount: number;
}

export interface CreateMeeting_meetingCreate_meeting_assignments {
  __typename: "MaterializedMeetingsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The number of users assigned to this meeting template.
   */
  stats: CreateMeeting_meetingCreate_meeting_assignments_stats;
}

export interface CreateMeeting_meetingCreate_meeting {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Meeting model (used to fetch meeting config)
   */
  modelId: number;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * The type of this meeting
   */
  meetingType: MeetingType;
  /**
   * The description of this meeting
   */
  description: string | null;
  /**
   * Custom text sent to the invitee after booking
   */
  bookingConfirmationMessage: string | null;
  /**
   * The htmlUrl without http:                                            // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl for the template that manages this meeting without http: // app.nutshell.com.
   */
  managedByHtmlUrlPath: string | null;
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number;
  /**
   * The published form preview url
   */
  previewUrl: string;
  /**
   * The minimum notice required to book this meeting
   */
  minNotice: CreateMeeting_meetingCreate_meeting_minNotice | null;
  /**
   * Buffer before each booking in minutes
   */
  bufferBeforeMins: number | null;
  /**
   * Buffer after each booking in minutes
   */
  bufferAfterMins: number | null;
  /**
   * The activity type for this meeting
   */
  activityType: CreateMeeting_meetingCreate_meeting_activityType;
  /**
   * The location of this meeting, such as address or phone number
   */
  location: string;
  /**
   * The location type of this meeting
   */
  locationType: MeetingLocationType;
  /**
   * The primary host for this meeting
   */
  creator: CreateMeeting_meetingCreate_meeting_creator;
  /**
   * The cohosts of this meeting, not including primary host
   */
  cohosts: CreateMeeting_meetingCreate_meeting_cohosts[];
  /**
   * The possible hosts of this meeting, team members for ROUND_ROBIN, set hosts for other types
   */
  hosts: CreateMeeting_meetingCreate_meeting_hosts[];
  /**
   * For a ROUND_ROBIN meeting, the selected team
   */
  team: CreateMeeting_meetingCreate_meeting_team | null;
  /**
   * The availability for this meeting
   */
  availability: CreateMeeting_meetingCreate_meeting_availability;
  /**
   * Publicly viewable link to the meeting
   */
  publicMeetingLink: string;
  /**
   * Whether this meeting is active
   */
  isActive: boolean;
  /**
   * The activity type for this meeting
   */
  form: CreateMeeting_meetingCreate_meeting_form;
  /**
   * The bookings of this meeting
   */
  bookings: CreateMeeting_meetingCreate_meeting_bookings[];
  /**
   * The timestamp this web form was last submitted
   */
  lastBookedTime: any | null;
  /**
   * Show invitees time slots at this interval in minutes
   */
  startTimeIntervalMinutes: number;
  /**
   * The number of times this meeting has been viewed
   */
  numViews: number;
  /**
   * Number of bookings compared to views
   */
  bookingRate: number;
  /**
   * Whether to send a booking confirmation email
   */
  sendConfirmationReminder: boolean;
  /**
   * Whether to send a reminder email one day before the meeting
   */
  sendUpcomingReminder: boolean;
  /**
   * Whether to send a reminder email 30 minutes before the meeting
   */
  sendSoonReminder: boolean;
  /**
   * Whether this meeting spans multiple timezones among primary and co hosts
   */
  spansTimezones: boolean;
  /**
   * The validity of this meeting
   */
  validity: CreateMeeting_meetingCreate_meeting_validity;
  /**
   * The embed snippet for this meeting
   */
  embedSnippet: string;
  /**
   * The DateTime that represents when the meeting was deleted
   */
  deletedTime: any | null;
  /**
   * Whether to allow additional attendees to be added to the booking
   */
  allowAdditionalAttendees: boolean;
  /**
   * Whether this meeting is hidden from public view or visible on the host users scheduler page
   */
  isHidden: boolean;
  /**
   * Whether this hidden meeting can be made public (all plans can make hidden meetings public)
   */
  isShowable: boolean;
  /**
   * Whether this public meeting can be hidden (requires full scheduler access)
   */
  isHideable: boolean;
  /**
   * The custom URL slug for the meeting
   */
  customSlug: string | null;
  /**
   * The url slug of this meeting
   */
  urlSlug: string;
  /**
   * Whether this meeting is a managed template
   */
  isManagedTemplate: boolean;
  /**
   * Whether this meeting is being managed by a template
   */
  isManagedMeeting: boolean;
  /**
   * Whether this meeting is severed from its template. Always false for non-managed meetings.
   */
  isSevered: boolean;
  /**
   * The users or teams assigned to this meeting template.
   */
  assignments: CreateMeeting_meetingCreate_meeting_assignments | null;
}

export interface CreateMeeting_meetingCreate {
  __typename: "MeetingCreatePayload";
  /**
   * The newly created meeting.
   */
  meeting: CreateMeeting_meetingCreate_meeting | null;
}

export interface CreateMeeting {
  /**
   * Creates a scheduler meeting
   */
  meetingCreate: CreateMeeting_meetingCreate;
}

export interface CreateMeetingVariables {
  input: MeetingCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteBooking
// ====================================================

export interface DeleteBooking_bookingDelete_booking_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface DeleteBooking_bookingDelete_booking_meeting {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of this meeting
   */
  meetingType: MeetingType;
}

export interface DeleteBooking_bookingDelete_booking_formSubmission_primaryEntity_Lead {
  __typename: "Lead";
}

export interface DeleteBooking_bookingDelete_booking_formSubmission_primaryEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface DeleteBooking_bookingDelete_booking_formSubmission_primaryEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export type DeleteBooking_bookingDelete_booking_formSubmission_primaryEntity = DeleteBooking_bookingDelete_booking_formSubmission_primaryEntity_Lead | DeleteBooking_bookingDelete_booking_formSubmission_primaryEntity_Account | DeleteBooking_bookingDelete_booking_formSubmission_primaryEntity_Contact;

export interface DeleteBooking_bookingDelete_booking_formSubmission_formVersion_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface DeleteBooking_bookingDelete_booking_formSubmission_formVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent form of this form version
   */
  form: DeleteBooking_bookingDelete_booking_formSubmission_formVersion_form;
}

export interface DeleteBooking_bookingDelete_booking_formSubmission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface DeleteBooking_bookingDelete_booking_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
}

export interface DeleteBooking_bookingDelete_booking_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface DeleteBooking_bookingDelete_booking_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export type DeleteBooking_bookingDelete_booking_formSubmission_fields_edges_fieldValue = DeleteBooking_bookingDelete_booking_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields | DeleteBooking_bookingDelete_booking_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | DeleteBooking_bookingDelete_booking_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueSingle;

export interface DeleteBooking_bookingDelete_booking_formSubmission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: DeleteBooking_bookingDelete_booking_formSubmission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: DeleteBooking_bookingDelete_booking_formSubmission_fields_edges_fieldValue | null;
}

export interface DeleteBooking_bookingDelete_booking_formSubmission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: DeleteBooking_bookingDelete_booking_formSubmission_fields_edges[];
}

export interface DeleteBooking_bookingDelete_booking_formSubmission {
  __typename: "Submission";
  /**
   * The primary entity on the submission
   */
  primaryEntity: DeleteBooking_bookingDelete_booking_formSubmission_primaryEntity | null;
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The url where the submission originates
   */
  submissionUrl: string;
  /**
   * The name of the submitted web form
   */
  formVersion: DeleteBooking_bookingDelete_booking_formSubmission_formVersion;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: DeleteBooking_bookingDelete_booking_formSubmission_fields;
}

export interface DeleteBooking_bookingDelete_booking_hostUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The user’s configured timezone
   */
  timezone: string;
}

export interface DeleteBooking_bookingDelete_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of the booking
   */
  status: BookingStatus;
  /**
   * The URL for rescheduling a booking
   */
  rescheduleUrl: string;
  /**
   * The activity associated with this booking
   */
  activity: DeleteBooking_bookingDelete_booking_activity | null;
  /**
   * The meeting connected to this booking
   */
  meeting: DeleteBooking_bookingDelete_booking_meeting;
  /**
   * The form submission associated with this booking
   */
  formSubmission: DeleteBooking_bookingDelete_booking_formSubmission | null;
  /**
   * The start time of this booking
   */
  startTime: any;
  /**
   * The created time of this booking
   */
  createdTime: any;
  /**
   * The host user of this booking
   */
  hostUser: DeleteBooking_bookingDelete_booking_hostUser | null;
}

export interface DeleteBooking_bookingDelete {
  __typename: "BookingDeletePayload";
  /**
   * The booking that was deleted.
   */
  booking: DeleteBooking_bookingDelete_booking | null;
}

export interface DeleteBooking {
  /**
   * Delete a booking
   */
  bookingDelete: DeleteBooking_bookingDelete;
}

export interface DeleteBookingVariables {
  input: BookingDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteMeeting
// ====================================================

export interface DeleteMeeting_meetingDelete_meeting_minNotice {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface DeleteMeeting_meetingDelete_meeting_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface DeleteMeeting_meetingDelete_meeting_creator {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
  /**
   * The user’s configured root meeting URL for scheduler
   */
  schedulerRootMeetingsUrl: string;
  /**
   * Whether or not the user has customized their meeting URL
   */
  hasCustomizedMeetingUrl: boolean;
}

export interface DeleteMeeting_meetingDelete_meeting_cohosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
}

export interface DeleteMeeting_meetingDelete_meeting_hosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
}

export interface DeleteMeeting_meetingDelete_meeting_team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface DeleteMeeting_meetingDelete_meeting_availability_times {
  __typename: "AvailabilityTime";
  /**
   * The day of this availability time
   */
  day: AvailabilityDay;
  /**
   * The time this duration starts
   */
  startTime: string;
  /**
   * The time this duration ends
   */
  endTime: string;
}

export interface DeleteMeeting_meetingDelete_meeting_availability {
  __typename: "Availability";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Availability times on monday
   */
  times: DeleteMeeting_meetingDelete_meeting_availability_times[];
}

export interface DeleteMeeting_meetingDelete_meeting_form_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface DeleteMeeting_meetingDelete_meeting_form_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DeleteMeeting_meetingDelete_meeting_form_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface DeleteMeeting_meetingDelete_meeting_form_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface DeleteMeeting_meetingDelete_meeting_form_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface DeleteMeeting_meetingDelete_meeting_form_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: DeleteMeeting_meetingDelete_meeting_form_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: DeleteMeeting_meetingDelete_meeting_form_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: DeleteMeeting_meetingDelete_meeting_form_createRules_lead_stagesetFieldRules_stageset;
}

export interface DeleteMeeting_meetingDelete_meeting_form_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: DeleteMeeting_meetingDelete_meeting_form_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: DeleteMeeting_meetingDelete_meeting_form_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: DeleteMeeting_meetingDelete_meeting_form_createRules_lead_stagesetFieldRules[];
}

export interface DeleteMeeting_meetingDelete_meeting_form_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DeleteMeeting_meetingDelete_meeting_form_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface DeleteMeeting_meetingDelete_meeting_form_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: DeleteMeeting_meetingDelete_meeting_form_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: DeleteMeeting_meetingDelete_meeting_form_createRules_contact_audiences[];
}

export interface DeleteMeeting_meetingDelete_meeting_form_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DeleteMeeting_meetingDelete_meeting_form_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: DeleteMeeting_meetingDelete_meeting_form_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface DeleteMeeting_meetingDelete_meeting_form_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: DeleteMeeting_meetingDelete_meeting_form_createRules_lead | null;
  /**
   * The create rules related to a contact
   */
  contact: DeleteMeeting_meetingDelete_meeting_form_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: DeleteMeeting_meetingDelete_meeting_form_createRules_account | null;
}

export interface DeleteMeeting_meetingDelete_meeting_form_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteMeeting_meetingDelete_meeting_form_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface DeleteMeeting_meetingDelete_meeting_form_publishedVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface DeleteMeeting_meetingDelete_meeting_form_publishedVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface DeleteMeeting_meetingDelete_meeting_form_publishedVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DeleteMeeting_meetingDelete_meeting_form_publishedVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface DeleteMeeting_meetingDelete_meeting_form_publishedVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface DeleteMeeting_meetingDelete_meeting_form_publishedVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DeleteMeeting_meetingDelete_meeting_form_publishedVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type DeleteMeeting_meetingDelete_meeting_form_publishedVersion_fields_rules_objectsToAssign = DeleteMeeting_meetingDelete_meeting_form_publishedVersion_fields_rules_objectsToAssign_Tag | DeleteMeeting_meetingDelete_meeting_form_publishedVersion_fields_rules_objectsToAssign_Audience | DeleteMeeting_meetingDelete_meeting_form_publishedVersion_fields_rules_objectsToAssign_Product | DeleteMeeting_meetingDelete_meeting_form_publishedVersion_fields_rules_objectsToAssign_Source | DeleteMeeting_meetingDelete_meeting_form_publishedVersion_fields_rules_objectsToAssign_Stageset;

export interface DeleteMeeting_meetingDelete_meeting_form_publishedVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: DeleteMeeting_meetingDelete_meeting_form_publishedVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: DeleteMeeting_meetingDelete_meeting_form_publishedVersion_fields_rules_objectsToAssign[];
}

export interface DeleteMeeting_meetingDelete_meeting_form_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: DeleteMeeting_meetingDelete_meeting_form_publishedVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: DeleteMeeting_meetingDelete_meeting_form_publishedVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: DeleteMeeting_meetingDelete_meeting_form_publishedVersion_fields_rules[];
}

export interface DeleteMeeting_meetingDelete_meeting_form_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: DeleteMeeting_meetingDelete_meeting_form_publishedVersion_pages[];
  /**
   * Array of fields associated with this web form version
   */
  fields: DeleteMeeting_meetingDelete_meeting_form_publishedVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
}

export interface DeleteMeeting_meetingDelete_meeting_form_editableVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface DeleteMeeting_meetingDelete_meeting_form_editableVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface DeleteMeeting_meetingDelete_meeting_form_editableVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface DeleteMeeting_meetingDelete_meeting_form_editableVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DeleteMeeting_meetingDelete_meeting_form_editableVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface DeleteMeeting_meetingDelete_meeting_form_editableVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface DeleteMeeting_meetingDelete_meeting_form_editableVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DeleteMeeting_meetingDelete_meeting_form_editableVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type DeleteMeeting_meetingDelete_meeting_form_editableVersion_fields_rules_objectsToAssign = DeleteMeeting_meetingDelete_meeting_form_editableVersion_fields_rules_objectsToAssign_Tag | DeleteMeeting_meetingDelete_meeting_form_editableVersion_fields_rules_objectsToAssign_Audience | DeleteMeeting_meetingDelete_meeting_form_editableVersion_fields_rules_objectsToAssign_Product | DeleteMeeting_meetingDelete_meeting_form_editableVersion_fields_rules_objectsToAssign_Source | DeleteMeeting_meetingDelete_meeting_form_editableVersion_fields_rules_objectsToAssign_Stageset;

export interface DeleteMeeting_meetingDelete_meeting_form_editableVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: DeleteMeeting_meetingDelete_meeting_form_editableVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: DeleteMeeting_meetingDelete_meeting_form_editableVersion_fields_rules_objectsToAssign[];
}

export interface DeleteMeeting_meetingDelete_meeting_form_editableVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: DeleteMeeting_meetingDelete_meeting_form_editableVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: DeleteMeeting_meetingDelete_meeting_form_editableVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: DeleteMeeting_meetingDelete_meeting_form_editableVersion_fields_rules[];
}

export interface DeleteMeeting_meetingDelete_meeting_form_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of fields associated with this web form version
   */
  fields: DeleteMeeting_meetingDelete_meeting_form_editableVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
}

export interface DeleteMeeting_meetingDelete_meeting_form_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface DeleteMeeting_meetingDelete_meeting_form_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteMeeting_meetingDelete_meeting_form_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: DeleteMeeting_meetingDelete_meeting_form_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: DeleteMeeting_meetingDelete_meeting_form_nextSteps_slackMessage_form;
}

export interface DeleteMeeting_meetingDelete_meeting_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface DeleteMeeting_meetingDelete_meeting_form_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type DeleteMeeting_meetingDelete_meeting_form_nextSteps_nutshellNotification_notifiables = DeleteMeeting_meetingDelete_meeting_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias | DeleteMeeting_meetingDelete_meeting_form_nextSteps_nutshellNotification_notifiables_User;

export interface DeleteMeeting_meetingDelete_meeting_form_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteMeeting_meetingDelete_meeting_form_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: DeleteMeeting_meetingDelete_meeting_form_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: DeleteMeeting_meetingDelete_meeting_form_nextSteps_nutshellNotification_form;
}

export interface DeleteMeeting_meetingDelete_meeting_form_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: DeleteMeeting_meetingDelete_meeting_form_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: DeleteMeeting_meetingDelete_meeting_form_nextSteps_nutshellNotification | null;
}

export interface DeleteMeeting_meetingDelete_meeting_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: DeleteMeeting_meetingDelete_meeting_form_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: DeleteMeeting_meetingDelete_meeting_form_publishedVersion | null;
  /**
   * Whether the form has been embedded
   */
  isLiveForm: boolean;
  /**
   * The published form preview url
   */
  publishedFormPreviewUrl: string;
  /**
   * Publicly viewable link to published form
   */
  sharableViewInBrowserLink: string;
  /**
   * Boolean, true if the editable version has any edits
   */
  hasUnpublishedChanges: boolean;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: DeleteMeeting_meetingDelete_meeting_form_editableVersion;
  /**
   * Next step automations for this form
   */
  nextSteps: DeleteMeeting_meetingDelete_meeting_form_nextSteps;
  /**
   * The embed snippet for this form
   */
  embedSnippet: string;
  /**
   * The type of form
   */
  type: FormType;
}

export interface DeleteMeeting_meetingDelete_meeting_bookings {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteMeeting_meetingDelete_meeting_validity_issues_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DeleteMeeting_meetingDelete_meeting_validity_issues {
  __typename: "MeetingValidityIssue";
  /**
   * The user tied to this issue
   */
  user: DeleteMeeting_meetingDelete_meeting_validity_issues_user;
  /**
   * The issue type of this issue
   */
  issueType: ValidityIssueType;
}

export interface DeleteMeeting_meetingDelete_meeting_validity {
  __typename: "MeetingValidity";
  /**
   * A list of issues with host users tied to this meeting
   */
  issues: DeleteMeeting_meetingDelete_meeting_validity_issues[];
  /**
   * Whether this meeting can be booked
   */
  isBookable: boolean;
}

export interface DeleteMeeting_meetingDelete_meeting_assignments_stats {
  __typename: "MaterializedMeetingsStats";
  /**
   * The number of users assigned to this meeting template.
   */
  assignedUsersCount: number;
  /**
   * The number of teams assigned to this meeting template.
   */
  assignedTeamsCount: number;
  /**
   * The number of materialized meetings from this meeting template that have been modified and severed.
   */
  severedCount: number;
}

export interface DeleteMeeting_meetingDelete_meeting_assignments {
  __typename: "MaterializedMeetingsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The number of users assigned to this meeting template.
   */
  stats: DeleteMeeting_meetingDelete_meeting_assignments_stats;
}

export interface DeleteMeeting_meetingDelete_meeting {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Meeting model (used to fetch meeting config)
   */
  modelId: number;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * The type of this meeting
   */
  meetingType: MeetingType;
  /**
   * The description of this meeting
   */
  description: string | null;
  /**
   * Custom text sent to the invitee after booking
   */
  bookingConfirmationMessage: string | null;
  /**
   * The htmlUrl without http:                                            // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl for the template that manages this meeting without http: // app.nutshell.com.
   */
  managedByHtmlUrlPath: string | null;
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number;
  /**
   * The published form preview url
   */
  previewUrl: string;
  /**
   * The minimum notice required to book this meeting
   */
  minNotice: DeleteMeeting_meetingDelete_meeting_minNotice | null;
  /**
   * Buffer before each booking in minutes
   */
  bufferBeforeMins: number | null;
  /**
   * Buffer after each booking in minutes
   */
  bufferAfterMins: number | null;
  /**
   * The activity type for this meeting
   */
  activityType: DeleteMeeting_meetingDelete_meeting_activityType;
  /**
   * The location of this meeting, such as address or phone number
   */
  location: string;
  /**
   * The location type of this meeting
   */
  locationType: MeetingLocationType;
  /**
   * The primary host for this meeting
   */
  creator: DeleteMeeting_meetingDelete_meeting_creator;
  /**
   * The cohosts of this meeting, not including primary host
   */
  cohosts: DeleteMeeting_meetingDelete_meeting_cohosts[];
  /**
   * The possible hosts of this meeting, team members for ROUND_ROBIN, set hosts for other types
   */
  hosts: DeleteMeeting_meetingDelete_meeting_hosts[];
  /**
   * For a ROUND_ROBIN meeting, the selected team
   */
  team: DeleteMeeting_meetingDelete_meeting_team | null;
  /**
   * The availability for this meeting
   */
  availability: DeleteMeeting_meetingDelete_meeting_availability;
  /**
   * Publicly viewable link to the meeting
   */
  publicMeetingLink: string;
  /**
   * Whether this meeting is active
   */
  isActive: boolean;
  /**
   * The activity type for this meeting
   */
  form: DeleteMeeting_meetingDelete_meeting_form;
  /**
   * The bookings of this meeting
   */
  bookings: DeleteMeeting_meetingDelete_meeting_bookings[];
  /**
   * The timestamp this web form was last submitted
   */
  lastBookedTime: any | null;
  /**
   * Show invitees time slots at this interval in minutes
   */
  startTimeIntervalMinutes: number;
  /**
   * The number of times this meeting has been viewed
   */
  numViews: number;
  /**
   * Number of bookings compared to views
   */
  bookingRate: number;
  /**
   * Whether to send a booking confirmation email
   */
  sendConfirmationReminder: boolean;
  /**
   * Whether to send a reminder email one day before the meeting
   */
  sendUpcomingReminder: boolean;
  /**
   * Whether to send a reminder email 30 minutes before the meeting
   */
  sendSoonReminder: boolean;
  /**
   * Whether this meeting spans multiple timezones among primary and co hosts
   */
  spansTimezones: boolean;
  /**
   * The validity of this meeting
   */
  validity: DeleteMeeting_meetingDelete_meeting_validity;
  /**
   * The embed snippet for this meeting
   */
  embedSnippet: string;
  /**
   * The DateTime that represents when the meeting was deleted
   */
  deletedTime: any | null;
  /**
   * Whether to allow additional attendees to be added to the booking
   */
  allowAdditionalAttendees: boolean;
  /**
   * Whether this meeting is hidden from public view or visible on the host users scheduler page
   */
  isHidden: boolean;
  /**
   * Whether this hidden meeting can be made public (all plans can make hidden meetings public)
   */
  isShowable: boolean;
  /**
   * Whether this public meeting can be hidden (requires full scheduler access)
   */
  isHideable: boolean;
  /**
   * The custom URL slug for the meeting
   */
  customSlug: string | null;
  /**
   * The url slug of this meeting
   */
  urlSlug: string;
  /**
   * Whether this meeting is a managed template
   */
  isManagedTemplate: boolean;
  /**
   * Whether this meeting is being managed by a template
   */
  isManagedMeeting: boolean;
  /**
   * Whether this meeting is severed from its template. Always false for non-managed meetings.
   */
  isSevered: boolean;
  /**
   * The users or teams assigned to this meeting template.
   */
  assignments: DeleteMeeting_meetingDelete_meeting_assignments | null;
}

export interface DeleteMeeting_meetingDelete {
  __typename: "MeetingDeletePayload";
  /**
   * The meeting that was deleted.
   */
  meeting: DeleteMeeting_meetingDelete_meeting | null;
}

export interface DeleteMeeting {
  /**
   * Delete a meeting
   */
  meetingDelete: DeleteMeeting_meetingDelete;
}

export interface DeleteMeetingVariables {
  input: MeetingDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DuplicateMeeting
// ====================================================

export interface DuplicateMeeting_meetingDuplicate_meeting_minNotice {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_creator {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
  /**
   * The user’s configured root meeting URL for scheduler
   */
  schedulerRootMeetingsUrl: string;
  /**
   * Whether or not the user has customized their meeting URL
   */
  hasCustomizedMeetingUrl: boolean;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_cohosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_hosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_availability_times {
  __typename: "AvailabilityTime";
  /**
   * The day of this availability time
   */
  day: AvailabilityDay;
  /**
   * The time this duration starts
   */
  startTime: string;
  /**
   * The time this duration ends
   */
  endTime: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_availability {
  __typename: "Availability";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Availability times on monday
   */
  times: DuplicateMeeting_meetingDuplicate_meeting_availability_times[];
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: DuplicateMeeting_meetingDuplicate_meeting_form_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: DuplicateMeeting_meetingDuplicate_meeting_form_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: DuplicateMeeting_meetingDuplicate_meeting_form_createRules_lead_stagesetFieldRules_stageset;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: DuplicateMeeting_meetingDuplicate_meeting_form_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: DuplicateMeeting_meetingDuplicate_meeting_form_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: DuplicateMeeting_meetingDuplicate_meeting_form_createRules_lead_stagesetFieldRules[];
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: DuplicateMeeting_meetingDuplicate_meeting_form_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: DuplicateMeeting_meetingDuplicate_meeting_form_createRules_contact_audiences[];
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: DuplicateMeeting_meetingDuplicate_meeting_form_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: DuplicateMeeting_meetingDuplicate_meeting_form_createRules_lead | null;
  /**
   * The create rules related to a contact
   */
  contact: DuplicateMeeting_meetingDuplicate_meeting_form_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: DuplicateMeeting_meetingDuplicate_meeting_form_createRules_account | null;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_fields_rules_objectsToAssign = DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Tag | DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Audience | DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Product | DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Source | DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Stageset;

export interface DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_fields_rules_objectsToAssign[];
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_fields_rules[];
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_pages[];
  /**
   * Array of fields associated with this web form version
   */
  fields: DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion_fields_rules_objectsToAssign = DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion_fields_rules_objectsToAssign_Tag | DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion_fields_rules_objectsToAssign_Audience | DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion_fields_rules_objectsToAssign_Product | DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion_fields_rules_objectsToAssign_Source | DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion_fields_rules_objectsToAssign_Stageset;

export interface DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion_fields_rules_objectsToAssign[];
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion_fields_rules[];
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of fields associated with this web form version
   */
  fields: DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: DuplicateMeeting_meetingDuplicate_meeting_form_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: DuplicateMeeting_meetingDuplicate_meeting_form_nextSteps_slackMessage_form;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type DuplicateMeeting_meetingDuplicate_meeting_form_nextSteps_nutshellNotification_notifiables = DuplicateMeeting_meetingDuplicate_meeting_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias | DuplicateMeeting_meetingDuplicate_meeting_form_nextSteps_nutshellNotification_notifiables_User;

export interface DuplicateMeeting_meetingDuplicate_meeting_form_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: DuplicateMeeting_meetingDuplicate_meeting_form_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: DuplicateMeeting_meetingDuplicate_meeting_form_nextSteps_nutshellNotification_form;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: DuplicateMeeting_meetingDuplicate_meeting_form_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: DuplicateMeeting_meetingDuplicate_meeting_form_nextSteps_nutshellNotification | null;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: DuplicateMeeting_meetingDuplicate_meeting_form_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: DuplicateMeeting_meetingDuplicate_meeting_form_publishedVersion | null;
  /**
   * Whether the form has been embedded
   */
  isLiveForm: boolean;
  /**
   * The published form preview url
   */
  publishedFormPreviewUrl: string;
  /**
   * Publicly viewable link to published form
   */
  sharableViewInBrowserLink: string;
  /**
   * Boolean, true if the editable version has any edits
   */
  hasUnpublishedChanges: boolean;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: DuplicateMeeting_meetingDuplicate_meeting_form_editableVersion;
  /**
   * Next step automations for this form
   */
  nextSteps: DuplicateMeeting_meetingDuplicate_meeting_form_nextSteps;
  /**
   * The embed snippet for this form
   */
  embedSnippet: string;
  /**
   * The type of form
   */
  type: FormType;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_bookings {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_validity_issues_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_validity_issues {
  __typename: "MeetingValidityIssue";
  /**
   * The user tied to this issue
   */
  user: DuplicateMeeting_meetingDuplicate_meeting_validity_issues_user;
  /**
   * The issue type of this issue
   */
  issueType: ValidityIssueType;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_validity {
  __typename: "MeetingValidity";
  /**
   * A list of issues with host users tied to this meeting
   */
  issues: DuplicateMeeting_meetingDuplicate_meeting_validity_issues[];
  /**
   * Whether this meeting can be booked
   */
  isBookable: boolean;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_assignments_stats {
  __typename: "MaterializedMeetingsStats";
  /**
   * The number of users assigned to this meeting template.
   */
  assignedUsersCount: number;
  /**
   * The number of teams assigned to this meeting template.
   */
  assignedTeamsCount: number;
  /**
   * The number of materialized meetings from this meeting template that have been modified and severed.
   */
  severedCount: number;
}

export interface DuplicateMeeting_meetingDuplicate_meeting_assignments {
  __typename: "MaterializedMeetingsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The number of users assigned to this meeting template.
   */
  stats: DuplicateMeeting_meetingDuplicate_meeting_assignments_stats;
}

export interface DuplicateMeeting_meetingDuplicate_meeting {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Meeting model (used to fetch meeting config)
   */
  modelId: number;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * The type of this meeting
   */
  meetingType: MeetingType;
  /**
   * The description of this meeting
   */
  description: string | null;
  /**
   * Custom text sent to the invitee after booking
   */
  bookingConfirmationMessage: string | null;
  /**
   * The htmlUrl without http:                                            // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl for the template that manages this meeting without http: // app.nutshell.com.
   */
  managedByHtmlUrlPath: string | null;
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number;
  /**
   * The published form preview url
   */
  previewUrl: string;
  /**
   * The minimum notice required to book this meeting
   */
  minNotice: DuplicateMeeting_meetingDuplicate_meeting_minNotice | null;
  /**
   * Buffer before each booking in minutes
   */
  bufferBeforeMins: number | null;
  /**
   * Buffer after each booking in minutes
   */
  bufferAfterMins: number | null;
  /**
   * The activity type for this meeting
   */
  activityType: DuplicateMeeting_meetingDuplicate_meeting_activityType;
  /**
   * The location of this meeting, such as address or phone number
   */
  location: string;
  /**
   * The location type of this meeting
   */
  locationType: MeetingLocationType;
  /**
   * The primary host for this meeting
   */
  creator: DuplicateMeeting_meetingDuplicate_meeting_creator;
  /**
   * The cohosts of this meeting, not including primary host
   */
  cohosts: DuplicateMeeting_meetingDuplicate_meeting_cohosts[];
  /**
   * The possible hosts of this meeting, team members for ROUND_ROBIN, set hosts for other types
   */
  hosts: DuplicateMeeting_meetingDuplicate_meeting_hosts[];
  /**
   * For a ROUND_ROBIN meeting, the selected team
   */
  team: DuplicateMeeting_meetingDuplicate_meeting_team | null;
  /**
   * The availability for this meeting
   */
  availability: DuplicateMeeting_meetingDuplicate_meeting_availability;
  /**
   * Publicly viewable link to the meeting
   */
  publicMeetingLink: string;
  /**
   * Whether this meeting is active
   */
  isActive: boolean;
  /**
   * The activity type for this meeting
   */
  form: DuplicateMeeting_meetingDuplicate_meeting_form;
  /**
   * The bookings of this meeting
   */
  bookings: DuplicateMeeting_meetingDuplicate_meeting_bookings[];
  /**
   * The timestamp this web form was last submitted
   */
  lastBookedTime: any | null;
  /**
   * Show invitees time slots at this interval in minutes
   */
  startTimeIntervalMinutes: number;
  /**
   * The number of times this meeting has been viewed
   */
  numViews: number;
  /**
   * Number of bookings compared to views
   */
  bookingRate: number;
  /**
   * Whether to send a booking confirmation email
   */
  sendConfirmationReminder: boolean;
  /**
   * Whether to send a reminder email one day before the meeting
   */
  sendUpcomingReminder: boolean;
  /**
   * Whether to send a reminder email 30 minutes before the meeting
   */
  sendSoonReminder: boolean;
  /**
   * Whether this meeting spans multiple timezones among primary and co hosts
   */
  spansTimezones: boolean;
  /**
   * The validity of this meeting
   */
  validity: DuplicateMeeting_meetingDuplicate_meeting_validity;
  /**
   * The embed snippet for this meeting
   */
  embedSnippet: string;
  /**
   * The DateTime that represents when the meeting was deleted
   */
  deletedTime: any | null;
  /**
   * Whether to allow additional attendees to be added to the booking
   */
  allowAdditionalAttendees: boolean;
  /**
   * Whether this meeting is hidden from public view or visible on the host users scheduler page
   */
  isHidden: boolean;
  /**
   * Whether this hidden meeting can be made public (all plans can make hidden meetings public)
   */
  isShowable: boolean;
  /**
   * Whether this public meeting can be hidden (requires full scheduler access)
   */
  isHideable: boolean;
  /**
   * The custom URL slug for the meeting
   */
  customSlug: string | null;
  /**
   * The url slug of this meeting
   */
  urlSlug: string;
  /**
   * Whether this meeting is a managed template
   */
  isManagedTemplate: boolean;
  /**
   * Whether this meeting is being managed by a template
   */
  isManagedMeeting: boolean;
  /**
   * Whether this meeting is severed from its template. Always false for non-managed meetings.
   */
  isSevered: boolean;
  /**
   * The users or teams assigned to this meeting template.
   */
  assignments: DuplicateMeeting_meetingDuplicate_meeting_assignments | null;
}

export interface DuplicateMeeting_meetingDuplicate {
  __typename: "MeetingDuplicatePayload";
  /**
   * The newly copied Nutshell meeting.
   */
  meeting: DuplicateMeeting_meetingDuplicate_meeting;
}

export interface DuplicateMeeting {
  /**
   * Creates a deep copy of a Nutshell Meeting
   */
  meetingDuplicate: DuplicateMeeting_meetingDuplicate;
}

export interface DuplicateMeetingVariables {
  input: MeetingDuplicateInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetAvailability
// ====================================================

export interface SetAvailability_availabilitySet_availability_times {
  __typename: "AvailabilityTime";
  /**
   * The day of this availability time
   */
  day: AvailabilityDay;
  /**
   * The time this duration starts
   */
  startTime: string;
  /**
   * The time this duration ends
   */
  endTime: string;
}

export interface SetAvailability_availabilitySet_availability {
  __typename: "Availability";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Availability times on monday
   */
  times: SetAvailability_availabilitySet_availability_times[];
}

export interface SetAvailability_availabilitySet {
  __typename: "AvailabilitySetPayload";
  /**
   * The updated availability.
   */
  availability: SetAvailability_availabilitySet_availability | null;
}

export interface SetAvailability {
  /**
   * Updates an availability
   */
  availabilitySet: SetAvailability_availabilitySet;
}

export interface SetAvailabilityVariables {
  input: AvailabilitySetInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UndeleteMeeting
// ====================================================

export interface UndeleteMeeting_meetingUndelete_meeting_minNotice {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface UndeleteMeeting_meetingUndelete_meeting_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_creator {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
  /**
   * The user’s configured root meeting URL for scheduler
   */
  schedulerRootMeetingsUrl: string;
  /**
   * Whether or not the user has customized their meeting URL
   */
  hasCustomizedMeetingUrl: boolean;
}

export interface UndeleteMeeting_meetingUndelete_meeting_cohosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_hosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_availability_times {
  __typename: "AvailabilityTime";
  /**
   * The day of this availability time
   */
  day: AvailabilityDay;
  /**
   * The time this duration starts
   */
  startTime: string;
  /**
   * The time this duration ends
   */
  endTime: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_availability {
  __typename: "Availability";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Availability times on monday
   */
  times: UndeleteMeeting_meetingUndelete_meeting_availability_times[];
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: UndeleteMeeting_meetingUndelete_meeting_form_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: UndeleteMeeting_meetingUndelete_meeting_form_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: UndeleteMeeting_meetingUndelete_meeting_form_createRules_lead_stagesetFieldRules_stageset;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: UndeleteMeeting_meetingUndelete_meeting_form_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: UndeleteMeeting_meetingUndelete_meeting_form_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: UndeleteMeeting_meetingUndelete_meeting_form_createRules_lead_stagesetFieldRules[];
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: UndeleteMeeting_meetingUndelete_meeting_form_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: UndeleteMeeting_meetingUndelete_meeting_form_createRules_contact_audiences[];
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: UndeleteMeeting_meetingUndelete_meeting_form_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: UndeleteMeeting_meetingUndelete_meeting_form_createRules_lead | null;
  /**
   * The create rules related to a contact
   */
  contact: UndeleteMeeting_meetingUndelete_meeting_form_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: UndeleteMeeting_meetingUndelete_meeting_form_createRules_account | null;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_fields_rules_objectsToAssign = UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_fields_rules_objectsToAssign_Tag | UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_fields_rules_objectsToAssign_Audience | UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_fields_rules_objectsToAssign_Product | UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_fields_rules_objectsToAssign_Source | UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_fields_rules_objectsToAssign_Stageset;

export interface UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_fields_rules_objectsToAssign[];
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_fields_rules[];
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_pages[];
  /**
   * Array of fields associated with this web form version
   */
  fields: UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_editableVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_editableVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_editableVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_editableVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_editableVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_editableVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_editableVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_editableVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type UndeleteMeeting_meetingUndelete_meeting_form_editableVersion_fields_rules_objectsToAssign = UndeleteMeeting_meetingUndelete_meeting_form_editableVersion_fields_rules_objectsToAssign_Tag | UndeleteMeeting_meetingUndelete_meeting_form_editableVersion_fields_rules_objectsToAssign_Audience | UndeleteMeeting_meetingUndelete_meeting_form_editableVersion_fields_rules_objectsToAssign_Product | UndeleteMeeting_meetingUndelete_meeting_form_editableVersion_fields_rules_objectsToAssign_Source | UndeleteMeeting_meetingUndelete_meeting_form_editableVersion_fields_rules_objectsToAssign_Stageset;

export interface UndeleteMeeting_meetingUndelete_meeting_form_editableVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: UndeleteMeeting_meetingUndelete_meeting_form_editableVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: UndeleteMeeting_meetingUndelete_meeting_form_editableVersion_fields_rules_objectsToAssign[];
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_editableVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: UndeleteMeeting_meetingUndelete_meeting_form_editableVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: UndeleteMeeting_meetingUndelete_meeting_form_editableVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: UndeleteMeeting_meetingUndelete_meeting_form_editableVersion_fields_rules[];
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of fields associated with this web form version
   */
  fields: UndeleteMeeting_meetingUndelete_meeting_form_editableVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: UndeleteMeeting_meetingUndelete_meeting_form_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: UndeleteMeeting_meetingUndelete_meeting_form_nextSteps_slackMessage_form;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type UndeleteMeeting_meetingUndelete_meeting_form_nextSteps_nutshellNotification_notifiables = UndeleteMeeting_meetingUndelete_meeting_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias | UndeleteMeeting_meetingUndelete_meeting_form_nextSteps_nutshellNotification_notifiables_User;

export interface UndeleteMeeting_meetingUndelete_meeting_form_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: UndeleteMeeting_meetingUndelete_meeting_form_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: UndeleteMeeting_meetingUndelete_meeting_form_nextSteps_nutshellNotification_form;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: UndeleteMeeting_meetingUndelete_meeting_form_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: UndeleteMeeting_meetingUndelete_meeting_form_nextSteps_nutshellNotification | null;
}

export interface UndeleteMeeting_meetingUndelete_meeting_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: UndeleteMeeting_meetingUndelete_meeting_form_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: UndeleteMeeting_meetingUndelete_meeting_form_publishedVersion | null;
  /**
   * Whether the form has been embedded
   */
  isLiveForm: boolean;
  /**
   * The published form preview url
   */
  publishedFormPreviewUrl: string;
  /**
   * Publicly viewable link to published form
   */
  sharableViewInBrowserLink: string;
  /**
   * Boolean, true if the editable version has any edits
   */
  hasUnpublishedChanges: boolean;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: UndeleteMeeting_meetingUndelete_meeting_form_editableVersion;
  /**
   * Next step automations for this form
   */
  nextSteps: UndeleteMeeting_meetingUndelete_meeting_form_nextSteps;
  /**
   * The embed snippet for this form
   */
  embedSnippet: string;
  /**
   * The type of form
   */
  type: FormType;
}

export interface UndeleteMeeting_meetingUndelete_meeting_bookings {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_validity_issues_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UndeleteMeeting_meetingUndelete_meeting_validity_issues {
  __typename: "MeetingValidityIssue";
  /**
   * The user tied to this issue
   */
  user: UndeleteMeeting_meetingUndelete_meeting_validity_issues_user;
  /**
   * The issue type of this issue
   */
  issueType: ValidityIssueType;
}

export interface UndeleteMeeting_meetingUndelete_meeting_validity {
  __typename: "MeetingValidity";
  /**
   * A list of issues with host users tied to this meeting
   */
  issues: UndeleteMeeting_meetingUndelete_meeting_validity_issues[];
  /**
   * Whether this meeting can be booked
   */
  isBookable: boolean;
}

export interface UndeleteMeeting_meetingUndelete_meeting_assignments_stats {
  __typename: "MaterializedMeetingsStats";
  /**
   * The number of users assigned to this meeting template.
   */
  assignedUsersCount: number;
  /**
   * The number of teams assigned to this meeting template.
   */
  assignedTeamsCount: number;
  /**
   * The number of materialized meetings from this meeting template that have been modified and severed.
   */
  severedCount: number;
}

export interface UndeleteMeeting_meetingUndelete_meeting_assignments {
  __typename: "MaterializedMeetingsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The number of users assigned to this meeting template.
   */
  stats: UndeleteMeeting_meetingUndelete_meeting_assignments_stats;
}

export interface UndeleteMeeting_meetingUndelete_meeting {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Meeting model (used to fetch meeting config)
   */
  modelId: number;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * The type of this meeting
   */
  meetingType: MeetingType;
  /**
   * The description of this meeting
   */
  description: string | null;
  /**
   * Custom text sent to the invitee after booking
   */
  bookingConfirmationMessage: string | null;
  /**
   * The htmlUrl without http:                                            // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl for the template that manages this meeting without http: // app.nutshell.com.
   */
  managedByHtmlUrlPath: string | null;
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number;
  /**
   * The published form preview url
   */
  previewUrl: string;
  /**
   * The minimum notice required to book this meeting
   */
  minNotice: UndeleteMeeting_meetingUndelete_meeting_minNotice | null;
  /**
   * Buffer before each booking in minutes
   */
  bufferBeforeMins: number | null;
  /**
   * Buffer after each booking in minutes
   */
  bufferAfterMins: number | null;
  /**
   * The activity type for this meeting
   */
  activityType: UndeleteMeeting_meetingUndelete_meeting_activityType;
  /**
   * The location of this meeting, such as address or phone number
   */
  location: string;
  /**
   * The location type of this meeting
   */
  locationType: MeetingLocationType;
  /**
   * The primary host for this meeting
   */
  creator: UndeleteMeeting_meetingUndelete_meeting_creator;
  /**
   * The cohosts of this meeting, not including primary host
   */
  cohosts: UndeleteMeeting_meetingUndelete_meeting_cohosts[];
  /**
   * The possible hosts of this meeting, team members for ROUND_ROBIN, set hosts for other types
   */
  hosts: UndeleteMeeting_meetingUndelete_meeting_hosts[];
  /**
   * For a ROUND_ROBIN meeting, the selected team
   */
  team: UndeleteMeeting_meetingUndelete_meeting_team | null;
  /**
   * The availability for this meeting
   */
  availability: UndeleteMeeting_meetingUndelete_meeting_availability;
  /**
   * Publicly viewable link to the meeting
   */
  publicMeetingLink: string;
  /**
   * Whether this meeting is active
   */
  isActive: boolean;
  /**
   * The activity type for this meeting
   */
  form: UndeleteMeeting_meetingUndelete_meeting_form;
  /**
   * The bookings of this meeting
   */
  bookings: UndeleteMeeting_meetingUndelete_meeting_bookings[];
  /**
   * The timestamp this web form was last submitted
   */
  lastBookedTime: any | null;
  /**
   * Show invitees time slots at this interval in minutes
   */
  startTimeIntervalMinutes: number;
  /**
   * The number of times this meeting has been viewed
   */
  numViews: number;
  /**
   * Number of bookings compared to views
   */
  bookingRate: number;
  /**
   * Whether to send a booking confirmation email
   */
  sendConfirmationReminder: boolean;
  /**
   * Whether to send a reminder email one day before the meeting
   */
  sendUpcomingReminder: boolean;
  /**
   * Whether to send a reminder email 30 minutes before the meeting
   */
  sendSoonReminder: boolean;
  /**
   * Whether this meeting spans multiple timezones among primary and co hosts
   */
  spansTimezones: boolean;
  /**
   * The validity of this meeting
   */
  validity: UndeleteMeeting_meetingUndelete_meeting_validity;
  /**
   * The embed snippet for this meeting
   */
  embedSnippet: string;
  /**
   * The DateTime that represents when the meeting was deleted
   */
  deletedTime: any | null;
  /**
   * Whether to allow additional attendees to be added to the booking
   */
  allowAdditionalAttendees: boolean;
  /**
   * Whether this meeting is hidden from public view or visible on the host users scheduler page
   */
  isHidden: boolean;
  /**
   * Whether this hidden meeting can be made public (all plans can make hidden meetings public)
   */
  isShowable: boolean;
  /**
   * Whether this public meeting can be hidden (requires full scheduler access)
   */
  isHideable: boolean;
  /**
   * The custom URL slug for the meeting
   */
  customSlug: string | null;
  /**
   * The url slug of this meeting
   */
  urlSlug: string;
  /**
   * Whether this meeting is a managed template
   */
  isManagedTemplate: boolean;
  /**
   * Whether this meeting is being managed by a template
   */
  isManagedMeeting: boolean;
  /**
   * Whether this meeting is severed from its template. Always false for non-managed meetings.
   */
  isSevered: boolean;
  /**
   * The users or teams assigned to this meeting template.
   */
  assignments: UndeleteMeeting_meetingUndelete_meeting_assignments | null;
}

export interface UndeleteMeeting_meetingUndelete {
  __typename: "MeetingUndeletePayload";
  /**
   * The freshly updated meeting.
   */
  meeting: UndeleteMeeting_meetingUndelete_meeting;
}

export interface UndeleteMeeting {
  /**
   * Undeletes (restores) a scheduler meeting
   */
  meetingUndelete: UndeleteMeeting_meetingUndelete;
}

export interface UndeleteMeetingVariables {
  input: MeetingUndeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateMeeting
// ====================================================

export interface UpdateMeeting_meetingUpdate_meeting_minNotice {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface UpdateMeeting_meetingUpdate_meeting_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_creator {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
  /**
   * The user’s configured root meeting URL for scheduler
   */
  schedulerRootMeetingsUrl: string;
  /**
   * Whether or not the user has customized their meeting URL
   */
  hasCustomizedMeetingUrl: boolean;
}

export interface UpdateMeeting_meetingUpdate_meeting_cohosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_hosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_availability_times {
  __typename: "AvailabilityTime";
  /**
   * The day of this availability time
   */
  day: AvailabilityDay;
  /**
   * The time this duration starts
   */
  startTime: string;
  /**
   * The time this duration ends
   */
  endTime: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_availability {
  __typename: "Availability";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Availability times on monday
   */
  times: UpdateMeeting_meetingUpdate_meeting_availability_times[];
}

export interface UpdateMeeting_meetingUpdate_meeting_form_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: UpdateMeeting_meetingUpdate_meeting_form_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: UpdateMeeting_meetingUpdate_meeting_form_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: UpdateMeeting_meetingUpdate_meeting_form_createRules_lead_stagesetFieldRules_stageset;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: UpdateMeeting_meetingUpdate_meeting_form_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: UpdateMeeting_meetingUpdate_meeting_form_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: UpdateMeeting_meetingUpdate_meeting_form_createRules_lead_stagesetFieldRules[];
}

export interface UpdateMeeting_meetingUpdate_meeting_form_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: UpdateMeeting_meetingUpdate_meeting_form_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: UpdateMeeting_meetingUpdate_meeting_form_createRules_contact_audiences[];
}

export interface UpdateMeeting_meetingUpdate_meeting_form_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: UpdateMeeting_meetingUpdate_meeting_form_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: UpdateMeeting_meetingUpdate_meeting_form_createRules_lead | null;
  /**
   * The create rules related to a contact
   */
  contact: UpdateMeeting_meetingUpdate_meeting_form_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: UpdateMeeting_meetingUpdate_meeting_form_createRules_account | null;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_fields_rules_objectsToAssign = UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Tag | UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Audience | UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Product | UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Source | UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Stageset;

export interface UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_fields_rules_objectsToAssign[];
}

export interface UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_fields_rules[];
}

export interface UpdateMeeting_meetingUpdate_meeting_form_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_pages[];
  /**
   * Array of fields associated with this web form version
   */
  fields: UpdateMeeting_meetingUpdate_meeting_form_publishedVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_editableVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_editableVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_editableVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_editableVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_editableVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_editableVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_editableVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_editableVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type UpdateMeeting_meetingUpdate_meeting_form_editableVersion_fields_rules_objectsToAssign = UpdateMeeting_meetingUpdate_meeting_form_editableVersion_fields_rules_objectsToAssign_Tag | UpdateMeeting_meetingUpdate_meeting_form_editableVersion_fields_rules_objectsToAssign_Audience | UpdateMeeting_meetingUpdate_meeting_form_editableVersion_fields_rules_objectsToAssign_Product | UpdateMeeting_meetingUpdate_meeting_form_editableVersion_fields_rules_objectsToAssign_Source | UpdateMeeting_meetingUpdate_meeting_form_editableVersion_fields_rules_objectsToAssign_Stageset;

export interface UpdateMeeting_meetingUpdate_meeting_form_editableVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: UpdateMeeting_meetingUpdate_meeting_form_editableVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: UpdateMeeting_meetingUpdate_meeting_form_editableVersion_fields_rules_objectsToAssign[];
}

export interface UpdateMeeting_meetingUpdate_meeting_form_editableVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: UpdateMeeting_meetingUpdate_meeting_form_editableVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: UpdateMeeting_meetingUpdate_meeting_form_editableVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: UpdateMeeting_meetingUpdate_meeting_form_editableVersion_fields_rules[];
}

export interface UpdateMeeting_meetingUpdate_meeting_form_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of fields associated with this web form version
   */
  fields: UpdateMeeting_meetingUpdate_meeting_form_editableVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: UpdateMeeting_meetingUpdate_meeting_form_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: UpdateMeeting_meetingUpdate_meeting_form_nextSteps_slackMessage_form;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface UpdateMeeting_meetingUpdate_meeting_form_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type UpdateMeeting_meetingUpdate_meeting_form_nextSteps_nutshellNotification_notifiables = UpdateMeeting_meetingUpdate_meeting_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias | UpdateMeeting_meetingUpdate_meeting_form_nextSteps_nutshellNotification_notifiables_User;

export interface UpdateMeeting_meetingUpdate_meeting_form_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: UpdateMeeting_meetingUpdate_meeting_form_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: UpdateMeeting_meetingUpdate_meeting_form_nextSteps_nutshellNotification_form;
}

export interface UpdateMeeting_meetingUpdate_meeting_form_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: UpdateMeeting_meetingUpdate_meeting_form_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: UpdateMeeting_meetingUpdate_meeting_form_nextSteps_nutshellNotification | null;
}

export interface UpdateMeeting_meetingUpdate_meeting_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: UpdateMeeting_meetingUpdate_meeting_form_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: UpdateMeeting_meetingUpdate_meeting_form_publishedVersion | null;
  /**
   * Whether the form has been embedded
   */
  isLiveForm: boolean;
  /**
   * The published form preview url
   */
  publishedFormPreviewUrl: string;
  /**
   * Publicly viewable link to published form
   */
  sharableViewInBrowserLink: string;
  /**
   * Boolean, true if the editable version has any edits
   */
  hasUnpublishedChanges: boolean;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: UpdateMeeting_meetingUpdate_meeting_form_editableVersion;
  /**
   * Next step automations for this form
   */
  nextSteps: UpdateMeeting_meetingUpdate_meeting_form_nextSteps;
  /**
   * The embed snippet for this form
   */
  embedSnippet: string;
  /**
   * The type of form
   */
  type: FormType;
}

export interface UpdateMeeting_meetingUpdate_meeting_bookings {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_validity_issues_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UpdateMeeting_meetingUpdate_meeting_validity_issues {
  __typename: "MeetingValidityIssue";
  /**
   * The user tied to this issue
   */
  user: UpdateMeeting_meetingUpdate_meeting_validity_issues_user;
  /**
   * The issue type of this issue
   */
  issueType: ValidityIssueType;
}

export interface UpdateMeeting_meetingUpdate_meeting_validity {
  __typename: "MeetingValidity";
  /**
   * A list of issues with host users tied to this meeting
   */
  issues: UpdateMeeting_meetingUpdate_meeting_validity_issues[];
  /**
   * Whether this meeting can be booked
   */
  isBookable: boolean;
}

export interface UpdateMeeting_meetingUpdate_meeting_assignments_stats {
  __typename: "MaterializedMeetingsStats";
  /**
   * The number of users assigned to this meeting template.
   */
  assignedUsersCount: number;
  /**
   * The number of teams assigned to this meeting template.
   */
  assignedTeamsCount: number;
  /**
   * The number of materialized meetings from this meeting template that have been modified and severed.
   */
  severedCount: number;
}

export interface UpdateMeeting_meetingUpdate_meeting_assignments {
  __typename: "MaterializedMeetingsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The number of users assigned to this meeting template.
   */
  stats: UpdateMeeting_meetingUpdate_meeting_assignments_stats;
}

export interface UpdateMeeting_meetingUpdate_meeting {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Meeting model (used to fetch meeting config)
   */
  modelId: number;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * The type of this meeting
   */
  meetingType: MeetingType;
  /**
   * The description of this meeting
   */
  description: string | null;
  /**
   * Custom text sent to the invitee after booking
   */
  bookingConfirmationMessage: string | null;
  /**
   * The htmlUrl without http:                                            // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl for the template that manages this meeting without http: // app.nutshell.com.
   */
  managedByHtmlUrlPath: string | null;
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number;
  /**
   * The published form preview url
   */
  previewUrl: string;
  /**
   * The minimum notice required to book this meeting
   */
  minNotice: UpdateMeeting_meetingUpdate_meeting_minNotice | null;
  /**
   * Buffer before each booking in minutes
   */
  bufferBeforeMins: number | null;
  /**
   * Buffer after each booking in minutes
   */
  bufferAfterMins: number | null;
  /**
   * The activity type for this meeting
   */
  activityType: UpdateMeeting_meetingUpdate_meeting_activityType;
  /**
   * The location of this meeting, such as address or phone number
   */
  location: string;
  /**
   * The location type of this meeting
   */
  locationType: MeetingLocationType;
  /**
   * The primary host for this meeting
   */
  creator: UpdateMeeting_meetingUpdate_meeting_creator;
  /**
   * The cohosts of this meeting, not including primary host
   */
  cohosts: UpdateMeeting_meetingUpdate_meeting_cohosts[];
  /**
   * The possible hosts of this meeting, team members for ROUND_ROBIN, set hosts for other types
   */
  hosts: UpdateMeeting_meetingUpdate_meeting_hosts[];
  /**
   * For a ROUND_ROBIN meeting, the selected team
   */
  team: UpdateMeeting_meetingUpdate_meeting_team | null;
  /**
   * The availability for this meeting
   */
  availability: UpdateMeeting_meetingUpdate_meeting_availability;
  /**
   * Publicly viewable link to the meeting
   */
  publicMeetingLink: string;
  /**
   * Whether this meeting is active
   */
  isActive: boolean;
  /**
   * The activity type for this meeting
   */
  form: UpdateMeeting_meetingUpdate_meeting_form;
  /**
   * The bookings of this meeting
   */
  bookings: UpdateMeeting_meetingUpdate_meeting_bookings[];
  /**
   * The timestamp this web form was last submitted
   */
  lastBookedTime: any | null;
  /**
   * Show invitees time slots at this interval in minutes
   */
  startTimeIntervalMinutes: number;
  /**
   * The number of times this meeting has been viewed
   */
  numViews: number;
  /**
   * Number of bookings compared to views
   */
  bookingRate: number;
  /**
   * Whether to send a booking confirmation email
   */
  sendConfirmationReminder: boolean;
  /**
   * Whether to send a reminder email one day before the meeting
   */
  sendUpcomingReminder: boolean;
  /**
   * Whether to send a reminder email 30 minutes before the meeting
   */
  sendSoonReminder: boolean;
  /**
   * Whether this meeting spans multiple timezones among primary and co hosts
   */
  spansTimezones: boolean;
  /**
   * The validity of this meeting
   */
  validity: UpdateMeeting_meetingUpdate_meeting_validity;
  /**
   * The embed snippet for this meeting
   */
  embedSnippet: string;
  /**
   * The DateTime that represents when the meeting was deleted
   */
  deletedTime: any | null;
  /**
   * Whether to allow additional attendees to be added to the booking
   */
  allowAdditionalAttendees: boolean;
  /**
   * Whether this meeting is hidden from public view or visible on the host users scheduler page
   */
  isHidden: boolean;
  /**
   * Whether this hidden meeting can be made public (all plans can make hidden meetings public)
   */
  isShowable: boolean;
  /**
   * Whether this public meeting can be hidden (requires full scheduler access)
   */
  isHideable: boolean;
  /**
   * The custom URL slug for the meeting
   */
  customSlug: string | null;
  /**
   * The url slug of this meeting
   */
  urlSlug: string;
  /**
   * Whether this meeting is a managed template
   */
  isManagedTemplate: boolean;
  /**
   * Whether this meeting is being managed by a template
   */
  isManagedMeeting: boolean;
  /**
   * Whether this meeting is severed from its template. Always false for non-managed meetings.
   */
  isSevered: boolean;
  /**
   * The users or teams assigned to this meeting template.
   */
  assignments: UpdateMeeting_meetingUpdate_meeting_assignments | null;
}

export interface UpdateMeeting_meetingUpdate {
  __typename: "MeetingUpdatePayload";
  /**
   * The updated meeting.
   */
  meeting: UpdateMeeting_meetingUpdate_meeting | null;
}

export interface UpdateMeeting {
  /**
   * Updates basic info about a Scheduler meeting – see AvailabilitySet for updating meeting availability
   */
  meetingUpdate: UpdateMeeting_meetingUpdate;
}

export interface UpdateMeetingVariables {
  input: MeetingUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateSchedulerPageConfig
// ====================================================

export interface UpdateSchedulerPageConfig_schedulerPageConfigUpdate_pageConfig_fromDomain {
  __typename: "Subdomain";
  /**
   * The ID of the em_from_domain row this record corresponds to, as each domain is split into multiple rows
   */
  fromDomainId: string;
  /**
   * The record of this DNS record
   */
  record: string;
  /**
   * The record of this DNS record
   */
  formattedRecord: string;
  /**
   * Where this subdomain is verified
   */
  isVerified: boolean;
}

export interface UpdateSchedulerPageConfig_schedulerPageConfigUpdate_pageConfig_defaultFromDomain {
  __typename: "Subdomain";
  /**
   * The ID of the em_from_domain row this record corresponds to, as each domain is split into multiple rows
   */
  fromDomainId: string;
  /**
   * The record of this DNS record
   */
  record: string;
  /**
   * The record of this DNS record
   */
  formattedRecord: string;
  /**
   * Where this subdomain is verified
   */
  isVerified: boolean;
}

export interface UpdateSchedulerPageConfig_schedulerPageConfigUpdate_pageConfig_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user’s configured root meeting URL for scheduler
   */
  schedulerRootMeetingsUrl: string;
}

export interface UpdateSchedulerPageConfig_schedulerPageConfigUpdate_pageConfig {
  __typename: "PageConfig";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether the user avatar should should be used on the scheduler page
   */
  useAvatar: boolean;
  /**
   * Whether the company logo should be used on the scheduler page
   */
  useCompanyLogo: boolean;
  /**
   * The path to the user’s scheduler page
   */
  userSlug: string | null;
  /**
   * The from domain of this PageConfig
   */
  fromDomain: UpdateSchedulerPageConfig_schedulerPageConfigUpdate_pageConfig_fromDomain | null;
  defaultUserSlug: string;
  defaultFromDomain: UpdateSchedulerPageConfig_schedulerPageConfigUpdate_pageConfig_defaultFromDomain;
  /**
   * The embed snippet for this user’s meetings page
   */
  embedSnippet: string;
  /**
   * The user connected to this PageConfig
   */
  user: UpdateSchedulerPageConfig_schedulerPageConfigUpdate_pageConfig_user;
}

export interface UpdateSchedulerPageConfig_schedulerPageConfigUpdate {
  __typename: "PageConfigUpdatePayload";
  /**
   * The page config that was updated.
   */
  pageConfig: UpdateSchedulerPageConfig_schedulerPageConfigUpdate_pageConfig | null;
}

export interface UpdateSchedulerPageConfig {
  /**
   * Update a user’s scheduler config
   */
  schedulerPageConfigUpdate: UpdateSchedulerPageConfig_schedulerPageConfigUpdate;
}

export interface UpdateSchedulerPageConfigVariables {
  input: PageConfigUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBookings
// ====================================================

export interface GetBookings_bookings_pageInfo {
  __typename: "PageInfo";
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor: string | null;
  endCursor: string | null;
}

export interface GetBookings_bookings_edges_node_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface GetBookings_bookings_edges_node_meeting {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of this meeting
   */
  meetingType: MeetingType;
}

export interface GetBookings_bookings_edges_node_formSubmission_primaryEntity_Lead {
  __typename: "Lead";
}

export interface GetBookings_bookings_edges_node_formSubmission_primaryEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetBookings_bookings_edges_node_formSubmission_primaryEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export type GetBookings_bookings_edges_node_formSubmission_primaryEntity = GetBookings_bookings_edges_node_formSubmission_primaryEntity_Lead | GetBookings_bookings_edges_node_formSubmission_primaryEntity_Account | GetBookings_bookings_edges_node_formSubmission_primaryEntity_Contact;

export interface GetBookings_bookings_edges_node_formSubmission_formVersion_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetBookings_bookings_edges_node_formSubmission_formVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent form of this form version
   */
  form: GetBookings_bookings_edges_node_formSubmission_formVersion_form;
}

export interface GetBookings_bookings_edges_node_formSubmission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface GetBookings_bookings_edges_node_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
}

export interface GetBookings_bookings_edges_node_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface GetBookings_bookings_edges_node_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export type GetBookings_bookings_edges_node_formSubmission_fields_edges_fieldValue = GetBookings_bookings_edges_node_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields | GetBookings_bookings_edges_node_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | GetBookings_bookings_edges_node_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueSingle;

export interface GetBookings_bookings_edges_node_formSubmission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: GetBookings_bookings_edges_node_formSubmission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: GetBookings_bookings_edges_node_formSubmission_fields_edges_fieldValue | null;
}

export interface GetBookings_bookings_edges_node_formSubmission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: GetBookings_bookings_edges_node_formSubmission_fields_edges[];
}

export interface GetBookings_bookings_edges_node_formSubmission {
  __typename: "Submission";
  /**
   * The primary entity on the submission
   */
  primaryEntity: GetBookings_bookings_edges_node_formSubmission_primaryEntity | null;
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The url where the submission originates
   */
  submissionUrl: string;
  /**
   * The name of the submitted web form
   */
  formVersion: GetBookings_bookings_edges_node_formSubmission_formVersion;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: GetBookings_bookings_edges_node_formSubmission_fields;
}

export interface GetBookings_bookings_edges_node_hostUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The user’s configured timezone
   */
  timezone: string;
}

export interface GetBookings_bookings_edges_node {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of the booking
   */
  status: BookingStatus;
  /**
   * The URL for rescheduling a booking
   */
  rescheduleUrl: string;
  /**
   * The activity associated with this booking
   */
  activity: GetBookings_bookings_edges_node_activity | null;
  /**
   * The meeting connected to this booking
   */
  meeting: GetBookings_bookings_edges_node_meeting;
  /**
   * The form submission associated with this booking
   */
  formSubmission: GetBookings_bookings_edges_node_formSubmission | null;
  /**
   * The start time of this booking
   */
  startTime: any;
  /**
   * The created time of this booking
   */
  createdTime: any;
  /**
   * The host user of this booking
   */
  hostUser: GetBookings_bookings_edges_node_hostUser | null;
}

export interface GetBookings_bookings_edges {
  __typename: "BookingEdge";
  node: GetBookings_bookings_edges_node;
}

export interface GetBookings_bookings {
  __typename: "BookingsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetBookings_bookings_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetBookings_bookings_edges[];
}

export interface GetBookings {
  /**
   * Returns a list of scheduler bookings
   */
  bookings: GetBookings_bookings;
}

export interface GetBookingsVariables {
  input: BookingsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetManagedMeetingsTemplates
// ====================================================

export interface GetManagedMeetingsTemplates_managedMeetings_activityType {
  __typename: "ActivityType";
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetManagedMeetingsTemplates_managedMeetings_assignments_edges_meetings {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * Whether this meeting is severed from its template. Always false for non-managed meetings.
   */
  isSevered: boolean;
}

export interface GetManagedMeetingsTemplates_managedMeetings_assignments_edges_node_assigneeEntity {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetManagedMeetingsTemplates_managedMeetings_assignments_edges_node {
  __typename: "Assignment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity to which the assignment was made
   */
  assigneeEntity: GetManagedMeetingsTemplates_managedMeetings_assignments_edges_node_assigneeEntity;
}

export interface GetManagedMeetingsTemplates_managedMeetings_assignments_edges {
  __typename: "MaterializedMeetingsEdge";
  /**
   * The materialized meetings.
   */
  meetings: GetManagedMeetingsTemplates_managedMeetings_assignments_edges_meetings[];
  node: GetManagedMeetingsTemplates_managedMeetings_assignments_edges_node;
}

export interface GetManagedMeetingsTemplates_managedMeetings_assignments {
  __typename: "MaterializedMeetingsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetManagedMeetingsTemplates_managedMeetings_assignments_edges[];
}

export interface GetManagedMeetingsTemplates_managedMeetings {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number;
  /**
   * The activity type for this meeting
   */
  activityType: GetManagedMeetingsTemplates_managedMeetings_activityType;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The DateTime that represents when the meeting was deleted
   */
  deletedTime: any | null;
  /**
   * The users or teams assigned to this meeting template.
   */
  assignments: GetManagedMeetingsTemplates_managedMeetings_assignments | null;
}

export interface GetManagedMeetingsTemplates {
  /**
   * Returns scheduler meetings
   */
  managedMeetings: GetManagedMeetingsTemplates_managedMeetings[];
}

export interface GetManagedMeetingsTemplatesVariables {
  archived: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMeeting
// ====================================================

export interface GetMeeting_meeting_minNotice {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface GetMeeting_meeting_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetMeeting_meeting_creator {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
  /**
   * The user’s configured root meeting URL for scheduler
   */
  schedulerRootMeetingsUrl: string;
  /**
   * Whether or not the user has customized their meeting URL
   */
  hasCustomizedMeetingUrl: boolean;
}

export interface GetMeeting_meeting_cohosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
}

export interface GetMeeting_meeting_hosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
}

export interface GetMeeting_meeting_team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface GetMeeting_meeting_availability_times {
  __typename: "AvailabilityTime";
  /**
   * The day of this availability time
   */
  day: AvailabilityDay;
  /**
   * The time this duration starts
   */
  startTime: string;
  /**
   * The time this duration ends
   */
  endTime: string;
}

export interface GetMeeting_meeting_availability {
  __typename: "Availability";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Availability times on monday
   */
  times: GetMeeting_meeting_availability_times[];
}

export interface GetMeeting_meeting_form_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetMeeting_meeting_form_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetMeeting_meeting_form_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface GetMeeting_meeting_form_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface GetMeeting_meeting_form_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetMeeting_meeting_form_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: GetMeeting_meeting_form_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: GetMeeting_meeting_form_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: GetMeeting_meeting_form_createRules_lead_stagesetFieldRules_stageset;
}

export interface GetMeeting_meeting_form_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: GetMeeting_meeting_form_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: GetMeeting_meeting_form_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: GetMeeting_meeting_form_createRules_lead_stagesetFieldRules[];
}

export interface GetMeeting_meeting_form_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetMeeting_meeting_form_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetMeeting_meeting_form_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: GetMeeting_meeting_form_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: GetMeeting_meeting_form_createRules_contact_audiences[];
}

export interface GetMeeting_meeting_form_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetMeeting_meeting_form_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: GetMeeting_meeting_form_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface GetMeeting_meeting_form_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: GetMeeting_meeting_form_createRules_lead | null;
  /**
   * The create rules related to a contact
   */
  contact: GetMeeting_meeting_form_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: GetMeeting_meeting_form_createRules_account | null;
}

export interface GetMeeting_meeting_form_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMeeting_meeting_form_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface GetMeeting_meeting_form_publishedVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface GetMeeting_meeting_form_publishedVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface GetMeeting_meeting_form_publishedVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetMeeting_meeting_form_publishedVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetMeeting_meeting_form_publishedVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface GetMeeting_meeting_form_publishedVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetMeeting_meeting_form_publishedVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type GetMeeting_meeting_form_publishedVersion_fields_rules_objectsToAssign = GetMeeting_meeting_form_publishedVersion_fields_rules_objectsToAssign_Tag | GetMeeting_meeting_form_publishedVersion_fields_rules_objectsToAssign_Audience | GetMeeting_meeting_form_publishedVersion_fields_rules_objectsToAssign_Product | GetMeeting_meeting_form_publishedVersion_fields_rules_objectsToAssign_Source | GetMeeting_meeting_form_publishedVersion_fields_rules_objectsToAssign_Stageset;

export interface GetMeeting_meeting_form_publishedVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: GetMeeting_meeting_form_publishedVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: GetMeeting_meeting_form_publishedVersion_fields_rules_objectsToAssign[];
}

export interface GetMeeting_meeting_form_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: GetMeeting_meeting_form_publishedVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: GetMeeting_meeting_form_publishedVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: GetMeeting_meeting_form_publishedVersion_fields_rules[];
}

export interface GetMeeting_meeting_form_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: GetMeeting_meeting_form_publishedVersion_pages[];
  /**
   * Array of fields associated with this web form version
   */
  fields: GetMeeting_meeting_form_publishedVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
}

export interface GetMeeting_meeting_form_editableVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface GetMeeting_meeting_form_editableVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface GetMeeting_meeting_form_editableVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface GetMeeting_meeting_form_editableVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetMeeting_meeting_form_editableVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetMeeting_meeting_form_editableVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface GetMeeting_meeting_form_editableVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetMeeting_meeting_form_editableVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type GetMeeting_meeting_form_editableVersion_fields_rules_objectsToAssign = GetMeeting_meeting_form_editableVersion_fields_rules_objectsToAssign_Tag | GetMeeting_meeting_form_editableVersion_fields_rules_objectsToAssign_Audience | GetMeeting_meeting_form_editableVersion_fields_rules_objectsToAssign_Product | GetMeeting_meeting_form_editableVersion_fields_rules_objectsToAssign_Source | GetMeeting_meeting_form_editableVersion_fields_rules_objectsToAssign_Stageset;

export interface GetMeeting_meeting_form_editableVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: GetMeeting_meeting_form_editableVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: GetMeeting_meeting_form_editableVersion_fields_rules_objectsToAssign[];
}

export interface GetMeeting_meeting_form_editableVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: GetMeeting_meeting_form_editableVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: GetMeeting_meeting_form_editableVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: GetMeeting_meeting_form_editableVersion_fields_rules[];
}

export interface GetMeeting_meeting_form_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of fields associated with this web form version
   */
  fields: GetMeeting_meeting_form_editableVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
}

export interface GetMeeting_meeting_form_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface GetMeeting_meeting_form_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMeeting_meeting_form_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: GetMeeting_meeting_form_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: GetMeeting_meeting_form_nextSteps_slackMessage_form;
}

export interface GetMeeting_meeting_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface GetMeeting_meeting_form_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type GetMeeting_meeting_form_nextSteps_nutshellNotification_notifiables = GetMeeting_meeting_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias | GetMeeting_meeting_form_nextSteps_nutshellNotification_notifiables_User;

export interface GetMeeting_meeting_form_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMeeting_meeting_form_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: GetMeeting_meeting_form_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: GetMeeting_meeting_form_nextSteps_nutshellNotification_form;
}

export interface GetMeeting_meeting_form_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: GetMeeting_meeting_form_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: GetMeeting_meeting_form_nextSteps_nutshellNotification | null;
}

export interface GetMeeting_meeting_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: GetMeeting_meeting_form_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: GetMeeting_meeting_form_publishedVersion | null;
  /**
   * Whether the form has been embedded
   */
  isLiveForm: boolean;
  /**
   * The published form preview url
   */
  publishedFormPreviewUrl: string;
  /**
   * Publicly viewable link to published form
   */
  sharableViewInBrowserLink: string;
  /**
   * Boolean, true if the editable version has any edits
   */
  hasUnpublishedChanges: boolean;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: GetMeeting_meeting_form_editableVersion;
  /**
   * Next step automations for this form
   */
  nextSteps: GetMeeting_meeting_form_nextSteps;
  /**
   * The embed snippet for this form
   */
  embedSnippet: string;
  /**
   * The type of form
   */
  type: FormType;
}

export interface GetMeeting_meeting_bookings {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMeeting_meeting_validity_issues_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetMeeting_meeting_validity_issues {
  __typename: "MeetingValidityIssue";
  /**
   * The user tied to this issue
   */
  user: GetMeeting_meeting_validity_issues_user;
  /**
   * The issue type of this issue
   */
  issueType: ValidityIssueType;
}

export interface GetMeeting_meeting_validity {
  __typename: "MeetingValidity";
  /**
   * A list of issues with host users tied to this meeting
   */
  issues: GetMeeting_meeting_validity_issues[];
  /**
   * Whether this meeting can be booked
   */
  isBookable: boolean;
}

export interface GetMeeting_meeting_assignments_stats {
  __typename: "MaterializedMeetingsStats";
  /**
   * The number of users assigned to this meeting template.
   */
  assignedUsersCount: number;
  /**
   * The number of teams assigned to this meeting template.
   */
  assignedTeamsCount: number;
  /**
   * The number of materialized meetings from this meeting template that have been modified and severed.
   */
  severedCount: number;
}

export interface GetMeeting_meeting_assignments {
  __typename: "MaterializedMeetingsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The number of users assigned to this meeting template.
   */
  stats: GetMeeting_meeting_assignments_stats;
}

export interface GetMeeting_meeting {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Meeting model (used to fetch meeting config)
   */
  modelId: number;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * The type of this meeting
   */
  meetingType: MeetingType;
  /**
   * The description of this meeting
   */
  description: string | null;
  /**
   * Custom text sent to the invitee after booking
   */
  bookingConfirmationMessage: string | null;
  /**
   * The htmlUrl without http:                                            // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl for the template that manages this meeting without http: // app.nutshell.com.
   */
  managedByHtmlUrlPath: string | null;
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number;
  /**
   * The published form preview url
   */
  previewUrl: string;
  /**
   * The minimum notice required to book this meeting
   */
  minNotice: GetMeeting_meeting_minNotice | null;
  /**
   * Buffer before each booking in minutes
   */
  bufferBeforeMins: number | null;
  /**
   * Buffer after each booking in minutes
   */
  bufferAfterMins: number | null;
  /**
   * The activity type for this meeting
   */
  activityType: GetMeeting_meeting_activityType;
  /**
   * The location of this meeting, such as address or phone number
   */
  location: string;
  /**
   * The location type of this meeting
   */
  locationType: MeetingLocationType;
  /**
   * The primary host for this meeting
   */
  creator: GetMeeting_meeting_creator;
  /**
   * The cohosts of this meeting, not including primary host
   */
  cohosts: GetMeeting_meeting_cohosts[];
  /**
   * The possible hosts of this meeting, team members for ROUND_ROBIN, set hosts for other types
   */
  hosts: GetMeeting_meeting_hosts[];
  /**
   * For a ROUND_ROBIN meeting, the selected team
   */
  team: GetMeeting_meeting_team | null;
  /**
   * The availability for this meeting
   */
  availability: GetMeeting_meeting_availability;
  /**
   * Publicly viewable link to the meeting
   */
  publicMeetingLink: string;
  /**
   * Whether this meeting is active
   */
  isActive: boolean;
  /**
   * The activity type for this meeting
   */
  form: GetMeeting_meeting_form;
  /**
   * The bookings of this meeting
   */
  bookings: GetMeeting_meeting_bookings[];
  /**
   * The timestamp this web form was last submitted
   */
  lastBookedTime: any | null;
  /**
   * Show invitees time slots at this interval in minutes
   */
  startTimeIntervalMinutes: number;
  /**
   * The number of times this meeting has been viewed
   */
  numViews: number;
  /**
   * Number of bookings compared to views
   */
  bookingRate: number;
  /**
   * Whether to send a booking confirmation email
   */
  sendConfirmationReminder: boolean;
  /**
   * Whether to send a reminder email one day before the meeting
   */
  sendUpcomingReminder: boolean;
  /**
   * Whether to send a reminder email 30 minutes before the meeting
   */
  sendSoonReminder: boolean;
  /**
   * Whether this meeting spans multiple timezones among primary and co hosts
   */
  spansTimezones: boolean;
  /**
   * The validity of this meeting
   */
  validity: GetMeeting_meeting_validity;
  /**
   * The embed snippet for this meeting
   */
  embedSnippet: string;
  /**
   * The DateTime that represents when the meeting was deleted
   */
  deletedTime: any | null;
  /**
   * Whether to allow additional attendees to be added to the booking
   */
  allowAdditionalAttendees: boolean;
  /**
   * Whether this meeting is hidden from public view or visible on the host users scheduler page
   */
  isHidden: boolean;
  /**
   * Whether this hidden meeting can be made public (all plans can make hidden meetings public)
   */
  isShowable: boolean;
  /**
   * Whether this public meeting can be hidden (requires full scheduler access)
   */
  isHideable: boolean;
  /**
   * The custom URL slug for the meeting
   */
  customSlug: string | null;
  /**
   * The url slug of this meeting
   */
  urlSlug: string;
  /**
   * Whether this meeting is a managed template
   */
  isManagedTemplate: boolean;
  /**
   * Whether this meeting is being managed by a template
   */
  isManagedMeeting: boolean;
  /**
   * Whether this meeting is severed from its template. Always false for non-managed meetings.
   */
  isSevered: boolean;
  /**
   * The users or teams assigned to this meeting template.
   */
  assignments: GetMeeting_meeting_assignments | null;
}

export interface GetMeeting {
  /**
   * Returns a scheduler meeting
   */
  meeting: GetMeeting_meeting;
}

export interface GetMeetingVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMeetings
// ====================================================

export interface GetMeetings_meetings_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetMeetings_meetings_creator {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
}

export interface GetMeetings_meetings_cohosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetMeetings_meetings_hosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetMeetings_meetings_team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface GetMeetings_meetings_bookings {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetMeetings_meetings_validity_issues_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetMeetings_meetings_validity_issues {
  __typename: "MeetingValidityIssue";
  /**
   * The user tied to this issue
   */
  user: GetMeetings_meetings_validity_issues_user;
  /**
   * The issue type of this issue
   */
  issueType: ValidityIssueType;
}

export interface GetMeetings_meetings_validity {
  __typename: "MeetingValidity";
  /**
   * A list of issues with host users tied to this meeting
   */
  issues: GetMeetings_meetings_validity_issues[];
  /**
   * Whether this meeting can be booked
   */
  isBookable: boolean;
}

export interface GetMeetings_meetings {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Meeting model (used to fetch meeting config)
   */
  modelId: number;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * The type of this meeting
   */
  meetingType: MeetingType;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number;
  /**
   * The activity type for this meeting
   */
  activityType: GetMeetings_meetings_activityType;
  /**
   * The location of this meeting, such as address or phone number
   */
  location: string;
  /**
   * The location type of this meeting
   */
  locationType: MeetingLocationType;
  /**
   * The primary host for this meeting
   */
  creator: GetMeetings_meetings_creator;
  /**
   * The cohosts of this meeting, not including primary host
   */
  cohosts: GetMeetings_meetings_cohosts[];
  /**
   * The possible hosts of this meeting, team members for ROUND_ROBIN, set hosts for other types
   */
  hosts: GetMeetings_meetings_hosts[];
  /**
   * For a ROUND_ROBIN meeting, the selected team
   */
  team: GetMeetings_meetings_team | null;
  /**
   * The bookings of this meeting
   */
  bookings: GetMeetings_meetings_bookings[];
  /**
   * Publicly viewable link to the meeting
   */
  publicMeetingLink: string;
  /**
   * Whether this meeting is active
   */
  isActive: boolean;
  /**
   * Show invitees time slots at this interval in minutes
   */
  startTimeIntervalMinutes: number;
  /**
   * The number of times this meeting has been viewed
   */
  numViews: number;
  /**
   * Number of bookings compared to views
   */
  bookingRate: number;
  /**
   * Whether this meeting spans multiple timezones among primary and co hosts
   */
  spansTimezones: boolean;
  /**
   * The timestamp this web form was last submitted
   */
  lastBookedTime: any | null;
  /**
   * The validity of this meeting
   */
  validity: GetMeetings_meetings_validity;
  /**
   * The embed snippet for this meeting
   */
  embedSnippet: string;
  /**
   * The DateTime that represents when the meeting was deleted
   */
  deletedTime: any | null;
  /**
   * Whether to allow additional attendees to be added to the booking
   */
  allowAdditionalAttendees: boolean;
  /**
   * Whether this meeting is hidden from public view or visible on the host users scheduler page
   */
  isHidden: boolean;
  /**
   * Whether this hidden meeting can be made public (all plans can make hidden meetings public)
   */
  isShowable: boolean;
  /**
   * Whether this public meeting can be hidden (requires full scheduler access)
   */
  isHideable: boolean;
  /**
   * Whether this meeting is being managed by a template
   */
  isManagedMeeting: boolean;
}

export interface GetMeetings {
  /**
   * Returns scheduler meetings
   */
  meetings: GetMeetings_meetings[];
}

export interface GetMeetingsVariables {
  entityIds?: string[] | null;
  archived?: boolean | null;
  meetingTypes?: MeetingType[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSchedulerPageConfig
// ====================================================

export interface GetSchedulerPageConfig_schedulerPageConfig_fromDomain {
  __typename: "Subdomain";
  /**
   * The ID of the em_from_domain row this record corresponds to, as each domain is split into multiple rows
   */
  fromDomainId: string;
  /**
   * The record of this DNS record
   */
  record: string;
  /**
   * The record of this DNS record
   */
  formattedRecord: string;
  /**
   * Where this subdomain is verified
   */
  isVerified: boolean;
}

export interface GetSchedulerPageConfig_schedulerPageConfig_defaultFromDomain {
  __typename: "Subdomain";
  /**
   * The ID of the em_from_domain row this record corresponds to, as each domain is split into multiple rows
   */
  fromDomainId: string;
  /**
   * The record of this DNS record
   */
  record: string;
  /**
   * The record of this DNS record
   */
  formattedRecord: string;
  /**
   * Where this subdomain is verified
   */
  isVerified: boolean;
}

export interface GetSchedulerPageConfig_schedulerPageConfig {
  __typename: "PageConfig";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether the user avatar should should be used on the scheduler page
   */
  useAvatar: boolean;
  /**
   * Whether the company logo should be used on the scheduler page
   */
  useCompanyLogo: boolean;
  /**
   * The path to the user’s scheduler page
   */
  userSlug: string | null;
  /**
   * The from domain of this PageConfig
   */
  fromDomain: GetSchedulerPageConfig_schedulerPageConfig_fromDomain | null;
  defaultUserSlug: string;
  defaultFromDomain: GetSchedulerPageConfig_schedulerPageConfig_defaultFromDomain;
  /**
   * The embed snippet for this user’s meetings page
   */
  embedSnippet: string;
}

export interface GetSchedulerPageConfig {
  /**
   * Returns a scheduler page config
   */
  schedulerPageConfig: GetSchedulerPageConfig_schedulerPageConfig;
}

export interface GetSchedulerPageConfigVariables {
  userId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetGoogleMeetIsEnabled
// ====================================================

export interface SetGoogleMeetIsEnabled_setGoogleMeetIsEnabled_googleMeetIntegration {
  __typename: "GoogleMeetIntegration";
  /**
   * Whether or not the  Google Meet integration is enabled with calendar sync
   */
  isEnabledCalendarSync: boolean;
  /**
   * Whether or not the Google Meet integration is enabled with meet sync
   */
  isEnabledMeetSync: boolean;
}

export interface SetGoogleMeetIsEnabled_setGoogleMeetIsEnabled {
  __typename: "SetGoogleMeetIsEnabledPayload";
  /**
   * URL to direct the user to if we need to authenticate with an external service, or null if authentication is unnecessary
   */
  authUrl: string | null;
  /**
   * Information about the Google Meet integration
   */
  googleMeetIntegration: SetGoogleMeetIsEnabled_setGoogleMeetIsEnabled_googleMeetIntegration;
}

export interface SetGoogleMeetIsEnabled {
  /**
   * Enable or disable the Google Meet integration.
   */
  setGoogleMeetIsEnabled: SetGoogleMeetIsEnabled_setGoogleMeetIsEnabled | null;
}

export interface SetGoogleMeetIsEnabledVariables {
  input: SetGoogleMeetIsEnabledInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetMicrosoftTeamsIsEnabled
// ====================================================

export interface SetMicrosoftTeamsIsEnabled_setMicrosoftTeamsIsEnabled_microsoftTeamsIntegration {
  __typename: "MicrosoftTeamsIntegration";
  /**
   * Whether or not the  Microsoft Teams integration is enabled
   */
  isEnabled: boolean;
}

export interface SetMicrosoftTeamsIsEnabled_setMicrosoftTeamsIsEnabled {
  __typename: "SetMicrosoftTeamsIsEnabledPayload";
  /**
   * URL to direct the user to if we need to authenticate with an external service, or null if authentication is unnecessary
   */
  authUrl: string | null;
  /**
   * Information about the Microsoft Teams integration
   */
  microsoftTeamsIntegration: SetMicrosoftTeamsIsEnabled_setMicrosoftTeamsIsEnabled_microsoftTeamsIntegration;
}

export interface SetMicrosoftTeamsIsEnabled {
  /**
   * Enable or disable the Microsoft Teams integration.
   */
  setMicrosoftTeamsIsEnabled: SetMicrosoftTeamsIsEnabled_setMicrosoftTeamsIsEnabled | null;
}

export interface SetMicrosoftTeamsIsEnabledVariables {
  input: SetMicrosoftTeamsIsEnabledInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetZoomIsEnabled
// ====================================================

export interface SetZoomIsEnabled_setZoomIsEnabled_zoomIntegration {
  __typename: "ZoomIntegration";
  /**
   * Whether or not the zoom integration is enabled
   */
  isEnabled: boolean;
}

export interface SetZoomIsEnabled_setZoomIsEnabled {
  __typename: "SetZoomIsEnabledPayload";
  /**
   * URL to direct the user to if we need to authenticate with an external service, or null if authentication is unnecessary
   */
  authUrl: string | null;
  /**
   * Information about the zoom integration
   */
  zoomIntegration: SetZoomIsEnabled_setZoomIsEnabled_zoomIntegration;
}

export interface SetZoomIsEnabled {
  /**
   * Enable or disable the Zoom integration.
   */
  setZoomIsEnabled: SetZoomIsEnabled_setZoomIsEnabled | null;
}

export interface SetZoomIsEnabledVariables {
  input: SetZoomIsEnabledInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMeetIntegration
// ====================================================

export interface GetMeetIntegration_loggedInUser_googleMeetIntegration {
  __typename: "GoogleMeetIntegration";
  /**
   * Whether or not the  Google Meet integration is enabled with calendar sync
   */
  isEnabledCalendarSync: boolean;
  /**
   * Whether or not the Google Meet integration is enabled with meet sync
   */
  isEnabledMeetSync: boolean;
  /**
   * Whether or not the Google Meet integration has the scope to create meeting spaces
   */
  hasMeetingSpaceCreateScope: boolean;
  /**
   * The email address of the Google Meet user
   */
  email: string | null;
}

export interface GetMeetIntegration_loggedInUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Google Meet integration details for this user
   */
  googleMeetIntegration: GetMeetIntegration_loggedInUser_googleMeetIntegration;
}

export interface GetMeetIntegration {
  /**
   * Returns the requesting user. This is essentially the logged in user, but in an
   * API context, they might not be any "logged in"
   */
  loggedInUser: GetMeetIntegration_loggedInUser;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTeamsIntegration
// ====================================================

export interface GetTeamsIntegration_loggedInUser_microsoftTeamsIntegration {
  __typename: "MicrosoftTeamsIntegration";
  /**
   * Whether or not the  Microsoft Teams integration is enabled
   */
  isEnabled: boolean;
  /**
   * Scheduler still works without certain permissions versus the main integration
   */
  isEnabledForScheduler: boolean;
  /**
   * The email address of the Microsoft Teams user
   */
  email: string | null;
}

export interface GetTeamsIntegration_loggedInUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Microsoft Teams integration details for this user
   */
  microsoftTeamsIntegration: GetTeamsIntegration_loggedInUser_microsoftTeamsIntegration;
}

export interface GetTeamsIntegration {
  /**
   * Returns the requesting user. This is essentially the logged in user, but in an
   * API context, they might not be any "logged in"
   */
  loggedInUser: GetTeamsIntegration_loggedInUser;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetZoomIntegration
// ====================================================

export interface GetZoomIntegration_loggedInUser_zoomIntegration {
  __typename: "ZoomIntegration";
  /**
   * Whether or not the zoom integration is enabled
   */
  isEnabled: boolean;
  /**
   * The email address of the zoom user
   */
  email: string | null;
}

export interface GetZoomIntegration_loggedInUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Zoom integration details for this user
   */
  zoomIntegration: GetZoomIntegration_loggedInUser_zoomIntegration;
}

export interface GetZoomIntegration {
  /**
   * Returns the requesting user. This is essentially the logged in user, but in an
   * API context, they might not be any "logged in"
   */
  loggedInUser: GetZoomIntegration_loggedInUser;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateManagedMeetingTemplate
// ====================================================

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_minNotice {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_creator {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
  /**
   * The user’s configured root meeting URL for scheduler
   */
  schedulerRootMeetingsUrl: string;
  /**
   * Whether or not the user has customized their meeting URL
   */
  hasCustomizedMeetingUrl: boolean;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_cohosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_hosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_availability_times {
  __typename: "AvailabilityTime";
  /**
   * The day of this availability time
   */
  day: AvailabilityDay;
  /**
   * The time this duration starts
   */
  startTime: string;
  /**
   * The time this duration ends
   */
  endTime: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_availability {
  __typename: "Availability";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Availability times on monday
   */
  times: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_availability_times[];
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_lead_stagesetFieldRules_stageset;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_lead_stagesetFieldRules[];
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_contact_audiences[];
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_lead | null;
  /**
   * The create rules related to a contact
   */
  contact: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules_account | null;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign = CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Tag | CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Audience | CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Product | CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Source | CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign_Stageset;

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_fields_rules_objectsToAssign[];
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_fields_rules[];
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_pages[];
  /**
   * Array of fields associated with this web form version
   */
  fields: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion_fields_rules_objectsToAssign = CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion_fields_rules_objectsToAssign_Tag | CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion_fields_rules_objectsToAssign_Audience | CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion_fields_rules_objectsToAssign_Product | CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion_fields_rules_objectsToAssign_Source | CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion_fields_rules_objectsToAssign_Stageset;

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion_fields_rules_objectsToAssign[];
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion_fields_rules[];
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of fields associated with this web form version
   */
  fields: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_nextSteps_slackMessage_form;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_nextSteps_nutshellNotification_notifiables = CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias | CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_nextSteps_nutshellNotification_notifiables_User;

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_nextSteps_nutshellNotification_form;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_nextSteps_nutshellNotification | null;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_publishedVersion | null;
  /**
   * Whether the form has been embedded
   */
  isLiveForm: boolean;
  /**
   * The published form preview url
   */
  publishedFormPreviewUrl: string;
  /**
   * Publicly viewable link to published form
   */
  sharableViewInBrowserLink: string;
  /**
   * Boolean, true if the editable version has any edits
   */
  hasUnpublishedChanges: boolean;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_editableVersion;
  /**
   * Next step automations for this form
   */
  nextSteps: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form_nextSteps;
  /**
   * The embed snippet for this form
   */
  embedSnippet: string;
  /**
   * The type of form
   */
  type: FormType;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_bookings {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_validity_issues_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_validity_issues {
  __typename: "MeetingValidityIssue";
  /**
   * The user tied to this issue
   */
  user: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_validity_issues_user;
  /**
   * The issue type of this issue
   */
  issueType: ValidityIssueType;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_validity {
  __typename: "MeetingValidity";
  /**
   * A list of issues with host users tied to this meeting
   */
  issues: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_validity_issues[];
  /**
   * Whether this meeting can be booked
   */
  isBookable: boolean;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_assignments_stats {
  __typename: "MaterializedMeetingsStats";
  /**
   * The number of users assigned to this meeting template.
   */
  assignedUsersCount: number;
  /**
   * The number of teams assigned to this meeting template.
   */
  assignedTeamsCount: number;
  /**
   * The number of materialized meetings from this meeting template that have been modified and severed.
   */
  severedCount: number;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_assignments {
  __typename: "MaterializedMeetingsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The number of users assigned to this meeting template.
   */
  stats: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_assignments_stats;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Meeting model (used to fetch meeting config)
   */
  modelId: number;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * The type of this meeting
   */
  meetingType: MeetingType;
  /**
   * The description of this meeting
   */
  description: string | null;
  /**
   * Custom text sent to the invitee after booking
   */
  bookingConfirmationMessage: string | null;
  /**
   * The htmlUrl without http:                                            // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl for the template that manages this meeting without http: // app.nutshell.com.
   */
  managedByHtmlUrlPath: string | null;
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number;
  /**
   * The published form preview url
   */
  previewUrl: string;
  /**
   * The minimum notice required to book this meeting
   */
  minNotice: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_minNotice | null;
  /**
   * Buffer before each booking in minutes
   */
  bufferBeforeMins: number | null;
  /**
   * Buffer after each booking in minutes
   */
  bufferAfterMins: number | null;
  /**
   * The activity type for this meeting
   */
  activityType: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_activityType;
  /**
   * The location of this meeting, such as address or phone number
   */
  location: string;
  /**
   * The location type of this meeting
   */
  locationType: MeetingLocationType;
  /**
   * The primary host for this meeting
   */
  creator: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_creator;
  /**
   * The cohosts of this meeting, not including primary host
   */
  cohosts: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_cohosts[];
  /**
   * The possible hosts of this meeting, team members for ROUND_ROBIN, set hosts for other types
   */
  hosts: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_hosts[];
  /**
   * For a ROUND_ROBIN meeting, the selected team
   */
  team: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_team | null;
  /**
   * The availability for this meeting
   */
  availability: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_availability;
  /**
   * Publicly viewable link to the meeting
   */
  publicMeetingLink: string;
  /**
   * Whether this meeting is active
   */
  isActive: boolean;
  /**
   * The activity type for this meeting
   */
  form: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_form;
  /**
   * The bookings of this meeting
   */
  bookings: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_bookings[];
  /**
   * The timestamp this web form was last submitted
   */
  lastBookedTime: any | null;
  /**
   * Show invitees time slots at this interval in minutes
   */
  startTimeIntervalMinutes: number;
  /**
   * The number of times this meeting has been viewed
   */
  numViews: number;
  /**
   * Number of bookings compared to views
   */
  bookingRate: number;
  /**
   * Whether to send a booking confirmation email
   */
  sendConfirmationReminder: boolean;
  /**
   * Whether to send a reminder email one day before the meeting
   */
  sendUpcomingReminder: boolean;
  /**
   * Whether to send a reminder email 30 minutes before the meeting
   */
  sendSoonReminder: boolean;
  /**
   * Whether this meeting spans multiple timezones among primary and co hosts
   */
  spansTimezones: boolean;
  /**
   * The validity of this meeting
   */
  validity: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_validity;
  /**
   * The embed snippet for this meeting
   */
  embedSnippet: string;
  /**
   * The DateTime that represents when the meeting was deleted
   */
  deletedTime: any | null;
  /**
   * Whether to allow additional attendees to be added to the booking
   */
  allowAdditionalAttendees: boolean;
  /**
   * Whether this meeting is hidden from public view or visible on the host users scheduler page
   */
  isHidden: boolean;
  /**
   * Whether this hidden meeting can be made public (all plans can make hidden meetings public)
   */
  isShowable: boolean;
  /**
   * Whether this public meeting can be hidden (requires full scheduler access)
   */
  isHideable: boolean;
  /**
   * The custom URL slug for the meeting
   */
  customSlug: string | null;
  /**
   * The url slug of this meeting
   */
  urlSlug: string;
  /**
   * Whether this meeting is a managed template
   */
  isManagedTemplate: boolean;
  /**
   * Whether this meeting is being managed by a template
   */
  isManagedMeeting: boolean;
  /**
   * Whether this meeting is severed from its template. Always false for non-managed meetings.
   */
  isSevered: boolean;
  /**
   * The users or teams assigned to this meeting template.
   */
  assignments: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting_assignments | null;
}

export interface CreateManagedMeetingTemplate_managedMeetingTemplateCreate {
  __typename: "ManagedMeetingTemplateCreatePayload";
  /**
   * The newly created managed meeting template
   */
  meeting: CreateManagedMeetingTemplate_managedMeetingTemplateCreate_meeting;
}

export interface CreateManagedMeetingTemplate {
  managedMeetingTemplateCreate: CreateManagedMeetingTemplate_managedMeetingTemplateCreate;
}

export interface CreateManagedMeetingTemplateVariables {
  input: ManagedMeetingTemplateCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteManagedMeetingTemplate
// ====================================================

export interface DeleteManagedMeetingTemplate_meetingDelete_meeting {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DateTime that represents when the meeting was deleted
   */
  deletedTime: any | null;
}

export interface DeleteManagedMeetingTemplate_meetingDelete {
  __typename: "MeetingDeletePayload";
  /**
   * The meeting that was deleted.
   */
  meeting: DeleteManagedMeetingTemplate_meetingDelete_meeting | null;
}

export interface DeleteManagedMeetingTemplate {
  /**
   * Delete a meeting
   */
  meetingDelete: DeleteManagedMeetingTemplate_meetingDelete;
}

export interface DeleteManagedMeetingTemplateVariables {
  input: MeetingDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ResetManagedMeetingChanges
// ====================================================

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_minNotice {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_creator {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
  /**
   * The user’s configured root meeting URL for scheduler
   */
  schedulerRootMeetingsUrl: string;
  /**
   * Whether or not the user has customized their meeting URL
   */
  hasCustomizedMeetingUrl: boolean;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_cohosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_hosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_availability_times {
  __typename: "AvailabilityTime";
  /**
   * The day of this availability time
   */
  day: AvailabilityDay;
  /**
   * The time this duration starts
   */
  startTime: string;
  /**
   * The time this duration ends
   */
  endTime: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_availability {
  __typename: "Availability";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Availability times on monday
   */
  times: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_availability_times[];
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_lead_stagesetFieldRules_stageset;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_lead_stagesetFieldRules[];
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_contact_audiences[];
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_lead | null;
  /**
   * The create rules related to a contact
   */
  contact: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules_account | null;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_fields_rules_objectsToAssign = ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_fields_rules_objectsToAssign_Tag | ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_fields_rules_objectsToAssign_Audience | ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_fields_rules_objectsToAssign_Product | ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_fields_rules_objectsToAssign_Source | ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_fields_rules_objectsToAssign_Stageset;

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_fields_rules_objectsToAssign[];
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_fields_rules[];
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_pages[];
  /**
   * Array of fields associated with this web form version
   */
  fields: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion_fields_rules_objectsToAssign = ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion_fields_rules_objectsToAssign_Tag | ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion_fields_rules_objectsToAssign_Audience | ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion_fields_rules_objectsToAssign_Product | ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion_fields_rules_objectsToAssign_Source | ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion_fields_rules_objectsToAssign_Stageset;

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion_fields_rules_objectsToAssign[];
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion_fields_rules[];
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of fields associated with this web form version
   */
  fields: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_nextSteps_slackMessage_form;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_nextSteps_nutshellNotification_notifiables = ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias | ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_nextSteps_nutshellNotification_notifiables_User;

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_nextSteps_nutshellNotification_form;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_nextSteps_nutshellNotification | null;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_publishedVersion | null;
  /**
   * Whether the form has been embedded
   */
  isLiveForm: boolean;
  /**
   * The published form preview url
   */
  publishedFormPreviewUrl: string;
  /**
   * Publicly viewable link to published form
   */
  sharableViewInBrowserLink: string;
  /**
   * Boolean, true if the editable version has any edits
   */
  hasUnpublishedChanges: boolean;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_editableVersion;
  /**
   * Next step automations for this form
   */
  nextSteps: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form_nextSteps;
  /**
   * The embed snippet for this form
   */
  embedSnippet: string;
  /**
   * The type of form
   */
  type: FormType;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_bookings {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_validity_issues_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_validity_issues {
  __typename: "MeetingValidityIssue";
  /**
   * The user tied to this issue
   */
  user: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_validity_issues_user;
  /**
   * The issue type of this issue
   */
  issueType: ValidityIssueType;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_validity {
  __typename: "MeetingValidity";
  /**
   * A list of issues with host users tied to this meeting
   */
  issues: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_validity_issues[];
  /**
   * Whether this meeting can be booked
   */
  isBookable: boolean;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_assignments_stats {
  __typename: "MaterializedMeetingsStats";
  /**
   * The number of users assigned to this meeting template.
   */
  assignedUsersCount: number;
  /**
   * The number of teams assigned to this meeting template.
   */
  assignedTeamsCount: number;
  /**
   * The number of materialized meetings from this meeting template that have been modified and severed.
   */
  severedCount: number;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_assignments {
  __typename: "MaterializedMeetingsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The number of users assigned to this meeting template.
   */
  stats: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_assignments_stats;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges_meeting {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Meeting model (used to fetch meeting config)
   */
  modelId: number;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * The type of this meeting
   */
  meetingType: MeetingType;
  /**
   * The description of this meeting
   */
  description: string | null;
  /**
   * Custom text sent to the invitee after booking
   */
  bookingConfirmationMessage: string | null;
  /**
   * The htmlUrl without http:                                            // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl for the template that manages this meeting without http: // app.nutshell.com.
   */
  managedByHtmlUrlPath: string | null;
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number;
  /**
   * The published form preview url
   */
  previewUrl: string;
  /**
   * The minimum notice required to book this meeting
   */
  minNotice: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_minNotice | null;
  /**
   * Buffer before each booking in minutes
   */
  bufferBeforeMins: number | null;
  /**
   * Buffer after each booking in minutes
   */
  bufferAfterMins: number | null;
  /**
   * The activity type for this meeting
   */
  activityType: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_activityType;
  /**
   * The location of this meeting, such as address or phone number
   */
  location: string;
  /**
   * The location type of this meeting
   */
  locationType: MeetingLocationType;
  /**
   * The primary host for this meeting
   */
  creator: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_creator;
  /**
   * The cohosts of this meeting, not including primary host
   */
  cohosts: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_cohosts[];
  /**
   * The possible hosts of this meeting, team members for ROUND_ROBIN, set hosts for other types
   */
  hosts: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_hosts[];
  /**
   * For a ROUND_ROBIN meeting, the selected team
   */
  team: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_team | null;
  /**
   * The availability for this meeting
   */
  availability: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_availability;
  /**
   * Publicly viewable link to the meeting
   */
  publicMeetingLink: string;
  /**
   * Whether this meeting is active
   */
  isActive: boolean;
  /**
   * The activity type for this meeting
   */
  form: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_form;
  /**
   * The bookings of this meeting
   */
  bookings: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_bookings[];
  /**
   * The timestamp this web form was last submitted
   */
  lastBookedTime: any | null;
  /**
   * Show invitees time slots at this interval in minutes
   */
  startTimeIntervalMinutes: number;
  /**
   * The number of times this meeting has been viewed
   */
  numViews: number;
  /**
   * Number of bookings compared to views
   */
  bookingRate: number;
  /**
   * Whether to send a booking confirmation email
   */
  sendConfirmationReminder: boolean;
  /**
   * Whether to send a reminder email one day before the meeting
   */
  sendUpcomingReminder: boolean;
  /**
   * Whether to send a reminder email 30 minutes before the meeting
   */
  sendSoonReminder: boolean;
  /**
   * Whether this meeting spans multiple timezones among primary and co hosts
   */
  spansTimezones: boolean;
  /**
   * The validity of this meeting
   */
  validity: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_validity;
  /**
   * The embed snippet for this meeting
   */
  embedSnippet: string;
  /**
   * The DateTime that represents when the meeting was deleted
   */
  deletedTime: any | null;
  /**
   * Whether to allow additional attendees to be added to the booking
   */
  allowAdditionalAttendees: boolean;
  /**
   * Whether this meeting is hidden from public view or visible on the host users scheduler page
   */
  isHidden: boolean;
  /**
   * Whether this hidden meeting can be made public (all plans can make hidden meetings public)
   */
  isShowable: boolean;
  /**
   * Whether this public meeting can be hidden (requires full scheduler access)
   */
  isHideable: boolean;
  /**
   * The custom URL slug for the meeting
   */
  customSlug: string | null;
  /**
   * The url slug of this meeting
   */
  urlSlug: string;
  /**
   * Whether this meeting is a managed template
   */
  isManagedTemplate: boolean;
  /**
   * Whether this meeting is being managed by a template
   */
  isManagedMeeting: boolean;
  /**
   * Whether this meeting is severed from its template. Always false for non-managed meetings.
   */
  isSevered: boolean;
  /**
   * The users or teams assigned to this meeting template.
   */
  assignments: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting_assignments | null;
}

export interface ResetManagedMeetingChanges_managedMeetingResetChanges {
  __typename: "ManagedMeetingResetChangesPayload";
  /**
   * The meeting after unsevering
   */
  meeting: ResetManagedMeetingChanges_managedMeetingResetChanges_meeting;
}

export interface ResetManagedMeetingChanges {
  /**
   * Resets a severed meeting to the state of its template
   */
  managedMeetingResetChanges: ResetManagedMeetingChanges_managedMeetingResetChanges;
}

export interface ResetManagedMeetingChangesVariables {
  input: ManagedMeetingResetChangesInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UndeleteManagedMeetingTemplate
// ====================================================

export interface UndeleteManagedMeetingTemplate_meetingUndelete_meeting {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DateTime that represents when the meeting was deleted
   */
  deletedTime: any | null;
}

export interface UndeleteManagedMeetingTemplate_meetingUndelete {
  __typename: "MeetingUndeletePayload";
  /**
   * The freshly updated meeting.
   */
  meeting: UndeleteManagedMeetingTemplate_meetingUndelete_meeting;
}

export interface UndeleteManagedMeetingTemplate {
  /**
   * Undeletes (restores) a scheduler meeting
   */
  meetingUndelete: UndeleteManagedMeetingTemplate_meetingUndelete;
}

export interface UndeleteManagedMeetingTemplateVariables {
  input: MeetingUndeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAvailabilityReport
// ====================================================

export interface GetAvailabilityReport_availabilityReport_days_views {
  __typename: "BookingDayStat";
  /**
   * The count of this booking day stat
   */
  count: number;
  /**
   * The heatmap for this booking day stat
   */
  heatmap: number;
}

export interface GetAvailabilityReport_availabilityReport_days_bookings {
  __typename: "BookingDayStat";
  /**
   * The count of this booking day stat
   */
  count: number;
  /**
   * The heatmap for this booking day stat
   */
  heatmap: number;
}

export interface GetAvailabilityReport_availabilityReport_days_availabilitySnapshot {
  __typename: "AvailabilityImpression";
  /**
   * Whether this availability impression is bookable
   */
  isBookable: boolean;
  /**
   * The days from view of this availability impression
   */
  daysFromView: number;
  /**
   * The date of this availability impression
   */
  date: string;
  /**
   * The score of this availability impression
   */
  score: AvailabilityScore;
  averageSlots: number;
  /**
   * Pre-formatted tooltip text for this availability cell
   */
  dataTip: string;
}

export interface GetAvailabilityReport_availabilityReport_days {
  __typename: "BookingDay";
  /**
   * The date of this booking window
   */
  date: string;
  /**
   * Whether this day is bookable via the meeting preferences
   */
  isBookable: boolean;
  /**
   * Bookings / views as a percentage string, e.g. "25%"
   */
  conversionRate: string;
  /**
   * The views for this booking day
   */
  views: GetAvailabilityReport_availabilityReport_days_views;
  /**
   * The bookings for this booking day
   */
  bookings: GetAvailabilityReport_availabilityReport_days_bookings;
  /**
   * The availability snapshot for this booking day
   */
  availabilitySnapshot: GetAvailabilityReport_availabilityReport_days_availabilitySnapshot[];
}

export interface GetAvailabilityReport_availabilityReport {
  __typename: "AvailabilityReport";
  /**
   * The ID of this report
   */
  id: string;
  /**
   * The day span for this report
   */
  days: GetAvailabilityReport_availabilityReport_days[];
}

export interface GetAvailabilityReport {
  /**
   * Returns a report structure for meeting availability
   */
  availabilityReport: GetAvailabilityReport_availabilityReport;
}

export interface GetAvailabilityReportVariables {
  meetingId: string;
  periodString?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSchedulerStats
// ====================================================

export interface GetSchedulerStats_schedulerStats_averageTimeUntilBooking {
  __typename: "FormattedValueDuration";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetSchedulerStats_schedulerStats {
  __typename: "SchedulerStats";
  /**
   * The id of the meeting the stats are for
   */
  id: string;
  /**
   * The total number of views for the meeting during the period
   */
  totalViews: number;
  /**
   * The conversion rate for the meeting during the period
   */
  conversionRate: number;
  /**
   * The total number of bookings for the meeting during the period
   */
  totalBookings: number;
  /**
   * The average time between making the booking and the actual meeting start time in seconds
   */
  averageTimeUntilBooking: GetSchedulerStats_schedulerStats_averageTimeUntilBooking | null;
}

export interface GetSchedulerStats {
  schedulerStats: GetSchedulerStats_schedulerStats | null;
}

export interface GetSchedulerStatsVariables {
  input: SchedulerStatsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateActivityType
// ====================================================

export interface CreateActivityType_activityTypeCreate_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
  /**
   * The URL of the report for this activity type
   */
  reportUrl: string;
  /**
   * Whether this activity type is immutable
   */
  isImmutable: boolean;
}

export interface CreateActivityType_activityTypeCreate {
  __typename: "ActivityTypeCreatePayload";
  /**
   * The created activity type
   */
  activityType: CreateActivityType_activityTypeCreate_activityType;
}

export interface CreateActivityType {
  /**
   * Create a new activity type
   */
  activityTypeCreate: CreateActivityType_activityTypeCreate;
}

export interface CreateActivityTypeVariables {
  input: ActivityTypeCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteActivityType
// ====================================================

export interface DeleteActivityType_activityTypeDelete_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
  /**
   * The URL of the report for this activity type
   */
  reportUrl: string;
  /**
   * Whether this activity type is immutable
   */
  isImmutable: boolean;
}

export interface DeleteActivityType_activityTypeDelete {
  __typename: "ActivityTypeDeletePayload";
  /**
   * The deleted activity type
   */
  activityType: DeleteActivityType_activityTypeDelete_activityType;
}

export interface DeleteActivityType {
  /**
   * Delete an existing activity type
   */
  activityTypeDelete: DeleteActivityType_activityTypeDelete;
}

export interface DeleteActivityTypeVariables {
  input: ActivityTypeDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateActivityType
// ====================================================

export interface UpdateActivityType_activityTypeUpdate_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
  /**
   * The URL of the report for this activity type
   */
  reportUrl: string;
  /**
   * Whether this activity type is immutable
   */
  isImmutable: boolean;
}

export interface UpdateActivityType_activityTypeUpdate {
  __typename: "ActivityTypeUpdatePayload";
  /**
   * The updated activity type
   */
  activityType: UpdateActivityType_activityTypeUpdate_activityType;
}

export interface UpdateActivityType {
  /**
   * Update an existing activity type
   */
  activityTypeUpdate: UpdateActivityType_activityTypeUpdate;
}

export interface UpdateActivityTypeVariables {
  input: ActivityTypeUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetActivityTypeDefaults
// ====================================================

export interface GetActivityTypeDefaults_activityTypeDefaults_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetActivityTypeDefaults_activityTypeDefaults {
  __typename: "ActivityTypeDefaults";
  /**
   * The type of activity
   */
  defaultType: ActivityTypeDefault;
  /**
   * The type of activity
   */
  activityType: GetActivityTypeDefaults_activityTypeDefaults_activityType;
}

export interface GetActivityTypeDefaults {
  /**
   * Default values to power the activity types default section
   */
  activityTypeDefaults: GetActivityTypeDefaults_activityTypeDefaults[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetActivityTypesWithStats
// ====================================================

export interface GetActivityTypesWithStats_activityTypes {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
  /**
   * The URL of the report for this activity type
   */
  reportUrl: string;
  /**
   * Whether this activity type is immutable
   */
  isImmutable: boolean;
  /**
   * The last time an activity of this type was created
   */
  lastActivityTime: any | null;
  /**
   * The number of activities of this type created in the past year
   */
  numActivitiesPastYear: number;
}

export interface GetActivityTypesWithStats {
  /**
   * Get a list of activity types
   */
  activityTypes: GetActivityTypesWithStats_activityTypes[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAiFeatureEnabled
// ====================================================

export interface GetAiFeatureEnabled_aiFeatureEnabled {
  __typename: "AiFeatureEnabled";
  type: AiFeatureType;
  isEnabled: boolean;
}

export interface GetAiFeatureEnabled {
  aiFeatureEnabled: GetAiFeatureEnabled_aiFeatureEnabled;
}

export interface GetAiFeatureEnabledVariables {
  type: AiFeatureType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAiFeatureUsage
// ====================================================

export interface GetAiFeatureUsage_aiFeatureUsage_features {
  __typename: "AiFeatureSetting";
  type: AiFeatureType;
  isEnabled: boolean;
  usage: number;
  requiresUpgrade: boolean;
  canDisableGlobally: boolean;
}

export interface GetAiFeatureUsage_aiFeatureUsage {
  __typename: "AiFeatureUsage";
  currentMonthUsage: number;
  currentMonthLimit: number | null;
  lastMonthUsage: number;
  features: GetAiFeatureUsage_aiFeatureUsage_features[];
}

export interface GetAiFeatureUsage {
  aiFeatureUsage: GetAiFeatureUsage_aiFeatureUsage;
}

export interface GetAiFeatureUsageVariables {
  category: AiFeatureCategory;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserAiFeatureSettings
// ====================================================

export interface GetUserAiFeatureSettings_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  isAiFollowUpTasksEnabled: boolean;
}

export interface GetUserAiFeatureSettings {
  /**
   * Returns a full Nutshell user object
   */
  user: GetUserAiFeatureSettings_user;
}

export interface GetUserAiFeatureSettingsVariables {
  userId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBulkEdits
// ====================================================

export interface GetBulkEdits_bulkEdits_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetBulkEdits_bulkEdits_edges_node_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetBulkEdits_bulkEdits_edges_node {
  __typename: "BulkEdit";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that initiated the bulk edit
   */
  user: GetBulkEdits_bulkEdits_edges_node_user | null;
  /**
   * The status of the bulk edit
   */
  status: BulkEditStatus;
  /**
   * The time the bulk edit was submitted
   */
  createdTime: any;
  /**
   * The time the bulk edit was started
   */
  startedTime: any | null;
  /**
   * The time the bulk edit was completed
   */
  completedTime: any | null;
  /**
   * The entity type that the bulk edit was performed on.
   */
  entityType: EntityType | null;
}

export interface GetBulkEdits_bulkEdits_edges {
  __typename: "BulkEditsEdge";
  node: GetBulkEdits_bulkEdits_edges_node;
}

export interface GetBulkEdits_bulkEdits {
  __typename: "BulkEditsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetBulkEdits_bulkEdits_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetBulkEdits_bulkEdits_edges[];
}

export interface GetBulkEdits {
  bulkEdits: GetBulkEdits_bulkEdits | null;
}

export interface GetBulkEditsVariables {
  first?: number | null;
  after?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetListExports
// ====================================================

export interface GetListExports_listBulkActions_actor_Origin {
  __typename: "Origin" | "Contact" | "Account" | "Form" | "MaUrl";
}

export interface GetListExports_listBulkActions_actor_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type GetListExports_listBulkActions_actor = GetListExports_listBulkActions_actor_Origin | GetListExports_listBulkActions_actor_User;

export interface GetListExports_listBulkActions_changes {
  __typename: "ChangeLogChange";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attrbute changed by the entry
   */
  attribute: string;
  /**
   * The new value after the change
   */
  newValue: string | null;
}

export interface GetListExports_listBulkActions {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of change i.e. created, modified, deleted, etc
   */
  changeType: ChangeType;
  changeTime: any;
  /**
   * The entity name associated with the event. Rarely used, but can be helpful for odd events like exports
   */
  entityName: string | null;
  /**
   * The entity that triggered the change_log entry
   */
  actor: GetListExports_listBulkActions_actor;
  changes: GetListExports_listBulkActions_changes[];
}

export interface GetListExports {
  listBulkActions: GetListExports_listBulkActions[];
}

export interface GetListExportsVariables {
  userId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserSessions
// ====================================================

export interface GetUserSessions_userSessions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetUserSessions_userSessions_edges_node_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetUserSessions_userSessions_edges_node {
  __typename: "UserSession";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  user: GetUserSessions_userSessions_edges_node_user;
  ipAddress: string;
  loginTime: any;
}

export interface GetUserSessions_userSessions_edges {
  __typename: "UserSessionsEdge";
  node: GetUserSessions_userSessions_edges_node;
}

export interface GetUserSessions_userSessions {
  __typename: "UserSessionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetUserSessions_userSessions_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetUserSessions_userSessions_edges[];
}

export interface GetUserSessions {
  userSessions: GetUserSessions_userSessions | null;
}

export interface GetUserSessionsVariables {
  userId?: string | null;
  first?: number | null;
  after?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AcceptCancellationOffer
// ====================================================

export interface AcceptCancellationOffer_cancellationOfferAccept {
  __typename: "CancellationOfferAcceptPayload";
  /**
   * True when the discount was redeemed. The client should reload billing rather than trust in-memory plan state.
   */
  success: boolean;
}

export interface AcceptCancellationOffer {
  /**
   * Apply the pre-cancellation retention discount to this instance
   */
  cancellationOfferAccept: AcceptCancellationOffer_cancellationOfferAccept;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: BillingInfoAutofill
// ====================================================

export interface BillingInfoAutofill_billingInfoAutofill {
  __typename: "BillingInfoAutofillPayload";
  /**
   * Whether the autofill was successful
   */
  success: boolean;
}

export interface BillingInfoAutofill {
  /**
   * Autofill in for development billing info
   */
  billingInfoAutofill: BillingInfoAutofill_billingInfoAutofill;
}

export interface BillingInfoAutofillVariables {
  input: ContactInfoInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CachePlanSelection
// ====================================================

export interface CachePlanSelection_cachePlanSelection {
  __typename: "CachePlanSelectionPayload";
  /**
   * Whether the billing info was cached
   */
  success: boolean;
}

export interface CachePlanSelection {
  /**
   * Used to cache plan selection during trials to persist changes across page loads
   */
  cachePlanSelection: CachePlanSelection_cachePlanSelection;
}

export interface CachePlanSelectionVariables {
  input: CachePlanSelectionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateBillingInfo
// ====================================================

export interface UpdateBillingInfo_billingInfoUpdate {
  __typename: "BillingInfoUpdatePayload";
  /**
   * Whether the update was successful
   */
  success: boolean;
}

export interface UpdateBillingInfo {
  /**
   * Update a customer's billing information
   */
  billingInfoUpdate: UpdateBillingInfo_billingInfoUpdate;
}

export interface UpdateBillingInfoVariables {
  input: BillingInfoUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateChurnInfo
// ====================================================

export interface UpdateChurnInfo_churnInfoUpdate_churnInfo {
  __typename: "ChurnInfo";
  /**
   * Array of selected churn reason values
   */
  selectedReasons: string[];
  /**
   * Additional comments or feedback
   */
  additionalComments: string | null;
  /**
   * Name of the user who submitted
   */
  userName: string | null;
  /**
   * Email of the user who submitted
   */
  userEmail: string | null;
}

export interface UpdateChurnInfo_churnInfoUpdate {
  __typename: "ChurnInfoUpdatePayload";
  /**
   * The updated churn info.
   */
  churnInfo: UpdateChurnInfo_churnInfoUpdate_churnInfo;
}

export interface UpdateChurnInfo {
  /**
   * Updates the churn survey info for this instance.
   */
  churnInfoUpdate: UpdateChurnInfo_churnInfoUpdate;
}

export interface UpdateChurnInfoVariables {
  input: ChurnInfoUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdatePlanSelection
// ====================================================

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_accountCoupons {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_nextEstimatedInvoice {
  __typename: "BillingInvoice";
  /**
   * The Recurly id of the invoice
   */
  id: string;
  /**
   * The total amount of the invoice
   */
  amount: string;
  /**
   * The timestamp date the invoice was created
   */
  date: any;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_splitEstimatedInvoices_monthly {
  __typename: "BillingInvoice";
  /**
   * The Recurly id of the invoice
   */
  id: string;
  /**
   * The total amount of the invoice
   */
  amount: string;
  /**
   * The timestamp date the invoice was created
   */
  date: any;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_splitEstimatedInvoices_annual {
  __typename: "BillingInvoice";
  /**
   * The Recurly id of the invoice
   */
  id: string;
  /**
   * The total amount of the invoice
   */
  amount: string;
  /**
   * The timestamp date the invoice was created
   */
  date: any;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_splitEstimatedInvoices {
  __typename: "SplitEstimatedInvoices";
  /**
   * The next estimated invoice for monthly-billed subscriptions
   */
  monthly: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_splitEstimatedInvoices_monthly | null;
  /**
   * The next estimated invoice for annually-billed subscriptions
   */
  annual: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_splitEstimatedInvoices_annual | null;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_crm_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_crm_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_crm {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_crm_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_crm_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_marketing_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_marketing_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_marketing {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_marketing_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_marketing_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_revenueBooster_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_revenueBooster_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_revenueBooster {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_revenueBooster_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_revenueBooster_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_nutshellIq_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_nutshellIq_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_nutshellIq {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_nutshellIq_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_nutshellIq_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_inbox_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_inbox_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_inbox {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_inbox_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_inbox_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_marketingSuite_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_marketingSuite_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_marketingSuite {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_marketingSuite_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_marketingSuite_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_smsCampaigns_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_smsCampaigns_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_smsCampaigns {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_smsCampaigns_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_smsCampaigns_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_quotes_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_quotes_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_quotes {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_quotes_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_quotes_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_nutshellAdvisor_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_nutshellAdvisor_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_nutshellAdvisor {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_nutshellAdvisor_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_nutshellAdvisor_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan {
  __typename: "AccountPlan";
  /**
   * The total monthly cost of all subscriptions
   */
  totalMonth: number;
  /**
   * The total display monthly cost of all subscriptions
   */
  totalMonthDisplay: string;
  /**
   * The sub total (pre account wide coupon) display monthly cost of all subscriptions
   */
  subtotalMonthDisplay: string;
  /**
   * The total display discount applied to the account
   */
  accountDiscountDisplay: string;
  /**
   * The coupon applied to the whole account
   */
  accountCoupons: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_accountCoupons[];
  /**
   * The next estimated invoice for the account plan
   */
  nextEstimatedInvoice: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_nextEstimatedInvoice | null;
  /**
   * Next estimated invoices split by monthly and annual billing cycles
   */
  splitEstimatedInvoices: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_splitEstimatedInvoices;
  /**
   * Whether the account plan is cancelled
   */
  isCancelled: boolean;
  /**
   * The subscription for the CRM plan
   */
  crm: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_crm | null;
  /**
   * The subscription for the Marketing plan
   */
  marketing: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_marketing | null;
  /**
   * The subscription for the Revenue Booster plan
   */
  revenueBooster: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_revenueBooster | null;
  /**
   * The subscription for the Nutshell IQ plan
   */
  nutshellIq: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_nutshellIq | null;
  /**
   * The subscription for the inbox plan
   */
  inbox: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_inbox | null;
  /**
   * The subscription for the marketing suite plan
   */
  marketingSuite: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_marketingSuite | null;
  /**
   * The subscription for the SMS campaigns plans
   */
  smsCampaigns: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_smsCampaigns | null;
  /**
   * The subscription for the Quotes plan
   */
  quotes: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_quotes | null;
  /**
   * The subscription for the Nutshell Advisor plan
   */
  nutshellAdvisor: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan_nutshellAdvisor | null;
}

export interface UpdatePlanSelection_planSelectionUpdate_accountBilling {
  __typename: "AccountBilling";
  /**
   * The name of the coupon
   */
  currentPlan: UpdatePlanSelection_planSelectionUpdate_accountBilling_currentPlan | null;
}

export interface UpdatePlanSelection_planSelectionUpdate {
  __typename: "PlanSelectionUpdatePayload";
  /**
   * The updated account billing state after the update
   */
  accountBilling: UpdatePlanSelection_planSelectionUpdate_accountBilling;
}

export interface UpdatePlanSelection {
  /**
   * Change the selected plans for this instance, including add-ons
   */
  planSelectionUpdate: UpdatePlanSelection_planSelectionUpdate;
}

export interface UpdatePlanSelectionVariables {
  input: PlanSelectionUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountBilling
// ====================================================

export interface GetAccountBilling_accountBilling_currentPlan_accountCoupons {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetAccountBilling_accountBilling_currentPlan_nextEstimatedInvoice {
  __typename: "BillingInvoice";
  /**
   * The Recurly id of the invoice
   */
  id: string;
  /**
   * The total amount of the invoice
   */
  amount: string;
  /**
   * The timestamp date the invoice was created
   */
  date: any;
}

export interface GetAccountBilling_accountBilling_currentPlan_splitEstimatedInvoices_monthly {
  __typename: "BillingInvoice";
  /**
   * The Recurly id of the invoice
   */
  id: string;
  /**
   * The total amount of the invoice
   */
  amount: string;
  /**
   * The timestamp date the invoice was created
   */
  date: any;
}

export interface GetAccountBilling_accountBilling_currentPlan_splitEstimatedInvoices_annual {
  __typename: "BillingInvoice";
  /**
   * The Recurly id of the invoice
   */
  id: string;
  /**
   * The total amount of the invoice
   */
  amount: string;
  /**
   * The timestamp date the invoice was created
   */
  date: any;
}

export interface GetAccountBilling_accountBilling_currentPlan_splitEstimatedInvoices {
  __typename: "SplitEstimatedInvoices";
  /**
   * The next estimated invoice for monthly-billed subscriptions
   */
  monthly: GetAccountBilling_accountBilling_currentPlan_splitEstimatedInvoices_monthly | null;
  /**
   * The next estimated invoice for annually-billed subscriptions
   */
  annual: GetAccountBilling_accountBilling_currentPlan_splitEstimatedInvoices_annual | null;
}

export interface GetAccountBilling_accountBilling_currentPlan_crm_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetAccountBilling_accountBilling_currentPlan_crm_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface GetAccountBilling_accountBilling_currentPlan_crm {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: GetAccountBilling_accountBilling_currentPlan_crm_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: GetAccountBilling_accountBilling_currentPlan_crm_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface GetAccountBilling_accountBilling_currentPlan_marketing_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetAccountBilling_accountBilling_currentPlan_marketing_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface GetAccountBilling_accountBilling_currentPlan_marketing {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: GetAccountBilling_accountBilling_currentPlan_marketing_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: GetAccountBilling_accountBilling_currentPlan_marketing_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface GetAccountBilling_accountBilling_currentPlan_revenueBooster_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetAccountBilling_accountBilling_currentPlan_revenueBooster_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface GetAccountBilling_accountBilling_currentPlan_revenueBooster {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: GetAccountBilling_accountBilling_currentPlan_revenueBooster_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: GetAccountBilling_accountBilling_currentPlan_revenueBooster_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface GetAccountBilling_accountBilling_currentPlan_nutshellIq_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetAccountBilling_accountBilling_currentPlan_nutshellIq_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface GetAccountBilling_accountBilling_currentPlan_nutshellIq {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: GetAccountBilling_accountBilling_currentPlan_nutshellIq_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: GetAccountBilling_accountBilling_currentPlan_nutshellIq_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface GetAccountBilling_accountBilling_currentPlan_inbox_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetAccountBilling_accountBilling_currentPlan_inbox_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface GetAccountBilling_accountBilling_currentPlan_inbox {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: GetAccountBilling_accountBilling_currentPlan_inbox_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: GetAccountBilling_accountBilling_currentPlan_inbox_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface GetAccountBilling_accountBilling_currentPlan_marketingSuite_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetAccountBilling_accountBilling_currentPlan_marketingSuite_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface GetAccountBilling_accountBilling_currentPlan_marketingSuite {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: GetAccountBilling_accountBilling_currentPlan_marketingSuite_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: GetAccountBilling_accountBilling_currentPlan_marketingSuite_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface GetAccountBilling_accountBilling_currentPlan_smsCampaigns_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetAccountBilling_accountBilling_currentPlan_smsCampaigns_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface GetAccountBilling_accountBilling_currentPlan_smsCampaigns {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: GetAccountBilling_accountBilling_currentPlan_smsCampaigns_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: GetAccountBilling_accountBilling_currentPlan_smsCampaigns_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface GetAccountBilling_accountBilling_currentPlan_quotes_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetAccountBilling_accountBilling_currentPlan_quotes_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface GetAccountBilling_accountBilling_currentPlan_quotes {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: GetAccountBilling_accountBilling_currentPlan_quotes_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: GetAccountBilling_accountBilling_currentPlan_quotes_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface GetAccountBilling_accountBilling_currentPlan_nutshellAdvisor_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetAccountBilling_accountBilling_currentPlan_nutshellAdvisor_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface GetAccountBilling_accountBilling_currentPlan_nutshellAdvisor {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: GetAccountBilling_accountBilling_currentPlan_nutshellAdvisor_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: GetAccountBilling_accountBilling_currentPlan_nutshellAdvisor_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface GetAccountBilling_accountBilling_currentPlan {
  __typename: "AccountPlan";
  /**
   * The total monthly cost of all subscriptions
   */
  totalMonth: number;
  /**
   * The total display monthly cost of all subscriptions
   */
  totalMonthDisplay: string;
  /**
   * The sub total (pre account wide coupon) display monthly cost of all subscriptions
   */
  subtotalMonthDisplay: string;
  /**
   * The total display discount applied to the account
   */
  accountDiscountDisplay: string;
  /**
   * The coupon applied to the whole account
   */
  accountCoupons: GetAccountBilling_accountBilling_currentPlan_accountCoupons[];
  /**
   * The next estimated invoice for the account plan
   */
  nextEstimatedInvoice: GetAccountBilling_accountBilling_currentPlan_nextEstimatedInvoice | null;
  /**
   * Next estimated invoices split by monthly and annual billing cycles
   */
  splitEstimatedInvoices: GetAccountBilling_accountBilling_currentPlan_splitEstimatedInvoices;
  /**
   * Whether the account plan is cancelled
   */
  isCancelled: boolean;
  /**
   * The subscription for the CRM plan
   */
  crm: GetAccountBilling_accountBilling_currentPlan_crm | null;
  /**
   * The subscription for the Marketing plan
   */
  marketing: GetAccountBilling_accountBilling_currentPlan_marketing | null;
  /**
   * The subscription for the Revenue Booster plan
   */
  revenueBooster: GetAccountBilling_accountBilling_currentPlan_revenueBooster | null;
  /**
   * The subscription for the Nutshell IQ plan
   */
  nutshellIq: GetAccountBilling_accountBilling_currentPlan_nutshellIq | null;
  /**
   * The subscription for the inbox plan
   */
  inbox: GetAccountBilling_accountBilling_currentPlan_inbox | null;
  /**
   * The subscription for the marketing suite plan
   */
  marketingSuite: GetAccountBilling_accountBilling_currentPlan_marketingSuite | null;
  /**
   * The subscription for the SMS campaigns plans
   */
  smsCampaigns: GetAccountBilling_accountBilling_currentPlan_smsCampaigns | null;
  /**
   * The subscription for the Quotes plan
   */
  quotes: GetAccountBilling_accountBilling_currentPlan_quotes | null;
  /**
   * The subscription for the Nutshell Advisor plan
   */
  nutshellAdvisor: GetAccountBilling_accountBilling_currentPlan_nutshellAdvisor | null;
}

export interface GetAccountBilling_accountBilling_lastThreeInvoices {
  __typename: "BillingInvoice";
  /**
   * The Recurly id of the invoice
   */
  id: string;
  /**
   * The total amount of the invoice
   */
  amount: string;
  /**
   * The timestamp date the invoice was created
   */
  date: any;
}

export interface GetAccountBilling_accountBilling {
  __typename: "AccountBilling";
  /**
   * The name of the coupon
   */
  currentPlan: GetAccountBilling_accountBilling_currentPlan | null;
  /**
   * The last three invoices for the account plan
   */
  lastThreeInvoices: GetAccountBilling_accountBilling_lastThreeInvoices[];
}

export interface GetAccountBilling {
  /**
   * Returns the current state of a Recurly account
   */
  accountBilling: GetAccountBilling_accountBilling;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAvailablePlans
// ====================================================

export interface GetAvailablePlans_recurlyAvailablePlans_crm_plans_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetAvailablePlans_recurlyAvailablePlans_crm_plans {
  __typename: "Plan";
  /**
   * The product type associated with the plan
   */
  product: BillingProductType;
  /**
   * code for product type and tier of that product
   */
  code: string;
  /**
   * Description of the plan
   */
  description: string;
  /**
   * The billing cycle for the plan (monthly vs. annual)
   */
  cycleText: CycleType;
  /**
   * Highlights of the plan
   */
  planHighlights: string[];
  /**
   * Text describing that the prior plans features are included (non-legacy crm only)
   */
  priorFeaturesText: string | null;
  /**
   * Text describing the recurrence of the the plan.
   */
  priceUnit: string | null;
  /**
   * The actual price of the plan after discounts
   */
  price: string;
  /**
   * Text to provide a shorter name of the plan
   */
  shortenedName: string | null;
  /**
   * The sticker price of the plan
   */
  stickerPrice: string;
  /**
   * Whether the plan is currently active
   */
  isActive: boolean;
  /**
   * Number of users for user plans, or 0/1 for addons
   */
  quantity: number;
  /**
   * The add-on unit (EX IQ credits)
   */
  productQuantity: number;
  /**
   * Whether the plan is a legacy plan
   */
  isLegacy: boolean;
  /**
   * Whether the plan is a fake plan thats been injected manually
   */
  isFake: boolean;
  /**
   * Text describing sub information around adding the plan
   */
  subtitleText: string | null;
  /**
   * Coupon applied to the plan
   */
  coupon: GetAvailablePlans_recurlyAvailablePlans_crm_plans_coupon | null;
  /**
   * The human-readable name of the plan
   */
  nameDisplay: string | null;
  /**
   * The name of the plan
   */
  name: string;
}

export interface GetAvailablePlans_recurlyAvailablePlans_crm_cachedPlan {
  __typename: "CachedPlan";
  /**
   * The code of the plan
   */
  code: string;
  /**
   * The number of licenses for the plan. Only applies to suite plans
   */
  licenseCount: number | null;
}

export interface GetAvailablePlans_recurlyAvailablePlans_crm {
  __typename: "PlanGroupCrm";
  /**
   * The default code for the plan type
   */
  defaultCode: string;
  /**
   * The active plan code for the plan type
   */
  activePlanCode: string | null;
  /**
   * The plans in the plan type
   */
  plans: GetAvailablePlans_recurlyAvailablePlans_crm_plans[];
  /**
   * Whether the plan is quantity based
   */
  isUserQuantityBased: boolean;
  /**
   * The cached plan for the plan type
   */
  cachedPlan: GetAvailablePlans_recurlyAvailablePlans_crm_cachedPlan | null;
  /**
   * Whether the plan is cycle based (annually or monthly)
   */
  isCycleBased: boolean;
  /**
   * The number of enabled users
   */
  enabledUsers: number;
  /**
   * The number of marketing licenses
   */
  numMarketingLicenses: number;
}

export interface GetAvailablePlans_recurlyAvailablePlans_marketing_plans_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetAvailablePlans_recurlyAvailablePlans_marketing_plans {
  __typename: "Plan";
  /**
   * The product type associated with the plan
   */
  product: BillingProductType;
  /**
   * code for product type and tier of that product
   */
  code: string;
  /**
   * Description of the plan
   */
  description: string;
  /**
   * The billing cycle for the plan (monthly vs. annual)
   */
  cycleText: CycleType;
  /**
   * Highlights of the plan
   */
  planHighlights: string[];
  /**
   * Text describing that the prior plans features are included (non-legacy crm only)
   */
  priorFeaturesText: string | null;
  /**
   * Text describing the recurrence of the the plan.
   */
  priceUnit: string | null;
  /**
   * The actual price of the plan after discounts
   */
  price: string;
  /**
   * Text to provide a shorter name of the plan
   */
  shortenedName: string | null;
  /**
   * The sticker price of the plan
   */
  stickerPrice: string;
  /**
   * Whether the plan is currently active
   */
  isActive: boolean;
  /**
   * Number of users for user plans, or 0/1 for addons
   */
  quantity: number;
  /**
   * The add-on unit (EX IQ credits)
   */
  productQuantity: number;
  /**
   * Whether the plan is a legacy plan
   */
  isLegacy: boolean;
  /**
   * Whether the plan is a fake plan thats been injected manually
   */
  isFake: boolean;
  /**
   * Text describing sub information around adding the plan
   */
  subtitleText: string | null;
  /**
   * Coupon applied to the plan
   */
  coupon: GetAvailablePlans_recurlyAvailablePlans_marketing_plans_coupon | null;
  /**
   * The human-readable name of the plan
   */
  nameDisplay: string | null;
  /**
   * The name of the plan
   */
  name: string;
}

export interface GetAvailablePlans_recurlyAvailablePlans_marketing_cachedPlan {
  __typename: "CachedPlan";
  /**
   * The code of the plan
   */
  code: string;
  /**
   * The number of licenses for the plan. Only applies to suite plans
   */
  licenseCount: number | null;
}

export interface GetAvailablePlans_recurlyAvailablePlans_marketing {
  __typename: "PlanGroupMarketing";
  /**
   * The default code for the plan type
   */
  defaultCode: string;
  /**
   * The active plan code for the plan type
   */
  activePlanCode: string | null;
  /**
   * The plans in the plan type
   */
  plans: GetAvailablePlans_recurlyAvailablePlans_marketing_plans[];
  /**
   * Whether the plan is quantity based
   */
  isUserQuantityBased: boolean;
  /**
   * The cached plan for the plan type
   */
  cachedPlan: GetAvailablePlans_recurlyAvailablePlans_marketing_cachedPlan | null;
  /**
   * Whether the plan is cycle based (annually or monthly)
   */
  isCycleBased: boolean;
  /**
   * The number of marketing contacts
   */
  numMarketingContacts: number;
  /**
   * The number of marketing contacts
   */
  numMarketingContactsAllowed: number | null;
  /**
   * The number of marketing contacts
   */
  contactUsEndCap: number | null;
  /**
   * The optional override set for max contact limit in this instance
   */
  numMarketingContactsAllowedOverride: number | null;
}

export interface GetAvailablePlans_recurlyAvailablePlans_revenueBooster_plans_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetAvailablePlans_recurlyAvailablePlans_revenueBooster_plans {
  __typename: "Plan";
  /**
   * The product type associated with the plan
   */
  product: BillingProductType;
  /**
   * code for product type and tier of that product
   */
  code: string;
  /**
   * Description of the plan
   */
  description: string;
  /**
   * The billing cycle for the plan (monthly vs. annual)
   */
  cycleText: CycleType;
  /**
   * Highlights of the plan
   */
  planHighlights: string[];
  /**
   * Text describing that the prior plans features are included (non-legacy crm only)
   */
  priorFeaturesText: string | null;
  /**
   * Text describing the recurrence of the the plan.
   */
  priceUnit: string | null;
  /**
   * The actual price of the plan after discounts
   */
  price: string;
  /**
   * Text to provide a shorter name of the plan
   */
  shortenedName: string | null;
  /**
   * The sticker price of the plan
   */
  stickerPrice: string;
  /**
   * Whether the plan is currently active
   */
  isActive: boolean;
  /**
   * Number of users for user plans, or 0/1 for addons
   */
  quantity: number;
  /**
   * The add-on unit (EX IQ credits)
   */
  productQuantity: number;
  /**
   * Whether the plan is a legacy plan
   */
  isLegacy: boolean;
  /**
   * Whether the plan is a fake plan thats been injected manually
   */
  isFake: boolean;
  /**
   * Text describing sub information around adding the plan
   */
  subtitleText: string | null;
  /**
   * Coupon applied to the plan
   */
  coupon: GetAvailablePlans_recurlyAvailablePlans_revenueBooster_plans_coupon | null;
  /**
   * The human-readable name of the plan
   */
  nameDisplay: string | null;
  /**
   * The name of the plan
   */
  name: string;
}

export interface GetAvailablePlans_recurlyAvailablePlans_revenueBooster_cachedPlan {
  __typename: "CachedPlan";
  /**
   * The code of the plan
   */
  code: string;
  /**
   * The number of licenses for the plan. Only applies to suite plans
   */
  licenseCount: number | null;
}

export interface GetAvailablePlans_recurlyAvailablePlans_revenueBooster {
  __typename: "PlanGroupBase";
  /**
   * The default code for the plan type
   */
  defaultCode: string;
  /**
   * The active plan code for the plan type
   */
  activePlanCode: string | null;
  /**
   * The plans in the plan type
   */
  plans: GetAvailablePlans_recurlyAvailablePlans_revenueBooster_plans[];
  /**
   * Whether the plan is quantity based
   */
  isUserQuantityBased: boolean;
  /**
   * The cached plan for the plan type
   */
  cachedPlan: GetAvailablePlans_recurlyAvailablePlans_revenueBooster_cachedPlan | null;
  /**
   * Whether the plan is cycle based (annually or monthly)
   */
  isCycleBased: boolean;
}

export interface GetAvailablePlans_recurlyAvailablePlans_nutshellIq_plans_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetAvailablePlans_recurlyAvailablePlans_nutshellIq_plans {
  __typename: "Plan";
  /**
   * The product type associated with the plan
   */
  product: BillingProductType;
  /**
   * code for product type and tier of that product
   */
  code: string;
  /**
   * Description of the plan
   */
  description: string;
  /**
   * The billing cycle for the plan (monthly vs. annual)
   */
  cycleText: CycleType;
  /**
   * Highlights of the plan
   */
  planHighlights: string[];
  /**
   * Text describing that the prior plans features are included (non-legacy crm only)
   */
  priorFeaturesText: string | null;
  /**
   * Text describing the recurrence of the the plan.
   */
  priceUnit: string | null;
  /**
   * The actual price of the plan after discounts
   */
  price: string;
  /**
   * Text to provide a shorter name of the plan
   */
  shortenedName: string | null;
  /**
   * The sticker price of the plan
   */
  stickerPrice: string;
  /**
   * Whether the plan is currently active
   */
  isActive: boolean;
  /**
   * Number of users for user plans, or 0/1 for addons
   */
  quantity: number;
  /**
   * The add-on unit (EX IQ credits)
   */
  productQuantity: number;
  /**
   * Whether the plan is a legacy plan
   */
  isLegacy: boolean;
  /**
   * Whether the plan is a fake plan thats been injected manually
   */
  isFake: boolean;
  /**
   * Text describing sub information around adding the plan
   */
  subtitleText: string | null;
  /**
   * Coupon applied to the plan
   */
  coupon: GetAvailablePlans_recurlyAvailablePlans_nutshellIq_plans_coupon | null;
  /**
   * The human-readable name of the plan
   */
  nameDisplay: string | null;
  /**
   * The name of the plan
   */
  name: string;
}

export interface GetAvailablePlans_recurlyAvailablePlans_nutshellIq_cachedPlan {
  __typename: "CachedPlan";
  /**
   * The code of the plan
   */
  code: string;
  /**
   * The number of licenses for the plan. Only applies to suite plans
   */
  licenseCount: number | null;
}

export interface GetAvailablePlans_recurlyAvailablePlans_nutshellIq {
  __typename: "PlanGroupNutshellIq";
  /**
   * The default code for the plan type
   */
  defaultCode: string;
  /**
   * The active plan code for the plan type
   */
  activePlanCode: string | null;
  /**
   * The plans in the plan type
   */
  plans: GetAvailablePlans_recurlyAvailablePlans_nutshellIq_plans[];
  /**
   * Whether the plan is quantity based
   */
  isUserQuantityBased: boolean;
  /**
   * The cached plan for the plan type
   */
  cachedPlan: GetAvailablePlans_recurlyAvailablePlans_nutshellIq_cachedPlan | null;
  /**
   * Whether the plan is cycle based (annually or monthly)
   */
  isCycleBased: boolean;
}

export interface GetAvailablePlans_recurlyAvailablePlans_inbox_plans_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetAvailablePlans_recurlyAvailablePlans_inbox_plans {
  __typename: "Plan";
  /**
   * The product type associated with the plan
   */
  product: BillingProductType;
  /**
   * code for product type and tier of that product
   */
  code: string;
  /**
   * Description of the plan
   */
  description: string;
  /**
   * The billing cycle for the plan (monthly vs. annual)
   */
  cycleText: CycleType;
  /**
   * Highlights of the plan
   */
  planHighlights: string[];
  /**
   * Text describing that the prior plans features are included (non-legacy crm only)
   */
  priorFeaturesText: string | null;
  /**
   * Text describing the recurrence of the the plan.
   */
  priceUnit: string | null;
  /**
   * The actual price of the plan after discounts
   */
  price: string;
  /**
   * Text to provide a shorter name of the plan
   */
  shortenedName: string | null;
  /**
   * The sticker price of the plan
   */
  stickerPrice: string;
  /**
   * Whether the plan is currently active
   */
  isActive: boolean;
  /**
   * Number of users for user plans, or 0/1 for addons
   */
  quantity: number;
  /**
   * The add-on unit (EX IQ credits)
   */
  productQuantity: number;
  /**
   * Whether the plan is a legacy plan
   */
  isLegacy: boolean;
  /**
   * Whether the plan is a fake plan thats been injected manually
   */
  isFake: boolean;
  /**
   * Text describing sub information around adding the plan
   */
  subtitleText: string | null;
  /**
   * Coupon applied to the plan
   */
  coupon: GetAvailablePlans_recurlyAvailablePlans_inbox_plans_coupon | null;
  /**
   * The human-readable name of the plan
   */
  nameDisplay: string | null;
  /**
   * The name of the plan
   */
  name: string;
}

export interface GetAvailablePlans_recurlyAvailablePlans_inbox_cachedPlan {
  __typename: "CachedPlan";
  /**
   * The code of the plan
   */
  code: string;
  /**
   * The number of licenses for the plan. Only applies to suite plans
   */
  licenseCount: number | null;
}

export interface GetAvailablePlans_recurlyAvailablePlans_inbox {
  __typename: "PlanGroupInbox";
  /**
   * The default code for the plan type
   */
  defaultCode: string;
  /**
   * The active plan code for the plan type
   */
  activePlanCode: string | null;
  /**
   * The plans in the plan type
   */
  plans: GetAvailablePlans_recurlyAvailablePlans_inbox_plans[];
  /**
   * Whether the plan is quantity based
   */
  isUserQuantityBased: boolean;
  /**
   * The cached plan for the plan type
   */
  cachedPlan: GetAvailablePlans_recurlyAvailablePlans_inbox_cachedPlan | null;
  /**
   * Whether the plan is cycle based (annually or monthly)
   */
  isCycleBased: boolean;
  /**
   * The number of enabled users
   */
  enabledUsers: number;
  /**
   * The number of enabled licenses
   */
  numEnabledLicenses: number;
  /**
   * The number of billed licenses
   */
  numBilledLicenses: number;
}

export interface GetAvailablePlans_recurlyAvailablePlans_smsCampaigns_plans_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetAvailablePlans_recurlyAvailablePlans_smsCampaigns_plans {
  __typename: "Plan";
  /**
   * The product type associated with the plan
   */
  product: BillingProductType;
  /**
   * code for product type and tier of that product
   */
  code: string;
  /**
   * Description of the plan
   */
  description: string;
  /**
   * The billing cycle for the plan (monthly vs. annual)
   */
  cycleText: CycleType;
  /**
   * Highlights of the plan
   */
  planHighlights: string[];
  /**
   * Text describing that the prior plans features are included (non-legacy crm only)
   */
  priorFeaturesText: string | null;
  /**
   * Text describing the recurrence of the the plan.
   */
  priceUnit: string | null;
  /**
   * The actual price of the plan after discounts
   */
  price: string;
  /**
   * Text to provide a shorter name of the plan
   */
  shortenedName: string | null;
  /**
   * The sticker price of the plan
   */
  stickerPrice: string;
  /**
   * Whether the plan is currently active
   */
  isActive: boolean;
  /**
   * Number of users for user plans, or 0/1 for addons
   */
  quantity: number;
  /**
   * The add-on unit (EX IQ credits)
   */
  productQuantity: number;
  /**
   * Whether the plan is a legacy plan
   */
  isLegacy: boolean;
  /**
   * Whether the plan is a fake plan thats been injected manually
   */
  isFake: boolean;
  /**
   * Text describing sub information around adding the plan
   */
  subtitleText: string | null;
  /**
   * Coupon applied to the plan
   */
  coupon: GetAvailablePlans_recurlyAvailablePlans_smsCampaigns_plans_coupon | null;
  /**
   * The human-readable name of the plan
   */
  nameDisplay: string | null;
  /**
   * The name of the plan
   */
  name: string;
}

export interface GetAvailablePlans_recurlyAvailablePlans_smsCampaigns_cachedPlan {
  __typename: "CachedPlan";
  /**
   * The code of the plan
   */
  code: string;
  /**
   * The number of licenses for the plan. Only applies to suite plans
   */
  licenseCount: number | null;
}

export interface GetAvailablePlans_recurlyAvailablePlans_smsCampaigns {
  __typename: "PlanGroupSmsCampaigns";
  /**
   * The default code for the plan type
   */
  defaultCode: string;
  /**
   * The active plan code for the plan type
   */
  activePlanCode: string | null;
  /**
   * The plans in the plan type
   */
  plans: GetAvailablePlans_recurlyAvailablePlans_smsCampaigns_plans[];
  /**
   * Whether the plan is quantity based
   */
  isUserQuantityBased: boolean;
  /**
   * The cached plan for the plan type
   */
  cachedPlan: GetAvailablePlans_recurlyAvailablePlans_smsCampaigns_cachedPlan | null;
  /**
   * Whether the plan is cycle based (annually or monthly)
   */
  isCycleBased: boolean;
}

export interface GetAvailablePlans_recurlyAvailablePlans_marketingSuite_plans_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetAvailablePlans_recurlyAvailablePlans_marketingSuite_plans {
  __typename: "Plan";
  /**
   * The product type associated with the plan
   */
  product: BillingProductType;
  /**
   * code for product type and tier of that product
   */
  code: string;
  /**
   * Description of the plan
   */
  description: string;
  /**
   * The billing cycle for the plan (monthly vs. annual)
   */
  cycleText: CycleType;
  /**
   * Highlights of the plan
   */
  planHighlights: string[];
  /**
   * Text describing that the prior plans features are included (non-legacy crm only)
   */
  priorFeaturesText: string | null;
  /**
   * Text describing the recurrence of the the plan.
   */
  priceUnit: string | null;
  /**
   * The actual price of the plan after discounts
   */
  price: string;
  /**
   * Text to provide a shorter name of the plan
   */
  shortenedName: string | null;
  /**
   * The sticker price of the plan
   */
  stickerPrice: string;
  /**
   * Whether the plan is currently active
   */
  isActive: boolean;
  /**
   * Number of users for user plans, or 0/1 for addons
   */
  quantity: number;
  /**
   * The add-on unit (EX IQ credits)
   */
  productQuantity: number;
  /**
   * Whether the plan is a legacy plan
   */
  isLegacy: boolean;
  /**
   * Whether the plan is a fake plan thats been injected manually
   */
  isFake: boolean;
  /**
   * Text describing sub information around adding the plan
   */
  subtitleText: string | null;
  /**
   * Coupon applied to the plan
   */
  coupon: GetAvailablePlans_recurlyAvailablePlans_marketingSuite_plans_coupon | null;
  /**
   * The human-readable name of the plan
   */
  nameDisplay: string | null;
  /**
   * The name of the plan
   */
  name: string;
}

export interface GetAvailablePlans_recurlyAvailablePlans_marketingSuite_cachedPlan {
  __typename: "CachedPlan";
  /**
   * The code of the plan
   */
  code: string;
  /**
   * The number of licenses for the plan. Only applies to suite plans
   */
  licenseCount: number | null;
}

export interface GetAvailablePlans_recurlyAvailablePlans_marketingSuite {
  __typename: "PlanGroupMarketingSuite";
  /**
   * The default code for the plan type
   */
  defaultCode: string;
  /**
   * The active plan code for the plan type
   */
  activePlanCode: string | null;
  /**
   * The plans in the plan type
   */
  plans: GetAvailablePlans_recurlyAvailablePlans_marketingSuite_plans[];
  /**
   * Whether the plan is quantity based
   */
  isUserQuantityBased: boolean;
  /**
   * The cached plan for the plan type
   */
  cachedPlan: GetAvailablePlans_recurlyAvailablePlans_marketingSuite_cachedPlan | null;
  /**
   * Whether the plan is cycle based (annually or monthly)
   */
  isCycleBased: boolean;
}

export interface GetAvailablePlans_recurlyAvailablePlans_quotes_plans_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetAvailablePlans_recurlyAvailablePlans_quotes_plans {
  __typename: "Plan";
  /**
   * The product type associated with the plan
   */
  product: BillingProductType;
  /**
   * code for product type and tier of that product
   */
  code: string;
  /**
   * Description of the plan
   */
  description: string;
  /**
   * The billing cycle for the plan (monthly vs. annual)
   */
  cycleText: CycleType;
  /**
   * Highlights of the plan
   */
  planHighlights: string[];
  /**
   * Text describing that the prior plans features are included (non-legacy crm only)
   */
  priorFeaturesText: string | null;
  /**
   * Text describing the recurrence of the the plan.
   */
  priceUnit: string | null;
  /**
   * The actual price of the plan after discounts
   */
  price: string;
  /**
   * Text to provide a shorter name of the plan
   */
  shortenedName: string | null;
  /**
   * The sticker price of the plan
   */
  stickerPrice: string;
  /**
   * Whether the plan is currently active
   */
  isActive: boolean;
  /**
   * Number of users for user plans, or 0/1 for addons
   */
  quantity: number;
  /**
   * The add-on unit (EX IQ credits)
   */
  productQuantity: number;
  /**
   * Whether the plan is a legacy plan
   */
  isLegacy: boolean;
  /**
   * Whether the plan is a fake plan thats been injected manually
   */
  isFake: boolean;
  /**
   * Text describing sub information around adding the plan
   */
  subtitleText: string | null;
  /**
   * Coupon applied to the plan
   */
  coupon: GetAvailablePlans_recurlyAvailablePlans_quotes_plans_coupon | null;
  /**
   * The human-readable name of the plan
   */
  nameDisplay: string | null;
  /**
   * The name of the plan
   */
  name: string;
}

export interface GetAvailablePlans_recurlyAvailablePlans_quotes_cachedPlan {
  __typename: "CachedPlan";
  /**
   * The code of the plan
   */
  code: string;
  /**
   * The number of licenses for the plan. Only applies to suite plans
   */
  licenseCount: number | null;
}

export interface GetAvailablePlans_recurlyAvailablePlans_quotes {
  __typename: "PlanGroupQuotes";
  /**
   * The default code for the plan type
   */
  defaultCode: string;
  /**
   * The active plan code for the plan type
   */
  activePlanCode: string | null;
  /**
   * The plans in the plan type
   */
  plans: GetAvailablePlans_recurlyAvailablePlans_quotes_plans[];
  /**
   * Whether the plan is quantity based
   */
  isUserQuantityBased: boolean;
  /**
   * The cached plan for the plan type
   */
  cachedPlan: GetAvailablePlans_recurlyAvailablePlans_quotes_cachedPlan | null;
  /**
   * Whether the plan is cycle based (annually or monthly)
   */
  isCycleBased: boolean;
}

export interface GetAvailablePlans_recurlyAvailablePlans_nutshellAdvisor_plans_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetAvailablePlans_recurlyAvailablePlans_nutshellAdvisor_plans {
  __typename: "Plan";
  /**
   * The product type associated with the plan
   */
  product: BillingProductType;
  /**
   * code for product type and tier of that product
   */
  code: string;
  /**
   * Description of the plan
   */
  description: string;
  /**
   * The billing cycle for the plan (monthly vs. annual)
   */
  cycleText: CycleType;
  /**
   * Highlights of the plan
   */
  planHighlights: string[];
  /**
   * Text describing that the prior plans features are included (non-legacy crm only)
   */
  priorFeaturesText: string | null;
  /**
   * Text describing the recurrence of the the plan.
   */
  priceUnit: string | null;
  /**
   * The actual price of the plan after discounts
   */
  price: string;
  /**
   * Text to provide a shorter name of the plan
   */
  shortenedName: string | null;
  /**
   * The sticker price of the plan
   */
  stickerPrice: string;
  /**
   * Whether the plan is currently active
   */
  isActive: boolean;
  /**
   * Number of users for user plans, or 0/1 for addons
   */
  quantity: number;
  /**
   * The add-on unit (EX IQ credits)
   */
  productQuantity: number;
  /**
   * Whether the plan is a legacy plan
   */
  isLegacy: boolean;
  /**
   * Whether the plan is a fake plan thats been injected manually
   */
  isFake: boolean;
  /**
   * Text describing sub information around adding the plan
   */
  subtitleText: string | null;
  /**
   * Coupon applied to the plan
   */
  coupon: GetAvailablePlans_recurlyAvailablePlans_nutshellAdvisor_plans_coupon | null;
  /**
   * The human-readable name of the plan
   */
  nameDisplay: string | null;
  /**
   * The name of the plan
   */
  name: string;
}

export interface GetAvailablePlans_recurlyAvailablePlans_nutshellAdvisor_cachedPlan {
  __typename: "CachedPlan";
  /**
   * The code of the plan
   */
  code: string;
  /**
   * The number of licenses for the plan. Only applies to suite plans
   */
  licenseCount: number | null;
}

export interface GetAvailablePlans_recurlyAvailablePlans_nutshellAdvisor {
  __typename: "PlanGroupNutshellAdvisor";
  /**
   * The default code for the plan type
   */
  defaultCode: string;
  /**
   * The active plan code for the plan type
   */
  activePlanCode: string | null;
  /**
   * The plans in the plan type
   */
  plans: GetAvailablePlans_recurlyAvailablePlans_nutshellAdvisor_plans[];
  /**
   * Whether the plan is quantity based
   */
  isUserQuantityBased: boolean;
  /**
   * The cached plan for the plan type
   */
  cachedPlan: GetAvailablePlans_recurlyAvailablePlans_nutshellAdvisor_cachedPlan | null;
  /**
   * Whether the plan is cycle based (annually or monthly)
   */
  isCycleBased: boolean;
}

export interface GetAvailablePlans_recurlyAvailablePlans {
  __typename: "AvailablePlans";
  /**
   * The available crms plans
   */
  crm: GetAvailablePlans_recurlyAvailablePlans_crm;
  /**
   * The available marketing add-on plans
   */
  marketing: GetAvailablePlans_recurlyAvailablePlans_marketing;
  /**
   * The available revenue booster add-on plans
   */
  revenueBooster: GetAvailablePlans_recurlyAvailablePlans_revenueBooster;
  /**
   * The available Nutshell IQ add-on plans
   */
  nutshellIq: GetAvailablePlans_recurlyAvailablePlans_nutshellIq;
  /**
   * The available inbox plans
   */
  inbox: GetAvailablePlans_recurlyAvailablePlans_inbox;
  /**
   * The available SMS campaigns add-on plans
   */
  smsCampaigns: GetAvailablePlans_recurlyAvailablePlans_smsCampaigns;
  /**
   * The available marketing suite plans
   */
  marketingSuite: GetAvailablePlans_recurlyAvailablePlans_marketingSuite;
  /**
   * The available quotes plans
   */
  quotes: GetAvailablePlans_recurlyAvailablePlans_quotes;
  /**
   * The available Nutshell Advisor plans
   */
  nutshellAdvisor: GetAvailablePlans_recurlyAvailablePlans_nutshellAdvisor;
}

export interface GetAvailablePlans {
  /**
   * All available plans from Recurly
   */
  recurlyAvailablePlans: GetAvailablePlans_recurlyAvailablePlans;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBillingDefaults
// ====================================================

export interface GetBillingDefaults_billingDefaults_address {
  __typename: "AddressInfo";
  /**
   * The first line of the address
   */
  address1: string;
  /**
   * The second line of the address
   */
  address2: string;
  /**
   * The city of the address
   */
  city: string;
  /**
   * The state of the address
   */
  state: string;
  /**
   * The postal code of the address
   */
  postal: string;
  /**
   * The country of the address
   */
  country: string;
}

export interface GetBillingDefaults_billingDefaults {
  __typename: "BillingDefaults";
  /**
   * Default email address
   */
  email: string | null;
  /**
   * Default first name
   */
  firstName: string | null;
  /**
   * Default last name
   */
  lastName: string | null;
  /**
   * Default company name
   */
  companyName: string;
  /**
   * Default address
   */
  address: GetBillingDefaults_billingDefaults_address;
}

export interface GetBillingDefaults {
  /**
   * Returns default billing form values for the current user
   */
  billingDefaults: GetBillingDefaults_billingDefaults;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBillingInfo
// ====================================================

export interface GetBillingInfo_billingInfo_bankInfo {
  __typename: "BankInfo";
  /**
   * The type of bank account
   */
  accountType: string;
  /**
   * The last four digits of the bank account number
   */
  accountNumber: string;
  /**
   * The name on the bank account
   */
  nameOnAccount: string;
  /**
   * The routing number of the bank account
   */
  routingNumber: string;
}

export interface GetBillingInfo_billingInfo_cardInfo {
  __typename: "CardInfo";
  /**
   * The last four digits of the credit card
   */
  lastFourDigits: string;
  /**
   * The first name on the credit card
   */
  firstName: string;
  /**
   * The last name on the credit card
   */
  lastName: string;
  /**
   * The expiration month of the credit card
   */
  expirationMonth: string;
  /**
   * The expiration year of the credit card
   */
  expirationYear: string;
  /**
   * The type of credit card
   */
  cardType: string;
}

export interface GetBillingInfo_billingInfo_addressInfo {
  __typename: "AddressInfo";
  /**
   * The first line of the address
   */
  address1: string;
  /**
   * The second line of the address
   */
  address2: string;
  /**
   * The city of the address
   */
  city: string;
  /**
   * The postal code of the address
   */
  postal: string;
  /**
   * The state of the address
   */
  state: string;
  /**
   * The country of the address
   */
  country: string;
}

export interface GetBillingInfo_billingInfo {
  __typename: "BillingInfo";
  /**
   * The phone number associated with this account
   */
  phoneNumber: string;
  /**
   * The formatted phone number associated with this account
   */
  phoneNumberFormatted: string;
  /**
   * The email address associated with this account
   */
  email: string;
  /**
   * The company name associated with this account
   */
  companyName: string;
  /**
   * The first name associated with this account
   */
  firstName: string;
  /**
   * The last name associated with this account
   */
  lastName: string;
  /**
   * The display name associated with this account
   */
  displayName: string;
  /**
   * Whether this account is a new subscription
   */
  isNewSubscription: boolean;
  /**
   * Whether the billing information is valid
   */
  isValid: boolean;
  /**
   * Banking information associated with this account
   */
  bankInfo: GetBillingInfo_billingInfo_bankInfo | null;
  /**
   * Credit card information associated with this account
   */
  cardInfo: GetBillingInfo_billingInfo_cardInfo | null;
  /**
   * Address information associated with this account
   */
  addressInfo: GetBillingInfo_billingInfo_addressInfo;
}

export interface GetBillingInfo {
  /**
   * Returns current Recurly billing information
   */
  billingInfo: GetBillingInfo_billingInfo | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCancellationOffer
// ====================================================

export interface GetCancellationOffer_cancellationOffer {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
  /**
   * How long the discount lasts: "forever", "single_use", or "temporal"
   */
  duration: string;
  /**
   * The unit the discount lasts for ("day", "week", "month", "year"). Only set for temporal coupons.
   */
  temporalUnit: string | null;
  /**
   * How many temporal units the discount lasts for. Only set for temporal coupons.
   */
  temporalAmount: number | null;
}

export interface GetCancellationOffer {
  /**
   * The retention coupon offered before cancellation, or null if this account is not eligible
   */
  cancellationOffer: GetCancellationOffer_cancellationOffer | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetInvoicePreview
// ====================================================

export interface GetInvoicePreview_invoicePreview_plan_accountCoupons {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetInvoicePreview_invoicePreview_plan_nextEstimatedInvoice {
  __typename: "BillingInvoice";
  /**
   * The Recurly id of the invoice
   */
  id: string;
  /**
   * The total amount of the invoice
   */
  amount: string;
  /**
   * The timestamp date the invoice was created
   */
  date: any;
}

export interface GetInvoicePreview_invoicePreview_plan_splitEstimatedInvoices_monthly {
  __typename: "BillingInvoice";
  /**
   * The Recurly id of the invoice
   */
  id: string;
  /**
   * The total amount of the invoice
   */
  amount: string;
  /**
   * The timestamp date the invoice was created
   */
  date: any;
}

export interface GetInvoicePreview_invoicePreview_plan_splitEstimatedInvoices_annual {
  __typename: "BillingInvoice";
  /**
   * The Recurly id of the invoice
   */
  id: string;
  /**
   * The total amount of the invoice
   */
  amount: string;
  /**
   * The timestamp date the invoice was created
   */
  date: any;
}

export interface GetInvoicePreview_invoicePreview_plan_splitEstimatedInvoices {
  __typename: "SplitEstimatedInvoices";
  /**
   * The next estimated invoice for monthly-billed subscriptions
   */
  monthly: GetInvoicePreview_invoicePreview_plan_splitEstimatedInvoices_monthly | null;
  /**
   * The next estimated invoice for annually-billed subscriptions
   */
  annual: GetInvoicePreview_invoicePreview_plan_splitEstimatedInvoices_annual | null;
}

export interface GetInvoicePreview_invoicePreview_plan_crm_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetInvoicePreview_invoicePreview_plan_crm_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface GetInvoicePreview_invoicePreview_plan_crm {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: GetInvoicePreview_invoicePreview_plan_crm_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: GetInvoicePreview_invoicePreview_plan_crm_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface GetInvoicePreview_invoicePreview_plan_marketing_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetInvoicePreview_invoicePreview_plan_marketing_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface GetInvoicePreview_invoicePreview_plan_marketing {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: GetInvoicePreview_invoicePreview_plan_marketing_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: GetInvoicePreview_invoicePreview_plan_marketing_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface GetInvoicePreview_invoicePreview_plan_revenueBooster_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetInvoicePreview_invoicePreview_plan_revenueBooster_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface GetInvoicePreview_invoicePreview_plan_revenueBooster {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: GetInvoicePreview_invoicePreview_plan_revenueBooster_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: GetInvoicePreview_invoicePreview_plan_revenueBooster_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface GetInvoicePreview_invoicePreview_plan_nutshellIq_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetInvoicePreview_invoicePreview_plan_nutshellIq_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface GetInvoicePreview_invoicePreview_plan_nutshellIq {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: GetInvoicePreview_invoicePreview_plan_nutshellIq_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: GetInvoicePreview_invoicePreview_plan_nutshellIq_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface GetInvoicePreview_invoicePreview_plan_inbox_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetInvoicePreview_invoicePreview_plan_inbox_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface GetInvoicePreview_invoicePreview_plan_inbox {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: GetInvoicePreview_invoicePreview_plan_inbox_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: GetInvoicePreview_invoicePreview_plan_inbox_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface GetInvoicePreview_invoicePreview_plan_marketingSuite_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetInvoicePreview_invoicePreview_plan_marketingSuite_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface GetInvoicePreview_invoicePreview_plan_marketingSuite {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: GetInvoicePreview_invoicePreview_plan_marketingSuite_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: GetInvoicePreview_invoicePreview_plan_marketingSuite_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface GetInvoicePreview_invoicePreview_plan_smsCampaigns_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetInvoicePreview_invoicePreview_plan_smsCampaigns_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface GetInvoicePreview_invoicePreview_plan_smsCampaigns {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: GetInvoicePreview_invoicePreview_plan_smsCampaigns_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: GetInvoicePreview_invoicePreview_plan_smsCampaigns_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface GetInvoicePreview_invoicePreview_plan_quotes_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetInvoicePreview_invoicePreview_plan_quotes_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface GetInvoicePreview_invoicePreview_plan_quotes {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: GetInvoicePreview_invoicePreview_plan_quotes_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: GetInvoicePreview_invoicePreview_plan_quotes_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface GetInvoicePreview_invoicePreview_plan_nutshellAdvisor_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface GetInvoicePreview_invoicePreview_plan_nutshellAdvisor_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface GetInvoicePreview_invoicePreview_plan_nutshellAdvisor {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: GetInvoicePreview_invoicePreview_plan_nutshellAdvisor_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: GetInvoicePreview_invoicePreview_plan_nutshellAdvisor_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface GetInvoicePreview_invoicePreview_plan {
  __typename: "AccountPlan";
  /**
   * The total monthly cost of all subscriptions
   */
  totalMonth: number;
  /**
   * The total display monthly cost of all subscriptions
   */
  totalMonthDisplay: string;
  /**
   * The sub total (pre account wide coupon) display monthly cost of all subscriptions
   */
  subtotalMonthDisplay: string;
  /**
   * The total display discount applied to the account
   */
  accountDiscountDisplay: string;
  /**
   * The coupon applied to the whole account
   */
  accountCoupons: GetInvoicePreview_invoicePreview_plan_accountCoupons[];
  /**
   * The next estimated invoice for the account plan
   */
  nextEstimatedInvoice: GetInvoicePreview_invoicePreview_plan_nextEstimatedInvoice | null;
  /**
   * Next estimated invoices split by monthly and annual billing cycles
   */
  splitEstimatedInvoices: GetInvoicePreview_invoicePreview_plan_splitEstimatedInvoices;
  /**
   * Whether the account plan is cancelled
   */
  isCancelled: boolean;
  /**
   * The subscription for the CRM plan
   */
  crm: GetInvoicePreview_invoicePreview_plan_crm | null;
  /**
   * The subscription for the Marketing plan
   */
  marketing: GetInvoicePreview_invoicePreview_plan_marketing | null;
  /**
   * The subscription for the Revenue Booster plan
   */
  revenueBooster: GetInvoicePreview_invoicePreview_plan_revenueBooster | null;
  /**
   * The subscription for the Nutshell IQ plan
   */
  nutshellIq: GetInvoicePreview_invoicePreview_plan_nutshellIq | null;
  /**
   * The subscription for the inbox plan
   */
  inbox: GetInvoicePreview_invoicePreview_plan_inbox | null;
  /**
   * The subscription for the marketing suite plan
   */
  marketingSuite: GetInvoicePreview_invoicePreview_plan_marketingSuite | null;
  /**
   * The subscription for the SMS campaigns plans
   */
  smsCampaigns: GetInvoicePreview_invoicePreview_plan_smsCampaigns | null;
  /**
   * The subscription for the Quotes plan
   */
  quotes: GetInvoicePreview_invoicePreview_plan_quotes | null;
  /**
   * The subscription for the Nutshell Advisor plan
   */
  nutshellAdvisor: GetInvoicePreview_invoicePreview_plan_nutshellAdvisor | null;
}

export interface GetInvoicePreview_invoicePreview {
  __typename: "InvoicePreview";
  /**
   * The price amount to display in the wrapup invoice preview
   */
  nextInvoiceDisplay: string;
  /**
   * The amount due today before account-wide discounts
   */
  dueTodaySubtotalDisplay: string;
  /**
   * The amount due today after account-wide discounts
   */
  dueTodayTotalDisplay: string;
  /**
   * The amount of the next billing cycle
   */
  billingCycleDisplay: string;
  /**
   * The description of the coupon
   */
  dueText: string;
  /**
   * The subtitle text for the invoice
   */
  subtitleText: string;
  /**
   * The plan attached to this invoice
   */
  plan: GetInvoicePreview_invoicePreview_plan;
  /**
   * Whether the invoice is different from the account’s active one
   */
  isModified: boolean;
  /**
   * Whether the user-supplied coupon was applied to the invoice
   */
  userSuppliedCouponApplied: boolean;
  /**
   * Error message
   */
  couponError: string | null;
}

export interface GetInvoicePreview {
  /**
   * Returns the current invoice preview
   */
  invoicePreview: GetInvoicePreview_invoicePreview;
}

export interface GetInvoicePreviewVariables {
  input: InvoicePreviewInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPreviousInvoices
// ====================================================

export interface GetPreviousInvoices_previousInvoices {
  __typename: "BillingInvoice";
  /**
   * The Recurly id of the invoice
   */
  id: string;
  /**
   * The total amount of the invoice
   */
  amount: string;
  /**
   * The status of the invoice
   */
  status: InvoiceStatus | null;
  /**
   * The timestamp date the invoice was created
   */
  date: any;
}

export interface GetPreviousInvoices {
  /**
   * Returns a list of previous Recurly invoices.
   */
  previousInvoices: GetPreviousInvoices_previousInvoices[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUsageScorecard
// ====================================================

export interface GetUsageScorecard_usageScorecard_sections_features {
  __typename: "UsageScorecardEntry";
  /**
   * How much this feature is currently being used
   */
  currentUsage: number;
  /**
   * The limit for this feature based on their plan (null if unlimited)
   */
  planLimit: number | null;
  /**
   * The custom limit for this feature if one has been set
   */
  customLimit: number | null;
  /**
   * The name that should be displayed on the usage scorecard table
   */
  displayName: string;
}

export interface GetUsageScorecard_usageScorecard_sections {
  __typename: "UsageScorecardSection";
  /**
   * The name of the section
   */
  sectionName: string;
  /**
   * The list of features for this section
   */
  features: GetUsageScorecard_usageScorecard_sections_features[];
}

export interface GetUsageScorecard_usageScorecard {
  __typename: "UsageScorecard";
  /**
   * The list of limited feature
   */
  sections: GetUsageScorecard_usageScorecard_sections[];
}

export interface GetUsageScorecard {
  /**
   * A report of all limited feature usage on this instance
   */
  usageScorecard: GetUsageScorecard_usageScorecard;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveConflictCalendar
// ====================================================

export interface RemoveConflictCalendar_conflictCalendarRemove_calendars {
  __typename: "CalendarSyncCalendar";
  /**
   * The API ID for this calendar
   */
  id: string;
  /**
   * The name of this calendar
   */
  name: string;
  /**
   * Indicates if this is the calendar selected for sync
   */
  isSelected: boolean;
  /**
   * The type of sync this calendar is used for. Can be conflict, primary, or none if it is not currently in use
   */
  syncType: SyncType;
  /**
   * Errors relating to the sync status of this calendar
   */
  syncErrors: string[];
  /**
   * The email address used for the oauth connection that created this calendar
   */
  username: string;
  /**
   * The service provider for this calendar, Google, Outlook, or Exchange
   */
  serviceType: ExternalService;
  /**
   * The rules for what events, if any, should be added to the calendar from Nutshell
   */
  exportRule: CalendarExportRule;
  /**
   * Whether contact creation is disabled when syncing calendar events or external meetings
   */
  isContactCreationDisabled: boolean;
}

export interface RemoveConflictCalendar_conflictCalendarRemove {
  __typename: "ConflictCalendarRemovePayload";
  /**
   * The calendars
   */
  calendars: RemoveConflictCalendar_conflictCalendarRemove_calendars[];
}

export interface RemoveConflictCalendar {
  /**
   * Remove the conflict calendar
   */
  conflictCalendarRemove: RemoveConflictCalendar_conflictCalendarRemove | null;
}

export interface RemoveConflictCalendarVariables {
  calendarId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SelectCalendarSyncCalendar
// ====================================================

export interface SelectCalendarSyncCalendar_selectCalendarSyncCalendar_calendars {
  __typename: "CalendarSyncCalendar";
  /**
   * The API ID for this calendar
   */
  id: string;
  /**
   * The name of this calendar
   */
  name: string;
  /**
   * Indicates if this is the calendar selected for sync
   */
  isSelected: boolean;
  /**
   * The type of sync this calendar is used for. Can be conflict, primary, or none if it is not currently in use
   */
  syncType: SyncType;
  /**
   * Errors relating to the sync status of this calendar
   */
  syncErrors: string[];
  /**
   * The email address used for the oauth connection that created this calendar
   */
  username: string;
  /**
   * The service provider for this calendar, Google, Outlook, or Exchange
   */
  serviceType: ExternalService;
  /**
   * The rules for what events, if any, should be added to the calendar from Nutshell
   */
  exportRule: CalendarExportRule;
  /**
   * Whether contact creation is disabled when syncing calendar events or external meetings
   */
  isContactCreationDisabled: boolean;
}

export interface SelectCalendarSyncCalendar_selectCalendarSyncCalendar {
  __typename: "SelectCalendarSyncCalendarPayload";
  /**
   * The calendars
   */
  calendars: SelectCalendarSyncCalendar_selectCalendarSyncCalendar_calendars[];
}

export interface SelectCalendarSyncCalendar {
  /**
   * Select the calendar we will sync with
   */
  selectCalendarSyncCalendar: SelectCalendarSyncCalendar_selectCalendarSyncCalendar | null;
}

export interface SelectCalendarSyncCalendarVariables {
  calendar: SelectCalendarSyncCalendarInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SelectConflictCalendar
// ====================================================

export interface SelectConflictCalendar_selectCalendarSyncCalendar_calendars {
  __typename: "CalendarSyncCalendar";
  /**
   * The API ID for this calendar
   */
  id: string;
  /**
   * The name of this calendar
   */
  name: string;
  /**
   * Indicates if this is the calendar selected for sync
   */
  isSelected: boolean;
  /**
   * The type of sync this calendar is used for. Can be conflict, primary, or none if it is not currently in use
   */
  syncType: SyncType;
  /**
   * Errors relating to the sync status of this calendar
   */
  syncErrors: string[];
  /**
   * The email address used for the oauth connection that created this calendar
   */
  username: string;
  /**
   * The service provider for this calendar, Google, Outlook, or Exchange
   */
  serviceType: ExternalService;
  /**
   * The rules for what events, if any, should be added to the calendar from Nutshell
   */
  exportRule: CalendarExportRule;
  /**
   * Whether contact creation is disabled when syncing calendar events or external meetings
   */
  isContactCreationDisabled: boolean;
}

export interface SelectConflictCalendar_selectCalendarSyncCalendar {
  __typename: "SelectCalendarSyncCalendarPayload";
  /**
   * The calendars
   */
  calendars: SelectConflictCalendar_selectCalendarSyncCalendar_calendars[];
}

export interface SelectConflictCalendar {
  /**
   * Select the calendar we will sync with
   */
  selectCalendarSyncCalendar: SelectConflictCalendar_selectCalendarSyncCalendar | null;
}

export interface SelectConflictCalendarVariables {
  calendar: SelectCalendarSyncCalendarInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetCalendarSyncCalendarShouldSync
// ====================================================

export interface SetCalendarSyncCalendarShouldSync_setCalendarSyncCalendarShouldSync_calendarSync_calendars {
  __typename: "CalendarSyncCalendar";
  /**
   * The API ID for this calendar
   */
  id: string;
  /**
   * The name of this calendar
   */
  name: string;
  /**
   * Indicates if this is the calendar selected for sync
   */
  isSelected: boolean;
  /**
   * The type of sync this calendar is used for. Can be conflict, primary, or none if it is not currently in use
   */
  syncType: SyncType;
  /**
   * Errors relating to the sync status of this calendar
   */
  syncErrors: string[];
  /**
   * The email address used for the oauth connection that created this calendar
   */
  username: string;
  /**
   * The service provider for this calendar, Google, Outlook, or Exchange
   */
  serviceType: ExternalService;
  /**
   * The rules for what events, if any, should be added to the calendar from Nutshell
   */
  exportRule: CalendarExportRule;
  /**
   * Whether contact creation is disabled when syncing calendar events or external meetings
   */
  isContactCreationDisabled: boolean;
}

export interface SetCalendarSyncCalendarShouldSync_setCalendarSyncCalendarShouldSync_calendarSync {
  __typename: "CalendarSync";
  /**
   * The email address being used for calendar sync
   */
  username: string;
  /**
   * The external calendar service we're syncing with
   */
  externalService: ExternalService;
  /**
   * Whether or not calendar sync is enabled
   */
  isEnabled: boolean;
  /**
   * Whether or not import from the primary calendar is enabled
   */
  importIsEnabled: boolean;
  /**
   * Errors relating to the sync status of the primary calendar
   */
  syncErrors: string[];
  /**
   * How to handle calendar invitations when creating activities that sync to the external calendar
   */
  inviteSetting: CalendarInviteSetting;
  /**
   * All of the calendars we can sync with
   */
  calendars: SetCalendarSyncCalendarShouldSync_setCalendarSyncCalendarShouldSync_calendarSync_calendars[];
}

export interface SetCalendarSyncCalendarShouldSync_setCalendarSyncCalendarShouldSync {
  __typename: "SetCalendarSyncCalendarShouldSyncPayload";
  /**
   * The current calendar sync
   */
  calendarSync: SetCalendarSyncCalendarShouldSync_setCalendarSyncCalendarShouldSync_calendarSync;
}

export interface SetCalendarSyncCalendarShouldSync {
  /**
   * Enable or disable sync for a particular calendar
   */
  setCalendarSyncCalendarShouldSync: SetCalendarSyncCalendarShouldSync_setCalendarSyncCalendarShouldSync | null;
}

export interface SetCalendarSyncCalendarShouldSyncVariables {
  calendar: SetCalendarSyncCalendarShouldSyncInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetCalendarSyncImportIsEnabled
// ====================================================

export interface SetCalendarSyncImportIsEnabled_setCalendarSyncImportIsEnabled_calendarSync_calendars {
  __typename: "CalendarSyncCalendar";
  /**
   * The API ID for this calendar
   */
  id: string;
  /**
   * The name of this calendar
   */
  name: string;
  /**
   * Indicates if this is the calendar selected for sync
   */
  isSelected: boolean;
  /**
   * The type of sync this calendar is used for. Can be conflict, primary, or none if it is not currently in use
   */
  syncType: SyncType;
  /**
   * Errors relating to the sync status of this calendar
   */
  syncErrors: string[];
  /**
   * The email address used for the oauth connection that created this calendar
   */
  username: string;
  /**
   * The service provider for this calendar, Google, Outlook, or Exchange
   */
  serviceType: ExternalService;
  /**
   * The rules for what events, if any, should be added to the calendar from Nutshell
   */
  exportRule: CalendarExportRule;
  /**
   * Whether contact creation is disabled when syncing calendar events or external meetings
   */
  isContactCreationDisabled: boolean;
}

export interface SetCalendarSyncImportIsEnabled_setCalendarSyncImportIsEnabled_calendarSync {
  __typename: "CalendarSync";
  /**
   * The email address being used for calendar sync
   */
  username: string;
  /**
   * The external calendar service we're syncing with
   */
  externalService: ExternalService;
  /**
   * Whether or not calendar sync is enabled
   */
  isEnabled: boolean;
  /**
   * Whether or not import from the primary calendar is enabled
   */
  importIsEnabled: boolean;
  /**
   * Errors relating to the sync status of the primary calendar
   */
  syncErrors: string[];
  /**
   * How to handle calendar invitations when creating activities that sync to the external calendar
   */
  inviteSetting: CalendarInviteSetting;
  /**
   * All of the calendars we can sync with
   */
  calendars: SetCalendarSyncImportIsEnabled_setCalendarSyncImportIsEnabled_calendarSync_calendars[];
}

export interface SetCalendarSyncImportIsEnabled_setCalendarSyncImportIsEnabled {
  __typename: "SetCalendarSyncImportIsEnabledPayload";
  /**
   * The current calendar sync
   */
  calendarSync: SetCalendarSyncImportIsEnabled_setCalendarSyncImportIsEnabled_calendarSync;
}

export interface SetCalendarSyncImportIsEnabled {
  /**
   * Enable or disable calendar -> Nutshell import
   */
  setCalendarSyncImportIsEnabled: SetCalendarSyncImportIsEnabled_setCalendarSyncImportIsEnabled | null;
}

export interface SetCalendarSyncImportIsEnabledVariables {
  calendarSync: SetCalendarSyncImportIsEnabledInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: setGoogleCalendarSyncIsEnabled
// ====================================================

export interface setGoogleCalendarSyncIsEnabled_setGoogleCalendarSyncIsEnabled_calendarSync_calendars {
  __typename: "CalendarSyncCalendar";
  /**
   * The API ID for this calendar
   */
  id: string;
  /**
   * The name of this calendar
   */
  name: string;
  /**
   * Indicates if this is the calendar selected for sync
   */
  isSelected: boolean;
  /**
   * The type of sync this calendar is used for. Can be conflict, primary, or none if it is not currently in use
   */
  syncType: SyncType;
  /**
   * Errors relating to the sync status of this calendar
   */
  syncErrors: string[];
  /**
   * The email address used for the oauth connection that created this calendar
   */
  username: string;
  /**
   * The service provider for this calendar, Google, Outlook, or Exchange
   */
  serviceType: ExternalService;
  /**
   * The rules for what events, if any, should be added to the calendar from Nutshell
   */
  exportRule: CalendarExportRule;
  /**
   * Whether contact creation is disabled when syncing calendar events or external meetings
   */
  isContactCreationDisabled: boolean;
}

export interface setGoogleCalendarSyncIsEnabled_setGoogleCalendarSyncIsEnabled_calendarSync {
  __typename: "CalendarSync";
  /**
   * The email address being used for calendar sync
   */
  username: string;
  /**
   * The external calendar service we're syncing with
   */
  externalService: ExternalService;
  /**
   * Whether or not calendar sync is enabled
   */
  isEnabled: boolean;
  /**
   * Whether or not import from the primary calendar is enabled
   */
  importIsEnabled: boolean;
  /**
   * Errors relating to the sync status of the primary calendar
   */
  syncErrors: string[];
  /**
   * How to handle calendar invitations when creating activities that sync to the external calendar
   */
  inviteSetting: CalendarInviteSetting;
  /**
   * All of the calendars we can sync with
   */
  calendars: setGoogleCalendarSyncIsEnabled_setGoogleCalendarSyncIsEnabled_calendarSync_calendars[];
}

export interface setGoogleCalendarSyncIsEnabled_setGoogleCalendarSyncIsEnabled {
  __typename: "SetGoogleCalendarSyncIsEnabledPayload";
  /**
   * URL to direct the user to if we need to authenticate with an external service, or null if authentication is unnecessary
   */
  authUrl: string | null;
  /**
   * State of calendar sync after the mutation. May be null if initial authentication is required.
   */
  calendarSync: setGoogleCalendarSyncIsEnabled_setGoogleCalendarSyncIsEnabled_calendarSync | null;
}

export interface setGoogleCalendarSyncIsEnabled {
  /**
   * Enable or disable Google calendar sync.
   */
  setGoogleCalendarSyncIsEnabled: setGoogleCalendarSyncIsEnabled_setGoogleCalendarSyncIsEnabled | null;
}

export interface setGoogleCalendarSyncIsEnabledVariables {
  isEnabled: boolean;
  forceReauth?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: setGoogleConflictCalendarSyncIsEnabled
// ====================================================

export interface setGoogleConflictCalendarSyncIsEnabled_setGoogleCalendarSyncIsEnabled_calendarSync_calendars {
  __typename: "CalendarSyncCalendar";
  /**
   * The API ID for this calendar
   */
  id: string;
  /**
   * The name of this calendar
   */
  name: string;
  /**
   * Indicates if this is the calendar selected for sync
   */
  isSelected: boolean;
  /**
   * The type of sync this calendar is used for. Can be conflict, primary, or none if it is not currently in use
   */
  syncType: SyncType;
  /**
   * Errors relating to the sync status of this calendar
   */
  syncErrors: string[];
  /**
   * The email address used for the oauth connection that created this calendar
   */
  username: string;
  /**
   * The service provider for this calendar, Google, Outlook, or Exchange
   */
  serviceType: ExternalService;
  /**
   * The rules for what events, if any, should be added to the calendar from Nutshell
   */
  exportRule: CalendarExportRule;
  /**
   * Whether contact creation is disabled when syncing calendar events or external meetings
   */
  isContactCreationDisabled: boolean;
}

export interface setGoogleConflictCalendarSyncIsEnabled_setGoogleCalendarSyncIsEnabled_calendarSync {
  __typename: "CalendarSync";
  /**
   * The email address being used for calendar sync
   */
  username: string;
  /**
   * The external calendar service we're syncing with
   */
  externalService: ExternalService;
  /**
   * Whether or not calendar sync is enabled
   */
  isEnabled: boolean;
  /**
   * Whether or not import from the primary calendar is enabled
   */
  importIsEnabled: boolean;
  /**
   * Errors relating to the sync status of the primary calendar
   */
  syncErrors: string[];
  /**
   * How to handle calendar invitations when creating activities that sync to the external calendar
   */
  inviteSetting: CalendarInviteSetting;
  /**
   * All of the calendars we can sync with
   */
  calendars: setGoogleConflictCalendarSyncIsEnabled_setGoogleCalendarSyncIsEnabled_calendarSync_calendars[];
}

export interface setGoogleConflictCalendarSyncIsEnabled_setGoogleCalendarSyncIsEnabled {
  __typename: "SetGoogleCalendarSyncIsEnabledPayload";
  /**
   * URL to direct the user to if we need to authenticate with an external service, or null if authentication is unnecessary
   */
  authUrl: string | null;
  /**
   * State of calendar sync after the mutation. May be null if initial authentication is required.
   */
  calendarSync: setGoogleConflictCalendarSyncIsEnabled_setGoogleCalendarSyncIsEnabled_calendarSync | null;
  /**
   * The ID of the connection if the mutation was for a conflict connection, or null otherwise.
   */
  newConnectionId: string | null;
}

export interface setGoogleConflictCalendarSyncIsEnabled {
  /**
   * Enable or disable Google calendar sync.
   */
  setGoogleCalendarSyncIsEnabled: setGoogleConflictCalendarSyncIsEnabled_setGoogleCalendarSyncIsEnabled | null;
}

export interface setGoogleConflictCalendarSyncIsEnabledVariables {
  isEnabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: setOffice365CalendarSyncIsEnabled
// ====================================================

export interface setOffice365CalendarSyncIsEnabled_setOffice365CalendarSyncIsEnabled_calendarSync_calendars {
  __typename: "CalendarSyncCalendar";
  /**
   * The API ID for this calendar
   */
  id: string;
  /**
   * The name of this calendar
   */
  name: string;
  /**
   * Indicates if this is the calendar selected for sync
   */
  isSelected: boolean;
  /**
   * The type of sync this calendar is used for. Can be conflict, primary, or none if it is not currently in use
   */
  syncType: SyncType;
  /**
   * Errors relating to the sync status of this calendar
   */
  syncErrors: string[];
  /**
   * The email address used for the oauth connection that created this calendar
   */
  username: string;
  /**
   * The service provider for this calendar, Google, Outlook, or Exchange
   */
  serviceType: ExternalService;
  /**
   * The rules for what events, if any, should be added to the calendar from Nutshell
   */
  exportRule: CalendarExportRule;
  /**
   * Whether contact creation is disabled when syncing calendar events or external meetings
   */
  isContactCreationDisabled: boolean;
}

export interface setOffice365CalendarSyncIsEnabled_setOffice365CalendarSyncIsEnabled_calendarSync {
  __typename: "CalendarSync";
  /**
   * The email address being used for calendar sync
   */
  username: string;
  /**
   * The external calendar service we're syncing with
   */
  externalService: ExternalService;
  /**
   * Whether or not calendar sync is enabled
   */
  isEnabled: boolean;
  /**
   * Whether or not import from the primary calendar is enabled
   */
  importIsEnabled: boolean;
  /**
   * Errors relating to the sync status of the primary calendar
   */
  syncErrors: string[];
  /**
   * How to handle calendar invitations when creating activities that sync to the external calendar
   */
  inviteSetting: CalendarInviteSetting;
  /**
   * All of the calendars we can sync with
   */
  calendars: setOffice365CalendarSyncIsEnabled_setOffice365CalendarSyncIsEnabled_calendarSync_calendars[];
}

export interface setOffice365CalendarSyncIsEnabled_setOffice365CalendarSyncIsEnabled {
  __typename: "SetOffice365CalendarSyncIsEnabledPayload";
  /**
   * URL to direct the user to if we need to authenticate with an external service, or null if authentication is unnecessary
   */
  authUrl: string | null;
  /**
   * State of calendar sync after the mutation. May be null if initial authentication is required.
   */
  calendarSync: setOffice365CalendarSyncIsEnabled_setOffice365CalendarSyncIsEnabled_calendarSync | null;
}

export interface setOffice365CalendarSyncIsEnabled {
  /**
   * Enable or disable Office 365 calendar sync.
   */
  setOffice365CalendarSyncIsEnabled: setOffice365CalendarSyncIsEnabled_setOffice365CalendarSyncIsEnabled | null;
}

export interface setOffice365CalendarSyncIsEnabledVariables {
  isEnabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: setOffice365ConflictCalendarSyncIsEnabled
// ====================================================

export interface setOffice365ConflictCalendarSyncIsEnabled_setOffice365CalendarSyncIsEnabled_calendarSync_calendars {
  __typename: "CalendarSyncCalendar";
  /**
   * The API ID for this calendar
   */
  id: string;
  /**
   * The name of this calendar
   */
  name: string;
  /**
   * Indicates if this is the calendar selected for sync
   */
  isSelected: boolean;
  /**
   * The type of sync this calendar is used for. Can be conflict, primary, or none if it is not currently in use
   */
  syncType: SyncType;
  /**
   * Errors relating to the sync status of this calendar
   */
  syncErrors: string[];
  /**
   * The email address used for the oauth connection that created this calendar
   */
  username: string;
  /**
   * The service provider for this calendar, Google, Outlook, or Exchange
   */
  serviceType: ExternalService;
  /**
   * The rules for what events, if any, should be added to the calendar from Nutshell
   */
  exportRule: CalendarExportRule;
  /**
   * Whether contact creation is disabled when syncing calendar events or external meetings
   */
  isContactCreationDisabled: boolean;
}

export interface setOffice365ConflictCalendarSyncIsEnabled_setOffice365CalendarSyncIsEnabled_calendarSync {
  __typename: "CalendarSync";
  /**
   * The email address being used for calendar sync
   */
  username: string;
  /**
   * The external calendar service we're syncing with
   */
  externalService: ExternalService;
  /**
   * Whether or not calendar sync is enabled
   */
  isEnabled: boolean;
  /**
   * Whether or not import from the primary calendar is enabled
   */
  importIsEnabled: boolean;
  /**
   * Errors relating to the sync status of the primary calendar
   */
  syncErrors: string[];
  /**
   * How to handle calendar invitations when creating activities that sync to the external calendar
   */
  inviteSetting: CalendarInviteSetting;
  /**
   * All of the calendars we can sync with
   */
  calendars: setOffice365ConflictCalendarSyncIsEnabled_setOffice365CalendarSyncIsEnabled_calendarSync_calendars[];
}

export interface setOffice365ConflictCalendarSyncIsEnabled_setOffice365CalendarSyncIsEnabled {
  __typename: "SetOffice365CalendarSyncIsEnabledPayload";
  /**
   * URL to direct the user to if we need to authenticate with an external service, or null if authentication is unnecessary
   */
  authUrl: string | null;
  /**
   * State of calendar sync after the mutation. May be null if initial authentication is required.
   */
  calendarSync: setOffice365ConflictCalendarSyncIsEnabled_setOffice365CalendarSyncIsEnabled_calendarSync | null;
  /**
   * The ID of the connection if the mutation was for a conflict connection, or null otherwise.
   */
  newConnectionId: string | null;
}

export interface setOffice365ConflictCalendarSyncIsEnabled {
  /**
   * Enable or disable Office 365 calendar sync.
   */
  setOffice365CalendarSyncIsEnabled: setOffice365ConflictCalendarSyncIsEnabled_setOffice365CalendarSyncIsEnabled | null;
}

export interface setOffice365ConflictCalendarSyncIsEnabledVariables {
  isEnabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateCalendarContactCreationRule
// ====================================================

export interface UpdateCalendarContactCreationRule_calendarContactCreationRuleUpdate_calendar {
  __typename: "CalendarSyncCalendar";
  /**
   * The API ID for this calendar
   */
  id: string;
  /**
   * The name of this calendar
   */
  name: string;
  /**
   * Indicates if this is the calendar selected for sync
   */
  isSelected: boolean;
  /**
   * The type of sync this calendar is used for. Can be conflict, primary, or none if it is not currently in use
   */
  syncType: SyncType;
  /**
   * Errors relating to the sync status of this calendar
   */
  syncErrors: string[];
  /**
   * The email address used for the oauth connection that created this calendar
   */
  username: string;
  /**
   * The service provider for this calendar, Google, Outlook, or Exchange
   */
  serviceType: ExternalService;
  /**
   * The rules for what events, if any, should be added to the calendar from Nutshell
   */
  exportRule: CalendarExportRule;
  /**
   * Whether contact creation is disabled when syncing calendar events or external meetings
   */
  isContactCreationDisabled: boolean;
}

export interface UpdateCalendarContactCreationRule_calendarContactCreationRuleUpdate {
  __typename: "CalendarContactCreationRuleUpdatePayload";
  /**
   * The calendar that was updated
   */
  calendar: UpdateCalendarContactCreationRule_calendarContactCreationRuleUpdate_calendar;
}

export interface UpdateCalendarContactCreationRule {
  /**
   * Update the contact creation rule for a calendar
   */
  calendarContactCreationRuleUpdate: UpdateCalendarContactCreationRule_calendarContactCreationRuleUpdate | null;
}

export interface UpdateCalendarContactCreationRuleVariables {
  calendarId: string;
  isContactCreationDisabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateCalendarExportRule
// ====================================================

export interface UpdateCalendarExportRule_calendarExportRuleUpdate_calendar {
  __typename: "CalendarSyncCalendar";
  /**
   * The API ID for this calendar
   */
  id: string;
  /**
   * The name of this calendar
   */
  name: string;
  /**
   * Indicates if this is the calendar selected for sync
   */
  isSelected: boolean;
  /**
   * The type of sync this calendar is used for. Can be conflict, primary, or none if it is not currently in use
   */
  syncType: SyncType;
  /**
   * Errors relating to the sync status of this calendar
   */
  syncErrors: string[];
  /**
   * The email address used for the oauth connection that created this calendar
   */
  username: string;
  /**
   * The service provider for this calendar, Google, Outlook, or Exchange
   */
  serviceType: ExternalService;
  /**
   * The rules for what events, if any, should be added to the calendar from Nutshell
   */
  exportRule: CalendarExportRule;
  /**
   * Whether contact creation is disabled when syncing calendar events or external meetings
   */
  isContactCreationDisabled: boolean;
}

export interface UpdateCalendarExportRule_calendarExportRuleUpdate {
  __typename: "CalendarExportRuleUpdatePayload";
  /**
   * The calendar that was updated
   */
  calendar: UpdateCalendarExportRule_calendarExportRuleUpdate_calendar;
}

export interface UpdateCalendarExportRule {
  /**
   * Update the export rule for a calendar
   */
  calendarExportRuleUpdate: UpdateCalendarExportRule_calendarExportRuleUpdate | null;
}

export interface UpdateCalendarExportRuleVariables {
  calendarId: string;
  exportRule: CalendarExportRule;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateCalendarSyncInviteRule
// ====================================================

export interface UpdateCalendarSyncInviteRule_calendarSyncInviteRuleUpdate_calendarSync {
  __typename: "CalendarSync";
  /**
   * How to handle calendar invitations when creating activities that sync to the external calendar
   */
  inviteSetting: CalendarInviteSetting;
}

export interface UpdateCalendarSyncInviteRule_calendarSyncInviteRuleUpdate {
  __typename: "CalendarSyncInviteRuleUpdatePayload";
  /**
   * The CalendarSync that was updated
   */
  calendarSync: UpdateCalendarSyncInviteRule_calendarSyncInviteRuleUpdate_calendarSync;
}

export interface UpdateCalendarSyncInviteRule {
  /**
   * Update the invite rule for a users calendar sync
   */
  calendarSyncInviteRuleUpdate: UpdateCalendarSyncInviteRule_calendarSyncInviteRuleUpdate | null;
}

export interface UpdateCalendarSyncInviteRuleVariables {
  inviteRule: CalendarInviteSetting;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCalendarSync
// ====================================================

export interface GetCalendarSync_loggedInUser_calendarSync_calendars {
  __typename: "CalendarSyncCalendar";
  /**
   * The API ID for this calendar
   */
  id: string;
  /**
   * The name of this calendar
   */
  name: string;
  /**
   * Indicates if this is the calendar selected for sync
   */
  isSelected: boolean;
  /**
   * The type of sync this calendar is used for. Can be conflict, primary, or none if it is not currently in use
   */
  syncType: SyncType;
  /**
   * Errors relating to the sync status of this calendar
   */
  syncErrors: string[];
  /**
   * The email address used for the oauth connection that created this calendar
   */
  username: string;
  /**
   * The service provider for this calendar, Google, Outlook, or Exchange
   */
  serviceType: ExternalService;
  /**
   * The rules for what events, if any, should be added to the calendar from Nutshell
   */
  exportRule: CalendarExportRule;
  /**
   * Whether contact creation is disabled when syncing calendar events or external meetings
   */
  isContactCreationDisabled: boolean;
}

export interface GetCalendarSync_loggedInUser_calendarSync {
  __typename: "CalendarSync";
  /**
   * The email address being used for calendar sync
   */
  username: string;
  /**
   * The external calendar service we're syncing with
   */
  externalService: ExternalService;
  /**
   * Whether or not calendar sync is enabled
   */
  isEnabled: boolean;
  /**
   * Whether or not import from the primary calendar is enabled
   */
  importIsEnabled: boolean;
  /**
   * Errors relating to the sync status of the primary calendar
   */
  syncErrors: string[];
  /**
   * How to handle calendar invitations when creating activities that sync to the external calendar
   */
  inviteSetting: CalendarInviteSetting;
  /**
   * All of the calendars we can sync with
   */
  calendars: GetCalendarSync_loggedInUser_calendarSync_calendars[];
}

export interface GetCalendarSync_loggedInUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Calendar sync details for this user
   */
  calendarSync: GetCalendarSync_loggedInUser_calendarSync | null;
  /**
   * Personal iCal activity feed URL
   */
  personalCalendarFeedUrl: string | null;
  /**
   * Company iCal activity feed URL
   */
  companyCalendarFeedUrl: string | null;
}

export interface GetCalendarSync {
  /**
   * Returns the requesting user. This is essentially the logged in user, but in an
   * API context, they might not be any "logged in"
   */
  loggedInUser: GetCalendarSync_loggedInUser;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCalendars
// ====================================================

export interface GetCalendars_calendars {
  __typename: "CalendarSyncCalendar";
  /**
   * The API ID for this calendar
   */
  id: string;
  /**
   * The name of this calendar
   */
  name: string;
  /**
   * Indicates if this is the calendar selected for sync
   */
  isSelected: boolean;
  /**
   * The type of sync this calendar is used for. Can be conflict, primary, or none if it is not currently in use
   */
  syncType: SyncType;
  /**
   * Errors relating to the sync status of this calendar
   */
  syncErrors: string[];
  /**
   * The email address used for the oauth connection that created this calendar
   */
  username: string;
  /**
   * The service provider for this calendar, Google, Outlook, or Exchange
   */
  serviceType: ExternalService;
  /**
   * The rules for what events, if any, should be added to the calendar from Nutshell
   */
  exportRule: CalendarExportRule;
  /**
   * Whether contact creation is disabled when syncing calendar events or external meetings
   */
  isContactCreationDisabled: boolean;
}

export interface GetCalendars {
  /**
   * When given a username or a connection ID, returns only the calendars for that
   * sync. When given no args, returns all conflict calendars regardless of sync.
   */
  calendars: GetCalendars_calendars[];
}

export interface GetCalendarsVariables {
  username?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetConnectNextSteps
// ====================================================

export interface GetConnectNextSteps_connectNextSteps {
  __typename: "ConnectNextSteps";
  /**
   * The next steps for user to connect their calendar, email, and meetings
   */
  nextSteps: ConnectionNextStep[];
  /**
   * Whether the user has connected their calendar, email, and at least one meeting service
   */
  isComplete: boolean;
}

export interface GetConnectNextSteps {
  /**
   * Gets the next steps for user to connect their calendar, email, and meetings
   */
  connectNextSteps: GetConnectNextSteps_connectNextSteps | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ArchiveCustomField
// ====================================================

export interface ArchiveCustomField_deleteCustomField_customField {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ArchiveCustomField_deleteCustomField {
  __typename: "DeleteCustomFieldPayload";
  /**
   * The deleted custom field
   */
  customField: ArchiveCustomField_deleteCustomField_customField;
}

export interface ArchiveCustomField {
  /**
   * Deletes a custom field
   */
  deleteCustomField: ArchiveCustomField_deleteCustomField;
}

export interface ArchiveCustomFieldVariables {
  input: DeleteCustomFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ConvertCustomFieldToNumber
// ====================================================

export interface ConvertCustomFieldToNumber_convertCustomFieldToNumber_customField_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The human readable type of the attribute
   */
  displayType: string;
}

export interface ConvertCustomFieldToNumber_convertCustomFieldToNumber_customField {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: ConvertCustomFieldToNumber_convertCustomFieldToNumber_customField_attribute;
}

export interface ConvertCustomFieldToNumber_convertCustomFieldToNumber {
  __typename: "CustomFieldConvertToNumberPayload";
  /**
   * The converted (now numeric) custom field.
   */
  customField: ConvertCustomFieldToNumber_convertCustomFieldToNumber_customField;
}

export interface ConvertCustomFieldToNumber {
  /**
   * Converts a text (String) custom field to a numeric (Number) one.
   */
  convertCustomFieldToNumber: ConvertCustomFieldToNumber_convertCustomFieldToNumber;
}

export interface ConvertCustomFieldToNumberVariables {
  input: CustomFieldConvertToNumberInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateCustomFieldPerPipeline
// ====================================================

export interface CreateCustomFieldPerPipeline_createCustomField_customField_attribute {
  __typename: "Attribute";
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The human readable type of the attribute
   */
  displayType: string;
  /**
   * The description of the attribute
   */
  description: string | null;
}

export interface CreateCustomFieldPerPipeline_createCustomField_customField_customFieldStats {
  __typename: "CustomFieldStats";
  /**
   * The number of forms that have this field
   */
  numOfForms: number;
  /**
   * The number of pipelines that have this field (for lead fields, else null)
   */
  numOfPipelines: number | null;
  /**
   * The number of published contract templates that have this field
   */
  numOfContracts: number;
}

export interface CreateCustomFieldPerPipeline_createCustomField_customField {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: CreateCustomFieldPerPipeline_createCustomField_customField_attribute;
  customFieldStats: CreateCustomFieldPerPipeline_createCustomField_customField_customFieldStats | null;
}

export interface CreateCustomFieldPerPipeline_createCustomField {
  __typename: "CreateCustomFieldPayload";
  /**
   * The newly created Nutshell custom field
   */
  customField: CreateCustomFieldPerPipeline_createCustomField_customField;
}

export interface CreateCustomFieldPerPipeline {
  /**
   * Creates a custom field.
   */
  createCustomField: CreateCustomFieldPerPipeline_createCustomField | null;
}

export interface CreateCustomFieldPerPipelineVariables {
  customField: CreateCustomFieldInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UnarchiveCustomField
// ====================================================

export interface UnarchiveCustomField_undeleteCustomField_customField_attribute {
  __typename: "Attribute";
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The human readable type of the attribute
   */
  displayType: string;
  /**
   * The description of the attribute
   */
  description: string | null;
}

export interface UnarchiveCustomField_undeleteCustomField_customField_customFieldStats {
  __typename: "CustomFieldStats";
  /**
   * The number of forms that have this field
   */
  numOfForms: number;
  /**
   * The number of published contract templates that have this field
   */
  numOfContracts: number;
}

export interface UnarchiveCustomField_undeleteCustomField_customField {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: UnarchiveCustomField_undeleteCustomField_customField_attribute;
  customFieldStats: UnarchiveCustomField_undeleteCustomField_customField_customFieldStats | null;
}

export interface UnarchiveCustomField_undeleteCustomField {
  __typename: "CustomFieldUndeletePayload";
  /**
   * The undeleted custom field
   */
  customField: UnarchiveCustomField_undeleteCustomField_customField;
}

export interface UnarchiveCustomField {
  /**
   * Undeletes a custom field
   */
  undeleteCustomField: UnarchiveCustomField_undeleteCustomField;
}

export interface UnarchiveCustomFieldVariables {
  input: CustomFieldUndeleteInputs;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateCustomFieldPositions
// ====================================================

export interface UpdateCustomFieldPositions_updateCustomFieldPositions {
  __typename: "CustomFieldUpdatePositionPayload";
  /**
   * Whether the custom field positions were updated successfully.
   */
  success: boolean;
}

export interface UpdateCustomFieldPositions {
  /**
   * Update the position of a custom field
   */
  updateCustomFieldPositions: UpdateCustomFieldPositions_updateCustomFieldPositions | null;
}

export interface UpdateCustomFieldPositionsVariables {
  input: CustomFieldUpdatePositionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateCustomField
// ====================================================

export interface UpdateCustomField_updateCustomField_customField_EntityAttributeBase_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The human readable type of the attribute
   */
  displayType: string;
  /**
   * The description of the attribute
   */
  description: string | null;
}

export interface UpdateCustomField_updateCustomField_customField_EntityAttributeBase_customFieldStats {
  __typename: "CustomFieldStats";
  /**
   * The number of forms that have this field
   */
  numOfForms: number;
  /**
   * The number of published contract templates that have this field
   */
  numOfContracts: number;
}

export interface UpdateCustomField_updateCustomField_customField_EntityAttributeBase_stagesets_edges_node {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateCustomField_updateCustomField_customField_EntityAttributeBase_stagesets_edges {
  __typename: "CustomFieldStagesetsEdge";
  /**
   * Is this field on the pipeline?
   */
  isOnPipeline: boolean;
  node: UpdateCustomField_updateCustomField_customField_EntityAttributeBase_stagesets_edges_node;
}

export interface UpdateCustomField_updateCustomField_customField_EntityAttributeBase_stagesets {
  __typename: "CustomFieldStagesetsConnection";
  /**
   * Whether this field is specific to a stageset
   */
  isStagesetSpecific: boolean | null;
  /**
   * A list of edges.
   */
  edges: UpdateCustomField_updateCustomField_customField_EntityAttributeBase_stagesets_edges[];
}

export interface UpdateCustomField_updateCustomField_customField_EntityAttributeBase {
  __typename: "EntityAttributeBase" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: UpdateCustomField_updateCustomField_customField_EntityAttributeBase_attribute;
  customFieldStats: UpdateCustomField_updateCustomField_customField_EntityAttributeBase_customFieldStats | null;
  stagesets: UpdateCustomField_updateCustomField_customField_EntityAttributeBase_stagesets | null;
}

export interface UpdateCustomField_updateCustomField_customField_EntityAttributeEnum_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The human readable type of the attribute
   */
  displayType: string;
  /**
   * The description of the attribute
   */
  description: string | null;
}

export interface UpdateCustomField_updateCustomField_customField_EntityAttributeEnum_customFieldStats {
  __typename: "CustomFieldStats";
  /**
   * The number of forms that have this field
   */
  numOfForms: number;
  /**
   * The number of published contract templates that have this field
   */
  numOfContracts: number;
}

export interface UpdateCustomField_updateCustomField_customField_EntityAttributeEnum_stagesets_edges_node {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateCustomField_updateCustomField_customField_EntityAttributeEnum_stagesets_edges {
  __typename: "CustomFieldStagesetsEdge";
  /**
   * Is this field on the pipeline?
   */
  isOnPipeline: boolean;
  node: UpdateCustomField_updateCustomField_customField_EntityAttributeEnum_stagesets_edges_node;
}

export interface UpdateCustomField_updateCustomField_customField_EntityAttributeEnum_stagesets {
  __typename: "CustomFieldStagesetsConnection";
  /**
   * Whether this field is specific to a stageset
   */
  isStagesetSpecific: boolean | null;
  /**
   * A list of edges.
   */
  edges: UpdateCustomField_updateCustomField_customField_EntityAttributeEnum_stagesets_edges[];
}

export interface UpdateCustomField_updateCustomField_customField_EntityAttributeEnum_options {
  __typename: "EnumOption";
  /**
   * The name (and primary identifier) of the enum option.
   */
  id: string;
  /**
   * The name (and display) of the enum option.
   */
  name: string;
}

export interface UpdateCustomField_updateCustomField_customField_EntityAttributeEnum {
  __typename: "EntityAttributeEnum";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: UpdateCustomField_updateCustomField_customField_EntityAttributeEnum_attribute;
  /**
   * Stats for this custom field
   */
  customFieldStats: UpdateCustomField_updateCustomField_customField_EntityAttributeEnum_customFieldStats | null;
  /**
   * The stagesets that this field is specific to
   */
  stagesets: UpdateCustomField_updateCustomField_customField_EntityAttributeEnum_stagesets | null;
  /**
   * Does this enum field allow multiple selections. I.e. can the value of "Favorite Color" be "Red" AND "Blue"?
   */
  allowMultiple: boolean;
  /**
   * Enum options for this field
   */
  options: UpdateCustomField_updateCustomField_customField_EntityAttributeEnum_options[];
}

export type UpdateCustomField_updateCustomField_customField = UpdateCustomField_updateCustomField_customField_EntityAttributeBase | UpdateCustomField_updateCustomField_customField_EntityAttributeEnum;

export interface UpdateCustomField_updateCustomField {
  __typename: "CustomFieldUpdatePayload";
  /**
   * The updated Nutshell custom field
   */
  customField: UpdateCustomField_updateCustomField_customField;
}

export interface UpdateCustomField {
  /**
   * Updates a custom field.
   */
  updateCustomField: UpdateCustomField_updateCustomField | null;
}

export interface UpdateCustomFieldVariables {
  input: CustomFieldUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCustomFieldById
// ====================================================

export interface GetCustomFieldById_customField_EntityAttributeBase_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
}

export interface GetCustomFieldById_customField_EntityAttributeBase_customFieldStats {
  __typename: "CustomFieldStats";
  /**
   * The number of forms that have this field
   */
  numOfForms: number;
}

export interface GetCustomFieldById_customField_EntityAttributeBase_stagesets_edges_node {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetCustomFieldById_customField_EntityAttributeBase_stagesets_edges {
  __typename: "CustomFieldStagesetsEdge";
  /**
   * Is this field on the pipeline?
   */
  isOnPipeline: boolean;
  node: GetCustomFieldById_customField_EntityAttributeBase_stagesets_edges_node;
}

export interface GetCustomFieldById_customField_EntityAttributeBase_stagesets {
  __typename: "CustomFieldStagesetsConnection";
  /**
   * Whether this field is specific to a stageset
   */
  isStagesetSpecific: boolean | null;
  /**
   * A list of edges.
   */
  edges: GetCustomFieldById_customField_EntityAttributeBase_stagesets_edges[];
}

export interface GetCustomFieldById_customField_EntityAttributeBase {
  __typename: "EntityAttributeBase" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: GetCustomFieldById_customField_EntityAttributeBase_attribute;
  customFieldStats: GetCustomFieldById_customField_EntityAttributeBase_customFieldStats | null;
  stagesets: GetCustomFieldById_customField_EntityAttributeBase_stagesets | null;
}

export interface GetCustomFieldById_customField_EntityAttributeEnum_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
}

export interface GetCustomFieldById_customField_EntityAttributeEnum_customFieldStats {
  __typename: "CustomFieldStats";
  /**
   * The number of forms that have this field
   */
  numOfForms: number;
}

export interface GetCustomFieldById_customField_EntityAttributeEnum_stagesets_edges_node {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetCustomFieldById_customField_EntityAttributeEnum_stagesets_edges {
  __typename: "CustomFieldStagesetsEdge";
  /**
   * Is this field on the pipeline?
   */
  isOnPipeline: boolean;
  node: GetCustomFieldById_customField_EntityAttributeEnum_stagesets_edges_node;
}

export interface GetCustomFieldById_customField_EntityAttributeEnum_stagesets {
  __typename: "CustomFieldStagesetsConnection";
  /**
   * Whether this field is specific to a stageset
   */
  isStagesetSpecific: boolean | null;
  /**
   * A list of edges.
   */
  edges: GetCustomFieldById_customField_EntityAttributeEnum_stagesets_edges[];
}

export interface GetCustomFieldById_customField_EntityAttributeEnum_options {
  __typename: "EnumOption";
  /**
   * The name (and primary identifier) of the enum option.
   */
  id: string;
  /**
   * The name (and display) of the enum option.
   */
  name: string;
}

export interface GetCustomFieldById_customField_EntityAttributeEnum {
  __typename: "EntityAttributeEnum";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: GetCustomFieldById_customField_EntityAttributeEnum_attribute;
  /**
   * Stats for this custom field
   */
  customFieldStats: GetCustomFieldById_customField_EntityAttributeEnum_customFieldStats | null;
  /**
   * The stagesets that this field is specific to
   */
  stagesets: GetCustomFieldById_customField_EntityAttributeEnum_stagesets | null;
  /**
   * Does this enum field allow multiple selections. I.e. can the value of "Favorite Color" be "Red" AND "Blue"?
   */
  allowMultiple: boolean;
  /**
   * Enum options for this field
   */
  options: GetCustomFieldById_customField_EntityAttributeEnum_options[];
}

export type GetCustomFieldById_customField = GetCustomFieldById_customField_EntityAttributeBase | GetCustomFieldById_customField_EntityAttributeEnum;

export interface GetCustomFieldById {
  /**
   * Returns an EAV entity attribute by id if it exists
   */
  customField: GetCustomFieldById_customField | null;
}

export interface GetCustomFieldByIdVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCustomFieldStagesets
// ====================================================

export interface GetCustomFieldStagesets_stagesets_customFields_shown_customField_attribute {
  __typename: "Attribute";
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The human readable type of the attribute
   */
  displayType: string;
  /**
   * The description of the attribute
   */
  description: string | null;
}

export interface GetCustomFieldStagesets_stagesets_customFields_shown_customField_customFieldStats {
  __typename: "CustomFieldStats";
  /**
   * The number of forms that have this field
   */
  numOfForms: number;
  /**
   * The number of published contract templates that have this field
   */
  numOfContracts: number;
}

export interface GetCustomFieldStagesets_stagesets_customFields_shown_customField {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: GetCustomFieldStagesets_stagesets_customFields_shown_customField_attribute;
  customFieldStats: GetCustomFieldStagesets_stagesets_customFields_shown_customField_customFieldStats | null;
}

export interface GetCustomFieldStagesets_stagesets_customFields_shown {
  __typename: "StagesetCustomFieldMap";
  /**
   * The position of the custom field on this stageset
   */
  position: number;
  /**
   * The custom field
   */
  customField: GetCustomFieldStagesets_stagesets_customFields_shown_customField;
}

export interface GetCustomFieldStagesets_stagesets_customFields_hidden_attribute {
  __typename: "Attribute";
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The human readable type of the attribute
   */
  displayType: string;
  /**
   * The description of the attribute
   */
  description: string | null;
}

export interface GetCustomFieldStagesets_stagesets_customFields_hidden_customFieldStats {
  __typename: "CustomFieldStats";
  /**
   * The number of forms that have this field
   */
  numOfForms: number;
  /**
   * The number of published contract templates that have this field
   */
  numOfContracts: number;
}

export interface GetCustomFieldStagesets_stagesets_customFields_hidden {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: GetCustomFieldStagesets_stagesets_customFields_hidden_attribute;
  customFieldStats: GetCustomFieldStagesets_stagesets_customFields_hidden_customFieldStats | null;
}

export interface GetCustomFieldStagesets_stagesets_customFields {
  __typename: "StagesetCustomFields";
  /**
   * Custom fields shown on leads in this stageset
   */
  shown: GetCustomFieldStagesets_stagesets_customFields_shown[];
  /**
   * Custom fields hidden from leads in this stageset
   */
  hidden: GetCustomFieldStagesets_stagesets_customFields_hidden[];
}

export interface GetCustomFieldStagesets_stagesets {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * Custom fields specific to this stageset
   */
  customFields: GetCustomFieldStagesets_stagesets_customFields;
}

export interface GetCustomFieldStagesets {
  /**
   * Returns a list of Nutshell Stagesets
   */
  stagesets: GetCustomFieldStagesets_stagesets[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCustomFields
// ====================================================

export interface GetCustomFields_customFields_active_attribute {
  __typename: "Attribute";
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The human readable type of the attribute
   */
  displayType: string;
  /**
   * The description of the attribute
   */
  description: string | null;
}

export interface GetCustomFields_customFields_active_customFieldStats {
  __typename: "CustomFieldStats";
  /**
   * The number of forms that have this field
   */
  numOfForms: number;
  /**
   * The number of published contract templates that have this field
   */
  numOfContracts: number;
}

export interface GetCustomFields_customFields_active {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: GetCustomFields_customFields_active_attribute;
  customFieldStats: GetCustomFields_customFields_active_customFieldStats | null;
}

export interface GetCustomFields_customFields_archived_attribute {
  __typename: "Attribute";
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The human readable type of the attribute
   */
  displayType: string;
  /**
   * The description of the attribute
   */
  description: string | null;
}

export interface GetCustomFields_customFields_archived_customFieldStats {
  __typename: "CustomFieldStats";
  /**
   * The number of forms that have this field
   */
  numOfForms: number;
  /**
   * The number of published contract templates that have this field
   */
  numOfContracts: number;
}

export interface GetCustomFields_customFields_archived {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: GetCustomFields_customFields_archived_attribute;
  customFieldStats: GetCustomFields_customFields_archived_customFieldStats | null;
}

export interface GetCustomFields_customFields {
  __typename: "CustomFields";
  /**
   * The custom field that haven't been deleted
   */
  active: GetCustomFields_customFields_active[];
  /**
   * The custom field that have been deleted
   */
  archived: GetCustomFields_customFields_archived[];
}

export interface GetCustomFields {
  /**
   * List of custom fields for a particular entity type
   */
  customFields: GetCustomFields_customFields;
}

export interface GetCustomFieldsVariables {
  input: CustomFieldsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPotentialNumericFields
// ====================================================

export interface GetPotentialNumericFields_potentialNumericFields_field_attribute {
  __typename: "Attribute";
  /**
   * The human readable name of the attribute
   */
  displayName: string;
}

export interface GetPotentialNumericFields_potentialNumericFields_field {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: GetPotentialNumericFields_potentialNumericFields_field_attribute;
}

export interface GetPotentialNumericFields_potentialNumericFields {
  __typename: "PotentialNumericFields";
  /**
   * The entity type this custom field belongs to.
   */
  entityType: EntityType;
  /**
   * The custom field that is a candidate for conversion from text to number.
   */
  field: GetPotentialNumericFields_potentialNumericFields_field;
  /**
   * The count of records that have any value indexed for this field
   */
  total: number;
  /**
   * The percentage of records for this field that appear to be numeric.
   */
  numericPercent: number;
}

export interface GetPotentialNumericFields {
  /**
   * A list of custom fields that are potential candidates for conversion from text to number.
   */
  potentialNumericFields: GetPotentialNumericFields_potentialNumericFields[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserSso
// ====================================================

export interface GetUserSso_user_sso {
  __typename: "UserSso";
  /**
   * Whether the user requires SSO to login
   */
  requiresSsoLogin: boolean;
  /**
   * Whether the user is managed by Nutshell
   */
  isNutshellManaged: boolean;
}

export interface GetUserSso_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  sso: GetUserSso_user_sso;
}

export interface GetUserSso {
  /**
   * Returns a full Nutshell user object
   */
  user: GetUserSso_user;
}

export interface GetUserSsoVariables {
  userId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddSubdomain
// ====================================================

export interface AddSubdomain_subdomainAdd_domain_groupSpf_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface AddSubdomain_subdomainAdd_domain_groupSpf {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: AddSubdomain_subdomainAdd_domain_groupSpf_records[];
}

export interface AddSubdomain_subdomainAdd_domain_groupDkim_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface AddSubdomain_subdomainAdd_domain_groupDkim {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: AddSubdomain_subdomainAdd_domain_groupDkim_records[];
}

export interface AddSubdomain_subdomainAdd_domain_groupCustom_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface AddSubdomain_subdomainAdd_domain_groupCustom {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: AddSubdomain_subdomainAdd_domain_groupCustom_records[];
}

export interface AddSubdomain_subdomainAdd_domain_groupDmarc_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface AddSubdomain_subdomainAdd_domain_groupDmarc {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: AddSubdomain_subdomainAdd_domain_groupDmarc_records[];
}

export interface AddSubdomain_subdomainAdd_domain {
  __typename: "Domain";
  /**
   * The domain ID (currently the name)
   */
  id: string;
  /**
   * The domain name
   */
  name: string;
  /**
   * If email deliverability requirements are all verified
   */
  emailDeliverabilityStatus: boolean;
  /**
   * If hosting domains are all verified
   */
  hostingTrackingStatus: boolean;
  /**
   * Whether or not the domain is not setup for email and hosting and is not in the process of verifying any records
   */
  canUseEntriSetup: boolean;
  /**
   * The group containing the SPF records for this domain
   */
  groupSpf: AddSubdomain_subdomainAdd_domain_groupSpf;
  /**
   * The group containing the DKIM records for this domain
   */
  groupDkim: AddSubdomain_subdomainAdd_domain_groupDkim;
  /**
   * The group containing the custom records for this domain
   */
  groupCustom: AddSubdomain_subdomainAdd_domain_groupCustom;
  /**
   * The group containing the DMARC records for this domain
   */
  groupDmarc: AddSubdomain_subdomainAdd_domain_groupDmarc;
}

export interface AddSubdomain_subdomainAdd {
  __typename: "SubdomainAddPayload";
  /**
   * The domain with the subdomain added.
   */
  domain: AddSubdomain_subdomainAdd_domain;
}

export interface AddSubdomain {
  /**
   * Adds a subdomain to a domain
   */
  subdomainAdd: AddSubdomain_subdomainAdd;
}

export interface AddSubdomainVariables {
  subdomainAdd: SubdomainAddInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: BootSnippetDomainSet
// ====================================================

export interface BootSnippetDomainSet_bootSnippetDomainSet {
  __typename: "BootSnippetDomainSetPayload";
  /**
   * The id of the selected domain.
   */
  domainId: string | null;
}

export interface BootSnippetDomainSet {
  /**
   * Sets the boot snippet domain for the instance
   */
  bootSnippetDomainSet: BootSnippetDomainSet_bootSnippetDomainSet;
}

export interface BootSnippetDomainSetVariables {
  input: BootSnippetDomainSetInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CheckDomain
// ====================================================

export interface CheckDomain_domainCheck_domain_groupSpf_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface CheckDomain_domainCheck_domain_groupSpf {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: CheckDomain_domainCheck_domain_groupSpf_records[];
}

export interface CheckDomain_domainCheck_domain_groupDkim_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface CheckDomain_domainCheck_domain_groupDkim {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: CheckDomain_domainCheck_domain_groupDkim_records[];
}

export interface CheckDomain_domainCheck_domain_groupCustom_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface CheckDomain_domainCheck_domain_groupCustom {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: CheckDomain_domainCheck_domain_groupCustom_records[];
}

export interface CheckDomain_domainCheck_domain_groupDmarc_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface CheckDomain_domainCheck_domain_groupDmarc {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: CheckDomain_domainCheck_domain_groupDmarc_records[];
}

export interface CheckDomain_domainCheck_domain {
  __typename: "Domain";
  /**
   * The domain ID (currently the name)
   */
  id: string;
  /**
   * The domain name
   */
  name: string;
  /**
   * If email deliverability requirements are all verified
   */
  emailDeliverabilityStatus: boolean;
  /**
   * If hosting domains are all verified
   */
  hostingTrackingStatus: boolean;
  /**
   * Whether or not the domain is not setup for email and hosting and is not in the process of verifying any records
   */
  canUseEntriSetup: boolean;
  /**
   * The group containing the SPF records for this domain
   */
  groupSpf: CheckDomain_domainCheck_domain_groupSpf;
  /**
   * The group containing the DKIM records for this domain
   */
  groupDkim: CheckDomain_domainCheck_domain_groupDkim;
  /**
   * The group containing the custom records for this domain
   */
  groupCustom: CheckDomain_domainCheck_domain_groupCustom;
  /**
   * The group containing the DMARC records for this domain
   */
  groupDmarc: CheckDomain_domainCheck_domain_groupDmarc;
}

export interface CheckDomain_domainCheck {
  __typename: "DomainCheckPayload";
  /**
   * The checked domain, with either verified or unverified results.
   */
  domain: CheckDomain_domainCheck_domain;
}

export interface CheckDomain {
  /**
   * Attempts to verify a domains DNS records.
   */
  domainCheck: CheckDomain_domainCheck;
}

export interface CheckDomainVariables {
  input: DomainCheckInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ClickTrackingDomainSet
// ====================================================

export interface ClickTrackingDomainSet_clickTrackingDomainSet {
  __typename: "ClickTrackingDomainSetPayload";
  /**
   * The id of the selected domain.
   */
  domainId: string | null;
}

export interface ClickTrackingDomainSet {
  /**
   * Sets the click tracking domain for the instance
   */
  clickTrackingDomainSet: ClickTrackingDomainSet_clickTrackingDomainSet;
}

export interface ClickTrackingDomainSetVariables {
  input: ClickTrackingDomainSetInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateDomain
// ====================================================

export interface CreateDomain_domainCreate_domain_groupSpf_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface CreateDomain_domainCreate_domain_groupSpf {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: CreateDomain_domainCreate_domain_groupSpf_records[];
}

export interface CreateDomain_domainCreate_domain_groupDkim_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface CreateDomain_domainCreate_domain_groupDkim {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: CreateDomain_domainCreate_domain_groupDkim_records[];
}

export interface CreateDomain_domainCreate_domain_groupCustom_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface CreateDomain_domainCreate_domain_groupCustom {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: CreateDomain_domainCreate_domain_groupCustom_records[];
}

export interface CreateDomain_domainCreate_domain_groupDmarc_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface CreateDomain_domainCreate_domain_groupDmarc {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: CreateDomain_domainCreate_domain_groupDmarc_records[];
}

export interface CreateDomain_domainCreate_domain {
  __typename: "Domain";
  /**
   * The domain ID (currently the name)
   */
  id: string;
  /**
   * The domain name
   */
  name: string;
  /**
   * If email deliverability requirements are all verified
   */
  emailDeliverabilityStatus: boolean;
  /**
   * If hosting domains are all verified
   */
  hostingTrackingStatus: boolean;
  /**
   * Whether or not the domain is not setup for email and hosting and is not in the process of verifying any records
   */
  canUseEntriSetup: boolean;
  /**
   * The group containing the SPF records for this domain
   */
  groupSpf: CreateDomain_domainCreate_domain_groupSpf;
  /**
   * The group containing the DKIM records for this domain
   */
  groupDkim: CreateDomain_domainCreate_domain_groupDkim;
  /**
   * The group containing the custom records for this domain
   */
  groupCustom: CreateDomain_domainCreate_domain_groupCustom;
  /**
   * The group containing the DMARC records for this domain
   */
  groupDmarc: CreateDomain_domainCreate_domain_groupDmarc;
}

export interface CreateDomain_domainCreate {
  __typename: "DomainCreatePayload";
  /**
   * The newly created domain.
   */
  domain: CreateDomain_domainCreate_domain;
}

export interface CreateDomain {
  /**
   * Creates a new domain from a name.
   */
  domainCreate: CreateDomain_domainCreate;
}

export interface CreateDomainVariables {
  domain: DomainCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateEntriConfig
// ====================================================

export interface CreateEntriConfig {
  /**
   * Generates a config object to power the Entri integration and register DNS records
   */
  entriConfigCreate: string;
}

export interface CreateEntriConfigVariables {
  domain: string;
  subdomain?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteDomain
// ====================================================

export interface DeleteDomain_domainDelete_domain_groupSpf_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface DeleteDomain_domainDelete_domain_groupSpf {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: DeleteDomain_domainDelete_domain_groupSpf_records[];
}

export interface DeleteDomain_domainDelete_domain_groupDkim_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface DeleteDomain_domainDelete_domain_groupDkim {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: DeleteDomain_domainDelete_domain_groupDkim_records[];
}

export interface DeleteDomain_domainDelete_domain_groupCustom_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface DeleteDomain_domainDelete_domain_groupCustom {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: DeleteDomain_domainDelete_domain_groupCustom_records[];
}

export interface DeleteDomain_domainDelete_domain_groupDmarc_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface DeleteDomain_domainDelete_domain_groupDmarc {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: DeleteDomain_domainDelete_domain_groupDmarc_records[];
}

export interface DeleteDomain_domainDelete_domain {
  __typename: "Domain";
  /**
   * The domain ID (currently the name)
   */
  id: string;
  /**
   * The domain name
   */
  name: string;
  /**
   * If email deliverability requirements are all verified
   */
  emailDeliverabilityStatus: boolean;
  /**
   * If hosting domains are all verified
   */
  hostingTrackingStatus: boolean;
  /**
   * Whether or not the domain is not setup for email and hosting and is not in the process of verifying any records
   */
  canUseEntriSetup: boolean;
  /**
   * The group containing the SPF records for this domain
   */
  groupSpf: DeleteDomain_domainDelete_domain_groupSpf;
  /**
   * The group containing the DKIM records for this domain
   */
  groupDkim: DeleteDomain_domainDelete_domain_groupDkim;
  /**
   * The group containing the custom records for this domain
   */
  groupCustom: DeleteDomain_domainDelete_domain_groupCustom;
  /**
   * The group containing the DMARC records for this domain
   */
  groupDmarc: DeleteDomain_domainDelete_domain_groupDmarc;
}

export interface DeleteDomain_domainDelete {
  __typename: "DomainDeletePayload";
  /**
   * The deleted domain.
   */
  domain: DeleteDomain_domainDelete_domain;
}

export interface DeleteDomain {
  /**
   * Deletes a domain by it's name.
   */
  domainDelete: DeleteDomain_domainDelete;
}

export interface DeleteDomainVariables {
  domain: DomainDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteSubdomain
// ====================================================

export interface DeleteSubdomain_subdomainDelete_fullDomain_groupSpf_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface DeleteSubdomain_subdomainDelete_fullDomain_groupSpf {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: DeleteSubdomain_subdomainDelete_fullDomain_groupSpf_records[];
}

export interface DeleteSubdomain_subdomainDelete_fullDomain_groupDkim_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface DeleteSubdomain_subdomainDelete_fullDomain_groupDkim {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: DeleteSubdomain_subdomainDelete_fullDomain_groupDkim_records[];
}

export interface DeleteSubdomain_subdomainDelete_fullDomain_groupCustom_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface DeleteSubdomain_subdomainDelete_fullDomain_groupCustom {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: DeleteSubdomain_subdomainDelete_fullDomain_groupCustom_records[];
}

export interface DeleteSubdomain_subdomainDelete_fullDomain_groupDmarc_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface DeleteSubdomain_subdomainDelete_fullDomain_groupDmarc {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: DeleteSubdomain_subdomainDelete_fullDomain_groupDmarc_records[];
}

export interface DeleteSubdomain_subdomainDelete_fullDomain {
  __typename: "Domain";
  /**
   * The domain ID (currently the name)
   */
  id: string;
  /**
   * The domain name
   */
  name: string;
  /**
   * If email deliverability requirements are all verified
   */
  emailDeliverabilityStatus: boolean;
  /**
   * If hosting domains are all verified
   */
  hostingTrackingStatus: boolean;
  /**
   * Whether or not the domain is not setup for email and hosting and is not in the process of verifying any records
   */
  canUseEntriSetup: boolean;
  /**
   * The group containing the SPF records for this domain
   */
  groupSpf: DeleteSubdomain_subdomainDelete_fullDomain_groupSpf;
  /**
   * The group containing the DKIM records for this domain
   */
  groupDkim: DeleteSubdomain_subdomainDelete_fullDomain_groupDkim;
  /**
   * The group containing the custom records for this domain
   */
  groupCustom: DeleteSubdomain_subdomainDelete_fullDomain_groupCustom;
  /**
   * The group containing the DMARC records for this domain
   */
  groupDmarc: DeleteSubdomain_subdomainDelete_fullDomain_groupDmarc;
}

export interface DeleteSubdomain_subdomainDelete {
  __typename: "SubdomainDeletePayload";
  /**
   * The deleted subdomain.
   */
  fullDomain: DeleteSubdomain_subdomainDelete_fullDomain;
}

export interface DeleteSubdomain {
  /**
   * Deletes a subdomain by it's name.
   */
  subdomainDelete: DeleteSubdomain_subdomainDelete;
}

export interface DeleteSubdomainVariables {
  subdomain: SubdomainDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetLandingPageDomain
// ====================================================

export interface SetLandingPageDomain_landingPageDomainSet {
  __typename: "LandingPageDomainSetPayload";
  /**
   * The id of the selected domain.
   */
  domainId: string | null;
}

export interface SetLandingPageDomain {
  /**
   * Sets the landing page domain for the instance
   */
  landingPageDomainSet: SetLandingPageDomain_landingPageDomainSet;
}

export interface SetLandingPageDomainVariables {
  input: LandingPageDomainSetInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ShortenedUrlDomainSet
// ====================================================

export interface ShortenedUrlDomainSet_shortenedUrlDomainSet {
  __typename: "ShortenedUrlDomainSetPayload";
  /**
   * The id of the selected domain.
   */
  domainId: string | null;
}

export interface ShortenedUrlDomainSet {
  /**
   * Sets the Forms & Scheduler domain for the instance
   */
  shortenedUrlDomainSet: ShortenedUrlDomainSet_shortenedUrlDomainSet;
}

export interface ShortenedUrlDomainSetVariables {
  input: ShortenedUrlDomainSetInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDomainFeatureStatuses
// ====================================================

export interface GetDomainFeatureStatuses_domainFeatureStatuses_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The domain name
   */
  name: string;
}

export interface GetDomainFeatureStatuses_domainFeatureStatuses {
  __typename: "DomainFeatureStatus";
  /**
   * The key of the status
   */
  key: DomainFeatureStatusKey;
  /**
   * The status of the feature
   */
  status: FeatureStatus;
  /**
   * Information about the status check result
   */
  fromDomain: GetDomainFeatureStatuses_domainFeatureStatuses_fromDomain | null;
  /**
   * The fully qualified domain name
   */
  fqdn: string | null;
}

export interface GetDomainFeatureStatuses {
  /**
   * A list of domain-based status items
   */
  domainFeatureStatuses: GetDomainFeatureStatuses_domainFeatureStatuses[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDomains
// ====================================================

export interface GetDomains_domains_groupSpf_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface GetDomains_domains_groupSpf {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: GetDomains_domains_groupSpf_records[];
}

export interface GetDomains_domains_groupDkim_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface GetDomains_domains_groupDkim {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: GetDomains_domains_groupDkim_records[];
}

export interface GetDomains_domains_groupCustom_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface GetDomains_domains_groupCustom {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: GetDomains_domains_groupCustom_records[];
}

export interface GetDomains_domains_groupDmarc_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface GetDomains_domains_groupDmarc {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: GetDomains_domains_groupDmarc_records[];
}

export interface GetDomains_domains {
  __typename: "Domain";
  /**
   * The domain ID (currently the name)
   */
  id: string;
  /**
   * The domain name
   */
  name: string;
  /**
   * If email deliverability requirements are all verified
   */
  emailDeliverabilityStatus: boolean;
  /**
   * If hosting domains are all verified
   */
  hostingTrackingStatus: boolean;
  /**
   * Whether or not the domain is not setup for email and hosting and is not in the process of verifying any records
   */
  canUseEntriSetup: boolean;
  /**
   * The group containing the SPF records for this domain
   */
  groupSpf: GetDomains_domains_groupSpf;
  /**
   * The group containing the DKIM records for this domain
   */
  groupDkim: GetDomains_domains_groupDkim;
  /**
   * The group containing the custom records for this domain
   */
  groupCustom: GetDomains_domains_groupCustom;
  /**
   * The group containing the DMARC records for this domain
   */
  groupDmarc: GetDomains_domains_groupDmarc;
}

export interface GetDomains {
  /**
   * Returns a list of domains
   */
  domains: GetDomains_domains[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateDigestSubscription
// ====================================================

export interface UpdateDigestSubscription_digestSubscriptionUpdate_subscription {
  __typename: "DigestSubscription";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  isActive: boolean;
  /**
   * Frequency for email digest subscription
   */
  frequency: DigestFrequencyEnum;
  /**
   * Email digest type
   */
  digestType: DigestTypeEnum;
}

export interface UpdateDigestSubscription_digestSubscriptionUpdate {
  __typename: "DigestConfiguration";
  subscription: UpdateDigestSubscription_digestSubscriptionUpdate_subscription | null;
  nextSendDate: string | null;
}

export interface UpdateDigestSubscription {
  /**
   * Updates the details of an email digest subscription
   */
  digestSubscriptionUpdate: UpdateDigestSubscription_digestSubscriptionUpdate | null;
}

export interface UpdateDigestSubscriptionVariables {
  input: DigestSubscriptionUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDigestConfiguration
// ====================================================

export interface GetDigestConfiguration_digestConfiguration_subscription {
  __typename: "DigestSubscription";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  isActive: boolean;
  /**
   * Frequency for email digest subscription
   */
  frequency: DigestFrequencyEnum;
  /**
   * Email digest type
   */
  digestType: DigestTypeEnum;
}

export interface GetDigestConfiguration_digestConfiguration {
  __typename: "DigestConfiguration";
  subscription: GetDigestConfiguration_digestConfiguration_subscription | null;
  nextSendDate: string | null;
}

export interface GetDigestConfiguration {
  /**
   * Configuration for the email digest page
   */
  digestConfiguration: GetDigestConfiguration_digestConfiguration | null;
}

export interface GetDigestConfigurationVariables {
  digestType: DigestTypeEnum;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDigestPreview
// ====================================================

export interface GetDigestPreview_digestPreview {
  __typename: "DigestPreview";
  previewHtml: string | null;
}

export interface GetDigestPreview {
  /**
   * Preview for the email digest page
   */
  digestPreview: GetDigestPreview_digestPreview | null;
}

export interface GetDigestPreviewVariables {
  digestType: DigestTypeEnum;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AttemptToVerifySmtpConnection
// ====================================================

export interface AttemptToVerifySmtpConnection_smtpConnectionAttemptToVerify_userEmail_smtpCredentials_settings {
  __typename: "SmtpCredentialsSettings";
  /**
   * Hostname for the SMTP connection
   */
  hostname: string;
  /**
   * Username for the connection
   */
  username: string;
  /**
   * The password associated with this account
   */
  password: string;
  /**
   * SSL or TLS information
   */
  ssl: SmtpPortType;
  /**
   * Port to use for this connection
   */
  port: string;
}

export interface AttemptToVerifySmtpConnection_smtpConnectionAttemptToVerify_userEmail_smtpCredentials {
  __typename: "SmtpCredentials";
  /**
   * The settings associated with this SMTP connection
   */
  settings: AttemptToVerifySmtpConnection_smtpConnectionAttemptToVerify_userEmail_smtpCredentials_settings;
  /**
   * Status of the SMTP connection (unverified, verifying, verified, etc.)
   */
  verificationStatus: SmtpConnectionVerificationStatus;
  /**
   * Message from the server about the verification status
   */
  verificationMessage: string | null;
}

export interface AttemptToVerifySmtpConnection_smtpConnectionAttemptToVerify_userEmail {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
  /**
   * Errors relating to email send
   */
  sendErrors: string[];
  /**
   * Is email sync enabled for this address? When the user is sending follow-ups,
   * for example, it’s nice to warn them if sync is not enabled
   */
  isSyncEnabled: boolean;
  /**
   * Errors relating to the sync status of this email
   */
  syncErrors: string[];
  /**
   * Is this email address able to have sync turned on
   */
  allowsEmailSync: boolean;
  /**
   * The address string of this email.
   */
  address: string;
  display: string | null;
  formatted: string;
  type: UserEmailType;
  smtpCredentials: AttemptToVerifySmtpConnection_smtpConnectionAttemptToVerify_userEmail_smtpCredentials | null;
}

export interface AttemptToVerifySmtpConnection_smtpConnectionAttemptToVerify {
  __typename: "SmtpConnectionAttemptToVerifyPayload";
  /**
   * The userEmail associated with the smtp connection that was attempted to be verified
   */
  userEmail: AttemptToVerifySmtpConnection_smtpConnectionAttemptToVerify_userEmail;
}

export interface AttemptToVerifySmtpConnection {
  /**
   * Attempt to verify a user email’s SMTP connection
   */
  smtpConnectionAttemptToVerify: AttemptToVerifySmtpConnection_smtpConnectionAttemptToVerify | null;
}

export interface AttemptToVerifySmtpConnectionVariables {
  userEmailId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: createUserEmailAddress
// ====================================================

export interface createUserEmailAddress_userEmailCreate_userEmail_smtpCredentials_settings {
  __typename: "SmtpCredentialsSettings";
  /**
   * Hostname for the SMTP connection
   */
  hostname: string;
  /**
   * Username for the connection
   */
  username: string;
  /**
   * The password associated with this account
   */
  password: string;
  /**
   * SSL or TLS information
   */
  ssl: SmtpPortType;
  /**
   * Port to use for this connection
   */
  port: string;
}

export interface createUserEmailAddress_userEmailCreate_userEmail_smtpCredentials {
  __typename: "SmtpCredentials";
  /**
   * The settings associated with this SMTP connection
   */
  settings: createUserEmailAddress_userEmailCreate_userEmail_smtpCredentials_settings;
  /**
   * Status of the SMTP connection (unverified, verifying, verified, etc.)
   */
  verificationStatus: SmtpConnectionVerificationStatus;
  /**
   * Message from the server about the verification status
   */
  verificationMessage: string | null;
}

export interface createUserEmailAddress_userEmailCreate_userEmail {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
  /**
   * Errors relating to email send
   */
  sendErrors: string[];
  /**
   * Is email sync enabled for this address? When the user is sending follow-ups,
   * for example, it’s nice to warn them if sync is not enabled
   */
  isSyncEnabled: boolean;
  /**
   * Errors relating to the sync status of this email
   */
  syncErrors: string[];
  /**
   * Is this email address able to have sync turned on
   */
  allowsEmailSync: boolean;
  /**
   * The address string of this email.
   */
  address: string;
  display: string | null;
  formatted: string;
  type: UserEmailType;
  smtpCredentials: createUserEmailAddress_userEmailCreate_userEmail_smtpCredentials | null;
}

export interface createUserEmailAddress_userEmailCreate {
  __typename: "UserEmailCreatePayload";
  userEmail: createUserEmailAddress_userEmailCreate_userEmail;
}

export interface createUserEmailAddress {
  /**
   * Creates a new User_Email for the current user.
   */
  userEmailCreate: createUserEmailAddress_userEmailCreate;
}

export interface createUserEmailAddressVariables {
  emailAddress: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DisableSmtpConnection
// ====================================================

export interface DisableSmtpConnection_smtpConnectionDisable_userEmail_smtpCredentials_settings {
  __typename: "SmtpCredentialsSettings";
  /**
   * Hostname for the SMTP connection
   */
  hostname: string;
  /**
   * Username for the connection
   */
  username: string;
  /**
   * The password associated with this account
   */
  password: string;
  /**
   * SSL or TLS information
   */
  ssl: SmtpPortType;
  /**
   * Port to use for this connection
   */
  port: string;
}

export interface DisableSmtpConnection_smtpConnectionDisable_userEmail_smtpCredentials {
  __typename: "SmtpCredentials";
  /**
   * The settings associated with this SMTP connection
   */
  settings: DisableSmtpConnection_smtpConnectionDisable_userEmail_smtpCredentials_settings;
  /**
   * Status of the SMTP connection (unverified, verifying, verified, etc.)
   */
  verificationStatus: SmtpConnectionVerificationStatus;
  /**
   * Message from the server about the verification status
   */
  verificationMessage: string | null;
}

export interface DisableSmtpConnection_smtpConnectionDisable_userEmail {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
  /**
   * Errors relating to email send
   */
  sendErrors: string[];
  /**
   * Is email sync enabled for this address? When the user is sending follow-ups,
   * for example, it’s nice to warn them if sync is not enabled
   */
  isSyncEnabled: boolean;
  /**
   * Errors relating to the sync status of this email
   */
  syncErrors: string[];
  /**
   * Is this email address able to have sync turned on
   */
  allowsEmailSync: boolean;
  /**
   * The address string of this email.
   */
  address: string;
  display: string | null;
  formatted: string;
  type: UserEmailType;
  smtpCredentials: DisableSmtpConnection_smtpConnectionDisable_userEmail_smtpCredentials | null;
}

export interface DisableSmtpConnection_smtpConnectionDisable {
  __typename: "SmtpConnectionDisablePayload";
  /**
   * The userEmail associated with smtp connection that was disabled
   */
  userEmail: DisableSmtpConnection_smtpConnectionDisable_userEmail;
}

export interface DisableSmtpConnection {
  /**
   * Disables a user email’s SMTP connection, and clears the settings
   */
  smtpConnectionDisable: DisableSmtpConnection_smtpConnectionDisable | null;
}

export interface DisableSmtpConnectionVariables {
  userEmailId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: setGoogleMailSendIsEnabled
// ====================================================

export interface setGoogleMailSendIsEnabled_setGoogleMailSendIsEnabled_emailAddresses_smtpCredentials_settings {
  __typename: "SmtpCredentialsSettings";
  /**
   * Hostname for the SMTP connection
   */
  hostname: string;
  /**
   * Username for the connection
   */
  username: string;
  /**
   * The password associated with this account
   */
  password: string;
  /**
   * SSL or TLS information
   */
  ssl: SmtpPortType;
  /**
   * Port to use for this connection
   */
  port: string;
}

export interface setGoogleMailSendIsEnabled_setGoogleMailSendIsEnabled_emailAddresses_smtpCredentials {
  __typename: "SmtpCredentials";
  /**
   * The settings associated with this SMTP connection
   */
  settings: setGoogleMailSendIsEnabled_setGoogleMailSendIsEnabled_emailAddresses_smtpCredentials_settings;
  /**
   * Status of the SMTP connection (unverified, verifying, verified, etc.)
   */
  verificationStatus: SmtpConnectionVerificationStatus;
  /**
   * Message from the server about the verification status
   */
  verificationMessage: string | null;
}

export interface setGoogleMailSendIsEnabled_setGoogleMailSendIsEnabled_emailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
  /**
   * Errors relating to email send
   */
  sendErrors: string[];
  /**
   * Is email sync enabled for this address? When the user is sending follow-ups,
   * for example, it’s nice to warn them if sync is not enabled
   */
  isSyncEnabled: boolean;
  /**
   * Errors relating to the sync status of this email
   */
  syncErrors: string[];
  /**
   * Is this email address able to have sync turned on
   */
  allowsEmailSync: boolean;
  /**
   * The address string of this email.
   */
  address: string;
  display: string | null;
  formatted: string;
  type: UserEmailType;
  smtpCredentials: setGoogleMailSendIsEnabled_setGoogleMailSendIsEnabled_emailAddresses_smtpCredentials | null;
}

export interface setGoogleMailSendIsEnabled_setGoogleMailSendIsEnabled {
  __typename: "SetGoogleMailSendIsEnabledPayload";
  /**
   * URL to direct the user to if we need to authenticate with an external service, or null if authentication is unnecessary
   */
  authUrl: string | null;
  /**
   * List of user email addresses that a user is able to use within Nutshell.
   */
  emailAddresses: setGoogleMailSendIsEnabled_setGoogleMailSendIsEnabled_emailAddresses[];
}

export interface setGoogleMailSendIsEnabled {
  /**
   * Enable or disable google mail sending.
   */
  setGoogleMailSendIsEnabled: setGoogleMailSendIsEnabled_setGoogleMailSendIsEnabled | null;
}

export interface setGoogleMailSendIsEnabledVariables {
  isEnabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: setGoogleMailSyncIsEnabled
// ====================================================

export interface setGoogleMailSyncIsEnabled_setGoogleMailSyncIsEnabled_emailAddresses_smtpCredentials_settings {
  __typename: "SmtpCredentialsSettings";
  /**
   * Hostname for the SMTP connection
   */
  hostname: string;
  /**
   * Username for the connection
   */
  username: string;
  /**
   * The password associated with this account
   */
  password: string;
  /**
   * SSL or TLS information
   */
  ssl: SmtpPortType;
  /**
   * Port to use for this connection
   */
  port: string;
}

export interface setGoogleMailSyncIsEnabled_setGoogleMailSyncIsEnabled_emailAddresses_smtpCredentials {
  __typename: "SmtpCredentials";
  /**
   * The settings associated with this SMTP connection
   */
  settings: setGoogleMailSyncIsEnabled_setGoogleMailSyncIsEnabled_emailAddresses_smtpCredentials_settings;
  /**
   * Status of the SMTP connection (unverified, verifying, verified, etc.)
   */
  verificationStatus: SmtpConnectionVerificationStatus;
  /**
   * Message from the server about the verification status
   */
  verificationMessage: string | null;
}

export interface setGoogleMailSyncIsEnabled_setGoogleMailSyncIsEnabled_emailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
  /**
   * Errors relating to email send
   */
  sendErrors: string[];
  /**
   * Is email sync enabled for this address? When the user is sending follow-ups,
   * for example, it’s nice to warn them if sync is not enabled
   */
  isSyncEnabled: boolean;
  /**
   * Errors relating to the sync status of this email
   */
  syncErrors: string[];
  /**
   * Is this email address able to have sync turned on
   */
  allowsEmailSync: boolean;
  /**
   * The address string of this email.
   */
  address: string;
  display: string | null;
  formatted: string;
  type: UserEmailType;
  smtpCredentials: setGoogleMailSyncIsEnabled_setGoogleMailSyncIsEnabled_emailAddresses_smtpCredentials | null;
}

export interface setGoogleMailSyncIsEnabled_setGoogleMailSyncIsEnabled {
  __typename: "SetGoogleMailSyncIsEnabledPayload";
  /**
   * URL to direct the user to if we need to authenticate with an external service, or null if authentication is unnecessary
   */
  authUrl: string | null;
  /**
   * The user email that sync is now enabled on
   */
  emailAddresses: setGoogleMailSyncIsEnabled_setGoogleMailSyncIsEnabled_emailAddresses[];
}

export interface setGoogleMailSyncIsEnabled {
  /**
   * Enable or disable Google email sync.
   */
  setGoogleMailSyncIsEnabled: setGoogleMailSyncIsEnabled_setGoogleMailSyncIsEnabled | null;
}

export interface setGoogleMailSyncIsEnabledVariables {
  isEnabled: boolean;
  fromDaysAgo?: number | null;
  createContacts?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: setOffice365MailSendIsEnabled
// ====================================================

export interface setOffice365MailSendIsEnabled_setOffice365MailSendIsEnabled_emailAddresses_smtpCredentials_settings {
  __typename: "SmtpCredentialsSettings";
  /**
   * Hostname for the SMTP connection
   */
  hostname: string;
  /**
   * Username for the connection
   */
  username: string;
  /**
   * The password associated with this account
   */
  password: string;
  /**
   * SSL or TLS information
   */
  ssl: SmtpPortType;
  /**
   * Port to use for this connection
   */
  port: string;
}

export interface setOffice365MailSendIsEnabled_setOffice365MailSendIsEnabled_emailAddresses_smtpCredentials {
  __typename: "SmtpCredentials";
  /**
   * The settings associated with this SMTP connection
   */
  settings: setOffice365MailSendIsEnabled_setOffice365MailSendIsEnabled_emailAddresses_smtpCredentials_settings;
  /**
   * Status of the SMTP connection (unverified, verifying, verified, etc.)
   */
  verificationStatus: SmtpConnectionVerificationStatus;
  /**
   * Message from the server about the verification status
   */
  verificationMessage: string | null;
}

export interface setOffice365MailSendIsEnabled_setOffice365MailSendIsEnabled_emailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
  /**
   * Errors relating to email send
   */
  sendErrors: string[];
  /**
   * Is email sync enabled for this address? When the user is sending follow-ups,
   * for example, it’s nice to warn them if sync is not enabled
   */
  isSyncEnabled: boolean;
  /**
   * Errors relating to the sync status of this email
   */
  syncErrors: string[];
  /**
   * Is this email address able to have sync turned on
   */
  allowsEmailSync: boolean;
  /**
   * The address string of this email.
   */
  address: string;
  display: string | null;
  formatted: string;
  type: UserEmailType;
  smtpCredentials: setOffice365MailSendIsEnabled_setOffice365MailSendIsEnabled_emailAddresses_smtpCredentials | null;
}

export interface setOffice365MailSendIsEnabled_setOffice365MailSendIsEnabled {
  __typename: "SetOffice365MailSendIsEnabledPayload";
  /**
   * URL to direct the user to if we need to authenticate with an external service, or null if authentication is unnecessary
   */
  authUrl: string | null;
  /**
   * List of user email addresses that a user is able to use within Nutshell.
   */
  emailAddresses: setOffice365MailSendIsEnabled_setOffice365MailSendIsEnabled_emailAddresses[];
}

export interface setOffice365MailSendIsEnabled {
  /**
   * Enable or disable Office365 mail sending.
   */
  setOffice365MailSendIsEnabled: setOffice365MailSendIsEnabled_setOffice365MailSendIsEnabled | null;
}

export interface setOffice365MailSendIsEnabledVariables {
  isEnabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: setOffice365MailSyncIsEnabled
// ====================================================

export interface setOffice365MailSyncIsEnabled_setOffice365MailSyncIsEnabled_emailAddresses_smtpCredentials_settings {
  __typename: "SmtpCredentialsSettings";
  /**
   * Hostname for the SMTP connection
   */
  hostname: string;
  /**
   * Username for the connection
   */
  username: string;
  /**
   * The password associated with this account
   */
  password: string;
  /**
   * SSL or TLS information
   */
  ssl: SmtpPortType;
  /**
   * Port to use for this connection
   */
  port: string;
}

export interface setOffice365MailSyncIsEnabled_setOffice365MailSyncIsEnabled_emailAddresses_smtpCredentials {
  __typename: "SmtpCredentials";
  /**
   * The settings associated with this SMTP connection
   */
  settings: setOffice365MailSyncIsEnabled_setOffice365MailSyncIsEnabled_emailAddresses_smtpCredentials_settings;
  /**
   * Status of the SMTP connection (unverified, verifying, verified, etc.)
   */
  verificationStatus: SmtpConnectionVerificationStatus;
  /**
   * Message from the server about the verification status
   */
  verificationMessage: string | null;
}

export interface setOffice365MailSyncIsEnabled_setOffice365MailSyncIsEnabled_emailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
  /**
   * Errors relating to email send
   */
  sendErrors: string[];
  /**
   * Is email sync enabled for this address? When the user is sending follow-ups,
   * for example, it’s nice to warn them if sync is not enabled
   */
  isSyncEnabled: boolean;
  /**
   * Errors relating to the sync status of this email
   */
  syncErrors: string[];
  /**
   * Is this email address able to have sync turned on
   */
  allowsEmailSync: boolean;
  /**
   * The address string of this email.
   */
  address: string;
  display: string | null;
  formatted: string;
  type: UserEmailType;
  smtpCredentials: setOffice365MailSyncIsEnabled_setOffice365MailSyncIsEnabled_emailAddresses_smtpCredentials | null;
}

export interface setOffice365MailSyncIsEnabled_setOffice365MailSyncIsEnabled {
  __typename: "SetOffice365MailSyncIsEnabledPayload";
  /**
   * URL to direct the user to if we need to authenticate with an external service, or null if authentication is unnecessary
   */
  authUrl: string | null;
  /**
   * The user email that sync is now enabled on
   */
  emailAddresses: setOffice365MailSyncIsEnabled_setOffice365MailSyncIsEnabled_emailAddresses[];
}

export interface setOffice365MailSyncIsEnabled {
  /**
   * Enable or disable Office365 email sync.
   */
  setOffice365MailSyncIsEnabled: setOffice365MailSyncIsEnabled_setOffice365MailSyncIsEnabled | null;
}

export interface setOffice365MailSyncIsEnabledVariables {
  isEnabled: boolean;
  fromDaysAgo?: number | null;
  createContacts?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetSmtpMailSendIsEnabled
// ====================================================

export interface SetSmtpMailSendIsEnabled_setSmtpMailSendIsEnabled_emailAddresses_smtpCredentials_settings {
  __typename: "SmtpCredentialsSettings";
  /**
   * Hostname for the SMTP connection
   */
  hostname: string;
  /**
   * Username for the connection
   */
  username: string;
  /**
   * The password associated with this account
   */
  password: string;
  /**
   * SSL or TLS information
   */
  ssl: SmtpPortType;
  /**
   * Port to use for this connection
   */
  port: string;
}

export interface SetSmtpMailSendIsEnabled_setSmtpMailSendIsEnabled_emailAddresses_smtpCredentials {
  __typename: "SmtpCredentials";
  /**
   * The settings associated with this SMTP connection
   */
  settings: SetSmtpMailSendIsEnabled_setSmtpMailSendIsEnabled_emailAddresses_smtpCredentials_settings;
  /**
   * Status of the SMTP connection (unverified, verifying, verified, etc.)
   */
  verificationStatus: SmtpConnectionVerificationStatus;
  /**
   * Message from the server about the verification status
   */
  verificationMessage: string | null;
}

export interface SetSmtpMailSendIsEnabled_setSmtpMailSendIsEnabled_emailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
  /**
   * Errors relating to email send
   */
  sendErrors: string[];
  /**
   * Is email sync enabled for this address? When the user is sending follow-ups,
   * for example, it’s nice to warn them if sync is not enabled
   */
  isSyncEnabled: boolean;
  /**
   * Errors relating to the sync status of this email
   */
  syncErrors: string[];
  /**
   * Is this email address able to have sync turned on
   */
  allowsEmailSync: boolean;
  /**
   * The address string of this email.
   */
  address: string;
  display: string | null;
  formatted: string;
  type: UserEmailType;
  smtpCredentials: SetSmtpMailSendIsEnabled_setSmtpMailSendIsEnabled_emailAddresses_smtpCredentials | null;
}

export interface SetSmtpMailSendIsEnabled_setSmtpMailSendIsEnabled {
  __typename: "SetSmtpMailSendIsEnabledPayload";
  /**
   * List of user email addresses that a user is able to use within Nutshell.
   */
  emailAddresses: SetSmtpMailSendIsEnabled_setSmtpMailSendIsEnabled_emailAddresses[];
}

export interface SetSmtpMailSendIsEnabled {
  /**
   * Enable or disable smtp mail sending.
   */
  setSmtpMailSendIsEnabled: SetSmtpMailSendIsEnabled_setSmtpMailSendIsEnabled | null;
}

export interface SetSmtpMailSendIsEnabledVariables {
  userEmailId: string;
  isEnabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: setUserEmailSignature
// ====================================================

export interface setUserEmailSignature_updateUserEmailSignature_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Full email signature for this user. Currently using base64 encoded images, so we can just send back a string
   */
  emailSignature: string | null;
}

export interface setUserEmailSignature_updateUserEmailSignature {
  __typename: "UpdateUserEmailSignaturePayload";
  /**
   * The user
   */
  user: setUserEmailSignature_updateUserEmailSignature_user;
}

export interface setUserEmailSignature {
  /**
   * Update a users email signature.
   */
  updateUserEmailSignature: setUserEmailSignature_updateUserEmailSignature | null;
}

export interface setUserEmailSignatureVariables {
  emailSignature?: string | null;
  userId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateSmtpSettings
// ====================================================

export interface UpdateSmtpSettings_smtpSettingsUpdate_userEmail_smtpCredentials_settings {
  __typename: "SmtpCredentialsSettings";
  /**
   * Hostname for the SMTP connection
   */
  hostname: string;
  /**
   * Username for the connection
   */
  username: string;
  /**
   * The password associated with this account
   */
  password: string;
  /**
   * SSL or TLS information
   */
  ssl: SmtpPortType;
  /**
   * Port to use for this connection
   */
  port: string;
}

export interface UpdateSmtpSettings_smtpSettingsUpdate_userEmail_smtpCredentials {
  __typename: "SmtpCredentials";
  /**
   * The settings associated with this SMTP connection
   */
  settings: UpdateSmtpSettings_smtpSettingsUpdate_userEmail_smtpCredentials_settings;
  /**
   * Status of the SMTP connection (unverified, verifying, verified, etc.)
   */
  verificationStatus: SmtpConnectionVerificationStatus;
  /**
   * Message from the server about the verification status
   */
  verificationMessage: string | null;
}

export interface UpdateSmtpSettings_smtpSettingsUpdate_userEmail {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
  /**
   * Errors relating to email send
   */
  sendErrors: string[];
  /**
   * Is email sync enabled for this address? When the user is sending follow-ups,
   * for example, it’s nice to warn them if sync is not enabled
   */
  isSyncEnabled: boolean;
  /**
   * Errors relating to the sync status of this email
   */
  syncErrors: string[];
  /**
   * Is this email address able to have sync turned on
   */
  allowsEmailSync: boolean;
  /**
   * The address string of this email.
   */
  address: string;
  display: string | null;
  formatted: string;
  type: UserEmailType;
  smtpCredentials: UpdateSmtpSettings_smtpSettingsUpdate_userEmail_smtpCredentials | null;
}

export interface UpdateSmtpSettings_smtpSettingsUpdate {
  __typename: "SmtpSettingsUpdatePayload";
  /**
   * The userEmail associated with smtp connection
   */
  userEmail: UpdateSmtpSettings_smtpSettingsUpdate_userEmail;
}

export interface UpdateSmtpSettings {
  /**
   * Saves SMTP Settings settings, but DOES NOT test them, which is handled in a separate mutation
   */
  smtpSettingsUpdate: UpdateSmtpSettings_smtpSettingsUpdate | null;
}

export interface UpdateSmtpSettingsVariables {
  smtpSettings: SmtpSettingsUpdateInputFieldInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetGlobalBlocklistedEmails
// ====================================================

export interface GetGlobalBlocklistedEmails_globallyBlocklistedEmails {
  __typename: "GloballyBlocklistedEmail";
  /**
   * The Globally blocklisted email address
   */
  emailAddress: string;
}

export interface GetGlobalBlocklistedEmails {
  /**
   * Get a list of instance-wide blocklisted emails
   */
  globallyBlocklistedEmails: GetGlobalBlocklistedEmails_globallyBlocklistedEmails[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPinnedDomains
// ====================================================

export interface GetPinnedDomains_sessionInstance {
  __typename: "Instance";
  /**
   * A list of email domains that have been pinned to the instance.
   */
  pinnedDomains: string[];
  /**
   * A list of internal domains that have been configured for this instance.
   */
  internalDomains: string[];
}

export interface GetPinnedDomains {
  /**
   * A hodge-podge of instance-level concerns
   */
  sessionInstance: GetPinnedDomains_sessionInstance | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSendableEmails
// ====================================================

export interface GetSendableEmails_loggedInUser_emailAddresses_smtpCredentials_settings {
  __typename: "SmtpCredentialsSettings";
  /**
   * Hostname for the SMTP connection
   */
  hostname: string;
  /**
   * Username for the connection
   */
  username: string;
  /**
   * The password associated with this account
   */
  password: string;
  /**
   * SSL or TLS information
   */
  ssl: SmtpPortType;
  /**
   * Port to use for this connection
   */
  port: string;
}

export interface GetSendableEmails_loggedInUser_emailAddresses_smtpCredentials {
  __typename: "SmtpCredentials";
  /**
   * The settings associated with this SMTP connection
   */
  settings: GetSendableEmails_loggedInUser_emailAddresses_smtpCredentials_settings;
  /**
   * Status of the SMTP connection (unverified, verifying, verified, etc.)
   */
  verificationStatus: SmtpConnectionVerificationStatus;
  /**
   * Message from the server about the verification status
   */
  verificationMessage: string | null;
}

export interface GetSendableEmails_loggedInUser_emailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
  /**
   * Errors relating to email send
   */
  sendErrors: string[];
  /**
   * Is email sync enabled for this address? When the user is sending follow-ups,
   * for example, it’s nice to warn them if sync is not enabled
   */
  isSyncEnabled: boolean;
  /**
   * Errors relating to the sync status of this email
   */
  syncErrors: string[];
  /**
   * Is this email address able to have sync turned on
   */
  allowsEmailSync: boolean;
  /**
   * The address string of this email.
   */
  address: string;
  display: string | null;
  formatted: string;
  type: UserEmailType;
  smtpCredentials: GetSendableEmails_loggedInUser_emailAddresses_smtpCredentials | null;
}

export interface GetSendableEmails_loggedInUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * User emails configured for this user
   */
  emailAddresses: GetSendableEmails_loggedInUser_emailAddresses[];
}

export interface GetSendableEmails {
  /**
   * Returns the requesting user. This is essentially the logged in user, but in an
   * API context, they might not be any "logged in"
   */
  loggedInUser: GetSendableEmails_loggedInUser;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserEmailSignatureById
// ====================================================

export interface GetUserEmailSignatureById_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Full email signature for this user. Currently using base64 encoded images, so we can just send back a string
   */
  emailSignature: string | null;
}

export interface GetUserEmailSignatureById {
  /**
   * Returns a full Nutshell user object
   */
  user: GetUserEmailSignatureById_user;
}

export interface GetUserEmailSignatureByIdVariables {
  userId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserEmailSignature
// ====================================================

export interface GetUserEmailSignature_loggedInUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Full email signature for this user. Currently using base64 encoded images, so we can just send back a string
   */
  emailSignature: string | null;
}

export interface GetUserEmailSignature {
  /**
   * Returns the requesting user. This is essentially the logged in user, but in an
   * API context, they might not be any "logged in"
   */
  loggedInUser: GetUserEmailSignature_loggedInUser;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CsvImportEnqueue
// ====================================================

export interface CsvImportEnqueue_csvImportEnqueue_import {
  __typename: "CsvImport";
  /**
   * The origin ID of this import
   */
  originId: string;
}

export interface CsvImportEnqueue_csvImportEnqueue {
  __typename: "CsvImportEnqueuePayload";
  /**
   * The kicked off import
   */
  import: CsvImportEnqueue_csvImportEnqueue_import;
}

export interface CsvImportEnqueue {
  /**
   * Enqueue a CSV import
   */
  csvImportEnqueue: CsvImportEnqueue_csvImportEnqueue;
}

export interface CsvImportEnqueueVariables {
  input: CsvImportEnqueueInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CsvImportPrepare
// ====================================================

export interface CsvImportPrepare_csvImportPrepare_draftImport_config_columnMap {
  __typename: "CsvImportMappingOption";
  entityType: EntityType;
  /**
   * The name of the entity this column is associated with (Accounts, Contacts, Leads, Notes, Account_ContactsMap)
   */
  entityName: string;
  /**
   * The name of the field this column is associated with. Absent for Notes
   * mappings that only attach a note to a parent entity.
   */
  fieldName: string | null;
  /**
   * The qualifier on multi-key fields (e.g. "mobile" for phone, "main" for address, "twitter" for url)
   */
  fieldKey: string | null;
  /**
   * The subfield of a compound type (e.g. "givenName" / "familyName" on name, "city" / "state" on address)
   */
  subFieldName: string | null;
  /**
   * Whether this column maps to an EAV field
   */
  isEav: boolean | null;
  /**
   * The custom field type when this mapping targets an existing custom field
   */
  fieldType: EntityCustomFieldType | null;
  /**
   * For Notes mappings, the entity in the row to attach the note to (Accounts, Contacts, or Leads)
   */
  parentEntity: string | null;
}

export interface CsvImportPrepare_csvImportPrepare_draftImport_config {
  __typename: "CsvImportConfig";
  /**
   * Opaque identifier for the uploaded CSV.
   */
  fileId: string;
  /**
   * The name of the CSV file
   */
  fileName: string;
  /**
   * The mapping of columns in the CSV, indexed by column number
   */
  columnMap: (CsvImportPrepare_csvImportPrepare_draftImport_config_columnMap | null)[];
  /**
   * Whether to update existing entities
   */
  updateExisting: boolean;
  /**
   * Whether to match duplicate emails
   */
  matchDuplicateEmail: boolean;
  /**
   * Whether to match duplicate names
   */
  matchDuplicateName: boolean;
  /**
   * Whether to match duplicate company names
   */
  matchDuplicateCompanyName: boolean;
  /**
   * Whether to match duplicate account IDs
   */
  matchDuplicateAccountId: boolean;
  /**
   * Whether to match duplicate contact IDs
   */
  matchDuplicateContactId: boolean;
  /**
   * Whether to create a lead
   */
  leadCreate: CreateLeadMode;
  /**
   * Whether to create a lead for existing entities
   */
  leadCreateForExisting: boolean;
  /**
   * Whether to tag the import
   */
  shouldTagImport: boolean;
  /**
   * The tag for the import
   */
  importTag: string;
  /**
   * Causes imported contacts to be added to this audience.
   */
  audienceId: string | null;
  /**
   * When true, the import creates Unsubscribe rows instead of creating or updating entities.
   */
  unsubscribe: boolean | null;
  /**
   * The column number in the CSV that contains the email address to unsubscribe.
   */
  unsubscribeEmailAddressColumnNum: number | null;
}

export interface CsvImportPrepare_csvImportPrepare_draftImport_columns {
  __typename: "CsvImportColumn";
  /**
   * The index of the column in the CSV
   */
  index: number;
  /**
   * The name of the column in the CSV
   */
  name: string;
  /**
   * The sample values of the column in the CSV
   */
  sampleValues: string[];
}

export interface CsvImportPrepare_csvImportPrepare_draftImport {
  __typename: "CsvImportDraft";
  /**
   * The configuration for the import
   */
  config: CsvImportPrepare_csvImportPrepare_draftImport_config;
  /**
   * The columns for the uploaded CSV
   */
  columns: CsvImportPrepare_csvImportPrepare_draftImport_columns[];
  /**
   * The number of lines in the CSV file
   */
  lineCount: number;
}

export interface CsvImportPrepare_csvImportPrepare {
  __typename: "CsvImportPreparePayload";
  /**
   * The not-yet-committed import for previewing
   */
  draftImport: CsvImportPrepare_csvImportPrepare_draftImport;
}

export interface CsvImportPrepare {
  /**
   * Intakes a CSV for storage and returns import setup context
   */
  csvImportPrepare: CsvImportPrepare_csvImportPrepare;
}

export interface CsvImportPrepareVariables {
  input: CsvImportPrepareInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CsvImportRollback
// ====================================================

export interface CsvImportRollback_csvImportRollback_import_initiatingUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CsvImportRollback_csvImportRollback_import_config_columnMap {
  __typename: "CsvImportMappingOption";
  entityType: EntityType;
  /**
   * The name of the entity this column is associated with (Accounts, Contacts, Leads, Notes, Account_ContactsMap)
   */
  entityName: string;
  /**
   * The name of the field this column is associated with. Absent for Notes
   * mappings that only attach a note to a parent entity.
   */
  fieldName: string | null;
  /**
   * The qualifier on multi-key fields (e.g. "mobile" for phone, "main" for address, "twitter" for url)
   */
  fieldKey: string | null;
  /**
   * The subfield of a compound type (e.g. "givenName" / "familyName" on name, "city" / "state" on address)
   */
  subFieldName: string | null;
  /**
   * Whether this column maps to an EAV field
   */
  isEav: boolean | null;
  /**
   * The custom field type when this mapping targets an existing custom field
   */
  fieldType: EntityCustomFieldType | null;
  /**
   * For Notes mappings, the entity in the row to attach the note to (Accounts, Contacts, or Leads)
   */
  parentEntity: string | null;
}

export interface CsvImportRollback_csvImportRollback_import_config {
  __typename: "CsvImportConfig";
  /**
   * Opaque identifier for the uploaded CSV.
   */
  fileId: string;
  /**
   * The name of the CSV file
   */
  fileName: string;
  /**
   * The mapping of columns in the CSV, indexed by column number
   */
  columnMap: (CsvImportRollback_csvImportRollback_import_config_columnMap | null)[];
  /**
   * Whether to update existing entities
   */
  updateExisting: boolean;
  /**
   * Whether to match duplicate emails
   */
  matchDuplicateEmail: boolean;
  /**
   * Whether to match duplicate names
   */
  matchDuplicateName: boolean;
  /**
   * Whether to match duplicate company names
   */
  matchDuplicateCompanyName: boolean;
  /**
   * Whether to match duplicate account IDs
   */
  matchDuplicateAccountId: boolean;
  /**
   * Whether to match duplicate contact IDs
   */
  matchDuplicateContactId: boolean;
  /**
   * Whether to create a lead
   */
  leadCreate: CreateLeadMode;
  /**
   * Whether to create a lead for existing entities
   */
  leadCreateForExisting: boolean;
  /**
   * Whether to tag the import
   */
  shouldTagImport: boolean;
  /**
   * The tag for the import
   */
  importTag: string;
  /**
   * Causes imported contacts to be added to this audience.
   */
  audienceId: string | null;
  /**
   * When true, the import creates Unsubscribe rows instead of creating or updating entities.
   */
  unsubscribe: boolean | null;
  /**
   * The column number in the CSV that contains the email address to unsubscribe.
   */
  unsubscribeEmailAddressColumnNum: number | null;
}

export interface CsvImportRollback_csvImportRollback_import_columns {
  __typename: "CsvImportColumn";
  /**
   * The index of the column in the CSV
   */
  index: number;
  /**
   * The name of the column in the CSV
   */
  name: string;
  /**
   * The sample values of the column in the CSV
   */
  sampleValues: string[];
}

export interface CsvImportRollback_csvImportRollback_import_modifiedCounts_accounts_created {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface CsvImportRollback_csvImportRollback_import_modifiedCounts_accounts_updated {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface CsvImportRollback_csvImportRollback_import_modifiedCounts_accounts {
  __typename: "CsvImportModifiedCount";
  created: CsvImportRollback_csvImportRollback_import_modifiedCounts_accounts_created;
  updated: CsvImportRollback_csvImportRollback_import_modifiedCounts_accounts_updated;
}

export interface CsvImportRollback_csvImportRollback_import_modifiedCounts_contacts_created {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface CsvImportRollback_csvImportRollback_import_modifiedCounts_contacts_updated {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface CsvImportRollback_csvImportRollback_import_modifiedCounts_contacts {
  __typename: "CsvImportModifiedCount";
  created: CsvImportRollback_csvImportRollback_import_modifiedCounts_contacts_created;
  updated: CsvImportRollback_csvImportRollback_import_modifiedCounts_contacts_updated;
}

export interface CsvImportRollback_csvImportRollback_import_modifiedCounts_leads_created {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface CsvImportRollback_csvImportRollback_import_modifiedCounts_leads_updated {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface CsvImportRollback_csvImportRollback_import_modifiedCounts_leads {
  __typename: "CsvImportModifiedCount";
  created: CsvImportRollback_csvImportRollback_import_modifiedCounts_leads_created;
  updated: CsvImportRollback_csvImportRollback_import_modifiedCounts_leads_updated;
}

export interface CsvImportRollback_csvImportRollback_import_modifiedCounts {
  __typename: "CsvImportModifiedCounts";
  accounts: CsvImportRollback_csvImportRollback_import_modifiedCounts_accounts;
  contacts: CsvImportRollback_csvImportRollback_import_modifiedCounts_contacts;
  leads: CsvImportRollback_csvImportRollback_import_modifiedCounts_leads;
}

export interface CsvImportRollback_csvImportRollback_import_bulkCreateCounts {
  __typename: "CsvImportBulkCreateActualCount";
  /**
   * Parent entity type (e.g. Accounts, Contacts, Leads)
   */
  entityName: string;
  /**
   * Field that triggered bulk creation (e.g. tag, source, industry)
   */
  fieldName: string;
  /**
   * Number of new entities created during the import
   */
  count: number;
}

export interface CsvImportRollback_csvImportRollback_import {
  __typename: "CsvImport";
  /**
   * The ID of this import
   */
  id: string;
  /**
   * The origin ID of this import
   */
  originId: string;
  /**
   * The Nutshell status type of this import
   */
  importStatus: ImportStatus;
  /**
   * The fileName of the import
   */
  fileName: string | null;
  /**
   * A list of errors that occurred during the import
   */
  errors: string[];
  /**
   * The user who initiated this import
   */
  initiatingUser: CsvImportRollback_csvImportRollback_import_initiatingUser | null;
  /**
   * The time the import was created
   */
  createdTime: any;
  /**
   * The time the import was started
   */
  startTime: any | null;
  /**
   * The time the import was finished
   */
  endTime: any | null;
  /**
   * Float 0–100 of import progress. Null until the importer has begun writing rows.
   */
  percentComplete: number;
  /**
   * The display status of the import
   */
  displayStatus: string;
  /**
   * Whether this import can be reverted right now.
   */
  canRevert: boolean;
  /**
   * The number of lines in the CSV file
   */
  lineCount: number;
  /**
   * URL to download the originally uploaded CSV file
   */
  fileDownloadUrl: string | null;
  /**
   * The configuration for the import
   */
  config: CsvImportRollback_csvImportRollback_import_config;
  /**
   * The columns for the uploaded CSV
   */
  columns: CsvImportRollback_csvImportRollback_import_columns[];
  /**
   * Actual counts split into "created" and "updated" for core entities
   */
  modifiedCounts: CsvImportRollback_csvImportRollback_import_modifiedCounts;
  /**
   * Actual counts of bulk get-or-create entities (tags, sources, etc.) created during the import
   */
  bulkCreateCounts: CsvImportRollback_csvImportRollback_import_bulkCreateCounts[];
}

export interface CsvImportRollback_csvImportRollback {
  __typename: "CsvImportRollbackPayload";
  import: CsvImportRollback_csvImportRollback_import;
}

export interface CsvImportRollback {
  /**
   * Queue rollback for a CSV import
   */
  csvImportRollback: CsvImportRollback_csvImportRollback;
}

export interface CsvImportRollbackVariables {
  input: CsvImportRollbackInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CustomFieldCandidateValidate
// ====================================================

export interface CustomFieldCandidateValidate {
  /**
   * Validates a custom field candidate
   */
  customFieldCandidateValidate: string[];
}

export interface CustomFieldCandidateValidateVariables {
  entityName: string;
  name: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCsvImportPreviewBulkCreateCount
// ====================================================

export interface GetCsvImportPreviewBulkCreateCount {
  /**
   * For a single CSV column mapping, the count of distinct values that would be newly created
   */
  csvImportPreviewBulkCreateCount: number;
}

export interface GetCsvImportPreviewBulkCreateCountVariables {
  input: CsvImportPreviewBulkCreateCountRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCsvImportDraft
// ====================================================

export interface GetCsvImportDraft_csvImportDraft_previewCounts {
  __typename: "CsvImportPreviewCounts";
  /**
   * Number of distinct rows that would create or update an account.
   */
  accounts: number;
  /**
   * Number of distinct rows that would create or update a contact.
   */
  contacts: number;
}

export interface GetCsvImportDraft_csvImportDraft_firstStageEmailAutomationsStagesets {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetCsvImportDraft_csvImportDraft {
  __typename: "CsvImportDraft";
  /**
   * Row-level estimates of how many distinct accounts and contacts the import would create or update.
   */
  previewCounts: GetCsvImportDraft_csvImportDraft_previewCounts;
  /**
   * Pipelines that have email automations or drip sequence start triggers configured on their first stage.
   */
  firstStageEmailAutomationsStagesets: GetCsvImportDraft_csvImportDraft_firstStageEmailAutomationsStagesets[];
}

export interface GetCsvImportDraft {
  /**
   * A draft of a CSV import
   */
  csvImportDraft: GetCsvImportDraft_csvImportDraft;
}

export interface GetCsvImportDraftVariables {
  csvImportConfig: CsvImportConfigInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCsvImport
// ====================================================

export interface GetCsvImport_csvImport_initiatingUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetCsvImport_csvImport_config_columnMap {
  __typename: "CsvImportMappingOption";
  entityType: EntityType;
  /**
   * The name of the entity this column is associated with (Accounts, Contacts, Leads, Notes, Account_ContactsMap)
   */
  entityName: string;
  /**
   * The name of the field this column is associated with. Absent for Notes
   * mappings that only attach a note to a parent entity.
   */
  fieldName: string | null;
  /**
   * The qualifier on multi-key fields (e.g. "mobile" for phone, "main" for address, "twitter" for url)
   */
  fieldKey: string | null;
  /**
   * The subfield of a compound type (e.g. "givenName" / "familyName" on name, "city" / "state" on address)
   */
  subFieldName: string | null;
  /**
   * Whether this column maps to an EAV field
   */
  isEav: boolean | null;
  /**
   * The custom field type when this mapping targets an existing custom field
   */
  fieldType: EntityCustomFieldType | null;
  /**
   * For Notes mappings, the entity in the row to attach the note to (Accounts, Contacts, or Leads)
   */
  parentEntity: string | null;
}

export interface GetCsvImport_csvImport_config {
  __typename: "CsvImportConfig";
  /**
   * Opaque identifier for the uploaded CSV.
   */
  fileId: string;
  /**
   * The name of the CSV file
   */
  fileName: string;
  /**
   * The mapping of columns in the CSV, indexed by column number
   */
  columnMap: (GetCsvImport_csvImport_config_columnMap | null)[];
  /**
   * Whether to update existing entities
   */
  updateExisting: boolean;
  /**
   * Whether to match duplicate emails
   */
  matchDuplicateEmail: boolean;
  /**
   * Whether to match duplicate names
   */
  matchDuplicateName: boolean;
  /**
   * Whether to match duplicate company names
   */
  matchDuplicateCompanyName: boolean;
  /**
   * Whether to match duplicate account IDs
   */
  matchDuplicateAccountId: boolean;
  /**
   * Whether to match duplicate contact IDs
   */
  matchDuplicateContactId: boolean;
  /**
   * Whether to create a lead
   */
  leadCreate: CreateLeadMode;
  /**
   * Whether to create a lead for existing entities
   */
  leadCreateForExisting: boolean;
  /**
   * Whether to tag the import
   */
  shouldTagImport: boolean;
  /**
   * The tag for the import
   */
  importTag: string;
  /**
   * Causes imported contacts to be added to this audience.
   */
  audienceId: string | null;
  /**
   * When true, the import creates Unsubscribe rows instead of creating or updating entities.
   */
  unsubscribe: boolean | null;
  /**
   * The column number in the CSV that contains the email address to unsubscribe.
   */
  unsubscribeEmailAddressColumnNum: number | null;
}

export interface GetCsvImport_csvImport_columns {
  __typename: "CsvImportColumn";
  /**
   * The index of the column in the CSV
   */
  index: number;
  /**
   * The name of the column in the CSV
   */
  name: string;
  /**
   * The sample values of the column in the CSV
   */
  sampleValues: string[];
}

export interface GetCsvImport_csvImport_modifiedCounts_accounts_created {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface GetCsvImport_csvImport_modifiedCounts_accounts_updated {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface GetCsvImport_csvImport_modifiedCounts_accounts {
  __typename: "CsvImportModifiedCount";
  created: GetCsvImport_csvImport_modifiedCounts_accounts_created;
  updated: GetCsvImport_csvImport_modifiedCounts_accounts_updated;
}

export interface GetCsvImport_csvImport_modifiedCounts_contacts_created {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface GetCsvImport_csvImport_modifiedCounts_contacts_updated {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface GetCsvImport_csvImport_modifiedCounts_contacts {
  __typename: "CsvImportModifiedCount";
  created: GetCsvImport_csvImport_modifiedCounts_contacts_created;
  updated: GetCsvImport_csvImport_modifiedCounts_contacts_updated;
}

export interface GetCsvImport_csvImport_modifiedCounts_leads_created {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface GetCsvImport_csvImport_modifiedCounts_leads_updated {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface GetCsvImport_csvImport_modifiedCounts_leads {
  __typename: "CsvImportModifiedCount";
  created: GetCsvImport_csvImport_modifiedCounts_leads_created;
  updated: GetCsvImport_csvImport_modifiedCounts_leads_updated;
}

export interface GetCsvImport_csvImport_modifiedCounts {
  __typename: "CsvImportModifiedCounts";
  accounts: GetCsvImport_csvImport_modifiedCounts_accounts;
  contacts: GetCsvImport_csvImport_modifiedCounts_contacts;
  leads: GetCsvImport_csvImport_modifiedCounts_leads;
}

export interface GetCsvImport_csvImport_bulkCreateCounts {
  __typename: "CsvImportBulkCreateActualCount";
  /**
   * Parent entity type (e.g. Accounts, Contacts, Leads)
   */
  entityName: string;
  /**
   * Field that triggered bulk creation (e.g. tag, source, industry)
   */
  fieldName: string;
  /**
   * Number of new entities created during the import
   */
  count: number;
}

export interface GetCsvImport_csvImport {
  __typename: "CsvImport";
  /**
   * The ID of this import
   */
  id: string;
  /**
   * The origin ID of this import
   */
  originId: string;
  /**
   * The Nutshell status type of this import
   */
  importStatus: ImportStatus;
  /**
   * The fileName of the import
   */
  fileName: string | null;
  /**
   * A list of errors that occurred during the import
   */
  errors: string[];
  /**
   * The user who initiated this import
   */
  initiatingUser: GetCsvImport_csvImport_initiatingUser | null;
  /**
   * The time the import was created
   */
  createdTime: any;
  /**
   * The time the import was started
   */
  startTime: any | null;
  /**
   * The time the import was finished
   */
  endTime: any | null;
  /**
   * Float 0–100 of import progress. Null until the importer has begun writing rows.
   */
  percentComplete: number;
  /**
   * The display status of the import
   */
  displayStatus: string;
  /**
   * Whether this import can be reverted right now.
   */
  canRevert: boolean;
  /**
   * The number of lines in the CSV file
   */
  lineCount: number;
  /**
   * URL to download the originally uploaded CSV file
   */
  fileDownloadUrl: string | null;
  /**
   * The configuration for the import
   */
  config: GetCsvImport_csvImport_config;
  /**
   * The columns for the uploaded CSV
   */
  columns: GetCsvImport_csvImport_columns[];
  /**
   * Actual counts split into "created" and "updated" for core entities
   */
  modifiedCounts: GetCsvImport_csvImport_modifiedCounts;
  /**
   * Actual counts of bulk get-or-create entities (tags, sources, etc.) created during the import
   */
  bulkCreateCounts: GetCsvImport_csvImport_bulkCreateCounts[];
}

export interface GetCsvImport {
  /**
   * A Nutshell CSV import
   */
  csvImport: GetCsvImport_csvImport;
}

export interface GetCsvImportVariables {
  id: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetImportColumnOptions
// ====================================================

export interface GetImportColumnOptions_importColumnOptions_account_value {
  __typename: "CsvImportMappingOption";
  entityType: EntityType;
  /**
   * The name of the entity this column is associated with (Accounts, Contacts, Leads, Notes, Account_ContactsMap)
   */
  entityName: string;
  /**
   * The name of the field this column is associated with. Absent for Notes
   * mappings that only attach a note to a parent entity.
   */
  fieldName: string | null;
  /**
   * The qualifier on multi-key fields (e.g. "mobile" for phone, "main" for address, "twitter" for url)
   */
  fieldKey: string | null;
  /**
   * The subfield of a compound type (e.g. "givenName" / "familyName" on name, "city" / "state" on address)
   */
  subFieldName: string | null;
  /**
   * Whether this column maps to an EAV field
   */
  isEav: boolean | null;
  /**
   * The custom field type when this mapping targets an existing custom field
   */
  fieldType: EntityCustomFieldType | null;
  /**
   * For Notes mappings, the entity in the row to attach the note to (Accounts, Contacts, or Leads)
   */
  parentEntity: string | null;
}

export interface GetImportColumnOptions_importColumnOptions_account {
  __typename: "ImportColumnOption";
  name: string;
  children: string[];
  root: boolean;
  value: GetImportColumnOptions_importColumnOptions_account_value | null;
}

export interface GetImportColumnOptions_importColumnOptions_contact_value {
  __typename: "CsvImportMappingOption";
  entityType: EntityType;
  /**
   * The name of the entity this column is associated with (Accounts, Contacts, Leads, Notes, Account_ContactsMap)
   */
  entityName: string;
  /**
   * The name of the field this column is associated with. Absent for Notes
   * mappings that only attach a note to a parent entity.
   */
  fieldName: string | null;
  /**
   * The qualifier on multi-key fields (e.g. "mobile" for phone, "main" for address, "twitter" for url)
   */
  fieldKey: string | null;
  /**
   * The subfield of a compound type (e.g. "givenName" / "familyName" on name, "city" / "state" on address)
   */
  subFieldName: string | null;
  /**
   * Whether this column maps to an EAV field
   */
  isEav: boolean | null;
  /**
   * The custom field type when this mapping targets an existing custom field
   */
  fieldType: EntityCustomFieldType | null;
  /**
   * For Notes mappings, the entity in the row to attach the note to (Accounts, Contacts, or Leads)
   */
  parentEntity: string | null;
}

export interface GetImportColumnOptions_importColumnOptions_contact {
  __typename: "ImportColumnOption";
  name: string;
  children: string[];
  root: boolean;
  value: GetImportColumnOptions_importColumnOptions_contact_value | null;
}

export interface GetImportColumnOptions_importColumnOptions_lead_value {
  __typename: "CsvImportMappingOption";
  entityType: EntityType;
  /**
   * The name of the entity this column is associated with (Accounts, Contacts, Leads, Notes, Account_ContactsMap)
   */
  entityName: string;
  /**
   * The name of the field this column is associated with. Absent for Notes
   * mappings that only attach a note to a parent entity.
   */
  fieldName: string | null;
  /**
   * The qualifier on multi-key fields (e.g. "mobile" for phone, "main" for address, "twitter" for url)
   */
  fieldKey: string | null;
  /**
   * The subfield of a compound type (e.g. "givenName" / "familyName" on name, "city" / "state" on address)
   */
  subFieldName: string | null;
  /**
   * Whether this column maps to an EAV field
   */
  isEav: boolean | null;
  /**
   * The custom field type when this mapping targets an existing custom field
   */
  fieldType: EntityCustomFieldType | null;
  /**
   * For Notes mappings, the entity in the row to attach the note to (Accounts, Contacts, or Leads)
   */
  parentEntity: string | null;
}

export interface GetImportColumnOptions_importColumnOptions_lead {
  __typename: "ImportColumnOption";
  name: string;
  children: string[];
  root: boolean;
  value: GetImportColumnOptions_importColumnOptions_lead_value | null;
}

export interface GetImportColumnOptions_importColumnOptions {
  __typename: "ImportColumnOptions";
  account: GetImportColumnOptions_importColumnOptions_account[];
  contact: GetImportColumnOptions_importColumnOptions_contact[];
  lead: GetImportColumnOptions_importColumnOptions_lead[];
}

export interface GetImportColumnOptions {
  importColumnOptions: GetImportColumnOptions_importColumnOptions;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RevertDromoImport
// ====================================================

export interface RevertDromoImport_dromoImportRollback_import_initiatingUser {
  __typename: "User";
  name: string;
}

export interface RevertDromoImport_dromoImportRollback_import {
  __typename: "DromoImport";
  /**
   * The origin ID of this import
   */
  id: string;
  /**
   * The Nutshell status type of this import
   */
  importStatus: ImportStatus;
  /**
   * Whether this import can be reverted right now.
   */
  canRevert: boolean;
  /**
   * The display status of the import
   */
  displayStatus: string;
  /**
   * The time the import was started
   */
  startTime: any | null;
  /**
   * The fileName of the import
   */
  fileName: string | null;
  /**
   * The URL of the original file uploaded by the user
   */
  dromoRawFileUrl: string | null;
  /**
   * The user who initiated this import
   */
  initiatingUser: RevertDromoImport_dromoImportRollback_import_initiatingUser | null;
}

export interface RevertDromoImport_dromoImportRollback {
  __typename: "DromoImportRollbackPayload";
  import: RevertDromoImport_dromoImportRollback_import;
}

export interface RevertDromoImport {
  /**
   * Queue rollback for a Dromo product import
   */
  dromoImportRollback: RevertDromoImport_dromoImportRollback;
}

export interface RevertDromoImportVariables {
  input: DromoImportRollbackInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UploadDromoImportResults
// ====================================================

export interface UploadDromoImportResults_dromoImport {
  __typename: "DromoImportPayload";
  /**
   * Whether the import has been successfully started
   */
  success: boolean;
}

export interface UploadDromoImportResults {
  /**
   * Begin processing a Dromo import
   */
  dromoImport: UploadDromoImportResults_dromoImport;
}

export interface UploadDromoImportResultsVariables {
  input: DromoImportInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDromoImports
// ====================================================

export interface GetDromoImports_dromoImports_imports_initiatingUser {
  __typename: "User";
  name: string;
}

export interface GetDromoImports_dromoImports_imports {
  __typename: "DromoImport";
  /**
   * The origin ID of this import
   */
  id: string;
  /**
   * The Nutshell status type of this import
   */
  importStatus: ImportStatus;
  /**
   * Whether this import can be reverted right now.
   */
  canRevert: boolean;
  /**
   * The display status of the import
   */
  displayStatus: string;
  /**
   * The time the import was started
   */
  startTime: any | null;
  /**
   * The fileName of the import
   */
  fileName: string | null;
  /**
   * The URL of the original file uploaded by the user
   */
  dromoRawFileUrl: string | null;
  /**
   * The user who initiated this import
   */
  initiatingUser: GetDromoImports_dromoImports_imports_initiatingUser | null;
}

export interface GetDromoImports_dromoImports_currentImport {
  __typename: "DromoImport";
  /**
   * The Nutshell status type of this import
   */
  importStatus: ImportStatus;
}

export interface GetDromoImports_dromoImports_recentCompletedImport {
  __typename: "DromoImport";
  /**
   * The Nutshell status type of this import
   */
  importStatus: ImportStatus;
}

export interface GetDromoImports_dromoImports {
  __typename: "DromoImports";
  imports: GetDromoImports_dromoImports_imports[];
  currentImport: GetDromoImports_dromoImports_currentImport | null;
  recentCompletedImport: GetDromoImports_dromoImports_recentCompletedImport | null;
}

export interface GetDromoImports {
  dromoImports: GetDromoImports_dromoImports;
}

export interface GetDromoImportsVariables {
  importIdentifier: ImportIdentifier;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetQuotaTemplate
// ====================================================

export interface GetQuotaTemplate_quotasTemplate {
  __typename: "QuotasTemplatePayload";
  csvContent: string;
}

export interface GetQuotaTemplate {
  /**
   * Generates a CSV template for quota imports, pre-populated with all enabled
   * users at zero values for the current fiscal year
   */
  quotasTemplate: GetQuotaTemplate_quotasTemplate;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ApproveImport2FullMigration
// ====================================================

export interface ApproveImport2FullMigration_import2AcceptSponsorship {
  __typename: "ImportAcceptSponsorshipPayload";
  /**
   * Boolean for whether the import was successfully purchased.
   */
  isSuccess: boolean;
}

export interface ApproveImport2FullMigration {
  /**
   * Accept sponsorship (pay) for the given Import2 migration
   */
  import2AcceptSponsorship: ApproveImport2FullMigration_import2AcceptSponsorship;
}

export interface ApproveImport2FullMigrationVariables {
  input: ImportAcceptSponsorshipInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: InitiateImport2Import
// ====================================================

export interface InitiateImport2Import_import2Initiate {
  __typename: "ImportInitiatePayload";
  /**
   * The id of the new origin row
   */
  originId: string | null;
  /**
   * The id supplied by the Import2 API
   */
  externalImportId: string | null;
  /**
   * The URL that supplies the Import2 iframe
   */
  redirectUrl: string | null;
  /**
   * Whether this is a new import or an existing one
   */
  isNewImport: boolean | null;
}

export interface InitiateImport2Import {
  /**
   * Initiate the Import2 import process
   */
  import2Initiate: InitiateImport2Import_import2Initiate;
}

export interface InitiateImport2ImportVariables {
  input: ImportInitiateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RequestImport2Sponsorship
// ====================================================

export interface RequestImport2Sponsorship_import2RequestSponsorship_import {
  __typename: "Import2Import";
  /**
   * The origin ID of this import
   */
  originId: string;
}

export interface RequestImport2Sponsorship_import2RequestSponsorship {
  __typename: "ImportRequestSponsorshipPayload";
  /**
   * Boolean for whether the import was successfully purchased.
   */
  import: RequestImport2Sponsorship_import2RequestSponsorship_import;
}

export interface RequestImport2Sponsorship {
  /**
   * Requests sponsorship (payment) from a support user for the given Import2 migration via Slack message
   */
  import2RequestSponsorship: RequestImport2Sponsorship_import2RequestSponsorship;
}

export interface RequestImport2SponsorshipVariables {
  input: ImportRequestSponsorshipInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetImport2CrmOptions
// ====================================================

export interface GetImport2CrmOptions_import2CrmOptions {
  __typename: "CrmOption";
  /**
   * The enum type of this CRM option/tool
   */
  type: CrmOptionType;
  /**
   * The formatted label of this CRM option/tool
   */
  label: string;
}

export interface GetImport2CrmOptions {
  /**
   * Returns a list of Import2 CRM options/tools
   */
  import2CrmOptions: GetImport2CrmOptions_import2CrmOptions[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetImport2ImportStatus
// ====================================================

export interface GetImport2ImportStatus_import2Import_crmOption {
  __typename: "CrmOption";
  /**
   * The enum type of this CRM option/tool
   */
  type: CrmOptionType;
  /**
   * The formatted label of this CRM option/tool
   */
  label: string;
}

export interface GetImport2ImportStatus_import2Import_initiatingUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetImport2ImportStatus_import2Import {
  __typename: "Import2Import";
  /**
   * The origin ID of this import
   */
  originId: string;
  /**
   * The CRM option of this import
   */
  crmOption: GetImport2ImportStatus_import2Import_crmOption;
  /**
   * The Import2 status type of this import
   */
  import2Status: Import2Status;
  /**
   * The Nutshell status type of this import
   */
  importStatus: ImportStatus;
  /**
   * The external (sourced from Import2) id of this import
   */
  externalImportId: string;
  /**
   * The URL for the Import2 migration page
   */
  redirectUrl: string;
  /**
   * A list of errors that occurred during the import
   */
  errors: string[];
  /**
   * The time the import was started
   */
  startTime: any | null;
  /**
   * The time the import was finished
   */
  endTime: any | null;
  /**
   * Whether or not the import has been requested for review
   */
  reviewRequested: boolean;
  /**
   * Whether the import has been reviewed and approved
   */
  reviewApproved: boolean;
  /**
   * The user who initiated this import
   */
  initiatingUser: GetImport2ImportStatus_import2Import_initiatingUser | null;
}

export interface GetImport2ImportStatus {
  /**
   * Returns an Import2 import by origin id
   */
  import2Import: GetImport2ImportStatus_import2Import;
}

export interface GetImport2ImportStatusVariables {
  originId: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: IntegrationFormSubmit
// ====================================================

export interface IntegrationFormSubmit_integrationFormSubmit {
  __typename: "IntegrationFormSubmitPayload";
  /**
   * Whether the integration form submission was successful.
   */
  success: boolean;
}

export interface IntegrationFormSubmit {
  /**
   * Submits an integration form
   */
  integrationFormSubmit: IntegrationFormSubmit_integrationFormSubmit;
}

export interface IntegrationFormSubmitVariables {
  input: IntegrationFormSubmitInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetIntegration
// ====================================================

export interface GetIntegration_integration {
  __typename: "AppIntegration";
  /**
   * Stable catalog key
   */
  key: IntegrationKey;
  /**
   * Display name
   */
  name: string;
  /**
   * Marketplace categories
   */
  categories: IntegrationCategory[];
  /**
   * How the integration is provided
   */
  provider: IntegrationProvider;
  /**
   * Whether this integration is currently connected/enabled
   */
  isEnabled: boolean;
}

export interface GetIntegration {
  /**
   * A single marketplace integration by catalog key
   */
  integration: GetIntegration_integration | null;
}

export interface GetIntegrationVariables {
  key: IntegrationKey;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetIntegrations
// ====================================================

export interface GetIntegrations_integrations_items {
  __typename: "AppIntegration";
  /**
   * Stable catalog key
   */
  key: IntegrationKey;
  /**
   * Display name
   */
  name: string;
  /**
   * Marketplace categories
   */
  categories: IntegrationCategory[];
  /**
   * How the integration is provided
   */
  provider: IntegrationProvider;
  /**
   * Whether this integration is currently connected/enabled
   */
  isEnabled: boolean;
}

export interface GetIntegrations_integrations_recommended {
  __typename: "AppIntegration";
  /**
   * Stable catalog key
   */
  key: IntegrationKey;
  /**
   * Display name
   */
  name: string;
  /**
   * Marketplace categories
   */
  categories: IntegrationCategory[];
  /**
   * How the integration is provided
   */
  provider: IntegrationProvider;
  /**
   * Whether this integration is currently connected/enabled
   */
  isEnabled: boolean;
}

export interface GetIntegrations_integrations {
  __typename: "AppIntegrations";
  items: GetIntegrations_integrations_items[];
  /**
   * Recommended integrations for this instance, excluding those already enabled
   */
  recommended: GetIntegrations_integrations_recommended[];
}

export interface GetIntegrations {
  /**
   * Marketplace integrations catalog with live enabled status
   */
  integrations: GetIntegrations_integrations;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetConstantContactIntegration
// ====================================================

export interface GetConstantContactIntegration_constantContactIntegration {
  __typename: "ConstantContactIntegration";
  /**
   * The email address used for constant contact.
   */
  email: string | null;
  /**
   * True if the integration is active, false if the user disconnected it.
   */
  isIntegrationActive: boolean;
  /**
   * Are the user‘s contacts synced between Nutshell and CC.
   */
  isContactSyncActive: boolean;
}

export interface GetConstantContactIntegration {
  /**
   * Returns a Nutshell constant contact integration object.
   */
  constantContactIntegration: GetConstantContactIntegration_constantContactIntegration | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: clearIntegrationOfType
// ====================================================

export interface clearIntegrationOfType_clearIntegration_userEmail {
  __typename: "UserEmail";
  display: string | null;
}

export interface clearIntegrationOfType_clearIntegration_calendarSync_calendars {
  __typename: "CalendarSyncCalendar";
  /**
   * The API ID for this calendar
   */
  id: string;
  /**
   * The name of this calendar
   */
  name: string;
  /**
   * Indicates if this is the calendar selected for sync
   */
  isSelected: boolean;
  /**
   * The type of sync this calendar is used for. Can be conflict, primary, or none if it is not currently in use
   */
  syncType: SyncType;
  /**
   * Errors relating to the sync status of this calendar
   */
  syncErrors: string[];
  /**
   * The email address used for the oauth connection that created this calendar
   */
  username: string;
  /**
   * The service provider for this calendar, Google, Outlook, or Exchange
   */
  serviceType: ExternalService;
  /**
   * The rules for what events, if any, should be added to the calendar from Nutshell
   */
  exportRule: CalendarExportRule;
  /**
   * Whether contact creation is disabled when syncing calendar events or external meetings
   */
  isContactCreationDisabled: boolean;
}

export interface clearIntegrationOfType_clearIntegration_calendarSync {
  __typename: "CalendarSync";
  /**
   * The email address being used for calendar sync
   */
  username: string;
  /**
   * The external calendar service we're syncing with
   */
  externalService: ExternalService;
  /**
   * Whether or not calendar sync is enabled
   */
  isEnabled: boolean;
  /**
   * Whether or not import from the primary calendar is enabled
   */
  importIsEnabled: boolean;
  /**
   * Errors relating to the sync status of the primary calendar
   */
  syncErrors: string[];
  /**
   * How to handle calendar invitations when creating activities that sync to the external calendar
   */
  inviteSetting: CalendarInviteSetting;
  /**
   * All of the calendars we can sync with
   */
  calendars: clearIntegrationOfType_clearIntegration_calendarSync_calendars[];
}

export interface clearIntegrationOfType_clearIntegration_taskSync {
  __typename: "TaskSync";
  /**
   * The email address being used for task sync
   */
  username: string;
  /**
   * The external task service we're syncing with
   */
  externalService: ExternalService;
  /**
   * Whether or not task sync is enabled
   */
  isEnabled: boolean;
  /**
   * Errors relating to the sync status of tasks
   */
  syncErrors: string[];
}

export interface clearIntegrationOfType_clearIntegration {
  __typename: "ClearIntegrationPayload";
  /**
   * The user email that was associated with the integration
   */
  userEmail: clearIntegrationOfType_clearIntegration_userEmail | null;
  /**
   * The state of calendar sync after clearing the integration
   */
  calendarSync: clearIntegrationOfType_clearIntegration_calendarSync | null;
  /**
   * The state of task sync after clearing the integration
   */
  taskSync: clearIntegrationOfType_clearIntegration_taskSync | null;
}

export interface clearIntegrationOfType {
  /**
   * Disable an integration with an external service for the current user
   */
  clearIntegration: clearIntegrationOfType_clearIntegration | null;
}

export interface clearIntegrationOfTypeVariables {
  externalService: ExternalService;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSyncStatuses
// ====================================================

export interface GetSyncStatuses_loggedInUser_taskSync {
  __typename: "TaskSync";
  /**
   * The email address being used for task sync
   */
  username: string;
  /**
   * The external task service we're syncing with
   */
  externalService: ExternalService;
  /**
   * Whether or not task sync is enabled
   */
  isEnabled: boolean;
  /**
   * Errors relating to the sync status of tasks
   */
  syncErrors: string[];
}

export interface GetSyncStatuses_loggedInUser_calendarSync_calendars {
  __typename: "CalendarSyncCalendar";
  /**
   * The API ID for this calendar
   */
  id: string;
  /**
   * The name of this calendar
   */
  name: string;
  /**
   * Indicates if this is the calendar selected for sync
   */
  isSelected: boolean;
  /**
   * The type of sync this calendar is used for. Can be conflict, primary, or none if it is not currently in use
   */
  syncType: SyncType;
  /**
   * Errors relating to the sync status of this calendar
   */
  syncErrors: string[];
  /**
   * The email address used for the oauth connection that created this calendar
   */
  username: string;
  /**
   * The service provider for this calendar, Google, Outlook, or Exchange
   */
  serviceType: ExternalService;
  /**
   * The rules for what events, if any, should be added to the calendar from Nutshell
   */
  exportRule: CalendarExportRule;
  /**
   * Whether contact creation is disabled when syncing calendar events or external meetings
   */
  isContactCreationDisabled: boolean;
}

export interface GetSyncStatuses_loggedInUser_calendarSync {
  __typename: "CalendarSync";
  /**
   * The email address being used for calendar sync
   */
  username: string;
  /**
   * The external calendar service we're syncing with
   */
  externalService: ExternalService;
  /**
   * Whether or not calendar sync is enabled
   */
  isEnabled: boolean;
  /**
   * Whether or not import from the primary calendar is enabled
   */
  importIsEnabled: boolean;
  /**
   * Errors relating to the sync status of the primary calendar
   */
  syncErrors: string[];
  /**
   * How to handle calendar invitations when creating activities that sync to the external calendar
   */
  inviteSetting: CalendarInviteSetting;
  /**
   * All of the calendars we can sync with
   */
  calendars: GetSyncStatuses_loggedInUser_calendarSync_calendars[];
}

export interface GetSyncStatuses_loggedInUser_emailAddresses_smtpCredentials_settings {
  __typename: "SmtpCredentialsSettings";
  /**
   * Hostname for the SMTP connection
   */
  hostname: string;
  /**
   * Username for the connection
   */
  username: string;
  /**
   * The password associated with this account
   */
  password: string;
  /**
   * SSL or TLS information
   */
  ssl: SmtpPortType;
  /**
   * Port to use for this connection
   */
  port: string;
}

export interface GetSyncStatuses_loggedInUser_emailAddresses_smtpCredentials {
  __typename: "SmtpCredentials";
  /**
   * The settings associated with this SMTP connection
   */
  settings: GetSyncStatuses_loggedInUser_emailAddresses_smtpCredentials_settings;
  /**
   * Status of the SMTP connection (unverified, verifying, verified, etc.)
   */
  verificationStatus: SmtpConnectionVerificationStatus;
  /**
   * Message from the server about the verification status
   */
  verificationMessage: string | null;
}

export interface GetSyncStatuses_loggedInUser_emailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
  /**
   * Errors relating to email send
   */
  sendErrors: string[];
  /**
   * Is email sync enabled for this address? When the user is sending follow-ups,
   * for example, it’s nice to warn them if sync is not enabled
   */
  isSyncEnabled: boolean;
  /**
   * Errors relating to the sync status of this email
   */
  syncErrors: string[];
  /**
   * Is this email address able to have sync turned on
   */
  allowsEmailSync: boolean;
  /**
   * The address string of this email.
   */
  address: string;
  display: string | null;
  formatted: string;
  type: UserEmailType;
  smtpCredentials: GetSyncStatuses_loggedInUser_emailAddresses_smtpCredentials | null;
}

export interface GetSyncStatuses_loggedInUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Personal iCal activity feed URL
   */
  personalCalendarFeedUrl: string | null;
  /**
   * Company iCal activity feed URL
   */
  companyCalendarFeedUrl: string | null;
  /**
   * Task sync details for this user
   */
  taskSync: GetSyncStatuses_loggedInUser_taskSync | null;
  /**
   * Calendar sync details for this user
   */
  calendarSync: GetSyncStatuses_loggedInUser_calendarSync | null;
  /**
   * User emails configured for this user
   */
  emailAddresses: GetSyncStatuses_loggedInUser_emailAddresses[];
}

export interface GetSyncStatuses {
  /**
   * Returns the requesting user. This is essentially the logged in user, but in an
   * API context, they might not be any "logged in"
   */
  loggedInUser: GetSyncStatuses_loggedInUser;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetLicensesForUser
// ====================================================

export interface SetLicensesForUser_setLicensesForUser_licenseUpdateResponse {
  __typename: "SetLicenseResponse";
  /**
   * Whether the license update was successful
   */
  wasSuccessful: boolean;
  /**
   * The error message if the license update was not successful
   */
  errorMessage: string | null;
  /**
   * The license state after the attempted mutation
   */
  newLicenseState: LicenseType[];
}

export interface SetLicensesForUser_setLicensesForUser {
  __typename: "SetLicensesForUserPayload";
  /**
   * The response from the license update
   */
  licenseUpdateResponse: SetLicensesForUser_setLicensesForUser_licenseUpdateResponse;
}

export interface SetLicensesForUser {
  /**
   * Sets the licenses for a user
   */
  setLicensesForUser: SetLicensesForUser_setLicensesForUser;
}

export interface SetLicensesForUserVariables {
  input: SetLicensesForUserInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLicenseOverview
// ====================================================

export interface GetLicenseOverview_licenseOverview_instanceLicenses {
  __typename: "LicenseInfo";
  /**
   * The type of license
   */
  licenseType: LicenseType;
  /**
   * Whether the license is purchased
   */
  isPurchased: boolean;
  /**
   * The total amount of licenses purchased
   */
  numBought: number;
  /**
   * Whether the license is unlimited
   */
  isUnlimited: boolean;
  /**
   * The amount of licenses currently in use
   */
  numUsed: number;
  /**
   * The display name of the license
   */
  displayName: string;
  /**
   * Whether another license can be added
   */
  canAdd: boolean;
}

export interface GetLicenseOverview_licenseOverview {
  __typename: "LicenseOverview";
  /**
   * Information about the instance licenses
   */
  instanceLicenses: GetLicenseOverview_licenseOverview_instanceLicenses[];
}

export interface GetLicenseOverview {
  /**
   * Returns information about the licenses for an instance
   */
  licenseOverview: GetLicenseOverview_licenseOverview;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserLicenses
// ====================================================

export interface GetUserLicenses_user_licenses {
  __typename: "UserLicenseInfo";
  /**
   * The type of the license
   */
  licenseType: LicenseType;
  /**
   * Whether the license is owned by the user
   */
  isOwned: boolean;
}

export interface GetUserLicenses_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of all licenses and whether they are enabled for this user
   */
  licenses: GetUserLicenses_user_licenses[];
}

export interface GetUserLicenses {
  /**
   * Returns a full Nutshell user object
   */
  user: GetUserLicenses_user;
}

export interface GetUserLicensesVariables {
  userId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateMfaRequiredSetting
// ====================================================

export interface UpdateMfaRequiredSetting_mfaUpdateRequiredSetting {
  __typename: "MfaUpdateRequiredSettingPayload";
  /**
   * Whether the MFA settings were updated successfully.
   */
  success: boolean;
}

export interface UpdateMfaRequiredSetting {
  /**
   * Update instance settings for MFA being required for all users.
   */
  mfaUpdateRequiredSetting: UpdateMfaRequiredSetting_mfaUpdateRequiredSetting;
}

export interface UpdateMfaRequiredSettingVariables {
  input: MfaUpdateRequiredSettingInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AssignCallRailPhoneNumber
// ====================================================

export interface AssignCallRailPhoneNumber_callRailIntegrationAssignPhoneNumber_callRailIntegration_phoneNumberAssignments_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface AssignCallRailPhoneNumber_callRailIntegrationAssignPhoneNumber_callRailIntegration_phoneNumberAssignments {
  __typename: "CallRailPhoneNumberAssignment";
  /**
   * The CallRail tracking phone number in E.164 format.
   */
  phoneNumber: string;
  /**
   * Display-formatted version of the tracking phone number.
   */
  formattedPhoneNumber: string;
  /**
   * The Nutshell user the phone number is assigned to. Null if the user has been deleted.
   */
  user: AssignCallRailPhoneNumber_callRailIntegrationAssignPhoneNumber_callRailIntegration_phoneNumberAssignments_user | null;
}

export interface AssignCallRailPhoneNumber_callRailIntegrationAssignPhoneNumber_callRailIntegration {
  __typename: "PhoneIntegration";
  /**
   * The type of integration
   */
  integrationType: ExternalServiceType;
  /**
   * CallRail-specific. Map of tracking phone numbers to the Nutshell users they
   * are assigned to. Empty for other integration types.
   */
  phoneNumberAssignments: AssignCallRailPhoneNumber_callRailIntegrationAssignPhoneNumber_callRailIntegration_phoneNumberAssignments[];
  /**
   * Unique Identifier for the user in the external system
   */
  externalUserIdentifier: string | null;
  /**
   * Additional information about the integration
   */
  tertiaryInformation: string | null;
}

export interface AssignCallRailPhoneNumber_callRailIntegrationAssignPhoneNumber {
  __typename: "CallRailIntegrationAssignPhoneNumberPayload";
  /**
   * Updated CallRail integration data
   */
  callRailIntegration: AssignCallRailPhoneNumber_callRailIntegrationAssignPhoneNumber_callRailIntegration;
}

export interface AssignCallRailPhoneNumber {
  /**
   * Assign a CallRail tracking phone number to a Nutshell user so that incoming
   * calls from that number create activities for the assigned user.
   */
  callRailIntegrationAssignPhoneNumber: AssignCallRailPhoneNumber_callRailIntegrationAssignPhoneNumber | null;
}

export interface AssignCallRailPhoneNumberVariables {
  input: CallRailIntegrationAssignPhoneNumberInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ConfigureRingCentralSmsInbox
// ====================================================

export interface ConfigureRingCentralSmsInbox_ringCentralSmsInboxConfigure_endpoint_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ConfigureRingCentralSmsInbox_ringCentralSmsInboxConfigure_endpoint_sourceChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
}

export interface ConfigureRingCentralSmsInbox_ringCentralSmsInboxConfigure_endpoint {
  __typename: "RingCentralSmsInboxEndpoint";
  /**
   * The connected RingCentral owner, or null if that user no longer exists.
   */
  owner: ConfigureRingCentralSmsInbox_ringCentralSmsInboxConfigure_endpoint_owner | null;
  extensionNumber: string | null;
  phoneNumber: string;
  /**
   * The RingCentral source channel, or null if the stored channel no longer exists.
   */
  sourceChannel: ConfigureRingCentralSmsInbox_ringCentralSmsInboxConfigure_endpoint_sourceChannel | null;
}

export interface ConfigureRingCentralSmsInbox_ringCentralSmsInboxConfigure {
  __typename: "RingCentralSmsInboxConfigurePayload";
  endpoint: ConfigureRingCentralSmsInbox_ringCentralSmsInboxConfigure_endpoint;
}

export interface ConfigureRingCentralSmsInbox {
  /**
   * Configures the active RingCentral endpoint used by the shared SMS Inbox.
   */
  ringCentralSmsInboxConfigure: ConfigureRingCentralSmsInbox_ringCentralSmsInboxConfigure;
}

export interface ConfigureRingCentralSmsInboxVariables {
  input: RingCentralSmsInboxConfigureInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateCallRailIntegration
// ====================================================

export interface CreateCallRailIntegration_callRailIntegrationCreate_callRailIntegration_phoneNumberAssignments_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateCallRailIntegration_callRailIntegrationCreate_callRailIntegration_phoneNumberAssignments {
  __typename: "CallRailPhoneNumberAssignment";
  /**
   * The CallRail tracking phone number in E.164 format.
   */
  phoneNumber: string;
  /**
   * Display-formatted version of the tracking phone number.
   */
  formattedPhoneNumber: string;
  /**
   * The Nutshell user the phone number is assigned to. Null if the user has been deleted.
   */
  user: CreateCallRailIntegration_callRailIntegrationCreate_callRailIntegration_phoneNumberAssignments_user | null;
}

export interface CreateCallRailIntegration_callRailIntegrationCreate_callRailIntegration {
  __typename: "PhoneIntegration";
  /**
   * The type of integration
   */
  integrationType: ExternalServiceType;
  /**
   * If the current user has enabled and set up credentials for this specific integration
   */
  isEnabledForUser: boolean;
  /**
   * CallRail-specific. Map of tracking phone numbers to the Nutshell users they
   * are assigned to. Empty for other integration types.
   */
  phoneNumberAssignments: CreateCallRailIntegration_callRailIntegrationCreate_callRailIntegration_phoneNumberAssignments[];
}

export interface CreateCallRailIntegration_callRailIntegrationCreate {
  __typename: "CallRailIntegrationCreatePayload";
  /**
   * The status of the callRailIntegrationCreate mutation.
   */
  status: CallRailcreateStatus;
  /**
   * Newly created CallRail integration data
   */
  callRailIntegration: CreateCallRailIntegration_callRailIntegrationCreate_callRailIntegration;
}

export interface CreateCallRailIntegration {
  /**
   * Create a new CallRail integration
   */
  callRailIntegrationCreate: CreateCallRailIntegration_callRailIntegrationCreate | null;
}

export interface CreateCallRailIntegrationVariables {
  input: CallRailIntegrationCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateKixieIntegration
// ====================================================

export interface CreateKixieIntegration_kixieIntegrationCreate_kixieIntegration {
  __typename: "PhoneIntegration";
  /**
   * If the current user has enabled and set up credentials for this specific integration
   */
  isEnabledForUser: boolean;
}

export interface CreateKixieIntegration_kixieIntegrationCreate {
  __typename: "KixieIntegrationCreatePayload";
  /**
   * Newly created Kixie integration data
   */
  kixieIntegration: CreateKixieIntegration_kixieIntegrationCreate_kixieIntegration;
}

export interface CreateKixieIntegration {
  /**
   * Create a new instance-wide Kixie integration
   */
  kixieIntegrationCreate: CreateKixieIntegration_kixieIntegrationCreate | null;
}

export interface CreateKixieIntegrationVariables {
  input: KixieIntegrationCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteCallrailIntegrationUserSettings
// ====================================================

export interface DeleteCallrailIntegrationUserSettings_callRailIntegrationUserSettingsDelete_callRailIntegration {
  __typename: "PhoneIntegration";
  /**
   * If the current user has enabled and set up credentials for this specific integration
   */
  isEnabledForUser: boolean;
  /**
   * The type of integration
   */
  integrationType: ExternalServiceType;
}

export interface DeleteCallrailIntegrationUserSettings_callRailIntegrationUserSettingsDelete {
  __typename: "CallRailIntegrationUserSettingsDeletePayload";
  /**
   * Updated CallRail integration data
   */
  callRailIntegration: DeleteCallrailIntegrationUserSettings_callRailIntegrationUserSettingsDelete_callRailIntegration;
}

export interface DeleteCallrailIntegrationUserSettings {
  /**
   * Deletes the CallRail integration auth settings rows for the current user.
   * Removes their API key and other saved data from signup
   */
  callRailIntegrationUserSettingsDelete: DeleteCallrailIntegrationUserSettings_callRailIntegrationUserSettingsDelete;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DisableClickToCallIntegration
// ====================================================

export interface DisableClickToCallIntegration_disableClickToCallIntegration_clickToCallIntegration_defaultCallsActivityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
  /**
   * Whether this activity type is immutable
   */
  isImmutable: boolean;
}

export interface DisableClickToCallIntegration_disableClickToCallIntegration_clickToCallIntegration_defaultVoicemailsActivityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
  /**
   * Whether this activity type is immutable
   */
  isImmutable: boolean;
}

export interface DisableClickToCallIntegration_disableClickToCallIntegration_clickToCallIntegration {
  __typename: "ClickToCallIntegration";
  /**
   * The type of integration
   */
  integrationType: ExternalServiceType;
  /**
   * If the current user has a validated phone number and caller ID for ClickToCall
   */
  isEnabled: boolean;
  /**
   * The phone number the user has configured for ClickToCall
   */
  phoneNumber: string | null;
  /**
   * The caller ID the user has configured for ClickToCall
   */
  callerId: string | null;
  /**
   * The activity type that will be used when activities are created for click-to-call phone calls
   */
  defaultCallsActivityType: DisableClickToCallIntegration_disableClickToCallIntegration_clickToCallIntegration_defaultCallsActivityType | null;
  /**
   * The activity type that will be used when activities are created for click-to-call voicemails
   */
  defaultVoicemailsActivityType: DisableClickToCallIntegration_disableClickToCallIntegration_clickToCallIntegration_defaultVoicemailsActivityType | null;
}

export interface DisableClickToCallIntegration_disableClickToCallIntegration {
  __typename: "DisableClickToCallIntegrationPayload";
  /**
   * The details of the Click to Call integration for the user
   */
  clickToCallIntegration: DisableClickToCallIntegration_disableClickToCallIntegration_clickToCallIntegration | null;
}

export interface DisableClickToCallIntegration {
  /**
   * Disable the Click to Call integration for the user
   */
  disableClickToCallIntegration: DisableClickToCallIntegration_disableClickToCallIntegration;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetAircallIntegrationIsEnabledForInstance
// ====================================================

export interface SetAircallIntegrationIsEnabledForInstance_setAircallIntegrationIsEnabledForInstance {
  __typename: "SetAircallIntegrationIsEnabledForInstancePayload";
  /**
   * URL to direct the user to start the Aircall OAuth flow
   */
  authUrl: string | null;
}

export interface SetAircallIntegrationIsEnabledForInstance {
  /**
   * Enable or disable the Aircall integration for the instance
   */
  setAircallIntegrationIsEnabledForInstance: SetAircallIntegrationIsEnabledForInstance_setAircallIntegrationIsEnabledForInstance | null;
}

export interface SetAircallIntegrationIsEnabledForInstanceVariables {
  isEnabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetAircallIntegrationIsEnabledForUser
// ====================================================

export interface SetAircallIntegrationIsEnabledForUser_setAircallIntegrationIsEnabledForUser_integration {
  __typename: "PhoneIntegration";
  /**
   * If the current user has enabled and set up credentials for this specific integration
   */
  isEnabledForUser: boolean;
  /**
   * The type of integration
   */
  integrationType: ExternalServiceType;
  /**
   * Unique Identifier for the user in the external system
   */
  externalUserIdentifier: string | null;
  /**
   * Additional information about the integration
   */
  tertiaryInformation: string | null;
}

export interface SetAircallIntegrationIsEnabledForUser_setAircallIntegrationIsEnabledForUser {
  __typename: "SetAircallIntegrationIsEnabledForUserPayload";
  integration: SetAircallIntegrationIsEnabledForUser_setAircallIntegrationIsEnabledForUser_integration;
}

export interface SetAircallIntegrationIsEnabledForUser {
  /**
   * Enable or disable the instance-wide Aircall integration for the user
   */
  setAircallIntegrationIsEnabledForUser: SetAircallIntegrationIsEnabledForUser_setAircallIntegrationIsEnabledForUser | null;
}

export interface SetAircallIntegrationIsEnabledForUserVariables {
  isEnabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetCallRailIntegrationIsEnabled
// ====================================================

export interface SetCallRailIntegrationIsEnabled_setCallRailIntegrationIsEnabled_callRailIntegration {
  __typename: "PhoneIntegration";
  /**
   * If the current user has enabled and set up credentials for this specific integration
   */
  isEnabledForUser: boolean;
  /**
   * The type of integration
   */
  integrationType: ExternalServiceType;
}

export interface SetCallRailIntegrationIsEnabled_setCallRailIntegrationIsEnabled {
  __typename: "SetCallRailIntegrationIsEnabledPayload";
  /**
   * Updated CallRail integration data
   */
  callRailIntegration: SetCallRailIntegrationIsEnabled_setCallRailIntegrationIsEnabled_callRailIntegration;
}

export interface SetCallRailIntegrationIsEnabled {
  /**
   * Enable or disable the CallRail integrations table row
   */
  setCallRailIntegrationIsEnabled: SetCallRailIntegrationIsEnabled_setCallRailIntegrationIsEnabled | null;
}

export interface SetCallRailIntegrationIsEnabledVariables {
  input: SetCallRailIntegrationIsEnabledInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetDialpadIntegrationIsEnabled
// ====================================================

export interface SetDialpadIntegrationIsEnabled_setDialpadIntegrationIsEnabled {
  __typename: "SetDialpadIntegrationIsEnabledPayload";
  /**
   * URL so user can authenticate with Dialpad
   */
  authUrl: string | null;
}

export interface SetDialpadIntegrationIsEnabled {
  /**
   * Enable or disable the Dialpad integration
   */
  setDialpadIntegrationIsEnabled: SetDialpadIntegrationIsEnabled_setDialpadIntegrationIsEnabled | null;
}

export interface SetDialpadIntegrationIsEnabledVariables {
  isEnabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetKixieIntegrationIsEnabled
// ====================================================

export interface SetKixieIntegrationIsEnabled_setKixieIntegrationIsEnabled_kixieIntegration {
  __typename: "PhoneIntegration";
  /**
   * If the current user has enabled and set up credentials for this specific integration
   */
  isEnabledForUser: boolean;
}

export interface SetKixieIntegrationIsEnabled_setKixieIntegrationIsEnabled {
  __typename: "SetKixieIntegrationIsEnabledPayload";
  /**
   * Updated Kixie integration data
   */
  kixieIntegration: SetKixieIntegrationIsEnabled_setKixieIntegrationIsEnabled_kixieIntegration;
}

export interface SetKixieIntegrationIsEnabled {
  /**
   * Enable or disable the Kixie integration for a given user
   */
  setKixieIntegrationIsEnabled: SetKixieIntegrationIsEnabled_setKixieIntegrationIsEnabled | null;
}

export interface SetKixieIntegrationIsEnabledVariables {
  isEnabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetRingCentralIntegrationIsEnabled
// ====================================================

export interface SetRingCentralIntegrationIsEnabled_setRingCentralIntegrationIsEnabled {
  __typename: "SetRingCentralIntegrationIsEnabledPayload";
  /**
   * URL to direct the user to if we need to authenticate with an external service
   */
  authUrl: string | null;
}

export interface SetRingCentralIntegrationIsEnabled {
  /**
   * Enable or disable the RingCentral integration for a user
   */
  setRingCentralIntegrationIsEnabled: SetRingCentralIntegrationIsEnabled_setRingCentralIntegrationIsEnabled | null;
}

export interface SetRingCentralIntegrationIsEnabledVariables {
  isEnabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SyncPastCalls
// ====================================================

export interface SyncPastCalls_syncPastCalls_phoneIntegration_integration {
  __typename: "Integration";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Indicates whether the integration is currently enabled
   */
  isEnabled: boolean;
  /**
   * Indicates whether the integration has been validated
   */
  isValidated: boolean;
}

export interface SyncPastCalls_syncPastCalls_phoneIntegration_defaultCallsActivityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface SyncPastCalls_syncPastCalls_phoneIntegration_defaultVoicemailsActivityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface SyncPastCalls_syncPastCalls_phoneIntegration_phoneNumberAssignments_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SyncPastCalls_syncPastCalls_phoneIntegration_phoneNumberAssignments {
  __typename: "CallRailPhoneNumberAssignment";
  /**
   * The CallRail tracking phone number in E.164 format.
   */
  phoneNumber: string;
  /**
   * Display-formatted version of the tracking phone number.
   */
  formattedPhoneNumber: string;
  /**
   * The Nutshell user the phone number is assigned to. Null if the user has been deleted.
   */
  user: SyncPastCalls_syncPastCalls_phoneIntegration_phoneNumberAssignments_user | null;
}

export interface SyncPastCalls_syncPastCalls_phoneIntegration {
  __typename: "PhoneIntegration";
  /**
   * If the current user has enabled and set up credentials for this specific integration
   */
  isEnabledForUser: boolean;
  /**
   * The integration object for those types that have an instance-wide integration.
   * Null for user-specific phone integration types.
   */
  integration: SyncPastCalls_syncPastCalls_phoneIntegration_integration | null;
  /**
   * The type of integration
   */
  integrationType: ExternalServiceType;
  /**
   * Unique Identifier for the user in the external system
   */
  externalUserIdentifier: string | null;
  /**
   * Additional information about the integration
   */
  tertiaryInformation: string | null;
  /**
   * The default activity type for calls from this integration
   */
  defaultCallsActivityType: SyncPastCalls_syncPastCalls_phoneIntegration_defaultCallsActivityType;
  /**
   * The default activity type for voicemails from this integration
   */
  defaultVoicemailsActivityType: SyncPastCalls_syncPastCalls_phoneIntegration_defaultVoicemailsActivityType;
  /**
   * True if the current user can sync previous calls for this integration
   */
  canSyncPreviousCalls: boolean;
  /**
   * True if the current user is performing an initial sync for this integration
   */
  isPerformingInitialSync: boolean;
  /**
   * CallRail-specific. Map of tracking phone numbers to the Nutshell users they
   * are assigned to. Empty for other integration types.
   */
  phoneNumberAssignments: SyncPastCalls_syncPastCalls_phoneIntegration_phoneNumberAssignments[];
}

export interface SyncPastCalls_syncPastCalls {
  __typename: "SyncPastCallsPayload";
  /**
   * The phone integration that was synced
   */
  phoneIntegration: SyncPastCalls_syncPastCalls_phoneIntegration;
}

export interface SyncPastCalls {
  /**
   * Triggers the Gearman job to sync previous calls from a phone integration.
   */
  syncPastCalls: SyncPastCalls_syncPastCalls | null;
}

export interface SyncPastCallsVariables {
  input: SyncPastCallsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UnassignCallRailPhoneNumber
// ====================================================

export interface UnassignCallRailPhoneNumber_callRailIntegrationUnassignPhoneNumber_callRailIntegration_phoneNumberAssignments_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UnassignCallRailPhoneNumber_callRailIntegrationUnassignPhoneNumber_callRailIntegration_phoneNumberAssignments {
  __typename: "CallRailPhoneNumberAssignment";
  /**
   * The CallRail tracking phone number in E.164 format.
   */
  phoneNumber: string;
  /**
   * Display-formatted version of the tracking phone number.
   */
  formattedPhoneNumber: string;
  /**
   * The Nutshell user the phone number is assigned to. Null if the user has been deleted.
   */
  user: UnassignCallRailPhoneNumber_callRailIntegrationUnassignPhoneNumber_callRailIntegration_phoneNumberAssignments_user | null;
}

export interface UnassignCallRailPhoneNumber_callRailIntegrationUnassignPhoneNumber_callRailIntegration {
  __typename: "PhoneIntegration";
  /**
   * The type of integration
   */
  integrationType: ExternalServiceType;
  /**
   * CallRail-specific. Map of tracking phone numbers to the Nutshell users they
   * are assigned to. Empty for other integration types.
   */
  phoneNumberAssignments: UnassignCallRailPhoneNumber_callRailIntegrationUnassignPhoneNumber_callRailIntegration_phoneNumberAssignments[];
  /**
   * Unique Identifier for the user in the external system
   */
  externalUserIdentifier: string | null;
  /**
   * Additional information about the integration
   */
  tertiaryInformation: string | null;
}

export interface UnassignCallRailPhoneNumber_callRailIntegrationUnassignPhoneNumber {
  __typename: "CallRailIntegrationUnassignPhoneNumberPayload";
  /**
   * Updated CallRail integration data
   */
  callRailIntegration: UnassignCallRailPhoneNumber_callRailIntegrationUnassignPhoneNumber_callRailIntegration;
}

export interface UnassignCallRailPhoneNumber {
  /**
   * Remove a CallRail tracking phone number assignment.
   */
  callRailIntegrationUnassignPhoneNumber: UnassignCallRailPhoneNumber_callRailIntegrationUnassignPhoneNumber | null;
}

export interface UnassignCallRailPhoneNumberVariables {
  input: CallRailIntegrationUnassignPhoneNumberInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateCallRailIntegration
// ====================================================

export interface UpdateCallRailIntegration_callRailIntegrationUpdate_callRailIntegration {
  __typename: "PhoneIntegration";
  /**
   * If the current user has enabled and set up credentials for this specific integration
   */
  isEnabledForUser: boolean;
}

export interface UpdateCallRailIntegration_callRailIntegrationUpdate {
  __typename: "CallRailIntegrationUpdatePayload";
  /**
   * Updated CallRail integration data
   */
  callRailIntegration: UpdateCallRailIntegration_callRailIntegrationUpdate_callRailIntegration;
}

export interface UpdateCallRailIntegration {
  /**
   * Update a CallRail integration
   */
  callRailIntegrationUpdate: UpdateCallRailIntegration_callRailIntegrationUpdate | null;
}

export interface UpdateCallRailIntegrationVariables {
  input: CallRailIntegrationUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCallRailTrackingNumbers
// ====================================================

export interface GetCallRailTrackingNumbers_phoneIntegration_availableTrackingNumbers {
  __typename: "CallRailTrackingNumber";
  /**
   * The CallRail tracking phone number in E.164 format. Use this when sending the number to a mutation.
   */
  phoneNumber: string;
  /**
   * Display-formatted version of the tracking phone number, suitable for showing to users.
   */
  formattedPhoneNumber: string;
}

export interface GetCallRailTrackingNumbers_phoneIntegration_phoneNumberAssignments_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetCallRailTrackingNumbers_phoneIntegration_phoneNumberAssignments {
  __typename: "CallRailPhoneNumberAssignment";
  /**
   * The CallRail tracking phone number in E.164 format.
   */
  phoneNumber: string;
  /**
   * Display-formatted version of the tracking phone number.
   */
  formattedPhoneNumber: string;
  /**
   * The Nutshell user the phone number is assigned to. Null if the user has been deleted.
   */
  user: GetCallRailTrackingNumbers_phoneIntegration_phoneNumberAssignments_user | null;
}

export interface GetCallRailTrackingNumbers_phoneIntegration {
  __typename: "PhoneIntegration";
  /**
   * The type of integration
   */
  integrationType: ExternalServiceType;
  /**
   * CallRail-specific. Tracker phone numbers known to CallRail for the configured
   * company, used to populate the assignment picker. Empty for other integration types.
   */
  availableTrackingNumbers: GetCallRailTrackingNumbers_phoneIntegration_availableTrackingNumbers[];
  /**
   * CallRail-specific. Map of tracking phone numbers to the Nutshell users they
   * are assigned to. Empty for other integration types.
   */
  phoneNumberAssignments: GetCallRailTrackingNumbers_phoneIntegration_phoneNumberAssignments[];
}

export interface GetCallRailTrackingNumbers {
  /**
   * The details of a specific phone integration for a user
   */
  phoneIntegration: GetCallRailTrackingNumbers_phoneIntegration;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRingCentralSmsInbox
// ====================================================

export interface GetRingCentralSmsInbox_ringCentralSmsInbox_endpoint_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetRingCentralSmsInbox_ringCentralSmsInbox_endpoint_sourceChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
}

export interface GetRingCentralSmsInbox_ringCentralSmsInbox_endpoint {
  __typename: "RingCentralSmsInboxEndpoint";
  /**
   * The connected RingCentral owner, or null if that user no longer exists.
   */
  owner: GetRingCentralSmsInbox_ringCentralSmsInbox_endpoint_owner | null;
  extensionNumber: string | null;
  phoneNumber: string;
  /**
   * The RingCentral source channel, or null if the stored channel no longer exists.
   */
  sourceChannel: GetRingCentralSmsInbox_ringCentralSmsInbox_endpoint_sourceChannel | null;
}

export interface GetRingCentralSmsInbox_ringCentralSmsInbox {
  __typename: "RingCentralSmsInbox";
  isConnected: boolean;
  hasRequiredScopes: boolean;
  /**
   * Numbers previously discovered for the current user. The selected number is validated live when saved.
   */
  availablePhoneNumbers: string[];
  endpoint: GetRingCentralSmsInbox_ringCentralSmsInbox_endpoint | null;
}

export interface GetRingCentralSmsInbox {
  ringCentralSmsInbox: GetRingCentralSmsInbox_ringCentralSmsInbox | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateProduct
// ====================================================

export interface CreateProduct_productCreate_product_category {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
  /**
   * The time the product category was created
   */
  createdTime: any;
  /**
   * The number of products associated with this category
   */
  numAssociatedProducts: number;
  /**
   * The link to the report for this product category
   */
  reportLink: string;
}

export interface CreateProduct_productCreate_product_markets_edges_node {
  __typename: "Market";
  id: string;
  name: string;
  currency: string;
  currencySymbol: string;
  isDefault: boolean;
}

export interface CreateProduct_productCreate_product_markets_edges_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface CreateProduct_productCreate_product_markets_edges {
  __typename: "ProductMarketsEdge";
  node: CreateProduct_productCreate_product_markets_edges_node;
  /**
   * The price and currency of the product in the market.
   */
  price: CreateProduct_productCreate_product_markets_edges_price | null;
  /**
   * Whether the product is available in the market.
   */
  isAvailable: boolean | null;
}

export interface CreateProduct_productCreate_product_markets {
  __typename: "ProductMarketsConnection";
  /**
   * A list of edges.
   */
  edges: CreateProduct_productCreate_product_markets_edges[];
}

export interface CreateProduct_productCreate_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The description of the product
   */
  description: string | null;
  /**
   * The DateTime the product was created
   */
  createdTime: any;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The category of the product
   */
  category: CreateProduct_productCreate_product_category | null;
  /**
   * The type of the product (Good or Service)
   */
  type: ProductType;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The DateTime the product was last used
   */
  lastUsedTime: any | null;
  /**
   * The markets of the product
   */
  markets: CreateProduct_productCreate_product_markets;
}

export interface CreateProduct_productCreate {
  __typename: "ProductCreatePayload";
  /**
   * Whether the product has been successfully deleted
   */
  product: CreateProduct_productCreate_product;
}

export interface CreateProduct {
  /**
   * Creates or updates a product based on input
   */
  productCreate: CreateProduct_productCreate;
}

export interface CreateProductVariables {
  input: ProductCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateProductsCsv
// ====================================================

export interface CreateProductsCsv_productsExport {
  __typename: "ProductsExportPayload";
  /**
   * The URL to download the CSV file
   */
  url: string;
}

export interface CreateProductsCsv {
  /**
   * Export products to a CSV file and return a URL to download it
   */
  productsExport: CreateProductsCsv_productsExport;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteProduct
// ====================================================

export interface DeleteProduct_productDelete_product_category {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
  /**
   * The time the product category was created
   */
  createdTime: any;
  /**
   * The number of products associated with this category
   */
  numAssociatedProducts: number;
  /**
   * The link to the report for this product category
   */
  reportLink: string;
}

export interface DeleteProduct_productDelete_product_markets_edges_node {
  __typename: "Market";
  id: string;
  name: string;
  currency: string;
  currencySymbol: string;
  isDefault: boolean;
}

export interface DeleteProduct_productDelete_product_markets_edges_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface DeleteProduct_productDelete_product_markets_edges {
  __typename: "ProductMarketsEdge";
  node: DeleteProduct_productDelete_product_markets_edges_node;
  /**
   * The price and currency of the product in the market.
   */
  price: DeleteProduct_productDelete_product_markets_edges_price | null;
  /**
   * Whether the product is available in the market.
   */
  isAvailable: boolean | null;
}

export interface DeleteProduct_productDelete_product_markets {
  __typename: "ProductMarketsConnection";
  /**
   * A list of edges.
   */
  edges: DeleteProduct_productDelete_product_markets_edges[];
}

export interface DeleteProduct_productDelete_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The description of the product
   */
  description: string | null;
  /**
   * The DateTime the product was created
   */
  createdTime: any;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The category of the product
   */
  category: DeleteProduct_productDelete_product_category | null;
  /**
   * The type of the product (Good or Service)
   */
  type: ProductType;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The DateTime the product was last used
   */
  lastUsedTime: any | null;
  /**
   * The markets of the product
   */
  markets: DeleteProduct_productDelete_product_markets;
}

export interface DeleteProduct_productDelete {
  __typename: "ProductDeletePayload";
  /**
   * The product that has been successfully deleted
   */
  product: DeleteProduct_productDelete_product;
}

export interface DeleteProduct {
  /**
   * Delete a product
   */
  productDelete: DeleteProduct_productDelete;
}

export interface DeleteProductVariables {
  input: ProductDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SyncProductsToQuickbooks
// ====================================================

export interface SyncProductsToQuickbooks_quickbooksSyncProducts {
  __typename: "QuickbooksSyncProductsPayload";
  /**
   * Whether the product sync completed in this request or will continue in the background
   */
  executionMode: QuickbooksSyncProductsExecutionMode;
  /**
   * The number of active products considered
   */
  totalCount: number;
  /**
   * The number of new products created in QuickBooks
   */
  successCount: number;
  /**
   * The number of products ignored because they already exist in QuickBooks
   */
  skippedCount: number;
  /**
   * The number of products that failed to sync
   */
  failureCount: number;
  /**
   * URL to view products/services in the connected QuickBooks company
   */
  quickbooksProductsUrl: string;
}

export interface SyncProductsToQuickbooks {
  /**
   * Sends new active Nutshell products to QuickBooks. Existing matches are ignored.
   */
  quickbooksSyncProducts: SyncProductsToQuickbooks_quickbooksSyncProducts;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UndeleteProduct
// ====================================================

export interface UndeleteProduct_productUndelete_product_category {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
  /**
   * The time the product category was created
   */
  createdTime: any;
  /**
   * The number of products associated with this category
   */
  numAssociatedProducts: number;
  /**
   * The link to the report for this product category
   */
  reportLink: string;
}

export interface UndeleteProduct_productUndelete_product_markets_edges_node {
  __typename: "Market";
  id: string;
  name: string;
  currency: string;
  currencySymbol: string;
  isDefault: boolean;
}

export interface UndeleteProduct_productUndelete_product_markets_edges_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UndeleteProduct_productUndelete_product_markets_edges {
  __typename: "ProductMarketsEdge";
  node: UndeleteProduct_productUndelete_product_markets_edges_node;
  /**
   * The price and currency of the product in the market.
   */
  price: UndeleteProduct_productUndelete_product_markets_edges_price | null;
  /**
   * Whether the product is available in the market.
   */
  isAvailable: boolean | null;
}

export interface UndeleteProduct_productUndelete_product_markets {
  __typename: "ProductMarketsConnection";
  /**
   * A list of edges.
   */
  edges: UndeleteProduct_productUndelete_product_markets_edges[];
}

export interface UndeleteProduct_productUndelete_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The description of the product
   */
  description: string | null;
  /**
   * The DateTime the product was created
   */
  createdTime: any;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The category of the product
   */
  category: UndeleteProduct_productUndelete_product_category | null;
  /**
   * The type of the product (Good or Service)
   */
  type: ProductType;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The DateTime the product was last used
   */
  lastUsedTime: any | null;
  /**
   * The markets of the product
   */
  markets: UndeleteProduct_productUndelete_product_markets;
}

export interface UndeleteProduct_productUndelete {
  __typename: "ProductUndeletePayload";
  /**
   * The product that has been successfully undeleted
   */
  product: UndeleteProduct_productUndelete_product;
}

export interface UndeleteProduct {
  /**
   * Undelete a product
   */
  productUndelete: UndeleteProduct_productUndelete;
}

export interface UndeleteProductVariables {
  input: ProductUndeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateProduct
// ====================================================

export interface UpdateProduct_productUpdate_product_category {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
  /**
   * The time the product category was created
   */
  createdTime: any;
  /**
   * The number of products associated with this category
   */
  numAssociatedProducts: number;
  /**
   * The link to the report for this product category
   */
  reportLink: string;
}

export interface UpdateProduct_productUpdate_product_markets_edges_node {
  __typename: "Market";
  id: string;
  name: string;
  currency: string;
  currencySymbol: string;
  isDefault: boolean;
}

export interface UpdateProduct_productUpdate_product_markets_edges_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface UpdateProduct_productUpdate_product_markets_edges {
  __typename: "ProductMarketsEdge";
  node: UpdateProduct_productUpdate_product_markets_edges_node;
  /**
   * The price and currency of the product in the market.
   */
  price: UpdateProduct_productUpdate_product_markets_edges_price | null;
  /**
   * Whether the product is available in the market.
   */
  isAvailable: boolean | null;
}

export interface UpdateProduct_productUpdate_product_markets {
  __typename: "ProductMarketsConnection";
  /**
   * A list of edges.
   */
  edges: UpdateProduct_productUpdate_product_markets_edges[];
}

export interface UpdateProduct_productUpdate_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The description of the product
   */
  description: string | null;
  /**
   * The DateTime the product was created
   */
  createdTime: any;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The category of the product
   */
  category: UpdateProduct_productUpdate_product_category | null;
  /**
   * The type of the product (Good or Service)
   */
  type: ProductType;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The DateTime the product was last used
   */
  lastUsedTime: any | null;
  /**
   * The markets of the product
   */
  markets: UpdateProduct_productUpdate_product_markets;
}

export interface UpdateProduct_productUpdate {
  __typename: "ProductUpdatePayload";
  /**
   * Whether the product has been successfully deleted
   */
  product: UpdateProduct_productUpdate_product;
}

export interface UpdateProduct {
  /**
   * Updates an existing product. Only market data that is explicitly provided will be updated.
   */
  productUpdate: UpdateProduct_productUpdate;
}

export interface UpdateProductVariables {
  input: ProductUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetProducts
// ====================================================

export interface GetProducts_products_edges_node_category {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
  /**
   * The time the product category was created
   */
  createdTime: any;
  /**
   * The number of products associated with this category
   */
  numAssociatedProducts: number;
  /**
   * The link to the report for this product category
   */
  reportLink: string;
}

export interface GetProducts_products_edges_node_markets_edges_node {
  __typename: "Market";
  id: string;
  name: string;
  currency: string;
  currencySymbol: string;
  isDefault: boolean;
}

export interface GetProducts_products_edges_node_markets_edges_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetProducts_products_edges_node_markets_edges {
  __typename: "ProductMarketsEdge";
  node: GetProducts_products_edges_node_markets_edges_node;
  /**
   * The price and currency of the product in the market.
   */
  price: GetProducts_products_edges_node_markets_edges_price | null;
  /**
   * Whether the product is available in the market.
   */
  isAvailable: boolean | null;
}

export interface GetProducts_products_edges_node_markets {
  __typename: "ProductMarketsConnection";
  /**
   * A list of edges.
   */
  edges: GetProducts_products_edges_node_markets_edges[];
}

export interface GetProducts_products_edges_node {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The description of the product
   */
  description: string | null;
  /**
   * The DateTime the product was created
   */
  createdTime: any;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The category of the product
   */
  category: GetProducts_products_edges_node_category | null;
  /**
   * The type of the product (Good or Service)
   */
  type: ProductType;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The DateTime the product was last used
   */
  lastUsedTime: any | null;
  /**
   * The markets of the product
   */
  markets: GetProducts_products_edges_node_markets;
  /**
   * The DateTime this product was last successfully linked or synced to QuickBooks
   */
  quickbooksSyncedTime: any | null;
}

export interface GetProducts_products_edges {
  __typename: "ProductsEdge";
  node: GetProducts_products_edges_node;
}

export interface GetProducts_products_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetProducts_products {
  __typename: "ProductsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetProducts_products_edges[];
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetProducts_products_pageInfo;
}

export interface GetProducts {
  /**
   * Returns a paging connection of products from the root of our query.
   */
  products: GetProducts_products | null;
}

export interface GetProductsVariables {
  first?: number | null;
  after?: string | null;
  last?: number | null;
  before?: string | null;
  offset?: number | null;
  categoryId?: string | null;
  archived?: boolean | null;
  includeQuickbooksSyncedTime?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetFilteredInvoices
// ====================================================

export interface GetFilteredInvoices_invoices_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetFilteredInvoices_invoices_edges_node_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetFilteredInvoices_invoices_edges_node_lead_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetFilteredInvoices_invoices_edges_node_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetFilteredInvoices_invoices_edges_node_lead_assignee | null;
}

export interface GetFilteredInvoices_invoices_edges_node {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The status of a quote that should be displayed to the user
   */
  displayStatus: QuoteDisplayStatus;
  /**
   * The slug of the quote
   */
  slug: string;
  /**
   * The string log of the last status update
   */
  statusLog: string;
  /**
   * The sharable view in browser link
   */
  shareableViewInBrowserLink: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The date the quote is valid until
   */
  validUntilDateFormatted: string;
  /**
   * The time the quote was sent
   */
  sentTime: any | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was published
   */
  publishedTime: any | null;
  /**
   * The time the quote was accepted
   */
  acceptedTime: any | null;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetFilteredInvoices_invoices_edges_node_total;
  /**
   * The user that created the quote
   */
  creatorUser: GetFilteredInvoices_invoices_edges_node_creatorUser | null;
  /**
   * The lead the quote is associated with
   */
  lead: GetFilteredInvoices_invoices_edges_node_lead;
  /**
   * A human readable string representing how long over due the invoice is
   */
  overdueDuration: string | null;
  /**
   * Whether the SalesDocument has been viewed
   */
  hasBeenViewed: boolean;
  /**
   * URL to view this invoice in QuickBooks, or null if it has not been sent to QuickBooks
   */
  quickbooksInvoiceUrl: string | null;
}

export interface GetFilteredInvoices_invoices_edges {
  __typename: "InvoiceEdge";
  node: GetFilteredInvoices_invoices_edges_node;
}

export interface GetFilteredInvoices_invoices_pageInfo {
  __typename: "PageInfo";
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor: string | null;
  endCursor: string | null;
}

export interface GetFilteredInvoices_invoices {
  __typename: "InvoicesConnection";
  /**
   * A list of edges.
   */
  edges: GetFilteredInvoices_invoices_edges[];
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetFilteredInvoices_invoices_pageInfo;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetFilteredInvoices {
  /**
   * Returns a list of invoices for the manage invoices page
   */
  invoices: GetFilteredInvoices_invoices;
}

export interface GetFilteredInvoicesVariables {
  input: InvoicesSearchInput;
  includeQuickbooks: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: QuoteUpdateAcceptanceOption
// ====================================================

export interface QuoteUpdateAcceptanceOption_quoteUpdateAcceptanceOption_quote_templateAttachedContract {
  __typename: "ContractTemplate";
  id: string;
  name: string;
  htmlUrlPath: string;
}

export interface QuoteUpdateAcceptanceOption_quoteUpdateAcceptanceOption_quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The option chosen for how end-users will accept the quote
   */
  acceptanceMode: QuoteAcceptanceOption;
  /**
   * The contract template attached to this quote template
   */
  templateAttachedContract: QuoteUpdateAcceptanceOption_quoteUpdateAcceptanceOption_quote_templateAttachedContract | null;
}

export interface QuoteUpdateAcceptanceOption_quoteUpdateAcceptanceOption {
  __typename: "QuoteUpdateAcceptanceOptionPayload";
  quote: QuoteUpdateAcceptanceOption_quoteUpdateAcceptanceOption_quote;
}

export interface QuoteUpdateAcceptanceOption {
  /**
   * Updates the acceptance option of a quote template.
   */
  quoteUpdateAcceptanceOption: QuoteUpdateAcceptanceOption_quoteUpdateAcceptanceOption;
}

export interface QuoteUpdateAcceptanceOptionVariables {
  input: QuoteUpdateAcceptanceOptionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetFilteredQuotes
// ====================================================

export interface GetFilteredQuotes_quotes_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetFilteredQuotes_quotes_edges_node_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetFilteredQuotes_quotes_edges_node_lead_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetFilteredQuotes_quotes_edges_node_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetFilteredQuotes_quotes_edges_node_lead_assignee | null;
}

export interface GetFilteredQuotes_quotes_edges_node {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The status of a quote that should be displayed to the user
   */
  displayStatus: QuoteDisplayStatus;
  /**
   * The slug of the quote
   */
  slug: string;
  /**
   * The string log of the last status update
   */
  statusLog: string;
  /**
   * The sharable view in browser link
   */
  shareableViewInBrowserLink: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The date the quote is valid until
   */
  validUntilDateFormatted: string;
  /**
   * The time the quote was sent
   */
  sentTime: any | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was published
   */
  publishedTime: any | null;
  /**
   * The time the quote was accepted
   */
  acceptedTime: any | null;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetFilteredQuotes_quotes_edges_node_total;
  /**
   * The user that created the quote
   */
  creatorUser: GetFilteredQuotes_quotes_edges_node_creatorUser | null;
  /**
   * The lead the quote is associated with
   */
  lead: GetFilteredQuotes_quotes_edges_node_lead;
  /**
   * Whether the SalesDocument has been viewed
   */
  hasBeenViewed: boolean;
}

export interface GetFilteredQuotes_quotes_edges {
  __typename: "QuoteEdge";
  node: GetFilteredQuotes_quotes_edges_node;
}

export interface GetFilteredQuotes_quotes_pageInfo {
  __typename: "PageInfo";
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor: string | null;
  endCursor: string | null;
}

export interface GetFilteredQuotes_quotes {
  __typename: "QuotesConnection";
  /**
   * A list of edges.
   */
  edges: GetFilteredQuotes_quotes_edges[];
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetFilteredQuotes_quotes_pageInfo;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetFilteredQuotes {
  /**
   * Returns a list of quotes for the manage quotes page
   */
  quotes: GetFilteredQuotes_quotes;
}

export interface GetFilteredQuotesVariables {
  input: QuotesSearchInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateScheduledReport
// ====================================================

export interface CreateScheduledReport_scheduledReportCreate_scheduledReport_savedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
}

export interface CreateScheduledReport_scheduledReportCreate_scheduledReport_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  htmlUrlPath: string | null;
}

export interface CreateScheduledReport_scheduledReportCreate_scheduledReport {
  __typename: "ScheduledReport";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  description: string | null;
  recurrenceRule: string;
  recipients: string[];
  isPaused: boolean;
  sourceType: ScheduledReportSourceType;
  lastRunTime: any | null;
  /**
   * Null when paused or when no upcoming occurrence can be calculated.
   */
  nextRunTime: any | null;
  savedFilter: CreateScheduledReport_scheduledReportCreate_scheduledReport_savedFilter | null;
  user: CreateScheduledReport_scheduledReportCreate_scheduledReport_user | null;
}

export interface CreateScheduledReport_scheduledReportCreate {
  __typename: "ScheduledReportCreatePayload";
  scheduledReport: CreateScheduledReport_scheduledReportCreate_scheduledReport;
}

export interface CreateScheduledReport {
  /**
   * Creates a scheduled report for a saved list or report
   */
  scheduledReportCreate: CreateScheduledReport_scheduledReportCreate;
}

export interface CreateScheduledReportVariables {
  input: ScheduledReportCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteScheduledReport
// ====================================================

export interface DeleteScheduledReport_scheduledReportDelete_scheduledReport {
  __typename: "ScheduledReport";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteScheduledReport_scheduledReportDelete {
  __typename: "ScheduledReportDeletePayload";
  /**
   * The deleted scheduled report
   */
  scheduledReport: DeleteScheduledReport_scheduledReportDelete_scheduledReport;
}

export interface DeleteScheduledReport {
  /**
   * Soft deletes a scheduled report
   */
  scheduledReportDelete: DeleteScheduledReport_scheduledReportDelete;
}

export interface DeleteScheduledReportVariables {
  input: ScheduledReportDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetScheduledReportIsPaused
// ====================================================

export interface SetScheduledReportIsPaused_scheduledReportSetIsPaused_scheduledReport {
  __typename: "ScheduledReport";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  isPaused: boolean;
  /**
   * Null when paused or when no upcoming occurrence can be calculated.
   */
  nextRunTime: any | null;
}

export interface SetScheduledReportIsPaused_scheduledReportSetIsPaused {
  __typename: "ScheduledReportSetIsPausedPayload";
  /**
   * The scheduled report that was updated
   */
  scheduledReport: SetScheduledReportIsPaused_scheduledReportSetIsPaused_scheduledReport;
}

export interface SetScheduledReportIsPaused {
  /**
   * Pauses or resumes a scheduled report. A paused report will not run on its schedule until it is resumed.
   */
  scheduledReportSetIsPaused: SetScheduledReportIsPaused_scheduledReportSetIsPaused;
}

export interface SetScheduledReportIsPausedVariables {
  input: ScheduledReportSetIsPausedInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateScheduledReport
// ====================================================

export interface UpdateScheduledReport_scheduledReportUpdate_scheduledReport_savedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
}

export interface UpdateScheduledReport_scheduledReportUpdate_scheduledReport_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  htmlUrlPath: string | null;
}

export interface UpdateScheduledReport_scheduledReportUpdate_scheduledReport {
  __typename: "ScheduledReport";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  description: string | null;
  recurrenceRule: string;
  recipients: string[];
  isPaused: boolean;
  sourceType: ScheduledReportSourceType;
  lastRunTime: any | null;
  /**
   * Null when paused or when no upcoming occurrence can be calculated.
   */
  nextRunTime: any | null;
  savedFilter: UpdateScheduledReport_scheduledReportUpdate_scheduledReport_savedFilter | null;
  user: UpdateScheduledReport_scheduledReportUpdate_scheduledReport_user | null;
}

export interface UpdateScheduledReport_scheduledReportUpdate {
  __typename: "ScheduledReportUpdatePayload";
  scheduledReport: UpdateScheduledReport_scheduledReportUpdate_scheduledReport;
}

export interface UpdateScheduledReport {
  /**
   * Updates a scheduled report
   */
  scheduledReportUpdate: UpdateScheduledReport_scheduledReportUpdate;
}

export interface UpdateScheduledReportVariables {
  input: ScheduledReportUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetScheduledReports
// ====================================================

export interface GetScheduledReports_scheduledReports_savedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
}

export interface GetScheduledReports_scheduledReports_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  htmlUrlPath: string | null;
}

export interface GetScheduledReports_scheduledReports {
  __typename: "ScheduledReport";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  description: string | null;
  recurrenceRule: string;
  recipients: string[];
  isPaused: boolean;
  sourceType: ScheduledReportSourceType;
  lastRunTime: any | null;
  /**
   * Null when paused or when no upcoming occurrence can be calculated.
   */
  nextRunTime: any | null;
  savedFilter: GetScheduledReports_scheduledReports_savedFilter | null;
  user: GetScheduledReports_scheduledReports_user | null;
}

export interface GetScheduledReports {
  scheduledReports: GetScheduledReports_scheduledReports[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: InitiateSsoSetup
// ====================================================

export interface InitiateSsoSetup_initiateSsoSetup {
  __typename: "InitiateSsoSetupPayload";
  /**
   * The redirect url.
   */
  redirectUrl: string;
}

export interface InitiateSsoSetup {
  /**
   * Initiate SSO setup
   */
  initiateSsoSetup: InitiateSsoSetup_initiateSsoSetup | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: QueueDirectorySync
// ====================================================

export interface QueueDirectorySync_queueDirectorySync {
  __typename: "QueueDirectorySyncPayload";
  /**
   * Whether the directory sync was successfully queued.
   */
  success: boolean;
}

export interface QueueDirectorySync {
  /**
   * Initiate a full directory sync sync based on the current cursor
   */
  queueDirectorySync: QueueDirectorySync_queueDirectorySync | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RefreshWorkOsDomainAdminPortal
// ====================================================

export interface RefreshWorkOsDomainAdminPortal_refreshWorkOsDomainAdminPortal {
  __typename: "RefreshWorkOsDomainAdminPortalPayload";
  /**
   * The freshly-minted admin portal URL, or null if the instance is not configured for WorkOS.
   */
  url: string | null;
}

export interface RefreshWorkOsDomainAdminPortal {
  /**
   * Mint a fresh WorkOS admin portal link for the domain verification intent. Used
   * to recover from stale tokens — WorkOS portal links expire after 5 minutes.
   */
  refreshWorkOsDomainAdminPortal: RefreshWorkOsDomainAdminPortal_refreshWorkOsDomainAdminPortal | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TeardownDirectorySyncForInstance
// ====================================================

export interface TeardownDirectorySyncForInstance_teardownDirectorySyncForInstance {
  __typename: "TeardownDirectorySyncForInstancePayload";
  /**
   * Whether the mutation was successful.
   */
  success: boolean;
}

export interface TeardownDirectorySyncForInstance {
  /**
   * Teardown Directory Sync settings
   */
  teardownDirectorySyncForInstance: TeardownDirectorySyncForInstance_teardownDirectorySyncForInstance | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TeardownSsoForInstance
// ====================================================

export interface TeardownSsoForInstance_teardownSsoForInstance {
  __typename: "TeardownSsoForInstancePayload";
  /**
   * Whether SSO was torn down successfully for this instance.
   */
  success: boolean;
}

export interface TeardownSsoForInstance {
  /**
   * Delete SSO organization from WorkOs
   */
  teardownSsoForInstance: TeardownSsoForInstance_teardownSsoForInstance | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateDirectorySyncSettings
// ====================================================

export interface UpdateDirectorySyncSettings_updateDirectorySyncSettings_directorySync_defaultRole {
  __typename: "Role";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this role
   */
  name: string;
}

export interface UpdateDirectorySyncSettings_updateDirectorySyncSettings_directorySync {
  __typename: "DirectorySync";
  /**
   * Whether directory sync is configured for the instance
   */
  isConfigured: boolean;
  /**
   * The default role for all new users added from this Active Directory
   */
  defaultRole: UpdateDirectorySyncSettings_updateDirectorySyncSettings_directorySync_defaultRole | null;
}

export interface UpdateDirectorySyncSettings_updateDirectorySyncSettings {
  __typename: "UpdateDirectorySyncSettingsPayload";
  /**
   * The Directory Sync settings that were updated.
   */
  directorySync: UpdateDirectorySyncSettings_updateDirectorySyncSettings_directorySync;
}

export interface UpdateDirectorySyncSettings {
  /**
   * Update Directory Sync settings
   */
  updateDirectorySyncSettings: UpdateDirectorySyncSettings_updateDirectorySyncSettings | null;
}

export interface UpdateDirectorySyncSettingsVariables {
  input: UpdateDirectorySyncSettingsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateSecuritySettings
// ====================================================

export interface UpdateSecuritySettings_securityUpdateSettings {
  __typename: "SecurityUpdateSettingsPayload";
  /**
   * Whether the security settings were updated successfully.
   */
  success: boolean;
}

export interface UpdateSecuritySettings {
  /**
   * Update instance security settings.
   */
  securityUpdateSettings: UpdateSecuritySettings_securityUpdateSettings;
}

export interface UpdateSecuritySettingsVariables {
  input: SecurityUpdateSettingsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateSsoSettings
// ====================================================

export interface UpdateSsoSettings_updateSsoSettings_sso {
  __typename: "Sso";
  /**
   * Whether SSO is configured for the instance
   */
  isConfigured: boolean;
  /**
   * Whether SSO is required for the instance
   */
  isRequired: boolean;
}

export interface UpdateSsoSettings_updateSsoSettings {
  __typename: "UpdateSsoSettingsPayload";
  /**
   * The SSO settings that were updated.
   */
  sso: UpdateSsoSettings_updateSsoSettings_sso;
}

export interface UpdateSsoSettings {
  /**
   * Update SSO settings
   */
  updateSsoSettings: UpdateSsoSettings_updateSsoSettings | null;
}

export interface UpdateSsoSettingsVariables {
  input: UpdateSsoSettingsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWorkOsInformation
// ====================================================

export interface GetWorkOsInformation_workOs_domainInfo_domains {
  __typename: "OrganizationDomain";
  /**
   * The domain
   */
  domain: string;
  /**
   * Whether the domain is verified
   */
  isVerified: boolean;
  /**
   * Whether the domain is pinned
   */
  isMarkedAsPinned: boolean;
}

export interface GetWorkOsInformation_workOs_domainInfo {
  __typename: "DomainInfo";
  /**
   * The domains for the organization
   */
  domains: GetWorkOsInformation_workOs_domainInfo_domains[];
  /**
   * The admin portal for the organization
   */
  adminPortal: string | null;
}

export interface GetWorkOsInformation_workOs_sso_exemptUsers {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetWorkOsInformation_workOs_sso_nonExemptUsers {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetWorkOsInformation_workOs_sso {
  __typename: "Sso";
  /**
   * Whether the instance is allowed to setup SSO
   */
  canSetup: boolean;
  /**
   * Whether SSO is configured for the instance
   */
  isConfigured: boolean;
  /**
   * Whether SSO is required for the instance
   */
  isRequired: boolean;
  /**
   * The URL to the WorkOS admin portal
   */
  adminPortal: string | null;
  /**
   * The list of users exempt from SSO
   */
  exemptUsers: (GetWorkOsInformation_workOs_sso_exemptUsers | null)[] | null;
  /**
   * The list of users required to use SSO
   */
  nonExemptUsers: (GetWorkOsInformation_workOs_sso_nonExemptUsers | null)[] | null;
}

export interface GetWorkOsInformation_workOs_directorySync_defaultRole {
  __typename: "Role";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this role
   */
  name: string;
}

export interface GetWorkOsInformation_workOs_directorySync {
  __typename: "DirectorySync";
  /**
   * Whether the instance is allowed to setup Directory Sync
   */
  canSetup: boolean;
  /**
   * Whether directory sync is configured for the instance
   */
  isConfigured: boolean;
  /**
   * The URL to the WorkOS admin portal
   */
  adminPortal: string | null;
  /**
   * The default role for all new users added from this Active Directory
   */
  defaultRole: GetWorkOsInformation_workOs_directorySync_defaultRole | null;
  /**
   * The time of the last directory sync
   */
  lastSyncTime: any | null;
}

export interface GetWorkOsInformation_workOs {
  __typename: "WorkOs";
  /**
   * The WorkOS organization ID for the instance
   */
  organizationId: string | null;
  /**
   * The domain info for the instance
   */
  domainInfo: GetWorkOsInformation_workOs_domainInfo;
  /**
   * The SSO setup for the instance
   */
  sso: GetWorkOsInformation_workOs_sso;
  /**
   * Whether SSO is required for the instance
   */
  directorySync: GetWorkOsInformation_workOs_directorySync;
}

export interface GetWorkOsInformation {
  /**
   * Information about an instance's SSO and diretcory sync setup
   */
  workOs: GetWorkOsInformation_workOs;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: setExchangeUsername
// ====================================================

export interface setExchangeUsername_setExchangeUsername_taskSync {
  __typename: "TaskSync";
  /**
   * The email address being used for task sync
   */
  username: string;
  /**
   * The external task service we're syncing with
   */
  externalService: ExternalService;
  /**
   * Whether or not task sync is enabled
   */
  isEnabled: boolean;
  /**
   * Errors relating to the sync status of tasks
   */
  syncErrors: string[];
}

export interface setExchangeUsername_setExchangeUsername_calendarSync_calendars {
  __typename: "CalendarSyncCalendar";
  /**
   * The API ID for this calendar
   */
  id: string;
  /**
   * The name of this calendar
   */
  name: string;
  /**
   * Indicates if this is the calendar selected for sync
   */
  isSelected: boolean;
  /**
   * The type of sync this calendar is used for. Can be conflict, primary, or none if it is not currently in use
   */
  syncType: SyncType;
  /**
   * Errors relating to the sync status of this calendar
   */
  syncErrors: string[];
  /**
   * The email address used for the oauth connection that created this calendar
   */
  username: string;
  /**
   * The service provider for this calendar, Google, Outlook, or Exchange
   */
  serviceType: ExternalService;
  /**
   * The rules for what events, if any, should be added to the calendar from Nutshell
   */
  exportRule: CalendarExportRule;
  /**
   * Whether contact creation is disabled when syncing calendar events or external meetings
   */
  isContactCreationDisabled: boolean;
}

export interface setExchangeUsername_setExchangeUsername_calendarSync {
  __typename: "CalendarSync";
  /**
   * The email address being used for calendar sync
   */
  username: string;
  /**
   * The external calendar service we're syncing with
   */
  externalService: ExternalService;
  /**
   * Whether or not calendar sync is enabled
   */
  isEnabled: boolean;
  /**
   * Whether or not import from the primary calendar is enabled
   */
  importIsEnabled: boolean;
  /**
   * Errors relating to the sync status of the primary calendar
   */
  syncErrors: string[];
  /**
   * How to handle calendar invitations when creating activities that sync to the external calendar
   */
  inviteSetting: CalendarInviteSetting;
  /**
   * All of the calendars we can sync with
   */
  calendars: setExchangeUsername_setExchangeUsername_calendarSync_calendars[];
}

export interface setExchangeUsername_setExchangeUsername {
  __typename: "SetExchangeUsernamePayload";
  /**
   * State of task sync after the mutation.
   */
  taskSync: setExchangeUsername_setExchangeUsername_taskSync | null;
  /**
   * State of calendar sync after the mutation.
   */
  calendarSync: setExchangeUsername_setExchangeUsername_calendarSync | null;
}

export interface setExchangeUsername {
  /**
   * Set the user's username for Exchange.
   */
  setExchangeUsername: setExchangeUsername_setExchangeUsername | null;
}

export interface setExchangeUsernameVariables {
  username?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateSource
// ====================================================

export interface CreateSource_sourceCreate_source_channel {
  __typename: "Channel";
  /**
   * The enum value of the source
   */
  value: ChannelType;
  /**
   * The title of the channel
   */
  title: string;
  /**
   * The description of the channel
   */
  description: string;
}

export interface CreateSource_sourceCreate_source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The type of the source
   */
  type: SourceType;
  /**
   * The DateTime that represents when the Source was created
   */
  createdTime: any | null;
  /**
   * Can the user delete this source?
   */
  isDeleteable: boolean;
  /**
   * Can the user edit this source?
   */
  isEditable: boolean;
  /**
   * The DateTime the source was last used
   */
  lastUsedTime: any | null;
  /**
   * The channel associated with the source
   */
  channel: CreateSource_sourceCreate_source_channel | null;
}

export interface CreateSource_sourceCreate {
  __typename: "SourceCreatePayload";
  /**
   * The Source
   */
  source: CreateSource_sourceCreate_source;
}

export interface CreateSource {
  /**
   * Creates a source
   */
  sourceCreate: CreateSource_sourceCreate;
}

export interface CreateSourceVariables {
  source: SourceCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteSource
// ====================================================

export interface DeleteSource_sourceDelete_source_channel {
  __typename: "Channel";
  /**
   * The enum value of the source
   */
  value: ChannelType;
  /**
   * The title of the channel
   */
  title: string;
  /**
   * The description of the channel
   */
  description: string;
}

export interface DeleteSource_sourceDelete_source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The type of the source
   */
  type: SourceType;
  /**
   * The DateTime that represents when the Source was created
   */
  createdTime: any | null;
  /**
   * Can the user delete this source?
   */
  isDeleteable: boolean;
  /**
   * Can the user edit this source?
   */
  isEditable: boolean;
  /**
   * The DateTime the source was last used
   */
  lastUsedTime: any | null;
  /**
   * The channel associated with the source
   */
  channel: DeleteSource_sourceDelete_source_channel | null;
}

export interface DeleteSource_sourceDelete {
  __typename: "SourceDeletePayload";
  /**
   * Source deleted
   */
  source: DeleteSource_sourceDelete_source;
}

export interface DeleteSource {
  /**
   * Deletes a source
   */
  sourceDelete: DeleteSource_sourceDelete;
}

export interface DeleteSourceVariables {
  source: SourceDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateSource
// ====================================================

export interface UpdateSource_sourceUpdate_source_channel {
  __typename: "Channel";
  /**
   * The enum value of the source
   */
  value: ChannelType;
  /**
   * The title of the channel
   */
  title: string;
  /**
   * The description of the channel
   */
  description: string;
}

export interface UpdateSource_sourceUpdate_source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The type of the source
   */
  type: SourceType;
  /**
   * The DateTime that represents when the Source was created
   */
  createdTime: any | null;
  /**
   * Can the user delete this source?
   */
  isDeleteable: boolean;
  /**
   * Can the user edit this source?
   */
  isEditable: boolean;
  /**
   * The DateTime the source was last used
   */
  lastUsedTime: any | null;
  /**
   * The channel associated with the source
   */
  channel: UpdateSource_sourceUpdate_source_channel | null;
}

export interface UpdateSource_sourceUpdate {
  __typename: "SourceUpdatePayload";
  /**
   * The Source
   */
  source: UpdateSource_sourceUpdate_source;
}

export interface UpdateSource {
  /**
   * Updates a sources name and channel
   */
  sourceUpdate: UpdateSource_sourceUpdate | null;
}

export interface UpdateSourceVariables {
  source: SourceUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSources
// ====================================================

export interface GetSources_sources_pageInfo {
  __typename: "PageInfo";
  endCursor: string | null;
  hasNextPage: boolean;
}

export interface GetSources_sources_edges_node_channel {
  __typename: "Channel";
  /**
   * The enum value of the source
   */
  value: ChannelType;
  /**
   * The title of the channel
   */
  title: string;
  /**
   * The description of the channel
   */
  description: string;
}

export interface GetSources_sources_edges_node {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The type of the source
   */
  type: SourceType;
  /**
   * The DateTime that represents when the Source was created
   */
  createdTime: any | null;
  /**
   * Can the user delete this source?
   */
  isDeleteable: boolean;
  /**
   * Can the user edit this source?
   */
  isEditable: boolean;
  /**
   * The DateTime the source was last used
   */
  lastUsedTime: any | null;
  /**
   * The channel associated with the source
   */
  channel: GetSources_sources_edges_node_channel | null;
}

export interface GetSources_sources_edges {
  __typename: "SourcesEdge";
  node: GetSources_sources_edges_node;
}

export interface GetSources_sources {
  __typename: "SourcesConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetSources_sources_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetSources_sources_edges[];
}

export interface GetSources {
  /**
   * Returns a paging connection of sources from the root of our query.
   */
  sources: GetSources_sources | null;
}

export interface GetSourcesVariables {
  first?: number | null;
  after?: string | null;
  hasChannel?: boolean | null;
  channel?: ChannelType | null;
  sort?: SourceSortType | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: setGoogleTaskSyncIsEnabled
// ====================================================

export interface setGoogleTaskSyncIsEnabled_setGoogleTaskSyncIsEnabled_taskSync {
  __typename: "TaskSync";
  /**
   * The email address being used for task sync
   */
  username: string;
  /**
   * The external task service we're syncing with
   */
  externalService: ExternalService;
  /**
   * Whether or not task sync is enabled
   */
  isEnabled: boolean;
  /**
   * Errors relating to the sync status of tasks
   */
  syncErrors: string[];
}

export interface setGoogleTaskSyncIsEnabled_setGoogleTaskSyncIsEnabled {
  __typename: "SetGoogleTaskSyncIsEnabledPayload";
  /**
   * URL to direct the user to if we need to authenticate with an external service, or null if authentication is unnecessary
   */
  authUrl: string | null;
  /**
   * State of task sync after the mutation. May be null if initial authentication is required.
   */
  taskSync: setGoogleTaskSyncIsEnabled_setGoogleTaskSyncIsEnabled_taskSync | null;
}

export interface setGoogleTaskSyncIsEnabled {
  /**
   * Enable or disable Google task sync.
   */
  setGoogleTaskSyncIsEnabled: setGoogleTaskSyncIsEnabled_setGoogleTaskSyncIsEnabled | null;
}

export interface setGoogleTaskSyncIsEnabledVariables {
  isEnabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTaskSync
// ====================================================

export interface GetTaskSync_loggedInUser_taskSync {
  __typename: "TaskSync";
  /**
   * The email address being used for task sync
   */
  username: string;
  /**
   * The external task service we're syncing with
   */
  externalService: ExternalService;
  /**
   * Whether or not task sync is enabled
   */
  isEnabled: boolean;
  /**
   * Errors relating to the sync status of tasks
   */
  syncErrors: string[];
}

export interface GetTaskSync_loggedInUser_calendarSync {
  __typename: "CalendarSync";
  /**
   * Whether or not calendar sync is enabled
   */
  isEnabled: boolean;
  /**
   * The external calendar service we're syncing with
   */
  externalService: ExternalService;
}

export interface GetTaskSync_loggedInUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Task sync details for this user
   */
  taskSync: GetTaskSync_loggedInUser_taskSync | null;
  /**
   * Calendar sync details for this user
   */
  calendarSync: GetTaskSync_loggedInUser_calendarSync | null;
}

export interface GetTaskSync {
  /**
   * Returns the requesting user. This is essentially the logged in user, but in an
   * API context, they might not be any "logged in"
   */
  loggedInUser: GetTaskSync_loggedInUser;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ProvisionPhoneNumber
// ====================================================

export interface ProvisionPhoneNumber_phoneNumberProvision_inboxChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface ProvisionPhoneNumber_phoneNumberProvision_inboxChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  phone: ProvisionPhoneNumber_phoneNumberProvision_inboxChannel_phone | null;
}

export interface ProvisionPhoneNumber_phoneNumberProvision {
  __typename: "PhoneNumberProvisionPayload";
  /**
   * The channel containing the purchased number.
   */
  inboxChannel: ProvisionPhoneNumber_phoneNumberProvision_inboxChannel;
}

export interface ProvisionPhoneNumber {
  /**
   * Purchases a phone number and creates a new channel.
   */
  phoneNumberProvision: ProvisionPhoneNumber_phoneNumberProvision;
}

export interface ProvisionPhoneNumberVariables {
  input: PhoneNumberProvisionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SubmitInboxEnrollmentForm
// ====================================================

export interface SubmitInboxEnrollmentForm_inboxEnrollmentFormSubmit_enrollmentForm_values {
  __typename: "EnrollmentFormField";
  /**
   * The name (key) of this enrollment form field
   */
  name: EnrollmentFormFieldKey;
  /**
   * The value of this enrollment form field
   */
  value: string | null;
  /**
   * The error associated with this enrollment form field
   */
  error: string | null;
}

export interface SubmitInboxEnrollmentForm_inboxEnrollmentFormSubmit_enrollmentForm {
  __typename: "EnrollmentForm";
  /**
   * The status of this instances enrollment form
   */
  status: EnrollmentFormEnumStatus;
  /**
   * The values of this instances enrollment form
   */
  values: SubmitInboxEnrollmentForm_inboxEnrollmentFormSubmit_enrollmentForm_values[];
  /**
   * Whether the enrollment form can be submitted
   */
  canSubmit: boolean;
  /**
   * The reasons for Twilio rejections
   */
  twilioRejectionReasons: string;
}

export interface SubmitInboxEnrollmentForm_inboxEnrollmentFormSubmit {
  __typename: "EnrollmentFormSubmitPayload";
  enrollmentForm: SubmitInboxEnrollmentForm_inboxEnrollmentFormSubmit_enrollmentForm;
}

export interface SubmitInboxEnrollmentForm {
  /**
   * Submits the Nutshell inbox enrollment form for async processing
   */
  inboxEnrollmentFormSubmit: SubmitInboxEnrollmentForm_inboxEnrollmentFormSubmit;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateInboxEnrollmentForm
// ====================================================

export interface UpdateInboxEnrollmentForm_inboxEnrollmentFormUpdate_enrollmentFormField {
  __typename: "EnrollmentFormField";
  /**
   * The value of this enrollment form field
   */
  value: string | null;
  /**
   * The name (key) of this enrollment form field
   */
  name: EnrollmentFormFieldKey;
  /**
   * The error associated with this enrollment form field
   */
  error: string | null;
}

export interface UpdateInboxEnrollmentForm_inboxEnrollmentFormUpdate {
  __typename: "EnrollmentFormUpdatePayload";
  enrollmentFormField: UpdateInboxEnrollmentForm_inboxEnrollmentFormUpdate_enrollmentFormField | null;
}

export interface UpdateInboxEnrollmentForm {
  /**
   * Updates the Nutshell Inbox enrollment form for texting
   */
  inboxEnrollmentFormUpdate: UpdateInboxEnrollmentForm_inboxEnrollmentFormUpdate;
}

export interface UpdateInboxEnrollmentFormVariables {
  input: EnrollmentFormUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAvailablePhoneNumbers
// ====================================================

export interface GetAvailablePhoneNumbers_availablePhoneNumbers {
  __typename: "NutPhoneNumber";
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The base number component of the phone number
   */
  numberFormatted: string;
  /**
   * The number in E164 format
   */
  e164: string;
  /**
   * The leading digits representing the number's origin
   */
  countryCode: string;
}

export interface GetAvailablePhoneNumbers {
  /**
   * Returns a list of phone numbers available to be purchased.
   */
  availablePhoneNumbers: GetAvailablePhoneNumbers_availablePhoneNumbers[];
}

export interface GetAvailablePhoneNumbersVariables {
  countryCode?: string | null;
  areaCode?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetInboxEnrollmentForm
// ====================================================

export interface GetInboxEnrollmentForm_inboxEnrollmentForm_values {
  __typename: "EnrollmentFormField";
  /**
   * The name (key) of this enrollment form field
   */
  name: EnrollmentFormFieldKey;
  /**
   * The value of this enrollment form field
   */
  value: string | null;
  /**
   * The error associated with this enrollment form field
   */
  error: string | null;
}

export interface GetInboxEnrollmentForm_inboxEnrollmentForm {
  __typename: "EnrollmentForm";
  /**
   * The status of this instances enrollment form
   */
  status: EnrollmentFormEnumStatus;
  /**
   * The values of this instances enrollment form
   */
  values: GetInboxEnrollmentForm_inboxEnrollmentForm_values[];
  /**
   * Whether the enrollment form can be submitted
   */
  canSubmit: boolean;
  /**
   * The reasons for Twilio rejections
   */
  twilioRejectionReasons: string;
}

export interface GetInboxEnrollmentForm {
  /**
   * Returns the enrollment form
   */
  inboxEnrollmentForm: GetInboxEnrollmentForm_inboxEnrollmentForm;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetInboxStatus
// ====================================================

export interface GetInboxStatus_inboxStatus_enrollmentFormStatus_enrollmentForm {
  __typename: "EnrollmentForm";
  /**
   * Whether the enrollment form can be submitted
   */
  canSubmit: boolean;
  /**
   * The reasons for Twilio rejections
   */
  twilioRejectionReasons: string;
}

export interface GetInboxStatus_inboxStatus_enrollmentFormStatus {
  __typename: "EnrollmentFormStatus";
  /**
   * The status of the phone configuration
   */
  status: EnrollmentFormEnumStatus;
  /**
   * The enrollment form for this instance
   */
  enrollmentForm: GetInboxStatus_inboxStatus_enrollmentFormStatus_enrollmentForm;
}

export interface GetInboxStatus_inboxStatus_phoneStatus_nutshellChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetInboxStatus_inboxStatus_phoneStatus_nutshellChannel {
  __typename: "InboxChannel";
  status: ChannelStatus;
  phone: GetInboxStatus_inboxStatus_phoneStatus_nutshellChannel_phone | null;
}

export interface GetInboxStatus_inboxStatus_phoneStatus {
  __typename: "PhoneStatus";
  /**
   * The status of the phone configuration
   */
  status: ChannelStatus;
  /**
   * The Inbox channel for this instance
   */
  nutshellChannel: GetInboxStatus_inboxStatus_phoneStatus_nutshellChannel | null;
}

export interface GetInboxStatus_inboxStatus_firstMessageStatus_message {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The content of the message
   */
  content: string;
}

export interface GetInboxStatus_inboxStatus_firstMessageStatus {
  __typename: "FirstMessageStatus";
  /**
   * Whether the first message has been sent
   */
  hasBeenSent: boolean;
  /**
   * The first message sent from this instance
   */
  message: GetInboxStatus_inboxStatus_firstMessageStatus_message | null;
}

export interface GetInboxStatus_inboxStatus_firstCampaignStatus_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface GetInboxStatus_inboxStatus_firstCampaignStatus {
  __typename: "FirstCampaignStatus";
  /**
   * Whether the first campaign has been sent
   */
  hasBeenSent: boolean;
  /**
   * The first campaign sent from this instance
   */
  campaign: GetInboxStatus_inboxStatus_firstCampaignStatus_campaign | null;
}

export interface GetInboxStatus_inboxStatus_planStatus {
  __typename: "PlanStatus";
  /**
   * The status of the instance inbox plan
   */
  status: InboxPlanEnum;
  /**
   * The number of remaining credits for this instance
   */
  remainingCredits: number;
  /**
   * How many messages are allowed to be sent this month
   */
  monthlyCredits: number;
  /**
   * How many messages were successfully sent this month
   */
  usedCredits: number;
}

export interface GetInboxStatus_inboxStatus {
  __typename: "InboxStatus";
  /**
   * The high-level status of the inbox setup
   */
  status: InboxStatusEnum;
  /**
   * This instance's enrollment form
   */
  enrollmentFormStatus: GetInboxStatus_inboxStatus_enrollmentFormStatus;
  /**
   * This instance's phone status
   */
  phoneStatus: GetInboxStatus_inboxStatus_phoneStatus;
  /**
   * Whether or not the first text has been sent
   */
  firstMessageStatus: GetInboxStatus_inboxStatus_firstMessageStatus;
  /**
   * Whether or not the first text has been sent
   */
  firstCampaignStatus: GetInboxStatus_inboxStatus_firstCampaignStatus;
  /**
   * This instance's inbox plan status
   */
  planStatus: GetInboxStatus_inboxStatus_planStatus;
}

export interface GetInboxStatus {
  /**
   * Returns the wrapup of multiple inbox facets
   */
  inboxStatus: GetInboxStatus_inboxStatus;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TestSnippetStatus
// ====================================================

export interface TestSnippetStatus_snippetStatusTest_snippetTestStatus {
  __typename: "SnippetTestStatus";
  /**
   * Whether or not the snippet was found at the tested domain
   */
  status: SnippetTestStatusEnum;
  /**
   * The timestamp of the last time the snippet was tested
   */
  lastTestedTime: any | null;
  /**
   * The domain at which the snippet has been embedded and tested. May be null if no embed or test is completed
   */
  embeddedDomain: string | null;
  /**
   * The domain used to load the snippet
   */
  loaderDomain: string | null;
}

export interface TestSnippetStatus_snippetStatusTest {
  __typename: "SnippetStatusTestPayload";
  /**
   * The status of the embedded snippet
   */
  snippetTestStatus: TestSnippetStatus_snippetStatusTest_snippetTestStatus;
}

export interface TestSnippetStatus {
  /**
   * Given a domain, test if the nutshell tracking or boot snippet is embedded there. Returns the status of the test.
   */
  snippetStatusTest: TestSnippetStatus_snippetStatusTest;
}

export interface TestSnippetStatusVariables {
  input: SnippetStatusTestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTrackingSnippetPageFeatures
// ====================================================

export interface GetTrackingSnippetPageFeatures_trackingSnippetPageFeatures {
  __typename: "TrackingSnippetPageFeatureListItem";
  /**
   * The key of the feature
   */
  key: TrackingSnippetPageFeatureListItemKey;
  /**
   * Information about the last usage of the feature
   */
  statusText: string;
  /**
   * Status of the feature. Dependent on the presence of the boot snippet and if the feature is configured for use
   */
  status: FeatureStatus;
}

export interface GetTrackingSnippetPageFeatures {
  /**
   * A list of features and their status on the tracking snippet page
   */
  trackingSnippetPageFeatures: GetTrackingSnippetPageFeatures_trackingSnippetPageFeatures[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTrackingSnippetStatus
// ====================================================

export interface GetTrackingSnippetStatus_analyticsStatus {
  __typename: "AnalyticsStatus";
  /**
   * The tracking status for the instance
   */
  status: Status;
  /**
   * The domain at which the snippet has been embedded. May be null if no embed or test is completed
   */
  domain: string | null;
  /**
   * The last recorded time the boot config was accessed
   */
  lastBootConfigAccessTime: any | null;
}

export interface GetTrackingSnippetStatus {
  /**
   * Status of the user’s session tracking
   */
  analyticsStatus: GetTrackingSnippetStatus_analyticsStatus;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateUser
// ====================================================

export interface CreateUser_userCreate_user_emailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The address string of this email.
   */
  address: string;
}

export interface CreateUser_userCreate_user_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface CreateUser_userCreate_user_role {
  __typename: "Role";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this role
   */
  name: string;
}

export interface CreateUser_userCreate_user_licenses {
  __typename: "UserLicenseInfo";
  /**
   * The type of the license
   */
  licenseType: LicenseType;
  /**
   * Whether the license is owned by the user
   */
  isOwned: boolean;
}

export interface CreateUser_userCreate_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  redirectUrl: string | null;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
  /**
   * User emails configured for this user
   */
  emailAddresses: CreateUser_userCreate_user_emailAddresses[];
  teams: CreateUser_userCreate_user_teams[];
  role: CreateUser_userCreate_user_role;
  /**
   * A list of all licenses and whether they are enabled for this user
   */
  licenses: CreateUser_userCreate_user_licenses[];
  hasTwoFactorEnabled: boolean;
  hasMailSyncEnabled: boolean;
  lastSeen: any | null;
}

export interface CreateUser_userCreate {
  __typename: "UserCreatePayload";
  user: CreateUser_userCreate_user;
  isExistingUser: boolean | null;
}

export interface CreateUser {
  /**
   * Creates a new user based on the provided input.
   */
  userCreate: CreateUser_userCreate;
}

export interface CreateUserVariables {
  input: UserCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUsersByFilter
// ====================================================

export interface GetUsersByFilter_usersByFilter_pageInfo {
  __typename: "PageInfo";
  endCursor: string | null;
  hasNextPage: boolean;
}

export interface GetUsersByFilter_usersByFilter_edges_node_emailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The address string of this email.
   */
  address: string;
}

export interface GetUsersByFilter_usersByFilter_edges_node_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface GetUsersByFilter_usersByFilter_edges_node_role {
  __typename: "Role";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this role
   */
  name: string;
}

export interface GetUsersByFilter_usersByFilter_edges_node_licenses {
  __typename: "UserLicenseInfo";
  /**
   * The type of the license
   */
  licenseType: LicenseType;
  /**
   * Whether the license is owned by the user
   */
  isOwned: boolean;
}

export interface GetUsersByFilter_usersByFilter_edges_node {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  redirectUrl: string | null;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
  /**
   * User emails configured for this user
   */
  emailAddresses: GetUsersByFilter_usersByFilter_edges_node_emailAddresses[];
  teams: GetUsersByFilter_usersByFilter_edges_node_teams[];
  role: GetUsersByFilter_usersByFilter_edges_node_role;
  /**
   * A list of all licenses and whether they are enabled for this user
   */
  licenses: GetUsersByFilter_usersByFilter_edges_node_licenses[];
  hasTwoFactorEnabled: boolean;
  hasMailSyncEnabled: boolean;
  lastSeen: any | null;
}

export interface GetUsersByFilter_usersByFilter_edges {
  __typename: "UsersEdge";
  node: GetUsersByFilter_usersByFilter_edges_node;
}

export interface GetUsersByFilter_usersByFilter {
  __typename: "UsersConnection";
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetUsersByFilter_usersByFilter_pageInfo;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetUsersByFilter_usersByFilter_edges[];
}

export interface GetUsersByFilter {
  /**
   * Returns a paging connection of users by status from the root of our query.
   */
  usersByFilter: GetUsersByFilter_usersByFilter;
}

export interface GetUsersByFilterVariables {
  first?: number | null;
  after?: string | null;
  statusFilter?: number | null;
  roleId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateRole
// ====================================================

export interface CreateRole_roleCreate_role {
  __typename: "Role";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this role
   */
  name: string;
  /**
   * The (order) position of this role
   */
  position: number;
  /**
   * Whether this role is immutable
   */
  isImmutable: boolean;
  /**
   * The permissions tied to this role
   */
  permissions: Permission[];
  /**
   * The number of users with this role
   */
  usersCount: number;
  /**
   * Whether this role is the default role for new users
   */
  isDefault: boolean;
}

export interface CreateRole_roleCreate {
  __typename: "RoleCreatePayload";
  /**
   * The newly created role
   */
  role: CreateRole_roleCreate_role | null;
}

export interface CreateRole {
  /**
   * Creates a new role
   */
  roleCreate: CreateRole_roleCreate;
}

export interface CreateRoleVariables {
  input: RoleCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteRole
// ====================================================

export interface DeleteRole_roleDelete_role {
  __typename: "Role";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this role
   */
  name: string;
  /**
   * The (order) position of this role
   */
  position: number;
  /**
   * Whether this role is immutable
   */
  isImmutable: boolean;
  /**
   * The permissions tied to this role
   */
  permissions: Permission[];
  /**
   * The number of users with this role
   */
  usersCount: number;
  /**
   * Whether this role is the default role for new users
   */
  isDefault: boolean;
}

export interface DeleteRole_roleDelete {
  __typename: "RoleDeletePayload";
  /**
   * The deleted role
   */
  role: DeleteRole_roleDelete_role | null;
}

export interface DeleteRole {
  /**
   * Deletes a role
   */
  roleDelete: DeleteRole_roleDelete;
}

export interface DeleteRoleVariables {
  input: RoleDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateRolePermission
// ====================================================

export interface UpdateRolePermission_roleUpdatePermission_role {
  __typename: "Role";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this role
   */
  name: string;
  /**
   * The (order) position of this role
   */
  position: number;
  /**
   * Whether this role is immutable
   */
  isImmutable: boolean;
  /**
   * The permissions tied to this role
   */
  permissions: Permission[];
  /**
   * The number of users with this role
   */
  usersCount: number;
  /**
   * Whether this role is the default role for new users
   */
  isDefault: boolean;
}

export interface UpdateRolePermission_roleUpdatePermission {
  __typename: "RoleUpdatePermissionPayload";
  /**
   * The newly updated role
   */
  role: UpdateRolePermission_roleUpdatePermission_role | null;
}

export interface UpdateRolePermission {
  /**
   * Updates a permission of a role
   */
  roleUpdatePermission: UpdateRolePermission_roleUpdatePermission;
}

export interface UpdateRolePermissionVariables {
  input: RoleUpdatePermissionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateRole
// ====================================================

export interface UpdateRole_roleUpdate_role {
  __typename: "Role";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this role
   */
  name: string;
  /**
   * The (order) position of this role
   */
  position: number;
  /**
   * Whether this role is immutable
   */
  isImmutable: boolean;
  /**
   * The permissions tied to this role
   */
  permissions: Permission[];
  /**
   * The number of users with this role
   */
  usersCount: number;
  /**
   * Whether this role is the default role for new users
   */
  isDefault: boolean;
}

export interface UpdateRole_roleUpdate {
  __typename: "RoleUpdatePayload";
  /**
   * The newly updated role
   */
  role: UpdateRole_roleUpdate_role | null;
}

export interface UpdateRole {
  /**
   * Updates the name of a role
   */
  roleUpdate: UpdateRole_roleUpdate;
}

export interface UpdateRoleVariables {
  input: RoleUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRoles
// ====================================================

export interface GetRoles_roles {
  __typename: "Role";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this role
   */
  name: string;
  /**
   * The (order) position of this role
   */
  position: number;
  /**
   * Whether this role is immutable
   */
  isImmutable: boolean;
  /**
   * The permissions tied to this role
   */
  permissions: Permission[];
  /**
   * The number of users with this role
   */
  usersCount: number;
  /**
   * Whether this role is the default role for new users
   */
  isDefault: boolean;
}

export interface GetRoles {
  /**
   * Returns an array of roles with permissions
   */
  roles: GetRoles_roles[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: GoogleReauth
// ====================================================

export interface GoogleReauth_revokeAndAuthGoogle {
  __typename: "RevokeAndAuthGooglePayload";
  /**
   * URL to direct the user to if we need to authenticate with an external service, or null if authentication is unnecessary
   */
  authUrl: string | null;
}

export interface GoogleReauth {
  /**
   * Revoke current wide scoped Google OAuth credentials and request narrow scopes.
   */
  revokeAndAuthGoogle: GoogleReauth_revokeAndAuthGoogle | null;
}

export interface GoogleReauthVariables {
  reauth: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MarkNotificationAllRead
// ====================================================

export interface MarkNotificationAllRead_markNotificationAllRead_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MarkNotificationAllRead_markNotificationAllRead {
  __typename: "NotificationMarkAllReadPayload";
  /**
   * The user that has paused automated emails
   */
  user: MarkNotificationAllRead_markNotificationAllRead_user;
}

export interface MarkNotificationAllRead {
  /**
   * Pauses automated emails for the logged in user.
   */
  markNotificationAllRead: MarkNotificationAllRead_markNotificationAllRead | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MarkNotificationAllSeen
// ====================================================

export interface MarkNotificationAllSeen_markNotificationAllSeen_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MarkNotificationAllSeen_markNotificationAllSeen {
  __typename: "NotificationMarkAllSeenPayload";
  /**
   * The user that has paused automated emails
   */
  user: MarkNotificationAllSeen_markNotificationAllSeen_user;
}

export interface MarkNotificationAllSeen {
  /**
   * Pauses automated emails for the logged in user.
   */
  markNotificationAllSeen: MarkNotificationAllSeen_markNotificationAllSeen | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MarkNotificationRead
// ====================================================

export interface MarkNotificationRead_notificationMarkRead_notification_destinationEntity_Account {
  __typename: "Account" | "Contact" | "Lead" | "Note" | "Comment" | "Reaction" | "Task" | "Step" | "UnknownEntityType" | "Submission" | "Form" | "Email" | "EmailAutomationStatus" | "Booking" | "User" | "Message" | "Quote" | "Invoice" | "DocumentView" | "Contract";
}

export interface MarkNotificationRead_notificationMarkRead_notification_destinationEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MarkNotificationRead_notificationMarkRead_notification_destinationEntity_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type MarkNotificationRead_notificationMarkRead_notification_destinationEntity = MarkNotificationRead_notificationMarkRead_notification_destinationEntity_Account | MarkNotificationRead_notificationMarkRead_notification_destinationEntity_Activity | MarkNotificationRead_notificationMarkRead_notification_destinationEntity_Thread;

export interface MarkNotificationRead_notificationMarkRead_notification_triggeringUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface MarkNotificationRead_notificationMarkRead_notification_entity_Account {
  __typename: "Account" | "Note" | "Comment" | "Task" | "Step" | "UnknownEntityType" | "Submission" | "Form" | "Email" | "EmailAutomationStatus" | "Booking" | "User" | "DocumentView" | "Contract";
}

export interface MarkNotificationRead_notificationMarkRead_notification_entity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MarkNotificationRead_notificationMarkRead_notification_entity_Lead {
  __typename: "Lead";
  avatarUrl: string;
  /**
   * Leads don’t have initials, but for interface reasons we’ll return an empty
   * string here instead of removing the property entirely.
   */
  initials: string;
}

export interface MarkNotificationRead_notificationMarkRead_notification_entity_Contact {
  __typename: "Contact";
  avatarUrl: string;
  initials: string;
}

export interface MarkNotificationRead_notificationMarkRead_notification_entity_Reaction {
  __typename: "Reaction";
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
}

export interface MarkNotificationRead_notificationMarkRead_notification_entity_Thread {
  __typename: "Thread";
  /**
   * The type of this thread
   */
  threadType: ThreadType;
}

export interface MarkNotificationRead_notificationMarkRead_notification_entity_Message_thread {
  __typename: "Thread";
  /**
   * The type of this thread
   */
  threadType: ThreadType;
}

export interface MarkNotificationRead_notificationMarkRead_notification_entity_Message {
  __typename: "Message";
  /**
   * The thread this message is part of
   */
  thread: MarkNotificationRead_notificationMarkRead_notification_entity_Message_thread;
}

export interface MarkNotificationRead_notificationMarkRead_notification_entity_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MarkNotificationRead_notificationMarkRead_notification_entity_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type MarkNotificationRead_notificationMarkRead_notification_entity = MarkNotificationRead_notificationMarkRead_notification_entity_Account | MarkNotificationRead_notificationMarkRead_notification_entity_Activity | MarkNotificationRead_notificationMarkRead_notification_entity_Lead | MarkNotificationRead_notificationMarkRead_notification_entity_Contact | MarkNotificationRead_notificationMarkRead_notification_entity_Reaction | MarkNotificationRead_notificationMarkRead_notification_entity_Thread | MarkNotificationRead_notificationMarkRead_notification_entity_Message | MarkNotificationRead_notificationMarkRead_notification_entity_Quote | MarkNotificationRead_notificationMarkRead_notification_entity_Invoice;

export interface MarkNotificationRead_notificationMarkRead_notification {
  __typename: "Notification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of notification
   */
  type: NotificationType;
  destinationEntity: MarkNotificationRead_notificationMarkRead_notification_destinationEntity | null;
  /**
   * The user that triggered this notification. Can be null if created by an origin
   */
  triggeringUser: MarkNotificationRead_notificationMarkRead_notification_triggeringUser | null;
  /**
   * Read status of this notification
   */
  readStatus: NotificationReadStatus;
  /**
   * Message of the notification
   */
  content: string;
  /**
   * First line of the notification entity the notification is about
   */
  preview: string;
  /**
   * Time that the notification was created
   */
  createdTime: any;
  htmlUrl: string | null;
  /**
   * The primary entity of this notification. Note that this is different than the
   * destinationEntity in some cases, like comments and reactions. When someone
   * comments on a note, the Comment is the entity, and the Note is the destination entity
   */
  entity: MarkNotificationRead_notificationMarkRead_notification_entity;
}

export interface MarkNotificationRead_notificationMarkRead {
  __typename: "NotificationMarkReadPayload";
  /**
   * The read notification
   */
  notification: MarkNotificationRead_notificationMarkRead_notification;
}

export interface MarkNotificationRead {
  /**
   * Marks a notification as read
   */
  notificationMarkRead: MarkNotificationRead_notificationMarkRead;
}

export interface MarkNotificationReadVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetNotifications
// ====================================================

export interface GetNotifications_notifications_destinationEntity_Account {
  __typename: "Account" | "Contact" | "Lead" | "Note" | "Comment" | "Reaction" | "Task" | "Step" | "UnknownEntityType" | "Submission" | "Form" | "Email" | "EmailAutomationStatus" | "Booking" | "User" | "Message" | "Quote" | "Invoice" | "DocumentView" | "Contract";
}

export interface GetNotifications_notifications_destinationEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetNotifications_notifications_destinationEntity_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type GetNotifications_notifications_destinationEntity = GetNotifications_notifications_destinationEntity_Account | GetNotifications_notifications_destinationEntity_Activity | GetNotifications_notifications_destinationEntity_Thread;

export interface GetNotifications_notifications_triggeringUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface GetNotifications_notifications_entity_Account {
  __typename: "Account" | "Note" | "Comment" | "Task" | "Step" | "UnknownEntityType" | "Submission" | "Form" | "Email" | "EmailAutomationStatus" | "Booking" | "User" | "DocumentView" | "Contract";
}

export interface GetNotifications_notifications_entity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetNotifications_notifications_entity_Lead {
  __typename: "Lead";
  avatarUrl: string;
  /**
   * Leads don’t have initials, but for interface reasons we’ll return an empty
   * string here instead of removing the property entirely.
   */
  initials: string;
}

export interface GetNotifications_notifications_entity_Contact {
  __typename: "Contact";
  avatarUrl: string;
  initials: string;
}

export interface GetNotifications_notifications_entity_Reaction {
  __typename: "Reaction";
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
}

export interface GetNotifications_notifications_entity_Thread {
  __typename: "Thread";
  /**
   * The type of this thread
   */
  threadType: ThreadType;
}

export interface GetNotifications_notifications_entity_Message_thread {
  __typename: "Thread";
  /**
   * The type of this thread
   */
  threadType: ThreadType;
}

export interface GetNotifications_notifications_entity_Message {
  __typename: "Message";
  /**
   * The thread this message is part of
   */
  thread: GetNotifications_notifications_entity_Message_thread;
}

export interface GetNotifications_notifications_entity_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetNotifications_notifications_entity_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type GetNotifications_notifications_entity = GetNotifications_notifications_entity_Account | GetNotifications_notifications_entity_Activity | GetNotifications_notifications_entity_Lead | GetNotifications_notifications_entity_Contact | GetNotifications_notifications_entity_Reaction | GetNotifications_notifications_entity_Thread | GetNotifications_notifications_entity_Message | GetNotifications_notifications_entity_Quote | GetNotifications_notifications_entity_Invoice;

export interface GetNotifications_notifications {
  __typename: "Notification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of notification
   */
  type: NotificationType;
  destinationEntity: GetNotifications_notifications_destinationEntity | null;
  /**
   * The user that triggered this notification. Can be null if created by an origin
   */
  triggeringUser: GetNotifications_notifications_triggeringUser | null;
  /**
   * Read status of this notification
   */
  readStatus: NotificationReadStatus;
  /**
   * Message of the notification
   */
  content: string;
  /**
   * First line of the notification entity the notification is about
   */
  preview: string;
  /**
   * Time that the notification was created
   */
  createdTime: any;
  htmlUrl: string | null;
  /**
   * The primary entity of this notification. Note that this is different than the
   * destinationEntity in some cases, like comments and reactions. When someone
   * comments on a note, the Comment is the entity, and the Note is the destination entity
   */
  entity: GetNotifications_notifications_entity;
}

export interface GetNotifications {
  /**
   * Collection around in-app notifications
   */
  notifications: GetNotifications_notifications[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSearchResults
// ====================================================

export interface GetSearchResults_search_quickResults_topResults_Lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetSearchResults_search_quickResults_topResults_Lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetSearchResults_search_quickResults_topResults_Lead_contacts_primaryEdge_node;
}

export interface GetSearchResults_search_quickResults_topResults_Lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetSearchResults_search_quickResults_topResults_Lead_contacts_primaryEdge | null;
}

export interface GetSearchResults_search_quickResults_topResults_Lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetSearchResults_search_quickResults_topResults_Lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetSearchResults_search_quickResults_topResults_Lead_accounts_primaryEdge_node;
}

export interface GetSearchResults_search_quickResults_topResults_Lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetSearchResults_search_quickResults_topResults_Lead_accounts_primaryEdge | null;
}

export interface GetSearchResults_search_quickResults_topResults_Lead_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetSearchResults_search_quickResults_topResults_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetSearchResults_search_quickResults_topResults_Lead_value_formattedValue;
}

export interface GetSearchResults_search_quickResults_topResults_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead, with html encoded special characters
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  /**
   * The time this lead did or will become overdue
   */
  overdueTime: any | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetSearchResults_search_quickResults_topResults_Lead_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetSearchResults_search_quickResults_topResults_Lead_accounts;
  value: GetSearchResults_search_quickResults_topResults_Lead_value | null;
}

export interface GetSearchResults_search_quickResults_topResults_Account_primaryContact {
  __typename: "Contact";
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetSearchResults_search_quickResults_topResults_Account_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetSearchResults_search_quickResults_topResults_Account_phones_primary {
  __typename: "Phone";
  value: GetSearchResults_search_quickResults_topResults_Account_phones_primary_value;
}

export interface GetSearchResults_search_quickResults_topResults_Account_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSearchResults_search_quickResults_topResults_Account_phones_primary | null;
}

export interface GetSearchResults_search_quickResults_topResults_Account_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  city: string | null;
  postalCode: string | null;
}

export interface GetSearchResults_search_quickResults_topResults_Account_postalAddresses_primary {
  __typename: "PostalAddress";
  value: GetSearchResults_search_quickResults_topResults_Account_postalAddresses_primary_value;
}

export interface GetSearchResults_search_quickResults_topResults_Account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSearchResults_search_quickResults_topResults_Account_postalAddresses_primary | null;
}

export interface GetSearchResults_search_quickResults_topResults_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The descriptive name of the Nutshell Contact, with special characters html encoded
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * The primary contact for this account
   */
  primaryContact: GetSearchResults_search_quickResults_topResults_Account_primaryContact | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetSearchResults_search_quickResults_topResults_Account_phones;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetSearchResults_search_quickResults_topResults_Account_postalAddresses;
}

export interface GetSearchResults_search_quickResults_topResults_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetSearchResults_search_quickResults_topResults_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetSearchResults_search_quickResults_topResults_Contact_accounts_primary | null;
}

export interface GetSearchResults_search_quickResults_topResults_Contact_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetSearchResults_search_quickResults_topResults_Contact_phones_primary {
  __typename: "Phone";
  value: GetSearchResults_search_quickResults_topResults_Contact_phones_primary_value;
}

export interface GetSearchResults_search_quickResults_topResults_Contact_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSearchResults_search_quickResults_topResults_Contact_phones_primary | null;
}

export interface GetSearchResults_search_quickResults_topResults_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetSearchResults_search_quickResults_topResults_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetSearchResults_search_quickResults_topResults_Contact_emailAddresses_primary_value;
}

export interface GetSearchResults_search_quickResults_topResults_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSearchResults_search_quickResults_topResults_Contact_emailAddresses_primary | null;
}

export interface GetSearchResults_search_quickResults_topResults_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The descriptive name of the Nutshell Contact, with special characters html encoded
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetSearchResults_search_quickResults_topResults_Contact_accounts;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetSearchResults_search_quickResults_topResults_Contact_phones;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetSearchResults_search_quickResults_topResults_Contact_emailAddresses;
}

export type GetSearchResults_search_quickResults_topResults = GetSearchResults_search_quickResults_topResults_Lead | GetSearchResults_search_quickResults_topResults_Account | GetSearchResults_search_quickResults_topResults_Contact;

export interface GetSearchResults_search_quickResults_recentResults_Lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetSearchResults_search_quickResults_recentResults_Lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetSearchResults_search_quickResults_recentResults_Lead_contacts_primaryEdge_node;
}

export interface GetSearchResults_search_quickResults_recentResults_Lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetSearchResults_search_quickResults_recentResults_Lead_contacts_primaryEdge | null;
}

export interface GetSearchResults_search_quickResults_recentResults_Lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetSearchResults_search_quickResults_recentResults_Lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetSearchResults_search_quickResults_recentResults_Lead_accounts_primaryEdge_node;
}

export interface GetSearchResults_search_quickResults_recentResults_Lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetSearchResults_search_quickResults_recentResults_Lead_accounts_primaryEdge | null;
}

export interface GetSearchResults_search_quickResults_recentResults_Lead_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetSearchResults_search_quickResults_recentResults_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetSearchResults_search_quickResults_recentResults_Lead_value_formattedValue;
}

export interface GetSearchResults_search_quickResults_recentResults_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead, with html encoded special characters
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  /**
   * The time this lead did or will become overdue
   */
  overdueTime: any | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetSearchResults_search_quickResults_recentResults_Lead_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetSearchResults_search_quickResults_recentResults_Lead_accounts;
  value: GetSearchResults_search_quickResults_recentResults_Lead_value | null;
}

export interface GetSearchResults_search_quickResults_recentResults_Account_primaryContact {
  __typename: "Contact";
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetSearchResults_search_quickResults_recentResults_Account_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetSearchResults_search_quickResults_recentResults_Account_phones_primary {
  __typename: "Phone";
  value: GetSearchResults_search_quickResults_recentResults_Account_phones_primary_value;
}

export interface GetSearchResults_search_quickResults_recentResults_Account_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSearchResults_search_quickResults_recentResults_Account_phones_primary | null;
}

export interface GetSearchResults_search_quickResults_recentResults_Account_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  city: string | null;
  postalCode: string | null;
}

export interface GetSearchResults_search_quickResults_recentResults_Account_postalAddresses_primary {
  __typename: "PostalAddress";
  value: GetSearchResults_search_quickResults_recentResults_Account_postalAddresses_primary_value;
}

export interface GetSearchResults_search_quickResults_recentResults_Account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSearchResults_search_quickResults_recentResults_Account_postalAddresses_primary | null;
}

export interface GetSearchResults_search_quickResults_recentResults_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The descriptive name of the Nutshell Contact, with special characters html encoded
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * The primary contact for this account
   */
  primaryContact: GetSearchResults_search_quickResults_recentResults_Account_primaryContact | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetSearchResults_search_quickResults_recentResults_Account_phones;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetSearchResults_search_quickResults_recentResults_Account_postalAddresses;
}

export interface GetSearchResults_search_quickResults_recentResults_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetSearchResults_search_quickResults_recentResults_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetSearchResults_search_quickResults_recentResults_Contact_accounts_primary | null;
}

export interface GetSearchResults_search_quickResults_recentResults_Contact_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetSearchResults_search_quickResults_recentResults_Contact_phones_primary {
  __typename: "Phone";
  value: GetSearchResults_search_quickResults_recentResults_Contact_phones_primary_value;
}

export interface GetSearchResults_search_quickResults_recentResults_Contact_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSearchResults_search_quickResults_recentResults_Contact_phones_primary | null;
}

export interface GetSearchResults_search_quickResults_recentResults_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetSearchResults_search_quickResults_recentResults_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetSearchResults_search_quickResults_recentResults_Contact_emailAddresses_primary_value;
}

export interface GetSearchResults_search_quickResults_recentResults_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSearchResults_search_quickResults_recentResults_Contact_emailAddresses_primary | null;
}

export interface GetSearchResults_search_quickResults_recentResults_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The descriptive name of the Nutshell Contact, with special characters html encoded
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetSearchResults_search_quickResults_recentResults_Contact_accounts;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetSearchResults_search_quickResults_recentResults_Contact_phones;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetSearchResults_search_quickResults_recentResults_Contact_emailAddresses;
}

export type GetSearchResults_search_quickResults_recentResults = GetSearchResults_search_quickResults_recentResults_Lead | GetSearchResults_search_quickResults_recentResults_Account | GetSearchResults_search_quickResults_recentResults_Contact;

export interface GetSearchResults_search_quickResults_leadResults_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetSearchResults_search_quickResults_leadResults_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetSearchResults_search_quickResults_leadResults_contacts_primaryEdge_node;
}

export interface GetSearchResults_search_quickResults_leadResults_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetSearchResults_search_quickResults_leadResults_contacts_primaryEdge | null;
}

export interface GetSearchResults_search_quickResults_leadResults_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetSearchResults_search_quickResults_leadResults_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetSearchResults_search_quickResults_leadResults_accounts_primaryEdge_node;
}

export interface GetSearchResults_search_quickResults_leadResults_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetSearchResults_search_quickResults_leadResults_accounts_primaryEdge | null;
}

export interface GetSearchResults_search_quickResults_leadResults_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetSearchResults_search_quickResults_leadResults_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: GetSearchResults_search_quickResults_leadResults_value_formattedValue;
}

export interface GetSearchResults_search_quickResults_leadResults {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead, with html encoded special characters
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  /**
   * The time this lead did or will become overdue
   */
  overdueTime: any | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetSearchResults_search_quickResults_leadResults_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetSearchResults_search_quickResults_leadResults_accounts;
  value: GetSearchResults_search_quickResults_leadResults_value | null;
}

export interface GetSearchResults_search_quickResults_accountResults_primaryContact {
  __typename: "Contact";
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetSearchResults_search_quickResults_accountResults_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetSearchResults_search_quickResults_accountResults_phones_primary {
  __typename: "Phone";
  value: GetSearchResults_search_quickResults_accountResults_phones_primary_value;
}

export interface GetSearchResults_search_quickResults_accountResults_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSearchResults_search_quickResults_accountResults_phones_primary | null;
}

export interface GetSearchResults_search_quickResults_accountResults_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  city: string | null;
  postalCode: string | null;
}

export interface GetSearchResults_search_quickResults_accountResults_postalAddresses_primary {
  __typename: "PostalAddress";
  value: GetSearchResults_search_quickResults_accountResults_postalAddresses_primary_value;
}

export interface GetSearchResults_search_quickResults_accountResults_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSearchResults_search_quickResults_accountResults_postalAddresses_primary | null;
}

export interface GetSearchResults_search_quickResults_accountResults {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The descriptive name of the Nutshell Contact, with special characters html encoded
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * The primary contact for this account
   */
  primaryContact: GetSearchResults_search_quickResults_accountResults_primaryContact | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetSearchResults_search_quickResults_accountResults_phones;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetSearchResults_search_quickResults_accountResults_postalAddresses;
}

export interface GetSearchResults_search_quickResults_contactResults_accounts_primary {
  __typename: "Account";
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetSearchResults_search_quickResults_contactResults_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetSearchResults_search_quickResults_contactResults_accounts_primary | null;
}

export interface GetSearchResults_search_quickResults_contactResults_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetSearchResults_search_quickResults_contactResults_phones_primary {
  __typename: "Phone";
  value: GetSearchResults_search_quickResults_contactResults_phones_primary_value;
}

export interface GetSearchResults_search_quickResults_contactResults_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSearchResults_search_quickResults_contactResults_phones_primary | null;
}

export interface GetSearchResults_search_quickResults_contactResults_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetSearchResults_search_quickResults_contactResults_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetSearchResults_search_quickResults_contactResults_emailAddresses_primary_value;
}

export interface GetSearchResults_search_quickResults_contactResults_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSearchResults_search_quickResults_contactResults_emailAddresses_primary | null;
}

export interface GetSearchResults_search_quickResults_contactResults {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The descriptive name of the Nutshell Contact, with special characters html encoded
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetSearchResults_search_quickResults_contactResults_accounts;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetSearchResults_search_quickResults_contactResults_phones;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetSearchResults_search_quickResults_contactResults_emailAddresses;
}

export interface GetSearchResults_search_quickResults {
  __typename: "SearchQuickResults";
  /**
   * A heterogeneous collection of the top search results items for the query.
   */
  topResults: GetSearchResults_search_quickResults_topResults[];
  /**
   * A heterogeneous collection of recently viewed items across all apps.
   */
  recentResults: GetSearchResults_search_quickResults_recentResults[];
  /**
   * A collection of lead results items for the query.
   */
  leadResults: GetSearchResults_search_quickResults_leadResults[];
  /**
   * A collection of account results items for the query.
   */
  accountResults: GetSearchResults_search_quickResults_accountResults[];
  /**
   * A collection of contact results items for the query.
   */
  contactResults: GetSearchResults_search_quickResults_contactResults[];
}

export interface GetSearchResults_search {
  __typename: "SearchResultItemConnection";
  /**
   * An opinionated object that is useful for our "search everything" UIs
   */
  quickResults: GetSearchResults_search_quickResults | null;
}

export interface GetSearchResults {
  /**
   * Perform a search across resources.
   */
  search: GetSearchResults_search | null;
}

export interface GetSearchResultsVariables {
  query: string;
  type?: EntityType | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SidebarCalendarActivitiesQuery
// ====================================================

export interface SidebarCalendarActivitiesQuery_myActivities_participants_ActivityExternalAttendee {
  __typename: "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the external attendee, "Unknown attendee" if not set
   */
  name: string;
}

export interface SidebarCalendarActivitiesQuery_myActivities_participants_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface SidebarCalendarActivitiesQuery_myActivities_participants_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface SidebarCalendarActivitiesQuery_myActivities_participants_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface SidebarCalendarActivitiesQuery_myActivities_participants_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export type SidebarCalendarActivitiesQuery_myActivities_participants = SidebarCalendarActivitiesQuery_myActivities_participants_ActivityExternalAttendee | SidebarCalendarActivitiesQuery_myActivities_participants_Contact | SidebarCalendarActivitiesQuery_myActivities_participants_User | SidebarCalendarActivitiesQuery_myActivities_participants_Account | SidebarCalendarActivitiesQuery_myActivities_participants_Lead;

export interface SidebarCalendarActivitiesQuery_myActivities {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * Canonical URL for an individual activity - launches a modal in this case
   */
  htmlUrl: string;
  /**
   * The DateTime that represents the start time of the Activity record
   */
  startTime: any;
  /**
   * The DateTime that represents the end time of the Activity record
   */
  endTime: any;
  /**
   * The boolean that represents whether or not the Activity has been logged (with
   * our without a message) for the purposes of completion/quota.
   */
  isLogged: boolean;
  /**
   * The boolean that represents whether or not the Activity represents an all day calendar event
   */
  isAllDay: boolean;
  /**
   * The boolean that represents whether or not the Activity is overdue.
   * Specifically, this means that the activity is not logged, and is in the past.
   */
  isOverdue: boolean;
  /**
   * Freeform text for public notes & agendas around the Nutshell Activity
   */
  agenda: string;
  /**
   * Whether the activity should show the new logging flow with video transcription and summary.
   */
  showTranscribeLoggingFlow: boolean;
  /**
   * The type of external service that the associated meeting belongs to
   */
  externalMeetingServiceType: ExternalServiceType | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: SidebarCalendarActivitiesQuery_myActivities_participants[];
}

export interface SidebarCalendarActivitiesQuery {
  /**
   * Returns a list of Nutshell Activities
   */
  myActivities: SidebarCalendarActivitiesQuery_myActivities[];
}

export interface SidebarCalendarActivitiesQueryVariables {
  dateMin: string;
  dateMax: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCsmInfo
// ====================================================

export interface GetCsmInfo_csmInfo {
  __typename: "CsmInfo";
  /**
   * The enum value of the csm, derived from their user id (nutshell_4)
   */
  csmType: CsmType;
  firstName: string;
  calendlyLink: string;
  emailAddress: string;
  funFact: string;
}

export interface GetCsmInfo {
  /**
   * Info about the Nutshell CSM for this instance
   */
  csmInfo: GetCsmInfo_csmInfo | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateSmartSequence
// ====================================================

export interface CreateSmartSequence_smartSequenceCreate_smartSequence {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface CreateSmartSequence_smartSequenceCreate {
  __typename: "SmartSequenceCreatePayload";
  /**
   * The newly created smart sequence
   */
  smartSequence: CreateSmartSequence_smartSequenceCreate_smartSequence;
}

export interface CreateSmartSequence {
  /**
   * Create a new draft smart sequence, seeded with a default start/end node graph.
   */
  smartSequenceCreate: CreateSmartSequence_smartSequenceCreate | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SmartSequenceActivate
// ====================================================

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The email template for this edition
   */
  emailTemplate: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_edition_emailTemplate | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigSendPageViewedNotification {
  __typename: "ActionConfigSendPageViewedNotification" | "ActionConfigSendEmail";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigAddTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigAddTags {
  __typename: "ActionConfigAddTags";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  tags: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigAddTags_tags[];
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigRemoveTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigRemoveTags {
  __typename: "ActionConfigRemoveTags";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The tags to remove.
   */
  tags: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigRemoveTags_tags[];
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigAddAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigAddAudiences {
  __typename: "ActionConfigAddAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigAddAudiences_audiences[];
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigRemoveAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigRemoveAudiences {
  __typename: "ActionConfigRemoveAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigRemoveAudiences_audiences[];
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigAddToDripSequence_dripSequence {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigAddToDripSequence {
  __typename: "ActionConfigAddToDripSequence";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The drip sequence to which the contact should be added.
   */
  dripSequence: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigAddToDripSequence_dripSequence;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule = SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_User | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_Team | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule;

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead {
  __typename: "ActionConfigCreateLead";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The stageset to which the lead should be added.
   */
  stageset: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_stageset;
  /**
   * The tags which should be added to the lead.
   */
  tags: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_tags[];
  /**
   * The assignee for the lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule | null;
}

export type SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config = SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigSendPageViewedNotification | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigAddTags | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigRemoveTags | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigAddAudiences | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigRemoveAudiences | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigAddToDripSequence | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead;

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions {
  __typename: "Action";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * The configuration for this action.
   */
  config: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions_config;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_trigger {
  __typename: "Trigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of event which activates this trigger.
   */
  type: TriggerType;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigTag_tagEntities {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
  /**
   * The tags this condition matches.
   */
  tagEntities: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigTag_tagEntities[];
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigSourceEntity {
  __typename: "ConditionConfigSourceEntity";
  sourceEntityId: string | null;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  url: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl_url;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed {
  __typename: "ConditionConfigPageViewed";
  maUrlId: string | null;
  maUrl: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl | null;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigFormSubmission_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigFormSubmission {
  __typename: "ConditionConfigFormSubmission";
  formId: string | null;
  form: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigFormSubmission_form | null;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigDateTimeBetween {
  __typename: "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The earlier date to test if an entity date time is between 2 dates.
   */
  startDate: any;
  /**
   * The later date to test if an entity date time is between 2 dates.
   */
  endDate: any;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigStrings {
  __typename: "EntityFilterFieldConfigStrings";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substrings to search for.
   */
  stringsContain: string;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigInteger {
  __typename: "EntityFilterFieldConfigInteger";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this integer field.
   */
  integerValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  integerComparator: Comparator;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigPhone {
  __typename: "EntityFilterFieldConfigPhone";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string of digits to match on when filtering on phone numbers.
   */
  startsWith: string;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter = SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigDateTimeBetween | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigStrings | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigInteger | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigPhone | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter;
}

export type SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config = SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigAudience | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigTag | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigLink | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigSourceEntity | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigFormSubmission | SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter;

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions {
  __typename: "Condition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this condition relative to its siblings.
   */
  position: number;
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions_config;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates {
  __typename: "Predicate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this predicate relative to its siblings.
   */
  position: number;
  /**
   * The trigger that will initiate execution of this predicate.
   */
  trigger: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_trigger;
  /**
   * The conditions that must be true for this predicate to activate an automation.
   */
  conditions: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates_conditions[];
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation {
  __typename: "Automation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Actions that will be taken when this automation is activated.
   */
  actions: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_actions[];
  /**
   * A list of predicates which can activate this automation.
   */
  predicates: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation_predicates[];
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_recipientTracking_emailEngagement {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_recipientTracking {
  __typename: "SmartSequenceNodeRecipientTracking";
  /**
   * Human-readable recipient count for the node banner (e.g. "24 recipients waiting").
   */
  recipientSummary: string | null;
  /**
   * Email delivery and engagement stats for send-email nodes.
   */
  emailEngagement: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_recipientTracking_emailEngagement | null;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes {
  __typename: "SmartSequenceNode";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: SmartSequenceNodeType;
  parentNodeId: string | null;
  parentBranch: SmartSequenceParentBranch | null;
  delay: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_delay | null;
  edition: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_edition | null;
  automation: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_automation | null;
  /**
   * Recipient progression and engagement display data for the canvas node.
   */
  recipientTracking: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes_recipientTracking | null;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence_edges {
  __typename: "SmartSequenceEdge";
  id: string;
  /**
   * The parent node API id.
   */
  source: string;
  /**
   * The child node API id.
   */
  target: string;
  /**
   * Decision branch label for this edge, if applicable.
   */
  branch: SmartSequenceParentBranch | null;
  /**
   * Human-readable count of recipients that entered this decision branch.
   */
  recipientSummary: string | null;
}

export interface SmartSequenceActivate_dripSequenceActivate_smartSequence {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Time of the last campaign status change. For example, if a customer activated
   * this sequence and its still active, this would be the time the sequence was
   * activated. Once the campaign status is changed (paused, retired, etc) this
   * would reflect that new time
   */
  lastStatusChangeTime: any | null;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  nodes: SmartSequenceActivate_dripSequenceActivate_smartSequence_nodes[];
  edges: SmartSequenceActivate_dripSequenceActivate_smartSequence_edges[];
}

export interface SmartSequenceActivate_dripSequenceActivate {
  __typename: "DripSequenceActivatePayload";
  /**
   * The newly activated smart sequence, when the campaign is a smart sequence
   */
  smartSequence: SmartSequenceActivate_dripSequenceActivate_smartSequence | null;
}

export interface SmartSequenceActivate {
  /**
   * Activate a new email marketing drip sequence
   */
  dripSequenceActivate: SmartSequenceActivate_dripSequenceActivate | null;
}

export interface SmartSequenceActivateVariables {
  input: DripSequenceActivateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SmartSequenceCampaignUpdate
// ====================================================

export interface SmartSequenceCampaignUpdate_campaignUpdate_smartSequence_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
}

export interface SmartSequenceCampaignUpdate_campaignUpdate_smartSequence_from_emailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface SmartSequenceCampaignUpdate_campaignUpdate_smartSequence_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface SmartSequenceCampaignUpdate_campaignUpdate_smartSequence_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: SmartSequenceCampaignUpdate_campaignUpdate_smartSequence_from_emailAddress;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: SmartSequenceCampaignUpdate_campaignUpdate_smartSequence_from_fromDomain | null;
}

export interface SmartSequenceCampaignUpdate_campaignUpdate_smartSequence {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * Should messages only be sent during business hours.
   */
  isBusinessHoursOnly: boolean;
  useUtmParameters: boolean;
  utmParameters: SmartSequenceCampaignUpdate_campaignUpdate_smartSequence_utmParameters;
  /**
   * The address to send this edition from
   */
  from: SmartSequenceCampaignUpdate_campaignUpdate_smartSequence_from | null;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * When a lead is closed, should drip sequences stop?
   */
  isStopOnLeadClose: boolean;
}

export interface SmartSequenceCampaignUpdate_campaignUpdate {
  __typename: "CampaignUpdatePayload";
  /**
   * The updated smart sequence, when the campaign is a smart sequence
   */
  smartSequence: SmartSequenceCampaignUpdate_campaignUpdate_smartSequence | null;
}

export interface SmartSequenceCampaignUpdate {
  /**
   * Save the template data for an email marketing campaign
   */
  campaignUpdate: SmartSequenceCampaignUpdate_campaignUpdate | null;
}

export interface SmartSequenceCampaignUpdateVariables {
  input: CampaignUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SmartSequenceCancel
// ====================================================

export interface SmartSequenceCancel_dripSequenceCancel_smartSequence_nodes_recipientTracking_emailEngagement {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
}

export interface SmartSequenceCancel_dripSequenceCancel_smartSequence_nodes_recipientTracking {
  __typename: "SmartSequenceNodeRecipientTracking";
  /**
   * Human-readable recipient count for the node banner (e.g. "24 recipients waiting").
   */
  recipientSummary: string | null;
  /**
   * Email delivery and engagement stats for send-email nodes.
   */
  emailEngagement: SmartSequenceCancel_dripSequenceCancel_smartSequence_nodes_recipientTracking_emailEngagement | null;
}

export interface SmartSequenceCancel_dripSequenceCancel_smartSequence_nodes {
  __typename: "SmartSequenceNode";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Recipient progression and engagement display data for the canvas node.
   */
  recipientTracking: SmartSequenceCancel_dripSequenceCancel_smartSequence_nodes_recipientTracking | null;
}

export interface SmartSequenceCancel_dripSequenceCancel_smartSequence {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Time of the last campaign status change. For example, if a customer activated
   * this sequence and its still active, this would be the time the sequence was
   * activated. Once the campaign status is changed (paused, retired, etc) this
   * would reflect that new time
   */
  lastStatusChangeTime: any | null;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  nodes: SmartSequenceCancel_dripSequenceCancel_smartSequence_nodes[];
}

export interface SmartSequenceCancel_dripSequenceCancel {
  __typename: "DripSequenceCancelPayload";
  /**
   * The canceled smart sequence, when the campaign is a smart sequence
   */
  smartSequence: SmartSequenceCancel_dripSequenceCancel_smartSequence | null;
}

export interface SmartSequenceCancel {
  /**
   * Cancel an email marketing drip sequence
   */
  dripSequenceCancel: SmartSequenceCancel_dripSequenceCancel | null;
}

export interface SmartSequenceCancelVariables {
  input: DripSequenceCancelInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SmartSequenceCreateFromTemplate
// ====================================================

export interface SmartSequenceCreateFromTemplate_smartSequenceCreateFromTemplate_smartSequence {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SmartSequenceCreateFromTemplate_smartSequenceCreateFromTemplate {
  __typename: "SmartSequenceCreateFromTemplatePayload";
  /**
   * The newly created smart sequence.
   */
  smartSequence: SmartSequenceCreateFromTemplate_smartSequenceCreateFromTemplate_smartSequence;
}

export interface SmartSequenceCreateFromTemplate {
  /**
   * Create a new draft smart sequence pre-populated from a code-driven template.
   */
  smartSequenceCreateFromTemplate: SmartSequenceCreateFromTemplate_smartSequenceCreateFromTemplate;
}

export interface SmartSequenceCreateFromTemplateVariables {
  input: SmartSequenceCreateFromTemplateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SmartSequenceDelete
// ====================================================

export interface SmartSequenceDelete_campaignDelete_campaign {
  __typename: "Campaign" | "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SmartSequenceDelete_campaignDelete {
  __typename: "CampaignDeletePayload";
  /**
   * The campaign
   */
  campaign: SmartSequenceDelete_campaignDelete_campaign;
}

export interface SmartSequenceDelete {
  /**
   * Delete a campaign and associated content.
   */
  campaignDelete: SmartSequenceDelete_campaignDelete | null;
}

export interface SmartSequenceDeleteVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SmartSequenceDuplicate
// ====================================================

export interface SmartSequenceDuplicate_smartSequenceDuplicate_smartSequence {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SmartSequenceDuplicate_smartSequenceDuplicate {
  __typename: "SmartSequenceDuplicatePayload";
  /**
   * The duplicate smart sequence.
   */
  smartSequence: SmartSequenceDuplicate_smartSequenceDuplicate_smartSequence;
}

export interface SmartSequenceDuplicate {
  /**
   * Duplicates a smart sequence along with all its nodes, configurations, automations, emails, etc.
   */
  smartSequenceDuplicate: SmartSequenceDuplicate_smartSequenceDuplicate;
}

export interface SmartSequenceDuplicateVariables {
  input: SmartSequenceDuplicateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SmartSequenceGoalSet
// ====================================================

export interface SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_conditions_config_ConditionConfigSourceEntity {
  __typename: "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_conditions_config_ConditionConfigEntityFilter_filter = SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export interface SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_conditions_config = SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_conditions_config_ConditionConfigSourceEntity | SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_conditions_config_ConditionConfigEntityFilter | SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_conditions_config_ConditionConfigLink | SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_conditions_config_ConditionConfigTag | SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_conditions_config_ConditionConfigAudience;

export interface SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_conditions_config;
}

export interface SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_action_config_ActionConfigRemoveTags {
  __typename: "ActionConfigRemoveTags" | "ActionConfigSendPageViewedNotification" | "ActionConfigAddToDripSequence" | "ActionConfigCreateLead" | "ActionConfigSendEmail";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
}

export interface SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_action_config_ActionConfigAddTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_action_config_ActionConfigAddTags {
  __typename: "ActionConfigAddTags";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  tags: SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_action_config_ActionConfigAddTags_tags[];
}

export interface SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_action_config_ActionConfigAddAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_action_config_ActionConfigAddAudiences {
  __typename: "ActionConfigAddAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_action_config_ActionConfigAddAudiences_audiences[];
}

export interface SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_action_config_ActionConfigRemoveAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_action_config_ActionConfigRemoveAudiences {
  __typename: "ActionConfigRemoveAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_action_config_ActionConfigRemoveAudiences_audiences[];
}

export type SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_action_config = SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_action_config_ActionConfigRemoveTags | SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_action_config_ActionConfigAddTags | SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_action_config_ActionConfigAddAudiences | SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_action_config_ActionConfigRemoveAudiences;

export interface SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_action {
  __typename: "Action";
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * Human readable title of this action
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this action. This is essentially just the
   * stringified version of the action’s conditions, but because a action can have
   * multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The configuration for this action.
   */
  config: SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_action_config;
}

export interface SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Calculated goal type based on conditions. This is not saved in the database
   */
  type: DripSequenceGoalType;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this goal. This is essentially just the stringified
   * version of the goal’s conditions, but because a goal can have multiple
   * conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * A list of conditions which must be true to activate this goal.
   */
  conditions: SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_conditions[];
  /**
   * The optional action (next step in this context) that will run when this goal is met
   */
  action: SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal_action | null;
}

export interface SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The newly created Nutshell goal
   */
  goal: SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence_goal | null;
}

export interface SmartSequenceGoalSet_dripSequenceGoalSet {
  __typename: "DripSequenceGoalSetPayload";
  /**
   * The updated smart sequence, when the campaign is a smart sequence
   */
  smartSequence: SmartSequenceGoalSet_dripSequenceGoalSet_smartSequence | null;
}

export interface SmartSequenceGoalSet {
  /**
   * Sets a dripSequenceGoal for a given drip sequence.
   */
  dripSequenceGoalSet: SmartSequenceGoalSet_dripSequenceGoalSet;
}

export interface SmartSequenceGoalSetVariables {
  input: DripSequenceGoalSetInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SmartSequenceGraphUpdate
// ====================================================

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The email template for this edition
   */
  emailTemplate: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_edition_emailTemplate | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigSendPageViewedNotification {
  __typename: "ActionConfigSendPageViewedNotification" | "ActionConfigSendEmail";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigAddTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigAddTags {
  __typename: "ActionConfigAddTags";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  tags: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigAddTags_tags[];
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigRemoveTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigRemoveTags {
  __typename: "ActionConfigRemoveTags";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The tags to remove.
   */
  tags: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigRemoveTags_tags[];
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigAddAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigAddAudiences {
  __typename: "ActionConfigAddAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigAddAudiences_audiences[];
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigRemoveAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigRemoveAudiences {
  __typename: "ActionConfigRemoveAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigRemoveAudiences_audiences[];
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigAddToDripSequence_dripSequence {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigAddToDripSequence {
  __typename: "ActionConfigAddToDripSequence";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The drip sequence to which the contact should be added.
   */
  dripSequence: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigAddToDripSequence_dripSequence;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule = SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_User | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_Team | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule;

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead {
  __typename: "ActionConfigCreateLead";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The stageset to which the lead should be added.
   */
  stageset: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_stageset;
  /**
   * The tags which should be added to the lead.
   */
  tags: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_tags[];
  /**
   * The assignee for the lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule | null;
}

export type SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config = SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigSendPageViewedNotification | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigAddTags | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigRemoveTags | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigAddAudiences | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigRemoveAudiences | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigAddToDripSequence | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead;

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions {
  __typename: "Action";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * The configuration for this action.
   */
  config: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions_config;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_trigger {
  __typename: "Trigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of event which activates this trigger.
   */
  type: TriggerType;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigTag_tagEntities {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
  /**
   * The tags this condition matches.
   */
  tagEntities: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigTag_tagEntities[];
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigSourceEntity {
  __typename: "ConditionConfigSourceEntity";
  sourceEntityId: string | null;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  url: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl_url;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed {
  __typename: "ConditionConfigPageViewed";
  maUrlId: string | null;
  maUrl: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl | null;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigFormSubmission_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigFormSubmission {
  __typename: "ConditionConfigFormSubmission";
  formId: string | null;
  form: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigFormSubmission_form | null;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigDateTimeBetween {
  __typename: "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The earlier date to test if an entity date time is between 2 dates.
   */
  startDate: any;
  /**
   * The later date to test if an entity date time is between 2 dates.
   */
  endDate: any;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigStrings {
  __typename: "EntityFilterFieldConfigStrings";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substrings to search for.
   */
  stringsContain: string;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigInteger {
  __typename: "EntityFilterFieldConfigInteger";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this integer field.
   */
  integerValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  integerComparator: Comparator;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigPhone {
  __typename: "EntityFilterFieldConfigPhone";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string of digits to match on when filtering on phone numbers.
   */
  startsWith: string;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter = SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigDateTimeBetween | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigStrings | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigInteger | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigPhone | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter;
}

export type SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config = SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigAudience | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigTag | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigLink | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigSourceEntity | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigFormSubmission | SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter;

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions {
  __typename: "Condition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this condition relative to its siblings.
   */
  position: number;
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions_config;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates {
  __typename: "Predicate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this predicate relative to its siblings.
   */
  position: number;
  /**
   * The trigger that will initiate execution of this predicate.
   */
  trigger: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_trigger;
  /**
   * The conditions that must be true for this predicate to activate an automation.
   */
  conditions: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates_conditions[];
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation {
  __typename: "Automation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Actions that will be taken when this automation is activated.
   */
  actions: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_actions[];
  /**
   * A list of predicates which can activate this automation.
   */
  predicates: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation_predicates[];
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_recipientTracking_emailEngagement {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_recipientTracking {
  __typename: "SmartSequenceNodeRecipientTracking";
  /**
   * Human-readable recipient count for the node banner (e.g. "24 recipients waiting").
   */
  recipientSummary: string | null;
  /**
   * Email delivery and engagement stats for send-email nodes.
   */
  emailEngagement: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_recipientTracking_emailEngagement | null;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes {
  __typename: "SmartSequenceNode";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: SmartSequenceNodeType;
  parentNodeId: string | null;
  parentBranch: SmartSequenceParentBranch | null;
  delay: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_delay | null;
  edition: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_edition | null;
  automation: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_automation | null;
  /**
   * Recipient progression and engagement display data for the canvas node.
   */
  recipientTracking: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes_recipientTracking | null;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_edges {
  __typename: "SmartSequenceEdge";
  id: string;
  /**
   * The parent node API id.
   */
  source: string;
  /**
   * The child node API id.
   */
  target: string;
  /**
   * Decision branch label for this edge, if applicable.
   */
  branch: SmartSequenceParentBranch | null;
  /**
   * Human-readable count of recipients that entered this decision branch.
   */
  recipientSummary: string | null;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  nodes: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_nodes[];
  edges: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence_edges[];
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate_createdNodes {
  __typename: "SmartSequenceCreatedNode";
  /**
   * The clientKey supplied in the mutation input for this create.
   */
  clientKey: string;
  /**
   * The API id assigned to the newly created node.
   */
  nodeId: string;
}

export interface SmartSequenceGraphUpdate_smartSequenceGraphUpdate {
  __typename: "SmartSequenceGraphUpdatePayload";
  /**
   * The smart sequence after the graph update.
   */
  smartSequence: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_smartSequence;
  /**
   * Nodes created in this update, mapping each clientKey to its new nodeId.
   */
  createdNodes: SmartSequenceGraphUpdate_smartSequenceGraphUpdate_createdNodes[];
}

export interface SmartSequenceGraphUpdate {
  /**
   * Replace the node graph for a smart sequence. Omitted existing nodes are
   * soft-deleted. New nodes use a null id and a clientKey.
   */
  smartSequenceGraphUpdate: SmartSequenceGraphUpdate_smartSequenceGraphUpdate;
}

export interface SmartSequenceGraphUpdateVariables {
  input: SmartSequenceGraphUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SmartSequencePause
// ====================================================

export interface SmartSequencePause_dripSequencePause_smartSequence {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Time of the last campaign status change. For example, if a customer activated
   * this sequence and its still active, this would be the time the sequence was
   * activated. Once the campaign status is changed (paused, retired, etc) this
   * would reflect that new time
   */
  lastStatusChangeTime: any | null;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
}

export interface SmartSequencePause_dripSequencePause {
  __typename: "DripSequencePausePayload";
  /**
   * The paused smart sequence, when the campaign is a smart sequence
   */
  smartSequence: SmartSequencePause_dripSequencePause_smartSequence | null;
}

export interface SmartSequencePause {
  /**
   * Pause an email marketing drip sequence
   */
  dripSequencePause: SmartSequencePause_dripSequencePause | null;
}

export interface SmartSequencePauseVariables {
  input: DripSequencePauseInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SmartSequenceRestore
// ====================================================

export interface SmartSequenceRestore_campaignRestore_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SmartSequenceRestore_campaignRestore {
  __typename: "CampaignRestorePayload";
  /**
   * The campaign
   */
  campaign: SmartSequenceRestore_campaignRestore_campaign;
}

export interface SmartSequenceRestore {
  /**
   * Restore an email campaign
   */
  campaignRestore: SmartSequenceRestore_campaignRestore | null;
}

export interface SmartSequenceRestoreVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SmartSequenceRetire
// ====================================================

export interface SmartSequenceRetire_dripSequenceRetire_smartSequence {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Time of the last campaign status change. For example, if a customer activated
   * this sequence and its still active, this would be the time the sequence was
   * activated. Once the campaign status is changed (paused, retired, etc) this
   * would reflect that new time
   */
  lastStatusChangeTime: any | null;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
}

export interface SmartSequenceRetire_dripSequenceRetire {
  __typename: "DripSequenceRetirePayload";
  /**
   * The retired smart sequence, when the campaign is a smart sequence
   */
  smartSequence: SmartSequenceRetire_dripSequenceRetire_smartSequence | null;
}

export interface SmartSequenceRetire {
  /**
   * Retire an email marketing drip sequence
   */
  dripSequenceRetire: SmartSequenceRetire_dripSequenceRetire | null;
}

export interface SmartSequenceRetireVariables {
  input: DripSequenceRetireInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SmartSequenceStartTriggerAdd
// ====================================================

export interface SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence_startTriggers_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter = SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence_startTriggers_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence_startTriggers_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence_startTriggers_conditions_config = SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence_startTriggers_conditions_config_ConditionConfigLink | SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter | SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence_startTriggers_conditions_config_ConditionConfigTag | SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence_startTriggers_conditions_config_ConditionConfigAudience;

export interface SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence_startTriggers_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence_startTriggers_conditions_config;
}

export interface SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence_startTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of startTrigger
   */
  type: StartTriggerType;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * A list of conditions which must be true to activate this startTrigger.
   */
  conditions: SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence_startTriggers_conditions[];
}

export interface SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * When a lead is closed, should drip sequences stop?
   */
  isStopOnLeadClose: boolean;
  /**
   * When a person is removed from an audience, should drip sequences stop?
   */
  isStopOnRemovedFromAudience: boolean;
  /**
   * The start triggers for the smart sequence.
   */
  startTriggers: SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence_startTriggers[];
}

export interface SmartSequenceStartTriggerAdd_startTriggerAdd {
  __typename: "StartTriggerAddPayload";
  /**
   * The updated smart sequence
   */
  smartSequence: SmartSequenceStartTriggerAdd_startTriggerAdd_smartSequence;
}

export interface SmartSequenceStartTriggerAdd {
  /**
   * Adds a start trigger to a smart sequence.
   */
  startTriggerAdd: SmartSequenceStartTriggerAdd_startTriggerAdd;
}

export interface SmartSequenceStartTriggerAddVariables {
  input: StartTriggerAddInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SmartSequenceStartTriggerDelete
// ====================================================

export interface SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence_startTriggers_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter = SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence_startTriggers_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence_startTriggers_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence_startTriggers_conditions_config = SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence_startTriggers_conditions_config_ConditionConfigLink | SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter | SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence_startTriggers_conditions_config_ConditionConfigTag | SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence_startTriggers_conditions_config_ConditionConfigAudience;

export interface SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence_startTriggers_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence_startTriggers_conditions_config;
}

export interface SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence_startTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of startTrigger
   */
  type: StartTriggerType;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * A list of conditions which must be true to activate this startTrigger.
   */
  conditions: SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence_startTriggers_conditions[];
}

export interface SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * When a lead is closed, should drip sequences stop?
   */
  isStopOnLeadClose: boolean;
  /**
   * When a person is removed from an audience, should drip sequences stop?
   */
  isStopOnRemovedFromAudience: boolean;
  /**
   * The start triggers for the smart sequence.
   */
  startTriggers: SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence_startTriggers[];
}

export interface SmartSequenceStartTriggerDelete_startTriggerDelete {
  __typename: "StartTriggerDeletePayload";
  /**
   * The updated smart sequence
   */
  smartSequence: SmartSequenceStartTriggerDelete_startTriggerDelete_smartSequence;
}

export interface SmartSequenceStartTriggerDelete {
  /**
   * Deletes a start trigger from a smart sequence.
   */
  startTriggerDelete: SmartSequenceStartTriggerDelete_startTriggerDelete;
}

export interface SmartSequenceStartTriggerDeleteVariables {
  input: StartTriggerDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SmartSequenceStartTriggerUpdate
// ====================================================

export interface SmartSequenceStartTriggerUpdate_startTriggerUpdate_startTrigger_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface SmartSequenceStartTriggerUpdate_startTriggerUpdate_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface SmartSequenceStartTriggerUpdate_startTriggerUpdate_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface SmartSequenceStartTriggerUpdate_startTriggerUpdate_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type SmartSequenceStartTriggerUpdate_startTriggerUpdate_startTrigger_conditions_config_ConditionConfigEntityFilter_filter = SmartSequenceStartTriggerUpdate_startTriggerUpdate_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | SmartSequenceStartTriggerUpdate_startTriggerUpdate_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | SmartSequenceStartTriggerUpdate_startTriggerUpdate_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface SmartSequenceStartTriggerUpdate_startTriggerUpdate_startTrigger_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: SmartSequenceStartTriggerUpdate_startTriggerUpdate_startTrigger_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface SmartSequenceStartTriggerUpdate_startTriggerUpdate_startTrigger_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface SmartSequenceStartTriggerUpdate_startTriggerUpdate_startTrigger_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type SmartSequenceStartTriggerUpdate_startTriggerUpdate_startTrigger_conditions_config = SmartSequenceStartTriggerUpdate_startTriggerUpdate_startTrigger_conditions_config_ConditionConfigLink | SmartSequenceStartTriggerUpdate_startTriggerUpdate_startTrigger_conditions_config_ConditionConfigEntityFilter | SmartSequenceStartTriggerUpdate_startTriggerUpdate_startTrigger_conditions_config_ConditionConfigTag | SmartSequenceStartTriggerUpdate_startTriggerUpdate_startTrigger_conditions_config_ConditionConfigAudience;

export interface SmartSequenceStartTriggerUpdate_startTriggerUpdate_startTrigger_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: SmartSequenceStartTriggerUpdate_startTriggerUpdate_startTrigger_conditions_config;
}

export interface SmartSequenceStartTriggerUpdate_startTriggerUpdate_startTrigger {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of startTrigger
   */
  type: StartTriggerType;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * A list of conditions which must be true to activate this startTrigger.
   */
  conditions: SmartSequenceStartTriggerUpdate_startTriggerUpdate_startTrigger_conditions[];
}

export interface SmartSequenceStartTriggerUpdate_startTriggerUpdate_smartSequence {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * When a lead is closed, should drip sequences stop?
   */
  isStopOnLeadClose: boolean;
  /**
   * When a person is removed from an audience, should drip sequences stop?
   */
  isStopOnRemovedFromAudience: boolean;
}

export interface SmartSequenceStartTriggerUpdate_startTriggerUpdate {
  __typename: "StartTriggerUpdatePayload";
  /**
   * The updated start trigger
   */
  startTrigger: SmartSequenceStartTriggerUpdate_startTriggerUpdate_startTrigger;
  /**
   * The updated smart sequence
   */
  smartSequence: SmartSequenceStartTriggerUpdate_startTriggerUpdate_smartSequence;
}

export interface SmartSequenceStartTriggerUpdate {
  /**
   * Updates a start trigger on a smart sequence.
   */
  startTriggerUpdate: SmartSequenceStartTriggerUpdate_startTriggerUpdate;
}

export interface SmartSequenceStartTriggerUpdateVariables {
  input: StartTriggerUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SmartSequenceUnpause
// ====================================================

export interface SmartSequenceUnpause_dripSequenceUnpause_smartSequence {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Time of the last campaign status change. For example, if a customer activated
   * this sequence and its still active, this would be the time the sequence was
   * activated. Once the campaign status is changed (paused, retired, etc) this
   * would reflect that new time
   */
  lastStatusChangeTime: any | null;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
}

export interface SmartSequenceUnpause_dripSequenceUnpause {
  __typename: "DripSequenceUnpausePayload";
  /**
   * The unpaused smart sequence, when the campaign is a smart sequence
   */
  smartSequence: SmartSequenceUnpause_dripSequenceUnpause_smartSequence | null;
}

export interface SmartSequenceUnpause {
  /**
   * Unpause an email marketing drip sequence
   */
  dripSequenceUnpause: SmartSequenceUnpause_dripSequenceUnpause | null;
}

export interface SmartSequenceUnpauseVariables {
  input: DripSequenceUnpauseInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetFormsForSmartSequence
// ====================================================

export interface GetFormsForSmartSequence_forms_pageInfo {
  __typename: "PageInfo";
  endCursor: string | null;
  hasNextPage: boolean;
}

export interface GetFormsForSmartSequence_forms_edges_node {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetFormsForSmartSequence_forms_edges {
  __typename: "FormsEdge";
  node: GetFormsForSmartSequence_forms_edges_node;
}

export interface GetFormsForSmartSequence_forms {
  __typename: "FormsConnection";
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetFormsForSmartSequence_forms_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetFormsForSmartSequence_forms_edges[];
}

export interface GetFormsForSmartSequence {
  /**
   * Returns a connection of Nutshell Web Forms
   */
  forms: GetFormsForSmartSequence_forms;
}

export interface GetFormsForSmartSequenceVariables {
  first: number;
  after?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMaUrlsForSmartSequence
// ====================================================

export interface GetMaUrlsForSmartSequence_maUrls_pageInfo {
  __typename: "PageInfo";
  endCursor: string | null;
  hasNextPage: boolean;
}

export interface GetMaUrlsForSmartSequence_maUrls_edges_node_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetMaUrlsForSmartSequence_maUrls_edges_node {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  url: GetMaUrlsForSmartSequence_maUrls_edges_node_url;
}

export interface GetMaUrlsForSmartSequence_maUrls_edges {
  __typename: "MaUrlsEdge";
  node: GetMaUrlsForSmartSequence_maUrls_edges_node;
}

export interface GetMaUrlsForSmartSequence_maUrls {
  __typename: "MaUrlsConnection";
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetMaUrlsForSmartSequence_maUrls_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetMaUrlsForSmartSequence_maUrls_edges[];
}

export interface GetMaUrlsForSmartSequence {
  /**
   * Returns a paging connection of non-deleted marketing automation URLs.
   */
  maUrls: GetMaUrlsForSmartSequence_maUrls;
}

export interface GetMaUrlsForSmartSequenceVariables {
  first: number;
  after?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSmartSequenceEditionLinks
// ====================================================

export interface GetSmartSequenceEditionLinks_smartSequence_editions_edges_node_emailTemplate_links {
  __typename: "EmailTemplateLink";
  link: string;
}

export interface GetSmartSequenceEditionLinks_smartSequence_editions_edges_node_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * All links in this email template
   */
  links: GetSmartSequenceEditionLinks_smartSequence_editions_edges_node_emailTemplate_links[];
}

export interface GetSmartSequenceEditionLinks_smartSequence_editions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetSmartSequenceEditionLinks_smartSequence_editions_edges_node_emailTemplate | null;
}

export interface GetSmartSequenceEditionLinks_smartSequence_editions_edges {
  __typename: "EditionsEdge";
  node: GetSmartSequenceEditionLinks_smartSequence_editions_edges_node;
}

export interface GetSmartSequenceEditionLinks_smartSequence_editions {
  __typename: "EditionsConnection";
  /**
   * A list of edges.
   */
  edges: GetSmartSequenceEditionLinks_smartSequence_editions_edges[];
}

export interface GetSmartSequenceEditionLinks_smartSequence {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  editions: GetSmartSequenceEditionLinks_smartSequence_editions;
}

export interface GetSmartSequenceEditionLinks {
  /**
   * Returns a smart sequence by ID.
   */
  smartSequence: GetSmartSequenceEditionLinks_smartSequence | null;
}

export interface GetSmartSequenceEditionLinksVariables {
  smartSequenceId: string;
  limit: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSmartSequenceEditions
// ====================================================

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: GetSmartSequenceEditions_smartSequence_editions_edges_node_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: GetSmartSequenceEditions_smartSequence_editions_edges_node_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: GetSmartSequenceEditions_smartSequence_editions_edges_node_campaign_nextSendingEdition | null;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: GetSmartSequenceEditions_smartSequence_editions_edges_node_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: GetSmartSequenceEditions_smartSequence_editions_edges_node_emailTemplate_links[];
  name: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: GetSmartSequenceEditions_smartSequence_editions_edges_node_comparisonEdition_emailTemplate_links_url | null;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: GetSmartSequenceEditions_smartSequence_editions_edges_node_comparisonEdition_emailTemplate_links[];
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: GetSmartSequenceEditions_smartSequence_editions_edges_node_comparisonEdition_emailTemplate | null;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetSmartSequenceEditions_smartSequence_editions_edges_node_comparison_winnerEdition_emailTemplate | null;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: GetSmartSequenceEditions_smartSequence_editions_edges_node_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: GetSmartSequenceEditions_smartSequence_editions_edges_node_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: GetSmartSequenceEditions_smartSequence_editions_edges_node_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: GetSmartSequenceEditions_smartSequence_editions_edges_node_comparison_winningEdition | null;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: GetSmartSequenceEditions_smartSequence_editions_edges_node_audience_fromSavedFilter_count;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetSmartSequenceEditions_smartSequence_editions_edges_node_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: GetSmartSequenceEditions_smartSequence_editions_edges_node_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: GetSmartSequenceEditions_smartSequence_editions_edges_node_audience_fromSavedFilter | null;
  membershipStats: GetSmartSequenceEditions_smartSequence_editions_edges_node_audience_membershipStats;
  smsMembershipStats: GetSmartSequenceEditions_smartSequence_editions_edges_node_audience_smsMembershipStats;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: GetSmartSequenceEditions_smartSequence_editions_edges_node_from_emailAddress;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: GetSmartSequenceEditions_smartSequence_editions_edges_node_from_fromDomain | null;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_gateError {
  __typename: "GateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity = GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Account | GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges_node;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions_edges[];
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: GetSmartSequenceEditions_smartSequence_editions_edges_node_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetSmartSequenceEditions_smartSequence_editions_edges_node_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: GetSmartSequenceEditions_smartSequence_editions_edges_node_emailTemplate | null;
  engagementStats: GetSmartSequenceEditions_smartSequence_editions_edges_node_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: GetSmartSequenceEditions_smartSequence_editions_edges_node_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: GetSmartSequenceEditions_smartSequence_editions_edges_node_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: GetSmartSequenceEditions_smartSequence_editions_edges_node_audience | null;
  /**
   * The address to send this edition from
   */
  from: GetSmartSequenceEditions_smartSequence_editions_edges_node_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: GetSmartSequenceEditions_smartSequence_editions_edges_node_delay | null;
  /**
   * The number of emails sent for this edition
   */
  numSentEmails: number;
  /**
   * The custom click domain that this edition will use to track links, if there is one
   */
  customClickDomain: GetSmartSequenceEditions_smartSequence_editions_edges_node_customClickDomain | null;
  utmParameters: GetSmartSequenceEditions_smartSequence_editions_edges_node_utmParameters;
  defaultUtmParameters: GetSmartSequenceEditions_smartSequence_editions_edges_node_defaultUtmParameters;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  useUtmParameters: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: GetSmartSequenceEditions_smartSequence_editions_edges_node_gateError | null;
  /**
   * Boolean indicating if the edition is using a web font.
   */
  hasWebFonts: boolean;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: GetSmartSequenceEditions_smartSequence_editions_edges_node_queuedDripProgressions | null;
  /**
   * The maximum number of recipients this edition can send to, if DMARC is not
   * fully configured. This is only relevant for non-drip sequence editions.
   */
  recipientLimitForDeliverability: number | null;
}

export interface GetSmartSequenceEditions_smartSequence_editions_edges {
  __typename: "EditionsEdge";
  cursor: string;
  node: GetSmartSequenceEditions_smartSequence_editions_edges_node;
}

export interface GetSmartSequenceEditions_smartSequence_editions {
  __typename: "EditionsConnection";
  /**
   * A list of edges.
   */
  edges: GetSmartSequenceEditions_smartSequence_editions_edges[];
}

export interface GetSmartSequenceEditions_smartSequence {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  editions: GetSmartSequenceEditions_smartSequence_editions;
}

export interface GetSmartSequenceEditions {
  /**
   * Returns a smart sequence by ID.
   */
  smartSequence: GetSmartSequenceEditions_smartSequence | null;
}

export interface GetSmartSequenceEditionsVariables {
  limit: number;
  smartSequenceId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSmartSequenceGraph
// ====================================================

export interface GetSmartSequenceGraph_smartSequence_nodes_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetSmartSequenceGraph_smartSequence_nodes_edition_emailTemplate | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigSendPageViewedNotification {
  __typename: "ActionConfigSendPageViewedNotification" | "ActionConfigSendEmail";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigAddTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigAddTags {
  __typename: "ActionConfigAddTags";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  tags: GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigAddTags_tags[];
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigRemoveTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigRemoveTags {
  __typename: "ActionConfigRemoveTags";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The tags to remove.
   */
  tags: GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigRemoveTags_tags[];
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigAddAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigAddAudiences {
  __typename: "ActionConfigAddAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigAddAudiences_audiences[];
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigRemoveAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigRemoveAudiences {
  __typename: "ActionConfigRemoveAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigRemoveAudiences_audiences[];
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigAddToDripSequence_dripSequence {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigAddToDripSequence {
  __typename: "ActionConfigAddToDripSequence";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The drip sequence to which the contact should be added.
   */
  dripSequence: GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigAddToDripSequence_dripSequence;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule = GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_User | GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_Team | GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule;

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead {
  __typename: "ActionConfigCreateLead";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The stageset to which the lead should be added.
   */
  stageset: GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_stageset;
  /**
   * The tags which should be added to the lead.
   */
  tags: GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_tags[];
  /**
   * The assignee for the lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule | null;
}

export type GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config = GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigSendPageViewedNotification | GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigAddTags | GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigRemoveTags | GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigAddAudiences | GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigRemoveAudiences | GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigAddToDripSequence | GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead;

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_actions {
  __typename: "Action";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * The configuration for this action.
   */
  config: GetSmartSequenceGraph_smartSequence_nodes_automation_actions_config;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_trigger {
  __typename: "Trigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of event which activates this trigger.
   */
  type: TriggerType;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigTag_tagEntities {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
  /**
   * The tags this condition matches.
   */
  tagEntities: GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigTag_tagEntities[];
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigSourceEntity {
  __typename: "ConditionConfigSourceEntity";
  sourceEntityId: string | null;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  url: GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl_url;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed {
  __typename: "ConditionConfigPageViewed";
  maUrlId: string | null;
  maUrl: GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl | null;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigFormSubmission_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigFormSubmission {
  __typename: "ConditionConfigFormSubmission";
  formId: string | null;
  form: GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigFormSubmission_form | null;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigDateTimeBetween {
  __typename: "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The earlier date to test if an entity date time is between 2 dates.
   */
  startDate: any;
  /**
   * The later date to test if an entity date time is between 2 dates.
   */
  endDate: any;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigStrings {
  __typename: "EntityFilterFieldConfigStrings";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substrings to search for.
   */
  stringsContain: string;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigInteger {
  __typename: "EntityFilterFieldConfigInteger";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this integer field.
   */
  integerValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  integerComparator: Comparator;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigPhone {
  __typename: "EntityFilterFieldConfigPhone";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string of digits to match on when filtering on phone numbers.
   */
  startsWith: string;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter = GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigDateTimeBetween | GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigStrings | GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigInteger | GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigPhone | GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter;
}

export type GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config = GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigAudience | GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigTag | GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigLink | GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigSourceEntity | GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed | GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigFormSubmission | GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter;

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions {
  __typename: "Condition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this condition relative to its siblings.
   */
  position: number;
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions_config;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation_predicates {
  __typename: "Predicate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this predicate relative to its siblings.
   */
  position: number;
  /**
   * The trigger that will initiate execution of this predicate.
   */
  trigger: GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_trigger;
  /**
   * The conditions that must be true for this predicate to activate an automation.
   */
  conditions: GetSmartSequenceGraph_smartSequence_nodes_automation_predicates_conditions[];
}

export interface GetSmartSequenceGraph_smartSequence_nodes_automation {
  __typename: "Automation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Actions that will be taken when this automation is activated.
   */
  actions: GetSmartSequenceGraph_smartSequence_nodes_automation_actions[];
  /**
   * A list of predicates which can activate this automation.
   */
  predicates: GetSmartSequenceGraph_smartSequence_nodes_automation_predicates[];
}

export interface GetSmartSequenceGraph_smartSequence_nodes_recipientTracking_emailEngagement {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
}

export interface GetSmartSequenceGraph_smartSequence_nodes_recipientTracking {
  __typename: "SmartSequenceNodeRecipientTracking";
  /**
   * Human-readable recipient count for the node banner (e.g. "24 recipients waiting").
   */
  recipientSummary: string | null;
  /**
   * Email delivery and engagement stats for send-email nodes.
   */
  emailEngagement: GetSmartSequenceGraph_smartSequence_nodes_recipientTracking_emailEngagement | null;
}

export interface GetSmartSequenceGraph_smartSequence_nodes {
  __typename: "SmartSequenceNode";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: SmartSequenceNodeType;
  parentNodeId: string | null;
  parentBranch: SmartSequenceParentBranch | null;
  delay: GetSmartSequenceGraph_smartSequence_nodes_delay | null;
  edition: GetSmartSequenceGraph_smartSequence_nodes_edition | null;
  automation: GetSmartSequenceGraph_smartSequence_nodes_automation | null;
  /**
   * Recipient progression and engagement display data for the canvas node.
   */
  recipientTracking: GetSmartSequenceGraph_smartSequence_nodes_recipientTracking | null;
}

export interface GetSmartSequenceGraph_smartSequence_edges {
  __typename: "SmartSequenceEdge";
  id: string;
  /**
   * The parent node API id.
   */
  source: string;
  /**
   * The child node API id.
   */
  target: string;
  /**
   * Decision branch label for this edge, if applicable.
   */
  branch: SmartSequenceParentBranch | null;
  /**
   * Human-readable count of recipients that entered this decision branch.
   */
  recipientSummary: string | null;
}

export interface GetSmartSequenceGraph_smartSequence_startTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface GetSmartSequenceGraph_smartSequence {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  nodes: GetSmartSequenceGraph_smartSequence_nodes[];
  edges: GetSmartSequenceGraph_smartSequence_edges[];
  /**
   * The start triggers for the smart sequence.
   */
  startTriggers: GetSmartSequenceGraph_smartSequence_startTriggers[];
}

export interface GetSmartSequenceGraph {
  /**
   * Returns a smart sequence by ID.
   */
  smartSequence: GetSmartSequenceGraph_smartSequence | null;
}

export interface GetSmartSequenceGraphVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSmartSequenceRecipientEngagement
// ====================================================

export interface GetSmartSequenceRecipientEngagement_smartSequence_recipientEngagement_averageTimeInSequence {
  __typename: "FormattedValueDuration";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formattedString: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface GetSmartSequenceRecipientEngagement_smartSequence_recipientEngagement {
  __typename: "SmartSequenceRecipientEngagement";
  /**
   * Number of recipients currently in the sequence (not yet exited).
   */
  activeRecipients: number;
  /**
   * Total number of recipients in the sequence.
   */
  totalRecipients: number;
  /**
   * Average time recipients spend in the sequence before completing (goal met or
   * reached an end node) or dropping off (unsubscribed, manually removed, bounced,
   * lead closed, audience removed, or email could not be sent e.g. missing merge
   * fields). Null when there is no population to compute over.
   */
  averageTimeInSequence: GetSmartSequenceRecipientEngagement_smartSequence_recipientEngagement_averageTimeInSequence | null;
  /**
   * Share of recipients (0–1) who reached a sequence end state or achieved the
   * sequence goal. Null when there is no population to compute over.
   */
  sequenceCompletionRate: number | null;
  /**
   * Share of recipients (0–1) who exited unsuccessfully before completion
   * (unsubscribed, manually removed, bounced, lead closed, audience removed, or
   * email could not be sent e.g. missing merge fields). Null when there is no
   * population to compute over.
   */
  dropOffRate: number | null;
}

export interface GetSmartSequenceRecipientEngagement_smartSequence {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Recipient-tab engagement metrics for this smart sequence.
   */
  recipientEngagement: GetSmartSequenceRecipientEngagement_smartSequence_recipientEngagement;
}

export interface GetSmartSequenceRecipientEngagement {
  /**
   * Returns a smart sequence by ID.
   */
  smartSequence: GetSmartSequenceRecipientEngagement_smartSequence | null;
}

export interface GetSmartSequenceRecipientEngagementVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSmartSequence
// ====================================================

export interface GetSmartSequence_smartSequence_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
}

export interface GetSmartSequence_smartSequence_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
}

export interface GetSmartSequence_smartSequence_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSmartSequence_smartSequence_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSmartSequence_smartSequence_from_emailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface GetSmartSequence_smartSequence_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface GetSmartSequence_smartSequence_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: GetSmartSequence_smartSequence_from_emailAddress;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: GetSmartSequence_smartSequence_from_fromDomain | null;
}

export interface GetSmartSequence_smartSequence_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface GetSmartSequence_smartSequence_startTriggers_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface GetSmartSequence_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface GetSmartSequence_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface GetSmartSequence_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type GetSmartSequence_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter = GetSmartSequence_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | GetSmartSequence_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | GetSmartSequence_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface GetSmartSequence_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: GetSmartSequence_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface GetSmartSequence_smartSequence_startTriggers_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface GetSmartSequence_smartSequence_startTriggers_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type GetSmartSequence_smartSequence_startTriggers_conditions_config = GetSmartSequence_smartSequence_startTriggers_conditions_config_ConditionConfigLink | GetSmartSequence_smartSequence_startTriggers_conditions_config_ConditionConfigEntityFilter | GetSmartSequence_smartSequence_startTriggers_conditions_config_ConditionConfigTag | GetSmartSequence_smartSequence_startTriggers_conditions_config_ConditionConfigAudience;

export interface GetSmartSequence_smartSequence_startTriggers_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: GetSmartSequence_smartSequence_startTriggers_conditions_config;
}

export interface GetSmartSequence_smartSequence_startTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of startTrigger
   */
  type: StartTriggerType;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * A list of conditions which must be true to activate this startTrigger.
   */
  conditions: GetSmartSequence_smartSequence_startTriggers_conditions[];
}

export interface GetSmartSequence_smartSequence_goal_conditions_config_ConditionConfigSourceEntity {
  __typename: "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface GetSmartSequence_smartSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface GetSmartSequence_smartSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface GetSmartSequence_smartSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type GetSmartSequence_smartSequence_goal_conditions_config_ConditionConfigEntityFilter_filter = GetSmartSequence_smartSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | GetSmartSequence_smartSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | GetSmartSequence_smartSequence_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface GetSmartSequence_smartSequence_goal_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: GetSmartSequence_smartSequence_goal_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface GetSmartSequence_smartSequence_goal_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export interface GetSmartSequence_smartSequence_goal_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface GetSmartSequence_smartSequence_goal_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type GetSmartSequence_smartSequence_goal_conditions_config = GetSmartSequence_smartSequence_goal_conditions_config_ConditionConfigSourceEntity | GetSmartSequence_smartSequence_goal_conditions_config_ConditionConfigEntityFilter | GetSmartSequence_smartSequence_goal_conditions_config_ConditionConfigLink | GetSmartSequence_smartSequence_goal_conditions_config_ConditionConfigTag | GetSmartSequence_smartSequence_goal_conditions_config_ConditionConfigAudience;

export interface GetSmartSequence_smartSequence_goal_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: GetSmartSequence_smartSequence_goal_conditions_config;
}

export interface GetSmartSequence_smartSequence_goal_action_config_ActionConfigRemoveTags {
  __typename: "ActionConfigRemoveTags" | "ActionConfigSendPageViewedNotification" | "ActionConfigAddToDripSequence" | "ActionConfigCreateLead" | "ActionConfigSendEmail";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
}

export interface GetSmartSequence_smartSequence_goal_action_config_ActionConfigAddTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetSmartSequence_smartSequence_goal_action_config_ActionConfigAddTags {
  __typename: "ActionConfigAddTags";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  tags: GetSmartSequence_smartSequence_goal_action_config_ActionConfigAddTags_tags[];
}

export interface GetSmartSequence_smartSequence_goal_action_config_ActionConfigAddAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetSmartSequence_smartSequence_goal_action_config_ActionConfigAddAudiences {
  __typename: "ActionConfigAddAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: GetSmartSequence_smartSequence_goal_action_config_ActionConfigAddAudiences_audiences[];
}

export interface GetSmartSequence_smartSequence_goal_action_config_ActionConfigRemoveAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetSmartSequence_smartSequence_goal_action_config_ActionConfigRemoveAudiences {
  __typename: "ActionConfigRemoveAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: GetSmartSequence_smartSequence_goal_action_config_ActionConfigRemoveAudiences_audiences[];
}

export type GetSmartSequence_smartSequence_goal_action_config = GetSmartSequence_smartSequence_goal_action_config_ActionConfigRemoveTags | GetSmartSequence_smartSequence_goal_action_config_ActionConfigAddTags | GetSmartSequence_smartSequence_goal_action_config_ActionConfigAddAudiences | GetSmartSequence_smartSequence_goal_action_config_ActionConfigRemoveAudiences;

export interface GetSmartSequence_smartSequence_goal_action {
  __typename: "Action";
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * Human readable title of this action
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this action. This is essentially just the
   * stringified version of the action’s conditions, but because a action can have
   * multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The configuration for this action.
   */
  config: GetSmartSequence_smartSequence_goal_action_config;
}

export interface GetSmartSequence_smartSequence_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Calculated goal type based on conditions. This is not saved in the database
   */
  type: DripSequenceGoalType;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this goal. This is essentially just the stringified
   * version of the goal’s conditions, but because a goal can have multiple
   * conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * A list of conditions which must be true to activate this goal.
   */
  conditions: GetSmartSequence_smartSequence_goal_conditions[];
  /**
   * The optional action (next step in this context) that will run when this goal is met
   */
  action: GetSmartSequence_smartSequence_goal_action | null;
}

export interface GetSmartSequence_smartSequence_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * The last time this particular piece of content was sent. This is slow to
   * calculate on a one-off basis so we chuck it in here.
   */
  latestDeliveryTime: any | null;
  /**
   * For edition base stats, the total number of drip progressions in any state for the related campaigns
   */
  dripProgressionTotalRecipients: number;
  /**
   * For edition base stats, the number of drip progressions that have stopped for the related campaigns
   */
  dripProgressionsStopped: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
  /**
   * For edition base stats, the percentage of drip progressions that received every message for the related campaigns
   */
  dripProgressionsReceivedEveryMessageRate: number | null;
}

export interface GetSmartSequence_smartSequence_nodes_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetSmartSequence_smartSequence_nodes_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
}

export interface GetSmartSequence_smartSequence_nodes_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetSmartSequence_smartSequence_nodes_edition_emailTemplate | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigSendPageViewedNotification {
  __typename: "ActionConfigSendPageViewedNotification" | "ActionConfigSendEmail";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
}

export interface GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigAddTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigAddTags {
  __typename: "ActionConfigAddTags";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  tags: GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigAddTags_tags[];
}

export interface GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigRemoveTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigRemoveTags {
  __typename: "ActionConfigRemoveTags";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The tags to remove.
   */
  tags: GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigRemoveTags_tags[];
}

export interface GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigAddAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigAddAudiences {
  __typename: "ActionConfigAddAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigAddAudiences_audiences[];
}

export interface GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigRemoveAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigRemoveAudiences {
  __typename: "ActionConfigRemoveAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigRemoveAudiences_audiences[];
}

export interface GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigAddToDripSequence_dripSequence {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigAddToDripSequence {
  __typename: "ActionConfigAddToDripSequence";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The drip sequence to which the contact should be added.
   */
  dripSequence: GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigAddToDripSequence_dripSequence;
}

export interface GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule = GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_User | GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_Team | GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule;

export interface GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead {
  __typename: "ActionConfigCreateLead";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The stageset to which the lead should be added.
   */
  stageset: GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_stageset;
  /**
   * The tags which should be added to the lead.
   */
  tags: GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_tags[];
  /**
   * The assignee for the lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule | null;
}

export type GetSmartSequence_smartSequence_nodes_automation_actions_config = GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigSendPageViewedNotification | GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigAddTags | GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigRemoveTags | GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigAddAudiences | GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigRemoveAudiences | GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigAddToDripSequence | GetSmartSequence_smartSequence_nodes_automation_actions_config_ActionConfigCreateLead;

export interface GetSmartSequence_smartSequence_nodes_automation_actions {
  __typename: "Action";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * The configuration for this action.
   */
  config: GetSmartSequence_smartSequence_nodes_automation_actions_config;
}

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_trigger {
  __typename: "Trigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of event which activates this trigger.
   */
  type: TriggerType;
}

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
}

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigTag_tagEntities {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
  /**
   * The tags this condition matches.
   */
  tagEntities: GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigTag_tagEntities[];
}

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigSourceEntity {
  __typename: "ConditionConfigSourceEntity";
  sourceEntityId: string | null;
}

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  url: GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl_url;
}

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed {
  __typename: "ConditionConfigPageViewed";
  maUrlId: string | null;
  maUrl: GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl | null;
}

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigFormSubmission_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigFormSubmission {
  __typename: "ConditionConfigFormSubmission";
  formId: string | null;
  form: GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigFormSubmission_form | null;
}

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigDateTimeBetween {
  __typename: "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The earlier date to test if an entity date time is between 2 dates.
   */
  startDate: any;
  /**
   * The later date to test if an entity date time is between 2 dates.
   */
  endDate: any;
}

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigStrings {
  __typename: "EntityFilterFieldConfigStrings";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substrings to search for.
   */
  stringsContain: string;
}

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigInteger {
  __typename: "EntityFilterFieldConfigInteger";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this integer field.
   */
  integerValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  integerComparator: Comparator;
}

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigPhone {
  __typename: "EntityFilterFieldConfigPhone";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string of digits to match on when filtering on phone numbers.
   */
  startsWith: string;
}

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter = GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigDateTimeBetween | GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigStrings | GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigInteger | GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigPhone | GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter;
}

export type GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config = GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigAudience | GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigTag | GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigLink | GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigSourceEntity | GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed | GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigFormSubmission | GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter;

export interface GetSmartSequence_smartSequence_nodes_automation_predicates_conditions {
  __typename: "Condition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this condition relative to its siblings.
   */
  position: number;
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: GetSmartSequence_smartSequence_nodes_automation_predicates_conditions_config;
}

export interface GetSmartSequence_smartSequence_nodes_automation_predicates {
  __typename: "Predicate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this predicate relative to its siblings.
   */
  position: number;
  /**
   * The trigger that will initiate execution of this predicate.
   */
  trigger: GetSmartSequence_smartSequence_nodes_automation_predicates_trigger;
  /**
   * The conditions that must be true for this predicate to activate an automation.
   */
  conditions: GetSmartSequence_smartSequence_nodes_automation_predicates_conditions[];
}

export interface GetSmartSequence_smartSequence_nodes_automation {
  __typename: "Automation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Actions that will be taken when this automation is activated.
   */
  actions: GetSmartSequence_smartSequence_nodes_automation_actions[];
  /**
   * A list of predicates which can activate this automation.
   */
  predicates: GetSmartSequence_smartSequence_nodes_automation_predicates[];
}

export interface GetSmartSequence_smartSequence_nodes_recipientTracking_emailEngagement {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
}

export interface GetSmartSequence_smartSequence_nodes_recipientTracking {
  __typename: "SmartSequenceNodeRecipientTracking";
  /**
   * Human-readable recipient count for the node banner (e.g. "24 recipients waiting").
   */
  recipientSummary: string | null;
  /**
   * Email delivery and engagement stats for send-email nodes.
   */
  emailEngagement: GetSmartSequence_smartSequence_nodes_recipientTracking_emailEngagement | null;
}

export interface GetSmartSequence_smartSequence_nodes {
  __typename: "SmartSequenceNode";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: SmartSequenceNodeType;
  parentNodeId: string | null;
  parentBranch: SmartSequenceParentBranch | null;
  delay: GetSmartSequence_smartSequence_nodes_delay | null;
  edition: GetSmartSequence_smartSequence_nodes_edition | null;
  automation: GetSmartSequence_smartSequence_nodes_automation | null;
  /**
   * Recipient progression and engagement display data for the canvas node.
   */
  recipientTracking: GetSmartSequence_smartSequence_nodes_recipientTracking | null;
}

export interface GetSmartSequence_smartSequence_edges {
  __typename: "SmartSequenceEdge";
  id: string;
  /**
   * The parent node API id.
   */
  source: string;
  /**
   * The child node API id.
   */
  target: string;
  /**
   * Decision branch label for this edge, if applicable.
   */
  branch: SmartSequenceParentBranch | null;
  /**
   * Human-readable count of recipients that entered this decision branch.
   */
  recipientSummary: string | null;
}

export interface GetSmartSequence_smartSequence {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  description: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The DateTime that represents when the campaign was last modified
   */
  modifiedTime: any | null;
  /**
   * Time of the last campaign status change. For example, if a customer activated
   * this sequence and its still active, this would be the time the sequence was
   * activated. Once the campaign status is changed (paused, retired, etc) this
   * would reflect that new time
   */
  lastStatusChangeTime: any | null;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * Whether the drip sequence should have a remove option
   */
  isRemovable: boolean;
  /**
   * Should messages only be sent during business hours.
   */
  isBusinessHoursOnly: boolean;
  useUtmParameters: boolean;
  utmParameters: GetSmartSequence_smartSequence_utmParameters;
  defaultUtmParameters: GetSmartSequence_smartSequence_defaultUtmParameters;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * When a lead is closed, should drip sequences stop?
   */
  isStopOnLeadClose: boolean;
  /**
   * When a person is removed from an audience, should drip sequences stop?
   */
  isStopOnRemovedFromAudience: boolean;
  /**
   * Number of in progress drip progressions for the drip sequence
   */
  numInProgressDripProgressions: number;
  creatorUser: GetSmartSequence_smartSequence_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: GetSmartSequence_smartSequence_owner | null;
  /**
   * The address to send this edition from
   */
  from: GetSmartSequence_smartSequence_from | null;
  /**
   * The custom click domain that this campaign will use to track links, if there is one
   */
  customClickDomain: GetSmartSequence_smartSequence_customClickDomain | null;
  /**
   * The start triggers for the smart sequence.
   */
  startTriggers: GetSmartSequence_smartSequence_startTriggers[];
  /**
   * The newly created Nutshell goal
   */
  goal: GetSmartSequence_smartSequence_goal | null;
  engagementStats: GetSmartSequence_smartSequence_engagementStats;
  /**
   * Unique undeleted contacts that have entered this sequence (any progression
   * state). Live count — not engagement-stats cache.
   */
  uniqueEnteredRecipients: number;
  nodes: GetSmartSequence_smartSequence_nodes[];
  edges: GetSmartSequence_smartSequence_edges[];
}

export interface GetSmartSequence {
  /**
   * Returns a smart sequence by ID.
   */
  smartSequence: GetSmartSequence_smartSequence | null;
}

export interface GetSmartSequenceVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSmartSequencesForCopy
// ====================================================

export interface GetSmartSequencesForCopy_smartSequences_edges_node {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
}

export interface GetSmartSequencesForCopy_smartSequences_edges {
  __typename: "SmartSequencesEdge";
  node: GetSmartSequencesForCopy_smartSequences_edges_node;
}

export interface GetSmartSequencesForCopy_smartSequences {
  __typename: "SmartSequencesConnection";
  /**
   * A list of edges.
   */
  edges: GetSmartSequencesForCopy_smartSequences_edges[];
}

export interface GetSmartSequencesForCopy {
  /**
   * Returns a paging connection of smart sequences from the root query.
   */
  smartSequences: GetSmartSequencesForCopy_smartSequences;
}

export interface GetSmartSequencesForCopyVariables {
  archived?: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSmartSequences
// ====================================================

export interface GetSmartSequences_smartSequences_edges_node_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSmartSequences_smartSequences_edges_node_startTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface GetSmartSequences_smartSequences_edges_node_from_emailAddress {
  __typename: "NutEmailAddress";
  formatted: string;
}

export interface GetSmartSequences_smartSequences_edges_node_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: GetSmartSequences_smartSequences_edges_node_from_emailAddress;
}

export interface GetSmartSequences_smartSequences_edges_node_editions_edges_node_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
}

export interface GetSmartSequences_smartSequences_edges_node_editions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The email template for this edition
   */
  emailTemplate: GetSmartSequences_smartSequences_edges_node_editions_edges_node_emailTemplate | null;
}

export interface GetSmartSequences_smartSequences_edges_node_editions_edges {
  __typename: "EditionsEdge";
  node: GetSmartSequences_smartSequences_edges_node_editions_edges_node;
}

export interface GetSmartSequences_smartSequences_edges_node_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetSmartSequences_smartSequences_edges_node_editions_edges[];
}

export interface GetSmartSequences_smartSequences_edges_node {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * Time of the last campaign status change. For example, if a customer activated
   * this sequence and its still active, this would be the time the sequence was
   * activated. Once the campaign status is changed (paused, retired, etc) this
   * would reflect that new time
   */
  lastStatusChangeTime: any | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  creatorUser: GetSmartSequences_smartSequences_edges_node_creatorUser | null;
  /**
   * The start triggers for the smart sequence.
   */
  startTriggers: GetSmartSequences_smartSequences_edges_node_startTriggers[];
  /**
   * Unique undeleted contacts that have entered this sequence (any progression
   * state). Live count — not engagement-stats cache.
   */
  uniqueEnteredRecipients: number;
  /**
   * The address to send this edition from
   */
  from: GetSmartSequences_smartSequences_edges_node_from | null;
  editions: GetSmartSequences_smartSequences_edges_node_editions;
}

export interface GetSmartSequences_smartSequences_edges {
  __typename: "SmartSequencesEdge";
  node: GetSmartSequences_smartSequences_edges_node;
}

export interface GetSmartSequences_smartSequences {
  __typename: "SmartSequencesConnection";
  /**
   * A list of edges.
   */
  edges: GetSmartSequences_smartSequences_edges[];
}

export interface GetSmartSequences {
  /**
   * Returns a paging connection of smart sequences from the root query.
   */
  smartSequences: GetSmartSequences_smartSequences;
}

export interface GetSmartSequencesVariables {
  archived?: boolean | null;
  search?: string | null;
  creatorUserId?: string | null;
  statuses?: CampaignStatus[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSmartSequenceDecisionBranchRecipients
// ====================================================

export interface GetSmartSequenceDecisionBranchRecipients_smartSequence_edges {
  __typename: "SmartSequenceEdge";
  id: string;
  /**
   * The parent node API id.
   */
  source: string;
  /**
   * The child node API id.
   */
  target: string;
  /**
   * Decision branch label for this edge, if applicable.
   */
  branch: SmartSequenceParentBranch | null;
  /**
   * Human-readable count of recipients that entered this decision branch.
   */
  recipientSummary: string | null;
}

export interface GetSmartSequenceDecisionBranchRecipients_smartSequence {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  edges: GetSmartSequenceDecisionBranchRecipients_smartSequence_edges[];
}

export interface GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges_node_audienceMember_entity = GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges_node_audienceMember_entity_Account | GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges_node_audienceMember_entity_Contact;

export interface GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges_node_audienceMember_entity;
}

export interface GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges_node_audienceMember;
}

export interface GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges_node;
}

export interface GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions_edges[];
}

export interface GetSmartSequenceDecisionBranchRecipients_smartSequenceNode {
  __typename: "SmartSequenceNode";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Recipients on a decision node YES/NO branch path.
   */
  branchDripProgressions: GetSmartSequenceDecisionBranchRecipients_smartSequenceNode_branchDripProgressions | null;
}

export interface GetSmartSequenceDecisionBranchRecipients {
  /**
   * Returns a smart sequence by ID.
   */
  smartSequence: GetSmartSequenceDecisionBranchRecipients_smartSequence | null;
  /**
   * Returns a smart sequence node by ID.
   */
  smartSequenceNode: GetSmartSequenceDecisionBranchRecipients_smartSequenceNode | null;
}

export interface GetSmartSequenceDecisionBranchRecipientsVariables {
  smartSequenceId: string;
  nodeId: string;
  branch: SmartSequenceParentBranch;
  first: number;
  after?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSmartSequenceNodeRecipients
// ====================================================

export interface GetSmartSequenceNodeRecipients_smartSequenceNode_recipientTracking {
  __typename: "SmartSequenceNodeRecipientTracking";
  /**
   * Human-readable recipient count for the node banner (e.g. "24 recipients waiting").
   */
  recipientSummary: string | null;
}

export interface GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges_node_audienceMember_entity = GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges_node_audienceMember_entity_Account | GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges_node_audienceMember_entity_Contact;

export interface GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges_node_audienceMember_entity;
}

export interface GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges_node_audienceMember;
}

export interface GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges_node;
}

export interface GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions_edges[];
}

export interface GetSmartSequenceNodeRecipients_smartSequenceNode {
  __typename: "SmartSequenceNode";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Recipient progression and engagement display data for the canvas node.
   */
  recipientTracking: GetSmartSequenceNodeRecipients_smartSequenceNode_recipientTracking | null;
  /**
   * Recipients associated with this node (entered, waiting, or completed).
   */
  dripProgressions: GetSmartSequenceNodeRecipients_smartSequenceNode_dripProgressions | null;
}

export interface GetSmartSequenceNodeRecipients {
  /**
   * Returns a smart sequence node by ID.
   */
  smartSequenceNode: GetSmartSequenceNodeRecipients_smartSequenceNode | null;
}

export interface GetSmartSequenceNodeRecipientsVariables {
  nodeId: string;
  first: number;
  after?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RequestTranscribeToken
// ====================================================

export interface RequestTranscribeToken_transcribeToken_limitInfo {
  __typename: "LimitInfo";
  /**
   * In trial, we don’t show limits but instead a warning when usage is above the lowest tier
   */
  shouldShowWarningInTrial: boolean;
  /**
   * The current usage of the given type
   */
  currentUsage: number;
  /**
   * All time usage of the given type
   */
  allTimeUsage: number | null;
  /**
   * The limit according to the user’s plan
   */
  currentPlanLimit: number | null;
  /**
   * Whether this limit is enforced or not, since some limits are grandfathered into older plans and are not being enforced
   */
  isEnforced: boolean;
  /**
   * Whether the user can add another of given type
   */
  canAdd: boolean;
  /**
   * The name of the user’s current plan
   */
  currentPlanName: string;
  /**
   * The limit according to the user’s plan
   */
  upgradePlanLimit: number | null;
  /**
   * The name of the user’s direct upgrade plan
   */
  upgradePlanName: string;
  /**
   * The limit according to the user’s plan excluding custom settings
   */
  tierPlanLimit: number | null;
  /**
   * User facing string of the thing being limited
   */
  humanReadableType: string;
}

export interface RequestTranscribeToken_transcribeToken {
  __typename: "TranscribeTokenRequestPayload";
  /**
   * An authenticator required for live transcription
   */
  token: string | null;
  /**
   * The number of transcriptions allowed to use in a month
   */
  limitInfo: RequestTranscribeToken_transcribeToken_limitInfo;
}

export interface RequestTranscribeToken {
  /**
   * Request a key for live transcription
   */
  transcribeToken: RequestTranscribeToken_transcribeToken;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTask
// ====================================================

export interface GetTask_task_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
}

export interface GetTask_task_recurrenceRule {
  __typename: "RecurrenceRule";
  /**
   * An RRULE-compatible string defining the recurrence pattern (e.g. "FREQ=WEEKLY;BYDAY=MO").
   */
  rule: string;
  mode: RecurrenceMode;
}

export interface GetTask_task_relatedEntity_ActivityExternalAttendee {
  __typename: "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the external attendee, "Unknown attendee" if not set
   */
  name: string;
}

export interface GetTask_task_relatedEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetTask_task_relatedEntity_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface GetTask_task_relatedEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetTask_task_relatedEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export type GetTask_task_relatedEntity = GetTask_task_relatedEntity_ActivityExternalAttendee | GetTask_task_relatedEntity_Lead | GetTask_task_relatedEntity_User | GetTask_task_relatedEntity_Contact | GetTask_task_relatedEntity_Account;

export interface GetTask_task {
  __typename: "Task";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The canonical API href for the task
   */
  href: string;
  /**
   * The name/title of the task
   */
  title: string;
  /**
   * The task’s user-defined description
   */
  description: string | null;
  /**
   * The due timestamp of the task
   */
  dueTime: any | null;
  /**
   * The person or team assigned to this task
   */
  assignee: GetTask_task_assignee | null;
  /**
   * The DateTime that represents when the Activity record was created
   */
  createdTime: any;
  /**
   * The DateTime that represents when the Task record was created
   */
  completedTime: any | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  deletedTime: any | null;
  /**
   * Null if the task does not recur under the new recurrence system.
   */
  recurrenceRule: GetTask_task_recurrenceRule | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  relatedEntity: GetTask_task_relatedEntity | null;
}

export interface GetTask {
  /**
   * Returns a Nutshell task
   */
  task: GetTask_task | null;
}

export interface GetTaskVariables {
  taskId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TrackAiAssistantConversation
// ====================================================

export interface TrackAiAssistantConversation_trackAiAssistantConversation {
  __typename: "TrackAiAssistantConversationPayload";
  /**
   * Whether the conversation was successfully tracked
   */
  success: boolean;
}

export interface TrackAiAssistantConversation {
  /**
   * Track a conversation with an AI assistant
   */
  trackAiAssistantConversation: TrackAiAssistantConversation_trackAiAssistantConversation;
}

export interface TrackAiAssistantConversationVariables {
  input: AiAssistantConversation;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBaseContext
// ====================================================

export interface GetBaseContext_userYouAreTalkingTo_emailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The address string of this email.
   */
  address: string;
}

export interface GetBaseContext_userYouAreTalkingTo {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * User emails configured for this user
   */
  emailAddresses: GetBaseContext_userYouAreTalkingTo_emailAddresses[];
}

export interface GetBaseContext_nutshellAccount {
  __typename: "Instance";
  companyName: string;
}

export interface GetBaseContext_allUsersInThisNutshellAccount {
  __typename: "UsersConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetBaseContext {
  /**
   * Returns the requesting user. This is essentially the logged in user, but in an
   * API context, they might not be any "logged in"
   */
  userYouAreTalkingTo: GetBaseContext_userYouAreTalkingTo;
  /**
   * A hodge-podge of instance-level concerns
   */
  nutshellAccount: GetBaseContext_nutshellAccount | null;
  /**
   * Returns a paging connection of users from the root of our query.
   */
  allUsersInThisNutshellAccount: GetBaseContext_allUsersInThisNutshellAccount;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEmailSequenceContext
// ====================================================

export interface GetEmailSequenceContext_products_edges_node {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  productId: string;
  /**
   * The name of the product
   */
  productName: string;
  /**
   * The type of the product (Good or Service)
   */
  goodOrService: ProductType;
  /**
   * The term of the product
   */
  serviceTerm: QuoteTerm | null;
}

export interface GetEmailSequenceContext_products_edges {
  __typename: "ProductsEdge";
  node: GetEmailSequenceContext_products_edges_node;
}

export interface GetEmailSequenceContext_products {
  __typename: "ProductsConnection";
  /**
   * A list of edges.
   */
  edges: GetEmailSequenceContext_products_edges[];
}

export interface GetEmailSequenceContext {
  /**
   * Returns a paging connection of products from the root of our query.
   */
  products: GetEmailSequenceContext_products | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPageContext
// ====================================================

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_dueDate {
  __typename: "StepDueDate";
  /**
   * The reference point for this due date. This can include when the lead was created, when the stage was entered, etc.
   */
  dueFrom: number;
  /**
   * The unit to measure this step template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this step template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name for this slack automation.
   */
  name: string;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_closedLeadAutomations_accountTypeAutomations_conditions {
  __typename: "Condition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
  /**
   * A list of conditions which must be true to activate this automation.
   */
  conditions: GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_closedLeadAutomations_accountTypeAutomations_conditions[];
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_closedLeadAutomations_accountTypeAutomations[];
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_emailAutomations_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_emailAutomations_exitsStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_emailAutomations_delay {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_emailAutomations_sendFromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_emailAutomations {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_emailAutomations_emailList | null;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_emailAutomations_entersStage;
  /**
   * The stage in which this stage subscription ends.
   */
  exitsStage: GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_emailAutomations_exitsStage | null;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_emailAutomations_delay | null;
  /**
   * Number of stages a EmailAutomation spans. If a subscription has no exit stage,
   * we count the last stage in the stageset as the "exit stage" for this count.
   */
  numberOfStagesSpanned: number;
  /**
   * The user that automated email sequences should be sent from, or null if sent from the lead assignee
   */
  sendFromUser: GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_emailAutomations_sendFromUser | null;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate {
  __typename: "ProcessTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell ProcessTemplate.
   */
  name: string | null;
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_closedLeadAutomations[];
  /**
   * Returns a list of Nutshell emails automations for a given process template
   */
  emailAutomations: GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate_emailAutomations[];
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates {
  __typename: "StepTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The rules to determine the due date for this step.
   */
  dueDate: GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_dueDate | null;
  /**
   * The position of the step template within its stage.
   */
  position: number;
  /**
   * The name of the Nutshell StepTemplate.
   */
  name: string;
  /**
   * The description of the Nutshell StepTemplate.
   */
  description: string | null;
  /**
   * The description of the Nutshell StepTemplate.
   */
  assignee: GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_assignee | null;
  /**
   * The Process template this stepTemplate belongs to.
   */
  processTemplate: GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates_processTemplate;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  stageName: string;
  /**
   * The default confidence value of the stage.
   */
  setConfidenceOnLeadWhenItEntersThisStage: number | null;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The active copies of the step templates available for this stage
   */
  activeStepTemplates: GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages_activeStepTemplates[];
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  pipelineName: string;
  /**
   * If this stageset is the default or not
   */
  isThisTheDefaultPipeline: boolean;
  /**
   * The stages associated with this stageset
   */
  stages: GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset_stages[];
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_clonedFrom {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_industry {
  __typename: "NutshellIndustry";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human description of the industry
   */
  name: string | null;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_primaryContact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  name: string;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_primaryContact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_primaryContact_emailAddresses_primary | null;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_primaryContact_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_primaryContact_phones_primary {
  __typename: "Phone";
  name: string;
  value: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_primaryContact_phones_primary_value;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_primaryContact_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_primaryContact_phones_primary | null;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_primaryContact_emailAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_primaryContact_phones;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  name: string;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_emailAddresses_primary | null;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_phones_primary {
  __typename: "Phone";
  name: string;
  value: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_phones_primary_value;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_phones_primary | null;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  address_1: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_postalAddresses_primary {
  __typename: "PostalAddress";
  name: string;
  value: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_postalAddresses_primary_value;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_postalAddresses_primary | null;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The industry of this account
   */
  industry: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_industry | null;
  /**
   * The primary contact for this account
   */
  primaryContact: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_primaryContact | null;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_owner | null;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_emailAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_phones;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node_postalAddresses;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges {
  __typename: "LeadAccountsEdge";
  node: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges_node;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * A list of edges.
   */
  edges: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts_edges[];
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_contacts_edges_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  name: string;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_contacts_edges_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_contacts_edges_node_emailAddresses_primary | null;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_contacts_edges_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_contacts_edges_node_phones_primary {
  __typename: "Phone";
  name: string;
  value: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_contacts_edges_node_phones_primary_value;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_contacts_edges_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_contacts_edges_node_phones_primary | null;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_contacts_edges_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_contacts_edges_node_emailAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_contacts_edges_node_phones;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_contacts_edges {
  __typename: "LeadContactsEdge";
  node: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_contacts_edges_node;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * A list of edges.
   */
  edges: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_contacts_edges[];
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_pipelineStages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The time this stage was deleted, or null if this stage has not been deleted.
   */
  deletedTime: any | null;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_pipelineStages_edges_node_stageset {
  __typename: "Stageset";
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_pipelineStages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_pipelineStages_edges_node_stageset;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_pipelineStages_edges {
  __typename: "LeadStagesEdge";
  node: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_pipelineStages_edges_node;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_pipelineStages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_pipelineStages_current | null;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_pipelineStages_edges[];
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The different type of entity that this tag belongs to (e.g., a Lead, or a Contact)
   */
  tagType: TagType;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_tagMaps_edges_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The different type of entity that this tag belongs to (e.g., a Lead, or a Contact)
   */
  tagType: TagType;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_tagMaps_edges {
  __typename: "TagMapsEdge";
  /**
   * The creator of this tag map
   */
  creator: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_tagMaps_edges_creator | null;
  /**
   * The DateTime that represents when the Tag was mapped
   */
  createdTime: any | null;
  node: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_tagMaps_edges_node | null;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_tagMaps_edges[];
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_outcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_sendToDestinations {
  __typename: "EntityDestination";
  /**
   * The descriptive name for this destination.
   */
  name: string;
  /**
   * The URL this destination should direct to.
   */
  localUrl: string;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_externalResources {
  __typename: "ExternalResource";
  /**
   * The ID of the external resource.
   */
  externalId: string;
  /**
   * The name of the external service this resource belongs to.
   */
  externalService: ExternalService;
  /**
   * The type of external resource.
   */
  externalResourceType: ExternalResourceType;
}

export interface GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The bcc address of the Nutshell Lead.
   */
  bccAddress: string;
  number: number | null;
  /**
   * The terrority to which this lead is assigned.
   */
  territory: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_territory | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  /**
   * Is this lead "Hot"?
   */
  isHot: boolean;
  /**
   * Is this lead "Overdue"? Overdue generally means that the lead is behind a
   * designated schedule dictated by its associated sales process
   */
  isOverdue: boolean;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The deleted time for the lead if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The percentage confidence of lead success.
   */
  confidence: number;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * The anticipated close time for the lead.
   */
  anticipatedClosedTime: any | null;
  /**
   * What time does this lead become overdue in the active stage? Null if no overdue time is set.
   */
  stageOverdueTime: any | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_assignee | null;
  /**
   * The deemed "creator" of this lead. If a user has created the lead manually,
   * our UI will show the user, otherwise we’ll fallback to the origin, i.e. "API"
   * or "CSV import"
   */
  creator: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_creator;
  value: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_value | null;
  /**
   * The lead this lead was cloned from (usually null)
   */
  clonedFrom: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_clonedFrom | null;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_contacts;
  /**
   * Stages for the lead
   */
  pipelineStages: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_pipelineStages;
  /**
   * Stageset associated with the given lead
   */
  stageset: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_stageset | null;
  /**
   * The list of tags on this lead
   */
  tags: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_tags[];
  /**
   * Tag maps for the lead
   */
  tagMaps: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_tagMaps | null;
  /**
   * The outcome for this lead, if there is one.
   */
  outcome: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_outcome | null;
  /**
   * The list of destinations for this lead
   */
  sendToDestinations: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_sendToDestinations[];
  /**
   * External resources mapped to this lead
   */
  externalResources: GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead_externalResources[];
}

export type GetPageContext_pageTheUserIsCurrentlyLookingAt = GetPageContext_pageTheUserIsCurrentlyLookingAt_Stageset | GetPageContext_pageTheUserIsCurrentlyLookingAt_Lead;

export interface GetPageContext {
  /**
   * Returns an entity that can have context constructed for AI models
   */
  pageTheUserIsCurrentlyLookingAt: GetPageContext_pageTheUserIsCurrentlyLookingAt | null;
}

export interface GetPageContextVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSalesObjectionContext
// ====================================================

export interface GetSalesObjectionContext_products_edges_node {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  productId: string;
  /**
   * The name of the product
   */
  productName: string;
  /**
   * The type of the product (Good or Service)
   */
  goodOrService: ProductType;
  /**
   * The term of the product
   */
  serviceTerm: QuoteTerm | null;
}

export interface GetSalesObjectionContext_products_edges {
  __typename: "ProductsEdge";
  node: GetSalesObjectionContext_products_edges_node;
}

export interface GetSalesObjectionContext_products {
  __typename: "ProductsConnection";
  /**
   * A list of edges.
   */
  edges: GetSalesObjectionContext_products_edges[];
}

export interface GetSalesObjectionContext {
  /**
   * Returns a paging connection of products from the root of our query.
   */
  products: GetSalesObjectionContext_products | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSalesProcessContext
// ====================================================

export interface GetSalesProcessContext_pipelines_stages_activeStepTemplates_dueDate {
  __typename: "StepDueDate";
  /**
   * The reference point for this due date. This can include when the lead was created, when the stage was entered, etc.
   */
  dueFrom: number;
  /**
   * The unit to measure this step template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this step template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface GetSalesProcessContext_pipelines_stages_activeStepTemplates_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name for this slack automation.
   */
  name: string;
}

export interface GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_closedLeadAutomations_accountTypeAutomations_conditions {
  __typename: "Condition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
}

export interface GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
  /**
   * A list of conditions which must be true to activate this automation.
   */
  conditions: GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_closedLeadAutomations_accountTypeAutomations_conditions[];
}

export interface GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_closedLeadAutomations_accountTypeAutomations[];
}

export interface GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_emailAutomations_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
}

export interface GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_emailAutomations_exitsStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
}

export interface GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_emailAutomations_delay {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_emailAutomations_sendFromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_emailAutomations {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_emailAutomations_emailList | null;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_emailAutomations_entersStage;
  /**
   * The stage in which this stage subscription ends.
   */
  exitsStage: GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_emailAutomations_exitsStage | null;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_emailAutomations_delay | null;
  /**
   * Number of stages a EmailAutomation spans. If a subscription has no exit stage,
   * we count the last stage in the stageset as the "exit stage" for this count.
   */
  numberOfStagesSpanned: number;
  /**
   * The user that automated email sequences should be sent from, or null if sent from the lead assignee
   */
  sendFromUser: GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_emailAutomations_sendFromUser | null;
}

export interface GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate {
  __typename: "ProcessTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell ProcessTemplate.
   */
  name: string | null;
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_closedLeadAutomations[];
  /**
   * Returns a list of Nutshell emails automations for a given process template
   */
  emailAutomations: GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate_emailAutomations[];
}

export interface GetSalesProcessContext_pipelines_stages_activeStepTemplates {
  __typename: "StepTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The rules to determine the due date for this step.
   */
  dueDate: GetSalesProcessContext_pipelines_stages_activeStepTemplates_dueDate | null;
  /**
   * The position of the step template within its stage.
   */
  position: number;
  /**
   * The name of the Nutshell StepTemplate.
   */
  name: string;
  /**
   * The description of the Nutshell StepTemplate.
   */
  description: string | null;
  /**
   * The description of the Nutshell StepTemplate.
   */
  assignee: GetSalesProcessContext_pipelines_stages_activeStepTemplates_assignee | null;
  /**
   * The Process template this stepTemplate belongs to.
   */
  processTemplate: GetSalesProcessContext_pipelines_stages_activeStepTemplates_processTemplate;
}

export interface GetSalesProcessContext_pipelines_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  stageName: string;
  /**
   * The default confidence value of the stage.
   */
  setConfidenceOnLeadWhenItEntersThisStage: number | null;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The active copies of the step templates available for this stage
   */
  activeStepTemplates: GetSalesProcessContext_pipelines_stages_activeStepTemplates[];
}

export interface GetSalesProcessContext_pipelines {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  pipelineName: string;
  /**
   * If this stageset is the default or not
   */
  isThisTheDefaultPipeline: boolean;
  /**
   * The stages associated with this stageset
   */
  stages: GetSalesProcessContext_pipelines_stages[];
}

export interface GetSalesProcessContext_products_edges_node {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  productId: string;
  /**
   * The name of the product
   */
  productName: string;
  /**
   * The type of the product (Good or Service)
   */
  goodOrService: ProductType;
  /**
   * The term of the product
   */
  serviceTerm: QuoteTerm | null;
}

export interface GetSalesProcessContext_products_edges {
  __typename: "ProductsEdge";
  node: GetSalesProcessContext_products_edges_node;
}

export interface GetSalesProcessContext_products {
  __typename: "ProductsConnection";
  /**
   * A list of edges.
   */
  edges: GetSalesProcessContext_products_edges[];
}

export interface GetSalesProcessContext {
  /**
   * Returns a list of Nutshell Stagesets
   */
  pipelines: GetSalesProcessContext_pipelines[];
  /**
   * Returns a paging connection of products from the root of our query.
   */
  products: GetSalesProcessContext_products | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTeamAiIdentity
// ====================================================

export interface GetTeamAiIdentity_teamAiIdentity {
  __typename: "TeamAiIdentity";
  /**
   * TeamAI's unique identifier for the user
   */
  userId: string;
  /**
   * The message authentication code (MAC) for the TeamAI user ID
   */
  userHash: string;
}

export interface GetTeamAiIdentity_loggedInUser {
  __typename: "User";
  firstName: string | null;
  lastName: string | null;
}

export interface GetTeamAiIdentity {
  /**
   * Get the TeamAiIdentity for the logged in user
   */
  teamAiIdentity: GetTeamAiIdentity_teamAiIdentity;
  /**
   * Returns the requesting user. This is essentially the logged in user, but in an
   * API context, they might not be any "logged in"
   */
  loggedInUser: GetTeamAiIdentity_loggedInUser;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetChangeLog
// ====================================================

export interface GetChangeLog_changelog_pageInfo {
  __typename: "PageInfo";
  endCursor: string | null;
  hasNextPage: boolean;
}

export interface GetChangeLog_changelog_edges_node_actor_Contact {
  __typename: "Contact" | "Account" | "Form" | "MaUrl";
}

export interface GetChangeLog_changelog_edges_node_actor_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetChangeLog_changelog_edges_node_actor_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type GetChangeLog_changelog_edges_node_actor = GetChangeLog_changelog_edges_node_actor_Contact | GetChangeLog_changelog_edges_node_actor_User | GetChangeLog_changelog_edges_node_actor_Origin;

export interface GetChangeLog_changelog_edges_node_origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetChangeLog_changelog_edges_node_changes {
  __typename: "ChangeLogChange";
  /**
   * The change as a human readable string
   */
  description: string | null;
}

export interface GetChangeLog_changelog_edges_node_automations {
  __typename: "Automation";
  /**
   * The change as a human readable string
   */
  humanReadableDescription: string | null;
}

export interface GetChangeLog_changelog_edges_node {
  __typename: "TimelineEvent";
  /**
   * The type of change i.e. created, modified, deleted, etc
   */
  changeType: ChangeType;
  changeTime: any;
  /**
   * The change as a human readable string
   */
  description: string | null;
  /**
   * The entity that triggered the change_log entry
   */
  actor: GetChangeLog_changelog_edges_node_actor;
  /**
   * The origin of the change_log entry
   */
  origin: GetChangeLog_changelog_edges_node_origin;
  changes: GetChangeLog_changelog_edges_node_changes[];
  automations: GetChangeLog_changelog_edges_node_automations[];
}

export interface GetChangeLog_changelog_edges {
  __typename: "TimelineEventsEdge";
  node: GetChangeLog_changelog_edges_node;
}

export interface GetChangeLog_changelog {
  __typename: "TimelineEventsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetChangeLog_changelog_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetChangeLog_changelog_edges[];
}

export interface GetChangeLog {
  /**
   * Returns the changelog for a given entity
   */
  changelog: GetChangeLog_changelog;
}

export interface GetChangeLogVariables {
  entityId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateComment
// ====================================================

export interface CreateComment_commentCreate_comment_changeLogEntry {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateComment_commentCreate_comment_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateComment_commentCreate_comment_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: CreateComment_commentCreate_comment_reactions_creatorUser;
}

export interface CreateComment_commentCreate_comment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  htmlUrl: string | null;
}

export interface CreateComment_commentCreate_comment {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Change log associated with the comment
   */
  changeLogEntry: CreateComment_commentCreate_comment_changeLogEntry | null;
  /**
   * User reactions left for the comment change log entry
   */
  reactions: CreateComment_commentCreate_comment_reactions[];
  /**
   * The user who created the comment.
   */
  creatorUser: CreateComment_commentCreate_comment_creatorUser;
  /**
   * The created time for the comment.
   */
  createdTime: any;
  /**
   * True if this comment can be deleted
   */
  isDeleteable: boolean;
}

export interface CreateComment_commentCreate {
  __typename: "CreateCommentPayload";
  /**
   * The newly created comment
   */
  comment: CreateComment_commentCreate_comment;
}

export interface CreateComment {
  /**
   * Creates a new comment
   */
  commentCreate: CreateComment_commentCreate;
}

export interface CreateCommentVariables {
  input: CreateCommentInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteNote
// ====================================================

export interface DeleteNote_noteDelete_note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DeleteNote_noteDelete {
  __typename: "DeleteNotePayload";
  /**
   * The deleted Nutshell note
   */
  note: DeleteNote_noteDelete_note;
}

export interface DeleteNote {
  /**
   * Deletes a note on a timeline entity.
   */
  noteDelete: DeleteNote_noteDelete;
}

export interface DeleteNoteVariables {
  input: DeleteNoteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateNote
// ====================================================

export interface CreateNote_noteCreate_note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CreateNote_noteCreate {
  __typename: "CreateNotePayload";
  /**
   * The newly created note
   */
  note: CreateNote_noteCreate_note;
}

export interface CreateNote {
  /**
   * Creates a new note
   */
  noteCreate: CreateNote_noteCreate;
}

export interface CreateNoteVariables {
  input: CreateNoteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: LogActivity
// ====================================================

export interface LogActivity_logActivity_activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface LogActivity_logActivity_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: LogActivity_logActivity_activity_activityType;
}

export interface LogActivity_logActivity {
  __typename: "LogActivityPayload";
  /**
   * The newly logged Nutshell activity
   */
  activity: LogActivity_logActivity_activity | null;
}

export interface LogActivity {
  /**
   * Performs a log action (with optional note for the records) on a Nutshell
   * activity, so the performing user can loop everyone into his or her actions and
   * get credit for the activity in the Nutshell quota system.
   */
  logActivity: LogActivity_logActivity | null;
}

export interface LogActivityVariables {
  input: LogActivityInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TimelineEventDelete
// ====================================================

export interface TimelineEventDelete_timelineEventDelete {
  __typename: "TimelineEventDeletePayload";
  /**
   * The id of the deleted timeline event
   */
  eventId: string;
}

export interface TimelineEventDelete {
  /**
   * Deletes an email, note, or activity from the timeline.
   */
  timelineEventDelete: TimelineEventDelete_timelineEventDelete;
}

export interface TimelineEventDeleteVariables {
  input: TimelineEventDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetPinnedEntity
// ====================================================

export interface SetPinnedEntity_setEntityPinnedStatus_pinnedInfo_pinnedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SetPinnedEntity_setEntityPinnedStatus_pinnedInfo {
  __typename: "PinnedInfo";
  pinnedTime: any | null;
  pinnedByUser: SetPinnedEntity_setEntityPinnedStatus_pinnedInfo_pinnedByUser;
}

export interface SetPinnedEntity_setEntityPinnedStatus {
  __typename: "SetEntityPinnedStatusPayload";
  /**
   * The new pinned state of the entities
   */
  pinnedInfo: SetPinnedEntity_setEntityPinnedStatus_pinnedInfo | null;
}

export interface SetPinnedEntity {
  /**
   * Updates the pinned status of an entity
   */
  setEntityPinnedStatus: SetPinnedEntity_setEntityPinnedStatus;
}

export interface SetPinnedEntityVariables {
  input: SetEntityPinnedStatusInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetChangeLogEntry
// ====================================================

export interface GetChangeLogEntry_event_actor_Form {
  __typename: "Form";
}

export interface GetChangeLogEntry_event_actor_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface GetChangeLogEntry_event_actor_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetChangeLogEntry_event_actor_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_actor_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_actor_MaUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Path to the edit page for this money page.
   */
  htmlUrlPath: string;
}

export type GetChangeLogEntry_event_actor = GetChangeLogEntry_event_actor_Form | GetChangeLogEntry_event_actor_User | GetChangeLogEntry_event_actor_Origin | GetChangeLogEntry_event_actor_Contact | GetChangeLogEntry_event_actor_Account | GetChangeLogEntry_event_actor_MaUrl;

export interface GetChangeLogEntry_event_payload_TimelineEventPayloadUnknownType {
  __typename: "TimelineEventPayloadUnknownType" | "AccountRelationshipChange" | "Quote" | "DocumentView" | "Invoice" | "Contract" | "LeadClonePayload" | "AccountContactFormerStatusChange" | "Thread" | "Message";
}

export interface GetChangeLogEntry_event_payload_Activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetChangeLogEntry_event_payload_Activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetChangeLogEntry_event_payload_Activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface GetChangeLogEntry_event_payload_Activity_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetChangeLogEntry_event_payload_Activity_relatedLeads_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetChangeLogEntry_event_payload_Activity_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_Activity_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetChangeLogEntry_event_payload_Activity_relatedLeads_contacts_primaryEdge_node;
}

export interface GetChangeLogEntry_event_payload_Activity_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetChangeLogEntry_event_payload_Activity_relatedLeads_contacts_primaryEdge | null;
}

export interface GetChangeLogEntry_event_payload_Activity_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_Activity_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetChangeLogEntry_event_payload_Activity_relatedLeads_accounts_primaryEdge_node;
}

export interface GetChangeLogEntry_event_payload_Activity_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetChangeLogEntry_event_payload_Activity_relatedLeads_accounts_primaryEdge | null;
}

export interface GetChangeLogEntry_event_payload_Activity_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: GetChangeLogEntry_event_payload_Activity_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetChangeLogEntry_event_payload_Activity_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetChangeLogEntry_event_payload_Activity_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetChangeLogEntry_event_payload_Activity_relatedLeads_accounts;
}

export interface GetChangeLogEntry_event_payload_Activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GetChangeLogEntry_event_payload_Activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface GetChangeLogEntry_event_payload_Activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: GetChangeLogEntry_event_payload_Activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: GetChangeLogEntry_event_payload_Activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface GetChangeLogEntry_event_payload_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetChangeLogEntry_event_payload_Activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetChangeLogEntry_event_payload_Activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetChangeLogEntry_event_payload_Activity_participants[];
  /**
   * Related leads for the activity.
   */
  relatedLeads: GetChangeLogEntry_event_payload_Activity_relatedLeads[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: GetChangeLogEntry_event_payload_Activity_externalMeeting | null;
}

export interface GetChangeLogEntry_event_payload_Note_entity_NoteEntityUnknownType {
  __typename: "NoteEntityUnknownType";
}

export interface GetChangeLogEntry_event_payload_Note_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_Note_entity_Activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetChangeLogEntry_event_payload_Note_entity_Activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetChangeLogEntry_event_payload_Note_entity_Activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface GetChangeLogEntry_event_payload_Note_entity_Activity_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetChangeLogEntry_event_payload_Note_entity_Activity_relatedLeads_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetChangeLogEntry_event_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetChangeLogEntry_event_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge_node;
}

export interface GetChangeLogEntry_event_payload_Note_entity_Activity_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetChangeLogEntry_event_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge | null;
}

export interface GetChangeLogEntry_event_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetChangeLogEntry_event_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge_node;
}

export interface GetChangeLogEntry_event_payload_Note_entity_Activity_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetChangeLogEntry_event_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge | null;
}

export interface GetChangeLogEntry_event_payload_Note_entity_Activity_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: GetChangeLogEntry_event_payload_Note_entity_Activity_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetChangeLogEntry_event_payload_Note_entity_Activity_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetChangeLogEntry_event_payload_Note_entity_Activity_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetChangeLogEntry_event_payload_Note_entity_Activity_relatedLeads_accounts;
}

export interface GetChangeLogEntry_event_payload_Note_entity_Activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GetChangeLogEntry_event_payload_Note_entity_Activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface GetChangeLogEntry_event_payload_Note_entity_Activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: GetChangeLogEntry_event_payload_Note_entity_Activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: GetChangeLogEntry_event_payload_Note_entity_Activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface GetChangeLogEntry_event_payload_Note_entity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetChangeLogEntry_event_payload_Note_entity_Activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetChangeLogEntry_event_payload_Note_entity_Activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetChangeLogEntry_event_payload_Note_entity_Activity_participants[];
  /**
   * Related leads for the activity.
   */
  relatedLeads: GetChangeLogEntry_event_payload_Note_entity_Activity_relatedLeads[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: GetChangeLogEntry_event_payload_Note_entity_Activity_externalMeeting | null;
}

export interface GetChangeLogEntry_event_payload_Note_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_Note_entity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetChangeLogEntry_event_payload_Note_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetChangeLogEntry_event_payload_Note_entity_Lead_value | null;
}

export interface GetChangeLogEntry_event_payload_Note_entity_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type GetChangeLogEntry_event_payload_Note_entity = GetChangeLogEntry_event_payload_Note_entity_NoteEntityUnknownType | GetChangeLogEntry_event_payload_Note_entity_Account | GetChangeLogEntry_event_payload_Note_entity_Activity | GetChangeLogEntry_event_payload_Note_entity_Contact | GetChangeLogEntry_event_payload_Note_entity_Lead | GetChangeLogEntry_event_payload_Note_entity_Thread;

export interface GetChangeLogEntry_event_payload_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
  /**
   * The htmlUrl without http: // app.nutshell.com
   */
  htmlUrlPath: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrl: string;
  /**
   * Is this note editable?
   */
  isEditable: boolean;
  /**
   * Does this note have mentioned entities? We care about this because our editing
   * flow for notes w/ mentioned entities is different than a note without entities.
   */
  hasMentionedEntities: boolean;
  /**
   * Whether note has been deleted
   */
  isDeleted: boolean;
  /**
   * The entity on which this note was written
   */
  entity: GetChangeLogEntry_event_payload_Note_entity | null;
}

export interface GetChangeLogEntry_event_payload_Email_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetChangeLogEntry_event_payload_Email_recipients_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetChangeLogEntry_event_payload_Email_recipients {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetChangeLogEntry_event_payload_Email_recipients_avatarEntity | null;
}

export interface GetChangeLogEntry_event_payload_Email_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetChangeLogEntry_event_payload_Email_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetChangeLogEntry_event_payload_Email_from_avatarEntity | null;
}

export interface GetChangeLogEntry_event_payload_Email_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface GetChangeLogEntry_event_payload_Email_emailRelatedLeads_edges_node_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetChangeLogEntry_event_payload_Email_emailRelatedLeads_edges_node_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetChangeLogEntry_event_payload_Email_emailRelatedLeads_edges_node_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_Email_emailRelatedLeads_edges_node_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetChangeLogEntry_event_payload_Email_emailRelatedLeads_edges_node_contacts_primaryEdge_node;
}

export interface GetChangeLogEntry_event_payload_Email_emailRelatedLeads_edges_node_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetChangeLogEntry_event_payload_Email_emailRelatedLeads_edges_node_contacts_primaryEdge | null;
}

export interface GetChangeLogEntry_event_payload_Email_emailRelatedLeads_edges_node_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_Email_emailRelatedLeads_edges_node_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetChangeLogEntry_event_payload_Email_emailRelatedLeads_edges_node_accounts_primaryEdge_node;
}

export interface GetChangeLogEntry_event_payload_Email_emailRelatedLeads_edges_node_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetChangeLogEntry_event_payload_Email_emailRelatedLeads_edges_node_accounts_primaryEdge | null;
}

export interface GetChangeLogEntry_event_payload_Email_emailRelatedLeads_edges_node {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: GetChangeLogEntry_event_payload_Email_emailRelatedLeads_edges_node_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetChangeLogEntry_event_payload_Email_emailRelatedLeads_edges_node_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetChangeLogEntry_event_payload_Email_emailRelatedLeads_edges_node_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetChangeLogEntry_event_payload_Email_emailRelatedLeads_edges_node_accounts;
}

export interface GetChangeLogEntry_event_payload_Email_emailRelatedLeads_edges {
  __typename: "EmailLeadsEdge";
  /**
   * Is this lead mapped to this email?
   */
  isMapped: boolean;
  node: GetChangeLogEntry_event_payload_Email_emailRelatedLeads_edges_node;
}

export interface GetChangeLogEntry_event_payload_Email_emailRelatedLeads {
  __typename: "EmailLeadsConnection";
  /**
   * A list of edges.
   */
  edges: GetChangeLogEntry_event_payload_Email_emailRelatedLeads_edges[];
}

export interface GetChangeLogEntry_event_payload_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The excerpt of this email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  /**
   * A partially-formatted version of the body of this email,for use in the expanded view in a list
   */
  emailBodyHtml: string;
  attachments: GetChangeLogEntry_event_payload_Email_attachments[];
  /**
   * True if the email is shared with other Nutshell users
   */
  isShared: boolean;
  /**
   * True if the email can be shared with other Nutshell users
   */
  isShareable: boolean;
  /**
   * Was this email a reply sent by Nutshell automatically.
   */
  isAutomatedReply: boolean;
  /**
   * Was this email sent by Nutshell automatically.
   */
  isEmailAutomation: boolean;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
  /**
   * If this is a ticket message from Zendesk, this is the id
   */
  ticketId: string | null;
  /**
   * If this is a ticket message from Zendesk, this is the url
   */
  ticketUrl: string | null;
  /**
   * Number of times this email has been viewed via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedViewsCount: number | null;
  /**
   * Number of times this email has been clicked via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedClicksCount: number | null;
  recipients: GetChangeLogEntry_event_payload_Email_recipients[];
  from: GetChangeLogEntry_event_payload_Email_from;
  /**
   * Was the email created outside of Nutshell
   */
  isInbound: boolean;
  /**
   * Was the email created in Nutshell
   */
  isOutbound: boolean;
  /**
   * Did the email fail to send
   */
  isFailed: boolean;
  /**
   * True if a Nutshell user can reply to this email
   */
  isReplyable: boolean;
  /**
   * Is this a Nutshell Marketing email
   */
  isNutshellMarketingEmail: boolean;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrlPath: string;
  /**
   * If this a Nutshell Marketing email, this is the edition
   */
  edition: GetChangeLogEntry_event_payload_Email_edition | null;
  /**
   * Gets all leads related to this email. This includes all open leads at the time
   * of send, as well as any previously/explicitly associated leads
   */
  emailRelatedLeads: GetChangeLogEntry_event_payload_Email_emailRelatedLeads;
  /**
   * How this email was added to Nutshell
   */
  originatedVia: string | null;
  /**
   * Was this email sent within the last week
   */
  sentWithinLastWeek: boolean;
  /**
   * Has this email accepted an AI reply suggestion
   */
  hasAcceptedSuggestion: boolean;
}

export interface GetChangeLogEntry_event_payload_EmailQueued_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetChangeLogEntry_event_payload_EmailQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetChangeLogEntry_event_payload_EmailQueued_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetChangeLogEntry_event_payload_EmailQueued_to_avatarEntity | null;
}

export interface GetChangeLogEntry_event_payload_EmailQueued_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetChangeLogEntry_event_payload_EmailQueued_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetChangeLogEntry_event_payload_EmailQueued_from_avatarEntity | null;
}

export interface GetChangeLogEntry_event_payload_EmailQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * The excerpt of this queued email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  /**
   * A partially-formatted version of the body of this queued email,for use in the expanded view in a list
   */
  emailBodyHtml: string;
  attachments: GetChangeLogEntry_event_payload_EmailQueued_attachments[];
  to: GetChangeLogEntry_event_payload_EmailQueued_to[];
  /**
   * The sender email address for this queued email.
   */
  from: GetChangeLogEntry_event_payload_EmailQueued_from;
  /**
   * True if this queued email is postponed and the user can retry it.
   */
  canRetry: boolean;
  /**
   * True if this is an email that looks failed to the user
   */
  isFailed: boolean;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetChangeLogEntry_event_payload_Submission_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
  formatted: string;
}

export interface GetChangeLogEntry_event_payload_Submission_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  isPrimary: boolean;
  value: GetChangeLogEntry_event_payload_Submission_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface GetChangeLogEntry_event_payload_Submission_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetChangeLogEntry_event_payload_Submission_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface GetChangeLogEntry_event_payload_Submission_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetChangeLogEntry_event_payload_Submission_booking_additionalAttendees_emailAddresses;
}

export interface GetChangeLogEntry_event_payload_Submission_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (GetChangeLogEntry_event_payload_Submission_booking_additionalAttendees | null)[];
}

export interface GetChangeLogEntry_event_payload_Submission_primaryEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_Submission_primaryEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_Submission_primaryEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetChangeLogEntry_event_payload_Submission_primaryEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetChangeLogEntry_event_payload_Submission_primaryEntity_Lead_value | null;
}

export type GetChangeLogEntry_event_payload_Submission_primaryEntity = GetChangeLogEntry_event_payload_Submission_primaryEntity_Account | GetChangeLogEntry_event_payload_Submission_primaryEntity_Contact | GetChangeLogEntry_event_payload_Submission_primaryEntity_Lead;

export interface GetChangeLogEntry_event_payload_Submission_formVersion_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetChangeLogEntry_event_payload_Submission_formVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent form of this form version
   */
  form: GetChangeLogEntry_event_payload_Submission_formVersion_form;
}

export interface GetChangeLogEntry_event_payload_Submission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface GetChangeLogEntry_event_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface GetChangeLogEntry_event_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: GetChangeLogEntry_event_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export interface GetChangeLogEntry_event_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface GetChangeLogEntry_event_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export type GetChangeLogEntry_event_payload_Submission_fields_edges_fieldValue = GetChangeLogEntry_event_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields | GetChangeLogEntry_event_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | GetChangeLogEntry_event_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle;

export interface GetChangeLogEntry_event_payload_Submission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: GetChangeLogEntry_event_payload_Submission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: GetChangeLogEntry_event_payload_Submission_fields_edges_fieldValue | null;
}

export interface GetChangeLogEntry_event_payload_Submission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: GetChangeLogEntry_event_payload_Submission_fields_edges[];
}

export interface GetChangeLogEntry_event_payload_Submission {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The url where the submission originates
   */
  submissionUrl: string;
  /**
   * The booking associated with this submission (if Scheduler)
   */
  booking: GetChangeLogEntry_event_payload_Submission_booking | null;
  /**
   * The primary entity on the submission
   */
  primaryEntity: GetChangeLogEntry_event_payload_Submission_primaryEntity | null;
  /**
   * The name of the submitted web form
   */
  formVersion: GetChangeLogEntry_event_payload_Submission_formVersion;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: GetChangeLogEntry_event_payload_Submission_fields;
}

export interface GetChangeLogEntry_event_payload_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetChangeLogEntry_event_payload_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetChangeLogEntry_event_payload_Lead_value | null;
}

export interface GetChangeLogEntry_event_payload_Chat_chatItems {
  __typename: "ChatItem";
  /**
   * Time this message was sent
   */
  timestamp: any;
  /**
   * The attrbute chatItemd by the entry
   */
  body: string;
  /**
   * Person writing this particular message
   */
  chatter: string;
  /**
   * Type of chat message
   */
  type: string;
}

export interface GetChangeLogEntry_event_payload_Chat_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetChangeLogEntry_event_payload_Chat_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetChangeLogEntry_event_payload_Chat_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface GetChangeLogEntry_event_payload_Chat_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetChangeLogEntry_event_payload_Chat_relatedLeads_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetChangeLogEntry_event_payload_Chat_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_Chat_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetChangeLogEntry_event_payload_Chat_relatedLeads_contacts_primaryEdge_node;
}

export interface GetChangeLogEntry_event_payload_Chat_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetChangeLogEntry_event_payload_Chat_relatedLeads_contacts_primaryEdge | null;
}

export interface GetChangeLogEntry_event_payload_Chat_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_Chat_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetChangeLogEntry_event_payload_Chat_relatedLeads_accounts_primaryEdge_node;
}

export interface GetChangeLogEntry_event_payload_Chat_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetChangeLogEntry_event_payload_Chat_relatedLeads_accounts_primaryEdge | null;
}

export interface GetChangeLogEntry_event_payload_Chat_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: GetChangeLogEntry_event_payload_Chat_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetChangeLogEntry_event_payload_Chat_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetChangeLogEntry_event_payload_Chat_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetChangeLogEntry_event_payload_Chat_relatedLeads_accounts;
}

export interface GetChangeLogEntry_event_payload_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * Not really sure tbh
   */
  chatItems: GetChangeLogEntry_event_payload_Chat_chatItems[];
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetChangeLogEntry_event_payload_Chat_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetChangeLogEntry_event_payload_Chat_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetChangeLogEntry_event_payload_Chat_participants[];
  /**
   * Related leads for the activity.
   */
  relatedLeads: GetChangeLogEntry_event_payload_Chat_relatedLeads[];
}

export interface GetChangeLogEntry_event_payload_Assignment_assignmentEntity_Thread {
  __typename: "Thread";
}

export interface GetChangeLogEntry_event_payload_Assignment_assignmentEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_Assignment_assignmentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * Canonical URL for an individual activity - launches a modal in this case
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_Assignment_assignmentEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_Assignment_assignmentEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_Assignment_assignmentEntity_UnknownEntityType {
  __typename: "UnknownEntityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type GetChangeLogEntry_event_payload_Assignment_assignmentEntity = GetChangeLogEntry_event_payload_Assignment_assignmentEntity_Thread | GetChangeLogEntry_event_payload_Assignment_assignmentEntity_Account | GetChangeLogEntry_event_payload_Assignment_assignmentEntity_Activity | GetChangeLogEntry_event_payload_Assignment_assignmentEntity_Contact | GetChangeLogEntry_event_payload_Assignment_assignmentEntity_Lead | GetChangeLogEntry_event_payload_Assignment_assignmentEntity_UnknownEntityType;

export interface GetChangeLogEntry_event_payload_Assignment_assigneeEntity {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetChangeLogEntry_event_payload_Assignment {
  __typename: "Assignment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity that was assigned
   */
  assignmentEntity: GetChangeLogEntry_event_payload_Assignment_assignmentEntity;
  /**
   * The entity to which the assignment was made
   */
  assigneeEntity: GetChangeLogEntry_event_payload_Assignment_assigneeEntity;
}

export interface GetChangeLogEntry_event_payload_EmailInteraction_emailDelivery_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_EmailInteraction_emailDelivery_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetChangeLogEntry_event_payload_EmailInteraction_emailDelivery_email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * A partially-formatted version of the body of this email,for use in the expanded view in a list
   */
  bodyHtml: string;
}

export interface GetChangeLogEntry_event_payload_EmailInteraction_emailDelivery {
  __typename: "EmailDelivery";
  primaryContact: GetChangeLogEntry_event_payload_EmailInteraction_emailDelivery_primaryContact | null;
  edition: GetChangeLogEntry_event_payload_EmailInteraction_emailDelivery_edition | null;
  email: GetChangeLogEntry_event_payload_EmailInteraction_emailDelivery_email | null;
}

export interface GetChangeLogEntry_event_payload_EmailInteraction {
  __typename: "EmailInteraction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: EmailInteractionType;
  link: string | null;
  emailDelivery: GetChangeLogEntry_event_payload_EmailInteraction_emailDelivery | null;
}

export interface GetChangeLogEntry_event_payload_ConstantContactContactTrackingActivity_ctctContact_contacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_ConstantContactContactTrackingActivity_ctctContact {
  __typename: "ConstantContactContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailAddress: string;
  /**
   * The Nutshell contacts associated with this CTCT contact
   */
  contacts: GetChangeLogEntry_event_payload_ConstantContactContactTrackingActivity_ctctContact_contacts[];
}

export interface GetChangeLogEntry_event_payload_ConstantContactContactTrackingActivity {
  __typename: "ConstantContactContactTrackingActivity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  campaignName: string | null;
  trackingActivityType: ConstantContactContactTrackingActivityType;
  emailSubject: string | null;
  ctctContact: GetChangeLogEntry_event_payload_ConstantContactContactTrackingActivity_ctctContact;
}

export interface GetChangeLogEntry_event_payload_EntityAttributeValueFile_eavEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_EntityAttributeValueFile_eavEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_EntityAttributeValueFile_eavEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetChangeLogEntry_event_payload_EntityAttributeValueFile_eavEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetChangeLogEntry_event_payload_EntityAttributeValueFile_eavEntity_Lead_value | null;
}

export type GetChangeLogEntry_event_payload_EntityAttributeValueFile_eavEntity = GetChangeLogEntry_event_payload_EntityAttributeValueFile_eavEntity_Account | GetChangeLogEntry_event_payload_EntityAttributeValueFile_eavEntity_Contact | GetChangeLogEntry_event_payload_EntityAttributeValueFile_eavEntity_Lead;

export interface GetChangeLogEntry_event_payload_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The entity that this file is associated with
   */
  eavEntity: GetChangeLogEntry_event_payload_EntityAttributeValueFile_eavEntity;
}

export interface GetChangeLogEntry_event_payload_Comment_parentEntity_Note_entity_Activity {
  __typename: "Activity" | "Thread" | "NoteEntityUnknownType";
}

export interface GetChangeLogEntry_event_payload_Comment_parentEntity_Note_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_Comment_parentEntity_Note_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_Comment_parentEntity_Note_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export type GetChangeLogEntry_event_payload_Comment_parentEntity_Note_entity = GetChangeLogEntry_event_payload_Comment_parentEntity_Note_entity_Activity | GetChangeLogEntry_event_payload_Comment_parentEntity_Note_entity_Contact | GetChangeLogEntry_event_payload_Comment_parentEntity_Note_entity_Account | GetChangeLogEntry_event_payload_Comment_parentEntity_Note_entity_Lead;

export interface GetChangeLogEntry_event_payload_Comment_parentEntity_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity on which this note was written
   */
  entity: GetChangeLogEntry_event_payload_Comment_parentEntity_Note_entity | null;
}

export interface GetChangeLogEntry_event_payload_Comment_parentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetChangeLogEntry_event_payload_Comment_parentEntity_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
}

export type GetChangeLogEntry_event_payload_Comment_parentEntity = GetChangeLogEntry_event_payload_Comment_parentEntity_Note | GetChangeLogEntry_event_payload_Comment_parentEntity_Activity | GetChangeLogEntry_event_payload_Comment_parentEntity_Email;

export interface GetChangeLogEntry_event_payload_Comment {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  commentId: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Deleted time for comment, null if not deleted
   */
  deletedTime: any | null;
  /**
   * The entity on which this note was written
   */
  parentEntity: GetChangeLogEntry_event_payload_Comment_parentEntity | null;
}

export interface GetChangeLogEntry_event_payload_Session_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https:             // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The `www.nutshell.com` part of https: // www.nutshell.com/features?utm_source=Google
   */
  host: string | null;
}

export interface GetChangeLogEntry_event_payload_Session_browser {
  __typename: "Browser";
  /**
   * The platform for the visit
   */
  platform: string;
  /**
   * The device type for the visit
   */
  deviceType: DeviceType;
}

export interface GetChangeLogEntry_event_payload_Session_source {
  __typename: "McfxVisitSource";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The utm_medium value for this particular visit
   */
  medium: string;
  /**
   * The utm_source value for this particular visit
   */
  source: string;
  /**
   * Then mROI channel derived from this source information
   */
  channel: string;
}

export interface GetChangeLogEntry_event_payload_Session_contact_nutshellContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_payload_Session_contact {
  __typename: "McfxContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The contact that made this form submission.
   */
  nutshellContact: GetChangeLogEntry_event_payload_Session_contact_nutshellContact | null;
}

export interface GetChangeLogEntry_event_payload_Session_visits_edges_node_maUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetChangeLogEntry_event_payload_Session_visits_edges_node_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The `/features` part of https: // www.nutshell.com/features?utm_source=Google
   */
  path: string | null;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
  /**
   * The full URL, i.e. https:      // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetChangeLogEntry_event_payload_Session_visits_edges_node {
  __typename: "Visit";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * How long the specific page visit lasted.
   */
  durationSeconds: number;
  /**
   * The marketing automation URL associated with this visit, if any.
   */
  maUrl: GetChangeLogEntry_event_payload_Session_visits_edges_node_maUrl | null;
  /**
   * The page url for this user visit.
   */
  url: GetChangeLogEntry_event_payload_Session_visits_edges_node_url;
}

export interface GetChangeLogEntry_event_payload_Session_visits_edges {
  __typename: "SessionVisitsEdge";
  node: GetChangeLogEntry_event_payload_Session_visits_edges_node;
}

export interface GetChangeLogEntry_event_payload_Session_visits {
  __typename: "SessionVisitsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The total amount of time the visits lasted.
   */
  totalDuration: number | null;
  /**
   * The number of visits that have an associated marketing automation URL.
   */
  maUrlCount: number;
  /**
   * A list of edges.
   */
  edges: GetChangeLogEntry_event_payload_Session_visits_edges[];
}

export interface GetChangeLogEntry_event_payload_Session {
  __typename: "Session";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The url for the session, used to open as a timeline entry modal.
   */
  htmlUrlPath: string;
  /**
   * Some basic info on the location of the user represented as a string.
   */
  locationSummary: string | null;
  /**
   * The session url.
   */
  url: GetChangeLogEntry_event_payload_Session_url;
  /**
   * The platform the user was on during the session.
   */
  browser: GetChangeLogEntry_event_payload_Session_browser | null;
  source: GetChangeLogEntry_event_payload_Session_source;
  /**
   * The contact associated with this session.
   */
  contact: GetChangeLogEntry_event_payload_Session_contact | null;
  visits: GetChangeLogEntry_event_payload_Session_visits;
  /**
   * When this session started. This is the value we’ll display to the user
   */
  startTime: any;
}

export type GetChangeLogEntry_event_payload = GetChangeLogEntry_event_payload_TimelineEventPayloadUnknownType | GetChangeLogEntry_event_payload_Activity | GetChangeLogEntry_event_payload_Note | GetChangeLogEntry_event_payload_Email | GetChangeLogEntry_event_payload_EmailQueued | GetChangeLogEntry_event_payload_Origin | GetChangeLogEntry_event_payload_Submission | GetChangeLogEntry_event_payload_Account | GetChangeLogEntry_event_payload_Contact | GetChangeLogEntry_event_payload_Lead | GetChangeLogEntry_event_payload_Chat | GetChangeLogEntry_event_payload_Assignment | GetChangeLogEntry_event_payload_EmailInteraction | GetChangeLogEntry_event_payload_ConstantContactContactTrackingActivity | GetChangeLogEntry_event_payload_EntityAttributeValueFile | GetChangeLogEntry_event_payload_Comment | GetChangeLogEntry_event_payload_Session;

export interface GetChangeLogEntry_event_changes {
  __typename: "ChangeLogChange";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attrbute changed by the entry
   */
  attribute: string;
  /**
   * The old value before the change
   */
  oldValue: string | null;
  /**
   * The new value after the change
   */
  newValue: string | null;
}

export interface GetChangeLogEntry_event_files_eavEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_files_eavEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetChangeLogEntry_event_files_eavEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetChangeLogEntry_event_files_eavEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetChangeLogEntry_event_files_eavEntity_Lead_value | null;
}

export type GetChangeLogEntry_event_files_eavEntity = GetChangeLogEntry_event_files_eavEntity_Account | GetChangeLogEntry_event_files_eavEntity_Contact | GetChangeLogEntry_event_files_eavEntity_Lead;

export interface GetChangeLogEntry_event_files {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The entity that this file is associated with
   */
  eavEntity: GetChangeLogEntry_event_files_eavEntity;
}

export interface GetChangeLogEntry_event_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetChangeLogEntry_event_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: GetChangeLogEntry_event_reactions_creatorUser;
}

export interface GetChangeLogEntry_event_comments_changeLogEntry {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetChangeLogEntry_event_comments_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetChangeLogEntry_event_comments_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: GetChangeLogEntry_event_comments_reactions_creatorUser;
}

export interface GetChangeLogEntry_event_comments_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  htmlUrl: string | null;
}

export interface GetChangeLogEntry_event_comments {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Change log associated with the comment
   */
  changeLogEntry: GetChangeLogEntry_event_comments_changeLogEntry | null;
  /**
   * User reactions left for the comment change log entry
   */
  reactions: GetChangeLogEntry_event_comments_reactions[];
  /**
   * The user who created the comment.
   */
  creatorUser: GetChangeLogEntry_event_comments_creatorUser;
  /**
   * The created time for the comment.
   */
  createdTime: any;
  /**
   * True if this comment can be deleted
   */
  isDeleteable: boolean;
}

export interface GetChangeLogEntry_event {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of change i.e. created, modified, deleted, etc
   */
  changeType: ChangeType;
  /**
   * The entity that triggered the change_log entry
   */
  actor: GetChangeLogEntry_event_actor;
  payload: GetChangeLogEntry_event_payload;
  changeTime: any;
  changes: GetChangeLogEntry_event_changes[];
  /**
   * A one-off property to handle the case where multiple files can be associated
   * with a single change log entry. This is the only situation where multiple
   * payloads exist on an entry, so rather than adding additional complexity to our
   * entire system, we’ll treat it as a separate property
   */
  files: GetChangeLogEntry_event_files[];
  reactions: GetChangeLogEntry_event_reactions[];
  comments: GetChangeLogEntry_event_comments[];
  /**
   * When multiple of the same entry occurs in a row, we’ll roll-up the count. For
   * example, if someone views an email 3 times in a row before a different change,
   * this value will be 3.
   */
  count: number | null;
}

export interface GetChangeLogEntry {
  /**
   * Returns a change log event for the timeline.
   */
  event: GetChangeLogEntry_event;
}

export interface GetChangeLogEntryVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEvent
// ====================================================

export interface GetEvent_event_actor_Form {
  __typename: "Form";
}

export interface GetEvent_event_actor_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface GetEvent_event_actor_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEvent_event_actor_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_actor_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_actor_MaUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Path to the edit page for this money page.
   */
  htmlUrlPath: string;
}

export type GetEvent_event_actor = GetEvent_event_actor_Form | GetEvent_event_actor_User | GetEvent_event_actor_Origin | GetEvent_event_actor_Contact | GetEvent_event_actor_Account | GetEvent_event_actor_MaUrl;

export interface GetEvent_event_payload_TimelineEventPayloadUnknownType {
  __typename: "TimelineEventPayloadUnknownType" | "AccountRelationshipChange" | "Quote" | "DocumentView" | "Invoice" | "Contract" | "LeadClonePayload" | "AccountContactFormerStatusChange" | "Thread" | "Message";
}

export interface GetEvent_event_payload_Activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetEvent_event_payload_Activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetEvent_event_payload_Activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface GetEvent_event_payload_Activity_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEvent_event_payload_Activity_relatedLeads_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEvent_event_payload_Activity_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_Activity_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetEvent_event_payload_Activity_relatedLeads_contacts_primaryEdge_node;
}

export interface GetEvent_event_payload_Activity_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEvent_event_payload_Activity_relatedLeads_contacts_primaryEdge | null;
}

export interface GetEvent_event_payload_Activity_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_Activity_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetEvent_event_payload_Activity_relatedLeads_accounts_primaryEdge_node;
}

export interface GetEvent_event_payload_Activity_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEvent_event_payload_Activity_relatedLeads_accounts_primaryEdge | null;
}

export interface GetEvent_event_payload_Activity_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: GetEvent_event_payload_Activity_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetEvent_event_payload_Activity_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetEvent_event_payload_Activity_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetEvent_event_payload_Activity_relatedLeads_accounts;
}

export interface GetEvent_event_payload_Activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GetEvent_event_payload_Activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface GetEvent_event_payload_Activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: GetEvent_event_payload_Activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: GetEvent_event_payload_Activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface GetEvent_event_payload_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetEvent_event_payload_Activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetEvent_event_payload_Activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetEvent_event_payload_Activity_participants[];
  /**
   * Related leads for the activity.
   */
  relatedLeads: GetEvent_event_payload_Activity_relatedLeads[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: GetEvent_event_payload_Activity_externalMeeting | null;
}

export interface GetEvent_event_payload_Note_entity_NoteEntityUnknownType {
  __typename: "NoteEntityUnknownType";
}

export interface GetEvent_event_payload_Note_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_Note_entity_Activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetEvent_event_payload_Note_entity_Activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetEvent_event_payload_Note_entity_Activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface GetEvent_event_payload_Note_entity_Activity_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEvent_event_payload_Note_entity_Activity_relatedLeads_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEvent_event_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetEvent_event_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge_node;
}

export interface GetEvent_event_payload_Note_entity_Activity_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEvent_event_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge | null;
}

export interface GetEvent_event_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetEvent_event_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge_node;
}

export interface GetEvent_event_payload_Note_entity_Activity_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEvent_event_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge | null;
}

export interface GetEvent_event_payload_Note_entity_Activity_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: GetEvent_event_payload_Note_entity_Activity_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetEvent_event_payload_Note_entity_Activity_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetEvent_event_payload_Note_entity_Activity_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetEvent_event_payload_Note_entity_Activity_relatedLeads_accounts;
}

export interface GetEvent_event_payload_Note_entity_Activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GetEvent_event_payload_Note_entity_Activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface GetEvent_event_payload_Note_entity_Activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: GetEvent_event_payload_Note_entity_Activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: GetEvent_event_payload_Note_entity_Activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface GetEvent_event_payload_Note_entity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetEvent_event_payload_Note_entity_Activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetEvent_event_payload_Note_entity_Activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetEvent_event_payload_Note_entity_Activity_participants[];
  /**
   * Related leads for the activity.
   */
  relatedLeads: GetEvent_event_payload_Note_entity_Activity_relatedLeads[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: GetEvent_event_payload_Note_entity_Activity_externalMeeting | null;
}

export interface GetEvent_event_payload_Note_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_Note_entity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEvent_event_payload_Note_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetEvent_event_payload_Note_entity_Lead_value | null;
}

export interface GetEvent_event_payload_Note_entity_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type GetEvent_event_payload_Note_entity = GetEvent_event_payload_Note_entity_NoteEntityUnknownType | GetEvent_event_payload_Note_entity_Account | GetEvent_event_payload_Note_entity_Activity | GetEvent_event_payload_Note_entity_Contact | GetEvent_event_payload_Note_entity_Lead | GetEvent_event_payload_Note_entity_Thread;

export interface GetEvent_event_payload_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
  /**
   * The htmlUrl without http: // app.nutshell.com
   */
  htmlUrlPath: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrl: string;
  /**
   * Is this note editable?
   */
  isEditable: boolean;
  /**
   * Does this note have mentioned entities? We care about this because our editing
   * flow for notes w/ mentioned entities is different than a note without entities.
   */
  hasMentionedEntities: boolean;
  /**
   * Whether note has been deleted
   */
  isDeleted: boolean;
  /**
   * The entity on which this note was written
   */
  entity: GetEvent_event_payload_Note_entity | null;
}

export interface GetEvent_event_payload_Email_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetEvent_event_payload_Email_recipients_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetEvent_event_payload_Email_recipients {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetEvent_event_payload_Email_recipients_avatarEntity | null;
}

export interface GetEvent_event_payload_Email_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetEvent_event_payload_Email_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetEvent_event_payload_Email_from_avatarEntity | null;
}

export interface GetEvent_event_payload_Email_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface GetEvent_event_payload_Email_emailRelatedLeads_edges_node_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEvent_event_payload_Email_emailRelatedLeads_edges_node_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEvent_event_payload_Email_emailRelatedLeads_edges_node_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_Email_emailRelatedLeads_edges_node_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetEvent_event_payload_Email_emailRelatedLeads_edges_node_contacts_primaryEdge_node;
}

export interface GetEvent_event_payload_Email_emailRelatedLeads_edges_node_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEvent_event_payload_Email_emailRelatedLeads_edges_node_contacts_primaryEdge | null;
}

export interface GetEvent_event_payload_Email_emailRelatedLeads_edges_node_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_Email_emailRelatedLeads_edges_node_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetEvent_event_payload_Email_emailRelatedLeads_edges_node_accounts_primaryEdge_node;
}

export interface GetEvent_event_payload_Email_emailRelatedLeads_edges_node_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEvent_event_payload_Email_emailRelatedLeads_edges_node_accounts_primaryEdge | null;
}

export interface GetEvent_event_payload_Email_emailRelatedLeads_edges_node {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: GetEvent_event_payload_Email_emailRelatedLeads_edges_node_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetEvent_event_payload_Email_emailRelatedLeads_edges_node_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetEvent_event_payload_Email_emailRelatedLeads_edges_node_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetEvent_event_payload_Email_emailRelatedLeads_edges_node_accounts;
}

export interface GetEvent_event_payload_Email_emailRelatedLeads_edges {
  __typename: "EmailLeadsEdge";
  /**
   * Is this lead mapped to this email?
   */
  isMapped: boolean;
  node: GetEvent_event_payload_Email_emailRelatedLeads_edges_node;
}

export interface GetEvent_event_payload_Email_emailRelatedLeads {
  __typename: "EmailLeadsConnection";
  /**
   * A list of edges.
   */
  edges: GetEvent_event_payload_Email_emailRelatedLeads_edges[];
}

export interface GetEvent_event_payload_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The excerpt of this email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  /**
   * A partially-formatted version of the body of this email,for use in the expanded view in a list
   */
  emailBodyHtml: string;
  attachments: GetEvent_event_payload_Email_attachments[];
  /**
   * True if the email is shared with other Nutshell users
   */
  isShared: boolean;
  /**
   * True if the email can be shared with other Nutshell users
   */
  isShareable: boolean;
  /**
   * Was this email a reply sent by Nutshell automatically.
   */
  isAutomatedReply: boolean;
  /**
   * Was this email sent by Nutshell automatically.
   */
  isEmailAutomation: boolean;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
  /**
   * If this is a ticket message from Zendesk, this is the id
   */
  ticketId: string | null;
  /**
   * If this is a ticket message from Zendesk, this is the url
   */
  ticketUrl: string | null;
  /**
   * Number of times this email has been viewed via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedViewsCount: number | null;
  /**
   * Number of times this email has been clicked via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedClicksCount: number | null;
  recipients: GetEvent_event_payload_Email_recipients[];
  from: GetEvent_event_payload_Email_from;
  /**
   * Was the email created outside of Nutshell
   */
  isInbound: boolean;
  /**
   * Was the email created in Nutshell
   */
  isOutbound: boolean;
  /**
   * Did the email fail to send
   */
  isFailed: boolean;
  /**
   * True if a Nutshell user can reply to this email
   */
  isReplyable: boolean;
  /**
   * Is this a Nutshell Marketing email
   */
  isNutshellMarketingEmail: boolean;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrlPath: string;
  /**
   * If this a Nutshell Marketing email, this is the edition
   */
  edition: GetEvent_event_payload_Email_edition | null;
  /**
   * Gets all leads related to this email. This includes all open leads at the time
   * of send, as well as any previously/explicitly associated leads
   */
  emailRelatedLeads: GetEvent_event_payload_Email_emailRelatedLeads;
  /**
   * How this email was added to Nutshell
   */
  originatedVia: string | null;
  /**
   * Was this email sent within the last week
   */
  sentWithinLastWeek: boolean;
  /**
   * Has this email accepted an AI reply suggestion
   */
  hasAcceptedSuggestion: boolean;
}

export interface GetEvent_event_payload_EmailQueued_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetEvent_event_payload_EmailQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetEvent_event_payload_EmailQueued_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetEvent_event_payload_EmailQueued_to_avatarEntity | null;
}

export interface GetEvent_event_payload_EmailQueued_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetEvent_event_payload_EmailQueued_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetEvent_event_payload_EmailQueued_from_avatarEntity | null;
}

export interface GetEvent_event_payload_EmailQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * The excerpt of this queued email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  /**
   * A partially-formatted version of the body of this queued email,for use in the expanded view in a list
   */
  emailBodyHtml: string;
  attachments: GetEvent_event_payload_EmailQueued_attachments[];
  to: GetEvent_event_payload_EmailQueued_to[];
  /**
   * The sender email address for this queued email.
   */
  from: GetEvent_event_payload_EmailQueued_from;
  /**
   * True if this queued email is postponed and the user can retry it.
   */
  canRetry: boolean;
  /**
   * True if this is an email that looks failed to the user
   */
  isFailed: boolean;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEvent_event_payload_Submission_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
  formatted: string;
}

export interface GetEvent_event_payload_Submission_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  isPrimary: boolean;
  value: GetEvent_event_payload_Submission_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface GetEvent_event_payload_Submission_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetEvent_event_payload_Submission_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface GetEvent_event_payload_Submission_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetEvent_event_payload_Submission_booking_additionalAttendees_emailAddresses;
}

export interface GetEvent_event_payload_Submission_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (GetEvent_event_payload_Submission_booking_additionalAttendees | null)[];
}

export interface GetEvent_event_payload_Submission_primaryEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_Submission_primaryEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_Submission_primaryEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEvent_event_payload_Submission_primaryEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetEvent_event_payload_Submission_primaryEntity_Lead_value | null;
}

export type GetEvent_event_payload_Submission_primaryEntity = GetEvent_event_payload_Submission_primaryEntity_Account | GetEvent_event_payload_Submission_primaryEntity_Contact | GetEvent_event_payload_Submission_primaryEntity_Lead;

export interface GetEvent_event_payload_Submission_formVersion_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetEvent_event_payload_Submission_formVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent form of this form version
   */
  form: GetEvent_event_payload_Submission_formVersion_form;
}

export interface GetEvent_event_payload_Submission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface GetEvent_event_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface GetEvent_event_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: GetEvent_event_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export interface GetEvent_event_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface GetEvent_event_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export type GetEvent_event_payload_Submission_fields_edges_fieldValue = GetEvent_event_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields | GetEvent_event_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | GetEvent_event_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle;

export interface GetEvent_event_payload_Submission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: GetEvent_event_payload_Submission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: GetEvent_event_payload_Submission_fields_edges_fieldValue | null;
}

export interface GetEvent_event_payload_Submission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: GetEvent_event_payload_Submission_fields_edges[];
}

export interface GetEvent_event_payload_Submission {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The url where the submission originates
   */
  submissionUrl: string;
  /**
   * The booking associated with this submission (if Scheduler)
   */
  booking: GetEvent_event_payload_Submission_booking | null;
  /**
   * The primary entity on the submission
   */
  primaryEntity: GetEvent_event_payload_Submission_primaryEntity | null;
  /**
   * The name of the submitted web form
   */
  formVersion: GetEvent_event_payload_Submission_formVersion;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: GetEvent_event_payload_Submission_fields;
}

export interface GetEvent_event_payload_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEvent_event_payload_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetEvent_event_payload_Lead_value | null;
}

export interface GetEvent_event_payload_Chat_chatItems {
  __typename: "ChatItem";
  /**
   * Time this message was sent
   */
  timestamp: any;
  /**
   * The attrbute chatItemd by the entry
   */
  body: string;
  /**
   * Person writing this particular message
   */
  chatter: string;
  /**
   * Type of chat message
   */
  type: string;
}

export interface GetEvent_event_payload_Chat_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetEvent_event_payload_Chat_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetEvent_event_payload_Chat_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface GetEvent_event_payload_Chat_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEvent_event_payload_Chat_relatedLeads_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEvent_event_payload_Chat_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_Chat_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetEvent_event_payload_Chat_relatedLeads_contacts_primaryEdge_node;
}

export interface GetEvent_event_payload_Chat_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEvent_event_payload_Chat_relatedLeads_contacts_primaryEdge | null;
}

export interface GetEvent_event_payload_Chat_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_Chat_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetEvent_event_payload_Chat_relatedLeads_accounts_primaryEdge_node;
}

export interface GetEvent_event_payload_Chat_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEvent_event_payload_Chat_relatedLeads_accounts_primaryEdge | null;
}

export interface GetEvent_event_payload_Chat_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: GetEvent_event_payload_Chat_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetEvent_event_payload_Chat_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetEvent_event_payload_Chat_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetEvent_event_payload_Chat_relatedLeads_accounts;
}

export interface GetEvent_event_payload_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * Not really sure tbh
   */
  chatItems: GetEvent_event_payload_Chat_chatItems[];
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetEvent_event_payload_Chat_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetEvent_event_payload_Chat_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetEvent_event_payload_Chat_participants[];
  /**
   * Related leads for the activity.
   */
  relatedLeads: GetEvent_event_payload_Chat_relatedLeads[];
}

export interface GetEvent_event_payload_Assignment_assignmentEntity_Thread {
  __typename: "Thread";
}

export interface GetEvent_event_payload_Assignment_assignmentEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_Assignment_assignmentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * Canonical URL for an individual activity - launches a modal in this case
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_Assignment_assignmentEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_Assignment_assignmentEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_Assignment_assignmentEntity_UnknownEntityType {
  __typename: "UnknownEntityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type GetEvent_event_payload_Assignment_assignmentEntity = GetEvent_event_payload_Assignment_assignmentEntity_Thread | GetEvent_event_payload_Assignment_assignmentEntity_Account | GetEvent_event_payload_Assignment_assignmentEntity_Activity | GetEvent_event_payload_Assignment_assignmentEntity_Contact | GetEvent_event_payload_Assignment_assignmentEntity_Lead | GetEvent_event_payload_Assignment_assignmentEntity_UnknownEntityType;

export interface GetEvent_event_payload_Assignment_assigneeEntity {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEvent_event_payload_Assignment {
  __typename: "Assignment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity that was assigned
   */
  assignmentEntity: GetEvent_event_payload_Assignment_assignmentEntity;
  /**
   * The entity to which the assignment was made
   */
  assigneeEntity: GetEvent_event_payload_Assignment_assigneeEntity;
}

export interface GetEvent_event_payload_EmailInteraction_emailDelivery_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_EmailInteraction_emailDelivery_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetEvent_event_payload_EmailInteraction_emailDelivery_email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * A partially-formatted version of the body of this email,for use in the expanded view in a list
   */
  bodyHtml: string;
}

export interface GetEvent_event_payload_EmailInteraction_emailDelivery {
  __typename: "EmailDelivery";
  primaryContact: GetEvent_event_payload_EmailInteraction_emailDelivery_primaryContact | null;
  edition: GetEvent_event_payload_EmailInteraction_emailDelivery_edition | null;
  email: GetEvent_event_payload_EmailInteraction_emailDelivery_email | null;
}

export interface GetEvent_event_payload_EmailInteraction {
  __typename: "EmailInteraction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: EmailInteractionType;
  link: string | null;
  emailDelivery: GetEvent_event_payload_EmailInteraction_emailDelivery | null;
}

export interface GetEvent_event_payload_ConstantContactContactTrackingActivity_ctctContact_contacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_ConstantContactContactTrackingActivity_ctctContact {
  __typename: "ConstantContactContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailAddress: string;
  /**
   * The Nutshell contacts associated with this CTCT contact
   */
  contacts: GetEvent_event_payload_ConstantContactContactTrackingActivity_ctctContact_contacts[];
}

export interface GetEvent_event_payload_ConstantContactContactTrackingActivity {
  __typename: "ConstantContactContactTrackingActivity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  campaignName: string | null;
  trackingActivityType: ConstantContactContactTrackingActivityType;
  emailSubject: string | null;
  ctctContact: GetEvent_event_payload_ConstantContactContactTrackingActivity_ctctContact;
}

export interface GetEvent_event_payload_EntityAttributeValueFile_eavEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_EntityAttributeValueFile_eavEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_EntityAttributeValueFile_eavEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEvent_event_payload_EntityAttributeValueFile_eavEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetEvent_event_payload_EntityAttributeValueFile_eavEntity_Lead_value | null;
}

export type GetEvent_event_payload_EntityAttributeValueFile_eavEntity = GetEvent_event_payload_EntityAttributeValueFile_eavEntity_Account | GetEvent_event_payload_EntityAttributeValueFile_eavEntity_Contact | GetEvent_event_payload_EntityAttributeValueFile_eavEntity_Lead;

export interface GetEvent_event_payload_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The entity that this file is associated with
   */
  eavEntity: GetEvent_event_payload_EntityAttributeValueFile_eavEntity;
}

export interface GetEvent_event_payload_Comment_parentEntity_Note_entity_Activity {
  __typename: "Activity" | "Thread" | "NoteEntityUnknownType";
}

export interface GetEvent_event_payload_Comment_parentEntity_Note_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_Comment_parentEntity_Note_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_Comment_parentEntity_Note_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export type GetEvent_event_payload_Comment_parentEntity_Note_entity = GetEvent_event_payload_Comment_parentEntity_Note_entity_Activity | GetEvent_event_payload_Comment_parentEntity_Note_entity_Contact | GetEvent_event_payload_Comment_parentEntity_Note_entity_Account | GetEvent_event_payload_Comment_parentEntity_Note_entity_Lead;

export interface GetEvent_event_payload_Comment_parentEntity_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity on which this note was written
   */
  entity: GetEvent_event_payload_Comment_parentEntity_Note_entity | null;
}

export interface GetEvent_event_payload_Comment_parentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetEvent_event_payload_Comment_parentEntity_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
}

export type GetEvent_event_payload_Comment_parentEntity = GetEvent_event_payload_Comment_parentEntity_Note | GetEvent_event_payload_Comment_parentEntity_Activity | GetEvent_event_payload_Comment_parentEntity_Email;

export interface GetEvent_event_payload_Comment {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  commentId: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Deleted time for comment, null if not deleted
   */
  deletedTime: any | null;
  /**
   * The entity on which this note was written
   */
  parentEntity: GetEvent_event_payload_Comment_parentEntity | null;
}

export interface GetEvent_event_payload_Session_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https:             // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The `www.nutshell.com` part of https: // www.nutshell.com/features?utm_source=Google
   */
  host: string | null;
}

export interface GetEvent_event_payload_Session_browser {
  __typename: "Browser";
  /**
   * The platform for the visit
   */
  platform: string;
  /**
   * The device type for the visit
   */
  deviceType: DeviceType;
}

export interface GetEvent_event_payload_Session_source {
  __typename: "McfxVisitSource";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The utm_medium value for this particular visit
   */
  medium: string;
  /**
   * The utm_source value for this particular visit
   */
  source: string;
  /**
   * Then mROI channel derived from this source information
   */
  channel: string;
}

export interface GetEvent_event_payload_Session_contact_nutshellContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_payload_Session_contact {
  __typename: "McfxContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The contact that made this form submission.
   */
  nutshellContact: GetEvent_event_payload_Session_contact_nutshellContact | null;
}

export interface GetEvent_event_payload_Session_visits_edges_node_maUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEvent_event_payload_Session_visits_edges_node_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The `/features` part of https: // www.nutshell.com/features?utm_source=Google
   */
  path: string | null;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
  /**
   * The full URL, i.e. https:      // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetEvent_event_payload_Session_visits_edges_node {
  __typename: "Visit";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * How long the specific page visit lasted.
   */
  durationSeconds: number;
  /**
   * The marketing automation URL associated with this visit, if any.
   */
  maUrl: GetEvent_event_payload_Session_visits_edges_node_maUrl | null;
  /**
   * The page url for this user visit.
   */
  url: GetEvent_event_payload_Session_visits_edges_node_url;
}

export interface GetEvent_event_payload_Session_visits_edges {
  __typename: "SessionVisitsEdge";
  node: GetEvent_event_payload_Session_visits_edges_node;
}

export interface GetEvent_event_payload_Session_visits {
  __typename: "SessionVisitsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The total amount of time the visits lasted.
   */
  totalDuration: number | null;
  /**
   * The number of visits that have an associated marketing automation URL.
   */
  maUrlCount: number;
  /**
   * A list of edges.
   */
  edges: GetEvent_event_payload_Session_visits_edges[];
}

export interface GetEvent_event_payload_Session {
  __typename: "Session";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The url for the session, used to open as a timeline entry modal.
   */
  htmlUrlPath: string;
  /**
   * Some basic info on the location of the user represented as a string.
   */
  locationSummary: string | null;
  /**
   * The session url.
   */
  url: GetEvent_event_payload_Session_url;
  /**
   * The platform the user was on during the session.
   */
  browser: GetEvent_event_payload_Session_browser | null;
  source: GetEvent_event_payload_Session_source;
  /**
   * The contact associated with this session.
   */
  contact: GetEvent_event_payload_Session_contact | null;
  visits: GetEvent_event_payload_Session_visits;
  /**
   * When this session started. This is the value we’ll display to the user
   */
  startTime: any;
}

export type GetEvent_event_payload = GetEvent_event_payload_TimelineEventPayloadUnknownType | GetEvent_event_payload_Activity | GetEvent_event_payload_Note | GetEvent_event_payload_Email | GetEvent_event_payload_EmailQueued | GetEvent_event_payload_Origin | GetEvent_event_payload_Submission | GetEvent_event_payload_Account | GetEvent_event_payload_Contact | GetEvent_event_payload_Lead | GetEvent_event_payload_Chat | GetEvent_event_payload_Assignment | GetEvent_event_payload_EmailInteraction | GetEvent_event_payload_ConstantContactContactTrackingActivity | GetEvent_event_payload_EntityAttributeValueFile | GetEvent_event_payload_Comment | GetEvent_event_payload_Session;

export interface GetEvent_event_changes {
  __typename: "ChangeLogChange";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attrbute changed by the entry
   */
  attribute: string;
  /**
   * The old value before the change
   */
  oldValue: string | null;
  /**
   * The new value after the change
   */
  newValue: string | null;
}

export interface GetEvent_event_files_eavEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_files_eavEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvent_event_files_eavEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEvent_event_files_eavEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetEvent_event_files_eavEntity_Lead_value | null;
}

export type GetEvent_event_files_eavEntity = GetEvent_event_files_eavEntity_Account | GetEvent_event_files_eavEntity_Contact | GetEvent_event_files_eavEntity_Lead;

export interface GetEvent_event_files {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The entity that this file is associated with
   */
  eavEntity: GetEvent_event_files_eavEntity;
}

export interface GetEvent_event_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEvent_event_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: GetEvent_event_reactions_creatorUser;
}

export interface GetEvent_event_comments_changeLogEntry {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEvent_event_comments_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEvent_event_comments_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: GetEvent_event_comments_reactions_creatorUser;
}

export interface GetEvent_event_comments_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  htmlUrl: string | null;
}

export interface GetEvent_event_comments {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Change log associated with the comment
   */
  changeLogEntry: GetEvent_event_comments_changeLogEntry | null;
  /**
   * User reactions left for the comment change log entry
   */
  reactions: GetEvent_event_comments_reactions[];
  /**
   * The user who created the comment.
   */
  creatorUser: GetEvent_event_comments_creatorUser;
  /**
   * The created time for the comment.
   */
  createdTime: any;
  /**
   * True if this comment can be deleted
   */
  isDeleteable: boolean;
}

export interface GetEvent_event {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of change i.e. created, modified, deleted, etc
   */
  changeType: ChangeType;
  /**
   * The entity that triggered the change_log entry
   */
  actor: GetEvent_event_actor;
  payload: GetEvent_event_payload;
  changeTime: any;
  changes: GetEvent_event_changes[];
  /**
   * A one-off property to handle the case where multiple files can be associated
   * with a single change log entry. This is the only situation where multiple
   * payloads exist on an entry, so rather than adding additional complexity to our
   * entire system, we’ll treat it as a separate property
   */
  files: GetEvent_event_files[];
  reactions: GetEvent_event_reactions[];
  comments: GetEvent_event_comments[];
  /**
   * When multiple of the same entry occurs in a row, we’ll roll-up the count. For
   * example, if someone views an email 3 times in a row before a different change,
   * this value will be 3.
   */
  count: number | null;
}

export interface GetEvent {
  /**
   * Returns a change log event for the timeline.
   */
  event: GetEvent_event;
}

export interface GetEventVariables {
  changeLogId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEvents
// ====================================================

export interface GetEvents_events_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
}

export interface GetEvents_events_edges_node_actor_Form {
  __typename: "Form";
}

export interface GetEvents_events_edges_node_actor_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface GetEvents_events_edges_node_actor_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEvents_events_edges_node_actor_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_actor_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_actor_MaUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Path to the edit page for this money page.
   */
  htmlUrlPath: string;
}

export type GetEvents_events_edges_node_actor = GetEvents_events_edges_node_actor_Form | GetEvents_events_edges_node_actor_User | GetEvents_events_edges_node_actor_Origin | GetEvents_events_edges_node_actor_Contact | GetEvents_events_edges_node_actor_Account | GetEvents_events_edges_node_actor_MaUrl;

export interface GetEvents_events_edges_node_payload_TimelineEventPayloadUnknownType {
  __typename: "TimelineEventPayloadUnknownType";
}

export interface GetEvents_events_edges_node_payload_Activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface GetEvents_events_edges_node_payload_Activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetEvents_events_edges_node_payload_Activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface GetEvents_events_edges_node_payload_Activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GetEvents_events_edges_node_payload_Activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface GetEvents_events_edges_node_payload_Activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: GetEvents_events_edges_node_payload_Activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: GetEvents_events_edges_node_payload_Activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface GetEvents_events_edges_node_payload_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetEvents_events_edges_node_payload_Activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetEvents_events_edges_node_payload_Activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetEvents_events_edges_node_payload_Activity_participants[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: GetEvents_events_edges_node_payload_Activity_externalMeeting | null;
  /**
   * The transcription of the activity.
   */
  transcription: string | null;
}

export interface GetEvents_events_edges_node_payload_AccountRelationshipChange_entityAdded {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_AccountRelationshipChange {
  __typename: "AccountRelationshipChange";
  /**
   * The child account in the relationship
   */
  entityAdded: GetEvents_events_edges_node_payload_AccountRelationshipChange_entityAdded;
  /**
   * The action that was taken to create this relationship
   */
  action: AccountRelationshipChangeAction;
}

export interface GetEvents_events_edges_node_payload_AccountContactFormerStatusChange_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_AccountContactFormerStatusChange_formerStatusContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_AccountContactFormerStatusChange {
  __typename: "AccountContactFormerStatusChange";
  account: GetEvents_events_edges_node_payload_AccountContactFormerStatusChange_account;
  formerStatusContact: GetEvents_events_edges_node_payload_AccountContactFormerStatusChange_formerStatusContact;
  formerStatusAction: AccountContactFormerStatusChangeAction;
}

export interface GetEvents_events_edges_node_payload_Note_entity_NoteEntityUnknownType {
  __typename: "NoteEntityUnknownType";
}

export interface GetEvents_events_edges_node_payload_Note_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_Note_entity_Activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetEvents_events_edges_node_payload_Note_entity_Activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetEvents_events_edges_node_payload_Note_entity_Activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface GetEvents_events_edges_node_payload_Note_entity_Activity_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEvents_events_edges_node_payload_Note_entity_Activity_relatedLeads_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEvents_events_edges_node_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetEvents_events_edges_node_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge_node;
}

export interface GetEvents_events_edges_node_payload_Note_entity_Activity_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEvents_events_edges_node_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge | null;
}

export interface GetEvents_events_edges_node_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetEvents_events_edges_node_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge_node;
}

export interface GetEvents_events_edges_node_payload_Note_entity_Activity_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEvents_events_edges_node_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge | null;
}

export interface GetEvents_events_edges_node_payload_Note_entity_Activity_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: GetEvents_events_edges_node_payload_Note_entity_Activity_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetEvents_events_edges_node_payload_Note_entity_Activity_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetEvents_events_edges_node_payload_Note_entity_Activity_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetEvents_events_edges_node_payload_Note_entity_Activity_relatedLeads_accounts;
}

export interface GetEvents_events_edges_node_payload_Note_entity_Activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GetEvents_events_edges_node_payload_Note_entity_Activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface GetEvents_events_edges_node_payload_Note_entity_Activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: GetEvents_events_edges_node_payload_Note_entity_Activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: GetEvents_events_edges_node_payload_Note_entity_Activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface GetEvents_events_edges_node_payload_Note_entity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetEvents_events_edges_node_payload_Note_entity_Activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetEvents_events_edges_node_payload_Note_entity_Activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetEvents_events_edges_node_payload_Note_entity_Activity_participants[];
  /**
   * Related leads for the activity.
   */
  relatedLeads: GetEvents_events_edges_node_payload_Note_entity_Activity_relatedLeads[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: GetEvents_events_edges_node_payload_Note_entity_Activity_externalMeeting | null;
}

export interface GetEvents_events_edges_node_payload_Note_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_Note_entity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEvents_events_edges_node_payload_Note_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetEvents_events_edges_node_payload_Note_entity_Lead_value | null;
}

export interface GetEvents_events_edges_node_payload_Note_entity_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type GetEvents_events_edges_node_payload_Note_entity = GetEvents_events_edges_node_payload_Note_entity_NoteEntityUnknownType | GetEvents_events_edges_node_payload_Note_entity_Account | GetEvents_events_edges_node_payload_Note_entity_Activity | GetEvents_events_edges_node_payload_Note_entity_Contact | GetEvents_events_edges_node_payload_Note_entity_Lead | GetEvents_events_edges_node_payload_Note_entity_Thread;

export interface GetEvents_events_edges_node_payload_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
  /**
   * The htmlUrl without http: // app.nutshell.com
   */
  htmlUrlPath: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrl: string;
  /**
   * Is this note editable?
   */
  isEditable: boolean;
  /**
   * Does this note have mentioned entities? We care about this because our editing
   * flow for notes w/ mentioned entities is different than a note without entities.
   */
  hasMentionedEntities: boolean;
  /**
   * Whether note has been deleted
   */
  isDeleted: boolean;
  /**
   * The entity on which this note was written
   */
  entity: GetEvents_events_edges_node_payload_Note_entity | null;
}

export interface GetEvents_events_edges_node_payload_Email_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetEvents_events_edges_node_payload_Email_recipients_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetEvents_events_edges_node_payload_Email_recipients {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetEvents_events_edges_node_payload_Email_recipients_avatarEntity | null;
}

export interface GetEvents_events_edges_node_payload_Email_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetEvents_events_edges_node_payload_Email_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetEvents_events_edges_node_payload_Email_from_avatarEntity | null;
}

export interface GetEvents_events_edges_node_payload_Email_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface GetEvents_events_edges_node_payload_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The excerpt of this email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  /**
   * A partially-formatted version of the body of this email,for use in the expanded view in a list
   */
  emailBodyHtml: string;
  /**
   * How this email was added to Nutshell
   */
  originatedVia: string | null;
  attachments: GetEvents_events_edges_node_payload_Email_attachments[];
  /**
   * True if the email is shared with other Nutshell users
   */
  isShared: boolean;
  /**
   * True if the email can be shared with other Nutshell users
   */
  isShareable: boolean;
  /**
   * Was this email a reply sent by Nutshell automatically.
   */
  isAutomatedReply: boolean;
  /**
   * Was this email sent by Nutshell automatically.
   */
  isEmailAutomation: boolean;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
  /**
   * If this is a ticket message from Zendesk, this is the id
   */
  ticketId: string | null;
  /**
   * If this is a ticket message from Zendesk, this is the url
   */
  ticketUrl: string | null;
  /**
   * Number of times this email has been viewed via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedViewsCount: number | null;
  /**
   * Number of times this email has been clicked via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedClicksCount: number | null;
  recipients: GetEvents_events_edges_node_payload_Email_recipients[];
  from: GetEvents_events_edges_node_payload_Email_from;
  /**
   * Was the email created outside of Nutshell
   */
  isInbound: boolean;
  /**
   * Was the email created in Nutshell
   */
  isOutbound: boolean;
  /**
   * Did the email fail to send
   */
  isFailed: boolean;
  /**
   * True if a Nutshell user can reply to this email
   */
  isReplyable: boolean;
  /**
   * Is this a Nutshell Marketing email
   */
  isNutshellMarketingEmail: boolean;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrlPath: string;
  /**
   * If this a Nutshell Marketing email, this is the edition
   */
  edition: GetEvents_events_edges_node_payload_Email_edition | null;
  /**
   * Was this email sent within the last week
   */
  sentWithinLastWeek: boolean;
  /**
   * Has this email accepted an AI reply suggestion
   */
  hasAcceptedSuggestion: boolean;
}

export interface GetEvents_events_edges_node_payload_EmailQueued_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetEvents_events_edges_node_payload_EmailQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetEvents_events_edges_node_payload_EmailQueued_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetEvents_events_edges_node_payload_EmailQueued_to_avatarEntity | null;
}

export interface GetEvents_events_edges_node_payload_EmailQueued_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetEvents_events_edges_node_payload_EmailQueued_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetEvents_events_edges_node_payload_EmailQueued_from_avatarEntity | null;
}

export interface GetEvents_events_edges_node_payload_EmailQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * The excerpt of this queued email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  attachments: GetEvents_events_edges_node_payload_EmailQueued_attachments[];
  to: GetEvents_events_edges_node_payload_EmailQueued_to[];
  /**
   * The sender email address for this queued email.
   */
  from: GetEvents_events_edges_node_payload_EmailQueued_from;
  /**
   * True if this queued email is postponed and the user can retry it.
   */
  canRetry: boolean;
  /**
   * True if this is an email that looks failed to the user
   */
  isFailed: boolean;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEvents_events_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
  formatted: string;
}

export interface GetEvents_events_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  isPrimary: boolean;
  value: GetEvents_events_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface GetEvents_events_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetEvents_events_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface GetEvents_events_edges_node_payload_Submission_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetEvents_events_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses;
}

export interface GetEvents_events_edges_node_payload_Submission_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (GetEvents_events_edges_node_payload_Submission_booking_additionalAttendees | null)[];
}

export interface GetEvents_events_edges_node_payload_Submission_primaryEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_Submission_primaryEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_Submission_primaryEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEvents_events_edges_node_payload_Submission_primaryEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetEvents_events_edges_node_payload_Submission_primaryEntity_Lead_value | null;
}

export type GetEvents_events_edges_node_payload_Submission_primaryEntity = GetEvents_events_edges_node_payload_Submission_primaryEntity_Account | GetEvents_events_edges_node_payload_Submission_primaryEntity_Contact | GetEvents_events_edges_node_payload_Submission_primaryEntity_Lead;

export interface GetEvents_events_edges_node_payload_Submission_formVersion_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetEvents_events_edges_node_payload_Submission_formVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent form of this form version
   */
  form: GetEvents_events_edges_node_payload_Submission_formVersion_form;
}

export interface GetEvents_events_edges_node_payload_Submission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface GetEvents_events_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface GetEvents_events_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: GetEvents_events_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export interface GetEvents_events_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface GetEvents_events_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export type GetEvents_events_edges_node_payload_Submission_fields_edges_fieldValue = GetEvents_events_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields | GetEvents_events_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | GetEvents_events_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle;

export interface GetEvents_events_edges_node_payload_Submission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: GetEvents_events_edges_node_payload_Submission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: GetEvents_events_edges_node_payload_Submission_fields_edges_fieldValue | null;
}

export interface GetEvents_events_edges_node_payload_Submission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: GetEvents_events_edges_node_payload_Submission_fields_edges[];
}

export interface GetEvents_events_edges_node_payload_Submission {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The url where the submission originates
   */
  submissionUrl: string;
  /**
   * The booking associated with this submission (if Scheduler)
   */
  booking: GetEvents_events_edges_node_payload_Submission_booking | null;
  /**
   * The primary entity on the submission
   */
  primaryEntity: GetEvents_events_edges_node_payload_Submission_primaryEntity | null;
  /**
   * The name of the submitted web form
   */
  formVersion: GetEvents_events_edges_node_payload_Submission_formVersion;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: GetEvents_events_edges_node_payload_Submission_fields;
}

export interface GetEvents_events_edges_node_payload_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEvents_events_edges_node_payload_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetEvents_events_edges_node_payload_Lead_value | null;
}

export interface GetEvents_events_edges_node_payload_Chat_chatItems {
  __typename: "ChatItem";
  /**
   * Time this message was sent
   */
  timestamp: any;
  /**
   * The attrbute chatItemd by the entry
   */
  body: string;
  /**
   * Person writing this particular message
   */
  chatter: string;
  /**
   * Type of chat message
   */
  type: string;
}

export interface GetEvents_events_edges_node_payload_Chat_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetEvents_events_edges_node_payload_Chat_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetEvents_events_edges_node_payload_Chat_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface GetEvents_events_edges_node_payload_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * Not really sure tbh
   */
  chatItems: GetEvents_events_edges_node_payload_Chat_chatItems[];
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetEvents_events_edges_node_payload_Chat_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetEvents_events_edges_node_payload_Chat_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetEvents_events_edges_node_payload_Chat_participants[];
}

export interface GetEvents_events_edges_node_payload_Assignment_assignmentEntity_Thread {
  __typename: "Thread";
}

export interface GetEvents_events_edges_node_payload_Assignment_assignmentEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_Assignment_assignmentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * Canonical URL for an individual activity - launches a modal in this case
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_Assignment_assignmentEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_Assignment_assignmentEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_Assignment_assignmentEntity_UnknownEntityType {
  __typename: "UnknownEntityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type GetEvents_events_edges_node_payload_Assignment_assignmentEntity = GetEvents_events_edges_node_payload_Assignment_assignmentEntity_Thread | GetEvents_events_edges_node_payload_Assignment_assignmentEntity_Account | GetEvents_events_edges_node_payload_Assignment_assignmentEntity_Activity | GetEvents_events_edges_node_payload_Assignment_assignmentEntity_Contact | GetEvents_events_edges_node_payload_Assignment_assignmentEntity_Lead | GetEvents_events_edges_node_payload_Assignment_assignmentEntity_UnknownEntityType;

export interface GetEvents_events_edges_node_payload_Assignment_assigneeEntity {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEvents_events_edges_node_payload_Assignment {
  __typename: "Assignment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity that was assigned
   */
  assignmentEntity: GetEvents_events_edges_node_payload_Assignment_assignmentEntity;
  /**
   * The entity to which the assignment was made
   */
  assigneeEntity: GetEvents_events_edges_node_payload_Assignment_assigneeEntity;
}

export interface GetEvents_events_edges_node_payload_EmailInteraction_emailDelivery_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_EmailInteraction_emailDelivery_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetEvents_events_edges_node_payload_EmailInteraction_emailDelivery_email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrlPath: string;
}

export interface GetEvents_events_edges_node_payload_EmailInteraction_emailDelivery {
  __typename: "EmailDelivery";
  primaryContact: GetEvents_events_edges_node_payload_EmailInteraction_emailDelivery_primaryContact | null;
  edition: GetEvents_events_edges_node_payload_EmailInteraction_emailDelivery_edition | null;
  email: GetEvents_events_edges_node_payload_EmailInteraction_emailDelivery_email | null;
}

export interface GetEvents_events_edges_node_payload_EmailInteraction {
  __typename: "EmailInteraction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: EmailInteractionType;
  link: string | null;
  emailDelivery: GetEvents_events_edges_node_payload_EmailInteraction_emailDelivery | null;
}

export interface GetEvents_events_edges_node_payload_ConstantContactContactTrackingActivity_ctctContact_contacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_ConstantContactContactTrackingActivity_ctctContact {
  __typename: "ConstantContactContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailAddress: string;
  /**
   * The Nutshell contacts associated with this CTCT contact
   */
  contacts: GetEvents_events_edges_node_payload_ConstantContactContactTrackingActivity_ctctContact_contacts[];
}

export interface GetEvents_events_edges_node_payload_ConstantContactContactTrackingActivity {
  __typename: "ConstantContactContactTrackingActivity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  campaignName: string | null;
  trackingActivityType: ConstantContactContactTrackingActivityType;
  emailSubject: string | null;
  ctctContact: GetEvents_events_edges_node_payload_ConstantContactContactTrackingActivity_ctctContact;
}

export interface GetEvents_events_edges_node_payload_EntityAttributeValueFile_eavEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_EntityAttributeValueFile_eavEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_EntityAttributeValueFile_eavEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEvents_events_edges_node_payload_EntityAttributeValueFile_eavEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetEvents_events_edges_node_payload_EntityAttributeValueFile_eavEntity_Lead_value | null;
}

export type GetEvents_events_edges_node_payload_EntityAttributeValueFile_eavEntity = GetEvents_events_edges_node_payload_EntityAttributeValueFile_eavEntity_Account | GetEvents_events_edges_node_payload_EntityAttributeValueFile_eavEntity_Contact | GetEvents_events_edges_node_payload_EntityAttributeValueFile_eavEntity_Lead;

export interface GetEvents_events_edges_node_payload_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The entity that this file is associated with
   */
  eavEntity: GetEvents_events_edges_node_payload_EntityAttributeValueFile_eavEntity;
}

export interface GetEvents_events_edges_node_payload_Comment_parentEntity_Note_entity_Activity {
  __typename: "Activity" | "Thread" | "NoteEntityUnknownType";
}

export interface GetEvents_events_edges_node_payload_Comment_parentEntity_Note_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_Comment_parentEntity_Note_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_Comment_parentEntity_Note_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export type GetEvents_events_edges_node_payload_Comment_parentEntity_Note_entity = GetEvents_events_edges_node_payload_Comment_parentEntity_Note_entity_Activity | GetEvents_events_edges_node_payload_Comment_parentEntity_Note_entity_Contact | GetEvents_events_edges_node_payload_Comment_parentEntity_Note_entity_Account | GetEvents_events_edges_node_payload_Comment_parentEntity_Note_entity_Lead;

export interface GetEvents_events_edges_node_payload_Comment_parentEntity_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity on which this note was written
   */
  entity: GetEvents_events_edges_node_payload_Comment_parentEntity_Note_entity | null;
}

export interface GetEvents_events_edges_node_payload_Comment_parentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetEvents_events_edges_node_payload_Comment_parentEntity_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
}

export type GetEvents_events_edges_node_payload_Comment_parentEntity = GetEvents_events_edges_node_payload_Comment_parentEntity_Note | GetEvents_events_edges_node_payload_Comment_parentEntity_Activity | GetEvents_events_edges_node_payload_Comment_parentEntity_Email;

export interface GetEvents_events_edges_node_payload_Comment {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  commentId: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Deleted time for comment, null if not deleted
   */
  deletedTime: any | null;
  /**
   * The entity on which this note was written
   */
  parentEntity: GetEvents_events_edges_node_payload_Comment_parentEntity | null;
}

export interface GetEvents_events_edges_node_payload_Session_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https:             // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The `www.nutshell.com` part of https: // www.nutshell.com/features?utm_source=Google
   */
  host: string | null;
}

export interface GetEvents_events_edges_node_payload_Session_browser {
  __typename: "Browser";
  /**
   * The platform for the visit
   */
  platform: string;
  /**
   * The device type for the visit
   */
  deviceType: DeviceType;
}

export interface GetEvents_events_edges_node_payload_Session_source {
  __typename: "McfxVisitSource";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The utm_medium value for this particular visit
   */
  medium: string;
  /**
   * The utm_source value for this particular visit
   */
  source: string;
  /**
   * Then mROI channel derived from this source information
   */
  channel: string;
}

export interface GetEvents_events_edges_node_payload_Session_contact_nutshellContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_Session_contact {
  __typename: "McfxContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The contact that made this form submission.
   */
  nutshellContact: GetEvents_events_edges_node_payload_Session_contact_nutshellContact | null;
}

export interface GetEvents_events_edges_node_payload_Session_visits_edges_node_maUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEvents_events_edges_node_payload_Session_visits_edges_node_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The `/features` part of https: // www.nutshell.com/features?utm_source=Google
   */
  path: string | null;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
  /**
   * The full URL, i.e. https:      // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetEvents_events_edges_node_payload_Session_visits_edges_node {
  __typename: "Visit";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * How long the specific page visit lasted.
   */
  durationSeconds: number;
  /**
   * The marketing automation URL associated with this visit, if any.
   */
  maUrl: GetEvents_events_edges_node_payload_Session_visits_edges_node_maUrl | null;
  /**
   * The page url for this user visit.
   */
  url: GetEvents_events_edges_node_payload_Session_visits_edges_node_url;
}

export interface GetEvents_events_edges_node_payload_Session_visits_edges {
  __typename: "SessionVisitsEdge";
  node: GetEvents_events_edges_node_payload_Session_visits_edges_node;
}

export interface GetEvents_events_edges_node_payload_Session_visits {
  __typename: "SessionVisitsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The total amount of time the visits lasted.
   */
  totalDuration: number | null;
  /**
   * The number of visits that have an associated marketing automation URL.
   */
  maUrlCount: number;
  /**
   * A list of edges.
   */
  edges: GetEvents_events_edges_node_payload_Session_visits_edges[];
}

export interface GetEvents_events_edges_node_payload_Session {
  __typename: "Session";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The url for the session, used to open as a timeline entry modal.
   */
  htmlUrlPath: string;
  /**
   * Some basic info on the location of the user represented as a string.
   */
  locationSummary: string | null;
  /**
   * The session url.
   */
  url: GetEvents_events_edges_node_payload_Session_url;
  /**
   * The platform the user was on during the session.
   */
  browser: GetEvents_events_edges_node_payload_Session_browser | null;
  source: GetEvents_events_edges_node_payload_Session_source;
  /**
   * The contact associated with this session.
   */
  contact: GetEvents_events_edges_node_payload_Session_contact | null;
  visits: GetEvents_events_edges_node_payload_Session_visits;
  /**
   * When this session started. This is the value we’ll display to the user
   */
  startTime: any;
}

export interface GetEvents_events_edges_node_payload_Thread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
}

export interface GetEvents_events_edges_node_payload_Thread_displayMessage_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  htmlUrl: string | null;
  avatarUrl: string;
  initials: string;
}

export interface GetEvents_events_edges_node_payload_Thread_displayMessage_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEvents_events_edges_node_payload_Thread_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The content of the message
   */
  content: string;
  /**
   * The plain text to display the message
   */
  plainTextForDisplay: string | null;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The user who created this thread
   */
  creatorUser: GetEvents_events_edges_node_payload_Thread_displayMessage_creatorUser | null;
  /**
   * The origin of the user who created this thread
   */
  creatorOrigin: GetEvents_events_edges_node_payload_Thread_displayMessage_creatorOrigin | null;
  /**
   * The images in the message
   */
  images: string[];
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
}

export interface GetEvents_events_edges_node_payload_Thread_messages {
  __typename: "ThreadMessagesConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetEvents_events_edges_node_payload_Thread_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  htmlUrl: string | null;
  avatarUrl: string;
  initials: string;
}

export interface GetEvents_events_edges_node_payload_Thread_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
}

export interface GetEvents_events_edges_node_payload_Thread_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  initials: string;
}

export interface GetEvents_events_edges_node_payload_Thread_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  initials: string;
}

export type GetEvents_events_edges_node_payload_Thread_bestEntity = GetEvents_events_edges_node_payload_Thread_bestEntity_Lead | GetEvents_events_edges_node_payload_Thread_bestEntity_Account | GetEvents_events_edges_node_payload_Thread_bestEntity_Contact;

export interface GetEvents_events_edges_node_payload_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external channel this thread is related to
   */
  externalChannel: GetEvents_events_edges_node_payload_Thread_externalChannel;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: GetEvents_events_edges_node_payload_Thread_displayMessage | null;
  /**
   * The messages associated with this thread
   */
  messages: GetEvents_events_edges_node_payload_Thread_messages;
  /**
   * the number of inbound messages on this thread
   */
  replyCount: number;
  /**
   * The user who created this thread
   */
  creatorUser: GetEvents_events_edges_node_payload_Thread_creatorUser | null;
  /**
   * The best entity associated with this thread
   */
  bestEntity: GetEvents_events_edges_node_payload_Thread_bestEntity | null;
  /**
   * Whether this thread can be reopened
   */
  canReopen: boolean;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
}

export interface GetEvents_events_edges_node_payload_Message_edition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface GetEvents_events_edges_node_payload_Message_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetEvents_events_edges_node_payload_Message_edition_campaign;
}

export interface GetEvents_events_edges_node_payload_Message_thread_bestEntity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_payload_Message_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The best entity associated with this thread
   */
  bestEntity: GetEvents_events_edges_node_payload_Message_thread_bestEntity | null;
}

export interface GetEvents_events_edges_node_payload_Message {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The edition of the message
   */
  edition: GetEvents_events_edges_node_payload_Message_edition | null;
  /**
   * The thread this message is part of
   */
  thread: GetEvents_events_edges_node_payload_Message_thread;
}

export interface GetEvents_events_edges_node_payload_Quote_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetEvents_events_edges_node_payload_Quote_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetEvents_events_edges_node_payload_Quote_lead_accounts_primaryEdge_node;
}

export interface GetEvents_events_edges_node_payload_Quote_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEvents_events_edges_node_payload_Quote_lead_accounts_primaryEdge | null;
}

export interface GetEvents_events_edges_node_payload_Quote_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetEvents_events_edges_node_payload_Quote_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetEvents_events_edges_node_payload_Quote_lead_contacts_primaryEdge_node;
}

export interface GetEvents_events_edges_node_payload_Quote_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEvents_events_edges_node_payload_Quote_lead_contacts_primaryEdge | null;
}

export interface GetEvents_events_edges_node_payload_Quote_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetEvents_events_edges_node_payload_Quote_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetEvents_events_edges_node_payload_Quote_lead_contacts;
}

export interface GetEvents_events_edges_node_payload_Quote_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetEvents_events_edges_node_payload_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetEvents_events_edges_node_payload_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: GetEvents_events_edges_node_payload_Quote_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetEvents_events_edges_node_payload_Quote_total;
  /**
   * The user that created the quote
   */
  creatorUser: GetEvents_events_edges_node_payload_Quote_creatorUser | null;
}

export interface GetEvents_events_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetEvents_events_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetEvents_events_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge_node;
}

export interface GetEvents_events_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEvents_events_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge | null;
}

export interface GetEvents_events_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetEvents_events_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetEvents_events_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge_node;
}

export interface GetEvents_events_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEvents_events_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge | null;
}

export interface GetEvents_events_edges_node_payload_DocumentView_salesDocument_Quote_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetEvents_events_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetEvents_events_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts;
}

export interface GetEvents_events_edges_node_payload_DocumentView_salesDocument_Quote_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetEvents_events_edges_node_payload_DocumentView_salesDocument_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetEvents_events_edges_node_payload_DocumentView_salesDocument_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: GetEvents_events_edges_node_payload_DocumentView_salesDocument_Quote_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetEvents_events_edges_node_payload_DocumentView_salesDocument_Quote_total;
  /**
   * The user that created the quote
   */
  creatorUser: GetEvents_events_edges_node_payload_DocumentView_salesDocument_Quote_creatorUser | null;
}

export interface GetEvents_events_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetEvents_events_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetEvents_events_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge_node;
}

export interface GetEvents_events_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEvents_events_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge | null;
}

export interface GetEvents_events_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetEvents_events_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetEvents_events_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge_node;
}

export interface GetEvents_events_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEvents_events_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge | null;
}

export interface GetEvents_events_edges_node_payload_DocumentView_salesDocument_Invoice_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetEvents_events_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetEvents_events_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts;
}

export interface GetEvents_events_edges_node_payload_DocumentView_salesDocument_Invoice_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetEvents_events_edges_node_payload_DocumentView_salesDocument_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetEvents_events_edges_node_payload_DocumentView_salesDocument_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: GetEvents_events_edges_node_payload_DocumentView_salesDocument_Invoice_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetEvents_events_edges_node_payload_DocumentView_salesDocument_Invoice_total;
  /**
   * The user that created the quote
   */
  creatorUser: GetEvents_events_edges_node_payload_DocumentView_salesDocument_Invoice_creatorUser | null;
}

export type GetEvents_events_edges_node_payload_DocumentView_salesDocument = GetEvents_events_edges_node_payload_DocumentView_salesDocument_Quote | GetEvents_events_edges_node_payload_DocumentView_salesDocument_Invoice;

export interface GetEvents_events_edges_node_payload_DocumentView_contract_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetEvents_events_edges_node_payload_DocumentView_contract_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetEvents_events_edges_node_payload_DocumentView_contract_lead_accounts_primaryEdge_node;
}

export interface GetEvents_events_edges_node_payload_DocumentView_contract_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEvents_events_edges_node_payload_DocumentView_contract_lead_accounts_primaryEdge | null;
}

export interface GetEvents_events_edges_node_payload_DocumentView_contract_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetEvents_events_edges_node_payload_DocumentView_contract_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetEvents_events_edges_node_payload_DocumentView_contract_lead_contacts_primaryEdge_node;
}

export interface GetEvents_events_edges_node_payload_DocumentView_contract_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEvents_events_edges_node_payload_DocumentView_contract_lead_contacts_primaryEdge | null;
}

export interface GetEvents_events_edges_node_payload_DocumentView_contract_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetEvents_events_edges_node_payload_DocumentView_contract_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetEvents_events_edges_node_payload_DocumentView_contract_lead_contacts;
}

export interface GetEvents_events_edges_node_payload_DocumentView_contract_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetEvents_events_edges_node_payload_DocumentView_contract {
  __typename: "Contract";
  id: string;
  /**
   * The htmlUrl path without domain.
   */
  htmlUrlPath: string;
  lead: GetEvents_events_edges_node_payload_DocumentView_contract_lead;
  displayNumber: string;
  creatorUser: GetEvents_events_edges_node_payload_DocumentView_contract_creatorUser | null;
}

export interface GetEvents_events_edges_node_payload_DocumentView {
  __typename: "DocumentView";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The quote or invoice this view is attached to, when applicable
   */
  salesDocument: GetEvents_events_edges_node_payload_DocumentView_salesDocument | null;
  /**
   * The contract this view is attached to, when applicable
   */
  contract: GetEvents_events_edges_node_payload_DocumentView_contract | null;
}

export interface GetEvents_events_edges_node_payload_Invoice_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetEvents_events_edges_node_payload_Invoice_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetEvents_events_edges_node_payload_Invoice_lead_accounts_primaryEdge_node;
}

export interface GetEvents_events_edges_node_payload_Invoice_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEvents_events_edges_node_payload_Invoice_lead_accounts_primaryEdge | null;
}

export interface GetEvents_events_edges_node_payload_Invoice_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetEvents_events_edges_node_payload_Invoice_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetEvents_events_edges_node_payload_Invoice_lead_contacts_primaryEdge_node;
}

export interface GetEvents_events_edges_node_payload_Invoice_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEvents_events_edges_node_payload_Invoice_lead_contacts_primaryEdge | null;
}

export interface GetEvents_events_edges_node_payload_Invoice_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetEvents_events_edges_node_payload_Invoice_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetEvents_events_edges_node_payload_Invoice_lead_contacts;
}

export interface GetEvents_events_edges_node_payload_Invoice_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetEvents_events_edges_node_payload_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetEvents_events_edges_node_payload_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: GetEvents_events_edges_node_payload_Invoice_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetEvents_events_edges_node_payload_Invoice_total;
  /**
   * The user that created the quote
   */
  creatorUser: GetEvents_events_edges_node_payload_Invoice_creatorUser | null;
}

export interface GetEvents_events_edges_node_payload_Contract_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetEvents_events_edges_node_payload_Contract_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetEvents_events_edges_node_payload_Contract_lead_accounts_primaryEdge_node;
}

export interface GetEvents_events_edges_node_payload_Contract_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEvents_events_edges_node_payload_Contract_lead_accounts_primaryEdge | null;
}

export interface GetEvents_events_edges_node_payload_Contract_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetEvents_events_edges_node_payload_Contract_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetEvents_events_edges_node_payload_Contract_lead_contacts_primaryEdge_node;
}

export interface GetEvents_events_edges_node_payload_Contract_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetEvents_events_edges_node_payload_Contract_lead_contacts_primaryEdge | null;
}

export interface GetEvents_events_edges_node_payload_Contract_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetEvents_events_edges_node_payload_Contract_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetEvents_events_edges_node_payload_Contract_lead_contacts;
}

export interface GetEvents_events_edges_node_payload_Contract_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetEvents_events_edges_node_payload_Contract {
  __typename: "Contract";
  id: string;
  /**
   * The htmlUrl path without domain.
   */
  htmlUrlPath: string;
  lead: GetEvents_events_edges_node_payload_Contract_lead;
  displayNumber: string;
  creatorUser: GetEvents_events_edges_node_payload_Contract_creatorUser | null;
}

export interface GetEvents_events_edges_node_payload_LeadClonePayload_original_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEvents_events_edges_node_payload_LeadClonePayload_original {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetEvents_events_edges_node_payload_LeadClonePayload_original_value | null;
}

export interface GetEvents_events_edges_node_payload_LeadClonePayload_clone_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEvents_events_edges_node_payload_LeadClonePayload_clone {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetEvents_events_edges_node_payload_LeadClonePayload_clone_value | null;
}

export interface GetEvents_events_edges_node_payload_LeadClonePayload {
  __typename: "LeadClonePayload";
  /**
   * The original lead
   */
  original: GetEvents_events_edges_node_payload_LeadClonePayload_original;
  /**
   * The cloned lead
   */
  clone: GetEvents_events_edges_node_payload_LeadClonePayload_clone;
}

export type GetEvents_events_edges_node_payload = GetEvents_events_edges_node_payload_TimelineEventPayloadUnknownType | GetEvents_events_edges_node_payload_Activity | GetEvents_events_edges_node_payload_AccountRelationshipChange | GetEvents_events_edges_node_payload_AccountContactFormerStatusChange | GetEvents_events_edges_node_payload_Note | GetEvents_events_edges_node_payload_Email | GetEvents_events_edges_node_payload_EmailQueued | GetEvents_events_edges_node_payload_Origin | GetEvents_events_edges_node_payload_Submission | GetEvents_events_edges_node_payload_Account | GetEvents_events_edges_node_payload_Contact | GetEvents_events_edges_node_payload_Lead | GetEvents_events_edges_node_payload_Chat | GetEvents_events_edges_node_payload_Assignment | GetEvents_events_edges_node_payload_EmailInteraction | GetEvents_events_edges_node_payload_ConstantContactContactTrackingActivity | GetEvents_events_edges_node_payload_EntityAttributeValueFile | GetEvents_events_edges_node_payload_Comment | GetEvents_events_edges_node_payload_Session | GetEvents_events_edges_node_payload_Thread | GetEvents_events_edges_node_payload_Message | GetEvents_events_edges_node_payload_Quote | GetEvents_events_edges_node_payload_DocumentView | GetEvents_events_edges_node_payload_Invoice | GetEvents_events_edges_node_payload_Contract | GetEvents_events_edges_node_payload_LeadClonePayload;

export interface GetEvents_events_edges_node_changes {
  __typename: "ChangeLogChange";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attrbute changed by the entry
   */
  attribute: string;
  /**
   * The old value before the change
   */
  oldValue: string | null;
  /**
   * The new value after the change
   */
  newValue: string | null;
}

export interface GetEvents_events_edges_node_files_eavEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_files_eavEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetEvents_events_edges_node_files_eavEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetEvents_events_edges_node_files_eavEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetEvents_events_edges_node_files_eavEntity_Lead_value | null;
}

export type GetEvents_events_edges_node_files_eavEntity = GetEvents_events_edges_node_files_eavEntity_Account | GetEvents_events_edges_node_files_eavEntity_Contact | GetEvents_events_edges_node_files_eavEntity_Lead;

export interface GetEvents_events_edges_node_files {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The entity that this file is associated with
   */
  eavEntity: GetEvents_events_edges_node_files_eavEntity;
}

export interface GetEvents_events_edges_node_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEvents_events_edges_node_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: GetEvents_events_edges_node_reactions_creatorUser;
}

export interface GetEvents_events_edges_node_comments_changeLogEntry {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEvents_events_edges_node_comments_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEvents_events_edges_node_comments_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: GetEvents_events_edges_node_comments_reactions_creatorUser;
}

export interface GetEvents_events_edges_node_comments_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  htmlUrl: string | null;
}

export interface GetEvents_events_edges_node_comments {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Change log associated with the comment
   */
  changeLogEntry: GetEvents_events_edges_node_comments_changeLogEntry | null;
  /**
   * User reactions left for the comment change log entry
   */
  reactions: GetEvents_events_edges_node_comments_reactions[];
  /**
   * The user who created the comment.
   */
  creatorUser: GetEvents_events_edges_node_comments_creatorUser;
  /**
   * The created time for the comment.
   */
  createdTime: any;
  /**
   * True if this comment can be deleted
   */
  isDeleteable: boolean;
}

export interface GetEvents_events_edges_node {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of change i.e. created, modified, deleted, etc
   */
  changeType: ChangeType;
  /**
   * The entity that triggered the change_log entry
   */
  actor: GetEvents_events_edges_node_actor;
  payload: GetEvents_events_edges_node_payload;
  changeTime: any;
  changes: GetEvents_events_edges_node_changes[];
  /**
   * A one-off property to handle the case where multiple files can be associated
   * with a single change log entry. This is the only situation where multiple
   * payloads exist on an entry, so rather than adding additional complexity to our
   * entire system, we’ll treat it as a separate property
   */
  files: GetEvents_events_edges_node_files[];
  reactions: GetEvents_events_edges_node_reactions[];
  comments: GetEvents_events_edges_node_comments[];
  /**
   * When multiple of the same entry occurs in a row, we’ll roll-up the count. For
   * example, if someone views an email 3 times in a row before a different change,
   * this value will be 3.
   */
  count: number | null;
}

export interface GetEvents_events_edges_pinnedInfo_pinnedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetEvents_events_edges_pinnedInfo {
  __typename: "PinnedInfo";
  pinnedTime: any | null;
  pinnedByUser: GetEvents_events_edges_pinnedInfo_pinnedByUser;
}

export interface GetEvents_events_edges {
  __typename: "TimelineEventsEdge";
  node: GetEvents_events_edges_node;
  pinnedInfo: GetEvents_events_edges_pinnedInfo | null;
}

export interface GetEvents_events {
  __typename: "TimelineEventsConnection";
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetEvents_events_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetEvents_events_edges[];
}

export interface GetEvents {
  /**
   * Returns events to display in a Nutshell timeline
   */
  events: GetEvents_events;
}

export interface GetEventsVariables {
  entityId?: string | null;
  first: number;
  before?: string | null;
  after?: string | null;
  filters?: TimelineEventsFilterInput | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetHtmlContentForEntry
// ====================================================

export interface GetHtmlContentForEntry_event_payload_Activity {
  __typename: "Activity" | "Origin" | "Submission" | "Account" | "Contact" | "Lead" | "ConstantContactContactTrackingActivity" | "Assignment" | "Comment" | "TimelineEventPayloadUnknownType" | "Chat" | "EntityAttributeValueFile" | "Session" | "AccountRelationshipChange" | "Quote" | "DocumentView" | "Invoice" | "Contract" | "LeadClonePayload" | "AccountContactFormerStatusChange" | "Thread" | "Message";
}

export interface GetHtmlContentForEntry_event_payload_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A partially-formatted version of the body of this email,for use in the expanded view in a list
   */
  emailBodyHtml: string;
}

export interface GetHtmlContentForEntry_event_payload_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  noteBodyHtml: string | null;
}

export interface GetHtmlContentForEntry_event_payload_EmailQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A partially-formatted version of the body of this queued email,for use in the expanded view in a list
   */
  bodyHtml: string;
}

export interface GetHtmlContentForEntry_event_payload_EmailInteraction_emailDelivery_email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A partially-formatted version of the body of this email,for use in the expanded view in a list
   */
  bodyHtml: string;
}

export interface GetHtmlContentForEntry_event_payload_EmailInteraction_emailDelivery {
  __typename: "EmailDelivery";
  email: GetHtmlContentForEntry_event_payload_EmailInteraction_emailDelivery_email | null;
}

export interface GetHtmlContentForEntry_event_payload_EmailInteraction {
  __typename: "EmailInteraction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailDelivery: GetHtmlContentForEntry_event_payload_EmailInteraction_emailDelivery | null;
}

export type GetHtmlContentForEntry_event_payload = GetHtmlContentForEntry_event_payload_Activity | GetHtmlContentForEntry_event_payload_Email | GetHtmlContentForEntry_event_payload_Note | GetHtmlContentForEntry_event_payload_EmailQueued | GetHtmlContentForEntry_event_payload_EmailInteraction;

export interface GetHtmlContentForEntry_event {
  __typename: "TimelineEvent";
  payload: GetHtmlContentForEntry_event_payload;
}

export interface GetHtmlContentForEntry {
  /**
   * Returns a change log event for the timeline.
   */
  event: GetHtmlContentForEntry_event;
}

export interface GetHtmlContentForEntryVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetKeyEvents
// ====================================================

export interface GetKeyEvents_keyEvents_edges_node_actor_Form {
  __typename: "Form";
}

export interface GetKeyEvents_keyEvents_edges_node_actor_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface GetKeyEvents_keyEvents_edges_node_actor_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetKeyEvents_keyEvents_edges_node_actor_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_actor_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_actor_MaUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Path to the edit page for this money page.
   */
  htmlUrlPath: string;
}

export type GetKeyEvents_keyEvents_edges_node_actor = GetKeyEvents_keyEvents_edges_node_actor_Form | GetKeyEvents_keyEvents_edges_node_actor_User | GetKeyEvents_keyEvents_edges_node_actor_Origin | GetKeyEvents_keyEvents_edges_node_actor_Contact | GetKeyEvents_keyEvents_edges_node_actor_Account | GetKeyEvents_keyEvents_edges_node_actor_MaUrl;

export interface GetKeyEvents_keyEvents_edges_node_payload_TimelineEventPayloadUnknownType {
  __typename: "TimelineEventPayloadUnknownType";
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: GetKeyEvents_keyEvents_edges_node_payload_Activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: GetKeyEvents_keyEvents_edges_node_payload_Activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetKeyEvents_keyEvents_edges_node_payload_Activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetKeyEvents_keyEvents_edges_node_payload_Activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetKeyEvents_keyEvents_edges_node_payload_Activity_participants[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: GetKeyEvents_keyEvents_edges_node_payload_Activity_externalMeeting | null;
  /**
   * The transcription of the activity.
   */
  transcription: string | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_AccountRelationshipChange_entityAdded {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_AccountRelationshipChange {
  __typename: "AccountRelationshipChange";
  /**
   * The child account in the relationship
   */
  entityAdded: GetKeyEvents_keyEvents_edges_node_payload_AccountRelationshipChange_entityAdded;
  /**
   * The action that was taken to create this relationship
   */
  action: AccountRelationshipChangeAction;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_AccountContactFormerStatusChange_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_AccountContactFormerStatusChange_formerStatusContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_AccountContactFormerStatusChange {
  __typename: "AccountContactFormerStatusChange";
  account: GetKeyEvents_keyEvents_edges_node_payload_AccountContactFormerStatusChange_account;
  formerStatusContact: GetKeyEvents_keyEvents_edges_node_payload_AccountContactFormerStatusChange_formerStatusContact;
  formerStatusAction: AccountContactFormerStatusChangeAction;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Note_entity_NoteEntityUnknownType {
  __typename: "NoteEntityUnknownType";
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_relatedLeads_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge_node;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge_node;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_relatedLeads_accounts;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_participants[];
  /**
   * Related leads for the activity.
   */
  relatedLeads: GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_relatedLeads[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity_externalMeeting | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Lead_value | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type GetKeyEvents_keyEvents_edges_node_payload_Note_entity = GetKeyEvents_keyEvents_edges_node_payload_Note_entity_NoteEntityUnknownType | GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Account | GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Activity | GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Contact | GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Lead | GetKeyEvents_keyEvents_edges_node_payload_Note_entity_Thread;

export interface GetKeyEvents_keyEvents_edges_node_payload_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
  /**
   * The htmlUrl without http: // app.nutshell.com
   */
  htmlUrlPath: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrl: string;
  /**
   * Is this note editable?
   */
  isEditable: boolean;
  /**
   * Does this note have mentioned entities? We care about this because our editing
   * flow for notes w/ mentioned entities is different than a note without entities.
   */
  hasMentionedEntities: boolean;
  /**
   * Whether note has been deleted
   */
  isDeleted: boolean;
  /**
   * The entity on which this note was written
   */
  entity: GetKeyEvents_keyEvents_edges_node_payload_Note_entity | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Email_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Email_recipients_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Email_recipients {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetKeyEvents_keyEvents_edges_node_payload_Email_recipients_avatarEntity | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Email_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Email_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetKeyEvents_keyEvents_edges_node_payload_Email_from_avatarEntity | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Email_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The excerpt of this email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  /**
   * A partially-formatted version of the body of this email,for use in the expanded view in a list
   */
  emailBodyHtml: string;
  /**
   * How this email was added to Nutshell
   */
  originatedVia: string | null;
  attachments: GetKeyEvents_keyEvents_edges_node_payload_Email_attachments[];
  /**
   * True if the email is shared with other Nutshell users
   */
  isShared: boolean;
  /**
   * True if the email can be shared with other Nutshell users
   */
  isShareable: boolean;
  /**
   * Was this email a reply sent by Nutshell automatically.
   */
  isAutomatedReply: boolean;
  /**
   * Was this email sent by Nutshell automatically.
   */
  isEmailAutomation: boolean;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
  /**
   * If this is a ticket message from Zendesk, this is the id
   */
  ticketId: string | null;
  /**
   * If this is a ticket message from Zendesk, this is the url
   */
  ticketUrl: string | null;
  /**
   * Number of times this email has been viewed via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedViewsCount: number | null;
  /**
   * Number of times this email has been clicked via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedClicksCount: number | null;
  recipients: GetKeyEvents_keyEvents_edges_node_payload_Email_recipients[];
  from: GetKeyEvents_keyEvents_edges_node_payload_Email_from;
  /**
   * Was the email created outside of Nutshell
   */
  isInbound: boolean;
  /**
   * Was the email created in Nutshell
   */
  isOutbound: boolean;
  /**
   * Did the email fail to send
   */
  isFailed: boolean;
  /**
   * True if a Nutshell user can reply to this email
   */
  isReplyable: boolean;
  /**
   * Is this a Nutshell Marketing email
   */
  isNutshellMarketingEmail: boolean;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrlPath: string;
  /**
   * If this a Nutshell Marketing email, this is the edition
   */
  edition: GetKeyEvents_keyEvents_edges_node_payload_Email_edition | null;
  /**
   * Was this email sent within the last week
   */
  sentWithinLastWeek: boolean;
  /**
   * Has this email accepted an AI reply suggestion
   */
  hasAcceptedSuggestion: boolean;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_EmailQueued_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_EmailQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_EmailQueued_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetKeyEvents_keyEvents_edges_node_payload_EmailQueued_to_avatarEntity | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_EmailQueued_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_EmailQueued_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetKeyEvents_keyEvents_edges_node_payload_EmailQueued_from_avatarEntity | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_EmailQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * The excerpt of this queued email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  attachments: GetKeyEvents_keyEvents_edges_node_payload_EmailQueued_attachments[];
  to: GetKeyEvents_keyEvents_edges_node_payload_EmailQueued_to[];
  /**
   * The sender email address for this queued email.
   */
  from: GetKeyEvents_keyEvents_edges_node_payload_EmailQueued_from;
  /**
   * True if this queued email is postponed and the user can retry it.
   */
  canRetry: boolean;
  /**
   * True if this is an email that looks failed to the user
   */
  isFailed: boolean;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
  formatted: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  isPrimary: boolean;
  value: GetKeyEvents_keyEvents_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetKeyEvents_keyEvents_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Submission_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetKeyEvents_keyEvents_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Submission_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (GetKeyEvents_keyEvents_edges_node_payload_Submission_booking_additionalAttendees | null)[];
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Submission_primaryEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Submission_primaryEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Submission_primaryEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Submission_primaryEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetKeyEvents_keyEvents_edges_node_payload_Submission_primaryEntity_Lead_value | null;
}

export type GetKeyEvents_keyEvents_edges_node_payload_Submission_primaryEntity = GetKeyEvents_keyEvents_edges_node_payload_Submission_primaryEntity_Account | GetKeyEvents_keyEvents_edges_node_payload_Submission_primaryEntity_Contact | GetKeyEvents_keyEvents_edges_node_payload_Submission_primaryEntity_Lead;

export interface GetKeyEvents_keyEvents_edges_node_payload_Submission_formVersion_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Submission_formVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent form of this form version
   */
  form: GetKeyEvents_keyEvents_edges_node_payload_Submission_formVersion_form;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Submission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: GetKeyEvents_keyEvents_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export type GetKeyEvents_keyEvents_edges_node_payload_Submission_fields_edges_fieldValue = GetKeyEvents_keyEvents_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields | GetKeyEvents_keyEvents_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | GetKeyEvents_keyEvents_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle;

export interface GetKeyEvents_keyEvents_edges_node_payload_Submission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: GetKeyEvents_keyEvents_edges_node_payload_Submission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: GetKeyEvents_keyEvents_edges_node_payload_Submission_fields_edges_fieldValue | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Submission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: GetKeyEvents_keyEvents_edges_node_payload_Submission_fields_edges[];
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Submission {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The url where the submission originates
   */
  submissionUrl: string;
  /**
   * The booking associated with this submission (if Scheduler)
   */
  booking: GetKeyEvents_keyEvents_edges_node_payload_Submission_booking | null;
  /**
   * The primary entity on the submission
   */
  primaryEntity: GetKeyEvents_keyEvents_edges_node_payload_Submission_primaryEntity | null;
  /**
   * The name of the submitted web form
   */
  formVersion: GetKeyEvents_keyEvents_edges_node_payload_Submission_formVersion;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: GetKeyEvents_keyEvents_edges_node_payload_Submission_fields;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetKeyEvents_keyEvents_edges_node_payload_Lead_value | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Chat_chatItems {
  __typename: "ChatItem";
  /**
   * Time this message was sent
   */
  timestamp: any;
  /**
   * The attrbute chatItemd by the entry
   */
  body: string;
  /**
   * Person writing this particular message
   */
  chatter: string;
  /**
   * Type of chat message
   */
  type: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Chat_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Chat_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Chat_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * Not really sure tbh
   */
  chatItems: GetKeyEvents_keyEvents_edges_node_payload_Chat_chatItems[];
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetKeyEvents_keyEvents_edges_node_payload_Chat_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetKeyEvents_keyEvents_edges_node_payload_Chat_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetKeyEvents_keyEvents_edges_node_payload_Chat_participants[];
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Assignment_assignmentEntity_Thread {
  __typename: "Thread";
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Assignment_assignmentEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Assignment_assignmentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * Canonical URL for an individual activity - launches a modal in this case
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Assignment_assignmentEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Assignment_assignmentEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Assignment_assignmentEntity_UnknownEntityType {
  __typename: "UnknownEntityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type GetKeyEvents_keyEvents_edges_node_payload_Assignment_assignmentEntity = GetKeyEvents_keyEvents_edges_node_payload_Assignment_assignmentEntity_Thread | GetKeyEvents_keyEvents_edges_node_payload_Assignment_assignmentEntity_Account | GetKeyEvents_keyEvents_edges_node_payload_Assignment_assignmentEntity_Activity | GetKeyEvents_keyEvents_edges_node_payload_Assignment_assignmentEntity_Contact | GetKeyEvents_keyEvents_edges_node_payload_Assignment_assignmentEntity_Lead | GetKeyEvents_keyEvents_edges_node_payload_Assignment_assignmentEntity_UnknownEntityType;

export interface GetKeyEvents_keyEvents_edges_node_payload_Assignment_assigneeEntity {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Assignment {
  __typename: "Assignment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity that was assigned
   */
  assignmentEntity: GetKeyEvents_keyEvents_edges_node_payload_Assignment_assignmentEntity;
  /**
   * The entity to which the assignment was made
   */
  assigneeEntity: GetKeyEvents_keyEvents_edges_node_payload_Assignment_assigneeEntity;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_EmailInteraction_emailDelivery_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_EmailInteraction_emailDelivery_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_EmailInteraction_emailDelivery_email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrlPath: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_EmailInteraction_emailDelivery {
  __typename: "EmailDelivery";
  primaryContact: GetKeyEvents_keyEvents_edges_node_payload_EmailInteraction_emailDelivery_primaryContact | null;
  edition: GetKeyEvents_keyEvents_edges_node_payload_EmailInteraction_emailDelivery_edition | null;
  email: GetKeyEvents_keyEvents_edges_node_payload_EmailInteraction_emailDelivery_email | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_EmailInteraction {
  __typename: "EmailInteraction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: EmailInteractionType;
  link: string | null;
  emailDelivery: GetKeyEvents_keyEvents_edges_node_payload_EmailInteraction_emailDelivery | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_ConstantContactContactTrackingActivity_ctctContact_contacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_ConstantContactContactTrackingActivity_ctctContact {
  __typename: "ConstantContactContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailAddress: string;
  /**
   * The Nutshell contacts associated with this CTCT contact
   */
  contacts: GetKeyEvents_keyEvents_edges_node_payload_ConstantContactContactTrackingActivity_ctctContact_contacts[];
}

export interface GetKeyEvents_keyEvents_edges_node_payload_ConstantContactContactTrackingActivity {
  __typename: "ConstantContactContactTrackingActivity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  campaignName: string | null;
  trackingActivityType: ConstantContactContactTrackingActivityType;
  emailSubject: string | null;
  ctctContact: GetKeyEvents_keyEvents_edges_node_payload_ConstantContactContactTrackingActivity_ctctContact;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_EntityAttributeValueFile_eavEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_EntityAttributeValueFile_eavEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_EntityAttributeValueFile_eavEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_EntityAttributeValueFile_eavEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetKeyEvents_keyEvents_edges_node_payload_EntityAttributeValueFile_eavEntity_Lead_value | null;
}

export type GetKeyEvents_keyEvents_edges_node_payload_EntityAttributeValueFile_eavEntity = GetKeyEvents_keyEvents_edges_node_payload_EntityAttributeValueFile_eavEntity_Account | GetKeyEvents_keyEvents_edges_node_payload_EntityAttributeValueFile_eavEntity_Contact | GetKeyEvents_keyEvents_edges_node_payload_EntityAttributeValueFile_eavEntity_Lead;

export interface GetKeyEvents_keyEvents_edges_node_payload_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The entity that this file is associated with
   */
  eavEntity: GetKeyEvents_keyEvents_edges_node_payload_EntityAttributeValueFile_eavEntity;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Comment_parentEntity_Note_entity_Activity {
  __typename: "Activity" | "Thread" | "NoteEntityUnknownType";
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Comment_parentEntity_Note_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Comment_parentEntity_Note_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Comment_parentEntity_Note_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export type GetKeyEvents_keyEvents_edges_node_payload_Comment_parentEntity_Note_entity = GetKeyEvents_keyEvents_edges_node_payload_Comment_parentEntity_Note_entity_Activity | GetKeyEvents_keyEvents_edges_node_payload_Comment_parentEntity_Note_entity_Contact | GetKeyEvents_keyEvents_edges_node_payload_Comment_parentEntity_Note_entity_Account | GetKeyEvents_keyEvents_edges_node_payload_Comment_parentEntity_Note_entity_Lead;

export interface GetKeyEvents_keyEvents_edges_node_payload_Comment_parentEntity_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity on which this note was written
   */
  entity: GetKeyEvents_keyEvents_edges_node_payload_Comment_parentEntity_Note_entity | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Comment_parentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Comment_parentEntity_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
}

export type GetKeyEvents_keyEvents_edges_node_payload_Comment_parentEntity = GetKeyEvents_keyEvents_edges_node_payload_Comment_parentEntity_Note | GetKeyEvents_keyEvents_edges_node_payload_Comment_parentEntity_Activity | GetKeyEvents_keyEvents_edges_node_payload_Comment_parentEntity_Email;

export interface GetKeyEvents_keyEvents_edges_node_payload_Comment {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  commentId: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Deleted time for comment, null if not deleted
   */
  deletedTime: any | null;
  /**
   * The entity on which this note was written
   */
  parentEntity: GetKeyEvents_keyEvents_edges_node_payload_Comment_parentEntity | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Session_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https:             // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The `www.nutshell.com` part of https: // www.nutshell.com/features?utm_source=Google
   */
  host: string | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Session_browser {
  __typename: "Browser";
  /**
   * The platform for the visit
   */
  platform: string;
  /**
   * The device type for the visit
   */
  deviceType: DeviceType;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Session_source {
  __typename: "McfxVisitSource";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The utm_medium value for this particular visit
   */
  medium: string;
  /**
   * The utm_source value for this particular visit
   */
  source: string;
  /**
   * Then mROI channel derived from this source information
   */
  channel: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Session_contact_nutshellContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Session_contact {
  __typename: "McfxContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The contact that made this form submission.
   */
  nutshellContact: GetKeyEvents_keyEvents_edges_node_payload_Session_contact_nutshellContact | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Session_visits_edges_node_maUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Session_visits_edges_node_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The `/features` part of https: // www.nutshell.com/features?utm_source=Google
   */
  path: string | null;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
  /**
   * The full URL, i.e. https:      // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Session_visits_edges_node {
  __typename: "Visit";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * How long the specific page visit lasted.
   */
  durationSeconds: number;
  /**
   * The marketing automation URL associated with this visit, if any.
   */
  maUrl: GetKeyEvents_keyEvents_edges_node_payload_Session_visits_edges_node_maUrl | null;
  /**
   * The page url for this user visit.
   */
  url: GetKeyEvents_keyEvents_edges_node_payload_Session_visits_edges_node_url;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Session_visits_edges {
  __typename: "SessionVisitsEdge";
  node: GetKeyEvents_keyEvents_edges_node_payload_Session_visits_edges_node;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Session_visits {
  __typename: "SessionVisitsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The total amount of time the visits lasted.
   */
  totalDuration: number | null;
  /**
   * The number of visits that have an associated marketing automation URL.
   */
  maUrlCount: number;
  /**
   * A list of edges.
   */
  edges: GetKeyEvents_keyEvents_edges_node_payload_Session_visits_edges[];
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Session {
  __typename: "Session";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The url for the session, used to open as a timeline entry modal.
   */
  htmlUrlPath: string;
  /**
   * Some basic info on the location of the user represented as a string.
   */
  locationSummary: string | null;
  /**
   * The session url.
   */
  url: GetKeyEvents_keyEvents_edges_node_payload_Session_url;
  /**
   * The platform the user was on during the session.
   */
  browser: GetKeyEvents_keyEvents_edges_node_payload_Session_browser | null;
  source: GetKeyEvents_keyEvents_edges_node_payload_Session_source;
  /**
   * The contact associated with this session.
   */
  contact: GetKeyEvents_keyEvents_edges_node_payload_Session_contact | null;
  visits: GetKeyEvents_keyEvents_edges_node_payload_Session_visits;
  /**
   * When this session started. This is the value we’ll display to the user
   */
  startTime: any;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Thread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Thread_displayMessage_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  htmlUrl: string | null;
  avatarUrl: string;
  initials: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Thread_displayMessage_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Thread_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The content of the message
   */
  content: string;
  /**
   * The plain text to display the message
   */
  plainTextForDisplay: string | null;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The user who created this thread
   */
  creatorUser: GetKeyEvents_keyEvents_edges_node_payload_Thread_displayMessage_creatorUser | null;
  /**
   * The origin of the user who created this thread
   */
  creatorOrigin: GetKeyEvents_keyEvents_edges_node_payload_Thread_displayMessage_creatorOrigin | null;
  /**
   * The images in the message
   */
  images: string[];
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Thread_messages {
  __typename: "ThreadMessagesConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Thread_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  htmlUrl: string | null;
  avatarUrl: string;
  initials: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Thread_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Thread_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  initials: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Thread_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  initials: string;
}

export type GetKeyEvents_keyEvents_edges_node_payload_Thread_bestEntity = GetKeyEvents_keyEvents_edges_node_payload_Thread_bestEntity_Lead | GetKeyEvents_keyEvents_edges_node_payload_Thread_bestEntity_Account | GetKeyEvents_keyEvents_edges_node_payload_Thread_bestEntity_Contact;

export interface GetKeyEvents_keyEvents_edges_node_payload_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external channel this thread is related to
   */
  externalChannel: GetKeyEvents_keyEvents_edges_node_payload_Thread_externalChannel;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: GetKeyEvents_keyEvents_edges_node_payload_Thread_displayMessage | null;
  /**
   * The messages associated with this thread
   */
  messages: GetKeyEvents_keyEvents_edges_node_payload_Thread_messages;
  /**
   * the number of inbound messages on this thread
   */
  replyCount: number;
  /**
   * The user who created this thread
   */
  creatorUser: GetKeyEvents_keyEvents_edges_node_payload_Thread_creatorUser | null;
  /**
   * The best entity associated with this thread
   */
  bestEntity: GetKeyEvents_keyEvents_edges_node_payload_Thread_bestEntity | null;
  /**
   * Whether this thread can be reopened
   */
  canReopen: boolean;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Message_edition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Message_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetKeyEvents_keyEvents_edges_node_payload_Message_edition_campaign;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Message_thread_bestEntity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Message_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The best entity associated with this thread
   */
  bestEntity: GetKeyEvents_keyEvents_edges_node_payload_Message_thread_bestEntity | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Message {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The edition of the message
   */
  edition: GetKeyEvents_keyEvents_edges_node_payload_Message_edition | null;
  /**
   * The thread this message is part of
   */
  thread: GetKeyEvents_keyEvents_edges_node_payload_Message_thread;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Quote_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Quote_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetKeyEvents_keyEvents_edges_node_payload_Quote_lead_accounts_primaryEdge_node;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Quote_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetKeyEvents_keyEvents_edges_node_payload_Quote_lead_accounts_primaryEdge | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Quote_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Quote_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetKeyEvents_keyEvents_edges_node_payload_Quote_lead_contacts_primaryEdge_node;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Quote_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetKeyEvents_keyEvents_edges_node_payload_Quote_lead_contacts_primaryEdge | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Quote_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetKeyEvents_keyEvents_edges_node_payload_Quote_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetKeyEvents_keyEvents_edges_node_payload_Quote_lead_contacts;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Quote_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: GetKeyEvents_keyEvents_edges_node_payload_Quote_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetKeyEvents_keyEvents_edges_node_payload_Quote_total;
  /**
   * The user that created the quote
   */
  creatorUser: GetKeyEvents_keyEvents_edges_node_payload_Quote_creatorUser | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge_node;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge_node;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Quote_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Quote_total;
  /**
   * The user that created the quote
   */
  creatorUser: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Quote_creatorUser | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge_node;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge_node;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Invoice_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Invoice_total;
  /**
   * The user that created the quote
   */
  creatorUser: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Invoice_creatorUser | null;
}

export type GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument = GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Quote | GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument_Invoice;

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_contract_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_contract_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_contract_lead_accounts_primaryEdge_node;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_contract_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_contract_lead_accounts_primaryEdge | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_contract_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_contract_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_contract_lead_contacts_primaryEdge_node;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_contract_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_contract_lead_contacts_primaryEdge | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_contract_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_contract_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_contract_lead_contacts;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_contract_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView_contract {
  __typename: "Contract";
  id: string;
  /**
   * The htmlUrl path without domain.
   */
  htmlUrlPath: string;
  lead: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_contract_lead;
  displayNumber: string;
  creatorUser: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_contract_creatorUser | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_DocumentView {
  __typename: "DocumentView";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The quote or invoice this view is attached to, when applicable
   */
  salesDocument: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_salesDocument | null;
  /**
   * The contract this view is attached to, when applicable
   */
  contract: GetKeyEvents_keyEvents_edges_node_payload_DocumentView_contract | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Invoice_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Invoice_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetKeyEvents_keyEvents_edges_node_payload_Invoice_lead_accounts_primaryEdge_node;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Invoice_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetKeyEvents_keyEvents_edges_node_payload_Invoice_lead_accounts_primaryEdge | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Invoice_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Invoice_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetKeyEvents_keyEvents_edges_node_payload_Invoice_lead_contacts_primaryEdge_node;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Invoice_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetKeyEvents_keyEvents_edges_node_payload_Invoice_lead_contacts_primaryEdge | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Invoice_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetKeyEvents_keyEvents_edges_node_payload_Invoice_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetKeyEvents_keyEvents_edges_node_payload_Invoice_lead_contacts;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Invoice_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: GetKeyEvents_keyEvents_edges_node_payload_Invoice_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetKeyEvents_keyEvents_edges_node_payload_Invoice_total;
  /**
   * The user that created the quote
   */
  creatorUser: GetKeyEvents_keyEvents_edges_node_payload_Invoice_creatorUser | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Contract_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Contract_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetKeyEvents_keyEvents_edges_node_payload_Contract_lead_accounts_primaryEdge_node;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Contract_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetKeyEvents_keyEvents_edges_node_payload_Contract_lead_accounts_primaryEdge | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Contract_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Contract_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetKeyEvents_keyEvents_edges_node_payload_Contract_lead_contacts_primaryEdge_node;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Contract_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetKeyEvents_keyEvents_edges_node_payload_Contract_lead_contacts_primaryEdge | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Contract_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetKeyEvents_keyEvents_edges_node_payload_Contract_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetKeyEvents_keyEvents_edges_node_payload_Contract_lead_contacts;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Contract_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_Contract {
  __typename: "Contract";
  id: string;
  /**
   * The htmlUrl path without domain.
   */
  htmlUrlPath: string;
  lead: GetKeyEvents_keyEvents_edges_node_payload_Contract_lead;
  displayNumber: string;
  creatorUser: GetKeyEvents_keyEvents_edges_node_payload_Contract_creatorUser | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_LeadClonePayload_original_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_LeadClonePayload_original {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetKeyEvents_keyEvents_edges_node_payload_LeadClonePayload_original_value | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_LeadClonePayload_clone_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_LeadClonePayload_clone {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetKeyEvents_keyEvents_edges_node_payload_LeadClonePayload_clone_value | null;
}

export interface GetKeyEvents_keyEvents_edges_node_payload_LeadClonePayload {
  __typename: "LeadClonePayload";
  /**
   * The original lead
   */
  original: GetKeyEvents_keyEvents_edges_node_payload_LeadClonePayload_original;
  /**
   * The cloned lead
   */
  clone: GetKeyEvents_keyEvents_edges_node_payload_LeadClonePayload_clone;
}

export type GetKeyEvents_keyEvents_edges_node_payload = GetKeyEvents_keyEvents_edges_node_payload_TimelineEventPayloadUnknownType | GetKeyEvents_keyEvents_edges_node_payload_Activity | GetKeyEvents_keyEvents_edges_node_payload_AccountRelationshipChange | GetKeyEvents_keyEvents_edges_node_payload_AccountContactFormerStatusChange | GetKeyEvents_keyEvents_edges_node_payload_Note | GetKeyEvents_keyEvents_edges_node_payload_Email | GetKeyEvents_keyEvents_edges_node_payload_EmailQueued | GetKeyEvents_keyEvents_edges_node_payload_Origin | GetKeyEvents_keyEvents_edges_node_payload_Submission | GetKeyEvents_keyEvents_edges_node_payload_Account | GetKeyEvents_keyEvents_edges_node_payload_Contact | GetKeyEvents_keyEvents_edges_node_payload_Lead | GetKeyEvents_keyEvents_edges_node_payload_Chat | GetKeyEvents_keyEvents_edges_node_payload_Assignment | GetKeyEvents_keyEvents_edges_node_payload_EmailInteraction | GetKeyEvents_keyEvents_edges_node_payload_ConstantContactContactTrackingActivity | GetKeyEvents_keyEvents_edges_node_payload_EntityAttributeValueFile | GetKeyEvents_keyEvents_edges_node_payload_Comment | GetKeyEvents_keyEvents_edges_node_payload_Session | GetKeyEvents_keyEvents_edges_node_payload_Thread | GetKeyEvents_keyEvents_edges_node_payload_Message | GetKeyEvents_keyEvents_edges_node_payload_Quote | GetKeyEvents_keyEvents_edges_node_payload_DocumentView | GetKeyEvents_keyEvents_edges_node_payload_Invoice | GetKeyEvents_keyEvents_edges_node_payload_Contract | GetKeyEvents_keyEvents_edges_node_payload_LeadClonePayload;

export interface GetKeyEvents_keyEvents_edges_node_changes {
  __typename: "ChangeLogChange";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attrbute changed by the entry
   */
  attribute: string;
  /**
   * The old value before the change
   */
  oldValue: string | null;
  /**
   * The new value after the change
   */
  newValue: string | null;
}

export interface GetKeyEvents_keyEvents_edges_node_files_eavEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_files_eavEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetKeyEvents_keyEvents_edges_node_files_eavEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetKeyEvents_keyEvents_edges_node_files_eavEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetKeyEvents_keyEvents_edges_node_files_eavEntity_Lead_value | null;
}

export type GetKeyEvents_keyEvents_edges_node_files_eavEntity = GetKeyEvents_keyEvents_edges_node_files_eavEntity_Account | GetKeyEvents_keyEvents_edges_node_files_eavEntity_Contact | GetKeyEvents_keyEvents_edges_node_files_eavEntity_Lead;

export interface GetKeyEvents_keyEvents_edges_node_files {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The entity that this file is associated with
   */
  eavEntity: GetKeyEvents_keyEvents_edges_node_files_eavEntity;
}

export interface GetKeyEvents_keyEvents_edges_node_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetKeyEvents_keyEvents_edges_node_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: GetKeyEvents_keyEvents_edges_node_reactions_creatorUser;
}

export interface GetKeyEvents_keyEvents_edges_node_comments_changeLogEntry {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetKeyEvents_keyEvents_edges_node_comments_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetKeyEvents_keyEvents_edges_node_comments_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: GetKeyEvents_keyEvents_edges_node_comments_reactions_creatorUser;
}

export interface GetKeyEvents_keyEvents_edges_node_comments_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  htmlUrl: string | null;
}

export interface GetKeyEvents_keyEvents_edges_node_comments {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Change log associated with the comment
   */
  changeLogEntry: GetKeyEvents_keyEvents_edges_node_comments_changeLogEntry | null;
  /**
   * User reactions left for the comment change log entry
   */
  reactions: GetKeyEvents_keyEvents_edges_node_comments_reactions[];
  /**
   * The user who created the comment.
   */
  creatorUser: GetKeyEvents_keyEvents_edges_node_comments_creatorUser;
  /**
   * The created time for the comment.
   */
  createdTime: any;
  /**
   * True if this comment can be deleted
   */
  isDeleteable: boolean;
}

export interface GetKeyEvents_keyEvents_edges_node {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of change i.e. created, modified, deleted, etc
   */
  changeType: ChangeType;
  /**
   * The entity that triggered the change_log entry
   */
  actor: GetKeyEvents_keyEvents_edges_node_actor;
  payload: GetKeyEvents_keyEvents_edges_node_payload;
  changeTime: any;
  changes: GetKeyEvents_keyEvents_edges_node_changes[];
  /**
   * A one-off property to handle the case where multiple files can be associated
   * with a single change log entry. This is the only situation where multiple
   * payloads exist on an entry, so rather than adding additional complexity to our
   * entire system, we’ll treat it as a separate property
   */
  files: GetKeyEvents_keyEvents_edges_node_files[];
  reactions: GetKeyEvents_keyEvents_edges_node_reactions[];
  comments: GetKeyEvents_keyEvents_edges_node_comments[];
  /**
   * When multiple of the same entry occurs in a row, we’ll roll-up the count. For
   * example, if someone views an email 3 times in a row before a different change,
   * this value will be 3.
   */
  count: number | null;
}

export interface GetKeyEvents_keyEvents_edges_pinnedInfo_pinnedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetKeyEvents_keyEvents_edges_pinnedInfo {
  __typename: "PinnedInfo";
  pinnedTime: any | null;
  pinnedByUser: GetKeyEvents_keyEvents_edges_pinnedInfo_pinnedByUser;
}

export interface GetKeyEvents_keyEvents_edges {
  __typename: "TimelineEventsEdge";
  node: GetKeyEvents_keyEvents_edges_node;
  pinnedInfo: GetKeyEvents_keyEvents_edges_pinnedInfo | null;
}

export interface GetKeyEvents_keyEvents {
  __typename: "TimelineEventsConnection";
  /**
   * A list of edges.
   */
  edges: GetKeyEvents_keyEvents_edges[];
}

export interface GetKeyEvents {
  /**
   * A list of timeline events representing entities that have been marked as key events
   */
  keyEvents: GetKeyEvents_keyEvents;
}

export interface GetKeyEventsVariables {
  input: TimelineEventsKeyInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetOpenThreads
// ====================================================

export interface GetOpenThreads_openThreads_actor_Form {
  __typename: "Form";
}

export interface GetOpenThreads_openThreads_actor_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface GetOpenThreads_openThreads_actor_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetOpenThreads_openThreads_actor_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_actor_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_actor_MaUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Path to the edit page for this money page.
   */
  htmlUrlPath: string;
}

export type GetOpenThreads_openThreads_actor = GetOpenThreads_openThreads_actor_Form | GetOpenThreads_openThreads_actor_User | GetOpenThreads_openThreads_actor_Origin | GetOpenThreads_openThreads_actor_Contact | GetOpenThreads_openThreads_actor_Account | GetOpenThreads_openThreads_actor_MaUrl;

export interface GetOpenThreads_openThreads_payload_TimelineEventPayloadUnknownType {
  __typename: "TimelineEventPayloadUnknownType";
}

export interface GetOpenThreads_openThreads_payload_Activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface GetOpenThreads_openThreads_payload_Activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetOpenThreads_openThreads_payload_Activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface GetOpenThreads_openThreads_payload_Activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GetOpenThreads_openThreads_payload_Activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface GetOpenThreads_openThreads_payload_Activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: GetOpenThreads_openThreads_payload_Activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: GetOpenThreads_openThreads_payload_Activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface GetOpenThreads_openThreads_payload_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetOpenThreads_openThreads_payload_Activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetOpenThreads_openThreads_payload_Activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetOpenThreads_openThreads_payload_Activity_participants[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: GetOpenThreads_openThreads_payload_Activity_externalMeeting | null;
  /**
   * The transcription of the activity.
   */
  transcription: string | null;
}

export interface GetOpenThreads_openThreads_payload_AccountRelationshipChange_entityAdded {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_AccountRelationshipChange {
  __typename: "AccountRelationshipChange";
  /**
   * The child account in the relationship
   */
  entityAdded: GetOpenThreads_openThreads_payload_AccountRelationshipChange_entityAdded;
  /**
   * The action that was taken to create this relationship
   */
  action: AccountRelationshipChangeAction;
}

export interface GetOpenThreads_openThreads_payload_AccountContactFormerStatusChange_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_AccountContactFormerStatusChange_formerStatusContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_AccountContactFormerStatusChange {
  __typename: "AccountContactFormerStatusChange";
  account: GetOpenThreads_openThreads_payload_AccountContactFormerStatusChange_account;
  formerStatusContact: GetOpenThreads_openThreads_payload_AccountContactFormerStatusChange_formerStatusContact;
  formerStatusAction: AccountContactFormerStatusChangeAction;
}

export interface GetOpenThreads_openThreads_payload_Note_entity_NoteEntityUnknownType {
  __typename: "NoteEntityUnknownType";
}

export interface GetOpenThreads_openThreads_payload_Note_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_Note_entity_Activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetOpenThreads_openThreads_payload_Note_entity_Activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetOpenThreads_openThreads_payload_Note_entity_Activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface GetOpenThreads_openThreads_payload_Note_entity_Activity_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetOpenThreads_openThreads_payload_Note_entity_Activity_relatedLeads_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetOpenThreads_openThreads_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetOpenThreads_openThreads_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge_node;
}

export interface GetOpenThreads_openThreads_payload_Note_entity_Activity_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetOpenThreads_openThreads_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge | null;
}

export interface GetOpenThreads_openThreads_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetOpenThreads_openThreads_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge_node;
}

export interface GetOpenThreads_openThreads_payload_Note_entity_Activity_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetOpenThreads_openThreads_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge | null;
}

export interface GetOpenThreads_openThreads_payload_Note_entity_Activity_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: GetOpenThreads_openThreads_payload_Note_entity_Activity_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetOpenThreads_openThreads_payload_Note_entity_Activity_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetOpenThreads_openThreads_payload_Note_entity_Activity_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetOpenThreads_openThreads_payload_Note_entity_Activity_relatedLeads_accounts;
}

export interface GetOpenThreads_openThreads_payload_Note_entity_Activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GetOpenThreads_openThreads_payload_Note_entity_Activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface GetOpenThreads_openThreads_payload_Note_entity_Activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: GetOpenThreads_openThreads_payload_Note_entity_Activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: GetOpenThreads_openThreads_payload_Note_entity_Activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface GetOpenThreads_openThreads_payload_Note_entity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetOpenThreads_openThreads_payload_Note_entity_Activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetOpenThreads_openThreads_payload_Note_entity_Activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetOpenThreads_openThreads_payload_Note_entity_Activity_participants[];
  /**
   * Related leads for the activity.
   */
  relatedLeads: GetOpenThreads_openThreads_payload_Note_entity_Activity_relatedLeads[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: GetOpenThreads_openThreads_payload_Note_entity_Activity_externalMeeting | null;
}

export interface GetOpenThreads_openThreads_payload_Note_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_Note_entity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetOpenThreads_openThreads_payload_Note_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetOpenThreads_openThreads_payload_Note_entity_Lead_value | null;
}

export interface GetOpenThreads_openThreads_payload_Note_entity_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type GetOpenThreads_openThreads_payload_Note_entity = GetOpenThreads_openThreads_payload_Note_entity_NoteEntityUnknownType | GetOpenThreads_openThreads_payload_Note_entity_Account | GetOpenThreads_openThreads_payload_Note_entity_Activity | GetOpenThreads_openThreads_payload_Note_entity_Contact | GetOpenThreads_openThreads_payload_Note_entity_Lead | GetOpenThreads_openThreads_payload_Note_entity_Thread;

export interface GetOpenThreads_openThreads_payload_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
  /**
   * The htmlUrl without http: // app.nutshell.com
   */
  htmlUrlPath: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrl: string;
  /**
   * Is this note editable?
   */
  isEditable: boolean;
  /**
   * Does this note have mentioned entities? We care about this because our editing
   * flow for notes w/ mentioned entities is different than a note without entities.
   */
  hasMentionedEntities: boolean;
  /**
   * Whether note has been deleted
   */
  isDeleted: boolean;
  /**
   * The entity on which this note was written
   */
  entity: GetOpenThreads_openThreads_payload_Note_entity | null;
}

export interface GetOpenThreads_openThreads_payload_Email_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetOpenThreads_openThreads_payload_Email_recipients_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetOpenThreads_openThreads_payload_Email_recipients {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetOpenThreads_openThreads_payload_Email_recipients_avatarEntity | null;
}

export interface GetOpenThreads_openThreads_payload_Email_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetOpenThreads_openThreads_payload_Email_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetOpenThreads_openThreads_payload_Email_from_avatarEntity | null;
}

export interface GetOpenThreads_openThreads_payload_Email_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface GetOpenThreads_openThreads_payload_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The excerpt of this email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  /**
   * A partially-formatted version of the body of this email,for use in the expanded view in a list
   */
  emailBodyHtml: string;
  /**
   * How this email was added to Nutshell
   */
  originatedVia: string | null;
  attachments: GetOpenThreads_openThreads_payload_Email_attachments[];
  /**
   * True if the email is shared with other Nutshell users
   */
  isShared: boolean;
  /**
   * True if the email can be shared with other Nutshell users
   */
  isShareable: boolean;
  /**
   * Was this email a reply sent by Nutshell automatically.
   */
  isAutomatedReply: boolean;
  /**
   * Was this email sent by Nutshell automatically.
   */
  isEmailAutomation: boolean;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
  /**
   * If this is a ticket message from Zendesk, this is the id
   */
  ticketId: string | null;
  /**
   * If this is a ticket message from Zendesk, this is the url
   */
  ticketUrl: string | null;
  /**
   * Number of times this email has been viewed via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedViewsCount: number | null;
  /**
   * Number of times this email has been clicked via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedClicksCount: number | null;
  recipients: GetOpenThreads_openThreads_payload_Email_recipients[];
  from: GetOpenThreads_openThreads_payload_Email_from;
  /**
   * Was the email created outside of Nutshell
   */
  isInbound: boolean;
  /**
   * Was the email created in Nutshell
   */
  isOutbound: boolean;
  /**
   * Did the email fail to send
   */
  isFailed: boolean;
  /**
   * True if a Nutshell user can reply to this email
   */
  isReplyable: boolean;
  /**
   * Is this a Nutshell Marketing email
   */
  isNutshellMarketingEmail: boolean;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrlPath: string;
  /**
   * If this a Nutshell Marketing email, this is the edition
   */
  edition: GetOpenThreads_openThreads_payload_Email_edition | null;
  /**
   * Was this email sent within the last week
   */
  sentWithinLastWeek: boolean;
  /**
   * Has this email accepted an AI reply suggestion
   */
  hasAcceptedSuggestion: boolean;
}

export interface GetOpenThreads_openThreads_payload_EmailQueued_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetOpenThreads_openThreads_payload_EmailQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetOpenThreads_openThreads_payload_EmailQueued_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetOpenThreads_openThreads_payload_EmailQueued_to_avatarEntity | null;
}

export interface GetOpenThreads_openThreads_payload_EmailQueued_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetOpenThreads_openThreads_payload_EmailQueued_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetOpenThreads_openThreads_payload_EmailQueued_from_avatarEntity | null;
}

export interface GetOpenThreads_openThreads_payload_EmailQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * The excerpt of this queued email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  attachments: GetOpenThreads_openThreads_payload_EmailQueued_attachments[];
  to: GetOpenThreads_openThreads_payload_EmailQueued_to[];
  /**
   * The sender email address for this queued email.
   */
  from: GetOpenThreads_openThreads_payload_EmailQueued_from;
  /**
   * True if this queued email is postponed and the user can retry it.
   */
  canRetry: boolean;
  /**
   * True if this is an email that looks failed to the user
   */
  isFailed: boolean;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetOpenThreads_openThreads_payload_Submission_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
  formatted: string;
}

export interface GetOpenThreads_openThreads_payload_Submission_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  isPrimary: boolean;
  value: GetOpenThreads_openThreads_payload_Submission_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface GetOpenThreads_openThreads_payload_Submission_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetOpenThreads_openThreads_payload_Submission_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface GetOpenThreads_openThreads_payload_Submission_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetOpenThreads_openThreads_payload_Submission_booking_additionalAttendees_emailAddresses;
}

export interface GetOpenThreads_openThreads_payload_Submission_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (GetOpenThreads_openThreads_payload_Submission_booking_additionalAttendees | null)[];
}

export interface GetOpenThreads_openThreads_payload_Submission_primaryEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_Submission_primaryEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_Submission_primaryEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetOpenThreads_openThreads_payload_Submission_primaryEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetOpenThreads_openThreads_payload_Submission_primaryEntity_Lead_value | null;
}

export type GetOpenThreads_openThreads_payload_Submission_primaryEntity = GetOpenThreads_openThreads_payload_Submission_primaryEntity_Account | GetOpenThreads_openThreads_payload_Submission_primaryEntity_Contact | GetOpenThreads_openThreads_payload_Submission_primaryEntity_Lead;

export interface GetOpenThreads_openThreads_payload_Submission_formVersion_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetOpenThreads_openThreads_payload_Submission_formVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent form of this form version
   */
  form: GetOpenThreads_openThreads_payload_Submission_formVersion_form;
}

export interface GetOpenThreads_openThreads_payload_Submission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface GetOpenThreads_openThreads_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface GetOpenThreads_openThreads_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: GetOpenThreads_openThreads_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export interface GetOpenThreads_openThreads_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface GetOpenThreads_openThreads_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export type GetOpenThreads_openThreads_payload_Submission_fields_edges_fieldValue = GetOpenThreads_openThreads_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields | GetOpenThreads_openThreads_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | GetOpenThreads_openThreads_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle;

export interface GetOpenThreads_openThreads_payload_Submission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: GetOpenThreads_openThreads_payload_Submission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: GetOpenThreads_openThreads_payload_Submission_fields_edges_fieldValue | null;
}

export interface GetOpenThreads_openThreads_payload_Submission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: GetOpenThreads_openThreads_payload_Submission_fields_edges[];
}

export interface GetOpenThreads_openThreads_payload_Submission {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The url where the submission originates
   */
  submissionUrl: string;
  /**
   * The booking associated with this submission (if Scheduler)
   */
  booking: GetOpenThreads_openThreads_payload_Submission_booking | null;
  /**
   * The primary entity on the submission
   */
  primaryEntity: GetOpenThreads_openThreads_payload_Submission_primaryEntity | null;
  /**
   * The name of the submitted web form
   */
  formVersion: GetOpenThreads_openThreads_payload_Submission_formVersion;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: GetOpenThreads_openThreads_payload_Submission_fields;
}

export interface GetOpenThreads_openThreads_payload_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetOpenThreads_openThreads_payload_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetOpenThreads_openThreads_payload_Lead_value | null;
}

export interface GetOpenThreads_openThreads_payload_Chat_chatItems {
  __typename: "ChatItem";
  /**
   * Time this message was sent
   */
  timestamp: any;
  /**
   * The attrbute chatItemd by the entry
   */
  body: string;
  /**
   * Person writing this particular message
   */
  chatter: string;
  /**
   * Type of chat message
   */
  type: string;
}

export interface GetOpenThreads_openThreads_payload_Chat_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetOpenThreads_openThreads_payload_Chat_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetOpenThreads_openThreads_payload_Chat_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface GetOpenThreads_openThreads_payload_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * Not really sure tbh
   */
  chatItems: GetOpenThreads_openThreads_payload_Chat_chatItems[];
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetOpenThreads_openThreads_payload_Chat_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetOpenThreads_openThreads_payload_Chat_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetOpenThreads_openThreads_payload_Chat_participants[];
}

export interface GetOpenThreads_openThreads_payload_Assignment_assignmentEntity_Thread {
  __typename: "Thread";
}

export interface GetOpenThreads_openThreads_payload_Assignment_assignmentEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_Assignment_assignmentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * Canonical URL for an individual activity - launches a modal in this case
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_Assignment_assignmentEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_Assignment_assignmentEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_Assignment_assignmentEntity_UnknownEntityType {
  __typename: "UnknownEntityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type GetOpenThreads_openThreads_payload_Assignment_assignmentEntity = GetOpenThreads_openThreads_payload_Assignment_assignmentEntity_Thread | GetOpenThreads_openThreads_payload_Assignment_assignmentEntity_Account | GetOpenThreads_openThreads_payload_Assignment_assignmentEntity_Activity | GetOpenThreads_openThreads_payload_Assignment_assignmentEntity_Contact | GetOpenThreads_openThreads_payload_Assignment_assignmentEntity_Lead | GetOpenThreads_openThreads_payload_Assignment_assignmentEntity_UnknownEntityType;

export interface GetOpenThreads_openThreads_payload_Assignment_assigneeEntity {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetOpenThreads_openThreads_payload_Assignment {
  __typename: "Assignment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity that was assigned
   */
  assignmentEntity: GetOpenThreads_openThreads_payload_Assignment_assignmentEntity;
  /**
   * The entity to which the assignment was made
   */
  assigneeEntity: GetOpenThreads_openThreads_payload_Assignment_assigneeEntity;
}

export interface GetOpenThreads_openThreads_payload_EmailInteraction_emailDelivery_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_EmailInteraction_emailDelivery_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetOpenThreads_openThreads_payload_EmailInteraction_emailDelivery_email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrlPath: string;
}

export interface GetOpenThreads_openThreads_payload_EmailInteraction_emailDelivery {
  __typename: "EmailDelivery";
  primaryContact: GetOpenThreads_openThreads_payload_EmailInteraction_emailDelivery_primaryContact | null;
  edition: GetOpenThreads_openThreads_payload_EmailInteraction_emailDelivery_edition | null;
  email: GetOpenThreads_openThreads_payload_EmailInteraction_emailDelivery_email | null;
}

export interface GetOpenThreads_openThreads_payload_EmailInteraction {
  __typename: "EmailInteraction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: EmailInteractionType;
  link: string | null;
  emailDelivery: GetOpenThreads_openThreads_payload_EmailInteraction_emailDelivery | null;
}

export interface GetOpenThreads_openThreads_payload_ConstantContactContactTrackingActivity_ctctContact_contacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_ConstantContactContactTrackingActivity_ctctContact {
  __typename: "ConstantContactContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailAddress: string;
  /**
   * The Nutshell contacts associated with this CTCT contact
   */
  contacts: GetOpenThreads_openThreads_payload_ConstantContactContactTrackingActivity_ctctContact_contacts[];
}

export interface GetOpenThreads_openThreads_payload_ConstantContactContactTrackingActivity {
  __typename: "ConstantContactContactTrackingActivity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  campaignName: string | null;
  trackingActivityType: ConstantContactContactTrackingActivityType;
  emailSubject: string | null;
  ctctContact: GetOpenThreads_openThreads_payload_ConstantContactContactTrackingActivity_ctctContact;
}

export interface GetOpenThreads_openThreads_payload_EntityAttributeValueFile_eavEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_EntityAttributeValueFile_eavEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_EntityAttributeValueFile_eavEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetOpenThreads_openThreads_payload_EntityAttributeValueFile_eavEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetOpenThreads_openThreads_payload_EntityAttributeValueFile_eavEntity_Lead_value | null;
}

export type GetOpenThreads_openThreads_payload_EntityAttributeValueFile_eavEntity = GetOpenThreads_openThreads_payload_EntityAttributeValueFile_eavEntity_Account | GetOpenThreads_openThreads_payload_EntityAttributeValueFile_eavEntity_Contact | GetOpenThreads_openThreads_payload_EntityAttributeValueFile_eavEntity_Lead;

export interface GetOpenThreads_openThreads_payload_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The entity that this file is associated with
   */
  eavEntity: GetOpenThreads_openThreads_payload_EntityAttributeValueFile_eavEntity;
}

export interface GetOpenThreads_openThreads_payload_Comment_parentEntity_Note_entity_Activity {
  __typename: "Activity" | "Thread" | "NoteEntityUnknownType";
}

export interface GetOpenThreads_openThreads_payload_Comment_parentEntity_Note_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_Comment_parentEntity_Note_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_Comment_parentEntity_Note_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export type GetOpenThreads_openThreads_payload_Comment_parentEntity_Note_entity = GetOpenThreads_openThreads_payload_Comment_parentEntity_Note_entity_Activity | GetOpenThreads_openThreads_payload_Comment_parentEntity_Note_entity_Contact | GetOpenThreads_openThreads_payload_Comment_parentEntity_Note_entity_Account | GetOpenThreads_openThreads_payload_Comment_parentEntity_Note_entity_Lead;

export interface GetOpenThreads_openThreads_payload_Comment_parentEntity_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity on which this note was written
   */
  entity: GetOpenThreads_openThreads_payload_Comment_parentEntity_Note_entity | null;
}

export interface GetOpenThreads_openThreads_payload_Comment_parentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetOpenThreads_openThreads_payload_Comment_parentEntity_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
}

export type GetOpenThreads_openThreads_payload_Comment_parentEntity = GetOpenThreads_openThreads_payload_Comment_parentEntity_Note | GetOpenThreads_openThreads_payload_Comment_parentEntity_Activity | GetOpenThreads_openThreads_payload_Comment_parentEntity_Email;

export interface GetOpenThreads_openThreads_payload_Comment {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  commentId: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Deleted time for comment, null if not deleted
   */
  deletedTime: any | null;
  /**
   * The entity on which this note was written
   */
  parentEntity: GetOpenThreads_openThreads_payload_Comment_parentEntity | null;
}

export interface GetOpenThreads_openThreads_payload_Session_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https:             // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The `www.nutshell.com` part of https: // www.nutshell.com/features?utm_source=Google
   */
  host: string | null;
}

export interface GetOpenThreads_openThreads_payload_Session_browser {
  __typename: "Browser";
  /**
   * The platform for the visit
   */
  platform: string;
  /**
   * The device type for the visit
   */
  deviceType: DeviceType;
}

export interface GetOpenThreads_openThreads_payload_Session_source {
  __typename: "McfxVisitSource";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The utm_medium value for this particular visit
   */
  medium: string;
  /**
   * The utm_source value for this particular visit
   */
  source: string;
  /**
   * Then mROI channel derived from this source information
   */
  channel: string;
}

export interface GetOpenThreads_openThreads_payload_Session_contact_nutshellContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_Session_contact {
  __typename: "McfxContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The contact that made this form submission.
   */
  nutshellContact: GetOpenThreads_openThreads_payload_Session_contact_nutshellContact | null;
}

export interface GetOpenThreads_openThreads_payload_Session_visits_edges_node_maUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetOpenThreads_openThreads_payload_Session_visits_edges_node_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The `/features` part of https: // www.nutshell.com/features?utm_source=Google
   */
  path: string | null;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
  /**
   * The full URL, i.e. https:      // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetOpenThreads_openThreads_payload_Session_visits_edges_node {
  __typename: "Visit";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * How long the specific page visit lasted.
   */
  durationSeconds: number;
  /**
   * The marketing automation URL associated with this visit, if any.
   */
  maUrl: GetOpenThreads_openThreads_payload_Session_visits_edges_node_maUrl | null;
  /**
   * The page url for this user visit.
   */
  url: GetOpenThreads_openThreads_payload_Session_visits_edges_node_url;
}

export interface GetOpenThreads_openThreads_payload_Session_visits_edges {
  __typename: "SessionVisitsEdge";
  node: GetOpenThreads_openThreads_payload_Session_visits_edges_node;
}

export interface GetOpenThreads_openThreads_payload_Session_visits {
  __typename: "SessionVisitsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The total amount of time the visits lasted.
   */
  totalDuration: number | null;
  /**
   * The number of visits that have an associated marketing automation URL.
   */
  maUrlCount: number;
  /**
   * A list of edges.
   */
  edges: GetOpenThreads_openThreads_payload_Session_visits_edges[];
}

export interface GetOpenThreads_openThreads_payload_Session {
  __typename: "Session";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The url for the session, used to open as a timeline entry modal.
   */
  htmlUrlPath: string;
  /**
   * Some basic info on the location of the user represented as a string.
   */
  locationSummary: string | null;
  /**
   * The session url.
   */
  url: GetOpenThreads_openThreads_payload_Session_url;
  /**
   * The platform the user was on during the session.
   */
  browser: GetOpenThreads_openThreads_payload_Session_browser | null;
  source: GetOpenThreads_openThreads_payload_Session_source;
  /**
   * The contact associated with this session.
   */
  contact: GetOpenThreads_openThreads_payload_Session_contact | null;
  visits: GetOpenThreads_openThreads_payload_Session_visits;
  /**
   * When this session started. This is the value we’ll display to the user
   */
  startTime: any;
}

export interface GetOpenThreads_openThreads_payload_Thread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
}

export interface GetOpenThreads_openThreads_payload_Thread_displayMessage_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  htmlUrl: string | null;
  avatarUrl: string;
  initials: string;
}

export interface GetOpenThreads_openThreads_payload_Thread_displayMessage_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetOpenThreads_openThreads_payload_Thread_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The content of the message
   */
  content: string;
  /**
   * The plain text to display the message
   */
  plainTextForDisplay: string | null;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The user who created this thread
   */
  creatorUser: GetOpenThreads_openThreads_payload_Thread_displayMessage_creatorUser | null;
  /**
   * The origin of the user who created this thread
   */
  creatorOrigin: GetOpenThreads_openThreads_payload_Thread_displayMessage_creatorOrigin | null;
  /**
   * The images in the message
   */
  images: string[];
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
}

export interface GetOpenThreads_openThreads_payload_Thread_messages {
  __typename: "ThreadMessagesConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetOpenThreads_openThreads_payload_Thread_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  htmlUrl: string | null;
  avatarUrl: string;
  initials: string;
}

export interface GetOpenThreads_openThreads_payload_Thread_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
}

export interface GetOpenThreads_openThreads_payload_Thread_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  initials: string;
}

export interface GetOpenThreads_openThreads_payload_Thread_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  initials: string;
}

export type GetOpenThreads_openThreads_payload_Thread_bestEntity = GetOpenThreads_openThreads_payload_Thread_bestEntity_Lead | GetOpenThreads_openThreads_payload_Thread_bestEntity_Account | GetOpenThreads_openThreads_payload_Thread_bestEntity_Contact;

export interface GetOpenThreads_openThreads_payload_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external channel this thread is related to
   */
  externalChannel: GetOpenThreads_openThreads_payload_Thread_externalChannel;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: GetOpenThreads_openThreads_payload_Thread_displayMessage | null;
  /**
   * The messages associated with this thread
   */
  messages: GetOpenThreads_openThreads_payload_Thread_messages;
  /**
   * the number of inbound messages on this thread
   */
  replyCount: number;
  /**
   * The user who created this thread
   */
  creatorUser: GetOpenThreads_openThreads_payload_Thread_creatorUser | null;
  /**
   * The best entity associated with this thread
   */
  bestEntity: GetOpenThreads_openThreads_payload_Thread_bestEntity | null;
  /**
   * Whether this thread can be reopened
   */
  canReopen: boolean;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
}

export interface GetOpenThreads_openThreads_payload_Message_edition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface GetOpenThreads_openThreads_payload_Message_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetOpenThreads_openThreads_payload_Message_edition_campaign;
}

export interface GetOpenThreads_openThreads_payload_Message_thread_bestEntity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_payload_Message_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The best entity associated with this thread
   */
  bestEntity: GetOpenThreads_openThreads_payload_Message_thread_bestEntity | null;
}

export interface GetOpenThreads_openThreads_payload_Message {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The edition of the message
   */
  edition: GetOpenThreads_openThreads_payload_Message_edition | null;
  /**
   * The thread this message is part of
   */
  thread: GetOpenThreads_openThreads_payload_Message_thread;
}

export interface GetOpenThreads_openThreads_payload_Quote_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetOpenThreads_openThreads_payload_Quote_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetOpenThreads_openThreads_payload_Quote_lead_accounts_primaryEdge_node;
}

export interface GetOpenThreads_openThreads_payload_Quote_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetOpenThreads_openThreads_payload_Quote_lead_accounts_primaryEdge | null;
}

export interface GetOpenThreads_openThreads_payload_Quote_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetOpenThreads_openThreads_payload_Quote_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetOpenThreads_openThreads_payload_Quote_lead_contacts_primaryEdge_node;
}

export interface GetOpenThreads_openThreads_payload_Quote_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetOpenThreads_openThreads_payload_Quote_lead_contacts_primaryEdge | null;
}

export interface GetOpenThreads_openThreads_payload_Quote_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetOpenThreads_openThreads_payload_Quote_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetOpenThreads_openThreads_payload_Quote_lead_contacts;
}

export interface GetOpenThreads_openThreads_payload_Quote_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetOpenThreads_openThreads_payload_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetOpenThreads_openThreads_payload_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: GetOpenThreads_openThreads_payload_Quote_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetOpenThreads_openThreads_payload_Quote_total;
  /**
   * The user that created the quote
   */
  creatorUser: GetOpenThreads_openThreads_payload_Quote_creatorUser | null;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge_node;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Quote_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge | null;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge_node;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Quote_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge | null;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Quote_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Quote_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Quote_lead_contacts;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Quote_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Quote_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Quote_total;
  /**
   * The user that created the quote
   */
  creatorUser: GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Quote_creatorUser | null;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge_node;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Invoice_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge | null;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge_node;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Invoice_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge | null;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Invoice_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Invoice_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Invoice_lead_contacts;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Invoice_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Invoice_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Invoice_total;
  /**
   * The user that created the quote
   */
  creatorUser: GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Invoice_creatorUser | null;
}

export type GetOpenThreads_openThreads_payload_DocumentView_salesDocument = GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Quote | GetOpenThreads_openThreads_payload_DocumentView_salesDocument_Invoice;

export interface GetOpenThreads_openThreads_payload_DocumentView_contract_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_contract_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetOpenThreads_openThreads_payload_DocumentView_contract_lead_accounts_primaryEdge_node;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_contract_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetOpenThreads_openThreads_payload_DocumentView_contract_lead_accounts_primaryEdge | null;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_contract_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_contract_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetOpenThreads_openThreads_payload_DocumentView_contract_lead_contacts_primaryEdge_node;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_contract_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetOpenThreads_openThreads_payload_DocumentView_contract_lead_contacts_primaryEdge | null;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_contract_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetOpenThreads_openThreads_payload_DocumentView_contract_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetOpenThreads_openThreads_payload_DocumentView_contract_lead_contacts;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_contract_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetOpenThreads_openThreads_payload_DocumentView_contract {
  __typename: "Contract";
  id: string;
  /**
   * The htmlUrl path without domain.
   */
  htmlUrlPath: string;
  lead: GetOpenThreads_openThreads_payload_DocumentView_contract_lead;
  displayNumber: string;
  creatorUser: GetOpenThreads_openThreads_payload_DocumentView_contract_creatorUser | null;
}

export interface GetOpenThreads_openThreads_payload_DocumentView {
  __typename: "DocumentView";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The quote or invoice this view is attached to, when applicable
   */
  salesDocument: GetOpenThreads_openThreads_payload_DocumentView_salesDocument | null;
  /**
   * The contract this view is attached to, when applicable
   */
  contract: GetOpenThreads_openThreads_payload_DocumentView_contract | null;
}

export interface GetOpenThreads_openThreads_payload_Invoice_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetOpenThreads_openThreads_payload_Invoice_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetOpenThreads_openThreads_payload_Invoice_lead_accounts_primaryEdge_node;
}

export interface GetOpenThreads_openThreads_payload_Invoice_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetOpenThreads_openThreads_payload_Invoice_lead_accounts_primaryEdge | null;
}

export interface GetOpenThreads_openThreads_payload_Invoice_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetOpenThreads_openThreads_payload_Invoice_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetOpenThreads_openThreads_payload_Invoice_lead_contacts_primaryEdge_node;
}

export interface GetOpenThreads_openThreads_payload_Invoice_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetOpenThreads_openThreads_payload_Invoice_lead_contacts_primaryEdge | null;
}

export interface GetOpenThreads_openThreads_payload_Invoice_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetOpenThreads_openThreads_payload_Invoice_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetOpenThreads_openThreads_payload_Invoice_lead_contacts;
}

export interface GetOpenThreads_openThreads_payload_Invoice_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetOpenThreads_openThreads_payload_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetOpenThreads_openThreads_payload_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: GetOpenThreads_openThreads_payload_Invoice_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetOpenThreads_openThreads_payload_Invoice_total;
  /**
   * The user that created the quote
   */
  creatorUser: GetOpenThreads_openThreads_payload_Invoice_creatorUser | null;
}

export interface GetOpenThreads_openThreads_payload_Contract_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetOpenThreads_openThreads_payload_Contract_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetOpenThreads_openThreads_payload_Contract_lead_accounts_primaryEdge_node;
}

export interface GetOpenThreads_openThreads_payload_Contract_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetOpenThreads_openThreads_payload_Contract_lead_accounts_primaryEdge | null;
}

export interface GetOpenThreads_openThreads_payload_Contract_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetOpenThreads_openThreads_payload_Contract_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetOpenThreads_openThreads_payload_Contract_lead_contacts_primaryEdge_node;
}

export interface GetOpenThreads_openThreads_payload_Contract_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetOpenThreads_openThreads_payload_Contract_lead_contacts_primaryEdge | null;
}

export interface GetOpenThreads_openThreads_payload_Contract_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetOpenThreads_openThreads_payload_Contract_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetOpenThreads_openThreads_payload_Contract_lead_contacts;
}

export interface GetOpenThreads_openThreads_payload_Contract_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetOpenThreads_openThreads_payload_Contract {
  __typename: "Contract";
  id: string;
  /**
   * The htmlUrl path without domain.
   */
  htmlUrlPath: string;
  lead: GetOpenThreads_openThreads_payload_Contract_lead;
  displayNumber: string;
  creatorUser: GetOpenThreads_openThreads_payload_Contract_creatorUser | null;
}

export interface GetOpenThreads_openThreads_payload_LeadClonePayload_original_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetOpenThreads_openThreads_payload_LeadClonePayload_original {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetOpenThreads_openThreads_payload_LeadClonePayload_original_value | null;
}

export interface GetOpenThreads_openThreads_payload_LeadClonePayload_clone_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetOpenThreads_openThreads_payload_LeadClonePayload_clone {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetOpenThreads_openThreads_payload_LeadClonePayload_clone_value | null;
}

export interface GetOpenThreads_openThreads_payload_LeadClonePayload {
  __typename: "LeadClonePayload";
  /**
   * The original lead
   */
  original: GetOpenThreads_openThreads_payload_LeadClonePayload_original;
  /**
   * The cloned lead
   */
  clone: GetOpenThreads_openThreads_payload_LeadClonePayload_clone;
}

export type GetOpenThreads_openThreads_payload = GetOpenThreads_openThreads_payload_TimelineEventPayloadUnknownType | GetOpenThreads_openThreads_payload_Activity | GetOpenThreads_openThreads_payload_AccountRelationshipChange | GetOpenThreads_openThreads_payload_AccountContactFormerStatusChange | GetOpenThreads_openThreads_payload_Note | GetOpenThreads_openThreads_payload_Email | GetOpenThreads_openThreads_payload_EmailQueued | GetOpenThreads_openThreads_payload_Origin | GetOpenThreads_openThreads_payload_Submission | GetOpenThreads_openThreads_payload_Account | GetOpenThreads_openThreads_payload_Contact | GetOpenThreads_openThreads_payload_Lead | GetOpenThreads_openThreads_payload_Chat | GetOpenThreads_openThreads_payload_Assignment | GetOpenThreads_openThreads_payload_EmailInteraction | GetOpenThreads_openThreads_payload_ConstantContactContactTrackingActivity | GetOpenThreads_openThreads_payload_EntityAttributeValueFile | GetOpenThreads_openThreads_payload_Comment | GetOpenThreads_openThreads_payload_Session | GetOpenThreads_openThreads_payload_Thread | GetOpenThreads_openThreads_payload_Message | GetOpenThreads_openThreads_payload_Quote | GetOpenThreads_openThreads_payload_DocumentView | GetOpenThreads_openThreads_payload_Invoice | GetOpenThreads_openThreads_payload_Contract | GetOpenThreads_openThreads_payload_LeadClonePayload;

export interface GetOpenThreads_openThreads_changes {
  __typename: "ChangeLogChange";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attrbute changed by the entry
   */
  attribute: string;
  /**
   * The old value before the change
   */
  oldValue: string | null;
  /**
   * The new value after the change
   */
  newValue: string | null;
}

export interface GetOpenThreads_openThreads_files_eavEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_files_eavEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetOpenThreads_openThreads_files_eavEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetOpenThreads_openThreads_files_eavEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetOpenThreads_openThreads_files_eavEntity_Lead_value | null;
}

export type GetOpenThreads_openThreads_files_eavEntity = GetOpenThreads_openThreads_files_eavEntity_Account | GetOpenThreads_openThreads_files_eavEntity_Contact | GetOpenThreads_openThreads_files_eavEntity_Lead;

export interface GetOpenThreads_openThreads_files {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The entity that this file is associated with
   */
  eavEntity: GetOpenThreads_openThreads_files_eavEntity;
}

export interface GetOpenThreads_openThreads_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetOpenThreads_openThreads_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: GetOpenThreads_openThreads_reactions_creatorUser;
}

export interface GetOpenThreads_openThreads_comments_changeLogEntry {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetOpenThreads_openThreads_comments_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetOpenThreads_openThreads_comments_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: GetOpenThreads_openThreads_comments_reactions_creatorUser;
}

export interface GetOpenThreads_openThreads_comments_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  htmlUrl: string | null;
}

export interface GetOpenThreads_openThreads_comments {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Change log associated with the comment
   */
  changeLogEntry: GetOpenThreads_openThreads_comments_changeLogEntry | null;
  /**
   * User reactions left for the comment change log entry
   */
  reactions: GetOpenThreads_openThreads_comments_reactions[];
  /**
   * The user who created the comment.
   */
  creatorUser: GetOpenThreads_openThreads_comments_creatorUser;
  /**
   * The created time for the comment.
   */
  createdTime: any;
  /**
   * True if this comment can be deleted
   */
  isDeleteable: boolean;
}

export interface GetOpenThreads_openThreads {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of change i.e. created, modified, deleted, etc
   */
  changeType: ChangeType;
  /**
   * The entity that triggered the change_log entry
   */
  actor: GetOpenThreads_openThreads_actor;
  payload: GetOpenThreads_openThreads_payload;
  changeTime: any;
  changes: GetOpenThreads_openThreads_changes[];
  /**
   * A one-off property to handle the case where multiple files can be associated
   * with a single change log entry. This is the only situation where multiple
   * payloads exist on an entry, so rather than adding additional complexity to our
   * entire system, we’ll treat it as a separate property
   */
  files: GetOpenThreads_openThreads_files[];
  reactions: GetOpenThreads_openThreads_reactions[];
  comments: GetOpenThreads_openThreads_comments[];
  /**
   * When multiple of the same entry occurs in a row, we’ll roll-up the count. For
   * example, if someone views an email 3 times in a row before a different change,
   * this value will be 3.
   */
  count: number | null;
}

export interface GetOpenThreads {
  /**
   * A list of open threads related to a Nutshell entity
   */
  openThreads: GetOpenThreads_openThreads[];
}

export interface GetOpenThreadsVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPinnedEvents
// ====================================================

export interface GetPinnedEvents_pinnedEvents_edges_node_actor_Form {
  __typename: "Form";
}

export interface GetPinnedEvents_pinnedEvents_edges_node_actor_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_actor_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_actor_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_actor_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_actor_MaUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Path to the edit page for this money page.
   */
  htmlUrlPath: string;
}

export type GetPinnedEvents_pinnedEvents_edges_node_actor = GetPinnedEvents_pinnedEvents_edges_node_actor_Form | GetPinnedEvents_pinnedEvents_edges_node_actor_User | GetPinnedEvents_pinnedEvents_edges_node_actor_Origin | GetPinnedEvents_pinnedEvents_edges_node_actor_Contact | GetPinnedEvents_pinnedEvents_edges_node_actor_Account | GetPinnedEvents_pinnedEvents_edges_node_actor_MaUrl;

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_TimelineEventPayloadUnknownType {
  __typename: "TimelineEventPayloadUnknownType";
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: GetPinnedEvents_pinnedEvents_edges_node_payload_Activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: GetPinnedEvents_pinnedEvents_edges_node_payload_Activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetPinnedEvents_pinnedEvents_edges_node_payload_Activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetPinnedEvents_pinnedEvents_edges_node_payload_Activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetPinnedEvents_pinnedEvents_edges_node_payload_Activity_participants[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: GetPinnedEvents_pinnedEvents_edges_node_payload_Activity_externalMeeting | null;
  /**
   * The transcription of the activity.
   */
  transcription: string | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_AccountRelationshipChange_entityAdded {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_AccountRelationshipChange {
  __typename: "AccountRelationshipChange";
  /**
   * The child account in the relationship
   */
  entityAdded: GetPinnedEvents_pinnedEvents_edges_node_payload_AccountRelationshipChange_entityAdded;
  /**
   * The action that was taken to create this relationship
   */
  action: AccountRelationshipChangeAction;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_AccountContactFormerStatusChange_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_AccountContactFormerStatusChange_formerStatusContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_AccountContactFormerStatusChange {
  __typename: "AccountContactFormerStatusChange";
  account: GetPinnedEvents_pinnedEvents_edges_node_payload_AccountContactFormerStatusChange_account;
  formerStatusContact: GetPinnedEvents_pinnedEvents_edges_node_payload_AccountContactFormerStatusChange_formerStatusContact;
  formerStatusAction: AccountContactFormerStatusChangeAction;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_NoteEntityUnknownType {
  __typename: "NoteEntityUnknownType";
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_relatedLeads_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge_node;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge_node;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_relatedLeads_accounts;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_participants[];
  /**
   * Related leads for the activity.
   */
  relatedLeads: GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_relatedLeads[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity_externalMeeting | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Lead_value | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity = GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_NoteEntityUnknownType | GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Account | GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Activity | GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Contact | GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Lead | GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity_Thread;

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
  /**
   * The htmlUrl without http: // app.nutshell.com
   */
  htmlUrlPath: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrl: string;
  /**
   * Is this note editable?
   */
  isEditable: boolean;
  /**
   * Does this note have mentioned entities? We care about this because our editing
   * flow for notes w/ mentioned entities is different than a note without entities.
   */
  hasMentionedEntities: boolean;
  /**
   * Whether note has been deleted
   */
  isDeleted: boolean;
  /**
   * The entity on which this note was written
   */
  entity: GetPinnedEvents_pinnedEvents_edges_node_payload_Note_entity | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Email_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Email_recipients_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Email_recipients {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetPinnedEvents_pinnedEvents_edges_node_payload_Email_recipients_avatarEntity | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Email_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Email_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetPinnedEvents_pinnedEvents_edges_node_payload_Email_from_avatarEntity | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Email_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The excerpt of this email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  /**
   * A partially-formatted version of the body of this email,for use in the expanded view in a list
   */
  emailBodyHtml: string;
  /**
   * How this email was added to Nutshell
   */
  originatedVia: string | null;
  attachments: GetPinnedEvents_pinnedEvents_edges_node_payload_Email_attachments[];
  /**
   * True if the email is shared with other Nutshell users
   */
  isShared: boolean;
  /**
   * True if the email can be shared with other Nutshell users
   */
  isShareable: boolean;
  /**
   * Was this email a reply sent by Nutshell automatically.
   */
  isAutomatedReply: boolean;
  /**
   * Was this email sent by Nutshell automatically.
   */
  isEmailAutomation: boolean;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
  /**
   * If this is a ticket message from Zendesk, this is the id
   */
  ticketId: string | null;
  /**
   * If this is a ticket message from Zendesk, this is the url
   */
  ticketUrl: string | null;
  /**
   * Number of times this email has been viewed via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedViewsCount: number | null;
  /**
   * Number of times this email has been clicked via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedClicksCount: number | null;
  recipients: GetPinnedEvents_pinnedEvents_edges_node_payload_Email_recipients[];
  from: GetPinnedEvents_pinnedEvents_edges_node_payload_Email_from;
  /**
   * Was the email created outside of Nutshell
   */
  isInbound: boolean;
  /**
   * Was the email created in Nutshell
   */
  isOutbound: boolean;
  /**
   * Did the email fail to send
   */
  isFailed: boolean;
  /**
   * True if a Nutshell user can reply to this email
   */
  isReplyable: boolean;
  /**
   * Is this a Nutshell Marketing email
   */
  isNutshellMarketingEmail: boolean;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrlPath: string;
  /**
   * If this a Nutshell Marketing email, this is the edition
   */
  edition: GetPinnedEvents_pinnedEvents_edges_node_payload_Email_edition | null;
  /**
   * Was this email sent within the last week
   */
  sentWithinLastWeek: boolean;
  /**
   * Has this email accepted an AI reply suggestion
   */
  hasAcceptedSuggestion: boolean;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_EmailQueued_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_EmailQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_EmailQueued_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetPinnedEvents_pinnedEvents_edges_node_payload_EmailQueued_to_avatarEntity | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_EmailQueued_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_EmailQueued_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetPinnedEvents_pinnedEvents_edges_node_payload_EmailQueued_from_avatarEntity | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_EmailQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * The excerpt of this queued email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  attachments: GetPinnedEvents_pinnedEvents_edges_node_payload_EmailQueued_attachments[];
  to: GetPinnedEvents_pinnedEvents_edges_node_payload_EmailQueued_to[];
  /**
   * The sender email address for this queued email.
   */
  from: GetPinnedEvents_pinnedEvents_edges_node_payload_EmailQueued_from;
  /**
   * True if this queued email is postponed and the user can retry it.
   */
  canRetry: boolean;
  /**
   * True if this is an email that looks failed to the user
   */
  isFailed: boolean;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
  formatted: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  isPrimary: boolean;
  value: GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_booking_additionalAttendees | null)[];
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_primaryEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_primaryEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_primaryEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_primaryEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_primaryEntity_Lead_value | null;
}

export type GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_primaryEntity = GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_primaryEntity_Account | GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_primaryEntity_Contact | GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_primaryEntity_Lead;

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_formVersion_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_formVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent form of this form version
   */
  form: GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_formVersion_form;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export type GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_fields_edges_fieldValue = GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields | GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle;

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_fields_edges_fieldValue | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_fields_edges[];
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Submission {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The url where the submission originates
   */
  submissionUrl: string;
  /**
   * The booking associated with this submission (if Scheduler)
   */
  booking: GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_booking | null;
  /**
   * The primary entity on the submission
   */
  primaryEntity: GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_primaryEntity | null;
  /**
   * The name of the submitted web form
   */
  formVersion: GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_formVersion;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: GetPinnedEvents_pinnedEvents_edges_node_payload_Submission_fields;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetPinnedEvents_pinnedEvents_edges_node_payload_Lead_value | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Chat_chatItems {
  __typename: "ChatItem";
  /**
   * Time this message was sent
   */
  timestamp: any;
  /**
   * The attrbute chatItemd by the entry
   */
  body: string;
  /**
   * Person writing this particular message
   */
  chatter: string;
  /**
   * Type of chat message
   */
  type: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Chat_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Chat_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Chat_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * Not really sure tbh
   */
  chatItems: GetPinnedEvents_pinnedEvents_edges_node_payload_Chat_chatItems[];
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetPinnedEvents_pinnedEvents_edges_node_payload_Chat_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetPinnedEvents_pinnedEvents_edges_node_payload_Chat_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetPinnedEvents_pinnedEvents_edges_node_payload_Chat_participants[];
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Assignment_assignmentEntity_Thread {
  __typename: "Thread";
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Assignment_assignmentEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Assignment_assignmentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * Canonical URL for an individual activity - launches a modal in this case
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Assignment_assignmentEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Assignment_assignmentEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Assignment_assignmentEntity_UnknownEntityType {
  __typename: "UnknownEntityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type GetPinnedEvents_pinnedEvents_edges_node_payload_Assignment_assignmentEntity = GetPinnedEvents_pinnedEvents_edges_node_payload_Assignment_assignmentEntity_Thread | GetPinnedEvents_pinnedEvents_edges_node_payload_Assignment_assignmentEntity_Account | GetPinnedEvents_pinnedEvents_edges_node_payload_Assignment_assignmentEntity_Activity | GetPinnedEvents_pinnedEvents_edges_node_payload_Assignment_assignmentEntity_Contact | GetPinnedEvents_pinnedEvents_edges_node_payload_Assignment_assignmentEntity_Lead | GetPinnedEvents_pinnedEvents_edges_node_payload_Assignment_assignmentEntity_UnknownEntityType;

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Assignment_assigneeEntity {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Assignment {
  __typename: "Assignment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity that was assigned
   */
  assignmentEntity: GetPinnedEvents_pinnedEvents_edges_node_payload_Assignment_assignmentEntity;
  /**
   * The entity to which the assignment was made
   */
  assigneeEntity: GetPinnedEvents_pinnedEvents_edges_node_payload_Assignment_assigneeEntity;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_EmailInteraction_emailDelivery_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_EmailInteraction_emailDelivery_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_EmailInteraction_emailDelivery_email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrlPath: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_EmailInteraction_emailDelivery {
  __typename: "EmailDelivery";
  primaryContact: GetPinnedEvents_pinnedEvents_edges_node_payload_EmailInteraction_emailDelivery_primaryContact | null;
  edition: GetPinnedEvents_pinnedEvents_edges_node_payload_EmailInteraction_emailDelivery_edition | null;
  email: GetPinnedEvents_pinnedEvents_edges_node_payload_EmailInteraction_emailDelivery_email | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_EmailInteraction {
  __typename: "EmailInteraction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: EmailInteractionType;
  link: string | null;
  emailDelivery: GetPinnedEvents_pinnedEvents_edges_node_payload_EmailInteraction_emailDelivery | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_ConstantContactContactTrackingActivity_ctctContact_contacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_ConstantContactContactTrackingActivity_ctctContact {
  __typename: "ConstantContactContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailAddress: string;
  /**
   * The Nutshell contacts associated with this CTCT contact
   */
  contacts: GetPinnedEvents_pinnedEvents_edges_node_payload_ConstantContactContactTrackingActivity_ctctContact_contacts[];
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_ConstantContactContactTrackingActivity {
  __typename: "ConstantContactContactTrackingActivity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  campaignName: string | null;
  trackingActivityType: ConstantContactContactTrackingActivityType;
  emailSubject: string | null;
  ctctContact: GetPinnedEvents_pinnedEvents_edges_node_payload_ConstantContactContactTrackingActivity_ctctContact;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_EntityAttributeValueFile_eavEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_EntityAttributeValueFile_eavEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_EntityAttributeValueFile_eavEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_EntityAttributeValueFile_eavEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetPinnedEvents_pinnedEvents_edges_node_payload_EntityAttributeValueFile_eavEntity_Lead_value | null;
}

export type GetPinnedEvents_pinnedEvents_edges_node_payload_EntityAttributeValueFile_eavEntity = GetPinnedEvents_pinnedEvents_edges_node_payload_EntityAttributeValueFile_eavEntity_Account | GetPinnedEvents_pinnedEvents_edges_node_payload_EntityAttributeValueFile_eavEntity_Contact | GetPinnedEvents_pinnedEvents_edges_node_payload_EntityAttributeValueFile_eavEntity_Lead;

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The entity that this file is associated with
   */
  eavEntity: GetPinnedEvents_pinnedEvents_edges_node_payload_EntityAttributeValueFile_eavEntity;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Comment_parentEntity_Note_entity_Activity {
  __typename: "Activity" | "Thread" | "NoteEntityUnknownType";
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Comment_parentEntity_Note_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Comment_parentEntity_Note_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Comment_parentEntity_Note_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export type GetPinnedEvents_pinnedEvents_edges_node_payload_Comment_parentEntity_Note_entity = GetPinnedEvents_pinnedEvents_edges_node_payload_Comment_parentEntity_Note_entity_Activity | GetPinnedEvents_pinnedEvents_edges_node_payload_Comment_parentEntity_Note_entity_Contact | GetPinnedEvents_pinnedEvents_edges_node_payload_Comment_parentEntity_Note_entity_Account | GetPinnedEvents_pinnedEvents_edges_node_payload_Comment_parentEntity_Note_entity_Lead;

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Comment_parentEntity_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity on which this note was written
   */
  entity: GetPinnedEvents_pinnedEvents_edges_node_payload_Comment_parentEntity_Note_entity | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Comment_parentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Comment_parentEntity_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
}

export type GetPinnedEvents_pinnedEvents_edges_node_payload_Comment_parentEntity = GetPinnedEvents_pinnedEvents_edges_node_payload_Comment_parentEntity_Note | GetPinnedEvents_pinnedEvents_edges_node_payload_Comment_parentEntity_Activity | GetPinnedEvents_pinnedEvents_edges_node_payload_Comment_parentEntity_Email;

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Comment {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  commentId: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Deleted time for comment, null if not deleted
   */
  deletedTime: any | null;
  /**
   * The entity on which this note was written
   */
  parentEntity: GetPinnedEvents_pinnedEvents_edges_node_payload_Comment_parentEntity | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Session_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https:             // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The `www.nutshell.com` part of https: // www.nutshell.com/features?utm_source=Google
   */
  host: string | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Session_browser {
  __typename: "Browser";
  /**
   * The platform for the visit
   */
  platform: string;
  /**
   * The device type for the visit
   */
  deviceType: DeviceType;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Session_source {
  __typename: "McfxVisitSource";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The utm_medium value for this particular visit
   */
  medium: string;
  /**
   * The utm_source value for this particular visit
   */
  source: string;
  /**
   * Then mROI channel derived from this source information
   */
  channel: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Session_contact_nutshellContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Session_contact {
  __typename: "McfxContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The contact that made this form submission.
   */
  nutshellContact: GetPinnedEvents_pinnedEvents_edges_node_payload_Session_contact_nutshellContact | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Session_visits_edges_node_maUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Session_visits_edges_node_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The `/features` part of https: // www.nutshell.com/features?utm_source=Google
   */
  path: string | null;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
  /**
   * The full URL, i.e. https:      // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Session_visits_edges_node {
  __typename: "Visit";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * How long the specific page visit lasted.
   */
  durationSeconds: number;
  /**
   * The marketing automation URL associated with this visit, if any.
   */
  maUrl: GetPinnedEvents_pinnedEvents_edges_node_payload_Session_visits_edges_node_maUrl | null;
  /**
   * The page url for this user visit.
   */
  url: GetPinnedEvents_pinnedEvents_edges_node_payload_Session_visits_edges_node_url;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Session_visits_edges {
  __typename: "SessionVisitsEdge";
  node: GetPinnedEvents_pinnedEvents_edges_node_payload_Session_visits_edges_node;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Session_visits {
  __typename: "SessionVisitsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The total amount of time the visits lasted.
   */
  totalDuration: number | null;
  /**
   * The number of visits that have an associated marketing automation URL.
   */
  maUrlCount: number;
  /**
   * A list of edges.
   */
  edges: GetPinnedEvents_pinnedEvents_edges_node_payload_Session_visits_edges[];
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Session {
  __typename: "Session";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The url for the session, used to open as a timeline entry modal.
   */
  htmlUrlPath: string;
  /**
   * Some basic info on the location of the user represented as a string.
   */
  locationSummary: string | null;
  /**
   * The session url.
   */
  url: GetPinnedEvents_pinnedEvents_edges_node_payload_Session_url;
  /**
   * The platform the user was on during the session.
   */
  browser: GetPinnedEvents_pinnedEvents_edges_node_payload_Session_browser | null;
  source: GetPinnedEvents_pinnedEvents_edges_node_payload_Session_source;
  /**
   * The contact associated with this session.
   */
  contact: GetPinnedEvents_pinnedEvents_edges_node_payload_Session_contact | null;
  visits: GetPinnedEvents_pinnedEvents_edges_node_payload_Session_visits;
  /**
   * When this session started. This is the value we’ll display to the user
   */
  startTime: any;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Thread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Thread_displayMessage_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  htmlUrl: string | null;
  avatarUrl: string;
  initials: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Thread_displayMessage_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Thread_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The content of the message
   */
  content: string;
  /**
   * The plain text to display the message
   */
  plainTextForDisplay: string | null;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The user who created this thread
   */
  creatorUser: GetPinnedEvents_pinnedEvents_edges_node_payload_Thread_displayMessage_creatorUser | null;
  /**
   * The origin of the user who created this thread
   */
  creatorOrigin: GetPinnedEvents_pinnedEvents_edges_node_payload_Thread_displayMessage_creatorOrigin | null;
  /**
   * The images in the message
   */
  images: string[];
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Thread_messages {
  __typename: "ThreadMessagesConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Thread_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  htmlUrl: string | null;
  avatarUrl: string;
  initials: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Thread_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Thread_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  initials: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Thread_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  initials: string;
}

export type GetPinnedEvents_pinnedEvents_edges_node_payload_Thread_bestEntity = GetPinnedEvents_pinnedEvents_edges_node_payload_Thread_bestEntity_Lead | GetPinnedEvents_pinnedEvents_edges_node_payload_Thread_bestEntity_Account | GetPinnedEvents_pinnedEvents_edges_node_payload_Thread_bestEntity_Contact;

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external channel this thread is related to
   */
  externalChannel: GetPinnedEvents_pinnedEvents_edges_node_payload_Thread_externalChannel;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: GetPinnedEvents_pinnedEvents_edges_node_payload_Thread_displayMessage | null;
  /**
   * The messages associated with this thread
   */
  messages: GetPinnedEvents_pinnedEvents_edges_node_payload_Thread_messages;
  /**
   * the number of inbound messages on this thread
   */
  replyCount: number;
  /**
   * The user who created this thread
   */
  creatorUser: GetPinnedEvents_pinnedEvents_edges_node_payload_Thread_creatorUser | null;
  /**
   * The best entity associated with this thread
   */
  bestEntity: GetPinnedEvents_pinnedEvents_edges_node_payload_Thread_bestEntity | null;
  /**
   * Whether this thread can be reopened
   */
  canReopen: boolean;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Message_edition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Message_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetPinnedEvents_pinnedEvents_edges_node_payload_Message_edition_campaign;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Message_thread_bestEntity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Message_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The best entity associated with this thread
   */
  bestEntity: GetPinnedEvents_pinnedEvents_edges_node_payload_Message_thread_bestEntity | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Message {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The edition of the message
   */
  edition: GetPinnedEvents_pinnedEvents_edges_node_payload_Message_edition | null;
  /**
   * The thread this message is part of
   */
  thread: GetPinnedEvents_pinnedEvents_edges_node_payload_Message_thread;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Quote_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Quote_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetPinnedEvents_pinnedEvents_edges_node_payload_Quote_lead_accounts_primaryEdge_node;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Quote_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPinnedEvents_pinnedEvents_edges_node_payload_Quote_lead_accounts_primaryEdge | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Quote_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Quote_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetPinnedEvents_pinnedEvents_edges_node_payload_Quote_lead_contacts_primaryEdge_node;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Quote_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPinnedEvents_pinnedEvents_edges_node_payload_Quote_lead_contacts_primaryEdge | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Quote_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetPinnedEvents_pinnedEvents_edges_node_payload_Quote_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetPinnedEvents_pinnedEvents_edges_node_payload_Quote_lead_contacts;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Quote_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: GetPinnedEvents_pinnedEvents_edges_node_payload_Quote_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetPinnedEvents_pinnedEvents_edges_node_payload_Quote_total;
  /**
   * The user that created the quote
   */
  creatorUser: GetPinnedEvents_pinnedEvents_edges_node_payload_Quote_creatorUser | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge_node;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge_node;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Quote_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Quote_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Quote_total;
  /**
   * The user that created the quote
   */
  creatorUser: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Quote_creatorUser | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge_node;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge_node;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Invoice_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Invoice_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Invoice_total;
  /**
   * The user that created the quote
   */
  creatorUser: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Invoice_creatorUser | null;
}

export type GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument = GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Quote | GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument_Invoice;

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_contract_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_contract_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_contract_lead_accounts_primaryEdge_node;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_contract_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_contract_lead_accounts_primaryEdge | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_contract_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_contract_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_contract_lead_contacts_primaryEdge_node;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_contract_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_contract_lead_contacts_primaryEdge | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_contract_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_contract_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_contract_lead_contacts;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_contract_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_contract {
  __typename: "Contract";
  id: string;
  /**
   * The htmlUrl path without domain.
   */
  htmlUrlPath: string;
  lead: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_contract_lead;
  displayNumber: string;
  creatorUser: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_contract_creatorUser | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView {
  __typename: "DocumentView";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The quote or invoice this view is attached to, when applicable
   */
  salesDocument: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_salesDocument | null;
  /**
   * The contract this view is attached to, when applicable
   */
  contract: GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView_contract | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Invoice_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Invoice_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetPinnedEvents_pinnedEvents_edges_node_payload_Invoice_lead_accounts_primaryEdge_node;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Invoice_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPinnedEvents_pinnedEvents_edges_node_payload_Invoice_lead_accounts_primaryEdge | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Invoice_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Invoice_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetPinnedEvents_pinnedEvents_edges_node_payload_Invoice_lead_contacts_primaryEdge_node;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Invoice_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPinnedEvents_pinnedEvents_edges_node_payload_Invoice_lead_contacts_primaryEdge | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Invoice_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetPinnedEvents_pinnedEvents_edges_node_payload_Invoice_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetPinnedEvents_pinnedEvents_edges_node_payload_Invoice_lead_contacts;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Invoice_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: GetPinnedEvents_pinnedEvents_edges_node_payload_Invoice_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetPinnedEvents_pinnedEvents_edges_node_payload_Invoice_total;
  /**
   * The user that created the quote
   */
  creatorUser: GetPinnedEvents_pinnedEvents_edges_node_payload_Invoice_creatorUser | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Contract_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Contract_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetPinnedEvents_pinnedEvents_edges_node_payload_Contract_lead_accounts_primaryEdge_node;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Contract_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPinnedEvents_pinnedEvents_edges_node_payload_Contract_lead_accounts_primaryEdge | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Contract_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Contract_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetPinnedEvents_pinnedEvents_edges_node_payload_Contract_lead_contacts_primaryEdge_node;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Contract_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetPinnedEvents_pinnedEvents_edges_node_payload_Contract_lead_contacts_primaryEdge | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Contract_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetPinnedEvents_pinnedEvents_edges_node_payload_Contract_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetPinnedEvents_pinnedEvents_edges_node_payload_Contract_lead_contacts;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Contract_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_Contract {
  __typename: "Contract";
  id: string;
  /**
   * The htmlUrl path without domain.
   */
  htmlUrlPath: string;
  lead: GetPinnedEvents_pinnedEvents_edges_node_payload_Contract_lead;
  displayNumber: string;
  creatorUser: GetPinnedEvents_pinnedEvents_edges_node_payload_Contract_creatorUser | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_LeadClonePayload_original_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_LeadClonePayload_original {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetPinnedEvents_pinnedEvents_edges_node_payload_LeadClonePayload_original_value | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_LeadClonePayload_clone_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_LeadClonePayload_clone {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetPinnedEvents_pinnedEvents_edges_node_payload_LeadClonePayload_clone_value | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_payload_LeadClonePayload {
  __typename: "LeadClonePayload";
  /**
   * The original lead
   */
  original: GetPinnedEvents_pinnedEvents_edges_node_payload_LeadClonePayload_original;
  /**
   * The cloned lead
   */
  clone: GetPinnedEvents_pinnedEvents_edges_node_payload_LeadClonePayload_clone;
}

export type GetPinnedEvents_pinnedEvents_edges_node_payload = GetPinnedEvents_pinnedEvents_edges_node_payload_TimelineEventPayloadUnknownType | GetPinnedEvents_pinnedEvents_edges_node_payload_Activity | GetPinnedEvents_pinnedEvents_edges_node_payload_AccountRelationshipChange | GetPinnedEvents_pinnedEvents_edges_node_payload_AccountContactFormerStatusChange | GetPinnedEvents_pinnedEvents_edges_node_payload_Note | GetPinnedEvents_pinnedEvents_edges_node_payload_Email | GetPinnedEvents_pinnedEvents_edges_node_payload_EmailQueued | GetPinnedEvents_pinnedEvents_edges_node_payload_Origin | GetPinnedEvents_pinnedEvents_edges_node_payload_Submission | GetPinnedEvents_pinnedEvents_edges_node_payload_Account | GetPinnedEvents_pinnedEvents_edges_node_payload_Contact | GetPinnedEvents_pinnedEvents_edges_node_payload_Lead | GetPinnedEvents_pinnedEvents_edges_node_payload_Chat | GetPinnedEvents_pinnedEvents_edges_node_payload_Assignment | GetPinnedEvents_pinnedEvents_edges_node_payload_EmailInteraction | GetPinnedEvents_pinnedEvents_edges_node_payload_ConstantContactContactTrackingActivity | GetPinnedEvents_pinnedEvents_edges_node_payload_EntityAttributeValueFile | GetPinnedEvents_pinnedEvents_edges_node_payload_Comment | GetPinnedEvents_pinnedEvents_edges_node_payload_Session | GetPinnedEvents_pinnedEvents_edges_node_payload_Thread | GetPinnedEvents_pinnedEvents_edges_node_payload_Message | GetPinnedEvents_pinnedEvents_edges_node_payload_Quote | GetPinnedEvents_pinnedEvents_edges_node_payload_DocumentView | GetPinnedEvents_pinnedEvents_edges_node_payload_Invoice | GetPinnedEvents_pinnedEvents_edges_node_payload_Contract | GetPinnedEvents_pinnedEvents_edges_node_payload_LeadClonePayload;

export interface GetPinnedEvents_pinnedEvents_edges_node_changes {
  __typename: "ChangeLogChange";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attrbute changed by the entry
   */
  attribute: string;
  /**
   * The old value before the change
   */
  oldValue: string | null;
  /**
   * The new value after the change
   */
  newValue: string | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_files_eavEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_files_eavEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_files_eavEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_files_eavEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: GetPinnedEvents_pinnedEvents_edges_node_files_eavEntity_Lead_value | null;
}

export type GetPinnedEvents_pinnedEvents_edges_node_files_eavEntity = GetPinnedEvents_pinnedEvents_edges_node_files_eavEntity_Account | GetPinnedEvents_pinnedEvents_edges_node_files_eavEntity_Contact | GetPinnedEvents_pinnedEvents_edges_node_files_eavEntity_Lead;

export interface GetPinnedEvents_pinnedEvents_edges_node_files {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The entity that this file is associated with
   */
  eavEntity: GetPinnedEvents_pinnedEvents_edges_node_files_eavEntity;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: GetPinnedEvents_pinnedEvents_edges_node_reactions_creatorUser;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_comments_changeLogEntry {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_comments_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_comments_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: GetPinnedEvents_pinnedEvents_edges_node_comments_reactions_creatorUser;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_comments_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  htmlUrl: string | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_node_comments {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Change log associated with the comment
   */
  changeLogEntry: GetPinnedEvents_pinnedEvents_edges_node_comments_changeLogEntry | null;
  /**
   * User reactions left for the comment change log entry
   */
  reactions: GetPinnedEvents_pinnedEvents_edges_node_comments_reactions[];
  /**
   * The user who created the comment.
   */
  creatorUser: GetPinnedEvents_pinnedEvents_edges_node_comments_creatorUser;
  /**
   * The created time for the comment.
   */
  createdTime: any;
  /**
   * True if this comment can be deleted
   */
  isDeleteable: boolean;
}

export interface GetPinnedEvents_pinnedEvents_edges_node {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of change i.e. created, modified, deleted, etc
   */
  changeType: ChangeType;
  /**
   * The entity that triggered the change_log entry
   */
  actor: GetPinnedEvents_pinnedEvents_edges_node_actor;
  payload: GetPinnedEvents_pinnedEvents_edges_node_payload;
  changeTime: any;
  changes: GetPinnedEvents_pinnedEvents_edges_node_changes[];
  /**
   * A one-off property to handle the case where multiple files can be associated
   * with a single change log entry. This is the only situation where multiple
   * payloads exist on an entry, so rather than adding additional complexity to our
   * entire system, we’ll treat it as a separate property
   */
  files: GetPinnedEvents_pinnedEvents_edges_node_files[];
  reactions: GetPinnedEvents_pinnedEvents_edges_node_reactions[];
  comments: GetPinnedEvents_pinnedEvents_edges_node_comments[];
  /**
   * When multiple of the same entry occurs in a row, we’ll roll-up the count. For
   * example, if someone views an email 3 times in a row before a different change,
   * this value will be 3.
   */
  count: number | null;
}

export interface GetPinnedEvents_pinnedEvents_edges_pinnedInfo_pinnedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetPinnedEvents_pinnedEvents_edges_pinnedInfo {
  __typename: "PinnedInfo";
  pinnedTime: any | null;
  pinnedByUser: GetPinnedEvents_pinnedEvents_edges_pinnedInfo_pinnedByUser;
}

export interface GetPinnedEvents_pinnedEvents_edges {
  __typename: "TimelineEventsEdge";
  node: GetPinnedEvents_pinnedEvents_edges_node;
  pinnedInfo: GetPinnedEvents_pinnedEvents_edges_pinnedInfo | null;
}

export interface GetPinnedEvents_pinnedEvents {
  __typename: "TimelineEventsConnection";
  /**
   * A list of edges.
   */
  edges: GetPinnedEvents_pinnedEvents_edges[];
}

export interface GetPinnedEvents {
  /**
   * A list of timeline events representing entities that have been pinned to another entity
   */
  pinnedEvents: GetPinnedEvents_pinnedEvents;
}

export interface GetPinnedEventsVariables {
  input: TimelineEventsPinnedInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetRelatedLeads
// ====================================================

export interface GetRelatedLeads_event_payload_Note {
  __typename: "Note" | "EmailQueued" | "EmailInteraction" | "Origin" | "Submission" | "Account" | "Contact" | "Lead" | "ConstantContactContactTrackingActivity" | "Assignment" | "Comment" | "TimelineEventPayloadUnknownType" | "EntityAttributeValueFile" | "Session" | "AccountRelationshipChange" | "Quote" | "DocumentView" | "Invoice" | "Contract" | "LeadClonePayload" | "AccountContactFormerStatusChange" | "Thread" | "Message";
}

export interface GetRelatedLeads_event_payload_Activity_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetRelatedLeads_event_payload_Activity_relatedLeads_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetRelatedLeads_event_payload_Activity_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetRelatedLeads_event_payload_Activity_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetRelatedLeads_event_payload_Activity_relatedLeads_contacts_primaryEdge_node;
}

export interface GetRelatedLeads_event_payload_Activity_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetRelatedLeads_event_payload_Activity_relatedLeads_contacts_primaryEdge | null;
}

export interface GetRelatedLeads_event_payload_Activity_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetRelatedLeads_event_payload_Activity_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetRelatedLeads_event_payload_Activity_relatedLeads_accounts_primaryEdge_node;
}

export interface GetRelatedLeads_event_payload_Activity_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetRelatedLeads_event_payload_Activity_relatedLeads_accounts_primaryEdge | null;
}

export interface GetRelatedLeads_event_payload_Activity_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: GetRelatedLeads_event_payload_Activity_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetRelatedLeads_event_payload_Activity_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetRelatedLeads_event_payload_Activity_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetRelatedLeads_event_payload_Activity_relatedLeads_accounts;
}

export interface GetRelatedLeads_event_payload_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Related leads for the activity.
   */
  relatedLeads: GetRelatedLeads_event_payload_Activity_relatedLeads[];
}

export interface GetRelatedLeads_event_payload_Email_emailRelatedLeads_edges_node_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetRelatedLeads_event_payload_Email_emailRelatedLeads_edges_node_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetRelatedLeads_event_payload_Email_emailRelatedLeads_edges_node_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetRelatedLeads_event_payload_Email_emailRelatedLeads_edges_node_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetRelatedLeads_event_payload_Email_emailRelatedLeads_edges_node_contacts_primaryEdge_node;
}

export interface GetRelatedLeads_event_payload_Email_emailRelatedLeads_edges_node_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetRelatedLeads_event_payload_Email_emailRelatedLeads_edges_node_contacts_primaryEdge | null;
}

export interface GetRelatedLeads_event_payload_Email_emailRelatedLeads_edges_node_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetRelatedLeads_event_payload_Email_emailRelatedLeads_edges_node_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetRelatedLeads_event_payload_Email_emailRelatedLeads_edges_node_accounts_primaryEdge_node;
}

export interface GetRelatedLeads_event_payload_Email_emailRelatedLeads_edges_node_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetRelatedLeads_event_payload_Email_emailRelatedLeads_edges_node_accounts_primaryEdge | null;
}

export interface GetRelatedLeads_event_payload_Email_emailRelatedLeads_edges_node {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: GetRelatedLeads_event_payload_Email_emailRelatedLeads_edges_node_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetRelatedLeads_event_payload_Email_emailRelatedLeads_edges_node_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetRelatedLeads_event_payload_Email_emailRelatedLeads_edges_node_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetRelatedLeads_event_payload_Email_emailRelatedLeads_edges_node_accounts;
}

export interface GetRelatedLeads_event_payload_Email_emailRelatedLeads_edges {
  __typename: "EmailLeadsEdge";
  /**
   * Is this lead mapped to this email?
   */
  isMapped: boolean;
  node: GetRelatedLeads_event_payload_Email_emailRelatedLeads_edges_node;
}

export interface GetRelatedLeads_event_payload_Email_emailRelatedLeads {
  __typename: "EmailLeadsConnection";
  /**
   * A list of edges.
   */
  edges: GetRelatedLeads_event_payload_Email_emailRelatedLeads_edges[];
}

export interface GetRelatedLeads_event_payload_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Gets all leads related to this email. This includes all open leads at the time
   * of send, as well as any previously/explicitly associated leads
   */
  emailRelatedLeads: GetRelatedLeads_event_payload_Email_emailRelatedLeads;
}

export interface GetRelatedLeads_event_payload_Chat_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetRelatedLeads_event_payload_Chat_relatedLeads_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetRelatedLeads_event_payload_Chat_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetRelatedLeads_event_payload_Chat_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetRelatedLeads_event_payload_Chat_relatedLeads_contacts_primaryEdge_node;
}

export interface GetRelatedLeads_event_payload_Chat_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetRelatedLeads_event_payload_Chat_relatedLeads_contacts_primaryEdge | null;
}

export interface GetRelatedLeads_event_payload_Chat_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetRelatedLeads_event_payload_Chat_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetRelatedLeads_event_payload_Chat_relatedLeads_accounts_primaryEdge_node;
}

export interface GetRelatedLeads_event_payload_Chat_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetRelatedLeads_event_payload_Chat_relatedLeads_accounts_primaryEdge | null;
}

export interface GetRelatedLeads_event_payload_Chat_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: GetRelatedLeads_event_payload_Chat_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetRelatedLeads_event_payload_Chat_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetRelatedLeads_event_payload_Chat_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetRelatedLeads_event_payload_Chat_relatedLeads_accounts;
}

export interface GetRelatedLeads_event_payload_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Related leads for the activity.
   */
  relatedLeads: GetRelatedLeads_event_payload_Chat_relatedLeads[];
}

export type GetRelatedLeads_event_payload = GetRelatedLeads_event_payload_Note | GetRelatedLeads_event_payload_Activity | GetRelatedLeads_event_payload_Email | GetRelatedLeads_event_payload_Chat;

export interface GetRelatedLeads_event {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  payload: GetRelatedLeads_event_payload;
}

export interface GetRelatedLeads {
  /**
   * Returns a change log event for the timeline.
   */
  event: GetRelatedLeads_event;
}

export interface GetRelatedLeadsVariables {
  changeLogId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateReaction
// ====================================================

export interface CreateReaction_reactionCreate_reaction_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CreateReaction_reactionCreate_reaction {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: CreateReaction_reactionCreate_reaction_creatorUser;
}

export interface CreateReaction_reactionCreate {
  __typename: "ReactionCreatePayload";
  /**
   * The new reaction
   */
  reaction: CreateReaction_reactionCreate_reaction;
}

export interface CreateReaction {
  /**
   * Creates a reaction
   */
  reactionCreate: CreateReaction_reactionCreate;
}

export interface CreateReactionVariables {
  input: ReactionCreateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteReaction
// ====================================================

export interface DeleteReaction_reactionDelete {
  __typename: "ReactionDeletePayload";
  /**
   * True if reaction was successfully deleted
   */
  reactionDeleted: boolean;
}

export interface DeleteReaction {
  /**
   * Deletes a reaction
   */
  reactionDelete: DeleteReaction_reactionDelete;
}

export interface DeleteReactionVariables {
  input: ReactionDeleteInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateEmailLeadAssociations
// ====================================================

export interface UpdateEmailLeadAssociations_emailLeadAssociationsUpdate_email_relatedLeads_edges_node {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UpdateEmailLeadAssociations_emailLeadAssociationsUpdate_email_relatedLeads_edges {
  __typename: "EmailLeadsEdge";
  node: UpdateEmailLeadAssociations_emailLeadAssociationsUpdate_email_relatedLeads_edges_node;
}

export interface UpdateEmailLeadAssociations_emailLeadAssociationsUpdate_email_relatedLeads {
  __typename: "EmailLeadsConnection";
  /**
   * A list of edges.
   */
  edges: UpdateEmailLeadAssociations_emailLeadAssociationsUpdate_email_relatedLeads_edges[];
}

export interface UpdateEmailLeadAssociations_emailLeadAssociationsUpdate_email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Gets all leads related to this email. This includes all open leads at the time
   * of send, as well as any previously/explicitly associated leads
   */
  relatedLeads: UpdateEmailLeadAssociations_emailLeadAssociationsUpdate_email_relatedLeads;
}

export interface UpdateEmailLeadAssociations_emailLeadAssociationsUpdate {
  __typename: "EmailLeadAssociationsUpdatePayload";
  /**
   * Resulting email after lead associations have been updated
   */
  email: UpdateEmailLeadAssociations_emailLeadAssociationsUpdate_email;
}

export interface UpdateEmailLeadAssociations {
  /**
   * Updates the associations between an email and its related leads
   */
  emailLeadAssociationsUpdate: UpdateEmailLeadAssociations_emailLeadAssociationsUpdate;
}

export interface UpdateEmailLeadAssociationsVariables {
  input: EmailLeadAssociationsUpdateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ContactsCreateFromEmailSync
// ====================================================

export interface ContactsCreateFromEmailSync_contactsCreateFromEmailSync {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface ContactsCreateFromEmailSync {
  contactsCreateFromEmailSync: ContactsCreateFromEmailSync_contactsCreateFromEmailSync[];
}

export interface ContactsCreateFromEmailSyncVariables {
  input: ContactsCreateFromEmailSyncInput[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: googleSetInitialSyncSettings
// ====================================================

export interface googleSetInitialSyncSettings_googleSetInitialSyncSettings {
  __typename: "GoogleSetInitialSyncSettingsPayload";
  success: boolean;
  errorMessage: string | null;
}

export interface googleSetInitialSyncSettings {
  /**
   * Enable email and calendar sync settings for Google after initial OAuth.
   */
  googleSetInitialSyncSettings: googleSetInitialSyncSettings_googleSetInitialSyncSettings | null;
}

export interface googleSetInitialSyncSettingsVariables {
  input: GoogleSetInitialSyncSettingsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MarkExploreAttentionBadgeAsSeen
// ====================================================

export interface MarkExploreAttentionBadgeAsSeen_exploreAttentionBadgeMarkAsSeen {
  __typename: "ExploreAttentionBadgeMarkAsSeenPayload";
  success: boolean;
}

export interface MarkExploreAttentionBadgeAsSeen {
  /**
   * Marks the explore attention badge as seen for the current user
   */
  exploreAttentionBadgeMarkAsSeen: MarkExploreAttentionBadgeAsSeen_exploreAttentionBadgeMarkAsSeen;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: office365SetInitialSyncSettings
// ====================================================

export interface office365SetInitialSyncSettings_office365SetInitialSyncSettings {
  __typename: "Office365SetInitialSyncSettingsPayload";
  success: boolean;
  errorMessage: string | null;
}

export interface office365SetInitialSyncSettings {
  /**
   * Enable email and calendar sync settings for Microsoft after initial OAuth.
   */
  office365SetInitialSyncSettings: office365SetInitialSyncSettings_office365SetInitialSyncSettings | null;
}

export interface office365SetInitialSyncSettingsVariables {
  input: Office365SetInitialSyncSettingsInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCustomerOnboarding
// ====================================================

export interface GetCustomerOnboarding_customerOnboarding_shownModules_steps {
  __typename: "OnboardingStep";
  /**
   * The name of the step
   */
  title: string;
  /**
   * The type of the step
   */
  type: OnboardingStepType;
  /**
   * Whether the step is complete
   */
  isComplete: boolean;
}

export interface GetCustomerOnboarding_customerOnboarding_shownModules {
  __typename: "OnboardingModule";
  /**
   * The name of the onboarding module
   */
  name: string;
  /**
   * The type of the onboarding module
   */
  type: OnboardingModuleType;
  /**
   * The status of the onboarding module
   */
  status: OnboardingModuleStatus;
  /**
   * The description of the onboarding module
   */
  description: string;
  /**
   * Whether the onboarding module is complete
   */
  isComplete: boolean;
  /**
   * The steps of the onboarding module
   */
  steps: GetCustomerOnboarding_customerOnboarding_shownModules_steps[];
}

export interface GetCustomerOnboarding_customerOnboarding_hiddenModules_steps {
  __typename: "OnboardingStep";
  /**
   * The name of the step
   */
  title: string;
  /**
   * The type of the step
   */
  type: OnboardingStepType;
  /**
   * Whether the step is complete
   */
  isComplete: boolean;
}

export interface GetCustomerOnboarding_customerOnboarding_hiddenModules {
  __typename: "OnboardingModule";
  /**
   * The name of the onboarding module
   */
  name: string;
  /**
   * The type of the onboarding module
   */
  type: OnboardingModuleType;
  /**
   * The status of the onboarding module
   */
  status: OnboardingModuleStatus;
  /**
   * The description of the onboarding module
   */
  description: string;
  /**
   * Whether the onboarding module is complete
   */
  isComplete: boolean;
  /**
   * The steps of the onboarding module
   */
  steps: GetCustomerOnboarding_customerOnboarding_hiddenModules_steps[];
}

export interface GetCustomerOnboarding_customerOnboarding {
  __typename: "CustomerOnboarding";
  /**
   * The onboarding modules to include in the "shown" section
   */
  shownModules: GetCustomerOnboarding_customerOnboarding_shownModules[];
  /**
   * The onboarding modules to include in the "hidden" section
   */
  hiddenModules: GetCustomerOnboarding_customerOnboarding_hiddenModules[];
}

export interface GetCustomerOnboarding {
  /**
   * The onboarding module sections for existing customers
   */
  customerOnboarding: GetCustomerOnboarding_customerOnboarding | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEmailCalendarStatuses
// ====================================================

export interface GetEmailCalendarStatuses_loggedInUser_calendarSync {
  __typename: "CalendarSync";
  /**
   * The email address being used for calendar sync
   */
  username: string;
  /**
   * Whether or not calendar sync is enabled
   */
  isEnabled: boolean;
}

export interface GetEmailCalendarStatuses_loggedInUser_sendableEmailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetEmailCalendarStatuses_loggedInUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Calendar sync details for this user
   */
  calendarSync: GetEmailCalendarStatuses_loggedInUser_calendarSync | null;
  /**
   * List of successfully enabled user email addresses that a user is able to send emails from Nutshell with.
   */
  sendableEmailAddresses: GetEmailCalendarStatuses_loggedInUser_sendableEmailAddresses[];
  hasMailSyncEnabled: boolean;
}

export interface GetEmailCalendarStatuses {
  /**
   * Returns the requesting user. This is essentially the logged in user, but in an
   * API context, they might not be any "logged in"
   */
  loggedInUser: GetEmailCalendarStatuses_loggedInUser;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEmailSyncPotentialContacts
// ====================================================

export interface GetEmailSyncPotentialContacts_getEmailSyncPotentialContacts_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  address: string;
}

export interface GetEmailSyncPotentialContacts_getEmailSyncPotentialContacts {
  __typename: "EmailSyncFoundContact";
  emailAddress: GetEmailSyncPotentialContacts_getEmailSyncPotentialContacts_emailAddress;
  lastContactedTime: any | null;
}

export interface GetEmailSyncPotentialContacts {
  getEmailSyncPotentialContacts: GetEmailSyncPotentialContacts_getEmailSyncPotentialContacts[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetGroupOnboardingBanner
// ====================================================

export interface GetGroupOnboardingBanner_groupOnboardingBanner_demioEvent {
  __typename: "Webcast";
  /**
   * The id field denoting a single instance of a webcast event.
   */
  id: number;
  /**
   * The name of the Webcast.
   */
  name: string;
  /**
   * The registration url for a specific Webcast event.
   */
  registrationUrl: string;
  /**
   * The DateTime that represents when the Webcast will take place.
   */
  timestamp: any;
  isCurrentUserRegistered: boolean;
}

export interface GetGroupOnboardingBanner_groupOnboardingBanner_upcomingEvents {
  __typename: "Webcast";
  /**
   * The id field denoting a single instance of a webcast event.
   */
  id: number;
  /**
   * The name of the Webcast.
   */
  name: string;
  /**
   * The registration url for a specific Webcast event.
   */
  registrationUrl: string;
  /**
   * The DateTime that represents when the Webcast will take place.
   */
  timestamp: any;
  isCurrentUserRegistered: boolean;
}

export interface GetGroupOnboardingBanner_groupOnboardingBanner {
  __typename: "CTABanner";
  /**
   * The title of the banner
   */
  key: CTABannerKey;
  /**
   * The title of the banner
   */
  ctaType: CTABannerType;
  /**
   * The title of the banner
   */
  title: string;
  /**
   * The subtitle of the banner
   */
  subtitle: string;
  /**
   * The url to register a meeting with a team member
   */
  registrationUrl: string | null;
  /**
   * The dismiss setting associated with this banner
   */
  dismissSettingName: string;
  /**
   * The event for the banner
   */
  demioEvent: GetGroupOnboardingBanner_groupOnboardingBanner_demioEvent | null;
  /**
   * A list of upcoming events
   */
  upcomingEvents: GetGroupOnboardingBanner_groupOnboardingBanner_upcomingEvents[];
}

export interface GetGroupOnboardingBanner {
  /**
   * Returns the group onboarding session banner.
   */
  groupOnboardingBanner: GetGroupOnboardingBanner_groupOnboardingBanner | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetIntroWebcastBanner
// ====================================================

export interface GetIntroWebcastBanner_introWebcastBanner_demioEvent {
  __typename: "Webcast";
  /**
   * The id field denoting a single instance of a webcast event.
   */
  id: number;
  /**
   * The name of the Webcast.
   */
  name: string;
  /**
   * The registration url for a specific Webcast event.
   */
  registrationUrl: string;
  /**
   * The DateTime that represents when the Webcast will take place.
   */
  timestamp: any;
  isCurrentUserRegistered: boolean;
}

export interface GetIntroWebcastBanner_introWebcastBanner_upcomingEvents {
  __typename: "Webcast";
  /**
   * The id field denoting a single instance of a webcast event.
   */
  id: number;
  /**
   * The name of the Webcast.
   */
  name: string;
  /**
   * The registration url for a specific Webcast event.
   */
  registrationUrl: string;
  /**
   * The DateTime that represents when the Webcast will take place.
   */
  timestamp: any;
  isCurrentUserRegistered: boolean;
}

export interface GetIntroWebcastBanner_introWebcastBanner {
  __typename: "CTABanner";
  /**
   * The title of the banner
   */
  key: CTABannerKey;
  /**
   * The title of the banner
   */
  ctaType: CTABannerType;
  /**
   * The title of the banner
   */
  title: string;
  /**
   * The subtitle of the banner
   */
  subtitle: string;
  /**
   * The url to register a meeting with a team member
   */
  registrationUrl: string | null;
  /**
   * The dismiss setting associated with this banner
   */
  dismissSettingName: string;
  /**
   * The event for the banner
   */
  demioEvent: GetIntroWebcastBanner_introWebcastBanner_demioEvent | null;
  /**
   * A list of upcoming events
   */
  upcomingEvents: GetIntroWebcastBanner_introWebcastBanner_upcomingEvents[];
}

export interface GetIntroWebcastBanner {
  /**
   * Returns the intro webcast banner.
   */
  introWebcastBanner: GetIntroWebcastBanner_introWebcastBanner | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetTrialOnboarding
// ====================================================

export interface GetTrialOnboarding_trialOnboarding_tailoredModules_steps {
  __typename: "OnboardingStep";
  /**
   * The name of the step
   */
  title: string;
  /**
   * The type of the step
   */
  type: OnboardingStepType;
  /**
   * Whether the step is complete
   */
  isComplete: boolean;
}

export interface GetTrialOnboarding_trialOnboarding_tailoredModules {
  __typename: "OnboardingModule";
  /**
   * The name of the onboarding module
   */
  name: string;
  /**
   * The type of the onboarding module
   */
  type: OnboardingModuleType;
  /**
   * The status of the onboarding module
   */
  status: OnboardingModuleStatus;
  /**
   * The description of the onboarding module
   */
  description: string;
  /**
   * Whether the onboarding module is complete
   */
  isComplete: boolean;
  /**
   * The steps of the onboarding module
   */
  steps: GetTrialOnboarding_trialOnboarding_tailoredModules_steps[];
}

export interface GetTrialOnboarding_trialOnboarding_additionalModules_steps {
  __typename: "OnboardingStep";
  /**
   * The name of the step
   */
  title: string;
  /**
   * The type of the step
   */
  type: OnboardingStepType;
  /**
   * Whether the step is complete
   */
  isComplete: boolean;
}

export interface GetTrialOnboarding_trialOnboarding_additionalModules {
  __typename: "OnboardingModule";
  /**
   * The name of the onboarding module
   */
  name: string;
  /**
   * The type of the onboarding module
   */
  type: OnboardingModuleType;
  /**
   * The status of the onboarding module
   */
  status: OnboardingModuleStatus;
  /**
   * The description of the onboarding module
   */
  description: string;
  /**
   * Whether the onboarding module is complete
   */
  isComplete: boolean;
  /**
   * The steps of the onboarding module
   */
  steps: GetTrialOnboarding_trialOnboarding_additionalModules_steps[];
}

export interface GetTrialOnboarding_trialOnboarding_onboardingQuotes_openQuote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface GetTrialOnboarding_trialOnboarding_onboardingQuotes {
  __typename: "OnboardingQuotes";
  /**
   * The quote to open for onboarding walkthrough
   */
  openQuote: GetTrialOnboarding_trialOnboarding_onboardingQuotes_openQuote | null;
}

export interface GetTrialOnboarding_trialOnboarding {
  __typename: "OnboardingHub";
  /**
   * The onboarding modules picked for this given instance/user
   */
  tailoredModules: GetTrialOnboarding_trialOnboarding_tailoredModules[];
  /**
   * The onboarding modules to further explore
   */
  additionalModules: GetTrialOnboarding_trialOnboarding_additionalModules[];
  /**
   * The quotes for onboarding steps
   */
  onboardingQuotes: GetTrialOnboarding_trialOnboarding_onboardingQuotes;
}

export interface GetTrialOnboarding {
  /**
   * Gets the onboarding hub for the current instance/user
   */
  trialOnboarding: GetTrialOnboarding_trialOnboarding | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserVideoIntegrations
// ====================================================

export interface GetUserVideoIntegrations_loggedInUser_zoomIntegration {
  __typename: "ZoomIntegration";
  /**
   * Whether or not the zoom integration is enabled
   */
  isEnabled: boolean;
}

export interface GetUserVideoIntegrations_loggedInUser_googleMeetIntegration {
  __typename: "GoogleMeetIntegration";
  /**
   * Whether or not the Google Meet integration is enabled with meet sync
   */
  isEnabledMeetSync: boolean;
}

export interface GetUserVideoIntegrations_loggedInUser_microsoftTeamsIntegration {
  __typename: "MicrosoftTeamsIntegration";
  /**
   * Whether or not the  Microsoft Teams integration is enabled
   */
  isEnabled: boolean;
}

export interface GetUserVideoIntegrations_loggedInUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Zoom integration details for this user
   */
  zoomIntegration: GetUserVideoIntegrations_loggedInUser_zoomIntegration;
  /**
   * Google Meet integration details for this user
   */
  googleMeetIntegration: GetUserVideoIntegrations_loggedInUser_googleMeetIntegration;
  /**
   * Microsoft Teams integration details for this user
   */
  microsoftTeamsIntegration: GetUserVideoIntegrations_loggedInUser_microsoftTeamsIntegration;
}

export interface GetUserVideoIntegrations {
  /**
   * Returns the requesting user. This is essentially the logged in user, but in an
   * API context, they might not be any "logged in"
   */
  loggedInUser: GetUserVideoIntegrations_loggedInUser;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TrialStart
// ====================================================

export interface TrialStart_trialStart {
  __typename: "TrialStartPayload";
  /**
   * The number of days remaining before this trial expires
   */
  daysRemaining: number | null;
}

export interface TrialStart {
  /**
   * Start an addon trial in Nutshell
   */
  trialStart: TrialStart_trialStart;
}

export interface TrialStartVariables {
  input: TrialStartInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetActiveWebinarAnnouncement
// ====================================================

export interface GetActiveWebinarAnnouncement_activeWebinarAnnouncement {
  __typename: "WebinarAnnouncement";
  id: string;
  title: string;
  /**
   * GitHub-flavored markdown source. Render client-side via `react-markdown`.
   */
  body: string;
  registerLink: string;
  registerText: string;
  /**
   * Optional markdown below the register CTA (seat limits, recording note).
   */
  subtext: string | null;
  /**
   * ISO-8601 datetime. Modal hidden until this instant (inclusive).
   */
  startTime: string;
  /**
   * ISO-8601 datetime. Modal hidden after this instant.
   */
  expiryTime: string;
  isLive: boolean;
  senderName: string;
  /**
   * Absolute web path to the sender avatar image.
   */
  senderAvatarSrc: string;
  /**
   * Absolute web path to the per-webinar hero image under `public/include/images/webinar-announcements/<id>/`.
   */
  heroImageSrc: string;
  /**
   * Human-readable schedule line shown next to the calendar icon (e.g. "Wednesday, July 22nd 2026 @ 3:00 PM EDT").
   */
  eventSchedule: string;
}

export interface GetActiveWebinarAnnouncement {
  /**
   * The single webinar announcement to auto-show as an in-app modal for the
   * current user, or null. Newest non-expired live entry that the user has not dismissed.
   */
  activeWebinarAnnouncement: GetActiveWebinarAnnouncement_activeWebinarAnnouncement | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDebugWebinarAnnouncements
// ====================================================

export interface GetDebugWebinarAnnouncements_debugWebinarAnnouncements {
  __typename: "WebinarAnnouncement";
  id: string;
  title: string;
  /**
   * GitHub-flavored markdown source. Render client-side via `react-markdown`.
   */
  body: string;
  registerLink: string;
  registerText: string;
  /**
   * Optional markdown below the register CTA (seat limits, recording note).
   */
  subtext: string | null;
  /**
   * ISO-8601 datetime. Modal hidden until this instant (inclusive).
   */
  startTime: string;
  /**
   * ISO-8601 datetime. Modal hidden after this instant.
   */
  expiryTime: string;
  isLive: boolean;
  senderName: string;
  /**
   * Absolute web path to the sender avatar image.
   */
  senderAvatarSrc: string;
  /**
   * Absolute web path to the per-webinar hero image under `public/include/images/webinar-announcements/<id>/`.
   */
  heroImageSrc: string;
  /**
   * Human-readable schedule line shown next to the calendar icon (e.g. "Wednesday, July 22nd 2026 @ 3:00 PM EDT").
   */
  eventSchedule: string;
}

export interface GetDebugWebinarAnnouncements {
  /**
   * All webinar announcements on disk, newest first, with no gating applied. Admin-only.
   */
  debugWebinarAnnouncements: GetDebugWebinarAnnouncements_debugWebinarAnnouncements[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWebinarAnnouncement
// ====================================================

export interface GetWebinarAnnouncement_webinarAnnouncement {
  __typename: "WebinarAnnouncement";
  id: string;
  title: string;
  /**
   * GitHub-flavored markdown source. Render client-side via `react-markdown`.
   */
  body: string;
  registerLink: string;
  registerText: string;
  /**
   * Optional markdown below the register CTA (seat limits, recording note).
   */
  subtext: string | null;
  /**
   * ISO-8601 datetime. Modal hidden until this instant (inclusive).
   */
  startTime: string;
  /**
   * ISO-8601 datetime. Modal hidden after this instant.
   */
  expiryTime: string;
  isLive: boolean;
  senderName: string;
  /**
   * Absolute web path to the sender avatar image.
   */
  senderAvatarSrc: string;
  /**
   * Absolute web path to the per-webinar hero image under `public/include/images/webinar-announcements/<id>/`.
   */
  heroImageSrc: string;
  /**
   * Human-readable schedule line shown next to the calendar icon (e.g. "Wednesday, July 22nd 2026 @ 3:00 PM EDT").
   */
  eventSchedule: string;
}

export interface GetWebinarAnnouncement {
  /**
   * Fetch a single webinar announcement by id, bypassing dismissal/expiry gates. Admin preview surface — admin-only.
   */
  webinarAnnouncement: GetWebinarAnnouncement_webinarAnnouncement | null;
}

export interface GetWebinarAnnouncementVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLeadContext
// ====================================================

export interface GetLeadContext_lead_outcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_lead_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_lead_accounts_primaryEdge_node_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
}

export interface GetLeadContext_lead_accounts_primaryEdge_node_postalAddresses_primary {
  __typename: "PostalAddress";
  value: GetLeadContext_lead_accounts_primaryEdge_node_postalAddresses_primary_value;
}

export interface GetLeadContext_lead_accounts_primaryEdge_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetLeadContext_lead_accounts_primaryEdge_node_postalAddresses_primary | null;
}

export interface GetLeadContext_lead_accounts_primaryEdge_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetLeadContext_lead_accounts_primaryEdge_node_phones_primary {
  __typename: "Phone";
  value: GetLeadContext_lead_accounts_primaryEdge_node_phones_primary_value;
}

export interface GetLeadContext_lead_accounts_primaryEdge_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetLeadContext_lead_accounts_primaryEdge_node_phones_primary | null;
}

export interface GetLeadContext_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetLeadContext_lead_accounts_primaryEdge_node_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetLeadContext_lead_accounts_primaryEdge_node_phones;
}

export interface GetLeadContext_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetLeadContext_lead_accounts_primaryEdge_node;
}

export interface GetLeadContext_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetLeadContext_lead_accounts_primaryEdge | null;
}

export interface GetLeadContext_lead_contacts_primaryEdge_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetLeadContext_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetLeadContext_lead_contacts_primaryEdge_node_emailAddresses_primary_value;
}

export interface GetLeadContext_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetLeadContext_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface GetLeadContext_lead_contacts_primaryEdge_node_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
}

export interface GetLeadContext_lead_contacts_primaryEdge_node_postalAddresses_primary {
  __typename: "PostalAddress";
  value: GetLeadContext_lead_contacts_primaryEdge_node_postalAddresses_primary_value;
}

export interface GetLeadContext_lead_contacts_primaryEdge_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetLeadContext_lead_contacts_primaryEdge_node_postalAddresses_primary | null;
}

export interface GetLeadContext_lead_contacts_primaryEdge_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetLeadContext_lead_contacts_primaryEdge_node_phones_primary {
  __typename: "Phone";
  value: GetLeadContext_lead_contacts_primaryEdge_node_phones_primary_value;
}

export interface GetLeadContext_lead_contacts_primaryEdge_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetLeadContext_lead_contacts_primaryEdge_node_phones_primary | null;
}

export interface GetLeadContext_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetLeadContext_lead_contacts_primaryEdge_node_emailAddresses;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetLeadContext_lead_contacts_primaryEdge_node_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetLeadContext_lead_contacts_primaryEdge_node_phones;
}

export interface GetLeadContext_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetLeadContext_lead_contacts_primaryEdge_node;
}

export interface GetLeadContext_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetLeadContext_lead_contacts_primaryEdge | null;
}

export interface GetLeadContext_lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The total integer amount of the monetary value in cents.
   */
  amountInCents: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
}

export interface GetLeadContext_lead_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetLeadContext_lead_stages_edges_timeInStage {
  __typename: "FormattedValueDuration";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetLeadContext_lead_stages_edges_goalConditions_condition {
  __typename: "Condition";
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface GetLeadContext_lead_stages_edges_goalConditions {
  __typename: "LeadGoalCondition";
  /**
   * The lead agnostic condition object.
   */
  condition: GetLeadContext_lead_stages_edges_goalConditions_condition;
  /**
   * Is this the current stage of the lead?
   */
  status: ConditionStatus;
}

export interface GetLeadContext_lead_stages_edges_emailAutomationStatuses {
  __typename: "EmailAutomationStatus";
  /**
   * Can this status be started
   */
  canStart: boolean;
}

export interface GetLeadContext_lead_stages_edges_unfiredEmailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface GetLeadContext_lead_stages_edges_unfiredEmailAutomations {
  __typename: "EmailAutomation";
  /**
   * The email list associated with this stage subscription.
   */
  emailList: GetLeadContext_lead_stages_edges_unfiredEmailAutomations_emailList | null;
}

export interface GetLeadContext_lead_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetLeadContext_lead_stages_edges {
  __typename: "LeadStagesEdge";
  /**
   * How long did the lead spend in this stage?
   */
  timeInStage: GetLeadContext_lead_stages_edges_timeInStage | null;
  /**
   * List of this lead goal’s conditions associated with the given stage
   */
  goalConditions: GetLeadContext_lead_stages_edges_goalConditions[];
  /**
   * List of active stage subscription statuses for this lead
   */
  emailAutomationStatuses: GetLeadContext_lead_stages_edges_emailAutomationStatuses[];
  /**
   * List of this stage’s unfired email automations (automations without a status yet, because they’re in a future stage)
   */
  unfiredEmailAutomations: GetLeadContext_lead_stages_edges_unfiredEmailAutomations[];
  node: GetLeadContext_lead_stages_edges_node;
}

export interface GetLeadContext_lead_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: GetLeadContext_lead_stages_current | null;
  /**
   * A list of edges.
   */
  edges: GetLeadContext_lead_stages_edges[];
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetLeadContext_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetLeadContext_lead_channels_edges_node {
  __typename: "Channel";
  /**
   * The title of the channel
   */
  title: string;
}

export interface GetLeadContext_lead_channels_edges_sources {
  __typename: "Source";
  /**
   * The name of the source
   */
  name: string;
}

export interface GetLeadContext_lead_channels_edges {
  __typename: "LeadChannelsEdge";
  node: GetLeadContext_lead_channels_edges_node;
  /**
   * Sources related to this LeadChannel
   */
  sources: GetLeadContext_lead_channels_edges_sources[];
}

export interface GetLeadContext_lead_channels {
  __typename: "LeadChannelsConnection";
  /**
   * A list of edges.
   */
  edges: GetLeadContext_lead_channels_edges[];
}

export interface GetLeadContext_lead_mergedWith {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
}

export interface GetLeadContext_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetLeadContext_lead_sources_edges_node_channel {
  __typename: "Channel";
  /**
   * The title of the channel
   */
  title: string;
}

export interface GetLeadContext_lead_sources_edges_node {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The channel associated with the source
   */
  channel: GetLeadContext_lead_sources_edges_node_channel | null;
}

export interface GetLeadContext_lead_sources_edges {
  __typename: "SourcesEdge";
  node: GetLeadContext_lead_sources_edges_node;
}

export interface GetLeadContext_lead_sources {
  __typename: "SourcesConnection";
  /**
   * A list of edges.
   */
  edges: GetLeadContext_lead_sources_edges[];
}

export interface GetLeadContext_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The outcome for this lead, if there is one.
   */
  outcome: GetLeadContext_lead_outcome | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetLeadContext_lead_assignee | null;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetLeadContext_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetLeadContext_lead_contacts;
  /**
   * The anticipated close time for the lead.
   */
  anticipatedClosedTime: any | null;
  value: GetLeadContext_lead_value | null;
  /**
   * The due time for the lead.
   */
  dueTime: any | null;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * The deleted time for the lead if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The percentage confidence of lead success.
   */
  confidence: number;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Stages for the lead
   */
  stages: GetLeadContext_lead_stages;
  /**
   * The list of tags on this lead
   */
  tags: GetLeadContext_lead_tags[];
  /**
   * List of channels associated with this lead
   */
  channels: GetLeadContext_lead_channels | null;
  /**
   * Entity this lead was merged with
   */
  mergedWith: GetLeadContext_lead_mergedWith | null;
  /**
   * Stageset associated with the given lead
   */
  stageset: GetLeadContext_lead_stageset | null;
  /**
   * Sources for the lead (simple tag-like objects that note _where_ this lead came from, e.g., a specific advertising campaign
   */
  sources: GetLeadContext_lead_sources | null;
}

export interface GetLeadContext_timeline_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
}

export interface GetLeadContext_timeline_edges_node_actor_Form {
  __typename: "Form" | "MaUrl";
}

export interface GetLeadContext_timeline_edges_node_actor_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_actor_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_actor_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_actor_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export type GetLeadContext_timeline_edges_node_actor = GetLeadContext_timeline_edges_node_actor_Form | GetLeadContext_timeline_edges_node_actor_User | GetLeadContext_timeline_edges_node_actor_Origin | GetLeadContext_timeline_edges_node_actor_Contact | GetLeadContext_timeline_edges_node_actor_Account;

export interface GetLeadContext_timeline_edges_node_payload_TimelineEventPayloadUnknownType {
  __typename: "TimelineEventPayloadUnknownType" | "Contract" | "AccountContactFormerStatusChange";
}

export interface GetLeadContext_timeline_edges_node_payload_Activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetLeadContext_timeline_edges_node_payload_Activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GetLeadContext_timeline_edges_node_payload_Activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: GetLeadContext_timeline_edges_node_payload_Activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: GetLeadContext_timeline_edges_node_payload_Activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface GetLeadContext_timeline_edges_node_payload_Activity_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GetLeadContext_timeline_edges_node_payload_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetLeadContext_timeline_edges_node_payload_Activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetLeadContext_timeline_edges_node_payload_Activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetLeadContext_timeline_edges_node_payload_Activity_participants[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: GetLeadContext_timeline_edges_node_payload_Activity_externalMeeting | null;
  /**
   * The summary of the activity.
   */
  transcriptionSummary: GetLeadContext_timeline_edges_node_payload_Activity_transcriptionSummary | null;
}

export interface GetLeadContext_timeline_edges_node_payload_AccountRelationshipChange_entityAdded {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_AccountRelationshipChange {
  __typename: "AccountRelationshipChange";
  /**
   * The child account in the relationship
   */
  entityAdded: GetLeadContext_timeline_edges_node_payload_AccountRelationshipChange_entityAdded;
  /**
   * The action that was taken to create this relationship
   */
  action: AccountRelationshipChangeAction;
}

export interface GetLeadContext_timeline_edges_node_payload_Note_entity_Thread {
  __typename: "Thread" | "NoteEntityUnknownType";
}

export interface GetLeadContext_timeline_edges_node_payload_Note_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Note_entity_Activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Note_entity_Activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetLeadContext_timeline_edges_node_payload_Note_entity_Activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Note_entity_Activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface GetLeadContext_timeline_edges_node_payload_Note_entity_Activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Note_entity_Activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: GetLeadContext_timeline_edges_node_payload_Note_entity_Activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: GetLeadContext_timeline_edges_node_payload_Note_entity_Activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface GetLeadContext_timeline_edges_node_payload_Note_entity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetLeadContext_timeline_edges_node_payload_Note_entity_Activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetLeadContext_timeline_edges_node_payload_Note_entity_Activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetLeadContext_timeline_edges_node_payload_Note_entity_Activity_participants[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: GetLeadContext_timeline_edges_node_payload_Note_entity_Activity_externalMeeting | null;
}

export interface GetLeadContext_timeline_edges_node_payload_Note_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Note_entity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Note_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: GetLeadContext_timeline_edges_node_payload_Note_entity_Lead_value | null;
}

export type GetLeadContext_timeline_edges_node_payload_Note_entity = GetLeadContext_timeline_edges_node_payload_Note_entity_Thread | GetLeadContext_timeline_edges_node_payload_Note_entity_Account | GetLeadContext_timeline_edges_node_payload_Note_entity_Activity | GetLeadContext_timeline_edges_node_payload_Note_entity_Contact | GetLeadContext_timeline_edges_node_payload_Note_entity_Lead;

export interface GetLeadContext_timeline_edges_node_payload_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
  /**
   * Whether note has been deleted
   */
  isDeleted: boolean;
  /**
   * The entity on which this note was written
   */
  entity: GetLeadContext_timeline_edges_node_payload_Note_entity | null;
}

export interface GetLeadContext_timeline_edges_node_payload_Email_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Email_recipients_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Email_recipients {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetLeadContext_timeline_edges_node_payload_Email_recipients_avatarEntity | null;
}

export interface GetLeadContext_timeline_edges_node_payload_Email_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Email_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetLeadContext_timeline_edges_node_payload_Email_from_avatarEntity | null;
}

export interface GetLeadContext_timeline_edges_node_payload_Email_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The excerpt of this email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  /**
   * A partially-formatted version of the body of this email,for use in the expanded view in a list
   */
  emailBodyHtml: string;
  /**
   * How this email was added to Nutshell
   */
  originatedVia: string | null;
  attachments: GetLeadContext_timeline_edges_node_payload_Email_attachments[];
  /**
   * True if the email is shared with other Nutshell users
   */
  isShared: boolean;
  /**
   * True if the email can be shared with other Nutshell users
   */
  isShareable: boolean;
  /**
   * Was this email a reply sent by Nutshell automatically.
   */
  isAutomatedReply: boolean;
  /**
   * Was this email sent by Nutshell automatically.
   */
  isEmailAutomation: boolean;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
  /**
   * If this is a ticket message from Zendesk, this is the id
   */
  ticketId: string | null;
  /**
   * If this is a ticket message from Zendesk, this is the url
   */
  ticketUrl: string | null;
  /**
   * Number of times this email has been viewed via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedViewsCount: number | null;
  /**
   * Number of times this email has been clicked via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedClicksCount: number | null;
  recipients: GetLeadContext_timeline_edges_node_payload_Email_recipients[];
  from: GetLeadContext_timeline_edges_node_payload_Email_from;
  /**
   * Was the email created outside of Nutshell
   */
  isInbound: boolean;
  /**
   * Was the email created in Nutshell
   */
  isOutbound: boolean;
  /**
   * Did the email fail to send
   */
  isFailed: boolean;
  /**
   * True if a Nutshell user can reply to this email
   */
  isReplyable: boolean;
  /**
   * Is this a Nutshell Marketing email
   */
  isNutshellMarketingEmail: boolean;
  /**
   * If this a Nutshell Marketing email, this is the edition
   */
  edition: GetLeadContext_timeline_edges_node_payload_Email_edition | null;
  /**
   * Was this email sent within the last week
   */
  sentWithinLastWeek: boolean;
  /**
   * Has this email accepted an AI reply suggestion
   */
  hasAcceptedSuggestion: boolean;
}

export interface GetLeadContext_timeline_edges_node_payload_EmailQueued_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface GetLeadContext_timeline_edges_node_payload_EmailQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_EmailQueued_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetLeadContext_timeline_edges_node_payload_EmailQueued_to_avatarEntity | null;
}

export interface GetLeadContext_timeline_edges_node_payload_EmailQueued_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_EmailQueued_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: GetLeadContext_timeline_edges_node_payload_EmailQueued_from_avatarEntity | null;
}

export interface GetLeadContext_timeline_edges_node_payload_EmailQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * The excerpt of this queued email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  attachments: GetLeadContext_timeline_edges_node_payload_EmailQueued_attachments[];
  to: GetLeadContext_timeline_edges_node_payload_EmailQueued_to[];
  /**
   * The sender email address for this queued email.
   */
  from: GetLeadContext_timeline_edges_node_payload_EmailQueued_from;
  /**
   * True if this queued email is postponed and the user can retry it.
   */
  canRetry: boolean;
  /**
   * True if this is an email that looks failed to the user
   */
  isFailed: boolean;
}

export interface GetLeadContext_timeline_edges_node_payload_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
  formatted: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  isPrimary: boolean;
  value: GetLeadContext_timeline_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface GetLeadContext_timeline_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetLeadContext_timeline_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface GetLeadContext_timeline_edges_node_payload_Submission_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetLeadContext_timeline_edges_node_payload_Submission_booking_additionalAttendees_emailAddresses;
}

export interface GetLeadContext_timeline_edges_node_payload_Submission_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (GetLeadContext_timeline_edges_node_payload_Submission_booking_additionalAttendees | null)[];
}

export interface GetLeadContext_timeline_edges_node_payload_Submission_primaryEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Submission_primaryEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Submission_primaryEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Submission_primaryEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: GetLeadContext_timeline_edges_node_payload_Submission_primaryEntity_Lead_value | null;
}

export type GetLeadContext_timeline_edges_node_payload_Submission_primaryEntity = GetLeadContext_timeline_edges_node_payload_Submission_primaryEntity_Account | GetLeadContext_timeline_edges_node_payload_Submission_primaryEntity_Contact | GetLeadContext_timeline_edges_node_payload_Submission_primaryEntity_Lead;

export interface GetLeadContext_timeline_edges_node_payload_Submission_formVersion_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Submission_formVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent form of this form version
   */
  form: GetLeadContext_timeline_edges_node_payload_Submission_formVersion_form;
}

export interface GetLeadContext_timeline_edges_node_payload_Submission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface GetLeadContext_timeline_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: GetLeadContext_timeline_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export interface GetLeadContext_timeline_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface GetLeadContext_timeline_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export type GetLeadContext_timeline_edges_node_payload_Submission_fields_edges_fieldValue = GetLeadContext_timeline_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields | GetLeadContext_timeline_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | GetLeadContext_timeline_edges_node_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle;

export interface GetLeadContext_timeline_edges_node_payload_Submission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: GetLeadContext_timeline_edges_node_payload_Submission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: GetLeadContext_timeline_edges_node_payload_Submission_fields_edges_fieldValue | null;
}

export interface GetLeadContext_timeline_edges_node_payload_Submission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: GetLeadContext_timeline_edges_node_payload_Submission_fields_edges[];
}

export interface GetLeadContext_timeline_edges_node_payload_Submission {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The booking associated with this submission (if Scheduler)
   */
  booking: GetLeadContext_timeline_edges_node_payload_Submission_booking | null;
  /**
   * The primary entity on the submission
   */
  primaryEntity: GetLeadContext_timeline_edges_node_payload_Submission_primaryEntity | null;
  /**
   * The name of the submitted web form
   */
  formVersion: GetLeadContext_timeline_edges_node_payload_Submission_formVersion;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: GetLeadContext_timeline_edges_node_payload_Submission_fields;
}

export interface GetLeadContext_timeline_edges_node_payload_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: GetLeadContext_timeline_edges_node_payload_Lead_value | null;
}

export interface GetLeadContext_timeline_edges_node_payload_Chat_chatItems {
  __typename: "ChatItem";
  /**
   * Time this message was sent
   */
  timestamp: any;
  /**
   * The attrbute chatItemd by the entry
   */
  body: string;
  /**
   * Person writing this particular message
   */
  chatter: string;
  /**
   * Type of chat message
   */
  type: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Chat_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Chat_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface GetLeadContext_timeline_edges_node_payload_Chat_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * Not really sure tbh
   */
  chatItems: GetLeadContext_timeline_edges_node_payload_Chat_chatItems[];
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: GetLeadContext_timeline_edges_node_payload_Chat_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetLeadContext_timeline_edges_node_payload_Chat_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetLeadContext_timeline_edges_node_payload_Chat_participants[];
}

export interface GetLeadContext_timeline_edges_node_payload_Assignment_assignmentEntity_Thread {
  __typename: "Thread";
}

export interface GetLeadContext_timeline_edges_node_payload_Assignment_assignmentEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Assignment_assignmentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Assignment_assignmentEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Assignment_assignmentEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Assignment_assignmentEntity_UnknownEntityType {
  __typename: "UnknownEntityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type GetLeadContext_timeline_edges_node_payload_Assignment_assignmentEntity = GetLeadContext_timeline_edges_node_payload_Assignment_assignmentEntity_Thread | GetLeadContext_timeline_edges_node_payload_Assignment_assignmentEntity_Account | GetLeadContext_timeline_edges_node_payload_Assignment_assignmentEntity_Activity | GetLeadContext_timeline_edges_node_payload_Assignment_assignmentEntity_Contact | GetLeadContext_timeline_edges_node_payload_Assignment_assignmentEntity_Lead | GetLeadContext_timeline_edges_node_payload_Assignment_assignmentEntity_UnknownEntityType;

export interface GetLeadContext_timeline_edges_node_payload_Assignment_assigneeEntity {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Assignment {
  __typename: "Assignment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity that was assigned
   */
  assignmentEntity: GetLeadContext_timeline_edges_node_payload_Assignment_assignmentEntity;
  /**
   * The entity to which the assignment was made
   */
  assigneeEntity: GetLeadContext_timeline_edges_node_payload_Assignment_assigneeEntity;
}

export interface GetLeadContext_timeline_edges_node_payload_EmailInteraction_emailDelivery_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_EmailInteraction_emailDelivery_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_EmailInteraction_emailDelivery_email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
}

export interface GetLeadContext_timeline_edges_node_payload_EmailInteraction_emailDelivery {
  __typename: "EmailDelivery";
  primaryContact: GetLeadContext_timeline_edges_node_payload_EmailInteraction_emailDelivery_primaryContact | null;
  edition: GetLeadContext_timeline_edges_node_payload_EmailInteraction_emailDelivery_edition | null;
  email: GetLeadContext_timeline_edges_node_payload_EmailInteraction_emailDelivery_email | null;
}

export interface GetLeadContext_timeline_edges_node_payload_EmailInteraction {
  __typename: "EmailInteraction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: EmailInteractionType;
  link: string | null;
  emailDelivery: GetLeadContext_timeline_edges_node_payload_EmailInteraction_emailDelivery | null;
}

export interface GetLeadContext_timeline_edges_node_payload_ConstantContactContactTrackingActivity_ctctContact_contacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_ConstantContactContactTrackingActivity_ctctContact {
  __typename: "ConstantContactContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailAddress: string;
  /**
   * The Nutshell contacts associated with this CTCT contact
   */
  contacts: GetLeadContext_timeline_edges_node_payload_ConstantContactContactTrackingActivity_ctctContact_contacts[];
}

export interface GetLeadContext_timeline_edges_node_payload_ConstantContactContactTrackingActivity {
  __typename: "ConstantContactContactTrackingActivity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  campaignName: string | null;
  trackingActivityType: ConstantContactContactTrackingActivityType;
  emailSubject: string | null;
  ctctContact: GetLeadContext_timeline_edges_node_payload_ConstantContactContactTrackingActivity_ctctContact;
}

export interface GetLeadContext_timeline_edges_node_payload_EntityAttributeValueFile_eavEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_EntityAttributeValueFile_eavEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_EntityAttributeValueFile_eavEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetLeadContext_timeline_edges_node_payload_EntityAttributeValueFile_eavEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: GetLeadContext_timeline_edges_node_payload_EntityAttributeValueFile_eavEntity_Lead_value | null;
}

export type GetLeadContext_timeline_edges_node_payload_EntityAttributeValueFile_eavEntity = GetLeadContext_timeline_edges_node_payload_EntityAttributeValueFile_eavEntity_Account | GetLeadContext_timeline_edges_node_payload_EntityAttributeValueFile_eavEntity_Contact | GetLeadContext_timeline_edges_node_payload_EntityAttributeValueFile_eavEntity_Lead;

export interface GetLeadContext_timeline_edges_node_payload_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The entity that this file is associated with
   */
  eavEntity: GetLeadContext_timeline_edges_node_payload_EntityAttributeValueFile_eavEntity;
}

export interface GetLeadContext_timeline_edges_node_payload_Comment_parentEntity_Note_entity_Activity {
  __typename: "Activity" | "Thread" | "NoteEntityUnknownType";
}

export interface GetLeadContext_timeline_edges_node_payload_Comment_parentEntity_Note_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Comment_parentEntity_Note_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Comment_parentEntity_Note_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
}

export type GetLeadContext_timeline_edges_node_payload_Comment_parentEntity_Note_entity = GetLeadContext_timeline_edges_node_payload_Comment_parentEntity_Note_entity_Activity | GetLeadContext_timeline_edges_node_payload_Comment_parentEntity_Note_entity_Contact | GetLeadContext_timeline_edges_node_payload_Comment_parentEntity_Note_entity_Account | GetLeadContext_timeline_edges_node_payload_Comment_parentEntity_Note_entity_Lead;

export interface GetLeadContext_timeline_edges_node_payload_Comment_parentEntity_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity on which this note was written
   */
  entity: GetLeadContext_timeline_edges_node_payload_Comment_parentEntity_Note_entity | null;
}

export interface GetLeadContext_timeline_edges_node_payload_Comment_parentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Comment_parentEntity_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
}

export type GetLeadContext_timeline_edges_node_payload_Comment_parentEntity = GetLeadContext_timeline_edges_node_payload_Comment_parentEntity_Note | GetLeadContext_timeline_edges_node_payload_Comment_parentEntity_Activity | GetLeadContext_timeline_edges_node_payload_Comment_parentEntity_Email;

export interface GetLeadContext_timeline_edges_node_payload_Comment {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  commentId: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Deleted time for comment, null if not deleted
   */
  deletedTime: any | null;
  /**
   * The entity on which this note was written
   */
  parentEntity: GetLeadContext_timeline_edges_node_payload_Comment_parentEntity | null;
}

export interface GetLeadContext_timeline_edges_node_payload_Session_url {
  __typename: "Url";
  /**
   * The full URL, i.e. https:             // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The `www.nutshell.com` part of https: // www.nutshell.com/features?utm_source=Google
   */
  host: string | null;
}

export interface GetLeadContext_timeline_edges_node_payload_Session_browser {
  __typename: "Browser";
  /**
   * The platform for the visit
   */
  platform: string;
  /**
   * The device type for the visit
   */
  deviceType: DeviceType;
}

export interface GetLeadContext_timeline_edges_node_payload_Session_source {
  __typename: "McfxVisitSource";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The utm_medium value for this particular visit
   */
  medium: string;
  /**
   * The utm_source value for this particular visit
   */
  source: string;
  /**
   * Then mROI channel derived from this source information
   */
  channel: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Session_contact_nutshellContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Session_contact {
  __typename: "McfxContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The contact that made this form submission.
   */
  nutshellContact: GetLeadContext_timeline_edges_node_payload_Session_contact_nutshellContact | null;
}

export interface GetLeadContext_timeline_edges_node_payload_Session_visits_edges_node_url {
  __typename: "Url";
  /**
   * The `/features` part of https: // www.nutshell.com/features?utm_source=Google
   */
  path: string | null;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
  /**
   * The full URL, i.e. https:      // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Session_visits_edges_node {
  __typename: "Visit";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * How long the specific page visit lasted.
   */
  durationSeconds: number;
  /**
   * The page url for this user visit.
   */
  url: GetLeadContext_timeline_edges_node_payload_Session_visits_edges_node_url;
}

export interface GetLeadContext_timeline_edges_node_payload_Session_visits_edges {
  __typename: "SessionVisitsEdge";
  node: GetLeadContext_timeline_edges_node_payload_Session_visits_edges_node;
}

export interface GetLeadContext_timeline_edges_node_payload_Session_visits {
  __typename: "SessionVisitsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The total amount of time the visits lasted.
   */
  totalDuration: number | null;
  /**
   * A list of edges.
   */
  edges: GetLeadContext_timeline_edges_node_payload_Session_visits_edges[];
}

export interface GetLeadContext_timeline_edges_node_payload_Session {
  __typename: "Session";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Some basic info on the location of the user represented as a string.
   */
  locationSummary: string | null;
  /**
   * The session url.
   */
  url: GetLeadContext_timeline_edges_node_payload_Session_url;
  /**
   * The platform the user was on during the session.
   */
  browser: GetLeadContext_timeline_edges_node_payload_Session_browser | null;
  source: GetLeadContext_timeline_edges_node_payload_Session_source;
  /**
   * The contact associated with this session.
   */
  contact: GetLeadContext_timeline_edges_node_payload_Session_contact | null;
  visits: GetLeadContext_timeline_edges_node_payload_Session_visits;
  /**
   * When this session started. This is the value we’ll display to the user
   */
  startTime: any;
}

export interface GetLeadContext_timeline_edges_node_payload_Thread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
}

export interface GetLeadContext_timeline_edges_node_payload_Thread_displayMessage_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Thread_displayMessage_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Thread_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The content of the message
   */
  content: string;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The user who created this thread
   */
  creatorUser: GetLeadContext_timeline_edges_node_payload_Thread_displayMessage_creatorUser | null;
  /**
   * The origin of the user who created this thread
   */
  creatorOrigin: GetLeadContext_timeline_edges_node_payload_Thread_displayMessage_creatorOrigin | null;
  /**
   * The images in the message
   */
  images: string[];
}

export interface GetLeadContext_timeline_edges_node_payload_Thread_messages {
  __typename: "ThreadMessagesConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface GetLeadContext_timeline_edges_node_payload_Thread_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Thread_bestEntity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external channel this thread is related to
   */
  externalChannel: GetLeadContext_timeline_edges_node_payload_Thread_externalChannel;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: GetLeadContext_timeline_edges_node_payload_Thread_displayMessage | null;
  /**
   * The messages associated with this thread
   */
  messages: GetLeadContext_timeline_edges_node_payload_Thread_messages;
  /**
   * the number of inbound messages on this thread
   */
  replyCount: number;
  /**
   * The user who created this thread
   */
  creatorUser: GetLeadContext_timeline_edges_node_payload_Thread_creatorUser | null;
  /**
   * The best entity associated with this thread
   */
  bestEntity: GetLeadContext_timeline_edges_node_payload_Thread_bestEntity | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
}

export interface GetLeadContext_timeline_edges_node_payload_Message_edition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Message_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: GetLeadContext_timeline_edges_node_payload_Message_edition_campaign;
}

export interface GetLeadContext_timeline_edges_node_payload_Message_thread_bestEntity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Message_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The best entity associated with this thread
   */
  bestEntity: GetLeadContext_timeline_edges_node_payload_Message_thread_bestEntity | null;
}

export interface GetLeadContext_timeline_edges_node_payload_Message {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The edition of the message
   */
  edition: GetLeadContext_timeline_edges_node_payload_Message_edition | null;
  /**
   * The thread this message is part of
   */
  thread: GetLeadContext_timeline_edges_node_payload_Message_thread;
}

export interface GetLeadContext_timeline_edges_node_payload_Quote_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Quote_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetLeadContext_timeline_edges_node_payload_Quote_lead_accounts_primaryEdge_node;
}

export interface GetLeadContext_timeline_edges_node_payload_Quote_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetLeadContext_timeline_edges_node_payload_Quote_lead_accounts_primaryEdge | null;
}

export interface GetLeadContext_timeline_edges_node_payload_Quote_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Quote_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetLeadContext_timeline_edges_node_payload_Quote_lead_contacts_primaryEdge_node;
}

export interface GetLeadContext_timeline_edges_node_payload_Quote_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetLeadContext_timeline_edges_node_payload_Quote_lead_contacts_primaryEdge | null;
}

export interface GetLeadContext_timeline_edges_node_payload_Quote_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetLeadContext_timeline_edges_node_payload_Quote_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetLeadContext_timeline_edges_node_payload_Quote_lead_contacts;
}

export interface GetLeadContext_timeline_edges_node_payload_Quote_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The lead the quote is associated with
   */
  lead: GetLeadContext_timeline_edges_node_payload_Quote_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetLeadContext_timeline_edges_node_payload_Quote_total;
  /**
   * The user that created the quote
   */
  creatorUser: GetLeadContext_timeline_edges_node_payload_Quote_creatorUser | null;
}

export interface GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge_node;
}

export interface GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge | null;
}

export interface GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge_node;
}

export interface GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge | null;
}

export interface GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Quote_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Quote_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Quote_lead_contacts;
}

export interface GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Quote_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The lead the quote is associated with
   */
  lead: GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Quote_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Quote_total;
  /**
   * The user that created the quote
   */
  creatorUser: GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Quote_creatorUser | null;
}

export interface GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge_node;
}

export interface GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge | null;
}

export interface GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge_node;
}

export interface GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge | null;
}

export interface GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Invoice_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Invoice_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Invoice_lead_contacts;
}

export interface GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Invoice_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The lead the quote is associated with
   */
  lead: GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Invoice_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Invoice_total;
  /**
   * The user that created the quote
   */
  creatorUser: GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Invoice_creatorUser | null;
}

export type GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument = GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Quote | GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument_Invoice;

export interface GetLeadContext_timeline_edges_node_payload_DocumentView {
  __typename: "DocumentView";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The quote or invoice this view is attached to, when applicable
   */
  salesDocument: GetLeadContext_timeline_edges_node_payload_DocumentView_salesDocument | null;
}

export interface GetLeadContext_timeline_edges_node_payload_Invoice_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Invoice_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetLeadContext_timeline_edges_node_payload_Invoice_lead_accounts_primaryEdge_node;
}

export interface GetLeadContext_timeline_edges_node_payload_Invoice_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetLeadContext_timeline_edges_node_payload_Invoice_lead_accounts_primaryEdge | null;
}

export interface GetLeadContext_timeline_edges_node_payload_Invoice_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Invoice_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetLeadContext_timeline_edges_node_payload_Invoice_lead_contacts_primaryEdge_node;
}

export interface GetLeadContext_timeline_edges_node_payload_Invoice_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetLeadContext_timeline_edges_node_payload_Invoice_lead_contacts_primaryEdge | null;
}

export interface GetLeadContext_timeline_edges_node_payload_Invoice_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetLeadContext_timeline_edges_node_payload_Invoice_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetLeadContext_timeline_edges_node_payload_Invoice_lead_contacts;
}

export interface GetLeadContext_timeline_edges_node_payload_Invoice_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_payload_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The lead the quote is associated with
   */
  lead: GetLeadContext_timeline_edges_node_payload_Invoice_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: GetLeadContext_timeline_edges_node_payload_Invoice_total;
  /**
   * The user that created the quote
   */
  creatorUser: GetLeadContext_timeline_edges_node_payload_Invoice_creatorUser | null;
}

export interface GetLeadContext_timeline_edges_node_payload_LeadClonePayload_original_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetLeadContext_timeline_edges_node_payload_LeadClonePayload_original {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: GetLeadContext_timeline_edges_node_payload_LeadClonePayload_original_value | null;
}

export interface GetLeadContext_timeline_edges_node_payload_LeadClonePayload_clone_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetLeadContext_timeline_edges_node_payload_LeadClonePayload_clone {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: GetLeadContext_timeline_edges_node_payload_LeadClonePayload_clone_value | null;
}

export interface GetLeadContext_timeline_edges_node_payload_LeadClonePayload {
  __typename: "LeadClonePayload";
  /**
   * The original lead
   */
  original: GetLeadContext_timeline_edges_node_payload_LeadClonePayload_original;
  /**
   * The cloned lead
   */
  clone: GetLeadContext_timeline_edges_node_payload_LeadClonePayload_clone;
}

export type GetLeadContext_timeline_edges_node_payload = GetLeadContext_timeline_edges_node_payload_TimelineEventPayloadUnknownType | GetLeadContext_timeline_edges_node_payload_Activity | GetLeadContext_timeline_edges_node_payload_AccountRelationshipChange | GetLeadContext_timeline_edges_node_payload_Note | GetLeadContext_timeline_edges_node_payload_Email | GetLeadContext_timeline_edges_node_payload_EmailQueued | GetLeadContext_timeline_edges_node_payload_Origin | GetLeadContext_timeline_edges_node_payload_Submission | GetLeadContext_timeline_edges_node_payload_Account | GetLeadContext_timeline_edges_node_payload_Contact | GetLeadContext_timeline_edges_node_payload_Lead | GetLeadContext_timeline_edges_node_payload_Chat | GetLeadContext_timeline_edges_node_payload_Assignment | GetLeadContext_timeline_edges_node_payload_EmailInteraction | GetLeadContext_timeline_edges_node_payload_ConstantContactContactTrackingActivity | GetLeadContext_timeline_edges_node_payload_EntityAttributeValueFile | GetLeadContext_timeline_edges_node_payload_Comment | GetLeadContext_timeline_edges_node_payload_Session | GetLeadContext_timeline_edges_node_payload_Thread | GetLeadContext_timeline_edges_node_payload_Message | GetLeadContext_timeline_edges_node_payload_Quote | GetLeadContext_timeline_edges_node_payload_DocumentView | GetLeadContext_timeline_edges_node_payload_Invoice | GetLeadContext_timeline_edges_node_payload_LeadClonePayload;

export interface GetLeadContext_timeline_edges_node_changes {
  __typename: "ChangeLogChange";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attrbute changed by the entry
   */
  attribute: string;
  /**
   * The old value before the change
   */
  oldValue: string | null;
  /**
   * The new value after the change
   */
  newValue: string | null;
}

export interface GetLeadContext_timeline_edges_node_files_eavEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_files_eavEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetLeadContext_timeline_edges_node_files_eavEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface GetLeadContext_timeline_edges_node_files_eavEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: GetLeadContext_timeline_edges_node_files_eavEntity_Lead_value | null;
}

export type GetLeadContext_timeline_edges_node_files_eavEntity = GetLeadContext_timeline_edges_node_files_eavEntity_Account | GetLeadContext_timeline_edges_node_files_eavEntity_Contact | GetLeadContext_timeline_edges_node_files_eavEntity_Lead;

export interface GetLeadContext_timeline_edges_node_files {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The entity that this file is associated with
   */
  eavEntity: GetLeadContext_timeline_edges_node_files_eavEntity;
}

export interface GetLeadContext_timeline_edges_node_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: GetLeadContext_timeline_edges_node_reactions_creatorUser;
}

export interface GetLeadContext_timeline_edges_node_comments_changeLogEntry {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetLeadContext_timeline_edges_node_comments_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_comments_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: GetLeadContext_timeline_edges_node_comments_reactions_creatorUser;
}

export interface GetLeadContext_timeline_edges_node_comments_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_node_comments {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Change log associated with the comment
   */
  changeLogEntry: GetLeadContext_timeline_edges_node_comments_changeLogEntry | null;
  /**
   * User reactions left for the comment change log entry
   */
  reactions: GetLeadContext_timeline_edges_node_comments_reactions[];
  /**
   * The user who created the comment.
   */
  creatorUser: GetLeadContext_timeline_edges_node_comments_creatorUser;
  /**
   * The created time for the comment.
   */
  createdTime: any;
}

export interface GetLeadContext_timeline_edges_node {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of change i.e. created, modified, deleted, etc
   */
  changeType: ChangeType;
  /**
   * The entity that triggered the change_log entry
   */
  actor: GetLeadContext_timeline_edges_node_actor;
  payload: GetLeadContext_timeline_edges_node_payload;
  changeTime: any;
  changes: GetLeadContext_timeline_edges_node_changes[];
  /**
   * A one-off property to handle the case where multiple files can be associated
   * with a single change log entry. This is the only situation where multiple
   * payloads exist on an entry, so rather than adding additional complexity to our
   * entire system, we’ll treat it as a separate property
   */
  files: GetLeadContext_timeline_edges_node_files[];
  reactions: GetLeadContext_timeline_edges_node_reactions[];
  comments: GetLeadContext_timeline_edges_node_comments[];
  /**
   * When multiple of the same entry occurs in a row, we’ll roll-up the count. For
   * example, if someone views an email 3 times in a row before a different change,
   * this value will be 3.
   */
  count: number | null;
}

export interface GetLeadContext_timeline_edges_pinnedInfo_pinnedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadContext_timeline_edges_pinnedInfo {
  __typename: "PinnedInfo";
  pinnedTime: any | null;
  pinnedByUser: GetLeadContext_timeline_edges_pinnedInfo_pinnedByUser;
}

export interface GetLeadContext_timeline_edges {
  __typename: "TimelineEventsEdge";
  node: GetLeadContext_timeline_edges_node;
  pinnedInfo: GetLeadContext_timeline_edges_pinnedInfo | null;
}

export interface GetLeadContext_timeline {
  __typename: "TimelineEventsConnection";
  /**
   * Information to aid in pagination.
   */
  pageInfo: GetLeadContext_timeline_pageInfo;
  /**
   * A list of edges.
   */
  edges: GetLeadContext_timeline_edges[];
}

export interface GetLeadContext {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetLeadContext_lead | null;
  /**
   * Returns events to display in a Nutshell timeline
   */
  timeline: GetLeadContext_timeline;
}

export interface GetLeadContextVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPlanComparisons
// ====================================================

export interface GetPlanComparisons_planComparisons_planStubs {
  __typename: "PlanStub";
  /**
   * Internal plan key
   */
  key: string;
  /**
   * The user facing plan name
   */
  name: string;
  /**
   * The user facing plan name
   */
  price: number | null;
  /**
   * The user facing plan name
   */
  priceUnit: string;
}

export interface GetPlanComparisons_planComparisons_featureGroups_features_planAvailabilities_value {
  __typename: "AvailabilityValue";
  /**
   * The type of availability value
   */
  availabilityValueType: AvailabilityValueType;
  /**
   * The custom string value if applicable
   */
  customValue: string | null;
}

export interface GetPlanComparisons_planComparisons_featureGroups_features_planAvailabilities {
  __typename: "featureAvailability";
  /**
   * The CRM tier (EX: pro, enterprise, etc.)
   */
  crmTier: CrmPlanTier;
  /**
   * The availability value of the plan tier for a feature (EX: unlimited, 5 uses, etc.)
   */
  value: GetPlanComparisons_planComparisons_featureGroups_features_planAvailabilities_value;
}

export interface GetPlanComparisons_planComparisons_featureGroups_features {
  __typename: "Feature";
  /**
   * Feature name
   */
  name: string;
  /**
   * Tooltip text
   */
  tooltip: string | null;
  /**
   * What the availability this feature has for each plan (unlimited, 5 uses, etc.)
   */
  planAvailabilities: GetPlanComparisons_planComparisons_featureGroups_features_planAvailabilities[];
}

export interface GetPlanComparisons_planComparisons_featureGroups {
  __typename: "FeatureGroup";
  /**
   * Similar characteristic for the features (table title)
   */
  title: string;
  /**
   * Features made up of a title, optional tooltip, and the availbility of this feature for each plan (table rows)
   */
  features: GetPlanComparisons_planComparisons_featureGroups_features[];
}

export interface GetPlanComparisons_planComparisons {
  __typename: "PlanComparisons";
  /**
   * The plans to be displayed
   */
  planStubs: GetPlanComparisons_planComparisons_planStubs[];
  /**
   * feature groups of similar features
   */
  featureGroups: GetPlanComparisons_planComparisons_featureGroups[];
}

export interface GetPlanComparisons {
  /**
   * Data related to the plan comparison tables
   */
  planComparisons: GetPlanComparisons_planComparisons;
}

export interface GetPlanComparisonsVariables {
  suiteType: SuiteType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetAccountWebhook
// ====================================================

export interface GetAccountWebhook_account_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface GetAccountWebhook_account_industry {
  __typename: "NutshellIndustry";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human description of the industry
   */
  name: string | null;
}

export interface GetAccountWebhook_account_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface GetAccountWebhook_account_revenue_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
}

export interface GetAccountWebhook_account_revenue {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: GetAccountWebhook_account_revenue_currencyValue;
}

export interface GetAccountWebhook_account_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
}

export interface GetAccountWebhook_account_postalAddresses_primary {
  __typename: "PostalAddress";
  value: GetAccountWebhook_account_postalAddresses_primary_value;
}

export interface GetAccountWebhook_account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountWebhook_account_postalAddresses_primary | null;
}

export interface GetAccountWebhook_account_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string | null;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetAccountWebhook_account_phones_primary {
  __typename: "Phone";
  value: GetAccountWebhook_account_phones_primary_value;
}

export interface GetAccountWebhook_account_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountWebhook_account_phones_primary | null;
}

export interface GetAccountWebhook_account_urls_primary {
  __typename: "URL";
  value: string | null;
}

export interface GetAccountWebhook_account_urls {
  __typename: "UrlsConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountWebhook_account_urls_primary | null;
}

export interface GetAccountWebhook_account_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
}

export interface GetAccountWebhook_account_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetAccountWebhook_account_emailAddresses_primary_value;
}

export interface GetAccountWebhook_account_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetAccountWebhook_account_emailAddresses_primary | null;
}

export interface GetAccountWebhook_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetAccountWebhook_account_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetAccountWebhook_account_mergedWith {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetAccountWebhook_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The type assigned to this account
   */
  accountType: GetAccountWebhook_account_accountType;
  /**
   * The industry of this account
   */
  industry: GetAccountWebhook_account_industry | null;
  /**
   * The terrority to which this peep is assigned.
   */
  territory: GetAccountWebhook_account_territory | null;
  revenue: GetAccountWebhook_account_revenue | null;
  /**
   * The number of people employed by this company
   */
  employeeCount: string | null;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetAccountWebhook_account_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetAccountWebhook_account_phones;
  /**
   * The paging collection of URLs.
   */
  urls: GetAccountWebhook_account_urls;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetAccountWebhook_account_emailAddresses;
  /**
   * Tags associated with the given peep
   */
  tags: GetAccountWebhook_account_tags[];
  avatarUrl: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: GetAccountWebhook_account_owner | null;
  /**
   * Is this entity deleted
   */
  isDeleted: boolean;
  /**
   * Entity this account was merged with
   */
  mergedWith: GetAccountWebhook_account_mergedWith | null;
}

export interface GetAccountWebhook {
  /**
   * Returns a Nutshell Account
   */
  account: GetAccountWebhook_account | null;
}

export interface GetAccountWebhookVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetActivityWebhook
// ====================================================

export interface GetActivityWebhook_activity_logger {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetActivityWebhook_activity_participants_Account {
  __typename: "Account" | "User" | "Lead" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetActivityWebhook_activity_participants_Contact_mcfxContacts {
  __typename: "McfxContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external ID of the contact.
   */
  externalId: string;
}

export interface GetActivityWebhook_activity_participants_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The MCFX contact associated with this contact
   */
  mcfxContacts: GetActivityWebhook_activity_participants_Contact_mcfxContacts[];
}

export type GetActivityWebhook_activity_participants = GetActivityWebhook_activity_participants_Account | GetActivityWebhook_activity_participants_Contact;

export interface GetActivityWebhook_activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The plain text (i.e., no HTML/rich text, no NutMark for @-mention tokenizing) representation of the Note text
   */
  body: string | null;
}

export interface GetActivityWebhook_activity_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetActivityWebhook_activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface GetActivityWebhook_activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The participants of this meeting
   */
  participants: GetActivityWebhook_activity_externalMeeting_participants[];
}

export interface GetActivityWebhook_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The DateTime that represents the start time of the Activity record
   */
  startTime: any;
  /**
   * The DateTime that represents the end time of the Activity record
   */
  endTime: any;
  /**
   * The boolean that represents whether or not the Activity represents an all day calendar event
   */
  isAllDay: boolean;
  /**
   * The boolean that represents whether or not the Activity has been logged (with
   * our without a message) for the purposes of completion/quota.
   */
  isLogged: boolean;
  /**
   * The boolean that represents whether or not the Activity is overdue.
   * Specifically, this means that the activity is not logged, and is in the past.
   */
  isOverdue: boolean;
  /**
   * The Nutshell user that logged this activity (null when the activity is not in a logged state).
   */
  logger: GetActivityWebhook_activity_logger | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetActivityWebhook_activity_participants[];
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: GetActivityWebhook_activity_logNote | null;
  /**
   * Related leads for the activity.
   */
  relatedLeads: GetActivityWebhook_activity_relatedLeads[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: GetActivityWebhook_activity_externalMeeting | null;
}

export interface GetActivityWebhook {
  /**
   * Returns a Nutshell Activity
   */
  activity: GetActivityWebhook_activity | null;
}

export interface GetActivityWebhookVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetBookingWebhook
// ====================================================

export interface GetBookingWebhook_booking_activity_participants_Account {
  __typename: "Account" | "User" | "Lead" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetBookingWebhook_booking_activity_participants_Contact_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string | null;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetBookingWebhook_booking_activity_participants_Contact_phones_primary {
  __typename: "Phone";
  value: GetBookingWebhook_booking_activity_participants_Contact_phones_primary_value;
}

export interface GetBookingWebhook_booking_activity_participants_Contact_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetBookingWebhook_booking_activity_participants_Contact_phones_primary | null;
}

export interface GetBookingWebhook_booking_activity_participants_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetBookingWebhook_booking_activity_participants_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetBookingWebhook_booking_activity_participants_Contact_emailAddresses_primary_value;
}

export interface GetBookingWebhook_booking_activity_participants_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetBookingWebhook_booking_activity_participants_Contact_emailAddresses_primary | null;
}

export interface GetBookingWebhook_booking_activity_participants_Contact_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
}

export interface GetBookingWebhook_booking_activity_participants_Contact_postalAddresses_primary {
  __typename: "PostalAddress";
  value: GetBookingWebhook_booking_activity_participants_Contact_postalAddresses_primary_value;
}

export interface GetBookingWebhook_booking_activity_participants_Contact_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetBookingWebhook_booking_activity_participants_Contact_postalAddresses_primary | null;
}

export interface GetBookingWebhook_booking_activity_participants_Contact_mcfxContacts {
  __typename: "McfxContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external ID of the contact.
   */
  externalId: string;
}

export interface GetBookingWebhook_booking_activity_participants_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetBookingWebhook_booking_activity_participants_Contact_phones;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetBookingWebhook_booking_activity_participants_Contact_emailAddresses;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetBookingWebhook_booking_activity_participants_Contact_postalAddresses;
  /**
   * The MCFX contact associated with this contact
   */
  mcfxContacts: GetBookingWebhook_booking_activity_participants_Contact_mcfxContacts[];
}

export type GetBookingWebhook_booking_activity_participants = GetBookingWebhook_booking_activity_participants_Account | GetBookingWebhook_booking_activity_participants_Contact;

export interface GetBookingWebhook_booking_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DateTime that represents the start time of the Activity record
   */
  startTime: any;
  /**
   * The DateTime that represents the end time of the Activity record
   */
  endTime: any;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: GetBookingWebhook_booking_activity_participants[];
}

export interface GetBookingWebhook_booking_additionalAttendees_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string | null;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetBookingWebhook_booking_additionalAttendees_phones_primary {
  __typename: "Phone";
  value: GetBookingWebhook_booking_additionalAttendees_phones_primary_value;
}

export interface GetBookingWebhook_booking_additionalAttendees_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetBookingWebhook_booking_additionalAttendees_phones_primary | null;
}

export interface GetBookingWebhook_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetBookingWebhook_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetBookingWebhook_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface GetBookingWebhook_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetBookingWebhook_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface GetBookingWebhook_booking_additionalAttendees_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
}

export interface GetBookingWebhook_booking_additionalAttendees_postalAddresses_primary {
  __typename: "PostalAddress";
  value: GetBookingWebhook_booking_additionalAttendees_postalAddresses_primary_value;
}

export interface GetBookingWebhook_booking_additionalAttendees_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetBookingWebhook_booking_additionalAttendees_postalAddresses_primary | null;
}

export interface GetBookingWebhook_booking_additionalAttendees_mcfxContacts {
  __typename: "McfxContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external ID of the contact.
   */
  externalId: string;
}

export interface GetBookingWebhook_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetBookingWebhook_booking_additionalAttendees_phones;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetBookingWebhook_booking_additionalAttendees_emailAddresses;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetBookingWebhook_booking_additionalAttendees_postalAddresses;
  /**
   * The MCFX contact associated with this contact
   */
  mcfxContacts: GetBookingWebhook_booking_additionalAttendees_mcfxContacts[];
}

export interface GetBookingWebhook_booking_meeting_creator_emailAddresses {
  __typename: "UserEmail";
  /**
   * The address string of this email.
   */
  address: string;
}

export interface GetBookingWebhook_booking_meeting_creator {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * User emails configured for this user
   */
  emailAddresses: GetBookingWebhook_booking_meeting_creator_emailAddresses[];
}

export interface GetBookingWebhook_booking_meeting_cohosts_emailAddresses {
  __typename: "UserEmail";
  /**
   * The address string of this email.
   */
  address: string;
}

export interface GetBookingWebhook_booking_meeting_cohosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * User emails configured for this user
   */
  emailAddresses: GetBookingWebhook_booking_meeting_cohosts_emailAddresses[];
}

export interface GetBookingWebhook_booking_meeting {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * The primary host for this meeting
   */
  creator: GetBookingWebhook_booking_meeting_creator;
  /**
   * The cohosts of this meeting, not including primary host
   */
  cohosts: GetBookingWebhook_booking_meeting_cohosts[];
}

export interface GetBookingWebhook_booking_formSubmission_formVersion_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form
   */
  type: FormType;
  /**
   * The user entered name of this web form
   */
  name: string;
}

export interface GetBookingWebhook_booking_formSubmission_formVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent form of this form version
   */
  form: GetBookingWebhook_booking_formSubmission_formVersion_form;
}

export interface GetBookingWebhook_booking_formSubmission_primaryEntity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetBookingWebhook_booking_formSubmission_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetBookingWebhook_booking_formSubmission_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetBookingWebhook_booking_formSubmission {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the submitted web form
   */
  formVersion: GetBookingWebhook_booking_formSubmission_formVersion;
  /**
   * The internal submission id of this form submission.
   */
  submissionId: string | null;
  /**
   * The primary entity on the submission
   */
  primaryEntity: GetBookingWebhook_booking_formSubmission_primaryEntity | null;
  /**
   * The account mapped to this submission
   */
  account: GetBookingWebhook_booking_formSubmission_account | null;
  /**
   * The lead mapped to this submission
   */
  lead: GetBookingWebhook_booking_formSubmission_lead | null;
}

export interface GetBookingWebhook_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The activity associated with this booking
   */
  activity: GetBookingWebhook_booking_activity | null;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (GetBookingWebhook_booking_additionalAttendees | null)[];
  /**
   * The meeting connected to this booking
   */
  meeting: GetBookingWebhook_booking_meeting;
  /**
   * The URL for rescheduling a booking
   */
  rescheduleUrl: string;
  /**
   * The status of the booking
   */
  status: BookingStatus;
  /**
   * The form submission associated with this booking
   */
  formSubmission: GetBookingWebhook_booking_formSubmission | null;
  /**
   * The created time of this booking
   */
  createdTime: any;
}

export interface GetBookingWebhook {
  /**
   * Returns a scheduler booking
   */
  booking: GetBookingWebhook_booking;
}

export interface GetBookingWebhookVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactWebhook
// ====================================================

export interface GetContactWebhook_contact_mcfxContacts {
  __typename: "McfxContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external ID of the contact.
   */
  externalId: string;
}

export interface GetContactWebhook_contact_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
}

export interface GetContactWebhook_contact_postalAddresses_primary {
  __typename: "PostalAddress";
  value: GetContactWebhook_contact_postalAddresses_primary_value;
}

export interface GetContactWebhook_contact_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetContactWebhook_contact_postalAddresses_primary | null;
}

export interface GetContactWebhook_contact_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string | null;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetContactWebhook_contact_phones_primary {
  __typename: "Phone";
  value: GetContactWebhook_contact_phones_primary_value;
}

export interface GetContactWebhook_contact_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetContactWebhook_contact_phones_primary | null;
}

export interface GetContactWebhook_contact_urls_primary {
  __typename: "URL";
  value: string | null;
}

export interface GetContactWebhook_contact_urls {
  __typename: "UrlsConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetContactWebhook_contact_urls_primary | null;
}

export interface GetContactWebhook_contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
}

export interface GetContactWebhook_contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetContactWebhook_contact_emailAddresses_primary_value;
}

export interface GetContactWebhook_contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetContactWebhook_contact_emailAddresses_primary | null;
}

export interface GetContactWebhook_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetContactWebhook_contact_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetContactWebhook_contact_mergedWith {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetContactWebhook_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The MCFX contact associated with this contact
   */
  mcfxContacts: GetContactWebhook_contact_mcfxContacts[];
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetContactWebhook_contact_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetContactWebhook_contact_phones;
  /**
   * The paging collection of URLs.
   */
  urls: GetContactWebhook_contact_urls;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetContactWebhook_contact_emailAddresses;
  /**
   * Tags associated with the given peep
   */
  tags: GetContactWebhook_contact_tags[];
  avatarUrl: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: GetContactWebhook_contact_owner | null;
  /**
   * Is this entity deleted
   */
  isDeleted: boolean;
  /**
   * Entity this contact was merged with
   */
  mergedWith: GetContactWebhook_contact_mergedWith | null;
}

export interface GetContactWebhook {
  /**
   * Returns a Nutshell Contact
   */
  contact: GetContactWebhook_contact | null;
}

export interface GetContactWebhookVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetEventWebhook
// ====================================================

export interface GetEventWebhook_event_actor_Origin {
  __typename: "Origin" | "Contact" | "Account" | "Form" | "MaUrl";
}

export interface GetEventWebhook_event_actor_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type GetEventWebhook_event_actor = GetEventWebhook_event_actor_Origin | GetEventWebhook_event_actor_User;

export interface GetEventWebhook_event_changes {
  __typename: "ChangeLogChange";
  /**
   * The attrbute changed by the entry
   */
  attribute: string;
  /**
   * The old value before the change
   */
  oldValue: string | null;
  /**
   * The new value after the change
   */
  newValue: string | null;
}

export interface GetEventWebhook_event {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The api-type representation of the entity associated with the event
   */
  apiType: string | null;
  /**
   * The entity that triggered the change_log entry
   */
  actor: GetEventWebhook_event_actor;
  changes: GetEventWebhook_event_changes[];
  /**
   * The action verb describing this change
   */
  action: string;
}

export interface GetEventWebhook {
  /**
   * Returns a change log event for the timeline.
   */
  event: GetEventWebhook_event;
}

export interface GetEventWebhookVariables {
  changeLogId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLeadWebhook
// ====================================================

export interface GetLeadWebhook_lead_outcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadWebhook_lead_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetLeadWebhook_lead_accounts_primaryEdge_node_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
}

export interface GetLeadWebhook_lead_accounts_primaryEdge_node_postalAddresses_primary {
  __typename: "PostalAddress";
  value: GetLeadWebhook_lead_accounts_primaryEdge_node_postalAddresses_primary_value;
}

export interface GetLeadWebhook_lead_accounts_primaryEdge_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetLeadWebhook_lead_accounts_primaryEdge_node_postalAddresses_primary | null;
}

export interface GetLeadWebhook_lead_accounts_primaryEdge_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string | null;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetLeadWebhook_lead_accounts_primaryEdge_node_phones_primary {
  __typename: "Phone";
  value: GetLeadWebhook_lead_accounts_primaryEdge_node_phones_primary_value;
}

export interface GetLeadWebhook_lead_accounts_primaryEdge_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetLeadWebhook_lead_accounts_primaryEdge_node_phones_primary | null;
}

export interface GetLeadWebhook_lead_accounts_primaryEdge_node_mcfxCompanies {
  __typename: "McfxCompany";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the company
   */
  name: string;
  /**
   * The external ID of the company
   */
  externalId: string;
  /**
   * Whether this company is a PDL company
   */
  isPdlCompany: boolean;
}

export interface GetLeadWebhook_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetLeadWebhook_lead_accounts_primaryEdge_node_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetLeadWebhook_lead_accounts_primaryEdge_node_phones;
  /**
   * The Mcfx company associated with this account
   */
  mcfxCompanies: GetLeadWebhook_lead_accounts_primaryEdge_node_mcfxCompanies[];
}

export interface GetLeadWebhook_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: GetLeadWebhook_lead_accounts_primaryEdge_node;
}

export interface GetLeadWebhook_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetLeadWebhook_lead_accounts_primaryEdge | null;
}

export interface GetLeadWebhook_lead_contacts_primaryEdge_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetLeadWebhook_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetLeadWebhook_lead_contacts_primaryEdge_node_emailAddresses_primary_value;
}

export interface GetLeadWebhook_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetLeadWebhook_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface GetLeadWebhook_lead_contacts_primaryEdge_node_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
}

export interface GetLeadWebhook_lead_contacts_primaryEdge_node_postalAddresses_primary {
  __typename: "PostalAddress";
  value: GetLeadWebhook_lead_contacts_primaryEdge_node_postalAddresses_primary_value;
}

export interface GetLeadWebhook_lead_contacts_primaryEdge_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetLeadWebhook_lead_contacts_primaryEdge_node_postalAddresses_primary | null;
}

export interface GetLeadWebhook_lead_contacts_primaryEdge_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string | null;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface GetLeadWebhook_lead_contacts_primaryEdge_node_phones_primary {
  __typename: "Phone";
  value: GetLeadWebhook_lead_contacts_primaryEdge_node_phones_primary_value;
}

export interface GetLeadWebhook_lead_contacts_primaryEdge_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetLeadWebhook_lead_contacts_primaryEdge_node_phones_primary | null;
}

export interface GetLeadWebhook_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetLeadWebhook_lead_contacts_primaryEdge_node_emailAddresses;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: GetLeadWebhook_lead_contacts_primaryEdge_node_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: GetLeadWebhook_lead_contacts_primaryEdge_node_phones;
}

export interface GetLeadWebhook_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: GetLeadWebhook_lead_contacts_primaryEdge_node;
}

export interface GetLeadWebhook_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: GetLeadWebhook_lead_contacts_primaryEdge | null;
}

export interface GetLeadWebhook_lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The total integer amount of the monetary value in cents.
   */
  amountInCents: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
}

export interface GetLeadWebhook_lead_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface GetLeadWebhook_lead_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: GetLeadWebhook_lead_stages_current | null;
}

export interface GetLeadWebhook_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface GetLeadWebhook_lead_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface GetLeadWebhook_lead_products_edges_node {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface GetLeadWebhook_lead_products_edges {
  __typename: "LeadProductsEdge";
  /**
   * The API ID of the Lead_ProductMap
   */
  id: string;
  /**
   * The quantity number of the given product that is attached to the lead
   */
  quantity: number;
  /**
   * The product
   */
  node: GetLeadWebhook_lead_products_edges_node;
}

export interface GetLeadWebhook_lead_products {
  __typename: "LeadProductsConnection";
  /**
   * A list of edges.
   */
  edges: GetLeadWebhook_lead_products_edges[];
}

export interface GetLeadWebhook_lead_channels_edges_node {
  __typename: "Channel";
  /**
   * The title of the channel
   */
  title: string;
}

export interface GetLeadWebhook_lead_channels_edges_sources {
  __typename: "Source";
  /**
   * The name of the source
   */
  name: string;
}

export interface GetLeadWebhook_lead_channels_edges {
  __typename: "LeadChannelsEdge";
  node: GetLeadWebhook_lead_channels_edges_node;
  /**
   * Sources related to this LeadChannel
   */
  sources: GetLeadWebhook_lead_channels_edges_sources[];
}

export interface GetLeadWebhook_lead_channels {
  __typename: "LeadChannelsConnection";
  /**
   * A list of edges.
   */
  edges: GetLeadWebhook_lead_channels_edges[];
}

export interface GetLeadWebhook_lead_mergedWith {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
}

export interface GetLeadWebhook_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface GetLeadWebhook_lead_sources_edges_node_channel {
  __typename: "Channel";
  /**
   * The title of the channel
   */
  title: string;
}

export interface GetLeadWebhook_lead_sources_edges_node {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The channel associated with the source
   */
  channel: GetLeadWebhook_lead_sources_edges_node_channel | null;
}

export interface GetLeadWebhook_lead_sources_edges {
  __typename: "SourcesEdge";
  node: GetLeadWebhook_lead_sources_edges_node;
}

export interface GetLeadWebhook_lead_sources {
  __typename: "SourcesConnection";
  /**
   * A list of edges.
   */
  edges: GetLeadWebhook_lead_sources_edges[];
}

export interface GetLeadWebhook_lead_attributionTracking {
  __typename: "LeadAttributionTracking";
  /**
   * Google Click Identifiers, used for click and conversion attribution
   */
  gclid: string[];
  /**
   * Facebook Click Identifiers used to track clicks from Facebook/Instagram ads
   */
  fbclid: string[];
  /**
   * Microsoft Click IDs used when auto-tagging is enabled in Microsoft Ads
   */
  msclkid: string[];
  /**
   * LinkedIn Click IDs, used for click and conversion attribution
   */
  lifatid: string[];
  /**
   * Google Ads identifiers used for web conversions under Apple's App Tracking Transparency limitations
   */
  wbraid: string[];
  /**
   * Google Ads identifiers used for app conversions under Apple's App Tracking Transparency limitations
   */
  gbraid: string[];
}

export interface GetLeadWebhook_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The outcome for this lead, if there is one.
   */
  outcome: GetLeadWebhook_lead_outcome | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: GetLeadWebhook_lead_assignee | null;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: GetLeadWebhook_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: GetLeadWebhook_lead_contacts;
  /**
   * The anticipated close time for the lead.
   */
  anticipatedClosedTime: any | null;
  value: GetLeadWebhook_lead_value | null;
  /**
   * The due time for the lead.
   */
  dueTime: any | null;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * The deleted time for the lead if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The percentage confidence of lead success.
   */
  confidence: number;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Stages for the lead
   */
  stages: GetLeadWebhook_lead_stages;
  /**
   * The list of tags on this lead
   */
  tags: GetLeadWebhook_lead_tags[];
  /**
   * The terrority to which this lead is assigned.
   */
  territory: GetLeadWebhook_lead_territory | null;
  /**
   * Products for the lead
   */
  products: GetLeadWebhook_lead_products | null;
  /**
   * List of channels associated with this lead
   */
  channels: GetLeadWebhook_lead_channels | null;
  /**
   * List of MCFX contact IDs associated with this lead
   */
  mcfxContactIds: string[];
  /**
   * Entity this lead was merged with
   */
  mergedWith: GetLeadWebhook_lead_mergedWith | null;
  /**
   * Stageset associated with the given lead
   */
  stageset: GetLeadWebhook_lead_stageset | null;
  /**
   * Sources for the lead (simple tag-like objects that note _where_ this lead came from, e.g., a specific advertising campaign
   */
  sources: GetLeadWebhook_lead_sources | null;
  /**
   * Click identifiers (gclid, fbclid, msclkid, etc) captured for this lead
   */
  attributionTracking: GetLeadWebhook_lead_attributionTracking;
}

export interface GetLeadWebhook {
  /**
   * Returns a Nutshell Lead
   */
  lead: GetLeadWebhook_lead | null;
}

export interface GetLeadWebhookVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetMessageWebhook
// ====================================================

export interface GetMessageWebhook_inboxMessage_thread_externalChannel_phone {
  __typename: "PhoneValue";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string | null;
}

export interface GetMessageWebhook_inboxMessage_thread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  phone: GetMessageWebhook_inboxMessage_thread_externalChannel_phone | null;
}

export interface GetMessageWebhook_inboxMessage_thread_bestEntity_relatedEmailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetMessageWebhook_inboxMessage_thread_bestEntity_relatedEmailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetMessageWebhook_inboxMessage_thread_bestEntity_relatedEmailAddresses_primary_value;
}

export interface GetMessageWebhook_inboxMessage_thread_bestEntity_relatedEmailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetMessageWebhook_inboxMessage_thread_bestEntity_relatedEmailAddresses_primary | null;
}

export interface GetMessageWebhook_inboxMessage_thread_bestEntity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  relatedEmailAddresses: GetMessageWebhook_inboxMessage_thread_bestEntity_relatedEmailAddresses;
}

export interface GetMessageWebhook_inboxMessage_thread_nutshellChannel_phone {
  __typename: "PhoneValue";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string | null;
}

export interface GetMessageWebhook_inboxMessage_thread_nutshellChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  phone: GetMessageWebhook_inboxMessage_thread_nutshellChannel_phone | null;
}

export interface GetMessageWebhook_inboxMessage_thread_owner_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface GetMessageWebhook_inboxMessage_thread_owner_User_emailAddresses {
  __typename: "UserEmail";
  /**
   * The address string of this email.
   */
  address: string;
}

export interface GetMessageWebhook_inboxMessage_thread_owner_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * User emails configured for this user
   */
  emailAddresses: GetMessageWebhook_inboxMessage_thread_owner_User_emailAddresses[];
}

export type GetMessageWebhook_inboxMessage_thread_owner = GetMessageWebhook_inboxMessage_thread_owner_Team | GetMessageWebhook_inboxMessage_thread_owner_User;

export interface GetMessageWebhook_inboxMessage_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
  /**
   * The external channel this thread is related to
   */
  externalChannel: GetMessageWebhook_inboxMessage_thread_externalChannel;
  /**
   * The best entity associated with this thread
   */
  bestEntity: GetMessageWebhook_inboxMessage_thread_bestEntity | null;
  /**
   * The internal nutshell channel this thread is related to
   */
  nutshellChannel: GetMessageWebhook_inboxMessage_thread_nutshellChannel;
  /**
   * The user or team assigned to this thread
   */
  owner: GetMessageWebhook_inboxMessage_thread_owner | null;
  /**
   * The attribution data for the thread, if it exists. For now, this should only exist for chat threads
   */
  attributionJson: string | null;
}

export interface GetMessageWebhook_inboxMessage {
  __typename: "Message";
  /**
   * The thread this message is part of
   */
  thread: GetMessageWebhook_inboxMessage_thread;
  /**
   * The content of the message
   */
  content: string;
  status: MessageStatus;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
}

export interface GetMessageWebhook {
  /**
   * Returns the inbox message
   */
  inboxMessage: GetMessageWebhook_inboxMessage;
}

export interface GetMessageWebhookVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSubmissionWebhook
// ====================================================

export interface GetSubmissionWebhook_submission_formVersion_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form
   */
  type: FormType;
  /**
   * The user entered name of this web form
   */
  name: string;
}

export interface GetSubmissionWebhook_submission_formVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent form of this form version
   */
  form: GetSubmissionWebhook_submission_formVersion_form;
}

export interface GetSubmissionWebhook_submission_mcfxFormSubmission {
  __typename: "FormSubmission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetSubmissionWebhook_submission_primaryEntity_Account {
  __typename: "Account" | "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetSubmissionWebhook_submission_primaryEntity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
}

export interface GetSubmissionWebhook_submission_primaryEntity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetSubmissionWebhook_submission_primaryEntity_Contact_emailAddresses_primary_value;
}

export interface GetSubmissionWebhook_submission_primaryEntity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetSubmissionWebhook_submission_primaryEntity_Contact_emailAddresses_primary | null;
}

export interface GetSubmissionWebhook_submission_primaryEntity_Contact_mcfxContacts {
  __typename: "McfxContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external ID of the contact.
   */
  externalId: string;
}

export interface GetSubmissionWebhook_submission_primaryEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: GetSubmissionWebhook_submission_primaryEntity_Contact_emailAddresses;
  /**
   * The MCFX contact associated with this contact
   */
  mcfxContacts: GetSubmissionWebhook_submission_primaryEntity_Contact_mcfxContacts[];
}

export type GetSubmissionWebhook_submission_primaryEntity = GetSubmissionWebhook_submission_primaryEntity_Account | GetSubmissionWebhook_submission_primaryEntity_Contact;

export interface GetSubmissionWebhook_submission_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface GetSubmissionWebhook_submission_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface GetSubmissionWebhook_submission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface GetSubmissionWebhook_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface GetSubmissionWebhook_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: GetSubmissionWebhook_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export interface GetSubmissionWebhook_submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface GetSubmissionWebhook_submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export type GetSubmissionWebhook_submission_fields_edges_fieldValue = GetSubmissionWebhook_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields | GetSubmissionWebhook_submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | GetSubmissionWebhook_submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle;

export interface GetSubmissionWebhook_submission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: GetSubmissionWebhook_submission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: GetSubmissionWebhook_submission_fields_edges_fieldValue | null;
}

export interface GetSubmissionWebhook_submission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: GetSubmissionWebhook_submission_fields_edges[];
}

export interface GetSubmissionWebhook_submission {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The internal submission id of this form submission.
   */
  submissionId: string | null;
  /**
   * The name of the submitted web form
   */
  formVersion: GetSubmissionWebhook_submission_formVersion;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The url where the submission originates
   */
  submissionUrl: string;
  /**
   * The connected MCFX submission, if this was created
   * 							as result of a MCFX form payload being processed
   */
  mcfxFormSubmission: GetSubmissionWebhook_submission_mcfxFormSubmission | null;
  /**
   * The primary entity on the submission
   */
  primaryEntity: GetSubmissionWebhook_submission_primaryEntity | null;
  /**
   * The account mapped to this submission
   */
  account: GetSubmissionWebhook_submission_account | null;
  /**
   * The lead mapped to this submission
   */
  lead: GetSubmissionWebhook_submission_lead | null;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: GetSubmissionWebhook_submission_fields;
  /**
   * The attribution data for the submission, if it exists
   */
  attributionJson: string | null;
}

export interface GetSubmissionWebhook {
  /**
   * Returns a Nutshell web form submission.
   */
  submission: GetSubmissionWebhook_submission;
}

export interface GetSubmissionWebhookVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetThreadWebhook
// ====================================================

export interface GetThreadWebhook_inboxThread_startedFromUrl {
  __typename: "Url";
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface GetThreadWebhook_inboxThread_externalChannel_phone {
  __typename: "PhoneValue";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string | null;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The base number component of the phone number
   */
  number: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
}

export interface GetThreadWebhook_inboxThread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  status: ChannelStatus;
  phone: GetThreadWebhook_inboxThread_externalChannel_phone | null;
}

export interface GetThreadWebhook_inboxThread_messages_edges_node {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The content of the message
   */
  content: string;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
}

export interface GetThreadWebhook_inboxThread_messages_edges {
  __typename: "ThreadMessagesEdge";
  node: GetThreadWebhook_inboxThread_messages_edges_node;
}

export interface GetThreadWebhook_inboxThread_messages {
  __typename: "ThreadMessagesConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: GetThreadWebhook_inboxThread_messages_edges[];
}

export interface GetThreadWebhook_inboxThread_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface GetThreadWebhook_inboxThread_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface GetThreadWebhook_inboxThread_bestEntity_Account_relatedEmailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetThreadWebhook_inboxThread_bestEntity_Account_relatedEmailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetThreadWebhook_inboxThread_bestEntity_Account_relatedEmailAddresses_primary_value;
}

export interface GetThreadWebhook_inboxThread_bestEntity_Account_relatedEmailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetThreadWebhook_inboxThread_bestEntity_Account_relatedEmailAddresses_primary | null;
}

export interface GetThreadWebhook_inboxThread_bestEntity_Account {
  __typename: "Account" | "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  relatedEmailAddresses: GetThreadWebhook_inboxThread_bestEntity_Account_relatedEmailAddresses;
}

export interface GetThreadWebhook_inboxThread_bestEntity_Contact_relatedEmailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface GetThreadWebhook_inboxThread_bestEntity_Contact_relatedEmailAddresses_primary {
  __typename: "EmailAddressEav";
  value: GetThreadWebhook_inboxThread_bestEntity_Contact_relatedEmailAddresses_primary_value;
}

export interface GetThreadWebhook_inboxThread_bestEntity_Contact_relatedEmailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: GetThreadWebhook_inboxThread_bestEntity_Contact_relatedEmailAddresses_primary | null;
}

export interface GetThreadWebhook_inboxThread_bestEntity_Contact_mcfxContacts {
  __typename: "McfxContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external ID of the contact.
   */
  externalId: string;
}

export interface GetThreadWebhook_inboxThread_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * All of the related email objects associated with this contact.
   */
  relatedEmailAddresses: GetThreadWebhook_inboxThread_bestEntity_Contact_relatedEmailAddresses;
  /**
   * The MCFX contact associated with this contact
   */
  mcfxContacts: GetThreadWebhook_inboxThread_bestEntity_Contact_mcfxContacts[];
  avatarUrl: string;
}

export type GetThreadWebhook_inboxThread_bestEntity = GetThreadWebhook_inboxThread_bestEntity_Account | GetThreadWebhook_inboxThread_bestEntity_Contact;

export interface GetThreadWebhook_inboxThread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
  /**
   * Whether this thread is open
   */
  isOpen: boolean;
  /**
   * The time this thread was created
   */
  createdTime: any;
  /**
   * The URL that this thread was started from
   */
  startedFromUrl: GetThreadWebhook_inboxThread_startedFromUrl | null;
  /**
   * The external channel this thread is related to
   */
  externalChannel: GetThreadWebhook_inboxThread_externalChannel;
  /**
   * The messages associated with this thread
   */
  messages: GetThreadWebhook_inboxThread_messages;
  /**
   * The time this thread is snoozed until
   */
  snoozedUntilTime: any | null;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The user or team assigned to this thread
   */
  owner: GetThreadWebhook_inboxThread_owner | null;
  /**
   * The leads associated with this thread
   */
  relatedLeads: GetThreadWebhook_inboxThread_relatedLeads[] | null;
  /**
   * The best entity associated with this thread
   */
  bestEntity: GetThreadWebhook_inboxThread_bestEntity | null;
  /**
   * The attribution data for the thread, if it exists. For now, this should only exist for chat threads
   */
  attributionJson: string | null;
}

export interface GetThreadWebhook {
  /**
   * Returns the inbox thread
   */
  inboxThread: GetThreadWebhook_inboxThread;
}

export interface GetThreadWebhookVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntitySummary
// ====================================================

export interface EntitySummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ZoomMeetingTimelineFragment
// ====================================================

export interface ZoomMeetingTimelineFragment_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface ZoomMeetingTimelineFragment_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface ZoomMeetingTimelineFragment {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: ZoomMeetingTimelineFragment_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: ZoomMeetingTimelineFragment_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ActivityModalFragment
// ====================================================

export interface ActivityModalFragment_logNote_audioLog {
  __typename: "EntityAttributeValueFile";
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Unique id for this file
   */
  fileId: string;
}

export interface ActivityModalFragment_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The plain text (i.e., no HTML/rich text, no NutMark for @-mention tokenizing) representation of the Note text
   */
  body: string | null;
  /**
   * The audio log for this note
   */
  audioLog: ActivityModalFragment_logNote_audioLog | null;
}

export interface ActivityModalFragment_externalMeeting_audioLog {
  __typename: "EntityAttributeValueFile";
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Unique id for this file
   */
  fileId: string;
}

export interface ActivityModalFragment_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The audio log of this meeting
   */
  audioLog: ActivityModalFragment_externalMeeting_audioLog | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
}

export interface ActivityModalFragment_summary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
}

export interface ActivityModalFragment_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
  primaryEmailAddress: string | null;
  primaryPhoneNumber: string | null;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface ActivityModalFragment_participantsWithStatus_participant {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
  primaryEmailAddress: string | null;
  primaryPhoneNumber: string | null;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface ActivityModalFragment_participantsWithStatus {
  __typename: "ActivityParticipantEdge";
  /**
   * Null when the activity is not publicly synced, the feature is disabled, or the
   * assignment status is not an invitation response (e.g. completed, incomplete).
   */
  attendanceStatus: ActivityParticipantAttendanceStatus | null;
  participant: ActivityModalFragment_participantsWithStatus_participant;
}

export interface ActivityModalFragment_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface ActivityModalFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ActivityModalFragment_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  originType: OriginType;
}

export interface ActivityModalFragment_comments_edges_node_changeLogEntry {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ActivityModalFragment_comments_edges_node_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ActivityModalFragment_comments_edges_node_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: ActivityModalFragment_comments_edges_node_reactions_creatorUser;
}

export interface ActivityModalFragment_comments_edges_node_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  htmlUrl: string | null;
}

export interface ActivityModalFragment_comments_edges_node {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Change log associated with the comment
   */
  changeLogEntry: ActivityModalFragment_comments_edges_node_changeLogEntry | null;
  /**
   * User reactions left for the comment change log entry
   */
  reactions: ActivityModalFragment_comments_edges_node_reactions[];
  /**
   * The user who created the comment.
   */
  creatorUser: ActivityModalFragment_comments_edges_node_creatorUser;
  /**
   * The created time for the comment.
   */
  createdTime: any;
  /**
   * True if this comment can be deleted
   */
  isDeleteable: boolean;
}

export interface ActivityModalFragment_comments_edges {
  __typename: "CommentsEdge";
  node: ActivityModalFragment_comments_edges_node;
}

export interface ActivityModalFragment_comments {
  __typename: "CommentsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: ActivityModalFragment_comments_edges[];
}

export interface ActivityModalFragment_loggedBy {
  __typename: "User";
  name: string;
}

export interface ActivityModalFragment_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface ActivityModalFragment_conferenceData {
  __typename: "ConferenceData";
  externalId: string | null;
  externalUuid: string | null;
  meetingUrl: string;
  type: ActivityConferenceType;
  canBeRemoved: boolean;
}

export interface ActivityModalFragment_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * Leads don’t have initials, but for interface reasons we’ll return an empty
   * string here instead of removing the property entirely.
   */
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface ActivityModalFragment_summaryStates {
  __typename: "ActivitySummaryStates";
  /**
   * The copy to display for the current activity configuration on the recording tab.
   */
  recordingEmptyState: string;
  /**
   * The copy to display for the current activity configuration on the transcription tab.
   */
  transcriptionEmptyState: string;
  /**
   * The current state of the activity summary.
   */
  summaryEmptyState: string;
  /**
   * The next action to take for the activity summary.
   */
  summaryNextAction: ActivitySummaryAction;
  /**
   * Whether the relevant notetaker feature has been disabled by an admin.
   */
  isNotetakerDisabled: boolean;
}

export interface ActivityModalFragment_previousActivity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface ActivityModalFragment_nextActivity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface ActivityModalFragment_tasks_delayApplications_delay {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the delay
   */
  name: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface ActivityModalFragment_tasks_delayApplications_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ActivityModalFragment_tasks_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * An optional note about the delay application
   */
  note: string | null;
  /**
   * The time when the delay was applied
   */
  appliedTime: any;
  /**
   * The delay that was applied
   */
  delay: ActivityModalFragment_tasks_delayApplications_delay;
  /**
   * The user who applied the delay
   */
  user: ActivityModalFragment_tasks_delayApplications_user | null;
}

export interface ActivityModalFragment_tasks_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ActivityModalFragment_tasks_completedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ActivityModalFragment_tasks_relatedEntity {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ActivityModalFragment_tasks_creatorEntity_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface ActivityModalFragment_tasks_creatorEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export type ActivityModalFragment_tasks_creatorEntity = ActivityModalFragment_tasks_creatorEntity_Chat | ActivityModalFragment_tasks_creatorEntity_Activity;

export interface ActivityModalFragment_tasks_assigner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ActivityModalFragment_tasks_recurrenceRule {
  __typename: "RecurrenceRule";
  mode: RecurrenceMode;
  /**
   * An RRULE-compatible string defining the recurrence pattern (e.g. "FREQ=WEEKLY;BYDAY=MO").
   */
  rule: string;
}

export interface ActivityModalFragment_tasks {
  __typename: "Task";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the task
   */
  title: string;
  /**
   * The canonical API href for the task
   */
  href: string;
  /**
   * The task’s user-defined description
   */
  description: string | null;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: ActivityModalFragment_tasks_delayApplications[];
  /**
   * The due timestamp of the task
   */
  dueTime: any | null;
  /**
   * The person or team assigned to this task
   */
  assignee: ActivityModalFragment_tasks_assignee | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  completedTime: any | null;
  /**
   * Can the task be completed?
   */
  canBeCompleted: boolean;
  /**
   * Is this task completed?
   */
  isCompleted: boolean;
  /**
   * The user who completed the task
   */
  completedByUser: ActivityModalFragment_tasks_completedByUser | null;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Whether the tasks due date is later than the current date
   */
  isOverdue: boolean;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  relatedEntity: ActivityModalFragment_tasks_relatedEntity | null;
  /**
   * The DateTime that represents when the Activity record was created
   */
  createdTime: any;
  /**
   * The task's linkified description with URLs converted to clickable links
   */
  linkifiedDescription: string | null;
  isAiGenerated: boolean;
  creatorEntity: ActivityModalFragment_tasks_creatorEntity | null;
  /**
   * The user who assigned the task
   */
  assigner: ActivityModalFragment_tasks_assigner | null;
  /**
   * The time the task was assigned
   */
  assignedTime: any | null;
  /**
   * Number of days between follow-up reminders. Null if the task is not recurring.
   */
  recurringPeriod: number | null;
  /**
   * Whether this task is the current user recurring follow-up reminder.
   */
  isRecurringForUser: boolean;
  /**
   * Null if the task does not recur under the new recurrence system.
   */
  recurrenceRule: ActivityModalFragment_tasks_recurrenceRule | null;
}

export interface ActivityModalFragment {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: ActivityModalFragment_logNote | null;
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: ActivityModalFragment_externalMeeting | null;
  /**
   * The summary of the activity.
   */
  summary: ActivityModalFragment_summary | null;
  /**
   * The transcription of the activity.
   */
  transcription: string | null;
  /**
   * The status of the transcription.
   */
  transcriptionStatus: ActivityTranscriptionStatus;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: ActivityModalFragment_participants[];
  /**
   * Activity participants paired with their calendar invitation response status.
   */
  participantsWithStatus: ActivityModalFragment_participantsWithStatus[];
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: ActivityModalFragment_activityType;
  /**
   * The boolean that represents whether or not the Activity is overdue.
   * Specifically, this means that the activity is not logged, and is in the past.
   */
  isOverdue: boolean;
  /**
   * The DateTime that represents the start time of the Activity record
   */
  startTime: any;
  /**
   * The DateTime that represents the end time of the Activity record
   */
  endTime: any;
  /**
   * Whether the activity should be summarized by the AI.
   */
  shouldSummarize: boolean;
  /**
   * Whether the activity is currently generating a summary.
   */
  generatingSummary: boolean;
  /**
   * Whether the activity is currently generating a recording.
   */
  generatingRecording: boolean;
  /**
   * The type of external service that the associated meeting belongs to
   */
  externalMeetingServiceType: ExternalServiceType | null;
  /**
   * The DateTime that represents when the Activity record was created
   */
  createdTime: any;
  /**
   * The user that created the activity.
   */
  creatorUser: ActivityModalFragment_creatorUser | null;
  /**
   * The origin that created the activity.
   */
  creatorOrigin: ActivityModalFragment_creatorOrigin | null;
  /**
   * The url of the origin that created the activity.
   */
  originUrl: string;
  /**
   * The comments for the activity.
   */
  comments: ActivityModalFragment_comments;
  /**
   * The status of the activity.
   */
  status: ActivityStatus;
  /**
   * Freeform text for public notes & agendas around the Nutshell Activity
   */
  agenda: string;
  /**
   * The boolean that represents whether or not the Activity represents an all day calendar event
   */
  isAllDay: boolean;
  /**
   * The boolean that represents whether an activity should display the audio log.
   */
  shouldDisplayAudio: boolean;
  /**
   * The boolean that represents whether an activity should display the video log.
   */
  shouldDisplayVideo: boolean;
  /**
   * Whether the activity has an associated scheduler booking.
   */
  hasBooking: boolean;
  /**
   * The user that logged the activity.
   */
  loggedBy: ActivityModalFragment_loggedBy | null;
  /**
   * The time that the activity was logged.
   */
  loggedTime: any | null;
  /**
   * Whether the activity was autologged
   */
  autologged: boolean;
  /**
   * An optional geographic location for the activity, helpful for knowing not only the time but the _place_ of the meeting
   */
  location: ActivityModalFragment_location | null;
  /**
   * The URL of the meeting for the activity.
   */
  externalMeetingUrl: string | null;
  conferenceData: ActivityModalFragment_conferenceData | null;
  /**
   * Related leads for the activity.
   */
  relatedLeads: ActivityModalFragment_relatedLeads[];
  /**
   * The Quill delta for the activity note. Useful for reconstructing @mentions.
   */
  quillDelta: string | null;
  /**
   * Whether the activity is editable.
   */
  isEditable: boolean;
  /**
   * Whether the activity has been connected to an external calendar
   */
  isConnectedToExternalCalendar: boolean;
  /**
   * Whether the activity can be summarized by the AI.
   */
  canViewSummaryDetails: boolean;
  /**
   * The current states of the activity based on its type and current conditions.
   */
  summaryStates: ActivityModalFragment_summaryStates;
  /**
   * Whether the user can log the activity.
   */
  canUserLogActivity: boolean;
  /**
   * The linkified agenda of the activity.
   */
  linkifiedAgenda: string;
  /**
   * Whether the user can sync the activity to the calendar.
   */
  canUserSeeSyncStatus: boolean;
  /**
   * Whether the activity should be force synced to the calendar. Not necessarily synced yet.
   */
  isForceSync: boolean;
  /**
   * Whether the activity is loggable due to its timing.
   */
  isLoggable: boolean;
  /**
   * Whether the activity should be synced to the calendar.
   */
  shouldSyncToCalendar: boolean;
  /**
   * The activity that preceded this activity in the follow up chain.
   */
  previousActivity: ActivityModalFragment_previousActivity | null;
  /**
   * The activity that followed this activity in the follow up chain.
   */
  nextActivity: ActivityModalFragment_nextActivity | null;
  /**
   * Whether the user can schedule a follow up for the activity.
   */
  canScheduleFollowUp: boolean;
  /**
   * The username of the organizer that the activity is synced to.
   */
  syncOrganizerUsername: string | null;
  /**
   * Whether the activity is private.
   */
  isPrivate: boolean;
  /**
   * The mode of how the activity should be synced to the calendar.
   */
  syncMode: ActivitySyncMode;
  /**
   * Tasks that were originated from this activity. Currently only as follow-ups from meeting summaries.
   */
  tasks: ActivityModalFragment_tasks[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ActivityTranscriptAndSummaryFragment
// ====================================================

export interface ActivityTranscriptAndSummaryFragment_summary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
}

export interface ActivityTranscriptAndSummaryFragment_logNote_audioLog {
  __typename: "EntityAttributeValueFile";
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Unique id for this file
   */
  fileId: string;
}

export interface ActivityTranscriptAndSummaryFragment_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audio log for this note
   */
  audioLog: ActivityTranscriptAndSummaryFragment_logNote_audioLog | null;
}

export interface ActivityTranscriptAndSummaryFragment_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
}

export interface ActivityTranscriptAndSummaryFragment_summaryStates {
  __typename: "ActivitySummaryStates";
  /**
   * The copy to display for the current activity configuration on the recording tab.
   */
  recordingEmptyState: string;
  /**
   * The copy to display for the current activity configuration on the transcription tab.
   */
  transcriptionEmptyState: string;
  /**
   * The current state of the activity summary.
   */
  summaryEmptyState: string;
  /**
   * The next action to take for the activity summary.
   */
  summaryNextAction: ActivitySummaryAction;
  /**
   * Whether the relevant notetaker feature has been disabled by an admin.
   */
  isNotetakerDisabled: boolean;
}

export interface ActivityTranscriptAndSummaryFragment {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The transcription of the activity.
   */
  transcription: string | null;
  /**
   * The status of the transcription.
   */
  transcriptionStatus: ActivityTranscriptionStatus;
  /**
   * The summary of the activity.
   */
  summary: ActivityTranscriptAndSummaryFragment_summary | null;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: ActivityTranscriptAndSummaryFragment_logNote | null;
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: ActivityTranscriptAndSummaryFragment_externalMeeting | null;
  /**
   * Whether the activity is currently generating a summary.
   */
  generatingSummary: boolean;
  /**
   * Whether the activity is currently generating a recording.
   */
  generatingRecording: boolean;
  /**
   * The boolean that represents whether an activity should display the audio log.
   */
  shouldDisplayAudio: boolean;
  /**
   * The current states of the activity based on its type and current conditions.
   */
  summaryStates: ActivityTranscriptAndSummaryFragment_summaryStates;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ExternalMeetingForModalFragment
// ====================================================

export interface ExternalMeetingForModalFragment_audioLog {
  __typename: "EntityAttributeValueFile";
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Unique id for this file
   */
  fileId: string;
}

export interface ExternalMeetingForModalFragment {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The audio log of this meeting
   */
  audioLog: ExternalMeetingForModalFragment_audioLog | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LogNoteForModalFragment
// ====================================================

export interface LogNoteForModalFragment_audioLog {
  __typename: "EntityAttributeValueFile";
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Unique id for this file
   */
  fileId: string;
}

export interface LogNoteForModalFragment {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The plain text (i.e., no HTML/rich text, no NutMark for @-mention tokenizing) representation of the Note text
   */
  body: string | null;
  /**
   * The audio log for this note
   */
  audioLog: LogNoteForModalFragment_audioLog | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PotentialActivityEntityFragment
// ====================================================

export interface PotentialActivityEntityFragment {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
  primaryEmailAddress: string | null;
  primaryPhoneNumber: string | null;
  /**
   * The API type for this model.
   */
  type: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AiFeatureFragment
// ====================================================

export interface AiFeatureFragment_AiFeatureBase {
  __typename: "AiFeatureBase";
  /**
   * The type of the feature
   */
  type: AiFeatureType;
  /**
   * The display name of the feature
   */
  displayName: string;
  requiresUpgrade: boolean;
  /**
   * The display name of the lowest plan that includes this feature, or null if available on all plans
   */
  minimumPlanName: string | null;
}

export interface AiFeatureFragment_AiFeatureWithStats_stats_AiValueStat {
  __typename: "AiValueStat";
  /**
   * The display name of the feature stat
   */
  displayName: string;
  /**
   * The tooltip of the feature stat
   */
  tooltip: string | null;
  /**
   * The value to be displayed
   */
  value: string;
}

export interface AiFeatureFragment_AiFeatureWithStats_stats_AiPercentageStat {
  __typename: "AiPercentageStat";
  /**
   * The display name of the feature stat
   */
  displayName: string;
  /**
   * The tooltip of the feature stat
   */
  tooltip: string | null;
  /**
   * The percentage to be displayed
   */
  percentage: number;
}

export interface AiFeatureFragment_AiFeatureWithStats_stats_AiUserStat_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface AiFeatureFragment_AiFeatureWithStats_stats_AiUserStat {
  __typename: "AiUserStat";
  /**
   * The display name of the feature stat
   */
  displayName: string;
  /**
   * The tooltip of the feature stat
   */
  tooltip: string | null;
  /**
   * The user who has the stat
   */
  user: AiFeatureFragment_AiFeatureWithStats_stats_AiUserStat_user | null;
}

export interface AiFeatureFragment_AiFeatureWithStats_stats_AiLimitStat {
  __typename: "AiLimitStat";
  /**
   * The display name of the feature stat
   */
  displayName: string;
  /**
   * The tooltip of the feature stat
   */
  tooltip: string | null;
  limitValue: number;
  limit: number | null;
  isUnlimited: boolean;
}

export type AiFeatureFragment_AiFeatureWithStats_stats = AiFeatureFragment_AiFeatureWithStats_stats_AiValueStat | AiFeatureFragment_AiFeatureWithStats_stats_AiPercentageStat | AiFeatureFragment_AiFeatureWithStats_stats_AiUserStat | AiFeatureFragment_AiFeatureWithStats_stats_AiLimitStat;

export interface AiFeatureFragment_AiFeatureWithStats {
  __typename: "AiFeatureWithStats";
  /**
   * The type of the feature
   */
  type: AiFeatureType;
  /**
   * The display name of the feature
   */
  displayName: string;
  requiresUpgrade: boolean;
  /**
   * The display name of the lowest plan that includes this feature, or null if available on all plans
   */
  minimumPlanName: string | null;
  /**
   * The stats of the feature
   */
  stats: AiFeatureFragment_AiFeatureWithStats_stats[];
}

export type AiFeatureFragment = AiFeatureFragment_AiFeatureBase | AiFeatureFragment_AiFeatureWithStats;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AiStatFragment
// ====================================================

export interface AiStatFragment_AiValueStat {
  __typename: "AiValueStat";
  /**
   * The display name of the feature stat
   */
  displayName: string;
  /**
   * The tooltip of the feature stat
   */
  tooltip: string | null;
  /**
   * The value to be displayed
   */
  value: string;
}

export interface AiStatFragment_AiPercentageStat {
  __typename: "AiPercentageStat";
  /**
   * The display name of the feature stat
   */
  displayName: string;
  /**
   * The tooltip of the feature stat
   */
  tooltip: string | null;
  /**
   * The percentage to be displayed
   */
  percentage: number;
}

export interface AiStatFragment_AiUserStat_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface AiStatFragment_AiUserStat {
  __typename: "AiUserStat";
  /**
   * The display name of the feature stat
   */
  displayName: string;
  /**
   * The tooltip of the feature stat
   */
  tooltip: string | null;
  /**
   * The user who has the stat
   */
  user: AiStatFragment_AiUserStat_user | null;
}

export interface AiStatFragment_AiLimitStat {
  __typename: "AiLimitStat";
  /**
   * The display name of the feature stat
   */
  displayName: string;
  /**
   * The tooltip of the feature stat
   */
  tooltip: string | null;
  limitValue: number;
  limit: number | null;
  isUnlimited: boolean;
}

export type AiStatFragment = AiStatFragment_AiValueStat | AiStatFragment_AiPercentageStat | AiStatFragment_AiUserStat | AiStatFragment_AiLimitStat;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AiUserFragment
// ====================================================

export interface AiUserFragment_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface AiUserFragment {
  __typename: "AiUser";
  /**
   * The user
   */
  user: AiUserFragment_user;
  /**
   * The formatted time saved by this user
   */
  timeSaved: string;
  outcomeCount: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PhoneIntegrationFields
// ====================================================

export interface PhoneIntegrationFields_integration {
  __typename: "Integration";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Indicates whether the integration is currently enabled
   */
  isEnabled: boolean;
  /**
   * Indicates whether the integration has been validated
   */
  isValidated: boolean;
}

export interface PhoneIntegrationFields_defaultCallsActivityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface PhoneIntegrationFields_defaultVoicemailsActivityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface PhoneIntegrationFields_phoneNumberAssignments_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface PhoneIntegrationFields_phoneNumberAssignments {
  __typename: "CallRailPhoneNumberAssignment";
  /**
   * The CallRail tracking phone number in E.164 format.
   */
  phoneNumber: string;
  /**
   * Display-formatted version of the tracking phone number.
   */
  formattedPhoneNumber: string;
  /**
   * The Nutshell user the phone number is assigned to. Null if the user has been deleted.
   */
  user: PhoneIntegrationFields_phoneNumberAssignments_user | null;
}

export interface PhoneIntegrationFields {
  __typename: "PhoneIntegration";
  /**
   * If the current user has enabled and set up credentials for this specific integration
   */
  isEnabledForUser: boolean;
  /**
   * The integration object for those types that have an instance-wide integration.
   * Null for user-specific phone integration types.
   */
  integration: PhoneIntegrationFields_integration | null;
  /**
   * The type of integration
   */
  integrationType: ExternalServiceType;
  /**
   * Unique Identifier for the user in the external system
   */
  externalUserIdentifier: string | null;
  /**
   * Additional information about the integration
   */
  tertiaryInformation: string | null;
  /**
   * The default activity type for calls from this integration
   */
  defaultCallsActivityType: PhoneIntegrationFields_defaultCallsActivityType;
  /**
   * The default activity type for voicemails from this integration
   */
  defaultVoicemailsActivityType: PhoneIntegrationFields_defaultVoicemailsActivityType;
  /**
   * True if the current user can sync previous calls for this integration
   */
  canSyncPreviousCalls: boolean;
  /**
   * True if the current user is performing an initial sync for this integration
   */
  isPerformingInitialSync: boolean;
  /**
   * CallRail-specific. Map of tracking phone numbers to the Nutshell users they
   * are assigned to. Empty for other integration types.
   */
  phoneNumberAssignments: PhoneIntegrationFields_phoneNumberAssignments[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ProductCategoryFragment
// ====================================================

export interface ProductCategoryFragment {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
  /**
   * The time the product category was created
   */
  createdTime: any;
  /**
   * The number of products associated with this category
   */
  numAssociatedProducts: number;
  /**
   * The link to the report for this product category
   */
  reportLink: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: McfxFormFragment
// ====================================================

export interface McfxFormFragment_lastSubmission {
  __typename: "FormSubmission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  createdTime: any;
}

export interface McfxFormFragment_submissions_edges_node_form {
  __typename: "McfxForm";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface McfxFormFragment_submissions_edges_node_contact_nutshellContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface McfxFormFragment_submissions_edges_node_contact {
  __typename: "McfxContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The contact that made this form submission.
   */
  nutshellContact: McfxFormFragment_submissions_edges_node_contact_nutshellContact | null;
}

export interface McfxFormFragment_submissions_edges_node {
  __typename: "FormSubmission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  createdTime: any;
  /**
   * The mcfx form that this submission is from.
   */
  form: McfxFormFragment_submissions_edges_node_form;
  /**
   * The contact that made this form submission.
   */
  contact: McfxFormFragment_submissions_edges_node_contact | null;
}

export interface McfxFormFragment_submissions_edges {
  __typename: "McfxSubmissionEdge";
  node: McfxFormFragment_submissions_edges_node;
}

export interface McfxFormFragment_submissions {
  __typename: "McfxSubmissionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: McfxFormFragment_submissions_edges[];
}

export interface McfxFormFragment_wfForm_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface McfxFormFragment_wfForm_publishedVersion_fields_exampleValues_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile" | "EntityAttributeValueImage" | "EntityAttributeValueset" | "EntityAttributeValueLocation" | "EntityAttributeValueCurrency" | "EntityAttributeValueDate" | "EntityAttributeValueEmail" | "EntityAttributeValueEnum" | "EntityAttributeValuePhone" | "EntityAttributeValueNumber" | "EntityAttributeValueText" | "EntityAttributeValueUrl";
}

export interface McfxFormFragment_wfForm_publishedVersion_fields_exampleValues_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export type McfxFormFragment_wfForm_publishedVersion_fields_exampleValues_all = McfxFormFragment_wfForm_publishedVersion_fields_exampleValues_all_EntityAttributeValueFile | McfxFormFragment_wfForm_publishedVersion_fields_exampleValues_all_EntityAttributeValueString;

export interface McfxFormFragment_wfForm_publishedVersion_fields_exampleValues {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: McfxFormFragment_wfForm_publishedVersion_fields_exampleValues_all[];
}

export interface McfxFormFragment_wfForm_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The input name that we received from an MCFX form submission
   */
  inputName: string;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: McfxFormFragment_wfForm_publishedVersion_fields_attribute | null;
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * If a field is ignored, data that it contains will not be transfered into Nutshell entities
   */
  isIgnored: boolean;
  /**
   * Whether or not the field has the required information to create data in Nutshell
   */
  needsMapping: boolean;
  /**
   * The last 3 submitted values for this field – only relevent for MCFX forms
   */
  exampleValues: McfxFormFragment_wfForm_publishedVersion_fields_exampleValues;
}

export interface McfxFormFragment_wfForm_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of fields associated with this web form version
   */
  fields: McfxFormFragment_wfForm_publishedVersion_fields[];
}

export interface McfxFormFragment_wfForm {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The status of the form
   */
  status: FormStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of mapped fields on this form
   */
  numMappedFields: number;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The version of this form that is published
   */
  publishedVersion: McfxFormFragment_wfForm_publishedVersion | null;
}

export interface McfxFormFragment {
  __typename: "McfxForm";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmission: McfxFormFragment_lastSubmission | null;
  submissions: McfxFormFragment_submissions;
  /**
   * The wf form that this mcfx form is related to.
   */
  wfForm: McfxFormFragment_wfForm | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: WfFieldFragment
// ====================================================

export interface WfFieldFragment_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface WfFieldFragment_exampleValues_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile" | "EntityAttributeValueImage" | "EntityAttributeValueset" | "EntityAttributeValueLocation" | "EntityAttributeValueCurrency" | "EntityAttributeValueDate" | "EntityAttributeValueEmail" | "EntityAttributeValueEnum" | "EntityAttributeValuePhone" | "EntityAttributeValueNumber" | "EntityAttributeValueText" | "EntityAttributeValueUrl";
}

export interface WfFieldFragment_exampleValues_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export type WfFieldFragment_exampleValues_all = WfFieldFragment_exampleValues_all_EntityAttributeValueFile | WfFieldFragment_exampleValues_all_EntityAttributeValueString;

export interface WfFieldFragment_exampleValues {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: WfFieldFragment_exampleValues_all[];
}

export interface WfFieldFragment {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The input name that we received from an MCFX form submission
   */
  inputName: string;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: WfFieldFragment_attribute | null;
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * If a field is ignored, data that it contains will not be transfered into Nutshell entities
   */
  isIgnored: boolean;
  /**
   * Whether or not the field has the required information to create data in Nutshell
   */
  needsMapping: boolean;
  /**
   * The last 3 submitted values for this field – only relevent for MCFX forms
   */
  exampleValues: WfFieldFragment_exampleValues;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: WfFormFragment
// ====================================================

export interface WfFormFragment_mcfxForm {
  __typename: "McfxForm";
  /**
   * A list of unique submission urls
   */
  urls: string[];
}

export interface WfFormFragment_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface WfFormFragment_publishedVersion_fields_exampleValues_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile" | "EntityAttributeValueImage" | "EntityAttributeValueset" | "EntityAttributeValueLocation" | "EntityAttributeValueCurrency" | "EntityAttributeValueDate" | "EntityAttributeValueEmail" | "EntityAttributeValueEnum" | "EntityAttributeValuePhone" | "EntityAttributeValueNumber" | "EntityAttributeValueText" | "EntityAttributeValueUrl";
}

export interface WfFormFragment_publishedVersion_fields_exampleValues_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export type WfFormFragment_publishedVersion_fields_exampleValues_all = WfFormFragment_publishedVersion_fields_exampleValues_all_EntityAttributeValueFile | WfFormFragment_publishedVersion_fields_exampleValues_all_EntityAttributeValueString;

export interface WfFormFragment_publishedVersion_fields_exampleValues {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: WfFormFragment_publishedVersion_fields_exampleValues_all[];
}

export interface WfFormFragment_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The input name that we received from an MCFX form submission
   */
  inputName: string;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: WfFormFragment_publishedVersion_fields_attribute | null;
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * If a field is ignored, data that it contains will not be transfered into Nutshell entities
   */
  isIgnored: boolean;
  /**
   * Whether or not the field has the required information to create data in Nutshell
   */
  needsMapping: boolean;
  /**
   * The last 3 submitted values for this field – only relevent for MCFX forms
   */
  exampleValues: WfFormFragment_publishedVersion_fields_exampleValues;
}

export interface WfFormFragment_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
  /**
   * Array of fields associated with this web form version
   */
  fields: WfFormFragment_publishedVersion_fields[];
}

export interface WfFormFragment_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface WfFormFragment_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface WfFormFragment_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: WfFormFragment_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: WfFormFragment_createRules_contact_audiences[];
}

export interface WfFormFragment_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface WfFormFragment_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: WfFormFragment_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface WfFormFragment_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface WfFormFragment_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface WfFormFragment_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface WfFormFragment_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface WfFormFragment_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface WfFormFragment_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: WfFormFragment_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: WfFormFragment_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: WfFormFragment_createRules_lead_stagesetFieldRules_stageset;
}

export interface WfFormFragment_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: WfFormFragment_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: WfFormFragment_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: WfFormFragment_createRules_lead_stagesetFieldRules[];
}

export interface WfFormFragment_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a contact
   */
  contact: WfFormFragment_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: WfFormFragment_createRules_account | null;
  /**
   * The create rules related to a lead
   */
  lead: WfFormFragment_createRules_lead | null;
}

export interface WfFormFragment_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface WfFormFragment_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface WfFormFragment_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: WfFormFragment_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: WfFormFragment_nextSteps_slackMessage_form;
}

export interface WfFormFragment_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface WfFormFragment_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type WfFormFragment_nextSteps_nutshellNotification_notifiables = WfFormFragment_nextSteps_nutshellNotification_notifiables_NotifiableAlias | WfFormFragment_nextSteps_nutshellNotification_notifiables_User;

export interface WfFormFragment_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface WfFormFragment_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: WfFormFragment_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: WfFormFragment_nextSteps_nutshellNotification_form;
}

export interface WfFormFragment_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: WfFormFragment_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: WfFormFragment_nextSteps_nutshellNotification | null;
}

export interface WfFormFragment {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The status of the form
   */
  status: FormStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of mapped fields on this form
   */
  numMappedFields: number;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The mcfx form that points to this wfForm
   */
  mcfxForm: WfFormFragment_mcfxForm | null;
  /**
   * The version of this form that is published
   */
  publishedVersion: WfFormFragment_publishedVersion | null;
  /**
   * Json representation of create rules for this form
   */
  createRules: WfFormFragment_createRules;
  /**
   * Next step automations for this form
   */
  nextSteps: WfFormFragment_nextSteps;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: WfFormStubFragment
// ====================================================

export interface WfFormStubFragment_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface WfFormStubFragment_publishedVersion_fields_exampleValues_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile" | "EntityAttributeValueImage" | "EntityAttributeValueset" | "EntityAttributeValueLocation" | "EntityAttributeValueCurrency" | "EntityAttributeValueDate" | "EntityAttributeValueEmail" | "EntityAttributeValueEnum" | "EntityAttributeValuePhone" | "EntityAttributeValueNumber" | "EntityAttributeValueText" | "EntityAttributeValueUrl";
}

export interface WfFormStubFragment_publishedVersion_fields_exampleValues_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export type WfFormStubFragment_publishedVersion_fields_exampleValues_all = WfFormStubFragment_publishedVersion_fields_exampleValues_all_EntityAttributeValueFile | WfFormStubFragment_publishedVersion_fields_exampleValues_all_EntityAttributeValueString;

export interface WfFormStubFragment_publishedVersion_fields_exampleValues {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: WfFormStubFragment_publishedVersion_fields_exampleValues_all[];
}

export interface WfFormStubFragment_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The input name that we received from an MCFX form submission
   */
  inputName: string;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: WfFormStubFragment_publishedVersion_fields_attribute | null;
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * If a field is ignored, data that it contains will not be transfered into Nutshell entities
   */
  isIgnored: boolean;
  /**
   * Whether or not the field has the required information to create data in Nutshell
   */
  needsMapping: boolean;
  /**
   * The last 3 submitted values for this field – only relevent for MCFX forms
   */
  exampleValues: WfFormStubFragment_publishedVersion_fields_exampleValues;
}

export interface WfFormStubFragment_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of fields associated with this web form version
   */
  fields: WfFormStubFragment_publishedVersion_fields[];
}

export interface WfFormStubFragment {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The status of the form
   */
  status: FormStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of mapped fields on this form
   */
  numMappedFields: number;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The version of this form that is published
   */
  publishedVersion: WfFormStubFragment_publishedVersion | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadContractFieldFragment
// ====================================================

export interface LeadContractFieldFragment {
  __typename: "DocumentField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  contractId: string | null;
  direction: DocumentFieldDirection;
  type: DocumentFieldType;
  signatureValueType: DocumentSignatureValueType | null;
  label: string;
  placeholder: string | null;
  isRequired: boolean;
  entityName: string | null;
  fieldName: string | null;
  entityAttributeId: string | null;
  /**
   * Raw JSON configuration for this field.
   */
  fieldJson: string | null;
  pageNumber: number | null;
  value: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadContractFragment
// ====================================================

export interface LeadContractFragment_recipientEntity_Contact_primaryAccount_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LeadContractFragment_recipientEntity_Contact_primaryAccount {
  __typename: "ContactAccountsEdge";
  node: LeadContractFragment_recipientEntity_Contact_primaryAccount_node;
}

export interface LeadContractFragment_recipientEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary account edge for this contact
   */
  primaryAccount: LeadContractFragment_recipientEntity_Contact_primaryAccount | null;
}

export interface LeadContractFragment_recipientEntity_Account_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LeadContractFragment_recipientEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary contact for this account
   */
  primaryContact: LeadContractFragment_recipientEntity_Account_primaryContact | null;
}

export type LeadContractFragment_recipientEntity = LeadContractFragment_recipientEntity_Contact | LeadContractFragment_recipientEntity_Account;

export interface LeadContractFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadContractFragment_fields {
  __typename: "DocumentField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  contractId: string | null;
  direction: DocumentFieldDirection;
  type: DocumentFieldType;
  signatureValueType: DocumentSignatureValueType | null;
  label: string;
  placeholder: string | null;
  isRequired: boolean;
  entityName: string | null;
  fieldName: string | null;
  entityAttributeId: string | null;
  /**
   * Raw JSON configuration for this field.
   */
  fieldJson: string | null;
  pageNumber: number | null;
  value: string | null;
}

export interface LeadContractFragment_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  avatarUrl: string;
}

export interface LeadContractFragment {
  __typename: "Contract";
  id: string;
  /**
   * Same-origin URL for this contract PDF.
   */
  pdfDownloadUrl: string | null;
  shareableViewInBrowserLink: string;
  internalViewInBrowserLink: string;
  name: string;
  description: string | null;
  publicSlug: string;
  number: number;
  displayNumber: string;
  displayStatus: ContractDisplayStatus;
  recipientEntity: LeadContractFragment_recipientEntity | null;
  recipientEmailAddress: string | null;
  readyTime: any | null;
  sentTime: any | null;
  acceptedTime: any | null;
  revokedTime: any | null;
  validThroughTime: string | null;
  creatorUserTimezone: string;
  createdTime: any;
  modifiedTime: any | null;
  deletedTime: any | null;
  creatorUser: LeadContractFragment_creatorUser | null;
  fields: LeadContractFragment_fields[];
  lead: LeadContractFragment_lead;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadContractRecipientEntityFragment
// ====================================================

export interface LeadContractRecipientEntityFragment_Contact_primaryAccount_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LeadContractRecipientEntityFragment_Contact_primaryAccount {
  __typename: "ContactAccountsEdge";
  node: LeadContractRecipientEntityFragment_Contact_primaryAccount_node;
}

export interface LeadContractRecipientEntityFragment_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary account edge for this contact
   */
  primaryAccount: LeadContractRecipientEntityFragment_Contact_primaryAccount | null;
}

export interface LeadContractRecipientEntityFragment_Account_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LeadContractRecipientEntityFragment_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary contact for this account
   */
  primaryContact: LeadContractRecipientEntityFragment_Account_primaryContact | null;
}

export type LeadContractRecipientEntityFragment = LeadContractRecipientEntityFragment_Contact | LeadContractRecipientEntityFragment_Account;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContractTemplateFieldFragment
// ====================================================

export interface ContractTemplateFieldFragment {
  __typename: "DocumentField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  direction: DocumentFieldDirection;
  type: DocumentFieldType;
  label: string;
  placeholder: string | null;
  isRequired: boolean;
  entityName: string | null;
  fieldName: string | null;
  entityAttributeId: string | null;
  /**
   * Raw JSON configuration for this field.
   */
  fieldJson: string | null;
  pageNumber: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContractTemplateFragment
// ====================================================

export interface ContractTemplateFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ContractTemplateFragment_fields {
  __typename: "DocumentField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  direction: DocumentFieldDirection;
  type: DocumentFieldType;
  label: string;
  placeholder: string | null;
  isRequired: boolean;
  entityName: string | null;
  fieldName: string | null;
  entityAttributeId: string | null;
  /**
   * Raw JSON configuration for this field.
   */
  fieldJson: string | null;
  pageNumber: number | null;
}

export interface ContractTemplateFragment {
  __typename: "ContractTemplate";
  id: string;
  name: string;
  description: string | null;
  isTemplatePublished: boolean;
  creatorUser: ContractTemplateFragment_creatorUser | null;
  createdTime: any;
  modifiedTime: any | null;
  deletedTime: any | null;
  /**
   * Same-origin URL for the template PDF; requires session auth. Null if none.
   */
  pdfDownloadUrl: string | null;
  numGeneratedDocuments: number | null;
  htmlUrlPath: string;
  isAttachedToQuoteTemplate: boolean;
  lastUsedTime: any | null;
  fields: ContractTemplateFragment_fields[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContractTemplateGeneratedDocFragment
// ====================================================

export interface ContractTemplateGeneratedDocFragment_documents_edges_node_contract_recipientEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
}

export interface ContractTemplateGeneratedDocFragment_documents_edges_node_contract_recipientEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The primary email address for this account
   */
  primaryEmailAddress: string | null;
}

export type ContractTemplateGeneratedDocFragment_documents_edges_node_contract_recipientEntity = ContractTemplateGeneratedDocFragment_documents_edges_node_contract_recipientEntity_Contact | ContractTemplateGeneratedDocFragment_documents_edges_node_contract_recipientEntity_Account;

export interface ContractTemplateGeneratedDocFragment_documents_edges_node_contract_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ContractTemplateGeneratedDocFragment_documents_edges_node_contract_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface ContractTemplateGeneratedDocFragment_documents_edges_node_contract_createdFromTemplate {
  __typename: "ContractTemplate";
  id: string;
  name: string;
  htmlUrlPath: string;
  deletedTime: any | null;
}

export interface ContractTemplateGeneratedDocFragment_documents_edges_node_contract {
  __typename: "Contract";
  id: string;
  name: string;
  shareableViewInBrowserLink: string;
  internalViewInBrowserLink: string;
  displayNumber: string;
  displayStatus: ContractDisplayStatus;
  createdTime: any;
  modifiedTime: any | null;
  readyTime: any | null;
  sentTime: any | null;
  acceptedTime: any | null;
  revokedTime: any | null;
  deletedTime: any | null;
  /**
   * Url path to this specific contract attached to a lead
   */
  leadContractUrl: string | null;
  recipientEntity: ContractTemplateGeneratedDocFragment_documents_edges_node_contract_recipientEntity | null;
  creatorUser: ContractTemplateGeneratedDocFragment_documents_edges_node_contract_creatorUser | null;
  lead: ContractTemplateGeneratedDocFragment_documents_edges_node_contract_lead;
  createdFromTemplate: ContractTemplateGeneratedDocFragment_documents_edges_node_contract_createdFromTemplate | null;
}

export interface ContractTemplateGeneratedDocFragment_documents_edges_node_quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface ContractTemplateGeneratedDocFragment_documents_edges_node {
  __typename: "EnvelopeDocument";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  documentType: EnvelopeDocumentType;
  contract: ContractTemplateGeneratedDocFragment_documents_edges_node_contract | null;
  quote: ContractTemplateGeneratedDocFragment_documents_edges_node_quote | null;
}

export interface ContractTemplateGeneratedDocFragment_documents_edges {
  __typename: "EnvelopeDocumentsEdge";
  node: ContractTemplateGeneratedDocFragment_documents_edges_node;
}

export interface ContractTemplateGeneratedDocFragment_documents {
  __typename: "EnvelopeDocumentsConnection";
  /**
   * A list of edges.
   */
  edges: ContractTemplateGeneratedDocFragment_documents_edges[];
}

export interface ContractTemplateGeneratedDocFragment {
  __typename: "Envelope";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  documents: ContractTemplateGeneratedDocFragment_documents;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AccountForCoreEntityFragment
// ====================================================

export interface AccountForCoreEntityFragment_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface AccountForCoreEntityFragment_postalAddresses_primary {
  __typename: "PostalAddress";
  location: AccountForCoreEntityFragment_postalAddresses_primary_location;
}

export interface AccountForCoreEntityFragment_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountForCoreEntityFragment_postalAddresses_primary | null;
}

export interface AccountForCoreEntityFragment_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface AccountForCoreEntityFragment_phones_primary {
  __typename: "Phone";
  value: AccountForCoreEntityFragment_phones_primary_value;
}

export interface AccountForCoreEntityFragment_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountForCoreEntityFragment_phones_primary | null;
}

export interface AccountForCoreEntityFragment {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: AccountForCoreEntityFragment_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: AccountForCoreEntityFragment_phones;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContactForCoreEntityFragment
// ====================================================

export interface ContactForCoreEntityFragment_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface ContactForCoreEntityFragment_phones_primary {
  __typename: "Phone";
  value: ContactForCoreEntityFragment_phones_primary_value;
}

export interface ContactForCoreEntityFragment_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: ContactForCoreEntityFragment_phones_primary | null;
}

export interface ContactForCoreEntityFragment {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: ContactForCoreEntityFragment_phones;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CoreEntityDeletedEventFragment
// ====================================================

export interface CoreEntityDeletedEventFragment_deletedEvent_actor_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface CoreEntityDeletedEventFragment_deletedEvent_actor_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CoreEntityDeletedEventFragment_deletedEvent_actor_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface CoreEntityDeletedEventFragment_deletedEvent_actor_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface CoreEntityDeletedEventFragment_deletedEvent_actor_Form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
}

export interface CoreEntityDeletedEventFragment_deletedEvent_actor_MaUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type CoreEntityDeletedEventFragment_deletedEvent_actor = CoreEntityDeletedEventFragment_deletedEvent_actor_User | CoreEntityDeletedEventFragment_deletedEvent_actor_Origin | CoreEntityDeletedEventFragment_deletedEvent_actor_Contact | CoreEntityDeletedEventFragment_deletedEvent_actor_Account | CoreEntityDeletedEventFragment_deletedEvent_actor_Form | CoreEntityDeletedEventFragment_deletedEvent_actor_MaUrl;

export interface CoreEntityDeletedEventFragment_deletedEvent {
  __typename: "TimelineEvent";
  changeTime: any;
  /**
   * The entity that triggered the change_log entry
   */
  actor: CoreEntityDeletedEventFragment_deletedEvent_actor;
}

export interface CoreEntityDeletedEventFragment {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The change log entry for this entity’s soft delete, including actor and timestamp.
   */
  deletedEvent: CoreEntityDeletedEventFragment_deletedEvent | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CoreEntityOriginFragment
// ====================================================

export interface CoreEntityOriginFragment {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  originType: OriginType;
  isInteresting: boolean;
  htmlUrl: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CoreEntityTaskFragment
// ====================================================

export interface CoreEntityTaskFragment_delayApplications_delay {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the delay
   */
  name: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface CoreEntityTaskFragment_delayApplications_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CoreEntityTaskFragment_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * An optional note about the delay application
   */
  note: string | null;
  /**
   * The time when the delay was applied
   */
  appliedTime: any;
  /**
   * The delay that was applied
   */
  delay: CoreEntityTaskFragment_delayApplications_delay;
  /**
   * The user who applied the delay
   */
  user: CoreEntityTaskFragment_delayApplications_user | null;
}

export interface CoreEntityTaskFragment_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CoreEntityTaskFragment_completedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CoreEntityTaskFragment_relatedEntity {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CoreEntityTaskFragment_creatorEntity_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface CoreEntityTaskFragment_creatorEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export type CoreEntityTaskFragment_creatorEntity = CoreEntityTaskFragment_creatorEntity_Chat | CoreEntityTaskFragment_creatorEntity_Activity;

export interface CoreEntityTaskFragment_assigner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CoreEntityTaskFragment_recurrenceRule {
  __typename: "RecurrenceRule";
  mode: RecurrenceMode;
  /**
   * An RRULE-compatible string defining the recurrence pattern (e.g. "FREQ=WEEKLY;BYDAY=MO").
   */
  rule: string;
}

export interface CoreEntityTaskFragment {
  __typename: "Task";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the task
   */
  title: string;
  /**
   * The canonical API href for the task
   */
  href: string;
  /**
   * The task’s user-defined description
   */
  description: string | null;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: CoreEntityTaskFragment_delayApplications[];
  /**
   * The due timestamp of the task
   */
  dueTime: any | null;
  /**
   * The person or team assigned to this task
   */
  assignee: CoreEntityTaskFragment_assignee | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  completedTime: any | null;
  /**
   * Can the task be completed?
   */
  canBeCompleted: boolean;
  /**
   * Is this task completed?
   */
  isCompleted: boolean;
  /**
   * The user who completed the task
   */
  completedByUser: CoreEntityTaskFragment_completedByUser | null;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Whether the tasks due date is later than the current date
   */
  isOverdue: boolean;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  relatedEntity: CoreEntityTaskFragment_relatedEntity | null;
  /**
   * The DateTime that represents when the Activity record was created
   */
  createdTime: any;
  /**
   * The task's linkified description with URLs converted to clickable links
   */
  linkifiedDescription: string | null;
  isAiGenerated: boolean;
  creatorEntity: CoreEntityTaskFragment_creatorEntity | null;
  /**
   * The user who assigned the task
   */
  assigner: CoreEntityTaskFragment_assigner | null;
  /**
   * The time the task was assigned
   */
  assignedTime: any | null;
  /**
   * Number of days between follow-up reminders. Null if the task is not recurring.
   */
  recurringPeriod: number | null;
  /**
   * Whether this task is the current user recurring follow-up reminder.
   */
  isRecurringForUser: boolean;
  /**
   * Null if the task does not recur under the new recurrence system.
   */
  recurrenceRule: CoreEntityTaskFragment_recurrenceRule | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CoreEntityTaskStepSharedFragment
// ====================================================

export interface CoreEntityTaskStepSharedFragment_delayApplications_delay {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the delay
   */
  name: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface CoreEntityTaskStepSharedFragment_delayApplications_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CoreEntityTaskStepSharedFragment_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * An optional note about the delay application
   */
  note: string | null;
  /**
   * The time when the delay was applied
   */
  appliedTime: any;
  /**
   * The delay that was applied
   */
  delay: CoreEntityTaskStepSharedFragment_delayApplications_delay;
  /**
   * The user who applied the delay
   */
  user: CoreEntityTaskStepSharedFragment_delayApplications_user | null;
}

export interface CoreEntityTaskStepSharedFragment_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CoreEntityTaskStepSharedFragment_completedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CoreEntityTaskStepSharedFragment_relatedEntity {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CoreEntityTaskStepSharedFragment {
  __typename: "Task" | "Step";
  /**
   * The API ID
   */
  id: string;
  /**
   * The name/title of the task
   */
  title: string;
  /**
   * The canonical API href for the task
   */
  href: string;
  /**
   * The task's user-defined description
   */
  description: string | null;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: CoreEntityTaskStepSharedFragment_delayApplications[];
  /**
   * The due timestamp of the task
   */
  dueTime: any | null;
  /**
   * The person or team assigned to this task
   */
  assignee: CoreEntityTaskStepSharedFragment_assignee | null;
  /**
   * The DateTime that represents when the task was deleted
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the task was completed
   */
  completedTime: any | null;
  /**
   * Can the step be completed?
   */
  canBeCompleted: boolean;
  /**
   * Is this task completed?
   */
  isCompleted: boolean;
  /**
   * The user who completed the task
   */
  completedByUser: CoreEntityTaskStepSharedFragment_completedByUser | null;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Whether the tasks due date is later than the current date
   */
  isOverdue: boolean;
  /**
   * The entity that this task exists on
   */
  relatedEntity: CoreEntityTaskStepSharedFragment_relatedEntity | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FileFragment
// ====================================================

export interface FileFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface FileFragment {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * The user who uploaded the file
   */
  creatorUser: FileFragment_creatorUser | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: HeaderFieldFragment
// ====================================================

export interface HeaderFieldFragment {
  __typename: "HeaderField";
  /**
   * The type of the header field
   */
  type: HeaderFieldType;
  /**
   * Whether the header field is enabled
   */
  isEnabled: boolean;
  /**
   * The name of the header field
   */
  name: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: TagFragment
// ====================================================

export interface TagFragment_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface TagFragment {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: TagFragment_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: TaskRecurrenceRuleFragment
// ====================================================

export interface TaskRecurrenceRuleFragment {
  __typename: "RecurrenceRule";
  mode: RecurrenceMode;
  /**
   * An RRULE-compatible string defining the recurrence pattern (e.g. "FREQ=WEEKLY;BYDAY=MO").
   */
  rule: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: WidgetFragmentFull
// ====================================================

export interface WidgetFragmentFull_OtherWidget {
  __typename: "OtherWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  /**
   * Whether the widget is required
   */
  isRequired: boolean;
  /**
   * Whether the widget is editable
   */
  isEditable: boolean;
  isDisabledByAdmin: boolean;
}

export interface WidgetFragmentFull_CustomCustomFieldsWidget_customCustomFields_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable type of the attribute
   */
  displayType: string;
}

export interface WidgetFragmentFull_CustomCustomFieldsWidget_customCustomFields {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: WidgetFragmentFull_CustomCustomFieldsWidget_customCustomFields_attribute;
}

export interface WidgetFragmentFull_CustomCustomFieldsWidget {
  __typename: "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  /**
   * Whether the widget is required
   */
  isRequired: boolean;
  /**
   * Whether the widget is editable
   */
  isEditable: boolean;
  isDisabledByAdmin: boolean;
  /**
   * The custom fields of the widget that can be customized
   */
  customCustomFields: WidgetFragmentFull_CustomCustomFieldsWidget_customCustomFields[];
}

export type WidgetFragmentFull = WidgetFragmentFull_OtherWidget | WidgetFragmentFull_CustomCustomFieldsWidget;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: WidgetFragment
// ====================================================

export interface WidgetFragment {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ActivityForWidgetFragment
// ====================================================

export interface ActivityForWidgetFragment_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface ActivityForWidgetFragment_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ActivityForWidgetFragment_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
  primaryEmailAddress: string | null;
  primaryPhoneNumber: string | null;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface ActivityForWidgetFragment {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: ActivityForWidgetFragment_activityType;
  /**
   * The DateTime that represents the start time of the Activity record
   */
  startTime: any;
  /**
   * The DateTime that represents the end time of the Activity record
   */
  endTime: any;
  /**
   * The boolean that represents whether or not the Activity represents an all day calendar event
   */
  isAllDay: boolean;
  /**
   * The boolean that represents whether or not the Activity is overdue.
   * Specifically, this means that the activity is not logged, and is in the past.
   */
  isOverdue: boolean;
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: ActivityForWidgetFragment_externalMeeting | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: ActivityForWidgetFragment_participants[];
  /**
   * Whether the activity is private.
   */
  isPrivate: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: DripProgressionEditionsFragment
// ====================================================

export interface DripProgressionEditionsFragment_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DripProgressionEditionsFragment_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface DripProgressionEditionsFragment_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The URL that this edition links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  scheduledTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: DripProgressionEditionsFragment_edition_emailTemplate | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: DripProgressionEditionsFragment_edition_delay | null;
}

export interface DripProgressionEditionsFragment {
  __typename: "DripProgressionEdition";
  /**
   * Whether this edition has been sent
   */
  sent: boolean;
  /**
   * The edition
   */
  edition: DripProgressionEditionsFragment_edition;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: DripProgressionFragment
// ====================================================

export interface DripProgressionFragment_currentNode {
  __typename: "SmartSequenceNode";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DripProgressionFragment_campaign_startTrigger {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface DripProgressionFragment_campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this goal. This is essentially just the stringified
   * version of the goal’s conditions, but because a goal can have multiple
   * conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface DripProgressionFragment_campaign_from_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DripProgressionFragment_campaign_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: DripProgressionFragment_campaign_from_creatorUser | null;
}

export interface DripProgressionFragment_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * When a lead is closed, should drip sequences stop?
   */
  isStopOnLeadClose: boolean;
  /**
   * The start trigger for the drip sequence
   */
  startTrigger: DripProgressionFragment_campaign_startTrigger | null;
  /**
   * The newly created Nutshell goal
   */
  goal: DripProgressionFragment_campaign_goal | null;
  /**
   * The address to send this edition from
   */
  from: DripProgressionFragment_campaign_from | null;
}

export interface DripProgressionFragment_editions_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DripProgressionFragment_editions_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface DripProgressionFragment_editions_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The URL that this edition links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  scheduledTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: DripProgressionFragment_editions_edition_emailTemplate | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: DripProgressionFragment_editions_edition_delay | null;
}

export interface DripProgressionFragment_editions {
  __typename: "DripProgressionEdition";
  /**
   * Whether this edition has been sent
   */
  sent: boolean;
  /**
   * The edition
   */
  edition: DripProgressionFragment_editions_edition;
}

export interface DripProgressionFragment {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * When this drip progression was created (when the contact entered the sequence)
   */
  createdTime: any;
  /**
   * When this progression stopped, or null if it is still active
   */
  stoppedTime: any | null;
  /**
   * Why this progression stopped, or null if it is still active
   */
  stoppedReason: DripProgressionStoppedReason | null;
  /**
   * The graph node this progression is currently on, if any. Null for legacy drip
   * progressions and for smart progressions without a current node.
   */
  currentNode: DripProgressionFragment_currentNode | null;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
  /**
   * Number of editions that have been sent so far for this progression. NOTE: This
   * can be inaccurate if editions are reordered or an edition is added to the
   * start of the drip after a progression has started. This is ok! We want this
   * number to represent the number of prior active editions, even if they aren’t always sent.
   */
  numEditionsSent: number;
  /**
   * The drip sequence for this drip progressions
   */
  campaign: DripProgressionFragment_campaign;
  /**
   * All editions in the drip sequence for this drip progression, in send order
   */
  editions: DripProgressionFragment_editions[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailAutomationStatusesFragment
// ====================================================

export interface EmailAutomationStatusesFragment_sender_sendableEmailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
}

export interface EmailAutomationStatusesFragment_sender {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * List of successfully enabled user email addresses that a user is able to send emails from Nutshell with.
   */
  sendableEmailAddresses: EmailAutomationStatusesFragment_sender_sendableEmailAddresses[];
}

export interface EmailAutomationStatusesFragment_companyName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
}

export interface EmailAutomationStatusesFragment_firstName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
}

export interface EmailAutomationStatusesFragment_lastName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
}

export interface EmailAutomationStatusesFragment_lead_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EmailAutomationStatusesFragment_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  name: string;
}

export interface EmailAutomationStatusesFragment_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: EmailAutomationStatusesFragment_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface EmailAutomationStatusesFragment_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: EmailAutomationStatusesFragment_lead_contacts_primaryEdge_node_emailAddresses;
}

export interface EmailAutomationStatusesFragment_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: EmailAutomationStatusesFragment_lead_contacts_primaryEdge_node;
}

export interface EmailAutomationStatusesFragment_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EmailAutomationStatusesFragment_lead_contacts_primaryEdge | null;
}

export interface EmailAutomationStatusesFragment_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: EmailAutomationStatusesFragment_lead_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: EmailAutomationStatusesFragment_lead_contacts;
}

export interface EmailAutomationStatusesFragment_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface EmailAutomationStatusesFragment_emailAutomation_exitsStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface EmailAutomationStatusesFragment_emailAutomation_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface EmailAutomationStatusesFragment_emailAutomation_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface EmailAutomationStatusesFragment_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: EmailAutomationStatusesFragment_emailAutomation_entersStage;
  /**
   * The stage in which this stage subscription ends.
   */
  exitsStage: EmailAutomationStatusesFragment_emailAutomation_exitsStage | null;
  /**
   * Indicates if a lead should receive emails from this subscription until it closes.
   */
  sendUntilClose: boolean;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: EmailAutomationStatusesFragment_emailAutomation_delay | null;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: EmailAutomationStatusesFragment_emailAutomation_emailList | null;
}

export interface EmailAutomationStatusesFragment_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
}

export interface EmailAutomationStatusesFragment_emailSequence_emailsQueued_fromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EmailAutomationStatusesFragment_emailSequence_emailsQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EmailAutomationStatusesFragment_emailSequence_emailsQueued_to {
  __typename: "NutEmailAddress";
  avatarEntity: EmailAutomationStatusesFragment_emailSequence_emailsQueued_to_avatarEntity | null;
}

export interface EmailAutomationStatusesFragment_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The current status of this queued email.
   */
  status: EmailQueuedStatus;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  fromUser: EmailAutomationStatusesFragment_emailSequence_emailsQueued_fromUser | null;
  to: EmailAutomationStatusesFragment_emailSequence_emailsQueued_to[];
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
}

export interface EmailAutomationStatusesFragment_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EmailAutomationStatusesFragment_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The next message to be sent
   */
  nextUnsentEmail: EmailAutomationStatusesFragment_emailSequence_nextUnsentEmail | null;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  /**
   * The number of emails that have been sent
   */
  sentEmailsCount: number;
  emailsQueued: EmailAutomationStatusesFragment_emailSequence_emailsQueued[];
  emailSequenceTemplate: EmailAutomationStatusesFragment_emailSequence_emailSequenceTemplate | null;
  /**
   * True if this sequence has only one email
   */
  isSingleEmailSequence: boolean;
}

export interface EmailAutomationStatusesFragment {
  __typename: "EmailAutomationStatus";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that either did send this automation, or current _would_ send this
   * automation given the current context. For example, if the user is assigned to
   * a team, the logged in user is considered a potential sender if they’re on that team
   */
  sender: EmailAutomationStatusesFragment_sender | null;
  /**
   * The total number of messages in the sequence for this status
   */
  unsentMessageCount: number | null;
  /**
   * Is this automation status paused?
   */
  isPaused: boolean;
  /**
   * Can this status be started
   */
  canStart: boolean;
  /**
   * Can this status be cancelled
   */
  canCancel: boolean;
  /**
   * The message to show to the user
   */
  status: EmailAutomationStatusStatus;
  /**
   * Status of the company name field
   */
  companyName: EmailAutomationStatusesFragment_companyName;
  /**
   * Status of the first name field
   */
  firstName: EmailAutomationStatusesFragment_firstName;
  /**
   * Status of the last name field
   */
  lastName: EmailAutomationStatusesFragment_lastName;
  /**
   * Lead associated with this status row
   */
  lead: EmailAutomationStatusesFragment_lead;
  /**
   * Email list stage subscription associated with this status row
   */
  emailAutomation: EmailAutomationStatusesFragment_emailAutomation;
  /**
   * The actual email sequence going out for this lead in this stage
   */
  emailSequence: EmailAutomationStatusesFragment_emailSequence | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailSequenceFragmentSparse
// ====================================================

export interface EmailSequenceFragmentSparse_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
}

export interface EmailSequenceFragmentSparse_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EmailSequenceFragmentSparse {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The next message to be sent
   */
  nextUnsentEmail: EmailSequenceFragmentSparse_nextUnsentEmail | null;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  /**
   * The number of emails that have been sent
   */
  sentEmailsCount: number;
  emailSequenceTemplate: EmailSequenceFragmentSparse_emailSequenceTemplate | null;
  /**
   * True if this sequence has only one email
   */
  isSingleEmailSequence: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailSequenceFragment
// ====================================================

export interface EmailSequenceFragment_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
}

export interface EmailSequenceFragment_emailsQueued_fromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EmailSequenceFragment_emailsQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EmailSequenceFragment_emailsQueued_to {
  __typename: "NutEmailAddress";
  avatarEntity: EmailSequenceFragment_emailsQueued_to_avatarEntity | null;
}

export interface EmailSequenceFragment_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The current status of this queued email.
   */
  status: EmailQueuedStatus;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  fromUser: EmailSequenceFragment_emailsQueued_fromUser | null;
  to: EmailSequenceFragment_emailsQueued_to[];
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
}

export interface EmailSequenceFragment_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EmailSequenceFragment {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The next message to be sent
   */
  nextUnsentEmail: EmailSequenceFragment_nextUnsentEmail | null;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  /**
   * The number of emails that have been sent
   */
  sentEmailsCount: number;
  emailsQueued: EmailSequenceFragment_emailsQueued[];
  emailSequenceTemplate: EmailSequenceFragment_emailSequenceTemplate | null;
  /**
   * True if this sequence has only one email
   */
  isSingleEmailSequence: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: QueuedEmailFragmentSparse
// ====================================================

export interface QueuedEmailFragmentSparse_fromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface QueuedEmailFragmentSparse_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface QueuedEmailFragmentSparse_to {
  __typename: "NutEmailAddress";
  avatarEntity: QueuedEmailFragmentSparse_to_avatarEntity | null;
}

export interface QueuedEmailFragmentSparse {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The current status of this queued email.
   */
  status: EmailQueuedStatus;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  fromUser: QueuedEmailFragmentSparse_fromUser | null;
  to: QueuedEmailFragmentSparse_to[];
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: WidgetCollapsedFragment
// ====================================================

export interface WidgetCollapsedFragment {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ConstantContactEmailCampaignActivityPreview
// ====================================================

export interface ConstantContactEmailCampaignActivityPreview {
  __typename: "ConstantContactEmailCampaignActivityPreview";
  campaignActivityId: string;
  fromEmail: string;
  fromName: string;
  preheader: string;
  previewHtmlContent: string;
  previewTextContent: string;
  replyToEmail: string;
  subject: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FromAddress
// ====================================================

export interface FromAddress_emailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface FromAddress_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface FromAddress {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: FromAddress_emailAddress;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: FromAddress_fromDomain | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CustomFieldEdgeFragment
// ====================================================

export interface CustomFieldEdgeFragment_value_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates | null;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type CustomFieldEdgeFragment_value_EntityAttributeValueset_all = CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueset | CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueString | CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueText | CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueEnum | CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueDate | CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueEmail | CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValuePhone | CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueLocation | CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueFile | CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueCurrency | CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueImage | CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueUrl | CustomFieldEdgeFragment_value_EntityAttributeValueset_all_EntityAttributeValueNumber;

export interface CustomFieldEdgeFragment_value_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: CustomFieldEdgeFragment_value_EntityAttributeValueset_all[];
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: CustomFieldEdgeFragment_value_EntityAttributeValueLocation_coordinates | null;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: CustomFieldEdgeFragment_value_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: CustomFieldEdgeFragment_value_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: CustomFieldEdgeFragment_value_EntityAttributeValueCurrency_currencyValue;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface CustomFieldEdgeFragment_value_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type CustomFieldEdgeFragment_value = CustomFieldEdgeFragment_value_EntityAttributeValueString | CustomFieldEdgeFragment_value_EntityAttributeValueText | CustomFieldEdgeFragment_value_EntityAttributeValueEnum | CustomFieldEdgeFragment_value_EntityAttributeValueDate | CustomFieldEdgeFragment_value_EntityAttributeValueset | CustomFieldEdgeFragment_value_EntityAttributeValueEmail | CustomFieldEdgeFragment_value_EntityAttributeValuePhone | CustomFieldEdgeFragment_value_EntityAttributeValueLocation | CustomFieldEdgeFragment_value_EntityAttributeValueFile | CustomFieldEdgeFragment_value_EntityAttributeValueCurrency | CustomFieldEdgeFragment_value_EntityAttributeValueImage | CustomFieldEdgeFragment_value_EntityAttributeValueUrl | CustomFieldEdgeFragment_value_EntityAttributeValueNumber;

export interface CustomFieldEdgeFragment_node_EntityAttributeBase_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface CustomFieldEdgeFragment_node_EntityAttributeBase {
  __typename: "EntityAttributeBase";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: CustomFieldEdgeFragment_node_EntityAttributeBase_attribute;
}

export interface CustomFieldEdgeFragment_node_EntityAttributeEnum_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface CustomFieldEdgeFragment_node_EntityAttributeEnum_options {
  __typename: "EnumOption";
  /**
   * The name (and primary identifier) of the enum option.
   */
  id: string;
  /**
   * The name (and display) of the enum option.
   */
  name: string;
}

export interface CustomFieldEdgeFragment_node_EntityAttributeEnum {
  __typename: "EntityAttributeEnum";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: CustomFieldEdgeFragment_node_EntityAttributeEnum_attribute;
  /**
   * Enum options for this field
   */
  options: CustomFieldEdgeFragment_node_EntityAttributeEnum_options[];
  /**
   * Does this enum field allow multiple selections. I.e. can the value of "Favorite Color" be "Red" AND "Blue"?
   */
  allowMultiple: boolean;
}

export interface CustomFieldEdgeFragment_node_EntityAttributeCurrency_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface CustomFieldEdgeFragment_node_EntityAttributeCurrency {
  __typename: "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: CustomFieldEdgeFragment_node_EntityAttributeCurrency_attribute;
  /**
   * Available currency options for this field
   */
  currencyOptions: string[];
  /**
   * Default currency for this field
   */
  defaultCurrency: string;
}

export type CustomFieldEdgeFragment_node = CustomFieldEdgeFragment_node_EntityAttributeBase | CustomFieldEdgeFragment_node_EntityAttributeEnum | CustomFieldEdgeFragment_node_EntityAttributeCurrency;

export interface CustomFieldEdgeFragment {
  __typename: "CustomFieldsEdge";
  /**
   * Value of this custom field for this entity.
   */
  value: CustomFieldEdgeFragment_value | null;
  node: CustomFieldEdgeFragment_node;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InstanceInfo
// ====================================================

export interface InstanceInfo {
  __typename: "Instance";
  /**
   * The id for the specific Nutshell instance.
   */
  instanceId: string | null;
  /**
   * Is this a pro instance?
   */
  isPro: boolean;
  /**
   * Is this a Nutshell trial?
   */
  isTrial: boolean;
  companyName: string;
  /**
   * Has this instance configured any Nutshell email automations?
   */
  hasConfiguredNutshellEmailAutomations: boolean;
  /**
   * Does this instance have an active landing pages plan?
   */
  hasLandingPages: boolean;
  /**
   * The string version of the WebFX site ID.
   */
  webfxSiteId: string | null;
  /**
   * Is the billing cycle deprecated?
   */
  hasDeprecatedBillingCycle: boolean | null;
  /**
   * Days left in trial
   */
  daysLeftInTrial: number | null;
  /**
   * Is billing managed by WebFX?
   */
  isBillingManagedByWebfx: boolean | null;
  /**
   * The type of scheduler access this instance has.
   */
  schedulerAccessType: SchedulerAccessType;
  /**
   * Date the Nutshell instance was created (YYYY-M-D)
   */
  inceptionDate: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SessionUser
// ====================================================

export interface SessionUser_sendableEmailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The address string of this email.
   */
  address: string;
  formatted: string;
  /**
   * Is email sync enabled for this address? When the user is sending follow-ups,
   * for example, it’s nice to warn them if sync is not enabled
   */
  isSyncEnabled: boolean;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
}

export interface SessionUser_emailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The address string of this email.
   */
  address: string;
  formatted: string;
  /**
   * Is email sync enabled for this address? When the user is sending follow-ups,
   * for example, it’s nice to warn them if sync is not enabled
   */
  isSyncEnabled: boolean;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
}

export interface SessionUser_permissions {
  __typename: "UserPermissionBooleans";
  canAccessSetup: boolean;
  canAccessMarketing: boolean;
  canBulkEdit: boolean;
  canExport: boolean;
  canViewSharedEmails: boolean;
  canImport: boolean;
  canMergeEntities: boolean;
  canDeleteEntities: boolean;
  canAssignEntities: boolean;
  canAccessBilling: boolean;
  canViewAllMeetings: boolean;
  canManageEmailTemplates: boolean;
  canAccessCrm: boolean;
  canAccessFullCampaigns: boolean;
  canUseInbox: boolean;
  canUseSms: boolean;
  canUseOrTryInbox: boolean;
  canUseSalesDocuments: boolean;
  canDeleteNotesAndActivities: boolean;
}

export interface SessionUser_zoomIntegration {
  __typename: "ZoomIntegration";
  /**
   * Whether or not the zoom integration is enabled
   */
  isEnabled: boolean;
}

export interface SessionUser_googleMeetIntegration {
  __typename: "GoogleMeetIntegration";
  /**
   * Whether or not the  Google Meet integration is enabled with calendar sync
   */
  isEnabledCalendarSync: boolean;
  /**
   * Whether or not the Google Meet integration is enabled with meet sync
   */
  isEnabledMeetSync: boolean;
}

export interface SessionUser_microsoftTeamsIntegration {
  __typename: "MicrosoftTeamsIntegration";
  /**
   * Whether or not the  Microsoft Teams integration is enabled
   */
  isEnabled: boolean;
}

export interface SessionUser_widgetsCollapsedState {
  __typename: "WidgetsCollapsedState";
  /**
   * Lead sales documents section widget state
   */
  leadSalesDocuments: boolean;
  /**
   * Lead companies and people section widget state
   */
  leadCompaniesAndPeople: boolean;
  /**
   * Lead products section widget state
   */
  leadProducts: boolean;
  /**
   * Lead channels and sources section widget state
   */
  leadChannelsAndSources: boolean;
  /**
   * Lead pipeline section widget state
   */
  leadPipeline: boolean;
  /**
   * Top custom fields section widget state
   */
  leadTopCustomFields: boolean;
  /**
   * Custom fields section widget state
   */
  leadCustomFields: boolean;
  /**
   * Competitors section widget state
   */
  leadCompetitors: boolean;
  /**
   * Attachments section widget state
   */
  leadAttachments: boolean;
  /**
   * Scheduled activities section widget state
   */
  leadScheduledActivities: boolean;
  /**
   * Logged activities section widget state
   */
  leadLoggedActivities: boolean;
  /**
   * Upcoming tasks section widget state
   */
  leadUpcomingTasks: boolean;
  /**
   * Future tasks section widget state
   */
  leadFutureTasks: boolean;
  /**
   * Completed tasks section widget state
   */
  leadCompletedTasks: boolean;
  /**
   * Drip sequences section widget state
   */
  leadDripSequences: boolean;
  /**
   * Personal email sequences section widget state
   */
  leadPersonalEmailSequences: boolean;
}

export interface SessionUser_phoneIntegrations_integration {
  __typename: "Integration";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Indicates whether the integration is currently enabled
   */
  isEnabled: boolean;
  /**
   * Indicates whether the integration has been validated
   */
  isValidated: boolean;
}

export interface SessionUser_phoneIntegrations_defaultCallsActivityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface SessionUser_phoneIntegrations_defaultVoicemailsActivityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface SessionUser_phoneIntegrations_phoneNumberAssignments_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SessionUser_phoneIntegrations_phoneNumberAssignments {
  __typename: "CallRailPhoneNumberAssignment";
  /**
   * The CallRail tracking phone number in E.164 format.
   */
  phoneNumber: string;
  /**
   * Display-formatted version of the tracking phone number.
   */
  formattedPhoneNumber: string;
  /**
   * The Nutshell user the phone number is assigned to. Null if the user has been deleted.
   */
  user: SessionUser_phoneIntegrations_phoneNumberAssignments_user | null;
}

export interface SessionUser_phoneIntegrations {
  __typename: "PhoneIntegration";
  /**
   * If the current user has enabled and set up credentials for this specific integration
   */
  isEnabledForUser: boolean;
  /**
   * The integration object for those types that have an instance-wide integration.
   * Null for user-specific phone integration types.
   */
  integration: SessionUser_phoneIntegrations_integration | null;
  /**
   * The type of integration
   */
  integrationType: ExternalServiceType;
  /**
   * Unique Identifier for the user in the external system
   */
  externalUserIdentifier: string | null;
  /**
   * Additional information about the integration
   */
  tertiaryInformation: string | null;
  /**
   * The default activity type for calls from this integration
   */
  defaultCallsActivityType: SessionUser_phoneIntegrations_defaultCallsActivityType;
  /**
   * The default activity type for voicemails from this integration
   */
  defaultVoicemailsActivityType: SessionUser_phoneIntegrations_defaultVoicemailsActivityType;
  /**
   * True if the current user can sync previous calls for this integration
   */
  canSyncPreviousCalls: boolean;
  /**
   * True if the current user is performing an initial sync for this integration
   */
  isPerformingInitialSync: boolean;
  /**
   * CallRail-specific. Map of tracking phone numbers to the Nutshell users they
   * are assigned to. Empty for other integration types.
   */
  phoneNumberAssignments: SessionUser_phoneIntegrations_phoneNumberAssignments[];
}

export interface SessionUser_clickToCallIntegration_defaultCallsActivityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
  /**
   * Whether this activity type is immutable
   */
  isImmutable: boolean;
}

export interface SessionUser_clickToCallIntegration_defaultVoicemailsActivityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
  /**
   * Whether this activity type is immutable
   */
  isImmutable: boolean;
}

export interface SessionUser_clickToCallIntegration {
  __typename: "ClickToCallIntegration";
  /**
   * The type of integration
   */
  integrationType: ExternalServiceType;
  /**
   * If the current user has a validated phone number and caller ID for ClickToCall
   */
  isEnabled: boolean;
  /**
   * The phone number the user has configured for ClickToCall
   */
  phoneNumber: string | null;
  /**
   * The caller ID the user has configured for ClickToCall
   */
  callerId: string | null;
  /**
   * The activity type that will be used when activities are created for click-to-call phone calls
   */
  defaultCallsActivityType: SessionUser_clickToCallIntegration_defaultCallsActivityType | null;
  /**
   * The activity type that will be used when activities are created for click-to-call voicemails
   */
  defaultVoicemailsActivityType: SessionUser_clickToCallIntegration_defaultVoicemailsActivityType | null;
}

export interface SessionUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  firstName: string | null;
  lastName: string | null;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
  /**
   * Is this user an administrator
   */
  isAdministrator: boolean;
  /**
   * Is this user a support user
   */
  isSupport: boolean;
  /**
   * The user’s configured timezone
   */
  timezone: string;
  /**
   * List of successfully enabled user email addresses that a user is able to send emails from Nutshell with.
   */
  sendableEmailAddresses: SessionUser_sendableEmailAddresses[];
  /**
   * User emails configured for this user
   */
  emailAddresses: SessionUser_emailAddresses[];
  /**
   * Full email signature for this user. Currently using base64 encoded images, so we can just send back a string
   */
  emailSignature: string | null;
  /**
   * Is this user tracking email clicks/views
   */
  isEmailTrackingEnabled: boolean;
  /**
   * Is this user hiding timeline email interactions
   */
  isExcludingTimelineInteractions: boolean;
  /**
   * Is this user hiding timeline outreach events
   */
  isExcludingTimelineOutreach: boolean;
  /**
   * Is this user hiding timeline customer journeys
   */
  isExcludingTimelineCustomerJourneys: boolean;
  /**
   * Should we show the confirmation popover before unlocking a company
   */
  hasDismissedCompanyUnlockConfirmation: boolean;
  /**
   * Should we show the scheduler promotion component on activities list
   */
  hasDismissedSchedulerPromotion: boolean;
  /**
   * Should we show the scheduler onboarding modal on scheduler page
   */
  hasViewedSchedulerOnboardingModal: boolean;
  dismissedSettings: string[];
  completedWizards: string[];
  /**
   * The user’s configured root meeting URL for scheduler
   */
  schedulerRootMeetingsUrl: string;
  /**
   * The user’s allowed permissions
   */
  permissions: SessionUser_permissions;
  agentStatus: AgentStatusEnum;
  isMainSidebarCollapsed: boolean;
  isAiAgentSidebarOpen: boolean;
  /**
   * The number of active chats the agent is currently assigned
   */
  numActiveChats: number;
  /**
   * The number of chats that need a reply from the agent
   */
  numNeedsReplyChats: number;
  clickToCallRecordingEnabled: boolean;
  clickToCallTranscriptionEnabled: boolean;
  clickToCallSummaryEnabled: boolean;
  agentPresence: AgentPresenceEnum;
  hasUploadedAvatar: boolean;
  hasDisabledShortcuts: boolean;
  hasMfaToken: boolean;
  /**
   * Zoom integration details for this user
   */
  zoomIntegration: SessionUser_zoomIntegration;
  /**
   * Google Meet integration details for this user
   */
  googleMeetIntegration: SessionUser_googleMeetIntegration;
  /**
   * Microsoft Teams integration details for this user
   */
  microsoftTeamsIntegration: SessionUser_microsoftTeamsIntegration;
  autoPresenceEnabled: boolean;
  hasEnabledZoomAutolog: boolean;
  hasEnabledGoogleMeetAutolog: boolean;
  hasEnabledMicrosoftTeamsAutolog: boolean;
  hasEnabledAircallAutolog: boolean;
  hasEnabledCallRailAutolog: boolean;
  hasEnabledRingCentralAutolog: boolean;
  hasEnabledDialpadAutolog: boolean;
  hasEnabledKixieAutolog: boolean;
  hasAllowedGoogleMeetWebhookProcessing: boolean;
  leadPageRedesignM1Enabled: boolean;
  leadPageRedesignM3Enabled: boolean;
  peepPagesRedesignEnabled: boolean;
  aiDashboardEnabled: boolean;
  widgetsCollapsedState: SessionUser_widgetsCollapsedState;
  isAiFollowUpTasksEnabled: boolean;
  phoneCallerType: string | null;
  phoneIntegrations: SessionUser_phoneIntegrations[];
  clickToCallIntegration: SessionUser_clickToCallIntegration;
  sendFromNutshellEnabled: boolean;
  shouldShowPipelineOnboardingTour: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserEmailAddress
// ====================================================

export interface UserEmailAddress {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The address string of this email.
   */
  address: string;
  formatted: string;
  /**
   * Is email sync enabled for this address? When the user is sending follow-ups,
   * for example, it’s nice to warn them if sync is not enabled
   */
  isSyncEnabled: boolean;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: Setting
// ====================================================

export interface Setting {
  __typename: "Setting";
  /**
   * The name of this Setting
   */
  id: string;
  /**
   * The value of this Setting
   */
  value: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: TeamFragment
// ====================================================

export interface TeamFragment {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The number of users affiliated with this team
   */
  numUsers: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: User
// ====================================================

export interface User_sendableEmailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The address string of this email.
   */
  address: string;
  formatted: string;
  /**
   * Is email sync enabled for this address? When the user is sending follow-ups,
   * for example, it’s nice to warn them if sync is not enabled
   */
  isSyncEnabled: boolean;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
}

export interface User_emailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The address string of this email.
   */
  address: string;
  formatted: string;
  /**
   * Is email sync enabled for this address? When the user is sending follow-ups,
   * for example, it’s nice to warn them if sync is not enabled
   */
  isSyncEnabled: boolean;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
}

export interface User_permissions {
  __typename: "UserPermissionBooleans";
  canAccessSetup: boolean;
  canAccessMarketing: boolean;
  canBulkEdit: boolean;
  canExport: boolean;
  canViewSharedEmails: boolean;
  canImport: boolean;
  canMergeEntities: boolean;
  canDeleteEntities: boolean;
  canAssignEntities: boolean;
  canAccessBilling: boolean;
  canViewAllMeetings: boolean;
  canManageEmailTemplates: boolean;
  canAccessCrm: boolean;
  canAccessFullCampaigns: boolean;
  canUseInbox: boolean;
  canUseSms: boolean;
  canUseOrTryInbox: boolean;
  canUseSalesDocuments: boolean;
  canDeleteNotesAndActivities: boolean;
}

export interface User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is this user an administrator
   */
  isAdministrator: boolean;
  /**
   * List of successfully enabled user email addresses that a user is able to send emails from Nutshell with.
   */
  sendableEmailAddresses: User_sendableEmailAddresses[];
  /**
   * User emails configured for this user
   */
  emailAddresses: User_emailAddresses[];
  /**
   * Full email signature for this user. Currently using base64 encoded images, so we can just send back a string
   */
  emailSignature: string | null;
  /**
   * Is this user tracking email clicks/views
   */
  isEmailTrackingEnabled: boolean;
  /**
   * The user’s allowed permissions
   */
  permissions: User_permissions;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserPermissionsFragment
// ====================================================

export interface UserPermissionsFragment {
  __typename: "UserPermissionBooleans";
  canAccessSetup: boolean;
  canAccessMarketing: boolean;
  canBulkEdit: boolean;
  canExport: boolean;
  canViewSharedEmails: boolean;
  canImport: boolean;
  canMergeEntities: boolean;
  canDeleteEntities: boolean;
  canAssignEntities: boolean;
  canAccessBilling: boolean;
  canViewAllMeetings: boolean;
  canManageEmailTemplates: boolean;
  canAccessCrm: boolean;
  canAccessFullCampaigns: boolean;
  canUseInbox: boolean;
  canUseSms: boolean;
  canUseOrTryInbox: boolean;
  canUseSalesDocuments: boolean;
  canDeleteNotesAndActivities: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: WidgetsCollapsedState
// ====================================================

export interface WidgetsCollapsedState {
  __typename: "WidgetsCollapsedState";
  /**
   * Lead sales documents section widget state
   */
  leadSalesDocuments: boolean;
  /**
   * Lead companies and people section widget state
   */
  leadCompaniesAndPeople: boolean;
  /**
   * Lead products section widget state
   */
  leadProducts: boolean;
  /**
   * Lead channels and sources section widget state
   */
  leadChannelsAndSources: boolean;
  /**
   * Lead pipeline section widget state
   */
  leadPipeline: boolean;
  /**
   * Top custom fields section widget state
   */
  leadTopCustomFields: boolean;
  /**
   * Custom fields section widget state
   */
  leadCustomFields: boolean;
  /**
   * Competitors section widget state
   */
  leadCompetitors: boolean;
  /**
   * Attachments section widget state
   */
  leadAttachments: boolean;
  /**
   * Scheduled activities section widget state
   */
  leadScheduledActivities: boolean;
  /**
   * Logged activities section widget state
   */
  leadLoggedActivities: boolean;
  /**
   * Upcoming tasks section widget state
   */
  leadUpcomingTasks: boolean;
  /**
   * Future tasks section widget state
   */
  leadFutureTasks: boolean;
  /**
   * Completed tasks section widget state
   */
  leadCompletedTasks: boolean;
  /**
   * Drip sequences section widget state
   */
  leadDripSequences: boolean;
  /**
   * Personal email sequences section widget state
   */
  leadPersonalEmailSequences: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CoreEntity
// ====================================================

export interface CoreEntity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string;
  createdTime: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: NotifyMessageFragment
// ====================================================

export interface NotifyMessageFragment {
  __typename: "NotifyMessage";
  id: string;
  type: string;
  message: string;
  errors: string[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AccountBasic
// ====================================================

export interface AccountBasic_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  region: string | null;
}

export interface AccountBasic_postalAddresses_primary {
  __typename: "PostalAddress";
  value: AccountBasic_postalAddresses_primary_value;
}

export interface AccountBasic_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountBasic_postalAddresses_primary | null;
}

export interface AccountBasic_contacts_edges_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface AccountBasic_contacts_edges {
  __typename: "AccountContactsEdge";
  node: AccountBasic_contacts_edges_node;
}

export interface AccountBasic_contacts {
  __typename: "AccountContactsConnection";
  /**
   * A list of edges.
   */
  edges: AccountBasic_contacts_edges[];
}

export interface AccountBasic {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: AccountBasic_postalAddresses;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to
   * Nutshell Contacts. This allows you to see and query all of the contacts that
   * are related in someway (e.g., they work for) this account. For further
   * reading, see [this blog post explaining GraphQL connection types](https: // dev-blog.apollodata.com/explaining-graphql-connections-c48b7c3d6976).
   */
  contacts: AccountBasic_contacts;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AccountType
// ====================================================

export interface AccountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ActivityType
// ====================================================

export interface ActivityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
  /**
   * The URL of the report for this activity type
   */
  reportUrl: string;
  /**
   * Whether this activity type is immutable
   */
  isImmutable: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AudienceBasic
// ====================================================

export interface AudienceBasic_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface AudienceBasic_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: AudienceBasic_membershipStats_totalCount;
}

export interface AudienceBasic {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The audience name
   */
  name: string;
  /**
   * Is this audience on the preference center?
   */
  isPublic: boolean;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  membershipStats: AudienceBasic_membershipStats;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ConstantContactList
// ====================================================

export interface ConstantContactList {
  __typename: "ConstantContactList";
  id: string;
  name: string;
  favorite: boolean;
  membershipCount: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContactBasic
// ====================================================

export interface ContactBasic_accounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface ContactBasic_accounts_edges {
  __typename: "ContactAccountsEdge";
  node: ContactBasic_accounts_edges_node;
}

export interface ContactBasic_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * A list of edges.
   */
  edges: ContactBasic_accounts_edges[];
}

export interface ContactBasic {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: ContactBasic_accounts;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailSequenceTemplateBasic
// ====================================================

export interface EmailSequenceTemplateBasic_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EmailSequenceTemplateBasic_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailSequenceTemplateBasic {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  creatorUser: EmailSequenceTemplateBasic_creatorUser;
  createdTime: any | null;
  emailSequenceTemplateMessages: EmailSequenceTemplateBasic_emailSequenceTemplateMessages[];
  /**
   * The url pathname to the edit modal for the email template
   */
  htmlUrlPath: string;
  /**
   * Whether the template has custom placeholders
   */
  hasCustomPlaceholders: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadBasic
// ====================================================

export interface LeadBasic {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Leads don’t have initials, but for interface reasons we’ll return an empty
   * string here instead of removing the property entirely.
   */
  initials: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadRecent
// ====================================================

export interface LeadRecent_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface LeadRecent_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: LeadRecent_contacts_primaryEdge_node;
}

export interface LeadRecent_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LeadRecent_contacts_primaryEdge | null;
}

export interface LeadRecent_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface LeadRecent_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: LeadRecent_accounts_primaryEdge_node;
}

export interface LeadRecent_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LeadRecent_accounts_primaryEdge | null;
}

export interface LeadRecent_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface LeadRecent_value {
  __typename: "Money";
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: LeadRecent_value_formattedValue;
}

export interface LeadRecent_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadRecent {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Leads don’t have initials, but for interface reasons we’ll return an empty
   * string here instead of removing the property entirely.
   */
  initials: string;
  number: number | null;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: LeadRecent_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: LeadRecent_accounts;
  value: LeadRecent_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: LeadRecent_assignee | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: MailChimpListBasic
// ====================================================

export interface MailChimpListBasic {
  __typename: "MailChimpList";
  id: string;
  name: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: MarketFragment
// ====================================================

export interface MarketFragment {
  __typename: "Market";
  id: string;
  name: string;
  currency: string;
  currencySymbol: string;
  isDefault: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SlackChannelBasic
// ====================================================

export interface SlackChannelBasic {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SourceBasic
// ====================================================

export interface SourceBasic {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: StageBasic
// ====================================================

export interface StageBasic {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: TagBasic
// ====================================================

export interface TagBasic_creator_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface TagBasic_creator_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type TagBasic_creator = TagBasic_creator_User | TagBasic_creator_Origin;

export interface TagBasic {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The number of entities tagged with this tag
   */
  count: number;
  /**
   * The different type of entity that this tag belongs to (e.g., a Lead, or a Contact)
   */
  tagType: TagType;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
  /**
   * The creator of this tag
   */
  creator: TagBasic_creator;
  /**
   * The DateTime that represents when the Tag was last used
   */
  lastUsedTime: any | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ProductPickerProductFragment
// ====================================================

export interface ProductPickerProductFragment_marketPrice {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface ProductPickerProductFragment_product_category {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
}

export interface ProductPickerProductFragment_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The category of the product
   */
  category: ProductPickerProductFragment_product_category | null;
}

export interface ProductPickerProductFragment {
  __typename: "ProductSearchResult";
  /**
   * Whether the product is available in the requested market.
   */
  isAvailable: boolean | null;
  /**
   * The product price in the requested market, when one exists.
   */
  marketPrice: ProductPickerProductFragment_marketPrice | null;
  product: ProductPickerProductFragment_product;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SubdomainFragment
// ====================================================

export interface SubdomainFragment {
  __typename: "Subdomain";
  /**
   * The ID of the em_from_domain row this record corresponds to, as each domain is split into multiple rows
   */
  fromDomainId: string;
  /**
   * The record of this DNS record
   */
  record: string;
  /**
   * The record of this DNS record
   */
  formattedRecord: string;
  /**
   * Where this subdomain is verified
   */
  isVerified: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AiEmailTemplate
// ====================================================

export interface AiEmailTemplate_editions_edges_node_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface AiEmailTemplate_editions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: AiEmailTemplate_editions_edges_node_emailTemplate | null;
}

export interface AiEmailTemplate_editions_edges {
  __typename: "EditionsEdge";
  node: AiEmailTemplate_editions_edges_node;
}

export interface AiEmailTemplate_editions {
  __typename: "EditionsConnection";
  /**
   * A list of edges.
   */
  edges: AiEmailTemplate_editions_edges[];
}

export interface AiEmailTemplate {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  description: string;
  editions: AiEmailTemplate_editions;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AnalyticsStatusFragment
// ====================================================

export interface AnalyticsStatusFragment_latestImpressionData_Visit {
  __typename: "Visit";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  createdTime: any;
}

export interface AnalyticsStatusFragment_latestImpressionData_FormSubmission {
  __typename: "FormSubmission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  createdTime: any;
}

export type AnalyticsStatusFragment_latestImpressionData = AnalyticsStatusFragment_latestImpressionData_Visit | AnalyticsStatusFragment_latestImpressionData_FormSubmission;

export interface AnalyticsStatusFragment {
  __typename: "AnalyticsStatus";
  /**
   * The tracking status for the instance
   */
  status: Status;
  /**
   * The status of the chat snippet embed for an instance
   */
  chatStatus: Status;
  /**
   * The last detected visit or submission to the instance
   */
  latestImpressionData: AnalyticsStatusFragment_latestImpressionData | null;
  /**
   * The number of forms that have been connected
   */
  numActiveForms: number;
  /**
   * The number of forms that have not been connected
   */
  numInactiveForms: number;
  /**
   * The embeddable script to add tracking to an instance
   */
  trackingScript: string;
  /**
   * The version of the analytics snippet that is being used
   */
  snippetVersion: AnalyticsSnippetVersion;
  /**
   * The auth token used in the embeddable snippet
   */
  authTokenForSnippet: string;
  /**
   * The domain that is embedded in the snippet.
   */
  embeddedDomain: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AudienceEngagementStats
// ====================================================

export interface AudienceEngagementStats_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
}

export interface AudienceEngagementStats_smsEngagementStats {
  __typename: "SmsEngagementStats";
  /**
   * Total number of texts we tried to send
   */
  totalSentCount: number;
  /**
   * Total number of people who responded to the SMS campaign
   */
  responseCount: number;
  /**
   * The ratio of response to total texts sent
   */
  responseRate: number | null;
  /**
   * Total number of texts which couldn’t be delivered
   */
  undeliveredCount: number;
  /**
   * The ratio of undelivered texts to total texts sent
   */
  undeliveredRate: number | null;
  /**
   * The number of people who opted out of SMS messages after receiving this campaign
   */
  optoutCount: number;
  /**
   * The ratio of optouts to total texts sent
   */
  optoutRate: number | null;
}

export interface AudienceEngagementStats {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  engagementStats: AudienceEngagementStats_engagementStats;
  smsEngagementStats: AudienceEngagementStats_smsEngagementStats;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AudienceMembershipStats
// ====================================================

export interface AudienceMembershipStats_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface AudienceMembershipStats_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: AudienceMembershipStats_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface AudienceMembershipStats {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  membershipStats: AudienceMembershipStats_membershipStats;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AudienceSmsMembershipStatsRealtime
// ====================================================

export interface AudienceSmsMembershipStatsRealtime_smsMembershipStatsRealtime_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface AudienceSmsMembershipStatsRealtime_smsMembershipStatsRealtime {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: AudienceSmsMembershipStatsRealtime_smsMembershipStatsRealtime_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface AudienceSmsMembershipStatsRealtime {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Runs the query to get SMS membership stats rather than using data from our cache table. 
   * 							Should only be used when quering an individual audience as it takes about ~0.5 seconds. 
   * 							If used in a list context it will take a while.
   */
  smsMembershipStatsRealtime: AudienceSmsMembershipStatsRealtime_smsMembershipStatsRealtime;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: DashboardStatsFragment
// ====================================================

export interface DashboardStatsFragment_delta {
  __typename: "Delta";
  /**
   * Which direction the statistic moved over the timespan
   */
  direction: DeltaDirection;
  /**
   * How much a statistic changed percentage wise over the timespan, formatted with a % sign
   */
  percentChange: string;
  /**
   * The text trailing the percentage change describing the timespan the change represents
   */
  timespanSuffix: string | null;
}

export interface DashboardStatsFragment {
  __typename: "Stat";
  /**
   * The name of the quantity the statistics represent
   */
  name: string;
  /**
   * The current value of the statistic formatted as a human-readable number
   */
  formattedValue: string;
  /**
   * Details about how a statistic has changed in a given timespan, and by how
   * much. If there is no data for the timespan preceeding this one, returns null.
   */
  delta: DashboardStatsFragment_delta | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: DripSequenceDashboardFragment
// ====================================================

export interface DripSequenceDashboardFragment_edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface DripSequenceDashboardFragment_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: DripSequenceDashboardFragment_edition_campaign;
}

export interface DripSequenceDashboardFragment {
  __typename: "RecentDrip";
  /**
   * The edition associated with this drip.
   */
  edition: DripSequenceDashboardFragment_edition;
  /**
   * User-friendly string representation of the number of deliveries
   */
  formattedDeliveries: string;
  /**
   * User-friendly string representation of the open rate
   */
  formattedOpenRate: string;
  /**
   * User-friendly string representation of the click rate
   */
  formattedClickRate: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EditionDashboardFragment
// ====================================================

export interface EditionDashboardFragment_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EditionDashboardFragment_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: EditionDashboardFragment_audience_membershipStats_totalCount;
  /**
   * String-formatted number of members to display on the frontend.
   */
  totalCountFormatted: string;
}

export interface EditionDashboardFragment_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  membershipStats: EditionDashboardFragment_audience_membershipStats;
}

export interface EditionDashboardFragment_engagementStats {
  __typename: "EngagementStats";
  /**
   * The click rate formatted as a human-readable number
   */
  clickRateFormatted: string;
  /**
   * String-formatted number of deliveries to display on the frontend.
   */
  totalSentCountFormatted: string;
  /**
   * The open rate formatted as a human-readable number
   */
  openRateFormatted: string;
}

export interface EditionDashboardFragment {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The audience to send this edition to
   */
  audience: EditionDashboardFragment_audience | null;
  engagementStats: EditionDashboardFragment_engagementStats;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: OnboardingChecklistItem
// ====================================================

export interface OnboardingChecklistItem {
  __typename: "OnboardingChecklistItem";
  /**
   * Completion percentage of all tasks on the onboarding checklist
   */
  key: OnboardingChecklistKey;
  /**
   * Title of the checklist item, i.e. "Create your first contact"
   */
  title: string;
  /**
   * Subtitle of the checklist item
   */
  subtitle: string | null;
  /**
   * The total decimal amount of the monetary value.
   */
  isComplete: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: MaterializedMessageBody
// ====================================================

export interface MaterializedMessageBody_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface MaterializedMessageBody_entity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MaterializedMessageBody {
  __typename: "MaterializedEmailTemplate";
  /**
   * Materialized body of this email template, meaning {firstName} would be returned as Chris.
   */
  body: string;
  /**
   * Underlying non-materialized version of this email template, for accessing the raw field data.
   */
  emailTemplate: MaterializedMessageBody_emailTemplate;
  /**
   * Model associated with this materialized email template.
   */
  entity: MaterializedMessageBody_entity;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ComparisonEditionFragment
// ====================================================

export interface ComparisonEditionFragment_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface ComparisonEditionFragment_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: ComparisonEditionFragment_emailTemplate_links_url | null;
}

export interface ComparisonEditionFragment_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: ComparisonEditionFragment_emailTemplate_links[];
}

export interface ComparisonEditionFragment {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: ComparisonEditionFragment_emailTemplate | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ComparisonFragment
// ====================================================

export interface ComparisonFragment_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface ComparisonFragment_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface ComparisonFragment_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: ComparisonFragment_winnerEdition_emailTemplate | null;
}

export interface ComparisonFragment_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface ComparisonFragment_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ComparisonFragment {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: ComparisonFragment_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: ComparisonFragment_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: ComparisonFragment_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: ComparisonFragment_winningEdition | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EditionBasicFragment
// ====================================================

export interface EditionBasicFragment {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: McfxAudienceFragment
// ====================================================

export interface McfxAudienceFragment {
  __typename: "McfxApiAudience";
  /**
   * How long the specific page visit lasted.
   */
  externalId: string;
  /**
   * How name of this MCFX audience.
   */
  name: string;
  /**
   * Category for audience (forms, campaigns, etc) – not shown in UI.
   */
  category: string | null;
  /**
   * How many members there are currently in this audience.
   */
  size: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EditionEngagementStats
// ====================================================

export interface EditionEngagementStats_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
}

export interface EditionEngagementStats_comparisonEdition_comparisonPeriodEngagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
}

export interface EditionEngagementStats_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The engagement stats for the duration of a comparison test
   */
  comparisonPeriodEngagementStats: EditionEngagementStats_comparisonEdition_comparisonPeriodEngagementStats | null;
}

export interface EditionEngagementStats_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EditionEngagementStats_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
}

export interface EditionEngagementStats_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EditionEngagementStats_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  winningMetric: ComparisonMetricType;
  /**
   * The winning edition
   */
  winnerEdition: EditionEngagementStats_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: EditionEngagementStats_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: EditionEngagementStats_comparison_winningEdition | null;
  /**
   * The percent of the test that is complete
   */
  percentComplete: number;
  /**
   * The number of minutes remaining in the test
   */
  minutesRemaining: number | null;
  /**
   * Indicates whether the comparison is tied
   */
  isTied: boolean;
}

export interface EditionEngagementStats_comparisonPeriodEngagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
}

export interface EditionEngagementStats {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  engagementStats: EditionEngagementStats_engagementStats;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: EditionEngagementStats_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: EditionEngagementStats_comparison | null;
  /**
   * The engagement stats for the duration of a comparison test
   */
  comparisonPeriodEngagementStats: EditionEngagementStats_comparisonPeriodEngagementStats | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: TemplateStubFragment
// ====================================================

export interface TemplateStubFragment_edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface TemplateStubFragment_edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface TemplateStubFragment_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface TemplateStubFragment_edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface TemplateStubFragment_edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: TemplateStubFragment_edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: TemplateStubFragment_edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: TemplateStubFragment_edition_campaign_nextSendingEdition | null;
}

export interface TemplateStubFragment_edition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface TemplateStubFragment_edition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: TemplateStubFragment_edition_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface TemplateStubFragment_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: TemplateStubFragment_edition_emailTemplate_links[];
}

export interface TemplateStubFragment_edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface TemplateStubFragment_edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface TemplateStubFragment_edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: TemplateStubFragment_edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface TemplateStubFragment_edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: TemplateStubFragment_edition_comparisonEdition_emailTemplate_links[];
}

export interface TemplateStubFragment_edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: TemplateStubFragment_edition_comparisonEdition_emailTemplate | null;
}

export interface TemplateStubFragment_edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface TemplateStubFragment_edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface TemplateStubFragment_edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: TemplateStubFragment_edition_comparison_winnerEdition_emailTemplate | null;
}

export interface TemplateStubFragment_edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface TemplateStubFragment_edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface TemplateStubFragment_edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: TemplateStubFragment_edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: TemplateStubFragment_edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: TemplateStubFragment_edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: TemplateStubFragment_edition_comparison_winningEdition | null;
}

export interface TemplateStubFragment_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface TemplateStubFragment_edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
}

export interface TemplateStubFragment_edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: TemplateStubFragment_edition_from_emailAddress;
}

export interface TemplateStubFragment_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface TemplateStubFragment_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: TemplateStubFragment_edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: TemplateStubFragment_edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: TemplateStubFragment_edition_emailTemplate | null;
  engagementStats: TemplateStubFragment_edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: TemplateStubFragment_edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: TemplateStubFragment_edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: TemplateStubFragment_edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: TemplateStubFragment_edition_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: TemplateStubFragment_edition_delay | null;
}

export interface TemplateStubFragment {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  edition: TemplateStubFragment_edition;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: Audience
// ====================================================

export interface Audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface Audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: Audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface Audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface Audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: Audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface Audience_publishedEditions_edges_node_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
}

export interface Audience_publishedEditions_edges_node_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
}

export interface Audience_publishedEditions_edges_node_from_emailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface Audience_publishedEditions_edges_node_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface Audience_publishedEditions_edges_node_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: Audience_publishedEditions_edges_node_from_emailAddress;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: Audience_publishedEditions_edges_node_from_fromDomain | null;
}

export interface Audience_publishedEditions_edges_node_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface Audience_publishedEditions_edges_node_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
}

export interface Audience_publishedEditions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  sendTime: any | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: Audience_publishedEditions_edges_node_campaign;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The email template for this edition
   */
  emailTemplate: Audience_publishedEditions_edges_node_emailTemplate | null;
  /**
   * The address to send this edition from
   */
  from: Audience_publishedEditions_edges_node_from | null;
  /**
   * The audience to send this edition to
   */
  audience: Audience_publishedEditions_edges_node_audience | null;
  engagementStats: Audience_publishedEditions_edges_node_engagementStats;
}

export interface Audience_publishedEditions_edges {
  __typename: "AudienceEditionEdge";
  node: Audience_publishedEditions_edges_node;
}

export interface Audience_publishedEditions {
  __typename: "AudienceEditionConnection";
  /**
   * A list of edges.
   */
  edges: Audience_publishedEditions_edges[];
}

export interface Audience_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface Audience_mostRecentSentEdition_SmsEdition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface Audience_mostRecentSentEdition_SmsEdition_campaign {
  __typename: "Campaign" | "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
}

export interface Audience_mostRecentSentEdition_SmsEdition_engagementStats {
  __typename: "SmsEngagementStats";
  /**
   * Total number of texts we tried to send
   */
  totalSentCount: number;
  /**
   * Total number of people who responded to the SMS campaign
   */
  responseCount: number;
  /**
   * The ratio of undelivered texts to total texts sent
   */
  undeliveredRate: number | null;
  /**
   * The ratio of optouts to total texts sent
   */
  optoutRate: number | null;
}

export interface Audience_mostRecentSentEdition_SmsEdition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The audience to send this edition to
   */
  audience: Audience_mostRecentSentEdition_SmsEdition_audience | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: Audience_mostRecentSentEdition_SmsEdition_campaign;
  /**
   * The content of the edition
   */
  content: string;
  engagementStats: Audience_mostRecentSentEdition_SmsEdition_engagementStats;
}

export interface Audience_mostRecentSentEdition_Edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface Audience_mostRecentSentEdition_Edition_campaign {
  __typename: "Campaign" | "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
}

export interface Audience_mostRecentSentEdition_Edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
}

export interface Audience_mostRecentSentEdition_Edition_from_emailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface Audience_mostRecentSentEdition_Edition_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface Audience_mostRecentSentEdition_Edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: Audience_mostRecentSentEdition_Edition_from_emailAddress;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: Audience_mostRecentSentEdition_Edition_from_fromDomain | null;
}

export interface Audience_mostRecentSentEdition_Edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
}

export interface Audience_mostRecentSentEdition_Edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The audience to send this edition to
   */
  audience: Audience_mostRecentSentEdition_Edition_audience | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: Audience_mostRecentSentEdition_Edition_campaign;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The email template for this edition
   */
  emailTemplate: Audience_mostRecentSentEdition_Edition_emailTemplate | null;
  /**
   * The address to send this edition from
   */
  from: Audience_mostRecentSentEdition_Edition_from | null;
  engagementStats: Audience_mostRecentSentEdition_Edition_engagementStats;
}

export type Audience_mostRecentSentEdition = Audience_mostRecentSentEdition_SmsEdition | Audience_mostRecentSentEdition_Edition;

export interface Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The description of this audience
   */
  description: string | null;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  membershipStats: Audience_membershipStats;
  smsMembershipStats: Audience_smsMembershipStats;
  /**
   * All published email editions for this audience
   */
  publishedEditions: Audience_publishedEditions;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * Is this audience on the preference center?
   */
  isPublic: boolean;
  modifiedTime: any | null;
  deletedTime: any | null;
  /**
   * The last time an email or SMS edition was sent to this audience
   */
  lastContactedTime: any | null;
  isArchived: boolean;
  creatorUser: Audience_creatorUser | null;
  createdTime: any;
  /**
   * The most recent sent edition for this audience
   */
  mostRecentSentEdition: Audience_mostRecentSentEdition | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AudienceStub
// ====================================================

export interface AudienceStub_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface AudienceStub_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: AudienceStub_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface AudienceStub_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface AudienceStub_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: AudienceStub_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface AudienceStub_publishedEditions_edges_node_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface AudienceStub_publishedEditions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  sendTime: any | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: AudienceStub_publishedEditions_edges_node_campaign;
}

export interface AudienceStub_publishedEditions_edges {
  __typename: "AudienceEditionEdge";
  node: AudienceStub_publishedEditions_edges_node;
}

export interface AudienceStub_publishedEditions {
  __typename: "AudienceEditionConnection";
  /**
   * A list of edges.
   */
  edges: AudienceStub_publishedEditions_edges[];
}

export interface AudienceStub {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The description of this audience
   */
  description: string | null;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  membershipStats: AudienceStub_membershipStats;
  smsMembershipStats: AudienceStub_smsMembershipStats;
  /**
   * All published email editions for this audience
   */
  publishedEditions: AudienceStub_publishedEditions;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * Is this audience on the preference center?
   */
  isPublic: boolean;
  modifiedTime: any | null;
  deletedTime: any | null;
  /**
   * The last time an email or SMS edition was sent to this audience
   */
  lastContactedTime: any | null;
  isArchived: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BroadcastFragment
// ====================================================

export interface BroadcastFragment_edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface BroadcastFragment_edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface BroadcastFragment_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface BroadcastFragment_edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface BroadcastFragment_edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: BroadcastFragment_edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: BroadcastFragment_edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: BroadcastFragment_edition_campaign_nextSendingEdition | null;
}

export interface BroadcastFragment_edition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface BroadcastFragment_edition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: BroadcastFragment_edition_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface BroadcastFragment_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: BroadcastFragment_edition_emailTemplate_links[];
  name: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface BroadcastFragment_edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface BroadcastFragment_edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface BroadcastFragment_edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: BroadcastFragment_edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface BroadcastFragment_edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: BroadcastFragment_edition_comparisonEdition_emailTemplate_links[];
}

export interface BroadcastFragment_edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: BroadcastFragment_edition_comparisonEdition_emailTemplate | null;
}

export interface BroadcastFragment_edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface BroadcastFragment_edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface BroadcastFragment_edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: BroadcastFragment_edition_comparison_winnerEdition_emailTemplate | null;
}

export interface BroadcastFragment_edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface BroadcastFragment_edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface BroadcastFragment_edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: BroadcastFragment_edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: BroadcastFragment_edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: BroadcastFragment_edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: BroadcastFragment_edition_comparison_winningEdition | null;
}

export interface BroadcastFragment_edition_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface BroadcastFragment_edition_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: BroadcastFragment_edition_audience_fromSavedFilter_count;
}

export interface BroadcastFragment_edition_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface BroadcastFragment_edition_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: BroadcastFragment_edition_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface BroadcastFragment_edition_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface BroadcastFragment_edition_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: BroadcastFragment_edition_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface BroadcastFragment_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: BroadcastFragment_edition_audience_fromSavedFilter | null;
  membershipStats: BroadcastFragment_edition_audience_membershipStats;
  smsMembershipStats: BroadcastFragment_edition_audience_smsMembershipStats;
}

export interface BroadcastFragment_edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface BroadcastFragment_edition_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface BroadcastFragment_edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: BroadcastFragment_edition_from_emailAddress;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: BroadcastFragment_edition_from_fromDomain | null;
}

export interface BroadcastFragment_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface BroadcastFragment_edition_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface BroadcastFragment_edition_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface BroadcastFragment_edition_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface BroadcastFragment_edition_gateError {
  __typename: "GateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface BroadcastFragment_edition_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface BroadcastFragment_edition_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface BroadcastFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface BroadcastFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface BroadcastFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: BroadcastFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface BroadcastFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: BroadcastFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface BroadcastFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface BroadcastFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: BroadcastFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface BroadcastFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: BroadcastFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: BroadcastFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type BroadcastFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity = BroadcastFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account | BroadcastFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface BroadcastFragment_edition_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: BroadcastFragment_edition_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: BroadcastFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface BroadcastFragment_edition_queuedDripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: BroadcastFragment_edition_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface BroadcastFragment_edition_queuedDripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: BroadcastFragment_edition_queuedDripProgressions_edges_node;
}

export interface BroadcastFragment_edition_queuedDripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: BroadcastFragment_edition_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: BroadcastFragment_edition_queuedDripProgressions_edges[];
}

export interface BroadcastFragment_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: BroadcastFragment_edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: BroadcastFragment_edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: BroadcastFragment_edition_emailTemplate | null;
  engagementStats: BroadcastFragment_edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: BroadcastFragment_edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: BroadcastFragment_edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: BroadcastFragment_edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: BroadcastFragment_edition_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: BroadcastFragment_edition_delay | null;
  /**
   * The number of emails sent for this edition
   */
  numSentEmails: number;
  /**
   * The custom click domain that this edition will use to track links, if there is one
   */
  customClickDomain: BroadcastFragment_edition_customClickDomain | null;
  utmParameters: BroadcastFragment_edition_utmParameters;
  defaultUtmParameters: BroadcastFragment_edition_defaultUtmParameters;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  useUtmParameters: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: BroadcastFragment_edition_gateError | null;
  /**
   * Boolean indicating if the edition is using a web font.
   */
  hasWebFonts: boolean;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: BroadcastFragment_edition_queuedDripProgressions | null;
  /**
   * The maximum number of recipients this edition can send to, if DMARC is not
   * fully configured. This is only relevant for non-drip sequence editions.
   */
  recipientLimitForDeliverability: number | null;
}

export interface BroadcastFragment {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  edition: BroadcastFragment_edition;
  description: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BroadcastStubFragment
// ====================================================

export interface BroadcastStubFragment_edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface BroadcastStubFragment_edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface BroadcastStubFragment_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface BroadcastStubFragment_edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface BroadcastStubFragment_edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: BroadcastStubFragment_edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: BroadcastStubFragment_edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: BroadcastStubFragment_edition_campaign_nextSendingEdition | null;
}

export interface BroadcastStubFragment_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface BroadcastStubFragment_edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
}

export interface BroadcastStubFragment_edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface BroadcastStubFragment_edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: BroadcastStubFragment_edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface BroadcastStubFragment_edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: BroadcastStubFragment_edition_comparisonEdition_emailTemplate_links[];
}

export interface BroadcastStubFragment_edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: BroadcastStubFragment_edition_comparisonEdition_emailTemplate | null;
}

export interface BroadcastStubFragment_edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface BroadcastStubFragment_edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface BroadcastStubFragment_edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: BroadcastStubFragment_edition_comparison_winnerEdition_emailTemplate | null;
}

export interface BroadcastStubFragment_edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface BroadcastStubFragment_edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface BroadcastStubFragment_edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: BroadcastStubFragment_edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: BroadcastStubFragment_edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: BroadcastStubFragment_edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: BroadcastStubFragment_edition_comparison_winningEdition | null;
}

export interface BroadcastStubFragment_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface BroadcastStubFragment_edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
}

export interface BroadcastStubFragment_edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: BroadcastStubFragment_edition_from_emailAddress;
}

export interface BroadcastStubFragment_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: BroadcastStubFragment_edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: BroadcastStubFragment_edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: BroadcastStubFragment_edition_emailTemplate | null;
  engagementStats: BroadcastStubFragment_edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: BroadcastStubFragment_edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: BroadcastStubFragment_edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: BroadcastStubFragment_edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: BroadcastStubFragment_edition_from | null;
}

export interface BroadcastStubFragment {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  edition: BroadcastStubFragment_edition;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: DripEditionFragment
// ====================================================

export interface DripEditionFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DripEditionFragment_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DripEditionFragment_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DripEditionFragment_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface DripEditionFragment_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: DripEditionFragment_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: DripEditionFragment_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: DripEditionFragment_campaign_nextSendingEdition | null;
}

export interface DripEditionFragment_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface DripEditionFragment_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: DripEditionFragment_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface DripEditionFragment_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: DripEditionFragment_emailTemplate_links[];
  name: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface DripEditionFragment_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface DripEditionFragment_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface DripEditionFragment_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: DripEditionFragment_comparisonEdition_emailTemplate_links_url | null;
}

export interface DripEditionFragment_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: DripEditionFragment_comparisonEdition_emailTemplate_links[];
}

export interface DripEditionFragment_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: DripEditionFragment_comparisonEdition_emailTemplate | null;
}

export interface DripEditionFragment_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface DripEditionFragment_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface DripEditionFragment_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: DripEditionFragment_comparison_winnerEdition_emailTemplate | null;
}

export interface DripEditionFragment_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface DripEditionFragment_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DripEditionFragment_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: DripEditionFragment_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: DripEditionFragment_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: DripEditionFragment_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: DripEditionFragment_comparison_winningEdition | null;
}

export interface DripEditionFragment_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface DripEditionFragment_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: DripEditionFragment_audience_fromSavedFilter_count;
}

export interface DripEditionFragment_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface DripEditionFragment_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: DripEditionFragment_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface DripEditionFragment_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface DripEditionFragment_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: DripEditionFragment_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface DripEditionFragment_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: DripEditionFragment_audience_fromSavedFilter | null;
  membershipStats: DripEditionFragment_audience_membershipStats;
  smsMembershipStats: DripEditionFragment_audience_smsMembershipStats;
}

export interface DripEditionFragment_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface DripEditionFragment_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface DripEditionFragment_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: DripEditionFragment_from_emailAddress;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: DripEditionFragment_from_fromDomain | null;
}

export interface DripEditionFragment_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface DripEditionFragment_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface DripEditionFragment_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface DripEditionFragment_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface DripEditionFragment_gateError {
  __typename: "GateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface DripEditionFragment_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface DripEditionFragment_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface DripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface DripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface DripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: DripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface DripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: DripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface DripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface DripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: DripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface DripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: DripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: DripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type DripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity = DripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Account | DripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface DripEditionFragment_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: DripEditionFragment_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: DripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface DripEditionFragment_queuedDripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: DripEditionFragment_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface DripEditionFragment_queuedDripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: DripEditionFragment_queuedDripProgressions_edges_node;
}

export interface DripEditionFragment_queuedDripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: DripEditionFragment_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: DripEditionFragment_queuedDripProgressions_edges[];
}

export interface DripEditionFragment {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: DripEditionFragment_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: DripEditionFragment_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: DripEditionFragment_emailTemplate | null;
  engagementStats: DripEditionFragment_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: DripEditionFragment_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: DripEditionFragment_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: DripEditionFragment_audience | null;
  /**
   * The address to send this edition from
   */
  from: DripEditionFragment_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: DripEditionFragment_delay | null;
  /**
   * The number of emails sent for this edition
   */
  numSentEmails: number;
  /**
   * The custom click domain that this edition will use to track links, if there is one
   */
  customClickDomain: DripEditionFragment_customClickDomain | null;
  utmParameters: DripEditionFragment_utmParameters;
  defaultUtmParameters: DripEditionFragment_defaultUtmParameters;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  useUtmParameters: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: DripEditionFragment_gateError | null;
  /**
   * Boolean indicating if the edition is using a web font.
   */
  hasWebFonts: boolean;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: DripEditionFragment_queuedDripProgressions | null;
  /**
   * The maximum number of recipients this edition can send to, if DMARC is not
   * fully configured. This is only relevant for non-drip sequence editions.
   */
  recipientLimitForDeliverability: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: DripSequenceFragment
// ====================================================

export interface DripSequenceFragment_startTrigger_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface DripSequenceFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface DripSequenceFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface DripSequenceFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type DripSequenceFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter = DripSequenceFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | DripSequenceFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | DripSequenceFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface DripSequenceFragment_startTrigger_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: DripSequenceFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface DripSequenceFragment_startTrigger_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface DripSequenceFragment_startTrigger_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type DripSequenceFragment_startTrigger_conditions_config = DripSequenceFragment_startTrigger_conditions_config_ConditionConfigLink | DripSequenceFragment_startTrigger_conditions_config_ConditionConfigEntityFilter | DripSequenceFragment_startTrigger_conditions_config_ConditionConfigTag | DripSequenceFragment_startTrigger_conditions_config_ConditionConfigAudience;

export interface DripSequenceFragment_startTrigger_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: DripSequenceFragment_startTrigger_conditions_config;
}

export interface DripSequenceFragment_startTrigger {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of startTrigger
   */
  type: StartTriggerType;
  /**
   * A list of conditions which must be true to activate this startTrigger.
   */
  conditions: DripSequenceFragment_startTrigger_conditions[];
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface DripSequenceFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DripSequenceFragment_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface DripSequenceFragment_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * The last time this particular piece of content was sent. This is slow to
   * calculate on a one-off basis so we chuck it in here.
   */
  latestDeliveryTime: any | null;
  /**
   * For edition base stats, the total number of drip progressions in any state for the related campaigns
   */
  dripProgressionTotalRecipients: number;
  /**
   * For edition base stats, the number of drip progressions that have stopped for the related campaigns
   */
  dripProgressionsStopped: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
  /**
   * For edition base stats, the percentage of drip progressions that received every message for the related campaigns
   */
  dripProgressionsReceivedEveryMessageRate: number | null;
}

export interface DripSequenceFragment_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface DripSequenceFragment_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface DripSequenceFragment_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: DripSequenceFragment_from_emailAddress;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: DripSequenceFragment_from_fromDomain | null;
}

export interface DripSequenceFragment_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
}

export interface DripSequenceFragment_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
}

export interface DripSequenceFragment_goal_conditions_config_ConditionConfigSourceEntity {
  __typename: "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface DripSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface DripSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface DripSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type DripSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter = DripSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | DripSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | DripSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface DripSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: DripSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface DripSequenceFragment_goal_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export interface DripSequenceFragment_goal_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface DripSequenceFragment_goal_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type DripSequenceFragment_goal_conditions_config = DripSequenceFragment_goal_conditions_config_ConditionConfigSourceEntity | DripSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter | DripSequenceFragment_goal_conditions_config_ConditionConfigLink | DripSequenceFragment_goal_conditions_config_ConditionConfigTag | DripSequenceFragment_goal_conditions_config_ConditionConfigAudience;

export interface DripSequenceFragment_goal_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: DripSequenceFragment_goal_conditions_config;
}

export interface DripSequenceFragment_goal_action_config_ActionConfigRemoveTags {
  __typename: "ActionConfigRemoveTags" | "ActionConfigSendPageViewedNotification" | "ActionConfigAddToDripSequence" | "ActionConfigCreateLead" | "ActionConfigSendEmail";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
}

export interface DripSequenceFragment_goal_action_config_ActionConfigAddTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface DripSequenceFragment_goal_action_config_ActionConfigAddTags {
  __typename: "ActionConfigAddTags";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  tags: DripSequenceFragment_goal_action_config_ActionConfigAddTags_tags[];
}

export interface DripSequenceFragment_goal_action_config_ActionConfigAddAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface DripSequenceFragment_goal_action_config_ActionConfigAddAudiences {
  __typename: "ActionConfigAddAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: DripSequenceFragment_goal_action_config_ActionConfigAddAudiences_audiences[];
}

export interface DripSequenceFragment_goal_action_config_ActionConfigRemoveAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface DripSequenceFragment_goal_action_config_ActionConfigRemoveAudiences {
  __typename: "ActionConfigRemoveAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: DripSequenceFragment_goal_action_config_ActionConfigRemoveAudiences_audiences[];
}

export type DripSequenceFragment_goal_action_config = DripSequenceFragment_goal_action_config_ActionConfigRemoveTags | DripSequenceFragment_goal_action_config_ActionConfigAddTags | DripSequenceFragment_goal_action_config_ActionConfigAddAudiences | DripSequenceFragment_goal_action_config_ActionConfigRemoveAudiences;

export interface DripSequenceFragment_goal_action {
  __typename: "Action";
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * Human readable title of this action
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this action. This is essentially just the
   * stringified version of the action’s conditions, but because a action can have
   * multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The configuration for this action.
   */
  config: DripSequenceFragment_goal_action_config;
}

export interface DripSequenceFragment_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Calculated goal type based on conditions. This is not saved in the database
   */
  type: DripSequenceGoalType;
  /**
   * A list of conditions which must be true to activate this goal.
   */
  conditions: DripSequenceFragment_goal_conditions[];
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this goal. This is essentially just the stringified
   * version of the goal’s conditions, but because a goal can have multiple
   * conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The optional action (next step in this context) that will run when this goal is met
   */
  action: DripSequenceFragment_goal_action | null;
}

export interface DripSequenceFragment_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface DripSequenceFragment {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The start trigger for the drip sequence
   */
  startTrigger: DripSequenceFragment_startTrigger | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  creatorUser: DripSequenceFragment_creatorUser | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The DateTime that represents when the campaign was last modified
   */
  modifiedTime: any | null;
  /**
   * Time of the last campaign status change. For example, if a customer activated
   * this sequence and its still active, this would be the time the sequence was
   * activated. Once the campaign status is changed (paused, retired, etc) this
   * would reflect that new time
   */
  lastStatusChangeTime: any | null;
  editions: DripSequenceFragment_editions;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * Whether the drip sequence should have a remove option
   */
  isRemovable: boolean;
  engagementStats: DripSequenceFragment_engagementStats;
  /**
   * The address to send this edition from
   */
  from: DripSequenceFragment_from | null;
  useUtmParameters: boolean;
  utmParameters: DripSequenceFragment_utmParameters;
  defaultUtmParameters: DripSequenceFragment_defaultUtmParameters;
  /**
   * Should messages only be sent during business hours.
   */
  isBusinessHoursOnly: boolean;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * When a lead is closed, should drip sequences stop?
   */
  isStopOnLeadClose: boolean;
  /**
   * When a person is removed from an audience, should drip sequences stop?
   */
  isStopOnRemovedFromAudience: boolean;
  /**
   * The newly created Nutshell goal
   */
  goal: DripSequenceFragment_goal | null;
  /**
   * Number of in progress drip progressions for the drip sequence
   */
  numInProgressDripProgressions: number;
  /**
   * The custom click domain that this campaign will use to track links, if there is one
   */
  customClickDomain: DripSequenceFragment_customClickDomain | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: DripSequenceStubFragment
// ====================================================

export interface DripSequenceStubFragment_startTrigger_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface DripSequenceStubFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface DripSequenceStubFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface DripSequenceStubFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type DripSequenceStubFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter = DripSequenceStubFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | DripSequenceStubFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | DripSequenceStubFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface DripSequenceStubFragment_startTrigger_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: DripSequenceStubFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface DripSequenceStubFragment_startTrigger_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface DripSequenceStubFragment_startTrigger_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type DripSequenceStubFragment_startTrigger_conditions_config = DripSequenceStubFragment_startTrigger_conditions_config_ConditionConfigLink | DripSequenceStubFragment_startTrigger_conditions_config_ConditionConfigEntityFilter | DripSequenceStubFragment_startTrigger_conditions_config_ConditionConfigTag | DripSequenceStubFragment_startTrigger_conditions_config_ConditionConfigAudience;

export interface DripSequenceStubFragment_startTrigger_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: DripSequenceStubFragment_startTrigger_conditions_config;
}

export interface DripSequenceStubFragment_startTrigger {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of startTrigger
   */
  type: StartTriggerType;
  /**
   * A list of conditions which must be true to activate this startTrigger.
   */
  conditions: DripSequenceStubFragment_startTrigger_conditions[];
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface DripSequenceStubFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface DripSequenceStubFragment_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface DripSequenceStubFragment_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * The last time this particular piece of content was sent. This is slow to
   * calculate on a one-off basis so we chuck it in here.
   */
  latestDeliveryTime: any | null;
  /**
   * For edition base stats, the total number of drip progressions in any state for the related campaigns
   */
  dripProgressionTotalRecipients: number;
  /**
   * For edition base stats, the number of drip progressions that have stopped for the related campaigns
   */
  dripProgressionsStopped: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
  /**
   * For edition base stats, the percentage of drip progressions that received every message for the related campaigns
   */
  dripProgressionsReceivedEveryMessageRate: number | null;
}

export interface DripSequenceStubFragment_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
}

export interface DripSequenceStubFragment_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: DripSequenceStubFragment_from_emailAddress;
}

export interface DripSequenceStubFragment {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The start trigger for the drip sequence
   */
  startTrigger: DripSequenceStubFragment_startTrigger | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  creatorUser: DripSequenceStubFragment_creatorUser | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The DateTime that represents when the campaign was last modified
   */
  modifiedTime: any | null;
  /**
   * Time of the last campaign status change. For example, if a customer activated
   * this sequence and its still active, this would be the time the sequence was
   * activated. Once the campaign status is changed (paused, retired, etc) this
   * would reflect that new time
   */
  lastStatusChangeTime: any | null;
  editions: DripSequenceStubFragment_editions;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * Whether the drip sequence should have a remove option
   */
  isRemovable: boolean;
  engagementStats: DripSequenceStubFragment_engagementStats;
  /**
   * The address to send this edition from
   */
  from: DripSequenceStubFragment_from | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EngagementStatsFragment
// ====================================================

export interface EngagementStatsFragment {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * The last time this particular piece of content was sent. This is slow to
   * calculate on a one-off basis so we chuck it in here.
   */
  latestDeliveryTime: any | null;
  /**
   * For edition base stats, the total number of drip progressions in any state for the related campaigns
   */
  dripProgressionTotalRecipients: number;
  /**
   * For edition base stats, the number of drip progressions that have stopped for the related campaigns
   */
  dripProgressionsStopped: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
  /**
   * For edition base stats, the percentage of drip progressions that received every message for the related campaigns
   */
  dripProgressionsReceivedEveryMessageRate: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AudienceFragment
// ====================================================

export interface AudienceFragment_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface AudienceFragment_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: AudienceFragment_fromSavedFilter_count;
}

export interface AudienceFragment_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface AudienceFragment_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: AudienceFragment_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface AudienceFragment_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface AudienceFragment_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: AudienceFragment_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface AudienceFragment {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: AudienceFragment_fromSavedFilter | null;
  membershipStats: AudienceFragment_membershipStats;
  smsMembershipStats: AudienceFragment_smsMembershipStats;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CampaignFragment
// ====================================================

export interface CampaignFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CampaignFragment_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CampaignFragment_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface CampaignFragment {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: CampaignFragment_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: CampaignFragment_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: CampaignFragment_nextSendingEdition | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EditionFragment
// ====================================================

export interface EditionFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EditionFragment_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EditionFragment_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EditionFragment_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface EditionFragment_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: EditionFragment_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: EditionFragment_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: EditionFragment_campaign_nextSendingEdition | null;
}

export interface EditionFragment_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface EditionFragment_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: EditionFragment_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface EditionFragment_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: EditionFragment_emailTemplate_links[];
  name: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface EditionFragment_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface EditionFragment_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface EditionFragment_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: EditionFragment_comparisonEdition_emailTemplate_links_url | null;
}

export interface EditionFragment_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: EditionFragment_comparisonEdition_emailTemplate_links[];
}

export interface EditionFragment_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: EditionFragment_comparisonEdition_emailTemplate | null;
}

export interface EditionFragment_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface EditionFragment_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface EditionFragment_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: EditionFragment_comparison_winnerEdition_emailTemplate | null;
}

export interface EditionFragment_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface EditionFragment_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EditionFragment_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: EditionFragment_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: EditionFragment_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: EditionFragment_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: EditionFragment_comparison_winningEdition | null;
}

export interface EditionFragment_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EditionFragment_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: EditionFragment_audience_fromSavedFilter_count;
}

export interface EditionFragment_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EditionFragment_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: EditionFragment_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface EditionFragment_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface EditionFragment_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: EditionFragment_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface EditionFragment_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: EditionFragment_audience_fromSavedFilter | null;
  membershipStats: EditionFragment_audience_membershipStats;
  smsMembershipStats: EditionFragment_audience_smsMembershipStats;
}

export interface EditionFragment_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface EditionFragment_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface EditionFragment_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: EditionFragment_from_emailAddress;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: EditionFragment_from_fromDomain | null;
}

export interface EditionFragment_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface EditionFragment_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface EditionFragment_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface EditionFragment_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface EditionFragment_gateError {
  __typename: "GateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface EditionFragment_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface EditionFragment_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface EditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface EditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: EditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface EditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: EditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface EditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface EditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: EditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface EditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: EditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: EditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type EditionFragment_queuedDripProgressions_edges_node_audienceMember_entity = EditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Account | EditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface EditionFragment_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: EditionFragment_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: EditionFragment_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface EditionFragment_queuedDripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: EditionFragment_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface EditionFragment_queuedDripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: EditionFragment_queuedDripProgressions_edges_node;
}

export interface EditionFragment_queuedDripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: EditionFragment_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: EditionFragment_queuedDripProgressions_edges[];
}

export interface EditionFragment {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: EditionFragment_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: EditionFragment_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: EditionFragment_emailTemplate | null;
  engagementStats: EditionFragment_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: EditionFragment_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: EditionFragment_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: EditionFragment_audience | null;
  /**
   * The address to send this edition from
   */
  from: EditionFragment_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: EditionFragment_delay | null;
  /**
   * The number of emails sent for this edition
   */
  numSentEmails: number;
  /**
   * The custom click domain that this edition will use to track links, if there is one
   */
  customClickDomain: EditionFragment_customClickDomain | null;
  utmParameters: EditionFragment_utmParameters;
  defaultUtmParameters: EditionFragment_defaultUtmParameters;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  useUtmParameters: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: EditionFragment_gateError | null;
  /**
   * Boolean indicating if the edition is using a web font.
   */
  hasWebFonts: boolean;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: EditionFragment_queuedDripProgressions | null;
  /**
   * The maximum number of recipients this edition can send to, if DMARC is not
   * fully configured. This is only relevant for non-drip sequence editions.
   */
  recipientLimitForDeliverability: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EditionStubFragment
// ====================================================

export interface EditionStubFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EditionStubFragment_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EditionStubFragment_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EditionStubFragment_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface EditionStubFragment_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: EditionStubFragment_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: EditionStubFragment_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: EditionStubFragment_campaign_nextSendingEdition | null;
}

export interface EditionStubFragment_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface EditionStubFragment_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: EditionStubFragment_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface EditionStubFragment_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: EditionStubFragment_emailTemplate_links[];
}

export interface EditionStubFragment_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface EditionStubFragment_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface EditionStubFragment_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: EditionStubFragment_comparisonEdition_emailTemplate_links_url | null;
}

export interface EditionStubFragment_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: EditionStubFragment_comparisonEdition_emailTemplate_links[];
}

export interface EditionStubFragment_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: EditionStubFragment_comparisonEdition_emailTemplate | null;
}

export interface EditionStubFragment_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface EditionStubFragment_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface EditionStubFragment_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: EditionStubFragment_comparison_winnerEdition_emailTemplate | null;
}

export interface EditionStubFragment_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface EditionStubFragment_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EditionStubFragment_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: EditionStubFragment_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: EditionStubFragment_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: EditionStubFragment_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: EditionStubFragment_comparison_winningEdition | null;
}

export interface EditionStubFragment_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface EditionStubFragment_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
}

export interface EditionStubFragment_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: EditionStubFragment_from_emailAddress;
}

export interface EditionStubFragment_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface EditionStubFragment {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: EditionStubFragment_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: EditionStubFragment_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: EditionStubFragment_emailTemplate | null;
  engagementStats: EditionStubFragment_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: EditionStubFragment_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: EditionStubFragment_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: EditionStubFragment_audience | null;
  /**
   * The address to send this edition from
   */
  from: EditionStubFragment_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: EditionStubFragment_delay | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: NewsletterFragment
// ====================================================

export interface NewsletterFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface NewsletterFragment_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface NewsletterFragment_lastSentEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  sendTime: any | null;
}

export interface NewsletterFragment_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
}

export interface NewsletterFragment_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface NewsletterFragment {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  creatorUser: NewsletterFragment_creatorUser | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  editions: NewsletterFragment_editions;
  lastSentEdition: NewsletterFragment_lastSentEdition | null;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the campaign was last modified
   */
  modifiedTime: any | null;
  engagementStats: NewsletterFragment_engagementStats;
  /**
   * The number of archived editions on this campaign.
   */
  archivedEditionCount: number;
  nextSendingEdition: NewsletterFragment_nextSendingEdition | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: NewsletterStubFragment
// ====================================================

export interface NewsletterStubFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface NewsletterStubFragment_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface NewsletterStubFragment_lastSentEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  sendTime: any | null;
}

export interface NewsletterStubFragment_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
}

export interface NewsletterStubFragment {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  creatorUser: NewsletterStubFragment_creatorUser | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  editions: NewsletterStubFragment_editions;
  lastSentEdition: NewsletterStubFragment_lastSentEdition | null;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the campaign was last modified
   */
  modifiedTime: any | null;
  engagementStats: NewsletterStubFragment_engagementStats;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SavedFilterFragment
// ====================================================

export interface SavedFilterFragment_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface SavedFilterFragment {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The DateTime that represents when the saved filter was created. This is sometimes not set for built-in filters.
   */
  createdTime: any | null;
  /**
   * The count of entities in this list
   */
  count: SavedFilterFragment_count;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: TemplateFragment
// ====================================================

export interface TemplateFragment_edition_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface TemplateFragment_edition_campaign_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface TemplateFragment_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface TemplateFragment_edition_campaign_nextSendingEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  scheduledTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface TemplateFragment_edition_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: TemplateFragment_edition_campaign_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: TemplateFragment_edition_campaign_owner | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  nextSendingEdition: TemplateFragment_edition_campaign_nextSendingEdition | null;
}

export interface TemplateFragment_edition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface TemplateFragment_edition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: TemplateFragment_edition_emailTemplate_links_url | null;
  link: string;
  numTimesSent: number;
  numTotalClicks: number;
  numUniqueClicks: number;
}

export interface TemplateFragment_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * All links in this email template
   */
  links: TemplateFragment_edition_emailTemplate_links[];
  name: string;
  /**
   * The body of the email template for web display
   */
  bodyForWeb: string;
}

export interface TemplateFragment_edition_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
}

export interface TemplateFragment_edition_comparisonEdition_emailTemplate_links_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface TemplateFragment_edition_comparisonEdition_emailTemplate_links {
  __typename: "EmailTemplateLink";
  url: TemplateFragment_edition_comparisonEdition_emailTemplate_links_url | null;
}

export interface TemplateFragment_edition_comparisonEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * All links in this email template
   */
  links: TemplateFragment_edition_comparisonEdition_emailTemplate_links[];
}

export interface TemplateFragment_edition_comparisonEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: TemplateFragment_edition_comparisonEdition_emailTemplate | null;
}

export interface TemplateFragment_edition_comparison_testPeriodLength {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface TemplateFragment_edition_comparison_winnerEdition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
  /**
   * The last time this email template was edited.
   */
  modifiedTime: any | null;
  /**
   * The raw saved body json of the email template from the bee editor.
   */
  beeBodyJson: string | null;
}

export interface TemplateFragment_edition_comparison_winnerEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  sendTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * The email template for this edition
   */
  emailTemplate: TemplateFragment_edition_comparison_winnerEdition_emailTemplate | null;
}

export interface TemplateFragment_edition_comparison_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
}

export interface TemplateFragment_edition_comparison_winningEdition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface TemplateFragment_edition_comparison {
  __typename: "Comparison";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
  fallbackEdition: ComparisonEditionType;
  winningMetric: ComparisonMetricType;
  /**
   * The time the test was sent
   */
  startTime: any | null;
  testPeriodLength: TemplateFragment_edition_comparison_testPeriodLength;
  /**
   * The percentage of the audience to send the test to (includes both versions)
   */
  sendPercentage: number;
  /**
   * The winning edition
   */
  winnerEdition: TemplateFragment_edition_comparison_winnerEdition | null;
  /**
   * Engagement stats for all editions in this comparison
   */
  engagementStats: TemplateFragment_edition_comparison_engagementStats;
  /**
   * The edition currently winning the a/b test
   */
  winningEdition: TemplateFragment_edition_comparison_winningEdition | null;
}

export interface TemplateFragment_edition_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface TemplateFragment_edition_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: TemplateFragment_edition_audience_fromSavedFilter_count;
}

export interface TemplateFragment_edition_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface TemplateFragment_edition_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: TemplateFragment_edition_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface TemplateFragment_edition_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface TemplateFragment_edition_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: TemplateFragment_edition_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface TemplateFragment_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: TemplateFragment_edition_audience_fromSavedFilter | null;
  membershipStats: TemplateFragment_edition_audience_membershipStats;
  smsMembershipStats: TemplateFragment_edition_audience_smsMembershipStats;
}

export interface TemplateFragment_edition_from_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  formatted: string;
  address: string;
}

export interface TemplateFragment_edition_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface TemplateFragment_edition_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: TemplateFragment_edition_from_emailAddress;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: TemplateFragment_edition_from_fromDomain | null;
}

export interface TemplateFragment_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface TemplateFragment_edition_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface TemplateFragment_edition_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface TemplateFragment_edition_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
  /**
   * The campaign utm parameter.
   */
  campaign: string | null;
}

export interface TemplateFragment_edition_gateError {
  __typename: "GateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface TemplateFragment_edition_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface TemplateFragment_edition_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface TemplateFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface TemplateFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface TemplateFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: TemplateFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface TemplateFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: TemplateFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface TemplateFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface TemplateFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: TemplateFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface TemplateFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: TemplateFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: TemplateFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type TemplateFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity = TemplateFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Account | TemplateFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface TemplateFragment_edition_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: TemplateFragment_edition_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: TemplateFragment_edition_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface TemplateFragment_edition_queuedDripProgressions_edges_node {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: TemplateFragment_edition_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface TemplateFragment_edition_queuedDripProgressions_edges {
  __typename: "EditionDripProgressionEdge";
  node: TemplateFragment_edition_queuedDripProgressions_edges_node;
}

export interface TemplateFragment_edition_queuedDripProgressions {
  __typename: "EditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: TemplateFragment_edition_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: TemplateFragment_edition_queuedDripProgressions_edges[];
}

export interface TemplateFragment_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  creatorUser: TemplateFragment_edition_creatorUser | null;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: TemplateFragment_edition_campaign;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The email template for this edition
   */
  emailTemplate: TemplateFragment_edition_emailTemplate | null;
  engagementStats: TemplateFragment_edition_engagementStats;
  sendTime: any | null;
  scheduledTime: any | null;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The comparison test for this edition
   */
  comparisonEdition: TemplateFragment_edition_comparisonEdition | null;
  /**
   * The comparison test for this edition
   */
  comparison: TemplateFragment_edition_comparison | null;
  /**
   * The audience to send this edition to
   */
  audience: TemplateFragment_edition_audience | null;
  /**
   * The address to send this edition from
   */
  from: TemplateFragment_edition_from | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: TemplateFragment_edition_delay | null;
  /**
   * The number of emails sent for this edition
   */
  numSentEmails: number;
  /**
   * The custom click domain that this edition will use to track links, if there is one
   */
  customClickDomain: TemplateFragment_edition_customClickDomain | null;
  utmParameters: TemplateFragment_edition_utmParameters;
  defaultUtmParameters: TemplateFragment_edition_defaultUtmParameters;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  useUtmParameters: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: TemplateFragment_edition_gateError | null;
  /**
   * Boolean indicating if the edition is using a web font.
   */
  hasWebFonts: boolean;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: TemplateFragment_edition_queuedDripProgressions | null;
  /**
   * The maximum number of recipients this edition can send to, if DMARC is not
   * fully configured. This is only relevant for non-drip sequence editions.
   */
  recipientLimitForDeliverability: number | null;
}

export interface TemplateFragment {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  edition: TemplateFragment_edition;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailMembershipStatsFragment
// ====================================================

export interface EmailMembershipStatsFragment_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EmailMembershipStatsFragment {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: EmailMembershipStatsFragment_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EngagementStats
// ====================================================

export interface EngagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: NutshellMarketingStats
// ====================================================

export interface NutshellMarketingStats_usageStats {
  __typename: "UsageStats";
  /**
   * The number of emails this account has sent this month
   */
  numberOfEmailsSentThisMonth: number;
  /**
   * The number of marketable contacts this account has
   */
  numberOfMarketableContacts: number;
}

export interface NutshellMarketingStats_gate {
  __typename: "Gate";
  /**
   * The max number of emails this account can send in a month
   */
  maxNumberOfEmailsPerMonth: number | null;
  /**
   * The max number of marketable contacts this account can have
   */
  maxNumberOfMarketableContacts: number | null;
  /**
   * The number of marketable contacts over the limit - if under this number we allow sending a test email
   */
  marketingContactsOverageAllowance: number | null;
  /**
   * Whether this account has unlimited marketing contacts - if true we allow
   * sending a test email as long as their email limit is not exceeded
   */
  hasUnlimitedMarketingContacts: boolean;
  /**
   * True if they have marketingContactsOverageAllowance set to null or 1
   * (indicating unlimited contacts) or a number besides 0 (a manual limit). Used
   * to determine whether to show overage text in the marketing sidebar.
   */
  hasOveragesEnabledFromWebfx: boolean;
}

export interface NutshellMarketingStats {
  __typename: "NutshellMarketingStats";
  /**
   * The number of emails this account has sent this month
   */
  usageStats: NutshellMarketingStats_usageStats;
  /**
   * The number of marketable contacts this account has
   */
  gate: NutshellMarketingStats_gate;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmsMembershipStatsFragment
// ====================================================

export interface SmsMembershipStatsFragment_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface SmsMembershipStatsFragment {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: SmsMembershipStatsFragment_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ProspectorContactsFragment
// ====================================================

export interface ProspectorContactsFragment_companySize {
  __typename: "NumericalRange";
  /**
   * The lower bound of the range (inclusive)
   */
  gte: number | null;
  /**
   * The upper bound of the range (inclusive)
   */
  lte: number | null;
}

export interface ProspectorContactsFragment_companyRevenue {
  __typename: "NumericalRange";
  /**
   * The lower bound of the range (inclusive)
   */
  gte: number | null;
  /**
   * The upper bound of the range (inclusive)
   */
  lte: number | null;
}

export interface ProspectorContactsFragment {
  __typename: "McfxViqContact";
  /**
   * The (external) id for this Viq person
   */
  id: string;
  /**
   * The (external) id for this Viq person
   */
  fullName: string;
  /**
   * Whether this Viq person has a valid phone number
   */
  hasPhone: boolean;
  /**
   * Whether this Viq person has a valid email address
   */
  hasEmail: boolean;
  /**
   * Whether this Viq person has a LinkedIn Url we know about
   */
  hasLinkedinUrl: boolean;
  /**
   * The location of this Viq person
   */
  location: string | null;
  /**
   * The job title of this Viq person
   */
  jobTitle: string | null;
  /**
   * The position of this Viq person
   */
  position: string | null;
  /**
   * The job title role of this person
   */
  industry: string | null;
  /**
   * The size of the company this person works for
   */
  companySize: ProspectorContactsFragment_companySize | null;
  /**
   * The name of the company this person works for
   */
  companyName: string | null;
  /**
   * The location of the company this person works for
   */
  companyLocation: string | null;
  /**
   * The industry of the company this person works for
   */
  companyIndustry: string | null;
  /**
   * The website of the company this person works for
   */
  companyWebsite: string | null;
  /**
   * The revenue of the company this person works for
   */
  companyRevenue: ProspectorContactsFragment_companyRevenue | null;
  /**
   * The initials of the person
   */
  initials: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ProspectorSavedFilterFragment
// ====================================================

export interface ProspectorSavedFilterFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ProspectorSavedFilterFragment {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The url path of the saved filter
   */
  htmlUrl: string;
  /**
   * The DateTime that represents when the saved filter was created. This is sometimes not set for built-in filters.
   */
  createdTime: any | null;
  /**
   * The user who created the saved filter
   */
  creatorUser: ProspectorSavedFilterFragment_creatorUser | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: NutshellMarketingBannerInfo
// ====================================================

export interface NutshellMarketingBannerInfo_gate_error {
  __typename: "GateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface NutshellMarketingBannerInfo_gate {
  __typename: "Gate";
  /**
   * The error, if any, for gating email sending
   */
  error: NutshellMarketingBannerInfo_gate_error | null;
}

export interface NutshellMarketingBannerInfo {
  __typename: "NutshellMarketingStats";
  /**
   * The number of marketable contacts this account has
   */
  gate: NutshellMarketingBannerInfo_gate;
  /**
   * Boolean describing whether to show the import unsubscribes banner
   */
  shouldShowImportUnsubscribesBanner: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AutomationActionFragment
// ====================================================

export interface AutomationActionFragment_config_ActionConfigRemoveTags {
  __typename: "ActionConfigRemoveTags" | "ActionConfigSendEmail";
}

export interface AutomationActionFragment_config_ActionConfigAddTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface AutomationActionFragment_config_ActionConfigAddTags {
  __typename: "ActionConfigAddTags";
  /**
   * The boolean value to filter on.
   */
  tags: AutomationActionFragment_config_ActionConfigAddTags_tags[];
}

export interface AutomationActionFragment_config_ActionConfigAddAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface AutomationActionFragment_config_ActionConfigAddAudiences {
  __typename: "ActionConfigAddAudiences";
  /**
   * The boolean value to filter on.
   */
  audiences: AutomationActionFragment_config_ActionConfigAddAudiences_audiences[];
}

export interface AutomationActionFragment_config_ActionConfigRemoveAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface AutomationActionFragment_config_ActionConfigRemoveAudiences {
  __typename: "ActionConfigRemoveAudiences";
  /**
   * The boolean value to filter on.
   */
  audiences: AutomationActionFragment_config_ActionConfigRemoveAudiences_audiences[];
}

export interface AutomationActionFragment_config_ActionConfigSendPageViewedNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface AutomationActionFragment_config_ActionConfigSendPageViewedNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
  /**
   * Specific type of alias
   */
  type: NotifiableAliasType;
}

export type AutomationActionFragment_config_ActionConfigSendPageViewedNotification_notifiables = AutomationActionFragment_config_ActionConfigSendPageViewedNotification_notifiables_User | AutomationActionFragment_config_ActionConfigSendPageViewedNotification_notifiables_NotifiableAlias;

export interface AutomationActionFragment_config_ActionConfigSendPageViewedNotification {
  __typename: "ActionConfigSendPageViewedNotification";
  /**
   * The users or aliases to which the notification should be sent.
   */
  notifiables: AutomationActionFragment_config_ActionConfigSendPageViewedNotification_notifiables[];
}

export interface AutomationActionFragment_config_ActionConfigAddToDripSequence_dripSequence {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface AutomationActionFragment_config_ActionConfigAddToDripSequence {
  __typename: "ActionConfigAddToDripSequence";
  /**
   * The drip sequence to which the contact should be added.
   */
  dripSequence: AutomationActionFragment_config_ActionConfigAddToDripSequence_dripSequence;
}

export interface AutomationActionFragment_config_ActionConfigCreateLead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface AutomationActionFragment_config_ActionConfigCreateLead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface AutomationActionFragment_config_ActionConfigCreateLead_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface AutomationActionFragment_config_ActionConfigCreateLead_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface AutomationActionFragment_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type AutomationActionFragment_config_ActionConfigCreateLead_assigneeOrRule = AutomationActionFragment_config_ActionConfigCreateLead_assigneeOrRule_User | AutomationActionFragment_config_ActionConfigCreateLead_assigneeOrRule_Team | AutomationActionFragment_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule;

export interface AutomationActionFragment_config_ActionConfigCreateLead {
  __typename: "ActionConfigCreateLead";
  /**
   * The stageset to which the lead should be added.
   */
  stageset: AutomationActionFragment_config_ActionConfigCreateLead_stageset;
  /**
   * The tags which should be added to the lead.
   */
  tags: AutomationActionFragment_config_ActionConfigCreateLead_tags[];
  /**
   * The assignee for the lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: AutomationActionFragment_config_ActionConfigCreateLead_assigneeOrRule | null;
}

export type AutomationActionFragment_config = AutomationActionFragment_config_ActionConfigRemoveTags | AutomationActionFragment_config_ActionConfigAddTags | AutomationActionFragment_config_ActionConfigAddAudiences | AutomationActionFragment_config_ActionConfigRemoveAudiences | AutomationActionFragment_config_ActionConfigSendPageViewedNotification | AutomationActionFragment_config_ActionConfigAddToDripSequence | AutomationActionFragment_config_ActionConfigCreateLead;

export interface AutomationActionFragment {
  __typename: "Action";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * The configuration for this action.
   */
  config: AutomationActionFragment_config;
  /**
   * Human readable title of this action
   */
  humanReadableTitle: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: MarketingAutomationFragment
// ====================================================

export interface MarketingAutomationFragment_actions_config_ActionConfigRemoveTags {
  __typename: "ActionConfigRemoveTags" | "ActionConfigSendEmail";
}

export interface MarketingAutomationFragment_actions_config_ActionConfigAddTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface MarketingAutomationFragment_actions_config_ActionConfigAddTags {
  __typename: "ActionConfigAddTags";
  /**
   * The boolean value to filter on.
   */
  tags: MarketingAutomationFragment_actions_config_ActionConfigAddTags_tags[];
}

export interface MarketingAutomationFragment_actions_config_ActionConfigAddAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface MarketingAutomationFragment_actions_config_ActionConfigAddAudiences {
  __typename: "ActionConfigAddAudiences";
  /**
   * The boolean value to filter on.
   */
  audiences: MarketingAutomationFragment_actions_config_ActionConfigAddAudiences_audiences[];
}

export interface MarketingAutomationFragment_actions_config_ActionConfigRemoveAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface MarketingAutomationFragment_actions_config_ActionConfigRemoveAudiences {
  __typename: "ActionConfigRemoveAudiences";
  /**
   * The boolean value to filter on.
   */
  audiences: MarketingAutomationFragment_actions_config_ActionConfigRemoveAudiences_audiences[];
}

export interface MarketingAutomationFragment_actions_config_ActionConfigSendPageViewedNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface MarketingAutomationFragment_actions_config_ActionConfigSendPageViewedNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
  /**
   * Specific type of alias
   */
  type: NotifiableAliasType;
}

export type MarketingAutomationFragment_actions_config_ActionConfigSendPageViewedNotification_notifiables = MarketingAutomationFragment_actions_config_ActionConfigSendPageViewedNotification_notifiables_User | MarketingAutomationFragment_actions_config_ActionConfigSendPageViewedNotification_notifiables_NotifiableAlias;

export interface MarketingAutomationFragment_actions_config_ActionConfigSendPageViewedNotification {
  __typename: "ActionConfigSendPageViewedNotification";
  /**
   * The users or aliases to which the notification should be sent.
   */
  notifiables: MarketingAutomationFragment_actions_config_ActionConfigSendPageViewedNotification_notifiables[];
}

export interface MarketingAutomationFragment_actions_config_ActionConfigAddToDripSequence_dripSequence {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface MarketingAutomationFragment_actions_config_ActionConfigAddToDripSequence {
  __typename: "ActionConfigAddToDripSequence";
  /**
   * The drip sequence to which the contact should be added.
   */
  dripSequence: MarketingAutomationFragment_actions_config_ActionConfigAddToDripSequence_dripSequence;
}

export interface MarketingAutomationFragment_actions_config_ActionConfigCreateLead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface MarketingAutomationFragment_actions_config_ActionConfigCreateLead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface MarketingAutomationFragment_actions_config_ActionConfigCreateLead_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface MarketingAutomationFragment_actions_config_ActionConfigCreateLead_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface MarketingAutomationFragment_actions_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type MarketingAutomationFragment_actions_config_ActionConfigCreateLead_assigneeOrRule = MarketingAutomationFragment_actions_config_ActionConfigCreateLead_assigneeOrRule_User | MarketingAutomationFragment_actions_config_ActionConfigCreateLead_assigneeOrRule_Team | MarketingAutomationFragment_actions_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule;

export interface MarketingAutomationFragment_actions_config_ActionConfigCreateLead {
  __typename: "ActionConfigCreateLead";
  /**
   * The stageset to which the lead should be added.
   */
  stageset: MarketingAutomationFragment_actions_config_ActionConfigCreateLead_stageset;
  /**
   * The tags which should be added to the lead.
   */
  tags: MarketingAutomationFragment_actions_config_ActionConfigCreateLead_tags[];
  /**
   * The assignee for the lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: MarketingAutomationFragment_actions_config_ActionConfigCreateLead_assigneeOrRule | null;
}

export type MarketingAutomationFragment_actions_config = MarketingAutomationFragment_actions_config_ActionConfigRemoveTags | MarketingAutomationFragment_actions_config_ActionConfigAddTags | MarketingAutomationFragment_actions_config_ActionConfigAddAudiences | MarketingAutomationFragment_actions_config_ActionConfigRemoveAudiences | MarketingAutomationFragment_actions_config_ActionConfigSendPageViewedNotification | MarketingAutomationFragment_actions_config_ActionConfigAddToDripSequence | MarketingAutomationFragment_actions_config_ActionConfigCreateLead;

export interface MarketingAutomationFragment_actions {
  __typename: "Action";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * The configuration for this action.
   */
  config: MarketingAutomationFragment_actions_config;
  /**
   * Human readable title of this action
   */
  humanReadableTitle: string;
}

export interface MarketingAutomationFragment {
  __typename: "Automation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of this automation.
   */
  type: number;
  /**
   * Actions that will be taken when this automation is activated.
   */
  actions: MarketingAutomationFragment_actions[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: NewsletterEngagementStats
// ====================================================

export interface NewsletterEngagementStats_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
}

export interface NewsletterEngagementStats_editions_edges_node_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
}

export interface NewsletterEngagementStats_editions_edges_node_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
}

export interface NewsletterEngagementStats_editions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The email template for this edition
   */
  emailTemplate: NewsletterEngagementStats_editions_edges_node_emailTemplate | null;
  sendTime: any | null;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  engagementStats: NewsletterEngagementStats_editions_edges_node_engagementStats;
}

export interface NewsletterEngagementStats_editions_edges {
  __typename: "EditionsEdge";
  node: NewsletterEngagementStats_editions_edges_node;
}

export interface NewsletterEngagementStats_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: NewsletterEngagementStats_editions_edges[];
}

export interface NewsletterEngagementStats {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  engagementStats: NewsletterEngagementStats_engagementStats;
  editions: NewsletterEngagementStats_editions;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PreferenceCenterAudience
// ====================================================

export interface PreferenceCenterAudience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface PreferenceCenterAudience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  totalCount: PreferenceCenterAudience_membershipStats_totalCount;
}

export interface PreferenceCenterAudience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The public name of this audience
   */
  publicName: string;
  /**
   * The description of this audience
   */
  description: string | null;
  /**
   * The public description of this audience
   */
  publicDescription: string | null;
  /**
   * Is this audience on the preference center?
   */
  isPublic: boolean;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  deletedTime: any | null;
  /**
   * The last time an email or SMS edition was sent to this audience
   */
  lastContactedTime: any | null;
  membershipStats: PreferenceCenterAudience_membershipStats;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmsBroadcastEngagementStatsFragment
// ====================================================

export interface SmsBroadcastEngagementStatsFragment_edition_engagementStats {
  __typename: "SmsEngagementStats";
  /**
   * Total number of texts we tried to send
   */
  totalSentCount: number;
  /**
   * Total number of people who responded to the SMS campaign
   */
  responseCount: number;
  /**
   * The ratio of response to total texts sent
   */
  responseRate: number | null;
  /**
   * Total number of texts which couldn’t be delivered
   */
  undeliveredCount: number;
  /**
   * The ratio of undelivered texts to total texts sent
   */
  undeliveredRate: number | null;
  /**
   * The number of people who opted out of SMS messages after receiving this campaign
   */
  optoutCount: number;
  /**
   * The ratio of optouts to total texts sent
   */
  optoutRate: number | null;
}

export interface SmsBroadcastEngagementStatsFragment_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  engagementStats: SmsBroadcastEngagementStatsFragment_edition_engagementStats;
}

export interface SmsBroadcastEngagementStatsFragment {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The edition of the broadcast
   */
  edition: SmsBroadcastEngagementStatsFragment_edition;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmsBroadcastFragment
// ====================================================

export interface SmsBroadcastFragment_edition_from_phone {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface SmsBroadcastFragment_edition_from {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
  phone: SmsBroadcastFragment_edition_from_phone | null;
}

export interface SmsBroadcastFragment_edition_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SmsBroadcastFragment_edition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The user who owns this campaign
   */
  owner: SmsBroadcastFragment_edition_campaign_owner | null;
}

export interface SmsBroadcastFragment_edition_engagementStats {
  __typename: "SmsEngagementStats";
  /**
   * Total number of texts we tried to send
   */
  totalSentCount: number;
  /**
   * Total number of people who responded to the SMS campaign
   */
  responseCount: number;
  /**
   * The ratio of response to total texts sent
   */
  responseRate: number | null;
  /**
   * Total number of texts which couldn’t be delivered
   */
  undeliveredCount: number;
  /**
   * The ratio of undelivered texts to total texts sent
   */
  undeliveredRate: number | null;
  /**
   * The number of people who opted out of SMS messages after receiving this campaign
   */
  optoutCount: number;
  /**
   * The ratio of optouts to total texts sent
   */
  optoutRate: number | null;
}

export interface SmsBroadcastFragment_edition_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface SmsBroadcastFragment_edition_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: SmsBroadcastFragment_edition_audience_fromSavedFilter_count;
}

export interface SmsBroadcastFragment_edition_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface SmsBroadcastFragment_edition_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: SmsBroadcastFragment_edition_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface SmsBroadcastFragment_edition_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface SmsBroadcastFragment_edition_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: SmsBroadcastFragment_edition_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface SmsBroadcastFragment_edition_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: SmsBroadcastFragment_edition_audience_fromSavedFilter | null;
  membershipStats: SmsBroadcastFragment_edition_audience_membershipStats;
  smsMembershipStats: SmsBroadcastFragment_edition_audience_smsMembershipStats;
}

export interface SmsBroadcastFragment_edition_gateError {
  __typename: "SmsGateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface SmsBroadcastFragment_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The content of the edition
   */
  content: string;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  scheduledTime: any | null;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The channel this edition was sent from
   */
  from: SmsBroadcastFragment_edition_from | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: SmsBroadcastFragment_edition_campaign;
  /**
   * The opt-out string in the message content
   */
  optOutText: string | null;
  engagementStats: SmsBroadcastFragment_edition_engagementStats;
  /**
   * The audience to send this edition to
   */
  audience: SmsBroadcastFragment_edition_audience | null;
  /**
   * If the content of the edition contains a link from a public URL shortener
   */
  hasShortLink: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: SmsBroadcastFragment_edition_gateError | null;
  /**
   * The number of SMS Campaigns credits this account has per month
   */
  smsCampaignsCreditLimit: number | null;
  /**
   * The number of SMS Campaigns credits this account has used per month
   */
  smsCampaignsCreditsUsed: number;
}

export interface SmsBroadcastFragment_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SmsBroadcastFragment {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The edition of the broadcast
   */
  edition: SmsBroadcastFragment_edition;
  /**
   * The user who owns this campaign
   */
  owner: SmsBroadcastFragment_owner | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmsBroadcastLightFragment
// ====================================================

export interface SmsBroadcastLightFragment_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The content of the edition
   */
  content: string;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  scheduledTime: any | null;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The opt-out string in the message content
   */
  optOutText: string | null;
}

export interface SmsBroadcastLightFragment_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SmsBroadcastLightFragment {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The edition of the broadcast
   */
  edition: SmsBroadcastLightFragment_edition;
  /**
   * The user who owns this campaign
   */
  owner: SmsBroadcastLightFragment_owner | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmsEditionFragment
// ====================================================

export interface SmsEditionFragment_from_phone {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface SmsEditionFragment_from {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
  phone: SmsEditionFragment_from_phone | null;
}

export interface SmsEditionFragment_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SmsEditionFragment_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The user who owns this campaign
   */
  owner: SmsEditionFragment_campaign_owner | null;
}

export interface SmsEditionFragment_engagementStats {
  __typename: "SmsEngagementStats";
  /**
   * Total number of texts we tried to send
   */
  totalSentCount: number;
  /**
   * Total number of people who responded to the SMS campaign
   */
  responseCount: number;
  /**
   * The ratio of response to total texts sent
   */
  responseRate: number | null;
  /**
   * Total number of texts which couldn’t be delivered
   */
  undeliveredCount: number;
  /**
   * The ratio of undelivered texts to total texts sent
   */
  undeliveredRate: number | null;
  /**
   * The number of people who opted out of SMS messages after receiving this campaign
   */
  optoutCount: number;
  /**
   * The ratio of optouts to total texts sent
   */
  optoutRate: number | null;
}

export interface SmsEditionFragment_audience_fromSavedFilter_count {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface SmsEditionFragment_audience_fromSavedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * The count of entities in this list
   */
  count: SmsEditionFragment_audience_fromSavedFilter_count;
}

export interface SmsEditionFragment_audience_membershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface SmsEditionFragment_audience_membershipStats {
  __typename: "AudienceMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: SmsEditionFragment_audience_membershipStats_totalCount;
  /**
   * The total count of members in this audience
   */
  subscribedCount: number;
  /**
   * The total count of members in this audience
   */
  unsubscribedCount: number;
  /**
   * The count of unique email addresses that have hard bounce or complaint
   */
  bouncedCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no email, duplicate email, or bounce/complaint)
   */
  undeliverableCount: number;
  /**
   * Contacts excluded because they have no primary email address
   */
  noEmailCount: number;
  /**
   * Contacts excluded because they share an email address with another member of this audience
   */
  duplicateEmailCount: number;
  /**
   * The rate of unsubscribes in this audience
   */
  unsubscribedRate: number | null;
}

export interface SmsEditionFragment_audience_smsMembershipStats_totalCount {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface SmsEditionFragment_audience_smsMembershipStats {
  __typename: "AudienceSmsMembershipStats";
  /**
   * The total count of members in this audience
   */
  totalCount: SmsEditionFragment_audience_smsMembershipStats_totalCount;
  /**
   * The number of audience members subscribed to SMS solicitations
   */
  subscribedCount: number;
  /**
   * The number of audience members who have opted out of SMS solicitations
   */
  optedOutCount: number;
  /**
   * Number of audience members who have no associated primary phone number
   */
  missingPhoneNumberCount: number;
  /**
   * Number of audience members who have the same primary phone number as another member
   */
  duplicatePhoneNumberCount: number;
  /**
   * Contacts excluded for any undeliverability reason (no phone number, duplicate phone number, or opt out)
   */
  undeliverableCount: number;
}

export interface SmsEditionFragment_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * The type of audience this is
   */
  type: AudienceType;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
  /**
   * Is this audience currently syncing from WebFX?
   */
  isSyncing: boolean;
  /**
   * The URL that this audience links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl used for audiences on the People page
   */
  htmlUrlPathForList: string;
  /**
   * The saved filter from which the audience was created
   */
  fromSavedFilter: SmsEditionFragment_audience_fromSavedFilter | null;
  membershipStats: SmsEditionFragment_audience_membershipStats;
  smsMembershipStats: SmsEditionFragment_audience_smsMembershipStats;
}

export interface SmsEditionFragment_gateError {
  __typename: "SmsGateError";
  /**
   * The reason for this gate exception
   */
  reason: GateErrorReason;
  /**
   * The user-facing message explaining this exception
   */
  message: string;
}

export interface SmsEditionFragment {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The content of the edition
   */
  content: string;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  scheduledTime: any | null;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The channel this edition was sent from
   */
  from: SmsEditionFragment_from | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: SmsEditionFragment_campaign;
  /**
   * The opt-out string in the message content
   */
  optOutText: string | null;
  engagementStats: SmsEditionFragment_engagementStats;
  /**
   * The audience to send this edition to
   */
  audience: SmsEditionFragment_audience | null;
  /**
   * If the content of the edition contains a link from a public URL shortener
   */
  hasShortLink: boolean;
  /**
   * The sending error, if there is one.
   */
  gateError: SmsEditionFragment_gateError | null;
  /**
   * The number of SMS Campaigns credits this account has per month
   */
  smsCampaignsCreditLimit: number | null;
  /**
   * The number of SMS Campaigns credits this account has used per month
   */
  smsCampaignsCreditsUsed: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmsEditionLightFragment
// ====================================================

export interface SmsEditionLightFragment {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The content of the edition
   */
  content: string;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  scheduledTime: any | null;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The opt-out string in the message content
   */
  optOutText: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmsDripEditionFragment
// ====================================================

export interface SmsDripEditionFragment_from_phone {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface SmsDripEditionFragment_from {
  __typename: "InboxChannel";
  phone: SmsDripEditionFragment_from_phone | null;
}

export interface SmsDripEditionFragment_campaign_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SmsDripEditionFragment_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The user who owns this campaign
   */
  owner: SmsDripEditionFragment_campaign_owner | null;
}

export interface SmsDripEditionFragment_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface SmsDripEditionFragment_engagementStats {
  __typename: "SmsEngagementStats";
  /**
   * Total number of texts we tried to send
   */
  totalSentCount: number;
  /**
   * Total number of people who responded to the SMS campaign
   */
  responseCount: number;
  /**
   * The ratio of response to total texts sent
   */
  responseRate: number | null;
  /**
   * Total number of texts which couldn’t be delivered
   */
  undeliveredCount: number;
  /**
   * The ratio of undelivered texts to total texts sent
   */
  undeliveredRate: number | null;
  /**
   * The number of people who opted out of SMS messages after receiving this campaign
   */
  optoutCount: number;
  /**
   * The ratio of optouts to total texts sent
   */
  optoutRate: number | null;
  /**
   * The ratio of goals met to total drip editions sent
   */
  dripProgressionsGoalMetRate: number | null;
  /**
   * The number of times the goal was met for this (drip) edition
   */
  goalMetCount: number | null;
}

export interface SmsDripEditionFragment_queuedDripProgressions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface SmsDripEditionFragment_queuedDripProgressions_edges_node_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SmsDripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SmsDripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface SmsDripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: SmsDripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface SmsDripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: SmsDripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface SmsDripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface SmsDripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: SmsDripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts_primary | null;
}

export interface SmsDripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: SmsDripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: SmsDripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact_accounts;
}

export type SmsDripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity = SmsDripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Account | SmsDripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity_Contact;

export interface SmsDripEditionFragment_queuedDripProgressions_edges_node_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: SmsDripEditionFragment_queuedDripProgressions_edges_node_audienceMember_audience;
  /**
   * The member entity
   */
  entity: SmsDripEditionFragment_queuedDripProgressions_edges_node_audienceMember_entity;
}

export interface SmsDripEditionFragment_queuedDripProgressions_edges_node {
  __typename: "SmsDripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: SmsDripEditionFragment_queuedDripProgressions_edges_node_audienceMember;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
}

export interface SmsDripEditionFragment_queuedDripProgressions_edges {
  __typename: "SmsEditionDripProgressionEdge";
  node: SmsDripEditionFragment_queuedDripProgressions_edges_node;
}

export interface SmsDripEditionFragment_queuedDripProgressions {
  __typename: "SmsEditionDripProgressionConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: SmsDripEditionFragment_queuedDripProgressions_pageInfo;
  /**
   * A list of edges.
   */
  edges: SmsDripEditionFragment_queuedDripProgressions_edges[];
}

export interface SmsDripEditionFragment {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The content of the edition
   */
  content: string;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The deleted time for the edition if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  /**
   * Last time this drip edition was sent
   */
  lastSentTime: any | null;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * The channel this edition was sent from
   */
  from: SmsDripEditionFragment_from | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: SmsDripEditionFragment_campaign;
  /**
   * The opt-out string in the message content
   */
  optOutText: string | null;
  /**
   * Whether the edition is the first in the drip sequence
   */
  isFirstEdition: boolean;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: SmsDripEditionFragment_delay | null;
  engagementStats: SmsDripEditionFragment_engagementStats;
  /**
   * Drip progressions queued to send this edition next
   */
  queuedDripProgressions: SmsDripEditionFragment_queuedDripProgressions | null;
  /**
   * If the content of the edition contains a link from a public URL shortener
   */
  hasShortLink: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmsDripSequenceFragment
// ====================================================

export interface SmsDripSequenceFragment_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface SmsDripSequenceFragment_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SmsDripSequenceFragment_from_phone {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface SmsDripSequenceFragment_from {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
  phone: SmsDripSequenceFragment_from_phone | null;
}

export interface SmsDripSequenceFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SmsDripSequenceFragment_startTrigger_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface SmsDripSequenceFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface SmsDripSequenceFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface SmsDripSequenceFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type SmsDripSequenceFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter = SmsDripSequenceFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | SmsDripSequenceFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | SmsDripSequenceFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface SmsDripSequenceFragment_startTrigger_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: SmsDripSequenceFragment_startTrigger_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface SmsDripSequenceFragment_startTrigger_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface SmsDripSequenceFragment_startTrigger_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type SmsDripSequenceFragment_startTrigger_conditions_config = SmsDripSequenceFragment_startTrigger_conditions_config_ConditionConfigLink | SmsDripSequenceFragment_startTrigger_conditions_config_ConditionConfigEntityFilter | SmsDripSequenceFragment_startTrigger_conditions_config_ConditionConfigTag | SmsDripSequenceFragment_startTrigger_conditions_config_ConditionConfigAudience;

export interface SmsDripSequenceFragment_startTrigger_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: SmsDripSequenceFragment_startTrigger_conditions_config;
}

export interface SmsDripSequenceFragment_startTrigger {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of startTrigger
   */
  type: StartTriggerType;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * A list of conditions which must be true to activate this startTrigger.
   */
  conditions: SmsDripSequenceFragment_startTrigger_conditions[];
}

export interface SmsDripSequenceFragment_goal_conditions_config_ConditionConfigSourceEntity {
  __typename: "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface SmsDripSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface SmsDripSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface SmsDripSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type SmsDripSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter = SmsDripSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | SmsDripSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | SmsDripSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface SmsDripSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: SmsDripSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface SmsDripSequenceFragment_goal_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export interface SmsDripSequenceFragment_goal_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface SmsDripSequenceFragment_goal_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type SmsDripSequenceFragment_goal_conditions_config = SmsDripSequenceFragment_goal_conditions_config_ConditionConfigSourceEntity | SmsDripSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter | SmsDripSequenceFragment_goal_conditions_config_ConditionConfigLink | SmsDripSequenceFragment_goal_conditions_config_ConditionConfigTag | SmsDripSequenceFragment_goal_conditions_config_ConditionConfigAudience;

export interface SmsDripSequenceFragment_goal_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: SmsDripSequenceFragment_goal_conditions_config;
}

export interface SmsDripSequenceFragment_goal_action_config_ActionConfigRemoveTags {
  __typename: "ActionConfigRemoveTags" | "ActionConfigSendPageViewedNotification" | "ActionConfigAddToDripSequence" | "ActionConfigCreateLead" | "ActionConfigSendEmail";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
}

export interface SmsDripSequenceFragment_goal_action_config_ActionConfigAddTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface SmsDripSequenceFragment_goal_action_config_ActionConfigAddTags {
  __typename: "ActionConfigAddTags";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  tags: SmsDripSequenceFragment_goal_action_config_ActionConfigAddTags_tags[];
}

export interface SmsDripSequenceFragment_goal_action_config_ActionConfigAddAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface SmsDripSequenceFragment_goal_action_config_ActionConfigAddAudiences {
  __typename: "ActionConfigAddAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: SmsDripSequenceFragment_goal_action_config_ActionConfigAddAudiences_audiences[];
}

export interface SmsDripSequenceFragment_goal_action_config_ActionConfigRemoveAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface SmsDripSequenceFragment_goal_action_config_ActionConfigRemoveAudiences {
  __typename: "ActionConfigRemoveAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: SmsDripSequenceFragment_goal_action_config_ActionConfigRemoveAudiences_audiences[];
}

export type SmsDripSequenceFragment_goal_action_config = SmsDripSequenceFragment_goal_action_config_ActionConfigRemoveTags | SmsDripSequenceFragment_goal_action_config_ActionConfigAddTags | SmsDripSequenceFragment_goal_action_config_ActionConfigAddAudiences | SmsDripSequenceFragment_goal_action_config_ActionConfigRemoveAudiences;

export interface SmsDripSequenceFragment_goal_action {
  __typename: "Action";
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * Human readable title of this action
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this action. This is essentially just the
   * stringified version of the action’s conditions, but because a action can have
   * multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The configuration for this action.
   */
  config: SmsDripSequenceFragment_goal_action_config;
}

export interface SmsDripSequenceFragment_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Calculated goal type based on conditions. This is not saved in the database
   */
  type: DripSequenceGoalType;
  /**
   * A list of conditions which must be true to activate this goal.
   */
  conditions: SmsDripSequenceFragment_goal_conditions[];
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this goal. This is essentially just the stringified
   * version of the goal’s conditions, but because a goal can have multiple
   * conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The optional action (next step in this context) that will run when this goal is met
   */
  action: SmsDripSequenceFragment_goal_action | null;
}

export interface SmsDripSequenceFragment_engagementStats {
  __typename: "SmsEngagementStats";
  /**
   * Total number of texts we tried to send
   */
  totalSentCount: number;
  /**
   * The ratio of response to total texts sent
   */
  responseRate: number | null;
  /**
   * Total number of people who responded to the SMS campaign
   */
  responseCount: number;
  /**
   * The ratio of undelivered texts to total texts sent
   */
  undeliveredRate: number | null;
  /**
   * Total number of texts which couldn’t be delivered
   */
  undeliveredCount: number;
  /**
   * The number of people who opted out of SMS messages after receiving this campaign
   */
  optoutCount: number;
  /**
   * The ratio of optouts to total texts sent
   */
  optoutRate: number | null;
  /**
   * The ratio of people who received every message in the sequence to the total number of recipients
   */
  dripProgressionsReceivedEveryMessageRate: number | null;
  /**
   * The ratio of goals met to total drip editions sent
   */
  dripProgressionsGoalMetRate: number | null;
  /**
   * The number of people who have received or are scheduled to receive messages from this drip campaign
   */
  dripProgressionTotalRecipients: number | null;
}

export interface SmsDripSequenceFragment {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The editions of the drip sequence
   */
  editions: SmsDripSequenceFragment_editions;
  /**
   * The user who owns this campaign
   */
  owner: SmsDripSequenceFragment_owner | null;
  /**
   * The channel this edition was sent from
   */
  from: SmsDripSequenceFragment_from | null;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The DateTime that represents when the campaign was last modified
   */
  modifiedTime: any | null;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  creatorUser: SmsDripSequenceFragment_creatorUser | null;
  /**
   * Should messages only be sent during business hours.
   */
  isBusinessHoursOnly: boolean;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * When a lead is closed, should drip sequences stop?
   */
  isStopOnLeadClose: boolean;
  /**
   * When a person is removed from an audience, should drip sequences stop?
   */
  isStopOnRemovedFromAudience: boolean;
  /**
   * Time of the last campaign status change. For example, if a customer activated
   * this sequence and its still active, this would be the time the sequence was
   * activated. Once the campaign status is changed (paused, retired, etc) this
   * would reflect that new time
   */
  lastStatusChangeTime: any | null;
  /**
   * The start trigger for the drip sequence
   */
  startTrigger: SmsDripSequenceFragment_startTrigger | null;
  /**
   * The newly created Nutshell goal
   */
  goal: SmsDripSequenceFragment_goal | null;
  /**
   * Statistics about the engagement of this campaign
   */
  engagementStats: SmsDripSequenceFragment_engagementStats;
  /**
   * Number of in progress drip progressions for the drip sequence
   */
  numInProgressDripProgressions: number;
  /**
   * Whether the drip sequence should have a remove option
   */
  isRemovable: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmsEditionEngagementStatsFragment
// ====================================================

export interface SmsEditionEngagementStatsFragment {
  __typename: "SmsEngagementStats";
  /**
   * Total number of texts we tried to send
   */
  totalSentCount: number;
  /**
   * Total number of people who responded to the SMS campaign
   */
  responseCount: number;
  /**
   * The ratio of response to total texts sent
   */
  responseRate: number | null;
  /**
   * Total number of texts which couldn’t be delivered
   */
  undeliveredCount: number;
  /**
   * The ratio of undelivered texts to total texts sent
   */
  undeliveredRate: number | null;
  /**
   * The number of people who opted out of SMS messages after receiving this campaign
   */
  optoutCount: number;
  /**
   * The ratio of optouts to total texts sent
   */
  optoutRate: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: McfxCompanyFragment
// ====================================================

export interface McfxCompanyFragment_industry {
  __typename: "McfxIndustry";
  /**
   * The enum value of this industry
   */
  id: IndustryType;
  /**
   * The name of this industry
   */
  name: string;
}

export interface McfxCompanyFragment_annualRevenue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface McfxCompanyFragment_relatedAccount_leads_edges_node_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface McfxCompanyFragment_relatedAccount_leads_edges_node_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: McfxCompanyFragment_relatedAccount_leads_edges_node_contacts_primaryEdge_node;
}

export interface McfxCompanyFragment_relatedAccount_leads_edges_node_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: McfxCompanyFragment_relatedAccount_leads_edges_node_contacts_primaryEdge | null;
}

export interface McfxCompanyFragment_relatedAccount_leads_edges_node_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface McfxCompanyFragment_relatedAccount_leads_edges_node_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: McfxCompanyFragment_relatedAccount_leads_edges_node_accounts_primaryEdge_node;
}

export interface McfxCompanyFragment_relatedAccount_leads_edges_node_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: McfxCompanyFragment_relatedAccount_leads_edges_node_accounts_primaryEdge | null;
}

export interface McfxCompanyFragment_relatedAccount_leads_edges_node_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface McfxCompanyFragment_relatedAccount_leads_edges_node_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: McfxCompanyFragment_relatedAccount_leads_edges_node_value_formattedValue;
}

export interface McfxCompanyFragment_relatedAccount_leads_edges_node {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: McfxCompanyFragment_relatedAccount_leads_edges_node_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: McfxCompanyFragment_relatedAccount_leads_edges_node_accounts;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  value: McfxCompanyFragment_relatedAccount_leads_edges_node_value | null;
}

export interface McfxCompanyFragment_relatedAccount_leads_edges {
  __typename: "PeepLeadsEdge";
  node: McfxCompanyFragment_relatedAccount_leads_edges_node;
}

export interface McfxCompanyFragment_relatedAccount_leads {
  __typename: "PeepLeadsConnection";
  /**
   * A list of edges.
   */
  edges: McfxCompanyFragment_relatedAccount_leads_edges[];
}

export interface McfxCompanyFragment_relatedAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * Leads related to this peep
   */
  leads: McfxCompanyFragment_relatedAccount_leads;
}

export interface McfxCompanyFragment_primaryAddress_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface McfxCompanyFragment_primaryAddress {
  __typename: "EntityAttributeValueLocation";
  fullAddress: string | null;
  region: string | null;
  postalCode: string | null;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: McfxCompanyFragment_primaryAddress_coordinates | null;
}

export interface McfxCompanyFragment {
  __typename: "McfxCompany";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the company
   */
  name: string;
  /**
   * The initials of the company
   */
  initials: string | null;
  /**
   * This company’s website
   */
  url: string | null;
  /**
   * Phone numbers for the company
   */
  phones: string[];
  /**
   * The industry of the company
   */
  industry: McfxCompanyFragment_industry | null;
  /**
   * The number of employees the company
   */
  numEmployees: number | null;
  /**
   * The annual revenue of the company
   */
  annualRevenue: McfxCompanyFragment_annualRevenue | null;
  /**
   * Is this company locked (not yet revealed)
   */
  isLocked: boolean;
  /**
   * The time this company was created
   */
  createdTime: any;
  /**
   * The time this company was converted to a real Nutshell account
   */
  convertedTime: any | null;
  /**
   * The time this company was unlocked
   */
  unlockTime: any | null;
  /**
   * The time this company was last seen
   */
  lastSeenTime: any | null;
  /**
   * Whether this company was converted automatically because it already existed in Nutshell when added
   */
  wasConvertedAutomatically: boolean;
  /**
   * The total number of page visits in all sessions
   */
  numVisits: number;
  /**
   * The total duration of all page visits in all sessions
   */
  totalVisitDuration: number;
  /**
   * Url of the account created from this company
   */
  relatedAccount: McfxCompanyFragment_relatedAccount | null;
  /**
   * The location of the company
   */
  primaryAddress: McfxCompanyFragment_primaryAddress | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: VisitorIqFilterSettingsFragment
// ====================================================

export interface VisitorIqFilterSettingsFragment_mcfxIndustries_industry {
  __typename: "McfxIndustry";
  /**
   * The enum value of this industry
   */
  id: IndustryType;
  /**
   * The name of this industry
   */
  name: string;
}

export interface VisitorIqFilterSettingsFragment_mcfxIndustries {
  __typename: "IndustrySetting";
  /**
   * The industry that this setting relates to
   */
  industry: VisitorIqFilterSettingsFragment_mcfxIndustries_industry;
  /**
   * Whether this industry should be ignored in Nutshell
   */
  isBlocked: boolean;
}

export interface VisitorIqFilterSettingsFragment_contactInformationList_contactInformation {
  __typename: "ContactInformationDetail";
  /**
   * The enum value of this filter
   */
  id: ContactInformationType;
  /**
   * The name of this filter
   */
  name: string;
}

export interface VisitorIqFilterSettingsFragment_contactInformationList {
  __typename: "ContactInformationSetting";
  /**
   * The contact information that this setting relates to
   */
  contactInformation: VisitorIqFilterSettingsFragment_contactInformationList_contactInformation;
  /**
   * Whether this contact information should be ignored in Nutshell
   */
  isBlocked: boolean;
}

export interface VisitorIqFilterSettingsFragment_jobFieldList_jobField {
  __typename: "JobFieldDetail";
  /**
   * The enum value of this filter
   */
  id: JobFieldType;
  /**
   * The name of this filter
   */
  name: string;
}

export interface VisitorIqFilterSettingsFragment_jobFieldList {
  __typename: "JobFieldSetting";
  /**
   * The job field that this setting relates to
   */
  jobField: VisitorIqFilterSettingsFragment_jobFieldList_jobField;
  /**
   * Whether this job field should be ignored in Nutshell
   */
  isBlocked: boolean;
}

export interface VisitorIqFilterSettingsFragment_managementLevelList_managementLevel {
  __typename: "ManagementLevelDetail";
  /**
   * The enum value of this filter
   */
  id: ManagementLevelType;
  /**
   * The name of this filter
   */
  name: string;
}

export interface VisitorIqFilterSettingsFragment_managementLevelList {
  __typename: "ManagementLevelSetting";
  /**
   * The job field that this setting relates to
   */
  managementLevel: VisitorIqFilterSettingsFragment_managementLevelList_managementLevel;
  /**
   * Whether this job field should be ignored in Nutshell
   */
  isBlocked: boolean;
}

export interface VisitorIqFilterSettingsFragment {
  __typename: "FilterSettingsPayload";
  /**
   * The updated list of industries to include in Nutshell
   */
  mcfxIndustries: VisitorIqFilterSettingsFragment_mcfxIndustries[];
  /**
   * The list of contact information to include in Nutshell
   */
  contactInformationList: VisitorIqFilterSettingsFragment_contactInformationList[];
  /**
   * The list of job fields to include in Nutshell
   */
  jobFieldList: VisitorIqFilterSettingsFragment_jobFieldList[];
  /**
   * The list of management levels to include in Nutshell
   */
  managementLevelList: VisitorIqFilterSettingsFragment_managementLevelList[];
  /**
   * Visitor IQ only: page URLs to exclude from visitor results when visited
   */
  urlBlocklist: string[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailAutomationStatus
// ====================================================

export interface EmailAutomationStatus_sender {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface EmailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: EmailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses_primary_value;
}

export interface EmailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: EmailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface EmailAutomationStatus_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: EmailAutomationStatus_lead_contacts_primaryEdge_node_emailAddresses;
}

export interface EmailAutomationStatus_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: EmailAutomationStatus_lead_contacts_primaryEdge_node;
}

export interface EmailAutomationStatus_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EmailAutomationStatus_lead_contacts_primaryEdge | null;
}

export interface EmailAutomationStatus_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  avatarUrl: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: EmailAutomationStatus_lead_contacts;
}

export interface EmailAutomationStatus_emailAutomation_emailList_ConstantContactList {
  __typename: "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface EmailAutomationStatus_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailAutomationStatus_emailAutomation_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
  emailSequenceTemplateMessages: EmailAutomationStatus_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
}

export type EmailAutomationStatus_emailAutomation_emailList = EmailAutomationStatus_emailAutomation_emailList_ConstantContactList | EmailAutomationStatus_emailAutomation_emailList_EmailSequenceTemplate;

export interface EmailAutomationStatus_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: EmailAutomationStatus_emailAutomation_emailList | null;
}

export interface EmailAutomationStatus_emailSequence_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailAutomationStatus_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: EmailAutomationStatus_emailSequence_emailSequenceTemplate_creatorUser;
}

export interface EmailAutomationStatus_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
}

export interface EmailAutomationStatus_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailAutomationStatus_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailSequenceTemplate: EmailAutomationStatus_emailSequence_emailSequenceTemplate | null;
  emailsQueued: EmailAutomationStatus_emailSequence_emailsQueued[];
  /**
   * The next message to be sent
   */
  nextUnsentEmail: EmailAutomationStatus_emailSequence_nextUnsentEmail | null;
}

export interface EmailAutomationStatus_firstName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface EmailAutomationStatus_lastName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface EmailAutomationStatus_emailAddress {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface EmailAutomationStatus_companyName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface EmailAutomationStatus {
  __typename: "EmailAutomationStatus";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The message to show to the user
   */
  status: EmailAutomationStatusStatus;
  /**
   * Is this automation status paused?
   */
  isPaused: boolean;
  /**
   * Can this status be cancelled
   */
  canCancel: boolean;
  /**
   * Can this status be started
   */
  canStart: boolean;
  /**
   * The user that either did send this automation, or current _would_ send this
   * automation given the current context. For example, if the user is assigned to
   * a team, the logged in user is considered a potential sender if they’re on that team
   */
  sender: EmailAutomationStatus_sender | null;
  /**
   * Lead associated with this status row
   */
  lead: EmailAutomationStatus_lead;
  /**
   * Email list stage subscription associated with this status row
   */
  emailAutomation: EmailAutomationStatus_emailAutomation;
  /**
   * The actual email sequence going out for this lead in this stage
   */
  emailSequence: EmailAutomationStatus_emailSequence | null;
  /**
   * Status of the first name field
   */
  firstName: EmailAutomationStatus_firstName;
  /**
   * Status of the last name field
   */
  lastName: EmailAutomationStatus_lastName;
  /**
   * Status of the email address field
   */
  emailAddress: EmailAutomationStatus_emailAddress;
  /**
   * Status of the company name field
   */
  companyName: EmailAutomationStatus_companyName;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailStats
// ====================================================

export interface EmailStats {
  __typename: "EmailStats";
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  status: EmailHealthStatus | null;
  /**
   * A quick summary of the account email health. Used for health button.
   */
  summary: string;
  /**
   * The long description of the account email health.
   */
  description: string;
  /**
   * The link destination for the email health description.
   */
  descriptionLinkHtmlRef: string | null;
  /**
   * The recommended max number of emails to be sent each day.
   */
  maxDailyEmailsCount: number;
  /**
   * The number of emails the user has sent today.
   */
  emailsSentTodayCount: number;
  /**
   * The number of scheduled emails for the user today.
   */
  emailsScheduledTodayCount: number;
  /**
   * The number of failed emails for the user.
   */
  emailsFailedCount: number;
  /**
   * The number of automated emails currently queued to send for the user.
   */
  automatedEmailsWillSendCount: number;
  /**
   * The number of automated emails ready to send for the user.
   */
  automatedEmailsReadyToSendCount: number;
  /**
   * The number of automated emails for the user that need attention before they can be queued to send.
   */
  automatedEmailsNeedsAttentionCount: number;
  /**
   * Has anyone in this instance configured Nutshell Email Automations?
   */
  instanceHasConfiguredEmailAutomations: boolean;
  /**
   * Has this user paused their automated emails from sending?
   */
  isAutomatedSendingPaused: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailAttachment
// ====================================================

export interface EmailAttachment {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailSequenceTemplate
// ====================================================

export interface EmailSequenceTemplate_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EmailSequenceTemplate_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface EmailSequenceTemplate_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: EmailSequenceTemplate_emailAutomation_entersStage_stageset;
}

export interface EmailSequenceTemplate_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: EmailSequenceTemplate_emailAutomation_entersStage;
}

export interface EmailSequenceTemplate_userChildSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailSequenceTemplate_emailSequenceTemplateMessages_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailTemplate: EmailSequenceTemplate_emailSequenceTemplateMessages_emailTemplate;
}

export interface EmailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  lastSentTime: any | null;
  isShared: boolean;
  isImmutable: boolean;
  /**
   * Has this sequence template been deleted?
   */
  isArchived: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  deletedTime: any | null;
  group: EmailSequenceTemplate_group | null;
  replyRate: number | null;
  /**
   * The count of the sent sequences that got a reply
   */
  replyCount: number;
  clickRate: number | null;
  clickCount: number;
  /**
   * The count of the sent sequences that were cancelled
   */
  cancelledCount: number;
  /**
   * The count of the sequences that finished sending
   */
  finishedCount: number;
  /**
   * The count of the sequences that are still sending messages
   */
  inProgressCount: number;
  /**
   * The count of the sent sequences that have one or more emails with click tracking
   */
  startedWithClickTrackingCount: number;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: EmailSequenceTemplate_emailAutomation | null;
  /**
   * Child template created by the user, if they have made one. Includes the template if its archived
   */
  userChildSequenceTemplate: EmailSequenceTemplate_userChildSequenceTemplate | null;
  emailSequenceTemplateMessages: EmailSequenceTemplate_emailSequenceTemplateMessages[];
  creatorUser: EmailSequenceTemplate_creatorUser;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailSequenceTemplateTemplate
// ====================================================

export interface EmailSequenceTemplateTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface EmailSequenceTemplateTemplate_parent_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface EmailSequenceTemplateTemplate_parent {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: EmailSequenceTemplateTemplate_parent_creatorUser;
}

export interface EmailSequenceTemplateTemplate_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface EmailSequenceTemplateTemplate_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: EmailSequenceTemplateTemplate_emailAutomation_entersStage_stageset;
}

export interface EmailSequenceTemplateTemplate_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: EmailSequenceTemplateTemplate_emailAutomation_entersStage;
}

export interface EmailSequenceTemplateTemplate_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EmailSequenceTemplateTemplate_emailSequenceTemplateMessages_sendDelay {
  __typename: "EmailSequenceEmailTemplateSendDelay";
  /**
   * The timespan after the start of the sequence in units of dueUnit for this email template’s send date.
   */
  delayTimespan: number;
}

export interface EmailSequenceTemplateTemplate_emailSequenceTemplateMessages_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The raw saved body of the email template, without any HTML tags. This string
   * includes the variables strings ( {firstName}, {lastName}, etc ) in variable form.
   */
  plaintextBody: string;
  /**
   * The raw saved body of the email template. This string includes the variables
   * strings ( {firstName}, {lastName}, etc ) in variable form.
   */
  body: string;
  /**
   * The number of times this email template has been sent.
   */
  sentCount: number;
  /**
   * The number of times this email template has been opened by the reciepents.
   */
  openedCount: number;
  /**
   * The number of times this email template has been clicked by the recipients.
   */
  clickCount: number;
}

export interface EmailSequenceTemplateTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  sendAsReply: boolean;
  useSignature: boolean;
  position: number;
  /**
   * The delay after which to send the follow up email. This is `null` for email
   * templates, and only exists for emails in sequence templates.
   */
  sendDelay: EmailSequenceTemplateTemplate_emailSequenceTemplateMessages_sendDelay | null;
  emailTemplate: EmailSequenceTemplateTemplate_emailSequenceTemplateMessages_emailTemplate;
}

export interface EmailSequenceTemplateTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  creatorUser: EmailSequenceTemplateTemplate_creatorUser;
  lastSentTime: any | null;
  isShared: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  /**
   * The parent sequence template of this child sequence template
   */
  parent: EmailSequenceTemplateTemplate_parent | null;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: EmailSequenceTemplateTemplate_emailAutomation | null;
  group: EmailSequenceTemplateTemplate_group | null;
  deletedTime: any | null;
  isImmutable: boolean;
  /**
   * Has this sequence template been deleted?
   */
  isArchived: boolean;
  emailSequenceTemplateMessages: EmailSequenceTemplateTemplate_emailSequenceTemplateMessages[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailableLead
// ====================================================

export interface EmailableLead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntityRelatedEmailAddresses
// ====================================================

export interface EntityRelatedEmailAddresses_relatedEmailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
  formatted: string;
}

export interface EntityRelatedEmailAddresses_relatedEmailAddresses_primary_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
}

export interface EntityRelatedEmailAddresses_relatedEmailAddresses_primary_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary email address for this account
   */
  primaryEmailAddress: string | null;
}

export interface EntityRelatedEmailAddresses_relatedEmailAddresses_primary_entity_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
}

export type EntityRelatedEmailAddresses_relatedEmailAddresses_primary_entity = EntityRelatedEmailAddresses_relatedEmailAddresses_primary_entity_Contact | EntityRelatedEmailAddresses_relatedEmailAddresses_primary_entity_Account | EntityRelatedEmailAddresses_relatedEmailAddresses_primary_entity_User;

export interface EntityRelatedEmailAddresses_relatedEmailAddresses_primary {
  __typename: "EmailAddressEav";
  id: string;
  name: string;
  isPrimary: boolean;
  isFormer: boolean;
  value: EntityRelatedEmailAddresses_relatedEmailAddresses_primary_value;
  /**
   * The entity that is associated with this email address value.
   */
  entity: EntityRelatedEmailAddresses_relatedEmailAddresses_primary_entity;
}

export interface EntityRelatedEmailAddresses_relatedEmailAddresses_all_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
  formatted: string;
}

export interface EntityRelatedEmailAddresses_relatedEmailAddresses_all_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
}

export interface EntityRelatedEmailAddresses_relatedEmailAddresses_all_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary email address for this account
   */
  primaryEmailAddress: string | null;
}

export interface EntityRelatedEmailAddresses_relatedEmailAddresses_all_entity_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
}

export type EntityRelatedEmailAddresses_relatedEmailAddresses_all_entity = EntityRelatedEmailAddresses_relatedEmailAddresses_all_entity_Contact | EntityRelatedEmailAddresses_relatedEmailAddresses_all_entity_Account | EntityRelatedEmailAddresses_relatedEmailAddresses_all_entity_User;

export interface EntityRelatedEmailAddresses_relatedEmailAddresses_all {
  __typename: "EmailAddressEav";
  id: string;
  name: string;
  isPrimary: boolean;
  isFormer: boolean;
  value: EntityRelatedEmailAddresses_relatedEmailAddresses_all_value;
  /**
   * The entity that is associated with this email address value.
   */
  entity: EntityRelatedEmailAddresses_relatedEmailAddresses_all_entity;
}

export interface EntityRelatedEmailAddresses_relatedEmailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: EntityRelatedEmailAddresses_relatedEmailAddresses_primary | null;
  /**
   * An ordered collection of values
   */
  all: EntityRelatedEmailAddresses_relatedEmailAddresses_all[];
}

export interface EntityRelatedEmailAddresses_emailableLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
}

export interface EntityRelatedEmailAddresses {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  htmlUrl: string;
  relatedEmailAddresses: EntityRelatedEmailAddresses_relatedEmailAddresses;
  emailableLeads: EntityRelatedEmailAddresses_emailableLeads[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: RelatedEmailAddresses
// ====================================================

export interface RelatedEmailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
  formatted: string;
}

export interface RelatedEmailAddresses_primary_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
}

export interface RelatedEmailAddresses_primary_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary email address for this account
   */
  primaryEmailAddress: string | null;
}

export interface RelatedEmailAddresses_primary_entity_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
}

export type RelatedEmailAddresses_primary_entity = RelatedEmailAddresses_primary_entity_Contact | RelatedEmailAddresses_primary_entity_Account | RelatedEmailAddresses_primary_entity_User;

export interface RelatedEmailAddresses_primary {
  __typename: "EmailAddressEav";
  id: string;
  name: string;
  isPrimary: boolean;
  isFormer: boolean;
  value: RelatedEmailAddresses_primary_value;
  /**
   * The entity that is associated with this email address value.
   */
  entity: RelatedEmailAddresses_primary_entity;
}

export interface RelatedEmailAddresses_all_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
  formatted: string;
}

export interface RelatedEmailAddresses_all_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
}

export interface RelatedEmailAddresses_all_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary email address for this account
   */
  primaryEmailAddress: string | null;
}

export interface RelatedEmailAddresses_all_entity_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
}

export type RelatedEmailAddresses_all_entity = RelatedEmailAddresses_all_entity_Contact | RelatedEmailAddresses_all_entity_Account | RelatedEmailAddresses_all_entity_User;

export interface RelatedEmailAddresses_all {
  __typename: "EmailAddressEav";
  id: string;
  name: string;
  isPrimary: boolean;
  isFormer: boolean;
  value: RelatedEmailAddresses_all_value;
  /**
   * The entity that is associated with this email address value.
   */
  entity: RelatedEmailAddresses_all_entity;
}

export interface RelatedEmailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: RelatedEmailAddresses_primary | null;
  /**
   * An ordered collection of values
   */
  all: RelatedEmailAddresses_all[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailAddress
// ====================================================

export interface EmailAddress_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
  formatted: string;
}

export interface EmailAddress_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
}

export interface EmailAddress_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary email address for this account
   */
  primaryEmailAddress: string | null;
}

export interface EmailAddress_entity_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
}

export type EmailAddress_entity = EmailAddress_entity_Contact | EmailAddress_entity_Account | EmailAddress_entity_User;

export interface EmailAddress {
  __typename: "EmailAddressEav";
  id: string;
  name: string;
  isPrimary: boolean;
  isFormer: boolean;
  value: EmailAddress_value;
  /**
   * The entity that is associated with this email address value.
   */
  entity: EmailAddress_entity;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: MaterializedEmailSequence
// ====================================================

export interface MaterializedEmailSequence_entity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MaterializedEmailSequence_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MaterializedEmailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  isShared: boolean;
  creatorUser: MaterializedEmailSequence_emailSequenceTemplate_creatorUser;
}

export interface MaterializedEmailSequence_materializedEmailSequenceTemplateMessages_materializedEmailTemplate {
  __typename: "MaterializedEmailTemplate";
  /**
   * Materialized subject of this email template, meaning {firstName} would be returned as Chris.
   */
  subject: string;
  /**
   * Materialized body of this email template, meaning {firstName} would be returned as Chris.
   */
  body: string;
  /**
   * Essentially our "warning" or "error" message for this materialized template,
   * if either the entity has no email address, or the entity doesn’t have all of
   * the expected template information (such as a missing last name, or no company name)
   */
  missingFieldsMessage: string | null;
  /**
   * Materialized body of this email template, without any HTML tags, meaning
   * <div>{firstName}</div> would be returned as Chris.
   */
  plaintextBody: string;
}

export interface MaterializedEmailSequence_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MaterializedEmailSequence_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage_sendDelay {
  __typename: "EmailSequenceEmailTemplateSendDelay";
  /**
   * The unit to measure this email template’s send date.This could be days or hours or their business equalivents.
   */
  delayUnit: DueDateUnit;
  /**
   * The timespan after the start of the sequence in units of dueUnit for this email template’s send date.
   */
  delayTimespan: number;
}

export interface MaterializedEmailSequence_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage {
  __typename: "EmailSequenceTemplateMessage";
  emailTemplate: MaterializedEmailSequence_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage_emailTemplate;
  /**
   * The delay after which to send the follow up email. This is `null` for email
   * templates, and only exists for emails in sequence templates.
   */
  sendDelay: MaterializedEmailSequence_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage_sendDelay | null;
  /**
   * The time that this email is expected to be sent based on the given delay.
   * Follows the same null logic as the sendDelay field above.
   */
  expectedSendTime: any | null;
  sendAsReply: boolean;
}

export interface MaterializedEmailSequence_materializedEmailSequenceTemplateMessages {
  __typename: "MaterializedEmailSequenceTemplateMessage";
  /**
   * The materialized email template for this message in the email sequence template
   */
  materializedEmailTemplate: MaterializedEmailSequence_materializedEmailSequenceTemplateMessages_materializedEmailTemplate;
  /**
   * The unmunged email sequence template message
   */
  emailSequenceTemplateMessage: MaterializedEmailSequence_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage;
}

export interface MaterializedEmailSequence {
  __typename: "MaterializedEmailSequenceTemplate";
  /**
   * The entity used for munging
   */
  entity: MaterializedEmailSequence_entity;
  /**
   * The unmunged email sequence template
   */
  emailSequenceTemplate: MaterializedEmailSequence_emailSequenceTemplate;
  /**
   * The sequence of messages for this email sequence template, munged with entity info
   */
  materializedEmailSequenceTemplateMessages: MaterializedEmailSequence_materializedEmailSequenceTemplateMessages[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: MaterializedEmailTemplate
// ====================================================

export interface MaterializedEmailTemplate_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface MaterializedEmailTemplate_entity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MaterializedEmailTemplate {
  __typename: "MaterializedEmailTemplate";
  /**
   * Materialized subject of this email template, meaning {firstName} would be returned as Chris.
   */
  subject: string;
  /**
   * Materialized body of this email template, meaning {firstName} would be returned as Chris.
   */
  body: string;
  /**
   * Essentially our "warning" or "error" message for this materialized template,
   * if either the entity has no email address, or the entity doesn’t have all of
   * the expected template information (such as a missing last name, or no company name)
   */
  missingFieldsMessage: string | null;
  /**
   * Underlying non-materialized version of this email template, for accessing the raw field data.
   */
  emailTemplate: MaterializedEmailTemplate_emailTemplate;
  /**
   * Model associated with this materialized email template.
   */
  entity: MaterializedEmailTemplate_entity;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: Email
// ====================================================

export interface Email_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface Email_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: Email_to_avatarEntity | null;
}

export interface Email_cc_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface Email_cc {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: Email_cc_avatarEntity | null;
}

export interface Email_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface Email_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: Email_from_avatarEntity | null;
}

export interface Email_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface Email_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface Email_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  emailSequenceTemplate: Email_emailSequence_emailSequenceTemplate | null;
}

export interface Email_queuedEmail {
  __typename: "EmailQueued";
  /**
   * The numerical position of the email in its sequence, if it belongs to one
   */
  messageNumber: number | null;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

export interface Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  to: Email_to[];
  cc: Email_cc[];
  from: Email_from;
  createdTime: any;
  sentTime: any | null;
  deletedTime: any | null;
  attachments: Email_attachments[];
  subject: string;
  /**
   * A plain-text version of the body of this email,for use in the collapsed view in a list
   */
  bodyText: string;
  /**
   * A partially-formatted version of the body of this email,for use in the expanded view in a list
   */
  bodyHtml: string;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
  /**
   * True if the email is shared with other Nutshell users
   */
  isShared: boolean;
  /**
   * True if the email can be shared with other Nutshell users
   */
  isShareable: boolean;
  /**
   * True if a Nutshell user can reply to this email
   */
  isReplyable: boolean;
  /**
   * The sequence this email is a part of, if any
   */
  emailSequence: Email_emailSequence | null;
  /**
   * The queued email that relates to this email
   */
  queuedEmail: Email_queuedEmail | null;
  /**
   * Number of times this email has been viewed via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedViewsCount: number | null;
  /**
   * Was this email a reply sent by Nutshell automatically.
   */
  isAutomatedReply: boolean;
  /**
   * Was this email sent by Nutshell automatically.
   */
  isEmailAutomation: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailListItem
// ====================================================

export interface EmailListItem_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface EmailListItem_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: EmailListItem_to_avatarEntity | null;
}

export interface EmailListItem_cc_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface EmailListItem_cc {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: EmailListItem_cc_avatarEntity | null;
}

export interface EmailListItem_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface EmailListItem_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: EmailListItem_from_avatarEntity | null;
}

export interface EmailListItem_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
}

export interface EmailListItem_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EmailListItem_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  emailSequenceTemplate: EmailListItem_emailSequence_emailSequenceTemplate | null;
}

export interface EmailListItem_queuedEmail {
  __typename: "EmailQueued";
  /**
   * The numerical position of the email in its sequence, if it belongs to one
   */
  messageNumber: number | null;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

export interface EmailListItem {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  to: EmailListItem_to[];
  cc: EmailListItem_cc[];
  from: EmailListItem_from;
  createdTime: any;
  sentTime: any | null;
  attachments: EmailListItem_attachments[];
  subject: string;
  /**
   * A plain-text version of the body of this email,for use in the collapsed view in a list
   */
  bodyText: string;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
  /**
   * True if the email is shared with other Nutshell users
   */
  isShared: boolean;
  /**
   * True if the email can be shared with other Nutshell users
   */
  isShareable: boolean;
  /**
   * True if a Nutshell user can reply to this email
   */
  isReplyable: boolean;
  /**
   * The sequence this email is a part of, if any
   */
  emailSequence: EmailListItem_emailSequence | null;
  /**
   * The queued email that relates to this email
   */
  queuedEmail: EmailListItem_queuedEmail | null;
  /**
   * Number of times this email has been viewed via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedViewsCount: number | null;
  /**
   * Was this email a reply sent by Nutshell automatically.
   */
  isAutomatedReply: boolean;
  /**
   * Was this email sent by Nutshell automatically.
   */
  isEmailAutomation: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: NutEmailAddress
// ====================================================

export interface NutEmailAddress_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface NutEmailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: NutEmailAddress_avatarEntity | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: QueuedEmail
// ====================================================

export interface QueuedEmail_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface QueuedEmail_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: QueuedEmail_to_avatarEntity | null;
}

export interface QueuedEmail_cc_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface QueuedEmail_cc {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: QueuedEmail_cc_avatarEntity | null;
}

export interface QueuedEmail_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface QueuedEmail_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: QueuedEmail_from_avatarEntity | null;
}

export interface QueuedEmail_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface QueuedEmail_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface QueuedEmail_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface QueuedEmail_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  emailSequenceTemplate: QueuedEmail_emailSequence_emailSequenceTemplate | null;
  /**
   * True if this sequence has only one email
   */
  isSingleEmailSequence: boolean;
  /**
   * The next message to be sent
   */
  nextUnsentEmail: QueuedEmail_emailSequence_nextUnsentEmail | null;
}

export interface QueuedEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  to: QueuedEmail_to[];
  cc: QueuedEmail_cc[];
  /**
   * The sender email address for this queued email.
   */
  from: QueuedEmail_from;
  /**
   * The numerical position of the email in its sequence, if it belongs to one
   */
  messageNumber: number | null;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * A plain-text version of the body of this queued email,for use in the collapsed view in a list
   */
  bodyText: string;
  /**
   * A partially-formatted version of the body of this queued email,for use in the expanded view in a list
   */
  bodyHtml: string;
  attachments: QueuedEmail_attachments[];
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * The parent email sequence of this queued email.
   */
  emailSequence: QueuedEmail_emailSequence | null;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  /**
   * The current status of this queued email.
   */
  status: EmailQueuedStatus;
  /**
   * The current status of this queued email.
   */
  sendProblems: EmailQueuedSendProblem[];
  /**
   * True if this queued email is postponed and the user can retry it.
   */
  canRetry: boolean;
  /**
   * True if this queued email has a delivery time that is in the future.
   */
  isScheduled: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
  /**
   * True if this queued email should be able to be delayed by the user.
   */
  canDelay: boolean;
  /**
   * True if this queued email is in reply to a previous email.
   */
  sendAsReply: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailSyncStatusBanner
// ====================================================

export interface EmailSyncStatusBanner_lastEmail {
  __typename: "Email";
  subject: string;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
}

export interface EmailSyncStatusBanner {
  __typename: "EmailSyncStatusBanner";
  /**
   * An enum of the current email sync status. Success, warning, or error. Null if email is not configured.
   */
  status: EmailBannerStatus;
  /**
   * A quick summary of the account email health. Used for health button.
   */
  title: string;
  /**
   * The long description of the account email health.
   */
  description: string | null;
  /**
   * The error message text.
   */
  error: string | null;
  /**
   * Status of the initial sync to bring in historic emails
   */
  initialSyncDescription: string | null;
  /**
   * Whether or not initialSyncDescription is an error
   */
  initialSyncDescriptionIsError: boolean;
  /**
   * The time of the last sync performed.
   */
  lastSyncTime: any | null;
  /**
   * The last email synced in for this user.
   */
  lastEmail: EmailSyncStatusBanner_lastEmail | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ReplyableEmail
// ====================================================

export interface ReplyableEmail_replyAllAddresses_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface ReplyableEmail_replyAllAddresses {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: ReplyableEmail_replyAllAddresses_avatarEntity | null;
}

export interface ReplyableEmail_replyToAddress_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface ReplyableEmail_replyToAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
  avatarEntity: ReplyableEmail_replyToAddress_avatarEntity | null;
}

export interface ReplyableEmail_relatedLeads_edges_node {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
}

export interface ReplyableEmail_relatedLeads_edges {
  __typename: "EmailLeadsEdge";
  node: ReplyableEmail_relatedLeads_edges_node;
  /**
   * Is this lead mapped to this email?
   */
  isMapped: boolean;
}

export interface ReplyableEmail_relatedLeads {
  __typename: "EmailLeadsConnection";
  /**
   * A list of edges.
   */
  edges: ReplyableEmail_relatedLeads_edges[];
}

export interface ReplyableEmail {
  __typename: "ReplyableEmail";
  /**
   * The HTML of the previous email, in a blockquote
   */
  bodyHtml: string;
  /**
   * The subject of the previous email, in a with re:
   */
  subject: string;
  /**
   * The array of email addresses for a reply all.
   */
  replyAllAddresses: ReplyableEmail_replyAllAddresses[];
  /**
   * The email address of the sender or the first non-self sent to address.
   */
  replyToAddress: ReplyableEmail_replyToAddress;
  /**
   * Gets all leads related to this email reply. This includes all open leads at
   * the time of send, as well as any previously/explicitly associated leads
   */
  relatedLeads: ReplyableEmail_relatedLeads;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: MaterializedEmailSequenceExtension
// ====================================================

export interface MaterializedEmailSequenceExtension_entity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MaterializedEmailSequenceExtension_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MaterializedEmailSequenceExtension_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  isShared: boolean;
  creatorUser: MaterializedEmailSequenceExtension_emailSequenceTemplate_creatorUser;
  /**
   * The complete url to the edit modal for the email template
   */
  htmlUrl: string;
}

export interface MaterializedEmailSequenceExtension_materializedEmailSequenceTemplateMessages_materializedEmailTemplate {
  __typename: "MaterializedEmailTemplate";
  /**
   * Materialized subject of this email template, meaning {firstName} would be returned as Chris.
   */
  subject: string;
  /**
   * Materialized body of this email template, meaning {firstName} would be returned as Chris.
   */
  body: string;
  /**
   * Essentially our "warning" or "error" message for this materialized template,
   * if either the entity has no email address, or the entity doesn’t have all of
   * the expected template information (such as a missing last name, or no company name)
   */
  missingFieldsMessage: string | null;
  /**
   * Materialized body of this email template, without any HTML tags, meaning
   * <div>{firstName}</div> would be returned as Chris.
   */
  plaintextBody: string;
}

export interface MaterializedEmailSequenceExtension_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MaterializedEmailSequenceExtension_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage_sendDelay {
  __typename: "EmailSequenceEmailTemplateSendDelay";
  /**
   * The unit to measure this email template’s send date.This could be days or hours or their business equalivents.
   */
  delayUnit: DueDateUnit;
  /**
   * The timespan after the start of the sequence in units of dueUnit for this email template’s send date.
   */
  delayTimespan: number;
}

export interface MaterializedEmailSequenceExtension_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage {
  __typename: "EmailSequenceTemplateMessage";
  emailTemplate: MaterializedEmailSequenceExtension_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage_emailTemplate;
  /**
   * The delay after which to send the follow up email. This is `null` for email
   * templates, and only exists for emails in sequence templates.
   */
  sendDelay: MaterializedEmailSequenceExtension_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage_sendDelay | null;
  /**
   * The time that this email is expected to be sent based on the given delay.
   * Follows the same null logic as the sendDelay field above.
   */
  expectedSendTime: any | null;
  sendAsReply: boolean;
}

export interface MaterializedEmailSequenceExtension_materializedEmailSequenceTemplateMessages {
  __typename: "MaterializedEmailSequenceTemplateMessage";
  /**
   * The materialized email template for this message in the email sequence template
   */
  materializedEmailTemplate: MaterializedEmailSequenceExtension_materializedEmailSequenceTemplateMessages_materializedEmailTemplate;
  /**
   * The unmunged email sequence template message
   */
  emailSequenceTemplateMessage: MaterializedEmailSequenceExtension_materializedEmailSequenceTemplateMessages_emailSequenceTemplateMessage;
}

export interface MaterializedEmailSequenceExtension {
  __typename: "MaterializedEmailSequenceTemplate";
  /**
   * The entity used for munging
   */
  entity: MaterializedEmailSequenceExtension_entity;
  /**
   * The unmunged email sequence template
   */
  emailSequenceTemplate: MaterializedEmailSequenceExtension_emailSequenceTemplate;
  /**
   * The sequence of messages for this email sequence template, munged with entity info
   */
  materializedEmailSequenceTemplateMessages: MaterializedEmailSequenceExtension_materializedEmailSequenceTemplateMessages[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailSequenceTemplateFullFragment
// ====================================================

export interface EmailSequenceTemplateFullFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface EmailSequenceTemplateFullFragment_parent_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface EmailSequenceTemplateFullFragment_parent {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: EmailSequenceTemplateFullFragment_parent_creatorUser;
}

export interface EmailSequenceTemplateFullFragment_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface EmailSequenceTemplateFullFragment_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: EmailSequenceTemplateFullFragment_emailAutomation_entersStage_stageset;
}

export interface EmailSequenceTemplateFullFragment_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: EmailSequenceTemplateFullFragment_emailAutomation_entersStage;
}

export interface EmailSequenceTemplateFullFragment_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EmailSequenceTemplateFullFragment_emailSequenceTemplateMessages_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailSequenceTemplateFullFragment_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailTemplate: EmailSequenceTemplateFullFragment_emailSequenceTemplateMessages_emailTemplate;
}

export interface EmailSequenceTemplateFullFragment {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  creatorUser: EmailSequenceTemplateFullFragment_creatorUser;
  lastSentTime: any | null;
  isShared: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  /**
   * The parent sequence template of this child sequence template
   */
  parent: EmailSequenceTemplateFullFragment_parent | null;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: EmailSequenceTemplateFullFragment_emailAutomation | null;
  group: EmailSequenceTemplateFullFragment_group | null;
  deletedTime: any | null;
  emailSequenceTemplateMessages: EmailSequenceTemplateFullFragment_emailSequenceTemplateMessages[];
  replyRate: number | null;
  /**
   * The count of the sent sequences that got a reply
   */
  replyCount: number;
  clickRate: number | null;
  clickCount: number;
  /**
   * The count of the sequences that are still sending messages
   */
  inProgressCount: number;
  /**
   * The count of the sequences that finished sending
   */
  finishedCount: number;
  /**
   * The count of the sent sequences that were cancelled
   */
  cancelledCount: number;
  /**
   * The count of the sent sequences that have one or more emails with click tracking
   */
  startedWithClickTrackingCount: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailSequenceTemplateStubBasic
// ====================================================

export interface EmailSequenceTemplateStubBasic_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface EmailSequenceTemplateStubBasic_parent_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface EmailSequenceTemplateStubBasic_parent {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: EmailSequenceTemplateStubBasic_parent_creatorUser;
}

export interface EmailSequenceTemplateStubBasic_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface EmailSequenceTemplateStubBasic_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: EmailSequenceTemplateStubBasic_emailAutomation_entersStage_stageset;
}

export interface EmailSequenceTemplateStubBasic_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: EmailSequenceTemplateStubBasic_emailAutomation_entersStage;
}

export interface EmailSequenceTemplateStubBasic_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EmailSequenceTemplateStubBasic {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  creatorUser: EmailSequenceTemplateStubBasic_creatorUser;
  lastSentTime: any | null;
  isShared: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  /**
   * The parent sequence template of this child sequence template
   */
  parent: EmailSequenceTemplateStubBasic_parent | null;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: EmailSequenceTemplateStubBasic_emailAutomation | null;
  group: EmailSequenceTemplateStubBasic_group | null;
  deletedTime: any | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailSequenceTemplateStubFragment
// ====================================================

export interface EmailSequenceTemplateStubFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface EmailSequenceTemplateStubFragment_parent_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface EmailSequenceTemplateStubFragment_parent {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: EmailSequenceTemplateStubFragment_parent_creatorUser;
}

export interface EmailSequenceTemplateStubFragment_emailAutomation_entersStage_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface EmailSequenceTemplateStubFragment_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: EmailSequenceTemplateStubFragment_emailAutomation_entersStage_stageset;
}

export interface EmailSequenceTemplateStubFragment_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: EmailSequenceTemplateStubFragment_emailAutomation_entersStage;
}

export interface EmailSequenceTemplateStubFragment_group {
  __typename: "EmailSequenceTemplateGroup";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EmailSequenceTemplateStubFragment_emailSequenceTemplateMessages_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailSequenceTemplateStubFragment_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailTemplate: EmailSequenceTemplateStubFragment_emailSequenceTemplateMessages_emailTemplate;
}

export interface EmailSequenceTemplateStubFragment {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  creatorUser: EmailSequenceTemplateStubFragment_creatorUser;
  lastSentTime: any | null;
  isShared: boolean;
  /**
   * Is the current user able to rename, edit or archive this sequence template?
   */
  canEdit: boolean;
  /**
   * The parent sequence template of this child sequence template
   */
  parent: EmailSequenceTemplateStubFragment_parent | null;
  /**
   * If this sequence template is used for an email automation, return that automation
   */
  emailAutomation: EmailSequenceTemplateStubFragment_emailAutomation | null;
  group: EmailSequenceTemplateStubFragment_group | null;
  deletedTime: any | null;
  emailSequenceTemplateMessages: EmailSequenceTemplateStubFragment_emailSequenceTemplateMessages[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PeepEngagementStats
// ====================================================

export interface PeepEngagementStats_Account_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
}

export interface PeepEngagementStats_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * Returns a Nutshell engagement rating of 0-5 stars
   */
  engagementRating: number;
  engagementStats: PeepEngagementStats_Account_engagementStats;
}

export interface PeepEngagementStats_Contact_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
}

export interface PeepEngagementStats_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * Returns a Nutshell engagement rating of 0-5 stars
   */
  engagementRating: number;
  engagementStats: PeepEngagementStats_Contact_engagementStats;
  /**
   * Boolean if the contact has hard bounced
   */
  hasHardBounced: boolean;
}

export type PeepEngagementStats = PeepEngagementStats_Account | PeepEngagementStats_Contact;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PeepRelatedLeadCardFragment
// ====================================================

export interface PeepRelatedLeadCardFragment_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface PeepRelatedLeadCardFragment_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: PeepRelatedLeadCardFragment_value_formattedValue;
}

export interface PeepRelatedLeadCardFragment_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface PeepRelatedLeadCardFragment_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: PeepRelatedLeadCardFragment_contacts_primaryEdge_node;
}

export interface PeepRelatedLeadCardFragment_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: PeepRelatedLeadCardFragment_contacts_primaryEdge | null;
}

export interface PeepRelatedLeadCardFragment_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface PeepRelatedLeadCardFragment_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: PeepRelatedLeadCardFragment_accounts_primaryEdge_node;
}

export interface PeepRelatedLeadCardFragment_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: PeepRelatedLeadCardFragment_accounts_primaryEdge | null;
}

export interface PeepRelatedLeadCardFragment_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
}

export interface PeepRelatedLeadCardFragment {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: PeepRelatedLeadCardFragment_value | null;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  /**
   * The time this lead did or will become overdue
   */
  overdueTime: any | null;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  avatarUrl: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: PeepRelatedLeadCardFragment_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: PeepRelatedLeadCardFragment_accounts;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: PeepRelatedLeadCardFragment_assignee | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PeepRelatedLeadCards
// ====================================================

export interface PeepRelatedLeadCards_leads_edges_node_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface PeepRelatedLeadCards_leads_edges_node_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: PeepRelatedLeadCards_leads_edges_node_value_formattedValue;
}

export interface PeepRelatedLeadCards_leads_edges_node_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface PeepRelatedLeadCards_leads_edges_node_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: PeepRelatedLeadCards_leads_edges_node_contacts_primaryEdge_node;
}

export interface PeepRelatedLeadCards_leads_edges_node_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: PeepRelatedLeadCards_leads_edges_node_contacts_primaryEdge | null;
}

export interface PeepRelatedLeadCards_leads_edges_node_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface PeepRelatedLeadCards_leads_edges_node_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: PeepRelatedLeadCards_leads_edges_node_accounts_primaryEdge_node;
}

export interface PeepRelatedLeadCards_leads_edges_node_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: PeepRelatedLeadCards_leads_edges_node_accounts_primaryEdge | null;
}

export interface PeepRelatedLeadCards_leads_edges_node_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
}

export interface PeepRelatedLeadCards_leads_edges_node {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: PeepRelatedLeadCards_leads_edges_node_value | null;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  /**
   * The time this lead did or will become overdue
   */
  overdueTime: any | null;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  avatarUrl: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: PeepRelatedLeadCards_leads_edges_node_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: PeepRelatedLeadCards_leads_edges_node_accounts;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: PeepRelatedLeadCards_leads_edges_node_assignee | null;
}

export interface PeepRelatedLeadCards_leads_edges {
  __typename: "PeepLeadsEdge";
  node: PeepRelatedLeadCards_leads_edges_node;
}

export interface PeepRelatedLeadCards_leads {
  __typename: "PeepLeadsConnection";
  /**
   * A list of edges.
   */
  edges: PeepRelatedLeadCards_leads_edges[];
}

export interface PeepRelatedLeadCards_childLeads_edges_node_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface PeepRelatedLeadCards_childLeads_edges_node_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: PeepRelatedLeadCards_childLeads_edges_node_value_formattedValue;
}

export interface PeepRelatedLeadCards_childLeads_edges_node_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface PeepRelatedLeadCards_childLeads_edges_node_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: PeepRelatedLeadCards_childLeads_edges_node_contacts_primaryEdge_node;
}

export interface PeepRelatedLeadCards_childLeads_edges_node_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: PeepRelatedLeadCards_childLeads_edges_node_contacts_primaryEdge | null;
}

export interface PeepRelatedLeadCards_childLeads_edges_node_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface PeepRelatedLeadCards_childLeads_edges_node_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: PeepRelatedLeadCards_childLeads_edges_node_accounts_primaryEdge_node;
}

export interface PeepRelatedLeadCards_childLeads_edges_node_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: PeepRelatedLeadCards_childLeads_edges_node_accounts_primaryEdge | null;
}

export interface PeepRelatedLeadCards_childLeads_edges_node_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
}

export interface PeepRelatedLeadCards_childLeads_edges_node {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: PeepRelatedLeadCards_childLeads_edges_node_value | null;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  /**
   * The time this lead did or will become overdue
   */
  overdueTime: any | null;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  avatarUrl: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: PeepRelatedLeadCards_childLeads_edges_node_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: PeepRelatedLeadCards_childLeads_edges_node_accounts;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: PeepRelatedLeadCards_childLeads_edges_node_assignee | null;
}

export interface PeepRelatedLeadCards_childLeads_edges {
  __typename: "PeepLeadsEdge";
  node: PeepRelatedLeadCards_childLeads_edges_node;
}

export interface PeepRelatedLeadCards_childLeads {
  __typename: "PeepLeadsConnection";
  /**
   * A list of edges.
   */
  edges: PeepRelatedLeadCards_childLeads_edges[];
}

export interface PeepRelatedLeadCards {
  __typename: "Account" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * Leads related to this peep
   */
  leads: PeepRelatedLeadCards_leads;
  /**
   * Leads related to this peeps children (for accounts, else null)
   */
  childLeads: PeepRelatedLeadCards_childLeads;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PeepRelatedLeadStats
// ====================================================

export interface PeepRelatedLeadStats_Account_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface PeepRelatedLeadStats_Account_phones_primary {
  __typename: "Phone";
  value: PeepRelatedLeadStats_Account_phones_primary_value;
}

export interface PeepRelatedLeadStats_Account_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: PeepRelatedLeadStats_Account_phones_primary | null;
}

export interface PeepRelatedLeadStats_Account_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface PeepRelatedLeadStats_Account_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: PeepRelatedLeadStats_Account_emailAddresses_primary_value;
}

export interface PeepRelatedLeadStats_Account_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: PeepRelatedLeadStats_Account_emailAddresses_primary | null;
}

export interface PeepRelatedLeadStats_Account_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  region: string | null;
}

export interface PeepRelatedLeadStats_Account_postalAddresses_primary {
  __typename: "PostalAddress";
  value: PeepRelatedLeadStats_Account_postalAddresses_primary_value;
}

export interface PeepRelatedLeadStats_Account_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: PeepRelatedLeadStats_Account_postalAddresses_primary | null;
}

export interface PeepRelatedLeadStats_Account_leads_stats_all_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface PeepRelatedLeadStats_Account_leads_stats_all_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: PeepRelatedLeadStats_Account_leads_stats_all_value_formattedValue;
}

export interface PeepRelatedLeadStats_Account_leads_stats_all {
  __typename: "LeadStat";
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  count: number;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  status: LeadStatus;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  value: PeepRelatedLeadStats_Account_leads_stats_all_value;
}

export interface PeepRelatedLeadStats_Account_leads_stats {
  __typename: "LeadStats";
  /**
   * All the stats, boi
   */
  all: PeepRelatedLeadStats_Account_leads_stats_all[];
}

export interface PeepRelatedLeadStats_Account_leads {
  __typename: "PeepLeadsConnection";
  /**
   * Statistics about this peep’s related leads
   */
  stats: PeepRelatedLeadStats_Account_leads_stats;
}

export interface PeepRelatedLeadStats_Account_childLeads_subsidiaryStats_all_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface PeepRelatedLeadStats_Account_childLeads_subsidiaryStats_all_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: PeepRelatedLeadStats_Account_childLeads_subsidiaryStats_all_value_formattedValue;
}

export interface PeepRelatedLeadStats_Account_childLeads_subsidiaryStats_all {
  __typename: "LeadStat";
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  count: number;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  status: LeadStatus;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  value: PeepRelatedLeadStats_Account_childLeads_subsidiaryStats_all_value;
}

export interface PeepRelatedLeadStats_Account_childLeads_subsidiaryStats {
  __typename: "LeadStats";
  /**
   * All the stats, boi
   */
  all: PeepRelatedLeadStats_Account_childLeads_subsidiaryStats_all[];
}

export interface PeepRelatedLeadStats_Account_childLeads {
  __typename: "PeepLeadsConnection";
  /**
   * Statistics about this peep’s related leads
   */
  subsidiaryStats: PeepRelatedLeadStats_Account_childLeads_subsidiaryStats | null;
}

export interface PeepRelatedLeadStats_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  avatarUrl: string;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: PeepRelatedLeadStats_Account_phones;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: PeepRelatedLeadStats_Account_emailAddresses;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: PeepRelatedLeadStats_Account_postalAddresses;
  /**
   * Leads related to this peep
   */
  leads: PeepRelatedLeadStats_Account_leads;
  /**
   * Leads related to this peeps children (for accounts, else null)
   */
  childLeads: PeepRelatedLeadStats_Account_childLeads;
}

export interface PeepRelatedLeadStats_Contact_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface PeepRelatedLeadStats_Contact_phones_primary {
  __typename: "Phone";
  value: PeepRelatedLeadStats_Contact_phones_primary_value;
}

export interface PeepRelatedLeadStats_Contact_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: PeepRelatedLeadStats_Contact_phones_primary | null;
}

export interface PeepRelatedLeadStats_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface PeepRelatedLeadStats_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: PeepRelatedLeadStats_Contact_emailAddresses_primary_value;
}

export interface PeepRelatedLeadStats_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: PeepRelatedLeadStats_Contact_emailAddresses_primary | null;
}

export interface PeepRelatedLeadStats_Contact_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  region: string | null;
}

export interface PeepRelatedLeadStats_Contact_postalAddresses_primary {
  __typename: "PostalAddress";
  value: PeepRelatedLeadStats_Contact_postalAddresses_primary_value;
}

export interface PeepRelatedLeadStats_Contact_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: PeepRelatedLeadStats_Contact_postalAddresses_primary | null;
}

export interface PeepRelatedLeadStats_Contact_leads_stats_all_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface PeepRelatedLeadStats_Contact_leads_stats_all_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: PeepRelatedLeadStats_Contact_leads_stats_all_value_formattedValue;
}

export interface PeepRelatedLeadStats_Contact_leads_stats_all {
  __typename: "LeadStat";
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  count: number;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  status: LeadStatus;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  value: PeepRelatedLeadStats_Contact_leads_stats_all_value;
}

export interface PeepRelatedLeadStats_Contact_leads_stats {
  __typename: "LeadStats";
  /**
   * All the stats, boi
   */
  all: PeepRelatedLeadStats_Contact_leads_stats_all[];
}

export interface PeepRelatedLeadStats_Contact_leads {
  __typename: "PeepLeadsConnection";
  /**
   * Statistics about this peep’s related leads
   */
  stats: PeepRelatedLeadStats_Contact_leads_stats;
}

export interface PeepRelatedLeadStats_Contact_childLeads_subsidiaryStats_all_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface PeepRelatedLeadStats_Contact_childLeads_subsidiaryStats_all_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: PeepRelatedLeadStats_Contact_childLeads_subsidiaryStats_all_value_formattedValue;
}

export interface PeepRelatedLeadStats_Contact_childLeads_subsidiaryStats_all {
  __typename: "LeadStat";
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  count: number;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  status: LeadStatus;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  value: PeepRelatedLeadStats_Contact_childLeads_subsidiaryStats_all_value;
}

export interface PeepRelatedLeadStats_Contact_childLeads_subsidiaryStats {
  __typename: "LeadStats";
  /**
   * All the stats, boi
   */
  all: PeepRelatedLeadStats_Contact_childLeads_subsidiaryStats_all[];
}

export interface PeepRelatedLeadStats_Contact_childLeads {
  __typename: "PeepLeadsConnection";
  /**
   * Statistics about this peep’s related leads
   */
  subsidiaryStats: PeepRelatedLeadStats_Contact_childLeads_subsidiaryStats | null;
}

export interface PeepRelatedLeadStats_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  avatarUrl: string;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: PeepRelatedLeadStats_Contact_phones;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: PeepRelatedLeadStats_Contact_emailAddresses;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: PeepRelatedLeadStats_Contact_postalAddresses;
  /**
   * Leads related to this peep
   */
  leads: PeepRelatedLeadStats_Contact_leads;
  /**
   * Leads related to this peeps children (for accounts, else null)
   */
  childLeads: PeepRelatedLeadStats_Contact_childLeads;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
}

export type PeepRelatedLeadStats = PeepRelatedLeadStats_Account | PeepRelatedLeadStats_Contact;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PeepRelatedLeadStat
// ====================================================

export interface PeepRelatedLeadStat_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface PeepRelatedLeadStat_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: PeepRelatedLeadStat_value_formattedValue;
}

export interface PeepRelatedLeadStat {
  __typename: "LeadStat";
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  count: number;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  status: LeadStatus;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  value: PeepRelatedLeadStat_value;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PeepSendToDestinations
// ====================================================

export interface PeepSendToDestinations_Account_sendToDestinations {
  __typename: "EntityDestination";
  /**
   * The URL this destination should direct to.
   */
  localUrl: string;
  /**
   * The descriptive name for this destination.
   */
  name: string;
}

export interface PeepSendToDestinations_Account_externalResources {
  __typename: "ExternalResource";
  /**
   * The name of the external service this resource belongs to.
   */
  externalService: ExternalService;
  /**
   * The type of external resource.
   */
  externalResourceType: ExternalResourceType;
  /**
   * The ID of the external resource.
   */
  externalId: string;
}

export interface PeepSendToDestinations_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Is this entity deleted
   */
  isDeleted: boolean;
  /**
   * The list of destinations for this peep
   */
  sendToDestinations: PeepSendToDestinations_Account_sendToDestinations[];
  /**
   * External resources mapped to this peep
   */
  externalResources: PeepSendToDestinations_Account_externalResources[];
}

export interface PeepSendToDestinations_Contact_sendToDestinations {
  __typename: "EntityDestination";
  /**
   * The URL this destination should direct to.
   */
  localUrl: string;
  /**
   * The descriptive name for this destination.
   */
  name: string;
}

export interface PeepSendToDestinations_Contact_externalResources {
  __typename: "ExternalResource";
  /**
   * The name of the external service this resource belongs to.
   */
  externalService: ExternalService;
  /**
   * The type of external resource.
   */
  externalResourceType: ExternalResourceType;
  /**
   * The ID of the external resource.
   */
  externalId: string;
}

export interface PeepSendToDestinations_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
  formatted: string;
}

export interface PeepSendToDestinations_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  isPrimary: boolean;
  value: PeepSendToDestinations_Contact_emailAddresses_primary_value;
}

export interface PeepSendToDestinations_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: PeepSendToDestinations_Contact_emailAddresses_primary | null;
}

export interface PeepSendToDestinations_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Is this entity deleted
   */
  isDeleted: boolean;
  /**
   * The list of destinations for this peep
   */
  sendToDestinations: PeepSendToDestinations_Contact_sendToDestinations[];
  /**
   * External resources mapped to this peep
   */
  externalResources: PeepSendToDestinations_Contact_externalResources[];
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: PeepSendToDestinations_Contact_emailAddresses;
}

export type PeepSendToDestinations = PeepSendToDestinations_Account | PeepSendToDestinations_Contact;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AccountInfoFragment
// ====================================================

export interface AccountInfoFragment_territory {
  __typename: "Territory";
  id: string | null;
}

export interface AccountInfoFragment_revenue_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface AccountInfoFragment_revenue {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: AccountInfoFragment_revenue_currencyValue;
}

export interface AccountInfoFragment_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface AccountInfoFragment_industry {
  __typename: "NutshellIndustry";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface AccountInfoFragment_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface AccountInfoFragment_tags_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface AccountInfoFragment_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: AccountInfoFragment_tags_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface AccountInfoFragment_tagMaps_edges_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface AccountInfoFragment_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface AccountInfoFragment_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: AccountInfoFragment_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface AccountInfoFragment_tagMaps_edges {
  __typename: "TagMapsEdge";
  /**
   * The creator of this tag map
   */
  creator: AccountInfoFragment_tagMaps_edges_creator | null;
  /**
   * The DateTime that represents when the Tag was mapped
   */
  createdTime: any | null;
  node: AccountInfoFragment_tagMaps_edges_node | null;
}

export interface AccountInfoFragment_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: AccountInfoFragment_tagMaps_edges[];
}

export interface AccountInfoFragment {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The terrority to which this peep is assigned.
   */
  territory: AccountInfoFragment_territory | null;
  /**
   * The number of people employed by this company
   */
  employeeCount: string | null;
  revenue: AccountInfoFragment_revenue | null;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: AccountInfoFragment_owner | null;
  /**
   * The industry of this account
   */
  industry: AccountInfoFragment_industry | null;
  /**
   * The type assigned to this account
   */
  accountType: AccountInfoFragment_accountType;
  /**
   * Tags associated with the given peep
   */
  tags: AccountInfoFragment_tags[];
  /**
   * Tag maps for the peep
   */
  tagMaps: AccountInfoFragment_tagMaps | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContactInfoFragment
// ====================================================

export interface ContactInfoFragment_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ContactInfoFragment_territory {
  __typename: "Territory";
  id: string | null;
}

export interface ContactInfoFragment_tags_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ContactInfoFragment_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: ContactInfoFragment_tags_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface ContactInfoFragment_tagMaps_edges_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ContactInfoFragment_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ContactInfoFragment_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: ContactInfoFragment_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface ContactInfoFragment_tagMaps_edges {
  __typename: "TagMapsEdge";
  /**
   * The creator of this tag map
   */
  creator: ContactInfoFragment_tagMaps_edges_creator | null;
  /**
   * The DateTime that represents when the Tag was mapped
   */
  createdTime: any | null;
  node: ContactInfoFragment_tagMaps_edges_node | null;
}

export interface ContactInfoFragment_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: ContactInfoFragment_tagMaps_edges[];
}

export interface ContactInfoFragment {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: ContactInfoFragment_owner | null;
  /**
   * The terrority to which this peep is assigned.
   */
  territory: ContactInfoFragment_territory | null;
  /**
   * Tags associated with the given peep
   */
  tags: ContactInfoFragment_tags[];
  /**
   * Tag maps for the peep
   */
  tagMaps: ContactInfoFragment_tagMaps | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LastContactedTimesPeep
// ====================================================

export interface LastContactedTimesPeep {
  __typename: "Account" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The most recent date this entity was contacted by the active user
   */
  myLastContactedTime: any | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: DripSequencePreviewStubFragment
// ====================================================

export interface DripSequencePreviewStubFragment_startTrigger {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface DripSequencePreviewStubFragment_editions_pageInfo {
  __typename: "PageInfo";
  startCursor: string | null;
  endCursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface DripSequencePreviewStubFragment_editions_edges_node_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
}

export interface DripSequencePreviewStubFragment_editions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The email template for this edition
   */
  emailTemplate: DripSequencePreviewStubFragment_editions_edges_node_emailTemplate | null;
  /**
   * The background color of this page
   */
  backgroundColor: string;
}

export interface DripSequencePreviewStubFragment_editions_edges {
  __typename: "EditionsEdge";
  node: DripSequencePreviewStubFragment_editions_edges_node;
}

export interface DripSequencePreviewStubFragment_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * Information to aid in pagination.
   */
  pageInfo: DripSequencePreviewStubFragment_editions_pageInfo;
  /**
   * A list of edges.
   */
  edges: DripSequencePreviewStubFragment_editions_edges[];
}

export interface DripSequencePreviewStubFragment_from_emailAddress {
  __typename: "NutEmailAddress";
  formatted: string;
}

export interface DripSequencePreviewStubFragment_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: DripSequencePreviewStubFragment_from_emailAddress;
}

export interface DripSequencePreviewStubFragment {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * Time of the last campaign status change. For example, if a customer activated
   * this sequence and its still active, this would be the time the sequence was
   * activated. Once the campaign status is changed (paused, retired, etc) this
   * would reflect that new time
   */
  lastStatusChangeTime: any | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The start trigger for the drip sequence
   */
  startTrigger: DripSequencePreviewStubFragment_startTrigger | null;
  editions: DripSequencePreviewStubFragment_editions;
  /**
   * The address to send this edition from
   */
  from: DripSequencePreviewStubFragment_from | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EditionStub
// ====================================================

export interface EditionStub_from_emailAddress {
  __typename: "NutEmailAddress";
  formatted: string;
}

export interface EditionStub_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: EditionStub_from_emailAddress;
}

export interface EditionStub_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface EditionStub_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
  subject: string;
  previewText: string;
}

export interface EditionStub {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The DateTime that represents when the edition was created
   */
  createdTime: any;
  /**
   * The last time this edition was edited.
   */
  modifiedTime: any | null;
  scheduledTime: any | null;
  sendTime: any | null;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Whether this edition is an A/B test
   */
  isABTesting: boolean;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The address to send this edition from
   */
  from: EditionStub_from | null;
  /**
   * The campaign this edition belongs to
   */
  campaign: EditionStub_campaign;
  /**
   * The email template for this edition
   */
  emailTemplate: EditionStub_emailTemplate | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SavedListStubFragment
// ====================================================

export interface SavedListStubFragment_sharedWithEntities {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SavedListStubFragment {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url to the count of entities in this list
   */
  countUrl: string | null;
  /**
   * The DateTime that represents when the saved filter was created. This is sometimes not set for built-in filters.
   */
  createdTime: any | null;
  /**
   * The url path of the saved filter
   */
  htmlUrl: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
  /**
   * The filter string, similar to the html url but without the scheme and host
   */
  filterString: string;
  /**
   * The users description of the saved filter
   */
  description: string | null;
  /**
   * The entity type this filter is for.
   */
  entityType: EntityType;
  /**
   * Whether the saved filter is shared with other users or private
   */
  isShared: boolean | null;
  /**
   * The users and teams that the saved filter is shared with
   */
  sharedWithEntities: (SavedListStubFragment_sharedWithEntities | null)[];
  /**
   * Whether the saved filter can be deleted
   */
  isDeleteable: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EnvelopeContractFragment
// ====================================================

export interface EnvelopeContractFragment {
  __typename: "Contract";
  id: string;
  /**
   * Same-origin URL for this contract PDF.
   */
  pdfDownloadUrl: string | null;
  name: string;
  displayNumber: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: DocumentFieldFragment
// ====================================================

export interface DocumentFieldFragment {
  __typename: "DocumentField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  quoteId: string | null;
  contractId: string | null;
  direction: DocumentFieldDirection;
  type: DocumentFieldType;
  signatureValueType: DocumentSignatureValueType | null;
  label: string;
  placeholder: string | null;
  isRequired: boolean;
  entityName: string | null;
  fieldName: string | null;
  entityAttributeId: string | null;
  /**
   * Raw JSON configuration for this field.
   */
  fieldJson: string | null;
  pageNumber: number | null;
  value: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EnvelopeDocumentFragment
// ====================================================

export interface EnvelopeDocumentFragment_quote_subtotal {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeDocumentFragment_quote_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeDocumentFragment_quote_productLineItems_edges_node_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EnvelopeDocumentFragment_quote_productLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeDocumentFragment_quote_productLineItems_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeDocumentFragment_quote_productLineItems_edges_node {
  __typename: "ProductLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The Nutshell product this line item is related to
   */
  product: EnvelopeDocumentFragment_quote_productLineItems_edges_node_product | null;
  /**
   * The unmodified price of a single unit of the product
   */
  price: EnvelopeDocumentFragment_quote_productLineItems_edges_node_price;
  /**
   * The description of the product
   */
  description: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The quantity of the product
   */
  quantity: number;
  /**
   * The formatted quantity of the product
   */
  formattedQuantity: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The unit of the discount
   */
  discountUnit: QuoteLineItemUnit | null;
  /**
   * The number of the discount
   */
  discountNumber: number | null;
  /**
   * The formatted discount
   */
  formattedDiscount: string | null;
  /**
   * The total price of the product including quantity and discount
   */
  total: EnvelopeDocumentFragment_quote_productLineItems_edges_node_total;
}

export interface EnvelopeDocumentFragment_quote_productLineItems_edges {
  __typename: "QuoteProductLineItemsEdge";
  node: EnvelopeDocumentFragment_quote_productLineItems_edges_node;
}

export interface EnvelopeDocumentFragment_quote_productLineItems {
  __typename: "QuoteProductLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: EnvelopeDocumentFragment_quote_productLineItems_edges[];
}

export interface EnvelopeDocumentFragment_quote_subtotalLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeDocumentFragment_quote_subtotalLineItems_edges_node {
  __typename: "SubtotalLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The price of the subtotal item
   */
  price: EnvelopeDocumentFragment_quote_subtotalLineItems_edges_node_price;
  /**
   * The label of the subtotal item
   */
  label: string;
  /**
   * The unit of the subtotal item's modifier
   */
  modifierUnit: QuoteLineItemUnit;
  /**
   * The value of the subtotal item's modifier
   */
  modifierValue: number;
  /**
   * The formatted subtotal item's modifier
   */
  formattedValue: string;
  /**
   * The operation of the subtotal item
   */
  operation: QuoteLineItemOperation;
}

export interface EnvelopeDocumentFragment_quote_subtotalLineItems_edges {
  __typename: "QuoteSubtotalLineItemsEdge";
  node: EnvelopeDocumentFragment_quote_subtotalLineItems_edges_node;
}

export interface EnvelopeDocumentFragment_quote_subtotalLineItems {
  __typename: "QuoteSubtotalLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: EnvelopeDocumentFragment_quote_subtotalLineItems_edges[];
}

export interface EnvelopeDocumentFragment_quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The subtotal (pre-SubtotalLineItem modifiers) price of the quote
   */
  subtotal: EnvelopeDocumentFragment_quote_subtotal;
  /**
   * The total price of the quote after all modifiers
   */
  total: EnvelopeDocumentFragment_quote_total;
  /**
   * The line items of the quote
   */
  productLineItems: EnvelopeDocumentFragment_quote_productLineItems;
  /**
   * The subtotal line items of the quote
   */
  subtotalLineItems: EnvelopeDocumentFragment_quote_subtotalLineItems;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The time the quote was prepared
   */
  preparedTime: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * The name of the person the quote was prepared for
   */
  preparedFor: string;
  /**
   * The name of the person that prepared the quote
   */
  preparedBy: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The option chosen for how end-users will accept the quote
   */
  acceptanceMode: QuoteAcceptanceOption;
}

export interface EnvelopeDocumentFragment_invoice_subtotal {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeDocumentFragment_invoice_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeDocumentFragment_invoice_productLineItems_edges_node_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EnvelopeDocumentFragment_invoice_productLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeDocumentFragment_invoice_productLineItems_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeDocumentFragment_invoice_productLineItems_edges_node {
  __typename: "ProductLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The Nutshell product this line item is related to
   */
  product: EnvelopeDocumentFragment_invoice_productLineItems_edges_node_product | null;
  /**
   * The unmodified price of a single unit of the product
   */
  price: EnvelopeDocumentFragment_invoice_productLineItems_edges_node_price;
  /**
   * The description of the product
   */
  description: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The quantity of the product
   */
  quantity: number;
  /**
   * The formatted quantity of the product
   */
  formattedQuantity: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The unit of the discount
   */
  discountUnit: QuoteLineItemUnit | null;
  /**
   * The number of the discount
   */
  discountNumber: number | null;
  /**
   * The formatted discount
   */
  formattedDiscount: string | null;
  /**
   * The total price of the product including quantity and discount
   */
  total: EnvelopeDocumentFragment_invoice_productLineItems_edges_node_total;
}

export interface EnvelopeDocumentFragment_invoice_productLineItems_edges {
  __typename: "QuoteProductLineItemsEdge";
  node: EnvelopeDocumentFragment_invoice_productLineItems_edges_node;
}

export interface EnvelopeDocumentFragment_invoice_productLineItems {
  __typename: "QuoteProductLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: EnvelopeDocumentFragment_invoice_productLineItems_edges[];
}

export interface EnvelopeDocumentFragment_invoice_subtotalLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeDocumentFragment_invoice_subtotalLineItems_edges_node {
  __typename: "SubtotalLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The price of the subtotal item
   */
  price: EnvelopeDocumentFragment_invoice_subtotalLineItems_edges_node_price;
  /**
   * The label of the subtotal item
   */
  label: string;
  /**
   * The unit of the subtotal item's modifier
   */
  modifierUnit: QuoteLineItemUnit;
  /**
   * The value of the subtotal item's modifier
   */
  modifierValue: number;
  /**
   * The formatted subtotal item's modifier
   */
  formattedValue: string;
  /**
   * The operation of the subtotal item
   */
  operation: QuoteLineItemOperation;
}

export interface EnvelopeDocumentFragment_invoice_subtotalLineItems_edges {
  __typename: "QuoteSubtotalLineItemsEdge";
  node: EnvelopeDocumentFragment_invoice_subtotalLineItems_edges_node;
}

export interface EnvelopeDocumentFragment_invoice_subtotalLineItems {
  __typename: "QuoteSubtotalLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: EnvelopeDocumentFragment_invoice_subtotalLineItems_edges[];
}

export interface EnvelopeDocumentFragment_invoice_canSendToQuickbooks_TrueWithReason {
  __typename: "TrueWithReason";
}

export interface EnvelopeDocumentFragment_invoice_canSendToQuickbooks_FalseWithReason {
  __typename: "FalseWithReason";
  /**
   * The reason why the value is false
   */
  reason: string;
}

export type EnvelopeDocumentFragment_invoice_canSendToQuickbooks = EnvelopeDocumentFragment_invoice_canSendToQuickbooks_TrueWithReason | EnvelopeDocumentFragment_invoice_canSendToQuickbooks_FalseWithReason;

export interface EnvelopeDocumentFragment_invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The subtotal (pre-SubtotalLineItem modifiers) price of the quote
   */
  subtotal: EnvelopeDocumentFragment_invoice_subtotal;
  /**
   * The total price of the quote after all modifiers
   */
  total: EnvelopeDocumentFragment_invoice_total;
  /**
   * The line items of the quote
   */
  productLineItems: EnvelopeDocumentFragment_invoice_productLineItems;
  /**
   * The subtotal line items of the quote
   */
  subtotalLineItems: EnvelopeDocumentFragment_invoice_subtotalLineItems;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The time the quote was prepared
   */
  preparedTime: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * The name of the person the quote was prepared for
   */
  preparedFor: string;
  /**
   * The name of the person that prepared the quote
   */
  preparedBy: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The purchase order number
   */
  purchaseOrderNumber: string | null;
  /**
   * The customer number
   */
  customerNumber: string | null;
  /**
   * The job number
   */
  jobNumber: string | null;
  /**
   * The reference number
   */
  referenceNumber: string | null;
  /**
   * The payment and terms
   */
  paymentAndTerms: string;
  /**
   * The completion comment
   */
  completionComment: string | null;
  /**
   * A human readable string representing how long over due the invoice is
   */
  overdueDuration: string | null;
  /**
   * URL to view this invoice in QuickBooks, or null if it has not been sent to QuickBooks
   */
  quickbooksInvoiceUrl: string | null;
  /**
   * Whether the invoice can be sent to Quickbooks in its current state
   */
  canSendToQuickbooks: EnvelopeDocumentFragment_invoice_canSendToQuickbooks;
}

export interface EnvelopeDocumentFragment_contract {
  __typename: "Contract";
  id: string;
  /**
   * Same-origin URL for this contract PDF.
   */
  pdfDownloadUrl: string | null;
  name: string;
  displayNumber: string;
}

export interface EnvelopeDocumentFragment_documentFields {
  __typename: "DocumentField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  quoteId: string | null;
  contractId: string | null;
  direction: DocumentFieldDirection;
  type: DocumentFieldType;
  signatureValueType: DocumentSignatureValueType | null;
  label: string;
  placeholder: string | null;
  isRequired: boolean;
  entityName: string | null;
  fieldName: string | null;
  entityAttributeId: string | null;
  /**
   * Raw JSON configuration for this field.
   */
  fieldJson: string | null;
  pageNumber: number | null;
  value: string | null;
}

export interface EnvelopeDocumentFragment {
  __typename: "EnvelopeDocument";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  documentType: EnvelopeDocumentType;
  position: number;
  quote: EnvelopeDocumentFragment_quote | null;
  invoice: EnvelopeDocumentFragment_invoice | null;
  contract: EnvelopeDocumentFragment_contract | null;
  documentFields: EnvelopeDocumentFragment_documentFields[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EnvelopeFragment
// ====================================================

export interface EnvelopeFragment_recipientEntity_Contact_primaryAccount_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface EnvelopeFragment_recipientEntity_Contact_primaryAccount {
  __typename: "ContactAccountsEdge";
  node: EnvelopeFragment_recipientEntity_Contact_primaryAccount_node;
}

export interface EnvelopeFragment_recipientEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary account edge for this contact
   */
  primaryAccount: EnvelopeFragment_recipientEntity_Contact_primaryAccount | null;
}

export interface EnvelopeFragment_recipientEntity_Account_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface EnvelopeFragment_recipientEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary contact for this account
   */
  primaryContact: EnvelopeFragment_recipientEntity_Account_primaryContact | null;
}

export type EnvelopeFragment_recipientEntity = EnvelopeFragment_recipientEntity_Contact | EnvelopeFragment_recipientEntity_Account;

export interface EnvelopeFragment_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
}

export interface EnvelopeFragment_documents_edges_node_quote_subtotal {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeFragment_documents_edges_node_quote_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeFragment_documents_edges_node_quote_productLineItems_edges_node_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EnvelopeFragment_documents_edges_node_quote_productLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeFragment_documents_edges_node_quote_productLineItems_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeFragment_documents_edges_node_quote_productLineItems_edges_node {
  __typename: "ProductLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The Nutshell product this line item is related to
   */
  product: EnvelopeFragment_documents_edges_node_quote_productLineItems_edges_node_product | null;
  /**
   * The unmodified price of a single unit of the product
   */
  price: EnvelopeFragment_documents_edges_node_quote_productLineItems_edges_node_price;
  /**
   * The description of the product
   */
  description: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The quantity of the product
   */
  quantity: number;
  /**
   * The formatted quantity of the product
   */
  formattedQuantity: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The unit of the discount
   */
  discountUnit: QuoteLineItemUnit | null;
  /**
   * The number of the discount
   */
  discountNumber: number | null;
  /**
   * The formatted discount
   */
  formattedDiscount: string | null;
  /**
   * The total price of the product including quantity and discount
   */
  total: EnvelopeFragment_documents_edges_node_quote_productLineItems_edges_node_total;
}

export interface EnvelopeFragment_documents_edges_node_quote_productLineItems_edges {
  __typename: "QuoteProductLineItemsEdge";
  node: EnvelopeFragment_documents_edges_node_quote_productLineItems_edges_node;
}

export interface EnvelopeFragment_documents_edges_node_quote_productLineItems {
  __typename: "QuoteProductLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: EnvelopeFragment_documents_edges_node_quote_productLineItems_edges[];
}

export interface EnvelopeFragment_documents_edges_node_quote_subtotalLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeFragment_documents_edges_node_quote_subtotalLineItems_edges_node {
  __typename: "SubtotalLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The price of the subtotal item
   */
  price: EnvelopeFragment_documents_edges_node_quote_subtotalLineItems_edges_node_price;
  /**
   * The label of the subtotal item
   */
  label: string;
  /**
   * The unit of the subtotal item's modifier
   */
  modifierUnit: QuoteLineItemUnit;
  /**
   * The value of the subtotal item's modifier
   */
  modifierValue: number;
  /**
   * The formatted subtotal item's modifier
   */
  formattedValue: string;
  /**
   * The operation of the subtotal item
   */
  operation: QuoteLineItemOperation;
}

export interface EnvelopeFragment_documents_edges_node_quote_subtotalLineItems_edges {
  __typename: "QuoteSubtotalLineItemsEdge";
  node: EnvelopeFragment_documents_edges_node_quote_subtotalLineItems_edges_node;
}

export interface EnvelopeFragment_documents_edges_node_quote_subtotalLineItems {
  __typename: "QuoteSubtotalLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: EnvelopeFragment_documents_edges_node_quote_subtotalLineItems_edges[];
}

export interface EnvelopeFragment_documents_edges_node_quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The subtotal (pre-SubtotalLineItem modifiers) price of the quote
   */
  subtotal: EnvelopeFragment_documents_edges_node_quote_subtotal;
  /**
   * The total price of the quote after all modifiers
   */
  total: EnvelopeFragment_documents_edges_node_quote_total;
  /**
   * The line items of the quote
   */
  productLineItems: EnvelopeFragment_documents_edges_node_quote_productLineItems;
  /**
   * The subtotal line items of the quote
   */
  subtotalLineItems: EnvelopeFragment_documents_edges_node_quote_subtotalLineItems;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The time the quote was prepared
   */
  preparedTime: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * The name of the person the quote was prepared for
   */
  preparedFor: string;
  /**
   * The name of the person that prepared the quote
   */
  preparedBy: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The option chosen for how end-users will accept the quote
   */
  acceptanceMode: QuoteAcceptanceOption;
}

export interface EnvelopeFragment_documents_edges_node_invoice_subtotal {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeFragment_documents_edges_node_invoice_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeFragment_documents_edges_node_invoice_productLineItems_edges_node_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EnvelopeFragment_documents_edges_node_invoice_productLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeFragment_documents_edges_node_invoice_productLineItems_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeFragment_documents_edges_node_invoice_productLineItems_edges_node {
  __typename: "ProductLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The Nutshell product this line item is related to
   */
  product: EnvelopeFragment_documents_edges_node_invoice_productLineItems_edges_node_product | null;
  /**
   * The unmodified price of a single unit of the product
   */
  price: EnvelopeFragment_documents_edges_node_invoice_productLineItems_edges_node_price;
  /**
   * The description of the product
   */
  description: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The quantity of the product
   */
  quantity: number;
  /**
   * The formatted quantity of the product
   */
  formattedQuantity: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The unit of the discount
   */
  discountUnit: QuoteLineItemUnit | null;
  /**
   * The number of the discount
   */
  discountNumber: number | null;
  /**
   * The formatted discount
   */
  formattedDiscount: string | null;
  /**
   * The total price of the product including quantity and discount
   */
  total: EnvelopeFragment_documents_edges_node_invoice_productLineItems_edges_node_total;
}

export interface EnvelopeFragment_documents_edges_node_invoice_productLineItems_edges {
  __typename: "QuoteProductLineItemsEdge";
  node: EnvelopeFragment_documents_edges_node_invoice_productLineItems_edges_node;
}

export interface EnvelopeFragment_documents_edges_node_invoice_productLineItems {
  __typename: "QuoteProductLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: EnvelopeFragment_documents_edges_node_invoice_productLineItems_edges[];
}

export interface EnvelopeFragment_documents_edges_node_invoice_subtotalLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeFragment_documents_edges_node_invoice_subtotalLineItems_edges_node {
  __typename: "SubtotalLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The price of the subtotal item
   */
  price: EnvelopeFragment_documents_edges_node_invoice_subtotalLineItems_edges_node_price;
  /**
   * The label of the subtotal item
   */
  label: string;
  /**
   * The unit of the subtotal item's modifier
   */
  modifierUnit: QuoteLineItemUnit;
  /**
   * The value of the subtotal item's modifier
   */
  modifierValue: number;
  /**
   * The formatted subtotal item's modifier
   */
  formattedValue: string;
  /**
   * The operation of the subtotal item
   */
  operation: QuoteLineItemOperation;
}

export interface EnvelopeFragment_documents_edges_node_invoice_subtotalLineItems_edges {
  __typename: "QuoteSubtotalLineItemsEdge";
  node: EnvelopeFragment_documents_edges_node_invoice_subtotalLineItems_edges_node;
}

export interface EnvelopeFragment_documents_edges_node_invoice_subtotalLineItems {
  __typename: "QuoteSubtotalLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: EnvelopeFragment_documents_edges_node_invoice_subtotalLineItems_edges[];
}

export interface EnvelopeFragment_documents_edges_node_invoice_canSendToQuickbooks_TrueWithReason {
  __typename: "TrueWithReason";
}

export interface EnvelopeFragment_documents_edges_node_invoice_canSendToQuickbooks_FalseWithReason {
  __typename: "FalseWithReason";
  /**
   * The reason why the value is false
   */
  reason: string;
}

export type EnvelopeFragment_documents_edges_node_invoice_canSendToQuickbooks = EnvelopeFragment_documents_edges_node_invoice_canSendToQuickbooks_TrueWithReason | EnvelopeFragment_documents_edges_node_invoice_canSendToQuickbooks_FalseWithReason;

export interface EnvelopeFragment_documents_edges_node_invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The subtotal (pre-SubtotalLineItem modifiers) price of the quote
   */
  subtotal: EnvelopeFragment_documents_edges_node_invoice_subtotal;
  /**
   * The total price of the quote after all modifiers
   */
  total: EnvelopeFragment_documents_edges_node_invoice_total;
  /**
   * The line items of the quote
   */
  productLineItems: EnvelopeFragment_documents_edges_node_invoice_productLineItems;
  /**
   * The subtotal line items of the quote
   */
  subtotalLineItems: EnvelopeFragment_documents_edges_node_invoice_subtotalLineItems;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The time the quote was prepared
   */
  preparedTime: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * The name of the person the quote was prepared for
   */
  preparedFor: string;
  /**
   * The name of the person that prepared the quote
   */
  preparedBy: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The purchase order number
   */
  purchaseOrderNumber: string | null;
  /**
   * The customer number
   */
  customerNumber: string | null;
  /**
   * The job number
   */
  jobNumber: string | null;
  /**
   * The reference number
   */
  referenceNumber: string | null;
  /**
   * The payment and terms
   */
  paymentAndTerms: string;
  /**
   * The completion comment
   */
  completionComment: string | null;
  /**
   * A human readable string representing how long over due the invoice is
   */
  overdueDuration: string | null;
  /**
   * URL to view this invoice in QuickBooks, or null if it has not been sent to QuickBooks
   */
  quickbooksInvoiceUrl: string | null;
  /**
   * Whether the invoice can be sent to Quickbooks in its current state
   */
  canSendToQuickbooks: EnvelopeFragment_documents_edges_node_invoice_canSendToQuickbooks;
}

export interface EnvelopeFragment_documents_edges_node_contract {
  __typename: "Contract";
  id: string;
  /**
   * Same-origin URL for this contract PDF.
   */
  pdfDownloadUrl: string | null;
  name: string;
  displayNumber: string;
}

export interface EnvelopeFragment_documents_edges_node_documentFields {
  __typename: "DocumentField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  quoteId: string | null;
  contractId: string | null;
  direction: DocumentFieldDirection;
  type: DocumentFieldType;
  signatureValueType: DocumentSignatureValueType | null;
  label: string;
  placeholder: string | null;
  isRequired: boolean;
  entityName: string | null;
  fieldName: string | null;
  entityAttributeId: string | null;
  /**
   * Raw JSON configuration for this field.
   */
  fieldJson: string | null;
  pageNumber: number | null;
  value: string | null;
}

export interface EnvelopeFragment_documents_edges_node {
  __typename: "EnvelopeDocument";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  documentType: EnvelopeDocumentType;
  position: number;
  quote: EnvelopeFragment_documents_edges_node_quote | null;
  invoice: EnvelopeFragment_documents_edges_node_invoice | null;
  contract: EnvelopeFragment_documents_edges_node_contract | null;
  documentFields: EnvelopeFragment_documents_edges_node_documentFields[];
}

export interface EnvelopeFragment_documents_edges {
  __typename: "EnvelopeDocumentsEdge";
  node: EnvelopeFragment_documents_edges_node;
}

export interface EnvelopeFragment_documents {
  __typename: "EnvelopeDocumentsConnection";
  /**
   * A list of edges.
   */
  edges: EnvelopeFragment_documents_edges[];
}

export interface EnvelopeFragment {
  __typename: "Envelope";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * In-app route to the envelope primary document page.
   */
  htmlUrlPath: string;
  primaryDocumentType: EnvelopeDocumentType;
  displayStatus: EnvelopeDisplayStatus;
  publicSlug: string;
  shareableViewInBrowserLink: string;
  internalViewInBrowserLink: string;
  validThroughTime: string | null;
  readyTime: any | null;
  sentTime: any | null;
  acceptedTime: any | null;
  revokedTime: any | null;
  deletedTime: any | null;
  createdTime: any;
  modifiedTime: any | null;
  recipientEmailAddress: string | null;
  recipientEntity: EnvelopeFragment_recipientEntity | null;
  lead: EnvelopeFragment_lead;
  documents: EnvelopeFragment_documents;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EnvelopeLeadFragment
// ====================================================

export interface EnvelopeLeadFragment {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EnvelopeRecipientEntityFragment
// ====================================================

export interface EnvelopeRecipientEntityFragment_Contact_primaryAccount_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface EnvelopeRecipientEntityFragment_Contact_primaryAccount {
  __typename: "ContactAccountsEdge";
  node: EnvelopeRecipientEntityFragment_Contact_primaryAccount_node;
}

export interface EnvelopeRecipientEntityFragment_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary account edge for this contact
   */
  primaryAccount: EnvelopeRecipientEntityFragment_Contact_primaryAccount | null;
}

export interface EnvelopeRecipientEntityFragment_Account_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface EnvelopeRecipientEntityFragment_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The primary contact for this account
   */
  primaryContact: EnvelopeRecipientEntityFragment_Account_primaryContact | null;
}

export type EnvelopeRecipientEntityFragment = EnvelopeRecipientEntityFragment_Contact | EnvelopeRecipientEntityFragment_Account;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EnvelopeInvoiceFragment
// ====================================================

export interface EnvelopeInvoiceFragment_subtotal {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeInvoiceFragment_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeInvoiceFragment_productLineItems_edges_node_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EnvelopeInvoiceFragment_productLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeInvoiceFragment_productLineItems_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeInvoiceFragment_productLineItems_edges_node {
  __typename: "ProductLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The Nutshell product this line item is related to
   */
  product: EnvelopeInvoiceFragment_productLineItems_edges_node_product | null;
  /**
   * The unmodified price of a single unit of the product
   */
  price: EnvelopeInvoiceFragment_productLineItems_edges_node_price;
  /**
   * The description of the product
   */
  description: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The quantity of the product
   */
  quantity: number;
  /**
   * The formatted quantity of the product
   */
  formattedQuantity: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The unit of the discount
   */
  discountUnit: QuoteLineItemUnit | null;
  /**
   * The number of the discount
   */
  discountNumber: number | null;
  /**
   * The formatted discount
   */
  formattedDiscount: string | null;
  /**
   * The total price of the product including quantity and discount
   */
  total: EnvelopeInvoiceFragment_productLineItems_edges_node_total;
}

export interface EnvelopeInvoiceFragment_productLineItems_edges {
  __typename: "QuoteProductLineItemsEdge";
  node: EnvelopeInvoiceFragment_productLineItems_edges_node;
}

export interface EnvelopeInvoiceFragment_productLineItems {
  __typename: "QuoteProductLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: EnvelopeInvoiceFragment_productLineItems_edges[];
}

export interface EnvelopeInvoiceFragment_subtotalLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeInvoiceFragment_subtotalLineItems_edges_node {
  __typename: "SubtotalLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The price of the subtotal item
   */
  price: EnvelopeInvoiceFragment_subtotalLineItems_edges_node_price;
  /**
   * The label of the subtotal item
   */
  label: string;
  /**
   * The unit of the subtotal item's modifier
   */
  modifierUnit: QuoteLineItemUnit;
  /**
   * The value of the subtotal item's modifier
   */
  modifierValue: number;
  /**
   * The formatted subtotal item's modifier
   */
  formattedValue: string;
  /**
   * The operation of the subtotal item
   */
  operation: QuoteLineItemOperation;
}

export interface EnvelopeInvoiceFragment_subtotalLineItems_edges {
  __typename: "QuoteSubtotalLineItemsEdge";
  node: EnvelopeInvoiceFragment_subtotalLineItems_edges_node;
}

export interface EnvelopeInvoiceFragment_subtotalLineItems {
  __typename: "QuoteSubtotalLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: EnvelopeInvoiceFragment_subtotalLineItems_edges[];
}

export interface EnvelopeInvoiceFragment_canSendToQuickbooks_TrueWithReason {
  __typename: "TrueWithReason";
}

export interface EnvelopeInvoiceFragment_canSendToQuickbooks_FalseWithReason {
  __typename: "FalseWithReason";
  /**
   * The reason why the value is false
   */
  reason: string;
}

export type EnvelopeInvoiceFragment_canSendToQuickbooks = EnvelopeInvoiceFragment_canSendToQuickbooks_TrueWithReason | EnvelopeInvoiceFragment_canSendToQuickbooks_FalseWithReason;

export interface EnvelopeInvoiceFragment {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The subtotal (pre-SubtotalLineItem modifiers) price of the quote
   */
  subtotal: EnvelopeInvoiceFragment_subtotal;
  /**
   * The total price of the quote after all modifiers
   */
  total: EnvelopeInvoiceFragment_total;
  /**
   * The line items of the quote
   */
  productLineItems: EnvelopeInvoiceFragment_productLineItems;
  /**
   * The subtotal line items of the quote
   */
  subtotalLineItems: EnvelopeInvoiceFragment_subtotalLineItems;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The time the quote was prepared
   */
  preparedTime: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * The name of the person the quote was prepared for
   */
  preparedFor: string;
  /**
   * The name of the person that prepared the quote
   */
  preparedBy: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The purchase order number
   */
  purchaseOrderNumber: string | null;
  /**
   * The customer number
   */
  customerNumber: string | null;
  /**
   * The job number
   */
  jobNumber: string | null;
  /**
   * The reference number
   */
  referenceNumber: string | null;
  /**
   * The payment and terms
   */
  paymentAndTerms: string;
  /**
   * The completion comment
   */
  completionComment: string | null;
  /**
   * A human readable string representing how long over due the invoice is
   */
  overdueDuration: string | null;
  /**
   * URL to view this invoice in QuickBooks, or null if it has not been sent to QuickBooks
   */
  quickbooksInvoiceUrl: string | null;
  /**
   * Whether the invoice can be sent to Quickbooks in its current state
   */
  canSendToQuickbooks: EnvelopeInvoiceFragment_canSendToQuickbooks;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EnvelopeMoneyFragment
// ====================================================

export interface EnvelopeMoneyFragment {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EnvelopeProductLineItemFragment
// ====================================================

export interface EnvelopeProductLineItemFragment_edges_node_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EnvelopeProductLineItemFragment_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeProductLineItemFragment_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeProductLineItemFragment_edges_node {
  __typename: "ProductLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The Nutshell product this line item is related to
   */
  product: EnvelopeProductLineItemFragment_edges_node_product | null;
  /**
   * The unmodified price of a single unit of the product
   */
  price: EnvelopeProductLineItemFragment_edges_node_price;
  /**
   * The description of the product
   */
  description: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The quantity of the product
   */
  quantity: number;
  /**
   * The formatted quantity of the product
   */
  formattedQuantity: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The unit of the discount
   */
  discountUnit: QuoteLineItemUnit | null;
  /**
   * The number of the discount
   */
  discountNumber: number | null;
  /**
   * The formatted discount
   */
  formattedDiscount: string | null;
  /**
   * The total price of the product including quantity and discount
   */
  total: EnvelopeProductLineItemFragment_edges_node_total;
}

export interface EnvelopeProductLineItemFragment_edges {
  __typename: "QuoteProductLineItemsEdge";
  node: EnvelopeProductLineItemFragment_edges_node;
}

export interface EnvelopeProductLineItemFragment {
  __typename: "QuoteProductLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: EnvelopeProductLineItemFragment_edges[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EnvelopeQuoteFragment
// ====================================================

export interface EnvelopeQuoteFragment_subtotal {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeQuoteFragment_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeQuoteFragment_productLineItems_edges_node_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EnvelopeQuoteFragment_productLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeQuoteFragment_productLineItems_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeQuoteFragment_productLineItems_edges_node {
  __typename: "ProductLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The Nutshell product this line item is related to
   */
  product: EnvelopeQuoteFragment_productLineItems_edges_node_product | null;
  /**
   * The unmodified price of a single unit of the product
   */
  price: EnvelopeQuoteFragment_productLineItems_edges_node_price;
  /**
   * The description of the product
   */
  description: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The quantity of the product
   */
  quantity: number;
  /**
   * The formatted quantity of the product
   */
  formattedQuantity: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The unit of the discount
   */
  discountUnit: QuoteLineItemUnit | null;
  /**
   * The number of the discount
   */
  discountNumber: number | null;
  /**
   * The formatted discount
   */
  formattedDiscount: string | null;
  /**
   * The total price of the product including quantity and discount
   */
  total: EnvelopeQuoteFragment_productLineItems_edges_node_total;
}

export interface EnvelopeQuoteFragment_productLineItems_edges {
  __typename: "QuoteProductLineItemsEdge";
  node: EnvelopeQuoteFragment_productLineItems_edges_node;
}

export interface EnvelopeQuoteFragment_productLineItems {
  __typename: "QuoteProductLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: EnvelopeQuoteFragment_productLineItems_edges[];
}

export interface EnvelopeQuoteFragment_subtotalLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeQuoteFragment_subtotalLineItems_edges_node {
  __typename: "SubtotalLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The price of the subtotal item
   */
  price: EnvelopeQuoteFragment_subtotalLineItems_edges_node_price;
  /**
   * The label of the subtotal item
   */
  label: string;
  /**
   * The unit of the subtotal item's modifier
   */
  modifierUnit: QuoteLineItemUnit;
  /**
   * The value of the subtotal item's modifier
   */
  modifierValue: number;
  /**
   * The formatted subtotal item's modifier
   */
  formattedValue: string;
  /**
   * The operation of the subtotal item
   */
  operation: QuoteLineItemOperation;
}

export interface EnvelopeQuoteFragment_subtotalLineItems_edges {
  __typename: "QuoteSubtotalLineItemsEdge";
  node: EnvelopeQuoteFragment_subtotalLineItems_edges_node;
}

export interface EnvelopeQuoteFragment_subtotalLineItems {
  __typename: "QuoteSubtotalLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: EnvelopeQuoteFragment_subtotalLineItems_edges[];
}

export interface EnvelopeQuoteFragment {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The subtotal (pre-SubtotalLineItem modifiers) price of the quote
   */
  subtotal: EnvelopeQuoteFragment_subtotal;
  /**
   * The total price of the quote after all modifiers
   */
  total: EnvelopeQuoteFragment_total;
  /**
   * The line items of the quote
   */
  productLineItems: EnvelopeQuoteFragment_productLineItems;
  /**
   * The subtotal line items of the quote
   */
  subtotalLineItems: EnvelopeQuoteFragment_subtotalLineItems;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The time the quote was prepared
   */
  preparedTime: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * The name of the person the quote was prepared for
   */
  preparedFor: string;
  /**
   * The name of the person that prepared the quote
   */
  preparedBy: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The option chosen for how end-users will accept the quote
   */
  acceptanceMode: QuoteAcceptanceOption;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EnvelopeSalesDocumentFragment
// ====================================================

export interface EnvelopeSalesDocumentFragment_subtotal {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeSalesDocumentFragment_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeSalesDocumentFragment_productLineItems_edges_node_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EnvelopeSalesDocumentFragment_productLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeSalesDocumentFragment_productLineItems_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeSalesDocumentFragment_productLineItems_edges_node {
  __typename: "ProductLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The Nutshell product this line item is related to
   */
  product: EnvelopeSalesDocumentFragment_productLineItems_edges_node_product | null;
  /**
   * The unmodified price of a single unit of the product
   */
  price: EnvelopeSalesDocumentFragment_productLineItems_edges_node_price;
  /**
   * The description of the product
   */
  description: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The quantity of the product
   */
  quantity: number;
  /**
   * The formatted quantity of the product
   */
  formattedQuantity: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The unit of the discount
   */
  discountUnit: QuoteLineItemUnit | null;
  /**
   * The number of the discount
   */
  discountNumber: number | null;
  /**
   * The formatted discount
   */
  formattedDiscount: string | null;
  /**
   * The total price of the product including quantity and discount
   */
  total: EnvelopeSalesDocumentFragment_productLineItems_edges_node_total;
}

export interface EnvelopeSalesDocumentFragment_productLineItems_edges {
  __typename: "QuoteProductLineItemsEdge";
  node: EnvelopeSalesDocumentFragment_productLineItems_edges_node;
}

export interface EnvelopeSalesDocumentFragment_productLineItems {
  __typename: "QuoteProductLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: EnvelopeSalesDocumentFragment_productLineItems_edges[];
}

export interface EnvelopeSalesDocumentFragment_subtotalLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeSalesDocumentFragment_subtotalLineItems_edges_node {
  __typename: "SubtotalLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The price of the subtotal item
   */
  price: EnvelopeSalesDocumentFragment_subtotalLineItems_edges_node_price;
  /**
   * The label of the subtotal item
   */
  label: string;
  /**
   * The unit of the subtotal item's modifier
   */
  modifierUnit: QuoteLineItemUnit;
  /**
   * The value of the subtotal item's modifier
   */
  modifierValue: number;
  /**
   * The formatted subtotal item's modifier
   */
  formattedValue: string;
  /**
   * The operation of the subtotal item
   */
  operation: QuoteLineItemOperation;
}

export interface EnvelopeSalesDocumentFragment_subtotalLineItems_edges {
  __typename: "QuoteSubtotalLineItemsEdge";
  node: EnvelopeSalesDocumentFragment_subtotalLineItems_edges_node;
}

export interface EnvelopeSalesDocumentFragment_subtotalLineItems {
  __typename: "QuoteSubtotalLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: EnvelopeSalesDocumentFragment_subtotalLineItems_edges[];
}

export interface EnvelopeSalesDocumentFragment {
  __typename: "Quote" | "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The subtotal (pre-SubtotalLineItem modifiers) price of the quote
   */
  subtotal: EnvelopeSalesDocumentFragment_subtotal;
  /**
   * The total price of the quote after all modifiers
   */
  total: EnvelopeSalesDocumentFragment_total;
  /**
   * The line items of the quote
   */
  productLineItems: EnvelopeSalesDocumentFragment_productLineItems;
  /**
   * The subtotal line items of the quote
   */
  subtotalLineItems: EnvelopeSalesDocumentFragment_subtotalLineItems;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The time the quote was prepared
   */
  preparedTime: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * The name of the person the quote was prepared for
   */
  preparedFor: string;
  /**
   * The name of the person that prepared the quote
   */
  preparedBy: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EnvelopeSubtotalLineItemFragment
// ====================================================

export interface EnvelopeSubtotalLineItemFragment_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeSubtotalLineItemFragment_edges_node {
  __typename: "SubtotalLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The price of the subtotal item
   */
  price: EnvelopeSubtotalLineItemFragment_edges_node_price;
  /**
   * The label of the subtotal item
   */
  label: string;
  /**
   * The unit of the subtotal item's modifier
   */
  modifierUnit: QuoteLineItemUnit;
  /**
   * The value of the subtotal item's modifier
   */
  modifierValue: number;
  /**
   * The formatted subtotal item's modifier
   */
  formattedValue: string;
  /**
   * The operation of the subtotal item
   */
  operation: QuoteLineItemOperation;
}

export interface EnvelopeSubtotalLineItemFragment_edges {
  __typename: "QuoteSubtotalLineItemsEdge";
  node: EnvelopeSubtotalLineItemFragment_edges_node;
}

export interface EnvelopeSubtotalLineItemFragment {
  __typename: "QuoteSubtotalLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: EnvelopeSubtotalLineItemFragment_edges[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InvoiceTemplateFragment
// ====================================================

export interface InvoiceTemplateFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface InvoiceTemplateFragment_canSendToQuickbooks_TrueWithReason {
  __typename: "TrueWithReason";
}

export interface InvoiceTemplateFragment_canSendToQuickbooks_FalseWithReason {
  __typename: "FalseWithReason";
  /**
   * The reason why the value is false
   */
  reason: string;
}

export type InvoiceTemplateFragment_canSendToQuickbooks = InvoiceTemplateFragment_canSendToQuickbooks_TrueWithReason | InvoiceTemplateFragment_canSendToQuickbooks_FalseWithReason;

export interface InvoiceTemplateFragment {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that created the quote
   */
  creatorUser: InvoiceTemplateFragment_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The purchase order number
   */
  purchaseOrderNumber: string | null;
  /**
   * The job number
   */
  jobNumber: string | null;
  /**
   * The customer number
   */
  customerNumber: string | null;
  /**
   * The reference number
   */
  referenceNumber: string | null;
  /**
   * The payment and terms
   */
  paymentAndTerms: string;
  /**
   * Whether the signature should be shown
   */
  isSignatureShown: boolean;
  /**
   * Whether the invoice can be sent to Quickbooks in its current state
   */
  canSendToQuickbooks: InvoiceTemplateFragment_canSendToQuickbooks;
  /**
   * URL to view this invoice in QuickBooks, or null if it has not been sent to QuickBooks
   */
  quickbooksInvoiceUrl: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadInvoiceFragment
// ====================================================

export interface LeadInvoiceFragment_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface LeadInvoiceFragment_canSendToQuickbooks_TrueWithReason {
  __typename: "TrueWithReason";
}

export interface LeadInvoiceFragment_canSendToQuickbooks_FalseWithReason {
  __typename: "FalseWithReason";
  /**
   * The reason why the value is false
   */
  reason: string;
}

export type LeadInvoiceFragment_canSendToQuickbooks = LeadInvoiceFragment_canSendToQuickbooks_TrueWithReason | LeadInvoiceFragment_canSendToQuickbooks_FalseWithReason;

export interface LeadInvoiceFragment {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of a quote that should be displayed to the user
   */
  displayStatus: QuoteDisplayStatus;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: LeadInvoiceFragment_total;
  /**
   * The slug of the quote
   */
  slug: string;
  /**
   * The sharable view in browser link
   */
  shareableViewInBrowserLink: string;
  /**
   * The internal view in browser link, for viewing as the customer without recording a view
   */
  internalViewInBrowserLink: string;
  /**
   * The time the quote was sent
   */
  sentTime: any | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was published
   */
  publishedTime: any | null;
  /**
   * The time the quote was accepted
   */
  acceptedTime: any | null;
  /**
   * A human readable string representing how long over due the invoice is
   */
  overdueDuration: string | null;
  /**
   * URL to view this invoice in QuickBooks, or null if it has not been sent to QuickBooks
   */
  quickbooksInvoiceUrl: string | null;
  /**
   * Whether the invoice can be sent to Quickbooks in its current state
   */
  canSendToQuickbooks: LeadInvoiceFragment_canSendToQuickbooks;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadQuoteFragment
// ====================================================

export interface LeadQuoteFragment_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface LeadQuoteFragment {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of a quote that should be displayed to the user
   */
  displayStatus: QuoteDisplayStatus;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: LeadQuoteFragment_total;
  /**
   * The slug of the quote
   */
  slug: string;
  /**
   * The sharable view in browser link
   */
  shareableViewInBrowserLink: string;
  /**
   * The internal view in browser link, for viewing as the customer without recording a view
   */
  internalViewInBrowserLink: string;
  /**
   * The time the quote was sent
   */
  sentTime: any | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was published
   */
  publishedTime: any | null;
  /**
   * The time the quote was accepted
   */
  acceptedTime: any | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: QuoteTemplateFragment
// ====================================================

export interface QuoteTemplateFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface QuoteTemplateFragment_templateAttachedContract {
  __typename: "ContractTemplate";
  id: string;
  name: string;
  htmlUrlPath: string;
}

export interface QuoteTemplateFragment {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Display name for the quote template
   */
  name: string | null;
  /**
   * The user that created the quote
   */
  creatorUser: QuoteTemplateFragment_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The option chosen for how end-users will accept the quote
   */
  acceptanceMode: QuoteAcceptanceOption;
  /**
   * The contract template attached to this quote template
   */
  templateAttachedContract: QuoteTemplateFragment_templateAttachedContract | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SalesDocumentFragment
// ====================================================

export interface SalesDocumentFragment_Quote_subtotal {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface SalesDocumentFragment_Quote_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface SalesDocumentFragment_Quote_productLineItems_edges_node_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SalesDocumentFragment_Quote_productLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface SalesDocumentFragment_Quote_productLineItems_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface SalesDocumentFragment_Quote_productLineItems_edges_node {
  __typename: "ProductLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The Nutshell product this line item is related to
   */
  product: SalesDocumentFragment_Quote_productLineItems_edges_node_product | null;
  /**
   * The unmodified price of a single unit of the product
   */
  price: SalesDocumentFragment_Quote_productLineItems_edges_node_price;
  /**
   * The description of the product
   */
  description: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The quantity of the product
   */
  quantity: number;
  /**
   * The formatted quantity of the product
   */
  formattedQuantity: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The unit of the discount
   */
  discountUnit: QuoteLineItemUnit | null;
  /**
   * The number of the discount
   */
  discountNumber: number | null;
  /**
   * The formatted discount
   */
  formattedDiscount: string | null;
  /**
   * The total price of the product including quantity and discount
   */
  total: SalesDocumentFragment_Quote_productLineItems_edges_node_total;
}

export interface SalesDocumentFragment_Quote_productLineItems_edges {
  __typename: "QuoteProductLineItemsEdge";
  node: SalesDocumentFragment_Quote_productLineItems_edges_node;
}

export interface SalesDocumentFragment_Quote_productLineItems {
  __typename: "QuoteProductLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: SalesDocumentFragment_Quote_productLineItems_edges[];
}

export interface SalesDocumentFragment_Quote_subtotalLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface SalesDocumentFragment_Quote_subtotalLineItems_edges_node {
  __typename: "SubtotalLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The price of the subtotal item
   */
  price: SalesDocumentFragment_Quote_subtotalLineItems_edges_node_price;
  /**
   * The label of the subtotal item
   */
  label: string;
  /**
   * The unit of the subtotal item's modifier
   */
  modifierUnit: QuoteLineItemUnit;
  /**
   * The value of the subtotal item's modifier
   */
  modifierValue: number;
  /**
   * The formatted subtotal item's modifier
   */
  formattedValue: string;
  /**
   * The operation of the subtotal item
   */
  operation: QuoteLineItemOperation;
}

export interface SalesDocumentFragment_Quote_subtotalLineItems_edges {
  __typename: "QuoteSubtotalLineItemsEdge";
  node: SalesDocumentFragment_Quote_subtotalLineItems_edges_node;
}

export interface SalesDocumentFragment_Quote_subtotalLineItems {
  __typename: "QuoteSubtotalLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: SalesDocumentFragment_Quote_subtotalLineItems_edges[];
}

export interface SalesDocumentFragment_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SalesDocumentFragment_Quote_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SalesDocumentFragment_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The subtotal (pre-SubtotalLineItem modifiers) price of the quote
   */
  subtotal: SalesDocumentFragment_Quote_subtotal;
  /**
   * The total price of the quote after all modifiers
   */
  total: SalesDocumentFragment_Quote_total;
  /**
   * The line items of the quote
   */
  productLineItems: SalesDocumentFragment_Quote_productLineItems;
  /**
   * The subtotal line items of the quote
   */
  subtotalLineItems: SalesDocumentFragment_Quote_subtotalLineItems;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The time the quote was prepared
   */
  preparedTime: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * The name of the person the quote was prepared for
   */
  preparedFor: string;
  /**
   * The name of the person that prepared the quote
   */
  preparedBy: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The status of a quote that should be displayed to the user
   */
  displayStatus: QuoteDisplayStatus;
  /**
   * The string log of the last status update
   */
  statusLog: string;
  /**
   * The slug of the quote
   */
  slug: string;
  /**
   * The date the quote is valid until
   */
  validUntilDate: string | null;
  /**
   * The date the quote is valid until
   */
  validUntilDateFormatted: string;
  /**
   * The user that created the quote
   */
  creatorUser: SalesDocumentFragment_Quote_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The time the quote was sent
   */
  sentTime: any | null;
  /**
   * The time the quote was accepted
   */
  acceptedTime: any | null;
  /**
   * The time the quote was revoked
   */
  revokedTime: any | null;
  /**
   * The time the quote was archived
   */
  archivedTime: any | null;
  /**
   * The time the quote was published
   */
  publishedTime: any | null;
  /**
   * The sharable view in browser link
   */
  shareableViewInBrowserLink: string;
  /**
   * The lead the quote is associated with
   */
  lead: SalesDocumentFragment_Quote_lead;
  /**
   * The option chosen for how end-users will accept the quote
   */
  acceptanceMode: QuoteAcceptanceOption;
}

export interface SalesDocumentFragment_Invoice_subtotal {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface SalesDocumentFragment_Invoice_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface SalesDocumentFragment_Invoice_productLineItems_edges_node_product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SalesDocumentFragment_Invoice_productLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface SalesDocumentFragment_Invoice_productLineItems_edges_node_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface SalesDocumentFragment_Invoice_productLineItems_edges_node {
  __typename: "ProductLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The Nutshell product this line item is related to
   */
  product: SalesDocumentFragment_Invoice_productLineItems_edges_node_product | null;
  /**
   * The unmodified price of a single unit of the product
   */
  price: SalesDocumentFragment_Invoice_productLineItems_edges_node_price;
  /**
   * The description of the product
   */
  description: string;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The quantity of the product
   */
  quantity: number;
  /**
   * The formatted quantity of the product
   */
  formattedQuantity: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The unit of the discount
   */
  discountUnit: QuoteLineItemUnit | null;
  /**
   * The number of the discount
   */
  discountNumber: number | null;
  /**
   * The formatted discount
   */
  formattedDiscount: string | null;
  /**
   * The total price of the product including quantity and discount
   */
  total: SalesDocumentFragment_Invoice_productLineItems_edges_node_total;
}

export interface SalesDocumentFragment_Invoice_productLineItems_edges {
  __typename: "QuoteProductLineItemsEdge";
  node: SalesDocumentFragment_Invoice_productLineItems_edges_node;
}

export interface SalesDocumentFragment_Invoice_productLineItems {
  __typename: "QuoteProductLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: SalesDocumentFragment_Invoice_productLineItems_edges[];
}

export interface SalesDocumentFragment_Invoice_subtotalLineItems_edges_node_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface SalesDocumentFragment_Invoice_subtotalLineItems_edges_node {
  __typename: "SubtotalLineItem";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The price of the subtotal item
   */
  price: SalesDocumentFragment_Invoice_subtotalLineItems_edges_node_price;
  /**
   * The label of the subtotal item
   */
  label: string;
  /**
   * The unit of the subtotal item's modifier
   */
  modifierUnit: QuoteLineItemUnit;
  /**
   * The value of the subtotal item's modifier
   */
  modifierValue: number;
  /**
   * The formatted subtotal item's modifier
   */
  formattedValue: string;
  /**
   * The operation of the subtotal item
   */
  operation: QuoteLineItemOperation;
}

export interface SalesDocumentFragment_Invoice_subtotalLineItems_edges {
  __typename: "QuoteSubtotalLineItemsEdge";
  node: SalesDocumentFragment_Invoice_subtotalLineItems_edges_node;
}

export interface SalesDocumentFragment_Invoice_subtotalLineItems {
  __typename: "QuoteSubtotalLineItemsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: SalesDocumentFragment_Invoice_subtotalLineItems_edges[];
}

export interface SalesDocumentFragment_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SalesDocumentFragment_Invoice_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SalesDocumentFragment_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The subtotal (pre-SubtotalLineItem modifiers) price of the quote
   */
  subtotal: SalesDocumentFragment_Invoice_subtotal;
  /**
   * The total price of the quote after all modifiers
   */
  total: SalesDocumentFragment_Invoice_total;
  /**
   * The line items of the quote
   */
  productLineItems: SalesDocumentFragment_Invoice_productLineItems;
  /**
   * The subtotal line items of the quote
   */
  subtotalLineItems: SalesDocumentFragment_Invoice_subtotalLineItems;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The time the quote was prepared
   */
  preparedTime: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * The name of the person the quote was prepared for
   */
  preparedFor: string;
  /**
   * The name of the person that prepared the quote
   */
  preparedBy: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The status of a quote that should be displayed to the user
   */
  displayStatus: QuoteDisplayStatus;
  /**
   * The string log of the last status update
   */
  statusLog: string;
  /**
   * The slug of the quote
   */
  slug: string;
  /**
   * The date the quote is valid until
   */
  validUntilDate: string | null;
  /**
   * The date the quote is valid until
   */
  validUntilDateFormatted: string;
  /**
   * The user that created the quote
   */
  creatorUser: SalesDocumentFragment_Invoice_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The time the quote was sent
   */
  sentTime: any | null;
  /**
   * The time the quote was accepted
   */
  acceptedTime: any | null;
  /**
   * The time the quote was revoked
   */
  revokedTime: any | null;
  /**
   * The time the quote was archived
   */
  archivedTime: any | null;
  /**
   * The time the quote was published
   */
  publishedTime: any | null;
  /**
   * The sharable view in browser link
   */
  shareableViewInBrowserLink: string;
  /**
   * The lead the quote is associated with
   */
  lead: SalesDocumentFragment_Invoice_lead;
  /**
   * The purchase order number
   */
  purchaseOrderNumber: string | null;
  /**
   * The customer number
   */
  customerNumber: string | null;
  /**
   * The job number
   */
  jobNumber: string | null;
  /**
   * The reference number
   */
  referenceNumber: string | null;
  /**
   * The payment and terms
   */
  paymentAndTerms: string;
  /**
   * The completion comment
   */
  completionComment: string | null;
  /**
   * A human readable string representing how long over due the invoice is
   */
  overdueDuration: string | null;
}

export type SalesDocumentFragment = SalesDocumentFragment_Quote | SalesDocumentFragment_Invoice;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SalesDocumentTemplateFragment
// ====================================================

export interface SalesDocumentTemplateFragment_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SalesDocumentTemplateFragment_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that created the quote
   */
  creatorUser: SalesDocumentTemplateFragment_Quote_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
}

export interface SalesDocumentTemplateFragment_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SalesDocumentTemplateFragment_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that created the quote
   */
  creatorUser: SalesDocumentTemplateFragment_Invoice_creatorUser | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The left column of the header
   */
  headerLeftColumn: string;
  /**
   * The right column of the header
   */
  headerRightColumn: string;
  /**
   * The body of the quote
   */
  body: string;
  /**
   * The footer of the quote
   */
  footer: string;
  /**
   * Whether the SKU should be shown
   */
  isSkuShown: boolean;
  /**
   * Whether the term should be shown
   */
  isTermShown: boolean;
  /**
   * Whether the discount should be shown
   */
  isDiscountShown: boolean;
  /**
   * The logo shown at the top of a quote
   */
  logo: string | null;
  /**
   * The purchase order number
   */
  purchaseOrderNumber: string | null;
  /**
   * The job number
   */
  jobNumber: string | null;
  /**
   * The customer number
   */
  customerNumber: string | null;
  /**
   * The reference number
   */
  referenceNumber: string | null;
  /**
   * The payment and terms
   */
  paymentAndTerms: string;
}

export type SalesDocumentTemplateFragment = SalesDocumentTemplateFragment_Quote | SalesDocumentTemplateFragment_Invoice;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ExternalMeetingFragment
// ====================================================

export interface ExternalMeetingFragment_duration {
  __typename: "FormattedValueDuration";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formattedString: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface ExternalMeetingFragment_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface ExternalMeetingFragment_participants_emailAddress_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface ExternalMeetingFragment_participants_emailAddress {
  __typename: "NutEmailAddress";
  display: string;
  address: string;
  avatarEntity: ExternalMeetingFragment_participants_emailAddress_avatarEntity | null;
}

export interface ExternalMeetingFragment_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
  emailAddress: ExternalMeetingFragment_participants_emailAddress | null;
}

export interface ExternalMeetingFragment_activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  htmlUrl: string | null;
  htmlUrlPath: string | null;
  primaryEmailAddress: string | null;
  primaryPhoneNumber: string | null;
}

export interface ExternalMeetingFragment_activity_duration {
  __typename: "FormattedValueDuration";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formattedString: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface ExternalMeetingFragment_activity_summary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface ExternalMeetingFragment_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The DateTime that represents the start time of the Activity record
   */
  startTime: any;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: ExternalMeetingFragment_activity_participants[];
  /**
   * The duration of the activity in minutes
   */
  durationMinutes: number | null;
  /**
   * The duration of this meeting
   */
  duration: ExternalMeetingFragment_activity_duration | null;
  /**
   * The summary of the activity.
   */
  summary: ExternalMeetingFragment_activity_summary | null;
}

export interface ExternalMeetingFragment {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of meeting (ex., instant, scheduled, inbound call, etc.)
   */
  type: ExternalType;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
  /**
   * The duration of this meeting
   */
  duration: ExternalMeetingFragment_duration | null;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: ExternalMeetingFragment_transcriptionSummary | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: ExternalMeetingFragment_participants[];
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The activity associated with this meeting, if it exists
   */
  activity: ExternalMeetingFragment_activity | null;
  /**
   * Whether the meeting is still processing, which is the state we go into when we do not have an end time
   */
  isProcessing: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ProductUpdateFragment
// ====================================================

export interface ProductUpdateFragment_primaryCta {
  __typename: "ProductUpdatePrimaryCta";
  text: string;
  href: string;
  isExternal: boolean;
  /**
   * When true, the in-app modal only shows this CTA to administrators.
   */
  adminOnly: boolean;
}

export interface ProductUpdateFragment {
  __typename: "ProductUpdate";
  id: string;
  slug: string;
  /**
   * ISO date `YYYY-MM-DD` from frontmatter.
   */
  publishedAt: string;
  /**
   * When true, only administrators see this update in the in-app teaser.
   */
  adminOnly: boolean;
  /**
   * True when the promo is live for production customers. Set in frontmatter; independent of `publishedAt`.
   */
  isLive: boolean;
  labels: string[];
  title: string;
  /**
   * Sidebar teaser body. One short sentence.
   */
  teaserDescription: string;
  /**
   * Description sized for product update cards on the explore page.
   */
  exploreDescription: string;
  /**
   * 1-2 sentence summary sized for the in-modal "Recent updates" list and the
   * public changelog. Null falls back to `teaserDescription` on render.
   */
  listDescription: string | null;
  /**
   * Absolute web path to the illustration asset under
   * `public/include/images/product-updates/<id>/`. Pass this directly to the
   * `Illustration` component via the `fullPath` prop on the client.
   */
  illustrationSrc: string;
  /**
   * Compact illustration asset for explore-page cards.
   */
  illustrationMiniSrc: string;
  illustrationBackgroundColor: string | null;
  modalHeaderText: string;
  modalHeaderSubtext: string | null;
  modalHeaderBackgroundColor: string | null;
  modalCloseButtonColor: string | null;
  updateColor: string | null;
  primaryCta: ProductUpdateFragment_primaryCta | null;
  learnMoreUrl: string | null;
  /**
   * GitHub-flavored markdown source. Render client-side via `react-markdown`.
   */
  body: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntityAttributeBase
// ====================================================

export interface EntityAttributeBase_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface EntityAttributeBase {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: EntityAttributeBase_attribute;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntityAttribute
// ====================================================

export interface EntityAttribute_EntityAttributeBase_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface EntityAttribute_EntityAttributeBase {
  __typename: "EntityAttributeBase";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: EntityAttribute_EntityAttributeBase_attribute;
}

export interface EntityAttribute_EntityAttributeEnum_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface EntityAttribute_EntityAttributeEnum_options {
  __typename: "EnumOption";
  /**
   * The name (and primary identifier) of the enum option.
   */
  id: string;
  /**
   * The name (and display) of the enum option.
   */
  name: string;
}

export interface EntityAttribute_EntityAttributeEnum {
  __typename: "EntityAttributeEnum";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: EntityAttribute_EntityAttributeEnum_attribute;
  /**
   * Enum options for this field
   */
  options: EntityAttribute_EntityAttributeEnum_options[];
  /**
   * Does this enum field allow multiple selections. I.e. can the value of "Favorite Color" be "Red" AND "Blue"?
   */
  allowMultiple: boolean;
}

export interface EntityAttribute_EntityAttributeCurrency_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface EntityAttribute_EntityAttributeCurrency {
  __typename: "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: EntityAttribute_EntityAttributeCurrency_attribute;
  /**
   * Available currency options for this field
   */
  currencyOptions: string[];
  /**
   * Default currency for this field
   */
  defaultCurrency: string;
}

export type EntityAttribute = EntityAttribute_EntityAttributeBase | EntityAttribute_EntityAttributeEnum | EntityAttribute_EntityAttributeCurrency;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntityAttributeEnum
// ====================================================

export interface EntityAttributeEnum_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface EntityAttributeEnum_options {
  __typename: "EnumOption";
  /**
   * The name (and primary identifier) of the enum option.
   */
  id: string;
  /**
   * The name (and display) of the enum option.
   */
  name: string;
}

export interface EntityAttributeEnum {
  __typename: "EntityAttributeEnum";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: EntityAttributeEnum_attribute;
  /**
   * Enum options for this field
   */
  options: EntityAttributeEnum_options[];
  /**
   * Does this enum field allow multiple selections. I.e. can the value of "Favorite Color" be "Red" AND "Blue"?
   */
  allowMultiple: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntityAttributeCurrency
// ====================================================

export interface EntityAttributeCurrency_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface EntityAttributeCurrency {
  __typename: "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: EntityAttributeCurrency_attribute;
  /**
   * Available currency options for this field
   */
  currencyOptions: string[];
  /**
   * Default currency for this field
   */
  defaultCurrency: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntityAttributeValue
// ====================================================

export interface EntityAttributeValue_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface EntityAttributeValue_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface EntityAttributeValue_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface EntityAttributeValue_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
}

export interface EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates | null;
}

export interface EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue;
}

export interface EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type EntityAttributeValue_EntityAttributeValueset_all = EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueset | EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueString | EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueText | EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueEnum | EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueDate | EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueEmail | EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValuePhone | EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueLocation | EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueFile | EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueCurrency | EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueImage | EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueUrl | EntityAttributeValue_EntityAttributeValueset_all_EntityAttributeValueNumber;

export interface EntityAttributeValue_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: EntityAttributeValue_EntityAttributeValueset_all[];
}

export interface EntityAttributeValue_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface EntityAttributeValue_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface EntityAttributeValue_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface EntityAttributeValue_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: EntityAttributeValue_EntityAttributeValueLocation_coordinates | null;
}

export interface EntityAttributeValue_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface EntityAttributeValue_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: EntityAttributeValue_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface EntityAttributeValue_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface EntityAttributeValue_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: EntityAttributeValue_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface EntityAttributeValue_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: EntityAttributeValue_EntityAttributeValueCurrency_currencyValue;
}

export interface EntityAttributeValue_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface EntityAttributeValue_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface EntityAttributeValue_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type EntityAttributeValue = EntityAttributeValue_EntityAttributeValueString | EntityAttributeValue_EntityAttributeValueText | EntityAttributeValue_EntityAttributeValueEnum | EntityAttributeValue_EntityAttributeValueDate | EntityAttributeValue_EntityAttributeValueset | EntityAttributeValue_EntityAttributeValueEmail | EntityAttributeValue_EntityAttributeValuePhone | EntityAttributeValue_EntityAttributeValueLocation | EntityAttributeValue_EntityAttributeValueFile | EntityAttributeValue_EntityAttributeValueCurrency | EntityAttributeValue_EntityAttributeValueImage | EntityAttributeValue_EntityAttributeValueUrl | EntityAttributeValue_EntityAttributeValueNumber;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntityAttributeValueString
// ====================================================

export interface EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntityAttributeValueText
// ====================================================

export interface EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntityAttributeValueNumber
// ====================================================

export interface EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntityAttributeValueEnum
// ====================================================

export interface EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntityAttributeValueDate
// ====================================================

export interface EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntityAttributeValueValueset
// ====================================================

export interface EntityAttributeValueValueset_all_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
}

export interface EntityAttributeValueValueset_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface EntityAttributeValueValueset_all_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface EntityAttributeValueValueset_all_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface EntityAttributeValueValueset_all_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface EntityAttributeValueValueset_all_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface EntityAttributeValueValueset_all_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface EntityAttributeValueValueset_all_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface EntityAttributeValueValueset_all_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: EntityAttributeValueValueset_all_EntityAttributeValueLocation_coordinates | null;
}

export interface EntityAttributeValueValueset_all_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface EntityAttributeValueValueset_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: EntityAttributeValueValueset_all_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface EntityAttributeValueValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface EntityAttributeValueValueset_all_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: EntityAttributeValueValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface EntityAttributeValueValueset_all_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: EntityAttributeValueValueset_all_EntityAttributeValueCurrency_currencyValue;
}

export interface EntityAttributeValueValueset_all_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface EntityAttributeValueValueset_all_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface EntityAttributeValueValueset_all_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type EntityAttributeValueValueset_all = EntityAttributeValueValueset_all_EntityAttributeValueset | EntityAttributeValueValueset_all_EntityAttributeValueString | EntityAttributeValueValueset_all_EntityAttributeValueText | EntityAttributeValueValueset_all_EntityAttributeValueEnum | EntityAttributeValueValueset_all_EntityAttributeValueDate | EntityAttributeValueValueset_all_EntityAttributeValueEmail | EntityAttributeValueValueset_all_EntityAttributeValuePhone | EntityAttributeValueValueset_all_EntityAttributeValueLocation | EntityAttributeValueValueset_all_EntityAttributeValueFile | EntityAttributeValueValueset_all_EntityAttributeValueCurrency | EntityAttributeValueValueset_all_EntityAttributeValueImage | EntityAttributeValueValueset_all_EntityAttributeValueUrl | EntityAttributeValueValueset_all_EntityAttributeValueNumber;

export interface EntityAttributeValueValueset {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: EntityAttributeValueValueset_all[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntityAttributeValueEmail
// ====================================================

export interface EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntityAttributeValuePhone
// ====================================================

export interface EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntityAttributeValueLocation
// ====================================================

export interface EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: EntityAttributeValueLocation_coordinates | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntityAttributeValueFile
// ====================================================

export interface EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntityAttributeValueCurrency
// ====================================================

export interface EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: EntityAttributeValueCurrency_currencyValue;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntityAttributeValueImage
// ====================================================

export interface EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntityAttributeValueUrl
// ====================================================

export interface EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FieldAnswerRuleFragment
// ====================================================

export interface FieldAnswerRuleFragment_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface FieldAnswerRuleFragment_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FieldAnswerRuleFragment_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface FieldAnswerRuleFragment_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface FieldAnswerRuleFragment_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FieldAnswerRuleFragment_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type FieldAnswerRuleFragment_objectsToAssign = FieldAnswerRuleFragment_objectsToAssign_Tag | FieldAnswerRuleFragment_objectsToAssign_Audience | FieldAnswerRuleFragment_objectsToAssign_Product | FieldAnswerRuleFragment_objectsToAssign_Source | FieldAnswerRuleFragment_objectsToAssign_Stageset;

export interface FieldAnswerRuleFragment {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: FieldAnswerRuleFragment_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: FieldAnswerRuleFragment_objectsToAssign[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FormFieldFragment
// ====================================================

export interface FormFieldFragment_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface FormFieldFragment_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface FormFieldFragment_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface FormFieldFragment_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FormFieldFragment_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface FormFieldFragment_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface FormFieldFragment_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FormFieldFragment_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type FormFieldFragment_rules_objectsToAssign = FormFieldFragment_rules_objectsToAssign_Tag | FormFieldFragment_rules_objectsToAssign_Audience | FormFieldFragment_rules_objectsToAssign_Product | FormFieldFragment_rules_objectsToAssign_Source | FormFieldFragment_rules_objectsToAssign_Stageset;

export interface FormFieldFragment_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: FormFieldFragment_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: FormFieldFragment_rules_objectsToAssign[];
}

export interface FormFieldFragment {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: FormFieldFragment_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: FormFieldFragment_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: FormFieldFragment_rules[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FormPageFragment
// ====================================================

export interface FormPageFragment_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface FormPageFragment_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface FormPageFragment_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface FormPageFragment_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FormPageFragment_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface FormPageFragment_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface FormPageFragment_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FormPageFragment_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type FormPageFragment_fields_rules_objectsToAssign = FormPageFragment_fields_rules_objectsToAssign_Tag | FormPageFragment_fields_rules_objectsToAssign_Audience | FormPageFragment_fields_rules_objectsToAssign_Product | FormPageFragment_fields_rules_objectsToAssign_Source | FormPageFragment_fields_rules_objectsToAssign_Stageset;

export interface FormPageFragment_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: FormPageFragment_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: FormPageFragment_fields_rules_objectsToAssign[];
}

export interface FormPageFragment_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: FormPageFragment_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: FormPageFragment_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: FormPageFragment_fields_rules[];
}

export interface FormPageFragment_defaultRule_targetPage {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
}

export interface FormPageFragment_defaultRule_enumElement {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface FormPageFragment_defaultRule_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface FormPageFragment_defaultRule {
  __typename: "PageRule";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The action type of the rule
   */
  actionType: PageRuleActionType;
  /**
   * Whether the rule is field based
   */
  isFieldBased: boolean;
  /**
   * The page that the rule is associated with
   */
  targetPage: FormPageFragment_defaultRule_targetPage | null;
  /**
   * The enum element that the rule is associated with
   */
  enumElement: FormPageFragment_defaultRule_enumElement | null;
  /**
   * The field that the rule is associated with
   */
  field: FormPageFragment_defaultRule_field | null;
}

export interface FormPageFragment_conditionalRules_targetPage {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
}

export interface FormPageFragment_conditionalRules_enumElement {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface FormPageFragment_conditionalRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface FormPageFragment_conditionalRules {
  __typename: "PageRule";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The action type of the rule
   */
  actionType: PageRuleActionType;
  /**
   * Whether the rule is field based
   */
  isFieldBased: boolean;
  /**
   * The page that the rule is associated with
   */
  targetPage: FormPageFragment_conditionalRules_targetPage | null;
  /**
   * The enum element that the rule is associated with
   */
  enumElement: FormPageFragment_conditionalRules_enumElement | null;
  /**
   * The field that the rule is associated with
   */
  field: FormPageFragment_conditionalRules_field | null;
}

export interface FormPageFragment {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
  /**
   * Array of fields associated with this web form page
   */
  fields: FormPageFragment_fields[];
  /**
   * The non-field based page rule associated with this web form page
   */
  defaultRule: FormPageFragment_defaultRule;
  /**
   * Array of field-based rules associated with this web form page
   */
  conditionalRules: FormPageFragment_conditionalRules[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: MultiPageFormFragment
// ====================================================

export interface MultiPageFormFragment_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface MultiPageFormFragment_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface MultiPageFormFragment_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface MultiPageFormFragment_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface MultiPageFormFragment_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface MultiPageFormFragment_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: MultiPageFormFragment_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: MultiPageFormFragment_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: MultiPageFormFragment_createRules_lead_stagesetFieldRules_stageset;
}

export interface MultiPageFormFragment_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: MultiPageFormFragment_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: MultiPageFormFragment_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: MultiPageFormFragment_createRules_lead_stagesetFieldRules[];
}

export interface MultiPageFormFragment_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface MultiPageFormFragment_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface MultiPageFormFragment_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: MultiPageFormFragment_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: MultiPageFormFragment_createRules_contact_audiences[];
}

export interface MultiPageFormFragment_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface MultiPageFormFragment_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: MultiPageFormFragment_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface MultiPageFormFragment_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: MultiPageFormFragment_createRules_lead | null;
  /**
   * The create rules related to a contact
   */
  contact: MultiPageFormFragment_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: MultiPageFormFragment_createRules_account | null;
}

export interface MultiPageFormFragment_publishedVersion_pages_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface MultiPageFormFragment_publishedVersion_pages_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface MultiPageFormFragment_publishedVersion_pages_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface MultiPageFormFragment_publishedVersion_pages_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface MultiPageFormFragment_publishedVersion_pages_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface MultiPageFormFragment_publishedVersion_pages_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface MultiPageFormFragment_publishedVersion_pages_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface MultiPageFormFragment_publishedVersion_pages_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type MultiPageFormFragment_publishedVersion_pages_fields_rules_objectsToAssign = MultiPageFormFragment_publishedVersion_pages_fields_rules_objectsToAssign_Tag | MultiPageFormFragment_publishedVersion_pages_fields_rules_objectsToAssign_Audience | MultiPageFormFragment_publishedVersion_pages_fields_rules_objectsToAssign_Product | MultiPageFormFragment_publishedVersion_pages_fields_rules_objectsToAssign_Source | MultiPageFormFragment_publishedVersion_pages_fields_rules_objectsToAssign_Stageset;

export interface MultiPageFormFragment_publishedVersion_pages_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: MultiPageFormFragment_publishedVersion_pages_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: MultiPageFormFragment_publishedVersion_pages_fields_rules_objectsToAssign[];
}

export interface MultiPageFormFragment_publishedVersion_pages_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: MultiPageFormFragment_publishedVersion_pages_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: MultiPageFormFragment_publishedVersion_pages_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: MultiPageFormFragment_publishedVersion_pages_fields_rules[];
}

export interface MultiPageFormFragment_publishedVersion_pages_defaultRule_targetPage {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
}

export interface MultiPageFormFragment_publishedVersion_pages_defaultRule_enumElement {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface MultiPageFormFragment_publishedVersion_pages_defaultRule_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MultiPageFormFragment_publishedVersion_pages_defaultRule {
  __typename: "PageRule";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The action type of the rule
   */
  actionType: PageRuleActionType;
  /**
   * Whether the rule is field based
   */
  isFieldBased: boolean;
  /**
   * The page that the rule is associated with
   */
  targetPage: MultiPageFormFragment_publishedVersion_pages_defaultRule_targetPage | null;
  /**
   * The enum element that the rule is associated with
   */
  enumElement: MultiPageFormFragment_publishedVersion_pages_defaultRule_enumElement | null;
  /**
   * The field that the rule is associated with
   */
  field: MultiPageFormFragment_publishedVersion_pages_defaultRule_field | null;
}

export interface MultiPageFormFragment_publishedVersion_pages_conditionalRules_targetPage {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
}

export interface MultiPageFormFragment_publishedVersion_pages_conditionalRules_enumElement {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface MultiPageFormFragment_publishedVersion_pages_conditionalRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MultiPageFormFragment_publishedVersion_pages_conditionalRules {
  __typename: "PageRule";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The action type of the rule
   */
  actionType: PageRuleActionType;
  /**
   * Whether the rule is field based
   */
  isFieldBased: boolean;
  /**
   * The page that the rule is associated with
   */
  targetPage: MultiPageFormFragment_publishedVersion_pages_conditionalRules_targetPage | null;
  /**
   * The enum element that the rule is associated with
   */
  enumElement: MultiPageFormFragment_publishedVersion_pages_conditionalRules_enumElement | null;
  /**
   * The field that the rule is associated with
   */
  field: MultiPageFormFragment_publishedVersion_pages_conditionalRules_field | null;
}

export interface MultiPageFormFragment_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
  /**
   * Array of fields associated with this web form page
   */
  fields: MultiPageFormFragment_publishedVersion_pages_fields[];
  /**
   * The non-field based page rule associated with this web form page
   */
  defaultRule: MultiPageFormFragment_publishedVersion_pages_defaultRule;
  /**
   * Array of field-based rules associated with this web form page
   */
  conditionalRules: MultiPageFormFragment_publishedVersion_pages_conditionalRules[];
}

export interface MultiPageFormFragment_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: MultiPageFormFragment_publishedVersion_pages[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
}

export interface MultiPageFormFragment_editableVersion_pages_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface MultiPageFormFragment_editableVersion_pages_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface MultiPageFormFragment_editableVersion_pages_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface MultiPageFormFragment_editableVersion_pages_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface MultiPageFormFragment_editableVersion_pages_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface MultiPageFormFragment_editableVersion_pages_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface MultiPageFormFragment_editableVersion_pages_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface MultiPageFormFragment_editableVersion_pages_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type MultiPageFormFragment_editableVersion_pages_fields_rules_objectsToAssign = MultiPageFormFragment_editableVersion_pages_fields_rules_objectsToAssign_Tag | MultiPageFormFragment_editableVersion_pages_fields_rules_objectsToAssign_Audience | MultiPageFormFragment_editableVersion_pages_fields_rules_objectsToAssign_Product | MultiPageFormFragment_editableVersion_pages_fields_rules_objectsToAssign_Source | MultiPageFormFragment_editableVersion_pages_fields_rules_objectsToAssign_Stageset;

export interface MultiPageFormFragment_editableVersion_pages_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: MultiPageFormFragment_editableVersion_pages_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: MultiPageFormFragment_editableVersion_pages_fields_rules_objectsToAssign[];
}

export interface MultiPageFormFragment_editableVersion_pages_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: MultiPageFormFragment_editableVersion_pages_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: MultiPageFormFragment_editableVersion_pages_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: MultiPageFormFragment_editableVersion_pages_fields_rules[];
}

export interface MultiPageFormFragment_editableVersion_pages_defaultRule_targetPage {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
}

export interface MultiPageFormFragment_editableVersion_pages_defaultRule_enumElement {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface MultiPageFormFragment_editableVersion_pages_defaultRule_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MultiPageFormFragment_editableVersion_pages_defaultRule {
  __typename: "PageRule";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The action type of the rule
   */
  actionType: PageRuleActionType;
  /**
   * Whether the rule is field based
   */
  isFieldBased: boolean;
  /**
   * The page that the rule is associated with
   */
  targetPage: MultiPageFormFragment_editableVersion_pages_defaultRule_targetPage | null;
  /**
   * The enum element that the rule is associated with
   */
  enumElement: MultiPageFormFragment_editableVersion_pages_defaultRule_enumElement | null;
  /**
   * The field that the rule is associated with
   */
  field: MultiPageFormFragment_editableVersion_pages_defaultRule_field | null;
}

export interface MultiPageFormFragment_editableVersion_pages_conditionalRules_targetPage {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
}

export interface MultiPageFormFragment_editableVersion_pages_conditionalRules_enumElement {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface MultiPageFormFragment_editableVersion_pages_conditionalRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MultiPageFormFragment_editableVersion_pages_conditionalRules {
  __typename: "PageRule";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The action type of the rule
   */
  actionType: PageRuleActionType;
  /**
   * Whether the rule is field based
   */
  isFieldBased: boolean;
  /**
   * The page that the rule is associated with
   */
  targetPage: MultiPageFormFragment_editableVersion_pages_conditionalRules_targetPage | null;
  /**
   * The enum element that the rule is associated with
   */
  enumElement: MultiPageFormFragment_editableVersion_pages_conditionalRules_enumElement | null;
  /**
   * The field that the rule is associated with
   */
  field: MultiPageFormFragment_editableVersion_pages_conditionalRules_field | null;
}

export interface MultiPageFormFragment_editableVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
  /**
   * Array of fields associated with this web form page
   */
  fields: MultiPageFormFragment_editableVersion_pages_fields[];
  /**
   * The non-field based page rule associated with this web form page
   */
  defaultRule: MultiPageFormFragment_editableVersion_pages_defaultRule;
  /**
   * Array of field-based rules associated with this web form page
   */
  conditionalRules: MultiPageFormFragment_editableVersion_pages_conditionalRules[];
}

export interface MultiPageFormFragment_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of pages associated with this web form version
   */
  pages: MultiPageFormFragment_editableVersion_pages[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * Whether the form should render its multi-page progress indicator.
   */
  shouldShowFormProgress: boolean;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
}

export interface MultiPageFormFragment_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface MultiPageFormFragment_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MultiPageFormFragment_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: MultiPageFormFragment_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: MultiPageFormFragment_nextSteps_slackMessage_form;
}

export interface MultiPageFormFragment_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface MultiPageFormFragment_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type MultiPageFormFragment_nextSteps_nutshellNotification_notifiables = MultiPageFormFragment_nextSteps_nutshellNotification_notifiables_NotifiableAlias | MultiPageFormFragment_nextSteps_nutshellNotification_notifiables_User;

export interface MultiPageFormFragment_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MultiPageFormFragment_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: MultiPageFormFragment_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: MultiPageFormFragment_nextSteps_nutshellNotification_form;
}

export interface MultiPageFormFragment_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: MultiPageFormFragment_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: MultiPageFormFragment_nextSteps_nutshellNotification | null;
}

export interface MultiPageFormFragment {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: MultiPageFormFragment_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: MultiPageFormFragment_publishedVersion | null;
  /**
   * Editor validation for the editable version (page fields and submittable navigation)
   */
  validationErrors: string[];
  /**
   * Whether the form has been embedded
   */
  isLiveForm: boolean;
  /**
   * The published form preview url
   */
  publishedFormPreviewUrl: string;
  /**
   * Publicly viewable link to published form
   */
  sharableViewInBrowserLink: string;
  /**
   * Boolean, true if the editable version has any edits
   */
  hasUnpublishedChanges: boolean;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: MultiPageFormFragment_editableVersion;
  /**
   * The embed snippet for this form
   */
  embedSnippet: string;
  /**
   * The type of form
   */
  type: FormType;
  /**
   * True when this form is referenced anywhere in the chat config (intake,
   * offline, goals, or an action form). Chat-backed forms cannot be converted to
   * multi-page, so the editor should block adding additional pages when this is true.
   */
  isUsedByChat: boolean;
  /**
   * Next step automations for this form
   */
  nextSteps: MultiPageFormFragment_nextSteps;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: NextStepsNutshellNotificationFragment
// ====================================================

export interface NextStepsNutshellNotificationFragment_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface NextStepsNutshellNotificationFragment_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type NextStepsNutshellNotificationFragment_notifiables = NextStepsNutshellNotificationFragment_notifiables_NotifiableAlias | NextStepsNutshellNotificationFragment_notifiables_User;

export interface NextStepsNutshellNotificationFragment_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface NextStepsNutshellNotificationFragment {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: NextStepsNutshellNotificationFragment_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: NextStepsNutshellNotificationFragment_form;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: NextStepsSlackMessageFragment
// ====================================================

export interface NextStepsSlackMessageFragment_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface NextStepsSlackMessageFragment_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface NextStepsSlackMessageFragment {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: NextStepsSlackMessageFragment_slackChannel | null;
  /**
   * The associated form for this slack message.
   */
  form: NextStepsSlackMessageFragment_form;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PageRuleFragment
// ====================================================

export interface PageRuleFragment_targetPage {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of the page
   */
  position: number;
}

export interface PageRuleFragment_enumElement {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface PageRuleFragment_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface PageRuleFragment {
  __typename: "PageRule";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The action type of the rule
   */
  actionType: PageRuleActionType;
  /**
   * Whether the rule is field based
   */
  isFieldBased: boolean;
  /**
   * The page that the rule is associated with
   */
  targetPage: PageRuleFragment_targetPage | null;
  /**
   * The enum element that the rule is associated with
   */
  enumElement: PageRuleFragment_enumElement | null;
  /**
   * The field that the rule is associated with
   */
  field: PageRuleFragment_field | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CreateRulesFragment
// ====================================================

export interface CreateRulesFragment_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateRulesFragment_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface CreateRulesFragment_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: CreateRulesFragment_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: CreateRulesFragment_contact_audiences[];
}

export interface CreateRulesFragment_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateRulesFragment_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: CreateRulesFragment_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface CreateRulesFragment_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface CreateRulesFragment_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface CreateRulesFragment_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface CreateRulesFragment_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface CreateRulesFragment_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface CreateRulesFragment_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: CreateRulesFragment_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: CreateRulesFragment_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: CreateRulesFragment_lead_stagesetFieldRules_stageset;
}

export interface CreateRulesFragment_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: CreateRulesFragment_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: CreateRulesFragment_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: CreateRulesFragment_lead_stagesetFieldRules[];
}

export interface CreateRulesFragment {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a contact
   */
  contact: CreateRulesFragment_contact | null;
  /**
   * The create rules related to a account
   */
  account: CreateRulesFragment_account | null;
  /**
   * The create rules related to a lead
   */
  lead: CreateRulesFragment_lead | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FieldFragment
// ====================================================

export interface FieldFragment_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface FieldFragment_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface FieldFragment_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface FieldFragment_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FieldFragment_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface FieldFragment_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface FieldFragment_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FieldFragment_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type FieldFragment_rules_objectsToAssign = FieldFragment_rules_objectsToAssign_Tag | FieldFragment_rules_objectsToAssign_Audience | FieldFragment_rules_objectsToAssign_Product | FieldFragment_rules_objectsToAssign_Source | FieldFragment_rules_objectsToAssign_Stageset;

export interface FieldFragment_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: FieldFragment_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: FieldFragment_rules_objectsToAssign[];
}

export interface FieldFragment {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: FieldFragment_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: FieldFragment_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: FieldFragment_rules[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FormFragment
// ====================================================

export interface FormFragment_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface FormFragment_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FormFragment_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface FormFragment_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface FormFragment_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface FormFragment_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: FormFragment_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: FormFragment_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: FormFragment_createRules_lead_stagesetFieldRules_stageset;
}

export interface FormFragment_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: FormFragment_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: FormFragment_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: FormFragment_createRules_lead_stagesetFieldRules[];
}

export interface FormFragment_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FormFragment_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface FormFragment_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: FormFragment_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: FormFragment_createRules_contact_audiences[];
}

export interface FormFragment_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FormFragment_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: FormFragment_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface FormFragment_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: FormFragment_createRules_lead | null;
  /**
   * The create rules related to a contact
   */
  contact: FormFragment_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: FormFragment_createRules_account | null;
}

export interface FormFragment_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface FormFragment_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface FormFragment_publishedVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface FormFragment_publishedVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface FormFragment_publishedVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FormFragment_publishedVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface FormFragment_publishedVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface FormFragment_publishedVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FormFragment_publishedVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type FormFragment_publishedVersion_fields_rules_objectsToAssign = FormFragment_publishedVersion_fields_rules_objectsToAssign_Tag | FormFragment_publishedVersion_fields_rules_objectsToAssign_Audience | FormFragment_publishedVersion_fields_rules_objectsToAssign_Product | FormFragment_publishedVersion_fields_rules_objectsToAssign_Source | FormFragment_publishedVersion_fields_rules_objectsToAssign_Stageset;

export interface FormFragment_publishedVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: FormFragment_publishedVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: FormFragment_publishedVersion_fields_rules_objectsToAssign[];
}

export interface FormFragment_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: FormFragment_publishedVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: FormFragment_publishedVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: FormFragment_publishedVersion_fields_rules[];
}

export interface FormFragment_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: FormFragment_publishedVersion_pages[];
  /**
   * Array of fields associated with this web form version
   */
  fields: FormFragment_publishedVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
}

export interface FormFragment_editableVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface FormFragment_editableVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface FormFragment_editableVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface FormFragment_editableVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FormFragment_editableVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface FormFragment_editableVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface FormFragment_editableVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface FormFragment_editableVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type FormFragment_editableVersion_fields_rules_objectsToAssign = FormFragment_editableVersion_fields_rules_objectsToAssign_Tag | FormFragment_editableVersion_fields_rules_objectsToAssign_Audience | FormFragment_editableVersion_fields_rules_objectsToAssign_Product | FormFragment_editableVersion_fields_rules_objectsToAssign_Source | FormFragment_editableVersion_fields_rules_objectsToAssign_Stageset;

export interface FormFragment_editableVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: FormFragment_editableVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: FormFragment_editableVersion_fields_rules_objectsToAssign[];
}

export interface FormFragment_editableVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: FormFragment_editableVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: FormFragment_editableVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: FormFragment_editableVersion_fields_rules[];
}

export interface FormFragment_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of fields associated with this web form version
   */
  fields: FormFragment_editableVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
}

export interface FormFragment_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface FormFragment_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface FormFragment_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: FormFragment_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: FormFragment_nextSteps_slackMessage_form;
}

export interface FormFragment_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface FormFragment_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type FormFragment_nextSteps_nutshellNotification_notifiables = FormFragment_nextSteps_nutshellNotification_notifiables_NotifiableAlias | FormFragment_nextSteps_nutshellNotification_notifiables_User;

export interface FormFragment_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface FormFragment_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: FormFragment_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: FormFragment_nextSteps_nutshellNotification_form;
}

export interface FormFragment_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: FormFragment_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: FormFragment_nextSteps_nutshellNotification | null;
}

export interface FormFragment {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: FormFragment_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: FormFragment_publishedVersion | null;
  /**
   * Whether the form has been embedded
   */
  isLiveForm: boolean;
  /**
   * The published form preview url
   */
  publishedFormPreviewUrl: string;
  /**
   * Publicly viewable link to published form
   */
  sharableViewInBrowserLink: string;
  /**
   * Boolean, true if the editable version has any edits
   */
  hasUnpublishedChanges: boolean;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: FormFragment_editableVersion;
  /**
   * Next step automations for this form
   */
  nextSteps: FormFragment_nextSteps;
  /**
   * The embed snippet for this form
   */
  embedSnippet: string;
  /**
   * The type of form
   */
  type: FormType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FormStubFragment
// ====================================================

export interface FormStubFragment_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface FormStubFragment_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: FormStubFragment_createRules_lead_stageset | null;
}

export interface FormStubFragment_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: FormStubFragment_createRules_lead | null;
}

export interface FormStubFragment_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface FormStubFragment_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: FormStubFragment_publishedVersion_pages[];
}

export interface FormStubFragment {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: FormStubFragment_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: FormStubFragment_publishedVersion | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: NextStepsFragment
// ====================================================

export interface NextStepsFragment_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface NextStepsFragment_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface NextStepsFragment_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: NextStepsFragment_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: NextStepsFragment_slackMessage_form;
}

export interface NextStepsFragment_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface NextStepsFragment_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type NextStepsFragment_nutshellNotification_notifiables = NextStepsFragment_nutshellNotification_notifiables_NotifiableAlias | NextStepsFragment_nutshellNotification_notifiables_User;

export interface NextStepsFragment_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface NextStepsFragment_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: NextStepsFragment_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: NextStepsFragment_nutshellNotification_form;
}

export interface NextStepsFragment {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: NextStepsFragment_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: NextStepsFragment_nutshellNotification | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AiSuggestionFragment
// ====================================================

export interface AiSuggestionFragment {
  __typename: "AiSuggestion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The content of the AI suggestion
   */
  content: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppearanceFragment
// ====================================================

export interface AppearanceFragment_lookAndFeel_nudgeSettings {
  __typename: "ChatSettingsNudge";
  /**
   * Is the nudge behavior enabled
   */
  isEnabled: boolean;
  /**
   * The nudge overlay text
   */
  message: string;
  /**
   * The call to action text
   */
  callToAction: string;
  /**
   * When to show nudges (desktop only or always)
   */
  deviceVisibility: NudgeDeviceVisibilityEnum;
}

export interface AppearanceFragment_lookAndFeel_icon {
  __typename: "ChatIcon";
  /**
   * Icon type
   */
  type: ChatIconEnum;
  /**
   * Icon URL
   */
  url: string | null;
}

export interface AppearanceFragment_lookAndFeel_disclaimerSettings {
  __typename: "ChatSettingsDisclaimer";
  /**
   * Is the disclaimer enabled
   */
  isEnabled: boolean;
  /**
   * The disclaimer message
   */
  message: string;
}

export interface AppearanceFragment_lookAndFeel {
  __typename: "LookAndFeel";
  /**
   * The primary color of the chat window
   */
  color: string;
  /**
   * The secondary color for chat
   */
  secondaryColor: string;
  /**
   * The chat variant (chat button only or actions bar)
   */
  chatVariant: ChatVariantEnum;
  /**
   * The position of the chat window
   */
  nameDisplay: string;
  /**
   * The name of the chatbot
   */
  chatbotName: string;
  /**
   * The icon type for the chatbot
   */
  chatbotIconEnum: ChatbotIconEnum;
  /**
   * The nudge settings
   */
  nudgeSettings: AppearanceFragment_lookAndFeel_nudgeSettings;
  /**
   * The chat icon settings
   */
  icon: AppearanceFragment_lookAndFeel_icon;
  /**
   * The intro message a visitor sees when they open the chat
   */
  conversationStarter: string;
  /**
   * Whether to show the powered by Nutshell logo
   */
  showPoweredBy: boolean;
  /**
   * The disclaimer settings
   */
  disclaimerSettings: AppearanceFragment_lookAndFeel_disclaimerSettings;
  /**
   * The actions that are shown in the engagement bar
   */
  actionBarShownActions: ActionBarActionEnum[];
  /**
   * The actions that are hidden in the engagement bar
   */
  actionBarHiddenActions: ActionBarActionEnum[];
  /**
   * The paths that are disabled for the chat widget
   */
  disabledPaths: string[];
}

export interface AppearanceFragment_appMode_homepageSettings_actionLabels {
  __typename: "ChatSettingsHomepageActionLabels";
  /**
   * The label for the book action
   */
  book: string;
  /**
   * The label for the email action
   */
  email: string;
  /**
   * The label for the call action
   */
  call: string;
  /**
   * The label for the text action
   */
  text: string;
  /**
   * The label for the quote action
   */
  quote: string;
}

export interface AppearanceFragment_appMode_homepageSettings {
  __typename: "ChatSettingsHomepage";
  /**
   * Whether the homepage is enabled
   */
  isEnabled: boolean;
  /**
   * The layout of the homepage
   */
  layout: ChatHomepageLayoutEnum;
  /**
   * Per-action labels displayed on the homepage
   */
  actionLabels: AppearanceFragment_appMode_homepageSettings_actionLabels;
}

export interface AppearanceFragment_appMode_businessCardSettings {
  __typename: "ChatSettingsBusinessCard";
  /**
   * Whether the business card is enabled
   */
  isEnabled: boolean;
  /**
   * The logo URL
   */
  logoUrl: string | null;
  /**
   * The company name
   */
  companyName: string | null;
  /**
   * The email
   */
  email: string | null;
  /**
   * The phone number
   */
  phoneNumber: string | null;
  /**
   * The address
   */
  address: string | null;
  /**
   * The business hours description
   */
  businessHours: string | null;
}

export interface AppearanceFragment_appMode {
  __typename: "AppMode";
  /**
   * The homepage settings
   */
  homepageSettings: AppearanceFragment_appMode_homepageSettings;
  /**
   * The business card settings
   */
  businessCardSettings: AppearanceFragment_appMode_businessCardSettings;
  /**
   * The auto open view
   */
  autoOpenView: ChatAutoOpenEnum | null;
}

export interface AppearanceFragment_intakeForm {
  __typename: "ChatSettingsIntakeForm";
  fields: ChatSettingsIntakeFormFieldsEnum[];
  type: ChatSettingsIntakeFormTypeEnum;
  /**
   * Allow chat threads to proceed without requiring a contact to be created
   */
  allowThreadsWithoutContact: boolean;
}

export interface AppearanceFragment {
  __typename: "ChatSettings";
  /**
   * The chat look and feel settings
   */
  lookAndFeel: AppearanceFragment_lookAndFeel;
  /**
   * The app mode settings
   */
  appMode: AppearanceFragment_appMode;
  /**
   * The chat intake form settings
   */
  intakeForm: AppearanceFragment_intakeForm;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BehaviorFragment
// ====================================================

export interface BehaviorFragment_chatbot_customAnswers {
  __typename: "CustomAnswer";
  question: string;
  answer: string;
  isEnabled: boolean;
}

export interface BehaviorFragment_chatbot {
  __typename: "Chatbot";
  /**
   * When the chatbot should respond to messages
   */
  responseTiming: ChatbotResponseTimingEnum;
  /**
   * The name of the chatbot
   */
  name: string;
  /**
   * The icon type for the chatbot
   */
  iconEnum: ChatbotIconEnum;
  /**
   * The tone of the chatbot responses
   */
  tone: ChatbotToneEnum;
  /**
   * The preferred length of chatbot responses
   */
  answerLength: ChatbotAnswerLengthEnum;
  /**
   * Style and behavior suggestions for the chatbot
   */
  suggestions: (string | null)[];
  /**
   * Topics the chatbot should avoid discussing
   */
  topicsToAvoid: (string | null)[];
  customAnswers: BehaviorFragment_chatbot_customAnswers[];
}

export interface BehaviorFragment_offline_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
}

export interface BehaviorFragment_offline {
  __typename: "ChatSettingsOffline";
  /**
   * Offline form capture enabled
   */
  isEnabled: boolean;
  /**
   * The offline custom form
   */
  form: BehaviorFragment_offline_form;
  formType: ChatSettingsOfflineFormTypeEnum;
  /**
   * The message to show if there are no agents online
   */
  message: string;
  /**
   * The message to show if there are no agents online for conversational forms
   */
  conversationalMessage: string;
}

export interface BehaviorFragment_assignment_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface BehaviorFragment_assignment {
  __typename: "ChatSettingsAssignment";
  /**
   * The assignment strategy for new chats
   */
  strategy: ChatAssignmentStrategyEnum;
  /**
   * The user to assign new chats to (only applicable if assignmentStrategy is SPECIFIC_USER)
   */
  user: BehaviorFragment_assignment_user | null;
}

export interface BehaviorFragment_lookAndFeel_nudgeSettings {
  __typename: "ChatSettingsNudge";
  /**
   * Is the nudge behavior enabled
   */
  isEnabled: boolean;
  /**
   * The nudge overlay text
   */
  message: string;
}

export interface BehaviorFragment_lookAndFeel_icon {
  __typename: "ChatIcon";
  /**
   * Icon type
   */
  type: ChatIconEnum;
  /**
   * Icon URL
   */
  url: string | null;
}

export interface BehaviorFragment_lookAndFeel_disclaimerSettings {
  __typename: "ChatSettingsDisclaimer";
  /**
   * Is the disclaimer enabled
   */
  isEnabled: boolean;
  /**
   * The disclaimer message
   */
  message: string;
}

export interface BehaviorFragment_lookAndFeel {
  __typename: "LookAndFeel";
  /**
   * The primary color of the chat window
   */
  color: string;
  /**
   * The position of the chat window
   */
  nameDisplay: string;
  /**
   * The nudge settings
   */
  nudgeSettings: BehaviorFragment_lookAndFeel_nudgeSettings;
  /**
   * The chat icon settings
   */
  icon: BehaviorFragment_lookAndFeel_icon;
  /**
   * The intro message a visitor sees when they open the chat
   */
  conversationStarter: string;
  /**
   * Whether to show the powered by Nutshell logo
   */
  showPoweredBy: boolean;
  /**
   * The disclaimer settings
   */
  disclaimerSettings: BehaviorFragment_lookAndFeel_disclaimerSettings;
}

export interface BehaviorFragment {
  __typename: "ChatSettings";
  /**
   * The chatbot settings
   */
  chatbot: BehaviorFragment_chatbot;
  /**
   * The chat offline settings
   */
  offline: BehaviorFragment_offline;
  /**
   * The chat assignment settings
   */
  assignment: BehaviorFragment_assignment;
  /**
   * The chat look and feel settings
   */
  lookAndFeel: BehaviorFragment_lookAndFeel;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CallTrackerNumbersFragment
// ====================================================

export interface CallTrackerNumbersFragment {
  __typename: "CallTrackerNumber";
  id: string;
  label: string;
  match: string;
  forwardTo: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ChatActionsFragment
// ====================================================

export interface ChatActionsFragment_chat {
  __typename: "ChatAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * Whether to automatically create leads from chat conversations
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
}

export interface ChatActionsFragment_booking {
  __typename: "BookingAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The meeting ID to use for booking
   */
  meetingId: string | null;
  /**
   * The confirmation message after booking a meeting
   */
  formConfirmationMessage: string;
  /**
   * Whether to automatically create leads from booking requests
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
}

export interface ChatActionsFragment_email {
  __typename: "EmailAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The slug for the form to display for email action
   */
  formSlug: string | null;
  /**
   * The slug for the default form that was auto-created for this action
   */
  defaultFormSlug: string | null;
  /**
   * The confirmation message after submitting a form
   */
  formConfirmationMessage: string;
  /**
   * Whether to automatically create leads from email requests
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * Whether to link an email address
   */
  shouldLinkEmailAddress: boolean;
  /**
   * The email address to link
   */
  linkEmailAddress: string | null;
}

export interface ChatActionsFragment_call_linkNumberConfig {
  __typename: "LinkNumberConfig";
  /**
   * The type of phone number that is linked (custom or call tracker fx)
   */
  type: LinkNumberTypeEnum;
  /**
   * The custom phone number to link
   */
  customNumber: string | null;
  /**
   * The phone number to link
   */
  callTrackerNumber: string | null;
  /**
   * The call tracker id
   */
  callTrackerId: string | null;
}

export interface ChatActionsFragment_call {
  __typename: "CallAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The slug for the form to display for call action
   */
  formSlug: string | null;
  /**
   * The slug for the default form that was auto-created for this action
   */
  defaultFormSlug: string | null;
  /**
   * The confirmation message after submitting a form
   */
  formConfirmationMessage: string;
  /**
   * Whether to automatically create leads from call requests
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * Whether to link a phone number
   */
  shouldLinkNumber: boolean;
  /**
   * The configuration for the linked phone number
   */
  linkNumberConfig: ChatActionsFragment_call_linkNumberConfig;
}

export interface ChatActionsFragment_text {
  __typename: "TextAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The slug for the form to display for text action
   */
  formSlug: string | null;
  /**
   * The slug for the default form that was auto-created for this action
   */
  defaultFormSlug: string | null;
  /**
   * The confirmation message after submitting a form
   */
  formConfirmationMessage: string;
  /**
   * Whether to automatically create leads from text requests
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * Whether to link a phone number
   */
  shouldLinkNumber: boolean;
  /**
   * The phone number to link
   */
  linkNumber: string | null;
}

export interface ChatActionsFragment_quote {
  __typename: "QuoteAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * Whether to automatically create leads after submitting a quote form
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The slug for the form to display for quote action
   */
  formSlug: string | null;
  /**
   * The slug for the default form that was auto-created for this action
   */
  defaultFormSlug: string | null;
  /**
   * The confirmation message after submitting a form
   */
  formConfirmationMessage: string;
}

export interface ChatActionsFragment {
  __typename: "Actions";
  /**
   * Chat action configuration
   */
  chat: ChatActionsFragment_chat;
  /**
   * Booking action configuration
   */
  booking: ChatActionsFragment_booking;
  /**
   * Email action configuration
   */
  email: ChatActionsFragment_email;
  /**
   * Call action configuration
   */
  call: ChatActionsFragment_call;
  /**
   * Text action configuration
   */
  text: ChatActionsFragment_text;
  /**
   * Quote action configuration
   */
  quote: ChatActionsFragment_quote;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ChatAgent
// ====================================================

export interface ChatAgent {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  agentStatus: AgentStatusEnum;
  /**
   * The number of active chats the agent is currently assigned
   */
  numActiveChats: number;
  /**
   * The number of chats that need a reply from the agent
   */
  numNeedsReplyChats: number;
  name: string;
  agentPresence: AgentPresenceEnum;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ChatSettingsEngagementBarFragment
// ====================================================

export interface ChatSettingsEngagementBarFragment_lookAndFeel_nudgeSettings {
  __typename: "ChatSettingsNudge";
  /**
   * Is the nudge behavior enabled
   */
  isEnabled: boolean;
  /**
   * The nudge overlay text
   */
  message: string;
  /**
   * When to show nudges (desktop only or always)
   */
  deviceVisibility: NudgeDeviceVisibilityEnum;
  /**
   * The call to action text
   */
  callToAction: string;
}

export interface ChatSettingsEngagementBarFragment_lookAndFeel_icon {
  __typename: "ChatIcon";
  /**
   * Icon type
   */
  type: ChatIconEnum;
  /**
   * Icon URL
   */
  url: string | null;
}

export interface ChatSettingsEngagementBarFragment_lookAndFeel_disclaimerSettings {
  __typename: "ChatSettingsDisclaimer";
  /**
   * Is the disclaimer enabled
   */
  isEnabled: boolean;
  /**
   * The disclaimer message
   */
  message: string;
}

export interface ChatSettingsEngagementBarFragment_lookAndFeel {
  __typename: "LookAndFeel";
  /**
   * The primary color of the chat window
   */
  color: string;
  /**
   * The secondary color for chat
   */
  secondaryColor: string;
  /**
   * The position of the chat window
   */
  nameDisplay: string;
  /**
   * The chat variant (chat button only or actions bar)
   */
  chatVariant: ChatVariantEnum;
  /**
   * The actions that are shown in the engagement bar
   */
  actionBarShownActions: ActionBarActionEnum[];
  /**
   * The nudge settings
   */
  nudgeSettings: ChatSettingsEngagementBarFragment_lookAndFeel_nudgeSettings;
  /**
   * The chat icon settings
   */
  icon: ChatSettingsEngagementBarFragment_lookAndFeel_icon;
  /**
   * The intro message a visitor sees when they open the chat
   */
  conversationStarter: string;
  /**
   * Whether to show the powered by Nutshell logo
   */
  showPoweredBy: boolean;
  /**
   * The disclaimer settings
   */
  disclaimerSettings: ChatSettingsEngagementBarFragment_lookAndFeel_disclaimerSettings;
}

export interface ChatSettingsEngagementBarFragment_intakeForm {
  __typename: "ChatSettingsIntakeForm";
  fields: ChatSettingsIntakeFormFieldsEnum[];
  type: ChatSettingsIntakeFormTypeEnum;
  /**
   * Allow chat threads to proceed without requiring a contact to be created
   */
  allowThreadsWithoutContact: boolean;
}

export interface ChatSettingsEngagementBarFragment_actions_chat {
  __typename: "ChatAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * Whether to automatically create leads from chat conversations
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
}

export interface ChatSettingsEngagementBarFragment_actions_booking {
  __typename: "BookingAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The meeting ID to use for booking
   */
  meetingId: string | null;
  /**
   * The confirmation message after booking a meeting
   */
  formConfirmationMessage: string;
  /**
   * Whether to automatically create leads from booking requests
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
}

export interface ChatSettingsEngagementBarFragment_actions_email {
  __typename: "EmailAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The slug for the form to display for email action
   */
  formSlug: string | null;
  /**
   * The slug for the default form that was auto-created for this action
   */
  defaultFormSlug: string | null;
  /**
   * The confirmation message after submitting a form
   */
  formConfirmationMessage: string;
  /**
   * Whether to automatically create leads from email requests
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * Whether to link an email address
   */
  shouldLinkEmailAddress: boolean;
  /**
   * The email address to link
   */
  linkEmailAddress: string | null;
}

export interface ChatSettingsEngagementBarFragment_actions_call_linkNumberConfig {
  __typename: "LinkNumberConfig";
  /**
   * The type of phone number that is linked (custom or call tracker fx)
   */
  type: LinkNumberTypeEnum;
  /**
   * The custom phone number to link
   */
  customNumber: string | null;
  /**
   * The phone number to link
   */
  callTrackerNumber: string | null;
  /**
   * The call tracker id
   */
  callTrackerId: string | null;
}

export interface ChatSettingsEngagementBarFragment_actions_call {
  __typename: "CallAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The slug for the form to display for call action
   */
  formSlug: string | null;
  /**
   * The slug for the default form that was auto-created for this action
   */
  defaultFormSlug: string | null;
  /**
   * The confirmation message after submitting a form
   */
  formConfirmationMessage: string;
  /**
   * Whether to automatically create leads from call requests
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * Whether to link a phone number
   */
  shouldLinkNumber: boolean;
  /**
   * The configuration for the linked phone number
   */
  linkNumberConfig: ChatSettingsEngagementBarFragment_actions_call_linkNumberConfig;
}

export interface ChatSettingsEngagementBarFragment_actions_text {
  __typename: "TextAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The slug for the form to display for text action
   */
  formSlug: string | null;
  /**
   * The slug for the default form that was auto-created for this action
   */
  defaultFormSlug: string | null;
  /**
   * The confirmation message after submitting a form
   */
  formConfirmationMessage: string;
  /**
   * Whether to automatically create leads from text requests
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * Whether to link a phone number
   */
  shouldLinkNumber: boolean;
  /**
   * The phone number to link
   */
  linkNumber: string | null;
}

export interface ChatSettingsEngagementBarFragment_actions_quote {
  __typename: "QuoteAction";
  /**
   * Whether the action is configured
   */
  isConfigured: boolean;
  /**
   * The label for the action button
   */
  label: string | null;
  /**
   * Whether to automatically create leads after submitting a quote form
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID for automatically created leads
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * The opening message shown when the action is selected. Note: Not used by ChatAction (always null).
   */
  openingMessage: string | null;
  /**
   * The slug for the form to display for quote action
   */
  formSlug: string | null;
  /**
   * The slug for the default form that was auto-created for this action
   */
  defaultFormSlug: string | null;
  /**
   * The confirmation message after submitting a form
   */
  formConfirmationMessage: string;
}

export interface ChatSettingsEngagementBarFragment_actions {
  __typename: "Actions";
  /**
   * Chat action configuration
   */
  chat: ChatSettingsEngagementBarFragment_actions_chat;
  /**
   * Booking action configuration
   */
  booking: ChatSettingsEngagementBarFragment_actions_booking;
  /**
   * Email action configuration
   */
  email: ChatSettingsEngagementBarFragment_actions_email;
  /**
   * Call action configuration
   */
  call: ChatSettingsEngagementBarFragment_actions_call;
  /**
   * Text action configuration
   */
  text: ChatSettingsEngagementBarFragment_actions_text;
  /**
   * Quote action configuration
   */
  quote: ChatSettingsEngagementBarFragment_actions_quote;
}

export interface ChatSettingsEngagementBarFragment_appMode_homepageSettings_actionLabels {
  __typename: "ChatSettingsHomepageActionLabels";
  /**
   * The label for the book action
   */
  book: string;
  /**
   * The label for the email action
   */
  email: string;
  /**
   * The label for the call action
   */
  call: string;
  /**
   * The label for the text action
   */
  text: string;
  /**
   * The label for the quote action
   */
  quote: string;
}

export interface ChatSettingsEngagementBarFragment_appMode_homepageSettings {
  __typename: "ChatSettingsHomepage";
  /**
   * Whether the homepage is enabled
   */
  isEnabled: boolean;
  /**
   * The layout of the homepage
   */
  layout: ChatHomepageLayoutEnum;
  /**
   * Per-action labels displayed on the homepage
   */
  actionLabels: ChatSettingsEngagementBarFragment_appMode_homepageSettings_actionLabels;
}

export interface ChatSettingsEngagementBarFragment_appMode_businessCardSettings {
  __typename: "ChatSettingsBusinessCard";
  /**
   * Whether the business card is enabled
   */
  isEnabled: boolean;
  /**
   * The logo URL
   */
  logoUrl: string | null;
  /**
   * The company name
   */
  companyName: string | null;
  /**
   * The email
   */
  email: string | null;
  /**
   * The phone number
   */
  phoneNumber: string | null;
  /**
   * The address
   */
  address: string | null;
  /**
   * The business hours description
   */
  businessHours: string | null;
}

export interface ChatSettingsEngagementBarFragment_appMode {
  __typename: "AppMode";
  /**
   * The homepage settings
   */
  homepageSettings: ChatSettingsEngagementBarFragment_appMode_homepageSettings;
  /**
   * The business card settings
   */
  businessCardSettings: ChatSettingsEngagementBarFragment_appMode_businessCardSettings;
}

export interface ChatSettingsEngagementBarFragment {
  __typename: "ChatSettings";
  /**
   * The chat look and feel settings
   */
  lookAndFeel: ChatSettingsEngagementBarFragment_lookAndFeel;
  /**
   * The chat intake form settings
   */
  intakeForm: ChatSettingsEngagementBarFragment_intakeForm;
  /**
   * The actions settings
   */
  actions: ChatSettingsEngagementBarFragment_actions;
  /**
   * The app mode settings
   */
  appMode: ChatSettingsEngagementBarFragment_appMode;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ChatSettingsFragment
// ====================================================

export interface ChatSettingsFragment_intakeForm {
  __typename: "ChatSettingsIntakeForm";
  fields: ChatSettingsIntakeFormFieldsEnum[];
  message: string;
  type: ChatSettingsIntakeFormTypeEnum;
  /**
   * Whether to create a lead if no other rules trigger a lead creation
   */
  shouldCreateLeads: boolean;
  /**
   * The pipeline ID to create the lead in
   */
  shouldCreateLeadsPipelineId: string | null;
  /**
   * Allow chat threads to proceed without requiring a contact to be created
   */
  allowThreadsWithoutContact: boolean;
}

export interface ChatSettingsFragment_lookAndFeel_nudgeSettings {
  __typename: "ChatSettingsNudge";
  /**
   * Is the nudge behavior enabled
   */
  isEnabled: boolean;
  /**
   * The nudge overlay text
   */
  message: string;
  /**
   * The call to action text
   */
  callToAction: string;
  /**
   * When to show nudges (desktop only or always)
   */
  deviceVisibility: NudgeDeviceVisibilityEnum;
}

export interface ChatSettingsFragment_lookAndFeel_icon {
  __typename: "ChatIcon";
  /**
   * Icon type
   */
  type: ChatIconEnum;
  /**
   * Icon URL
   */
  url: string | null;
}

export interface ChatSettingsFragment_lookAndFeel_disclaimerSettings {
  __typename: "ChatSettingsDisclaimer";
  /**
   * Is the disclaimer enabled
   */
  isEnabled: boolean;
  /**
   * The disclaimer message
   */
  message: string;
}

export interface ChatSettingsFragment_lookAndFeel {
  __typename: "LookAndFeel";
  /**
   * The primary color of the chat window
   */
  color: string;
  /**
   * The secondary color for chat
   */
  secondaryColor: string;
  /**
   * The position of the chat window
   */
  nameDisplay: string;
  /**
   * The nudge settings
   */
  nudgeSettings: ChatSettingsFragment_lookAndFeel_nudgeSettings;
  /**
   * The chat icon settings
   */
  icon: ChatSettingsFragment_lookAndFeel_icon;
  /**
   * The intro message a visitor sees when they open the chat
   */
  conversationStarter: string;
  /**
   * Whether to show the powered by Nutshell logo
   */
  showPoweredBy: boolean;
  /**
   * The disclaimer settings
   */
  disclaimerSettings: ChatSettingsFragment_lookAndFeel_disclaimerSettings;
  /**
   * The actions that are shown in the engagement bar
   */
  actionBarShownActions: ActionBarActionEnum[];
  /**
   * The actions that are hidden in the engagement bar
   */
  actionBarHiddenActions: ActionBarActionEnum[];
  /**
   * The chat variant (chat button only or actions bar)
   */
  chatVariant: ChatVariantEnum;
  /**
   * The name of the chatbot
   */
  chatbotName: string;
  /**
   * The icon type for the chatbot
   */
  chatbotIconEnum: ChatbotIconEnum;
  /**
   * The paths that are disabled for the chat widget
   */
  disabledPaths: string[];
}

export interface ChatSettingsFragment_offline_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
}

export interface ChatSettingsFragment_offline {
  __typename: "ChatSettingsOffline";
  /**
   * Offline form capture enabled
   */
  isEnabled: boolean;
  /**
   * The offline custom form
   */
  form: ChatSettingsFragment_offline_form;
  formType: ChatSettingsOfflineFormTypeEnum;
  /**
   * The message to show if there are no agents online
   */
  message: string;
  /**
   * The message to show if there are no agents online for conversational forms
   */
  conversationalMessage: string;
}

export interface ChatSettingsFragment_assignment_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ChatSettingsFragment_assignment {
  __typename: "ChatSettingsAssignment";
  /**
   * The assignment strategy for new chats
   */
  strategy: ChatAssignmentStrategyEnum;
  /**
   * The user to assign new chats to (only applicable if assignmentStrategy is SPECIFIC_USER)
   */
  user: ChatSettingsFragment_assignment_user | null;
}

export interface ChatSettingsFragment_chatbot {
  __typename: "Chatbot";
  /**
   * When the chatbot should respond to messages
   */
  responseTiming: ChatbotResponseTimingEnum;
  /**
   * The name of the chatbot
   */
  name: string;
  /**
   * The icon type for the chatbot
   */
  iconEnum: ChatbotIconEnum;
  /**
   * The tone of the chatbot responses
   */
  tone: ChatbotToneEnum;
  /**
   * The preferred length of chatbot responses
   */
  answerLength: ChatbotAnswerLengthEnum;
  /**
   * Style and behavior suggestions for the chatbot
   */
  suggestions: (string | null)[];
  /**
   * Topics the chatbot should avoid discussing
   */
  topicsToAvoid: (string | null)[];
}

export interface ChatSettingsFragment_goals {
  __typename: "Goals";
  /**
   * Whether the scheduler goal is enabled
   */
  schedulerIsEnabled: boolean;
  /**
   * The scheduler meeting ID to show in the chat
   */
  schedulerMeetingId: string | null;
  /**
   * Whether the form goal is enabled
   */
  formIsEnabled: boolean;
  /**
   * The form slug to show in the chat
   */
  formSlug: string | null;
}

export interface ChatSettingsFragment {
  __typename: "ChatSettings";
  /**
   * Is the chat widget enabled
   */
  isChatEnabled: boolean;
  /**
   * The chat intake form settings
   */
  intakeForm: ChatSettingsFragment_intakeForm;
  /**
   * The chat look and feel settings
   */
  lookAndFeel: ChatSettingsFragment_lookAndFeel;
  /**
   * The chat offline settings
   */
  offline: ChatSettingsFragment_offline;
  /**
   * The chat assignment settings
   */
  assignment: ChatSettingsFragment_assignment;
  /**
   * The embeddable script to add chat on a website
   */
  embedScript: string;
  /**
   * The chatbot settings
   */
  chatbot: ChatSettingsFragment_chatbot;
  /**
   * The goals settings
   */
  goals: ChatSettingsFragment_goals;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ChatSettingsKnowledgeFragment
// ====================================================

export interface ChatSettingsKnowledgeFragment_lookAndFeel_nudgeSettings {
  __typename: "ChatSettingsNudge";
  /**
   * Is the nudge behavior enabled
   */
  isEnabled: boolean;
  /**
   * The nudge overlay text
   */
  message: string;
}

export interface ChatSettingsKnowledgeFragment_lookAndFeel {
  __typename: "LookAndFeel";
  /**
   * The nudge settings
   */
  nudgeSettings: ChatSettingsKnowledgeFragment_lookAndFeel_nudgeSettings;
  /**
   * The secondary color for chat
   */
  secondaryColor: string;
}

export interface ChatSettingsKnowledgeFragment_chatbot_customAnswers {
  __typename: "CustomAnswer";
  question: string;
  answer: string;
  isEnabled: boolean;
}

export interface ChatSettingsKnowledgeFragment_chatbot {
  __typename: "Chatbot";
  customAnswers: ChatSettingsKnowledgeFragment_chatbot_customAnswers[];
}

export interface ChatSettingsKnowledgeFragment {
  __typename: "ChatSettings";
  /**
   * The chat look and feel settings
   */
  lookAndFeel: ChatSettingsKnowledgeFragment_lookAndFeel;
  /**
   * The chatbot settings
   */
  chatbot: ChatSettingsKnowledgeFragment_chatbot;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContextDocumentFragment
// ====================================================

export interface ContextDocumentFragment_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
}

export interface ContextDocumentFragment_aiSuggestions {
  __typename: "AiSuggestion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The content of the AI suggestion
   */
  content: string;
}

export interface ContextDocumentFragment {
  __typename: "ContextDocument";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the context document, for example, the name of the uploaded file
   */
  name: string | null;
  /**
   * The URL of the context document
   */
  url: ContextDocumentFragment_url | null;
  /**
   * The content of the context document
   */
  content: string | null;
  /**
   * The summary of the context document
   */
  summary: string | null;
  /**
   * Whether the context document is included
   */
  isIncluded: boolean;
  isHidden: boolean;
  /**
   * The effective status of the context document
   */
  effectiveStatus: DocumentEffectiveStatusEnum;
  /**
   * The number of words in the context document
   */
  wordCount: number;
  /**
   * Whether the context document is a subpage
   */
  isSubpage: boolean;
  /**
   * The source type of the context document
   */
  sourceType: DocumentSourceTypeEnum;
  /**
   * The time the context document was last crawled
   */
  lastCrawledTime: any;
  /**
   * The AI suggestions for the context document
   */
  aiSuggestions: ContextDocumentFragment_aiSuggestions[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: HomepageActionLabelsFragment
// ====================================================

export interface HomepageActionLabelsFragment {
  __typename: "ChatSettingsHomepageActionLabels";
  /**
   * The label for the book action
   */
  book: string;
  /**
   * The label for the email action
   */
  email: string;
  /**
   * The label for the call action
   */
  call: string;
  /**
   * The label for the text action
   */
  text: string;
  /**
   * The label for the quote action
   */
  quote: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PreviewChatbotResponseFragment
// ====================================================

export interface PreviewChatbotResponseFragment_citations {
  __typename: "PreviewChatbotCitation";
  documentId: string;
  url: string;
  title: string;
  sourceType: DocumentSourceTypeEnum;
}

export interface PreviewChatbotResponseFragment {
  __typename: "PreviewChatbotResponsePayload";
  answer: string;
  citations: PreviewChatbotResponseFragment_citations[];
  promptTokens: number;
  completionTokens: number;
  /**
   * True when the returned answer text matches an enabled custom answer verbatim.
   */
  usedCustomAnswer: boolean;
  /**
   * The custom answer question that matched, when usedCustomAnswer is true.
   */
  matchedCustomAnswerQuestion: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SchedulerMeetingChatFragment
// ====================================================

export interface SchedulerMeetingChatFragment_primaryHost {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SchedulerMeetingChatFragment_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface SchedulerMeetingChatFragment_validity {
  __typename: "MeetingValidity";
  /**
   * Whether this meeting can be booked
   */
  isBookable: boolean;
}

export interface SchedulerMeetingChatFragment {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number;
  /**
   * The primary host for this meeting
   */
  primaryHost: SchedulerMeetingChatFragment_primaryHost | null;
  /**
   * The activity type for this meeting
   */
  activityType: SchedulerMeetingChatFragment_activityType;
  /**
   * The timestamp this web form was last submitted
   */
  lastBookedTime: any | null;
  /**
   * The validity of this meeting
   */
  validity: SchedulerMeetingChatFragment_validity;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: WfFormChatFragment
// ====================================================

export interface WfFormChatFragment {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InboundEmailRulesFragment
// ====================================================

export interface InboundEmailRulesFragment_assignment_assignedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface InboundEmailRulesFragment_assignment {
  __typename: "InboundRulesAssignment";
  strategy: ChatAssignmentStrategyEnum;
  /**
   * The user to assign inbound SMS thread to.
   */
  assignedUser: InboundEmailRulesFragment_assignment_assignedUser | null;
}

export interface InboundEmailRulesFragment_leadCreation_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface InboundEmailRulesFragment_leadCreation_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface InboundEmailRulesFragment_leadCreation {
  __typename: "InboundRulesLeadCreation";
  /**
   * Whether lead creation is enabled.
   */
  enabled: boolean;
  /**
   * The stageset to use for lead creation.
   */
  stageset: InboundEmailRulesFragment_leadCreation_stageset | null;
  /**
   * The tags to apply to the lead.
   */
  tags: InboundEmailRulesFragment_leadCreation_tags[] | null;
}

export interface InboundEmailRulesFragment_contactCreation_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface InboundEmailRulesFragment_contactCreation_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface InboundEmailRulesFragment_contactCreation {
  __typename: "InboundEmailRulesContactCreation";
  enabled: boolean;
  tags: InboundEmailRulesFragment_contactCreation_tags[];
  audiences: InboundEmailRulesFragment_contactCreation_audiences[];
}

export interface InboundEmailRulesFragment_spamFilter {
  __typename: "InboundEmailRulesSpamFilter";
  /**
   * Whether spam filtering is enabled.
   */
  isEnabled: boolean;
  /**
   * Sender addresses or wildcard patterns (e.g. *@trusted.com) that bypass the spam check.
   */
  senderAllowlist: string[];
  /**
   * Sender addresses or wildcard patterns that are always classified as spam.
   */
  senderDenylist: string[];
  /**
   * Number of inbound email threads classified as spam in the last 30 days.
   */
  spamFilteredCount: number;
}

export interface InboundEmailRulesFragment {
  __typename: "InboundEmailRules";
  /**
   * The assignment rule for inbound Email.
   */
  assignment: InboundEmailRulesFragment_assignment;
  /**
   * The lead creation rule for inbound Email.
   */
  leadCreation: InboundEmailRulesFragment_leadCreation;
  contactCreation: InboundEmailRulesFragment_contactCreation;
  /**
   * The spam filter rule for inbound Email.
   */
  spamFilter: InboundEmailRulesFragment_spamFilter;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SharedInboxAddressFragment
// ====================================================

export interface SharedInboxAddressFragment_nutshellAddress_email {
  __typename: "NutEmailAddress";
  address: string;
}

export interface SharedInboxAddressFragment_nutshellAddress {
  __typename: "SharedInboxInboundAddress";
  email: SharedInboxAddressFragment_nutshellAddress_email;
}

export interface SharedInboxAddressFragment_sharedAddresses_emailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface SharedInboxAddressFragment_sharedAddresses_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface SharedInboxAddressFragment_sharedAddresses {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: SharedInboxAddressFragment_sharedAddresses_emailAddress;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: SharedInboxAddressFragment_sharedAddresses_fromDomain | null;
  /**
   * The DateTime when email forwarding was last verified for this shared inbox address.
   */
  forwardingVerifiedTime: any | null;
}

export interface SharedInboxAddressFragment {
  __typename: "SharedEmailInboxConfig";
  nutshellAddress: SharedInboxAddressFragment_nutshellAddress;
  sharedAddresses: SharedInboxAddressFragment_sharedAddresses[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InboundFacebookRulesFragment
// ====================================================

export interface InboundFacebookRulesFragment_assignment_assignedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface InboundFacebookRulesFragment_assignment {
  __typename: "InboundRulesAssignment";
  strategy: ChatAssignmentStrategyEnum;
  /**
   * The user to assign inbound SMS thread to.
   */
  assignedUser: InboundFacebookRulesFragment_assignment_assignedUser | null;
}

export interface InboundFacebookRulesFragment_leadCreation_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface InboundFacebookRulesFragment_leadCreation_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface InboundFacebookRulesFragment_leadCreation {
  __typename: "InboundRulesLeadCreation";
  /**
   * Whether lead creation is enabled.
   */
  enabled: boolean;
  /**
   * The stageset to use for lead creation.
   */
  stageset: InboundFacebookRulesFragment_leadCreation_stageset | null;
  /**
   * The tags to apply to the lead.
   */
  tags: InboundFacebookRulesFragment_leadCreation_tags[] | null;
}

export interface InboundFacebookRulesFragment {
  __typename: "InboundFacebookRules";
  /**
   * The assignment rule for inbound Facebook.
   */
  assignment: InboundFacebookRulesFragment_assignment;
  /**
   * The lead creation rule for inbound Facebook.
   */
  leadCreation: InboundFacebookRulesFragment_leadCreation;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InboxAssignmentFragment
// ====================================================

export interface InboxAssignmentFragment_assignmentEntity_Account {
  __typename: "Account" | "Activity" | "Contact" | "Lead" | "UnknownEntityType";
}

export interface InboxAssignmentFragment_assignmentEntity_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type InboxAssignmentFragment_assignmentEntity = InboxAssignmentFragment_assignmentEntity_Account | InboxAssignmentFragment_assignmentEntity_Thread;

export interface InboxAssignmentFragment_assigneeEntity {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface InboxAssignmentFragment {
  __typename: "Assignment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity that was assigned
   */
  assignmentEntity: InboxAssignmentFragment_assignmentEntity;
  /**
   * The entity to which the assignment was made
   */
  assigneeEntity: InboxAssignmentFragment_assigneeEntity;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InboxChannelEventFragment
// ====================================================

export interface InboxChannelEventFragment_changes {
  __typename: "ChangeLogChange";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attrbute changed by the entry
   */
  attribute: string;
  /**
   * The old value before the change
   */
  oldValue: string | null;
  /**
   * The new value after the change
   */
  newValue: string | null;
}

export interface InboxChannelEventFragment_actor_Account {
  __typename: "Account" | "Form" | "MaUrl";
}

export interface InboxChannelEventFragment_actor_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface InboxChannelEventFragment_actor_Contact {
  __typename: "Contact";
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface InboxChannelEventFragment_actor_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type InboxChannelEventFragment_actor = InboxChannelEventFragment_actor_Account | InboxChannelEventFragment_actor_User | InboxChannelEventFragment_actor_Contact | InboxChannelEventFragment_actor_Origin;

export interface InboxChannelEventFragment_payload_Activity {
  __typename: "Activity" | "Email" | "EmailQueued" | "EmailInteraction" | "Origin" | "Submission" | "Account" | "Contact" | "Lead" | "ConstantContactContactTrackingActivity" | "Comment" | "TimelineEventPayloadUnknownType" | "Chat" | "EntityAttributeValueFile" | "Session" | "AccountRelationshipChange" | "Quote" | "DocumentView" | "Invoice" | "Contract" | "LeadClonePayload" | "AccountContactFormerStatusChange";
}

export interface InboxChannelEventFragment_payload_Assignment_assignmentEntity_Account {
  __typename: "Account" | "Activity" | "Contact" | "Lead" | "UnknownEntityType";
}

export interface InboxChannelEventFragment_payload_Assignment_assignmentEntity_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type InboxChannelEventFragment_payload_Assignment_assignmentEntity = InboxChannelEventFragment_payload_Assignment_assignmentEntity_Account | InboxChannelEventFragment_payload_Assignment_assignmentEntity_Thread;

export interface InboxChannelEventFragment_payload_Assignment_assigneeEntity {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface InboxChannelEventFragment_payload_Assignment {
  __typename: "Assignment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity that was assigned
   */
  assignmentEntity: InboxChannelEventFragment_payload_Assignment_assignmentEntity;
  /**
   * The entity to which the assignment was made
   */
  assigneeEntity: InboxChannelEventFragment_payload_Assignment_assigneeEntity;
}

export interface InboxChannelEventFragment_payload_Thread_recipientEmailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface InboxChannelEventFragment_payload_Thread_startedFromUrl {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https:      // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
  /**
   * The `/features` part of https: // www.nutshell.com/features?utm_source=Google
   */
  path: string | null;
}

export interface InboxChannelEventFragment_payload_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The time this thread was created
   */
  createdTime: any;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
  /**
   * The shared inbox address this email thread was delivered to
   */
  recipientEmailAddress: InboxChannelEventFragment_payload_Thread_recipientEmailAddress | null;
  /**
   * The URL that this thread was started from
   */
  startedFromUrl: InboxChannelEventFragment_payload_Thread_startedFromUrl | null;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The images in the message
   */
  images: string[];
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_owner_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_owner_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export type InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_owner = InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_owner_User | InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_owner_Team;

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_externalChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_externalChannel_email {
  __typename: "NutEmailAddress";
  address: string;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  sessionId: string | null;
  status: ChannelStatus;
  phone: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_externalChannel_phone | null;
  email: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_externalChannel_email | null;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_nutshellChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_nutshellChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  phone: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_nutshellChannel_phone | null;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts_primary | null;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
}

export type InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_bestEntity = InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Lead | InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Contact | InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_bestEntity_Account;

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_stubEntity {
  __typename: "StubEntity";
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrlPath: string;
  initials: string;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export type InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_assignee = InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_Team | InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_assignee_User;

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary | null;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge | null;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge_node;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge | null;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges {
  __typename: "LeadStagesEdge";
  node: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages_current | null;
  /**
   * A list of edges.
   */
  edges: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges[];
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_accounts;
  /**
   * Stageset associated with the given lead
   */
  stageset: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stageset | null;
  /**
   * Stages for the lead
   */
  stages: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_stages;
  /**
   * The list of tags on this lead
   */
  tags: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads_tags[];
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this thread is open
   */
  isOpen: boolean;
  /**
   * Whether this thread is active
   */
  isActive: boolean;
  /**
   * The effective status of this thread
   */
  effectiveStatus: ThreadStatus;
  threadSummary: string | null;
  /**
   * Whether this thread can be archived
   */
  canArchive: boolean;
  /**
   * Whether this thread can be reopened
   */
  canReopen: boolean;
  /**
   * Whether this thread is assigned to the current user
   */
  isAssignedToCurrentUser: boolean;
  /**
   * The bot status of this thread
   */
  botStatus: ThreadBotStatus;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_displayMessage | null;
  /**
   * The user who created this thread
   */
  creatorUser: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_creatorUser | null;
  /**
   * The time this thread was created
   */
  createdTime: any;
  /**
   * The time this thread is snoozed until
   */
  snoozedUntilTime: any | null;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The user or team assigned to this thread
   */
  owner: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_owner | null;
  /**
   * The external channel this thread is related to
   */
  externalChannel: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_externalChannel;
  /**
   * The internal nutshell channel this thread is related to
   */
  nutshellChannel: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_nutshellChannel;
  /**
   * The best entity associated with this thread
   */
  bestEntity: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_bestEntity | null;
  /**
   * The Shelly entity only if this thread is on the stub Shelly channel
   */
  stubEntity: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_stubEntity | null;
  /**
   * The leads associated with this thread
   */
  relatedLeads: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread_relatedLeads[] | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
  /**
   * Whether this thread has unread messages
   */
  isUnread: boolean;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel_threads {
  __typename: "InboxChannelThreadsConnection";
  /**
   * The latest thread (open or closed) on this channel
   */
  latestThread: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads_latestThread | null;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The number of closed threads on this channel.
   */
  closedCount: number;
}

export interface InboxChannelEventFragment_payload_Message_thread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
  threads: InboxChannelEventFragment_payload_Message_thread_externalChannel_threads;
}

export interface InboxChannelEventFragment_payload_Message_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external channel this thread is related to
   */
  externalChannel: InboxChannelEventFragment_payload_Message_thread_externalChannel;
}

export interface InboxChannelEventFragment_payload_Message_senderEmailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface InboxChannelEventFragment_payload_Message_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface InboxChannelEventFragment_payload_Message_edition_campaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface InboxChannelEventFragment_payload_Message_edition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The editions of the drip sequence
   */
  editions: InboxChannelEventFragment_payload_Message_edition_campaign_editions;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface InboxChannelEventFragment_payload_Message_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: InboxChannelEventFragment_payload_Message_edition_campaign;
  /**
   * The position of the edition in the drip sequence
   */
  position: number;
}

export interface InboxChannelEventFragment_payload_Message_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  originType: OriginType;
}

export interface InboxChannelEventFragment_payload_Message_submission_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface InboxChannelEventFragment_payload_Message_submission_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: InboxChannelEventFragment_payload_Message_submission_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface InboxChannelEventFragment_payload_Message_submission_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: InboxChannelEventFragment_payload_Message_submission_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface InboxChannelEventFragment_payload_Message_submission_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: InboxChannelEventFragment_payload_Message_submission_booking_additionalAttendees_emailAddresses;
}

export interface InboxChannelEventFragment_payload_Message_submission_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The start time of this booking
   */
  startTime: any;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (InboxChannelEventFragment_payload_Message_submission_booking_additionalAttendees | null)[];
}

export interface InboxChannelEventFragment_payload_Message_submission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface InboxChannelEventFragment_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface InboxChannelEventFragment_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export interface InboxChannelEventFragment_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface InboxChannelEventFragment_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: InboxChannelEventFragment_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export type InboxChannelEventFragment_payload_Message_submission_fields_edges_fieldValue = InboxChannelEventFragment_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | InboxChannelEventFragment_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle | InboxChannelEventFragment_payload_Message_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields;

export interface InboxChannelEventFragment_payload_Message_submission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: InboxChannelEventFragment_payload_Message_submission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: InboxChannelEventFragment_payload_Message_submission_fields_edges_fieldValue | null;
}

export interface InboxChannelEventFragment_payload_Message_submission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: InboxChannelEventFragment_payload_Message_submission_fields_edges[];
}

export interface InboxChannelEventFragment_payload_Message_submission {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The booking associated with this submission (if Scheduler)
   */
  booking: InboxChannelEventFragment_payload_Message_submission_booking | null;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: InboxChannelEventFragment_payload_Message_submission_fields;
}

export interface InboxChannelEventFragment_payload_Message {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: MessageStatus;
  /**
   * The thread this message is part of
   */
  thread: InboxChannelEventFragment_payload_Message_thread;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  senderEmailAddress: InboxChannelEventFragment_payload_Message_senderEmailAddress | null;
  /**
   * Whether this message is a Nutshell system response
   */
  isNutshellSystemResponse: boolean;
  /**
   * The user who created this thread
   */
  creatorUser: InboxChannelEventFragment_payload_Message_creatorUser | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The time the message was read
   */
  readTime: any | null;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The edition of the message
   */
  edition: InboxChannelEventFragment_payload_Message_edition | null;
  /**
   * Whether this message can be canceled
   */
  isCancelable: boolean;
  /**
   * The reaction to the message
   */
  reaction: string | null;
  /**
   * The reason the message failed to send
   */
  errorReason: ErrorReason | null;
  /**
   * The URL of the media in the message
   */
  mediaUrl: string | null;
  /**
   * The origin of the user who created this thread
   */
  creatorOrigin: InboxChannelEventFragment_payload_Message_creatorOrigin | null;
  /**
   * The images in the message
   */
  images: string[];
  /**
   * The submission for a form or scheduler booking related to the chatbot goal
   */
  submission: InboxChannelEventFragment_payload_Message_submission | null;
}

export interface InboxChannelEventFragment_payload_Note {
  __typename: "Note";
  /**
   * The plain text (i.e., no HTML/rich text, no NutMark for @-mention tokenizing) representation of the Note text
   */
  body: string | null;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export type InboxChannelEventFragment_payload = InboxChannelEventFragment_payload_Activity | InboxChannelEventFragment_payload_Assignment | InboxChannelEventFragment_payload_Thread | InboxChannelEventFragment_payload_Message | InboxChannelEventFragment_payload_Note;

export interface InboxChannelEventFragment {
  __typename: "TimelineEvent";
  changeTime: any;
  /**
   * The type of change i.e. created, modified, deleted, etc
   */
  changeType: ChangeType;
  changes: InboxChannelEventFragment_changes[];
  /**
   * The entity that triggered the change_log entry
   */
  actor: InboxChannelEventFragment_actor;
  payload: InboxChannelEventFragment_payload;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InboxChannelFragment
// ====================================================

export interface InboxChannelFragment_threads_latestThread_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The images in the message
   */
  images: string[];
}

export interface InboxChannelFragment_threads_latestThread_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface InboxChannelFragment_threads_latestThread_owner_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface InboxChannelFragment_threads_latestThread_owner_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export type InboxChannelFragment_threads_latestThread_owner = InboxChannelFragment_threads_latestThread_owner_User | InboxChannelFragment_threads_latestThread_owner_Team;

export interface InboxChannelFragment_threads_latestThread_externalChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface InboxChannelFragment_threads_latestThread_externalChannel_email {
  __typename: "NutEmailAddress";
  address: string;
}

export interface InboxChannelFragment_threads_latestThread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  sessionId: string | null;
  status: ChannelStatus;
  phone: InboxChannelFragment_threads_latestThread_externalChannel_phone | null;
  email: InboxChannelFragment_threads_latestThread_externalChannel_email | null;
}

export interface InboxChannelFragment_threads_latestThread_nutshellChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface InboxChannelFragment_threads_latestThread_nutshellChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  phone: InboxChannelFragment_threads_latestThread_nutshellChannel_phone | null;
}

export interface InboxChannelFragment_threads_latestThread_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface InboxChannelFragment_threads_latestThread_bestEntity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface InboxChannelFragment_threads_latestThread_bestEntity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: InboxChannelFragment_threads_latestThread_bestEntity_Contact_accounts_primary | null;
}

export interface InboxChannelFragment_threads_latestThread_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: InboxChannelFragment_threads_latestThread_bestEntity_Contact_accounts;
}

export interface InboxChannelFragment_threads_latestThread_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
}

export type InboxChannelFragment_threads_latestThread_bestEntity = InboxChannelFragment_threads_latestThread_bestEntity_Lead | InboxChannelFragment_threads_latestThread_bestEntity_Contact | InboxChannelFragment_threads_latestThread_bestEntity_Account;

export interface InboxChannelFragment_threads_latestThread_stubEntity {
  __typename: "StubEntity";
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrlPath: string;
  initials: string;
}

export interface InboxChannelFragment_threads_latestThread_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface InboxChannelFragment_threads_latestThread_relatedLeads_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface InboxChannelFragment_threads_latestThread_relatedLeads_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export type InboxChannelFragment_threads_latestThread_relatedLeads_assignee = InboxChannelFragment_threads_latestThread_relatedLeads_assignee_Team | InboxChannelFragment_threads_latestThread_relatedLeads_assignee_User;

export interface InboxChannelFragment_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface InboxChannelFragment_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: InboxChannelFragment_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary | null;
}

export interface InboxChannelFragment_threads_latestThread_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: InboxChannelFragment_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts;
}

export interface InboxChannelFragment_threads_latestThread_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: InboxChannelFragment_threads_latestThread_relatedLeads_contacts_primaryEdge_node;
}

export interface InboxChannelFragment_threads_latestThread_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: InboxChannelFragment_threads_latestThread_relatedLeads_contacts_primaryEdge | null;
}

export interface InboxChannelFragment_threads_latestThread_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface InboxChannelFragment_threads_latestThread_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: InboxChannelFragment_threads_latestThread_relatedLeads_accounts_primaryEdge_node;
}

export interface InboxChannelFragment_threads_latestThread_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: InboxChannelFragment_threads_latestThread_relatedLeads_accounts_primaryEdge | null;
}

export interface InboxChannelFragment_threads_latestThread_relatedLeads_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface InboxChannelFragment_threads_latestThread_relatedLeads_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface InboxChannelFragment_threads_latestThread_relatedLeads_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface InboxChannelFragment_threads_latestThread_relatedLeads_stages_edges {
  __typename: "LeadStagesEdge";
  node: InboxChannelFragment_threads_latestThread_relatedLeads_stages_edges_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
}

export interface InboxChannelFragment_threads_latestThread_relatedLeads_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: InboxChannelFragment_threads_latestThread_relatedLeads_stages_current | null;
  /**
   * A list of edges.
   */
  edges: InboxChannelFragment_threads_latestThread_relatedLeads_stages_edges[];
}

export interface InboxChannelFragment_threads_latestThread_relatedLeads_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface InboxChannelFragment_threads_latestThread_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: InboxChannelFragment_threads_latestThread_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: InboxChannelFragment_threads_latestThread_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: InboxChannelFragment_threads_latestThread_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: InboxChannelFragment_threads_latestThread_relatedLeads_accounts;
  /**
   * Stageset associated with the given lead
   */
  stageset: InboxChannelFragment_threads_latestThread_relatedLeads_stageset | null;
  /**
   * Stages for the lead
   */
  stages: InboxChannelFragment_threads_latestThread_relatedLeads_stages;
  /**
   * The list of tags on this lead
   */
  tags: InboxChannelFragment_threads_latestThread_relatedLeads_tags[];
}

export interface InboxChannelFragment_threads_latestThread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this thread is open
   */
  isOpen: boolean;
  /**
   * Whether this thread is active
   */
  isActive: boolean;
  /**
   * The effective status of this thread
   */
  effectiveStatus: ThreadStatus;
  threadSummary: string | null;
  /**
   * Whether this thread can be archived
   */
  canArchive: boolean;
  /**
   * Whether this thread can be reopened
   */
  canReopen: boolean;
  /**
   * Whether this thread is assigned to the current user
   */
  isAssignedToCurrentUser: boolean;
  /**
   * The bot status of this thread
   */
  botStatus: ThreadBotStatus;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: InboxChannelFragment_threads_latestThread_displayMessage | null;
  /**
   * The user who created this thread
   */
  creatorUser: InboxChannelFragment_threads_latestThread_creatorUser | null;
  /**
   * The time this thread was created
   */
  createdTime: any;
  /**
   * The time this thread is snoozed until
   */
  snoozedUntilTime: any | null;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The user or team assigned to this thread
   */
  owner: InboxChannelFragment_threads_latestThread_owner | null;
  /**
   * The external channel this thread is related to
   */
  externalChannel: InboxChannelFragment_threads_latestThread_externalChannel;
  /**
   * The internal nutshell channel this thread is related to
   */
  nutshellChannel: InboxChannelFragment_threads_latestThread_nutshellChannel;
  /**
   * The best entity associated with this thread
   */
  bestEntity: InboxChannelFragment_threads_latestThread_bestEntity | null;
  /**
   * The Shelly entity only if this thread is on the stub Shelly channel
   */
  stubEntity: InboxChannelFragment_threads_latestThread_stubEntity | null;
  /**
   * The leads associated with this thread
   */
  relatedLeads: InboxChannelFragment_threads_latestThread_relatedLeads[] | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
  /**
   * Whether this thread has unread messages
   */
  isUnread: boolean;
}

export interface InboxChannelFragment_threads {
  __typename: "InboxChannelThreadsConnection";
  /**
   * The latest thread (open or closed) on this channel
   */
  latestThread: InboxChannelFragment_threads_latestThread | null;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The number of closed threads on this channel.
   */
  closedCount: number;
}

export interface InboxChannelFragment {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
  threads: InboxChannelFragment_threads;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InboxMessageFragment
// ====================================================

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The images in the message
   */
  images: string[];
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_owner_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_owner_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export type InboxMessageFragment_thread_externalChannel_threads_latestThread_owner = InboxMessageFragment_thread_externalChannel_threads_latestThread_owner_User | InboxMessageFragment_thread_externalChannel_threads_latestThread_owner_Team;

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_externalChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_externalChannel_email {
  __typename: "NutEmailAddress";
  address: string;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  sessionId: string | null;
  status: ChannelStatus;
  phone: InboxMessageFragment_thread_externalChannel_threads_latestThread_externalChannel_phone | null;
  email: InboxMessageFragment_thread_externalChannel_threads_latestThread_externalChannel_email | null;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_nutshellChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_nutshellChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  phone: InboxMessageFragment_thread_externalChannel_threads_latestThread_nutshellChannel_phone | null;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: InboxMessageFragment_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts_primary | null;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: InboxMessageFragment_thread_externalChannel_threads_latestThread_bestEntity_Contact_accounts;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
}

export type InboxMessageFragment_thread_externalChannel_threads_latestThread_bestEntity = InboxMessageFragment_thread_externalChannel_threads_latestThread_bestEntity_Lead | InboxMessageFragment_thread_externalChannel_threads_latestThread_bestEntity_Contact | InboxMessageFragment_thread_externalChannel_threads_latestThread_bestEntity_Account;

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_stubEntity {
  __typename: "StubEntity";
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrlPath: string;
  initials: string;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export type InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_assignee = InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_assignee_Team | InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_assignee_User;

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts_primary | null;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node_accounts;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge_node;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_contacts_primaryEdge | null;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge_node;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_accounts_primaryEdge | null;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges {
  __typename: "LeadStagesEdge";
  node: InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_stages_current | null;
  /**
   * A list of edges.
   */
  edges: InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_stages_edges[];
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_accounts;
  /**
   * Stageset associated with the given lead
   */
  stageset: InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_stageset | null;
  /**
   * Stages for the lead
   */
  stages: InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_stages;
  /**
   * The list of tags on this lead
   */
  tags: InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads_tags[];
}

export interface InboxMessageFragment_thread_externalChannel_threads_latestThread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this thread is open
   */
  isOpen: boolean;
  /**
   * Whether this thread is active
   */
  isActive: boolean;
  /**
   * The effective status of this thread
   */
  effectiveStatus: ThreadStatus;
  threadSummary: string | null;
  /**
   * Whether this thread can be archived
   */
  canArchive: boolean;
  /**
   * Whether this thread can be reopened
   */
  canReopen: boolean;
  /**
   * Whether this thread is assigned to the current user
   */
  isAssignedToCurrentUser: boolean;
  /**
   * The bot status of this thread
   */
  botStatus: ThreadBotStatus;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: InboxMessageFragment_thread_externalChannel_threads_latestThread_displayMessage | null;
  /**
   * The user who created this thread
   */
  creatorUser: InboxMessageFragment_thread_externalChannel_threads_latestThread_creatorUser | null;
  /**
   * The time this thread was created
   */
  createdTime: any;
  /**
   * The time this thread is snoozed until
   */
  snoozedUntilTime: any | null;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The user or team assigned to this thread
   */
  owner: InboxMessageFragment_thread_externalChannel_threads_latestThread_owner | null;
  /**
   * The external channel this thread is related to
   */
  externalChannel: InboxMessageFragment_thread_externalChannel_threads_latestThread_externalChannel;
  /**
   * The internal nutshell channel this thread is related to
   */
  nutshellChannel: InboxMessageFragment_thread_externalChannel_threads_latestThread_nutshellChannel;
  /**
   * The best entity associated with this thread
   */
  bestEntity: InboxMessageFragment_thread_externalChannel_threads_latestThread_bestEntity | null;
  /**
   * The Shelly entity only if this thread is on the stub Shelly channel
   */
  stubEntity: InboxMessageFragment_thread_externalChannel_threads_latestThread_stubEntity | null;
  /**
   * The leads associated with this thread
   */
  relatedLeads: InboxMessageFragment_thread_externalChannel_threads_latestThread_relatedLeads[] | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
  /**
   * Whether this thread has unread messages
   */
  isUnread: boolean;
}

export interface InboxMessageFragment_thread_externalChannel_threads {
  __typename: "InboxChannelThreadsConnection";
  /**
   * The latest thread (open or closed) on this channel
   */
  latestThread: InboxMessageFragment_thread_externalChannel_threads_latestThread | null;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The number of closed threads on this channel.
   */
  closedCount: number;
}

export interface InboxMessageFragment_thread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
  threads: InboxMessageFragment_thread_externalChannel_threads;
}

export interface InboxMessageFragment_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external channel this thread is related to
   */
  externalChannel: InboxMessageFragment_thread_externalChannel;
}

export interface InboxMessageFragment_senderEmailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface InboxMessageFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface InboxMessageFragment_edition_campaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface InboxMessageFragment_edition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The editions of the drip sequence
   */
  editions: InboxMessageFragment_edition_campaign_editions;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface InboxMessageFragment_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: InboxMessageFragment_edition_campaign;
  /**
   * The position of the edition in the drip sequence
   */
  position: number;
}

export interface InboxMessageFragment_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  originType: OriginType;
}

export interface InboxMessageFragment_submission_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface InboxMessageFragment_submission_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: InboxMessageFragment_submission_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface InboxMessageFragment_submission_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: InboxMessageFragment_submission_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface InboxMessageFragment_submission_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: InboxMessageFragment_submission_booking_additionalAttendees_emailAddresses;
}

export interface InboxMessageFragment_submission_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The start time of this booking
   */
  startTime: any;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (InboxMessageFragment_submission_booking_additionalAttendees | null)[];
}

export interface InboxMessageFragment_submission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface InboxMessageFragment_submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface InboxMessageFragment_submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export interface InboxMessageFragment_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface InboxMessageFragment_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: InboxMessageFragment_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export type InboxMessageFragment_submission_fields_edges_fieldValue = InboxMessageFragment_submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | InboxMessageFragment_submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle | InboxMessageFragment_submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields;

export interface InboxMessageFragment_submission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: InboxMessageFragment_submission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: InboxMessageFragment_submission_fields_edges_fieldValue | null;
}

export interface InboxMessageFragment_submission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: InboxMessageFragment_submission_fields_edges[];
}

export interface InboxMessageFragment_submission {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The booking associated with this submission (if Scheduler)
   */
  booking: InboxMessageFragment_submission_booking | null;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: InboxMessageFragment_submission_fields;
}

export interface InboxMessageFragment {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: MessageStatus;
  /**
   * The thread this message is part of
   */
  thread: InboxMessageFragment_thread;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  senderEmailAddress: InboxMessageFragment_senderEmailAddress | null;
  /**
   * Whether this message is a Nutshell system response
   */
  isNutshellSystemResponse: boolean;
  /**
   * The user who created this thread
   */
  creatorUser: InboxMessageFragment_creatorUser | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The time the message was read
   */
  readTime: any | null;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The edition of the message
   */
  edition: InboxMessageFragment_edition | null;
  /**
   * Whether this message can be canceled
   */
  isCancelable: boolean;
  /**
   * The reaction to the message
   */
  reaction: string | null;
  /**
   * The reason the message failed to send
   */
  errorReason: ErrorReason | null;
  /**
   * The URL of the media in the message
   */
  mediaUrl: string | null;
  /**
   * The origin of the user who created this thread
   */
  creatorOrigin: InboxMessageFragment_creatorOrigin | null;
  /**
   * The images in the message
   */
  images: string[];
  /**
   * The submission for a form or scheduler booking related to the chatbot goal
   */
  submission: InboxMessageFragment_submission | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InboxRelatedLeadFragment
// ====================================================

export interface InboxRelatedLeadFragment_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface InboxRelatedLeadFragment_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface InboxRelatedLeadFragment_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export type InboxRelatedLeadFragment_assignee = InboxRelatedLeadFragment_assignee_Team | InboxRelatedLeadFragment_assignee_User;

export interface InboxRelatedLeadFragment_contacts_primaryEdge_node_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface InboxRelatedLeadFragment_contacts_primaryEdge_node_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: InboxRelatedLeadFragment_contacts_primaryEdge_node_accounts_primary | null;
}

export interface InboxRelatedLeadFragment_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: InboxRelatedLeadFragment_contacts_primaryEdge_node_accounts;
}

export interface InboxRelatedLeadFragment_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: InboxRelatedLeadFragment_contacts_primaryEdge_node;
}

export interface InboxRelatedLeadFragment_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: InboxRelatedLeadFragment_contacts_primaryEdge | null;
}

export interface InboxRelatedLeadFragment_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface InboxRelatedLeadFragment_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: InboxRelatedLeadFragment_accounts_primaryEdge_node;
}

export interface InboxRelatedLeadFragment_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: InboxRelatedLeadFragment_accounts_primaryEdge | null;
}

export interface InboxRelatedLeadFragment_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface InboxRelatedLeadFragment_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface InboxRelatedLeadFragment_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface InboxRelatedLeadFragment_stages_edges {
  __typename: "LeadStagesEdge";
  node: InboxRelatedLeadFragment_stages_edges_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
}

export interface InboxRelatedLeadFragment_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: InboxRelatedLeadFragment_stages_current | null;
  /**
   * A list of edges.
   */
  edges: InboxRelatedLeadFragment_stages_edges[];
}

export interface InboxRelatedLeadFragment_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface InboxRelatedLeadFragment {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: InboxRelatedLeadFragment_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: InboxRelatedLeadFragment_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: InboxRelatedLeadFragment_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: InboxRelatedLeadFragment_accounts;
  /**
   * Stageset associated with the given lead
   */
  stageset: InboxRelatedLeadFragment_stageset | null;
  /**
   * Stages for the lead
   */
  stages: InboxRelatedLeadFragment_stages;
  /**
   * The list of tags on this lead
   */
  tags: InboxRelatedLeadFragment_tags[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InboxRelatedLeadStageEdgeFragment
// ====================================================

export interface InboxRelatedLeadStageEdgeFragment_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface InboxRelatedLeadStageEdgeFragment {
  __typename: "LeadStagesEdge";
  node: InboxRelatedLeadStageEdgeFragment_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InboxSidebarThreadFragment
// ====================================================

export interface InboxSidebarThreadFragment_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The content of the message
   */
  content: string;
}

export interface InboxSidebarThreadFragment_externalChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface InboxSidebarThreadFragment_externalChannel_email {
  __typename: "NutEmailAddress";
  address: string;
}

export interface InboxSidebarThreadFragment_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  phone: InboxSidebarThreadFragment_externalChannel_phone | null;
  email: InboxSidebarThreadFragment_externalChannel_email | null;
}

export interface InboxSidebarThreadFragment_nutshellChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface InboxSidebarThreadFragment_nutshellChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  phone: InboxSidebarThreadFragment_nutshellChannel_phone | null;
}

export interface InboxSidebarThreadFragment_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface InboxSidebarThreadFragment_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
}

export interface InboxSidebarThreadFragment_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
}

export type InboxSidebarThreadFragment_bestEntity = InboxSidebarThreadFragment_bestEntity_Lead | InboxSidebarThreadFragment_bestEntity_Contact | InboxSidebarThreadFragment_bestEntity_Account;

export interface InboxSidebarThreadFragment_stubEntity {
  __typename: "StubEntity";
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrlPath: string;
  initials: string;
}

export interface InboxSidebarThreadFragment_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface InboxSidebarThreadFragment_relatedLeads_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface InboxSidebarThreadFragment_relatedLeads_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export type InboxSidebarThreadFragment_relatedLeads_assignee = InboxSidebarThreadFragment_relatedLeads_assignee_Team | InboxSidebarThreadFragment_relatedLeads_assignee_User;

export interface InboxSidebarThreadFragment_relatedLeads_contacts_primaryEdge_node_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface InboxSidebarThreadFragment_relatedLeads_contacts_primaryEdge_node_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: InboxSidebarThreadFragment_relatedLeads_contacts_primaryEdge_node_accounts_primary | null;
}

export interface InboxSidebarThreadFragment_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: InboxSidebarThreadFragment_relatedLeads_contacts_primaryEdge_node_accounts;
}

export interface InboxSidebarThreadFragment_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: InboxSidebarThreadFragment_relatedLeads_contacts_primaryEdge_node;
}

export interface InboxSidebarThreadFragment_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: InboxSidebarThreadFragment_relatedLeads_contacts_primaryEdge | null;
}

export interface InboxSidebarThreadFragment_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface InboxSidebarThreadFragment_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: InboxSidebarThreadFragment_relatedLeads_accounts_primaryEdge_node;
}

export interface InboxSidebarThreadFragment_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: InboxSidebarThreadFragment_relatedLeads_accounts_primaryEdge | null;
}

export interface InboxSidebarThreadFragment_relatedLeads_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface InboxSidebarThreadFragment_relatedLeads_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface InboxSidebarThreadFragment_relatedLeads_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface InboxSidebarThreadFragment_relatedLeads_stages_edges {
  __typename: "LeadStagesEdge";
  node: InboxSidebarThreadFragment_relatedLeads_stages_edges_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
}

export interface InboxSidebarThreadFragment_relatedLeads_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: InboxSidebarThreadFragment_relatedLeads_stages_current | null;
  /**
   * A list of edges.
   */
  edges: InboxSidebarThreadFragment_relatedLeads_stages_edges[];
}

export interface InboxSidebarThreadFragment_relatedLeads_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface InboxSidebarThreadFragment_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: InboxSidebarThreadFragment_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: InboxSidebarThreadFragment_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: InboxSidebarThreadFragment_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: InboxSidebarThreadFragment_relatedLeads_accounts;
  /**
   * Stageset associated with the given lead
   */
  stageset: InboxSidebarThreadFragment_relatedLeads_stageset | null;
  /**
   * Stages for the lead
   */
  stages: InboxSidebarThreadFragment_relatedLeads_stages;
  /**
   * The list of tags on this lead
   */
  tags: InboxSidebarThreadFragment_relatedLeads_tags[];
}

export interface InboxSidebarThreadFragment {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The effective status of this thread
   */
  effectiveStatus: ThreadStatus;
  /**
   * The number of messages on this thread
   */
  messageCount: number;
  threadSummary: string | null;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: InboxSidebarThreadFragment_displayMessage | null;
  /**
   * The external channel this thread is related to
   */
  externalChannel: InboxSidebarThreadFragment_externalChannel;
  /**
   * The internal nutshell channel this thread is related to
   */
  nutshellChannel: InboxSidebarThreadFragment_nutshellChannel;
  /**
   * The best entity associated with this thread
   */
  bestEntity: InboxSidebarThreadFragment_bestEntity | null;
  /**
   * The Shelly entity only if this thread is on the stub Shelly channel
   */
  stubEntity: InboxSidebarThreadFragment_stubEntity | null;
  /**
   * The leads associated with this thread
   */
  relatedLeads: InboxSidebarThreadFragment_relatedLeads[] | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InboxThreadFragment
// ====================================================

export interface InboxThreadFragment_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The content of the message
   */
  content: string;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The images in the message
   */
  images: string[];
}

export interface InboxThreadFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface InboxThreadFragment_owner_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

export interface InboxThreadFragment_owner_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export type InboxThreadFragment_owner = InboxThreadFragment_owner_User | InboxThreadFragment_owner_Team;

export interface InboxThreadFragment_externalChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface InboxThreadFragment_externalChannel_email {
  __typename: "NutEmailAddress";
  address: string;
}

export interface InboxThreadFragment_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  sessionId: string | null;
  status: ChannelStatus;
  phone: InboxThreadFragment_externalChannel_phone | null;
  email: InboxThreadFragment_externalChannel_email | null;
}

export interface InboxThreadFragment_nutshellChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface InboxThreadFragment_nutshellChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
  phone: InboxThreadFragment_nutshellChannel_phone | null;
}

export interface InboxThreadFragment_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface InboxThreadFragment_bestEntity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface InboxThreadFragment_bestEntity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: InboxThreadFragment_bestEntity_Contact_accounts_primary | null;
}

export interface InboxThreadFragment_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: InboxThreadFragment_bestEntity_Contact_accounts;
}

export interface InboxThreadFragment_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  initials: string;
}

export type InboxThreadFragment_bestEntity = InboxThreadFragment_bestEntity_Lead | InboxThreadFragment_bestEntity_Contact | InboxThreadFragment_bestEntity_Account;

export interface InboxThreadFragment_stubEntity {
  __typename: "StubEntity";
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrlPath: string;
  initials: string;
}

export interface InboxThreadFragment_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface InboxThreadFragment_relatedLeads_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface InboxThreadFragment_relatedLeads_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export type InboxThreadFragment_relatedLeads_assignee = InboxThreadFragment_relatedLeads_assignee_Team | InboxThreadFragment_relatedLeads_assignee_User;

export interface InboxThreadFragment_relatedLeads_contacts_primaryEdge_node_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface InboxThreadFragment_relatedLeads_contacts_primaryEdge_node_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: InboxThreadFragment_relatedLeads_contacts_primaryEdge_node_accounts_primary | null;
}

export interface InboxThreadFragment_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: InboxThreadFragment_relatedLeads_contacts_primaryEdge_node_accounts;
}

export interface InboxThreadFragment_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: InboxThreadFragment_relatedLeads_contacts_primaryEdge_node;
}

export interface InboxThreadFragment_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: InboxThreadFragment_relatedLeads_contacts_primaryEdge | null;
}

export interface InboxThreadFragment_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface InboxThreadFragment_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: InboxThreadFragment_relatedLeads_accounts_primaryEdge_node;
}

export interface InboxThreadFragment_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: InboxThreadFragment_relatedLeads_accounts_primaryEdge | null;
}

export interface InboxThreadFragment_relatedLeads_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface InboxThreadFragment_relatedLeads_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface InboxThreadFragment_relatedLeads_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface InboxThreadFragment_relatedLeads_stages_edges {
  __typename: "LeadStagesEdge";
  node: InboxThreadFragment_relatedLeads_stages_edges_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
}

export interface InboxThreadFragment_relatedLeads_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: InboxThreadFragment_relatedLeads_stages_current | null;
  /**
   * A list of edges.
   */
  edges: InboxThreadFragment_relatedLeads_stages_edges[];
}

export interface InboxThreadFragment_relatedLeads_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface InboxThreadFragment_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: InboxThreadFragment_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: InboxThreadFragment_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: InboxThreadFragment_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: InboxThreadFragment_relatedLeads_accounts;
  /**
   * Stageset associated with the given lead
   */
  stageset: InboxThreadFragment_relatedLeads_stageset | null;
  /**
   * Stages for the lead
   */
  stages: InboxThreadFragment_relatedLeads_stages;
  /**
   * The list of tags on this lead
   */
  tags: InboxThreadFragment_relatedLeads_tags[];
}

export interface InboxThreadFragment {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this thread is open
   */
  isOpen: boolean;
  /**
   * Whether this thread is active
   */
  isActive: boolean;
  /**
   * The effective status of this thread
   */
  effectiveStatus: ThreadStatus;
  threadSummary: string | null;
  /**
   * Whether this thread can be archived
   */
  canArchive: boolean;
  /**
   * Whether this thread can be reopened
   */
  canReopen: boolean;
  /**
   * Whether this thread is assigned to the current user
   */
  isAssignedToCurrentUser: boolean;
  /**
   * The bot status of this thread
   */
  botStatus: ThreadBotStatus;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: InboxThreadFragment_displayMessage | null;
  /**
   * The user who created this thread
   */
  creatorUser: InboxThreadFragment_creatorUser | null;
  /**
   * The time this thread was created
   */
  createdTime: any;
  /**
   * The time this thread is snoozed until
   */
  snoozedUntilTime: any | null;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The user or team assigned to this thread
   */
  owner: InboxThreadFragment_owner | null;
  /**
   * The external channel this thread is related to
   */
  externalChannel: InboxThreadFragment_externalChannel;
  /**
   * The internal nutshell channel this thread is related to
   */
  nutshellChannel: InboxThreadFragment_nutshellChannel;
  /**
   * The best entity associated with this thread
   */
  bestEntity: InboxThreadFragment_bestEntity | null;
  /**
   * The Shelly entity only if this thread is on the stub Shelly channel
   */
  stubEntity: InboxThreadFragment_stubEntity | null;
  /**
   * The leads associated with this thread
   */
  relatedLeads: InboxThreadFragment_relatedLeads[] | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
  /**
   * Whether this thread has unread messages
   */
  isUnread: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InboxUserFragment
// ====================================================

export interface InboxUserFragment {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string;
  avatarUrl: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InboundSmsRulesFragment
// ====================================================

export interface InboundSmsRulesFragment_assignment_assignedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface InboundSmsRulesFragment_assignment {
  __typename: "InboundRulesAssignment";
  strategy: ChatAssignmentStrategyEnum;
  /**
   * The user to assign inbound SMS thread to.
   */
  assignedUser: InboundSmsRulesFragment_assignment_assignedUser | null;
}

export interface InboundSmsRulesFragment_leadCreation_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface InboundSmsRulesFragment_leadCreation_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface InboundSmsRulesFragment_leadCreation {
  __typename: "InboundRulesLeadCreation";
  /**
   * Whether lead creation is enabled.
   */
  enabled: boolean;
  /**
   * The stageset to use for lead creation.
   */
  stageset: InboundSmsRulesFragment_leadCreation_stageset | null;
  /**
   * The tags to apply to the lead.
   */
  tags: InboundSmsRulesFragment_leadCreation_tags[] | null;
}

export interface InboundSmsRulesFragment_redirectPhoneNumber {
  __typename: "NutPhoneNumber";
  /**
   * The base number component of the phone number
   */
  numberFormatted: string;
}

export interface InboundSmsRulesFragment {
  __typename: "InboundSmsRules";
  /**
   * The assignment rule for inbound SMS.
   */
  assignment: InboundSmsRulesFragment_assignment;
  /**
   * The lead creation rule for inbound SMS.
   */
  leadCreation: InboundSmsRulesFragment_leadCreation;
  /**
   * The phone number to redirect inbound SMS to.
   */
  redirectPhoneNumber: InboundSmsRulesFragment_redirectPhoneNumber | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InboundWhatsAppRulesFragment
// ====================================================

export interface InboundWhatsAppRulesFragment_assignment_assignedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface InboundWhatsAppRulesFragment_assignment {
  __typename: "InboundRulesAssignment";
  strategy: ChatAssignmentStrategyEnum;
  /**
   * The user to assign inbound SMS thread to.
   */
  assignedUser: InboundWhatsAppRulesFragment_assignment_assignedUser | null;
}

export interface InboundWhatsAppRulesFragment_leadCreation_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface InboundWhatsAppRulesFragment_leadCreation_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface InboundWhatsAppRulesFragment_leadCreation {
  __typename: "InboundRulesLeadCreation";
  /**
   * Whether lead creation is enabled.
   */
  enabled: boolean;
  /**
   * The stageset to use for lead creation.
   */
  stageset: InboundWhatsAppRulesFragment_leadCreation_stageset | null;
  /**
   * The tags to apply to the lead.
   */
  tags: InboundWhatsAppRulesFragment_leadCreation_tags[] | null;
}

export interface InboundWhatsAppRulesFragment {
  __typename: "InboundWhatsAppRules";
  /**
   * The assignment rule for inbound WhatsApp.
   */
  assignment: InboundWhatsAppRulesFragment_assignment;
  /**
   * The lead creation rule for inbound WhatsApp.
   */
  leadCreation: InboundWhatsAppRulesFragment_leadCreation;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FormForLandingPage
// ====================================================

export interface FormForLandingPage_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface FormForLandingPage {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  creatorUser: FormForLandingPage_creatorUser | null;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: MeetingForLandingPage
// ====================================================

export interface MeetingForLandingPage_validity_issues_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface MeetingForLandingPage_validity_issues {
  __typename: "MeetingValidityIssue";
  /**
   * The user tied to this issue
   */
  user: MeetingForLandingPage_validity_issues_user;
  /**
   * The issue type of this issue
   */
  issueType: ValidityIssueType;
}

export interface MeetingForLandingPage_validity {
  __typename: "MeetingValidity";
  /**
   * A list of issues with host users tied to this meeting
   */
  issues: MeetingForLandingPage_validity_issues[];
  /**
   * Whether this meeting can be booked
   */
  isBookable: boolean;
}

export interface MeetingForLandingPage_creator {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
}

export interface MeetingForLandingPage_cohosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface MeetingForLandingPage_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface MeetingForLandingPage_bookings {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MeetingForLandingPage {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * The type of this meeting
   */
  meetingType: MeetingType;
  /**
   * Whether this meeting is active
   */
  isActive: boolean;
  /**
   * The DateTime that represents when the meeting was deleted
   */
  deletedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The validity of this meeting
   */
  validity: MeetingForLandingPage_validity;
  /**
   * The primary host for this meeting
   */
  creator: MeetingForLandingPage_creator;
  /**
   * The cohosts of this meeting, not including primary host
   */
  cohosts: MeetingForLandingPage_cohosts[];
  /**
   * The activity type for this meeting
   */
  activityType: MeetingForLandingPage_activityType;
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number;
  /**
   * The bookings of this meeting
   */
  bookings: MeetingForLandingPage_bookings[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LandingPageFullFragment
// ====================================================

export interface LandingPageFullFragment_publishedVersion_publisherUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LandingPageFullFragment_publishedVersion {
  __typename: "PageVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that published this landing page version
   */
  publisherUser: LandingPageFullFragment_publishedVersion_publisherUser | null;
  /**
   * The JSON string representing the BEE page body
   */
  beeBodyJson: string;
  /**
   * The HTML string representing the materialized page
   */
  htmlMaterialized: string;
}

export interface LandingPageFullFragment_subdomainRecord {
  __typename: "Subdomain";
  /**
   * The ID of the em_from_domain row this record corresponds to, as each domain is split into multiple rows
   */
  fromDomainId: string;
  /**
   * The record of this DNS record
   */
  record: string;
  /**
   * The record of this DNS record
   */
  formattedRecord: string;
  /**
   * Where this subdomain is verified
   */
  isVerified: boolean;
}

export interface LandingPageFullFragment_editableVersion {
  __typename: "PageVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The JSON string representing the BEE page body
   */
  beeBodyJson: string;
}

export interface LandingPageFullFragment {
  __typename: "Page";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this landing page
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this landing page was created
   */
  createdTime: any;
  /**
   * The timestamp this landing page was last modified
   */
  lastModifiedTime: any;
  /**
   * The custom domain published version URL
   */
  customPublishedUrl: string | null;
  /**
   * The Nutshell hosted published version URL
   */
  nutshellPublishedUrl: string;
  /**
   * Whether or not this landing page has unpublished changes
   */
  hasUnpublishedChanges: boolean;
  /**
   * Page thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The status of this page
   */
  status: PageStatus;
  /**
   * The number of times this page has been viewed
   */
  numViews: number;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The current published version
   */
  publishedVersion: LandingPageFullFragment_publishedVersion | null;
  /**
   * The url slug of this landing page
   */
  urlSlug: string;
  /**
   * The embed code for embedding this landing page into an iframe
   */
  iframeEmbedCode: string;
  /**
   * The subdomain record tied to this page
   */
  subdomainRecord: LandingPageFullFragment_subdomainRecord | null;
  /**
   * An editable version of this landing page
   */
  editableVersion: LandingPageFullFragment_editableVersion;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LandingPageHtmlFragment
// ====================================================

export interface LandingPageHtmlFragment_editableVersion {
  __typename: "PageVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The HTML string representing the materialized page
   */
  htmlMaterialized: string;
}

export interface LandingPageHtmlFragment {
  __typename: "Page";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this landing page
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * An editable version of this landing page
   */
  editableVersion: LandingPageHtmlFragment_editableVersion;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LandingPageStubFragment
// ====================================================

export interface LandingPageStubFragment_publishedVersion_publisherUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LandingPageStubFragment_publishedVersion {
  __typename: "PageVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that published this landing page version
   */
  publisherUser: LandingPageStubFragment_publishedVersion_publisherUser | null;
}

export interface LandingPageStubFragment {
  __typename: "Page";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this landing page
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this landing page was created
   */
  createdTime: any;
  /**
   * The timestamp this landing page was last modified
   */
  lastModifiedTime: any;
  /**
   * The custom domain published version URL
   */
  customPublishedUrl: string | null;
  /**
   * The Nutshell hosted published version URL
   */
  nutshellPublishedUrl: string;
  /**
   * Whether or not this landing page has unpublished changes
   */
  hasUnpublishedChanges: boolean;
  /**
   * Page thumbnail
   */
  thumbnailUrl: string | null;
  /**
   * The status of this page
   */
  status: PageStatus;
  /**
   * The number of times this page has been viewed
   */
  numViews: number;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The current published version
   */
  publishedVersion: LandingPageStubFragment_publishedVersion | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadDripSequencesFragment
// ====================================================

export interface LeadDripSequencesFragment_contacts_edges_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  id: string;
  name: string;
}

export interface LeadDripSequencesFragment_contacts_edges_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: LeadDripSequencesFragment_contacts_edges_node_emailAddresses_primary | null;
}

export interface LeadDripSequencesFragment_contacts_edges_node_dripProgressions_currentNode {
  __typename: "SmartSequenceNode";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LeadDripSequencesFragment_contacts_edges_node_dripProgressions_campaign_startTrigger {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface LeadDripSequencesFragment_contacts_edges_node_dripProgressions_campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this goal. This is essentially just the stringified
   * version of the goal’s conditions, but because a goal can have multiple
   * conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface LeadDripSequencesFragment_contacts_edges_node_dripProgressions_campaign_from_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadDripSequencesFragment_contacts_edges_node_dripProgressions_campaign_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: LeadDripSequencesFragment_contacts_edges_node_dripProgressions_campaign_from_creatorUser | null;
}

export interface LeadDripSequencesFragment_contacts_edges_node_dripProgressions_campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * When a lead is closed, should drip sequences stop?
   */
  isStopOnLeadClose: boolean;
  /**
   * The start trigger for the drip sequence
   */
  startTrigger: LeadDripSequencesFragment_contacts_edges_node_dripProgressions_campaign_startTrigger | null;
  /**
   * The newly created Nutshell goal
   */
  goal: LeadDripSequencesFragment_contacts_edges_node_dripProgressions_campaign_goal | null;
  /**
   * The address to send this edition from
   */
  from: LeadDripSequencesFragment_contacts_edges_node_dripProgressions_campaign_from | null;
}

export interface LeadDripSequencesFragment_contacts_edges_node_dripProgressions_editions_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LeadDripSequencesFragment_contacts_edges_node_dripProgressions_editions_edition_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface LeadDripSequencesFragment_contacts_edges_node_dripProgressions_editions_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The URL that this edition links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The status for this edition
   */
  status: EditionStatus;
  scheduledTime: any | null;
  /**
   * The email template for this edition
   */
  emailTemplate: LeadDripSequencesFragment_contacts_edges_node_dripProgressions_editions_edition_emailTemplate | null;
  /**
   * The delay for this email, either from the previous email or from the time an
   * email triggers the drip sequence if this is the first email
   */
  delay: LeadDripSequencesFragment_contacts_edges_node_dripProgressions_editions_edition_delay | null;
}

export interface LeadDripSequencesFragment_contacts_edges_node_dripProgressions_editions {
  __typename: "DripProgressionEdition";
  /**
   * Whether this edition has been sent
   */
  sent: boolean;
  /**
   * The edition
   */
  edition: LeadDripSequencesFragment_contacts_edges_node_dripProgressions_editions_edition;
}

export interface LeadDripSequencesFragment_contacts_edges_node_dripProgressions {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * When this drip progression was created (when the contact entered the sequence)
   */
  createdTime: any;
  /**
   * When this progression stopped, or null if it is still active
   */
  stoppedTime: any | null;
  /**
   * Why this progression stopped, or null if it is still active
   */
  stoppedReason: DripProgressionStoppedReason | null;
  /**
   * The graph node this progression is currently on, if any. Null for legacy drip
   * progressions and for smart progressions without a current node.
   */
  currentNode: LeadDripSequencesFragment_contacts_edges_node_dripProgressions_currentNode | null;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
  /**
   * Number of editions that have been sent so far for this progression. NOTE: This
   * can be inaccurate if editions are reordered or an edition is added to the
   * start of the drip after a progression has started. This is ok! We want this
   * number to represent the number of prior active editions, even if they aren’t always sent.
   */
  numEditionsSent: number;
  /**
   * The drip sequence for this drip progressions
   */
  campaign: LeadDripSequencesFragment_contacts_edges_node_dripProgressions_campaign;
  /**
   * All editions in the drip sequence for this drip progression, in send order
   */
  editions: LeadDripSequencesFragment_contacts_edges_node_dripProgressions_editions[];
}

export interface LeadDripSequencesFragment_contacts_edges_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: LeadDripSequencesFragment_contacts_edges_node_emailAddresses;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * List of drip progressions for this contact. By default only active
   * progressions on non-cancelled campaigns are returned. Soft-deleted
   * progressions are always excluded.
   */
  dripProgressions: LeadDripSequencesFragment_contacts_edges_node_dripProgressions[];
}

export interface LeadDripSequencesFragment_contacts_edges {
  __typename: "LeadContactsEdge";
  node: LeadDripSequencesFragment_contacts_edges_node;
}

export interface LeadDripSequencesFragment_contacts {
  __typename: "LeadContactsConnection";
  /**
   * A list of edges.
   */
  edges: LeadDripSequencesFragment_contacts_edges[];
}

export interface LeadDripSequencesFragment {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: LeadDripSequencesFragment_contacts;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadPersonalEmailSequencesFragment
// ====================================================

export interface LeadPersonalEmailSequencesFragment_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_sender_sendableEmailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_sender {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * List of successfully enabled user email addresses that a user is able to send emails from Nutshell with.
   */
  sendableEmailAddresses: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_sender_sendableEmailAddresses[];
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_companyName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_firstName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_lastName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_lead_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  name: string;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge | null;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_lead_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_lead_contacts;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailAutomation_exitsStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailAutomation_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailAutomation_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailAutomation_entersStage;
  /**
   * The stage in which this stage subscription ends.
   */
  exitsStage: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailAutomation_exitsStage | null;
  /**
   * Indicates if a lead should receive emails from this subscription until it closes.
   */
  sendUntilClose: boolean;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailAutomation_delay | null;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailAutomation_emailList | null;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued_fromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued_to {
  __typename: "NutEmailAddress";
  avatarEntity: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued_to_avatarEntity | null;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The current status of this queued email.
   */
  status: EmailQueuedStatus;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
  fromUser: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued_fromUser | null;
  to: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued_to[];
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The next message to be sent
   */
  nextUnsentEmail: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailSequence_nextUnsentEmail | null;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  /**
   * The number of emails that have been sent
   */
  sentEmailsCount: number;
  emailsQueued: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued[];
  emailSequenceTemplate: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate | null;
  /**
   * True if this sequence has only one email
   */
  isSingleEmailSequence: boolean;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses {
  __typename: "EmailAutomationStatus";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that either did send this automation, or current _would_ send this
   * automation given the current context. For example, if the user is assigned to
   * a team, the logged in user is considered a potential sender if they’re on that team
   */
  sender: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_sender | null;
  /**
   * The total number of messages in the sequence for this status
   */
  unsentMessageCount: number | null;
  /**
   * Is this automation status paused?
   */
  isPaused: boolean;
  /**
   * Can this status be started
   */
  canStart: boolean;
  /**
   * Can this status be cancelled
   */
  canCancel: boolean;
  /**
   * The message to show to the user
   */
  status: EmailAutomationStatusStatus;
  /**
   * Status of the company name field
   */
  companyName: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_companyName;
  /**
   * Status of the first name field
   */
  firstName: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_firstName;
  /**
   * Status of the last name field
   */
  lastName: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_lastName;
  /**
   * Lead associated with this status row
   */
  lead: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_lead;
  /**
   * Email list stage subscription associated with this status row
   */
  emailAutomation: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailAutomation;
  /**
   * The actual email sequence going out for this lead in this stage
   */
  emailSequence: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses_emailSequence | null;
}

export interface LeadPersonalEmailSequencesFragment_stages_edges {
  __typename: "LeadStagesEdge";
  node: LeadPersonalEmailSequencesFragment_stages_edges_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
  /**
   * List of active stage subscription statuses for this lead
   */
  emailAutomationStatuses: LeadPersonalEmailSequencesFragment_stages_edges_emailAutomationStatuses[];
}

export interface LeadPersonalEmailSequencesFragment_stages {
  __typename: "LeadStagesConnection";
  /**
   * A list of edges.
   */
  edges: LeadPersonalEmailSequencesFragment_stages_edges[];
}

export interface LeadPersonalEmailSequencesFragment {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Stages for the lead
   */
  stages: LeadPersonalEmailSequencesFragment_stages;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadGoalFragment
// ====================================================

export interface LeadGoalFragment_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LeadGoalFragment_goalConditions_condition {
  __typename: "Condition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_node_EntityAttributeBase_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_node_EntityAttributeBase {
  __typename: "EntityAttributeBase";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: LeadGoalFragment_goalConditions_conditionCustomField_node_EntityAttributeBase_attribute;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_node_EntityAttributeEnum_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_node_EntityAttributeEnum_options {
  __typename: "EnumOption";
  /**
   * The name (and primary identifier) of the enum option.
   */
  id: string;
  /**
   * The name (and display) of the enum option.
   */
  name: string;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_node_EntityAttributeEnum {
  __typename: "EntityAttributeEnum";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: LeadGoalFragment_goalConditions_conditionCustomField_node_EntityAttributeEnum_attribute;
  /**
   * Enum options for this field
   */
  options: LeadGoalFragment_goalConditions_conditionCustomField_node_EntityAttributeEnum_options[];
  /**
   * Does this enum field allow multiple selections. I.e. can the value of "Favorite Color" be "Red" AND "Blue"?
   */
  allowMultiple: boolean;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_node_EntityAttributeCurrency_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_node_EntityAttributeCurrency {
  __typename: "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: LeadGoalFragment_goalConditions_conditionCustomField_node_EntityAttributeCurrency_attribute;
  /**
   * Available currency options for this field
   */
  currencyOptions: string[];
  /**
   * Default currency for this field
   */
  defaultCurrency: string;
}

export type LeadGoalFragment_goalConditions_conditionCustomField_node = LeadGoalFragment_goalConditions_conditionCustomField_node_EntityAttributeBase | LeadGoalFragment_goalConditions_conditionCustomField_node_EntityAttributeEnum | LeadGoalFragment_goalConditions_conditionCustomField_node_EntityAttributeCurrency;

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates | null;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all = LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueset | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueString | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueText | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEnum | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueDate | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEmail | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValuePhone | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueImage | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueUrl | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueNumber;

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset_all[];
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueLocation_coordinates | null;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type LeadGoalFragment_goalConditions_conditionCustomField_value = LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueString | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueText | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueEnum | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueDate | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueset | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueEmail | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValuePhone | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueLocation | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueFile | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueImage | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueUrl | LeadGoalFragment_goalConditions_conditionCustomField_value_EntityAttributeValueNumber;

export interface LeadGoalFragment_goalConditions_conditionCustomField {
  __typename: "LeadConditionCustomField";
  /**
   * The lead agnostic entity attribute object (the field).
   */
  node: LeadGoalFragment_goalConditions_conditionCustomField_node;
  /**
   * Value of this custom field for this particular lead
   */
  value: LeadGoalFragment_goalConditions_conditionCustomField_value | null;
}

export interface LeadGoalFragment_goalConditions {
  __typename: "LeadGoalCondition";
  /**
   * The lead agnostic condition object.
   */
  condition: LeadGoalFragment_goalConditions_condition;
  /**
   * Is this the current stage of the lead?
   */
  status: ConditionStatus;
  /**
   * Custom field associated with this goal’s condition. Ideally, this would be
   * _any_ field, but for now we’re only supporting custom fields. Therefore, if
   * the field associated with this condition is _not_ a custom field, this will return `null`
   */
  conditionCustomField: LeadGoalFragment_goalConditions_conditionCustomField | null;
}

export interface LeadGoalFragment {
  __typename: "LeadStagesEdge";
  node: LeadGoalFragment_node;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
  /**
   * List of this lead goal’s conditions associated with the given stage
   */
  goalConditions: LeadGoalFragment_goalConditions[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InstallmentFragment
// ====================================================

export interface InstallmentFragment_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface InstallmentFragment {
  __typename: "Installment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  dueTime: any;
  description: string | null;
  failedTime: any | null;
  value: InstallmentFragment_value;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadAssignable
// ====================================================

export interface LeadAssignable_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface LeadAssignable_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type LeadAssignable = LeadAssignable_Team | LeadAssignable_User;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: Lead
// ====================================================

export interface Lead_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface Lead_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface Lead_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type Lead_assignee = Lead_assignee_Team | Lead_assignee_User;

export interface Lead_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface Lead_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
}

export interface Lead_products_totalValue {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface Lead_products {
  __typename: "LeadProductsConnection";
  /**
   * The total value of the products mapped to the lead
   */
  totalValue: Lead_products_totalValue | null;
}

export interface Lead_clonedFrom {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface Lead_stages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The time this stage was deleted, or null if this stage has not been deleted.
   */
  deletedTime: any | null;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
}

export interface Lead_stages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface Lead_stages_edges_timeInStage {
  __typename: "FormattedValueDuration";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formattedString: string;
}

export interface Lead_stages_edges_goalConditions_condition {
  __typename: "Condition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase {
  __typename: "EntityAttributeBase";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: Lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase_attribute;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_options {
  __typename: "EnumOption";
  /**
   * The name (and primary identifier) of the enum option.
   */
  id: string;
  /**
   * The name (and display) of the enum option.
   */
  name: string;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum {
  __typename: "EntityAttributeEnum";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: Lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_attribute;
  /**
   * Enum options for this field
   */
  options: Lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum_options[];
  /**
   * Does this enum field allow multiple selections. I.e. can the value of "Favorite Color" be "Red" AND "Blue"?
   */
  allowMultiple: boolean;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency {
  __typename: "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: Lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency_attribute;
  /**
   * Available currency options for this field
   */
  currencyOptions: string[];
  /**
   * Default currency for this field
   */
  defaultCurrency: string;
}

export type Lead_stages_edges_goalConditions_conditionCustomField_node = Lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeBase | Lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeEnum | Lead_stages_edges_goalConditions_conditionCustomField_node_EntityAttributeCurrency;

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates | null;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all = Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueset | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueString | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueText | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEnum | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueDate | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEmail | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValuePhone | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueImage | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueUrl | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueNumber;

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset_all[];
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation_coordinates | null;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type Lead_stages_edges_goalConditions_conditionCustomField_value = Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueString | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueText | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEnum | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueDate | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueset | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueEmail | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValuePhone | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueLocation | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueFile | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueImage | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueUrl | Lead_stages_edges_goalConditions_conditionCustomField_value_EntityAttributeValueNumber;

export interface Lead_stages_edges_goalConditions_conditionCustomField_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface Lead_stages_edges_goalConditions_conditionCustomField {
  __typename: "LeadConditionCustomField";
  /**
   * The lead agnostic entity attribute object (the field).
   */
  node: Lead_stages_edges_goalConditions_conditionCustomField_node;
  /**
   * Value of this custom field for this particular lead
   */
  value: Lead_stages_edges_goalConditions_conditionCustomField_value | null;
  /**
   * Lead associated with this particular custom field context
   */
  lead: Lead_stages_edges_goalConditions_conditionCustomField_lead;
}

export interface Lead_stages_edges_goalConditions {
  __typename: "LeadGoalCondition";
  /**
   * The lead agnostic condition object.
   */
  condition: Lead_stages_edges_goalConditions_condition;
  /**
   * Is this the current stage of the lead?
   */
  status: ConditionStatus;
  /**
   * Custom field associated with this goal’s condition. Ideally, this would be
   * _any_ field, but for now we’re only supporting custom fields. Therefore, if
   * the field associated with this condition is _not_ a custom field, this will return `null`
   */
  conditionCustomField: Lead_stages_edges_goalConditions_conditionCustomField | null;
}

export interface Lead_stages_edges_unfiredEmailAutomations_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface Lead_stages_edges_unfiredEmailAutomations_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface Lead_stages_edges_unfiredEmailAutomations_emailList_MailChimpList {
  __typename: "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface Lead_stages_edges_unfiredEmailAutomations_emailList_ConstantContactList {
  __typename: "ConstantContactList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface Lead_stages_edges_unfiredEmailAutomations_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface Lead_stages_edges_unfiredEmailAutomations_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  emailSequenceTemplateMessages: Lead_stages_edges_unfiredEmailAutomations_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
}

export type Lead_stages_edges_unfiredEmailAutomations_emailList = Lead_stages_edges_unfiredEmailAutomations_emailList_MailChimpList | Lead_stages_edges_unfiredEmailAutomations_emailList_ConstantContactList | Lead_stages_edges_unfiredEmailAutomations_emailList_EmailSequenceTemplate;

export interface Lead_stages_edges_unfiredEmailAutomations {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: Lead_stages_edges_unfiredEmailAutomations_delay | null;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: Lead_stages_edges_unfiredEmailAutomations_entersStage;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: Lead_stages_edges_unfiredEmailAutomations_emailList | null;
}

export interface Lead_stages_edges_emailAutomationStatuses_sender_sendableEmailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
}

export interface Lead_stages_edges_emailAutomationStatuses_sender {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * List of successfully enabled user email addresses that a user is able to send emails from Nutshell with.
   */
  sendableEmailAddresses: Lead_stages_edges_emailAutomationStatuses_sender_sendableEmailAddresses[];
}

export interface Lead_stages_edges_emailAutomationStatuses_emailAutomation_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface Lead_stages_edges_emailAutomationStatuses_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface Lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_MailChimpList {
  __typename: "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface Lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_ConstantContactList {
  __typename: "ConstantContactList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface Lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface Lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  emailSequenceTemplateMessages: Lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
}

export type Lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList = Lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_MailChimpList | Lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_ConstantContactList | Lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate;

export interface Lead_stages_edges_emailAutomationStatuses_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: Lead_stages_edges_emailAutomationStatuses_emailAutomation_delay | null;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: Lead_stages_edges_emailAutomationStatuses_emailAutomation_entersStage;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: Lead_stages_edges_emailAutomationStatuses_emailAutomation_emailList | null;
}

export interface Lead_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

export interface Lead_stages_edges_emailAutomationStatuses_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface Lead_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface Lead_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: Lead_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate_creatorUser;
}

export interface Lead_stages_edges_emailAutomationStatuses_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  emailsQueued: Lead_stages_edges_emailAutomationStatuses_emailSequence_emailsQueued[];
  /**
   * The next message to be sent
   */
  nextUnsentEmail: Lead_stages_edges_emailAutomationStatuses_emailSequence_nextUnsentEmail | null;
  emailSequenceTemplate: Lead_stages_edges_emailAutomationStatuses_emailSequence_emailSequenceTemplate | null;
}

export interface Lead_stages_edges_emailAutomationStatuses_firstName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface Lead_stages_edges_emailAutomationStatuses_lastName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface Lead_stages_edges_emailAutomationStatuses_companyName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface Lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface Lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: Lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary_value;
}

export interface Lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: Lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface Lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: Lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses;
}

export interface Lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: Lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge_node;
}

export interface Lead_stages_edges_emailAutomationStatuses_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: Lead_stages_edges_emailAutomationStatuses_lead_contacts_primaryEdge | null;
}

export interface Lead_stages_edges_emailAutomationStatuses_lead_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface Lead_stages_edges_emailAutomationStatuses_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: Lead_stages_edges_emailAutomationStatuses_lead_contacts;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: Lead_stages_edges_emailAutomationStatuses_lead_assignee | null;
}

export interface Lead_stages_edges_emailAutomationStatuses {
  __typename: "EmailAutomationStatus";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The message to show to the user
   */
  status: EmailAutomationStatusStatus;
  /**
   * Is this automation status paused?
   */
  isPaused: boolean;
  /**
   * Can this status be cancelled
   */
  canCancel: boolean;
  /**
   * The total number of messages in the sequence for this status
   */
  unsentMessageCount: number | null;
  /**
   * Can this status be started
   */
  canStart: boolean;
  /**
   * The user that either did send this automation, or current _would_ send this
   * automation given the current context. For example, if the user is assigned to
   * a team, the logged in user is considered a potential sender if they’re on that team
   */
  sender: Lead_stages_edges_emailAutomationStatuses_sender | null;
  /**
   * Email list stage subscription associated with this status row
   */
  emailAutomation: Lead_stages_edges_emailAutomationStatuses_emailAutomation;
  /**
   * The actual email sequence going out for this lead in this stage
   */
  emailSequence: Lead_stages_edges_emailAutomationStatuses_emailSequence | null;
  /**
   * Status of the first name field
   */
  firstName: Lead_stages_edges_emailAutomationStatuses_firstName;
  /**
   * Status of the last name field
   */
  lastName: Lead_stages_edges_emailAutomationStatuses_lastName;
  /**
   * Status of the company name field
   */
  companyName: Lead_stages_edges_emailAutomationStatuses_companyName;
  /**
   * Lead associated with this status row
   */
  lead: Lead_stages_edges_emailAutomationStatuses_lead;
}

export interface Lead_stages_edges {
  __typename: "LeadStagesEdge";
  node: Lead_stages_edges_node;
  /**
   * Contextual avatarUrl for this stage. This might be something like an
   * incomplete avatarUrl, an active one, or a complete one.
   */
  avatarUrl: string;
  /**
   * Chevron style avatarUrl for this stage. This is impacted by the status of the lead.
   */
  chevronAvatarUrl: string;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
  /**
   * How long did the lead spend in this stage?
   */
  timeInStage: Lead_stages_edges_timeInStage | null;
  /**
   * List of this lead goal’s conditions associated with the given stage
   */
  goalConditions: Lead_stages_edges_goalConditions[];
  /**
   * List of this stage’s unfired email automations (automations without a status yet, because they’re in a future stage)
   */
  unfiredEmailAutomations: Lead_stages_edges_unfiredEmailAutomations[];
  /**
   * List of active stage subscription statuses for this lead
   */
  emailAutomationStatuses: Lead_stages_edges_emailAutomationStatuses[];
}

export interface Lead_stages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: Lead_stages_current | null;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: Lead_stages_edges[];
}

export interface Lead_stageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface Lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The stages associated with this stageset
   */
  stages: Lead_stageset_stages[];
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
}

export interface Lead_stagesetForWidgets_sidebarWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface Lead_stagesetForWidgets_workspaceWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface Lead_stagesetForWidgets {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The widgets of the stageset lead sidebar
   */
  sidebarWidgets: Lead_stagesetForWidgets_sidebarWidgets[];
  /**
   * The widgets of the stageset lead workspace
   */
  workspaceWidgets: Lead_stagesetForWidgets_workspaceWidgets[];
}

export interface Lead_tags_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface Lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: Lead_tags_creator;
}

export interface Lead_tagMaps_edges_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface Lead_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface Lead_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: Lead_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface Lead_tagMaps_edges {
  __typename: "TagMapsEdge";
  /**
   * The creator of this tag map
   */
  creator: Lead_tagMaps_edges_creator | null;
  /**
   * The DateTime that represents when the Tag was mapped
   */
  createdTime: any | null;
  node: Lead_tagMaps_edges_node | null;
}

export interface Lead_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * A list of edges.
   */
  edges: Lead_tagMaps_edges[];
}

export interface Lead_outcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface Lead_sendToDestinations {
  __typename: "EntityDestination";
  /**
   * The descriptive name for this destination.
   */
  name: string;
  /**
   * The URL this destination should direct to.
   */
  localUrl: string;
}

export interface Lead_externalResources {
  __typename: "ExternalResource";
  /**
   * The name of the external service this resource belongs to.
   */
  externalService: ExternalService;
  /**
   * The type of external resource.
   */
  externalResourceType: ExternalResourceType;
  /**
   * The ID of the external resource.
   */
  externalId: string;
}

export interface Lead_research_summary_leadFitReasons {
  __typename: "LeadFitReason";
  /**
   * Concise headline explaining this factor (always visible)
   */
  text: string;
  sentiment: LeadResearchSentiment;
  /**
   * Supporting detail shown when expanded
   */
  body: string;
}

export interface Lead_research_summary_fields {
  __typename: "LeadResearchField";
  key: string;
  label: string;
  value: string;
}

export interface Lead_research_summary_companyOverview {
  __typename: "CompanyOverview";
  /**
   * One punchy sentence about the company (max 48 chars)
   */
  headline: string;
  /**
   * 1-2 sentences of key factual details
   */
  body: string;
}

export interface Lead_research_summary {
  __typename: "EntitySummaryLeadResearch";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
  leadFit: LeadFitScore;
  leadFitLabel: string;
  leadFitReasons: Lead_research_summary_leadFitReasons[];
  fields: Lead_research_summary_fields[];
  companyOverview: Lead_research_summary_companyOverview | null;
  isDemoOverride: boolean;
  canRefresh: boolean;
}

export interface Lead_research {
  __typename: "LeadResearchResult";
  /**
   * Whether the lead has sufficient data (domains) to be researched
   */
  canResearch: boolean;
  isDemoResearchEnabled: boolean;
  /**
   * The AI-generated research summary, if available
   */
  summary: Lead_research_summary | null;
}

export interface Lead_installments_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface Lead_installments {
  __typename: "Installment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  dueTime: any;
  description: string | null;
  failedTime: any | null;
  value: Lead_installments_value;
}

export interface Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The bcc address of the Nutshell Lead.
   */
  bccAddress: string;
  number: number | null;
  /**
   * The terrority to which this lead is assigned.
   */
  territory: Lead_territory | null;
  avatarUrl: string;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  /**
   * Is this lead "Hot"?
   */
  isHot: boolean;
  /**
   * Is this lead "Overdue"? Overdue generally means that the lead is behind a
   * designated schedule dictated by its associated sales process
   */
  isOverdue: boolean;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The deleted time for the lead if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The percentage confidence of lead success.
   */
  confidence: number;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * The anticipated close time for the lead.
   */
  anticipatedClosedTime: any | null;
  /**
   * Returns true if the current user is watching this lead.
   */
  isCurrentUserWatching: boolean;
  /**
   * What time does this lead become overdue in the active stage? Null if no overdue time is set.
   */
  stageOverdueTime: any | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: Lead_assignee | null;
  /**
   * The deemed "creator" of this lead. If a user has created the lead manually,
   * our UI will show the user, otherwise we’ll fallback to the origin, i.e. "API"
   * or "CSV import"
   */
  creator: Lead_creator;
  /**
   * The mode of the leads value
   */
  valueMode: LeadValueMode;
  value: Lead_value | null;
  /**
   * Products for the lead
   */
  products: Lead_products | null;
  /**
   * The lead this lead was cloned from (usually null)
   */
  clonedFrom: Lead_clonedFrom | null;
  /**
   * Stages for the lead
   */
  stages: Lead_stages;
  /**
   * Stageset associated with the given lead
   */
  stageset: Lead_stageset | null;
  /**
   * Stageset to be used for gathering widget information, even for leads that may be missing an explicit stageset
   */
  stagesetForWidgets: Lead_stagesetForWidgets;
  /**
   * The list of tags on this lead
   */
  tags: Lead_tags[];
  /**
   * Tag maps for the lead
   */
  tagMaps: Lead_tagMaps | null;
  /**
   * The outcome for this lead, if there is one.
   */
  outcome: Lead_outcome | null;
  /**
   * The list of destinations for this lead
   */
  sendToDestinations: Lead_sendToDestinations[];
  /**
   * External resources mapped to this lead
   */
  externalResources: Lead_externalResources[];
  /**
   * AI-generated research and insights about this lead
   */
  research: Lead_research;
  /**
   * Timezone for installment paid and past-due. Lead owner, then first admin, then UTC.
   */
  installmentsTimezone: string;
  /**
   * List of installments on this lead
   */
  installments: Lead_installments[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadGoalCondition
// ====================================================

export interface LeadGoalCondition_condition {
  __typename: "Condition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface LeadGoalCondition_conditionCustomField_node_EntityAttributeBase_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface LeadGoalCondition_conditionCustomField_node_EntityAttributeBase {
  __typename: "EntityAttributeBase";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: LeadGoalCondition_conditionCustomField_node_EntityAttributeBase_attribute;
}

export interface LeadGoalCondition_conditionCustomField_node_EntityAttributeEnum_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface LeadGoalCondition_conditionCustomField_node_EntityAttributeEnum_options {
  __typename: "EnumOption";
  /**
   * The name (and primary identifier) of the enum option.
   */
  id: string;
  /**
   * The name (and display) of the enum option.
   */
  name: string;
}

export interface LeadGoalCondition_conditionCustomField_node_EntityAttributeEnum {
  __typename: "EntityAttributeEnum";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: LeadGoalCondition_conditionCustomField_node_EntityAttributeEnum_attribute;
  /**
   * Enum options for this field
   */
  options: LeadGoalCondition_conditionCustomField_node_EntityAttributeEnum_options[];
  /**
   * Does this enum field allow multiple selections. I.e. can the value of "Favorite Color" be "Red" AND "Blue"?
   */
  allowMultiple: boolean;
}

export interface LeadGoalCondition_conditionCustomField_node_EntityAttributeCurrency_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface LeadGoalCondition_conditionCustomField_node_EntityAttributeCurrency {
  __typename: "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: LeadGoalCondition_conditionCustomField_node_EntityAttributeCurrency_attribute;
  /**
   * Available currency options for this field
   */
  currencyOptions: string[];
  /**
   * Default currency for this field
   */
  defaultCurrency: string;
}

export type LeadGoalCondition_conditionCustomField_node = LeadGoalCondition_conditionCustomField_node_EntityAttributeBase | LeadGoalCondition_conditionCustomField_node_EntityAttributeEnum | LeadGoalCondition_conditionCustomField_node_EntityAttributeCurrency;

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates | null;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all = LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueset | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueString | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueText | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEnum | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueDate | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEmail | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValuePhone | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueImage | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueUrl | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueNumber;

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset_all[];
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: LeadGoalCondition_conditionCustomField_value_EntityAttributeValueLocation_coordinates | null;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: LeadGoalCondition_conditionCustomField_value_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: LeadGoalCondition_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: LeadGoalCondition_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface LeadGoalCondition_conditionCustomField_value_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type LeadGoalCondition_conditionCustomField_value = LeadGoalCondition_conditionCustomField_value_EntityAttributeValueString | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueText | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueEnum | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueDate | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueset | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueEmail | LeadGoalCondition_conditionCustomField_value_EntityAttributeValuePhone | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueLocation | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueFile | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueCurrency | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueImage | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueUrl | LeadGoalCondition_conditionCustomField_value_EntityAttributeValueNumber;

export interface LeadGoalCondition_conditionCustomField_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LeadGoalCondition_conditionCustomField {
  __typename: "LeadConditionCustomField";
  /**
   * The lead agnostic entity attribute object (the field).
   */
  node: LeadGoalCondition_conditionCustomField_node;
  /**
   * Value of this custom field for this particular lead
   */
  value: LeadGoalCondition_conditionCustomField_value | null;
  /**
   * Lead associated with this particular custom field context
   */
  lead: LeadGoalCondition_conditionCustomField_lead;
}

export interface LeadGoalCondition {
  __typename: "LeadGoalCondition";
  /**
   * The lead agnostic condition object.
   */
  condition: LeadGoalCondition_condition;
  /**
   * Is this the current stage of the lead?
   */
  status: ConditionStatus;
  /**
   * Custom field associated with this goal’s condition. Ideally, this would be
   * _any_ field, but for now we’re only supporting custom fields. Therefore, if
   * the field associated with this condition is _not_ a custom field, this will return `null`
   */
  conditionCustomField: LeadGoalCondition_conditionCustomField | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ConditionCustomField
// ====================================================

export interface ConditionCustomField_node_EntityAttributeBase_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface ConditionCustomField_node_EntityAttributeBase {
  __typename: "EntityAttributeBase";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: ConditionCustomField_node_EntityAttributeBase_attribute;
}

export interface ConditionCustomField_node_EntityAttributeEnum_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface ConditionCustomField_node_EntityAttributeEnum_options {
  __typename: "EnumOption";
  /**
   * The name (and primary identifier) of the enum option.
   */
  id: string;
  /**
   * The name (and display) of the enum option.
   */
  name: string;
}

export interface ConditionCustomField_node_EntityAttributeEnum {
  __typename: "EntityAttributeEnum";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: ConditionCustomField_node_EntityAttributeEnum_attribute;
  /**
   * Enum options for this field
   */
  options: ConditionCustomField_node_EntityAttributeEnum_options[];
  /**
   * Does this enum field allow multiple selections. I.e. can the value of "Favorite Color" be "Red" AND "Blue"?
   */
  allowMultiple: boolean;
}

export interface ConditionCustomField_node_EntityAttributeCurrency_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface ConditionCustomField_node_EntityAttributeCurrency {
  __typename: "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: ConditionCustomField_node_EntityAttributeCurrency_attribute;
  /**
   * Available currency options for this field
   */
  currencyOptions: string[];
  /**
   * Default currency for this field
   */
  defaultCurrency: string;
}

export type ConditionCustomField_node = ConditionCustomField_node_EntityAttributeBase | ConditionCustomField_node_EntityAttributeEnum | ConditionCustomField_node_EntityAttributeCurrency;

export interface ConditionCustomField_value_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface ConditionCustomField_value_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface ConditionCustomField_value_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface ConditionCustomField_value_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
}

export interface ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates | null;
}

export interface ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue;
}

export interface ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type ConditionCustomField_value_EntityAttributeValueset_all = ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueset | ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueString | ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueText | ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEnum | ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueDate | ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEmail | ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValuePhone | ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation | ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile | ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency | ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueImage | ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueUrl | ConditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueNumber;

export interface ConditionCustomField_value_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: ConditionCustomField_value_EntityAttributeValueset_all[];
}

export interface ConditionCustomField_value_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface ConditionCustomField_value_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface ConditionCustomField_value_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface ConditionCustomField_value_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: ConditionCustomField_value_EntityAttributeValueLocation_coordinates | null;
}

export interface ConditionCustomField_value_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface ConditionCustomField_value_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: ConditionCustomField_value_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface ConditionCustomField_value_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface ConditionCustomField_value_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: ConditionCustomField_value_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface ConditionCustomField_value_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: ConditionCustomField_value_EntityAttributeValueCurrency_currencyValue;
}

export interface ConditionCustomField_value_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface ConditionCustomField_value_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface ConditionCustomField_value_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type ConditionCustomField_value = ConditionCustomField_value_EntityAttributeValueString | ConditionCustomField_value_EntityAttributeValueText | ConditionCustomField_value_EntityAttributeValueEnum | ConditionCustomField_value_EntityAttributeValueDate | ConditionCustomField_value_EntityAttributeValueset | ConditionCustomField_value_EntityAttributeValueEmail | ConditionCustomField_value_EntityAttributeValuePhone | ConditionCustomField_value_EntityAttributeValueLocation | ConditionCustomField_value_EntityAttributeValueFile | ConditionCustomField_value_EntityAttributeValueCurrency | ConditionCustomField_value_EntityAttributeValueImage | ConditionCustomField_value_EntityAttributeValueUrl | ConditionCustomField_value_EntityAttributeValueNumber;

export interface ConditionCustomField_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ConditionCustomField {
  __typename: "LeadConditionCustomField";
  /**
   * The lead agnostic entity attribute object (the field).
   */
  node: ConditionCustomField_node;
  /**
   * Value of this custom field for this particular lead
   */
  value: ConditionCustomField_value | null;
  /**
   * Lead associated with this particular custom field context
   */
  lead: ConditionCustomField_lead;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadEmailAutomation
// ====================================================

export interface LeadEmailAutomation_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface LeadEmailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface LeadEmailAutomation_emailList_MailChimpList {
  __typename: "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface LeadEmailAutomation_emailList_ConstantContactList {
  __typename: "ConstantContactList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface LeadEmailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LeadEmailAutomation_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  emailSequenceTemplateMessages: LeadEmailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
}

export type LeadEmailAutomation_emailList = LeadEmailAutomation_emailList_MailChimpList | LeadEmailAutomation_emailList_ConstantContactList | LeadEmailAutomation_emailList_EmailSequenceTemplate;

export interface LeadEmailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: LeadEmailAutomation_delay | null;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: LeadEmailAutomation_entersStage;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: LeadEmailAutomation_emailList | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadStagesEdge
// ====================================================

export interface LeadStagesEdge_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface LeadStagesEdge_timeInStage {
  __typename: "FormattedValueDuration";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formattedString: string;
}

export interface LeadStagesEdge_goalConditions_condition {
  __typename: "Condition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_node_EntityAttributeBase_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_node_EntityAttributeBase {
  __typename: "EntityAttributeBase";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: LeadStagesEdge_goalConditions_conditionCustomField_node_EntityAttributeBase_attribute;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_node_EntityAttributeEnum_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_node_EntityAttributeEnum_options {
  __typename: "EnumOption";
  /**
   * The name (and primary identifier) of the enum option.
   */
  id: string;
  /**
   * The name (and display) of the enum option.
   */
  name: string;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_node_EntityAttributeEnum {
  __typename: "EntityAttributeEnum";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: LeadStagesEdge_goalConditions_conditionCustomField_node_EntityAttributeEnum_attribute;
  /**
   * Enum options for this field
   */
  options: LeadStagesEdge_goalConditions_conditionCustomField_node_EntityAttributeEnum_options[];
  /**
   * Does this enum field allow multiple selections. I.e. can the value of "Favorite Color" be "Red" AND "Blue"?
   */
  allowMultiple: boolean;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_node_EntityAttributeCurrency_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The type of the attribute
   */
  type: EntityCustomFieldType;
  /**
   * The description of the attribute
   */
  description: string | null;
  /**
   * Whether this attribute is immutable
   */
  isImmutable: boolean;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_node_EntityAttributeCurrency {
  __typename: "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attribute of this entity attribute
   */
  attribute: LeadStagesEdge_goalConditions_conditionCustomField_node_EntityAttributeCurrency_attribute;
  /**
   * Available currency options for this field
   */
  currencyOptions: string[];
  /**
   * Default currency for this field
   */
  defaultCurrency: string;
}

export type LeadStagesEdge_goalConditions_conditionCustomField_node = LeadStagesEdge_goalConditions_conditionCustomField_node_EntityAttributeBase | LeadStagesEdge_goalConditions_conditionCustomField_node_EntityAttributeEnum | LeadStagesEdge_goalConditions_conditionCustomField_node_EntityAttributeCurrency;

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueString {
  __typename: "EntityAttributeValueString";
  value: string;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueText {
  __typename: "EntityAttributeValueText";
  value: string;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEnum {
  __typename: "EntityAttributeValueEnum";
  value: string;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueDate {
  __typename: "EntityAttributeValueDate";
  date: any;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation_coordinates | null;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency_currencyValue;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all = LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueset | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueString | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueText | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEnum | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueDate | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueEmail | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValuePhone | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueLocation | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueFile | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueCurrency | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueImage | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueUrl | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all_EntityAttributeValueNumber;

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset {
  __typename: "EntityAttributeValueset";
  /**
   * An ordered collection of values
   */
  all: LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset_all[];
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueEmail {
  __typename: "EntityAttributeValueEmail";
  address: string;
  display: string;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValuePhone {
  __typename: "EntityAttributeValuePhone";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueLocation_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueLocation {
  __typename: "EntityAttributeValueLocation";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  region: string | null;
  fullAddress: string | null;
  /**
   * A more detailed printable address than fullAddress
   */
  fullAddressAllFields: string;
  /**
   * Unified type of lat, lng, and location accuracy. Returns this type so that
   * location accuracy is grouped together with lat/lng
   */
  coordinates: LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueLocation_coordinates | null;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueFile_nutFile {
  __typename: "File";
  /**
   * The unique identifier for this file
   */
  slug: string;
  /**
   * The name for this file
   */
  filename: string;
  /**
   * The download URL for this file
   */
  url: string;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * The Nut_File object for this file
   */
  nutFile: LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueFile_nutFile;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue_formattedValue {
  __typename: "FormattedValue";
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * Additional data provided, usually `days`, `hours`, etc
   */
  unit: string | null;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue_formattedValue;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency_currencyValue;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueImage {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  imageUrl: string;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueUrl {
  __typename: "EntityAttributeValueUrl";
  /**
   * Formatted value as displayed in UI
   */
  display: string;
  /**
   * Raw value for this URL
   */
  value: string;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueNumber {
  __typename: "EntityAttributeValueNumber";
  value: string;
  /**
   * The locale-aware parsed float value, or null if the stored string cannot be parsed as a number
   */
  numericValue: number | null;
}

export type LeadStagesEdge_goalConditions_conditionCustomField_value = LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueString | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueText | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueEnum | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueDate | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueset | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueEmail | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValuePhone | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueLocation | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueFile | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueCurrency | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueImage | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueUrl | LeadStagesEdge_goalConditions_conditionCustomField_value_EntityAttributeValueNumber;

export interface LeadStagesEdge_goalConditions_conditionCustomField_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LeadStagesEdge_goalConditions_conditionCustomField {
  __typename: "LeadConditionCustomField";
  /**
   * The lead agnostic entity attribute object (the field).
   */
  node: LeadStagesEdge_goalConditions_conditionCustomField_node;
  /**
   * Value of this custom field for this particular lead
   */
  value: LeadStagesEdge_goalConditions_conditionCustomField_value | null;
  /**
   * Lead associated with this particular custom field context
   */
  lead: LeadStagesEdge_goalConditions_conditionCustomField_lead;
}

export interface LeadStagesEdge_goalConditions {
  __typename: "LeadGoalCondition";
  /**
   * The lead agnostic condition object.
   */
  condition: LeadStagesEdge_goalConditions_condition;
  /**
   * Is this the current stage of the lead?
   */
  status: ConditionStatus;
  /**
   * Custom field associated with this goal’s condition. Ideally, this would be
   * _any_ field, but for now we’re only supporting custom fields. Therefore, if
   * the field associated with this condition is _not_ a custom field, this will return `null`
   */
  conditionCustomField: LeadStagesEdge_goalConditions_conditionCustomField | null;
}

export interface LeadStagesEdge_unfiredEmailAutomations_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface LeadStagesEdge_unfiredEmailAutomations_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface LeadStagesEdge_unfiredEmailAutomations_emailList_MailChimpList {
  __typename: "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface LeadStagesEdge_unfiredEmailAutomations_emailList_ConstantContactList {
  __typename: "ConstantContactList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface LeadStagesEdge_unfiredEmailAutomations_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LeadStagesEdge_unfiredEmailAutomations_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  emailSequenceTemplateMessages: LeadStagesEdge_unfiredEmailAutomations_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
}

export type LeadStagesEdge_unfiredEmailAutomations_emailList = LeadStagesEdge_unfiredEmailAutomations_emailList_MailChimpList | LeadStagesEdge_unfiredEmailAutomations_emailList_ConstantContactList | LeadStagesEdge_unfiredEmailAutomations_emailList_EmailSequenceTemplate;

export interface LeadStagesEdge_unfiredEmailAutomations {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: LeadStagesEdge_unfiredEmailAutomations_delay | null;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: LeadStagesEdge_unfiredEmailAutomations_entersStage;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: LeadStagesEdge_unfiredEmailAutomations_emailList | null;
}

export interface LeadStagesEdge_emailAutomationStatuses_sender_sendableEmailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
}

export interface LeadStagesEdge_emailAutomationStatuses_sender {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * List of successfully enabled user email addresses that a user is able to send emails from Nutshell with.
   */
  sendableEmailAddresses: LeadStagesEdge_emailAutomationStatuses_sender_sendableEmailAddresses[];
}

export interface LeadStagesEdge_emailAutomationStatuses_emailAutomation_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface LeadStagesEdge_emailAutomationStatuses_emailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface LeadStagesEdge_emailAutomationStatuses_emailAutomation_emailList_MailChimpList {
  __typename: "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface LeadStagesEdge_emailAutomationStatuses_emailAutomation_emailList_ConstantContactList {
  __typename: "ConstantContactList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface LeadStagesEdge_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LeadStagesEdge_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  emailSequenceTemplateMessages: LeadStagesEdge_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
}

export type LeadStagesEdge_emailAutomationStatuses_emailAutomation_emailList = LeadStagesEdge_emailAutomationStatuses_emailAutomation_emailList_MailChimpList | LeadStagesEdge_emailAutomationStatuses_emailAutomation_emailList_ConstantContactList | LeadStagesEdge_emailAutomationStatuses_emailAutomation_emailList_EmailSequenceTemplate;

export interface LeadStagesEdge_emailAutomationStatuses_emailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: LeadStagesEdge_emailAutomationStatuses_emailAutomation_delay | null;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: LeadStagesEdge_emailAutomationStatuses_emailAutomation_entersStage;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: LeadStagesEdge_emailAutomationStatuses_emailAutomation_emailList | null;
}

export interface LeadStagesEdge_emailAutomationStatuses_emailSequence_emailsQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * True if this queued email has been sent.
   */
  isAlreadySent: boolean;
  /**
   * True if this queued email is scheduled in the future and the next to be sent for its sequence.
   */
  isNextScheduledEmail: boolean;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * The scheduled delivery time for this queued email.
   */
  deliveryTime: any;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

export interface LeadStagesEdge_emailAutomationStatuses_emailSequence_nextUnsentEmail {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LeadStagesEdge_emailAutomationStatuses_emailSequence_emailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LeadStagesEdge_emailAutomationStatuses_emailSequence_emailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  creatorUser: LeadStagesEdge_emailAutomationStatuses_emailSequence_emailSequenceTemplate_creatorUser;
}

export interface LeadStagesEdge_emailAutomationStatuses_emailSequence {
  __typename: "EmailSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The total number of messages in this sequence
   */
  messageCount: number;
  emailsQueued: LeadStagesEdge_emailAutomationStatuses_emailSequence_emailsQueued[];
  /**
   * The next message to be sent
   */
  nextUnsentEmail: LeadStagesEdge_emailAutomationStatuses_emailSequence_nextUnsentEmail | null;
  emailSequenceTemplate: LeadStagesEdge_emailAutomationStatuses_emailSequence_emailSequenceTemplate | null;
}

export interface LeadStagesEdge_emailAutomationStatuses_firstName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface LeadStagesEdge_emailAutomationStatuses_lastName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface LeadStagesEdge_emailAutomationStatuses_companyName {
  __typename: "NutEmailAutomationFieldStatus";
  /**
   * True if this field is required to materialize the email sequence template
   */
  required: boolean;
  /**
   * Value that will be used to materialize this field
   */
  value: string | null;
}

export interface LeadStagesEdge_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface LeadStagesEdge_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: LeadStagesEdge_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary_value;
}

export interface LeadStagesEdge_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: LeadStagesEdge_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface LeadStagesEdge_emailAutomationStatuses_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: LeadStagesEdge_emailAutomationStatuses_lead_contacts_primaryEdge_node_emailAddresses;
}

export interface LeadStagesEdge_emailAutomationStatuses_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: LeadStagesEdge_emailAutomationStatuses_lead_contacts_primaryEdge_node;
}

export interface LeadStagesEdge_emailAutomationStatuses_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LeadStagesEdge_emailAutomationStatuses_lead_contacts_primaryEdge | null;
}

export interface LeadStagesEdge_emailAutomationStatuses_lead_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LeadStagesEdge_emailAutomationStatuses_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: LeadStagesEdge_emailAutomationStatuses_lead_contacts;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: LeadStagesEdge_emailAutomationStatuses_lead_assignee | null;
}

export interface LeadStagesEdge_emailAutomationStatuses {
  __typename: "EmailAutomationStatus";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The message to show to the user
   */
  status: EmailAutomationStatusStatus;
  /**
   * Is this automation status paused?
   */
  isPaused: boolean;
  /**
   * Can this status be cancelled
   */
  canCancel: boolean;
  /**
   * The total number of messages in the sequence for this status
   */
  unsentMessageCount: number | null;
  /**
   * Can this status be started
   */
  canStart: boolean;
  /**
   * The user that either did send this automation, or current _would_ send this
   * automation given the current context. For example, if the user is assigned to
   * a team, the logged in user is considered a potential sender if they’re on that team
   */
  sender: LeadStagesEdge_emailAutomationStatuses_sender | null;
  /**
   * Email list stage subscription associated with this status row
   */
  emailAutomation: LeadStagesEdge_emailAutomationStatuses_emailAutomation;
  /**
   * The actual email sequence going out for this lead in this stage
   */
  emailSequence: LeadStagesEdge_emailAutomationStatuses_emailSequence | null;
  /**
   * Status of the first name field
   */
  firstName: LeadStagesEdge_emailAutomationStatuses_firstName;
  /**
   * Status of the last name field
   */
  lastName: LeadStagesEdge_emailAutomationStatuses_lastName;
  /**
   * Status of the company name field
   */
  companyName: LeadStagesEdge_emailAutomationStatuses_companyName;
  /**
   * Lead associated with this status row
   */
  lead: LeadStagesEdge_emailAutomationStatuses_lead;
}

export interface LeadStagesEdge {
  __typename: "LeadStagesEdge";
  node: LeadStagesEdge_node;
  /**
   * Contextual avatarUrl for this stage. This might be something like an
   * incomplete avatarUrl, an active one, or a complete one.
   */
  avatarUrl: string;
  /**
   * Chevron style avatarUrl for this stage. This is impacted by the status of the lead.
   */
  chevronAvatarUrl: string;
  /**
   * Is this the current stage of the lead?
   */
  isActive: boolean;
  /**
   * How long did the lead spend in this stage?
   */
  timeInStage: LeadStagesEdge_timeInStage | null;
  /**
   * List of this lead goal’s conditions associated with the given stage
   */
  goalConditions: LeadStagesEdge_goalConditions[];
  /**
   * List of this stage’s unfired email automations (automations without a status yet, because they’re in a future stage)
   */
  unfiredEmailAutomations: LeadStagesEdge_unfiredEmailAutomations[];
  /**
   * List of active stage subscription statuses for this lead
   */
  emailAutomationStatuses: LeadStagesEdge_emailAutomationStatuses[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadStepFragment
// ====================================================

export interface LeadStepFragment_delayApplications_delay {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the delay
   */
  name: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface LeadStepFragment_delayApplications_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadStepFragment_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * An optional note about the delay application
   */
  note: string | null;
  /**
   * The time when the delay was applied
   */
  appliedTime: any;
  /**
   * The delay that was applied
   */
  delay: LeadStepFragment_delayApplications_delay;
  /**
   * The user who applied the delay
   */
  user: LeadStepFragment_delayApplications_user | null;
}

export interface LeadStepFragment_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadStepFragment_completedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadStepFragment_relatedEntity {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadStepFragment_relatedLead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
}

export interface LeadStepFragment_delays {
  __typename: "Delay";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human-readable length of the delay
   */
  displayLength: string;
}

export interface LeadStepFragment_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface LeadStepFragment {
  __typename: "Step";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the step
   */
  title: string;
  /**
   * The canonical API href for the step
   */
  href: string;
  /**
   * The step’s user-defined description
   */
  description: string | null;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: LeadStepFragment_delayApplications[];
  /**
   * The due timestamp of the step
   */
  dueTime: any | null;
  /**
   * The person or team assigned to this step
   */
  assignee: LeadStepFragment_assignee | null;
  /**
   * The DateTime that represents when the Step record was deleted
   */
  deletedTime: any | null;
  /**
   * The DateTime that represents when the Step record was created
   */
  completedTime: any | null;
  /**
   * Can the step be completed?
   */
  canBeCompleted: boolean;
  /**
   * Is this step completed?
   */
  isCompleted: boolean;
  /**
   * The user who completed the step
   */
  completedByUser: LeadStepFragment_completedByUser | null;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Is the step overdue?
   */
  isOverdue: boolean;
  /**
   * The entity that this task exists on
   */
  relatedEntity: LeadStepFragment_relatedEntity | null;
  /**
   * Related lead that this step is associated with
   */
  relatedLead: LeadStepFragment_relatedLead;
  /**
   * The delays that can be applied to this step
   */
  delays: (LeadStepFragment_delays | null)[];
  /**
   * The stage that this step is due in
   */
  stage: LeadStepFragment_stage | null;
  /**
   * The step's linkified description with URLs converted to clickable links
   */
  linkifiedDescription: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadValueFragment
// ====================================================

export interface LeadValueFragment_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
}

export interface LeadValueFragment_products_totalValue {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface LeadValueFragment_products {
  __typename: "LeadProductsConnection";
  /**
   * The total value of the products mapped to the lead
   */
  totalValue: LeadValueFragment_products_totalValue | null;
}

export interface LeadValueFragment {
  __typename: "Lead";
  /**
   * The mode of the leads value
   */
  valueMode: LeadValueMode;
  value: LeadValueFragment_value | null;
  /**
   * Products for the lead
   */
  products: LeadValueFragment_products | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: Stage
// ====================================================

export interface Stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: TagCount
// ====================================================

export interface TagCount_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface TagCount {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: TagCount_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
  /**
   * The number of entities tagged with this tag
   */
  count: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AccountsForLeadFragment
// ====================================================

export interface AccountsForLeadFragment_accounts_primaryEdge_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface AccountsForLeadFragment_accounts_primaryEdge_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: AccountsForLeadFragment_accounts_primaryEdge_node_postalAddresses_primary_location;
}

export interface AccountsForLeadFragment_accounts_primaryEdge_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountsForLeadFragment_accounts_primaryEdge_node_postalAddresses_primary | null;
}

export interface AccountsForLeadFragment_accounts_primaryEdge_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface AccountsForLeadFragment_accounts_primaryEdge_node_phones_primary {
  __typename: "Phone";
  value: AccountsForLeadFragment_accounts_primaryEdge_node_phones_primary_value;
}

export interface AccountsForLeadFragment_accounts_primaryEdge_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountsForLeadFragment_accounts_primaryEdge_node_phones_primary | null;
}

export interface AccountsForLeadFragment_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: AccountsForLeadFragment_accounts_primaryEdge_node_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: AccountsForLeadFragment_accounts_primaryEdge_node_phones;
}

export interface AccountsForLeadFragment_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: AccountsForLeadFragment_accounts_primaryEdge_node;
}

export interface AccountsForLeadFragment_accounts_edges_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface AccountsForLeadFragment_accounts_edges_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: AccountsForLeadFragment_accounts_edges_node_postalAddresses_primary_location;
}

export interface AccountsForLeadFragment_accounts_edges_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountsForLeadFragment_accounts_edges_node_postalAddresses_primary | null;
}

export interface AccountsForLeadFragment_accounts_edges_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface AccountsForLeadFragment_accounts_edges_node_phones_primary {
  __typename: "Phone";
  value: AccountsForLeadFragment_accounts_edges_node_phones_primary_value;
}

export interface AccountsForLeadFragment_accounts_edges_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountsForLeadFragment_accounts_edges_node_phones_primary | null;
}

export interface AccountsForLeadFragment_accounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: AccountsForLeadFragment_accounts_edges_node_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: AccountsForLeadFragment_accounts_edges_node_phones;
}

export interface AccountsForLeadFragment_accounts_edges_leadAccountContacts_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface AccountsForLeadFragment_accounts_edges_leadAccountContacts_phones_primary {
  __typename: "Phone";
  value: AccountsForLeadFragment_accounts_edges_leadAccountContacts_phones_primary_value;
}

export interface AccountsForLeadFragment_accounts_edges_leadAccountContacts_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountsForLeadFragment_accounts_edges_leadAccountContacts_phones_primary | null;
}

export interface AccountsForLeadFragment_accounts_edges_leadAccountContacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: AccountsForLeadFragment_accounts_edges_leadAccountContacts_phones;
}

export interface AccountsForLeadFragment_accounts_edges {
  __typename: "LeadAccountsEdge";
  node: AccountsForLeadFragment_accounts_edges_node;
  /**
   * List of contacts associated with this account that are also on the root lead
   */
  leadAccountContacts: AccountsForLeadFragment_accounts_edges_leadAccountContacts[] | null;
}

export interface AccountsForLeadFragment_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: AccountsForLeadFragment_accounts_primaryEdge | null;
  /**
   * A list of edges.
   */
  edges: AccountsForLeadFragment_accounts_edges[];
}

export interface AccountsForLeadFragment {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: AccountsForLeadFragment_accounts;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContactsForLeadFragment
// ====================================================

export interface ContactsForLeadFragment_contacts_primaryEdge_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface ContactsForLeadFragment_contacts_primaryEdge_node_phones_primary {
  __typename: "Phone";
  value: ContactsForLeadFragment_contacts_primaryEdge_node_phones_primary_value;
}

export interface ContactsForLeadFragment_contacts_primaryEdge_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: ContactsForLeadFragment_contacts_primaryEdge_node_phones_primary | null;
}

export interface ContactsForLeadFragment_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: ContactsForLeadFragment_contacts_primaryEdge_node_phones;
}

export interface ContactsForLeadFragment_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: ContactsForLeadFragment_contacts_primaryEdge_node;
}

export interface ContactsForLeadFragment_contacts_nonCompanyMappedContacts_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface ContactsForLeadFragment_contacts_nonCompanyMappedContacts_node_phones_primary {
  __typename: "Phone";
  value: ContactsForLeadFragment_contacts_nonCompanyMappedContacts_node_phones_primary_value;
}

export interface ContactsForLeadFragment_contacts_nonCompanyMappedContacts_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: ContactsForLeadFragment_contacts_nonCompanyMappedContacts_node_phones_primary | null;
}

export interface ContactsForLeadFragment_contacts_nonCompanyMappedContacts_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The job title of this contact
   */
  jobTitle: string | null;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: ContactsForLeadFragment_contacts_nonCompanyMappedContacts_node_phones;
}

export interface ContactsForLeadFragment_contacts_nonCompanyMappedContacts {
  __typename: "LeadContactsEdge";
  node: ContactsForLeadFragment_contacts_nonCompanyMappedContacts_node;
}

export interface ContactsForLeadFragment_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: ContactsForLeadFragment_contacts_primaryEdge | null;
  /**
   * List of contacts that are not associated with a company on this lead
   */
  nonCompanyMappedContacts: ContactsForLeadFragment_contacts_nonCompanyMappedContacts[] | null;
}

export interface ContactsForLeadFragment {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: ContactsForLeadFragment_contacts;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContractRecipientFragment
// ====================================================

export interface ContractRecipientFragment_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface ContractRecipientFragment_emailAddresses_primary {
  __typename: "EmailAddressEav";
  id: string;
  value: ContractRecipientFragment_emailAddresses_primary_value;
}

export interface ContractRecipientFragment_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: ContractRecipientFragment_emailAddresses_primary | null;
}

export interface ContractRecipientFragment {
  __typename: "Account" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The paging collection of email addresses for this peep.
   */
  emailAddresses: ContractRecipientFragment_emailAddresses;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContractRecipientsFragment
// ====================================================

export interface ContractRecipientsFragment_accounts_primaryEdge_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface ContractRecipientsFragment_accounts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  id: string;
  value: ContractRecipientsFragment_accounts_primaryEdge_node_emailAddresses_primary_value;
}

export interface ContractRecipientsFragment_accounts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: ContractRecipientsFragment_accounts_primaryEdge_node_emailAddresses_primary | null;
}

export interface ContractRecipientsFragment_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: ContractRecipientsFragment_accounts_primaryEdge_node_emailAddresses;
}

export interface ContractRecipientsFragment_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: ContractRecipientsFragment_accounts_primaryEdge_node;
}

export interface ContractRecipientsFragment_accounts_edges_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface ContractRecipientsFragment_accounts_edges_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  id: string;
  value: ContractRecipientsFragment_accounts_edges_node_emailAddresses_primary_value;
}

export interface ContractRecipientsFragment_accounts_edges_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: ContractRecipientsFragment_accounts_edges_node_emailAddresses_primary | null;
}

export interface ContractRecipientsFragment_accounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: ContractRecipientsFragment_accounts_edges_node_emailAddresses;
}

export interface ContractRecipientsFragment_accounts_edges {
  __typename: "LeadAccountsEdge";
  node: ContractRecipientsFragment_accounts_edges_node;
}

export interface ContractRecipientsFragment_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: ContractRecipientsFragment_accounts_primaryEdge | null;
  /**
   * A list of edges.
   */
  edges: ContractRecipientsFragment_accounts_edges[];
}

export interface ContractRecipientsFragment_contacts_primaryEdge_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface ContractRecipientsFragment_contacts_primaryEdge_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  id: string;
  value: ContractRecipientsFragment_contacts_primaryEdge_node_emailAddresses_primary_value;
}

export interface ContractRecipientsFragment_contacts_primaryEdge_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: ContractRecipientsFragment_contacts_primaryEdge_node_emailAddresses_primary | null;
}

export interface ContractRecipientsFragment_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: ContractRecipientsFragment_contacts_primaryEdge_node_emailAddresses;
}

export interface ContractRecipientsFragment_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: ContractRecipientsFragment_contacts_primaryEdge_node;
}

export interface ContractRecipientsFragment_contacts_edges_node_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface ContractRecipientsFragment_contacts_edges_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  id: string;
  value: ContractRecipientsFragment_contacts_edges_node_emailAddresses_primary_value;
}

export interface ContractRecipientsFragment_contacts_edges_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: ContractRecipientsFragment_contacts_edges_node_emailAddresses_primary | null;
}

export interface ContractRecipientsFragment_contacts_edges_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: ContractRecipientsFragment_contacts_edges_node_emailAddresses;
}

export interface ContractRecipientsFragment_contacts_edges {
  __typename: "LeadContactsEdge";
  node: ContractRecipientsFragment_contacts_edges_node;
}

export interface ContractRecipientsFragment_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: ContractRecipientsFragment_contacts_primaryEdge | null;
  /**
   * A list of edges.
   */
  edges: ContractRecipientsFragment_contacts_edges[];
}

export interface ContractRecipientsFragment {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: ContractRecipientsFragment_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: ContractRecipientsFragment_contacts;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadAttachmentsFragment
// ====================================================

export interface LeadAttachmentsFragment_files_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface LeadAttachmentsFragment_files {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * The user who uploaded the file
   */
  creatorUser: LeadAttachmentsFragment_files_creatorUser | null;
}

export interface LeadAttachmentsFragment {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * List of attachments on this lead
   */
  files: LeadAttachmentsFragment_files[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadContractSparseFragment
// ====================================================

export interface LeadContractSparseFragment_recipientEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
}

export interface LeadContractSparseFragment_recipientEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The primary email address for this account
   */
  primaryEmailAddress: string | null;
}

export type LeadContractSparseFragment_recipientEntity = LeadContractSparseFragment_recipientEntity_Contact | LeadContractSparseFragment_recipientEntity_Account;

export interface LeadContractSparseFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadContractSparseFragment_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface LeadContractSparseFragment_createdFromTemplate {
  __typename: "ContractTemplate";
  id: string;
  name: string;
  htmlUrlPath: string;
  deletedTime: any | null;
}

export interface LeadContractSparseFragment {
  __typename: "Contract";
  id: string;
  name: string;
  shareableViewInBrowserLink: string;
  internalViewInBrowserLink: string;
  displayNumber: string;
  displayStatus: ContractDisplayStatus;
  createdTime: any;
  modifiedTime: any | null;
  readyTime: any | null;
  sentTime: any | null;
  acceptedTime: any | null;
  revokedTime: any | null;
  deletedTime: any | null;
  /**
   * Url path to this specific contract attached to a lead
   */
  leadContractUrl: string | null;
  recipientEntity: LeadContractSparseFragment_recipientEntity | null;
  creatorUser: LeadContractSparseFragment_creatorUser | null;
  lead: LeadContractSparseFragment_lead;
  createdFromTemplate: LeadContractSparseFragment_createdFromTemplate | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CompetitorForLeadFragment
// ====================================================

export interface CompetitorForLeadFragment {
  __typename: "Competitor";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the competitor
   */
  name: string | null;
  /**
   * The percentage of leads that have been won against this competitor
   */
  leadSuccessPercent: number | null;
  /**
   * The URL of the report for this competitor
   */
  reportUrl: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CompetitorsLeadFragment
// ====================================================

export interface CompetitorsLeadFragment_competitors_edges_node {
  __typename: "Competitor";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the competitor
   */
  name: string | null;
  /**
   * The percentage of leads that have been won against this competitor
   */
  leadSuccessPercent: number | null;
  /**
   * The URL of the report for this competitor
   */
  reportUrl: string;
}

export interface CompetitorsLeadFragment_competitors_edges {
  __typename: "LeadCompetitorsEdge";
  node: CompetitorsLeadFragment_competitors_edges_node;
  /**
   * The one-off short note that users can write on this lead->competitor relationship.
   */
  relationshipNote: string | null;
}

export interface CompetitorsLeadFragment_competitors {
  __typename: "LeadCompetitorsConnection";
  /**
   * A list of edges.
   */
  edges: CompetitorsLeadFragment_competitors_edges[];
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface CompetitorsLeadFragment {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Competitors for the lead
   */
  competitors: CompetitorsLeadFragment_competitors | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EnvelopeDocumentsLeadFragment
// ====================================================

export interface EnvelopeDocumentsLeadFragment_documents_edges_node_quote_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeDocumentsLeadFragment_documents_edges_node_quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of a quote that should be displayed to the user
   */
  displayStatus: QuoteDisplayStatus;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: EnvelopeDocumentsLeadFragment_documents_edges_node_quote_total;
  /**
   * The slug of the quote
   */
  slug: string;
  /**
   * The sharable view in browser link
   */
  shareableViewInBrowserLink: string;
  /**
   * The internal view in browser link, for viewing as the customer without recording a view
   */
  internalViewInBrowserLink: string;
  /**
   * The time the quote was sent
   */
  sentTime: any | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was published
   */
  publishedTime: any | null;
  /**
   * The time the quote was accepted
   */
  acceptedTime: any | null;
}

export interface EnvelopeDocumentsLeadFragment_documents_edges_node_invoice_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EnvelopeDocumentsLeadFragment_documents_edges_node_invoice_canSendToQuickbooks_TrueWithReason {
  __typename: "TrueWithReason";
}

export interface EnvelopeDocumentsLeadFragment_documents_edges_node_invoice_canSendToQuickbooks_FalseWithReason {
  __typename: "FalseWithReason";
  /**
   * The reason why the value is false
   */
  reason: string;
}

export type EnvelopeDocumentsLeadFragment_documents_edges_node_invoice_canSendToQuickbooks = EnvelopeDocumentsLeadFragment_documents_edges_node_invoice_canSendToQuickbooks_TrueWithReason | EnvelopeDocumentsLeadFragment_documents_edges_node_invoice_canSendToQuickbooks_FalseWithReason;

export interface EnvelopeDocumentsLeadFragment_documents_edges_node_invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of a quote that should be displayed to the user
   */
  displayStatus: QuoteDisplayStatus;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: EnvelopeDocumentsLeadFragment_documents_edges_node_invoice_total;
  /**
   * The slug of the quote
   */
  slug: string;
  /**
   * The sharable view in browser link
   */
  shareableViewInBrowserLink: string;
  /**
   * The internal view in browser link, for viewing as the customer without recording a view
   */
  internalViewInBrowserLink: string;
  /**
   * The time the quote was sent
   */
  sentTime: any | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was published
   */
  publishedTime: any | null;
  /**
   * The time the quote was accepted
   */
  acceptedTime: any | null;
  /**
   * A human readable string representing how long over due the invoice is
   */
  overdueDuration: string | null;
  /**
   * URL to view this invoice in QuickBooks, or null if it has not been sent to QuickBooks
   */
  quickbooksInvoiceUrl: string | null;
  /**
   * Whether the invoice can be sent to Quickbooks in its current state
   */
  canSendToQuickbooks: EnvelopeDocumentsLeadFragment_documents_edges_node_invoice_canSendToQuickbooks;
}

export interface EnvelopeDocumentsLeadFragment_documents_edges_node_contract_recipientEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
}

export interface EnvelopeDocumentsLeadFragment_documents_edges_node_contract_recipientEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The primary email address for this account
   */
  primaryEmailAddress: string | null;
}

export type EnvelopeDocumentsLeadFragment_documents_edges_node_contract_recipientEntity = EnvelopeDocumentsLeadFragment_documents_edges_node_contract_recipientEntity_Contact | EnvelopeDocumentsLeadFragment_documents_edges_node_contract_recipientEntity_Account;

export interface EnvelopeDocumentsLeadFragment_documents_edges_node_contract_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EnvelopeDocumentsLeadFragment_documents_edges_node_contract_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface EnvelopeDocumentsLeadFragment_documents_edges_node_contract_createdFromTemplate {
  __typename: "ContractTemplate";
  id: string;
  name: string;
  htmlUrlPath: string;
  deletedTime: any | null;
}

export interface EnvelopeDocumentsLeadFragment_documents_edges_node_contract {
  __typename: "Contract";
  id: string;
  name: string;
  shareableViewInBrowserLink: string;
  internalViewInBrowserLink: string;
  displayNumber: string;
  displayStatus: ContractDisplayStatus;
  createdTime: any;
  modifiedTime: any | null;
  readyTime: any | null;
  sentTime: any | null;
  acceptedTime: any | null;
  revokedTime: any | null;
  deletedTime: any | null;
  /**
   * Url path to this specific contract attached to a lead
   */
  leadContractUrl: string | null;
  recipientEntity: EnvelopeDocumentsLeadFragment_documents_edges_node_contract_recipientEntity | null;
  creatorUser: EnvelopeDocumentsLeadFragment_documents_edges_node_contract_creatorUser | null;
  lead: EnvelopeDocumentsLeadFragment_documents_edges_node_contract_lead;
  createdFromTemplate: EnvelopeDocumentsLeadFragment_documents_edges_node_contract_createdFromTemplate | null;
}

export interface EnvelopeDocumentsLeadFragment_documents_edges_node {
  __typename: "EnvelopeDocument";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  documentType: EnvelopeDocumentType;
  quote: EnvelopeDocumentsLeadFragment_documents_edges_node_quote | null;
  invoice: EnvelopeDocumentsLeadFragment_documents_edges_node_invoice | null;
  contract: EnvelopeDocumentsLeadFragment_documents_edges_node_contract | null;
}

export interface EnvelopeDocumentsLeadFragment_documents_edges {
  __typename: "EnvelopeDocumentsEdge";
  node: EnvelopeDocumentsLeadFragment_documents_edges_node;
}

export interface EnvelopeDocumentsLeadFragment_documents {
  __typename: "EnvelopeDocumentsConnection";
  /**
   * A list of edges.
   */
  edges: EnvelopeDocumentsLeadFragment_documents_edges[];
}

export interface EnvelopeDocumentsLeadFragment {
  __typename: "Envelope";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  primaryDocumentType: EnvelopeDocumentType;
  documents: EnvelopeDocumentsLeadFragment_documents;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadResearchSummaryFragment
// ====================================================

export interface LeadResearchSummaryFragment_leadFitReasons {
  __typename: "LeadFitReason";
  /**
   * Concise headline explaining this factor (always visible)
   */
  text: string;
  sentiment: LeadResearchSentiment;
  /**
   * Supporting detail shown when expanded
   */
  body: string;
}

export interface LeadResearchSummaryFragment_fields {
  __typename: "LeadResearchField";
  key: string;
  label: string;
  value: string;
}

export interface LeadResearchSummaryFragment_companyOverview {
  __typename: "CompanyOverview";
  /**
   * One punchy sentence about the company (max 48 chars)
   */
  headline: string;
  /**
   * 1-2 sentences of key factual details
   */
  body: string;
}

export interface LeadResearchSummaryFragment {
  __typename: "EntitySummaryLeadResearch";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
  leadFit: LeadFitScore;
  leadFitLabel: string;
  leadFitReasons: LeadResearchSummaryFragment_leadFitReasons[];
  fields: LeadResearchSummaryFragment_fields[];
  companyOverview: LeadResearchSummaryFragment_companyOverview | null;
  isDemoOverride: boolean;
  canRefresh: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: MarketForLeadFragment
// ====================================================

export interface MarketForLeadFragment_market {
  __typename: "Market";
  id: string;
  name: string;
  currency: string;
  currencySymbol: string;
  isDefault: boolean;
}

export interface MarketForLeadFragment {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The market for the products attached to the lead
   */
  market: MarketForLeadFragment_market | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ProductForLeadFragment
// ====================================================

export interface ProductForLeadFragment_price {
  __typename: "Money";
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface ProductForLeadFragment_originalPrice {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface ProductForLeadFragment_node_category {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
}

export interface ProductForLeadFragment_node_markets_edges_price {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface ProductForLeadFragment_node_markets_edges {
  __typename: "ProductMarketsEdge";
  /**
   * The price and currency of the product in the market.
   */
  price: ProductForLeadFragment_node_markets_edges_price | null;
  /**
   * Whether the product is available in the market.
   */
  isAvailable: boolean | null;
}

export interface ProductForLeadFragment_node_markets {
  __typename: "ProductMarketsConnection";
  /**
   * A list of edges.
   */
  edges: ProductForLeadFragment_node_markets_edges[];
}

export interface ProductForLeadFragment_node {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The description of the product
   */
  description: string | null;
  /**
   * The type of the product (Good or Service)
   */
  type: ProductType;
  /**
   * The URL of the report for this product
   */
  reportUrl: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The category of the product
   */
  category: ProductForLeadFragment_node_category | null;
  /**
   * The markets of the product
   */
  markets: ProductForLeadFragment_node_markets;
  /**
   * The DateTime the product was created
   */
  createdTime: any;
}

export interface ProductForLeadFragment {
  __typename: "LeadProductsEdge";
  /**
   * The API ID of the Lead_ProductMap
   */
  id: string;
  /**
   * The one-off short note that users can write on this lead->product relationship.
   */
  relationshipNote: string | null;
  /**
   * The quantity number of the given product that is attached to the lead
   */
  quantity: number;
  /**
   * The monetary value for each unit of the product attached to the lead
   */
  price: ProductForLeadFragment_price;
  /**
   * The original price of the product
   */
  originalPrice: ProductForLeadFragment_originalPrice | null;
  /**
   * The total value of this attached product on the lead, taking its unit price and multiplying it by the given quantity.
   */
  total: number;
  /**
   * The product
   */
  node: ProductForLeadFragment_node;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ProductsForLeadFragment
// ====================================================

export interface ProductsForLeadFragment_products_edges_price {
  __typename: "Money";
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface ProductsForLeadFragment_products_edges_originalPrice {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface ProductsForLeadFragment_products_edges_node_category {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
}

export interface ProductsForLeadFragment_products_edges_node_markets_edges_price {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface ProductsForLeadFragment_products_edges_node_markets_edges {
  __typename: "ProductMarketsEdge";
  /**
   * The price and currency of the product in the market.
   */
  price: ProductsForLeadFragment_products_edges_node_markets_edges_price | null;
  /**
   * Whether the product is available in the market.
   */
  isAvailable: boolean | null;
}

export interface ProductsForLeadFragment_products_edges_node_markets {
  __typename: "ProductMarketsConnection";
  /**
   * A list of edges.
   */
  edges: ProductsForLeadFragment_products_edges_node_markets_edges[];
}

export interface ProductsForLeadFragment_products_edges_node {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The description of the product
   */
  description: string | null;
  /**
   * The type of the product (Good or Service)
   */
  type: ProductType;
  /**
   * The URL of the report for this product
   */
  reportUrl: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The category of the product
   */
  category: ProductsForLeadFragment_products_edges_node_category | null;
  /**
   * The markets of the product
   */
  markets: ProductsForLeadFragment_products_edges_node_markets;
  /**
   * The DateTime the product was created
   */
  createdTime: any;
}

export interface ProductsForLeadFragment_products_edges {
  __typename: "LeadProductsEdge";
  /**
   * The API ID of the Lead_ProductMap
   */
  id: string;
  /**
   * The one-off short note that users can write on this lead->product relationship.
   */
  relationshipNote: string | null;
  /**
   * The quantity number of the given product that is attached to the lead
   */
  quantity: number;
  /**
   * The monetary value for each unit of the product attached to the lead
   */
  price: ProductsForLeadFragment_products_edges_price;
  /**
   * The original price of the product
   */
  originalPrice: ProductsForLeadFragment_products_edges_originalPrice | null;
  /**
   * The total value of this attached product on the lead, taking its unit price and multiplying it by the given quantity.
   */
  total: number;
  /**
   * The product
   */
  node: ProductsForLeadFragment_products_edges_node;
}

export interface ProductsForLeadFragment_products {
  __typename: "LeadProductsConnection";
  /**
   * A list of edges.
   */
  edges: ProductsForLeadFragment_products_edges[];
}

export interface ProductsForLeadFragment {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Products for the lead
   */
  products: ProductsForLeadFragment_products | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ProductMutationFragment
// ====================================================

export interface ProductMutationFragment_products_edges_price {
  __typename: "Money";
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface ProductMutationFragment_products_edges_originalPrice {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface ProductMutationFragment_products_edges_node_category {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
}

export interface ProductMutationFragment_products_edges_node_markets_edges_price {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface ProductMutationFragment_products_edges_node_markets_edges {
  __typename: "ProductMarketsEdge";
  /**
   * The price and currency of the product in the market.
   */
  price: ProductMutationFragment_products_edges_node_markets_edges_price | null;
  /**
   * Whether the product is available in the market.
   */
  isAvailable: boolean | null;
}

export interface ProductMutationFragment_products_edges_node_markets {
  __typename: "ProductMarketsConnection";
  /**
   * A list of edges.
   */
  edges: ProductMutationFragment_products_edges_node_markets_edges[];
}

export interface ProductMutationFragment_products_edges_node {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The description of the product
   */
  description: string | null;
  /**
   * The type of the product (Good or Service)
   */
  type: ProductType;
  /**
   * The URL of the report for this product
   */
  reportUrl: string;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The category of the product
   */
  category: ProductMutationFragment_products_edges_node_category | null;
  /**
   * The markets of the product
   */
  markets: ProductMutationFragment_products_edges_node_markets;
  /**
   * The DateTime the product was created
   */
  createdTime: any;
}

export interface ProductMutationFragment_products_edges {
  __typename: "LeadProductsEdge";
  /**
   * The API ID of the Lead_ProductMap
   */
  id: string;
  /**
   * The one-off short note that users can write on this lead->product relationship.
   */
  relationshipNote: string | null;
  /**
   * The quantity number of the given product that is attached to the lead
   */
  quantity: number;
  /**
   * The monetary value for each unit of the product attached to the lead
   */
  price: ProductMutationFragment_products_edges_price;
  /**
   * The original price of the product
   */
  originalPrice: ProductMutationFragment_products_edges_originalPrice | null;
  /**
   * The total value of this attached product on the lead, taking its unit price and multiplying it by the given quantity.
   */
  total: number;
  /**
   * The product
   */
  node: ProductMutationFragment_products_edges_node;
}

export interface ProductMutationFragment_products_totalValue {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface ProductMutationFragment_products {
  __typename: "LeadProductsConnection";
  /**
   * A list of edges.
   */
  edges: ProductMutationFragment_products_edges[];
  /**
   * The total value of the products mapped to the lead
   */
  totalValue: ProductMutationFragment_products_totalValue | null;
}

export interface ProductMutationFragment_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
}

export interface ProductMutationFragment {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Products for the lead
   */
  products: ProductMutationFragment_products | null;
  /**
   * The mode of the leads value
   */
  valueMode: LeadValueMode;
  value: ProductMutationFragment_value | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadSummaryFragment
// ====================================================

export interface LeadSummaryFragment_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface LeadSummaryFragment_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadSummaryFragment_clonedFrom {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface LeadSummaryFragment_outcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadSummaryFragment {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  number: number | null;
  /**
   * The terrority to which this lead is assigned.
   */
  territory: LeadSummaryFragment_territory | null;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The percentage confidence of lead success.
   */
  confidence: number;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * The anticipated close time for the lead.
   */
  anticipatedClosedTime: any | null;
  /**
   * The deemed "creator" of this lead. If a user has created the lead manually,
   * our UI will show the user, otherwise we’ll fallback to the origin, i.e. "API"
   * or "CSV import"
   */
  creator: LeadSummaryFragment_creator;
  /**
   * The lead this lead was cloned from (usually null)
   */
  clonedFrom: LeadSummaryFragment_clonedFrom | null;
  /**
   * The outcome for this lead, if there is one.
   */
  outcome: LeadSummaryFragment_outcome | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CTABanner
// ====================================================

export interface CTABanner_demioEvent {
  __typename: "Webcast";
  /**
   * The id field denoting a single instance of a webcast event.
   */
  id: number;
  /**
   * The name of the Webcast.
   */
  name: string;
  /**
   * The registration url for a specific Webcast event.
   */
  registrationUrl: string;
  /**
   * The DateTime that represents when the Webcast will take place.
   */
  timestamp: any;
  isCurrentUserRegistered: boolean;
}

export interface CTABanner_upcomingEvents {
  __typename: "Webcast";
  /**
   * The id field denoting a single instance of a webcast event.
   */
  id: number;
  /**
   * The name of the Webcast.
   */
  name: string;
  /**
   * The registration url for a specific Webcast event.
   */
  registrationUrl: string;
  /**
   * The DateTime that represents when the Webcast will take place.
   */
  timestamp: any;
  isCurrentUserRegistered: boolean;
}

export interface CTABanner {
  __typename: "CTABanner";
  /**
   * The title of the banner
   */
  key: CTABannerKey;
  /**
   * The title of the banner
   */
  ctaType: CTABannerType;
  /**
   * The title of the banner
   */
  title: string;
  /**
   * The subtitle of the banner
   */
  subtitle: string;
  /**
   * The url to register a meeting with a team member
   */
  registrationUrl: string | null;
  /**
   * The dismiss setting associated with this banner
   */
  dismissSettingName: string;
  /**
   * The event for the banner
   */
  demioEvent: CTABanner_demioEvent | null;
  /**
   * A list of upcoming events
   */
  upcomingEvents: CTABanner_upcomingEvents[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: Webcast
// ====================================================

export interface Webcast {
  __typename: "Webcast";
  /**
   * The id field denoting a single instance of a webcast event.
   */
  id: number;
  /**
   * The name of the Webcast.
   */
  name: string;
  /**
   * The registration url for a specific Webcast event.
   */
  registrationUrl: string;
  /**
   * The DateTime that represents when the Webcast will take place.
   */
  timestamp: any;
  isCurrentUserRegistered: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: TodoListStep
// ====================================================

export interface TodoListStep_delayApplications {
  __typename: "DelayApplication";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface TodoListStep_relatedLead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface TodoListStep {
  __typename: "Step";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The name/title of the step
   */
  title: string;
  /**
   * The canonical API href for the step
   */
  href: string;
  /**
   * The step’s user-defined description
   */
  description: string | null;
  /**
   * Details on the times this step has been delayed
   */
  delayApplications: TodoListStep_delayApplications[];
  /**
   * The due timestamp of the step
   */
  dueTime: any | null;
  /**
   * Can the step be completed?
   */
  isCompleteable: boolean;
  /**
   * Is this step completed?
   */
  isCompleted: boolean;
  /**
   * Can the step be delayed?
   */
  isDelayable: boolean;
  /**
   * Is the step overdue?
   */
  isOverdue: boolean;
  /**
   * Can the step be skipped?
   */
  isSkippable: boolean;
  /**
   * Has this step been skipped?
   */
  isSkipped: boolean;
  /**
   * Human readable description of requirements that must be met to complete the step
   */
  requirementText: string;
  /**
   * Related lead that this step is associated with
   */
  relatedLead: TodoListStep_relatedLead;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppMessageFragment
// ====================================================

export interface AppMessageFragment {
  __typename: "AppMessage";
  /**
   * The unique id of the message.
   */
  id: string;
  /**
   * The message to show to the user.
   */
  message: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AiSearchResultFragment
// ====================================================

export interface AiSearchResultFragment_suggestions {
  __typename: "AiSearchSuggestion";
  /**
   * Suggestion type: navigation or action
   */
  type: AiSearchSuggestionTypeEnum;
  /**
   * Human-readable label
   */
  label: string;
  /**
   * Brief explanation of why this is suggested
   */
  description: string | null;
  /**
   * Navigation path, if type is navigation
   */
  path: string | null;
  /**
   * Action identifier, if type is action
   */
  actionId: string | null;
}

export interface AiSearchResultFragment {
  __typename: "AiSearchResult";
  /**
   * The intent of AI search
   */
  intent: AiSearchIntentEnum;
  /**
   * Ordered list of suggestions
   */
  suggestions: AiSearchResultFragment_suggestions[];
  /**
   * Refined search query for entity search, if applicable
   */
  searchRefinement: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AccountSearchResultByType
// ====================================================

export interface AccountSearchResultByType_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface AccountSearchResultByType_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  city: string | null;
  postalCode: string | null;
}

export interface AccountSearchResultByType_postalAddresses_primary {
  __typename: "PostalAddress";
  value: AccountSearchResultByType_postalAddresses_primary_value;
}

export interface AccountSearchResultByType_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountSearchResultByType_postalAddresses_primary | null;
}

export interface AccountSearchResultByType_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface AccountSearchResultByType_phones_primary {
  __typename: "Phone";
  value: AccountSearchResultByType_phones_primary_value;
}

export interface AccountSearchResultByType_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountSearchResultByType_phones_primary | null;
}

export interface AccountSearchResultByType {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * The primary contact for this account
   */
  primaryContact: AccountSearchResultByType_primaryContact | null;
  /**
   * Convenience way to get the region display for an account
   */
  primaryAddressRegion: string | null;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: AccountSearchResultByType_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: AccountSearchResultByType_phones;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContactSearchResultByType
// ====================================================

export interface ContactSearchResultByType_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface ContactSearchResultByType_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: ContactSearchResultByType_accounts_primary | null;
}

export interface ContactSearchResultByType_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface ContactSearchResultByType_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: ContactSearchResultByType_emailAddresses_primary_value;
}

export interface ContactSearchResultByType_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: ContactSearchResultByType_emailAddresses_primary | null;
}

export interface ContactSearchResultByType_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface ContactSearchResultByType_phones_primary {
  __typename: "Phone";
  value: ContactSearchResultByType_phones_primary_value;
}

export interface ContactSearchResultByType_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: ContactSearchResultByType_phones_primary | null;
}

export interface ContactSearchResultByType {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: ContactSearchResultByType_accounts;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: ContactSearchResultByType_emailAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: ContactSearchResultByType_phones;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadSearchResultByType
// ====================================================

export interface LeadSearchResultByType_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadSearchResultByType_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
}

export interface LeadSearchResultByType_value {
  __typename: "Money";
  /**
   * The [ISO_4217](https: // en.wikipedia.org/wiki/ISO_4217) shortcode to represent the currency of this monetary value.
   */
  currency: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: LeadSearchResultByType_value_formattedValue;
}

export interface LeadSearchResultByType_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface LeadSearchResultByType_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: LeadSearchResultByType_contacts_primaryEdge_node;
}

export interface LeadSearchResultByType_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LeadSearchResultByType_contacts_primaryEdge | null;
}

export interface LeadSearchResultByType_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface LeadSearchResultByType_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: LeadSearchResultByType_accounts_primaryEdge_node;
}

export interface LeadSearchResultByType_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LeadSearchResultByType_accounts_primaryEdge | null;
}

export interface LeadSearchResultByType {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * Leads don’t have initials, but for interface reasons we’ll return an empty
   * string here instead of removing the property entirely.
   */
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: LeadSearchResultByType_assignee | null;
  value: LeadSearchResultByType_value | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: LeadSearchResultByType_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: LeadSearchResultByType_accounts;
  /**
   * The created time for the lead.
   */
  createdTime: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: TrialInfo
// ====================================================

export interface TrialInfo {
  __typename: "Instance";
  /**
   * Should we show a chat CTA to the current user? Note, we still might hide this if we’re outside business hours.
   */
  shouldShowChatCta: boolean;
  /**
   * Is it currently during Nutshell business hours?
   */
  isDuringNutshellBusinessHours: boolean;
  /**
   * Should we hide chat even during business hours?
   */
  isChatHidden: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AccountHierarchyFragment
// ====================================================

export interface AccountHierarchyFragment_parentAccount_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface AccountHierarchyFragment_parentAccount_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface AccountHierarchyFragment_parentAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The type assigned to this account
   */
  accountType: AccountHierarchyFragment_parentAccount_accountType;
  /**
   * Convenience way to get the region display for an account
   */
  primaryAddressRegion: string | null;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The primary contact for this account
   */
  primaryContact: AccountHierarchyFragment_parentAccount_primaryContact | null;
}

export interface AccountHierarchyFragment_childAccounts_edges_node_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface AccountHierarchyFragment_childAccounts_edges_node_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface AccountHierarchyFragment_childAccounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The type assigned to this account
   */
  accountType: AccountHierarchyFragment_childAccounts_edges_node_accountType;
  /**
   * Convenience way to get the region display for an account
   */
  primaryAddressRegion: string | null;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The primary contact for this account
   */
  primaryContact: AccountHierarchyFragment_childAccounts_edges_node_primaryContact | null;
}

export interface AccountHierarchyFragment_childAccounts_edges {
  __typename: "AccountChildrenEdge";
  node: AccountHierarchyFragment_childAccounts_edges_node;
}

export interface AccountHierarchyFragment_childAccounts {
  __typename: "AccountChildrenConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: AccountHierarchyFragment_childAccounts_edges[];
}

export interface AccountHierarchyFragment {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The parent account of this account
   */
  parentAccount: AccountHierarchyFragment_parentAccount | null;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to child Accounts.
   */
  childAccounts: AccountHierarchyFragment_childAccounts;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ParentChildFragment
// ====================================================

export interface ParentChildFragment_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface ParentChildFragment_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface ParentChildFragment {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The type assigned to this account
   */
  accountType: ParentChildFragment_accountType;
  /**
   * Convenience way to get the region display for an account
   */
  primaryAddressRegion: string | null;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The primary contact for this account
   */
  primaryContact: ParentChildFragment_primaryContact | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AccountDuplicateDetailsFragment
// ====================================================

export interface AccountDuplicateDetailsFragment_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface AccountDuplicateDetailsFragment_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The full printable address of this location
   */
  fullPrintableAddress: string | null;
}

export interface AccountDuplicateDetailsFragment_postalAddresses_primary {
  __typename: "PostalAddress";
  id: string;
  location: AccountDuplicateDetailsFragment_postalAddresses_primary_location;
}

export interface AccountDuplicateDetailsFragment_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountDuplicateDetailsFragment_postalAddresses_primary | null;
}

export interface AccountDuplicateDetailsFragment_industry {
  __typename: "NutshellIndustry";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human description of the industry
   */
  name: string | null;
}

export interface AccountDuplicateDetailsFragment_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface AccountDuplicateDetailsFragment_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface AccountDuplicateDetailsFragment {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The primary email address for this account
   */
  primaryEmailAddress: string | null;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: AccountDuplicateDetailsFragment_owner | null;
  /**
   * The time this peep was last modified.
   */
  modifiedTime: any | null;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: AccountDuplicateDetailsFragment_postalAddresses;
  /**
   * The industry of this account
   */
  industry: AccountDuplicateDetailsFragment_industry | null;
  /**
   * The type assigned to this account
   */
  accountType: AccountDuplicateDetailsFragment_accountType;
  /**
   * The primary contact for this account
   */
  primaryContact: AccountDuplicateDetailsFragment_primaryContact | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AccountDuplicateFragment
// ====================================================

export interface AccountDuplicateFragment {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this peep has duplicates
   */
  hasDuplicates: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AccountLastContactedTimeFragment
// ====================================================

export interface AccountLastContactedTimeFragment {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The most recent date this entity was contacted by the active user
   */
  myLastContactedTime: any | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AccountPageFragment
// ====================================================

export interface AccountPageFragment_revenue_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface AccountPageFragment_revenue {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: AccountPageFragment_revenue_currencyValue;
}

export interface AccountPageFragment_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface AccountPageFragment_industry {
  __typename: "NutshellIndustry";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human description of the industry
   */
  name: string | null;
}

export interface AccountPageFragment_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface AccountPageFragment_parentAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface AccountPageFragment_childAccounts {
  __typename: "AccountChildrenConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface AccountPageFragment_creatorUser_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface AccountPageFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  firstName: string | null;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
  teams: AccountPageFragment_creatorUser_teams[];
}

export interface AccountPageFragment_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface AccountPageFragment_workspaceWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface AccountPageFragment_sidebarWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface AccountPageFragment_headerFields {
  __typename: "HeaderField";
  /**
   * The type of the header field
   */
  type: HeaderFieldType;
  /**
   * Whether the header field is enabled
   */
  isEnabled: boolean;
  /**
   * The name of the header field
   */
  name: string;
}

export interface AccountPageFragment_postalAddresses_primary_location_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface AccountPageFragment_postalAddresses_primary_location_weather {
  __typename: "Weather";
  temperature: string | null;
  condition: string | null;
  location: string | null;
  localTime: string | null;
}

export interface AccountPageFragment_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
  coordinates: AccountPageFragment_postalAddresses_primary_location_coordinates | null;
  weather: AccountPageFragment_postalAddresses_primary_location_weather | null;
}

export interface AccountPageFragment_postalAddresses_primary {
  __typename: "PostalAddress";
  location: AccountPageFragment_postalAddresses_primary_location;
}

export interface AccountPageFragment_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountPageFragment_postalAddresses_primary | null;
}

export interface AccountPageFragment_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface AccountPageFragment_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: AccountPageFragment_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface AccountPageFragment_tagMaps_edges {
  __typename: "TagMapsEdge";
  node: AccountPageFragment_tagMaps_edges_node | null;
}

export interface AccountPageFragment_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * A list of edges.
   */
  edges: AccountPageFragment_tagMaps_edges[];
}

export interface AccountPageFragment {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this entity deleted
   */
  isDeleted: boolean;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  avatarUrl: string;
  hasUploadedAvatar: boolean;
  canDeleteAvatar: boolean;
  /**
   * The number of people employed by this company
   */
  employeeCount: string | null;
  revenue: AccountPageFragment_revenue | null;
  /**
   * The terrority to which this peep is assigned.
   */
  territory: AccountPageFragment_territory | null;
  /**
   * The industry of this account
   */
  industry: AccountPageFragment_industry | null;
  /**
   * The type assigned to this account
   */
  accountType: AccountPageFragment_accountType;
  /**
   * The parent account of this account
   */
  parentAccount: AccountPageFragment_parentAccount | null;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to child Accounts.
   */
  childAccounts: AccountPageFragment_childAccounts;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The user who created this peep.
   */
  creatorUser: AccountPageFragment_creatorUser | null;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: AccountPageFragment_owner | null;
  /**
   * The widgets of the stageset lead workspace
   */
  workspaceWidgets: AccountPageFragment_workspaceWidgets[];
  /**
   * The widgets of the stageset lead sidebar
   */
  sidebarWidgets: AccountPageFragment_sidebarWidgets[];
  /**
   * The header fields for the entity type
   */
  headerFields: AccountPageFragment_headerFields[];
  /**
   * The postal addresses of the peep
   */
  postalAddresses: AccountPageFragment_postalAddresses;
  /**
   * Tag maps for the peep
   */
  tagMaps: AccountPageFragment_tagMaps | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AccountHierarchyInfoFragment
// ====================================================

export interface AccountHierarchyInfoFragment_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface AccountHierarchyInfoFragment_postalAddresses_primary {
  __typename: "PostalAddress";
  location: AccountHierarchyInfoFragment_postalAddresses_primary_location;
}

export interface AccountHierarchyInfoFragment_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountHierarchyInfoFragment_postalAddresses_primary | null;
}

export interface AccountHierarchyInfoFragment_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface AccountHierarchyInfoFragment_phones_primary {
  __typename: "Phone";
  value: AccountHierarchyInfoFragment_phones_primary_value;
}

export interface AccountHierarchyInfoFragment_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountHierarchyInfoFragment_phones_primary | null;
}

export interface AccountHierarchyInfoFragment_parentAccount_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface AccountHierarchyInfoFragment_parentAccount_postalAddresses_primary {
  __typename: "PostalAddress";
  location: AccountHierarchyInfoFragment_parentAccount_postalAddresses_primary_location;
}

export interface AccountHierarchyInfoFragment_parentAccount_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountHierarchyInfoFragment_parentAccount_postalAddresses_primary | null;
}

export interface AccountHierarchyInfoFragment_parentAccount_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface AccountHierarchyInfoFragment_parentAccount_phones_primary {
  __typename: "Phone";
  value: AccountHierarchyInfoFragment_parentAccount_phones_primary_value;
}

export interface AccountHierarchyInfoFragment_parentAccount_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountHierarchyInfoFragment_parentAccount_phones_primary | null;
}

export interface AccountHierarchyInfoFragment_parentAccount {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: AccountHierarchyInfoFragment_parentAccount_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: AccountHierarchyInfoFragment_parentAccount_phones;
}

export interface AccountHierarchyInfoFragment_childAccounts_edges_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface AccountHierarchyInfoFragment_childAccounts_edges_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: AccountHierarchyInfoFragment_childAccounts_edges_node_postalAddresses_primary_location;
}

export interface AccountHierarchyInfoFragment_childAccounts_edges_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountHierarchyInfoFragment_childAccounts_edges_node_postalAddresses_primary | null;
}

export interface AccountHierarchyInfoFragment_childAccounts_edges_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface AccountHierarchyInfoFragment_childAccounts_edges_node_phones_primary {
  __typename: "Phone";
  value: AccountHierarchyInfoFragment_childAccounts_edges_node_phones_primary_value;
}

export interface AccountHierarchyInfoFragment_childAccounts_edges_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountHierarchyInfoFragment_childAccounts_edges_node_phones_primary | null;
}

export interface AccountHierarchyInfoFragment_childAccounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: AccountHierarchyInfoFragment_childAccounts_edges_node_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: AccountHierarchyInfoFragment_childAccounts_edges_node_phones;
}

export interface AccountHierarchyInfoFragment_childAccounts_edges {
  __typename: "AccountChildrenEdge";
  node: AccountHierarchyInfoFragment_childAccounts_edges_node;
}

export interface AccountHierarchyInfoFragment_childAccounts {
  __typename: "AccountChildrenConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: AccountHierarchyInfoFragment_childAccounts_edges[];
}

export interface AccountHierarchyInfoFragment {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: AccountHierarchyInfoFragment_postalAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: AccountHierarchyInfoFragment_phones;
  /**
   * The parent account of this account
   */
  parentAccount: AccountHierarchyInfoFragment_parentAccount | null;
  /**
   * A paging list of edges in our graph that connect this Nutshell Account to child Accounts.
   */
  childAccounts: AccountHierarchyInfoFragment_childAccounts;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AccountAttachmentsFragment
// ====================================================

export interface AccountAttachmentsFragment_files_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface AccountAttachmentsFragment_files {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * The user who uploaded the file
   */
  creatorUser: AccountAttachmentsFragment_files_creatorUser | null;
}

export interface AccountAttachmentsFragment {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The files for this peep
   */
  files: AccountAttachmentsFragment_files[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AccountSummaryFragment
// ====================================================

export interface AccountSummaryFragment_revenue_currencyValue {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface AccountSummaryFragment_revenue {
  __typename: "EntityAttributeValueCurrency";
  currencyValue: AccountSummaryFragment_revenue_currencyValue;
}

export interface AccountSummaryFragment_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface AccountSummaryFragment_industry {
  __typename: "NutshellIndustry";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human description of the industry
   */
  name: string | null;
}

export interface AccountSummaryFragment_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface AccountSummaryFragment_creatorUser_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface AccountSummaryFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  firstName: string | null;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
  teams: AccountSummaryFragment_creatorUser_teams[];
}

export interface AccountSummaryFragment_mergedWith {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface AccountSummaryFragment_origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  originType: OriginType;
  isInteresting: boolean;
  htmlUrl: string | null;
}

export interface AccountSummaryFragment_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface AccountSummaryFragment_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface AccountSummaryFragment_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: AccountSummaryFragment_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface AccountSummaryFragment_tagMaps_edges {
  __typename: "TagMapsEdge";
  node: AccountSummaryFragment_tagMaps_edges_node | null;
}

export interface AccountSummaryFragment_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * A list of edges.
   */
  edges: AccountSummaryFragment_tagMaps_edges[];
}

export interface AccountSummaryFragment {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The number of people employed by this company
   */
  employeeCount: string | null;
  revenue: AccountSummaryFragment_revenue | null;
  /**
   * The terrority to which this peep is assigned.
   */
  territory: AccountSummaryFragment_territory | null;
  /**
   * The industry of this account
   */
  industry: AccountSummaryFragment_industry | null;
  /**
   * The type assigned to this account
   */
  accountType: AccountSummaryFragment_accountType;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The time this entity was deleted
   */
  deletedTime: any | null;
  /**
   * The user who created this peep.
   */
  creatorUser: AccountSummaryFragment_creatorUser | null;
  /**
   * Entity this account was merged with
   */
  mergedWith: AccountSummaryFragment_mergedWith | null;
  /**
   * The origin of the peep
   */
  origin: AccountSummaryFragment_origin;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: AccountSummaryFragment_owner | null;
  /**
   * Tag maps for the peep
   */
  tagMaps: AccountSummaryFragment_tagMaps | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CtCtActivity
// ====================================================

export interface CtCtActivity {
  __typename: "ConstantContactContactTrackingActivity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  createdTime: any;
  trackingActivityType: ConstantContactContactTrackingActivityType;
  campaignName: string | null;
  subject: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CtCtContact
// ====================================================

export interface CtCtContact_listMemberships {
  __typename: "ConstantContactList";
  id: string;
  name: string;
}

export interface CtCtContact_latestActivity {
  __typename: "ConstantContactContactTrackingActivity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  createdTime: any;
  trackingActivityType: ConstantContactContactTrackingActivityType;
  campaignName: string | null;
  subject: string | null;
}

export interface CtCtContact {
  __typename: "ConstantContactContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailAddress: string;
  status: ConstantContactContactStatus;
  openRate: number | null;
  clickRate: number | null;
  /**
   * The 0-5 Nutshell generated engagement rating for this contact
   */
  engagementRating: number | null;
  sendsCount: number;
  /**
   * The last time that constant contact tracking activities were fetched for this contact
   */
  lastActivitySyncTime: any | null;
  listMemberships: CtCtContact_listMemberships[];
  latestActivity: CtCtContact_latestActivity | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContactDuplicateDetailsFragment
// ====================================================

export interface ContactDuplicateDetailsFragment_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ContactDuplicateDetailsFragment_primaryAccount_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface ContactDuplicateDetailsFragment_primaryAccount {
  __typename: "ContactAccountsEdge";
  node: ContactDuplicateDetailsFragment_primaryAccount_node;
}

export interface ContactDuplicateDetailsFragment_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The full printable address of this location
   */
  fullPrintableAddress: string | null;
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
}

export interface ContactDuplicateDetailsFragment_postalAddresses_primary {
  __typename: "PostalAddress";
  id: string;
  location: ContactDuplicateDetailsFragment_postalAddresses_primary_location;
}

export interface ContactDuplicateDetailsFragment_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: ContactDuplicateDetailsFragment_postalAddresses_primary | null;
}

export interface ContactDuplicateDetailsFragment_leads {
  __typename: "PeepLeadsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface ContactDuplicateDetailsFragment {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The primary email address for this contact
   */
  primaryEmailAddress: string | null;
  /**
   * The primary phone number for this peep
   */
  primaryPhoneNumber: string | null;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: ContactDuplicateDetailsFragment_owner | null;
  /**
   * The time this peep was last modified.
   */
  modifiedTime: any | null;
  /**
   * The primary account edge for this contact
   */
  primaryAccount: ContactDuplicateDetailsFragment_primaryAccount | null;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: ContactDuplicateDetailsFragment_postalAddresses;
  /**
   * Leads related to this peep
   */
  leads: ContactDuplicateDetailsFragment_leads;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContactDuplicateFragment
// ====================================================

export interface ContactDuplicateFragment {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether this peep has duplicates
   */
  hasDuplicates: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContactLastContactedTimeFragment
// ====================================================

export interface ContactLastContactedTimeFragment {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The most recent date this entity was contacted by anyone in Nutshell
   */
  lastContactedTime: any | null;
  /**
   * The most recent date this entity was contacted by the active user
   */
  myLastContactedTime: any | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContactPageFragment
// ====================================================

export interface ContactPageFragment_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface ContactPageFragment_creatorUser_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface ContactPageFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  firstName: string | null;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
  teams: ContactPageFragment_creatorUser_teams[];
}

export interface ContactPageFragment_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ContactPageFragment_primaryAccount_node_postalAddresses_primary_location_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface ContactPageFragment_primaryAccount_node_postalAddresses_primary_location_weather {
  __typename: "Weather";
  temperature: string | null;
  condition: string | null;
  location: string | null;
  localTime: string | null;
}

export interface ContactPageFragment_primaryAccount_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
  coordinates: ContactPageFragment_primaryAccount_node_postalAddresses_primary_location_coordinates | null;
  weather: ContactPageFragment_primaryAccount_node_postalAddresses_primary_location_weather | null;
}

export interface ContactPageFragment_primaryAccount_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: ContactPageFragment_primaryAccount_node_postalAddresses_primary_location;
}

export interface ContactPageFragment_primaryAccount_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: ContactPageFragment_primaryAccount_node_postalAddresses_primary | null;
}

export interface ContactPageFragment_primaryAccount_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: ContactPageFragment_primaryAccount_node_postalAddresses;
}

export interface ContactPageFragment_primaryAccount {
  __typename: "ContactAccountsEdge";
  /**
   * The one-off short note that users can write on this contact->account relationship.
   */
  relationshipNote: string | null;
  node: ContactPageFragment_primaryAccount_node;
}

export interface ContactPageFragment_leads {
  __typename: "PeepLeadsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface ContactPageFragment_workspaceWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface ContactPageFragment_sidebarWidgets {
  __typename: "OtherWidget" | "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  isDisabledByAdmin: boolean;
}

export interface ContactPageFragment_headerFields {
  __typename: "HeaderField";
  /**
   * The type of the header field
   */
  type: HeaderFieldType;
  /**
   * Whether the header field is enabled
   */
  isEnabled: boolean;
  /**
   * The name of the header field
   */
  name: string;
}

export interface ContactPageFragment_postalAddresses_primary_location_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface ContactPageFragment_postalAddresses_primary_location_weather {
  __typename: "Weather";
  temperature: string | null;
  condition: string | null;
  location: string | null;
  localTime: string | null;
}

export interface ContactPageFragment_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The full printable address of this location
   */
  fullPrintableAddress: string | null;
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
  coordinates: ContactPageFragment_postalAddresses_primary_location_coordinates | null;
  weather: ContactPageFragment_postalAddresses_primary_location_weather | null;
}

export interface ContactPageFragment_postalAddresses_primary {
  __typename: "PostalAddress";
  location: ContactPageFragment_postalAddresses_primary_location;
}

export interface ContactPageFragment_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: ContactPageFragment_postalAddresses_primary | null;
}

export interface ContactPageFragment_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ContactPageFragment_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: ContactPageFragment_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface ContactPageFragment_tagMaps_edges {
  __typename: "TagMapsEdge";
  node: ContactPageFragment_tagMaps_edges_node | null;
}

export interface ContactPageFragment_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * A list of edges.
   */
  edges: ContactPageFragment_tagMaps_edges[];
}

export interface ContactPageFragment {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this entity deleted
   */
  isDeleted: boolean;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  avatarUrl: string;
  hasUploadedAvatar: boolean;
  canDeleteAvatar: boolean;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The terrority to which this peep is assigned.
   */
  territory: ContactPageFragment_territory | null;
  /**
   * The user who created this peep.
   */
  creatorUser: ContactPageFragment_creatorUser | null;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: ContactPageFragment_owner | null;
  /**
   * The primary account edge for this contact
   */
  primaryAccount: ContactPageFragment_primaryAccount | null;
  /**
   * Leads related to this peep
   */
  leads: ContactPageFragment_leads;
  /**
   * The widgets of the stageset lead workspace
   */
  workspaceWidgets: ContactPageFragment_workspaceWidgets[];
  /**
   * The widgets of the stageset lead sidebar
   */
  sidebarWidgets: ContactPageFragment_sidebarWidgets[];
  /**
   * The header fields for the entity type
   */
  headerFields: ContactPageFragment_headerFields[];
  /**
   * The postal addresses of the peep
   */
  postalAddresses: ContactPageFragment_postalAddresses;
  /**
   * Tag maps for the peep
   */
  tagMaps: ContactPageFragment_tagMaps | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContactPrimaryAccountFragment
// ====================================================

export interface ContactPrimaryAccountFragment_node_postalAddresses_primary_location_coordinates {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

export interface ContactPrimaryAccountFragment_node_postalAddresses_primary_location_weather {
  __typename: "Weather";
  temperature: string | null;
  condition: string | null;
  location: string | null;
  localTime: string | null;
}

export interface ContactPrimaryAccountFragment_node_postalAddresses_primary_location {
  __typename: "Location";
  /**
   * The formatted address of this location
   */
  formattedAddress: string | null;
  coordinates: ContactPrimaryAccountFragment_node_postalAddresses_primary_location_coordinates | null;
  weather: ContactPrimaryAccountFragment_node_postalAddresses_primary_location_weather | null;
}

export interface ContactPrimaryAccountFragment_node_postalAddresses_primary {
  __typename: "PostalAddress";
  location: ContactPrimaryAccountFragment_node_postalAddresses_primary_location;
}

export interface ContactPrimaryAccountFragment_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: ContactPrimaryAccountFragment_node_postalAddresses_primary | null;
}

export interface ContactPrimaryAccountFragment_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: ContactPrimaryAccountFragment_node_postalAddresses;
}

export interface ContactPrimaryAccountFragment {
  __typename: "ContactAccountsEdge";
  /**
   * The one-off short note that users can write on this contact->account relationship.
   */
  relationshipNote: string | null;
  node: ContactPrimaryAccountFragment_node;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailDeliverabilityFragment
// ====================================================

export interface EmailDeliverabilityFragment_unsubscribeStats_userUnsubscribedBy {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EmailDeliverabilityFragment_unsubscribeStats {
  __typename: "UnsubscribeStats";
  /**
   * The time the email address was globally unsubscribed
   */
  unsubscribeTime: any;
  /**
   * The source of the unsubscribe
   */
  unsubscribeSource: UnsubscribeSource;
  /**
   * The Nutshell user who unsubscribed the email address, if applicable
   */
  userUnsubscribedBy: EmailDeliverabilityFragment_unsubscribeStats_userUnsubscribedBy | null;
}

export interface EmailDeliverabilityFragment {
  __typename: "DeliverabilityStatus";
  /**
   * The status of deliverability
   */
  status: EmailDeliverabilityStatusType;
  /**
   * The stats for an unsubscribe
   */
  unsubscribeStats: EmailDeliverabilityFragment_unsubscribeStats | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmsDeliverabilityFragment
// ====================================================

export interface SmsDeliverabilityFragment {
  __typename: "SmsDeliverabilityStatus";
  /**
   * The deliverability status of the phone number
   */
  status: SmsDeliverabilityStatusType;
  /**
   * The time the phone number was opted out of SMS solicitations
   */
  optOutTime: any | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContactAttachmentsFragment
// ====================================================

export interface ContactAttachmentsFragment_files_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface ContactAttachmentsFragment_files {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The href to view the file
   */
  viewHref: string;
  /**
   * Whether the file is viewable in the browser
   */
  viewableInBrowser: boolean;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The time the file was uploaded
   */
  uploadedTime: any | null;
  /**
   * The user who uploaded the file
   */
  creatorUser: ContactAttachmentsFragment_files_creatorUser | null;
}

export interface ContactAttachmentsFragment {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The files for this peep
   */
  files: ContactAttachmentsFragment_files[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AudienceWidgetFragment
// ====================================================

export interface AudienceWidgetFragment {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContactPageFormSubmissionFragment
// ====================================================

export interface ContactPageFormSubmissionFragment_formVersion_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface ContactPageFormSubmissionFragment_formVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent form of this form version
   */
  form: ContactPageFormSubmissionFragment_formVersion_form;
}

export interface ContactPageFormSubmissionFragment {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The url where the submission originates
   */
  submissionUrl: string;
  /**
   * The name of the submitted web form
   */
  formVersion: ContactPageFormSubmissionFragment_formVersion;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContactSummaryFragment
// ====================================================

export interface ContactSummaryFragment_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface ContactSummaryFragment_creatorUser_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface ContactSummaryFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  firstName: string | null;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
  teams: ContactSummaryFragment_creatorUser_teams[];
}

export interface ContactSummaryFragment_mergedWith {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface ContactSummaryFragment_origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  originType: OriginType;
  isInteresting: boolean;
  htmlUrl: string | null;
}

export interface ContactSummaryFragment_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ContactSummaryFragment_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: ContactSummaryFragment_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface ContactSummaryFragment_tagMaps_edges {
  __typename: "TagMapsEdge";
  node: ContactSummaryFragment_tagMaps_edges_node | null;
}

export interface ContactSummaryFragment_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * A list of edges.
   */
  edges: ContactSummaryFragment_tagMaps_edges[];
}

export interface ContactSummaryFragment {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The time this entity was deleted
   */
  deletedTime: any | null;
  /**
   * The terrority to which this peep is assigned.
   */
  territory: ContactSummaryFragment_territory | null;
  /**
   * The user who created this peep.
   */
  creatorUser: ContactSummaryFragment_creatorUser | null;
  /**
   * Entity this contact was merged with
   */
  mergedWith: ContactSummaryFragment_mergedWith | null;
  /**
   * The origin of the peep
   */
  origin: ContactSummaryFragment_origin;
  /**
   * Tag maps for the peep
   */
  tagMaps: ContactSummaryFragment_tagMaps | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BulkEditStatusFragment
// ====================================================

export interface BulkEditStatusFragment_config {
  __typename: "BulkEditConfig";
  numDuplicates: number;
}

export interface BulkEditStatusFragment {
  __typename: "BulkEdit";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  progress: number;
  /**
   * The status of the bulk edit
   */
  status: BulkEditStatus;
  config: BulkEditStatusFragment_config | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AudienceMembership
// ====================================================

export interface AudienceMembership_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
}

export interface AudienceMembership {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: AudienceMembership_audience;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContactAudienceMeberships
// ====================================================

export interface ContactAudienceMeberships_emailAddresses_all {
  __typename: "EmailAddressEav";
  id: string;
  name: string;
}

export interface ContactAudienceMeberships_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * An ordered collection of values
   */
  all: ContactAudienceMeberships_emailAddresses_all[];
}

export interface ContactAudienceMeberships_audienceMemberships_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
}

export interface ContactAudienceMeberships_audienceMemberships {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: ContactAudienceMeberships_audienceMemberships_audience;
}

export interface ContactAudienceMeberships_audienceMembershipsSubscribed_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
}

export interface ContactAudienceMeberships_audienceMembershipsSubscribed {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: ContactAudienceMeberships_audienceMembershipsSubscribed_audience;
}

export interface ContactAudienceMeberships_audienceMembershipsUnsubscribed_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
  /**
   * Did this audience originate from WebFX?
   */
  isWebFX: boolean;
}

export interface ContactAudienceMeberships_audienceMembershipsUnsubscribed {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: ContactAudienceMeberships_audienceMembershipsUnsubscribed_audience;
}

export interface ContactAudienceMeberships {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * Boolean if the contact has unsubscribed from all marketing emails
   */
  hasUnsubscribedFromAllAudiences: boolean;
  /**
   * Source where the contact unsubscribed from all marketing emails
   */
  unsubscribedFromAllAudiencesSource: UnsubscribeSource | null;
  /**
   * Boolean if the contact has hard bounced
   */
  hasHardBounced: boolean;
  /**
   * The link for this contact to manage their email preferences
   */
  preferenceCenterLink: string | null;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: ContactAudienceMeberships_emailAddresses;
  /**
   * The current membership status of each audience this contact belongs to
   */
  audienceMemberships: ContactAudienceMeberships_audienceMemberships[];
  /**
   * The current membership status of each audience this contact belongs to
   */
  audienceMembershipsSubscribed: ContactAudienceMeberships_audienceMembershipsSubscribed[];
  /**
   * The current membership status of each audience this contact belongs to
   */
  audienceMembershipsUnsubscribed: ContactAudienceMeberships_audienceMembershipsUnsubscribed[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CoordinatesFragment
// ====================================================

export interface CoordinatesFragment {
  __typename: "Coordinates";
  latitude: string;
  longitude: string;
  accuracy: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CreatorUserFragment
// ====================================================

export interface CreatorUserFragment_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface CreatorUserFragment {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  firstName: string | null;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
  teams: CreatorUserFragment_teams[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LocationWeatherFragment
// ====================================================

export interface LocationWeatherFragment {
  __typename: "Weather";
  temperature: string | null;
  condition: string | null;
  location: string | null;
  localTime: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PeepLegacyIdFragment
// ====================================================

export interface PeepLegacyIdFragment {
  __typename: "Account" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The legacy ID for this peep
   */
  legacyId: string | null;
  /**
   * Whether the legacy ID field should be shown for this peep
   */
  shouldShowLegacyId: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PeepTagMapsFragment
// ====================================================

export interface PeepTagMapsFragment_tagMaps_edges_node_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface PeepTagMapsFragment_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
  /**
   * The creator of this tag
   */
  creator: PeepTagMapsFragment_tagMaps_edges_node_creator;
  /**
   * The DateTime that represents when the Tag was created
   */
  createdTime: any | null;
}

export interface PeepTagMapsFragment_tagMaps_edges {
  __typename: "TagMapsEdge";
  node: PeepTagMapsFragment_tagMaps_edges_node | null;
}

export interface PeepTagMapsFragment_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * A list of edges.
   */
  edges: PeepTagMapsFragment_tagMaps_edges[];
}

export interface PeepTagMapsFragment {
  __typename: "Account" | "Contact";
  /**
   * Tag maps for the peep
   */
  tagMaps: PeepTagMapsFragment_tagMaps | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PeepBusinessCardInfoFragment
// ====================================================

export interface PeepBusinessCardInfoFragment_emailAddresses_all_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface PeepBusinessCardInfoFragment_emailAddresses_all_deliverabilityStatus_unsubscribeStats_userUnsubscribedBy {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface PeepBusinessCardInfoFragment_emailAddresses_all_deliverabilityStatus_unsubscribeStats {
  __typename: "UnsubscribeStats";
  /**
   * The time the email address was globally unsubscribed
   */
  unsubscribeTime: any;
  /**
   * The source of the unsubscribe
   */
  unsubscribeSource: UnsubscribeSource;
  /**
   * The Nutshell user who unsubscribed the email address, if applicable
   */
  userUnsubscribedBy: PeepBusinessCardInfoFragment_emailAddresses_all_deliverabilityStatus_unsubscribeStats_userUnsubscribedBy | null;
}

export interface PeepBusinessCardInfoFragment_emailAddresses_all_deliverabilityStatus {
  __typename: "DeliverabilityStatus";
  /**
   * The status of deliverability
   */
  status: EmailDeliverabilityStatusType;
  /**
   * The stats for an unsubscribe
   */
  unsubscribeStats: PeepBusinessCardInfoFragment_emailAddresses_all_deliverabilityStatus_unsubscribeStats | null;
}

export interface PeepBusinessCardInfoFragment_emailAddresses_all {
  __typename: "EmailAddressEav";
  id: string;
  name: string;
  isPrimary: boolean;
  isFormer: boolean;
  value: PeepBusinessCardInfoFragment_emailAddresses_all_value;
  deliverabilityStatus: PeepBusinessCardInfoFragment_emailAddresses_all_deliverabilityStatus;
}

export interface PeepBusinessCardInfoFragment_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * An ordered collection of values
   */
  all: PeepBusinessCardInfoFragment_emailAddresses_all[];
}

export interface PeepBusinessCardInfoFragment_phones_all_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number with country code.
   */
  numberFormattedWithCountryCode: string | null;
}

export interface PeepBusinessCardInfoFragment_phones_all_deliverabilityStatus {
  __typename: "SmsDeliverabilityStatus";
  /**
   * The deliverability status of the phone number
   */
  status: SmsDeliverabilityStatusType;
  /**
   * The time the phone number was opted out of SMS solicitations
   */
  optOutTime: any | null;
}

export interface PeepBusinessCardInfoFragment_phones_all {
  __typename: "Phone";
  id: string;
  name: string;
  isPrimary: boolean;
  isFormer: boolean;
  value: PeepBusinessCardInfoFragment_phones_all_value;
  deliverabilityStatus: PeepBusinessCardInfoFragment_phones_all_deliverabilityStatus;
}

export interface PeepBusinessCardInfoFragment_phones {
  __typename: "PhonesConnection";
  /**
   * An ordered collection of values
   */
  all: PeepBusinessCardInfoFragment_phones_all[];
}

export interface PeepBusinessCardInfoFragment_postalAddresses_all_location {
  __typename: "Location";
  /**
   * The full printable address of this location
   */
  fullPrintableAddress: string | null;
  /**
   * Street address
   */
  address_1: string | null;
  /**
   * Street address, continued
   */
  address_2: string | null;
  /**
   * Street address, continued
   */
  address_3: string | null;
  /**
   * City of this address
   */
  city: string | null;
  /**
   * [ISO 3166-2](https:         // en.wikipedia.org/wiki/ISO_3166-2) state code of this address
   */
  state: string | null;
  /**
   * Postal/zip code of this address
   */
  postal_code: string | null;
  /**
   * [ISO 3166-1 alpha-2](https: // en.wikipedia.org/wiki/ISO_3166-1_alpha-2) country code of this address
   */
  country: string | null;
}

export interface PeepBusinessCardInfoFragment_postalAddresses_all {
  __typename: "PostalAddress";
  id: string;
  name: string;
  isPrimary: boolean;
  isFormer: boolean;
  location: PeepBusinessCardInfoFragment_postalAddresses_all_location;
}

export interface PeepBusinessCardInfoFragment_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * An ordered collection of values
   */
  all: PeepBusinessCardInfoFragment_postalAddresses_all[];
}

export interface PeepBusinessCardInfoFragment_urls_all {
  __typename: "URL";
  id: string;
  name: string;
  value: string | null;
  isPrimary: boolean;
  /**
   * User-friendly display text for this URL, such as `@handle` for Twitter profiles.
   */
  displayValue: string;
  /**
   * Recognized social platform based on the URL host. Null for non-social URLs.
   */
  socialPlatform: SocialPlatform | null;
}

export interface PeepBusinessCardInfoFragment_urls {
  __typename: "UrlsConnection";
  /**
   * An ordered collection of values
   */
  all: PeepBusinessCardInfoFragment_urls_all[];
}

export interface PeepBusinessCardInfoFragment {
  __typename: "Account" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The paging collection of email addresses for this peep.
   */
  emailAddresses: PeepBusinessCardInfoFragment_emailAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: PeepBusinessCardInfoFragment_phones;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: PeepBusinessCardInfoFragment_postalAddresses;
  /**
   * The paging collection of URLs.
   */
  urls: PeepBusinessCardInfoFragment_urls;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PeepLabelOptionsFragment
// ====================================================

export interface PeepLabelOptionsFragment {
  __typename: "PeepLabelOptions";
  phones: string[];
  emailAddresses: string[];
  postalAddresses: string[];
  urls: string[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PeepRelatedLeadFragment
// ====================================================

export interface PeepRelatedLeadFragment_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface PeepRelatedLeadFragment_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface PeepRelatedLeadFragment_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: PeepRelatedLeadFragment_contacts_primaryEdge_node;
}

export interface PeepRelatedLeadFragment_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: PeepRelatedLeadFragment_contacts_primaryEdge | null;
}

export interface PeepRelatedLeadFragment_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface PeepRelatedLeadFragment_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: PeepRelatedLeadFragment_accounts_primaryEdge_node;
}

export interface PeepRelatedLeadFragment_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: PeepRelatedLeadFragment_accounts_primaryEdge | null;
}

export interface PeepRelatedLeadFragment_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface PeepRelatedLeadFragment {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  number: number | null;
  value: PeepRelatedLeadFragment_value | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  avatarUrl: string;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: PeepRelatedLeadFragment_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: PeepRelatedLeadFragment_accounts;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: PeepRelatedLeadFragment_assignee | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PeepRelatedLeadStatFragment
// ====================================================

export interface PeepRelatedLeadStatFragment_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface PeepRelatedLeadStatFragment_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: PeepRelatedLeadStatFragment_value_formattedValue;
}

export interface PeepRelatedLeadStatFragment {
  __typename: "LeadStat";
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  count: number;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  status: LeadStatus;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  value: PeepRelatedLeadStatFragment_value;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PeepRelatedLeadStatsFragment
// ====================================================

export interface PeepRelatedLeadStatsFragment_all_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface PeepRelatedLeadStatsFragment_all_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: PeepRelatedLeadStatsFragment_all_value_formattedValue;
}

export interface PeepRelatedLeadStatsFragment_all {
  __typename: "LeadStat";
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  count: number;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  status: LeadStatus;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  value: PeepRelatedLeadStatsFragment_all_value;
}

export interface PeepRelatedLeadStatsFragment_openAndPending_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface PeepRelatedLeadStatsFragment_openAndPending_value {
  __typename: "Money";
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: PeepRelatedLeadStatsFragment_openAndPending_value_formattedValue;
}

export interface PeepRelatedLeadStatsFragment_openAndPending {
  __typename: "LeadStat";
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  count: number;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  status: LeadStatus;
  /**
   * An enum of the current email health. Success, warning, or error. Null if email is not configured.
   */
  value: PeepRelatedLeadStatsFragment_openAndPending_value;
}

export interface PeepRelatedLeadStatsFragment {
  __typename: "LeadStats";
  /**
   * All the stats, boi
   */
  all: PeepRelatedLeadStatsFragment_all[];
  /**
   * The count and value of open and pending leads with a status of open
   */
  openAndPending: PeepRelatedLeadStatsFragment_openAndPending | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: McfxViqContactFragment
// ====================================================

export interface McfxViqContactFragment_contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface McfxViqContactFragment_contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: McfxViqContactFragment_contact_emailAddresses_primary_value;
}

export interface McfxViqContactFragment_contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: McfxViqContactFragment_contact_emailAddresses_primary | null;
}

export interface McfxViqContactFragment_contact_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface McfxViqContactFragment_contact_phones_primary {
  __typename: "Phone";
  value: McfxViqContactFragment_contact_phones_primary_value;
}

export interface McfxViqContactFragment_contact_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: McfxViqContactFragment_contact_phones_primary | null;
}

export interface McfxViqContactFragment_contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: McfxViqContactFragment_contact_emailAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: McfxViqContactFragment_contact_phones;
}

export interface McfxViqContactFragment {
  __typename: "McfxViqContact";
  /**
   * The (external) id for this Viq person
   */
  id: string;
  /**
   * The (external) id for this Viq person
   */
  fullName: string;
  /**
   * The job title of this Viq person
   */
  jobTitle: string | null;
  /**
   * The location of this Viq person
   */
  location: string | null;
  /**
   * The position of this Viq person
   */
  position: string | null;
  /**
   * Whether this Viq person has a valid email address
   */
  hasEmail: boolean;
  /**
   * Whether this Viq person has a valid phone number
   */
  hasPhone: boolean;
  /**
   * Whether this Viq person has a LinkedIn Url we know about
   */
  hasLinkedinUrl: boolean;
  /**
   * The Nutshell contact associated with this viq contact
   */
  contact: McfxViqContactFragment_contact | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PeopleIqFilterSettingsFragment
// ====================================================

export interface PeopleIqFilterSettingsFragment_contactInformationList_contactInformation {
  __typename: "ContactInformationDetail";
  /**
   * The enum value of this filter
   */
  id: ContactInformationType;
  /**
   * The name of this filter
   */
  name: string;
}

export interface PeopleIqFilterSettingsFragment_contactInformationList {
  __typename: "ContactInformationSetting";
  /**
   * The contact information that this setting relates to
   */
  contactInformation: PeopleIqFilterSettingsFragment_contactInformationList_contactInformation;
  /**
   * Whether this contact information should be ignored in Nutshell
   */
  isBlocked: boolean;
}

export interface PeopleIqFilterSettingsFragment_jobFieldList_jobField {
  __typename: "JobFieldDetail";
  /**
   * The enum value of this filter
   */
  id: JobFieldType;
  /**
   * The name of this filter
   */
  name: string;
}

export interface PeopleIqFilterSettingsFragment_jobFieldList {
  __typename: "JobFieldSetting";
  /**
   * The job field that this setting relates to
   */
  jobField: PeopleIqFilterSettingsFragment_jobFieldList_jobField;
  /**
   * Whether this job field should be ignored in Nutshell
   */
  isBlocked: boolean;
}

export interface PeopleIqFilterSettingsFragment_managementLevelList_managementLevel {
  __typename: "ManagementLevelDetail";
  /**
   * The enum value of this filter
   */
  id: ManagementLevelType;
  /**
   * The name of this filter
   */
  name: string;
}

export interface PeopleIqFilterSettingsFragment_managementLevelList {
  __typename: "ManagementLevelSetting";
  /**
   * The job field that this setting relates to
   */
  managementLevel: PeopleIqFilterSettingsFragment_managementLevelList_managementLevel;
  /**
   * Whether this job field should be ignored in Nutshell
   */
  isBlocked: boolean;
}

export interface PeopleIqFilterSettingsFragment {
  __typename: "FilterSettingsPayload";
  /**
   * The list of contact information to include in Nutshell
   */
  contactInformationList: PeopleIqFilterSettingsFragment_contactInformationList[];
  /**
   * The list of job fields to include in Nutshell
   */
  jobFieldList: PeopleIqFilterSettingsFragment_jobFieldList[];
  /**
   * The list of management levels to include in Nutshell
   */
  managementLevelList: PeopleIqFilterSettingsFragment_managementLevelList[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntitySummaryFragment
// ====================================================

export interface EntitySummaryFragment_EntitySummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface EntitySummaryFragment_LeadEntitySummary {
  __typename: "LeadEntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
  /**
   * Whether the lead context summary is valid
   */
  isValid: boolean;
  /**
   * The recap of the lead context summary
   */
  recap: string | null;
  /**
   * The next steps of the lead context summary
   */
  nextSteps: string[] | null;
  /**
   * Recap of the lead's most recent logged and scheduled activities. Null if the lead has none.
   */
  lastActivities: string | null;
  /**
   * Unanswered questions surfaced from emails, calls, and notes. Empty if none were found.
   */
  openQuestions: string[] | null;
  /**
   * Profile of the lead: conversation points, business context, and rapport notes. Null if there is not enough data.
   */
  dossier: string | null;
}

export interface EntitySummaryFragment_EntitySummaryLeadResearch_leadFitReasons {
  __typename: "LeadFitReason";
  /**
   * Concise headline explaining this factor (always visible)
   */
  text: string;
  sentiment: LeadResearchSentiment;
  /**
   * Supporting detail shown when expanded
   */
  body: string;
}

export interface EntitySummaryFragment_EntitySummaryLeadResearch_fields {
  __typename: "LeadResearchField";
  key: string;
  label: string;
  value: string;
}

export interface EntitySummaryFragment_EntitySummaryLeadResearch_companyOverview {
  __typename: "CompanyOverview";
  /**
   * One punchy sentence about the company (max 48 chars)
   */
  headline: string;
  /**
   * 1-2 sentences of key factual details
   */
  body: string;
}

export interface EntitySummaryFragment_EntitySummaryLeadResearch {
  __typename: "EntitySummaryLeadResearch";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
  leadFit: LeadFitScore;
  leadFitLabel: string;
  leadFitReasons: EntitySummaryFragment_EntitySummaryLeadResearch_leadFitReasons[];
  fields: EntitySummaryFragment_EntitySummaryLeadResearch_fields[];
  companyOverview: EntitySummaryFragment_EntitySummaryLeadResearch_companyOverview | null;
}

export type EntitySummaryFragment = EntitySummaryFragment_EntitySummary | EntitySummaryFragment_LeadEntitySummary | EntitySummaryFragment_EntitySummaryLeadResearch;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ChatbotReportAiMetricsFragment
// ====================================================

export interface ChatbotReportAiMetricsFragment_summary {
  __typename: "ChatbotReportSummary";
  performance: string | null;
  activity: string | null;
  impact: string | null;
}

export interface ChatbotReportAiMetricsFragment_sentimentBreakdown {
  __typename: "ChatbotReportSentimentBreakdown";
  goodPercent: number;
  badPercent: number;
  neutralPercent: number;
  goodSampleThreadIds: string[];
  badSampleThreadIds: string[];
  neutralSampleThreadIds: string[];
}

export interface ChatbotReportAiMetricsFragment_commonTopics {
  __typename: "ChatbotReportTopic";
  topic: string;
  threadIds: string[];
  threadCount: number;
}

export interface ChatbotReportAiMetricsFragment_frustrationTopics {
  __typename: "ChatbotReportTopic";
  topic: string;
  threadIds: string[];
  threadCount: number;
}

export interface ChatbotReportAiMetricsFragment_knowledgeGaps {
  __typename: "ChatbotReportKnowledgeGap";
  question: string;
  threadIds: string[];
  threadCount: number;
}

export interface ChatbotReportAiMetricsFragment_oddballThreads {
  __typename: "ChatbotReportOddballThread";
  topic: string;
  description: string;
  threadIds: string[];
  threadCount: number;
}

export interface ChatbotReportAiMetricsFragment {
  __typename: "ChatbotReportAIMetrics";
  summary: ChatbotReportAiMetricsFragment_summary | null;
  sentimentBreakdown: ChatbotReportAiMetricsFragment_sentimentBreakdown | null;
  askedForHumanPercent: number;
  commonTopics: ChatbotReportAiMetricsFragment_commonTopics[];
  frustrationTopics: ChatbotReportAiMetricsFragment_frustrationTopics[];
  knowledgeGaps: ChatbotReportAiMetricsFragment_knowledgeGaps[];
  oddballThreads: ChatbotReportAiMetricsFragment_oddballThreads[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ChatbotReportDbMetricsFragment
// ====================================================

export interface ChatbotReportDbMetricsFragment_topNudges {
  __typename: "ChatbotReportNudge";
  nudgeId: string;
  content: string;
  pageSlugs: string[];
  threadCount: number;
  threadIds: string[];
}

export interface ChatbotReportDbMetricsFragment {
  __typename: "ChatbotReportDbMetrics";
  visitorCount: number;
  conversationCount: number;
  visitorsFilledFormPercent: number;
  topNudges: ChatbotReportDbMetricsFragment_topNudges[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ReportViewFields
// ====================================================

export interface ReportViewFields_savedFilter {
  __typename: "SavedFilter";
  id: string;
}

export interface ReportViewFields {
  __typename: "ReportView";
  /**
   * The title of the report (saved filter name or description of filters)
   */
  title: string;
  /**
   * The subtitle of the report
   */
  subtitle: string;
  /**
   * The type of report (e.g., Sales, Activity, Forecast)
   */
  reportType: SavedFiltersReportType;
  /**
   * The time to display for the report on the frontend (last viewed time for
   * recently viewed reports, created time for saved reports)
   */
  displayTime: any;
  /**
   * The URL path to navigate to this report
   */
  htmlUrlPath: string;
  /**
   * The underlying saved filter if this is a saved report
   */
  savedFilter: ReportViewFields_savedFilter | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: StagesetWidgetsFragment
// ====================================================

export interface StagesetWidgetsFragment_workspaceWidgets_OtherWidget {
  __typename: "OtherWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  /**
   * Whether the widget is required
   */
  isRequired: boolean;
  /**
   * Whether the widget is editable
   */
  isEditable: boolean;
  isDisabledByAdmin: boolean;
}

export interface StagesetWidgetsFragment_workspaceWidgets_CustomCustomFieldsWidget_customCustomFields_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable type of the attribute
   */
  displayType: string;
}

export interface StagesetWidgetsFragment_workspaceWidgets_CustomCustomFieldsWidget_customCustomFields {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: StagesetWidgetsFragment_workspaceWidgets_CustomCustomFieldsWidget_customCustomFields_attribute;
}

export interface StagesetWidgetsFragment_workspaceWidgets_CustomCustomFieldsWidget {
  __typename: "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  /**
   * Whether the widget is required
   */
  isRequired: boolean;
  /**
   * Whether the widget is editable
   */
  isEditable: boolean;
  isDisabledByAdmin: boolean;
  /**
   * The custom fields of the widget that can be customized
   */
  customCustomFields: StagesetWidgetsFragment_workspaceWidgets_CustomCustomFieldsWidget_customCustomFields[];
}

export type StagesetWidgetsFragment_workspaceWidgets = StagesetWidgetsFragment_workspaceWidgets_OtherWidget | StagesetWidgetsFragment_workspaceWidgets_CustomCustomFieldsWidget;

export interface StagesetWidgetsFragment_sidebarWidgets_OtherWidget {
  __typename: "OtherWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  /**
   * Whether the widget is required
   */
  isRequired: boolean;
  /**
   * Whether the widget is editable
   */
  isEditable: boolean;
  isDisabledByAdmin: boolean;
}

export interface StagesetWidgetsFragment_sidebarWidgets_CustomCustomFieldsWidget_customCustomFields_attribute {
  __typename: "Attribute";
  /**
   * The name of the attribute
   */
  name: string;
  /**
   * The human readable type of the attribute
   */
  displayType: string;
}

export interface StagesetWidgetsFragment_sidebarWidgets_CustomCustomFieldsWidget_customCustomFields {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: StagesetWidgetsFragment_sidebarWidgets_CustomCustomFieldsWidget_customCustomFields_attribute;
}

export interface StagesetWidgetsFragment_sidebarWidgets_CustomCustomFieldsWidget {
  __typename: "CustomCustomFieldsWidget";
  /**
   * The API ID of the widget
   */
  id: string;
  /**
   * The name of the widget
   */
  name: string;
  /**
   * The type of the widget
   */
  type: WidgetType;
  /**
   * Whether the widget is collapsed for the current user
   */
  isCollapsedForUser: boolean;
  /**
   * Whether the widget is hidden
   */
  isHidden: boolean;
  /**
   * The location of the widget
   */
  location: WidgetLocation;
  /**
   * The position of the widget
   */
  position: number;
  /**
   * Whether the widget is required
   */
  isRequired: boolean;
  /**
   * Whether the widget is editable
   */
  isEditable: boolean;
  isDisabledByAdmin: boolean;
  /**
   * The custom fields of the widget that can be customized
   */
  customCustomFields: StagesetWidgetsFragment_sidebarWidgets_CustomCustomFieldsWidget_customCustomFields[];
}

export type StagesetWidgetsFragment_sidebarWidgets = StagesetWidgetsFragment_sidebarWidgets_OtherWidget | StagesetWidgetsFragment_sidebarWidgets_CustomCustomFieldsWidget;

export interface StagesetWidgetsFragment {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The widgets of the stageset lead workspace
   */
  workspaceWidgets: StagesetWidgetsFragment_workspaceWidgets[];
  /**
   * The widgets of the stageset lead sidebar
   */
  sidebarWidgets: StagesetWidgetsFragment_sidebarWidgets[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailAutomationSelect
// ====================================================

export interface EmailAutomationSelect {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AccountTypeAutomation
// ====================================================

export interface AccountTypeAutomation_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface AccountTypeAutomation {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: AccountTypeAutomation_accountType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SalesAutomationAssignable
// ====================================================

export interface SalesAutomationAssignable_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface SalesAutomationAssignable_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type SalesAutomationAssignable = SalesAutomationAssignable_Team | SalesAutomationAssignable_User;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: Condition
// ====================================================

export interface Condition_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface Condition_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface Condition_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface Condition_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface Condition_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface Condition_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface Condition_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type Condition_config_ConditionConfigEntityFilter_filter = Condition_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | Condition_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | Condition_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | Condition_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | Condition_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | Condition_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface Condition_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: Condition_config_ConditionConfigEntityFilter_filter;
}

export interface Condition_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type Condition_config = Condition_config_ConditionConfigAudience | Condition_config_ConditionConfigEntityFilter | Condition_config_ConditionConfigLink;

export interface Condition {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: Condition_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntityFilterFieldConfig
// ====================================================

export interface EntityFilterFieldConfig_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface EntityFilterFieldConfig_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface EntityFilterFieldConfig_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface EntityFilterFieldConfig_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface EntityFilterFieldConfig_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface EntityFilterFieldConfig_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type EntityFilterFieldConfig = EntityFilterFieldConfig_EntityFilterFieldConfigBoolean | EntityFilterFieldConfig_EntityFilterFieldConfigCurrency | EntityFilterFieldConfig_EntityFilterFieldConfigRelationship | EntityFilterFieldConfig_EntityFilterFieldConfigString | EntityFilterFieldConfig_EntityFilterFieldConfigEnum | EntityFilterFieldConfig_EntityFilterFieldConfigIsSet;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SalesAutomationClosedLeadAutomation
// ====================================================

export interface SalesAutomationClosedLeadAutomation_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface SalesAutomationClosedLeadAutomation_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SalesAutomationClosedLeadAutomation_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface SalesAutomationClosedLeadAutomation_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type SalesAutomationClosedLeadAutomation_followupLeadAutomations_assigneeOrRule = SalesAutomationClosedLeadAutomation_followupLeadAutomations_assigneeOrRule_User | SalesAutomationClosedLeadAutomation_followupLeadAutomations_assigneeOrRule_Team | SalesAutomationClosedLeadAutomation_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface SalesAutomationClosedLeadAutomation_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface SalesAutomationClosedLeadAutomation_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: SalesAutomationClosedLeadAutomation_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: SalesAutomationClosedLeadAutomation_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: SalesAutomationClosedLeadAutomation_followupLeadAutomations_tags[];
}

export interface SalesAutomationClosedLeadAutomation_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SalesAutomationClosedLeadAutomation_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: SalesAutomationClosedLeadAutomation_tagAutomations_tags[];
}

export interface SalesAutomationClosedLeadAutomation_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface SalesAutomationClosedLeadAutomation_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface SalesAutomationClosedLeadAutomation_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type SalesAutomationClosedLeadAutomation_taskTemplates_assignee = SalesAutomationClosedLeadAutomation_taskTemplates_assignee_Team | SalesAutomationClosedLeadAutomation_taskTemplates_assignee_User;

export interface SalesAutomationClosedLeadAutomation_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: SalesAutomationClosedLeadAutomation_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: SalesAutomationClosedLeadAutomation_taskTemplates_assignee | null;
}

export interface SalesAutomationClosedLeadAutomation_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface SalesAutomationClosedLeadAutomation_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: SalesAutomationClosedLeadAutomation_emailAutomations_emailList | null;
}

export interface SalesAutomationClosedLeadAutomation_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface SalesAutomationClosedLeadAutomation_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface SalesAutomationClosedLeadAutomation_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface SalesAutomationClosedLeadAutomation_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface SalesAutomationClosedLeadAutomation_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface SalesAutomationClosedLeadAutomation_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface SalesAutomationClosedLeadAutomation_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type SalesAutomationClosedLeadAutomation_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = SalesAutomationClosedLeadAutomation_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | SalesAutomationClosedLeadAutomation_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | SalesAutomationClosedLeadAutomation_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | SalesAutomationClosedLeadAutomation_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | SalesAutomationClosedLeadAutomation_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | SalesAutomationClosedLeadAutomation_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface SalesAutomationClosedLeadAutomation_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: SalesAutomationClosedLeadAutomation_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface SalesAutomationClosedLeadAutomation_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type SalesAutomationClosedLeadAutomation_slackAutomations_conditions_config = SalesAutomationClosedLeadAutomation_slackAutomations_conditions_config_ConditionConfigAudience | SalesAutomationClosedLeadAutomation_slackAutomations_conditions_config_ConditionConfigEntityFilter | SalesAutomationClosedLeadAutomation_slackAutomations_conditions_config_ConditionConfigLink;

export interface SalesAutomationClosedLeadAutomation_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: SalesAutomationClosedLeadAutomation_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface SalesAutomationClosedLeadAutomation_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface SalesAutomationClosedLeadAutomation_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: SalesAutomationClosedLeadAutomation_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: SalesAutomationClosedLeadAutomation_slackAutomations_slackChannel | null;
}

export interface SalesAutomationClosedLeadAutomation_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface SalesAutomationClosedLeadAutomation_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: SalesAutomationClosedLeadAutomation_accountTypeAutomations_accountType;
}

export interface SalesAutomationClosedLeadAutomation_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface SalesAutomationClosedLeadAutomation_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface SalesAutomationClosedLeadAutomation_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: SalesAutomationClosedLeadAutomation_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: SalesAutomationClosedLeadAutomation_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface SalesAutomationClosedLeadAutomation_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface SalesAutomationClosedLeadAutomation_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface SalesAutomationClosedLeadAutomation_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: SalesAutomationClosedLeadAutomation_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: SalesAutomationClosedLeadAutomation_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type SalesAutomationClosedLeadAutomation_nutshellMarketingStartTriggers_campaign = SalesAutomationClosedLeadAutomation_nutshellMarketingStartTriggers_campaign_Campaign | SalesAutomationClosedLeadAutomation_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface SalesAutomationClosedLeadAutomation_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: SalesAutomationClosedLeadAutomation_nutshellMarketingStartTriggers_campaign;
}

export interface SalesAutomationClosedLeadAutomation {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: SalesAutomationClosedLeadAutomation_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: SalesAutomationClosedLeadAutomation_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: SalesAutomationClosedLeadAutomation_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: SalesAutomationClosedLeadAutomation_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: SalesAutomationClosedLeadAutomation_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: SalesAutomationClosedLeadAutomation_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: SalesAutomationClosedLeadAutomation_nutshellMarketingStartTriggers[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ClosedLeadEmailAutomation
// ====================================================

export interface ClosedLeadEmailAutomation_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface ClosedLeadEmailAutomation {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: ClosedLeadEmailAutomation_emailList | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ClosedLeadSlackMessage
// ====================================================

export interface ClosedLeadSlackMessage_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface ClosedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface ClosedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface ClosedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface ClosedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface ClosedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface ClosedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type ClosedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter = ClosedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | ClosedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | ClosedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | ClosedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | ClosedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | ClosedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface ClosedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: ClosedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface ClosedLeadSlackMessage_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type ClosedLeadSlackMessage_conditions_config = ClosedLeadSlackMessage_conditions_config_ConditionConfigAudience | ClosedLeadSlackMessage_conditions_config_ConditionConfigEntityFilter | ClosedLeadSlackMessage_conditions_config_ConditionConfigLink;

export interface ClosedLeadSlackMessage_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: ClosedLeadSlackMessage_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface ClosedLeadSlackMessage_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface ClosedLeadSlackMessage {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: ClosedLeadSlackMessage_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: ClosedLeadSlackMessage_slackChannel | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailAutomation
// ====================================================

export interface EmailAutomation_emailList_MailChimpList {
  __typename: "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface EmailAutomation_emailList_ConstantContactList {
  __typename: "ConstantContactList";
  /**
   * The id of the list.
   */
  id: string;
  name: string;
}

export interface EmailAutomation_emailList_EmailSequenceTemplate_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EmailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages {
  __typename: "EmailSequenceTemplateMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailAutomation_emailList_EmailSequenceTemplate {
  __typename: "EmailSequenceTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  creatorUser: EmailAutomation_emailList_EmailSequenceTemplate_creatorUser;
  createdTime: any | null;
  emailSequenceTemplateMessages: EmailAutomation_emailList_EmailSequenceTemplate_emailSequenceTemplateMessages[];
  /**
   * The url pathname to the edit modal for the email template
   */
  htmlUrlPath: string;
  /**
   * Whether the template has custom placeholders
   */
  hasCustomPlaceholders: boolean;
}

export type EmailAutomation_emailList = EmailAutomation_emailList_MailChimpList | EmailAutomation_emailList_ConstantContactList | EmailAutomation_emailList_EmailSequenceTemplate;

export interface EmailAutomation_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
}

export interface EmailAutomation_exitsStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface EmailAutomation_sendFromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EmailAutomation_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface EmailAutomation {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: EmailAutomation_emailList | null;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: EmailAutomation_entersStage;
  /**
   * The stage in which this stage subscription ends.
   */
  exitsStage: EmailAutomation_exitsStage | null;
  /**
   * The user that automated email sequences should be sent from, or null if sent from the lead assignee
   */
  sendFromUser: EmailAutomation_sendFromUser | null;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: EmailAutomation_delay | null;
  /**
   * The unix timestamp of when this stage subscription was created
   */
  createdTime: any;
  /**
   * Number of stages a EmailAutomation spans. If a subscription has no exit stage,
   * we count the last stage in the stageset as the "exit stage" for this count.
   */
  numberOfStagesSpanned: number;
  /**
   * Indicates if a lead should receive emails from this subscription until it closes.
   */
  sendUntilClose: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: GoalField
// ====================================================

export interface GoalField_FieldPhone {
  __typename: "FieldPhone" | "FieldString" | "FieldLocation" | "FieldBoolean" | "FieldCurrency" | "FieldDateTime" | "FieldInteger" | "FieldRelationship" | "FieldStrings" | "FieldText";
  /**
   * The internal name of the field
   */
  name: string;
  /**
   * The type of the field (string, date-time, etc)
   */
  type: EntityFieldType;
  /**
   * The filter title of the field
   */
  filterTitle: string;
}

export interface GoalField_FieldEnum {
  __typename: "FieldEnum";
  /**
   * The internal name of the field
   */
  name: string;
  /**
   * The type of the field (string, date-time, etc)
   */
  type: EntityFieldType;
  /**
   * The filter title of the field
   */
  filterTitle: string;
  /**
   * The possible options allowed for this enum type
   */
  options: string[];
}

export type GoalField = GoalField_FieldPhone | GoalField_FieldEnum;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadDistributionAutomation
// ====================================================

export interface LeadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface LeadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface LeadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface LeadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface LeadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type LeadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = LeadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | LeadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | LeadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | LeadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface LeadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: LeadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface LeadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type LeadDistributionAutomation_conditions_config = LeadDistributionAutomation_conditions_config_ConditionConfigAudience | LeadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | LeadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface LeadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: LeadDistributionAutomation_conditions_config;
}

export interface LeadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: LeadDistributionAutomation_conditions[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: NutshellMarketingStartTriggerFragment
// ====================================================

export interface NutshellMarketingStartTriggerFragment_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface NutshellMarketingStartTriggerFragment_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface NutshellMarketingStartTriggerFragment_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: NutshellMarketingStartTriggerFragment_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: NutshellMarketingStartTriggerFragment_campaign_Campaign_goal | null;
}

export interface NutshellMarketingStartTriggerFragment_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface NutshellMarketingStartTriggerFragment_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface NutshellMarketingStartTriggerFragment_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: NutshellMarketingStartTriggerFragment_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: NutshellMarketingStartTriggerFragment_campaign_SmsCampaign_goal | null;
}

export type NutshellMarketingStartTriggerFragment_campaign = NutshellMarketingStartTriggerFragment_campaign_Campaign | NutshellMarketingStartTriggerFragment_campaign_SmsCampaign;

export interface NutshellMarketingStartTriggerFragment {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: NutshellMarketingStartTriggerFragment_campaign;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SlackMessageAutomation
// ====================================================

export interface SlackMessageAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface SlackMessageAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface SlackMessageAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface SlackMessageAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface SlackMessageAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface SlackMessageAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface SlackMessageAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type SlackMessageAutomation_conditions_config_ConditionConfigEntityFilter_filter = SlackMessageAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | SlackMessageAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | SlackMessageAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | SlackMessageAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | SlackMessageAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | SlackMessageAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface SlackMessageAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: SlackMessageAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface SlackMessageAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type SlackMessageAutomation_conditions_config = SlackMessageAutomation_conditions_config_ConditionConfigAudience | SlackMessageAutomation_conditions_config_ConditionConfigEntityFilter | SlackMessageAutomation_conditions_config_ConditionConfigLink;

export interface SlackMessageAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: SlackMessageAutomation_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface SlackMessageAutomation_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface SlackMessageAutomation {
  __typename: "SlackMessageAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to activate this slack message automation.
   */
  conditions: SlackMessageAutomation_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: SlackMessageAutomation_slackChannel | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SalesAutomationStageGoal
// ====================================================

export interface SalesAutomationStageGoal_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface SalesAutomationStageGoal_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface SalesAutomationStageGoal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface SalesAutomationStageGoal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface SalesAutomationStageGoal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface SalesAutomationStageGoal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface SalesAutomationStageGoal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface SalesAutomationStageGoal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type SalesAutomationStageGoal_conditions_config_ConditionConfigEntityFilter_filter = SalesAutomationStageGoal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | SalesAutomationStageGoal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | SalesAutomationStageGoal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | SalesAutomationStageGoal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | SalesAutomationStageGoal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | SalesAutomationStageGoal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface SalesAutomationStageGoal_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: SalesAutomationStageGoal_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface SalesAutomationStageGoal_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type SalesAutomationStageGoal_conditions_config = SalesAutomationStageGoal_conditions_config_ConditionConfigAudience | SalesAutomationStageGoal_conditions_config_ConditionConfigEntityFilter | SalesAutomationStageGoal_conditions_config_ConditionConfigLink;

export interface SalesAutomationStageGoal_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: SalesAutomationStageGoal_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface SalesAutomationStageGoal {
  __typename: "Goal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of goal. This is strictly used for UI purposes, and is inferred from the goal’s conditions
   */
  goalType: GoalType;
  /**
   * The associated stage for this goal.
   */
  stage: SalesAutomationStageGoal_stage;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this goal. This is essentially just the stringified
   * version of the goal’s conditions, but because a goal can have multiple
   * conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * A list of conditions which must be true to activate this goal.
   */
  conditions: SalesAutomationStageGoal_conditions[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SalesAutomationStage
// ====================================================

export interface SalesAutomationStage_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface SalesAutomationStage_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface SalesAutomationStage_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SalesAutomationStage_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SalesAutomationStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: SalesAutomationStage_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: SalesAutomationStage_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: SalesAutomationStage_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: SalesAutomationStage_addTagAutomationTags[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SalesAutomationStageset
// ====================================================

export interface SalesAutomationStageset_modifiedUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SalesAutomationStageset_stages_overdueDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface SalesAutomationStageset_stages_autocloseDuration {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface SalesAutomationStageset_stages_autocloseOutcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SalesAutomationStageset_stages_addTagAutomationTags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SalesAutomationStageset_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
  /**
   * Maximum time leads should remain in this stage
   */
  overdueDuration: SalesAutomationStageset_stages_overdueDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseDuration: SalesAutomationStageset_stages_autocloseDuration | null;
  /**
   * Maximum time leads should remain in this stage before being autoclosed
   */
  autocloseOutcome: SalesAutomationStageset_stages_autocloseOutcome | null;
  /**
   * Tags that will be added to a lead when it enters this stage. Empty list means no add-tag automation is configured.
   */
  addTagAutomationTags: SalesAutomationStageset_stages_addTagAutomationTags[];
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule = SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_User | SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_Team | SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule_LeadAssigneeRule;

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations {
  __typename: "FollowupLeadAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The new stageset to put the cloned lead in.
   */
  newStageset: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_newStageset;
  /**
   * The assignee for the cloned lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_assigneeOrRule;
  /**
   * The tags to add to the cloned lead.
   */
  tags: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations_tags[];
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_tagAutomations {
  __typename: "ClosedLeadTagAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  entityType: ClosedLeadTagAutomationEntityType;
  tags: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_tagAutomations_tags[];
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee = SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_Team | SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee_User;

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_taskTemplates {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_taskTemplates_assignee | null;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter = SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config = SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigAudience | SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigEntityFilter | SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config_ConditionConfigLink;

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to send this slack message.
   */
  conditions: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations_slackChannel | null;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  editions: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign_goal | null;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions {
  __typename: "SmsDripEditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The type of campaign this is
   */
  type: CampaignType;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * The text for the drip sequence start trigger and delay, in the format `3 days after stage is entered`.
   */
  startTriggerDelayText: string | null;
  /**
   * The editions of the drip sequence
   */
  editions: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_editions;
  /**
   * The newly created Nutshell goal
   */
  goal: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign_goal | null;
}

export type SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign = SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_Campaign | SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign_SmsCampaign;

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The associated campaign for this startTrigger.
   */
  campaign: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers_campaign;
}

export interface SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Followup lead automations
   */
  followupLeadAutomations: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_followupLeadAutomations[];
  /**
   * Tag automations to apply to contacts or companies when a lead is closed
   */
  tagAutomations: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_tagAutomations[];
  /**
   * Tasks to be created when lead enters this outcome type
   */
  taskTemplates: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_taskTemplates[];
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_accountTypeAutomations[];
  /**
   * Returns a list start triggers for Nutshell Marketing drip sequences
   */
  nutshellMarketingStartTriggers: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations_nutshellMarketingStartTriggers[];
}

export interface SalesAutomationStageset_editableProcessTemplate {
  __typename: "EditableProcessTemplate";
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: SalesAutomationStageset_editableProcessTemplate_closedLeadAutomations[];
}

export interface SalesAutomationStageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface SalesAutomationStageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigEnum" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface SalesAutomationStageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface SalesAutomationStageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface SalesAutomationStageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export type SalesAutomationStageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter = SalesAutomationStageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | SalesAutomationStageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | SalesAutomationStageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | SalesAutomationStageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship;

export interface SalesAutomationStageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: SalesAutomationStageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface SalesAutomationStageset_leadDistributionAutomation_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type SalesAutomationStageset_leadDistributionAutomation_conditions_config = SalesAutomationStageset_leadDistributionAutomation_conditions_config_ConditionConfigAudience | SalesAutomationStageset_leadDistributionAutomation_conditions_config_ConditionConfigEntityFilter | SalesAutomationStageset_leadDistributionAutomation_conditions_config_ConditionConfigLink;

export interface SalesAutomationStageset_leadDistributionAutomation_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: SalesAutomationStageset_leadDistributionAutomation_conditions_config;
}

export interface SalesAutomationStageset_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * A list of conditions which must be true to activate this leadDistributionAutomation.
   */
  conditions: SalesAutomationStageset_leadDistributionAutomation_conditions[];
}

export interface SalesAutomationStageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The DateTime that represents when the Stageset record was modified
   */
  modifiedTime: any | null;
  /**
   * The User that last modified the Stageset
   */
  modifiedUser: SalesAutomationStageset_modifiedUser | null;
  /**
   * The stages associated with this stageset
   */
  stages: SalesAutomationStageset_stages[];
  /**
   * The editable process template associated with this stageset
   */
  editableProcessTemplate: SalesAutomationStageset_editableProcessTemplate;
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: SalesAutomationStageset_leadDistributionAutomation | null;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: StepTemplateDueDate
// ====================================================

export interface StepTemplateDueDate {
  __typename: "StepDueDate";
  /**
   * The reference point for this due date. This can include when the lead was created, when the stage was entered, etc.
   */
  dueFrom: number;
  /**
   * The unit to measure this step template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this step template’s due date. Is a number.
   */
  dueTimespan: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SalesAutomationStepTemplate
// ====================================================

export interface SalesAutomationStepTemplate_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SalesAutomationStepTemplate_dueDate {
  __typename: "StepDueDate";
  /**
   * The reference point for this due date. This can include when the lead was created, when the stage was entered, etc.
   */
  dueFrom: number;
  /**
   * The unit to measure this step template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this step template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface SalesAutomationStepTemplate_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface SalesAutomationStepTemplate_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type SalesAutomationStepTemplate_assignee = SalesAutomationStepTemplate_assignee_Team | SalesAutomationStepTemplate_assignee_User;

export interface SalesAutomationStepTemplate {
  __typename: "StepTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The name of the Nutshell StepTemplate.
   */
  name: string;
  /**
   * The description of the Nutshell StepTemplate.
   */
  description: string | null;
  /**
   * The stage/milestone within the pipeline that this step template lives within for our sales automation tool
   */
  stage: SalesAutomationStepTemplate_stage;
  /**
   * The rules to determine the due date for this step.
   */
  dueDate: SalesAutomationStepTemplate_dueDate | null;
  /**
   * The description of the Nutshell StepTemplate.
   */
  assignee: SalesAutomationStepTemplate_assignee | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: TaskTemplateDueDate
// ====================================================

export interface TaskTemplateDueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SalesAutomationTaskTemplate
// ====================================================

export interface SalesAutomationTaskTemplate_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface SalesAutomationTaskTemplate_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface SalesAutomationTaskTemplate_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type SalesAutomationTaskTemplate_assignee = SalesAutomationTaskTemplate_assignee_Team | SalesAutomationTaskTemplate_assignee_User;

export interface SalesAutomationTaskTemplate {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: SalesAutomationTaskTemplate_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: SalesAutomationTaskTemplate_assignee | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: StageSlackMessageData
// ====================================================

export interface StageSlackMessageData_editableSlackMessageAutomations_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface StageSlackMessageData_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface StageSlackMessageData_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface StageSlackMessageData_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface StageSlackMessageData_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface StageSlackMessageData_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface StageSlackMessageData_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type StageSlackMessageData_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter = StageSlackMessageData_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | StageSlackMessageData_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | StageSlackMessageData_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | StageSlackMessageData_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | StageSlackMessageData_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | StageSlackMessageData_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface StageSlackMessageData_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: StageSlackMessageData_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface StageSlackMessageData_editableSlackMessageAutomations_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type StageSlackMessageData_editableSlackMessageAutomations_conditions_config = StageSlackMessageData_editableSlackMessageAutomations_conditions_config_ConditionConfigAudience | StageSlackMessageData_editableSlackMessageAutomations_conditions_config_ConditionConfigEntityFilter | StageSlackMessageData_editableSlackMessageAutomations_conditions_config_ConditionConfigLink;

export interface StageSlackMessageData_editableSlackMessageAutomations_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: StageSlackMessageData_editableSlackMessageAutomations_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface StageSlackMessageData_editableSlackMessageAutomations_slackChannel {
  __typename: "SlackChannel";
  display: string;
  externalId: string;
  name: string;
}

export interface StageSlackMessageData_editableSlackMessageAutomations {
  __typename: "SlackMessageAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * A list of conditions which must be true to activate this slack message automation.
   */
  conditions: StageSlackMessageData_editableSlackMessageAutomations_conditions[];
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: StageSlackMessageData_editableSlackMessageAutomations_slackChannel | null;
}

export interface StageSlackMessageData {
  __typename: "Stage";
  /**
   * The list of slack message automations attached to this stage.
   */
  editableSlackMessageAutomations: StageSlackMessageData_editableSlackMessageAutomations[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: StageLeadUserAssignmentData
// ====================================================

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The DateTime that represents when the team record was deleted
   */
  deletedTime: any | null;
}

export type StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_assignee = StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_assignee_User | StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_assignee_Team;

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter = StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config = StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigAudience | StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigEntityFilter | StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config_ConditionConfigLink;

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate {
  __typename: "Predicate";
  /**
   * The conditions that must be true for this predicate to activate an automation.
   */
  conditions: StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate_conditions[];
}

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation {
  __typename: "StageLeadAssignmentAutomation";
  /**
   * Flag to determine if this automation should unassign the lead.
   */
  shouldUnassign: boolean;
  /**
   * If the assignee is a team, round robin will equally distribute leads to each member of the team.
   */
  shouldRoundRobin: boolean | null;
  /**
   * The assignee object for this lead assignment automation.
   */
  assignee: StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_assignee | null;
  /**
   * This automation's predicate.
   */
  predicate: StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation_predicate;
}

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The DateTime that represents when the team record was deleted
   */
  deletedTime: any | null;
}

export type StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_assignee = StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_assignee_User | StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_assignee_Team;

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter = StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config = StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigAudience | StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigEntityFilter | StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config_ConditionConfigLink;

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate {
  __typename: "Predicate";
  /**
   * The conditions that must be true for this predicate to activate an automation.
   */
  conditions: StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate_conditions[];
}

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations {
  __typename: "StageLeadAssignmentAutomation";
  /**
   * Flag to determine if this automation should unassign the lead.
   */
  shouldUnassign: boolean;
  /**
   * If the assignee is a team, round robin will equally distribute leads to each member of the team.
   */
  shouldRoundRobin: boolean | null;
  /**
   * The assignee object for this lead assignment automation.
   */
  assignee: StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_assignee | null;
  /**
   * This automation's predicate.
   */
  predicate: StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations_predicate;
}

export interface StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData {
  __typename: "StageLeadAssignmentAutomationData";
  /**
   * The global setting for this set of stage lead assignment automations saying whether reassignment is allowed.
   */
  stageLeadAssignmentAllowReassign: boolean;
  /**
   * The default automation that will be fired if all special cases fail to fire.
   */
  stageLeadAssignmentDefaultAutomation: StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentDefaultAutomation | null;
  /**
   * The nicely unpacked list of automations for this set of stage lead assignment automations.
   */
  stageLeadAssignmentAutomations: StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData_stageLeadAssignmentAutomations[];
}

export interface StageLeadUserAssignmentData {
  __typename: "Stage";
  /**
   * The object housing the list of editable stageLeadAssignmentAutomations and associated meta data for this stage.
   */
  editableStageLeadAssignmentAutomationData: StageLeadUserAssignmentData_editableStageLeadAssignmentAutomationData;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: StageLeadAssignmentAutomation
// ====================================================

export interface StageLeadAssignmentAutomation_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
}

export interface StageLeadAssignmentAutomation_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The DateTime that represents when the team record was deleted
   */
  deletedTime: any | null;
}

export type StageLeadAssignmentAutomation_assignee = StageLeadAssignmentAutomation_assignee_User | StageLeadAssignmentAutomation_assignee_Team;

export interface StageLeadAssignmentAutomation_predicate_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience" | "ConditionConfigTag" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface StageLeadAssignmentAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
}

export interface StageLeadAssignmentAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface StageLeadAssignmentAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface StageLeadAssignmentAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface StageLeadAssignmentAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
}

export interface StageLeadAssignmentAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type StageLeadAssignmentAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter = StageLeadAssignmentAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | StageLeadAssignmentAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | StageLeadAssignmentAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | StageLeadAssignmentAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | StageLeadAssignmentAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | StageLeadAssignmentAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface StageLeadAssignmentAutomation_predicate_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: StageLeadAssignmentAutomation_predicate_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface StageLeadAssignmentAutomation_predicate_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export type StageLeadAssignmentAutomation_predicate_conditions_config = StageLeadAssignmentAutomation_predicate_conditions_config_ConditionConfigAudience | StageLeadAssignmentAutomation_predicate_conditions_config_ConditionConfigEntityFilter | StageLeadAssignmentAutomation_predicate_conditions_config_ConditionConfigLink;

export interface StageLeadAssignmentAutomation_predicate_conditions {
  __typename: "Condition";
  /**
   * The configuration for this condition.
   */
  config: StageLeadAssignmentAutomation_predicate_conditions_config;
  /**
   * The human readable text of "what to do" for this condition
   */
  humanReadableObjectiveString: string;
}

export interface StageLeadAssignmentAutomation_predicate {
  __typename: "Predicate";
  /**
   * The conditions that must be true for this predicate to activate an automation.
   */
  conditions: StageLeadAssignmentAutomation_predicate_conditions[];
}

export interface StageLeadAssignmentAutomation {
  __typename: "StageLeadAssignmentAutomation";
  /**
   * Flag to determine if this automation should unassign the lead.
   */
  shouldUnassign: boolean;
  /**
   * If the assignee is a team, round robin will equally distribute leads to each member of the team.
   */
  shouldRoundRobin: boolean | null;
  /**
   * The assignee object for this lead assignment automation.
   */
  assignee: StageLeadAssignmentAutomation_assignee | null;
  /**
   * This automation's predicate.
   */
  predicate: StageLeadAssignmentAutomation_predicate;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: StagesetBasic
// ====================================================

export interface StagesetBasic_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The default confidence value of the stage.
   */
  defaultConfidence: number | null;
}

export interface StagesetBasic_leadDistributionAutomation {
  __typename: "LeadDistributionAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface StagesetBasic {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * If this stageset is the default or not
   */
  default: boolean;
  /**
   * The position of this stageset
   */
  position: number;
  /**
   * Can we delete this stageset? Default stagesets, stagesets with open leads
   * still in them, and stagesets with lead routes cannot be deleted
   */
  canDelete: boolean;
  /**
   * Can this pipeline be accessed? If a customer downgrades, non-default pipelines may become inaccessible
   */
  canAccess: boolean;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
  /**
   * The status of the stageset
   */
  status: StagesetStatus;
  /**
   * The stages associated with this stageset
   */
  stages: StagesetBasic_stages[];
  /**
   * The lead distribution rule that automatically place leads in this stageset
   */
  leadDistributionAutomation: StagesetBasic_leadDistributionAutomation | null;
  /**
   * The number of open leads in the stageset
   */
  numOfOpenLeads: number;
  /**
   * Who is allowed to view this stageset, its leads, and their contacts/accounts.
   */
  visibilityMode: StagesetVisibilityMode;
  /**
   * The number of enabled users who can view this stageset when visibilityMode is
   * RESTRICTED. Includes administrators. Returns null otherwise. Admin-only; null
   * for non-admins.
   */
  restrictedCanViewCount: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: StagesetVisibilityAssignable
// ====================================================

export interface StagesetVisibilityAssignable_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
}

export interface StagesetVisibilityAssignable_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The number of users affiliated with this team
   */
  numUsers: number;
}

export type StagesetVisibilityAssignable = StagesetVisibilityAssignable_User | StagesetVisibilityAssignable_Team;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: StagesetVisibility
// ====================================================

export interface StagesetVisibility_allowedViewers_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
  /**
   * The primary email address for this user
   */
  primaryEmailAddress: string | null;
}

export interface StagesetVisibility_allowedViewers_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The number of users affiliated with this team
   */
  numUsers: number;
}

export type StagesetVisibility_allowedViewers = StagesetVisibility_allowedViewers_User | StagesetVisibility_allowedViewers_Team;

export interface StagesetVisibility {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Who is allowed to view this stageset, its leads, and their contacts/accounts.
   */
  visibilityMode: StagesetVisibilityMode;
  /**
   * The number of enabled users who can view this stageset when visibilityMode is
   * RESTRICTED. Includes administrators. Returns null otherwise. Admin-only; null
   * for non-admins.
   */
  restrictedCanViewCount: number | null;
  /**
   * The users and teams allowed to view this stageset when visibilityMode is
   * RESTRICTED. Administrators always have access and are never included here.
   * Admin-only; empty for non-admins.
   */
  allowedViewers: StagesetVisibility_allowedViewers[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: TextAutomation
// ====================================================

export interface TextAutomation_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
}

export interface TextAutomation_sendFromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  initials: string;
  avatarUrl: string;
  name: string;
}

export interface TextAutomation_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface TextAutomation {
  __typename: "TextMessageAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Content of the text body.
   */
  content: string;
  position: number;
  /**
   * The associated stage for this text.
   */
  stage: TextAutomation_stage;
  /**
   * The user to assign the thread to and send messages from.
   */
  sendFromUser: TextAutomation_sendFromUser | null;
  /**
   * How long to wait before sending the text.
   */
  delay: TextAutomation_delay;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: TodoTemplateCard
// ====================================================

export interface TodoTemplateCard_StepTemplate_stage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface TodoTemplateCard_StepTemplate_dueDate {
  __typename: "StepDueDate";
  /**
   * The reference point for this due date. This can include when the lead was created, when the stage was entered, etc.
   */
  dueFrom: number;
  /**
   * The unit to measure this step template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this step template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface TodoTemplateCard_StepTemplate_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface TodoTemplateCard_StepTemplate_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type TodoTemplateCard_StepTemplate_assignee = TodoTemplateCard_StepTemplate_assignee_Team | TodoTemplateCard_StepTemplate_assignee_User;

export interface TodoTemplateCard_StepTemplate {
  __typename: "StepTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The name of the Nutshell StepTemplate.
   */
  name: string;
  /**
   * The description of the Nutshell StepTemplate.
   */
  description: string | null;
  /**
   * The stage/milestone within the pipeline that this step template lives within for our sales automation tool
   */
  stage: TodoTemplateCard_StepTemplate_stage;
  /**
   * The rules to determine the due date for this step.
   */
  dueDate: TodoTemplateCard_StepTemplate_dueDate | null;
  /**
   * The description of the Nutshell StepTemplate.
   */
  assignee: TodoTemplateCard_StepTemplate_assignee | null;
}

export interface TodoTemplateCard_ClosedLeadTaskTemplate_dueDate {
  __typename: "ClosedLeadTaskTemplateDueDate";
  /**
   * The unit to measure this task template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this task template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface TodoTemplateCard_ClosedLeadTaskTemplate_assignee_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface TodoTemplateCard_ClosedLeadTaskTemplate_assignee_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  avatarUrl: string;
  initials: string;
}

export type TodoTemplateCard_ClosedLeadTaskTemplate_assignee = TodoTemplateCard_ClosedLeadTaskTemplate_assignee_Team | TodoTemplateCard_ClosedLeadTaskTemplate_assignee_User;

export interface TodoTemplateCard_ClosedLeadTaskTemplate {
  __typename: "ClosedLeadTaskTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name task that will be created
   */
  name: string;
  /**
   * The description of the task that will be created.
   */
  description: string | null;
  /**
   * The rules to determine the due date for this task.
   */
  dueDate: TodoTemplateCard_ClosedLeadTaskTemplate_dueDate | null;
  /**
   * The assignee of the task that will be created.
   */
  assignee: TodoTemplateCard_ClosedLeadTaskTemplate_assignee | null;
}

export type TodoTemplateCard = TodoTemplateCard_StepTemplate | TodoTemplateCard_ClosedLeadTaskTemplate;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserQuotaFragment
// ====================================================

export interface UserQuotaFragment_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface UserQuotaFragment_quotas_months_value {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
}

export interface UserQuotaFragment_quotas_months {
  __typename: "Month";
  /**
   * The number of the month (1-12)
   */
  identifier: number;
  /**
   * The monetary total of the month
   */
  value: UserQuotaFragment_quotas_months_value;
}

export interface UserQuotaFragment_quotas {
  __typename: "Quota";
  /**
   * The fiscal year for the quota
   */
  fiscalYear: number;
  months: UserQuotaFragment_quotas_months[];
}

export interface UserQuotaFragment {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  teams: UserQuotaFragment_teams[];
  quotas: UserQuotaFragment_quotas[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AssignedUserFragment
// ====================================================

export interface AssignedUserFragment_emailAddresses {
  __typename: "UserEmail";
  /**
   * The address string of this email.
   */
  address: string;
}

export interface AssignedUserFragment {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * User emails configured for this user
   */
  emailAddresses: AssignedUserFragment_emailAddresses[];
  avatarUrl: string;
  initials: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ManagedMeetingFragment
// ====================================================

export interface ManagedMeetingFragment_assignments_edges_meetings_hosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ManagedMeetingFragment_assignments_edges_meetings_bookings {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface ManagedMeetingFragment_assignments_edges_meetings_validity {
  __typename: "MeetingValidity";
  /**
   * Whether this meeting can be booked
   */
  isBookable: boolean;
}

export interface ManagedMeetingFragment_assignments_edges_meetings {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The possible hosts of this meeting, team members for ROUND_ROBIN, set hosts for other types
   */
  hosts: ManagedMeetingFragment_assignments_edges_meetings_hosts[];
  /**
   * The bookings of this meeting
   */
  bookings: ManagedMeetingFragment_assignments_edges_meetings_bookings[];
  /**
   * Whether this meeting is severed from its template. Always false for non-managed meetings.
   */
  isSevered: boolean;
  /**
   * The DateTime that represents when the meeting was deleted
   */
  deletedTime: any | null;
  /**
   * The validity of this meeting
   */
  validity: ManagedMeetingFragment_assignments_edges_meetings_validity;
}

export interface ManagedMeetingFragment_assignments_edges_node_assigneeEntity_User_emailAddresses {
  __typename: "UserEmail";
  /**
   * The address string of this email.
   */
  address: string;
}

export interface ManagedMeetingFragment_assignments_edges_node_assigneeEntity_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * User emails configured for this user
   */
  emailAddresses: ManagedMeetingFragment_assignments_edges_node_assigneeEntity_User_emailAddresses[];
  avatarUrl: string;
  initials: string;
}

export interface ManagedMeetingFragment_assignments_edges_node_assigneeEntity_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
  /**
   * The number of users affiliated with this team
   */
  numUsers: number;
}

export type ManagedMeetingFragment_assignments_edges_node_assigneeEntity = ManagedMeetingFragment_assignments_edges_node_assigneeEntity_User | ManagedMeetingFragment_assignments_edges_node_assigneeEntity_Team;

export interface ManagedMeetingFragment_assignments_edges_node {
  __typename: "Assignment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity to which the assignment was made
   */
  assigneeEntity: ManagedMeetingFragment_assignments_edges_node_assigneeEntity;
}

export interface ManagedMeetingFragment_assignments_edges {
  __typename: "MaterializedMeetingsEdge";
  /**
   * The materialized meetings.
   */
  meetings: ManagedMeetingFragment_assignments_edges_meetings[];
  node: ManagedMeetingFragment_assignments_edges_node;
}

export interface ManagedMeetingFragment_assignments {
  __typename: "MaterializedMeetingsConnection";
  /**
   * A list of edges.
   */
  edges: ManagedMeetingFragment_assignments_edges[];
}

export interface ManagedMeetingFragment {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The users or teams assigned to this meeting template.
   */
  assignments: ManagedMeetingFragment_assignments | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AvailabilityFragment
// ====================================================

export interface AvailabilityFragment_times {
  __typename: "AvailabilityTime";
  /**
   * The day of this availability time
   */
  day: AvailabilityDay;
  /**
   * The time this duration starts
   */
  startTime: string;
  /**
   * The time this duration ends
   */
  endTime: string;
}

export interface AvailabilityFragment {
  __typename: "Availability";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Availability times on monday
   */
  times: AvailabilityFragment_times[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BookingFragment
// ====================================================

export interface BookingFragment_activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface BookingFragment_meeting {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of this meeting
   */
  meetingType: MeetingType;
}

export interface BookingFragment_formSubmission_primaryEntity_Lead {
  __typename: "Lead";
}

export interface BookingFragment_formSubmission_primaryEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface BookingFragment_formSubmission_primaryEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export type BookingFragment_formSubmission_primaryEntity = BookingFragment_formSubmission_primaryEntity_Lead | BookingFragment_formSubmission_primaryEntity_Account | BookingFragment_formSubmission_primaryEntity_Contact;

export interface BookingFragment_formSubmission_formVersion_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface BookingFragment_formSubmission_formVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent form of this form version
   */
  form: BookingFragment_formSubmission_formVersion_form;
}

export interface BookingFragment_formSubmission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface BookingFragment_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
}

export interface BookingFragment_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface BookingFragment_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export type BookingFragment_formSubmission_fields_edges_fieldValue = BookingFragment_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields | BookingFragment_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | BookingFragment_formSubmission_fields_edges_fieldValue_FormFieldSubmissionValueSingle;

export interface BookingFragment_formSubmission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: BookingFragment_formSubmission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: BookingFragment_formSubmission_fields_edges_fieldValue | null;
}

export interface BookingFragment_formSubmission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: BookingFragment_formSubmission_fields_edges[];
}

export interface BookingFragment_formSubmission {
  __typename: "Submission";
  /**
   * The primary entity on the submission
   */
  primaryEntity: BookingFragment_formSubmission_primaryEntity | null;
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The url where the submission originates
   */
  submissionUrl: string;
  /**
   * The name of the submitted web form
   */
  formVersion: BookingFragment_formSubmission_formVersion;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: BookingFragment_formSubmission_fields;
}

export interface BookingFragment_hostUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The user’s configured timezone
   */
  timezone: string;
}

export interface BookingFragment {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of the booking
   */
  status: BookingStatus;
  /**
   * The URL for rescheduling a booking
   */
  rescheduleUrl: string;
  /**
   * The activity associated with this booking
   */
  activity: BookingFragment_activity | null;
  /**
   * The meeting connected to this booking
   */
  meeting: BookingFragment_meeting;
  /**
   * The form submission associated with this booking
   */
  formSubmission: BookingFragment_formSubmission | null;
  /**
   * The start time of this booking
   */
  startTime: any;
  /**
   * The created time of this booking
   */
  createdTime: any;
  /**
   * The host user of this booking
   */
  hostUser: BookingFragment_hostUser | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: MeetingFragment
// ====================================================

export interface MeetingFragment_minNotice {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
}

export interface MeetingFragment_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface MeetingFragment_creator {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
  /**
   * The user’s configured root meeting URL for scheduler
   */
  schedulerRootMeetingsUrl: string;
  /**
   * Whether or not the user has customized their meeting URL
   */
  hasCustomizedMeetingUrl: boolean;
}

export interface MeetingFragment_cohosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
}

export interface MeetingFragment_hosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
  /**
   * The user’s configured timezone
   */
  timezone: string;
}

export interface MeetingFragment_team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface MeetingFragment_availability_times {
  __typename: "AvailabilityTime";
  /**
   * The day of this availability time
   */
  day: AvailabilityDay;
  /**
   * The time this duration starts
   */
  startTime: string;
  /**
   * The time this duration ends
   */
  endTime: string;
}

export interface MeetingFragment_availability {
  __typename: "Availability";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Availability times on monday
   */
  times: MeetingFragment_availability_times[];
}

export interface MeetingFragment_form_createRules_lead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface MeetingFragment_form_createRules_lead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface MeetingFragment_form_createRules_lead_stagesetFieldRules_field {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
}

export interface MeetingFragment_form_createRules_lead_stagesetFieldRules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface MeetingFragment_form_createRules_lead_stagesetFieldRules_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface MeetingFragment_form_createRules_lead_stagesetFieldRules {
  __typename: "StagesetFieldRules";
  /**
   * The field that the rule is associated with
   */
  field: MeetingFragment_form_createRules_lead_stagesetFieldRules_field;
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: MeetingFragment_form_createRules_lead_stagesetFieldRules_answerChoice;
  /**
   * The stageset to assign to entity if answer choice is selected
   */
  stageset: MeetingFragment_form_createRules_lead_stagesetFieldRules_stageset;
}

export interface MeetingFragment_form_createRules_lead {
  __typename: "FormCreateRulesLead";
  /**
   * The stageset to be added to a created lead
   */
  stageset: MeetingFragment_form_createRules_lead_stageset | null;
  /**
   * The tags to be added for this create rule
   */
  tags: MeetingFragment_form_createRules_lead_tags[];
  /**
   * The rules for creating stagesets based on field answers
   */
  stagesetFieldRules: MeetingFragment_form_createRules_lead_stagesetFieldRules[];
}

export interface MeetingFragment_form_createRules_contact_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface MeetingFragment_form_createRules_contact_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface MeetingFragment_form_createRules_contact {
  __typename: "FormCreateRulesContact";
  /**
   * The tags to be added for this create rule
   */
  tags: MeetingFragment_form_createRules_contact_tags[];
  /**
   * The audiences to be added for this create rule
   */
  audiences: MeetingFragment_form_createRules_contact_audiences[];
}

export interface MeetingFragment_form_createRules_account_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface MeetingFragment_form_createRules_account {
  __typename: "FormCreateRulesAccount";
  /**
   * The tags to be added for this create rule
   */
  tags: MeetingFragment_form_createRules_account_tags[];
  /**
   * Whether or not to attempt to find a company that matches form data
   */
  shouldDedupe: boolean;
}

export interface MeetingFragment_form_createRules {
  __typename: "FormCreateRules";
  /**
   * The create rules related to a lead
   */
  lead: MeetingFragment_form_createRules_lead | null;
  /**
   * The create rules related to a contact
   */
  contact: MeetingFragment_form_createRules_contact | null;
  /**
   * The create rules related to a account
   */
  account: MeetingFragment_form_createRules_account | null;
}

export interface MeetingFragment_form_publishedVersion_pages {
  __typename: "FormPage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MeetingFragment_form_publishedVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface MeetingFragment_form_publishedVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface MeetingFragment_form_publishedVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface MeetingFragment_form_publishedVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface MeetingFragment_form_publishedVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface MeetingFragment_form_publishedVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface MeetingFragment_form_publishedVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface MeetingFragment_form_publishedVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type MeetingFragment_form_publishedVersion_fields_rules_objectsToAssign = MeetingFragment_form_publishedVersion_fields_rules_objectsToAssign_Tag | MeetingFragment_form_publishedVersion_fields_rules_objectsToAssign_Audience | MeetingFragment_form_publishedVersion_fields_rules_objectsToAssign_Product | MeetingFragment_form_publishedVersion_fields_rules_objectsToAssign_Source | MeetingFragment_form_publishedVersion_fields_rules_objectsToAssign_Stageset;

export interface MeetingFragment_form_publishedVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: MeetingFragment_form_publishedVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: MeetingFragment_form_publishedVersion_fields_rules_objectsToAssign[];
}

export interface MeetingFragment_form_publishedVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: MeetingFragment_form_publishedVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: MeetingFragment_form_publishedVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: MeetingFragment_form_publishedVersion_fields_rules[];
}

export interface MeetingFragment_form_publishedVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Convenience boolean to determine if this form version has at least 1 field-based (conditional) page rule
   */
  hasConditionalRules: boolean;
  /**
   * Array of pages associated with this web form version
   */
  pages: MeetingFragment_form_publishedVersion_pages[];
  /**
   * Array of fields associated with this web form version
   */
  fields: MeetingFragment_form_publishedVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
}

export interface MeetingFragment_form_editableVersion_fields_attribute {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  type: EntityCustomFieldType;
}

export interface MeetingFragment_form_editableVersion_fields_image {
  __typename: "EntityAttributeValueImage";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  imageUrl: string;
}

export interface MeetingFragment_form_editableVersion_fields_rules_answerChoice {
  __typename: "EnumElement";
  /**
   * The api id of the enum element
   */
  id: string;
  /**
   * The name of the enum element
   */
  name: string | null;
}

export interface MeetingFragment_form_editableVersion_fields_rules_objectsToAssign_Tag {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface MeetingFragment_form_editableVersion_fields_rules_objectsToAssign_Audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface MeetingFragment_form_editableVersion_fields_rules_objectsToAssign_Product {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
}

export interface MeetingFragment_form_editableVersion_fields_rules_objectsToAssign_Source {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface MeetingFragment_form_editableVersion_fields_rules_objectsToAssign_Stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export type MeetingFragment_form_editableVersion_fields_rules_objectsToAssign = MeetingFragment_form_editableVersion_fields_rules_objectsToAssign_Tag | MeetingFragment_form_editableVersion_fields_rules_objectsToAssign_Audience | MeetingFragment_form_editableVersion_fields_rules_objectsToAssign_Product | MeetingFragment_form_editableVersion_fields_rules_objectsToAssign_Source | MeetingFragment_form_editableVersion_fields_rules_objectsToAssign_Stageset;

export interface MeetingFragment_form_editableVersion_fields_rules {
  __typename: "AnswerChoiceRules";
  /**
   * The answer choice that the rule is associated with
   */
  answerChoice: MeetingFragment_form_editableVersion_fields_rules_answerChoice;
  /**
   * The objects to assign to entity if answer choice is selected
   */
  objectsToAssign: MeetingFragment_form_editableVersion_fields_rules_objectsToAssign[];
}

export interface MeetingFragment_form_editableVersion_fields {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of form field (textfield, dropdown, etc)
   */
  type: FormFieldType;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * The form placeholder for this field
   */
  placeholder: string | null;
  /**
   * Form styles associated with this field
   */
  styles: string;
  /**
   * The subfields nested within this field
   */
  subfields: string;
  /**
   * Whether or not this field is separate fields
   */
  isSeparateFields: boolean;
  /**
   * The ids of the answer choice(s) that are preselected
   */
  defaultValues: string[];
  /**
   * The entity type associated with this field
   */
  entityName: EntityType | null;
  /**
   * The Nutshell field name associated with this field
   */
  fieldName: string | null;
  /**
   * Valid entity types for this field to map to, i.e. a Note could map to a CONTACT or an ACCOUNT
   */
  entityTypes: EntityType[];
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
  /**
   * If a field cannot be edited, such as name and email fields on a meeting form
   */
  isRemovable: boolean;
  /**
   * The entity attribute associated with this field if it is a custom field
   */
  attribute: MeetingFragment_form_editableVersion_fields_attribute | null;
  /**
   * The eav of the image to display here, or null if there is no image
   */
  image: MeetingFragment_form_editableVersion_fields_image | null;
  /**
   * The ID of the the earliest field this was duplicated from
   */
  originalFieldId: number | null;
  /**
   * The original field this was duplicated from
   */
  originalFieldApiId: string | null;
  /**
   * ISO currency code for currency custom fields (e.g. USD). Null when unset.
   */
  currencyShortname: string | null;
  /**
   * Whether or not the "Other" option is enabled for this field
   */
  isOtherEnabled: boolean;
  /**
   * The rules for this field.
   */
  rules: MeetingFragment_form_editableVersion_fields_rules[];
}

export interface MeetingFragment_form_editableVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Array of fields associated with this web form version
   */
  fields: MeetingFragment_form_editableVersion_fields[];
  /**
   * Form styles associated with this version
   */
  styles: string;
  /**
   * The URL to redirect the user to after form submission
   */
  redirectUrl: string | null;
  /**
   * The text to show to the user after form submission
   */
  afterSubmissionText: string | null;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a contact
   */
  hasContactFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to an account
   */
  hasAccountFields: boolean;
  /**
   * Convenience boolean to determine if this form version has at least 1 field mapped to a lead
   */
  hasLeadFields: boolean;
}

export interface MeetingFragment_form_nextSteps_slackMessage_slackChannel {
  __typename: "SlackChannel";
  name: string;
  display: string;
  externalId: string;
}

export interface MeetingFragment_form_nextSteps_slackMessage_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MeetingFragment_form_nextSteps_slackMessage {
  __typename: "FormNextStepsSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this slack automation relative to its siblings.
   */
  position: number;
  /**
   * The Slack channel to post the message in.
   */
  slackChannel: MeetingFragment_form_nextSteps_slackMessage_slackChannel | null;
  /**
   * The id of the Slack channel to post the message to.
   */
  channelId: string;
  /**
   * The associated form for this slack message.
   */
  form: MeetingFragment_form_nextSteps_slackMessage_form;
}

export interface MeetingFragment_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias {
  __typename: "NotifiableAlias";
}

export interface MeetingFragment_form_nextSteps_nutshellNotification_notifiables_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type MeetingFragment_form_nextSteps_nutshellNotification_notifiables = MeetingFragment_form_nextSteps_nutshellNotification_notifiables_NotifiableAlias | MeetingFragment_form_nextSteps_nutshellNotification_notifiables_User;

export interface MeetingFragment_form_nextSteps_nutshellNotification_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MeetingFragment_form_nextSteps_nutshellNotification {
  __typename: "FormNextStepsNutshellNotification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this automation relative to its siblings.
   */
  position: number;
  notifiables: MeetingFragment_form_nextSteps_nutshellNotification_notifiables[];
  /**
   * The associated form for this slack message.
   */
  form: MeetingFragment_form_nextSteps_nutshellNotification_form;
}

export interface MeetingFragment_form_nextSteps {
  __typename: "FormNextSteps";
  /**
   * Slack automations
   */
  slackMessage: MeetingFragment_form_nextSteps_slackMessage | null;
  /**
   * The create rules related to a account
   */
  nutshellNotification: MeetingFragment_form_nextSteps_nutshellNotification | null;
}

export interface MeetingFragment_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The timestamp this web form was created
   */
  createdTime: any;
  /**
   * The timestamp this web form was last updated
   */
  lastUpdatedTime: any | null;
  /**
   * Whether the form is archivable
   */
  canArchive: boolean | null;
  /**
   * The number of submissions for this form
   */
  numSubmissions: number;
  /**
   * The number of locations where this form is posted
   */
  numLocations: number;
  /**
   * The type of spam prevention configured for this form
   */
  spamPreventionType: SpamPreventionType;
  /**
   * The timestamp this web form was last submitted
   */
  lastSubmittedTime: any | null;
  /**
   * The number of page visits
   */
  pageVisits: number;
  /**
   * Form conversion rate
   */
  conversionRate: number;
  isArchived: boolean;
  /**
   * Json representation of create rules for this form
   */
  createRules: MeetingFragment_form_createRules;
  /**
   * The version of this form that is published
   */
  publishedVersion: MeetingFragment_form_publishedVersion | null;
  /**
   * Whether the form has been embedded
   */
  isLiveForm: boolean;
  /**
   * The published form preview url
   */
  publishedFormPreviewUrl: string;
  /**
   * Publicly viewable link to published form
   */
  sharableViewInBrowserLink: string;
  /**
   * Boolean, true if the editable version has any edits
   */
  hasUnpublishedChanges: boolean;
  /**
   * The version of this form that is the draft / editable
   */
  editableVersion: MeetingFragment_form_editableVersion;
  /**
   * Next step automations for this form
   */
  nextSteps: MeetingFragment_form_nextSteps;
  /**
   * The embed snippet for this form
   */
  embedSnippet: string;
  /**
   * The type of form
   */
  type: FormType;
}

export interface MeetingFragment_bookings {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MeetingFragment_validity_issues_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface MeetingFragment_validity_issues {
  __typename: "MeetingValidityIssue";
  /**
   * The user tied to this issue
   */
  user: MeetingFragment_validity_issues_user;
  /**
   * The issue type of this issue
   */
  issueType: ValidityIssueType;
}

export interface MeetingFragment_validity {
  __typename: "MeetingValidity";
  /**
   * A list of issues with host users tied to this meeting
   */
  issues: MeetingFragment_validity_issues[];
  /**
   * Whether this meeting can be booked
   */
  isBookable: boolean;
}

export interface MeetingFragment_assignments_stats {
  __typename: "MaterializedMeetingsStats";
  /**
   * The number of users assigned to this meeting template.
   */
  assignedUsersCount: number;
  /**
   * The number of teams assigned to this meeting template.
   */
  assignedTeamsCount: number;
  /**
   * The number of materialized meetings from this meeting template that have been modified and severed.
   */
  severedCount: number;
}

export interface MeetingFragment_assignments {
  __typename: "MaterializedMeetingsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The number of users assigned to this meeting template.
   */
  stats: MeetingFragment_assignments_stats;
}

export interface MeetingFragment {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Meeting model (used to fetch meeting config)
   */
  modelId: number;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * The type of this meeting
   */
  meetingType: MeetingType;
  /**
   * The description of this meeting
   */
  description: string | null;
  /**
   * Custom text sent to the invitee after booking
   */
  bookingConfirmationMessage: string | null;
  /**
   * The htmlUrl without http:                                            // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The htmlUrl for the template that manages this meeting without http: // app.nutshell.com.
   */
  managedByHtmlUrlPath: string | null;
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number;
  /**
   * The published form preview url
   */
  previewUrl: string;
  /**
   * The minimum notice required to book this meeting
   */
  minNotice: MeetingFragment_minNotice | null;
  /**
   * Buffer before each booking in minutes
   */
  bufferBeforeMins: number | null;
  /**
   * Buffer after each booking in minutes
   */
  bufferAfterMins: number | null;
  /**
   * The activity type for this meeting
   */
  activityType: MeetingFragment_activityType;
  /**
   * The location of this meeting, such as address or phone number
   */
  location: string;
  /**
   * The location type of this meeting
   */
  locationType: MeetingLocationType;
  /**
   * The primary host for this meeting
   */
  creator: MeetingFragment_creator;
  /**
   * The cohosts of this meeting, not including primary host
   */
  cohosts: MeetingFragment_cohosts[];
  /**
   * The possible hosts of this meeting, team members for ROUND_ROBIN, set hosts for other types
   */
  hosts: MeetingFragment_hosts[];
  /**
   * For a ROUND_ROBIN meeting, the selected team
   */
  team: MeetingFragment_team | null;
  /**
   * The availability for this meeting
   */
  availability: MeetingFragment_availability;
  /**
   * Publicly viewable link to the meeting
   */
  publicMeetingLink: string;
  /**
   * Whether this meeting is active
   */
  isActive: boolean;
  /**
   * The activity type for this meeting
   */
  form: MeetingFragment_form;
  /**
   * The bookings of this meeting
   */
  bookings: MeetingFragment_bookings[];
  /**
   * The timestamp this web form was last submitted
   */
  lastBookedTime: any | null;
  /**
   * Show invitees time slots at this interval in minutes
   */
  startTimeIntervalMinutes: number;
  /**
   * The number of times this meeting has been viewed
   */
  numViews: number;
  /**
   * Number of bookings compared to views
   */
  bookingRate: number;
  /**
   * Whether to send a booking confirmation email
   */
  sendConfirmationReminder: boolean;
  /**
   * Whether to send a reminder email one day before the meeting
   */
  sendUpcomingReminder: boolean;
  /**
   * Whether to send a reminder email 30 minutes before the meeting
   */
  sendSoonReminder: boolean;
  /**
   * Whether this meeting spans multiple timezones among primary and co hosts
   */
  spansTimezones: boolean;
  /**
   * The validity of this meeting
   */
  validity: MeetingFragment_validity;
  /**
   * The embed snippet for this meeting
   */
  embedSnippet: string;
  /**
   * The DateTime that represents when the meeting was deleted
   */
  deletedTime: any | null;
  /**
   * Whether to allow additional attendees to be added to the booking
   */
  allowAdditionalAttendees: boolean;
  /**
   * Whether this meeting is hidden from public view or visible on the host users scheduler page
   */
  isHidden: boolean;
  /**
   * Whether this hidden meeting can be made public (all plans can make hidden meetings public)
   */
  isShowable: boolean;
  /**
   * Whether this public meeting can be hidden (requires full scheduler access)
   */
  isHideable: boolean;
  /**
   * The custom URL slug for the meeting
   */
  customSlug: string | null;
  /**
   * The url slug of this meeting
   */
  urlSlug: string;
  /**
   * Whether this meeting is a managed template
   */
  isManagedTemplate: boolean;
  /**
   * Whether this meeting is being managed by a template
   */
  isManagedMeeting: boolean;
  /**
   * Whether this meeting is severed from its template. Always false for non-managed meetings.
   */
  isSevered: boolean;
  /**
   * The users or teams assigned to this meeting template.
   */
  assignments: MeetingFragment_assignments | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: MeetingStubFragment
// ====================================================

export interface MeetingStubFragment_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface MeetingStubFragment_creator {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  firstName: string | null;
}

export interface MeetingStubFragment_cohosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface MeetingStubFragment_hosts {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface MeetingStubFragment_team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface MeetingStubFragment_bookings {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface MeetingStubFragment_validity_issues_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface MeetingStubFragment_validity_issues {
  __typename: "MeetingValidityIssue";
  /**
   * The user tied to this issue
   */
  user: MeetingStubFragment_validity_issues_user;
  /**
   * The issue type of this issue
   */
  issueType: ValidityIssueType;
}

export interface MeetingStubFragment_validity {
  __typename: "MeetingValidity";
  /**
   * A list of issues with host users tied to this meeting
   */
  issues: MeetingStubFragment_validity_issues[];
  /**
   * Whether this meeting can be booked
   */
  isBookable: boolean;
}

export interface MeetingStubFragment {
  __typename: "Meeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The id of the Meeting model (used to fetch meeting config)
   */
  modelId: number;
  /**
   * The name of this meeting
   */
  name: string;
  /**
   * The type of this meeting
   */
  meetingType: MeetingType;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number;
  /**
   * The activity type for this meeting
   */
  activityType: MeetingStubFragment_activityType;
  /**
   * The location of this meeting, such as address or phone number
   */
  location: string;
  /**
   * The location type of this meeting
   */
  locationType: MeetingLocationType;
  /**
   * The primary host for this meeting
   */
  creator: MeetingStubFragment_creator;
  /**
   * The cohosts of this meeting, not including primary host
   */
  cohosts: MeetingStubFragment_cohosts[];
  /**
   * The possible hosts of this meeting, team members for ROUND_ROBIN, set hosts for other types
   */
  hosts: MeetingStubFragment_hosts[];
  /**
   * For a ROUND_ROBIN meeting, the selected team
   */
  team: MeetingStubFragment_team | null;
  /**
   * The bookings of this meeting
   */
  bookings: MeetingStubFragment_bookings[];
  /**
   * Publicly viewable link to the meeting
   */
  publicMeetingLink: string;
  /**
   * Whether this meeting is active
   */
  isActive: boolean;
  /**
   * Show invitees time slots at this interval in minutes
   */
  startTimeIntervalMinutes: number;
  /**
   * The number of times this meeting has been viewed
   */
  numViews: number;
  /**
   * Number of bookings compared to views
   */
  bookingRate: number;
  /**
   * Whether this meeting spans multiple timezones among primary and co hosts
   */
  spansTimezones: boolean;
  /**
   * The timestamp this web form was last submitted
   */
  lastBookedTime: any | null;
  /**
   * The validity of this meeting
   */
  validity: MeetingStubFragment_validity;
  /**
   * The embed snippet for this meeting
   */
  embedSnippet: string;
  /**
   * The DateTime that represents when the meeting was deleted
   */
  deletedTime: any | null;
  /**
   * Whether to allow additional attendees to be added to the booking
   */
  allowAdditionalAttendees: boolean;
  /**
   * Whether this meeting is hidden from public view or visible on the host users scheduler page
   */
  isHidden: boolean;
  /**
   * Whether this hidden meeting can be made public (all plans can make hidden meetings public)
   */
  isShowable: boolean;
  /**
   * Whether this public meeting can be hidden (requires full scheduler access)
   */
  isHideable: boolean;
  /**
   * Whether this meeting is being managed by a template
   */
  isManagedMeeting: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: MeetingValidityIssueFragment
// ====================================================

export interface MeetingValidityIssueFragment_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface MeetingValidityIssueFragment {
  __typename: "MeetingValidityIssue";
  /**
   * The user tied to this issue
   */
  user: MeetingValidityIssueFragment_user;
  /**
   * The issue type of this issue
   */
  issueType: ValidityIssueType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SchedulerPageConfigFragment
// ====================================================

export interface SchedulerPageConfigFragment_fromDomain {
  __typename: "Subdomain";
  /**
   * The ID of the em_from_domain row this record corresponds to, as each domain is split into multiple rows
   */
  fromDomainId: string;
  /**
   * The record of this DNS record
   */
  record: string;
  /**
   * The record of this DNS record
   */
  formattedRecord: string;
  /**
   * Where this subdomain is verified
   */
  isVerified: boolean;
}

export interface SchedulerPageConfigFragment_defaultFromDomain {
  __typename: "Subdomain";
  /**
   * The ID of the em_from_domain row this record corresponds to, as each domain is split into multiple rows
   */
  fromDomainId: string;
  /**
   * The record of this DNS record
   */
  record: string;
  /**
   * The record of this DNS record
   */
  formattedRecord: string;
  /**
   * Where this subdomain is verified
   */
  isVerified: boolean;
}

export interface SchedulerPageConfigFragment {
  __typename: "PageConfig";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Whether the user avatar should should be used on the scheduler page
   */
  useAvatar: boolean;
  /**
   * Whether the company logo should be used on the scheduler page
   */
  useCompanyLogo: boolean;
  /**
   * The path to the user’s scheduler page
   */
  userSlug: string | null;
  /**
   * The from domain of this PageConfig
   */
  fromDomain: SchedulerPageConfigFragment_fromDomain | null;
  defaultUserSlug: string;
  defaultFromDomain: SchedulerPageConfigFragment_defaultFromDomain;
  /**
   * The embed snippet for this user’s meetings page
   */
  embedSnippet: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AvailabilityReportDayFragment
// ====================================================

export interface AvailabilityReportDayFragment_views {
  __typename: "BookingDayStat";
  /**
   * The count of this booking day stat
   */
  count: number;
  /**
   * The heatmap for this booking day stat
   */
  heatmap: number;
}

export interface AvailabilityReportDayFragment_bookings {
  __typename: "BookingDayStat";
  /**
   * The count of this booking day stat
   */
  count: number;
  /**
   * The heatmap for this booking day stat
   */
  heatmap: number;
}

export interface AvailabilityReportDayFragment_availabilitySnapshot {
  __typename: "AvailabilityImpression";
  /**
   * Whether this availability impression is bookable
   */
  isBookable: boolean;
  /**
   * The days from view of this availability impression
   */
  daysFromView: number;
  /**
   * The date of this availability impression
   */
  date: string;
  /**
   * The score of this availability impression
   */
  score: AvailabilityScore;
  averageSlots: number;
  /**
   * Pre-formatted tooltip text for this availability cell
   */
  dataTip: string;
}

export interface AvailabilityReportDayFragment {
  __typename: "BookingDay";
  /**
   * The date of this booking window
   */
  date: string;
  /**
   * Whether this day is bookable via the meeting preferences
   */
  isBookable: boolean;
  /**
   * Bookings / views as a percentage string, e.g. "25%"
   */
  conversionRate: string;
  /**
   * The views for this booking day
   */
  views: AvailabilityReportDayFragment_views;
  /**
   * The bookings for this booking day
   */
  bookings: AvailabilityReportDayFragment_bookings;
  /**
   * The availability snapshot for this booking day
   */
  availabilitySnapshot: AvailabilityReportDayFragment_availabilitySnapshot[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AvailabilityReportDaySnapshotFragment
// ====================================================

export interface AvailabilityReportDaySnapshotFragment {
  __typename: "AvailabilityImpression";
  /**
   * Whether this availability impression is bookable
   */
  isBookable: boolean;
  /**
   * The days from view of this availability impression
   */
  daysFromView: number;
  /**
   * The date of this availability impression
   */
  date: string;
  /**
   * The score of this availability impression
   */
  score: AvailabilityScore;
  averageSlots: number;
  /**
   * Pre-formatted tooltip text for this availability cell
   */
  dataTip: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AvailabilityReportFragment
// ====================================================

export interface AvailabilityReportFragment_days_views {
  __typename: "BookingDayStat";
  /**
   * The count of this booking day stat
   */
  count: number;
  /**
   * The heatmap for this booking day stat
   */
  heatmap: number;
}

export interface AvailabilityReportFragment_days_bookings {
  __typename: "BookingDayStat";
  /**
   * The count of this booking day stat
   */
  count: number;
  /**
   * The heatmap for this booking day stat
   */
  heatmap: number;
}

export interface AvailabilityReportFragment_days_availabilitySnapshot {
  __typename: "AvailabilityImpression";
  /**
   * Whether this availability impression is bookable
   */
  isBookable: boolean;
  /**
   * The days from view of this availability impression
   */
  daysFromView: number;
  /**
   * The date of this availability impression
   */
  date: string;
  /**
   * The score of this availability impression
   */
  score: AvailabilityScore;
  averageSlots: number;
  /**
   * Pre-formatted tooltip text for this availability cell
   */
  dataTip: string;
}

export interface AvailabilityReportFragment_days {
  __typename: "BookingDay";
  /**
   * The date of this booking window
   */
  date: string;
  /**
   * Whether this day is bookable via the meeting preferences
   */
  isBookable: boolean;
  /**
   * Bookings / views as a percentage string, e.g. "25%"
   */
  conversionRate: string;
  /**
   * The views for this booking day
   */
  views: AvailabilityReportFragment_days_views;
  /**
   * The bookings for this booking day
   */
  bookings: AvailabilityReportFragment_days_bookings;
  /**
   * The availability snapshot for this booking day
   */
  availabilitySnapshot: AvailabilityReportFragment_days_availabilitySnapshot[];
}

export interface AvailabilityReportFragment {
  __typename: "AvailabilityReport";
  /**
   * The ID of this report
   */
  id: string;
  /**
   * The day span for this report
   */
  days: AvailabilityReportFragment_days[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ActivityTypeWithStats
// ====================================================

export interface ActivityTypeWithStats {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
  /**
   * The URL of the report for this activity type
   */
  reportUrl: string;
  /**
   * Whether this activity type is immutable
   */
  isImmutable: boolean;
  /**
   * The last time an activity of this type was created
   */
  lastActivityTime: any | null;
  /**
   * The number of activities of this type created in the past year
   */
  numActivitiesPastYear: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AiFeatureUsageFragment
// ====================================================

export interface AiFeatureUsageFragment_features {
  __typename: "AiFeatureSetting";
  type: AiFeatureType;
  isEnabled: boolean;
  usage: number;
  requiresUpgrade: boolean;
  canDisableGlobally: boolean;
}

export interface AiFeatureUsageFragment {
  __typename: "AiFeatureUsage";
  currentMonthUsage: number;
  currentMonthLimit: number | null;
  lastMonthUsage: number;
  features: AiFeatureUsageFragment_features[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BulkEditFragment
// ====================================================

export interface BulkEditFragment_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface BulkEditFragment {
  __typename: "BulkEdit";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user that initiated the bulk edit
   */
  user: BulkEditFragment_user | null;
  /**
   * The status of the bulk edit
   */
  status: BulkEditStatus;
  /**
   * The time the bulk edit was submitted
   */
  createdTime: any;
  /**
   * The time the bulk edit was started
   */
  startedTime: any | null;
  /**
   * The time the bulk edit was completed
   */
  completedTime: any | null;
  /**
   * The entity type that the bulk edit was performed on.
   */
  entityType: EntityType | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ListBulkActionsFragment
// ====================================================

export interface ListBulkActionsFragment_actor_Origin {
  __typename: "Origin" | "Contact" | "Account" | "Form" | "MaUrl";
}

export interface ListBulkActionsFragment_actor_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type ListBulkActionsFragment_actor = ListBulkActionsFragment_actor_Origin | ListBulkActionsFragment_actor_User;

export interface ListBulkActionsFragment_changes {
  __typename: "ChangeLogChange";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attrbute changed by the entry
   */
  attribute: string;
  /**
   * The new value after the change
   */
  newValue: string | null;
}

export interface ListBulkActionsFragment {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of change i.e. created, modified, deleted, etc
   */
  changeType: ChangeType;
  changeTime: any;
  /**
   * The entity name associated with the event. Rarely used, but can be helpful for odd events like exports
   */
  entityName: string | null;
  /**
   * The entity that triggered the change_log entry
   */
  actor: ListBulkActionsFragment_actor;
  changes: ListBulkActionsFragment_changes[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserSessionFragment
// ====================================================

export interface UserSessionFragment_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface UserSessionFragment {
  __typename: "UserSession";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  user: UserSessionFragment_user;
  ipAddress: string;
  loginTime: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AccountPlanFragment
// ====================================================

export interface AccountPlanFragment_accountCoupons {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface AccountPlanFragment_nextEstimatedInvoice {
  __typename: "BillingInvoice";
  /**
   * The Recurly id of the invoice
   */
  id: string;
  /**
   * The total amount of the invoice
   */
  amount: string;
  /**
   * The timestamp date the invoice was created
   */
  date: any;
}

export interface AccountPlanFragment_splitEstimatedInvoices_monthly {
  __typename: "BillingInvoice";
  /**
   * The Recurly id of the invoice
   */
  id: string;
  /**
   * The total amount of the invoice
   */
  amount: string;
  /**
   * The timestamp date the invoice was created
   */
  date: any;
}

export interface AccountPlanFragment_splitEstimatedInvoices_annual {
  __typename: "BillingInvoice";
  /**
   * The Recurly id of the invoice
   */
  id: string;
  /**
   * The total amount of the invoice
   */
  amount: string;
  /**
   * The timestamp date the invoice was created
   */
  date: any;
}

export interface AccountPlanFragment_splitEstimatedInvoices {
  __typename: "SplitEstimatedInvoices";
  /**
   * The next estimated invoice for monthly-billed subscriptions
   */
  monthly: AccountPlanFragment_splitEstimatedInvoices_monthly | null;
  /**
   * The next estimated invoice for annually-billed subscriptions
   */
  annual: AccountPlanFragment_splitEstimatedInvoices_annual | null;
}

export interface AccountPlanFragment_crm_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface AccountPlanFragment_crm_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface AccountPlanFragment_crm {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: AccountPlanFragment_crm_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: AccountPlanFragment_crm_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface AccountPlanFragment_marketing_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface AccountPlanFragment_marketing_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface AccountPlanFragment_marketing {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: AccountPlanFragment_marketing_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: AccountPlanFragment_marketing_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface AccountPlanFragment_revenueBooster_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface AccountPlanFragment_revenueBooster_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface AccountPlanFragment_revenueBooster {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: AccountPlanFragment_revenueBooster_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: AccountPlanFragment_revenueBooster_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface AccountPlanFragment_nutshellIq_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface AccountPlanFragment_nutshellIq_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface AccountPlanFragment_nutshellIq {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: AccountPlanFragment_nutshellIq_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: AccountPlanFragment_nutshellIq_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface AccountPlanFragment_inbox_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface AccountPlanFragment_inbox_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface AccountPlanFragment_inbox {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: AccountPlanFragment_inbox_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: AccountPlanFragment_inbox_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface AccountPlanFragment_marketingSuite_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface AccountPlanFragment_marketingSuite_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface AccountPlanFragment_marketingSuite {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: AccountPlanFragment_marketingSuite_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: AccountPlanFragment_marketingSuite_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface AccountPlanFragment_smsCampaigns_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface AccountPlanFragment_smsCampaigns_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface AccountPlanFragment_smsCampaigns {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: AccountPlanFragment_smsCampaigns_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: AccountPlanFragment_smsCampaigns_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface AccountPlanFragment_quotes_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface AccountPlanFragment_quotes_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface AccountPlanFragment_quotes {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: AccountPlanFragment_quotes_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: AccountPlanFragment_quotes_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface AccountPlanFragment_nutshellAdvisor_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface AccountPlanFragment_nutshellAdvisor_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface AccountPlanFragment_nutshellAdvisor {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: AccountPlanFragment_nutshellAdvisor_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: AccountPlanFragment_nutshellAdvisor_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

export interface AccountPlanFragment {
  __typename: "AccountPlan";
  /**
   * The total monthly cost of all subscriptions
   */
  totalMonth: number;
  /**
   * The total display monthly cost of all subscriptions
   */
  totalMonthDisplay: string;
  /**
   * The sub total (pre account wide coupon) display monthly cost of all subscriptions
   */
  subtotalMonthDisplay: string;
  /**
   * The total display discount applied to the account
   */
  accountDiscountDisplay: string;
  /**
   * The coupon applied to the whole account
   */
  accountCoupons: AccountPlanFragment_accountCoupons[];
  /**
   * The next estimated invoice for the account plan
   */
  nextEstimatedInvoice: AccountPlanFragment_nextEstimatedInvoice | null;
  /**
   * Next estimated invoices split by monthly and annual billing cycles
   */
  splitEstimatedInvoices: AccountPlanFragment_splitEstimatedInvoices;
  /**
   * Whether the account plan is cancelled
   */
  isCancelled: boolean;
  /**
   * The subscription for the CRM plan
   */
  crm: AccountPlanFragment_crm | null;
  /**
   * The subscription for the Marketing plan
   */
  marketing: AccountPlanFragment_marketing | null;
  /**
   * The subscription for the Revenue Booster plan
   */
  revenueBooster: AccountPlanFragment_revenueBooster | null;
  /**
   * The subscription for the Nutshell IQ plan
   */
  nutshellIq: AccountPlanFragment_nutshellIq | null;
  /**
   * The subscription for the inbox plan
   */
  inbox: AccountPlanFragment_inbox | null;
  /**
   * The subscription for the marketing suite plan
   */
  marketingSuite: AccountPlanFragment_marketingSuite | null;
  /**
   * The subscription for the SMS campaigns plans
   */
  smsCampaigns: AccountPlanFragment_smsCampaigns | null;
  /**
   * The subscription for the Quotes plan
   */
  quotes: AccountPlanFragment_quotes | null;
  /**
   * The subscription for the Nutshell Advisor plan
   */
  nutshellAdvisor: AccountPlanFragment_nutshellAdvisor | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BillingInfo
// ====================================================

export interface BillingInfo_bankInfo {
  __typename: "BankInfo";
  /**
   * The type of bank account
   */
  accountType: string;
  /**
   * The last four digits of the bank account number
   */
  accountNumber: string;
  /**
   * The name on the bank account
   */
  nameOnAccount: string;
  /**
   * The routing number of the bank account
   */
  routingNumber: string;
}

export interface BillingInfo_cardInfo {
  __typename: "CardInfo";
  /**
   * The last four digits of the credit card
   */
  lastFourDigits: string;
  /**
   * The first name on the credit card
   */
  firstName: string;
  /**
   * The last name on the credit card
   */
  lastName: string;
  /**
   * The expiration month of the credit card
   */
  expirationMonth: string;
  /**
   * The expiration year of the credit card
   */
  expirationYear: string;
  /**
   * The type of credit card
   */
  cardType: string;
}

export interface BillingInfo_addressInfo {
  __typename: "AddressInfo";
  /**
   * The first line of the address
   */
  address1: string;
  /**
   * The second line of the address
   */
  address2: string;
  /**
   * The city of the address
   */
  city: string;
  /**
   * The postal code of the address
   */
  postal: string;
  /**
   * The state of the address
   */
  state: string;
  /**
   * The country of the address
   */
  country: string;
}

export interface BillingInfo {
  __typename: "BillingInfo";
  /**
   * The phone number associated with this account
   */
  phoneNumber: string;
  /**
   * The formatted phone number associated with this account
   */
  phoneNumberFormatted: string;
  /**
   * The email address associated with this account
   */
  email: string;
  /**
   * The company name associated with this account
   */
  companyName: string;
  /**
   * The first name associated with this account
   */
  firstName: string;
  /**
   * The last name associated with this account
   */
  lastName: string;
  /**
   * The display name associated with this account
   */
  displayName: string;
  /**
   * Whether this account is a new subscription
   */
  isNewSubscription: boolean;
  /**
   * Whether the billing information is valid
   */
  isValid: boolean;
  /**
   * Banking information associated with this account
   */
  bankInfo: BillingInfo_bankInfo | null;
  /**
   * Credit card information associated with this account
   */
  cardInfo: BillingInfo_cardInfo | null;
  /**
   * Address information associated with this account
   */
  addressInfo: BillingInfo_addressInfo;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BillingInvoiceFragment
// ====================================================

export interface BillingInvoiceFragment {
  __typename: "BillingInvoice";
  /**
   * The Recurly id of the invoice
   */
  id: string;
  /**
   * The total amount of the invoice
   */
  amount: string;
  /**
   * The timestamp date the invoice was created
   */
  date: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CachedPlanFragment
// ====================================================

export interface CachedPlanFragment {
  __typename: "CachedPlan";
  /**
   * The code of the plan
   */
  code: string;
  /**
   * The number of licenses for the plan. Only applies to suite plans
   */
  licenseCount: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CouponFragment
// ====================================================

export interface CouponFragment {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PlanFragment
// ====================================================

export interface PlanFragment_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface PlanFragment {
  __typename: "Plan";
  /**
   * The product type associated with the plan
   */
  product: BillingProductType;
  /**
   * code for product type and tier of that product
   */
  code: string;
  /**
   * Description of the plan
   */
  description: string;
  /**
   * The billing cycle for the plan (monthly vs. annual)
   */
  cycleText: CycleType;
  /**
   * Highlights of the plan
   */
  planHighlights: string[];
  /**
   * Text describing that the prior plans features are included (non-legacy crm only)
   */
  priorFeaturesText: string | null;
  /**
   * Text describing the recurrence of the the plan.
   */
  priceUnit: string | null;
  /**
   * The actual price of the plan after discounts
   */
  price: string;
  /**
   * Text to provide a shorter name of the plan
   */
  shortenedName: string | null;
  /**
   * The sticker price of the plan
   */
  stickerPrice: string;
  /**
   * Whether the plan is currently active
   */
  isActive: boolean;
  /**
   * Number of users for user plans, or 0/1 for addons
   */
  quantity: number;
  /**
   * The add-on unit (EX IQ credits)
   */
  productQuantity: number;
  /**
   * Whether the plan is a legacy plan
   */
  isLegacy: boolean;
  /**
   * Whether the plan is a fake plan thats been injected manually
   */
  isFake: boolean;
  /**
   * Text describing sub information around adding the plan
   */
  subtitleText: string | null;
  /**
   * Coupon applied to the plan
   */
  coupon: PlanFragment_coupon | null;
  /**
   * The human-readable name of the plan
   */
  nameDisplay: string | null;
  /**
   * The name of the plan
   */
  name: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PlanGroupFragment
// ====================================================

export interface PlanGroupFragment_plans_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface PlanGroupFragment_plans {
  __typename: "Plan";
  /**
   * The product type associated with the plan
   */
  product: BillingProductType;
  /**
   * code for product type and tier of that product
   */
  code: string;
  /**
   * Description of the plan
   */
  description: string;
  /**
   * The billing cycle for the plan (monthly vs. annual)
   */
  cycleText: CycleType;
  /**
   * Highlights of the plan
   */
  planHighlights: string[];
  /**
   * Text describing that the prior plans features are included (non-legacy crm only)
   */
  priorFeaturesText: string | null;
  /**
   * Text describing the recurrence of the the plan.
   */
  priceUnit: string | null;
  /**
   * The actual price of the plan after discounts
   */
  price: string;
  /**
   * Text to provide a shorter name of the plan
   */
  shortenedName: string | null;
  /**
   * The sticker price of the plan
   */
  stickerPrice: string;
  /**
   * Whether the plan is currently active
   */
  isActive: boolean;
  /**
   * Number of users for user plans, or 0/1 for addons
   */
  quantity: number;
  /**
   * The add-on unit (EX IQ credits)
   */
  productQuantity: number;
  /**
   * Whether the plan is a legacy plan
   */
  isLegacy: boolean;
  /**
   * Whether the plan is a fake plan thats been injected manually
   */
  isFake: boolean;
  /**
   * Text describing sub information around adding the plan
   */
  subtitleText: string | null;
  /**
   * Coupon applied to the plan
   */
  coupon: PlanGroupFragment_plans_coupon | null;
  /**
   * The human-readable name of the plan
   */
  nameDisplay: string | null;
  /**
   * The name of the plan
   */
  name: string;
}

export interface PlanGroupFragment_cachedPlan {
  __typename: "CachedPlan";
  /**
   * The code of the plan
   */
  code: string;
  /**
   * The number of licenses for the plan. Only applies to suite plans
   */
  licenseCount: number | null;
}

export interface PlanGroupFragment {
  __typename: "PlanGroupCrm" | "PlanGroupMarketing" | "PlanGroupBase" | "PlanGroupNutshellIq" | "PlanGroupInbox" | "PlanGroupMarketingSuite" | "PlanGroupSmsCampaigns" | "PlanGroupQuotes" | "PlanGroupNutshellAdvisor";
  /**
   * The default code for the plan type
   */
  defaultCode: string;
  /**
   * The active plan code for the plan type
   */
  activePlanCode: string | null;
  /**
   * The plans in the plan type
   */
  plans: PlanGroupFragment_plans[];
  /**
   * Whether the plan is quantity based
   */
  isUserQuantityBased: boolean;
  /**
   * The cached plan for the plan type
   */
  cachedPlan: PlanGroupFragment_cachedPlan | null;
  /**
   * Whether the plan is cycle based (annually or monthly)
   */
  isCycleBased: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SubscriptionFragment
// ====================================================

export interface SubscriptionFragment_coupon {
  __typename: "Coupon";
  /**
   * The name of the coupon
   */
  name: string;
  /**
   * The code of the coupon
   */
  code: string;
  /**
   * The plan codes the coupon applies to
   */
  planCodes: string[];
  /**
   * The expiration date of the coupon
   */
  expiresAt: any | null;
  /**
   * The date the coupon was applied
   */
  appliedAt: any | null;
  /**
   * The type of discount the coupon provides
   */
  discountType: DiscountType;
  /**
   * The amount discounted if not a percentage
   */
  discountAmount: number | null;
  /**
   * The percentage discount the coupon provides
   */
  discountPercent: number | null;
  /**
   * The display info of the coupon
   */
  displayInfo: string | null;
}

export interface SubscriptionFragment_billDate {
  __typename: "BillDate";
  /**
   * The timestamp format of the date
   */
  timestamp: number;
  /**
   * The shortened version of the date
   */
  humanShort: string;
  /**
   * The formatted version of the date
   */
  humanDate: string;
}

export interface SubscriptionFragment {
  __typename: "Subscription";
  /**
   * The price of each subscription unit
   */
  unitAmount: number;
  /**
   * The price of the subscription with quanity
   */
  total: number;
  /**
   * The sticker price of the subscription with quantity
   */
  stickerTotal: number;
  /**
   * The display price of each subscription unit
   */
  unitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit
   */
  stickerUnitAmountDisplay: string;
  /**
   * The display sticker price of each subscription unit on the monthly plan
   */
  stickerMonthlyUnitAmountDisplay: string | null;
  /**
   * The display price of the subscription with quantity
   */
  totalDisplay: string;
  /**
   * The display sticker price of the subscription with quantity
   */
  stickerTotalDisplay: string;
  /**
   * The code of the plan
   */
  planCode: string;
  /**
   * The coupon applied to the subscription
   */
  coupon: SubscriptionFragment_coupon | null;
  /**
   * The product of the subscription
   */
  product: BillingProductType;
  /**
   * The cycle of the subscription
   */
  cycleText: CycleType;
  /**
   * The name of the subscription
   */
  name: string;
  /**
   * The display name of the subscription
   */
  nameDisplay: string;
  /**
   * The tier of the subscription
   */
  currentTier: string | null;
  /**
   * The quantity of the subscription
   */
  quantity: number;
  /**
   * The quantity of the product
   */
  productQuantity: number;
  /**
   * The billing date of the subscription
   */
  billDate: SubscriptionFragment_billDate | null;
  /**
   * Whether this subscription differs from the customer's current Recurly subscription in the pending plan selection
   */
  isModified: boolean;
  /**
   * Whether this subscription is a fake plan that has been injected manually
   */
  isFake: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UsageScorecardEntry
// ====================================================

export interface UsageScorecardEntry {
  __typename: "UsageScorecardEntry";
  /**
   * How much this feature is currently being used
   */
  currentUsage: number;
  /**
   * The limit for this feature based on their plan (null if unlimited)
   */
  planLimit: number | null;
  /**
   * The custom limit for this feature if one has been set
   */
  customLimit: number | null;
  /**
   * The name that should be displayed on the usage scorecard table
   */
  displayName: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CalendarFragment
// ====================================================

export interface CalendarFragment {
  __typename: "CalendarSyncCalendar";
  /**
   * The API ID for this calendar
   */
  id: string;
  /**
   * The name of this calendar
   */
  name: string;
  /**
   * Indicates if this is the calendar selected for sync
   */
  isSelected: boolean;
  /**
   * The type of sync this calendar is used for. Can be conflict, primary, or none if it is not currently in use
   */
  syncType: SyncType;
  /**
   * Errors relating to the sync status of this calendar
   */
  syncErrors: string[];
  /**
   * The email address used for the oauth connection that created this calendar
   */
  username: string;
  /**
   * The service provider for this calendar, Google, Outlook, or Exchange
   */
  serviceType: ExternalService;
  /**
   * The rules for what events, if any, should be added to the calendar from Nutshell
   */
  exportRule: CalendarExportRule;
  /**
   * Whether contact creation is disabled when syncing calendar events or external meetings
   */
  isContactCreationDisabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CalendarSync
// ====================================================

export interface CalendarSync_calendars {
  __typename: "CalendarSyncCalendar";
  /**
   * The API ID for this calendar
   */
  id: string;
  /**
   * The name of this calendar
   */
  name: string;
  /**
   * Indicates if this is the calendar selected for sync
   */
  isSelected: boolean;
  /**
   * The type of sync this calendar is used for. Can be conflict, primary, or none if it is not currently in use
   */
  syncType: SyncType;
  /**
   * Errors relating to the sync status of this calendar
   */
  syncErrors: string[];
  /**
   * The email address used for the oauth connection that created this calendar
   */
  username: string;
  /**
   * The service provider for this calendar, Google, Outlook, or Exchange
   */
  serviceType: ExternalService;
  /**
   * The rules for what events, if any, should be added to the calendar from Nutshell
   */
  exportRule: CalendarExportRule;
  /**
   * Whether contact creation is disabled when syncing calendar events or external meetings
   */
  isContactCreationDisabled: boolean;
}

export interface CalendarSync {
  __typename: "CalendarSync";
  /**
   * The email address being used for calendar sync
   */
  username: string;
  /**
   * The external calendar service we're syncing with
   */
  externalService: ExternalService;
  /**
   * Whether or not calendar sync is enabled
   */
  isEnabled: boolean;
  /**
   * Whether or not import from the primary calendar is enabled
   */
  importIsEnabled: boolean;
  /**
   * Errors relating to the sync status of the primary calendar
   */
  syncErrors: string[];
  /**
   * How to handle calendar invitations when creating activities that sync to the external calendar
   */
  inviteSetting: CalendarInviteSetting;
  /**
   * All of the calendars we can sync with
   */
  calendars: CalendarSync_calendars[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CustomFieldFragment
// ====================================================

export interface CustomFieldFragment_attribute {
  __typename: "Attribute";
  /**
   * The human readable name of the attribute
   */
  displayName: string;
  /**
   * The human readable type of the attribute
   */
  displayType: string;
  /**
   * The description of the attribute
   */
  description: string | null;
}

export interface CustomFieldFragment_customFieldStats {
  __typename: "CustomFieldStats";
  /**
   * The number of forms that have this field
   */
  numOfForms: number;
  /**
   * The number of published contract templates that have this field
   */
  numOfContracts: number;
}

export interface CustomFieldFragment {
  __typename: "EntityAttributeBase" | "EntityAttributeEnum" | "EntityAttributeCurrency";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  attribute: CustomFieldFragment_attribute;
  customFieldStats: CustomFieldFragment_customFieldStats | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntityAttributeEnumFragment
// ====================================================

export interface EntityAttributeEnumFragment_options {
  __typename: "EnumOption";
  /**
   * The name (and primary identifier) of the enum option.
   */
  id: string;
  /**
   * The name (and display) of the enum option.
   */
  name: string;
}

export interface EntityAttributeEnumFragment {
  __typename: "EntityAttributeEnum";
  /**
   * Does this enum field allow multiple selections. I.e. can the value of "Favorite Color" be "Red" AND "Blue"?
   */
  allowMultiple: boolean;
  /**
   * Enum options for this field
   */
  options: EntityAttributeEnumFragment_options[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: StagesetFragment
// ====================================================

export interface StagesetFragment_edges_node {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface StagesetFragment_edges {
  __typename: "CustomFieldStagesetsEdge";
  /**
   * Is this field on the pipeline?
   */
  isOnPipeline: boolean;
  node: StagesetFragment_edges_node;
}

export interface StagesetFragment {
  __typename: "CustomFieldStagesetsConnection";
  /**
   * Whether this field is specific to a stageset
   */
  isStagesetSpecific: boolean | null;
  /**
   * A list of edges.
   */
  edges: StagesetFragment_edges[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: DomainFragment
// ====================================================

export interface DomainFragment_groupSpf_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface DomainFragment_groupSpf {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: DomainFragment_groupSpf_records[];
}

export interface DomainFragment_groupDkim_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface DomainFragment_groupDkim {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: DomainFragment_groupDkim_records[];
}

export interface DomainFragment_groupCustom_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface DomainFragment_groupCustom {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: DomainFragment_groupCustom_records[];
}

export interface DomainFragment_groupDmarc_records {
  __typename: "Record";
  /**
   * The type of this DNS record
   */
  type: RecordType;
  /**
   * The fully qualified domain name of this DNS record
   */
  record: string;
  /**
   * The value of this DNS record
   */
  value: string;
  /**
   * The priority of this DNS record (null if not applicable), used for MX records to denote preference
   */
  priority: number | null;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The error message for this individual DNS record
   */
  errorMessage: string | null;
}

export interface DomainFragment_groupDmarc {
  __typename: "Group";
  /**
   * The type of this DNS group
   */
  type: GroupType;
  /**
   * The name of this DNS group
   */
  name: string;
  /**
   * The status of this individual DNS record
   */
  status: FromDomainStatus;
  /**
   * The DNS records under this group
   */
  records: DomainFragment_groupDmarc_records[];
}

export interface DomainFragment {
  __typename: "Domain";
  /**
   * The domain ID (currently the name)
   */
  id: string;
  /**
   * The domain name
   */
  name: string;
  /**
   * If email deliverability requirements are all verified
   */
  emailDeliverabilityStatus: boolean;
  /**
   * If hosting domains are all verified
   */
  hostingTrackingStatus: boolean;
  /**
   * Whether or not the domain is not setup for email and hosting and is not in the process of verifying any records
   */
  canUseEntriSetup: boolean;
  /**
   * The group containing the SPF records for this domain
   */
  groupSpf: DomainFragment_groupSpf;
  /**
   * The group containing the DKIM records for this domain
   */
  groupDkim: DomainFragment_groupDkim;
  /**
   * The group containing the custom records for this domain
   */
  groupCustom: DomainFragment_groupCustom;
  /**
   * The group containing the DMARC records for this domain
   */
  groupDmarc: DomainFragment_groupDmarc;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: DigestSubscriptionFragment
// ====================================================

export interface DigestSubscriptionFragment {
  __typename: "DigestSubscription";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  isActive: boolean;
  /**
   * Frequency for email digest subscription
   */
  frequency: DigestFrequencyEnum;
  /**
   * Email digest type
   */
  digestType: DigestTypeEnum;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserEmail
// ====================================================

export interface UserEmail_smtpCredentials_settings {
  __typename: "SmtpCredentialsSettings";
  /**
   * Hostname for the SMTP connection
   */
  hostname: string;
  /**
   * Username for the connection
   */
  username: string;
  /**
   * The password associated with this account
   */
  password: string;
  /**
   * SSL or TLS information
   */
  ssl: SmtpPortType;
  /**
   * Port to use for this connection
   */
  port: string;
}

export interface UserEmail_smtpCredentials {
  __typename: "SmtpCredentials";
  /**
   * The settings associated with this SMTP connection
   */
  settings: UserEmail_smtpCredentials_settings;
  /**
   * Status of the SMTP connection (unverified, verifying, verified, etc.)
   */
  verificationStatus: SmtpConnectionVerificationStatus;
  /**
   * Message from the server about the verification status
   */
  verificationMessage: string | null;
}

export interface UserEmail {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Is this email successfully configured to send email from Nutshell
   */
  isEnabledForSending: boolean;
  /**
   * Errors relating to email send
   */
  sendErrors: string[];
  /**
   * Is email sync enabled for this address? When the user is sending follow-ups,
   * for example, it’s nice to warn them if sync is not enabled
   */
  isSyncEnabled: boolean;
  /**
   * Errors relating to the sync status of this email
   */
  syncErrors: string[];
  /**
   * Is this email address able to have sync turned on
   */
  allowsEmailSync: boolean;
  /**
   * The address string of this email.
   */
  address: string;
  display: string | null;
  formatted: string;
  type: UserEmailType;
  smtpCredentials: UserEmail_smtpCredentials | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ColumnMapFragment
// ====================================================

export interface ColumnMapFragment {
  __typename: "CsvImportMappingOption";
  entityType: EntityType;
  /**
   * The name of the entity this column is associated with (Accounts, Contacts, Leads, Notes, Account_ContactsMap)
   */
  entityName: string;
  /**
   * The name of the field this column is associated with. Absent for Notes
   * mappings that only attach a note to a parent entity.
   */
  fieldName: string | null;
  /**
   * The qualifier on multi-key fields (e.g. "mobile" for phone, "main" for address, "twitter" for url)
   */
  fieldKey: string | null;
  /**
   * The subfield of a compound type (e.g. "givenName" / "familyName" on name, "city" / "state" on address)
   */
  subFieldName: string | null;
  /**
   * Whether this column maps to an EAV field
   */
  isEav: boolean | null;
  /**
   * The custom field type when this mapping targets an existing custom field
   */
  fieldType: EntityCustomFieldType | null;
  /**
   * For Notes mappings, the entity in the row to attach the note to (Accounts, Contacts, or Leads)
   */
  parentEntity: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CsvImportBulkCreateActualCountFragment
// ====================================================

export interface CsvImportBulkCreateActualCountFragment {
  __typename: "CsvImportBulkCreateActualCount";
  /**
   * Parent entity type (e.g. Accounts, Contacts, Leads)
   */
  entityName: string;
  /**
   * Field that triggered bulk creation (e.g. tag, source, industry)
   */
  fieldName: string;
  /**
   * Number of new entities created during the import
   */
  count: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CsvImportColumnFragment
// ====================================================

export interface CsvImportColumnFragment {
  __typename: "CsvImportColumn";
  /**
   * The index of the column in the CSV
   */
  index: number;
  /**
   * The name of the column in the CSV
   */
  name: string;
  /**
   * The sample values of the column in the CSV
   */
  sampleValues: string[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CsvImportConfigFragment
// ====================================================

export interface CsvImportConfigFragment_columnMap {
  __typename: "CsvImportMappingOption";
  entityType: EntityType;
  /**
   * The name of the entity this column is associated with (Accounts, Contacts, Leads, Notes, Account_ContactsMap)
   */
  entityName: string;
  /**
   * The name of the field this column is associated with. Absent for Notes
   * mappings that only attach a note to a parent entity.
   */
  fieldName: string | null;
  /**
   * The qualifier on multi-key fields (e.g. "mobile" for phone, "main" for address, "twitter" for url)
   */
  fieldKey: string | null;
  /**
   * The subfield of a compound type (e.g. "givenName" / "familyName" on name, "city" / "state" on address)
   */
  subFieldName: string | null;
  /**
   * Whether this column maps to an EAV field
   */
  isEav: boolean | null;
  /**
   * The custom field type when this mapping targets an existing custom field
   */
  fieldType: EntityCustomFieldType | null;
  /**
   * For Notes mappings, the entity in the row to attach the note to (Accounts, Contacts, or Leads)
   */
  parentEntity: string | null;
}

export interface CsvImportConfigFragment {
  __typename: "CsvImportConfig";
  /**
   * Opaque identifier for the uploaded CSV.
   */
  fileId: string;
  /**
   * The name of the CSV file
   */
  fileName: string;
  /**
   * The mapping of columns in the CSV, indexed by column number
   */
  columnMap: (CsvImportConfigFragment_columnMap | null)[];
  /**
   * Whether to update existing entities
   */
  updateExisting: boolean;
  /**
   * Whether to match duplicate emails
   */
  matchDuplicateEmail: boolean;
  /**
   * Whether to match duplicate names
   */
  matchDuplicateName: boolean;
  /**
   * Whether to match duplicate company names
   */
  matchDuplicateCompanyName: boolean;
  /**
   * Whether to match duplicate account IDs
   */
  matchDuplicateAccountId: boolean;
  /**
   * Whether to match duplicate contact IDs
   */
  matchDuplicateContactId: boolean;
  /**
   * Whether to create a lead
   */
  leadCreate: CreateLeadMode;
  /**
   * Whether to create a lead for existing entities
   */
  leadCreateForExisting: boolean;
  /**
   * Whether to tag the import
   */
  shouldTagImport: boolean;
  /**
   * The tag for the import
   */
  importTag: string;
  /**
   * Causes imported contacts to be added to this audience.
   */
  audienceId: string | null;
  /**
   * When true, the import creates Unsubscribe rows instead of creating or updating entities.
   */
  unsubscribe: boolean | null;
  /**
   * The column number in the CSV that contains the email address to unsubscribe.
   */
  unsubscribeEmailAddressColumnNum: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CsvImportFragment
// ====================================================

export interface CsvImportFragment_initiatingUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CsvImportFragment_config_columnMap {
  __typename: "CsvImportMappingOption";
  entityType: EntityType;
  /**
   * The name of the entity this column is associated with (Accounts, Contacts, Leads, Notes, Account_ContactsMap)
   */
  entityName: string;
  /**
   * The name of the field this column is associated with. Absent for Notes
   * mappings that only attach a note to a parent entity.
   */
  fieldName: string | null;
  /**
   * The qualifier on multi-key fields (e.g. "mobile" for phone, "main" for address, "twitter" for url)
   */
  fieldKey: string | null;
  /**
   * The subfield of a compound type (e.g. "givenName" / "familyName" on name, "city" / "state" on address)
   */
  subFieldName: string | null;
  /**
   * Whether this column maps to an EAV field
   */
  isEav: boolean | null;
  /**
   * The custom field type when this mapping targets an existing custom field
   */
  fieldType: EntityCustomFieldType | null;
  /**
   * For Notes mappings, the entity in the row to attach the note to (Accounts, Contacts, or Leads)
   */
  parentEntity: string | null;
}

export interface CsvImportFragment_config {
  __typename: "CsvImportConfig";
  /**
   * Opaque identifier for the uploaded CSV.
   */
  fileId: string;
  /**
   * The name of the CSV file
   */
  fileName: string;
  /**
   * The mapping of columns in the CSV, indexed by column number
   */
  columnMap: (CsvImportFragment_config_columnMap | null)[];
  /**
   * Whether to update existing entities
   */
  updateExisting: boolean;
  /**
   * Whether to match duplicate emails
   */
  matchDuplicateEmail: boolean;
  /**
   * Whether to match duplicate names
   */
  matchDuplicateName: boolean;
  /**
   * Whether to match duplicate company names
   */
  matchDuplicateCompanyName: boolean;
  /**
   * Whether to match duplicate account IDs
   */
  matchDuplicateAccountId: boolean;
  /**
   * Whether to match duplicate contact IDs
   */
  matchDuplicateContactId: boolean;
  /**
   * Whether to create a lead
   */
  leadCreate: CreateLeadMode;
  /**
   * Whether to create a lead for existing entities
   */
  leadCreateForExisting: boolean;
  /**
   * Whether to tag the import
   */
  shouldTagImport: boolean;
  /**
   * The tag for the import
   */
  importTag: string;
  /**
   * Causes imported contacts to be added to this audience.
   */
  audienceId: string | null;
  /**
   * When true, the import creates Unsubscribe rows instead of creating or updating entities.
   */
  unsubscribe: boolean | null;
  /**
   * The column number in the CSV that contains the email address to unsubscribe.
   */
  unsubscribeEmailAddressColumnNum: number | null;
}

export interface CsvImportFragment_columns {
  __typename: "CsvImportColumn";
  /**
   * The index of the column in the CSV
   */
  index: number;
  /**
   * The name of the column in the CSV
   */
  name: string;
  /**
   * The sample values of the column in the CSV
   */
  sampleValues: string[];
}

export interface CsvImportFragment_modifiedCounts_accounts_created {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface CsvImportFragment_modifiedCounts_accounts_updated {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface CsvImportFragment_modifiedCounts_accounts {
  __typename: "CsvImportModifiedCount";
  created: CsvImportFragment_modifiedCounts_accounts_created;
  updated: CsvImportFragment_modifiedCounts_accounts_updated;
}

export interface CsvImportFragment_modifiedCounts_contacts_created {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface CsvImportFragment_modifiedCounts_contacts_updated {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface CsvImportFragment_modifiedCounts_contacts {
  __typename: "CsvImportModifiedCount";
  created: CsvImportFragment_modifiedCounts_contacts_created;
  updated: CsvImportFragment_modifiedCounts_contacts_updated;
}

export interface CsvImportFragment_modifiedCounts_leads_created {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface CsvImportFragment_modifiedCounts_leads_updated {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface CsvImportFragment_modifiedCounts_leads {
  __typename: "CsvImportModifiedCount";
  created: CsvImportFragment_modifiedCounts_leads_created;
  updated: CsvImportFragment_modifiedCounts_leads_updated;
}

export interface CsvImportFragment_modifiedCounts {
  __typename: "CsvImportModifiedCounts";
  accounts: CsvImportFragment_modifiedCounts_accounts;
  contacts: CsvImportFragment_modifiedCounts_contacts;
  leads: CsvImportFragment_modifiedCounts_leads;
}

export interface CsvImportFragment_bulkCreateCounts {
  __typename: "CsvImportBulkCreateActualCount";
  /**
   * Parent entity type (e.g. Accounts, Contacts, Leads)
   */
  entityName: string;
  /**
   * Field that triggered bulk creation (e.g. tag, source, industry)
   */
  fieldName: string;
  /**
   * Number of new entities created during the import
   */
  count: number;
}

export interface CsvImportFragment {
  __typename: "CsvImport";
  /**
   * The ID of this import
   */
  id: string;
  /**
   * The origin ID of this import
   */
  originId: string;
  /**
   * The Nutshell status type of this import
   */
  importStatus: ImportStatus;
  /**
   * The fileName of the import
   */
  fileName: string | null;
  /**
   * A list of errors that occurred during the import
   */
  errors: string[];
  /**
   * The user who initiated this import
   */
  initiatingUser: CsvImportFragment_initiatingUser | null;
  /**
   * The time the import was created
   */
  createdTime: any;
  /**
   * The time the import was started
   */
  startTime: any | null;
  /**
   * The time the import was finished
   */
  endTime: any | null;
  /**
   * Float 0–100 of import progress. Null until the importer has begun writing rows.
   */
  percentComplete: number;
  /**
   * The display status of the import
   */
  displayStatus: string;
  /**
   * Whether this import can be reverted right now.
   */
  canRevert: boolean;
  /**
   * The number of lines in the CSV file
   */
  lineCount: number;
  /**
   * URL to download the originally uploaded CSV file
   */
  fileDownloadUrl: string | null;
  /**
   * The configuration for the import
   */
  config: CsvImportFragment_config;
  /**
   * The columns for the uploaded CSV
   */
  columns: CsvImportFragment_columns[];
  /**
   * Actual counts split into "created" and "updated" for core entities
   */
  modifiedCounts: CsvImportFragment_modifiedCounts;
  /**
   * Actual counts of bulk get-or-create entities (tags, sources, etc.) created during the import
   */
  bulkCreateCounts: CsvImportFragment_bulkCreateCounts[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CsvImportModifiedCountFragment
// ====================================================

export interface CsvImportModifiedCountFragment_created {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface CsvImportModifiedCountFragment_updated {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface CsvImportModifiedCountFragment {
  __typename: "CsvImportModifiedCount";
  created: CsvImportModifiedCountFragment_created;
  updated: CsvImportModifiedCountFragment_updated;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CsvImportModifiedCountsFragment
// ====================================================

export interface CsvImportModifiedCountsFragment_accounts_created {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface CsvImportModifiedCountsFragment_accounts_updated {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface CsvImportModifiedCountsFragment_accounts {
  __typename: "CsvImportModifiedCount";
  created: CsvImportModifiedCountsFragment_accounts_created;
  updated: CsvImportModifiedCountsFragment_accounts_updated;
}

export interface CsvImportModifiedCountsFragment_contacts_created {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface CsvImportModifiedCountsFragment_contacts_updated {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface CsvImportModifiedCountsFragment_contacts {
  __typename: "CsvImportModifiedCount";
  created: CsvImportModifiedCountsFragment_contacts_created;
  updated: CsvImportModifiedCountsFragment_contacts_updated;
}

export interface CsvImportModifiedCountsFragment_leads_created {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface CsvImportModifiedCountsFragment_leads_updated {
  __typename: "CsvImportModifiedEntityResult";
  count: number;
  viewUrl: string | null;
}

export interface CsvImportModifiedCountsFragment_leads {
  __typename: "CsvImportModifiedCount";
  created: CsvImportModifiedCountsFragment_leads_created;
  updated: CsvImportModifiedCountsFragment_leads_updated;
}

export interface CsvImportModifiedCountsFragment {
  __typename: "CsvImportModifiedCounts";
  accounts: CsvImportModifiedCountsFragment_accounts;
  contacts: CsvImportModifiedCountsFragment_contacts;
  leads: CsvImportModifiedCountsFragment_leads;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ImportColumnOptionFragment
// ====================================================

export interface ImportColumnOptionFragment_value {
  __typename: "CsvImportMappingOption";
  entityType: EntityType;
  /**
   * The name of the entity this column is associated with (Accounts, Contacts, Leads, Notes, Account_ContactsMap)
   */
  entityName: string;
  /**
   * The name of the field this column is associated with. Absent for Notes
   * mappings that only attach a note to a parent entity.
   */
  fieldName: string | null;
  /**
   * The qualifier on multi-key fields (e.g. "mobile" for phone, "main" for address, "twitter" for url)
   */
  fieldKey: string | null;
  /**
   * The subfield of a compound type (e.g. "givenName" / "familyName" on name, "city" / "state" on address)
   */
  subFieldName: string | null;
  /**
   * Whether this column maps to an EAV field
   */
  isEav: boolean | null;
  /**
   * The custom field type when this mapping targets an existing custom field
   */
  fieldType: EntityCustomFieldType | null;
  /**
   * For Notes mappings, the entity in the row to attach the note to (Accounts, Contacts, or Leads)
   */
  parentEntity: string | null;
}

export interface ImportColumnOptionFragment {
  __typename: "ImportColumnOption";
  name: string;
  children: string[];
  root: boolean;
  value: ImportColumnOptionFragment_value | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: DromoImportFragment
// ====================================================

export interface DromoImportFragment_initiatingUser {
  __typename: "User";
  name: string;
}

export interface DromoImportFragment {
  __typename: "DromoImport";
  /**
   * The origin ID of this import
   */
  id: string;
  /**
   * The Nutshell status type of this import
   */
  importStatus: ImportStatus;
  /**
   * Whether this import can be reverted right now.
   */
  canRevert: boolean;
  /**
   * The display status of the import
   */
  displayStatus: string;
  /**
   * The time the import was started
   */
  startTime: any | null;
  /**
   * The fileName of the import
   */
  fileName: string | null;
  /**
   * The URL of the original file uploaded by the user
   */
  dromoRawFileUrl: string | null;
  /**
   * The user who initiated this import
   */
  initiatingUser: DromoImportFragment_initiatingUser | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: Import2StatusFragment
// ====================================================

export interface Import2StatusFragment_crmOption {
  __typename: "CrmOption";
  /**
   * The enum type of this CRM option/tool
   */
  type: CrmOptionType;
  /**
   * The formatted label of this CRM option/tool
   */
  label: string;
}

export interface Import2StatusFragment_initiatingUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface Import2StatusFragment {
  __typename: "Import2Import";
  /**
   * The origin ID of this import
   */
  originId: string;
  /**
   * The CRM option of this import
   */
  crmOption: Import2StatusFragment_crmOption;
  /**
   * The Import2 status type of this import
   */
  import2Status: Import2Status;
  /**
   * The Nutshell status type of this import
   */
  importStatus: ImportStatus;
  /**
   * The external (sourced from Import2) id of this import
   */
  externalImportId: string;
  /**
   * The URL for the Import2 migration page
   */
  redirectUrl: string;
  /**
   * A list of errors that occurred during the import
   */
  errors: string[];
  /**
   * The time the import was started
   */
  startTime: any | null;
  /**
   * The time the import was finished
   */
  endTime: any | null;
  /**
   * Whether or not the import has been requested for review
   */
  reviewRequested: boolean;
  /**
   * Whether the import has been reviewed and approved
   */
  reviewApproved: boolean;
  /**
   * The user who initiated this import
   */
  initiatingUser: Import2StatusFragment_initiatingUser | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppIntegrationFragment
// ====================================================

export interface AppIntegrationFragment {
  __typename: "AppIntegration";
  /**
   * Stable catalog key
   */
  key: IntegrationKey;
  /**
   * Display name
   */
  name: string;
  /**
   * Marketplace categories
   */
  categories: IntegrationCategory[];
  /**
   * How the integration is provided
   */
  provider: IntegrationProvider;
  /**
   * Whether this integration is currently connected/enabled
   */
  isEnabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ConstantContactIntegration
// ====================================================

export interface ConstantContactIntegration {
  __typename: "ConstantContactIntegration";
  /**
   * The email address used for constant contact.
   */
  email: string | null;
  /**
   * True if the integration is active, false if the user disconnected it.
   */
  isIntegrationActive: boolean;
  /**
   * Are the user‘s contacts synced between Nutshell and CC.
   */
  isContactSyncActive: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LicenseInfoFragment
// ====================================================

export interface LicenseInfoFragment {
  __typename: "LicenseInfo";
  /**
   * The type of license
   */
  licenseType: LicenseType;
  /**
   * Whether the license is purchased
   */
  isPurchased: boolean;
  /**
   * The total amount of licenses purchased
   */
  numBought: number;
  /**
   * Whether the license is unlimited
   */
  isUnlimited: boolean;
  /**
   * The amount of licenses currently in use
   */
  numUsed: number;
  /**
   * The display name of the license
   */
  displayName: string;
  /**
   * Whether another license can be added
   */
  canAdd: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: RingCentralSmsInboxEndpointFragment
// ====================================================

export interface RingCentralSmsInboxEndpointFragment_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface RingCentralSmsInboxEndpointFragment_sourceChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: InboxChannelType;
}

export interface RingCentralSmsInboxEndpointFragment {
  __typename: "RingCentralSmsInboxEndpoint";
  /**
   * The connected RingCentral owner, or null if that user no longer exists.
   */
  owner: RingCentralSmsInboxEndpointFragment_owner | null;
  extensionNumber: string | null;
  phoneNumber: string;
  /**
   * The RingCentral source channel, or null if the stored channel no longer exists.
   */
  sourceChannel: RingCentralSmsInboxEndpointFragment_sourceChannel | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ProductFragment
// ====================================================

export interface ProductFragment_category {
  __typename: "ProductCategory";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product category
   */
  name: string;
  /**
   * The time the product category was created
   */
  createdTime: any;
  /**
   * The number of products associated with this category
   */
  numAssociatedProducts: number;
  /**
   * The link to the report for this product category
   */
  reportLink: string;
}

export interface ProductFragment_markets_edges_node {
  __typename: "Market";
  id: string;
  name: string;
  currency: string;
  currencySymbol: string;
  isDefault: boolean;
}

export interface ProductFragment_markets_edges_price {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The currency symbol (e.g. $, £, €, ¥)
   */
  symbol: string;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface ProductFragment_markets_edges {
  __typename: "ProductMarketsEdge";
  node: ProductFragment_markets_edges_node;
  /**
   * The price and currency of the product in the market.
   */
  price: ProductFragment_markets_edges_price | null;
  /**
   * Whether the product is available in the market.
   */
  isAvailable: boolean | null;
}

export interface ProductFragment_markets {
  __typename: "ProductMarketsConnection";
  /**
   * A list of edges.
   */
  edges: ProductFragment_markets_edges[];
}

export interface ProductFragment {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the product
   */
  name: string;
  /**
   * The description of the product
   */
  description: string | null;
  /**
   * The DateTime the product was created
   */
  createdTime: any;
  /**
   * The SKU of the product
   */
  sku: string;
  /**
   * The category of the product
   */
  category: ProductFragment_category | null;
  /**
   * The type of the product (Good or Service)
   */
  type: ProductType;
  /**
   * The term of the product
   */
  term: QuoteTerm | null;
  /**
   * The DateTime the product was last used
   */
  lastUsedTime: any | null;
  /**
   * The markets of the product
   */
  markets: ProductFragment_markets;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FilteredInvoiceFragment
// ====================================================

export interface FilteredInvoiceFragment_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface FilteredInvoiceFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface FilteredInvoiceFragment_lead_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface FilteredInvoiceFragment_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: FilteredInvoiceFragment_lead_assignee | null;
}

export interface FilteredInvoiceFragment {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The status of a quote that should be displayed to the user
   */
  displayStatus: QuoteDisplayStatus;
  /**
   * The slug of the quote
   */
  slug: string;
  /**
   * The string log of the last status update
   */
  statusLog: string;
  /**
   * The sharable view in browser link
   */
  shareableViewInBrowserLink: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The date the quote is valid until
   */
  validUntilDateFormatted: string;
  /**
   * The time the quote was sent
   */
  sentTime: any | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was published
   */
  publishedTime: any | null;
  /**
   * The time the quote was accepted
   */
  acceptedTime: any | null;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The total price of the quote after all modifiers
   */
  total: FilteredInvoiceFragment_total;
  /**
   * The user that created the quote
   */
  creatorUser: FilteredInvoiceFragment_creatorUser | null;
  /**
   * The lead the quote is associated with
   */
  lead: FilteredInvoiceFragment_lead;
  /**
   * A human readable string representing how long over due the invoice is
   */
  overdueDuration: string | null;
  /**
   * Whether the SalesDocument has been viewed
   */
  hasBeenViewed: boolean;
  /**
   * URL to view this invoice in QuickBooks, or null if it has not been sent to QuickBooks
   */
  quickbooksInvoiceUrl: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FilteredQuoteFragment
// ====================================================

export interface FilteredQuoteFragment_total {
  __typename: "Money";
  /**
   * The total decimal amount of the monetary value.
   */
  amount: number;
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface FilteredQuoteFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface FilteredQuoteFragment_lead_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface FilteredQuoteFragment_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: FilteredQuoteFragment_lead_assignee | null;
}

export interface FilteredQuoteFragment {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The status of a quote that should be displayed to the user
   */
  displayStatus: QuoteDisplayStatus;
  /**
   * The slug of the quote
   */
  slug: string;
  /**
   * The string log of the last status update
   */
  statusLog: string;
  /**
   * The sharable view in browser link
   */
  shareableViewInBrowserLink: string;
  /**
   * The time the quote was prepared
   */
  preparedTimeFormatted: string;
  /**
   * The date the quote is valid until
   */
  validUntilDateFormatted: string;
  /**
   * The time the quote was sent
   */
  sentTime: any | null;
  /**
   * The time the quote was created
   */
  createdTime: any;
  /**
   * The time the quote was published
   */
  publishedTime: any | null;
  /**
   * The time the quote was accepted
   */
  acceptedTime: any | null;
  /**
   * The time the quote was last modified
   */
  modifiedTime: any | null;
  /**
   * The total price of the quote after all modifiers
   */
  total: FilteredQuoteFragment_total;
  /**
   * The user that created the quote
   */
  creatorUser: FilteredQuoteFragment_creatorUser | null;
  /**
   * The lead the quote is associated with
   */
  lead: FilteredQuoteFragment_lead;
  /**
   * Whether the SalesDocument has been viewed
   */
  hasBeenViewed: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ScheduledReportFragment
// ====================================================

export interface ScheduledReportFragment_savedFilter {
  __typename: "SavedFilter";
  id: string;
  /**
   * The name of the saved filter
   */
  name: string;
  /**
   * The url path of the saved filter
   */
  htmlUrlPath: string;
}

export interface ScheduledReportFragment_user {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  htmlUrlPath: string | null;
}

export interface ScheduledReportFragment {
  __typename: "ScheduledReport";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  description: string | null;
  recurrenceRule: string;
  recipients: string[];
  isPaused: boolean;
  sourceType: ScheduledReportSourceType;
  lastRunTime: any | null;
  /**
   * Null when paused or when no upcoming occurrence can be calculated.
   */
  nextRunTime: any | null;
  savedFilter: ScheduledReportFragment_savedFilter | null;
  user: ScheduledReportFragment_user | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: WorkOsFragment
// ====================================================

export interface WorkOsFragment_domainInfo_domains {
  __typename: "OrganizationDomain";
  /**
   * The domain
   */
  domain: string;
  /**
   * Whether the domain is verified
   */
  isVerified: boolean;
  /**
   * Whether the domain is pinned
   */
  isMarkedAsPinned: boolean;
}

export interface WorkOsFragment_domainInfo {
  __typename: "DomainInfo";
  /**
   * The domains for the organization
   */
  domains: WorkOsFragment_domainInfo_domains[];
  /**
   * The admin portal for the organization
   */
  adminPortal: string | null;
}

export interface WorkOsFragment_sso_exemptUsers {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface WorkOsFragment_sso_nonExemptUsers {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface WorkOsFragment_sso {
  __typename: "Sso";
  /**
   * Whether the instance is allowed to setup SSO
   */
  canSetup: boolean;
  /**
   * Whether SSO is configured for the instance
   */
  isConfigured: boolean;
  /**
   * Whether SSO is required for the instance
   */
  isRequired: boolean;
  /**
   * The URL to the WorkOS admin portal
   */
  adminPortal: string | null;
  /**
   * The list of users exempt from SSO
   */
  exemptUsers: (WorkOsFragment_sso_exemptUsers | null)[] | null;
  /**
   * The list of users required to use SSO
   */
  nonExemptUsers: (WorkOsFragment_sso_nonExemptUsers | null)[] | null;
}

export interface WorkOsFragment_directorySync_defaultRole {
  __typename: "Role";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this role
   */
  name: string;
}

export interface WorkOsFragment_directorySync {
  __typename: "DirectorySync";
  /**
   * Whether the instance is allowed to setup Directory Sync
   */
  canSetup: boolean;
  /**
   * Whether directory sync is configured for the instance
   */
  isConfigured: boolean;
  /**
   * The URL to the WorkOS admin portal
   */
  adminPortal: string | null;
  /**
   * The default role for all new users added from this Active Directory
   */
  defaultRole: WorkOsFragment_directorySync_defaultRole | null;
  /**
   * The time of the last directory sync
   */
  lastSyncTime: any | null;
}

export interface WorkOsFragment {
  __typename: "WorkOs";
  /**
   * The WorkOS organization ID for the instance
   */
  organizationId: string | null;
  /**
   * The domain info for the instance
   */
  domainInfo: WorkOsFragment_domainInfo;
  /**
   * The SSO setup for the instance
   */
  sso: WorkOsFragment_sso;
  /**
   * Whether SSO is required for the instance
   */
  directorySync: WorkOsFragment_directorySync;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SourceFragment
// ====================================================

export interface SourceFragment_channel {
  __typename: "Channel";
  /**
   * The enum value of the source
   */
  value: ChannelType;
  /**
   * The title of the channel
   */
  title: string;
  /**
   * The description of the channel
   */
  description: string;
}

export interface SourceFragment {
  __typename: "Source";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The type of the source
   */
  type: SourceType;
  /**
   * The DateTime that represents when the Source was created
   */
  createdTime: any | null;
  /**
   * Can the user delete this source?
   */
  isDeleteable: boolean;
  /**
   * Can the user edit this source?
   */
  isEditable: boolean;
  /**
   * The DateTime the source was last used
   */
  lastUsedTime: any | null;
  /**
   * The channel associated with the source
   */
  channel: SourceFragment_channel | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: TaskSync
// ====================================================

export interface TaskSync {
  __typename: "TaskSync";
  /**
   * The email address being used for task sync
   */
  username: string;
  /**
   * The external task service we're syncing with
   */
  externalService: ExternalService;
  /**
   * Whether or not task sync is enabled
   */
  isEnabled: boolean;
  /**
   * Errors relating to the sync status of tasks
   */
  syncErrors: string[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EnrollmentFormFragment
// ====================================================

export interface EnrollmentFormFragment_values {
  __typename: "EnrollmentFormField";
  /**
   * The name (key) of this enrollment form field
   */
  name: EnrollmentFormFieldKey;
  /**
   * The value of this enrollment form field
   */
  value: string | null;
  /**
   * The error associated with this enrollment form field
   */
  error: string | null;
}

export interface EnrollmentFormFragment {
  __typename: "EnrollmentForm";
  /**
   * The status of this instances enrollment form
   */
  status: EnrollmentFormEnumStatus;
  /**
   * The values of this instances enrollment form
   */
  values: EnrollmentFormFragment_values[];
  /**
   * Whether the enrollment form can be submitted
   */
  canSubmit: boolean;
  /**
   * The reasons for Twilio rejections
   */
  twilioRejectionReasons: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InboxStatusFragment
// ====================================================

export interface InboxStatusFragment_enrollmentFormStatus_enrollmentForm {
  __typename: "EnrollmentForm";
  /**
   * Whether the enrollment form can be submitted
   */
  canSubmit: boolean;
  /**
   * The reasons for Twilio rejections
   */
  twilioRejectionReasons: string;
}

export interface InboxStatusFragment_enrollmentFormStatus {
  __typename: "EnrollmentFormStatus";
  /**
   * The status of the phone configuration
   */
  status: EnrollmentFormEnumStatus;
  /**
   * The enrollment form for this instance
   */
  enrollmentForm: InboxStatusFragment_enrollmentFormStatus_enrollmentForm;
}

export interface InboxStatusFragment_phoneStatus_nutshellChannel_phone {
  __typename: "PhoneValue";
  /**
   * The unique identifier (E164) of the phone number
   */
  id: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface InboxStatusFragment_phoneStatus_nutshellChannel {
  __typename: "InboxChannel";
  status: ChannelStatus;
  phone: InboxStatusFragment_phoneStatus_nutshellChannel_phone | null;
}

export interface InboxStatusFragment_phoneStatus {
  __typename: "PhoneStatus";
  /**
   * The status of the phone configuration
   */
  status: ChannelStatus;
  /**
   * The Inbox channel for this instance
   */
  nutshellChannel: InboxStatusFragment_phoneStatus_nutshellChannel | null;
}

export interface InboxStatusFragment_firstMessageStatus_message {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The content of the message
   */
  content: string;
}

export interface InboxStatusFragment_firstMessageStatus {
  __typename: "FirstMessageStatus";
  /**
   * Whether the first message has been sent
   */
  hasBeenSent: boolean;
  /**
   * The first message sent from this instance
   */
  message: InboxStatusFragment_firstMessageStatus_message | null;
}

export interface InboxStatusFragment_firstCampaignStatus_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface InboxStatusFragment_firstCampaignStatus {
  __typename: "FirstCampaignStatus";
  /**
   * Whether the first campaign has been sent
   */
  hasBeenSent: boolean;
  /**
   * The first campaign sent from this instance
   */
  campaign: InboxStatusFragment_firstCampaignStatus_campaign | null;
}

export interface InboxStatusFragment_planStatus {
  __typename: "PlanStatus";
  /**
   * The status of the instance inbox plan
   */
  status: InboxPlanEnum;
  /**
   * The number of remaining credits for this instance
   */
  remainingCredits: number;
  /**
   * How many messages are allowed to be sent this month
   */
  monthlyCredits: number;
  /**
   * How many messages were successfully sent this month
   */
  usedCredits: number;
}

export interface InboxStatusFragment {
  __typename: "InboxStatus";
  /**
   * The high-level status of the inbox setup
   */
  status: InboxStatusEnum;
  /**
   * This instance's enrollment form
   */
  enrollmentFormStatus: InboxStatusFragment_enrollmentFormStatus;
  /**
   * This instance's phone status
   */
  phoneStatus: InboxStatusFragment_phoneStatus;
  /**
   * Whether or not the first text has been sent
   */
  firstMessageStatus: InboxStatusFragment_firstMessageStatus;
  /**
   * Whether or not the first text has been sent
   */
  firstCampaignStatus: InboxStatusFragment_firstCampaignStatus;
  /**
   * This instance's inbox plan status
   */
  planStatus: InboxStatusFragment_planStatus;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserTableFragment
// ====================================================

export interface UserTableFragment_emailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The address string of this email.
   */
  address: string;
}

export interface UserTableFragment_teams {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface UserTableFragment_role {
  __typename: "Role";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this role
   */
  name: string;
}

export interface UserTableFragment_licenses {
  __typename: "UserLicenseInfo";
  /**
   * The type of the license
   */
  licenseType: LicenseType;
  /**
   * Whether the license is owned by the user
   */
  isOwned: boolean;
}

export interface UserTableFragment {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  redirectUrl: string | null;
  /**
   * Is the user currently permitted to login to Nutshell
   */
  isEnabled: boolean;
  /**
   * User emails configured for this user
   */
  emailAddresses: UserTableFragment_emailAddresses[];
  teams: UserTableFragment_teams[];
  role: UserTableFragment_role;
  /**
   * A list of all licenses and whether they are enabled for this user
   */
  licenses: UserTableFragment_licenses[];
  hasTwoFactorEnabled: boolean;
  hasMailSyncEnabled: boolean;
  lastSeen: any | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: RoleFragment
// ====================================================

export interface RoleFragment {
  __typename: "Role";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of this role
   */
  name: string;
  /**
   * The (order) position of this role
   */
  position: number;
  /**
   * Whether this role is immutable
   */
  isImmutable: boolean;
  /**
   * The permissions tied to this role
   */
  permissions: Permission[];
  /**
   * The number of users with this role
   */
  usersCount: number;
  /**
   * Whether this role is the default role for new users
   */
  isDefault: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FullActivity
// ====================================================

export interface FullActivity_participants_ActivityExternalAttendee {
  __typename: "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the external attendee, "Unknown attendee" if not set
   */
  name: string;
}

export interface FullActivity_participants_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface FullActivity_participants_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface FullActivity_participants_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface FullActivity_participants_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export type FullActivity_participants = FullActivity_participants_ActivityExternalAttendee | FullActivity_participants_Contact | FullActivity_participants_User | FullActivity_participants_Account | FullActivity_participants_Lead;

export interface FullActivity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * Canonical URL for an individual activity - launches a modal in this case
   */
  htmlUrl: string;
  /**
   * The DateTime that represents the start time of the Activity record
   */
  startTime: any;
  /**
   * The DateTime that represents the end time of the Activity record
   */
  endTime: any;
  /**
   * The boolean that represents whether or not the Activity has been logged (with
   * our without a message) for the purposes of completion/quota.
   */
  isLogged: boolean;
  /**
   * The boolean that represents whether or not the Activity represents an all day calendar event
   */
  isAllDay: boolean;
  /**
   * The boolean that represents whether or not the Activity is overdue.
   * Specifically, this means that the activity is not logged, and is in the past.
   */
  isOverdue: boolean;
  /**
   * Freeform text for public notes & agendas around the Nutshell Activity
   */
  agenda: string;
  /**
   * Whether the activity should show the new logging flow with video transcription and summary.
   */
  showTranscribeLoggingFlow: boolean;
  /**
   * The type of external service that the associated meeting belongs to
   */
  externalMeetingServiceType: ExternalServiceType | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: FullActivity_participants[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: NotificationFragment
// ====================================================

export interface NotificationFragment_destinationEntity_Account {
  __typename: "Account" | "Contact" | "Lead" | "Note" | "Comment" | "Reaction" | "Task" | "Step" | "UnknownEntityType" | "Submission" | "Form" | "Email" | "EmailAutomationStatus" | "Booking" | "User" | "Message" | "Quote" | "Invoice" | "DocumentView" | "Contract";
}

export interface NotificationFragment_destinationEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface NotificationFragment_destinationEntity_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type NotificationFragment_destinationEntity = NotificationFragment_destinationEntity_Account | NotificationFragment_destinationEntity_Activity | NotificationFragment_destinationEntity_Thread;

export interface NotificationFragment_triggeringUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface NotificationFragment_entity_Account {
  __typename: "Account" | "Note" | "Comment" | "Task" | "Step" | "UnknownEntityType" | "Submission" | "Form" | "Email" | "EmailAutomationStatus" | "Booking" | "User" | "DocumentView" | "Contract";
}

export interface NotificationFragment_entity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface NotificationFragment_entity_Lead {
  __typename: "Lead";
  avatarUrl: string;
  /**
   * Leads don’t have initials, but for interface reasons we’ll return an empty
   * string here instead of removing the property entirely.
   */
  initials: string;
}

export interface NotificationFragment_entity_Contact {
  __typename: "Contact";
  avatarUrl: string;
  initials: string;
}

export interface NotificationFragment_entity_Reaction {
  __typename: "Reaction";
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
}

export interface NotificationFragment_entity_Thread {
  __typename: "Thread";
  /**
   * The type of this thread
   */
  threadType: ThreadType;
}

export interface NotificationFragment_entity_Message_thread {
  __typename: "Thread";
  /**
   * The type of this thread
   */
  threadType: ThreadType;
}

export interface NotificationFragment_entity_Message {
  __typename: "Message";
  /**
   * The thread this message is part of
   */
  thread: NotificationFragment_entity_Message_thread;
}

export interface NotificationFragment_entity_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface NotificationFragment_entity_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type NotificationFragment_entity = NotificationFragment_entity_Account | NotificationFragment_entity_Activity | NotificationFragment_entity_Lead | NotificationFragment_entity_Contact | NotificationFragment_entity_Reaction | NotificationFragment_entity_Thread | NotificationFragment_entity_Message | NotificationFragment_entity_Quote | NotificationFragment_entity_Invoice;

export interface NotificationFragment {
  __typename: "Notification";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of notification
   */
  type: NotificationType;
  destinationEntity: NotificationFragment_destinationEntity | null;
  /**
   * The user that triggered this notification. Can be null if created by an origin
   */
  triggeringUser: NotificationFragment_triggeringUser | null;
  /**
   * Read status of this notification
   */
  readStatus: NotificationReadStatus;
  /**
   * Message of the notification
   */
  content: string;
  /**
   * First line of the notification entity the notification is about
   */
  preview: string;
  /**
   * Time that the notification was created
   */
  createdTime: any;
  htmlUrl: string | null;
  /**
   * The primary entity of this notification. Note that this is different than the
   * destinationEntity in some cases, like comments and reactions. When someone
   * comments on a note, the Comment is the entity, and the Note is the destination entity
   */
  entity: NotificationFragment_entity;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AccountSearchResult
// ====================================================

export interface AccountSearchResult_primaryContact {
  __typename: "Contact";
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface AccountSearchResult_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface AccountSearchResult_phones_primary {
  __typename: "Phone";
  value: AccountSearchResult_phones_primary_value;
}

export interface AccountSearchResult_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountSearchResult_phones_primary | null;
}

export interface AccountSearchResult_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  city: string | null;
  postalCode: string | null;
}

export interface AccountSearchResult_postalAddresses_primary {
  __typename: "PostalAddress";
  value: AccountSearchResult_postalAddresses_primary_value;
}

export interface AccountSearchResult_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountSearchResult_postalAddresses_primary | null;
}

export interface AccountSearchResult {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The descriptive name of the Nutshell Contact, with special characters html encoded
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * The primary contact for this account
   */
  primaryContact: AccountSearchResult_primaryContact | null;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: AccountSearchResult_phones;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: AccountSearchResult_postalAddresses;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContactSearchResult
// ====================================================

export interface ContactSearchResult_accounts_primary {
  __typename: "Account";
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface ContactSearchResult_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: ContactSearchResult_accounts_primary | null;
}

export interface ContactSearchResult_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface ContactSearchResult_phones_primary {
  __typename: "Phone";
  value: ContactSearchResult_phones_primary_value;
}

export interface ContactSearchResult_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: ContactSearchResult_phones_primary | null;
}

export interface ContactSearchResult_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface ContactSearchResult_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: ContactSearchResult_emailAddresses_primary_value;
}

export interface ContactSearchResult_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: ContactSearchResult_emailAddresses_primary | null;
}

export interface ContactSearchResult {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The descriptive name of the Nutshell Contact, with special characters html encoded
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: ContactSearchResult_accounts;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: ContactSearchResult_phones;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: ContactSearchResult_emailAddresses;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadSearchResult
// ====================================================

export interface LeadSearchResult_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LeadSearchResult_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: LeadSearchResult_contacts_primaryEdge_node;
}

export interface LeadSearchResult_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LeadSearchResult_contacts_primaryEdge | null;
}

export interface LeadSearchResult_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LeadSearchResult_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: LeadSearchResult_accounts_primaryEdge_node;
}

export interface LeadSearchResult_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LeadSearchResult_accounts_primaryEdge | null;
}

export interface LeadSearchResult_value_formattedValue {
  __typename: "FormattedValue";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The optional suffix of the value, usually for currency ($, £, etc)
   */
  prefix: string;
  /**
   * The optional suffix of the value (k, m, etc)
   */
  suffix: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface LeadSearchResult_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The flexible formatted representation of this monetary value
   */
  formattedValue: LeadSearchResult_value_formattedValue;
}

export interface LeadSearchResult {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead, with html encoded special characters
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  avatarUrl: string;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  /**
   * The time this lead did or will become overdue
   */
  overdueTime: any | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: LeadSearchResult_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: LeadSearchResult_accounts;
  value: LeadSearchResult_value | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmartSequenceEntityFilterFieldConfig
// ====================================================

export interface SmartSequenceEntityFilterFieldConfig_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface SmartSequenceEntityFilterFieldConfig_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface SmartSequenceEntityFilterFieldConfig_EntityFilterFieldConfigDateTimeBetween {
  __typename: "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The earlier date to test if an entity date time is between 2 dates.
   */
  startDate: any;
  /**
   * The later date to test if an entity date time is between 2 dates.
   */
  endDate: any;
}

export interface SmartSequenceEntityFilterFieldConfig_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface SmartSequenceEntityFilterFieldConfig_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface SmartSequenceEntityFilterFieldConfig_EntityFilterFieldConfigStrings {
  __typename: "EntityFilterFieldConfigStrings";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substrings to search for.
   */
  stringsContain: string;
}

export interface SmartSequenceEntityFilterFieldConfig_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export interface SmartSequenceEntityFilterFieldConfig_EntityFilterFieldConfigInteger {
  __typename: "EntityFilterFieldConfigInteger";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this integer field.
   */
  integerValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  integerComparator: Comparator;
}

export interface SmartSequenceEntityFilterFieldConfig_EntityFilterFieldConfigPhone {
  __typename: "EntityFilterFieldConfigPhone";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string of digits to match on when filtering on phone numbers.
   */
  startsWith: string;
}

export interface SmartSequenceEntityFilterFieldConfig_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type SmartSequenceEntityFilterFieldConfig = SmartSequenceEntityFilterFieldConfig_EntityFilterFieldConfigBoolean | SmartSequenceEntityFilterFieldConfig_EntityFilterFieldConfigCurrency | SmartSequenceEntityFilterFieldConfig_EntityFilterFieldConfigDateTimeBetween | SmartSequenceEntityFilterFieldConfig_EntityFilterFieldConfigRelationship | SmartSequenceEntityFilterFieldConfig_EntityFilterFieldConfigString | SmartSequenceEntityFilterFieldConfig_EntityFilterFieldConfigStrings | SmartSequenceEntityFilterFieldConfig_EntityFilterFieldConfigEnum | SmartSequenceEntityFilterFieldConfig_EntityFilterFieldConfigInteger | SmartSequenceEntityFilterFieldConfig_EntityFilterFieldConfigPhone | SmartSequenceEntityFilterFieldConfig_EntityFilterFieldConfigIsSet;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmartSequenceCampaignUpdateFragment
// ====================================================

export interface SmartSequenceCampaignUpdateFragment_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
}

export interface SmartSequenceCampaignUpdateFragment_from_emailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface SmartSequenceCampaignUpdateFragment_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface SmartSequenceCampaignUpdateFragment_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: SmartSequenceCampaignUpdateFragment_from_emailAddress;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: SmartSequenceCampaignUpdateFragment_from_fromDomain | null;
}

export interface SmartSequenceCampaignUpdateFragment {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * Should messages only be sent during business hours.
   */
  isBusinessHoursOnly: boolean;
  useUtmParameters: boolean;
  utmParameters: SmartSequenceCampaignUpdateFragment_utmParameters;
  /**
   * The address to send this edition from
   */
  from: SmartSequenceCampaignUpdateFragment_from | null;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * When a lead is closed, should drip sequences stop?
   */
  isStopOnLeadClose: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmartSequenceCopySelectFragment
// ====================================================

export interface SmartSequenceCopySelectFragment {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmartSequenceEdgeFragment
// ====================================================

export interface SmartSequenceEdgeFragment {
  __typename: "SmartSequenceEdge";
  id: string;
  /**
   * The parent node API id.
   */
  source: string;
  /**
   * The child node API id.
   */
  target: string;
  /**
   * Decision branch label for this edge, if applicable.
   */
  branch: SmartSequenceParentBranch | null;
  /**
   * Human-readable count of recipients that entered this decision branch.
   */
  recipientSummary: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmartSequenceFragment
// ====================================================

export interface SmartSequenceFragment_utmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
}

export interface SmartSequenceFragment_defaultUtmParameters {
  __typename: "UtmParameters";
  /**
   * The source utm parameter.
   */
  source: string | null;
  /**
   * The medium utm parameter.
   */
  medium: string | null;
}

export interface SmartSequenceFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SmartSequenceFragment_owner {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SmartSequenceFragment_from_emailAddress {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  formatted: string;
}

export interface SmartSequenceFragment_from_fromDomain {
  __typename: "FromDomain";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The DKIM verification status for SES
   */
  sesDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellMailfromStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell
   */
  nutshellDkimStatus: FromDomainStatus;
  /**
   * The DKIM verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedNutshellDkimStatus: FromDomainStatus;
  /**
   * The DMARC verification status for Nutshell, guaranteed to be no more than 1 hour old
   */
  refreshedDmarcStatus: FromDomainStatus;
}

export interface SmartSequenceFragment_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status for this email address
   */
  status: FromAddressStatus;
  /**
   * The from email address
   */
  emailAddress: SmartSequenceFragment_from_emailAddress;
  /**
   * The mailfrom verification status for SES
   */
  sesMailfromStatus: FromDomainStatus;
  /**
   * The domain this email address is associated with
   */
  fromDomain: SmartSequenceFragment_from_fromDomain | null;
}

export interface SmartSequenceFragment_customClickDomain {
  __typename: "FromDomain";
  /**
   * If the domain has been verified
   */
  isVerified: boolean;
}

export interface SmartSequenceFragment_startTriggers_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface SmartSequenceFragment_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface SmartSequenceFragment_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface SmartSequenceFragment_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type SmartSequenceFragment_startTriggers_conditions_config_ConditionConfigEntityFilter_filter = SmartSequenceFragment_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | SmartSequenceFragment_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | SmartSequenceFragment_startTriggers_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface SmartSequenceFragment_startTriggers_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: SmartSequenceFragment_startTriggers_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface SmartSequenceFragment_startTriggers_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface SmartSequenceFragment_startTriggers_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type SmartSequenceFragment_startTriggers_conditions_config = SmartSequenceFragment_startTriggers_conditions_config_ConditionConfigLink | SmartSequenceFragment_startTriggers_conditions_config_ConditionConfigEntityFilter | SmartSequenceFragment_startTriggers_conditions_config_ConditionConfigTag | SmartSequenceFragment_startTriggers_conditions_config_ConditionConfigAudience;

export interface SmartSequenceFragment_startTriggers_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: SmartSequenceFragment_startTriggers_conditions_config;
}

export interface SmartSequenceFragment_startTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of startTrigger
   */
  type: StartTriggerType;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * A list of conditions which must be true to activate this startTrigger.
   */
  conditions: SmartSequenceFragment_startTriggers_conditions[];
}

export interface SmartSequenceFragment_goal_conditions_config_ConditionConfigSourceEntity {
  __typename: "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface SmartSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface SmartSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface SmartSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type SmartSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter = SmartSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | SmartSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | SmartSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface SmartSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: SmartSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface SmartSequenceFragment_goal_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export interface SmartSequenceFragment_goal_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface SmartSequenceFragment_goal_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type SmartSequenceFragment_goal_conditions_config = SmartSequenceFragment_goal_conditions_config_ConditionConfigSourceEntity | SmartSequenceFragment_goal_conditions_config_ConditionConfigEntityFilter | SmartSequenceFragment_goal_conditions_config_ConditionConfigLink | SmartSequenceFragment_goal_conditions_config_ConditionConfigTag | SmartSequenceFragment_goal_conditions_config_ConditionConfigAudience;

export interface SmartSequenceFragment_goal_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: SmartSequenceFragment_goal_conditions_config;
}

export interface SmartSequenceFragment_goal_action_config_ActionConfigRemoveTags {
  __typename: "ActionConfigRemoveTags" | "ActionConfigSendPageViewedNotification" | "ActionConfigAddToDripSequence" | "ActionConfigCreateLead" | "ActionConfigSendEmail";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
}

export interface SmartSequenceFragment_goal_action_config_ActionConfigAddTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface SmartSequenceFragment_goal_action_config_ActionConfigAddTags {
  __typename: "ActionConfigAddTags";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  tags: SmartSequenceFragment_goal_action_config_ActionConfigAddTags_tags[];
}

export interface SmartSequenceFragment_goal_action_config_ActionConfigAddAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface SmartSequenceFragment_goal_action_config_ActionConfigAddAudiences {
  __typename: "ActionConfigAddAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: SmartSequenceFragment_goal_action_config_ActionConfigAddAudiences_audiences[];
}

export interface SmartSequenceFragment_goal_action_config_ActionConfigRemoveAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface SmartSequenceFragment_goal_action_config_ActionConfigRemoveAudiences {
  __typename: "ActionConfigRemoveAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: SmartSequenceFragment_goal_action_config_ActionConfigRemoveAudiences_audiences[];
}

export type SmartSequenceFragment_goal_action_config = SmartSequenceFragment_goal_action_config_ActionConfigRemoveTags | SmartSequenceFragment_goal_action_config_ActionConfigAddTags | SmartSequenceFragment_goal_action_config_ActionConfigAddAudiences | SmartSequenceFragment_goal_action_config_ActionConfigRemoveAudiences;

export interface SmartSequenceFragment_goal_action {
  __typename: "Action";
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * Human readable title of this action
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this action. This is essentially just the
   * stringified version of the action’s conditions, but because a action can have
   * multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The configuration for this action.
   */
  config: SmartSequenceFragment_goal_action_config;
}

export interface SmartSequenceFragment_goal {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Calculated goal type based on conditions. This is not saved in the database
   */
  type: DripSequenceGoalType;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this goal. This is essentially just the stringified
   * version of the goal’s conditions, but because a goal can have multiple
   * conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * A list of conditions which must be true to activate this goal.
   */
  conditions: SmartSequenceFragment_goal_conditions[];
  /**
   * The optional action (next step in this context) that will run when this goal is met
   */
  action: SmartSequenceFragment_goal_action | null;
}

export interface SmartSequenceFragment_engagementStats {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email reply rate
   */
  replyRate: number | null;
  /**
   * Unique email replies
   */
  replyCount: number;
  /**
   * Unique email clicks
   */
  clickCount: number;
  /**
   * Email click rate
   */
  clickRate: number | null;
  /**
   * Unique email opens
   */
  openCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email permanent bounce rate
   */
  permanentBounceRate: number | null;
  /**
   * Unique permanent bounces
   */
  permanentBounceCount: number;
  /**
   * Email unsubscribe rate
   */
  unsubscribeRate: number | null;
  /**
   * Unique unsubscribes
   */
  unsubscribeCount: number;
  /**
   * The last time this particular piece of content was sent. This is slow to
   * calculate on a one-off basis so we chuck it in here.
   */
  latestDeliveryTime: any | null;
  /**
   * For edition base stats, the total number of drip progressions in any state for the related campaigns
   */
  dripProgressionTotalRecipients: number;
  /**
   * For edition base stats, the number of drip progressions that have stopped for the related campaigns
   */
  dripProgressionsStopped: number;
  /**
   * For edition base stats, the number of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMet: number;
  /**
   * For edition base stats, the percentage of drip progressions where the goal was met for the related campaigns
   */
  dripProgressionsGoalMetRate: number | null;
  /**
   * For edition base stats, the percentage of drip progressions that received every message for the related campaigns
   */
  dripProgressionsReceivedEveryMessageRate: number | null;
}

export interface SmartSequenceFragment_nodes_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface SmartSequenceFragment_nodes_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
}

export interface SmartSequenceFragment_nodes_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The email template for this edition
   */
  emailTemplate: SmartSequenceFragment_nodes_edition_emailTemplate | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SmartSequenceFragment_nodes_automation_actions_config_ActionConfigSendPageViewedNotification {
  __typename: "ActionConfigSendPageViewedNotification" | "ActionConfigSendEmail";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
}

export interface SmartSequenceFragment_nodes_automation_actions_config_ActionConfigAddTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SmartSequenceFragment_nodes_automation_actions_config_ActionConfigAddTags {
  __typename: "ActionConfigAddTags";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  tags: SmartSequenceFragment_nodes_automation_actions_config_ActionConfigAddTags_tags[];
}

export interface SmartSequenceFragment_nodes_automation_actions_config_ActionConfigRemoveTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SmartSequenceFragment_nodes_automation_actions_config_ActionConfigRemoveTags {
  __typename: "ActionConfigRemoveTags";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The tags to remove.
   */
  tags: SmartSequenceFragment_nodes_automation_actions_config_ActionConfigRemoveTags_tags[];
}

export interface SmartSequenceFragment_nodes_automation_actions_config_ActionConfigAddAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface SmartSequenceFragment_nodes_automation_actions_config_ActionConfigAddAudiences {
  __typename: "ActionConfigAddAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: SmartSequenceFragment_nodes_automation_actions_config_ActionConfigAddAudiences_audiences[];
}

export interface SmartSequenceFragment_nodes_automation_actions_config_ActionConfigRemoveAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface SmartSequenceFragment_nodes_automation_actions_config_ActionConfigRemoveAudiences {
  __typename: "ActionConfigRemoveAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: SmartSequenceFragment_nodes_automation_actions_config_ActionConfigRemoveAudiences_audiences[];
}

export interface SmartSequenceFragment_nodes_automation_actions_config_ActionConfigAddToDripSequence_dripSequence {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface SmartSequenceFragment_nodes_automation_actions_config_ActionConfigAddToDripSequence {
  __typename: "ActionConfigAddToDripSequence";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The drip sequence to which the contact should be added.
   */
  dripSequence: SmartSequenceFragment_nodes_automation_actions_config_ActionConfigAddToDripSequence_dripSequence;
}

export interface SmartSequenceFragment_nodes_automation_actions_config_ActionConfigCreateLead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface SmartSequenceFragment_nodes_automation_actions_config_ActionConfigCreateLead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SmartSequenceFragment_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SmartSequenceFragment_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface SmartSequenceFragment_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type SmartSequenceFragment_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule = SmartSequenceFragment_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_User | SmartSequenceFragment_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_Team | SmartSequenceFragment_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule;

export interface SmartSequenceFragment_nodes_automation_actions_config_ActionConfigCreateLead {
  __typename: "ActionConfigCreateLead";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The stageset to which the lead should be added.
   */
  stageset: SmartSequenceFragment_nodes_automation_actions_config_ActionConfigCreateLead_stageset;
  /**
   * The tags which should be added to the lead.
   */
  tags: SmartSequenceFragment_nodes_automation_actions_config_ActionConfigCreateLead_tags[];
  /**
   * The assignee for the lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: SmartSequenceFragment_nodes_automation_actions_config_ActionConfigCreateLead_assigneeOrRule | null;
}

export type SmartSequenceFragment_nodes_automation_actions_config = SmartSequenceFragment_nodes_automation_actions_config_ActionConfigSendPageViewedNotification | SmartSequenceFragment_nodes_automation_actions_config_ActionConfigAddTags | SmartSequenceFragment_nodes_automation_actions_config_ActionConfigRemoveTags | SmartSequenceFragment_nodes_automation_actions_config_ActionConfigAddAudiences | SmartSequenceFragment_nodes_automation_actions_config_ActionConfigRemoveAudiences | SmartSequenceFragment_nodes_automation_actions_config_ActionConfigAddToDripSequence | SmartSequenceFragment_nodes_automation_actions_config_ActionConfigCreateLead;

export interface SmartSequenceFragment_nodes_automation_actions {
  __typename: "Action";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * The configuration for this action.
   */
  config: SmartSequenceFragment_nodes_automation_actions_config;
}

export interface SmartSequenceFragment_nodes_automation_predicates_trigger {
  __typename: "Trigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of event which activates this trigger.
   */
  type: TriggerType;
}

export interface SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
}

export interface SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigTag_tagEntities {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
  /**
   * The tags this condition matches.
   */
  tagEntities: SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigTag_tagEntities[];
}

export interface SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export interface SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigSourceEntity {
  __typename: "ConditionConfigSourceEntity";
  sourceEntityId: string | null;
}

export interface SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  url: SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl_url;
}

export interface SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed {
  __typename: "ConditionConfigPageViewed";
  maUrlId: string | null;
  maUrl: SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl | null;
}

export interface SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigFormSubmission_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigFormSubmission {
  __typename: "ConditionConfigFormSubmission";
  formId: string | null;
  form: SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigFormSubmission_form | null;
}

export interface SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigDateTimeBetween {
  __typename: "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The earlier date to test if an entity date time is between 2 dates.
   */
  startDate: any;
  /**
   * The later date to test if an entity date time is between 2 dates.
   */
  endDate: any;
}

export interface SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigStrings {
  __typename: "EntityFilterFieldConfigStrings";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substrings to search for.
   */
  stringsContain: string;
}

export interface SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export interface SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigInteger {
  __typename: "EntityFilterFieldConfigInteger";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this integer field.
   */
  integerValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  integerComparator: Comparator;
}

export interface SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigPhone {
  __typename: "EntityFilterFieldConfigPhone";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string of digits to match on when filtering on phone numbers.
   */
  startsWith: string;
}

export interface SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter = SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigDateTimeBetween | SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigStrings | SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigInteger | SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigPhone | SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter;
}

export type SmartSequenceFragment_nodes_automation_predicates_conditions_config = SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigAudience | SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigTag | SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigLink | SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigSourceEntity | SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigPageViewed | SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigFormSubmission | SmartSequenceFragment_nodes_automation_predicates_conditions_config_ConditionConfigEntityFilter;

export interface SmartSequenceFragment_nodes_automation_predicates_conditions {
  __typename: "Condition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this condition relative to its siblings.
   */
  position: number;
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: SmartSequenceFragment_nodes_automation_predicates_conditions_config;
}

export interface SmartSequenceFragment_nodes_automation_predicates {
  __typename: "Predicate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this predicate relative to its siblings.
   */
  position: number;
  /**
   * The trigger that will initiate execution of this predicate.
   */
  trigger: SmartSequenceFragment_nodes_automation_predicates_trigger;
  /**
   * The conditions that must be true for this predicate to activate an automation.
   */
  conditions: SmartSequenceFragment_nodes_automation_predicates_conditions[];
}

export interface SmartSequenceFragment_nodes_automation {
  __typename: "Automation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Actions that will be taken when this automation is activated.
   */
  actions: SmartSequenceFragment_nodes_automation_actions[];
  /**
   * A list of predicates which can activate this automation.
   */
  predicates: SmartSequenceFragment_nodes_automation_predicates[];
}

export interface SmartSequenceFragment_nodes_recipientTracking_emailEngagement {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
}

export interface SmartSequenceFragment_nodes_recipientTracking {
  __typename: "SmartSequenceNodeRecipientTracking";
  /**
   * Human-readable recipient count for the node banner (e.g. "24 recipients waiting").
   */
  recipientSummary: string | null;
  /**
   * Email delivery and engagement stats for send-email nodes.
   */
  emailEngagement: SmartSequenceFragment_nodes_recipientTracking_emailEngagement | null;
}

export interface SmartSequenceFragment_nodes {
  __typename: "SmartSequenceNode";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: SmartSequenceNodeType;
  parentNodeId: string | null;
  parentBranch: SmartSequenceParentBranch | null;
  delay: SmartSequenceFragment_nodes_delay | null;
  edition: SmartSequenceFragment_nodes_edition | null;
  automation: SmartSequenceFragment_nodes_automation | null;
  /**
   * Recipient progression and engagement display data for the canvas node.
   */
  recipientTracking: SmartSequenceFragment_nodes_recipientTracking | null;
}

export interface SmartSequenceFragment_edges {
  __typename: "SmartSequenceEdge";
  id: string;
  /**
   * The parent node API id.
   */
  source: string;
  /**
   * The child node API id.
   */
  target: string;
  /**
   * Decision branch label for this edge, if applicable.
   */
  branch: SmartSequenceParentBranch | null;
  /**
   * Human-readable count of recipients that entered this decision branch.
   */
  recipientSummary: string | null;
}

export interface SmartSequenceFragment {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  description: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The DateTime that represents when the campaign was last modified
   */
  modifiedTime: any | null;
  /**
   * Time of the last campaign status change. For example, if a customer activated
   * this sequence and its still active, this would be the time the sequence was
   * activated. Once the campaign status is changed (paused, retired, etc) this
   * would reflect that new time
   */
  lastStatusChangeTime: any | null;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * Whether the drip sequence should have a remove option
   */
  isRemovable: boolean;
  /**
   * Should messages only be sent during business hours.
   */
  isBusinessHoursOnly: boolean;
  useUtmParameters: boolean;
  utmParameters: SmartSequenceFragment_utmParameters;
  defaultUtmParameters: SmartSequenceFragment_defaultUtmParameters;
  /**
   * When a goal is met, should the drip sequence stop?
   */
  isStopOnGoal: boolean;
  /**
   * When a lead is closed, should drip sequences stop?
   */
  isStopOnLeadClose: boolean;
  /**
   * When a person is removed from an audience, should drip sequences stop?
   */
  isStopOnRemovedFromAudience: boolean;
  /**
   * Number of in progress drip progressions for the drip sequence
   */
  numInProgressDripProgressions: number;
  creatorUser: SmartSequenceFragment_creatorUser | null;
  /**
   * The user who owns this campaign
   */
  owner: SmartSequenceFragment_owner | null;
  /**
   * The address to send this edition from
   */
  from: SmartSequenceFragment_from | null;
  /**
   * The custom click domain that this campaign will use to track links, if there is one
   */
  customClickDomain: SmartSequenceFragment_customClickDomain | null;
  /**
   * The start triggers for the smart sequence.
   */
  startTriggers: SmartSequenceFragment_startTriggers[];
  /**
   * The newly created Nutshell goal
   */
  goal: SmartSequenceFragment_goal | null;
  engagementStats: SmartSequenceFragment_engagementStats;
  /**
   * Unique undeleted contacts that have entered this sequence (any progression
   * state). Live count — not engagement-stats cache.
   */
  uniqueEnteredRecipients: number;
  nodes: SmartSequenceFragment_nodes[];
  edges: SmartSequenceFragment_edges[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmartSequenceGoalFragment
// ====================================================

export interface SmartSequenceGoalFragment_conditions_config_ConditionConfigSourceEntity {
  __typename: "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface SmartSequenceGoalFragment_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface SmartSequenceGoalFragment_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface SmartSequenceGoalFragment_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type SmartSequenceGoalFragment_conditions_config_ConditionConfigEntityFilter_filter = SmartSequenceGoalFragment_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | SmartSequenceGoalFragment_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | SmartSequenceGoalFragment_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface SmartSequenceGoalFragment_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: SmartSequenceGoalFragment_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface SmartSequenceGoalFragment_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export interface SmartSequenceGoalFragment_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface SmartSequenceGoalFragment_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type SmartSequenceGoalFragment_conditions_config = SmartSequenceGoalFragment_conditions_config_ConditionConfigSourceEntity | SmartSequenceGoalFragment_conditions_config_ConditionConfigEntityFilter | SmartSequenceGoalFragment_conditions_config_ConditionConfigLink | SmartSequenceGoalFragment_conditions_config_ConditionConfigTag | SmartSequenceGoalFragment_conditions_config_ConditionConfigAudience;

export interface SmartSequenceGoalFragment_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: SmartSequenceGoalFragment_conditions_config;
}

export interface SmartSequenceGoalFragment_action_config_ActionConfigRemoveTags {
  __typename: "ActionConfigRemoveTags" | "ActionConfigSendPageViewedNotification" | "ActionConfigAddToDripSequence" | "ActionConfigCreateLead" | "ActionConfigSendEmail";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
}

export interface SmartSequenceGoalFragment_action_config_ActionConfigAddTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
}

export interface SmartSequenceGoalFragment_action_config_ActionConfigAddTags {
  __typename: "ActionConfigAddTags";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  tags: SmartSequenceGoalFragment_action_config_ActionConfigAddTags_tags[];
}

export interface SmartSequenceGoalFragment_action_config_ActionConfigAddAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface SmartSequenceGoalFragment_action_config_ActionConfigAddAudiences {
  __typename: "ActionConfigAddAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: SmartSequenceGoalFragment_action_config_ActionConfigAddAudiences_audiences[];
}

export interface SmartSequenceGoalFragment_action_config_ActionConfigRemoveAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface SmartSequenceGoalFragment_action_config_ActionConfigRemoveAudiences {
  __typename: "ActionConfigRemoveAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: SmartSequenceGoalFragment_action_config_ActionConfigRemoveAudiences_audiences[];
}

export type SmartSequenceGoalFragment_action_config = SmartSequenceGoalFragment_action_config_ActionConfigRemoveTags | SmartSequenceGoalFragment_action_config_ActionConfigAddTags | SmartSequenceGoalFragment_action_config_ActionConfigAddAudiences | SmartSequenceGoalFragment_action_config_ActionConfigRemoveAudiences;

export interface SmartSequenceGoalFragment_action {
  __typename: "Action";
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * Human readable title of this action
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this action. This is essentially just the
   * stringified version of the action’s conditions, but because a action can have
   * multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * The configuration for this action.
   */
  config: SmartSequenceGoalFragment_action_config;
}

export interface SmartSequenceGoalFragment {
  __typename: "DripSequenceGoal";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Calculated goal type based on conditions. This is not saved in the database
   */
  type: DripSequenceGoalType;
  /**
   * Human readable title of this goal
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this goal. This is essentially just the stringified
   * version of the goal’s conditions, but because a goal can have multiple
   * conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * A list of conditions which must be true to activate this goal.
   */
  conditions: SmartSequenceGoalFragment_conditions[];
  /**
   * The optional action (next step in this context) that will run when this goal is met
   */
  action: SmartSequenceGoalFragment_action | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmartSequenceNodeFragment
// ====================================================

export interface SmartSequenceNodeFragment_delay {
  __typename: "Timespan";
  /**
   * The unit to measure this duration of time.
   */
  unit: DueDateUnit;
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface SmartSequenceNodeFragment_edition_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
}

export interface SmartSequenceNodeFragment_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The public link to view this edition in the browser
   */
  viewInBrowserLink: string;
  /**
   * Boolean indicating if the edition contains the required unsubscribe link.
   */
  hasUnsubscribeLink: boolean;
  /**
   * Boolean indicating if the edition contains the required address tag.
   */
  hasStreetAddress: boolean;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The email template for this edition
   */
  emailTemplate: SmartSequenceNodeFragment_edition_emailTemplate | null;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SmartSequenceNodeFragment_automation_actions_config_ActionConfigSendPageViewedNotification {
  __typename: "ActionConfigSendPageViewedNotification" | "ActionConfigSendEmail";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
}

export interface SmartSequenceNodeFragment_automation_actions_config_ActionConfigAddTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SmartSequenceNodeFragment_automation_actions_config_ActionConfigAddTags {
  __typename: "ActionConfigAddTags";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  tags: SmartSequenceNodeFragment_automation_actions_config_ActionConfigAddTags_tags[];
}

export interface SmartSequenceNodeFragment_automation_actions_config_ActionConfigRemoveTags_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SmartSequenceNodeFragment_automation_actions_config_ActionConfigRemoveTags {
  __typename: "ActionConfigRemoveTags";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The tags to remove.
   */
  tags: SmartSequenceNodeFragment_automation_actions_config_ActionConfigRemoveTags_tags[];
}

export interface SmartSequenceNodeFragment_automation_actions_config_ActionConfigAddAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface SmartSequenceNodeFragment_automation_actions_config_ActionConfigAddAudiences {
  __typename: "ActionConfigAddAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: SmartSequenceNodeFragment_automation_actions_config_ActionConfigAddAudiences_audiences[];
}

export interface SmartSequenceNodeFragment_automation_actions_config_ActionConfigRemoveAudiences_audiences {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The audience name
   */
  name: string;
}

export interface SmartSequenceNodeFragment_automation_actions_config_ActionConfigRemoveAudiences {
  __typename: "ActionConfigRemoveAudiences";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The boolean value to filter on.
   */
  audiences: SmartSequenceNodeFragment_automation_actions_config_ActionConfigRemoveAudiences_audiences[];
}

export interface SmartSequenceNodeFragment_automation_actions_config_ActionConfigAddToDripSequence_dripSequence {
  __typename: "Campaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface SmartSequenceNodeFragment_automation_actions_config_ActionConfigAddToDripSequence {
  __typename: "ActionConfigAddToDripSequence";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The drip sequence to which the contact should be added.
   */
  dripSequence: SmartSequenceNodeFragment_automation_actions_config_ActionConfigAddToDripSequence_dripSequence;
}

export interface SmartSequenceNodeFragment_automation_actions_config_ActionConfigCreateLead_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface SmartSequenceNodeFragment_automation_actions_config_ActionConfigCreateLead_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SmartSequenceNodeFragment_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SmartSequenceNodeFragment_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_Team {
  __typename: "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Team.
   */
  name: string;
}

export interface SmartSequenceNodeFragment_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule {
  __typename: "LeadAssigneeRule";
  /**
   * The assignment rule to use for the lead
   */
  assignmentRule: LeadAssigneeRuleEnum | null;
}

export type SmartSequenceNodeFragment_automation_actions_config_ActionConfigCreateLead_assigneeOrRule = SmartSequenceNodeFragment_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_User | SmartSequenceNodeFragment_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_Team | SmartSequenceNodeFragment_automation_actions_config_ActionConfigCreateLead_assigneeOrRule_LeadAssigneeRule;

export interface SmartSequenceNodeFragment_automation_actions_config_ActionConfigCreateLead {
  __typename: "ActionConfigCreateLead";
  /**
   * Is this action’s config valid (deleted entities, maybe?)
   */
  isValid: boolean;
  /**
   * The stageset to which the lead should be added.
   */
  stageset: SmartSequenceNodeFragment_automation_actions_config_ActionConfigCreateLead_stageset;
  /**
   * The tags which should be added to the lead.
   */
  tags: SmartSequenceNodeFragment_automation_actions_config_ActionConfigCreateLead_tags[];
  /**
   * The assignee for the lead or the assignment rule to use (ex. auto assign)
   */
  assigneeOrRule: SmartSequenceNodeFragment_automation_actions_config_ActionConfigCreateLead_assigneeOrRule | null;
}

export type SmartSequenceNodeFragment_automation_actions_config = SmartSequenceNodeFragment_automation_actions_config_ActionConfigSendPageViewedNotification | SmartSequenceNodeFragment_automation_actions_config_ActionConfigAddTags | SmartSequenceNodeFragment_automation_actions_config_ActionConfigRemoveTags | SmartSequenceNodeFragment_automation_actions_config_ActionConfigAddAudiences | SmartSequenceNodeFragment_automation_actions_config_ActionConfigRemoveAudiences | SmartSequenceNodeFragment_automation_actions_config_ActionConfigAddToDripSequence | SmartSequenceNodeFragment_automation_actions_config_ActionConfigCreateLead;

export interface SmartSequenceNodeFragment_automation_actions {
  __typename: "Action";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of action that will be run.
   */
  type: ActionType;
  /**
   * The configuration for this action.
   */
  config: SmartSequenceNodeFragment_automation_actions_config;
}

export interface SmartSequenceNodeFragment_automation_predicates_trigger {
  __typename: "Trigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of event which activates this trigger.
   */
  type: TriggerType;
}

export interface SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
}

export interface SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigTag_tagEntities {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
  /**
   * The tags this condition matches.
   */
  tagEntities: SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigTag_tagEntities[];
}

export interface SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  links: string[];
}

export interface SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigSourceEntity {
  __typename: "ConditionConfigSourceEntity";
  sourceEntityId: string | null;
}

export interface SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https: // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  url: SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl_url;
}

export interface SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigPageViewed {
  __typename: "ConditionConfigPageViewed";
  maUrlId: string | null;
  maUrl: SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigPageViewed_maUrl | null;
}

export interface SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigFormSubmission_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The public facing id for this web form
   */
  publicFormId: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigFormSubmission {
  __typename: "ConditionConfigFormSubmission";
  formId: string | null;
  form: SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigFormSubmission_form | null;
}

export interface SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean {
  __typename: "EntityFilterFieldConfigBoolean";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The boolean value to filter on.
   */
  booleanValue: boolean;
}

export interface SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency {
  __typename: "EntityFilterFieldConfigCurrency";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The logical comparator to be used in this filter.
   */
  currencyComparator: Comparator;
  /**
   * The numeric value for this currency field.
   */
  currencyValue: number | null;
  /**
   * The currency code for this value.
   */
  currencyCode: string;
}

export interface SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigDateTimeBetween {
  __typename: "EntityFilterFieldConfigDateTimeBetween";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The earlier date to test if an entity date time is between 2 dates.
   */
  startDate: any;
  /**
   * The later date to test if an entity date time is between 2 dates.
   */
  endDate: any;
}

export interface SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
}

export interface SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString {
  __typename: "EntityFilterFieldConfigString";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substring to search for.
   */
  stringContains: string;
}

export interface SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigStrings {
  __typename: "EntityFilterFieldConfigStrings";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The substrings to search for.
   */
  stringsContain: string;
}

export interface SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export interface SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigInteger {
  __typename: "EntityFilterFieldConfigInteger";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The numeric value for this integer field.
   */
  integerValue: number | null;
  /**
   * The logical comparator to be used in this filter.
   */
  integerComparator: Comparator;
}

export interface SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigPhone {
  __typename: "EntityFilterFieldConfigPhone";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * The string of digits to match on when filtering on phone numbers.
   */
  startsWith: string;
}

export interface SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet";
  /**
   * The field name that will be checked on the entity.
   */
  fieldName: string;
  /**
   * The field type that will be checked.
   */
  fieldType: EntityFieldType;
  /**
   * If true, this filter will match entities that have a value for this field. If
   * false, this filter will match entities that do NOT have a value.
   */
  isSetValue: boolean;
}

export type SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter = SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigBoolean | SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigCurrency | SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigDateTimeBetween | SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigString | SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigStrings | SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum | SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigInteger | SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigPhone | SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet;

export interface SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter_filter;
}

export type SmartSequenceNodeFragment_automation_predicates_conditions_config = SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigAudience | SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigTag | SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigLink | SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigSourceEntity | SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigPageViewed | SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigFormSubmission | SmartSequenceNodeFragment_automation_predicates_conditions_config_ConditionConfigEntityFilter;

export interface SmartSequenceNodeFragment_automation_predicates_conditions {
  __typename: "Condition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this condition relative to its siblings.
   */
  position: number;
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: SmartSequenceNodeFragment_automation_predicates_conditions_config;
}

export interface SmartSequenceNodeFragment_automation_predicates {
  __typename: "Predicate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The position of this predicate relative to its siblings.
   */
  position: number;
  /**
   * The trigger that will initiate execution of this predicate.
   */
  trigger: SmartSequenceNodeFragment_automation_predicates_trigger;
  /**
   * The conditions that must be true for this predicate to activate an automation.
   */
  conditions: SmartSequenceNodeFragment_automation_predicates_conditions[];
}

export interface SmartSequenceNodeFragment_automation {
  __typename: "Automation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Actions that will be taken when this automation is activated.
   */
  actions: SmartSequenceNodeFragment_automation_actions[];
  /**
   * A list of predicates which can activate this automation.
   */
  predicates: SmartSequenceNodeFragment_automation_predicates[];
}

export interface SmartSequenceNodeFragment_recipientTracking_emailEngagement {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
}

export interface SmartSequenceNodeFragment_recipientTracking {
  __typename: "SmartSequenceNodeRecipientTracking";
  /**
   * Human-readable recipient count for the node banner (e.g. "24 recipients waiting").
   */
  recipientSummary: string | null;
  /**
   * Email delivery and engagement stats for send-email nodes.
   */
  emailEngagement: SmartSequenceNodeFragment_recipientTracking_emailEngagement | null;
}

export interface SmartSequenceNodeFragment {
  __typename: "SmartSequenceNode";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: SmartSequenceNodeType;
  parentNodeId: string | null;
  parentBranch: SmartSequenceParentBranch | null;
  delay: SmartSequenceNodeFragment_delay | null;
  edition: SmartSequenceNodeFragment_edition | null;
  automation: SmartSequenceNodeFragment_automation | null;
  /**
   * Recipient progression and engagement display data for the canvas node.
   */
  recipientTracking: SmartSequenceNodeFragment_recipientTracking | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmartSequenceNodeRecipientTrackingFragment
// ====================================================

export interface SmartSequenceNodeRecipientTrackingFragment_emailEngagement {
  __typename: "EngagementStats";
  /**
   * Total number of emails delivered
   */
  totalSentCount: number;
  /**
   * Email open rate
   */
  openRate: number | null;
  /**
   * Email click rate
   */
  clickRate: number | null;
}

export interface SmartSequenceNodeRecipientTrackingFragment {
  __typename: "SmartSequenceNodeRecipientTracking";
  /**
   * Human-readable recipient count for the node banner (e.g. "24 recipients waiting").
   */
  recipientSummary: string | null;
  /**
   * Email delivery and engagement stats for send-email nodes.
   */
  emailEngagement: SmartSequenceNodeRecipientTrackingFragment_emailEngagement | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmartSequenceRecipientEngagementFragment
// ====================================================

export interface SmartSequenceRecipientEngagementFragment_averageTimeInSequence {
  __typename: "FormattedValueDuration";
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formatted: string;
  /**
   * The user-readable formatted value of this valuefor the clients to echo out in the UI
   */
  formattedString: string;
  /**
   * The raw decimal amount of the formatted value.
   */
  value: number;
}

export interface SmartSequenceRecipientEngagementFragment {
  __typename: "SmartSequenceRecipientEngagement";
  /**
   * Number of recipients currently in the sequence (not yet exited).
   */
  activeRecipients: number;
  /**
   * Total number of recipients in the sequence.
   */
  totalRecipients: number;
  /**
   * Average time recipients spend in the sequence before completing (goal met or
   * reached an end node) or dropping off (unsubscribed, manually removed, bounced,
   * lead closed, audience removed, or email could not be sent e.g. missing merge
   * fields). Null when there is no population to compute over.
   */
  averageTimeInSequence: SmartSequenceRecipientEngagementFragment_averageTimeInSequence | null;
  /**
   * Share of recipients (0–1) who reached a sequence end state or achieved the
   * sequence goal. Null when there is no population to compute over.
   */
  sequenceCompletionRate: number | null;
  /**
   * Share of recipients (0–1) who exited unsuccessfully before completion
   * (unsubscribed, manually removed, bounced, lead closed, audience removed, or
   * email could not be sent e.g. missing merge fields). Null when there is no
   * population to compute over.
   */
  dropOffRate: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmartSequenceSparseFragment
// ====================================================

export interface SmartSequenceSparseFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SmartSequenceSparseFragment_startTriggers {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
}

export interface SmartSequenceSparseFragment_from_emailAddress {
  __typename: "NutEmailAddress";
  formatted: string;
}

export interface SmartSequenceSparseFragment_from {
  __typename: "FromAddress";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The from email address
   */
  emailAddress: SmartSequenceSparseFragment_from_emailAddress;
}

export interface SmartSequenceSparseFragment_editions_edges_node_emailTemplate {
  __typename: "EmailTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  previewText: string;
  /**
   * Email template thumbnail
   */
  thumbnailUrl: string | null;
}

export interface SmartSequenceSparseFragment_editions_edges_node {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The background color of this page
   */
  backgroundColor: string;
  /**
   * The email template for this edition
   */
  emailTemplate: SmartSequenceSparseFragment_editions_edges_node_emailTemplate | null;
}

export interface SmartSequenceSparseFragment_editions_edges {
  __typename: "EditionsEdge";
  node: SmartSequenceSparseFragment_editions_edges_node;
}

export interface SmartSequenceSparseFragment_editions {
  __typename: "EditionsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: SmartSequenceSparseFragment_editions_edges[];
}

export interface SmartSequenceSparseFragment {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The status of the campaign
   */
  status: CampaignStatus;
  /**
   * Time of the last campaign status change. For example, if a customer activated
   * this sequence and its still active, this would be the time the sequence was
   * activated. Once the campaign status is changed (paused, retired, etc) this
   * would reflect that new time
   */
  lastStatusChangeTime: any | null;
  /**
   * The DateTime that represents when the campaign was created
   */
  createdTime: any;
  /**
   * The deleted time for the campaign if it has been deleted.
   */
  deletedTime: any | null;
  creatorUser: SmartSequenceSparseFragment_creatorUser | null;
  /**
   * The start triggers for the smart sequence.
   */
  startTriggers: SmartSequenceSparseFragment_startTriggers[];
  /**
   * Unique undeleted contacts that have entered this sequence (any progression
   * state). Live count — not engagement-stats cache.
   */
  uniqueEnteredRecipients: number;
  /**
   * The address to send this edition from
   */
  from: SmartSequenceSparseFragment_from | null;
  editions: SmartSequenceSparseFragment_editions;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmartSequenceStartTriggerFragment
// ====================================================

export interface SmartSequenceStartTriggerFragment_conditions_config_ConditionConfigLink {
  __typename: "ConditionConfigLink" | "ConditionConfigSourceEntity" | "ConditionConfigPageViewed" | "ConditionConfigFormSubmission";
}

export interface SmartSequenceStartTriggerFragment_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet {
  __typename: "EntityFilterFieldConfigIsSet" | "EntityFilterFieldConfigBoolean" | "EntityFilterFieldConfigCurrency" | "EntityFilterFieldConfigInteger" | "EntityFilterFieldConfigPhone" | "EntityFilterFieldConfigString" | "EntityFilterFieldConfigStrings" | "EntityFilterFieldConfigDateTimeBetween";
}

export interface SmartSequenceStartTriggerFragment_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship {
  __typename: "EntityFilterFieldConfigRelationship";
  /**
   * The search type for this relationship filter.
   */
  relationshipAnyAll: AnyAll;
  /**
   * The list of strings to use in the any all relationship filter.
   */
  relationshipData: string[];
}

export interface SmartSequenceStartTriggerFragment_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum {
  __typename: "EntityFilterFieldConfigEnum";
  /**
   * The string enum value to filter on.
   */
  enumValue: string;
  /**
   * If enumIsNot is true, the condition will be true if the entity does NOT match the specified value.
   */
  enumIsNot: boolean;
}

export type SmartSequenceStartTriggerFragment_conditions_config_ConditionConfigEntityFilter_filter = SmartSequenceStartTriggerFragment_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigIsSet | SmartSequenceStartTriggerFragment_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigRelationship | SmartSequenceStartTriggerFragment_conditions_config_ConditionConfigEntityFilter_filter_EntityFilterFieldConfigEnum;

export interface SmartSequenceStartTriggerFragment_conditions_config_ConditionConfigEntityFilter {
  __typename: "ConditionConfigEntityFilter";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  filter: SmartSequenceStartTriggerFragment_conditions_config_ConditionConfigEntityFilter_filter;
}

export interface SmartSequenceStartTriggerFragment_conditions_config_ConditionConfigTag {
  __typename: "ConditionConfigTag";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  tags: string[];
}

export interface SmartSequenceStartTriggerFragment_conditions_config_ConditionConfigAudience {
  __typename: "ConditionConfigAudience";
  /**
   * The filter that the entity must match for this condition to be true.
   */
  audiences: string[];
}

export type SmartSequenceStartTriggerFragment_conditions_config = SmartSequenceStartTriggerFragment_conditions_config_ConditionConfigLink | SmartSequenceStartTriggerFragment_conditions_config_ConditionConfigEntityFilter | SmartSequenceStartTriggerFragment_conditions_config_ConditionConfigTag | SmartSequenceStartTriggerFragment_conditions_config_ConditionConfigAudience;

export interface SmartSequenceStartTriggerFragment_conditions {
  __typename: "Condition";
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
  /**
   * The configuration for this condition.
   */
  config: SmartSequenceStartTriggerFragment_conditions_config;
}

export interface SmartSequenceStartTriggerFragment {
  __typename: "StartTrigger";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of startTrigger
   */
  type: StartTriggerType;
  /**
   * Human readable title of this startTrigger
   */
  humanReadableTitle: string;
  /**
   * Human readable subtitle of this startTrigger. This is essentially just the
   * stringified version of the startTrigger’s conditions, but because a
   * startTrigger can have multiple conditions, we do some work munging those together
   */
  humanReadableSubtitle: string;
  /**
   * A list of conditions which must be true to activate this startTrigger.
   */
  conditions: SmartSequenceStartTriggerFragment_conditions[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmartSequenceStopSettingsFragment
// ====================================================

export interface SmartSequenceStopSettingsFragment {
  __typename: "SmartSequence";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * When a lead is closed, should drip sequences stop?
   */
  isStopOnLeadClose: boolean;
  /**
   * When a person is removed from an audience, should drip sequences stop?
   */
  isStopOnRemovedFromAudience: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SmartSequenceRecipientDripProgressionFragment
// ====================================================

export interface SmartSequenceRecipientDripProgressionFragment_audienceMember_audience {
  __typename: "Audience";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface SmartSequenceRecipientDripProgressionFragment_audienceMember_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SmartSequenceRecipientDripProgressionFragment_audienceMember_entity_Contact_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  display: string | null;
}

export interface SmartSequenceRecipientDripProgressionFragment_audienceMember_entity_Contact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: SmartSequenceRecipientDripProgressionFragment_audienceMember_entity_Contact_emailAddresses_primary_value;
}

export interface SmartSequenceRecipientDripProgressionFragment_audienceMember_entity_Contact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: SmartSequenceRecipientDripProgressionFragment_audienceMember_entity_Contact_emailAddresses_primary | null;
}

export interface SmartSequenceRecipientDripProgressionFragment_audienceMember_entity_Contact_accounts_primary {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface SmartSequenceRecipientDripProgressionFragment_audienceMember_entity_Contact_accounts {
  __typename: "ContactAccountsConnection";
  /**
   * Primary account for this contact
   */
  primary: SmartSequenceRecipientDripProgressionFragment_audienceMember_entity_Contact_accounts_primary | null;
}

export interface SmartSequenceRecipientDripProgressionFragment_audienceMember_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: SmartSequenceRecipientDripProgressionFragment_audienceMember_entity_Contact_emailAddresses;
  /**
   * Accounts (Companies in the app UI) that the contact is related to
   */
  accounts: SmartSequenceRecipientDripProgressionFragment_audienceMember_entity_Contact_accounts;
}

export type SmartSequenceRecipientDripProgressionFragment_audienceMember_entity = SmartSequenceRecipientDripProgressionFragment_audienceMember_entity_Account | SmartSequenceRecipientDripProgressionFragment_audienceMember_entity_Contact;

export interface SmartSequenceRecipientDripProgressionFragment_audienceMember {
  __typename: "AudienceMember";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent audience
   */
  audience: SmartSequenceRecipientDripProgressionFragment_audienceMember_audience;
  /**
   * The member entity
   */
  entity: SmartSequenceRecipientDripProgressionFragment_audienceMember_entity;
}

export interface SmartSequenceRecipientDripProgressionFragment {
  __typename: "DripProgression";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The time the next edition in the drip is scheduled to send, or null if ended
   */
  nextEditionSendTime: any | null;
  /**
   * The audience member this drip progression is for
   */
  audienceMember: SmartSequenceRecipientDripProgressionFragment_audienceMember;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: Task
// ====================================================

export interface Task_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  name: string;
}

export interface Task_recurrenceRule {
  __typename: "RecurrenceRule";
  /**
   * An RRULE-compatible string defining the recurrence pattern (e.g. "FREQ=WEEKLY;BYDAY=MO").
   */
  rule: string;
  mode: RecurrenceMode;
}

export interface Task_relatedEntity_ActivityExternalAttendee {
  __typename: "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the external attendee, "Unknown attendee" if not set
   */
  name: string;
}

export interface Task_relatedEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface Task_relatedEntity_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
}

export interface Task_relatedEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface Task_relatedEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export type Task_relatedEntity = Task_relatedEntity_ActivityExternalAttendee | Task_relatedEntity_Lead | Task_relatedEntity_User | Task_relatedEntity_Contact | Task_relatedEntity_Account;

export interface Task {
  __typename: "Task";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API type for this model.
   */
  type: string;
  /**
   * The canonical API href for the task
   */
  href: string;
  /**
   * The name/title of the task
   */
  title: string;
  /**
   * The task’s user-defined description
   */
  description: string | null;
  /**
   * The due timestamp of the task
   */
  dueTime: any | null;
  /**
   * The person or team assigned to this task
   */
  assignee: Task_assignee | null;
  /**
   * The DateTime that represents when the Activity record was created
   */
  createdTime: any;
  /**
   * The DateTime that represents when the Task record was created
   */
  completedTime: any | null;
  /**
   * The DateTime that represents when the Task record was created
   */
  deletedTime: any | null;
  /**
   * Null if the task does not recur under the new recurrence system.
   */
  recurrenceRule: Task_recurrenceRule | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  relatedEntity: Task_relatedEntity | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AccountContext
// ====================================================

export interface AccountContext_industry {
  __typename: "NutshellIndustry";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human description of the industry
   */
  name: string | null;
}

export interface AccountContext_primaryContact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  name: string;
}

export interface AccountContext_primaryContact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountContext_primaryContact_emailAddresses_primary | null;
}

export interface AccountContext_primaryContact_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface AccountContext_primaryContact_phones_primary {
  __typename: "Phone";
  name: string;
  value: AccountContext_primaryContact_phones_primary_value;
}

export interface AccountContext_primaryContact_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountContext_primaryContact_phones_primary | null;
}

export interface AccountContext_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: AccountContext_primaryContact_emailAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: AccountContext_primaryContact_phones;
}

export interface AccountContext_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface AccountContext_emailAddresses_primary {
  __typename: "EmailAddressEav";
  name: string;
}

export interface AccountContext_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountContext_emailAddresses_primary | null;
}

export interface AccountContext_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface AccountContext_phones_primary {
  __typename: "Phone";
  name: string;
  value: AccountContext_phones_primary_value;
}

export interface AccountContext_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountContext_phones_primary | null;
}

export interface AccountContext_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  address_1: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
}

export interface AccountContext_postalAddresses_primary {
  __typename: "PostalAddress";
  name: string;
  value: AccountContext_postalAddresses_primary_value;
}

export interface AccountContext_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: AccountContext_postalAddresses_primary | null;
}

export interface AccountContext {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The industry of this account
   */
  industry: AccountContext_industry | null;
  /**
   * The primary contact for this account
   */
  primaryContact: AccountContext_primaryContact | null;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: AccountContext_owner | null;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: AccountContext_emailAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: AccountContext_phones;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: AccountContext_postalAddresses;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContactContext
// ====================================================

export interface ContactContext_emailAddresses_primary {
  __typename: "EmailAddressEav";
  name: string;
}

export interface ContactContext_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: ContactContext_emailAddresses_primary | null;
}

export interface ContactContext_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface ContactContext_phones_primary {
  __typename: "Phone";
  name: string;
  value: ContactContext_phones_primary_value;
}

export interface ContactContext_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: ContactContext_phones_primary | null;
}

export interface ContactContext {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: ContactContext_emailAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: ContactContext_phones;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadContext
// ====================================================

export interface LeadContext_territory {
  __typename: "Territory";
  id: string | null;
  name: string | null;
}

export interface LeadContext_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadContext_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadContext_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface LeadContext_clonedFrom {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface LeadContext_accounts_edges_node_industry {
  __typename: "NutshellIndustry";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human description of the industry
   */
  name: string | null;
}

export interface LeadContext_accounts_edges_node_primaryContact_emailAddresses_primary {
  __typename: "EmailAddressEav";
  name: string;
}

export interface LeadContext_accounts_edges_node_primaryContact_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: LeadContext_accounts_edges_node_primaryContact_emailAddresses_primary | null;
}

export interface LeadContext_accounts_edges_node_primaryContact_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface LeadContext_accounts_edges_node_primaryContact_phones_primary {
  __typename: "Phone";
  name: string;
  value: LeadContext_accounts_edges_node_primaryContact_phones_primary_value;
}

export interface LeadContext_accounts_edges_node_primaryContact_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: LeadContext_accounts_edges_node_primaryContact_phones_primary | null;
}

export interface LeadContext_accounts_edges_node_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: LeadContext_accounts_edges_node_primaryContact_emailAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: LeadContext_accounts_edges_node_primaryContact_phones;
}

export interface LeadContext_accounts_edges_node_owner {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadContext_accounts_edges_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  name: string;
}

export interface LeadContext_accounts_edges_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: LeadContext_accounts_edges_node_emailAddresses_primary | null;
}

export interface LeadContext_accounts_edges_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface LeadContext_accounts_edges_node_phones_primary {
  __typename: "Phone";
  name: string;
  value: LeadContext_accounts_edges_node_phones_primary_value;
}

export interface LeadContext_accounts_edges_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: LeadContext_accounts_edges_node_phones_primary | null;
}

export interface LeadContext_accounts_edges_node_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  address_1: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
}

export interface LeadContext_accounts_edges_node_postalAddresses_primary {
  __typename: "PostalAddress";
  name: string;
  value: LeadContext_accounts_edges_node_postalAddresses_primary_value;
}

export interface LeadContext_accounts_edges_node_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: LeadContext_accounts_edges_node_postalAddresses_primary | null;
}

export interface LeadContext_accounts_edges_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The created time for this peep.
   */
  createdTime: any;
  /**
   * The industry of this account
   */
  industry: LeadContext_accounts_edges_node_industry | null;
  /**
   * The primary contact for this account
   */
  primaryContact: LeadContext_accounts_edges_node_primaryContact | null;
  /**
   * The user or team assigned to this person or company. Also referred to as "owner" within the product
   */
  owner: LeadContext_accounts_edges_node_owner | null;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: LeadContext_accounts_edges_node_emailAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: LeadContext_accounts_edges_node_phones;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: LeadContext_accounts_edges_node_postalAddresses;
}

export interface LeadContext_accounts_edges {
  __typename: "LeadAccountsEdge";
  node: LeadContext_accounts_edges_node;
}

export interface LeadContext_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * A list of edges.
   */
  edges: LeadContext_accounts_edges[];
}

export interface LeadContext_contacts_edges_node_emailAddresses_primary {
  __typename: "EmailAddressEav";
  name: string;
}

export interface LeadContext_contacts_edges_node_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: LeadContext_contacts_edges_node_emailAddresses_primary | null;
}

export interface LeadContext_contacts_edges_node_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface LeadContext_contacts_edges_node_phones_primary {
  __typename: "Phone";
  name: string;
  value: LeadContext_contacts_edges_node_phones_primary_value;
}

export interface LeadContext_contacts_edges_node_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: LeadContext_contacts_edges_node_phones_primary | null;
}

export interface LeadContext_contacts_edges_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The human description of the peep
   */
  description: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: LeadContext_contacts_edges_node_emailAddresses;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: LeadContext_contacts_edges_node_phones;
}

export interface LeadContext_contacts_edges {
  __typename: "LeadContactsEdge";
  node: LeadContext_contacts_edges_node;
}

export interface LeadContext_contacts {
  __typename: "LeadContactsConnection";
  /**
   * A list of edges.
   */
  edges: LeadContext_contacts_edges[];
}

export interface LeadContext_pipelineStages_current {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The time this stage was deleted, or null if this stage has not been deleted.
   */
  deletedTime: any | null;
  /**
   * The default avatarUrl for this stage (green)
   */
  avatarUrl: string;
}

export interface LeadContext_pipelineStages_edges_node_stageset {
  __typename: "Stageset";
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
}

export interface LeadContext_pipelineStages_edges_node {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The stageset this stage belongs to
   */
  stageset: LeadContext_pipelineStages_edges_node_stageset;
}

export interface LeadContext_pipelineStages_edges {
  __typename: "LeadStagesEdge";
  node: LeadContext_pipelineStages_edges_node;
}

export interface LeadContext_pipelineStages {
  __typename: "LeadStagesConnection";
  /**
   * Active stage relationship for this lead
   */
  current: LeadContext_pipelineStages_current | null;
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: LeadContext_pipelineStages_edges[];
}

export interface LeadContext_stageset {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  name: string;
  /**
   * If this stageset is archived or not
   */
  isArchived: boolean;
}

export interface LeadContext_tags {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The different type of entity that this tag belongs to (e.g., a Lead, or a Contact)
   */
  tagType: TagType;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface LeadContext_tagMaps_edges_creator {
  __typename: "User" | "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadContext_tagMaps_edges_node {
  __typename: "Tag";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the source
   */
  name: string;
  /**
   * The different type of entity that this tag belongs to (e.g., a Lead, or a Contact)
   */
  tagType: TagType;
  /**
   * The color for this Tag
   */
  color: TagColor;
}

export interface LeadContext_tagMaps_edges {
  __typename: "TagMapsEdge";
  /**
   * The creator of this tag map
   */
  creator: LeadContext_tagMaps_edges_creator | null;
  /**
   * The DateTime that represents when the Tag was mapped
   */
  createdTime: any | null;
  node: LeadContext_tagMaps_edges_node | null;
}

export interface LeadContext_tagMaps {
  __typename: "TagMapsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * A list of edges.
   */
  edges: LeadContext_tagMaps_edges[];
}

export interface LeadContext_outcome {
  __typename: "Outcome";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LeadContext_sendToDestinations {
  __typename: "EntityDestination";
  /**
   * The descriptive name for this destination.
   */
  name: string;
  /**
   * The URL this destination should direct to.
   */
  localUrl: string;
}

export interface LeadContext_externalResources {
  __typename: "ExternalResource";
  /**
   * The ID of the external resource.
   */
  externalId: string;
  /**
   * The name of the external service this resource belongs to.
   */
  externalService: ExternalService;
  /**
   * The type of external resource.
   */
  externalResourceType: ExternalResourceType;
}

export interface LeadContext {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The bcc address of the Nutshell Lead.
   */
  bccAddress: string;
  number: number | null;
  /**
   * The terrority to which this lead is assigned.
   */
  territory: LeadContext_territory | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  /**
   * Is this lead "Hot"?
   */
  isHot: boolean;
  /**
   * Is this lead "Overdue"? Overdue generally means that the lead is behind a
   * designated schedule dictated by its associated sales process
   */
  isOverdue: boolean;
  /**
   * The created time for the lead.
   */
  createdTime: any;
  /**
   * The deleted time for the lead if it has been deleted.
   */
  deletedTime: any | null;
  /**
   * The percentage confidence of lead success.
   */
  confidence: number;
  /**
   * The closed time for the lead.
   */
  closedTime: any | null;
  /**
   * The anticipated close time for the lead.
   */
  anticipatedClosedTime: any | null;
  /**
   * What time does this lead become overdue in the active stage? Null if no overdue time is set.
   */
  stageOverdueTime: any | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: LeadContext_assignee | null;
  /**
   * The deemed "creator" of this lead. If a user has created the lead manually,
   * our UI will show the user, otherwise we’ll fallback to the origin, i.e. "API"
   * or "CSV import"
   */
  creator: LeadContext_creator;
  value: LeadContext_value | null;
  /**
   * The lead this lead was cloned from (usually null)
   */
  clonedFrom: LeadContext_clonedFrom | null;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: LeadContext_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: LeadContext_contacts;
  /**
   * Stages for the lead
   */
  pipelineStages: LeadContext_pipelineStages;
  /**
   * Stageset associated with the given lead
   */
  stageset: LeadContext_stageset | null;
  /**
   * The list of tags on this lead
   */
  tags: LeadContext_tags[];
  /**
   * Tag maps for the lead
   */
  tagMaps: LeadContext_tagMaps | null;
  /**
   * The outcome for this lead, if there is one.
   */
  outcome: LeadContext_outcome | null;
  /**
   * The list of destinations for this lead
   */
  sendToDestinations: LeadContext_sendToDestinations[];
  /**
   * External resources mapped to this lead
   */
  externalResources: LeadContext_externalResources[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ProductContext
// ====================================================

export interface ProductContext {
  __typename: "Product";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  productId: string;
  /**
   * The name of the product
   */
  productName: string;
  /**
   * The type of the product (Good or Service)
   */
  goodOrService: ProductType;
  /**
   * The term of the product
   */
  serviceTerm: QuoteTerm | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: StagesetContext
// ====================================================

export interface StagesetContext_stages_activeStepTemplates_dueDate {
  __typename: "StepDueDate";
  /**
   * The reference point for this due date. This can include when the lead was created, when the stage was entered, etc.
   */
  dueFrom: number;
  /**
   * The unit to measure this step template’s due date.This could be days or hours or their business equalivents.
   */
  dueUnit: DueDateUnit;
  /**
   * The timespan after dueFrom in units of dueUnit for this step template’s due date. Is a number.
   */
  dueTimespan: number;
}

export interface StagesetContext_stages_activeStepTemplates_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface StagesetContext_stages_activeStepTemplates_processTemplate_closedLeadAutomations_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface StagesetContext_stages_activeStepTemplates_processTemplate_closedLeadAutomations_emailAutomations {
  __typename: "ClosedLeadEmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this subscription.
   */
  emailList: StagesetContext_stages_activeStepTemplates_processTemplate_closedLeadAutomations_emailAutomations_emailList | null;
}

export interface StagesetContext_stages_activeStepTemplates_processTemplate_closedLeadAutomations_slackAutomations {
  __typename: "ClosedLeadSlackMessage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name for this slack automation.
   */
  name: string;
}

export interface StagesetContext_stages_activeStepTemplates_processTemplate_closedLeadAutomations_accountTypeAutomations_accountType {
  __typename: "AccountType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type name
   */
  name: string;
}

export interface StagesetContext_stages_activeStepTemplates_processTemplate_closedLeadAutomations_accountTypeAutomations_conditions {
  __typename: "Condition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of condition which is neccessary to execute this automation.
   */
  type: ConditionType;
}

export interface StagesetContext_stages_activeStepTemplates_processTemplate_closedLeadAutomations_accountTypeAutomations {
  __typename: "AccountTypeAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The account type that linked accounts will be changed to.
   */
  accountType: StagesetContext_stages_activeStepTemplates_processTemplate_closedLeadAutomations_accountTypeAutomations_accountType;
  /**
   * A list of conditions which must be true to activate this automation.
   */
  conditions: StagesetContext_stages_activeStepTemplates_processTemplate_closedLeadAutomations_accountTypeAutomations_conditions[];
}

export interface StagesetContext_stages_activeStepTemplates_processTemplate_closedLeadAutomations {
  __typename: "ClosedLeadAutomations";
  /**
   * The type of event which activates this trigger.
   */
  outcomeType: OutcomeType;
  /**
   * Email list subscriptions to be created when lead enters this outcome type
   */
  emailAutomations: StagesetContext_stages_activeStepTemplates_processTemplate_closedLeadAutomations_emailAutomations[];
  /**
   * Slack automations
   */
  slackAutomations: StagesetContext_stages_activeStepTemplates_processTemplate_closedLeadAutomations_slackAutomations[];
  /**
   * Account type automations
   */
  accountTypeAutomations: StagesetContext_stages_activeStepTemplates_processTemplate_closedLeadAutomations_accountTypeAutomations[];
}

export interface StagesetContext_stages_activeStepTemplates_processTemplate_emailAutomations_emailList {
  __typename: "EmailSequenceTemplate" | "ConstantContactList" | "MailChimpList";
  /**
   * The id of the list.
   */
  id: string;
  /**
   * The remote name of the list.
   */
  name: string | null;
}

export interface StagesetContext_stages_activeStepTemplates_processTemplate_emailAutomations_entersStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
}

export interface StagesetContext_stages_activeStepTemplates_processTemplate_emailAutomations_exitsStage {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  name: string;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
}

export interface StagesetContext_stages_activeStepTemplates_processTemplate_emailAutomations_delay {
  __typename: "Timespan";
  /**
   * The number of units for this duration of time.
   */
  timespan: number;
}

export interface StagesetContext_stages_activeStepTemplates_processTemplate_emailAutomations_sendFromUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface StagesetContext_stages_activeStepTemplates_processTemplate_emailAutomations {
  __typename: "EmailAutomation";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The email list associated with this stage subscription.
   */
  emailList: StagesetContext_stages_activeStepTemplates_processTemplate_emailAutomations_emailList | null;
  /**
   * The stage in which this stage subscription starts.
   */
  entersStage: StagesetContext_stages_activeStepTemplates_processTemplate_emailAutomations_entersStage;
  /**
   * The stage in which this stage subscription ends.
   */
  exitsStage: StagesetContext_stages_activeStepTemplates_processTemplate_emailAutomations_exitsStage | null;
  /**
   * The delay for automated email sequences between a lead entering a stage, and the scheduled time to start the sequence
   */
  delay: StagesetContext_stages_activeStepTemplates_processTemplate_emailAutomations_delay | null;
  /**
   * Number of stages a EmailAutomation spans. If a subscription has no exit stage,
   * we count the last stage in the stageset as the "exit stage" for this count.
   */
  numberOfStagesSpanned: number;
  /**
   * The user that automated email sequences should be sent from, or null if sent from the lead assignee
   */
  sendFromUser: StagesetContext_stages_activeStepTemplates_processTemplate_emailAutomations_sendFromUser | null;
}

export interface StagesetContext_stages_activeStepTemplates_processTemplate {
  __typename: "ProcessTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell ProcessTemplate.
   */
  name: string | null;
  /**
   * The outcome automations associated with this process template
   */
  closedLeadAutomations: StagesetContext_stages_activeStepTemplates_processTemplate_closedLeadAutomations[];
  /**
   * Returns a list of Nutshell emails automations for a given process template
   */
  emailAutomations: StagesetContext_stages_activeStepTemplates_processTemplate_emailAutomations[];
}

export interface StagesetContext_stages_activeStepTemplates {
  __typename: "StepTemplate";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The rules to determine the due date for this step.
   */
  dueDate: StagesetContext_stages_activeStepTemplates_dueDate | null;
  /**
   * The position of the step template within its stage.
   */
  position: number;
  /**
   * The name of the Nutshell StepTemplate.
   */
  name: string;
  /**
   * The description of the Nutshell StepTemplate.
   */
  description: string | null;
  /**
   * The description of the Nutshell StepTemplate.
   */
  assignee: StagesetContext_stages_activeStepTemplates_assignee | null;
  /**
   * The Process template this stepTemplate belongs to.
   */
  processTemplate: StagesetContext_stages_activeStepTemplates_processTemplate;
}

export interface StagesetContext_stages {
  __typename: "Stage";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stage.
   */
  stageName: string;
  /**
   * The default confidence value of the stage.
   */
  setConfidenceOnLeadWhenItEntersThisStage: number | null;
  /**
   * The description of the Nutshell Stage.
   */
  description: string;
  /**
   * The position of the stage relative to the other stages (1-based index)
   */
  position: number;
  /**
   * The active copies of the step templates available for this stage
   */
  activeStepTemplates: StagesetContext_stages_activeStepTemplates[];
}

export interface StagesetContext {
  __typename: "Stageset";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Stageset.
   */
  pipelineName: string;
  /**
   * If this stageset is the default or not
   */
  isThisTheDefaultPipeline: boolean;
  /**
   * The stages associated with this stageset
   */
  stages: StagesetContext_stages[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ChangelogEventFragment
// ====================================================

export interface ChangelogEventFragment_actor_Contact {
  __typename: "Contact" | "Account" | "Form" | "MaUrl";
}

export interface ChangelogEventFragment_actor_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ChangelogEventFragment_actor_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type ChangelogEventFragment_actor = ChangelogEventFragment_actor_Contact | ChangelogEventFragment_actor_User | ChangelogEventFragment_actor_Origin;

export interface ChangelogEventFragment_origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ChangelogEventFragment_changes {
  __typename: "ChangeLogChange";
  /**
   * The change as a human readable string
   */
  description: string | null;
}

export interface ChangelogEventFragment_automations {
  __typename: "Automation";
  /**
   * The change as a human readable string
   */
  humanReadableDescription: string | null;
}

export interface ChangelogEventFragment {
  __typename: "TimelineEvent";
  /**
   * The type of change i.e. created, modified, deleted, etc
   */
  changeType: ChangeType;
  changeTime: any;
  /**
   * The change as a human readable string
   */
  description: string | null;
  /**
   * The entity that triggered the change_log entry
   */
  actor: ChangelogEventFragment_actor;
  /**
   * The origin of the change_log entry
   */
  origin: ChangelogEventFragment_origin;
  changes: ChangelogEventFragment_changes[];
  automations: ChangelogEventFragment_automations[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CommentFragment
// ====================================================

export interface CommentFragment_changeLogEntry {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface CommentFragment_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface CommentFragment_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: CommentFragment_reactions_creatorUser;
}

export interface CommentFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  htmlUrl: string | null;
}

export interface CommentFragment {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Change log associated with the comment
   */
  changeLogEntry: CommentFragment_changeLogEntry | null;
  /**
   * User reactions left for the comment change log entry
   */
  reactions: CommentFragment_reactions[];
  /**
   * The user who created the comment.
   */
  creatorUser: CommentFragment_creatorUser;
  /**
   * The created time for the comment.
   */
  createdTime: any;
  /**
   * True if this comment can be deleted
   */
  isDeleteable: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AccountFragment
// ====================================================

export interface AccountFragment {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ActivityFragment
// ====================================================

export interface ActivityFragment_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface ActivityFragment_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface ActivityFragment_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface ActivityFragment_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface ActivityFragment_relatedLeads_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ActivityFragment_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface ActivityFragment_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: ActivityFragment_relatedLeads_contacts_primaryEdge_node;
}

export interface ActivityFragment_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: ActivityFragment_relatedLeads_contacts_primaryEdge | null;
}

export interface ActivityFragment_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface ActivityFragment_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: ActivityFragment_relatedLeads_accounts_primaryEdge_node;
}

export interface ActivityFragment_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: ActivityFragment_relatedLeads_accounts_primaryEdge | null;
}

export interface ActivityFragment_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: ActivityFragment_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: ActivityFragment_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: ActivityFragment_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: ActivityFragment_relatedLeads_accounts;
}

export interface ActivityFragment_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface ActivityFragment_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface ActivityFragment_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: ActivityFragment_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: ActivityFragment_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface ActivityFragment {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: ActivityFragment_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: ActivityFragment_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: ActivityFragment_participants[];
  /**
   * Related leads for the activity.
   */
  relatedLeads: ActivityFragment_relatedLeads[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: ActivityFragment_externalMeeting | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AssignmentFragment
// ====================================================

export interface AssignmentFragment_assignmentEntity_Thread {
  __typename: "Thread";
}

export interface AssignmentFragment_assignmentEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface AssignmentFragment_assignmentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * Canonical URL for an individual activity - launches a modal in this case
   */
  htmlUrl: string;
}

export interface AssignmentFragment_assignmentEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface AssignmentFragment_assignmentEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface AssignmentFragment_assignmentEntity_UnknownEntityType {
  __typename: "UnknownEntityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type AssignmentFragment_assignmentEntity = AssignmentFragment_assignmentEntity_Thread | AssignmentFragment_assignmentEntity_Account | AssignmentFragment_assignmentEntity_Activity | AssignmentFragment_assignmentEntity_Contact | AssignmentFragment_assignmentEntity_Lead | AssignmentFragment_assignmentEntity_UnknownEntityType;

export interface AssignmentFragment_assigneeEntity {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface AssignmentFragment {
  __typename: "Assignment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity that was assigned
   */
  assignmentEntity: AssignmentFragment_assignmentEntity;
  /**
   * The entity to which the assignment was made
   */
  assigneeEntity: AssignmentFragment_assigneeEntity;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ChatFragment
// ====================================================

export interface ChatFragment_chatItems {
  __typename: "ChatItem";
  /**
   * Time this message was sent
   */
  timestamp: any;
  /**
   * The attrbute chatItemd by the entry
   */
  body: string;
  /**
   * Person writing this particular message
   */
  chatter: string;
  /**
   * Type of chat message
   */
  type: string;
}

export interface ChatFragment_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface ChatFragment_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface ChatFragment_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface ChatFragment_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface ChatFragment_relatedLeads_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ChatFragment_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface ChatFragment_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: ChatFragment_relatedLeads_contacts_primaryEdge_node;
}

export interface ChatFragment_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: ChatFragment_relatedLeads_contacts_primaryEdge | null;
}

export interface ChatFragment_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface ChatFragment_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: ChatFragment_relatedLeads_accounts_primaryEdge_node;
}

export interface ChatFragment_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: ChatFragment_relatedLeads_accounts_primaryEdge | null;
}

export interface ChatFragment_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: ChatFragment_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: ChatFragment_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: ChatFragment_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: ChatFragment_relatedLeads_accounts;
}

export interface ChatFragment {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * Not really sure tbh
   */
  chatItems: ChatFragment_chatItems[];
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: ChatFragment_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: ChatFragment_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: ChatFragment_participants[];
  /**
   * Related leads for the activity.
   */
  relatedLeads: ChatFragment_relatedLeads[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CommentBannerFragment
// ====================================================

export interface CommentBannerFragment_parentEntity_Note_entity_Activity {
  __typename: "Activity" | "Thread" | "NoteEntityUnknownType";
}

export interface CommentBannerFragment_parentEntity_Note_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface CommentBannerFragment_parentEntity_Note_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface CommentBannerFragment_parentEntity_Note_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export type CommentBannerFragment_parentEntity_Note_entity = CommentBannerFragment_parentEntity_Note_entity_Activity | CommentBannerFragment_parentEntity_Note_entity_Contact | CommentBannerFragment_parentEntity_Note_entity_Account | CommentBannerFragment_parentEntity_Note_entity_Lead;

export interface CommentBannerFragment_parentEntity_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity on which this note was written
   */
  entity: CommentBannerFragment_parentEntity_Note_entity | null;
}

export interface CommentBannerFragment_parentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface CommentBannerFragment_parentEntity_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
}

export type CommentBannerFragment_parentEntity = CommentBannerFragment_parentEntity_Note | CommentBannerFragment_parentEntity_Activity | CommentBannerFragment_parentEntity_Email;

export interface CommentBannerFragment {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  commentId: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Deleted time for comment, null if not deleted
   */
  deletedTime: any | null;
  /**
   * The entity on which this note was written
   */
  parentEntity: CommentBannerFragment_parentEntity | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ConstantContactContactTrackingActivityFragment
// ====================================================

export interface ConstantContactContactTrackingActivityFragment_ctctContact_contacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface ConstantContactContactTrackingActivityFragment_ctctContact {
  __typename: "ConstantContactContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailAddress: string;
  /**
   * The Nutshell contacts associated with this CTCT contact
   */
  contacts: ConstantContactContactTrackingActivityFragment_ctctContact_contacts[];
}

export interface ConstantContactContactTrackingActivityFragment {
  __typename: "ConstantContactContactTrackingActivity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  campaignName: string | null;
  trackingActivityType: ConstantContactContactTrackingActivityType;
  emailSubject: string | null;
  ctctContact: ConstantContactContactTrackingActivityFragment_ctctContact;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContactFragment
// ====================================================

export interface ContactFragment {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContractBannerFragment
// ====================================================

export interface ContractBannerFragment_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface ContractBannerFragment_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: ContractBannerFragment_lead_accounts_primaryEdge_node;
}

export interface ContractBannerFragment_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: ContractBannerFragment_lead_accounts_primaryEdge | null;
}

export interface ContractBannerFragment_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface ContractBannerFragment_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: ContractBannerFragment_lead_contacts_primaryEdge_node;
}

export interface ContractBannerFragment_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: ContractBannerFragment_lead_contacts_primaryEdge | null;
}

export interface ContractBannerFragment_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: ContractBannerFragment_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: ContractBannerFragment_lead_contacts;
}

export interface ContractBannerFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface ContractBannerFragment {
  __typename: "Contract";
  id: string;
  /**
   * The htmlUrl path without domain.
   */
  htmlUrlPath: string;
  lead: ContractBannerFragment_lead;
  displayNumber: string;
  creatorUser: ContractBannerFragment_creatorUser | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: DocumentViewFragment
// ====================================================

export interface DocumentViewFragment_salesDocument_Quote_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface DocumentViewFragment_salesDocument_Quote_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: DocumentViewFragment_salesDocument_Quote_lead_accounts_primaryEdge_node;
}

export interface DocumentViewFragment_salesDocument_Quote_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: DocumentViewFragment_salesDocument_Quote_lead_accounts_primaryEdge | null;
}

export interface DocumentViewFragment_salesDocument_Quote_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface DocumentViewFragment_salesDocument_Quote_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: DocumentViewFragment_salesDocument_Quote_lead_contacts_primaryEdge_node;
}

export interface DocumentViewFragment_salesDocument_Quote_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: DocumentViewFragment_salesDocument_Quote_lead_contacts_primaryEdge | null;
}

export interface DocumentViewFragment_salesDocument_Quote_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: DocumentViewFragment_salesDocument_Quote_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: DocumentViewFragment_salesDocument_Quote_lead_contacts;
}

export interface DocumentViewFragment_salesDocument_Quote_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface DocumentViewFragment_salesDocument_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface DocumentViewFragment_salesDocument_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: DocumentViewFragment_salesDocument_Quote_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: DocumentViewFragment_salesDocument_Quote_total;
  /**
   * The user that created the quote
   */
  creatorUser: DocumentViewFragment_salesDocument_Quote_creatorUser | null;
}

export interface DocumentViewFragment_salesDocument_Invoice_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface DocumentViewFragment_salesDocument_Invoice_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: DocumentViewFragment_salesDocument_Invoice_lead_accounts_primaryEdge_node;
}

export interface DocumentViewFragment_salesDocument_Invoice_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: DocumentViewFragment_salesDocument_Invoice_lead_accounts_primaryEdge | null;
}

export interface DocumentViewFragment_salesDocument_Invoice_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface DocumentViewFragment_salesDocument_Invoice_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: DocumentViewFragment_salesDocument_Invoice_lead_contacts_primaryEdge_node;
}

export interface DocumentViewFragment_salesDocument_Invoice_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: DocumentViewFragment_salesDocument_Invoice_lead_contacts_primaryEdge | null;
}

export interface DocumentViewFragment_salesDocument_Invoice_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: DocumentViewFragment_salesDocument_Invoice_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: DocumentViewFragment_salesDocument_Invoice_lead_contacts;
}

export interface DocumentViewFragment_salesDocument_Invoice_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface DocumentViewFragment_salesDocument_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface DocumentViewFragment_salesDocument_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: DocumentViewFragment_salesDocument_Invoice_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: DocumentViewFragment_salesDocument_Invoice_total;
  /**
   * The user that created the quote
   */
  creatorUser: DocumentViewFragment_salesDocument_Invoice_creatorUser | null;
}

export type DocumentViewFragment_salesDocument = DocumentViewFragment_salesDocument_Quote | DocumentViewFragment_salesDocument_Invoice;

export interface DocumentViewFragment_contract_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface DocumentViewFragment_contract_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: DocumentViewFragment_contract_lead_accounts_primaryEdge_node;
}

export interface DocumentViewFragment_contract_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: DocumentViewFragment_contract_lead_accounts_primaryEdge | null;
}

export interface DocumentViewFragment_contract_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface DocumentViewFragment_contract_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: DocumentViewFragment_contract_lead_contacts_primaryEdge_node;
}

export interface DocumentViewFragment_contract_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: DocumentViewFragment_contract_lead_contacts_primaryEdge | null;
}

export interface DocumentViewFragment_contract_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: DocumentViewFragment_contract_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: DocumentViewFragment_contract_lead_contacts;
}

export interface DocumentViewFragment_contract_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface DocumentViewFragment_contract {
  __typename: "Contract";
  id: string;
  /**
   * The htmlUrl path without domain.
   */
  htmlUrlPath: string;
  lead: DocumentViewFragment_contract_lead;
  displayNumber: string;
  creatorUser: DocumentViewFragment_contract_creatorUser | null;
}

export interface DocumentViewFragment {
  __typename: "DocumentView";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The quote or invoice this view is attached to, when applicable
   */
  salesDocument: DocumentViewFragment_salesDocument | null;
  /**
   * The contract this view is attached to, when applicable
   */
  contract: DocumentViewFragment_contract | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EntityAttributeValueFileFragment
// ====================================================

export interface EntityAttributeValueFileFragment_eavEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EntityAttributeValueFileFragment_eavEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EntityAttributeValueFileFragment_eavEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EntityAttributeValueFileFragment_eavEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: EntityAttributeValueFileFragment_eavEntity_Lead_value | null;
}

export type EntityAttributeValueFileFragment_eavEntity = EntityAttributeValueFileFragment_eavEntity_Account | EntityAttributeValueFileFragment_eavEntity_Contact | EntityAttributeValueFileFragment_eavEntity_Lead;

export interface EntityAttributeValueFileFragment {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The entity that this file is associated with
   */
  eavEntity: EntityAttributeValueFileFragment_eavEntity;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EventFragmentFull
// ====================================================

export interface EventFragmentFull_actor_Form {
  __typename: "Form";
}

export interface EventFragmentFull_actor_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface EventFragmentFull_actor_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EventFragmentFull_actor_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_actor_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_actor_MaUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Path to the edit page for this money page.
   */
  htmlUrlPath: string;
}

export type EventFragmentFull_actor = EventFragmentFull_actor_Form | EventFragmentFull_actor_User | EventFragmentFull_actor_Origin | EventFragmentFull_actor_Contact | EventFragmentFull_actor_Account | EventFragmentFull_actor_MaUrl;

export interface EventFragmentFull_payload_TimelineEventPayloadUnknownType {
  __typename: "TimelineEventPayloadUnknownType" | "AccountRelationshipChange" | "Quote" | "DocumentView" | "Invoice" | "Contract" | "LeadClonePayload" | "AccountContactFormerStatusChange" | "Thread" | "Message";
}

export interface EventFragmentFull_payload_Activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface EventFragmentFull_payload_Activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface EventFragmentFull_payload_Activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface EventFragmentFull_payload_Activity_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EventFragmentFull_payload_Activity_relatedLeads_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EventFragmentFull_payload_Activity_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_Activity_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: EventFragmentFull_payload_Activity_relatedLeads_contacts_primaryEdge_node;
}

export interface EventFragmentFull_payload_Activity_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EventFragmentFull_payload_Activity_relatedLeads_contacts_primaryEdge | null;
}

export interface EventFragmentFull_payload_Activity_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_Activity_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: EventFragmentFull_payload_Activity_relatedLeads_accounts_primaryEdge_node;
}

export interface EventFragmentFull_payload_Activity_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EventFragmentFull_payload_Activity_relatedLeads_accounts_primaryEdge | null;
}

export interface EventFragmentFull_payload_Activity_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: EventFragmentFull_payload_Activity_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: EventFragmentFull_payload_Activity_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: EventFragmentFull_payload_Activity_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: EventFragmentFull_payload_Activity_relatedLeads_accounts;
}

export interface EventFragmentFull_payload_Activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface EventFragmentFull_payload_Activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface EventFragmentFull_payload_Activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: EventFragmentFull_payload_Activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: EventFragmentFull_payload_Activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface EventFragmentFull_payload_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: EventFragmentFull_payload_Activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: EventFragmentFull_payload_Activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: EventFragmentFull_payload_Activity_participants[];
  /**
   * Related leads for the activity.
   */
  relatedLeads: EventFragmentFull_payload_Activity_relatedLeads[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: EventFragmentFull_payload_Activity_externalMeeting | null;
}

export interface EventFragmentFull_payload_Note_entity_NoteEntityUnknownType {
  __typename: "NoteEntityUnknownType";
}

export interface EventFragmentFull_payload_Note_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_Note_entity_Activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface EventFragmentFull_payload_Note_entity_Activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface EventFragmentFull_payload_Note_entity_Activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface EventFragmentFull_payload_Note_entity_Activity_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EventFragmentFull_payload_Note_entity_Activity_relatedLeads_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EventFragmentFull_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: EventFragmentFull_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge_node;
}

export interface EventFragmentFull_payload_Note_entity_Activity_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EventFragmentFull_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge | null;
}

export interface EventFragmentFull_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: EventFragmentFull_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge_node;
}

export interface EventFragmentFull_payload_Note_entity_Activity_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EventFragmentFull_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge | null;
}

export interface EventFragmentFull_payload_Note_entity_Activity_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: EventFragmentFull_payload_Note_entity_Activity_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: EventFragmentFull_payload_Note_entity_Activity_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: EventFragmentFull_payload_Note_entity_Activity_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: EventFragmentFull_payload_Note_entity_Activity_relatedLeads_accounts;
}

export interface EventFragmentFull_payload_Note_entity_Activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface EventFragmentFull_payload_Note_entity_Activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface EventFragmentFull_payload_Note_entity_Activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: EventFragmentFull_payload_Note_entity_Activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: EventFragmentFull_payload_Note_entity_Activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface EventFragmentFull_payload_Note_entity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: EventFragmentFull_payload_Note_entity_Activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: EventFragmentFull_payload_Note_entity_Activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: EventFragmentFull_payload_Note_entity_Activity_participants[];
  /**
   * Related leads for the activity.
   */
  relatedLeads: EventFragmentFull_payload_Note_entity_Activity_relatedLeads[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: EventFragmentFull_payload_Note_entity_Activity_externalMeeting | null;
}

export interface EventFragmentFull_payload_Note_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_Note_entity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EventFragmentFull_payload_Note_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: EventFragmentFull_payload_Note_entity_Lead_value | null;
}

export interface EventFragmentFull_payload_Note_entity_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type EventFragmentFull_payload_Note_entity = EventFragmentFull_payload_Note_entity_NoteEntityUnknownType | EventFragmentFull_payload_Note_entity_Account | EventFragmentFull_payload_Note_entity_Activity | EventFragmentFull_payload_Note_entity_Contact | EventFragmentFull_payload_Note_entity_Lead | EventFragmentFull_payload_Note_entity_Thread;

export interface EventFragmentFull_payload_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
  /**
   * The htmlUrl without http: // app.nutshell.com
   */
  htmlUrlPath: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrl: string;
  /**
   * Is this note editable?
   */
  isEditable: boolean;
  /**
   * Does this note have mentioned entities? We care about this because our editing
   * flow for notes w/ mentioned entities is different than a note without entities.
   */
  hasMentionedEntities: boolean;
  /**
   * Whether note has been deleted
   */
  isDeleted: boolean;
  /**
   * The entity on which this note was written
   */
  entity: EventFragmentFull_payload_Note_entity | null;
}

export interface EventFragmentFull_payload_Email_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface EventFragmentFull_payload_Email_recipients_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface EventFragmentFull_payload_Email_recipients {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: EventFragmentFull_payload_Email_recipients_avatarEntity | null;
}

export interface EventFragmentFull_payload_Email_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface EventFragmentFull_payload_Email_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: EventFragmentFull_payload_Email_from_avatarEntity | null;
}

export interface EventFragmentFull_payload_Email_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface EventFragmentFull_payload_Email_emailRelatedLeads_edges_node_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EventFragmentFull_payload_Email_emailRelatedLeads_edges_node_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EventFragmentFull_payload_Email_emailRelatedLeads_edges_node_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_Email_emailRelatedLeads_edges_node_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: EventFragmentFull_payload_Email_emailRelatedLeads_edges_node_contacts_primaryEdge_node;
}

export interface EventFragmentFull_payload_Email_emailRelatedLeads_edges_node_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EventFragmentFull_payload_Email_emailRelatedLeads_edges_node_contacts_primaryEdge | null;
}

export interface EventFragmentFull_payload_Email_emailRelatedLeads_edges_node_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_Email_emailRelatedLeads_edges_node_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: EventFragmentFull_payload_Email_emailRelatedLeads_edges_node_accounts_primaryEdge_node;
}

export interface EventFragmentFull_payload_Email_emailRelatedLeads_edges_node_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EventFragmentFull_payload_Email_emailRelatedLeads_edges_node_accounts_primaryEdge | null;
}

export interface EventFragmentFull_payload_Email_emailRelatedLeads_edges_node {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: EventFragmentFull_payload_Email_emailRelatedLeads_edges_node_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: EventFragmentFull_payload_Email_emailRelatedLeads_edges_node_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: EventFragmentFull_payload_Email_emailRelatedLeads_edges_node_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: EventFragmentFull_payload_Email_emailRelatedLeads_edges_node_accounts;
}

export interface EventFragmentFull_payload_Email_emailRelatedLeads_edges {
  __typename: "EmailLeadsEdge";
  /**
   * Is this lead mapped to this email?
   */
  isMapped: boolean;
  node: EventFragmentFull_payload_Email_emailRelatedLeads_edges_node;
}

export interface EventFragmentFull_payload_Email_emailRelatedLeads {
  __typename: "EmailLeadsConnection";
  /**
   * A list of edges.
   */
  edges: EventFragmentFull_payload_Email_emailRelatedLeads_edges[];
}

export interface EventFragmentFull_payload_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The excerpt of this email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  /**
   * A partially-formatted version of the body of this email,for use in the expanded view in a list
   */
  emailBodyHtml: string;
  attachments: EventFragmentFull_payload_Email_attachments[];
  /**
   * True if the email is shared with other Nutshell users
   */
  isShared: boolean;
  /**
   * True if the email can be shared with other Nutshell users
   */
  isShareable: boolean;
  /**
   * Was this email a reply sent by Nutshell automatically.
   */
  isAutomatedReply: boolean;
  /**
   * Was this email sent by Nutshell automatically.
   */
  isEmailAutomation: boolean;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
  /**
   * If this is a ticket message from Zendesk, this is the id
   */
  ticketId: string | null;
  /**
   * If this is a ticket message from Zendesk, this is the url
   */
  ticketUrl: string | null;
  /**
   * Number of times this email has been viewed via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedViewsCount: number | null;
  /**
   * Number of times this email has been clicked via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedClicksCount: number | null;
  recipients: EventFragmentFull_payload_Email_recipients[];
  from: EventFragmentFull_payload_Email_from;
  /**
   * Was the email created outside of Nutshell
   */
  isInbound: boolean;
  /**
   * Was the email created in Nutshell
   */
  isOutbound: boolean;
  /**
   * Did the email fail to send
   */
  isFailed: boolean;
  /**
   * True if a Nutshell user can reply to this email
   */
  isReplyable: boolean;
  /**
   * Is this a Nutshell Marketing email
   */
  isNutshellMarketingEmail: boolean;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrlPath: string;
  /**
   * If this a Nutshell Marketing email, this is the edition
   */
  edition: EventFragmentFull_payload_Email_edition | null;
  /**
   * Gets all leads related to this email. This includes all open leads at the time
   * of send, as well as any previously/explicitly associated leads
   */
  emailRelatedLeads: EventFragmentFull_payload_Email_emailRelatedLeads;
  /**
   * How this email was added to Nutshell
   */
  originatedVia: string | null;
  /**
   * Was this email sent within the last week
   */
  sentWithinLastWeek: boolean;
  /**
   * Has this email accepted an AI reply suggestion
   */
  hasAcceptedSuggestion: boolean;
}

export interface EventFragmentFull_payload_EmailQueued_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface EventFragmentFull_payload_EmailQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface EventFragmentFull_payload_EmailQueued_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: EventFragmentFull_payload_EmailQueued_to_avatarEntity | null;
}

export interface EventFragmentFull_payload_EmailQueued_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface EventFragmentFull_payload_EmailQueued_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: EventFragmentFull_payload_EmailQueued_from_avatarEntity | null;
}

export interface EventFragmentFull_payload_EmailQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * The excerpt of this queued email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  /**
   * A partially-formatted version of the body of this queued email,for use in the expanded view in a list
   */
  emailBodyHtml: string;
  attachments: EventFragmentFull_payload_EmailQueued_attachments[];
  to: EventFragmentFull_payload_EmailQueued_to[];
  /**
   * The sender email address for this queued email.
   */
  from: EventFragmentFull_payload_EmailQueued_from;
  /**
   * True if this queued email is postponed and the user can retry it.
   */
  canRetry: boolean;
  /**
   * True if this is an email that looks failed to the user
   */
  isFailed: boolean;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EventFragmentFull_payload_Submission_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
  formatted: string;
}

export interface EventFragmentFull_payload_Submission_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  isPrimary: boolean;
  value: EventFragmentFull_payload_Submission_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface EventFragmentFull_payload_Submission_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: EventFragmentFull_payload_Submission_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface EventFragmentFull_payload_Submission_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: EventFragmentFull_payload_Submission_booking_additionalAttendees_emailAddresses;
}

export interface EventFragmentFull_payload_Submission_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (EventFragmentFull_payload_Submission_booking_additionalAttendees | null)[];
}

export interface EventFragmentFull_payload_Submission_primaryEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_Submission_primaryEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_Submission_primaryEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EventFragmentFull_payload_Submission_primaryEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: EventFragmentFull_payload_Submission_primaryEntity_Lead_value | null;
}

export type EventFragmentFull_payload_Submission_primaryEntity = EventFragmentFull_payload_Submission_primaryEntity_Account | EventFragmentFull_payload_Submission_primaryEntity_Contact | EventFragmentFull_payload_Submission_primaryEntity_Lead;

export interface EventFragmentFull_payload_Submission_formVersion_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface EventFragmentFull_payload_Submission_formVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent form of this form version
   */
  form: EventFragmentFull_payload_Submission_formVersion_form;
}

export interface EventFragmentFull_payload_Submission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface EventFragmentFull_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface EventFragmentFull_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: EventFragmentFull_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export interface EventFragmentFull_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface EventFragmentFull_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export type EventFragmentFull_payload_Submission_fields_edges_fieldValue = EventFragmentFull_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields | EventFragmentFull_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | EventFragmentFull_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle;

export interface EventFragmentFull_payload_Submission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: EventFragmentFull_payload_Submission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: EventFragmentFull_payload_Submission_fields_edges_fieldValue | null;
}

export interface EventFragmentFull_payload_Submission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: EventFragmentFull_payload_Submission_fields_edges[];
}

export interface EventFragmentFull_payload_Submission {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The url where the submission originates
   */
  submissionUrl: string;
  /**
   * The booking associated with this submission (if Scheduler)
   */
  booking: EventFragmentFull_payload_Submission_booking | null;
  /**
   * The primary entity on the submission
   */
  primaryEntity: EventFragmentFull_payload_Submission_primaryEntity | null;
  /**
   * The name of the submitted web form
   */
  formVersion: EventFragmentFull_payload_Submission_formVersion;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: EventFragmentFull_payload_Submission_fields;
}

export interface EventFragmentFull_payload_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EventFragmentFull_payload_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: EventFragmentFull_payload_Lead_value | null;
}

export interface EventFragmentFull_payload_Chat_chatItems {
  __typename: "ChatItem";
  /**
   * Time this message was sent
   */
  timestamp: any;
  /**
   * The attrbute chatItemd by the entry
   */
  body: string;
  /**
   * Person writing this particular message
   */
  chatter: string;
  /**
   * Type of chat message
   */
  type: string;
}

export interface EventFragmentFull_payload_Chat_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface EventFragmentFull_payload_Chat_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface EventFragmentFull_payload_Chat_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface EventFragmentFull_payload_Chat_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EventFragmentFull_payload_Chat_relatedLeads_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EventFragmentFull_payload_Chat_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_Chat_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: EventFragmentFull_payload_Chat_relatedLeads_contacts_primaryEdge_node;
}

export interface EventFragmentFull_payload_Chat_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EventFragmentFull_payload_Chat_relatedLeads_contacts_primaryEdge | null;
}

export interface EventFragmentFull_payload_Chat_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_Chat_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: EventFragmentFull_payload_Chat_relatedLeads_accounts_primaryEdge_node;
}

export interface EventFragmentFull_payload_Chat_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EventFragmentFull_payload_Chat_relatedLeads_accounts_primaryEdge | null;
}

export interface EventFragmentFull_payload_Chat_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: EventFragmentFull_payload_Chat_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: EventFragmentFull_payload_Chat_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: EventFragmentFull_payload_Chat_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: EventFragmentFull_payload_Chat_relatedLeads_accounts;
}

export interface EventFragmentFull_payload_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * Not really sure tbh
   */
  chatItems: EventFragmentFull_payload_Chat_chatItems[];
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: EventFragmentFull_payload_Chat_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: EventFragmentFull_payload_Chat_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: EventFragmentFull_payload_Chat_participants[];
  /**
   * Related leads for the activity.
   */
  relatedLeads: EventFragmentFull_payload_Chat_relatedLeads[];
}

export interface EventFragmentFull_payload_Assignment_assignmentEntity_Thread {
  __typename: "Thread";
}

export interface EventFragmentFull_payload_Assignment_assignmentEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_Assignment_assignmentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * Canonical URL for an individual activity - launches a modal in this case
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_Assignment_assignmentEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_Assignment_assignmentEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_Assignment_assignmentEntity_UnknownEntityType {
  __typename: "UnknownEntityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type EventFragmentFull_payload_Assignment_assignmentEntity = EventFragmentFull_payload_Assignment_assignmentEntity_Thread | EventFragmentFull_payload_Assignment_assignmentEntity_Account | EventFragmentFull_payload_Assignment_assignmentEntity_Activity | EventFragmentFull_payload_Assignment_assignmentEntity_Contact | EventFragmentFull_payload_Assignment_assignmentEntity_Lead | EventFragmentFull_payload_Assignment_assignmentEntity_UnknownEntityType;

export interface EventFragmentFull_payload_Assignment_assigneeEntity {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EventFragmentFull_payload_Assignment {
  __typename: "Assignment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity that was assigned
   */
  assignmentEntity: EventFragmentFull_payload_Assignment_assignmentEntity;
  /**
   * The entity to which the assignment was made
   */
  assigneeEntity: EventFragmentFull_payload_Assignment_assigneeEntity;
}

export interface EventFragmentFull_payload_EmailInteraction_emailDelivery_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_EmailInteraction_emailDelivery_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface EventFragmentFull_payload_EmailInteraction_emailDelivery_email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * A partially-formatted version of the body of this email,for use in the expanded view in a list
   */
  bodyHtml: string;
}

export interface EventFragmentFull_payload_EmailInteraction_emailDelivery {
  __typename: "EmailDelivery";
  primaryContact: EventFragmentFull_payload_EmailInteraction_emailDelivery_primaryContact | null;
  edition: EventFragmentFull_payload_EmailInteraction_emailDelivery_edition | null;
  email: EventFragmentFull_payload_EmailInteraction_emailDelivery_email | null;
}

export interface EventFragmentFull_payload_EmailInteraction {
  __typename: "EmailInteraction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: EmailInteractionType;
  link: string | null;
  emailDelivery: EventFragmentFull_payload_EmailInteraction_emailDelivery | null;
}

export interface EventFragmentFull_payload_ConstantContactContactTrackingActivity_ctctContact_contacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_ConstantContactContactTrackingActivity_ctctContact {
  __typename: "ConstantContactContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailAddress: string;
  /**
   * The Nutshell contacts associated with this CTCT contact
   */
  contacts: EventFragmentFull_payload_ConstantContactContactTrackingActivity_ctctContact_contacts[];
}

export interface EventFragmentFull_payload_ConstantContactContactTrackingActivity {
  __typename: "ConstantContactContactTrackingActivity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  campaignName: string | null;
  trackingActivityType: ConstantContactContactTrackingActivityType;
  emailSubject: string | null;
  ctctContact: EventFragmentFull_payload_ConstantContactContactTrackingActivity_ctctContact;
}

export interface EventFragmentFull_payload_EntityAttributeValueFile_eavEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_EntityAttributeValueFile_eavEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_EntityAttributeValueFile_eavEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EventFragmentFull_payload_EntityAttributeValueFile_eavEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: EventFragmentFull_payload_EntityAttributeValueFile_eavEntity_Lead_value | null;
}

export type EventFragmentFull_payload_EntityAttributeValueFile_eavEntity = EventFragmentFull_payload_EntityAttributeValueFile_eavEntity_Account | EventFragmentFull_payload_EntityAttributeValueFile_eavEntity_Contact | EventFragmentFull_payload_EntityAttributeValueFile_eavEntity_Lead;

export interface EventFragmentFull_payload_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The entity that this file is associated with
   */
  eavEntity: EventFragmentFull_payload_EntityAttributeValueFile_eavEntity;
}

export interface EventFragmentFull_payload_Comment_parentEntity_Note_entity_Activity {
  __typename: "Activity" | "Thread" | "NoteEntityUnknownType";
}

export interface EventFragmentFull_payload_Comment_parentEntity_Note_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_Comment_parentEntity_Note_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_Comment_parentEntity_Note_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export type EventFragmentFull_payload_Comment_parentEntity_Note_entity = EventFragmentFull_payload_Comment_parentEntity_Note_entity_Activity | EventFragmentFull_payload_Comment_parentEntity_Note_entity_Contact | EventFragmentFull_payload_Comment_parentEntity_Note_entity_Account | EventFragmentFull_payload_Comment_parentEntity_Note_entity_Lead;

export interface EventFragmentFull_payload_Comment_parentEntity_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity on which this note was written
   */
  entity: EventFragmentFull_payload_Comment_parentEntity_Note_entity | null;
}

export interface EventFragmentFull_payload_Comment_parentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface EventFragmentFull_payload_Comment_parentEntity_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
}

export type EventFragmentFull_payload_Comment_parentEntity = EventFragmentFull_payload_Comment_parentEntity_Note | EventFragmentFull_payload_Comment_parentEntity_Activity | EventFragmentFull_payload_Comment_parentEntity_Email;

export interface EventFragmentFull_payload_Comment {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  commentId: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Deleted time for comment, null if not deleted
   */
  deletedTime: any | null;
  /**
   * The entity on which this note was written
   */
  parentEntity: EventFragmentFull_payload_Comment_parentEntity | null;
}

export interface EventFragmentFull_payload_Session_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https:             // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The `www.nutshell.com` part of https: // www.nutshell.com/features?utm_source=Google
   */
  host: string | null;
}

export interface EventFragmentFull_payload_Session_browser {
  __typename: "Browser";
  /**
   * The platform for the visit
   */
  platform: string;
  /**
   * The device type for the visit
   */
  deviceType: DeviceType;
}

export interface EventFragmentFull_payload_Session_source {
  __typename: "McfxVisitSource";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The utm_medium value for this particular visit
   */
  medium: string;
  /**
   * The utm_source value for this particular visit
   */
  source: string;
  /**
   * Then mROI channel derived from this source information
   */
  channel: string;
}

export interface EventFragmentFull_payload_Session_contact_nutshellContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_payload_Session_contact {
  __typename: "McfxContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The contact that made this form submission.
   */
  nutshellContact: EventFragmentFull_payload_Session_contact_nutshellContact | null;
}

export interface EventFragmentFull_payload_Session_visits_edges_node_maUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EventFragmentFull_payload_Session_visits_edges_node_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The `/features` part of https: // www.nutshell.com/features?utm_source=Google
   */
  path: string | null;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
  /**
   * The full URL, i.e. https:      // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface EventFragmentFull_payload_Session_visits_edges_node {
  __typename: "Visit";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * How long the specific page visit lasted.
   */
  durationSeconds: number;
  /**
   * The marketing automation URL associated with this visit, if any.
   */
  maUrl: EventFragmentFull_payload_Session_visits_edges_node_maUrl | null;
  /**
   * The page url for this user visit.
   */
  url: EventFragmentFull_payload_Session_visits_edges_node_url;
}

export interface EventFragmentFull_payload_Session_visits_edges {
  __typename: "SessionVisitsEdge";
  node: EventFragmentFull_payload_Session_visits_edges_node;
}

export interface EventFragmentFull_payload_Session_visits {
  __typename: "SessionVisitsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The total amount of time the visits lasted.
   */
  totalDuration: number | null;
  /**
   * The number of visits that have an associated marketing automation URL.
   */
  maUrlCount: number;
  /**
   * A list of edges.
   */
  edges: EventFragmentFull_payload_Session_visits_edges[];
}

export interface EventFragmentFull_payload_Session {
  __typename: "Session";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The url for the session, used to open as a timeline entry modal.
   */
  htmlUrlPath: string;
  /**
   * Some basic info on the location of the user represented as a string.
   */
  locationSummary: string | null;
  /**
   * The session url.
   */
  url: EventFragmentFull_payload_Session_url;
  /**
   * The platform the user was on during the session.
   */
  browser: EventFragmentFull_payload_Session_browser | null;
  source: EventFragmentFull_payload_Session_source;
  /**
   * The contact associated with this session.
   */
  contact: EventFragmentFull_payload_Session_contact | null;
  visits: EventFragmentFull_payload_Session_visits;
  /**
   * When this session started. This is the value we’ll display to the user
   */
  startTime: any;
}

export type EventFragmentFull_payload = EventFragmentFull_payload_TimelineEventPayloadUnknownType | EventFragmentFull_payload_Activity | EventFragmentFull_payload_Note | EventFragmentFull_payload_Email | EventFragmentFull_payload_EmailQueued | EventFragmentFull_payload_Origin | EventFragmentFull_payload_Submission | EventFragmentFull_payload_Account | EventFragmentFull_payload_Contact | EventFragmentFull_payload_Lead | EventFragmentFull_payload_Chat | EventFragmentFull_payload_Assignment | EventFragmentFull_payload_EmailInteraction | EventFragmentFull_payload_ConstantContactContactTrackingActivity | EventFragmentFull_payload_EntityAttributeValueFile | EventFragmentFull_payload_Comment | EventFragmentFull_payload_Session;

export interface EventFragmentFull_changes {
  __typename: "ChangeLogChange";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attrbute changed by the entry
   */
  attribute: string;
  /**
   * The old value before the change
   */
  oldValue: string | null;
  /**
   * The new value after the change
   */
  newValue: string | null;
}

export interface EventFragmentFull_files_eavEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_files_eavEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentFull_files_eavEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EventFragmentFull_files_eavEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: EventFragmentFull_files_eavEntity_Lead_value | null;
}

export type EventFragmentFull_files_eavEntity = EventFragmentFull_files_eavEntity_Account | EventFragmentFull_files_eavEntity_Contact | EventFragmentFull_files_eavEntity_Lead;

export interface EventFragmentFull_files {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The entity that this file is associated with
   */
  eavEntity: EventFragmentFull_files_eavEntity;
}

export interface EventFragmentFull_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EventFragmentFull_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: EventFragmentFull_reactions_creatorUser;
}

export interface EventFragmentFull_comments_changeLogEntry {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EventFragmentFull_comments_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EventFragmentFull_comments_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: EventFragmentFull_comments_reactions_creatorUser;
}

export interface EventFragmentFull_comments_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  htmlUrl: string | null;
}

export interface EventFragmentFull_comments {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Change log associated with the comment
   */
  changeLogEntry: EventFragmentFull_comments_changeLogEntry | null;
  /**
   * User reactions left for the comment change log entry
   */
  reactions: EventFragmentFull_comments_reactions[];
  /**
   * The user who created the comment.
   */
  creatorUser: EventFragmentFull_comments_creatorUser;
  /**
   * The created time for the comment.
   */
  createdTime: any;
  /**
   * True if this comment can be deleted
   */
  isDeleteable: boolean;
}

export interface EventFragmentFull {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of change i.e. created, modified, deleted, etc
   */
  changeType: ChangeType;
  /**
   * The entity that triggered the change_log entry
   */
  actor: EventFragmentFull_actor;
  payload: EventFragmentFull_payload;
  changeTime: any;
  changes: EventFragmentFull_changes[];
  /**
   * A one-off property to handle the case where multiple files can be associated
   * with a single change log entry. This is the only situation where multiple
   * payloads exist on an entry, so rather than adding additional complexity to our
   * entire system, we’ll treat it as a separate property
   */
  files: EventFragmentFull_files[];
  reactions: EventFragmentFull_reactions[];
  comments: EventFragmentFull_comments[];
  /**
   * When multiple of the same entry occurs in a row, we’ll roll-up the count. For
   * example, if someone views an email 3 times in a row before a different change,
   * this value will be 3.
   */
  count: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EventFragmentSparse
// ====================================================

export interface EventFragmentSparse_actor_Form {
  __typename: "Form";
}

export interface EventFragmentSparse_actor_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

export interface EventFragmentSparse_actor_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EventFragmentSparse_actor_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_actor_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_actor_MaUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Path to the edit page for this money page.
   */
  htmlUrlPath: string;
}

export type EventFragmentSparse_actor = EventFragmentSparse_actor_Form | EventFragmentSparse_actor_User | EventFragmentSparse_actor_Origin | EventFragmentSparse_actor_Contact | EventFragmentSparse_actor_Account | EventFragmentSparse_actor_MaUrl;

export interface EventFragmentSparse_payload_TimelineEventPayloadUnknownType {
  __typename: "TimelineEventPayloadUnknownType";
}

export interface EventFragmentSparse_payload_Activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface EventFragmentSparse_payload_Activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface EventFragmentSparse_payload_Activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface EventFragmentSparse_payload_Activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface EventFragmentSparse_payload_Activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface EventFragmentSparse_payload_Activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: EventFragmentSparse_payload_Activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: EventFragmentSparse_payload_Activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface EventFragmentSparse_payload_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: EventFragmentSparse_payload_Activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: EventFragmentSparse_payload_Activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: EventFragmentSparse_payload_Activity_participants[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: EventFragmentSparse_payload_Activity_externalMeeting | null;
  /**
   * The transcription of the activity.
   */
  transcription: string | null;
}

export interface EventFragmentSparse_payload_AccountRelationshipChange_entityAdded {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_AccountRelationshipChange {
  __typename: "AccountRelationshipChange";
  /**
   * The child account in the relationship
   */
  entityAdded: EventFragmentSparse_payload_AccountRelationshipChange_entityAdded;
  /**
   * The action that was taken to create this relationship
   */
  action: AccountRelationshipChangeAction;
}

export interface EventFragmentSparse_payload_AccountContactFormerStatusChange_account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_AccountContactFormerStatusChange_formerStatusContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_AccountContactFormerStatusChange {
  __typename: "AccountContactFormerStatusChange";
  account: EventFragmentSparse_payload_AccountContactFormerStatusChange_account;
  formerStatusContact: EventFragmentSparse_payload_AccountContactFormerStatusChange_formerStatusContact;
  formerStatusAction: AccountContactFormerStatusChangeAction;
}

export interface EventFragmentSparse_payload_Note_entity_NoteEntityUnknownType {
  __typename: "NoteEntityUnknownType";
}

export interface EventFragmentSparse_payload_Note_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_Note_entity_Activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface EventFragmentSparse_payload_Note_entity_Activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface EventFragmentSparse_payload_Note_entity_Activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface EventFragmentSparse_payload_Note_entity_Activity_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EventFragmentSparse_payload_Note_entity_Activity_relatedLeads_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EventFragmentSparse_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: EventFragmentSparse_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge_node;
}

export interface EventFragmentSparse_payload_Note_entity_Activity_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EventFragmentSparse_payload_Note_entity_Activity_relatedLeads_contacts_primaryEdge | null;
}

export interface EventFragmentSparse_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: EventFragmentSparse_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge_node;
}

export interface EventFragmentSparse_payload_Note_entity_Activity_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EventFragmentSparse_payload_Note_entity_Activity_relatedLeads_accounts_primaryEdge | null;
}

export interface EventFragmentSparse_payload_Note_entity_Activity_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: EventFragmentSparse_payload_Note_entity_Activity_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: EventFragmentSparse_payload_Note_entity_Activity_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: EventFragmentSparse_payload_Note_entity_Activity_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: EventFragmentSparse_payload_Note_entity_Activity_relatedLeads_accounts;
}

export interface EventFragmentSparse_payload_Note_entity_Activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface EventFragmentSparse_payload_Note_entity_Activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface EventFragmentSparse_payload_Note_entity_Activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: EventFragmentSparse_payload_Note_entity_Activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: EventFragmentSparse_payload_Note_entity_Activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface EventFragmentSparse_payload_Note_entity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: EventFragmentSparse_payload_Note_entity_Activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: EventFragmentSparse_payload_Note_entity_Activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: EventFragmentSparse_payload_Note_entity_Activity_participants[];
  /**
   * Related leads for the activity.
   */
  relatedLeads: EventFragmentSparse_payload_Note_entity_Activity_relatedLeads[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: EventFragmentSparse_payload_Note_entity_Activity_externalMeeting | null;
}

export interface EventFragmentSparse_payload_Note_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_Note_entity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EventFragmentSparse_payload_Note_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: EventFragmentSparse_payload_Note_entity_Lead_value | null;
}

export interface EventFragmentSparse_payload_Note_entity_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type EventFragmentSparse_payload_Note_entity = EventFragmentSparse_payload_Note_entity_NoteEntityUnknownType | EventFragmentSparse_payload_Note_entity_Account | EventFragmentSparse_payload_Note_entity_Activity | EventFragmentSparse_payload_Note_entity_Contact | EventFragmentSparse_payload_Note_entity_Lead | EventFragmentSparse_payload_Note_entity_Thread;

export interface EventFragmentSparse_payload_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
  /**
   * The htmlUrl without http: // app.nutshell.com
   */
  htmlUrlPath: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrl: string;
  /**
   * Is this note editable?
   */
  isEditable: boolean;
  /**
   * Does this note have mentioned entities? We care about this because our editing
   * flow for notes w/ mentioned entities is different than a note without entities.
   */
  hasMentionedEntities: boolean;
  /**
   * Whether note has been deleted
   */
  isDeleted: boolean;
  /**
   * The entity on which this note was written
   */
  entity: EventFragmentSparse_payload_Note_entity | null;
}

export interface EventFragmentSparse_payload_Email_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface EventFragmentSparse_payload_Email_recipients_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface EventFragmentSparse_payload_Email_recipients {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: EventFragmentSparse_payload_Email_recipients_avatarEntity | null;
}

export interface EventFragmentSparse_payload_Email_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface EventFragmentSparse_payload_Email_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: EventFragmentSparse_payload_Email_from_avatarEntity | null;
}

export interface EventFragmentSparse_payload_Email_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface EventFragmentSparse_payload_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The excerpt of this email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  /**
   * A partially-formatted version of the body of this email,for use in the expanded view in a list
   */
  emailBodyHtml: string;
  /**
   * How this email was added to Nutshell
   */
  originatedVia: string | null;
  attachments: EventFragmentSparse_payload_Email_attachments[];
  /**
   * True if the email is shared with other Nutshell users
   */
  isShared: boolean;
  /**
   * True if the email can be shared with other Nutshell users
   */
  isShareable: boolean;
  /**
   * Was this email a reply sent by Nutshell automatically.
   */
  isAutomatedReply: boolean;
  /**
   * Was this email sent by Nutshell automatically.
   */
  isEmailAutomation: boolean;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
  /**
   * If this is a ticket message from Zendesk, this is the id
   */
  ticketId: string | null;
  /**
   * If this is a ticket message from Zendesk, this is the url
   */
  ticketUrl: string | null;
  /**
   * Number of times this email has been viewed via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedViewsCount: number | null;
  /**
   * Number of times this email has been clicked via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedClicksCount: number | null;
  recipients: EventFragmentSparse_payload_Email_recipients[];
  from: EventFragmentSparse_payload_Email_from;
  /**
   * Was the email created outside of Nutshell
   */
  isInbound: boolean;
  /**
   * Was the email created in Nutshell
   */
  isOutbound: boolean;
  /**
   * Did the email fail to send
   */
  isFailed: boolean;
  /**
   * True if a Nutshell user can reply to this email
   */
  isReplyable: boolean;
  /**
   * Is this a Nutshell Marketing email
   */
  isNutshellMarketingEmail: boolean;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrlPath: string;
  /**
   * If this a Nutshell Marketing email, this is the edition
   */
  edition: EventFragmentSparse_payload_Email_edition | null;
  /**
   * Was this email sent within the last week
   */
  sentWithinLastWeek: boolean;
  /**
   * Has this email accepted an AI reply suggestion
   */
  hasAcceptedSuggestion: boolean;
}

export interface EventFragmentSparse_payload_EmailQueued_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface EventFragmentSparse_payload_EmailQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface EventFragmentSparse_payload_EmailQueued_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: EventFragmentSparse_payload_EmailQueued_to_avatarEntity | null;
}

export interface EventFragmentSparse_payload_EmailQueued_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface EventFragmentSparse_payload_EmailQueued_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: EventFragmentSparse_payload_EmailQueued_from_avatarEntity | null;
}

export interface EventFragmentSparse_payload_EmailQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * The excerpt of this queued email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  attachments: EventFragmentSparse_payload_EmailQueued_attachments[];
  to: EventFragmentSparse_payload_EmailQueued_to[];
  /**
   * The sender email address for this queued email.
   */
  from: EventFragmentSparse_payload_EmailQueued_from;
  /**
   * True if this queued email is postponed and the user can retry it.
   */
  canRetry: boolean;
  /**
   * True if this is an email that looks failed to the user
   */
  isFailed: boolean;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EventFragmentSparse_payload_Submission_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
  formatted: string;
}

export interface EventFragmentSparse_payload_Submission_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  isPrimary: boolean;
  value: EventFragmentSparse_payload_Submission_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface EventFragmentSparse_payload_Submission_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: EventFragmentSparse_payload_Submission_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface EventFragmentSparse_payload_Submission_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: EventFragmentSparse_payload_Submission_booking_additionalAttendees_emailAddresses;
}

export interface EventFragmentSparse_payload_Submission_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (EventFragmentSparse_payload_Submission_booking_additionalAttendees | null)[];
}

export interface EventFragmentSparse_payload_Submission_primaryEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_Submission_primaryEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_Submission_primaryEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EventFragmentSparse_payload_Submission_primaryEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: EventFragmentSparse_payload_Submission_primaryEntity_Lead_value | null;
}

export type EventFragmentSparse_payload_Submission_primaryEntity = EventFragmentSparse_payload_Submission_primaryEntity_Account | EventFragmentSparse_payload_Submission_primaryEntity_Contact | EventFragmentSparse_payload_Submission_primaryEntity_Lead;

export interface EventFragmentSparse_payload_Submission_formVersion_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface EventFragmentSparse_payload_Submission_formVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent form of this form version
   */
  form: EventFragmentSparse_payload_Submission_formVersion_form;
}

export interface EventFragmentSparse_payload_Submission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface EventFragmentSparse_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface EventFragmentSparse_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: EventFragmentSparse_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export interface EventFragmentSparse_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface EventFragmentSparse_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export type EventFragmentSparse_payload_Submission_fields_edges_fieldValue = EventFragmentSparse_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields | EventFragmentSparse_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | EventFragmentSparse_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle;

export interface EventFragmentSparse_payload_Submission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: EventFragmentSparse_payload_Submission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: EventFragmentSparse_payload_Submission_fields_edges_fieldValue | null;
}

export interface EventFragmentSparse_payload_Submission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: EventFragmentSparse_payload_Submission_fields_edges[];
}

export interface EventFragmentSparse_payload_Submission {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The url where the submission originates
   */
  submissionUrl: string;
  /**
   * The booking associated with this submission (if Scheduler)
   */
  booking: EventFragmentSparse_payload_Submission_booking | null;
  /**
   * The primary entity on the submission
   */
  primaryEntity: EventFragmentSparse_payload_Submission_primaryEntity | null;
  /**
   * The name of the submitted web form
   */
  formVersion: EventFragmentSparse_payload_Submission_formVersion;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: EventFragmentSparse_payload_Submission_fields;
}

export interface EventFragmentSparse_payload_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EventFragmentSparse_payload_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: EventFragmentSparse_payload_Lead_value | null;
}

export interface EventFragmentSparse_payload_Chat_chatItems {
  __typename: "ChatItem";
  /**
   * Time this message was sent
   */
  timestamp: any;
  /**
   * The attrbute chatItemd by the entry
   */
  body: string;
  /**
   * Person writing this particular message
   */
  chatter: string;
  /**
   * Type of chat message
   */
  type: string;
}

export interface EventFragmentSparse_payload_Chat_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface EventFragmentSparse_payload_Chat_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface EventFragmentSparse_payload_Chat_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface EventFragmentSparse_payload_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * Not really sure tbh
   */
  chatItems: EventFragmentSparse_payload_Chat_chatItems[];
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: EventFragmentSparse_payload_Chat_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: EventFragmentSparse_payload_Chat_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: EventFragmentSparse_payload_Chat_participants[];
}

export interface EventFragmentSparse_payload_Assignment_assignmentEntity_Thread {
  __typename: "Thread";
}

export interface EventFragmentSparse_payload_Assignment_assignmentEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_Assignment_assignmentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * Canonical URL for an individual activity - launches a modal in this case
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_Assignment_assignmentEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_Assignment_assignmentEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_Assignment_assignmentEntity_UnknownEntityType {
  __typename: "UnknownEntityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type EventFragmentSparse_payload_Assignment_assignmentEntity = EventFragmentSparse_payload_Assignment_assignmentEntity_Thread | EventFragmentSparse_payload_Assignment_assignmentEntity_Account | EventFragmentSparse_payload_Assignment_assignmentEntity_Activity | EventFragmentSparse_payload_Assignment_assignmentEntity_Contact | EventFragmentSparse_payload_Assignment_assignmentEntity_Lead | EventFragmentSparse_payload_Assignment_assignmentEntity_UnknownEntityType;

export interface EventFragmentSparse_payload_Assignment_assigneeEntity {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EventFragmentSparse_payload_Assignment {
  __typename: "Assignment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity that was assigned
   */
  assignmentEntity: EventFragmentSparse_payload_Assignment_assignmentEntity;
  /**
   * The entity to which the assignment was made
   */
  assigneeEntity: EventFragmentSparse_payload_Assignment_assigneeEntity;
}

export interface EventFragmentSparse_payload_EmailInteraction_emailDelivery_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_EmailInteraction_emailDelivery_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface EventFragmentSparse_payload_EmailInteraction_emailDelivery_email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrlPath: string;
}

export interface EventFragmentSparse_payload_EmailInteraction_emailDelivery {
  __typename: "EmailDelivery";
  primaryContact: EventFragmentSparse_payload_EmailInteraction_emailDelivery_primaryContact | null;
  edition: EventFragmentSparse_payload_EmailInteraction_emailDelivery_edition | null;
  email: EventFragmentSparse_payload_EmailInteraction_emailDelivery_email | null;
}

export interface EventFragmentSparse_payload_EmailInteraction {
  __typename: "EmailInteraction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: EmailInteractionType;
  link: string | null;
  emailDelivery: EventFragmentSparse_payload_EmailInteraction_emailDelivery | null;
}

export interface EventFragmentSparse_payload_ConstantContactContactTrackingActivity_ctctContact_contacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_ConstantContactContactTrackingActivity_ctctContact {
  __typename: "ConstantContactContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailAddress: string;
  /**
   * The Nutshell contacts associated with this CTCT contact
   */
  contacts: EventFragmentSparse_payload_ConstantContactContactTrackingActivity_ctctContact_contacts[];
}

export interface EventFragmentSparse_payload_ConstantContactContactTrackingActivity {
  __typename: "ConstantContactContactTrackingActivity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  campaignName: string | null;
  trackingActivityType: ConstantContactContactTrackingActivityType;
  emailSubject: string | null;
  ctctContact: EventFragmentSparse_payload_ConstantContactContactTrackingActivity_ctctContact;
}

export interface EventFragmentSparse_payload_EntityAttributeValueFile_eavEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_EntityAttributeValueFile_eavEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_EntityAttributeValueFile_eavEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EventFragmentSparse_payload_EntityAttributeValueFile_eavEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: EventFragmentSparse_payload_EntityAttributeValueFile_eavEntity_Lead_value | null;
}

export type EventFragmentSparse_payload_EntityAttributeValueFile_eavEntity = EventFragmentSparse_payload_EntityAttributeValueFile_eavEntity_Account | EventFragmentSparse_payload_EntityAttributeValueFile_eavEntity_Contact | EventFragmentSparse_payload_EntityAttributeValueFile_eavEntity_Lead;

export interface EventFragmentSparse_payload_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The entity that this file is associated with
   */
  eavEntity: EventFragmentSparse_payload_EntityAttributeValueFile_eavEntity;
}

export interface EventFragmentSparse_payload_Comment_parentEntity_Note_entity_Activity {
  __typename: "Activity" | "Thread" | "NoteEntityUnknownType";
}

export interface EventFragmentSparse_payload_Comment_parentEntity_Note_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_Comment_parentEntity_Note_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_Comment_parentEntity_Note_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export type EventFragmentSparse_payload_Comment_parentEntity_Note_entity = EventFragmentSparse_payload_Comment_parentEntity_Note_entity_Activity | EventFragmentSparse_payload_Comment_parentEntity_Note_entity_Contact | EventFragmentSparse_payload_Comment_parentEntity_Note_entity_Account | EventFragmentSparse_payload_Comment_parentEntity_Note_entity_Lead;

export interface EventFragmentSparse_payload_Comment_parentEntity_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity on which this note was written
   */
  entity: EventFragmentSparse_payload_Comment_parentEntity_Note_entity | null;
}

export interface EventFragmentSparse_payload_Comment_parentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface EventFragmentSparse_payload_Comment_parentEntity_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
}

export type EventFragmentSparse_payload_Comment_parentEntity = EventFragmentSparse_payload_Comment_parentEntity_Note | EventFragmentSparse_payload_Comment_parentEntity_Activity | EventFragmentSparse_payload_Comment_parentEntity_Email;

export interface EventFragmentSparse_payload_Comment {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  commentId: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Deleted time for comment, null if not deleted
   */
  deletedTime: any | null;
  /**
   * The entity on which this note was written
   */
  parentEntity: EventFragmentSparse_payload_Comment_parentEntity | null;
}

export interface EventFragmentSparse_payload_Session_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https:             // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The `www.nutshell.com` part of https: // www.nutshell.com/features?utm_source=Google
   */
  host: string | null;
}

export interface EventFragmentSparse_payload_Session_browser {
  __typename: "Browser";
  /**
   * The platform for the visit
   */
  platform: string;
  /**
   * The device type for the visit
   */
  deviceType: DeviceType;
}

export interface EventFragmentSparse_payload_Session_source {
  __typename: "McfxVisitSource";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The utm_medium value for this particular visit
   */
  medium: string;
  /**
   * The utm_source value for this particular visit
   */
  source: string;
  /**
   * Then mROI channel derived from this source information
   */
  channel: string;
}

export interface EventFragmentSparse_payload_Session_contact_nutshellContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_Session_contact {
  __typename: "McfxContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The contact that made this form submission.
   */
  nutshellContact: EventFragmentSparse_payload_Session_contact_nutshellContact | null;
}

export interface EventFragmentSparse_payload_Session_visits_edges_node_maUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EventFragmentSparse_payload_Session_visits_edges_node_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The `/features` part of https: // www.nutshell.com/features?utm_source=Google
   */
  path: string | null;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
  /**
   * The full URL, i.e. https:      // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface EventFragmentSparse_payload_Session_visits_edges_node {
  __typename: "Visit";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * How long the specific page visit lasted.
   */
  durationSeconds: number;
  /**
   * The marketing automation URL associated with this visit, if any.
   */
  maUrl: EventFragmentSparse_payload_Session_visits_edges_node_maUrl | null;
  /**
   * The page url for this user visit.
   */
  url: EventFragmentSparse_payload_Session_visits_edges_node_url;
}

export interface EventFragmentSparse_payload_Session_visits_edges {
  __typename: "SessionVisitsEdge";
  node: EventFragmentSparse_payload_Session_visits_edges_node;
}

export interface EventFragmentSparse_payload_Session_visits {
  __typename: "SessionVisitsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The total amount of time the visits lasted.
   */
  totalDuration: number | null;
  /**
   * The number of visits that have an associated marketing automation URL.
   */
  maUrlCount: number;
  /**
   * A list of edges.
   */
  edges: EventFragmentSparse_payload_Session_visits_edges[];
}

export interface EventFragmentSparse_payload_Session {
  __typename: "Session";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The url for the session, used to open as a timeline entry modal.
   */
  htmlUrlPath: string;
  /**
   * Some basic info on the location of the user represented as a string.
   */
  locationSummary: string | null;
  /**
   * The session url.
   */
  url: EventFragmentSparse_payload_Session_url;
  /**
   * The platform the user was on during the session.
   */
  browser: EventFragmentSparse_payload_Session_browser | null;
  source: EventFragmentSparse_payload_Session_source;
  /**
   * The contact associated with this session.
   */
  contact: EventFragmentSparse_payload_Session_contact | null;
  visits: EventFragmentSparse_payload_Session_visits;
  /**
   * When this session started. This is the value we’ll display to the user
   */
  startTime: any;
}

export interface EventFragmentSparse_payload_Thread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
}

export interface EventFragmentSparse_payload_Thread_displayMessage_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  htmlUrl: string | null;
  avatarUrl: string;
  initials: string;
}

export interface EventFragmentSparse_payload_Thread_displayMessage_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EventFragmentSparse_payload_Thread_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The content of the message
   */
  content: string;
  /**
   * The plain text to display the message
   */
  plainTextForDisplay: string | null;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The user who created this thread
   */
  creatorUser: EventFragmentSparse_payload_Thread_displayMessage_creatorUser | null;
  /**
   * The origin of the user who created this thread
   */
  creatorOrigin: EventFragmentSparse_payload_Thread_displayMessage_creatorOrigin | null;
  /**
   * The images in the message
   */
  images: string[];
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
}

export interface EventFragmentSparse_payload_Thread_messages {
  __typename: "ThreadMessagesConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface EventFragmentSparse_payload_Thread_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  htmlUrl: string | null;
  avatarUrl: string;
  initials: string;
}

export interface EventFragmentSparse_payload_Thread_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
}

export interface EventFragmentSparse_payload_Thread_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  initials: string;
}

export interface EventFragmentSparse_payload_Thread_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  initials: string;
}

export type EventFragmentSparse_payload_Thread_bestEntity = EventFragmentSparse_payload_Thread_bestEntity_Lead | EventFragmentSparse_payload_Thread_bestEntity_Account | EventFragmentSparse_payload_Thread_bestEntity_Contact;

export interface EventFragmentSparse_payload_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external channel this thread is related to
   */
  externalChannel: EventFragmentSparse_payload_Thread_externalChannel;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: EventFragmentSparse_payload_Thread_displayMessage | null;
  /**
   * The messages associated with this thread
   */
  messages: EventFragmentSparse_payload_Thread_messages;
  /**
   * the number of inbound messages on this thread
   */
  replyCount: number;
  /**
   * The user who created this thread
   */
  creatorUser: EventFragmentSparse_payload_Thread_creatorUser | null;
  /**
   * The best entity associated with this thread
   */
  bestEntity: EventFragmentSparse_payload_Thread_bestEntity | null;
  /**
   * Whether this thread can be reopened
   */
  canReopen: boolean;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
}

export interface EventFragmentSparse_payload_Message_edition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface EventFragmentSparse_payload_Message_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: EventFragmentSparse_payload_Message_edition_campaign;
}

export interface EventFragmentSparse_payload_Message_thread_bestEntity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string;
}

export interface EventFragmentSparse_payload_Message_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The best entity associated with this thread
   */
  bestEntity: EventFragmentSparse_payload_Message_thread_bestEntity | null;
}

export interface EventFragmentSparse_payload_Message {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The edition of the message
   */
  edition: EventFragmentSparse_payload_Message_edition | null;
  /**
   * The thread this message is part of
   */
  thread: EventFragmentSparse_payload_Message_thread;
}

export interface EventFragmentSparse_payload_Quote_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface EventFragmentSparse_payload_Quote_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: EventFragmentSparse_payload_Quote_lead_accounts_primaryEdge_node;
}

export interface EventFragmentSparse_payload_Quote_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EventFragmentSparse_payload_Quote_lead_accounts_primaryEdge | null;
}

export interface EventFragmentSparse_payload_Quote_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface EventFragmentSparse_payload_Quote_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: EventFragmentSparse_payload_Quote_lead_contacts_primaryEdge_node;
}

export interface EventFragmentSparse_payload_Quote_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EventFragmentSparse_payload_Quote_lead_contacts_primaryEdge | null;
}

export interface EventFragmentSparse_payload_Quote_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: EventFragmentSparse_payload_Quote_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: EventFragmentSparse_payload_Quote_lead_contacts;
}

export interface EventFragmentSparse_payload_Quote_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EventFragmentSparse_payload_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface EventFragmentSparse_payload_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: EventFragmentSparse_payload_Quote_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: EventFragmentSparse_payload_Quote_total;
  /**
   * The user that created the quote
   */
  creatorUser: EventFragmentSparse_payload_Quote_creatorUser | null;
}

export interface EventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface EventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: EventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge_node;
}

export interface EventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge | null;
}

export interface EventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface EventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: EventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge_node;
}

export interface EventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge | null;
}

export interface EventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: EventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: EventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_contacts;
}

export interface EventFragmentSparse_payload_DocumentView_salesDocument_Quote_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EventFragmentSparse_payload_DocumentView_salesDocument_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface EventFragmentSparse_payload_DocumentView_salesDocument_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: EventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: EventFragmentSparse_payload_DocumentView_salesDocument_Quote_total;
  /**
   * The user that created the quote
   */
  creatorUser: EventFragmentSparse_payload_DocumentView_salesDocument_Quote_creatorUser | null;
}

export interface EventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface EventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: EventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge_node;
}

export interface EventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge | null;
}

export interface EventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface EventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: EventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge_node;
}

export interface EventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge | null;
}

export interface EventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: EventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: EventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_contacts;
}

export interface EventFragmentSparse_payload_DocumentView_salesDocument_Invoice_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EventFragmentSparse_payload_DocumentView_salesDocument_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface EventFragmentSparse_payload_DocumentView_salesDocument_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: EventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: EventFragmentSparse_payload_DocumentView_salesDocument_Invoice_total;
  /**
   * The user that created the quote
   */
  creatorUser: EventFragmentSparse_payload_DocumentView_salesDocument_Invoice_creatorUser | null;
}

export type EventFragmentSparse_payload_DocumentView_salesDocument = EventFragmentSparse_payload_DocumentView_salesDocument_Quote | EventFragmentSparse_payload_DocumentView_salesDocument_Invoice;

export interface EventFragmentSparse_payload_DocumentView_contract_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface EventFragmentSparse_payload_DocumentView_contract_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: EventFragmentSparse_payload_DocumentView_contract_lead_accounts_primaryEdge_node;
}

export interface EventFragmentSparse_payload_DocumentView_contract_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EventFragmentSparse_payload_DocumentView_contract_lead_accounts_primaryEdge | null;
}

export interface EventFragmentSparse_payload_DocumentView_contract_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface EventFragmentSparse_payload_DocumentView_contract_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: EventFragmentSparse_payload_DocumentView_contract_lead_contacts_primaryEdge_node;
}

export interface EventFragmentSparse_payload_DocumentView_contract_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EventFragmentSparse_payload_DocumentView_contract_lead_contacts_primaryEdge | null;
}

export interface EventFragmentSparse_payload_DocumentView_contract_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: EventFragmentSparse_payload_DocumentView_contract_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: EventFragmentSparse_payload_DocumentView_contract_lead_contacts;
}

export interface EventFragmentSparse_payload_DocumentView_contract_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface EventFragmentSparse_payload_DocumentView_contract {
  __typename: "Contract";
  id: string;
  /**
   * The htmlUrl path without domain.
   */
  htmlUrlPath: string;
  lead: EventFragmentSparse_payload_DocumentView_contract_lead;
  displayNumber: string;
  creatorUser: EventFragmentSparse_payload_DocumentView_contract_creatorUser | null;
}

export interface EventFragmentSparse_payload_DocumentView {
  __typename: "DocumentView";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The quote or invoice this view is attached to, when applicable
   */
  salesDocument: EventFragmentSparse_payload_DocumentView_salesDocument | null;
  /**
   * The contract this view is attached to, when applicable
   */
  contract: EventFragmentSparse_payload_DocumentView_contract | null;
}

export interface EventFragmentSparse_payload_Invoice_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface EventFragmentSparse_payload_Invoice_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: EventFragmentSparse_payload_Invoice_lead_accounts_primaryEdge_node;
}

export interface EventFragmentSparse_payload_Invoice_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EventFragmentSparse_payload_Invoice_lead_accounts_primaryEdge | null;
}

export interface EventFragmentSparse_payload_Invoice_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface EventFragmentSparse_payload_Invoice_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: EventFragmentSparse_payload_Invoice_lead_contacts_primaryEdge_node;
}

export interface EventFragmentSparse_payload_Invoice_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EventFragmentSparse_payload_Invoice_lead_contacts_primaryEdge | null;
}

export interface EventFragmentSparse_payload_Invoice_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: EventFragmentSparse_payload_Invoice_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: EventFragmentSparse_payload_Invoice_lead_contacts;
}

export interface EventFragmentSparse_payload_Invoice_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface EventFragmentSparse_payload_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface EventFragmentSparse_payload_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: EventFragmentSparse_payload_Invoice_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: EventFragmentSparse_payload_Invoice_total;
  /**
   * The user that created the quote
   */
  creatorUser: EventFragmentSparse_payload_Invoice_creatorUser | null;
}

export interface EventFragmentSparse_payload_Contract_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface EventFragmentSparse_payload_Contract_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: EventFragmentSparse_payload_Contract_lead_accounts_primaryEdge_node;
}

export interface EventFragmentSparse_payload_Contract_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EventFragmentSparse_payload_Contract_lead_accounts_primaryEdge | null;
}

export interface EventFragmentSparse_payload_Contract_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface EventFragmentSparse_payload_Contract_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: EventFragmentSparse_payload_Contract_lead_contacts_primaryEdge_node;
}

export interface EventFragmentSparse_payload_Contract_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EventFragmentSparse_payload_Contract_lead_contacts_primaryEdge | null;
}

export interface EventFragmentSparse_payload_Contract_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: EventFragmentSparse_payload_Contract_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: EventFragmentSparse_payload_Contract_lead_contacts;
}

export interface EventFragmentSparse_payload_Contract_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface EventFragmentSparse_payload_Contract {
  __typename: "Contract";
  id: string;
  /**
   * The htmlUrl path without domain.
   */
  htmlUrlPath: string;
  lead: EventFragmentSparse_payload_Contract_lead;
  displayNumber: string;
  creatorUser: EventFragmentSparse_payload_Contract_creatorUser | null;
}

export interface EventFragmentSparse_payload_LeadClonePayload_original_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EventFragmentSparse_payload_LeadClonePayload_original {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: EventFragmentSparse_payload_LeadClonePayload_original_value | null;
}

export interface EventFragmentSparse_payload_LeadClonePayload_clone_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EventFragmentSparse_payload_LeadClonePayload_clone {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: EventFragmentSparse_payload_LeadClonePayload_clone_value | null;
}

export interface EventFragmentSparse_payload_LeadClonePayload {
  __typename: "LeadClonePayload";
  /**
   * The original lead
   */
  original: EventFragmentSparse_payload_LeadClonePayload_original;
  /**
   * The cloned lead
   */
  clone: EventFragmentSparse_payload_LeadClonePayload_clone;
}

export type EventFragmentSparse_payload = EventFragmentSparse_payload_TimelineEventPayloadUnknownType | EventFragmentSparse_payload_Activity | EventFragmentSparse_payload_AccountRelationshipChange | EventFragmentSparse_payload_AccountContactFormerStatusChange | EventFragmentSparse_payload_Note | EventFragmentSparse_payload_Email | EventFragmentSparse_payload_EmailQueued | EventFragmentSparse_payload_Origin | EventFragmentSparse_payload_Submission | EventFragmentSparse_payload_Account | EventFragmentSparse_payload_Contact | EventFragmentSparse_payload_Lead | EventFragmentSparse_payload_Chat | EventFragmentSparse_payload_Assignment | EventFragmentSparse_payload_EmailInteraction | EventFragmentSparse_payload_ConstantContactContactTrackingActivity | EventFragmentSparse_payload_EntityAttributeValueFile | EventFragmentSparse_payload_Comment | EventFragmentSparse_payload_Session | EventFragmentSparse_payload_Thread | EventFragmentSparse_payload_Message | EventFragmentSparse_payload_Quote | EventFragmentSparse_payload_DocumentView | EventFragmentSparse_payload_Invoice | EventFragmentSparse_payload_Contract | EventFragmentSparse_payload_LeadClonePayload;

export interface EventFragmentSparse_changes {
  __typename: "ChangeLogChange";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attrbute changed by the entry
   */
  attribute: string;
  /**
   * The old value before the change
   */
  oldValue: string | null;
  /**
   * The new value after the change
   */
  newValue: string | null;
}

export interface EventFragmentSparse_files_eavEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_files_eavEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EventFragmentSparse_files_eavEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EventFragmentSparse_files_eavEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: EventFragmentSparse_files_eavEntity_Lead_value | null;
}

export type EventFragmentSparse_files_eavEntity = EventFragmentSparse_files_eavEntity_Account | EventFragmentSparse_files_eavEntity_Contact | EventFragmentSparse_files_eavEntity_Lead;

export interface EventFragmentSparse_files {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The entity that this file is associated with
   */
  eavEntity: EventFragmentSparse_files_eavEntity;
}

export interface EventFragmentSparse_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EventFragmentSparse_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: EventFragmentSparse_reactions_creatorUser;
}

export interface EventFragmentSparse_comments_changeLogEntry {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EventFragmentSparse_comments_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EventFragmentSparse_comments_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: EventFragmentSparse_comments_reactions_creatorUser;
}

export interface EventFragmentSparse_comments_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
  htmlUrl: string | null;
}

export interface EventFragmentSparse_comments {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Change log associated with the comment
   */
  changeLogEntry: EventFragmentSparse_comments_changeLogEntry | null;
  /**
   * User reactions left for the comment change log entry
   */
  reactions: EventFragmentSparse_comments_reactions[];
  /**
   * The user who created the comment.
   */
  creatorUser: EventFragmentSparse_comments_creatorUser;
  /**
   * The created time for the comment.
   */
  createdTime: any;
  /**
   * True if this comment can be deleted
   */
  isDeleteable: boolean;
}

export interface EventFragmentSparse {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of change i.e. created, modified, deleted, etc
   */
  changeType: ChangeType;
  /**
   * The entity that triggered the change_log entry
   */
  actor: EventFragmentSparse_actor;
  payload: EventFragmentSparse_payload;
  changeTime: any;
  changes: EventFragmentSparse_changes[];
  /**
   * A one-off property to handle the case where multiple files can be associated
   * with a single change log entry. This is the only situation where multiple
   * payloads exist on an entry, so rather than adding additional complexity to our
   * entire system, we’ll treat it as a separate property
   */
  files: EventFragmentSparse_files[];
  reactions: EventFragmentSparse_reactions[];
  comments: EventFragmentSparse_comments[];
  /**
   * When multiple of the same entry occurs in a row, we’ll roll-up the count. For
   * example, if someone views an email 3 times in a row before a different change,
   * this value will be 3.
   */
  count: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailFragmentFull
// ====================================================

export interface EmailFragmentFull_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface EmailFragmentFull_recipients_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface EmailFragmentFull_recipients {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: EmailFragmentFull_recipients_avatarEntity | null;
}

export interface EmailFragmentFull_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface EmailFragmentFull_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: EmailFragmentFull_from_avatarEntity | null;
}

export interface EmailFragmentFull_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface EmailFragmentFull_emailRelatedLeads_edges_node_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface EmailFragmentFull_emailRelatedLeads_edges_node_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface EmailFragmentFull_emailRelatedLeads_edges_node_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EmailFragmentFull_emailRelatedLeads_edges_node_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: EmailFragmentFull_emailRelatedLeads_edges_node_contacts_primaryEdge_node;
}

export interface EmailFragmentFull_emailRelatedLeads_edges_node_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EmailFragmentFull_emailRelatedLeads_edges_node_contacts_primaryEdge | null;
}

export interface EmailFragmentFull_emailRelatedLeads_edges_node_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EmailFragmentFull_emailRelatedLeads_edges_node_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: EmailFragmentFull_emailRelatedLeads_edges_node_accounts_primaryEdge_node;
}

export interface EmailFragmentFull_emailRelatedLeads_edges_node_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: EmailFragmentFull_emailRelatedLeads_edges_node_accounts_primaryEdge | null;
}

export interface EmailFragmentFull_emailRelatedLeads_edges_node {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: EmailFragmentFull_emailRelatedLeads_edges_node_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: EmailFragmentFull_emailRelatedLeads_edges_node_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: EmailFragmentFull_emailRelatedLeads_edges_node_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: EmailFragmentFull_emailRelatedLeads_edges_node_accounts;
}

export interface EmailFragmentFull_emailRelatedLeads_edges {
  __typename: "EmailLeadsEdge";
  /**
   * Is this lead mapped to this email?
   */
  isMapped: boolean;
  node: EmailFragmentFull_emailRelatedLeads_edges_node;
}

export interface EmailFragmentFull_emailRelatedLeads {
  __typename: "EmailLeadsConnection";
  /**
   * A list of edges.
   */
  edges: EmailFragmentFull_emailRelatedLeads_edges[];
}

export interface EmailFragmentFull {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The excerpt of this email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  /**
   * A partially-formatted version of the body of this email,for use in the expanded view in a list
   */
  emailBodyHtml: string;
  attachments: EmailFragmentFull_attachments[];
  /**
   * True if the email is shared with other Nutshell users
   */
  isShared: boolean;
  /**
   * True if the email can be shared with other Nutshell users
   */
  isShareable: boolean;
  /**
   * Was this email a reply sent by Nutshell automatically.
   */
  isAutomatedReply: boolean;
  /**
   * Was this email sent by Nutshell automatically.
   */
  isEmailAutomation: boolean;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
  /**
   * If this is a ticket message from Zendesk, this is the id
   */
  ticketId: string | null;
  /**
   * If this is a ticket message from Zendesk, this is the url
   */
  ticketUrl: string | null;
  /**
   * Number of times this email has been viewed via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedViewsCount: number | null;
  /**
   * Number of times this email has been clicked via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedClicksCount: number | null;
  recipients: EmailFragmentFull_recipients[];
  from: EmailFragmentFull_from;
  /**
   * Was the email created outside of Nutshell
   */
  isInbound: boolean;
  /**
   * Was the email created in Nutshell
   */
  isOutbound: boolean;
  /**
   * Did the email fail to send
   */
  isFailed: boolean;
  /**
   * True if a Nutshell user can reply to this email
   */
  isReplyable: boolean;
  /**
   * Is this a Nutshell Marketing email
   */
  isNutshellMarketingEmail: boolean;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrlPath: string;
  /**
   * If this a Nutshell Marketing email, this is the edition
   */
  edition: EmailFragmentFull_edition | null;
  /**
   * Gets all leads related to this email. This includes all open leads at the time
   * of send, as well as any previously/explicitly associated leads
   */
  emailRelatedLeads: EmailFragmentFull_emailRelatedLeads;
  /**
   * How this email was added to Nutshell
   */
  originatedVia: string | null;
  /**
   * Was this email sent within the last week
   */
  sentWithinLastWeek: boolean;
  /**
   * Has this email accepted an AI reply suggestion
   */
  hasAcceptedSuggestion: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailInteractionFragmentFull
// ====================================================

export interface EmailInteractionFragmentFull_emailDelivery_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EmailInteractionFragmentFull_emailDelivery_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface EmailInteractionFragmentFull_emailDelivery_email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * A partially-formatted version of the body of this email,for use in the expanded view in a list
   */
  bodyHtml: string;
}

export interface EmailInteractionFragmentFull_emailDelivery {
  __typename: "EmailDelivery";
  primaryContact: EmailInteractionFragmentFull_emailDelivery_primaryContact | null;
  edition: EmailInteractionFragmentFull_emailDelivery_edition | null;
  email: EmailInteractionFragmentFull_emailDelivery_email | null;
}

export interface EmailInteractionFragmentFull {
  __typename: "EmailInteraction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: EmailInteractionType;
  link: string | null;
  emailDelivery: EmailInteractionFragmentFull_emailDelivery | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailQueuedFragmentFull
// ====================================================

export interface EmailQueuedFragmentFull_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface EmailQueuedFragmentFull_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface EmailQueuedFragmentFull_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: EmailQueuedFragmentFull_to_avatarEntity | null;
}

export interface EmailQueuedFragmentFull_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface EmailQueuedFragmentFull_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: EmailQueuedFragmentFull_from_avatarEntity | null;
}

export interface EmailQueuedFragmentFull {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * The excerpt of this queued email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  /**
   * A partially-formatted version of the body of this queued email,for use in the expanded view in a list
   */
  emailBodyHtml: string;
  attachments: EmailQueuedFragmentFull_attachments[];
  to: EmailQueuedFragmentFull_to[];
  /**
   * The sender email address for this queued email.
   */
  from: EmailQueuedFragmentFull_from;
  /**
   * True if this queued email is postponed and the user can retry it.
   */
  canRetry: boolean;
  /**
   * True if this is an email that looks failed to the user
   */
  isFailed: boolean;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InvoiceBannerFragment
// ====================================================

export interface InvoiceBannerFragment_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface InvoiceBannerFragment_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: InvoiceBannerFragment_lead_accounts_primaryEdge_node;
}

export interface InvoiceBannerFragment_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: InvoiceBannerFragment_lead_accounts_primaryEdge | null;
}

export interface InvoiceBannerFragment_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface InvoiceBannerFragment_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: InvoiceBannerFragment_lead_contacts_primaryEdge_node;
}

export interface InvoiceBannerFragment_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: InvoiceBannerFragment_lead_contacts_primaryEdge | null;
}

export interface InvoiceBannerFragment_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: InvoiceBannerFragment_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: InvoiceBannerFragment_lead_contacts;
}

export interface InvoiceBannerFragment_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface InvoiceBannerFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface InvoiceBannerFragment {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: InvoiceBannerFragment_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: InvoiceBannerFragment_total;
  /**
   * The user that created the quote
   */
  creatorUser: InvoiceBannerFragment_creatorUser | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LeadFragment
// ====================================================

export interface LeadFragment_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface LeadFragment {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: LeadFragment_value | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: MaUrlFragment
// ====================================================

export interface MaUrlFragment {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  /**
   * Path to the edit page for this money page.
   */
  htmlUrlPath: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: MessageFragment
// ====================================================

export interface MessageFragment_edition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface MessageFragment_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: MessageFragment_edition_campaign;
}

export interface MessageFragment_thread_bestEntity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string;
}

export interface MessageFragment_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The best entity associated with this thread
   */
  bestEntity: MessageFragment_thread_bestEntity | null;
}

export interface MessageFragment {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The edition of the message
   */
  edition: MessageFragment_edition | null;
  /**
   * The thread this message is part of
   */
  thread: MessageFragment_thread;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: NoteFragment
// ====================================================

export interface NoteFragment_entity_NoteEntityUnknownType {
  __typename: "NoteEntityUnknownType";
}

export interface NoteFragment_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface NoteFragment_entity_Activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface NoteFragment_entity_Activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface NoteFragment_entity_Activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface NoteFragment_entity_Activity_relatedLeads_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface NoteFragment_entity_Activity_relatedLeads_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface NoteFragment_entity_Activity_relatedLeads_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface NoteFragment_entity_Activity_relatedLeads_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: NoteFragment_entity_Activity_relatedLeads_contacts_primaryEdge_node;
}

export interface NoteFragment_entity_Activity_relatedLeads_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: NoteFragment_entity_Activity_relatedLeads_contacts_primaryEdge | null;
}

export interface NoteFragment_entity_Activity_relatedLeads_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface NoteFragment_entity_Activity_relatedLeads_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: NoteFragment_entity_Activity_relatedLeads_accounts_primaryEdge_node;
}

export interface NoteFragment_entity_Activity_relatedLeads_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: NoteFragment_entity_Activity_relatedLeads_accounts_primaryEdge | null;
}

export interface NoteFragment_entity_Activity_relatedLeads {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: NoteFragment_entity_Activity_relatedLeads_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: NoteFragment_entity_Activity_relatedLeads_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: NoteFragment_entity_Activity_relatedLeads_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: NoteFragment_entity_Activity_relatedLeads_accounts;
}

export interface NoteFragment_entity_Activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface NoteFragment_entity_Activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface NoteFragment_entity_Activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: NoteFragment_entity_Activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: NoteFragment_entity_Activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface NoteFragment_entity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: NoteFragment_entity_Activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: NoteFragment_entity_Activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: NoteFragment_entity_Activity_participants[];
  /**
   * Related leads for the activity.
   */
  relatedLeads: NoteFragment_entity_Activity_relatedLeads[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: NoteFragment_entity_Activity_externalMeeting | null;
}

export interface NoteFragment_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface NoteFragment_entity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface NoteFragment_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: NoteFragment_entity_Lead_value | null;
}

export interface NoteFragment_entity_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export type NoteFragment_entity = NoteFragment_entity_NoteEntityUnknownType | NoteFragment_entity_Account | NoteFragment_entity_Activity | NoteFragment_entity_Contact | NoteFragment_entity_Lead | NoteFragment_entity_Thread;

export interface NoteFragment {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
  /**
   * The htmlUrl without http: // app.nutshell.com
   */
  htmlUrlPath: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrl: string;
  /**
   * Is this note editable?
   */
  isEditable: boolean;
  /**
   * Does this note have mentioned entities? We care about this because our editing
   * flow for notes w/ mentioned entities is different than a note without entities.
   */
  hasMentionedEntities: boolean;
  /**
   * Whether note has been deleted
   */
  isDeleted: boolean;
  /**
   * The entity on which this note was written
   */
  entity: NoteFragment_entity | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: NutEmailAddressFragment
// ====================================================

export interface NutEmailAddressFragment_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface NutEmailAddressFragment {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: NutEmailAddressFragment_avatarEntity | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: OriginFragment
// ====================================================

export interface OriginFragment {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PinnedInfoFragment
// ====================================================

export interface PinnedInfoFragment_pinnedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface PinnedInfoFragment {
  __typename: "PinnedInfo";
  pinnedTime: any | null;
  pinnedByUser: PinnedInfoFragment_pinnedByUser;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: QuoteBannerFragment
// ====================================================

export interface QuoteBannerFragment_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface QuoteBannerFragment_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: QuoteBannerFragment_lead_accounts_primaryEdge_node;
}

export interface QuoteBannerFragment_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: QuoteBannerFragment_lead_accounts_primaryEdge | null;
}

export interface QuoteBannerFragment_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  initials: string;
}

export interface QuoteBannerFragment_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: QuoteBannerFragment_lead_contacts_primaryEdge_node;
}

export interface QuoteBannerFragment_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: QuoteBannerFragment_lead_contacts_primaryEdge | null;
}

export interface QuoteBannerFragment_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: QuoteBannerFragment_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: QuoteBannerFragment_lead_contacts;
}

export interface QuoteBannerFragment_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface QuoteBannerFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  htmlUrl: string | null;
  initials: string;
}

export interface QuoteBannerFragment {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * The lead the quote is associated with
   */
  lead: QuoteBannerFragment_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: QuoteBannerFragment_total;
  /**
   * The user that created the quote
   */
  creatorUser: QuoteBannerFragment_creatorUser | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: RelatedLeadFragment
// ====================================================

export interface RelatedLeadFragment_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface RelatedLeadFragment_assignee {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface RelatedLeadFragment_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface RelatedLeadFragment_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: RelatedLeadFragment_contacts_primaryEdge_node;
}

export interface RelatedLeadFragment_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: RelatedLeadFragment_contacts_primaryEdge | null;
}

export interface RelatedLeadFragment_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface RelatedLeadFragment_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: RelatedLeadFragment_accounts_primaryEdge_node;
}

export interface RelatedLeadFragment_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: RelatedLeadFragment_accounts_primaryEdge | null;
}

export interface RelatedLeadFragment {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  number: number | null;
  /**
   * String value of the lead’s current status
   */
  status: LeadStatus;
  /**
   * Priority for this lead
   */
  priority: LeadPriority;
  value: RelatedLeadFragment_value | null;
  /**
   * The user or team assigned to sell/win/nuture this Nutshell lead. Also referred to as "owner" within the product
   */
  assignee: RelatedLeadFragment_assignee | null;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: RelatedLeadFragment_contacts;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: RelatedLeadFragment_accounts;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SessionFragment
// ====================================================

export interface SessionFragment_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The full URL, i.e. https:             // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The `www.nutshell.com` part of https: // www.nutshell.com/features?utm_source=Google
   */
  host: string | null;
}

export interface SessionFragment_browser {
  __typename: "Browser";
  /**
   * The platform for the visit
   */
  platform: string;
  /**
   * The device type for the visit
   */
  deviceType: DeviceType;
}

export interface SessionFragment_source {
  __typename: "McfxVisitSource";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The utm_medium value for this particular visit
   */
  medium: string;
  /**
   * The utm_source value for this particular visit
   */
  source: string;
  /**
   * Then mROI channel derived from this source information
   */
  channel: string;
}

export interface SessionFragment_contact_nutshellContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface SessionFragment_contact {
  __typename: "McfxContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The contact that made this form submission.
   */
  nutshellContact: SessionFragment_contact_nutshellContact | null;
}

export interface SessionFragment_visits_edges_node_maUrl {
  __typename: "MaUrl";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface SessionFragment_visits_edges_node_url {
  __typename: "Url";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The `/features` part of https: // www.nutshell.com/features?utm_source=Google
   */
  path: string | null;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
  /**
   * The full URL, i.e. https:      // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface SessionFragment_visits_edges_node {
  __typename: "Visit";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * How long the specific page visit lasted.
   */
  durationSeconds: number;
  /**
   * The marketing automation URL associated with this visit, if any.
   */
  maUrl: SessionFragment_visits_edges_node_maUrl | null;
  /**
   * The page url for this user visit.
   */
  url: SessionFragment_visits_edges_node_url;
}

export interface SessionFragment_visits_edges {
  __typename: "SessionVisitsEdge";
  node: SessionFragment_visits_edges_node;
}

export interface SessionFragment_visits {
  __typename: "SessionVisitsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The total amount of time the visits lasted.
   */
  totalDuration: number | null;
  /**
   * The number of visits that have an associated marketing automation URL.
   */
  maUrlCount: number;
  /**
   * A list of edges.
   */
  edges: SessionFragment_visits_edges[];
}

export interface SessionFragment {
  __typename: "Session";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The url for the session, used to open as a timeline entry modal.
   */
  htmlUrlPath: string;
  /**
   * Some basic info on the location of the user represented as a string.
   */
  locationSummary: string | null;
  /**
   * The session url.
   */
  url: SessionFragment_url;
  /**
   * The platform the user was on during the session.
   */
  browser: SessionFragment_browser | null;
  source: SessionFragment_source;
  /**
   * The contact associated with this session.
   */
  contact: SessionFragment_contact | null;
  visits: SessionFragment_visits;
  /**
   * When this session started. This is the value we’ll display to the user
   */
  startTime: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ActivityFragmentSparse
// ====================================================

export interface ActivityFragmentSparse_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
  /**
   * The icon for this activity type
   */
  icon: ActivityTypeIcon;
}

export interface ActivityFragmentSparse_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface ActivityFragmentSparse_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface ActivityFragmentSparse_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The API ID of the entity this summary is for
   */
  entityId: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The current user's rating of this summary
   */
  userRating: EntitySummaryRating | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface ActivityFragmentSparse_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface ActivityFragmentSparse_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The transcript of this meeting
   */
  transcript: string | null;
  /**
   * The status of the transcript
   */
  transcriptStatus: TranscriptionStatus;
  /**
   * The url for the recording of this meeting
   */
  recordingUrl: string | null;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: ActivityFragmentSparse_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: ActivityFragmentSparse_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface ActivityFragmentSparse {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: ActivityFragmentSparse_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: ActivityFragmentSparse_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: ActivityFragmentSparse_participants[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: ActivityFragmentSparse_externalMeeting | null;
  /**
   * The transcription of the activity.
   */
  transcription: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ChatFragmentSparse
// ====================================================

export interface ChatFragmentSparse_chatItems {
  __typename: "ChatItem";
  /**
   * Time this message was sent
   */
  timestamp: any;
  /**
   * The attrbute chatItemd by the entry
   */
  body: string;
  /**
   * Person writing this particular message
   */
  chatter: string;
  /**
   * Type of chat message
   */
  type: string;
}

export interface ChatFragmentSparse_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface ChatFragmentSparse_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface ChatFragmentSparse_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string | null;
  htmlUrl: string | null;
}

export interface ChatFragmentSparse {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  /**
   * Not really sure tbh
   */
  chatItems: ChatFragmentSparse_chatItems[];
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: ChatFragmentSparse_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: ChatFragmentSparse_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: ChatFragmentSparse_participants[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailFragmentSparse
// ====================================================

export interface EmailFragmentSparse_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface EmailFragmentSparse_recipients_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface EmailFragmentSparse_recipients {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: EmailFragmentSparse_recipients_avatarEntity | null;
}

export interface EmailFragmentSparse_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface EmailFragmentSparse_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: EmailFragmentSparse_from_avatarEntity | null;
}

export interface EmailFragmentSparse_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface EmailFragmentSparse {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The excerpt of this email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  /**
   * A partially-formatted version of the body of this email,for use in the expanded view in a list
   */
  emailBodyHtml: string;
  /**
   * How this email was added to Nutshell
   */
  originatedVia: string | null;
  attachments: EmailFragmentSparse_attachments[];
  /**
   * True if the email is shared with other Nutshell users
   */
  isShared: boolean;
  /**
   * True if the email can be shared with other Nutshell users
   */
  isShareable: boolean;
  /**
   * Was this email a reply sent by Nutshell automatically.
   */
  isAutomatedReply: boolean;
  /**
   * Was this email sent by Nutshell automatically.
   */
  isEmailAutomation: boolean;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
  /**
   * If this is a ticket message from Zendesk, this is the id
   */
  ticketId: string | null;
  /**
   * If this is a ticket message from Zendesk, this is the url
   */
  ticketUrl: string | null;
  /**
   * Number of times this email has been viewed via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedViewsCount: number | null;
  /**
   * Number of times this email has been clicked via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedClicksCount: number | null;
  recipients: EmailFragmentSparse_recipients[];
  from: EmailFragmentSparse_from;
  /**
   * Was the email created outside of Nutshell
   */
  isInbound: boolean;
  /**
   * Was the email created in Nutshell
   */
  isOutbound: boolean;
  /**
   * Did the email fail to send
   */
  isFailed: boolean;
  /**
   * True if a Nutshell user can reply to this email
   */
  isReplyable: boolean;
  /**
   * Is this a Nutshell Marketing email
   */
  isNutshellMarketingEmail: boolean;
  /**
   * The URL that this note links to
   */
  htmlUrl: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrlPath: string;
  /**
   * If this a Nutshell Marketing email, this is the edition
   */
  edition: EmailFragmentSparse_edition | null;
  /**
   * Was this email sent within the last week
   */
  sentWithinLastWeek: boolean;
  /**
   * Has this email accepted an AI reply suggestion
   */
  hasAcceptedSuggestion: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailInteractionFragmentSparse
// ====================================================

export interface EmailInteractionFragmentSparse_emailDelivery_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface EmailInteractionFragmentSparse_emailDelivery_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface EmailInteractionFragmentSparse_emailDelivery_email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The URL that this note links to within the context of Nutshell
   */
  htmlUrlPath: string;
}

export interface EmailInteractionFragmentSparse_emailDelivery {
  __typename: "EmailDelivery";
  primaryContact: EmailInteractionFragmentSparse_emailDelivery_primaryContact | null;
  edition: EmailInteractionFragmentSparse_emailDelivery_edition | null;
  email: EmailInteractionFragmentSparse_emailDelivery_email | null;
}

export interface EmailInteractionFragmentSparse {
  __typename: "EmailInteraction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: EmailInteractionType;
  link: string | null;
  emailDelivery: EmailInteractionFragmentSparse_emailDelivery | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailQueuedFragmentSparse
// ====================================================

export interface EmailQueuedFragmentSparse_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface EmailQueuedFragmentSparse_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface EmailQueuedFragmentSparse_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: EmailQueuedFragmentSparse_to_avatarEntity | null;
}

export interface EmailQueuedFragmentSparse_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  initials: string | null;
  avatarUrl: string;
  htmlUrl: string | null;
}

export interface EmailQueuedFragmentSparse_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: EmailQueuedFragmentSparse_from_avatarEntity | null;
}

export interface EmailQueuedFragmentSparse {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * The excerpt of this queued email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  attachments: EmailQueuedFragmentSparse_attachments[];
  to: EmailQueuedFragmentSparse_to[];
  /**
   * The sender email address for this queued email.
   */
  from: EmailQueuedFragmentSparse_from;
  /**
   * True if this queued email is postponed and the user can retry it.
   */
  canRetry: boolean;
  /**
   * True if this is an email that looks failed to the user
   */
  isFailed: boolean;
  /**
   * A path to get to the detail view of this queued email.
   */
  htmlUrl: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SubmissionFragment
// ====================================================

export interface SubmissionFragment_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
  formatted: string;
}

export interface SubmissionFragment_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  isPrimary: boolean;
  value: SubmissionFragment_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface SubmissionFragment_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: SubmissionFragment_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface SubmissionFragment_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: SubmissionFragment_booking_additionalAttendees_emailAddresses;
}

export interface SubmissionFragment_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (SubmissionFragment_booking_additionalAttendees | null)[];
}

export interface SubmissionFragment_primaryEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface SubmissionFragment_primaryEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  avatarUrl: string;
  initials: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
}

export interface SubmissionFragment_primaryEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface SubmissionFragment_primaryEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  avatarUrl: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
  value: SubmissionFragment_primaryEntity_Lead_value | null;
}

export type SubmissionFragment_primaryEntity = SubmissionFragment_primaryEntity_Account | SubmissionFragment_primaryEntity_Contact | SubmissionFragment_primaryEntity_Lead;

export interface SubmissionFragment_formVersion_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface SubmissionFragment_formVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent form of this form version
   */
  form: SubmissionFragment_formVersion_form;
}

export interface SubmissionFragment_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface SubmissionFragment_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface SubmissionFragment_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: SubmissionFragment_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export interface SubmissionFragment_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface SubmissionFragment_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export type SubmissionFragment_fields_edges_fieldValue = SubmissionFragment_fields_edges_fieldValue_FormFieldSubmissionValueSubfields | SubmissionFragment_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | SubmissionFragment_fields_edges_fieldValue_FormFieldSubmissionValueSingle;

export interface SubmissionFragment_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: SubmissionFragment_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: SubmissionFragment_fields_edges_fieldValue | null;
}

export interface SubmissionFragment_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: SubmissionFragment_fields_edges[];
}

export interface SubmissionFragment {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The url where the submission originates
   */
  submissionUrl: string;
  /**
   * The booking associated with this submission (if Scheduler)
   */
  booking: SubmissionFragment_booking | null;
  /**
   * The primary entity on the submission
   */
  primaryEntity: SubmissionFragment_primaryEntity | null;
  /**
   * The name of the submitted web form
   */
  formVersion: SubmissionFragment_formVersion;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: SubmissionFragment_fields;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ThreadFragment
// ====================================================

export interface ThreadFragment_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
}

export interface ThreadFragment_displayMessage_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  htmlUrl: string | null;
  avatarUrl: string;
  initials: string;
}

export interface ThreadFragment_displayMessage_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ThreadFragment_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The content of the message
   */
  content: string;
  /**
   * The plain text to display the message
   */
  plainTextForDisplay: string | null;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The user who created this thread
   */
  creatorUser: ThreadFragment_displayMessage_creatorUser | null;
  /**
   * The origin of the user who created this thread
   */
  creatorOrigin: ThreadFragment_displayMessage_creatorOrigin | null;
  /**
   * The images in the message
   */
  images: string[];
  /**
   * The time the message is scheduled to be sent
   */
  scheduledTime: any;
  /**
   * The time the message was sent
   */
  sentTime: any | null;
  /**
   * The time the message failed to send
   */
  failedTime: any | null;
}

export interface ThreadFragment_messages {
  __typename: "ThreadMessagesConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface ThreadFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  htmlUrl: string | null;
  avatarUrl: string;
  initials: string;
}

export interface ThreadFragment_bestEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
}

export interface ThreadFragment_bestEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  initials: string;
}

export interface ThreadFragment_bestEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The URL that this person links to within the context of Nutshell.
   */
  htmlUrl: string;
  avatarUrl: string;
  initials: string;
}

export type ThreadFragment_bestEntity = ThreadFragment_bestEntity_Lead | ThreadFragment_bestEntity_Account | ThreadFragment_bestEntity_Contact;

export interface ThreadFragment {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external channel this thread is related to
   */
  externalChannel: ThreadFragment_externalChannel;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: ThreadFragment_displayMessage | null;
  /**
   * The messages associated with this thread
   */
  messages: ThreadFragment_messages;
  /**
   * the number of inbound messages on this thread
   */
  replyCount: number;
  /**
   * The user who created this thread
   */
  creatorUser: ThreadFragment_creatorUser | null;
  /**
   * The best entity associated with this thread
   */
  bestEntity: ThreadFragment_bestEntity | null;
  /**
   * Whether this thread can be reopened
   */
  canReopen: boolean;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserFragment
// ====================================================

export interface UserFragment {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
  avatarUrl: string;
  initials: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ReactionFragment
// ====================================================

export interface ReactionFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface ReactionFragment {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: ReactionFragment_creatorUser;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EmailLeadAssociationsFragment
// ====================================================

export interface EmailLeadAssociationsFragment_relatedLeads_edges_node {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface EmailLeadAssociationsFragment_relatedLeads_edges {
  __typename: "EmailLeadsEdge";
  node: EmailLeadAssociationsFragment_relatedLeads_edges_node;
}

export interface EmailLeadAssociationsFragment_relatedLeads {
  __typename: "EmailLeadsConnection";
  /**
   * A list of edges.
   */
  edges: EmailLeadAssociationsFragment_relatedLeads_edges[];
}

export interface EmailLeadAssociationsFragment {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Gets all leads related to this email. This includes all open leads at the time
   * of send, as well as any previously/explicitly associated leads
   */
  relatedLeads: EmailLeadAssociationsFragment_relatedLeads;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: OnboardingModuleFragment
// ====================================================

export interface OnboardingModuleFragment_steps {
  __typename: "OnboardingStep";
  /**
   * The name of the step
   */
  title: string;
  /**
   * The type of the step
   */
  type: OnboardingStepType;
  /**
   * Whether the step is complete
   */
  isComplete: boolean;
}

export interface OnboardingModuleFragment {
  __typename: "OnboardingModule";
  /**
   * The name of the onboarding module
   */
  name: string;
  /**
   * The type of the onboarding module
   */
  type: OnboardingModuleType;
  /**
   * The status of the onboarding module
   */
  status: OnboardingModuleStatus;
  /**
   * The description of the onboarding module
   */
  description: string;
  /**
   * Whether the onboarding module is complete
   */
  isComplete: boolean;
  /**
   * The steps of the onboarding module
   */
  steps: OnboardingModuleFragment_steps[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: OnboardingQuotesFragment
// ====================================================

export interface OnboardingQuotesFragment_openQuote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The htmlUrl without http: // app.nutshell.com.
   */
  htmlUrlPath: string;
}

export interface OnboardingQuotesFragment {
  __typename: "OnboardingQuotes";
  /**
   * The quote to open for onboarding walkthrough
   */
  openQuote: OnboardingQuotesFragment_openQuote | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: OnboardingStepFragment
// ====================================================

export interface OnboardingStepFragment {
  __typename: "OnboardingStep";
  /**
   * The name of the step
   */
  title: string;
  /**
   * The type of the step
   */
  type: OnboardingStepType;
  /**
   * Whether the step is complete
   */
  isComplete: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserEmailCalendarStatusesFragment
// ====================================================

export interface UserEmailCalendarStatusesFragment_calendarSync {
  __typename: "CalendarSync";
  /**
   * The email address being used for calendar sync
   */
  username: string;
  /**
   * Whether or not calendar sync is enabled
   */
  isEnabled: boolean;
}

export interface UserEmailCalendarStatusesFragment_sendableEmailAddresses {
  __typename: "UserEmail";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface UserEmailCalendarStatusesFragment {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Calendar sync details for this user
   */
  calendarSync: UserEmailCalendarStatusesFragment_calendarSync | null;
  /**
   * List of successfully enabled user email addresses that a user is able to send emails from Nutshell with.
   */
  sendableEmailAddresses: UserEmailCalendarStatusesFragment_sendableEmailAddresses[];
  hasMailSyncEnabled: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserVideoIntegrationsFragment
// ====================================================

export interface UserVideoIntegrationsFragment_zoomIntegration {
  __typename: "ZoomIntegration";
  /**
   * Whether or not the zoom integration is enabled
   */
  isEnabled: boolean;
}

export interface UserVideoIntegrationsFragment_googleMeetIntegration {
  __typename: "GoogleMeetIntegration";
  /**
   * Whether or not the Google Meet integration is enabled with meet sync
   */
  isEnabledMeetSync: boolean;
}

export interface UserVideoIntegrationsFragment_microsoftTeamsIntegration {
  __typename: "MicrosoftTeamsIntegration";
  /**
   * Whether or not the  Microsoft Teams integration is enabled
   */
  isEnabled: boolean;
}

export interface UserVideoIntegrationsFragment {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Zoom integration details for this user
   */
  zoomIntegration: UserVideoIntegrationsFragment_zoomIntegration;
  /**
   * Google Meet integration details for this user
   */
  googleMeetIntegration: UserVideoIntegrationsFragment_googleMeetIntegration;
  /**
   * Microsoft Teams integration details for this user
   */
  microsoftTeamsIntegration: UserVideoIntegrationsFragment_microsoftTeamsIntegration;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: WebinarAnnouncementFragment
// ====================================================

export interface WebinarAnnouncementFragment {
  __typename: "WebinarAnnouncement";
  id: string;
  title: string;
  /**
   * GitHub-flavored markdown source. Render client-side via `react-markdown`.
   */
  body: string;
  registerLink: string;
  registerText: string;
  /**
   * Optional markdown below the register CTA (seat limits, recording note).
   */
  subtext: string | null;
  /**
   * ISO-8601 datetime. Modal hidden until this instant (inclusive).
   */
  startTime: string;
  /**
   * ISO-8601 datetime. Modal hidden after this instant.
   */
  expiryTime: string;
  isLive: boolean;
  senderName: string;
  /**
   * Absolute web path to the sender avatar image.
   */
  senderAvatarSrc: string;
  /**
   * Absolute web path to the per-webinar hero image under `public/include/images/webinar-announcements/<id>/`.
   */
  heroImageSrc: string;
  /**
   * Human-readable schedule line shown next to the calendar icon (e.g. "Wednesday, July 22nd 2026 @ 3:00 PM EDT").
   */
  eventSchedule: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCUserFragment
// ====================================================

export interface LCUserFragment {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCOriginFragment
// ====================================================

export interface LCOriginFragment {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCContactFragment
// ====================================================

export interface LCContactFragment {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCAccountFragment
// ====================================================

export interface LCAccountFragment {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCEntitySummaryFragment
// ====================================================

export interface LCEntitySummaryFragment {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCZoomMeetingTimelineFragment
// ====================================================

export interface LCZoomMeetingTimelineFragment_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface LCZoomMeetingTimelineFragment_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface LCZoomMeetingTimelineFragment {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: LCZoomMeetingTimelineFragment_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: LCZoomMeetingTimelineFragment_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCActivityFragment
// ====================================================

export interface LCActivityFragment_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface LCActivityFragment_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface LCActivityFragment_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCActivityFragment_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface LCActivityFragment_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface LCActivityFragment_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: LCActivityFragment_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: LCActivityFragment_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface LCActivityFragment {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: LCActivityFragment_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: LCActivityFragment_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: LCActivityFragment_participants[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: LCActivityFragment_externalMeeting | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCLeadFragment
// ====================================================

export interface LCLeadFragment_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface LCLeadFragment {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: LCLeadFragment_value | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCNoteFragment
// ====================================================

export interface LCNoteFragment_entity_Thread {
  __typename: "Thread" | "NoteEntityUnknownType";
}

export interface LCNoteFragment_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCNoteFragment_entity_Activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface LCNoteFragment_entity_Activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface LCNoteFragment_entity_Activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCNoteFragment_entity_Activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface LCNoteFragment_entity_Activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface LCNoteFragment_entity_Activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: LCNoteFragment_entity_Activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: LCNoteFragment_entity_Activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface LCNoteFragment_entity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: LCNoteFragment_entity_Activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: LCNoteFragment_entity_Activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: LCNoteFragment_entity_Activity_participants[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: LCNoteFragment_entity_Activity_externalMeeting | null;
}

export interface LCNoteFragment_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCNoteFragment_entity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface LCNoteFragment_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: LCNoteFragment_entity_Lead_value | null;
}

export type LCNoteFragment_entity = LCNoteFragment_entity_Thread | LCNoteFragment_entity_Account | LCNoteFragment_entity_Activity | LCNoteFragment_entity_Contact | LCNoteFragment_entity_Lead;

export interface LCNoteFragment {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
  /**
   * Whether note has been deleted
   */
  isDeleted: boolean;
  /**
   * The entity on which this note was written
   */
  entity: LCNoteFragment_entity | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCSubmissionFragment
// ====================================================

export interface LCSubmissionFragment_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
  formatted: string;
}

export interface LCSubmissionFragment_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  isPrimary: boolean;
  value: LCSubmissionFragment_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface LCSubmissionFragment_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: LCSubmissionFragment_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface LCSubmissionFragment_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: LCSubmissionFragment_booking_additionalAttendees_emailAddresses;
}

export interface LCSubmissionFragment_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (LCSubmissionFragment_booking_additionalAttendees | null)[];
}

export interface LCSubmissionFragment_primaryEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCSubmissionFragment_primaryEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCSubmissionFragment_primaryEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface LCSubmissionFragment_primaryEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: LCSubmissionFragment_primaryEntity_Lead_value | null;
}

export type LCSubmissionFragment_primaryEntity = LCSubmissionFragment_primaryEntity_Account | LCSubmissionFragment_primaryEntity_Contact | LCSubmissionFragment_primaryEntity_Lead;

export interface LCSubmissionFragment_formVersion_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
}

export interface LCSubmissionFragment_formVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent form of this form version
   */
  form: LCSubmissionFragment_formVersion_form;
}

export interface LCSubmissionFragment_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface LCSubmissionFragment_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface LCSubmissionFragment_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: LCSubmissionFragment_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export interface LCSubmissionFragment_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface LCSubmissionFragment_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export type LCSubmissionFragment_fields_edges_fieldValue = LCSubmissionFragment_fields_edges_fieldValue_FormFieldSubmissionValueSubfields | LCSubmissionFragment_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | LCSubmissionFragment_fields_edges_fieldValue_FormFieldSubmissionValueSingle;

export interface LCSubmissionFragment_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: LCSubmissionFragment_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: LCSubmissionFragment_fields_edges_fieldValue | null;
}

export interface LCSubmissionFragment_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: LCSubmissionFragment_fields_edges[];
}

export interface LCSubmissionFragment {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The booking associated with this submission (if Scheduler)
   */
  booking: LCSubmissionFragment_booking | null;
  /**
   * The primary entity on the submission
   */
  primaryEntity: LCSubmissionFragment_primaryEntity | null;
  /**
   * The name of the submitted web form
   */
  formVersion: LCSubmissionFragment_formVersion;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: LCSubmissionFragment_fields;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCAssignmentFragment
// ====================================================

export interface LCAssignmentFragment_assignmentEntity_Thread {
  __typename: "Thread";
}

export interface LCAssignmentFragment_assignmentEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCAssignmentFragment_assignmentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface LCAssignmentFragment_assignmentEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCAssignmentFragment_assignmentEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
}

export interface LCAssignmentFragment_assignmentEntity_UnknownEntityType {
  __typename: "UnknownEntityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type LCAssignmentFragment_assignmentEntity = LCAssignmentFragment_assignmentEntity_Thread | LCAssignmentFragment_assignmentEntity_Account | LCAssignmentFragment_assignmentEntity_Activity | LCAssignmentFragment_assignmentEntity_Contact | LCAssignmentFragment_assignmentEntity_Lead | LCAssignmentFragment_assignmentEntity_UnknownEntityType;

export interface LCAssignmentFragment_assigneeEntity {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCAssignmentFragment {
  __typename: "Assignment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity that was assigned
   */
  assignmentEntity: LCAssignmentFragment_assignmentEntity;
  /**
   * The entity to which the assignment was made
   */
  assigneeEntity: LCAssignmentFragment_assigneeEntity;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCConstantContactContactTrackingActivityFragment
// ====================================================

export interface LCConstantContactContactTrackingActivityFragment_ctctContact_contacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCConstantContactContactTrackingActivityFragment_ctctContact {
  __typename: "ConstantContactContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailAddress: string;
  /**
   * The Nutshell contacts associated with this CTCT contact
   */
  contacts: LCConstantContactContactTrackingActivityFragment_ctctContact_contacts[];
}

export interface LCConstantContactContactTrackingActivityFragment {
  __typename: "ConstantContactContactTrackingActivity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  campaignName: string | null;
  trackingActivityType: ConstantContactContactTrackingActivityType;
  emailSubject: string | null;
  ctctContact: LCConstantContactContactTrackingActivityFragment_ctctContact;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCEntityAttributeValueFileFragment
// ====================================================

export interface LCEntityAttributeValueFileFragment_eavEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEntityAttributeValueFileFragment_eavEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEntityAttributeValueFileFragment_eavEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface LCEntityAttributeValueFileFragment_eavEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: LCEntityAttributeValueFileFragment_eavEntity_Lead_value | null;
}

export type LCEntityAttributeValueFileFragment_eavEntity = LCEntityAttributeValueFileFragment_eavEntity_Account | LCEntityAttributeValueFileFragment_eavEntity_Contact | LCEntityAttributeValueFileFragment_eavEntity_Lead;

export interface LCEntityAttributeValueFileFragment {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The entity that this file is associated with
   */
  eavEntity: LCEntityAttributeValueFileFragment_eavEntity;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCCommentBannerFragment
// ====================================================

export interface LCCommentBannerFragment_parentEntity_Note_entity_Activity {
  __typename: "Activity" | "Thread" | "NoteEntityUnknownType";
}

export interface LCCommentBannerFragment_parentEntity_Note_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCCommentBannerFragment_parentEntity_Note_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCCommentBannerFragment_parentEntity_Note_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
}

export type LCCommentBannerFragment_parentEntity_Note_entity = LCCommentBannerFragment_parentEntity_Note_entity_Activity | LCCommentBannerFragment_parentEntity_Note_entity_Contact | LCCommentBannerFragment_parentEntity_Note_entity_Account | LCCommentBannerFragment_parentEntity_Note_entity_Lead;

export interface LCCommentBannerFragment_parentEntity_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity on which this note was written
   */
  entity: LCCommentBannerFragment_parentEntity_Note_entity | null;
}

export interface LCCommentBannerFragment_parentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface LCCommentBannerFragment_parentEntity_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
}

export type LCCommentBannerFragment_parentEntity = LCCommentBannerFragment_parentEntity_Note | LCCommentBannerFragment_parentEntity_Activity | LCCommentBannerFragment_parentEntity_Email;

export interface LCCommentBannerFragment {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  commentId: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Deleted time for comment, null if not deleted
   */
  deletedTime: any | null;
  /**
   * The entity on which this note was written
   */
  parentEntity: LCCommentBannerFragment_parentEntity | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCSessionFragment
// ====================================================

export interface LCSessionFragment_url {
  __typename: "Url";
  /**
   * The full URL, i.e. https:             // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The `www.nutshell.com` part of https: // www.nutshell.com/features?utm_source=Google
   */
  host: string | null;
}

export interface LCSessionFragment_browser {
  __typename: "Browser";
  /**
   * The platform for the visit
   */
  platform: string;
  /**
   * The device type for the visit
   */
  deviceType: DeviceType;
}

export interface LCSessionFragment_source {
  __typename: "McfxVisitSource";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The utm_medium value for this particular visit
   */
  medium: string;
  /**
   * The utm_source value for this particular visit
   */
  source: string;
  /**
   * Then mROI channel derived from this source information
   */
  channel: string;
}

export interface LCSessionFragment_contact_nutshellContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCSessionFragment_contact {
  __typename: "McfxContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The contact that made this form submission.
   */
  nutshellContact: LCSessionFragment_contact_nutshellContact | null;
}

export interface LCSessionFragment_visits_edges_node_url {
  __typename: "Url";
  /**
   * The `/features` part of https: // www.nutshell.com/features?utm_source=Google
   */
  path: string | null;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
  /**
   * The full URL, i.e. https:      // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface LCSessionFragment_visits_edges_node {
  __typename: "Visit";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * How long the specific page visit lasted.
   */
  durationSeconds: number;
  /**
   * The page url for this user visit.
   */
  url: LCSessionFragment_visits_edges_node_url;
}

export interface LCSessionFragment_visits_edges {
  __typename: "SessionVisitsEdge";
  node: LCSessionFragment_visits_edges_node;
}

export interface LCSessionFragment_visits {
  __typename: "SessionVisitsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The total amount of time the visits lasted.
   */
  totalDuration: number | null;
  /**
   * A list of edges.
   */
  edges: LCSessionFragment_visits_edges[];
}

export interface LCSessionFragment {
  __typename: "Session";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Some basic info on the location of the user represented as a string.
   */
  locationSummary: string | null;
  /**
   * The session url.
   */
  url: LCSessionFragment_url;
  /**
   * The platform the user was on during the session.
   */
  browser: LCSessionFragment_browser | null;
  source: LCSessionFragment_source;
  /**
   * The contact associated with this session.
   */
  contact: LCSessionFragment_contact | null;
  visits: LCSessionFragment_visits;
  /**
   * When this session started. This is the value we’ll display to the user
   */
  startTime: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCThreadFragment
// ====================================================

export interface LCThreadFragment_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
}

export interface LCThreadFragment_displayMessage_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCThreadFragment_displayMessage_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCThreadFragment_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The content of the message
   */
  content: string;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The user who created this thread
   */
  creatorUser: LCThreadFragment_displayMessage_creatorUser | null;
  /**
   * The origin of the user who created this thread
   */
  creatorOrigin: LCThreadFragment_displayMessage_creatorOrigin | null;
  /**
   * The images in the message
   */
  images: string[];
}

export interface LCThreadFragment_messages {
  __typename: "ThreadMessagesConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface LCThreadFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCThreadFragment_bestEntity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCThreadFragment {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external channel this thread is related to
   */
  externalChannel: LCThreadFragment_externalChannel;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: LCThreadFragment_displayMessage | null;
  /**
   * The messages associated with this thread
   */
  messages: LCThreadFragment_messages;
  /**
   * the number of inbound messages on this thread
   */
  replyCount: number;
  /**
   * The user who created this thread
   */
  creatorUser: LCThreadFragment_creatorUser | null;
  /**
   * The best entity associated with this thread
   */
  bestEntity: LCThreadFragment_bestEntity | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCMessageFragment
// ====================================================

export interface LCMessageFragment_edition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface LCMessageFragment_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: LCMessageFragment_edition_campaign;
}

export interface LCMessageFragment_thread_bestEntity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCMessageFragment_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The best entity associated with this thread
   */
  bestEntity: LCMessageFragment_thread_bestEntity | null;
}

export interface LCMessageFragment {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The edition of the message
   */
  edition: LCMessageFragment_edition | null;
  /**
   * The thread this message is part of
   */
  thread: LCMessageFragment_thread;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCQuoteBannerFragment
// ====================================================

export interface LCQuoteBannerFragment_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCQuoteBannerFragment_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: LCQuoteBannerFragment_lead_accounts_primaryEdge_node;
}

export interface LCQuoteBannerFragment_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LCQuoteBannerFragment_lead_accounts_primaryEdge | null;
}

export interface LCQuoteBannerFragment_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCQuoteBannerFragment_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: LCQuoteBannerFragment_lead_contacts_primaryEdge_node;
}

export interface LCQuoteBannerFragment_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LCQuoteBannerFragment_lead_contacts_primaryEdge | null;
}

export interface LCQuoteBannerFragment_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: LCQuoteBannerFragment_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: LCQuoteBannerFragment_lead_contacts;
}

export interface LCQuoteBannerFragment_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface LCQuoteBannerFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCQuoteBannerFragment {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The lead the quote is associated with
   */
  lead: LCQuoteBannerFragment_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: LCQuoteBannerFragment_total;
  /**
   * The user that created the quote
   */
  creatorUser: LCQuoteBannerFragment_creatorUser | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCDocumentView
// ====================================================

export interface LCDocumentView_salesDocument_Quote_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCDocumentView_salesDocument_Quote_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: LCDocumentView_salesDocument_Quote_lead_accounts_primaryEdge_node;
}

export interface LCDocumentView_salesDocument_Quote_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LCDocumentView_salesDocument_Quote_lead_accounts_primaryEdge | null;
}

export interface LCDocumentView_salesDocument_Quote_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCDocumentView_salesDocument_Quote_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: LCDocumentView_salesDocument_Quote_lead_contacts_primaryEdge_node;
}

export interface LCDocumentView_salesDocument_Quote_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LCDocumentView_salesDocument_Quote_lead_contacts_primaryEdge | null;
}

export interface LCDocumentView_salesDocument_Quote_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: LCDocumentView_salesDocument_Quote_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: LCDocumentView_salesDocument_Quote_lead_contacts;
}

export interface LCDocumentView_salesDocument_Quote_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface LCDocumentView_salesDocument_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCDocumentView_salesDocument_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The lead the quote is associated with
   */
  lead: LCDocumentView_salesDocument_Quote_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: LCDocumentView_salesDocument_Quote_total;
  /**
   * The user that created the quote
   */
  creatorUser: LCDocumentView_salesDocument_Quote_creatorUser | null;
}

export interface LCDocumentView_salesDocument_Invoice_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCDocumentView_salesDocument_Invoice_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: LCDocumentView_salesDocument_Invoice_lead_accounts_primaryEdge_node;
}

export interface LCDocumentView_salesDocument_Invoice_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LCDocumentView_salesDocument_Invoice_lead_accounts_primaryEdge | null;
}

export interface LCDocumentView_salesDocument_Invoice_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCDocumentView_salesDocument_Invoice_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: LCDocumentView_salesDocument_Invoice_lead_contacts_primaryEdge_node;
}

export interface LCDocumentView_salesDocument_Invoice_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LCDocumentView_salesDocument_Invoice_lead_contacts_primaryEdge | null;
}

export interface LCDocumentView_salesDocument_Invoice_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: LCDocumentView_salesDocument_Invoice_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: LCDocumentView_salesDocument_Invoice_lead_contacts;
}

export interface LCDocumentView_salesDocument_Invoice_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface LCDocumentView_salesDocument_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCDocumentView_salesDocument_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The lead the quote is associated with
   */
  lead: LCDocumentView_salesDocument_Invoice_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: LCDocumentView_salesDocument_Invoice_total;
  /**
   * The user that created the quote
   */
  creatorUser: LCDocumentView_salesDocument_Invoice_creatorUser | null;
}

export type LCDocumentView_salesDocument = LCDocumentView_salesDocument_Quote | LCDocumentView_salesDocument_Invoice;

export interface LCDocumentView {
  __typename: "DocumentView";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The quote or invoice this view is attached to, when applicable
   */
  salesDocument: LCDocumentView_salesDocument | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCInvoiceBannerFragment
// ====================================================

export interface LCInvoiceBannerFragment_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCInvoiceBannerFragment_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: LCInvoiceBannerFragment_lead_accounts_primaryEdge_node;
}

export interface LCInvoiceBannerFragment_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LCInvoiceBannerFragment_lead_accounts_primaryEdge | null;
}

export interface LCInvoiceBannerFragment_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCInvoiceBannerFragment_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: LCInvoiceBannerFragment_lead_contacts_primaryEdge_node;
}

export interface LCInvoiceBannerFragment_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LCInvoiceBannerFragment_lead_contacts_primaryEdge | null;
}

export interface LCInvoiceBannerFragment_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: LCInvoiceBannerFragment_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: LCInvoiceBannerFragment_lead_contacts;
}

export interface LCInvoiceBannerFragment_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface LCInvoiceBannerFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCInvoiceBannerFragment {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The lead the quote is associated with
   */
  lead: LCInvoiceBannerFragment_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: LCInvoiceBannerFragment_total;
  /**
   * The user that created the quote
   */
  creatorUser: LCInvoiceBannerFragment_creatorUser | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCNutEmailAddressFragment
// ====================================================

export interface LCNutEmailAddressFragment_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCNutEmailAddressFragment {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: LCNutEmailAddressFragment_avatarEntity | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCEmailFragmentSparse
// ====================================================

export interface LCEmailFragmentSparse_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface LCEmailFragmentSparse_recipients_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEmailFragmentSparse_recipients {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: LCEmailFragmentSparse_recipients_avatarEntity | null;
}

export interface LCEmailFragmentSparse_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEmailFragmentSparse_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: LCEmailFragmentSparse_from_avatarEntity | null;
}

export interface LCEmailFragmentSparse_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface LCEmailFragmentSparse {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The excerpt of this email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  /**
   * A partially-formatted version of the body of this email,for use in the expanded view in a list
   */
  emailBodyHtml: string;
  /**
   * How this email was added to Nutshell
   */
  originatedVia: string | null;
  attachments: LCEmailFragmentSparse_attachments[];
  /**
   * True if the email is shared with other Nutshell users
   */
  isShared: boolean;
  /**
   * True if the email can be shared with other Nutshell users
   */
  isShareable: boolean;
  /**
   * Was this email a reply sent by Nutshell automatically.
   */
  isAutomatedReply: boolean;
  /**
   * Was this email sent by Nutshell automatically.
   */
  isEmailAutomation: boolean;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
  /**
   * If this is a ticket message from Zendesk, this is the id
   */
  ticketId: string | null;
  /**
   * If this is a ticket message from Zendesk, this is the url
   */
  ticketUrl: string | null;
  /**
   * Number of times this email has been viewed via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedViewsCount: number | null;
  /**
   * Number of times this email has been clicked via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedClicksCount: number | null;
  recipients: LCEmailFragmentSparse_recipients[];
  from: LCEmailFragmentSparse_from;
  /**
   * Was the email created outside of Nutshell
   */
  isInbound: boolean;
  /**
   * Was the email created in Nutshell
   */
  isOutbound: boolean;
  /**
   * Did the email fail to send
   */
  isFailed: boolean;
  /**
   * True if a Nutshell user can reply to this email
   */
  isReplyable: boolean;
  /**
   * Is this a Nutshell Marketing email
   */
  isNutshellMarketingEmail: boolean;
  /**
   * If this a Nutshell Marketing email, this is the edition
   */
  edition: LCEmailFragmentSparse_edition | null;
  /**
   * Was this email sent within the last week
   */
  sentWithinLastWeek: boolean;
  /**
   * Has this email accepted an AI reply suggestion
   */
  hasAcceptedSuggestion: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCEmailQueuedFragmentSparse
// ====================================================

export interface LCEmailQueuedFragmentSparse_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface LCEmailQueuedFragmentSparse_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEmailQueuedFragmentSparse_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: LCEmailQueuedFragmentSparse_to_avatarEntity | null;
}

export interface LCEmailQueuedFragmentSparse_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEmailQueuedFragmentSparse_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: LCEmailQueuedFragmentSparse_from_avatarEntity | null;
}

export interface LCEmailQueuedFragmentSparse {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * The excerpt of this queued email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  attachments: LCEmailQueuedFragmentSparse_attachments[];
  to: LCEmailQueuedFragmentSparse_to[];
  /**
   * The sender email address for this queued email.
   */
  from: LCEmailQueuedFragmentSparse_from;
  /**
   * True if this queued email is postponed and the user can retry it.
   */
  canRetry: boolean;
  /**
   * True if this is an email that looks failed to the user
   */
  isFailed: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCEmailInteractionFragmentSparse
// ====================================================

export interface LCEmailInteractionFragmentSparse_emailDelivery_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEmailInteractionFragmentSparse_emailDelivery_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface LCEmailInteractionFragmentSparse_emailDelivery_email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
}

export interface LCEmailInteractionFragmentSparse_emailDelivery {
  __typename: "EmailDelivery";
  primaryContact: LCEmailInteractionFragmentSparse_emailDelivery_primaryContact | null;
  edition: LCEmailInteractionFragmentSparse_emailDelivery_edition | null;
  email: LCEmailInteractionFragmentSparse_emailDelivery_email | null;
}

export interface LCEmailInteractionFragmentSparse {
  __typename: "EmailInteraction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: EmailInteractionType;
  link: string | null;
  emailDelivery: LCEmailInteractionFragmentSparse_emailDelivery | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCChatFragmentSparse
// ====================================================

export interface LCChatFragmentSparse_chatItems {
  __typename: "ChatItem";
  /**
   * Time this message was sent
   */
  timestamp: any;
  /**
   * The attrbute chatItemd by the entry
   */
  body: string;
  /**
   * Person writing this particular message
   */
  chatter: string;
  /**
   * Type of chat message
   */
  type: string;
}

export interface LCChatFragmentSparse_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface LCChatFragmentSparse_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface LCChatFragmentSparse_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCChatFragmentSparse {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * Not really sure tbh
   */
  chatItems: LCChatFragmentSparse_chatItems[];
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: LCChatFragmentSparse_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: LCChatFragmentSparse_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: LCChatFragmentSparse_participants[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCActivityFragmentSparse
// ====================================================

export interface LCActivityFragmentSparse_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface LCActivityFragmentSparse_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface LCActivityFragmentSparse_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCActivityFragmentSparse_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface LCActivityFragmentSparse_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface LCActivityFragmentSparse_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: LCActivityFragmentSparse_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: LCActivityFragmentSparse_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface LCActivityFragmentSparse_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface LCActivityFragmentSparse {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: LCActivityFragmentSparse_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: LCActivityFragmentSparse_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: LCActivityFragmentSparse_participants[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: LCActivityFragmentSparse_externalMeeting | null;
  /**
   * The summary of the activity.
   */
  transcriptionSummary: LCActivityFragmentSparse_transcriptionSummary | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCReactionFragment
// ====================================================

export interface LCReactionFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCReactionFragment {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: LCReactionFragment_creatorUser;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCCommentFragment
// ====================================================

export interface LCCommentFragment_changeLogEntry {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LCCommentFragment_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCCommentFragment_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: LCCommentFragment_reactions_creatorUser;
}

export interface LCCommentFragment_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCCommentFragment {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Change log associated with the comment
   */
  changeLogEntry: LCCommentFragment_changeLogEntry | null;
  /**
   * User reactions left for the comment change log entry
   */
  reactions: LCCommentFragment_reactions[];
  /**
   * The user who created the comment.
   */
  creatorUser: LCCommentFragment_creatorUser;
  /**
   * The created time for the comment.
   */
  createdTime: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCEventFragmentSparse
// ====================================================

export interface LCEventFragmentSparse_actor_Form {
  __typename: "Form" | "MaUrl";
}

export interface LCEventFragmentSparse_actor_User {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_actor_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_actor_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_actor_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export type LCEventFragmentSparse_actor = LCEventFragmentSparse_actor_Form | LCEventFragmentSparse_actor_User | LCEventFragmentSparse_actor_Origin | LCEventFragmentSparse_actor_Contact | LCEventFragmentSparse_actor_Account;

export interface LCEventFragmentSparse_payload_TimelineEventPayloadUnknownType {
  __typename: "TimelineEventPayloadUnknownType" | "Contract" | "AccountContactFormerStatusChange";
}

export interface LCEventFragmentSparse_payload_Activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface LCEventFragmentSparse_payload_Activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_payload_Activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface LCEventFragmentSparse_payload_Activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface LCEventFragmentSparse_payload_Activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: LCEventFragmentSparse_payload_Activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: LCEventFragmentSparse_payload_Activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface LCEventFragmentSparse_payload_Activity_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface LCEventFragmentSparse_payload_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The boolean that represents whether an activity has been recorded or not.
   */
  isMediaLogged: boolean;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: LCEventFragmentSparse_payload_Activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: LCEventFragmentSparse_payload_Activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: LCEventFragmentSparse_payload_Activity_participants[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: LCEventFragmentSparse_payload_Activity_externalMeeting | null;
  /**
   * The summary of the activity.
   */
  transcriptionSummary: LCEventFragmentSparse_payload_Activity_transcriptionSummary | null;
}

export interface LCEventFragmentSparse_payload_AccountRelationshipChange_entityAdded {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_AccountRelationshipChange {
  __typename: "AccountRelationshipChange";
  /**
   * The child account in the relationship
   */
  entityAdded: LCEventFragmentSparse_payload_AccountRelationshipChange_entityAdded;
  /**
   * The action that was taken to create this relationship
   */
  action: AccountRelationshipChangeAction;
}

export interface LCEventFragmentSparse_payload_Note_entity_Thread {
  __typename: "Thread" | "NoteEntityUnknownType";
}

export interface LCEventFragmentSparse_payload_Note_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Note_entity_Activity_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Note_entity_Activity_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface LCEventFragmentSparse_payload_Note_entity_Activity_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_payload_Note_entity_Activity_externalMeeting_transcriptionSummary {
  __typename: "EntitySummary";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The status of this entity summary
   */
  status: EntitySummaryStatus;
  /**
   * The summary of this entity
   */
  summary: string | null;
  /**
   * The DateTime that represents when the entitySummary was created
   */
  createdTime: any;
}

export interface LCEventFragmentSparse_payload_Note_entity_Activity_externalMeeting_participants {
  __typename: "ZoomMeetingParticipant";
  name: string;
}

export interface LCEventFragmentSparse_payload_Note_entity_Activity_externalMeeting {
  __typename: "ExternalMeeting";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The topic/name of the meeting
   */
  topic: string | null;
  /**
   * The type of external service that the meeting belongs to
   */
  serviceType: ExternalServiceType;
  /**
   * The status of the recording
   */
  recordingStatus: RecordingStatus;
  /**
   * The summary of the transcript of this meeting
   */
  transcriptionSummary: LCEventFragmentSparse_payload_Note_entity_Activity_externalMeeting_transcriptionSummary | null;
  /**
   * The DateTime that represents when the external meeting started
   */
  startTime: any;
  /**
   * The participants of this meeting
   */
  participants: LCEventFragmentSparse_payload_Note_entity_Activity_externalMeeting_participants[];
  /**
   * The duration of this meeting in minutes
   */
  durationMinutes: number | null;
}

export interface LCEventFragmentSparse_payload_Note_entity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: LCEventFragmentSparse_payload_Note_entity_Activity_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: LCEventFragmentSparse_payload_Note_entity_Activity_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: LCEventFragmentSparse_payload_Note_entity_Activity_participants[];
  /**
   * External meeting for the activity if one exists.
   */
  externalMeeting: LCEventFragmentSparse_payload_Note_entity_Activity_externalMeeting | null;
}

export interface LCEventFragmentSparse_payload_Note_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Note_entity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface LCEventFragmentSparse_payload_Note_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: LCEventFragmentSparse_payload_Note_entity_Lead_value | null;
}

export type LCEventFragmentSparse_payload_Note_entity = LCEventFragmentSparse_payload_Note_entity_Thread | LCEventFragmentSparse_payload_Note_entity_Account | LCEventFragmentSparse_payload_Note_entity_Activity | LCEventFragmentSparse_payload_Note_entity_Contact | LCEventFragmentSparse_payload_Note_entity_Lead;

export interface LCEventFragmentSparse_payload_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
  /**
   * Whether note has been deleted
   */
  isDeleted: boolean;
  /**
   * The entity on which this note was written
   */
  entity: LCEventFragmentSparse_payload_Note_entity | null;
}

export interface LCEventFragmentSparse_payload_Email_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface LCEventFragmentSparse_payload_Email_recipients_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_payload_Email_recipients {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: LCEventFragmentSparse_payload_Email_recipients_avatarEntity | null;
}

export interface LCEventFragmentSparse_payload_Email_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_payload_Email_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: LCEventFragmentSparse_payload_Email_from_avatarEntity | null;
}

export interface LCEventFragmentSparse_payload_Email_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * The excerpt of this email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  /**
   * A partially-formatted version of the body of this email,for use in the expanded view in a list
   */
  emailBodyHtml: string;
  /**
   * How this email was added to Nutshell
   */
  originatedVia: string | null;
  attachments: LCEventFragmentSparse_payload_Email_attachments[];
  /**
   * True if the email is shared with other Nutshell users
   */
  isShared: boolean;
  /**
   * True if the email can be shared with other Nutshell users
   */
  isShareable: boolean;
  /**
   * Was this email a reply sent by Nutshell automatically.
   */
  isAutomatedReply: boolean;
  /**
   * Was this email sent by Nutshell automatically.
   */
  isEmailAutomation: boolean;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
  /**
   * If this is a ticket message from Zendesk, this is the id
   */
  ticketId: string | null;
  /**
   * If this is a ticket message from Zendesk, this is the url
   */
  ticketUrl: string | null;
  /**
   * Number of times this email has been viewed via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedViewsCount: number | null;
  /**
   * Number of times this email has been clicked via our tracking pixel (optionally
   * set by a user). If `null`, that means the email was not being tracked.
   */
  trackedClicksCount: number | null;
  recipients: LCEventFragmentSparse_payload_Email_recipients[];
  from: LCEventFragmentSparse_payload_Email_from;
  /**
   * Was the email created outside of Nutshell
   */
  isInbound: boolean;
  /**
   * Was the email created in Nutshell
   */
  isOutbound: boolean;
  /**
   * Did the email fail to send
   */
  isFailed: boolean;
  /**
   * True if a Nutshell user can reply to this email
   */
  isReplyable: boolean;
  /**
   * Is this a Nutshell Marketing email
   */
  isNutshellMarketingEmail: boolean;
  /**
   * If this a Nutshell Marketing email, this is the edition
   */
  edition: LCEventFragmentSparse_payload_Email_edition | null;
  /**
   * Was this email sent within the last week
   */
  sentWithinLastWeek: boolean;
  /**
   * Has this email accepted an AI reply suggestion
   */
  hasAcceptedSuggestion: boolean;
}

export interface LCEventFragmentSparse_payload_EmailQueued_attachments {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * The href to download the file
   */
  href: string;
  /**
   * The readable type of the file
   */
  fileType: string;
}

export interface LCEventFragmentSparse_payload_EmailQueued_to_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_payload_EmailQueued_to {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: LCEventFragmentSparse_payload_EmailQueued_to_avatarEntity | null;
}

export interface LCEventFragmentSparse_payload_EmailQueued_from_avatarEntity {
  __typename: "Account" | "User" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_payload_EmailQueued_from {
  __typename: "NutEmailAddress";
  address: string;
  display: string;
  avatarEntity: LCEventFragmentSparse_payload_EmailQueued_from_avatarEntity | null;
}

export interface LCEventFragmentSparse_payload_EmailQueued {
  __typename: "EmailQueued";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The subject line for this queued email.
   */
  subject: string;
  /**
   * The excerpt of this queued email used in timeline entries before expanding
   */
  bodyExcerpt: string;
  attachments: LCEventFragmentSparse_payload_EmailQueued_attachments[];
  to: LCEventFragmentSparse_payload_EmailQueued_to[];
  /**
   * The sender email address for this queued email.
   */
  from: LCEventFragmentSparse_payload_EmailQueued_from;
  /**
   * True if this queued email is postponed and the user can retry it.
   */
  canRetry: boolean;
  /**
   * True if this is an email that looks failed to the user
   */
  isFailed: boolean;
}

export interface LCEventFragmentSparse_payload_Origin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_payload_Submission_booking_additionalAttendees_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
  display: string | null;
  formatted: string;
}

export interface LCEventFragmentSparse_payload_Submission_booking_additionalAttendees_emailAddresses_primary {
  __typename: "EmailAddressEav";
  isPrimary: boolean;
  value: LCEventFragmentSparse_payload_Submission_booking_additionalAttendees_emailAddresses_primary_value;
}

export interface LCEventFragmentSparse_payload_Submission_booking_additionalAttendees_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: LCEventFragmentSparse_payload_Submission_booking_additionalAttendees_emailAddresses_primary | null;
}

export interface LCEventFragmentSparse_payload_Submission_booking_additionalAttendees {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: LCEventFragmentSparse_payload_Submission_booking_additionalAttendees_emailAddresses;
}

export interface LCEventFragmentSparse_payload_Submission_booking {
  __typename: "Booking";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Additional attendees for this booking
   */
  additionalAttendees: (LCEventFragmentSparse_payload_Submission_booking_additionalAttendees | null)[];
}

export interface LCEventFragmentSparse_payload_Submission_primaryEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Submission_primaryEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Submission_primaryEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface LCEventFragmentSparse_payload_Submission_primaryEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: LCEventFragmentSparse_payload_Submission_primaryEntity_Lead_value | null;
}

export type LCEventFragmentSparse_payload_Submission_primaryEntity = LCEventFragmentSparse_payload_Submission_primaryEntity_Account | LCEventFragmentSparse_payload_Submission_primaryEntity_Contact | LCEventFragmentSparse_payload_Submission_primaryEntity_Lead;

export interface LCEventFragmentSparse_payload_Submission_formVersion_form {
  __typename: "Form";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The user entered name of this web form
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Submission_formVersion {
  __typename: "FormVersion";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The parent form of this form version
   */
  form: LCEventFragmentSparse_payload_Submission_formVersion_form;
}

export interface LCEventFragmentSparse_payload_Submission_fields_edges_node {
  __typename: "FormField";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The form label for this field
   */
  label: string;
  /**
   * Is this field required when the form is submitted
   */
  isRequired: boolean;
}

export interface LCEventFragmentSparse_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues {
  __typename: "SubfieldValue";
  name: string;
  value: string;
  label: string;
}

export interface LCEventFragmentSparse_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields {
  __typename: "FormFieldSubmissionValueSubfields";
  subfieldValues: LCEventFragmentSparse_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields_subfieldValues[];
}

export interface LCEventFragmentSparse_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple {
  __typename: "FormFieldSubmissionValueMultiple";
  values: string[];
}

export interface LCEventFragmentSparse_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle {
  __typename: "FormFieldSubmissionValueSingle";
  value: string;
}

export type LCEventFragmentSparse_payload_Submission_fields_edges_fieldValue = LCEventFragmentSparse_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSubfields | LCEventFragmentSparse_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueMultiple | LCEventFragmentSparse_payload_Submission_fields_edges_fieldValue_FormFieldSubmissionValueSingle;

export interface LCEventFragmentSparse_payload_Submission_fields_edges {
  __typename: "SubmissionFieldsEdge";
  node: LCEventFragmentSparse_payload_Submission_fields_edges_node;
  /**
   * Value for field on a given submission
   */
  fieldValue: LCEventFragmentSparse_payload_Submission_fields_edges_fieldValue | null;
}

export interface LCEventFragmentSparse_payload_Submission_fields {
  __typename: "SubmissionFieldsConnection";
  /**
   * A list of edges.
   */
  edges: LCEventFragmentSparse_payload_Submission_fields_edges[];
}

export interface LCEventFragmentSparse_payload_Submission {
  __typename: "Submission";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The timestamp of this submission
   */
  submissionTime: any;
  /**
   * The booking associated with this submission (if Scheduler)
   */
  booking: LCEventFragmentSparse_payload_Submission_booking | null;
  /**
   * The primary entity on the submission
   */
  primaryEntity: LCEventFragmentSparse_payload_Submission_primaryEntity | null;
  /**
   * The name of the submitted web form
   */
  formVersion: LCEventFragmentSparse_payload_Submission_formVersion;
  /**
   * Connection to all fields for the form version of this submission
   */
  fields: LCEventFragmentSparse_payload_Submission_fields;
}

export interface LCEventFragmentSparse_payload_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface LCEventFragmentSparse_payload_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: LCEventFragmentSparse_payload_Lead_value | null;
}

export interface LCEventFragmentSparse_payload_Chat_chatItems {
  __typename: "ChatItem";
  /**
   * Time this message was sent
   */
  timestamp: any;
  /**
   * The attrbute chatItemd by the entry
   */
  body: string;
  /**
   * Person writing this particular message
   */
  chatter: string;
  /**
   * Type of chat message
   */
  type: string;
}

export interface LCEventFragmentSparse_payload_Chat_activityType {
  __typename: "ActivityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity Type
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Chat_logNote {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the Note test
   */
  bodyHtml: string | null;
}

export interface LCEventFragmentSparse_payload_Chat_participants {
  __typename: "Account" | "User" | "Lead" | "Contact" | "ActivityExternalAttendee";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_payload_Chat {
  __typename: "Chat";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
  /**
   * Not really sure tbh
   */
  chatItems: LCEventFragmentSparse_payload_Chat_chatItems[];
  /**
   * The entity that represents the type of activity, i.e., was it a phone call, meeting, or something customized by the user
   */
  activityType: LCEventFragmentSparse_payload_Chat_activityType;
  /**
   * The Nutshell note (with @-mentioning capability) that presents the text that
   * was written by the Nutshell user who logged the Activity
   */
  logNote: LCEventFragmentSparse_payload_Chat_logNote | null;
  /**
   * Nutshell entities that are attendees/participants of the Nutshell activity
   * (i.e., people or relevant companies in attendance of the meeting/calendar event).
   */
  participants: LCEventFragmentSparse_payload_Chat_participants[];
}

export interface LCEventFragmentSparse_payload_Assignment_assignmentEntity_Thread {
  __typename: "Thread";
}

export interface LCEventFragmentSparse_payload_Assignment_assignmentEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Assignment_assignmentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Assignment_assignmentEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Assignment_assignmentEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Assignment_assignmentEntity_UnknownEntityType {
  __typename: "UnknownEntityType";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export type LCEventFragmentSparse_payload_Assignment_assignmentEntity = LCEventFragmentSparse_payload_Assignment_assignmentEntity_Thread | LCEventFragmentSparse_payload_Assignment_assignmentEntity_Account | LCEventFragmentSparse_payload_Assignment_assignmentEntity_Activity | LCEventFragmentSparse_payload_Assignment_assignmentEntity_Contact | LCEventFragmentSparse_payload_Assignment_assignmentEntity_Lead | LCEventFragmentSparse_payload_Assignment_assignmentEntity_UnknownEntityType;

export interface LCEventFragmentSparse_payload_Assignment_assigneeEntity {
  __typename: "User" | "Team";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_payload_Assignment {
  __typename: "Assignment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity that was assigned
   */
  assignmentEntity: LCEventFragmentSparse_payload_Assignment_assignmentEntity;
  /**
   * The entity to which the assignment was made
   */
  assigneeEntity: LCEventFragmentSparse_payload_Assignment_assigneeEntity;
}

export interface LCEventFragmentSparse_payload_EmailInteraction_emailDelivery_primaryContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_EmailInteraction_emailDelivery_edition {
  __typename: "Edition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_EmailInteraction_emailDelivery_email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
}

export interface LCEventFragmentSparse_payload_EmailInteraction_emailDelivery {
  __typename: "EmailDelivery";
  primaryContact: LCEventFragmentSparse_payload_EmailInteraction_emailDelivery_primaryContact | null;
  edition: LCEventFragmentSparse_payload_EmailInteraction_emailDelivery_edition | null;
  email: LCEventFragmentSparse_payload_EmailInteraction_emailDelivery_email | null;
}

export interface LCEventFragmentSparse_payload_EmailInteraction {
  __typename: "EmailInteraction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  type: EmailInteractionType;
  link: string | null;
  emailDelivery: LCEventFragmentSparse_payload_EmailInteraction_emailDelivery | null;
}

export interface LCEventFragmentSparse_payload_ConstantContactContactTrackingActivity_ctctContact_contacts {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_ConstantContactContactTrackingActivity_ctctContact {
  __typename: "ConstantContactContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  emailAddress: string;
  /**
   * The Nutshell contacts associated with this CTCT contact
   */
  contacts: LCEventFragmentSparse_payload_ConstantContactContactTrackingActivity_ctctContact_contacts[];
}

export interface LCEventFragmentSparse_payload_ConstantContactContactTrackingActivity {
  __typename: "ConstantContactContactTrackingActivity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  campaignName: string | null;
  trackingActivityType: ConstantContactContactTrackingActivityType;
  emailSubject: string | null;
  ctctContact: LCEventFragmentSparse_payload_ConstantContactContactTrackingActivity_ctctContact;
}

export interface LCEventFragmentSparse_payload_EntityAttributeValueFile_eavEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_EntityAttributeValueFile_eavEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_EntityAttributeValueFile_eavEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface LCEventFragmentSparse_payload_EntityAttributeValueFile_eavEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: LCEventFragmentSparse_payload_EntityAttributeValueFile_eavEntity_Lead_value | null;
}

export type LCEventFragmentSparse_payload_EntityAttributeValueFile_eavEntity = LCEventFragmentSparse_payload_EntityAttributeValueFile_eavEntity_Account | LCEventFragmentSparse_payload_EntityAttributeValueFile_eavEntity_Contact | LCEventFragmentSparse_payload_EntityAttributeValueFile_eavEntity_Lead;

export interface LCEventFragmentSparse_payload_EntityAttributeValueFile {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The entity that this file is associated with
   */
  eavEntity: LCEventFragmentSparse_payload_EntityAttributeValueFile_eavEntity;
}

export interface LCEventFragmentSparse_payload_Comment_parentEntity_Note_entity_Activity {
  __typename: "Activity" | "Thread" | "NoteEntityUnknownType";
}

export interface LCEventFragmentSparse_payload_Comment_parentEntity_Note_entity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Comment_parentEntity_Note_entity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Comment_parentEntity_Note_entity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
}

export type LCEventFragmentSparse_payload_Comment_parentEntity_Note_entity = LCEventFragmentSparse_payload_Comment_parentEntity_Note_entity_Activity | LCEventFragmentSparse_payload_Comment_parentEntity_Note_entity_Contact | LCEventFragmentSparse_payload_Comment_parentEntity_Note_entity_Account | LCEventFragmentSparse_payload_Comment_parentEntity_Note_entity_Lead;

export interface LCEventFragmentSparse_payload_Comment_parentEntity_Note {
  __typename: "Note";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The entity on which this note was written
   */
  entity: LCEventFragmentSparse_payload_Comment_parentEntity_Note_entity | null;
}

export interface LCEventFragmentSparse_payload_Comment_parentEntity_Activity {
  __typename: "Activity";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name/title of the Nutshell Activity; meant to be the human identifiable text in list views, calendar UIs, etc.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Comment_parentEntity_Email {
  __typename: "Email";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  subject: string;
  /**
   * True if this is a ticket message from Zendesk, which is solely determined by this email’s origin id
   */
  isTicketMessage: boolean;
}

export type LCEventFragmentSparse_payload_Comment_parentEntity = LCEventFragmentSparse_payload_Comment_parentEntity_Note | LCEventFragmentSparse_payload_Comment_parentEntity_Activity | LCEventFragmentSparse_payload_Comment_parentEntity_Email;

export interface LCEventFragmentSparse_payload_Comment {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  commentId: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Deleted time for comment, null if not deleted
   */
  deletedTime: any | null;
  /**
   * The entity on which this note was written
   */
  parentEntity: LCEventFragmentSparse_payload_Comment_parentEntity | null;
}

export interface LCEventFragmentSparse_payload_Session_url {
  __typename: "Url";
  /**
   * The full URL, i.e. https:             // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
  /**
   * The `www.nutshell.com` part of https: // www.nutshell.com/features?utm_source=Google
   */
  host: string | null;
}

export interface LCEventFragmentSparse_payload_Session_browser {
  __typename: "Browser";
  /**
   * The platform for the visit
   */
  platform: string;
  /**
   * The device type for the visit
   */
  deviceType: DeviceType;
}

export interface LCEventFragmentSparse_payload_Session_source {
  __typename: "McfxVisitSource";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The utm_medium value for this particular visit
   */
  medium: string;
  /**
   * The utm_source value for this particular visit
   */
  source: string;
  /**
   * Then mROI channel derived from this source information
   */
  channel: string;
}

export interface LCEventFragmentSparse_payload_Session_contact_nutshellContact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Session_contact {
  __typename: "McfxContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The contact that made this form submission.
   */
  nutshellContact: LCEventFragmentSparse_payload_Session_contact_nutshellContact | null;
}

export interface LCEventFragmentSparse_payload_Session_visits_edges_node_url {
  __typename: "Url";
  /**
   * The `/features` part of https: // www.nutshell.com/features?utm_source=Google
   */
  path: string | null;
  /**
   * The page title for the url, if we have one
   */
  pageTitle: string | null;
  /**
   * The full URL, i.e. https:      // www.nutshell.com/features?utm_source=Google
   */
  fullyQualifiedUrl: string;
}

export interface LCEventFragmentSparse_payload_Session_visits_edges_node {
  __typename: "Visit";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * How long the specific page visit lasted.
   */
  durationSeconds: number;
  /**
   * The page url for this user visit.
   */
  url: LCEventFragmentSparse_payload_Session_visits_edges_node_url;
}

export interface LCEventFragmentSparse_payload_Session_visits_edges {
  __typename: "SessionVisitsEdge";
  node: LCEventFragmentSparse_payload_Session_visits_edges_node;
}

export interface LCEventFragmentSparse_payload_Session_visits {
  __typename: "SessionVisitsConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
  /**
   * The total amount of time the visits lasted.
   */
  totalDuration: number | null;
  /**
   * A list of edges.
   */
  edges: LCEventFragmentSparse_payload_Session_visits_edges[];
}

export interface LCEventFragmentSparse_payload_Session {
  __typename: "Session";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Some basic info on the location of the user represented as a string.
   */
  locationSummary: string | null;
  /**
   * The session url.
   */
  url: LCEventFragmentSparse_payload_Session_url;
  /**
   * The platform the user was on during the session.
   */
  browser: LCEventFragmentSparse_payload_Session_browser | null;
  source: LCEventFragmentSparse_payload_Session_source;
  /**
   * The contact associated with this session.
   */
  contact: LCEventFragmentSparse_payload_Session_contact | null;
  visits: LCEventFragmentSparse_payload_Session_visits;
  /**
   * When this session started. This is the value we’ll display to the user
   */
  startTime: any;
}

export interface LCEventFragmentSparse_payload_Thread_externalChannel {
  __typename: "InboxChannel";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  status: ChannelStatus;
}

export interface LCEventFragmentSparse_payload_Thread_displayMessage_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_payload_Thread_displayMessage_creatorOrigin {
  __typename: "Origin";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_payload_Thread_displayMessage {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The content of the message
   */
  content: string;
  /**
   * Whether this message was sent from Nutshell to an external channel
   */
  isOutbound: boolean;
  /**
   * The user who created this thread
   */
  creatorUser: LCEventFragmentSparse_payload_Thread_displayMessage_creatorUser | null;
  /**
   * The origin of the user who created this thread
   */
  creatorOrigin: LCEventFragmentSparse_payload_Thread_displayMessage_creatorOrigin | null;
  /**
   * The images in the message
   */
  images: string[];
}

export interface LCEventFragmentSparse_payload_Thread_messages {
  __typename: "ThreadMessagesConnection";
  /**
   * Identifies the total count of items in the connection.
   */
  totalCount: number;
}

export interface LCEventFragmentSparse_payload_Thread_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_payload_Thread_bestEntity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_payload_Thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external channel this thread is related to
   */
  externalChannel: LCEventFragmentSparse_payload_Thread_externalChannel;
  /**
   * The time this thread was closed
   */
  closedTime: any | null;
  /**
   * The display (preview) message of this thread
   */
  displayMessage: LCEventFragmentSparse_payload_Thread_displayMessage | null;
  /**
   * The messages associated with this thread
   */
  messages: LCEventFragmentSparse_payload_Thread_messages;
  /**
   * the number of inbound messages on this thread
   */
  replyCount: number;
  /**
   * The user who created this thread
   */
  creatorUser: LCEventFragmentSparse_payload_Thread_creatorUser | null;
  /**
   * The best entity associated with this thread
   */
  bestEntity: LCEventFragmentSparse_payload_Thread_bestEntity | null;
  /**
   * The type of this thread
   */
  threadType: ThreadType;
}

export interface LCEventFragmentSparse_payload_Message_edition_campaign {
  __typename: "SmsCampaign";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Message_edition {
  __typename: "SmsEdition";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The name of the campaign
   */
  name: string;
  /**
   * The campaign this edition belongs to
   */
  campaign: LCEventFragmentSparse_payload_Message_edition_campaign;
}

export interface LCEventFragmentSparse_payload_Message_thread_bestEntity {
  __typename: "Account" | "Lead" | "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_payload_Message_thread {
  __typename: "Thread";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The best entity associated with this thread
   */
  bestEntity: LCEventFragmentSparse_payload_Message_thread_bestEntity | null;
}

export interface LCEventFragmentSparse_payload_Message {
  __typename: "Message";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The edition of the message
   */
  edition: LCEventFragmentSparse_payload_Message_edition | null;
  /**
   * The thread this message is part of
   */
  thread: LCEventFragmentSparse_payload_Message_thread;
}

export interface LCEventFragmentSparse_payload_Quote_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Quote_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: LCEventFragmentSparse_payload_Quote_lead_accounts_primaryEdge_node;
}

export interface LCEventFragmentSparse_payload_Quote_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LCEventFragmentSparse_payload_Quote_lead_accounts_primaryEdge | null;
}

export interface LCEventFragmentSparse_payload_Quote_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Quote_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: LCEventFragmentSparse_payload_Quote_lead_contacts_primaryEdge_node;
}

export interface LCEventFragmentSparse_payload_Quote_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LCEventFragmentSparse_payload_Quote_lead_contacts_primaryEdge | null;
}

export interface LCEventFragmentSparse_payload_Quote_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: LCEventFragmentSparse_payload_Quote_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: LCEventFragmentSparse_payload_Quote_lead_contacts;
}

export interface LCEventFragmentSparse_payload_Quote_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface LCEventFragmentSparse_payload_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_payload_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The lead the quote is associated with
   */
  lead: LCEventFragmentSparse_payload_Quote_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: LCEventFragmentSparse_payload_Quote_total;
  /**
   * The user that created the quote
   */
  creatorUser: LCEventFragmentSparse_payload_Quote_creatorUser | null;
}

export interface LCEventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: LCEventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge_node;
}

export interface LCEventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LCEventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_accounts_primaryEdge | null;
}

export interface LCEventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: LCEventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge_node;
}

export interface LCEventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LCEventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_contacts_primaryEdge | null;
}

export interface LCEventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: LCEventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: LCEventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead_contacts;
}

export interface LCEventFragmentSparse_payload_DocumentView_salesDocument_Quote_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface LCEventFragmentSparse_payload_DocumentView_salesDocument_Quote_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_payload_DocumentView_salesDocument_Quote {
  __typename: "Quote";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The lead the quote is associated with
   */
  lead: LCEventFragmentSparse_payload_DocumentView_salesDocument_Quote_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: LCEventFragmentSparse_payload_DocumentView_salesDocument_Quote_total;
  /**
   * The user that created the quote
   */
  creatorUser: LCEventFragmentSparse_payload_DocumentView_salesDocument_Quote_creatorUser | null;
}

export interface LCEventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: LCEventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge_node;
}

export interface LCEventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LCEventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_accounts_primaryEdge | null;
}

export interface LCEventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: LCEventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge_node;
}

export interface LCEventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LCEventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_contacts_primaryEdge | null;
}

export interface LCEventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: LCEventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: LCEventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead_contacts;
}

export interface LCEventFragmentSparse_payload_DocumentView_salesDocument_Invoice_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface LCEventFragmentSparse_payload_DocumentView_salesDocument_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_payload_DocumentView_salesDocument_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The lead the quote is associated with
   */
  lead: LCEventFragmentSparse_payload_DocumentView_salesDocument_Invoice_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: LCEventFragmentSparse_payload_DocumentView_salesDocument_Invoice_total;
  /**
   * The user that created the quote
   */
  creatorUser: LCEventFragmentSparse_payload_DocumentView_salesDocument_Invoice_creatorUser | null;
}

export type LCEventFragmentSparse_payload_DocumentView_salesDocument = LCEventFragmentSparse_payload_DocumentView_salesDocument_Quote | LCEventFragmentSparse_payload_DocumentView_salesDocument_Invoice;

export interface LCEventFragmentSparse_payload_DocumentView {
  __typename: "DocumentView";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The quote or invoice this view is attached to, when applicable
   */
  salesDocument: LCEventFragmentSparse_payload_DocumentView_salesDocument | null;
}

export interface LCEventFragmentSparse_payload_Invoice_lead_accounts_primaryEdge_node {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Invoice_lead_accounts_primaryEdge {
  __typename: "LeadAccountsEdge";
  node: LCEventFragmentSparse_payload_Invoice_lead_accounts_primaryEdge_node;
}

export interface LCEventFragmentSparse_payload_Invoice_lead_accounts {
  __typename: "LeadAccountsConnection";
  /**
   * The primary/main account/company on the lead. This usually maps to the _first_
   * account/company added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LCEventFragmentSparse_payload_Invoice_lead_accounts_primaryEdge | null;
}

export interface LCEventFragmentSparse_payload_Invoice_lead_contacts_primaryEdge_node {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_payload_Invoice_lead_contacts_primaryEdge {
  __typename: "LeadContactsEdge";
  node: LCEventFragmentSparse_payload_Invoice_lead_contacts_primaryEdge_node;
}

export interface LCEventFragmentSparse_payload_Invoice_lead_contacts {
  __typename: "LeadContactsConnection";
  /**
   * The primary/main contacts/person on the lead. This usually maps to the _first_
   * contact/person added to the lead, or the one marked as primary by the user.
   */
  primaryEdge: LCEventFragmentSparse_payload_Invoice_lead_contacts_primaryEdge | null;
}

export interface LCEventFragmentSparse_payload_Invoice_lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  /**
   * Accounts (Companies in the app UI) that the lead is related to
   */
  accounts: LCEventFragmentSparse_payload_Invoice_lead_accounts;
  /**
   * Contacts (People in the app UI) that the lead is related to
   */
  contacts: LCEventFragmentSparse_payload_Invoice_lead_contacts;
}

export interface LCEventFragmentSparse_payload_Invoice_total {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI, including cents
   */
  formattedWithCents: string;
}

export interface LCEventFragmentSparse_payload_Invoice_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_payload_Invoice {
  __typename: "Invoice";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The lead the quote is associated with
   */
  lead: LCEventFragmentSparse_payload_Invoice_lead;
  /**
   * The full quote number (ex: 1234-01)
   */
  displayNumber: string;
  /**
   * The total price of the quote after all modifiers
   */
  total: LCEventFragmentSparse_payload_Invoice_total;
  /**
   * The user that created the quote
   */
  creatorUser: LCEventFragmentSparse_payload_Invoice_creatorUser | null;
}

export interface LCEventFragmentSparse_payload_LeadClonePayload_original_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface LCEventFragmentSparse_payload_LeadClonePayload_original {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: LCEventFragmentSparse_payload_LeadClonePayload_original_value | null;
}

export interface LCEventFragmentSparse_payload_LeadClonePayload_clone_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface LCEventFragmentSparse_payload_LeadClonePayload_clone {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: LCEventFragmentSparse_payload_LeadClonePayload_clone_value | null;
}

export interface LCEventFragmentSparse_payload_LeadClonePayload {
  __typename: "LeadClonePayload";
  /**
   * The original lead
   */
  original: LCEventFragmentSparse_payload_LeadClonePayload_original;
  /**
   * The cloned lead
   */
  clone: LCEventFragmentSparse_payload_LeadClonePayload_clone;
}

export type LCEventFragmentSparse_payload = LCEventFragmentSparse_payload_TimelineEventPayloadUnknownType | LCEventFragmentSparse_payload_Activity | LCEventFragmentSparse_payload_AccountRelationshipChange | LCEventFragmentSparse_payload_Note | LCEventFragmentSparse_payload_Email | LCEventFragmentSparse_payload_EmailQueued | LCEventFragmentSparse_payload_Origin | LCEventFragmentSparse_payload_Submission | LCEventFragmentSparse_payload_Account | LCEventFragmentSparse_payload_Contact | LCEventFragmentSparse_payload_Lead | LCEventFragmentSparse_payload_Chat | LCEventFragmentSparse_payload_Assignment | LCEventFragmentSparse_payload_EmailInteraction | LCEventFragmentSparse_payload_ConstantContactContactTrackingActivity | LCEventFragmentSparse_payload_EntityAttributeValueFile | LCEventFragmentSparse_payload_Comment | LCEventFragmentSparse_payload_Session | LCEventFragmentSparse_payload_Thread | LCEventFragmentSparse_payload_Message | LCEventFragmentSparse_payload_Quote | LCEventFragmentSparse_payload_DocumentView | LCEventFragmentSparse_payload_Invoice | LCEventFragmentSparse_payload_LeadClonePayload;

export interface LCEventFragmentSparse_changes {
  __typename: "ChangeLogChange";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The attrbute changed by the entry
   */
  attribute: string;
  /**
   * The old value before the change
   */
  oldValue: string | null;
  /**
   * The new value after the change
   */
  newValue: string | null;
}

export interface LCEventFragmentSparse_files_eavEntity_Account {
  __typename: "Account";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_files_eavEntity_Contact {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
}

export interface LCEventFragmentSparse_files_eavEntity_Lead_value {
  __typename: "Money";
  /**
   * The user-readable formatted value of this monetary valuefor the clients to echo out in the UI
   */
  formatted: string;
}

export interface LCEventFragmentSparse_files_eavEntity_Lead {
  __typename: "Lead";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  number: number | null;
  /**
   * The descriptive name of the Nutshell Lead.
   */
  name: string;
  value: LCEventFragmentSparse_files_eavEntity_Lead_value | null;
}

export type LCEventFragmentSparse_files_eavEntity = LCEventFragmentSparse_files_eavEntity_Account | LCEventFragmentSparse_files_eavEntity_Contact | LCEventFragmentSparse_files_eavEntity_Lead;

export interface LCEventFragmentSparse_files {
  __typename: "EntityAttributeValueFile";
  /**
   * Unique id for this file
   */
  fileId: string;
  /**
   * Name of the file
   */
  name: string;
  /**
   * Size of the file, in humanized form
   */
  size: string;
  /**
   * The readable type of the file
   */
  fileType: string;
  /**
   * The entity that this file is associated with
   */
  eavEntity: LCEventFragmentSparse_files_eavEntity;
}

export interface LCEventFragmentSparse_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: LCEventFragmentSparse_reactions_creatorUser;
}

export interface LCEventFragmentSparse_comments_changeLogEntry {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
}

export interface LCEventFragmentSparse_comments_reactions_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_comments_reactions {
  __typename: "Reaction";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * Reaction type of the reaction
   */
  reactionType: ReactionType;
  /**
   * Time the reaction was created
   */
  createdTime: any;
  /**
   * User that created the reaction
   */
  creatorUser: LCEventFragmentSparse_comments_reactions_creatorUser;
}

export interface LCEventFragmentSparse_comments_creatorUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCEventFragmentSparse_comments {
  __typename: "Comment";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The marked-up-with-HTML text representation of the comment
   */
  bodyHtml: string | null;
  /**
   * Change log associated with the comment
   */
  changeLogEntry: LCEventFragmentSparse_comments_changeLogEntry | null;
  /**
   * User reactions left for the comment change log entry
   */
  reactions: LCEventFragmentSparse_comments_reactions[];
  /**
   * The user who created the comment.
   */
  creatorUser: LCEventFragmentSparse_comments_creatorUser;
  /**
   * The created time for the comment.
   */
  createdTime: any;
}

export interface LCEventFragmentSparse {
  __typename: "TimelineEvent";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The type of change i.e. created, modified, deleted, etc
   */
  changeType: ChangeType;
  /**
   * The entity that triggered the change_log entry
   */
  actor: LCEventFragmentSparse_actor;
  payload: LCEventFragmentSparse_payload;
  changeTime: any;
  changes: LCEventFragmentSparse_changes[];
  /**
   * A one-off property to handle the case where multiple files can be associated
   * with a single change log entry. This is the only situation where multiple
   * payloads exist on an entry, so rather than adding additional complexity to our
   * entire system, we’ll treat it as a separate property
   */
  files: LCEventFragmentSparse_files[];
  reactions: LCEventFragmentSparse_reactions[];
  comments: LCEventFragmentSparse_comments[];
  /**
   * When multiple of the same entry occurs in a row, we’ll roll-up the count. For
   * example, if someone views an email 3 times in a row before a different change,
   * this value will be 3.
   */
  count: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LCPinnedInfoFragment
// ====================================================

export interface LCPinnedInfoFragment_pinnedByUser {
  __typename: "User";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  name: string;
}

export interface LCPinnedInfoFragment {
  __typename: "PinnedInfo";
  pinnedTime: any | null;
  pinnedByUser: LCPinnedInfoFragment_pinnedByUser;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: BookingContactFragment
// ====================================================

export interface BookingContactFragment_phones_primary_value {
  __typename: "PhoneValue";
  /**
   * [E.164](https: // en.wikipedia.org/wiki/E.164) representation of the phone number.
   */
  E164: string | null;
  /**
   * The country code component of the phone number
   */
  countryCode: string | null;
  /**
   * The extension component of the phone number
   */
  extension: string | null;
  /**
   * The base number component of the phone number
   */
  number: string | null;
  /**
   * The localized and UI-ready formatted version of the phone number.
   */
  numberFormatted: string | null;
}

export interface BookingContactFragment_phones_primary {
  __typename: "Phone";
  value: BookingContactFragment_phones_primary_value;
}

export interface BookingContactFragment_phones {
  __typename: "PhonesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: BookingContactFragment_phones_primary | null;
}

export interface BookingContactFragment_emailAddresses_primary_value {
  __typename: "EmailAddressValue";
  address: string;
}

export interface BookingContactFragment_emailAddresses_primary {
  __typename: "EmailAddressEav";
  value: BookingContactFragment_emailAddresses_primary_value;
}

export interface BookingContactFragment_emailAddresses {
  __typename: "EmailAddressesEavConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: BookingContactFragment_emailAddresses_primary | null;
}

export interface BookingContactFragment_postalAddresses_primary_value {
  __typename: "PostalAddressValue";
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
}

export interface BookingContactFragment_postalAddresses_primary {
  __typename: "PostalAddress";
  value: BookingContactFragment_postalAddresses_primary_value;
}

export interface BookingContactFragment_postalAddresses {
  __typename: "PostalAddressesConnection";
  /**
   * The property value marked as the primary one.
   */
  primary: BookingContactFragment_postalAddresses_primary | null;
}

export interface BookingContactFragment_mcfxContacts {
  __typename: "McfxContact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The external ID of the contact.
   */
  externalId: string;
}

export interface BookingContactFragment {
  __typename: "Contact";
  /**
   * The API ID for this model in the format {id}-{type}.
   */
  id: string;
  /**
   * The human name of the Nutshell Contact.
   */
  name: string;
  /**
   * The paging collection of phone numbers for this peep.
   */
  phones: BookingContactFragment_phones;
  /**
   * The paging collection of email addresses.
   */
  emailAddresses: BookingContactFragment_emailAddresses;
  /**
   * The postal addresses of the peep
   */
  postalAddresses: BookingContactFragment_postalAddresses;
  /**
   * The MCFX contact associated with this contact
   */
  mcfxContacts: BookingContactFragment_mcfxContacts[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * The relationship action that changed a contact to or from former status
 */
export const AccountContactFormerStatusChangeAction = {
  MARKED_FORMER: "MARKED_FORMER",
  UNMARKED_FORMER: "UNMARKED_FORMER",
} as const;
export type AccountContactFormerStatusChangeAction = typeof AccountContactFormerStatusChangeAction[keyof typeof AccountContactFormerStatusChangeAction];

/**
 * something
 */
export const AccountRelationshipChangeAction = {
  CHILD_ADDED: "CHILD_ADDED",
  PARENT_ADDED: "PARENT_ADDED",
} as const;
export type AccountRelationshipChangeAction = typeof AccountRelationshipChangeAction[keyof typeof AccountRelationshipChangeAction];

/**
 * The available actions for the engagement bar
 */
export const ActionBarActionEnum = {
  BOOKING_ACTION: "BOOKING_ACTION",
  CALL_ACTION: "CALL_ACTION",
  CHAT_ACTION: "CHAT_ACTION",
  EMAIL_ACTION: "EMAIL_ACTION",
  QUOTE_ACTION: "QUOTE_ACTION",
  TEXT_ACTION: "TEXT_ACTION",
} as const;
export type ActionBarActionEnum = typeof ActionBarActionEnum[keyof typeof ActionBarActionEnum];

/**
 * The type of this action.
 */
export const ActionType = {
  ADD_AUDIENCES: "ADD_AUDIENCES",
  ADD_TAGS: "ADD_TAGS",
  ADD_TO_DRIP_SEQUENCE: "ADD_TO_DRIP_SEQUENCE",
  CREATE_LEAD: "CREATE_LEAD",
  REMOVE_AUDIENCES: "REMOVE_AUDIENCES",
  REMOVE_TAGS: "REMOVE_TAGS",
  SEND_EMAIL: "SEND_EMAIL",
  SEND_NOTIFICATION: "SEND_NOTIFICATION",
} as const;
export type ActionType = typeof ActionType[keyof typeof ActionType];

/**
 * The type of video conference that the activity belongs to
 */
export const ActivityConferenceType = {
  GOOGLE_MEET: "GOOGLE_MEET",
  MICROSOFT_TEAMS: "MICROSOFT_TEAMS",
  ZOOM: "ZOOM",
} as const;
export type ActivityConferenceType = typeof ActivityConferenceType[keyof typeof ActivityConferenceType];

/**
 * Participant response to a calendar invitation for an activity. relies on Assignment table status column.
 */
export const ActivityParticipantAttendanceStatus = {
  ABSENT: "ABSENT",
  ATTENDING: "ATTENDING",
  MAYBE: "MAYBE",
  PENDING: "PENDING",
} as const;
export type ActivityParticipantAttendanceStatus = typeof ActivityParticipantAttendanceStatus[keyof typeof ActivityParticipantAttendanceStatus];

/**
 * The potential activity statuses.
 */
export const ActivityStatus = {
  CANCELLED: "CANCELLED",
  LOGGED: "LOGGED",
  OVERDUE: "OVERDUE",
  SCHEDULED: "SCHEDULED",
} as const;
export type ActivityStatus = typeof ActivityStatus[keyof typeof ActivityStatus];

/**
 * The action to take by the user for the activity summary.
 */
export const ActivitySummaryAction = {
  AI_SETTINGS: "AI_SETTINGS",
  CONNECT_GOOGLE: "CONNECT_GOOGLE",
  CONNECT_ZOOM: "CONNECT_ZOOM",
  NONE: "NONE",
  SUMMARIZE: "SUMMARIZE",
  UPGRADE: "UPGRADE",
} as const;
export type ActivitySummaryAction = typeof ActivitySummaryAction[keyof typeof ActivitySummaryAction];

/**
 * The activities sync modes.
 */
export const ActivitySyncMode = {
  FORCE: "FORCE",
  NEVER: "NEVER",
  NORMAL: "NORMAL",
} as const;
export type ActivitySyncMode = typeof ActivitySyncMode[keyof typeof ActivitySyncMode];

/**
 * The status of an activity transcription.
 */
export const ActivityTranscriptionStatus = {
  COMPLETE: "COMPLETE",
  ERRORED: "ERRORED",
  IN_PROGRESS: "IN_PROGRESS",
  NOT_ENABLED: "NOT_ENABLED",
  NOT_STARTED: "NOT_STARTED",
} as const;
export type ActivityTranscriptionStatus = typeof ActivityTranscriptionStatus[keyof typeof ActivityTranscriptionStatus];

/**
 * The activity type default
 */
export const ActivityTypeDefault = {
  CLICK_TO_CALL: "CLICK_TO_CALL",
  CLICK_TO_CALL_VOICEMAILS: "CLICK_TO_CALL_VOICEMAILS",
  NEW_ACTIVITIES: "NEW_ACTIVITIES",
  SCHEDULER_MEETING: "SCHEDULER_MEETING",
  VIRTUAL_MEETING: "VIRTUAL_MEETING",
} as const;
export type ActivityTypeDefault = typeof ActivityTypeDefault[keyof typeof ActivityTypeDefault];

/**
 * The icon for an activity type
 */
export const ActivityTypeIcon = {
  ALARM: "ALARM",
  BELL: "BELL",
  BOOK: "BOOK",
  BRIEFCASE: "BRIEFCASE",
  CHAT: "CHAT",
  DEFAULT: "DEFAULT",
  EMAIL: "EMAIL",
  FLAG: "FLAG",
  GEAR: "GEAR",
  HANDSHAKE: "HANDSHAKE",
  HEART: "HEART",
  HOME: "HOME",
  LIGHTBULB: "LIGHTBULB",
  PENCIL: "PENCIL",
  PEOPLE: "PEOPLE",
  PHONE: "PHONE",
  STAR: "STAR",
  TROPHY: "TROPHY",
  VIDEO: "VIDEO",
  VOICEMAIL: "VOICEMAIL",
} as const;
export type ActivityTypeIcon = typeof ActivityTypeIcon[keyof typeof ActivityTypeIcon];

/**
 * The presence of a chat agent as determined by pusher presence
 */
export const AgentPresenceEnum = {
  OFFLINE: "OFFLINE",
  ONLINE: "ONLINE",
} as const;
export type AgentPresenceEnum = typeof AgentPresenceEnum[keyof typeof AgentPresenceEnum];

/**
 * The status of a chat agent
 */
export const AgentStatusEnum = {
  NOT_ACCEPTING_CHATS: "NOT_ACCEPTING_CHATS",
  ONLINE: "ONLINE",
} as const;
export type AgentStatusEnum = typeof AgentStatusEnum[keyof typeof AgentStatusEnum];

export const AiAssistantRole = {
  ASSISTANT: "ASSISTANT",
  USER: "USER",
} as const;
export type AiAssistantRole = typeof AiAssistantRole[keyof typeof AiAssistantRole];

export const AiFeatureCategory = {
  ASSIST: "ASSIST",
  OTHER: "OTHER",
  OUTCOME: "OUTCOME",
} as const;
export type AiFeatureCategory = typeof AiFeatureCategory[keyof typeof AiFeatureCategory];

export const AiFeaturePeriod = {
  ALL: "ALL",
  MONTH: "MONTH",
  WEEK: "WEEK",
  YEAR: "YEAR",
} as const;
export type AiFeaturePeriod = typeof AiFeaturePeriod[keyof typeof AiFeaturePeriod];

export const AiFeatureType = {
  ADMIN_DIGEST: "ADMIN_DIGEST",
  AIRCALL_NOTETAKER: "AIRCALL_NOTETAKER",
  AI_FOLLOW_UP_TASKS: "AI_FOLLOW_UP_TASKS",
  CALLRAIL_NOTETAKER: "CALLRAIL_NOTETAKER",
  CHATGPT_MCP: "CHATGPT_MCP",
  CLAUDE_MCP: "CLAUDE_MCP",
  CLICK_TO_CALL_NOTETAKER: "CLICK_TO_CALL_NOTETAKER",
  COMPANY_IQ: "COMPANY_IQ",
  COMPETITOR_SPY: "COMPETITOR_SPY",
  DIALPAD_NOTETAKER: "DIALPAD_NOTETAKER",
  EMAIL_CAMPAIGN_BUILDER: "EMAIL_CAMPAIGN_BUILDER",
  EMAIL_REPLY_STARTER: "EMAIL_REPLY_STARTER",
  EMAIL_SEQUENCE_WRITER: "EMAIL_SEQUENCE_WRITER",
  GOOGLE_MEET_NOTETAKER: "GOOGLE_MEET_NOTETAKER",
  KIXIE_NOTETAKER: "KIXIE_NOTETAKER",
  LEAD_RESEARCH: "LEAD_RESEARCH",
  LEAD_RESEARCHER: "LEAD_RESEARCHER",
  LEAD_SUMMARIZER: "LEAD_SUMMARIZER",
  MCP_SERVER: "MCP_SERVER",
  MICROSOFT_TEAMS_NOTETAKER: "MICROSOFT_TEAMS_NOTETAKER",
  NOTE_TRANSCRIBER: "NOTE_TRANSCRIBER",
  PEOPLE_IQ: "PEOPLE_IQ",
  PROSPECTOR_IQ: "PROSPECTOR_IQ",
  REPORT_GENERATOR: "REPORT_GENERATOR",
  RINGCENTRAL_NOTETAKER: "RINGCENTRAL_NOTETAKER",
  SALES_CHATBOT: "SALES_CHATBOT",
  SALES_OBJECTION_COACH: "SALES_OBJECTION_COACH",
  SALES_PIPELINE_DESIGNER: "SALES_PIPELINE_DESIGNER",
  SPEAK_TO_LOG: "SPEAK_TO_LOG",
  TIMELINE_SUMMARIZER: "TIMELINE_SUMMARIZER",
  USER_DIGEST: "USER_DIGEST",
  VISITOR_IQ: "VISITOR_IQ",
  ZOOM_NOTETAKER: "ZOOM_NOTETAKER",
} as const;
export type AiFeatureType = typeof AiFeatureType[keyof typeof AiFeatureType];

/**
 * The intent of AI search
 */
export const AiSearchIntentEnum = {
  ACTION: "ACTION",
  ENTITY_SEARCH: "ENTITY_SEARCH",
  INFO: "INFO",
  NAVIGATE: "NAVIGATE",
} as const;
export type AiSearchIntentEnum = typeof AiSearchIntentEnum[keyof typeof AiSearchIntentEnum];

/**
 * The type of AI search suggestion
 */
export const AiSearchSuggestionTypeEnum = {
  ACTION: "ACTION",
  NAVIGATION: "NAVIGATION",
} as const;
export type AiSearchSuggestionTypeEnum = typeof AiSearchSuggestionTypeEnum[keyof typeof AiSearchSuggestionTypeEnum];

/**
 * The target campaign type when accepting an AI-generated template.
 */
export const AiTemplateAcceptTargetType = {
  BROADCAST: "BROADCAST",
  DRIP_SEQUENCE: "DRIP_SEQUENCE",
  NEWSLETTER: "NEWSLETTER",
  TEMPLATE: "TEMPLATE",
} as const;
export type AiTemplateAcceptTargetType = typeof AiTemplateAcceptTargetType[keyof typeof AiTemplateAcceptTargetType];

/**
 * The version of the analytics snippet that is being used.
 */
export const AnalyticsSnippetVersion = {
  VERSION_1: "VERSION_1",
  VERSION_1_5: "VERSION_1_5",
  VERSION_2: "VERSION_2",
} as const;
export type AnalyticsSnippetVersion = typeof AnalyticsSnippetVersion[keyof typeof AnalyticsSnippetVersion];

/**
 * An option to match any value or all values.
 */
export const AnyAll = {
  ALL: "ALL",
  ANY: "ANY",
} as const;
export type AnyAll = typeof AnyAll[keyof typeof AnyAll];

/**
 * Valid params for sorting Audiences
 */
export const AudienceSortType = {
  CREATED_TIME_DESC: "CREATED_TIME_DESC",
  MODIFIED_TIME_ASC: "MODIFIED_TIME_ASC",
  MODIFIED_TIME_DESC: "MODIFIED_TIME_DESC",
  NAME_ASC: "NAME_ASC",
  NAME_DESC: "NAME_DESC",
} as const;
export type AudienceSortType = typeof AudienceSortType[keyof typeof AudienceSortType];

/**
 * The type for Nutshell email marketing audiences.
 */
export const AudienceType = {
  HIDDEN: "HIDDEN",
  HIDDEN_BUILDING: "HIDDEN_BUILDING",
  VISIBLE: "VISIBLE",
} as const;
export type AudienceType = typeof AudienceType[keyof typeof AudienceType];

/**
 * The types of audiences to include in query (all, only public, only private)
 */
export const AudienceTypeFilter = {
  ALL: "ALL",
  ONLY_PRIVATE: "ONLY_PRIVATE",
  ONLY_PUBLIC: "ONLY_PUBLIC",
} as const;
export type AudienceTypeFilter = typeof AudienceTypeFilter[keyof typeof AudienceTypeFilter];

export const AvailabilityDay = {
  FRIDAY: "FRIDAY",
  MONDAY: "MONDAY",
  SATURDAY: "SATURDAY",
  SUNDAY: "SUNDAY",
  THURSDAY: "THURSDAY",
  TUESDAY: "TUESDAY",
  WEDNESDAY: "WEDNESDAY",
} as const;
export type AvailabilityDay = typeof AvailabilityDay[keyof typeof AvailabilityDay];

/**
 * The score of an availability impression
 */
export const AvailabilityScore = {
  HIGH: "HIGH",
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  NOT_AVAILABLE: "NOT_AVAILABLE",
} as const;
export type AvailabilityScore = typeof AvailabilityScore[keyof typeof AvailabilityScore];

/**
 * Feature availability value type enum
 */
export const AvailabilityValueType = {
  Checkmark: "Checkmark",
  CustomString: "CustomString",
  Unlimited: "Unlimited",
  Xmark: "Xmark",
} as const;
export type AvailabilityValueType = typeof AvailabilityValueType[keyof typeof AvailabilityValueType];

/**
 * Nutshell addon plans
 */
export const BillingProductType = {
  CRM: "CRM",
  INBOX: "INBOX",
  MARKETING: "MARKETING",
  MARKETING_SUITE: "MARKETING_SUITE",
  NUTSHELL_ADVISOR: "NUTSHELL_ADVISOR",
  NUTSHELL_IQ: "NUTSHELL_IQ",
  QUOTES: "QUOTES",
  REVENUE_BOOSTER: "REVENUE_BOOSTER",
  SMS_CAMPAIGNS: "SMS_CAMPAIGNS",
} as const;
export type BillingProductType = typeof BillingProductType[keyof typeof BillingProductType];

/**
 * What order the bookings for a meeting should be returned in
 */
export const BookingSortOrder = {
  CREATED_TIME_ASC: "CREATED_TIME_ASC",
  CREATED_TIME_DESC: "CREATED_TIME_DESC",
  START_TIME_ASC: "START_TIME_ASC",
  START_TIME_DESC: "START_TIME_DESC",
} as const;
export type BookingSortOrder = typeof BookingSortOrder[keyof typeof BookingSortOrder];

/**
 * The status of the booking.
 */
export const BookingStatus = {
  ACTIVE: "ACTIVE",
  CANCELLED: "CANCELLED",
  PENDING: "PENDING",
  SCHEDULED: "SCHEDULED",
} as const;
export type BookingStatus = typeof BookingStatus[keyof typeof BookingStatus];

/**
 * Valid params for sorting Broadcasts
 */
export const BroadcastSortType = {
  MODIFIED_TIME_ASC: "MODIFIED_TIME_ASC",
  MODIFIED_TIME_DESC: "MODIFIED_TIME_DESC",
  NAME_ASC: "NAME_ASC",
  NAME_DESC: "NAME_DESC",
  STATUS: "STATUS",
} as const;
export type BroadcastSortType = typeof BroadcastSortType[keyof typeof BroadcastSortType];

/**
 * The status of the bulk edit.
 */
export const BulkEditStatus = {
  COMPLETED: "COMPLETED",
  ERRORED: "ERRORED",
  IN_PROGRESS: "IN_PROGRESS",
  QUEUED: "QUEUED",
} as const;
export type BulkEditStatus = typeof BulkEditStatus[keyof typeof BulkEditStatus];

/**
 * The key for a CTA banner.
 */
export const CTABannerKey = {
  GROUP_ONBOARDING: "GROUP_ONBOARDING",
  IMPORT: "IMPORT",
  LEARN_BASICS: "LEARN_BASICS",
  LIVE_DEMO: "LIVE_DEMO",
  MEET_WITH_TEAM_CHAD: "MEET_WITH_TEAM_CHAD",
  MEET_WITH_TEAM_JARED: "MEET_WITH_TEAM_JARED",
  SALES_TRAINING: "SALES_TRAINING",
} as const;
export type CTABannerKey = typeof CTABannerKey[keyof typeof CTABannerKey];

/**
 * The type for a CTA banner.
 */
export const CTABannerType = {
  DEMIO: "DEMIO",
  IMPORT: "IMPORT",
  SALES_BOOKING: "SALES_BOOKING",
} as const;
export type CTABannerType = typeof CTABannerType[keyof typeof CTABannerType];

/**
 * The rules for what activities should be added to the users synced calendar
 */
export const CalendarExportRule = {
  ALL: "ALL",
  IMPORTANT: "IMPORTANT",
  NONE: "NONE",
} as const;
export type CalendarExportRule = typeof CalendarExportRule[keyof typeof CalendarExportRule];

/**
 * Whether to send external calendar invitations when creating synced activities
 */
export const CalendarInviteSetting = {
  ALWAYS: "ALWAYS",
  ASK: "ASK",
  NEVER: "NEVER",
} as const;
export type CalendarInviteSetting = typeof CalendarInviteSetting[keyof typeof CalendarInviteSetting];

/**
 * Status of creating a CallRail integration
 */
export const CallRailcreateStatus = {
  NEEDS_SIGNING_KEY: "NEEDS_SIGNING_KEY",
  VALID_INTEGRATION_EXISTS: "VALID_INTEGRATION_EXISTS",
  WEBHOOK_INTEGRATION_CREATED: "WEBHOOK_INTEGRATION_CREATED",
} as const;
export type CallRailcreateStatus = typeof CallRailcreateStatus[keyof typeof CallRailcreateStatus];

/**
 * The status for Nutshell email marketing campaign. However, this is only used for drip sequences.
 */
export const CampaignStatus = {
  ACTIVE: "ACTIVE",
  ARCHIVED: "ARCHIVED",
  CANCELLED: "CANCELLED",
  DRAFT: "DRAFT",
  GENERATED_WITH_ISSUES: "GENERATED_WITH_ISSUES",
  GENERATING: "GENERATING",
  PAUSED: "PAUSED",
  PROBLEM: "PROBLEM",
  RETIRED: "RETIRED",
} as const;
export type CampaignStatus = typeof CampaignStatus[keyof typeof CampaignStatus];

/**
 * The type for Nutshell email marketing campaigns.
 */
export const CampaignType = {
  AI_EMAIL_TEMPLATE: "AI_EMAIL_TEMPLATE",
  AI_STARTER_TEMPLATE: "AI_STARTER_TEMPLATE",
  BROADCAST: "BROADCAST",
  DRIP_SEQUENCE: "DRIP_SEQUENCE",
  NEWSLETTER: "NEWSLETTER",
  SMART_SEQUENCE: "SMART_SEQUENCE",
  TEMPLATE: "TEMPLATE",
} as const;
export type CampaignType = typeof CampaignType[keyof typeof CampaignType];

/**
 * The type of change event that has happened.
 */
export const ChangeType = {
  ADDED: "ADDED",
  AUTOMATION_FIRED: "AUTOMATION_FIRED",
  BULK_DELETE_INITIATED: "BULK_DELETE_INITIATED",
  COMMENTED: "COMMENTED",
  DELETED: "DELETED",
  EDITED: "EDITED",
  ENRICHMENT_ACCEPTED: "ENRICHMENT_ACCEPTED",
  ENRICHMENT_DECLINED: "ENRICHMENT_DECLINED",
  EXPORT_INITIATED: "EXPORT_INITIATED",
  FILE_UPLOADED: "FILE_UPLOADED",
  FOLLOWUP: "FOLLOWUP",
  FORM_SUBMISSION_MAPPED: "FORM_SUBMISSION_MAPPED",
  HARD_DELETED: "HARD_DELETED",
  HIDDEN_EMAIL_SYNCED: "HIDDEN_EMAIL_SYNCED",
  INSTANTIATED: "INSTANTIATED",
  LEAD_CLONED: "LEAD_CLONED",
  MAILCHIMP: "MAILCHIMP",
  MAPPED: "MAPPED",
  MERGED: "MERGED",
  PAGE_VIEWED: "PAGE_VIEWED",
  PEOPLE_IQ_DECLINED: "PEOPLE_IQ_DECLINED",
  QUICKBOOKS: "QUICKBOOKS",
  STAGE_CHANGED: "STAGE_CHANGED",
  UNDELETED: "UNDELETED",
} as const;
export type ChangeType = typeof ChangeType[keyof typeof ChangeType];

/**
 * The status of the Inbox phone number.
 */
export const ChannelStatus = {
  INVALID: "INVALID",
  MISSING_CONTACT_INFO: "MISSING_CONTACT_INFO",
  NOT_SELECTED: "NOT_SELECTED",
  OPTED_OUT: "OPTED_OUT",
  UNDELIVERABLE: "UNDELIVERABLE",
  VALID: "VALID",
} as const;
export type ChannelStatus = typeof ChannelStatus[keyof typeof ChannelStatus];

export const ChannelType = {
  DIRECT_TO_WEBSITE: "DIRECT_TO_WEBSITE",
  EMAIL: "EMAIL",
  REFERRER: "REFERRER",
  SEARCH_ORGANIC: "SEARCH_ORGANIC",
  SEARCH_PAID: "SEARCH_PAID",
  SOCIAL_ORGANIC: "SOCIAL_ORGANIC",
  SOCIAL_PAID: "SOCIAL_PAID",
  TRADITIONAL: "TRADITIONAL",
  UNKNOWN: "UNKNOWN",
} as const;
export type ChannelType = typeof ChannelType[keyof typeof ChannelType];

/**
 * The different assignment strategies for new chats
 */
export const ChatAssignmentStrategyEnum = {
  NOBODY: "NOBODY",
  ROUND_ROBIN: "ROUND_ROBIN",
  SPECIFIC_USER: "SPECIFIC_USER",
} as const;
export type ChatAssignmentStrategyEnum = typeof ChatAssignmentStrategyEnum[keyof typeof ChatAssignmentStrategyEnum];

/**
 * The auto open view
 */
export const ChatAutoOpenEnum = {
  BOOKING_ACTION: "BOOKING_ACTION",
  CALL_ACTION: "CALL_ACTION",
  CHAT_ACTION: "CHAT_ACTION",
  EMAIL_ACTION: "EMAIL_ACTION",
  HOME: "HOME",
  QUOTE_ACTION: "QUOTE_ACTION",
  SMART_NUDGES: "SMART_NUDGES",
  TEXT_ACTION: "TEXT_ACTION",
} as const;
export type ChatAutoOpenEnum = typeof ChatAutoOpenEnum[keyof typeof ChatAutoOpenEnum];

/**
 * The layout of the homepage
 */
export const ChatHomepageLayoutEnum = {
  GRID: "GRID",
  STACKED: "STACKED",
} as const;
export type ChatHomepageLayoutEnum = typeof ChatHomepageLayoutEnum[keyof typeof ChatHomepageLayoutEnum];

/**
 * The possible icon types
 */
export const ChatIconEnum = {
  CHAT_BUBBLE: "CHAT_BUBBLE",
  CUSTOM: "CUSTOM",
  SMILEY_FACE: "SMILEY_FACE",
  WAVE: "WAVE",
} as const;
export type ChatIconEnum = typeof ChatIconEnum[keyof typeof ChatIconEnum];

/**
 * The possible intake form fields
 */
export const ChatSettingsIntakeFormFieldsEnum = {
  companyName: "companyName",
  email: "email",
  name: "name",
  phone: "phone",
} as const;
export type ChatSettingsIntakeFormFieldsEnum = typeof ChatSettingsIntakeFormFieldsEnum[keyof typeof ChatSettingsIntakeFormFieldsEnum];

/**
 * The possible intake form types
 */
export const ChatSettingsIntakeFormTypeEnum = {
  CONVERSATIONAL: "CONVERSATIONAL",
  REGULAR: "REGULAR",
} as const;
export type ChatSettingsIntakeFormTypeEnum = typeof ChatSettingsIntakeFormTypeEnum[keyof typeof ChatSettingsIntakeFormTypeEnum];

/**
 * The possible intake form types
 */
export const ChatSettingsOfflineFormTypeEnum = {
  CONVERSATIONAL: "CONVERSATIONAL",
  NONE: "NONE",
  REGULAR: "REGULAR",
} as const;
export type ChatSettingsOfflineFormTypeEnum = typeof ChatSettingsOfflineFormTypeEnum[keyof typeof ChatSettingsOfflineFormTypeEnum];

/**
 * The chat variant (chat button only or actions bar)
 */
export const ChatVariantEnum = {
  ACTIONS: "ACTIONS",
  CHAT: "CHAT",
} as const;
export type ChatVariantEnum = typeof ChatVariantEnum[keyof typeof ChatVariantEnum];

/**
 * The preferred length of chatbot responses
 */
export const ChatbotAnswerLengthEnum = {
  COMPLETE: "COMPLETE",
  CONCISE: "CONCISE",
  NORMAL: "NORMAL",
} as const;
export type ChatbotAnswerLengthEnum = typeof ChatbotAnswerLengthEnum[keyof typeof ChatbotAnswerLengthEnum];

/**
 * The icon type for the chatbot
 */
export const ChatbotIconEnum = {
  CHATBOT: "CHATBOT",
  NONE: "NONE",
  SPARKLE: "SPARKLE",
} as const;
export type ChatbotIconEnum = typeof ChatbotIconEnum[keyof typeof ChatbotIconEnum];

/**
 * When the chatbot should respond to messages
 */
export const ChatbotResponseTimingEnum = {
  ALWAYS: "ALWAYS",
  NEVER: "NEVER",
  OFFLINE: "OFFLINE",
} as const;
export type ChatbotResponseTimingEnum = typeof ChatbotResponseTimingEnum[keyof typeof ChatbotResponseTimingEnum];

/**
 * The tone of the chatbot
 */
export const ChatbotToneEnum = {
  FRIENDLY: "FRIENDLY",
  NEUTRAL: "NEUTRAL",
  PROFESSIONAL: "PROFESSIONAL",
} as const;
export type ChatbotToneEnum = typeof ChatbotToneEnum[keyof typeof ChatbotToneEnum];

/**
 * The type of entity to tag when a lead is closed.
 */
export const ClosedLeadTagAutomationEntityType = {
  ACCOUNT: "ACCOUNT",
  CONTACT: "CONTACT",
} as const;
export type ClosedLeadTagAutomationEntityType = typeof ClosedLeadTagAutomationEntityType[keyof typeof ClosedLeadTagAutomationEntityType];

/**
 * The number of columns in the email template
 */
export const ColumnType = {
  DOUBLE_COLUMN: "DOUBLE_COLUMN",
  SINGLE_COLUMN: "SINGLE_COLUMN",
} as const;
export type ColumnType = typeof ColumnType[keyof typeof ColumnType];

/**
 * The available comparators for field filters.
 */
export const Comparator = {
  EQUAL: "EQUAL",
  GREATER: "GREATER",
  LESS: "LESS",
} as const;
export type Comparator = typeof Comparator[keyof typeof Comparator];

export const ComparisonEditionType = {
  ALTERNATE: "ALTERNATE",
  MAIN: "MAIN",
} as const;
export type ComparisonEditionType = typeof ComparisonEditionType[keyof typeof ComparisonEditionType];

/**
 * Valid metrics for choosing a comparison winner
 */
export const ComparisonMetricType = {
  CLICK_RATE: "CLICK_RATE",
  OPEN_RATE: "OPEN_RATE",
  SPECIFIC_LINK_CLICK_RATE: "SPECIFIC_LINK_CLICK_RATE",
} as const;
export type ComparisonMetricType = typeof ComparisonMetricType[keyof typeof ComparisonMetricType];

/**
 * The different statuses associated with the condition
 */
export const ConditionStatus = {
  FULFILLED: "FULFILLED",
  MISSING_CUSTOM_FIELD_ERROR: "MISSING_CUSTOM_FIELD_ERROR",
  UNFULFILLED: "UNFULFILLED",
  UNKNOWN_ERROR: "UNKNOWN_ERROR",
} as const;
export type ConditionStatus = typeof ConditionStatus[keyof typeof ConditionStatus];

/**
 * The type of this condition.
 */
export const ConditionType = {
  ACTIVITY_OF_TYPE_LOGGED: "ACTIVITY_OF_TYPE_LOGGED",
  ADD_TO_AUDIENCE: "ADD_TO_AUDIENCE",
  ENTITY_FILTER: "ENTITY_FILTER",
  FORM_SUBMISSION: "FORM_SUBMISSION",
  PAGE_VIEWED: "PAGE_VIEWED",
  SOURCE_ENTITY: "SOURCE_ENTITY",
  TYPE_ADD_TAG: "TYPE_ADD_TAG",
  TYPE_LINK_CLICKED: "TYPE_LINK_CLICKED",
} as const;
export type ConditionType = typeof ConditionType[keyof typeof ConditionType];

/**
 * The next steps for user to connect their calendar, email, and meetings
 */
export const ConnectionNextStep = {
  GOOGLE_CALENDAR: "GOOGLE_CALENDAR",
  GOOGLE_EMAIL: "GOOGLE_EMAIL",
  GOOGLE_EMAIL_ENABLE_SYNC: "GOOGLE_EMAIL_ENABLE_SYNC",
  GOOGLE_MEETINGS: "GOOGLE_MEETINGS",
  MICROSOFT_CALENDAR: "MICROSOFT_CALENDAR",
  MICROSOFT_EMAIL: "MICROSOFT_EMAIL",
  MICROSOFT_EMAIL_ENABLE_SYNC: "MICROSOFT_EMAIL_ENABLE_SYNC",
  MICROSOFT_MEETINGS: "MICROSOFT_MEETINGS",
  ZOOM_MEETINGS: "ZOOM_MEETINGS",
} as const;
export type ConnectionNextStep = typeof ConnectionNextStep[keyof typeof ConnectionNextStep];

/**
 * The subscription status of this contact
 */
export const ConstantContactContactStatus = {
  ACTIVE: "ACTIVE",
  UNSUBSCRIBED: "UNSUBSCRIBED",
} as const;
export type ConstantContactContactStatus = typeof ConstantContactContactStatus[keyof typeof ConstantContactContactStatus];

/**
 * Activity types captured by Constant Contact (send, open, click, bounce, etc.)
 */
export const ConstantContactContactTrackingActivityType = {
  BOUNCES: "BOUNCES",
  CLICKS: "CLICKS",
  FORWARDS: "FORWARDS",
  OPENS: "OPENS",
  OPTOUTS: "OPTOUTS",
  SENDS: "SENDS",
} as const;
export type ConstantContactContactTrackingActivityType = typeof ConstantContactContactTrackingActivityType[keyof typeof ConstantContactContactTrackingActivityType];

/**
 * Filter threads by contact association status
 */
export const ContactFilter = {
  ALL: "ALL",
  HAS_CONTACT: "HAS_CONTACT",
  NO_CONTACT: "NO_CONTACT",
} as const;
export type ContactFilter = typeof ContactFilter[keyof typeof ContactFilter];

/**
 * PeopleIQ filter for contact information
 */
export const ContactInformationType = {
  MUST_HAVE_EMAIL: "MUST_HAVE_EMAIL",
  MUST_HAVE_LINKEDIN: "MUST_HAVE_LINKEDIN",
  MUST_HAVE_PHONE: "MUST_HAVE_PHONE",
} as const;
export type ContactInformationType = typeof ContactInformationType[keyof typeof ContactInformationType];

export const ContractDisplayStatus = {
  ACCEPTED: "ACCEPTED",
  ARCHIVED: "ARCHIVED",
  DRAFT: "DRAFT",
  EXPIRED: "EXPIRED",
  READY: "READY",
  REVOKED: "REVOKED",
  SENT: "SENT",
} as const;
export type ContractDisplayStatus = typeof ContractDisplayStatus[keyof typeof ContractDisplayStatus];

/**
 * What order generated contracts should be returned in.
 */
export const ContractSortOrder = {
  LAST_UPDATE_ASC: "LAST_UPDATE_ASC",
  LAST_UPDATE_DESC: "LAST_UPDATE_DESC",
} as const;
export type ContractSortOrder = typeof ContractSortOrder[keyof typeof ContractSortOrder];

/**
 * What order contract templates should be returned in.
 */
export const ContractTemplateSortOrder = {
  LAST_USED_BY_USER: "LAST_USED_BY_USER",
  LAST_USED_GLOBAL: "LAST_USED_GLOBAL",
} as const;
export type ContractTemplateSortOrder = typeof ContractTemplateSortOrder[keyof typeof ContractTemplateSortOrder];

/**
 * The mode of creating leads for CSV imports
 */
export const CreateLeadMode = {
  ACCOUNT: "ACCOUNT",
  CONTACT: "CONTACT",
  NEVER: "NEVER",
} as const;
export type CreateLeadMode = typeof CreateLeadMode[keyof typeof CreateLeadMode];

/**
 * Crm option/tool for Import2
 */
export const CrmOptionType = {
  ACT: "ACT",
  ACTIVECAMPAIGN: "ACTIVECAMPAIGN",
  AFFINITY: "AFFINITY",
  AGILECRM: "AGILECRM",
  ATTIO: "ATTIO",
  CAPSULE: "CAPSULE",
  CLOSE: "CLOSE",
  CONSTANTCONTACT: "CONSTANTCONTACT",
  COPERNIQ: "COPERNIQ",
  COPPER: "COPPER",
  FIRMAO: "FIRMAO",
  FOWCRM: "FOWCRM",
  GOHIGHLEVEL: "GOHIGHLEVEL",
  HIGHRISE: "HIGHRISE",
  HUBSPOT: "HUBSPOT",
  INSIGHTLY: "INSIGHTLY",
  KEAP: "KEAP",
  LESSANNOYINGCRM: "LESSANNOYINGCRM",
  MAILCHIMP: "MAILCHIMP",
  MSDYNAMICS: "MSDYNAMICS",
  NIMBLE: "NIMBLE",
  NUTSHELL: "NUTSHELL",
  ONEPAGE: "ONEPAGE",
  PIPEDRIVE: "PIPEDRIVE",
  PIPELINE: "PIPELINE",
  REDTAIL: "REDTAIL",
  SALESFORCE: "SALESFORCE",
  STREAK: "STREAK",
  SUGAR: "SUGAR",
  SUITE: "SUITE",
  UNKNOWN: "UNKNOWN",
  WEALTHBOX: "WEALTHBOX",
  ZENDESKSELL: "ZENDESKSELL",
  ZOHO: "ZOHO",
} as const;
export type CrmOptionType = typeof CrmOptionType[keyof typeof CrmOptionType];

/**
 * The tier of the CRM plan (pro, enterprise, etc.)
 */
export const CrmPlanTier = {
  business: "business",
  classic: "classic",
  enterprise: "enterprise",
  foundation: "foundation",
  growth: "growth",
  pro: "pro",
  proplus: "proplus",
  starter: "starter",
} as const;
export type CrmPlanTier = typeof CrmPlanTier[keyof typeof CrmPlanTier];

export const CsmType = {
  DEVIN: "DEVIN",
  RACHEL: "RACHEL",
  ROB: "ROB",
} as const;
export type CsmType = typeof CsmType[keyof typeof CsmType];

/**
 * The billing cycle for plan
 */
export const CycleType = {
  ANNUALLY: "ANNUALLY",
  MONTHLY: "MONTHLY",
} as const;
export type CycleType = typeof CycleType[keyof typeof CycleType];

/**
 * The type of channel that can be used for a dashboard.
 */
export const DashboardableChannelType = {
  chat: "chat",
  chatbot: "chatbot",
  facebook: "facebook",
  instagram: "instagram",
  whatsapp: "whatsapp",
} as const;
export type DashboardableChannelType = typeof DashboardableChannelType[keyof typeof DashboardableChannelType];

/**
 * What direction a statistic has moved in a given timeframe.
 */
export const DeltaDirection = {
  CONSTANT: "CONSTANT",
  DECREASE: "DECREASE",
  INCREASE: "INCREASE",
} as const;
export type DeltaDirection = typeof DeltaDirection[keyof typeof DeltaDirection];

/**
 * The type of device used for the visit
 */
export const DeviceType = {
  DESKTOP: "DESKTOP",
  MOBILE: "MOBILE",
  TABLET: "TABLET",
  UNKNOWN: "UNKNOWN",
  WEARABLE: "WEARABLE",
} as const;
export type DeviceType = typeof DeviceType[keyof typeof DeviceType];

/**
 * The possible email digest frequencies
 */
export const DigestFrequencyEnum = {
  DAILY: "DAILY",
  WEEKLY: "WEEKLY",
} as const;
export type DigestFrequencyEnum = typeof DigestFrequencyEnum[keyof typeof DigestFrequencyEnum];

/**
 * The possible email digest types for a subscription
 */
export const DigestTypeEnum = {
  MORNING_DIGEST: "MORNING_DIGEST",
  TEAM_REPORT: "TEAM_REPORT",
} as const;
export type DigestTypeEnum = typeof DigestTypeEnum[keyof typeof DigestTypeEnum];

/**
 * The discount type of a Recurly coupon
 */
export const DiscountType = {
  DOLLARS: "DOLLARS",
  FREE_TRIAL: "FREE_TRIAL",
  PERCENT: "PERCENT",
} as const;
export type DiscountType = typeof DiscountType[keyof typeof DiscountType];

/**
 * The possible sync statuses
 */
export const DocumentEffectiveStatusEnum = {
  DISABLED: "DISABLED",
  FAILED: "FAILED",
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  UNKNOWN: "UNKNOWN",
} as const;
export type DocumentEffectiveStatusEnum = typeof DocumentEffectiveStatusEnum[keyof typeof DocumentEffectiveStatusEnum];

export const DocumentFieldDirection = {
  RECIPIENT: "RECIPIENT",
  SENDER: "SENDER",
  UNKNOWN: "UNKNOWN",
} as const;
export type DocumentFieldDirection = typeof DocumentFieldDirection[keyof typeof DocumentFieldDirection];

export const DocumentFieldType = {
  DATE: "DATE",
  SIGNATURE: "SIGNATURE",
  TEXT: "TEXT",
  UNKNOWN: "UNKNOWN",
} as const;
export type DocumentFieldType = typeof DocumentFieldType[keyof typeof DocumentFieldType];

/**
 * The possible reasons for exceeding the document limit
 */
export const DocumentLimitExceededReasonEnum = {
  PAGE_LIMIT: "PAGE_LIMIT",
  WORD_LIMIT: "WORD_LIMIT",
} as const;
export type DocumentLimitExceededReasonEnum = typeof DocumentLimitExceededReasonEnum[keyof typeof DocumentLimitExceededReasonEnum];

export const DocumentSignatureValueType = {
  DRAWN: "DRAWN",
  TYPED: "TYPED",
} as const;
export type DocumentSignatureValueType = typeof DocumentSignatureValueType[keyof typeof DocumentSignatureValueType];

/**
 * The possible document source types
 */
export const DocumentSourceTypeEnum = {
  PDF: "PDF",
  UNKNOWN: "UNKNOWN",
  WEB_PAGE: "WEB_PAGE",
} as const;
export type DocumentSourceTypeEnum = typeof DocumentSourceTypeEnum[keyof typeof DocumentSourceTypeEnum];

/**
 * Keys for different domain-based statuses
 */
export const DomainFeatureStatusKey = {
  bootSnippet: "bootSnippet",
  customClickTracking: "customClickTracking",
  emailDeliverability: "emailDeliverability",
  landingPages: "landingPages",
  schedulerAndForms: "schedulerAndForms",
} as const;
export type DomainFeatureStatusKey = typeof DomainFeatureStatusKey[keyof typeof DomainFeatureStatusKey];

/**
 * Why a drip or smart sequence progression stopped. Null while the progression is still active.
 */
export const DripProgressionStoppedReason = {
  AUDIENCE_REMOVED: "AUDIENCE_REMOVED",
  AUTOMATIC: "AUTOMATIC",
  BOUNCED: "BOUNCED",
  CAMPAIGN_CANCELLED: "CAMPAIGN_CANCELLED",
  CANT_PROGRESS: "CANT_PROGRESS",
  ENDED: "ENDED",
  GOAL_MET: "GOAL_MET",
  LEAD_CLOSED: "LEAD_CLOSED",
  LEAD_STAGESET_CHANGED: "LEAD_STAGESET_CHANGED",
  MANUAL_CANCEL: "MANUAL_CANCEL",
  PROBLEM_MATERIALIZING: "PROBLEM_MATERIALIZING",
  UNSUBSCRIBED: "UNSUBSCRIBED",
} as const;
export type DripProgressionStoppedReason = typeof DripProgressionStoppedReason[keyof typeof DripProgressionStoppedReason];

/**
 * The type of drip sequence goal. This is strictly used for UI purposes, and is inferred from the goal’s conditions.
 */
export const DripSequenceGoalType = {
  ADD_TAG: "ADD_TAG",
  ADD_TO_AUDIENCE: "ADD_TO_AUDIENCE",
  LEAD_CREATED: "LEAD_CREATED",
  LEAD_WON: "LEAD_WON",
  LINK_CLICKED: "LINK_CLICKED",
} as const;
export type DripSequenceGoalType = typeof DripSequenceGoalType[keyof typeof DripSequenceGoalType];

/**
 * Valid params for sorting Drip Sequences
 */
export const DripSequenceSortType = {
  MODIFIED_TIME_ASC: "MODIFIED_TIME_ASC",
  MODIFIED_TIME_DESC: "MODIFIED_TIME_DESC",
  NAME_ASC: "NAME_ASC",
  NAME_DESC: "NAME_DESC",
  STATUS: "STATUS",
} as const;
export type DripSequenceSortType = typeof DripSequenceSortType[keyof typeof DripSequenceSortType];

/**
 * The reference point for this Nutshell due date specification.
 */
export const DueDateUnit = {
  HH: "HH",
  MM: "MM",
  bzd: "bzd",
  bzh: "bzh",
  dd: "dd",
  mm: "mm",
  ww: "ww",
} as const;
export type DueDateUnit = typeof DueDateUnit[keyof typeof DueDateUnit];

/**
 * Valid params for sorting all editions
 */
export const EditionSortType = {
  MODIFIED_TIME_ASC: "MODIFIED_TIME_ASC",
  MODIFIED_TIME_DESC: "MODIFIED_TIME_DESC",
  SCHEDULED_TIME_ASC: "SCHEDULED_TIME_ASC",
  SCHEDULED_TIME_DESC: "SCHEDULED_TIME_DESC",
} as const;
export type EditionSortType = typeof EditionSortType[keyof typeof EditionSortType];

/**
 * The status for Nutshell email marketing editions.
 */
export const EditionStatus = {
  ARCHIVED: "ARCHIVED",
  CANCELLED: "CANCELLED",
  COMPARISON_SENDING: "COMPARISON_SENDING",
  COMPARISON_WAITING: "COMPARISON_WAITING",
  GENERATED_WITH_ISSUES: "GENERATED_WITH_ISSUES",
  GENERATING: "GENERATING",
  HALTED: "HALTED",
  IN_REVIEW: "IN_REVIEW",
  NEW: "NEW",
  PAUSED: "PAUSED",
  RETIRED: "RETIRED",
  RETIRING: "RETIRING",
  SCHEDULED: "SCHEDULED",
  SENDING: "SENDING",
  SENT: "SENT",
  TEMPLATE: "TEMPLATE",
  USER_TEMPLATE_PUBLISHED: "USER_TEMPLATE_PUBLISHED",
} as const;
export type EditionStatus = typeof EditionStatus[keyof typeof EditionStatus];

/**
 * Email automation fields for the email automation status table
 */
export const EmailAutomationField = {
  COMPANY_NAME: "COMPANY_NAME",
  EMAIL_ADDRESS: "EMAIL_ADDRESS",
  FIRST_NAME: "FIRST_NAME",
  LAST_NAME: "LAST_NAME",
} as const;
export type EmailAutomationField = typeof EmailAutomationField[keyof typeof EmailAutomationField];

/**
 * The different statuses associated with an email automation status
 */
export const EmailAutomationStatusStatus = {
  CANCELLED_AUTOMATICALLY: "CANCELLED_AUTOMATICALLY",
  CANCELLED_MANUALLY: "CANCELLED_MANUALLY",
  NEEDS_ATTENTION: "NEEDS_ATTENTION",
  NEW: "NEW",
  PREEXISTING_LEAD_EXEMPTED: "PREEXISTING_LEAD_EXEMPTED",
  PREEXISTING_SEQUENCE_EXEMPTED: "PREEXISTING_SEQUENCE_EXEMPTED",
  QUEUED_AUTOMATICALLY: "QUEUED_AUTOMATICALLY",
  QUEUED_MANUALLY: "QUEUED_MANUALLY",
  READY_TO_SEND: "READY_TO_SEND",
  SENT: "SENT",
} as const;
export type EmailAutomationStatusStatus = typeof EmailAutomationStatusStatus[keyof typeof EmailAutomationStatusStatus];

/**
 * The type for stage subscriptions.
 */
export const EmailAutomationType = {
  CONSTANT_CONTACT: "CONSTANT_CONTACT",
  MAILCHIMP: "MAILCHIMP",
  NUTSHELL_EMAIL_SEQUENCE_TEMPLATE: "NUTSHELL_EMAIL_SEQUENCE_TEMPLATE",
} as const;
export type EmailAutomationType = typeof EmailAutomationType[keyof typeof EmailAutomationType];

/**
 * The different statuses associated with email health
 */
export const EmailBannerStatus = {
  success: "success",
  warning: "warning",
} as const;
export type EmailBannerStatus = typeof EmailBannerStatus[keyof typeof EmailBannerStatus];

/**
 * Deliverability statuses for an email address
 */
export const EmailDeliverabilityStatusType = {
  BOUNCING: "BOUNCING",
  DELIVERABLE: "DELIVERABLE",
  GLOBALLY_UNSUBSCRIBED: "GLOBALLY_UNSUBSCRIBED",
} as const;
export type EmailDeliverabilityStatusType = typeof EmailDeliverabilityStatusType[keyof typeof EmailDeliverabilityStatusType];

/**
 * The different statuses associated with email health
 */
export const EmailHealthStatus = {
  error: "error",
  success: "success",
  warning: "warning",
} as const;
export type EmailHealthStatus = typeof EmailHealthStatus[keyof typeof EmailHealthStatus];

/**
 * The type for email interactions.
 */
export const EmailInteractionType = {
  CLICKED: "CLICKED",
  VIEWED: "VIEWED",
} as const;
export type EmailInteractionType = typeof EmailInteractionType[keyof typeof EmailInteractionType];

/**
 * A problem that prevents a queued email from being sent.
 */
export const EmailQueuedSendProblem = {
  AUTOMATION_INVALID: "AUTOMATION_INVALID",
  DELETED: "DELETED",
  DMARC_NOT_CONFIGURED: "DMARC_NOT_CONFIGURED",
  FROM_ADDRESS_NOT_VERIFIED: "FROM_ADDRESS_NOT_VERIFIED",
  HAS_PLACEHOLDER_TAGS: "HAS_PLACEHOLDER_TAGS",
  INSTANCE_INACTIVE: "INSTANCE_INACTIVE",
  NO_ENTITIES: "NO_ENTITIES",
  NO_FOLLOWUP_CAPABILITY: "NO_FOLLOWUP_CAPABILITY",
  POSTPONED: "POSTPONED",
  PREVIOUS_EMAIL_NOT_SENT: "PREVIOUS_EMAIL_NOT_SENT",
  SENDER_ADDRESS_DISABLED: "SENDER_ADDRESS_DISABLED",
  SENDER_USER_INACTIVE: "SENDER_USER_INACTIVE",
} as const;
export type EmailQueuedSendProblem = typeof EmailQueuedSendProblem[keyof typeof EmailQueuedSendProblem];

/**
 * The different statuses associated with a queued email
 */
export const EmailQueuedStatus = {
  DELIVERED: "DELIVERED",
  DELIVERING: "DELIVERING",
  FAILED: "FAILED",
  PAUSED: "PAUSED",
  POSTPONED: "POSTPONED",
  SCHEDULED: "SCHEDULED",
  WONT_SEND: "WONT_SEND",
} as const;
export type EmailQueuedStatus = typeof EmailQueuedStatus[keyof typeof EmailQueuedStatus];

/**
 * Response by the user for accepting or declining an enrichment payload
 */
export const EnrichmentResponse = {
  ACCEPTED: "ACCEPTED",
  DECLINED: "DECLINED",
} as const;
export type EnrichmentResponse = typeof EnrichmentResponse[keyof typeof EnrichmentResponse];

/**
 * The different statuses associated with enrollment form progress
 */
export const EnrollmentFormEnumStatus = {
  CONTACT_SUPPORT: "CONTACT_SUPPORT",
  IN_PROGRESS: "IN_PROGRESS",
  NOT_STARTED: "NOT_STARTED",
  SUBMISSION_ACCEPTED: "SUBMISSION_ACCEPTED",
  SUBMISSION_VALIDATING: "SUBMISSION_VALIDATING",
  UNDER_REVIEW: "UNDER_REVIEW",
} as const;
export type EnrollmentFormEnumStatus = typeof EnrollmentFormEnumStatus[keyof typeof EnrollmentFormEnumStatus];

/**
 * The different keys/names for each field in the enrollment form
 */
export const EnrollmentFormFieldKey = {
  AGE_GATED_CONTENT_INCLUDED: "AGE_GATED_CONTENT_INCLUDED",
  BUSINESS_NAME: "BUSINESS_NAME",
  BUSINESS_TYPE: "BUSINESS_TYPE",
  CITY: "CITY",
  COUNTRY: "COUNTRY",
  GOVERNMENT_REGISTRATION_NUMBER: "GOVERNMENT_REGISTRATION_NUMBER",
  GOVERNMENT_REGISTRATION_TYPE: "GOVERNMENT_REGISTRATION_TYPE",
  INDUSTRY: "INDUSTRY",
  LENDING_INFO_INCLUDED: "LENDING_INFO_INCLUDED",
  LINKS_INCLUDED: "LINKS_INCLUDED",
  OPT_IN_DESCRIPTION: "OPT_IN_DESCRIPTION",
  OWNERSHIP: "OWNERSHIP",
  PHONE_NUMBERS_INCLUDED: "PHONE_NUMBERS_INCLUDED",
  POSTAL_CODE: "POSTAL_CODE",
  PRIVACY_POLICY_URL: "PRIVACY_POLICY_URL",
  REGION: "REGION",
  REGION_OF_OPERATION: "REGION_OF_OPERATION",
  REP_EMAIL: "REP_EMAIL",
  REP_FIRST_NAME: "REP_FIRST_NAME",
  REP_LAST_NAME: "REP_LAST_NAME",
  REP_PHONE_NUMBER: "REP_PHONE_NUMBER",
  REP_POSITION: "REP_POSITION",
  REP_TITLE: "REP_TITLE",
  SAMPLE_MESSAGE_1: "SAMPLE_MESSAGE_1",
  SAMPLE_MESSAGE_2: "SAMPLE_MESSAGE_2",
  SMS_PLANS_DESCRIPTION: "SMS_PLANS_DESCRIPTION",
  SOCIAL_URL: "SOCIAL_URL",
  STOCK_EXCHANGE: "STOCK_EXCHANGE",
  STOCK_TICKER_SYMBOL: "STOCK_TICKER_SYMBOL",
  STREET_ADDRESS: "STREET_ADDRESS",
  STREET_ADDRESS_2: "STREET_ADDRESS_2",
  TERMS_AND_CONDITIONS_URL: "TERMS_AND_CONDITIONS_URL",
  WEBSITE_URL: "WEBSITE_URL",
} as const;
export type EnrollmentFormFieldKey = typeof EnrollmentFormFieldKey[keyof typeof EnrollmentFormFieldKey];

/**
 * The type of this field.
 */
export const EntityCustomFieldType = {
  ADDRESS: "ADDRESS",
  CURRENCY: "CURRENCY",
  DATE: "DATE",
  EMAIL: "EMAIL",
  ENUM: "ENUM",
  LOCATION: "LOCATION",
  NUMBER: "NUMBER",
  PHONE: "PHONE",
  STRING: "STRING",
  TEXT: "TEXT",
  URL: "URL",
} as const;
export type EntityCustomFieldType = typeof EntityCustomFieldType[keyof typeof EntityCustomFieldType];

/**
 * The type of this condition.
 */
export const EntityFieldType = {
  ADDRESS: "ADDRESS",
  ASYNC: "ASYNC",
  BOOLEAN: "BOOLEAN",
  CURRENCY: "CURRENCY",
  DATE: "DATE",
  DATE_TIME: "DATE_TIME",
  EMAIL: "EMAIL",
  EMAILS: "EMAILS",
  ENUM: "ENUM",
  HIERARCHY: "HIERARCHY",
  INTEGER: "INTEGER",
  LOCATION: "LOCATION",
  LONGTEXT: "LONGTEXT",
  PHONE: "PHONE",
  PHONES: "PHONES",
  RATING: "RATING",
  RELATIONSHIP: "RELATIONSHIP",
  STRING: "STRING",
  STRINGS: "STRINGS",
  TEXT: "TEXT",
  URL: "URL",
} as const;
export type EntityFieldType = typeof EntityFieldType[keyof typeof EntityFieldType];

/**
 * The rating of an entity summary
 */
export const EntitySummaryRating = {
  NEGATIVE: "NEGATIVE",
  POSITIVE: "POSITIVE",
} as const;
export type EntitySummaryRating = typeof EntitySummaryRating[keyof typeof EntitySummaryRating];

/**
 * The different statuses associated with entity summary
 */
export const EntitySummaryStatus = {
  COMPLETE: "COMPLETE",
  ERRORED: "ERRORED",
  LOADING: "LOADING",
} as const;
export type EntitySummaryStatus = typeof EntitySummaryStatus[keyof typeof EntitySummaryStatus];

export const EntityType = {
  ACCOUNT: "ACCOUNT",
  CONTACT: "CONTACT",
  LEAD: "LEAD",
} as const;
export type EntityType = typeof EntityType[keyof typeof EntityType];

export const EnvelopeDisplayStatus = {
  ACCEPTED: "ACCEPTED",
  ARCHIVED: "ARCHIVED",
  DRAFT: "DRAFT",
  EXPIRED: "EXPIRED",
  READY: "READY",
  REVOKED: "REVOKED",
  SENT: "SENT",
} as const;
export type EnvelopeDisplayStatus = typeof EnvelopeDisplayStatus[keyof typeof EnvelopeDisplayStatus];

export const EnvelopeDocumentType = {
  CONTRACT: "CONTRACT",
  INVOICE: "INVOICE",
  QUOTE: "QUOTE",
} as const;
export type EnvelopeDocumentType = typeof EnvelopeDocumentType[keyof typeof EnvelopeDocumentType];

/**
 * Different reasons an SMS or WhatsApp message might fail to send
 */
export const ErrorReason = {
  HANDSET_UNAVAILABLE: "HANDSET_UNAVAILABLE",
  LANDLINE_OR_UNREACHABLE: "LANDLINE_OR_UNREACHABLE",
  SENDER_NOT_CONFIGURED: "SENDER_NOT_CONFIGURED",
  UNKNOWN_ERROR: "UNKNOWN_ERROR",
  UNKNOWN_NUMBER: "UNKNOWN_NUMBER",
  WHATSAPP_24_HOUR_WINDOW_EXPIRED: "WHATSAPP_24_HOUR_WINDOW_EXPIRED",
  WHATSAPP_MEDIA_UPLOAD_ERROR: "WHATSAPP_MEDIA_UPLOAD_ERROR",
  WHATSAPP_PAYMENT_ERROR: "WHATSAPP_PAYMENT_ERROR",
  WHATSAPP_PHONE_REGISTRATION_ERROR: "WHATSAPP_PHONE_REGISTRATION_ERROR",
  WHATSAPP_RECIPIENT_OPTED_OUT: "WHATSAPP_RECIPIENT_OPTED_OUT",
} as const;
export type ErrorReason = typeof ErrorReason[keyof typeof ErrorReason];

/**
 * Different external resource types
 */
export const ExternalResourceType = {
  GMAIL_MESSAGE: "GMAIL_MESSAGE",
  OFFICE365_MESSAGE: "OFFICE365_MESSAGE",
  QUICKBOOKS_CUSTOMER: "QUICKBOOKS_CUSTOMER",
  QUICKBOOKS_INVOICE: "QUICKBOOKS_INVOICE",
  QUICKBOOKS_ITEM: "QUICKBOOKS_ITEM",
} as const;
export type ExternalResourceType = typeof ExternalResourceType[keyof typeof ExternalResourceType];

/**
 * Different external services
 */
export const ExternalService = {
  DEMO: "DEMO",
  EXCHANGE: "EXCHANGE",
  GOOGLE: "GOOGLE",
  GOOGLE_APPS: "GOOGLE_APPS",
  OFFICE365: "OFFICE365",
  QUICKBOOKS: "QUICKBOOKS",
} as const;
export type ExternalService = typeof ExternalService[keyof typeof ExternalService];

/**
 * The type of external service that the external meeting belongs to
 */
export const ExternalServiceType = {
  AIRCALL: "AIRCALL",
  CALLRAIL: "CALLRAIL",
  CALLTRACKERFX: "CALLTRACKERFX",
  CLICKTOCALL: "CLICKTOCALL",
  DIALPAD: "DIALPAD",
  GOOGLE_MEET: "GOOGLE_MEET",
  KIXIE: "KIXIE",
  MICROSOFT_TEAMS: "MICROSOFT_TEAMS",
  RINGCENTRAL: "RINGCENTRAL",
  ZOOM: "ZOOM",
} as const;
export type ExternalServiceType = typeof ExternalServiceType[keyof typeof ExternalServiceType];

/**
 * The type of external meeting
 */
export const ExternalType = {
  INSTANT: "INSTANT",
  MISSED_CALL_INBOUND: "MISSED_CALL_INBOUND",
  MISSED_CALL_OUTBOUND: "MISSED_CALL_OUTBOUND",
  PAC: "PAC",
  PERSONAL: "PERSONAL",
  PHONE_CALL_INBOUND: "PHONE_CALL_INBOUND",
  PHONE_CALL_OUTBOUND: "PHONE_CALL_OUTBOUND",
  PRE_SCHEDULED: "PRE_SCHEDULED",
  RECURRING: "RECURRING",
  RECURRING_FIXED: "RECURRING_FIXED",
  SCHEDULED: "SCHEDULED",
  VOICEMAIL_INBOUND: "VOICEMAIL_INBOUND",
  VOICEMAIL_OUTBOUND: "VOICEMAIL_OUTBOUND",
} as const;
export type ExternalType = typeof ExternalType[keyof typeof ExternalType];

/**
 * Status of a feature
 */
export const FeatureStatus = {
  ACTIVE: "ACTIVE",
  NOT_ACTIVE: "NOT_ACTIVE",
  NOT_CONNECTED: "NOT_CONNECTED",
  NOT_ENABLED: "NOT_ENABLED",
} as const;
export type FeatureStatus = typeof FeatureStatus[keyof typeof FeatureStatus];

/**
 * The user-facing font weight type for a form field’s text
 */
export const FontWeightType = {
  bold: "bold",
  normal: "normal",
} as const;
export type FontWeightType = typeof FontWeightType[keyof typeof FontWeightType];

/**
 * The user-facing display type for a form field
 */
export const FormFieldType = {
  CHECKBOXES: "CHECKBOXES",
  DATE: "DATE",
  FILE: "FILE",
  HEADER: "HEADER",
  IMAGE: "IMAGE",
  INPUT: "INPUT",
  RADIO: "RADIO",
  SUBHEADER: "SUBHEADER",
  SUBMIT_BUTTON: "SUBMIT_BUTTON",
  TEXT: "TEXT",
  URL: "URL",
} as const;
export type FormFieldType = typeof FormFieldType[keyof typeof FormFieldType];

/**
 * Valid params for sorting Broadcasts
 */
export const FormSortType = {
  MODIFIED_TIME_ASC: "MODIFIED_TIME_ASC",
  MODIFIED_TIME_DESC: "MODIFIED_TIME_DESC",
  NAME_ASC: "NAME_ASC",
  NAME_DESC: "NAME_DESC",
} as const;
export type FormSortType = typeof FormSortType[keyof typeof FormSortType];

/**
 * The status of a web form
 */
export const FormStatus = {
  ACTIVATED: "ACTIVATED",
  IGNORED: "IGNORED",
  NOT_ACTIVATED: "NOT_ACTIVATED",
} as const;
export type FormStatus = typeof FormStatus[keyof typeof FormStatus];

/**
 * What order the submissions for a form should be returned in
 */
export const FormSubmissionSortOrder = {
  SUBMITTED_TIME_ASC: "SUBMITTED_TIME_ASC",
  SUBMITTED_TIME_DESC: "SUBMITTED_TIME_DESC",
} as const;
export type FormSubmissionSortOrder = typeof FormSubmissionSortOrder[keyof typeof FormSubmissionSortOrder];

/**
 * The type of form.
 */
export const FormType = {
  CHAT: "CHAT",
  MCFX: "MCFX",
  NUTSHELL: "NUTSHELL",
  SCHEDULER: "SCHEDULER",
} as const;
export type FormType = typeof FormType[keyof typeof FormType];

/**
 * The status for Nutshell campaigns from address.
 */
export const FromAddressStatus = {
  FAILED: "FAILED",
  NEW: "NEW",
  VERIFIED: "VERIFIED",
} as const;
export type FromAddressStatus = typeof FromAddressStatus[keyof typeof FromAddressStatus];

/**
 * The status of an aspect of a FromDomain
 */
export const FromDomainStatus = {
  STATUS_FAILED: "STATUS_FAILED",
  STATUS_NEW: "STATUS_NEW",
  STATUS_NOT_STARTED: "STATUS_NOT_STARTED",
  STATUS_UNCONFIGURED: "STATUS_UNCONFIGURED",
  STATUS_VERIFIED: "STATUS_VERIFIED",
  STATUS_VERIFYING: "STATUS_VERIFYING",
} as const;
export type FromDomainStatus = typeof FromDomainStatus[keyof typeof FromDomainStatus];

/**
 * The type of this exception.
 */
export const GateErrorReason = {
  REASON_EMAILS_SENT_LIMIT_EXCEEDED: "REASON_EMAILS_SENT_LIMIT_EXCEEDED",
  REASON_MARKETING_CONTACT_LIMIT_EXCEEDED: "REASON_MARKETING_CONTACT_LIMIT_EXCEEDED",
  REASON_MARKETING_DISABLED: "REASON_MARKETING_DISABLED",
} as const;
export type GateErrorReason = typeof GateErrorReason[keyof typeof GateErrorReason];

/**
 * Status of the report that was generated
 */
export const GenerateReportStatus = {
  FAILED: "FAILED",
  SUCCESS: "SUCCESS",
} as const;
export type GenerateReportStatus = typeof GenerateReportStatus[keyof typeof GenerateReportStatus];

/**
 * The type of goal. This is strictly used for UI purposes, and is inferred from the goal’s conditions.
 */
export const GoalType = {
  ACTIVITY_LOGGED: "ACTIVITY_LOGGED",
  ACTIVITY_SCHEDULED: "ACTIVITY_SCHEDULED",
  BASIC_INFO: "BASIC_INFO",
  CONTRACT_ACCEPTED: "CONTRACT_ACCEPTED",
  CONTRACT_SENT: "CONTRACT_SENT",
  EMAIL_CLICKED: "EMAIL_CLICKED",
  EMAIL_RECEIVED: "EMAIL_RECEIVED",
  EMAIL_SENT: "EMAIL_SENT",
  INVOICE_PAID: "INVOICE_PAID",
  INVOICE_SENT: "INVOICE_SENT",
  LEAD_FIELDS: "LEAD_FIELDS",
  LEAD_VALUE: "LEAD_VALUE",
  QUOTE_ACCEPTED: "QUOTE_ACCEPTED",
  QUOTE_SENT: "QUOTE_SENT",
  TAG_ADDED: "TAG_ADDED",
} as const;
export type GoalType = typeof GoalType[keyof typeof GoalType];

/**
 * The type of a DNS group (collection of records)
 */
export const GroupType = {
  CUSTOM: "CUSTOM",
  DKIM: "DKIM",
  DMARC: "DMARC",
  NUTSHELL_MANAGED: "NUTSHELL_MANAGED",
  SPF: "SPF",
} as const;
export type GroupType = typeof GroupType[keyof typeof GroupType];

/**
 * The different types of toggleable header fields for entities.
 */
export const HeaderFieldType = {
  COMPANY_TYPE: "COMPANY_TYPE",
  INDUSTRY: "INDUSTRY",
  LAST_CONTACTED: "LAST_CONTACTED",
  NUMBER_OF_EMPLOYEES: "NUMBER_OF_EMPLOYEES",
  REVENUE: "REVENUE",
  TERRITORY: "TERRITORY",
} as const;
export type HeaderFieldType = typeof HeaderFieldType[keyof typeof HeaderFieldType];

/**
 * Import2 status enum for the import flow
 */
export const Import2Status = {
  STATUS_MIGRATION_APPROVED: "STATUS_MIGRATION_APPROVED",
  STATUS_MIGRATION_COMPLETE: "STATUS_MIGRATION_COMPLETE",
  STATUS_MIGRATION_IN_PROGRESS: "STATUS_MIGRATION_IN_PROGRESS",
  STATUS_MIGRATION_REQUESTED: "STATUS_MIGRATION_REQUESTED",
  STATUS_NOT_STARTED: "STATUS_NOT_STARTED",
  STATUS_REVERTED: "STATUS_REVERTED",
  STATUS_SAMPLE_COMPLETED: "STATUS_SAMPLE_COMPLETED",
  STATUS_SAMPLE_IN_PROGRESS: "STATUS_SAMPLE_IN_PROGRESS",
} as const;
export type Import2Status = typeof Import2Status[keyof typeof Import2Status];

/**
 * The Dromo importIdentifier (https: // developer.dromo.io/settings#importidentifier)
 */
export const ImportIdentifier = {
  PRODUCT: "PRODUCT",
  QUOTA: "QUOTA",
} as const;
export type ImportIdentifier = typeof ImportIdentifier[keyof typeof ImportIdentifier];

/**
 * The status of a Nutshell import.
 */
export const ImportStatus = {
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  IN_PROGRESS: "IN_PROGRESS",
  MIGRATION_BEGAN: "MIGRATION_BEGAN",
  MIGRATION_READY: "MIGRATION_READY",
  REVERTED: "REVERTED",
  SAMPLE_BEGAN: "SAMPLE_BEGAN",
  SAMPLE_COMPLETE: "SAMPLE_COMPLETE",
  SAMPLE_NEW: "SAMPLE_NEW",
} as const;
export type ImportStatus = typeof ImportStatus[keyof typeof ImportStatus];

/**
 * The status of the Inbox phone number.
 */
export const InboxChannelType = {
  TYPE_CHAT_EXTERNAL: "TYPE_CHAT_EXTERNAL",
  TYPE_CHAT_NUTSHELL: "TYPE_CHAT_NUTSHELL",
  TYPE_EMAIL_EXTERNAL: "TYPE_EMAIL_EXTERNAL",
  TYPE_EMAIL_NUTSHELL: "TYPE_EMAIL_NUTSHELL",
  TYPE_FACEBOOK_EXTERNAL: "TYPE_FACEBOOK_EXTERNAL",
  TYPE_FACEBOOK_NUTSHELL: "TYPE_FACEBOOK_NUTSHELL",
  TYPE_INSTAGRAM_EXTERNAL: "TYPE_INSTAGRAM_EXTERNAL",
  TYPE_INSTAGRAM_NUTSHELL: "TYPE_INSTAGRAM_NUTSHELL",
  TYPE_PHONE_CALLTRACKER: "TYPE_PHONE_CALLTRACKER",
  TYPE_PHONE_EXTERNAL: "TYPE_PHONE_EXTERNAL",
  TYPE_PHONE_NUTSHELL: "TYPE_PHONE_NUTSHELL",
  TYPE_PHONE_RINGCENTRAL: "TYPE_PHONE_RINGCENTRAL",
  TYPE_STUB_EXTERNAL: "TYPE_STUB_EXTERNAL",
  TYPE_STUB_NUTSHELL: "TYPE_STUB_NUTSHELL",
  TYPE_STUB_SHELLY: "TYPE_STUB_SHELLY",
  TYPE_UNKNOWN: "TYPE_UNKNOWN",
  TYPE_WHATSAPP_EXTERNAL: "TYPE_WHATSAPP_EXTERNAL",
  TYPE_WHATSAPP_NUTSHELL: "TYPE_WHATSAPP_NUTSHELL",
} as const;
export type InboxChannelType = typeof InboxChannelType[keyof typeof InboxChannelType];

/**
 * The status of the instance inbox plan
 */
export const InboxPlanEnum = {
  CAN_SEND: "CAN_SEND",
  NO_CREDITS: "NO_CREDITS",
  NO_PLAN: "NO_PLAN",
  ON_BETA: "ON_BETA",
} as const;
export type InboxPlanEnum = typeof InboxPlanEnum[keyof typeof InboxPlanEnum];

/**
 * The high-level status of the entire inbox setup
 */
export const InboxStatusEnum = {
  ERROR: "ERROR",
  FORM_APPROVED: "FORM_APPROVED",
  FORM_IN_PROGRESS: "FORM_IN_PROGRESS",
  NOT_STARTED: "NOT_STARTED",
  NUMBER_SETUP: "NUMBER_SETUP",
  VALID: "VALID",
} as const;
export type InboxStatusEnum = typeof InboxStatusEnum[keyof typeof InboxStatusEnum];

/**
 * An mcfx industry that a company can belong to
 */
export const IndustryType = {
  ACCOMMODATION_FOOD_SERVICES: "ACCOMMODATION_FOOD_SERVICES",
  ADMINISTRATIVE_SUPPORT_WASTE_MANAGEMENT_REMEDIATION_SERVICES: "ADMINISTRATIVE_SUPPORT_WASTE_MANAGEMENT_REMEDIATION_SERVICES",
  AGRICULTURE_FORESTRY_FISHING_HUNTING: "AGRICULTURE_FORESTRY_FISHING_HUNTING",
  ARTS_ENTERTAINMENT_RECREATION: "ARTS_ENTERTAINMENT_RECREATION",
  CONSTRUCTION: "CONSTRUCTION",
  EDUCATIONAL_SERVICES: "EDUCATIONAL_SERVICES",
  FINANCE_INSURANCE: "FINANCE_INSURANCE",
  HEALTH_CARE_SOCIAL_ASSISTANCE: "HEALTH_CARE_SOCIAL_ASSISTANCE",
  INFORMATION: "INFORMATION",
  MANAGEMENT_OF_COMPANIES_ENTERPRISES: "MANAGEMENT_OF_COMPANIES_ENTERPRISES",
  MANUFACTURING: "MANUFACTURING",
  MINING_QUARRYING_OIL_GAS_EXTRACTION: "MINING_QUARRYING_OIL_GAS_EXTRACTION",
  OTHER_SERVICES: "OTHER_SERVICES",
  PROFESSIONAL_SCIENTIFIC_TECHNICAL_SERVICES: "PROFESSIONAL_SCIENTIFIC_TECHNICAL_SERVICES",
  PUBLIC_ADMINISTRATION: "PUBLIC_ADMINISTRATION",
  REAL_ESTATE_RENTAL_LEASING: "REAL_ESTATE_RENTAL_LEASING",
  RETAIL_TRADE: "RETAIL_TRADE",
  TRANSPORTATION_WAREHOUSING: "TRANSPORTATION_WAREHOUSING",
  UTILITIES: "UTILITIES",
  WHOLESALE_TRADE: "WHOLESALE_TRADE",
} as const;
export type IndustryType = typeof IndustryType[keyof typeof IndustryType];

/**
 * When to collect visitor information during chat
 */
export const IntakeFormCollectionTimingEnum = {
  AFTER_FIFTH_BOT_REPLY: "AFTER_FIFTH_BOT_REPLY",
  AFTER_FIRST_BOT_REPLY: "AFTER_FIRST_BOT_REPLY",
  IMMEDIATELY: "IMMEDIATELY",
} as const;
export type IntakeFormCollectionTimingEnum = typeof IntakeFormCollectionTimingEnum[keyof typeof IntakeFormCollectionTimingEnum];

/**
 * Marketplace integration category
 */
export const IntegrationCategory = {
  ACCOUNTING: "ACCOUNTING",
  AI: "AI",
  COMMUNICATIONS: "COMMUNICATIONS",
  DOCUMENTS: "DOCUMENTS",
  EMAIL_AND_CALENDAR: "EMAIL_AND_CALENDAR",
  FORMS: "FORMS",
  MARKETING: "MARKETING",
  OTHER: "OTHER",
  PROJECT_MANAGEMENT: "PROJECT_MANAGEMENT",
  SALES: "SALES",
  SCHEDULING: "SCHEDULING",
} as const;
export type IntegrationCategory = typeof IntegrationCategory[keyof typeof IntegrationCategory];

/**
 * Catalog key for a marketplace integration
 */
export const IntegrationKey = {
  ACUITY_SCHEDULING: "ACUITY_SCHEDULING",
  AIRCALL: "AIRCALL",
  AIRTABLE: "AIRTABLE",
  APOLLO_IO: "APOLLO_IO",
  CALENDLY: "CALENDLY",
  CALLRAIL: "CALLRAIL",
  CHATGPT_MCP: "CHATGPT_MCP",
  CHROME_EXTENSION: "CHROME_EXTENSION",
  CLAUDE_MCP: "CLAUDE_MCP",
  DEMIO: "DEMIO",
  DIALPAD: "DIALPAD",
  DOCUSIGN: "DOCUSIGN",
  DROPBOX_DOCSEND: "DROPBOX_DOCSEND",
  DROPBOX_SIGN: "DROPBOX_SIGN",
  ECOLOGI: "ECOLOGI",
  EVENTBRITE: "EVENTBRITE",
  EWEBINAR: "EWEBINAR",
  FACEBOOK_LEAD_ADS: "FACEBOOK_LEAD_ADS",
  FACEBOOK_MESSENGER: "FACEBOOK_MESSENGER",
  FRESHCALLER: "FRESHCALLER",
  GIVEBUTTER: "GIVEBUTTER",
  GMAIL: "GMAIL",
  GOOGLE_CALENDAR: "GOOGLE_CALENDAR",
  GOOGLE_MEET: "GOOGLE_MEET",
  GOOGLE_SHEETS: "GOOGLE_SHEETS",
  GOOGLE_TASKS: "GOOGLE_TASKS",
  GRAVITY_FORMS: "GRAVITY_FORMS",
  HOUSECALL_PRO: "HOUSECALL_PRO",
  INSTAGRAM_DMS: "INSTAGRAM_DMS",
  INTERCOM: "INTERCOM",
  JOTFORM: "JOTFORM",
  JUSTCALL: "JUSTCALL",
  KIT: "KIT",
  KIXIE: "KIXIE",
  KRISPCALL: "KRISPCALL",
  LEADPAGES: "LEADPAGES",
  LINKEDIN_ADS: "LINKEDIN_ADS",
  MAILCHIMP: "MAILCHIMP",
  MICROSOFT_CALENDAR: "MICROSOFT_CALENDAR",
  MICROSOFT_TEAMS: "MICROSOFT_TEAMS",
  MICROSOFT_TEAMS_EVENTS: "MICROSOFT_TEAMS_EVENTS",
  MICROSOFT_TEAMS_MEETINGS: "MICROSOFT_TEAMS_MEETINGS",
  MIGHTYCALL: "MIGHTYCALL",
  MIGHTYFORMS: "MIGHTYFORMS",
  NINJA_FORMS: "NINJA_FORMS",
  NUTSHELL_CHAT: "NUTSHELL_CHAT",
  NUTSHELL_EMAIL_MARKETING: "NUTSHELL_EMAIL_MARKETING",
  NUTSHELL_FORMS: "NUTSHELL_FORMS",
  NUTSHELL_MOBILE_APP: "NUTSHELL_MOBILE_APP",
  NUTSHELL_SCHEDULER: "NUTSHELL_SCHEDULER",
  NUTSHELL_SMS: "NUTSHELL_SMS",
  NUTSHELL_SMS_MARKETING: "NUTSHELL_SMS_MARKETING",
  OLARK: "OLARK",
  OUTLOOK: "OUTLOOK",
  OUTLOOK_ADD_IN: "OUTLOOK_ADD_IN",
  PANDADOC: "PANDADOC",
  PEOPLE_IQ: "PEOPLE_IQ",
  PERSPECTIVE: "PERSPECTIVE",
  PROPOSALS_INVOICES: "PROPOSALS_INVOICES",
  PROPOSIFY: "PROPOSIFY",
  PROSPECTOR_IQ: "PROSPECTOR_IQ",
  QUICKBOOKS: "QUICKBOOKS",
  QUO: "QUO",
  QUOTIENT: "QUOTIENT",
  REVENUECLOUDFX: "REVENUECLOUDFX",
  RINGCENTRAL: "RINGCENTRAL",
  SEAMLESS_AI: "SEAMLESS_AI",
  SHOPIFY: "SHOPIFY",
  SIGNNOW: "SIGNNOW",
  SIGNREQUEST: "SIGNREQUEST",
  SIGNWELL: "SIGNWELL",
  SLACK: "SLACK",
  SQUARESPACE: "SQUARESPACE",
  STRIPE: "STRIPE",
  TEXTIFUL: "TEXTIFUL",
  TEXTMAGIC: "TEXTMAGIC",
  TIKTOK: "TIKTOK",
  TRELLO: "TRELLO",
  TYPEFORM: "TYPEFORM",
  UNCOMMON_GIVING: "UNCOMMON_GIVING",
  USERVOICE: "USERVOICE",
  VISITOR_IQ: "VISITOR_IQ",
  WEBFLOW: "WEBFLOW",
  WHATSAPP_BUSINESS: "WHATSAPP_BUSINESS",
  WOOCOMMERCE: "WOOCOMMERCE",
  WORDPRESS: "WORDPRESS",
  WPFORMS: "WPFORMS",
  WUFOO: "WUFOO",
  XERO: "XERO",
  ZENDESK: "ZENDESK",
  ZOOM: "ZOOM",
} as const;
export type IntegrationKey = typeof IntegrationKey[keyof typeof IntegrationKey];

/**
 * How a marketplace integration is provided
 */
export const IntegrationProvider = {
  INSTANT: "INSTANT",
  NUTSHELL: "NUTSHELL",
  ZAPIER: "ZAPIER",
} as const;
export type IntegrationProvider = typeof IntegrationProvider[keyof typeof IntegrationProvider];

/**
 * The status of a Recurly invoice
 */
export const InvoiceStatus = {
  LATE: "LATE",
  NOT_PAID: "NOT_PAID",
  PAID: "PAID",
  PAYMENT_FAILED: "PAYMENT_FAILED",
  REFUND: "REFUND",
  SCHEDULED: "SCHEDULED",
} as const;
export type InvoiceStatus = typeof InvoiceStatus[keyof typeof InvoiceStatus];

/**
 * PeopleIQ filter for job field
 */
export const JobFieldType = {
  CUSTOMER_SERVICE: "CUSTOMER_SERVICE",
  DESIGN: "DESIGN",
  EDUCATION: "EDUCATION",
  ENGINEERING: "ENGINEERING",
  FINANCE: "FINANCE",
  HEALTH: "HEALTH",
  HUMAN_RESOURCES: "HUMAN_RESOURCES",
  LEGAL: "LEGAL",
  MARKETING: "MARKETING",
  MEDIA: "MEDIA",
  OPERATIONS: "OPERATIONS",
  PUBLIC_RELATIONS: "PUBLIC_RELATIONS",
  REAL_ESTATE: "REAL_ESTATE",
  SALES: "SALES",
  TRADES: "TRADES",
} as const;
export type JobFieldType = typeof JobFieldType[keyof typeof JobFieldType];

/**
 * Other options that can be used for assigning a lead besides assigning to a user or team. 
 * 				Shared with followup and new lead automations, so some values may work only for one or the other.
 */
export const LeadAssigneeRuleEnum = {
  ASSIGN_TO_CONTACT_ASSIGNEE: "ASSIGN_TO_CONTACT_ASSIGNEE",
  ASSIGN_TO_SOURCE_LEAD_ASSIGNEE: "ASSIGN_TO_SOURCE_LEAD_ASSIGNEE",
  AUTO_ASSIGN: "AUTO_ASSIGN",
} as const;
export type LeadAssigneeRuleEnum = typeof LeadAssigneeRuleEnum[keyof typeof LeadAssigneeRuleEnum];

/**
 * A score indicating how well a lead fits the ideal customer profile
 */
export const LeadFitScore = {
  IDEAL: "IDEAL",
  POSSIBLE: "POSSIBLE",
  UNKNOWN: "UNKNOWN",
  UNLIKELY: "UNLIKELY",
} as const;
export type LeadFitScore = typeof LeadFitScore[keyof typeof LeadFitScore];

/**
 * The different priority values a lead can have
 */
export const LeadPriority = {
  HOT: "HOT",
  NORMAL: "NORMAL",
} as const;
export type LeadPriority = typeof LeadPriority[keyof typeof LeadPriority];

/**
 * Sentiment indicating whether information is positive, negative, or neutral for the sale
 */
export const LeadResearchSentiment = {
  BAD: "BAD",
  GOOD: "GOOD",
  NEUTRAL: "NEUTRAL",
} as const;
export type LeadResearchSentiment = typeof LeadResearchSentiment[keyof typeof LeadResearchSentiment];

/**
 * The different statuses associated of a lead
 */
export const LeadStatus = {
  CANCELLED: "CANCELLED",
  CLOSED_IMPORT: "CLOSED_IMPORT",
  LOST: "LOST",
  OPEN: "OPEN",
  PENDING: "PENDING",
  WON: "WON",
} as const;
export type LeadStatus = typeof LeadStatus[keyof typeof LeadStatus];

/**
 * The different modes associated with a lead value
 */
export const LeadValueMode = {
  MANUAL: "MANUAL",
  PRODUCT: "PRODUCT",
} as const;
export type LeadValueMode = typeof LeadValueMode[keyof typeof LeadValueMode];

/**
 * The types of Nutshell licenses
 */
export const LicenseType = {
  CRM: "CRM",
  ENGAGEMENT: "ENGAGEMENT",
  MARKETING: "MARKETING",
} as const;
export type LicenseType = typeof LicenseType[keyof typeof LicenseType];

/**
 * The type of limited feature in Nutshell
 */
export const LimitedType = {
  AI_CONVERSATIONS: "AI_CONVERSATIONS",
  AI_OUTCOMES: "AI_OUTCOMES",
  AI_SUMMARIES: "AI_SUMMARIES",
  AI_TRANSCRIPTIONS: "AI_TRANSCRIPTIONS",
  CUSTOM_FIELDS: "CUSTOM_FIELDS",
  FORMS: "FORMS",
  LEADS: "LEADS",
  MARKETS: "MARKETS",
  PIPELINES: "PIPELINES",
  ROLES: "ROLES",
  TEAMS: "TEAMS",
  TERRITORIES: "TERRITORIES",
} as const;
export type LimitedType = typeof LimitedType[keyof typeof LimitedType];

/**
 * The type of phone number that is linked
 */
export const LinkNumberTypeEnum = {
  callTracker: "callTracker",
  custom: "custom",
} as const;
export type LinkNumberTypeEnum = typeof LinkNumberTypeEnum[keyof typeof LinkNumberTypeEnum];

/**
 * PeopleIQ filter for management level
 */
export const ManagementLevelType = {
  CXO: "CXO",
  DIRECTOR: "DIRECTOR",
  ENTRY: "ENTRY",
  MANAGER: "MANAGER",
  OWNER: "OWNER",
  PARTNER: "PARTNER",
  SENIOR: "SENIOR",
  TRAINING: "TRAINING",
  UNPAID: "UNPAID",
  VP: "VP",
} as const;
export type ManagementLevelType = typeof ManagementLevelType[keyof typeof ManagementLevelType];

/**
 * Can either be scheduler (calendar) or gmeet page (meetings) and we decide
 * whether to enable calendar sync or subscribe to meeting webhooks
 */
export const MeetAuthType = {
  CALENDAR: "CALENDAR",
  MEETINGS: "MEETINGS",
} as const;
export type MeetAuthType = typeof MeetAuthType[keyof typeof MeetAuthType];

/**
 * Location type for meetings
 */
export const MeetingLocationType = {
  ADDRESS: "ADDRESS",
  INBOUND_CALL: "INBOUND_CALL",
  MEET: "MEET",
  NONE: "NONE",
  OUTBOUND_CALL: "OUTBOUND_CALL",
  TEAMS: "TEAMS",
  ZOOM: "ZOOM",
} as const;
export type MeetingLocationType = typeof MeetingLocationType[keyof typeof MeetingLocationType];

/**
 * Valid params for sorting Scheduler meetings
 */
export const MeetingSortOrder = {
  BOOKABLE_FIRST: "BOOKABLE_FIRST",
  BOOKABLE_LAST: "BOOKABLE_LAST",
  NUM_BOOKINGS_DESC: "NUM_BOOKINGS_DESC",
} as const;
export type MeetingSortOrder = typeof MeetingSortOrder[keyof typeof MeetingSortOrder];

/**
 * Type of meeting
 */
export const MeetingType = {
  COHOSTED: "COHOSTED",
  ROUND_ROBIN: "ROUND_ROBIN",
  SOLO: "SOLO",
  UNKNOWN: "UNKNOWN",
} as const;
export type MeetingType = typeof MeetingType[keyof typeof MeetingType];

/**
 * The status of a message
 */
export const MessageStatus = {
  CANCELLED: "CANCELLED",
  FAILED: "FAILED",
  QUEUED: "QUEUED",
  SCHEDULED: "SCHEDULED",
  SENT: "SENT",
  TRANSIT: "TRANSIT",
} as const;
export type MessageStatus = typeof MessageStatus[keyof typeof MessageStatus];

/**
 * Valid params for sorting Newsletters
 */
export const NewsletterSortType = {
  MODIFIED_TIME_ASC: "MODIFIED_TIME_ASC",
  MODIFIED_TIME_DESC: "MODIFIED_TIME_DESC",
  NAME_ASC: "NAME_ASC",
  NAME_DESC: "NAME_DESC",
} as const;
export type NewsletterSortType = typeof NewsletterSortType[keyof typeof NewsletterSortType];

/**
 * A type of alias for a Nutshell user to be resolved at runtime.
 */
export const NotifiableAliasType = {
  CONTACT_ASSIGNEE: "CONTACT_ASSIGNEE",
  RELATED_LEAD_ASSIGNEE: "RELATED_LEAD_ASSIGNEE",
} as const;
export type NotifiableAliasType = typeof NotifiableAliasType[keyof typeof NotifiableAliasType];

/**
 * The different states of an in-app notification, i.e., if it is read, or seen, or unseen.
 */
export const NotificationReadStatus = {
  READ: "READ",
  SEEN: "SEEN",
  UNSEEN: "UNSEEN",
} as const;
export type NotificationReadStatus = typeof NotificationReadStatus[keyof typeof NotificationReadStatus];

/**
 * Channel used to deliver a notification.
 */
export const NotificationSendType = {
  EMAIL: "EMAIL",
  IN_APP: "IN_APP",
  PUSH: "PUSH",
  SMS: "SMS",
  WEBHOOK: "WEBHOOK",
} as const;
export type NotificationSendType = typeof NotificationSendType[keyof typeof NotificationSendType];

/**
 * The options describing the formal type of notification messages.
 */
export const NotificationType = {
  ACCOUNT_ASSIGNMENT: "ACCOUNT_ASSIGNMENT",
  ACTIVITY: "ACTIVITY",
  ACTIVITY_REMINDER: "ACTIVITY_REMINDER",
  BROKEN_INTEGRATION: "BROKEN_INTEGRATION",
  COMMENT: "COMMENT",
  CONTRACT_ACCEPTED: "CONTRACT_ACCEPTED",
  CONTRACT_VIEWED: "CONTRACT_VIEWED",
  DOCUMENT_ACCEPTED: "DOCUMENT_ACCEPTED",
  EMAIL_AUTOMATION_STATUS: "EMAIL_AUTOMATION_STATUS",
  FULLCONTACT: "FULLCONTACT",
  GENERIC: "GENERIC",
  HIDDEN_ENGAGEMENT_MESSAGE: "HIDDEN_ENGAGEMENT_MESSAGE",
  INVOICE_VIEWED: "INVOICE_VIEWED",
  LEAD: "LEAD",
  LINK_CLICKED: "LINK_CLICKED",
  MEETING_NEEDS_ATTENTION: "MEETING_NEEDS_ATTENTION",
  MENTION: "MENTION",
  NEW_CONNECTED_FORM: "NEW_CONNECTED_FORM",
  PAGE_VIEWED: "PAGE_VIEWED",
  PAGE_VIEWED_TEST: "PAGE_VIEWED_TEST",
  QUICKBOOKS_INVOICE_PAID: "QUICKBOOKS_INVOICE_PAID",
  QUOTE_ACCEPTED: "QUOTE_ACCEPTED",
  QUOTE_VIEWED: "QUOTE_VIEWED",
  REACTION: "REACTION",
  SCHEDULER_BOOKING: "SCHEDULER_BOOKING",
  SMS_REPLY: "SMS_REPLY",
  STEP: "STEP",
  STEP_REMINDER: "STEP_REMINDER",
  SUBMISSION: "SUBMISSION",
  TASK: "TASK",
  TASK_REMINDER: "TASK_REMINDER",
  THREAD_ASSIGNMENT: "THREAD_ASSIGNMENT",
  THREAD_UNASSIGNED_START: "THREAD_UNASSIGNED_START",
  WEBHOOK_DEACTIVATE: "WEBHOOK_DEACTIVATE",
} as const;
export type NotificationType = typeof NotificationType[keyof typeof NotificationType];

/**
 * When to show nudges (desktop only or always)
 */
export const NudgeDeviceVisibilityEnum = {
  ALWAYS: "ALWAYS",
  DESKTOP_ONLY: "DESKTOP_ONLY",
} as const;
export type NudgeDeviceVisibilityEnum = typeof NudgeDeviceVisibilityEnum[keyof typeof NudgeDeviceVisibilityEnum];

/**
 * The key for a onboarding checklist item.
 */
export const OnboardingChecklistKey = {
  connectExternalAccount: "connectExternalAccount",
  createBroadcast: "createBroadcast",
  createForm: "createForm",
  embedChat: "embedChat",
  importContacts: "importContacts",
  inviteYourTeam: "inviteYourTeam",
  reviewAgentsAndAvailability: "reviewAgentsAndAvailability",
  setupSMS: "setupSMS",
  useAnalytics: "useAnalytics",
} as const;
export type OnboardingChecklistKey = typeof OnboardingChecklistKey[keyof typeof OnboardingChecklistKey];

/**
 * The status of the onboarding module
 */
export const OnboardingModuleStatus = {
  COMPLETED: "COMPLETED",
  IN_PROGRESS: "IN_PROGRESS",
  TO_EXPLORE: "TO_EXPLORE",
} as const;
export type OnboardingModuleStatus = typeof OnboardingModuleStatus[keyof typeof OnboardingModuleStatus];

export const OnboardingModuleType = {
  CALLS_MEETINGS: "CALLS_MEETINGS",
  CALLS_NON_ADMIN: "CALLS_NON_ADMIN",
  CHATBOT_FORMS: "CHATBOT_FORMS",
  DATA_ORGANIZED: "DATA_ORGANIZED",
  EMAILS: "EMAILS",
  ESSENTIALS: "ESSENTIALS",
  LEADS_PIPELINES: "LEADS_PIPELINES",
  MEETINGS_NON_ADMIN: "MEETINGS_NON_ADMIN",
  QUOTES_INVOICES: "QUOTES_INVOICES",
  SCHEDULER_NON_ADMIN: "SCHEDULER_NON_ADMIN",
  SEND_EMAILS_NON_ADMIN: "SEND_EMAILS_NON_ADMIN",
  STAY_ORGANIZED_NON_ADMIN: "STAY_ORGANIZED_NON_ADMIN",
  USE_NUTSHELL_WHEREVER_NON_ADMIN: "USE_NUTSHELL_WHEREVER_NON_ADMIN",
} as const;
export type OnboardingModuleType = typeof OnboardingModuleType[keyof typeof OnboardingModuleType];

/**
 * The type of the onboarding step
 */
export const OnboardingStepType = {
  ADD_LEAD: "ADD_LEAD",
  BOOK_MEETING: "BOOK_MEETING",
  CHAT_TO_SITE: "CHAT_TO_SITE",
  CLICK_TO_CALL: "CLICK_TO_CALL",
  CONNECT_MEETING: "CONNECT_MEETING",
  CONNECT_PHONE: "CONNECT_PHONE",
  CREATE_ACCOUNT: "CREATE_ACCOUNT",
  CREATE_CONTRACT: "CREATE_CONTRACT",
  CREATE_DASHBOARD_CARD: "CREATE_DASHBOARD_CARD",
  CREATE_INVOICE: "CREATE_INVOICE",
  CREATE_PIPELINE: "CREATE_PIPELINE",
  CREATE_QUOTE: "CREATE_QUOTE",
  CUSTOM_FIELD: "CUSTOM_FIELD",
  DESIGN_BROADCAST: "DESIGN_BROADCAST",
  DNS_SETUP: "DNS_SETUP",
  EMAIL_CALENDAR_SYNC: "EMAIL_CALENDAR_SYNC",
  EMAIL_LEADS: "EMAIL_LEADS",
  EMAIL_SEQUENCE: "EMAIL_SEQUENCE",
  EMAIL_SYNC: "EMAIL_SYNC",
  IMPORT_CRM: "IMPORT_CRM",
  INSTALL_CHROME_OR_OUTLOOK: "INSTALL_CHROME_OR_OUTLOOK",
  INSTALL_MOBILE_APP: "INSTALL_MOBILE_APP",
  INVITE_TEAM: "INVITE_TEAM",
  LOG_PHONE_ACTIVITY: "LOG_PHONE_ACTIVITY",
  LOG_VIDEO_ACTIVITY: "LOG_VIDEO_ACTIVITY",
  MAKE_PHONE_CALL: "MAKE_PHONE_CALL",
  MOVE_LEAD: "MOVE_LEAD",
  NUTSHELL_FORM: "NUTSHELL_FORM",
  PHONE_PROVIDER: "PHONE_PROVIDER",
  PREVIEW_CHATBOT: "PREVIEW_CHATBOT",
  PRODUCTS_ADDED: "PRODUCTS_ADDED",
  QUOTE_TEMPLATE: "QUOTE_TEMPLATE",
  REPORT_LEADS: "REPORT_LEADS",
  SAVED_LISTS: "SAVED_LISTS",
  SAVED_LIST_DASHBOARD: "SAVED_LIST_DASHBOARD",
  SCHEDULER: "SCHEDULER",
  SEND_EMAIL: "SEND_EMAIL",
  SEND_EMAIL_SEQUENCE: "SEND_EMAIL_SEQUENCE",
  SYNC_VIDEO_CALL: "SYNC_VIDEO_CALL",
  VIEW_ACTIVITIES: "VIEW_ACTIVITIES",
  VISITOR_IQ: "VISITOR_IQ",
} as const;
export type OnboardingStepType = typeof OnboardingStepType[keyof typeof OnboardingStepType];

/**
 * Available opt-out message options for SMS editions
 */
export const OptOutType = {
  REPLY_STOP_TO_UNSUBSCRIBE: "REPLY_STOP_TO_UNSUBSCRIBE",
  STOPALL_TO_QUIT: "STOPALL_TO_QUIT",
  STOP_TO_QUIT: "STOP_TO_QUIT",
  STOP_TO_UNSUBSCRIBE: "STOP_TO_UNSUBSCRIBE",
  UNSUBSCRIBE_TO_QUIT: "UNSUBSCRIBE_TO_QUIT",
} as const;
export type OptOutType = typeof OptOutType[keyof typeof OptOutType];

export const OriginType = {
  ABBYY_BUSINESSCARD: "ABBYY_BUSINESSCARD",
  AIRCALL: "AIRCALL",
  API: "API",
  ASYNC: "ASYNC",
  AUTO_LEAD_CLOSER: "AUTO_LEAD_CLOSER",
  BULK_EDIT: "BULK_EDIT",
  BULK_EMAIL: "BULK_EMAIL",
  CALLRAIL: "CALLRAIL",
  CALLTRACKER_FX: "CALLTRACKER_FX",
  CHAT: "CHAT",
  CHATBOT: "CHATBOT",
  CHAT_OFFLINE: "CHAT_OFFLINE",
  CHAT_THREAD: "CHAT_THREAD",
  CONSTANT_CONTACT: "CONSTANT_CONTACT",
  CREATE_FROM_LIST: "CREATE_FROM_LIST",
  DEMIO: "DEMIO",
  DIALPAD: "DIALPAD",
  DIRECTORY_SYNC: "DIRECTORY_SYNC",
  EMAIL: "EMAIL",
  EMAIL_AUTOMATED_REPLY: "EMAIL_AUTOMATED_REPLY",
  EMAIL_MARKETING: "EMAIL_MARKETING",
  EMAIL_MARKETING_TEST_MESSAGE: "EMAIL_MARKETING_TEST_MESSAGE",
  ENGAGEMENT_BOOKING: "ENGAGEMENT_BOOKING",
  ENGAGEMENT_CALL: "ENGAGEMENT_CALL",
  ENGAGEMENT_EMAIL: "ENGAGEMENT_EMAIL",
  ENGAGEMENT_QUOTE: "ENGAGEMENT_QUOTE",
  ENGAGEMENT_TEXT: "ENGAGEMENT_TEXT",
  FORM: "FORM",
  FULLCONTACT: "FULLCONTACT",
  FULL_ENRICH: "FULL_ENRICH",
  GMAIL: "GMAIL",
  GOOGLE_API: "GOOGLE_API",
  HUBSPOT: "HUBSPOT",
  IMPORT: "IMPORT",
  INSTAGRAM: "INSTAGRAM",
  INTEGRATION: "INTEGRATION",
  KIXIE: "KIXIE",
  MCFX: "MCFX",
  MESSENGER: "MESSENGER",
  NUTSHELL_AI_CAMPAIGN_GENERATOR: "NUTSHELL_AI_CAMPAIGN_GENERATOR",
  NUTSHELL_AUTOMATION: "NUTSHELL_AUTOMATION",
  NUTSHELL_MARKETING_AUTOMATION: "NUTSHELL_MARKETING_AUTOMATION",
  NUTSHELL_MCP: "NUTSHELL_MCP",
  NUTSHELL_PROVISIONER: "NUTSHELL_PROVISIONER",
  NUT_TRACK: "NUT_TRACK",
  OFFICE365_API: "OFFICE365_API",
  ONBOARDING: "ONBOARDING",
  PEOPLEIQ: "PEOPLEIQ",
  PROSPECTOR: "PROSPECTOR",
  QUICKBOOKS: "QUICKBOOKS",
  QUOTE: "QUOTE",
  REPAIR: "REPAIR",
  REVERT_BULK_EDIT: "REVERT_BULK_EDIT",
  RINGCENTRAL: "RINGCENTRAL",
  SCHEDULER: "SCHEDULER",
  SHARED_EMAIL_INBOX: "SHARED_EMAIL_INBOX",
  SHARED_EMAIL_INBOX_OUTBOUND: "SHARED_EMAIL_INBOX_OUTBOUND",
  SMS: "SMS",
  SMS_MARKETING: "SMS_MARKETING",
  SSO: "SSO",
  UNBOUNCE: "UNBOUNCE",
  UNKNOWN: "UNKNOWN",
  USERVOICE: "USERVOICE",
  VISITORIQ: "VISITORIQ",
  WEB: "WEB",
  WHATSAPP: "WHATSAPP",
  ZENDESK: "ZENDESK",
  ZOOM: "ZOOM",
} as const;
export type OriginType = typeof OriginType[keyof typeof OriginType];

/**
 * The type of lead closing event.
 */
export const OutcomeType = {
  LEAD_CANCELLED: "LEAD_CANCELLED",
  LEAD_LOST: "LEAD_LOST",
  LEAD_WON: "LEAD_WON",
} as const;
export type OutcomeType = typeof OutcomeType[keyof typeof OutcomeType];

/**
 * The action type of the rule
 */
export const PageRuleActionType = {
  CONTINUE: "CONTINUE",
  PAGE: "PAGE",
  SUBMIT: "SUBMIT",
  UNKNOWN: "UNKNOWN",
} as const;
export type PageRuleActionType = typeof PageRuleActionType[keyof typeof PageRuleActionType];

/**
 * The different statuses associated with a landing page
 */
export const PageStatus = {
  NEW: "NEW",
  PUBLISHED: "PUBLISHED",
  UNDER_REVIEW: "UNDER_REVIEW",
} as const;
export type PageStatus = typeof PageStatus[keyof typeof PageStatus];

/**
 * Duplicate-grouping keys shared across contacts and accounts. Contacts accept all
 * four values; accounts accept only COMPANY_NAME, EMAIL_ADDRESS, and PHONE_NUMBER
 * (FULL_NAME is rejected at validation time).
 */
export const PeepDuplicateGroupingKey = {
  COMPANY_NAME: "COMPANY_NAME",
  EMAIL_ADDRESS: "EMAIL_ADDRESS",
  FULL_NAME: "FULL_NAME",
  PHONE_NUMBER: "PHONE_NUMBER",
} as const;
export type PeepDuplicateGroupingKey = typeof PeepDuplicateGroupingKey[keyof typeof PeepDuplicateGroupingKey];

/**
 * Strategies for selecting the primary record to keep when merging a duplicate group of peep entities (contacts or accounts).
 */
export const PeepDuplicateMergeRule = {
  CREATED_MOST_RECENTLY: "CREATED_MOST_RECENTLY",
  CREATED_OLDEST: "CREATED_OLDEST",
  MOST_RECENT_ENGAGEMENT: "MOST_RECENT_ENGAGEMENT",
  UPDATED_MOST_RECENTLY: "UPDATED_MOST_RECENTLY",
} as const;
export type PeepDuplicateMergeRule = typeof PeepDuplicateMergeRule[keyof typeof PeepDuplicateMergeRule];

/**
 * The sort type for related peeps
 */
export const PeepRelatedPeepSortType = {
  CREATED_TIME_DESC: "CREATED_TIME_DESC",
  NAME_ASC: "NAME_ASC",
  NAME_DESC: "NAME_DESC",
} as const;
export type PeepRelatedPeepSortType = typeof PeepRelatedPeepSortType[keyof typeof PeepRelatedPeepSortType];

/**
 * The relationship type between a contact and an account
 */
export const PeepRelationshipType = {
  FORMER_CONTACT: "FORMER_CONTACT",
  PRIMARY_CONTACT: "PRIMARY_CONTACT",
  UNDEFINED: "UNDEFINED",
} as const;
export type PeepRelationshipType = typeof PeepRelationshipType[keyof typeof PeepRelationshipType];

/**
 * Receive PeopleIQ suggestions for a given company
 */
export const PeopleIqPreference = {
  DECLINED: "DECLINED",
} as const;
export type PeopleIqPreference = typeof PeopleIqPreference[keyof typeof PeopleIqPreference];

/**
 * The options describing the formal type of permissions for roles.
 */
export const Permission = {
  CAN_ACCESS_BILLING: "CAN_ACCESS_BILLING",
  CAN_ACCESS_FULL_CAMPAIGNS: "CAN_ACCESS_FULL_CAMPAIGNS",
  CAN_ACCESS_MARKETING: "CAN_ACCESS_MARKETING",
  CAN_ACCESS_SETUP: "CAN_ACCESS_SETUP",
  CAN_ASSIGN_ENTITIES: "CAN_ASSIGN_ENTITIES",
  CAN_BULK_EDIT: "CAN_BULK_EDIT",
  CAN_DELETE_ENTITIES: "CAN_DELETE_ENTITIES",
  CAN_DELETE_NOTES_AND_ACTIVITIES: "CAN_DELETE_NOTES_AND_ACTIVITIES",
  CAN_EXPORT: "CAN_EXPORT",
  CAN_IMPORT: "CAN_IMPORT",
  CAN_MANAGE_EMAIL_TEMPLATES: "CAN_MANAGE_EMAIL_TEMPLATES",
  CAN_MERGE_ENTITIES: "CAN_MERGE_ENTITIES",
  CAN_USE_INBOX: "CAN_USE_INBOX",
  CAN_USE_PEOPLEIQ: "CAN_USE_PEOPLEIQ",
  CAN_USE_PROSPECTORIQ: "CAN_USE_PROSPECTORIQ",
  CAN_USE_SALES_DOCUMENTS: "CAN_USE_SALES_DOCUMENTS",
  CAN_VIEW_SHARED_EMAILS: "CAN_VIEW_SHARED_EMAILS",
} as const;
export type Permission = typeof Permission[keyof typeof Permission];

/**
 * Nutshell addon plans
 */
export const PlanType = {
  INBOX: "INBOX",
  REVENUE_BOOSTER: "REVENUE_BOOSTER",
} as const;
export type PlanType = typeof PlanType[keyof typeof PlanType];

/**
 * The type of the product (Good or Service)
 */
export const ProductType = {
  GOOD: "GOOD",
  SERVICE: "SERVICE",
} as const;
export type ProductType = typeof ProductType[keyof typeof ProductType];

export const QuickbooksCustomerPreparationStatus = {
  LINKED: "LINKED",
  MATCHED: "MATCHED",
  MISSING: "MISSING",
  NEW: "NEW",
} as const;
export type QuickbooksCustomerPreparationStatus = typeof QuickbooksCustomerPreparationStatus[keyof typeof QuickbooksCustomerPreparationStatus];

export const QuickbooksProductsPreparationStatus = {
  BLOCKED: "BLOCKED",
  EMPTY: "EMPTY",
  LINKED: "LINKED",
  MIXED: "MIXED",
  NEW: "NEW",
} as const;
export type QuickbooksProductsPreparationStatus = typeof QuickbooksProductsPreparationStatus[keyof typeof QuickbooksProductsPreparationStatus];

export const QuickbooksSyncProductsExecutionMode = {
  BACKGROUND: "BACKGROUND",
  SYNCHRONOUS: "SYNCHRONOUS",
} as const;
export type QuickbooksSyncProductsExecutionMode = typeof QuickbooksSyncProductsExecutionMode[keyof typeof QuickbooksSyncProductsExecutionMode];

export const QuoteAcceptanceOption = {
  CLICK: "CLICK",
  CONTRACT: "CONTRACT",
  SIGNATURE: "SIGNATURE",
} as const;
export type QuoteAcceptanceOption = typeof QuoteAcceptanceOption[keyof typeof QuoteAcceptanceOption];

/**
 * The status of a quote that should be displayed to the user
 */
export const QuoteDisplayStatus = {
  ACCEPTED: "ACCEPTED",
  ARCHIVED: "ARCHIVED",
  DRAFT: "DRAFT",
  EXPIRED: "EXPIRED",
  READY: "READY",
  REVOKED: "REVOKED",
  SENT: "SENT",
} as const;
export type QuoteDisplayStatus = typeof QuoteDisplayStatus[keyof typeof QuoteDisplayStatus];

/**
 * The operation of a quote subtotal line item
 */
export const QuoteLineItemOperation = {
  ADD: "ADD",
  SUBTRACT: "SUBTRACT",
} as const;
export type QuoteLineItemOperation = typeof QuoteLineItemOperation[keyof typeof QuoteLineItemOperation];

/**
 * The unit of a quote subtotal line item
 */
export const QuoteLineItemUnit = {
  FIXED_AMOUNT: "FIXED_AMOUNT",
  PERCENT: "PERCENT",
} as const;
export type QuoteLineItemUnit = typeof QuoteLineItemUnit[keyof typeof QuoteLineItemUnit];

/**
 * A unit of time (month, day, etc)
 */
export const QuoteTerm = {
  DAY: "DAY",
  HOUR: "HOUR",
  MINUTE: "MINUTE",
  MONTH: "MONTH",
  QUARTER: "QUARTER",
  WEEK: "WEEK",
  YEAR: "YEAR",
} as const;
export type QuoteTerm = typeof QuoteTerm[keyof typeof QuoteTerm];

/**
 * The type of reaction for a reaction
 */
export const ReactionType = {
  PARTY_POPPER: "PARTY_POPPER",
  SMILEY_FACE: "SMILEY_FACE",
  THUMBS_DOWN: "THUMBS_DOWN",
  THUMBS_UP: "THUMBS_UP",
} as const;
export type ReactionType = typeof ReactionType[keyof typeof ReactionType];

/**
 * The type of recommendations to generate
 */
export const RecommendationsEnum = {
  SUGGESTIONS: "SUGGESTIONS",
  TOPICS_TO_AVOID: "TOPICS_TO_AVOID",
} as const;
export type RecommendationsEnum = typeof RecommendationsEnum[keyof typeof RecommendationsEnum];

/**
 * The type of a DNS record
 */
export const RecordType = {
  CNAME: "CNAME",
  MX: "MX",
  TXT: "TXT",
} as const;
export type RecordType = typeof RecordType[keyof typeof RecordType];

/**
 * The status for the recording of a Zoom meetings.
 */
export const RecordingStatus = {
  NONE: "NONE",
  PROCESSED: "PROCESSED",
  PROCESSING: "PROCESSING",
  STARTED: "STARTED",
} as const;
export type RecordingStatus = typeof RecordingStatus[keyof typeof RecordingStatus];

/**
 * How the next recurring task due date is calculated.
 */
export const RecurrenceMode = {
  COMPLETION: "COMPLETION",
  DUE_DATE: "DUE_DATE",
} as const;
export type RecurrenceMode = typeof RecurrenceMode[keyof typeof RecurrenceMode];

export const SalesContactType = {
  CHAD: "CHAD",
  JARED: "JARED",
} as const;
export type SalesContactType = typeof SalesContactType[keyof typeof SalesContactType];

/**
 * What order the sales documents (quotes/invoices) should be returned in
 */
export const SalesDocumentSortOrder = {
  MODIFIED_TIME_ASC: "MODIFIED_TIME_ASC",
  MODIFIED_TIME_DESC: "MODIFIED_TIME_DESC",
  VALUE_ASC: "VALUE_ASC",
  VALUE_DESC: "VALUE_DESC",
} as const;
export type SalesDocumentSortOrder = typeof SalesDocumentSortOrder[keyof typeof SalesDocumentSortOrder];

/**
 * Quote or invoice
 */
export const SalesDocumentVariant = {
  INVOICE: "INVOICE",
  QUOTE: "QUOTE",
} as const;
export type SalesDocumentVariant = typeof SalesDocumentVariant[keyof typeof SalesDocumentVariant];

/**
 * Valid params for sorting SavedFilters
 */
export const SavedFilterSortType = {
  CREATED_TIME_DESC: "CREATED_TIME_DESC",
  NAME_ASC: "NAME_ASC",
} as const;
export type SavedFilterSortType = typeof SavedFilterSortType[keyof typeof SavedFilterSortType];

/**
 * Arguments for saved filters
 */
export const SavedFiltersReportType = {
  AUDIENCE: "AUDIENCE",
  DASHBOARD_IFRAME: "DASHBOARD_IFRAME",
  DASHBOARD_LEADERBOARD: "DASHBOARD_LEADERBOARD",
  DASHBOARD_LIST: "DASHBOARD_LIST",
  DASHBOARD_LIST_SUMMARIES: "DASHBOARD_LIST_SUMMARIES",
  DASHBOARD_METRICS: "DASHBOARD_METRICS",
  DASHBOARD_ONBOARDING: "DASHBOARD_ONBOARDING",
  DASHBOARD_PIPELINE: "DASHBOARD_PIPELINE",
  DASHBOARD_QUOTAS: "DASHBOARD_QUOTAS",
  ENTITY_LIST_ACCOUNTS: "ENTITY_LIST_ACCOUNTS",
  ENTITY_LIST_CONTACTS: "ENTITY_LIST_CONTACTS",
  ENTITY_LIST_LEADS: "ENTITY_LIST_LEADS",
  PROSPECTOR: "PROSPECTOR",
  REPORT_ACTIVITY: "REPORT_ACTIVITY",
  REPORT_ATTRIBUTION: "REPORT_ATTRIBUTION",
  REPORT_CUSTOM: "REPORT_CUSTOM",
  REPORT_EMAIL: "REPORT_EMAIL",
  REPORT_FORECAST: "REPORT_FORECAST",
  REPORT_FUNNEL: "REPORT_FUNNEL",
  REPORT_INSTALLMENTS: "REPORT_INSTALLMENTS",
  REPORT_LOSSES: "REPORT_LOSSES",
  REPORT_NEWLEADS: "REPORT_NEWLEADS",
  REPORT_PRODUCTS: "REPORT_PRODUCTS",
  REPORT_SALES: "REPORT_SALES",
  REPORT_TASKS: "REPORT_TASKS",
} as const;
export type SavedFiltersReportType = typeof SavedFiltersReportType[keyof typeof SavedFiltersReportType];

export const ScheduledReportSourceType = {
  LIST: "LIST",
  OTHER: "OTHER",
  REPORT: "REPORT",
} as const;
export type ScheduledReportSourceType = typeof ScheduledReportSourceType[keyof typeof ScheduledReportSourceType];

export const SchedulerAccessType = {
  FULL_ACCESS: "FULL_ACCESS",
  LITE_ACCESS: "LITE_ACCESS",
  NO_ACCESS: "NO_ACCESS",
} as const;
export type SchedulerAccessType = typeof SchedulerAccessType[keyof typeof SchedulerAccessType];

/**
 * The status of the Inbox phone number.
 */
export const SendabilityStatus = {
  CHANNEL_BLOCKED: "CHANNEL_BLOCKED",
  CHANNEL_INVALID: "CHANNEL_INVALID",
  CHATBOT_MANAGED: "CHATBOT_MANAGED",
  MESSAGING_WINDOW_EXPIRED: "MESSAGING_WINDOW_EXPIRED",
  NOT_ASSIGNED: "NOT_ASSIGNED",
  NOT_ENABLED: "NOT_ENABLED",
  RINGCENTRAL_NEEDS_RECONNECT: "RINGCENTRAL_NEEDS_RECONNECT",
  THREAD_CLOSED: "THREAD_CLOSED",
} as const;
export type SendabilityStatus = typeof SendabilityStatus[keyof typeof SendabilityStatus];

/**
 * The type of a smart sequence node.
 */
export const SmartSequenceNodeType = {
  ADD_AUDIENCE: "ADD_AUDIENCE",
  ADD_TAG: "ADD_TAG",
  CREATE_LEAD: "CREATE_LEAD",
  DECISION: "DECISION",
  DECISION_CUSTOM_FIELD_IS_SET: "DECISION_CUSTOM_FIELD_IS_SET",
  DECISION_CUSTOM_FIELD_VALUE: "DECISION_CUSTOM_FIELD_VALUE",
  DECISION_FORM_COMPLETED: "DECISION_FORM_COMPLETED",
  DECISION_PAGE_VIEWED: "DECISION_PAGE_VIEWED",
  DECISION_PREVIOUS_EMAIL_CLICKED: "DECISION_PREVIOUS_EMAIL_CLICKED",
  DECISION_PREVIOUS_EMAIL_OPENED: "DECISION_PREVIOUS_EMAIL_OPENED",
  DECISION_REPLY_RECEIVED: "DECISION_REPLY_RECEIVED",
  DECISION_SPECIFIC_LINK_CLICKED: "DECISION_SPECIFIC_LINK_CLICKED",
  DECISION_TAG_ON_CONTACT: "DECISION_TAG_ON_CONTACT",
  END: "END",
  REMOVE_AUDIENCE: "REMOVE_AUDIENCE",
  REMOVE_TAG: "REMOVE_TAG",
  SEND_EMAIL: "SEND_EMAIL",
  START: "START",
  START_SEQUENCE: "START_SEQUENCE",
  WAIT: "WAIT",
} as const;
export type SmartSequenceNodeType = typeof SmartSequenceNodeType[keyof typeof SmartSequenceNodeType];

/**
 * Which branch of a decision node this node is a child of.
 */
export const SmartSequenceParentBranch = {
  NO: "NO",
  YES: "YES",
} as const;
export type SmartSequenceParentBranch = typeof SmartSequenceParentBranch[keyof typeof SmartSequenceParentBranch];

/**
 * A code-driven smart sequence template to create from.
 */
export const SmartSequenceTemplate = {
  HAS_TAG_BRANCH: "HAS_TAG_BRANCH",
} as const;
export type SmartSequenceTemplate = typeof SmartSequenceTemplate[keyof typeof SmartSequenceTemplate];

/**
 * Deliverability statuses for a phone number
 */
export const SmsDeliverabilityStatusType = {
  DELIVERABLE: "DELIVERABLE",
  OPTED_OUT: "OPTED_OUT",
  UNDELIVERABLE: "UNDELIVERABLE",
} as const;
export type SmsDeliverabilityStatusType = typeof SmsDeliverabilityStatusType[keyof typeof SmsDeliverabilityStatusType];

/**
 * Is the SMTP connection verified, unverified, or did it fail?
 */
export const SmtpConnectionVerificationStatus = {
  FAILED: "FAILED",
  UNVERIFIED: "UNVERIFIED",
  VERIFIED: "VERIFIED",
} as const;
export type SmtpConnectionVerificationStatus = typeof SmtpConnectionVerificationStatus[keyof typeof SmtpConnectionVerificationStatus];

/**
 * What type of port is this connection using? Either SSL or TLS
 */
export const SmtpPortType = {
  SSL: "SSL",
  TLS: "TLS",
} as const;
export type SmtpPortType = typeof SmtpPortType[keyof typeof SmtpPortType];

/**
 * Status of a snippet test
 */
export const SnippetTestStatusEnum = {
  NOT_ON_WEBSITE: "NOT_ON_WEBSITE",
  ON_WEBSITE_CUSTOM_DOMAIN: "ON_WEBSITE_CUSTOM_DOMAIN",
  ON_WEBSITE_NS_DOMAIN: "ON_WEBSITE_NS_DOMAIN",
} as const;
export type SnippetTestStatusEnum = typeof SnippetTestStatusEnum[keyof typeof SnippetTestStatusEnum];

export const SocialPlatform = {
  ANGELLIST: "ANGELLIST",
  BEHANCE: "BEHANCE",
  DELICIOUS: "DELICIOUS",
  DIGG: "DIGG",
  DRIBBLE: "DRIBBLE",
  FACEBOOK: "FACEBOOK",
  FLICKR: "FLICKR",
  FOURSQUARE: "FOURSQUARE",
  GITHUB: "GITHUB",
  GOOGLE_PLUS: "GOOGLE_PLUS",
  HACKER_NEWS: "HACKER_NEWS",
  INSTAGRAM: "INSTAGRAM",
  LASTFM: "LASTFM",
  LINKEDIN: "LINKEDIN",
  PINTEREST: "PINTEREST",
  REDDIT: "REDDIT",
  TUMBLR: "TUMBLR",
  TWITCH: "TWITCH",
  TWITTER: "TWITTER",
  VIMEO: "VIMEO",
  VINE: "VINE",
  X: "X",
  YOUTUBE: "YOUTUBE",
} as const;
export type SocialPlatform = typeof SocialPlatform[keyof typeof SocialPlatform];

/**
 * The order of items based on created time
 */
export const SortOrder = {
  ASC: "ASC",
  DESC: "DESC",
} as const;
export type SortOrder = typeof SortOrder[keyof typeof SortOrder];

/**
 * Valid params for sorting Sources
 */
export const SourceSortType = {
  NAME_ASC: "NAME_ASC",
  NAME_DESC: "NAME_DESC",
} as const;
export type SourceSortType = typeof SourceSortType[keyof typeof SourceSortType];

export const SourceType = {
  CAMPAIGN: "CAMPAIGN",
  CONTENT: "CONTENT",
  MEDIUM: "MEDIUM",
  NONE: "NONE",
  REFERRER: "REFERRER",
  SOURCE: "SOURCE",
  TERM: "TERM",
} as const;
export type SourceType = typeof SourceType[keyof typeof SourceType];

/**
 * Spam prevention type configured for a form
 */
export const SpamPreventionType = {
  SPAM_PREVENTION_ALWAYS_ON: "SPAM_PREVENTION_ALWAYS_ON",
  SPAM_PREVENTION_MOSTLY_INVISIBLE: "SPAM_PREVENTION_MOSTLY_INVISIBLE",
  SPAM_PREVENTION_OFF: "SPAM_PREVENTION_OFF",
} as const;
export type SpamPreventionType = typeof SpamPreventionType[keyof typeof SpamPreventionType];

export const StagesetStarterCategory = {
  INDUSTRY: "INDUSTRY",
  SALES: "SALES",
} as const;
export type StagesetStarterCategory = typeof StagesetStarterCategory[keyof typeof StagesetStarterCategory];

export const StagesetStarterPreviewDripSequenceStatus = {
  ACTIVE: "ACTIVE",
  DRAFT: "DRAFT",
} as const;
export type StagesetStarterPreviewDripSequenceStatus = typeof StagesetStarterPreviewDripSequenceStatus[keyof typeof StagesetStarterPreviewDripSequenceStatus];

/**
 * The type of stageset starter to create.
 */
export const StagesetStarterType = {
  CONSULTING: "CONSULTING",
  ENTERPRISE_SALES: "ENTERPRISE_SALES",
  FAST_TOUCH_INBOUND: "FAST_TOUCH_INBOUND",
  MANUFACTURING: "MANUFACTURING",
  OUTBOUND_PROSPECTING: "OUTBOUND_PROSPECTING",
  QUOTE_AND_INVOICE_SELLING: "QUOTE_AND_INVOICE_SELLING",
  RENEWALS: "RENEWALS",
  SAAS: "SAAS",
} as const;
export type StagesetStarterType = typeof StagesetStarterType[keyof typeof StagesetStarterType];

/**
 * The stageset statuses.
 */
export const StagesetStatus = {
  ACTIVE: "ACTIVE",
  DRAFT: "DRAFT",
  RETIRED: "RETIRED",
} as const;
export type StagesetStatus = typeof StagesetStatus[keyof typeof StagesetStatus];

/**
 * Who can view a stageset and its leads: everyone, or a specific allow-list of users and teams.
 */
export const StagesetVisibilityMode = {
  EVERYONE: "EVERYONE",
  RESTRICTED: "RESTRICTED",
} as const;
export type StagesetVisibilityMode = typeof StagesetVisibilityMode[keyof typeof StagesetVisibilityMode];

/**
 * The type of start trigger. This is strictly used for UI purposes, and is inferred from the start triggers’s conditions.
 */
export const StartTriggerType = {
  ADD_TAG: "ADD_TAG",
  ADD_TO_AUDIENCE: "ADD_TO_AUDIENCE",
  LEAD_CLOSED: "LEAD_CLOSED",
  LEAD_CREATED: "LEAD_CREATED",
  LEAD_STAGE_ENTERED: "LEAD_STAGE_ENTERED",
} as const;
export type StartTriggerType = typeof StartTriggerType[keyof typeof StartTriggerType];

/**
 * The operational status of the analytics configuration.
 */
export const Status = {
  CONFIGURED: "CONFIGURED",
  NEVER_CONFIGURED: "NEVER_CONFIGURED",
  NEW_VERSION_AVAILABLE: "NEW_VERSION_AVAILABLE",
  NOT_WORKING: "NOT_WORKING",
} as const;
export type Status = typeof Status[keyof typeof Status];

/**
 * The different statuses associated with a request for suggested replies
 */
export const SuggestedReplyStatus = {
  ALREADY_ACCEPTED: "ALREADY_ACCEPTED",
  DISABLED: "DISABLED",
  ERROR: "ERROR",
  FEATURE_FLAGGED: "FEATURE_FLAGGED",
  NOT_SUPPORTED: "NOT_SUPPORTED",
  SUCCESS: "SUCCESS",
} as const;
export type SuggestedReplyStatus = typeof SuggestedReplyStatus[keyof typeof SuggestedReplyStatus];

/**
 * The potential suite types.
 */
export const SuiteType = {
  engagement: "engagement",
  marketing: "marketing",
  sales: "sales",
} as const;
export type SuiteType = typeof SuiteType[keyof typeof SuiteType];

/**
 * The type of summary
 */
export const SummaryType = {
  CALL: "CALL",
  ENTITY_CONTEXT: "ENTITY_CONTEXT",
  LEAD_RESEARCH: "LEAD_RESEARCH",
  MEETING: "MEETING",
  TIMELINE: "TIMELINE",
} as const;
export type SummaryType = typeof SummaryType[keyof typeof SummaryType];

/**
 * The type of sync this calendar is used for. Can be conflict, primary, or none if it is not currently in use
 */
export const SyncType = {
  CONFLICT: "CONFLICT",
  NONE: "NONE",
  PRIMARY: "PRIMARY",
} as const;
export type SyncType = typeof SyncType[keyof typeof SyncType];

/**
 * The potential colors for a tag.
 */
export const TagColor = {
  COLOR_BLUE: "COLOR_BLUE",
  COLOR_BLUE_LT: "COLOR_BLUE_LT",
  COLOR_DEFAULT: "COLOR_DEFAULT",
  COLOR_GREEN: "COLOR_GREEN",
  COLOR_GREEN_LT: "COLOR_GREEN_LT",
  COLOR_GREY: "COLOR_GREY",
  COLOR_ORANGE: "COLOR_ORANGE",
  COLOR_ORANGE_LT: "COLOR_ORANGE_LT",
  COLOR_PURPLE: "COLOR_PURPLE",
  COLOR_PURPLE_LT: "COLOR_PURPLE_LT",
  COLOR_RED: "COLOR_RED",
  COLOR_RED_LT: "COLOR_RED_LT",
  COLOR_YELLOW: "COLOR_YELLOW",
  COLOR_YELLOW_LT: "COLOR_YELLOW_LT",
} as const;
export type TagColor = typeof TagColor[keyof typeof TagColor];

/**
 * The different types that can be associated with a tag
 */
export const TagType = {
  ACCOUNT: "ACCOUNT",
  CONTACT: "CONTACT",
  LEAD: "LEAD",
} as const;
export type TagType = typeof TagType[keyof typeof TagType];

/**
 * The user-facing type for a form label’s text alignment
 */
export const TextAlignType = {
  center: "center",
  left: "left",
  right: "right",
} as const;
export type TextAlignType = typeof TextAlignType[keyof typeof TextAlignType];

/**
 * The bot status of a thread
 */
export const ThreadBotStatus = {
  BOT_DISABLED: "BOT_DISABLED",
  BOT_ENABLED: "BOT_ENABLED",
} as const;
export type ThreadBotStatus = typeof ThreadBotStatus[keyof typeof ThreadBotStatus];

/**
 * The status of a thread
 */
export const ThreadStatus = {
  ARCHIVED: "ARCHIVED",
  AWAITING_REPLY: "AWAITING_REPLY",
  CLOSED: "CLOSED",
  FAILED: "FAILED",
  OPEN: "OPEN",
  SCHEDULED: "SCHEDULED",
  SNOOZED: "SNOOZED",
  SPAM: "SPAM",
  UNASSIGNED: "UNASSIGNED",
} as const;
export type ThreadStatus = typeof ThreadStatus[keyof typeof ThreadStatus];

/**
 * The type of a thread
 */
export const ThreadType = {
  CHAT: "CHAT",
  EMAIL: "EMAIL",
  INSTAGRAM: "INSTAGRAM",
  MESSENGER: "MESSENGER",
  SMS: "SMS",
  WHATSAPP: "WHATSAPP",
} as const;
export type ThreadType = typeof ThreadType[keyof typeof ThreadType];

/**
 * The tone of the email template
 */
export const ToneType = {
  CLASSIC: "CLASSIC",
  MINIMAL: "MINIMAL",
  MODERN: "MODERN",
} as const;
export type ToneType = typeof ToneType[keyof typeof ToneType];

/**
 * The identifier for the feature item on the tracking snippet page
 */
export const TrackingSnippetPageFeatureListItemKey = {
  chat: "chat",
  connectedForms: "connectedForms",
  leadAttribution: "leadAttribution",
  nutshellForms: "nutshellForms",
  trafficAnalysis: "trafficAnalysis",
  visitorIq: "visitorIq",
} as const;
export type TrackingSnippetPageFeatureListItemKey = typeof TrackingSnippetPageFeatureListItemKey[keyof typeof TrackingSnippetPageFeatureListItemKey];

/**
 * The status for the recording of a Zoom meetings.
 */
export const TranscriptionStatus = {
  FAILED: "FAILED",
  NONE: "NONE",
  PROCESSED: "PROCESSED",
  PROCESSING: "PROCESSING",
} as const;
export type TranscriptionStatus = typeof TranscriptionStatus[keyof typeof TranscriptionStatus];

/**
 * The type of this trigger.
 */
export const TriggerType = {
  ADD_TAG: "ADD_TAG",
  ADD_TO_AUDIENCE: "ADD_TO_AUDIENCE",
  DRIP_PROGRESSED: "DRIP_PROGRESSED",
  EMAIL_OPENED: "EMAIL_OPENED",
  EMAIL_REPLY_RECEIVED: "EMAIL_REPLY_RECEIVED",
  ENTITY_CHANGED: "ENTITY_CHANGED",
  FORM_SUBMISSION_MAPPED: "FORM_SUBMISSION_MAPPED",
  LEAD_CLOSED: "LEAD_CLOSED",
  LEAD_WON: "LEAD_WON",
  LINK_CLICKED: "LINK_CLICKED",
  PAGE_VIEWED: "PAGE_VIEWED",
} as const;
export type TriggerType = typeof TriggerType[keyof typeof TriggerType];

/**
 * The source for an unsubscribe.
 */
export const UnsubscribeSource = {
  IMPORT: "IMPORT",
  LIST_UNSUBSCRIBE: "LIST_UNSUBSCRIBE",
  NUTSHELL_USER: "NUTSHELL_USER",
  RECIPIENT_LINK: "RECIPIENT_LINK",
  UNKNOWN: "UNKNOWN",
} as const;
export type UnsubscribeSource = typeof UnsubscribeSource[keyof typeof UnsubscribeSource];

/**
 * The different statuses associated with a user email
 */
export const UserEmailType = {
  GOOGLE: "GOOGLE",
  GOOGLE_APPS: "GOOGLE_APPS",
  OFFICE365: "OFFICE365",
  SMTP: "SMTP",
  UNCONFIGURED: "UNCONFIGURED",
} as const;
export type UserEmailType = typeof UserEmailType[keyof typeof UserEmailType];

export const ValidityIssueType = {
  CALENDAR_DISCONNECTED: "CALENDAR_DISCONNECTED",
  O365_GOOGLE_MEET: "O365_GOOGLE_MEET",
  TEAMS_NOT_ENABLED: "TEAMS_NOT_ENABLED",
  USER_REMOVED: "USER_REMOVED",
  ZOOM_NOT_ENABLED: "ZOOM_NOT_ENABLED",
} as const;
export type ValidityIssueType = typeof ValidityIssueType[keyof typeof ValidityIssueType];

/**
 * The different statuses associated with WhatsApp sync progress
 */
export const WhatsAppSyncStatusEnum = {
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  IN_PROGRESS: "IN_PROGRESS",
  NOT_STARTED: "NOT_STARTED",
} as const;
export type WhatsAppSyncStatusEnum = typeof WhatsAppSyncStatusEnum[keyof typeof WhatsAppSyncStatusEnum];

/**
 * The different types of widgets available in Nutshell.
 */
export const WidgetEntityType = {
  ACCOUNT: "ACCOUNT",
  CONTACT: "CONTACT",
  LEAD: "LEAD",
} as const;
export type WidgetEntityType = typeof WidgetEntityType[keyof typeof WidgetEntityType];

/**
 * The different locations where widgets can be added.
 */
export const WidgetLocation = {
  SIDEBAR: "SIDEBAR",
  WORKSPACE: "WORKSPACE",
} as const;
export type WidgetLocation = typeof WidgetLocation[keyof typeof WidgetLocation];

/**
 * The different types of widgets available in Nutshell.
 */
export const WidgetType = {
  ACTIVITIES: "ACTIVITIES",
  AI_SUMMARY: "AI_SUMMARY",
  ALL_CUSTOM_FIELDS: "ALL_CUSTOM_FIELDS",
  ATTACHMENTS: "ATTACHMENTS",
  AUDIENCES: "AUDIENCES",
  AUTOMATED_EMAILS: "AUTOMATED_EMAILS",
  BUSINESS_CARD: "BUSINESS_CARD",
  CHILD_LEADS: "CHILD_LEADS",
  COMPANIES_AND_PEOPLE: "COMPANIES_AND_PEOPLE",
  COMPANY_HIERARCHY: "COMPANY_HIERARCHY",
  COMPETITORS: "COMPETITORS",
  CUSTOM_CUSTOM_FIELDS: "CUSTOM_CUSTOM_FIELDS",
  EMAIL_ENGAGEMENT: "EMAIL_ENGAGEMENT",
  FORMS: "FORMS",
  LEADS: "LEADS",
  LEAD_RESEARCHER: "LEAD_RESEARCHER",
  RELATED_ACCOUNTS: "RELATED_ACCOUNTS",
  RELATED_CONTACTS: "RELATED_CONTACTS",
  REVENUE: "REVENUE",
  SALES_DOCUMENTS: "SALES_DOCUMENTS",
  SALES_PROCESS: "SALES_PROCESS",
  SOURCES: "SOURCES",
  SUMMARY: "SUMMARY",
  TASKS: "TASKS",
} as const;
export type WidgetType = typeof WidgetType[keyof typeof WidgetType];

/**
 * The input data for the accountCreate mutation
 */
export interface AccountCreateInput {
  name: string;
  parentAccountId?: string | null;
  childAccountIds?: string[] | null;
  description?: string | null;
  addresses?: PeepAddressInput[] | null;
  leads?: EntityRelatedEntityInput[] | null;
  contacts?: EntityRelatedEntityInput[] | null;
}

export interface AccountEnrichmentRespondInput {
  accountId: string;
  response: EnrichmentResponse;
}

export interface AccountFileAddInput {
  account: string;
  files: NutFileInput[];
}

export interface AccountFileRemoveInput {
  account: string;
  fileId: string;
}

/**
 * Input data for AccountParentRemove mutation.
 */
export interface AccountParentRemoveInput {
  accountId: string;
}

/**
 * The input data for the accountParentSet mutation.
 */
export interface AccountParentSetInput {
  accountId: string;
  parentAccountId: string;
}

export interface AccountPdlContactsAddInput {
  accountId: string;
  pdlContactIds?: string[] | null;
  leadId?: string | null;
}

/**
 * The input data for updating a Nutshell Account
 */
export interface AccountUpdateInput {
  accountId: string;
  name?: string | null;
  description?: string | null;
  phones?: PeepPhoneNumberInput[] | null;
  emailAddresses?: NutEmailAddressInput[] | null;
  urls?: PeepUrlInput[] | null;
  addresses?: PeepAddressInput[] | null;
  customFields?: EntityCustomFieldInput[] | null;
  revenue?: number | null;
  employeeCount?: number | null;
  accountTypeId?: string | null;
  territoryId?: string | null;
  assigneeId?: string | null;
  industryId?: string | null;
  tags?: TagInput[] | null;
  leads?: EntityRelatedEntityInput[] | null;
  avatarFile?: NutFileInput | null;
  isDeleted?: boolean | null;
  contacts?: EntityRelatedEntityInput[] | null;
  legacyId?: string | null;
}

/**
 * The input data for the AccountsMarkNotDupe mutation
 */
export interface AccountsMarkNotDupeInput {
  accountIds: string[];
}

export interface AccountsMergeInput {
  winnerAccountId: string;
  accountIdsToMerge: string[];
}

/**
 * An action definition that runs as a result of a Nutshell automation.
 */
export interface ActionConfigInput {
  addTagIds?: string[] | null;
  addAudienceIds?: string[] | null;
  removeAudienceIds?: string[] | null;
  notifiables?: string[] | null;
  dripSequenceId?: string | null;
  createLead?: CreateLeadActionConfigInput | null;
}

/**
 * A action definition to activate a Nutshell automation.
 */
export interface ActionInput {
  position?: number | null;
  name?: string | null;
  description?: string | null;
  config: ActionConfigInput;
}

export interface ActivityCalendarInput {
  startTime: any;
  endTime: any;
  timeZone?: string | null;
  allDay: boolean;
  location?: string | null;
  participants: string[];
  agenda: string;
  conferenceData?: ConferenceDataInput | null;
}

export interface ActivityCreateInput {
  name: string;
  isLogged: boolean;
  activityType: string;
  logNote?: string | null;
  isFlagged: boolean;
  isForceSync: boolean;
  calendar: ActivityCalendarInput;
  relatedLeadIds: string[];
  createdFromLead: boolean;
  previousActivity?: string | null;
  publicSync?: boolean | null;
}

export interface ActivityCreateOrMergeContactFromExternalAttendeeInput {
  activityId: string;
  externalAttendeeId: string;
  contactId?: string | null;
  name?: string | null;
  email?: string | null;
  phone?: string | null;
}

/**
 * Input for fetching activity defaults
 */
export interface ActivityDefaultsInput {
  relatedEntityId?: string | null;
  activityTypeId?: string | null;
  durationMinutes?: number | null;
  note?: string | null;
}

export interface ActivityDeleteInput {
  activity: string;
  removeFromSyncedCalendar: boolean;
}

export interface ActivityRecordingDeleteInput {
  activity: string;
  recordingFileId: string;
}

/**
 * The input data for the ActivitySummarize mutation
 */
export interface ActivitySummarizeInput {
  activityId: string;
}

/**
 * The input data for the ActivityTranscribeCall mutation.
 */
export interface ActivityTranscribeCallInput {
  activityId: string;
}

export interface ActivityTypeCreateInput {
  name: string;
  icon?: ActivityTypeIcon | null;
}

export interface ActivityTypeDeleteInput {
  id: string;
}

export interface ActivityTypeUpdateInput {
  id: string;
  name?: string | null;
  icon?: ActivityTypeIcon | null;
}

export interface ActivityUpdateInput {
  activity: string;
  name?: string | null;
  isLogged?: boolean | null;
  activityType?: string | null;
  logNote?: string | null;
  isFlagged?: boolean | null;
  isForceSync?: boolean | null;
  calendar?: ActivityCalendarInput | null;
  relatedLeadIds?: string[] | null;
  externalAttendees?: string[] | null;
  publicSync?: boolean | null;
}

export interface AddEntityToAudienceInput {
  audienceId: string;
  contactId?: string | null;
  entityId?: string | null;
  onlyAddPrimaryContact?: boolean | null;
}

export interface AddModalFieldsUpdateInput {
  entityType: EntityType;
  fields: SelectableFieldInput[];
}

/**
 * An add-on that has been selected on the plan picker
 */
export interface AddOnSelection {
  product: BillingProductType;
  planCode: string;
  quantity?: number | null;
}

export interface AddressInfoInput {
  address1: string;
  address2?: string | null;
  city: string;
  state: string;
  postalCode: string;
  country: string;
}

export interface AgentStatusUpdateInput {
  userId: string;
  agentStatus: AgentStatusEnum;
}

export interface AiAssistantConversation {
  assistantId: string;
  messages: AiAssistantMessage[];
}

export interface AiAssistantMessage {
  externalId: string;
  role: AiAssistantRole;
  content: string;
  timestamp: string;
}

export interface AiBroadcastAcceptAndConvertInput {
  campaignId: string;
}

export interface AiEmailTemplateAcceptInput {
  selectedEditionId: string;
  targetCampaignId: string;
  targetType: AiTemplateAcceptTargetType;
}

export interface AiEmailTemplateGenerateFromTemplateInput {
  userPrompt: string;
  websiteUrl: string;
  originalCampaignId?: string | null;
}

export interface AiEmailTemplateGenerateInput {
  userPrompt: string;
  websiteUrl: string;
}

export interface AiEmailTemplateRegenerateFromTemplateInput {
  originalCampaignId?: string | null;
  campaignId: string;
  userPrompt: string;
  websiteUrl: string;
}

export interface AiEmailTemplateRegenerateInput {
  campaignId: string;
  userPrompt: string;
  tone: ToneType;
  columns: ColumnType;
  websiteUrl: string;
}

export interface AnswerChoiceRulesInput {
  answerChoiceId: string;
  assignmentObjectsApiIds: string[];
}

export interface AssignLeadInputFieldInput {
  id: string;
  assigneeId?: string | null;
}

export interface AudienceCreateInput {
  audience: AudienceCreateInputAudience;
}

export interface AudienceCreateInputAudience {
  name: string;
  description?: string | null;
}

/**
 * The input data for the deleteAudience mutation.
 */
export interface AudienceDeleteInput {
  id: string;
}

export interface AudienceMemberDeleteInput {
  audienceMemberId: string;
}

/**
 * The input data for the AudienceUpdate mutation.
 */
export interface AudienceUpdateInput {
  audienceId: string;
  name?: string | null;
  publicName?: string | null;
  description?: string | null;
  publicDescription?: string | null;
  isPublic?: boolean | null;
}

/**
 * The input data for the AvailabilitySet mutation
 */
export interface AvailabilitySetInput {
  id: string;
  newTimes: AvailabilityTimeInput[];
}

/**
 * The input data for a single availability time
 */
export interface AvailabilityTimeInput {
  day: AvailabilityDay;
  startTime: string;
  endTime: string;
}

export interface BillingInfoUpdateInput {
  recurlyToken?: string | null;
  paymentType: string;
  agree: boolean;
  addressInfo: AddressInfoInput;
  contactInfo: ContactInfoInput;
}

export interface BookingActionInput {
  label?: string | null;
  isEnabled?: boolean | null;
  openingMessage?: string | null;
  meetingId?: string | null;
  formConfirmationMessage?: string | null;
  shouldCreateLeads?: boolean | null;
  shouldCreateLeadsPipelineId?: string | null;
}

/**
 * The input data for the BookingCancel mutation.
 */
export interface BookingCancelInput {
  id: string;
  optionalMessage?: string | null;
}

/**
 * The input data for the BookingDelete mutation.
 */
export interface BookingDeleteInput {
  id: string;
}

export interface BookingsInput {
  first?: number | null;
  after?: string | null;
  last?: number | null;
  before?: string | null;
  meetingId: string;
  sort?: BookingSortOrder | null;
}

export interface BootSnippetDomainSetInput {
  domainId?: string | null;
}

export interface BroadcastCreateInput {
  name: string;
  isABTested?: boolean | null;
  fieldsToCompare?: FieldsToCompare | null;
}

export interface CachePlanSelectionInput {
  crm?: CachedPlanInput | null;
  marketingSuite?: CachedPlanInput | null;
  inbox?: CachedPlanInput | null;
  marketing?: CachedPlanInput | null;
  nutshellIq?: CachedPlanInput | null;
  smsCampaigns?: CachedPlanInput | null;
  quotes?: CachedPlanInput | null;
  nutshellAdvisor?: CachedPlanInput | null;
}

export interface CachedPlanInput {
  planCode: string;
  licenseCount?: number | null;
}

export interface CallActionInput {
  label?: string | null;
  isEnabled?: boolean | null;
  openingMessage?: string | null;
  shouldLinkNumber?: boolean | null;
  linkNumberConfig?: LinkNumberConfigInput | null;
  formSlug?: string | null;
  formConfirmationMessage?: string | null;
  shouldCreateLeads?: boolean | null;
  shouldCreateLeadsPipelineId?: string | null;
}

export interface CallRailIntegrationAssignPhoneNumberInput {
  phoneNumber: string;
}

/**
 * The input data for the callRailIntegrationCreate mutation.
 */
export interface CallRailIntegrationCreateInput {
  apiKey: string;
  accountId: string;
  companyId: string;
  phoneNumbers?: string[] | null;
}

export interface CallRailIntegrationUnassignPhoneNumberInput {
  phoneNumber: string;
}

/**
 * The input data for the callRailIntegrationUpdate mutation.
 */
export interface CallRailIntegrationUpdateInput {
  signingKey: string;
}

/**
 * The input data for the CampaignDelete mutation.
 */
export interface CampaignDeleteInput {
  id: string;
}

/**
 * The input data for the campaignSetOwner mutation.
 */
export interface CampaignSetOwnerInput {
  userId?: string | null;
  campaignId: string;
}

/**
 * The input data for the CampaignUpdate mutation.
 */
export interface CampaignUpdateInput {
  id: string;
  name?: string | null;
  fromAddressId?: string | null;
  isBusinessHoursOnly?: boolean | null;
  isStopOnGoal?: boolean | null;
  isStopOnLeadClose?: boolean | null;
  useUtmParameters?: boolean | null;
  utmSource?: string | null;
  utmMedium?: string | null;
}

export interface ChatActionInput {
  label?: string | null;
  isEnabled?: boolean | null;
  openingMessage?: string | null;
  shouldCreateLeads?: boolean | null;
  shouldCreateLeadsPipelineId?: string | null;
}

export interface ChatBusinessCardLogoUpdateInput {
  imageUrl: string;
}

export interface ChatSettingsActionsInput {
  chat?: ChatActionInput | null;
  booking?: BookingActionInput | null;
  email?: EmailActionInput | null;
  call?: CallActionInput | null;
  text?: TextActionInput | null;
  quote?: QuoteActionInput | null;
}

export interface ChatSettingsAppModeInput {
  homepageSettings?: ChatSettingsHomepageInput | null;
  businessCardSettings?: ChatSettingsBusinessCardInput | null;
  autoOpenView?: ChatAutoOpenEnum | null;
}

export interface ChatSettingsAssignmentInput {
  assignmentStrategy?: ChatAssignmentStrategyEnum | null;
  assignmentSpecificUserId?: string | null;
}

export interface ChatSettingsBusinessCardInput {
  isEnabled?: boolean | null;
  logoUrl?: string | null;
  companyName?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  address?: string | null;
  businessHours?: string | null;
}

export interface ChatSettingsChatbotInput {
  responseTiming?: ChatbotResponseTimingEnum | null;
  name?: string | null;
  iconEnum?: ChatbotIconEnum | null;
  tone?: ChatbotToneEnum | null;
  answerLength?: ChatbotAnswerLengthEnum | null;
  suggestions?: (string | null)[] | null;
  topicsToAvoid?: (string | null)[] | null;
  customAnswers?: CustomAnswerInput[] | null;
}

export interface ChatSettingsDisclaimerInput {
  isEnabled?: boolean | null;
  message?: string | null;
}

export interface ChatSettingsEnableChatInput {
  isChatEnabled: boolean;
}

export interface ChatSettingsGoalsInput {
  schedulerIsEnabled?: boolean | null;
  schedulerMeetingId?: string | null;
  formIsEnabled?: boolean | null;
  formSlug?: string | null;
}

/**
 * Per-action labels displayed on the chat widget homepage
 */
export interface ChatSettingsHomepageActionLabelsInput {
  book?: string | null;
  email?: string | null;
  call?: string | null;
  text?: string | null;
  quote?: string | null;
}

export interface ChatSettingsHomepageInput {
  isEnabled?: boolean | null;
  layout?: ChatHomepageLayoutEnum | null;
  actionLabels?: ChatSettingsHomepageActionLabelsInput | null;
}

export interface ChatSettingsInput {
  lookAndFeel?: ChatSettingsLookAndFeelInput | null;
  intakeForm?: ChatSettingsIntakeFormInput | null;
  offline?: ChatSettingsOfflineInput | null;
  assignment?: ChatSettingsAssignmentInput | null;
  chatbot?: ChatSettingsChatbotInput | null;
  goals?: ChatSettingsGoalsInput | null;
  actions?: ChatSettingsActionsInput | null;
  appMode?: ChatSettingsAppModeInput | null;
}

export interface ChatSettingsIntakeFormInput {
  fields?: ChatSettingsIntakeFormFieldsEnum[] | null;
  message?: string | null;
  type?: ChatSettingsIntakeFormTypeEnum | null;
  shouldCreateLeads?: boolean | null;
  shouldCreateLeadsPipelineId?: string | null;
  allowThreadsWithoutContact?: boolean | null;
  collectionTiming?: IntakeFormCollectionTimingEnum | null;
}

export interface ChatSettingsLookAndFeelInput {
  color?: string | null;
  secondaryColor?: string | null;
  chatVariant?: ChatVariantEnum | null;
  nameDisplay?: string | null;
  chatbotName?: string | null;
  chatbotIconEnum?: ChatbotIconEnum | null;
  nudgeSettings?: ChatSettingsNudgeInput | null;
  conversationStarter?: string | null;
  showPoweredBy?: boolean | null;
  disclaimerSettings?: ChatSettingsDisclaimerInput | null;
  actionBarShownActions?: (ActionBarActionEnum | null)[] | null;
  actionBarHiddenActions?: (ActionBarActionEnum | null)[] | null;
  disabledPaths?: string[] | null;
}

export interface ChatSettingsNudgeInput {
  isEnabled?: boolean | null;
  message?: string | null;
  callToAction?: string | null;
  deviceVisibility?: NudgeDeviceVisibilityEnum | null;
}

export interface ChatSettingsOfflineInput {
  isEnabled?: boolean | null;
  formSlug?: string | null;
  message?: string | null;
  conversationalMessage?: string | null;
  formType?: ChatSettingsOfflineFormTypeEnum | null;
}

/**
 * The input data for the updateSetting mutation.
 */
export interface ChatSettingsUpdateInput {
  chatSettings: ChatSettingsInput;
}

export interface ChatWidgetIconUpdateInput {
  type: ChatIconEnum;
  imageUrl?: string | null;
}

export interface ChurnInfoUpdateFieldInput {
  selectedReasons?: string[] | null;
  additionalComments?: string | null;
  priceDifference?: number | null;
}

/**
 * The input data for the churnInfoUpdate mutation.
 */
export interface ChurnInfoUpdateInput {
  churnInfo: ChurnInfoUpdateFieldInput;
}

/**
 * Notifiables for the link.
 */
export interface ClickNotificationSetInput {
  emailTemplateId: string;
  link: string;
  notifiables?: NotifiablesInput | null;
}

export interface ClickTrackingDomainSetInput {
  domainId?: string | null;
}

/**
 * The input data for the ClosedLeadTagAutomationCreate mutation.
 */
export interface ClosedLeadTagAutomationCreateInput {
  stagesetId: string;
  status: LeadStatus;
  tagIds: string[];
}

/**
 * The input data for the ClosedLeadTagAutomationDelete mutation.
 */
export interface ClosedLeadTagAutomationDeleteInput {
  id: string;
}

/**
 * Input for fetching a closed lead tag automation
 */
export interface ClosedLeadTagAutomationInput {
  automationId?: string | null;
}

/**
 * The input data for the ClosedLeadTagAutomationUpdate mutation.
 */
export interface ClosedLeadTagAutomationUpdateInput {
  actionId: string;
  tagIds: string[];
}

/**
 * A Nutshell relative due date specification for closed lead task templates.
 */
export interface ClosedLeadTaskTemplateDueDateInput {
  dueUnit: DueDateUnit;
  dueTimespan: number;
}

export interface ComparisonInput {
  shouldCompareSubject?: boolean | null;
  shouldComparePreviewText?: boolean | null;
  shouldCompareContent?: boolean | null;
  alternateSubject?: string | null;
  alternatePreviewText?: string | null;
  alternateContent?: string | null;
  fallbackEdition?: ComparisonEditionType | null;
  winningMetric?: ComparisonMetricType | null;
  testPeriodLength?: TimespanInput | null;
  sendPercentage?: number | null;
}

/**
 * Input for toggling an edition between comparison and non-comparison
 */
export interface ComparisonToggleInput {
  editionId: string;
  shouldBeComparison: boolean;
  fieldsToCompare?: FieldsToCompare | null;
}

/**
 * The input data for the SetCompetitorIqWebsitesSettings mutation
 */
export interface CompetitorIqWebsitesSettingsInput {
  website?: string | null;
  competitors?: string[] | null;
}

export interface CompleteStepInputFieldInput {
  id: string;
}

/**
 * A condition definition to activate a Nutshell automation.
 */
export interface ConditionConfigInput {
  filter?: EntityFilterFieldConfigInput | null;
  links?: string[] | null;
  audiences?: string[] | null;
  tags?: string[] | null;
}

/**
 * A condition definition to activate a Nutshell automation.
 */
export interface ConditionInput {
  position?: number | null;
  name?: string | null;
  description?: string | null;
  config: ConditionConfigInput;
  type?: number | null;
}

export interface ConferenceDataInput {
  externalId: string;
  externalUuid: string;
  meetingUrl: string;
  type: ActivityConferenceType;
  isNew?: boolean | null;
}

/**
 * The input data for the ConnectedFormActivate mutation.
 */
export interface ConnectedFormActivateInput {
  wfFormId: string;
}

/**
 * The input data for the ConnectedFormIgnore mutation.
 */
export interface ConnectedFormIgnoreInput {
  wfFormId: string;
}

/**
 * The input data for the ConnectedFormUnignore mutation.
 */
export interface ConnectedFormUnignoreInput {
  wfFormId: string;
}

export interface ConstantContactAddEntityToListInput {
  entityId: string;
  listId: string;
}

export interface ContactCreateByThreadInput {
  threadId: string;
}

/**
 * The input data for the contactCreate mutation.
 */
export interface ContactCreateInput {
  contact: ContactCreateInputFieldInput;
}

export interface ContactCreateInputFieldInput {
  name?: string | null;
  description?: string | null;
  ownerId?: string | null;
  phones?: PeepPhoneNumberInput[] | null;
  emailAddresses?: NutEmailAddressInput[] | null;
  urls?: PeepUrlInput[] | null;
  addresses?: PeepAddressInput[] | null;
  customFields?: EntityCustomFieldInput[] | null;
  accounts?: EntityRelatedEntityInput[] | null;
  leads?: EntityRelatedEntityInput[] | null;
  note?: string | null;
  territoryId?: string | null;
  tags?: TagInput[] | null;
}

export interface ContactCreateValidationInput {
  name?: string | null;
  email?: string | null;
  phone?: string | null;
}

export interface ContactEnrichmentInput {
  id: string;
}

export interface ContactFileAddInput {
  contact: string;
  files: NutFileInput[];
}

export interface ContactFileRemoveInput {
  contact: string;
  fileId: string;
}

export interface ContactInfoInput {
  firstName: string;
  lastName: string;
  companyName: string;
  email: string;
  phone: string;
}

/**
 * The input data for the contactUpdate mutation.
 */
export interface ContactUpdateInput {
  contact: ContactUpdateInputFieldInput;
}

export interface ContactUpdateInputFieldInput {
  id: string;
  name?: string | null;
  ownerId?: string | null;
  createdTime?: any | null;
  description?: string | null;
  phones?: PeepPhoneNumberInput[] | null;
  emailAddresses?: NutEmailAddressInput[] | null;
  urls?: PeepUrlInput[] | null;
  addresses?: PeepAddressInput[] | null;
  customFields?: EntityCustomFieldInput[] | null;
  accounts?: EntityRelatedEntityInput[] | null;
  leads?: EntityRelatedEntityInput[] | null;
  note?: string | null;
  territoryId?: string | null;
  tags?: TagInput[] | null;
  audienceId?: string | null;
  avatarFile?: NutFileInput | null;
  isDeleted?: boolean | null;
  legacyId?: string | null;
}

export interface ContactsCreateFromEmailSyncInput {
  emailAddress: NutEmailAddressInput;
}

/**
 * The input data for the ContactsMarkNotDupe mutation
 */
export interface ContactsMarkNotDupeInput {
  contactIds: string[];
}

export interface ContactsMergeInput {
  winnerContactId: string;
  contactIdsToMerge: string[];
}

export interface ContextDocumentRecrawlInput {
  documentId?: string | null;
}

export interface ContextDocumentRemoveInput {
  documentId: string;
}

export interface ContextDocumentUsageToggleInput {
  documentId: string;
  isEnabled: boolean;
}

export interface ContractCreateInput {
  contractTemplate: string;
  lead: string;
  recipient?: string | null;
}

export interface ContractListInput {
  first?: number | null;
  after?: string | null;
  last?: number | null;
  before?: string | null;
  status?: ContractDisplayStatus | null;
  owner?: string | null;
  sort?: ContractSortOrder | null;
}

export interface ContractTemplateChildrenInput {
  template: string;
  status?: ContractDisplayStatus | null;
  owner?: string | null;
}

/**
 * Input for contractTemplateCreate; sends the Filestack-backed PDF for the template.
 */
export interface ContractTemplateCreateInput {
  templatePdf: NutFileInput;
}

export interface ContractTemplateFieldUpdateInput {
  id?: string | null;
  pageNumber?: number | null;
  fieldName?: string | null;
  entityAttributeId?: string | null;
  entityName?: string | null;
  isRequired: boolean;
  fieldJson?: string | null;
  direction: DocumentFieldDirection;
  type: DocumentFieldType;
  label: string;
  placeholder?: string | null;
}

export interface ContractTemplateListInput {
  archived?: boolean | null;
  owner?: string | null;
  sort?: ContractTemplateSortOrder | null;
  isPublished?: boolean | null;
}

export interface ContractTemplateUpdateInput {
  id: string;
  name?: string | null;
  description?: string | null;
  isTemplatePublished?: boolean | null;
  fields?: ContractTemplateFieldUpdateInput[] | null;
}

export interface ContractUpdateInput {
  id: string;
  name?: string | null;
  validThroughDate?: string | null;
}

export interface ContractUpdateStatusInput {
  id: string;
  status: ContractDisplayStatus;
}

export interface CreateAccountFromMcfxCompanyInput {
  mcfxCompanyId: string;
  createRelatedLead: boolean;
  stagesetId?: string | null;
}

export interface CreateClosedLeadAccountTypeAutomationInputFieldInput {
  stagesetId: string;
  outcomeType: OutcomeType;
  accountTypeId: string;
}

export interface CreateClosedLeadEmailAutomationInputFieldInput {
  stagesetId: string;
  outcomeType: OutcomeType;
  emailListExternalListId: string;
  emailListType: EmailAutomationType;
}

export interface CreateClosedLeadSlackMessageInputFieldInput {
  stagesetId: string;
  channelId: string;
  outcomeType: OutcomeType;
  conditions?: ConditionInput[] | null;
}

export interface CreateClosedLeadTaskTemplateInputFieldInput {
  stagesetId: string;
  outcomeType: OutcomeType;
  name: string;
  description?: string | null;
  assigneeId?: string | null;
  dueDate?: ClosedLeadTaskTemplateDueDateInput | null;
}

export interface CreateCommentInput {
  comment: CreateCommentInputComment;
}

export interface CreateCommentInputComment {
  value: string;
  parentId: string;
}

export interface CreateCustomFieldInputFieldInput {
  entityName: string;
  name: string;
  type: string;
  allowMultiple?: boolean | null;
  choices?: string[] | null;
  description?: string | null;
  pipelines?: string[] | null;
}

export interface CreateEmailAutomationInputFieldInput {
  emailListId: string;
  entersStageId: string;
  exitsStageId?: string | null;
  sendUntilClose?: boolean | null;
  sendFromUserId?: string | null;
  delay?: TimespanInput | null;
  type: EmailAutomationType;
}

export interface CreateGoalInputFieldInput {
  stageId: string;
  description?: string | null;
  type?: GoalType | null;
  conditions: ConditionInput[];
  newLoggedActivityTypes?: string[] | null;
  newScheduledActivityTypes?: string[] | null;
}

/**
 * Configuration for a CREATE_LEAD action in an automation
 */
export interface CreateLeadActionConfigInput {
  stagesetId: string;
  assigneeOrRule: LeadAutomationAssigneeOrRuleInput;
  tagIds?: string[] | null;
}

export interface CreateLeadDistributionAutomationInputFieldInput {
  stagesetId: string;
  conditions: ConditionInput[];
}

export interface CreateNoteInput {
  note: CreateNoteInputNote;
}

export interface CreateNoteInputNote {
  value: string;
  entityId: string;
  isPinned?: boolean | null;
}

export interface CreateOpenLeadSlackMessageInputFieldInput {
  stageId: string;
  conditions?: ConditionInput[] | null;
  channelId: string;
}

export interface CreateStagesetInputFieldInput {
  name: string;
}

export interface CreateStepTemplateInputFieldInput {
  stageId: string;
  name: string;
  description?: string | null;
  assigneeId?: string | null;
  dueDate?: StepDueDateInput | null;
}

export interface CreateTagInput {
  tag: CreateTagInputTag;
}

export interface CreateTagInputTag {
  name: string;
  entityType: EntityType;
  color?: TagColor | null;
}

export interface CsvImportConfigInput {
  fileId: string;
  fileName: string;
  columnMap: (CsvImportMappingInput | null)[];
  updateExisting: boolean;
  matchDuplicateEmail: boolean;
  matchDuplicateName: boolean;
  matchDuplicateCompanyName: boolean;
  matchDuplicateAccountId: boolean;
  matchDuplicateContactId: boolean;
  leadCreate: CreateLeadMode;
  leadCreateForExisting: boolean;
  shouldTagImport: boolean;
  importTag: string;
  audienceId?: string | null;
  unsubscribe?: boolean | null;
  unsubscribeEmailAddressColumnNum?: number | null;
}

export interface CsvImportCreateFieldInput {
  type: EntityCustomFieldType;
  label: string;
  enumValues: string[];
  description?: string | null;
}

export interface CsvImportEnqueueInput {
  csvImportConfig: CsvImportConfigInput;
  importSource?: string | null;
}

export interface CsvImportMappingInput {
  entityName: string;
  fieldName?: string | null;
  fieldKey?: string | null;
  subFieldName?: string | null;
  isEav?: boolean | null;
  parentEntity?: string | null;
  createField?: CsvImportCreateFieldInput | null;
}

export interface CsvImportPrepareInput {
  file: NutFileInput;
  oldImportId?: string | null;
  importSource?: string | null;
}

export interface CsvImportPreviewBulkCreateCountInput {
  columnIndex: number;
  entityName: string;
  fieldName: string;
  createField?: CsvImportCreateFieldInput | null;
}

export interface CsvImportPreviewBulkCreateCountRequestInput {
  fileId: string;
  fileName: string;
  column: CsvImportPreviewBulkCreateCountInput;
}

/**
 * Input for enqueueing CSV import rollback
 */
export interface CsvImportRollbackInput {
  originId: number;
}

export interface CustomAnswerInput {
  question: string;
  answer: string;
  isEnabled: boolean;
}

/**
 * The input data for the CustomFieldConvertToNumber mutation.
 */
export interface CustomFieldConvertToNumberInput {
  id: string;
}

/**
 * The position of the custom field.
 */
export interface CustomFieldPosition {
  fieldId: string;
  position?: number | null;
}

/**
 * The input data for the CustomFieldUndelete mutation
 */
export interface CustomFieldUndeleteInputs {
  id: string;
}

/**
 * The input data for the CustomFieldUpdate mutation.
 */
export interface CustomFieldUpdateInput {
  id: string;
  edits: CustomFieldUpdateInputFieldInput;
}

export interface CustomFieldUpdateInputFieldInput {
  name: string;
  allowMultiple?: boolean | null;
  choices?: string[] | null;
  description?: string | null;
  type?: EntityCustomFieldType | null;
  pipelines?: string[] | null;
}

/**
 * The input data for the CustomFieldUpdatePosition mutation.
 */
export interface CustomFieldUpdatePositionInput {
  fieldPositions: CustomFieldPosition[];
  stagesetId?: string | null;
  entityType: EntityType;
}

/**
 * The set of fields that can be passed when trying to set a currency’s custom field value
 */
export interface CustomFieldValueCurrencyInput {
  currencyShortname: string;
  value: number;
}

/**
 * The set of fields that can be passed when trying to set a currency’s custom field value
 */
export interface CustomFieldValueEmailInput {
  display?: string | null;
  address: string;
}

/**
 * Top-level input object for all custom field values. All of this input objects fields are nullable per-type input objects
 */
export interface CustomFieldValueInput {
  string?: string | null;
  text?: string | null;
  number?: string | null;
  date?: string | null;
  currency?: CustomFieldValueCurrencyInput | null;
  location?: CustomFieldValueLocationInput | null;
  phone?: CustomFieldValuePhoneInput | null;
  enumSingle?: string | null;
  enumMultiple?: string[] | null;
  email?: CustomFieldValueEmailInput | null;
  url?: string | null;
}

/**
 * The set of fields that can be passed when trying to set a location’s custom field value
 */
export interface CustomFieldValueLocationInput {
  address_1?: string | null;
  address_2?: string | null;
  address_3?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  country?: string | null;
}

/**
 * The set of fields that can be passed when trying to set a phone’s custom field value
 */
export interface CustomFieldValuePhoneInput {
  countryCodeAndNumber?: string | null;
  extension?: string | null;
}

export interface CustomFieldWidgetInput {
  name: string;
  fieldIds: string[];
}

export interface CustomFieldsInput {
  entityType: EntityType;
}

export interface DashboardInput {
  timespan: string;
  compareTo?: string | null;
  channelType?: DashboardableChannelType | null;
}

/**
 * The input data for the DelayQueuedEmail mutation
 */
export interface DelayQueuedEmailInput {
  queuedEmail: DelayQueuedEmailInputFieldInput;
}

export interface DelayQueuedEmailInputFieldInput {
  id: string;
  delay: TimespanInput;
}

export interface DeleteAllProgressionsForDripEditionInput {
  editionId: string;
}

export interface DeleteClosedLeadAccountTypeAutomationInputFieldInput {
  id: string;
}

export interface DeleteClosedLeadEmailAutomationInputFieldInput {
  id: string;
}

export interface DeleteClosedLeadSlackMessageInputFieldInput {
  id: string;
}

export interface DeleteClosedLeadTaskTemplateInputFieldInput {
  id: string;
}

/**
 * The input data for the DeleteCustomField mutation
 */
export interface DeleteCustomFieldInput {
  id: string;
}

export interface DeleteEmailAutomationInputFieldInput {
  id: string;
}

/**
 * The input data for the deleteEmail mutation.
 */
export interface DeleteEmailInput {
  email: DeleteEmailInputFieldInput;
  allByAddress?: string | null;
}

export interface DeleteEmailInputFieldInput {
  id: string;
}

/**
 * Options to control how failed emails are deleted.
 */
export interface DeleteFailedEmailsInput {
  limit: number;
}

export interface DeleteGoalInputFieldInput {
  id: string;
}

export interface DeleteLeadDistributionAutomationInputFieldInput {
  id: string;
}

/**
 * The input data for the deleteNote mutation.
 */
export interface DeleteNoteInput {
  note: DeleteNoteInputFieldInput;
}

export interface DeleteNoteInputFieldInput {
  id: string;
}

export interface DeleteOpenLeadSlackMessageInputFieldInput {
  id: string;
}

export interface DeleteStagesetInputFieldInput {
  id: string;
}

export interface DeleteStepTemplateInputFieldInput {
  id: string;
}

/**
 * The input data for the DeleteTag mutation
 */
export interface DeleteTagInput {
  tagId: string;
}

export interface DemioRegisterInputFieldInput {
  webcastId: number;
  eventRegistrationUrl: string;
}

export interface DigestSubscriptionUpdateInput {
  digestType: DigestTypeEnum;
  frequency?: DigestFrequencyEnum | null;
  isActive?: boolean | null;
}

export interface DocumentFieldUpdateValueInput {
  field: string;
  value?: string | null;
}

export interface DomainCheckInput {
  name: string;
}

export interface DomainCreateInput {
  name: string;
}

export interface DomainDeleteInput {
  name: string;
}

export interface DripProgressionDeleteInput {
  dripProgressionId: string;
}

export interface DripSequenceActivateInput {
  dripSequenceId: string;
}

export interface DripSequenceCancelInput {
  dripSequenceId: string;
}

export interface DripSequenceCreateInput {
  name: string;
}

/**
 * The input data for the DripSequenceDuplicate mutation.
 */
export interface DripSequenceDuplicateInput {
  name?: string | null;
  campaignId: string;
}

/**
 * The input data for the dripSequenceGoalSet mutation.
 */
export interface DripSequenceGoalSetInput {
  campaignId: string;
  dripSequenceGoal?: DripSequenceGoalSetInputFieldInput | null;
}

export interface DripSequenceGoalSetInputFieldInput {
  type: DripSequenceGoalType;
  conditions?: ConditionInput[] | null;
  action?: ActionInput | null;
}

export interface DripSequencePauseInput {
  dripSequenceId: string;
}

export interface DripSequenceRetireInput {
  dripSequenceId: string;
}

export interface DripSequenceUnpauseInput {
  dripSequenceId: string;
}

export interface DromoImportInput {
  importData: string;
  dromoId: string;
  filename?: string | null;
  importIdentifier: ImportIdentifier;
}

/**
 * Input for enqueueing Dromo product import rollback
 */
export interface DromoImportRollbackInput {
  originId: string;
}

/**
 * The input data for the deleteStageset mutation.
 */
export interface DuplicateStagesetInput {
  stageset: DuplicateStagesetInputFieldInput;
}

export interface DuplicateStagesetInputFieldInput {
  id: string;
  name: string;
}

/**
 * Input for updating one account/contact EAV value.
 */
export interface EavPatchInput {
  entityId: string;
  attributeValueId: string;
  isDelete?: boolean | null;
  isPrimary?: boolean | null;
  isFormer?: boolean | null;
  name?: string | null;
  phoneValue?: CustomFieldValuePhoneInput | null;
  emailValue?: string | null;
  addressInput?: CustomFieldValueLocationInput | null;
  urlInput?: string | null;
}

/**
 * The input data for the EditQueuedEmail mutation
 */
export interface EditQueuedEmailInput {
  queuedEmailsList: EditQueuedEmailListInputFieldInput;
}

export interface EditQueuedEmailInputFieldInput {
  id: string;
  subject: string;
  formattedBody: string;
}

export interface EditQueuedEmailListInputFieldInput {
  queuedEmails: EditQueuedEmailInputFieldInput[];
}

/**
 * The input data for the EditTag mutation
 */
export interface EditTagInput {
  tag: EditTagInputTag;
}

export interface EditTagInputTag {
  id: string;
  name: string;
  color?: TagColor | null;
}

export interface EditionCopyContentToEditionInput {
  fromEditionId: string;
  toEditionId: string;
}

/**
 * The input data for the EditionCreate mutation.
 */
export interface EditionCreateInput {
  name: string;
  campaignId: string;
  isABTested?: boolean | null;
  fieldsToCompare?: FieldsToCompare | null;
  position?: number | null;
}

export interface EditionDuplicateToBroadcastInput {
  name?: string | null;
  editionId: string;
}

/**
 * The input data for the EditionDuplicateToNewsletterEdition mutation.
 */
export interface EditionDuplicateToNewsletterEditionInput {
  name?: string | null;
  editionId: string;
  campaignId: string;
  position?: number | null;
}

export interface EditionDuplicateToTemplateInput {
  name?: string | null;
  editionId: string;
}

/**
 * The input data for the EditionSchedule mutation.
 */
export interface EditionScheduleInput {
  editionId: string;
  audienceId?: string | null;
  scheduledTime: any;
}

/**
 * The input data for the EditionSend mutation.
 */
export interface EditionSendInput {
  editionId: string;
  audienceId?: string | null;
  mcfxAudienceId?: string | null;
  scheduledTime?: any | null;
}

/**
 * The input data for the EditionSendToFilteredList mutation.
 */
export interface EditionSendToFilteredListInput {
  editionId: string;
  filterString: string;
  savedFilterId?: string | null;
  entityType: EntityType;
  includePreviousRecipients?: boolean | null;
  editionName?: string | null;
  scheduledTime?: any | null;
}

/**
 * The input data for the EditionTestEmailSend mutation.
 */
export interface EditionTestEmailSendInput {
  editionId: string;
  emailAddresses: string[];
}

/**
 * The input data for the EditionUnschedule mutation.
 */
export interface EditionUnscheduleInput {
  editionId: string;
}

/**
 * The input data for the EditionUpdate mutation.
 */
export interface EditionUpdateInput {
  editionId: string;
  name?: string | null;
  subject?: string | null;
  previewText?: string | null;
  body?: string | null;
  beeBodyJson?: string | null;
  fromAddressId?: string | null;
  audienceId?: string | null;
  useUtmParameters?: boolean | null;
  utmSource?: string | null;
  utmMedium?: string | null;
  utmCampaign?: string | null;
  sendDelay?: TimespanInput | null;
  comparison?: ComparisonInput | null;
  status?: number | null;
}

/**
 * The input data for the emailAcceptSuggestedReply mutation.
 */
export interface EmailAcceptSuggestedReplyInput {
  suggestedReplyId: string;
}

export interface EmailActionInput {
  label?: string | null;
  isEnabled?: boolean | null;
  openingMessage?: string | null;
  formSlug?: string | null;
  formConfirmationMessage?: string | null;
  shouldCreateLeads?: boolean | null;
  shouldCreateLeadsPipelineId?: string | null;
  shouldLinkEmailAddress?: boolean | null;
  linkEmailAddress?: string | null;
}

export interface EmailAutomationStatusCancelFieldsInput {
  id: string;
}

/**
 * The input data for the EmailAutomationStatusCancel mutation
 */
export interface EmailAutomationStatusCancelInput {
  emailAutomationStatus: EmailAutomationStatusCancelFieldsInput;
}

/**
 * The input data for the EmailAutomationStatusManualStart mutation
 */
export interface EmailAutomationStatusManualStartInput {
  id: string;
}

/**
 * The input data for the EmailAutomationStatusUpdateField mutation
 */
export interface EmailAutomationStatusUpdateFieldInput {
  id: string;
  field: EmailAutomationField;
  value?: string | null;
}

/**
 * The input data for adding a specific address to the global email blocklist
 */
export interface EmailGlobalBlocklistAddInput {
  address: string;
}

/**
 * The input data for updating the associations between an email and its related leads
 */
export interface EmailLeadAssociationsUpdateInput {
  emailId: string;
  leadAssociations: LeadAssociationInput[];
}

/**
 * The input data for the EmailQueuedRetry mutation
 */
export interface EmailQueuedRetryInput {
  queuedEmail: EmailQueuedRetryInputFieldInput;
}

export interface EmailQueuedRetryInputFieldInput {
  id: string;
}

/**
 * The input data for the EmailQueuedSendNow mutation
 */
export interface EmailQueuedSendNowInput {
  queuedEmail: EmailQueuedSendNowInputFieldInput;
}

export interface EmailQueuedSendNowInputFieldInput {
  id: string;
}

/**
 * The input data for the emailSequenceCreate mutation.
 */
export interface EmailSequenceCreateInput {
  emailSequence: EmailSequenceCreateInputFieldInput;
}

export interface EmailSequenceCreateInputFieldInput {
  emailSequenceTemplateId?: string | null;
  userEmailId: string;
  toEmailAddresses: NutEmailAddressInput[];
  ccEmailAddresses?: NutEmailAddressInput[] | null;
  emails: EmailSequenceCreateInputFieldInputEmail[];
  relatedLeadIds?: string[] | null;
  scheduledTime?: any | null;
}

export interface EmailSequenceCreateInputFieldInputEmail {
  emailTemplateId?: string | null;
  delay: TimespanInput;
  subject: string;
  formattedBody: string;
  sendAsReply: boolean;
  attachments?: NutFileInput[] | null;
  emailReplyId?: string | null;
}

export interface EmailSequenceDeleteFieldsInput {
  id: string;
}

/**
 * The input data for the EmailSequenceDelete mutation
 */
export interface EmailSequenceDeleteInput {
  emailSequence: EmailSequenceDeleteFieldsInput;
}

/**
 * The input data for the EmailSequenceTemplateCreate mutation
 */
export interface EmailSequenceTemplateCreateInput {
  emailSequenceTemplate: EmailSequenceTemplateCreateInputFieldInput;
}

/**
 * The input data for the EmailSequenceTemplateCreate mutation
 */
export interface EmailSequenceTemplateCreateInputFieldInput {
  name: string;
  isShared: boolean;
  groupId?: string | null;
  parentEmailSequenceTemplateId?: string | null;
  emailSequenceTemplateMessages: EmailSequenceTemplateMessageInput[];
}

/**
 * The input data for the EmailSequenceTemplateDelete mutation
 */
export interface EmailSequenceTemplateDeleteInput {
  id: string;
}

/**
 * The input data for the EmailSequenceTemplateDuplicate mutation
 */
export interface EmailSequenceTemplateDuplicateInput {
  id: string;
  name: string;
}

/**
 * The input data for the EmailSequenceTemplateGroupArchive mutation
 */
export interface EmailSequenceTemplateGroupArchiveInput {
  id: string;
  shouldArchiveTemplates: boolean;
}

/**
 * The input data for the EmailSequenceTemplateGroupCreate mutation
 */
export interface EmailSequenceTemplateGroupCreateInput {
  name: string;
}

/**
 * The input data for the EmailSequenceTemplateGroupUpdate mutation
 */
export interface EmailSequenceTemplateGroupUpdateInput {
  id: string;
  name?: string | null;
}

/**
 * Represents a single message in an email sequence template.
 */
export interface EmailSequenceTemplateMessageInput {
  id?: string | null;
  subject: string;
  body: string;
  useSignature: boolean;
  sendDelay: TimespanInput;
  sendAsReply: boolean;
}

/**
 * The input data for the EmailSequenceTemplateUndelete mutation
 */
export interface EmailSequenceTemplateUndeleteInput {
  id: string;
}

/**
 * The input data for the EmailSequenceTemplateUpdate mutation
 */
export interface EmailSequenceTemplateUpdateInput {
  emailSequenceTemplate: EmailSequenceTemplateUpdateInputFieldInput;
}

/**
 * The input data for the EmailSequenceTemplateUpdate mutation
 */
export interface EmailSequenceTemplateUpdateInputFieldInput {
  id: string;
  name?: string | null;
  isShared?: boolean | null;
  groupId?: string | null;
  emailSequenceTemplateMessages?: EmailSequenceTemplateMessageInput[] | null;
}

export interface EmailShareAndCreateContactsInput {
  emailId: string;
  shouldShare: boolean;
}

export interface EmailsQueuedFilterInput {
  entityId?: string | null;
  messageId?: string | null;
}

export interface EnrichContactInput {
  contactId: string;
  baseFieldsResponse: EnrichmentResponse;
  companyFieldsResponse: EnrichmentResponse;
  socialFieldsResponse: EnrichmentResponse;
}

/**
 * Input key/value for updating an enrollment form field
 */
export interface EnrollmentFormUpdateInput {
  key: EnrollmentFormFieldKey;
  value: string;
}

/**
 * The input data for a single entity custom field when running an update entity mutation.
 */
export interface EntityCustomFieldInput {
  fieldName: string;
  value: CustomFieldValueInput;
}

/**
 * This configuration describes a filter for matching a Nutshell entity boolean field.
 */
export interface EntityFilterFieldConfigBooleanInput {
  booleanValue: boolean;
}

/**
 * This configuration describes a filter for matching a Nutshell entity Currency field.
 */
export interface EntityFilterFieldConfigCurrencyInput {
  currencyCode: string;
  currencyValue?: number | null;
  currencyComparator: Comparator;
}

/**
 * This configuration describes a filter for matching a Nutshell entity DateTime field between two dates.
 */
export interface EntityFilterFieldConfigDateTimeBetweenInput {
  startDate: any;
  endDate: any;
}

/**
 * This configuration describes a filter for matching a Nutshell entity Enum field.
 */
export interface EntityFilterFieldConfigEnumInput {
  enumValue: string;
  enumIsNot: boolean;
}

/**
 * A condition definition to activate a Nutshell automation.
 */
export interface EntityFilterFieldConfigInput {
  fieldName: string;
  fieldType?: EntityFieldType | null;
  booleanConfig?: EntityFilterFieldConfigBooleanInput | null;
  currencyConfig?: EntityFilterFieldConfigCurrencyInput | null;
  dateTimeBetweenConfig?: EntityFilterFieldConfigDateTimeBetweenInput | null;
  enumConfig?: EntityFilterFieldConfigEnumInput | null;
  integerConfig?: EntityFilterFieldConfigIntegerInput | null;
  isSetConfig?: EntityFilterFieldConfigIsSetInput | null;
  phoneConfig?: EntityFilterFieldConfigPhoneInput | null;
  relationshipConfig?: EntityFilterFieldConfigRelationshipInput | null;
  stringConfig?: EntityFilterFieldConfigStringInput | null;
  stringsConfig?: EntityFilterFieldConfigStringsInput | null;
}

/**
 * This configuration describes a filter for matching a Nutshell entity Integer field.
 */
export interface EntityFilterFieldConfigIntegerInput {
  integerValue: number;
  integerComparator: Comparator;
}

/**
 * This configuration describes a filter for matching a Nutshell entity IsSet field.
 */
export interface EntityFilterFieldConfigIsSetInput {
  isSetValue: boolean;
}

/**
 * This configuration describes a filter for matching a Nutshell entity Phone field.
 */
export interface EntityFilterFieldConfigPhoneInput {
  startsWith: string;
}

/**
 * This configuration describes a filter for matching a Nutshell entity Relationship field.
 */
export interface EntityFilterFieldConfigRelationshipInput {
  relationshipData: string[];
  relationshipAnyAll: AnyAll;
}

/**
 * This configuration describes a filter for matching a Nutshell entity String field.
 */
export interface EntityFilterFieldConfigStringInput {
  stringContains: string;
}

/**
 * This configuration describes a filter for matching a Nutshell entity Strings field.
 */
export interface EntityFilterFieldConfigStringsInput {
  stringsContain: string;
}

/**
 * An entity to associate with another entity, and the option to give describe the relationship
 */
export interface EntityRelatedEntityInput {
  id: string;
  relationship?: string | null;
}

/**
 * The input data for the EntitySummaryDelete mutation
 */
export interface EntitySummaryDeleteInput {
  entitySummaryId: string;
}

/**
 * The input data for the EntitySummaryGenerate mutation
 */
export interface EntitySummaryGenerateInput {
  entityId: string;
  summaryType: SummaryType;
}

/**
 * The input data for the EntitySummaryRate mutation
 */
export interface EntitySummaryRateInput {
  entitySummaryId: string;
  rating: EntitySummaryRating;
}

export interface EnvelopeDuplicateInput {
  id: string;
}

export interface EnvelopeEmailSendInput {
  id: string;
  customMessage?: string | null;
}

export interface EnvelopeUpdateInput {
  envelope: string;
  validThroughDate?: string | null;
  recipient?: string | null;
}

/**
 * For each field, explicitly providing null will save the field as null, omitting
 * the field will leave it unchanged:
 * https: // spec.graphql.org/October2021/#sec-Null-Value
 */
export interface EnvelopeUpdateStatusInput {
  id: string;
  status: EnvelopeDisplayStatus;
  comment?: string | null;
  acceptedName?: string | null;
  acceptedEmail?: string | null;
}

export interface ExternalMeetingAssociateWithActivityInput {
  id: string;
}

export interface ExternalMeetingRecordingDeleteInput {
  externalMeeting: string;
}

/**
 * The input data for the FailedEmailRetry mutation.
 */
export interface FailedEmailRetryInput {
  emailId: string;
}

export interface FeedbackSubmitInput {
  key: string;
  response?: string | null;
  uri?: string | null;
  linearProjectName?: string | null;
}

export interface FieldCreateInput {
  formId: string;
  type: FormFieldType;
  fieldName?: string | null;
  entityName?: EntityType | null;
  entityAttributeId?: string | null;
}

/**
 * The A/B test fields to compare
 */
export interface FieldsToCompare {
  shouldCompareSubject: boolean;
  shouldComparePreviewText: boolean;
  shouldCompareContent: boolean;
}

/**
 * The input data for the FilterCreate mutation
 */
export interface FilterCreateInput {
  name: string;
  type: number;
  value: string;
  isShared?: boolean | null;
  description?: string | null;
}

/**
 * The input data for the FilterDelete mutation.
 */
export interface FilterDeleteInput {
  id: string;
}

/**
 * The input data for the FilterShareUpdate mutation
 */
export interface FilterShareUpdateInput {
  id: string;
  isShared: boolean;
  sharedWithIds: string[];
}

/**
 * The input data for the FilterUpdate mutation
 */
export interface FilterUpdateInput {
  id: string;
  name?: string | null;
  value?: string | null;
  isShared?: boolean | null;
  description?: string | null;
}

/**
 * The input data for the FilteredListAddToDripSequence mutation.
 */
export interface FilteredListAddToDripSequenceInput {
  dripSequenceId: string;
  filterString: string;
  entityType: EntityType;
  includePreviousRecipients?: boolean | null;
}

/**
 * The input data for the FollowupLeadAutomationCreate mutation.
 */
export interface FollowupLeadAutomationCreateInput {
  stagesetId: string;
  status: LeadStatus;
  newStagesetId: string;
  assigneeOrRule: LeadAutomationAssigneeOrRuleInput;
  tagIds?: string[] | null;
}

/**
 * The input data for the FollowupLeadAutomationDelete mutation.
 */
export interface FollowupLeadAutomationDeleteInput {
  id: string;
}

/**
 * Input for fetching a followup lead automation
 */
export interface FollowupLeadAutomationInput {
  automationId?: string | null;
}

/**
 * The input data for the FollowupLeadAutomationUpdate mutation.
 */
export interface FollowupLeadAutomationUpdateInput {
  actionId: string;
  newStagesetId?: string | null;
  assigneeOrRule?: LeadAutomationAssigneeOrRuleInput | null;
  tagIds?: string[] | null;
}

/**
 * Font style input for a form
 */
export interface FontStyleInput {
  name: string;
  fontFamily: string;
  inheritWhenEmbedded: boolean;
}

export interface FormCreateInput {
  form: FormCreateInputFieldInput;
}

export interface FormCreateInputFieldInput {
  name: string;
  webFormStarterId?: string | null;
}

/**
 * Input type for form next steps
 */
export interface FormCreateRulesAccountInput {
  shouldDedupe?: boolean | null;
  tagIds?: string[] | null;
}

/**
 * Input type for form next steps
 */
export interface FormCreateRulesContactInput {
  tagIds?: string[] | null;
  audienceIds?: string[] | null;
}

/**
 * Input type for form next steps
 */
export interface FormCreateRulesInput {
  contact?: FormCreateRulesContactInput | null;
  account?: FormCreateRulesAccountInput | null;
  lead?: FormCreateRulesLeadInput | null;
}

/**
 * Input type for form next steps
 */
export interface FormCreateRulesLeadInput {
  stagesetId?: string | null;
  tagIds?: string[] | null;
  stagesetFieldRules?: StagesetFieldRulesInput[] | null;
}

export interface FormCreateRulesUpdateInput {
  form: FormCreateRulesUpdateInputFieldInput;
}

export interface FormCreateRulesUpdateInputFieldInput {
  id: string;
  createRules: FormCreateRulesInput;
}

export interface FormDiscardChangesInput {
  formId: string;
}

export interface FormDuplicateInputFieldInput {
  copyName?: string | null;
  wfFormId: string;
}

/**
 * An individual field within a web form.
 */
export interface FormFieldInput {
  id?: string | null;
  type: FormFieldType;
  isRequired?: boolean | null;
  label?: string | null;
  fieldName?: string | null;
  entityName?: EntityType | null;
  attributeId?: string | null;
  placeholder?: string | null;
  styles: FormFieldStylesInput;
  isSeparateFields?: boolean | null;
  subfields?: FormFieldSubfieldsInput[] | null;
  defaultValues?: string[] | null;
  currencyShortname?: string | null;
  isOtherEnabled?: boolean | null;
  rules?: AnswerChoiceRulesInput[] | null;
  imageUrl?: string | null;
}

/**
 * Styles for an individual field within a web form.
 */
export interface FormFieldStylesInput {
  border?: string | null;
  backgroundColor?: string | null;
  color?: string | null;
  inputColor?: string | null;
  borderRadius?: number | null;
  fontSize?: number | null;
  fontWeight?: FontWeightType | null;
  textAlign?: TextAlignType | null;
  justifyContent?: string | null;
  width?: number | null;
}

/**
 * The fields type for the subfields within a form field
 */
export interface FormFieldSubfieldsInput {
  name: string;
  required?: boolean | null;
  label?: string | null;
  placeholder?: string | null;
  isEnabled?: boolean | null;
}

export interface FormFieldUpdateInput {
  field: UpdateFormFieldInput;
}

export interface FormNextStepsNutshellNotificationDeleteInput {
  nextStepsNutshellNotification: FormNextStepsNutshellNotificationDeleteInputFieldInput;
}

export interface FormNextStepsNutshellNotificationDeleteInputFieldInput {
  actionId: string;
}

export interface FormNextStepsNutshellNotificationSetInput {
  nextStepsNutshellNotification: FormNextStepsNutshellNotificationSetInputFieldInput;
}

export interface FormNextStepsNutshellNotificationSetInputFieldInput {
  formId: string;
  actionId?: string | null;
  notifiables: string[];
}

export interface FormNextStepsSlackMessageDeleteInput {
  nextStepsSlackMessage: FormNextStepsSlackMessageDeleteInputFieldInput;
}

export interface FormNextStepsSlackMessageDeleteInputFieldInput {
  actionId: string;
}

export interface FormNextStepsSlackMessageSetInput {
  nextStepsSlackMessage: FormNextStepsSlackMessageSetInputFieldInput;
}

export interface FormNextStepsSlackMessageSetInputFieldInput {
  formId: string;
  actionId?: string | null;
  channelId: string;
}

/**
 * An individual page within a web form.
 */
export interface FormPageInput {
  id?: string | null;
  fields?: FormFieldInput[] | null;
}

export interface FormPageRuleInput {
  id?: string | null;
  actionType: PageRuleActionType;
  targetPageId?: string | null;
  fieldId?: string | null;
  enumElementId?: string | null;
}

export interface FormPageRulesUpdateInput {
  pageId: string;
  defaultRule?: FormPageRuleInput | null;
  conditionalRules?: FormPageRuleInput[] | null;
}

export interface FormPublishInput {
  form: FormPublishInputFieldInput;
}

export interface FormPublishInputFieldInput {
  id: string;
}

/**
 * Global styles input for a form
 */
export interface FormStylesInput {
  backgroundColor?: string | null;
  fontStyle: FontStyleInput;
  pageColor?: string | null;
}

export interface FormSubmissionsInput {
  first?: number | null;
  after?: string | null;
  last?: number | null;
  before?: string | null;
  formId: string;
  sort?: FormSubmissionSortOrder | null;
}

export interface FormUpdateInput {
  form: FormUpdateInputFieldInput;
}

export interface FormUpdateInputFieldInput {
  id: string;
  name?: string | null;
  pages?: FormPageInput[] | null;
  fields?: FormFieldInput[] | null;
  spamPreventionType?: SpamPreventionType | null;
  styles?: FormStylesInput | null;
  redirectUrl?: string | null;
  afterSubmissionText?: string | null;
  shouldShowFormProgress?: boolean | null;
}

/**
 * The input data for the FromAddress mutation.
 */
export interface FromAddressInput {
  emailAddress: NutEmailAddressInput;
}

export interface GenerateReportInput {
  prompt: string;
}

export interface GoogleMeetWebhooksSubscribeInput {
  isEnabled: boolean;
}

export interface GoogleSetInitialSyncSettingsInput {
  syncEmailsFromDaysAgo?: number | null;
  importEmailedContacts: boolean;
  enableCalendarExport: boolean;
  enableCalendarImport: boolean;
  createPeopleFromEvents: boolean;
  calendarId?: string | null;
}

export interface HeaderFieldInput {
  type: HeaderFieldType;
  isEnabled: boolean;
}

/**
 * The input data for the approval of an import sponsorship.
 */
export interface ImportAcceptSponsorshipInput {
  originId: string;
}

/**
 * The input data for the initiate import mutation.
 */
export interface ImportInitiateInput {
  optionType: CrmOptionType;
  isSupplemental?: boolean | null;
}

/**
 * The input data for the requesting of import sponsorship.
 */
export interface ImportRequestSponsorshipInput {
  originId: string;
}

export interface InboundEmailContactCreationRuleInput {
  enabled: boolean;
  tagIds?: string[] | null;
  audienceIds?: string[] | null;
}

export interface InboundEmailRulesUpdateInput {
  assignment?: InboundSmsAssignmentRuleInput | null;
  leadCreation?: InboundSmsLeadCreationRuleInput | null;
  contactCreation?: InboundEmailContactCreationRuleInput | null;
  spamFilter?: InboundEmailSpamFilterRuleInput | null;
}

/**
 * The spam filter rule for inbound Email.
 */
export interface InboundEmailSpamFilterRuleInput {
  isEnabled: boolean;
  senderAllowlist: string[];
  senderDenylist: string[];
}

/**
 * Input data for InboundSmsRulesUpdate mutation.
 */
export interface InboundFacebookRulesUpdateInput {
  threadType: ThreadType;
  assignment?: InboundSmsAssignmentRuleInput | null;
  leadCreation?: InboundSmsLeadCreationRuleInput | null;
}

/**
 * The assignment rule for inbound SMS.
 */
export interface InboundSmsAssignmentRuleInput {
  strategy: ChatAssignmentStrategyEnum;
  assignedUserId?: string | null;
}

/**
 * The lead creation rule for inbound SMS.
 */
export interface InboundSmsLeadCreationRuleInput {
  enabled: boolean;
  stagesetId?: string | null;
  tagIds: (string | null)[];
}

/**
 * Input data for InboundSmsRulesUpdate mutation.
 */
export interface InboundSmsRulesUpdateInput {
  assignment?: InboundSmsAssignmentRuleInput | null;
  leadCreation?: InboundSmsLeadCreationRuleInput | null;
  redirectPhoneNumber?: string | null;
}

/**
 * Input data for InboundWhatsAppRulesUpdate mutation.
 */
export interface InboundWhatsAppRulesUpdateInput {
  assignment?: InboundSmsAssignmentRuleInput | null;
  leadCreation?: InboundSmsLeadCreationRuleInput | null;
}

/**
 * An input type for a Nutshell installment
 */
export interface InstallmentInput {
  id?: string | null;
  dueTime: any;
  description?: string | null;
  value: string;
  isFailed: boolean;
}

export interface InstallmentsUpdateInput {
  leadId: string;
  installments: InstallmentInput[];
}

/**
 * The input data for the IntegrationFormSubmit mutation.
 */
export interface IntegrationFormSubmitInput {
  integrationId: string;
  username: string;
  password: string;
  email: string;
  requestedActions: string[];
}

export interface InvoiceCreateFromQuoteInput {
  quote: string;
}

export interface InvoicePreviewInput {
  crmPlanCode: string;
  numberOfUsers: number;
  marketingSuitePlanCode?: string | null;
  engagementPlanCode?: string | null;
  numberOfEngagementUsers?: number | null;
  addOns: AddOnSelection[];
  couponCode?: string | null;
}

export interface InvoicesSearchInput {
  first?: number | null;
  after?: string | null;
  last?: number | null;
  before?: string | null;
  userIds: (string | null)[];
  status?: QuoteDisplayStatus | null;
  sort?: SalesDocumentSortOrder | null;
}

/**
 * The input data for the kixieIntegrationCreate mutation.
 */
export interface KixieIntegrationCreateInput {
  businessId: string;
  apiKey: string;
}

export interface LandingPageDomainSetInput {
  domainId?: string | null;
}

export interface LeadAddChannelInput {
  leadId: string;
  channel?: ChannelType | null;
}

export interface LeadAddSourceInput {
  leadId: string;
  sourceId: string;
}

/**
 * The input data for updating the association status of a lead for an email
 */
export interface LeadAssociationInput {
  leadId: string;
  isMapped: boolean;
}

/**
 * The input data required for assigning a lead in lead automations. Can be a user
 * or team, or a special rule for assigning a lead like auto assign
 */
export interface LeadAutomationAssigneeOrRuleInput {
  assignee?: string | null;
  assignmentRule?: LeadAssigneeRuleEnum | null;
}

export interface LeadCardFieldsUpdateInput {
  stagesetId: string;
  fields: SelectableFieldInput[];
}

export interface LeadCompetitorAddInput {
  lead: string;
  competitor?: string | null;
  name?: string | null;
}

export interface LeadCompetitorRemoveInput {
  lead: string;
  competitor: string;
}

export interface LeadCompetitorUpdateInput {
  lead: string;
  competitor: string;
  note?: string | null;
}

export interface LeadCreateByThreadInput {
  threadId: string;
  stagesetId?: string | null;
  assigneeId?: string | null;
}

/**
 * The input data for the LeadCreate mutation
 */
export interface LeadCreateInput {
  stageset?: string | null;
  assignee?: string | null;
  contacts?: string[] | null;
  accounts?: string[] | null;
  origin?: OriginType | null;
}

export interface LeadFileAddInput {
  lead: string;
  files: NutFileInput[];
}

export interface LeadFileRemoveInput {
  lead: string;
  fileId: string;
}

export interface LeadMarketUpdateInput {
  lead: string;
  market: string;
}

export interface LeadProductAddInput {
  lead: string;
  product: string;
}

export interface LeadProductRemoveInput {
  leadProductMap: string;
}

export interface LeadProductUpdateInput {
  leadProductMap: string;
  quantity?: number | null;
  price?: string | null;
  note?: string | null;
}

export interface LeadPromptResponseGenerateInput {
  leadId: string;
  userPrompt: string;
}

export interface LeadRemoveAccountInput {
  lead: string;
  account: string;
}

export interface LeadRemoveChannelInput {
  leadId: string;
  channel?: ChannelType | null;
}

export interface LeadRemoveContactInput {
  lead: string;
  contact: string;
}

export interface LeadRemoveSourceInput {
  leadId: string;
  sourceId: string;
}

/**
 * Input for researching a lead.
 */
export interface LeadResearchInput {
  leadId: string;
  isDemoMode?: boolean | null;
  forceRefresh?: boolean | null;
}

/**
 * Input for updating lead research settings.
 */
export interface LeadResearchPromptUpdateInput {
  selectedFields?: string[] | null;
  businessContext?: string | null;
  idealCustomer?: string | null;
}

export interface LeadSetWatchedInputFieldInput {
  id: string;
  shouldWatch: boolean;
}

export interface LeadValueUpdateInput {
  lead: string;
  mode: LeadValueMode;
  value?: string | null;
}

/**
 * An input object representing an license type and whether it is enabled
 */
export interface LicenseEnabled {
  licenseType: LicenseType;
  isEnabled: boolean;
}

export interface LinkNumberConfigInput {
  type?: string | null;
  customNumber?: string | null;
  callTrackerNumber?: string | null;
  callTrackerId?: string | null;
}

export interface LogActivityInput {
  activity: LogActivityInputActivity;
}

export interface LogActivityInputActivity {
  activityId?: string | null;
  participants?: string[] | null;
  durationMinutes?: number | null;
  activityTypeId?: string | null;
  logNote?: string | null;
  leadIds?: string[] | null;
  agenda?: string | null;
  isAllDay?: boolean | null;
  isImportant?: boolean | null;
  startTime?: string | null;
  endTime?: string | null;
  address_1?: string | null;
  address_2?: string | null;
  address_3?: string | null;
  city?: string | null;
  state?: string | null;
  country?: string | null;
  postalCode?: string | null;
  addressType?: string | null;
  dontAddSelf?: boolean | null;
  externalMeetingId?: string | null;
  shouldSummarize?: boolean | null;
  shouldTranscribeZoomMeeting?: boolean | null;
}

/**
 * The input data needed for resetting a severed meeting to the state of its template
 */
export interface ManagedMeetingResetChangesInput {
  severedMeetingId: string;
}

/**
 * The input data for the ManagedMeetingTemplateAssignmentsUpdate mutation.
 */
export interface ManagedMeetingTemplateAssignmentsUpdateInput {
  meetingId: string;
  users?: string[] | null;
  teams?: string[] | null;
}

/**
 * The input data needed for creating a managed meeting template
 */
export interface ManagedMeetingTemplateCreateInput {
  name: string;
}

export interface McfxAudienceSyncInAppInput {
  mcfxAudienceId: string;
  name: string;
}

export interface McfxCompaniesUnlockInput {
  mcfxCompanyIds: string[];
}

export interface McfxFormsInput {
  ignored?: boolean | null;
  statuses?: FormStatus[] | null;
}

export interface McfxViqCompanyUpdateInput {
  mcfxCompanyId: string;
  mcfxViqContactIds?: string[] | null;
  createRelatedLead: boolean;
  stagesetId?: string | null;
}

/**
 * The input data for the MeetingCreate mutation
 */
export interface MeetingCreateInput {
  name: string;
  type: MeetingType;
  cohostIds?: string[] | null;
  teamId?: string | null;
}

/**
 * The input data for the MeetingDelete mutation.
 */
export interface MeetingDeleteInput {
  id: string;
}

export interface MeetingDuplicateInputFieldInput {
  id: string;
  name?: string | null;
  cohostIds?: string[] | null;
}

/**
 * The input data for the MeetingUndelete mutation
 */
export interface MeetingUndeleteInput {
  meetingId: string;
}

/**
 * The input data for the MeetingCreate mutation
 */
export interface MeetingUpdateInput {
  id: string;
  name?: string | null;
  description?: string | null;
  bookingConfirmationMessage?: string | null;
  activityTypeId?: string | null;
  durationMinutes?: number | null;
  location?: string | null;
  locationType?: MeetingLocationType | null;
  isActive?: boolean | null;
  minNotice?: TimespanInput | null;
  bufferBeforeMins?: number | null;
  bufferAfterMins?: number | null;
  startTimeIntervalMinutes?: number | null;
  sendConfirmationReminder?: boolean | null;
  sendUpcomingReminder?: boolean | null;
  sendSoonReminder?: boolean | null;
  allowAdditionalAttendees?: boolean | null;
  isHidden?: boolean | null;
  customSlug?: string | null;
}

export interface MessageSendForChatInput {
  threadId: string;
  content: string;
  closeThread?: boolean | null;
  imageUrls?: string[] | null;
}

/**
 * The input data for the messageSendFromSharedInbox mutation.
 */
export interface MessageSendFromSharedInboxInput {
  threadId: string;
  fromAddress: NutEmailAddressInput;
  content: string;
}

export interface MessageSendInput {
  threadId: string;
  content?: string | null;
  closeThread?: boolean | null;
  imageUrls?: string[] | null;
}

export interface MfaUpdateRequiredSettingInput {
  mfaRequiredForAllUsers: string;
}

/**
 * Input for a monthly quota allocation
 */
export interface MonthInput {
  identifier: number;
  value: number;
}

export interface MonthValueInput {
  month: number;
  value: number;
}

export interface NavigationSwitchInput {
  isNewNavigation: boolean;
}

/**
 * The input data for the NewsletterCreate mutation.
 */
export interface NewsletterCreateInput {
  name: string;
}

/**
 * Input type for configurable notification entities.
 */
export interface NotifiablesInput {
  entityIds: string[];
  notifiableAliasTypes: NotifiableAliasType[];
}

/**
 * The input data for the notifyMessageDismiss mutation.
 */
export interface NotifyMessageDismissInput {
  id: string;
}

/**
 * An email address with a display string
 */
export interface NutEmailAddressInput {
  id?: string | null;
  display?: string | null;
  address: string;
  isPrimary?: boolean | null;
}

/**
 * Input object for nut file uploads
 */
export interface NutFileInput {
  filename: string;
  filesize: number;
  locationUri: string;
  mimeType?: string | null;
}

export interface Office365SetInitialSyncSettingsInput {
  syncEmailsFromDaysAgo?: number | null;
  importEmailedContacts: boolean;
  enableCalendarExport: boolean;
  enableCalendarImport: boolean;
  createPeopleFromEvents: boolean;
  calendarId?: string | null;
}

/**
 * Input for parsing and adding one omnifield value.
 */
export interface OmnifieldAddInput {
  entityId: string;
  value: string;
}

/**
 * The input data for the PageConfigUpdate mutation.
 */
export interface PageConfigUpdateInput {
  useAvatar?: boolean | null;
  useCompanyLogo?: boolean | null;
  userSlug?: string | null;
  fromDomainId?: string | null;
}

/**
 * The input data for the PageCreate mutation
 */
export interface PageCreateInput {
  name: string;
  publicSlug: string;
}

/**
 * The input data for the PageDelete mutation
 */
export interface PageDeleteInput {
  id: string;
}

export interface PageDiscardChangesInput {
  pageId: string;
}

/**
 * The input data for the PageCreate mutation
 */
export interface PageDuplicateInput {
  pageId: string;
  name: string;
  publicSlug: string;
}

export interface PagePreviewInput {
  pageId: string;
}

export interface PagePublishInput {
  pageVersionId: string;
}

/**
 * The input data for the PageUndelete mutation
 */
export interface PageUndeleteInput {
  id: string;
}

export interface PageUpdateInput {
  pageId: string;
  name?: string | null;
  publicSlug?: string | null;
  beeBodyJson?: string | null;
  fromDomainId?: string | null;
}

export interface PagesCrawlTriggerInput {
  urls: (string | null)[];
  subpageLimit?: number | null;
  subpageKeywords?: (string | null)[] | null;
  isOnboarding?: boolean | null;
}

/**
 * An address with an optional display name (i.e. "office"). If you pass in just an
 * {address_1:"location"} it will be parsed into a structured address
 */
export interface PeepAddressInput {
  id?: string | null;
  name?: string | null;
  address: CustomFieldValueLocationInput;
  singleLineAddress?: string | null;
  isPrimary?: boolean | null;
}

/**
 * The input data for the PeepMapCreate mutation
 */
export interface PeepMapCreateInput {
  contact: string;
  account: string;
  relationship?: string | null;
  relationshipType?: PeepRelationshipType | null;
}

/**
 * The input data for the PeepMapDelete mutation
 */
export interface PeepMapDeleteInput {
  contact: string;
  account: string;
}

/**
 * The input data for the PeepMapUpdate mutation
 */
export interface PeepMapUpdateInput {
  contact: string;
  account: string;
  relationship?: string | null;
  relationshipType?: PeepRelationshipType | null;
}

/**
 * The input data for the PeepMergeAll mutation
 */
export interface PeepMergeAllInput {
  entityType: EntityType;
  groupBy: PeepDuplicateGroupingKey[];
  mergeRule: PeepDuplicateMergeRule;
  numDuplicates: number;
}

/**
 * An email address with a display string
 */
export interface PeepPhoneNumberInput {
  id?: string | null;
  name?: string | null;
  number: string;
  isPrimary?: boolean | null;
}

/**
 * An url with an optional display name (i.e. "personal")
 */
export interface PeepUrlInput {
  id?: string | null;
  name?: string | null;
  url: string;
  isPrimary?: boolean | null;
}

/**
 * Options for updating the PeopleIQ filters
 */
export interface PeopleIqFilterSettingsUpdateInput {
  contactInformation: ContactInformationType[];
  jobField: JobFieldType[];
  managementLevel: ManagementLevelType[];
}

export interface PeopleIqPreferenceInput {
  accountId: string;
  preference: PeopleIqPreference;
}

/**
 * The input data for the PhonecallSetShouldSummarize mutation
 */
export interface PhoneCallSetShouldSummarizeInput {
  phonecallId: string;
  shouldSummarize: boolean;
}

/**
 * Input data for PhoneNumberProvision mutation.
 */
export interface PhoneNumberProvisionInput {
  phoneNumber: string;
}

export interface PlanSelectionUpdateInput {
  crmPlanCode: string;
  numberOfUsers: number;
  marketingSuitePlanCode?: string | null;
  engagementPlanCode?: string | null;
  numberOfEngagementUsers?: number | null;
  addOns: AddOnSelection[];
  couponCode?: string | null;
}

/**
 * A potential entities input for GraphQL queries
 */
export interface PotentialEntitiesInput {
  entityIds: string[];
}

export interface PreviewChatbotResponseInput {
  question: string;
  nudgeId?: string | null;
}

export interface ProductCategoryCreateInput {
  name: string;
}

export interface ProductCategoryDeleteInput {
  id: string;
  shouldDeleteProducts: boolean;
}

export interface ProductCategoryUpdateInput {
  id: string;
  name: string;
}

export interface ProductCreateInput {
  productData: ProductDataInput;
}

/**
 * The input type for either updating or creating Nutshell products.
 */
export interface ProductDataInput {
  name: string;
  description?: string | null;
  sku?: string | null;
  categoryId?: string | null;
  type: ProductType;
  unit?: QuoteTerm | null;
  marketPrices: ProductMarketPriceInput[];
}

export interface ProductDeleteInput {
  productId: string;
}

export interface ProductLineItemInput {
  id?: string | null;
  productId?: string | null;
  name: string;
  description: string;
  sku: string;
  quantity: number;
  price: string;
  term?: QuoteTerm | null;
  discountUnit?: QuoteLineItemUnit | null;
  discountNumber?: string | null;
}

export interface ProductMarketPriceInput {
  marketId: string;
  price: number;
  available: boolean;
}

export interface ProductUndeleteInput {
  productId: string;
}

export interface ProductUpdateInput {
  id: string;
  productData: ProductDataInput;
}

export interface ProspectorContactsAddInput {
  pdlIds: string[];
  shouldCreateNewLeads: boolean;
  stagesetId?: string | null;
}

/**
 * Filters for the Prospector Contacts query
 */
export interface ProspectorFilters {
  hasEmail?: string | null;
  hasLinkedin?: string | null;
  hasPhoneNumber?: string | null;
  personName?: string | null;
  role?: string | null;
  level?: string | null;
  companyName?: string | null;
  industry?: string | null;
  size?: string | null;
  location?: string | null;
  revenue?: string | null;
}

/**
 * The input data for the QuickbooksCreateInvoiceForInvoice mutation.
 */
export interface QuickbooksCreateInvoiceForInvoiceInput {
  invoiceId: string;
  quickbooksCustomerId?: string | null;
}

/**
 * The input data for the QuickbooksCreateInvoiceForLead mutation.
 */
export interface QuickbooksCreateInvoiceForLeadInput {
  leadId: string;
}

/**
 * The input data for the QuickbooksCreateOrUpdateCustomer mutation.
 */
export interface QuickbooksCreateOrUpdateCustomerInput {
  peepId: string;
}

export interface QuotaCreateInput {
  userIds: string[];
  duplicateFromUserId?: string | null;
  fiscalYear?: number | null;
  monthValues?: MonthValueInput[] | null;
}

export interface QuotaDeleteInput {
  userId: string;
  fiscalYear?: number | null;
}

export interface QuotaUpdateInput {
  userId: string;
  fiscalYear: number;
  months: MonthInput[];
}

export interface QuoteActionInput {
  label?: string | null;
  isEnabled?: boolean | null;
  openingMessage?: string | null;
  shouldCreateLeads?: boolean | null;
  shouldCreateLeadsPipelineId?: string | null;
  formSlug?: string | null;
  formConfirmationMessage?: string | null;
}

/**
 * The input data for the quoteProductsUpdate mutation
 */
export interface QuoteProductsUpdateInput {
  id: string;
  isSkuShown: boolean;
  isTermShown: boolean;
  isDiscountShown: boolean;
  products: ProductLineItemInput[];
}

/**
 * The input data for the quoteProductsUpdate mutation
 */
export interface QuoteSubtotalItemsUpdateInput {
  id: string;
  lineItems: SubtotalLineItemInput[];
}

export interface QuoteTemplateUpdateNameInput {
  id: string;
  name?: string | null;
}

export interface QuoteUpdateAcceptanceOptionInput {
  id: string;
  acceptanceOption: QuoteAcceptanceOption;
  contractTemplateId?: string | null;
}

export interface QuotesSearchInput {
  first?: number | null;
  after?: string | null;
  last?: number | null;
  before?: string | null;
  userIds: (string | null)[];
  status?: QuoteDisplayStatus | null;
  sort?: SalesDocumentSortOrder | null;
}

export interface ReactionCreateInput {
  changeLogId: string;
  userId: string;
  type: ReactionType;
}

export interface ReactionDeleteInput {
  changeLogId: string;
  userId: string;
  type: ReactionType;
}

export interface RecommendationsGenerateInput {
  type: RecommendationsEnum;
}

export interface RecurrenceRuleInput {
  rule: string;
  mode: RecurrenceMode;
}

/**
 * The input type of a RemoveExternalMeeting mutation
 */
export interface RemoveExternalMeetingInput {
  id: string;
}

/**
 * The input data for the repositionStageset mutation.
 */
export interface RepositionStagesetInput {
  stagesetId: string;
  destinationPosition: number;
}

/**
 * The input data for the repositionStepTemplate mutation.
 */
export interface RepositionStepTemplateInput {
  stepTemplateId: string;
  destinationStageId: string;
  destinationPosition?: number | null;
}

export interface RestoreStagesetInputFieldInput {
  id: string;
}

/**
 * The input data for the RestoreTag mutation
 */
export interface RestoreTagInput {
  tagId: string;
}

export interface RingCentralSmsInboxConfigureInput {
  phoneNumber: string;
}

/**
 * The input data for the RoleCreate mutation
 */
export interface RoleCreateInput {
  name: string;
}

/**
 * The input data for the RoleDelete mutation
 */
export interface RoleDeleteInput {
  roleId: string;
}

/**
 * The input data for the RoleUpdate mutation
 */
export interface RoleUpdateInput {
  roleId: string;
  name: string;
}

/**
 * The input data for the RoleUpdatePermission mutation
 */
export interface RoleUpdatePermissionInput {
  roleId: string;
  permission: Permission;
  action: string;
}

/**
 * The input data for the SalesDocumentCreate mutation
 */
export interface SalesDocumentCreateInput {
  leadId: string;
  salesDocumentVariant: SalesDocumentVariant;
  templateQuoteId?: string | null;
}

/**
 * The input data for the SalesDocumentRestore mutation
 */
export interface SalesDocumentRestoreInput {
  salesDocumentId: string;
}

/**
 * For each field, explicitly providing null will save the field as null, omitting
 * the field will leave it unchanged:
 * https: // spec.graphql.org/October2021/#sec-Null-Value
 */
export interface SalesDocumentUpdateInput {
  salesDocument: string;
  purchaseOrderNumber?: string | null;
  jobNumber?: string | null;
  customerNumber?: string | null;
  referenceNumber?: string | null;
  preparedTime?: string | null;
  validUntilDate?: string | null;
  logo?: string | null;
  headerLeftColumn?: string | null;
  headerRightColumn?: string | null;
  body?: string | null;
  paymentAndTerms?: string | null;
  footer?: string | null;
  preparedFor?: string | null;
  preparedBy?: string | null;
  isSignatureShown?: boolean | null;
}

/**
 * For each field, explicitly providing null will save the field as null, omitting
 * the field will leave it unchanged:
 * https: // spec.graphql.org/October2021/#sec-Null-Value
 */
export interface SalesDocumentUpdateStatusInput {
  id?: string | null;
  status: QuoteDisplayStatus;
  comment?: string | null;
}

export interface ScheduledReportCreateInput {
  savedFilterId: string;
  name: string;
  recurrenceRule: string;
  recipients: string[];
}

export interface ScheduledReportDeleteInput {
  id: string;
}

export interface ScheduledReportSetIsPausedInput {
  id: string;
  isPaused: boolean;
}

export interface ScheduledReportUpdateInput {
  id: string;
  name: string;
  recurrenceRule: string;
  recipients: string[];
}

export interface SchedulerStatsInput {
  meetingId: string;
  periodString?: string | null;
}

export interface SecurityUpdateSettingsInput {
  emailAcls: string;
  sessionLength: number;
}

export interface SelectCalendarSyncCalendarInputFieldInput {
  id: string;
  syncType?: SyncType | null;
}

/**
 * The input type of a SelectableField mutation
 */
export interface SelectableFieldInput {
  fieldId: string;
  isRequired: boolean;
}

/**
 * The input data for the sendRawHtmlEmail mutation.
 */
export interface SendRawHtmlEmailInput {
  emailSequence: SendRawHtmlEmailInputFieldInput;
}

export interface SendRawHtmlEmailInputFieldInput {
  toEmailAddresses: NutEmailAddressInput[];
  subject: string;
  htmlBody: string;
}

/**
 * The input data for the emailSequenceCreate mutation.
 */
export interface SequenceCreateFromGmailInput {
  emailSequence: SequenceCreateFromGmailInputFieldInput;
}

export interface SequenceCreateFromGmailInputFieldInput {
  emailSequenceTemplateId?: string | null;
  fromEmailAddress: NutEmailAddressInput;
  toEmailAddresses: NutEmailAddressInput[];
  ccEmailAddresses?: NutEmailAddressInput[] | null;
  bccEmailAddresses?: NutEmailAddressInput[] | null;
  emails: SequenceCreateFromGmailInputFieldInputEmail[];
}

export interface SequenceCreateFromGmailInputFieldInputEmail {
  emailTemplateId?: string | null;
  delay: TimespanInput;
  subject: string;
  formattedBody: string;
  sendAsReply: boolean;
  attachments?: NutFileInput[] | null;
}

export interface SetCalendarSyncCalendarShouldSyncInputFieldInput {
  id: string;
  shouldSync: boolean;
}

export interface SetCalendarSyncImportIsEnabledInputFieldInput {
  importIsEnabled: boolean;
}

/**
 * The input data for the setCallRailIntegrationIsEnabled mutation.
 */
export interface SetCallRailIntegrationIsEnabledInput {
  isEnabled: boolean;
}

export interface SetDefaultStagesetInputFieldInput {
  id: string;
}

export interface SetEntityPinnedStatusInput {
  entityToPinId: string;
  pinToEntityId: string;
  status: boolean;
}

/**
 * The input data for the setGoogleMeetIsEnabled mutation.
 */
export interface SetGoogleMeetIsEnabledInput {
  isEnabled: boolean;
  meetAuthType: MeetAuthType;
}

/**
 * The input data for the SetLicensesForUser mutation.
 */
export interface SetLicensesForUserInput {
  id: string;
  licenses: LicenseEnabled[];
}

/**
 * The input data for the setMicrosoftTeamsIsEnabled mutation.
 */
export interface SetMicrosoftTeamsIsEnabledInput {
  isEnabled: boolean;
}

export interface SetStageLeadAssignmentAutomationInputFieldAutomationCase {
  assigneeId?: string | null;
  shouldUnassign?: boolean | null;
  shouldRoundRobin?: boolean | null;
  condition?: ConditionConfigInput | null;
}

export interface SetStageLeadAssignmentAutomationInputFieldInput {
  name?: string | null;
  description?: string | null;
  stageId: string;
  defaultAutomation?: SetStageLeadAssignmentAutomationInputFieldAutomationCase | null;
  allowReassign?: boolean | null;
  automationCases: SetStageLeadAssignmentAutomationInputFieldAutomationCase[];
}

/**
 * The input data for the setZoomIsEnabled mutation.
 */
export interface SetZoomIsEnabledInput {
  isEnabled: boolean;
}

/**
 * The input data for the ShareEmail mutation.
 */
export interface ShareEmailInput {
  emailId: string;
  isShared: boolean;
}

export interface SharedEmailAddressAddInput {
  emailAddress: string;
  displayName: string;
}

export interface SharedEmailAddressRemoveInput {
  fromAddressId: string;
}

export interface SharedEmailAddressUpdateInput {
  id: string;
  displayName: string;
}

/**
 * Input for sending a shared inbox forwarding verification email.
 */
export interface SharedInboxVerificationEmailSendInput {
  emailAddress: string;
}

export interface ShortenedUrlDomainSetInput {
  domainId?: string | null;
}

/**
 * The input data for the skipStep mutation
 */
export interface SkipStepInput {
  step: SkipStepInputFieldInput;
}

export interface SkipStepInputFieldInput {
  id: string;
}

export interface SmartSequenceCreateFromTemplateInput {
  template: SmartSequenceTemplate;
}

export interface SmartSequenceCreateLeadConfigInput {
  pipelineId: string;
  assigneeOrRule?: LeadAutomationAssigneeOrRuleInput | null;
}

/**
 * Exactly one of tagOnContact, previousEmailOpened, previousEmailClicked,
 * specificLinkClicked, pageViewed, formCompleted, replyReceived, or
 * customFieldValue should be set for the decision YES branch.
 */
export interface SmartSequenceDecisionConditionInput {
  tagOnContact?: SmartSequenceDecisionTagOnContactInput | null;
  previousEmailOpened?: SmartSequenceDecisionPreviousEmailOpenedInput | null;
  previousEmailClicked?: SmartSequenceDecisionPreviousEmailClickedInput | null;
  specificLinkClicked?: SmartSequenceDecisionSpecificLinkClickedInput | null;
  pageViewed?: SmartSequenceDecisionPageViewedInput | null;
  formCompleted?: SmartSequenceDecisionFormCompletedInput | null;
  replyReceived?: SmartSequenceDecisionReplyReceivedInput | null;
  customFieldValue?: SmartSequenceDecisionCustomFieldValueInput | null;
}

/**
 * Decision node config. noBranchDelay is shared; exactly one condition nest must be set (M1: tagOnContact).
 */
export interface SmartSequenceDecisionConfigInput {
  noBranchDelay: TimespanInput;
  condition: SmartSequenceDecisionConditionInput;
}

export interface SmartSequenceDecisionCustomFieldValueInput {
  filter: EntityFilterFieldConfigInput;
}

export interface SmartSequenceDecisionFormCompletedInput {
  formId: string;
}

export interface SmartSequenceDecisionPageViewedInput {
  maUrlId: string;
}

export interface SmartSequenceDecisionPreviousEmailClickedInput {
  emailNodeId: string;
}

export interface SmartSequenceDecisionPreviousEmailOpenedInput {
  emailNodeId: string;
}

export interface SmartSequenceDecisionReplyReceivedInput {
  emailNodeId: string;
}

export interface SmartSequenceDecisionSpecificLinkClickedInput {
  links: string[];
}

export interface SmartSequenceDecisionTagOnContactInput {
  tagIds: string[];
}

export interface SmartSequenceDuplicateInput {
  name: string;
  campaignId: string;
}

/**
 * Input for bulk-updating a smart sequence graph.
 */
export interface SmartSequenceGraphUpdateInput {
  smartSequenceId: string;
  nodes: SmartSequenceNodeInput[];
  removedNode?: SmartSequenceRemovedNodeInput | null;
}

export interface SmartSequenceMigrateInput {
  campaignId: string;
}

/**
 * Exactly one of updateTag, updateAudience, startSequence, createLead, wait,
 * decision, or sendEmail should be set, matching the node type.
 */
export interface SmartSequenceNodeConfigInput {
  updateTag?: SmartSequenceUpdateTagConfigInput | null;
  updateAudience?: SmartSequenceUpdateAudienceConfigInput | null;
  startSequence?: SmartSequenceStartSequenceConfigInput | null;
  createLead?: SmartSequenceCreateLeadConfigInput | null;
  wait?: SmartSequenceWaitConfigInput | null;
  decision?: SmartSequenceDecisionConfigInput | null;
  sendEmail?: SmartSequenceSendEmailConfigInput | null;
}

/**
 * A node in the saved smart sequence graph.
 */
export interface SmartSequenceNodeInput {
  id?: string | null;
  clientKey?: string | null;
  type: SmartSequenceNodeType;
  parentNodeId?: string | null;
  parentBranch?: SmartSequenceParentBranch | null;
  config?: SmartSequenceNodeConfigInput | null;
}

/**
 * A node removed from the graph. Used when the sequence has recipients in Active,
 * Paused, Problem, or Retired status so the backend knows where to move recipients
 * that were on the removed node.
 */
export interface SmartSequenceRemovedNodeInput {
  nodeId: string;
  childId?: string | null;
  childClientKey?: string | null;
}

export interface SmartSequenceSendEmailConfigInput {
  editionId: string;
}

export interface SmartSequenceStartSequenceConfigInput {
  smartSequenceId: string;
}

export interface SmartSequenceUpdateAudienceConfigInput {
  audienceIds: string[];
}

export interface SmartSequenceUpdateTagConfigInput {
  tagIds: string[];
}

export interface SmartSequenceWaitConfigInput {
  delay: TimespanInput;
}

/**
 * The input data for the campaignRestore mutation.
 */
export interface SmsCampaignRestoreInput {
  id: string;
}

/**
 * The input data for the EditionCreate mutation.
 */
export interface SmsDripEditionCreateInput {
  campaignId: string;
}

/**
 * The input data for the EditionDelete mutation.
 */
export interface SmsDripEditionDeleteInput {
  id: string;
}

export interface SmsDripSequenceActivateInput {
  dripSequenceId: string;
}

export interface SmsDripSequenceCreateInput {
  name?: string | null;
}

/**
 * The input data for the DripSequenceUpdate mutation.
 */
export interface SmsDripSequenceUpdateInput {
  id: string;
  name?: string | null;
  isBusinessHoursOnly?: boolean | null;
  isStopOnGoal?: boolean | null;
}

/**
 * The input data for the EditionUpdate mutation.
 */
export interface SmsEditionUpdateInput {
  editionId: string;
  name?: string | null;
  content?: string | null;
  audienceId?: string | null;
  sendDelay?: TimespanInput | null;
  status?: number | null;
  optOutText?: OptOutType | null;
}

export interface SmtpSettingsUpdateInputFieldInput {
  userEmailId: string;
  hostname: string;
  port: string;
  ssl: SmtpPortType;
  username: string;
  password: string;
}

export interface SnippetStatusTestInput {
  domain: string;
}

/**
 * The input data for the SourceCreate mutation
 */
export interface SourceCreateInput {
  name: string;
  channel?: ChannelType | null;
}

export interface SourceDeleteInput {
  id: string;
}

/**
 * The input data for the SourceUpdate mutation
 */
export interface SourceUpdateInput {
  id: string;
  name?: string | null;
  channel?: ChannelType | null;
}

export interface StageCreateInputFieldInput {
  stagesetId: string;
  name: string;
  description?: string | null;
  overdueDuration?: TimespanInput | null;
  autocloseDuration?: TimespanInput | null;
  autocloseOutcomeId?: string | null;
  defaultConfidence?: number | null;
}

export interface StageDeleteInputFieldInput {
  id: string;
}

export interface StageUpdateInputFieldInput {
  id: string;
  name?: string | null;
  description?: string | null;
  overdueDuration?: TimespanInput | null;
  autocloseDuration?: TimespanInput | null;
  autocloseOutcomeId?: string | null;
  position?: number | null;
  defaultConfidence?: number | null;
}

export interface StagesetActivateDraftInput {
  stagesetId: string;
  shouldSetAsDefault?: boolean | null;
}

export interface StagesetDeactivateInput {
  stagesetId: string;
}

/**
 * Input type for form next steps
 */
export interface StagesetFieldRulesInput {
  fieldId: string;
  answerChoiceId: string;
  stagesetId: string;
}

/**
 * The input data for the createStageset mutation.
 */
export interface StagesetStarterCreateInput {
  type: StagesetStarterType;
}

/**
 * The input data for the startTriggerAdd mutation.
 */
export interface StartTriggerAddInput {
  campaignId: string;
  startTrigger: StartTriggerAddInputFieldInput;
}

export interface StartTriggerAddInputFieldInput {
  type: StartTriggerType;
  conditions: ConditionInput[];
  isStopOnRemovedFromAudience?: boolean | null;
}

/**
 * The input data for the startTriggerDelete mutation.
 */
export interface StartTriggerDeleteInput {
  startTriggerId: string;
}

/**
 * The input data for the startTriggerSet mutation.
 */
export interface StartTriggerSetInput {
  startTrigger?: StartTriggerSetInputFieldInput | null;
  campaignId: string;
}

export interface StartTriggerSetInputFieldInput {
  type: StartTriggerType;
  conditions: ConditionInput[];
  isStopOnLeadClose?: boolean | null;
  isStopOnRemovedFromAudience?: boolean | null;
  removedFromAudienceIds?: string[] | null;
}

/**
 * The input data for the startTriggerUpdate mutation.
 */
export interface StartTriggerUpdateInput {
  startTriggerId: string;
  type: StartTriggerType;
  conditions: ConditionInput[];
  isStopOnRemovedFromAudience?: boolean | null;
}

/**
 * The input data for the StepDelay mutation
 */
export interface StepDelayInput {
  step: string;
  delay: string;
  note?: string | null;
}

/**
 * A Nutshell relative due date specification.
 */
export interface StepDueDateInput {
  dueFrom: number;
  dueUnit: DueDateUnit;
  dueTimespan: number;
}

/**
 * The input data for the unskipStep mutation
 */
export interface StepUnskipInput {
  step: StepUnskipInputFieldInput;
}

export interface StepUnskipInputFieldInput {
  id: string;
}

/**
 * The input data for the StepUpdate mutation
 */
export interface StepUpdateInput {
  step: string;
  assignee?: string | null;
  completion?: boolean | null;
}

export interface SubdomainAddInput {
  subdomain: string;
  domain: string;
}

export interface SubdomainDeleteInput {
  domain: string;
  subdomain: string;
}

/**
 * The input data for the SubmissionsCsvGenerate mutation
 */
export interface SubmissionsCsvGenerateInput {
  formId: string;
}

export interface SubtotalLineItemInput {
  id?: string | null;
  label: string;
  modifierUnit: QuoteLineItemUnit;
  modifierValue: string;
  operation: QuoteLineItemOperation;
}

/**
 * The input for the suggested replies
 */
export interface SuggestedRepliesInput {
  emailId: string;
}

export interface SupportPageStatusToggleInput {
  pageId: string;
  status: PageStatus;
}

export interface SyncPastCallsFieldInput {
  integrationType: ExternalServiceType;
  initialSyncStartFromDaysAgo?: number | null;
}

/**
 * The input data for the syncPastCalls mutation.
 */
export interface SyncPastCallsInput {
  syncPastCalls: SyncPastCallsFieldInput;
}

/**
 * A tag to be applied to a Nutshell entity
 */
export interface TagInput {
  name: string;
  tagType: TagType;
}

export interface TagsQueryInputType {
  entityType?: TagType | null;
  searchTerm?: string | null;
  archived?: boolean | null;
}

/**
 * The input data for the TaskCreate mutation
 */
export interface TaskCreateInput {
  entity: string;
  name: string;
  dueTime: any;
  assignee?: string | null;
  description?: string | null;
  recurringPeriod?: number | null;
  recurrenceRule?: RecurrenceRuleInput | null;
}

/**
 * The input data for the TaskDelete mutation
 */
export interface TaskDeleteInput {
  task: string;
}

/**
 * The input data for the TaskMarkUnhelpfulAndDelete mutation
 */
export interface TaskMarkUnhelpfulAndDeleteInput {
  task: string;
}

/**
 * The input data for the TaskUpdate mutation
 */
export interface TaskUpdateInput {
  task: string;
  name?: string | null;
  dueTime?: any | null;
  assignee?: string | null;
  description?: string | null;
  completion?: boolean | null;
  recurringPeriod?: number | null;
  recurrenceRule?: RecurrenceRuleInput | null;
}

export interface TemplateCreateInput {
  name: string;
}

export interface TemplatePublishInput {
  template: TemplatePublishInputFieldInput;
}

export interface TemplatePublishInputFieldInput {
  id: string;
}

export interface TextActionInput {
  label?: string | null;
  isEnabled?: boolean | null;
  openingMessage?: string | null;
  shouldLinkNumber?: boolean | null;
  linkNumber?: string | null;
  formSlug?: string | null;
  formConfirmationMessage?: string | null;
  shouldCreateLeads?: boolean | null;
  shouldCreateLeadsPipelineId?: string | null;
}

/**
 * The input data for the TextAutomationCreate mutation.
 */
export interface TextAutomationCreateInput {
  stageId: string;
  messageContent: string;
  delay: TimespanInput;
  sendFromUserId?: string | null;
  fallbackSendFromUserId?: string | null;
  snoozeDuration?: number | null;
}

/**
 * The input data for the textAutomationDelte mutation.
 */
export interface TextAutomationDeleteInput {
  id: string;
}

/**
 * The input data for the TextAutomationUpdate mutation.
 */
export interface TextAutomationUpdateInput {
  automationId: string;
  messageContent?: string | null;
  delay?: TimespanInput | null;
  sendFromUserId?: string | null;
  fallbackSendFromUserId?: string | null;
  snoozeDuration?: number | null;
}

export interface TextMessageDeleteInput {
  messageId: string;
}

/**
 * Input data for TextMessageResend mutation.
 */
export interface TextMessageResendInput {
  messageId: string;
}

export interface TextMessageSendInput {
  externalNumber: string;
  threadId?: string | null;
  content: string;
  leadIds?: string[] | null;
  scheduledTime?: any | null;
  snoozeDuration?: number | null;
  closeThread?: boolean | null;
}

/**
 * Input data for ThreadArchive mutation.
 */
export interface ThreadArchiveInput {
  threadId: string;
}

/**
 * Input data for ThreadClose mutation.
 */
export interface ThreadCloseInput {
  threadId: string;
}

/**
 * Input data for ThreadMarkAsNotSpam mutation.
 */
export interface ThreadMarkAsNotSpamInput {
  threadId: string;
}

/**
 * Input data for ThreadMarkAsSpam mutation.
 */
export interface ThreadMarkAsSpamInput {
  threadId: string;
}

/**
 * Input data for ThreadReassign mutation.
 */
export interface ThreadReassignInput {
  threadId: string;
  assigneeId?: string | null;
}

/**
 * Input data for ThreadReopen mutation.
 */
export interface ThreadReopenInput {
  threadId: string;
}

/**
 * Input data for ThreadSnooze mutation.
 */
export interface ThreadSnoozeInput {
  threadId: string;
  snoozeDuration: number;
}

/**
 * The input data for the timelineEventDelete mutation.
 */
export interface TimelineEventDeleteInput {
  eventId: string;
}

export interface TimelineEventsFilterInput {
  period?: string | null;
  activityTypeIds?: string[] | null;
  entryTypes?: string[] | null;
  creatorIds?: string[] | null;
  excludeOutreach?: boolean | null;
  excludeInteractions?: boolean | null;
  excludeCustomerJourneys?: boolean | null;
}

/**
 * Input fields for fetching key entities
 */
export interface TimelineEventsKeyInput {
  entityId: string;
}

/**
 * Input fields for fetching pinned entities
 */
export interface TimelineEventsPinnedInput {
  entityId: string;
}

/**
 * A Nutshell input to represent a passing of time.
 */
export interface TimespanInput {
  unit: DueDateUnit;
  timespan: number;
}

export interface TrackReportViewInput {
  url: string;
  updateMostRecent?: boolean | null;
}

export interface TranscriptDeleteInput {
  activityId: string;
}

export interface TranscriptSummaryDeleteInput {
  activityId: string;
}

/**
 * The input data for the TranscriptSummaryGenerate mutation
 */
export interface TranscriptSummaryGenerateInput {
  zoomMeetingId: string;
}

/**
 * The input data for saving a transcript summary to the activity description
 */
export interface TranscriptSummarySaveInput {
  activityId: string;
  replace: boolean;
}

/**
 * The input data for the trialStart mutation.
 */
export interface TrialStartInput {
  planType: PlanType;
}

export interface UpdateClosedLeadAccountTypeAutomationInputFieldInput {
  id: string;
  accountTypeId?: string | null;
}

export interface UpdateClosedLeadEmailAutomationInputFieldInput {
  id: string;
  emailListExternalListId: string;
}

export interface UpdateClosedLeadSlackMessageInputFieldInput {
  id: string;
  channelId?: string | null;
  conditions?: ConditionInput[] | null;
}

export interface UpdateClosedLeadTaskTemplateInputFieldInput {
  id: string;
  name: string;
  description?: string | null;
  assigneeId?: string | null;
  dueDate?: ClosedLeadTaskTemplateDueDateInput | null;
}

export interface UpdateDefaultStagesetForOnboardingWizardInputFieldInput {
  usesOutboundSales?: boolean | null;
  usesInboundSales?: boolean | null;
  usesExistingLeads?: boolean | null;
  wantsMoreLeads?: boolean | null;
  usesPhoneCallActivities?: boolean | null;
  usesOnSiteDemoActivities?: boolean | null;
  usesScreenShareActivities?: boolean | null;
  usesNoActivities?: boolean | null;
  usesProposalDocumentStep?: boolean | null;
  usesFollowupStep?: boolean | null;
  usesNoOtherStep?: boolean | null;
}

/**
 * The input data for the UpdateDirectorySyncSettings mutation.
 */
export interface UpdateDirectorySyncSettingsInput {
  defaultRoleId: string;
}

export interface UpdateEmailAutomationInputFieldInput {
  id: string;
  emailListId?: string | null;
  entersStageId?: string | null;
  exitsStageId?: string | null;
  sendUntilClose?: boolean | null;
  sendFromUserId?: string | null;
  delay?: TimespanInput | null;
}

/**
 * An individual field within a web form to update.
 */
export interface UpdateFormFieldInput {
  id: string;
  fieldName?: string | null;
  entityName?: EntityType | null;
  attributeId?: string | null;
  isIgnored?: boolean | null;
}

export interface UpdateGoalInputFieldInput {
  id: string;
  conditions?: ConditionInput[] | null;
  newLoggedActivityTypes?: string[] | null;
  newScheduledActivityTypes?: string[] | null;
}

export interface UpdateLeadDistributionAutomationInputFieldInput {
  id: string;
  conditions: ConditionInput[];
}

export interface UpdateLeadInputFieldInput {
  id: string;
  stageId?: string | null;
  forceStageChange?: boolean | null;
  assigneeId?: string | null;
  createdTime?: any | null;
  closedTime?: any | null;
  dueTime?: any | null;
  confidence?: number | null;
  priority?: LeadPriority | null;
  description?: string | null;
  customFields?: EntityCustomFieldInput[] | null;
  tags?: TagInput[] | null;
  sources?: string[] | null;
}

export interface UpdateOpenLeadSlackMessageInputFieldInput {
  id: string;
  conditions?: ConditionInput[] | null;
  channelId: string;
}

export interface UpdateSettingFieldInput {
  name: string;
  value: string;
  isGlobal?: boolean | null;
  userId?: string | null;
}

/**
 * The input data for the UpdateSsoSettings mutation.
 */
export interface UpdateSsoSettingsInput {
  instanceRequireSso: boolean;
  exemptFromSsoUserIds: string[];
}

export interface UpdateStagesetInputFieldInput {
  id: string;
  name?: string | null;
}

/**
 * The input data for the updateStagesetVisibility mutation.
 */
export interface UpdateStagesetVisibilityInput {
  id: string;
  visibilityMode: StagesetVisibilityMode;
  allowedViewerIds: string[];
}

export interface UpdateStepTemplateInputFieldInput {
  id: string;
  stageId: string;
  name: string;
  description?: string | null;
  assigneeId?: string | null;
  dueDate?: StepDueDateInput | null;
}

/**
 * Input for creating a marketing automation URL automation action.
 */
export interface UrlAutomationCreateInput {
  urlId: string;
  action: ActionInput;
}

/**
 * Input for deleting a marketing automation URL automation action.
 */
export interface UrlAutomationDeleteInput {
  actionId: string;
}

/**
 * Input for updating a marketing automation URL automation action.
 */
export interface UrlAutomationUpdateInput {
  actionId: string;
  config: ActionConfigInput;
  type?: string | null;
}

export interface UrlCreateInput {
  name: string;
  url: string;
}

export interface UrlDeleteInput {
  id: string;
}

export interface UrlSetIsEnabledInput {
  id: string;
  isEnabled: boolean;
}

export interface UrlUpdateInput {
  id: string;
  name: string;
  url?: string | null;
}

export interface UserCreateInput {
  firstName: string;
  lastName: string;
  email: string;
  roleId: string;
  sendInvite: boolean;
  licenses?: LicenseType[] | null;
}

/**
 * Input data for UserInboxAdd mutation.
 */
export interface UserInboxAddInput {
  userId: string;
  threadType?: ThreadType | null;
}

/**
 * Input data for UserInboxRemove mutation.
 */
export interface UserInboxRemoveInput {
  userId: string;
  threadType?: ThreadType | null;
}

/**
 * Options for updating the VisitorIQ filters
 */
export interface VisitorIqFilterSettingsUpdateInput {
  industries: IndustryType[];
  contactInformation: ContactInformationType[];
  jobField: JobFieldType[];
  managementLevel: ManagementLevelType[];
  urlBlocklist: string[];
}

/**
 * Input data for WhatsAppSyncInitiate mutation.
 */
export interface WhatsAppSyncInitiateInput {
  shouldSyncContacts: boolean;
  shouldSyncMessages: boolean;
}

export interface WidgetEntityTypeUpdateInput {
  entityType: WidgetEntityType;
  sidebar: WidgetInput[];
  workspace: WidgetInput[];
  headerFields: HeaderFieldInput[];
}

export interface WidgetInput {
  widgetId?: string | null;
  isHidden: boolean;
  type: WidgetType;
  customWidgetInput?: CustomFieldWidgetInput | null;
}

export interface WidgetStagesetUpdateInput {
  stageset: string;
  sidebar: WidgetInput[];
  workspace: WidgetInput[];
}

export interface WidgetUpdateCollapseStateInput {
  widget: string;
  isCollapsed: boolean;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
